
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequireaed0"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequireaed0"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("5qD1E", function(module, exports) {

$parcel$export(module.exports, "STATE", () => $3f3da726e7661cf2$export$63b4527a2777036f);
$parcel$export(module.exports, "loadGraphDataFromServer", () => $3f3da726e7661cf2$export$236737ca2d9ef492);
$parcel$export(module.exports, "clearNodeHighlights", () => $3f3da726e7661cf2$export$915afd478a0e2a72);

var $lsJox = parcelRequire("lsJox");

var $8E8xA = parcelRequire("8E8xA");

var $cTjUK = parcelRequire("cTjUK");

var $5YqKr = parcelRequire("5YqKr");

var $7jtZA = parcelRequire("7jtZA");

var $7jXoy = parcelRequire("7jXoy");

var $2UrZ2 = parcelRequire("2UrZ2");

var $e8aKe = parcelRequire("e8aKe");

var $d8Pvn = parcelRequire("d8Pvn");

var $ftuQo = parcelRequire("ftuQo");
(0, $lsJox.default).use((0, (/*@__PURE__*/$parcel$interopDefault($cTjUK))));
(0, $lsJox.default).use((0, (/*@__PURE__*/$parcel$interopDefault($8E8xA))));
(0, $lsJox.default).use((0, $5YqKr.default));
(0, $lsJox.default).use((0, (/*@__PURE__*/$parcel$interopDefault($7jtZA))));
(0, $lsJox.default).use((0, (/*@__PURE__*/$parcel$interopDefault($7jXoy))));
const $3f3da726e7661cf2$export$63b4527a2777036f = {
    cy: null,
    walks: [],
    possibleWalks: [],
    graph_jsons: [],
    minEdgeWeight: 1,
    minPathLength: 1,
    maxPathLength: 900,
    previousClickedElement: null,
    previousClickedElementStyle: null,
    originalGraphData: null,
    selectedNodeColor: "#8dd3c7",
    nodeColor: "#1f77b4",
    highlightWalkColor: "#ff5733",
    sourceNodeColor: "#31a354",
    hideUninvolvedElements: true,
    hideSingletonNodes: false
};
window.STATE = $3f3da726e7661cf2$export$63b4527a2777036f;
// Get the "Change Layout" button element
layoutSelect.addEventListener("change", ()=>{
    // Get the selected layout from the select element
    const selectedLayout = document.getElementById("layoutSelect").value;
    if ($3f3da726e7661cf2$export$63b4527a2777036f.cy === null) return;
    // Apply the chosen layout
    $3f3da726e7661cf2$export$63b4527a2777036f.cy.layout({
        name: selectedLayout,
        animate: true,
        fit: true,
        padding: 10,
        avoidOverlap: true,
        rankDir: "LR"
    }).run();
});
// Filter walks by possiblePaths
// walks: array of walks (each walk is array of cytoscape node objects)
// possiblePaths: object { auroraId: [elementId1, elementId2, ...] }
function $3f3da726e7661cf2$var$filterWalksByPossiblePaths(walks, possiblePaths) {
    // Build a set of stringified element ID sequences for fast lookup
    const possibleSequences = new Set(Object.values(possiblePaths).map((seq)=>JSON.stringify(seq)));
    // Helper to get the sequence of element IDs for a walk
    function getWalkElementIdSequence(walk) {
        const ids = [];
        for(let i = 0; i < walk.length; i++){
            ids.push(walk[i].id());
            // If not last node, add edge ID to next node
            if (i < walk.length - 1) {
                const edge = walk[i].edgesTo(walk[i + 1]);
                if (edge && edge.length > 0) ids.push(edge[0].id());
            }
        }
        return ids;
    }
    // Filter walks
    return walks.filter((walk)=>{
        const seq = getWalkElementIdSequence(walk);
        return possibleSequences.has(JSON.stringify(seq));
    });
}
// Function to update graph based on edge weight
function $3f3da726e7661cf2$var$updateGraph() {
    // Reset graph to original data
    console.log("updateGraph", $3f3da726e7661cf2$export$63b4527a2777036f);
    $3f3da726e7661cf2$export$63b4527a2777036f.walks.length = 0;
    $3f3da726e7661cf2$export$63b4527a2777036f.cy.elements().remove();
    $3f3da726e7661cf2$export$63b4527a2777036f.cy.add($3f3da726e7661cf2$export$63b4527a2777036f.originalGraphData);
    const sourceNodes = $3f3da726e7661cf2$export$63b4527a2777036f.cy.nodes().filter((node)=>node.indegree() === 0);
    const sinkNodes = $3f3da726e7661cf2$export$63b4527a2777036f.cy.nodes().filter((node)=>node.outdegree() === 0);
    // update walks
    sourceNodes.forEach((sourceNode)=>{
        (0, $2UrZ2.dfs)(sourceNode, [], sinkNodes);
    });
    if ($3f3da726e7661cf2$export$63b4527a2777036f.possibleWalks && Object.keys($3f3da726e7661cf2$export$63b4527a2777036f.possibleWalks).length > 0) {
        console.log("UPDATE Graph: filtering walks by possible walks");
        $3f3da726e7661cf2$export$63b4527a2777036f.walks = $3f3da726e7661cf2$var$filterWalksByPossiblePaths($3f3da726e7661cf2$export$63b4527a2777036f.walks, $3f3da726e7661cf2$export$63b4527a2777036f.possibleWalks);
    }
    if ($3f3da726e7661cf2$export$63b4527a2777036f.hideUninvolvedElements) $3f3da726e7661cf2$var$hideUninvolvedElements();
    if ($3f3da726e7661cf2$export$63b4527a2777036f.hideSingletonNodes) (0, $2UrZ2.hideSingletonNodes)();
    // Optionally, you can re-run layout here
    // // change layout to dagre
    // document.getElementById("layoutSelect").value = "dagre";
    let currentLayout = document.getElementById("layoutSelect").value;
    if (currentLayout === "euler") {
        document.getElementById("layoutSelect").value = "dagre";
        currentLayout = "dagre";
    }
    $3f3da726e7661cf2$export$63b4527a2777036f.cy.layout({
        name: currentLayout,
        animate: false,
        fit: true,
        padding: 10,
        avoidOverlap: true,
        rankDir: "LR"
    }).run();
    $3f3da726e7661cf2$var$setupGraphInteractions();
}
function $3f3da726e7661cf2$var$hideUninvolvedElements() {
    const involvedNodes = new Set();
    const involvedEdges = new Set();
    // Mark all nodes and edges involved in the walks
    $3f3da726e7661cf2$export$63b4527a2777036f.walks.forEach((walk)=>{
        walk.forEach((node, index)=>{
            involvedNodes.add(node.id());
            if (index < walk.length - 1) {
                const nextNode = walk[index + 1];
                const connectingEdge = node.edgesTo(nextNode);
                involvedEdges.add(connectingEdge.id());
            }
        });
    });
    // Hide nodes and edges not involved in any walk
    $3f3da726e7661cf2$export$63b4527a2777036f.cy.nodes().forEach((node)=>{
        if (!involvedNodes.has(node.id())) node.hide();
    });
    $3f3da726e7661cf2$export$63b4527a2777036f.cy.edges().forEach((edge)=>{
        if (!involvedEdges.has(edge.id())) edge.hide();
    });
}
document.getElementById("minEdgeWeight").addEventListener("change", function() {
    const minEdgeWeight = parseFloat(this.value) || 1;
    if (Number.isNaN(minEdgeWeight)) return;
    $3f3da726e7661cf2$export$63b4527a2777036f.minEdgeWeight = minEdgeWeight;
    $3f3da726e7661cf2$var$updateGraph();
});
document.getElementById("MaxDepth").addEventListener("change", function() {
    const MaxDepth = parseFloat(this.value) || 900;
    if (Number.isNaN(MaxDepth)) return;
    $3f3da726e7661cf2$export$63b4527a2777036f.maxPathLength = MaxDepth;
    if ($3f3da726e7661cf2$export$63b4527a2777036f.minPathLength > $3f3da726e7661cf2$export$63b4527a2777036f.maxPathLength) {
        // altert user
        alert("Min Depth cannot be greater than Max Depth");
        document.getElementById("MaxDepth").value = $3f3da726e7661cf2$export$63b4527a2777036f.minPathLength;
        return;
    }
    $3f3da726e7661cf2$var$updateGraph();
});
document.getElementById("MinDepth").addEventListener("change", function() {
    const MinDepth = parseFloat(this.value) || 2;
    if (Number.isNaN(MinDepth)) return;
    $3f3da726e7661cf2$export$63b4527a2777036f.minPathLength = MinDepth;
    if ($3f3da726e7661cf2$export$63b4527a2777036f.minPathLength > $3f3da726e7661cf2$export$63b4527a2777036f.maxPathLength) {
        // altert user
        alert("Min Depth cannot be greater than Max Depth");
        document.getElementById("MinDepth").value = $3f3da726e7661cf2$export$63b4527a2777036f.maxPathLength;
        return;
    }
    $3f3da726e7661cf2$var$updateGraph();
});
function $3f3da726e7661cf2$export$236737ca2d9ef492(graphData) {
    //check if graphData has elements
    // if has elements, initialize graph using elements
    // if not has elements, initialize graph using graphData
    if (graphData.elements) {
        $3f3da726e7661cf2$export$63b4527a2777036f.originalGraphData = graphData.elements;
        (0, $e8aKe.initializeGraph)(graphData.elements);
    } else {
        $3f3da726e7661cf2$export$63b4527a2777036f.originalGraphData = graphData;
        (0, $e8aKe.initializeGraph)(graphData);
    }
    console.log("graphData", graphData.data);
    // --- Filter walks using possible_paths if present in graphData.data ---
    let possiblePaths = null;
    if (Array.isArray(graphData.data)) {
        const dataObj = Object.fromEntries(graphData.data);
        possiblePaths = dataObj.possible_paths;
    }
    if (possiblePaths && typeof possiblePaths === 'object') {
        // Save all possible walks
        $3f3da726e7661cf2$export$63b4527a2777036f.possibleWalks = possiblePaths;
        console.log("possibleWalks", $3f3da726e7661cf2$export$63b4527a2777036f.possibleWalks);
        let walks_number_before_filtering = $3f3da726e7661cf2$export$63b4527a2777036f.walks.length;
        // Filter walks to only those matching possible_paths
        $3f3da726e7661cf2$export$63b4527a2777036f.walks = $3f3da726e7661cf2$var$filterWalksByPossiblePaths($3f3da726e7661cf2$export$63b4527a2777036f.walks, $3f3da726e7661cf2$export$63b4527a2777036f.possibleWalks);
        let walks_number_after_filtering = $3f3da726e7661cf2$export$63b4527a2777036f.walks.length;
        console.log("walks_number_before_filtering", walks_number_before_filtering);
        console.log("walks_number_after_filtering", walks_number_after_filtering);
    }
    $3f3da726e7661cf2$var$setupGraphInteractions();
}
// Make loadGraphDataFromServer globally available to avoid circular dependencies
window.loadGraphDataFromServer = $3f3da726e7661cf2$export$236737ca2d9ef492;
// Initialize reset button event listener
function $3f3da726e7661cf2$var$initializeResetButton() {
    const resetButton = document.getElementById("resetGraph");
    if (!resetButton) {
        console.warn("Element with ID 'resetGraph' not found in the DOM");
        return;
    }
    resetButton.addEventListener("click", ()=>{
        if (!$3f3da726e7661cf2$export$63b4527a2777036f.cy) {
            window.showAlert?.("No graph loaded to reset", "error");
            return;
        }
        try {
            // Reset layout to default
            $3f3da726e7661cf2$export$63b4527a2777036f.cy.elements().removeClass("highlightWalk");
            const layoutSelect1 = document.getElementById("layoutSelect");
            if (layoutSelect1) layoutSelect1.value = "dagre";
            $3f3da726e7661cf2$export$63b4527a2777036f.cy.layout({
                name: "dagre",
                animate: true,
                fit: true,
                padding: 10,
                avoidOverlap: true,
                rankDir: "LR"
            }).run();
            const cyContainer = document.getElementById("cy");
            const infoPanel = document.getElementById("info");
            const walksPanel = document.getElementById("walks");
            if (cyContainer) {
                cyContainer.style.width = "";
                cyContainer.style.height = "";
            }
            if (infoPanel) {
                infoPanel.style.width = "";
                infoPanel.style.display = "";
            }
            if (walksPanel) {
                walksPanel.style.width = "";
                walksPanel.style.display = "";
            }
            window.showAlert?.("Graph reset to default layout", "success", 2000);
        } catch (error) {
            console.error("Error resetting graph:", error);
            window.showAlert?.("Failed to reset graph", "error");
        }
    });
}
// Initialize on DOM load
if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", $3f3da726e7661cf2$var$initializeResetButton);
else $3f3da726e7661cf2$var$initializeResetButton();
// Function to get color based on weight
function $3f3da726e7661cf2$var$setupGraphInteractions() {
    $3f3da726e7661cf2$export$63b4527a2777036f.cy.on("tap", (evt)=>{
        if (evt.target === $3f3da726e7661cf2$export$63b4527a2777036f.cy) $3f3da726e7661cf2$export$915afd478a0e2a72($3f3da726e7661cf2$export$63b4527a2777036f.cy);
    });
    $3f3da726e7661cf2$var$displayWalks();
    (0, $2UrZ2.setupClickEvent)();
    (0, $d8Pvn.createTooltip)();
    // Initialize gene annotation functionality
    (0, $ftuQo.initGeneAnnotation)();
}
/**
 * Convert a string to a numeric identifier using SHA-256.
 * @param {string} inputString - The string to convert
 * @param {number|null} [length=10] - The desired length of the output identifier. If null, returns the full numeric representation
 * @returns {Promise<string>} A string of decimal numbers derived from the SHA-256 hash
 * @throws {TypeError} If inputString is not a string or length is not a number/null
 * @throws {Error} If length is not positive
 *
 * @example
 * const numericId = await toNumericIdentifier("Hello World!", 10);
 * console.log(numericId); // Outputs a string of 10 decimal numbers
 */ async function $3f3da726e7661cf2$var$toNumericIdentifier(inputString, length = 10) {
    // Type checking
    if (typeof inputString !== "string") throw new TypeError("Input must be a string");
    if (length !== null && (!Number.isInteger(length) || typeof length !== "number")) throw new TypeError("Length must be an integer or null");
    if (length !== null && length <= 0) throw new Error("Length must be positive");
    // Create SHA-256 hash
    const encoder = new TextEncoder();
    const data = encoder.encode(inputString);
    const hashBuffer = await crypto.subtle.digest("SHA-256", data);
    // Convert buffer to decimal string
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    let numericString = hashArray.map((b)=>b.toString().padStart(3, "0")).join("");
    // Take specified length of the numeric string if provided
    let result = length ? numericString.slice(0, length) : numericString;
    return result;
}
/**
 * Convert a string to a hash-based identifier using SHA-256.
 * @param {string} inputString - The string to convert
 * @param {number|null} [length=16] - The desired length of the output identifier. If null, returns the full hash
 * @returns {Promise<string>} A valid identifier string derived from the SHA-256 hash
 * @throws {TypeError} If inputString is not a string or length is not a number/null
 * @throws {ValueError} If length is not positive
 *
 * @example
 * const identifier = await toHashIdentifier("Hello World!");
 * console.log(identifier); // Outputs something like 'a591a6d40bf420'
 */ async function $3f3da726e7661cf2$var$toHashIdentifier(inputString, length = 16) {
    // Type checking
    if (typeof inputString !== "string") throw new TypeError("Input must be a string");
    if (length !== null && (!Number.isInteger(length) || typeof length !== "number")) throw new TypeError("Length must be an integer or null");
    if (length !== null && length <= 0) throw new Error("Length must be positive");
    // Create SHA-256 hash
    const encoder = new TextEncoder();
    const data = encoder.encode(inputString);
    const hashBuffer = await crypto.subtle.digest("SHA-256", data);
    // Convert buffer to hex string
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    const hashHex = hashArray.map((b)=>b.toString(16).padStart(2, "0")).join("");
    // Take specified length of hash if provided
    let result = length ? hashHex.slice(0, length) : hashHex;
    // Ensure the identifier starts with a letter (prefix with 'a' if it starts with a number)
    if (/^[0-9]/.test(result)) result = "a" + result.slice(1);
    return result;
}
/**
 * Generates a unique Aurora ID for a given walk through the graph.
 * @param {Array} walk - Array of graph nodes representing a walk
 * @returns {Promise<string>} A unique identifier for the walk generated using toNumericIdentifier
 *
 * @example
 * const walk = [node1, node2, node3];
 * const auroraId = await getWalkAuroraId(walk);
 * console.log(auroraId); // Outputs something like 'a591a6d40bf420'
 */ async function $3f3da726e7661cf2$var$getWalkAuroraId(walk) {
    // Create the walk info string by joining node information
    const walkInfo = walk.map((node)=>{
        const nodeId = node.data("id");
        return nodeId;
    }).join("-");
    // Generate numeric identifier for the walk info
    console.log(`Generating Aurora ID for walk: ${walkInfo}`);
    const auroraId = await $3f3da726e7661cf2$var$toNumericIdentifier(walkInfo);
    return `TSP${auroraId}`;
}
// Update the displayWalks function for a more beautiful presentation
async function $3f3da726e7661cf2$var$displayWalks(searchText = "", auroraIds = []) {
    const walksContainer = document.getElementById("walks");
    if (!walksContainer) {
        console.error("Walks container not found");
        return;
    }
    // Clear previous walks display and add search box with improved styling
    walksContainer.innerHTML = `
        <div class="walks-header">
            <h3>
                <i class="bi bi-diagram-3"></i> Graph Walks
                <span class="badge bg-primary walks-count">0</span>
            </h3>
            <div class="input-group mb-3">
                <span class="input-group-text"><i class="bi bi-search"></i></span>
                <input
                    type="text"
                    class="form-control"
                    id="walkSearch"
                    placeholder="Search walks or Aurora ID..."
                    aria-label="Search walks"
                >
                <button class="btn btn-outline-secondary" type="button" id="clearWalkSearch">
                    <i class="bi bi-x-lg"></i>
                </button>
            </div>
            <div class="input-group mb-3">
                <input
                    type="file"
                    class="form-control"
                    id="auroraIdsFile"
                    accept=".txt"
                    aria-label="Upload Aurora IDs file"
                />
                <button class="btn btn-outline-primary" type="button" id="uploadAuroraIds">
                    <i class="bi bi-upload"></i> Batch Search
                </button>
            </div>
            ${auroraIds.length > 0 ? `<div class="alert alert-info">
                <i class="bi bi-info-circle me-2"></i> Searching for ${auroraIds.length} Aurora IDs
                <button class="btn btn-sm btn-outline-secondary float-end" id="clearAuroraIds">Clear</button>
            </div>` : ""}
        </div>
        <div class="walk-list-container">
            <!-- Walks will be loaded here -->
            <div class="loading-walks">
                <div class="spinner-border text-primary" role="status">
                    <span class="visually-hidden">Loading...</span>
                </div>
                <p>Loading walks...</p>
            </div>
        </div>
    `;
    // Add search event listener with improved functionality
    const searchInput = document.getElementById("walkSearch");
    const clearSearchBtn = document.getElementById("clearWalkSearch");
    const auroraIdsFileInput = document.getElementById("auroraIdsFile");
    const uploadAuroraIdsBtn = document.getElementById("uploadAuroraIds");
    const clearAuroraIdsBtn = document.getElementById("clearAuroraIds");
    if (searchInput) {
        searchInput.value = searchText; // Preserve search text when redisplaying
        // Remove old event listeners before adding new one
        const newSearchInput = searchInput.cloneNode(true);
        searchInput.parentNode.replaceChild(newSearchInput, searchInput);
        newSearchInput.addEventListener("input", (e)=>{
            // Real-time filtering as user types
            const searchValue = e.target.value.trim().toLowerCase();
            $3f3da726e7661cf2$var$filterWalkCards(searchValue, auroraIds);
        });
    }
    if (clearSearchBtn) clearSearchBtn.addEventListener("click", ()=>{
        if (searchInput) {
            searchInput.value = "";
            // Only filter by Aurora IDs if they exist
            $3f3da726e7661cf2$var$filterWalkCards("", auroraIds);
            searchInput.focus();
        }
    });
    if (uploadAuroraIdsBtn && auroraIdsFileInput) uploadAuroraIdsBtn.addEventListener("click", ()=>{
        $3f3da726e7661cf2$var$handleAuroraIdsFileUpload();
    });
    if (clearAuroraIdsBtn) clearAuroraIdsBtn.addEventListener("click", ()=>{
        // Redisplay walks without Aurora ID filtering
        $3f3da726e7661cf2$var$displayWalks(searchText);
    });
    try {
        // Sort walks by length (number of nodes) in descending order
        const sortedWalks = [
            ...$3f3da726e7661cf2$export$63b4527a2777036f.walks
        ].sort((a, b)=>b.length - a.length);
        const walkListContainer = walksContainer.querySelector(".walk-list-container");
        if (sortedWalks.length === 0) {
            walkListContainer.innerHTML = `
                <div class="alert alert-info text-center">
                    <i class="bi bi-exclamation-circle me-2"></i>
                    No walks found in this graph
                </div>
            `;
            return;
        }
        // Update walks count badge
        const walksCountBadge = walksContainer.querySelector(".walks-count");
        if (walksCountBadge) walksCountBadge.textContent = sortedWalks.length;
        // Create container for walkCards
        walkListContainer.innerHTML = '<div class="walks-accordion" id="walksAccordion"></div>';
        const walksAccordion = document.getElementById("walksAccordion");
        // Create a mapping between display order index and original STATE.walks index
        const walkIndexMap = sortedWalks.map((walk, displayIndex)=>{
            // Find the original index in STATE.walks
            const originalIndex = $3f3da726e7661cf2$export$63b4527a2777036f.walks.findIndex((w)=>w === walk);
            return {
                displayIndex: displayIndex,
                originalIndex: originalIndex
            };
        });
        // Store this mapping in a window variable for reference
        window.walkIndexMap = walkIndexMap;
        // Process all walks in parallel
        const walkPromises = sortedWalks.map(async (walk, displayIndex)=>{
            try {
                // Get original walk index from STATE.walks array
                const originalIndex = walkIndexMap[displayIndex].originalIndex;
                const walkText = walk.map((node)=>node.id()).join(" \u2192 ");
                const auroraId = await $3f3da726e7661cf2$var$getWalkAuroraId(walk);
                // Create a more appealing card for each walk
                const walkCard = document.createElement("div");
                walkCard.className = "walk-card";
                walkCard.setAttribute("data-walk-text", walkText);
                walkCard.setAttribute("data-aurora-id", auroraId);
                walkCard.setAttribute("data-walk-index", originalIndex); // Store the ORIGINAL index, not display index
                walkCard.setAttribute("data-display-index", displayIndex);
                // Check if the walk should be visible based on search text and aurora IDs
                const searchLower = searchText.trim().toLowerCase();
                const walkLower = walkText.toLowerCase();
                const auroraLower = auroraId.toLowerCase();
                let shouldHide = false;
                // Hide based on text search
                if (searchLower && !walkLower.includes(searchLower) && !auroraLower.includes(searchLower)) shouldHide = true;
                // Hide based on Aurora IDs, unless it's in the list
                if (auroraIds.length > 0 && !auroraIds.includes(auroraId)) shouldHide = true;
                if (shouldHide) walkCard.style.display = "none";
                // Simplified display of the walk with copy feature, accordion for details
                walkCard.innerHTML = `
                    <div class="card mb-2">
                        <div class="card-header d-flex justify-content-between align-items-center">
                            <button class="btn btn-link btn-sm walk-toggle-btn" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#walk-${displayIndex}" aria-expanded="false" aria-controls="walk-${displayIndex}">
                                <i class="bi bi-chevron-down chevron-icon"></i>
                                Walk ${displayIndex + 1} <span class="badge bg-info ms-2">${walk.length} nodes</span>
                            </button>
                            <div class="btn-group btn-group-sm" role="group">
                                <button class="btn btn-outline-primary highlight-walk-btn" title="Highlight this walk">
                                    <i class="bi bi-lightbulb"></i>
                                </button>
                                <button class="btn btn-outline-secondary copy-aurora-btn" title="Copy Aurora ID">
                                    <i class="bi bi-clipboard"></i>
                                </button>
                            </div>
                        </div>
                        <div id="walk-${displayIndex}" class="collapse">
                            <div class="card-body">
                                <div class="aurora-id-container">
                                    <small class="text-muted d-flex align-items-center">
                                        <span class="me-2">Aurora ID:</span>
                                        <code class="aurora-id">${auroraId}</code>
                                    </small>
                                </div>
                                <div class="walk-path mt-2">
                                    <div class="path-visualization">
                                        ${$3f3da726e7661cf2$var$generatePathVisualization(walk)}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                `;
                return walkCard;
            } catch (error) {
                console.error(`Error processing walk ${displayIndex}:`, error);
                return null;
            }
        });
        // Wait for all walks to be processed
        const walkCards = await Promise.all(walkPromises);
        // Clear loading indicator
        walkListContainer.querySelector(".loading-walks")?.remove();
        // Append only the non-null walk cards
        if (walksAccordion) {
            walkCards.filter((card)=>card !== null).forEach((card)=>walksAccordion.appendChild(card));
            // Add event listeners to buttons after all cards are added
            $3f3da726e7661cf2$var$addWalkCardEventListeners();
            // Update count of visible walks based on search
            $3f3da726e7661cf2$var$updateVisibleWalksCount();
        }
    } catch (error) {
        console.error("Error displaying walks:", error);
        walksContainer.innerHTML += `
            <div class="alert alert-danger">
                <i class="bi bi-exclamation-triangle-fill me-2"></i>
                Error displaying walks: ${error.message}
            </div>
        `;
    }
    // Add styles for the walks section
    $3f3da726e7661cf2$var$addWalksStyles();
}
// Function to handle Aurora IDs file upload
async function $3f3da726e7661cf2$var$handleAuroraIdsFileUpload() {
    const fileInput = document.getElementById("auroraIdsFile");
    if (!fileInput || !fileInput.files || fileInput.files.length === 0) {
        window.showAlert("Please select a text file containing Aurora IDs.", "warning");
        return;
    }
    const file = fileInput.files[0];
    try {
        // Show a loading indicator
        window.showAlert("Processing Aurora IDs file...", "info");
        const text = await file.text();
        const lines = text.split(/\r?\n/).filter((line)=>line.trim() !== "");
        if (lines.length === 0) {
            window.showAlert("No Aurora IDs found in the file.", "warning");
            return;
        }
        // Get the current search text
        const searchInput = document.getElementById("walkSearch");
        const searchText = searchInput ? searchInput.value : "";
        // Redisplay walks with the specified Aurora IDs
        $3f3da726e7661cf2$var$displayWalks(searchText, lines);
        window.showAlert(`Found ${lines.length} Aurora IDs in the file.`, "success");
    } catch (error) {
        console.error("Error reading Aurora IDs file:", error);
        window.showAlert("Error reading the file. Please make sure it's a valid text file.", "danger");
    }
}
// Function to filter walk cards based on search text and Aurora IDs
function $3f3da726e7661cf2$var$filterWalkCards(searchValue, auroraIds = []) {
    // Keep track of the visible cards and their corresponding walk indices
    let visibleCardCount = 0;
    document.querySelectorAll(".walk-card").forEach((card)=>{
        const walkText = card.getAttribute("data-walk-text").toLowerCase();
        const auroraId = card.getAttribute("data-aurora-id").toLowerCase();
        const walkIndex = card.getAttribute("data-walk-index");
        let shouldShow = true;
        // Filter by search text if provided
        if (searchValue && !walkText.includes(searchValue) && !auroraId.includes(searchValue)) shouldShow = false;
        // Filter by Aurora IDs if provided
        if (auroraIds.length > 0 && !auroraIds.includes(card.getAttribute("data-aurora-id"))) shouldShow = false;
        // Debug information
        if (shouldShow && searchValue) console.log(`Match found: "${searchValue}" in walk ${walkIndex} (${walkText.substring(0, 50)}...)`);
        card.style.display = shouldShow ? "" : "none";
        if (shouldShow) visibleCardCount++;
    });
    console.log(`Filter results: ${visibleCardCount} walks match the criteria`);
    // Update the count of visible walks
    $3f3da726e7661cf2$var$updateVisibleWalksCount();
}
// Helper function to generate a visual representation of the path
function $3f3da726e7661cf2$var$generatePathVisualization(walk) {
    let visualization = '<div class="path-nodes">';
    walk.forEach((node, index)=>{
        const nodeData = node.data();
        const displayName = nodeData.name && nodeData.name !== nodeData.id ? nodeData.name : $3f3da726e7661cf2$var$shortenNodeId(nodeData.id);
        visualization += `
            <div class="path-node${index === 0 ? " start-node" : index === walk.length - 1 ? " end-node" : ""}">
                <div class="node-dot"></div>
                <button class="node-label clickable-node-id" title="${nodeData.id}" data-node-id="${nodeData.id}">${displayName}</button>
                ${index < walk.length - 1 ? '<div class="node-arrow"><i class="bi bi-arrow-right"></i></div>' : ""}
            </div>
        `;
    });
    visualization += "</div>";
    return visualization;
}
// Helper function to shorten node IDs for better display
function $3f3da726e7661cf2$var$shortenNodeId(id) {
    if (id.length > 20) return id.substring(0, 8) + "..." + id.substring(id.length - 8);
    return id;
}
// Helper function to add event listeners to walk cards
function $3f3da726e7661cf2$var$addWalkCardEventListeners() {
    // Highlight walk buttons
    document.querySelectorAll(".highlight-walk-btn").forEach((btn)=>{
        btn.addEventListener("click", ()=>{
            const walkCard = btn.closest(".walk-card");
            const walkIndex = parseInt(walkCard.getAttribute("data-walk-index"), 10);
            console.log(`Highlighting walk at index: ${walkIndex}`);
            if (walkIndex >= 0 && walkIndex < $3f3da726e7661cf2$export$63b4527a2777036f.walks.length) {
                $3f3da726e7661cf2$var$highlightWalk($3f3da726e7661cf2$export$63b4527a2777036f.walks[walkIndex]);
                // Add visual feedback
                btn.classList.add("active");
                setTimeout(()=>btn.classList.remove("active"), 1000);
            } else console.error(`Invalid walk index: ${walkIndex}, max index: ${$3f3da726e7661cf2$export$63b4527a2777036f.walks.length - 1}`);
        });
    });
    // Copy Aurora ID buttons
    document.querySelectorAll(".copy-aurora-btn").forEach((btn)=>{
        btn.addEventListener("click", ()=>{
            const auroraId = btn.closest(".walk-card").getAttribute("data-aurora-id");
            navigator.clipboard.writeText(auroraId).then(()=>{
                // Add visual feedback
                const originalIcon = btn.innerHTML;
                btn.innerHTML = '<i class="bi bi-check"></i>';
                btn.classList.add("btn-success");
                setTimeout(()=>{
                    btn.innerHTML = originalIcon;
                    btn.classList.remove("btn-success");
                }, 1500);
            });
        });
    });
    // Toggle buttons to animate chevron
    document.querySelectorAll(".walk-toggle-btn").forEach((btn)=>{
        btn.addEventListener("click", ()=>{
            const chevron = btn.querySelector(".chevron-icon");
            chevron.classList.toggle("rotated");
        });
    });
    // Add click event listeners to node ids in path visualization
    document.querySelectorAll(".clickable-node-id").forEach((btn)=>{
        btn.addEventListener("click", (e)=>{
            e.stopPropagation(); // Prevent accordion toggle
            const nodeId = btn.getAttribute("data-node-id");
            if (window.highlightNode && typeof window.highlightNode === "function") window.highlightNode($3f3da726e7661cf2$export$63b4527a2777036f.cy, nodeId);
            else if (typeof $3f3da726e7661cf2$var$highlightNode === "function") $3f3da726e7661cf2$var$highlightNode($3f3da726e7661cf2$export$63b4527a2777036f.cy, nodeId);
            else console.error("highlightNode function not found");
        });
    });
}
// Helper function to update the count of visible walks
function $3f3da726e7661cf2$var$updateVisibleWalksCount() {
    const visibleWalks = document.querySelectorAll('.walk-card[style="display: none;"]');
    const totalWalks = document.querySelectorAll(".walk-card").length;
    const visibleCount = totalWalks - visibleWalks.length;
    const walksCountBadge = document.querySelector(".walks-count");
    if (walksCountBadge) walksCountBadge.textContent = `${visibleCount}/${totalWalks}`;
}
// Helper function to add styles for the walks section
function $3f3da726e7661cf2$var$addWalksStyles() {
    // Check if styles are already added
    if (document.getElementById("walks-styles")) return;
    const style = document.createElement("style");
    style.id = "walks-styles";
    style.textContent = `

        .walks-count {
            margin-left: 10px;
            font-size: 0.8em;
        }

        .walk-list-container {
            overflow-y: auto;
            max-height: calc(100vh - 250px);
        }

        .loading-walks {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            padding: 30px 0;
            color: #6c757d;
        }

        .walk-card {
            transition: all 0.2s ease-in-out;
        }

        .walk-card:hover {
            transform: translateY(-2px);
        }

        .walk-toggle-btn {
            color: #212529;
            text-decoration: none;
            width: 100%;
            text-align: left;
            padding: 0;
            display: flex;
            align-items: center;
        }

        .walk-toggle-btn:hover {
            color: #0d6efd;
        }

        .chevron-icon {
            transition: transform 0.3s ease;
            margin-right: 8px;
        }

        .chevron-icon.rotated {
            transform: rotate(180deg);
        }

        .aurora-id-container {
            background: #f8f9fa;
            padding: 8px;
            border-radius: 4px;
            margin-bottom: 10px;
        }

        .aurora-id {
            background: transparent;
            font-family: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
            color: #6610f2;
        }

        .path-visualization {
            margin-top: 10px;
            overflow-x: auto;
        }

        .path-nodes {
            display: flex;
            align-items: center;
            min-width: 100%;
            padding: 10px 0;
        }

        .path-node {
            display: flex;
            align-items: center;
            flex-shrink: 0;
        }

        .node-dot {
            width: 12px;
            height: 12px;
            border-radius: 50%;
            background-color: #6c757d;
            margin: 0 5px;
        }

        .start-node .node-dot {
            background-color: #28a745;
        }

        .end-node .node-dot {
            background-color: #dc3545;
        }

        .node-label {
            font-size: 0.8rem;
            max-width: 150px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            border: 1px solid #d1d5db;
            border-radius: 999px;
            background: #fff;
            color: #222;
            padding: 4px 14px;
            margin: 0 2px;
            box-shadow: 0 1px 3px rgba(0,0,0,0.04);
            cursor: pointer;
            transition: border 0.15s, box-shadow 0.15s, color 0.15s, background 0.15s, transform 0.1s;
            outline: none;
            font-weight: 500;
            position: relative;
        }
        .node-label:focus, .node-label:hover {
            background: #f3f4f6;
            border-color: #a5b4fc;
            color: #1d4ed8;
            box-shadow: 0 2px 8px rgba(30, 64, 175, 0.08);
            transform: scale(1.04);
            z-index: 2;
        }
        .node-label:active {
            background: #e0e7ff;
            border-color: #6366f1;
            color: #3730a3;
            transform: scale(0.98);
        }
        .node-arrow {
            margin: 0 5px;
            color: #adb5bd;
        }

        .highlight-walk-btn.active {
            background-color: #ffc107;
            border-color: #ffc107;
        }
    `;
    document.head.appendChild(style);
}
function $3f3da726e7661cf2$var$highlightWalk(walk) {
    // Reset any previously highlight nodes or edges
    $3f3da726e7661cf2$export$63b4527a2777036f.cy.elements().removeClass("highlightWalk");
    walk.forEach((node, index)=>{
        node.addClass("highlightWalk");
    });
    $3f3da726e7661cf2$export$63b4527a2777036f.cy.style().update();
}
// node data
// {
//   "id": "chr8_62251376_62302403_T_349",
//   "indegree": 1,
//   "outdegree": 0,
//   "data": {
//     "chrom": "chr8",
//     "ref_start": 62251376,
//     "ref_end": 62302403,
//     "strand": "-",
//     "is_head": false,
//     "node_id": 349,
//     "exons": "[62251376-62252614,62284023-62284107,62284267-62284408,62284826-62284911,62302311-62302403]",
//     "ptc": 1,
//     "ptf": 0,
//     "id": "chr8_62251376_62302403_T_349",
//     "value": "chr8_62251376_62302403_T_349",
//     "name": "chr8_62251376_62302403_T_349"
//   }
// }
// Function to calculate node ranking by PTC
function $3f3da726e7661cf2$var$calculateNodeRanking(cy) {
    if (!cy) {
        console.warn("No graph provided to calculateNodeRanking");
        return [];
    }
    // Check if graph has nodes before getting the array
    const nodes = cy.nodes().length > 0 ? cy.nodes().toArray() : [];
    // If there are no nodes, return an empty array
    if (nodes.length === 0) return [];
    const ranking = nodes.map((node)=>{
        return {
            id: node.id(),
            name: node.data("name") || node.id(),
            ptc: node.data("ptc") || 0,
            class: node.data("class") || "unknown"
        };
    }).filter((node)=>node.ptc > 0).sort((a, b)=>b.ptc - a.ptc);
    return ranking;
}
// Function to update the node ranking modal
function $3f3da726e7661cf2$var$updateNodeRankingModal(cy) {
    const ranking = $3f3da726e7661cf2$var$calculateNodeRanking(cy);
    const nodeRankingList = document.getElementById("nodeRankingList");
    // Clear the current list
    nodeRankingList.innerHTML = "";
    if (ranking.length === 0) {
        nodeRankingList.innerHTML = '<li class="list-group-item">No nodes with PTC values found</li>';
        return;
    }
    // Add clear highlights button at the top
    const clearButtonItem = document.createElement("li");
    clearButtonItem.className = "list-group-item d-flex justify-content-end";
    clearButtonItem.innerHTML = `
    <button class="btn btn-outline-secondary btn-sm" id="clearHighlights">
      <i class="bi bi-eraser"></i> Clear Highlights
    </button>
  `;
    nodeRankingList.appendChild(clearButtonItem);
    // Create header row
    const headerItem = document.createElement("li");
    headerItem.className = "list-group-item active";
    headerItem.innerHTML = `
    <div class="row">
      <div class="col-1"><strong>Rank</strong></div>
      <div class="col-4"><strong>Name</strong></div>
      <div class="col-3"><strong>PTC Value</strong></div>
      <div class="col-2"><strong>Class</strong></div>
      <div class="col-2"><strong>Action</strong></div>
    </div>
  `;
    nodeRankingList.appendChild(headerItem);
    // Add each node to the list
    ranking.forEach((node, index)=>{
        const listItem = document.createElement("li");
        listItem.className = "list-group-item";
        listItem.innerHTML = `
      <div class="row">
        <div class="col-1">${index + 1}</div>
        <div class="col-4">${node.name}</div>
        <div class="col-3">${node.ptc.toFixed(4)}</div>
        <div class="col-2">${node.class}</div>
        <div class="col-2">
          <button class="btn btn-sm btn-primary highlight-node" data-node-id="${node.id}">
            Highlight
          </button>
        </div>
      </div>
    `;
        nodeRankingList.appendChild(listItem);
    });
    // Add event listeners to highlight buttons
    document.querySelectorAll(".highlight-node").forEach((button)=>{
        button.addEventListener("click", (event)=>{
            const nodeId = event.currentTarget.getAttribute("data-node-id");
            $3f3da726e7661cf2$var$highlightNode($3f3da726e7661cf2$export$63b4527a2777036f.cy, nodeId);
        });
    });
    // Add event listener for the clear highlights button
    document.getElementById("clearHighlights").addEventListener("click", ()=>{
        $3f3da726e7661cf2$export$915afd478a0e2a72(cy);
    });
}
// Function to highlight a specific node
function $3f3da726e7661cf2$var$highlightNode(cy, nodeId) {
    // Find the node by ID
    const node = cy.getElementById(nodeId);
    if (node.length > 0) {
        // Check if the node is already highlighted
        const isAlreadyHighlighted = node.hasClass("highlighted");
        if (isAlreadyHighlighted) {
            console.log("Node is already highlighted, clearing highlights");
            // If the node is already highlighted, clear all highlights
            $3f3da726e7661cf2$export$915afd478a0e2a72(cy);
        } else {
            console.log("Highlighting node:", nodeId);
            // Clear any existing highlights first
            $3f3da726e7661cf2$export$915afd478a0e2a72(cy);
            // Add highlighted class to the node
            node.addClass("highlighted");
            // Fade all other nodes and edges
            cy.elements().difference(node).addClass("faded");
            // Center the view on the highlighted node
            cy.animate({
                fit: {
                    eles: node,
                    padding: 50
                },
                duration: 500
            });
            // Update the info panel with node information
            const infoContent = document.getElementById("infoContent");
            if (infoContent) (0, $2UrZ2.displayElementInfo)(node, infoContent);
        }
    } else console.error("Node not found:", nodeId);
}
function $3f3da726e7661cf2$export$915afd478a0e2a72(cy) {
    console.log("Clearing all highlights");
    // Check if cy exists before accessing its elements
    if (!cy) {
        console.warn("Cannot clear highlights: graph object is null");
        return;
    }
    // Remove highlighting classes from all elements
    cy.elements().removeClass("highlighted");
    cy.elements().removeClass("faded");
    cy.elements().removeClass("highlightWalk"); // Also clear walk highlights
    // Reset the view to fit all elements
    cy.fit(cy.elements().filter(":visible"), 50);
}
// Add a global event listener for the escape key to clear highlights
document.addEventListener("keydown", (event)=>{
    if (event.key === "Escape") $3f3da726e7661cf2$export$915afd478a0e2a72($3f3da726e7661cf2$export$63b4527a2777036f.cy);
});
// Event listener for the node ranking button
document.getElementById("showNodeRanking").addEventListener("click", ()=>{
    $3f3da726e7661cf2$var$updateNodeRankingModal($3f3da726e7661cf2$export$63b4527a2777036f.cy); // Use STATE.cy instead of just cy
});

});
parcelRegister("lsJox", function(module, exports) {

$parcel$export(module.exports, "default", () => $e815fda779bc047b$export$2e2bcd8739ae039);
/**
 * Copyright (c) 2016-2025, The Cytoscape Consortium.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy of
 * this software and associated documentation files (the “Software”), to deal in
 * the Software without restriction, including without limitation the rights to
 * use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies
 * of the Software, and to permit persons to whom the Software is furnished to do
 * so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED “AS IS”, WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */ function $e815fda779bc047b$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $e815fda779bc047b$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
function $e815fda779bc047b$var$_arrayWithoutHoles(r) {
    if (Array.isArray(r)) return $e815fda779bc047b$var$_arrayLikeToArray(r);
}
function $e815fda779bc047b$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function $e815fda779bc047b$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, $e815fda779bc047b$var$_toPropertyKey(o.key), o);
    }
}
function $e815fda779bc047b$var$_createClass(e, r, t) {
    return r && $e815fda779bc047b$var$_defineProperties(e.prototype, r), Object.defineProperty(e, "prototype", {
        writable: false
    }), e;
}
function $e815fda779bc047b$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $e815fda779bc047b$var$_unsupportedIterableToArray(r)) || e) {
            t && (r = t);
            var n = 0, F = function() {};
            return {
                s: F,
                n: function() {
                    return n >= r.length ? {
                        done: true
                    } : {
                        done: false,
                        value: r[n++]
                    };
                },
                e: function(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = true, u = false;
    return {
        s: function() {
            t = t.call(r);
        },
        n: function() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function(r) {
            u = true, o = r;
        },
        f: function() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $e815fda779bc047b$var$_defineProperty$1(e, r, t) {
    return (r = $e815fda779bc047b$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: true,
        configurable: true,
        writable: true
    }) : e[r] = t, e;
}
function $e815fda779bc047b$var$_iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function $e815fda779bc047b$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = true, o = false;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = true, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $e815fda779bc047b$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $e815fda779bc047b$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $e815fda779bc047b$var$_slicedToArray(r, e) {
    return $e815fda779bc047b$var$_arrayWithHoles(r) || $e815fda779bc047b$var$_iterableToArrayLimit(r, e) || $e815fda779bc047b$var$_unsupportedIterableToArray(r, e) || $e815fda779bc047b$var$_nonIterableRest();
}
function $e815fda779bc047b$var$_toConsumableArray(r) {
    return $e815fda779bc047b$var$_arrayWithoutHoles(r) || $e815fda779bc047b$var$_iterableToArray(r) || $e815fda779bc047b$var$_unsupportedIterableToArray(r) || $e815fda779bc047b$var$_nonIterableSpread();
}
function $e815fda779bc047b$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (undefined !== e) {
        var i = e.call(t, r);
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return String(t);
}
function $e815fda779bc047b$var$_toPropertyKey(t) {
    var i = $e815fda779bc047b$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $e815fda779bc047b$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $e815fda779bc047b$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $e815fda779bc047b$var$_typeof(o);
}
function $e815fda779bc047b$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $e815fda779bc047b$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $e815fda779bc047b$var$_arrayLikeToArray(r, a) : undefined;
    }
}
var $e815fda779bc047b$var$_window = typeof window === 'undefined' ? null : window; // eslint-disable-line no-undef
var $e815fda779bc047b$var$navigator = $e815fda779bc047b$var$_window ? $e815fda779bc047b$var$_window.navigator : null;
$e815fda779bc047b$var$_window && $e815fda779bc047b$var$_window.document;
var $e815fda779bc047b$var$typeofstr = $e815fda779bc047b$var$_typeof('');
var $e815fda779bc047b$var$typeofobj = $e815fda779bc047b$var$_typeof({});
var $e815fda779bc047b$var$typeoffn = $e815fda779bc047b$var$_typeof(function() {});
var $e815fda779bc047b$var$typeofhtmlele = typeof HTMLElement === "undefined" ? "undefined" : $e815fda779bc047b$var$_typeof(HTMLElement);
var $e815fda779bc047b$var$instanceStr = function instanceStr(obj) {
    return obj && obj.instanceString && $e815fda779bc047b$var$fn$6(obj.instanceString) ? obj.instanceString() : null;
};
var $e815fda779bc047b$var$string = function string(obj) {
    return obj != null && $e815fda779bc047b$var$_typeof(obj) == $e815fda779bc047b$var$typeofstr;
};
var $e815fda779bc047b$var$fn$6 = function fn(obj) {
    return obj != null && $e815fda779bc047b$var$_typeof(obj) === $e815fda779bc047b$var$typeoffn;
};
var $e815fda779bc047b$var$array = function array(obj) {
    return !$e815fda779bc047b$var$elementOrCollection(obj) && (Array.isArray ? Array.isArray(obj) : obj != null && obj instanceof Array);
};
var $e815fda779bc047b$var$plainObject = function plainObject(obj) {
    return obj != null && $e815fda779bc047b$var$_typeof(obj) === $e815fda779bc047b$var$typeofobj && !$e815fda779bc047b$var$array(obj) && obj.constructor === Object;
};
var $e815fda779bc047b$var$object = function object(obj) {
    return obj != null && $e815fda779bc047b$var$_typeof(obj) === $e815fda779bc047b$var$typeofobj;
};
var $e815fda779bc047b$var$number$1 = function number(obj) {
    return obj != null && $e815fda779bc047b$var$_typeof(obj) === $e815fda779bc047b$var$_typeof(1) && !isNaN(obj);
};
var $e815fda779bc047b$var$integer = function integer(obj) {
    return $e815fda779bc047b$var$number$1(obj) && Math.floor(obj) === obj;
};
var $e815fda779bc047b$var$htmlElement = function htmlElement(obj) {
    if ('undefined' === $e815fda779bc047b$var$typeofhtmlele) return undefined;
    else return null != obj && obj instanceof HTMLElement;
};
var $e815fda779bc047b$var$elementOrCollection = function elementOrCollection(obj) {
    return $e815fda779bc047b$var$element(obj) || $e815fda779bc047b$var$collection(obj);
};
var $e815fda779bc047b$var$element = function element(obj) {
    return $e815fda779bc047b$var$instanceStr(obj) === 'collection' && obj._private.single;
};
var $e815fda779bc047b$var$collection = function collection(obj) {
    return $e815fda779bc047b$var$instanceStr(obj) === 'collection' && !obj._private.single;
};
var $e815fda779bc047b$var$core = function core(obj) {
    return $e815fda779bc047b$var$instanceStr(obj) === 'core';
};
var $e815fda779bc047b$var$stylesheet = function stylesheet(obj) {
    return $e815fda779bc047b$var$instanceStr(obj) === 'stylesheet';
};
var $e815fda779bc047b$var$event = function event(obj) {
    return $e815fda779bc047b$var$instanceStr(obj) === 'event';
};
var $e815fda779bc047b$var$emptyString = function emptyString(obj) {
    if (obj === undefined || obj === null) // null is empty
    return true;
    else if (obj === '' || obj.match(/^\s+$/)) return true; // empty string is empty
    return false; // otherwise, we don't know what we've got
};
var $e815fda779bc047b$var$domElement = function domElement(obj) {
    if (typeof HTMLElement === 'undefined') return false; // we're not in a browser so it doesn't matter
    else return obj instanceof HTMLElement;
};
var $e815fda779bc047b$var$boundingBox = function boundingBox(obj) {
    return $e815fda779bc047b$var$plainObject(obj) && $e815fda779bc047b$var$number$1(obj.x1) && $e815fda779bc047b$var$number$1(obj.x2) && $e815fda779bc047b$var$number$1(obj.y1) && $e815fda779bc047b$var$number$1(obj.y2);
};
var $e815fda779bc047b$var$promise = function promise(obj) {
    return $e815fda779bc047b$var$object(obj) && $e815fda779bc047b$var$fn$6(obj.then);
};
var $e815fda779bc047b$var$ms = function ms() {
    return $e815fda779bc047b$var$navigator && $e815fda779bc047b$var$navigator.userAgent.match(/msie|trident|edge/i);
}; // probably a better way to detect this...
var $e815fda779bc047b$var$memoize = function memoize(fn, keyFn) {
    if (!keyFn) keyFn = function keyFn() {
        if (arguments.length === 1) return arguments[0];
        else if (arguments.length === 0) return 'undefined';
        var args = [];
        for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
        return args.join('$');
    };
    var _memoizedFn = function memoizedFn() {
        var self1 = this;
        var args = arguments;
        var ret;
        var k = keyFn.apply(self1, args);
        var cache = _memoizedFn.cache;
        if (!(ret = cache[k])) ret = cache[k] = fn.apply(self1, args);
        return ret;
    };
    _memoizedFn.cache = {};
    return _memoizedFn;
};
var $e815fda779bc047b$var$camel2dash = $e815fda779bc047b$var$memoize(function(str) {
    return str.replace(/([A-Z])/g, function(v) {
        return '-' + v.toLowerCase();
    });
});
var $e815fda779bc047b$var$dash2camel = $e815fda779bc047b$var$memoize(function(str) {
    return str.replace(/(-\w)/g, function(v) {
        return v[1].toUpperCase();
    });
});
var $e815fda779bc047b$var$prependCamel = $e815fda779bc047b$var$memoize(function(prefix, str) {
    return prefix + str[0].toUpperCase() + str.substring(1);
}, function(prefix, str) {
    return prefix + '$' + str;
});
var $e815fda779bc047b$var$capitalize = function capitalize(str) {
    if ($e815fda779bc047b$var$emptyString(str)) return str;
    return str.charAt(0).toUpperCase() + str.substring(1);
};
var $e815fda779bc047b$var$endsWith = function endsWith(string, suffix) {
    return string.slice(-1 * suffix.length) === suffix;
};
var $e815fda779bc047b$var$number = '(?:[-+]?(?:(?:\\d+|\\d*\\.\\d+)(?:[Ee][+-]?\\d+)?))';
var $e815fda779bc047b$var$rgba = 'rgb[a]?\\((' + $e815fda779bc047b$var$number + '[%]?)\\s*,\\s*(' + $e815fda779bc047b$var$number + '[%]?)\\s*,\\s*(' + $e815fda779bc047b$var$number + '[%]?)(?:\\s*,\\s*(' + $e815fda779bc047b$var$number + '))?\\)';
var $e815fda779bc047b$var$rgbaNoBackRefs = 'rgb[a]?\\((?:' + $e815fda779bc047b$var$number + '[%]?)\\s*,\\s*(?:' + $e815fda779bc047b$var$number + '[%]?)\\s*,\\s*(?:' + $e815fda779bc047b$var$number + '[%]?)(?:\\s*,\\s*(?:' + $e815fda779bc047b$var$number + '))?\\)';
var $e815fda779bc047b$var$hsla = 'hsl[a]?\\((' + $e815fda779bc047b$var$number + ')\\s*,\\s*(' + $e815fda779bc047b$var$number + '[%])\\s*,\\s*(' + $e815fda779bc047b$var$number + '[%])(?:\\s*,\\s*(' + $e815fda779bc047b$var$number + '))?\\)';
var $e815fda779bc047b$var$hslaNoBackRefs = 'hsl[a]?\\((?:' + $e815fda779bc047b$var$number + ')\\s*,\\s*(?:' + $e815fda779bc047b$var$number + '[%])\\s*,\\s*(?:' + $e815fda779bc047b$var$number + '[%])(?:\\s*,\\s*(?:' + $e815fda779bc047b$var$number + '))?\\)';
var $e815fda779bc047b$var$hex3 = '\\#[0-9a-fA-F]{3}';
var $e815fda779bc047b$var$hex6 = '\\#[0-9a-fA-F]{6}';
var $e815fda779bc047b$var$ascending = function ascending(a, b) {
    if (a < b) return -1;
    else if (a > b) return 1;
    else return 0;
};
var $e815fda779bc047b$var$descending = function descending(a, b) {
    return -1 * $e815fda779bc047b$var$ascending(a, b);
};
var $e815fda779bc047b$var$extend = Object.assign != null ? Object.assign.bind(Object) : function(tgt) {
    var args = arguments;
    for(var i = 1; i < args.length; i++){
        var obj = args[i];
        if (obj == null) continue;
        var keys = Object.keys(obj);
        for(var j = 0; j < keys.length; j++){
            var k = keys[j];
            tgt[k] = obj[k];
        }
    }
    return tgt;
};
// get [r, g, b] from #abc or #aabbcc
var $e815fda779bc047b$var$hex2tuple = function hex2tuple(hex) {
    if (!(hex.length === 4 || hex.length === 7) || hex[0] !== '#') return;
    var shortHex = hex.length === 4;
    var r, g, b;
    var base = 16;
    if (shortHex) {
        r = parseInt(hex[1] + hex[1], base);
        g = parseInt(hex[2] + hex[2], base);
        b = parseInt(hex[3] + hex[3], base);
    } else {
        r = parseInt(hex[1] + hex[2], base);
        g = parseInt(hex[3] + hex[4], base);
        b = parseInt(hex[5] + hex[6], base);
    }
    return [
        r,
        g,
        b
    ];
};
// get [r, g, b, a] from hsl(0, 0, 0) or hsla(0, 0, 0, 0)
var $e815fda779bc047b$var$hsl2tuple = function hsl2tuple(hsl) {
    var ret;
    var h, s, l, a, r, g, b;
    function hue2rgb(p, q, t) {
        if (t < 0) t += 1;
        if (t > 1) t -= 1;
        if (t < 1 / 6) return p + (q - p) * 6 * t;
        if (t < 0.5) return q;
        if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
        return p;
    }
    var m1 = new RegExp('^' + $e815fda779bc047b$var$hsla + '$').exec(hsl);
    if (m1) {
        // get hue
        h = parseInt(m1[1]);
        if (h < 0) h = (360 - -1 * h % 360) % 360;
        else if (h > 360) h = h % 360;
        h /= 360; // normalise on [0, 1]
        s = parseFloat(m1[2]);
        if (s < 0 || s > 100) return;
         // saturation is [0, 100]
        s = s / 100; // normalise on [0, 1]
        l = parseFloat(m1[3]);
        if (l < 0 || l > 100) return;
         // lightness is [0, 100]
        l = l / 100; // normalise on [0, 1]
        a = m1[4];
        if (a !== undefined) {
            a = parseFloat(a);
            if (a < 0 || a > 1) return;
             // alpha is [0, 1]
        }
        // now, convert to rgb
        // code from http://mjijackson.com/2008/02/rgb-to-hsl-and-rgb-to-hsv-color-model-conversion-algorithms-in-javascript
        if (s === 0) r = g = b = Math.round(l * 255); // achromatic
        else {
            var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
            var p = 2 * l - q;
            r = Math.round(255 * hue2rgb(p, q, h + 1 / 3));
            g = Math.round(255 * hue2rgb(p, q, h));
            b = Math.round(255 * hue2rgb(p, q, h - 1 / 3));
        }
        ret = [
            r,
            g,
            b,
            a
        ];
    }
    return ret;
};
// get [r, g, b, a] from rgb(0, 0, 0) or rgba(0, 0, 0, 0)
var $e815fda779bc047b$var$rgb2tuple = function rgb2tuple(rgb) {
    var ret;
    var m1 = new RegExp('^' + $e815fda779bc047b$var$rgba + '$').exec(rgb);
    if (m1) {
        ret = [];
        var isPct = [];
        for(var i = 1; i <= 3; i++){
            var channel = m1[i];
            if (channel[channel.length - 1] === '%') isPct[i] = true;
            channel = parseFloat(channel);
            if (isPct[i]) channel = channel / 100 * 255; // normalise to [0, 255]
            if (channel < 0 || channel > 255) return;
             // invalid channel value
            ret.push(Math.floor(channel));
        }
        var atLeastOneIsPct = isPct[1] || isPct[2] || isPct[3];
        var allArePct = isPct[1] && isPct[2] && isPct[3];
        if (atLeastOneIsPct && !allArePct) return;
         // must all be percent values if one is
        var alpha = m1[4];
        if (alpha !== undefined) {
            alpha = parseFloat(alpha);
            if (alpha < 0 || alpha > 1) return;
             // invalid alpha value
            ret.push(alpha);
        }
    }
    return ret;
};
var $e815fda779bc047b$var$colorname2tuple = function colorname2tuple(color) {
    return $e815fda779bc047b$var$colors[color.toLowerCase()];
};
var $e815fda779bc047b$var$color2tuple = function color2tuple(color) {
    return ($e815fda779bc047b$var$array(color) ? color : null) || $e815fda779bc047b$var$colorname2tuple(color) || $e815fda779bc047b$var$hex2tuple(color) || $e815fda779bc047b$var$rgb2tuple(color) || $e815fda779bc047b$var$hsl2tuple(color);
};
var $e815fda779bc047b$var$colors = {
    // special colour names
    transparent: [
        0,
        0,
        0,
        0
    ],
    // NB alpha === 0
    // regular colours
    aliceblue: [
        240,
        248,
        255
    ],
    antiquewhite: [
        250,
        235,
        215
    ],
    aqua: [
        0,
        255,
        255
    ],
    aquamarine: [
        127,
        255,
        212
    ],
    azure: [
        240,
        255,
        255
    ],
    beige: [
        245,
        245,
        220
    ],
    bisque: [
        255,
        228,
        196
    ],
    black: [
        0,
        0,
        0
    ],
    blanchedalmond: [
        255,
        235,
        205
    ],
    blue: [
        0,
        0,
        255
    ],
    blueviolet: [
        138,
        43,
        226
    ],
    brown: [
        165,
        42,
        42
    ],
    burlywood: [
        222,
        184,
        135
    ],
    cadetblue: [
        95,
        158,
        160
    ],
    chartreuse: [
        127,
        255,
        0
    ],
    chocolate: [
        210,
        105,
        30
    ],
    coral: [
        255,
        127,
        80
    ],
    cornflowerblue: [
        100,
        149,
        237
    ],
    cornsilk: [
        255,
        248,
        220
    ],
    crimson: [
        220,
        20,
        60
    ],
    cyan: [
        0,
        255,
        255
    ],
    darkblue: [
        0,
        0,
        139
    ],
    darkcyan: [
        0,
        139,
        139
    ],
    darkgoldenrod: [
        184,
        134,
        11
    ],
    darkgray: [
        169,
        169,
        169
    ],
    darkgreen: [
        0,
        100,
        0
    ],
    darkgrey: [
        169,
        169,
        169
    ],
    darkkhaki: [
        189,
        183,
        107
    ],
    darkmagenta: [
        139,
        0,
        139
    ],
    darkolivegreen: [
        85,
        107,
        47
    ],
    darkorange: [
        255,
        140,
        0
    ],
    darkorchid: [
        153,
        50,
        204
    ],
    darkred: [
        139,
        0,
        0
    ],
    darksalmon: [
        233,
        150,
        122
    ],
    darkseagreen: [
        143,
        188,
        143
    ],
    darkslateblue: [
        72,
        61,
        139
    ],
    darkslategray: [
        47,
        79,
        79
    ],
    darkslategrey: [
        47,
        79,
        79
    ],
    darkturquoise: [
        0,
        206,
        209
    ],
    darkviolet: [
        148,
        0,
        211
    ],
    deeppink: [
        255,
        20,
        147
    ],
    deepskyblue: [
        0,
        191,
        255
    ],
    dimgray: [
        105,
        105,
        105
    ],
    dimgrey: [
        105,
        105,
        105
    ],
    dodgerblue: [
        30,
        144,
        255
    ],
    firebrick: [
        178,
        34,
        34
    ],
    floralwhite: [
        255,
        250,
        240
    ],
    forestgreen: [
        34,
        139,
        34
    ],
    fuchsia: [
        255,
        0,
        255
    ],
    gainsboro: [
        220,
        220,
        220
    ],
    ghostwhite: [
        248,
        248,
        255
    ],
    gold: [
        255,
        215,
        0
    ],
    goldenrod: [
        218,
        165,
        32
    ],
    gray: [
        128,
        128,
        128
    ],
    grey: [
        128,
        128,
        128
    ],
    green: [
        0,
        128,
        0
    ],
    greenyellow: [
        173,
        255,
        47
    ],
    honeydew: [
        240,
        255,
        240
    ],
    hotpink: [
        255,
        105,
        180
    ],
    indianred: [
        205,
        92,
        92
    ],
    indigo: [
        75,
        0,
        130
    ],
    ivory: [
        255,
        255,
        240
    ],
    khaki: [
        240,
        230,
        140
    ],
    lavender: [
        230,
        230,
        250
    ],
    lavenderblush: [
        255,
        240,
        245
    ],
    lawngreen: [
        124,
        252,
        0
    ],
    lemonchiffon: [
        255,
        250,
        205
    ],
    lightblue: [
        173,
        216,
        230
    ],
    lightcoral: [
        240,
        128,
        128
    ],
    lightcyan: [
        224,
        255,
        255
    ],
    lightgoldenrodyellow: [
        250,
        250,
        210
    ],
    lightgray: [
        211,
        211,
        211
    ],
    lightgreen: [
        144,
        238,
        144
    ],
    lightgrey: [
        211,
        211,
        211
    ],
    lightpink: [
        255,
        182,
        193
    ],
    lightsalmon: [
        255,
        160,
        122
    ],
    lightseagreen: [
        32,
        178,
        170
    ],
    lightskyblue: [
        135,
        206,
        250
    ],
    lightslategray: [
        119,
        136,
        153
    ],
    lightslategrey: [
        119,
        136,
        153
    ],
    lightsteelblue: [
        176,
        196,
        222
    ],
    lightyellow: [
        255,
        255,
        224
    ],
    lime: [
        0,
        255,
        0
    ],
    limegreen: [
        50,
        205,
        50
    ],
    linen: [
        250,
        240,
        230
    ],
    magenta: [
        255,
        0,
        255
    ],
    maroon: [
        128,
        0,
        0
    ],
    mediumaquamarine: [
        102,
        205,
        170
    ],
    mediumblue: [
        0,
        0,
        205
    ],
    mediumorchid: [
        186,
        85,
        211
    ],
    mediumpurple: [
        147,
        112,
        219
    ],
    mediumseagreen: [
        60,
        179,
        113
    ],
    mediumslateblue: [
        123,
        104,
        238
    ],
    mediumspringgreen: [
        0,
        250,
        154
    ],
    mediumturquoise: [
        72,
        209,
        204
    ],
    mediumvioletred: [
        199,
        21,
        133
    ],
    midnightblue: [
        25,
        25,
        112
    ],
    mintcream: [
        245,
        255,
        250
    ],
    mistyrose: [
        255,
        228,
        225
    ],
    moccasin: [
        255,
        228,
        181
    ],
    navajowhite: [
        255,
        222,
        173
    ],
    navy: [
        0,
        0,
        128
    ],
    oldlace: [
        253,
        245,
        230
    ],
    olive: [
        128,
        128,
        0
    ],
    olivedrab: [
        107,
        142,
        35
    ],
    orange: [
        255,
        165,
        0
    ],
    orangered: [
        255,
        69,
        0
    ],
    orchid: [
        218,
        112,
        214
    ],
    palegoldenrod: [
        238,
        232,
        170
    ],
    palegreen: [
        152,
        251,
        152
    ],
    paleturquoise: [
        175,
        238,
        238
    ],
    palevioletred: [
        219,
        112,
        147
    ],
    papayawhip: [
        255,
        239,
        213
    ],
    peachpuff: [
        255,
        218,
        185
    ],
    peru: [
        205,
        133,
        63
    ],
    pink: [
        255,
        192,
        203
    ],
    plum: [
        221,
        160,
        221
    ],
    powderblue: [
        176,
        224,
        230
    ],
    purple: [
        128,
        0,
        128
    ],
    red: [
        255,
        0,
        0
    ],
    rosybrown: [
        188,
        143,
        143
    ],
    royalblue: [
        65,
        105,
        225
    ],
    saddlebrown: [
        139,
        69,
        19
    ],
    salmon: [
        250,
        128,
        114
    ],
    sandybrown: [
        244,
        164,
        96
    ],
    seagreen: [
        46,
        139,
        87
    ],
    seashell: [
        255,
        245,
        238
    ],
    sienna: [
        160,
        82,
        45
    ],
    silver: [
        192,
        192,
        192
    ],
    skyblue: [
        135,
        206,
        235
    ],
    slateblue: [
        106,
        90,
        205
    ],
    slategray: [
        112,
        128,
        144
    ],
    slategrey: [
        112,
        128,
        144
    ],
    snow: [
        255,
        250,
        250
    ],
    springgreen: [
        0,
        255,
        127
    ],
    steelblue: [
        70,
        130,
        180
    ],
    tan: [
        210,
        180,
        140
    ],
    teal: [
        0,
        128,
        128
    ],
    thistle: [
        216,
        191,
        216
    ],
    tomato: [
        255,
        99,
        71
    ],
    turquoise: [
        64,
        224,
        208
    ],
    violet: [
        238,
        130,
        238
    ],
    wheat: [
        245,
        222,
        179
    ],
    white: [
        255,
        255,
        255
    ],
    whitesmoke: [
        245,
        245,
        245
    ],
    yellow: [
        255,
        255,
        0
    ],
    yellowgreen: [
        154,
        205,
        50
    ]
};
// sets the value in a map (map may not be built)
var $e815fda779bc047b$var$setMap = function setMap(options) {
    var obj = options.map;
    var keys = options.keys;
    var l = keys.length;
    for(var i = 0; i < l; i++){
        var key = keys[i];
        if ($e815fda779bc047b$var$plainObject(key)) throw Error('Tried to set map with object key');
        if (i < keys.length - 1) {
            // extend the map if necessary
            if (obj[key] == null) obj[key] = {};
            obj = obj[key];
        } else // set the value
        obj[key] = options.value;
    }
};
// gets the value in a map even if it's not built in places
var $e815fda779bc047b$var$getMap = function getMap(options) {
    var obj = options.map;
    var keys = options.keys;
    var l = keys.length;
    for(var i = 0; i < l; i++){
        var key = keys[i];
        if ($e815fda779bc047b$var$plainObject(key)) throw Error('Tried to get map with object key');
        obj = obj[key];
        if (obj == null) return obj;
    }
    return obj;
};
var $e815fda779bc047b$var$commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof $parcel$global !== 'undefined' ? $parcel$global : typeof self !== 'undefined' ? self : {};
function $e815fda779bc047b$var$getDefaultExportFromCjs(x) {
    return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ var $e815fda779bc047b$var$isObject_1;
var $e815fda779bc047b$var$hasRequiredIsObject;
function $e815fda779bc047b$var$requireIsObject() {
    if ($e815fda779bc047b$var$hasRequiredIsObject) return $e815fda779bc047b$var$isObject_1;
    $e815fda779bc047b$var$hasRequiredIsObject = 1;
    function isObject(value) {
        var type = typeof value;
        return value != null && (type == 'object' || type == 'function');
    }
    $e815fda779bc047b$var$isObject_1 = isObject;
    return $e815fda779bc047b$var$isObject_1;
}
/** Detect free variable `global` from Node.js. */ var $e815fda779bc047b$var$_freeGlobal;
var $e815fda779bc047b$var$hasRequired_freeGlobal;
function $e815fda779bc047b$var$require_freeGlobal() {
    if ($e815fda779bc047b$var$hasRequired_freeGlobal) return $e815fda779bc047b$var$_freeGlobal;
    $e815fda779bc047b$var$hasRequired_freeGlobal = 1;
    var freeGlobal = typeof $e815fda779bc047b$var$commonjsGlobal == 'object' && $e815fda779bc047b$var$commonjsGlobal && $e815fda779bc047b$var$commonjsGlobal.Object === Object && $e815fda779bc047b$var$commonjsGlobal;
    $e815fda779bc047b$var$_freeGlobal = freeGlobal;
    return $e815fda779bc047b$var$_freeGlobal;
}
var $e815fda779bc047b$var$_root;
var $e815fda779bc047b$var$hasRequired_root;
function $e815fda779bc047b$var$require_root() {
    if ($e815fda779bc047b$var$hasRequired_root) return $e815fda779bc047b$var$_root;
    $e815fda779bc047b$var$hasRequired_root = 1;
    var freeGlobal = $e815fda779bc047b$var$require_freeGlobal();
    /** Detect free variable `self`. */ var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
    /** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function('return this')();
    $e815fda779bc047b$var$_root = root;
    return $e815fda779bc047b$var$_root;
}
var $e815fda779bc047b$var$now_1;
var $e815fda779bc047b$var$hasRequiredNow;
function $e815fda779bc047b$var$requireNow() {
    if ($e815fda779bc047b$var$hasRequiredNow) return $e815fda779bc047b$var$now_1;
    $e815fda779bc047b$var$hasRequiredNow = 1;
    var root = $e815fda779bc047b$var$require_root();
    /**
	 * Gets the timestamp of the number of milliseconds that have elapsed since
	 * the Unix epoch (1 January 1970 00:00:00 UTC).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Date
	 * @returns {number} Returns the timestamp.
	 * @example
	 *
	 * _.defer(function(stamp) {
	 *   console.log(_.now() - stamp);
	 * }, _.now());
	 * // => Logs the number of milliseconds it took for the deferred invocation.
	 */ var now = function() {
        return root.Date.now();
    };
    $e815fda779bc047b$var$now_1 = now;
    return $e815fda779bc047b$var$now_1;
}
/** Used to match a single whitespace character. */ var $e815fda779bc047b$var$_trimmedEndIndex;
var $e815fda779bc047b$var$hasRequired_trimmedEndIndex;
function $e815fda779bc047b$var$require_trimmedEndIndex() {
    if ($e815fda779bc047b$var$hasRequired_trimmedEndIndex) return $e815fda779bc047b$var$_trimmedEndIndex;
    $e815fda779bc047b$var$hasRequired_trimmedEndIndex = 1;
    var reWhitespace = /\s/;
    /**
	 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
	 * character of `string`.
	 *
	 * @private
	 * @param {string} string The string to inspect.
	 * @returns {number} Returns the index of the last non-whitespace character.
	 */ function trimmedEndIndex(string) {
        var index = string.length;
        while(index-- && reWhitespace.test(string.charAt(index)));
        return index;
    }
    $e815fda779bc047b$var$_trimmedEndIndex = trimmedEndIndex;
    return $e815fda779bc047b$var$_trimmedEndIndex;
}
var $e815fda779bc047b$var$_baseTrim;
var $e815fda779bc047b$var$hasRequired_baseTrim;
function $e815fda779bc047b$var$require_baseTrim() {
    if ($e815fda779bc047b$var$hasRequired_baseTrim) return $e815fda779bc047b$var$_baseTrim;
    $e815fda779bc047b$var$hasRequired_baseTrim = 1;
    var trimmedEndIndex = $e815fda779bc047b$var$require_trimmedEndIndex();
    /** Used to match leading whitespace. */ var reTrimStart = /^\s+/;
    /**
	 * The base implementation of `_.trim`.
	 *
	 * @private
	 * @param {string} string The string to trim.
	 * @returns {string} Returns the trimmed string.
	 */ function baseTrim(string) {
        return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '') : string;
    }
    $e815fda779bc047b$var$_baseTrim = baseTrim;
    return $e815fda779bc047b$var$_baseTrim;
}
var $e815fda779bc047b$var$_Symbol;
var $e815fda779bc047b$var$hasRequired_Symbol;
function $e815fda779bc047b$var$require_Symbol() {
    if ($e815fda779bc047b$var$hasRequired_Symbol) return $e815fda779bc047b$var$_Symbol;
    $e815fda779bc047b$var$hasRequired_Symbol = 1;
    var root = $e815fda779bc047b$var$require_root();
    /** Built-in value references. */ var Symbol1 = root.Symbol;
    $e815fda779bc047b$var$_Symbol = Symbol1;
    return $e815fda779bc047b$var$_Symbol;
}
var $e815fda779bc047b$var$_getRawTag;
var $e815fda779bc047b$var$hasRequired_getRawTag;
function $e815fda779bc047b$var$require_getRawTag() {
    if ($e815fda779bc047b$var$hasRequired_getRawTag) return $e815fda779bc047b$var$_getRawTag;
    $e815fda779bc047b$var$hasRequired_getRawTag = 1;
    var Symbol1 = $e815fda779bc047b$var$require_Symbol();
    /** Used for built-in method references. */ var objectProto = Object.prototype;
    /** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
    /**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */ var nativeObjectToString = objectProto.toString;
    /** Built-in value references. */ var symToStringTag = Symbol1 ? Symbol1.toStringTag : undefined;
    /**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */ function getRawTag(value) {
        var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
        try {
            value[symToStringTag] = undefined;
            var unmasked = true;
        } catch (e) {}
        var result = nativeObjectToString.call(value);
        if (unmasked) {
            if (isOwn) value[symToStringTag] = tag;
            else delete value[symToStringTag];
        }
        return result;
    }
    $e815fda779bc047b$var$_getRawTag = getRawTag;
    return $e815fda779bc047b$var$_getRawTag;
}
/** Used for built-in method references. */ var $e815fda779bc047b$var$_objectToString;
var $e815fda779bc047b$var$hasRequired_objectToString;
function $e815fda779bc047b$var$require_objectToString() {
    if ($e815fda779bc047b$var$hasRequired_objectToString) return $e815fda779bc047b$var$_objectToString;
    $e815fda779bc047b$var$hasRequired_objectToString = 1;
    var objectProto = Object.prototype;
    /**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */ var nativeObjectToString = objectProto.toString;
    /**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */ function objectToString(value) {
        return nativeObjectToString.call(value);
    }
    $e815fda779bc047b$var$_objectToString = objectToString;
    return $e815fda779bc047b$var$_objectToString;
}
var $e815fda779bc047b$var$_baseGetTag;
var $e815fda779bc047b$var$hasRequired_baseGetTag;
function $e815fda779bc047b$var$require_baseGetTag() {
    if ($e815fda779bc047b$var$hasRequired_baseGetTag) return $e815fda779bc047b$var$_baseGetTag;
    $e815fda779bc047b$var$hasRequired_baseGetTag = 1;
    var Symbol1 = $e815fda779bc047b$var$require_Symbol(), getRawTag = $e815fda779bc047b$var$require_getRawTag(), objectToString = $e815fda779bc047b$var$require_objectToString();
    /** `Object#toString` result references. */ var nullTag = '[object Null]', undefinedTag = '[object Undefined]';
    /** Built-in value references. */ var symToStringTag = Symbol1 ? Symbol1.toStringTag : undefined;
    /**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */ function baseGetTag(value) {
        if (value == null) return value === undefined ? undefinedTag : nullTag;
        return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
    }
    $e815fda779bc047b$var$_baseGetTag = baseGetTag;
    return $e815fda779bc047b$var$_baseGetTag;
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ var $e815fda779bc047b$var$isObjectLike_1;
var $e815fda779bc047b$var$hasRequiredIsObjectLike;
function $e815fda779bc047b$var$requireIsObjectLike() {
    if ($e815fda779bc047b$var$hasRequiredIsObjectLike) return $e815fda779bc047b$var$isObjectLike_1;
    $e815fda779bc047b$var$hasRequiredIsObjectLike = 1;
    function isObjectLike(value) {
        return value != null && typeof value == 'object';
    }
    $e815fda779bc047b$var$isObjectLike_1 = isObjectLike;
    return $e815fda779bc047b$var$isObjectLike_1;
}
var $e815fda779bc047b$var$isSymbol_1;
var $e815fda779bc047b$var$hasRequiredIsSymbol;
function $e815fda779bc047b$var$requireIsSymbol() {
    if ($e815fda779bc047b$var$hasRequiredIsSymbol) return $e815fda779bc047b$var$isSymbol_1;
    $e815fda779bc047b$var$hasRequiredIsSymbol = 1;
    var baseGetTag = $e815fda779bc047b$var$require_baseGetTag(), isObjectLike = $e815fda779bc047b$var$requireIsObjectLike();
    /** `Object#toString` result references. */ var symbolTag = '[object Symbol]';
    /**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */ function isSymbol(value) {
        return typeof value == 'symbol' || isObjectLike(value) && baseGetTag(value) == symbolTag;
    }
    $e815fda779bc047b$var$isSymbol_1 = isSymbol;
    return $e815fda779bc047b$var$isSymbol_1;
}
var $e815fda779bc047b$var$toNumber_1;
var $e815fda779bc047b$var$hasRequiredToNumber;
function $e815fda779bc047b$var$requireToNumber() {
    if ($e815fda779bc047b$var$hasRequiredToNumber) return $e815fda779bc047b$var$toNumber_1;
    $e815fda779bc047b$var$hasRequiredToNumber = 1;
    var baseTrim = $e815fda779bc047b$var$require_baseTrim(), isObject = $e815fda779bc047b$var$requireIsObject(), isSymbol = $e815fda779bc047b$var$requireIsSymbol();
    /** Used as references for various `Number` constants. */ var NAN = 0 / 0;
    /** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    /** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
    /** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
    /** Built-in method references without a dependency on `root`. */ var freeParseInt = parseInt;
    /**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */ function toNumber(value) {
        if (typeof value == 'number') return value;
        if (isSymbol(value)) return NAN;
        if (isObject(value)) {
            var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
            value = isObject(other) ? other + '' : other;
        }
        if (typeof value != 'string') return value === 0 ? value : +value;
        value = baseTrim(value);
        var isBinary = reIsBinary.test(value);
        return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
    }
    $e815fda779bc047b$var$toNumber_1 = toNumber;
    return $e815fda779bc047b$var$toNumber_1;
}
var $e815fda779bc047b$var$debounce_1;
var $e815fda779bc047b$var$hasRequiredDebounce;
function $e815fda779bc047b$var$requireDebounce() {
    if ($e815fda779bc047b$var$hasRequiredDebounce) return $e815fda779bc047b$var$debounce_1;
    $e815fda779bc047b$var$hasRequiredDebounce = 1;
    var isObject = $e815fda779bc047b$var$requireIsObject(), now = $e815fda779bc047b$var$requireNow(), toNumber = $e815fda779bc047b$var$requireToNumber();
    /** Error message constants. */ var FUNC_ERROR_TEXT = 'Expected a function';
    /* Built-in method references for those with the same name as other `lodash` methods. */ var nativeMax = Math.max, nativeMin = Math.min;
    /**
	 * Creates a debounced function that delays invoking `func` until after `wait`
	 * milliseconds have elapsed since the last time the debounced function was
	 * invoked. The debounced function comes with a `cancel` method to cancel
	 * delayed `func` invocations and a `flush` method to immediately invoke them.
	 * Provide `options` to indicate whether `func` should be invoked on the
	 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	 * with the last arguments provided to the debounced function. Subsequent
	 * calls to the debounced function return the result of the last `func`
	 * invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the debounced function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.debounce` and `_.throttle`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to debounce.
	 * @param {number} [wait=0] The number of milliseconds to delay.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=false]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {number} [options.maxWait]
	 *  The maximum time `func` is allowed to be delayed before it's invoked.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new debounced function.
	 * @example
	 *
	 * // Avoid costly calculations while the window size is in flux.
	 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	 *
	 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	 * jQuery(element).on('click', _.debounce(sendMail, 300, {
	 *   'leading': true,
	 *   'trailing': false
	 * }));
	 *
	 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	 * var source = new EventSource('/stream');
	 * jQuery(source).on('message', debounced);
	 *
	 * // Cancel the trailing debounced invocation.
	 * jQuery(window).on('popstate', debounced.cancel);
	 */ function debounce(func, wait, options) {
        var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
        if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
        wait = toNumber(wait) || 0;
        if (isObject(options)) {
            leading = !!options.leading;
            maxing = 'maxWait' in options;
            maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
            trailing = 'trailing' in options ? !!options.trailing : trailing;
        }
        function invokeFunc(time) {
            var args = lastArgs, thisArg = lastThis;
            lastArgs = lastThis = undefined;
            lastInvokeTime = time;
            result = func.apply(thisArg, args);
            return result;
        }
        function leadingEdge(time) {
            // Reset any `maxWait` timer.
            lastInvokeTime = time;
            // Start the timer for the trailing edge.
            timerId = setTimeout(timerExpired, wait);
            // Invoke the leading edge.
            return leading ? invokeFunc(time) : result;
        }
        function remainingWait(time) {
            var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
            return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
        }
        function shouldInvoke(time) {
            var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
            // Either this is the first call, activity has stopped and we're at the
            // trailing edge, the system time has gone backwards and we're treating
            // it as the trailing edge, or we've hit the `maxWait` limit.
            return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
        }
        function timerExpired() {
            var time = now();
            if (shouldInvoke(time)) return trailingEdge(time);
            // Restart the timer.
            timerId = setTimeout(timerExpired, remainingWait(time));
        }
        function trailingEdge(time) {
            timerId = undefined;
            // Only invoke if we have `lastArgs` which means `func` has been
            // debounced at least once.
            if (trailing && lastArgs) return invokeFunc(time);
            lastArgs = lastThis = undefined;
            return result;
        }
        function cancel() {
            if (timerId !== undefined) clearTimeout(timerId);
            lastInvokeTime = 0;
            lastArgs = lastCallTime = lastThis = timerId = undefined;
        }
        function flush() {
            return timerId === undefined ? result : trailingEdge(now());
        }
        function debounced() {
            var time = now(), isInvoking = shouldInvoke(time);
            lastArgs = arguments;
            lastThis = this;
            lastCallTime = time;
            if (isInvoking) {
                if (timerId === undefined) return leadingEdge(lastCallTime);
                if (maxing) {
                    // Handle invocations in a tight loop.
                    clearTimeout(timerId);
                    timerId = setTimeout(timerExpired, wait);
                    return invokeFunc(lastCallTime);
                }
            }
            if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
            return result;
        }
        debounced.cancel = cancel;
        debounced.flush = flush;
        return debounced;
    }
    $e815fda779bc047b$var$debounce_1 = debounce;
    return $e815fda779bc047b$var$debounce_1;
}
var $e815fda779bc047b$var$debounceExports = $e815fda779bc047b$var$requireDebounce();
var $e815fda779bc047b$var$debounce = /*@__PURE__*/ $e815fda779bc047b$var$getDefaultExportFromCjs($e815fda779bc047b$var$debounceExports);
var $e815fda779bc047b$var$performance$1 = $e815fda779bc047b$var$_window ? $e815fda779bc047b$var$_window.performance : null;
var $e815fda779bc047b$var$pnow = $e815fda779bc047b$var$performance$1 && $e815fda779bc047b$var$performance$1.now ? function() {
    return $e815fda779bc047b$var$performance$1.now();
} : function() {
    return Date.now();
};
var $e815fda779bc047b$var$raf = function() {
    if ($e815fda779bc047b$var$_window) {
        if ($e815fda779bc047b$var$_window.requestAnimationFrame) return function(fn) {
            $e815fda779bc047b$var$_window.requestAnimationFrame(fn);
        };
        else if ($e815fda779bc047b$var$_window.mozRequestAnimationFrame) return function(fn) {
            $e815fda779bc047b$var$_window.mozRequestAnimationFrame(fn);
        };
        else if ($e815fda779bc047b$var$_window.webkitRequestAnimationFrame) return function(fn) {
            $e815fda779bc047b$var$_window.webkitRequestAnimationFrame(fn);
        };
        else if ($e815fda779bc047b$var$_window.msRequestAnimationFrame) return function(fn) {
            $e815fda779bc047b$var$_window.msRequestAnimationFrame(fn);
        };
    }
    return function(fn) {
        if (fn) setTimeout(function() {
            fn($e815fda779bc047b$var$pnow());
        }, 1000 / 60);
    };
}();
var $e815fda779bc047b$var$requestAnimationFrame = function requestAnimationFrame(fn) {
    return $e815fda779bc047b$var$raf(fn);
};
var $e815fda779bc047b$var$performanceNow = $e815fda779bc047b$var$pnow;
var $e815fda779bc047b$var$DEFAULT_HASH_SEED = 9261;
var $e815fda779bc047b$var$K = 65599; // 37 also works pretty well
var $e815fda779bc047b$var$DEFAULT_HASH_SEED_ALT = 5381;
var $e815fda779bc047b$var$hashIterableInts = function hashIterableInts(iterator) {
    var seed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $e815fda779bc047b$var$DEFAULT_HASH_SEED;
    // sdbm/string-hash
    var hash = seed;
    var entry;
    for(;;){
        entry = iterator.next();
        if (entry.done) break;
        hash = hash * $e815fda779bc047b$var$K + entry.value | 0;
    }
    return hash;
};
var $e815fda779bc047b$var$hashInt = function hashInt(num) {
    var seed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $e815fda779bc047b$var$DEFAULT_HASH_SEED;
    // sdbm/string-hash
    return seed * $e815fda779bc047b$var$K + num | 0;
};
var $e815fda779bc047b$var$hashIntAlt = function hashIntAlt(num) {
    var seed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $e815fda779bc047b$var$DEFAULT_HASH_SEED_ALT;
    // djb2/string-hash
    return (seed << 5) + seed + num | 0;
};
var $e815fda779bc047b$var$combineHashes = function combineHashes(hash1, hash2) {
    return hash1 * 0x200000 + hash2;
};
var $e815fda779bc047b$var$combineHashesArray = function combineHashesArray(hashes) {
    return hashes[0] * 0x200000 + hashes[1];
};
var $e815fda779bc047b$var$hashArrays = function hashArrays(hashes1, hashes2) {
    return [
        $e815fda779bc047b$var$hashInt(hashes1[0], hashes2[0]),
        $e815fda779bc047b$var$hashIntAlt(hashes1[1], hashes2[1])
    ];
};
var $e815fda779bc047b$var$hashIntsArray = function hashIntsArray(ints, seed) {
    var entry = {
        value: 0,
        done: false
    };
    var i = 0;
    var length = ints.length;
    var iterator = {
        next: function next() {
            if (i < length) entry.value = ints[i++];
            else entry.done = true;
            return entry;
        }
    };
    return $e815fda779bc047b$var$hashIterableInts(iterator, seed);
};
var $e815fda779bc047b$var$hashString = function hashString(str, seed) {
    var entry = {
        value: 0,
        done: false
    };
    var i = 0;
    var length = str.length;
    var iterator = {
        next: function next() {
            if (i < length) entry.value = str.charCodeAt(i++);
            else entry.done = true;
            return entry;
        }
    };
    return $e815fda779bc047b$var$hashIterableInts(iterator, seed);
};
var $e815fda779bc047b$var$hashStrings = function hashStrings() {
    return $e815fda779bc047b$var$hashStringsArray(arguments);
};
var $e815fda779bc047b$var$hashStringsArray = function hashStringsArray(strs) {
    var hash;
    for(var i = 0; i < strs.length; i++){
        var str = strs[i];
        if (i === 0) hash = $e815fda779bc047b$var$hashString(str);
        else hash = $e815fda779bc047b$var$hashString(str, hash);
    }
    return hash;
};
function $e815fda779bc047b$var$rotatePoint(x, y, centerX, centerY, angleDegrees) {
    var angleRadians = angleDegrees * Math.PI / 180;
    var rotatedX = Math.cos(angleRadians) * (x - centerX) - Math.sin(angleRadians) * (y - centerY) + centerX;
    var rotatedY = Math.sin(angleRadians) * (x - centerX) + Math.cos(angleRadians) * (y - centerY) + centerY;
    return {
        x: rotatedX,
        y: rotatedY
    };
}
var $e815fda779bc047b$var$movePointByBoxAspect = function movePointByBoxAspect(x, y, boxX, boxY, skewX, skewY) {
    return {
        x: (x - boxX) * skewX + boxX,
        y: (y - boxY) * skewY + boxY
    };
};
function $e815fda779bc047b$var$rotatePosAndSkewByBox(pos, box, angleDegrees) {
    if (angleDegrees === 0) return pos;
    var centerX = (box.x1 + box.x2) / 2;
    var centerY = (box.y1 + box.y2) / 2;
    var skewX = box.w / box.h;
    var skewY = 1 / skewX;
    var rotated = $e815fda779bc047b$var$rotatePoint(pos.x, pos.y, centerX, centerY, angleDegrees);
    var skewed = $e815fda779bc047b$var$movePointByBoxAspect(rotated.x, rotated.y, centerX, centerY, skewX, skewY);
    return {
        x: skewed.x,
        y: skewed.y
    };
}
var $e815fda779bc047b$var$warningsEnabled = true;
var $e815fda779bc047b$var$warnSupported = console.warn != null;
var $e815fda779bc047b$var$traceSupported = console.trace != null;
var $e815fda779bc047b$var$MAX_INT$1 = Number.MAX_SAFE_INTEGER || 9007199254740991;
var $e815fda779bc047b$var$trueify = function trueify() {
    return true;
};
var $e815fda779bc047b$var$falsify = function falsify() {
    return false;
};
var $e815fda779bc047b$var$zeroify = function zeroify() {
    return 0;
};
var $e815fda779bc047b$var$noop$1 = function noop() {};
var $e815fda779bc047b$var$error = function error(msg) {
    throw new Error(msg);
};
var $e815fda779bc047b$var$warnings = function warnings(enabled) {
    if (enabled !== undefined) $e815fda779bc047b$var$warningsEnabled = !!enabled;
    else return $e815fda779bc047b$var$warningsEnabled;
};
var $e815fda779bc047b$var$warn = function warn(msg) {
    if (!$e815fda779bc047b$var$warnings()) return;
    if ($e815fda779bc047b$var$warnSupported) console.warn(msg);
    else {
        console.log(msg);
        if ($e815fda779bc047b$var$traceSupported) console.trace();
    }
};
var $e815fda779bc047b$var$clone = function clone(obj) {
    return $e815fda779bc047b$var$extend({}, obj);
};
// gets a shallow copy of the argument
var $e815fda779bc047b$var$copy = function copy(obj) {
    if (obj == null) return obj;
    if ($e815fda779bc047b$var$array(obj)) return obj.slice();
    else if ($e815fda779bc047b$var$plainObject(obj)) return $e815fda779bc047b$var$clone(obj);
    else return obj;
};
var $e815fda779bc047b$var$copyArray = function copyArray(arr) {
    return arr.slice();
};
var $e815fda779bc047b$var$uuid = function uuid(a, b /* placeholders */ ) {
    for(// loop :)
    b = a = ''; // b - result , a - numeric letiable
    a++ < 36; //
    b += a * 51 & 52 // if "a" is not 9 or 14 or 19 or 24
     ? //  return a random number or 4
    (a ^ 15 // if "a" is not 15
     ? // generate a random number from 0 to 15
    8 ^ Math.random() * (a ^ 20 ? 16 : 4 // unless "a" is 20, in which case a random number from 8 to 11
    ) : 4 //  otherwise 4
    ).toString(16) : '-' //  in other cases (if "a" is 9,14,19,24) insert "-"
    );
    return b;
};
var $e815fda779bc047b$var$_staticEmptyObject = {};
var $e815fda779bc047b$var$staticEmptyObject = function staticEmptyObject() {
    return $e815fda779bc047b$var$_staticEmptyObject;
};
var $e815fda779bc047b$var$defaults$g = function defaults(_defaults) {
    var keys = Object.keys(_defaults);
    return function(opts) {
        var filledOpts = {};
        for(var i = 0; i < keys.length; i++){
            var key = keys[i];
            var optVal = opts == null ? undefined : opts[key];
            filledOpts[key] = optVal === undefined ? _defaults[key] : optVal;
        }
        return filledOpts;
    };
};
var $e815fda779bc047b$var$removeFromArray = function removeFromArray(arr, ele, oneCopy) {
    for(var i = arr.length - 1; i >= 0; i--)if (arr[i] === ele) arr.splice(i, 1);
};
var $e815fda779bc047b$var$clearArray = function clearArray(arr) {
    arr.splice(0, arr.length);
};
var $e815fda779bc047b$var$push = function push(arr, otherArr) {
    for(var i = 0; i < otherArr.length; i++){
        var el = otherArr[i];
        arr.push(el);
    }
};
var $e815fda779bc047b$var$getPrefixedProperty = function getPrefixedProperty(obj, propName, prefix) {
    if (prefix) propName = $e815fda779bc047b$var$prependCamel(prefix, propName); // e.g. (labelWidth, source) => sourceLabelWidth
    return obj[propName];
};
var $e815fda779bc047b$var$setPrefixedProperty = function setPrefixedProperty(obj, propName, prefix, value) {
    if (prefix) propName = $e815fda779bc047b$var$prependCamel(prefix, propName); // e.g. (labelWidth, source) => sourceLabelWidth
    obj[propName] = value;
};
/* global Map */ var $e815fda779bc047b$var$ObjectMap = /*#__PURE__*/ function() {
    function ObjectMap() {
        $e815fda779bc047b$var$_classCallCheck(this, ObjectMap);
        this._obj = {};
    }
    return $e815fda779bc047b$var$_createClass(ObjectMap, [
        {
            key: "set",
            value: function set(key, val) {
                this._obj[key] = val;
                return this;
            }
        },
        {
            key: "delete",
            value: function _delete(key) {
                this._obj[key] = undefined;
                return this;
            }
        },
        {
            key: "clear",
            value: function clear() {
                this._obj = {};
            }
        },
        {
            key: "has",
            value: function has(key) {
                return this._obj[key] !== undefined;
            }
        },
        {
            key: "get",
            value: function get(key) {
                return this._obj[key];
            }
        }
    ]);
}();
var $e815fda779bc047b$var$Map$1 = typeof Map !== 'undefined' ? Map : $e815fda779bc047b$var$ObjectMap;
/* global Set */ var $e815fda779bc047b$var$undef = "undefined";
var $e815fda779bc047b$var$ObjectSet = /*#__PURE__*/ function() {
    function ObjectSet(arrayOrObjectSet) {
        $e815fda779bc047b$var$_classCallCheck(this, ObjectSet);
        this._obj = Object.create(null);
        this.size = 0;
        if (arrayOrObjectSet != null) {
            var arr;
            if (arrayOrObjectSet.instanceString != null && arrayOrObjectSet.instanceString() === this.instanceString()) arr = arrayOrObjectSet.toArray();
            else arr = arrayOrObjectSet;
            for(var i = 0; i < arr.length; i++)this.add(arr[i]);
        }
    }
    return $e815fda779bc047b$var$_createClass(ObjectSet, [
        {
            key: "instanceString",
            value: function instanceString() {
                return 'set';
            }
        },
        {
            key: "add",
            value: function add(val) {
                var o = this._obj;
                if (o[val] !== 1) {
                    o[val] = 1;
                    this.size++;
                }
            }
        },
        {
            key: "delete",
            value: function _delete(val) {
                var o = this._obj;
                if (o[val] === 1) {
                    o[val] = 0;
                    this.size--;
                }
            }
        },
        {
            key: "clear",
            value: function clear() {
                this._obj = Object.create(null);
            }
        },
        {
            key: "has",
            value: function has(val) {
                return this._obj[val] === 1;
            }
        },
        {
            key: "toArray",
            value: function toArray() {
                var _this = this;
                return Object.keys(this._obj).filter(function(key) {
                    return _this.has(key);
                });
            }
        },
        {
            key: "forEach",
            value: function forEach(callback, thisArg) {
                return this.toArray().forEach(callback, thisArg);
            }
        }
    ]);
}();
var $e815fda779bc047b$var$Set$1 = (typeof Set === "undefined" ? "undefined" : $e815fda779bc047b$var$_typeof(Set)) !== $e815fda779bc047b$var$undef ? Set : $e815fda779bc047b$var$ObjectSet;
// represents a node or an edge
var $e815fda779bc047b$var$Element = function Element(cy, params) {
    var restore = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    if (cy === undefined || params === undefined || !$e815fda779bc047b$var$core(cy)) {
        $e815fda779bc047b$var$error('An element must have a core reference and parameters set');
        return;
    }
    var group = params.group;
    // try to automatically infer the group if unspecified
    if (group == null) {
        if (params.data && params.data.source != null && params.data.target != null) group = 'edges';
        else group = 'nodes';
    }
    // validate group
    if (group !== 'nodes' && group !== 'edges') {
        $e815fda779bc047b$var$error('An element must be of type `nodes` or `edges`; you specified `' + group + '`');
        return;
    }
    // make the element array-like, just like a collection
    this.length = 1;
    this[0] = this;
    // NOTE: when something is added here, add also to ele.json()
    var _p = this._private = {
        cy: cy,
        single: true,
        // indicates this is an element
        data: params.data || {},
        // data object
        position: params.position || {
            x: 0,
            y: 0
        },
        // (x, y) position pair
        autoWidth: undefined,
        // width and height of nodes calculated by the renderer when set to special 'auto' value
        autoHeight: undefined,
        autoPadding: undefined,
        compoundBoundsClean: false,
        // whether the compound dimensions need to be recalculated the next time dimensions are read
        listeners: [],
        // array of bound listeners
        group: group,
        // string; 'nodes' or 'edges'
        style: {},
        // properties as set by the style
        rstyle: {},
        // properties for style sent from the renderer to the core
        styleCxts: [],
        // applied style contexts from the styler
        styleKeys: {},
        // per-group keys of style property values
        removed: true,
        // whether it's inside the vis; true if removed (set true here since we call restore)
        selected: params.selected ? true : false,
        // whether it's selected
        selectable: params.selectable === undefined ? true : params.selectable ? true : false,
        // whether it's selectable
        locked: params.locked ? true : false,
        // whether the element is locked (cannot be moved)
        grabbed: false,
        // whether the element is grabbed by the mouse; renderer sets this privately
        grabbable: params.grabbable === undefined ? true : params.grabbable ? true : false,
        // whether the element can be grabbed
        pannable: params.pannable === undefined ? group === 'edges' ? true : false : params.pannable ? true : false,
        // whether the element has passthrough panning enabled
        active: false,
        // whether the element is active from user interaction
        classes: new $e815fda779bc047b$var$Set$1(),
        // map ( className => true )
        animation: {
            // object for currently-running animations
            current: [],
            queue: []
        },
        rscratch: {},
        // object in which the renderer can store information
        scratch: params.scratch || {},
        // scratch objects
        edges: [],
        // array of connected edges
        children: [],
        // array of children
        parent: params.parent && params.parent.isNode() ? params.parent : null,
        // parent ref
        traversalCache: {},
        // cache of output of traversal functions
        backgrounding: false,
        // whether background images are loading
        bbCache: null,
        // cache of the current bounding box
        bbCacheShift: {
            x: 0,
            y: 0
        },
        // shift applied to cached bb to be applied on next get
        bodyBounds: null,
        // bounds cache of element body, w/o overlay
        overlayBounds: null,
        // bounds cache of element body, including overlay
        labelBounds: {
            // bounds cache of labels
            all: null,
            source: null,
            target: null,
            main: null
        },
        arrowBounds: {
            // bounds cache of edge arrows
            source: null,
            target: null,
            'mid-source': null,
            'mid-target': null
        }
    };
    if (_p.position.x == null) _p.position.x = 0;
    if (_p.position.y == null) _p.position.y = 0;
    // renderedPosition overrides if specified
    if (params.renderedPosition) {
        var rpos = params.renderedPosition;
        var pan = cy.pan();
        var zoom = cy.zoom();
        _p.position = {
            x: (rpos.x - pan.x) / zoom,
            y: (rpos.y - pan.y) / zoom
        };
    }
    var classes = [];
    if ($e815fda779bc047b$var$array(params.classes)) classes = params.classes;
    else if ($e815fda779bc047b$var$string(params.classes)) classes = params.classes.split(/\s+/);
    for(var i = 0, l = classes.length; i < l; i++){
        var cls = classes[i];
        if (!cls || cls === '') continue;
        _p.classes.add(cls);
    }
    this.createEmitter();
    if (restore === undefined || restore) this.restore();
    var bypass = params.style || params.css;
    if (bypass) {
        $e815fda779bc047b$var$warn('Setting a `style` bypass at element creation should be done only when absolutely necessary.  Try to use the stylesheet instead.');
        this.style(bypass);
    }
};
var $e815fda779bc047b$var$defineSearch = function defineSearch(params) {
    params = {
        bfs: params.bfs || !params.dfs,
        dfs: params.dfs || !params.bfs
    };
    // from pseudocode on wikipedia
    return function searchFn(roots, fn, directed) {
        var options;
        if ($e815fda779bc047b$var$plainObject(roots) && !$e815fda779bc047b$var$elementOrCollection(roots)) {
            options = roots;
            roots = options.roots || options.root;
            fn = options.visit;
            directed = options.directed;
        }
        directed = arguments.length === 2 && !$e815fda779bc047b$var$fn$6(fn) ? fn : directed;
        fn = $e815fda779bc047b$var$fn$6(fn) ? fn : function() {};
        var cy = this._private.cy;
        var v = roots = $e815fda779bc047b$var$string(roots) ? this.filter(roots) : roots;
        var Q = [];
        var connectedNodes = [];
        var connectedBy = {};
        var id2depth = {};
        var V = {};
        var j = 0;
        var found;
        var _this$byGroup = this.byGroup(), nodes = _this$byGroup.nodes, edges = _this$byGroup.edges;
        // enqueue v
        for(var i = 0; i < v.length; i++){
            var vi = v[i];
            var viId = vi.id();
            if (vi.isNode()) {
                Q.unshift(vi);
                if (params.bfs) {
                    V[viId] = true;
                    connectedNodes.push(vi);
                }
                id2depth[viId] = 0;
            }
        }
        var _loop = function _loop() {
            var v = params.bfs ? Q.shift() : Q.pop();
            var vId = v.id();
            if (params.dfs) {
                if (V[vId]) return 0; // continue
                V[vId] = true;
                connectedNodes.push(v);
            }
            var depth = id2depth[vId];
            var prevEdge = connectedBy[vId];
            var src = prevEdge != null ? prevEdge.source() : null;
            var tgt = prevEdge != null ? prevEdge.target() : null;
            var prevNode = prevEdge == null ? undefined : v.same(src) ? tgt[0] : src[0];
            var ret;
            ret = fn(v, prevEdge, prevNode, j++, depth);
            if (ret === true) {
                found = v;
                return 1; // break
            }
            if (ret === false) return 1; // break
            var vwEdges = v.connectedEdges().filter(function(e) {
                return (!directed || e.source().same(v)) && edges.has(e);
            });
            for(var _i2 = 0; _i2 < vwEdges.length; _i2++){
                var e = vwEdges[_i2];
                var w = e.connectedNodes().filter(function(n) {
                    return !n.same(v) && nodes.has(n);
                });
                var wId = w.id();
                if (w.length !== 0 && !V[wId]) {
                    w = w[0];
                    Q.push(w);
                    if (params.bfs) {
                        V[wId] = true;
                        connectedNodes.push(w);
                    }
                    connectedBy[wId] = e;
                    id2depth[wId] = id2depth[vId] + 1;
                }
            }
        }, _ret;
        while(Q.length !== 0){
            _ret = _loop();
            if (_ret === 0) continue;
            if (_ret === 1) break;
        }
        var connectedEles = cy.collection();
        for(var _i = 0; _i < connectedNodes.length; _i++){
            var node = connectedNodes[_i];
            var edge = connectedBy[node.id()];
            if (edge != null) connectedEles.push(edge);
            connectedEles.push(node);
        }
        return {
            path: cy.collection(connectedEles),
            found: cy.collection(found)
        };
    };
};
// search, spanning trees, etc
var $e815fda779bc047b$var$elesfn$v = {
    breadthFirstSearch: $e815fda779bc047b$var$defineSearch({
        bfs: true
    }),
    depthFirstSearch: $e815fda779bc047b$var$defineSearch({
        dfs: true
    })
};
// nice, short mathematical alias
$e815fda779bc047b$var$elesfn$v.bfs = $e815fda779bc047b$var$elesfn$v.breadthFirstSearch;
$e815fda779bc047b$var$elesfn$v.dfs = $e815fda779bc047b$var$elesfn$v.depthFirstSearch;
var $e815fda779bc047b$var$heap$2 = {
    exports: {}
};
var $e815fda779bc047b$var$heap$1 = $e815fda779bc047b$var$heap$2.exports;
var $e815fda779bc047b$var$hasRequiredHeap$1;
function $e815fda779bc047b$var$requireHeap$1() {
    if ($e815fda779bc047b$var$hasRequiredHeap$1) return $e815fda779bc047b$var$heap$2.exports;
    $e815fda779bc047b$var$hasRequiredHeap$1 = 1;
    (function(module, exports) {
        // Generated by CoffeeScript 1.8.0
        (function() {
            var Heap, defaultCmp, floor, heapify, heappop, heappush, heappushpop, heapreplace, insort, min, nlargest, nsmallest, updateItem, _siftdown, _siftup;
            floor = Math.floor, min = Math.min;
            /*
		  Default comparison function to be used
		   */ defaultCmp = function(x, y) {
                if (x < y) return -1;
                if (x > y) return 1;
                return 0;
            };
            /*
		  Insert item x in list a, and keep it sorted assuming a is sorted.
		  
		  If x is already in a, insert it to the right of the rightmost x.
		  
		  Optional args lo (default 0) and hi (default a.length) bound the slice
		  of a to be searched.
		   */ insort = function(a, x, lo, hi, cmp) {
                var mid;
                if (lo == null) lo = 0;
                if (cmp == null) cmp = defaultCmp;
                if (lo < 0) throw new Error('lo must be non-negative');
                if (hi == null) hi = a.length;
                while(lo < hi){
                    mid = floor((lo + hi) / 2);
                    if (cmp(x, a[mid]) < 0) hi = mid;
                    else lo = mid + 1;
                }
                return [].splice.apply(a, [
                    lo,
                    lo - lo
                ].concat(x)), x;
            };
            /*
		  Push item onto heap, maintaining the heap invariant.
		   */ heappush = function(array, item, cmp) {
                if (cmp == null) cmp = defaultCmp;
                array.push(item);
                return _siftdown(array, 0, array.length - 1, cmp);
            };
            /*
		  Pop the smallest item off the heap, maintaining the heap invariant.
		   */ heappop = function(array, cmp) {
                var lastelt, returnitem;
                if (cmp == null) cmp = defaultCmp;
                lastelt = array.pop();
                if (array.length) {
                    returnitem = array[0];
                    array[0] = lastelt;
                    _siftup(array, 0, cmp);
                } else returnitem = lastelt;
                return returnitem;
            };
            /*
		  Pop and return the current smallest value, and add the new item.
		  
		  This is more efficient than heappop() followed by heappush(), and can be
		  more appropriate when using a fixed size heap. Note that the value
		  returned may be larger than item! That constrains reasonable use of
		  this routine unless written as part of a conditional replacement:
		      if item > array[0]
		        item = heapreplace(array, item)
		   */ heapreplace = function(array, item, cmp) {
                var returnitem;
                if (cmp == null) cmp = defaultCmp;
                returnitem = array[0];
                array[0] = item;
                _siftup(array, 0, cmp);
                return returnitem;
            };
            /*
		  Fast version of a heappush followed by a heappop.
		   */ heappushpop = function(array, item, cmp) {
                var _ref;
                if (cmp == null) cmp = defaultCmp;
                if (array.length && cmp(array[0], item) < 0) {
                    _ref = [
                        array[0],
                        item
                    ], item = _ref[0], array[0] = _ref[1];
                    _siftup(array, 0, cmp);
                }
                return item;
            };
            /*
		  Transform list into a heap, in-place, in O(array.length) time.
		   */ heapify = function(array, cmp) {
                var i, _i, _len, _ref1, _results, _results1;
                if (cmp == null) cmp = defaultCmp;
                _ref1 = (function() {
                    _results1 = [];
                    for(var _j = 0, _ref = floor(array.length / 2); 0 <= _ref ? _j < _ref : _j > _ref; 0 <= _ref ? _j++ : _j--)_results1.push(_j);
                    return _results1;
                }).apply(this).reverse();
                _results = [];
                for(_i = 0, _len = _ref1.length; _i < _len; _i++){
                    i = _ref1[_i];
                    _results.push(_siftup(array, i, cmp));
                }
                return _results;
            };
            /*
		  Update the position of the given item in the heap.
		  This function should be called every time the item is being modified.
		   */ updateItem = function(array, item, cmp) {
                var pos;
                if (cmp == null) cmp = defaultCmp;
                pos = array.indexOf(item);
                if (pos === -1) return;
                _siftdown(array, 0, pos, cmp);
                return _siftup(array, pos, cmp);
            };
            /*
		  Find the n largest elements in a dataset.
		   */ nlargest = function(array, n, cmp) {
                var elem, result, _i, _len, _ref;
                if (cmp == null) cmp = defaultCmp;
                result = array.slice(0, n);
                if (!result.length) return result;
                heapify(result, cmp);
                _ref = array.slice(n);
                for(_i = 0, _len = _ref.length; _i < _len; _i++){
                    elem = _ref[_i];
                    heappushpop(result, elem, cmp);
                }
                return result.sort(cmp).reverse();
            };
            /*
		  Find the n smallest elements in a dataset.
		   */ nsmallest = function(array, n, cmp) {
                var elem, los, result, _i, _j, _len, _ref, _ref1, _results;
                if (cmp == null) cmp = defaultCmp;
                if (n * 10 <= array.length) {
                    result = array.slice(0, n).sort(cmp);
                    if (!result.length) return result;
                    los = result[result.length - 1];
                    _ref = array.slice(n);
                    for(_i = 0, _len = _ref.length; _i < _len; _i++){
                        elem = _ref[_i];
                        if (cmp(elem, los) < 0) {
                            insort(result, elem, 0, null, cmp);
                            result.pop();
                            los = result[result.length - 1];
                        }
                    }
                    return result;
                }
                heapify(array, cmp);
                _results = [];
                for(_j = 0, _ref1 = min(n, array.length); 0 <= _ref1 ? _j < _ref1 : _j > _ref1; 0 <= _ref1 ? ++_j : --_j)_results.push(heappop(array, cmp));
                return _results;
            };
            _siftdown = function(array, startpos, pos, cmp) {
                var newitem, parent, parentpos;
                if (cmp == null) cmp = defaultCmp;
                newitem = array[pos];
                while(pos > startpos){
                    parentpos = pos - 1 >> 1;
                    parent = array[parentpos];
                    if (cmp(newitem, parent) < 0) {
                        array[pos] = parent;
                        pos = parentpos;
                        continue;
                    }
                    break;
                }
                return array[pos] = newitem;
            };
            _siftup = function(array, pos, cmp) {
                var childpos, endpos, newitem, rightpos, startpos;
                if (cmp == null) cmp = defaultCmp;
                endpos = array.length;
                startpos = pos;
                newitem = array[pos];
                childpos = 2 * pos + 1;
                while(childpos < endpos){
                    rightpos = childpos + 1;
                    if (rightpos < endpos && !(cmp(array[childpos], array[rightpos]) < 0)) childpos = rightpos;
                    array[pos] = array[childpos];
                    pos = childpos;
                    childpos = 2 * pos + 1;
                }
                array[pos] = newitem;
                return _siftdown(array, startpos, pos, cmp);
            };
            Heap = function() {
                Heap.push = heappush;
                Heap.pop = heappop;
                Heap.replace = heapreplace;
                Heap.pushpop = heappushpop;
                Heap.heapify = heapify;
                Heap.updateItem = updateItem;
                Heap.nlargest = nlargest;
                Heap.nsmallest = nsmallest;
                function Heap(cmp) {
                    this.cmp = cmp != null ? cmp : defaultCmp;
                    this.nodes = [];
                }
                Heap.prototype.push = function(x) {
                    return heappush(this.nodes, x, this.cmp);
                };
                Heap.prototype.pop = function() {
                    return heappop(this.nodes, this.cmp);
                };
                Heap.prototype.peek = function() {
                    return this.nodes[0];
                };
                Heap.prototype.contains = function(x) {
                    return this.nodes.indexOf(x) !== -1;
                };
                Heap.prototype.replace = function(x) {
                    return heapreplace(this.nodes, x, this.cmp);
                };
                Heap.prototype.pushpop = function(x) {
                    return heappushpop(this.nodes, x, this.cmp);
                };
                Heap.prototype.heapify = function() {
                    return heapify(this.nodes, this.cmp);
                };
                Heap.prototype.updateItem = function(x) {
                    return updateItem(this.nodes, x, this.cmp);
                };
                Heap.prototype.clear = function() {
                    return this.nodes = [];
                };
                Heap.prototype.empty = function() {
                    return this.nodes.length === 0;
                };
                Heap.prototype.size = function() {
                    return this.nodes.length;
                };
                Heap.prototype.clone = function() {
                    var heap;
                    heap = new Heap();
                    heap.nodes = this.nodes.slice(0);
                    return heap;
                };
                Heap.prototype.toArray = function() {
                    return this.nodes.slice(0);
                };
                Heap.prototype.insert = Heap.prototype.push;
                Heap.prototype.top = Heap.prototype.peek;
                Heap.prototype.front = Heap.prototype.peek;
                Heap.prototype.has = Heap.prototype.contains;
                Heap.prototype.copy = Heap.prototype.clone;
                return Heap;
            }();
            (function(root, factory) {
                return module.exports = factory();
            })(this, function() {
                return Heap;
            });
        }).call($e815fda779bc047b$var$heap$1);
    })($e815fda779bc047b$var$heap$2);
    return $e815fda779bc047b$var$heap$2.exports;
}
var $e815fda779bc047b$var$heap;
var $e815fda779bc047b$var$hasRequiredHeap;
function $e815fda779bc047b$var$requireHeap() {
    if ($e815fda779bc047b$var$hasRequiredHeap) return $e815fda779bc047b$var$heap;
    $e815fda779bc047b$var$hasRequiredHeap = 1;
    $e815fda779bc047b$var$heap = $e815fda779bc047b$var$requireHeap$1();
    return $e815fda779bc047b$var$heap;
}
var $e815fda779bc047b$var$heapExports = $e815fda779bc047b$var$requireHeap();
var $e815fda779bc047b$var$Heap = /*@__PURE__*/ $e815fda779bc047b$var$getDefaultExportFromCjs($e815fda779bc047b$var$heapExports);
var $e815fda779bc047b$var$dijkstraDefaults = $e815fda779bc047b$var$defaults$g({
    root: null,
    weight: function weight(edge) {
        return 1;
    },
    directed: false
});
var $e815fda779bc047b$var$elesfn$u = {
    dijkstra: function dijkstra(options) {
        if (!$e815fda779bc047b$var$plainObject(options)) {
            var args = arguments;
            options = {
                root: args[0],
                weight: args[1],
                directed: args[2]
            };
        }
        var _dijkstraDefaults = $e815fda779bc047b$var$dijkstraDefaults(options), root = _dijkstraDefaults.root, weight = _dijkstraDefaults.weight, directed = _dijkstraDefaults.directed;
        var eles = this;
        var weightFn = weight;
        var source = $e815fda779bc047b$var$string(root) ? this.filter(root)[0] : root[0];
        var dist = {};
        var prev = {};
        var knownDist = {};
        var _this$byGroup = this.byGroup(), nodes = _this$byGroup.nodes, edges = _this$byGroup.edges;
        edges.unmergeBy(function(ele) {
            return ele.isLoop();
        });
        var getDist = function getDist(node) {
            return dist[node.id()];
        };
        var setDist = function setDist(node, d) {
            dist[node.id()] = d;
            Q.updateItem(node);
        };
        var Q = new $e815fda779bc047b$var$Heap(function(a, b) {
            return getDist(a) - getDist(b);
        });
        for(var i = 0; i < nodes.length; i++){
            var node = nodes[i];
            dist[node.id()] = node.same(source) ? 0 : Infinity;
            Q.push(node);
        }
        var distBetween = function distBetween(u, v) {
            var uvs = (directed ? u.edgesTo(v) : u.edgesWith(v)).intersect(edges);
            var smallestDistance = Infinity;
            var smallestEdge;
            for(var _i = 0; _i < uvs.length; _i++){
                var edge = uvs[_i];
                var _weight = weightFn(edge);
                if (_weight < smallestDistance || !smallestEdge) {
                    smallestDistance = _weight;
                    smallestEdge = edge;
                }
            }
            return {
                edge: smallestEdge,
                dist: smallestDistance
            };
        };
        while(Q.size() > 0){
            var u = Q.pop();
            var smalletsDist = getDist(u);
            var uid = u.id();
            knownDist[uid] = smalletsDist;
            if (smalletsDist === Infinity) continue;
            var neighbors = u.neighborhood().intersect(nodes);
            for(var _i2 = 0; _i2 < neighbors.length; _i2++){
                var v = neighbors[_i2];
                var vid = v.id();
                var vDist = distBetween(u, v);
                var alt = smalletsDist + vDist.dist;
                if (alt < getDist(v)) {
                    setDist(v, alt);
                    prev[vid] = {
                        node: u,
                        edge: vDist.edge
                    };
                }
            } // for
        } // while
        return {
            distanceTo: function distanceTo(node) {
                var target = $e815fda779bc047b$var$string(node) ? nodes.filter(node)[0] : node[0];
                return knownDist[target.id()];
            },
            pathTo: function pathTo(node) {
                var target = $e815fda779bc047b$var$string(node) ? nodes.filter(node)[0] : node[0];
                var S = [];
                var u = target;
                var uid = u.id();
                if (target.length > 0) {
                    S.unshift(target);
                    while(prev[uid]){
                        var p = prev[uid];
                        S.unshift(p.edge);
                        S.unshift(p.node);
                        u = p.node;
                        uid = u.id();
                    }
                }
                return eles.spawn(S);
            }
        };
    }
};
var $e815fda779bc047b$var$elesfn$t = {
    // kruskal's algorithm (finds min spanning tree, assuming undirected graph)
    // implemented from pseudocode from wikipedia
    kruskal: function kruskal(weightFn) {
        weightFn = weightFn || function(edge) {
            return 1;
        };
        var _this$byGroup = this.byGroup(), nodes = _this$byGroup.nodes, edges = _this$byGroup.edges;
        var numNodes = nodes.length;
        var forest = new Array(numNodes);
        var A = nodes; // assumes byGroup() creates new collections that can be safely mutated
        var findSetIndex = function findSetIndex(ele) {
            for(var i = 0; i < forest.length; i++){
                var eles = forest[i];
                if (eles.has(ele)) return i;
            }
        };
        // start with one forest per node
        for(var i = 0; i < numNodes; i++)forest[i] = this.spawn(nodes[i]);
        var S = edges.sort(function(a, b) {
            return weightFn(a) - weightFn(b);
        });
        for(var _i = 0; _i < S.length; _i++){
            var edge = S[_i];
            var u = edge.source()[0];
            var v = edge.target()[0];
            var setUIndex = findSetIndex(u);
            var setVIndex = findSetIndex(v);
            var setU = forest[setUIndex];
            var setV = forest[setVIndex];
            if (setUIndex !== setVIndex) {
                A.merge(edge);
                // combine forests for u and v
                setU.merge(setV);
                forest.splice(setVIndex, 1);
            }
        }
        return A;
    }
};
var $e815fda779bc047b$var$aStarDefaults = $e815fda779bc047b$var$defaults$g({
    root: null,
    goal: null,
    weight: function weight(edge) {
        return 1;
    },
    heuristic: function heuristic(edge) {
        return 0;
    },
    directed: false
});
var $e815fda779bc047b$var$elesfn$s = {
    // Implemented from pseudocode from wikipedia
    aStar: function aStar(options) {
        var cy = this.cy();
        var _aStarDefaults = $e815fda779bc047b$var$aStarDefaults(options), root = _aStarDefaults.root, goal = _aStarDefaults.goal, heuristic = _aStarDefaults.heuristic, directed = _aStarDefaults.directed, weight = _aStarDefaults.weight;
        root = cy.collection(root)[0];
        goal = cy.collection(goal)[0];
        var sid = root.id();
        var tid = goal.id();
        var gScore = {};
        var fScore = {};
        var closedSetIds = {};
        var openSet = new $e815fda779bc047b$var$Heap(function(a, b) {
            return fScore[a.id()] - fScore[b.id()];
        });
        var openSetIds = new $e815fda779bc047b$var$Set$1();
        var cameFrom = {};
        var cameFromEdge = {};
        var addToOpenSet = function addToOpenSet(ele, id) {
            openSet.push(ele);
            openSetIds.add(id);
        };
        var cMin, cMinId;
        var popFromOpenSet = function popFromOpenSet() {
            cMin = openSet.pop();
            cMinId = cMin.id();
            openSetIds["delete"](cMinId);
        };
        var isInOpenSet = function isInOpenSet(id) {
            return openSetIds.has(id);
        };
        addToOpenSet(root, sid);
        gScore[sid] = 0;
        fScore[sid] = heuristic(root);
        // Counter
        var steps = 0;
        // Main loop
        while(openSet.size() > 0){
            popFromOpenSet();
            steps++;
            // If we've found our goal, then we are done
            if (cMinId === tid) {
                var path = [];
                var pathNode = goal;
                var pathNodeId = tid;
                var pathEdge = cameFromEdge[pathNodeId];
                for(;;){
                    path.unshift(pathNode);
                    if (pathEdge != null) path.unshift(pathEdge);
                    pathNode = cameFrom[pathNodeId];
                    if (pathNode == null) break;
                    pathNodeId = pathNode.id();
                    pathEdge = cameFromEdge[pathNodeId];
                }
                return {
                    found: true,
                    distance: gScore[cMinId],
                    path: this.spawn(path),
                    steps: steps
                };
            }
            // Add cMin to processed nodes
            closedSetIds[cMinId] = true;
            // Update scores for neighbors of cMin
            // Take into account if graph is directed or not
            var vwEdges = cMin._private.edges;
            for(var i = 0; i < vwEdges.length; i++){
                var e = vwEdges[i];
                // edge must be in set of calling eles
                if (!this.hasElementWithId(e.id())) continue;
                // cMin must be the source of edge if directed
                if (directed && e.data('source') !== cMinId) continue;
                var wSrc = e.source();
                var wTgt = e.target();
                var w = wSrc.id() !== cMinId ? wSrc : wTgt;
                var wid = w.id();
                // node must be in set of calling eles
                if (!this.hasElementWithId(wid)) continue;
                // if node is in closedSet, ignore it
                if (closedSetIds[wid]) continue;
                // New tentative score for node w
                var tempScore = gScore[cMinId] + weight(e);
                // Update gScore for node w if:
                //   w not present in openSet
                // OR
                //   tentative gScore is less than previous value
                // w not in openSet
                if (!isInOpenSet(wid)) {
                    gScore[wid] = tempScore;
                    fScore[wid] = tempScore + heuristic(w);
                    addToOpenSet(w, wid);
                    cameFrom[wid] = cMin;
                    cameFromEdge[wid] = e;
                    continue;
                }
                // w already in openSet, but with greater gScore
                if (tempScore < gScore[wid]) {
                    gScore[wid] = tempScore;
                    fScore[wid] = tempScore + heuristic(w);
                    cameFrom[wid] = cMin;
                    cameFromEdge[wid] = e;
                }
            } // End of neighbors update
        } // End of main loop
        // If we've reached here, then we've not reached our goal
        return {
            found: false,
            distance: undefined,
            path: undefined,
            steps: steps
        };
    }
}; // elesfn
var $e815fda779bc047b$var$floydWarshallDefaults = $e815fda779bc047b$var$defaults$g({
    weight: function weight(edge) {
        return 1;
    },
    directed: false
});
var $e815fda779bc047b$var$elesfn$r = {
    // Implemented from pseudocode from wikipedia
    floydWarshall: function floydWarshall(options) {
        var cy = this.cy();
        var _floydWarshallDefault = $e815fda779bc047b$var$floydWarshallDefaults(options), weight = _floydWarshallDefault.weight, directed = _floydWarshallDefault.directed;
        var weightFn = weight;
        var _this$byGroup = this.byGroup(), nodes = _this$byGroup.nodes, edges = _this$byGroup.edges;
        var N = nodes.length;
        var Nsq = N * N;
        var indexOf = function indexOf(node) {
            return nodes.indexOf(node);
        };
        var atIndex = function atIndex(i) {
            return nodes[i];
        };
        // Initialize distance matrix
        var dist = new Array(Nsq);
        for(var n = 0; n < Nsq; n++){
            var j = n % N;
            var i = (n - j) / N;
            if (i === j) dist[n] = 0;
            else dist[n] = Infinity;
        }
        // Initialize matrix used for path reconstruction
        // Initialize distance matrix
        var next = new Array(Nsq);
        var edgeNext = new Array(Nsq);
        // Process edges
        for(var _i = 0; _i < edges.length; _i++){
            var edge = edges[_i];
            var src = edge.source()[0];
            var tgt = edge.target()[0];
            if (src === tgt) continue;
             // exclude loops
            var s = indexOf(src);
            var t = indexOf(tgt);
            var st = s * N + t; // source to target index
            var _weight = weightFn(edge);
            // Check if already process another edge between same 2 nodes
            if (dist[st] > _weight) {
                dist[st] = _weight;
                next[st] = t;
                edgeNext[st] = edge;
            }
            // If undirected graph, process 'reversed' edge
            if (!directed) {
                var ts = t * N + s; // target to source index
                if (!directed && dist[ts] > _weight) {
                    dist[ts] = _weight;
                    next[ts] = s;
                    edgeNext[ts] = edge;
                }
            }
        }
        // Main loop
        for(var k = 0; k < N; k++)for(var _i2 = 0; _i2 < N; _i2++){
            var ik = _i2 * N + k;
            for(var _j = 0; _j < N; _j++){
                var ij = _i2 * N + _j;
                var kj = k * N + _j;
                if (dist[ik] + dist[kj] < dist[ij]) {
                    dist[ij] = dist[ik] + dist[kj];
                    next[ij] = next[ik];
                }
            }
        }
        var getArgEle = function getArgEle(ele) {
            return ($e815fda779bc047b$var$string(ele) ? cy.filter(ele) : ele)[0];
        };
        var indexOfArgEle = function indexOfArgEle(ele) {
            return indexOf(getArgEle(ele));
        };
        var res = {
            distance: function distance(from, to) {
                var i = indexOfArgEle(from);
                var j = indexOfArgEle(to);
                return dist[i * N + j];
            },
            path: function path(from, to) {
                var i = indexOfArgEle(from);
                var j = indexOfArgEle(to);
                var fromNode = atIndex(i);
                if (i === j) return fromNode.collection();
                if (next[i * N + j] == null) return cy.collection();
                var path = cy.collection();
                var prev = i;
                var edge;
                path.merge(fromNode);
                while(i !== j){
                    prev = i;
                    i = next[i * N + j];
                    edge = edgeNext[prev * N + i];
                    path.merge(edge);
                    path.merge(atIndex(i));
                }
                return path;
            }
        };
        return res;
    } // floydWarshall
}; // elesfn
var $e815fda779bc047b$var$bellmanFordDefaults = $e815fda779bc047b$var$defaults$g({
    weight: function weight(edge) {
        return 1;
    },
    directed: false,
    root: null
});
var $e815fda779bc047b$var$elesfn$q = {
    // Implemented from pseudocode from wikipedia
    bellmanFord: function bellmanFord(options) {
        var _this = this;
        var _bellmanFordDefaults = $e815fda779bc047b$var$bellmanFordDefaults(options), weight = _bellmanFordDefaults.weight, directed = _bellmanFordDefaults.directed, root = _bellmanFordDefaults.root;
        var weightFn = weight;
        var eles = this;
        var cy = this.cy();
        var _this$byGroup = this.byGroup(), edges = _this$byGroup.edges, nodes = _this$byGroup.nodes;
        var numNodes = nodes.length;
        var infoMap = new $e815fda779bc047b$var$Map$1();
        var hasNegativeWeightCycle = false;
        var negativeWeightCycles = [];
        root = cy.collection(root)[0]; // in case selector passed
        edges.unmergeBy(function(edge) {
            return edge.isLoop();
        });
        var numEdges = edges.length;
        var getInfo = function getInfo(node) {
            var obj = infoMap.get(node.id());
            if (!obj) {
                obj = {};
                infoMap.set(node.id(), obj);
            }
            return obj;
        };
        var getNodeFromTo = function getNodeFromTo(to) {
            return ($e815fda779bc047b$var$string(to) ? cy.$(to) : to)[0];
        };
        var distanceTo = function distanceTo(to) {
            return getInfo(getNodeFromTo(to)).dist;
        };
        var pathTo = function pathTo(to) {
            var thisStart = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : root;
            var end = getNodeFromTo(to);
            var path = [];
            var node = end;
            for(;;){
                if (node == null) return _this.spawn();
                var _getInfo = getInfo(node), edge = _getInfo.edge, pred = _getInfo.pred;
                path.unshift(node[0]);
                if (node.same(thisStart) && path.length > 0) break;
                if (edge != null) path.unshift(edge);
                node = pred;
            }
            return eles.spawn(path);
        };
        // Initializations { dist, pred, edge }
        for(var i = 0; i < numNodes; i++){
            var node = nodes[i];
            var info = getInfo(node);
            if (node.same(root)) info.dist = 0;
            else info.dist = Infinity;
            info.pred = null;
            info.edge = null;
        }
        // Edges relaxation
        var replacedEdge = false;
        var checkForEdgeReplacement = function checkForEdgeReplacement(node1, node2, edge, info1, info2, weight) {
            var dist = info1.dist + weight;
            if (dist < info2.dist && !edge.same(info1.edge)) {
                info2.dist = dist;
                info2.pred = node1;
                info2.edge = edge;
                replacedEdge = true;
            }
        };
        for(var _i = 1; _i < numNodes; _i++){
            replacedEdge = false;
            for(var e = 0; e < numEdges; e++){
                var edge = edges[e];
                var src = edge.source();
                var tgt = edge.target();
                var _weight = weightFn(edge);
                var srcInfo = getInfo(src);
                var tgtInfo = getInfo(tgt);
                checkForEdgeReplacement(src, tgt, edge, srcInfo, tgtInfo, _weight);
                // If undirected graph, we need to take into account the 'reverse' edge
                if (!directed) checkForEdgeReplacement(tgt, src, edge, tgtInfo, srcInfo, _weight);
            }
            if (!replacedEdge) break;
        }
        if (replacedEdge) {
            // Check for negative weight cycles
            var negativeWeightCycleIds = [];
            for(var _e = 0; _e < numEdges; _e++){
                var _edge = edges[_e];
                var _src = _edge.source();
                var _tgt = _edge.target();
                var _weight2 = weightFn(_edge);
                var srcDist = getInfo(_src).dist;
                var tgtDist = getInfo(_tgt).dist;
                if (srcDist + _weight2 < tgtDist || !directed && tgtDist + _weight2 < srcDist) {
                    if (!hasNegativeWeightCycle) {
                        $e815fda779bc047b$var$warn('Graph contains a negative weight cycle for Bellman-Ford');
                        hasNegativeWeightCycle = true;
                    }
                    if (options.findNegativeWeightCycles !== false) {
                        var negativeNodes = [];
                        if (srcDist + _weight2 < tgtDist) negativeNodes.push(_src);
                        if (!directed && tgtDist + _weight2 < srcDist) negativeNodes.push(_tgt);
                        var numNegativeNodes = negativeNodes.length;
                        for(var n = 0; n < numNegativeNodes; n++){
                            var start = negativeNodes[n];
                            var cycle = [
                                start
                            ];
                            cycle.push(getInfo(start).edge);
                            var _node = getInfo(start).pred;
                            while(cycle.indexOf(_node) === -1){
                                cycle.push(_node);
                                cycle.push(getInfo(_node).edge);
                                _node = getInfo(_node).pred;
                            }
                            cycle = cycle.slice(cycle.indexOf(_node));
                            var smallestId = cycle[0].id();
                            var smallestIndex = 0;
                            for(var c = 2; c < cycle.length; c += 2)if (cycle[c].id() < smallestId) {
                                smallestId = cycle[c].id();
                                smallestIndex = c;
                            }
                            cycle = cycle.slice(smallestIndex).concat(cycle.slice(0, smallestIndex));
                            cycle.push(cycle[0]);
                            var cycleId = cycle.map(function(el) {
                                return el.id();
                            }).join(",");
                            if (negativeWeightCycleIds.indexOf(cycleId) === -1) {
                                negativeWeightCycles.push(eles.spawn(cycle));
                                negativeWeightCycleIds.push(cycleId);
                            }
                        }
                    } else break;
                }
            }
        }
        return {
            distanceTo: distanceTo,
            pathTo: pathTo,
            hasNegativeWeightCycle: hasNegativeWeightCycle,
            negativeWeightCycles: negativeWeightCycles
        };
    } // bellmanFord
}; // elesfn
var $e815fda779bc047b$var$sqrt2 = Math.sqrt(2);
// Function which colapses 2 (meta) nodes into one
// Updates the remaining edge lists
// Receives as a paramater the edge which causes the collapse
var $e815fda779bc047b$var$collapse = function collapse(edgeIndex, nodeMap, remainingEdges) {
    if (remainingEdges.length === 0) $e815fda779bc047b$var$error("Karger-Stein must be run on a connected (sub)graph");
    var edgeInfo = remainingEdges[edgeIndex];
    var sourceIn = edgeInfo[1];
    var targetIn = edgeInfo[2];
    var partition1 = nodeMap[sourceIn];
    var partition2 = nodeMap[targetIn];
    var newEdges = remainingEdges; // re-use array
    // Delete all edges between partition1 and partition2
    for(var i = newEdges.length - 1; i >= 0; i--){
        var edge = newEdges[i];
        var src = edge[1];
        var tgt = edge[2];
        if (nodeMap[src] === partition1 && nodeMap[tgt] === partition2 || nodeMap[src] === partition2 && nodeMap[tgt] === partition1) newEdges.splice(i, 1);
    }
    // All edges pointing to partition2 should now point to partition1
    for(var _i = 0; _i < newEdges.length; _i++){
        var _edge = newEdges[_i];
        if (_edge[1] === partition2) {
            // Check source
            newEdges[_i] = _edge.slice(); // copy
            newEdges[_i][1] = partition1;
        } else if (_edge[2] === partition2) {
            // Check target
            newEdges[_i] = _edge.slice(); // copy
            newEdges[_i][2] = partition1;
        }
    }
    // Move all nodes from partition2 to partition1
    for(var _i2 = 0; _i2 < nodeMap.length; _i2++)if (nodeMap[_i2] === partition2) nodeMap[_i2] = partition1;
    return newEdges;
};
// Contracts a graph until we reach a certain number of meta nodes
var $e815fda779bc047b$var$contractUntil = function contractUntil(metaNodeMap, remainingEdges, size, sizeLimit) {
    while(size > sizeLimit){
        // Choose an edge randomly
        var edgeIndex = Math.floor(Math.random() * remainingEdges.length);
        // Collapse graph based on edge
        remainingEdges = $e815fda779bc047b$var$collapse(edgeIndex, metaNodeMap, remainingEdges);
        size--;
    }
    return remainingEdges;
};
var $e815fda779bc047b$var$elesfn$p = {
    // Computes the minimum cut of an undirected graph
    // Returns the correct answer with high probability
    kargerStein: function kargerStein() {
        var _this = this;
        var _this$byGroup = this.byGroup(), nodes = _this$byGroup.nodes, edges = _this$byGroup.edges;
        edges.unmergeBy(function(edge) {
            return edge.isLoop();
        });
        var numNodes = nodes.length;
        var numEdges = edges.length;
        var numIter = Math.ceil(Math.pow(Math.log(numNodes) / Math.LN2, 2));
        var stopSize = Math.floor(numNodes / $e815fda779bc047b$var$sqrt2);
        if (numNodes < 2) {
            $e815fda779bc047b$var$error('At least 2 nodes are required for Karger-Stein algorithm');
            return undefined;
        }
        // Now store edge destination as indexes
        // Format for each edge (edge index, source node index, target node index)
        var edgeIndexes = [];
        for(var i = 0; i < numEdges; i++){
            var e = edges[i];
            edgeIndexes.push([
                i,
                nodes.indexOf(e.source()),
                nodes.indexOf(e.target())
            ]);
        }
        // We will store the best cut found here
        var minCutSize = Infinity;
        var minCutEdgeIndexes = [];
        var minCutNodeMap = new Array(numNodes);
        // Initial meta node partition
        var metaNodeMap = new Array(numNodes);
        var metaNodeMap2 = new Array(numNodes);
        var copyNodesMap = function copyNodesMap(from, to) {
            for(var _i3 = 0; _i3 < numNodes; _i3++)to[_i3] = from[_i3];
        };
        // Main loop
        for(var iter = 0; iter <= numIter; iter++){
            // Reset meta node partition
            for(var _i4 = 0; _i4 < numNodes; _i4++)metaNodeMap[_i4] = _i4;
            // Contract until stop point (stopSize nodes)
            var edgesState = $e815fda779bc047b$var$contractUntil(metaNodeMap, edgeIndexes.slice(), numNodes, stopSize);
            var edgesState2 = edgesState.slice(); // copy
            // Create a copy of the colapsed nodes state
            copyNodesMap(metaNodeMap, metaNodeMap2);
            // Run 2 iterations starting in the stop state
            var res1 = $e815fda779bc047b$var$contractUntil(metaNodeMap, edgesState, stopSize, 2);
            var res2 = $e815fda779bc047b$var$contractUntil(metaNodeMap2, edgesState2, stopSize, 2);
            // Is any of the 2 results the best cut so far?
            if (res1.length <= res2.length && res1.length < minCutSize) {
                minCutSize = res1.length;
                minCutEdgeIndexes = res1;
                copyNodesMap(metaNodeMap, minCutNodeMap);
            } else if (res2.length <= res1.length && res2.length < minCutSize) {
                minCutSize = res2.length;
                minCutEdgeIndexes = res2;
                copyNodesMap(metaNodeMap2, minCutNodeMap);
            }
        } // end of main loop
        // Construct result
        var cut = this.spawn(minCutEdgeIndexes.map(function(e) {
            return edges[e[0]];
        }));
        var partition1 = this.spawn();
        var partition2 = this.spawn();
        // traverse metaNodeMap for best cut
        var witnessNodePartition = minCutNodeMap[0];
        for(var _i5 = 0; _i5 < minCutNodeMap.length; _i5++){
            var partitionId = minCutNodeMap[_i5];
            var node = nodes[_i5];
            if (partitionId === witnessNodePartition) partition1.merge(node);
            else partition2.merge(node);
        }
        // construct components corresponding to each disjoint subset of nodes
        var constructComponent = function constructComponent(subset) {
            var component = _this.spawn();
            subset.forEach(function(node) {
                component.merge(node);
                node.connectedEdges().forEach(function(edge) {
                    // ensure edge is within calling collection and edge is not in cut
                    if (_this.contains(edge) && !cut.contains(edge)) component.merge(edge);
                });
            });
            return component;
        };
        var components = [
            constructComponent(partition1),
            constructComponent(partition2)
        ];
        var ret = {
            cut: cut,
            components: components,
            // n.b. partitions are included to be compatible with the old api spec
            // (could be removed in a future major version)
            partition1: partition1,
            partition2: partition2
        };
        return ret;
    }
}; // elesfn
var $e815fda779bc047b$var$_Math$hypot;
var $e815fda779bc047b$var$copyPosition = function copyPosition(p) {
    return {
        x: p.x,
        y: p.y
    };
};
var $e815fda779bc047b$var$modelToRenderedPosition$1 = function modelToRenderedPosition(p, zoom, pan) {
    return {
        x: p.x * zoom + pan.x,
        y: p.y * zoom + pan.y
    };
};
var $e815fda779bc047b$var$renderedToModelPosition = function renderedToModelPosition(p, zoom, pan) {
    return {
        x: (p.x - pan.x) / zoom,
        y: (p.y - pan.y) / zoom
    };
};
var $e815fda779bc047b$var$array2point = function array2point(arr) {
    return {
        x: arr[0],
        y: arr[1]
    };
};
var $e815fda779bc047b$var$min = function min(arr) {
    var begin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var end = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : arr.length;
    var min = Infinity;
    for(var i = begin; i < end; i++){
        var val = arr[i];
        if (isFinite(val)) min = Math.min(val, min);
    }
    return min;
};
var $e815fda779bc047b$var$max = function max(arr) {
    var begin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var end = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : arr.length;
    var max = -Infinity;
    for(var i = begin; i < end; i++){
        var val = arr[i];
        if (isFinite(val)) max = Math.max(val, max);
    }
    return max;
};
var $e815fda779bc047b$var$mean = function mean(arr) {
    var begin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var end = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : arr.length;
    var total = 0;
    var n = 0;
    for(var i = begin; i < end; i++){
        var val = arr[i];
        if (isFinite(val)) {
            total += val;
            n++;
        }
    }
    return total / n;
};
var $e815fda779bc047b$var$median = function median(arr) {
    var begin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var end = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : arr.length;
    var copy = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
    var sort = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
    var includeHoles = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : true;
    if (copy) arr = arr.slice(begin, end);
    else {
        if (end < arr.length) arr.splice(end, arr.length - end);
        if (begin > 0) arr.splice(0, begin);
    }
    // all non finite (e.g. Infinity, NaN) elements must be -Infinity so they go to the start
    var off = 0; // offset from non-finite values
    for(var i = arr.length - 1; i >= 0; i--){
        var v = arr[i];
        if (includeHoles) {
            if (!isFinite(v)) {
                arr[i] = -Infinity;
                off++;
            }
        } else // just remove it if we don't want to consider holes
        arr.splice(i, 1);
    }
    if (sort) arr.sort(function(a, b) {
        return a - b;
    }); // requires copy = true if you don't want to change the orig
    var len = arr.length;
    var mid = Math.floor(len / 2);
    if (len % 2 !== 0) return arr[mid + 1 + off];
    else return (arr[mid - 1 + off] + arr[mid + off]) / 2;
};
var $e815fda779bc047b$var$deg2rad = function deg2rad(deg) {
    return Math.PI * deg / 180;
};
var $e815fda779bc047b$var$getAngleFromDisp = function getAngleFromDisp(dispX, dispY) {
    return Math.atan2(dispY, dispX) - Math.PI / 2;
};
var $e815fda779bc047b$var$log2 = Math.log2 || function(n) {
    return Math.log(n) / Math.log(2);
};
var $e815fda779bc047b$var$signum = function signum(x) {
    if (x > 0) return 1;
    else if (x < 0) return -1;
    else return 0;
};
var $e815fda779bc047b$var$dist = function dist(p1, p2) {
    return Math.sqrt($e815fda779bc047b$var$sqdist(p1, p2));
};
var $e815fda779bc047b$var$sqdist = function sqdist(p1, p2) {
    var dx = p2.x - p1.x;
    var dy = p2.y - p1.y;
    return dx * dx + dy * dy;
};
var $e815fda779bc047b$var$inPlaceSumNormalize = function inPlaceSumNormalize(v) {
    var length = v.length;
    // First, get sum of all elements
    var total = 0;
    for(var i = 0; i < length; i++)total += v[i];
    // Now, divide each by the sum of all elements
    for(var _i = 0; _i < length; _i++)v[_i] = v[_i] / total;
    return v;
};
// from http://en.wikipedia.org/wiki/Bézier_curve#Quadratic_curves
var $e815fda779bc047b$var$qbezierAt = function qbezierAt(p0, p1, p2, t) {
    return (1 - t) * (1 - t) * p0 + 2 * (1 - t) * t * p1 + t * t * p2;
};
var $e815fda779bc047b$var$qbezierPtAt = function qbezierPtAt(p0, p1, p2, t) {
    return {
        x: $e815fda779bc047b$var$qbezierAt(p0.x, p1.x, p2.x, t),
        y: $e815fda779bc047b$var$qbezierAt(p0.y, p1.y, p2.y, t)
    };
};
var $e815fda779bc047b$var$lineAt = function lineAt(p0, p1, t, d) {
    var vec = {
        x: p1.x - p0.x,
        y: p1.y - p0.y
    };
    var vecDist = $e815fda779bc047b$var$dist(p0, p1);
    var normVec = {
        x: vec.x / vecDist,
        y: vec.y / vecDist
    };
    t = t == null ? 0 : t;
    d = d != null ? d : t * vecDist;
    return {
        x: p0.x + normVec.x * d,
        y: p0.y + normVec.y * d
    };
};
var $e815fda779bc047b$var$bound = function bound(min, val, max) {
    return Math.max(min, Math.min(max, val));
};
// makes a full bb (x1, y1, x2, y2, w, h) from implicit params
var $e815fda779bc047b$var$makeBoundingBox = function makeBoundingBox(bb) {
    if (bb == null) return {
        x1: Infinity,
        y1: Infinity,
        x2: -Infinity,
        y2: -Infinity,
        w: 0,
        h: 0
    };
    else if (bb.x1 != null && bb.y1 != null) {
        if (bb.x2 != null && bb.y2 != null && bb.x2 >= bb.x1 && bb.y2 >= bb.y1) return {
            x1: bb.x1,
            y1: bb.y1,
            x2: bb.x2,
            y2: bb.y2,
            w: bb.x2 - bb.x1,
            h: bb.y2 - bb.y1
        };
        else if (bb.w != null && bb.h != null && bb.w >= 0 && bb.h >= 0) return {
            x1: bb.x1,
            y1: bb.y1,
            x2: bb.x1 + bb.w,
            y2: bb.y1 + bb.h,
            w: bb.w,
            h: bb.h
        };
    }
};
var $e815fda779bc047b$var$copyBoundingBox = function copyBoundingBox(bb) {
    return {
        x1: bb.x1,
        x2: bb.x2,
        w: bb.w,
        y1: bb.y1,
        y2: bb.y2,
        h: bb.h
    };
};
var $e815fda779bc047b$var$clearBoundingBox = function clearBoundingBox(bb) {
    bb.x1 = Infinity;
    bb.y1 = Infinity;
    bb.x2 = -Infinity;
    bb.y2 = -Infinity;
    bb.w = 0;
    bb.h = 0;
};
var $e815fda779bc047b$var$updateBoundingBox = function updateBoundingBox(bb1, bb2) {
    // update bb1 with bb2 bounds
    bb1.x1 = Math.min(bb1.x1, bb2.x1);
    bb1.x2 = Math.max(bb1.x2, bb2.x2);
    bb1.w = bb1.x2 - bb1.x1;
    bb1.y1 = Math.min(bb1.y1, bb2.y1);
    bb1.y2 = Math.max(bb1.y2, bb2.y2);
    bb1.h = bb1.y2 - bb1.y1;
};
var $e815fda779bc047b$var$expandBoundingBoxByPoint = function expandBoundingBoxByPoint(bb, x, y) {
    bb.x1 = Math.min(bb.x1, x);
    bb.x2 = Math.max(bb.x2, x);
    bb.w = bb.x2 - bb.x1;
    bb.y1 = Math.min(bb.y1, y);
    bb.y2 = Math.max(bb.y2, y);
    bb.h = bb.y2 - bb.y1;
};
var $e815fda779bc047b$var$expandBoundingBox = function expandBoundingBox(bb) {
    var padding = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    bb.x1 -= padding;
    bb.x2 += padding;
    bb.y1 -= padding;
    bb.y2 += padding;
    bb.w = bb.x2 - bb.x1;
    bb.h = bb.y2 - bb.y1;
    return bb;
};
var $e815fda779bc047b$var$expandBoundingBoxSides = function expandBoundingBoxSides(bb) {
    var padding = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [
        0
    ];
    var top, right, bottom, left;
    if (padding.length === 1) top = right = bottom = left = padding[0];
    else if (padding.length === 2) {
        top = bottom = padding[0];
        left = right = padding[1];
    } else if (padding.length === 4) {
        var _padding = $e815fda779bc047b$var$_slicedToArray(padding, 4);
        top = _padding[0];
        right = _padding[1];
        bottom = _padding[2];
        left = _padding[3];
    }
    bb.x1 -= left;
    bb.x2 += right;
    bb.y1 -= top;
    bb.y2 += bottom;
    bb.w = bb.x2 - bb.x1;
    bb.h = bb.y2 - bb.y1;
    return bb;
};
// assign the values of bb2 into bb1
var $e815fda779bc047b$var$assignBoundingBox = function assignBoundingBox(bb1, bb2) {
    bb1.x1 = bb2.x1;
    bb1.y1 = bb2.y1;
    bb1.x2 = bb2.x2;
    bb1.y2 = bb2.y2;
    bb1.w = bb1.x2 - bb1.x1;
    bb1.h = bb1.y2 - bb1.y1;
};
var $e815fda779bc047b$var$boundingBoxesIntersect = function boundingBoxesIntersect(bb1, bb2) {
    // case: one bb to right of other
    if (bb1.x1 > bb2.x2) return false;
    if (bb2.x1 > bb1.x2) return false;
    // case: one bb to left of other
    if (bb1.x2 < bb2.x1) return false;
    if (bb2.x2 < bb1.x1) return false;
    // case: one bb above other
    if (bb1.y2 < bb2.y1) return false;
    if (bb2.y2 < bb1.y1) return false;
    // case: one bb below other
    if (bb1.y1 > bb2.y2) return false;
    if (bb2.y1 > bb1.y2) return false;
    // otherwise, must have some overlap
    return true;
};
var $e815fda779bc047b$var$inBoundingBox = function inBoundingBox(bb, x, y) {
    return bb.x1 <= x && x <= bb.x2 && bb.y1 <= y && y <= bb.y2;
};
var $e815fda779bc047b$var$pointInBoundingBox = function pointInBoundingBox(bb, pt) {
    return $e815fda779bc047b$var$inBoundingBox(bb, pt.x, pt.y);
};
var $e815fda779bc047b$var$boundingBoxInBoundingBox = function boundingBoxInBoundingBox(bb1, bb2) {
    return $e815fda779bc047b$var$inBoundingBox(bb1, bb2.x1, bb2.y1) && $e815fda779bc047b$var$inBoundingBox(bb1, bb2.x2, bb2.y2);
};
var $e815fda779bc047b$var$hypot = ($e815fda779bc047b$var$_Math$hypot = Math.hypot) !== null && $e815fda779bc047b$var$_Math$hypot !== undefined ? $e815fda779bc047b$var$_Math$hypot : function(x, y) {
    return Math.sqrt(x * x + y * y);
};
function $e815fda779bc047b$var$inflatePolygon(polygon, d) {
    if (polygon.length < 3) throw new Error('Need at least 3 vertices');
    // Helpers
    var add = function add(a, b) {
        return {
            x: a.x + b.x,
            y: a.y + b.y
        };
    };
    var sub = function sub(a, b) {
        return {
            x: a.x - b.x,
            y: a.y - b.y
        };
    };
    var scale = function scale(v, s) {
        return {
            x: v.x * s,
            y: v.y * s
        };
    };
    var cross = function cross(u, v) {
        return u.x * v.y - u.y * v.x;
    };
    var normalize = function normalize(v) {
        var len = $e815fda779bc047b$var$hypot(v.x, v.y);
        return len === 0 ? {
            x: 0,
            y: 0
        } : {
            x: v.x / len,
            y: v.y / len
        };
    };
    // Signed area (positive = CCW)
    var signedArea = function signedArea(pts) {
        var A = 0;
        for(var i = 0; i < pts.length; i++){
            var p = pts[i], q = pts[(i + 1) % pts.length];
            A += p.x * q.y - q.x * p.y;
        }
        return A / 2;
    };
    // Line–line intersection (infinite lines)
    var intersectLines = function intersectLines(p1, p2, p3, p4) {
        var r = sub(p2, p1);
        var s = sub(p4, p3);
        var denom = cross(r, s);
        if (Math.abs(denom) < 1e-9) // Parallel or nearly so — fallback to midpoint
        return add(p1, scale(r, 0.5));
        var t = cross(sub(p3, p1), s) / denom;
        return add(p1, scale(r, t));
    };
    // Make a shallow copy and enforce CCW
    var pts = polygon.map(function(p) {
        return {
            x: p.x,
            y: p.y
        };
    });
    if (signedArea(pts) < 0) pts.reverse();
    var n = pts.length;
    // Compute outward normals for each edge
    var normals = [];
    for(var i = 0; i < n; i++){
        var p = pts[i], q = pts[(i + 1) % n];
        var edge = sub(q, p);
        // For CCW polygon, inward normal = (-edge.y, edge.x)
        // so outward normal = (edge.y, -edge.x)
        var out = normalize({
            x: edge.y,
            y: -edge.x
        });
        normals.push(out);
    }
    // Build offset edges
    var offsetEdges = normals.map(function(nrm, i) {
        var p1 = add(pts[i], scale(nrm, d));
        var p2 = add(pts[(i + 1) % n], scale(nrm, d));
        return {
            p1: p1,
            p2: p2
        };
    });
    // Intersect consecutive offset edges
    var inflated = [];
    for(var _i2 = 0; _i2 < n; _i2++){
        var prevEdge = offsetEdges[(_i2 - 1 + n) % n];
        var currEdge = offsetEdges[_i2];
        var ip = intersectLines(prevEdge.p1, prevEdge.p2, currEdge.p1, currEdge.p2);
        inflated.push(ip);
    }
    return inflated;
}
function $e815fda779bc047b$var$miterBox(pts, centerX, centerY, width, height, strokeWidth) {
    var tpts = $e815fda779bc047b$var$transformPoints(pts, centerX, centerY, width, height);
    var offsetPoints = $e815fda779bc047b$var$inflatePolygon(tpts, strokeWidth);
    var bb = $e815fda779bc047b$var$makeBoundingBox();
    offsetPoints.forEach(function(pt) {
        return $e815fda779bc047b$var$expandBoundingBoxByPoint(bb, pt.x, pt.y);
    });
    return bb;
}
var $e815fda779bc047b$var$roundRectangleIntersectLine = function roundRectangleIntersectLine(x, y, nodeX, nodeY, width, height, padding) {
    var radius = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : 'auto';
    var cornerRadius = radius === 'auto' ? $e815fda779bc047b$var$getRoundRectangleRadius(width, height) : radius;
    var halfWidth = width / 2;
    var halfHeight = height / 2;
    cornerRadius = Math.min(cornerRadius, halfWidth, halfHeight);
    var doWidth = cornerRadius !== halfWidth, doHeight = cornerRadius !== halfHeight;
    // Check intersections with straight line segments
    var straightLineIntersections;
    // Top segment, left to right
    if (doWidth) {
        var topStartX = nodeX - halfWidth + cornerRadius - padding;
        var topStartY = nodeY - halfHeight - padding;
        var topEndX = nodeX + halfWidth - cornerRadius + padding;
        var topEndY = topStartY;
        straightLineIntersections = $e815fda779bc047b$var$finiteLinesIntersect(x, y, nodeX, nodeY, topStartX, topStartY, topEndX, topEndY, false);
        if (straightLineIntersections.length > 0) return straightLineIntersections;
    }
    // Right segment, top to bottom
    if (doHeight) {
        var rightStartX = nodeX + halfWidth + padding;
        var rightStartY = nodeY - halfHeight + cornerRadius - padding;
        var rightEndX = rightStartX;
        var rightEndY = nodeY + halfHeight - cornerRadius + padding;
        straightLineIntersections = $e815fda779bc047b$var$finiteLinesIntersect(x, y, nodeX, nodeY, rightStartX, rightStartY, rightEndX, rightEndY, false);
        if (straightLineIntersections.length > 0) return straightLineIntersections;
    }
    // Bottom segment, left to right
    if (doWidth) {
        var bottomStartX = nodeX - halfWidth + cornerRadius - padding;
        var bottomStartY = nodeY + halfHeight + padding;
        var bottomEndX = nodeX + halfWidth - cornerRadius + padding;
        var bottomEndY = bottomStartY;
        straightLineIntersections = $e815fda779bc047b$var$finiteLinesIntersect(x, y, nodeX, nodeY, bottomStartX, bottomStartY, bottomEndX, bottomEndY, false);
        if (straightLineIntersections.length > 0) return straightLineIntersections;
    }
    // Left segment, top to bottom
    if (doHeight) {
        var leftStartX = nodeX - halfWidth - padding;
        var leftStartY = nodeY - halfHeight + cornerRadius - padding;
        var leftEndX = leftStartX;
        var leftEndY = nodeY + halfHeight - cornerRadius + padding;
        straightLineIntersections = $e815fda779bc047b$var$finiteLinesIntersect(x, y, nodeX, nodeY, leftStartX, leftStartY, leftEndX, leftEndY, false);
        if (straightLineIntersections.length > 0) return straightLineIntersections;
    }
    // Check intersections with arc segments
    var arcIntersections;
    var topLeftCenterX = nodeX - halfWidth + cornerRadius;
    var topLeftCenterY = nodeY - halfHeight + cornerRadius;
    arcIntersections = $e815fda779bc047b$var$intersectLineCircle(x, y, nodeX, nodeY, topLeftCenterX, topLeftCenterY, cornerRadius + padding);
    // Ensure the intersection is on the desired quarter of the circle
    if (arcIntersections.length > 0 && arcIntersections[0] <= topLeftCenterX && arcIntersections[1] <= topLeftCenterY) return [
        arcIntersections[0],
        arcIntersections[1]
    ];
    var topRightCenterX = nodeX + halfWidth - cornerRadius;
    var topRightCenterY = nodeY - halfHeight + cornerRadius;
    arcIntersections = $e815fda779bc047b$var$intersectLineCircle(x, y, nodeX, nodeY, topRightCenterX, topRightCenterY, cornerRadius + padding);
    // Ensure the intersection is on the desired quarter of the circle
    if (arcIntersections.length > 0 && arcIntersections[0] >= topRightCenterX && arcIntersections[1] <= topRightCenterY) return [
        arcIntersections[0],
        arcIntersections[1]
    ];
    var bottomRightCenterX = nodeX + halfWidth - cornerRadius;
    var bottomRightCenterY = nodeY + halfHeight - cornerRadius;
    arcIntersections = $e815fda779bc047b$var$intersectLineCircle(x, y, nodeX, nodeY, bottomRightCenterX, bottomRightCenterY, cornerRadius + padding);
    // Ensure the intersection is on the desired quarter of the circle
    if (arcIntersections.length > 0 && arcIntersections[0] >= bottomRightCenterX && arcIntersections[1] >= bottomRightCenterY) return [
        arcIntersections[0],
        arcIntersections[1]
    ];
    var bottomLeftCenterX = nodeX - halfWidth + cornerRadius;
    var bottomLeftCenterY = nodeY + halfHeight - cornerRadius;
    arcIntersections = $e815fda779bc047b$var$intersectLineCircle(x, y, nodeX, nodeY, bottomLeftCenterX, bottomLeftCenterY, cornerRadius + padding);
    // Ensure the intersection is on the desired quarter of the circle
    if (arcIntersections.length > 0 && arcIntersections[0] <= bottomLeftCenterX && arcIntersections[1] >= bottomLeftCenterY) return [
        arcIntersections[0],
        arcIntersections[1]
    ];
    return []; // if nothing
};
var $e815fda779bc047b$var$inLineVicinity = function inLineVicinity(x, y, lx1, ly1, lx2, ly2, tolerance) {
    var t = tolerance;
    var x1 = Math.min(lx1, lx2);
    var x2 = Math.max(lx1, lx2);
    var y1 = Math.min(ly1, ly2);
    var y2 = Math.max(ly1, ly2);
    return x1 - t <= x && x <= x2 + t && y1 - t <= y && y <= y2 + t;
};
var $e815fda779bc047b$var$inBezierVicinity = function inBezierVicinity(x, y, x1, y1, x2, y2, x3, y3, tolerance) {
    var bb = {
        x1: Math.min(x1, x3, x2) - tolerance,
        x2: Math.max(x1, x3, x2) + tolerance,
        y1: Math.min(y1, y3, y2) - tolerance,
        y2: Math.max(y1, y3, y2) + tolerance
    };
    // if outside the rough bounding box for the bezier, then it can't be a hit
    if (x < bb.x1 || x > bb.x2 || y < bb.y1 || y > bb.y2) // console.log('bezier out of rough bb')
    return false;
    else // console.log('do more expensive check');
    return true;
};
var $e815fda779bc047b$var$solveQuadratic = function solveQuadratic(a, b, c, val) {
    c -= val;
    var r = b * b - 4 * a * c;
    if (r < 0) return [];
    var sqrtR = Math.sqrt(r);
    var denom = 2 * a;
    var root1 = (-b + sqrtR) / denom;
    var root2 = (-b - sqrtR) / denom;
    return [
        root1,
        root2
    ];
};
var $e815fda779bc047b$var$solveCubic = function solveCubic(a, b, c, d, result) {
    // Solves a cubic function, returns root in form [r1, i1, r2, i2, r3, i3], where
    // r is the real component, i is the imaginary component
    // An implementation of the Cardano method from the year 1545
    // http://en.wikipedia.org/wiki/Cubic_function#The_nature_of_the_roots
    var epsilon = 0.00001;
    // avoid division by zero while keeping the overall expression close in value
    if (a === 0) a = epsilon;
    b /= a;
    c /= a;
    d /= a;
    var discriminant, q, r, dum1, s, t, term1, r13;
    q = (3.0 * c - b * b) / 9.0;
    r = -(27.0 * d) + b * (9.0 * c - 2.0 * (b * b));
    r /= 54.0;
    discriminant = q * q * q + r * r;
    result[1] = 0;
    term1 = b / 3.0;
    if (discriminant > 0) {
        s = r + Math.sqrt(discriminant);
        s = s < 0 ? -Math.pow(-s, 1.0 / 3.0) : Math.pow(s, 1.0 / 3.0);
        t = r - Math.sqrt(discriminant);
        t = t < 0 ? -Math.pow(-t, 1.0 / 3.0) : Math.pow(t, 1.0 / 3.0);
        result[0] = -term1 + s + t;
        term1 += (s + t) / 2.0;
        result[4] = result[2] = -term1;
        term1 = Math.sqrt(3.0) * (-t + s) / 2;
        result[3] = term1;
        result[5] = -term1;
        return;
    }
    result[5] = result[3] = 0;
    if (discriminant === 0) {
        r13 = r < 0 ? -Math.pow(-r, 1.0 / 3.0) : Math.pow(r, 1.0 / 3.0);
        result[0] = -term1 + 2.0 * r13;
        result[4] = result[2] = -(r13 + term1);
        return;
    }
    q = -q;
    dum1 = q * q * q;
    dum1 = Math.acos(r / Math.sqrt(dum1));
    r13 = 2.0 * Math.sqrt(q);
    result[0] = -term1 + r13 * Math.cos(dum1 / 3.0);
    result[2] = -term1 + r13 * Math.cos((dum1 + 2.0 * Math.PI) / 3.0);
    result[4] = -term1 + r13 * Math.cos((dum1 + 4.0 * Math.PI) / 3.0);
    return;
};
var $e815fda779bc047b$var$sqdistToQuadraticBezier = function sqdistToQuadraticBezier(x, y, x1, y1, x2, y2, x3, y3) {
    // Find minimum distance by using the minimum of the distance
    // function between the given point and the curve
    // This gives the coefficients of the resulting cubic equation
    // whose roots tell us where a possible minimum is
    // (Coefficients are divided by 4)
    var a = 1.0 * x1 * x1 - 4 * x1 * x2 + 2 * x1 * x3 + 4 * x2 * x2 - 4 * x2 * x3 + x3 * x3 + y1 * y1 - 4 * y1 * y2 + 2 * y1 * y3 + 4 * y2 * y2 - 4 * y2 * y3 + y3 * y3;
    var b = 9 * x1 * x2 - 3 * x1 * x1 - 3 * x1 * x3 - 6 * x2 * x2 + 3 * x2 * x3 + 9 * y1 * y2 - 3 * y1 * y1 - 3 * y1 * y3 - 6 * y2 * y2 + 3 * y2 * y3;
    var c = 3 * x1 * x1 - 6 * x1 * x2 + x1 * x3 - x1 * x + 2 * x2 * x2 + 2 * x2 * x - x3 * x + 3 * y1 * y1 - 6 * y1 * y2 + y1 * y3 - y1 * y + 2 * y2 * y2 + 2 * y2 * y - y3 * y;
    var d = 1.0 * x1 * x2 - x1 * x1 + x1 * x - x2 * x + y1 * y2 - y1 * y1 + y1 * y - y2 * y;
    // debug("coefficients: " + a / a + ", " + b / a + ", " + c / a + ", " + d / a);
    var roots = [];
    // Use the cubic solving algorithm
    $e815fda779bc047b$var$solveCubic(a, b, c, d, roots);
    var zeroThreshold = 0.0000001;
    var params = [];
    for(var index = 0; index < 6; index += 2)if (Math.abs(roots[index + 1]) < zeroThreshold && roots[index] >= 0 && roots[index] <= 1.0) params.push(roots[index]);
    params.push(1.0);
    params.push(0.0);
    var minDistanceSquared = -1;
    var curX, curY, distSquared;
    for(var i = 0; i < params.length; i++){
        curX = Math.pow(1.0 - params[i], 2.0) * x1 + 2.0 * (1 - params[i]) * params[i] * x2 + params[i] * params[i] * x3;
        curY = Math.pow(1 - params[i], 2.0) * y1 + 2 * (1.0 - params[i]) * params[i] * y2 + params[i] * params[i] * y3;
        distSquared = Math.pow(curX - x, 2) + Math.pow(curY - y, 2);
        // debug('distance for param ' + params[i] + ": " + Math.sqrt(distSquared));
        if (minDistanceSquared >= 0) {
            if (distSquared < minDistanceSquared) minDistanceSquared = distSquared;
        } else minDistanceSquared = distSquared;
    }
    return minDistanceSquared;
};
var $e815fda779bc047b$var$sqdistToFiniteLine = function sqdistToFiniteLine(x, y, x1, y1, x2, y2) {
    var offset = [
        x - x1,
        y - y1
    ];
    var line = [
        x2 - x1,
        y2 - y1
    ];
    var lineSq = line[0] * line[0] + line[1] * line[1];
    var hypSq = offset[0] * offset[0] + offset[1] * offset[1];
    var dotProduct = offset[0] * line[0] + offset[1] * line[1];
    var adjSq = dotProduct * dotProduct / lineSq;
    if (dotProduct < 0) return hypSq;
    if (adjSq > lineSq) return (x - x2) * (x - x2) + (y - y2) * (y - y2);
    return hypSq - adjSq;
};
var $e815fda779bc047b$var$pointInsidePolygonPoints = function pointInsidePolygonPoints(x, y, points) {
    var x1, y1, x2, y2;
    var y3;
    // Intersect with vertical line through (x, y)
    var up = 0;
    // let down = 0;
    for(var i = 0; i < points.length / 2; i++){
        x1 = points[i * 2];
        y1 = points[i * 2 + 1];
        if (i + 1 < points.length / 2) {
            x2 = points[(i + 1) * 2];
            y2 = points[(i + 1) * 2 + 1];
        } else {
            x2 = points[(i + 1 - points.length / 2) * 2];
            y2 = points[(i + 1 - points.length / 2) * 2 + 1];
        }
        if (x1 == x && x2 == x) ;
        else if (x1 >= x && x >= x2 || x1 <= x && x <= x2) {
            y3 = (x - x1) / (x2 - x1) * (y2 - y1) + y1;
            if (y3 > y) up++;
        // if( y3 < y ){
        // down++;
        // }
        } else continue;
    }
    if (up % 2 === 0) return false;
    else return true;
};
var $e815fda779bc047b$var$pointInsidePolygon = function pointInsidePolygon(x, y, basePoints, centerX, centerY, width, height, direction, padding) {
    var transformedPoints = new Array(basePoints.length);
    // Gives negative angle
    var angle;
    if (direction[0] != null) {
        angle = Math.atan(direction[1] / direction[0]);
        if (direction[0] < 0) angle = angle + Math.PI / 2;
        else angle = -angle - Math.PI / 2;
    } else angle = direction;
    var cos = Math.cos(-angle);
    var sin = Math.sin(-angle);
    //    console.log("base: " + basePoints);
    for(var i = 0; i < transformedPoints.length / 2; i++){
        transformedPoints[i * 2] = width / 2 * (basePoints[i * 2] * cos - basePoints[i * 2 + 1] * sin);
        transformedPoints[i * 2 + 1] = height / 2 * (basePoints[i * 2 + 1] * cos + basePoints[i * 2] * sin);
        transformedPoints[i * 2] += centerX;
        transformedPoints[i * 2 + 1] += centerY;
    }
    var points;
    if (padding > 0) {
        var expandedLineSet = $e815fda779bc047b$var$expandPolygon(transformedPoints, -padding);
        points = $e815fda779bc047b$var$joinLines(expandedLineSet);
    } else points = transformedPoints;
    return $e815fda779bc047b$var$pointInsidePolygonPoints(x, y, points);
};
var $e815fda779bc047b$var$pointInsideRoundPolygon = function pointInsideRoundPolygon(x, y, basePoints, centerX, centerY, width, height, corners) {
    var cutPolygonPoints = new Array(basePoints.length * 2);
    for(var i = 0; i < corners.length; i++){
        var corner = corners[i];
        cutPolygonPoints[i * 4 + 0] = corner.startX;
        cutPolygonPoints[i * 4 + 1] = corner.startY;
        cutPolygonPoints[i * 4 + 2] = corner.stopX;
        cutPolygonPoints[i * 4 + 3] = corner.stopY;
        var squaredDistance = Math.pow(corner.cx - x, 2) + Math.pow(corner.cy - y, 2);
        if (squaredDistance <= Math.pow(corner.radius, 2)) return true;
    }
    return $e815fda779bc047b$var$pointInsidePolygonPoints(x, y, cutPolygonPoints);
};
var $e815fda779bc047b$var$joinLines = function joinLines(lineSet) {
    var vertices = new Array(lineSet.length / 2);
    var currentLineStartX, currentLineStartY, currentLineEndX, currentLineEndY;
    var nextLineStartX, nextLineStartY, nextLineEndX, nextLineEndY;
    for(var i = 0; i < lineSet.length / 4; i++){
        currentLineStartX = lineSet[i * 4];
        currentLineStartY = lineSet[i * 4 + 1];
        currentLineEndX = lineSet[i * 4 + 2];
        currentLineEndY = lineSet[i * 4 + 3];
        if (i < lineSet.length / 4 - 1) {
            nextLineStartX = lineSet[(i + 1) * 4];
            nextLineStartY = lineSet[(i + 1) * 4 + 1];
            nextLineEndX = lineSet[(i + 1) * 4 + 2];
            nextLineEndY = lineSet[(i + 1) * 4 + 3];
        } else {
            nextLineStartX = lineSet[0];
            nextLineStartY = lineSet[1];
            nextLineEndX = lineSet[2];
            nextLineEndY = lineSet[3];
        }
        var intersection = $e815fda779bc047b$var$finiteLinesIntersect(currentLineStartX, currentLineStartY, currentLineEndX, currentLineEndY, nextLineStartX, nextLineStartY, nextLineEndX, nextLineEndY, true);
        vertices[i * 2] = intersection[0];
        vertices[i * 2 + 1] = intersection[1];
    }
    return vertices;
};
var $e815fda779bc047b$var$expandPolygon = function expandPolygon(points, pad) {
    var expandedLineSet = new Array(points.length * 2);
    var currentPointX, currentPointY, nextPointX, nextPointY;
    for(var i = 0; i < points.length / 2; i++){
        currentPointX = points[i * 2];
        currentPointY = points[i * 2 + 1];
        if (i < points.length / 2 - 1) {
            nextPointX = points[(i + 1) * 2];
            nextPointY = points[(i + 1) * 2 + 1];
        } else {
            nextPointX = points[0];
            nextPointY = points[1];
        }
        // Current line: [currentPointX, currentPointY] to [nextPointX, nextPointY]
        // Assume CCW polygon winding
        var offsetX = nextPointY - currentPointY;
        var offsetY = -(nextPointX - currentPointX);
        // Normalize
        var offsetLength = Math.sqrt(offsetX * offsetX + offsetY * offsetY);
        var normalizedOffsetX = offsetX / offsetLength;
        var normalizedOffsetY = offsetY / offsetLength;
        expandedLineSet[i * 4] = currentPointX + normalizedOffsetX * pad;
        expandedLineSet[i * 4 + 1] = currentPointY + normalizedOffsetY * pad;
        expandedLineSet[i * 4 + 2] = nextPointX + normalizedOffsetX * pad;
        expandedLineSet[i * 4 + 3] = nextPointY + normalizedOffsetY * pad;
    }
    return expandedLineSet;
};
var $e815fda779bc047b$var$intersectLineEllipse = function intersectLineEllipse(x, y, centerX, centerY, ellipseWradius, ellipseHradius) {
    var dispX = centerX - x;
    var dispY = centerY - y;
    dispX /= ellipseWradius;
    dispY /= ellipseHradius;
    var len = Math.sqrt(dispX * dispX + dispY * dispY);
    var newLength = len - 1;
    if (newLength < 0) return [];
    var lenProportion = newLength / len;
    return [
        (centerX - x) * lenProportion + x,
        (centerY - y) * lenProportion + y
    ];
};
var $e815fda779bc047b$var$checkInEllipse = function checkInEllipse(x, y, width, height, centerX, centerY, padding) {
    x -= centerX;
    y -= centerY;
    x /= width / 2 + padding;
    y /= height / 2 + padding;
    return x * x + y * y <= 1;
};
// Returns intersections of increasing distance from line's start point
var $e815fda779bc047b$var$intersectLineCircle = function intersectLineCircle(x1, y1, x2, y2, centerX, centerY, radius) {
    // Calculate d, direction vector of line
    var d = [
        x2 - x1,
        y2 - y1
    ]; // Direction vector of line
    var f = [
        x1 - centerX,
        y1 - centerY
    ];
    var a = d[0] * d[0] + d[1] * d[1];
    var b = 2 * (f[0] * d[0] + f[1] * d[1]);
    var c = f[0] * f[0] + f[1] * f[1] - radius * radius;
    var discriminant = b * b - 4 * a * c;
    if (discriminant < 0) return [];
    var t1 = (-b + Math.sqrt(discriminant)) / (2 * a);
    var t2 = (-b - Math.sqrt(discriminant)) / (2 * a);
    var tMin = Math.min(t1, t2);
    var tMax = Math.max(t1, t2);
    var inRangeParams = [];
    if (tMin >= 0 && tMin <= 1) inRangeParams.push(tMin);
    if (tMax >= 0 && tMax <= 1) inRangeParams.push(tMax);
    if (inRangeParams.length === 0) return [];
    var nearIntersectionX = inRangeParams[0] * d[0] + x1;
    var nearIntersectionY = inRangeParams[0] * d[1] + y1;
    if (inRangeParams.length > 1) {
        if (inRangeParams[0] == inRangeParams[1]) return [
            nearIntersectionX,
            nearIntersectionY
        ];
        else {
            var farIntersectionX = inRangeParams[1] * d[0] + x1;
            var farIntersectionY = inRangeParams[1] * d[1] + y1;
            return [
                nearIntersectionX,
                nearIntersectionY,
                farIntersectionX,
                farIntersectionY
            ];
        }
    } else return [
        nearIntersectionX,
        nearIntersectionY
    ];
};
var $e815fda779bc047b$var$midOfThree = function midOfThree(a, b, c) {
    if (b <= a && a <= c || c <= a && a <= b) return a;
    else if (a <= b && b <= c || c <= b && b <= a) return b;
    else return c;
};
// (x1,y1)=>(x2,y2) intersect with (x3,y3)=>(x4,y4)
var $e815fda779bc047b$var$finiteLinesIntersect = function finiteLinesIntersect(x1, y1, x2, y2, x3, y3, x4, y4, infiniteLines) {
    var dx13 = x1 - x3;
    var dx21 = x2 - x1;
    var dx43 = x4 - x3;
    var dy13 = y1 - y3;
    var dy21 = y2 - y1;
    var dy43 = y4 - y3;
    var ua_t = dx43 * dy13 - dy43 * dx13;
    var ub_t = dx21 * dy13 - dy21 * dx13;
    var u_b = dy43 * dx21 - dx43 * dy21;
    if (u_b !== 0) {
        var ua = ua_t / u_b;
        var ub = ub_t / u_b;
        var flptThreshold = 0.001;
        var _min = 0 - flptThreshold;
        var _max = 1 + flptThreshold;
        if (_min <= ua && ua <= _max && _min <= ub && ub <= _max) return [
            x1 + ua * dx21,
            y1 + ua * dy21
        ];
        else {
            if (!infiniteLines) return [];
            else return [
                x1 + ua * dx21,
                y1 + ua * dy21
            ];
        }
    } else {
        if (ua_t === 0 || ub_t === 0) {
            // Parallel, coincident lines. Check if overlap
            // Check endpoint of second line
            if ($e815fda779bc047b$var$midOfThree(x1, x2, x4) === x4) return [
                x4,
                y4
            ];
            // Check start point of second line
            if ($e815fda779bc047b$var$midOfThree(x1, x2, x3) === x3) return [
                x3,
                y3
            ];
            // Endpoint of first line
            if ($e815fda779bc047b$var$midOfThree(x3, x4, x2) === x2) return [
                x2,
                y2
            ];
            return [];
        } else // Parallel, non-coincident
        return [];
    }
};
var $e815fda779bc047b$var$transformPoints = function transformPoints(points, centerX, centerY, width, height) {
    var ret = [];
    var halfW = width / 2;
    var halfH = height / 2;
    var x = centerX;
    var y = centerY;
    ret.push({
        x: x + halfW * points[0],
        y: y + halfH * points[1]
    });
    for(var i = 1; i < points.length / 2; i++)ret.push({
        x: x + halfW * points[i * 2],
        y: y + halfH * points[i * 2 + 1]
    });
    return ret;
};
// math.polygonIntersectLine( x, y, basePoints, centerX, centerY, width, height, padding )
// intersect a node polygon (pts transformed)
//
// math.polygonIntersectLine( x, y, basePoints, centerX, centerY )
// intersect the points (no transform)
var $e815fda779bc047b$var$polygonIntersectLine = function polygonIntersectLine(x, y, basePoints, centerX, centerY, width, height, padding) {
    var intersections = [];
    var intersection;
    var transformedPoints = new Array(basePoints.length);
    var doTransform = true;
    if (width == null) doTransform = false;
    var points;
    if (doTransform) {
        for(var i = 0; i < transformedPoints.length / 2; i++){
            transformedPoints[i * 2] = basePoints[i * 2] * width + centerX;
            transformedPoints[i * 2 + 1] = basePoints[i * 2 + 1] * height + centerY;
        }
        if (padding > 0) {
            var expandedLineSet = $e815fda779bc047b$var$expandPolygon(transformedPoints, -padding);
            points = $e815fda779bc047b$var$joinLines(expandedLineSet);
        } else points = transformedPoints;
    } else points = basePoints;
    var currentX, currentY, nextX, nextY;
    for(var _i3 = 0; _i3 < points.length / 2; _i3++){
        currentX = points[_i3 * 2];
        currentY = points[_i3 * 2 + 1];
        if (_i3 < points.length / 2 - 1) {
            nextX = points[(_i3 + 1) * 2];
            nextY = points[(_i3 + 1) * 2 + 1];
        } else {
            nextX = points[0];
            nextY = points[1];
        }
        intersection = $e815fda779bc047b$var$finiteLinesIntersect(x, y, centerX, centerY, currentX, currentY, nextX, nextY);
        if (intersection.length !== 0) intersections.push(intersection[0], intersection[1]);
    }
    return intersections;
};
var $e815fda779bc047b$var$roundPolygonIntersectLine = function roundPolygonIntersectLine(x, y, basePoints, centerX, centerY, width, height, padding, corners) {
    var intersections = [];
    var intersection;
    var lines = new Array(basePoints.length * 2);
    corners.forEach(function(corner, i) {
        if (i === 0) {
            lines[lines.length - 2] = corner.startX;
            lines[lines.length - 1] = corner.startY;
        } else {
            lines[i * 4 - 2] = corner.startX;
            lines[i * 4 - 1] = corner.startY;
        }
        lines[i * 4] = corner.stopX;
        lines[i * 4 + 1] = corner.stopY;
        intersection = $e815fda779bc047b$var$intersectLineCircle(x, y, centerX, centerY, corner.cx, corner.cy, corner.radius);
        if (intersection.length !== 0) intersections.push(intersection[0], intersection[1]);
    });
    for(var i = 0; i < lines.length / 4; i++){
        intersection = $e815fda779bc047b$var$finiteLinesIntersect(x, y, centerX, centerY, lines[i * 4], lines[i * 4 + 1], lines[i * 4 + 2], lines[i * 4 + 3], false);
        if (intersection.length !== 0) intersections.push(intersection[0], intersection[1]);
    }
    if (intersections.length > 2) {
        var lowestIntersection = [
            intersections[0],
            intersections[1]
        ];
        var lowestSquaredDistance = Math.pow(lowestIntersection[0] - x, 2) + Math.pow(lowestIntersection[1] - y, 2);
        for(var _i4 = 1; _i4 < intersections.length / 2; _i4++){
            var squaredDistance = Math.pow(intersections[_i4 * 2] - x, 2) + Math.pow(intersections[_i4 * 2 + 1] - y, 2);
            if (squaredDistance <= lowestSquaredDistance) {
                lowestIntersection[0] = intersections[_i4 * 2];
                lowestIntersection[1] = intersections[_i4 * 2 + 1];
                lowestSquaredDistance = squaredDistance;
            }
        }
        return lowestIntersection;
    }
    return intersections;
};
var $e815fda779bc047b$var$shortenIntersection = function shortenIntersection(intersection, offset, amount) {
    var disp = [
        intersection[0] - offset[0],
        intersection[1] - offset[1]
    ];
    var length = Math.sqrt(disp[0] * disp[0] + disp[1] * disp[1]);
    var lenRatio = (length - amount) / length;
    if (lenRatio < 0) lenRatio = 0.00001;
    return [
        offset[0] + lenRatio * disp[0],
        offset[1] + lenRatio * disp[1]
    ];
};
var $e815fda779bc047b$var$generateUnitNgonPointsFitToSquare = function generateUnitNgonPointsFitToSquare(sides, rotationRadians) {
    var points = $e815fda779bc047b$var$generateUnitNgonPoints(sides, rotationRadians);
    points = $e815fda779bc047b$var$fitPolygonToSquare(points);
    return points;
};
var $e815fda779bc047b$var$fitPolygonToSquare = function fitPolygonToSquare(points) {
    var x, y;
    var sides = points.length / 2;
    var minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity;
    for(var i = 0; i < sides; i++){
        x = points[2 * i];
        y = points[2 * i + 1];
        minX = Math.min(minX, x);
        maxX = Math.max(maxX, x);
        minY = Math.min(minY, y);
        maxY = Math.max(maxY, y);
    }
    // stretch factors
    var sx = 2 / (maxX - minX);
    var sy = 2 / (maxY - minY);
    for(var _i5 = 0; _i5 < sides; _i5++){
        x = points[2 * _i5] = points[2 * _i5] * sx;
        y = points[2 * _i5 + 1] = points[2 * _i5 + 1] * sy;
        minX = Math.min(minX, x);
        maxX = Math.max(maxX, x);
        minY = Math.min(minY, y);
        maxY = Math.max(maxY, y);
    }
    if (minY < -1) for(var _i6 = 0; _i6 < sides; _i6++)y = points[2 * _i6 + 1] = points[2 * _i6 + 1] + (-1 - minY);
    return points;
};
var $e815fda779bc047b$var$generateUnitNgonPoints = function generateUnitNgonPoints(sides, rotationRadians) {
    var increment = 1.0 / sides * 2 * Math.PI;
    var startAngle = sides % 2 === 0 ? Math.PI / 2.0 + increment / 2.0 : Math.PI / 2.0;
    startAngle += rotationRadians;
    var points = new Array(sides * 2);
    var currentAngle;
    for(var i = 0; i < sides; i++){
        currentAngle = i * increment + startAngle;
        points[2 * i] = Math.cos(currentAngle); // x
        points[2 * i + 1] = Math.sin(-currentAngle); // y
    }
    return points;
};
// Set the default radius, unless half of width or height is smaller than default
var $e815fda779bc047b$var$getRoundRectangleRadius = function getRoundRectangleRadius(width, height) {
    return Math.min(width / 4, height / 4, 8);
};
// Set the default radius
var $e815fda779bc047b$var$getRoundPolygonRadius = function getRoundPolygonRadius(width, height) {
    return Math.min(width / 10, height / 10, 8);
};
var $e815fda779bc047b$var$getCutRectangleCornerLength = function getCutRectangleCornerLength() {
    return 8;
};
var $e815fda779bc047b$var$bezierPtsToQuadCoeff = function bezierPtsToQuadCoeff(p0, p1, p2) {
    return [
        p0 - 2 * p1 + p2,
        2 * (p1 - p0),
        p0
    ];
};
// get curve width, height, and control point position offsets as a percentage of node height / width
var $e815fda779bc047b$var$getBarrelCurveConstants = function getBarrelCurveConstants(width, height) {
    return {
        heightOffset: Math.min(15, 0.05 * height),
        widthOffset: Math.min(100, 0.25 * width),
        ctrlPtOffsetPct: 0.05
    };
};
// Separating Axis Theorem (SAT) to determine if two polygons intersect. 
// The function takes two polygons as input and returns a boolean value indicating 
// whether the two polygons intersect.
function $e815fda779bc047b$var$satPolygonIntersection(poly1, poly2) {
    function getAxes(polygon) {
        var axes = [];
        for(var i = 0; i < polygon.length; i++){
            var p1 = polygon[i];
            var p2 = polygon[(i + 1) % polygon.length];
            var edge = {
                x: p2.x - p1.x,
                y: p2.y - p1.y
            };
            var normal = {
                x: -edge.y,
                y: edge.x
            };
            var length = Math.sqrt(normal.x * normal.x + normal.y * normal.y);
            axes.push({
                x: normal.x / length,
                y: normal.y / length
            });
        }
        return axes;
    }
    function project(polygon, axis) {
        var min = Infinity;
        var max = -Infinity;
        var _iterator = $e815fda779bc047b$var$_createForOfIteratorHelper(polygon), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var point = _step.value;
                var projection = point.x * axis.x + point.y * axis.y;
                min = Math.min(min, projection);
                max = Math.max(max, projection);
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return {
            min: min,
            max: max
        };
    }
    function overlaps(proj1, proj2) {
        return !(proj1.max < proj2.min || proj2.max < proj1.min);
    }
    var axes = [].concat($e815fda779bc047b$var$_toConsumableArray(getAxes(poly1)), $e815fda779bc047b$var$_toConsumableArray(getAxes(poly2)));
    var _iterator2 = $e815fda779bc047b$var$_createForOfIteratorHelper(axes), _step2;
    try {
        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
            var axis = _step2.value;
            var proj1 = project(poly1, axis);
            var proj2 = project(poly2, axis);
            if (!overlaps(proj1, proj2)) return false; // No overlap, so the polygons do not intersect
        }
    } catch (err) {
        _iterator2.e(err);
    } finally{
        _iterator2.f();
    }
    return true; // polygons intersect
}
var $e815fda779bc047b$var$pageRankDefaults = $e815fda779bc047b$var$defaults$g({
    dampingFactor: 0.8,
    precision: 0.000001,
    iterations: 200,
    weight: function weight(edge) {
        return 1;
    }
});
var $e815fda779bc047b$var$elesfn$o = {
    pageRank: function pageRank(options) {
        var _pageRankDefaults = $e815fda779bc047b$var$pageRankDefaults(options), dampingFactor = _pageRankDefaults.dampingFactor, precision = _pageRankDefaults.precision, iterations = _pageRankDefaults.iterations, weight = _pageRankDefaults.weight;
        var cy = this._private.cy;
        var _this$byGroup = this.byGroup(), nodes = _this$byGroup.nodes, edges = _this$byGroup.edges;
        var numNodes = nodes.length;
        var numNodesSqd = numNodes * numNodes;
        var numEdges = edges.length;
        // Construct transposed adjacency matrix
        // First lets have a zeroed matrix of the right size
        // We'll also keep track of the sum of each column
        var matrix = new Array(numNodesSqd);
        var columnSum = new Array(numNodes);
        var additionalProb = (1 - dampingFactor) / numNodes;
        // Create null matrix
        for(var i = 0; i < numNodes; i++){
            for(var j = 0; j < numNodes; j++){
                var n = i * numNodes + j;
                matrix[n] = 0;
            }
            columnSum[i] = 0;
        }
        // Now, process edges
        for(var _i = 0; _i < numEdges; _i++){
            var edge = edges[_i];
            var srcId = edge.data('source');
            var tgtId = edge.data('target');
            // Don't include loops in the matrix
            if (srcId === tgtId) continue;
            var s = nodes.indexOfId(srcId);
            var t = nodes.indexOfId(tgtId);
            var w = weight(edge);
            var _n = t * numNodes + s;
            // Update matrix
            matrix[_n] += w;
            // Update column sum
            columnSum[s] += w;
        }
        // Add additional probability based on damping factor
        // Also, take into account columns that have sum = 0
        var p = 1.0 / numNodes + additionalProb; // Shorthand
        // Traverse matrix, column by column
        for(var _j = 0; _j < numNodes; _j++){
            if (columnSum[_j] === 0) // No 'links' out from node jth, assume equal probability for each possible node
            for(var _i2 = 0; _i2 < numNodes; _i2++){
                var _n2 = _i2 * numNodes + _j;
                matrix[_n2] = p;
            }
            else // Node jth has outgoing link, compute normalized probabilities
            for(var _i3 = 0; _i3 < numNodes; _i3++){
                var _n3 = _i3 * numNodes + _j;
                matrix[_n3] = matrix[_n3] / columnSum[_j] + additionalProb;
            }
        }
        // Compute dominant eigenvector using power method
        var eigenvector = new Array(numNodes);
        var temp = new Array(numNodes);
        var previous;
        // Start with a vector of all 1's
        // Also, initialize a null vector which will be used as shorthand
        for(var _i4 = 0; _i4 < numNodes; _i4++)eigenvector[_i4] = 1;
        for(var iter = 0; iter < iterations; iter++){
            // Temp array with all 0's
            for(var _i5 = 0; _i5 < numNodes; _i5++)temp[_i5] = 0;
            // Multiply matrix with previous result
            for(var _i6 = 0; _i6 < numNodes; _i6++)for(var _j2 = 0; _j2 < numNodes; _j2++){
                var _n4 = _i6 * numNodes + _j2;
                temp[_i6] += matrix[_n4] * eigenvector[_j2];
            }
            $e815fda779bc047b$var$inPlaceSumNormalize(temp);
            previous = eigenvector;
            eigenvector = temp;
            temp = previous;
            var diff = 0;
            // Compute difference (squared module) of both vectors
            for(var _i7 = 0; _i7 < numNodes; _i7++){
                var delta = previous[_i7] - eigenvector[_i7];
                diff += delta * delta;
            }
            // If difference is less than the desired threshold, stop iterating
            if (diff < precision) break;
        }
        // Construct result
        var res = {
            rank: function rank(node) {
                node = cy.collection(node)[0];
                return eigenvector[nodes.indexOf(node)];
            }
        };
        return res;
    } // pageRank
}; // elesfn
var $e815fda779bc047b$var$defaults$f = $e815fda779bc047b$var$defaults$g({
    root: null,
    weight: function weight(edge) {
        return 1;
    },
    directed: false,
    alpha: 0
});
var $e815fda779bc047b$var$elesfn$n = {
    degreeCentralityNormalized: function degreeCentralityNormalized(options) {
        options = $e815fda779bc047b$var$defaults$f(options);
        var cy = this.cy();
        var nodes = this.nodes();
        var numNodes = nodes.length;
        if (!options.directed) {
            var degrees = {};
            var maxDegree = 0;
            for(var i = 0; i < numNodes; i++){
                var node = nodes[i];
                // add current node to the current options object and call degreeCentrality
                options.root = node;
                var currDegree = this.degreeCentrality(options);
                if (maxDegree < currDegree.degree) maxDegree = currDegree.degree;
                degrees[node.id()] = currDegree.degree;
            }
            return {
                degree: function degree(node) {
                    if (maxDegree === 0) return 0;
                    if ($e815fda779bc047b$var$string(node)) // from is a selector string
                    node = cy.filter(node);
                    return degrees[node.id()] / maxDegree;
                }
            };
        } else {
            var indegrees = {};
            var outdegrees = {};
            var maxIndegree = 0;
            var maxOutdegree = 0;
            for(var _i = 0; _i < numNodes; _i++){
                var _node = nodes[_i];
                var id = _node.id();
                // add current node to the current options object and call degreeCentrality
                options.root = _node;
                var _currDegree = this.degreeCentrality(options);
                if (maxIndegree < _currDegree.indegree) maxIndegree = _currDegree.indegree;
                if (maxOutdegree < _currDegree.outdegree) maxOutdegree = _currDegree.outdegree;
                indegrees[id] = _currDegree.indegree;
                outdegrees[id] = _currDegree.outdegree;
            }
            return {
                indegree: function indegree(node) {
                    if (maxIndegree == 0) return 0;
                    if ($e815fda779bc047b$var$string(node)) // from is a selector string
                    node = cy.filter(node);
                    return indegrees[node.id()] / maxIndegree;
                },
                outdegree: function outdegree(node) {
                    if (maxOutdegree === 0) return 0;
                    if ($e815fda779bc047b$var$string(node)) // from is a selector string
                    node = cy.filter(node);
                    return outdegrees[node.id()] / maxOutdegree;
                }
            };
        }
    },
    // degreeCentralityNormalized
    // Implemented from the algorithm in Opsahl's paper
    // "Node centrality in weighted networks: Generalizing degree and shortest paths"
    // check the heading 2 "Degree"
    degreeCentrality: function degreeCentrality(options) {
        options = $e815fda779bc047b$var$defaults$f(options);
        var cy = this.cy();
        var callingEles = this;
        var _options = options, root = _options.root, weight = _options.weight, directed = _options.directed, alpha = _options.alpha;
        root = cy.collection(root)[0];
        if (!directed) {
            var connEdges = root.connectedEdges().intersection(callingEles);
            var k = connEdges.length;
            var s = 0;
            // Now, sum edge weights
            for(var i = 0; i < connEdges.length; i++)s += weight(connEdges[i]);
            return {
                degree: Math.pow(k, 1 - alpha) * Math.pow(s, alpha)
            };
        } else {
            var edges = root.connectedEdges();
            var incoming = edges.filter(function(edge) {
                return edge.target().same(root) && callingEles.has(edge);
            });
            var outgoing = edges.filter(function(edge) {
                return edge.source().same(root) && callingEles.has(edge);
            });
            var k_in = incoming.length;
            var k_out = outgoing.length;
            var s_in = 0;
            var s_out = 0;
            // Now, sum incoming edge weights
            for(var _i2 = 0; _i2 < incoming.length; _i2++)s_in += weight(incoming[_i2]);
            // Now, sum outgoing edge weights
            for(var _i3 = 0; _i3 < outgoing.length; _i3++)s_out += weight(outgoing[_i3]);
            return {
                indegree: Math.pow(k_in, 1 - alpha) * Math.pow(s_in, alpha),
                outdegree: Math.pow(k_out, 1 - alpha) * Math.pow(s_out, alpha)
            };
        }
    } // degreeCentrality
}; // elesfn
// nice, short mathematical alias
$e815fda779bc047b$var$elesfn$n.dc = $e815fda779bc047b$var$elesfn$n.degreeCentrality;
$e815fda779bc047b$var$elesfn$n.dcn = $e815fda779bc047b$var$elesfn$n.degreeCentralityNormalised = $e815fda779bc047b$var$elesfn$n.degreeCentralityNormalized;
var $e815fda779bc047b$var$defaults$e = $e815fda779bc047b$var$defaults$g({
    harmonic: true,
    weight: function weight() {
        return 1;
    },
    directed: false,
    root: null
});
var $e815fda779bc047b$var$elesfn$m = {
    closenessCentralityNormalized: function closenessCentralityNormalized(options) {
        var _defaults = $e815fda779bc047b$var$defaults$e(options), harmonic = _defaults.harmonic, weight = _defaults.weight, directed = _defaults.directed;
        var cy = this.cy();
        var closenesses = {};
        var maxCloseness = 0;
        var nodes = this.nodes();
        var fw = this.floydWarshall({
            weight: weight,
            directed: directed
        });
        // Compute closeness for every node and find the maximum closeness
        for(var i = 0; i < nodes.length; i++){
            var currCloseness = 0;
            var node_i = nodes[i];
            for(var j = 0; j < nodes.length; j++)if (i !== j) {
                var d = fw.distance(node_i, nodes[j]);
                if (harmonic) currCloseness += 1 / d;
                else currCloseness += d;
            }
            if (!harmonic) currCloseness = 1 / currCloseness;
            if (maxCloseness < currCloseness) maxCloseness = currCloseness;
            closenesses[node_i.id()] = currCloseness;
        }
        return {
            closeness: function closeness(node) {
                if (maxCloseness == 0) return 0;
                if ($e815fda779bc047b$var$string(node)) // from is a selector string
                node = cy.filter(node)[0].id();
                else // from is a node
                node = node.id();
                return closenesses[node] / maxCloseness;
            }
        };
    },
    // Implemented from pseudocode from wikipedia
    closenessCentrality: function closenessCentrality(options) {
        var _defaults2 = $e815fda779bc047b$var$defaults$e(options), root = _defaults2.root, weight = _defaults2.weight, directed = _defaults2.directed, harmonic = _defaults2.harmonic;
        root = this.filter(root)[0];
        // we need distance from this node to every other node
        var dijkstra = this.dijkstra({
            root: root,
            weight: weight,
            directed: directed
        });
        var totalDistance = 0;
        var nodes = this.nodes();
        for(var i = 0; i < nodes.length; i++){
            var n = nodes[i];
            if (!n.same(root)) {
                var d = dijkstra.distanceTo(n);
                if (harmonic) totalDistance += 1 / d;
                else totalDistance += d;
            }
        }
        return harmonic ? totalDistance : 1 / totalDistance;
    } // closenessCentrality
}; // elesfn
// nice, short mathematical alias
$e815fda779bc047b$var$elesfn$m.cc = $e815fda779bc047b$var$elesfn$m.closenessCentrality;
$e815fda779bc047b$var$elesfn$m.ccn = $e815fda779bc047b$var$elesfn$m.closenessCentralityNormalised = $e815fda779bc047b$var$elesfn$m.closenessCentralityNormalized;
var $e815fda779bc047b$var$defaults$d = $e815fda779bc047b$var$defaults$g({
    weight: null,
    directed: false
});
var $e815fda779bc047b$var$elesfn$l = {
    // Implemented from the algorithm in the paper "On Variants of Shortest-Path Betweenness Centrality and their Generic Computation" by Ulrik Brandes
    betweennessCentrality: function betweennessCentrality(options) {
        var _defaults = $e815fda779bc047b$var$defaults$d(options), directed = _defaults.directed, weight = _defaults.weight;
        var weighted = weight != null;
        var cy = this.cy();
        // starting
        var V = this.nodes();
        var A = {};
        var _C = {};
        var max = 0;
        var C = {
            set: function set(key, val) {
                _C[key] = val;
                if (val > max) max = val;
            },
            get: function get(key) {
                return _C[key];
            }
        };
        // A contains the neighborhoods of every node
        for(var i = 0; i < V.length; i++){
            var v = V[i];
            var vid = v.id();
            if (directed) A[vid] = v.outgoers().nodes(); // get outgoers of every node
            else A[vid] = v.openNeighborhood().nodes(); // get neighbors of every node
            C.set(vid, 0);
        }
        var _loop = function _loop() {
            var sid = V[s].id();
            var S = []; // stack
            var P = {};
            var g = {};
            var d = {};
            var Q = new $e815fda779bc047b$var$Heap(function(a, b) {
                return d[a] - d[b];
            }); // queue
            // init dictionaries
            for(var _i = 0; _i < V.length; _i++){
                var _vid = V[_i].id();
                P[_vid] = [];
                g[_vid] = 0;
                d[_vid] = Infinity;
            }
            g[sid] = 1; // sigma
            d[sid] = 0; // distance to s
            Q.push(sid);
            while(!Q.empty()){
                var _v = Q.pop();
                S.push(_v);
                if (weighted) for(var j = 0; j < A[_v].length; j++){
                    var w = A[_v][j];
                    var vEle = cy.getElementById(_v);
                    var edge = undefined;
                    if (vEle.edgesTo(w).length > 0) edge = vEle.edgesTo(w)[0];
                    else edge = w.edgesTo(vEle)[0];
                    var edgeWeight = weight(edge);
                    w = w.id();
                    if (d[w] > d[_v] + edgeWeight) {
                        d[w] = d[_v] + edgeWeight;
                        if (Q.nodes.indexOf(w) < 0) //if w is not in Q
                        Q.push(w);
                        else // update position if w is in Q
                        Q.updateItem(w);
                        g[w] = 0;
                        P[w] = [];
                    }
                    if (d[w] == d[_v] + edgeWeight) {
                        g[w] = g[w] + g[_v];
                        P[w].push(_v);
                    }
                }
                else for(var _j = 0; _j < A[_v].length; _j++){
                    var _w = A[_v][_j].id();
                    if (d[_w] == Infinity) {
                        Q.push(_w);
                        d[_w] = d[_v] + 1;
                    }
                    if (d[_w] == d[_v] + 1) {
                        g[_w] = g[_w] + g[_v];
                        P[_w].push(_v);
                    }
                }
            }
            var e = {};
            for(var _i2 = 0; _i2 < V.length; _i2++)e[V[_i2].id()] = 0;
            while(S.length > 0){
                var _w2 = S.pop();
                for(var _j2 = 0; _j2 < P[_w2].length; _j2++){
                    var _v2 = P[_w2][_j2];
                    e[_v2] = e[_v2] + g[_v2] / g[_w2] * (1 + e[_w2]);
                }
                if (_w2 != V[s].id()) C.set(_w2, C.get(_w2) + e[_w2]);
            }
        };
        for(var s = 0; s < V.length; s++)_loop();
        var ret = {
            betweenness: function betweenness(node) {
                var id = cy.collection(node).id();
                return C.get(id);
            },
            betweennessNormalized: function betweennessNormalized(node) {
                if (max == 0) return 0;
                var id = cy.collection(node).id();
                return C.get(id) / max;
            }
        };
        // alias
        ret.betweennessNormalised = ret.betweennessNormalized;
        return ret;
    } // betweennessCentrality
}; // elesfn
// nice, short mathematical alias
$e815fda779bc047b$var$elesfn$l.bc = $e815fda779bc047b$var$elesfn$l.betweennessCentrality;
// Implemented by Zoe Xi @zoexi for GSOC 2016
// https://github.com/cytoscape/cytoscape.js-markov-cluster
/* eslint-disable no-unused-vars */ var $e815fda779bc047b$var$defaults$c = $e815fda779bc047b$var$defaults$g({
    expandFactor: 2,
    // affects time of computation and cluster granularity to some extent: M * M
    inflateFactor: 2,
    // affects cluster granularity (the greater the value, the more clusters): M(i,j) / E(j)
    multFactor: 1,
    // optional self loops for each node. Use a neutral value to improve cluster computations.
    maxIterations: 20,
    // maximum number of iterations of the MCL algorithm in a single run
    attributes: [
        // attributes/features used to group nodes, ie. similarity values between nodes
        function(edge) {
            return 1;
        }
    ]
});
/* eslint-enable */ var $e815fda779bc047b$var$setOptions$3 = function setOptions(options) {
    return $e815fda779bc047b$var$defaults$c(options);
};
/* eslint-enable */ var $e815fda779bc047b$var$getSimilarity$1 = function getSimilarity(edge, attributes) {
    var total = 0;
    for(var i = 0; i < attributes.length; i++)total += attributes[i](edge);
    return total;
};
var $e815fda779bc047b$var$addLoops = function addLoops(M, n, val) {
    for(var i = 0; i < n; i++)M[i * n + i] = val;
};
var $e815fda779bc047b$var$normalize = function normalize(M, n) {
    var sum;
    for(var col = 0; col < n; col++){
        sum = 0;
        for(var row = 0; row < n; row++)sum += M[row * n + col];
        for(var _row = 0; _row < n; _row++)M[_row * n + col] = M[_row * n + col] / sum;
    }
};
// TODO: blocked matrix multiplication?
var $e815fda779bc047b$var$mmult = function mmult(A, B, n) {
    var C = new Array(n * n);
    for(var i = 0; i < n; i++){
        for(var j = 0; j < n; j++)C[i * n + j] = 0;
        for(var k = 0; k < n; k++)for(var _j = 0; _j < n; _j++)C[i * n + _j] += A[i * n + k] * B[k * n + _j];
    }
    return C;
};
var $e815fda779bc047b$var$expand = function expand(M, n, expandFactor /** power **/ ) {
    var _M = M.slice(0);
    for(var p = 1; p < expandFactor; p++)M = $e815fda779bc047b$var$mmult(M, _M, n);
    return M;
};
var $e815fda779bc047b$var$inflate = function inflate(M, n, inflateFactor /** r **/ ) {
    var _M = new Array(n * n);
    // M(i,j) ^ inflatePower
    for(var i = 0; i < n * n; i++)_M[i] = Math.pow(M[i], inflateFactor);
    $e815fda779bc047b$var$normalize(_M, n);
    return _M;
};
var $e815fda779bc047b$var$hasConverged = function hasConverged(M, _M, n2, roundFactor) {
    // Check that both matrices have the same elements (i,j)
    for(var i = 0; i < n2; i++){
        var v1 = Math.round(M[i] * Math.pow(10, roundFactor)) / Math.pow(10, roundFactor); // truncate to 'roundFactor' decimal places
        var v2 = Math.round(_M[i] * Math.pow(10, roundFactor)) / Math.pow(10, roundFactor);
        if (v1 !== v2) return false;
    }
    return true;
};
var $e815fda779bc047b$var$assign$2 = function assign(M, n, nodes, cy) {
    var clusters = [];
    for(var i = 0; i < n; i++){
        var cluster = [];
        for(var j = 0; j < n; j++)// Row-wise attractors and elements that they attract belong in same cluster
        if (Math.round(M[i * n + j] * 1000) / 1000 > 0) cluster.push(nodes[j]);
        if (cluster.length !== 0) clusters.push(cy.collection(cluster));
    }
    return clusters;
};
var $e815fda779bc047b$var$isDuplicate = function isDuplicate(c1, c2) {
    for(var i = 0; i < c1.length; i++){
        if (!c2[i] || c1[i].id() !== c2[i].id()) return false;
    }
    return true;
};
var $e815fda779bc047b$var$removeDuplicates = function removeDuplicates(clusters) {
    for(var i = 0; i < clusters.length; i++){
        for(var j = 0; j < clusters.length; j++)if (i != j && $e815fda779bc047b$var$isDuplicate(clusters[i], clusters[j])) clusters.splice(j, 1);
    }
    return clusters;
};
var $e815fda779bc047b$var$markovClustering = function markovClustering(options) {
    var nodes = this.nodes();
    var edges = this.edges();
    var cy = this.cy();
    // Set parameters of algorithm:
    var opts = $e815fda779bc047b$var$setOptions$3(options);
    // Map each node to its position in node array
    var id2position = {};
    for(var i = 0; i < nodes.length; i++)id2position[nodes[i].id()] = i;
    // Generate stochastic matrix M from input graph G (should be symmetric/undirected)
    var n = nodes.length, n2 = n * n;
    var M = new Array(n2), _M;
    for(var _i = 0; _i < n2; _i++)M[_i] = 0;
    for(var e = 0; e < edges.length; e++){
        var edge = edges[e];
        var _i2 = id2position[edge.source().id()];
        var j = id2position[edge.target().id()];
        var sim = $e815fda779bc047b$var$getSimilarity$1(edge, opts.attributes);
        M[_i2 * n + j] += sim; // G should be symmetric and undirected
        M[j * n + _i2] += sim;
    }
    // Begin Markov cluster algorithm
    // Step 1: Add self loops to each node, ie. add multFactor to matrix diagonal
    $e815fda779bc047b$var$addLoops(M, n, opts.multFactor);
    // Step 2: M = normalize( M );
    $e815fda779bc047b$var$normalize(M, n);
    var isStillMoving = true;
    var iterations = 0;
    while(isStillMoving && iterations < opts.maxIterations){
        isStillMoving = false;
        // Step 3:
        _M = $e815fda779bc047b$var$expand(M, n, opts.expandFactor);
        // Step 4:
        M = $e815fda779bc047b$var$inflate(_M, n, opts.inflateFactor);
        // Step 5: check to see if ~steady state has been reached
        if (!$e815fda779bc047b$var$hasConverged(M, _M, n2, 4)) isStillMoving = true;
        iterations++;
    }
    // Build clusters from matrix
    var clusters = $e815fda779bc047b$var$assign$2(M, n, nodes, cy);
    // Remove duplicate clusters due to symmetry of graph and M matrix
    clusters = $e815fda779bc047b$var$removeDuplicates(clusters);
    return clusters;
};
var $e815fda779bc047b$var$markovClustering$1 = {
    markovClustering: $e815fda779bc047b$var$markovClustering,
    mcl: $e815fda779bc047b$var$markovClustering
};
// Common distance metrics for clustering algorithms
// https://en.wikipedia.org/wiki/Hierarchical_clustering#Metric
var $e815fda779bc047b$var$identity$1 = function identity(x) {
    return x;
};
var $e815fda779bc047b$var$absDiff = function absDiff(p, q) {
    return Math.abs(q - p);
};
var $e815fda779bc047b$var$addAbsDiff = function addAbsDiff(total, p, q) {
    return total + $e815fda779bc047b$var$absDiff(p, q);
};
var $e815fda779bc047b$var$addSquaredDiff = function addSquaredDiff(total, p, q) {
    return total + Math.pow(q - p, 2);
};
var $e815fda779bc047b$var$sqrt = function sqrt(x) {
    return Math.sqrt(x);
};
var $e815fda779bc047b$var$maxAbsDiff = function maxAbsDiff(currentMax, p, q) {
    return Math.max(currentMax, $e815fda779bc047b$var$absDiff(p, q));
};
var $e815fda779bc047b$var$getDistance = function getDistance(length, getP, getQ, init, visit) {
    var post = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : $e815fda779bc047b$var$identity$1;
    var ret = init;
    var p, q;
    for(var dim = 0; dim < length; dim++){
        p = getP(dim);
        q = getQ(dim);
        ret = visit(ret, p, q);
    }
    return post(ret);
};
var $e815fda779bc047b$var$distances = {
    euclidean: function euclidean(length, getP, getQ) {
        if (length >= 2) return $e815fda779bc047b$var$getDistance(length, getP, getQ, 0, $e815fda779bc047b$var$addSquaredDiff, $e815fda779bc047b$var$sqrt);
        else // for single attr case, more efficient to avoid sqrt
        return $e815fda779bc047b$var$getDistance(length, getP, getQ, 0, $e815fda779bc047b$var$addAbsDiff);
    },
    squaredEuclidean: function squaredEuclidean(length, getP, getQ) {
        return $e815fda779bc047b$var$getDistance(length, getP, getQ, 0, $e815fda779bc047b$var$addSquaredDiff);
    },
    manhattan: function manhattan(length, getP, getQ) {
        return $e815fda779bc047b$var$getDistance(length, getP, getQ, 0, $e815fda779bc047b$var$addAbsDiff);
    },
    max: function max(length, getP, getQ) {
        return $e815fda779bc047b$var$getDistance(length, getP, getQ, -Infinity, $e815fda779bc047b$var$maxAbsDiff);
    }
};
// in case the user accidentally doesn't use camel case
$e815fda779bc047b$var$distances['squared-euclidean'] = $e815fda779bc047b$var$distances['squaredEuclidean'];
$e815fda779bc047b$var$distances['squaredeuclidean'] = $e815fda779bc047b$var$distances['squaredEuclidean'];
function $e815fda779bc047b$var$clusteringDistance(method, length, getP, getQ, nodeP, nodeQ) {
    var impl;
    if ($e815fda779bc047b$var$fn$6(method)) impl = method;
    else impl = $e815fda779bc047b$var$distances[method] || $e815fda779bc047b$var$distances.euclidean;
    if (length === 0 && $e815fda779bc047b$var$fn$6(method)) return impl(nodeP, nodeQ);
    else return impl(length, getP, getQ, nodeP, nodeQ);
}
var $e815fda779bc047b$var$defaults$b = $e815fda779bc047b$var$defaults$g({
    k: 2,
    m: 2,
    sensitivityThreshold: 0.0001,
    distance: 'euclidean',
    maxIterations: 10,
    attributes: [],
    testMode: false,
    testCentroids: null
});
var $e815fda779bc047b$var$setOptions$2 = function setOptions(options) {
    return $e815fda779bc047b$var$defaults$b(options);
};
var $e815fda779bc047b$var$getDist = function getDist(type, node, centroid, attributes, mode) {
    var noNodeP = mode !== 'kMedoids';
    var getP = noNodeP ? function(i) {
        return centroid[i];
    } : function(i) {
        return attributes[i](centroid);
    };
    var getQ = function getQ(i) {
        return attributes[i](node);
    };
    var nodeP = centroid;
    var nodeQ = node;
    return $e815fda779bc047b$var$clusteringDistance(type, attributes.length, getP, getQ, nodeP, nodeQ);
};
var $e815fda779bc047b$var$randomCentroids = function randomCentroids(nodes, k, attributes) {
    var ndim = attributes.length;
    var min = new Array(ndim);
    var max = new Array(ndim);
    var centroids = new Array(k);
    var centroid = null;
    // Find min, max values for each attribute dimension
    for(var i = 0; i < ndim; i++){
        min[i] = nodes.min(attributes[i]).value;
        max[i] = nodes.max(attributes[i]).value;
    }
    // Build k centroids, each represented as an n-dim feature vector
    for(var c = 0; c < k; c++){
        centroid = [];
        for(var _i = 0; _i < ndim; _i++)centroid[_i] = Math.random() * (max[_i] - min[_i]) + min[_i]; // random initial value
        centroids[c] = centroid;
    }
    return centroids;
};
var $e815fda779bc047b$var$classify = function classify(node, centroids, distance, attributes, type) {
    var min = Infinity;
    var index = 0;
    for(var i = 0; i < centroids.length; i++){
        var dist = $e815fda779bc047b$var$getDist(distance, node, centroids[i], attributes, type);
        if (dist < min) {
            min = dist;
            index = i;
        }
    }
    return index;
};
var $e815fda779bc047b$var$buildCluster = function buildCluster(centroid, nodes, assignment) {
    var cluster = [];
    var node = null;
    for(var n = 0; n < nodes.length; n++){
        node = nodes[n];
        if (assignment[node.id()] === centroid) //console.log("Node " + node.id() + " is associated with medoid #: " + m);
        cluster.push(node);
    }
    return cluster;
};
var $e815fda779bc047b$var$haveValuesConverged = function haveValuesConverged(v1, v2, sensitivityThreshold) {
    return Math.abs(v2 - v1) <= sensitivityThreshold;
};
var $e815fda779bc047b$var$haveMatricesConverged = function haveMatricesConverged(v1, v2, sensitivityThreshold) {
    for(var i = 0; i < v1.length; i++)for(var j = 0; j < v1[i].length; j++){
        var diff = Math.abs(v1[i][j] - v2[i][j]);
        if (diff > sensitivityThreshold) return false;
    }
    return true;
};
var $e815fda779bc047b$var$seenBefore = function seenBefore(node, medoids, n) {
    for(var i = 0; i < n; i++){
        if (node === medoids[i]) return true;
    }
    return false;
};
var $e815fda779bc047b$var$randomMedoids = function randomMedoids(nodes, k) {
    var medoids = new Array(k);
    // For small data sets, the probability of medoid conflict is greater,
    // so we need to check to see if we've already seen or chose this node before.
    if (nodes.length < 50) // Randomly select k medoids from the n nodes
    for(var i = 0; i < k; i++){
        var node = nodes[Math.floor(Math.random() * nodes.length)];
        // If we've already chosen this node to be a medoid, don't choose it again (for small data sets).
        // Instead choose a different random node.
        while($e815fda779bc047b$var$seenBefore(node, medoids, i))node = nodes[Math.floor(Math.random() * nodes.length)];
        medoids[i] = node;
    }
    else // Relatively large data set, so pretty safe to not check and just select random nodes
    for(var _i2 = 0; _i2 < k; _i2++)medoids[_i2] = nodes[Math.floor(Math.random() * nodes.length)];
    return medoids;
};
var $e815fda779bc047b$var$findCost = function findCost(potentialNewMedoid, cluster, attributes) {
    var cost = 0;
    for(var n = 0; n < cluster.length; n++)cost += $e815fda779bc047b$var$getDist('manhattan', cluster[n], potentialNewMedoid, attributes, 'kMedoids');
    return cost;
};
var $e815fda779bc047b$var$kMeans = function kMeans(options) {
    var cy = this.cy();
    var nodes = this.nodes();
    var node = null;
    // Set parameters of algorithm: # of clusters, distance metric, etc.
    var opts = $e815fda779bc047b$var$setOptions$2(options);
    // Begin k-means algorithm
    var clusters = new Array(opts.k);
    var assignment = {};
    var centroids;
    // Step 1: Initialize centroid positions
    if (opts.testMode) {
        if (typeof opts.testCentroids === 'number') {
            // TODO: implement a seeded random number generator.
            opts.testCentroids;
            centroids = $e815fda779bc047b$var$randomCentroids(nodes, opts.k, opts.attributes);
        } else if ($e815fda779bc047b$var$_typeof(opts.testCentroids) === 'object') centroids = opts.testCentroids;
        else centroids = $e815fda779bc047b$var$randomCentroids(nodes, opts.k, opts.attributes);
    } else centroids = $e815fda779bc047b$var$randomCentroids(nodes, opts.k, opts.attributes);
    var isStillMoving = true;
    var iterations = 0;
    while(isStillMoving && iterations < opts.maxIterations){
        // Step 2: Assign nodes to the nearest centroid
        for(var n = 0; n < nodes.length; n++){
            node = nodes[n];
            // Determine which cluster this node belongs to: node id => cluster #
            assignment[node.id()] = $e815fda779bc047b$var$classify(node, centroids, opts.distance, opts.attributes, 'kMeans');
        }
        // Step 3: For each of the k clusters, update its centroid
        isStillMoving = false;
        for(var c = 0; c < opts.k; c++){
            // Get all nodes that belong to this cluster
            var cluster = $e815fda779bc047b$var$buildCluster(c, nodes, assignment);
            if (cluster.length === 0) continue;
            // Update centroids by calculating avg of all nodes within the cluster.
            var ndim = opts.attributes.length;
            var centroid = centroids[c]; // [ dim_1, dim_2, dim_3, ... , dim_n ]
            var newCentroid = new Array(ndim);
            var sum = new Array(ndim);
            for(var d = 0; d < ndim; d++){
                sum[d] = 0.0;
                for(var i = 0; i < cluster.length; i++){
                    node = cluster[i];
                    sum[d] += opts.attributes[d](node);
                }
                newCentroid[d] = sum[d] / cluster.length;
                // Check to see if algorithm has converged, i.e. when centroids no longer change
                if (!$e815fda779bc047b$var$haveValuesConverged(newCentroid[d], centroid[d], opts.sensitivityThreshold)) isStillMoving = true;
            }
            centroids[c] = newCentroid;
            clusters[c] = cy.collection(cluster);
        }
        iterations++;
    }
    return clusters;
};
var $e815fda779bc047b$var$kMedoids = function kMedoids(options) {
    var cy = this.cy();
    var nodes = this.nodes();
    var node = null;
    var opts = $e815fda779bc047b$var$setOptions$2(options);
    // Begin k-medoids algorithm
    var clusters = new Array(opts.k);
    var medoids;
    var assignment = {};
    var curCost;
    var minCosts = new Array(opts.k); // minimum cost configuration for each cluster
    // Step 1: Initialize k medoids
    if (opts.testMode) {
        if (typeof opts.testCentroids === 'number') ;
        else if ($e815fda779bc047b$var$_typeof(opts.testCentroids) === 'object') medoids = opts.testCentroids;
        else medoids = $e815fda779bc047b$var$randomMedoids(nodes, opts.k);
    } else medoids = $e815fda779bc047b$var$randomMedoids(nodes, opts.k);
    var isStillMoving = true;
    var iterations = 0;
    while(isStillMoving && iterations < opts.maxIterations){
        // Step 2: Assign nodes to the nearest medoid
        for(var n = 0; n < nodes.length; n++){
            node = nodes[n];
            // Determine which cluster this node belongs to: node id => cluster #
            assignment[node.id()] = $e815fda779bc047b$var$classify(node, medoids, opts.distance, opts.attributes, 'kMedoids');
        }
        isStillMoving = false;
        // Step 3: For each medoid m, and for each node associated with mediod m,
        // select the node with the lowest configuration cost as new medoid.
        for(var m1 = 0; m1 < medoids.length; m1++){
            // Get all nodes that belong to this medoid
            var cluster = $e815fda779bc047b$var$buildCluster(m1, nodes, assignment);
            if (cluster.length === 0) continue;
            minCosts[m1] = $e815fda779bc047b$var$findCost(medoids[m1], cluster, opts.attributes); // original cost
            // Select different medoid if its configuration has the lowest cost
            for(var _n = 0; _n < cluster.length; _n++){
                curCost = $e815fda779bc047b$var$findCost(cluster[_n], cluster, opts.attributes);
                if (curCost < minCosts[m1]) {
                    minCosts[m1] = curCost;
                    medoids[m1] = cluster[_n];
                    isStillMoving = true;
                }
            }
            clusters[m1] = cy.collection(cluster);
        }
        iterations++;
    }
    return clusters;
};
var $e815fda779bc047b$var$updateCentroids = function updateCentroids(centroids, nodes, U, weight, opts) {
    var numerator, denominator;
    for(var n = 0; n < nodes.length; n++)for(var c = 0; c < centroids.length; c++)weight[n][c] = Math.pow(U[n][c], opts.m);
    for(var _c = 0; _c < centroids.length; _c++)for(var dim = 0; dim < opts.attributes.length; dim++){
        numerator = 0;
        denominator = 0;
        for(var _n2 = 0; _n2 < nodes.length; _n2++){
            numerator += weight[_n2][_c] * opts.attributes[dim](nodes[_n2]);
            denominator += weight[_n2][_c];
        }
        centroids[_c][dim] = numerator / denominator;
    }
};
var $e815fda779bc047b$var$updateMembership = function updateMembership(U, _U, centroids, nodes, opts) {
    // Save previous step
    for(var i = 0; i < U.length; i++)_U[i] = U[i].slice();
    var sum, numerator, denominator;
    var pow = 2 / (opts.m - 1);
    for(var c = 0; c < centroids.length; c++)for(var n = 0; n < nodes.length; n++){
        sum = 0;
        for(var k = 0; k < centroids.length; k++){
            // against all other centroids
            numerator = $e815fda779bc047b$var$getDist(opts.distance, nodes[n], centroids[c], opts.attributes, 'cmeans');
            denominator = $e815fda779bc047b$var$getDist(opts.distance, nodes[n], centroids[k], opts.attributes, 'cmeans');
            sum += Math.pow(numerator / denominator, pow);
        }
        U[n][c] = 1 / sum;
    }
};
var $e815fda779bc047b$var$assign$1 = function assign(nodes, U, opts, cy) {
    var clusters = new Array(opts.k);
    for(var c = 0; c < clusters.length; c++)clusters[c] = [];
    var max;
    var index;
    for(var n = 0; n < U.length; n++){
        // for each node (U is N x C matrix)
        max = -Infinity;
        index = -1;
        // Determine which cluster the node is most likely to belong in
        for(var _c2 = 0; _c2 < U[0].length; _c2++)if (U[n][_c2] > max) {
            max = U[n][_c2];
            index = _c2;
        }
        clusters[index].push(nodes[n]);
    }
    // Turn every array into a collection of nodes
    for(var _c3 = 0; _c3 < clusters.length; _c3++)clusters[_c3] = cy.collection(clusters[_c3]);
    return clusters;
};
var $e815fda779bc047b$var$fuzzyCMeans = function fuzzyCMeans(options) {
    var cy = this.cy();
    var nodes = this.nodes();
    var opts = $e815fda779bc047b$var$setOptions$2(options);
    // Begin fuzzy c-means algorithm
    var clusters;
    var centroids;
    var U;
    var _U;
    var weight;
    // Step 1: Initialize letiables.
    _U = new Array(nodes.length);
    for(var i = 0; i < nodes.length; i++)// N x C matrix
    _U[i] = new Array(opts.k);
    U = new Array(nodes.length);
    for(var _i3 = 0; _i3 < nodes.length; _i3++)// N x C matrix
    U[_i3] = new Array(opts.k);
    for(var _i4 = 0; _i4 < nodes.length; _i4++){
        var total = 0;
        for(var j = 0; j < opts.k; j++){
            U[_i4][j] = Math.random();
            total += U[_i4][j];
        }
        for(var _j = 0; _j < opts.k; _j++)U[_i4][_j] = U[_i4][_j] / total;
    }
    centroids = new Array(opts.k);
    for(var _i5 = 0; _i5 < opts.k; _i5++)centroids[_i5] = new Array(opts.attributes.length);
    weight = new Array(nodes.length);
    for(var _i6 = 0; _i6 < nodes.length; _i6++)// N x C matrix
    weight[_i6] = new Array(opts.k);
    // end init FCM
    var isStillMoving = true;
    var iterations = 0;
    while(isStillMoving && iterations < opts.maxIterations){
        isStillMoving = false;
        // Step 2: Calculate the centroids for each step.
        $e815fda779bc047b$var$updateCentroids(centroids, nodes, U, weight, opts);
        // Step 3: Update the partition matrix U.
        $e815fda779bc047b$var$updateMembership(U, _U, centroids, nodes, opts);
        // Step 4: Check for convergence.
        if (!$e815fda779bc047b$var$haveMatricesConverged(U, _U, opts.sensitivityThreshold)) isStillMoving = true;
        iterations++;
    }
    // Assign nodes to clusters with highest probability.
    clusters = $e815fda779bc047b$var$assign$1(nodes, U, opts, cy);
    return {
        clusters: clusters,
        degreeOfMembership: U
    };
};
var $e815fda779bc047b$var$kClustering = {
    kMeans: $e815fda779bc047b$var$kMeans,
    kMedoids: $e815fda779bc047b$var$kMedoids,
    fuzzyCMeans: $e815fda779bc047b$var$fuzzyCMeans,
    fcm: $e815fda779bc047b$var$fuzzyCMeans
};
// Implemented by Zoe Xi @zoexi for GSOC 2016
// https://github.com/cytoscape/cytoscape.js-hierarchical
var $e815fda779bc047b$var$defaults$a = $e815fda779bc047b$var$defaults$g({
    distance: 'euclidean',
    // distance metric to compare nodes
    linkage: 'min',
    // linkage criterion : how to determine the distance between clusters of nodes
    mode: 'threshold',
    // mode:'threshold' => clusters must be threshold distance apart
    threshold: Infinity,
    // the distance threshold
    // mode:'dendrogram' => the nodes are organised as leaves in a tree (siblings are close), merging makes clusters
    addDendrogram: false,
    // whether to add the dendrogram to the graph for viz
    dendrogramDepth: 0,
    // depth at which dendrogram branches are merged into the returned clusters
    attributes: [] // array of attr functions
});
var $e815fda779bc047b$var$linkageAliases = {
    'single': 'min',
    'complete': 'max'
};
var $e815fda779bc047b$var$setOptions$1 = function setOptions(options) {
    var opts = $e815fda779bc047b$var$defaults$a(options);
    var preferredAlias = $e815fda779bc047b$var$linkageAliases[opts.linkage];
    if (preferredAlias != null) opts.linkage = preferredAlias;
    return opts;
};
var $e815fda779bc047b$var$mergeClosest = function mergeClosest(clusters, index, dists, mins, opts) {
    // Find two closest clusters from cached mins
    var minKey = 0;
    var min = Infinity;
    var dist;
    var attrs = opts.attributes;
    var getDist = function getDist(n1, n2) {
        return $e815fda779bc047b$var$clusteringDistance(opts.distance, attrs.length, function(i) {
            return attrs[i](n1);
        }, function(i) {
            return attrs[i](n2);
        }, n1, n2);
    };
    for(var i = 0; i < clusters.length; i++){
        var key = clusters[i].key;
        var _dist = dists[key][mins[key]];
        if (_dist < min) {
            minKey = key;
            min = _dist;
        }
    }
    if (opts.mode === 'threshold' && min >= opts.threshold || opts.mode === 'dendrogram' && clusters.length === 1) return false;
    var c1 = index[minKey];
    var c2 = index[mins[minKey]];
    var merged;
    // Merge two closest clusters
    if (opts.mode === 'dendrogram') merged = {
        left: c1,
        right: c2,
        key: c1.key
    };
    else merged = {
        value: c1.value.concat(c2.value),
        key: c1.key
    };
    clusters[c1.index] = merged;
    clusters.splice(c2.index, 1);
    index[c1.key] = merged;
    // Update distances with new merged cluster
    for(var _i = 0; _i < clusters.length; _i++){
        var cur = clusters[_i];
        if (c1.key === cur.key) dist = Infinity;
        else if (opts.linkage === 'min') {
            dist = dists[c1.key][cur.key];
            if (dists[c1.key][cur.key] > dists[c2.key][cur.key]) dist = dists[c2.key][cur.key];
        } else if (opts.linkage === 'max') {
            dist = dists[c1.key][cur.key];
            if (dists[c1.key][cur.key] < dists[c2.key][cur.key]) dist = dists[c2.key][cur.key];
        } else if (opts.linkage === 'mean') dist = (dists[c1.key][cur.key] * c1.size + dists[c2.key][cur.key] * c2.size) / (c1.size + c2.size);
        else if (opts.mode === 'dendrogram') dist = getDist(cur.value, c1.value);
        else dist = getDist(cur.value[0], c1.value[0]);
        dists[c1.key][cur.key] = dists[cur.key][c1.key] = dist; // distance matrix is symmetric
    }
    // Update cached mins
    for(var _i2 = 0; _i2 < clusters.length; _i2++){
        var key1 = clusters[_i2].key;
        if (mins[key1] === c1.key || mins[key1] === c2.key) {
            var _min = key1;
            for(var j = 0; j < clusters.length; j++){
                var key2 = clusters[j].key;
                if (dists[key1][key2] < dists[key1][_min]) _min = key2;
            }
            mins[key1] = _min;
        }
        clusters[_i2].index = _i2;
    }
    // Clean up meta data used for clustering
    c1.key = c2.key = c1.index = c2.index = null;
    return true;
};
var $e815fda779bc047b$var$_getAllChildren = function getAllChildren(root, arr, cy) {
    if (!root) return;
    if (root.value) arr.push(root.value);
    else {
        if (root.left) $e815fda779bc047b$var$_getAllChildren(root.left, arr);
        if (root.right) $e815fda779bc047b$var$_getAllChildren(root.right, arr);
    }
};
var $e815fda779bc047b$var$_buildDendrogram = function buildDendrogram(root, cy) {
    if (!root) return '';
    if (root.left && root.right) {
        var leftStr = $e815fda779bc047b$var$_buildDendrogram(root.left, cy);
        var rightStr = $e815fda779bc047b$var$_buildDendrogram(root.right, cy);
        var node = cy.add({
            group: 'nodes',
            data: {
                id: leftStr + ',' + rightStr
            }
        });
        cy.add({
            group: 'edges',
            data: {
                source: leftStr,
                target: node.id()
            }
        });
        cy.add({
            group: 'edges',
            data: {
                source: rightStr,
                target: node.id()
            }
        });
        return node.id();
    } else if (root.value) return root.value.id();
};
var $e815fda779bc047b$var$_buildClustersFromTree = function buildClustersFromTree(root, k, cy) {
    if (!root) return [];
    var left = [], right = [], leaves = [];
    if (k === 0) {
        // don't cut tree, simply return all nodes as 1 single cluster
        if (root.left) $e815fda779bc047b$var$_getAllChildren(root.left, left);
        if (root.right) $e815fda779bc047b$var$_getAllChildren(root.right, right);
        leaves = left.concat(right);
        return [
            cy.collection(leaves)
        ];
    } else if (k === 1) {
        // cut at root
        if (root.value) // leaf node
        return [
            cy.collection(root.value)
        ];
        else {
            if (root.left) $e815fda779bc047b$var$_getAllChildren(root.left, left);
            if (root.right) $e815fda779bc047b$var$_getAllChildren(root.right, right);
            return [
                cy.collection(left),
                cy.collection(right)
            ];
        }
    } else {
        if (root.value) return [
            cy.collection(root.value)
        ];
        else {
            if (root.left) left = $e815fda779bc047b$var$_buildClustersFromTree(root.left, k - 1, cy);
            if (root.right) right = $e815fda779bc047b$var$_buildClustersFromTree(root.right, k - 1, cy);
            return left.concat(right);
        }
    }
};
var $e815fda779bc047b$var$hierarchicalClustering = function hierarchicalClustering(options) {
    var cy = this.cy();
    var nodes = this.nodes();
    // Set parameters of algorithm: linkage type, distance metric, etc.
    var opts = $e815fda779bc047b$var$setOptions$1(options);
    var attrs = opts.attributes;
    var getDist = function getDist(n1, n2) {
        return $e815fda779bc047b$var$clusteringDistance(opts.distance, attrs.length, function(i) {
            return attrs[i](n1);
        }, function(i) {
            return attrs[i](n2);
        }, n1, n2);
    };
    // Begin hierarchical algorithm
    var clusters = [];
    var dists = []; // distances between each pair of clusters
    var mins = []; // closest cluster for each cluster
    var index = []; // hash of all clusters by key
    // In agglomerative (bottom-up) clustering, each node starts as its own cluster
    for(var n = 0; n < nodes.length; n++){
        var cluster = {
            value: opts.mode === 'dendrogram' ? nodes[n] : [
                nodes[n]
            ],
            key: n,
            index: n
        };
        clusters[n] = cluster;
        index[n] = cluster;
        dists[n] = [];
        mins[n] = 0;
    }
    // Calculate the distance between each pair of clusters
    for(var i = 0; i < clusters.length; i++)for(var j = 0; j <= i; j++){
        var dist = undefined;
        if (opts.mode === 'dendrogram') // modes store cluster values differently
        dist = i === j ? Infinity : getDist(clusters[i].value, clusters[j].value);
        else dist = i === j ? Infinity : getDist(clusters[i].value[0], clusters[j].value[0]);
        dists[i][j] = dist;
        dists[j][i] = dist;
        if (dist < dists[i][mins[i]]) mins[i] = j; // Cache mins: closest cluster to cluster i is cluster j
    }
    // Find the closest pair of clusters and merge them into a single cluster.
    // Update distances between new cluster and each of the old clusters, and loop until threshold reached.
    var merged = $e815fda779bc047b$var$mergeClosest(clusters, index, dists, mins, opts);
    while(merged)merged = $e815fda779bc047b$var$mergeClosest(clusters, index, dists, mins, opts);
    var retClusters;
    // Dendrogram mode builds the hierarchy and adds intermediary nodes + edges
    // in addition to returning the clusters.
    if (opts.mode === 'dendrogram') {
        retClusters = $e815fda779bc047b$var$_buildClustersFromTree(clusters[0], opts.dendrogramDepth, cy);
        if (opts.addDendrogram) $e815fda779bc047b$var$_buildDendrogram(clusters[0], cy);
    } else {
        // Regular mode simply returns the clusters
        retClusters = new Array(clusters.length);
        clusters.forEach(function(cluster, i) {
            // Clean up meta data used for clustering
            cluster.key = cluster.index = null;
            retClusters[i] = cy.collection(cluster.value);
        });
    }
    return retClusters;
};
var $e815fda779bc047b$var$hierarchicalClustering$1 = {
    hierarchicalClustering: $e815fda779bc047b$var$hierarchicalClustering,
    hca: $e815fda779bc047b$var$hierarchicalClustering
};
// Implemented by Zoe Xi @zoexi for GSOC 2016
// https://github.com/cytoscape/cytoscape.js-affinity-propagation
var $e815fda779bc047b$var$defaults$9 = $e815fda779bc047b$var$defaults$g({
    distance: 'euclidean',
    // distance metric to compare attributes between two nodes
    preference: 'median',
    // suitability of a data point to serve as an exemplar
    damping: 0.8,
    // damping factor between [0.5, 1)
    maxIterations: 1000,
    // max number of iterations to run
    minIterations: 100,
    // min number of iterations to run in order for clustering to stop
    attributes: []
});
var $e815fda779bc047b$var$setOptions = function setOptions(options) {
    var dmp = options.damping;
    var pref = options.preference;
    if (!(0.5 <= dmp && dmp < 1)) $e815fda779bc047b$var$error("Damping must range on [0.5, 1).  Got: ".concat(dmp));
    var validPrefs = [
        'median',
        'mean',
        'min',
        'max'
    ];
    if (!(validPrefs.some(function(v) {
        return v === pref;
    }) || $e815fda779bc047b$var$number$1(pref))) $e815fda779bc047b$var$error("Preference must be one of [".concat(validPrefs.map(function(p) {
        return "'".concat(p, "'");
    }).join(', '), "] or a number.  Got: ").concat(pref));
    return $e815fda779bc047b$var$defaults$9(options);
};
var $e815fda779bc047b$var$getSimilarity = function getSimilarity(type, n1, n2, attributes) {
    var attr = function attr(n, i) {
        return attributes[i](n);
    };
    // nb negative because similarity should have an inverse relationship to distance
    return -$e815fda779bc047b$var$clusteringDistance(type, attributes.length, function(i) {
        return attr(n1, i);
    }, function(i) {
        return attr(n2, i);
    }, n1, n2);
};
var $e815fda779bc047b$var$getPreference = function getPreference(S, preference) {
    // larger preference = greater # of clusters
    var p = null;
    if (preference === 'median') p = $e815fda779bc047b$var$median(S);
    else if (preference === 'mean') p = $e815fda779bc047b$var$mean(S);
    else if (preference === 'min') p = $e815fda779bc047b$var$min(S);
    else if (preference === 'max') p = $e815fda779bc047b$var$max(S);
    else // Custom preference number, as set by user
    p = preference;
    return p;
};
var $e815fda779bc047b$var$findExemplars = function findExemplars(n, R, A) {
    var indices = [];
    for(var i = 0; i < n; i++)if (R[i * n + i] + A[i * n + i] > 0) indices.push(i);
    return indices;
};
var $e815fda779bc047b$var$assignClusters = function assignClusters(n, S, exemplars) {
    var clusters = [];
    for(var i = 0; i < n; i++){
        var index = -1;
        var max = -Infinity;
        for(var ei = 0; ei < exemplars.length; ei++){
            var e = exemplars[ei];
            if (S[i * n + e] > max) {
                index = e;
                max = S[i * n + e];
            }
        }
        if (index > 0) clusters.push(index);
    }
    for(var _ei = 0; _ei < exemplars.length; _ei++)clusters[exemplars[_ei]] = exemplars[_ei];
    return clusters;
};
var $e815fda779bc047b$var$assign = function assign(n, S, exemplars) {
    var clusters = $e815fda779bc047b$var$assignClusters(n, S, exemplars);
    for(var ei = 0; ei < exemplars.length; ei++){
        var ii = [];
        for(var c = 0; c < clusters.length; c++)if (clusters[c] === exemplars[ei]) ii.push(c);
        var maxI = -1;
        var maxSum = -Infinity;
        for(var i = 0; i < ii.length; i++){
            var sum = 0;
            for(var j = 0; j < ii.length; j++)sum += S[ii[j] * n + ii[i]];
            if (sum > maxSum) {
                maxI = i;
                maxSum = sum;
            }
        }
        exemplars[ei] = ii[maxI];
    }
    clusters = $e815fda779bc047b$var$assignClusters(n, S, exemplars);
    return clusters;
};
var $e815fda779bc047b$var$affinityPropagation = function affinityPropagation(options) {
    var cy = this.cy();
    var nodes = this.nodes();
    var opts = $e815fda779bc047b$var$setOptions(options);
    // Map each node to its position in node array
    var id2position = {};
    for(var i = 0; i < nodes.length; i++)id2position[nodes[i].id()] = i;
    // Begin affinity propagation algorithm
    var n; // number of data points
    var n2; // size of matrices
    var S; // similarity matrix (1D array)
    var p; // preference/suitability of a data point to serve as an exemplar
    var R; // responsibility matrix (1D array)
    var A; // availability matrix (1D array)
    n = nodes.length;
    n2 = n * n;
    // Initialize and build S similarity matrix
    S = new Array(n2);
    for(var _i = 0; _i < n2; _i++)S[_i] = -Infinity; // for cases where two data points shouldn't be linked together
    for(var _i2 = 0; _i2 < n; _i2++){
        for(var j = 0; j < n; j++)if (_i2 !== j) S[_i2 * n + j] = $e815fda779bc047b$var$getSimilarity(opts.distance, nodes[_i2], nodes[j], opts.attributes);
    }
    // Place preferences on the diagonal of S
    p = $e815fda779bc047b$var$getPreference(S, opts.preference);
    for(var _i3 = 0; _i3 < n; _i3++)S[_i3 * n + _i3] = p;
    // Initialize R responsibility matrix
    R = new Array(n2);
    for(var _i4 = 0; _i4 < n2; _i4++)R[_i4] = 0.0;
    // Initialize A availability matrix
    A = new Array(n2);
    for(var _i5 = 0; _i5 < n2; _i5++)A[_i5] = 0.0;
    var old = new Array(n);
    var Rp = new Array(n);
    var se = new Array(n);
    for(var _i6 = 0; _i6 < n; _i6++){
        old[_i6] = 0.0;
        Rp[_i6] = 0.0;
        se[_i6] = 0;
    }
    var e = new Array(n * opts.minIterations);
    for(var _i7 = 0; _i7 < e.length; _i7++)e[_i7] = 0;
    var iter;
    for(iter = 0; iter < opts.maxIterations; iter++){
        // main algorithmic loop
        // Update R responsibility matrix
        for(var _i8 = 0; _i8 < n; _i8++){
            var max = -Infinity, max2 = -Infinity, maxI = -1, AS = 0.0;
            for(var _j = 0; _j < n; _j++){
                old[_j] = R[_i8 * n + _j];
                AS = A[_i8 * n + _j] + S[_i8 * n + _j];
                if (AS >= max) {
                    max2 = max;
                    max = AS;
                    maxI = _j;
                } else if (AS > max2) max2 = AS;
            }
            for(var _j2 = 0; _j2 < n; _j2++)R[_i8 * n + _j2] = (1 - opts.damping) * (S[_i8 * n + _j2] - max) + opts.damping * old[_j2];
            R[_i8 * n + maxI] = (1 - opts.damping) * (S[_i8 * n + maxI] - max2) + opts.damping * old[maxI];
        }
        // Update A availability matrix
        for(var _i9 = 0; _i9 < n; _i9++){
            var sum = 0;
            for(var _j3 = 0; _j3 < n; _j3++){
                old[_j3] = A[_j3 * n + _i9];
                Rp[_j3] = Math.max(0, R[_j3 * n + _i9]);
                sum += Rp[_j3];
            }
            sum -= Rp[_i9];
            Rp[_i9] = R[_i9 * n + _i9];
            sum += Rp[_i9];
            for(var _j4 = 0; _j4 < n; _j4++)A[_j4 * n + _i9] = (1 - opts.damping) * Math.min(0, sum - Rp[_j4]) + opts.damping * old[_j4];
            A[_i9 * n + _i9] = (1 - opts.damping) * (sum - Rp[_i9]) + opts.damping * old[_i9];
        }
        // Check for convergence
        var K = 0;
        for(var _i10 = 0; _i10 < n; _i10++){
            var E = A[_i10 * n + _i10] + R[_i10 * n + _i10] > 0 ? 1 : 0;
            e[iter % opts.minIterations * n + _i10] = E;
            K += E;
        }
        if (K > 0 && (iter >= opts.minIterations - 1 || iter == opts.maxIterations - 1)) {
            var _sum = 0;
            for(var _i11 = 0; _i11 < n; _i11++){
                se[_i11] = 0;
                for(var _j5 = 0; _j5 < opts.minIterations; _j5++)se[_i11] += e[_j5 * n + _i11];
                if (se[_i11] === 0 || se[_i11] === opts.minIterations) _sum++;
            }
            if (_sum === n) break;
        }
    }
    // Identify exemplars (cluster centers)
    var exemplarsIndices = $e815fda779bc047b$var$findExemplars(n, R, A);
    // Assign nodes to clusters
    var clusterIndices = $e815fda779bc047b$var$assign(n, S, exemplarsIndices);
    var clusters = {};
    for(var c = 0; c < exemplarsIndices.length; c++)clusters[exemplarsIndices[c]] = [];
    for(var _i12 = 0; _i12 < nodes.length; _i12++){
        var pos = id2position[nodes[_i12].id()];
        var clusterIndex = clusterIndices[pos];
        if (clusterIndex != null) // the node may have not been assigned a cluster if no valid attributes were specified
        clusters[clusterIndex].push(nodes[_i12]);
    }
    var retClusters = new Array(exemplarsIndices.length);
    for(var _c = 0; _c < exemplarsIndices.length; _c++)retClusters[_c] = cy.collection(clusters[exemplarsIndices[_c]]);
    return retClusters;
};
var $e815fda779bc047b$var$affinityPropagation$1 = {
    affinityPropagation: $e815fda779bc047b$var$affinityPropagation,
    ap: $e815fda779bc047b$var$affinityPropagation
};
var $e815fda779bc047b$var$hierholzerDefaults = $e815fda779bc047b$var$defaults$g({
    root: undefined,
    directed: false
});
var $e815fda779bc047b$var$elesfn$k = {
    hierholzer: function hierholzer(options) {
        if (!$e815fda779bc047b$var$plainObject(options)) {
            var args = arguments;
            options = {
                root: args[0],
                directed: args[1]
            };
        }
        var _hierholzerDefaults = $e815fda779bc047b$var$hierholzerDefaults(options), root = _hierholzerDefaults.root, directed = _hierholzerDefaults.directed;
        var eles = this;
        var dflag = false;
        var oddIn;
        var oddOut;
        var startVertex;
        if (root) startVertex = $e815fda779bc047b$var$string(root) ? this.filter(root)[0].id() : root[0].id();
        var nodes = {};
        var edges = {};
        if (directed) eles.forEach(function(ele) {
            var id = ele.id();
            if (ele.isNode()) {
                var ind = ele.indegree(true);
                var outd = ele.outdegree(true);
                var d1 = ind - outd;
                var d2 = outd - ind;
                if (d1 == 1) {
                    if (oddIn) dflag = true;
                    else oddIn = id;
                } else if (d2 == 1) {
                    if (oddOut) dflag = true;
                    else oddOut = id;
                } else if (d2 > 1 || d1 > 1) dflag = true;
                nodes[id] = [];
                ele.outgoers().forEach(function(e) {
                    if (e.isEdge()) nodes[id].push(e.id());
                });
            } else edges[id] = [
                undefined,
                ele.target().id()
            ];
        });
        else eles.forEach(function(ele) {
            var id = ele.id();
            if (ele.isNode()) {
                var d = ele.degree(true);
                if (d % 2) {
                    if (!oddIn) oddIn = id;
                    else if (!oddOut) oddOut = id;
                    else dflag = true;
                }
                nodes[id] = [];
                ele.connectedEdges().forEach(function(e) {
                    return nodes[id].push(e.id());
                });
            } else edges[id] = [
                ele.source().id(),
                ele.target().id()
            ];
        });
        var result = {
            found: false,
            trail: undefined
        };
        if (dflag) return result;
        else if (oddOut && oddIn) {
            if (directed) {
                if (startVertex && oddOut != startVertex) return result;
                startVertex = oddOut;
            } else {
                if (startVertex && oddOut != startVertex && oddIn != startVertex) return result;
                else if (!startVertex) startVertex = oddOut;
            }
        } else if (!startVertex) startVertex = eles[0].id();
        var walk = function walk(v) {
            var currentNode = v;
            var subtour = [
                v
            ];
            var adj, adjTail, adjHead;
            while(nodes[currentNode].length){
                adj = nodes[currentNode].shift();
                adjTail = edges[adj][0];
                adjHead = edges[adj][1];
                if (currentNode != adjHead) {
                    nodes[adjHead] = nodes[adjHead].filter(function(e) {
                        return e != adj;
                    });
                    currentNode = adjHead;
                } else if (!directed && currentNode != adjTail) {
                    nodes[adjTail] = nodes[adjTail].filter(function(e) {
                        return e != adj;
                    });
                    currentNode = adjTail;
                }
                subtour.unshift(adj);
                subtour.unshift(currentNode);
            }
            return subtour;
        };
        var trail = [];
        var subtour = [];
        subtour = walk(startVertex);
        while(subtour.length != 1)if (nodes[subtour[0]].length == 0) {
            trail.unshift(eles.getElementById(subtour.shift()));
            trail.unshift(eles.getElementById(subtour.shift()));
        } else subtour = walk(subtour.shift()).concat(subtour);
        trail.unshift(eles.getElementById(subtour.shift())); // final node
        for(var d in nodes){
            if (nodes[d].length) return result;
        }
        result.found = true;
        result.trail = this.spawn(trail, true);
        return result;
    }
};
var $e815fda779bc047b$var$hopcroftTarjanBiconnected = function hopcroftTarjanBiconnected() {
    var eles = this;
    var nodes = {};
    var id = 0;
    var edgeCount = 0;
    var components = [];
    var stack = [];
    var visitedEdges = {};
    var buildComponent = function buildComponent(x, y) {
        var i = stack.length - 1;
        var cutset = [];
        var component = eles.spawn();
        while(stack[i].x != x || stack[i].y != y){
            cutset.push(stack.pop().edge);
            i--;
        }
        cutset.push(stack.pop().edge);
        cutset.forEach(function(edge) {
            var connectedNodes = edge.connectedNodes().intersection(eles);
            component.merge(edge);
            connectedNodes.forEach(function(node) {
                var nodeId = node.id();
                var connectedEdges = node.connectedEdges().intersection(eles);
                component.merge(node);
                if (!nodes[nodeId].cutVertex) component.merge(connectedEdges);
                else component.merge(connectedEdges.filter(function(edge) {
                    return edge.isLoop();
                }));
            });
        });
        components.push(component);
    };
    var _biconnectedSearch = function biconnectedSearch(root, currentNode, parent) {
        if (root === parent) edgeCount += 1;
        nodes[currentNode] = {
            id: id,
            low: id++,
            cutVertex: false
        };
        var edges = eles.getElementById(currentNode).connectedEdges().intersection(eles);
        if (edges.size() === 0) components.push(eles.spawn(eles.getElementById(currentNode)));
        else {
            var sourceId, targetId, otherNodeId, edgeId;
            edges.forEach(function(edge) {
                sourceId = edge.source().id();
                targetId = edge.target().id();
                otherNodeId = sourceId === currentNode ? targetId : sourceId;
                if (otherNodeId !== parent) {
                    edgeId = edge.id();
                    if (!visitedEdges[edgeId]) {
                        visitedEdges[edgeId] = true;
                        stack.push({
                            x: currentNode,
                            y: otherNodeId,
                            edge: edge
                        });
                    }
                    if (!(otherNodeId in nodes)) {
                        _biconnectedSearch(root, otherNodeId, currentNode);
                        nodes[currentNode].low = Math.min(nodes[currentNode].low, nodes[otherNodeId].low);
                        if (nodes[currentNode].id <= nodes[otherNodeId].low) {
                            nodes[currentNode].cutVertex = true;
                            buildComponent(currentNode, otherNodeId);
                        }
                    } else nodes[currentNode].low = Math.min(nodes[currentNode].low, nodes[otherNodeId].id);
                }
            });
        }
    };
    eles.forEach(function(ele) {
        if (ele.isNode()) {
            var nodeId = ele.id();
            if (!(nodeId in nodes)) {
                edgeCount = 0;
                _biconnectedSearch(nodeId, nodeId);
                nodes[nodeId].cutVertex = edgeCount > 1;
            }
        }
    });
    var cutVertices = Object.keys(nodes).filter(function(id) {
        return nodes[id].cutVertex;
    }).map(function(id) {
        return eles.getElementById(id);
    });
    return {
        cut: eles.spawn(cutVertices),
        components: components
    };
};
var $e815fda779bc047b$var$hopcroftTarjanBiconnected$1 = {
    hopcroftTarjanBiconnected: $e815fda779bc047b$var$hopcroftTarjanBiconnected,
    htbc: $e815fda779bc047b$var$hopcroftTarjanBiconnected,
    htb: $e815fda779bc047b$var$hopcroftTarjanBiconnected,
    hopcroftTarjanBiconnectedComponents: $e815fda779bc047b$var$hopcroftTarjanBiconnected
};
var $e815fda779bc047b$var$tarjanStronglyConnected = function tarjanStronglyConnected() {
    var eles = this;
    var nodes = {};
    var index = 0;
    var components = [];
    var stack = [];
    var cut = eles.spawn(eles);
    var _stronglyConnectedSearch = function stronglyConnectedSearch(sourceNodeId) {
        stack.push(sourceNodeId);
        nodes[sourceNodeId] = {
            index: index,
            low: index++,
            explored: false
        };
        var connectedEdges = eles.getElementById(sourceNodeId).connectedEdges().intersection(eles);
        connectedEdges.forEach(function(edge) {
            var targetNodeId = edge.target().id();
            if (targetNodeId !== sourceNodeId) {
                if (!(targetNodeId in nodes)) _stronglyConnectedSearch(targetNodeId);
                if (!nodes[targetNodeId].explored) nodes[sourceNodeId].low = Math.min(nodes[sourceNodeId].low, nodes[targetNodeId].low);
            }
        });
        if (nodes[sourceNodeId].index === nodes[sourceNodeId].low) {
            var componentNodes = eles.spawn();
            for(;;){
                var nodeId = stack.pop();
                componentNodes.merge(eles.getElementById(nodeId));
                nodes[nodeId].low = nodes[sourceNodeId].index;
                nodes[nodeId].explored = true;
                if (nodeId === sourceNodeId) break;
            }
            var componentEdges = componentNodes.edgesWith(componentNodes);
            var component = componentNodes.merge(componentEdges);
            components.push(component);
            cut = cut.difference(component);
        }
    };
    eles.forEach(function(ele) {
        if (ele.isNode()) {
            var nodeId = ele.id();
            if (!(nodeId in nodes)) _stronglyConnectedSearch(nodeId);
        }
    });
    return {
        cut: cut,
        components: components
    };
};
var $e815fda779bc047b$var$tarjanStronglyConnected$1 = {
    tarjanStronglyConnected: $e815fda779bc047b$var$tarjanStronglyConnected,
    tsc: $e815fda779bc047b$var$tarjanStronglyConnected,
    tscc: $e815fda779bc047b$var$tarjanStronglyConnected,
    tarjanStronglyConnectedComponents: $e815fda779bc047b$var$tarjanStronglyConnected
};
var $e815fda779bc047b$var$elesfn$j = {};
[
    $e815fda779bc047b$var$elesfn$v,
    $e815fda779bc047b$var$elesfn$u,
    $e815fda779bc047b$var$elesfn$t,
    $e815fda779bc047b$var$elesfn$s,
    $e815fda779bc047b$var$elesfn$r,
    $e815fda779bc047b$var$elesfn$q,
    $e815fda779bc047b$var$elesfn$p,
    $e815fda779bc047b$var$elesfn$o,
    $e815fda779bc047b$var$elesfn$n,
    $e815fda779bc047b$var$elesfn$m,
    $e815fda779bc047b$var$elesfn$l,
    $e815fda779bc047b$var$markovClustering$1,
    $e815fda779bc047b$var$kClustering,
    $e815fda779bc047b$var$hierarchicalClustering$1,
    $e815fda779bc047b$var$affinityPropagation$1,
    $e815fda779bc047b$var$elesfn$k,
    $e815fda779bc047b$var$hopcroftTarjanBiconnected$1,
    $e815fda779bc047b$var$tarjanStronglyConnected$1
].forEach(function(props) {
    $e815fda779bc047b$var$extend($e815fda779bc047b$var$elesfn$j, props);
});
/*!
Embeddable Minimum Strictly-Compliant Promises/A+ 1.1.1 Thenable
Copyright (c) 2013-2014 Ralf S. Engelschall (http://engelschall.com)
Licensed under The MIT License (http://opensource.org/licenses/MIT)
*/ /*  promise states [Promises/A+ 2.1]  */ var $e815fda779bc047b$var$STATE_PENDING = 0; /*  [Promises/A+ 2.1.1]  */ 
var $e815fda779bc047b$var$STATE_FULFILLED = 1; /*  [Promises/A+ 2.1.2]  */ 
var $e815fda779bc047b$var$STATE_REJECTED = 2; /*  [Promises/A+ 2.1.3]  */ 
/*  promise object constructor  */ var $e815fda779bc047b$var$_api = function api(executor) {
    /*  optionally support non-constructor/plain-function call  */ if (!(this instanceof $e815fda779bc047b$var$_api)) return new $e815fda779bc047b$var$_api(executor);
    /*  initialize object  */ this.id = 'Thenable/1.0.7';
    this.state = $e815fda779bc047b$var$STATE_PENDING; /*  initial state  */ 
    this.fulfillValue = undefined; /*  initial value  */  /*  [Promises/A+ 1.3, 2.1.2.2]  */ 
    this.rejectReason = undefined; /*  initial reason */  /*  [Promises/A+ 1.5, 2.1.3.2]  */ 
    this.onFulfilled = []; /*  initial handlers  */ 
    this.onRejected = []; /*  initial handlers  */ 
    /*  provide optional information-hiding proxy  */ this.proxy = {
        then: this.then.bind(this)
    };
    /*  support optional executor function  */ if (typeof executor === 'function') executor.call(this, this.fulfill.bind(this), this.reject.bind(this));
};
/*  promise API methods  */ $e815fda779bc047b$var$_api.prototype = {
    /*  promise resolving methods  */ fulfill: function fulfill(value) {
        return $e815fda779bc047b$var$deliver(this, $e815fda779bc047b$var$STATE_FULFILLED, 'fulfillValue', value);
    },
    reject: function reject(value) {
        return $e815fda779bc047b$var$deliver(this, $e815fda779bc047b$var$STATE_REJECTED, 'rejectReason', value);
    },
    /*  "The then Method" [Promises/A+ 1.1, 1.2, 2.2]  */ then: function then(onFulfilled, onRejected) {
        var curr = this;
        var next = new $e815fda779bc047b$var$_api(); /*  [Promises/A+ 2.2.7]  */ 
        curr.onFulfilled.push($e815fda779bc047b$var$resolver(onFulfilled, next, 'fulfill')); /*  [Promises/A+ 2.2.2/2.2.6]  */ 
        curr.onRejected.push($e815fda779bc047b$var$resolver(onRejected, next, 'reject')); /*  [Promises/A+ 2.2.3/2.2.6]  */ 
        $e815fda779bc047b$var$execute(curr);
        return next.proxy; /*  [Promises/A+ 2.2.7, 3.3]  */ 
    }
};
/*  deliver an action  */ var $e815fda779bc047b$var$deliver = function deliver(curr, state, name, value) {
    if (curr.state === $e815fda779bc047b$var$STATE_PENDING) {
        curr.state = state; /*  [Promises/A+ 2.1.2.1, 2.1.3.1]  */ 
        curr[name] = value; /*  [Promises/A+ 2.1.2.2, 2.1.3.2]  */ 
        $e815fda779bc047b$var$execute(curr);
    }
    return curr;
};
/*  execute all handlers  */ var $e815fda779bc047b$var$execute = function execute(curr) {
    if (curr.state === $e815fda779bc047b$var$STATE_FULFILLED) $e815fda779bc047b$var$execute_handlers(curr, 'onFulfilled', curr.fulfillValue);
    else if (curr.state === $e815fda779bc047b$var$STATE_REJECTED) $e815fda779bc047b$var$execute_handlers(curr, 'onRejected', curr.rejectReason);
};
/*  execute particular set of handlers  */ var $e815fda779bc047b$var$execute_handlers = function execute_handlers(curr, name, value) {
    /* global setImmediate: true */ /* global setTimeout: true */ /*  short-circuit processing  */ if (curr[name].length === 0) return;
    /*  iterate over all handlers, exactly once  */ var handlers = curr[name];
    curr[name] = []; /*  [Promises/A+ 2.2.2.3, 2.2.3.3]  */ 
    var func = function func() {
        for(var i = 0; i < handlers.length; i++)handlers[i](value); /*  [Promises/A+ 2.2.5]  */ 
    };
    /*  execute procedure asynchronously  */ /*  [Promises/A+ 2.2.4, 3.1]  */ if (typeof setImmediate === 'function') setImmediate(func);
    else setTimeout(func, 0);
};
/*  generate a resolver function  */ var $e815fda779bc047b$var$resolver = function resolver(cb, next, method) {
    return function(value) {
        if (typeof cb !== 'function') /*  [Promises/A+ 2.2.1, 2.2.7.3, 2.2.7.4]  */ next[method].call(next, value); /*  [Promises/A+ 2.2.7.3, 2.2.7.4]  */ 
        else {
            var result;
            try {
                result = cb(value);
            } catch (e) {
                next.reject(e); /*  [Promises/A+ 2.2.7.2]  */ 
                return;
            }
            $e815fda779bc047b$var$_resolve(next, result); /*  [Promises/A+ 2.2.7.1]  */ 
        }
    };
};
/*  "Promise Resolution Procedure"  */ /*  [Promises/A+ 2.3]  */ var $e815fda779bc047b$var$_resolve = function resolve(promise, x) {
    /*  sanity check arguments  */ /*  [Promises/A+ 2.3.1]  */ if (promise === x || promise.proxy === x) {
        promise.reject(new TypeError('cannot resolve promise with itself'));
        return;
    }
    /*  surgically check for a "then" method
    (mainly to just call the "getter" of "then" only once)  */ var then;
    if ($e815fda779bc047b$var$_typeof(x) === 'object' && x !== null || typeof x === 'function') try {
        then = x.then;
    } catch (e) {
        promise.reject(e); /*  [Promises/A+ 2.3.3.2]  */ 
        return;
    }
    /*  handle own Thenables    [Promises/A+ 2.3.2]
    and similar "thenables" [Promises/A+ 2.3.3]  */ if (typeof then === 'function') {
        var resolved = false;
        try {
            /*  call retrieved "then" method */ /*  [Promises/A+ 2.3.3.3]  */ then.call(x, /*  resolvePromise  */ /*  [Promises/A+ 2.3.3.3.1]  */ function(y) {
                if (resolved) return;
                resolved = true; /*  [Promises/A+ 2.3.3.3.3]  */ 
                if (y === x) /*  [Promises/A+ 3.6]  */ promise.reject(new TypeError('circular thenable chain'));
                else $e815fda779bc047b$var$_resolve(promise, y);
            }, /*  rejectPromise  */ /*  [Promises/A+ 2.3.3.3.2]  */ function(r) {
                if (resolved) return;
                resolved = true; /*  [Promises/A+ 2.3.3.3.3]  */ 
                promise.reject(r);
            });
        } catch (e) {
            if (!resolved) /*  [Promises/A+ 2.3.3.3.3]  */ promise.reject(e); /*  [Promises/A+ 2.3.3.3.4]  */ 
        }
        return;
    }
    /*  handle other values  */ promise.fulfill(x); /*  [Promises/A+ 2.3.4, 2.3.3.4]  */ 
};
// so we always have Promise.all()
$e815fda779bc047b$var$_api.all = function(ps) {
    return new $e815fda779bc047b$var$_api(function(resolveAll, rejectAll) {
        var vals = new Array(ps.length);
        var doneCount = 0;
        var fulfill = function fulfill(i, val) {
            vals[i] = val;
            doneCount++;
            if (doneCount === ps.length) resolveAll(vals);
        };
        for(var i = 0; i < ps.length; i++)(function(i) {
            var p = ps[i];
            var isPromise = p != null && p.then != null;
            if (isPromise) p.then(function(val) {
                fulfill(i, val);
            }, function(err) {
                rejectAll(err);
            });
            else {
                var val = p;
                fulfill(i, val);
            }
        })(i);
    });
};
$e815fda779bc047b$var$_api.resolve = function(val) {
    return new $e815fda779bc047b$var$_api(function(resolve, reject) {
        resolve(val);
    });
};
$e815fda779bc047b$var$_api.reject = function(val) {
    return new $e815fda779bc047b$var$_api(function(resolve, reject) {
        reject(val);
    });
};
var $e815fda779bc047b$var$Promise$1 = typeof Promise !== 'undefined' ? Promise : $e815fda779bc047b$var$_api; // eslint-disable-line no-undef
var $e815fda779bc047b$var$Animation = function Animation(target, opts, opts2) {
    var isCore = $e815fda779bc047b$var$core(target);
    var isEle = !isCore;
    var _p = this._private = $e815fda779bc047b$var$extend({
        duration: 1000
    }, opts, opts2);
    _p.target = target;
    _p.style = _p.style || _p.css;
    _p.started = false;
    _p.playing = false;
    _p.hooked = false;
    _p.applying = false;
    _p.progress = 0;
    _p.completes = [];
    _p.frames = [];
    if (_p.complete && $e815fda779bc047b$var$fn$6(_p.complete)) _p.completes.push(_p.complete);
    if (isEle) {
        var pos = target.position();
        _p.startPosition = _p.startPosition || {
            x: pos.x,
            y: pos.y
        };
        _p.startStyle = _p.startStyle || target.cy().style().getAnimationStartStyle(target, _p.style);
    }
    if (isCore) {
        var pan = target.pan();
        _p.startPan = {
            x: pan.x,
            y: pan.y
        };
        _p.startZoom = target.zoom();
    }
    // for future timeline/animations impl
    this.length = 1;
    this[0] = this;
};
var $e815fda779bc047b$var$anifn = $e815fda779bc047b$var$Animation.prototype;
$e815fda779bc047b$var$extend($e815fda779bc047b$var$anifn, {
    instanceString: function instanceString() {
        return 'animation';
    },
    hook: function hook() {
        var _p = this._private;
        if (!_p.hooked) {
            // add to target's animation queue
            var q;
            var tAni = _p.target._private.animation;
            if (_p.queue) q = tAni.queue;
            else q = tAni.current;
            q.push(this);
            // add to the animation loop pool
            if ($e815fda779bc047b$var$elementOrCollection(_p.target)) _p.target.cy().addToAnimationPool(_p.target);
            _p.hooked = true;
        }
        return this;
    },
    play: function play() {
        var _p = this._private;
        // autorewind
        if (_p.progress === 1) _p.progress = 0;
        _p.playing = true;
        _p.started = false; // needs to be started by animation loop
        _p.stopped = false;
        this.hook();
        // the animation loop will start the animation...
        return this;
    },
    playing: function playing() {
        return this._private.playing;
    },
    apply: function apply() {
        var _p = this._private;
        _p.applying = true;
        _p.started = false; // needs to be started by animation loop
        _p.stopped = false;
        this.hook();
        // the animation loop will apply the animation at this progress
        return this;
    },
    applying: function applying() {
        return this._private.applying;
    },
    pause: function pause() {
        var _p = this._private;
        _p.playing = false;
        _p.started = false;
        return this;
    },
    stop: function stop() {
        var _p = this._private;
        _p.playing = false;
        _p.started = false;
        _p.stopped = true; // to be removed from animation queues
        return this;
    },
    rewind: function rewind() {
        return this.progress(0);
    },
    fastforward: function fastforward() {
        return this.progress(1);
    },
    time: function time(t) {
        var _p = this._private;
        if (t === undefined) return _p.progress * _p.duration;
        else return this.progress(t / _p.duration);
    },
    progress: function progress(p) {
        var _p = this._private;
        var wasPlaying = _p.playing;
        if (p === undefined) return _p.progress;
        else {
            if (wasPlaying) this.pause();
            _p.progress = p;
            _p.started = false;
            if (wasPlaying) this.play();
        }
        return this;
    },
    completed: function completed() {
        return this._private.progress === 1;
    },
    reverse: function reverse() {
        var _p = this._private;
        var wasPlaying = _p.playing;
        if (wasPlaying) this.pause();
        _p.progress = 1 - _p.progress;
        _p.started = false;
        var swap = function swap(a, b) {
            var _pa = _p[a];
            if (_pa == null) return;
            _p[a] = _p[b];
            _p[b] = _pa;
        };
        swap('zoom', 'startZoom');
        swap('pan', 'startPan');
        swap('position', 'startPosition');
        // swap styles
        if (_p.style) for(var i = 0; i < _p.style.length; i++){
            var prop = _p.style[i];
            var name = prop.name;
            var startStyleProp = _p.startStyle[name];
            _p.startStyle[name] = prop;
            _p.style[i] = startStyleProp;
        }
        if (wasPlaying) this.play();
        return this;
    },
    promise: function promise(type) {
        var _p = this._private;
        var arr;
        switch(type){
            case 'frame':
                arr = _p.frames;
                break;
            default:
            case 'complete':
            case 'completed':
                arr = _p.completes;
        }
        return new $e815fda779bc047b$var$Promise$1(function(resolve, reject) {
            arr.push(function() {
                resolve();
            });
        });
    }
});
$e815fda779bc047b$var$anifn.complete = $e815fda779bc047b$var$anifn.completed;
$e815fda779bc047b$var$anifn.run = $e815fda779bc047b$var$anifn.play;
$e815fda779bc047b$var$anifn.running = $e815fda779bc047b$var$anifn.playing;
var $e815fda779bc047b$var$define$3 = {
    animated: function animated() {
        return function animatedImpl() {
            var self1 = this;
            var selfIsArrayLike = self1.length !== undefined;
            var all = selfIsArrayLike ? self1 : [
                self1
            ]; // put in array if not array-like
            var cy = this._private.cy || this;
            if (!cy.styleEnabled()) return false;
            var ele = all[0];
            if (ele) return ele._private.animation.current.length > 0;
        };
    },
    // animated
    clearQueue: function clearQueue() {
        return function clearQueueImpl() {
            var self1 = this;
            var selfIsArrayLike = self1.length !== undefined;
            var all = selfIsArrayLike ? self1 : [
                self1
            ]; // put in array if not array-like
            var cy = this._private.cy || this;
            if (!cy.styleEnabled()) return this;
            for(var i = 0; i < all.length; i++){
                var ele = all[i];
                ele._private.animation.queue = [];
            }
            return this;
        };
    },
    // clearQueue
    delay: function delay() {
        return function delayImpl(time, complete) {
            var cy = this._private.cy || this;
            if (!cy.styleEnabled()) return this;
            return this.animate({
                delay: time,
                duration: time,
                complete: complete
            });
        };
    },
    // delay
    delayAnimation: function delayAnimation() {
        return function delayAnimationImpl(time, complete) {
            var cy = this._private.cy || this;
            if (!cy.styleEnabled()) return this;
            return this.animation({
                delay: time,
                duration: time,
                complete: complete
            });
        };
    },
    // delay
    animation: function animation() {
        return function animationImpl(properties, params) {
            var self1 = this;
            var selfIsArrayLike = self1.length !== undefined;
            var all = selfIsArrayLike ? self1 : [
                self1
            ]; // put in array if not array-like
            var cy = this._private.cy || this;
            var isCore = !selfIsArrayLike;
            var isEles = !isCore;
            if (!cy.styleEnabled()) return this;
            var style = cy.style();
            properties = $e815fda779bc047b$var$extend({}, properties, params);
            var propertiesEmpty = Object.keys(properties).length === 0;
            if (propertiesEmpty) return new $e815fda779bc047b$var$Animation(all[0], properties); // nothing to animate
            if (properties.duration === undefined) properties.duration = 400;
            switch(properties.duration){
                case 'slow':
                    properties.duration = 600;
                    break;
                case 'fast':
                    properties.duration = 200;
                    break;
            }
            if (isEles) {
                properties.style = style.getPropsList(properties.style || properties.css);
                properties.css = undefined;
            }
            if (isEles && properties.renderedPosition != null) {
                var rpos = properties.renderedPosition;
                var pan = cy.pan();
                var zoom = cy.zoom();
                properties.position = $e815fda779bc047b$var$renderedToModelPosition(rpos, zoom, pan);
            }
            // override pan w/ panBy if set
            if (isCore && properties.panBy != null) {
                var panBy = properties.panBy;
                var cyPan = cy.pan();
                properties.pan = {
                    x: cyPan.x + panBy.x,
                    y: cyPan.y + panBy.y
                };
            }
            // override pan w/ center if set
            var center = properties.center || properties.centre;
            if (isCore && center != null) {
                var centerPan = cy.getCenterPan(center.eles, properties.zoom);
                if (centerPan != null) properties.pan = centerPan;
            }
            // override pan & zoom w/ fit if set
            if (isCore && properties.fit != null) {
                var fit = properties.fit;
                var fitVp = cy.getFitViewport(fit.eles || fit.boundingBox, fit.padding);
                if (fitVp != null) {
                    properties.pan = fitVp.pan;
                    properties.zoom = fitVp.zoom;
                }
            }
            // override zoom (& potentially pan) w/ zoom obj if set
            if (isCore && $e815fda779bc047b$var$plainObject(properties.zoom)) {
                var vp = cy.getZoomedViewport(properties.zoom);
                if (vp != null) {
                    if (vp.zoomed) properties.zoom = vp.zoom;
                    if (vp.panned) properties.pan = vp.pan;
                } else properties.zoom = null; // an inavalid zoom (e.g. no delta) gets automatically destroyed
            }
            return new $e815fda779bc047b$var$Animation(all[0], properties);
        };
    },
    // animate
    animate: function animate() {
        return function animateImpl(properties, params) {
            var self1 = this;
            var selfIsArrayLike = self1.length !== undefined;
            var all = selfIsArrayLike ? self1 : [
                self1
            ]; // put in array if not array-like
            var cy = this._private.cy || this;
            if (!cy.styleEnabled()) return this;
            if (params) properties = $e815fda779bc047b$var$extend({}, properties, params);
            // manually hook and run the animation
            for(var i = 0; i < all.length; i++){
                var ele = all[i];
                var queue = ele.animated() && (properties.queue === undefined || properties.queue);
                var ani = ele.animation(properties, queue ? {
                    queue: true
                } : undefined);
                ani.play();
            }
            return this; // chaining
        };
    },
    // animate
    stop: function stop() {
        return function stopImpl(clearQueue, jumpToEnd) {
            var self1 = this;
            var selfIsArrayLike = self1.length !== undefined;
            var all = selfIsArrayLike ? self1 : [
                self1
            ]; // put in array if not array-like
            var cy = this._private.cy || this;
            if (!cy.styleEnabled()) return this;
            for(var i = 0; i < all.length; i++){
                var ele = all[i];
                var _p = ele._private;
                var anis = _p.animation.current;
                for(var j = 0; j < anis.length; j++){
                    var ani = anis[j];
                    var ani_p = ani._private;
                    if (jumpToEnd) // next iteration of the animation loop, the animation
                    // will go straight to the end and be removed
                    ani_p.duration = 0;
                }
                // clear the queue of future animations
                if (clearQueue) _p.animation.queue = [];
                if (!jumpToEnd) _p.animation.current = [];
            }
            // we have to notify (the animation loop doesn't do it for us on `stop`)
            cy.notify('draw');
            return this;
        };
    } // stop
}; // define
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $e815fda779bc047b$var$isArray_1;
var $e815fda779bc047b$var$hasRequiredIsArray;
function $e815fda779bc047b$var$requireIsArray() {
    if ($e815fda779bc047b$var$hasRequiredIsArray) return $e815fda779bc047b$var$isArray_1;
    $e815fda779bc047b$var$hasRequiredIsArray = 1;
    var isArray = Array.isArray;
    $e815fda779bc047b$var$isArray_1 = isArray;
    return $e815fda779bc047b$var$isArray_1;
}
var $e815fda779bc047b$var$_isKey;
var $e815fda779bc047b$var$hasRequired_isKey;
function $e815fda779bc047b$var$require_isKey() {
    if ($e815fda779bc047b$var$hasRequired_isKey) return $e815fda779bc047b$var$_isKey;
    $e815fda779bc047b$var$hasRequired_isKey = 1;
    var isArray = $e815fda779bc047b$var$requireIsArray(), isSymbol = $e815fda779bc047b$var$requireIsSymbol();
    /** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/;
    /**
	 * Checks if `value` is a property name and not a property path.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	 */ function isKey(value, object) {
        if (isArray(value)) return false;
        var type = typeof value;
        if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || isSymbol(value)) return true;
        return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object(object);
    }
    $e815fda779bc047b$var$_isKey = isKey;
    return $e815fda779bc047b$var$_isKey;
}
var $e815fda779bc047b$var$isFunction_1;
var $e815fda779bc047b$var$hasRequiredIsFunction;
function $e815fda779bc047b$var$requireIsFunction() {
    if ($e815fda779bc047b$var$hasRequiredIsFunction) return $e815fda779bc047b$var$isFunction_1;
    $e815fda779bc047b$var$hasRequiredIsFunction = 1;
    var baseGetTag = $e815fda779bc047b$var$require_baseGetTag(), isObject = $e815fda779bc047b$var$requireIsObject();
    /** `Object#toString` result references. */ var asyncTag = '[object AsyncFunction]', funcTag = '[object Function]', genTag = '[object GeneratorFunction]', proxyTag = '[object Proxy]';
    /**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */ function isFunction(value) {
        if (!isObject(value)) return false;
        // The use of `Object#toString` avoids issues with the `typeof` operator
        // in Safari 9 which returns 'object' for typed arrays and other constructors.
        var tag = baseGetTag(value);
        return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }
    $e815fda779bc047b$var$isFunction_1 = isFunction;
    return $e815fda779bc047b$var$isFunction_1;
}
var $e815fda779bc047b$var$_coreJsData;
var $e815fda779bc047b$var$hasRequired_coreJsData;
function $e815fda779bc047b$var$require_coreJsData() {
    if ($e815fda779bc047b$var$hasRequired_coreJsData) return $e815fda779bc047b$var$_coreJsData;
    $e815fda779bc047b$var$hasRequired_coreJsData = 1;
    var root = $e815fda779bc047b$var$require_root();
    /** Used to detect overreaching core-js shims. */ var coreJsData = root['__core-js_shared__'];
    $e815fda779bc047b$var$_coreJsData = coreJsData;
    return $e815fda779bc047b$var$_coreJsData;
}
var $e815fda779bc047b$var$_isMasked;
var $e815fda779bc047b$var$hasRequired_isMasked;
function $e815fda779bc047b$var$require_isMasked() {
    if ($e815fda779bc047b$var$hasRequired_isMasked) return $e815fda779bc047b$var$_isMasked;
    $e815fda779bc047b$var$hasRequired_isMasked = 1;
    var coreJsData = $e815fda779bc047b$var$require_coreJsData();
    /** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
        var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
        return uid ? 'Symbol(src)_1.' + uid : '';
    }();
    /**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */ function isMasked(func) {
        return !!maskSrcKey && maskSrcKey in func;
    }
    $e815fda779bc047b$var$_isMasked = isMasked;
    return $e815fda779bc047b$var$_isMasked;
}
/** Used for built-in method references. */ var $e815fda779bc047b$var$_toSource;
var $e815fda779bc047b$var$hasRequired_toSource;
function $e815fda779bc047b$var$require_toSource() {
    if ($e815fda779bc047b$var$hasRequired_toSource) return $e815fda779bc047b$var$_toSource;
    $e815fda779bc047b$var$hasRequired_toSource = 1;
    var funcProto = Function.prototype;
    /** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
    /**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to convert.
	 * @returns {string} Returns the source code.
	 */ function toSource(func) {
        if (func != null) {
            try {
                return funcToString.call(func);
            } catch (e) {}
            try {
                return func + '';
            } catch (e) {}
        }
        return '';
    }
    $e815fda779bc047b$var$_toSource = toSource;
    return $e815fda779bc047b$var$_toSource;
}
var $e815fda779bc047b$var$_baseIsNative;
var $e815fda779bc047b$var$hasRequired_baseIsNative;
function $e815fda779bc047b$var$require_baseIsNative() {
    if ($e815fda779bc047b$var$hasRequired_baseIsNative) return $e815fda779bc047b$var$_baseIsNative;
    $e815fda779bc047b$var$hasRequired_baseIsNative = 1;
    var isFunction = $e815fda779bc047b$var$requireIsFunction(), isMasked = $e815fda779bc047b$var$require_isMasked(), isObject = $e815fda779bc047b$var$requireIsObject(), toSource = $e815fda779bc047b$var$require_toSource();
    /**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
    /** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
    /** Used for built-in method references. */ var funcProto = Function.prototype, objectProto = Object.prototype;
    /** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
    /** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
    /** Used to detect if a method is native. */ var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
    /**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */ function baseIsNative(value) {
        if (!isObject(value) || isMasked(value)) return false;
        var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
        return pattern.test(toSource(value));
    }
    $e815fda779bc047b$var$_baseIsNative = baseIsNative;
    return $e815fda779bc047b$var$_baseIsNative;
}
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ var $e815fda779bc047b$var$_getValue;
var $e815fda779bc047b$var$hasRequired_getValue;
function $e815fda779bc047b$var$require_getValue() {
    if ($e815fda779bc047b$var$hasRequired_getValue) return $e815fda779bc047b$var$_getValue;
    $e815fda779bc047b$var$hasRequired_getValue = 1;
    function getValue(object, key) {
        return object == null ? undefined : object[key];
    }
    $e815fda779bc047b$var$_getValue = getValue;
    return $e815fda779bc047b$var$_getValue;
}
var $e815fda779bc047b$var$_getNative;
var $e815fda779bc047b$var$hasRequired_getNative;
function $e815fda779bc047b$var$require_getNative() {
    if ($e815fda779bc047b$var$hasRequired_getNative) return $e815fda779bc047b$var$_getNative;
    $e815fda779bc047b$var$hasRequired_getNative = 1;
    var baseIsNative = $e815fda779bc047b$var$require_baseIsNative(), getValue = $e815fda779bc047b$var$require_getValue();
    /**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */ function getNative(object, key) {
        var value = getValue(object, key);
        return baseIsNative(value) ? value : undefined;
    }
    $e815fda779bc047b$var$_getNative = getNative;
    return $e815fda779bc047b$var$_getNative;
}
var $e815fda779bc047b$var$_nativeCreate;
var $e815fda779bc047b$var$hasRequired_nativeCreate;
function $e815fda779bc047b$var$require_nativeCreate() {
    if ($e815fda779bc047b$var$hasRequired_nativeCreate) return $e815fda779bc047b$var$_nativeCreate;
    $e815fda779bc047b$var$hasRequired_nativeCreate = 1;
    var getNative = $e815fda779bc047b$var$require_getNative();
    /* Built-in method references that are verified to be native. */ var nativeCreate = getNative(Object, 'create');
    $e815fda779bc047b$var$_nativeCreate = nativeCreate;
    return $e815fda779bc047b$var$_nativeCreate;
}
var $e815fda779bc047b$var$_hashClear;
var $e815fda779bc047b$var$hasRequired_hashClear;
function $e815fda779bc047b$var$require_hashClear() {
    if ($e815fda779bc047b$var$hasRequired_hashClear) return $e815fda779bc047b$var$_hashClear;
    $e815fda779bc047b$var$hasRequired_hashClear = 1;
    var nativeCreate = $e815fda779bc047b$var$require_nativeCreate();
    /**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */ function hashClear() {
        this.__data__ = nativeCreate ? nativeCreate(null) : {};
        this.size = 0;
    }
    $e815fda779bc047b$var$_hashClear = hashClear;
    return $e815fda779bc047b$var$_hashClear;
}
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ var $e815fda779bc047b$var$_hashDelete;
var $e815fda779bc047b$var$hasRequired_hashDelete;
function $e815fda779bc047b$var$require_hashDelete() {
    if ($e815fda779bc047b$var$hasRequired_hashDelete) return $e815fda779bc047b$var$_hashDelete;
    $e815fda779bc047b$var$hasRequired_hashDelete = 1;
    function hashDelete(key) {
        var result = this.has(key) && delete this.__data__[key];
        this.size -= result ? 1 : 0;
        return result;
    }
    $e815fda779bc047b$var$_hashDelete = hashDelete;
    return $e815fda779bc047b$var$_hashDelete;
}
var $e815fda779bc047b$var$_hashGet;
var $e815fda779bc047b$var$hasRequired_hashGet;
function $e815fda779bc047b$var$require_hashGet() {
    if ($e815fda779bc047b$var$hasRequired_hashGet) return $e815fda779bc047b$var$_hashGet;
    $e815fda779bc047b$var$hasRequired_hashGet = 1;
    var nativeCreate = $e815fda779bc047b$var$require_nativeCreate();
    /** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
    /** Used for built-in method references. */ var objectProto = Object.prototype;
    /** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
    /**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */ function hashGet(key) {
        var data = this.__data__;
        if (nativeCreate) {
            var result = data[key];
            return result === HASH_UNDEFINED ? undefined : result;
        }
        return hasOwnProperty.call(data, key) ? data[key] : undefined;
    }
    $e815fda779bc047b$var$_hashGet = hashGet;
    return $e815fda779bc047b$var$_hashGet;
}
var $e815fda779bc047b$var$_hashHas;
var $e815fda779bc047b$var$hasRequired_hashHas;
function $e815fda779bc047b$var$require_hashHas() {
    if ($e815fda779bc047b$var$hasRequired_hashHas) return $e815fda779bc047b$var$_hashHas;
    $e815fda779bc047b$var$hasRequired_hashHas = 1;
    var nativeCreate = $e815fda779bc047b$var$require_nativeCreate();
    /** Used for built-in method references. */ var objectProto = Object.prototype;
    /** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
    /**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */ function hashHas(key) {
        var data = this.__data__;
        return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
    }
    $e815fda779bc047b$var$_hashHas = hashHas;
    return $e815fda779bc047b$var$_hashHas;
}
var $e815fda779bc047b$var$_hashSet;
var $e815fda779bc047b$var$hasRequired_hashSet;
function $e815fda779bc047b$var$require_hashSet() {
    if ($e815fda779bc047b$var$hasRequired_hashSet) return $e815fda779bc047b$var$_hashSet;
    $e815fda779bc047b$var$hasRequired_hashSet = 1;
    var nativeCreate = $e815fda779bc047b$var$require_nativeCreate();
    /** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
    /**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */ function hashSet(key, value) {
        var data = this.__data__;
        this.size += this.has(key) ? 0 : 1;
        data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
        return this;
    }
    $e815fda779bc047b$var$_hashSet = hashSet;
    return $e815fda779bc047b$var$_hashSet;
}
var $e815fda779bc047b$var$_Hash;
var $e815fda779bc047b$var$hasRequired_Hash;
function $e815fda779bc047b$var$require_Hash() {
    if ($e815fda779bc047b$var$hasRequired_Hash) return $e815fda779bc047b$var$_Hash;
    $e815fda779bc047b$var$hasRequired_Hash = 1;
    var hashClear = $e815fda779bc047b$var$require_hashClear(), hashDelete = $e815fda779bc047b$var$require_hashDelete(), hashGet = $e815fda779bc047b$var$require_hashGet(), hashHas = $e815fda779bc047b$var$require_hashHas(), hashSet = $e815fda779bc047b$var$require_hashSet();
    /**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */ function Hash(entries) {
        var index = -1, length = entries == null ? 0 : entries.length;
        this.clear();
        while(++index < length){
            var entry = entries[index];
            this.set(entry[0], entry[1]);
        }
    }
    // Add methods to `Hash`.
    Hash.prototype.clear = hashClear;
    Hash.prototype['delete'] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;
    $e815fda779bc047b$var$_Hash = Hash;
    return $e815fda779bc047b$var$_Hash;
}
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ var $e815fda779bc047b$var$_listCacheClear;
var $e815fda779bc047b$var$hasRequired_listCacheClear;
function $e815fda779bc047b$var$require_listCacheClear() {
    if ($e815fda779bc047b$var$hasRequired_listCacheClear) return $e815fda779bc047b$var$_listCacheClear;
    $e815fda779bc047b$var$hasRequired_listCacheClear = 1;
    function listCacheClear() {
        this.__data__ = [];
        this.size = 0;
    }
    $e815fda779bc047b$var$_listCacheClear = listCacheClear;
    return $e815fda779bc047b$var$_listCacheClear;
}
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ var $e815fda779bc047b$var$eq_1;
var $e815fda779bc047b$var$hasRequiredEq;
function $e815fda779bc047b$var$requireEq() {
    if ($e815fda779bc047b$var$hasRequiredEq) return $e815fda779bc047b$var$eq_1;
    $e815fda779bc047b$var$hasRequiredEq = 1;
    function eq(value, other) {
        return value === other || value !== value && other !== other;
    }
    $e815fda779bc047b$var$eq_1 = eq;
    return $e815fda779bc047b$var$eq_1;
}
var $e815fda779bc047b$var$_assocIndexOf;
var $e815fda779bc047b$var$hasRequired_assocIndexOf;
function $e815fda779bc047b$var$require_assocIndexOf() {
    if ($e815fda779bc047b$var$hasRequired_assocIndexOf) return $e815fda779bc047b$var$_assocIndexOf;
    $e815fda779bc047b$var$hasRequired_assocIndexOf = 1;
    var eq = $e815fda779bc047b$var$requireEq();
    /**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */ function assocIndexOf(array, key) {
        var length = array.length;
        while(length--){
            if (eq(array[length][0], key)) return length;
        }
        return -1;
    }
    $e815fda779bc047b$var$_assocIndexOf = assocIndexOf;
    return $e815fda779bc047b$var$_assocIndexOf;
}
var $e815fda779bc047b$var$_listCacheDelete;
var $e815fda779bc047b$var$hasRequired_listCacheDelete;
function $e815fda779bc047b$var$require_listCacheDelete() {
    if ($e815fda779bc047b$var$hasRequired_listCacheDelete) return $e815fda779bc047b$var$_listCacheDelete;
    $e815fda779bc047b$var$hasRequired_listCacheDelete = 1;
    var assocIndexOf = $e815fda779bc047b$var$require_assocIndexOf();
    /** Used for built-in method references. */ var arrayProto = Array.prototype;
    /** Built-in value references. */ var splice = arrayProto.splice;
    /**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */ function listCacheDelete(key) {
        var data = this.__data__, index = assocIndexOf(data, key);
        if (index < 0) return false;
        var lastIndex = data.length - 1;
        if (index == lastIndex) data.pop();
        else splice.call(data, index, 1);
        --this.size;
        return true;
    }
    $e815fda779bc047b$var$_listCacheDelete = listCacheDelete;
    return $e815fda779bc047b$var$_listCacheDelete;
}
var $e815fda779bc047b$var$_listCacheGet;
var $e815fda779bc047b$var$hasRequired_listCacheGet;
function $e815fda779bc047b$var$require_listCacheGet() {
    if ($e815fda779bc047b$var$hasRequired_listCacheGet) return $e815fda779bc047b$var$_listCacheGet;
    $e815fda779bc047b$var$hasRequired_listCacheGet = 1;
    var assocIndexOf = $e815fda779bc047b$var$require_assocIndexOf();
    /**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */ function listCacheGet(key) {
        var data = this.__data__, index = assocIndexOf(data, key);
        return index < 0 ? undefined : data[index][1];
    }
    $e815fda779bc047b$var$_listCacheGet = listCacheGet;
    return $e815fda779bc047b$var$_listCacheGet;
}
var $e815fda779bc047b$var$_listCacheHas;
var $e815fda779bc047b$var$hasRequired_listCacheHas;
function $e815fda779bc047b$var$require_listCacheHas() {
    if ($e815fda779bc047b$var$hasRequired_listCacheHas) return $e815fda779bc047b$var$_listCacheHas;
    $e815fda779bc047b$var$hasRequired_listCacheHas = 1;
    var assocIndexOf = $e815fda779bc047b$var$require_assocIndexOf();
    /**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */ function listCacheHas(key) {
        return assocIndexOf(this.__data__, key) > -1;
    }
    $e815fda779bc047b$var$_listCacheHas = listCacheHas;
    return $e815fda779bc047b$var$_listCacheHas;
}
var $e815fda779bc047b$var$_listCacheSet;
var $e815fda779bc047b$var$hasRequired_listCacheSet;
function $e815fda779bc047b$var$require_listCacheSet() {
    if ($e815fda779bc047b$var$hasRequired_listCacheSet) return $e815fda779bc047b$var$_listCacheSet;
    $e815fda779bc047b$var$hasRequired_listCacheSet = 1;
    var assocIndexOf = $e815fda779bc047b$var$require_assocIndexOf();
    /**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */ function listCacheSet(key, value) {
        var data = this.__data__, index = assocIndexOf(data, key);
        if (index < 0) {
            ++this.size;
            data.push([
                key,
                value
            ]);
        } else data[index][1] = value;
        return this;
    }
    $e815fda779bc047b$var$_listCacheSet = listCacheSet;
    return $e815fda779bc047b$var$_listCacheSet;
}
var $e815fda779bc047b$var$_ListCache;
var $e815fda779bc047b$var$hasRequired_ListCache;
function $e815fda779bc047b$var$require_ListCache() {
    if ($e815fda779bc047b$var$hasRequired_ListCache) return $e815fda779bc047b$var$_ListCache;
    $e815fda779bc047b$var$hasRequired_ListCache = 1;
    var listCacheClear = $e815fda779bc047b$var$require_listCacheClear(), listCacheDelete = $e815fda779bc047b$var$require_listCacheDelete(), listCacheGet = $e815fda779bc047b$var$require_listCacheGet(), listCacheHas = $e815fda779bc047b$var$require_listCacheHas(), listCacheSet = $e815fda779bc047b$var$require_listCacheSet();
    /**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */ function ListCache(entries) {
        var index = -1, length = entries == null ? 0 : entries.length;
        this.clear();
        while(++index < length){
            var entry = entries[index];
            this.set(entry[0], entry[1]);
        }
    }
    // Add methods to `ListCache`.
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype['delete'] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;
    $e815fda779bc047b$var$_ListCache = ListCache;
    return $e815fda779bc047b$var$_ListCache;
}
var $e815fda779bc047b$var$_Map;
var $e815fda779bc047b$var$hasRequired_Map;
function $e815fda779bc047b$var$require_Map() {
    if ($e815fda779bc047b$var$hasRequired_Map) return $e815fda779bc047b$var$_Map;
    $e815fda779bc047b$var$hasRequired_Map = 1;
    var getNative = $e815fda779bc047b$var$require_getNative(), root = $e815fda779bc047b$var$require_root();
    /* Built-in method references that are verified to be native. */ var Map1 = getNative(root, 'Map');
    $e815fda779bc047b$var$_Map = Map1;
    return $e815fda779bc047b$var$_Map;
}
var $e815fda779bc047b$var$_mapCacheClear;
var $e815fda779bc047b$var$hasRequired_mapCacheClear;
function $e815fda779bc047b$var$require_mapCacheClear() {
    if ($e815fda779bc047b$var$hasRequired_mapCacheClear) return $e815fda779bc047b$var$_mapCacheClear;
    $e815fda779bc047b$var$hasRequired_mapCacheClear = 1;
    var Hash = $e815fda779bc047b$var$require_Hash(), ListCache = $e815fda779bc047b$var$require_ListCache(), Map1 = $e815fda779bc047b$var$require_Map();
    /**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */ function mapCacheClear() {
        this.size = 0;
        this.__data__ = {
            'hash': new Hash,
            'map': new (Map1 || ListCache),
            'string': new Hash
        };
    }
    $e815fda779bc047b$var$_mapCacheClear = mapCacheClear;
    return $e815fda779bc047b$var$_mapCacheClear;
}
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ var $e815fda779bc047b$var$_isKeyable;
var $e815fda779bc047b$var$hasRequired_isKeyable;
function $e815fda779bc047b$var$require_isKeyable() {
    if ($e815fda779bc047b$var$hasRequired_isKeyable) return $e815fda779bc047b$var$_isKeyable;
    $e815fda779bc047b$var$hasRequired_isKeyable = 1;
    function isKeyable(value) {
        var type = typeof value;
        return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
    }
    $e815fda779bc047b$var$_isKeyable = isKeyable;
    return $e815fda779bc047b$var$_isKeyable;
}
var $e815fda779bc047b$var$_getMapData;
var $e815fda779bc047b$var$hasRequired_getMapData;
function $e815fda779bc047b$var$require_getMapData() {
    if ($e815fda779bc047b$var$hasRequired_getMapData) return $e815fda779bc047b$var$_getMapData;
    $e815fda779bc047b$var$hasRequired_getMapData = 1;
    var isKeyable = $e815fda779bc047b$var$require_isKeyable();
    /**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */ function getMapData(map, key) {
        var data = map.__data__;
        return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
    }
    $e815fda779bc047b$var$_getMapData = getMapData;
    return $e815fda779bc047b$var$_getMapData;
}
var $e815fda779bc047b$var$_mapCacheDelete;
var $e815fda779bc047b$var$hasRequired_mapCacheDelete;
function $e815fda779bc047b$var$require_mapCacheDelete() {
    if ($e815fda779bc047b$var$hasRequired_mapCacheDelete) return $e815fda779bc047b$var$_mapCacheDelete;
    $e815fda779bc047b$var$hasRequired_mapCacheDelete = 1;
    var getMapData = $e815fda779bc047b$var$require_getMapData();
    /**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */ function mapCacheDelete(key) {
        var result = getMapData(this, key)['delete'](key);
        this.size -= result ? 1 : 0;
        return result;
    }
    $e815fda779bc047b$var$_mapCacheDelete = mapCacheDelete;
    return $e815fda779bc047b$var$_mapCacheDelete;
}
var $e815fda779bc047b$var$_mapCacheGet;
var $e815fda779bc047b$var$hasRequired_mapCacheGet;
function $e815fda779bc047b$var$require_mapCacheGet() {
    if ($e815fda779bc047b$var$hasRequired_mapCacheGet) return $e815fda779bc047b$var$_mapCacheGet;
    $e815fda779bc047b$var$hasRequired_mapCacheGet = 1;
    var getMapData = $e815fda779bc047b$var$require_getMapData();
    /**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */ function mapCacheGet(key) {
        return getMapData(this, key).get(key);
    }
    $e815fda779bc047b$var$_mapCacheGet = mapCacheGet;
    return $e815fda779bc047b$var$_mapCacheGet;
}
var $e815fda779bc047b$var$_mapCacheHas;
var $e815fda779bc047b$var$hasRequired_mapCacheHas;
function $e815fda779bc047b$var$require_mapCacheHas() {
    if ($e815fda779bc047b$var$hasRequired_mapCacheHas) return $e815fda779bc047b$var$_mapCacheHas;
    $e815fda779bc047b$var$hasRequired_mapCacheHas = 1;
    var getMapData = $e815fda779bc047b$var$require_getMapData();
    /**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */ function mapCacheHas(key) {
        return getMapData(this, key).has(key);
    }
    $e815fda779bc047b$var$_mapCacheHas = mapCacheHas;
    return $e815fda779bc047b$var$_mapCacheHas;
}
var $e815fda779bc047b$var$_mapCacheSet;
var $e815fda779bc047b$var$hasRequired_mapCacheSet;
function $e815fda779bc047b$var$require_mapCacheSet() {
    if ($e815fda779bc047b$var$hasRequired_mapCacheSet) return $e815fda779bc047b$var$_mapCacheSet;
    $e815fda779bc047b$var$hasRequired_mapCacheSet = 1;
    var getMapData = $e815fda779bc047b$var$require_getMapData();
    /**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */ function mapCacheSet(key, value) {
        var data = getMapData(this, key), size = data.size;
        data.set(key, value);
        this.size += data.size == size ? 0 : 1;
        return this;
    }
    $e815fda779bc047b$var$_mapCacheSet = mapCacheSet;
    return $e815fda779bc047b$var$_mapCacheSet;
}
var $e815fda779bc047b$var$_MapCache;
var $e815fda779bc047b$var$hasRequired_MapCache;
function $e815fda779bc047b$var$require_MapCache() {
    if ($e815fda779bc047b$var$hasRequired_MapCache) return $e815fda779bc047b$var$_MapCache;
    $e815fda779bc047b$var$hasRequired_MapCache = 1;
    var mapCacheClear = $e815fda779bc047b$var$require_mapCacheClear(), mapCacheDelete = $e815fda779bc047b$var$require_mapCacheDelete(), mapCacheGet = $e815fda779bc047b$var$require_mapCacheGet(), mapCacheHas = $e815fda779bc047b$var$require_mapCacheHas(), mapCacheSet = $e815fda779bc047b$var$require_mapCacheSet();
    /**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */ function MapCache(entries) {
        var index = -1, length = entries == null ? 0 : entries.length;
        this.clear();
        while(++index < length){
            var entry = entries[index];
            this.set(entry[0], entry[1]);
        }
    }
    // Add methods to `MapCache`.
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype['delete'] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;
    $e815fda779bc047b$var$_MapCache = MapCache;
    return $e815fda779bc047b$var$_MapCache;
}
var $e815fda779bc047b$var$memoize_1;
var $e815fda779bc047b$var$hasRequiredMemoize;
function $e815fda779bc047b$var$requireMemoize() {
    if ($e815fda779bc047b$var$hasRequiredMemoize) return $e815fda779bc047b$var$memoize_1;
    $e815fda779bc047b$var$hasRequiredMemoize = 1;
    var MapCache = $e815fda779bc047b$var$require_MapCache();
    /** Error message constants. */ var FUNC_ERROR_TEXT = 'Expected a function';
    /**
	 * Creates a function that memoizes the result of `func`. If `resolver` is
	 * provided, it determines the cache key for storing the result based on the
	 * arguments provided to the memoized function. By default, the first argument
	 * provided to the memoized function is used as the map cache key. The `func`
	 * is invoked with the `this` binding of the memoized function.
	 *
	 * **Note:** The cache is exposed as the `cache` property on the memoized
	 * function. Its creation may be customized by replacing the `_.memoize.Cache`
	 * constructor with one whose instances implement the
	 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to have its output memoized.
	 * @param {Function} [resolver] The function to resolve the cache key.
	 * @returns {Function} Returns the new memoized function.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': 2 };
	 * var other = { 'c': 3, 'd': 4 };
	 *
	 * var values = _.memoize(_.values);
	 * values(object);
	 * // => [1, 2]
	 *
	 * values(other);
	 * // => [3, 4]
	 *
	 * object.a = 2;
	 * values(object);
	 * // => [1, 2]
	 *
	 * // Modify the result cache.
	 * values.cache.set(object, ['a', 'b']);
	 * values(object);
	 * // => ['a', 'b']
	 *
	 * // Replace `_.memoize.Cache`.
	 * _.memoize.Cache = WeakMap;
	 */ function memoize(func, resolver) {
        if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError(FUNC_ERROR_TEXT);
        var memoized = function() {
            var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
            if (cache.has(key)) return cache.get(key);
            var result = func.apply(this, args);
            memoized.cache = cache.set(key, result) || cache;
            return result;
        };
        memoized.cache = new (memoize.Cache || MapCache);
        return memoized;
    }
    // Expose `MapCache`.
    memoize.Cache = MapCache;
    $e815fda779bc047b$var$memoize_1 = memoize;
    return $e815fda779bc047b$var$memoize_1;
}
var $e815fda779bc047b$var$_memoizeCapped;
var $e815fda779bc047b$var$hasRequired_memoizeCapped;
function $e815fda779bc047b$var$require_memoizeCapped() {
    if ($e815fda779bc047b$var$hasRequired_memoizeCapped) return $e815fda779bc047b$var$_memoizeCapped;
    $e815fda779bc047b$var$hasRequired_memoizeCapped = 1;
    var memoize = $e815fda779bc047b$var$requireMemoize();
    /** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
    /**
	 * A specialized version of `_.memoize` which clears the memoized function's
	 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	 *
	 * @private
	 * @param {Function} func The function to have its output memoized.
	 * @returns {Function} Returns the new memoized function.
	 */ function memoizeCapped(func) {
        var result = memoize(func, function(key) {
            if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
            return key;
        });
        var cache = result.cache;
        return result;
    }
    $e815fda779bc047b$var$_memoizeCapped = memoizeCapped;
    return $e815fda779bc047b$var$_memoizeCapped;
}
var $e815fda779bc047b$var$_stringToPath;
var $e815fda779bc047b$var$hasRequired_stringToPath;
function $e815fda779bc047b$var$require_stringToPath() {
    if ($e815fda779bc047b$var$hasRequired_stringToPath) return $e815fda779bc047b$var$_stringToPath;
    $e815fda779bc047b$var$hasRequired_stringToPath = 1;
    var memoizeCapped = $e815fda779bc047b$var$require_memoizeCapped();
    /** Used to match property names within property paths. */ var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
    /** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
    /**
	 * Converts `string` to a property path array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the property path array.
	 */ var stringToPath = memoizeCapped(function(string) {
        var result = [];
        if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
        string.replace(rePropName, function(match, number, quote, subString) {
            result.push(quote ? subString.replace(reEscapeChar, '$1') : number || match);
        });
        return result;
    });
    $e815fda779bc047b$var$_stringToPath = stringToPath;
    return $e815fda779bc047b$var$_stringToPath;
}
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ var $e815fda779bc047b$var$_arrayMap;
var $e815fda779bc047b$var$hasRequired_arrayMap;
function $e815fda779bc047b$var$require_arrayMap() {
    if ($e815fda779bc047b$var$hasRequired_arrayMap) return $e815fda779bc047b$var$_arrayMap;
    $e815fda779bc047b$var$hasRequired_arrayMap = 1;
    function arrayMap(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length, result = Array(length);
        while(++index < length)result[index] = iteratee(array[index], index, array);
        return result;
    }
    $e815fda779bc047b$var$_arrayMap = arrayMap;
    return $e815fda779bc047b$var$_arrayMap;
}
var $e815fda779bc047b$var$_baseToString;
var $e815fda779bc047b$var$hasRequired_baseToString;
function $e815fda779bc047b$var$require_baseToString() {
    if ($e815fda779bc047b$var$hasRequired_baseToString) return $e815fda779bc047b$var$_baseToString;
    $e815fda779bc047b$var$hasRequired_baseToString = 1;
    var Symbol1 = $e815fda779bc047b$var$require_Symbol(), arrayMap = $e815fda779bc047b$var$require_arrayMap(), isArray = $e815fda779bc047b$var$requireIsArray(), isSymbol = $e815fda779bc047b$var$requireIsSymbol();
    /** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol1 ? Symbol1.prototype : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
    /**
	 * The base implementation of `_.toString` which doesn't convert nullish
	 * values to empty strings.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 */ function baseToString(value) {
        // Exit early for strings to avoid a performance hit in some environments.
        if (typeof value == 'string') return value;
        if (isArray(value)) // Recursively convert values (susceptible to call stack limits).
        return arrayMap(value, baseToString) + '';
        if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : '';
        var result = value + '';
        return result == '0' && 1 / value == -Infinity ? '-0' : result;
    }
    $e815fda779bc047b$var$_baseToString = baseToString;
    return $e815fda779bc047b$var$_baseToString;
}
var $e815fda779bc047b$var$toString_1;
var $e815fda779bc047b$var$hasRequiredToString;
function $e815fda779bc047b$var$requireToString() {
    if ($e815fda779bc047b$var$hasRequiredToString) return $e815fda779bc047b$var$toString_1;
    $e815fda779bc047b$var$hasRequiredToString = 1;
    var baseToString = $e815fda779bc047b$var$require_baseToString();
    /**
	 * Converts `value` to a string. An empty string is returned for `null`
	 * and `undefined` values. The sign of `-0` is preserved.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 * @example
	 *
	 * _.toString(null);
	 * // => ''
	 *
	 * _.toString(-0);
	 * // => '-0'
	 *
	 * _.toString([1, 2, 3]);
	 * // => '1,2,3'
	 */ function toString(value) {
        return value == null ? '' : baseToString(value);
    }
    $e815fda779bc047b$var$toString_1 = toString;
    return $e815fda779bc047b$var$toString_1;
}
var $e815fda779bc047b$var$_castPath;
var $e815fda779bc047b$var$hasRequired_castPath;
function $e815fda779bc047b$var$require_castPath() {
    if ($e815fda779bc047b$var$hasRequired_castPath) return $e815fda779bc047b$var$_castPath;
    $e815fda779bc047b$var$hasRequired_castPath = 1;
    var isArray = $e815fda779bc047b$var$requireIsArray(), isKey = $e815fda779bc047b$var$require_isKey(), stringToPath = $e815fda779bc047b$var$require_stringToPath(), toString = $e815fda779bc047b$var$requireToString();
    /**
	 * Casts `value` to a path array if it's not one.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {Array} Returns the cast property path array.
	 */ function castPath(value, object) {
        if (isArray(value)) return value;
        return isKey(value, object) ? [
            value
        ] : stringToPath(toString(value));
    }
    $e815fda779bc047b$var$_castPath = castPath;
    return $e815fda779bc047b$var$_castPath;
}
var $e815fda779bc047b$var$_toKey;
var $e815fda779bc047b$var$hasRequired_toKey;
function $e815fda779bc047b$var$require_toKey() {
    if ($e815fda779bc047b$var$hasRequired_toKey) return $e815fda779bc047b$var$_toKey;
    $e815fda779bc047b$var$hasRequired_toKey = 1;
    var isSymbol = $e815fda779bc047b$var$requireIsSymbol();
    /**
	 * Converts `value` to a string key if it's not a string or symbol.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {string|symbol} Returns the key.
	 */ function toKey(value) {
        if (typeof value == 'string' || isSymbol(value)) return value;
        var result = value + '';
        return result == '0' && 1 / value == -Infinity ? '-0' : result;
    }
    $e815fda779bc047b$var$_toKey = toKey;
    return $e815fda779bc047b$var$_toKey;
}
var $e815fda779bc047b$var$_baseGet;
var $e815fda779bc047b$var$hasRequired_baseGet;
function $e815fda779bc047b$var$require_baseGet() {
    if ($e815fda779bc047b$var$hasRequired_baseGet) return $e815fda779bc047b$var$_baseGet;
    $e815fda779bc047b$var$hasRequired_baseGet = 1;
    var castPath = $e815fda779bc047b$var$require_castPath(), toKey = $e815fda779bc047b$var$require_toKey();
    /**
	 * The base implementation of `_.get` without support for default values.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @returns {*} Returns the resolved value.
	 */ function baseGet(object, path) {
        path = castPath(path, object);
        var index = 0, length = path.length;
        while(object != null && index < length)object = object[toKey(path[index++])];
        return index && index == length ? object : undefined;
    }
    $e815fda779bc047b$var$_baseGet = baseGet;
    return $e815fda779bc047b$var$_baseGet;
}
var $e815fda779bc047b$var$get_1;
var $e815fda779bc047b$var$hasRequiredGet;
function $e815fda779bc047b$var$requireGet() {
    if ($e815fda779bc047b$var$hasRequiredGet) return $e815fda779bc047b$var$get_1;
    $e815fda779bc047b$var$hasRequiredGet = 1;
    var baseGet = $e815fda779bc047b$var$require_baseGet();
    /**
	 * Gets the value at `path` of `object`. If the resolved value is
	 * `undefined`, the `defaultValue` is returned in its place.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.7.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	 * @returns {*} Returns the resolved value.
	 * @example
	 *
	 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	 *
	 * _.get(object, 'a[0].b.c');
	 * // => 3
	 *
	 * _.get(object, ['a', '0', 'b', 'c']);
	 * // => 3
	 *
	 * _.get(object, 'a.b.c', 'default');
	 * // => 'default'
	 */ function get(object, path, defaultValue) {
        var result = object == null ? undefined : baseGet(object, path);
        return result === undefined ? defaultValue : result;
    }
    $e815fda779bc047b$var$get_1 = get;
    return $e815fda779bc047b$var$get_1;
}
var $e815fda779bc047b$var$getExports = $e815fda779bc047b$var$requireGet();
var $e815fda779bc047b$var$get = /*@__PURE__*/ $e815fda779bc047b$var$getDefaultExportFromCjs($e815fda779bc047b$var$getExports);
var $e815fda779bc047b$var$_defineProperty;
var $e815fda779bc047b$var$hasRequired_defineProperty;
function $e815fda779bc047b$var$require_defineProperty() {
    if ($e815fda779bc047b$var$hasRequired_defineProperty) return $e815fda779bc047b$var$_defineProperty;
    $e815fda779bc047b$var$hasRequired_defineProperty = 1;
    var getNative = $e815fda779bc047b$var$require_getNative();
    var defineProperty = function() {
        try {
            var func = getNative(Object, 'defineProperty');
            func({}, '', {});
            return func;
        } catch (e) {}
    }();
    $e815fda779bc047b$var$_defineProperty = defineProperty;
    return $e815fda779bc047b$var$_defineProperty;
}
var $e815fda779bc047b$var$_baseAssignValue;
var $e815fda779bc047b$var$hasRequired_baseAssignValue;
function $e815fda779bc047b$var$require_baseAssignValue() {
    if ($e815fda779bc047b$var$hasRequired_baseAssignValue) return $e815fda779bc047b$var$_baseAssignValue;
    $e815fda779bc047b$var$hasRequired_baseAssignValue = 1;
    var defineProperty = $e815fda779bc047b$var$require_defineProperty();
    /**
	 * The base implementation of `assignValue` and `assignMergeValue` without
	 * value checks.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */ function baseAssignValue(object, key, value) {
        if (key == '__proto__' && defineProperty) defineProperty(object, key, {
            'configurable': true,
            'enumerable': true,
            'value': value,
            'writable': true
        });
        else object[key] = value;
    }
    $e815fda779bc047b$var$_baseAssignValue = baseAssignValue;
    return $e815fda779bc047b$var$_baseAssignValue;
}
var $e815fda779bc047b$var$_assignValue;
var $e815fda779bc047b$var$hasRequired_assignValue;
function $e815fda779bc047b$var$require_assignValue() {
    if ($e815fda779bc047b$var$hasRequired_assignValue) return $e815fda779bc047b$var$_assignValue;
    $e815fda779bc047b$var$hasRequired_assignValue = 1;
    var baseAssignValue = $e815fda779bc047b$var$require_baseAssignValue(), eq = $e815fda779bc047b$var$requireEq();
    /** Used for built-in method references. */ var objectProto = Object.prototype;
    /** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
    /**
	 * Assigns `value` to `key` of `object` if the existing value is not equivalent
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */ function assignValue(object, key, value) {
        var objValue = object[key];
        if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
    }
    $e815fda779bc047b$var$_assignValue = assignValue;
    return $e815fda779bc047b$var$_assignValue;
}
/** Used as references for various `Number` constants. */ var $e815fda779bc047b$var$_isIndex;
var $e815fda779bc047b$var$hasRequired_isIndex;
function $e815fda779bc047b$var$require_isIndex() {
    if ($e815fda779bc047b$var$hasRequired_isIndex) return $e815fda779bc047b$var$_isIndex;
    $e815fda779bc047b$var$hasRequired_isIndex = 1;
    var MAX_SAFE_INTEGER = 9007199254740991;
    /** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
    /**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */ function isIndex(value, length) {
        var type = typeof value;
        length = length == null ? MAX_SAFE_INTEGER : length;
        return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
    }
    $e815fda779bc047b$var$_isIndex = isIndex;
    return $e815fda779bc047b$var$_isIndex;
}
var $e815fda779bc047b$var$_baseSet;
var $e815fda779bc047b$var$hasRequired_baseSet;
function $e815fda779bc047b$var$require_baseSet() {
    if ($e815fda779bc047b$var$hasRequired_baseSet) return $e815fda779bc047b$var$_baseSet;
    $e815fda779bc047b$var$hasRequired_baseSet = 1;
    var assignValue = $e815fda779bc047b$var$require_assignValue(), castPath = $e815fda779bc047b$var$require_castPath(), isIndex = $e815fda779bc047b$var$require_isIndex(), isObject = $e815fda779bc047b$var$requireIsObject(), toKey = $e815fda779bc047b$var$require_toKey();
    /**
	 * The base implementation of `_.set`.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {Array|string} path The path of the property to set.
	 * @param {*} value The value to set.
	 * @param {Function} [customizer] The function to customize path creation.
	 * @returns {Object} Returns `object`.
	 */ function baseSet(object, path, value, customizer) {
        if (!isObject(object)) return object;
        path = castPath(path, object);
        var index = -1, length = path.length, lastIndex = length - 1, nested = object;
        while(nested != null && ++index < length){
            var key = toKey(path[index]), newValue = value;
            if (key === '__proto__' || key === 'constructor' || key === 'prototype') return object;
            if (index != lastIndex) {
                var objValue = nested[key];
                newValue = customizer ? customizer(objValue, key, nested) : undefined;
                if (newValue === undefined) newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
            }
            assignValue(nested, key, newValue);
            nested = nested[key];
        }
        return object;
    }
    $e815fda779bc047b$var$_baseSet = baseSet;
    return $e815fda779bc047b$var$_baseSet;
}
var $e815fda779bc047b$var$set_1;
var $e815fda779bc047b$var$hasRequiredSet;
function $e815fda779bc047b$var$requireSet() {
    if ($e815fda779bc047b$var$hasRequiredSet) return $e815fda779bc047b$var$set_1;
    $e815fda779bc047b$var$hasRequiredSet = 1;
    var baseSet = $e815fda779bc047b$var$require_baseSet();
    /**
	 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
	 * it's created. Arrays are created for missing index properties while objects
	 * are created for all other missing properties. Use `_.setWith` to customize
	 * `path` creation.
	 *
	 * **Note:** This method mutates `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.7.0
	 * @category Object
	 * @param {Object} object The object to modify.
	 * @param {Array|string} path The path of the property to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns `object`.
	 * @example
	 *
	 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	 *
	 * _.set(object, 'a[0].b.c', 4);
	 * console.log(object.a[0].b.c);
	 * // => 4
	 *
	 * _.set(object, ['x', '0', 'y', 'z'], 5);
	 * console.log(object.x[0].y.z);
	 * // => 5
	 */ function set(object, path, value) {
        return object == null ? object : baseSet(object, path, value);
    }
    $e815fda779bc047b$var$set_1 = set;
    return $e815fda779bc047b$var$set_1;
}
var $e815fda779bc047b$var$setExports = $e815fda779bc047b$var$requireSet();
var $e815fda779bc047b$var$set = /*@__PURE__*/ $e815fda779bc047b$var$getDefaultExportFromCjs($e815fda779bc047b$var$setExports);
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ var $e815fda779bc047b$var$_copyArray;
var $e815fda779bc047b$var$hasRequired_copyArray;
function $e815fda779bc047b$var$require_copyArray() {
    if ($e815fda779bc047b$var$hasRequired_copyArray) return $e815fda779bc047b$var$_copyArray;
    $e815fda779bc047b$var$hasRequired_copyArray = 1;
    function copyArray(source, array) {
        var index = -1, length = source.length;
        array || (array = Array(length));
        while(++index < length)array[index] = source[index];
        return array;
    }
    $e815fda779bc047b$var$_copyArray = copyArray;
    return $e815fda779bc047b$var$_copyArray;
}
var $e815fda779bc047b$var$toPath_1;
var $e815fda779bc047b$var$hasRequiredToPath;
function $e815fda779bc047b$var$requireToPath() {
    if ($e815fda779bc047b$var$hasRequiredToPath) return $e815fda779bc047b$var$toPath_1;
    $e815fda779bc047b$var$hasRequiredToPath = 1;
    var arrayMap = $e815fda779bc047b$var$require_arrayMap(), copyArray = $e815fda779bc047b$var$require_copyArray(), isArray = $e815fda779bc047b$var$requireIsArray(), isSymbol = $e815fda779bc047b$var$requireIsSymbol(), stringToPath = $e815fda779bc047b$var$require_stringToPath(), toKey = $e815fda779bc047b$var$require_toKey(), toString = $e815fda779bc047b$var$requireToString();
    /**
	 * Converts `value` to a property path array.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Util
	 * @param {*} value The value to convert.
	 * @returns {Array} Returns the new property path array.
	 * @example
	 *
	 * _.toPath('a.b.c');
	 * // => ['a', 'b', 'c']
	 *
	 * _.toPath('a[0].b.c');
	 * // => ['a', '0', 'b', 'c']
	 */ function toPath(value) {
        if (isArray(value)) return arrayMap(value, toKey);
        return isSymbol(value) ? [
            value
        ] : copyArray(stringToPath(toString(value)));
    }
    $e815fda779bc047b$var$toPath_1 = toPath;
    return $e815fda779bc047b$var$toPath_1;
}
var $e815fda779bc047b$var$toPathExports = $e815fda779bc047b$var$requireToPath();
var $e815fda779bc047b$var$toPath = /*@__PURE__*/ $e815fda779bc047b$var$getDefaultExportFromCjs($e815fda779bc047b$var$toPathExports);
var $e815fda779bc047b$var$define$2 = {
    // access data field
    data: function data(params) {
        var defaults = {
            field: 'data',
            bindingEvent: 'data',
            allowBinding: false,
            allowSetting: false,
            allowGetting: false,
            settingEvent: 'data',
            settingTriggersEvent: false,
            triggerFnName: 'trigger',
            immutableKeys: {},
            // key => true if immutable
            updateStyle: false,
            beforeGet: function beforeGet(self1) {},
            beforeSet: function beforeSet(self1, obj) {},
            onSet: function onSet(self1) {},
            canSet: function canSet(self1) {
                return true;
            }
        };
        params = $e815fda779bc047b$var$extend({}, defaults, params);
        return function dataImpl(name, value) {
            var p = params;
            var self1 = this;
            var selfIsArrayLike = self1.length !== undefined;
            var all = selfIsArrayLike ? self1 : [
                self1
            ]; // put in array if not array-like
            var single = selfIsArrayLike ? self1[0] : self1;
            // .data('foo', ...)
            if ($e815fda779bc047b$var$string(name)) {
                // set or get property
                var isPathLike = name.indexOf('.') !== -1; // there might be a normal field with a dot 
                var path = isPathLike && $e815fda779bc047b$var$toPath(name);
                // .data('foo')
                if (p.allowGetting && value === undefined) {
                    // get
                    var ret;
                    if (single) {
                        p.beforeGet(single);
                        // check if it's path and a field with the same name doesn't exist
                        if (path && single._private[p.field][name] === undefined) ret = $e815fda779bc047b$var$get(single._private[p.field], path);
                        else ret = single._private[p.field][name];
                    }
                    return ret;
                // .data('foo', 'bar')
                } else if (p.allowSetting && value !== undefined) {
                    // set
                    var valid = !p.immutableKeys[name];
                    if (valid) {
                        var change = $e815fda779bc047b$var$_defineProperty$1({}, name, value);
                        p.beforeSet(self1, change);
                        for(var i = 0, l = all.length; i < l; i++){
                            var ele = all[i];
                            if (p.canSet(ele)) {
                                if (path && single._private[p.field][name] === undefined) $e815fda779bc047b$var$set(ele._private[p.field], path, value);
                                else ele._private[p.field][name] = value;
                            }
                        }
                        // update mappers if asked
                        if (p.updateStyle) self1.updateStyle();
                        // call onSet callback
                        p.onSet(self1);
                        if (p.settingTriggersEvent) self1[p.triggerFnName](p.settingEvent);
                    }
                }
            // .data({ 'foo': 'bar' })
            } else if (p.allowSetting && $e815fda779bc047b$var$plainObject(name)) {
                // extend
                var obj = name;
                var k, v;
                var keys = Object.keys(obj);
                p.beforeSet(self1, obj);
                for(var _i = 0; _i < keys.length; _i++){
                    k = keys[_i];
                    v = obj[k];
                    var _valid = !p.immutableKeys[k];
                    if (_valid) for(var j = 0; j < all.length; j++){
                        var _ele = all[j];
                        if (p.canSet(_ele)) _ele._private[p.field][k] = v;
                    }
                }
                // update mappers if asked
                if (p.updateStyle) self1.updateStyle();
                // call onSet callback
                p.onSet(self1);
                if (p.settingTriggersEvent) self1[p.triggerFnName](p.settingEvent);
            // .data(function(){ ... })
            } else if (p.allowBinding && $e815fda779bc047b$var$fn$6(name)) {
                // bind to event
                var fn = name;
                self1.on(p.bindingEvent, fn);
            // .data()
            } else if (p.allowGetting && name === undefined) {
                // get whole object
                var _ret;
                if (single) {
                    p.beforeGet(single);
                    _ret = single._private[p.field];
                }
                return _ret;
            }
            return self1; // maintain chainability
        }; // function
    },
    // data
    // remove data field
    removeData: function removeData(params) {
        var defaults = {
            field: 'data',
            event: 'data',
            triggerFnName: 'trigger',
            triggerEvent: false,
            immutableKeys: {} // key => true if immutable
        };
        params = $e815fda779bc047b$var$extend({}, defaults, params);
        return function removeDataImpl(names) {
            var p = params;
            var self1 = this;
            var selfIsArrayLike = self1.length !== undefined;
            var all = selfIsArrayLike ? self1 : [
                self1
            ]; // put in array if not array-like
            // .removeData('foo bar')
            if ($e815fda779bc047b$var$string(names)) {
                // then get the list of keys, and delete them
                var keys = names.split(/\s+/);
                var l = keys.length;
                for(var i = 0; i < l; i++){
                    // delete each non-empty key
                    var key = keys[i];
                    if ($e815fda779bc047b$var$emptyString(key)) continue;
                    var valid = !p.immutableKeys[key]; // not valid if immutable
                    if (valid) for(var i_a = 0, l_a = all.length; i_a < l_a; i_a++)all[i_a]._private[p.field][key] = undefined;
                }
                if (p.triggerEvent) self1[p.triggerFnName](p.event);
            // .removeData()
            } else if (names === undefined) {
                // then delete all keys
                for(var _i_a = 0, _l_a = all.length; _i_a < _l_a; _i_a++){
                    var _privateFields = all[_i_a]._private[p.field];
                    var _keys = Object.keys(_privateFields);
                    for(var _i2 = 0; _i2 < _keys.length; _i2++){
                        var _key = _keys[_i2];
                        var validKeyToDelete = !p.immutableKeys[_key];
                        if (validKeyToDelete) _privateFields[_key] = undefined;
                    }
                }
                if (p.triggerEvent) self1[p.triggerFnName](p.event);
            }
            return self1; // maintain chaining
        }; // function
    } // removeData
}; // define
var $e815fda779bc047b$var$define$1 = {
    eventAliasesOn: function eventAliasesOn(proto) {
        var p = proto;
        p.addListener = p.listen = p.bind = p.on;
        p.unlisten = p.unbind = p.off = p.removeListener;
        p.trigger = p.emit;
        // this is just a wrapper alias of .on()
        p.pon = p.promiseOn = function(events, selector) {
            var self1 = this;
            var args = Array.prototype.slice.call(arguments, 0);
            return new $e815fda779bc047b$var$Promise$1(function(resolve, reject) {
                var callback = function callback(e) {
                    self1.off.apply(self1, offArgs);
                    resolve(e);
                };
                var onArgs = args.concat([
                    callback
                ]);
                var offArgs = onArgs.concat([]);
                self1.on.apply(self1, onArgs);
            });
        };
    }
}; // define
// use this module to cherry pick functions into your prototype
// (useful for functions shared between the core and collections, for example)
var $e815fda779bc047b$var$define = {};
[
    $e815fda779bc047b$var$define$3,
    $e815fda779bc047b$var$define$2,
    $e815fda779bc047b$var$define$1
].forEach(function(m1) {
    $e815fda779bc047b$var$extend($e815fda779bc047b$var$define, m1);
});
var $e815fda779bc047b$var$elesfn$i = {
    animate: $e815fda779bc047b$var$define.animate(),
    animation: $e815fda779bc047b$var$define.animation(),
    animated: $e815fda779bc047b$var$define.animated(),
    clearQueue: $e815fda779bc047b$var$define.clearQueue(),
    delay: $e815fda779bc047b$var$define.delay(),
    delayAnimation: $e815fda779bc047b$var$define.delayAnimation(),
    stop: $e815fda779bc047b$var$define.stop()
};
var $e815fda779bc047b$var$elesfn$h = {
    classes: function classes(_classes) {
        var self1 = this;
        if (_classes === undefined) {
            var ret = [];
            self1[0]._private.classes.forEach(function(cls) {
                return ret.push(cls);
            });
            return ret;
        } else if (!$e815fda779bc047b$var$array(_classes)) // extract classes from string
        _classes = (_classes || '').match(/\S+/g) || [];
        var changed = [];
        var classesSet = new $e815fda779bc047b$var$Set$1(_classes);
        // check and update each ele
        for(var j = 0; j < self1.length; j++){
            var ele = self1[j];
            var _p = ele._private;
            var eleClasses = _p.classes;
            var changedEle = false;
            // check if ele has all of the passed classes
            for(var i = 0; i < _classes.length; i++){
                var cls = _classes[i];
                var eleHasClass = eleClasses.has(cls);
                if (!eleHasClass) {
                    changedEle = true;
                    break;
                }
            }
            // check if ele has classes outside of those passed
            if (!changedEle) changedEle = eleClasses.size !== _classes.length;
            if (changedEle) {
                _p.classes = classesSet;
                changed.push(ele);
            }
        }
        // trigger update style on those eles that had class changes
        if (changed.length > 0) this.spawn(changed).updateStyle().emit('class');
        return self1;
    },
    addClass: function addClass(classes) {
        return this.toggleClass(classes, true);
    },
    hasClass: function hasClass(className) {
        var ele = this[0];
        return ele != null && ele._private.classes.has(className);
    },
    toggleClass: function toggleClass(classes, toggle) {
        if (!$e815fda779bc047b$var$array(classes)) // extract classes from string
        classes = classes.match(/\S+/g) || [];
        var self1 = this;
        var toggleUndefd = toggle === undefined;
        var changed = []; // eles who had classes changed
        for(var i = 0, il = self1.length; i < il; i++){
            var ele = self1[i];
            var eleClasses = ele._private.classes;
            var changedEle = false;
            for(var j = 0; j < classes.length; j++){
                var cls = classes[j];
                var hasClass = eleClasses.has(cls);
                var changedNow = false;
                if (toggle || toggleUndefd && !hasClass) {
                    eleClasses.add(cls);
                    changedNow = true;
                } else if (!toggle || toggleUndefd && hasClass) {
                    eleClasses["delete"](cls);
                    changedNow = true;
                }
                if (!changedEle && changedNow) {
                    changed.push(ele);
                    changedEle = true;
                }
            } // for j classes
        } // for i eles
        // trigger update style on those eles that had class changes
        if (changed.length > 0) this.spawn(changed).updateStyle().emit('class');
        return self1;
    },
    removeClass: function removeClass(classes) {
        return this.toggleClass(classes, false);
    },
    flashClass: function flashClass(classes, duration) {
        var self1 = this;
        if (duration == null) duration = 250;
        else if (duration === 0) return self1; // nothing to do really
        self1.addClass(classes);
        setTimeout(function() {
            self1.removeClass(classes);
        }, duration);
        return self1;
    }
};
$e815fda779bc047b$var$elesfn$h.className = $e815fda779bc047b$var$elesfn$h.classNames = $e815fda779bc047b$var$elesfn$h.classes;
// tokens in the query language
var $e815fda779bc047b$var$tokens = {
    metaChar: '[\\!\\"\\#\\$\\%\\&\\\'\\(\\)\\*\\+\\,\\.\\/\\:\\;\\<\\=\\>\\?\\@\\[\\]\\^\\`\\{\\|\\}\\~]',
    // chars we need to escape in let names, etc
    comparatorOp: '=|\\!=|>|>=|<|<=|\\$=|\\^=|\\*=',
    // binary comparison op (used in data selectors)
    boolOp: '\\?|\\!|\\^',
    // boolean (unary) operators (used in data selectors)
    string: "\"(?:\\\\\"|[^\"])*\"|'(?:\\\\'|[^'])*'",
    // string literals (used in data selectors) -- doublequotes | singlequotes
    number: $e815fda779bc047b$var$number,
    // number literal (used in data selectors) --- e.g. 0.1234, 1234, 12e123
    meta: 'degree|indegree|outdegree',
    // allowed metadata fields (i.e. allowed functions to use from Collection)
    separator: '\\s*,\\s*',
    // queries are separated by commas, e.g. edge[foo = 'bar'], node.someClass
    descendant: '\\s+',
    child: '\\s+>\\s+',
    subject: '\\$',
    group: 'node|edge|\\*',
    directedEdge: '\\s+->\\s+',
    undirectedEdge: '\\s+<->\\s+'
};
$e815fda779bc047b$var$tokens.variable = '(?:[\\w-.]|(?:\\\\' + $e815fda779bc047b$var$tokens.metaChar + '))+'; // a variable name can have letters, numbers, dashes, and periods
$e815fda779bc047b$var$tokens.className = '(?:[\\w-]|(?:\\\\' + $e815fda779bc047b$var$tokens.metaChar + '))+'; // a class name has the same rules as a variable except it can't have a '.' in the name
$e815fda779bc047b$var$tokens.value = $e815fda779bc047b$var$tokens.string + '|' + $e815fda779bc047b$var$tokens.number; // a value literal, either a string or number
$e815fda779bc047b$var$tokens.id = $e815fda779bc047b$var$tokens.variable; // an element id (follows variable conventions)
(function() {
    var ops, op, i;
    // add @ variants to comparatorOp
    ops = $e815fda779bc047b$var$tokens.comparatorOp.split('|');
    for(i = 0; i < ops.length; i++){
        op = ops[i];
        $e815fda779bc047b$var$tokens.comparatorOp += '|@' + op;
    }
    // add ! variants to comparatorOp
    ops = $e815fda779bc047b$var$tokens.comparatorOp.split('|');
    for(i = 0; i < ops.length; i++){
        op = ops[i];
        if (op.indexOf('!') >= 0) continue;
         // skip ops that explicitly contain !
        if (op === '=') continue;
         // skip = b/c != is explicitly defined
        $e815fda779bc047b$var$tokens.comparatorOp += '|\\!' + op;
    }
})();
/**
 * Make a new query object
 *
 * @prop type {Type} The type enum (int) of the query
 * @prop checks List of checks to make against an ele to test for a match
 */ var $e815fda779bc047b$var$newQuery = function newQuery() {
    return {
        checks: []
    };
};
/**
 * A check type enum-like object.  Uses integer values for fast match() lookup.
 * The ordering does not matter as long as the ints are unique.
 */ var $e815fda779bc047b$var$Type = {
    /** E.g. node */ GROUP: 0,
    /** A collection of elements */ COLLECTION: 1,
    /** A filter(ele) function */ FILTER: 2,
    /** E.g. [foo > 1] */ DATA_COMPARE: 3,
    /** E.g. [foo] */ DATA_EXIST: 4,
    /** E.g. [?foo] */ DATA_BOOL: 5,
    /** E.g. [[degree > 2]] */ META_COMPARE: 6,
    /** E.g. :selected */ STATE: 7,
    /** E.g. #foo */ ID: 8,
    /** E.g. .foo */ CLASS: 9,
    /** E.g. #foo <-> #bar */ UNDIRECTED_EDGE: 10,
    /** E.g. #foo -> #bar */ DIRECTED_EDGE: 11,
    /** E.g. $#foo -> #bar */ NODE_SOURCE: 12,
    /** E.g. #foo -> $#bar */ NODE_TARGET: 13,
    /** E.g. $#foo <-> #bar */ NODE_NEIGHBOR: 14,
    /** E.g. #foo > #bar */ CHILD: 15,
    /** E.g. #foo #bar */ DESCENDANT: 16,
    /** E.g. $#foo > #bar */ PARENT: 17,
    /** E.g. $#foo #bar */ ANCESTOR: 18,
    /** E.g. #foo > $bar > #baz */ COMPOUND_SPLIT: 19,
    /** Always matches, useful placeholder for subject in `COMPOUND_SPLIT` */ TRUE: 20
};
var $e815fda779bc047b$var$stateSelectors = [
    {
        selector: ':selected',
        matches: function matches(ele) {
            return ele.selected();
        }
    },
    {
        selector: ':unselected',
        matches: function matches(ele) {
            return !ele.selected();
        }
    },
    {
        selector: ':selectable',
        matches: function matches(ele) {
            return ele.selectable();
        }
    },
    {
        selector: ':unselectable',
        matches: function matches(ele) {
            return !ele.selectable();
        }
    },
    {
        selector: ':locked',
        matches: function matches(ele) {
            return ele.locked();
        }
    },
    {
        selector: ':unlocked',
        matches: function matches(ele) {
            return !ele.locked();
        }
    },
    {
        selector: ':visible',
        matches: function matches(ele) {
            return ele.visible();
        }
    },
    {
        selector: ':hidden',
        matches: function matches(ele) {
            return !ele.visible();
        }
    },
    {
        selector: ':transparent',
        matches: function matches(ele) {
            return ele.transparent();
        }
    },
    {
        selector: ':grabbed',
        matches: function matches(ele) {
            return ele.grabbed();
        }
    },
    {
        selector: ':free',
        matches: function matches(ele) {
            return !ele.grabbed();
        }
    },
    {
        selector: ':removed',
        matches: function matches(ele) {
            return ele.removed();
        }
    },
    {
        selector: ':inside',
        matches: function matches(ele) {
            return !ele.removed();
        }
    },
    {
        selector: ':grabbable',
        matches: function matches(ele) {
            return ele.grabbable();
        }
    },
    {
        selector: ':ungrabbable',
        matches: function matches(ele) {
            return !ele.grabbable();
        }
    },
    {
        selector: ':animated',
        matches: function matches(ele) {
            return ele.animated();
        }
    },
    {
        selector: ':unanimated',
        matches: function matches(ele) {
            return !ele.animated();
        }
    },
    {
        selector: ':parent',
        matches: function matches(ele) {
            return ele.isParent();
        }
    },
    {
        selector: ':childless',
        matches: function matches(ele) {
            return ele.isChildless();
        }
    },
    {
        selector: ':child',
        matches: function matches(ele) {
            return ele.isChild();
        }
    },
    {
        selector: ':orphan',
        matches: function matches(ele) {
            return ele.isOrphan();
        }
    },
    {
        selector: ':nonorphan',
        matches: function matches(ele) {
            return ele.isChild();
        }
    },
    {
        selector: ':compound',
        matches: function matches(ele) {
            if (ele.isNode()) return ele.isParent();
            else return ele.source().isParent() || ele.target().isParent();
        }
    },
    {
        selector: ':loop',
        matches: function matches(ele) {
            return ele.isLoop();
        }
    },
    {
        selector: ':simple',
        matches: function matches(ele) {
            return ele.isSimple();
        }
    },
    {
        selector: ':active',
        matches: function matches(ele) {
            return ele.active();
        }
    },
    {
        selector: ':inactive',
        matches: function matches(ele) {
            return !ele.active();
        }
    },
    {
        selector: ':backgrounding',
        matches: function matches(ele) {
            return ele.backgrounding();
        }
    },
    {
        selector: ':nonbackgrounding',
        matches: function matches(ele) {
            return !ele.backgrounding();
        }
    }
].sort(function(a, b) {
    // n.b. selectors that are starting substrings of others must have the longer ones first
    return $e815fda779bc047b$var$descending(a.selector, b.selector);
});
var $e815fda779bc047b$var$lookup = function() {
    var selToFn = {};
    var s;
    for(var i = 0; i < $e815fda779bc047b$var$stateSelectors.length; i++){
        s = $e815fda779bc047b$var$stateSelectors[i];
        selToFn[s.selector] = s.matches;
    }
    return selToFn;
}();
var $e815fda779bc047b$var$stateSelectorMatches = function stateSelectorMatches(sel, ele) {
    return $e815fda779bc047b$var$lookup[sel](ele);
};
var $e815fda779bc047b$var$stateSelectorRegex = '(' + $e815fda779bc047b$var$stateSelectors.map(function(s) {
    return s.selector;
}).join('|') + ')';
// when a token like a variable has escaped meta characters, we need to clean the backslashes out
// so that values get compared properly in Selector.filter()
var $e815fda779bc047b$var$cleanMetaChars = function cleanMetaChars(str) {
    return str.replace(new RegExp('\\\\(' + $e815fda779bc047b$var$tokens.metaChar + ')', 'g'), function(match, $1) {
        return $1;
    });
};
var $e815fda779bc047b$var$replaceLastQuery = function replaceLastQuery(selector, examiningQuery, replacementQuery) {
    selector[selector.length - 1] = replacementQuery;
};
// NOTE: add new expression syntax here to have it recognised by the parser;
// - a query contains all adjacent (i.e. no separator in between) expressions;
// - the current query is stored in selector[i]
// - you need to check the query objects in match() for it actually filter properly, but that's pretty straight forward
var $e815fda779bc047b$var$exprs = [
    {
        name: 'group',
        // just used for identifying when debugging
        query: true,
        regex: '(' + $e815fda779bc047b$var$tokens.group + ')',
        populate: function populate(selector, query, _ref) {
            var _ref2 = $e815fda779bc047b$var$_slicedToArray(_ref, 1), group = _ref2[0];
            query.checks.push({
                type: $e815fda779bc047b$var$Type.GROUP,
                value: group === '*' ? group : group + 's'
            });
        }
    },
    {
        name: 'state',
        query: true,
        regex: $e815fda779bc047b$var$stateSelectorRegex,
        populate: function populate(selector, query, _ref3) {
            var _ref4 = $e815fda779bc047b$var$_slicedToArray(_ref3, 1), state = _ref4[0];
            query.checks.push({
                type: $e815fda779bc047b$var$Type.STATE,
                value: state
            });
        }
    },
    {
        name: 'id',
        query: true,
        regex: '\\#(' + $e815fda779bc047b$var$tokens.id + ')',
        populate: function populate(selector, query, _ref5) {
            var _ref6 = $e815fda779bc047b$var$_slicedToArray(_ref5, 1), id = _ref6[0];
            query.checks.push({
                type: $e815fda779bc047b$var$Type.ID,
                value: $e815fda779bc047b$var$cleanMetaChars(id)
            });
        }
    },
    {
        name: 'className',
        query: true,
        regex: '\\.(' + $e815fda779bc047b$var$tokens.className + ')',
        populate: function populate(selector, query, _ref7) {
            var _ref8 = $e815fda779bc047b$var$_slicedToArray(_ref7, 1), className = _ref8[0];
            query.checks.push({
                type: $e815fda779bc047b$var$Type.CLASS,
                value: $e815fda779bc047b$var$cleanMetaChars(className)
            });
        }
    },
    {
        name: 'dataExists',
        query: true,
        regex: '\\[\\s*(' + $e815fda779bc047b$var$tokens.variable + ')\\s*\\]',
        populate: function populate(selector, query, _ref9) {
            var _ref10 = $e815fda779bc047b$var$_slicedToArray(_ref9, 1), variable = _ref10[0];
            query.checks.push({
                type: $e815fda779bc047b$var$Type.DATA_EXIST,
                field: $e815fda779bc047b$var$cleanMetaChars(variable)
            });
        }
    },
    {
        name: 'dataCompare',
        query: true,
        regex: '\\[\\s*(' + $e815fda779bc047b$var$tokens.variable + ')\\s*(' + $e815fda779bc047b$var$tokens.comparatorOp + ')\\s*(' + $e815fda779bc047b$var$tokens.value + ')\\s*\\]',
        populate: function populate(selector, query, _ref11) {
            var _ref12 = $e815fda779bc047b$var$_slicedToArray(_ref11, 3), variable = _ref12[0], comparatorOp = _ref12[1], value = _ref12[2];
            var valueIsString = new RegExp('^' + $e815fda779bc047b$var$tokens.string + '$').exec(value) != null;
            if (valueIsString) value = value.substring(1, value.length - 1);
            else value = parseFloat(value);
            query.checks.push({
                type: $e815fda779bc047b$var$Type.DATA_COMPARE,
                field: $e815fda779bc047b$var$cleanMetaChars(variable),
                operator: comparatorOp,
                value: value
            });
        }
    },
    {
        name: 'dataBool',
        query: true,
        regex: '\\[\\s*(' + $e815fda779bc047b$var$tokens.boolOp + ')\\s*(' + $e815fda779bc047b$var$tokens.variable + ')\\s*\\]',
        populate: function populate(selector, query, _ref13) {
            var _ref14 = $e815fda779bc047b$var$_slicedToArray(_ref13, 2), boolOp = _ref14[0], variable = _ref14[1];
            query.checks.push({
                type: $e815fda779bc047b$var$Type.DATA_BOOL,
                field: $e815fda779bc047b$var$cleanMetaChars(variable),
                operator: boolOp
            });
        }
    },
    {
        name: 'metaCompare',
        query: true,
        regex: '\\[\\[\\s*(' + $e815fda779bc047b$var$tokens.meta + ')\\s*(' + $e815fda779bc047b$var$tokens.comparatorOp + ')\\s*(' + $e815fda779bc047b$var$tokens.number + ')\\s*\\]\\]',
        populate: function populate(selector, query, _ref15) {
            var _ref16 = $e815fda779bc047b$var$_slicedToArray(_ref15, 3), meta = _ref16[0], comparatorOp = _ref16[1], number = _ref16[2];
            query.checks.push({
                type: $e815fda779bc047b$var$Type.META_COMPARE,
                field: $e815fda779bc047b$var$cleanMetaChars(meta),
                operator: comparatorOp,
                value: parseFloat(number)
            });
        }
    },
    {
        name: 'nextQuery',
        separator: true,
        regex: $e815fda779bc047b$var$tokens.separator,
        populate: function populate(selector, query) {
            var currentSubject = selector.currentSubject;
            var edgeCount = selector.edgeCount;
            var compoundCount = selector.compoundCount;
            var lastQ = selector[selector.length - 1];
            if (currentSubject != null) {
                lastQ.subject = currentSubject;
                selector.currentSubject = null;
            }
            lastQ.edgeCount = edgeCount;
            lastQ.compoundCount = compoundCount;
            selector.edgeCount = 0;
            selector.compoundCount = 0;
            // go on to next query
            var nextQuery = selector[selector.length++] = $e815fda779bc047b$var$newQuery();
            return nextQuery; // this is the new query to be filled by the following exprs
        }
    },
    {
        name: 'directedEdge',
        separator: true,
        regex: $e815fda779bc047b$var$tokens.directedEdge,
        populate: function populate(selector, query) {
            if (selector.currentSubject == null) {
                // undirected edge
                var edgeQuery = $e815fda779bc047b$var$newQuery();
                var source = query;
                var target = $e815fda779bc047b$var$newQuery();
                edgeQuery.checks.push({
                    type: $e815fda779bc047b$var$Type.DIRECTED_EDGE,
                    source: source,
                    target: target
                });
                // the query in the selector should be the edge rather than the source
                $e815fda779bc047b$var$replaceLastQuery(selector, query, edgeQuery);
                selector.edgeCount++;
                // we're now populating the target query with expressions that follow
                return target;
            } else {
                // source/target
                var srcTgtQ = $e815fda779bc047b$var$newQuery();
                var _source = query;
                var _target = $e815fda779bc047b$var$newQuery();
                srcTgtQ.checks.push({
                    type: $e815fda779bc047b$var$Type.NODE_SOURCE,
                    source: _source,
                    target: _target
                });
                // the query in the selector should be the neighbourhood rather than the node
                $e815fda779bc047b$var$replaceLastQuery(selector, query, srcTgtQ);
                selector.edgeCount++;
                return _target; // now populating the target with the following expressions
            }
        }
    },
    {
        name: 'undirectedEdge',
        separator: true,
        regex: $e815fda779bc047b$var$tokens.undirectedEdge,
        populate: function populate(selector, query) {
            if (selector.currentSubject == null) {
                // undirected edge
                var edgeQuery = $e815fda779bc047b$var$newQuery();
                var source = query;
                var target = $e815fda779bc047b$var$newQuery();
                edgeQuery.checks.push({
                    type: $e815fda779bc047b$var$Type.UNDIRECTED_EDGE,
                    nodes: [
                        source,
                        target
                    ]
                });
                // the query in the selector should be the edge rather than the source
                $e815fda779bc047b$var$replaceLastQuery(selector, query, edgeQuery);
                selector.edgeCount++;
                // we're now populating the target query with expressions that follow
                return target;
            } else {
                // neighbourhood
                var nhoodQ = $e815fda779bc047b$var$newQuery();
                var node = query;
                var neighbor = $e815fda779bc047b$var$newQuery();
                nhoodQ.checks.push({
                    type: $e815fda779bc047b$var$Type.NODE_NEIGHBOR,
                    node: node,
                    neighbor: neighbor
                });
                // the query in the selector should be the neighbourhood rather than the node
                $e815fda779bc047b$var$replaceLastQuery(selector, query, nhoodQ);
                return neighbor; // now populating the neighbor with following expressions
            }
        }
    },
    {
        name: 'child',
        separator: true,
        regex: $e815fda779bc047b$var$tokens.child,
        populate: function populate(selector, query) {
            if (selector.currentSubject == null) {
                // default: child query
                var parentChildQuery = $e815fda779bc047b$var$newQuery();
                var child = $e815fda779bc047b$var$newQuery();
                var parent = selector[selector.length - 1];
                parentChildQuery.checks.push({
                    type: $e815fda779bc047b$var$Type.CHILD,
                    parent: parent,
                    child: child
                });
                // the query in the selector should be the '>' itself
                $e815fda779bc047b$var$replaceLastQuery(selector, query, parentChildQuery);
                selector.compoundCount++;
                // we're now populating the child query with expressions that follow
                return child;
            } else if (selector.currentSubject === query) {
                // compound split query
                var compound = $e815fda779bc047b$var$newQuery();
                var left = selector[selector.length - 1];
                var right = $e815fda779bc047b$var$newQuery();
                var subject = $e815fda779bc047b$var$newQuery();
                var _child = $e815fda779bc047b$var$newQuery();
                var _parent = $e815fda779bc047b$var$newQuery();
                // set up the root compound q
                compound.checks.push({
                    type: $e815fda779bc047b$var$Type.COMPOUND_SPLIT,
                    left: left,
                    right: right,
                    subject: subject
                });
                // populate the subject and replace the q at the old spot (within left) with TRUE
                subject.checks = query.checks; // take the checks from the left
                query.checks = [
                    {
                        type: $e815fda779bc047b$var$Type.TRUE
                    }
                ]; // checks under left refs the subject implicitly
                // set up the right q
                _parent.checks.push({
                    type: $e815fda779bc047b$var$Type.TRUE
                }); // parent implicitly refs the subject
                right.checks.push({
                    type: $e815fda779bc047b$var$Type.PARENT,
                    // type is swapped on right side queries
                    parent: _parent,
                    child: _child // empty for now
                });
                $e815fda779bc047b$var$replaceLastQuery(selector, left, compound);
                // update the ref since we moved things around for `query`
                selector.currentSubject = subject;
                selector.compoundCount++;
                return _child; // now populating the right side's child
            } else {
                // parent query
                // info for parent query
                var _parent2 = $e815fda779bc047b$var$newQuery();
                var _child2 = $e815fda779bc047b$var$newQuery();
                var pcQChecks = [
                    {
                        type: $e815fda779bc047b$var$Type.PARENT,
                        parent: _parent2,
                        child: _child2
                    }
                ];
                // the parent-child query takes the place of the query previously being populated
                _parent2.checks = query.checks; // the previous query contains the checks for the parent
                query.checks = pcQChecks; // pc query takes over
                selector.compoundCount++;
                return _child2; // we're now populating the child
            }
        }
    },
    {
        name: 'descendant',
        separator: true,
        regex: $e815fda779bc047b$var$tokens.descendant,
        populate: function populate(selector, query) {
            if (selector.currentSubject == null) {
                // default: descendant query
                var ancChQuery = $e815fda779bc047b$var$newQuery();
                var descendant = $e815fda779bc047b$var$newQuery();
                var ancestor = selector[selector.length - 1];
                ancChQuery.checks.push({
                    type: $e815fda779bc047b$var$Type.DESCENDANT,
                    ancestor: ancestor,
                    descendant: descendant
                });
                // the query in the selector should be the '>' itself
                $e815fda779bc047b$var$replaceLastQuery(selector, query, ancChQuery);
                selector.compoundCount++;
                // we're now populating the descendant query with expressions that follow
                return descendant;
            } else if (selector.currentSubject === query) {
                // compound split query
                var compound = $e815fda779bc047b$var$newQuery();
                var left = selector[selector.length - 1];
                var right = $e815fda779bc047b$var$newQuery();
                var subject = $e815fda779bc047b$var$newQuery();
                var _descendant = $e815fda779bc047b$var$newQuery();
                var _ancestor = $e815fda779bc047b$var$newQuery();
                // set up the root compound q
                compound.checks.push({
                    type: $e815fda779bc047b$var$Type.COMPOUND_SPLIT,
                    left: left,
                    right: right,
                    subject: subject
                });
                // populate the subject and replace the q at the old spot (within left) with TRUE
                subject.checks = query.checks; // take the checks from the left
                query.checks = [
                    {
                        type: $e815fda779bc047b$var$Type.TRUE
                    }
                ]; // checks under left refs the subject implicitly
                // set up the right q
                _ancestor.checks.push({
                    type: $e815fda779bc047b$var$Type.TRUE
                }); // ancestor implicitly refs the subject
                right.checks.push({
                    type: $e815fda779bc047b$var$Type.ANCESTOR,
                    // type is swapped on right side queries
                    ancestor: _ancestor,
                    descendant: _descendant // empty for now
                });
                $e815fda779bc047b$var$replaceLastQuery(selector, left, compound);
                // update the ref since we moved things around for `query`
                selector.currentSubject = subject;
                selector.compoundCount++;
                return _descendant; // now populating the right side's descendant
            } else {
                // ancestor query
                // info for parent query
                var _ancestor2 = $e815fda779bc047b$var$newQuery();
                var _descendant2 = $e815fda779bc047b$var$newQuery();
                var adQChecks = [
                    {
                        type: $e815fda779bc047b$var$Type.ANCESTOR,
                        ancestor: _ancestor2,
                        descendant: _descendant2
                    }
                ];
                // the parent-child query takes the place of the query previously being populated
                _ancestor2.checks = query.checks; // the previous query contains the checks for the parent
                query.checks = adQChecks; // pc query takes over
                selector.compoundCount++;
                return _descendant2; // we're now populating the child
            }
        }
    },
    {
        name: 'subject',
        modifier: true,
        regex: $e815fda779bc047b$var$tokens.subject,
        populate: function populate(selector, query) {
            if (selector.currentSubject != null && selector.currentSubject !== query) {
                $e815fda779bc047b$var$warn('Redefinition of subject in selector `' + selector.toString() + '`');
                return false;
            }
            selector.currentSubject = query;
            var topQ = selector[selector.length - 1];
            var topChk = topQ.checks[0];
            var topType = topChk == null ? null : topChk.type;
            if (topType === $e815fda779bc047b$var$Type.DIRECTED_EDGE) // directed edge with subject on the target
            // change to target node check
            topChk.type = $e815fda779bc047b$var$Type.NODE_TARGET;
            else if (topType === $e815fda779bc047b$var$Type.UNDIRECTED_EDGE) {
                // undirected edge with subject on the second node
                // change to neighbor check
                topChk.type = $e815fda779bc047b$var$Type.NODE_NEIGHBOR;
                topChk.node = topChk.nodes[1]; // second node is subject
                topChk.neighbor = topChk.nodes[0];
                // clean up unused fields for new type
                topChk.nodes = null;
            }
        }
    }
];
$e815fda779bc047b$var$exprs.forEach(function(e) {
    return e.regexObj = new RegExp('^' + e.regex);
});
/**
 * Of all the expressions, find the first match in the remaining text.
 * @param {string} remaining The remaining text to parse
 * @returns The matched expression and the newly remaining text `{ expr, match, name, remaining }`
 */ var $e815fda779bc047b$var$consumeExpr = function consumeExpr(remaining) {
    var expr;
    var match;
    var name;
    for(var j = 0; j < $e815fda779bc047b$var$exprs.length; j++){
        var e = $e815fda779bc047b$var$exprs[j];
        var n = e.name;
        var m1 = remaining.match(e.regexObj);
        if (m1 != null) {
            match = m1;
            expr = e;
            name = n;
            var consumed = m1[0];
            remaining = remaining.substring(consumed.length);
            break; // we've consumed one expr, so we can return now
        }
    }
    return {
        expr: expr,
        match: match,
        name: name,
        remaining: remaining
    };
};
/**
 * Consume all the leading whitespace
 * @param {string} remaining The text to consume
 * @returns The text with the leading whitespace removed
 */ var $e815fda779bc047b$var$consumeWhitespace = function consumeWhitespace(remaining) {
    var match = remaining.match(/^\s+/);
    if (match) {
        var consumed = match[0];
        remaining = remaining.substring(consumed.length);
    }
    return remaining;
};
/**
 * Parse the string and store the parsed representation in the Selector.
 * @param {string} selector The selector string
 * @returns `true` if the selector was successfully parsed, `false` otherwise
 */ var $e815fda779bc047b$var$parse = function parse(selector) {
    var self1 = this;
    var remaining = self1.inputText = selector;
    var currentQuery = self1[0] = $e815fda779bc047b$var$newQuery();
    self1.length = 1;
    remaining = $e815fda779bc047b$var$consumeWhitespace(remaining); // get rid of leading whitespace
    for(;;){
        var exprInfo = $e815fda779bc047b$var$consumeExpr(remaining);
        if (exprInfo.expr == null) {
            $e815fda779bc047b$var$warn('The selector `' + selector + '`is invalid');
            return false;
        } else {
            var args = exprInfo.match.slice(1);
            // let the token populate the selector object in currentQuery
            var ret = exprInfo.expr.populate(self1, currentQuery, args);
            if (ret === false) return false; // exit if population failed
            else if (ret != null) currentQuery = ret; // change the current query to be filled if the expr specifies
        }
        remaining = exprInfo.remaining;
        // we're done when there's nothing left to parse
        if (remaining.match(/^\s*$/)) break;
    }
    var lastQ = self1[self1.length - 1];
    if (self1.currentSubject != null) lastQ.subject = self1.currentSubject;
    lastQ.edgeCount = self1.edgeCount;
    lastQ.compoundCount = self1.compoundCount;
    for(var i = 0; i < self1.length; i++){
        var q = self1[i];
        // in future, this could potentially be allowed if there were operator precedence and detection of invalid combinations
        if (q.compoundCount > 0 && q.edgeCount > 0) {
            $e815fda779bc047b$var$warn('The selector `' + selector + '` is invalid because it uses both a compound selector and an edge selector');
            return false;
        }
        if (q.edgeCount > 1) {
            $e815fda779bc047b$var$warn('The selector `' + selector + '` is invalid because it uses multiple edge selectors');
            return false;
        } else if (q.edgeCount === 1) $e815fda779bc047b$var$warn('The selector `' + selector + '` is deprecated.  Edge selectors do not take effect on changes to source and target nodes after an edge is added, for performance reasons.  Use a class or data selector on edges instead, updating the class or data of an edge when your app detects a change in source or target nodes.');
    }
    return true; // success
};
/**
 * Get the selector represented as a string.  This value uses default formatting,
 * so things like spacing may differ from the input text passed to the constructor.
 * @returns {string} The selector string
 */ var $e815fda779bc047b$var$toString = function toString() {
    if (this.toStringCache != null) return this.toStringCache;
    var clean = function clean(obj) {
        if (obj == null) return '';
        else return obj;
    };
    var cleanVal = function cleanVal(val) {
        if ($e815fda779bc047b$var$string(val)) return '"' + val + '"';
        else return clean(val);
    };
    var space = function space(val) {
        return ' ' + val + ' ';
    };
    var checkToString = function checkToString(check, subject) {
        var type = check.type, value = check.value;
        switch(type){
            case $e815fda779bc047b$var$Type.GROUP:
                var group = clean(value);
                return group.substring(0, group.length - 1);
            case $e815fda779bc047b$var$Type.DATA_COMPARE:
                var field = check.field, operator = check.operator;
                return '[' + field + space(clean(operator)) + cleanVal(value) + ']';
            case $e815fda779bc047b$var$Type.DATA_BOOL:
                var _operator = check.operator, _field = check.field;
                return '[' + clean(_operator) + _field + ']';
            case $e815fda779bc047b$var$Type.DATA_EXIST:
                var _field2 = check.field;
                return '[' + _field2 + ']';
            case $e815fda779bc047b$var$Type.META_COMPARE:
                var _operator2 = check.operator, _field3 = check.field;
                return '[[' + _field3 + space(clean(_operator2)) + cleanVal(value) + ']]';
            case $e815fda779bc047b$var$Type.STATE:
                return value;
            case $e815fda779bc047b$var$Type.ID:
                return '#' + value;
            case $e815fda779bc047b$var$Type.CLASS:
                return '.' + value;
            case $e815fda779bc047b$var$Type.PARENT:
            case $e815fda779bc047b$var$Type.CHILD:
                return queryToString(check.parent, subject) + space('>') + queryToString(check.child, subject);
            case $e815fda779bc047b$var$Type.ANCESTOR:
            case $e815fda779bc047b$var$Type.DESCENDANT:
                return queryToString(check.ancestor, subject) + ' ' + queryToString(check.descendant, subject);
            case $e815fda779bc047b$var$Type.COMPOUND_SPLIT:
                var lhs = queryToString(check.left, subject);
                var sub = queryToString(check.subject, subject);
                var rhs = queryToString(check.right, subject);
                return lhs + (lhs.length > 0 ? ' ' : '') + sub + rhs;
            case $e815fda779bc047b$var$Type.TRUE:
                return '';
        }
    };
    var queryToString = function queryToString(query, subject) {
        return query.checks.reduce(function(str, chk, i) {
            return str + (subject === query && i === 0 ? '$' : '') + checkToString(chk, subject);
        }, '');
    };
    var str = '';
    for(var i = 0; i < this.length; i++){
        var query = this[i];
        str += queryToString(query, query.subject);
        if (this.length > 1 && i < this.length - 1) str += ', ';
    }
    this.toStringCache = str;
    return str;
};
var $e815fda779bc047b$var$parse$1 = {
    parse: $e815fda779bc047b$var$parse,
    toString: $e815fda779bc047b$var$toString
};
var $e815fda779bc047b$var$valCmp = function valCmp(fieldVal, operator, value) {
    var matches;
    var isFieldStr = $e815fda779bc047b$var$string(fieldVal);
    var isFieldNum = $e815fda779bc047b$var$number$1(fieldVal);
    var isValStr = $e815fda779bc047b$var$string(value);
    var fieldStr, valStr;
    var caseInsensitive = false;
    var notExpr = false;
    var isIneqCmp = false;
    if (operator.indexOf('!') >= 0) {
        operator = operator.replace('!', '');
        notExpr = true;
    }
    if (operator.indexOf('@') >= 0) {
        operator = operator.replace('@', '');
        caseInsensitive = true;
    }
    if (isFieldStr || isValStr || caseInsensitive) {
        fieldStr = !isFieldStr && !isFieldNum ? '' : '' + fieldVal;
        valStr = '' + value;
    }
    // if we're doing a case insensitive comparison, then we're using a STRING comparison
    // even if we're comparing numbers
    if (caseInsensitive) {
        fieldVal = fieldStr = fieldStr.toLowerCase();
        value = valStr = valStr.toLowerCase();
    }
    switch(operator){
        case '*=':
            matches = fieldStr.indexOf(valStr) >= 0;
            break;
        case '$=':
            matches = fieldStr.indexOf(valStr, fieldStr.length - valStr.length) >= 0;
            break;
        case '^=':
            matches = fieldStr.indexOf(valStr) === 0;
            break;
        case '=':
            matches = fieldVal === value;
            break;
        case '>':
            isIneqCmp = true;
            matches = fieldVal > value;
            break;
        case '>=':
            isIneqCmp = true;
            matches = fieldVal >= value;
            break;
        case '<':
            isIneqCmp = true;
            matches = fieldVal < value;
            break;
        case '<=':
            isIneqCmp = true;
            matches = fieldVal <= value;
            break;
        default:
            matches = false;
            break;
    }
    // apply the not op, but null vals for inequalities should always stay non-matching
    if (notExpr && (fieldVal != null || !isIneqCmp)) matches = !matches;
    return matches;
};
var $e815fda779bc047b$var$boolCmp = function boolCmp(fieldVal, operator) {
    switch(operator){
        case '?':
            return fieldVal ? true : false;
        case '!':
            return fieldVal ? false : true;
        case '^':
            return fieldVal === undefined;
    }
};
var $e815fda779bc047b$var$existCmp = function existCmp(fieldVal) {
    return fieldVal !== undefined;
};
var $e815fda779bc047b$var$data$1 = function data(ele, field) {
    return ele.data(field);
};
var $e815fda779bc047b$var$meta = function meta(ele, field) {
    return ele[field]();
};
/** A lookup of `match(check, ele)` functions by `Type` int */ var $e815fda779bc047b$var$match = [];
/**
 * Returns whether the query matches for the element
 * @param query The `{ type, value, ... }` query object
 * @param ele The element to compare against
*/ var $e815fda779bc047b$var$matches$1 = function matches(query, ele) {
    return query.checks.every(function(chk) {
        return $e815fda779bc047b$var$match[chk.type](chk, ele);
    });
};
$e815fda779bc047b$var$match[$e815fda779bc047b$var$Type.GROUP] = function(check, ele) {
    var group = check.value;
    return group === '*' || group === ele.group();
};
$e815fda779bc047b$var$match[$e815fda779bc047b$var$Type.STATE] = function(check, ele) {
    var stateSelector = check.value;
    return $e815fda779bc047b$var$stateSelectorMatches(stateSelector, ele);
};
$e815fda779bc047b$var$match[$e815fda779bc047b$var$Type.ID] = function(check, ele) {
    var id = check.value;
    return ele.id() === id;
};
$e815fda779bc047b$var$match[$e815fda779bc047b$var$Type.CLASS] = function(check, ele) {
    var cls = check.value;
    return ele.hasClass(cls);
};
$e815fda779bc047b$var$match[$e815fda779bc047b$var$Type.META_COMPARE] = function(check, ele) {
    var field = check.field, operator = check.operator, value = check.value;
    return $e815fda779bc047b$var$valCmp($e815fda779bc047b$var$meta(ele, field), operator, value);
};
$e815fda779bc047b$var$match[$e815fda779bc047b$var$Type.DATA_COMPARE] = function(check, ele) {
    var field = check.field, operator = check.operator, value = check.value;
    return $e815fda779bc047b$var$valCmp($e815fda779bc047b$var$data$1(ele, field), operator, value);
};
$e815fda779bc047b$var$match[$e815fda779bc047b$var$Type.DATA_BOOL] = function(check, ele) {
    var field = check.field, operator = check.operator;
    return $e815fda779bc047b$var$boolCmp($e815fda779bc047b$var$data$1(ele, field), operator);
};
$e815fda779bc047b$var$match[$e815fda779bc047b$var$Type.DATA_EXIST] = function(check, ele) {
    var field = check.field;
    check.operator;
    return $e815fda779bc047b$var$existCmp($e815fda779bc047b$var$data$1(ele, field));
};
$e815fda779bc047b$var$match[$e815fda779bc047b$var$Type.UNDIRECTED_EDGE] = function(check, ele) {
    var qA = check.nodes[0];
    var qB = check.nodes[1];
    var src = ele.source();
    var tgt = ele.target();
    return $e815fda779bc047b$var$matches$1(qA, src) && $e815fda779bc047b$var$matches$1(qB, tgt) || $e815fda779bc047b$var$matches$1(qB, src) && $e815fda779bc047b$var$matches$1(qA, tgt);
};
$e815fda779bc047b$var$match[$e815fda779bc047b$var$Type.NODE_NEIGHBOR] = function(check, ele) {
    return $e815fda779bc047b$var$matches$1(check.node, ele) && ele.neighborhood().some(function(n) {
        return n.isNode() && $e815fda779bc047b$var$matches$1(check.neighbor, n);
    });
};
$e815fda779bc047b$var$match[$e815fda779bc047b$var$Type.DIRECTED_EDGE] = function(check, ele) {
    return $e815fda779bc047b$var$matches$1(check.source, ele.source()) && $e815fda779bc047b$var$matches$1(check.target, ele.target());
};
$e815fda779bc047b$var$match[$e815fda779bc047b$var$Type.NODE_SOURCE] = function(check, ele) {
    return $e815fda779bc047b$var$matches$1(check.source, ele) && ele.outgoers().some(function(n) {
        return n.isNode() && $e815fda779bc047b$var$matches$1(check.target, n);
    });
};
$e815fda779bc047b$var$match[$e815fda779bc047b$var$Type.NODE_TARGET] = function(check, ele) {
    return $e815fda779bc047b$var$matches$1(check.target, ele) && ele.incomers().some(function(n) {
        return n.isNode() && $e815fda779bc047b$var$matches$1(check.source, n);
    });
};
$e815fda779bc047b$var$match[$e815fda779bc047b$var$Type.CHILD] = function(check, ele) {
    return $e815fda779bc047b$var$matches$1(check.child, ele) && $e815fda779bc047b$var$matches$1(check.parent, ele.parent());
};
$e815fda779bc047b$var$match[$e815fda779bc047b$var$Type.PARENT] = function(check, ele) {
    return $e815fda779bc047b$var$matches$1(check.parent, ele) && ele.children().some(function(c) {
        return $e815fda779bc047b$var$matches$1(check.child, c);
    });
};
$e815fda779bc047b$var$match[$e815fda779bc047b$var$Type.DESCENDANT] = function(check, ele) {
    return $e815fda779bc047b$var$matches$1(check.descendant, ele) && ele.ancestors().some(function(a) {
        return $e815fda779bc047b$var$matches$1(check.ancestor, a);
    });
};
$e815fda779bc047b$var$match[$e815fda779bc047b$var$Type.ANCESTOR] = function(check, ele) {
    return $e815fda779bc047b$var$matches$1(check.ancestor, ele) && ele.descendants().some(function(d) {
        return $e815fda779bc047b$var$matches$1(check.descendant, d);
    });
};
$e815fda779bc047b$var$match[$e815fda779bc047b$var$Type.COMPOUND_SPLIT] = function(check, ele) {
    return $e815fda779bc047b$var$matches$1(check.subject, ele) && $e815fda779bc047b$var$matches$1(check.left, ele) && $e815fda779bc047b$var$matches$1(check.right, ele);
};
$e815fda779bc047b$var$match[$e815fda779bc047b$var$Type.TRUE] = function() {
    return true;
};
$e815fda779bc047b$var$match[$e815fda779bc047b$var$Type.COLLECTION] = function(check, ele) {
    var collection = check.value;
    return collection.has(ele);
};
$e815fda779bc047b$var$match[$e815fda779bc047b$var$Type.FILTER] = function(check, ele) {
    var filter = check.value;
    return filter(ele);
};
// filter an existing collection
var $e815fda779bc047b$var$filter = function filter(collection) {
    var self1 = this;
    // for 1 id #foo queries, just get the element
    if (self1.length === 1 && self1[0].checks.length === 1 && self1[0].checks[0].type === $e815fda779bc047b$var$Type.ID) return collection.getElementById(self1[0].checks[0].value).collection();
    var selectorFunction = function selectorFunction(element) {
        for(var j = 0; j < self1.length; j++){
            var query = self1[j];
            if ($e815fda779bc047b$var$matches$1(query, element)) return true;
        }
        return false;
    };
    if (self1.text() == null) selectorFunction = function selectorFunction() {
        return true;
    };
    return collection.filter(selectorFunction);
}; // filter
// does selector match a single element?
var $e815fda779bc047b$var$matches = function matches(ele) {
    var self1 = this;
    for(var j = 0; j < self1.length; j++){
        var query = self1[j];
        if ($e815fda779bc047b$var$matches$1(query, ele)) return true;
    }
    return false;
}; // matches
var $e815fda779bc047b$var$matching = {
    matches: $e815fda779bc047b$var$matches,
    filter: $e815fda779bc047b$var$filter
};
var $e815fda779bc047b$var$Selector = function Selector(selector) {
    this.inputText = selector;
    this.currentSubject = null;
    this.compoundCount = 0;
    this.edgeCount = 0;
    this.length = 0;
    if (selector == null || $e815fda779bc047b$var$string(selector) && selector.match(/^\s*$/)) ;
    else if ($e815fda779bc047b$var$elementOrCollection(selector)) this.addQuery({
        checks: [
            {
                type: $e815fda779bc047b$var$Type.COLLECTION,
                value: selector.collection()
            }
        ]
    });
    else if ($e815fda779bc047b$var$fn$6(selector)) this.addQuery({
        checks: [
            {
                type: $e815fda779bc047b$var$Type.FILTER,
                value: selector
            }
        ]
    });
    else if ($e815fda779bc047b$var$string(selector)) {
        if (!this.parse(selector)) this.invalid = true;
    } else $e815fda779bc047b$var$error('A selector must be created from a string; found ');
};
var $e815fda779bc047b$var$selfn = $e815fda779bc047b$var$Selector.prototype;
[
    $e815fda779bc047b$var$parse$1,
    $e815fda779bc047b$var$matching
].forEach(function(p) {
    return $e815fda779bc047b$var$extend($e815fda779bc047b$var$selfn, p);
});
$e815fda779bc047b$var$selfn.text = function() {
    return this.inputText;
};
$e815fda779bc047b$var$selfn.size = function() {
    return this.length;
};
$e815fda779bc047b$var$selfn.eq = function(i) {
    return this[i];
};
$e815fda779bc047b$var$selfn.sameText = function(otherSel) {
    return !this.invalid && !otherSel.invalid && this.text() === otherSel.text();
};
$e815fda779bc047b$var$selfn.addQuery = function(q) {
    this[this.length++] = q;
};
$e815fda779bc047b$var$selfn.selector = $e815fda779bc047b$var$selfn.toString;
var $e815fda779bc047b$var$elesfn$g = {
    allAre: function allAre(selector) {
        var selObj = new $e815fda779bc047b$var$Selector(selector);
        return this.every(function(ele) {
            return selObj.matches(ele);
        });
    },
    is: function is(selector) {
        var selObj = new $e815fda779bc047b$var$Selector(selector);
        return this.some(function(ele) {
            return selObj.matches(ele);
        });
    },
    some: function some(fn, thisArg) {
        for(var i = 0; i < this.length; i++){
            var ret = !thisArg ? fn(this[i], i, this) : fn.apply(thisArg, [
                this[i],
                i,
                this
            ]);
            if (ret) return true;
        }
        return false;
    },
    every: function every(fn, thisArg) {
        for(var i = 0; i < this.length; i++){
            var ret = !thisArg ? fn(this[i], i, this) : fn.apply(thisArg, [
                this[i],
                i,
                this
            ]);
            if (!ret) return false;
        }
        return true;
    },
    same: function same(collection) {
        // cheap collection ref check
        if (this === collection) return true;
        collection = this.cy().collection(collection);
        var thisLength = this.length;
        var collectionLength = collection.length;
        // cheap length check
        if (thisLength !== collectionLength) return false;
        // cheap element ref check
        if (thisLength === 1) return this[0] === collection[0];
        return this.every(function(ele) {
            return collection.hasElementWithId(ele.id());
        });
    },
    anySame: function anySame(collection) {
        collection = this.cy().collection(collection);
        return this.some(function(ele) {
            return collection.hasElementWithId(ele.id());
        });
    },
    allAreNeighbors: function allAreNeighbors(collection) {
        collection = this.cy().collection(collection);
        var nhood = this.neighborhood();
        return collection.every(function(ele) {
            return nhood.hasElementWithId(ele.id());
        });
    },
    contains: function contains(collection) {
        collection = this.cy().collection(collection);
        var self1 = this;
        return collection.every(function(ele) {
            return self1.hasElementWithId(ele.id());
        });
    }
};
$e815fda779bc047b$var$elesfn$g.allAreNeighbours = $e815fda779bc047b$var$elesfn$g.allAreNeighbors;
$e815fda779bc047b$var$elesfn$g.has = $e815fda779bc047b$var$elesfn$g.contains;
$e815fda779bc047b$var$elesfn$g.equal = $e815fda779bc047b$var$elesfn$g.equals = $e815fda779bc047b$var$elesfn$g.same;
var $e815fda779bc047b$var$cache = function cache(fn, name) {
    return function traversalCache(arg1, arg2, arg3, arg4) {
        var selectorOrEles = arg1;
        var eles = this;
        var key;
        if (selectorOrEles == null) key = '';
        else if ($e815fda779bc047b$var$elementOrCollection(selectorOrEles) && selectorOrEles.length === 1) key = selectorOrEles.id();
        if (eles.length === 1 && key) {
            var _p = eles[0]._private;
            var tch = _p.traversalCache = _p.traversalCache || {};
            var ch = tch[name] = tch[name] || [];
            var hash = $e815fda779bc047b$var$hashString(key);
            var cacheHit = ch[hash];
            if (cacheHit) return cacheHit;
            else return ch[hash] = fn.call(eles, arg1, arg2, arg3, arg4);
        } else return fn.call(eles, arg1, arg2, arg3, arg4);
    };
};
var $e815fda779bc047b$var$elesfn$f = {
    parent: function parent(selector) {
        var parents = [];
        // optimisation for single ele call
        if (this.length === 1) {
            var parent = this[0]._private.parent;
            if (parent) return parent;
        }
        for(var i = 0; i < this.length; i++){
            var ele = this[i];
            var _parent = ele._private.parent;
            if (_parent) parents.push(_parent);
        }
        return this.spawn(parents, true).filter(selector);
    },
    parents: function parents(selector) {
        var parents = [];
        var eles = this.parent();
        while(eles.nonempty()){
            for(var i = 0; i < eles.length; i++){
                var ele = eles[i];
                parents.push(ele);
            }
            eles = eles.parent();
        }
        return this.spawn(parents, true).filter(selector);
    },
    commonAncestors: function commonAncestors(selector) {
        var ancestors;
        for(var i = 0; i < this.length; i++){
            var ele = this[i];
            var parents = ele.parents();
            ancestors = ancestors || parents;
            ancestors = ancestors.intersect(parents); // current list must be common with current ele parents set
        }
        return ancestors.filter(selector);
    },
    orphans: function orphans(selector) {
        return this.stdFilter(function(ele) {
            return ele.isOrphan();
        }).filter(selector);
    },
    nonorphans: function nonorphans(selector) {
        return this.stdFilter(function(ele) {
            return ele.isChild();
        }).filter(selector);
    },
    children: $e815fda779bc047b$var$cache(function(selector) {
        var children = [];
        for(var i = 0; i < this.length; i++){
            var ele = this[i];
            var eleChildren = ele._private.children;
            for(var j = 0; j < eleChildren.length; j++)children.push(eleChildren[j]);
        }
        return this.spawn(children, true).filter(selector);
    }, 'children'),
    siblings: function siblings(selector) {
        return this.parent().children().not(this).filter(selector);
    },
    isParent: function isParent() {
        var ele = this[0];
        if (ele) return ele.isNode() && ele._private.children.length !== 0;
    },
    isChildless: function isChildless() {
        var ele = this[0];
        if (ele) return ele.isNode() && ele._private.children.length === 0;
    },
    isChild: function isChild() {
        var ele = this[0];
        if (ele) return ele.isNode() && ele._private.parent != null;
    },
    isOrphan: function isOrphan() {
        var ele = this[0];
        if (ele) return ele.isNode() && ele._private.parent == null;
    },
    descendants: function descendants(selector) {
        var elements = [];
        function add(eles) {
            for(var i = 0; i < eles.length; i++){
                var ele = eles[i];
                elements.push(ele);
                if (ele.children().nonempty()) add(ele.children());
            }
        }
        add(this.children());
        return this.spawn(elements, true).filter(selector);
    }
};
function $e815fda779bc047b$var$forEachCompound(eles, fn, includeSelf, recursiveStep) {
    var q = [];
    var did = new $e815fda779bc047b$var$Set$1();
    var cy = eles.cy();
    var hasCompounds = cy.hasCompoundNodes();
    for(var i = 0; i < eles.length; i++){
        var ele = eles[i];
        if (includeSelf) q.push(ele);
        else if (hasCompounds) recursiveStep(q, did, ele);
    }
    while(q.length > 0){
        var _ele = q.shift();
        fn(_ele);
        did.add(_ele.id());
        if (hasCompounds) recursiveStep(q, did, _ele);
    }
    return eles;
}
function $e815fda779bc047b$var$addChildren(q, did, ele) {
    if (ele.isParent()) {
        var children = ele._private.children;
        for(var i = 0; i < children.length; i++){
            var child = children[i];
            if (!did.has(child.id())) q.push(child);
        }
    }
}
// very efficient version of eles.add( eles.descendants() ).forEach()
// for internal use
$e815fda779bc047b$var$elesfn$f.forEachDown = function(fn) {
    var includeSelf = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    return $e815fda779bc047b$var$forEachCompound(this, fn, includeSelf, $e815fda779bc047b$var$addChildren);
};
function $e815fda779bc047b$var$addParent(q, did, ele) {
    if (ele.isChild()) {
        var parent = ele._private.parent;
        if (!did.has(parent.id())) q.push(parent);
    }
}
$e815fda779bc047b$var$elesfn$f.forEachUp = function(fn) {
    var includeSelf = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    return $e815fda779bc047b$var$forEachCompound(this, fn, includeSelf, $e815fda779bc047b$var$addParent);
};
function $e815fda779bc047b$var$addParentAndChildren(q, did, ele) {
    $e815fda779bc047b$var$addParent(q, did, ele);
    $e815fda779bc047b$var$addChildren(q, did, ele);
}
$e815fda779bc047b$var$elesfn$f.forEachUpAndDown = function(fn) {
    var includeSelf = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    return $e815fda779bc047b$var$forEachCompound(this, fn, includeSelf, $e815fda779bc047b$var$addParentAndChildren);
};
// aliases
$e815fda779bc047b$var$elesfn$f.ancestors = $e815fda779bc047b$var$elesfn$f.parents;
var $e815fda779bc047b$var$fn$5, $e815fda779bc047b$var$elesfn$e;
$e815fda779bc047b$var$fn$5 = $e815fda779bc047b$var$elesfn$e = {
    data: $e815fda779bc047b$var$define.data({
        field: 'data',
        bindingEvent: 'data',
        allowBinding: true,
        allowSetting: true,
        settingEvent: 'data',
        settingTriggersEvent: true,
        triggerFnName: 'trigger',
        allowGetting: true,
        immutableKeys: {
            'id': true,
            'source': true,
            'target': true,
            'parent': true
        },
        updateStyle: true
    }),
    removeData: $e815fda779bc047b$var$define.removeData({
        field: 'data',
        event: 'data',
        triggerFnName: 'trigger',
        triggerEvent: true,
        immutableKeys: {
            'id': true,
            'source': true,
            'target': true,
            'parent': true
        },
        updateStyle: true
    }),
    scratch: $e815fda779bc047b$var$define.data({
        field: 'scratch',
        bindingEvent: 'scratch',
        allowBinding: true,
        allowSetting: true,
        settingEvent: 'scratch',
        settingTriggersEvent: true,
        triggerFnName: 'trigger',
        allowGetting: true,
        updateStyle: true
    }),
    removeScratch: $e815fda779bc047b$var$define.removeData({
        field: 'scratch',
        event: 'scratch',
        triggerFnName: 'trigger',
        triggerEvent: true,
        updateStyle: true
    }),
    rscratch: $e815fda779bc047b$var$define.data({
        field: 'rscratch',
        allowBinding: false,
        allowSetting: true,
        settingTriggersEvent: false,
        allowGetting: true
    }),
    removeRscratch: $e815fda779bc047b$var$define.removeData({
        field: 'rscratch',
        triggerEvent: false
    }),
    id: function id() {
        var ele = this[0];
        if (ele) return ele._private.data.id;
    }
};
// aliases
$e815fda779bc047b$var$fn$5.attr = $e815fda779bc047b$var$fn$5.data;
$e815fda779bc047b$var$fn$5.removeAttr = $e815fda779bc047b$var$fn$5.removeData;
var $e815fda779bc047b$var$data = $e815fda779bc047b$var$elesfn$e;
var $e815fda779bc047b$var$elesfn$d = {};
function $e815fda779bc047b$var$defineDegreeFunction(callback) {
    return function(includeLoops) {
        var self1 = this;
        if (includeLoops === undefined) includeLoops = true;
        if (self1.length === 0) return;
        if (self1.isNode() && !self1.removed()) {
            var degree = 0;
            var node = self1[0];
            var connectedEdges = node._private.edges;
            for(var i = 0; i < connectedEdges.length; i++){
                var edge = connectedEdges[i];
                if (!includeLoops && edge.isLoop()) continue;
                degree += callback(node, edge);
            }
            return degree;
        } else return;
    };
}
$e815fda779bc047b$var$extend($e815fda779bc047b$var$elesfn$d, {
    degree: $e815fda779bc047b$var$defineDegreeFunction(function(node, edge) {
        if (edge.source().same(edge.target())) return 2;
        else return 1;
    }),
    indegree: $e815fda779bc047b$var$defineDegreeFunction(function(node, edge) {
        if (edge.target().same(node)) return 1;
        else return 0;
    }),
    outdegree: $e815fda779bc047b$var$defineDegreeFunction(function(node, edge) {
        if (edge.source().same(node)) return 1;
        else return 0;
    })
});
function $e815fda779bc047b$var$defineDegreeBoundsFunction(degreeFn, callback) {
    return function(includeLoops) {
        var ret;
        var nodes = this.nodes();
        for(var i = 0; i < nodes.length; i++){
            var ele = nodes[i];
            var degree = ele[degreeFn](includeLoops);
            if (degree !== undefined && (ret === undefined || callback(degree, ret))) ret = degree;
        }
        return ret;
    };
}
$e815fda779bc047b$var$extend($e815fda779bc047b$var$elesfn$d, {
    minDegree: $e815fda779bc047b$var$defineDegreeBoundsFunction('degree', function(degree, min) {
        return degree < min;
    }),
    maxDegree: $e815fda779bc047b$var$defineDegreeBoundsFunction('degree', function(degree, max) {
        return degree > max;
    }),
    minIndegree: $e815fda779bc047b$var$defineDegreeBoundsFunction('indegree', function(degree, min) {
        return degree < min;
    }),
    maxIndegree: $e815fda779bc047b$var$defineDegreeBoundsFunction('indegree', function(degree, max) {
        return degree > max;
    }),
    minOutdegree: $e815fda779bc047b$var$defineDegreeBoundsFunction('outdegree', function(degree, min) {
        return degree < min;
    }),
    maxOutdegree: $e815fda779bc047b$var$defineDegreeBoundsFunction('outdegree', function(degree, max) {
        return degree > max;
    })
});
$e815fda779bc047b$var$extend($e815fda779bc047b$var$elesfn$d, {
    totalDegree: function totalDegree(includeLoops) {
        var total = 0;
        var nodes = this.nodes();
        for(var i = 0; i < nodes.length; i++)total += nodes[i].degree(includeLoops);
        return total;
    }
});
var $e815fda779bc047b$var$fn$4, $e815fda779bc047b$var$elesfn$c;
var $e815fda779bc047b$var$beforePositionSet = function beforePositionSet(eles, newPos, silent) {
    for(var i = 0; i < eles.length; i++){
        var ele = eles[i];
        if (!ele.locked()) {
            var oldPos = ele._private.position;
            var delta = {
                x: newPos.x != null ? newPos.x - oldPos.x : 0,
                y: newPos.y != null ? newPos.y - oldPos.y : 0
            };
            if (ele.isParent() && !(delta.x === 0 && delta.y === 0)) ele.children().shift(delta, silent);
            ele.dirtyBoundingBoxCache();
        }
    }
};
var $e815fda779bc047b$var$positionDef = {
    field: 'position',
    bindingEvent: 'position',
    allowBinding: true,
    allowSetting: true,
    settingEvent: 'position',
    settingTriggersEvent: true,
    triggerFnName: 'emitAndNotify',
    allowGetting: true,
    validKeys: [
        'x',
        'y'
    ],
    beforeGet: function beforeGet(ele) {
        ele.updateCompoundBounds();
    },
    beforeSet: function beforeSet(eles, newPos) {
        $e815fda779bc047b$var$beforePositionSet(eles, newPos, false);
    },
    onSet: function onSet(eles) {
        eles.dirtyCompoundBoundsCache();
    },
    canSet: function canSet(ele) {
        return !ele.locked();
    }
};
$e815fda779bc047b$var$fn$4 = $e815fda779bc047b$var$elesfn$c = {
    position: $e815fda779bc047b$var$define.data($e815fda779bc047b$var$positionDef),
    // position but no notification to renderer
    silentPosition: $e815fda779bc047b$var$define.data($e815fda779bc047b$var$extend({}, $e815fda779bc047b$var$positionDef, {
        allowBinding: false,
        allowSetting: true,
        settingTriggersEvent: false,
        allowGetting: false,
        beforeSet: function beforeSet(eles, newPos) {
            $e815fda779bc047b$var$beforePositionSet(eles, newPos, true);
        },
        onSet: function onSet(eles) {
            eles.dirtyCompoundBoundsCache();
        }
    })),
    positions: function positions(pos, silent) {
        if ($e815fda779bc047b$var$plainObject(pos)) {
            if (silent) this.silentPosition(pos);
            else this.position(pos);
        } else if ($e815fda779bc047b$var$fn$6(pos)) {
            var _fn = pos;
            var cy = this.cy();
            cy.startBatch();
            for(var i = 0; i < this.length; i++){
                var ele = this[i];
                var _pos = undefined;
                if (_pos = _fn(ele, i)) {
                    if (silent) ele.silentPosition(_pos);
                    else ele.position(_pos);
                }
            }
            cy.endBatch();
        }
        return this; // chaining
    },
    silentPositions: function silentPositions(pos) {
        return this.positions(pos, true);
    },
    shift: function shift(dim, val, silent) {
        var delta;
        if ($e815fda779bc047b$var$plainObject(dim)) {
            delta = {
                x: $e815fda779bc047b$var$number$1(dim.x) ? dim.x : 0,
                y: $e815fda779bc047b$var$number$1(dim.y) ? dim.y : 0
            };
            silent = val;
        } else if ($e815fda779bc047b$var$string(dim) && $e815fda779bc047b$var$number$1(val)) {
            delta = {
                x: 0,
                y: 0
            };
            delta[dim] = val;
        }
        if (delta != null) {
            var cy = this.cy();
            cy.startBatch();
            for(var i = 0; i < this.length; i++){
                var ele = this[i];
                // exclude any node that is a descendant of the calling collection
                if (cy.hasCompoundNodes() && ele.isChild() && ele.ancestors().anySame(this)) continue;
                var pos = ele.position();
                var newPos = {
                    x: pos.x + delta.x,
                    y: pos.y + delta.y
                };
                if (silent) ele.silentPosition(newPos);
                else ele.position(newPos);
            }
            cy.endBatch();
        }
        return this;
    },
    silentShift: function silentShift(dim, val) {
        if ($e815fda779bc047b$var$plainObject(dim)) this.shift(dim, true);
        else if ($e815fda779bc047b$var$string(dim) && $e815fda779bc047b$var$number$1(val)) this.shift(dim, val, true);
        return this;
    },
    // get/set the rendered (i.e. on screen) positon of the element
    renderedPosition: function renderedPosition(dim, val) {
        var ele = this[0];
        var cy = this.cy();
        var zoom = cy.zoom();
        var pan = cy.pan();
        var rpos = $e815fda779bc047b$var$plainObject(dim) ? dim : undefined;
        var setting = rpos !== undefined || val !== undefined && $e815fda779bc047b$var$string(dim);
        if (ele && ele.isNode()) {
            // must have an element and must be a node to return position
            if (setting) for(var i = 0; i < this.length; i++){
                var _ele = this[i];
                if (val !== undefined) // set one dimension
                _ele.position(dim, (val - pan[dim]) / zoom);
                else if (rpos !== undefined) // set whole position
                _ele.position($e815fda779bc047b$var$renderedToModelPosition(rpos, zoom, pan));
            }
            else {
                // getting
                var pos = ele.position();
                rpos = $e815fda779bc047b$var$modelToRenderedPosition$1(pos, zoom, pan);
                if (dim === undefined) // then return the whole rendered position
                return rpos;
                else // then return the specified dimension
                return rpos[dim];
            }
        } else if (!setting) return undefined; // for empty collection case
        return this; // chaining
    },
    // get/set the position relative to the parent
    relativePosition: function relativePosition(dim, val) {
        var ele = this[0];
        var cy = this.cy();
        var ppos = $e815fda779bc047b$var$plainObject(dim) ? dim : undefined;
        var setting = ppos !== undefined || val !== undefined && $e815fda779bc047b$var$string(dim);
        var hasCompoundNodes = cy.hasCompoundNodes();
        if (ele && ele.isNode()) {
            // must have an element and must be a node to return position
            if (setting) for(var i = 0; i < this.length; i++){
                var _ele2 = this[i];
                var parent = hasCompoundNodes ? _ele2.parent() : null;
                var hasParent = parent && parent.length > 0;
                var relativeToParent = hasParent;
                if (hasParent) parent = parent[0];
                var origin = relativeToParent ? parent.position() : {
                    x: 0,
                    y: 0
                };
                if (val !== undefined) // set one dimension
                _ele2.position(dim, val + origin[dim]);
                else if (ppos !== undefined) // set whole position
                _ele2.position({
                    x: ppos.x + origin.x,
                    y: ppos.y + origin.y
                });
            }
            else {
                // getting
                var pos = ele.position();
                var _parent = hasCompoundNodes ? ele.parent() : null;
                var _hasParent = _parent && _parent.length > 0;
                var _relativeToParent = _hasParent;
                if (_hasParent) _parent = _parent[0];
                var _origin = _relativeToParent ? _parent.position() : {
                    x: 0,
                    y: 0
                };
                ppos = {
                    x: pos.x - _origin.x,
                    y: pos.y - _origin.y
                };
                if (dim === undefined) // then return the whole rendered position
                return ppos;
                else // then return the specified dimension
                return ppos[dim];
            }
        } else if (!setting) return undefined; // for empty collection case
        return this; // chaining
    }
};
// aliases
$e815fda779bc047b$var$fn$4.modelPosition = $e815fda779bc047b$var$fn$4.point = $e815fda779bc047b$var$fn$4.position;
$e815fda779bc047b$var$fn$4.modelPositions = $e815fda779bc047b$var$fn$4.points = $e815fda779bc047b$var$fn$4.positions;
$e815fda779bc047b$var$fn$4.renderedPoint = $e815fda779bc047b$var$fn$4.renderedPosition;
$e815fda779bc047b$var$fn$4.relativePoint = $e815fda779bc047b$var$fn$4.relativePosition;
var $e815fda779bc047b$var$position = $e815fda779bc047b$var$elesfn$c;
var $e815fda779bc047b$var$fn$3, $e815fda779bc047b$var$elesfn$b;
$e815fda779bc047b$var$fn$3 = $e815fda779bc047b$var$elesfn$b = {};
$e815fda779bc047b$var$elesfn$b.renderedBoundingBox = function(options) {
    var bb = this.boundingBox(options);
    var cy = this.cy();
    var zoom = cy.zoom();
    var pan = cy.pan();
    var x1 = bb.x1 * zoom + pan.x;
    var x2 = bb.x2 * zoom + pan.x;
    var y1 = bb.y1 * zoom + pan.y;
    var y2 = bb.y2 * zoom + pan.y;
    return {
        x1: x1,
        x2: x2,
        y1: y1,
        y2: y2,
        w: x2 - x1,
        h: y2 - y1
    };
};
$e815fda779bc047b$var$elesfn$b.dirtyCompoundBoundsCache = function() {
    var silent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var cy = this.cy();
    if (!cy.styleEnabled() || !cy.hasCompoundNodes()) return this;
    this.forEachUp(function(ele) {
        if (ele.isParent()) {
            var _p = ele._private;
            _p.compoundBoundsClean = false;
            _p.bbCache = null;
            if (!silent) ele.emitAndNotify('bounds');
        }
    });
    return this;
};
$e815fda779bc047b$var$elesfn$b.updateCompoundBounds = function() {
    var force = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var cy = this.cy();
    // not possible to do on non-compound graphs or with the style disabled
    if (!cy.styleEnabled() || !cy.hasCompoundNodes()) return this;
    // save cycles when batching -- but bounds will be stale (or not exist yet)
    if (!force && cy.batching()) return this;
    function update(parent) {
        if (!parent.isParent()) return;
        var _p = parent._private;
        var children = parent.children();
        var includeLabels = parent.pstyle('compound-sizing-wrt-labels').value === 'include';
        var min = {
            width: {
                val: parent.pstyle('min-width').pfValue,
                left: parent.pstyle('min-width-bias-left'),
                right: parent.pstyle('min-width-bias-right')
            },
            height: {
                val: parent.pstyle('min-height').pfValue,
                top: parent.pstyle('min-height-bias-top'),
                bottom: parent.pstyle('min-height-bias-bottom')
            }
        };
        var bb = children.boundingBox({
            includeLabels: includeLabels,
            includeOverlays: false,
            // updating the compound bounds happens outside of the regular
            // cache cycle (i.e. before fired events)
            useCache: false
        });
        var pos = _p.position;
        // if children take up zero area then keep position and fall back on stylesheet w/h
        if (bb.w === 0 || bb.h === 0) {
            bb = {
                w: parent.pstyle('width').pfValue,
                h: parent.pstyle('height').pfValue
            };
            bb.x1 = pos.x - bb.w / 2;
            bb.x2 = pos.x + bb.w / 2;
            bb.y1 = pos.y - bb.h / 2;
            bb.y2 = pos.y + bb.h / 2;
        }
        function computeBiasValues(propDiff, propBias, propBiasComplement) {
            var biasDiff = 0;
            var biasComplementDiff = 0;
            var biasTotal = propBias + propBiasComplement;
            if (propDiff > 0 && biasTotal > 0) {
                biasDiff = propBias / biasTotal * propDiff;
                biasComplementDiff = propBiasComplement / biasTotal * propDiff;
            }
            return {
                biasDiff: biasDiff,
                biasComplementDiff: biasComplementDiff
            };
        }
        function computePaddingValues(width, height, paddingObject, relativeTo) {
            // Assuming percentage is number from 0 to 1
            if (paddingObject.units === '%') switch(relativeTo){
                case 'width':
                    return width > 0 ? paddingObject.pfValue * width : 0;
                case 'height':
                    return height > 0 ? paddingObject.pfValue * height : 0;
                case 'average':
                    return width > 0 && height > 0 ? paddingObject.pfValue * (width + height) / 2 : 0;
                case 'min':
                    return width > 0 && height > 0 ? width > height ? paddingObject.pfValue * height : paddingObject.pfValue * width : 0;
                case 'max':
                    return width > 0 && height > 0 ? width > height ? paddingObject.pfValue * width : paddingObject.pfValue * height : 0;
                default:
                    return 0;
            }
            else if (paddingObject.units === 'px') return paddingObject.pfValue;
            else return 0;
        }
        var leftVal = min.width.left.value;
        if (min.width.left.units === 'px' && min.width.val > 0) leftVal = leftVal * 100 / min.width.val;
        var rightVal = min.width.right.value;
        if (min.width.right.units === 'px' && min.width.val > 0) rightVal = rightVal * 100 / min.width.val;
        var topVal = min.height.top.value;
        if (min.height.top.units === 'px' && min.height.val > 0) topVal = topVal * 100 / min.height.val;
        var bottomVal = min.height.bottom.value;
        if (min.height.bottom.units === 'px' && min.height.val > 0) bottomVal = bottomVal * 100 / min.height.val;
        var widthBiasDiffs = computeBiasValues(min.width.val - bb.w, leftVal, rightVal);
        var diffLeft = widthBiasDiffs.biasDiff;
        var diffRight = widthBiasDiffs.biasComplementDiff;
        var heightBiasDiffs = computeBiasValues(min.height.val - bb.h, topVal, bottomVal);
        var diffTop = heightBiasDiffs.biasDiff;
        var diffBottom = heightBiasDiffs.biasComplementDiff;
        _p.autoPadding = computePaddingValues(bb.w, bb.h, parent.pstyle('padding'), parent.pstyle('padding-relative-to').value);
        _p.autoWidth = Math.max(bb.w, min.width.val);
        pos.x = (-diffLeft + bb.x1 + bb.x2 + diffRight) / 2;
        _p.autoHeight = Math.max(bb.h, min.height.val);
        pos.y = (-diffTop + bb.y1 + bb.y2 + diffBottom) / 2;
    }
    for(var i = 0; i < this.length; i++){
        var ele = this[i];
        var _p = ele._private;
        if (!_p.compoundBoundsClean || force) {
            update(ele);
            if (!cy.batching()) _p.compoundBoundsClean = true;
        }
    }
    return this;
};
var $e815fda779bc047b$var$noninf = function noninf(x) {
    if (x === Infinity || x === -Infinity) return 0;
    return x;
};
var $e815fda779bc047b$var$updateBounds = function updateBounds(b, x1, y1, x2, y2) {
    // don't update with zero area boxes
    if (x2 - x1 === 0 || y2 - y1 === 0) return;
    // don't update with null dim
    if (x1 == null || y1 == null || x2 == null || y2 == null) return;
    b.x1 = x1 < b.x1 ? x1 : b.x1;
    b.x2 = x2 > b.x2 ? x2 : b.x2;
    b.y1 = y1 < b.y1 ? y1 : b.y1;
    b.y2 = y2 > b.y2 ? y2 : b.y2;
    b.w = b.x2 - b.x1;
    b.h = b.y2 - b.y1;
};
var $e815fda779bc047b$var$updateBoundsFromBox = function updateBoundsFromBox(b, b2) {
    if (b2 == null) return b;
    return $e815fda779bc047b$var$updateBounds(b, b2.x1, b2.y1, b2.x2, b2.y2);
};
var $e815fda779bc047b$var$prefixedProperty = function prefixedProperty(obj, field, prefix) {
    return $e815fda779bc047b$var$getPrefixedProperty(obj, field, prefix);
};
var $e815fda779bc047b$var$updateBoundsFromArrow = function updateBoundsFromArrow(bounds, ele, prefix) {
    if (ele.cy().headless()) return;
    var _p = ele._private;
    var rstyle = _p.rstyle;
    var halfArW = rstyle.arrowWidth / 2;
    var arrowType = ele.pstyle(prefix + '-arrow-shape').value;
    var x;
    var y;
    if (arrowType !== 'none') {
        if (prefix === 'source') {
            x = rstyle.srcX;
            y = rstyle.srcY;
        } else if (prefix === 'target') {
            x = rstyle.tgtX;
            y = rstyle.tgtY;
        } else {
            x = rstyle.midX;
            y = rstyle.midY;
        }
        // always store the individual arrow bounds
        var bbs = _p.arrowBounds = _p.arrowBounds || {};
        var bb = bbs[prefix] = bbs[prefix] || {};
        bb.x1 = x - halfArW;
        bb.y1 = y - halfArW;
        bb.x2 = x + halfArW;
        bb.y2 = y + halfArW;
        bb.w = bb.x2 - bb.x1;
        bb.h = bb.y2 - bb.y1;
        $e815fda779bc047b$var$expandBoundingBox(bb, 1);
        $e815fda779bc047b$var$updateBounds(bounds, bb.x1, bb.y1, bb.x2, bb.y2);
    }
};
var $e815fda779bc047b$var$updateBoundsFromLabel = function updateBoundsFromLabel(bounds, ele, prefix) {
    if (ele.cy().headless()) return;
    var prefixDash;
    if (prefix) prefixDash = prefix + '-';
    else prefixDash = '';
    var _p = ele._private;
    var rstyle = _p.rstyle;
    var label = ele.pstyle(prefixDash + 'label').strValue;
    if (label) {
        var halign = ele.pstyle('text-halign');
        var valign = ele.pstyle('text-valign');
        var labelWidth = $e815fda779bc047b$var$prefixedProperty(rstyle, 'labelWidth', prefix);
        var labelHeight = $e815fda779bc047b$var$prefixedProperty(rstyle, 'labelHeight', prefix);
        var labelX = $e815fda779bc047b$var$prefixedProperty(rstyle, 'labelX', prefix);
        var labelY = $e815fda779bc047b$var$prefixedProperty(rstyle, 'labelY', prefix);
        var marginX = ele.pstyle(prefixDash + 'text-margin-x').pfValue;
        var marginY = ele.pstyle(prefixDash + 'text-margin-y').pfValue;
        var isEdge = ele.isEdge();
        var rotation = ele.pstyle(prefixDash + 'text-rotation');
        var outlineWidth = ele.pstyle('text-outline-width').pfValue;
        var borderWidth = ele.pstyle('text-border-width').pfValue;
        var halfBorderWidth = borderWidth / 2;
        var padding = ele.pstyle('text-background-padding').pfValue;
        var marginOfError = 2; // expand to work around browser dimension inaccuracies
        var lh = labelHeight;
        var lw = labelWidth;
        var lw_2 = lw / 2;
        var lh_2 = lh / 2;
        var lx1, lx2, ly1, ly2;
        if (isEdge) {
            lx1 = labelX - lw_2;
            lx2 = labelX + lw_2;
            ly1 = labelY - lh_2;
            ly2 = labelY + lh_2;
        } else {
            switch(halign.value){
                case 'left':
                    lx1 = labelX - lw;
                    lx2 = labelX;
                    break;
                case 'center':
                    lx1 = labelX - lw_2;
                    lx2 = labelX + lw_2;
                    break;
                case 'right':
                    lx1 = labelX;
                    lx2 = labelX + lw;
                    break;
            }
            switch(valign.value){
                case 'top':
                    ly1 = labelY - lh;
                    ly2 = labelY;
                    break;
                case 'center':
                    ly1 = labelY - lh_2;
                    ly2 = labelY + lh_2;
                    break;
                case 'bottom':
                    ly1 = labelY;
                    ly2 = labelY + lh;
                    break;
            }
        }
        // shift by margin and expand by outline and border
        var leftPad = marginX - Math.max(outlineWidth, halfBorderWidth) - padding - marginOfError;
        var rightPad = marginX + Math.max(outlineWidth, halfBorderWidth) + padding + marginOfError;
        var topPad = marginY - Math.max(outlineWidth, halfBorderWidth) - padding - marginOfError;
        var botPad = marginY + Math.max(outlineWidth, halfBorderWidth) + padding + marginOfError;
        lx1 += leftPad;
        lx2 += rightPad;
        ly1 += topPad;
        ly2 += botPad;
        // always store the unrotated label bounds separately
        var bbPrefix = prefix || 'main';
        var bbs = _p.labelBounds;
        var bb = bbs[bbPrefix] = bbs[bbPrefix] || {};
        bb.x1 = lx1;
        bb.y1 = ly1;
        bb.x2 = lx2;
        bb.y2 = ly2;
        bb.w = lx2 - lx1;
        bb.h = ly2 - ly1;
        bb.leftPad = leftPad;
        bb.rightPad = rightPad;
        bb.topPad = topPad;
        bb.botPad = botPad;
        var isAutorotate = isEdge && rotation.strValue === 'autorotate';
        var isPfValue = rotation.pfValue != null && rotation.pfValue !== 0;
        if (isAutorotate || isPfValue) {
            var theta = isAutorotate ? $e815fda779bc047b$var$prefixedProperty(_p.rstyle, 'labelAngle', prefix) : rotation.pfValue;
            var cos = Math.cos(theta);
            var sin = Math.sin(theta);
            // rotation point (default value for center-center)
            var xo = (lx1 + lx2) / 2;
            var yo = (ly1 + ly2) / 2;
            if (!isEdge) {
                switch(halign.value){
                    case 'left':
                        xo = lx2;
                        break;
                    case 'right':
                        xo = lx1;
                        break;
                }
                switch(valign.value){
                    case 'top':
                        yo = ly2;
                        break;
                    case 'bottom':
                        yo = ly1;
                        break;
                }
            }
            var rotate = function rotate(x, y) {
                x = x - xo;
                y = y - yo;
                return {
                    x: x * cos - y * sin + xo,
                    y: x * sin + y * cos + yo
                };
            };
            var px1y1 = rotate(lx1, ly1);
            var px1y2 = rotate(lx1, ly2);
            var px2y1 = rotate(lx2, ly1);
            var px2y2 = rotate(lx2, ly2);
            lx1 = Math.min(px1y1.x, px1y2.x, px2y1.x, px2y2.x);
            lx2 = Math.max(px1y1.x, px1y2.x, px2y1.x, px2y2.x);
            ly1 = Math.min(px1y1.y, px1y2.y, px2y1.y, px2y2.y);
            ly2 = Math.max(px1y1.y, px1y2.y, px2y1.y, px2y2.y);
        }
        var bbPrefixRot = bbPrefix + 'Rot';
        var bbRot = bbs[bbPrefixRot] = bbs[bbPrefixRot] || {};
        bbRot.x1 = lx1;
        bbRot.y1 = ly1;
        bbRot.x2 = lx2;
        bbRot.y2 = ly2;
        bbRot.w = lx2 - lx1;
        bbRot.h = ly2 - ly1;
        $e815fda779bc047b$var$updateBounds(bounds, lx1, ly1, lx2, ly2);
        $e815fda779bc047b$var$updateBounds(_p.labelBounds.all, lx1, ly1, lx2, ly2);
    }
    return bounds;
};
var $e815fda779bc047b$var$updateBoundsFromOutline = function updateBoundsFromOutline(bounds, ele) {
    if (ele.cy().headless()) return;
    var outlineOpacity = ele.pstyle('outline-opacity').value;
    var outlineWidth = ele.pstyle('outline-width').value;
    var outlineOffset = ele.pstyle('outline-offset').value;
    var expansion = outlineWidth + outlineOffset;
    $e815fda779bc047b$var$updateBoundsFromMiter(bounds, ele, outlineOpacity, expansion, 'outside', expansion / 2);
};
var $e815fda779bc047b$var$updateBoundsFromMiter = function updateBoundsFromMiter(bounds, ele, opacity, expansionSize, expansionPosition, useFallbackValue) {
    if (opacity === 0 || expansionSize <= 0 || expansionPosition === 'inside') return;
    var cy = ele.cy();
    var shape = ele.pstyle('shape').value;
    var rshape = cy.renderer().nodeShapes[shape];
    var _ele$position = ele.position(), x = _ele$position.x, y = _ele$position.y;
    var w = ele.width();
    var h = ele.height();
    if (rshape.hasMiterBounds) {
        if (expansionPosition === 'center') expansionSize /= 2;
        var mbb = rshape.miterBounds(x, y, w, h, expansionSize);
        $e815fda779bc047b$var$updateBoundsFromBox(bounds, mbb);
    } else if (useFallbackValue != null && useFallbackValue > 0) $e815fda779bc047b$var$expandBoundingBoxSides(bounds, [
        useFallbackValue,
        useFallbackValue,
        useFallbackValue,
        useFallbackValue
    ]);
};
var $e815fda779bc047b$var$updateBoundsFromMiterBorder = function updateBoundsFromMiterBorder(bounds, ele) {
    if (ele.cy().headless()) return;
    var borderOpacity = ele.pstyle('border-opacity').value;
    var borderWidth = ele.pstyle('border-width').pfValue;
    var borderPosition = ele.pstyle('border-position').value;
    $e815fda779bc047b$var$updateBoundsFromMiter(bounds, ele, borderOpacity, borderWidth, borderPosition);
};
// get the bounding box of the elements (in raw model position)
var $e815fda779bc047b$var$boundingBoxImpl = function boundingBoxImpl(ele, options) {
    var cy = ele._private.cy;
    var styleEnabled = cy.styleEnabled();
    var headless = cy.headless();
    var bounds = $e815fda779bc047b$var$makeBoundingBox();
    var _p = ele._private;
    var isNode = ele.isNode();
    var isEdge = ele.isEdge();
    var ex1, ex2, ey1, ey2; // extrema of body / lines
    var x, y; // node pos
    var rstyle = _p.rstyle;
    var manualExpansion = isNode && styleEnabled ? ele.pstyle('bounds-expansion').pfValue : [
        0
    ];
    // must use `display` prop only, as reading `compound.width()` causes recursion
    // (other factors like width values will be considered later in this function anyway)
    var isDisplayed = function isDisplayed(ele) {
        return ele.pstyle('display').value !== 'none';
    };
    var displayed = !styleEnabled || isDisplayed(ele) && (!isEdge || isDisplayed(ele.source()) && isDisplayed(ele.target()));
    if (displayed) {
        // displayed suffices, since we will find zero area eles anyway
        var overlayOpacity = 0;
        var overlayPadding = 0;
        if (styleEnabled && options.includeOverlays) {
            overlayOpacity = ele.pstyle('overlay-opacity').value;
            if (overlayOpacity !== 0) overlayPadding = ele.pstyle('overlay-padding').value;
        }
        var underlayOpacity = 0;
        var underlayPadding = 0;
        if (styleEnabled && options.includeUnderlays) {
            underlayOpacity = ele.pstyle('underlay-opacity').value;
            if (underlayOpacity !== 0) underlayPadding = ele.pstyle('underlay-padding').value;
        }
        var padding = Math.max(overlayPadding, underlayPadding);
        var w = 0;
        var wHalf = 0;
        if (styleEnabled) {
            w = ele.pstyle('width').pfValue;
            wHalf = w / 2;
        }
        if (isNode && options.includeNodes) {
            var pos = ele.position();
            x = pos.x;
            y = pos.y;
            var _w = ele.outerWidth();
            var halfW = _w / 2;
            var h = ele.outerHeight();
            var halfH = h / 2;
            // handle node dimensions
            /////////////////////////
            ex1 = x - halfW;
            ex2 = x + halfW;
            ey1 = y - halfH;
            ey2 = y + halfH;
            $e815fda779bc047b$var$updateBounds(bounds, ex1, ey1, ex2, ey2);
            if (styleEnabled) $e815fda779bc047b$var$updateBoundsFromOutline(bounds, ele);
            if (styleEnabled && options.includeOutlines && !headless) $e815fda779bc047b$var$updateBoundsFromOutline(bounds, ele);
            if (styleEnabled) $e815fda779bc047b$var$updateBoundsFromMiterBorder(bounds, ele);
        } else if (isEdge && options.includeEdges) {
            if (styleEnabled && !headless) {
                var curveStyle = ele.pstyle('curve-style').strValue;
                // handle edge dimensions (rough box estimate)
                //////////////////////////////////////////////
                ex1 = Math.min(rstyle.srcX, rstyle.midX, rstyle.tgtX);
                ex2 = Math.max(rstyle.srcX, rstyle.midX, rstyle.tgtX);
                ey1 = Math.min(rstyle.srcY, rstyle.midY, rstyle.tgtY);
                ey2 = Math.max(rstyle.srcY, rstyle.midY, rstyle.tgtY);
                // take into account edge width
                ex1 -= wHalf;
                ex2 += wHalf;
                ey1 -= wHalf;
                ey2 += wHalf;
                $e815fda779bc047b$var$updateBounds(bounds, ex1, ey1, ex2, ey2);
                // precise edges
                ////////////////
                if (curveStyle === 'haystack') {
                    var hpts = rstyle.haystackPts;
                    if (hpts && hpts.length === 2) {
                        ex1 = hpts[0].x;
                        ey1 = hpts[0].y;
                        ex2 = hpts[1].x;
                        ey2 = hpts[1].y;
                        if (ex1 > ex2) {
                            var temp = ex1;
                            ex1 = ex2;
                            ex2 = temp;
                        }
                        if (ey1 > ey2) {
                            var _temp = ey1;
                            ey1 = ey2;
                            ey2 = _temp;
                        }
                        $e815fda779bc047b$var$updateBounds(bounds, ex1 - wHalf, ey1 - wHalf, ex2 + wHalf, ey2 + wHalf);
                    }
                } else if (curveStyle === 'bezier' || curveStyle === 'unbundled-bezier' || $e815fda779bc047b$var$endsWith(curveStyle, 'segments') || $e815fda779bc047b$var$endsWith(curveStyle, 'taxi')) {
                    var pts;
                    switch(curveStyle){
                        case 'bezier':
                        case 'unbundled-bezier':
                            pts = rstyle.bezierPts;
                            break;
                        case 'segments':
                        case 'taxi':
                        case 'round-segments':
                        case 'round-taxi':
                            pts = rstyle.linePts;
                            break;
                    }
                    if (pts != null) for(var j = 0; j < pts.length; j++){
                        var pt = pts[j];
                        ex1 = pt.x - wHalf;
                        ex2 = pt.x + wHalf;
                        ey1 = pt.y - wHalf;
                        ey2 = pt.y + wHalf;
                        $e815fda779bc047b$var$updateBounds(bounds, ex1, ey1, ex2, ey2);
                    }
                } // bezier-like or segment-like edge
            } else {
                // headless or style disabled
                // fallback on source and target positions
                //////////////////////////////////////////
                var n1 = ele.source();
                var n1pos = n1.position();
                var n2 = ele.target();
                var n2pos = n2.position();
                ex1 = n1pos.x;
                ex2 = n2pos.x;
                ey1 = n1pos.y;
                ey2 = n2pos.y;
                if (ex1 > ex2) {
                    var _temp2 = ex1;
                    ex1 = ex2;
                    ex2 = _temp2;
                }
                if (ey1 > ey2) {
                    var _temp3 = ey1;
                    ey1 = ey2;
                    ey2 = _temp3;
                }
                // take into account edge width
                ex1 -= wHalf;
                ex2 += wHalf;
                ey1 -= wHalf;
                ey2 += wHalf;
                $e815fda779bc047b$var$updateBounds(bounds, ex1, ey1, ex2, ey2);
            } // headless or style disabled
        } // edges
        // handle edge arrow size
        /////////////////////////
        if (styleEnabled && options.includeEdges && isEdge) {
            $e815fda779bc047b$var$updateBoundsFromArrow(bounds, ele, 'mid-source');
            $e815fda779bc047b$var$updateBoundsFromArrow(bounds, ele, 'mid-target');
            $e815fda779bc047b$var$updateBoundsFromArrow(bounds, ele, 'source');
            $e815fda779bc047b$var$updateBoundsFromArrow(bounds, ele, 'target');
        }
        // ghost
        ////////
        if (styleEnabled) {
            var ghost = ele.pstyle('ghost').value === 'yes';
            if (ghost) {
                var gx = ele.pstyle('ghost-offset-x').pfValue;
                var gy = ele.pstyle('ghost-offset-y').pfValue;
                $e815fda779bc047b$var$updateBounds(bounds, bounds.x1 + gx, bounds.y1 + gy, bounds.x2 + gx, bounds.y2 + gy);
            }
        }
        // always store the body bounds separately from the labels
        var bbBody = _p.bodyBounds = _p.bodyBounds || {};
        $e815fda779bc047b$var$assignBoundingBox(bbBody, bounds);
        $e815fda779bc047b$var$expandBoundingBoxSides(bbBody, manualExpansion);
        $e815fda779bc047b$var$expandBoundingBox(bbBody, 1); // expand to work around browser dimension inaccuracies
        // overlay
        //////////
        if (styleEnabled) {
            ex1 = bounds.x1;
            ex2 = bounds.x2;
            ey1 = bounds.y1;
            ey2 = bounds.y2;
            $e815fda779bc047b$var$updateBounds(bounds, ex1 - padding, ey1 - padding, ex2 + padding, ey2 + padding);
        }
        // always store the body bounds separately from the labels
        var bbOverlay = _p.overlayBounds = _p.overlayBounds || {};
        $e815fda779bc047b$var$assignBoundingBox(bbOverlay, bounds);
        $e815fda779bc047b$var$expandBoundingBoxSides(bbOverlay, manualExpansion);
        $e815fda779bc047b$var$expandBoundingBox(bbOverlay, 1); // expand to work around browser dimension inaccuracies
        // handle label dimensions
        //////////////////////////
        var bbLabels = _p.labelBounds = _p.labelBounds || {};
        if (bbLabels.all != null) $e815fda779bc047b$var$clearBoundingBox(bbLabels.all);
        else bbLabels.all = $e815fda779bc047b$var$makeBoundingBox();
        if (styleEnabled && options.includeLabels) {
            if (options.includeMainLabels) $e815fda779bc047b$var$updateBoundsFromLabel(bounds, ele, null);
            if (isEdge) {
                if (options.includeSourceLabels) $e815fda779bc047b$var$updateBoundsFromLabel(bounds, ele, 'source');
                if (options.includeTargetLabels) $e815fda779bc047b$var$updateBoundsFromLabel(bounds, ele, 'target');
            }
        } // style enabled for labels
    } // if displayed
    bounds.x1 = $e815fda779bc047b$var$noninf(bounds.x1);
    bounds.y1 = $e815fda779bc047b$var$noninf(bounds.y1);
    bounds.x2 = $e815fda779bc047b$var$noninf(bounds.x2);
    bounds.y2 = $e815fda779bc047b$var$noninf(bounds.y2);
    bounds.w = $e815fda779bc047b$var$noninf(bounds.x2 - bounds.x1);
    bounds.h = $e815fda779bc047b$var$noninf(bounds.y2 - bounds.y1);
    if (bounds.w > 0 && bounds.h > 0 && displayed) {
        $e815fda779bc047b$var$expandBoundingBoxSides(bounds, manualExpansion);
        // expand bounds by 1 because antialiasing can increase the visual/effective size by 1 on all sides
        $e815fda779bc047b$var$expandBoundingBox(bounds, 1);
    }
    return bounds;
};
var $e815fda779bc047b$var$getKey = function getKey(opts) {
    var i = 0;
    var tf = function tf(val) {
        return (val ? 1 : 0) << i++;
    };
    var key = 0;
    key += tf(opts.incudeNodes);
    key += tf(opts.includeEdges);
    key += tf(opts.includeLabels);
    key += tf(opts.includeMainLabels);
    key += tf(opts.includeSourceLabels);
    key += tf(opts.includeTargetLabels);
    key += tf(opts.includeOverlays);
    key += tf(opts.includeOutlines);
    return key;
};
var $e815fda779bc047b$var$getBoundingBoxPosKey = function getBoundingBoxPosKey(ele) {
    var r = function r(x) {
        return Math.round(x);
    };
    if (ele.isEdge()) {
        var p1 = ele.source().position();
        var p2 = ele.target().position();
        return $e815fda779bc047b$var$hashIntsArray([
            r(p1.x),
            r(p1.y),
            r(p2.x),
            r(p2.y)
        ]);
    } else {
        var p = ele.position();
        return $e815fda779bc047b$var$hashIntsArray([
            r(p.x),
            r(p.y)
        ]);
    }
};
var $e815fda779bc047b$var$cachedBoundingBoxImpl = function cachedBoundingBoxImpl(ele, opts) {
    var _p = ele._private;
    var bb;
    var isEdge = ele.isEdge();
    var key = opts == null ? $e815fda779bc047b$var$defBbOptsKey : $e815fda779bc047b$var$getKey(opts);
    var usingDefOpts = key === $e815fda779bc047b$var$defBbOptsKey;
    if (_p.bbCache == null) {
        bb = $e815fda779bc047b$var$boundingBoxImpl(ele, $e815fda779bc047b$var$defBbOpts);
        _p.bbCache = bb;
        _p.bbCachePosKey = $e815fda779bc047b$var$getBoundingBoxPosKey(ele);
    } else bb = _p.bbCache;
    // not using def opts => need to build up bb from combination of sub bbs
    if (!usingDefOpts) {
        var isNode = ele.isNode();
        bb = $e815fda779bc047b$var$makeBoundingBox();
        if (opts.includeNodes && isNode || opts.includeEdges && !isNode) {
            if (opts.includeOverlays) $e815fda779bc047b$var$updateBoundsFromBox(bb, _p.overlayBounds);
            else $e815fda779bc047b$var$updateBoundsFromBox(bb, _p.bodyBounds);
        }
        if (opts.includeLabels) {
            if (opts.includeMainLabels && (!isEdge || opts.includeSourceLabels && opts.includeTargetLabels)) $e815fda779bc047b$var$updateBoundsFromBox(bb, _p.labelBounds.all);
            else {
                if (opts.includeMainLabels) $e815fda779bc047b$var$updateBoundsFromBox(bb, _p.labelBounds.mainRot);
                if (opts.includeSourceLabels) $e815fda779bc047b$var$updateBoundsFromBox(bb, _p.labelBounds.sourceRot);
                if (opts.includeTargetLabels) $e815fda779bc047b$var$updateBoundsFromBox(bb, _p.labelBounds.targetRot);
            }
        }
        bb.w = bb.x2 - bb.x1;
        bb.h = bb.y2 - bb.y1;
    }
    return bb;
};
var $e815fda779bc047b$var$defBbOpts = {
    includeNodes: true,
    includeEdges: true,
    includeLabels: true,
    includeMainLabels: true,
    includeSourceLabels: true,
    includeTargetLabels: true,
    includeOverlays: true,
    includeUnderlays: true,
    includeOutlines: true,
    useCache: true
};
var $e815fda779bc047b$var$defBbOptsKey = $e815fda779bc047b$var$getKey($e815fda779bc047b$var$defBbOpts);
var $e815fda779bc047b$var$filledBbOpts = $e815fda779bc047b$var$defaults$g($e815fda779bc047b$var$defBbOpts);
$e815fda779bc047b$var$elesfn$b.boundingBox = function(options) {
    var bounds;
    var useCache = options === undefined || options.useCache === undefined || options.useCache === true;
    var isDirty = $e815fda779bc047b$var$memoize(function(ele) {
        var _p = ele._private;
        return _p.bbCache == null || _p.styleDirty || _p.bbCachePosKey !== $e815fda779bc047b$var$getBoundingBoxPosKey(ele);
    }, function(ele) {
        return ele.id();
    });
    // the main usecase is ele.boundingBox() for a single element with no/def options
    // specified s.t. the cache is used, so check for this case to make it faster by
    // avoiding the overhead of the rest of the function
    if (useCache && this.length === 1 && !isDirty(this[0])) {
        if (options === undefined) options = $e815fda779bc047b$var$defBbOpts;
        else options = $e815fda779bc047b$var$filledBbOpts(options);
        bounds = $e815fda779bc047b$var$cachedBoundingBoxImpl(this[0], options);
    } else {
        bounds = $e815fda779bc047b$var$makeBoundingBox();
        options = options || $e815fda779bc047b$var$defBbOpts;
        var opts = $e815fda779bc047b$var$filledBbOpts(options);
        var eles = this;
        var cy = eles.cy();
        var styleEnabled = cy.styleEnabled();
        // cache the isDirty state for all eles, edges first since they depend on node state
        this.edges().forEach(isDirty);
        this.nodes().forEach(isDirty);
        if (styleEnabled) this.recalculateRenderedStyle(useCache);
        this.updateCompoundBounds(!useCache);
        for(var i = 0; i < eles.length; i++){
            var ele = eles[i];
            if (isDirty(ele)) ele.dirtyBoundingBoxCache();
            $e815fda779bc047b$var$updateBoundsFromBox(bounds, $e815fda779bc047b$var$cachedBoundingBoxImpl(ele, opts));
        }
    }
    bounds.x1 = $e815fda779bc047b$var$noninf(bounds.x1);
    bounds.y1 = $e815fda779bc047b$var$noninf(bounds.y1);
    bounds.x2 = $e815fda779bc047b$var$noninf(bounds.x2);
    bounds.y2 = $e815fda779bc047b$var$noninf(bounds.y2);
    bounds.w = $e815fda779bc047b$var$noninf(bounds.x2 - bounds.x1);
    bounds.h = $e815fda779bc047b$var$noninf(bounds.y2 - bounds.y1);
    return bounds;
};
$e815fda779bc047b$var$elesfn$b.dirtyBoundingBoxCache = function() {
    for(var i = 0; i < this.length; i++){
        var _p = this[i]._private;
        _p.bbCache = null;
        _p.bbCachePosKey = null;
        _p.bodyBounds = null;
        _p.overlayBounds = null;
        _p.labelBounds.all = null;
        _p.labelBounds.source = null;
        _p.labelBounds.target = null;
        _p.labelBounds.main = null;
        _p.labelBounds.sourceRot = null;
        _p.labelBounds.targetRot = null;
        _p.labelBounds.mainRot = null;
        _p.arrowBounds.source = null;
        _p.arrowBounds.target = null;
        _p.arrowBounds['mid-source'] = null;
        _p.arrowBounds['mid-target'] = null;
    }
    this.emitAndNotify('bounds');
    return this;
};
// private helper to get bounding box for custom node positions
// - good for perf in certain cases but currently requires dirtying the rendered style
// - would be better to not modify the nodes but the nodes are read directly everywhere in the renderer...
// - try to use for only things like discrete layouts where the node position would change anyway
$e815fda779bc047b$var$elesfn$b.boundingBoxAt = function(fn) {
    var nodes = this.nodes();
    var cy = this.cy();
    var hasCompoundNodes = cy.hasCompoundNodes();
    var parents = cy.collection();
    if (hasCompoundNodes) {
        parents = nodes.filter(function(node) {
            return node.isParent();
        });
        nodes = nodes.not(parents);
    }
    if ($e815fda779bc047b$var$plainObject(fn)) {
        var obj = fn;
        fn = function fn() {
            return obj;
        };
    }
    var storeOldPos = function storeOldPos(node, i) {
        return node._private.bbAtOldPos = fn(node, i);
    };
    var getOldPos = function getOldPos(node) {
        return node._private.bbAtOldPos;
    };
    cy.startBatch();
    nodes.forEach(storeOldPos).silentPositions(fn);
    if (hasCompoundNodes) {
        parents.dirtyCompoundBoundsCache();
        parents.dirtyBoundingBoxCache();
        parents.updateCompoundBounds(true); // force update b/c we're inside a batch cycle
    }
    var bb = $e815fda779bc047b$var$copyBoundingBox(this.boundingBox({
        useCache: false
    }));
    nodes.silentPositions(getOldPos);
    if (hasCompoundNodes) {
        parents.dirtyCompoundBoundsCache();
        parents.dirtyBoundingBoxCache();
        parents.updateCompoundBounds(true); // force update b/c we're inside a batch cycle
    }
    cy.endBatch();
    return bb;
};
$e815fda779bc047b$var$fn$3.boundingbox = $e815fda779bc047b$var$fn$3.bb = $e815fda779bc047b$var$fn$3.boundingBox;
$e815fda779bc047b$var$fn$3.renderedBoundingbox = $e815fda779bc047b$var$fn$3.renderedBoundingBox;
var $e815fda779bc047b$var$bounds = $e815fda779bc047b$var$elesfn$b;
var $e815fda779bc047b$var$fn$2, $e815fda779bc047b$var$elesfn$a;
$e815fda779bc047b$var$fn$2 = $e815fda779bc047b$var$elesfn$a = {};
var $e815fda779bc047b$var$defineDimFns = function defineDimFns(opts) {
    opts.uppercaseName = $e815fda779bc047b$var$capitalize(opts.name);
    opts.autoName = 'auto' + opts.uppercaseName;
    opts.labelName = 'label' + opts.uppercaseName;
    opts.outerName = 'outer' + opts.uppercaseName;
    opts.uppercaseOuterName = $e815fda779bc047b$var$capitalize(opts.outerName);
    $e815fda779bc047b$var$fn$2[opts.name] = function dimImpl() {
        var ele = this[0];
        var _p = ele._private;
        var cy = _p.cy;
        var styleEnabled = cy._private.styleEnabled;
        if (ele) {
            if (styleEnabled) {
                if (ele.isParent()) {
                    ele.updateCompoundBounds();
                    return _p[opts.autoName] || 0;
                }
                var d = ele.pstyle(opts.name);
                switch(d.strValue){
                    case 'label':
                        ele.recalculateRenderedStyle();
                        return _p.rstyle[opts.labelName] || 0;
                    default:
                        return d.pfValue;
                }
            } else return 1;
        }
    };
    $e815fda779bc047b$var$fn$2['outer' + opts.uppercaseName] = function outerDimImpl() {
        var ele = this[0];
        var _p = ele._private;
        var cy = _p.cy;
        var styleEnabled = cy._private.styleEnabled;
        if (ele) {
            if (styleEnabled) {
                var dim = ele[opts.name]();
                var borderPos = ele.pstyle('border-position').value;
                var border;
                if (borderPos === 'center') border = ele.pstyle('border-width').pfValue; // n.b. 1/2 each side
                else if (borderPos === 'outside') border = 2 * ele.pstyle('border-width').pfValue;
                else // 'inside'
                border = 0;
                var padding = 2 * ele.padding();
                return dim + border + padding;
            } else return 1;
        }
    };
    $e815fda779bc047b$var$fn$2['rendered' + opts.uppercaseName] = function renderedDimImpl() {
        var ele = this[0];
        if (ele) {
            var d = ele[opts.name]();
            return d * this.cy().zoom();
        }
    };
    $e815fda779bc047b$var$fn$2['rendered' + opts.uppercaseOuterName] = function renderedOuterDimImpl() {
        var ele = this[0];
        if (ele) {
            var od = ele[opts.outerName]();
            return od * this.cy().zoom();
        }
    };
};
$e815fda779bc047b$var$defineDimFns({
    name: 'width'
});
$e815fda779bc047b$var$defineDimFns({
    name: 'height'
});
$e815fda779bc047b$var$elesfn$a.padding = function() {
    var ele = this[0];
    var _p = ele._private;
    if (ele.isParent()) {
        ele.updateCompoundBounds();
        if (_p.autoPadding !== undefined) return _p.autoPadding;
        else return ele.pstyle('padding').pfValue;
    } else return ele.pstyle('padding').pfValue;
};
$e815fda779bc047b$var$elesfn$a.paddedHeight = function() {
    var ele = this[0];
    return ele.height() + 2 * ele.padding();
};
$e815fda779bc047b$var$elesfn$a.paddedWidth = function() {
    var ele = this[0];
    return ele.width() + 2 * ele.padding();
};
var $e815fda779bc047b$var$widthHeight = $e815fda779bc047b$var$elesfn$a;
var $e815fda779bc047b$var$ifEdge = function ifEdge(ele, getValue) {
    if (ele.isEdge() && ele.takesUpSpace()) return getValue(ele);
};
var $e815fda779bc047b$var$ifEdgeRenderedPosition = function ifEdgeRenderedPosition(ele, getPoint) {
    if (ele.isEdge() && ele.takesUpSpace()) {
        var cy = ele.cy();
        return $e815fda779bc047b$var$modelToRenderedPosition$1(getPoint(ele), cy.zoom(), cy.pan());
    }
};
var $e815fda779bc047b$var$ifEdgeRenderedPositions = function ifEdgeRenderedPositions(ele, getPoints) {
    if (ele.isEdge() && ele.takesUpSpace()) {
        var cy = ele.cy();
        var pan = cy.pan();
        var zoom = cy.zoom();
        return getPoints(ele).map(function(p) {
            return $e815fda779bc047b$var$modelToRenderedPosition$1(p, zoom, pan);
        });
    }
};
var $e815fda779bc047b$var$controlPoints = function controlPoints(ele) {
    return ele.renderer().getControlPoints(ele);
};
var $e815fda779bc047b$var$segmentPoints = function segmentPoints(ele) {
    return ele.renderer().getSegmentPoints(ele);
};
var $e815fda779bc047b$var$sourceEndpoint = function sourceEndpoint(ele) {
    return ele.renderer().getSourceEndpoint(ele);
};
var $e815fda779bc047b$var$targetEndpoint = function targetEndpoint(ele) {
    return ele.renderer().getTargetEndpoint(ele);
};
var $e815fda779bc047b$var$midpoint = function midpoint(ele) {
    return ele.renderer().getEdgeMidpoint(ele);
};
var $e815fda779bc047b$var$pts = {
    controlPoints: {
        get: $e815fda779bc047b$var$controlPoints,
        mult: true
    },
    segmentPoints: {
        get: $e815fda779bc047b$var$segmentPoints,
        mult: true
    },
    sourceEndpoint: {
        get: $e815fda779bc047b$var$sourceEndpoint
    },
    targetEndpoint: {
        get: $e815fda779bc047b$var$targetEndpoint
    },
    midpoint: {
        get: $e815fda779bc047b$var$midpoint
    }
};
var $e815fda779bc047b$var$renderedName = function renderedName(name) {
    return 'rendered' + name[0].toUpperCase() + name.substr(1);
};
var $e815fda779bc047b$var$edgePoints = Object.keys($e815fda779bc047b$var$pts).reduce(function(obj, name) {
    var spec = $e815fda779bc047b$var$pts[name];
    var rName = $e815fda779bc047b$var$renderedName(name);
    obj[name] = function() {
        return $e815fda779bc047b$var$ifEdge(this, spec.get);
    };
    if (spec.mult) obj[rName] = function() {
        return $e815fda779bc047b$var$ifEdgeRenderedPositions(this, spec.get);
    };
    else obj[rName] = function() {
        return $e815fda779bc047b$var$ifEdgeRenderedPosition(this, spec.get);
    };
    return obj;
}, {});
var $e815fda779bc047b$var$dimensions = $e815fda779bc047b$var$extend({}, $e815fda779bc047b$var$position, $e815fda779bc047b$var$bounds, $e815fda779bc047b$var$widthHeight, $e815fda779bc047b$var$edgePoints);
/*!
Event object based on jQuery events, MIT license

https://jquery.org/license/
https://tldrlegal.com/license/mit-license
https://github.com/jquery/jquery/blob/master/src/event.js
*/ var $e815fda779bc047b$var$Event = function Event(src, props) {
    this.recycle(src, props);
};
function $e815fda779bc047b$var$returnFalse() {
    return false;
}
function $e815fda779bc047b$var$returnTrue() {
    return true;
}
// http://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
$e815fda779bc047b$var$Event.prototype = {
    instanceString: function instanceString() {
        return 'event';
    },
    recycle: function recycle(src, props) {
        this.isImmediatePropagationStopped = this.isPropagationStopped = this.isDefaultPrevented = $e815fda779bc047b$var$returnFalse;
        if (src != null && src.preventDefault) {
            // Browser Event object
            this.type = src.type;
            // Events bubbling up the document may have been marked as prevented
            // by a handler lower down the tree; reflect the correct value.
            this.isDefaultPrevented = src.defaultPrevented ? $e815fda779bc047b$var$returnTrue : $e815fda779bc047b$var$returnFalse;
        } else if (src != null && src.type) // Plain object containing all event details
        props = src;
        else // Event string
        this.type = src;
        // Put explicitly provided properties onto the event object
        if (props != null) {
            // more efficient to manually copy fields we use
            this.originalEvent = props.originalEvent;
            this.type = props.type != null ? props.type : this.type;
            this.cy = props.cy;
            this.target = props.target;
            this.position = props.position;
            this.renderedPosition = props.renderedPosition;
            this.namespace = props.namespace;
            this.layout = props.layout;
        }
        if (this.cy != null && this.position != null && this.renderedPosition == null) {
            // create a rendered position based on the passed position
            var pos = this.position;
            var zoom = this.cy.zoom();
            var pan = this.cy.pan();
            this.renderedPosition = {
                x: pos.x * zoom + pan.x,
                y: pos.y * zoom + pan.y
            };
        }
        // Create a timestamp if incoming event doesn't have one
        this.timeStamp = src && src.timeStamp || Date.now();
    },
    preventDefault: function preventDefault() {
        this.isDefaultPrevented = $e815fda779bc047b$var$returnTrue;
        var e = this.originalEvent;
        if (!e) return;
        // if preventDefault exists run it on the original event
        if (e.preventDefault) e.preventDefault();
    },
    stopPropagation: function stopPropagation() {
        this.isPropagationStopped = $e815fda779bc047b$var$returnTrue;
        var e = this.originalEvent;
        if (!e) return;
        // if stopPropagation exists run it on the original event
        if (e.stopPropagation) e.stopPropagation();
    },
    stopImmediatePropagation: function stopImmediatePropagation() {
        this.isImmediatePropagationStopped = $e815fda779bc047b$var$returnTrue;
        this.stopPropagation();
    },
    isDefaultPrevented: $e815fda779bc047b$var$returnFalse,
    isPropagationStopped: $e815fda779bc047b$var$returnFalse,
    isImmediatePropagationStopped: $e815fda779bc047b$var$returnFalse
};
var $e815fda779bc047b$var$eventRegex = /^([^.]+)(\.(?:[^.]+))?$/; // regex for matching event strings (e.g. "click.namespace")
var $e815fda779bc047b$var$universalNamespace = '.*'; // matches as if no namespace specified and prevents users from unbinding accidentally
var $e815fda779bc047b$var$defaults$8 = {
    qualifierCompare: function qualifierCompare(q1, q2) {
        return q1 === q2;
    },
    eventMatches: function eventMatches() {
        return true;
    },
    addEventFields: function addEventFields() {},
    callbackContext: function callbackContext(context /*, listener, eventObj*/ ) {
        return context;
    },
    beforeEmit: function beforeEmit() {},
    afterEmit: function afterEmit() {},
    bubble: function bubble() {
        return false;
    },
    parent: function parent() {
        return null;
    },
    context: null
};
var $e815fda779bc047b$var$defaultsKeys = Object.keys($e815fda779bc047b$var$defaults$8);
var $e815fda779bc047b$var$emptyOpts = {};
function $e815fda779bc047b$var$Emitter() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $e815fda779bc047b$var$emptyOpts;
    var context = arguments.length > 1 ? arguments[1] : undefined;
    // micro-optimisation vs Object.assign() -- reduces Element instantiation time
    for(var i = 0; i < $e815fda779bc047b$var$defaultsKeys.length; i++){
        var key = $e815fda779bc047b$var$defaultsKeys[i];
        this[key] = opts[key] || $e815fda779bc047b$var$defaults$8[key];
    }
    this.context = context || this.context;
    this.listeners = [];
    this.emitting = 0;
}
var $e815fda779bc047b$var$p = $e815fda779bc047b$var$Emitter.prototype;
var $e815fda779bc047b$var$forEachEvent = function forEachEvent(self1, handler, events, qualifier, callback, conf, confOverrides) {
    if ($e815fda779bc047b$var$fn$6(qualifier)) {
        callback = qualifier;
        qualifier = null;
    }
    if (confOverrides) {
        if (conf == null) conf = confOverrides;
        else conf = $e815fda779bc047b$var$extend({}, conf, confOverrides);
    }
    var eventList = $e815fda779bc047b$var$array(events) ? events : events.split(/\s+/);
    for(var i = 0; i < eventList.length; i++){
        var evt = eventList[i];
        if ($e815fda779bc047b$var$emptyString(evt)) continue;
        var match = evt.match($e815fda779bc047b$var$eventRegex); // type[.namespace]
        if (match) {
            var type = match[1];
            var namespace = match[2] ? match[2] : null;
            var ret = handler(self1, evt, type, namespace, qualifier, callback, conf);
            if (ret === false) break;
             // allow exiting early
        }
    }
};
var $e815fda779bc047b$var$makeEventObj = function makeEventObj(self1, obj) {
    self1.addEventFields(self1.context, obj);
    return new $e815fda779bc047b$var$Event(obj.type, obj);
};
var $e815fda779bc047b$var$forEachEventObj = function forEachEventObj(self1, handler, events) {
    if ($e815fda779bc047b$var$event(events)) {
        handler(self1, events);
        return;
    } else if ($e815fda779bc047b$var$plainObject(events)) {
        handler(self1, $e815fda779bc047b$var$makeEventObj(self1, events));
        return;
    }
    var eventList = $e815fda779bc047b$var$array(events) ? events : events.split(/\s+/);
    for(var i = 0; i < eventList.length; i++){
        var evt = eventList[i];
        if ($e815fda779bc047b$var$emptyString(evt)) continue;
        var match = evt.match($e815fda779bc047b$var$eventRegex); // type[.namespace]
        if (match) {
            var type = match[1];
            var namespace = match[2] ? match[2] : null;
            var eventObj = $e815fda779bc047b$var$makeEventObj(self1, {
                type: type,
                namespace: namespace,
                target: self1.context
            });
            handler(self1, eventObj);
        }
    }
};
$e815fda779bc047b$var$p.on = $e815fda779bc047b$var$p.addListener = function(events, qualifier, callback, conf, confOverrides) {
    $e815fda779bc047b$var$forEachEvent(this, function(self1, event, type, namespace, qualifier, callback, conf) {
        if ($e815fda779bc047b$var$fn$6(callback)) self1.listeners.push({
            event: event,
            // full event string
            callback: callback,
            // callback to run
            type: type,
            // the event type (e.g. 'click')
            namespace: namespace,
            // the event namespace (e.g. ".foo")
            qualifier: qualifier,
            // a restriction on whether to match this emitter
            conf: conf // additional configuration
        });
    }, events, qualifier, callback, conf, confOverrides);
    return this;
};
$e815fda779bc047b$var$p.one = function(events, qualifier, callback, conf) {
    return this.on(events, qualifier, callback, conf, {
        one: true
    });
};
$e815fda779bc047b$var$p.removeListener = $e815fda779bc047b$var$p.off = function(events, qualifier, callback, conf) {
    var _this = this;
    if (this.emitting !== 0) this.listeners = $e815fda779bc047b$var$copyArray(this.listeners);
    var listeners = this.listeners;
    var _loop = function _loop(i) {
        var listener = listeners[i];
        $e815fda779bc047b$var$forEachEvent(_this, function(self1, event, type, namespace, qualifier, callback /*, conf*/ ) {
            if ((listener.type === type || events === '*') && (!namespace && listener.namespace !== '.*' || listener.namespace === namespace) && (!qualifier || self1.qualifierCompare(listener.qualifier, qualifier)) && (!callback || listener.callback === callback)) {
                listeners.splice(i, 1);
                return false;
            }
        }, events, qualifier, callback, conf);
    };
    for(var i = listeners.length - 1; i >= 0; i--)_loop(i);
    return this;
};
$e815fda779bc047b$var$p.removeAllListeners = function() {
    return this.removeListener('*');
};
$e815fda779bc047b$var$p.emit = $e815fda779bc047b$var$p.trigger = function(events, extraParams, manualCallback) {
    var listeners = this.listeners;
    var numListenersBeforeEmit = listeners.length;
    this.emitting++;
    if (!$e815fda779bc047b$var$array(extraParams)) extraParams = [
        extraParams
    ];
    $e815fda779bc047b$var$forEachEventObj(this, function(self1, eventObj) {
        if (manualCallback != null) {
            listeners = [
                {
                    event: eventObj.event,
                    type: eventObj.type,
                    namespace: eventObj.namespace,
                    callback: manualCallback
                }
            ];
            numListenersBeforeEmit = listeners.length;
        }
        var _loop2 = function _loop2() {
            var listener = listeners[i];
            if (listener.type === eventObj.type && (!listener.namespace || listener.namespace === eventObj.namespace || listener.namespace === $e815fda779bc047b$var$universalNamespace) && self1.eventMatches(self1.context, listener, eventObj)) {
                var args = [
                    eventObj
                ];
                if (extraParams != null) $e815fda779bc047b$var$push(args, extraParams);
                self1.beforeEmit(self1.context, listener, eventObj);
                if (listener.conf && listener.conf.one) self1.listeners = self1.listeners.filter(function(l) {
                    return l !== listener;
                });
                var context = self1.callbackContext(self1.context, listener, eventObj);
                var ret = listener.callback.apply(context, args);
                self1.afterEmit(self1.context, listener, eventObj);
                if (ret === false) {
                    eventObj.stopPropagation();
                    eventObj.preventDefault();
                }
            } // if listener matches
        };
        for(var i = 0; i < numListenersBeforeEmit; i++)_loop2();
         // for listener
        if (self1.bubble(self1.context) && !eventObj.isPropagationStopped()) self1.parent(self1.context).emit(eventObj, extraParams);
    }, events);
    this.emitting--;
    return this;
};
var $e815fda779bc047b$var$emitterOptions$1 = {
    qualifierCompare: function qualifierCompare(selector1, selector2) {
        if (selector1 == null || selector2 == null) return selector1 == null && selector2 == null;
        else return selector1.sameText(selector2);
    },
    eventMatches: function eventMatches(ele, listener, eventObj) {
        var selector = listener.qualifier;
        if (selector != null) return ele !== eventObj.target && $e815fda779bc047b$var$element(eventObj.target) && selector.matches(eventObj.target);
        return true;
    },
    addEventFields: function addEventFields(ele, evt) {
        evt.cy = ele.cy();
        evt.target = ele;
    },
    callbackContext: function callbackContext(ele, listener, eventObj) {
        return listener.qualifier != null ? eventObj.target : ele;
    },
    beforeEmit: function beforeEmit(context, listener /*, eventObj*/ ) {
        if (listener.conf && listener.conf.once) listener.conf.onceCollection.removeListener(listener.event, listener.qualifier, listener.callback);
    },
    bubble: function bubble() {
        return true;
    },
    parent: function parent(ele) {
        return ele.isChild() ? ele.parent() : ele.cy();
    }
};
var $e815fda779bc047b$var$argSelector$1 = function argSelector(arg) {
    if ($e815fda779bc047b$var$string(arg)) return new $e815fda779bc047b$var$Selector(arg);
    else return arg;
};
var $e815fda779bc047b$var$elesfn$9 = {
    createEmitter: function createEmitter() {
        for(var i = 0; i < this.length; i++){
            var ele = this[i];
            var _p = ele._private;
            if (!_p.emitter) _p.emitter = new $e815fda779bc047b$var$Emitter($e815fda779bc047b$var$emitterOptions$1, ele);
        }
        return this;
    },
    emitter: function emitter() {
        return this._private.emitter;
    },
    on: function on(events, selector, callback) {
        var argSel = $e815fda779bc047b$var$argSelector$1(selector);
        for(var i = 0; i < this.length; i++){
            var ele = this[i];
            ele.emitter().on(events, argSel, callback);
        }
        return this;
    },
    removeListener: function removeListener(events, selector, callback) {
        var argSel = $e815fda779bc047b$var$argSelector$1(selector);
        for(var i = 0; i < this.length; i++){
            var ele = this[i];
            ele.emitter().removeListener(events, argSel, callback);
        }
        return this;
    },
    removeAllListeners: function removeAllListeners() {
        for(var i = 0; i < this.length; i++){
            var ele = this[i];
            ele.emitter().removeAllListeners();
        }
        return this;
    },
    one: function one(events, selector, callback) {
        var argSel = $e815fda779bc047b$var$argSelector$1(selector);
        for(var i = 0; i < this.length; i++){
            var ele = this[i];
            ele.emitter().one(events, argSel, callback);
        }
        return this;
    },
    once: function once(events, selector, callback) {
        var argSel = $e815fda779bc047b$var$argSelector$1(selector);
        for(var i = 0; i < this.length; i++){
            var ele = this[i];
            ele.emitter().on(events, argSel, callback, {
                once: true,
                onceCollection: this
            });
        }
    },
    emit: function emit(events, extraParams) {
        for(var i = 0; i < this.length; i++){
            var ele = this[i];
            ele.emitter().emit(events, extraParams);
        }
        return this;
    },
    emitAndNotify: function emitAndNotify(event, extraParams) {
        // for internal use only
        if (this.length === 0) return;
         // empty collections don't need to notify anything
        // notify renderer
        this.cy().notify(event, this);
        this.emit(event, extraParams);
        return this;
    }
};
$e815fda779bc047b$var$define.eventAliasesOn($e815fda779bc047b$var$elesfn$9);
var $e815fda779bc047b$var$elesfn$8 = {
    nodes: function nodes(selector) {
        return this.filter(function(ele) {
            return ele.isNode();
        }).filter(selector);
    },
    edges: function edges(selector) {
        return this.filter(function(ele) {
            return ele.isEdge();
        }).filter(selector);
    },
    // internal helper to get nodes and edges as separate collections with single iteration over elements
    byGroup: function byGroup() {
        var nodes = this.spawn();
        var edges = this.spawn();
        for(var i = 0; i < this.length; i++){
            var ele = this[i];
            if (ele.isNode()) nodes.push(ele);
            else edges.push(ele);
        }
        return {
            nodes: nodes,
            edges: edges
        };
    },
    filter: function filter(_filter, thisArg) {
        if (_filter === undefined) // check this first b/c it's the most common/performant case
        return this;
        else if ($e815fda779bc047b$var$string(_filter) || $e815fda779bc047b$var$elementOrCollection(_filter)) return new $e815fda779bc047b$var$Selector(_filter).filter(this);
        else if ($e815fda779bc047b$var$fn$6(_filter)) {
            var filterEles = this.spawn();
            var eles = this;
            for(var i = 0; i < eles.length; i++){
                var ele = eles[i];
                var include = thisArg ? _filter.apply(thisArg, [
                    ele,
                    i,
                    eles
                ]) : _filter(ele, i, eles);
                if (include) filterEles.push(ele);
            }
            return filterEles;
        }
        return this.spawn(); // if not handled by above, give 'em an empty collection
    },
    not: function not(toRemove) {
        if (!toRemove) return this;
        else {
            if ($e815fda779bc047b$var$string(toRemove)) toRemove = this.filter(toRemove);
            var elements = this.spawn();
            for(var i = 0; i < this.length; i++){
                var element = this[i];
                var remove = toRemove.has(element);
                if (!remove) elements.push(element);
            }
            return elements;
        }
    },
    absoluteComplement: function absoluteComplement() {
        var cy = this.cy();
        return cy.mutableElements().not(this);
    },
    intersect: function intersect(other) {
        // if a selector is specified, then filter by it instead
        if ($e815fda779bc047b$var$string(other)) {
            var selector = other;
            return this.filter(selector);
        }
        var elements = this.spawn();
        var col1 = this;
        var col2 = other;
        var col1Smaller = this.length < other.length;
        var colS = col1Smaller ? col1 : col2;
        var colL = col1Smaller ? col2 : col1;
        for(var i = 0; i < colS.length; i++){
            var ele = colS[i];
            if (colL.has(ele)) elements.push(ele);
        }
        return elements;
    },
    xor: function xor(other) {
        var cy = this._private.cy;
        if ($e815fda779bc047b$var$string(other)) other = cy.$(other);
        var elements = this.spawn();
        var col1 = this;
        var col2 = other;
        var add = function add(col, other) {
            for(var i = 0; i < col.length; i++){
                var ele = col[i];
                var id = ele._private.data.id;
                var inOther = other.hasElementWithId(id);
                if (!inOther) elements.push(ele);
            }
        };
        add(col1, col2);
        add(col2, col1);
        return elements;
    },
    diff: function diff(other) {
        var cy = this._private.cy;
        if ($e815fda779bc047b$var$string(other)) other = cy.$(other);
        var left = this.spawn();
        var right = this.spawn();
        var both = this.spawn();
        var col1 = this;
        var col2 = other;
        var add = function add(col, other, retEles) {
            for(var i = 0; i < col.length; i++){
                var ele = col[i];
                var id = ele._private.data.id;
                var inOther = other.hasElementWithId(id);
                if (inOther) both.merge(ele);
                else retEles.push(ele);
            }
        };
        add(col1, col2, left);
        add(col2, col1, right);
        return {
            left: left,
            right: right,
            both: both
        };
    },
    add: function add(toAdd) {
        var cy = this._private.cy;
        if (!toAdd) return this;
        if ($e815fda779bc047b$var$string(toAdd)) {
            var selector = toAdd;
            toAdd = cy.mutableElements().filter(selector);
        }
        var elements = this.spawnSelf();
        for(var i = 0; i < toAdd.length; i++){
            var ele = toAdd[i];
            var add = !this.has(ele);
            if (add) elements.push(ele);
        }
        return elements;
    },
    // in place merge on calling collection
    merge: function merge(toAdd) {
        var _p = this._private;
        var cy = _p.cy;
        if (!toAdd) return this;
        if (toAdd && $e815fda779bc047b$var$string(toAdd)) {
            var selector = toAdd;
            toAdd = cy.mutableElements().filter(selector);
        }
        var map = _p.map;
        for(var i = 0; i < toAdd.length; i++){
            var toAddEle = toAdd[i];
            var id = toAddEle._private.data.id;
            var add = !map.has(id);
            if (add) {
                var index = this.length++;
                this[index] = toAddEle;
                map.set(id, {
                    ele: toAddEle,
                    index: index
                });
            }
        }
        return this; // chaining
    },
    unmergeAt: function unmergeAt(i) {
        var ele = this[i];
        var id = ele.id();
        var _p = this._private;
        var map = _p.map;
        // remove ele
        this[i] = undefined;
        map["delete"](id);
        var unmergedLastEle = i === this.length - 1;
        // replace empty spot with last ele in collection
        if (this.length > 1 && !unmergedLastEle) {
            var lastEleI = this.length - 1;
            var lastEle = this[lastEleI];
            var lastEleId = lastEle._private.data.id;
            this[lastEleI] = undefined;
            this[i] = lastEle;
            map.set(lastEleId, {
                ele: lastEle,
                index: i
            });
        }
        // the collection is now 1 ele smaller
        this.length--;
        return this;
    },
    // remove single ele in place in calling collection
    unmergeOne: function unmergeOne(ele) {
        ele = ele[0];
        var _p = this._private;
        var id = ele._private.data.id;
        var map = _p.map;
        var entry = map.get(id);
        if (!entry) return this; // no need to remove
        var i = entry.index;
        this.unmergeAt(i);
        return this;
    },
    // remove eles in place on calling collection
    unmerge: function unmerge(toRemove) {
        var cy = this._private.cy;
        if (!toRemove) return this;
        if (toRemove && $e815fda779bc047b$var$string(toRemove)) {
            var selector = toRemove;
            toRemove = cy.mutableElements().filter(selector);
        }
        for(var i = 0; i < toRemove.length; i++)this.unmergeOne(toRemove[i]);
        return this; // chaining
    },
    unmergeBy: function unmergeBy(toRmFn) {
        for(var i = this.length - 1; i >= 0; i--){
            var ele = this[i];
            if (toRmFn(ele)) this.unmergeAt(i);
        }
        return this;
    },
    map: function map(mapFn, thisArg) {
        var arr = [];
        var eles = this;
        for(var i = 0; i < eles.length; i++){
            var ele = eles[i];
            var ret = thisArg ? mapFn.apply(thisArg, [
                ele,
                i,
                eles
            ]) : mapFn(ele, i, eles);
            arr.push(ret);
        }
        return arr;
    },
    reduce: function reduce(fn, initialValue) {
        var val = initialValue;
        var eles = this;
        for(var i = 0; i < eles.length; i++)val = fn(val, eles[i], i, eles);
        return val;
    },
    max: function max(valFn, thisArg) {
        var max = -Infinity;
        var maxEle;
        var eles = this;
        for(var i = 0; i < eles.length; i++){
            var ele = eles[i];
            var val = thisArg ? valFn.apply(thisArg, [
                ele,
                i,
                eles
            ]) : valFn(ele, i, eles);
            if (val > max) {
                max = val;
                maxEle = ele;
            }
        }
        return {
            value: max,
            ele: maxEle
        };
    },
    min: function min(valFn, thisArg) {
        var min = Infinity;
        var minEle;
        var eles = this;
        for(var i = 0; i < eles.length; i++){
            var ele = eles[i];
            var val = thisArg ? valFn.apply(thisArg, [
                ele,
                i,
                eles
            ]) : valFn(ele, i, eles);
            if (val < min) {
                min = val;
                minEle = ele;
            }
        }
        return {
            value: min,
            ele: minEle
        };
    }
};
// aliases
var $e815fda779bc047b$var$fn$1 = $e815fda779bc047b$var$elesfn$8;
$e815fda779bc047b$var$fn$1['u'] = $e815fda779bc047b$var$fn$1['|'] = $e815fda779bc047b$var$fn$1['+'] = $e815fda779bc047b$var$fn$1.union = $e815fda779bc047b$var$fn$1.or = $e815fda779bc047b$var$fn$1.add;
$e815fda779bc047b$var$fn$1['\\'] = $e815fda779bc047b$var$fn$1['!'] = $e815fda779bc047b$var$fn$1['-'] = $e815fda779bc047b$var$fn$1.difference = $e815fda779bc047b$var$fn$1.relativeComplement = $e815fda779bc047b$var$fn$1.subtract = $e815fda779bc047b$var$fn$1.not;
$e815fda779bc047b$var$fn$1['n'] = $e815fda779bc047b$var$fn$1['&'] = $e815fda779bc047b$var$fn$1['.'] = $e815fda779bc047b$var$fn$1.and = $e815fda779bc047b$var$fn$1.intersection = $e815fda779bc047b$var$fn$1.intersect;
$e815fda779bc047b$var$fn$1['^'] = $e815fda779bc047b$var$fn$1['(+)'] = $e815fda779bc047b$var$fn$1['(-)'] = $e815fda779bc047b$var$fn$1.symmetricDifference = $e815fda779bc047b$var$fn$1.symdiff = $e815fda779bc047b$var$fn$1.xor;
$e815fda779bc047b$var$fn$1.fnFilter = $e815fda779bc047b$var$fn$1.filterFn = $e815fda779bc047b$var$fn$1.stdFilter = $e815fda779bc047b$var$fn$1.filter;
$e815fda779bc047b$var$fn$1.complement = $e815fda779bc047b$var$fn$1.abscomp = $e815fda779bc047b$var$fn$1.absoluteComplement;
var $e815fda779bc047b$var$elesfn$7 = {
    isNode: function isNode() {
        return this.group() === 'nodes';
    },
    isEdge: function isEdge() {
        return this.group() === 'edges';
    },
    isLoop: function isLoop() {
        return this.isEdge() && this.source()[0] === this.target()[0];
    },
    isSimple: function isSimple() {
        return this.isEdge() && this.source()[0] !== this.target()[0];
    },
    group: function group() {
        var ele = this[0];
        if (ele) return ele._private.group;
    }
};
/**
 *  Elements are drawn in a specific order based on compound depth (low to high), the element type (nodes above edges),
 *  and z-index (low to high).  These styles affect how this applies:
 *
 *  z-compound-depth: May be `bottom | orphan | auto | top`.  The first drawn is `bottom`, then `orphan` which is the
 *      same depth as the root of the compound graph, followed by the default value `auto` which draws in order from
 *      root to leaves of the compound graph.  The last drawn is `top`.
 *  z-index-compare: May be `auto | manual`.  The default value is `auto` which always draws edges under nodes.
 *      `manual` ignores this convention and draws based on the `z-index` value setting.
 *  z-index: An integer value that affects the relative draw order of elements.  In general, an element with a higher
 *      `z-index` will be drawn on top of an element with a lower `z-index`.
 */ var $e815fda779bc047b$var$zIndexSort = function zIndexSort(a, b) {
    var cy = a.cy();
    var hasCompoundNodes = cy.hasCompoundNodes();
    function getDepth(ele) {
        var style = ele.pstyle('z-compound-depth');
        if (style.value === 'auto') return hasCompoundNodes ? ele.zDepth() : 0;
        else if (style.value === 'bottom') return -1;
        else if (style.value === 'top') return $e815fda779bc047b$var$MAX_INT$1;
        // 'orphan'
        return 0;
    }
    var depthDiff = getDepth(a) - getDepth(b);
    if (depthDiff !== 0) return depthDiff;
    function getEleDepth(ele) {
        var style = ele.pstyle('z-index-compare');
        if (style.value === 'auto') return ele.isNode() ? 1 : 0;
        // 'manual'
        return 0;
    }
    var eleDiff = getEleDepth(a) - getEleDepth(b);
    if (eleDiff !== 0) return eleDiff;
    var zDiff = a.pstyle('z-index').value - b.pstyle('z-index').value;
    if (zDiff !== 0) return zDiff;
    // compare indices in the core (order added to graph w/ last on top)
    return a.poolIndex() - b.poolIndex();
};
var $e815fda779bc047b$var$elesfn$6 = {
    forEach: function forEach(fn, thisArg) {
        if ($e815fda779bc047b$var$fn$6(fn)) {
            var N = this.length;
            for(var i = 0; i < N; i++){
                var ele = this[i];
                var ret = thisArg ? fn.apply(thisArg, [
                    ele,
                    i,
                    this
                ]) : fn(ele, i, this);
                if (ret === false) break;
                 // exit each early on return false
            }
        }
        return this;
    },
    toArray: function toArray() {
        var array = [];
        for(var i = 0; i < this.length; i++)array.push(this[i]);
        return array;
    },
    slice: function slice(start, end) {
        var array = [];
        var thisSize = this.length;
        if (end == null) end = thisSize;
        if (start == null) start = 0;
        if (start < 0) start = thisSize + start;
        if (end < 0) end = thisSize + end;
        for(var i = start; i >= 0 && i < end && i < thisSize; i++)array.push(this[i]);
        return this.spawn(array);
    },
    size: function size() {
        return this.length;
    },
    eq: function eq(i) {
        return this[i] || this.spawn();
    },
    first: function first() {
        return this[0] || this.spawn();
    },
    last: function last() {
        return this[this.length - 1] || this.spawn();
    },
    empty: function empty() {
        return this.length === 0;
    },
    nonempty: function nonempty() {
        return !this.empty();
    },
    sort: function sort(sortFn) {
        if (!$e815fda779bc047b$var$fn$6(sortFn)) return this;
        var sorted = this.toArray().sort(sortFn);
        return this.spawn(sorted);
    },
    sortByZIndex: function sortByZIndex() {
        return this.sort($e815fda779bc047b$var$zIndexSort);
    },
    zDepth: function zDepth() {
        var ele = this[0];
        if (!ele) return undefined;
        // let cy = ele.cy();
        var _p = ele._private;
        var group = _p.group;
        if (group === 'nodes') {
            var depth = _p.data.parent ? ele.parents().size() : 0;
            if (!ele.isParent()) return $e815fda779bc047b$var$MAX_INT$1 - 1; // childless nodes always on top
            return depth;
        } else {
            var src = _p.source;
            var tgt = _p.target;
            var srcDepth = src.zDepth();
            var tgtDepth = tgt.zDepth();
            return Math.max(srcDepth, tgtDepth, 0); // depth of deepest parent
        }
    }
};
$e815fda779bc047b$var$elesfn$6.each = $e815fda779bc047b$var$elesfn$6.forEach;
var $e815fda779bc047b$var$defineSymbolIterator = function defineSymbolIterator() {
    var typeofUndef = "undefined";
    var isIteratorSupported = (typeof Symbol === "undefined" ? "undefined" : $e815fda779bc047b$var$_typeof(Symbol)) != typeofUndef && $e815fda779bc047b$var$_typeof(Symbol.iterator) != typeofUndef;
    if (isIteratorSupported) $e815fda779bc047b$var$elesfn$6[Symbol.iterator] = function() {
        var _this = this;
        var entry = {
            value: undefined,
            done: false
        };
        var i = 0;
        var length = this.length;
        return $e815fda779bc047b$var$_defineProperty$1({
            next: function next() {
                if (i < length) entry.value = _this[i++];
                else {
                    entry.value = undefined;
                    entry.done = true;
                }
                return entry;
            }
        }, Symbol.iterator, function() {
            return this;
        });
    };
};
$e815fda779bc047b$var$defineSymbolIterator();
var $e815fda779bc047b$var$getLayoutDimensionOptions = $e815fda779bc047b$var$defaults$g({
    nodeDimensionsIncludeLabels: false
});
var $e815fda779bc047b$var$elesfn$5 = {
    // Calculates and returns node dimensions { x, y } based on options given
    layoutDimensions: function layoutDimensions(options) {
        options = $e815fda779bc047b$var$getLayoutDimensionOptions(options);
        var dims;
        if (!this.takesUpSpace()) dims = {
            w: 0,
            h: 0
        };
        else if (options.nodeDimensionsIncludeLabels) {
            var bbDim = this.boundingBox();
            dims = {
                w: bbDim.w,
                h: bbDim.h
            };
        } else dims = {
            w: this.outerWidth(),
            h: this.outerHeight()
        };
        // sanitise the dimensions for external layouts (avoid division by zero)
        if (dims.w === 0 || dims.h === 0) dims.w = dims.h = 1;
        return dims;
    },
    // using standard layout options, apply position function (w/ or w/o animation)
    layoutPositions: function layoutPositions(layout, options, fn) {
        var nodes = this.nodes().filter(function(n) {
            return !n.isParent();
        });
        var cy = this.cy();
        var layoutEles = options.eles; // nodes & edges
        var getMemoizeKey = function getMemoizeKey(node) {
            return node.id();
        };
        var fnMem = $e815fda779bc047b$var$memoize(fn, getMemoizeKey); // memoized version of position function
        layout.emit({
            type: 'layoutstart',
            layout: layout
        });
        layout.animations = [];
        var calculateSpacing = function calculateSpacing(spacing, nodesBb, pos) {
            var center = {
                x: nodesBb.x1 + nodesBb.w / 2,
                y: nodesBb.y1 + nodesBb.h / 2
            };
            var spacingVector = {
                // scale from center of bounding box (not necessarily 0,0)
                x: (pos.x - center.x) * spacing,
                y: (pos.y - center.y) * spacing
            };
            return {
                x: center.x + spacingVector.x,
                y: center.y + spacingVector.y
            };
        };
        var useSpacingFactor = options.spacingFactor && options.spacingFactor !== 1;
        var spacingBb = function spacingBb() {
            if (!useSpacingFactor) return null;
            var bb = $e815fda779bc047b$var$makeBoundingBox();
            for(var i = 0; i < nodes.length; i++){
                var node = nodes[i];
                var pos = fnMem(node, i);
                $e815fda779bc047b$var$expandBoundingBoxByPoint(bb, pos.x, pos.y);
            }
            return bb;
        };
        var bb = spacingBb();
        var getFinalPos = $e815fda779bc047b$var$memoize(function(node, i) {
            var newPos = fnMem(node, i);
            if (useSpacingFactor) {
                var spacing = Math.abs(options.spacingFactor);
                newPos = calculateSpacing(spacing, bb, newPos);
            }
            if (options.transform != null) newPos = options.transform(node, newPos);
            return newPos;
        }, getMemoizeKey);
        if (options.animate) {
            for(var i = 0; i < nodes.length; i++){
                var node = nodes[i];
                var newPos = getFinalPos(node, i);
                var animateNode = options.animateFilter == null || options.animateFilter(node, i);
                if (animateNode) {
                    var ani = node.animation({
                        position: newPos,
                        duration: options.animationDuration,
                        easing: options.animationEasing
                    });
                    layout.animations.push(ani);
                } else node.position(newPos);
            }
            if (options.fit) {
                var fitAni = cy.animation({
                    fit: {
                        boundingBox: layoutEles.boundingBoxAt(getFinalPos),
                        padding: options.padding
                    },
                    duration: options.animationDuration,
                    easing: options.animationEasing
                });
                layout.animations.push(fitAni);
            } else if (options.zoom !== undefined && options.pan !== undefined) {
                var zoomPanAni = cy.animation({
                    zoom: options.zoom,
                    pan: options.pan,
                    duration: options.animationDuration,
                    easing: options.animationEasing
                });
                layout.animations.push(zoomPanAni);
            }
            layout.animations.forEach(function(ani) {
                return ani.play();
            });
            layout.one('layoutready', options.ready);
            layout.emit({
                type: 'layoutready',
                layout: layout
            });
            $e815fda779bc047b$var$Promise$1.all(layout.animations.map(function(ani) {
                return ani.promise();
            })).then(function() {
                layout.one('layoutstop', options.stop);
                layout.emit({
                    type: 'layoutstop',
                    layout: layout
                });
            });
        } else {
            nodes.positions(getFinalPos);
            if (options.fit) cy.fit(options.eles, options.padding);
            if (options.zoom != null) cy.zoom(options.zoom);
            if (options.pan) cy.pan(options.pan);
            layout.one('layoutready', options.ready);
            layout.emit({
                type: 'layoutready',
                layout: layout
            });
            layout.one('layoutstop', options.stop);
            layout.emit({
                type: 'layoutstop',
                layout: layout
            });
        }
        return this; // chaining
    },
    layout: function layout(options) {
        var cy = this.cy();
        return cy.makeLayout($e815fda779bc047b$var$extend({}, options, {
            eles: this
        }));
    }
};
// aliases:
$e815fda779bc047b$var$elesfn$5.createLayout = $e815fda779bc047b$var$elesfn$5.makeLayout = $e815fda779bc047b$var$elesfn$5.layout;
function $e815fda779bc047b$var$styleCache(key, fn, ele) {
    var _p = ele._private;
    var cache = _p.styleCache = _p.styleCache || [];
    var val;
    if ((val = cache[key]) != null) return val;
    else {
        val = cache[key] = fn(ele);
        return val;
    }
}
function $e815fda779bc047b$var$cacheStyleFunction(key, fn) {
    key = $e815fda779bc047b$var$hashString(key);
    return function cachedStyleFunction(ele) {
        return $e815fda779bc047b$var$styleCache(key, fn, ele);
    };
}
function $e815fda779bc047b$var$cachePrototypeStyleFunction(key, fn) {
    key = $e815fda779bc047b$var$hashString(key);
    var selfFn = function selfFn(ele) {
        return fn.call(ele);
    };
    return function cachedPrototypeStyleFunction() {
        var ele = this[0];
        if (ele) return $e815fda779bc047b$var$styleCache(key, selfFn, ele);
    };
}
var $e815fda779bc047b$var$elesfn$4 = {
    recalculateRenderedStyle: function recalculateRenderedStyle(useCache) {
        var cy = this.cy();
        var renderer = cy.renderer();
        var styleEnabled = cy.styleEnabled();
        if (renderer && styleEnabled) renderer.recalculateRenderedStyle(this, useCache);
        return this;
    },
    dirtyStyleCache: function dirtyStyleCache() {
        var cy = this.cy();
        var dirty = function dirty(ele) {
            return ele._private.styleCache = null;
        };
        if (cy.hasCompoundNodes()) {
            var eles;
            eles = this.spawnSelf().merge(this.descendants()).merge(this.parents());
            eles.merge(eles.connectedEdges());
            eles.forEach(dirty);
        } else this.forEach(function(ele) {
            dirty(ele);
            ele.connectedEdges().forEach(dirty);
        });
        return this;
    },
    // fully updates (recalculates) the style for the elements
    updateStyle: function updateStyle(notifyRenderer) {
        var cy = this._private.cy;
        if (!cy.styleEnabled()) return this;
        if (cy.batching()) {
            var bEles = cy._private.batchStyleEles;
            bEles.merge(this);
            return this; // chaining and exit early when batching
        }
        var hasCompounds = cy.hasCompoundNodes();
        var updatedEles = this;
        notifyRenderer = notifyRenderer || notifyRenderer === undefined ? true : false;
        if (hasCompounds) // then add everything up and down for compound selector checks
        updatedEles = this.spawnSelf().merge(this.descendants()).merge(this.parents());
        // let changedEles = style.apply( updatedEles );
        var changedEles = updatedEles;
        if (notifyRenderer) changedEles.emitAndNotify('style'); // let renderer know we changed style
        else changedEles.emit('style'); // just fire the event
        updatedEles.forEach(function(ele) {
            return ele._private.styleDirty = true;
        });
        return this; // chaining
    },
    // private: clears dirty flag and recalculates style
    cleanStyle: function cleanStyle() {
        var cy = this.cy();
        if (!cy.styleEnabled()) return;
        for(var i = 0; i < this.length; i++){
            var ele = this[i];
            if (ele._private.styleDirty) {
                // n.b. this flag should be set before apply() to avoid potential infinite recursion
                ele._private.styleDirty = false;
                cy.style().apply(ele);
            }
        }
    },
    // get the internal parsed style object for the specified property
    parsedStyle: function parsedStyle(property) {
        var includeNonDefault = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
        var ele = this[0];
        var cy = ele.cy();
        if (!cy.styleEnabled()) return;
        if (ele) {
            // this.cleanStyle();
            // Inline the important part of cleanStyle(), for raw performance
            if (ele._private.styleDirty) {
                // n.b. this flag should be set before apply() to avoid potential infinite recursion
                ele._private.styleDirty = false;
                cy.style().apply(ele);
            }
            var overriddenStyle = ele._private.style[property];
            if (overriddenStyle != null) return overriddenStyle;
            else if (includeNonDefault) return cy.style().getDefaultProperty(property);
            else return null;
        }
    },
    numericStyle: function numericStyle(property) {
        var ele = this[0];
        if (!ele.cy().styleEnabled()) return;
        if (ele) {
            var pstyle = ele.pstyle(property);
            return pstyle.pfValue !== undefined ? pstyle.pfValue : pstyle.value;
        }
    },
    numericStyleUnits: function numericStyleUnits(property) {
        var ele = this[0];
        if (!ele.cy().styleEnabled()) return;
        if (ele) return ele.pstyle(property).units;
    },
    // get the specified css property as a rendered value (i.e. on-screen value)
    // or get the whole rendered style if no property specified (NB doesn't allow setting)
    renderedStyle: function renderedStyle(property) {
        var cy = this.cy();
        if (!cy.styleEnabled()) return this;
        var ele = this[0];
        if (ele) return cy.style().getRenderedStyle(ele, property);
    },
    // read the calculated css style of the element or override the style (via a bypass)
    style: function style(name, value) {
        var cy = this.cy();
        if (!cy.styleEnabled()) return this;
        var updateTransitions = false;
        var style = cy.style();
        if ($e815fda779bc047b$var$plainObject(name)) {
            // then extend the bypass
            var props = name;
            style.applyBypass(this, props, updateTransitions);
            this.emitAndNotify('style'); // let the renderer know we've updated style
        } else if ($e815fda779bc047b$var$string(name)) {
            if (value === undefined) {
                // then get the property from the style
                var ele = this[0];
                if (ele) return style.getStylePropertyValue(ele, name);
                else // empty collection => can't get any value
                return;
            } else {
                // then set the bypass with the property value
                style.applyBypass(this, name, value, updateTransitions);
                this.emitAndNotify('style'); // let the renderer know we've updated style
            }
        } else if (name === undefined) {
            var _ele = this[0];
            if (_ele) return style.getRawStyle(_ele);
            else // empty collection => can't get any value
            return;
        }
        return this; // chaining
    },
    removeStyle: function removeStyle(names) {
        var cy = this.cy();
        if (!cy.styleEnabled()) return this;
        var updateTransitions = false;
        var style = cy.style();
        var eles = this;
        if (names === undefined) for(var i = 0; i < eles.length; i++){
            var ele = eles[i];
            style.removeAllBypasses(ele, updateTransitions);
        }
        else {
            names = names.split(/\s+/);
            for(var _i = 0; _i < eles.length; _i++){
                var _ele2 = eles[_i];
                style.removeBypasses(_ele2, names, updateTransitions);
            }
        }
        this.emitAndNotify('style'); // let the renderer know we've updated style
        return this; // chaining
    },
    show: function show() {
        this.css('display', 'element');
        return this; // chaining
    },
    hide: function hide() {
        this.css('display', 'none');
        return this; // chaining
    },
    effectiveOpacity: function effectiveOpacity() {
        var cy = this.cy();
        if (!cy.styleEnabled()) return 1;
        var hasCompoundNodes = cy.hasCompoundNodes();
        var ele = this[0];
        if (ele) {
            var _p = ele._private;
            var parentOpacity = ele.pstyle('opacity').value;
            if (!hasCompoundNodes) return parentOpacity;
            var parents = !_p.data.parent ? null : ele.parents();
            if (parents) for(var i = 0; i < parents.length; i++){
                var parent = parents[i];
                var opacity = parent.pstyle('opacity').value;
                parentOpacity = opacity * parentOpacity;
            }
            return parentOpacity;
        }
    },
    transparent: function transparent() {
        var cy = this.cy();
        if (!cy.styleEnabled()) return false;
        var ele = this[0];
        var hasCompoundNodes = ele.cy().hasCompoundNodes();
        if (ele) {
            if (!hasCompoundNodes) return ele.pstyle('opacity').value === 0;
            else return ele.effectiveOpacity() === 0;
        }
    },
    backgrounding: function backgrounding() {
        var cy = this.cy();
        if (!cy.styleEnabled()) return false;
        var ele = this[0];
        return ele._private.backgrounding ? true : false;
    }
};
function $e815fda779bc047b$var$checkCompound(ele, parentOk) {
    var _p = ele._private;
    var parents = _p.data.parent ? ele.parents() : null;
    if (parents) for(var i = 0; i < parents.length; i++){
        var parent = parents[i];
        if (!parentOk(parent)) return false;
    }
    return true;
}
function $e815fda779bc047b$var$defineDerivedStateFunction(specs) {
    var ok = specs.ok;
    var edgeOkViaNode = specs.edgeOkViaNode || specs.ok;
    var parentOk = specs.parentOk || specs.ok;
    return function() {
        var cy = this.cy();
        if (!cy.styleEnabled()) return true;
        var ele = this[0];
        var hasCompoundNodes = cy.hasCompoundNodes();
        if (ele) {
            var _p = ele._private;
            if (!ok(ele)) return false;
            if (ele.isNode()) return !hasCompoundNodes || $e815fda779bc047b$var$checkCompound(ele, parentOk);
            else {
                var src = _p.source;
                var tgt = _p.target;
                return edgeOkViaNode(src) && (!hasCompoundNodes || $e815fda779bc047b$var$checkCompound(src, edgeOkViaNode)) && (src === tgt || edgeOkViaNode(tgt) && (!hasCompoundNodes || $e815fda779bc047b$var$checkCompound(tgt, edgeOkViaNode)));
            }
        }
    };
}
var $e815fda779bc047b$var$eleTakesUpSpace = $e815fda779bc047b$var$cacheStyleFunction('eleTakesUpSpace', function(ele) {
    return ele.pstyle('display').value === 'element' && ele.width() !== 0 && (ele.isNode() ? ele.height() !== 0 : true);
});
$e815fda779bc047b$var$elesfn$4.takesUpSpace = $e815fda779bc047b$var$cachePrototypeStyleFunction('takesUpSpace', $e815fda779bc047b$var$defineDerivedStateFunction({
    ok: $e815fda779bc047b$var$eleTakesUpSpace
}));
var $e815fda779bc047b$var$eleInteractive = $e815fda779bc047b$var$cacheStyleFunction('eleInteractive', function(ele) {
    return ele.pstyle('events').value === 'yes' && ele.pstyle('visibility').value === 'visible' && $e815fda779bc047b$var$eleTakesUpSpace(ele);
});
var $e815fda779bc047b$var$parentInteractive = $e815fda779bc047b$var$cacheStyleFunction('parentInteractive', function(parent) {
    return parent.pstyle('visibility').value === 'visible' && $e815fda779bc047b$var$eleTakesUpSpace(parent);
});
$e815fda779bc047b$var$elesfn$4.interactive = $e815fda779bc047b$var$cachePrototypeStyleFunction('interactive', $e815fda779bc047b$var$defineDerivedStateFunction({
    ok: $e815fda779bc047b$var$eleInteractive,
    parentOk: $e815fda779bc047b$var$parentInteractive,
    edgeOkViaNode: $e815fda779bc047b$var$eleTakesUpSpace
}));
$e815fda779bc047b$var$elesfn$4.noninteractive = function() {
    var ele = this[0];
    if (ele) return !ele.interactive();
};
var $e815fda779bc047b$var$eleVisible = $e815fda779bc047b$var$cacheStyleFunction('eleVisible', function(ele) {
    return ele.pstyle('visibility').value === 'visible' && ele.pstyle('opacity').pfValue !== 0 && $e815fda779bc047b$var$eleTakesUpSpace(ele);
});
var $e815fda779bc047b$var$edgeVisibleViaNode = $e815fda779bc047b$var$eleTakesUpSpace;
$e815fda779bc047b$var$elesfn$4.visible = $e815fda779bc047b$var$cachePrototypeStyleFunction('visible', $e815fda779bc047b$var$defineDerivedStateFunction({
    ok: $e815fda779bc047b$var$eleVisible,
    edgeOkViaNode: $e815fda779bc047b$var$edgeVisibleViaNode
}));
$e815fda779bc047b$var$elesfn$4.hidden = function() {
    var ele = this[0];
    if (ele) return !ele.visible();
};
$e815fda779bc047b$var$elesfn$4.isBundledBezier = $e815fda779bc047b$var$cachePrototypeStyleFunction('isBundledBezier', function() {
    if (!this.cy().styleEnabled()) return false;
    return !this.removed() && this.pstyle('curve-style').value === 'bezier' && this.takesUpSpace();
});
$e815fda779bc047b$var$elesfn$4.bypass = $e815fda779bc047b$var$elesfn$4.css = $e815fda779bc047b$var$elesfn$4.style;
$e815fda779bc047b$var$elesfn$4.renderedCss = $e815fda779bc047b$var$elesfn$4.renderedStyle;
$e815fda779bc047b$var$elesfn$4.removeBypass = $e815fda779bc047b$var$elesfn$4.removeCss = $e815fda779bc047b$var$elesfn$4.removeStyle;
$e815fda779bc047b$var$elesfn$4.pstyle = $e815fda779bc047b$var$elesfn$4.parsedStyle;
var $e815fda779bc047b$var$elesfn$3 = {};
function $e815fda779bc047b$var$defineSwitchFunction(params) {
    return function() {
        var args = arguments;
        var changedEles = [];
        // e.g. cy.nodes().select( data, handler )
        if (args.length === 2) {
            var data = args[0];
            var handler = args[1];
            this.on(params.event, data, handler);
        } else if (args.length === 1 && $e815fda779bc047b$var$fn$6(args[0])) {
            var _handler = args[0];
            this.on(params.event, _handler);
        } else if (args.length === 0 || args.length === 1 && $e815fda779bc047b$var$array(args[0])) {
            var addlEvents = args.length === 1 ? args[0] : null;
            for(var i = 0; i < this.length; i++){
                var ele = this[i];
                var able = !params.ableField || ele._private[params.ableField];
                var changed = ele._private[params.field] != params.value;
                if (params.overrideAble) {
                    var overrideAble = params.overrideAble(ele);
                    if (overrideAble !== undefined) {
                        able = overrideAble;
                        if (!overrideAble) return this;
                         // to save cycles assume not able for all on override
                    }
                }
                if (able) {
                    ele._private[params.field] = params.value;
                    if (changed) changedEles.push(ele);
                }
            }
            var changedColl = this.spawn(changedEles);
            changedColl.updateStyle(); // change of state => possible change of style
            changedColl.emit(params.event);
            if (addlEvents) changedColl.emit(addlEvents);
        }
        return this;
    };
}
function $e815fda779bc047b$var$defineSwitchSet(params) {
    $e815fda779bc047b$var$elesfn$3[params.field] = function() {
        var ele = this[0];
        if (ele) {
            if (params.overrideField) {
                var val = params.overrideField(ele);
                if (val !== undefined) return val;
            }
            return ele._private[params.field];
        }
    };
    $e815fda779bc047b$var$elesfn$3[params.on] = $e815fda779bc047b$var$defineSwitchFunction({
        event: params.on,
        field: params.field,
        ableField: params.ableField,
        overrideAble: params.overrideAble,
        value: true
    });
    $e815fda779bc047b$var$elesfn$3[params.off] = $e815fda779bc047b$var$defineSwitchFunction({
        event: params.off,
        field: params.field,
        ableField: params.ableField,
        overrideAble: params.overrideAble,
        value: false
    });
}
$e815fda779bc047b$var$defineSwitchSet({
    field: 'locked',
    overrideField: function overrideField(ele) {
        return ele.cy().autolock() ? true : undefined;
    },
    on: 'lock',
    off: 'unlock'
});
$e815fda779bc047b$var$defineSwitchSet({
    field: 'grabbable',
    overrideField: function overrideField(ele) {
        return ele.cy().autoungrabify() || ele.pannable() ? false : undefined;
    },
    on: 'grabify',
    off: 'ungrabify'
});
$e815fda779bc047b$var$defineSwitchSet({
    field: 'selected',
    ableField: 'selectable',
    overrideAble: function overrideAble(ele) {
        return ele.cy().autounselectify() ? false : undefined;
    },
    on: 'select',
    off: 'unselect'
});
$e815fda779bc047b$var$defineSwitchSet({
    field: 'selectable',
    overrideField: function overrideField(ele) {
        return ele.cy().autounselectify() ? false : undefined;
    },
    on: 'selectify',
    off: 'unselectify'
});
$e815fda779bc047b$var$elesfn$3.deselect = $e815fda779bc047b$var$elesfn$3.unselect;
$e815fda779bc047b$var$elesfn$3.grabbed = function() {
    var ele = this[0];
    if (ele) return ele._private.grabbed;
};
$e815fda779bc047b$var$defineSwitchSet({
    field: 'active',
    on: 'activate',
    off: 'unactivate'
});
$e815fda779bc047b$var$defineSwitchSet({
    field: 'pannable',
    on: 'panify',
    off: 'unpanify'
});
$e815fda779bc047b$var$elesfn$3.inactive = function() {
    var ele = this[0];
    if (ele) return !ele._private.active;
};
var $e815fda779bc047b$var$elesfn$2 = {};
// DAG functions
////////////////
var $e815fda779bc047b$var$defineDagExtremity = function defineDagExtremity(params) {
    return function dagExtremityImpl(selector) {
        var eles = this;
        var ret = [];
        for(var i = 0; i < eles.length; i++){
            var ele = eles[i];
            if (!ele.isNode()) continue;
            var disqualified = false;
            var edges = ele.connectedEdges();
            for(var j = 0; j < edges.length; j++){
                var edge = edges[j];
                var src = edge.source();
                var tgt = edge.target();
                if (params.noIncomingEdges && tgt === ele && src !== ele || params.noOutgoingEdges && src === ele && tgt !== ele) {
                    disqualified = true;
                    break;
                }
            }
            if (!disqualified) ret.push(ele);
        }
        return this.spawn(ret, true).filter(selector);
    };
};
var $e815fda779bc047b$var$defineDagOneHop = function defineDagOneHop(params) {
    return function(selector) {
        var eles = this;
        var oEles = [];
        for(var i = 0; i < eles.length; i++){
            var ele = eles[i];
            if (!ele.isNode()) continue;
            var edges = ele.connectedEdges();
            for(var j = 0; j < edges.length; j++){
                var edge = edges[j];
                var src = edge.source();
                var tgt = edge.target();
                if (params.outgoing && src === ele) {
                    oEles.push(edge);
                    oEles.push(tgt);
                } else if (params.incoming && tgt === ele) {
                    oEles.push(edge);
                    oEles.push(src);
                }
            }
        }
        return this.spawn(oEles, true).filter(selector);
    };
};
var $e815fda779bc047b$var$defineDagAllHops = function defineDagAllHops(params) {
    return function(selector) {
        var eles = this;
        var sEles = [];
        var sElesIds = {};
        for(;;){
            var next = params.outgoing ? eles.outgoers() : eles.incomers();
            if (next.length === 0) break;
             // done if none left
            var newNext = false;
            for(var i = 0; i < next.length; i++){
                var n = next[i];
                var nid = n.id();
                if (!sElesIds[nid]) {
                    sElesIds[nid] = true;
                    sEles.push(n);
                    newNext = true;
                }
            }
            if (!newNext) break;
             // done if touched all outgoers already
            eles = next;
        }
        return this.spawn(sEles, true).filter(selector);
    };
};
$e815fda779bc047b$var$elesfn$2.clearTraversalCache = function() {
    for(var i = 0; i < this.length; i++)this[i]._private.traversalCache = null;
};
$e815fda779bc047b$var$extend($e815fda779bc047b$var$elesfn$2, {
    // get the root nodes in the DAG
    roots: $e815fda779bc047b$var$defineDagExtremity({
        noIncomingEdges: true
    }),
    // get the leaf nodes in the DAG
    leaves: $e815fda779bc047b$var$defineDagExtremity({
        noOutgoingEdges: true
    }),
    // normally called children in graph theory
    // these nodes =edges=> outgoing nodes
    outgoers: $e815fda779bc047b$var$cache($e815fda779bc047b$var$defineDagOneHop({
        outgoing: true
    }), 'outgoers'),
    // aka DAG descendants
    successors: $e815fda779bc047b$var$defineDagAllHops({
        outgoing: true
    }),
    // normally called parents in graph theory
    // these nodes <=edges= incoming nodes
    incomers: $e815fda779bc047b$var$cache($e815fda779bc047b$var$defineDagOneHop({
        incoming: true
    }), 'incomers'),
    // aka DAG ancestors
    predecessors: $e815fda779bc047b$var$defineDagAllHops({})
});
// Neighbourhood functions
//////////////////////////
$e815fda779bc047b$var$extend($e815fda779bc047b$var$elesfn$2, {
    neighborhood: $e815fda779bc047b$var$cache(function(selector) {
        var elements = [];
        var nodes = this.nodes();
        for(var i = 0; i < nodes.length; i++){
            // for all nodes
            var node = nodes[i];
            var connectedEdges = node.connectedEdges();
            // for each connected edge, add the edge and the other node
            for(var j = 0; j < connectedEdges.length; j++){
                var edge = connectedEdges[j];
                var src = edge.source();
                var tgt = edge.target();
                var otherNode = node === src ? tgt : src;
                // need check in case of loop
                if (otherNode.length > 0) elements.push(otherNode[0]); // add node 1 hop away
                // add connected edge
                elements.push(edge[0]);
            }
        }
        return this.spawn(elements, true).filter(selector);
    }, 'neighborhood'),
    closedNeighborhood: function closedNeighborhood(selector) {
        return this.neighborhood().add(this).filter(selector);
    },
    openNeighborhood: function openNeighborhood(selector) {
        return this.neighborhood(selector);
    }
});
// aliases
$e815fda779bc047b$var$elesfn$2.neighbourhood = $e815fda779bc047b$var$elesfn$2.neighborhood;
$e815fda779bc047b$var$elesfn$2.closedNeighbourhood = $e815fda779bc047b$var$elesfn$2.closedNeighborhood;
$e815fda779bc047b$var$elesfn$2.openNeighbourhood = $e815fda779bc047b$var$elesfn$2.openNeighborhood;
// Edge functions
/////////////////
$e815fda779bc047b$var$extend($e815fda779bc047b$var$elesfn$2, {
    source: $e815fda779bc047b$var$cache(function sourceImpl(selector) {
        var ele = this[0];
        var src;
        if (ele) src = ele._private.source || ele.cy().collection();
        return src && selector ? src.filter(selector) : src;
    }, 'source'),
    target: $e815fda779bc047b$var$cache(function targetImpl(selector) {
        var ele = this[0];
        var tgt;
        if (ele) tgt = ele._private.target || ele.cy().collection();
        return tgt && selector ? tgt.filter(selector) : tgt;
    }, 'target'),
    sources: $e815fda779bc047b$var$defineSourceFunction({
        attr: 'source'
    }),
    targets: $e815fda779bc047b$var$defineSourceFunction({
        attr: 'target'
    })
});
function $e815fda779bc047b$var$defineSourceFunction(params) {
    return function sourceImpl(selector) {
        var sources = [];
        for(var i = 0; i < this.length; i++){
            var ele = this[i];
            var src = ele._private[params.attr];
            if (src) sources.push(src);
        }
        return this.spawn(sources, true).filter(selector);
    };
}
$e815fda779bc047b$var$extend($e815fda779bc047b$var$elesfn$2, {
    edgesWith: $e815fda779bc047b$var$cache($e815fda779bc047b$var$defineEdgesWithFunction(), 'edgesWith'),
    edgesTo: $e815fda779bc047b$var$cache($e815fda779bc047b$var$defineEdgesWithFunction({
        thisIsSrc: true
    }), 'edgesTo')
});
function $e815fda779bc047b$var$defineEdgesWithFunction(params) {
    return function edgesWithImpl(otherNodes) {
        var elements = [];
        var cy = this._private.cy;
        var p = params || {};
        // get elements if a selector is specified
        if ($e815fda779bc047b$var$string(otherNodes)) otherNodes = cy.$(otherNodes);
        for(var h = 0; h < otherNodes.length; h++){
            var edges = otherNodes[h]._private.edges;
            for(var i = 0; i < edges.length; i++){
                var edge = edges[i];
                var edgeData = edge._private.data;
                var thisToOther = this.hasElementWithId(edgeData.source) && otherNodes.hasElementWithId(edgeData.target);
                var otherToThis = otherNodes.hasElementWithId(edgeData.source) && this.hasElementWithId(edgeData.target);
                var edgeConnectsThisAndOther = thisToOther || otherToThis;
                if (!edgeConnectsThisAndOther) continue;
                if (p.thisIsSrc || p.thisIsTgt) {
                    if (p.thisIsSrc && !thisToOther) continue;
                    if (p.thisIsTgt && !otherToThis) continue;
                }
                elements.push(edge);
            }
        }
        return this.spawn(elements, true);
    };
}
$e815fda779bc047b$var$extend($e815fda779bc047b$var$elesfn$2, {
    connectedEdges: $e815fda779bc047b$var$cache(function(selector) {
        var retEles = [];
        var eles = this;
        for(var i = 0; i < eles.length; i++){
            var node = eles[i];
            if (!node.isNode()) continue;
            var edges = node._private.edges;
            for(var j = 0; j < edges.length; j++){
                var edge = edges[j];
                retEles.push(edge);
            }
        }
        return this.spawn(retEles, true).filter(selector);
    }, 'connectedEdges'),
    connectedNodes: $e815fda779bc047b$var$cache(function(selector) {
        var retEles = [];
        var eles = this;
        for(var i = 0; i < eles.length; i++){
            var edge = eles[i];
            if (!edge.isEdge()) continue;
            retEles.push(edge.source()[0]);
            retEles.push(edge.target()[0]);
        }
        return this.spawn(retEles, true).filter(selector);
    }, 'connectedNodes'),
    parallelEdges: $e815fda779bc047b$var$cache($e815fda779bc047b$var$defineParallelEdgesFunction(), 'parallelEdges'),
    codirectedEdges: $e815fda779bc047b$var$cache($e815fda779bc047b$var$defineParallelEdgesFunction({
        codirected: true
    }), 'codirectedEdges')
});
function $e815fda779bc047b$var$defineParallelEdgesFunction(params) {
    var defaults = {
        codirected: false
    };
    params = $e815fda779bc047b$var$extend({}, defaults, params);
    return function parallelEdgesImpl(selector) {
        // micro-optimised for renderer
        var elements = [];
        var edges = this.edges();
        var p = params;
        // look at all the edges in the collection
        for(var i = 0; i < edges.length; i++){
            var edge1 = edges[i];
            var edge1_p = edge1._private;
            var src1 = edge1_p.source;
            var srcid1 = src1._private.data.id;
            var tgtid1 = edge1_p.data.target;
            var srcEdges1 = src1._private.edges;
            // look at edges connected to the src node of this edge
            for(var j = 0; j < srcEdges1.length; j++){
                var edge2 = srcEdges1[j];
                var edge2data = edge2._private.data;
                var tgtid2 = edge2data.target;
                var srcid2 = edge2data.source;
                var codirected = tgtid2 === tgtid1 && srcid2 === srcid1;
                var oppdirected = srcid1 === tgtid2 && tgtid1 === srcid2;
                if (p.codirected && codirected || !p.codirected && (codirected || oppdirected)) elements.push(edge2);
            }
        }
        return this.spawn(elements, true).filter(selector);
    };
}
// Misc functions
/////////////////
$e815fda779bc047b$var$extend($e815fda779bc047b$var$elesfn$2, {
    components: function components(root) {
        var self1 = this;
        var cy = self1.cy();
        var visited = cy.collection();
        var unvisited = root == null ? self1.nodes() : root.nodes();
        var components = [];
        if (root != null && unvisited.empty()) // root may contain only edges
        unvisited = root.sources(); // doesn't matter which node to use (undirected), so just use the source sides
        var visitInComponent = function visitInComponent(node, component) {
            visited.merge(node);
            unvisited.unmerge(node);
            component.merge(node);
        };
        if (unvisited.empty()) return self1.spawn();
        var _loop = function _loop() {
            // each iteration yields a component
            var cmpt = cy.collection();
            components.push(cmpt);
            var root = unvisited[0];
            visitInComponent(root, cmpt);
            self1.bfs({
                directed: false,
                roots: root,
                visit: function visit(v) {
                    return visitInComponent(v, cmpt);
                }
            });
            cmpt.forEach(function(node) {
                node.connectedEdges().forEach(function(e) {
                    // connectedEdges() usually cached
                    if (self1.has(e) && cmpt.has(e.source()) && cmpt.has(e.target())) // has() is cheap
                    cmpt.merge(e); // forEach() only considers nodes -- sets N at call time
                });
            });
        };
        do _loop();
        while (unvisited.length > 0);
        return components;
    },
    component: function component() {
        var ele = this[0];
        return ele.cy().mutableElements().components(ele)[0];
    }
});
$e815fda779bc047b$var$elesfn$2.componentsOf = $e815fda779bc047b$var$elesfn$2.components;
// represents a set of nodes, edges, or both together
var $e815fda779bc047b$var$Collection = function Collection(cy, elements) {
    var unique = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var removed = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    if (cy === undefined) {
        $e815fda779bc047b$var$error('A collection must have a reference to the core');
        return;
    }
    var map = new $e815fda779bc047b$var$Map$1();
    var createdElements = false;
    if (!elements) elements = [];
    else if (elements.length > 0 && $e815fda779bc047b$var$plainObject(elements[0]) && !$e815fda779bc047b$var$element(elements[0])) {
        createdElements = true;
        // make elements from json and restore all at once later
        var eles = [];
        var elesIds = new $e815fda779bc047b$var$Set$1();
        for(var i = 0, l = elements.length; i < l; i++){
            var json = elements[i];
            if (json.data == null) json.data = {};
            var _data = json.data;
            // make sure newly created elements have valid ids
            if (_data.id == null) _data.id = $e815fda779bc047b$var$uuid();
            else if (cy.hasElementWithId(_data.id) || elesIds.has(_data.id)) continue; // can't create element if prior id already exists
            var ele = new $e815fda779bc047b$var$Element(cy, json, false);
            eles.push(ele);
            elesIds.add(_data.id);
        }
        elements = eles;
    }
    this.length = 0;
    for(var _i = 0, _l = elements.length; _i < _l; _i++){
        var element$1 = elements[_i][0]; // [0] in case elements is an array of collections, rather than array of elements
        if (element$1 == null) continue;
        var id = element$1._private.data.id;
        if (!unique || !map.has(id)) {
            if (unique) map.set(id, {
                index: this.length,
                ele: element$1
            });
            this[this.length] = element$1;
            this.length++;
        }
    }
    this._private = {
        eles: this,
        cy: cy,
        get map () {
            if (this.lazyMap == null) this.rebuildMap();
            return this.lazyMap;
        },
        set map (m){
            this.lazyMap = m;
        },
        rebuildMap: function rebuildMap() {
            var m1 = this.lazyMap = new $e815fda779bc047b$var$Map$1();
            var eles = this.eles;
            for(var _i2 = 0; _i2 < eles.length; _i2++){
                var _ele = eles[_i2];
                m1.set(_ele.id(), {
                    index: _i2,
                    ele: _ele
                });
            }
        }
    };
    if (unique) this._private.map = map;
    // restore the elements if we created them from json
    if (createdElements && !removed) this.restore();
};
// Functions
////////////////////////////////////////////////////////////////////////////////////////////////////
// keep the prototypes in sync (an element has the same functions as a collection)
// and use elefn and elesfn as shorthands to the prototypes
var $e815fda779bc047b$var$elesfn$1 = $e815fda779bc047b$var$Element.prototype = $e815fda779bc047b$var$Collection.prototype = Object.create(Array.prototype);
$e815fda779bc047b$var$elesfn$1.instanceString = function() {
    return 'collection';
};
$e815fda779bc047b$var$elesfn$1.spawn = function(eles, unique) {
    return new $e815fda779bc047b$var$Collection(this.cy(), eles, unique);
};
$e815fda779bc047b$var$elesfn$1.spawnSelf = function() {
    return this.spawn(this);
};
$e815fda779bc047b$var$elesfn$1.cy = function() {
    return this._private.cy;
};
$e815fda779bc047b$var$elesfn$1.renderer = function() {
    return this._private.cy.renderer();
};
$e815fda779bc047b$var$elesfn$1.element = function() {
    return this[0];
};
$e815fda779bc047b$var$elesfn$1.collection = function() {
    if ($e815fda779bc047b$var$collection(this)) return this;
    else // an element
    return new $e815fda779bc047b$var$Collection(this._private.cy, [
        this
    ]);
};
$e815fda779bc047b$var$elesfn$1.unique = function() {
    return new $e815fda779bc047b$var$Collection(this._private.cy, this, true);
};
$e815fda779bc047b$var$elesfn$1.hasElementWithId = function(id) {
    id = '' + id; // id must be string
    return this._private.map.has(id);
};
$e815fda779bc047b$var$elesfn$1.getElementById = function(id) {
    id = '' + id; // id must be string
    var cy = this._private.cy;
    var entry = this._private.map.get(id);
    return entry ? entry.ele : new $e815fda779bc047b$var$Collection(cy); // get ele or empty collection
};
$e815fda779bc047b$var$elesfn$1.$id = $e815fda779bc047b$var$elesfn$1.getElementById;
$e815fda779bc047b$var$elesfn$1.poolIndex = function() {
    var cy = this._private.cy;
    var eles = cy._private.elements;
    var id = this[0]._private.data.id;
    return eles._private.map.get(id).index;
};
$e815fda779bc047b$var$elesfn$1.indexOf = function(ele) {
    var id = ele[0]._private.data.id;
    return this._private.map.get(id).index;
};
$e815fda779bc047b$var$elesfn$1.indexOfId = function(id) {
    id = '' + id; // id must be string
    return this._private.map.get(id).index;
};
$e815fda779bc047b$var$elesfn$1.json = function(obj) {
    var ele = this.element();
    var cy = this.cy();
    if (ele == null && obj) return this;
     // can't set to no eles
    if (ele == null) return undefined;
     // can't get from no eles
    var p = ele._private;
    if ($e815fda779bc047b$var$plainObject(obj)) {
        // set
        cy.startBatch();
        if (obj.data) {
            ele.data(obj.data);
            var _data2 = p.data;
            if (ele.isEdge()) {
                // source and target are immutable via data()
                var move = false;
                var spec = {};
                var src = obj.data.source;
                var tgt = obj.data.target;
                if (src != null && src != _data2.source) {
                    spec.source = '' + src; // id must be string
                    move = true;
                }
                if (tgt != null && tgt != _data2.target) {
                    spec.target = '' + tgt; // id must be string
                    move = true;
                }
                if (move) ele = ele.move(spec);
            } else {
                // parent is immutable via data()
                var newParentValSpecd = 'parent' in obj.data;
                var parent = obj.data.parent;
                if (newParentValSpecd && (parent != null || _data2.parent != null) && parent != _data2.parent) {
                    if (parent === undefined) // can't set undefined imperatively, so use null
                    parent = null;
                    if (parent != null) parent = '' + parent; // id must be string
                    ele = ele.move({
                        parent: parent
                    });
                }
            }
        }
        if (obj.position) ele.position(obj.position);
        // ignore group -- immutable
        var checkSwitch = function checkSwitch(k, trueFnName, falseFnName) {
            var obj_k = obj[k];
            if (obj_k != null && obj_k !== p[k]) {
                if (obj_k) ele[trueFnName]();
                else ele[falseFnName]();
            }
        };
        checkSwitch('removed', 'remove', 'restore');
        checkSwitch('selected', 'select', 'unselect');
        checkSwitch('selectable', 'selectify', 'unselectify');
        checkSwitch('locked', 'lock', 'unlock');
        checkSwitch('grabbable', 'grabify', 'ungrabify');
        checkSwitch('pannable', 'panify', 'unpanify');
        if (obj.classes != null) ele.classes(obj.classes);
        cy.endBatch();
        return this;
    } else if (obj === undefined) {
        // get
        var json = {
            data: $e815fda779bc047b$var$copy(p.data),
            position: $e815fda779bc047b$var$copy(p.position),
            group: p.group,
            removed: p.removed,
            selected: p.selected,
            selectable: p.selectable,
            locked: p.locked,
            grabbable: p.grabbable,
            pannable: p.pannable,
            classes: null
        };
        json.classes = '';
        var i = 0;
        p.classes.forEach(function(cls) {
            return json.classes += i++ === 0 ? cls : ' ' + cls;
        });
        return json;
    }
};
$e815fda779bc047b$var$elesfn$1.jsons = function() {
    var jsons = [];
    for(var i = 0; i < this.length; i++){
        var ele = this[i];
        var json = ele.json();
        jsons.push(json);
    }
    return jsons;
};
$e815fda779bc047b$var$elesfn$1.clone = function() {
    var cy = this.cy();
    var elesArr = [];
    for(var i = 0; i < this.length; i++){
        var ele = this[i];
        var json = ele.json();
        var clone = new $e815fda779bc047b$var$Element(cy, json, false); // NB no restore
        elesArr.push(clone);
    }
    return new $e815fda779bc047b$var$Collection(cy, elesArr);
};
$e815fda779bc047b$var$elesfn$1.copy = $e815fda779bc047b$var$elesfn$1.clone;
$e815fda779bc047b$var$elesfn$1.restore = function() {
    var notifyRenderer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    var addToPool = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var self1 = this;
    var cy = self1.cy();
    var cy_p = cy._private;
    // create arrays of nodes and edges, since we need to
    // restore the nodes first
    var nodes = [];
    var edges = [];
    var elements;
    for(var _i3 = 0, l = self1.length; _i3 < l; _i3++){
        var ele = self1[_i3];
        if (addToPool && !ele.removed()) continue;
        // keep nodes first in the array and edges after
        if (ele.isNode()) // put to front of array if node
        nodes.push(ele);
        else // put to end of array if edge
        edges.push(ele);
    }
    elements = nodes.concat(edges);
    var i;
    var removeFromElements = function removeFromElements() {
        elements.splice(i, 1);
        i--;
    };
    // now, restore each element
    for(i = 0; i < elements.length; i++){
        var _ele2 = elements[i];
        var _private = _ele2._private;
        var _data3 = _private.data;
        // the traversal cache should start fresh when ele is added
        _ele2.clearTraversalCache();
        // set id and validate
        if (!addToPool && !_private.removed) ;
        else if (_data3.id === undefined) _data3.id = $e815fda779bc047b$var$uuid();
        else if ($e815fda779bc047b$var$number$1(_data3.id)) _data3.id = '' + _data3.id; // now it's a string
        else if ($e815fda779bc047b$var$emptyString(_data3.id) || !$e815fda779bc047b$var$string(_data3.id)) {
            $e815fda779bc047b$var$error('Can not create element with invalid string ID `' + _data3.id + '`');
            // can't create element if it has empty string as id or non-string id
            removeFromElements();
            continue;
        } else if (cy.hasElementWithId(_data3.id)) {
            $e815fda779bc047b$var$error('Can not create second element with ID `' + _data3.id + '`');
            // can't create element if one already has that id
            removeFromElements();
            continue;
        }
        var id = _data3.id; // id is finalised, now let's keep a ref
        if (_ele2.isNode()) {
            // extra checks for nodes
            var pos = _private.position;
            // make sure the nodes have a defined position
            if (pos.x == null) pos.x = 0;
            if (pos.y == null) pos.y = 0;
        }
        if (_ele2.isEdge()) {
            // extra checks for edges
            var edge = _ele2;
            var fields = [
                'source',
                'target'
            ];
            var fieldsLength = fields.length;
            var badSourceOrTarget = false;
            for(var j = 0; j < fieldsLength; j++){
                var field = fields[j];
                var val = _data3[field];
                if ($e815fda779bc047b$var$number$1(val)) val = _data3[field] = '' + _data3[field]; // now string
                if (val == null || val === '') {
                    // can't create if source or target is not defined properly
                    $e815fda779bc047b$var$error('Can not create edge `' + id + '` with unspecified ' + field);
                    badSourceOrTarget = true;
                } else if (!cy.hasElementWithId(val)) {
                    // can't create edge if one of its nodes doesn't exist
                    $e815fda779bc047b$var$error('Can not create edge `' + id + '` with nonexistant ' + field + ' `' + val + '`');
                    badSourceOrTarget = true;
                }
            }
            if (badSourceOrTarget) {
                removeFromElements();
                continue;
            } // can't create this
            var src = cy.getElementById(_data3.source);
            var tgt = cy.getElementById(_data3.target);
            // only one edge in node if loop
            if (src.same(tgt)) src._private.edges.push(edge);
            else {
                src._private.edges.push(edge);
                tgt._private.edges.push(edge);
            }
            edge._private.source = src;
            edge._private.target = tgt;
        } // if is edge
        // create mock ids / indexes maps for element so it can be used like collections
        _private.map = new $e815fda779bc047b$var$Map$1();
        _private.map.set(id, {
            ele: _ele2,
            index: 0
        });
        _private.removed = false;
        if (addToPool) cy.addToPool(_ele2);
    } // for each element
    // do compound node sanity checks
    for(var _i4 = 0; _i4 < nodes.length; _i4++){
        // each node
        var node = nodes[_i4];
        var _data4 = node._private.data;
        if ($e815fda779bc047b$var$number$1(_data4.parent)) // then automake string
        _data4.parent = '' + _data4.parent;
        var parentId = _data4.parent;
        var specifiedParent = parentId != null;
        if (specifiedParent || node._private.parent) {
            var parent = node._private.parent ? cy.collection().merge(node._private.parent) : cy.getElementById(parentId);
            if (parent.empty()) // non-existant parent; just remove it
            _data4.parent = undefined;
            else if (parent[0].removed()) {
                $e815fda779bc047b$var$warn('Node added with missing parent, reference to parent removed');
                _data4.parent = undefined;
                node._private.parent = null;
            } else {
                var selfAsParent = false;
                var ancestor = parent;
                while(!ancestor.empty()){
                    if (node.same(ancestor)) {
                        // mark self as parent and remove from data
                        selfAsParent = true;
                        _data4.parent = undefined; // remove parent reference
                        break;
                    }
                    ancestor = ancestor.parent();
                }
                if (!selfAsParent) {
                    // connect with children
                    parent[0]._private.children.push(node);
                    node._private.parent = parent[0];
                    // let the core know we have a compound graph
                    cy_p.hasCompoundNodes = true;
                }
            } // else
        } // if specified parent
    } // for each node
    if (elements.length > 0) {
        var restored = elements.length === self1.length ? self1 : new $e815fda779bc047b$var$Collection(cy, elements);
        for(var _i5 = 0; _i5 < restored.length; _i5++){
            var _ele3 = restored[_i5];
            if (_ele3.isNode()) continue;
            // adding an edge invalidates the traversal caches for the parallel edges
            _ele3.parallelEdges().clearTraversalCache();
            // adding an edge invalidates the traversal cache for the connected nodes
            _ele3.source().clearTraversalCache();
            _ele3.target().clearTraversalCache();
        }
        var toUpdateStyle;
        if (cy_p.hasCompoundNodes) toUpdateStyle = cy.collection().merge(restored).merge(restored.connectedNodes()).merge(restored.parent());
        else toUpdateStyle = restored;
        toUpdateStyle.dirtyCompoundBoundsCache().dirtyBoundingBoxCache().updateStyle(notifyRenderer);
        if (notifyRenderer) restored.emitAndNotify('add');
        else if (addToPool) restored.emit('add');
    }
    return self1; // chainability
};
$e815fda779bc047b$var$elesfn$1.removed = function() {
    var ele = this[0];
    return ele && ele._private.removed;
};
$e815fda779bc047b$var$elesfn$1.inside = function() {
    var ele = this[0];
    return ele && !ele._private.removed;
};
$e815fda779bc047b$var$elesfn$1.remove = function() {
    var notifyRenderer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    var removeFromPool = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var self1 = this;
    var elesToRemove = [];
    var elesToRemoveIds = {};
    var cy = self1._private.cy;
    // add connected edges
    function addConnectedEdges(node) {
        var edges = node._private.edges;
        for(var i = 0; i < edges.length; i++)add(edges[i]);
    }
    // add descendant nodes
    function addChildren(node) {
        var children = node._private.children;
        for(var i = 0; i < children.length; i++)add(children[i]);
    }
    function add(ele) {
        var alreadyAdded = elesToRemoveIds[ele.id()];
        if (removeFromPool && ele.removed() || alreadyAdded) return;
        else elesToRemoveIds[ele.id()] = true;
        if (ele.isNode()) {
            elesToRemove.push(ele); // nodes are removed last
            addConnectedEdges(ele);
            addChildren(ele);
        } else elesToRemove.unshift(ele); // edges are removed first
    }
    // make the list of elements to remove
    // (may be removing more than specified due to connected edges etc)
    for(var i = 0, l = self1.length; i < l; i++){
        var ele = self1[i];
        add(ele);
    }
    function removeEdgeRef(node, edge) {
        var connectedEdges = node._private.edges;
        $e815fda779bc047b$var$removeFromArray(connectedEdges, edge);
        // removing an edges invalidates the traversal cache for its nodes
        node.clearTraversalCache();
    }
    function removeParallelRef(pllEdge) {
        // removing an edge invalidates the traversal caches for the parallel edges
        pllEdge.clearTraversalCache();
    }
    var alteredParents = [];
    alteredParents.ids = {};
    function removeChildRef(parent, ele) {
        ele = ele[0];
        parent = parent[0];
        var children = parent._private.children;
        var pid = parent.id();
        $e815fda779bc047b$var$removeFromArray(children, ele); // remove parent => child ref
        ele._private.parent = null; // remove child => parent ref
        if (!alteredParents.ids[pid]) {
            alteredParents.ids[pid] = true;
            alteredParents.push(parent);
        }
    }
    self1.dirtyCompoundBoundsCache();
    if (removeFromPool) cy.removeFromPool(elesToRemove); // remove from core pool
    for(var _i6 = 0; _i6 < elesToRemove.length; _i6++){
        var _ele4 = elesToRemove[_i6];
        if (_ele4.isEdge()) {
            // remove references to this edge in its connected nodes
            var src = _ele4.source()[0];
            var tgt = _ele4.target()[0];
            removeEdgeRef(src, _ele4);
            removeEdgeRef(tgt, _ele4);
            var pllEdges = _ele4.parallelEdges();
            for(var j = 0; j < pllEdges.length; j++){
                var pllEdge = pllEdges[j];
                removeParallelRef(pllEdge);
                if (pllEdge.isBundledBezier()) pllEdge.dirtyBoundingBoxCache();
            }
        } else {
            // remove reference to parent
            var parent = _ele4.parent();
            if (parent.length !== 0) removeChildRef(parent, _ele4);
        }
        if (removeFromPool) // mark as removed
        _ele4._private.removed = true;
    }
    // check to see if we have a compound graph or not
    var elesStillInside = cy._private.elements;
    cy._private.hasCompoundNodes = false;
    for(var _i7 = 0; _i7 < elesStillInside.length; _i7++){
        var _ele5 = elesStillInside[_i7];
        if (_ele5.isParent()) {
            cy._private.hasCompoundNodes = true;
            break;
        }
    }
    var removedElements = new $e815fda779bc047b$var$Collection(this.cy(), elesToRemove);
    if (removedElements.size() > 0) {
        // must manually notify since trigger won't do this automatically once removed
        if (notifyRenderer) removedElements.emitAndNotify('remove');
        else if (removeFromPool) removedElements.emit('remove');
    }
    // the parents who were modified by the removal need their style updated
    for(var _i8 = 0; _i8 < alteredParents.length; _i8++){
        var _ele6 = alteredParents[_i8];
        if (!removeFromPool || !_ele6.removed()) _ele6.updateStyle();
    }
    return removedElements;
};
$e815fda779bc047b$var$elesfn$1.move = function(struct) {
    var cy = this._private.cy;
    var eles = this;
    // just clean up refs, caches, etc. in the same way as when removing and then restoring
    // (our calls to remove/restore do not remove from the graph or make events)
    var notifyRenderer = false;
    var modifyPool = false;
    var toString = function toString(id) {
        return id == null ? id : '' + id;
    }; // id must be string
    if (struct.source !== undefined || struct.target !== undefined) {
        var srcId = toString(struct.source);
        var tgtId = toString(struct.target);
        var srcExists = srcId != null && cy.hasElementWithId(srcId);
        var tgtExists = tgtId != null && cy.hasElementWithId(tgtId);
        if (srcExists || tgtExists) {
            cy.batch(function() {
                // avoid duplicate style updates
                eles.remove(notifyRenderer, modifyPool); // clean up refs etc.
                eles.emitAndNotify('moveout');
                for(var i = 0; i < eles.length; i++){
                    var ele = eles[i];
                    var _data5 = ele._private.data;
                    if (ele.isEdge()) {
                        if (srcExists) _data5.source = srcId;
                        if (tgtExists) _data5.target = tgtId;
                    }
                }
                eles.restore(notifyRenderer, modifyPool); // make new refs, style, etc.
            });
            eles.emitAndNotify('move');
        }
    } else if (struct.parent !== undefined) {
        // move node to new parent
        var parentId = toString(struct.parent);
        var parentExists = parentId === null || cy.hasElementWithId(parentId);
        if (parentExists) {
            var pidToAssign = parentId === null ? undefined : parentId;
            cy.batch(function() {
                // avoid duplicate style updates
                var updated = eles.remove(notifyRenderer, modifyPool); // clean up refs etc.
                updated.emitAndNotify('moveout');
                for(var i = 0; i < eles.length; i++){
                    var ele = eles[i];
                    var _data6 = ele._private.data;
                    if (ele.isNode()) _data6.parent = pidToAssign;
                }
                updated.restore(notifyRenderer, modifyPool); // make new refs, style, etc.
            });
            eles.emitAndNotify('move');
        }
    }
    return this;
};
[
    $e815fda779bc047b$var$elesfn$j,
    $e815fda779bc047b$var$elesfn$i,
    $e815fda779bc047b$var$elesfn$h,
    $e815fda779bc047b$var$elesfn$g,
    $e815fda779bc047b$var$elesfn$f,
    $e815fda779bc047b$var$data,
    $e815fda779bc047b$var$elesfn$d,
    $e815fda779bc047b$var$dimensions,
    $e815fda779bc047b$var$elesfn$9,
    $e815fda779bc047b$var$elesfn$8,
    $e815fda779bc047b$var$elesfn$7,
    $e815fda779bc047b$var$elesfn$6,
    $e815fda779bc047b$var$elesfn$5,
    $e815fda779bc047b$var$elesfn$4,
    $e815fda779bc047b$var$elesfn$3,
    $e815fda779bc047b$var$elesfn$2
].forEach(function(props) {
    $e815fda779bc047b$var$extend($e815fda779bc047b$var$elesfn$1, props);
});
var $e815fda779bc047b$var$corefn$9 = {
    add: function add(opts) {
        var elements;
        var cy = this;
        // add the elements
        if ($e815fda779bc047b$var$elementOrCollection(opts)) {
            var eles = opts;
            if (eles._private.cy === cy) // same instance => just restore
            elements = eles.restore();
            else {
                // otherwise, copy from json
                var jsons = [];
                for(var i = 0; i < eles.length; i++){
                    var ele = eles[i];
                    jsons.push(ele.json());
                }
                elements = new $e815fda779bc047b$var$Collection(cy, jsons);
            }
        } else if ($e815fda779bc047b$var$array(opts)) {
            var _jsons = opts;
            elements = new $e815fda779bc047b$var$Collection(cy, _jsons);
        } else if ($e815fda779bc047b$var$plainObject(opts) && ($e815fda779bc047b$var$array(opts.nodes) || $e815fda779bc047b$var$array(opts.edges))) {
            var elesByGroup = opts;
            var _jsons2 = [];
            var grs = [
                'nodes',
                'edges'
            ];
            for(var _i = 0, il = grs.length; _i < il; _i++){
                var group = grs[_i];
                var elesArray = elesByGroup[group];
                if ($e815fda779bc047b$var$array(elesArray)) for(var j = 0, jl = elesArray.length; j < jl; j++){
                    var json = $e815fda779bc047b$var$extend({
                        group: group
                    }, elesArray[j]);
                    _jsons2.push(json);
                }
            }
            elements = new $e815fda779bc047b$var$Collection(cy, _jsons2);
        } else {
            var _json = opts;
            elements = new $e815fda779bc047b$var$Element(cy, _json).collection();
        }
        return elements;
    },
    remove: function remove(collection) {
        if ($e815fda779bc047b$var$elementOrCollection(collection)) ;
        else if ($e815fda779bc047b$var$string(collection)) {
            var selector = collection;
            collection = this.$(selector);
        }
        return collection.remove();
    }
};
/* global Float32Array */ /*! Bezier curve function generator. Copyright Gaetan Renaudeau. MIT License: http://en.wikipedia.org/wiki/MIT_License */ function $e815fda779bc047b$var$generateCubicBezier(mX1, mY1, mX2, mY2) {
    var NEWTON_ITERATIONS = 4, NEWTON_MIN_SLOPE = 0.001, SUBDIVISION_PRECISION = 0.0000001, SUBDIVISION_MAX_ITERATIONS = 10, kSplineTableSize = 11, kSampleStepSize = 1.0 / (kSplineTableSize - 1.0), float32ArraySupported = typeof Float32Array !== 'undefined';
    /* Must contain four arguments. */ if (arguments.length !== 4) return false;
    /* Arguments must be numbers. */ for(var i = 0; i < 4; ++i){
        if (typeof arguments[i] !== "number" || isNaN(arguments[i]) || !isFinite(arguments[i])) return false;
    }
    /* X values must be in the [0, 1] range. */ mX1 = Math.min(mX1, 1);
    mX2 = Math.min(mX2, 1);
    mX1 = Math.max(mX1, 0);
    mX2 = Math.max(mX2, 0);
    var mSampleValues = float32ArraySupported ? new Float32Array(kSplineTableSize) : new Array(kSplineTableSize);
    function A(aA1, aA2) {
        return 1.0 - 3.0 * aA2 + 3.0 * aA1;
    }
    function B(aA1, aA2) {
        return 3.0 * aA2 - 6.0 * aA1;
    }
    function C(aA1) {
        return 3.0 * aA1;
    }
    function calcBezier(aT, aA1, aA2) {
        return ((A(aA1, aA2) * aT + B(aA1, aA2)) * aT + C(aA1)) * aT;
    }
    function getSlope(aT, aA1, aA2) {
        return 3.0 * A(aA1, aA2) * aT * aT + 2.0 * B(aA1, aA2) * aT + C(aA1);
    }
    function newtonRaphsonIterate(aX, aGuessT) {
        for(var _i = 0; _i < NEWTON_ITERATIONS; ++_i){
            var currentSlope = getSlope(aGuessT, mX1, mX2);
            if (currentSlope === 0.0) return aGuessT;
            var currentX = calcBezier(aGuessT, mX1, mX2) - aX;
            aGuessT -= currentX / currentSlope;
        }
        return aGuessT;
    }
    function calcSampleValues() {
        for(var _i2 = 0; _i2 < kSplineTableSize; ++_i2)mSampleValues[_i2] = calcBezier(_i2 * kSampleStepSize, mX1, mX2);
    }
    function binarySubdivide(aX, aA, aB) {
        var currentX, currentT, i = 0;
        do {
            currentT = aA + (aB - aA) / 2.0;
            currentX = calcBezier(currentT, mX1, mX2) - aX;
            if (currentX > 0.0) aB = currentT;
            else aA = currentT;
        }while (Math.abs(currentX) > SUBDIVISION_PRECISION && ++i < SUBDIVISION_MAX_ITERATIONS);
        return currentT;
    }
    function getTForX(aX) {
        var intervalStart = 0.0, currentSample = 1, lastSample = kSplineTableSize - 1;
        for(; currentSample !== lastSample && mSampleValues[currentSample] <= aX; ++currentSample)intervalStart += kSampleStepSize;
        --currentSample;
        var dist = (aX - mSampleValues[currentSample]) / (mSampleValues[currentSample + 1] - mSampleValues[currentSample]), guessForT = intervalStart + dist * kSampleStepSize, initialSlope = getSlope(guessForT, mX1, mX2);
        if (initialSlope >= NEWTON_MIN_SLOPE) return newtonRaphsonIterate(aX, guessForT);
        else if (initialSlope === 0.0) return guessForT;
        else return binarySubdivide(aX, intervalStart, intervalStart + kSampleStepSize);
    }
    var _precomputed = false;
    function precompute() {
        _precomputed = true;
        if (mX1 !== mY1 || mX2 !== mY2) calcSampleValues();
    }
    var f = function f(aX) {
        if (!_precomputed) precompute();
        if (mX1 === mY1 && mX2 === mY2) return aX;
        if (aX === 0) return 0;
        if (aX === 1) return 1;
        return calcBezier(getTForX(aX), mY1, mY2);
    };
    f.getControlPoints = function() {
        return [
            {
                x: mX1,
                y: mY1
            },
            {
                x: mX2,
                y: mY2
            }
        ];
    };
    var str = "generateBezier(" + [
        mX1,
        mY1,
        mX2,
        mY2
    ] + ")";
    f.toString = function() {
        return str;
    };
    return f;
}
/*! Runge-Kutta spring physics function generator. Adapted from Framer.js, copyright Koen Bok. MIT License: http://en.wikipedia.org/wiki/MIT_License */ /* Given a tension, friction, and duration, a simulation at 60FPS will first run without a defined duration in order to calculate the full path. A second pass
   then adjusts the time delta -- using the relation between actual time and duration -- to calculate the path for the duration-constrained animation. */ var $e815fda779bc047b$var$generateSpringRK4 = function() {
    function springAccelerationForState(state) {
        return -state.tension * state.x - state.friction * state.v;
    }
    function springEvaluateStateWithDerivative(initialState, dt, derivative) {
        var state = {
            x: initialState.x + derivative.dx * dt,
            v: initialState.v + derivative.dv * dt,
            tension: initialState.tension,
            friction: initialState.friction
        };
        return {
            dx: state.v,
            dv: springAccelerationForState(state)
        };
    }
    function springIntegrateState(state, dt) {
        var a = {
            dx: state.v,
            dv: springAccelerationForState(state)
        }, b = springEvaluateStateWithDerivative(state, dt * 0.5, a), c = springEvaluateStateWithDerivative(state, dt * 0.5, b), d = springEvaluateStateWithDerivative(state, dt, c), dxdt = 1.0 / 6.0 * (a.dx + 2.0 * (b.dx + c.dx) + d.dx), dvdt = 1.0 / 6.0 * (a.dv + 2.0 * (b.dv + c.dv) + d.dv);
        state.x = state.x + dxdt * dt;
        state.v = state.v + dvdt * dt;
        return state;
    }
    return function springRK4Factory(tension, friction, duration) {
        var initState = {
            x: -1,
            v: 0,
            tension: null,
            friction: null
        }, path = [
            0
        ], time_lapsed = 0, tolerance = 0.0001, DT = 0.016, have_duration, dt, last_state;
        tension = parseFloat(tension) || 500;
        friction = parseFloat(friction) || 20;
        duration = duration || null;
        initState.tension = tension;
        initState.friction = friction;
        have_duration = duration !== null;
        /* Calculate the actual time it takes for this animation to complete with the provided conditions. */ if (have_duration) {
            /* Run the simulation without a duration. */ time_lapsed = springRK4Factory(tension, friction);
            /* Compute the adjusted time delta. */ dt = time_lapsed / duration * DT;
        } else dt = DT;
        for(;;){
            /* Next/step function .*/ last_state = springIntegrateState(last_state || initState, dt);
            /* Store the position. */ path.push(1 + last_state.x);
            time_lapsed += 16;
            /* If the change threshold is reached, break. */ if (!(Math.abs(last_state.x) > tolerance && Math.abs(last_state.v) > tolerance)) break;
        }
        /* If duration is not defined, return the actual time required for completing this animation. Otherwise, return a closure that holds the
       computed path and returns a snapshot of the position according to a given percentComplete. */ return !have_duration ? time_lapsed : function(percentComplete) {
            return path[percentComplete * (path.length - 1) | 0];
        };
    };
}();
var $e815fda779bc047b$var$cubicBezier = function cubicBezier(t1, p1, t2, p2) {
    var bezier = $e815fda779bc047b$var$generateCubicBezier(t1, p1, t2, p2);
    return function(start, end, percent) {
        return start + (end - start) * bezier(percent);
    };
};
var $e815fda779bc047b$var$easings = {
    'linear': function linear(start, end, percent) {
        return start + (end - start) * percent;
    },
    // default easings
    'ease': $e815fda779bc047b$var$cubicBezier(0.25, 0.1, 0.25, 1),
    'ease-in': $e815fda779bc047b$var$cubicBezier(0.42, 0, 1, 1),
    'ease-out': $e815fda779bc047b$var$cubicBezier(0, 0, 0.58, 1),
    'ease-in-out': $e815fda779bc047b$var$cubicBezier(0.42, 0, 0.58, 1),
    // sine
    'ease-in-sine': $e815fda779bc047b$var$cubicBezier(0.47, 0, 0.745, 0.715),
    'ease-out-sine': $e815fda779bc047b$var$cubicBezier(0.39, 0.575, 0.565, 1),
    'ease-in-out-sine': $e815fda779bc047b$var$cubicBezier(0.445, 0.05, 0.55, 0.95),
    // quad
    'ease-in-quad': $e815fda779bc047b$var$cubicBezier(0.55, 0.085, 0.68, 0.53),
    'ease-out-quad': $e815fda779bc047b$var$cubicBezier(0.25, 0.46, 0.45, 0.94),
    'ease-in-out-quad': $e815fda779bc047b$var$cubicBezier(0.455, 0.03, 0.515, 0.955),
    // cubic
    'ease-in-cubic': $e815fda779bc047b$var$cubicBezier(0.55, 0.055, 0.675, 0.19),
    'ease-out-cubic': $e815fda779bc047b$var$cubicBezier(0.215, 0.61, 0.355, 1),
    'ease-in-out-cubic': $e815fda779bc047b$var$cubicBezier(0.645, 0.045, 0.355, 1),
    // quart
    'ease-in-quart': $e815fda779bc047b$var$cubicBezier(0.895, 0.03, 0.685, 0.22),
    'ease-out-quart': $e815fda779bc047b$var$cubicBezier(0.165, 0.84, 0.44, 1),
    'ease-in-out-quart': $e815fda779bc047b$var$cubicBezier(0.77, 0, 0.175, 1),
    // quint
    'ease-in-quint': $e815fda779bc047b$var$cubicBezier(0.755, 0.05, 0.855, 0.06),
    'ease-out-quint': $e815fda779bc047b$var$cubicBezier(0.23, 1, 0.32, 1),
    'ease-in-out-quint': $e815fda779bc047b$var$cubicBezier(0.86, 0, 0.07, 1),
    // expo
    'ease-in-expo': $e815fda779bc047b$var$cubicBezier(0.95, 0.05, 0.795, 0.035),
    'ease-out-expo': $e815fda779bc047b$var$cubicBezier(0.19, 1, 0.22, 1),
    'ease-in-out-expo': $e815fda779bc047b$var$cubicBezier(1, 0, 0, 1),
    // circ
    'ease-in-circ': $e815fda779bc047b$var$cubicBezier(0.6, 0.04, 0.98, 0.335),
    'ease-out-circ': $e815fda779bc047b$var$cubicBezier(0.075, 0.82, 0.165, 1),
    'ease-in-out-circ': $e815fda779bc047b$var$cubicBezier(0.785, 0.135, 0.15, 0.86),
    // user param easings...
    'spring': function spring(tension, friction, duration) {
        if (duration === 0) // can't get a spring w/ duration 0
        return $e815fda779bc047b$var$easings.linear; // duration 0 => jump to end so impl doesn't matter
        var spring = $e815fda779bc047b$var$generateSpringRK4(tension, friction, duration);
        return function(start, end, percent) {
            return start + (end - start) * spring(percent);
        };
    },
    'cubic-bezier': $e815fda779bc047b$var$cubicBezier
};
function $e815fda779bc047b$var$getEasedValue(type, start, end, percent, easingFn) {
    if (percent === 1) return end;
    if (start === end) return end;
    var val = easingFn(start, end, percent);
    if (type == null) return val;
    if (type.roundValue || type.color) val = Math.round(val);
    if (type.min !== undefined) val = Math.max(val, type.min);
    if (type.max !== undefined) val = Math.min(val, type.max);
    return val;
}
function $e815fda779bc047b$var$getValue(prop, spec) {
    if (prop.pfValue != null || prop.value != null) {
        if (prop.pfValue != null && (spec == null || spec.type.units !== '%')) return prop.pfValue;
        else return prop.value;
    } else return prop;
}
function $e815fda779bc047b$var$ease(startProp, endProp, percent, easingFn, propSpec) {
    var type = propSpec != null ? propSpec.type : null;
    if (percent < 0) percent = 0;
    else if (percent > 1) percent = 1;
    var start = $e815fda779bc047b$var$getValue(startProp, propSpec);
    var end = $e815fda779bc047b$var$getValue(endProp, propSpec);
    if ($e815fda779bc047b$var$number$1(start) && $e815fda779bc047b$var$number$1(end)) return $e815fda779bc047b$var$getEasedValue(type, start, end, percent, easingFn);
    else if ($e815fda779bc047b$var$array(start) && $e815fda779bc047b$var$array(end)) {
        var easedArr = [];
        for(var i = 0; i < end.length; i++){
            var si = start[i];
            var ei = end[i];
            if (si != null && ei != null) {
                var val = $e815fda779bc047b$var$getEasedValue(type, si, ei, percent, easingFn);
                easedArr.push(val);
            } else easedArr.push(ei);
        }
        return easedArr;
    }
    return undefined;
}
function $e815fda779bc047b$var$step$1(self1, ani, now, isCore) {
    var isEles = !isCore;
    var _p = self1._private;
    var ani_p = ani._private;
    var pEasing = ani_p.easing;
    var startTime = ani_p.startTime;
    var cy = isCore ? self1 : self1.cy();
    var style = cy.style();
    if (!ani_p.easingImpl) {
        if (pEasing == null) // use default
        ani_p.easingImpl = $e815fda779bc047b$var$easings['linear'];
        else {
            // then define w/ name
            var easingVals;
            if ($e815fda779bc047b$var$string(pEasing)) {
                var easingProp = style.parse('transition-timing-function', pEasing);
                easingVals = easingProp.value;
            } else // then assume preparsed array
            easingVals = pEasing;
            var name, args;
            if ($e815fda779bc047b$var$string(easingVals)) {
                name = easingVals;
                args = [];
            } else {
                name = easingVals[1];
                args = easingVals.slice(2).map(function(n) {
                    return +n;
                });
            }
            if (args.length > 0) {
                // create with args
                if (name === 'spring') args.push(ani_p.duration); // need duration to generate spring
                ani_p.easingImpl = $e815fda779bc047b$var$easings[name].apply(null, args);
            } else // static impl by name
            ani_p.easingImpl = $e815fda779bc047b$var$easings[name];
        }
    }
    var easing = ani_p.easingImpl;
    var percent;
    if (ani_p.duration === 0) percent = 1;
    else percent = (now - startTime) / ani_p.duration;
    if (ani_p.applying) percent = ani_p.progress;
    if (percent < 0) percent = 0;
    else if (percent > 1) percent = 1;
    if (ani_p.delay == null) {
        // then update
        var startPos = ani_p.startPosition;
        var endPos = ani_p.position;
        if (endPos && isEles && !self1.locked()) {
            var newPos = {};
            if ($e815fda779bc047b$var$valid(startPos.x, endPos.x)) newPos.x = $e815fda779bc047b$var$ease(startPos.x, endPos.x, percent, easing);
            if ($e815fda779bc047b$var$valid(startPos.y, endPos.y)) newPos.y = $e815fda779bc047b$var$ease(startPos.y, endPos.y, percent, easing);
            self1.position(newPos);
        }
        var startPan = ani_p.startPan;
        var endPan = ani_p.pan;
        var pan = _p.pan;
        var animatingPan = endPan != null && isCore;
        if (animatingPan) {
            if ($e815fda779bc047b$var$valid(startPan.x, endPan.x)) pan.x = $e815fda779bc047b$var$ease(startPan.x, endPan.x, percent, easing);
            if ($e815fda779bc047b$var$valid(startPan.y, endPan.y)) pan.y = $e815fda779bc047b$var$ease(startPan.y, endPan.y, percent, easing);
            self1.emit('pan');
        }
        var startZoom = ani_p.startZoom;
        var endZoom = ani_p.zoom;
        var animatingZoom = endZoom != null && isCore;
        if (animatingZoom) {
            if ($e815fda779bc047b$var$valid(startZoom, endZoom)) _p.zoom = $e815fda779bc047b$var$bound(_p.minZoom, $e815fda779bc047b$var$ease(startZoom, endZoom, percent, easing), _p.maxZoom);
            self1.emit('zoom');
        }
        if (animatingPan || animatingZoom) self1.emit('viewport');
        var props = ani_p.style;
        if (props && props.length > 0 && isEles) {
            for(var i = 0; i < props.length; i++){
                var prop = props[i];
                var _name = prop.name;
                var end = prop;
                var start = ani_p.startStyle[_name];
                var propSpec = style.properties[start.name];
                var easedVal = $e815fda779bc047b$var$ease(start, end, percent, easing, propSpec);
                style.overrideBypass(self1, _name, easedVal);
            } // for props
            self1.emit('style');
        } // if
    }
    ani_p.progress = percent;
    return percent;
}
function $e815fda779bc047b$var$valid(start, end) {
    if (start == null || end == null) return false;
    if ($e815fda779bc047b$var$number$1(start) && $e815fda779bc047b$var$number$1(end)) return true;
    else if (start && end) return true;
    return false;
}
function $e815fda779bc047b$var$startAnimation(self1, ani, now, isCore) {
    var ani_p = ani._private;
    ani_p.started = true;
    ani_p.startTime = now - ani_p.progress * ani_p.duration;
}
function $e815fda779bc047b$var$stepAll(now, cy) {
    var eles = cy._private.aniEles;
    var doneEles = [];
    function stepOne(ele, isCore) {
        var _p = ele._private;
        var current = _p.animation.current;
        var queue = _p.animation.queue;
        var ranAnis = false;
        // if nothing currently animating, get something from the queue
        if (current.length === 0) {
            var next = queue.shift();
            if (next) current.push(next);
        }
        var callbacks = function callbacks(_callbacks) {
            for(var j = _callbacks.length - 1; j >= 0; j--){
                var cb = _callbacks[j];
                cb();
            }
            _callbacks.splice(0, _callbacks.length);
        };
        // step and remove if done
        for(var i = current.length - 1; i >= 0; i--){
            var ani = current[i];
            var ani_p = ani._private;
            if (ani_p.stopped) {
                current.splice(i, 1);
                ani_p.hooked = false;
                ani_p.playing = false;
                ani_p.started = false;
                callbacks(ani_p.frames);
                continue;
            }
            if (!ani_p.playing && !ani_p.applying) continue;
            // an apply() while playing shouldn't do anything
            if (ani_p.playing && ani_p.applying) ani_p.applying = false;
            if (!ani_p.started) $e815fda779bc047b$var$startAnimation(ele, ani, now);
            $e815fda779bc047b$var$step$1(ele, ani, now, isCore);
            if (ani_p.applying) ani_p.applying = false;
            callbacks(ani_p.frames);
            if (ani_p.step != null) ani_p.step(now);
            if (ani.completed()) {
                current.splice(i, 1);
                ani_p.hooked = false;
                ani_p.playing = false;
                ani_p.started = false;
                callbacks(ani_p.completes);
            }
            ranAnis = true;
        }
        if (!isCore && current.length === 0 && queue.length === 0) doneEles.push(ele);
        return ranAnis;
    } // stepElement
    // handle all eles
    var ranEleAni = false;
    for(var e = 0; e < eles.length; e++){
        var ele = eles[e];
        var handledThisEle = stepOne(ele);
        ranEleAni = ranEleAni || handledThisEle;
    } // each element
    var ranCoreAni = stepOne(cy, true);
    // notify renderer
    if (ranEleAni || ranCoreAni) {
        if (eles.length > 0) cy.notify('draw', eles);
        else cy.notify('draw');
    }
    // remove elements from list of currently animating if its queues are empty
    eles.unmerge(doneEles);
    cy.emit('step');
} // stepAll
var $e815fda779bc047b$var$corefn$8 = {
    // pull in animation functions
    animate: $e815fda779bc047b$var$define.animate(),
    animation: $e815fda779bc047b$var$define.animation(),
    animated: $e815fda779bc047b$var$define.animated(),
    clearQueue: $e815fda779bc047b$var$define.clearQueue(),
    delay: $e815fda779bc047b$var$define.delay(),
    delayAnimation: $e815fda779bc047b$var$define.delayAnimation(),
    stop: $e815fda779bc047b$var$define.stop(),
    addToAnimationPool: function addToAnimationPool(eles) {
        var cy = this;
        if (!cy.styleEnabled()) return;
         // save cycles when no style used
        cy._private.aniEles.merge(eles);
    },
    stopAnimationLoop: function stopAnimationLoop() {
        this._private.animationsRunning = false;
    },
    startAnimationLoop: function startAnimationLoop() {
        var cy = this;
        cy._private.animationsRunning = true;
        if (!cy.styleEnabled()) return;
         // save cycles when no style used
        // NB the animation loop will exec in headless environments if style enabled
        // and explicit cy.destroy() is necessary to stop the loop
        function headlessStep() {
            if (!cy._private.animationsRunning) return;
            $e815fda779bc047b$var$requestAnimationFrame(function animationStep(now) {
                $e815fda779bc047b$var$stepAll(now, cy);
                headlessStep();
            });
        }
        var renderer = cy.renderer();
        if (renderer && renderer.beforeRender) // let the renderer schedule animations
        renderer.beforeRender(function rendererAnimationStep(willDraw, now) {
            $e815fda779bc047b$var$stepAll(now, cy);
        }, renderer.beforeRenderPriorities.animations);
        else // manage the animation loop ourselves
        headlessStep(); // first call
    }
};
var $e815fda779bc047b$var$emitterOptions = {
    qualifierCompare: function qualifierCompare(selector1, selector2) {
        if (selector1 == null || selector2 == null) return selector1 == null && selector2 == null;
        else return selector1.sameText(selector2);
    },
    eventMatches: function eventMatches(cy, listener, eventObj) {
        var selector = listener.qualifier;
        if (selector != null) return cy !== eventObj.target && $e815fda779bc047b$var$element(eventObj.target) && selector.matches(eventObj.target);
        return true;
    },
    addEventFields: function addEventFields(cy, evt) {
        evt.cy = cy;
        evt.target = cy;
    },
    callbackContext: function callbackContext(cy, listener, eventObj) {
        return listener.qualifier != null ? eventObj.target : cy;
    }
};
var $e815fda779bc047b$var$argSelector = function argSelector(arg) {
    if ($e815fda779bc047b$var$string(arg)) return new $e815fda779bc047b$var$Selector(arg);
    else return arg;
};
var $e815fda779bc047b$var$elesfn = {
    createEmitter: function createEmitter() {
        var _p = this._private;
        if (!_p.emitter) _p.emitter = new $e815fda779bc047b$var$Emitter($e815fda779bc047b$var$emitterOptions, this);
        return this;
    },
    emitter: function emitter() {
        return this._private.emitter;
    },
    on: function on(events, selector, callback) {
        this.emitter().on(events, $e815fda779bc047b$var$argSelector(selector), callback);
        return this;
    },
    removeListener: function removeListener(events, selector, callback) {
        this.emitter().removeListener(events, $e815fda779bc047b$var$argSelector(selector), callback);
        return this;
    },
    removeAllListeners: function removeAllListeners() {
        this.emitter().removeAllListeners();
        return this;
    },
    one: function one(events, selector, callback) {
        this.emitter().one(events, $e815fda779bc047b$var$argSelector(selector), callback);
        return this;
    },
    once: function once(events, selector, callback) {
        this.emitter().one(events, $e815fda779bc047b$var$argSelector(selector), callback);
        return this;
    },
    emit: function emit(events, extraParams) {
        this.emitter().emit(events, extraParams);
        return this;
    },
    emitAndNotify: function emitAndNotify(event, eles) {
        this.emit(event);
        this.notify(event, eles);
        return this;
    }
};
$e815fda779bc047b$var$define.eventAliasesOn($e815fda779bc047b$var$elesfn);
var $e815fda779bc047b$var$corefn$7 = {
    png: function png(options) {
        var renderer = this._private.renderer;
        options = options || {};
        return renderer.png(options);
    },
    jpg: function jpg(options) {
        var renderer = this._private.renderer;
        options = options || {};
        options.bg = options.bg || '#fff';
        return renderer.jpg(options);
    }
};
$e815fda779bc047b$var$corefn$7.jpeg = $e815fda779bc047b$var$corefn$7.jpg;
var $e815fda779bc047b$var$corefn$6 = {
    layout: function layout(options) {
        var cy = this;
        if (options == null) {
            $e815fda779bc047b$var$error('Layout options must be specified to make a layout');
            return;
        }
        if (options.name == null) {
            $e815fda779bc047b$var$error('A `name` must be specified to make a layout');
            return;
        }
        var name = options.name;
        var Layout = cy.extension('layout', name);
        if (Layout == null) {
            $e815fda779bc047b$var$error('No such layout `' + name + '` found.  Did you forget to import it and `cytoscape.use()` it?');
            return;
        }
        var eles;
        if ($e815fda779bc047b$var$string(options.eles)) eles = cy.$(options.eles);
        else eles = options.eles != null ? options.eles : cy.$();
        var layout = new Layout($e815fda779bc047b$var$extend({}, options, {
            cy: cy,
            eles: eles
        }));
        return layout;
    }
};
$e815fda779bc047b$var$corefn$6.createLayout = $e815fda779bc047b$var$corefn$6.makeLayout = $e815fda779bc047b$var$corefn$6.layout;
var $e815fda779bc047b$var$corefn$5 = {
    notify: function notify(eventName, eventEles) {
        var _p = this._private;
        if (this.batching()) {
            _p.batchNotifications = _p.batchNotifications || {};
            var eles = _p.batchNotifications[eventName] = _p.batchNotifications[eventName] || this.collection();
            if (eventEles != null) eles.merge(eventEles);
            return; // notifications are disabled during batching
        }
        if (!_p.notificationsEnabled) return;
         // exit on disabled
        var renderer = this.renderer();
        // exit if destroy() called on core or renderer in between frames #1499 #1528
        if (this.destroyed() || !renderer) return;
        renderer.notify(eventName, eventEles);
    },
    notifications: function notifications(bool) {
        var p = this._private;
        if (bool === undefined) return p.notificationsEnabled;
        else p.notificationsEnabled = bool ? true : false;
        return this;
    },
    noNotifications: function noNotifications(callback) {
        this.notifications(false);
        callback();
        this.notifications(true);
    },
    batching: function batching() {
        return this._private.batchCount > 0;
    },
    startBatch: function startBatch() {
        var _p = this._private;
        if (_p.batchCount == null) _p.batchCount = 0;
        if (_p.batchCount === 0) {
            _p.batchStyleEles = this.collection();
            _p.batchNotifications = {};
        }
        _p.batchCount++;
        return this;
    },
    endBatch: function endBatch() {
        var _p = this._private;
        if (_p.batchCount === 0) return this;
        _p.batchCount--;
        if (_p.batchCount === 0) {
            // update style for dirty eles
            _p.batchStyleEles.updateStyle();
            var renderer = this.renderer();
            // notify the renderer of queued eles and event types
            Object.keys(_p.batchNotifications).forEach(function(eventName) {
                var eles = _p.batchNotifications[eventName];
                if (eles.empty()) renderer.notify(eventName);
                else renderer.notify(eventName, eles);
            });
        }
        return this;
    },
    batch: function batch(callback) {
        this.startBatch();
        callback();
        this.endBatch();
        return this;
    },
    // for backwards compatibility
    batchData: function batchData(map) {
        var cy = this;
        return this.batch(function() {
            var ids = Object.keys(map);
            for(var i = 0; i < ids.length; i++){
                var id = ids[i];
                var data = map[id];
                var ele = cy.getElementById(id);
                ele.data(data);
            }
        });
    }
};
var $e815fda779bc047b$var$rendererDefaults = $e815fda779bc047b$var$defaults$g({
    hideEdgesOnViewport: false,
    textureOnViewport: false,
    motionBlur: false,
    motionBlurOpacity: 0.05,
    pixelRatio: undefined,
    desktopTapThreshold: 4,
    touchTapThreshold: 8,
    wheelSensitivity: 1,
    debug: false,
    showFps: false,
    // webgl options
    webgl: false,
    webglDebug: false,
    webglDebugShowAtlases: false,
    // defaults good for mobile
    webglTexSize: 2048,
    webglTexRows: 36,
    webglTexRowsNodes: 18,
    webglBatchSize: 2048,
    webglTexPerBatch: 14,
    webglBgColor: [
        255,
        255,
        255
    ]
});
var $e815fda779bc047b$var$corefn$4 = {
    renderTo: function renderTo(context, zoom, pan, pxRatio) {
        var r = this._private.renderer;
        r.renderTo(context, zoom, pan, pxRatio);
        return this;
    },
    renderer: function renderer() {
        return this._private.renderer;
    },
    forceRender: function forceRender() {
        this.notify('draw');
        return this;
    },
    resize: function resize() {
        this.invalidateSize();
        this.emitAndNotify('resize');
        return this;
    },
    initRenderer: function initRenderer(options) {
        var cy = this;
        var RendererProto = cy.extension('renderer', options.name);
        if (RendererProto == null) {
            $e815fda779bc047b$var$error("Can not initialise: No such renderer `".concat(options.name, "` found. Did you forget to import it and `cytoscape.use()` it?"));
            return;
        }
        if (options.wheelSensitivity !== undefined) $e815fda779bc047b$var$warn("You have set a custom wheel sensitivity.  This will make your app zoom unnaturally when using mainstream mice.  You should change this value from the default only if you can guarantee that all your users will use the same hardware and OS configuration as your current machine.");
        var rOpts = $e815fda779bc047b$var$rendererDefaults(options);
        rOpts.cy = cy;
        cy._private.renderer = new RendererProto(rOpts);
        this.notify('init');
    },
    destroyRenderer: function destroyRenderer() {
        var cy = this;
        cy.notify('destroy'); // destroy the renderer
        var domEle = cy.container();
        if (domEle) {
            domEle._cyreg = null;
            while(domEle.childNodes.length > 0)domEle.removeChild(domEle.childNodes[0]);
        }
        cy._private.renderer = null; // to be extra safe, remove the ref
        cy.mutableElements().forEach(function(ele) {
            var _p = ele._private;
            _p.rscratch = {};
            _p.rstyle = {};
            _p.animation.current = [];
            _p.animation.queue = [];
        });
    },
    onRender: function onRender(fn) {
        return this.on('render', fn);
    },
    offRender: function offRender(fn) {
        return this.off('render', fn);
    }
};
$e815fda779bc047b$var$corefn$4.invalidateDimensions = $e815fda779bc047b$var$corefn$4.resize;
var $e815fda779bc047b$var$corefn$3 = {
    // get a collection
    // - empty collection on no args
    // - collection of elements in the graph on selector arg
    // - guarantee a returned collection when elements or collection specified
    collection: function collection(eles, opts) {
        if ($e815fda779bc047b$var$string(eles)) return this.$(eles);
        else if ($e815fda779bc047b$var$elementOrCollection(eles)) return eles.collection();
        else if ($e815fda779bc047b$var$array(eles)) {
            if (!opts) opts = {};
            return new $e815fda779bc047b$var$Collection(this, eles, opts.unique, opts.removed);
        }
        return new $e815fda779bc047b$var$Collection(this);
    },
    nodes: function nodes(selector) {
        var nodes = this.$(function(ele) {
            return ele.isNode();
        });
        if (selector) return nodes.filter(selector);
        return nodes;
    },
    edges: function edges(selector) {
        var edges = this.$(function(ele) {
            return ele.isEdge();
        });
        if (selector) return edges.filter(selector);
        return edges;
    },
    // search the graph like jQuery
    $: function $(selector) {
        var eles = this._private.elements;
        if (selector) return eles.filter(selector);
        else return eles.spawnSelf();
    },
    mutableElements: function mutableElements() {
        return this._private.elements;
    }
};
// aliases
$e815fda779bc047b$var$corefn$3.elements = $e815fda779bc047b$var$corefn$3.filter = $e815fda779bc047b$var$corefn$3.$;
var $e815fda779bc047b$var$styfn$8 = {};
// keys for style blocks, e.g. ttfftt
var $e815fda779bc047b$var$TRUE = 't';
var $e815fda779bc047b$var$FALSE = 'f';
// (potentially expensive calculation)
// apply the style to the element based on
// - its bypass
// - what selectors match it
$e815fda779bc047b$var$styfn$8.apply = function(eles) {
    var self1 = this;
    var _p = self1._private;
    var cy = _p.cy;
    var updatedEles = cy.collection();
    for(var ie = 0; ie < eles.length; ie++){
        var ele = eles[ie];
        var cxtMeta = self1.getContextMeta(ele);
        if (cxtMeta.empty) continue;
        var cxtStyle = self1.getContextStyle(cxtMeta);
        var app = self1.applyContextStyle(cxtMeta, cxtStyle, ele);
        if (ele._private.appliedInitStyle) self1.updateTransitions(ele, app.diffProps);
        else ele._private.appliedInitStyle = true;
        var hintsDiff = self1.updateStyleHints(ele);
        if (hintsDiff) updatedEles.push(ele);
    } // for elements
    return updatedEles;
};
$e815fda779bc047b$var$styfn$8.getPropertiesDiff = function(oldCxtKey, newCxtKey) {
    var self1 = this;
    var cache = self1._private.propDiffs = self1._private.propDiffs || {};
    var dualCxtKey = oldCxtKey + '-' + newCxtKey;
    var cachedVal = cache[dualCxtKey];
    if (cachedVal) return cachedVal;
    var diffProps = [];
    var addedProp = {};
    for(var i = 0; i < self1.length; i++){
        var cxt = self1[i];
        var oldHasCxt = oldCxtKey[i] === $e815fda779bc047b$var$TRUE;
        var newHasCxt = newCxtKey[i] === $e815fda779bc047b$var$TRUE;
        var cxtHasDiffed = oldHasCxt !== newHasCxt;
        var cxtHasMappedProps = cxt.mappedProperties.length > 0;
        if (cxtHasDiffed || newHasCxt && cxtHasMappedProps) {
            var props = undefined;
            if (cxtHasDiffed && cxtHasMappedProps) props = cxt.properties; // suffices b/c mappedProperties is a subset of properties
            else if (cxtHasDiffed) props = cxt.properties; // need to check them all
            else if (cxtHasMappedProps) props = cxt.mappedProperties; // only need to check mapped
            for(var j = 0; j < props.length; j++){
                var prop = props[j];
                var name = prop.name;
                // if a later context overrides this property, then the fact that this context has switched/diffed doesn't matter
                // (semi expensive check since it makes this function O(n^2) on context length, but worth it since overall result
                // is cached)
                var laterCxtOverrides = false;
                for(var k = i + 1; k < self1.length; k++){
                    var laterCxt = self1[k];
                    var hasLaterCxt = newCxtKey[k] === $e815fda779bc047b$var$TRUE;
                    if (!hasLaterCxt) continue;
                     // can't override unless the context is active
                    laterCxtOverrides = laterCxt.properties[prop.name] != null;
                    if (laterCxtOverrides) break;
                     // exit early as long as one later context overrides
                }
                if (!addedProp[name] && !laterCxtOverrides) {
                    addedProp[name] = true;
                    diffProps.push(name);
                }
            } // for props
        } // if
    } // for contexts
    cache[dualCxtKey] = diffProps;
    return diffProps;
};
$e815fda779bc047b$var$styfn$8.getContextMeta = function(ele) {
    var self1 = this;
    var cxtKey = '';
    var diffProps;
    var prevKey = ele._private.styleCxtKey || '';
    // get the cxt key
    for(var i = 0; i < self1.length; i++){
        var context = self1[i];
        var contextSelectorMatches = context.selector && context.selector.matches(ele); // NB: context.selector may be null for 'core'
        if (contextSelectorMatches) cxtKey += $e815fda779bc047b$var$TRUE;
        else cxtKey += $e815fda779bc047b$var$FALSE;
    } // for context
    diffProps = self1.getPropertiesDiff(prevKey, cxtKey);
    ele._private.styleCxtKey = cxtKey;
    return {
        key: cxtKey,
        diffPropNames: diffProps,
        empty: diffProps.length === 0
    };
};
// gets a computed ele style object based on matched contexts
$e815fda779bc047b$var$styfn$8.getContextStyle = function(cxtMeta) {
    var cxtKey = cxtMeta.key;
    var self1 = this;
    var cxtStyles = this._private.contextStyles = this._private.contextStyles || {};
    // if already computed style, returned cached copy
    if (cxtStyles[cxtKey]) return cxtStyles[cxtKey];
    var style = {
        _private: {
            key: cxtKey
        }
    };
    for(var i = 0; i < self1.length; i++){
        var cxt = self1[i];
        var hasCxt = cxtKey[i] === $e815fda779bc047b$var$TRUE;
        if (!hasCxt) continue;
        for(var j = 0; j < cxt.properties.length; j++){
            var prop = cxt.properties[j];
            style[prop.name] = prop;
        }
    }
    cxtStyles[cxtKey] = style;
    return style;
};
$e815fda779bc047b$var$styfn$8.applyContextStyle = function(cxtMeta, cxtStyle, ele) {
    var self1 = this;
    var diffProps = cxtMeta.diffPropNames;
    var retDiffProps = {};
    var types = self1.types;
    for(var i = 0; i < diffProps.length; i++){
        var diffPropName = diffProps[i];
        var cxtProp = cxtStyle[diffPropName];
        var eleProp = ele.pstyle(diffPropName);
        if (!cxtProp) {
            // no context prop means delete
            if (!eleProp) continue; // no existing prop means nothing needs to be removed
            else if (eleProp.bypass) cxtProp = {
                name: diffPropName,
                deleteBypassed: true
            };
            else cxtProp = {
                name: diffPropName,
                "delete": true
            };
        }
        // save cycles when the context prop doesn't need to be applied
        if (eleProp === cxtProp) continue;
        // save cycles when a mapped context prop doesn't need to be applied
        if (cxtProp.mapped === types.fn // context prop is function mapper
         && eleProp != null // some props can be null even by default (e.g. a prop that overrides another one)
         && eleProp.mapping != null // ele prop is a concrete value from from a mapper
         && eleProp.mapping.value === cxtProp.value // the current prop on the ele is a flat prop value for the function mapper
        ) {
            // NB don't write to cxtProp, as it's shared among eles (stored in stylesheet)
            var mapping = eleProp.mapping; // can write to mapping, as it's a per-ele copy
            var fnValue = mapping.fnValue = cxtProp.value(ele); // temporarily cache the value in case of a miss
            if (fnValue === mapping.prevFnValue) continue;
        }
        var retDiffProp = retDiffProps[diffPropName] = {
            prev: eleProp
        };
        self1.applyParsedProperty(ele, cxtProp);
        retDiffProp.next = ele.pstyle(diffPropName);
        if (retDiffProp.next && retDiffProp.next.bypass) retDiffProp.next = retDiffProp.next.bypassed;
    }
    return {
        diffProps: retDiffProps
    };
};
$e815fda779bc047b$var$styfn$8.updateStyleHints = function(ele) {
    var _p = ele._private;
    var self1 = this;
    var propNames = self1.propertyGroupNames;
    var propGrKeys = self1.propertyGroupKeys;
    var propHash = function propHash(ele, propNames, seedKey) {
        return self1.getPropertiesHash(ele, propNames, seedKey);
    };
    var oldStyleKey = _p.styleKey;
    if (ele.removed()) return false;
    var isNode = _p.group === 'nodes';
    // get the style key hashes per prop group
    // but lazily -- only use non-default prop values to reduce the number of hashes
    //
    var overriddenStyles = ele._private.style;
    propNames = Object.keys(overriddenStyles);
    for(var i = 0; i < propGrKeys.length; i++){
        var grKey = propGrKeys[i];
        _p.styleKeys[grKey] = [
            $e815fda779bc047b$var$DEFAULT_HASH_SEED,
            $e815fda779bc047b$var$DEFAULT_HASH_SEED_ALT
        ];
    }
    var updateGrKey1 = function updateGrKey1(val, grKey) {
        return _p.styleKeys[grKey][0] = $e815fda779bc047b$var$hashInt(val, _p.styleKeys[grKey][0]);
    };
    var updateGrKey2 = function updateGrKey2(val, grKey) {
        return _p.styleKeys[grKey][1] = $e815fda779bc047b$var$hashIntAlt(val, _p.styleKeys[grKey][1]);
    };
    var updateGrKey = function updateGrKey(val, grKey) {
        updateGrKey1(val, grKey);
        updateGrKey2(val, grKey);
    };
    var updateGrKeyWStr = function updateGrKeyWStr(strVal, grKey) {
        for(var j = 0; j < strVal.length; j++){
            var ch = strVal.charCodeAt(j);
            updateGrKey1(ch, grKey);
            updateGrKey2(ch, grKey);
        }
    };
    // - hashing works on 32 bit ints b/c we use bitwise ops
    // - small numbers get cut off (e.g. 0.123 is seen as 0 by the hashing function)
    // - raise up small numbers so more significant digits are seen by hashing
    // - make small numbers larger than a normal value to avoid collisions
    // - works in practice and it's relatively cheap
    var N = 2000000000;
    var cleanNum = function cleanNum(val) {
        return -128 < val && val < 128 && Math.floor(val) !== val ? N - (val * 1024 | 0) : val;
    };
    for(var _i = 0; _i < propNames.length; _i++){
        var name = propNames[_i];
        var parsedProp = overriddenStyles[name];
        if (parsedProp == null) continue;
        var propInfo = this.properties[name];
        var type = propInfo.type;
        var _grKey = propInfo.groupKey;
        var normalizedNumberVal = undefined;
        if (propInfo.hashOverride != null) normalizedNumberVal = propInfo.hashOverride(ele, parsedProp);
        else if (parsedProp.pfValue != null) normalizedNumberVal = parsedProp.pfValue;
        // might not be a number if it allows enums
        var numberVal = propInfo.enums == null ? parsedProp.value : null;
        var haveNormNum = normalizedNumberVal != null;
        var haveUnitedNum = numberVal != null;
        var haveNum = haveNormNum || haveUnitedNum;
        var units = parsedProp.units;
        // numbers are cheaper to hash than strings
        // 1 hash op vs n hash ops (for length n string)
        if (type.number && haveNum && !type.multiple) {
            var v = haveNormNum ? normalizedNumberVal : numberVal;
            updateGrKey(cleanNum(v), _grKey);
            if (!haveNormNum && units != null) updateGrKeyWStr(units, _grKey);
        } else updateGrKeyWStr(parsedProp.strValue, _grKey);
    }
    // overall style key
    //
    var hash = [
        $e815fda779bc047b$var$DEFAULT_HASH_SEED,
        $e815fda779bc047b$var$DEFAULT_HASH_SEED_ALT
    ];
    for(var _i2 = 0; _i2 < propGrKeys.length; _i2++){
        var _grKey2 = propGrKeys[_i2];
        var grHash = _p.styleKeys[_grKey2];
        hash[0] = $e815fda779bc047b$var$hashInt(grHash[0], hash[0]);
        hash[1] = $e815fda779bc047b$var$hashIntAlt(grHash[1], hash[1]);
    }
    _p.styleKey = $e815fda779bc047b$var$combineHashes(hash[0], hash[1]);
    // label dims
    //
    var sk = _p.styleKeys;
    _p.labelDimsKey = $e815fda779bc047b$var$combineHashesArray(sk.labelDimensions);
    var labelKeys = propHash(ele, [
        'label'
    ], sk.labelDimensions);
    _p.labelKey = $e815fda779bc047b$var$combineHashesArray(labelKeys);
    _p.labelStyleKey = $e815fda779bc047b$var$combineHashesArray($e815fda779bc047b$var$hashArrays(sk.commonLabel, labelKeys));
    if (!isNode) {
        var sourceLabelKeys = propHash(ele, [
            'source-label'
        ], sk.labelDimensions);
        _p.sourceLabelKey = $e815fda779bc047b$var$combineHashesArray(sourceLabelKeys);
        _p.sourceLabelStyleKey = $e815fda779bc047b$var$combineHashesArray($e815fda779bc047b$var$hashArrays(sk.commonLabel, sourceLabelKeys));
        var targetLabelKeys = propHash(ele, [
            'target-label'
        ], sk.labelDimensions);
        _p.targetLabelKey = $e815fda779bc047b$var$combineHashesArray(targetLabelKeys);
        _p.targetLabelStyleKey = $e815fda779bc047b$var$combineHashesArray($e815fda779bc047b$var$hashArrays(sk.commonLabel, targetLabelKeys));
    }
    // node
    //
    if (isNode) {
        var _p$styleKeys = _p.styleKeys, nodeBody = _p$styleKeys.nodeBody, nodeBorder = _p$styleKeys.nodeBorder, nodeOutline = _p$styleKeys.nodeOutline, backgroundImage = _p$styleKeys.backgroundImage, compound = _p$styleKeys.compound, pie = _p$styleKeys.pie, stripe = _p$styleKeys.stripe;
        var nodeKeys = [
            nodeBody,
            nodeBorder,
            nodeOutline,
            backgroundImage,
            compound,
            pie,
            stripe
        ].filter(function(k) {
            return k != null;
        }).reduce($e815fda779bc047b$var$hashArrays, [
            $e815fda779bc047b$var$DEFAULT_HASH_SEED,
            $e815fda779bc047b$var$DEFAULT_HASH_SEED_ALT
        ]);
        _p.nodeKey = $e815fda779bc047b$var$combineHashesArray(nodeKeys);
        _p.hasPie = pie != null && pie[0] !== $e815fda779bc047b$var$DEFAULT_HASH_SEED && pie[1] !== $e815fda779bc047b$var$DEFAULT_HASH_SEED_ALT;
        _p.hasStripe = stripe != null && stripe[0] !== $e815fda779bc047b$var$DEFAULT_HASH_SEED && stripe[1] !== $e815fda779bc047b$var$DEFAULT_HASH_SEED_ALT;
    }
    return oldStyleKey !== _p.styleKey;
};
$e815fda779bc047b$var$styfn$8.clearStyleHints = function(ele) {
    var _p = ele._private;
    _p.styleCxtKey = '';
    _p.styleKeys = {};
    _p.styleKey = null;
    _p.labelKey = null;
    _p.labelStyleKey = null;
    _p.sourceLabelKey = null;
    _p.sourceLabelStyleKey = null;
    _p.targetLabelKey = null;
    _p.targetLabelStyleKey = null;
    _p.nodeKey = null;
    _p.hasPie = null;
    _p.hasStripe = null;
};
// apply a property to the style (for internal use)
// returns whether application was successful
//
// now, this function flattens the property, and here's how:
//
// for parsedProp:{ bypass: true, deleteBypass: true }
// no property is generated, instead the bypass property in the
// element's style is replaced by what's pointed to by the `bypassed`
// field in the bypass property (i.e. restoring the property the
// bypass was overriding)
//
// for parsedProp:{ mapped: truthy }
// the generated flattenedProp:{ mapping: prop }
//
// for parsedProp:{ bypass: true }
// the generated flattenedProp:{ bypassed: parsedProp }
$e815fda779bc047b$var$styfn$8.applyParsedProperty = function(ele, parsedProp) {
    var self1 = this;
    var prop = parsedProp;
    var style = ele._private.style;
    var flatProp;
    var types = self1.types;
    var type = self1.properties[prop.name].type;
    var propIsBypass = prop.bypass;
    var origProp = style[prop.name];
    var origPropIsBypass = origProp && origProp.bypass;
    var _p = ele._private;
    var flatPropMapping = 'mapping';
    var getVal = function getVal(p) {
        if (p == null) return null;
        else if (p.pfValue != null) return p.pfValue;
        else return p.value;
    };
    var checkTriggers = function checkTriggers() {
        var fromVal = getVal(origProp);
        var toVal = getVal(prop);
        self1.checkTriggers(ele, prop.name, fromVal, toVal);
    };
    // edge sanity checks to prevent the client from making serious mistakes
    if (parsedProp.name === 'curve-style' && ele.isEdge() && // loops must be bundled beziers
    (parsedProp.value !== 'bezier' && ele.isLoop() || // edges connected to compound nodes can not be haystacks
    parsedProp.value === 'haystack' && (ele.source().isParent() || ele.target().isParent()))) prop = parsedProp = this.parse(parsedProp.name, 'bezier', propIsBypass);
    if (prop["delete"]) {
        // delete the property and use the default value on falsey value
        style[prop.name] = undefined;
        checkTriggers();
        return true;
    }
    if (prop.deleteBypassed) {
        // delete the property that the
        if (!origProp) {
            checkTriggers();
            return true; // can't delete if no prop
        } else if (origProp.bypass) {
            // delete bypassed
            origProp.bypassed = undefined;
            checkTriggers();
            return true;
        } else return false; // we're unsuccessful deleting the bypassed
    }
    // check if we need to delete the current bypass
    if (prop.deleteBypass) {
        // then this property is just here to indicate we need to delete
        if (!origProp) {
            checkTriggers();
            return true; // property is already not defined
        } else if (origProp.bypass) {
            // then replace the bypass property with the original
            // because the bypassed property was already applied (and therefore parsed), we can just replace it (no reapplying necessary)
            style[prop.name] = origProp.bypassed;
            checkTriggers();
            return true;
        } else return false; // we're unsuccessful deleting the bypass
    }
    var printMappingErr = function printMappingErr() {
        $e815fda779bc047b$var$warn('Do not assign mappings to elements without corresponding data (i.e. ele `' + ele.id() + '` has no mapping for property `' + prop.name + '` with data field `' + prop.field + '`); try a `[' + prop.field + ']` selector to limit scope to elements with `' + prop.field + '` defined');
    };
    // put the property in the style objects
    switch(prop.mapped){
        // flatten the property if mapped
        case types.mapData:
            // flatten the field (e.g. data.foo.bar)
            var fields = prop.field.split('.');
            var fieldVal = _p.data;
            for(var i = 0; i < fields.length && fieldVal; i++){
                var field = fields[i];
                fieldVal = fieldVal[field];
            }
            if (fieldVal == null) {
                printMappingErr();
                return false;
            }
            var percent;
            if (!$e815fda779bc047b$var$number$1(fieldVal)) {
                // then don't apply and fall back on the existing style
                $e815fda779bc047b$var$warn('Do not use continuous mappers without specifying numeric data (i.e. `' + prop.field + ': ' + fieldVal + '` for `' + ele.id() + '` is non-numeric)');
                return false;
            } else {
                var fieldWidth = prop.fieldMax - prop.fieldMin;
                if (fieldWidth === 0) // safety check -- not strictly necessary as no props of zero range should be passed here
                percent = 0;
                else percent = (fieldVal - prop.fieldMin) / fieldWidth;
            }
            // make sure to bound percent value
            if (percent < 0) percent = 0;
            else if (percent > 1) percent = 1;
            if (type.color) {
                var r1 = prop.valueMin[0];
                var r2 = prop.valueMax[0];
                var g1 = prop.valueMin[1];
                var g2 = prop.valueMax[1];
                var b1 = prop.valueMin[2];
                var b2 = prop.valueMax[2];
                var a1 = prop.valueMin[3] == null ? 1 : prop.valueMin[3];
                var a2 = prop.valueMax[3] == null ? 1 : prop.valueMax[3];
                var clr = [
                    Math.round(r1 + (r2 - r1) * percent),
                    Math.round(g1 + (g2 - g1) * percent),
                    Math.round(b1 + (b2 - b1) * percent),
                    Math.round(a1 + (a2 - a1) * percent)
                ];
                flatProp = {
                    // colours are simple, so just create the flat property instead of expensive string parsing
                    bypass: prop.bypass,
                    // we're a bypass if the mapping property is a bypass
                    name: prop.name,
                    value: clr,
                    strValue: 'rgb(' + clr[0] + ', ' + clr[1] + ', ' + clr[2] + ')'
                };
            } else if (type.number) {
                var calcValue = prop.valueMin + (prop.valueMax - prop.valueMin) * percent;
                flatProp = this.parse(prop.name, calcValue, prop.bypass, flatPropMapping);
            } else return false; // can only map to colours and numbers
            if (!flatProp) {
                // if we can't flatten the property, then don't apply the property and fall back on the existing style
                printMappingErr();
                return false;
            }
            flatProp.mapping = prop; // keep a reference to the mapping
            prop = flatProp; // the flattened (mapped) property is the one we want
            break;
        // direct mapping
        case types.data:
            // flatten the field (e.g. data.foo.bar)
            var _fields = prop.field.split('.');
            var _fieldVal = _p.data;
            for(var _i3 = 0; _i3 < _fields.length && _fieldVal; _i3++){
                var _field = _fields[_i3];
                _fieldVal = _fieldVal[_field];
            }
            if (_fieldVal != null) flatProp = this.parse(prop.name, _fieldVal, prop.bypass, flatPropMapping);
            if (!flatProp) {
                // if we can't flatten the property, then don't apply and fall back on the existing style
                printMappingErr();
                return false;
            }
            flatProp.mapping = prop; // keep a reference to the mapping
            prop = flatProp; // the flattened (mapped) property is the one we want
            break;
        case types.fn:
            var fn = prop.value;
            var fnRetVal = prop.fnValue != null ? prop.fnValue : fn(ele); // check for cached value before calling function
            prop.prevFnValue = fnRetVal;
            if (fnRetVal == null) {
                $e815fda779bc047b$var$warn('Custom function mappers may not return null (i.e. `' + prop.name + '` for ele `' + ele.id() + '` is null)');
                return false;
            }
            flatProp = this.parse(prop.name, fnRetVal, prop.bypass, flatPropMapping);
            if (!flatProp) {
                $e815fda779bc047b$var$warn('Custom function mappers may not return invalid values for the property type (i.e. `' + prop.name + '` for ele `' + ele.id() + '` is invalid)');
                return false;
            }
            flatProp.mapping = $e815fda779bc047b$var$copy(prop); // keep a reference to the mapping
            prop = flatProp; // the flattened (mapped) property is the one we want
            break;
        case undefined:
            break;
        // just set the property
        default:
            return false;
    }
    // if the property is a bypass property, then link the resultant property to the original one
    if (propIsBypass) {
        if (origPropIsBypass) // then this bypass overrides the existing one
        prop.bypassed = origProp.bypassed; // steal bypassed prop from old bypass
        else // then link the orig prop to the new bypass
        prop.bypassed = origProp;
        style[prop.name] = prop; // and set
    } else // prop is not bypass
    if (origPropIsBypass) // then keep the orig prop (since it's a bypass) and link to the new prop
    origProp.bypassed = prop;
    else // then just replace the old prop with the new one
    style[prop.name] = prop;
    checkTriggers();
    return true;
};
$e815fda779bc047b$var$styfn$8.cleanElements = function(eles, keepBypasses) {
    for(var i = 0; i < eles.length; i++){
        var ele = eles[i];
        this.clearStyleHints(ele);
        ele.dirtyCompoundBoundsCache();
        ele.dirtyBoundingBoxCache();
        if (!keepBypasses) ele._private.style = {};
        else {
            var style = ele._private.style;
            var propNames = Object.keys(style);
            for(var j = 0; j < propNames.length; j++){
                var propName = propNames[j];
                var eleProp = style[propName];
                if (eleProp != null) {
                    if (eleProp.bypass) eleProp.bypassed = null;
                    else style[propName] = null;
                }
            }
        }
    }
};
// updates the visual style for all elements (useful for manual style modification after init)
$e815fda779bc047b$var$styfn$8.update = function() {
    var cy = this._private.cy;
    var eles = cy.mutableElements();
    eles.updateStyle();
};
// diffProps : { name => { prev, next } }
$e815fda779bc047b$var$styfn$8.updateTransitions = function(ele, diffProps) {
    var self1 = this;
    var _p = ele._private;
    var props = ele.pstyle('transition-property').value;
    var duration = ele.pstyle('transition-duration').pfValue;
    var delay = ele.pstyle('transition-delay').pfValue;
    if (props.length > 0 && duration > 0) {
        var style = {};
        // build up the style to animate towards
        var anyPrev = false;
        for(var i = 0; i < props.length; i++){
            var prop = props[i];
            var styProp = ele.pstyle(prop);
            var diffProp = diffProps[prop];
            if (!diffProp) continue;
            var prevProp = diffProp.prev;
            var fromProp = prevProp;
            var toProp = diffProp.next != null ? diffProp.next : styProp;
            var diff = false;
            var initVal = undefined;
            var initDt = 0.000001; // delta time % value for initVal (allows animating out of init zero opacity)
            if (!fromProp) continue;
            // consider px values
            if ($e815fda779bc047b$var$number$1(fromProp.pfValue) && $e815fda779bc047b$var$number$1(toProp.pfValue)) {
                diff = toProp.pfValue - fromProp.pfValue; // nonzero is truthy
                initVal = fromProp.pfValue + initDt * diff;
            // consider numerical values
            } else if ($e815fda779bc047b$var$number$1(fromProp.value) && $e815fda779bc047b$var$number$1(toProp.value)) {
                diff = toProp.value - fromProp.value; // nonzero is truthy
                initVal = fromProp.value + initDt * diff;
            // consider colour values
            } else if ($e815fda779bc047b$var$array(fromProp.value) && $e815fda779bc047b$var$array(toProp.value)) {
                diff = fromProp.value[0] !== toProp.value[0] || fromProp.value[1] !== toProp.value[1] || fromProp.value[2] !== toProp.value[2];
                initVal = fromProp.strValue;
            }
            // the previous value is good for an animation only if it's different
            if (diff) {
                style[prop] = toProp.strValue; // to val
                this.applyBypass(ele, prop, initVal); // from val
                anyPrev = true;
            }
        } // end if props allow ani
        // can't transition if there's nothing previous to transition from
        if (!anyPrev) return;
        _p.transitioning = true;
        new $e815fda779bc047b$var$Promise$1(function(resolve) {
            if (delay > 0) ele.delayAnimation(delay).play().promise().then(resolve);
            else resolve();
        }).then(function() {
            return ele.animation({
                style: style,
                duration: duration,
                easing: ele.pstyle('transition-timing-function').value,
                queue: false
            }).play().promise();
        }).then(function() {
            // if( !isBypass ){
            self1.removeBypasses(ele, props);
            ele.emitAndNotify('style');
            // }
            _p.transitioning = false;
        });
    } else if (_p.transitioning) {
        this.removeBypasses(ele, props);
        ele.emitAndNotify('style');
        _p.transitioning = false;
    }
};
$e815fda779bc047b$var$styfn$8.checkTrigger = function(ele, name, fromValue, toValue, getTrigger, onTrigger) {
    var prop = this.properties[name];
    var triggerCheck = getTrigger(prop);
    if (ele.removed()) return;
    if (triggerCheck != null && triggerCheck(fromValue, toValue, ele)) onTrigger(prop);
};
$e815fda779bc047b$var$styfn$8.checkZOrderTrigger = function(ele, name, fromValue, toValue) {
    var _this = this;
    this.checkTrigger(ele, name, fromValue, toValue, function(prop) {
        return prop.triggersZOrder;
    }, function() {
        _this._private.cy.notify('zorder', ele);
    });
};
$e815fda779bc047b$var$styfn$8.checkBoundsTrigger = function(ele, name, fromValue, toValue) {
    this.checkTrigger(ele, name, fromValue, toValue, function(prop) {
        return prop.triggersBounds;
    }, function(prop) {
        ele.dirtyCompoundBoundsCache();
        ele.dirtyBoundingBoxCache();
    });
};
$e815fda779bc047b$var$styfn$8.checkConnectedEdgesBoundsTrigger = function(ele, name, fromValue, toValue) {
    this.checkTrigger(ele, name, fromValue, toValue, function(prop) {
        return prop.triggersBoundsOfConnectedEdges;
    }, function(prop) {
        ele.connectedEdges().forEach(function(edge) {
            edge.dirtyBoundingBoxCache();
        });
    });
};
$e815fda779bc047b$var$styfn$8.checkParallelEdgesBoundsTrigger = function(ele, name, fromValue, toValue) {
    this.checkTrigger(ele, name, fromValue, toValue, function(prop) {
        return prop.triggersBoundsOfParallelEdges;
    }, function(prop) {
        ele.parallelEdges().forEach(function(pllEdge) {
            pllEdge.dirtyBoundingBoxCache();
        });
    });
};
$e815fda779bc047b$var$styfn$8.checkTriggers = function(ele, name, fromValue, toValue) {
    ele.dirtyStyleCache();
    this.checkZOrderTrigger(ele, name, fromValue, toValue);
    this.checkBoundsTrigger(ele, name, fromValue, toValue);
    this.checkConnectedEdgesBoundsTrigger(ele, name, fromValue, toValue);
    this.checkParallelEdgesBoundsTrigger(ele, name, fromValue, toValue);
};
var $e815fda779bc047b$var$styfn$7 = {};
// bypasses are applied to an existing style on an element, and just tacked on temporarily
// returns true iff application was successful for at least 1 specified property
$e815fda779bc047b$var$styfn$7.applyBypass = function(eles, name, value, updateTransitions) {
    var self1 = this;
    var props = [];
    var isBypass = true;
    // put all the properties (can specify one or many) in an array after parsing them
    if (name === '*' || name === '**') {
        // apply to all property names
        if (value !== undefined) for(var i = 0; i < self1.properties.length; i++){
            var prop = self1.properties[i];
            var _name = prop.name;
            var parsedProp = this.parse(_name, value, true);
            if (parsedProp) props.push(parsedProp);
        }
    } else if ($e815fda779bc047b$var$string(name)) {
        // then parse the single property
        var _parsedProp = this.parse(name, value, true);
        if (_parsedProp) props.push(_parsedProp);
    } else if ($e815fda779bc047b$var$plainObject(name)) {
        // then parse each property
        var specifiedProps = name;
        updateTransitions = value;
        var names = Object.keys(specifiedProps);
        for(var _i = 0; _i < names.length; _i++){
            var _name2 = names[_i];
            var _value = specifiedProps[_name2];
            if (_value === undefined) // try camel case name too
            _value = specifiedProps[$e815fda779bc047b$var$dash2camel(_name2)];
            if (_value !== undefined) {
                var _parsedProp2 = this.parse(_name2, _value, true);
                if (_parsedProp2) props.push(_parsedProp2);
            }
        }
    } else // can't do anything without well defined properties
    return false;
    // we've failed if there are no valid properties
    if (props.length === 0) return false;
    // now, apply the bypass properties on the elements
    var ret = false; // return true if at least one succesful bypass applied
    for(var _i2 = 0; _i2 < eles.length; _i2++){
        // for each ele
        var ele = eles[_i2];
        var diffProps = {};
        var diffProp = undefined;
        for(var j = 0; j < props.length; j++){
            // for each prop
            var _prop = props[j];
            if (updateTransitions) {
                var prevProp = ele.pstyle(_prop.name);
                diffProp = diffProps[_prop.name] = {
                    prev: prevProp
                };
            }
            ret = this.applyParsedProperty(ele, $e815fda779bc047b$var$copy(_prop)) || ret;
            if (updateTransitions) diffProp.next = ele.pstyle(_prop.name);
        } // for props
        if (ret) this.updateStyleHints(ele);
        if (updateTransitions) this.updateTransitions(ele, diffProps, isBypass);
    } // for eles
    return ret;
};
// only useful in specific cases like animation
$e815fda779bc047b$var$styfn$7.overrideBypass = function(eles, name, value) {
    name = $e815fda779bc047b$var$camel2dash(name);
    for(var i = 0; i < eles.length; i++){
        var ele = eles[i];
        var prop = ele._private.style[name];
        var type = this.properties[name].type;
        var isColor = type.color;
        var isMulti = type.mutiple;
        var oldValue = !prop ? null : prop.pfValue != null ? prop.pfValue : prop.value;
        if (!prop || !prop.bypass) // need a bypass if one doesn't exist
        this.applyBypass(ele, name, value);
        else {
            prop.value = value;
            if (prop.pfValue != null) prop.pfValue = value;
            if (isColor) prop.strValue = 'rgb(' + value.join(',') + ')';
            else if (isMulti) prop.strValue = value.join(' ');
            else prop.strValue = '' + value;
            this.updateStyleHints(ele);
        }
        this.checkTriggers(ele, name, oldValue, value);
    }
};
$e815fda779bc047b$var$styfn$7.removeAllBypasses = function(eles, updateTransitions) {
    return this.removeBypasses(eles, this.propertyNames, updateTransitions);
};
$e815fda779bc047b$var$styfn$7.removeBypasses = function(eles, props, updateTransitions) {
    var isBypass = true;
    for(var j = 0; j < eles.length; j++){
        var ele = eles[j];
        var diffProps = {};
        for(var i = 0; i < props.length; i++){
            var name = props[i];
            var prop = this.properties[name];
            var prevProp = ele.pstyle(prop.name);
            if (!prevProp || !prevProp.bypass) continue;
            var value = ''; // empty => remove bypass
            var parsedProp = this.parse(name, value, true);
            var diffProp = diffProps[prop.name] = {
                prev: prevProp
            };
            this.applyParsedProperty(ele, parsedProp);
            diffProp.next = ele.pstyle(prop.name);
        } // for props
        this.updateStyleHints(ele);
        if (updateTransitions) this.updateTransitions(ele, diffProps, isBypass);
    } // for eles
};
var $e815fda779bc047b$var$styfn$6 = {};
// gets what an em size corresponds to in pixels relative to a dom element
$e815fda779bc047b$var$styfn$6.getEmSizeInPixels = function() {
    var px = this.containerCss('font-size');
    if (px != null) return parseFloat(px);
    else return 1; // for headless
};
// gets css property from the core container
$e815fda779bc047b$var$styfn$6.containerCss = function(propName) {
    var cy = this._private.cy;
    var domElement = cy.container();
    var containerWindow = cy.window();
    if (containerWindow && domElement && containerWindow.getComputedStyle) return containerWindow.getComputedStyle(domElement).getPropertyValue(propName);
};
var $e815fda779bc047b$var$styfn$5 = {};
// gets the rendered style for an element
$e815fda779bc047b$var$styfn$5.getRenderedStyle = function(ele, prop) {
    if (prop) return this.getStylePropertyValue(ele, prop, true);
    else return this.getRawStyle(ele, true);
};
// gets the raw style for an element
$e815fda779bc047b$var$styfn$5.getRawStyle = function(ele, isRenderedVal) {
    var self1 = this;
    ele = ele[0]; // insure it's an element
    if (ele) {
        var rstyle = {};
        for(var i = 0; i < self1.properties.length; i++){
            var prop = self1.properties[i];
            var val = self1.getStylePropertyValue(ele, prop.name, isRenderedVal);
            if (val != null) {
                rstyle[prop.name] = val;
                rstyle[$e815fda779bc047b$var$dash2camel(prop.name)] = val;
            }
        }
        return rstyle;
    }
};
$e815fda779bc047b$var$styfn$5.getIndexedStyle = function(ele, property, subproperty, index) {
    var pstyle = ele.pstyle(property)[subproperty][index];
    return pstyle != null ? pstyle : ele.cy().style().getDefaultProperty(property)[subproperty][0];
};
$e815fda779bc047b$var$styfn$5.getStylePropertyValue = function(ele, propName, isRenderedVal) {
    var self1 = this;
    ele = ele[0]; // insure it's an element
    if (ele) {
        var prop = self1.properties[propName];
        if (prop.alias) prop = prop.pointsTo;
        var type = prop.type;
        var styleProp = ele.pstyle(prop.name);
        if (styleProp) {
            var value = styleProp.value, units = styleProp.units, strValue = styleProp.strValue;
            if (isRenderedVal && type.number && value != null && $e815fda779bc047b$var$number$1(value)) {
                var zoom = ele.cy().zoom();
                var getRenderedValue = function getRenderedValue(val) {
                    return val * zoom;
                };
                var getValueStringWithUnits = function getValueStringWithUnits(val, units) {
                    return getRenderedValue(val) + units;
                };
                var isArrayValue = $e815fda779bc047b$var$array(value);
                var haveUnits = isArrayValue ? units.every(function(u) {
                    return u != null;
                }) : units != null;
                if (haveUnits) {
                    if (isArrayValue) return value.map(function(v, i) {
                        return getValueStringWithUnits(v, units[i]);
                    }).join(' ');
                    else return getValueStringWithUnits(value, units);
                } else {
                    if (isArrayValue) return value.map(function(v) {
                        return $e815fda779bc047b$var$string(v) ? v : '' + getRenderedValue(v);
                    }).join(' ');
                    else return '' + getRenderedValue(value);
                }
            } else if (strValue != null) return strValue;
        }
        return null;
    }
};
$e815fda779bc047b$var$styfn$5.getAnimationStartStyle = function(ele, aniProps) {
    var rstyle = {};
    for(var i = 0; i < aniProps.length; i++){
        var aniProp = aniProps[i];
        var name = aniProp.name;
        var styleProp = ele.pstyle(name);
        if (styleProp !== undefined) {
            // then make a prop of it
            if ($e815fda779bc047b$var$plainObject(styleProp)) styleProp = this.parse(name, styleProp.strValue);
            else styleProp = this.parse(name, styleProp);
        }
        if (styleProp) rstyle[name] = styleProp;
    }
    return rstyle;
};
$e815fda779bc047b$var$styfn$5.getPropsList = function(propsObj) {
    var self1 = this;
    var rstyle = [];
    var style = propsObj;
    var props = self1.properties;
    if (style) {
        var names = Object.keys(style);
        for(var i = 0; i < names.length; i++){
            var name = names[i];
            var val = style[name];
            var prop = props[name] || props[$e815fda779bc047b$var$camel2dash(name)];
            var styleProp = this.parse(prop.name, val);
            if (styleProp) rstyle.push(styleProp);
        }
    }
    return rstyle;
};
$e815fda779bc047b$var$styfn$5.getNonDefaultPropertiesHash = function(ele, propNames, seed) {
    var hash = seed.slice();
    var name, val, strVal, chVal;
    var i, j;
    for(i = 0; i < propNames.length; i++){
        name = propNames[i];
        val = ele.pstyle(name, false);
        if (val == null) continue;
        else if (val.pfValue != null) {
            hash[0] = $e815fda779bc047b$var$hashInt(chVal, hash[0]);
            hash[1] = $e815fda779bc047b$var$hashIntAlt(chVal, hash[1]);
        } else {
            strVal = val.strValue;
            for(j = 0; j < strVal.length; j++){
                chVal = strVal.charCodeAt(j);
                hash[0] = $e815fda779bc047b$var$hashInt(chVal, hash[0]);
                hash[1] = $e815fda779bc047b$var$hashIntAlt(chVal, hash[1]);
            }
        }
    }
    return hash;
};
$e815fda779bc047b$var$styfn$5.getPropertiesHash = $e815fda779bc047b$var$styfn$5.getNonDefaultPropertiesHash;
var $e815fda779bc047b$var$styfn$4 = {};
$e815fda779bc047b$var$styfn$4.appendFromJson = function(json) {
    var style = this;
    for(var i = 0; i < json.length; i++){
        var context = json[i];
        var selector = context.selector;
        var props = context.style || context.css;
        var names = Object.keys(props);
        style.selector(selector); // apply selector
        for(var j = 0; j < names.length; j++){
            var name = names[j];
            var value = props[name];
            style.css(name, value); // apply property
        }
    }
    return style;
};
// accessible cy.style() function
$e815fda779bc047b$var$styfn$4.fromJson = function(json) {
    var style = this;
    style.resetToDefault();
    style.appendFromJson(json);
    return style;
};
// get json from cy.style() api
$e815fda779bc047b$var$styfn$4.json = function() {
    var json = [];
    for(var i = this.defaultLength; i < this.length; i++){
        var cxt = this[i];
        var selector = cxt.selector;
        var props = cxt.properties;
        var css = {};
        for(var j = 0; j < props.length; j++){
            var prop = props[j];
            css[prop.name] = prop.strValue;
        }
        json.push({
            selector: !selector ? 'core' : selector.toString(),
            style: css
        });
    }
    return json;
};
var $e815fda779bc047b$var$styfn$3 = {};
$e815fda779bc047b$var$styfn$3.appendFromString = function(string) {
    var self1 = this;
    var style = this;
    var remaining = '' + string;
    var selAndBlockStr;
    var blockRem;
    var propAndValStr;
    // remove comments from the style string
    remaining = remaining.replace(/[/][*](\s|.)+?[*][/]/g, '');
    function removeSelAndBlockFromRemaining() {
        // remove the parsed selector and block from the remaining text to parse
        if (remaining.length > selAndBlockStr.length) remaining = remaining.substr(selAndBlockStr.length);
        else remaining = '';
    }
    function removePropAndValFromRem() {
        // remove the parsed property and value from the remaining block text to parse
        if (blockRem.length > propAndValStr.length) blockRem = blockRem.substr(propAndValStr.length);
        else blockRem = '';
    }
    for(;;){
        var nothingLeftToParse = remaining.match(/^\s*$/);
        if (nothingLeftToParse) break;
        var selAndBlock = remaining.match(/^\s*((?:.|\s)+?)\s*\{((?:.|\s)+?)\}/);
        if (!selAndBlock) {
            $e815fda779bc047b$var$warn('Halting stylesheet parsing: String stylesheet contains more to parse but no selector and block found in: ' + remaining);
            break;
        }
        selAndBlockStr = selAndBlock[0];
        // parse the selector
        var selectorStr = selAndBlock[1];
        if (selectorStr !== 'core') {
            var selector = new $e815fda779bc047b$var$Selector(selectorStr);
            if (selector.invalid) {
                $e815fda779bc047b$var$warn('Skipping parsing of block: Invalid selector found in string stylesheet: ' + selectorStr);
                // skip this selector and block
                removeSelAndBlockFromRemaining();
                continue;
            }
        }
        // parse the block of properties and values
        var blockStr = selAndBlock[2];
        var invalidBlock = false;
        blockRem = blockStr;
        var props = [];
        for(;;){
            var _nothingLeftToParse = blockRem.match(/^\s*$/);
            if (_nothingLeftToParse) break;
            var propAndVal = blockRem.match(/^\s*(.+?)\s*:\s*(.+?)(?:\s*;|\s*$)/);
            if (!propAndVal) {
                $e815fda779bc047b$var$warn('Skipping parsing of block: Invalid formatting of style property and value definitions found in:' + blockStr);
                invalidBlock = true;
                break;
            }
            propAndValStr = propAndVal[0];
            var propStr = propAndVal[1];
            var valStr = propAndVal[2];
            var prop = self1.properties[propStr];
            if (!prop) {
                $e815fda779bc047b$var$warn('Skipping property: Invalid property name in: ' + propAndValStr);
                // skip this property in the block
                removePropAndValFromRem();
                continue;
            }
            var parsedProp = style.parse(propStr, valStr);
            if (!parsedProp) {
                $e815fda779bc047b$var$warn('Skipping property: Invalid property definition in: ' + propAndValStr);
                // skip this property in the block
                removePropAndValFromRem();
                continue;
            }
            props.push({
                name: propStr,
                val: valStr
            });
            removePropAndValFromRem();
        }
        if (invalidBlock) {
            removeSelAndBlockFromRemaining();
            break;
        }
        // put the parsed block in the style
        style.selector(selectorStr);
        for(var i = 0; i < props.length; i++){
            var _prop = props[i];
            style.css(_prop.name, _prop.val);
        }
        removeSelAndBlockFromRemaining();
    }
    return style;
};
$e815fda779bc047b$var$styfn$3.fromString = function(string) {
    var style = this;
    style.resetToDefault();
    style.appendFromString(string);
    return style;
};
var $e815fda779bc047b$var$styfn$2 = {};
(function() {
    var number$1 = $e815fda779bc047b$var$number;
    var rgba = $e815fda779bc047b$var$rgbaNoBackRefs;
    var hsla = $e815fda779bc047b$var$hslaNoBackRefs;
    var hex3$1 = $e815fda779bc047b$var$hex3;
    var hex6$1 = $e815fda779bc047b$var$hex6;
    var data = function data(prefix) {
        return '^' + prefix + '\\s*\\(\\s*([\\w\\.]+)\\s*\\)$';
    };
    var mapData = function mapData(prefix) {
        var mapArg = number$1 + '|\\w+|' + rgba + '|' + hsla + '|' + hex3$1 + '|' + hex6$1;
        return '^' + prefix + '\\s*\\(([\\w\\.]+)\\s*\\,\\s*(' + number$1 + ')\\s*\\,\\s*(' + number$1 + ')\\s*,\\s*(' + mapArg + ')\\s*\\,\\s*(' + mapArg + ')\\)$';
    };
    var urlRegexes = [
        '^url\\s*\\(\\s*[\'"]?(.+?)[\'"]?\\s*\\)$',
        '^(none)$',
        '^(.+)$'
    ];
    // each visual style property has a type and needs to be validated according to it
    $e815fda779bc047b$var$styfn$2.types = {
        time: {
            number: true,
            min: 0,
            units: 's|ms',
            implicitUnits: 'ms'
        },
        percent: {
            number: true,
            min: 0,
            max: 100,
            units: '%',
            implicitUnits: '%'
        },
        percentages: {
            number: true,
            min: 0,
            max: 100,
            units: '%',
            implicitUnits: '%',
            multiple: true
        },
        zeroOneNumber: {
            number: true,
            min: 0,
            max: 1,
            unitless: true
        },
        zeroOneNumbers: {
            number: true,
            min: 0,
            max: 1,
            unitless: true,
            multiple: true
        },
        nOneOneNumber: {
            number: true,
            min: -1,
            max: 1,
            unitless: true
        },
        nonNegativeInt: {
            number: true,
            min: 0,
            integer: true,
            unitless: true
        },
        nonNegativeNumber: {
            number: true,
            min: 0,
            unitless: true
        },
        position: {
            enums: [
                'parent',
                'origin'
            ]
        },
        nodeSize: {
            number: true,
            min: 0,
            enums: [
                'label'
            ]
        },
        number: {
            number: true,
            unitless: true
        },
        numbers: {
            number: true,
            unitless: true,
            multiple: true
        },
        positiveNumber: {
            number: true,
            unitless: true,
            min: 0,
            strictMin: true
        },
        size: {
            number: true,
            min: 0
        },
        bidirectionalSize: {
            number: true
        },
        // allows negative
        bidirectionalSizeMaybePercent: {
            number: true,
            allowPercent: true
        },
        // allows negative
        bidirectionalSizes: {
            number: true,
            multiple: true
        },
        // allows negative
        sizeMaybePercent: {
            number: true,
            min: 0,
            allowPercent: true
        },
        axisDirection: {
            enums: [
                'horizontal',
                'leftward',
                'rightward',
                'vertical',
                'upward',
                'downward',
                'auto'
            ]
        },
        axisDirectionExplicit: {
            enums: [
                'leftward',
                'rightward',
                'upward',
                'downward'
            ]
        },
        axisDirectionPrimary: {
            enums: [
                'horizontal',
                'vertical'
            ]
        },
        paddingRelativeTo: {
            enums: [
                'width',
                'height',
                'average',
                'min',
                'max'
            ]
        },
        bgWH: {
            number: true,
            min: 0,
            allowPercent: true,
            enums: [
                'auto'
            ],
            multiple: true
        },
        bgPos: {
            number: true,
            allowPercent: true,
            multiple: true
        },
        bgRelativeTo: {
            enums: [
                'inner',
                'include-padding'
            ],
            multiple: true
        },
        bgRepeat: {
            enums: [
                'repeat',
                'repeat-x',
                'repeat-y',
                'no-repeat'
            ],
            multiple: true
        },
        bgFit: {
            enums: [
                'none',
                'contain',
                'cover'
            ],
            multiple: true
        },
        bgCrossOrigin: {
            enums: [
                'anonymous',
                'use-credentials',
                'null'
            ],
            multiple: true
        },
        bgClip: {
            enums: [
                'none',
                'node'
            ],
            multiple: true
        },
        bgContainment: {
            enums: [
                'inside',
                'over'
            ],
            multiple: true
        },
        boxSelection: {
            enums: [
                'contain',
                'overlap',
                'none'
            ]
        },
        color: {
            color: true
        },
        colors: {
            color: true,
            multiple: true
        },
        fill: {
            enums: [
                'solid',
                'linear-gradient',
                'radial-gradient'
            ]
        },
        bool: {
            enums: [
                'yes',
                'no'
            ]
        },
        bools: {
            enums: [
                'yes',
                'no'
            ],
            multiple: true
        },
        lineStyle: {
            enums: [
                'solid',
                'dotted',
                'dashed'
            ]
        },
        lineCap: {
            enums: [
                'butt',
                'round',
                'square'
            ]
        },
        linePosition: {
            enums: [
                'center',
                'inside',
                'outside'
            ]
        },
        lineJoin: {
            enums: [
                'round',
                'bevel',
                'miter'
            ]
        },
        borderStyle: {
            enums: [
                'solid',
                'dotted',
                'dashed',
                'double'
            ]
        },
        curveStyle: {
            enums: [
                'bezier',
                'unbundled-bezier',
                'haystack',
                'segments',
                'straight',
                'straight-triangle',
                'taxi',
                'round-segments',
                'round-taxi'
            ]
        },
        radiusType: {
            enums: [
                'arc-radius',
                'influence-radius'
            ],
            multiple: true
        },
        fontFamily: {
            regex: '^([\\w- \\"]+(?:\\s*,\\s*[\\w- \\"]+)*)$'
        },
        fontStyle: {
            enums: [
                'italic',
                'normal',
                'oblique'
            ]
        },
        fontWeight: {
            enums: [
                'normal',
                'bold',
                'bolder',
                'lighter',
                '100',
                '200',
                '300',
                '400',
                '500',
                '600',
                '800',
                '900',
                100,
                200,
                300,
                400,
                500,
                600,
                700,
                800,
                900
            ]
        },
        textDecoration: {
            enums: [
                'none',
                'underline',
                'overline',
                'line-through'
            ]
        },
        textTransform: {
            enums: [
                'none',
                'uppercase',
                'lowercase'
            ]
        },
        textWrap: {
            enums: [
                'none',
                'wrap',
                'ellipsis'
            ]
        },
        textOverflowWrap: {
            enums: [
                'whitespace',
                'anywhere'
            ]
        },
        textBackgroundShape: {
            enums: [
                'rectangle',
                'roundrectangle',
                'round-rectangle',
                'circle'
            ]
        },
        nodeShape: {
            enums: [
                'rectangle',
                'roundrectangle',
                'round-rectangle',
                'cutrectangle',
                'cut-rectangle',
                'bottomroundrectangle',
                'bottom-round-rectangle',
                'barrel',
                'ellipse',
                'triangle',
                'round-triangle',
                'square',
                'pentagon',
                'round-pentagon',
                'hexagon',
                'round-hexagon',
                'concavehexagon',
                'concave-hexagon',
                'heptagon',
                'round-heptagon',
                'octagon',
                'round-octagon',
                'tag',
                'round-tag',
                'star',
                'diamond',
                'round-diamond',
                'vee',
                'rhomboid',
                'right-rhomboid',
                'polygon'
            ]
        },
        overlayShape: {
            enums: [
                'roundrectangle',
                'round-rectangle',
                'ellipse'
            ]
        },
        cornerRadius: {
            number: true,
            min: 0,
            units: 'px|em',
            implicitUnits: 'px',
            enums: [
                'auto'
            ]
        },
        compoundIncludeLabels: {
            enums: [
                'include',
                'exclude'
            ]
        },
        arrowShape: {
            enums: [
                'tee',
                'triangle',
                'triangle-tee',
                'circle-triangle',
                'triangle-cross',
                'triangle-backcurve',
                'vee',
                'square',
                'circle',
                'diamond',
                'chevron',
                'none'
            ]
        },
        arrowFill: {
            enums: [
                'filled',
                'hollow'
            ]
        },
        arrowWidth: {
            number: true,
            units: '%|px|em',
            implicitUnits: 'px',
            enums: [
                'match-line'
            ]
        },
        display: {
            enums: [
                'element',
                'none'
            ]
        },
        visibility: {
            enums: [
                'hidden',
                'visible'
            ]
        },
        zCompoundDepth: {
            enums: [
                'bottom',
                'orphan',
                'auto',
                'top'
            ]
        },
        zIndexCompare: {
            enums: [
                'auto',
                'manual'
            ]
        },
        valign: {
            enums: [
                'top',
                'center',
                'bottom'
            ]
        },
        halign: {
            enums: [
                'left',
                'center',
                'right'
            ]
        },
        justification: {
            enums: [
                'left',
                'center',
                'right',
                'auto'
            ]
        },
        text: {
            string: true
        },
        data: {
            mapping: true,
            regex: data('data')
        },
        layoutData: {
            mapping: true,
            regex: data('layoutData')
        },
        scratch: {
            mapping: true,
            regex: data('scratch')
        },
        mapData: {
            mapping: true,
            regex: mapData('mapData')
        },
        mapLayoutData: {
            mapping: true,
            regex: mapData('mapLayoutData')
        },
        mapScratch: {
            mapping: true,
            regex: mapData('mapScratch')
        },
        fn: {
            mapping: true,
            fn: true
        },
        url: {
            regexes: urlRegexes,
            singleRegexMatchValue: true
        },
        urls: {
            regexes: urlRegexes,
            singleRegexMatchValue: true,
            multiple: true
        },
        propList: {
            propList: true
        },
        angle: {
            number: true,
            units: 'deg|rad',
            implicitUnits: 'rad'
        },
        textRotation: {
            number: true,
            units: 'deg|rad',
            implicitUnits: 'rad',
            enums: [
                'none',
                'autorotate'
            ]
        },
        polygonPointList: {
            number: true,
            multiple: true,
            evenMultiple: true,
            min: -1,
            max: 1,
            unitless: true
        },
        edgeDistances: {
            enums: [
                'intersection',
                'node-position',
                'endpoints'
            ]
        },
        edgeEndpoint: {
            number: true,
            multiple: true,
            units: '%|px|em|deg|rad',
            implicitUnits: 'px',
            enums: [
                'inside-to-node',
                'outside-to-node',
                'outside-to-node-or-label',
                'outside-to-line',
                'outside-to-line-or-label'
            ],
            singleEnum: true,
            validate: function validate(valArr, unitsArr) {
                switch(valArr.length){
                    case 2:
                        // can be % or px only
                        return unitsArr[0] !== 'deg' && unitsArr[0] !== 'rad' && unitsArr[1] !== 'deg' && unitsArr[1] !== 'rad';
                    case 1:
                        // can be enum, deg, or rad only
                        return $e815fda779bc047b$var$string(valArr[0]) || unitsArr[0] === 'deg' || unitsArr[0] === 'rad';
                    default:
                        return false;
                }
            }
        },
        easing: {
            regexes: [
                '^(spring)\\s*\\(\\s*(' + number$1 + ')\\s*,\\s*(' + number$1 + ')\\s*\\)$',
                '^(cubic-bezier)\\s*\\(\\s*(' + number$1 + ')\\s*,\\s*(' + number$1 + ')\\s*,\\s*(' + number$1 + ')\\s*,\\s*(' + number$1 + ')\\s*\\)$'
            ],
            enums: [
                'linear',
                'ease',
                'ease-in',
                'ease-out',
                'ease-in-out',
                'ease-in-sine',
                'ease-out-sine',
                'ease-in-out-sine',
                'ease-in-quad',
                'ease-out-quad',
                'ease-in-out-quad',
                'ease-in-cubic',
                'ease-out-cubic',
                'ease-in-out-cubic',
                'ease-in-quart',
                'ease-out-quart',
                'ease-in-out-quart',
                'ease-in-quint',
                'ease-out-quint',
                'ease-in-out-quint',
                'ease-in-expo',
                'ease-out-expo',
                'ease-in-out-expo',
                'ease-in-circ',
                'ease-out-circ',
                'ease-in-out-circ'
            ]
        },
        gradientDirection: {
            enums: [
                'to-bottom',
                'to-top',
                'to-left',
                'to-right',
                'to-bottom-right',
                'to-bottom-left',
                'to-top-right',
                'to-top-left',
                'to-right-bottom',
                'to-left-bottom',
                'to-right-top',
                'to-left-top' // different order
            ]
        },
        boundsExpansion: {
            number: true,
            multiple: true,
            min: 0,
            validate: function validate(valArr) {
                var length = valArr.length;
                return length === 1 || length === 2 || length === 4;
            }
        }
    };
    var diff = {
        zeroNonZero: function zeroNonZero(val1, val2) {
            if ((val1 == null || val2 == null) && val1 !== val2) return true; // null cases could represent any value
            if (val1 == 0 && val2 != 0) return true;
            else if (val1 != 0 && val2 == 0) return true;
            else return false;
        },
        any: function any(val1, val2) {
            return val1 != val2;
        },
        emptyNonEmpty: function emptyNonEmpty(str1, str2) {
            var empty1 = $e815fda779bc047b$var$emptyString(str1);
            var empty2 = $e815fda779bc047b$var$emptyString(str2);
            return empty1 && !empty2 || !empty1 && empty2;
        }
    };
    // define visual style properties
    //
    // - n.b. adding a new group of props may require updates to updateStyleHints()
    // - adding new props to an existing group gets handled automatically
    var t = $e815fda779bc047b$var$styfn$2.types;
    var mainLabel = [
        {
            name: 'label',
            type: t.text,
            triggersBounds: diff.any,
            triggersZOrder: diff.emptyNonEmpty
        },
        {
            name: 'text-rotation',
            type: t.textRotation,
            triggersBounds: diff.any
        },
        {
            name: 'text-margin-x',
            type: t.bidirectionalSize,
            triggersBounds: diff.any
        },
        {
            name: 'text-margin-y',
            type: t.bidirectionalSize,
            triggersBounds: diff.any
        }
    ];
    var sourceLabel = [
        {
            name: 'source-label',
            type: t.text,
            triggersBounds: diff.any
        },
        {
            name: 'source-text-rotation',
            type: t.textRotation,
            triggersBounds: diff.any
        },
        {
            name: 'source-text-margin-x',
            type: t.bidirectionalSize,
            triggersBounds: diff.any
        },
        {
            name: 'source-text-margin-y',
            type: t.bidirectionalSize,
            triggersBounds: diff.any
        },
        {
            name: 'source-text-offset',
            type: t.size,
            triggersBounds: diff.any
        }
    ];
    var targetLabel = [
        {
            name: 'target-label',
            type: t.text,
            triggersBounds: diff.any
        },
        {
            name: 'target-text-rotation',
            type: t.textRotation,
            triggersBounds: diff.any
        },
        {
            name: 'target-text-margin-x',
            type: t.bidirectionalSize,
            triggersBounds: diff.any
        },
        {
            name: 'target-text-margin-y',
            type: t.bidirectionalSize,
            triggersBounds: diff.any
        },
        {
            name: 'target-text-offset',
            type: t.size,
            triggersBounds: diff.any
        }
    ];
    var labelDimensions = [
        {
            name: 'font-family',
            type: t.fontFamily,
            triggersBounds: diff.any
        },
        {
            name: 'font-style',
            type: t.fontStyle,
            triggersBounds: diff.any
        },
        {
            name: 'font-weight',
            type: t.fontWeight,
            triggersBounds: diff.any
        },
        {
            name: 'font-size',
            type: t.size,
            triggersBounds: diff.any
        },
        {
            name: 'text-transform',
            type: t.textTransform,
            triggersBounds: diff.any
        },
        {
            name: 'text-wrap',
            type: t.textWrap,
            triggersBounds: diff.any
        },
        {
            name: 'text-overflow-wrap',
            type: t.textOverflowWrap,
            triggersBounds: diff.any
        },
        {
            name: 'text-max-width',
            type: t.size,
            triggersBounds: diff.any
        },
        {
            name: 'text-outline-width',
            type: t.size,
            triggersBounds: diff.any
        },
        {
            name: 'line-height',
            type: t.positiveNumber,
            triggersBounds: diff.any
        }
    ];
    var commonLabel = [
        {
            name: 'text-valign',
            type: t.valign,
            triggersBounds: diff.any
        },
        {
            name: 'text-halign',
            type: t.halign,
            triggersBounds: diff.any
        },
        {
            name: 'color',
            type: t.color
        },
        {
            name: 'text-outline-color',
            type: t.color
        },
        {
            name: 'text-outline-opacity',
            type: t.zeroOneNumber
        },
        {
            name: 'text-background-color',
            type: t.color
        },
        {
            name: 'text-background-opacity',
            type: t.zeroOneNumber
        },
        {
            name: 'text-background-padding',
            type: t.size,
            triggersBounds: diff.any
        },
        {
            name: 'text-border-opacity',
            type: t.zeroOneNumber
        },
        {
            name: 'text-border-color',
            type: t.color
        },
        {
            name: 'text-border-width',
            type: t.size,
            triggersBounds: diff.any
        },
        {
            name: 'text-border-style',
            type: t.borderStyle,
            triggersBounds: diff.any
        },
        {
            name: 'text-background-shape',
            type: t.textBackgroundShape,
            triggersBounds: diff.any
        },
        {
            name: 'text-justification',
            type: t.justification
        },
        {
            name: 'box-select-labels',
            type: t.bool,
            triggersBounds: diff.any
        }
    ];
    var behavior = [
        {
            name: 'events',
            type: t.bool,
            triggersZOrder: diff.any
        },
        {
            name: 'text-events',
            type: t.bool,
            triggersZOrder: diff.any
        },
        {
            name: 'box-selection',
            type: t.boxSelection,
            triggersZOrder: diff.any
        }
    ];
    var visibility = [
        {
            name: 'display',
            type: t.display,
            triggersZOrder: diff.any,
            triggersBounds: diff.any,
            triggersBoundsOfConnectedEdges: diff.any,
            triggersBoundsOfParallelEdges: function triggersBoundsOfParallelEdges(fromValue, toValue, ele) {
                if (fromValue === toValue) return false;
                // only if edge is bundled bezier (so as not to affect performance of other edges)
                return ele.pstyle('curve-style').value === 'bezier';
            }
        },
        {
            name: 'visibility',
            type: t.visibility,
            triggersZOrder: diff.any
        },
        {
            name: 'opacity',
            type: t.zeroOneNumber,
            triggersZOrder: diff.zeroNonZero
        },
        {
            name: 'text-opacity',
            type: t.zeroOneNumber
        },
        {
            name: 'min-zoomed-font-size',
            type: t.size
        },
        {
            name: 'z-compound-depth',
            type: t.zCompoundDepth,
            triggersZOrder: diff.any
        },
        {
            name: 'z-index-compare',
            type: t.zIndexCompare,
            triggersZOrder: diff.any
        },
        {
            name: 'z-index',
            type: t.number,
            triggersZOrder: diff.any
        }
    ];
    var overlay = [
        {
            name: 'overlay-padding',
            type: t.size,
            triggersBounds: diff.any
        },
        {
            name: 'overlay-color',
            type: t.color
        },
        {
            name: 'overlay-opacity',
            type: t.zeroOneNumber,
            triggersBounds: diff.zeroNonZero
        },
        {
            name: 'overlay-shape',
            type: t.overlayShape,
            triggersBounds: diff.any
        },
        {
            name: 'overlay-corner-radius',
            type: t.cornerRadius
        }
    ];
    var underlay = [
        {
            name: 'underlay-padding',
            type: t.size,
            triggersBounds: diff.any
        },
        {
            name: 'underlay-color',
            type: t.color
        },
        {
            name: 'underlay-opacity',
            type: t.zeroOneNumber,
            triggersBounds: diff.zeroNonZero
        },
        {
            name: 'underlay-shape',
            type: t.overlayShape,
            triggersBounds: diff.any
        },
        {
            name: 'underlay-corner-radius',
            type: t.cornerRadius
        }
    ];
    var transition = [
        {
            name: 'transition-property',
            type: t.propList
        },
        {
            name: 'transition-duration',
            type: t.time
        },
        {
            name: 'transition-delay',
            type: t.time
        },
        {
            name: 'transition-timing-function',
            type: t.easing
        }
    ];
    var nodeSizeHashOverride = function nodeSizeHashOverride(ele, parsedProp) {
        if (parsedProp.value === 'label') return -ele.poolIndex(); // no hash key hits is using label size (hitrate for perf probably low anyway)
        else return parsedProp.pfValue;
    };
    var nodeBody = [
        {
            name: 'height',
            type: t.nodeSize,
            triggersBounds: diff.any,
            hashOverride: nodeSizeHashOverride
        },
        {
            name: 'width',
            type: t.nodeSize,
            triggersBounds: diff.any,
            hashOverride: nodeSizeHashOverride
        },
        {
            name: 'shape',
            type: t.nodeShape,
            triggersBounds: diff.any
        },
        {
            name: 'shape-polygon-points',
            type: t.polygonPointList,
            triggersBounds: diff.any
        },
        {
            name: 'corner-radius',
            type: t.cornerRadius
        },
        {
            name: 'background-color',
            type: t.color
        },
        {
            name: 'background-fill',
            type: t.fill
        },
        {
            name: 'background-opacity',
            type: t.zeroOneNumber
        },
        {
            name: 'background-blacken',
            type: t.nOneOneNumber
        },
        {
            name: 'background-gradient-stop-colors',
            type: t.colors
        },
        {
            name: 'background-gradient-stop-positions',
            type: t.percentages
        },
        {
            name: 'background-gradient-direction',
            type: t.gradientDirection
        },
        {
            name: 'padding',
            type: t.sizeMaybePercent,
            triggersBounds: diff.any
        },
        {
            name: 'padding-relative-to',
            type: t.paddingRelativeTo,
            triggersBounds: diff.any
        },
        {
            name: 'bounds-expansion',
            type: t.boundsExpansion,
            triggersBounds: diff.any
        }
    ];
    var nodeBorder = [
        {
            name: 'border-color',
            type: t.color
        },
        {
            name: 'border-opacity',
            type: t.zeroOneNumber
        },
        {
            name: 'border-width',
            type: t.size,
            triggersBounds: diff.any
        },
        {
            name: 'border-style',
            type: t.borderStyle
        },
        {
            name: 'border-cap',
            type: t.lineCap
        },
        {
            name: 'border-join',
            type: t.lineJoin
        },
        {
            name: 'border-dash-pattern',
            type: t.numbers
        },
        {
            name: 'border-dash-offset',
            type: t.number
        },
        {
            name: 'border-position',
            type: t.linePosition
        }
    ];
    var nodeOutline = [
        {
            name: 'outline-color',
            type: t.color
        },
        {
            name: 'outline-opacity',
            type: t.zeroOneNumber
        },
        {
            name: 'outline-width',
            type: t.size,
            triggersBounds: diff.any
        },
        {
            name: 'outline-style',
            type: t.borderStyle
        },
        {
            name: 'outline-offset',
            type: t.size,
            triggersBounds: diff.any
        }
    ];
    var backgroundImage = [
        {
            name: 'background-image',
            type: t.urls
        },
        {
            name: 'background-image-crossorigin',
            type: t.bgCrossOrigin
        },
        {
            name: 'background-image-opacity',
            type: t.zeroOneNumbers
        },
        {
            name: 'background-image-containment',
            type: t.bgContainment
        },
        {
            name: 'background-image-smoothing',
            type: t.bools
        },
        {
            name: 'background-position-x',
            type: t.bgPos
        },
        {
            name: 'background-position-y',
            type: t.bgPos
        },
        {
            name: 'background-width-relative-to',
            type: t.bgRelativeTo
        },
        {
            name: 'background-height-relative-to',
            type: t.bgRelativeTo
        },
        {
            name: 'background-repeat',
            type: t.bgRepeat
        },
        {
            name: 'background-fit',
            type: t.bgFit
        },
        {
            name: 'background-clip',
            type: t.bgClip
        },
        {
            name: 'background-width',
            type: t.bgWH
        },
        {
            name: 'background-height',
            type: t.bgWH
        },
        {
            name: 'background-offset-x',
            type: t.bgPos
        },
        {
            name: 'background-offset-y',
            type: t.bgPos
        }
    ];
    var compound = [
        {
            name: 'position',
            type: t.position,
            triggersBounds: diff.any
        },
        {
            name: 'compound-sizing-wrt-labels',
            type: t.compoundIncludeLabels,
            triggersBounds: diff.any
        },
        {
            name: 'min-width',
            type: t.size,
            triggersBounds: diff.any
        },
        {
            name: 'min-width-bias-left',
            type: t.sizeMaybePercent,
            triggersBounds: diff.any
        },
        {
            name: 'min-width-bias-right',
            type: t.sizeMaybePercent,
            triggersBounds: diff.any
        },
        {
            name: 'min-height',
            type: t.size,
            triggersBounds: diff.any
        },
        {
            name: 'min-height-bias-top',
            type: t.sizeMaybePercent,
            triggersBounds: diff.any
        },
        {
            name: 'min-height-bias-bottom',
            type: t.sizeMaybePercent,
            triggersBounds: diff.any
        }
    ];
    var edgeLine = [
        {
            name: 'line-style',
            type: t.lineStyle
        },
        {
            name: 'line-color',
            type: t.color
        },
        {
            name: 'line-fill',
            type: t.fill
        },
        {
            name: 'line-cap',
            type: t.lineCap
        },
        {
            name: 'line-opacity',
            type: t.zeroOneNumber
        },
        {
            name: 'line-dash-pattern',
            type: t.numbers
        },
        {
            name: 'line-dash-offset',
            type: t.number
        },
        {
            name: 'line-outline-width',
            type: t.size
        },
        {
            name: 'line-outline-color',
            type: t.color
        },
        {
            name: 'line-gradient-stop-colors',
            type: t.colors
        },
        {
            name: 'line-gradient-stop-positions',
            type: t.percentages
        },
        {
            name: 'curve-style',
            type: t.curveStyle,
            triggersBounds: diff.any,
            triggersBoundsOfParallelEdges: function triggersBoundsOfParallelEdges(fromValue, toValue) {
                if (fromValue === toValue) return false;
                 // must have diff
                return fromValue === 'bezier' || // remove from bundle
                toValue === 'bezier'; // add to bundle
            }
        },
        {
            name: 'haystack-radius',
            type: t.zeroOneNumber,
            triggersBounds: diff.any
        },
        {
            name: 'source-endpoint',
            type: t.edgeEndpoint,
            triggersBounds: diff.any
        },
        {
            name: 'target-endpoint',
            type: t.edgeEndpoint,
            triggersBounds: diff.any
        },
        {
            name: 'control-point-step-size',
            type: t.size,
            triggersBounds: diff.any
        },
        {
            name: 'control-point-distances',
            type: t.bidirectionalSizes,
            triggersBounds: diff.any
        },
        {
            name: 'control-point-weights',
            type: t.numbers,
            triggersBounds: diff.any
        },
        {
            name: 'segment-distances',
            type: t.bidirectionalSizes,
            triggersBounds: diff.any
        },
        {
            name: 'segment-weights',
            type: t.numbers,
            triggersBounds: diff.any
        },
        {
            name: 'segment-radii',
            type: t.numbers,
            triggersBounds: diff.any
        },
        {
            name: 'radius-type',
            type: t.radiusType,
            triggersBounds: diff.any
        },
        {
            name: 'taxi-turn',
            type: t.bidirectionalSizeMaybePercent,
            triggersBounds: diff.any
        },
        {
            name: 'taxi-turn-min-distance',
            type: t.size,
            triggersBounds: diff.any
        },
        {
            name: 'taxi-direction',
            type: t.axisDirection,
            triggersBounds: diff.any
        },
        {
            name: 'taxi-radius',
            type: t.number,
            triggersBounds: diff.any
        },
        {
            name: 'edge-distances',
            type: t.edgeDistances,
            triggersBounds: diff.any
        },
        {
            name: 'arrow-scale',
            type: t.positiveNumber,
            triggersBounds: diff.any
        },
        {
            name: 'loop-direction',
            type: t.angle,
            triggersBounds: diff.any
        },
        {
            name: 'loop-sweep',
            type: t.angle,
            triggersBounds: diff.any
        },
        {
            name: 'source-distance-from-node',
            type: t.size,
            triggersBounds: diff.any
        },
        {
            name: 'target-distance-from-node',
            type: t.size,
            triggersBounds: diff.any
        }
    ];
    var ghost = [
        {
            name: 'ghost',
            type: t.bool,
            triggersBounds: diff.any
        },
        {
            name: 'ghost-offset-x',
            type: t.bidirectionalSize,
            triggersBounds: diff.any
        },
        {
            name: 'ghost-offset-y',
            type: t.bidirectionalSize,
            triggersBounds: diff.any
        },
        {
            name: 'ghost-opacity',
            type: t.zeroOneNumber
        }
    ];
    var core = [
        {
            name: 'selection-box-color',
            type: t.color
        },
        {
            name: 'selection-box-opacity',
            type: t.zeroOneNumber
        },
        {
            name: 'selection-box-border-color',
            type: t.color
        },
        {
            name: 'selection-box-border-width',
            type: t.size
        },
        {
            name: 'active-bg-color',
            type: t.color
        },
        {
            name: 'active-bg-opacity',
            type: t.zeroOneNumber
        },
        {
            name: 'active-bg-size',
            type: t.size
        },
        {
            name: 'outside-texture-bg-color',
            type: t.color
        },
        {
            name: 'outside-texture-bg-opacity',
            type: t.zeroOneNumber
        }
    ];
    // pie backgrounds for nodes
    var pie = [];
    $e815fda779bc047b$var$styfn$2.pieBackgroundN = 16; // because the pie properties are numbered, give access to a constant N (for renderer use)
    pie.push({
        name: 'pie-size',
        type: t.sizeMaybePercent
    });
    pie.push({
        name: 'pie-hole',
        type: t.sizeMaybePercent
    });
    pie.push({
        name: 'pie-start-angle',
        type: t.angle
    });
    for(var i = 1; i <= $e815fda779bc047b$var$styfn$2.pieBackgroundN; i++){
        pie.push({
            name: 'pie-' + i + '-background-color',
            type: t.color
        });
        pie.push({
            name: 'pie-' + i + '-background-size',
            type: t.percent
        });
        pie.push({
            name: 'pie-' + i + '-background-opacity',
            type: t.zeroOneNumber
        });
    }
    // stripe backgrounds for nodes
    var stripe = [];
    $e815fda779bc047b$var$styfn$2.stripeBackgroundN = 16; // because the stripe properties are numbered, give access to a constant N (for renderer use)
    stripe.push({
        name: 'stripe-size',
        type: t.sizeMaybePercent
    });
    stripe.push({
        name: 'stripe-direction',
        type: t.axisDirectionPrimary
    });
    for(var _i = 1; _i <= $e815fda779bc047b$var$styfn$2.stripeBackgroundN; _i++){
        stripe.push({
            name: 'stripe-' + _i + '-background-color',
            type: t.color
        });
        stripe.push({
            name: 'stripe-' + _i + '-background-size',
            type: t.percent
        });
        stripe.push({
            name: 'stripe-' + _i + '-background-opacity',
            type: t.zeroOneNumber
        });
    }
    // edge arrows
    var edgeArrow = [];
    var arrowPrefixes = $e815fda779bc047b$var$styfn$2.arrowPrefixes = [
        'source',
        'mid-source',
        'target',
        'mid-target'
    ];
    [
        {
            name: 'arrow-shape',
            type: t.arrowShape,
            triggersBounds: diff.any
        },
        {
            name: 'arrow-color',
            type: t.color
        },
        {
            name: 'arrow-fill',
            type: t.arrowFill
        },
        {
            name: 'arrow-width',
            type: t.arrowWidth
        }
    ].forEach(function(prop) {
        arrowPrefixes.forEach(function(prefix) {
            var name = prefix + '-' + prop.name;
            var type = prop.type, triggersBounds = prop.triggersBounds;
            edgeArrow.push({
                name: name,
                type: type,
                triggersBounds: triggersBounds
            });
        });
    }, {});
    var props = $e815fda779bc047b$var$styfn$2.properties = [].concat(behavior, transition, visibility, overlay, underlay, ghost, commonLabel, labelDimensions, mainLabel, sourceLabel, targetLabel, nodeBody, nodeBorder, nodeOutline, backgroundImage, pie, stripe, compound, edgeLine, edgeArrow, core);
    var propGroups = $e815fda779bc047b$var$styfn$2.propertyGroups = {
        // common to all eles
        behavior: behavior,
        transition: transition,
        visibility: visibility,
        overlay: overlay,
        underlay: underlay,
        ghost: ghost,
        // labels
        commonLabel: commonLabel,
        labelDimensions: labelDimensions,
        mainLabel: mainLabel,
        sourceLabel: sourceLabel,
        targetLabel: targetLabel,
        // node props
        nodeBody: nodeBody,
        nodeBorder: nodeBorder,
        nodeOutline: nodeOutline,
        backgroundImage: backgroundImage,
        pie: pie,
        stripe: stripe,
        compound: compound,
        // edge props
        edgeLine: edgeLine,
        edgeArrow: edgeArrow,
        core: core
    };
    var propGroupNames = $e815fda779bc047b$var$styfn$2.propertyGroupNames = {};
    var propGroupKeys = $e815fda779bc047b$var$styfn$2.propertyGroupKeys = Object.keys(propGroups);
    propGroupKeys.forEach(function(key) {
        propGroupNames[key] = propGroups[key].map(function(prop) {
            return prop.name;
        });
        propGroups[key].forEach(function(prop) {
            return prop.groupKey = key;
        });
    });
    // define aliases
    var aliases = $e815fda779bc047b$var$styfn$2.aliases = [
        {
            name: 'content',
            pointsTo: 'label'
        },
        {
            name: 'control-point-distance',
            pointsTo: 'control-point-distances'
        },
        {
            name: 'control-point-weight',
            pointsTo: 'control-point-weights'
        },
        {
            name: 'segment-distance',
            pointsTo: 'segment-distances'
        },
        {
            name: 'segment-weight',
            pointsTo: 'segment-weights'
        },
        {
            name: 'segment-radius',
            pointsTo: 'segment-radii'
        },
        {
            name: 'edge-text-rotation',
            pointsTo: 'text-rotation'
        },
        {
            name: 'padding-left',
            pointsTo: 'padding'
        },
        {
            name: 'padding-right',
            pointsTo: 'padding'
        },
        {
            name: 'padding-top',
            pointsTo: 'padding'
        },
        {
            name: 'padding-bottom',
            pointsTo: 'padding'
        }
    ];
    // list of property names
    $e815fda779bc047b$var$styfn$2.propertyNames = props.map(function(p) {
        return p.name;
    });
    // allow access of properties by name ( e.g. style.properties.height )
    for(var _i2 = 0; _i2 < props.length; _i2++){
        var prop = props[_i2];
        props[prop.name] = prop; // allow lookup by name
    }
    // map aliases
    for(var _i3 = 0; _i3 < aliases.length; _i3++){
        var alias = aliases[_i3];
        var pointsToProp = props[alias.pointsTo];
        var aliasProp = {
            name: alias.name,
            alias: true,
            pointsTo: pointsToProp
        };
        // add alias prop for parsing
        props.push(aliasProp);
        props[alias.name] = aliasProp; // allow lookup by name
    }
})();
$e815fda779bc047b$var$styfn$2.getDefaultProperty = function(name) {
    return this.getDefaultProperties()[name];
};
$e815fda779bc047b$var$styfn$2.getDefaultProperties = function() {
    var _p = this._private;
    if (_p.defaultProperties != null) return _p.defaultProperties;
    var rawProps = $e815fda779bc047b$var$extend({
        // core props
        'selection-box-color': '#ddd',
        'selection-box-opacity': 0.65,
        'selection-box-border-color': '#aaa',
        'selection-box-border-width': 1,
        'active-bg-color': 'black',
        'active-bg-opacity': 0.15,
        'active-bg-size': 30,
        'outside-texture-bg-color': '#000',
        'outside-texture-bg-opacity': 0.125,
        // common node/edge props
        'events': 'yes',
        'text-events': 'no',
        'text-valign': 'top',
        'text-halign': 'center',
        'text-justification': 'auto',
        'line-height': 1,
        'color': '#000',
        'box-selection': 'contain',
        'text-outline-color': '#000',
        'text-outline-width': 0,
        'text-outline-opacity': 1,
        'text-opacity': 1,
        'text-decoration': 'none',
        'text-transform': 'none',
        'text-wrap': 'none',
        'text-overflow-wrap': 'whitespace',
        'text-max-width': 9999,
        'text-background-color': '#000',
        'text-background-opacity': 0,
        'text-background-shape': 'rectangle',
        'text-background-padding': 0,
        'text-border-opacity': 0,
        'text-border-width': 0,
        'text-border-style': 'solid',
        'text-border-color': '#000',
        'font-family': 'Helvetica Neue, Helvetica, sans-serif',
        'font-style': 'normal',
        'font-weight': 'normal',
        'font-size': 16,
        'min-zoomed-font-size': 0,
        'text-rotation': 'none',
        'source-text-rotation': 'none',
        'target-text-rotation': 'none',
        'visibility': 'visible',
        'display': 'element',
        'opacity': 1,
        'z-compound-depth': 'auto',
        'z-index-compare': 'auto',
        'z-index': 0,
        'label': '',
        'text-margin-x': 0,
        'text-margin-y': 0,
        'source-label': '',
        'source-text-offset': 0,
        'source-text-margin-x': 0,
        'source-text-margin-y': 0,
        'target-label': '',
        'target-text-offset': 0,
        'target-text-margin-x': 0,
        'target-text-margin-y': 0,
        'overlay-opacity': 0,
        'overlay-color': '#000',
        'overlay-padding': 10,
        'overlay-shape': 'round-rectangle',
        'overlay-corner-radius': 'auto',
        'underlay-opacity': 0,
        'underlay-color': '#000',
        'underlay-padding': 10,
        'underlay-shape': 'round-rectangle',
        'underlay-corner-radius': 'auto',
        'transition-property': 'none',
        'transition-duration': 0,
        'transition-delay': 0,
        'transition-timing-function': 'linear',
        'box-select-labels': 'no',
        // node props
        'background-blacken': 0,
        'background-color': '#999',
        'background-fill': 'solid',
        'background-opacity': 1,
        'background-image': 'none',
        'background-image-crossorigin': 'anonymous',
        'background-image-opacity': 1,
        'background-image-containment': 'inside',
        'background-image-smoothing': 'yes',
        'background-position-x': '50%',
        'background-position-y': '50%',
        'background-offset-x': 0,
        'background-offset-y': 0,
        'background-width-relative-to': 'include-padding',
        'background-height-relative-to': 'include-padding',
        'background-repeat': 'no-repeat',
        'background-fit': 'none',
        'background-clip': 'node',
        'background-width': 'auto',
        'background-height': 'auto',
        'border-color': '#000',
        'border-opacity': 1,
        'border-width': 0,
        'border-style': 'solid',
        'border-dash-pattern': [
            4,
            2
        ],
        'border-dash-offset': 0,
        'border-cap': 'butt',
        'border-join': 'miter',
        'border-position': 'center',
        'outline-color': '#999',
        'outline-opacity': 1,
        'outline-width': 0,
        'outline-offset': 0,
        'outline-style': 'solid',
        'height': 30,
        'width': 30,
        'shape': 'ellipse',
        'shape-polygon-points': '-1, -1,   1, -1,   1, 1,   -1, 1',
        'corner-radius': 'auto',
        'bounds-expansion': 0,
        // node gradient
        'background-gradient-direction': 'to-bottom',
        'background-gradient-stop-colors': '#999',
        'background-gradient-stop-positions': '0%',
        // ghost props
        'ghost': 'no',
        'ghost-offset-y': 0,
        'ghost-offset-x': 0,
        'ghost-opacity': 0,
        // compound props
        'padding': 0,
        'padding-relative-to': 'width',
        'position': 'origin',
        'compound-sizing-wrt-labels': 'include',
        'min-width': 0,
        'min-width-bias-left': 0,
        'min-width-bias-right': 0,
        'min-height': 0,
        'min-height-bias-top': 0,
        'min-height-bias-bottom': 0
    }, {
        // node pie bg
        'pie-size': '100%',
        'pie-hole': 0,
        'pie-start-angle': '0deg'
    }, [
        {
            name: 'pie-{{i}}-background-color',
            value: 'black'
        },
        {
            name: 'pie-{{i}}-background-size',
            value: '0%'
        },
        {
            name: 'pie-{{i}}-background-opacity',
            value: 1
        }
    ].reduce(function(css, prop) {
        for(var i = 1; i <= $e815fda779bc047b$var$styfn$2.pieBackgroundN; i++){
            var name = prop.name.replace('{{i}}', i);
            var val = prop.value;
            css[name] = val;
        }
        return css;
    }, {}), {
        // node stripes bg
        'stripe-size': '100%',
        'stripe-direction': 'horizontal'
    }, [
        {
            name: 'stripe-{{i}}-background-color',
            value: 'black'
        },
        {
            name: 'stripe-{{i}}-background-size',
            value: '0%'
        },
        {
            name: 'stripe-{{i}}-background-opacity',
            value: 1
        }
    ].reduce(function(css, prop) {
        for(var i = 1; i <= $e815fda779bc047b$var$styfn$2.stripeBackgroundN; i++){
            var name = prop.name.replace('{{i}}', i);
            var val = prop.value;
            css[name] = val;
        }
        return css;
    }, {}), {
        // edge props
        'line-style': 'solid',
        'line-color': '#999',
        'line-fill': 'solid',
        'line-cap': 'butt',
        'line-opacity': 1,
        'line-outline-width': 0,
        'line-outline-color': '#000',
        'line-gradient-stop-colors': '#999',
        'line-gradient-stop-positions': '0%',
        'control-point-step-size': 40,
        'control-point-weights': 0.5,
        'segment-weights': 0.5,
        'segment-distances': 20,
        'segment-radii': 15,
        'radius-type': 'arc-radius',
        'taxi-turn': '50%',
        'taxi-radius': 15,
        'taxi-turn-min-distance': 10,
        'taxi-direction': 'auto',
        'edge-distances': 'intersection',
        'curve-style': 'haystack',
        'haystack-radius': 0,
        'arrow-scale': 1,
        'loop-direction': '-45deg',
        'loop-sweep': '-90deg',
        'source-distance-from-node': 0,
        'target-distance-from-node': 0,
        'source-endpoint': 'outside-to-node',
        'target-endpoint': 'outside-to-node',
        'line-dash-pattern': [
            6,
            3
        ],
        'line-dash-offset': 0
    }, [
        {
            name: 'arrow-shape',
            value: 'none'
        },
        {
            name: 'arrow-color',
            value: '#999'
        },
        {
            name: 'arrow-fill',
            value: 'filled'
        },
        {
            name: 'arrow-width',
            value: 1
        }
    ].reduce(function(css, prop) {
        $e815fda779bc047b$var$styfn$2.arrowPrefixes.forEach(function(prefix) {
            var name = prefix + '-' + prop.name;
            var val = prop.value;
            css[name] = val;
        });
        return css;
    }, {}));
    var parsedProps = {};
    for(var i = 0; i < this.properties.length; i++){
        var prop = this.properties[i];
        if (prop.pointsTo) continue;
        var name = prop.name;
        var val = rawProps[name];
        var parsedProp = this.parse(name, val);
        parsedProps[name] = parsedProp;
    }
    _p.defaultProperties = parsedProps;
    return _p.defaultProperties;
};
$e815fda779bc047b$var$styfn$2.addDefaultStylesheet = function() {
    this.selector(':parent').css({
        'shape': 'rectangle',
        'padding': 10,
        'background-color': '#eee',
        'border-color': '#ccc',
        'border-width': 1
    }).selector('edge').css({
        'width': 3
    }).selector(':loop').css({
        'curve-style': 'bezier'
    }).selector('edge:compound').css({
        'curve-style': 'bezier',
        'source-endpoint': 'outside-to-line',
        'target-endpoint': 'outside-to-line'
    }).selector(':selected').css({
        'background-color': '#0169D9',
        'line-color': '#0169D9',
        'source-arrow-color': '#0169D9',
        'target-arrow-color': '#0169D9',
        'mid-source-arrow-color': '#0169D9',
        'mid-target-arrow-color': '#0169D9'
    }).selector(':parent:selected').css({
        'background-color': '#CCE1F9',
        'border-color': '#aec8e5'
    }).selector(':active').css({
        'overlay-color': 'black',
        'overlay-padding': 10,
        'overlay-opacity': 0.25
    });
    this.defaultLength = this.length;
};
var $e815fda779bc047b$var$styfn$1 = {};
// a caching layer for property parsing
$e815fda779bc047b$var$styfn$1.parse = function(name, value, propIsBypass, propIsFlat) {
    var self1 = this;
    // function values can't be cached in all cases, and there isn't much benefit of caching them anyway
    if ($e815fda779bc047b$var$fn$6(value)) return self1.parseImplWarn(name, value, propIsBypass, propIsFlat);
    var flatKey = propIsFlat === 'mapping' || propIsFlat === true || propIsFlat === false || propIsFlat == null ? 'dontcare' : propIsFlat;
    var bypassKey = propIsBypass ? 't' : 'f';
    var valueKey = '' + value;
    var argHash = $e815fda779bc047b$var$hashStrings(name, valueKey, bypassKey, flatKey);
    var propCache = self1.propCache = self1.propCache || [];
    var ret;
    if (!(ret = propCache[argHash])) ret = propCache[argHash] = self1.parseImplWarn(name, value, propIsBypass, propIsFlat);
    // - bypasses can't be shared b/c the value can be changed by animations or otherwise overridden
    // - mappings can't be shared b/c mappings are per-element
    if (propIsBypass || propIsFlat === 'mapping') {
        // need a copy since props are mutated later in their lifecycles
        ret = $e815fda779bc047b$var$copy(ret);
        if (ret) ret.value = $e815fda779bc047b$var$copy(ret.value); // because it could be an array, e.g. colour
    }
    return ret;
};
$e815fda779bc047b$var$styfn$1.parseImplWarn = function(name, value, propIsBypass, propIsFlat) {
    var prop = this.parseImpl(name, value, propIsBypass, propIsFlat);
    if (!prop && value != null) $e815fda779bc047b$var$warn("The style property `".concat(name, ": ").concat(value, "` is invalid"));
    if (prop && (prop.name === 'width' || prop.name === 'height') && value === 'label') $e815fda779bc047b$var$warn('The style value of `label` is deprecated for `' + prop.name + '`');
    return prop;
};
// parse a property; return null on invalid; return parsed property otherwise
// fields :
// - name : the name of the property
// - value : the parsed, native-typed value of the property
// - strValue : a string value that represents the property value in valid css
// - bypass : true iff the property is a bypass property
$e815fda779bc047b$var$styfn$1.parseImpl = function(name, value, propIsBypass, propIsFlat) {
    var self1 = this;
    name = $e815fda779bc047b$var$camel2dash(name); // make sure the property name is in dash form (e.g. 'property-name' not 'propertyName')
    var property = self1.properties[name];
    var passedValue = value;
    var types = self1.types;
    if (!property) return null;
     // return null on property of unknown name
    if (value === undefined) return null;
     // can't assign undefined
    // the property may be an alias
    if (property.alias) {
        property = property.pointsTo;
        name = property.name;
    }
    var valueIsString = $e815fda779bc047b$var$string(value);
    if (valueIsString) // trim the value to make parsing easier
    value = value.trim();
    var type = property.type;
    if (!type) return null;
     // no type, no luck
    // check if bypass is null or empty string (i.e. indication to delete bypass property)
    if (propIsBypass && (value === '' || value === null)) return {
        name: name,
        value: value,
        bypass: true,
        deleteBypass: true
    };
    // check if value is a function used as a mapper
    if ($e815fda779bc047b$var$fn$6(value)) return {
        name: name,
        value: value,
        strValue: 'fn',
        mapped: types.fn,
        bypass: propIsBypass
    };
    // check if value is mapped
    var data, mapData;
    if (!valueIsString || propIsFlat || value.length < 7 || value[1] !== 'a') ;
    else if (value.length >= 7 && value[0] === 'd' && (data = new RegExp(types.data.regex).exec(value))) {
        if (propIsBypass) return false;
         // mappers not allowed in bypass
        var mapped = types.data;
        return {
            name: name,
            value: data,
            strValue: '' + value,
            mapped: mapped,
            field: data[1],
            bypass: propIsBypass
        };
    } else if (value.length >= 10 && value[0] === 'm' && (mapData = new RegExp(types.mapData.regex).exec(value))) {
        if (propIsBypass) return false;
         // mappers not allowed in bypass
        if (type.multiple) return false;
         // impossible to map to num
        var _mapped = types.mapData;
        // we can map only if the type is a colour or a number
        if (!(type.color || type.number)) return false;
        var valueMin = this.parse(name, mapData[4]); // parse to validate
        if (!valueMin || valueMin.mapped) return false;
         // can't be invalid or mapped
        var valueMax = this.parse(name, mapData[5]); // parse to validate
        if (!valueMax || valueMax.mapped) return false;
         // can't be invalid or mapped
        // check if valueMin and valueMax are the same
        if (valueMin.pfValue === valueMax.pfValue || valueMin.strValue === valueMax.strValue) {
            $e815fda779bc047b$var$warn('`' + name + ': ' + value + '` is not a valid mapper because the output range is zero; converting to `' + name + ': ' + valueMin.strValue + '`');
            return this.parse(name, valueMin.strValue); // can't make much of a mapper without a range
        } else if (type.color) {
            var c1 = valueMin.value;
            var c2 = valueMax.value;
            var same = c1[0] === c2[0] // red
             && c1[1] === c2[1] // green
             && c1[2] === c2[2] // blue
             && // optional alpha
            (c1[3] === c2[3] // same alpha outright
             || (c1[3] == null || c1[3] === 1 // full opacity for colour 1?
            ) && (c2[3] == null || c2[3] === 1 // full opacity for colour 2?
            ));
            if (same) return false;
             // can't make a mapper without a range
        }
        return {
            name: name,
            value: mapData,
            strValue: '' + value,
            mapped: _mapped,
            field: mapData[1],
            fieldMin: parseFloat(mapData[2]),
            // min & max are numeric
            fieldMax: parseFloat(mapData[3]),
            valueMin: valueMin.value,
            valueMax: valueMax.value,
            bypass: propIsBypass
        };
    }
    if (type.multiple && propIsFlat !== 'multiple') {
        var vals;
        if (valueIsString) vals = value.split(/\s+/);
        else if ($e815fda779bc047b$var$array(value)) vals = value;
        else vals = [
            value
        ];
        if (type.evenMultiple && vals.length % 2 !== 0) return null;
        var valArr = [];
        var unitsArr = [];
        var pfValArr = [];
        var strVal = '';
        var hasEnum = false;
        for(var i = 0; i < vals.length; i++){
            var p = self1.parse(name, vals[i], propIsBypass, 'multiple');
            hasEnum = hasEnum || $e815fda779bc047b$var$string(p.value);
            valArr.push(p.value);
            pfValArr.push(p.pfValue != null ? p.pfValue : p.value);
            unitsArr.push(p.units);
            strVal += (i > 0 ? ' ' : '') + p.strValue;
        }
        if (type.validate && !type.validate(valArr, unitsArr)) return null;
        if (type.singleEnum && hasEnum) {
            if (valArr.length === 1 && $e815fda779bc047b$var$string(valArr[0])) return {
                name: name,
                value: valArr[0],
                strValue: valArr[0],
                bypass: propIsBypass
            };
            else return null;
        }
        return {
            name: name,
            value: valArr,
            pfValue: pfValArr,
            strValue: strVal,
            bypass: propIsBypass,
            units: unitsArr
        };
    }
    // several types also allow enums
    var checkEnums = function checkEnums() {
        for(var _i = 0; _i < type.enums.length; _i++){
            var en = type.enums[_i];
            if (en === value) return {
                name: name,
                value: value,
                strValue: '' + value,
                bypass: propIsBypass
            };
        }
        return null;
    };
    // check the type and return the appropriate object
    if (type.number) {
        var units;
        var implicitUnits = 'px'; // not set => px
        if (type.units) // use specified units if set
        units = type.units;
        if (type.implicitUnits) implicitUnits = type.implicitUnits;
        if (!type.unitless) {
            if (valueIsString) {
                var unitsRegex = 'px|em' + (type.allowPercent ? '|\\%' : '');
                if (units) unitsRegex = units;
                 // only allow explicit units if so set
                var match = value.match('^(' + $e815fda779bc047b$var$number + ')(' + unitsRegex + ')?' + '$');
                if (match) {
                    value = match[1];
                    units = match[2] || implicitUnits;
                }
            } else if (!units || type.implicitUnits) units = implicitUnits; // implicitly px if unspecified
        }
        value = parseFloat(value);
        // if not a number and enums not allowed, then the value is invalid
        if (isNaN(value) && type.enums === undefined) return null;
        // check if this number type also accepts special keywords in place of numbers
        // (i.e. `left`, `auto`, etc)
        if (isNaN(value) && type.enums !== undefined) {
            value = passedValue;
            return checkEnums();
        }
        // check if value must be an integer
        if (type.integer && !$e815fda779bc047b$var$integer(value)) return null;
        // check value is within range
        if (type.min !== undefined && (value < type.min || type.strictMin && value === type.min) || type.max !== undefined && (value > type.max || type.strictMax && value === type.max)) return null;
        var ret = {
            name: name,
            value: value,
            strValue: '' + value + (units ? units : ''),
            units: units,
            bypass: propIsBypass
        };
        // normalise value in pixels
        if (type.unitless || units !== 'px' && units !== 'em') ret.pfValue = value;
        else ret.pfValue = units === 'px' || !units ? value : this.getEmSizeInPixels() * value;
        // normalise value in ms
        if (units === 'ms' || units === 's') ret.pfValue = units === 'ms' ? value : 1000 * value;
        // normalise value in rad
        if (units === 'deg' || units === 'rad') ret.pfValue = units === 'rad' ? value : $e815fda779bc047b$var$deg2rad(value);
        // normalize value in %
        if (units === '%') ret.pfValue = value / 100;
        return ret;
    } else if (type.propList) {
        var props = [];
        var propsStr = '' + value;
        if (propsStr === 'none') ;
        else {
            // go over each prop
            var propsSplit = propsStr.split(/\s*,\s*|\s+/);
            for(var _i2 = 0; _i2 < propsSplit.length; _i2++){
                var propName = propsSplit[_i2].trim();
                if (self1.properties[propName]) props.push(propName);
                else $e815fda779bc047b$var$warn('`' + propName + '` is not a valid property name');
            }
            if (props.length === 0) return null;
        }
        return {
            name: name,
            value: props,
            strValue: props.length === 0 ? 'none' : props.join(' '),
            bypass: propIsBypass
        };
    } else if (type.color) {
        var tuple = $e815fda779bc047b$var$color2tuple(value);
        if (!tuple) return null;
        return {
            name: name,
            value: tuple,
            pfValue: tuple,
            strValue: 'rgb(' + tuple[0] + ',' + tuple[1] + ',' + tuple[2] + ')',
            // n.b. no spaces b/c of multiple support
            bypass: propIsBypass
        };
    } else if (type.regex || type.regexes) {
        // first check enums
        if (type.enums) {
            var enumProp = checkEnums();
            if (enumProp) return enumProp;
        }
        var regexes = type.regexes ? type.regexes : [
            type.regex
        ];
        for(var _i3 = 0; _i3 < regexes.length; _i3++){
            var regex = new RegExp(regexes[_i3]); // make a regex from the type string
            var m1 = regex.exec(value);
            if (m1) // regex matches
            return {
                name: name,
                value: type.singleRegexMatchValue ? m1[1] : m1,
                strValue: '' + value,
                bypass: propIsBypass
            };
        }
        return null; // didn't match any
    } else if (type.string) // just return
    return {
        name: name,
        value: '' + value,
        strValue: '' + value,
        bypass: propIsBypass
    };
    else if (type.enums) // check enums last because it's a combo type in others
    return checkEnums();
    else return null; // not a type we can handle
};
var $e815fda779bc047b$var$_Style = function Style(cy) {
    if (!(this instanceof $e815fda779bc047b$var$_Style)) return new $e815fda779bc047b$var$_Style(cy);
    if (!$e815fda779bc047b$var$core(cy)) {
        $e815fda779bc047b$var$error('A style must have a core reference');
        return;
    }
    this._private = {
        cy: cy,
        coreStyle: {}
    };
    this.length = 0;
    this.resetToDefault();
};
var $e815fda779bc047b$var$styfn = $e815fda779bc047b$var$_Style.prototype;
$e815fda779bc047b$var$styfn.instanceString = function() {
    return 'style';
};
// remove all contexts
$e815fda779bc047b$var$styfn.clear = function() {
    var _p = this._private;
    var cy = _p.cy;
    var eles = cy.elements();
    for(var i = 0; i < this.length; i++)this[i] = undefined;
    this.length = 0;
    _p.contextStyles = {};
    _p.propDiffs = {};
    this.cleanElements(eles, true);
    eles.forEach(function(ele) {
        var ele_p = ele[0]._private;
        ele_p.styleDirty = true;
        ele_p.appliedInitStyle = false;
    });
    return this; // chaining
};
$e815fda779bc047b$var$styfn.resetToDefault = function() {
    this.clear();
    this.addDefaultStylesheet();
    return this;
};
// builds a style object for the 'core' selector
$e815fda779bc047b$var$styfn.core = function(propName) {
    return this._private.coreStyle[propName] || this.getDefaultProperty(propName);
};
// create a new context from the specified selector string and switch to that context
$e815fda779bc047b$var$styfn.selector = function(selectorStr) {
    // 'core' is a special case and does not need a selector
    var selector = selectorStr === 'core' ? null : new $e815fda779bc047b$var$Selector(selectorStr);
    var i = this.length++; // new context means new index
    this[i] = {
        selector: selector,
        properties: [],
        mappedProperties: [],
        index: i
    };
    return this; // chaining
};
// add one or many css rules to the current context
$e815fda779bc047b$var$styfn.css = function() {
    var self1 = this;
    var args = arguments;
    if (args.length === 1) {
        var map = args[0];
        for(var i = 0; i < self1.properties.length; i++){
            var prop = self1.properties[i];
            var mapVal = map[prop.name];
            if (mapVal === undefined) mapVal = map[$e815fda779bc047b$var$dash2camel(prop.name)];
            if (mapVal !== undefined) this.cssRule(prop.name, mapVal);
        }
    } else if (args.length === 2) this.cssRule(args[0], args[1]);
    // do nothing if args are invalid
    return this; // chaining
};
$e815fda779bc047b$var$styfn.style = $e815fda779bc047b$var$styfn.css;
// add a single css rule to the current context
$e815fda779bc047b$var$styfn.cssRule = function(name, value) {
    // name-value pair
    var property = this.parse(name, value);
    // add property to current context if valid
    if (property) {
        var i = this.length - 1;
        this[i].properties.push(property);
        this[i].properties[property.name] = property; // allow access by name as well
        if (property.name.match(/pie-(\d+)-background-size/) && property.value) this._private.hasPie = true;
        if (property.name.match(/stripe-(\d+)-background-size/) && property.value) this._private.hasStripe = true;
        if (property.mapped) this[i].mappedProperties.push(property);
        // add to core style if necessary
        var currentSelectorIsCore = !this[i].selector;
        if (currentSelectorIsCore) this._private.coreStyle[property.name] = property;
    }
    return this; // chaining
};
$e815fda779bc047b$var$styfn.append = function(style) {
    if ($e815fda779bc047b$var$stylesheet(style)) style.appendToStyle(this);
    else if ($e815fda779bc047b$var$array(style)) this.appendFromJson(style);
    else if ($e815fda779bc047b$var$string(style)) this.appendFromString(style);
     // you probably wouldn't want to append a Style, since you'd duplicate the default parts
    return this;
};
// static function
$e815fda779bc047b$var$_Style.fromJson = function(cy, json) {
    var style = new $e815fda779bc047b$var$_Style(cy);
    style.fromJson(json);
    return style;
};
$e815fda779bc047b$var$_Style.fromString = function(cy, string) {
    return new $e815fda779bc047b$var$_Style(cy).fromString(string);
};
[
    $e815fda779bc047b$var$styfn$8,
    $e815fda779bc047b$var$styfn$7,
    $e815fda779bc047b$var$styfn$6,
    $e815fda779bc047b$var$styfn$5,
    $e815fda779bc047b$var$styfn$4,
    $e815fda779bc047b$var$styfn$3,
    $e815fda779bc047b$var$styfn$2,
    $e815fda779bc047b$var$styfn$1
].forEach(function(props) {
    $e815fda779bc047b$var$extend($e815fda779bc047b$var$styfn, props);
});
$e815fda779bc047b$var$_Style.types = $e815fda779bc047b$var$styfn.types;
$e815fda779bc047b$var$_Style.properties = $e815fda779bc047b$var$styfn.properties;
$e815fda779bc047b$var$_Style.propertyGroups = $e815fda779bc047b$var$styfn.propertyGroups;
$e815fda779bc047b$var$_Style.propertyGroupNames = $e815fda779bc047b$var$styfn.propertyGroupNames;
$e815fda779bc047b$var$_Style.propertyGroupKeys = $e815fda779bc047b$var$styfn.propertyGroupKeys;
var $e815fda779bc047b$var$corefn$2 = {
    style: function style(newStyle) {
        if (newStyle) {
            var s = this.setStyle(newStyle);
            s.update();
        }
        return this._private.style;
    },
    setStyle: function setStyle(style) {
        var _p = this._private;
        if ($e815fda779bc047b$var$stylesheet(style)) _p.style = style.generateStyle(this);
        else if ($e815fda779bc047b$var$array(style)) _p.style = $e815fda779bc047b$var$_Style.fromJson(this, style);
        else if ($e815fda779bc047b$var$string(style)) _p.style = $e815fda779bc047b$var$_Style.fromString(this, style);
        else _p.style = $e815fda779bc047b$var$_Style(this);
        return _p.style;
    },
    // e.g. cy.data() changed => recalc ele mappers
    updateStyle: function updateStyle() {
        this.mutableElements().updateStyle(); // just send to all eles
    }
};
var $e815fda779bc047b$var$defaultSelectionType = 'single';
var $e815fda779bc047b$var$corefn$1 = {
    autolock: function autolock(bool) {
        if (bool !== undefined) this._private.autolock = bool ? true : false;
        else return this._private.autolock;
        return this; // chaining
    },
    autoungrabify: function autoungrabify(bool) {
        if (bool !== undefined) this._private.autoungrabify = bool ? true : false;
        else return this._private.autoungrabify;
        return this; // chaining
    },
    autounselectify: function autounselectify(bool) {
        if (bool !== undefined) this._private.autounselectify = bool ? true : false;
        else return this._private.autounselectify;
        return this; // chaining
    },
    selectionType: function selectionType(selType) {
        var _p = this._private;
        if (_p.selectionType == null) _p.selectionType = $e815fda779bc047b$var$defaultSelectionType;
        if (selType !== undefined) {
            if (selType === 'additive' || selType === 'single') _p.selectionType = selType;
        } else return _p.selectionType;
        return this;
    },
    panningEnabled: function panningEnabled(bool) {
        if (bool !== undefined) this._private.panningEnabled = bool ? true : false;
        else return this._private.panningEnabled;
        return this; // chaining
    },
    userPanningEnabled: function userPanningEnabled(bool) {
        if (bool !== undefined) this._private.userPanningEnabled = bool ? true : false;
        else return this._private.userPanningEnabled;
        return this; // chaining
    },
    zoomingEnabled: function zoomingEnabled(bool) {
        if (bool !== undefined) this._private.zoomingEnabled = bool ? true : false;
        else return this._private.zoomingEnabled;
        return this; // chaining
    },
    userZoomingEnabled: function userZoomingEnabled(bool) {
        if (bool !== undefined) this._private.userZoomingEnabled = bool ? true : false;
        else return this._private.userZoomingEnabled;
        return this; // chaining
    },
    boxSelectionEnabled: function boxSelectionEnabled(bool) {
        if (bool !== undefined) this._private.boxSelectionEnabled = bool ? true : false;
        else return this._private.boxSelectionEnabled;
        return this; // chaining
    },
    pan: function pan() {
        var args = arguments;
        var pan = this._private.pan;
        var dim, val, dims, x, y;
        switch(args.length){
            case 0:
                // .pan()
                return pan;
            case 1:
                if ($e815fda779bc047b$var$string(args[0])) {
                    // .pan('x')
                    dim = args[0];
                    return pan[dim];
                } else if ($e815fda779bc047b$var$plainObject(args[0])) {
                    // .pan({ x: 0, y: 100 })
                    if (!this._private.panningEnabled) return this;
                    dims = args[0];
                    x = dims.x;
                    y = dims.y;
                    if ($e815fda779bc047b$var$number$1(x)) pan.x = x;
                    if ($e815fda779bc047b$var$number$1(y)) pan.y = y;
                    this.emit('pan viewport');
                }
                break;
            case 2:
                // .pan('x', 100)
                if (!this._private.panningEnabled) return this;
                dim = args[0];
                val = args[1];
                if ((dim === 'x' || dim === 'y') && $e815fda779bc047b$var$number$1(val)) pan[dim] = val;
                this.emit('pan viewport');
                break;
        }
        this.notify('viewport');
        return this; // chaining
    },
    panBy: function panBy(arg0, arg1) {
        var args = arguments;
        var pan = this._private.pan;
        var dim, val, dims, x, y;
        if (!this._private.panningEnabled) return this;
        switch(args.length){
            case 1:
                if ($e815fda779bc047b$var$plainObject(arg0)) {
                    // .panBy({ x: 0, y: 100 })
                    dims = args[0];
                    x = dims.x;
                    y = dims.y;
                    if ($e815fda779bc047b$var$number$1(x)) pan.x += x;
                    if ($e815fda779bc047b$var$number$1(y)) pan.y += y;
                    this.emit('pan viewport');
                }
                break;
            case 2:
                // .panBy('x', 100)
                dim = arg0;
                val = arg1;
                if ((dim === 'x' || dim === 'y') && $e815fda779bc047b$var$number$1(val)) pan[dim] += val;
                this.emit('pan viewport');
                break;
        }
        this.notify('viewport');
        return this; // chaining
    },
    gc: function gc() {
        this.notify('gc');
    },
    fit: function fit(elements, padding) {
        var viewportState = this.getFitViewport(elements, padding);
        if (viewportState) {
            var _p = this._private;
            _p.zoom = viewportState.zoom;
            _p.pan = viewportState.pan;
            this.emit('pan zoom viewport');
            this.notify('viewport');
        }
        return this; // chaining
    },
    getFitViewport: function getFitViewport(elements, padding) {
        if ($e815fda779bc047b$var$number$1(elements) && padding === undefined) {
            // elements is optional
            padding = elements;
            elements = undefined;
        }
        if (!this._private.panningEnabled || !this._private.zoomingEnabled) return;
        var bb;
        if ($e815fda779bc047b$var$string(elements)) {
            var sel = elements;
            elements = this.$(sel);
        } else if ($e815fda779bc047b$var$boundingBox(elements)) {
            // assume bb
            var bbe = elements;
            bb = {
                x1: bbe.x1,
                y1: bbe.y1,
                x2: bbe.x2,
                y2: bbe.y2
            };
            bb.w = bb.x2 - bb.x1;
            bb.h = bb.y2 - bb.y1;
        } else if (!$e815fda779bc047b$var$elementOrCollection(elements)) elements = this.mutableElements();
        if ($e815fda779bc047b$var$elementOrCollection(elements) && elements.empty()) return;
         // can't fit to nothing
        bb = bb || elements.boundingBox();
        var w = this.width();
        var h = this.height();
        var zoom;
        padding = $e815fda779bc047b$var$number$1(padding) ? padding : 0;
        if (!isNaN(w) && !isNaN(h) && w > 0 && h > 0 && !isNaN(bb.w) && !isNaN(bb.h) && bb.w > 0 && bb.h > 0) {
            zoom = Math.min((w - 2 * padding) / bb.w, (h - 2 * padding) / bb.h);
            // crop zoom
            zoom = zoom > this._private.maxZoom ? this._private.maxZoom : zoom;
            zoom = zoom < this._private.minZoom ? this._private.minZoom : zoom;
            var pan = {
                // now pan to middle
                x: (w - zoom * (bb.x1 + bb.x2)) / 2,
                y: (h - zoom * (bb.y1 + bb.y2)) / 2
            };
            return {
                zoom: zoom,
                pan: pan
            };
        }
        return;
    },
    zoomRange: function zoomRange(min, max) {
        var _p = this._private;
        if (max == null) {
            var opts = min;
            min = opts.min;
            max = opts.max;
        }
        if ($e815fda779bc047b$var$number$1(min) && $e815fda779bc047b$var$number$1(max) && min <= max) {
            _p.minZoom = min;
            _p.maxZoom = max;
        } else if ($e815fda779bc047b$var$number$1(min) && max === undefined && min <= _p.maxZoom) _p.minZoom = min;
        else if ($e815fda779bc047b$var$number$1(max) && min === undefined && max >= _p.minZoom) _p.maxZoom = max;
        return this;
    },
    minZoom: function minZoom(zoom) {
        if (zoom === undefined) return this._private.minZoom;
        else return this.zoomRange({
            min: zoom
        });
    },
    maxZoom: function maxZoom(zoom) {
        if (zoom === undefined) return this._private.maxZoom;
        else return this.zoomRange({
            max: zoom
        });
    },
    getZoomedViewport: function getZoomedViewport(params) {
        var _p = this._private;
        var currentPan = _p.pan;
        var currentZoom = _p.zoom;
        var pos; // in rendered px
        var zoom;
        var bail = false;
        if (!_p.zoomingEnabled) // zooming disabled
        bail = true;
        if ($e815fda779bc047b$var$number$1(params)) // then set the zoom
        zoom = params;
        else if ($e815fda779bc047b$var$plainObject(params)) {
            // then zoom about a point
            zoom = params.level;
            if (params.position != null) pos = $e815fda779bc047b$var$modelToRenderedPosition$1(params.position, currentZoom, currentPan);
            else if (params.renderedPosition != null) pos = params.renderedPosition;
            if (pos != null && !_p.panningEnabled) // panning disabled
            bail = true;
        }
        // crop zoom
        zoom = zoom > _p.maxZoom ? _p.maxZoom : zoom;
        zoom = zoom < _p.minZoom ? _p.minZoom : zoom;
        // can't zoom with invalid params
        if (bail || !$e815fda779bc047b$var$number$1(zoom) || zoom === currentZoom || pos != null && (!$e815fda779bc047b$var$number$1(pos.x) || !$e815fda779bc047b$var$number$1(pos.y))) return null;
        if (pos != null) {
            // set zoom about position
            var pan1 = currentPan;
            var zoom1 = currentZoom;
            var zoom2 = zoom;
            var pan2 = {
                x: -zoom2 / zoom1 * (pos.x - pan1.x) + pos.x,
                y: -zoom2 / zoom1 * (pos.y - pan1.y) + pos.y
            };
            return {
                zoomed: true,
                panned: true,
                zoom: zoom2,
                pan: pan2
            };
        } else // just set the zoom
        return {
            zoomed: true,
            panned: false,
            zoom: zoom,
            pan: currentPan
        };
    },
    zoom: function zoom(params) {
        if (params === undefined) // get
        return this._private.zoom;
        else {
            // set
            var vp = this.getZoomedViewport(params);
            var _p = this._private;
            if (vp == null || !vp.zoomed) return this;
            _p.zoom = vp.zoom;
            if (vp.panned) {
                _p.pan.x = vp.pan.x;
                _p.pan.y = vp.pan.y;
            }
            this.emit('zoom' + (vp.panned ? ' pan' : '') + ' viewport');
            this.notify('viewport');
            return this; // chaining
        }
    },
    viewport: function viewport(opts) {
        var _p = this._private;
        var zoomDefd = true;
        var panDefd = true;
        var events = []; // to trigger
        var zoomFailed = false;
        var panFailed = false;
        if (!opts) return this;
        if (!$e815fda779bc047b$var$number$1(opts.zoom)) zoomDefd = false;
        if (!$e815fda779bc047b$var$plainObject(opts.pan)) panDefd = false;
        if (!zoomDefd && !panDefd) return this;
        if (zoomDefd) {
            var z = opts.zoom;
            if (z < _p.minZoom || z > _p.maxZoom || !_p.zoomingEnabled) zoomFailed = true;
            else {
                _p.zoom = z;
                events.push('zoom');
            }
        }
        if (panDefd && (!zoomFailed || !opts.cancelOnFailedZoom) && _p.panningEnabled) {
            var p = opts.pan;
            if ($e815fda779bc047b$var$number$1(p.x)) {
                _p.pan.x = p.x;
                panFailed = false;
            }
            if ($e815fda779bc047b$var$number$1(p.y)) {
                _p.pan.y = p.y;
                panFailed = false;
            }
            if (!panFailed) events.push('pan');
        }
        if (events.length > 0) {
            events.push('viewport');
            this.emit(events.join(' '));
            this.notify('viewport');
        }
        return this; // chaining
    },
    center: function center(elements) {
        var pan = this.getCenterPan(elements);
        if (pan) {
            this._private.pan = pan;
            this.emit('pan viewport');
            this.notify('viewport');
        }
        return this; // chaining
    },
    getCenterPan: function getCenterPan(elements, zoom) {
        if (!this._private.panningEnabled) return;
        if ($e815fda779bc047b$var$string(elements)) {
            var selector = elements;
            elements = this.mutableElements().filter(selector);
        } else if (!$e815fda779bc047b$var$elementOrCollection(elements)) elements = this.mutableElements();
        if (elements.length === 0) return;
         // can't centre pan to nothing
        var bb = elements.boundingBox();
        var w = this.width();
        var h = this.height();
        zoom = zoom === undefined ? this._private.zoom : zoom;
        var pan = {
            // middle
            x: (w - zoom * (bb.x1 + bb.x2)) / 2,
            y: (h - zoom * (bb.y1 + bb.y2)) / 2
        };
        return pan;
    },
    reset: function reset() {
        if (!this._private.panningEnabled || !this._private.zoomingEnabled) return this;
        this.viewport({
            pan: {
                x: 0,
                y: 0
            },
            zoom: 1
        });
        return this; // chaining
    },
    invalidateSize: function invalidateSize() {
        this._private.sizeCache = null;
    },
    size: function size() {
        var _p = this._private;
        var container = _p.container;
        var cy = this;
        return _p.sizeCache = _p.sizeCache || (container ? function() {
            var style = cy.window().getComputedStyle(container);
            var val = function val(name) {
                return parseFloat(style.getPropertyValue(name));
            };
            return {
                width: container.clientWidth - val('padding-left') - val('padding-right'),
                height: container.clientHeight - val('padding-top') - val('padding-bottom')
            };
        }() : {
            // fallback if no container (not 0 b/c can be used for dividing etc)
            width: 1,
            height: 1
        });
    },
    width: function width() {
        return this.size().width;
    },
    height: function height() {
        return this.size().height;
    },
    extent: function extent() {
        var pan = this._private.pan;
        var zoom = this._private.zoom;
        var rb = this.renderedExtent();
        var b = {
            x1: (rb.x1 - pan.x) / zoom,
            x2: (rb.x2 - pan.x) / zoom,
            y1: (rb.y1 - pan.y) / zoom,
            y2: (rb.y2 - pan.y) / zoom
        };
        b.w = b.x2 - b.x1;
        b.h = b.y2 - b.y1;
        return b;
    },
    renderedExtent: function renderedExtent() {
        var width = this.width();
        var height = this.height();
        return {
            x1: 0,
            y1: 0,
            x2: width,
            y2: height,
            w: width,
            h: height
        };
    },
    multiClickDebounceTime: function multiClickDebounceTime(_int) {
        if (_int) this._private.multiClickDebounceTime = _int;
        else return this._private.multiClickDebounceTime;
        return this; // chaining
    }
};
// aliases
$e815fda779bc047b$var$corefn$1.centre = $e815fda779bc047b$var$corefn$1.center;
// backwards compatibility
$e815fda779bc047b$var$corefn$1.autolockNodes = $e815fda779bc047b$var$corefn$1.autolock;
$e815fda779bc047b$var$corefn$1.autoungrabifyNodes = $e815fda779bc047b$var$corefn$1.autoungrabify;
var $e815fda779bc047b$var$fn = {
    data: $e815fda779bc047b$var$define.data({
        field: 'data',
        bindingEvent: 'data',
        allowBinding: true,
        allowSetting: true,
        settingEvent: 'data',
        settingTriggersEvent: true,
        triggerFnName: 'trigger',
        allowGetting: true,
        updateStyle: true
    }),
    removeData: $e815fda779bc047b$var$define.removeData({
        field: 'data',
        event: 'data',
        triggerFnName: 'trigger',
        triggerEvent: true,
        updateStyle: true
    }),
    scratch: $e815fda779bc047b$var$define.data({
        field: 'scratch',
        bindingEvent: 'scratch',
        allowBinding: true,
        allowSetting: true,
        settingEvent: 'scratch',
        settingTriggersEvent: true,
        triggerFnName: 'trigger',
        allowGetting: true,
        updateStyle: true
    }),
    removeScratch: $e815fda779bc047b$var$define.removeData({
        field: 'scratch',
        event: 'scratch',
        triggerFnName: 'trigger',
        triggerEvent: true,
        updateStyle: true
    })
};
// aliases
$e815fda779bc047b$var$fn.attr = $e815fda779bc047b$var$fn.data;
$e815fda779bc047b$var$fn.removeAttr = $e815fda779bc047b$var$fn.removeData;
var $e815fda779bc047b$var$Core = function Core(opts) {
    var cy = this;
    opts = $e815fda779bc047b$var$extend({}, opts);
    var container = opts.container;
    // allow for passing a wrapped jquery object
    // e.g. cytoscape({ container: $('#cy') })
    if (container && !$e815fda779bc047b$var$htmlElement(container) && $e815fda779bc047b$var$htmlElement(container[0])) container = container[0];
    var reg = container ? container._cyreg : null; // e.g. already registered some info (e.g. readies) via jquery
    reg = reg || {};
    if (reg && reg.cy) {
        reg.cy.destroy();
        reg = {}; // old instance => replace reg completely
    }
    var readies = reg.readies = reg.readies || [];
    if (container) container._cyreg = reg;
     // make sure container assoc'd reg points to this cy
    reg.cy = cy;
    var head = $e815fda779bc047b$var$_window !== undefined && container !== undefined && !opts.headless;
    var options = opts;
    options.layout = $e815fda779bc047b$var$extend({
        name: head ? 'grid' : 'null'
    }, options.layout);
    options.renderer = $e815fda779bc047b$var$extend({
        name: head ? 'canvas' : 'null'
    }, options.renderer);
    var defVal = function defVal(def, val, altVal) {
        if (val !== undefined) return val;
        else if (altVal !== undefined) return altVal;
        else return def;
    };
    var _p = this._private = {
        container: container,
        // html dom ele container
        ready: false,
        // whether ready has been triggered
        options: options,
        // cached options
        elements: new $e815fda779bc047b$var$Collection(this),
        // elements in the graph
        listeners: [],
        // list of listeners
        aniEles: new $e815fda779bc047b$var$Collection(this),
        // elements being animated
        data: options.data || {},
        // data for the core
        scratch: {},
        // scratch object for core
        layout: null,
        renderer: null,
        destroyed: false,
        // whether destroy was called
        notificationsEnabled: true,
        // whether notifications are sent to the renderer
        minZoom: 1e-50,
        maxZoom: 1e50,
        zoomingEnabled: defVal(true, options.zoomingEnabled),
        userZoomingEnabled: defVal(true, options.userZoomingEnabled),
        panningEnabled: defVal(true, options.panningEnabled),
        userPanningEnabled: defVal(true, options.userPanningEnabled),
        boxSelectionEnabled: defVal(true, options.boxSelectionEnabled),
        autolock: defVal(false, options.autolock, options.autolockNodes),
        autoungrabify: defVal(false, options.autoungrabify, options.autoungrabifyNodes),
        autounselectify: defVal(false, options.autounselectify),
        styleEnabled: options.styleEnabled === undefined ? head : options.styleEnabled,
        zoom: $e815fda779bc047b$var$number$1(options.zoom) ? options.zoom : 1,
        pan: {
            x: $e815fda779bc047b$var$plainObject(options.pan) && $e815fda779bc047b$var$number$1(options.pan.x) ? options.pan.x : 0,
            y: $e815fda779bc047b$var$plainObject(options.pan) && $e815fda779bc047b$var$number$1(options.pan.y) ? options.pan.y : 0
        },
        animation: {
            // object for currently-running animations
            current: [],
            queue: []
        },
        hasCompoundNodes: false,
        multiClickDebounceTime: defVal(250, options.multiClickDebounceTime)
    };
    this.createEmitter();
    // set selection type
    this.selectionType(options.selectionType);
    // init zoom bounds
    this.zoomRange({
        min: options.minZoom,
        max: options.maxZoom
    });
    var loadExtData = function loadExtData(extData, next) {
        var anyIsPromise = extData.some($e815fda779bc047b$var$promise);
        if (anyIsPromise) return $e815fda779bc047b$var$Promise$1.all(extData).then(next); // load all data asynchronously, then exec rest of init
        else next(extData); // exec synchronously for convenience
    };
    // start with the default stylesheet so we have something before loading an external stylesheet
    if (_p.styleEnabled) cy.setStyle([]);
    // create the renderer
    var rendererOptions = $e815fda779bc047b$var$extend({}, options, options.renderer); // allow rendering hints in top level options
    cy.initRenderer(rendererOptions);
    var setElesAndLayout = function setElesAndLayout(elements, onload, ondone) {
        cy.notifications(false);
        // remove old elements
        var oldEles = cy.mutableElements();
        if (oldEles.length > 0) oldEles.remove();
        if (elements != null) {
            if ($e815fda779bc047b$var$plainObject(elements) || $e815fda779bc047b$var$array(elements)) cy.add(elements);
        }
        cy.one('layoutready', function(e) {
            cy.notifications(true);
            cy.emit(e); // we missed this event by turning notifications off, so pass it on
            cy.one('load', onload);
            cy.emitAndNotify('load');
        }).one('layoutstop', function() {
            cy.one('done', ondone);
            cy.emit('done');
        });
        var layoutOpts = $e815fda779bc047b$var$extend({}, cy._private.options.layout);
        layoutOpts.eles = cy.elements();
        cy.layout(layoutOpts).run();
    };
    loadExtData([
        options.style,
        options.elements
    ], function(thens) {
        var initStyle = thens[0];
        var initEles = thens[1];
        // init style
        if (_p.styleEnabled) cy.style().append(initStyle);
        // initial load
        setElesAndLayout(initEles, function() {
            // onready
            cy.startAnimationLoop();
            _p.ready = true;
            // if a ready callback is specified as an option, the bind it
            if ($e815fda779bc047b$var$fn$6(options.ready)) cy.on('ready', options.ready);
            // bind all the ready handlers registered before creating this instance
            for(var i = 0; i < readies.length; i++){
                var fn = readies[i];
                cy.on('ready', fn);
            }
            if (reg) reg.readies = [];
             // clear b/c we've bound them all and don't want to keep it around in case a new core uses the same div etc
            cy.emit('ready');
        }, options.done);
    });
};
var $e815fda779bc047b$var$corefn = $e815fda779bc047b$var$Core.prototype; // short alias
$e815fda779bc047b$var$extend($e815fda779bc047b$var$corefn, {
    instanceString: function instanceString() {
        return 'core';
    },
    isReady: function isReady() {
        return this._private.ready;
    },
    destroyed: function destroyed() {
        return this._private.destroyed;
    },
    ready: function ready(fn) {
        if (this.isReady()) this.emitter().emit('ready', [], fn); // just calls fn as though triggered via ready event
        else this.on('ready', fn);
        return this;
    },
    destroy: function destroy() {
        var cy = this;
        if (cy.destroyed()) return;
        cy.stopAnimationLoop();
        cy.destroyRenderer();
        this.emit('destroy');
        cy._private.destroyed = true;
        return cy;
    },
    hasElementWithId: function hasElementWithId(id) {
        return this._private.elements.hasElementWithId(id);
    },
    getElementById: function getElementById(id) {
        return this._private.elements.getElementById(id);
    },
    hasCompoundNodes: function hasCompoundNodes() {
        return this._private.hasCompoundNodes;
    },
    headless: function headless() {
        return this._private.renderer.isHeadless();
    },
    styleEnabled: function styleEnabled() {
        return this._private.styleEnabled;
    },
    addToPool: function addToPool(eles) {
        this._private.elements.merge(eles);
        return this; // chaining
    },
    removeFromPool: function removeFromPool(eles) {
        this._private.elements.unmerge(eles);
        return this;
    },
    container: function container() {
        return this._private.container || null;
    },
    window: function window1() {
        var container = this._private.container;
        if (container == null) return $e815fda779bc047b$var$_window;
        var ownerDocument = this._private.container.ownerDocument;
        if (ownerDocument === undefined || ownerDocument == null) return $e815fda779bc047b$var$_window;
        return ownerDocument.defaultView || $e815fda779bc047b$var$_window;
    },
    mount: function mount(container) {
        if (container == null) return;
        var cy = this;
        var _p = cy._private;
        var options = _p.options;
        if (!$e815fda779bc047b$var$htmlElement(container) && $e815fda779bc047b$var$htmlElement(container[0])) container = container[0];
        cy.stopAnimationLoop();
        cy.destroyRenderer();
        _p.container = container;
        _p.styleEnabled = true;
        cy.invalidateSize();
        cy.initRenderer($e815fda779bc047b$var$extend({}, options, options.renderer, {
            // allow custom renderer name to be re-used, otherwise use canvas
            name: options.renderer.name === 'null' ? 'canvas' : options.renderer.name
        }));
        cy.startAnimationLoop();
        cy.style(options.style);
        cy.emit('mount');
        return cy;
    },
    unmount: function unmount() {
        var cy = this;
        cy.stopAnimationLoop();
        cy.destroyRenderer();
        cy.initRenderer({
            name: 'null'
        });
        cy.emit('unmount');
        return cy;
    },
    options: function options() {
        return $e815fda779bc047b$var$copy(this._private.options);
    },
    json: function json(obj) {
        var cy = this;
        var _p = cy._private;
        var eles = cy.mutableElements();
        var getFreshRef = function getFreshRef(ele) {
            return cy.getElementById(ele.id());
        };
        if ($e815fda779bc047b$var$plainObject(obj)) {
            // set
            cy.startBatch();
            if (obj.elements) {
                var idInJson = {};
                var updateEles = function updateEles(jsons, gr) {
                    var toAdd = [];
                    var toMod = [];
                    for(var i = 0; i < jsons.length; i++){
                        var json = jsons[i];
                        if (!json.data.id) {
                            $e815fda779bc047b$var$warn('cy.json() cannot handle elements without an ID attribute');
                            continue;
                        }
                        var id = '' + json.data.id; // id must be string
                        var ele = cy.getElementById(id);
                        idInJson[id] = true;
                        if (ele.length !== 0) // existing element should be updated
                        toMod.push({
                            ele: ele,
                            json: json
                        });
                        else // otherwise should be added
                        if (gr) {
                            json.group = gr;
                            toAdd.push(json);
                        } else toAdd.push(json);
                    }
                    cy.add(toAdd);
                    for(var _i = 0; _i < toMod.length; _i++){
                        var _toMod$_i = toMod[_i], _ele = _toMod$_i.ele, _json = _toMod$_i.json;
                        _ele.json(_json);
                    }
                };
                if ($e815fda779bc047b$var$array(obj.elements)) // elements: []
                updateEles(obj.elements);
                else {
                    // elements: { nodes: [], edges: [] }
                    var grs = [
                        'nodes',
                        'edges'
                    ];
                    for(var i = 0; i < grs.length; i++){
                        var gr = grs[i];
                        var elements = obj.elements[gr];
                        if ($e815fda779bc047b$var$array(elements)) updateEles(elements, gr);
                    }
                }
                var parentsToRemove = cy.collection();
                eles.filter(function(ele) {
                    return !idInJson[ele.id()];
                }).forEach(function(ele) {
                    if (ele.isParent()) parentsToRemove.merge(ele);
                    else ele.remove();
                });
                // so that children are not removed w/parent
                parentsToRemove.forEach(function(ele) {
                    return ele.children().move({
                        parent: null
                    });
                });
                // intermediate parents may be moved by prior line, so make sure we remove by fresh refs
                parentsToRemove.forEach(function(ele) {
                    return getFreshRef(ele).remove();
                });
            }
            if (obj.style) cy.style(obj.style);
            if (obj.zoom != null && obj.zoom !== _p.zoom) cy.zoom(obj.zoom);
            if (obj.pan) {
                if (obj.pan.x !== _p.pan.x || obj.pan.y !== _p.pan.y) cy.pan(obj.pan);
            }
            if (obj.data) cy.data(obj.data);
            var fields = [
                'minZoom',
                'maxZoom',
                'zoomingEnabled',
                'userZoomingEnabled',
                'panningEnabled',
                'userPanningEnabled',
                'boxSelectionEnabled',
                'autolock',
                'autoungrabify',
                'autounselectify',
                'multiClickDebounceTime'
            ];
            for(var _i2 = 0; _i2 < fields.length; _i2++){
                var f = fields[_i2];
                if (obj[f] != null) cy[f](obj[f]);
            }
            cy.endBatch();
            return this; // chaining
        } else {
            // get
            var flat = !!obj;
            var json = {};
            if (flat) json.elements = this.elements().map(function(ele) {
                return ele.json();
            });
            else {
                json.elements = {};
                eles.forEach(function(ele) {
                    var group = ele.group();
                    if (!json.elements[group]) json.elements[group] = [];
                    json.elements[group].push(ele.json());
                });
            }
            if (this._private.styleEnabled) json.style = cy.style().json();
            json.data = $e815fda779bc047b$var$copy(cy.data());
            var options = _p.options;
            json.zoomingEnabled = _p.zoomingEnabled;
            json.userZoomingEnabled = _p.userZoomingEnabled;
            json.zoom = _p.zoom;
            json.minZoom = _p.minZoom;
            json.maxZoom = _p.maxZoom;
            json.panningEnabled = _p.panningEnabled;
            json.userPanningEnabled = _p.userPanningEnabled;
            json.pan = $e815fda779bc047b$var$copy(_p.pan);
            json.boxSelectionEnabled = _p.boxSelectionEnabled;
            json.renderer = $e815fda779bc047b$var$copy(options.renderer);
            json.hideEdgesOnViewport = options.hideEdgesOnViewport;
            json.textureOnViewport = options.textureOnViewport;
            json.wheelSensitivity = options.wheelSensitivity;
            json.motionBlur = options.motionBlur;
            json.multiClickDebounceTime = options.multiClickDebounceTime;
            return json;
        }
    }
});
$e815fda779bc047b$var$corefn.$id = $e815fda779bc047b$var$corefn.getElementById;
[
    $e815fda779bc047b$var$corefn$9,
    $e815fda779bc047b$var$corefn$8,
    $e815fda779bc047b$var$elesfn,
    $e815fda779bc047b$var$corefn$7,
    $e815fda779bc047b$var$corefn$6,
    $e815fda779bc047b$var$corefn$5,
    $e815fda779bc047b$var$corefn$4,
    $e815fda779bc047b$var$corefn$3,
    $e815fda779bc047b$var$corefn$2,
    $e815fda779bc047b$var$corefn$1,
    $e815fda779bc047b$var$fn
].forEach(function(props) {
    $e815fda779bc047b$var$extend($e815fda779bc047b$var$corefn, props);
});
/* eslint-disable no-unused-vars */ var $e815fda779bc047b$var$defaults$7 = {
    fit: true,
    // whether to fit the viewport to the graph
    directed: false,
    // whether the tree is directed downwards (or edges can point in any direction if false)
    direction: 'downward',
    // determines the direction in which the tree structure is drawn.  The possible values are 'downward', 'upward', 'rightward', or 'leftward'.
    padding: 30,
    // padding on fit
    circle: false,
    // put depths in concentric circles if true, put depths top down if false
    grid: false,
    // whether to create an even grid into which the DAG is placed (circle:false only)
    spacingFactor: 1.75,
    // positive spacing factor, larger => more space between nodes (N.B. n/a if causes overlap)
    boundingBox: undefined,
    // constrain layout bounds; { x1, y1, x2, y2 } or { x1, y1, w, h }
    avoidOverlap: true,
    // prevents node overlap, may overflow boundingBox if not enough space
    nodeDimensionsIncludeLabels: false,
    // Excludes the label when calculating node bounding boxes for the layout algorithm
    roots: undefined,
    // the roots of the trees
    depthSort: undefined,
    // a sorting function to order nodes at equal depth. e.g. function(a, b){ return a.data('weight') - b.data('weight') }
    animate: false,
    // whether to transition the node positions
    animationDuration: 500,
    // duration of animation in ms if enabled
    animationEasing: undefined,
    // easing of animation if enabled,
    animateFilter: function animateFilter(node, i) {
        return true;
    },
    // a function that determines whether the node should be animated.  All nodes animated by default on animate enabled.  Non-animated nodes are positioned immediately when the layout starts
    ready: undefined,
    // callback on layoutready
    stop: undefined,
    // callback on layoutstop
    transform: function transform(node, position) {
        return position;
    } // transform a given node position. Useful for changing flow direction in discrete layouts
};
var $e815fda779bc047b$var$deprecatedOptionDefaults = {
    maximal: false,
    // whether to shift nodes down their natural BFS depths in order to avoid upwards edges (DAGS only); setting acyclic to true sets maximal to true also
    acyclic: false // whether the tree is acyclic and thus a node could be shifted (due to the maximal option) multiple times without causing an infinite loop; setting to true sets maximal to true also; if you are uncertain whether a tree is acyclic, set to false to avoid potential infinite loops
};
/* eslint-enable */ var $e815fda779bc047b$var$getInfo = function getInfo(ele) {
    return ele.scratch('breadthfirst');
};
var $e815fda779bc047b$var$setInfo = function setInfo(ele, obj) {
    return ele.scratch('breadthfirst', obj);
};
function $e815fda779bc047b$var$BreadthFirstLayout(options) {
    this.options = $e815fda779bc047b$var$extend({}, $e815fda779bc047b$var$defaults$7, $e815fda779bc047b$var$deprecatedOptionDefaults, options);
}
$e815fda779bc047b$var$BreadthFirstLayout.prototype.run = function() {
    var options = this.options;
    var cy = options.cy;
    var eles = options.eles;
    var nodes = eles.nodes().filter(function(n) {
        return n.isChildless();
    });
    var graph = eles;
    var directed = options.directed;
    var maximal = options.acyclic || options.maximal || options.maximalAdjustments > 0; // maximalAdjustments for compat. w/ old code; also, setting acyclic to true sets maximal to true
    var hasBoundingBox = !!options.boundingBox;
    var bb = $e815fda779bc047b$var$makeBoundingBox(hasBoundingBox ? options.boundingBox : structuredClone(cy.extent()));
    var roots;
    if ($e815fda779bc047b$var$elementOrCollection(options.roots)) roots = options.roots;
    else if ($e815fda779bc047b$var$array(options.roots)) {
        var rootsArray = [];
        for(var i = 0; i < options.roots.length; i++){
            var id = options.roots[i];
            var ele = cy.getElementById(id);
            rootsArray.push(ele);
        }
        roots = cy.collection(rootsArray);
    } else if ($e815fda779bc047b$var$string(options.roots)) roots = cy.$(options.roots);
    else if (directed) roots = nodes.roots();
    else {
        var components = eles.components();
        roots = cy.collection();
        var _loop = function _loop() {
            var comp = components[_i];
            var maxDegree = comp.maxDegree(false);
            var compRoots = comp.filter(function(ele) {
                return ele.degree(false) === maxDegree;
            });
            roots = roots.add(compRoots);
        };
        for(var _i = 0; _i < components.length; _i++)_loop();
    }
    var depths = [];
    var foundByBfs = {};
    var addToDepth = function addToDepth(ele, d) {
        if (depths[d] == null) depths[d] = [];
        var i = depths[d].length;
        depths[d].push(ele);
        $e815fda779bc047b$var$setInfo(ele, {
            index: i,
            depth: d
        });
    };
    var changeDepth = function changeDepth(ele, newDepth) {
        var _getInfo = $e815fda779bc047b$var$getInfo(ele), depth = _getInfo.depth, index = _getInfo.index;
        depths[depth][index] = null;
        // add only childless nodes
        if (ele.isChildless()) addToDepth(ele, newDepth);
    };
    // find the depths of the nodes
    graph.bfs({
        roots: roots,
        directed: options.directed,
        visit: function visit(node, edge, pNode, i, depth) {
            var ele = node[0];
            var id = ele.id();
            // add only childless nodes
            if (ele.isChildless()) addToDepth(ele, depth);
            foundByBfs[id] = true;
        }
    });
    // check for nodes not found by bfs
    var orphanNodes = [];
    for(var _i2 = 0; _i2 < nodes.length; _i2++){
        var _ele = nodes[_i2];
        if (foundByBfs[_ele.id()]) continue;
        else orphanNodes.push(_ele);
    }
    // assign the nodes a depth and index
    var assignDepthsAt = function assignDepthsAt(i) {
        var eles = depths[i];
        for(var j = 0; j < eles.length; j++){
            var _ele2 = eles[j];
            if (_ele2 == null) {
                eles.splice(j, 1);
                j--;
                continue;
            }
            $e815fda779bc047b$var$setInfo(_ele2, {
                depth: i,
                index: j
            });
        }
    };
    var adjustMaximally = function adjustMaximally(ele, shifted) {
        var eInfo = $e815fda779bc047b$var$getInfo(ele);
        var incomers = ele.incomers().filter(function(el) {
            return el.isNode() && eles.has(el);
        });
        var maxDepth = -1;
        var id = ele.id();
        for(var k = 0; k < incomers.length; k++){
            var incmr = incomers[k];
            var iInfo = $e815fda779bc047b$var$getInfo(incmr);
            maxDepth = Math.max(maxDepth, iInfo.depth);
        }
        if (eInfo.depth <= maxDepth) {
            if (!options.acyclic && shifted[id]) return null;
            var newDepth = maxDepth + 1;
            changeDepth(ele, newDepth);
            shifted[id] = newDepth;
            return true;
        }
        return false;
    };
    // for the directed case, try to make the edges all go down (i.e. depth i => depth i + 1)
    if (directed && maximal) {
        var Q = [];
        var shifted = {};
        var enqueue = function enqueue(n) {
            return Q.push(n);
        };
        var dequeue = function dequeue() {
            return Q.shift();
        };
        nodes.forEach(function(n) {
            return Q.push(n);
        });
        while(Q.length > 0){
            var _ele3 = dequeue();
            var didShift = adjustMaximally(_ele3, shifted);
            if (didShift) _ele3.outgoers().filter(function(el) {
                return el.isNode() && eles.has(el);
            }).forEach(enqueue);
            else if (didShift === null) {
                $e815fda779bc047b$var$warn('Detected double maximal shift for node `' + _ele3.id() + '`.  Bailing maximal adjustment due to cycle.  Use `options.maximal: true` only on DAGs.');
                break; // exit on failure
            }
        }
    }
    // find min distance we need to leave between nodes
    var minDistance = 0;
    if (options.avoidOverlap) for(var _i3 = 0; _i3 < nodes.length; _i3++){
        var n = nodes[_i3];
        var nbb = n.layoutDimensions(options);
        var w = nbb.w;
        var h = nbb.h;
        minDistance = Math.max(minDistance, w, h);
    }
    // get the weighted percent for an element based on its connectivity to other levels
    var cachedWeightedPercent = {};
    var getWeightedPercent = function getWeightedPercent(ele) {
        if (cachedWeightedPercent[ele.id()]) return cachedWeightedPercent[ele.id()];
        var eleDepth = $e815fda779bc047b$var$getInfo(ele).depth;
        var neighbors = ele.neighborhood();
        var percent = 0;
        var samples = 0;
        for(var _i4 = 0; _i4 < neighbors.length; _i4++){
            var neighbor = neighbors[_i4];
            if (neighbor.isEdge() || neighbor.isParent() || !nodes.has(neighbor)) continue;
            var bf = $e815fda779bc047b$var$getInfo(neighbor);
            if (bf == null) continue;
            var index = bf.index;
            var depth = bf.depth;
            // unassigned neighbours shouldn't affect the ordering
            if (index == null || depth == null) continue;
            var nDepth = depths[depth].length;
            if (depth < eleDepth) {
                // only get influenced by elements above
                percent += index / nDepth;
                samples++;
            }
        }
        samples = Math.max(1, samples);
        percent = percent / samples;
        if (samples === 0) // put lone nodes at the start
        percent = 0;
        cachedWeightedPercent[ele.id()] = percent;
        return percent;
    };
    // rearrange the indices in each depth level based on connectivity
    var sortFn = function sortFn(a, b) {
        var apct = getWeightedPercent(a);
        var bpct = getWeightedPercent(b);
        var diff = apct - bpct;
        if (diff === 0) return $e815fda779bc047b$var$ascending(a.id(), b.id()); // make sure sort doesn't have don't-care comparisons
        else return diff;
    };
    if (options.depthSort !== undefined) sortFn = options.depthSort;
    var depthsLen = depths.length;
    // sort each level to make connected nodes closer
    for(var _i5 = 0; _i5 < depthsLen; _i5++){
        depths[_i5].sort(sortFn);
        assignDepthsAt(_i5);
    }
    // assign orphan nodes to a new top-level depth
    var orphanDepth = [];
    for(var _i6 = 0; _i6 < orphanNodes.length; _i6++)orphanDepth.push(orphanNodes[_i6]);
    var assignDepths = function assignDepths() {
        for(var _i7 = 0; _i7 < depthsLen; _i7++)assignDepthsAt(_i7);
    };
    // add a new top-level depth only when there are orphan nodes
    if (orphanDepth.length) {
        depths.unshift(orphanDepth);
        depthsLen = depths.length;
        assignDepths();
    }
    var biggestDepthSize = 0;
    for(var _i8 = 0; _i8 < depthsLen; _i8++)biggestDepthSize = Math.max(depths[_i8].length, biggestDepthSize);
    var center = {
        x: bb.x1 + bb.w / 2,
        y: bb.y1 + bb.h / 2
    };
    // average node size
    var aveNodeSize = nodes.reduce(function(acc, node) {
        return function(box) {
            return {
                w: acc.w === -1 ? box.w : (acc.w + box.w) / 2,
                h: acc.h === -1 ? box.h : (acc.h + box.h) / 2
            };
        }(node.boundingBox({
            includeLabels: options.nodeDimensionsIncludeLabels
        }));
    }, {
        w: -1,
        h: -1
    });
    var distanceY = Math.max(// only one depth
    depthsLen === 1 ? 0 : // inside a bounding box, no need for top & bottom padding
    hasBoundingBox ? (bb.h - options.padding * 2 - aveNodeSize.h) / (depthsLen - 1) : (bb.h - options.padding * 2 - aveNodeSize.h) / (depthsLen + 1), minDistance);
    var maxDepthSize = depths.reduce(function(max, eles) {
        return Math.max(max, eles.length);
    }, 0);
    var getPositionTopBottom = function getPositionTopBottom(ele) {
        var _getInfo2 = $e815fda779bc047b$var$getInfo(ele), depth = _getInfo2.depth, index = _getInfo2.index;
        if (options.circle) {
            var radiusStepSize = Math.min(bb.w / 2 / depthsLen, bb.h / 2 / depthsLen);
            radiusStepSize = Math.max(radiusStepSize, minDistance);
            var radius = radiusStepSize * depth + radiusStepSize - (depthsLen > 0 && depths[0].length <= 3 ? radiusStepSize / 2 : 0);
            var theta = 2 * Math.PI / depths[depth].length * index;
            if (depth === 0 && depths[0].length === 1) radius = 1;
            return {
                x: center.x + radius * Math.cos(theta),
                y: center.y + radius * Math.sin(theta)
            };
        } else {
            var depthSize = depths[depth].length;
            var distanceX = Math.max(// only one depth
            depthSize === 1 ? 0 : // inside a bounding box, no need for left & right padding
            hasBoundingBox ? (bb.w - options.padding * 2 - aveNodeSize.w) / ((options.grid ? maxDepthSize : depthSize) - 1) : (bb.w - options.padding * 2 - aveNodeSize.w) / ((options.grid ? maxDepthSize : depthSize) + 1), minDistance);
            var epos = {
                x: center.x + (index + 1 - (depthSize + 1) / 2) * distanceX,
                y: center.y + (depth + 1 - (depthsLen + 1) / 2) * distanceY
            };
            return epos;
        }
    };
    var rotateDegrees = {
        'downward': 0,
        'leftward': 90,
        'upward': 180,
        'rightward': -90
    };
    if (Object.keys(rotateDegrees).indexOf(options.direction) === -1) $e815fda779bc047b$var$error("Invalid direction '".concat(options.direction, "' specified for breadthfirst layout. Valid values are: ").concat(Object.keys(rotateDegrees).join(', ')));
    var getPosition = function getPosition(ele) {
        return $e815fda779bc047b$var$rotatePosAndSkewByBox(getPositionTopBottom(ele), bb, rotateDegrees[options.direction]);
    };
    eles.nodes().layoutPositions(this, options, getPosition);
    return this; // chaining
};
var $e815fda779bc047b$var$defaults$6 = {
    fit: true,
    // whether to fit the viewport to the graph
    padding: 30,
    // the padding on fit
    boundingBox: undefined,
    // constrain layout bounds; { x1, y1, x2, y2 } or { x1, y1, w, h }
    avoidOverlap: true,
    // prevents node overlap, may overflow boundingBox and radius if not enough space
    nodeDimensionsIncludeLabels: false,
    // Excludes the label when calculating node bounding boxes for the layout algorithm
    spacingFactor: undefined,
    // Applies a multiplicative factor (>0) to expand or compress the overall area that the nodes take up
    radius: undefined,
    // the radius of the circle
    startAngle: 1.5 * Math.PI,
    // where nodes start in radians
    sweep: undefined,
    // how many radians should be between the first and last node (defaults to full circle)
    clockwise: true,
    // whether the layout should go clockwise (true) or counterclockwise/anticlockwise (false)
    sort: undefined,
    // a sorting function to order the nodes; e.g. function(a, b){ return a.data('weight') - b.data('weight') }
    animate: false,
    // whether to transition the node positions
    animationDuration: 500,
    // duration of animation in ms if enabled
    animationEasing: undefined,
    // easing of animation if enabled
    animateFilter: function animateFilter(node, i) {
        return true;
    },
    // a function that determines whether the node should be animated.  All nodes animated by default on animate enabled.  Non-animated nodes are positioned immediately when the layout starts
    ready: undefined,
    // callback on layoutready
    stop: undefined,
    // callback on layoutstop
    transform: function transform(node, position) {
        return position;
    } // transform a given node position. Useful for changing flow direction in discrete layouts 
};
function $e815fda779bc047b$var$CircleLayout(options) {
    this.options = $e815fda779bc047b$var$extend({}, $e815fda779bc047b$var$defaults$6, options);
}
$e815fda779bc047b$var$CircleLayout.prototype.run = function() {
    var params = this.options;
    var options = params;
    var cy = params.cy;
    var eles = options.eles;
    var clockwise = options.counterclockwise !== undefined ? !options.counterclockwise : options.clockwise;
    var nodes = eles.nodes().not(':parent');
    if (options.sort) nodes = nodes.sort(options.sort);
    var bb = $e815fda779bc047b$var$makeBoundingBox(options.boundingBox ? options.boundingBox : {
        x1: 0,
        y1: 0,
        w: cy.width(),
        h: cy.height()
    });
    var center = {
        x: bb.x1 + bb.w / 2,
        y: bb.y1 + bb.h / 2
    };
    var sweep = options.sweep === undefined ? 2 * Math.PI - 2 * Math.PI / nodes.length : options.sweep;
    var dTheta = sweep / Math.max(1, nodes.length - 1);
    var r;
    var minDistance = 0;
    for(var i = 0; i < nodes.length; i++){
        var n = nodes[i];
        var nbb = n.layoutDimensions(options);
        var w = nbb.w;
        var h = nbb.h;
        minDistance = Math.max(minDistance, w, h);
    }
    if ($e815fda779bc047b$var$number$1(options.radius)) r = options.radius;
    else if (nodes.length <= 1) r = 0;
    else r = Math.min(bb.h, bb.w) / 2 - minDistance;
    // calculate the radius
    if (nodes.length > 1 && options.avoidOverlap) {
        // but only if more than one node (can't overlap)
        minDistance *= 1.75; // just to have some nice spacing
        var dcos = Math.cos(dTheta) - Math.cos(0);
        var dsin = Math.sin(dTheta) - Math.sin(0);
        var rMin = Math.sqrt(minDistance * minDistance / (dcos * dcos + dsin * dsin)); // s.t. no nodes overlapping
        r = Math.max(rMin, r);
    }
    var getPos = function getPos(ele, i) {
        var theta = options.startAngle + i * dTheta * (clockwise ? 1 : -1);
        var rx = r * Math.cos(theta);
        var ry = r * Math.sin(theta);
        var pos = {
            x: center.x + rx,
            y: center.y + ry
        };
        return pos;
    };
    eles.nodes().layoutPositions(this, options, getPos);
    return this; // chaining
};
var $e815fda779bc047b$var$defaults$5 = {
    fit: true,
    // whether to fit the viewport to the graph
    padding: 30,
    // the padding on fit
    startAngle: 1.5 * Math.PI,
    // where nodes start in radians
    sweep: undefined,
    // how many radians should be between the first and last node (defaults to full circle)
    clockwise: true,
    // whether the layout should go clockwise (true) or counterclockwise/anticlockwise (false)
    equidistant: false,
    // whether levels have an equal radial distance betwen them, may cause bounding box overflow
    minNodeSpacing: 10,
    // min spacing between outside of nodes (used for radius adjustment)
    boundingBox: undefined,
    // constrain layout bounds; { x1, y1, x2, y2 } or { x1, y1, w, h }
    avoidOverlap: true,
    // prevents node overlap, may overflow boundingBox if not enough space
    nodeDimensionsIncludeLabels: false,
    // Excludes the label when calculating node bounding boxes for the layout algorithm
    height: undefined,
    // height of layout area (overrides container height)
    width: undefined,
    // width of layout area (overrides container width)
    spacingFactor: undefined,
    // Applies a multiplicative factor (>0) to expand or compress the overall area that the nodes take up
    concentric: function concentric(node) {
        // returns numeric value for each node, placing higher nodes in levels towards the centre
        return node.degree();
    },
    levelWidth: function levelWidth(nodes) {
        // the variation of concentric values in each level
        return nodes.maxDegree() / 4;
    },
    animate: false,
    // whether to transition the node positions
    animationDuration: 500,
    // duration of animation in ms if enabled
    animationEasing: undefined,
    // easing of animation if enabled
    animateFilter: function animateFilter(node, i) {
        return true;
    },
    // a function that determines whether the node should be animated.  All nodes animated by default on animate enabled.  Non-animated nodes are positioned immediately when the layout starts
    ready: undefined,
    // callback on layoutready
    stop: undefined,
    // callback on layoutstop
    transform: function transform(node, position) {
        return position;
    } // transform a given node position. Useful for changing flow direction in discrete layouts
};
function $e815fda779bc047b$var$ConcentricLayout(options) {
    this.options = $e815fda779bc047b$var$extend({}, $e815fda779bc047b$var$defaults$5, options);
}
$e815fda779bc047b$var$ConcentricLayout.prototype.run = function() {
    var params = this.options;
    var options = params;
    var clockwise = options.counterclockwise !== undefined ? !options.counterclockwise : options.clockwise;
    var cy = params.cy;
    var eles = options.eles;
    var nodes = eles.nodes().not(':parent');
    var bb = $e815fda779bc047b$var$makeBoundingBox(options.boundingBox ? options.boundingBox : {
        x1: 0,
        y1: 0,
        w: cy.width(),
        h: cy.height()
    });
    var center = {
        x: bb.x1 + bb.w / 2,
        y: bb.y1 + bb.h / 2
    };
    var nodeValues = []; // { node, value }
    var maxNodeSize = 0;
    for(var i = 0; i < nodes.length; i++){
        var node = nodes[i];
        var value = undefined;
        // calculate the node value
        value = options.concentric(node);
        nodeValues.push({
            value: value,
            node: node
        });
        // for style mapping
        node._private.scratch.concentric = value;
    }
    // in case we used the `concentric` in style
    nodes.updateStyle();
    // calculate max size now based on potentially updated mappers
    for(var _i = 0; _i < nodes.length; _i++){
        var _node = nodes[_i];
        var nbb = _node.layoutDimensions(options);
        maxNodeSize = Math.max(maxNodeSize, nbb.w, nbb.h);
    }
    // sort node values in descreasing order
    nodeValues.sort(function(a, b) {
        return b.value - a.value;
    });
    var levelWidth = options.levelWidth(nodes);
    // put the values into levels
    var levels = [
        []
    ];
    var currentLevel = levels[0];
    for(var _i2 = 0; _i2 < nodeValues.length; _i2++){
        var val = nodeValues[_i2];
        if (currentLevel.length > 0) {
            var diff = Math.abs(currentLevel[0].value - val.value);
            if (diff >= levelWidth) {
                currentLevel = [];
                levels.push(currentLevel);
            }
        }
        currentLevel.push(val);
    }
    // create positions from levels
    var minDist = maxNodeSize + options.minNodeSpacing; // min dist between nodes
    if (!options.avoidOverlap) {
        // then strictly constrain to bb
        var firstLvlHasMulti = levels.length > 0 && levels[0].length > 1;
        var maxR = Math.min(bb.w, bb.h) / 2 - minDist;
        var rStep = maxR / (levels.length + firstLvlHasMulti ? 1 : 0);
        minDist = Math.min(minDist, rStep);
    }
    // find the metrics for each level
    var r = 0;
    for(var _i3 = 0; _i3 < levels.length; _i3++){
        var level = levels[_i3];
        var sweep = options.sweep === undefined ? 2 * Math.PI - 2 * Math.PI / level.length : options.sweep;
        var dTheta = level.dTheta = sweep / Math.max(1, level.length - 1);
        // calculate the radius
        if (level.length > 1 && options.avoidOverlap) {
            // but only if more than one node (can't overlap)
            var dcos = Math.cos(dTheta) - Math.cos(0);
            var dsin = Math.sin(dTheta) - Math.sin(0);
            var rMin = Math.sqrt(minDist * minDist / (dcos * dcos + dsin * dsin)); // s.t. no nodes overlapping
            r = Math.max(rMin, r);
        }
        level.r = r;
        r += minDist;
    }
    if (options.equidistant) {
        var rDeltaMax = 0;
        var _r = 0;
        for(var _i4 = 0; _i4 < levels.length; _i4++){
            var _level = levels[_i4];
            var rDelta = _level.r - _r;
            rDeltaMax = Math.max(rDeltaMax, rDelta);
        }
        _r = 0;
        for(var _i5 = 0; _i5 < levels.length; _i5++){
            var _level2 = levels[_i5];
            if (_i5 === 0) _r = _level2.r;
            _level2.r = _r;
            _r += rDeltaMax;
        }
    }
    // calculate the node positions
    var pos = {}; // id => position
    for(var _i6 = 0; _i6 < levels.length; _i6++){
        var _level3 = levels[_i6];
        var _dTheta = _level3.dTheta;
        var _r2 = _level3.r;
        for(var j = 0; j < _level3.length; j++){
            var _val = _level3[j];
            var theta = options.startAngle + (clockwise ? 1 : -1) * _dTheta * j;
            var p = {
                x: center.x + _r2 * Math.cos(theta),
                y: center.y + _r2 * Math.sin(theta)
            };
            pos[_val.node.id()] = p;
        }
    }
    // position the nodes
    eles.nodes().layoutPositions(this, options, function(ele) {
        var id = ele.id();
        return pos[id];
    });
    return this; // chaining
};
/*
The CoSE layout was written by Gerardo Huck.
https://www.linkedin.com/in/gerardohuck/

Based on the following article:
http://dl.acm.org/citation.cfm?id=1498047

Modifications tracked on Github.
*/ var $e815fda779bc047b$var$DEBUG;
/**
 * @brief :  default layout options
 */ var $e815fda779bc047b$var$defaults$4 = {
    // Called on `layoutready`
    ready: function ready() {},
    // Called on `layoutstop`
    stop: function stop() {},
    // Whether to animate while running the layout
    // true : Animate continuously as the layout is running
    // false : Just show the end result
    // 'end' : Animate with the end result, from the initial positions to the end positions
    animate: true,
    // Easing of the animation for animate:'end'
    animationEasing: undefined,
    // The duration of the animation for animate:'end'
    animationDuration: undefined,
    // A function that determines whether the node should be animated
    // All nodes animated by default on animate enabled
    // Non-animated nodes are positioned immediately when the layout starts
    animateFilter: function animateFilter(node, i) {
        return true;
    },
    // The layout animates only after this many milliseconds for animate:true
    // (prevents flashing on fast runs)
    animationThreshold: 250,
    // Number of iterations between consecutive screen positions update
    refresh: 20,
    // Whether to fit the network view after when done
    fit: true,
    // Padding on fit
    padding: 30,
    // Constrain layout bounds; { x1, y1, x2, y2 } or { x1, y1, w, h }
    boundingBox: undefined,
    // Excludes the label when calculating node bounding boxes for the layout algorithm
    nodeDimensionsIncludeLabels: false,
    // Randomize the initial positions of the nodes (true) or use existing positions (false)
    randomize: false,
    // Extra spacing between components in non-compound graphs
    componentSpacing: 40,
    // Node repulsion (non overlapping) multiplier
    nodeRepulsion: function nodeRepulsion(node) {
        return 2048;
    },
    // Node repulsion (overlapping) multiplier
    nodeOverlap: 4,
    // Ideal edge (non nested) length
    idealEdgeLength: function idealEdgeLength(edge) {
        return 32;
    },
    // Divisor to compute edge forces
    edgeElasticity: function edgeElasticity(edge) {
        return 32;
    },
    // Nesting factor (multiplier) to compute ideal edge length for nested edges
    nestingFactor: 1.2,
    // Gravity force (constant)
    gravity: 1,
    // Maximum number of iterations to perform
    numIter: 1000,
    // Initial temperature (maximum node displacement)
    initialTemp: 1000,
    // Cooling factor (how the temperature is reduced between consecutive iterations
    coolingFactor: 0.99,
    // Lower temperature threshold (below this point the layout will end)
    minTemp: 1.0
};
/**
 * @brief       : constructor
 * @arg options : object containing layout options
 */ function $e815fda779bc047b$var$CoseLayout(options) {
    this.options = $e815fda779bc047b$var$extend({}, $e815fda779bc047b$var$defaults$4, options);
    this.options.layout = this;
    // Exclude any edge that has a source or target node that is not in the set of passed-in nodes
    var nodes = this.options.eles.nodes();
    var edges = this.options.eles.edges();
    var notEdges = edges.filter(function(e) {
        var sourceId = e.source().data('id');
        var targetId = e.target().data('id');
        var hasSource = nodes.some(function(n) {
            return n.data('id') === sourceId;
        });
        var hasTarget = nodes.some(function(n) {
            return n.data('id') === targetId;
        });
        return !hasSource || !hasTarget;
    });
    this.options.eles = this.options.eles.not(notEdges);
}
/**
 * @brief : runs the layout
 */ $e815fda779bc047b$var$CoseLayout.prototype.run = function() {
    var options = this.options;
    var cy = options.cy;
    var layout = this;
    layout.stopped = false;
    if (options.animate === true || options.animate === false) layout.emit({
        type: 'layoutstart',
        layout: layout
    });
    // Set DEBUG - Global variable
    if (true === options.debug) $e815fda779bc047b$var$DEBUG = true;
    else $e815fda779bc047b$var$DEBUG = false;
    // Initialize layout info
    var layoutInfo = $e815fda779bc047b$var$createLayoutInfo(cy, layout, options);
    // Show LayoutInfo contents if debugging
    if ($e815fda779bc047b$var$DEBUG) $e815fda779bc047b$var$printLayoutInfo(layoutInfo);
    // If required, randomize node positions
    if (options.randomize) $e815fda779bc047b$var$randomizePositions(layoutInfo);
    var startTime = $e815fda779bc047b$var$performanceNow();
    var refresh = function refresh() {
        $e815fda779bc047b$var$refreshPositions(layoutInfo, cy, options);
        // Fit the graph if necessary
        if (true === options.fit) cy.fit(options.padding);
    };
    var mainLoop = function mainLoop(i) {
        if (layout.stopped || i >= options.numIter) // logDebug("Layout manually stopped. Stopping computation in step " + i);
        return false;
        // Do one step in the phisical simulation
        $e815fda779bc047b$var$step(layoutInfo, options);
        // Update temperature
        layoutInfo.temperature = layoutInfo.temperature * options.coolingFactor;
        // logDebug("New temperature: " + layoutInfo.temperature);
        if (layoutInfo.temperature < options.minTemp) // logDebug("Temperature drop below minimum threshold. Stopping computation in step " + i);
        return false;
        return true;
    };
    var done = function done() {
        if (options.animate === true || options.animate === false) {
            refresh();
            // Layout has finished
            layout.one('layoutstop', options.stop);
            layout.emit({
                type: 'layoutstop',
                layout: layout
            });
        } else {
            var nodes = options.eles.nodes();
            var getScaledPos = $e815fda779bc047b$var$getScaleInBoundsFn(layoutInfo, options, nodes);
            nodes.layoutPositions(layout, options, getScaledPos);
        }
    };
    var i = 0;
    var loopRet = true;
    if (options.animate === true) {
        var _frame = function frame() {
            var f = 0;
            while(loopRet && f < options.refresh){
                loopRet = mainLoop(i);
                i++;
                f++;
            }
            if (!loopRet) {
                // it's done
                $e815fda779bc047b$var$separateComponents(layoutInfo, options);
                done();
            } else {
                var now = $e815fda779bc047b$var$performanceNow();
                if (now - startTime >= options.animationThreshold) refresh();
                $e815fda779bc047b$var$requestAnimationFrame(_frame);
            }
        };
        _frame();
    } else {
        while(loopRet){
            loopRet = mainLoop(i);
            i++;
        }
        $e815fda779bc047b$var$separateComponents(layoutInfo, options);
        done();
    }
    return this; // chaining
};
/**
 * @brief : called on continuous layouts to stop them before they finish
 */ $e815fda779bc047b$var$CoseLayout.prototype.stop = function() {
    this.stopped = true;
    if (this.thread) this.thread.stop();
    this.emit('layoutstop');
    return this; // chaining
};
$e815fda779bc047b$var$CoseLayout.prototype.destroy = function() {
    if (this.thread) this.thread.stop();
    return this; // chaining
};
/**
 * @brief     : Creates an object which is contains all the data
 *              used in the layout process
 * @arg cy    : cytoscape.js object
 * @return    : layoutInfo object initialized
 */ var $e815fda779bc047b$var$createLayoutInfo = function createLayoutInfo(cy, layout, options) {
    // Shortcut
    var edges = options.eles.edges();
    var nodes = options.eles.nodes();
    var bb = $e815fda779bc047b$var$makeBoundingBox(options.boundingBox ? options.boundingBox : {
        x1: 0,
        y1: 0,
        w: cy.width(),
        h: cy.height()
    });
    var layoutInfo = {
        isCompound: cy.hasCompoundNodes(),
        layoutNodes: [],
        idToIndex: {},
        nodeSize: nodes.size(),
        graphSet: [],
        indexToGraph: [],
        layoutEdges: [],
        edgeSize: edges.size(),
        temperature: options.initialTemp,
        clientWidth: bb.w,
        clientHeight: bb.h,
        boundingBox: bb
    };
    var components = options.eles.components();
    var id2cmptId = {};
    for(var i = 0; i < components.length; i++){
        var component = components[i];
        for(var j = 0; j < component.length; j++){
            var node = component[j];
            id2cmptId[node.id()] = i;
        }
    }
    // Iterate over all nodes, creating layout nodes
    for(var i = 0; i < layoutInfo.nodeSize; i++){
        var n = nodes[i];
        var nbb = n.layoutDimensions(options);
        var tempNode = {};
        tempNode.isLocked = n.locked();
        tempNode.id = n.data('id');
        tempNode.parentId = n.data('parent');
        tempNode.cmptId = id2cmptId[n.id()];
        tempNode.children = [];
        tempNode.positionX = n.position('x');
        tempNode.positionY = n.position('y');
        tempNode.offsetX = 0;
        tempNode.offsetY = 0;
        tempNode.height = nbb.w;
        tempNode.width = nbb.h;
        tempNode.maxX = tempNode.positionX + tempNode.width / 2;
        tempNode.minX = tempNode.positionX - tempNode.width / 2;
        tempNode.maxY = tempNode.positionY + tempNode.height / 2;
        tempNode.minY = tempNode.positionY - tempNode.height / 2;
        tempNode.padLeft = parseFloat(n.style('padding'));
        tempNode.padRight = parseFloat(n.style('padding'));
        tempNode.padTop = parseFloat(n.style('padding'));
        tempNode.padBottom = parseFloat(n.style('padding'));
        // forces
        tempNode.nodeRepulsion = $e815fda779bc047b$var$fn$6(options.nodeRepulsion) ? options.nodeRepulsion(n) : options.nodeRepulsion;
        // Add new node
        layoutInfo.layoutNodes.push(tempNode);
        // Add entry to id-index map
        layoutInfo.idToIndex[tempNode.id] = i;
    }
    // Inline implementation of a queue, used for traversing the graph in BFS order
    var queue = [];
    var start = 0; // Points to the start the queue
    var end = -1; // Points to the end of the queue
    var tempGraph = [];
    // Second pass to add child information and
    // initialize queue for hierarchical traversal
    for(var i = 0; i < layoutInfo.nodeSize; i++){
        var n = layoutInfo.layoutNodes[i];
        var p_id = n.parentId;
        // Check if node n has a parent node
        if (null != p_id) // Add node Id to parent's list of children
        layoutInfo.layoutNodes[layoutInfo.idToIndex[p_id]].children.push(n.id);
        else {
            // If a node doesn't have a parent, then it's in the root graph
            queue[++end] = n.id;
            tempGraph.push(n.id);
        }
    }
    // Add root graph to graphSet
    layoutInfo.graphSet.push(tempGraph);
    // Traverse the graph, level by level,
    while(start <= end){
        // Get the node to visit and remove it from queue
        var node_id = queue[start++];
        var node_ix = layoutInfo.idToIndex[node_id];
        var node = layoutInfo.layoutNodes[node_ix];
        var children = node.children;
        if (children.length > 0) {
            // Add children nodes as a new graph to graph set
            layoutInfo.graphSet.push(children);
            // Add children to que queue to be visited
            for(var i = 0; i < children.length; i++)queue[++end] = children[i];
        }
    }
    // Create indexToGraph map
    for(var i = 0; i < layoutInfo.graphSet.length; i++){
        var graph = layoutInfo.graphSet[i];
        for(var j = 0; j < graph.length; j++){
            var index = layoutInfo.idToIndex[graph[j]];
            layoutInfo.indexToGraph[index] = i;
        }
    }
    // Iterate over all edges, creating Layout Edges
    for(var i = 0; i < layoutInfo.edgeSize; i++){
        var e = edges[i];
        var tempEdge = {};
        tempEdge.id = e.data('id');
        tempEdge.sourceId = e.data('source');
        tempEdge.targetId = e.data('target');
        // Compute ideal length
        var idealLength = $e815fda779bc047b$var$fn$6(options.idealEdgeLength) ? options.idealEdgeLength(e) : options.idealEdgeLength;
        var elasticity = $e815fda779bc047b$var$fn$6(options.edgeElasticity) ? options.edgeElasticity(e) : options.edgeElasticity;
        // Check if it's an inter graph edge
        var sourceIx = layoutInfo.idToIndex[tempEdge.sourceId];
        var targetIx = layoutInfo.idToIndex[tempEdge.targetId];
        var sourceGraph = layoutInfo.indexToGraph[sourceIx];
        var targetGraph = layoutInfo.indexToGraph[targetIx];
        if (sourceGraph != targetGraph) {
            // Find lowest common graph ancestor
            var lca = $e815fda779bc047b$var$findLCA(tempEdge.sourceId, tempEdge.targetId, layoutInfo);
            // Compute sum of node depths, relative to lca graph
            var lcaGraph = layoutInfo.graphSet[lca];
            var depth = 0;
            // Source depth
            var tempNode = layoutInfo.layoutNodes[sourceIx];
            while(-1 === lcaGraph.indexOf(tempNode.id)){
                tempNode = layoutInfo.layoutNodes[layoutInfo.idToIndex[tempNode.parentId]];
                depth++;
            }
            // Target depth
            tempNode = layoutInfo.layoutNodes[targetIx];
            while(-1 === lcaGraph.indexOf(tempNode.id)){
                tempNode = layoutInfo.layoutNodes[layoutInfo.idToIndex[tempNode.parentId]];
                depth++;
            }
            // logDebug('LCA of nodes ' + tempEdge.sourceId + ' and ' + tempEdge.targetId +
            //  ". Index: " + lca + " Contents: " + lcaGraph.toString() +
            //  ". Depth: " + depth);
            // Update idealLength
            idealLength *= depth * options.nestingFactor;
        }
        tempEdge.idealLength = idealLength;
        tempEdge.elasticity = elasticity;
        layoutInfo.layoutEdges.push(tempEdge);
    }
    // Finally, return layoutInfo object
    return layoutInfo;
};
/**
 * @brief : This function finds the index of the lowest common
 *          graph ancestor between 2 nodes in the subtree
 *          (from the graph hierarchy induced tree) whose
 *          root is graphIx
 *
 * @arg node1: node1's ID
 * @arg node2: node2's ID
 * @arg layoutInfo: layoutInfo object
 *
 */ var $e815fda779bc047b$var$findLCA = function findLCA(node1, node2, layoutInfo) {
    // Find their common ancester, starting from the root graph
    var res = $e815fda779bc047b$var$_findLCA_aux(node1, node2, 0, layoutInfo);
    if (2 > res.count) // If aux function couldn't find the common ancester,
    // then it is the root graph
    return 0;
    else return res.graph;
};
/**
 * @brief          : Auxiliary function used for LCA computation
 *
 * @arg node1      : node1's ID
 * @arg node2      : node2's ID
 * @arg graphIx    : subgraph index
 * @arg layoutInfo : layoutInfo object
 *
 * @return         : object of the form {count: X, graph: Y}, where:
 *                   X is the number of ancestors (max: 2) found in
 *                   graphIx (and it's subgraphs),
 *                   Y is the graph index of the lowest graph containing
 *                   all X nodes
 */ var $e815fda779bc047b$var$_findLCA_aux = function findLCA_aux(node1, node2, graphIx, layoutInfo) {
    var graph = layoutInfo.graphSet[graphIx];
    // If both nodes belongs to graphIx
    if (-1 < graph.indexOf(node1) && -1 < graph.indexOf(node2)) return {
        count: 2,
        graph: graphIx
    };
    // Make recursive calls for all subgraphs
    var c = 0;
    for(var i = 0; i < graph.length; i++){
        var nodeId = graph[i];
        var nodeIx = layoutInfo.idToIndex[nodeId];
        var children = layoutInfo.layoutNodes[nodeIx].children;
        // If the node has no child, skip it
        if (0 === children.length) continue;
        var childGraphIx = layoutInfo.indexToGraph[layoutInfo.idToIndex[children[0]]];
        var result = $e815fda779bc047b$var$_findLCA_aux(node1, node2, childGraphIx, layoutInfo);
        if (0 === result.count) continue;
        else if (1 === result.count) {
            // One of (node1, node2) is present in this subgraph
            c++;
            if (2 === c) break;
        } else // Both nodes are present in this subgraph
        return result;
    }
    return {
        count: c,
        graph: graphIx
    };
};
/**
 * @brief: printsLayoutInfo into js console
 *         Only used for debbuging
 */ var $e815fda779bc047b$var$printLayoutInfo;
/**
 * @brief : Randomizes the position of all nodes
 */ var $e815fda779bc047b$var$randomizePositions = function randomizePositions(layoutInfo, cy) {
    var width = layoutInfo.clientWidth;
    var height = layoutInfo.clientHeight;
    for(var i = 0; i < layoutInfo.nodeSize; i++){
        var n = layoutInfo.layoutNodes[i];
        // No need to randomize compound nodes or locked nodes
        if (0 === n.children.length && !n.isLocked) {
            n.positionX = Math.random() * width;
            n.positionY = Math.random() * height;
        }
    }
};
var $e815fda779bc047b$var$getScaleInBoundsFn = function getScaleInBoundsFn(layoutInfo, options, nodes) {
    var bb = layoutInfo.boundingBox;
    var coseBB = {
        x1: Infinity,
        x2: -Infinity,
        y1: Infinity,
        y2: -Infinity
    };
    if (options.boundingBox) {
        nodes.forEach(function(node) {
            var lnode = layoutInfo.layoutNodes[layoutInfo.idToIndex[node.data('id')]];
            coseBB.x1 = Math.min(coseBB.x1, lnode.positionX);
            coseBB.x2 = Math.max(coseBB.x2, lnode.positionX);
            coseBB.y1 = Math.min(coseBB.y1, lnode.positionY);
            coseBB.y2 = Math.max(coseBB.y2, lnode.positionY);
        });
        coseBB.w = coseBB.x2 - coseBB.x1;
        coseBB.h = coseBB.y2 - coseBB.y1;
    }
    return function(ele, i) {
        var lnode = layoutInfo.layoutNodes[layoutInfo.idToIndex[ele.data('id')]];
        if (options.boundingBox) {
            // then add extra bounding box constraint
            // Handle single node case where coseBB.w or coseBB.h is 0
            var pctX = coseBB.w === 0 ? 0.5 : (lnode.positionX - coseBB.x1) / coseBB.w;
            var pctY = coseBB.h === 0 ? 0.5 : (lnode.positionY - coseBB.y1) / coseBB.h;
            return {
                x: bb.x1 + pctX * bb.w,
                y: bb.y1 + pctY * bb.h
            };
        } else return {
            x: lnode.positionX,
            y: lnode.positionY
        };
    };
};
/**
 * @brief          : Updates the positions of nodes in the network
 * @arg layoutInfo : LayoutInfo object
 * @arg cy         : Cytoscape object
 * @arg options    : Layout options
 */ var $e815fda779bc047b$var$refreshPositions = function refreshPositions(layoutInfo, cy, options) {
    // var s = 'Refreshing positions';
    // logDebug(s);
    var layout = options.layout;
    var nodes = options.eles.nodes();
    var getScaledPos = $e815fda779bc047b$var$getScaleInBoundsFn(layoutInfo, options, nodes);
    nodes.positions(getScaledPos);
    // Trigger layoutReady only on first call
    if (true !== layoutInfo.ready) {
        // s = 'Triggering layoutready';
        // logDebug(s);
        layoutInfo.ready = true;
        layout.one('layoutready', options.ready);
        layout.emit({
            type: 'layoutready',
            layout: this
        });
    }
};
/**
 * @brief : Logs a debug message in JS console, if DEBUG is ON
 */ // var logDebug = function(text) {
//   if (DEBUG) {
//     console.debug(text);
//   }
// };
/**
 * @brief          : Performs one iteration of the physical simulation
 * @arg layoutInfo : LayoutInfo object already initialized
 * @arg cy         : Cytoscape object
 * @arg options    : Layout options
 */ var $e815fda779bc047b$var$step = function step(layoutInfo, options, _step) {
    // var s = "\n\n###############################";
    // s += "\nSTEP: " + step;
    // s += "\n###############################\n";
    // logDebug(s);
    // Calculate node repulsions
    $e815fda779bc047b$var$calculateNodeForces(layoutInfo, options);
    // Calculate edge forces
    $e815fda779bc047b$var$calculateEdgeForces(layoutInfo);
    // Calculate gravity forces
    $e815fda779bc047b$var$calculateGravityForces(layoutInfo, options);
    // Propagate forces from parent to child
    $e815fda779bc047b$var$propagateForces(layoutInfo);
    // Update positions based on calculated forces
    $e815fda779bc047b$var$updatePositions(layoutInfo);
};
/**
 * @brief : Computes the node repulsion forces
 */ var $e815fda779bc047b$var$calculateNodeForces = function calculateNodeForces(layoutInfo, options) {
    // Go through each of the graphs in graphSet
    // Nodes only repel each other if they belong to the same graph
    // var s = 'calculateNodeForces';
    // logDebug(s);
    for(var i = 0; i < layoutInfo.graphSet.length; i++){
        var graph = layoutInfo.graphSet[i];
        var numNodes = graph.length;
        // s = "Set: " + graph.toString();
        // logDebug(s);
        // Now get all the pairs of nodes
        // Only get each pair once, (A, B) = (B, A)
        for(var j = 0; j < numNodes; j++){
            var node1 = layoutInfo.layoutNodes[layoutInfo.idToIndex[graph[j]]];
            for(var k = j + 1; k < numNodes; k++){
                var node2 = layoutInfo.layoutNodes[layoutInfo.idToIndex[graph[k]]];
                $e815fda779bc047b$var$nodeRepulsion(node1, node2, layoutInfo, options);
            }
        }
    }
};
var $e815fda779bc047b$var$randomDistance = function randomDistance(max) {
    return -1 + 2 * max * Math.random();
};
/**
 * @brief : Compute the node repulsion forces between a pair of nodes
 */ var $e815fda779bc047b$var$nodeRepulsion = function nodeRepulsion(node1, node2, layoutInfo, options) {
    // var s = "Node repulsion. Node1: " + node1.id + " Node2: " + node2.id;
    var cmptId1 = node1.cmptId;
    var cmptId2 = node2.cmptId;
    if (cmptId1 !== cmptId2 && !layoutInfo.isCompound) return;
    // Get direction of line connecting both node centers
    var directionX = node2.positionX - node1.positionX;
    var directionY = node2.positionY - node1.positionY;
    var maxRandDist = 1;
    // s += "\ndirectionX: " + directionX + ", directionY: " + directionY;
    // If both centers are the same, apply a random force
    if (0 === directionX && 0 === directionY) {
        directionX = $e815fda779bc047b$var$randomDistance(maxRandDist);
        directionY = $e815fda779bc047b$var$randomDistance(maxRandDist);
    }
    var overlap = $e815fda779bc047b$var$nodesOverlap(node1, node2, directionX, directionY);
    if (overlap > 0) {
        // s += "\nNodes DO overlap.";
        // s += "\nOverlap: " + overlap;
        // If nodes overlap, repulsion force is proportional
        // to the overlap
        var force = options.nodeOverlap * overlap;
        // Compute the module and components of the force vector
        var distance = Math.sqrt(directionX * directionX + directionY * directionY);
        // s += "\nDistance: " + distance;
        var forceX = force * directionX / distance;
        var forceY = force * directionY / distance;
    } else {
        // s += "\nNodes do NOT overlap.";
        // If there's no overlap, force is inversely proportional
        // to squared distance
        // Get clipping points for both nodes
        var point1 = $e815fda779bc047b$var$findClippingPoint(node1, directionX, directionY);
        var point2 = $e815fda779bc047b$var$findClippingPoint(node2, -1 * directionX, -1 * directionY);
        // Use clipping points to compute distance
        var distanceX = point2.x - point1.x;
        var distanceY = point2.y - point1.y;
        var distanceSqr = distanceX * distanceX + distanceY * distanceY;
        var distance = Math.sqrt(distanceSqr);
        // s += "\nDistance: " + distance;
        // Compute the module and components of the force vector
        var force = (node1.nodeRepulsion + node2.nodeRepulsion) / distanceSqr;
        var forceX = force * distanceX / distance;
        var forceY = force * distanceY / distance;
    }
    // Apply force
    if (!node1.isLocked) {
        node1.offsetX -= forceX;
        node1.offsetY -= forceY;
    }
    if (!node2.isLocked) {
        node2.offsetX += forceX;
        node2.offsetY += forceY;
    }
    // s += "\nForceX: " + forceX + " ForceY: " + forceY;
    // logDebug(s);
    return;
};
/**
 * @brief  : Determines whether two nodes overlap or not
 * @return : Amount of overlapping (0 => no overlap)
 */ var $e815fda779bc047b$var$nodesOverlap = function nodesOverlap(node1, node2, dX, dY) {
    if (dX > 0) var overlapX = node1.maxX - node2.minX;
    else var overlapX = node2.maxX - node1.minX;
    if (dY > 0) var overlapY = node1.maxY - node2.minY;
    else var overlapY = node2.maxY - node1.minY;
    if (overlapX >= 0 && overlapY >= 0) return Math.sqrt(overlapX * overlapX + overlapY * overlapY);
    else return 0;
};
/**
 * @brief : Finds the point in which an edge (direction dX, dY) intersects
 *          the rectangular bounding box of it's source/target node
 */ var $e815fda779bc047b$var$findClippingPoint = function findClippingPoint(node, dX, dY) {
    // Shorcuts
    var X = node.positionX;
    var Y = node.positionY;
    var H = node.height || 1;
    var W = node.width || 1;
    var dirSlope = dY / dX;
    var nodeSlope = H / W;
    // var s = 'Computing clipping point of node ' + node.id +
    //   " . Height:  " + H + ", Width: " + W +
    //   "\nDirection " + dX + ", " + dY;
    //
    // Compute intersection
    var res = {};
    // Case: Vertical direction (up)
    if (0 === dX && 0 < dY) {
        res.x = X;
        // s += "\nUp direction";
        res.y = Y + H / 2;
        return res;
    }
    // Case: Vertical direction (down)
    if (0 === dX && 0 > dY) {
        res.x = X;
        res.y = Y + H / 2;
        // s += "\nDown direction";
        return res;
    }
    // Case: Intersects the right border
    if (0 < dX && -1 * nodeSlope <= dirSlope && dirSlope <= nodeSlope) {
        res.x = X + W / 2;
        res.y = Y + W * dY / 2 / dX;
        // s += "\nRightborder";
        return res;
    }
    // Case: Intersects the left border
    if (0 > dX && -1 * nodeSlope <= dirSlope && dirSlope <= nodeSlope) {
        res.x = X - W / 2;
        res.y = Y - W * dY / 2 / dX;
        // s += "\nLeftborder";
        return res;
    }
    // Case: Intersects the top border
    if (0 < dY && (dirSlope <= -1 * nodeSlope || dirSlope >= nodeSlope)) {
        res.x = X + H * dX / 2 / dY;
        res.y = Y + H / 2;
        // s += "\nTop border";
        return res;
    }
    // Case: Intersects the bottom border
    if (0 > dY && (dirSlope <= -1 * nodeSlope || dirSlope >= nodeSlope)) {
        res.x = X - H * dX / 2 / dY;
        res.y = Y - H / 2;
        // s += "\nBottom border";
        return res;
    }
    // s += "\nClipping point found at " + res.x + ", " + res.y;
    // logDebug(s);
    return res;
};
/**
 * @brief : Calculates all edge forces
 */ var $e815fda779bc047b$var$calculateEdgeForces = function calculateEdgeForces(layoutInfo, options) {
    // Iterate over all edges
    for(var i = 0; i < layoutInfo.edgeSize; i++){
        // Get edge, source & target nodes
        var edge = layoutInfo.layoutEdges[i];
        var sourceIx = layoutInfo.idToIndex[edge.sourceId];
        var source = layoutInfo.layoutNodes[sourceIx];
        var targetIx = layoutInfo.idToIndex[edge.targetId];
        var target = layoutInfo.layoutNodes[targetIx];
        // Get direction of line connecting both node centers
        var directionX = target.positionX - source.positionX;
        var directionY = target.positionY - source.positionY;
        // If both centers are the same, do nothing.
        // A random force has already been applied as node repulsion
        if (0 === directionX && 0 === directionY) continue;
        // Get clipping points for both nodes
        var point1 = $e815fda779bc047b$var$findClippingPoint(source, directionX, directionY);
        var point2 = $e815fda779bc047b$var$findClippingPoint(target, -1 * directionX, -1 * directionY);
        var lx = point2.x - point1.x;
        var ly = point2.y - point1.y;
        var l = Math.sqrt(lx * lx + ly * ly);
        var force = Math.pow(edge.idealLength - l, 2) / edge.elasticity;
        if (0 !== l) {
            var forceX = force * lx / l;
            var forceY = force * ly / l;
        } else {
            var forceX = 0;
            var forceY = 0;
        }
        // Add this force to target and source nodes
        if (!source.isLocked) {
            source.offsetX += forceX;
            source.offsetY += forceY;
        }
        if (!target.isLocked) {
            target.offsetX -= forceX;
            target.offsetY -= forceY;
        }
    // var s = 'Edge force between nodes ' + source.id + ' and ' + target.id;
    // s += "\nDistance: " + l + " Force: (" + forceX + ", " + forceY + ")";
    // logDebug(s);
    }
};
/**
 * @brief : Computes gravity forces for all nodes
 */ var $e815fda779bc047b$var$calculateGravityForces = function calculateGravityForces(layoutInfo, options) {
    if (options.gravity === 0) return;
    var distThreshold = 1;
    // var s = 'calculateGravityForces';
    // logDebug(s);
    for(var i = 0; i < layoutInfo.graphSet.length; i++){
        var graph = layoutInfo.graphSet[i];
        var numNodes = graph.length;
        // s = "Set: " + graph.toString();
        // logDebug(s);
        // Compute graph center
        if (0 === i) {
            var centerX = layoutInfo.clientHeight / 2;
            var centerY = layoutInfo.clientWidth / 2;
        } else {
            // Get Parent node for this graph, and use its position as center
            var temp = layoutInfo.layoutNodes[layoutInfo.idToIndex[graph[0]]];
            var parent = layoutInfo.layoutNodes[layoutInfo.idToIndex[temp.parentId]];
            var centerX = parent.positionX;
            var centerY = parent.positionY;
        }
        // s = "Center found at: " + centerX + ", " + centerY;
        // logDebug(s);
        // Apply force to all nodes in graph
        for(var j = 0; j < numNodes; j++){
            var node = layoutInfo.layoutNodes[layoutInfo.idToIndex[graph[j]]];
            // s = "Node: " + node.id;
            if (node.isLocked) continue;
            var dx = centerX - node.positionX;
            var dy = centerY - node.positionY;
            var d = Math.sqrt(dx * dx + dy * dy);
            if (d > distThreshold) {
                var fx = options.gravity * dx / d;
                var fy = options.gravity * dy / d;
                node.offsetX += fx;
                node.offsetY += fy;
            // s += ": Applied force: " + fx + ", " + fy;
            }
        // logDebug(s);
        }
    }
};
/**
 * @brief          : This function propagates the existing offsets from
 *                   parent nodes to its descendents.
 * @arg layoutInfo : layoutInfo Object
 * @arg cy         : cytoscape Object
 * @arg options    : Layout options
 */ var $e815fda779bc047b$var$propagateForces = function propagateForces(layoutInfo, options) {
    // Inline implementation of a queue, used for traversing the graph in BFS order
    var queue = [];
    var start = 0; // Points to the start the queue
    var end = -1; // Points to the end of the queue
    // logDebug('propagateForces');
    // Start by visiting the nodes in the root graph
    queue.push.apply(queue, layoutInfo.graphSet[0]);
    end += layoutInfo.graphSet[0].length;
    // Traverse the graph, level by level,
    while(start <= end){
        // Get the node to visit and remove it from queue
        var nodeId = queue[start++];
        var nodeIndex = layoutInfo.idToIndex[nodeId];
        var node = layoutInfo.layoutNodes[nodeIndex];
        var children = node.children;
        // We only need to process the node if it's compound
        if (0 < children.length && !node.isLocked) {
            var offX = node.offsetX;
            var offY = node.offsetY;
            // var s = "Propagating offset from parent node : " + node.id +
            //   ". OffsetX: " + offX + ". OffsetY: " + offY;
            // s += "\n Children: " + children.toString();
            // logDebug(s);
            for(var i = 0; i < children.length; i++){
                var childNode = layoutInfo.layoutNodes[layoutInfo.idToIndex[children[i]]];
                // Propagate offset
                childNode.offsetX += offX;
                childNode.offsetY += offY;
                // Add children to queue to be visited
                queue[++end] = children[i];
            }
            // Reset parent offsets
            node.offsetX = 0;
            node.offsetY = 0;
        }
    }
};
/**
 * @brief : Updates the layout model positions, based on
 *          the accumulated forces
 */ var $e815fda779bc047b$var$updatePositions = function updatePositions(layoutInfo, options) {
    // var s = 'Updating positions';
    // logDebug(s);
    // Reset boundaries for compound nodes
    for(var i = 0; i < layoutInfo.nodeSize; i++){
        var n = layoutInfo.layoutNodes[i];
        if (0 < n.children.length) {
            // logDebug("Resetting boundaries of compound node: " + n.id);
            n.maxX = undefined;
            n.minX = undefined;
            n.maxY = undefined;
            n.minY = undefined;
        }
    }
    for(var i = 0; i < layoutInfo.nodeSize; i++){
        var n = layoutInfo.layoutNodes[i];
        if (0 < n.children.length || n.isLocked) continue;
        // s = "Node: " + n.id + " Previous position: (" +
        // n.positionX + ", " + n.positionY + ").";
        // Limit displacement in order to improve stability
        var tempForce = $e815fda779bc047b$var$limitForce(n.offsetX, n.offsetY, layoutInfo.temperature);
        n.positionX += tempForce.x;
        n.positionY += tempForce.y;
        n.offsetX = 0;
        n.offsetY = 0;
        n.minX = n.positionX - n.width;
        n.maxX = n.positionX + n.width;
        n.minY = n.positionY - n.height;
        n.maxY = n.positionY + n.height;
        // s += " New Position: (" + n.positionX + ", " + n.positionY + ").";
        // logDebug(s);
        // Update ancestry boudaries
        $e815fda779bc047b$var$_updateAncestryBoundaries(n, layoutInfo);
    }
    // Update size, position of compund nodes
    for(var i = 0; i < layoutInfo.nodeSize; i++){
        var n = layoutInfo.layoutNodes[i];
        if (0 < n.children.length && !n.isLocked) {
            n.positionX = (n.maxX + n.minX) / 2;
            n.positionY = (n.maxY + n.minY) / 2;
            n.width = n.maxX - n.minX;
            n.height = n.maxY - n.minY;
        // s = "Updating position, size of compound node " + n.id;
        // s += "\nPositionX: " + n.positionX + ", PositionY: " + n.positionY;
        // s += "\nWidth: " + n.width + ", Height: " + n.height;
        // logDebug(s);
        }
    }
};
/**
 * @brief : Limits a force (forceX, forceY) to be not
 *          greater (in modulo) than max.
 8          Preserves force direction.
  */ var $e815fda779bc047b$var$limitForce = function limitForce(forceX, forceY, max) {
    // var s = "Limiting force: (" + forceX + ", " + forceY + "). Max: " + max;
    var force = Math.sqrt(forceX * forceX + forceY * forceY);
    if (force > max) var res = {
        x: max * forceX / force,
        y: max * forceY / force
    };
    else var res = {
        x: forceX,
        y: forceY
    };
    // s += ".\nResult: (" + res.x + ", " + res.y + ")";
    // logDebug(s);
    return res;
};
/**
 * @brief : Function used for keeping track of compound node
 *          sizes, since they should bound all their subnodes.
 */ var $e815fda779bc047b$var$_updateAncestryBoundaries = function updateAncestryBoundaries(node, layoutInfo) {
    // var s = "Propagating new position/size of node " + node.id;
    var parentId = node.parentId;
    if (null == parentId) // If there's no parent, we are done
    // s += ". No parent node.";
    // logDebug(s);
    return;
    // Get Parent Node
    var p = layoutInfo.layoutNodes[layoutInfo.idToIndex[parentId]];
    var flag = false;
    // MaxX
    if (null == p.maxX || node.maxX + p.padRight > p.maxX) {
        p.maxX = node.maxX + p.padRight;
        flag = true;
    // s += "\nNew maxX for parent node " + p.id + ": " + p.maxX;
    }
    // MinX
    if (null == p.minX || node.minX - p.padLeft < p.minX) {
        p.minX = node.minX - p.padLeft;
        flag = true;
    // s += "\nNew minX for parent node " + p.id + ": " + p.minX;
    }
    // MaxY
    if (null == p.maxY || node.maxY + p.padBottom > p.maxY) {
        p.maxY = node.maxY + p.padBottom;
        flag = true;
    // s += "\nNew maxY for parent node " + p.id + ": " + p.maxY;
    }
    // MinY
    if (null == p.minY || node.minY - p.padTop < p.minY) {
        p.minY = node.minY - p.padTop;
        flag = true;
    // s += "\nNew minY for parent node " + p.id + ": " + p.minY;
    }
    // If updated boundaries, propagate changes upward
    if (flag) // logDebug(s);
    return $e815fda779bc047b$var$_updateAncestryBoundaries(p, layoutInfo);
    // s += ". No changes in boundaries/position of parent node " + p.id;
    // logDebug(s);
    return;
};
var $e815fda779bc047b$var$separateComponents = function separateComponents(layoutInfo, options) {
    var nodes = layoutInfo.layoutNodes;
    var components = [];
    for(var i = 0; i < nodes.length; i++){
        var node = nodes[i];
        var cid = node.cmptId;
        var component = components[cid] = components[cid] || [];
        component.push(node);
    }
    var totalA = 0;
    for(var i = 0; i < components.length; i++){
        var c = components[i];
        if (!c) continue;
        c.x1 = Infinity;
        c.x2 = -Infinity;
        c.y1 = Infinity;
        c.y2 = -Infinity;
        for(var j = 0; j < c.length; j++){
            var n = c[j];
            c.x1 = Math.min(c.x1, n.positionX - n.width / 2);
            c.x2 = Math.max(c.x2, n.positionX + n.width / 2);
            c.y1 = Math.min(c.y1, n.positionY - n.height / 2);
            c.y2 = Math.max(c.y2, n.positionY + n.height / 2);
        }
        c.w = c.x2 - c.x1;
        c.h = c.y2 - c.y1;
        totalA += c.w * c.h;
    }
    components.sort(function(c1, c2) {
        return c2.w * c2.h - c1.w * c1.h;
    });
    var x = 0;
    var y = 0;
    var usedW = 0;
    var rowH = 0;
    var maxRowW = Math.sqrt(totalA) * layoutInfo.clientWidth / layoutInfo.clientHeight;
    for(var i = 0; i < components.length; i++){
        var c = components[i];
        if (!c) continue;
        for(var j = 0; j < c.length; j++){
            var n = c[j];
            if (!n.isLocked) {
                n.positionX += x - c.x1;
                n.positionY += y - c.y1;
            }
        }
        x += c.w + options.componentSpacing;
        usedW += c.w + options.componentSpacing;
        rowH = Math.max(rowH, c.h);
        if (usedW > maxRowW) {
            y += rowH + options.componentSpacing;
            x = 0;
            usedW = 0;
            rowH = 0;
        }
    }
};
var $e815fda779bc047b$var$defaults$3 = {
    fit: true,
    // whether to fit the viewport to the graph
    padding: 30,
    // padding used on fit
    boundingBox: undefined,
    // constrain layout bounds; { x1, y1, x2, y2 } or { x1, y1, w, h }
    avoidOverlap: true,
    // prevents node overlap, may overflow boundingBox if not enough space
    avoidOverlapPadding: 10,
    // extra spacing around nodes when avoidOverlap: true
    nodeDimensionsIncludeLabels: false,
    // Excludes the label when calculating node bounding boxes for the layout algorithm
    spacingFactor: undefined,
    // Applies a multiplicative factor (>0) to expand or compress the overall area that the nodes take up
    condense: false,
    // uses all available space on false, uses minimal space on true
    rows: undefined,
    // force num of rows in the grid
    cols: undefined,
    // force num of columns in the grid
    position: function position(node) {},
    // returns { row, col } for element
    sort: undefined,
    // a sorting function to order the nodes; e.g. function(a, b){ return a.data('weight') - b.data('weight') }
    animate: false,
    // whether to transition the node positions
    animationDuration: 500,
    // duration of animation in ms if enabled
    animationEasing: undefined,
    // easing of animation if enabled
    animateFilter: function animateFilter(node, i) {
        return true;
    },
    // a function that determines whether the node should be animated.  All nodes animated by default on animate enabled.  Non-animated nodes are positioned immediately when the layout starts
    ready: undefined,
    // callback on layoutready
    stop: undefined,
    // callback on layoutstop
    transform: function transform(node, position) {
        return position;
    } // transform a given node position. Useful for changing flow direction in discrete layouts 
};
function $e815fda779bc047b$var$GridLayout(options) {
    this.options = $e815fda779bc047b$var$extend({}, $e815fda779bc047b$var$defaults$3, options);
}
$e815fda779bc047b$var$GridLayout.prototype.run = function() {
    var params = this.options;
    var options = params;
    var cy = params.cy;
    var eles = options.eles;
    var nodes = eles.nodes().not(':parent');
    if (options.sort) nodes = nodes.sort(options.sort);
    var bb = $e815fda779bc047b$var$makeBoundingBox(options.boundingBox ? options.boundingBox : {
        x1: 0,
        y1: 0,
        w: cy.width(),
        h: cy.height()
    });
    if (bb.h === 0 || bb.w === 0) eles.nodes().layoutPositions(this, options, function(ele) {
        return {
            x: bb.x1,
            y: bb.y1
        };
    });
    else {
        // width/height * splits^2 = cells where splits is number of times to split width
        var cells = nodes.size();
        var splits = Math.sqrt(cells * bb.h / bb.w);
        var rows = Math.round(splits);
        var cols = Math.round(bb.w / bb.h * splits);
        var small = function small(val) {
            if (val == null) return Math.min(rows, cols);
            else {
                var min = Math.min(rows, cols);
                if (min == rows) rows = val;
                else cols = val;
            }
        };
        var large = function large(val) {
            if (val == null) return Math.max(rows, cols);
            else {
                var max = Math.max(rows, cols);
                if (max == rows) rows = val;
                else cols = val;
            }
        };
        var oRows = options.rows;
        var oCols = options.cols != null ? options.cols : options.columns;
        // if rows or columns were set in options, use those values
        if (oRows != null && oCols != null) {
            rows = oRows;
            cols = oCols;
        } else if (oRows != null && oCols == null) {
            rows = oRows;
            cols = Math.ceil(cells / rows);
        } else if (oRows == null && oCols != null) {
            cols = oCols;
            rows = Math.ceil(cells / cols);
        } else if (cols * rows > cells) {
            var sm = small();
            var lg = large();
            // reducing the small side takes away the most cells, so try it first
            if ((sm - 1) * lg >= cells) small(sm - 1);
            else if ((lg - 1) * sm >= cells) large(lg - 1);
        } else // if rounding was too low, add rows or columns
        while(cols * rows < cells){
            var _sm = small();
            var _lg = large();
            // try to add to larger side first (adds less in multiplication)
            if ((_lg + 1) * _sm >= cells) large(_lg + 1);
            else small(_sm + 1);
        }
        var cellWidth = bb.w / cols;
        var cellHeight = bb.h / rows;
        if (options.condense) {
            cellWidth = 0;
            cellHeight = 0;
        }
        if (options.avoidOverlap) for(var i = 0; i < nodes.length; i++){
            var node = nodes[i];
            var pos = node._private.position;
            if (pos.x == null || pos.y == null) {
                // for bb
                pos.x = 0;
                pos.y = 0;
            }
            var nbb = node.layoutDimensions(options);
            var p = options.avoidOverlapPadding;
            var w = nbb.w + p;
            var h = nbb.h + p;
            cellWidth = Math.max(cellWidth, w);
            cellHeight = Math.max(cellHeight, h);
        }
        var cellUsed = {}; // e.g. 'c-0-2' => true
        var used = function used(row, col) {
            return cellUsed['c-' + row + '-' + col] ? true : false;
        };
        var use = function use(row, col) {
            cellUsed['c-' + row + '-' + col] = true;
        };
        // to keep track of current cell position
        var row = 0;
        var col = 0;
        var moveToNextCell = function moveToNextCell() {
            col++;
            if (col >= cols) {
                col = 0;
                row++;
            }
        };
        // get a cache of all the manual positions
        var id2manPos = {};
        for(var _i = 0; _i < nodes.length; _i++){
            var _node = nodes[_i];
            var rcPos = options.position(_node);
            if (rcPos && (rcPos.row !== undefined || rcPos.col !== undefined)) {
                // must have at least row or col def'd
                var _pos = {
                    row: rcPos.row,
                    col: rcPos.col
                };
                if (_pos.col === undefined) {
                    // find unused col
                    _pos.col = 0;
                    while(used(_pos.row, _pos.col))_pos.col++;
                } else if (_pos.row === undefined) {
                    // find unused row
                    _pos.row = 0;
                    while(used(_pos.row, _pos.col))_pos.row++;
                }
                id2manPos[_node.id()] = _pos;
                use(_pos.row, _pos.col);
            }
        }
        var getPos = function getPos(element, i) {
            var x, y;
            if (element.locked() || element.isParent()) return false;
            // see if we have a manual position set
            var rcPos = id2manPos[element.id()];
            if (rcPos) {
                x = rcPos.col * cellWidth + cellWidth / 2 + bb.x1;
                y = rcPos.row * cellHeight + cellHeight / 2 + bb.y1;
            } else {
                // otherwise set automatically
                while(used(row, col))moveToNextCell();
                x = col * cellWidth + cellWidth / 2 + bb.x1;
                y = row * cellHeight + cellHeight / 2 + bb.y1;
                use(row, col);
                moveToNextCell();
            }
            return {
                x: x,
                y: y
            };
        };
        nodes.layoutPositions(this, options, getPos);
    }
    return this; // chaining
};
// default layout options
var $e815fda779bc047b$var$defaults$2 = {
    ready: function ready() {},
    // on layoutready
    stop: function stop() {} // on layoutstop
};
// constructor
// options : object containing layout options
function $e815fda779bc047b$var$NullLayout(options) {
    this.options = $e815fda779bc047b$var$extend({}, $e815fda779bc047b$var$defaults$2, options);
}
// runs the layout
$e815fda779bc047b$var$NullLayout.prototype.run = function() {
    var options = this.options;
    var eles = options.eles; // elements to consider in the layout
    var layout = this;
    // cy is automatically populated for us in the constructor
    // (disable eslint for next line as this serves as example layout code to external developers)
    // eslint-disable-next-line no-unused-vars
    options.cy;
    layout.emit('layoutstart');
    // puts all nodes at (0, 0)
    // n.b. most layouts would use layoutPositions(), instead of positions() and manual events
    eles.nodes().positions(function() {
        return {
            x: 0,
            y: 0
        };
    });
    // trigger layoutready when each node has had its position set at least once
    layout.one('layoutready', options.ready);
    layout.emit('layoutready');
    // trigger layoutstop when the layout stops (e.g. finishes)
    layout.one('layoutstop', options.stop);
    layout.emit('layoutstop');
    return this; // chaining
};
// called on continuous layouts to stop them before they finish
$e815fda779bc047b$var$NullLayout.prototype.stop = function() {
    return this; // chaining
};
var $e815fda779bc047b$var$defaults$1 = {
    positions: undefined,
    // map of (node id) => (position obj); or function(node){ return somPos; }
    zoom: undefined,
    // the zoom level to set (prob want fit = false if set)
    pan: undefined,
    // the pan level to set (prob want fit = false if set)
    fit: true,
    // whether to fit to viewport
    padding: 30,
    // padding on fit
    spacingFactor: undefined,
    // Applies a multiplicative factor (>0) to expand or compress the overall area that the nodes take up
    animate: false,
    // whether to transition the node positions
    animationDuration: 500,
    // duration of animation in ms if enabled
    animationEasing: undefined,
    // easing of animation if enabled
    animateFilter: function animateFilter(node, i) {
        return true;
    },
    // a function that determines whether the node should be animated.  All nodes animated by default on animate enabled.  Non-animated nodes are positioned immediately when the layout starts
    ready: undefined,
    // callback on layoutready
    stop: undefined,
    // callback on layoutstop
    transform: function transform(node, position) {
        return position;
    } // transform a given node position. Useful for changing flow direction in discrete layouts
};
function $e815fda779bc047b$var$PresetLayout(options) {
    this.options = $e815fda779bc047b$var$extend({}, $e815fda779bc047b$var$defaults$1, options);
}
$e815fda779bc047b$var$PresetLayout.prototype.run = function() {
    var options = this.options;
    var eles = options.eles;
    var nodes = eles.nodes();
    var posIsFn = $e815fda779bc047b$var$fn$6(options.positions);
    function getPosition(node) {
        if (options.positions == null) return $e815fda779bc047b$var$copyPosition(node.position());
        if (posIsFn) return options.positions(node);
        var pos = options.positions[node._private.data.id];
        if (pos == null) return null;
        return pos;
    }
    nodes.layoutPositions(this, options, function(node, i) {
        var position = getPosition(node);
        if (node.locked() || position == null) return false;
        return position;
    });
    return this; // chaining
};
var $e815fda779bc047b$var$defaults = {
    fit: true,
    // whether to fit to viewport
    padding: 30,
    // fit padding
    boundingBox: undefined,
    // constrain layout bounds; { x1, y1, x2, y2 } or { x1, y1, w, h }
    animate: false,
    // whether to transition the node positions
    animationDuration: 500,
    // duration of animation in ms if enabled
    animationEasing: undefined,
    // easing of animation if enabled
    animateFilter: function animateFilter(node, i) {
        return true;
    },
    // a function that determines whether the node should be animated.  All nodes animated by default on animate enabled.  Non-animated nodes are positioned immediately when the layout starts
    ready: undefined,
    // callback on layoutready
    stop: undefined,
    // callback on layoutstop
    transform: function transform(node, position) {
        return position;
    } // transform a given node position. Useful for changing flow direction in discrete layouts 
};
function $e815fda779bc047b$var$RandomLayout(options) {
    this.options = $e815fda779bc047b$var$extend({}, $e815fda779bc047b$var$defaults, options);
}
$e815fda779bc047b$var$RandomLayout.prototype.run = function() {
    var options = this.options;
    var cy = options.cy;
    var eles = options.eles;
    var bb = $e815fda779bc047b$var$makeBoundingBox(options.boundingBox ? options.boundingBox : {
        x1: 0,
        y1: 0,
        w: cy.width(),
        h: cy.height()
    });
    var getPos = function getPos(node, i) {
        return {
            x: bb.x1 + Math.round(Math.random() * bb.w),
            y: bb.y1 + Math.round(Math.random() * bb.h)
        };
    };
    eles.nodes().layoutPositions(this, options, getPos);
    return this; // chaining
};
var $e815fda779bc047b$var$layout = [
    {
        name: 'breadthfirst',
        impl: $e815fda779bc047b$var$BreadthFirstLayout
    },
    {
        name: 'circle',
        impl: $e815fda779bc047b$var$CircleLayout
    },
    {
        name: 'concentric',
        impl: $e815fda779bc047b$var$ConcentricLayout
    },
    {
        name: 'cose',
        impl: $e815fda779bc047b$var$CoseLayout
    },
    {
        name: 'grid',
        impl: $e815fda779bc047b$var$GridLayout
    },
    {
        name: 'null',
        impl: $e815fda779bc047b$var$NullLayout
    },
    {
        name: 'preset',
        impl: $e815fda779bc047b$var$PresetLayout
    },
    {
        name: 'random',
        impl: $e815fda779bc047b$var$RandomLayout
    }
];
function $e815fda779bc047b$var$NullRenderer(options) {
    this.options = options;
    this.notifications = 0; // for testing
}
var $e815fda779bc047b$var$noop = function noop() {};
var $e815fda779bc047b$var$throwImgErr = function throwImgErr() {
    throw new Error('A headless instance can not render images');
};
$e815fda779bc047b$var$NullRenderer.prototype = {
    recalculateRenderedStyle: $e815fda779bc047b$var$noop,
    notify: function notify() {
        this.notifications++;
    },
    init: $e815fda779bc047b$var$noop,
    isHeadless: function isHeadless() {
        return true;
    },
    png: $e815fda779bc047b$var$throwImgErr,
    jpg: $e815fda779bc047b$var$throwImgErr
};
var $e815fda779bc047b$var$BRp$f = {};
$e815fda779bc047b$var$BRp$f.arrowShapeWidth = 0.3;
$e815fda779bc047b$var$BRp$f.registerArrowShapes = function() {
    var arrowShapes = this.arrowShapes = {};
    var renderer = this;
    // Contract for arrow shapes:
    // 0, 0 is arrow tip
    // (0, 1) is direction towards node
    // (1, 0) is right
    //
    // functional api:
    // collide: check x, y in shape
    // roughCollide: called before collide, no false negatives
    // draw: draw
    // spacing: dist(arrowTip, nodeBoundary)
    // gap: dist(edgeTip, nodeBoundary), edgeTip may != arrowTip
    var bbCollide = function bbCollide(x, y, size, angle, translation, edgeWidth, padding) {
        var x1 = translation.x - size / 2 - padding;
        var x2 = translation.x + size / 2 + padding;
        var y1 = translation.y - size / 2 - padding;
        var y2 = translation.y + size / 2 + padding;
        var inside = x1 <= x && x <= x2 && y1 <= y && y <= y2;
        return inside;
    };
    var transform = function transform(x, y, size, angle, translation) {
        var xRotated = x * Math.cos(angle) - y * Math.sin(angle);
        var yRotated = x * Math.sin(angle) + y * Math.cos(angle);
        var xScaled = xRotated * size;
        var yScaled = yRotated * size;
        var xTranslated = xScaled + translation.x;
        var yTranslated = yScaled + translation.y;
        return {
            x: xTranslated,
            y: yTranslated
        };
    };
    var transformPoints = function transformPoints(pts, size, angle, translation) {
        var retPts = [];
        for(var i = 0; i < pts.length; i += 2){
            var x = pts[i];
            var y = pts[i + 1];
            retPts.push(transform(x, y, size, angle, translation));
        }
        return retPts;
    };
    var pointsToArr = function pointsToArr(pts) {
        var ret = [];
        for(var i = 0; i < pts.length; i++){
            var p = pts[i];
            ret.push(p.x, p.y);
        }
        return ret;
    };
    var standardGap = function standardGap(edge) {
        return edge.pstyle('width').pfValue * edge.pstyle('arrow-scale').pfValue * 2;
    };
    var defineArrowShape = function defineArrowShape(name, defn) {
        if ($e815fda779bc047b$var$string(defn)) defn = arrowShapes[defn];
        arrowShapes[name] = $e815fda779bc047b$var$extend({
            name: name,
            points: [
                -0.15,
                -0.3,
                0.15,
                -0.3,
                0.15,
                0.3,
                -0.15,
                0.3
            ],
            collide: function collide(x, y, size, angle, translation, padding) {
                var points = pointsToArr(transformPoints(this.points, size + 2 * padding, angle, translation));
                var inside = $e815fda779bc047b$var$pointInsidePolygonPoints(x, y, points);
                return inside;
            },
            roughCollide: bbCollide,
            draw: function draw(context, size, angle, translation) {
                var points = transformPoints(this.points, size, angle, translation);
                renderer.arrowShapeImpl('polygon')(context, points);
            },
            spacing: function spacing(edge) {
                return 0;
            },
            gap: standardGap
        }, defn);
    };
    defineArrowShape('none', {
        collide: $e815fda779bc047b$var$falsify,
        roughCollide: $e815fda779bc047b$var$falsify,
        draw: $e815fda779bc047b$var$noop$1,
        spacing: $e815fda779bc047b$var$zeroify,
        gap: $e815fda779bc047b$var$zeroify
    });
    defineArrowShape('triangle', {
        points: [
            -0.15,
            -0.3,
            0,
            0,
            0.15,
            -0.3
        ]
    });
    defineArrowShape('arrow', 'triangle');
    defineArrowShape('triangle-backcurve', {
        points: arrowShapes['triangle'].points,
        controlPoint: [
            0,
            -0.15
        ],
        roughCollide: bbCollide,
        draw: function draw(context, size, angle, translation, edgeWidth) {
            var ptsTrans = transformPoints(this.points, size, angle, translation);
            var ctrlPt = this.controlPoint;
            var ctrlPtTrans = transform(ctrlPt[0], ctrlPt[1], size, angle, translation);
            renderer.arrowShapeImpl(this.name)(context, ptsTrans, ctrlPtTrans);
        },
        gap: function gap(edge) {
            return standardGap(edge) * 0.8;
        }
    });
    defineArrowShape('triangle-tee', {
        points: [
            0,
            0,
            0.15,
            -0.3,
            -0.15,
            -0.3,
            0,
            0
        ],
        pointsTee: [
            -0.15,
            -0.4,
            -0.15,
            -0.5,
            0.15,
            -0.5,
            0.15,
            -0.4
        ],
        collide: function collide(x, y, size, angle, translation, edgeWidth, padding) {
            var triPts = pointsToArr(transformPoints(this.points, size + 2 * padding, angle, translation));
            var teePts = pointsToArr(transformPoints(this.pointsTee, size + 2 * padding, angle, translation));
            var inside = $e815fda779bc047b$var$pointInsidePolygonPoints(x, y, triPts) || $e815fda779bc047b$var$pointInsidePolygonPoints(x, y, teePts);
            return inside;
        },
        draw: function draw(context, size, angle, translation, edgeWidth) {
            var triPts = transformPoints(this.points, size, angle, translation);
            var teePts = transformPoints(this.pointsTee, size, angle, translation);
            renderer.arrowShapeImpl(this.name)(context, triPts, teePts);
        }
    });
    defineArrowShape('circle-triangle', {
        radius: 0.15,
        pointsTr: [
            0,
            -0.15,
            0.15,
            -0.45,
            -0.15,
            -0.45,
            0,
            -0.15
        ],
        collide: function collide(x, y, size, angle, translation, edgeWidth, padding) {
            var t = translation;
            var circleInside = Math.pow(t.x - x, 2) + Math.pow(t.y - y, 2) <= Math.pow((size + 2 * padding) * this.radius, 2);
            var triPts = pointsToArr(transformPoints(this.points, size + 2 * padding, angle, translation));
            return $e815fda779bc047b$var$pointInsidePolygonPoints(x, y, triPts) || circleInside;
        },
        draw: function draw(context, size, angle, translation, edgeWidth) {
            var triPts = transformPoints(this.pointsTr, size, angle, translation);
            renderer.arrowShapeImpl(this.name)(context, triPts, translation.x, translation.y, this.radius * size);
        },
        spacing: function spacing(edge) {
            return renderer.getArrowWidth(edge.pstyle('width').pfValue, edge.pstyle('arrow-scale').value) * this.radius;
        }
    });
    defineArrowShape('triangle-cross', {
        points: [
            0,
            0,
            0.15,
            -0.3,
            -0.15,
            -0.3,
            0,
            0
        ],
        baseCrossLinePts: [
            -0.15,
            -0.4,
            // first half of the rectangle
            -0.15,
            -0.4,
            0.15,
            -0.4,
            // second half of the rectangle
            0.15,
            -0.4
        ],
        crossLinePts: function crossLinePts(size, edgeWidth) {
            // shift points so that the distance between the cross points matches edge width
            var p = this.baseCrossLinePts.slice();
            var shiftFactor = edgeWidth / size;
            var y0 = 3;
            var y1 = 5;
            p[y0] = p[y0] - shiftFactor;
            p[y1] = p[y1] - shiftFactor;
            return p;
        },
        collide: function collide(x, y, size, angle, translation, edgeWidth, padding) {
            var triPts = pointsToArr(transformPoints(this.points, size + 2 * padding, angle, translation));
            var teePts = pointsToArr(transformPoints(this.crossLinePts(size, edgeWidth), size + 2 * padding, angle, translation));
            var inside = $e815fda779bc047b$var$pointInsidePolygonPoints(x, y, triPts) || $e815fda779bc047b$var$pointInsidePolygonPoints(x, y, teePts);
            return inside;
        },
        draw: function draw(context, size, angle, translation, edgeWidth) {
            var triPts = transformPoints(this.points, size, angle, translation);
            var crossLinePts = transformPoints(this.crossLinePts(size, edgeWidth), size, angle, translation);
            renderer.arrowShapeImpl(this.name)(context, triPts, crossLinePts);
        }
    });
    defineArrowShape('vee', {
        points: [
            -0.15,
            -0.3,
            0,
            0,
            0.15,
            -0.3,
            0,
            -0.15
        ],
        gap: function gap(edge) {
            return standardGap(edge) * 0.525;
        }
    });
    defineArrowShape('circle', {
        radius: 0.15,
        collide: function collide(x, y, size, angle, translation, edgeWidth, padding) {
            var t = translation;
            var inside = Math.pow(t.x - x, 2) + Math.pow(t.y - y, 2) <= Math.pow((size + 2 * padding) * this.radius, 2);
            return inside;
        },
        draw: function draw(context, size, angle, translation, edgeWidth) {
            renderer.arrowShapeImpl(this.name)(context, translation.x, translation.y, this.radius * size);
        },
        spacing: function spacing(edge) {
            return renderer.getArrowWidth(edge.pstyle('width').pfValue, edge.pstyle('arrow-scale').value) * this.radius;
        }
    });
    defineArrowShape('tee', {
        points: [
            -0.15,
            0,
            -0.15,
            -0.1,
            0.15,
            -0.1,
            0.15,
            0
        ],
        spacing: function spacing(edge) {
            return 1;
        },
        gap: function gap(edge) {
            return 1;
        }
    });
    defineArrowShape('square', {
        points: [
            -0.15,
            0.00,
            0.15,
            0.00,
            0.15,
            -0.3,
            -0.15,
            -0.3
        ]
    });
    defineArrowShape('diamond', {
        points: [
            -0.15,
            -0.15,
            0,
            -0.3,
            0.15,
            -0.15,
            0,
            0
        ],
        gap: function gap(edge) {
            return edge.pstyle('width').pfValue * edge.pstyle('arrow-scale').value;
        }
    });
    defineArrowShape('chevron', {
        points: [
            0,
            0,
            -0.15,
            -0.15,
            -0.1,
            -0.2,
            0,
            -0.1,
            0.1,
            -0.2,
            0.15,
            -0.15
        ],
        gap: function gap(edge) {
            return 0.95 * edge.pstyle('width').pfValue * edge.pstyle('arrow-scale').value;
        }
    });
};
var $e815fda779bc047b$var$BRp$e = {};
// Project mouse
$e815fda779bc047b$var$BRp$e.projectIntoViewport = function(clientX, clientY) {
    var cy = this.cy;
    var offsets = this.findContainerClientCoords();
    var offsetLeft = offsets[0];
    var offsetTop = offsets[1];
    var scale = offsets[4];
    var pan = cy.pan();
    var zoom = cy.zoom();
    var x = ((clientX - offsetLeft) / scale - pan.x) / zoom;
    var y = ((clientY - offsetTop) / scale - pan.y) / zoom;
    return [
        x,
        y
    ];
};
$e815fda779bc047b$var$BRp$e.findContainerClientCoords = function() {
    if (this.containerBB) return this.containerBB;
    var container = this.container;
    var rect = container.getBoundingClientRect();
    var style = this.cy.window().getComputedStyle(container);
    var styleValue = function styleValue(name) {
        return parseFloat(style.getPropertyValue(name));
    };
    var padding = {
        left: styleValue('padding-left'),
        right: styleValue('padding-right'),
        top: styleValue('padding-top'),
        bottom: styleValue('padding-bottom')
    };
    var border = {
        left: styleValue('border-left-width'),
        right: styleValue('border-right-width'),
        top: styleValue('border-top-width'),
        bottom: styleValue('border-bottom-width')
    };
    var clientWidth = container.clientWidth;
    var clientHeight = container.clientHeight;
    var paddingHor = padding.left + padding.right;
    var paddingVer = padding.top + padding.bottom;
    var borderHor = border.left + border.right;
    var scale = rect.width / (clientWidth + borderHor);
    var unscaledW = clientWidth - paddingHor;
    var unscaledH = clientHeight - paddingVer;
    var left = rect.left + padding.left + border.left;
    var top = rect.top + padding.top + border.top;
    return this.containerBB = [
        left,
        top,
        unscaledW,
        unscaledH,
        scale
    ];
};
$e815fda779bc047b$var$BRp$e.invalidateContainerClientCoordsCache = function() {
    this.containerBB = null;
};
$e815fda779bc047b$var$BRp$e.findNearestElement = function(x, y, interactiveElementsOnly, isTouch) {
    return this.findNearestElements(x, y, interactiveElementsOnly, isTouch)[0];
};
$e815fda779bc047b$var$BRp$e.findNearestElements = function(x, y, interactiveElementsOnly, isTouch) {
    var self1 = this;
    var r = this;
    var eles = r.getCachedZSortedEles();
    var near = []; // 1 node max, 1 edge max
    var zoom = r.cy.zoom();
    var hasCompounds = r.cy.hasCompoundNodes();
    var edgeThreshold = (isTouch ? 24 : 8) / zoom;
    var nodeThreshold = (isTouch ? 8 : 2) / zoom;
    var labelThreshold = (isTouch ? 8 : 2) / zoom;
    var minSqDist = Infinity;
    var nearEdge;
    var nearNode;
    if (interactiveElementsOnly) eles = eles.interactive;
    function addEle(ele, sqDist) {
        if (ele.isNode()) {
            if (nearNode) return; // can't replace node
            else {
                nearNode = ele;
                near.push(ele);
            }
        }
        if (ele.isEdge() && (sqDist == null || sqDist < minSqDist)) {
            if (nearEdge) // then replace existing edge
            // can replace only if same z-index
            {
                if (nearEdge.pstyle('z-compound-depth').value === ele.pstyle('z-compound-depth').value && nearEdge.pstyle('z-compound-depth').value === ele.pstyle('z-compound-depth').value) {
                    for(var i = 0; i < near.length; i++)if (near[i].isEdge()) {
                        near[i] = ele;
                        nearEdge = ele;
                        minSqDist = sqDist != null ? sqDist : minSqDist;
                        break;
                    }
                }
            } else {
                near.push(ele);
                nearEdge = ele;
                minSqDist = sqDist != null ? sqDist : minSqDist;
            }
        }
    }
    function checkNode(node) {
        var width = node.outerWidth() + 2 * nodeThreshold;
        var height = node.outerHeight() + 2 * nodeThreshold;
        var hw = width / 2;
        var hh = height / 2;
        var pos = node.position();
        var cornerRadius = node.pstyle('corner-radius').value === 'auto' ? 'auto' : node.pstyle('corner-radius').pfValue;
        var rs = node._private.rscratch;
        if (pos.x - hw <= x && x <= pos.x + hw // bb check x
         && pos.y - hh <= y && y <= pos.y + hh // bb check y
        ) {
            var shape = r.nodeShapes[self1.getNodeShape(node)];
            if (shape.checkPoint(x, y, 0, width, height, pos.x, pos.y, cornerRadius, rs)) {
                addEle(node, 0);
                return true;
            }
        }
    }
    function checkEdge(edge) {
        var _p = edge._private;
        var rs = _p.rscratch;
        var styleWidth = edge.pstyle('width').pfValue;
        var scale = edge.pstyle('arrow-scale').value;
        var width = styleWidth / 2 + edgeThreshold; // more like a distance radius from centre
        var widthSq = width * width;
        var width2 = width * 2;
        var src = _p.source;
        var tgt = _p.target;
        var sqDist;
        if (rs.edgeType === 'segments' || rs.edgeType === 'straight' || rs.edgeType === 'haystack') {
            var pts = rs.allpts;
            for(var i = 0; i + 3 < pts.length; i += 2)if ($e815fda779bc047b$var$inLineVicinity(x, y, pts[i], pts[i + 1], pts[i + 2], pts[i + 3], width2) && widthSq > (sqDist = $e815fda779bc047b$var$sqdistToFiniteLine(x, y, pts[i], pts[i + 1], pts[i + 2], pts[i + 3]))) {
                addEle(edge, sqDist);
                return true;
            }
        } else if (rs.edgeType === 'bezier' || rs.edgeType === 'multibezier' || rs.edgeType === 'self' || rs.edgeType === 'compound') {
            var pts = rs.allpts;
            for(var i = 0; i + 5 < rs.allpts.length; i += 4)if ($e815fda779bc047b$var$inBezierVicinity(x, y, pts[i], pts[i + 1], pts[i + 2], pts[i + 3], pts[i + 4], pts[i + 5], width2) && widthSq > (sqDist = $e815fda779bc047b$var$sqdistToQuadraticBezier(x, y, pts[i], pts[i + 1], pts[i + 2], pts[i + 3], pts[i + 4], pts[i + 5]))) {
                addEle(edge, sqDist);
                return true;
            }
        }
        // if we're close to the edge but didn't hit it, maybe we hit its arrows
        var src = src || _p.source;
        var tgt = tgt || _p.target;
        var arSize = self1.getArrowWidth(styleWidth, scale);
        var arrows = [
            {
                name: 'source',
                x: rs.arrowStartX,
                y: rs.arrowStartY,
                angle: rs.srcArrowAngle
            },
            {
                name: 'target',
                x: rs.arrowEndX,
                y: rs.arrowEndY,
                angle: rs.tgtArrowAngle
            },
            {
                name: 'mid-source',
                x: rs.midX,
                y: rs.midY,
                angle: rs.midsrcArrowAngle
            },
            {
                name: 'mid-target',
                x: rs.midX,
                y: rs.midY,
                angle: rs.midtgtArrowAngle
            }
        ];
        for(var i = 0; i < arrows.length; i++){
            var ar = arrows[i];
            var shape = r.arrowShapes[edge.pstyle(ar.name + '-arrow-shape').value];
            var edgeWidth = edge.pstyle('width').pfValue;
            if (shape.roughCollide(x, y, arSize, ar.angle, {
                x: ar.x,
                y: ar.y
            }, edgeWidth, edgeThreshold) && shape.collide(x, y, arSize, ar.angle, {
                x: ar.x,
                y: ar.y
            }, edgeWidth, edgeThreshold)) {
                addEle(edge);
                return true;
            }
        }
        // for compound graphs, hitting edge may actually want a connected node instead (b/c edge may have greater z-index precedence)
        if (hasCompounds && near.length > 0) {
            checkNode(src);
            checkNode(tgt);
        }
    }
    function preprop(obj, name, pre) {
        return $e815fda779bc047b$var$getPrefixedProperty(obj, name, pre);
    }
    function checkLabel(ele, prefix) {
        var _p = ele._private;
        var th = labelThreshold;
        var prefixDash;
        if (prefix) prefixDash = prefix + '-';
        else prefixDash = '';
        ele.boundingBox();
        var bb = _p.labelBounds[prefix || 'main'];
        var text = ele.pstyle(prefixDash + 'label').value;
        var eventsEnabled = ele.pstyle('text-events').strValue === 'yes';
        if (!eventsEnabled || !text) return;
        var lx = preprop(_p.rscratch, 'labelX', prefix);
        var ly = preprop(_p.rscratch, 'labelY', prefix);
        var theta = preprop(_p.rscratch, 'labelAngle', prefix);
        var ox = ele.pstyle(prefixDash + 'text-margin-x').pfValue;
        var oy = ele.pstyle(prefixDash + 'text-margin-y').pfValue;
        var lx1 = bb.x1 - th - ox; // (-ox, -oy) as bb already includes margin
        var lx2 = bb.x2 + th - ox; // and rotation is about (lx, ly)
        var ly1 = bb.y1 - th - oy;
        var ly2 = bb.y2 + th - oy;
        if (theta) {
            var cos = Math.cos(theta);
            var sin = Math.sin(theta);
            var rotate = function rotate(x, y) {
                x = x - lx;
                y = y - ly;
                return {
                    x: x * cos - y * sin + lx,
                    y: x * sin + y * cos + ly
                };
            };
            var px1y1 = rotate(lx1, ly1);
            var px1y2 = rotate(lx1, ly2);
            var px2y1 = rotate(lx2, ly1);
            var px2y2 = rotate(lx2, ly2);
            var points = [
                // with the margin added after the rotation is applied
                px1y1.x + ox,
                px1y1.y + oy,
                px2y1.x + ox,
                px2y1.y + oy,
                px2y2.x + ox,
                px2y2.y + oy,
                px1y2.x + ox,
                px1y2.y + oy
            ];
            if ($e815fda779bc047b$var$pointInsidePolygonPoints(x, y, points)) {
                addEle(ele);
                return true;
            }
        } else // do a cheaper bb check
        if ($e815fda779bc047b$var$inBoundingBox(bb, x, y)) {
            addEle(ele);
            return true;
        }
    }
    for(var i = eles.length - 1; i >= 0; i--){
        // reverse order for precedence
        var ele = eles[i];
        if (ele.isNode()) checkNode(ele) || checkLabel(ele);
        else // then edge
        checkEdge(ele) || checkLabel(ele) || checkLabel(ele, 'source') || checkLabel(ele, 'target');
    }
    return near;
};
// 'Give me everything from this box'
$e815fda779bc047b$var$BRp$e.getAllInBox = function(x1, y1, x2, y2) {
    var eles = this.getCachedZSortedEles().interactive;
    var zoom = this.cy.zoom();
    var labelThreshold = 2 / zoom;
    var box = [];
    var x1c = Math.min(x1, x2);
    var x2c = Math.max(x1, x2);
    var y1c = Math.min(y1, y2);
    var y2c = Math.max(y1, y2);
    x1 = x1c;
    x2 = x2c;
    y1 = y1c;
    y2 = y2c;
    var boxBb = $e815fda779bc047b$var$makeBoundingBox({
        x1: x1,
        y1: y1,
        x2: x2,
        y2: y2
    });
    var selectionBox = [
        {
            x: boxBb.x1,
            y: boxBb.y1
        },
        {
            x: boxBb.x2,
            y: boxBb.y1
        },
        {
            x: boxBb.x2,
            y: boxBb.y2
        },
        {
            x: boxBb.x1,
            y: boxBb.y2
        }
    ];
    var boxEdges = [
        [
            selectionBox[0],
            selectionBox[1]
        ],
        [
            selectionBox[1],
            selectionBox[2]
        ],
        [
            selectionBox[2],
            selectionBox[3]
        ],
        [
            selectionBox[3],
            selectionBox[0]
        ]
    ];
    function preprop(obj, name, pre) {
        return $e815fda779bc047b$var$getPrefixedProperty(obj, name, pre);
    }
    function getRotatedLabelBox(ele, prefix) {
        var _p = ele._private;
        var th = labelThreshold;
        var prefixDash = '';
        ele.boundingBox();
        var bb = _p.labelBounds['main'];
        // If the bounding box is not available, return null.
        // This indicates that the label box cannot be calculated, which is consistent
        // with the expected behavior of this function. Returning null allows the caller
        // to handle the absence of a bounding box explicitly.
        if (!bb) return null;
        var lx = preprop(_p.rscratch, 'labelX', prefix);
        var ly = preprop(_p.rscratch, 'labelY', prefix);
        var theta = preprop(_p.rscratch, 'labelAngle', prefix);
        var ox = ele.pstyle(prefixDash + 'text-margin-x').pfValue;
        var oy = ele.pstyle(prefixDash + 'text-margin-y').pfValue;
        var lx1 = bb.x1 - th - ox;
        var lx2 = bb.x2 + th - ox;
        var ly1 = bb.y1 - th - oy;
        var ly2 = bb.y2 + th - oy;
        if (theta) {
            var cos = Math.cos(theta);
            var sin = Math.sin(theta);
            var rotate = function rotate(x, y) {
                x = x - lx;
                y = y - ly;
                return {
                    x: x * cos - y * sin + lx,
                    y: x * sin + y * cos + ly
                };
            };
            return [
                rotate(lx1, ly1),
                rotate(lx2, ly1),
                rotate(lx2, ly2),
                rotate(lx1, ly2)
            ];
        } else return [
            {
                x: lx1,
                y: ly1
            },
            {
                x: lx2,
                y: ly1
            },
            {
                x: lx2,
                y: ly2
            },
            {
                x: lx1,
                y: ly2
            }
        ];
    }
    function doLinesIntersect(p1, p2, q1, q2) {
        function ccw(a, b, c) {
            return (c.y - a.y) * (b.x - a.x) > (b.y - a.y) * (c.x - a.x);
        }
        return ccw(p1, q1, q2) !== ccw(p2, q1, q2) && ccw(p1, p2, q1) !== ccw(p1, p2, q2);
    }
    for(var e = 0; e < eles.length; e++){
        var ele = eles[e];
        if (ele.isNode()) {
            var node = ele;
            var textEvents = node.pstyle('text-events').strValue === 'yes';
            var nodeBoxSelectMode = node.pstyle('box-selection').strValue;
            var labelBoxSelectEnabled = node.pstyle('box-select-labels').strValue === 'yes';
            if (nodeBoxSelectMode === 'none') continue;
            var includeLabels = (nodeBoxSelectMode === 'overlap' || labelBoxSelectEnabled) && textEvents;
            var nodeBb = node.boundingBox({
                includeNodes: true,
                includeEdges: false,
                includeLabels: includeLabels
            });
            if (nodeBoxSelectMode === 'contain') {
                var selected = false;
                if (labelBoxSelectEnabled && textEvents) {
                    var rotatedLabelBox = getRotatedLabelBox(node);
                    if (rotatedLabelBox && $e815fda779bc047b$var$satPolygonIntersection(rotatedLabelBox, selectionBox)) {
                        box.push(node);
                        selected = true;
                    }
                }
                if (!selected && $e815fda779bc047b$var$boundingBoxInBoundingBox(boxBb, nodeBb)) box.push(node);
            } else if (nodeBoxSelectMode === 'overlap') {
                if ($e815fda779bc047b$var$boundingBoxesIntersect(boxBb, nodeBb)) {
                    var nodeBodyBb = node.boundingBox({
                        includeNodes: true,
                        includeEdges: true,
                        includeLabels: false,
                        includeMainLabels: false,
                        includeSourceLabels: false,
                        includeTargetLabels: false
                    });
                    var nodeBodyCorners = [
                        {
                            x: nodeBodyBb.x1,
                            y: nodeBodyBb.y1
                        },
                        {
                            x: nodeBodyBb.x2,
                            y: nodeBodyBb.y1
                        },
                        {
                            x: nodeBodyBb.x2,
                            y: nodeBodyBb.y2
                        },
                        {
                            x: nodeBodyBb.x1,
                            y: nodeBodyBb.y2
                        }
                    ];
                    // if node body intersects, no need to check label
                    if ($e815fda779bc047b$var$satPolygonIntersection(nodeBodyCorners, selectionBox)) box.push(node);
                    else {
                        // only check label if node body didn't intersect
                        var _rotatedLabelBox = getRotatedLabelBox(node);
                        if (_rotatedLabelBox && $e815fda779bc047b$var$satPolygonIntersection(_rotatedLabelBox, selectionBox)) box.push(node);
                    }
                }
            }
        } else {
            var edge = ele;
            var _p = edge._private;
            var rs = _p.rscratch;
            var edgeBoxSelectMode = edge.pstyle('box-selection').strValue;
            if (edgeBoxSelectMode === 'none') continue;
            if (edgeBoxSelectMode === 'contain') {
                if (rs.startX != null && rs.startY != null && !$e815fda779bc047b$var$inBoundingBox(boxBb, rs.startX, rs.startY)) continue;
                if (rs.endX != null && rs.endY != null && !$e815fda779bc047b$var$inBoundingBox(boxBb, rs.endX, rs.endY)) continue;
                if (rs.edgeType === 'bezier' || rs.edgeType === 'multibezier' || rs.edgeType === 'self' || rs.edgeType === 'compound' || rs.edgeType === 'segments' || rs.edgeType === 'haystack') {
                    var pts = _p.rstyle.bezierPts || _p.rstyle.linePts || _p.rstyle.haystackPts;
                    var allInside = true;
                    for(var i = 0; i < pts.length; i++)if (!$e815fda779bc047b$var$pointInBoundingBox(boxBb, pts[i])) {
                        allInside = false;
                        break;
                    }
                    if (allInside) box.push(edge);
                } else if (rs.edgeType === 'straight') box.push(edge);
            } else if (edgeBoxSelectMode === 'overlap') {
                var _selected = false;
                // Check: either endpoint inside box
                if (rs.startX != null && rs.startY != null && rs.endX != null && rs.endY != null && ($e815fda779bc047b$var$inBoundingBox(boxBb, rs.startX, rs.startY) || $e815fda779bc047b$var$inBoundingBox(boxBb, rs.endX, rs.endY))) {
                    box.push(edge);
                    _selected = true;
                } else if (!_selected && rs.edgeType === 'haystack') {
                    var haystackPts = _p.rstyle.haystackPts;
                    for(var _i = 0; _i < haystackPts.length; _i++)if ($e815fda779bc047b$var$pointInBoundingBox(boxBb, haystackPts[_i])) {
                        box.push(edge);
                        _selected = true;
                        break;
                    }
                }
                // Segment intersection check (only if not already selected)
                if (!_selected) {
                    var _pts = _p.rstyle.bezierPts || _p.rstyle.linePts || _p.rstyle.haystackPts;
                    // straight edges
                    if ((!_pts || _pts.length < 2) && rs.edgeType === 'straight') {
                        if (rs.startX != null && rs.startY != null && rs.endX != null && rs.endY != null) _pts = [
                            {
                                x: rs.startX,
                                y: rs.startY
                            },
                            {
                                x: rs.endX,
                                y: rs.endY
                            }
                        ];
                    }
                    if (!_pts || _pts.length < 2) continue;
                    for(var _i2 = 0; _i2 < _pts.length - 1; _i2++){
                        var segStart = _pts[_i2];
                        var segEnd = _pts[_i2 + 1];
                        for(var b = 0; b < boxEdges.length; b++){
                            var _boxEdges$b = $e815fda779bc047b$var$_slicedToArray(boxEdges[b], 2), boxStart = _boxEdges$b[0], boxEnd = _boxEdges$b[1];
                            if (doLinesIntersect(segStart, segEnd, boxStart, boxEnd)) {
                                box.push(edge);
                                _selected = true;
                                break;
                            }
                        }
                        if (_selected) break;
                    }
                }
            }
        }
    }
    return box;
};
var $e815fda779bc047b$var$BRp$d = {};
$e815fda779bc047b$var$BRp$d.calculateArrowAngles = function(edge) {
    var rs = edge._private.rscratch;
    var isHaystack = rs.edgeType === 'haystack';
    var isBezier = rs.edgeType === 'bezier';
    var isMultibezier = rs.edgeType === 'multibezier';
    var isSegments = rs.edgeType === 'segments';
    var isCompound = rs.edgeType === 'compound';
    var isSelf = rs.edgeType === 'self';
    // Displacement gives direction for arrowhead orientation
    var dispX, dispY;
    var startX, startY, endX, endY, midX, midY;
    if (isHaystack) {
        startX = rs.haystackPts[0];
        startY = rs.haystackPts[1];
        endX = rs.haystackPts[2];
        endY = rs.haystackPts[3];
    } else {
        startX = rs.arrowStartX;
        startY = rs.arrowStartY;
        endX = rs.arrowEndX;
        endY = rs.arrowEndY;
    }
    midX = rs.midX;
    midY = rs.midY;
    // source
    //
    if (isSegments) {
        dispX = startX - rs.segpts[0];
        dispY = startY - rs.segpts[1];
    } else if (isMultibezier || isCompound || isSelf || isBezier) {
        var pts = rs.allpts;
        var bX = $e815fda779bc047b$var$qbezierAt(pts[0], pts[2], pts[4], 0.1);
        var bY = $e815fda779bc047b$var$qbezierAt(pts[1], pts[3], pts[5], 0.1);
        dispX = startX - bX;
        dispY = startY - bY;
    } else {
        dispX = startX - midX;
        dispY = startY - midY;
    }
    rs.srcArrowAngle = $e815fda779bc047b$var$getAngleFromDisp(dispX, dispY);
    // mid target
    //
    var midX = rs.midX;
    var midY = rs.midY;
    if (isHaystack) {
        midX = (startX + endX) / 2;
        midY = (startY + endY) / 2;
    }
    dispX = endX - startX;
    dispY = endY - startY;
    if (isSegments) {
        var pts = rs.allpts;
        if (pts.length / 2 % 2 === 0) {
            var i2 = pts.length / 2;
            var i1 = i2 - 2;
            dispX = pts[i2] - pts[i1];
            dispY = pts[i2 + 1] - pts[i1 + 1];
        } else if (rs.isRound) {
            dispX = rs.midVector[1];
            dispY = -rs.midVector[0];
        } else {
            var i2 = pts.length / 2 - 1;
            var i1 = i2 - 2;
            dispX = pts[i2] - pts[i1];
            dispY = pts[i2 + 1] - pts[i1 + 1];
        }
    } else if (isMultibezier || isCompound || isSelf) {
        var pts = rs.allpts;
        var cpts = rs.ctrlpts;
        var bp0x, bp0y;
        var bp1x, bp1y;
        if (cpts.length / 2 % 2 === 0) {
            var p0 = pts.length / 2 - 1; // startpt
            var ic = p0 + 2;
            var p1 = ic + 2;
            bp0x = $e815fda779bc047b$var$qbezierAt(pts[p0], pts[ic], pts[p1], 0.0);
            bp0y = $e815fda779bc047b$var$qbezierAt(pts[p0 + 1], pts[ic + 1], pts[p1 + 1], 0.0);
            bp1x = $e815fda779bc047b$var$qbezierAt(pts[p0], pts[ic], pts[p1], 0.0001);
            bp1y = $e815fda779bc047b$var$qbezierAt(pts[p0 + 1], pts[ic + 1], pts[p1 + 1], 0.0001);
        } else {
            var ic = pts.length / 2 - 1; // ctrpt
            var p0 = ic - 2; // startpt
            var p1 = ic + 2; // endpt
            bp0x = $e815fda779bc047b$var$qbezierAt(pts[p0], pts[ic], pts[p1], 0.4999);
            bp0y = $e815fda779bc047b$var$qbezierAt(pts[p0 + 1], pts[ic + 1], pts[p1 + 1], 0.4999);
            bp1x = $e815fda779bc047b$var$qbezierAt(pts[p0], pts[ic], pts[p1], 0.5);
            bp1y = $e815fda779bc047b$var$qbezierAt(pts[p0 + 1], pts[ic + 1], pts[p1 + 1], 0.5);
        }
        dispX = bp1x - bp0x;
        dispY = bp1y - bp0y;
    }
    rs.midtgtArrowAngle = $e815fda779bc047b$var$getAngleFromDisp(dispX, dispY);
    rs.midDispX = dispX;
    rs.midDispY = dispY;
    // mid source
    //
    dispX *= -1;
    dispY *= -1;
    if (isSegments) {
        var pts = rs.allpts;
        if (pts.length / 2 % 2 === 0) ;
        else if (!rs.isRound) {
            var i2 = pts.length / 2 - 1;
            var i3 = i2 + 2;
            dispX = -(pts[i3] - pts[i2]);
            dispY = -(pts[i3 + 1] - pts[i2 + 1]);
        }
    }
    rs.midsrcArrowAngle = $e815fda779bc047b$var$getAngleFromDisp(dispX, dispY);
    // target
    //
    if (isSegments) {
        dispX = endX - rs.segpts[rs.segpts.length - 2];
        dispY = endY - rs.segpts[rs.segpts.length - 1];
    } else if (isMultibezier || isCompound || isSelf || isBezier) {
        var pts = rs.allpts;
        var l = pts.length;
        var bX = $e815fda779bc047b$var$qbezierAt(pts[l - 6], pts[l - 4], pts[l - 2], 0.9);
        var bY = $e815fda779bc047b$var$qbezierAt(pts[l - 5], pts[l - 3], pts[l - 1], 0.9);
        dispX = endX - bX;
        dispY = endY - bY;
    } else {
        dispX = endX - midX;
        dispY = endY - midY;
    }
    rs.tgtArrowAngle = $e815fda779bc047b$var$getAngleFromDisp(dispX, dispY);
};
$e815fda779bc047b$var$BRp$d.getArrowWidth = $e815fda779bc047b$var$BRp$d.getArrowHeight = function(edgeWidth, scale) {
    var cache = this.arrowWidthCache = this.arrowWidthCache || {};
    var cachedVal = cache[edgeWidth + ', ' + scale];
    if (cachedVal) return cachedVal;
    cachedVal = Math.max(Math.pow(edgeWidth * 13.37, 0.9), 29) * scale;
    cache[edgeWidth + ', ' + scale] = cachedVal;
    return cachedVal;
};
/**
 * Explained by Blindman67 at https://stackoverflow.com/a/44856925/11028828
 */ // Declare reused variable to avoid reallocating variables every time the function is called
var $e815fda779bc047b$var$x, $e815fda779bc047b$var$y, $e815fda779bc047b$var$v1 = {}, $e815fda779bc047b$var$v2 = {}, $e815fda779bc047b$var$sinA, $e815fda779bc047b$var$sinA90, $e815fda779bc047b$var$radDirection, $e815fda779bc047b$var$drawDirection, $e815fda779bc047b$var$angle, $e815fda779bc047b$var$halfAngle, $e815fda779bc047b$var$cRadius, $e815fda779bc047b$var$lenOut, $e815fda779bc047b$var$radius, $e815fda779bc047b$var$limit;
var $e815fda779bc047b$var$startX, $e815fda779bc047b$var$startY, $e815fda779bc047b$var$stopX, $e815fda779bc047b$var$stopY;
var $e815fda779bc047b$var$lastPoint;
// convert 2 points into vector form, polar form, and normalised
var $e815fda779bc047b$var$asVec = function asVec(p, pp, v) {
    v.x = pp.x - p.x;
    v.y = pp.y - p.y;
    v.len = Math.sqrt(v.x * v.x + v.y * v.y);
    v.nx = v.x / v.len;
    v.ny = v.y / v.len;
    v.ang = Math.atan2(v.ny, v.nx);
};
var $e815fda779bc047b$var$invertVec = function invertVec(originalV, invertedV) {
    invertedV.x = originalV.x * -1;
    invertedV.y = originalV.y * -1;
    invertedV.nx = originalV.nx * -1;
    invertedV.ny = originalV.ny * -1;
    invertedV.ang = originalV.ang > 0 ? -(Math.PI - originalV.ang) : Math.PI + originalV.ang;
};
var $e815fda779bc047b$var$calcCornerArc = function calcCornerArc(previousPoint, currentPoint, nextPoint, radiusMax, isArcRadius) {
    //-----------------------------------------
    // Part 1
    previousPoint !== $e815fda779bc047b$var$lastPoint ? $e815fda779bc047b$var$asVec(currentPoint, previousPoint, $e815fda779bc047b$var$v1) : $e815fda779bc047b$var$invertVec($e815fda779bc047b$var$v2, $e815fda779bc047b$var$v1); // Avoid recalculating vec if it is the invert of the last one calculated
    $e815fda779bc047b$var$asVec(currentPoint, nextPoint, $e815fda779bc047b$var$v2);
    $e815fda779bc047b$var$sinA = $e815fda779bc047b$var$v1.nx * $e815fda779bc047b$var$v2.ny - $e815fda779bc047b$var$v1.ny * $e815fda779bc047b$var$v2.nx;
    $e815fda779bc047b$var$sinA90 = $e815fda779bc047b$var$v1.nx * $e815fda779bc047b$var$v2.nx - $e815fda779bc047b$var$v1.ny * -$e815fda779bc047b$var$v2.ny;
    $e815fda779bc047b$var$angle = Math.asin(Math.max(-1, Math.min(1, $e815fda779bc047b$var$sinA)));
    if (Math.abs($e815fda779bc047b$var$angle) < 1e-6) {
        $e815fda779bc047b$var$x = currentPoint.x;
        $e815fda779bc047b$var$y = currentPoint.y;
        $e815fda779bc047b$var$cRadius = $e815fda779bc047b$var$radius = 0;
        return;
    }
    //-----------------------------------------
    $e815fda779bc047b$var$radDirection = 1;
    $e815fda779bc047b$var$drawDirection = false;
    if ($e815fda779bc047b$var$sinA90 < 0) {
        if ($e815fda779bc047b$var$angle < 0) $e815fda779bc047b$var$angle = Math.PI + $e815fda779bc047b$var$angle;
        else {
            $e815fda779bc047b$var$angle = Math.PI - $e815fda779bc047b$var$angle;
            $e815fda779bc047b$var$radDirection = -1;
            $e815fda779bc047b$var$drawDirection = true;
        }
    } else if ($e815fda779bc047b$var$angle > 0) {
        $e815fda779bc047b$var$radDirection = -1;
        $e815fda779bc047b$var$drawDirection = true;
    }
    if (currentPoint.radius !== undefined) $e815fda779bc047b$var$radius = currentPoint.radius;
    else $e815fda779bc047b$var$radius = radiusMax;
    //-----------------------------------------
    // Part 2
    $e815fda779bc047b$var$halfAngle = $e815fda779bc047b$var$angle / 2;
    //-----------------------------------------
    $e815fda779bc047b$var$limit = Math.min($e815fda779bc047b$var$v1.len / 2, $e815fda779bc047b$var$v2.len / 2);
    if (isArcRadius) {
        //-----------------------------------------
        // Part 3
        $e815fda779bc047b$var$lenOut = Math.abs(Math.cos($e815fda779bc047b$var$halfAngle) * $e815fda779bc047b$var$radius / Math.sin($e815fda779bc047b$var$halfAngle));
        //-----------------------------------------
        // Special part A
        if ($e815fda779bc047b$var$lenOut > $e815fda779bc047b$var$limit) {
            $e815fda779bc047b$var$lenOut = $e815fda779bc047b$var$limit;
            $e815fda779bc047b$var$cRadius = Math.abs($e815fda779bc047b$var$lenOut * Math.sin($e815fda779bc047b$var$halfAngle) / Math.cos($e815fda779bc047b$var$halfAngle));
        } else $e815fda779bc047b$var$cRadius = $e815fda779bc047b$var$radius;
    } else {
        $e815fda779bc047b$var$lenOut = Math.min($e815fda779bc047b$var$limit, $e815fda779bc047b$var$radius);
        $e815fda779bc047b$var$cRadius = Math.abs($e815fda779bc047b$var$lenOut * Math.sin($e815fda779bc047b$var$halfAngle) / Math.cos($e815fda779bc047b$var$halfAngle));
    }
    //-----------------------------------------
    //-----------------------------------------
    // Part 4
    $e815fda779bc047b$var$stopX = currentPoint.x + $e815fda779bc047b$var$v2.nx * $e815fda779bc047b$var$lenOut;
    $e815fda779bc047b$var$stopY = currentPoint.y + $e815fda779bc047b$var$v2.ny * $e815fda779bc047b$var$lenOut;
    //-----------------------------------------
    // Part 5
    $e815fda779bc047b$var$x = $e815fda779bc047b$var$stopX - $e815fda779bc047b$var$v2.ny * $e815fda779bc047b$var$cRadius * $e815fda779bc047b$var$radDirection;
    $e815fda779bc047b$var$y = $e815fda779bc047b$var$stopY + $e815fda779bc047b$var$v2.nx * $e815fda779bc047b$var$cRadius * $e815fda779bc047b$var$radDirection;
    //-----------------------------------------
    // Additional Part : calculate start point E
    $e815fda779bc047b$var$startX = currentPoint.x + $e815fda779bc047b$var$v1.nx * $e815fda779bc047b$var$lenOut;
    $e815fda779bc047b$var$startY = currentPoint.y + $e815fda779bc047b$var$v1.ny * $e815fda779bc047b$var$lenOut;
    // Save last point to avoid recalculating vector when not needed
    $e815fda779bc047b$var$lastPoint = currentPoint;
};
/**
 * Draw corner provided by {@link getRoundCorner}
 *
 * @param ctx :CanvasRenderingContext2D
 * @param roundCorner {{cx:number, cy:number, radius:number, endAngle: number, startAngle: number, counterClockwise: boolean}}
 */ function $e815fda779bc047b$var$drawPreparedRoundCorner(ctx, roundCorner) {
    if (roundCorner.radius === 0) ctx.lineTo(roundCorner.cx, roundCorner.cy);
    else ctx.arc(roundCorner.cx, roundCorner.cy, roundCorner.radius, roundCorner.startAngle, roundCorner.endAngle, roundCorner.counterClockwise);
}
/**
 * Get round corner from a point and its previous and next neighbours in a path
 *
 * @param previousPoint {{x: number, y:number, radius: number?}}
 * @param currentPoint {{x: number, y:number, radius: number?}}
 * @param nextPoint {{x: number, y:number, radius: number?}}
 * @param radiusMax :number
 * @param isArcRadius :boolean
 * @return {{
 * cx:number, cy:number, radius:number,
 * startX:number, startY:number,
 * stopX:number, stopY: number,
 * endAngle: number, startAngle: number, counterClockwise: boolean
 * }}
 */ function $e815fda779bc047b$var$getRoundCorner(previousPoint, currentPoint, nextPoint, radiusMax) {
    var isArcRadius = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
    if (radiusMax === 0 || currentPoint.radius === 0) return {
        cx: currentPoint.x,
        cy: currentPoint.y,
        radius: 0,
        startX: currentPoint.x,
        startY: currentPoint.y,
        stopX: currentPoint.x,
        stopY: currentPoint.y,
        startAngle: undefined,
        endAngle: undefined,
        counterClockwise: undefined
    };
    $e815fda779bc047b$var$calcCornerArc(previousPoint, currentPoint, nextPoint, radiusMax, isArcRadius);
    return {
        cx: $e815fda779bc047b$var$x,
        cy: $e815fda779bc047b$var$y,
        radius: $e815fda779bc047b$var$cRadius,
        startX: $e815fda779bc047b$var$startX,
        startY: $e815fda779bc047b$var$startY,
        stopX: $e815fda779bc047b$var$stopX,
        stopY: $e815fda779bc047b$var$stopY,
        startAngle: $e815fda779bc047b$var$v1.ang + Math.PI / 2 * $e815fda779bc047b$var$radDirection,
        endAngle: $e815fda779bc047b$var$v2.ang - Math.PI / 2 * $e815fda779bc047b$var$radDirection,
        counterClockwise: $e815fda779bc047b$var$drawDirection
    };
}
var $e815fda779bc047b$var$AVOID_IMPOSSIBLE_BEZIER_CONSTANT = 0.01;
var $e815fda779bc047b$var$AVOID_IMPOSSIBLE_BEZIER_CONSTANT_L = Math.sqrt(2 * $e815fda779bc047b$var$AVOID_IMPOSSIBLE_BEZIER_CONSTANT);
var $e815fda779bc047b$var$BRp$c = {};
$e815fda779bc047b$var$BRp$c.findMidptPtsEtc = function(edge, pairInfo) {
    var posPts = pairInfo.posPts, intersectionPts = pairInfo.intersectionPts, vectorNormInverse = pairInfo.vectorNormInverse;
    var midptPts;
    // n.b. assumes all edges in bezier bundle have same endpoints specified
    var srcManEndpt = edge.pstyle('source-endpoint');
    var tgtManEndpt = edge.pstyle('target-endpoint');
    var haveManualEndPts = srcManEndpt.units != null && tgtManEndpt.units != null;
    var recalcVectorNormInverse = function recalcVectorNormInverse(x1, y1, x2, y2) {
        var dy = y2 - y1;
        var dx = x2 - x1;
        var l = Math.sqrt(dx * dx + dy * dy);
        return {
            x: -dy / l,
            y: dx / l
        };
    };
    var edgeDistances = edge.pstyle('edge-distances').value;
    switch(edgeDistances){
        case 'node-position':
            midptPts = posPts;
            break;
        case 'intersection':
            midptPts = intersectionPts;
            break;
        case 'endpoints':
            if (haveManualEndPts) {
                var _this$manualEndptToPx = this.manualEndptToPx(edge.source()[0], srcManEndpt), _this$manualEndptToPx2 = $e815fda779bc047b$var$_slicedToArray(_this$manualEndptToPx, 2), x1 = _this$manualEndptToPx2[0], y1 = _this$manualEndptToPx2[1];
                var _this$manualEndptToPx3 = this.manualEndptToPx(edge.target()[0], tgtManEndpt), _this$manualEndptToPx4 = $e815fda779bc047b$var$_slicedToArray(_this$manualEndptToPx3, 2), x2 = _this$manualEndptToPx4[0], y2 = _this$manualEndptToPx4[1];
                var endPts = {
                    x1: x1,
                    y1: y1,
                    x2: x2,
                    y2: y2
                };
                vectorNormInverse = recalcVectorNormInverse(x1, y1, x2, y2);
                midptPts = endPts;
            } else {
                $e815fda779bc047b$var$warn("Edge ".concat(edge.id(), " has edge-distances:endpoints specified without manual endpoints specified via source-endpoint and target-endpoint.  Falling back on edge-distances:intersection (default)."));
                midptPts = intersectionPts; // back to default
            }
            break;
    }
    return {
        midptPts: midptPts,
        vectorNormInverse: vectorNormInverse
    };
};
$e815fda779bc047b$var$BRp$c.findHaystackPoints = function(edges) {
    for(var i = 0; i < edges.length; i++){
        var edge = edges[i];
        var _p = edge._private;
        var rs = _p.rscratch;
        if (!rs.haystack) {
            var angle = Math.random() * 2 * Math.PI;
            rs.source = {
                x: Math.cos(angle),
                y: Math.sin(angle)
            };
            angle = Math.random() * 2 * Math.PI;
            rs.target = {
                x: Math.cos(angle),
                y: Math.sin(angle)
            };
        }
        var src = _p.source;
        var tgt = _p.target;
        var srcPos = src.position();
        var tgtPos = tgt.position();
        var srcW = src.width();
        var tgtW = tgt.width();
        var srcH = src.height();
        var tgtH = tgt.height();
        var radius = edge.pstyle('haystack-radius').value;
        var halfRadius = radius / 2; // b/c have to half width/height
        rs.haystackPts = rs.allpts = [
            rs.source.x * srcW * halfRadius + srcPos.x,
            rs.source.y * srcH * halfRadius + srcPos.y,
            rs.target.x * tgtW * halfRadius + tgtPos.x,
            rs.target.y * tgtH * halfRadius + tgtPos.y
        ];
        rs.midX = (rs.allpts[0] + rs.allpts[2]) / 2;
        rs.midY = (rs.allpts[1] + rs.allpts[3]) / 2;
        // always override as haystack in case set to different type previously
        rs.edgeType = 'haystack';
        rs.haystack = true;
        this.storeEdgeProjections(edge);
        this.calculateArrowAngles(edge);
        this.recalculateEdgeLabelProjections(edge);
        this.calculateLabelAngles(edge);
    }
};
$e815fda779bc047b$var$BRp$c.findSegmentsPoints = function(edge, pairInfo) {
    // Segments (multiple straight lines)
    var rs = edge._private.rscratch;
    var segmentWs = edge.pstyle('segment-weights');
    var segmentDs = edge.pstyle('segment-distances');
    var segmentRs = edge.pstyle('segment-radii');
    var segmentTs = edge.pstyle('radius-type');
    var segmentsN = Math.min(segmentWs.pfValue.length, segmentDs.pfValue.length);
    var lastRadius = segmentRs.pfValue[segmentRs.pfValue.length - 1];
    var lastRadiusType = segmentTs.pfValue[segmentTs.pfValue.length - 1];
    rs.edgeType = 'segments';
    rs.segpts = [];
    rs.radii = [];
    rs.isArcRadius = [];
    for(var s = 0; s < segmentsN; s++){
        var w = segmentWs.pfValue[s];
        var d = segmentDs.pfValue[s];
        var w1 = 1 - w;
        var w2 = w;
        var _this$findMidptPtsEtc = this.findMidptPtsEtc(edge, pairInfo), midptPts = _this$findMidptPtsEtc.midptPts, vectorNormInverse = _this$findMidptPtsEtc.vectorNormInverse;
        var adjustedMidpt = {
            x: midptPts.x1 * w1 + midptPts.x2 * w2,
            y: midptPts.y1 * w1 + midptPts.y2 * w2
        };
        rs.segpts.push(adjustedMidpt.x + vectorNormInverse.x * d, adjustedMidpt.y + vectorNormInverse.y * d);
        rs.radii.push(segmentRs.pfValue[s] !== undefined ? segmentRs.pfValue[s] : lastRadius);
        rs.isArcRadius.push((segmentTs.pfValue[s] !== undefined ? segmentTs.pfValue[s] : lastRadiusType) === 'arc-radius');
    }
};
$e815fda779bc047b$var$BRp$c.findLoopPoints = function(edge, pairInfo, i, edgeIsUnbundled) {
    // Self-edge
    var rs = edge._private.rscratch;
    var dirCounts = pairInfo.dirCounts, srcPos = pairInfo.srcPos;
    var ctrlptDists = edge.pstyle('control-point-distances');
    var ctrlptDist = ctrlptDists ? ctrlptDists.pfValue[0] : undefined;
    var loopDir = edge.pstyle('loop-direction').pfValue;
    var loopSwp = edge.pstyle('loop-sweep').pfValue;
    var stepSize = edge.pstyle('control-point-step-size').pfValue;
    rs.edgeType = 'self';
    var j = i;
    var loopDist = stepSize;
    if (edgeIsUnbundled) {
        j = 0;
        loopDist = ctrlptDist;
    }
    var loopAngle = loopDir - Math.PI / 2;
    var outAngle = loopAngle - loopSwp / 2;
    var inAngle = loopAngle + loopSwp / 2;
    // increase by step size for overlapping loops, keyed on direction and sweep values
    var dc = String(loopDir + '_' + loopSwp);
    j = dirCounts[dc] === undefined ? dirCounts[dc] = 0 : ++dirCounts[dc];
    rs.ctrlpts = [
        srcPos.x + Math.cos(outAngle) * 1.4 * loopDist * (j / 3 + 1),
        srcPos.y + Math.sin(outAngle) * 1.4 * loopDist * (j / 3 + 1),
        srcPos.x + Math.cos(inAngle) * 1.4 * loopDist * (j / 3 + 1),
        srcPos.y + Math.sin(inAngle) * 1.4 * loopDist * (j / 3 + 1)
    ];
};
$e815fda779bc047b$var$BRp$c.findCompoundLoopPoints = function(edge, pairInfo, i, edgeIsUnbundled) {
    // Compound edge
    var rs = edge._private.rscratch;
    rs.edgeType = 'compound';
    var srcPos = pairInfo.srcPos, tgtPos = pairInfo.tgtPos, srcW = pairInfo.srcW, srcH = pairInfo.srcH, tgtW = pairInfo.tgtW, tgtH = pairInfo.tgtH;
    var stepSize = edge.pstyle('control-point-step-size').pfValue;
    var ctrlptDists = edge.pstyle('control-point-distances');
    var ctrlptDist = ctrlptDists ? ctrlptDists.pfValue[0] : undefined;
    var j = i;
    var loopDist = stepSize;
    if (edgeIsUnbundled) {
        j = 0;
        loopDist = ctrlptDist;
    }
    var loopW = 50;
    var loopaPos = {
        x: srcPos.x - srcW / 2,
        y: srcPos.y - srcH / 2
    };
    var loopbPos = {
        x: tgtPos.x - tgtW / 2,
        y: tgtPos.y - tgtH / 2
    };
    var loopPos = {
        x: Math.min(loopaPos.x, loopbPos.x),
        y: Math.min(loopaPos.y, loopbPos.y)
    };
    // avoids cases with impossible beziers
    var minCompoundStretch = 0.5;
    var compoundStretchA = Math.max(minCompoundStretch, Math.log(srcW * $e815fda779bc047b$var$AVOID_IMPOSSIBLE_BEZIER_CONSTANT));
    var compoundStretchB = Math.max(minCompoundStretch, Math.log(tgtW * $e815fda779bc047b$var$AVOID_IMPOSSIBLE_BEZIER_CONSTANT));
    rs.ctrlpts = [
        loopPos.x,
        loopPos.y - (1 + Math.pow(loopW, 1.12) / 100) * loopDist * (j / 3 + 1) * compoundStretchA,
        loopPos.x - (1 + Math.pow(loopW, 1.12) / 100) * loopDist * (j / 3 + 1) * compoundStretchB,
        loopPos.y
    ];
};
$e815fda779bc047b$var$BRp$c.findStraightEdgePoints = function(edge) {
    // Straight edge within bundle
    edge._private.rscratch.edgeType = 'straight';
};
$e815fda779bc047b$var$BRp$c.findBezierPoints = function(edge, pairInfo, i, edgeIsUnbundled, edgeIsSwapped) {
    var rs = edge._private.rscratch;
    var stepSize = edge.pstyle('control-point-step-size').pfValue;
    var ctrlptDists = edge.pstyle('control-point-distances');
    var ctrlptWs = edge.pstyle('control-point-weights');
    var bezierN = ctrlptDists && ctrlptWs ? Math.min(ctrlptDists.value.length, ctrlptWs.value.length) : 1;
    var ctrlptDist = ctrlptDists ? ctrlptDists.pfValue[0] : undefined;
    var ctrlptWeight = ctrlptWs.value[0];
    // (Multi)bezier
    var multi = edgeIsUnbundled;
    rs.edgeType = multi ? 'multibezier' : 'bezier';
    rs.ctrlpts = [];
    for(var b = 0; b < bezierN; b++){
        var normctrlptDist = (0.5 - pairInfo.eles.length / 2 + i) * stepSize * (edgeIsSwapped ? -1 : 1);
        var manctrlptDist = undefined;
        var sign = $e815fda779bc047b$var$signum(normctrlptDist);
        if (multi) {
            ctrlptDist = ctrlptDists ? ctrlptDists.pfValue[b] : stepSize; // fall back on step size
            ctrlptWeight = ctrlptWs.value[b];
        }
        if (edgeIsUnbundled) // multi or single unbundled
        manctrlptDist = ctrlptDist;
        else manctrlptDist = ctrlptDist !== undefined ? sign * ctrlptDist : undefined;
        var distanceFromMidpoint = manctrlptDist !== undefined ? manctrlptDist : normctrlptDist;
        var w1 = 1 - ctrlptWeight;
        var w2 = ctrlptWeight;
        var _this$findMidptPtsEtc2 = this.findMidptPtsEtc(edge, pairInfo), midptPts = _this$findMidptPtsEtc2.midptPts, vectorNormInverse = _this$findMidptPtsEtc2.vectorNormInverse;
        var adjustedMidpt = {
            x: midptPts.x1 * w1 + midptPts.x2 * w2,
            y: midptPts.y1 * w1 + midptPts.y2 * w2
        };
        rs.ctrlpts.push(adjustedMidpt.x + vectorNormInverse.x * distanceFromMidpoint, adjustedMidpt.y + vectorNormInverse.y * distanceFromMidpoint);
    }
};
$e815fda779bc047b$var$BRp$c.findTaxiPoints = function(edge, pairInfo) {
    // Taxicab geometry with two turns maximum
    var rs = edge._private.rscratch;
    rs.edgeType = 'segments';
    var VERTICAL = 'vertical';
    var HORIZONTAL = 'horizontal';
    var LEFTWARD = 'leftward';
    var RIGHTWARD = 'rightward';
    var DOWNWARD = 'downward';
    var UPWARD = 'upward';
    var AUTO = 'auto';
    var posPts = pairInfo.posPts, srcW = pairInfo.srcW, srcH = pairInfo.srcH, tgtW = pairInfo.tgtW, tgtH = pairInfo.tgtH;
    var edgeDistances = edge.pstyle('edge-distances').value;
    var dIncludesNodeBody = edgeDistances !== 'node-position';
    var taxiDir = edge.pstyle('taxi-direction').value;
    var rawTaxiDir = taxiDir; // unprocessed value
    var taxiTurn = edge.pstyle('taxi-turn');
    var turnIsPercent = taxiTurn.units === '%';
    var taxiTurnPfVal = taxiTurn.pfValue;
    var turnIsNegative = taxiTurnPfVal < 0; // i.e. from target side
    var minD = edge.pstyle('taxi-turn-min-distance').pfValue;
    var dw = dIncludesNodeBody ? (srcW + tgtW) / 2 : 0;
    var dh = dIncludesNodeBody ? (srcH + tgtH) / 2 : 0;
    var pdx = posPts.x2 - posPts.x1;
    var pdy = posPts.y2 - posPts.y1;
    // take away the effective w/h from the magnitude of the delta value
    var subDWH = function subDWH(dxy, dwh) {
        if (dxy > 0) return Math.max(dxy - dwh, 0);
        else return Math.min(dxy + dwh, 0);
    };
    var dx = subDWH(pdx, dw);
    var dy = subDWH(pdy, dh);
    var isExplicitDir = false;
    if (rawTaxiDir === AUTO) taxiDir = Math.abs(dx) > Math.abs(dy) ? HORIZONTAL : VERTICAL;
    else if (rawTaxiDir === UPWARD || rawTaxiDir === DOWNWARD) {
        taxiDir = VERTICAL;
        isExplicitDir = true;
    } else if (rawTaxiDir === LEFTWARD || rawTaxiDir === RIGHTWARD) {
        taxiDir = HORIZONTAL;
        isExplicitDir = true;
    }
    var isVert = taxiDir === VERTICAL;
    var l = isVert ? dy : dx;
    var pl = isVert ? pdy : pdx;
    var sgnL = $e815fda779bc047b$var$signum(pl);
    var forcedDir = false;
    if (!(isExplicitDir && (turnIsPercent || turnIsNegative) // forcing in this case would cause weird growing in the opposite direction
    ) && (rawTaxiDir === DOWNWARD && pl < 0 || rawTaxiDir === UPWARD && pl > 0 || rawTaxiDir === LEFTWARD && pl > 0 || rawTaxiDir === RIGHTWARD && pl < 0)) {
        sgnL *= -1;
        l = sgnL * Math.abs(l);
        forcedDir = true;
    }
    var d;
    if (turnIsPercent) {
        var p = taxiTurnPfVal < 0 ? 1 + taxiTurnPfVal : taxiTurnPfVal;
        d = p * l;
    } else {
        var k = taxiTurnPfVal < 0 ? l : 0;
        d = k + taxiTurnPfVal * sgnL;
    }
    var getIsTooClose = function getIsTooClose(d) {
        return Math.abs(d) < minD || Math.abs(d) >= Math.abs(l);
    };
    var isTooCloseSrc = getIsTooClose(d);
    var isTooCloseTgt = getIsTooClose(Math.abs(l) - Math.abs(d));
    var isTooClose = isTooCloseSrc || isTooCloseTgt;
    if (isTooClose && !forcedDir) {
        // non-ideal routing
        if (isVert) {
            // vertical fallbacks
            var lShapeInsideSrc = Math.abs(pl) <= srcH / 2;
            var lShapeInsideTgt = Math.abs(pdx) <= tgtW / 2;
            if (lShapeInsideSrc) {
                // horizontal Z-shape (direction not respected)
                var x = (posPts.x1 + posPts.x2) / 2;
                var y1 = posPts.y1, y2 = posPts.y2;
                rs.segpts = [
                    x,
                    y1,
                    x,
                    y2
                ];
            } else if (lShapeInsideTgt) {
                // vertical Z-shape (distance not respected)
                var y = (posPts.y1 + posPts.y2) / 2;
                var x1 = posPts.x1, x2 = posPts.x2;
                rs.segpts = [
                    x1,
                    y,
                    x2,
                    y
                ];
            } else // L-shape fallback (turn distance not respected, but works well with tree siblings)
            rs.segpts = [
                posPts.x1,
                posPts.y2
            ];
        } else {
            // horizontal fallbacks
            var _lShapeInsideSrc = Math.abs(pl) <= srcW / 2;
            var _lShapeInsideTgt = Math.abs(pdy) <= tgtH / 2;
            if (_lShapeInsideSrc) {
                // vertical Z-shape (direction not respected)
                var _y = (posPts.y1 + posPts.y2) / 2;
                var _x = posPts.x1, _x2 = posPts.x2;
                rs.segpts = [
                    _x,
                    _y,
                    _x2,
                    _y
                ];
            } else if (_lShapeInsideTgt) {
                // horizontal Z-shape (turn distance not respected)
                var _x3 = (posPts.x1 + posPts.x2) / 2;
                var _y2 = posPts.y1, _y3 = posPts.y2;
                rs.segpts = [
                    _x3,
                    _y2,
                    _x3,
                    _y3
                ];
            } else // L-shape (turn distance not respected, but works well for tree siblings)
            rs.segpts = [
                posPts.x2,
                posPts.y1
            ];
        }
    } else // ideal routing
    if (isVert) {
        var _y4 = posPts.y1 + d + (dIncludesNodeBody ? srcH / 2 * sgnL : 0);
        var _x4 = posPts.x1, _x5 = posPts.x2;
        rs.segpts = [
            _x4,
            _y4,
            _x5,
            _y4
        ];
    } else {
        // horizontal
        var _x6 = posPts.x1 + d + (dIncludesNodeBody ? srcW / 2 * sgnL : 0);
        var _y5 = posPts.y1, _y6 = posPts.y2;
        rs.segpts = [
            _x6,
            _y5,
            _x6,
            _y6
        ];
    }
    if (rs.isRound) {
        var radius = edge.pstyle('taxi-radius').value;
        var isArcRadius = edge.pstyle('radius-type').value[0] === 'arc-radius';
        rs.radii = new Array(rs.segpts.length / 2).fill(radius);
        rs.isArcRadius = new Array(rs.segpts.length / 2).fill(isArcRadius);
    }
};
$e815fda779bc047b$var$BRp$c.tryToCorrectInvalidPoints = function(edge, pairInfo) {
    var rs = edge._private.rscratch;
    // can only correct beziers for now...
    if (rs.edgeType === 'bezier') {
        var srcPos = pairInfo.srcPos, tgtPos = pairInfo.tgtPos, srcW = pairInfo.srcW, srcH = pairInfo.srcH, tgtW = pairInfo.tgtW, tgtH = pairInfo.tgtH, srcShape = pairInfo.srcShape, tgtShape = pairInfo.tgtShape, srcCornerRadius = pairInfo.srcCornerRadius, tgtCornerRadius = pairInfo.tgtCornerRadius, srcRs = pairInfo.srcRs, tgtRs = pairInfo.tgtRs;
        var badStart = !$e815fda779bc047b$var$number$1(rs.startX) || !$e815fda779bc047b$var$number$1(rs.startY);
        var badAStart = !$e815fda779bc047b$var$number$1(rs.arrowStartX) || !$e815fda779bc047b$var$number$1(rs.arrowStartY);
        var badEnd = !$e815fda779bc047b$var$number$1(rs.endX) || !$e815fda779bc047b$var$number$1(rs.endY);
        var badAEnd = !$e815fda779bc047b$var$number$1(rs.arrowEndX) || !$e815fda779bc047b$var$number$1(rs.arrowEndY);
        var minCpADistFactor = 3;
        var arrowW = this.getArrowWidth(edge.pstyle('width').pfValue, edge.pstyle('arrow-scale').value) * this.arrowShapeWidth;
        var minCpADist = minCpADistFactor * arrowW;
        var startACpDist = $e815fda779bc047b$var$dist({
            x: rs.ctrlpts[0],
            y: rs.ctrlpts[1]
        }, {
            x: rs.startX,
            y: rs.startY
        });
        var closeStartACp = startACpDist < minCpADist;
        var endACpDist = $e815fda779bc047b$var$dist({
            x: rs.ctrlpts[0],
            y: rs.ctrlpts[1]
        }, {
            x: rs.endX,
            y: rs.endY
        });
        var closeEndACp = endACpDist < minCpADist;
        var overlapping = false;
        if (badStart || badAStart || closeStartACp) {
            overlapping = true;
            // project control point along line from src centre to outside the src shape
            // (otherwise intersection will yield nothing)
            var cpD = {
                // delta
                x: rs.ctrlpts[0] - srcPos.x,
                y: rs.ctrlpts[1] - srcPos.y
            };
            var cpL = Math.sqrt(cpD.x * cpD.x + cpD.y * cpD.y); // length of line
            var cpM = {
                // normalised delta
                x: cpD.x / cpL,
                y: cpD.y / cpL
            };
            var radius = Math.max(srcW, srcH);
            var cpProj = {
                // *2 radius guarantees outside shape
                x: rs.ctrlpts[0] + cpM.x * 2 * radius,
                y: rs.ctrlpts[1] + cpM.y * 2 * radius
            };
            var srcCtrlPtIntn = srcShape.intersectLine(srcPos.x, srcPos.y, srcW, srcH, cpProj.x, cpProj.y, 0, srcCornerRadius, srcRs);
            if (closeStartACp) {
                rs.ctrlpts[0] = rs.ctrlpts[0] + cpM.x * (minCpADist - startACpDist);
                rs.ctrlpts[1] = rs.ctrlpts[1] + cpM.y * (minCpADist - startACpDist);
            } else {
                rs.ctrlpts[0] = srcCtrlPtIntn[0] + cpM.x * minCpADist;
                rs.ctrlpts[1] = srcCtrlPtIntn[1] + cpM.y * minCpADist;
            }
        }
        if (badEnd || badAEnd || closeEndACp) {
            overlapping = true;
            // project control point along line from tgt centre to outside the tgt shape
            // (otherwise intersection will yield nothing)
            var _cpD = {
                // delta
                x: rs.ctrlpts[0] - tgtPos.x,
                y: rs.ctrlpts[1] - tgtPos.y
            };
            var _cpL = Math.sqrt(_cpD.x * _cpD.x + _cpD.y * _cpD.y); // length of line
            var _cpM = {
                // normalised delta
                x: _cpD.x / _cpL,
                y: _cpD.y / _cpL
            };
            var _radius = Math.max(srcW, srcH);
            var _cpProj = {
                // *2 radius guarantees outside shape
                x: rs.ctrlpts[0] + _cpM.x * 2 * _radius,
                y: rs.ctrlpts[1] + _cpM.y * 2 * _radius
            };
            var tgtCtrlPtIntn = tgtShape.intersectLine(tgtPos.x, tgtPos.y, tgtW, tgtH, _cpProj.x, _cpProj.y, 0, tgtCornerRadius, tgtRs);
            if (closeEndACp) {
                rs.ctrlpts[0] = rs.ctrlpts[0] + _cpM.x * (minCpADist - endACpDist);
                rs.ctrlpts[1] = rs.ctrlpts[1] + _cpM.y * (minCpADist - endACpDist);
            } else {
                rs.ctrlpts[0] = tgtCtrlPtIntn[0] + _cpM.x * minCpADist;
                rs.ctrlpts[1] = tgtCtrlPtIntn[1] + _cpM.y * minCpADist;
            }
        }
        if (overlapping) // recalc endpts
        this.findEndpoints(edge);
    }
};
$e815fda779bc047b$var$BRp$c.storeAllpts = function(edge) {
    var rs = edge._private.rscratch;
    if (rs.edgeType === 'multibezier' || rs.edgeType === 'bezier' || rs.edgeType === 'self' || rs.edgeType === 'compound') {
        rs.allpts = [];
        rs.allpts.push(rs.startX, rs.startY);
        for(var b = 0; b + 1 < rs.ctrlpts.length; b += 2){
            // ctrl pt itself
            rs.allpts.push(rs.ctrlpts[b], rs.ctrlpts[b + 1]);
            // the midpt between ctrlpts as intermediate destination pts
            if (b + 3 < rs.ctrlpts.length) rs.allpts.push((rs.ctrlpts[b] + rs.ctrlpts[b + 2]) / 2, (rs.ctrlpts[b + 1] + rs.ctrlpts[b + 3]) / 2);
        }
        rs.allpts.push(rs.endX, rs.endY);
        var m1, mt;
        if (rs.ctrlpts.length / 2 % 2 === 0) {
            m1 = rs.allpts.length / 2 - 1;
            rs.midX = rs.allpts[m1];
            rs.midY = rs.allpts[m1 + 1];
        } else {
            m1 = rs.allpts.length / 2 - 3;
            mt = 0.5;
            rs.midX = $e815fda779bc047b$var$qbezierAt(rs.allpts[m1], rs.allpts[m1 + 2], rs.allpts[m1 + 4], mt);
            rs.midY = $e815fda779bc047b$var$qbezierAt(rs.allpts[m1 + 1], rs.allpts[m1 + 3], rs.allpts[m1 + 5], mt);
        }
    } else if (rs.edgeType === 'straight') {
        // need to calc these after endpts
        rs.allpts = [
            rs.startX,
            rs.startY,
            rs.endX,
            rs.endY
        ];
        // default midpt for labels etc
        rs.midX = (rs.startX + rs.endX + rs.arrowStartX + rs.arrowEndX) / 4;
        rs.midY = (rs.startY + rs.endY + rs.arrowStartY + rs.arrowEndY) / 4;
    } else if (rs.edgeType === 'segments') {
        rs.allpts = [];
        rs.allpts.push(rs.startX, rs.startY);
        rs.allpts.push.apply(rs.allpts, rs.segpts);
        rs.allpts.push(rs.endX, rs.endY);
        if (rs.isRound) {
            rs.roundCorners = [];
            for(var i = 2; i + 3 < rs.allpts.length; i += 2){
                var radius = rs.radii[i / 2 - 1];
                var isArcRadius = rs.isArcRadius[i / 2 - 1];
                rs.roundCorners.push($e815fda779bc047b$var$getRoundCorner({
                    x: rs.allpts[i - 2],
                    y: rs.allpts[i - 1]
                }, {
                    x: rs.allpts[i],
                    y: rs.allpts[i + 1],
                    radius: radius
                }, {
                    x: rs.allpts[i + 2],
                    y: rs.allpts[i + 3]
                }, radius, isArcRadius));
            }
        }
        if (rs.segpts.length % 4 === 0) {
            var i2 = rs.segpts.length / 2;
            var i1 = i2 - 2;
            rs.midX = (rs.segpts[i1] + rs.segpts[i2]) / 2;
            rs.midY = (rs.segpts[i1 + 1] + rs.segpts[i2 + 1]) / 2;
        } else {
            var _i = rs.segpts.length / 2 - 1;
            if (!rs.isRound) {
                rs.midX = rs.segpts[_i];
                rs.midY = rs.segpts[_i + 1];
            } else {
                var point = {
                    x: rs.segpts[_i],
                    y: rs.segpts[_i + 1]
                };
                var corner = rs.roundCorners[_i / 2];
                if (corner.radius === 0) {
                    // On collinear points
                    var nextPoint = {
                        x: rs.segpts[_i + 2],
                        y: rs.segpts[_i + 3]
                    };
                    rs.midX = point.x;
                    rs.midY = point.y;
                    rs.midVector = [
                        point.y - nextPoint.y,
                        nextPoint.x - point.x
                    ];
                } else {
                    // On rounded points
                    var v = [
                        point.x - corner.cx,
                        point.y - corner.cy
                    ];
                    var factor = corner.radius / Math.sqrt(Math.pow(v[0], 2) + Math.pow(v[1], 2));
                    v = v.map(function(c) {
                        return c * factor;
                    });
                    rs.midX = corner.cx + v[0];
                    rs.midY = corner.cy + v[1];
                    rs.midVector = v;
                }
            }
        }
    }
};
$e815fda779bc047b$var$BRp$c.checkForInvalidEdgeWarning = function(edge) {
    var rs = edge[0]._private.rscratch;
    if (rs.nodesOverlap || $e815fda779bc047b$var$number$1(rs.startX) && $e815fda779bc047b$var$number$1(rs.startY) && $e815fda779bc047b$var$number$1(rs.endX) && $e815fda779bc047b$var$number$1(rs.endY)) rs.loggedErr = false;
    else if (!rs.loggedErr) {
        rs.loggedErr = true;
        $e815fda779bc047b$var$warn('Edge `' + edge.id() + '` has invalid endpoints and so it is impossible to draw.  Adjust your edge style (e.g. control points) accordingly or use an alternative edge type.  This is expected behaviour when the source node and the target node overlap.');
    }
};
$e815fda779bc047b$var$BRp$c.findEdgeControlPoints = function(edges) {
    var _this = this;
    if (!edges || edges.length === 0) return;
    var r = this;
    var cy = r.cy;
    var hasCompounds = cy.hasCompoundNodes();
    var hashTable = new $e815fda779bc047b$var$Map$1();
    var getKey = function getKey(pairId, edgeIsUnbundled) {
        return [].concat($e815fda779bc047b$var$_toConsumableArray(pairId), [
            edgeIsUnbundled ? 1 : 0
        ]).join('-');
    };
    var pairIds = [];
    var haystackEdges = [];
    // create a table of edge (src, tgt) => list of edges between them
    for(var i = 0; i < edges.length; i++){
        var edge = edges[i];
        var _p = edge._private;
        var curveStyle = edge.pstyle('curve-style').value;
        // ignore edges who are not to be displayed
        // they shouldn't take up space
        if (edge.removed() || !edge.takesUpSpace()) continue;
        if (curveStyle === 'haystack') {
            haystackEdges.push(edge);
            continue;
        }
        var edgeIsUnbundled = curveStyle === 'unbundled-bezier' || $e815fda779bc047b$var$endsWith(curveStyle, 'segments') || curveStyle === 'straight' || curveStyle === 'straight-triangle' || $e815fda779bc047b$var$endsWith(curveStyle, 'taxi');
        var edgeIsBezier = curveStyle === 'unbundled-bezier' || curveStyle === 'bezier';
        var src = _p.source;
        var tgt = _p.target;
        var srcIndex = src.poolIndex();
        var tgtIndex = tgt.poolIndex();
        var pairId = [
            srcIndex,
            tgtIndex
        ].sort();
        var key = getKey(pairId, edgeIsUnbundled);
        var tableEntry = hashTable.get(key);
        if (tableEntry == null) {
            tableEntry = {
                eles: []
            };
            pairIds.push({
                pairId: pairId,
                edgeIsUnbundled: edgeIsUnbundled
            });
            hashTable.set(key, tableEntry);
        }
        tableEntry.eles.push(edge);
        if (edgeIsUnbundled) tableEntry.hasUnbundled = true;
        if (edgeIsBezier) tableEntry.hasBezier = true;
    }
    // for each pair (src, tgt), create the ctrl pts
    // Nested for loop is OK; total number of iterations for both loops = edgeCount
    var _loop = function _loop() {
        var _pairIds$p = pairIds[p], pairId = _pairIds$p.pairId, edgeIsUnbundled = _pairIds$p.edgeIsUnbundled;
        var key = getKey(pairId, edgeIsUnbundled);
        var pairInfo = hashTable.get(key);
        var swappedpairInfo;
        if (!pairInfo.hasUnbundled) {
            var pllEdges = pairInfo.eles[0].parallelEdges().filter(function(e) {
                return e.isBundledBezier();
            });
            $e815fda779bc047b$var$clearArray(pairInfo.eles);
            pllEdges.forEach(function(edge) {
                return pairInfo.eles.push(edge);
            });
            // for each pair id, the edges should be sorted by index
            pairInfo.eles.sort(function(edge1, edge2) {
                return edge1.poolIndex() - edge2.poolIndex();
            });
        }
        var firstEdge = pairInfo.eles[0];
        var src = firstEdge.source();
        var tgt = firstEdge.target();
        // make sure src/tgt distinction is consistent w.r.t. pairId
        if (src.poolIndex() > tgt.poolIndex()) {
            var temp = src;
            src = tgt;
            tgt = temp;
        }
        var srcPos = pairInfo.srcPos = src.position();
        var tgtPos = pairInfo.tgtPos = tgt.position();
        var srcW = pairInfo.srcW = src.outerWidth();
        var srcH = pairInfo.srcH = src.outerHeight();
        var tgtW = pairInfo.tgtW = tgt.outerWidth();
        var tgtH = pairInfo.tgtH = tgt.outerHeight();
        var srcShape = pairInfo.srcShape = r.nodeShapes[_this.getNodeShape(src)];
        var tgtShape = pairInfo.tgtShape = r.nodeShapes[_this.getNodeShape(tgt)];
        var srcCornerRadius = pairInfo.srcCornerRadius = src.pstyle('corner-radius').value === 'auto' ? 'auto' : src.pstyle('corner-radius').pfValue;
        var tgtCornerRadius = pairInfo.tgtCornerRadius = tgt.pstyle('corner-radius').value === 'auto' ? 'auto' : tgt.pstyle('corner-radius').pfValue;
        var tgtRs = pairInfo.tgtRs = tgt._private.rscratch;
        var srcRs = pairInfo.srcRs = src._private.rscratch;
        pairInfo.dirCounts = {
            'north': 0,
            'west': 0,
            'south': 0,
            'east': 0,
            'northwest': 0,
            'southwest': 0,
            'northeast': 0,
            'southeast': 0
        };
        for(var _i2 = 0; _i2 < pairInfo.eles.length; _i2++){
            var _edge = pairInfo.eles[_i2];
            var rs = _edge[0]._private.rscratch;
            var _curveStyle = _edge.pstyle('curve-style').value;
            var _edgeIsUnbundled = _curveStyle === 'unbundled-bezier' || $e815fda779bc047b$var$endsWith(_curveStyle, 'segments') || $e815fda779bc047b$var$endsWith(_curveStyle, 'taxi');
            // whether the normalised pair order is the reverse of the edge's src-tgt order
            var edgeIsSwapped = !src.same(_edge.source());
            if (!pairInfo.calculatedIntersection && src !== tgt && (pairInfo.hasBezier || pairInfo.hasUnbundled)) {
                pairInfo.calculatedIntersection = true;
                // pt outside src shape to calc distance/displacement from src to tgt
                var srcOutside = srcShape.intersectLine(srcPos.x, srcPos.y, srcW, srcH, tgtPos.x, tgtPos.y, 0, srcCornerRadius, srcRs);
                var srcIntn = pairInfo.srcIntn = srcOutside;
                // pt outside tgt shape to calc distance/displacement from src to tgt
                var tgtOutside = tgtShape.intersectLine(tgtPos.x, tgtPos.y, tgtW, tgtH, srcPos.x, srcPos.y, 0, tgtCornerRadius, tgtRs);
                var tgtIntn = pairInfo.tgtIntn = tgtOutside;
                var intersectionPts = pairInfo.intersectionPts = {
                    x1: srcOutside[0],
                    x2: tgtOutside[0],
                    y1: srcOutside[1],
                    y2: tgtOutside[1]
                };
                var posPts = pairInfo.posPts = {
                    x1: srcPos.x,
                    x2: tgtPos.x,
                    y1: srcPos.y,
                    y2: tgtPos.y
                };
                var dy = tgtOutside[1] - srcOutside[1];
                var dx = tgtOutside[0] - srcOutside[0];
                var l = Math.sqrt(dx * dx + dy * dy);
                if ($e815fda779bc047b$var$number$1(l) && l >= $e815fda779bc047b$var$AVOID_IMPOSSIBLE_BEZIER_CONSTANT_L) ;
                else l = Math.sqrt(Math.max(dx * dx, $e815fda779bc047b$var$AVOID_IMPOSSIBLE_BEZIER_CONSTANT) + Math.max(dy * dy, $e815fda779bc047b$var$AVOID_IMPOSSIBLE_BEZIER_CONSTANT));
                var vector = pairInfo.vector = {
                    x: dx,
                    y: dy
                };
                var vectorNorm = pairInfo.vectorNorm = {
                    x: vector.x / l,
                    y: vector.y / l
                };
                var vectorNormInverse = {
                    x: -vectorNorm.y,
                    y: vectorNorm.x
                };
                // if node shapes overlap, then no ctrl pts to draw
                pairInfo.nodesOverlap = !$e815fda779bc047b$var$number$1(l) || tgtShape.checkPoint(srcOutside[0], srcOutside[1], 0, tgtW, tgtH, tgtPos.x, tgtPos.y, tgtCornerRadius, tgtRs) || srcShape.checkPoint(tgtOutside[0], tgtOutside[1], 0, srcW, srcH, srcPos.x, srcPos.y, srcCornerRadius, srcRs);
                pairInfo.vectorNormInverse = vectorNormInverse;
                swappedpairInfo = {
                    nodesOverlap: pairInfo.nodesOverlap,
                    dirCounts: pairInfo.dirCounts,
                    calculatedIntersection: true,
                    hasBezier: pairInfo.hasBezier,
                    hasUnbundled: pairInfo.hasUnbundled,
                    eles: pairInfo.eles,
                    srcPos: tgtPos,
                    srcRs: tgtRs,
                    tgtPos: srcPos,
                    tgtRs: srcRs,
                    srcW: tgtW,
                    srcH: tgtH,
                    tgtW: srcW,
                    tgtH: srcH,
                    srcIntn: tgtIntn,
                    tgtIntn: srcIntn,
                    srcShape: tgtShape,
                    tgtShape: srcShape,
                    posPts: {
                        x1: posPts.x2,
                        y1: posPts.y2,
                        x2: posPts.x1,
                        y2: posPts.y1
                    },
                    intersectionPts: {
                        x1: intersectionPts.x2,
                        y1: intersectionPts.y2,
                        x2: intersectionPts.x1,
                        y2: intersectionPts.y1
                    },
                    vector: {
                        x: -vector.x,
                        y: -vector.y
                    },
                    vectorNorm: {
                        x: -vectorNorm.x,
                        y: -vectorNorm.y
                    },
                    vectorNormInverse: {
                        x: -vectorNormInverse.x,
                        y: -vectorNormInverse.y
                    }
                };
            }
            var passedPairInfo = edgeIsSwapped ? swappedpairInfo : pairInfo;
            rs.nodesOverlap = passedPairInfo.nodesOverlap;
            rs.srcIntn = passedPairInfo.srcIntn;
            rs.tgtIntn = passedPairInfo.tgtIntn;
            rs.isRound = _curveStyle.startsWith('round');
            if (hasCompounds && (src.isParent() || src.isChild() || tgt.isParent() || tgt.isChild()) && (src.parents().anySame(tgt) || tgt.parents().anySame(src) || src.same(tgt) && src.isParent())) _this.findCompoundLoopPoints(_edge, passedPairInfo, _i2, _edgeIsUnbundled);
            else if (src === tgt) _this.findLoopPoints(_edge, passedPairInfo, _i2, _edgeIsUnbundled);
            else if (_curveStyle.endsWith('segments')) _this.findSegmentsPoints(_edge, passedPairInfo);
            else if (_curveStyle.endsWith('taxi')) _this.findTaxiPoints(_edge, passedPairInfo);
            else if (_curveStyle === 'straight' || !_edgeIsUnbundled && pairInfo.eles.length % 2 === 1 && _i2 === Math.floor(pairInfo.eles.length / 2)) _this.findStraightEdgePoints(_edge);
            else _this.findBezierPoints(_edge, passedPairInfo, _i2, _edgeIsUnbundled, edgeIsSwapped);
            _this.findEndpoints(_edge);
            _this.tryToCorrectInvalidPoints(_edge, passedPairInfo);
            _this.checkForInvalidEdgeWarning(_edge);
            _this.storeAllpts(_edge);
            _this.storeEdgeProjections(_edge);
            _this.calculateArrowAngles(_edge);
            _this.recalculateEdgeLabelProjections(_edge);
            _this.calculateLabelAngles(_edge);
        } // for pair edges
    };
    for(var p = 0; p < pairIds.length; p++)_loop();
     // for pair ids
    // haystacks avoid the expense of pairInfo stuff (intersections etc.)
    this.findHaystackPoints(haystackEdges);
};
function $e815fda779bc047b$var$getPts(pts) {
    var retPts = [];
    if (pts == null) return;
    for(var i = 0; i < pts.length; i += 2){
        var x = pts[i];
        var y = pts[i + 1];
        retPts.push({
            x: x,
            y: y
        });
    }
    return retPts;
}
$e815fda779bc047b$var$BRp$c.getSegmentPoints = function(edge) {
    var rs = edge[0]._private.rscratch;
    this.recalculateRenderedStyle(edge);
    var type = rs.edgeType;
    if (type === 'segments') return $e815fda779bc047b$var$getPts(rs.segpts);
};
$e815fda779bc047b$var$BRp$c.getControlPoints = function(edge) {
    var rs = edge[0]._private.rscratch;
    this.recalculateRenderedStyle(edge);
    var type = rs.edgeType;
    if (type === 'bezier' || type === 'multibezier' || type === 'self' || type === 'compound') return $e815fda779bc047b$var$getPts(rs.ctrlpts);
};
$e815fda779bc047b$var$BRp$c.getEdgeMidpoint = function(edge) {
    var rs = edge[0]._private.rscratch;
    this.recalculateRenderedStyle(edge);
    return {
        x: rs.midX,
        y: rs.midY
    };
};
var $e815fda779bc047b$var$BRp$b = {};
$e815fda779bc047b$var$BRp$b.manualEndptToPx = function(node, prop) {
    var r = this;
    var npos = node.position();
    var w = node.outerWidth();
    var h = node.outerHeight();
    var rs = node._private.rscratch;
    if (prop.value.length === 2) {
        var p = [
            prop.pfValue[0],
            prop.pfValue[1]
        ];
        if (prop.units[0] === '%') p[0] = p[0] * w;
        if (prop.units[1] === '%') p[1] = p[1] * h;
        p[0] += npos.x;
        p[1] += npos.y;
        return p;
    } else {
        var angle = prop.pfValue[0];
        angle = -Math.PI / 2 + angle; // start at 12 o'clock
        var l = 2 * Math.max(w, h);
        var _p = [
            npos.x + Math.cos(angle) * l,
            npos.y + Math.sin(angle) * l
        ];
        return r.nodeShapes[this.getNodeShape(node)].intersectLine(npos.x, npos.y, w, h, _p[0], _p[1], 0, node.pstyle('corner-radius').value === 'auto' ? 'auto' : node.pstyle('corner-radius').pfValue, rs);
    }
};
$e815fda779bc047b$var$BRp$b.findEndpoints = function(edge) {
    var _ref, _tgtManEndpt$pfValue, _ref2, _srcManEndpt$pfValue;
    var r = this;
    var intersect;
    var source = edge.source()[0];
    var target = edge.target()[0];
    var srcPos = source.position();
    var tgtPos = target.position();
    var tgtArShape = edge.pstyle('target-arrow-shape').value;
    var srcArShape = edge.pstyle('source-arrow-shape').value;
    var tgtDist = edge.pstyle('target-distance-from-node').pfValue;
    var srcDist = edge.pstyle('source-distance-from-node').pfValue;
    var srcRs = source._private.rscratch;
    var tgtRs = target._private.rscratch;
    var curveStyle = edge.pstyle('curve-style').value;
    var rs = edge._private.rscratch;
    var et = rs.edgeType;
    var taxi = $e815fda779bc047b$var$endsWith(curveStyle, 'taxi'); // Covers taxi and round-taxi
    var self1 = et === 'self' || et === 'compound';
    var bezier = et === 'bezier' || et === 'multibezier' || self1;
    var multi = et !== 'bezier';
    var lines = et === 'straight' || et === 'segments';
    var segments = et === 'segments';
    var hasEndpts = bezier || multi || lines;
    var overrideEndpts = self1 || taxi;
    var srcManEndpt = edge.pstyle('source-endpoint');
    var srcManEndptVal = overrideEndpts ? 'outside-to-node' : srcManEndpt.value;
    var srcCornerRadius = source.pstyle('corner-radius').value === 'auto' ? 'auto' : source.pstyle('corner-radius').pfValue;
    var tgtManEndpt = edge.pstyle('target-endpoint');
    var tgtManEndptVal = overrideEndpts ? 'outside-to-node' : tgtManEndpt.value;
    var tgtCornerRadius = target.pstyle('corner-radius').value === 'auto' ? 'auto' : target.pstyle('corner-radius').pfValue;
    rs.srcManEndpt = srcManEndpt;
    rs.tgtManEndpt = tgtManEndpt;
    var p1; // last known point of edge on target side
    var p2; // last known point of edge on source side
    var p1_i; // point to intersect with target shape
    var p2_i; // point to intersect with source shape
    var tgtManEndptPt = (_ref = (tgtManEndpt === null || tgtManEndpt === undefined || (_tgtManEndpt$pfValue = tgtManEndpt.pfValue) === null || _tgtManEndpt$pfValue === undefined ? undefined : _tgtManEndpt$pfValue.length) === 2 ? tgtManEndpt.pfValue : null) !== null && _ref !== undefined ? _ref : [
        0,
        0
    ];
    var srcManEndptPt = (_ref2 = (srcManEndpt === null || srcManEndpt === undefined || (_srcManEndpt$pfValue = srcManEndpt.pfValue) === null || _srcManEndpt$pfValue === undefined ? undefined : _srcManEndpt$pfValue.length) === 2 ? srcManEndpt.pfValue : null) !== null && _ref2 !== undefined ? _ref2 : [
        0,
        0
    ];
    if (bezier) {
        var cpStart = [
            rs.ctrlpts[0],
            rs.ctrlpts[1]
        ];
        var cpEnd = multi ? [
            rs.ctrlpts[rs.ctrlpts.length - 2],
            rs.ctrlpts[rs.ctrlpts.length - 1]
        ] : cpStart;
        p1 = cpEnd;
        p2 = cpStart;
    } else if (lines) {
        var srcArrowFromPt = !segments ? [
            tgtPos.x + tgtManEndptPt[0],
            tgtPos.y + tgtManEndptPt[1]
        ] : rs.segpts.slice(0, 2);
        var tgtArrowFromPt = !segments ? [
            srcPos.x + srcManEndptPt[0],
            srcPos.y + srcManEndptPt[1]
        ] : rs.segpts.slice(rs.segpts.length - 2);
        p1 = tgtArrowFromPt;
        p2 = srcArrowFromPt;
    }
    if (tgtManEndptVal === 'inside-to-node') intersect = [
        tgtPos.x,
        tgtPos.y
    ];
    else if (tgtManEndpt.units) intersect = this.manualEndptToPx(target, tgtManEndpt);
    else if (tgtManEndptVal === 'outside-to-line') intersect = rs.tgtIntn; // use cached value from ctrlpt calc
    else {
        if (tgtManEndptVal === 'outside-to-node' || tgtManEndptVal === 'outside-to-node-or-label') p1_i = p1;
        else if (tgtManEndptVal === 'outside-to-line' || tgtManEndptVal === 'outside-to-line-or-label') p1_i = [
            srcPos.x,
            srcPos.y
        ];
        intersect = r.nodeShapes[this.getNodeShape(target)].intersectLine(tgtPos.x, tgtPos.y, target.outerWidth(), target.outerHeight(), p1_i[0], p1_i[1], 0, tgtCornerRadius, tgtRs);
        if (tgtManEndptVal === 'outside-to-node-or-label' || tgtManEndptVal === 'outside-to-line-or-label') {
            var trs = target._private.rscratch;
            var lw = trs.labelWidth;
            var lh = trs.labelHeight;
            var lx = trs.labelX;
            var ly = trs.labelY;
            var lw2 = lw / 2;
            var lh2 = lh / 2;
            var va = target.pstyle('text-valign').value;
            if (va === 'top') ly -= lh2;
            else if (va === 'bottom') ly += lh2;
            var ha = target.pstyle('text-halign').value;
            if (ha === 'left') lx -= lw2;
            else if (ha === 'right') lx += lw2;
            var labelIntersect = $e815fda779bc047b$var$polygonIntersectLine(p1_i[0], p1_i[1], [
                lx - lw2,
                ly - lh2,
                lx + lw2,
                ly - lh2,
                lx + lw2,
                ly + lh2,
                lx - lw2,
                ly + lh2
            ], tgtPos.x, tgtPos.y);
            if (labelIntersect.length > 0) {
                var refPt = srcPos;
                var intSqdist = $e815fda779bc047b$var$sqdist(refPt, $e815fda779bc047b$var$array2point(intersect));
                var labIntSqdist = $e815fda779bc047b$var$sqdist(refPt, $e815fda779bc047b$var$array2point(labelIntersect));
                var minSqDist = intSqdist;
                if (labIntSqdist < intSqdist) {
                    intersect = labelIntersect;
                    minSqDist = labIntSqdist;
                }
                if (labelIntersect.length > 2) {
                    var labInt2SqDist = $e815fda779bc047b$var$sqdist(refPt, {
                        x: labelIntersect[2],
                        y: labelIntersect[3]
                    });
                    if (labInt2SqDist < minSqDist) intersect = [
                        labelIntersect[2],
                        labelIntersect[3]
                    ];
                }
            }
        }
    }
    var arrowEnd = $e815fda779bc047b$var$shortenIntersection(intersect, p1, r.arrowShapes[tgtArShape].spacing(edge) + tgtDist);
    var edgeEnd = $e815fda779bc047b$var$shortenIntersection(intersect, p1, r.arrowShapes[tgtArShape].gap(edge) + tgtDist);
    rs.endX = edgeEnd[0];
    rs.endY = edgeEnd[1];
    rs.arrowEndX = arrowEnd[0];
    rs.arrowEndY = arrowEnd[1];
    if (srcManEndptVal === 'inside-to-node') intersect = [
        srcPos.x,
        srcPos.y
    ];
    else if (srcManEndpt.units) intersect = this.manualEndptToPx(source, srcManEndpt);
    else if (srcManEndptVal === 'outside-to-line') intersect = rs.srcIntn; // use cached value from ctrlpt calc
    else {
        if (srcManEndptVal === 'outside-to-node' || srcManEndptVal === 'outside-to-node-or-label') p2_i = p2;
        else if (srcManEndptVal === 'outside-to-line' || srcManEndptVal === 'outside-to-line-or-label') p2_i = [
            tgtPos.x,
            tgtPos.y
        ];
        intersect = r.nodeShapes[this.getNodeShape(source)].intersectLine(srcPos.x, srcPos.y, source.outerWidth(), source.outerHeight(), p2_i[0], p2_i[1], 0, srcCornerRadius, srcRs);
        if (srcManEndptVal === 'outside-to-node-or-label' || srcManEndptVal === 'outside-to-line-or-label') {
            var srs = source._private.rscratch;
            var _lw = srs.labelWidth;
            var _lh = srs.labelHeight;
            var _lx = srs.labelX;
            var _ly = srs.labelY;
            var _lw2 = _lw / 2;
            var _lh2 = _lh / 2;
            var _va = source.pstyle('text-valign').value;
            if (_va === 'top') _ly -= _lh2;
            else if (_va === 'bottom') _ly += _lh2;
            var _ha = source.pstyle('text-halign').value;
            if (_ha === 'left') _lx -= _lw2;
            else if (_ha === 'right') _lx += _lw2;
            var _labelIntersect = $e815fda779bc047b$var$polygonIntersectLine(p2_i[0], p2_i[1], [
                _lx - _lw2,
                _ly - _lh2,
                _lx + _lw2,
                _ly - _lh2,
                _lx + _lw2,
                _ly + _lh2,
                _lx - _lw2,
                _ly + _lh2
            ], srcPos.x, srcPos.y);
            if (_labelIntersect.length > 0) {
                var _refPt = tgtPos;
                var _intSqdist = $e815fda779bc047b$var$sqdist(_refPt, $e815fda779bc047b$var$array2point(intersect));
                var _labIntSqdist = $e815fda779bc047b$var$sqdist(_refPt, $e815fda779bc047b$var$array2point(_labelIntersect));
                var _minSqDist = _intSqdist;
                if (_labIntSqdist < _intSqdist) {
                    intersect = [
                        _labelIntersect[0],
                        _labelIntersect[1]
                    ];
                    _minSqDist = _labIntSqdist;
                }
                if (_labelIntersect.length > 2) {
                    var _labInt2SqDist = $e815fda779bc047b$var$sqdist(_refPt, {
                        x: _labelIntersect[2],
                        y: _labelIntersect[3]
                    });
                    if (_labInt2SqDist < _minSqDist) intersect = [
                        _labelIntersect[2],
                        _labelIntersect[3]
                    ];
                }
            }
        }
    }
    var arrowStart = $e815fda779bc047b$var$shortenIntersection(intersect, p2, r.arrowShapes[srcArShape].spacing(edge) + srcDist);
    var edgeStart = $e815fda779bc047b$var$shortenIntersection(intersect, p2, r.arrowShapes[srcArShape].gap(edge) + srcDist);
    rs.startX = edgeStart[0];
    rs.startY = edgeStart[1];
    rs.arrowStartX = arrowStart[0];
    rs.arrowStartY = arrowStart[1];
    if (hasEndpts) {
        if (!$e815fda779bc047b$var$number$1(rs.startX) || !$e815fda779bc047b$var$number$1(rs.startY) || !$e815fda779bc047b$var$number$1(rs.endX) || !$e815fda779bc047b$var$number$1(rs.endY)) rs.badLine = true;
        else rs.badLine = false;
    }
};
$e815fda779bc047b$var$BRp$b.getSourceEndpoint = function(edge) {
    var rs = edge[0]._private.rscratch;
    this.recalculateRenderedStyle(edge);
    switch(rs.edgeType){
        case 'haystack':
            return {
                x: rs.haystackPts[0],
                y: rs.haystackPts[1]
            };
        default:
            return {
                x: rs.arrowStartX,
                y: rs.arrowStartY
            };
    }
};
$e815fda779bc047b$var$BRp$b.getTargetEndpoint = function(edge) {
    var rs = edge[0]._private.rscratch;
    this.recalculateRenderedStyle(edge);
    switch(rs.edgeType){
        case 'haystack':
            return {
                x: rs.haystackPts[2],
                y: rs.haystackPts[3]
            };
        default:
            return {
                x: rs.arrowEndX,
                y: rs.arrowEndY
            };
    }
};
var $e815fda779bc047b$var$BRp$a = {};
function $e815fda779bc047b$var$pushBezierPts(r, edge, pts) {
    var qbezierAt$1 = function qbezierAt$1(p1, p2, p3, t) {
        return $e815fda779bc047b$var$qbezierAt(p1, p2, p3, t);
    };
    var _p = edge._private;
    var bpts = _p.rstyle.bezierPts;
    for(var i = 0; i < r.bezierProjPcts.length; i++){
        var p = r.bezierProjPcts[i];
        bpts.push({
            x: qbezierAt$1(pts[0], pts[2], pts[4], p),
            y: qbezierAt$1(pts[1], pts[3], pts[5], p)
        });
    }
}
$e815fda779bc047b$var$BRp$a.storeEdgeProjections = function(edge) {
    var _p = edge._private;
    var rs = _p.rscratch;
    var et = rs.edgeType;
    // clear the cached points state
    _p.rstyle.bezierPts = null;
    _p.rstyle.linePts = null;
    _p.rstyle.haystackPts = null;
    if (et === 'multibezier' || et === 'bezier' || et === 'self' || et === 'compound') {
        _p.rstyle.bezierPts = [];
        for(var i = 0; i + 5 < rs.allpts.length; i += 4)$e815fda779bc047b$var$pushBezierPts(this, edge, rs.allpts.slice(i, i + 6));
    } else if (et === 'segments') {
        var lpts = _p.rstyle.linePts = [];
        for(var i = 0; i + 1 < rs.allpts.length; i += 2)lpts.push({
            x: rs.allpts[i],
            y: rs.allpts[i + 1]
        });
    } else if (et === 'haystack') {
        var hpts = rs.haystackPts;
        _p.rstyle.haystackPts = [
            {
                x: hpts[0],
                y: hpts[1]
            },
            {
                x: hpts[2],
                y: hpts[3]
            }
        ];
    }
    _p.rstyle.arrowWidth = this.getArrowWidth(edge.pstyle('width').pfValue, edge.pstyle('arrow-scale').value) * this.arrowShapeWidth;
};
$e815fda779bc047b$var$BRp$a.recalculateEdgeProjections = function(edges) {
    this.findEdgeControlPoints(edges);
};
var $e815fda779bc047b$var$BRp$9 = {};
$e815fda779bc047b$var$BRp$9.recalculateNodeLabelProjection = function(node) {
    var content = node.pstyle('label').strValue;
    if ($e815fda779bc047b$var$emptyString(content)) return;
    var textX, textY;
    var _p = node._private;
    var nodeWidth = node.width();
    var nodeHeight = node.height();
    var padding = node.padding();
    var nodePos = node.position();
    var textHalign = node.pstyle('text-halign').strValue;
    var textValign = node.pstyle('text-valign').strValue;
    var rs = _p.rscratch;
    var rstyle = _p.rstyle;
    switch(textHalign){
        case 'left':
            textX = nodePos.x - nodeWidth / 2 - padding;
            break;
        case 'right':
            textX = nodePos.x + nodeWidth / 2 + padding;
            break;
        default:
            // e.g. center
            textX = nodePos.x;
    }
    switch(textValign){
        case 'top':
            textY = nodePos.y - nodeHeight / 2 - padding;
            break;
        case 'bottom':
            textY = nodePos.y + nodeHeight / 2 + padding;
            break;
        default:
            // e.g. middle
            textY = nodePos.y;
    }
    rs.labelX = textX;
    rs.labelY = textY;
    rstyle.labelX = textX;
    rstyle.labelY = textY;
    this.calculateLabelAngles(node);
    this.applyLabelDimensions(node);
};
var $e815fda779bc047b$var$lineAngleFromDelta = function lineAngleFromDelta(dx, dy) {
    var angle = Math.atan(dy / dx);
    if (dx === 0 && angle < 0) angle = angle * -1;
    return angle;
};
var $e815fda779bc047b$var$lineAngle = function lineAngle(p0, p1) {
    var dx = p1.x - p0.x;
    var dy = p1.y - p0.y;
    return $e815fda779bc047b$var$lineAngleFromDelta(dx, dy);
};
var $e815fda779bc047b$var$bezierAngle = function bezierAngle(p0, p1, p2, t) {
    var t0 = $e815fda779bc047b$var$bound(0, t - 0.001, 1);
    var t1 = $e815fda779bc047b$var$bound(0, t + 0.001, 1);
    var lp0 = $e815fda779bc047b$var$qbezierPtAt(p0, p1, p2, t0);
    var lp1 = $e815fda779bc047b$var$qbezierPtAt(p0, p1, p2, t1);
    return $e815fda779bc047b$var$lineAngle(lp0, lp1);
};
$e815fda779bc047b$var$BRp$9.recalculateEdgeLabelProjections = function(edge) {
    var p;
    var _p = edge._private;
    var rs = _p.rscratch;
    var r = this;
    var content = {
        mid: edge.pstyle('label').strValue,
        source: edge.pstyle('source-label').strValue,
        target: edge.pstyle('target-label').strValue
    };
    if (content.mid || content.source || content.target) ;
    else return; // no labels => no calcs
    // add center point to style so bounding box calculations can use it
    //
    p = {
        x: rs.midX,
        y: rs.midY
    };
    var setRs = function setRs(propName, prefix, value) {
        $e815fda779bc047b$var$setPrefixedProperty(_p.rscratch, propName, prefix, value);
        $e815fda779bc047b$var$setPrefixedProperty(_p.rstyle, propName, prefix, value);
    };
    setRs('labelX', null, p.x);
    setRs('labelY', null, p.y);
    var midAngle = $e815fda779bc047b$var$lineAngleFromDelta(rs.midDispX, rs.midDispY);
    setRs('labelAutoAngle', null, midAngle);
    var _createControlPointInfo = function createControlPointInfo() {
        if (_createControlPointInfo.cache) return _createControlPointInfo.cache;
         // use cache so only 1x per edge
        var ctrlpts = [];
        // store each ctrlpt info init
        for(var i = 0; i + 5 < rs.allpts.length; i += 4){
            var p0 = {
                x: rs.allpts[i],
                y: rs.allpts[i + 1]
            };
            var p1 = {
                x: rs.allpts[i + 2],
                y: rs.allpts[i + 3]
            }; // ctrlpt
            var p2 = {
                x: rs.allpts[i + 4],
                y: rs.allpts[i + 5]
            };
            ctrlpts.push({
                p0: p0,
                p1: p1,
                p2: p2,
                startDist: 0,
                length: 0,
                segments: []
            });
        }
        var bpts = _p.rstyle.bezierPts;
        var nProjs = r.bezierProjPcts.length;
        function addSegment(cp, p0, p1, t0, t1) {
            var length = $e815fda779bc047b$var$dist(p0, p1);
            var prevSegment = cp.segments[cp.segments.length - 1];
            var segment = {
                p0: p0,
                p1: p1,
                t0: t0,
                t1: t1,
                startDist: prevSegment ? prevSegment.startDist + prevSegment.length : 0,
                length: length
            };
            cp.segments.push(segment);
            cp.length += length;
        }
        // update each ctrlpt with segment info
        for(var _i = 0; _i < ctrlpts.length; _i++){
            var cp = ctrlpts[_i];
            var prevCp = ctrlpts[_i - 1];
            if (prevCp) cp.startDist = prevCp.startDist + prevCp.length;
            addSegment(cp, cp.p0, bpts[_i * nProjs], 0, r.bezierProjPcts[0]); // first
            for(var j = 0; j < nProjs - 1; j++)addSegment(cp, bpts[_i * nProjs + j], bpts[_i * nProjs + j + 1], r.bezierProjPcts[j], r.bezierProjPcts[j + 1]);
            addSegment(cp, bpts[_i * nProjs + nProjs - 1], cp.p2, r.bezierProjPcts[nProjs - 1], 1); // last
        }
        return _createControlPointInfo.cache = ctrlpts;
    };
    var calculateEndProjection = function calculateEndProjection(prefix) {
        var angle;
        var isSrc = prefix === 'source';
        if (!content[prefix]) return;
        var offset = edge.pstyle(prefix + '-text-offset').pfValue;
        switch(rs.edgeType){
            case 'self':
            case 'compound':
            case 'bezier':
            case 'multibezier':
                var cps = _createControlPointInfo();
                var selected;
                var startDist = 0;
                var totalDist = 0;
                // find the segment we're on
                for(var i = 0; i < cps.length; i++){
                    var _cp = cps[isSrc ? i : cps.length - 1 - i];
                    for(var j = 0; j < _cp.segments.length; j++){
                        var _seg = _cp.segments[isSrc ? j : _cp.segments.length - 1 - j];
                        var lastSeg = i === cps.length - 1 && j === _cp.segments.length - 1;
                        startDist = totalDist;
                        totalDist += _seg.length;
                        if (totalDist >= offset || lastSeg) {
                            selected = {
                                cp: _cp,
                                segment: _seg
                            };
                            break;
                        }
                    }
                    if (selected) break;
                }
                var cp = selected.cp;
                var seg = selected.segment;
                var tSegment = (offset - startDist) / seg.length;
                var segDt = seg.t1 - seg.t0;
                var t = isSrc ? seg.t0 + segDt * tSegment : seg.t1 - segDt * tSegment;
                t = $e815fda779bc047b$var$bound(0, t, 1);
                p = $e815fda779bc047b$var$qbezierPtAt(cp.p0, cp.p1, cp.p2, t);
                angle = $e815fda779bc047b$var$bezierAngle(cp.p0, cp.p1, cp.p2, t);
                break;
            case 'straight':
            case 'segments':
            case 'haystack':
                var d = 0, di, d0;
                var p0, p1;
                var l = rs.allpts.length;
                for(var _i2 = 0; _i2 + 3 < l; _i2 += 2){
                    if (isSrc) {
                        p0 = {
                            x: rs.allpts[_i2],
                            y: rs.allpts[_i2 + 1]
                        };
                        p1 = {
                            x: rs.allpts[_i2 + 2],
                            y: rs.allpts[_i2 + 3]
                        };
                    } else {
                        p0 = {
                            x: rs.allpts[l - 2 - _i2],
                            y: rs.allpts[l - 1 - _i2]
                        };
                        p1 = {
                            x: rs.allpts[l - 4 - _i2],
                            y: rs.allpts[l - 3 - _i2]
                        };
                    }
                    di = $e815fda779bc047b$var$dist(p0, p1);
                    d0 = d;
                    d += di;
                    if (d >= offset) break;
                }
                var pD = offset - d0;
                var _t = pD / di;
                _t = $e815fda779bc047b$var$bound(0, _t, 1);
                p = $e815fda779bc047b$var$lineAt(p0, p1, _t);
                angle = $e815fda779bc047b$var$lineAngle(p0, p1);
                break;
        }
        setRs('labelX', prefix, p.x);
        setRs('labelY', prefix, p.y);
        setRs('labelAutoAngle', prefix, angle);
    };
    calculateEndProjection('source');
    calculateEndProjection('target');
    this.applyLabelDimensions(edge);
};
$e815fda779bc047b$var$BRp$9.applyLabelDimensions = function(ele) {
    this.applyPrefixedLabelDimensions(ele);
    if (ele.isEdge()) {
        this.applyPrefixedLabelDimensions(ele, 'source');
        this.applyPrefixedLabelDimensions(ele, 'target');
    }
};
$e815fda779bc047b$var$BRp$9.applyPrefixedLabelDimensions = function(ele, prefix) {
    var _p = ele._private;
    var text = this.getLabelText(ele, prefix);
    var cacheKey = $e815fda779bc047b$var$hashString(text, ele._private.labelDimsKey);
    // save recalc if the label is the same as before
    if ($e815fda779bc047b$var$getPrefixedProperty(_p.rscratch, 'prefixedLabelDimsKey', prefix) === cacheKey) return; // then the label dimensions + text are the same
    // save the key
    $e815fda779bc047b$var$setPrefixedProperty(_p.rscratch, 'prefixedLabelDimsKey', prefix, cacheKey);
    var labelDims = this.calculateLabelDimensions(ele, text);
    var lineHeight = ele.pstyle('line-height').pfValue;
    var textWrap = ele.pstyle('text-wrap').strValue;
    var lines = $e815fda779bc047b$var$getPrefixedProperty(_p.rscratch, 'labelWrapCachedLines', prefix) || [];
    var numLines = textWrap !== 'wrap' ? 1 : Math.max(lines.length, 1);
    var normPerLineHeight = labelDims.height / numLines;
    var labelLineHeight = normPerLineHeight * lineHeight;
    var width = labelDims.width;
    var height = labelDims.height + (numLines - 1) * (lineHeight - 1) * normPerLineHeight;
    $e815fda779bc047b$var$setPrefixedProperty(_p.rstyle, 'labelWidth', prefix, width);
    $e815fda779bc047b$var$setPrefixedProperty(_p.rscratch, 'labelWidth', prefix, width);
    $e815fda779bc047b$var$setPrefixedProperty(_p.rstyle, 'labelHeight', prefix, height);
    $e815fda779bc047b$var$setPrefixedProperty(_p.rscratch, 'labelHeight', prefix, height);
    $e815fda779bc047b$var$setPrefixedProperty(_p.rscratch, 'labelLineHeight', prefix, labelLineHeight);
};
$e815fda779bc047b$var$BRp$9.getLabelText = function(ele, prefix) {
    var _p = ele._private;
    var pfd = prefix ? prefix + '-' : '';
    var text = ele.pstyle(pfd + 'label').strValue;
    var textTransform = ele.pstyle('text-transform').value;
    var rscratch = function rscratch(propName, value) {
        if (value) {
            $e815fda779bc047b$var$setPrefixedProperty(_p.rscratch, propName, prefix, value);
            return value;
        } else return $e815fda779bc047b$var$getPrefixedProperty(_p.rscratch, propName, prefix);
    };
    // for empty text, skip all processing
    if (!text) return '';
    if (textTransform == 'none') ;
    else if (textTransform == 'uppercase') text = text.toUpperCase();
    else if (textTransform == 'lowercase') text = text.toLowerCase();
    var wrapStyle = ele.pstyle('text-wrap').value;
    if (wrapStyle === 'wrap') {
        var labelKey = rscratch('labelKey');
        // save recalc if the label is the same as before
        if (labelKey != null && rscratch('labelWrapKey') === labelKey) return rscratch('labelWrapCachedText');
        var zwsp = "\u200B";
        var lines = text.split('\n');
        var maxW = ele.pstyle('text-max-width').pfValue;
        var overflow = ele.pstyle('text-overflow-wrap').value;
        var overflowAny = overflow === 'anywhere';
        var wrappedLines = [];
        var separatorRegex = /[\s\u200b]+|$/g; // Include end of string to add last word
        for(var l = 0; l < lines.length; l++){
            var line = lines[l];
            var lineDims = this.calculateLabelDimensions(ele, line);
            var lineW = lineDims.width;
            if (overflowAny) {
                var processedLine = line.split('').join(zwsp);
                line = processedLine;
            }
            if (lineW > maxW) {
                // line is too long
                var separatorMatches = line.matchAll(separatorRegex);
                var subline = '';
                var previousIndex = 0;
                // Add fake match
                var _iterator = $e815fda779bc047b$var$_createForOfIteratorHelper(separatorMatches), _step;
                try {
                    for(_iterator.s(); !(_step = _iterator.n()).done;){
                        var separatorMatch = _step.value;
                        var wordSeparator = separatorMatch[0];
                        var word = line.substring(previousIndex, separatorMatch.index);
                        previousIndex = separatorMatch.index + wordSeparator.length;
                        var testLine = subline.length === 0 ? word : subline + word + wordSeparator;
                        var testDims = this.calculateLabelDimensions(ele, testLine);
                        var testW = testDims.width;
                        if (testW <= maxW) // word fits on current line
                        subline += word + wordSeparator;
                        else {
                            // word starts new line
                            if (subline) wrappedLines.push(subline);
                            subline = word + wordSeparator;
                        }
                    }
                // if there's remaining text, put it in a wrapped line
                } catch (err) {
                    _iterator.e(err);
                } finally{
                    _iterator.f();
                }
                if (!subline.match(/^[\s\u200b]+$/)) wrappedLines.push(subline);
            } else // line is already short enough
            wrappedLines.push(line);
        } // for
        rscratch('labelWrapCachedLines', wrappedLines);
        text = rscratch('labelWrapCachedText', wrappedLines.join('\n'));
        rscratch('labelWrapKey', labelKey);
    } else if (wrapStyle === 'ellipsis') {
        var _maxW = ele.pstyle('text-max-width').pfValue;
        var ellipsized = '';
        var ellipsis = "\u2026";
        var incLastCh = false;
        if (this.calculateLabelDimensions(ele, text).width < _maxW) // the label already fits
        return text;
        for(var i = 0; i < text.length; i++){
            var widthWithNextCh = this.calculateLabelDimensions(ele, ellipsized + text[i] + ellipsis).width;
            if (widthWithNextCh > _maxW) break;
            ellipsized += text[i];
            if (i === text.length - 1) incLastCh = true;
        }
        if (!incLastCh) ellipsized += ellipsis;
        return ellipsized;
    } // if ellipsize
    return text;
};
$e815fda779bc047b$var$BRp$9.getLabelJustification = function(ele) {
    var justification = ele.pstyle('text-justification').strValue;
    var textHalign = ele.pstyle('text-halign').strValue;
    if (justification === 'auto') {
        if (ele.isNode()) switch(textHalign){
            case 'left':
                return 'right';
            case 'right':
                return 'left';
            default:
                return 'center';
        }
        else return 'center';
    } else return justification;
};
$e815fda779bc047b$var$BRp$9.calculateLabelDimensions = function(ele, text) {
    var r = this;
    var containerWindow = r.cy.window();
    var document1 = containerWindow.document;
    var padding = 0; // add padding around text dims, as the measurement isn't that accurate
    var fStyle = ele.pstyle('font-style').strValue;
    var size = ele.pstyle('font-size').pfValue;
    var family = ele.pstyle('font-family').strValue;
    var weight = ele.pstyle('font-weight').strValue;
    var canvas = this.labelCalcCanvas;
    var c2d = this.labelCalcCanvasContext;
    if (!canvas) {
        canvas = this.labelCalcCanvas = document1.createElement('canvas');
        c2d = this.labelCalcCanvasContext = canvas.getContext('2d');
        var ds = canvas.style;
        ds.position = 'absolute';
        ds.left = '-9999px';
        ds.top = '-9999px';
        ds.zIndex = '-1';
        ds.visibility = 'hidden';
        ds.pointerEvents = 'none';
    }
    c2d.font = "".concat(fStyle, " ").concat(weight, " ").concat(size, "px ").concat(family);
    var width = 0;
    var height = 0;
    var lines = text.split('\n');
    for(var i = 0; i < lines.length; i++){
        var line = lines[i];
        var metrics = c2d.measureText(line);
        var w = Math.ceil(metrics.width);
        var h = size;
        width = Math.max(w, width);
        height += h;
    }
    width += padding;
    height += padding;
    return {
        width: width,
        height: height
    };
};
$e815fda779bc047b$var$BRp$9.calculateLabelAngle = function(ele, prefix) {
    var _p = ele._private;
    var rs = _p.rscratch;
    var isEdge = ele.isEdge();
    var prefixDash = prefix ? prefix + '-' : '';
    var rot = ele.pstyle(prefixDash + 'text-rotation');
    var rotStr = rot.strValue;
    if (rotStr === 'none') return 0;
    else if (isEdge && rotStr === 'autorotate') return rs.labelAutoAngle;
    else if (rotStr === 'autorotate') return 0;
    else return rot.pfValue;
};
$e815fda779bc047b$var$BRp$9.calculateLabelAngles = function(ele) {
    var r = this;
    var isEdge = ele.isEdge();
    var _p = ele._private;
    var rs = _p.rscratch;
    rs.labelAngle = r.calculateLabelAngle(ele);
    if (isEdge) {
        rs.sourceLabelAngle = r.calculateLabelAngle(ele, 'source');
        rs.targetLabelAngle = r.calculateLabelAngle(ele, 'target');
    }
};
var $e815fda779bc047b$var$BRp$8 = {};
var $e815fda779bc047b$var$TOO_SMALL_CUT_RECT = 28;
var $e815fda779bc047b$var$warnedCutRect = false;
$e815fda779bc047b$var$BRp$8.getNodeShape = function(node) {
    var r = this;
    var shape = node.pstyle('shape').value;
    if (shape === 'cutrectangle' && (node.width() < $e815fda779bc047b$var$TOO_SMALL_CUT_RECT || node.height() < $e815fda779bc047b$var$TOO_SMALL_CUT_RECT)) {
        if (!$e815fda779bc047b$var$warnedCutRect) {
            $e815fda779bc047b$var$warn('The `cutrectangle` node shape can not be used at small sizes so `rectangle` is used instead');
            $e815fda779bc047b$var$warnedCutRect = true;
        }
        return 'rectangle';
    }
    if (node.isParent()) {
        if (shape === 'rectangle' || shape === 'roundrectangle' || shape === 'round-rectangle' || shape === 'cutrectangle' || shape === 'cut-rectangle' || shape === 'barrel') return shape;
        else return 'rectangle';
    }
    if (shape === 'polygon') {
        var points = node.pstyle('shape-polygon-points').value;
        return r.nodeShapes.makePolygon(points).name;
    }
    return shape;
};
var $e815fda779bc047b$var$BRp$7 = {};
$e815fda779bc047b$var$BRp$7.registerCalculationListeners = function() {
    var cy = this.cy;
    var elesToUpdate = cy.collection();
    var r = this;
    var enqueue = function enqueue(eles) {
        var dirtyStyleCaches = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
        elesToUpdate.merge(eles);
        if (dirtyStyleCaches) for(var i = 0; i < eles.length; i++){
            var ele = eles[i];
            var _p = ele._private;
            var rstyle = _p.rstyle;
            rstyle.clean = false;
            rstyle.cleanConnected = false;
        }
    };
    r.binder(cy).on('bounds.* dirty.*', function onDirtyBounds(e) {
        var ele = e.target;
        enqueue(ele);
    }).on('style.* background.*', function onDirtyStyle(e) {
        var ele = e.target;
        enqueue(ele, false);
    });
    var updateEleCalcs = function updateEleCalcs(willDraw) {
        if (willDraw) {
            var fns = r.onUpdateEleCalcsFns;
            // because we need to have up-to-date style (e.g. stylesheet mappers)
            // before calculating rendered style (and pstyle might not be called yet)
            elesToUpdate.cleanStyle();
            for(var i = 0; i < elesToUpdate.length; i++){
                var ele = elesToUpdate[i];
                var rstyle = ele._private.rstyle;
                if (ele.isNode() && !rstyle.cleanConnected) {
                    enqueue(ele.connectedEdges());
                    rstyle.cleanConnected = true;
                }
            }
            if (fns) for(var _i = 0; _i < fns.length; _i++){
                var fn = fns[_i];
                fn(willDraw, elesToUpdate);
            }
            r.recalculateRenderedStyle(elesToUpdate);
            elesToUpdate = cy.collection();
        }
    };
    r.flushRenderedStyleQueue = function() {
        updateEleCalcs(true);
    };
    r.beforeRender(updateEleCalcs, r.beforeRenderPriorities.eleCalcs);
};
$e815fda779bc047b$var$BRp$7.onUpdateEleCalcs = function(fn) {
    var fns = this.onUpdateEleCalcsFns = this.onUpdateEleCalcsFns || [];
    fns.push(fn);
};
$e815fda779bc047b$var$BRp$7.recalculateRenderedStyle = function(eles, useCache) {
    var isCleanConnected = function isCleanConnected(ele) {
        return ele._private.rstyle.cleanConnected;
    };
    if (eles.length === 0) return;
    var edges = [];
    var nodes = [];
    // the renderer can't be used for calcs when destroyed, e.g. ele.boundingBox()
    if (this.destroyed) return;
    // use cache by default for perf
    if (useCache === undefined) useCache = true;
    for(var i = 0; i < eles.length; i++){
        var ele = eles[i];
        var _p = ele._private;
        var rstyle = _p.rstyle;
        // an edge may be implicitly dirty b/c of one of its connected nodes
        // (and a request for recalc may come in between frames)
        if (ele.isEdge() && (!isCleanConnected(ele.source()) || !isCleanConnected(ele.target()))) rstyle.clean = false;
        if (ele.isEdge() && ele.isBundledBezier()) {
            if (ele.parallelEdges().some(function(ele) {
                return !ele._private.rstyle.clean && ele.isBundledBezier();
            })) rstyle.clean = false;
        }
        // only update if dirty and in graph
        if (useCache && rstyle.clean || ele.removed()) continue;
        // only update if not display: none
        if (ele.pstyle('display').value === 'none') continue;
        if (_p.group === 'nodes') nodes.push(ele);
        else // edges
        edges.push(ele);
        rstyle.clean = true;
    }
    // update node data from projections
    for(var _i2 = 0; _i2 < nodes.length; _i2++){
        var _ele = nodes[_i2];
        var _p2 = _ele._private;
        var _rstyle = _p2.rstyle;
        var pos = _ele.position();
        this.recalculateNodeLabelProjection(_ele);
        _rstyle.nodeX = pos.x;
        _rstyle.nodeY = pos.y;
        _rstyle.nodeW = _ele.pstyle('width').pfValue;
        _rstyle.nodeH = _ele.pstyle('height').pfValue;
    }
    this.recalculateEdgeProjections(edges);
    // update edge data from projections
    for(var _i3 = 0; _i3 < edges.length; _i3++){
        var _ele2 = edges[_i3];
        var _p3 = _ele2._private;
        var _rstyle2 = _p3.rstyle;
        var rs = _p3.rscratch;
        // update rstyle positions
        _rstyle2.srcX = rs.arrowStartX;
        _rstyle2.srcY = rs.arrowStartY;
        _rstyle2.tgtX = rs.arrowEndX;
        _rstyle2.tgtY = rs.arrowEndY;
        _rstyle2.midX = rs.midX;
        _rstyle2.midY = rs.midY;
        _rstyle2.labelAngle = rs.labelAngle;
        _rstyle2.sourceLabelAngle = rs.sourceLabelAngle;
        _rstyle2.targetLabelAngle = rs.targetLabelAngle;
    }
};
var $e815fda779bc047b$var$BRp$6 = {};
$e815fda779bc047b$var$BRp$6.updateCachedGrabbedEles = function() {
    var eles = this.cachedZSortedEles;
    if (!eles) // just let this be recalculated on the next z sort tick
    return;
    eles.drag = [];
    eles.nondrag = [];
    var grabTargets = [];
    for(var i = 0; i < eles.length; i++){
        var ele = eles[i];
        var rs = ele._private.rscratch;
        if (ele.grabbed() && !ele.isParent()) grabTargets.push(ele);
        else if (rs.inDragLayer) eles.drag.push(ele);
        else eles.nondrag.push(ele);
    }
    // put the grab target nodes last so it's on top of its neighbourhood
    for(var i = 0; i < grabTargets.length; i++){
        var ele = grabTargets[i];
        eles.drag.push(ele);
    }
};
$e815fda779bc047b$var$BRp$6.invalidateCachedZSortedEles = function() {
    this.cachedZSortedEles = null;
};
$e815fda779bc047b$var$BRp$6.getCachedZSortedEles = function(forceRecalc) {
    if (forceRecalc || !this.cachedZSortedEles) {
        var eles = this.cy.mutableElements().toArray();
        eles.sort($e815fda779bc047b$var$zIndexSort);
        eles.interactive = eles.filter(function(ele) {
            return ele.interactive();
        });
        this.cachedZSortedEles = eles;
        this.updateCachedGrabbedEles();
    } else eles = this.cachedZSortedEles;
    return eles;
};
var $e815fda779bc047b$var$BRp$5 = {};
[
    $e815fda779bc047b$var$BRp$e,
    $e815fda779bc047b$var$BRp$d,
    $e815fda779bc047b$var$BRp$c,
    $e815fda779bc047b$var$BRp$b,
    $e815fda779bc047b$var$BRp$a,
    $e815fda779bc047b$var$BRp$9,
    $e815fda779bc047b$var$BRp$8,
    $e815fda779bc047b$var$BRp$7,
    $e815fda779bc047b$var$BRp$6
].forEach(function(props) {
    $e815fda779bc047b$var$extend($e815fda779bc047b$var$BRp$5, props);
});
var $e815fda779bc047b$var$BRp$4 = {};
$e815fda779bc047b$var$BRp$4.getCachedImage = function(url, crossOrigin, onLoad) {
    var r = this;
    var imageCache = r.imageCache = r.imageCache || {};
    var cache = imageCache[url];
    if (cache) {
        if (!cache.image.complete) cache.image.addEventListener('load', onLoad);
        return cache.image;
    } else {
        cache = imageCache[url] = imageCache[url] || {};
        var image = cache.image = new Image(); // eslint-disable-line no-undef
        image.addEventListener('load', onLoad);
        image.addEventListener('error', function() {
            image.error = true;
        });
        // #1582 safari doesn't load data uris with crossOrigin properly
        // https://bugs.webkit.org/show_bug.cgi?id=123978
        var dataUriPrefix = 'data:';
        var isDataUri = url.substring(0, dataUriPrefix.length).toLowerCase() === dataUriPrefix;
        if (!isDataUri) {
            // if crossorigin is 'null'(stringified), then manually set it to null 
            crossOrigin = crossOrigin === 'null' ? null : crossOrigin;
            image.crossOrigin = crossOrigin; // prevent tainted canvas
        }
        image.src = url;
        return image;
    }
};
var $e815fda779bc047b$var$BRp$3 = {};
/* global document, ResizeObserver, MutationObserver */ $e815fda779bc047b$var$BRp$3.registerBinding = function(target, event, handler, useCapture) {
    // eslint-disable-line no-unused-vars
    var args = Array.prototype.slice.apply(arguments, [
        1
    ]); // copy
    if (Array.isArray(target)) {
        var res = [];
        for(var i = 0; i < target.length; i++){
            var t = target[i];
            if (t !== undefined) {
                var b = this.binder(t);
                res.push(b.on.apply(b, args));
            }
        }
        return res;
    }
    var b = this.binder(target);
    return b.on.apply(b, args);
};
$e815fda779bc047b$var$BRp$3.binder = function(tgt) {
    var r = this;
    var containerWindow = r.cy.window();
    var tgtIsDom = tgt === containerWindow || tgt === containerWindow.document || tgt === containerWindow.document.body || $e815fda779bc047b$var$domElement(tgt);
    if (r.supportsPassiveEvents == null) {
        // from https://github.com/WICG/EventListenerOptions/blob/gh-pages/explainer.md#feature-detection
        var supportsPassive = false;
        try {
            var opts = Object.defineProperty({}, 'passive', {
                get: function get() {
                    supportsPassive = true;
                    return true;
                }
            });
            containerWindow.addEventListener('test', null, opts);
        } catch (err) {
        // not supported
        }
        r.supportsPassiveEvents = supportsPassive;
    }
    var on = function on(event, handler, useCapture) {
        var args = Array.prototype.slice.call(arguments);
        if (tgtIsDom && r.supportsPassiveEvents) // replace useCapture w/ opts obj
        args[2] = {
            capture: useCapture != null ? useCapture : false,
            passive: false,
            once: false
        };
        r.bindings.push({
            target: tgt,
            args: args
        });
        (tgt.addEventListener || tgt.on).apply(tgt, args);
        return this;
    };
    return {
        on: on,
        addEventListener: on,
        addListener: on,
        bind: on
    };
};
$e815fda779bc047b$var$BRp$3.nodeIsDraggable = function(node) {
    return node && node.isNode() && !node.locked() && node.grabbable();
};
$e815fda779bc047b$var$BRp$3.nodeIsGrabbable = function(node) {
    return this.nodeIsDraggable(node) && node.interactive();
};
$e815fda779bc047b$var$BRp$3.load = function() {
    var r = this;
    var containerWindow = r.cy.window();
    var isSelected = function isSelected(ele) {
        return ele.selected();
    };
    var getShadowRoot = function getShadowRoot(element) {
        var rootNode = element.getRootNode();
        // Check if the root node is a shadow root
        if (rootNode && rootNode.nodeType === 11 && rootNode.host !== undefined) return rootNode;
    };
    var triggerEvents = function triggerEvents(target, names, e, position) {
        if (target == null) target = r.cy;
        for(var i = 0; i < names.length; i++){
            var name = names[i];
            target.emit({
                originalEvent: e,
                type: name,
                position: position
            });
        }
    };
    var isMultSelKeyDown = function isMultSelKeyDown(e) {
        return e.shiftKey || e.metaKey || e.ctrlKey; // maybe e.altKey
    };
    var allowPanningPassthrough = function allowPanningPassthrough(down, downs) {
        var allowPassthrough = true;
        if (r.cy.hasCompoundNodes() && down && down.pannable()) // a grabbable compound node below the ele => no passthrough panning
        for(var i = 0; downs && i < downs.length; i++){
            var down = downs[i];
            //if any parent node in event hierarchy isn't pannable, reject passthrough
            if (down.isNode() && down.isParent() && !down.pannable()) {
                allowPassthrough = false;
                break;
            }
        }
        else allowPassthrough = true;
        return allowPassthrough;
    };
    var setGrabbed = function setGrabbed(ele) {
        ele[0]._private.grabbed = true;
    };
    var setFreed = function setFreed(ele) {
        ele[0]._private.grabbed = false;
    };
    var setInDragLayer = function setInDragLayer(ele) {
        ele[0]._private.rscratch.inDragLayer = true;
    };
    var setOutDragLayer = function setOutDragLayer(ele) {
        ele[0]._private.rscratch.inDragLayer = false;
    };
    var setGrabTarget = function setGrabTarget(ele) {
        ele[0]._private.rscratch.isGrabTarget = true;
    };
    var removeGrabTarget = function removeGrabTarget(ele) {
        ele[0]._private.rscratch.isGrabTarget = false;
    };
    var addToDragList = function addToDragList(ele, opts) {
        var list = opts.addToList;
        var listHasEle = list.has(ele);
        if (!listHasEle && ele.grabbable() && !ele.locked()) {
            list.merge(ele);
            setGrabbed(ele);
        }
    };
    // helper function to determine which child nodes and inner edges
    // of a compound node to be dragged as well as the grabbed and selected nodes
    var addDescendantsToDrag = function addDescendantsToDrag(node, opts) {
        if (!node.cy().hasCompoundNodes()) return;
        if (opts.inDragLayer == null && opts.addToList == null) return;
         // nothing to do
        var innerNodes = node.descendants();
        if (opts.inDragLayer) {
            innerNodes.forEach(setInDragLayer);
            innerNodes.connectedEdges().forEach(setInDragLayer);
        }
        if (opts.addToList) addToDragList(innerNodes, opts);
    };
    // adds the given nodes and its neighbourhood to the drag layer
    var addNodesToDrag = function addNodesToDrag(nodes, opts) {
        opts = opts || {};
        var hasCompoundNodes = nodes.cy().hasCompoundNodes();
        if (opts.inDragLayer) {
            nodes.forEach(setInDragLayer);
            nodes.neighborhood().stdFilter(function(ele) {
                return !hasCompoundNodes || ele.isEdge();
            }).forEach(setInDragLayer);
        }
        if (opts.addToList) nodes.forEach(function(ele) {
            addToDragList(ele, opts);
        });
        addDescendantsToDrag(nodes, opts); // always add to drag
        // also add nodes and edges related to the topmost ancestor
        updateAncestorsInDragLayer(nodes, {
            inDragLayer: opts.inDragLayer
        });
        r.updateCachedGrabbedEles();
    };
    var addNodeToDrag = addNodesToDrag;
    var freeDraggedElements = function freeDraggedElements(grabbedEles) {
        if (!grabbedEles) return;
        // just go over all elements rather than doing a bunch of (possibly expensive) traversals
        r.getCachedZSortedEles().forEach(function(ele) {
            setFreed(ele);
            setOutDragLayer(ele);
            removeGrabTarget(ele);
        });
        r.updateCachedGrabbedEles();
    };
    // helper function to determine which ancestor nodes and edges should go
    // to the drag layer (or should be removed from drag layer).
    var updateAncestorsInDragLayer = function updateAncestorsInDragLayer(node, opts) {
        if (opts.inDragLayer == null && opts.addToList == null) return;
         // nothing to do
        if (!node.cy().hasCompoundNodes()) return;
        // find top-level parent
        var parent = node.ancestors().orphans();
        // no parent node: no nodes to add to the drag layer
        if (parent.same(node)) return;
        var nodes = parent.descendants().spawnSelf().merge(parent).unmerge(node).unmerge(node.descendants());
        var edges = nodes.connectedEdges();
        if (opts.inDragLayer) {
            edges.forEach(setInDragLayer);
            nodes.forEach(setInDragLayer);
        }
        if (opts.addToList) nodes.forEach(function(ele) {
            addToDragList(ele, opts);
        });
    };
    var blurActiveDomElement = function blurActiveDomElement() {
        if (document.activeElement != null && document.activeElement.blur != null) document.activeElement.blur();
    };
    var haveMutationsApi = typeof MutationObserver !== 'undefined';
    var haveResizeObserverApi = typeof ResizeObserver !== 'undefined';
    // watch for when the cy container is removed from the dom
    if (haveMutationsApi) {
        r.removeObserver = new MutationObserver(function(mutns) {
            // eslint-disable-line no-undef
            for(var i = 0; i < mutns.length; i++){
                var mutn = mutns[i];
                var rNodes = mutn.removedNodes;
                if (rNodes) for(var j = 0; j < rNodes.length; j++){
                    var rNode = rNodes[j];
                    if (rNode === r.container) {
                        r.destroy();
                        break;
                    }
                }
            }
        });
        if (r.container.parentNode) r.removeObserver.observe(r.container.parentNode, {
            childList: true
        });
    } else r.registerBinding(r.container, 'DOMNodeRemoved', function(e) {
        // eslint-disable-line no-unused-vars
        r.destroy();
    });
    var onResize = $e815fda779bc047b$var$debounce(function() {
        r.cy.resize();
    }, 100);
    if (haveMutationsApi) {
        r.styleObserver = new MutationObserver(onResize); // eslint-disable-line no-undef
        r.styleObserver.observe(r.container, {
            attributes: true
        });
    }
    // auto resize
    r.registerBinding(containerWindow, 'resize', onResize); // eslint-disable-line no-undef
    if (haveResizeObserverApi) {
        r.resizeObserver = new ResizeObserver(onResize); // eslint-disable-line no-undef
        r.resizeObserver.observe(r.container);
    }
    var forEachUp = function forEachUp(domEle, fn) {
        while(domEle != null){
            fn(domEle);
            domEle = domEle.parentNode;
        }
    };
    var invalidateCoords = function invalidateCoords() {
        r.invalidateContainerClientCoordsCache();
    };
    forEachUp(r.container, function(domEle) {
        r.registerBinding(domEle, 'transitionend', invalidateCoords);
        r.registerBinding(domEle, 'animationend', invalidateCoords);
        r.registerBinding(domEle, 'scroll', invalidateCoords);
    });
    // stop right click menu from appearing on cy
    r.registerBinding(r.container, 'contextmenu', function(e) {
        e.preventDefault();
    });
    var inBoxSelection = function inBoxSelection() {
        return r.selection[4] !== 0;
    };
    var eventInContainer = function eventInContainer(e) {
        // save cycles if mouse events aren't to be captured
        var containerPageCoords = r.findContainerClientCoords();
        var x = containerPageCoords[0];
        var y = containerPageCoords[1];
        var width = containerPageCoords[2];
        var height = containerPageCoords[3];
        var positions = e.touches ? e.touches : [
            e
        ];
        var atLeastOnePosInside = false;
        for(var i = 0; i < positions.length; i++){
            var p = positions[i];
            if (x <= p.clientX && p.clientX <= x + width && y <= p.clientY && p.clientY <= y + height) {
                atLeastOnePosInside = true;
                break;
            }
        }
        if (!atLeastOnePosInside) return false;
        var container = r.container;
        var target = e.target;
        var tParent = target.parentNode;
        var containerIsTarget = false;
        while(tParent){
            if (tParent === container) {
                containerIsTarget = true;
                break;
            }
            tParent = tParent.parentNode;
        }
        if (!containerIsTarget) return false;
         // if target is outisde cy container, then this event is not for us
        return true;
    };
    // Primary key
    r.registerBinding(r.container, 'mousedown', function mousedownHandler(e) {
        if (!eventInContainer(e)) return;
        // during left mouse button gestures, ignore other buttons
        if (r.hoverData.which === 1 && e.which !== 1) return;
        e.preventDefault();
        blurActiveDomElement();
        r.hoverData.capture = true;
        r.hoverData.which = e.which;
        var cy = r.cy;
        var gpos = [
            e.clientX,
            e.clientY
        ];
        var pos = r.projectIntoViewport(gpos[0], gpos[1]);
        var select = r.selection;
        var nears = r.findNearestElements(pos[0], pos[1], true, false);
        var near = nears[0];
        var draggedElements = r.dragData.possibleDragElements;
        r.hoverData.mdownPos = pos;
        r.hoverData.mdownGPos = gpos;
        var makeEvent = function makeEvent(type) {
            return {
                originalEvent: e,
                type: type,
                position: {
                    x: pos[0],
                    y: pos[1]
                }
            };
        };
        var checkForTaphold = function checkForTaphold() {
            r.hoverData.tapholdCancelled = false;
            clearTimeout(r.hoverData.tapholdTimeout);
            r.hoverData.tapholdTimeout = setTimeout(function() {
                if (r.hoverData.tapholdCancelled) return;
                else {
                    var ele = r.hoverData.down;
                    if (ele) ele.emit(makeEvent('taphold'));
                    else cy.emit(makeEvent('taphold'));
                }
            }, r.tapholdDuration);
        };
        // Right click button
        if (e.which == 3) {
            r.hoverData.cxtStarted = true;
            var cxtEvt = {
                originalEvent: e,
                type: 'cxttapstart',
                position: {
                    x: pos[0],
                    y: pos[1]
                }
            };
            if (near) {
                near.activate();
                near.emit(cxtEvt);
                r.hoverData.down = near;
            } else cy.emit(cxtEvt);
            r.hoverData.downTime = new Date().getTime();
            r.hoverData.cxtDragged = false;
        // Primary button
        } else if (e.which == 1) {
            if (near) near.activate();
            // If something is under the cursor and it is draggable, prepare to grab it
            if (near != null) {
                if (r.nodeIsGrabbable(near)) {
                    var triggerGrab = function triggerGrab(ele) {
                        ele.emit(makeEvent('grab'));
                    };
                    setGrabTarget(near);
                    if (!near.selected()) {
                        draggedElements = r.dragData.possibleDragElements = cy.collection();
                        addNodeToDrag(near, {
                            addToList: draggedElements
                        });
                        near.emit(makeEvent('grabon')).emit(makeEvent('grab'));
                    } else {
                        draggedElements = r.dragData.possibleDragElements = cy.collection();
                        var selectedNodes = cy.$(function(ele) {
                            return ele.isNode() && ele.selected() && r.nodeIsGrabbable(ele);
                        });
                        addNodesToDrag(selectedNodes, {
                            addToList: draggedElements
                        });
                        near.emit(makeEvent('grabon'));
                        selectedNodes.forEach(triggerGrab);
                    }
                    r.redrawHint('eles', true);
                    r.redrawHint('drag', true);
                }
            }
            r.hoverData.down = near;
            r.hoverData.downs = nears;
            r.hoverData.downTime = new Date().getTime();
            triggerEvents(near, [
                'mousedown',
                'tapstart',
                'vmousedown'
            ], e, {
                x: pos[0],
                y: pos[1]
            });
            if (near == null) {
                select[4] = 1;
                r.data.bgActivePosistion = {
                    x: pos[0],
                    y: pos[1]
                };
                r.redrawHint('select', true);
                r.redraw();
            } else if (near.pannable()) select[4] = 1; // for future pan
            checkForTaphold();
        }
        // Initialize selection box coordinates
        select[0] = select[2] = pos[0];
        select[1] = select[3] = pos[1];
    }, false);
    var shadowRoot = getShadowRoot(r.container);
    r.registerBinding([
        containerWindow,
        shadowRoot
    ], 'mousemove', function mousemoveHandler(e) {
        // eslint-disable-line no-undef
        var capture = r.hoverData.capture;
        if (!capture && !eventInContainer(e)) return;
        var preventDefault = false;
        var cy = r.cy;
        var zoom = cy.zoom();
        var gpos = [
            e.clientX,
            e.clientY
        ];
        var pos = r.projectIntoViewport(gpos[0], gpos[1]);
        var mdownPos = r.hoverData.mdownPos;
        var mdownGPos = r.hoverData.mdownGPos;
        var select = r.selection;
        var near = null;
        if (!r.hoverData.draggingEles && !r.hoverData.dragging && !r.hoverData.selecting) near = r.findNearestElement(pos[0], pos[1], true, false);
        var last = r.hoverData.last;
        var down = r.hoverData.down;
        var disp = [
            pos[0] - select[2],
            pos[1] - select[3]
        ];
        var draggedElements = r.dragData.possibleDragElements;
        var isOverThresholdDrag;
        if (mdownGPos) {
            var dx = gpos[0] - mdownGPos[0];
            var dx2 = dx * dx;
            var dy = gpos[1] - mdownGPos[1];
            var dy2 = dy * dy;
            var dist2 = dx2 + dy2;
            r.hoverData.isOverThresholdDrag = isOverThresholdDrag = dist2 >= r.desktopTapThreshold2;
        }
        var multSelKeyDown = isMultSelKeyDown(e);
        if (isOverThresholdDrag) r.hoverData.tapholdCancelled = true;
        var updateDragDelta = function updateDragDelta() {
            var dragDelta = r.hoverData.dragDelta = r.hoverData.dragDelta || [];
            if (dragDelta.length === 0) {
                dragDelta.push(disp[0]);
                dragDelta.push(disp[1]);
            } else {
                dragDelta[0] += disp[0];
                dragDelta[1] += disp[1];
            }
        };
        preventDefault = true;
        triggerEvents(near, [
            'mousemove',
            'vmousemove',
            'tapdrag'
        ], e, {
            x: pos[0],
            y: pos[1]
        });
        var makeEvent = function makeEvent(type) {
            return {
                originalEvent: e,
                type: type,
                position: {
                    x: pos[0],
                    y: pos[1]
                }
            };
        };
        var goIntoBoxMode = function goIntoBoxMode() {
            r.data.bgActivePosistion = undefined;
            if (!r.hoverData.selecting) cy.emit(makeEvent('boxstart'));
            select[4] = 1;
            r.hoverData.selecting = true;
            r.redrawHint('select', true);
            r.redraw();
        };
        // trigger context drag if rmouse down
        if (r.hoverData.which === 3) // but only if over threshold
        {
            if (isOverThresholdDrag) {
                var cxtEvt = makeEvent('cxtdrag');
                if (down) down.emit(cxtEvt);
                else cy.emit(cxtEvt);
                r.hoverData.cxtDragged = true;
                if (!r.hoverData.cxtOver || near !== r.hoverData.cxtOver) {
                    if (r.hoverData.cxtOver) r.hoverData.cxtOver.emit(makeEvent('cxtdragout'));
                    r.hoverData.cxtOver = near;
                    if (near) near.emit(makeEvent('cxtdragover'));
                }
            }
        } else if (r.hoverData.dragging) {
            preventDefault = true;
            if (cy.panningEnabled() && cy.userPanningEnabled()) {
                var deltaP;
                if (r.hoverData.justStartedPan) {
                    var mdPos = r.hoverData.mdownPos;
                    deltaP = {
                        x: (pos[0] - mdPos[0]) * zoom,
                        y: (pos[1] - mdPos[1]) * zoom
                    };
                    r.hoverData.justStartedPan = false;
                } else deltaP = {
                    x: disp[0] * zoom,
                    y: disp[1] * zoom
                };
                cy.panBy(deltaP);
                cy.emit(makeEvent('dragpan'));
                r.hoverData.dragged = true;
            }
            // Needs reproject due to pan changing viewport
            pos = r.projectIntoViewport(e.clientX, e.clientY);
        // Checks primary button down & out of time & mouse not moved much
        } else if (select[4] == 1 && (down == null || down.pannable())) {
            if (isOverThresholdDrag) {
                if (!r.hoverData.dragging && cy.boxSelectionEnabled() && (multSelKeyDown || !cy.panningEnabled() || !cy.userPanningEnabled())) goIntoBoxMode();
                else if (!r.hoverData.selecting && cy.panningEnabled() && cy.userPanningEnabled()) {
                    var allowPassthrough = allowPanningPassthrough(down, r.hoverData.downs);
                    if (allowPassthrough) {
                        r.hoverData.dragging = true;
                        r.hoverData.justStartedPan = true;
                        select[4] = 0;
                        r.data.bgActivePosistion = $e815fda779bc047b$var$array2point(mdownPos);
                        r.redrawHint('select', true);
                        r.redraw();
                    }
                }
                if (down && down.pannable() && down.active()) down.unactivate();
            }
        } else {
            if (down && down.pannable() && down.active()) down.unactivate();
            if ((!down || !down.grabbed()) && near != last) {
                if (last) triggerEvents(last, [
                    'mouseout',
                    'tapdragout'
                ], e, {
                    x: pos[0],
                    y: pos[1]
                });
                if (near) triggerEvents(near, [
                    'mouseover',
                    'tapdragover'
                ], e, {
                    x: pos[0],
                    y: pos[1]
                });
                r.hoverData.last = near;
            }
            if (down) {
                if (isOverThresholdDrag) {
                    // then we can take action
                    if (cy.boxSelectionEnabled() && multSelKeyDown) {
                        // then selection overrides
                        if (down && down.grabbed()) {
                            freeDraggedElements(draggedElements);
                            down.emit(makeEvent('freeon'));
                            draggedElements.emit(makeEvent('free'));
                            if (r.dragData.didDrag) {
                                down.emit(makeEvent('dragfreeon'));
                                draggedElements.emit(makeEvent('dragfree'));
                            }
                        }
                        goIntoBoxMode();
                    } else if (down && down.grabbed() && r.nodeIsDraggable(down)) {
                        // drag node
                        var justStartedDrag = !r.dragData.didDrag;
                        if (justStartedDrag) r.redrawHint('eles', true);
                        r.dragData.didDrag = true; // indicate that we actually did drag the node
                        // now, add the elements to the drag layer if not done already
                        if (!r.hoverData.draggingEles) addNodesToDrag(draggedElements, {
                            inDragLayer: true
                        });
                        var totalShift = {
                            x: 0,
                            y: 0
                        };
                        if ($e815fda779bc047b$var$number$1(disp[0]) && $e815fda779bc047b$var$number$1(disp[1])) {
                            totalShift.x += disp[0];
                            totalShift.y += disp[1];
                            if (justStartedDrag) {
                                var dragDelta = r.hoverData.dragDelta;
                                if (dragDelta && $e815fda779bc047b$var$number$1(dragDelta[0]) && $e815fda779bc047b$var$number$1(dragDelta[1])) {
                                    totalShift.x += dragDelta[0];
                                    totalShift.y += dragDelta[1];
                                }
                            }
                        }
                        r.hoverData.draggingEles = true;
                        draggedElements.silentShift(totalShift).emit(makeEvent('position')).emit(makeEvent('drag'));
                        r.redrawHint('drag', true);
                        r.redraw();
                    }
                } else // otherwise save drag delta for when we actually start dragging so the relative grab pos is constant
                updateDragDelta();
            }
            // prevent the dragging from triggering text selection on the page
            preventDefault = true;
        }
        select[2] = pos[0];
        select[3] = pos[1];
        if (preventDefault) {
            if (e.stopPropagation) e.stopPropagation();
            if (e.preventDefault) e.preventDefault();
            return false;
        }
    }, false);
    var clickTimeout, didDoubleClick, prevClickTimeStamp;
    r.registerBinding(containerWindow, 'mouseup', function mouseupHandler(e) {
        // eslint-disable-line no-undef
        // during left mouse button gestures, ignore other buttons
        if (r.hoverData.which === 1 && e.which !== 1 && r.hoverData.capture) return;
        var capture = r.hoverData.capture;
        if (!capture) return;
        r.hoverData.capture = false;
        var cy = r.cy;
        var pos = r.projectIntoViewport(e.clientX, e.clientY);
        var select = r.selection;
        var near = r.findNearestElement(pos[0], pos[1], true, false);
        var draggedElements = r.dragData.possibleDragElements;
        var down = r.hoverData.down;
        var multSelKeyDown = isMultSelKeyDown(e);
        if (r.data.bgActivePosistion) {
            r.redrawHint('select', true);
            r.redraw();
        }
        r.hoverData.tapholdCancelled = true;
        r.data.bgActivePosistion = undefined; // not active bg now
        if (down) down.unactivate();
        var makeEvent = function makeEvent(type) {
            return {
                originalEvent: e,
                type: type,
                position: {
                    x: pos[0],
                    y: pos[1]
                }
            };
        };
        if (r.hoverData.which === 3) {
            var cxtEvt = makeEvent('cxttapend');
            if (down) down.emit(cxtEvt);
            else cy.emit(cxtEvt);
            if (!r.hoverData.cxtDragged) {
                var cxtTap = makeEvent('cxttap');
                if (down) down.emit(cxtTap);
                else cy.emit(cxtTap);
            }
            r.hoverData.cxtDragged = false;
            r.hoverData.which = null;
        } else if (r.hoverData.which === 1) {
            triggerEvents(near, [
                'mouseup',
                'tapend',
                'vmouseup'
            ], e, {
                x: pos[0],
                y: pos[1]
            });
            if (!r.dragData.didDrag && // didn't move a node around
            !r.hoverData.dragged && // didn't pan
            !r.hoverData.selecting && // not box selection
            !r.hoverData.isOverThresholdDrag // didn't move too much
            ) {
                triggerEvents(down, [
                    "click",
                    "tap",
                    "vclick"
                ], e, {
                    x: pos[0],
                    y: pos[1]
                });
                didDoubleClick = false;
                if (e.timeStamp - prevClickTimeStamp <= cy.multiClickDebounceTime()) {
                    clickTimeout && clearTimeout(clickTimeout);
                    didDoubleClick = true;
                    prevClickTimeStamp = null;
                    triggerEvents(down, [
                        "dblclick",
                        "dbltap",
                        "vdblclick"
                    ], e, {
                        x: pos[0],
                        y: pos[1]
                    });
                } else {
                    clickTimeout = setTimeout(function() {
                        if (didDoubleClick) return;
                        triggerEvents(down, [
                            "oneclick",
                            "onetap",
                            "voneclick"
                        ], e, {
                            x: pos[0],
                            y: pos[1]
                        });
                    }, cy.multiClickDebounceTime());
                    prevClickTimeStamp = e.timeStamp;
                }
            }
            // Deselect all elements if nothing is currently under the mouse cursor and we aren't dragging something
            if (down == null // not mousedown on node
             && !r.dragData.didDrag // didn't move the node around
             && !r.hoverData.selecting // not box selection
             && !r.hoverData.dragged // didn't pan
             && !isMultSelKeyDown(e)) {
                cy.$(isSelected).unselect([
                    'tapunselect'
                ]);
                if (draggedElements.length > 0) r.redrawHint('eles', true);
                r.dragData.possibleDragElements = draggedElements = cy.collection();
            }
            // Single selection
            if (near == down && !r.dragData.didDrag && !r.hoverData.selecting) {
                if (near != null && near._private.selectable) {
                    if (r.hoverData.dragging) ;
                    else if (cy.selectionType() === 'additive' || multSelKeyDown) {
                        if (near.selected()) near.unselect([
                            'tapunselect'
                        ]);
                        else near.select([
                            'tapselect'
                        ]);
                    } else if (!multSelKeyDown) {
                        cy.$(isSelected).unmerge(near).unselect([
                            'tapunselect'
                        ]);
                        near.select([
                            'tapselect'
                        ]);
                    }
                    r.redrawHint('eles', true);
                }
            }
            if (r.hoverData.selecting) {
                var box = cy.collection(r.getAllInBox(select[0], select[1], select[2], select[3]));
                r.redrawHint('select', true);
                if (box.length > 0) r.redrawHint('eles', true);
                cy.emit(makeEvent('boxend'));
                var eleWouldBeSelected = function eleWouldBeSelected(ele) {
                    return ele.selectable() && !ele.selected();
                };
                if (cy.selectionType() === 'additive') box.emit(makeEvent('box')).stdFilter(eleWouldBeSelected).select().emit(makeEvent('boxselect'));
                else {
                    if (!multSelKeyDown) cy.$(isSelected).unmerge(box).unselect();
                    box.emit(makeEvent('box')).stdFilter(eleWouldBeSelected).select().emit(makeEvent('boxselect'));
                }
                // always need redraw in case eles unselectable
                r.redraw();
            }
            // Cancel drag pan
            if (r.hoverData.dragging) {
                r.hoverData.dragging = false;
                r.redrawHint('select', true);
                r.redrawHint('eles', true);
                r.redraw();
            }
            if (!select[4]) {
                r.redrawHint('drag', true);
                r.redrawHint('eles', true);
                var downWasGrabbed = down && down.grabbed();
                freeDraggedElements(draggedElements);
                if (downWasGrabbed) {
                    down.emit(makeEvent('freeon'));
                    draggedElements.emit(makeEvent('free'));
                    if (r.dragData.didDrag) {
                        down.emit(makeEvent('dragfreeon'));
                        draggedElements.emit(makeEvent('dragfree'));
                    }
                }
            }
        } // else not right mouse
        select[4] = 0;
        r.hoverData.down = null;
        r.hoverData.cxtStarted = false;
        r.hoverData.draggingEles = false;
        r.hoverData.selecting = false;
        r.hoverData.isOverThresholdDrag = false;
        r.dragData.didDrag = false;
        r.hoverData.dragged = false;
        r.hoverData.dragDelta = [];
        r.hoverData.mdownPos = null;
        r.hoverData.mdownGPos = null;
        r.hoverData.which = null;
    }, false);
    var wheelDeltas = []; // log of first N wheel deltas
    var wheelDeltaN = 4; // how many events to log
    var inaccurateScrollDevice;
    var inaccurateScrollFactor = 100000; // base of inaccurate wheel deltas (e.g. base 5 could yield wheels of 10, 25, 50, etc.)
    var allAreDivisibleBy = function allAreDivisibleBy(list, factor) {
        for(var i = 0; i < list.length; i++){
            if (list[i] % factor !== 0) return false;
        }
        return true;
    };
    var allAreSameMagnitude = function allAreSameMagnitude(list) {
        var firstMag = Math.abs(list[0]);
        for(var i = 1; i < list.length; i++){
            if (Math.abs(list[i]) !== firstMag) return false;
        }
        return true;
    };
    var wheelHandler = function wheelHandler(e) {
        var clamp = false;
        var delta = e.deltaY;
        if (delta == null) {
            // compatibility with old browsers
            if (e.wheelDeltaY != null) delta = e.wheelDeltaY / 4;
            else if (e.wheelDelta != null) delta = e.wheelDelta / 4;
        }
        if (delta === 0) return; // no change in zoom (Bug: Zoom becomes erratic on rapid scroll due to deltaY: 0 event #3394)
        if (inaccurateScrollDevice == null) {
            if (wheelDeltas.length >= wheelDeltaN) {
                // use log to determine if inaccurate
                var wds = wheelDeltas;
                inaccurateScrollDevice = allAreDivisibleBy(wds, 5);
                if (!inaccurateScrollDevice) {
                    // check for all large values of exact same magnitude
                    var firstMag = Math.abs(wds[0]);
                    inaccurateScrollDevice = allAreSameMagnitude(wds) && firstMag > 5;
                }
                if (inaccurateScrollDevice) for(var i = 0; i < wds.length; i++)inaccurateScrollFactor = Math.min(Math.abs(wds[i]), inaccurateScrollFactor);
            // console.log('Sampled wheel deltas:', wds);
            // console.log('inaccurateScrollDevice:', inaccurateScrollDevice);
            // console.log('inaccurateScrollFactor:', inaccurateScrollFactor);
            } else {
                // clamp and log until we reach N
                wheelDeltas.push(delta);
                clamp = true;
            // console.log('Clamping initial wheel events until we get a good sample');
            }
        } else if (inaccurateScrollDevice) // keep updating
        inaccurateScrollFactor = Math.min(Math.abs(delta), inaccurateScrollFactor);
        if (r.scrollingPage) return;
         // while scrolling, ignore wheel-to-zoom
        var cy = r.cy;
        var zoom = cy.zoom();
        var pan = cy.pan();
        var pos = r.projectIntoViewport(e.clientX, e.clientY);
        var rpos = [
            pos[0] * zoom + pan.x,
            pos[1] * zoom + pan.y
        ];
        if (r.hoverData.draggingEles || r.hoverData.dragging || r.hoverData.cxtStarted || inBoxSelection()) {
            // if pan dragging or cxt dragging, wheel movements make no zoom
            e.preventDefault();
            return;
        }
        if (cy.panningEnabled() && cy.userPanningEnabled() && cy.zoomingEnabled() && cy.userZoomingEnabled()) {
            e.preventDefault();
            r.data.wheelZooming = true;
            clearTimeout(r.data.wheelTimeout);
            r.data.wheelTimeout = setTimeout(function() {
                r.data.wheelZooming = false;
                r.redrawHint('eles', true);
                r.redraw();
            }, 150);
            var diff;
            if (clamp && Math.abs(delta) > 5) delta = $e815fda779bc047b$var$signum(delta) * 5;
            diff = delta / -250;
            if (inaccurateScrollDevice) {
                diff /= inaccurateScrollFactor;
                diff *= 3;
            }
            diff = diff * r.wheelSensitivity;
            // console.log(`delta = ${delta}, diff = ${diff}, mode = ${e.deltaMode}`)
            var needsWheelFix = e.deltaMode === 1;
            if (needsWheelFix) // fixes slow wheel events on ff/linux and ff/windows
            diff *= 33;
            var newZoom = cy.zoom() * Math.pow(10, diff);
            if (e.type === 'gesturechange') newZoom = r.gestureStartZoom * e.scale;
            cy.zoom({
                level: newZoom,
                renderedPosition: {
                    x: rpos[0],
                    y: rpos[1]
                }
            });
            cy.emit({
                type: e.type === 'gesturechange' ? 'pinchzoom' : 'scrollzoom',
                originalEvent: e,
                position: {
                    x: pos[0],
                    y: pos[1]
                }
            });
        }
    };
    // Functions to help with whether mouse wheel should trigger zooming
    // --
    r.registerBinding(r.container, 'wheel', wheelHandler, true);
    // disable nonstandard wheel events
    // r.registerBinding(r.container, 'mousewheel', wheelHandler, true);
    // r.registerBinding(r.container, 'DOMMouseScroll', wheelHandler, true);
    // r.registerBinding(r.container, 'MozMousePixelScroll', wheelHandler, true); // older firefox
    r.registerBinding(containerWindow, 'scroll', function scrollHandler(e) {
        // eslint-disable-line no-unused-vars
        r.scrollingPage = true;
        clearTimeout(r.scrollingPageTimeout);
        r.scrollingPageTimeout = setTimeout(function() {
            r.scrollingPage = false;
        }, 250);
    }, true);
    // desktop safari pinch to zoom start
    r.registerBinding(r.container, 'gesturestart', function gestureStartHandler(e) {
        r.gestureStartZoom = r.cy.zoom();
        if (!r.hasTouchStarted) // don't affect touch devices like iphone
        e.preventDefault();
    }, true);
    r.registerBinding(r.container, 'gesturechange', function(e) {
        if (!r.hasTouchStarted) // don't affect touch devices like iphone
        wheelHandler(e);
    }, true);
    // Functions to help with handling mouseout/mouseover on the Cytoscape container
    // Handle mouseout on Cytoscape container
    r.registerBinding(r.container, 'mouseout', function mouseOutHandler(e) {
        var pos = r.projectIntoViewport(e.clientX, e.clientY);
        r.cy.emit({
            originalEvent: e,
            type: 'mouseout',
            position: {
                x: pos[0],
                y: pos[1]
            }
        });
    }, false);
    r.registerBinding(r.container, 'mouseover', function mouseOverHandler(e) {
        var pos = r.projectIntoViewport(e.clientX, e.clientY);
        r.cy.emit({
            originalEvent: e,
            type: 'mouseover',
            position: {
                x: pos[0],
                y: pos[1]
            }
        });
    }, false);
    var f1x1, f1y1, f2x1, f2y1; // starting points for pinch-to-zoom
    var distance1, distance1Sq; // initial distance between finger 1 and finger 2 for pinch-to-zoom
    var center1, modelCenter1; // center point on start pinch to zoom
    var offsetLeft, offsetTop;
    var containerWidth, containerHeight;
    var twoFingersStartInside;
    var distance = function distance(x1, y1, x2, y2) {
        return Math.sqrt((x2 - x1) * (x2 - x1) + (y2 - y1) * (y2 - y1));
    };
    var distanceSq = function distanceSq(x1, y1, x2, y2) {
        return (x2 - x1) * (x2 - x1) + (y2 - y1) * (y2 - y1);
    };
    var touchstartHandler;
    r.registerBinding(r.container, 'touchstart', touchstartHandler = function touchstartHandler(e) {
        r.hasTouchStarted = true;
        if (!eventInContainer(e)) return;
        blurActiveDomElement();
        r.touchData.capture = true;
        r.data.bgActivePosistion = undefined;
        var cy = r.cy;
        var now = r.touchData.now;
        var earlier = r.touchData.earlier;
        if (e.touches[0]) {
            var pos = r.projectIntoViewport(e.touches[0].clientX, e.touches[0].clientY);
            now[0] = pos[0];
            now[1] = pos[1];
        }
        if (e.touches[1]) {
            var pos = r.projectIntoViewport(e.touches[1].clientX, e.touches[1].clientY);
            now[2] = pos[0];
            now[3] = pos[1];
        }
        if (e.touches[2]) {
            var pos = r.projectIntoViewport(e.touches[2].clientX, e.touches[2].clientY);
            now[4] = pos[0];
            now[5] = pos[1];
        }
        var makeEvent = function makeEvent(type) {
            return {
                originalEvent: e,
                type: type,
                position: {
                    x: now[0],
                    y: now[1]
                }
            };
        };
        // record starting points for pinch-to-zoom
        if (e.touches[1]) {
            r.touchData.singleTouchMoved = true;
            freeDraggedElements(r.dragData.touchDragEles);
            var offsets = r.findContainerClientCoords();
            offsetLeft = offsets[0];
            offsetTop = offsets[1];
            containerWidth = offsets[2];
            containerHeight = offsets[3];
            f1x1 = e.touches[0].clientX - offsetLeft;
            f1y1 = e.touches[0].clientY - offsetTop;
            f2x1 = e.touches[1].clientX - offsetLeft;
            f2y1 = e.touches[1].clientY - offsetTop;
            twoFingersStartInside = 0 <= f1x1 && f1x1 <= containerWidth && 0 <= f2x1 && f2x1 <= containerWidth && 0 <= f1y1 && f1y1 <= containerHeight && 0 <= f2y1 && f2y1 <= containerHeight;
            var pan = cy.pan();
            var zoom = cy.zoom();
            distance1 = distance(f1x1, f1y1, f2x1, f2y1);
            distance1Sq = distanceSq(f1x1, f1y1, f2x1, f2y1);
            center1 = [
                (f1x1 + f2x1) / 2,
                (f1y1 + f2y1) / 2
            ];
            modelCenter1 = [
                (center1[0] - pan.x) / zoom,
                (center1[1] - pan.y) / zoom
            ];
            // consider context tap
            var cxtDistThreshold = 200;
            var cxtDistThresholdSq = cxtDistThreshold * cxtDistThreshold;
            if (distance1Sq < cxtDistThresholdSq && !e.touches[2]) {
                var near1 = r.findNearestElement(now[0], now[1], true, true);
                var near2 = r.findNearestElement(now[2], now[3], true, true);
                if (near1 && near1.isNode()) {
                    near1.activate().emit(makeEvent('cxttapstart'));
                    r.touchData.start = near1;
                } else if (near2 && near2.isNode()) {
                    near2.activate().emit(makeEvent('cxttapstart'));
                    r.touchData.start = near2;
                } else cy.emit(makeEvent('cxttapstart'));
                if (r.touchData.start) r.touchData.start._private.grabbed = false;
                r.touchData.cxt = true;
                r.touchData.cxtDragged = false;
                r.data.bgActivePosistion = undefined;
                r.redraw();
                return;
            }
        }
        if (e.touches[2]) // ignore
        // safari on ios pans the page otherwise (normally you should be able to preventdefault on touchmove...)
        {
            if (cy.boxSelectionEnabled()) e.preventDefault();
        } else if (e.touches[1]) ;
        else if (e.touches[0]) {
            var nears = r.findNearestElements(now[0], now[1], true, true);
            var near = nears[0];
            if (near != null) {
                near.activate();
                r.touchData.start = near;
                r.touchData.starts = nears;
                if (r.nodeIsGrabbable(near)) {
                    var draggedEles = r.dragData.touchDragEles = cy.collection();
                    var selectedNodes = null;
                    r.redrawHint('eles', true);
                    r.redrawHint('drag', true);
                    if (near.selected()) {
                        // reset drag elements, since near will be added again
                        selectedNodes = cy.$(function(ele) {
                            return ele.selected() && r.nodeIsGrabbable(ele);
                        });
                        addNodesToDrag(selectedNodes, {
                            addToList: draggedEles
                        });
                    } else addNodeToDrag(near, {
                        addToList: draggedEles
                    });
                    setGrabTarget(near);
                    near.emit(makeEvent('grabon'));
                    if (selectedNodes) selectedNodes.forEach(function(n) {
                        n.emit(makeEvent('grab'));
                    });
                    else near.emit(makeEvent('grab'));
                }
            }
            triggerEvents(near, [
                'touchstart',
                'tapstart',
                'vmousedown'
            ], e, {
                x: now[0],
                y: now[1]
            });
            if (near == null) {
                r.data.bgActivePosistion = {
                    x: pos[0],
                    y: pos[1]
                };
                r.redrawHint('select', true);
                r.redraw();
            }
            // Tap, taphold
            // -----
            r.touchData.singleTouchMoved = false;
            r.touchData.singleTouchStartTime = +new Date();
            clearTimeout(r.touchData.tapholdTimeout);
            r.touchData.tapholdTimeout = setTimeout(function() {
                if (r.touchData.singleTouchMoved === false && !r.pinching // if pinching, then taphold unselect shouldn't take effect
                 && !r.touchData.selecting // box selection shouldn't allow taphold through
                ) triggerEvents(r.touchData.start, [
                    'taphold'
                ], e, {
                    x: now[0],
                    y: now[1]
                });
            }, r.tapholdDuration);
        }
        if (e.touches.length >= 1) {
            var sPos = r.touchData.startPosition = [
                null,
                null,
                null,
                null,
                null,
                null
            ];
            for(var i = 0; i < now.length; i++)sPos[i] = earlier[i] = now[i];
            var touch0 = e.touches[0];
            r.touchData.startGPosition = [
                touch0.clientX,
                touch0.clientY
            ];
        }
    }, false);
    var touchmoveHandler;
    r.registerBinding(containerWindow, 'touchmove', touchmoveHandler = function touchmoveHandler(e) {
        // eslint-disable-line no-undef
        var capture = r.touchData.capture;
        if (!capture && !eventInContainer(e)) return;
        var select = r.selection;
        var cy = r.cy;
        var now = r.touchData.now;
        var earlier = r.touchData.earlier;
        var zoom = cy.zoom();
        if (e.touches[0]) {
            var pos = r.projectIntoViewport(e.touches[0].clientX, e.touches[0].clientY);
            now[0] = pos[0];
            now[1] = pos[1];
        }
        if (e.touches[1]) {
            var pos = r.projectIntoViewport(e.touches[1].clientX, e.touches[1].clientY);
            now[2] = pos[0];
            now[3] = pos[1];
        }
        if (e.touches[2]) {
            var pos = r.projectIntoViewport(e.touches[2].clientX, e.touches[2].clientY);
            now[4] = pos[0];
            now[5] = pos[1];
        }
        var makeEvent = function makeEvent(type) {
            return {
                originalEvent: e,
                type: type,
                position: {
                    x: now[0],
                    y: now[1]
                }
            };
        };
        var startGPos = r.touchData.startGPosition;
        var isOverThresholdDrag;
        if (capture && e.touches[0] && startGPos) {
            var disp = [];
            for(var j = 0; j < now.length; j++)disp[j] = now[j] - earlier[j];
            var dx = e.touches[0].clientX - startGPos[0];
            var dx2 = dx * dx;
            var dy = e.touches[0].clientY - startGPos[1];
            var dy2 = dy * dy;
            var dist2 = dx2 + dy2;
            isOverThresholdDrag = dist2 >= r.touchTapThreshold2;
        }
        // context swipe cancelling
        if (capture && r.touchData.cxt) {
            e.preventDefault();
            var f1x2 = e.touches[0].clientX - offsetLeft, f1y2 = e.touches[0].clientY - offsetTop;
            var f2x2 = e.touches[1].clientX - offsetLeft, f2y2 = e.touches[1].clientY - offsetTop;
            // var distance2 = distance( f1x2, f1y2, f2x2, f2y2 );
            var distance2Sq = distanceSq(f1x2, f1y2, f2x2, f2y2);
            var factorSq = distance2Sq / distance1Sq;
            var distThreshold = 150;
            var distThresholdSq = distThreshold * distThreshold;
            var factorThreshold = 1.5;
            var factorThresholdSq = factorThreshold * factorThreshold;
            // cancel ctx gestures if the distance b/t the fingers increases
            if (factorSq >= factorThresholdSq || distance2Sq >= distThresholdSq) {
                r.touchData.cxt = false;
                r.data.bgActivePosistion = undefined;
                r.redrawHint('select', true);
                var cxtEvt = makeEvent('cxttapend');
                if (r.touchData.start) {
                    r.touchData.start.unactivate().emit(cxtEvt);
                    r.touchData.start = null;
                } else cy.emit(cxtEvt);
            }
        }
        // context swipe
        if (capture && r.touchData.cxt) {
            var cxtEvt = makeEvent('cxtdrag');
            r.data.bgActivePosistion = undefined;
            r.redrawHint('select', true);
            if (r.touchData.start) r.touchData.start.emit(cxtEvt);
            else cy.emit(cxtEvt);
            if (r.touchData.start) r.touchData.start._private.grabbed = false;
            r.touchData.cxtDragged = true;
            var near = r.findNearestElement(now[0], now[1], true, true);
            if (!r.touchData.cxtOver || near !== r.touchData.cxtOver) {
                if (r.touchData.cxtOver) r.touchData.cxtOver.emit(makeEvent('cxtdragout'));
                r.touchData.cxtOver = near;
                if (near) near.emit(makeEvent('cxtdragover'));
            }
        // box selection
        } else if (capture && e.touches[2] && cy.boxSelectionEnabled()) {
            e.preventDefault();
            r.data.bgActivePosistion = undefined;
            this.lastThreeTouch = +new Date();
            if (!r.touchData.selecting) cy.emit(makeEvent('boxstart'));
            r.touchData.selecting = true;
            r.touchData.didSelect = true;
            select[4] = 1;
            if (!select || select.length === 0 || select[0] === undefined) {
                select[0] = (now[0] + now[2] + now[4]) / 3;
                select[1] = (now[1] + now[3] + now[5]) / 3;
                select[2] = (now[0] + now[2] + now[4]) / 3 + 1;
                select[3] = (now[1] + now[3] + now[5]) / 3 + 1;
            } else {
                select[2] = (now[0] + now[2] + now[4]) / 3;
                select[3] = (now[1] + now[3] + now[5]) / 3;
            }
            r.redrawHint('select', true);
            r.redraw();
        // pinch to zoom
        } else if (capture && e.touches[1] && !r.touchData.didSelect // don't allow box selection to degrade to pinch-to-zoom
         && cy.zoomingEnabled() && cy.panningEnabled() && cy.userZoomingEnabled() && cy.userPanningEnabled()) {
            // two fingers => pinch to zoom
            e.preventDefault();
            r.data.bgActivePosistion = undefined;
            r.redrawHint('select', true);
            var draggedEles = r.dragData.touchDragEles;
            if (draggedEles) {
                r.redrawHint('drag', true);
                for(var i = 0; i < draggedEles.length; i++){
                    var de_p = draggedEles[i]._private;
                    de_p.grabbed = false;
                    de_p.rscratch.inDragLayer = false;
                }
            }
            var _start = r.touchData.start;
            // (x2, y2) for fingers 1 and 2
            var f1x2 = e.touches[0].clientX - offsetLeft, f1y2 = e.touches[0].clientY - offsetTop;
            var f2x2 = e.touches[1].clientX - offsetLeft, f2y2 = e.touches[1].clientY - offsetTop;
            var distance2 = distance(f1x2, f1y2, f2x2, f2y2);
            // var distance2Sq = distanceSq( f1x2, f1y2, f2x2, f2y2 );
            // var factor = Math.sqrt( distance2Sq ) / Math.sqrt( distance1Sq );
            var factor = distance2 / distance1;
            if (twoFingersStartInside) {
                // delta finger1
                var df1x = f1x2 - f1x1;
                var df1y = f1y2 - f1y1;
                // delta finger 2
                var df2x = f2x2 - f2x1;
                var df2y = f2y2 - f2y1;
                // translation is the normalised vector of the two fingers movement
                // i.e. so pinching cancels out and moving together pans
                var tx = (df1x + df2x) / 2;
                var ty = (df1y + df2y) / 2;
                // now calculate the zoom
                var zoom1 = cy.zoom();
                var zoom2 = zoom1 * factor;
                var pan1 = cy.pan();
                // the model center point converted to the current rendered pos
                var ctrx = modelCenter1[0] * zoom1 + pan1.x;
                var ctry = modelCenter1[1] * zoom1 + pan1.y;
                var pan2 = {
                    x: -zoom2 / zoom1 * (ctrx - pan1.x - tx) + ctrx,
                    y: -zoom2 / zoom1 * (ctry - pan1.y - ty) + ctry
                };
                // remove dragged eles
                if (_start && _start.active()) {
                    var draggedEles = r.dragData.touchDragEles;
                    freeDraggedElements(draggedEles);
                    r.redrawHint('drag', true);
                    r.redrawHint('eles', true);
                    _start.unactivate().emit(makeEvent('freeon'));
                    draggedEles.emit(makeEvent('free'));
                    if (r.dragData.didDrag) {
                        _start.emit(makeEvent('dragfreeon'));
                        draggedEles.emit(makeEvent('dragfree'));
                    }
                }
                cy.viewport({
                    zoom: zoom2,
                    pan: pan2,
                    cancelOnFailedZoom: true
                });
                cy.emit(makeEvent('pinchzoom'));
                distance1 = distance2;
                f1x1 = f1x2;
                f1y1 = f1y2;
                f2x1 = f2x2;
                f2y1 = f2y2;
                r.pinching = true;
            }
            // Re-project
            if (e.touches[0]) {
                var pos = r.projectIntoViewport(e.touches[0].clientX, e.touches[0].clientY);
                now[0] = pos[0];
                now[1] = pos[1];
            }
            if (e.touches[1]) {
                var pos = r.projectIntoViewport(e.touches[1].clientX, e.touches[1].clientY);
                now[2] = pos[0];
                now[3] = pos[1];
            }
            if (e.touches[2]) {
                var pos = r.projectIntoViewport(e.touches[2].clientX, e.touches[2].clientY);
                now[4] = pos[0];
                now[5] = pos[1];
            }
        } else if (e.touches[0] && !r.touchData.didSelect // don't allow box selection to degrade to single finger events like panning
        ) {
            var start = r.touchData.start;
            var last = r.touchData.last;
            var near;
            if (!r.hoverData.draggingEles && !r.swipePanning) near = r.findNearestElement(now[0], now[1], true, true);
            if (capture && start != null) e.preventDefault();
            // dragging nodes
            if (capture && start != null && r.nodeIsDraggable(start)) {
                if (isOverThresholdDrag) {
                    // then dragging can happen
                    var draggedEles = r.dragData.touchDragEles;
                    var justStartedDrag = !r.dragData.didDrag;
                    if (justStartedDrag) addNodesToDrag(draggedEles, {
                        inDragLayer: true
                    });
                    r.dragData.didDrag = true;
                    var totalShift = {
                        x: 0,
                        y: 0
                    };
                    if ($e815fda779bc047b$var$number$1(disp[0]) && $e815fda779bc047b$var$number$1(disp[1])) {
                        totalShift.x += disp[0];
                        totalShift.y += disp[1];
                        if (justStartedDrag) {
                            r.redrawHint('eles', true);
                            var dragDelta = r.touchData.dragDelta;
                            if (dragDelta && $e815fda779bc047b$var$number$1(dragDelta[0]) && $e815fda779bc047b$var$number$1(dragDelta[1])) {
                                totalShift.x += dragDelta[0];
                                totalShift.y += dragDelta[1];
                            }
                        }
                    }
                    r.hoverData.draggingEles = true;
                    draggedEles.silentShift(totalShift).emit(makeEvent('position')).emit(makeEvent('drag'));
                    r.redrawHint('drag', true);
                    if (r.touchData.startPosition[0] == earlier[0] && r.touchData.startPosition[1] == earlier[1]) r.redrawHint('eles', true);
                    r.redraw();
                } else {
                    // otherwise keep track of drag delta for later
                    var dragDelta = r.touchData.dragDelta = r.touchData.dragDelta || [];
                    if (dragDelta.length === 0) {
                        dragDelta.push(disp[0]);
                        dragDelta.push(disp[1]);
                    } else {
                        dragDelta[0] += disp[0];
                        dragDelta[1] += disp[1];
                    }
                }
            }
            triggerEvents(start || near, [
                'touchmove',
                'tapdrag',
                'vmousemove'
            ], e, {
                x: now[0],
                y: now[1]
            });
            if ((!start || !start.grabbed()) && near != last) {
                if (last) last.emit(makeEvent('tapdragout'));
                if (near) near.emit(makeEvent('tapdragover'));
            }
            r.touchData.last = near;
            // check to cancel taphold
            if (capture) {
                for(var i = 0; i < now.length; i++)if (now[i] && r.touchData.startPosition[i] && isOverThresholdDrag) r.touchData.singleTouchMoved = true;
            }
            // panning
            if (capture && (start == null || start.pannable()) && cy.panningEnabled() && cy.userPanningEnabled()) {
                var allowPassthrough = allowPanningPassthrough(start, r.touchData.starts);
                if (allowPassthrough) {
                    e.preventDefault();
                    if (!r.data.bgActivePosistion) r.data.bgActivePosistion = $e815fda779bc047b$var$array2point(r.touchData.startPosition);
                    if (r.swipePanning) {
                        cy.panBy({
                            x: disp[0] * zoom,
                            y: disp[1] * zoom
                        });
                        cy.emit(makeEvent('dragpan'));
                    } else if (isOverThresholdDrag) {
                        r.swipePanning = true;
                        cy.panBy({
                            x: dx * zoom,
                            y: dy * zoom
                        });
                        cy.emit(makeEvent('dragpan'));
                        if (start) {
                            start.unactivate();
                            r.redrawHint('select', true);
                            r.touchData.start = null;
                        }
                    }
                }
                // Re-project
                var pos = r.projectIntoViewport(e.touches[0].clientX, e.touches[0].clientY);
                now[0] = pos[0];
                now[1] = pos[1];
            }
        }
        for(var j = 0; j < now.length; j++)earlier[j] = now[j];
        // the active bg indicator should be removed when making a swipe that is neither for dragging nodes or panning
        if (capture && e.touches.length > 0 && !r.hoverData.draggingEles && !r.swipePanning && r.data.bgActivePosistion != null) {
            r.data.bgActivePosistion = undefined;
            r.redrawHint('select', true);
            r.redraw();
        }
    }, false);
    var touchcancelHandler;
    r.registerBinding(containerWindow, 'touchcancel', touchcancelHandler = function touchcancelHandler(e) {
        // eslint-disable-line no-unused-vars
        var start = r.touchData.start;
        r.touchData.capture = false;
        if (start) start.unactivate();
    });
    var touchendHandler, didDoubleTouch, touchTimeout, prevTouchTimeStamp;
    r.registerBinding(containerWindow, 'touchend', touchendHandler = function touchendHandler(e) {
        // eslint-disable-line no-unused-vars
        var start = r.touchData.start;
        var capture = r.touchData.capture;
        if (capture) {
            if (e.touches.length === 0) r.touchData.capture = false;
            e.preventDefault();
        } else return;
        var select = r.selection;
        r.swipePanning = false;
        r.hoverData.draggingEles = false;
        var cy = r.cy;
        var zoom = cy.zoom();
        var now = r.touchData.now;
        var earlier = r.touchData.earlier;
        if (e.touches[0]) {
            var pos = r.projectIntoViewport(e.touches[0].clientX, e.touches[0].clientY);
            now[0] = pos[0];
            now[1] = pos[1];
        }
        if (e.touches[1]) {
            var pos = r.projectIntoViewport(e.touches[1].clientX, e.touches[1].clientY);
            now[2] = pos[0];
            now[3] = pos[1];
        }
        if (e.touches[2]) {
            var pos = r.projectIntoViewport(e.touches[2].clientX, e.touches[2].clientY);
            now[4] = pos[0];
            now[5] = pos[1];
        }
        var makeEvent = function makeEvent(type) {
            return {
                originalEvent: e,
                type: type,
                position: {
                    x: now[0],
                    y: now[1]
                }
            };
        };
        if (start) start.unactivate();
        var ctxTapend;
        if (r.touchData.cxt) {
            ctxTapend = makeEvent('cxttapend');
            if (start) start.emit(ctxTapend);
            else cy.emit(ctxTapend);
            if (!r.touchData.cxtDragged) {
                var ctxTap = makeEvent('cxttap');
                if (start) start.emit(ctxTap);
                else cy.emit(ctxTap);
            }
            if (r.touchData.start) r.touchData.start._private.grabbed = false;
            r.touchData.cxt = false;
            r.touchData.start = null;
            r.redraw();
            return;
        }
        // no more box selection if we don't have three fingers
        if (!e.touches[2] && cy.boxSelectionEnabled() && r.touchData.selecting) {
            r.touchData.selecting = false;
            var box = cy.collection(r.getAllInBox(select[0], select[1], select[2], select[3]));
            select[0] = undefined;
            select[1] = undefined;
            select[2] = undefined;
            select[3] = undefined;
            select[4] = 0;
            r.redrawHint('select', true);
            cy.emit(makeEvent('boxend'));
            var eleWouldBeSelected = function eleWouldBeSelected(ele) {
                return ele.selectable() && !ele.selected();
            };
            box.emit(makeEvent('box')).stdFilter(eleWouldBeSelected).select().emit(makeEvent('boxselect'));
            if (box.nonempty()) r.redrawHint('eles', true);
            r.redraw();
        }
        if (start != null) start.unactivate();
        if (e.touches[2]) {
            r.data.bgActivePosistion = undefined;
            r.redrawHint('select', true);
        } else if (e.touches[1]) ;
        else if (e.touches[0]) ;
        else if (!e.touches[0]) {
            r.data.bgActivePosistion = undefined;
            r.redrawHint('select', true);
            var draggedEles = r.dragData.touchDragEles;
            if (start != null) {
                var startWasGrabbed = start._private.grabbed;
                freeDraggedElements(draggedEles);
                r.redrawHint('drag', true);
                r.redrawHint('eles', true);
                if (startWasGrabbed) {
                    start.emit(makeEvent('freeon'));
                    draggedEles.emit(makeEvent('free'));
                    if (r.dragData.didDrag) {
                        start.emit(makeEvent('dragfreeon'));
                        draggedEles.emit(makeEvent('dragfree'));
                    }
                }
                triggerEvents(start, [
                    'touchend',
                    'tapend',
                    'vmouseup',
                    'tapdragout'
                ], e, {
                    x: now[0],
                    y: now[1]
                });
                start.unactivate();
                r.touchData.start = null;
            } else {
                var near = r.findNearestElement(now[0], now[1], true, true);
                triggerEvents(near, [
                    'touchend',
                    'tapend',
                    'vmouseup',
                    'tapdragout'
                ], e, {
                    x: now[0],
                    y: now[1]
                });
            }
            var dx = r.touchData.startPosition[0] - now[0];
            var dx2 = dx * dx;
            var dy = r.touchData.startPosition[1] - now[1];
            var dy2 = dy * dy;
            var dist2 = dx2 + dy2;
            var rdist2 = dist2 * zoom * zoom;
            // Tap event, roughly same as mouse click event for touch
            if (!r.touchData.singleTouchMoved) {
                if (!start) cy.$(':selected').unselect([
                    'tapunselect'
                ]);
                triggerEvents(start, [
                    'tap',
                    'vclick'
                ], e, {
                    x: now[0],
                    y: now[1]
                });
                didDoubleTouch = false;
                if (e.timeStamp - prevTouchTimeStamp <= cy.multiClickDebounceTime()) {
                    touchTimeout && clearTimeout(touchTimeout);
                    didDoubleTouch = true;
                    prevTouchTimeStamp = null;
                    triggerEvents(start, [
                        'dbltap',
                        'vdblclick'
                    ], e, {
                        x: now[0],
                        y: now[1]
                    });
                } else {
                    touchTimeout = setTimeout(function() {
                        if (didDoubleTouch) return;
                        triggerEvents(start, [
                            'onetap',
                            'voneclick'
                        ], e, {
                            x: now[0],
                            y: now[1]
                        });
                    }, cy.multiClickDebounceTime());
                    prevTouchTimeStamp = e.timeStamp;
                }
            }
            // Prepare to select the currently touched node, only if it hasn't been dragged past a certain distance
            if (start != null && !r.dragData.didDrag // didn't drag nodes around
             && start._private.selectable && rdist2 < r.touchTapThreshold2 && !r.pinching // pinch to zoom should not affect selection
            ) {
                if (cy.selectionType() === 'single') {
                    cy.$(isSelected).unmerge(start).unselect([
                        'tapunselect'
                    ]);
                    start.select([
                        'tapselect'
                    ]);
                } else if (start.selected()) start.unselect([
                    'tapunselect'
                ]);
                else start.select([
                    'tapselect'
                ]);
                r.redrawHint('eles', true);
            }
            r.touchData.singleTouchMoved = true;
        }
        for(var j = 0; j < now.length; j++)earlier[j] = now[j];
        r.dragData.didDrag = false; // reset for next touchstart
        if (e.touches.length === 0) {
            r.touchData.dragDelta = [];
            r.touchData.startPosition = [
                null,
                null,
                null,
                null,
                null,
                null
            ];
            r.touchData.startGPosition = null;
            r.touchData.didSelect = false;
        }
        if (e.touches.length < 2) {
            if (e.touches.length === 1) // the old start global pos'n may not be the same finger that remains
            r.touchData.startGPosition = [
                e.touches[0].clientX,
                e.touches[0].clientY
            ];
            r.pinching = false;
            r.redrawHint('eles', true);
            r.redraw();
        }
    //r.redraw();
    }, false);
    // fallback compatibility layer for ms pointer events
    if (typeof TouchEvent === 'undefined') {
        var pointers = [];
        var makeTouch = function makeTouch(e) {
            return {
                clientX: e.clientX,
                clientY: e.clientY,
                force: 1,
                identifier: e.pointerId,
                pageX: e.pageX,
                pageY: e.pageY,
                radiusX: e.width / 2,
                radiusY: e.height / 2,
                screenX: e.screenX,
                screenY: e.screenY,
                target: e.target
            };
        };
        var makePointer = function makePointer(e) {
            return {
                event: e,
                touch: makeTouch(e)
            };
        };
        var addPointer = function addPointer(e) {
            pointers.push(makePointer(e));
        };
        var removePointer = function removePointer(e) {
            for(var i = 0; i < pointers.length; i++){
                var p = pointers[i];
                if (p.event.pointerId === e.pointerId) {
                    pointers.splice(i, 1);
                    return;
                }
            }
        };
        var updatePointer = function updatePointer(e) {
            var p = pointers.filter(function(p) {
                return p.event.pointerId === e.pointerId;
            })[0];
            p.event = e;
            p.touch = makeTouch(e);
        };
        var addTouchesToEvent = function addTouchesToEvent(e) {
            e.touches = pointers.map(function(p) {
                return p.touch;
            });
        };
        var pointerIsMouse = function pointerIsMouse(e) {
            return e.pointerType === 'mouse' || e.pointerType === 4;
        };
        r.registerBinding(r.container, 'pointerdown', function(e) {
            if (pointerIsMouse(e)) return;
             // mouse already handled
            e.preventDefault();
            addPointer(e);
            addTouchesToEvent(e);
            touchstartHandler(e);
        });
        r.registerBinding(r.container, 'pointerup', function(e) {
            if (pointerIsMouse(e)) return;
             // mouse already handled
            removePointer(e);
            addTouchesToEvent(e);
            touchendHandler(e);
        });
        r.registerBinding(r.container, 'pointercancel', function(e) {
            if (pointerIsMouse(e)) return;
             // mouse already handled
            removePointer(e);
            addTouchesToEvent(e);
            touchcancelHandler(e);
        });
        r.registerBinding(r.container, 'pointermove', function(e) {
            if (pointerIsMouse(e)) return;
             // mouse already handled
            e.preventDefault();
            updatePointer(e);
            addTouchesToEvent(e);
            touchmoveHandler(e);
        });
    }
};
var $e815fda779bc047b$var$BRp$2 = {};
$e815fda779bc047b$var$BRp$2.generatePolygon = function(name, points) {
    return this.nodeShapes[name] = {
        renderer: this,
        name: name,
        points: points,
        draw: function draw(context, centerX, centerY, width, height, cornerRadius) {
            this.renderer.nodeShapeImpl('polygon', context, centerX, centerY, width, height, this.points);
        },
        intersectLine: function intersectLine(nodeX, nodeY, width, height, x, y, padding, cornerRadius) {
            return $e815fda779bc047b$var$polygonIntersectLine(x, y, this.points, nodeX, nodeY, width / 2, height / 2, padding);
        },
        checkPoint: function checkPoint(x, y, padding, width, height, centerX, centerY, cornerRadius) {
            return $e815fda779bc047b$var$pointInsidePolygon(x, y, this.points, centerX, centerY, width, height, [
                0,
                -1
            ], padding);
        },
        hasMiterBounds: name !== 'rectangle',
        miterBounds: function miterBounds(centerX, centerY, width, height, strokeWidth, strokePosition) {
            return $e815fda779bc047b$var$miterBox(this.points, centerX, centerY, width, height, strokeWidth);
        }
    };
};
$e815fda779bc047b$var$BRp$2.generateEllipse = function() {
    return this.nodeShapes['ellipse'] = {
        renderer: this,
        name: 'ellipse',
        draw: function draw(context, centerX, centerY, width, height, cornerRadius) {
            this.renderer.nodeShapeImpl(this.name, context, centerX, centerY, width, height);
        },
        intersectLine: function intersectLine(nodeX, nodeY, width, height, x, y, padding, cornerRadius) {
            return $e815fda779bc047b$var$intersectLineEllipse(x, y, nodeX, nodeY, width / 2 + padding, height / 2 + padding);
        },
        checkPoint: function checkPoint(x, y, padding, width, height, centerX, centerY, cornerRadius) {
            return $e815fda779bc047b$var$checkInEllipse(x, y, width, height, centerX, centerY, padding);
        }
    };
};
$e815fda779bc047b$var$BRp$2.generateRoundPolygon = function(name, points) {
    return this.nodeShapes[name] = {
        renderer: this,
        name: name,
        points: points,
        getOrCreateCorners: function getOrCreateCorners(centerX, centerY, width, height, cornerRadius, rs, field) {
            if (rs[field] !== undefined && rs[field + '-cx'] === centerX && rs[field + '-cy'] === centerY) return rs[field];
            rs[field] = new Array(points.length / 2);
            rs[field + '-cx'] = centerX;
            rs[field + '-cy'] = centerY;
            var halfW = width / 2;
            var halfH = height / 2;
            cornerRadius = cornerRadius === 'auto' ? $e815fda779bc047b$var$getRoundPolygonRadius(width, height) : cornerRadius;
            var p = new Array(points.length / 2);
            for(var _i = 0; _i < points.length / 2; _i++)p[_i] = {
                x: centerX + halfW * points[_i * 2],
                y: centerY + halfH * points[_i * 2 + 1]
            };
            var i, p1, p2, p3, len = p.length;
            p1 = p[len - 1];
            // for each point
            for(i = 0; i < len; i++){
                p2 = p[i % len];
                p3 = p[(i + 1) % len];
                rs[field][i] = $e815fda779bc047b$var$getRoundCorner(p1, p2, p3, cornerRadius);
                p1 = p2;
                p2 = p3;
            }
            return rs[field];
        },
        draw: function draw(context, centerX, centerY, width, height, cornerRadius, rs) {
            this.renderer.nodeShapeImpl('round-polygon', context, centerX, centerY, width, height, this.points, this.getOrCreateCorners(centerX, centerY, width, height, cornerRadius, rs, 'drawCorners'));
        },
        intersectLine: function intersectLine(nodeX, nodeY, width, height, x, y, padding, cornerRadius, rs) {
            return $e815fda779bc047b$var$roundPolygonIntersectLine(x, y, this.points, nodeX, nodeY, width, height, padding, this.getOrCreateCorners(nodeX, nodeY, width, height, cornerRadius, rs, 'corners'));
        },
        checkPoint: function checkPoint(x, y, padding, width, height, centerX, centerY, cornerRadius, rs) {
            return $e815fda779bc047b$var$pointInsideRoundPolygon(x, y, this.points, centerX, centerY, width, height, this.getOrCreateCorners(centerX, centerY, width, height, cornerRadius, rs, 'corners'));
        }
    };
};
$e815fda779bc047b$var$BRp$2.generateRoundRectangle = function() {
    return this.nodeShapes['round-rectangle'] = this.nodeShapes['roundrectangle'] = {
        renderer: this,
        name: 'round-rectangle',
        points: $e815fda779bc047b$var$generateUnitNgonPointsFitToSquare(4, 0),
        draw: function draw(context, centerX, centerY, width, height, cornerRadius) {
            this.renderer.nodeShapeImpl(this.name, context, centerX, centerY, width, height, this.points, cornerRadius);
        },
        intersectLine: function intersectLine(nodeX, nodeY, width, height, x, y, padding, cornerRadius) {
            return $e815fda779bc047b$var$roundRectangleIntersectLine(x, y, nodeX, nodeY, width, height, padding, cornerRadius);
        },
        checkPoint: function checkPoint(x, y, padding, width, height, centerX, centerY, cornerRadius) {
            var halfWidth = width / 2;
            var halfHeight = height / 2;
            cornerRadius = cornerRadius === 'auto' ? $e815fda779bc047b$var$getRoundRectangleRadius(width, height) : cornerRadius;
            cornerRadius = Math.min(halfWidth, halfHeight, cornerRadius);
            var diam = cornerRadius * 2;
            // Check hBox
            if ($e815fda779bc047b$var$pointInsidePolygon(x, y, this.points, centerX, centerY, width, height - diam, [
                0,
                -1
            ], padding)) return true;
            // Check vBox
            if ($e815fda779bc047b$var$pointInsidePolygon(x, y, this.points, centerX, centerY, width - diam, height, [
                0,
                -1
            ], padding)) return true;
            // Check top left quarter circle
            if ($e815fda779bc047b$var$checkInEllipse(x, y, diam, diam, centerX - halfWidth + cornerRadius, centerY - halfHeight + cornerRadius, padding)) return true;
            // Check top right quarter circle
            if ($e815fda779bc047b$var$checkInEllipse(x, y, diam, diam, centerX + halfWidth - cornerRadius, centerY - halfHeight + cornerRadius, padding)) return true;
            // Check bottom right quarter circle
            if ($e815fda779bc047b$var$checkInEllipse(x, y, diam, diam, centerX + halfWidth - cornerRadius, centerY + halfHeight - cornerRadius, padding)) return true;
            // Check bottom left quarter circle
            if ($e815fda779bc047b$var$checkInEllipse(x, y, diam, diam, centerX - halfWidth + cornerRadius, centerY + halfHeight - cornerRadius, padding)) return true;
            return false;
        }
    };
};
$e815fda779bc047b$var$BRp$2.generateCutRectangle = function() {
    return this.nodeShapes['cut-rectangle'] = this.nodeShapes['cutrectangle'] = {
        renderer: this,
        name: 'cut-rectangle',
        cornerLength: $e815fda779bc047b$var$getCutRectangleCornerLength(),
        points: $e815fda779bc047b$var$generateUnitNgonPointsFitToSquare(4, 0),
        draw: function draw(context, centerX, centerY, width, height, cornerRadius) {
            this.renderer.nodeShapeImpl(this.name, context, centerX, centerY, width, height, null, cornerRadius);
        },
        generateCutTrianglePts: function generateCutTrianglePts(width, height, centerX, centerY, cornerRadius) {
            var cl = cornerRadius === 'auto' ? this.cornerLength : cornerRadius;
            var hh = height / 2;
            var hw = width / 2;
            var xBegin = centerX - hw;
            var xEnd = centerX + hw;
            var yBegin = centerY - hh;
            var yEnd = centerY + hh;
            // points are in clockwise order, inner (imaginary) triangle pt on [4, 5]
            return {
                topLeft: [
                    xBegin,
                    yBegin + cl,
                    xBegin + cl,
                    yBegin,
                    xBegin + cl,
                    yBegin + cl
                ],
                topRight: [
                    xEnd - cl,
                    yBegin,
                    xEnd,
                    yBegin + cl,
                    xEnd - cl,
                    yBegin + cl
                ],
                bottomRight: [
                    xEnd,
                    yEnd - cl,
                    xEnd - cl,
                    yEnd,
                    xEnd - cl,
                    yEnd - cl
                ],
                bottomLeft: [
                    xBegin + cl,
                    yEnd,
                    xBegin,
                    yEnd - cl,
                    xBegin + cl,
                    yEnd - cl
                ]
            };
        },
        intersectLine: function intersectLine(nodeX, nodeY, width, height, x, y, padding, cornerRadius) {
            var cPts = this.generateCutTrianglePts(width + 2 * padding, height + 2 * padding, nodeX, nodeY, cornerRadius);
            var pts = [].concat.apply([], [
                cPts.topLeft.splice(0, 4),
                cPts.topRight.splice(0, 4),
                cPts.bottomRight.splice(0, 4),
                cPts.bottomLeft.splice(0, 4)
            ]);
            return $e815fda779bc047b$var$polygonIntersectLine(x, y, pts, nodeX, nodeY);
        },
        checkPoint: function checkPoint(x, y, padding, width, height, centerX, centerY, cornerRadius) {
            var cl = cornerRadius === 'auto' ? this.cornerLength : cornerRadius;
            // Check hBox
            if ($e815fda779bc047b$var$pointInsidePolygon(x, y, this.points, centerX, centerY, width, height - 2 * cl, [
                0,
                -1
            ], padding)) return true;
            // Check vBox
            if ($e815fda779bc047b$var$pointInsidePolygon(x, y, this.points, centerX, centerY, width - 2 * cl, height, [
                0,
                -1
            ], padding)) return true;
            var cutTrianglePts = this.generateCutTrianglePts(width, height, centerX, centerY);
            return $e815fda779bc047b$var$pointInsidePolygonPoints(x, y, cutTrianglePts.topLeft) || $e815fda779bc047b$var$pointInsidePolygonPoints(x, y, cutTrianglePts.topRight) || $e815fda779bc047b$var$pointInsidePolygonPoints(x, y, cutTrianglePts.bottomRight) || $e815fda779bc047b$var$pointInsidePolygonPoints(x, y, cutTrianglePts.bottomLeft);
        }
    };
};
$e815fda779bc047b$var$BRp$2.generateBarrel = function() {
    return this.nodeShapes['barrel'] = {
        renderer: this,
        name: 'barrel',
        points: $e815fda779bc047b$var$generateUnitNgonPointsFitToSquare(4, 0),
        draw: function draw(context, centerX, centerY, width, height, cornerRadius) {
            this.renderer.nodeShapeImpl(this.name, context, centerX, centerY, width, height);
        },
        intersectLine: function intersectLine(nodeX, nodeY, width, height, x, y, padding, cornerRadius) {
            // use two fixed t values for the bezier curve approximation
            var t0 = 0.15;
            var t1 = 0.5;
            var t2 = 0.85;
            var bPts = this.generateBarrelBezierPts(width + 2 * padding, height + 2 * padding, nodeX, nodeY);
            var approximateBarrelCurvePts = function approximateBarrelCurvePts(pts) {
                // approximate curve pts based on the two t values
                var m0 = $e815fda779bc047b$var$qbezierPtAt({
                    x: pts[0],
                    y: pts[1]
                }, {
                    x: pts[2],
                    y: pts[3]
                }, {
                    x: pts[4],
                    y: pts[5]
                }, t0);
                var m1 = $e815fda779bc047b$var$qbezierPtAt({
                    x: pts[0],
                    y: pts[1]
                }, {
                    x: pts[2],
                    y: pts[3]
                }, {
                    x: pts[4],
                    y: pts[5]
                }, t1);
                var m2 = $e815fda779bc047b$var$qbezierPtAt({
                    x: pts[0],
                    y: pts[1]
                }, {
                    x: pts[2],
                    y: pts[3]
                }, {
                    x: pts[4],
                    y: pts[5]
                }, t2);
                return [
                    pts[0],
                    pts[1],
                    m0.x,
                    m0.y,
                    m1.x,
                    m1.y,
                    m2.x,
                    m2.y,
                    pts[4],
                    pts[5]
                ];
            };
            var pts = [].concat(approximateBarrelCurvePts(bPts.topLeft), approximateBarrelCurvePts(bPts.topRight), approximateBarrelCurvePts(bPts.bottomRight), approximateBarrelCurvePts(bPts.bottomLeft));
            return $e815fda779bc047b$var$polygonIntersectLine(x, y, pts, nodeX, nodeY);
        },
        generateBarrelBezierPts: function generateBarrelBezierPts(width, height, centerX, centerY) {
            var hh = height / 2;
            var hw = width / 2;
            var xBegin = centerX - hw;
            var xEnd = centerX + hw;
            var yBegin = centerY - hh;
            var yEnd = centerY + hh;
            var curveConstants = $e815fda779bc047b$var$getBarrelCurveConstants(width, height);
            var hOffset = curveConstants.heightOffset;
            var wOffset = curveConstants.widthOffset;
            var ctrlPtXOffset = curveConstants.ctrlPtOffsetPct * width;
            // points are in clockwise order, inner (imaginary) control pt on [4, 5]
            var pts = {
                topLeft: [
                    xBegin,
                    yBegin + hOffset,
                    xBegin + ctrlPtXOffset,
                    yBegin,
                    xBegin + wOffset,
                    yBegin
                ],
                topRight: [
                    xEnd - wOffset,
                    yBegin,
                    xEnd - ctrlPtXOffset,
                    yBegin,
                    xEnd,
                    yBegin + hOffset
                ],
                bottomRight: [
                    xEnd,
                    yEnd - hOffset,
                    xEnd - ctrlPtXOffset,
                    yEnd,
                    xEnd - wOffset,
                    yEnd
                ],
                bottomLeft: [
                    xBegin + wOffset,
                    yEnd,
                    xBegin + ctrlPtXOffset,
                    yEnd,
                    xBegin,
                    yEnd - hOffset
                ]
            };
            pts.topLeft.isTop = true;
            pts.topRight.isTop = true;
            pts.bottomLeft.isBottom = true;
            pts.bottomRight.isBottom = true;
            return pts;
        },
        checkPoint: function checkPoint(x, y, padding, width, height, centerX, centerY, cornerRadius) {
            var curveConstants = $e815fda779bc047b$var$getBarrelCurveConstants(width, height);
            var hOffset = curveConstants.heightOffset;
            var wOffset = curveConstants.widthOffset;
            // Check hBox
            if ($e815fda779bc047b$var$pointInsidePolygon(x, y, this.points, centerX, centerY, width, height - 2 * hOffset, [
                0,
                -1
            ], padding)) return true;
            // Check vBox
            if ($e815fda779bc047b$var$pointInsidePolygon(x, y, this.points, centerX, centerY, width - 2 * wOffset, height, [
                0,
                -1
            ], padding)) return true;
            var barrelCurvePts = this.generateBarrelBezierPts(width, height, centerX, centerY);
            var getCurveT = function getCurveT(x, y, curvePts) {
                var x0 = curvePts[4];
                var x1 = curvePts[2];
                var x2 = curvePts[0];
                var y0 = curvePts[5];
                // var y1 = curvePts[ 3 ];
                var y2 = curvePts[1];
                var xMin = Math.min(x0, x2);
                var xMax = Math.max(x0, x2);
                var yMin = Math.min(y0, y2);
                var yMax = Math.max(y0, y2);
                if (xMin <= x && x <= xMax && yMin <= y && y <= yMax) {
                    var coeff = $e815fda779bc047b$var$bezierPtsToQuadCoeff(x0, x1, x2);
                    var roots = $e815fda779bc047b$var$solveQuadratic(coeff[0], coeff[1], coeff[2], x);
                    var validRoots = roots.filter(function(r) {
                        return 0 <= r && r <= 1;
                    });
                    if (validRoots.length > 0) return validRoots[0];
                }
                return null;
            };
            var curveRegions = Object.keys(barrelCurvePts);
            for(var i = 0; i < curveRegions.length; i++){
                var corner = curveRegions[i];
                var cornerPts = barrelCurvePts[corner];
                var t = getCurveT(x, y, cornerPts);
                if (t == null) continue;
                var y0 = cornerPts[5];
                var y1 = cornerPts[3];
                var y2 = cornerPts[1];
                var bezY = $e815fda779bc047b$var$qbezierAt(y0, y1, y2, t);
                if (cornerPts.isTop && bezY <= y) return true;
                if (cornerPts.isBottom && y <= bezY) return true;
            }
            return false;
        }
    };
};
$e815fda779bc047b$var$BRp$2.generateBottomRoundrectangle = function() {
    return this.nodeShapes['bottom-round-rectangle'] = this.nodeShapes['bottomroundrectangle'] = {
        renderer: this,
        name: 'bottom-round-rectangle',
        points: $e815fda779bc047b$var$generateUnitNgonPointsFitToSquare(4, 0),
        draw: function draw(context, centerX, centerY, width, height, cornerRadius) {
            this.renderer.nodeShapeImpl(this.name, context, centerX, centerY, width, height, this.points, cornerRadius);
        },
        intersectLine: function intersectLine(nodeX, nodeY, width, height, x, y, padding, cornerRadius) {
            var topStartX = nodeX - (width / 2 + padding);
            var topStartY = nodeY - (height / 2 + padding);
            var topEndY = topStartY;
            var topEndX = nodeX + (width / 2 + padding);
            var topIntersections = $e815fda779bc047b$var$finiteLinesIntersect(x, y, nodeX, nodeY, topStartX, topStartY, topEndX, topEndY, false);
            if (topIntersections.length > 0) return topIntersections;
            return $e815fda779bc047b$var$roundRectangleIntersectLine(x, y, nodeX, nodeY, width, height, padding, cornerRadius);
        },
        checkPoint: function checkPoint(x, y, padding, width, height, centerX, centerY, cornerRadius) {
            cornerRadius = cornerRadius === 'auto' ? $e815fda779bc047b$var$getRoundRectangleRadius(width, height) : cornerRadius;
            var diam = 2 * cornerRadius;
            // Check hBox
            if ($e815fda779bc047b$var$pointInsidePolygon(x, y, this.points, centerX, centerY, width, height - diam, [
                0,
                -1
            ], padding)) return true;
            // Check vBox
            if ($e815fda779bc047b$var$pointInsidePolygon(x, y, this.points, centerX, centerY, width - diam, height, [
                0,
                -1
            ], padding)) return true;
            // check non-rounded top side
            var outerWidth = width / 2 + 2 * padding;
            var outerHeight = height / 2 + 2 * padding;
            var points = [
                centerX - outerWidth,
                centerY - outerHeight,
                centerX - outerWidth,
                centerY,
                centerX + outerWidth,
                centerY,
                centerX + outerWidth,
                centerY - outerHeight
            ];
            if ($e815fda779bc047b$var$pointInsidePolygonPoints(x, y, points)) return true;
            // Check bottom right quarter circle
            if ($e815fda779bc047b$var$checkInEllipse(x, y, diam, diam, centerX + width / 2 - cornerRadius, centerY + height / 2 - cornerRadius, padding)) return true;
            // Check bottom left quarter circle
            if ($e815fda779bc047b$var$checkInEllipse(x, y, diam, diam, centerX - width / 2 + cornerRadius, centerY + height / 2 - cornerRadius, padding)) return true;
            return false;
        }
    };
};
$e815fda779bc047b$var$BRp$2.registerNodeShapes = function() {
    var nodeShapes = this.nodeShapes = {};
    var renderer = this;
    this.generateEllipse();
    this.generatePolygon('triangle', $e815fda779bc047b$var$generateUnitNgonPointsFitToSquare(3, 0));
    this.generateRoundPolygon('round-triangle', $e815fda779bc047b$var$generateUnitNgonPointsFitToSquare(3, 0));
    this.generatePolygon('rectangle', $e815fda779bc047b$var$generateUnitNgonPointsFitToSquare(4, 0));
    nodeShapes['square'] = nodeShapes['rectangle'];
    this.generateRoundRectangle();
    this.generateCutRectangle();
    this.generateBarrel();
    this.generateBottomRoundrectangle();
    var diamondPoints = [
        0,
        1,
        1,
        0,
        0,
        -1,
        -1,
        0
    ];
    this.generatePolygon('diamond', diamondPoints);
    this.generateRoundPolygon('round-diamond', diamondPoints);
    this.generatePolygon('pentagon', $e815fda779bc047b$var$generateUnitNgonPointsFitToSquare(5, 0));
    this.generateRoundPolygon('round-pentagon', $e815fda779bc047b$var$generateUnitNgonPointsFitToSquare(5, 0));
    this.generatePolygon('hexagon', $e815fda779bc047b$var$generateUnitNgonPointsFitToSquare(6, 0));
    this.generateRoundPolygon('round-hexagon', $e815fda779bc047b$var$generateUnitNgonPointsFitToSquare(6, 0));
    this.generatePolygon('heptagon', $e815fda779bc047b$var$generateUnitNgonPointsFitToSquare(7, 0));
    this.generateRoundPolygon('round-heptagon', $e815fda779bc047b$var$generateUnitNgonPointsFitToSquare(7, 0));
    this.generatePolygon('octagon', $e815fda779bc047b$var$generateUnitNgonPointsFitToSquare(8, 0));
    this.generateRoundPolygon('round-octagon', $e815fda779bc047b$var$generateUnitNgonPointsFitToSquare(8, 0));
    var star5Points = new Array(20);
    var outerPoints = $e815fda779bc047b$var$generateUnitNgonPoints(5, 0);
    var innerPoints = $e815fda779bc047b$var$generateUnitNgonPoints(5, Math.PI / 5);
    // Outer radius is 1; inner radius of star is smaller
    var innerRadius = 0.5 * (3 - Math.sqrt(5));
    innerRadius *= 1.57;
    for(var i = 0; i < innerPoints.length / 2; i++){
        innerPoints[i * 2] *= innerRadius;
        innerPoints[i * 2 + 1] *= innerRadius;
    }
    for(var i = 0; i < 5; i++){
        star5Points[i * 4] = outerPoints[i * 2];
        star5Points[i * 4 + 1] = outerPoints[i * 2 + 1];
        star5Points[i * 4 + 2] = innerPoints[i * 2];
        star5Points[i * 4 + 3] = innerPoints[i * 2 + 1];
    }
    star5Points = $e815fda779bc047b$var$fitPolygonToSquare(star5Points);
    this.generatePolygon('star', star5Points);
    this.generatePolygon('vee', [
        -1,
        -1,
        0,
        -0.333,
        1,
        -1,
        0,
        1
    ]);
    this.generatePolygon('rhomboid', [
        -1,
        -1,
        0.333,
        -1,
        1,
        1,
        -0.333,
        1
    ]);
    this.generatePolygon('right-rhomboid', [
        -0.333,
        -1,
        1,
        -1,
        0.333,
        1,
        -1,
        1
    ]);
    this.nodeShapes['concavehexagon'] = this.generatePolygon('concave-hexagon', [
        -1,
        -0.95,
        -0.75,
        0,
        -1,
        0.95,
        1,
        0.95,
        0.75,
        0,
        1,
        -0.95
    ]);
    var tagPoints = [
        -1,
        -1,
        0.25,
        -1,
        1,
        0,
        0.25,
        1,
        -1,
        1
    ];
    this.generatePolygon('tag', tagPoints);
    this.generateRoundPolygon('round-tag', tagPoints);
    nodeShapes.makePolygon = function(points) {
        // use caching on user-specified polygons so they are as fast as native shapes
        var key = points.join('$');
        var name = 'polygon-' + key;
        var shape;
        if (shape = this[name]) // got cached shape
        return shape;
        // create and cache new shape
        return renderer.generatePolygon(name, points);
    };
};
var $e815fda779bc047b$var$BRp$1 = {};
$e815fda779bc047b$var$BRp$1.timeToRender = function() {
    return this.redrawTotalTime / this.redrawCount;
};
$e815fda779bc047b$var$BRp$1.redraw = function(options) {
    options = options || $e815fda779bc047b$var$staticEmptyObject();
    var r = this;
    if (r.averageRedrawTime === undefined) r.averageRedrawTime = 0;
    if (r.lastRedrawTime === undefined) r.lastRedrawTime = 0;
    if (r.lastDrawTime === undefined) r.lastDrawTime = 0;
    r.requestedFrame = true;
    r.renderOptions = options;
};
$e815fda779bc047b$var$BRp$1.beforeRender = function(fn, priority) {
    // the renderer can't add tick callbacks when destroyed
    if (this.destroyed) return;
    if (priority == null) $e815fda779bc047b$var$error('Priority is not optional for beforeRender');
    var cbs = this.beforeRenderCallbacks;
    cbs.push({
        fn: fn,
        priority: priority
    });
    // higher priority callbacks executed first
    cbs.sort(function(a, b) {
        return b.priority - a.priority;
    });
};
var $e815fda779bc047b$var$beforeRenderCallbacks = function beforeRenderCallbacks(r, willDraw, startTime) {
    var cbs = r.beforeRenderCallbacks;
    for(var i = 0; i < cbs.length; i++)cbs[i].fn(willDraw, startTime);
};
$e815fda779bc047b$var$BRp$1.startRenderLoop = function() {
    var r = this;
    var cy = r.cy;
    if (r.renderLoopStarted) return;
    else r.renderLoopStarted = true;
    var _renderFn = function renderFn(requestTime) {
        if (r.destroyed) return;
        if (cy.batching()) ;
        else if (r.requestedFrame && !r.skipFrame) {
            $e815fda779bc047b$var$beforeRenderCallbacks(r, true, requestTime);
            var startTime = $e815fda779bc047b$var$performanceNow();
            r.render(r.renderOptions);
            var endTime = r.lastDrawTime = $e815fda779bc047b$var$performanceNow();
            if (r.averageRedrawTime === undefined) r.averageRedrawTime = endTime - startTime;
            if (r.redrawCount === undefined) r.redrawCount = 0;
            r.redrawCount++;
            if (r.redrawTotalTime === undefined) r.redrawTotalTime = 0;
            var duration = endTime - startTime;
            r.redrawTotalTime += duration;
            r.lastRedrawTime = duration;
            // use a weighted average with a bias from the previous average so we don't spike so easily
            r.averageRedrawTime = r.averageRedrawTime / 2 + duration / 2;
            r.requestedFrame = false;
        } else $e815fda779bc047b$var$beforeRenderCallbacks(r, false, requestTime);
        r.skipFrame = false;
        $e815fda779bc047b$var$requestAnimationFrame(_renderFn);
    };
    $e815fda779bc047b$var$requestAnimationFrame(_renderFn);
};
var $e815fda779bc047b$var$BaseRenderer = function BaseRenderer(options) {
    this.init(options);
};
var $e815fda779bc047b$var$BR = $e815fda779bc047b$var$BaseRenderer;
var $e815fda779bc047b$var$BRp = $e815fda779bc047b$var$BR.prototype;
$e815fda779bc047b$var$BRp.clientFunctions = [
    'redrawHint',
    'render',
    'renderTo',
    'matchCanvasSize',
    'nodeShapeImpl',
    'arrowShapeImpl'
];
$e815fda779bc047b$var$BRp.init = function(options) {
    var r = this;
    r.options = options;
    r.cy = options.cy;
    var ctr = r.container = options.cy.container();
    var containerWindow = r.cy.window();
    // prepend a stylesheet in the head such that
    if (containerWindow) {
        var document1 = containerWindow.document;
        var head = document1.head;
        var stylesheetId = '__________cytoscape_stylesheet';
        var className = '__________cytoscape_container';
        var stylesheetAlreadyExists = document1.getElementById(stylesheetId) != null;
        if (ctr.className.indexOf(className) < 0) ctr.className = (ctr.className || '') + ' ' + className;
        if (!stylesheetAlreadyExists) {
            var stylesheet = document1.createElement('style');
            stylesheet.id = stylesheetId;
            stylesheet.textContent = '.' + className + ' { position: relative; }';
            head.insertBefore(stylesheet, head.children[0]); // first so lowest priority
        }
        var computedStyle = containerWindow.getComputedStyle(ctr);
        var position = computedStyle.getPropertyValue('position');
        if (position === 'static') $e815fda779bc047b$var$warn('A Cytoscape container has style position:static and so can not use UI extensions properly');
    }
    r.selection = [
        undefined,
        undefined,
        undefined,
        undefined,
        0
    ]; // Coordinates for selection box, plus enabled flag
    r.bezierProjPcts = [
        0.05,
        0.225,
        0.4,
        0.5,
        0.6,
        0.775,
        0.95
    ];
    //--Pointer-related data
    r.hoverData = {
        down: null,
        last: null,
        downTime: null,
        triggerMode: null,
        dragging: false,
        initialPan: [
            null,
            null
        ],
        capture: false
    };
    r.dragData = {
        possibleDragElements: []
    };
    r.touchData = {
        start: null,
        capture: false,
        // These 3 fields related to tap, taphold events
        startPosition: [
            null,
            null,
            null,
            null,
            null,
            null
        ],
        singleTouchStartTime: null,
        singleTouchMoved: true,
        now: [
            null,
            null,
            null,
            null,
            null,
            null
        ],
        earlier: [
            null,
            null,
            null,
            null,
            null,
            null
        ]
    };
    r.redraws = 0;
    r.showFps = options.showFps;
    r.debug = options.debug;
    r.webgl = options.webgl;
    r.hideEdgesOnViewport = options.hideEdgesOnViewport;
    r.textureOnViewport = options.textureOnViewport;
    r.wheelSensitivity = options.wheelSensitivity;
    r.motionBlurEnabled = options.motionBlur; // on by default
    r.forcedPixelRatio = $e815fda779bc047b$var$number$1(options.pixelRatio) ? options.pixelRatio : null;
    r.motionBlur = options.motionBlur; // for initial kick off
    r.motionBlurOpacity = options.motionBlurOpacity;
    r.motionBlurTransparency = 1 - r.motionBlurOpacity;
    r.motionBlurPxRatio = 1;
    r.mbPxRBlurry = 1; //0.8;
    r.minMbLowQualFrames = 4;
    r.fullQualityMb = false;
    r.clearedForMotionBlur = [];
    r.desktopTapThreshold = options.desktopTapThreshold;
    r.desktopTapThreshold2 = options.desktopTapThreshold * options.desktopTapThreshold;
    r.touchTapThreshold = options.touchTapThreshold;
    r.touchTapThreshold2 = options.touchTapThreshold * options.touchTapThreshold;
    r.tapholdDuration = 500;
    r.bindings = [];
    r.beforeRenderCallbacks = [];
    r.beforeRenderPriorities = {
        // higher priority execs before lower one
        animations: 400,
        eleCalcs: 300,
        eleTxrDeq: 200,
        lyrTxrDeq: 150,
        lyrTxrSkip: 100
    };
    r.registerNodeShapes();
    r.registerArrowShapes();
    r.registerCalculationListeners();
};
$e815fda779bc047b$var$BRp.notify = function(eventName, eles) {
    var r = this;
    var cy = r.cy;
    // the renderer can't be notified after it's destroyed
    if (this.destroyed) return;
    if (eventName === 'init') {
        r.load();
        return;
    }
    if (eventName === 'destroy') {
        r.destroy();
        return;
    }
    if (eventName === 'add' || eventName === 'remove' || eventName === 'move' && cy.hasCompoundNodes() || eventName === 'load' || eventName === 'zorder' || eventName === 'mount') r.invalidateCachedZSortedEles();
    if (eventName === 'viewport') r.redrawHint('select', true);
    if (eventName === 'gc') r.redrawHint('gc', true);
    if (eventName === 'load' || eventName === 'resize' || eventName === 'mount') {
        r.invalidateContainerClientCoordsCache();
        r.matchCanvasSize(r.container);
    }
    r.redrawHint('eles', true);
    r.redrawHint('drag', true);
    this.startRenderLoop();
    this.redraw();
};
$e815fda779bc047b$var$BRp.destroy = function() {
    var r = this;
    r.destroyed = true;
    r.cy.stopAnimationLoop();
    for(var i = 0; i < r.bindings.length; i++){
        var binding = r.bindings[i];
        var b = binding;
        var tgt = b.target;
        (tgt.off || tgt.removeEventListener).apply(tgt, b.args);
    }
    r.bindings = [];
    r.beforeRenderCallbacks = [];
    r.onUpdateEleCalcsFns = [];
    if (r.removeObserver) r.removeObserver.disconnect();
    if (r.styleObserver) r.styleObserver.disconnect();
    if (r.resizeObserver) r.resizeObserver.disconnect();
    if (r.labelCalcDiv) try {
        document.body.removeChild(r.labelCalcDiv); // eslint-disable-line no-undef
    } catch (e) {
    // ie10 issue #1014
    }
};
$e815fda779bc047b$var$BRp.isHeadless = function() {
    return false;
};
[
    $e815fda779bc047b$var$BRp$f,
    $e815fda779bc047b$var$BRp$5,
    $e815fda779bc047b$var$BRp$4,
    $e815fda779bc047b$var$BRp$3,
    $e815fda779bc047b$var$BRp$2,
    $e815fda779bc047b$var$BRp$1
].forEach(function(props) {
    $e815fda779bc047b$var$extend($e815fda779bc047b$var$BRp, props);
});
var $e815fda779bc047b$var$fullFpsTime = 1000 / 60; // assume 60 frames per second
var $e815fda779bc047b$var$defs = {
    setupDequeueing: function setupDequeueing(opts) {
        return function setupDequeueingImpl() {
            var self1 = this;
            var r = this.renderer;
            if (self1.dequeueingSetup) return;
            else self1.dequeueingSetup = true;
            var queueRedraw = $e815fda779bc047b$var$debounce(function() {
                r.redrawHint('eles', true);
                r.redrawHint('drag', true);
                r.redraw();
            }, opts.deqRedrawThreshold);
            var dequeue = function dequeue(willDraw, frameStartTime) {
                var startTime = $e815fda779bc047b$var$performanceNow();
                var avgRenderTime = r.averageRedrawTime;
                var renderTime = r.lastRedrawTime;
                var deqd = [];
                var extent = r.cy.extent();
                var pixelRatio = r.getPixelRatio();
                // if we aren't in a tick that causes a draw, then the rendered style
                // queue won't automatically be flushed before dequeueing starts
                if (!willDraw) r.flushRenderedStyleQueue();
                while(true){
                    // eslint-disable-line no-constant-condition
                    var now = $e815fda779bc047b$var$performanceNow();
                    var duration = now - startTime;
                    var frameDuration = now - frameStartTime;
                    if (renderTime < $e815fda779bc047b$var$fullFpsTime) {
                        // if we're rendering faster than the ideal fps, then do dequeueing
                        // during all of the remaining frame time
                        var timeAvailable = $e815fda779bc047b$var$fullFpsTime - (willDraw ? avgRenderTime : 0);
                        if (frameDuration >= opts.deqFastCost * timeAvailable) break;
                    } else {
                        if (willDraw) {
                            if (duration >= opts.deqCost * renderTime || duration >= opts.deqAvgCost * avgRenderTime) break;
                        } else if (frameDuration >= opts.deqNoDrawCost * $e815fda779bc047b$var$fullFpsTime) break;
                    }
                    var thisDeqd = opts.deq(self1, pixelRatio, extent);
                    if (thisDeqd.length > 0) for(var i = 0; i < thisDeqd.length; i++)deqd.push(thisDeqd[i]);
                    else break;
                }
                // callbacks on dequeue
                if (deqd.length > 0) {
                    opts.onDeqd(self1, deqd);
                    if (!willDraw && opts.shouldRedraw(self1, deqd, pixelRatio, extent)) queueRedraw();
                }
            };
            var priority = opts.priority || $e815fda779bc047b$var$noop$1;
            r.beforeRender(dequeue, priority(self1));
        };
    }
};
// Allows lookups for (ele, lvl) => cache.
// Uses keys so elements may share the same cache.
var $e815fda779bc047b$var$ElementTextureCacheLookup = /*#__PURE__*/ function() {
    function ElementTextureCacheLookup(getKey) {
        var doesEleInvalidateKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $e815fda779bc047b$var$falsify;
        $e815fda779bc047b$var$_classCallCheck(this, ElementTextureCacheLookup);
        this.idsByKey = new $e815fda779bc047b$var$Map$1();
        this.keyForId = new $e815fda779bc047b$var$Map$1();
        this.cachesByLvl = new $e815fda779bc047b$var$Map$1();
        this.lvls = [];
        this.getKey = getKey;
        this.doesEleInvalidateKey = doesEleInvalidateKey;
    }
    return $e815fda779bc047b$var$_createClass(ElementTextureCacheLookup, [
        {
            key: "getIdsFor",
            value: function getIdsFor(key) {
                if (key == null) $e815fda779bc047b$var$error("Can not get id list for null key");
                var idsByKey = this.idsByKey;
                var ids = this.idsByKey.get(key);
                if (!ids) {
                    ids = new $e815fda779bc047b$var$Set$1();
                    idsByKey.set(key, ids);
                }
                return ids;
            }
        },
        {
            key: "addIdForKey",
            value: function addIdForKey(key, id) {
                if (key != null) this.getIdsFor(key).add(id);
            }
        },
        {
            key: "deleteIdForKey",
            value: function deleteIdForKey(key, id) {
                if (key != null) this.getIdsFor(key)["delete"](id);
            }
        },
        {
            key: "getNumberOfIdsForKey",
            value: function getNumberOfIdsForKey(key) {
                if (key == null) return 0;
                else return this.getIdsFor(key).size;
            }
        },
        {
            key: "updateKeyMappingFor",
            value: function updateKeyMappingFor(ele) {
                var id = ele.id();
                var prevKey = this.keyForId.get(id);
                var currKey = this.getKey(ele);
                this.deleteIdForKey(prevKey, id);
                this.addIdForKey(currKey, id);
                this.keyForId.set(id, currKey);
            }
        },
        {
            key: "deleteKeyMappingFor",
            value: function deleteKeyMappingFor(ele) {
                var id = ele.id();
                var prevKey = this.keyForId.get(id);
                this.deleteIdForKey(prevKey, id);
                this.keyForId["delete"](id);
            }
        },
        {
            key: "keyHasChangedFor",
            value: function keyHasChangedFor(ele) {
                var id = ele.id();
                var prevKey = this.keyForId.get(id);
                var newKey = this.getKey(ele);
                return prevKey !== newKey;
            }
        },
        {
            key: "isInvalid",
            value: function isInvalid(ele) {
                return this.keyHasChangedFor(ele) || this.doesEleInvalidateKey(ele);
            }
        },
        {
            key: "getCachesAt",
            value: function getCachesAt(lvl) {
                var cachesByLvl = this.cachesByLvl, lvls = this.lvls;
                var caches = cachesByLvl.get(lvl);
                if (!caches) {
                    caches = new $e815fda779bc047b$var$Map$1();
                    cachesByLvl.set(lvl, caches);
                    lvls.push(lvl);
                }
                return caches;
            }
        },
        {
            key: "getCache",
            value: function getCache(key, lvl) {
                return this.getCachesAt(lvl).get(key);
            }
        },
        {
            key: "get",
            value: function get(ele, lvl) {
                var key = this.getKey(ele);
                var cache = this.getCache(key, lvl);
                // getting for an element may need to add to the id list b/c eles can share keys
                if (cache != null) this.updateKeyMappingFor(ele);
                return cache;
            }
        },
        {
            key: "getForCachedKey",
            value: function getForCachedKey(ele, lvl) {
                var key = this.keyForId.get(ele.id()); // n.b. use cached key, not newly computed key
                var cache = this.getCache(key, lvl);
                return cache;
            }
        },
        {
            key: "hasCache",
            value: function hasCache(key, lvl) {
                return this.getCachesAt(lvl).has(key);
            }
        },
        {
            key: "has",
            value: function has(ele, lvl) {
                var key = this.getKey(ele);
                return this.hasCache(key, lvl);
            }
        },
        {
            key: "setCache",
            value: function setCache(key, lvl, cache) {
                cache.key = key;
                this.getCachesAt(lvl).set(key, cache);
            }
        },
        {
            key: "set",
            value: function set(ele, lvl, cache) {
                var key = this.getKey(ele);
                this.setCache(key, lvl, cache);
                this.updateKeyMappingFor(ele);
            }
        },
        {
            key: "deleteCache",
            value: function deleteCache(key, lvl) {
                this.getCachesAt(lvl)["delete"](key);
            }
        },
        {
            key: "delete",
            value: function _delete(ele, lvl) {
                var key = this.getKey(ele);
                this.deleteCache(key, lvl);
            }
        },
        {
            key: "invalidateKey",
            value: function invalidateKey(key) {
                var _this = this;
                this.lvls.forEach(function(lvl) {
                    return _this.deleteCache(key, lvl);
                });
            }
        },
        {
            key: "invalidate",
            value: function invalidate(ele) {
                var id = ele.id();
                var key = this.keyForId.get(id); // n.b. use stored key rather than current (potential key)
                this.deleteKeyMappingFor(ele);
                var entireKeyInvalidated = this.doesEleInvalidateKey(ele);
                if (entireKeyInvalidated) // clear mapping for current key
                this.invalidateKey(key);
                return entireKeyInvalidated || this.getNumberOfIdsForKey(key) === 0;
            }
        }
    ]);
}();
var $e815fda779bc047b$var$minTxrH = 25; // the size of the texture cache for small height eles (special case)
var $e815fda779bc047b$var$txrStepH = 50; // the min size of the regular cache, and the size it increases with each step up
var $e815fda779bc047b$var$minLvl$1 = -4; // when scaling smaller than that we don't need to re-render
var $e815fda779bc047b$var$maxLvl$1 = 3; // when larger than this scale just render directly (caching is not helpful)
var $e815fda779bc047b$var$maxZoom$1 = 7.99; // beyond this zoom level, layered textures are not used
var $e815fda779bc047b$var$eleTxrSpacing = 8; // spacing between elements on textures to avoid blitting overlaps
var $e815fda779bc047b$var$defTxrWidth = 1024; // default/minimum texture width
var $e815fda779bc047b$var$maxTxrW = 1024; // the maximum width of a texture
var $e815fda779bc047b$var$maxTxrH = 1024; // the maximum height of a texture
var $e815fda779bc047b$var$minUtility = 0.2; // if usage of texture is less than this, it is retired
var $e815fda779bc047b$var$maxFullness = 0.8; // fullness of texture after which queue removal is checked
var $e815fda779bc047b$var$maxFullnessChecks = 10; // dequeued after this many checks
var $e815fda779bc047b$var$deqCost$1 = 0.15; // % of add'l rendering cost allowed for dequeuing ele caches each frame
var $e815fda779bc047b$var$deqAvgCost$1 = 0.1; // % of add'l rendering cost compared to average overall redraw time
var $e815fda779bc047b$var$deqNoDrawCost$1 = 0.9; // % of avg frame time that can be used for dequeueing when not drawing
var $e815fda779bc047b$var$deqFastCost$1 = 0.9; // % of frame time to be used when >60fps
var $e815fda779bc047b$var$deqRedrawThreshold$1 = 100; // time to batch redraws together from dequeueing to allow more dequeueing calcs to happen in the meanwhile
var $e815fda779bc047b$var$maxDeqSize$1 = 1; // number of eles to dequeue and render at higher texture in each batch
var $e815fda779bc047b$var$getTxrReasons = {
    dequeue: 'dequeue',
    downscale: 'downscale',
    highQuality: 'highQuality'
};
var $e815fda779bc047b$var$initDefaults = $e815fda779bc047b$var$defaults$g({
    getKey: null,
    doesEleInvalidateKey: $e815fda779bc047b$var$falsify,
    drawElement: null,
    getBoundingBox: null,
    getRotationPoint: null,
    getRotationOffset: null,
    isVisible: $e815fda779bc047b$var$trueify,
    allowEdgeTxrCaching: true,
    allowParentTxrCaching: true
});
var $e815fda779bc047b$var$ElementTextureCache = function ElementTextureCache(renderer, initOptions) {
    var self1 = this;
    self1.renderer = renderer;
    self1.onDequeues = [];
    var opts = $e815fda779bc047b$var$initDefaults(initOptions);
    $e815fda779bc047b$var$extend(self1, opts);
    self1.lookup = new $e815fda779bc047b$var$ElementTextureCacheLookup(opts.getKey, opts.doesEleInvalidateKey);
    self1.setupDequeueing();
};
var $e815fda779bc047b$var$ETCp = $e815fda779bc047b$var$ElementTextureCache.prototype;
$e815fda779bc047b$var$ETCp.reasons = $e815fda779bc047b$var$getTxrReasons;
// the list of textures in which new subtextures for elements can be placed
$e815fda779bc047b$var$ETCp.getTextureQueue = function(txrH) {
    var self1 = this;
    self1.eleImgCaches = self1.eleImgCaches || {};
    return self1.eleImgCaches[txrH] = self1.eleImgCaches[txrH] || [];
};
// the list of usused textures which can be recycled (in use in texture queue)
$e815fda779bc047b$var$ETCp.getRetiredTextureQueue = function(txrH) {
    var self1 = this;
    var rtxtrQs = self1.eleImgCaches.retired = self1.eleImgCaches.retired || {};
    var rtxtrQ = rtxtrQs[txrH] = rtxtrQs[txrH] || [];
    return rtxtrQ;
};
// queue of element draw requests at different scale levels
$e815fda779bc047b$var$ETCp.getElementQueue = function() {
    var self1 = this;
    var q = self1.eleCacheQueue = self1.eleCacheQueue || new $e815fda779bc047b$var$Heap(function(a, b) {
        return b.reqs - a.reqs;
    });
    return q;
};
// queue of element draw requests at different scale levels (element id lookup)
$e815fda779bc047b$var$ETCp.getElementKeyToQueue = function() {
    var self1 = this;
    var k2q = self1.eleKeyToCacheQueue = self1.eleKeyToCacheQueue || {};
    return k2q;
};
$e815fda779bc047b$var$ETCp.getElement = function(ele, bb, pxRatio, lvl, reason) {
    var self1 = this;
    var r = this.renderer;
    var zoom = r.cy.zoom();
    var lookup = this.lookup;
    if (!bb || bb.w === 0 || bb.h === 0 || isNaN(bb.w) || isNaN(bb.h) || !ele.visible() || ele.removed()) return null;
    if (!self1.allowEdgeTxrCaching && ele.isEdge() || !self1.allowParentTxrCaching && ele.isParent()) return null;
    if (lvl == null) lvl = Math.ceil($e815fda779bc047b$var$log2(zoom * pxRatio));
    if (lvl < $e815fda779bc047b$var$minLvl$1) lvl = $e815fda779bc047b$var$minLvl$1;
    else if (zoom >= $e815fda779bc047b$var$maxZoom$1 || lvl > $e815fda779bc047b$var$maxLvl$1) return null;
    var scale = Math.pow(2, lvl);
    var eleScaledH = bb.h * scale;
    var eleScaledW = bb.w * scale;
    var scaledLabelShown = r.eleTextBiggerThanMin(ele, scale);
    if (!this.isVisible(ele, scaledLabelShown)) return null;
    var eleCache = lookup.get(ele, lvl);
    // if this get was on an unused/invalidated cache, then restore the texture usage metric
    if (eleCache && eleCache.invalidated) {
        eleCache.invalidated = false;
        eleCache.texture.invalidatedWidth -= eleCache.width;
    }
    if (eleCache) return eleCache;
    var txrH; // which texture height this ele belongs to
    if (eleScaledH <= $e815fda779bc047b$var$minTxrH) txrH = $e815fda779bc047b$var$minTxrH;
    else if (eleScaledH <= $e815fda779bc047b$var$txrStepH) txrH = $e815fda779bc047b$var$txrStepH;
    else txrH = Math.ceil(eleScaledH / $e815fda779bc047b$var$txrStepH) * $e815fda779bc047b$var$txrStepH;
    if (eleScaledH > $e815fda779bc047b$var$maxTxrH || eleScaledW > $e815fda779bc047b$var$maxTxrW) return null; // caching large elements is not efficient
    var txrQ = self1.getTextureQueue(txrH);
    // first try the second last one in case it has space at the end
    var txr = txrQ[txrQ.length - 2];
    var addNewTxr = function addNewTxr() {
        return self1.recycleTexture(txrH, eleScaledW) || self1.addTexture(txrH, eleScaledW);
    };
    // try the last one if there is no second last one
    if (!txr) txr = txrQ[txrQ.length - 1];
    // if the last one doesn't exist, we need a first one
    if (!txr) txr = addNewTxr();
    // if there's no room in the current texture, we need a new one
    if (txr.width - txr.usedWidth < eleScaledW) txr = addNewTxr();
    var scalableFrom = function scalableFrom(otherCache) {
        return otherCache && otherCache.scaledLabelShown === scaledLabelShown;
    };
    var deqing = reason && reason === $e815fda779bc047b$var$getTxrReasons.dequeue;
    var highQualityReq = reason && reason === $e815fda779bc047b$var$getTxrReasons.highQuality;
    var downscaleReq = reason && reason === $e815fda779bc047b$var$getTxrReasons.downscale;
    var higherCache; // the nearest cache with a higher level
    for(var l = lvl + 1; l <= $e815fda779bc047b$var$maxLvl$1; l++){
        var c = lookup.get(ele, l);
        if (c) {
            higherCache = c;
            break;
        }
    }
    var oneUpCache = higherCache && higherCache.level === lvl + 1 ? higherCache : null;
    var downscale = function downscale() {
        txr.context.drawImage(oneUpCache.texture.canvas, oneUpCache.x, 0, oneUpCache.width, oneUpCache.height, txr.usedWidth, 0, eleScaledW, eleScaledH);
    };
    // reset ele area in texture
    txr.context.setTransform(1, 0, 0, 1, 0, 0);
    txr.context.clearRect(txr.usedWidth, 0, eleScaledW, txrH);
    if (scalableFrom(oneUpCache)) // then we can relatively cheaply rescale the existing image w/o rerendering
    downscale();
    else if (scalableFrom(higherCache)) {
        // then use the higher cache for now and queue the next level down
        // to cheaply scale towards the smaller level
        if (highQualityReq) {
            for(var _l = higherCache.level; _l > lvl; _l--)oneUpCache = self1.getElement(ele, bb, pxRatio, _l, $e815fda779bc047b$var$getTxrReasons.downscale);
            downscale();
        } else {
            self1.queueElement(ele, higherCache.level - 1);
            return higherCache;
        }
    } else {
        var lowerCache; // the nearest cache with a lower level
        if (!deqing && !highQualityReq && !downscaleReq) for(var _l2 = lvl - 1; _l2 >= $e815fda779bc047b$var$minLvl$1; _l2--){
            var _c = lookup.get(ele, _l2);
            if (_c) {
                lowerCache = _c;
                break;
            }
        }
        if (scalableFrom(lowerCache)) {
            // then use the lower quality cache for now and queue the better one for later
            self1.queueElement(ele, lvl);
            return lowerCache;
        }
        txr.context.translate(txr.usedWidth, 0);
        txr.context.scale(scale, scale);
        this.drawElement(txr.context, ele, bb, scaledLabelShown, false);
        txr.context.scale(1 / scale, 1 / scale);
        txr.context.translate(-txr.usedWidth, 0);
    }
    eleCache = {
        x: txr.usedWidth,
        texture: txr,
        level: lvl,
        scale: scale,
        width: eleScaledW,
        height: eleScaledH,
        scaledLabelShown: scaledLabelShown
    };
    txr.usedWidth += Math.ceil(eleScaledW + $e815fda779bc047b$var$eleTxrSpacing);
    txr.eleCaches.push(eleCache);
    lookup.set(ele, lvl, eleCache);
    self1.checkTextureFullness(txr);
    return eleCache;
};
$e815fda779bc047b$var$ETCp.invalidateElements = function(eles) {
    for(var i = 0; i < eles.length; i++)this.invalidateElement(eles[i]);
};
$e815fda779bc047b$var$ETCp.invalidateElement = function(ele) {
    var self1 = this;
    var lookup = self1.lookup;
    var caches = [];
    var invalid = lookup.isInvalid(ele);
    if (!invalid) return; // override the invalidation request if the element key has not changed
    for(var lvl = $e815fda779bc047b$var$minLvl$1; lvl <= $e815fda779bc047b$var$maxLvl$1; lvl++){
        var cache = lookup.getForCachedKey(ele, lvl);
        if (cache) caches.push(cache);
    }
    var noOtherElesUseCache = lookup.invalidate(ele);
    if (noOtherElesUseCache) for(var i = 0; i < caches.length; i++){
        var _cache = caches[i];
        var txr = _cache.texture;
        // remove space from the texture it belongs to
        txr.invalidatedWidth += _cache.width;
        // mark the cache as invalidated
        _cache.invalidated = true;
        // retire the texture if its utility is low
        self1.checkTextureUtility(txr);
    }
    // remove from queue since the old req was for the old state
    self1.removeFromQueue(ele);
};
$e815fda779bc047b$var$ETCp.checkTextureUtility = function(txr) {
    // invalidate all entries in the cache if the cache size is small
    if (txr.invalidatedWidth >= $e815fda779bc047b$var$minUtility * txr.width) this.retireTexture(txr);
};
$e815fda779bc047b$var$ETCp.checkTextureFullness = function(txr) {
    // if texture has been mostly filled and passed over several times, remove
    // it from the queue so we don't need to waste time looking at it to put new things
    var self1 = this;
    var txrQ = self1.getTextureQueue(txr.height);
    if (txr.usedWidth / txr.width > $e815fda779bc047b$var$maxFullness && txr.fullnessChecks >= $e815fda779bc047b$var$maxFullnessChecks) $e815fda779bc047b$var$removeFromArray(txrQ, txr);
    else txr.fullnessChecks++;
};
$e815fda779bc047b$var$ETCp.retireTexture = function(txr) {
    var self1 = this;
    var txrH = txr.height;
    var txrQ = self1.getTextureQueue(txrH);
    var lookup = this.lookup;
    // retire the texture from the active / searchable queue:
    $e815fda779bc047b$var$removeFromArray(txrQ, txr);
    txr.retired = true;
    // remove the refs from the eles to the caches:
    var eleCaches = txr.eleCaches;
    for(var i = 0; i < eleCaches.length; i++){
        var eleCache = eleCaches[i];
        lookup.deleteCache(eleCache.key, eleCache.level);
    }
    $e815fda779bc047b$var$clearArray(eleCaches);
    // add the texture to a retired queue so it can be recycled in future:
    var rtxtrQ = self1.getRetiredTextureQueue(txrH);
    rtxtrQ.push(txr);
};
$e815fda779bc047b$var$ETCp.addTexture = function(txrH, minW) {
    var self1 = this;
    var txrQ = self1.getTextureQueue(txrH);
    var txr = {};
    txrQ.push(txr);
    txr.eleCaches = [];
    txr.height = txrH;
    txr.width = Math.max($e815fda779bc047b$var$defTxrWidth, minW);
    txr.usedWidth = 0;
    txr.invalidatedWidth = 0;
    txr.fullnessChecks = 0;
    txr.canvas = self1.renderer.makeOffscreenCanvas(txr.width, txr.height);
    txr.context = txr.canvas.getContext('2d');
    return txr;
};
$e815fda779bc047b$var$ETCp.recycleTexture = function(txrH, minW) {
    var self1 = this;
    var txrQ = self1.getTextureQueue(txrH);
    var rtxtrQ = self1.getRetiredTextureQueue(txrH);
    for(var i = 0; i < rtxtrQ.length; i++){
        var txr = rtxtrQ[i];
        if (txr.width >= minW) {
            txr.retired = false;
            txr.usedWidth = 0;
            txr.invalidatedWidth = 0;
            txr.fullnessChecks = 0;
            $e815fda779bc047b$var$clearArray(txr.eleCaches);
            txr.context.setTransform(1, 0, 0, 1, 0, 0);
            txr.context.clearRect(0, 0, txr.width, txr.height);
            $e815fda779bc047b$var$removeFromArray(rtxtrQ, txr);
            txrQ.push(txr);
            return txr;
        }
    }
};
$e815fda779bc047b$var$ETCp.queueElement = function(ele, lvl) {
    var self1 = this;
    var q = self1.getElementQueue();
    var k2q = self1.getElementKeyToQueue();
    var key = this.getKey(ele);
    var existingReq = k2q[key];
    if (existingReq) {
        // use the max lvl b/c in between lvls are cheap to make
        existingReq.level = Math.max(existingReq.level, lvl);
        existingReq.eles.merge(ele);
        existingReq.reqs++;
        q.updateItem(existingReq);
    } else {
        var req = {
            eles: ele.spawn().merge(ele),
            level: lvl,
            reqs: 1,
            key: key
        };
        q.push(req);
        k2q[key] = req;
    }
};
$e815fda779bc047b$var$ETCp.dequeue = function(pxRatio /*, extent*/ ) {
    var self1 = this;
    var q = self1.getElementQueue();
    var k2q = self1.getElementKeyToQueue();
    var dequeued = [];
    var lookup = self1.lookup;
    for(var i = 0; i < $e815fda779bc047b$var$maxDeqSize$1; i++){
        if (q.size() > 0) {
            var req = q.pop();
            var key = req.key;
            var ele = req.eles[0]; // all eles have the same key
            var cacheExists = lookup.hasCache(ele, req.level);
            // clear out the key to req lookup
            k2q[key] = null;
            // dequeueing isn't necessary with an existing cache
            if (cacheExists) continue;
            dequeued.push(req);
            var bb = self1.getBoundingBox(ele);
            self1.getElement(ele, bb, pxRatio, req.level, $e815fda779bc047b$var$getTxrReasons.dequeue);
        } else break;
    }
    return dequeued;
};
$e815fda779bc047b$var$ETCp.removeFromQueue = function(ele) {
    var self1 = this;
    var q = self1.getElementQueue();
    var k2q = self1.getElementKeyToQueue();
    var key = this.getKey(ele);
    var req = k2q[key];
    if (req != null) {
        if (req.eles.length === 1) {
            // remove if last ele in the req
            // bring to front of queue
            req.reqs = $e815fda779bc047b$var$MAX_INT$1;
            q.updateItem(req);
            q.pop(); // remove from queue
            k2q[key] = null; // remove from lookup map
        } else // otherwise just remove ele from req
        req.eles.unmerge(ele);
    }
};
$e815fda779bc047b$var$ETCp.onDequeue = function(fn) {
    this.onDequeues.push(fn);
};
$e815fda779bc047b$var$ETCp.offDequeue = function(fn) {
    $e815fda779bc047b$var$removeFromArray(this.onDequeues, fn);
};
$e815fda779bc047b$var$ETCp.setupDequeueing = $e815fda779bc047b$var$defs.setupDequeueing({
    deqRedrawThreshold: $e815fda779bc047b$var$deqRedrawThreshold$1,
    deqCost: $e815fda779bc047b$var$deqCost$1,
    deqAvgCost: $e815fda779bc047b$var$deqAvgCost$1,
    deqNoDrawCost: $e815fda779bc047b$var$deqNoDrawCost$1,
    deqFastCost: $e815fda779bc047b$var$deqFastCost$1,
    deq: function deq(self1, pxRatio, extent) {
        return self1.dequeue(pxRatio, extent);
    },
    onDeqd: function onDeqd(self1, deqd) {
        for(var i = 0; i < self1.onDequeues.length; i++){
            var fn = self1.onDequeues[i];
            fn(deqd);
        }
    },
    shouldRedraw: function shouldRedraw(self1, deqd, pxRatio, extent) {
        for(var i = 0; i < deqd.length; i++){
            var eles = deqd[i].eles;
            for(var j = 0; j < eles.length; j++){
                var bb = eles[j].boundingBox();
                if ($e815fda779bc047b$var$boundingBoxesIntersect(bb, extent)) return true;
            }
        }
        return false;
    },
    priority: function priority(self1) {
        return self1.renderer.beforeRenderPriorities.eleTxrDeq;
    }
});
var $e815fda779bc047b$var$defNumLayers = 1; // default number of layers to use
var $e815fda779bc047b$var$minLvl = -4; // when scaling smaller than that we don't need to re-render
var $e815fda779bc047b$var$maxLvl = 2; // when larger than this scale just render directly (caching is not helpful)
var $e815fda779bc047b$var$maxZoom = 3.99; // beyond this zoom level, layered textures are not used
var $e815fda779bc047b$var$deqRedrawThreshold = 50; // time to batch redraws together from dequeueing to allow more dequeueing calcs to happen in the meanwhile
var $e815fda779bc047b$var$refineEleDebounceTime = 50; // time to debounce sharper ele texture updates
var $e815fda779bc047b$var$deqCost = 0.15; // % of add'l rendering cost allowed for dequeuing ele caches each frame
var $e815fda779bc047b$var$deqAvgCost = 0.1; // % of add'l rendering cost compared to average overall redraw time
var $e815fda779bc047b$var$deqNoDrawCost = 0.9; // % of avg frame time that can be used for dequeueing when not drawing
var $e815fda779bc047b$var$deqFastCost = 0.9; // % of frame time to be used when >60fps
var $e815fda779bc047b$var$maxDeqSize = 1; // number of eles to dequeue and render at higher texture in each batch
var $e815fda779bc047b$var$invalidThreshold = 250; // time threshold for disabling b/c of invalidations
var $e815fda779bc047b$var$maxLayerArea = 16000000; // layers can't be bigger than this
var $e815fda779bc047b$var$maxLayerDim = 32767; // maximum size for the width/height of layer canvases
var $e815fda779bc047b$var$useHighQualityEleTxrReqs = true; // whether to use high quality ele txr requests (generally faster and cheaper in the longterm)
// var log = function(){ console.log.apply( console, arguments ); };
var $e815fda779bc047b$var$LayeredTextureCache = function LayeredTextureCache(renderer) {
    var self1 = this;
    var r = self1.renderer = renderer;
    var cy = r.cy;
    self1.layersByLevel = {}; // e.g. 2 => [ layer1, layer2, ..., layerN ]
    self1.firstGet = true;
    self1.lastInvalidationTime = $e815fda779bc047b$var$performanceNow() - 2 * $e815fda779bc047b$var$invalidThreshold;
    self1.skipping = false;
    self1.eleTxrDeqs = cy.collection();
    self1.scheduleElementRefinement = $e815fda779bc047b$var$debounce(function() {
        self1.refineElementTextures(self1.eleTxrDeqs);
        self1.eleTxrDeqs.unmerge(self1.eleTxrDeqs);
    }, $e815fda779bc047b$var$refineEleDebounceTime);
    r.beforeRender(function(willDraw, now) {
        if (now - self1.lastInvalidationTime <= $e815fda779bc047b$var$invalidThreshold) self1.skipping = true;
        else self1.skipping = false;
    }, r.beforeRenderPriorities.lyrTxrSkip);
    var qSort = function qSort(a, b) {
        return b.reqs - a.reqs;
    };
    self1.layersQueue = new $e815fda779bc047b$var$Heap(qSort);
    self1.setupDequeueing();
};
var $e815fda779bc047b$var$LTCp = $e815fda779bc047b$var$LayeredTextureCache.prototype;
var $e815fda779bc047b$var$layerIdPool = 0;
var $e815fda779bc047b$var$MAX_INT = Math.pow(2, 53) - 1;
$e815fda779bc047b$var$LTCp.makeLayer = function(bb, lvl) {
    var scale = Math.pow(2, lvl);
    var w = Math.ceil(bb.w * scale);
    var h = Math.ceil(bb.h * scale);
    var canvas = this.renderer.makeOffscreenCanvas(w, h);
    var layer = {
        id: $e815fda779bc047b$var$layerIdPool = ++$e815fda779bc047b$var$layerIdPool % $e815fda779bc047b$var$MAX_INT,
        bb: bb,
        level: lvl,
        width: w,
        height: h,
        canvas: canvas,
        context: canvas.getContext('2d'),
        eles: [],
        elesQueue: [],
        reqs: 0
    };
    // log('make layer %s with w %s and h %s and lvl %s', layer.id, layer.width, layer.height, layer.level);
    var cxt = layer.context;
    var dx = -layer.bb.x1;
    var dy = -layer.bb.y1;
    // do the transform on creation to save cycles (it's the same for all eles)
    cxt.scale(scale, scale);
    cxt.translate(dx, dy);
    return layer;
};
$e815fda779bc047b$var$LTCp.getLayers = function(eles, pxRatio, lvl) {
    var self1 = this;
    var r = self1.renderer;
    var cy = r.cy;
    var zoom = cy.zoom();
    var firstGet = self1.firstGet;
    self1.firstGet = false;
    // log('--\nget layers with %s eles', eles.length);
    //log eles.map(function(ele){ return ele.id() }) );
    if (lvl == null) {
        lvl = Math.ceil($e815fda779bc047b$var$log2(zoom * pxRatio));
        if (lvl < $e815fda779bc047b$var$minLvl) lvl = $e815fda779bc047b$var$minLvl;
        else if (zoom >= $e815fda779bc047b$var$maxZoom || lvl > $e815fda779bc047b$var$maxLvl) return null;
    }
    self1.validateLayersElesOrdering(lvl, eles);
    var layersByLvl = self1.layersByLevel;
    var scale = Math.pow(2, lvl);
    var layers = layersByLvl[lvl] = layersByLvl[lvl] || [];
    var bb;
    var lvlComplete = self1.levelIsComplete(lvl, eles);
    var tmpLayers;
    var checkTempLevels = function checkTempLevels() {
        var canUseAsTmpLvl = function canUseAsTmpLvl(l) {
            self1.validateLayersElesOrdering(l, eles);
            if (self1.levelIsComplete(l, eles)) {
                tmpLayers = layersByLvl[l];
                return true;
            }
        };
        var checkLvls = function checkLvls(dir) {
            if (tmpLayers) return;
            for(var l = lvl + dir; $e815fda779bc047b$var$minLvl <= l && l <= $e815fda779bc047b$var$maxLvl; l += dir){
                if (canUseAsTmpLvl(l)) break;
            }
        };
        checkLvls(1);
        checkLvls(-1);
        // remove the invalid layers; they will be replaced as needed later in this function
        for(var i = layers.length - 1; i >= 0; i--){
            var layer = layers[i];
            if (layer.invalid) $e815fda779bc047b$var$removeFromArray(layers, layer);
        }
    };
    if (!lvlComplete) // if the current level is incomplete, then use the closest, best quality layerset temporarily
    // and later queue the current layerset so we can get the proper quality level soon
    checkTempLevels();
    else // log('level complete, using existing layers\n--');
    return layers;
    var getBb = function getBb() {
        if (!bb) {
            bb = $e815fda779bc047b$var$makeBoundingBox();
            for(var i = 0; i < eles.length; i++)$e815fda779bc047b$var$updateBoundingBox(bb, eles[i].boundingBox());
        }
        return bb;
    };
    var makeLayer = function makeLayer(opts) {
        opts = opts || {};
        var after = opts.after;
        getBb();
        var w = Math.ceil(bb.w * scale);
        var h = Math.ceil(bb.h * scale);
        if (w > $e815fda779bc047b$var$maxLayerDim || h > $e815fda779bc047b$var$maxLayerDim) return null;
        var area = w * h;
        if (area > $e815fda779bc047b$var$maxLayerArea) return null;
        var layer = self1.makeLayer(bb, lvl);
        if (after != null) {
            var index = layers.indexOf(after) + 1;
            layers.splice(index, 0, layer);
        } else if (opts.insert === undefined || opts.insert) // no after specified => first layer made so put at start
        layers.unshift(layer);
        // if( tmpLayers ){
        //self.queueLayer( layer );
        // }
        return layer;
    };
    if (self1.skipping && !firstGet) // log('skip layers');
    return null;
    // log('do layers');
    var layer = null;
    var maxElesPerLayer = eles.length / $e815fda779bc047b$var$defNumLayers;
    var allowLazyQueueing = !firstGet;
    for(var i = 0; i < eles.length; i++){
        var ele = eles[i];
        var rs = ele._private.rscratch;
        var caches = rs.imgLayerCaches = rs.imgLayerCaches || {};
        // log('look at ele', ele.id());
        var existingLayer = caches[lvl];
        if (existingLayer) {
            // reuse layer for later eles
            // log('reuse layer for', ele.id());
            layer = existingLayer;
            continue;
        }
        if (!layer || layer.eles.length >= maxElesPerLayer || !$e815fda779bc047b$var$boundingBoxInBoundingBox(layer.bb, ele.boundingBox())) {
            // log('make new layer for ele %s', ele.id());
            layer = makeLayer({
                insert: true,
                after: layer
            });
            // if now layer can be built then we can't use layers at this level
            if (!layer) return null;
        // log('new layer with id %s', layer.id);
        }
        if (tmpLayers || allowLazyQueueing) // log('queue ele %s in layer %s', ele.id(), layer.id);
        self1.queueLayer(layer, ele);
        else // log('draw ele %s in layer %s', ele.id(), layer.id);
        self1.drawEleInLayer(layer, ele, lvl, pxRatio);
        layer.eles.push(ele);
        caches[lvl] = layer;
    }
    // log('--');
    if (tmpLayers) // then we only queued the current layerset and can't draw it yet
    return tmpLayers;
    if (allowLazyQueueing) // log('lazy queue level', lvl);
    return null;
    return layers;
};
// a layer may want to use an ele cache of a higher level to avoid blurriness
// so the layer level might not equal the ele level
$e815fda779bc047b$var$LTCp.getEleLevelForLayerLevel = function(lvl, pxRatio) {
    return lvl;
};
$e815fda779bc047b$var$LTCp.drawEleInLayer = function(layer, ele, lvl, pxRatio) {
    var self1 = this;
    var r = this.renderer;
    var context = layer.context;
    var bb = ele.boundingBox();
    if (bb.w === 0 || bb.h === 0 || !ele.visible()) return;
    lvl = self1.getEleLevelForLayerLevel(lvl, pxRatio);
    r.setImgSmoothing(context, false);
    r.drawCachedElement(context, ele, null, null, lvl, $e815fda779bc047b$var$useHighQualityEleTxrReqs);
    r.setImgSmoothing(context, true);
};
$e815fda779bc047b$var$LTCp.levelIsComplete = function(lvl, eles) {
    var self1 = this;
    var layers = self1.layersByLevel[lvl];
    if (!layers || layers.length === 0) return false;
    var numElesInLayers = 0;
    for(var i = 0; i < layers.length; i++){
        var layer = layers[i];
        // if there are any eles needed to be drawn yet, the level is not complete
        if (layer.reqs > 0) return false;
        // if the layer is invalid, the level is not complete
        if (layer.invalid) return false;
        numElesInLayers += layer.eles.length;
    }
    // we should have exactly the number of eles passed in to be complete
    if (numElesInLayers !== eles.length) return false;
    return true;
};
$e815fda779bc047b$var$LTCp.validateLayersElesOrdering = function(lvl, eles) {
    var layers = this.layersByLevel[lvl];
    if (!layers) return;
    // if in a layer the eles are not in the same order, then the layer is invalid
    // (i.e. there is an ele in between the eles in the layer)
    for(var i = 0; i < layers.length; i++){
        var layer = layers[i];
        var offset = -1;
        // find the offset
        for(var j = 0; j < eles.length; j++)if (layer.eles[0] === eles[j]) {
            offset = j;
            break;
        }
        if (offset < 0) {
            // then the layer has nonexistent elements and is invalid
            this.invalidateLayer(layer);
            continue;
        }
        // the eles in the layer must be in the same continuous order, else the layer is invalid
        var o = offset;
        for(var j = 0; j < layer.eles.length; j++)if (layer.eles[j] !== eles[o + j]) {
            // log('invalidate based on ordering', layer.id);
            this.invalidateLayer(layer);
            break;
        }
    }
};
$e815fda779bc047b$var$LTCp.updateElementsInLayers = function(eles, update) {
    var self1 = this;
    var isEles = $e815fda779bc047b$var$element(eles[0]);
    // collect udpated elements (cascaded from the layers) and update each
    // layer itself along the way
    for(var i = 0; i < eles.length; i++){
        var req = isEles ? null : eles[i];
        var ele = isEles ? eles[i] : eles[i].ele;
        var rs = ele._private.rscratch;
        var caches = rs.imgLayerCaches = rs.imgLayerCaches || {};
        for(var l = $e815fda779bc047b$var$minLvl; l <= $e815fda779bc047b$var$maxLvl; l++){
            var layer = caches[l];
            if (!layer) continue;
            // if update is a request from the ele cache, then it affects only
            // the matching level
            if (req && self1.getEleLevelForLayerLevel(layer.level) !== req.level) continue;
            update(layer, ele, req);
        }
    }
};
$e815fda779bc047b$var$LTCp.haveLayers = function() {
    var self1 = this;
    var haveLayers = false;
    for(var l = $e815fda779bc047b$var$minLvl; l <= $e815fda779bc047b$var$maxLvl; l++){
        var layers = self1.layersByLevel[l];
        if (layers && layers.length > 0) {
            haveLayers = true;
            break;
        }
    }
    return haveLayers;
};
$e815fda779bc047b$var$LTCp.invalidateElements = function(eles) {
    var self1 = this;
    if (eles.length === 0) return;
    self1.lastInvalidationTime = $e815fda779bc047b$var$performanceNow();
    // log('update invalidate layer time from eles');
    if (eles.length === 0 || !self1.haveLayers()) return;
    self1.updateElementsInLayers(eles, function invalAssocLayers(layer, ele, req) {
        self1.invalidateLayer(layer);
    });
};
$e815fda779bc047b$var$LTCp.invalidateLayer = function(layer) {
    // log('update invalidate layer time');
    this.lastInvalidationTime = $e815fda779bc047b$var$performanceNow();
    if (layer.invalid) return;
     // save cycles
    var lvl = layer.level;
    var eles = layer.eles;
    var layers = this.layersByLevel[lvl];
    // log('invalidate layer', layer.id );
    $e815fda779bc047b$var$removeFromArray(layers, layer);
    // layer.eles = [];
    layer.elesQueue = [];
    layer.invalid = true;
    if (layer.replacement) layer.replacement.invalid = true;
    for(var i = 0; i < eles.length; i++){
        var caches = eles[i]._private.rscratch.imgLayerCaches;
        if (caches) caches[lvl] = null;
    }
};
$e815fda779bc047b$var$LTCp.refineElementTextures = function(eles) {
    var self1 = this;
    // log('refine', eles.length);
    self1.updateElementsInLayers(eles, function refineEachEle(layer, ele, req) {
        var rLyr = layer.replacement;
        if (!rLyr) {
            rLyr = layer.replacement = self1.makeLayer(layer.bb, layer.level);
            rLyr.replaces = layer;
            rLyr.eles = layer.eles;
        // log('make replacement layer %s for %s with level %s', rLyr.id, layer.id, rLyr.level);
        }
        if (!rLyr.reqs) for(var i = 0; i < rLyr.eles.length; i++)self1.queueLayer(rLyr, rLyr.eles[i]);
    });
};
$e815fda779bc047b$var$LTCp.enqueueElementRefinement = function(ele) {
    this.eleTxrDeqs.merge(ele);
    this.scheduleElementRefinement();
};
$e815fda779bc047b$var$LTCp.queueLayer = function(layer, ele) {
    var self1 = this;
    var q = self1.layersQueue;
    var elesQ = layer.elesQueue;
    var hasId = elesQ.hasId = elesQ.hasId || {};
    // if a layer is going to be replaced, queuing is a waste of time
    if (layer.replacement) return;
    if (ele) {
        if (hasId[ele.id()]) return;
        elesQ.push(ele);
        hasId[ele.id()] = true;
    }
    if (layer.reqs) {
        layer.reqs++;
        q.updateItem(layer);
    } else {
        layer.reqs = 1;
        q.push(layer);
    }
};
$e815fda779bc047b$var$LTCp.dequeue = function(pxRatio) {
    var self1 = this;
    var q = self1.layersQueue;
    var deqd = [];
    var eleDeqs = 0;
    while(eleDeqs < $e815fda779bc047b$var$maxDeqSize){
        if (q.size() === 0) break;
        var layer = q.peek();
        // if a layer has been or will be replaced, then don't waste time with it
        if (layer.replacement) {
            // log('layer %s in queue skipped b/c it already has a replacement', layer.id);
            q.pop();
            continue;
        }
        // if this is a replacement layer that has been superceded, then forget it
        if (layer.replaces && layer !== layer.replaces.replacement) {
            // log('layer is no longer the most uptodate replacement; dequeued', layer.id)
            q.pop();
            continue;
        }
        if (layer.invalid) {
            // log('replacement layer %s is invalid; dequeued', layer.id);
            q.pop();
            continue;
        }
        var ele = layer.elesQueue.shift();
        if (ele) {
            // log('dequeue layer %s', layer.id);
            self1.drawEleInLayer(layer, ele, layer.level, pxRatio);
            eleDeqs++;
        }
        if (deqd.length === 0) // we need only one entry in deqd to queue redrawing etc
        deqd.push(true);
        // if the layer has all its eles done, then remove from the queue
        if (layer.elesQueue.length === 0) {
            q.pop();
            layer.reqs = 0;
            // log('dequeue of layer %s complete', layer.id);
            // when a replacement layer is dequeued, it replaces the old layer in the level
            if (layer.replaces) self1.applyLayerReplacement(layer);
            self1.requestRedraw();
        }
    }
    return deqd;
};
$e815fda779bc047b$var$LTCp.applyLayerReplacement = function(layer) {
    var self1 = this;
    var layersInLevel = self1.layersByLevel[layer.level];
    var replaced = layer.replaces;
    var index = layersInLevel.indexOf(replaced);
    // if the replaced layer is not in the active list for the level, then replacing
    // refs would be a mistake (i.e. overwriting the true active layer)
    if (index < 0 || replaced.invalid) // log('replacement layer would have no effect', layer.id);
    return;
    layersInLevel[index] = layer; // replace level ref
    // replace refs in eles
    for(var i = 0; i < layer.eles.length; i++){
        var _p = layer.eles[i]._private;
        var cache = _p.imgLayerCaches = _p.imgLayerCaches || {};
        if (cache) cache[layer.level] = layer;
    }
    // log('apply replacement layer %s over %s', layer.id, replaced.id);
    self1.requestRedraw();
};
$e815fda779bc047b$var$LTCp.requestRedraw = $e815fda779bc047b$var$debounce(function() {
    var r = this.renderer;
    r.redrawHint('eles', true);
    r.redrawHint('drag', true);
    r.redraw();
}, 100);
$e815fda779bc047b$var$LTCp.setupDequeueing = $e815fda779bc047b$var$defs.setupDequeueing({
    deqRedrawThreshold: $e815fda779bc047b$var$deqRedrawThreshold,
    deqCost: $e815fda779bc047b$var$deqCost,
    deqAvgCost: $e815fda779bc047b$var$deqAvgCost,
    deqNoDrawCost: $e815fda779bc047b$var$deqNoDrawCost,
    deqFastCost: $e815fda779bc047b$var$deqFastCost,
    deq: function deq(self1, pxRatio) {
        return self1.dequeue(pxRatio);
    },
    onDeqd: $e815fda779bc047b$var$noop$1,
    shouldRedraw: $e815fda779bc047b$var$trueify,
    priority: function priority(self1) {
        return self1.renderer.beforeRenderPriorities.lyrTxrDeq;
    }
});
var $e815fda779bc047b$var$CRp$b = {};
var $e815fda779bc047b$var$impl;
function $e815fda779bc047b$var$polygon(context, points) {
    for(var i = 0; i < points.length; i++){
        var pt = points[i];
        context.lineTo(pt.x, pt.y);
    }
}
function $e815fda779bc047b$var$triangleBackcurve(context, points, controlPoint) {
    var firstPt;
    for(var i = 0; i < points.length; i++){
        var pt = points[i];
        if (i === 0) firstPt = pt;
        context.lineTo(pt.x, pt.y);
    }
    context.quadraticCurveTo(controlPoint.x, controlPoint.y, firstPt.x, firstPt.y);
}
function $e815fda779bc047b$var$triangleTee(context, trianglePoints, teePoints) {
    if (context.beginPath) context.beginPath();
    var triPts = trianglePoints;
    for(var i = 0; i < triPts.length; i++){
        var pt = triPts[i];
        context.lineTo(pt.x, pt.y);
    }
    var teePts = teePoints;
    var firstTeePt = teePoints[0];
    context.moveTo(firstTeePt.x, firstTeePt.y);
    for(var i = 1; i < teePts.length; i++){
        var pt = teePts[i];
        context.lineTo(pt.x, pt.y);
    }
    if (context.closePath) context.closePath();
}
function $e815fda779bc047b$var$circleTriangle(context, trianglePoints, rx, ry, r) {
    if (context.beginPath) context.beginPath();
    context.arc(rx, ry, r, 0, Math.PI * 2, false);
    var triPts = trianglePoints;
    var firstTrPt = triPts[0];
    context.moveTo(firstTrPt.x, firstTrPt.y);
    for(var i = 0; i < triPts.length; i++){
        var pt = triPts[i];
        context.lineTo(pt.x, pt.y);
    }
    if (context.closePath) context.closePath();
}
function $e815fda779bc047b$var$circle$1(context, rx, ry, r) {
    context.arc(rx, ry, r, 0, Math.PI * 2, false);
}
$e815fda779bc047b$var$CRp$b.arrowShapeImpl = function(name) {
    return ($e815fda779bc047b$var$impl || ($e815fda779bc047b$var$impl = {
        'polygon': $e815fda779bc047b$var$polygon,
        'triangle-backcurve': $e815fda779bc047b$var$triangleBackcurve,
        'triangle-tee': $e815fda779bc047b$var$triangleTee,
        'circle-triangle': $e815fda779bc047b$var$circleTriangle,
        'triangle-cross': $e815fda779bc047b$var$triangleTee,
        'circle': $e815fda779bc047b$var$circle$1
    }))[name];
};
var $e815fda779bc047b$var$CRp$a = {};
$e815fda779bc047b$var$CRp$a.drawElement = function(context, ele, shiftToOriginWithBb, showLabel, showOverlay, showOpacity) {
    var r = this;
    if (ele.isNode()) r.drawNode(context, ele, shiftToOriginWithBb, showLabel, showOverlay, showOpacity);
    else r.drawEdge(context, ele, shiftToOriginWithBb, showLabel, showOverlay, showOpacity);
};
$e815fda779bc047b$var$CRp$a.drawElementOverlay = function(context, ele) {
    var r = this;
    if (ele.isNode()) r.drawNodeOverlay(context, ele);
    else r.drawEdgeOverlay(context, ele);
};
$e815fda779bc047b$var$CRp$a.drawElementUnderlay = function(context, ele) {
    var r = this;
    if (ele.isNode()) r.drawNodeUnderlay(context, ele);
    else r.drawEdgeUnderlay(context, ele);
};
$e815fda779bc047b$var$CRp$a.drawCachedElementPortion = function(context, ele, eleTxrCache, pxRatio, lvl, reason, getRotation, getOpacity) {
    var r = this;
    var bb = eleTxrCache.getBoundingBox(ele);
    if (bb.w === 0 || bb.h === 0) return;
     // ignore zero size case
    var eleCache = eleTxrCache.getElement(ele, bb, pxRatio, lvl, reason);
    if (eleCache != null) {
        var opacity = getOpacity(r, ele);
        if (opacity === 0) return;
        var theta = getRotation(r, ele);
        var x1 = bb.x1, y1 = bb.y1, w = bb.w, h = bb.h;
        var x, y, sx, sy, smooth;
        if (theta !== 0) {
            var rotPt = eleTxrCache.getRotationPoint(ele);
            sx = rotPt.x;
            sy = rotPt.y;
            context.translate(sx, sy);
            context.rotate(theta);
            smooth = r.getImgSmoothing(context);
            if (!smooth) r.setImgSmoothing(context, true);
            var off = eleTxrCache.getRotationOffset(ele);
            x = off.x;
            y = off.y;
        } else {
            x = x1;
            y = y1;
        }
        var oldGlobalAlpha;
        if (opacity !== 1) {
            oldGlobalAlpha = context.globalAlpha;
            context.globalAlpha = oldGlobalAlpha * opacity;
        }
        context.drawImage(eleCache.texture.canvas, eleCache.x, 0, eleCache.width, eleCache.height, x, y, w, h);
        if (opacity !== 1) context.globalAlpha = oldGlobalAlpha;
        if (theta !== 0) {
            context.rotate(-theta);
            context.translate(-sx, -sy);
            if (!smooth) r.setImgSmoothing(context, false);
        }
    } else eleTxrCache.drawElement(context, ele); // direct draw fallback
};
var $e815fda779bc047b$var$getZeroRotation = function getZeroRotation() {
    return 0;
};
var $e815fda779bc047b$var$getLabelRotation = function getLabelRotation(r, ele) {
    return r.getTextAngle(ele, null);
};
var $e815fda779bc047b$var$getSourceLabelRotation = function getSourceLabelRotation(r, ele) {
    return r.getTextAngle(ele, 'source');
};
var $e815fda779bc047b$var$getTargetLabelRotation = function getTargetLabelRotation(r, ele) {
    return r.getTextAngle(ele, 'target');
};
var $e815fda779bc047b$var$getOpacity = function getOpacity(r, ele) {
    return ele.effectiveOpacity();
};
var $e815fda779bc047b$var$getTextOpacity = function getTextOpacity(e, ele) {
    return ele.pstyle('text-opacity').pfValue * ele.effectiveOpacity();
};
$e815fda779bc047b$var$CRp$a.drawCachedElement = function(context, ele, pxRatio, extent, lvl, requestHighQuality) {
    var r = this;
    var _r$data = r.data, eleTxrCache = _r$data.eleTxrCache, lblTxrCache = _r$data.lblTxrCache, slbTxrCache = _r$data.slbTxrCache, tlbTxrCache = _r$data.tlbTxrCache;
    var bb = ele.boundingBox();
    var reason = requestHighQuality === true ? eleTxrCache.reasons.highQuality : null;
    if (bb.w === 0 || bb.h === 0 || !ele.visible()) return;
    if (!extent || $e815fda779bc047b$var$boundingBoxesIntersect(bb, extent)) {
        var isEdge = ele.isEdge();
        var badLine = ele.element()._private.rscratch.badLine;
        r.drawElementUnderlay(context, ele);
        r.drawCachedElementPortion(context, ele, eleTxrCache, pxRatio, lvl, reason, $e815fda779bc047b$var$getZeroRotation, $e815fda779bc047b$var$getOpacity);
        if (!isEdge || !badLine) r.drawCachedElementPortion(context, ele, lblTxrCache, pxRatio, lvl, reason, $e815fda779bc047b$var$getLabelRotation, $e815fda779bc047b$var$getTextOpacity);
        if (isEdge && !badLine) {
            r.drawCachedElementPortion(context, ele, slbTxrCache, pxRatio, lvl, reason, $e815fda779bc047b$var$getSourceLabelRotation, $e815fda779bc047b$var$getTextOpacity);
            r.drawCachedElementPortion(context, ele, tlbTxrCache, pxRatio, lvl, reason, $e815fda779bc047b$var$getTargetLabelRotation, $e815fda779bc047b$var$getTextOpacity);
        }
        r.drawElementOverlay(context, ele);
    }
};
$e815fda779bc047b$var$CRp$a.drawElements = function(context, eles) {
    var r = this;
    for(var i = 0; i < eles.length; i++){
        var ele = eles[i];
        r.drawElement(context, ele);
    }
};
$e815fda779bc047b$var$CRp$a.drawCachedElements = function(context, eles, pxRatio, extent) {
    var r = this;
    for(var i = 0; i < eles.length; i++){
        var ele = eles[i];
        r.drawCachedElement(context, ele, pxRatio, extent);
    }
};
$e815fda779bc047b$var$CRp$a.drawCachedNodes = function(context, eles, pxRatio, extent) {
    var r = this;
    for(var i = 0; i < eles.length; i++){
        var ele = eles[i];
        if (!ele.isNode()) continue;
        r.drawCachedElement(context, ele, pxRatio, extent);
    }
};
$e815fda779bc047b$var$CRp$a.drawLayeredElements = function(context, eles, pxRatio, extent) {
    var r = this;
    var layers = r.data.lyrTxrCache.getLayers(eles, pxRatio);
    if (layers) for(var i = 0; i < layers.length; i++){
        var layer = layers[i];
        var bb = layer.bb;
        if (bb.w === 0 || bb.h === 0) continue;
        context.drawImage(layer.canvas, bb.x1, bb.y1, bb.w, bb.h);
    }
    else // fall back on plain caching if no layers
    r.drawCachedElements(context, eles, pxRatio, extent);
};
var $e815fda779bc047b$var$CRp$9 = {};
$e815fda779bc047b$var$CRp$9.drawEdge = function(context, edge, shiftToOriginWithBb) {
    var drawLabel = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
    var shouldDrawOverlay = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
    var shouldDrawOpacity = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : true;
    var r = this;
    var rs = edge._private.rscratch;
    if (shouldDrawOpacity && !edge.visible()) return;
    // if bezier ctrl pts can not be calculated, then die
    if (rs.badLine || rs.allpts == null || isNaN(rs.allpts[0])) // isNaN in case edge is impossible and browser bugs (e.g. safari)
    return;
    var bb;
    if (shiftToOriginWithBb) {
        bb = shiftToOriginWithBb;
        context.translate(-bb.x1, -bb.y1);
    }
    var opacity = shouldDrawOpacity ? edge.pstyle('opacity').value : 1;
    var lineOpacity = shouldDrawOpacity ? edge.pstyle('line-opacity').value : 1;
    var curveStyle = edge.pstyle('curve-style').value;
    var lineStyle = edge.pstyle('line-style').value;
    var edgeWidth = edge.pstyle('width').pfValue;
    var lineCap = edge.pstyle('line-cap').value;
    var lineOutlineWidth = edge.pstyle('line-outline-width').value;
    var lineOutlineColor = edge.pstyle('line-outline-color').value;
    var effectiveLineOpacity = opacity * lineOpacity;
    // separate arrow opacity would require arrow-opacity property
    var effectiveArrowOpacity = opacity * lineOpacity;
    var drawLine = function drawLine() {
        var strokeOpacity = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : effectiveLineOpacity;
        if (curveStyle === 'straight-triangle') {
            r.eleStrokeStyle(context, edge, strokeOpacity);
            r.drawEdgeTrianglePath(edge, context, rs.allpts);
        } else {
            context.lineWidth = edgeWidth;
            context.lineCap = lineCap;
            r.eleStrokeStyle(context, edge, strokeOpacity);
            r.drawEdgePath(edge, context, rs.allpts, lineStyle);
            context.lineCap = 'butt'; // reset for other drawing functions
        }
    };
    var drawLineOutline = function drawLineOutline() {
        var strokeOpacity = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : effectiveLineOpacity;
        context.lineWidth = edgeWidth + lineOutlineWidth;
        context.lineCap = lineCap;
        if (lineOutlineWidth > 0) r.colorStrokeStyle(context, lineOutlineColor[0], lineOutlineColor[1], lineOutlineColor[2], strokeOpacity);
        else {
            // do not draw any lineOutline
            context.lineCap = 'butt'; // reset for other drawing functions
            return;
        }
        if (curveStyle === 'straight-triangle') r.drawEdgeTrianglePath(edge, context, rs.allpts);
        else {
            r.drawEdgePath(edge, context, rs.allpts, lineStyle);
            context.lineCap = 'butt'; // reset for other drawing functions
        }
    };
    var drawOverlay = function drawOverlay() {
        if (!shouldDrawOverlay) return;
        r.drawEdgeOverlay(context, edge);
    };
    var drawUnderlay = function drawUnderlay() {
        if (!shouldDrawOverlay) return;
        r.drawEdgeUnderlay(context, edge);
    };
    var drawArrows = function drawArrows() {
        var arrowOpacity = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : effectiveArrowOpacity;
        r.drawArrowheads(context, edge, arrowOpacity);
    };
    var drawText = function drawText() {
        r.drawElementText(context, edge, null, drawLabel);
    };
    context.lineJoin = 'round';
    var ghost = edge.pstyle('ghost').value === 'yes';
    if (ghost) {
        var gx = edge.pstyle('ghost-offset-x').pfValue;
        var gy = edge.pstyle('ghost-offset-y').pfValue;
        var ghostOpacity = edge.pstyle('ghost-opacity').value;
        var effectiveGhostOpacity = effectiveLineOpacity * ghostOpacity;
        context.translate(gx, gy);
        drawLine(effectiveGhostOpacity);
        drawArrows(effectiveGhostOpacity);
        context.translate(-gx, -gy);
    } else drawLineOutline();
    drawUnderlay();
    drawLine();
    drawArrows();
    drawOverlay();
    drawText();
    if (shiftToOriginWithBb) context.translate(bb.x1, bb.y1);
};
var $e815fda779bc047b$var$drawEdgeOverlayUnderlay = function drawEdgeOverlayUnderlay(overlayOrUnderlay) {
    if (![
        'overlay',
        'underlay'
    ].includes(overlayOrUnderlay)) throw new Error('Invalid state');
    return function(context, edge) {
        if (!edge.visible()) return;
        var opacity = edge.pstyle("".concat(overlayOrUnderlay, "-opacity")).value;
        if (opacity === 0) return;
        var r = this;
        var usePaths = r.usePaths();
        var rs = edge._private.rscratch;
        var padding = edge.pstyle("".concat(overlayOrUnderlay, "-padding")).pfValue;
        var width = 2 * padding;
        var color = edge.pstyle("".concat(overlayOrUnderlay, "-color")).value;
        context.lineWidth = width;
        if (rs.edgeType === 'self' && !usePaths) context.lineCap = 'butt';
        else context.lineCap = 'round';
        r.colorStrokeStyle(context, color[0], color[1], color[2], opacity);
        r.drawEdgePath(edge, context, rs.allpts, 'solid');
    };
};
$e815fda779bc047b$var$CRp$9.drawEdgeOverlay = $e815fda779bc047b$var$drawEdgeOverlayUnderlay('overlay');
$e815fda779bc047b$var$CRp$9.drawEdgeUnderlay = $e815fda779bc047b$var$drawEdgeOverlayUnderlay('underlay');
$e815fda779bc047b$var$CRp$9.drawEdgePath = function(edge, context, pts, type) {
    var rs = edge._private.rscratch;
    var canvasCxt = context;
    var path;
    var pathCacheHit = false;
    var usePaths = this.usePaths();
    var lineDashPattern = edge.pstyle('line-dash-pattern').pfValue;
    var lineDashOffset = edge.pstyle('line-dash-offset').pfValue;
    if (usePaths) {
        var pathCacheKey = pts.join('$');
        var keyMatches = rs.pathCacheKey && rs.pathCacheKey === pathCacheKey;
        if (keyMatches) {
            path = context = rs.pathCache;
            pathCacheHit = true;
        } else {
            path = context = new Path2D();
            rs.pathCacheKey = pathCacheKey;
            rs.pathCache = path;
        }
    }
    if (canvasCxt.setLineDash) // for very outofdate browsers
    switch(type){
        case 'dotted':
            canvasCxt.setLineDash([
                1,
                1
            ]);
            break;
        case 'dashed':
            canvasCxt.setLineDash(lineDashPattern);
            canvasCxt.lineDashOffset = lineDashOffset;
            break;
        case 'solid':
            canvasCxt.setLineDash([]);
            break;
    }
    if (!pathCacheHit && !rs.badLine) {
        if (context.beginPath) context.beginPath();
        context.moveTo(pts[0], pts[1]);
        switch(rs.edgeType){
            case 'bezier':
            case 'self':
            case 'compound':
            case 'multibezier':
                for(var i = 2; i + 3 < pts.length; i += 4)context.quadraticCurveTo(pts[i], pts[i + 1], pts[i + 2], pts[i + 3]);
                break;
            case 'straight':
            case 'haystack':
                for(var _i = 2; _i + 1 < pts.length; _i += 2)context.lineTo(pts[_i], pts[_i + 1]);
                break;
            case 'segments':
                if (rs.isRound) {
                    var _iterator = $e815fda779bc047b$var$_createForOfIteratorHelper(rs.roundCorners), _step;
                    try {
                        for(_iterator.s(); !(_step = _iterator.n()).done;){
                            var corner = _step.value;
                            $e815fda779bc047b$var$drawPreparedRoundCorner(context, corner);
                        }
                    } catch (err) {
                        _iterator.e(err);
                    } finally{
                        _iterator.f();
                    }
                    context.lineTo(pts[pts.length - 2], pts[pts.length - 1]);
                } else for(var _i2 = 2; _i2 + 1 < pts.length; _i2 += 2)context.lineTo(pts[_i2], pts[_i2 + 1]);
                break;
        }
    }
    context = canvasCxt;
    if (usePaths) context.stroke(path);
    else context.stroke();
    // reset any line dashes
    if (context.setLineDash) // for very outofdate browsers
    context.setLineDash([]);
};
$e815fda779bc047b$var$CRp$9.drawEdgeTrianglePath = function(edge, context, pts) {
    // use line stroke style for triangle fill style
    context.fillStyle = context.strokeStyle;
    var edgeWidth = edge.pstyle('width').pfValue;
    for(var i = 0; i + 1 < pts.length; i += 2){
        var vector = [
            pts[i + 2] - pts[i],
            pts[i + 3] - pts[i + 1]
        ];
        var length = Math.sqrt(vector[0] * vector[0] + vector[1] * vector[1]);
        var normal = [
            vector[1] / length,
            -vector[0] / length
        ];
        var triangleHead = [
            normal[0] * edgeWidth / 2,
            normal[1] * edgeWidth / 2
        ];
        context.beginPath();
        context.moveTo(pts[i] - triangleHead[0], pts[i + 1] - triangleHead[1]);
        context.lineTo(pts[i] + triangleHead[0], pts[i + 1] + triangleHead[1]);
        context.lineTo(pts[i + 2], pts[i + 3]);
        context.closePath();
        context.fill();
    }
};
$e815fda779bc047b$var$CRp$9.drawArrowheads = function(context, edge, opacity) {
    var rs = edge._private.rscratch;
    var isHaystack = rs.edgeType === 'haystack';
    if (!isHaystack) this.drawArrowhead(context, edge, 'source', rs.arrowStartX, rs.arrowStartY, rs.srcArrowAngle, opacity);
    this.drawArrowhead(context, edge, 'mid-target', rs.midX, rs.midY, rs.midtgtArrowAngle, opacity);
    this.drawArrowhead(context, edge, 'mid-source', rs.midX, rs.midY, rs.midsrcArrowAngle, opacity);
    if (!isHaystack) this.drawArrowhead(context, edge, 'target', rs.arrowEndX, rs.arrowEndY, rs.tgtArrowAngle, opacity);
};
$e815fda779bc047b$var$CRp$9.drawArrowhead = function(context, edge, prefix, x, y, angle, opacity) {
    if (isNaN(x) || x == null || isNaN(y) || y == null || isNaN(angle) || angle == null) return;
    var self1 = this;
    var arrowShape = edge.pstyle(prefix + '-arrow-shape').value;
    if (arrowShape === 'none') return;
    var arrowClearFill = edge.pstyle(prefix + '-arrow-fill').value === 'hollow' ? 'both' : 'filled';
    var arrowFill = edge.pstyle(prefix + '-arrow-fill').value;
    var edgeWidth = edge.pstyle('width').pfValue;
    var pArrowWidth = edge.pstyle(prefix + '-arrow-width');
    var arrowWidth = pArrowWidth.value === 'match-line' ? edgeWidth : pArrowWidth.pfValue;
    if (pArrowWidth.units === '%') arrowWidth *= edgeWidth;
    var edgeOpacity = edge.pstyle('opacity').value;
    if (opacity === undefined) opacity = edgeOpacity;
    var gco = context.globalCompositeOperation;
    if (opacity !== 1 || arrowFill === 'hollow') {
        // then extra clear is needed
        context.globalCompositeOperation = 'destination-out';
        self1.colorFillStyle(context, 255, 255, 255, 1);
        self1.colorStrokeStyle(context, 255, 255, 255, 1);
        self1.drawArrowShape(edge, context, arrowClearFill, edgeWidth, arrowShape, arrowWidth, x, y, angle);
        context.globalCompositeOperation = gco;
    } // otherwise, the opaque arrow clears it for free :)
    var color = edge.pstyle(prefix + '-arrow-color').value;
    self1.colorFillStyle(context, color[0], color[1], color[2], opacity);
    self1.colorStrokeStyle(context, color[0], color[1], color[2], opacity);
    self1.drawArrowShape(edge, context, arrowFill, edgeWidth, arrowShape, arrowWidth, x, y, angle);
};
$e815fda779bc047b$var$CRp$9.drawArrowShape = function(edge, context, fill, edgeWidth, shape, shapeWidth, x, y, angle) {
    var r = this;
    var usePaths = this.usePaths() && shape !== 'triangle-cross';
    var pathCacheHit = false;
    var path;
    var canvasContext = context;
    var translation = {
        x: x,
        y: y
    };
    var scale = edge.pstyle('arrow-scale').value;
    var size = this.getArrowWidth(edgeWidth, scale);
    var shapeImpl = r.arrowShapes[shape];
    if (usePaths) {
        var cache = r.arrowPathCache = r.arrowPathCache || [];
        var key = $e815fda779bc047b$var$hashString(shape);
        var cachedPath = cache[key];
        if (cachedPath != null) {
            path = context = cachedPath;
            pathCacheHit = true;
        } else {
            path = context = new Path2D();
            cache[key] = path;
        }
    }
    if (!pathCacheHit) {
        if (context.beginPath) context.beginPath();
        if (usePaths) // store in the path cache with values easily manipulated later
        shapeImpl.draw(context, 1, 0, {
            x: 0,
            y: 0
        }, 1);
        else shapeImpl.draw(context, size, angle, translation, edgeWidth);
        if (context.closePath) context.closePath();
    }
    context = canvasContext;
    if (usePaths) {
        // set transform to arrow position/orientation
        context.translate(x, y);
        context.rotate(angle);
        context.scale(size, size);
    }
    if (fill === 'filled' || fill === 'both') {
        if (usePaths) context.fill(path);
        else context.fill();
    }
    if (fill === 'hollow' || fill === 'both') {
        context.lineWidth = shapeWidth / (usePaths ? size : 1);
        context.lineJoin = 'miter';
        if (usePaths) context.stroke(path);
        else context.stroke();
    }
    if (usePaths) {
        // reset transform by applying inverse
        context.scale(1 / size, 1 / size);
        context.rotate(-angle);
        context.translate(-x, -y);
    }
};
var $e815fda779bc047b$var$CRp$8 = {};
$e815fda779bc047b$var$CRp$8.safeDrawImage = function(context, img, ix, iy, iw, ih, x, y, w, h) {
    // detect problematic cases for old browsers with bad images (cheaper than try-catch)
    if (iw <= 0 || ih <= 0 || w <= 0 || h <= 0) return;
    try {
        context.drawImage(img, ix, iy, iw, ih, x, y, w, h);
    } catch (e) {
        $e815fda779bc047b$var$warn(e);
    }
};
$e815fda779bc047b$var$CRp$8.drawInscribedImage = function(context, img, node, index, nodeOpacity) {
    var r = this;
    var pos = node.position();
    var nodeX = pos.x;
    var nodeY = pos.y;
    var styleObj = node.cy().style();
    var getIndexedStyle = styleObj.getIndexedStyle.bind(styleObj);
    var fit = getIndexedStyle(node, 'background-fit', 'value', index);
    var repeat = getIndexedStyle(node, 'background-repeat', 'value', index);
    var nodeW = node.width();
    var nodeH = node.height();
    var paddingX2 = node.padding() * 2;
    var nodeTW = nodeW + (getIndexedStyle(node, 'background-width-relative-to', 'value', index) === 'inner' ? 0 : paddingX2);
    var nodeTH = nodeH + (getIndexedStyle(node, 'background-height-relative-to', 'value', index) === 'inner' ? 0 : paddingX2);
    var rs = node._private.rscratch;
    var clip = getIndexedStyle(node, 'background-clip', 'value', index);
    var shouldClip = clip === 'node';
    var imgOpacity = getIndexedStyle(node, 'background-image-opacity', 'value', index) * nodeOpacity;
    var smooth = getIndexedStyle(node, 'background-image-smoothing', 'value', index);
    var cornerRadius = node.pstyle('corner-radius').value;
    if (cornerRadius !== 'auto') cornerRadius = node.pstyle('corner-radius').pfValue;
    var imgW = img.width || img.cachedW;
    var imgH = img.height || img.cachedH;
    // workaround for broken browsers like ie
    if (null == imgW || null == imgH) {
        document.body.appendChild(img); // eslint-disable-line no-undef
        imgW = img.cachedW = img.width || img.offsetWidth;
        imgH = img.cachedH = img.height || img.offsetHeight;
        document.body.removeChild(img); // eslint-disable-line no-undef
    }
    var w = imgW;
    var h = imgH;
    if (getIndexedStyle(node, 'background-width', 'value', index) !== 'auto') {
        if (getIndexedStyle(node, 'background-width', 'units', index) === '%') w = getIndexedStyle(node, 'background-width', 'pfValue', index) * nodeTW;
        else w = getIndexedStyle(node, 'background-width', 'pfValue', index);
    }
    if (getIndexedStyle(node, 'background-height', 'value', index) !== 'auto') {
        if (getIndexedStyle(node, 'background-height', 'units', index) === '%') h = getIndexedStyle(node, 'background-height', 'pfValue', index) * nodeTH;
        else h = getIndexedStyle(node, 'background-height', 'pfValue', index);
    }
    if (w === 0 || h === 0) return; // no point in drawing empty image (and chrome is broken in this case)
    if (fit === 'contain') {
        var scale = Math.min(nodeTW / w, nodeTH / h);
        w *= scale;
        h *= scale;
    } else if (fit === 'cover') {
        var scale = Math.max(nodeTW / w, nodeTH / h);
        w *= scale;
        h *= scale;
    }
    var x = nodeX - nodeTW / 2; // left
    var posXUnits = getIndexedStyle(node, 'background-position-x', 'units', index);
    var posXPfVal = getIndexedStyle(node, 'background-position-x', 'pfValue', index);
    if (posXUnits === '%') x += (nodeTW - w) * posXPfVal;
    else x += posXPfVal;
    var offXUnits = getIndexedStyle(node, 'background-offset-x', 'units', index);
    var offXPfVal = getIndexedStyle(node, 'background-offset-x', 'pfValue', index);
    if (offXUnits === '%') x += (nodeTW - w) * offXPfVal;
    else x += offXPfVal;
    var y = nodeY - nodeTH / 2; // top
    var posYUnits = getIndexedStyle(node, 'background-position-y', 'units', index);
    var posYPfVal = getIndexedStyle(node, 'background-position-y', 'pfValue', index);
    if (posYUnits === '%') y += (nodeTH - h) * posYPfVal;
    else y += posYPfVal;
    var offYUnits = getIndexedStyle(node, 'background-offset-y', 'units', index);
    var offYPfVal = getIndexedStyle(node, 'background-offset-y', 'pfValue', index);
    if (offYUnits === '%') y += (nodeTH - h) * offYPfVal;
    else y += offYPfVal;
    if (rs.pathCache) {
        x -= nodeX;
        y -= nodeY;
        nodeX = 0;
        nodeY = 0;
    }
    var gAlpha = context.globalAlpha;
    context.globalAlpha = imgOpacity;
    var smoothingEnabled = r.getImgSmoothing(context);
    var isSmoothingSwitched = false;
    if (smooth === 'no' && smoothingEnabled) {
        r.setImgSmoothing(context, false);
        isSmoothingSwitched = true;
    } else if (smooth === 'yes' && !smoothingEnabled) {
        r.setImgSmoothing(context, true);
        isSmoothingSwitched = true;
    }
    if (repeat === 'no-repeat') {
        if (shouldClip) {
            context.save();
            if (rs.pathCache) context.clip(rs.pathCache);
            else {
                r.nodeShapes[r.getNodeShape(node)].draw(context, nodeX, nodeY, nodeTW, nodeTH, cornerRadius, rs);
                context.clip();
            }
        }
        r.safeDrawImage(context, img, 0, 0, imgW, imgH, x, y, w, h);
        if (shouldClip) context.restore();
    } else {
        var pattern = context.createPattern(img, repeat);
        context.fillStyle = pattern;
        r.nodeShapes[r.getNodeShape(node)].draw(context, nodeX, nodeY, nodeTW, nodeTH, cornerRadius, rs);
        context.translate(x, y);
        context.fill();
        context.translate(-x, -y);
    }
    context.globalAlpha = gAlpha;
    if (isSmoothingSwitched) r.setImgSmoothing(context, smoothingEnabled);
};
var $e815fda779bc047b$var$CRp$7 = {};
$e815fda779bc047b$var$CRp$7.eleTextBiggerThanMin = function(ele, scale) {
    if (!scale) {
        var zoom = ele.cy().zoom();
        var pxRatio = this.getPixelRatio();
        var lvl = Math.ceil($e815fda779bc047b$var$log2(zoom * pxRatio)); // the effective texture level
        scale = Math.pow(2, lvl);
    }
    var computedSize = ele.pstyle('font-size').pfValue * scale;
    var minSize = ele.pstyle('min-zoomed-font-size').pfValue;
    if (computedSize < minSize) return false;
    return true;
};
$e815fda779bc047b$var$CRp$7.drawElementText = function(context, ele, shiftToOriginWithBb, force, prefix) {
    var useEleOpacity = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : true;
    var r = this;
    if (force == null) {
        if (useEleOpacity && !r.eleTextBiggerThanMin(ele)) return;
    } else if (force === false) return;
    if (ele.isNode()) {
        var label = ele.pstyle('label');
        if (!label || !label.value) return;
        var justification = r.getLabelJustification(ele);
        context.textAlign = justification;
        context.textBaseline = 'bottom';
    } else {
        var badLine = ele.element()._private.rscratch.badLine;
        var _label = ele.pstyle('label');
        var srcLabel = ele.pstyle('source-label');
        var tgtLabel = ele.pstyle('target-label');
        if (badLine || (!_label || !_label.value) && (!srcLabel || !srcLabel.value) && (!tgtLabel || !tgtLabel.value)) return;
        context.textAlign = 'center';
        context.textBaseline = 'bottom';
    }
    var applyRotation = !shiftToOriginWithBb;
    var bb;
    if (shiftToOriginWithBb) {
        bb = shiftToOriginWithBb;
        context.translate(-bb.x1, -bb.y1);
    }
    if (prefix == null) {
        r.drawText(context, ele, null, applyRotation, useEleOpacity);
        if (ele.isEdge()) {
            r.drawText(context, ele, 'source', applyRotation, useEleOpacity);
            r.drawText(context, ele, 'target', applyRotation, useEleOpacity);
        }
    } else r.drawText(context, ele, prefix, applyRotation, useEleOpacity);
    if (shiftToOriginWithBb) context.translate(bb.x1, bb.y1);
};
$e815fda779bc047b$var$CRp$7.getFontCache = function(context) {
    var cache;
    this.fontCaches = this.fontCaches || [];
    for(var i = 0; i < this.fontCaches.length; i++){
        cache = this.fontCaches[i];
        if (cache.context === context) return cache;
    }
    cache = {
        context: context
    };
    this.fontCaches.push(cache);
    return cache;
};
// set up canvas context with font
// returns transformed text string
$e815fda779bc047b$var$CRp$7.setupTextStyle = function(context, ele) {
    var useEleOpacity = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    // Font style
    var labelStyle = ele.pstyle('font-style').strValue;
    var labelSize = ele.pstyle('font-size').pfValue + 'px';
    var labelFamily = ele.pstyle('font-family').strValue;
    var labelWeight = ele.pstyle('font-weight').strValue;
    var opacity = useEleOpacity ? ele.effectiveOpacity() * ele.pstyle('text-opacity').value : 1;
    var outlineOpacity = ele.pstyle('text-outline-opacity').value * opacity;
    var color = ele.pstyle('color').value;
    var outlineColor = ele.pstyle('text-outline-color').value;
    context.font = labelStyle + ' ' + labelWeight + ' ' + labelSize + ' ' + labelFamily;
    context.lineJoin = 'round'; // so text outlines aren't jagged
    this.colorFillStyle(context, color[0], color[1], color[2], opacity);
    this.colorStrokeStyle(context, outlineColor[0], outlineColor[1], outlineColor[2], outlineOpacity);
};
function $e815fda779bc047b$var$circle(ctx, x, y, width, height) {
    var diameter = Math.min(width, height);
    var radius = diameter / 2;
    var centerX = x + width / 2;
    var centerY = y + height / 2;
    ctx.beginPath();
    ctx.arc(centerX, centerY, radius, 0, Math.PI * 2);
    ctx.closePath();
}
function $e815fda779bc047b$var$roundRect(ctx, x, y, width, height) {
    var radius = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 5;
    var r = Math.min(radius, width / 2, height / 2); // prevent overflow
    ctx.beginPath();
    ctx.moveTo(x + r, y);
    ctx.lineTo(x + width - r, y);
    ctx.quadraticCurveTo(x + width, y, x + width, y + r);
    ctx.lineTo(x + width, y + height - r);
    ctx.quadraticCurveTo(x + width, y + height, x + width - r, y + height);
    ctx.lineTo(x + r, y + height);
    ctx.quadraticCurveTo(x, y + height, x, y + height - r);
    ctx.lineTo(x, y + r);
    ctx.quadraticCurveTo(x, y, x + r, y);
    ctx.closePath();
}
$e815fda779bc047b$var$CRp$7.getTextAngle = function(ele, prefix) {
    var theta;
    var _p = ele._private;
    var rscratch = _p.rscratch;
    var pdash = prefix ? prefix + '-' : '';
    var rotation = ele.pstyle(pdash + 'text-rotation');
    if (rotation.strValue === 'autorotate') {
        var textAngle = $e815fda779bc047b$var$getPrefixedProperty(rscratch, 'labelAngle', prefix);
        theta = ele.isEdge() ? textAngle : 0;
    } else if (rotation.strValue === 'none') theta = 0;
    else theta = rotation.pfValue;
    return theta;
};
$e815fda779bc047b$var$CRp$7.drawText = function(context, ele, prefix) {
    var applyRotation = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
    var useEleOpacity = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
    var _p = ele._private;
    var rscratch = _p.rscratch;
    var parentOpacity = useEleOpacity ? ele.effectiveOpacity() : 1;
    if (useEleOpacity && (parentOpacity === 0 || ele.pstyle('text-opacity').value === 0)) return;
    // use 'main' as an alias for the main label (i.e. null prefix)
    if (prefix === 'main') prefix = null;
    var textX = $e815fda779bc047b$var$getPrefixedProperty(rscratch, 'labelX', prefix);
    var textY = $e815fda779bc047b$var$getPrefixedProperty(rscratch, 'labelY', prefix);
    var orgTextX, orgTextY; // used for rotation
    var text = this.getLabelText(ele, prefix);
    if (text != null && text !== '' && !isNaN(textX) && !isNaN(textY)) {
        this.setupTextStyle(context, ele, useEleOpacity);
        var pdash = prefix ? prefix + '-' : '';
        var textW = $e815fda779bc047b$var$getPrefixedProperty(rscratch, 'labelWidth', prefix);
        var textH = $e815fda779bc047b$var$getPrefixedProperty(rscratch, 'labelHeight', prefix);
        var marginX = ele.pstyle(pdash + 'text-margin-x').pfValue;
        var marginY = ele.pstyle(pdash + 'text-margin-y').pfValue;
        var isEdge = ele.isEdge();
        var halign = ele.pstyle('text-halign').value;
        var valign = ele.pstyle('text-valign').value;
        if (isEdge) {
            halign = 'center';
            valign = 'center';
        }
        textX += marginX;
        textY += marginY;
        var theta;
        if (!applyRotation) theta = 0;
        else theta = this.getTextAngle(ele, prefix);
        if (theta !== 0) {
            orgTextX = textX;
            orgTextY = textY;
            context.translate(orgTextX, orgTextY);
            context.rotate(theta);
            textX = 0;
            textY = 0;
        }
        switch(valign){
            case 'top':
                break;
            case 'center':
                textY += textH / 2;
                break;
            case 'bottom':
                textY += textH;
                break;
        }
        var backgroundOpacity = ele.pstyle('text-background-opacity').value;
        var borderOpacity = ele.pstyle('text-border-opacity').value;
        var textBorderWidth = ele.pstyle('text-border-width').pfValue;
        var backgroundPadding = ele.pstyle('text-background-padding').pfValue;
        var styleShape = ele.pstyle('text-background-shape').strValue;
        var rounded = styleShape === 'round-rectangle' || styleShape === 'roundrectangle';
        var circled = styleShape === 'circle';
        var roundRadius = 2;
        if (backgroundOpacity > 0 || textBorderWidth > 0 && borderOpacity > 0) {
            var textFill = context.fillStyle;
            var textStroke = context.strokeStyle;
            var textLineWidth = context.lineWidth;
            var textBackgroundColor = ele.pstyle('text-background-color').value;
            var textBorderColor = ele.pstyle('text-border-color').value;
            var textBorderStyle = ele.pstyle('text-border-style').value;
            var doFill = backgroundOpacity > 0;
            var doStroke = textBorderWidth > 0 && borderOpacity > 0;
            var bgX = textX - backgroundPadding;
            switch(halign){
                case 'left':
                    bgX -= textW;
                    break;
                case 'center':
                    bgX -= textW / 2;
                    break;
            }
            var bgY = textY - textH - backgroundPadding;
            var bgW = textW + 2 * backgroundPadding;
            var bgH = textH + 2 * backgroundPadding;
            if (doFill) context.fillStyle = "rgba(".concat(textBackgroundColor[0], ",").concat(textBackgroundColor[1], ",").concat(textBackgroundColor[2], ",").concat(backgroundOpacity * parentOpacity, ")");
            if (doStroke) {
                context.strokeStyle = "rgba(".concat(textBorderColor[0], ",").concat(textBorderColor[1], ",").concat(textBorderColor[2], ",").concat(borderOpacity * parentOpacity, ")");
                context.lineWidth = textBorderWidth;
                if (context.setLineDash) switch(textBorderStyle){
                    case 'dotted':
                        context.setLineDash([
                            1,
                            1
                        ]);
                        break;
                    case 'dashed':
                        context.setLineDash([
                            4,
                            2
                        ]);
                        break;
                    case 'double':
                        context.lineWidth = textBorderWidth / 4;
                        context.setLineDash([]);
                        break;
                    case 'solid':
                    default:
                        context.setLineDash([]);
                        break;
                }
            }
            if (rounded) {
                context.beginPath();
                $e815fda779bc047b$var$roundRect(context, bgX, bgY, bgW, bgH, roundRadius);
            } else if (circled) {
                context.beginPath();
                $e815fda779bc047b$var$circle(context, bgX, bgY, bgW, bgH);
            } else {
                context.beginPath();
                context.rect(bgX, bgY, bgW, bgH);
            }
            if (doFill) context.fill();
            if (doStroke) context.stroke();
            // Double border pass for 'double' style
            if (doStroke && textBorderStyle === 'double') {
                var whiteWidth = textBorderWidth / 2;
                context.beginPath();
                if (rounded) $e815fda779bc047b$var$roundRect(context, bgX + whiteWidth, bgY + whiteWidth, bgW - 2 * whiteWidth, bgH - 2 * whiteWidth, roundRadius);
                else context.rect(bgX + whiteWidth, bgY + whiteWidth, bgW - 2 * whiteWidth, bgH - 2 * whiteWidth);
                context.stroke();
            }
            context.fillStyle = textFill;
            context.strokeStyle = textStroke;
            context.lineWidth = textLineWidth;
            if (context.setLineDash) context.setLineDash([]);
        }
        var lineWidth = 2 * ele.pstyle('text-outline-width').pfValue; // *2 b/c the stroke is drawn centred on the middle
        if (lineWidth > 0) context.lineWidth = lineWidth;
        if (ele.pstyle('text-wrap').value === 'wrap') {
            var lines = $e815fda779bc047b$var$getPrefixedProperty(rscratch, 'labelWrapCachedLines', prefix);
            var lineHeight = $e815fda779bc047b$var$getPrefixedProperty(rscratch, 'labelLineHeight', prefix);
            var halfTextW = textW / 2;
            var justification = this.getLabelJustification(ele);
            if (justification === 'auto') ;
            else if (halign === 'left') {
                // auto justification : right
                if (justification === 'left') textX += -textW;
                else if (justification === 'center') textX += -halfTextW;
                 // else same as auto
            } else if (halign === 'center') {
                // auto justfication : center
                if (justification === 'left') textX += -halfTextW;
                else if (justification === 'right') textX += halfTextW;
                 // else same as auto
            } else if (halign === 'right') {
                // auto justification : left
                if (justification === 'center') textX += halfTextW;
                else if (justification === 'right') textX += textW;
                 // else same as auto
            }
            switch(valign){
                case 'top':
                    textY -= (lines.length - 1) * lineHeight;
                    break;
                case 'center':
                case 'bottom':
                    textY -= (lines.length - 1) * lineHeight;
                    break;
            }
            for(var l = 0; l < lines.length; l++){
                if (lineWidth > 0) context.strokeText(lines[l], textX, textY);
                context.fillText(lines[l], textX, textY);
                textY += lineHeight;
            }
        } else {
            if (lineWidth > 0) context.strokeText(text, textX, textY);
            context.fillText(text, textX, textY);
        }
        if (theta !== 0) {
            context.rotate(-theta);
            context.translate(-orgTextX, -orgTextY);
        }
    }
};
/* global Path2D */ var $e815fda779bc047b$var$CRp$6 = {};
$e815fda779bc047b$var$CRp$6.drawNode = function(context, node, shiftToOriginWithBb) {
    var drawLabel = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
    var shouldDrawOverlay = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
    var shouldDrawOpacity = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : true;
    var r = this;
    var nodeWidth, nodeHeight;
    var _p = node._private;
    var rs = _p.rscratch;
    var pos = node.position();
    if (!$e815fda779bc047b$var$number$1(pos.x) || !$e815fda779bc047b$var$number$1(pos.y)) return; // can't draw node with undefined position
    if (shouldDrawOpacity && !node.visible()) return;
    var eleOpacity = shouldDrawOpacity ? node.effectiveOpacity() : 1;
    var usePaths = r.usePaths();
    var path;
    var pathCacheHit = false;
    var padding = node.padding();
    nodeWidth = node.width() + 2 * padding;
    nodeHeight = node.height() + 2 * padding;
    //
    // setup shift
    var bb;
    if (shiftToOriginWithBb) {
        bb = shiftToOriginWithBb;
        context.translate(-bb.x1, -bb.y1);
    }
    //
    // load bg image
    var bgImgProp = node.pstyle('background-image');
    var urls = bgImgProp.value;
    var urlDefined = new Array(urls.length);
    var image = new Array(urls.length);
    var numImages = 0;
    for(var i = 0; i < urls.length; i++){
        var url = urls[i];
        var defd = urlDefined[i] = url != null && url !== 'none';
        if (defd) {
            var bgImgCrossOrigin = node.cy().style().getIndexedStyle(node, 'background-image-crossorigin', 'value', i);
            numImages++;
            // get image, and if not loaded then ask to redraw when later loaded
            image[i] = r.getCachedImage(url, bgImgCrossOrigin, function() {
                _p.backgroundTimestamp = Date.now();
                node.emitAndNotify('background');
            });
        }
    }
    //
    // setup styles
    var darkness = node.pstyle('background-blacken').value;
    var borderWidth = node.pstyle('border-width').pfValue;
    var bgOpacity = node.pstyle('background-opacity').value * eleOpacity;
    var borderColor = node.pstyle('border-color').value;
    var borderStyle = node.pstyle('border-style').value;
    var borderJoin = node.pstyle('border-join').value;
    var borderCap = node.pstyle('border-cap').value;
    var borderPosition = node.pstyle('border-position').value;
    var borderPattern = node.pstyle('border-dash-pattern').pfValue;
    var borderOffset = node.pstyle('border-dash-offset').pfValue;
    var borderOpacity = node.pstyle('border-opacity').value * eleOpacity;
    var outlineWidth = node.pstyle('outline-width').pfValue;
    var outlineColor = node.pstyle('outline-color').value;
    var outlineStyle = node.pstyle('outline-style').value;
    var outlineOpacity = node.pstyle('outline-opacity').value * eleOpacity;
    var outlineOffset = node.pstyle('outline-offset').value;
    var cornerRadius = node.pstyle('corner-radius').value;
    if (cornerRadius !== 'auto') cornerRadius = node.pstyle('corner-radius').pfValue;
    var setupShapeColor = function setupShapeColor() {
        var bgOpy = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : bgOpacity;
        r.eleFillStyle(context, node, bgOpy);
    };
    var setupBorderColor = function setupBorderColor() {
        var bdrOpy = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : borderOpacity;
        r.colorStrokeStyle(context, borderColor[0], borderColor[1], borderColor[2], bdrOpy);
    };
    var setupOutlineColor = function setupOutlineColor() {
        var otlnOpy = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : outlineOpacity;
        r.colorStrokeStyle(context, outlineColor[0], outlineColor[1], outlineColor[2], otlnOpy);
    };
    //
    // setup shape
    var getPath = function getPath(width, height, shape, points) {
        var pathCache = r.nodePathCache = r.nodePathCache || [];
        var key = $e815fda779bc047b$var$hashStrings(shape === 'polygon' ? shape + ',' + points.join(',') : shape, '' + height, '' + width, '' + cornerRadius);
        var cachedPath = pathCache[key];
        var path;
        var cacheHit = false;
        if (cachedPath != null) {
            path = cachedPath;
            cacheHit = true;
            rs.pathCache = path;
        } else {
            path = new Path2D();
            pathCache[key] = rs.pathCache = path;
        }
        return {
            path: path,
            cacheHit: cacheHit
        };
    };
    var styleShape = node.pstyle('shape').strValue;
    var shapePts = node.pstyle('shape-polygon-points').pfValue;
    if (usePaths) {
        context.translate(pos.x, pos.y);
        var shapePath = getPath(nodeWidth, nodeHeight, styleShape, shapePts);
        path = shapePath.path;
        pathCacheHit = shapePath.cacheHit;
    }
    var drawShape = function drawShape() {
        if (!pathCacheHit) {
            var npos = pos;
            if (usePaths) npos = {
                x: 0,
                y: 0
            };
            r.nodeShapes[r.getNodeShape(node)].draw(path || context, npos.x, npos.y, nodeWidth, nodeHeight, cornerRadius, rs);
        }
        if (usePaths) context.fill(path);
        else context.fill();
    };
    var drawImages = function drawImages() {
        var nodeOpacity = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : eleOpacity;
        var inside = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
        var prevBging = _p.backgrounding;
        var totalCompleted = 0;
        for(var _i = 0; _i < image.length; _i++){
            var bgContainment = node.cy().style().getIndexedStyle(node, 'background-image-containment', 'value', _i);
            if (inside && bgContainment === 'over' || !inside && bgContainment === 'inside') {
                totalCompleted++;
                continue;
            }
            if (urlDefined[_i] && image[_i].complete && !image[_i].error) {
                totalCompleted++;
                r.drawInscribedImage(context, image[_i], node, _i, nodeOpacity);
            }
        }
        _p.backgrounding = !(totalCompleted === numImages);
        if (prevBging !== _p.backgrounding) // update style b/c :backgrounding state changed
        node.updateStyle(false);
    };
    var drawPie = function drawPie() {
        var redrawShape = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        var pieOpacity = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : eleOpacity;
        if (r.hasPie(node)) {
            r.drawPie(context, node, pieOpacity);
            // redraw/restore path if steps after pie need it
            if (redrawShape) {
                if (!usePaths) r.nodeShapes[r.getNodeShape(node)].draw(context, pos.x, pos.y, nodeWidth, nodeHeight, cornerRadius, rs);
            }
        }
    };
    var drawStripe = function drawStripe() {
        var redrawShape = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        var stripeOpacity = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : eleOpacity;
        if (r.hasStripe(node)) {
            context.save();
            if (usePaths) context.clip(rs.pathCache);
            else {
                r.nodeShapes[r.getNodeShape(node)].draw(context, pos.x, pos.y, nodeWidth, nodeHeight, cornerRadius, rs);
                context.clip();
            }
            r.drawStripe(context, node, stripeOpacity);
            context.restore();
            // redraw/restore path if steps after stripes need it
            if (redrawShape) {
                if (!usePaths) r.nodeShapes[r.getNodeShape(node)].draw(context, pos.x, pos.y, nodeWidth, nodeHeight, cornerRadius, rs);
            }
        }
    };
    var darken = function darken() {
        var darkenOpacity = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : eleOpacity;
        var opacity = (darkness > 0 ? darkness : -darkness) * darkenOpacity;
        var c = darkness > 0 ? 0 : 255;
        if (darkness !== 0) {
            r.colorFillStyle(context, c, c, c, opacity);
            if (usePaths) context.fill(path);
            else context.fill();
        }
    };
    var drawBorder = function drawBorder() {
        if (borderWidth > 0) {
            context.lineWidth = borderWidth;
            context.lineCap = borderCap;
            context.lineJoin = borderJoin;
            if (context.setLineDash) // for very outofdate browsers
            switch(borderStyle){
                case 'dotted':
                    context.setLineDash([
                        1,
                        1
                    ]);
                    break;
                case 'dashed':
                    context.setLineDash(borderPattern);
                    context.lineDashOffset = borderOffset;
                    break;
                case 'solid':
                case 'double':
                    context.setLineDash([]);
                    break;
            }
            if (borderPosition !== 'center') {
                context.save();
                context.lineWidth *= 2;
                if (borderPosition === 'inside') usePaths ? context.clip(path) : context.clip();
                else {
                    var region = new Path2D();
                    region.rect(-nodeWidth / 2 - borderWidth, -nodeHeight / 2 - borderWidth, nodeWidth + 2 * borderWidth, nodeHeight + 2 * borderWidth);
                    region.addPath(path);
                    context.clip(region, 'evenodd');
                }
                usePaths ? context.stroke(path) : context.stroke();
                context.restore();
            } else usePaths ? context.stroke(path) : context.stroke();
            if (borderStyle === 'double') {
                context.lineWidth = borderWidth / 3;
                var gco = context.globalCompositeOperation;
                context.globalCompositeOperation = 'destination-out';
                if (usePaths) context.stroke(path);
                else context.stroke();
                context.globalCompositeOperation = gco;
            }
            // reset in case we changed the border style
            if (context.setLineDash) // for very outofdate browsers
            context.setLineDash([]);
        }
    };
    var drawOutline = function drawOutline() {
        if (outlineWidth > 0) {
            context.lineWidth = outlineWidth;
            context.lineCap = 'butt';
            if (context.setLineDash) // for very outofdate browsers
            switch(outlineStyle){
                case 'dotted':
                    context.setLineDash([
                        1,
                        1
                    ]);
                    break;
                case 'dashed':
                    context.setLineDash([
                        4,
                        2
                    ]);
                    break;
                case 'solid':
                case 'double':
                    context.setLineDash([]);
                    break;
            }
            var npos = pos;
            if (usePaths) npos = {
                x: 0,
                y: 0
            };
            var shape = r.getNodeShape(node);
            var bWidth = borderWidth;
            if (borderPosition === 'inside') bWidth = 0;
            if (borderPosition === 'outside') bWidth *= 2;
            var scaleX = (nodeWidth + bWidth + (outlineWidth + outlineOffset)) / nodeWidth;
            var scaleY = (nodeHeight + bWidth + (outlineWidth + outlineOffset)) / nodeHeight;
            var sWidth = nodeWidth * scaleX;
            var sHeight = nodeHeight * scaleY;
            var points = r.nodeShapes[shape].points;
            var _path;
            if (usePaths) {
                var outlinePath = getPath(sWidth, sHeight, shape, points);
                _path = outlinePath.path;
            }
            // draw the outline path, either by using expanded points or by scaling 
            // the dimensions, depending on shape
            if (shape === "ellipse") r.drawEllipsePath(_path || context, npos.x, npos.y, sWidth, sHeight);
            else if ([
                'round-diamond',
                'round-heptagon',
                'round-hexagon',
                'round-octagon',
                'round-pentagon',
                'round-polygon',
                'round-triangle',
                'round-tag'
            ].includes(shape)) {
                var sMult = 0;
                var offsetX = 0;
                var offsetY = 0;
                if (shape === 'round-diamond') sMult = (bWidth + outlineOffset + outlineWidth) * 1.4;
                else if (shape === 'round-heptagon') {
                    sMult = (bWidth + outlineOffset + outlineWidth) * 1.075;
                    offsetY = -(bWidth / 2 + outlineOffset + outlineWidth) / 35;
                } else if (shape === 'round-hexagon') sMult = (bWidth + outlineOffset + outlineWidth) * 1.12;
                else if (shape === 'round-pentagon') {
                    sMult = (bWidth + outlineOffset + outlineWidth) * 1.13;
                    offsetY = -(bWidth / 2 + outlineOffset + outlineWidth) / 15;
                } else if (shape === 'round-tag') {
                    sMult = (bWidth + outlineOffset + outlineWidth) * 1.12;
                    offsetX = (bWidth / 2 + outlineWidth + outlineOffset) * .07;
                } else if (shape === 'round-triangle') {
                    sMult = (bWidth + outlineOffset + outlineWidth) * (Math.PI / 2);
                    offsetY = -(bWidth + outlineOffset / 2 + outlineWidth) / Math.PI;
                }
                if (sMult !== 0) {
                    scaleX = (nodeWidth + sMult) / nodeWidth;
                    sWidth = nodeWidth * scaleX;
                    if (![
                        'round-hexagon',
                        'round-tag'
                    ].includes(shape)) {
                        scaleY = (nodeHeight + sMult) / nodeHeight;
                        sHeight = nodeHeight * scaleY;
                    }
                }
                cornerRadius = cornerRadius === 'auto' ? $e815fda779bc047b$var$getRoundPolygonRadius(sWidth, sHeight) : cornerRadius;
                var halfW = sWidth / 2;
                var halfH = sHeight / 2;
                var radius = cornerRadius + (bWidth + outlineWidth + outlineOffset) / 2;
                var p = new Array(points.length / 2);
                var corners = new Array(points.length / 2);
                for(var _i2 = 0; _i2 < points.length / 2; _i2++)p[_i2] = {
                    x: npos.x + offsetX + halfW * points[_i2 * 2],
                    y: npos.y + offsetY + halfH * points[_i2 * 2 + 1]
                };
                var _i3, p1, p2, p3, len = p.length;
                p1 = p[len - 1];
                // for each point
                for(_i3 = 0; _i3 < len; _i3++){
                    p2 = p[_i3 % len];
                    p3 = p[(_i3 + 1) % len];
                    corners[_i3] = $e815fda779bc047b$var$getRoundCorner(p1, p2, p3, radius);
                    p1 = p2;
                    p2 = p3;
                }
                r.drawRoundPolygonPath(_path || context, npos.x + offsetX, npos.y + offsetY, nodeWidth * scaleX, nodeHeight * scaleY, points, corners);
            } else if ([
                'roundrectangle',
                'round-rectangle'
            ].includes(shape)) {
                cornerRadius = cornerRadius === 'auto' ? $e815fda779bc047b$var$getRoundRectangleRadius(sWidth, sHeight) : cornerRadius;
                r.drawRoundRectanglePath(_path || context, npos.x, npos.y, sWidth, sHeight, cornerRadius + (bWidth + outlineWidth + outlineOffset) / 2);
            } else if ([
                'cutrectangle',
                'cut-rectangle'
            ].includes(shape)) {
                cornerRadius = cornerRadius === 'auto' ? $e815fda779bc047b$var$getCutRectangleCornerLength() : cornerRadius;
                r.drawCutRectanglePath(_path || context, npos.x, npos.y, sWidth, sHeight, null, cornerRadius + (bWidth + outlineWidth + outlineOffset) / 4);
            } else if ([
                'bottomroundrectangle',
                'bottom-round-rectangle'
            ].includes(shape)) {
                cornerRadius = cornerRadius === 'auto' ? $e815fda779bc047b$var$getRoundRectangleRadius(sWidth, sHeight) : cornerRadius;
                r.drawBottomRoundRectanglePath(_path || context, npos.x, npos.y, sWidth, sHeight, cornerRadius + (bWidth + outlineWidth + outlineOffset) / 2);
            } else if (shape === "barrel") r.drawBarrelPath(_path || context, npos.x, npos.y, sWidth, sHeight);
            else if (shape.startsWith("polygon") || [
                'rhomboid',
                'right-rhomboid',
                'round-tag',
                'tag',
                'vee'
            ].includes(shape)) {
                var pad = (bWidth + outlineWidth + outlineOffset) / nodeWidth;
                points = $e815fda779bc047b$var$joinLines($e815fda779bc047b$var$expandPolygon(points, pad));
                r.drawPolygonPath(_path || context, npos.x, npos.y, nodeWidth, nodeHeight, points);
            } else {
                var _pad = (bWidth + outlineWidth + outlineOffset) / nodeWidth;
                points = $e815fda779bc047b$var$joinLines($e815fda779bc047b$var$expandPolygon(points, -_pad));
                r.drawPolygonPath(_path || context, npos.x, npos.y, nodeWidth, nodeHeight, points);
            }
            if (usePaths) context.stroke(_path);
            else context.stroke();
            if (outlineStyle === 'double') {
                context.lineWidth = bWidth / 3;
                var gco = context.globalCompositeOperation;
                context.globalCompositeOperation = 'destination-out';
                if (usePaths) context.stroke(_path);
                else context.stroke();
                context.globalCompositeOperation = gco;
            }
            // reset in case we changed the border style
            if (context.setLineDash) // for very outofdate browsers
            context.setLineDash([]);
        }
    };
    var drawOverlay = function drawOverlay() {
        if (shouldDrawOverlay) r.drawNodeOverlay(context, node, pos, nodeWidth, nodeHeight);
    };
    var drawUnderlay = function drawUnderlay() {
        if (shouldDrawOverlay) r.drawNodeUnderlay(context, node, pos, nodeWidth, nodeHeight);
    };
    var drawText = function drawText() {
        r.drawElementText(context, node, null, drawLabel);
    };
    var ghost = node.pstyle('ghost').value === 'yes';
    if (ghost) {
        var gx = node.pstyle('ghost-offset-x').pfValue;
        var gy = node.pstyle('ghost-offset-y').pfValue;
        var ghostOpacity = node.pstyle('ghost-opacity').value;
        var effGhostOpacity = ghostOpacity * eleOpacity;
        context.translate(gx, gy);
        setupOutlineColor();
        drawOutline();
        setupShapeColor(ghostOpacity * bgOpacity);
        drawShape();
        drawImages(effGhostOpacity, true);
        setupBorderColor(ghostOpacity * borderOpacity);
        drawBorder();
        drawPie(darkness !== 0 || borderWidth !== 0);
        drawStripe(darkness !== 0 || borderWidth !== 0);
        drawImages(effGhostOpacity, false);
        darken(effGhostOpacity);
        context.translate(-gx, -gy);
    }
    if (usePaths) context.translate(-pos.x, -pos.y);
    drawUnderlay();
    if (usePaths) context.translate(pos.x, pos.y);
    setupOutlineColor();
    drawOutline();
    setupShapeColor();
    drawShape();
    drawImages(eleOpacity, true);
    setupBorderColor();
    drawBorder();
    drawPie(darkness !== 0 || borderWidth !== 0);
    drawStripe(darkness !== 0 || borderWidth !== 0);
    drawImages(eleOpacity, false);
    darken();
    if (usePaths) context.translate(-pos.x, -pos.y);
    drawText();
    drawOverlay();
    //
    // clean up shift
    if (shiftToOriginWithBb) context.translate(bb.x1, bb.y1);
};
var $e815fda779bc047b$var$drawNodeOverlayUnderlay = function drawNodeOverlayUnderlay(overlayOrUnderlay) {
    if (![
        'overlay',
        'underlay'
    ].includes(overlayOrUnderlay)) throw new Error('Invalid state');
    return function(context, node, pos, nodeWidth, nodeHeight) {
        var r = this;
        if (!node.visible()) return;
        var padding = node.pstyle("".concat(overlayOrUnderlay, "-padding")).pfValue;
        var opacity = node.pstyle("".concat(overlayOrUnderlay, "-opacity")).value;
        var color = node.pstyle("".concat(overlayOrUnderlay, "-color")).value;
        var shape = node.pstyle("".concat(overlayOrUnderlay, "-shape")).value;
        var radius = node.pstyle("".concat(overlayOrUnderlay, "-corner-radius")).value;
        if (opacity > 0) {
            pos = pos || node.position();
            if (nodeWidth == null || nodeHeight == null) {
                var _padding = node.padding();
                nodeWidth = node.width() + 2 * _padding;
                nodeHeight = node.height() + 2 * _padding;
            }
            r.colorFillStyle(context, color[0], color[1], color[2], opacity);
            r.nodeShapes[shape].draw(context, pos.x, pos.y, nodeWidth + padding * 2, nodeHeight + padding * 2, radius);
            context.fill();
        }
    };
};
$e815fda779bc047b$var$CRp$6.drawNodeOverlay = $e815fda779bc047b$var$drawNodeOverlayUnderlay('overlay');
$e815fda779bc047b$var$CRp$6.drawNodeUnderlay = $e815fda779bc047b$var$drawNodeOverlayUnderlay('underlay');
// does the node have at least one pie piece?
$e815fda779bc047b$var$CRp$6.hasPie = function(node) {
    node = node[0]; // ensure ele ref
    return node._private.hasPie;
};
$e815fda779bc047b$var$CRp$6.hasStripe = function(node) {
    node = node[0]; // ensure ele ref
    return node._private.hasStripe;
};
$e815fda779bc047b$var$CRp$6.drawPie = function(context, node, nodeOpacity, pos) {
    node = node[0]; // ensure ele ref
    pos = pos || node.position();
    var cyStyle = node.cy().style();
    var pieSize = node.pstyle('pie-size');
    var hole = node.pstyle('pie-hole');
    var overallStartAngle = node.pstyle('pie-start-angle').pfValue;
    var x = pos.x;
    var y = pos.y;
    var nodeW = node.width();
    var nodeH = node.height();
    var radius = Math.min(nodeW, nodeH) / 2; // must fit in node
    var holeRadius;
    var lastPercent = 0; // what % to continue drawing pie slices from on [0, 1]
    var usePaths = this.usePaths();
    if (usePaths) {
        x = 0;
        y = 0;
    }
    if (pieSize.units === '%') radius = radius * pieSize.pfValue;
    else if (pieSize.pfValue !== undefined) radius = pieSize.pfValue / 2; // diameter in pixels => radius
    if (hole.units === '%') holeRadius = radius * hole.pfValue;
    else if (hole.pfValue !== undefined) holeRadius = hole.pfValue / 2; // diameter in pixels => radius
    if (holeRadius >= radius) return; // the pie would be invisible anyway
    for(var i = 1; i <= cyStyle.pieBackgroundN; i++){
        // 1..N
        var size = node.pstyle('pie-' + i + '-background-size').value;
        var color = node.pstyle('pie-' + i + '-background-color').value;
        var opacity = node.pstyle('pie-' + i + '-background-opacity').value * nodeOpacity;
        var percent = size / 100; // map integer range [0, 100] to [0, 1]
        // percent can't push beyond 1
        if (percent + lastPercent > 1) percent = 1 - lastPercent;
        var angleStart = 1.5 * Math.PI + 2 * Math.PI * lastPercent; // start at 12 o'clock and go clockwise
        angleStart += overallStartAngle; // shift by the overall pie start angle
        var angleDelta = 2 * Math.PI * percent;
        var angleEnd = angleStart + angleDelta;
        // ignore if
        // - zero size
        // - we're already beyond the full circle
        // - adding the current slice would go beyond the full circle
        if (size === 0 || lastPercent >= 1 || lastPercent + percent > 1) continue;
        if (holeRadius === 0) {
            // make a pie slice
            context.beginPath();
            context.moveTo(x, y);
            context.arc(x, y, radius, angleStart, angleEnd);
            context.closePath();
        } else {
            // make a pie slice that's like the above but with a hole in the middle
            context.beginPath();
            context.arc(x, y, radius, angleStart, angleEnd);
            context.arc(x, y, holeRadius, angleEnd, angleStart, true); // true for anticlockwise
            context.closePath();
        }
        this.colorFillStyle(context, color[0], color[1], color[2], opacity);
        context.fill();
        lastPercent += percent;
    }
};
$e815fda779bc047b$var$CRp$6.drawStripe = function(context, node, nodeOpacity, pos) {
    node = node[0]; // ensure ele ref
    pos = pos || node.position();
    var cyStyle = node.cy().style();
    var x = pos.x;
    var y = pos.y;
    var nodeW = node.width();
    var nodeH = node.height();
    var lastPercent = 0; // what % to continue drawing pie slices from on [0, 1]
    var usePaths = this.usePaths();
    context.save();
    var direction = node.pstyle('stripe-direction').value;
    var stripeSize = node.pstyle('stripe-size');
    switch(direction){
        case 'vertical':
            break;
        // default
        case 'righward':
            context.rotate(-Math.PI / 2);
            break;
    }
    var stripeW = nodeW;
    var stripeH = nodeH;
    if (stripeSize.units === '%') {
        stripeW = stripeW * stripeSize.pfValue;
        stripeH = stripeH * stripeSize.pfValue;
    } else if (stripeSize.pfValue !== undefined) {
        stripeW = stripeSize.pfValue;
        stripeH = stripeSize.pfValue;
    }
    if (usePaths) {
        x = 0;
        y = 0;
    }
    // shift up from the centre of the node to the top-left corner
    y -= stripeW / 2;
    x -= stripeH / 2;
    for(var i = 1; i <= cyStyle.stripeBackgroundN; i++){
        // 1..N
        var size = node.pstyle('stripe-' + i + '-background-size').value;
        var color = node.pstyle('stripe-' + i + '-background-color').value;
        var opacity = node.pstyle('stripe-' + i + '-background-opacity').value * nodeOpacity;
        var percent = size / 100; // map integer range [0, 100] to [0, 1]
        // percent can't push beyond 1
        if (percent + lastPercent > 1) percent = 1 - lastPercent;
        // ignore if
        // - zero size
        // - we're already beyond the full chart
        // - adding the current slice would go beyond the full chart
        if (size === 0 || lastPercent >= 1 || lastPercent + percent > 1) continue;
        // draw rect for the current stripe
        context.beginPath();
        context.rect(x, y + stripeH * lastPercent, stripeW, stripeH * percent);
        context.closePath();
        this.colorFillStyle(context, color[0], color[1], color[2], opacity);
        context.fill();
        lastPercent += percent;
    }
    context.restore();
};
var $e815fda779bc047b$var$CRp$5 = {};
var $e815fda779bc047b$var$motionBlurDelay = 100;
// var isFirefox = typeof InstallTrigger !== 'undefined';
$e815fda779bc047b$var$CRp$5.getPixelRatio = function() {
    var context = this.data.contexts[0];
    if (this.forcedPixelRatio != null) return this.forcedPixelRatio;
    var containerWindow = this.cy.window();
    var backingStore = context.backingStorePixelRatio || context.webkitBackingStorePixelRatio || context.mozBackingStorePixelRatio || context.msBackingStorePixelRatio || context.oBackingStorePixelRatio || context.backingStorePixelRatio || 1;
    return (containerWindow.devicePixelRatio || 1) / backingStore; // eslint-disable-line no-undef
};
$e815fda779bc047b$var$CRp$5.paintCache = function(context) {
    var caches = this.paintCaches = this.paintCaches || [];
    var needToCreateCache = true;
    var cache;
    for(var i = 0; i < caches.length; i++){
        cache = caches[i];
        if (cache.context === context) {
            needToCreateCache = false;
            break;
        }
    }
    if (needToCreateCache) {
        cache = {
            context: context
        };
        caches.push(cache);
    }
    return cache;
};
$e815fda779bc047b$var$CRp$5.createGradientStyleFor = function(context, shapeStyleName, ele, fill, opacity) {
    var gradientStyle;
    var usePaths = this.usePaths();
    var colors = ele.pstyle(shapeStyleName + '-gradient-stop-colors').value, positions = ele.pstyle(shapeStyleName + '-gradient-stop-positions').pfValue;
    if (fill === 'radial-gradient') {
        if (ele.isEdge()) {
            var start = ele.sourceEndpoint(), end = ele.targetEndpoint(), mid = ele.midpoint();
            var d1 = $e815fda779bc047b$var$dist(start, mid);
            var d2 = $e815fda779bc047b$var$dist(end, mid);
            gradientStyle = context.createRadialGradient(mid.x, mid.y, 0, mid.x, mid.y, Math.max(d1, d2));
        } else {
            var pos = usePaths ? {
                x: 0,
                y: 0
            } : ele.position(), width = ele.paddedWidth(), height = ele.paddedHeight();
            gradientStyle = context.createRadialGradient(pos.x, pos.y, 0, pos.x, pos.y, Math.max(width, height));
        }
    } else if (ele.isEdge()) {
        var _start = ele.sourceEndpoint(), _end = ele.targetEndpoint();
        gradientStyle = context.createLinearGradient(_start.x, _start.y, _end.x, _end.y);
    } else {
        var _pos = usePaths ? {
            x: 0,
            y: 0
        } : ele.position(), _width = ele.paddedWidth(), _height = ele.paddedHeight(), halfWidth = _width / 2, halfHeight = _height / 2;
        var direction = ele.pstyle('background-gradient-direction').value;
        switch(direction){
            case 'to-bottom':
                gradientStyle = context.createLinearGradient(_pos.x, _pos.y - halfHeight, _pos.x, _pos.y + halfHeight);
                break;
            case 'to-top':
                gradientStyle = context.createLinearGradient(_pos.x, _pos.y + halfHeight, _pos.x, _pos.y - halfHeight);
                break;
            case 'to-left':
                gradientStyle = context.createLinearGradient(_pos.x + halfWidth, _pos.y, _pos.x - halfWidth, _pos.y);
                break;
            case 'to-right':
                gradientStyle = context.createLinearGradient(_pos.x - halfWidth, _pos.y, _pos.x + halfWidth, _pos.y);
                break;
            case 'to-bottom-right':
            case 'to-right-bottom':
                gradientStyle = context.createLinearGradient(_pos.x - halfWidth, _pos.y - halfHeight, _pos.x + halfWidth, _pos.y + halfHeight);
                break;
            case 'to-top-right':
            case 'to-right-top':
                gradientStyle = context.createLinearGradient(_pos.x - halfWidth, _pos.y + halfHeight, _pos.x + halfWidth, _pos.y - halfHeight);
                break;
            case 'to-bottom-left':
            case 'to-left-bottom':
                gradientStyle = context.createLinearGradient(_pos.x + halfWidth, _pos.y - halfHeight, _pos.x - halfWidth, _pos.y + halfHeight);
                break;
            case 'to-top-left':
            case 'to-left-top':
                gradientStyle = context.createLinearGradient(_pos.x + halfWidth, _pos.y + halfHeight, _pos.x - halfWidth, _pos.y - halfHeight);
                break;
        }
    }
    if (!gradientStyle) return null; // invalid gradient style
    var hasPositions = positions.length === colors.length;
    var length = colors.length;
    for(var i = 0; i < length; i++)gradientStyle.addColorStop(hasPositions ? positions[i] : i / (length - 1), 'rgba(' + colors[i][0] + ',' + colors[i][1] + ',' + colors[i][2] + ',' + opacity + ')');
    return gradientStyle;
};
$e815fda779bc047b$var$CRp$5.gradientFillStyle = function(context, ele, fill, opacity) {
    var gradientStyle = this.createGradientStyleFor(context, 'background', ele, fill, opacity);
    if (!gradientStyle) return null; // error
    context.fillStyle = gradientStyle;
};
$e815fda779bc047b$var$CRp$5.colorFillStyle = function(context, r, g, b, a) {
    context.fillStyle = 'rgba(' + r + ',' + g + ',' + b + ',' + a + ')';
// turn off for now, seems context does its own caching
// var cache = this.paintCache(context);
// var fillStyle = 'rgba(' + r + ',' + g + ',' + b + ',' + a + ')';
// if( cache.fillStyle !== fillStyle ){
//   context.fillStyle = cache.fillStyle = fillStyle;
// }
};
$e815fda779bc047b$var$CRp$5.eleFillStyle = function(context, ele, opacity) {
    var backgroundFill = ele.pstyle('background-fill').value;
    if (backgroundFill === 'linear-gradient' || backgroundFill === 'radial-gradient') this.gradientFillStyle(context, ele, backgroundFill, opacity);
    else {
        var backgroundColor = ele.pstyle('background-color').value;
        this.colorFillStyle(context, backgroundColor[0], backgroundColor[1], backgroundColor[2], opacity);
    }
};
$e815fda779bc047b$var$CRp$5.gradientStrokeStyle = function(context, ele, fill, opacity) {
    var gradientStyle = this.createGradientStyleFor(context, 'line', ele, fill, opacity);
    if (!gradientStyle) return null; // error
    context.strokeStyle = gradientStyle;
};
$e815fda779bc047b$var$CRp$5.colorStrokeStyle = function(context, r, g, b, a) {
    context.strokeStyle = 'rgba(' + r + ',' + g + ',' + b + ',' + a + ')';
// turn off for now, seems context does its own caching
// var cache = this.paintCache(context);
// var strokeStyle = 'rgba(' + r + ',' + g + ',' + b + ',' + a + ')';
// if( cache.strokeStyle !== strokeStyle ){
//   context.strokeStyle = cache.strokeStyle = strokeStyle;
// }
};
$e815fda779bc047b$var$CRp$5.eleStrokeStyle = function(context, ele, opacity) {
    var lineFill = ele.pstyle('line-fill').value;
    if (lineFill === 'linear-gradient' || lineFill === 'radial-gradient') this.gradientStrokeStyle(context, ele, lineFill, opacity);
    else {
        var lineColor = ele.pstyle('line-color').value;
        this.colorStrokeStyle(context, lineColor[0], lineColor[1], lineColor[2], opacity);
    }
};
// Resize canvas
$e815fda779bc047b$var$CRp$5.matchCanvasSize = function(container) {
    var r = this;
    var data = r.data;
    var bb = r.findContainerClientCoords();
    var width = bb[2];
    var height = bb[3];
    var pixelRatio = r.getPixelRatio();
    var mbPxRatio = r.motionBlurPxRatio;
    if (container === r.data.bufferCanvases[r.MOTIONBLUR_BUFFER_NODE] || container === r.data.bufferCanvases[r.MOTIONBLUR_BUFFER_DRAG]) pixelRatio = mbPxRatio;
    var canvasWidth = width * pixelRatio;
    var canvasHeight = height * pixelRatio;
    var canvas;
    if (canvasWidth === r.canvasWidth && canvasHeight === r.canvasHeight) return; // save cycles if same
    r.fontCaches = null; // resizing resets the style
    var canvasContainer = data.canvasContainer;
    canvasContainer.style.width = width + 'px';
    canvasContainer.style.height = height + 'px';
    for(var i = 0; i < r.CANVAS_LAYERS; i++){
        canvas = data.canvases[i];
        canvas.width = canvasWidth;
        canvas.height = canvasHeight;
        canvas.style.width = width + 'px';
        canvas.style.height = height + 'px';
    }
    for(var i = 0; i < r.BUFFER_COUNT; i++){
        canvas = data.bufferCanvases[i];
        canvas.width = canvasWidth;
        canvas.height = canvasHeight;
        canvas.style.width = width + 'px';
        canvas.style.height = height + 'px';
    }
    r.textureMult = 1;
    if (pixelRatio <= 1) {
        canvas = data.bufferCanvases[r.TEXTURE_BUFFER];
        r.textureMult = 2;
        canvas.width = canvasWidth * r.textureMult;
        canvas.height = canvasHeight * r.textureMult;
    }
    r.canvasWidth = canvasWidth;
    r.canvasHeight = canvasHeight;
    r.pixelRatio = pixelRatio;
};
$e815fda779bc047b$var$CRp$5.renderTo = function(cxt, zoom, pan, pxRatio) {
    this.render({
        forcedContext: cxt,
        forcedZoom: zoom,
        forcedPan: pan,
        drawAllLayers: true,
        forcedPxRatio: pxRatio
    });
};
$e815fda779bc047b$var$CRp$5.clearCanvas = function() {
    var r = this;
    var data = r.data;
    function clear(context) {
        context.clearRect(0, 0, r.canvasWidth, r.canvasHeight);
    }
    clear(data.contexts[r.NODE]);
    clear(data.contexts[r.DRAG]);
};
$e815fda779bc047b$var$CRp$5.render = function(options) {
    var r = this;
    options = options || $e815fda779bc047b$var$staticEmptyObject();
    var cy = r.cy;
    var forcedContext = options.forcedContext;
    var drawAllLayers = options.drawAllLayers;
    var drawOnlyNodeLayer = options.drawOnlyNodeLayer;
    var forcedZoom = options.forcedZoom;
    var forcedPan = options.forcedPan;
    var pixelRatio = options.forcedPxRatio === undefined ? this.getPixelRatio() : options.forcedPxRatio;
    var data = r.data;
    var needDraw = data.canvasNeedsRedraw;
    var textureDraw = r.textureOnViewport && !forcedContext && (r.pinching || r.hoverData.dragging || r.swipePanning || r.data.wheelZooming);
    var motionBlur = options.motionBlur !== undefined ? options.motionBlur : r.motionBlur;
    var mbPxRatio = r.motionBlurPxRatio;
    var hasCompoundNodes = cy.hasCompoundNodes();
    var inNodeDragGesture = r.hoverData.draggingEles;
    var inBoxSelection = r.hoverData.selecting || r.touchData.selecting ? true : false;
    motionBlur = motionBlur && !forcedContext && r.motionBlurEnabled && !inBoxSelection;
    var motionBlurFadeEffect = motionBlur;
    if (!forcedContext) {
        if (r.prevPxRatio !== pixelRatio) {
            r.invalidateContainerClientCoordsCache();
            r.matchCanvasSize(r.container);
            r.redrawHint('eles', true);
            r.redrawHint('drag', true);
        }
        r.prevPxRatio = pixelRatio;
    }
    if (!forcedContext && r.motionBlurTimeout) clearTimeout(r.motionBlurTimeout);
    if (motionBlur) {
        if (r.mbFrames == null) r.mbFrames = 0;
        r.mbFrames++;
        if (r.mbFrames < 3) // need several frames before even high quality motionblur
        motionBlurFadeEffect = false;
        // go to lower quality blurry frames when several m/b frames have been rendered (avoids flashing)
        if (r.mbFrames > r.minMbLowQualFrames) //r.fullQualityMb = false;
        r.motionBlurPxRatio = r.mbPxRBlurry;
    }
    if (r.clearingMotionBlur) r.motionBlurPxRatio = 1;
    // b/c drawToContext() may be async w.r.t. redraw(), keep track of last texture frame
    // because a rogue async texture frame would clear needDraw
    if (r.textureDrawLastFrame && !textureDraw) {
        needDraw[r.NODE] = true;
        needDraw[r.SELECT_BOX] = true;
    }
    var style = cy.style();
    var zoom = cy.zoom();
    var effectiveZoom = forcedZoom !== undefined ? forcedZoom : zoom;
    var pan = cy.pan();
    var effectivePan = {
        x: pan.x,
        y: pan.y
    };
    var vp = {
        zoom: zoom,
        pan: {
            x: pan.x,
            y: pan.y
        }
    };
    var prevVp = r.prevViewport;
    var viewportIsDiff = prevVp === undefined || vp.zoom !== prevVp.zoom || vp.pan.x !== prevVp.pan.x || vp.pan.y !== prevVp.pan.y;
    // we want the low quality motionblur only when the viewport is being manipulated etc (where it's not noticed)
    if (!viewportIsDiff && !(inNodeDragGesture && !hasCompoundNodes)) r.motionBlurPxRatio = 1;
    if (forcedPan) effectivePan = forcedPan;
    // apply pixel ratio
    effectiveZoom *= pixelRatio;
    effectivePan.x *= pixelRatio;
    effectivePan.y *= pixelRatio;
    var eles = r.getCachedZSortedEles();
    function mbclear(context, x, y, w, h) {
        var gco = context.globalCompositeOperation;
        context.globalCompositeOperation = 'destination-out';
        r.colorFillStyle(context, 255, 255, 255, r.motionBlurTransparency);
        context.fillRect(x, y, w, h);
        context.globalCompositeOperation = gco;
    }
    function setContextTransform(context, clear) {
        var ePan, eZoom, w, h;
        if (!r.clearingMotionBlur && (context === data.bufferContexts[r.MOTIONBLUR_BUFFER_NODE] || context === data.bufferContexts[r.MOTIONBLUR_BUFFER_DRAG])) {
            ePan = {
                x: pan.x * mbPxRatio,
                y: pan.y * mbPxRatio
            };
            eZoom = zoom * mbPxRatio;
            w = r.canvasWidth * mbPxRatio;
            h = r.canvasHeight * mbPxRatio;
        } else {
            ePan = effectivePan;
            eZoom = effectiveZoom;
            w = r.canvasWidth;
            h = r.canvasHeight;
        }
        context.setTransform(1, 0, 0, 1, 0, 0);
        if (clear === 'motionBlur') mbclear(context, 0, 0, w, h);
        else if (!forcedContext && (clear === undefined || clear)) context.clearRect(0, 0, w, h);
        if (!drawAllLayers) {
            context.translate(ePan.x, ePan.y);
            context.scale(eZoom, eZoom);
        }
        if (forcedPan) context.translate(forcedPan.x, forcedPan.y);
        if (forcedZoom) context.scale(forcedZoom, forcedZoom);
    }
    if (!textureDraw) r.textureDrawLastFrame = false;
    if (textureDraw) {
        r.textureDrawLastFrame = true;
        if (!r.textureCache) {
            r.textureCache = {};
            r.textureCache.bb = cy.mutableElements().boundingBox();
            r.textureCache.texture = r.data.bufferCanvases[r.TEXTURE_BUFFER];
            var cxt = r.data.bufferContexts[r.TEXTURE_BUFFER];
            cxt.setTransform(1, 0, 0, 1, 0, 0);
            cxt.clearRect(0, 0, r.canvasWidth * r.textureMult, r.canvasHeight * r.textureMult);
            r.render({
                forcedContext: cxt,
                drawOnlyNodeLayer: true,
                forcedPxRatio: pixelRatio * r.textureMult
            });
            var vp = r.textureCache.viewport = {
                zoom: cy.zoom(),
                pan: cy.pan(),
                width: r.canvasWidth,
                height: r.canvasHeight
            };
            vp.mpan = {
                x: (0 - vp.pan.x) / vp.zoom,
                y: (0 - vp.pan.y) / vp.zoom
            };
        }
        needDraw[r.DRAG] = false;
        needDraw[r.NODE] = false;
        var context = data.contexts[r.NODE];
        var texture = r.textureCache.texture;
        var vp = r.textureCache.viewport;
        context.setTransform(1, 0, 0, 1, 0, 0);
        if (motionBlur) mbclear(context, 0, 0, vp.width, vp.height);
        else context.clearRect(0, 0, vp.width, vp.height);
        var outsideBgColor = style.core('outside-texture-bg-color').value;
        var outsideBgOpacity = style.core('outside-texture-bg-opacity').value;
        r.colorFillStyle(context, outsideBgColor[0], outsideBgColor[1], outsideBgColor[2], outsideBgOpacity);
        context.fillRect(0, 0, vp.width, vp.height);
        var zoom = cy.zoom();
        setContextTransform(context, false);
        context.clearRect(vp.mpan.x, vp.mpan.y, vp.width / vp.zoom / pixelRatio, vp.height / vp.zoom / pixelRatio);
        context.drawImage(texture, vp.mpan.x, vp.mpan.y, vp.width / vp.zoom / pixelRatio, vp.height / vp.zoom / pixelRatio);
    } else if (r.textureOnViewport && !forcedContext) // clear the cache since we don't need it
    r.textureCache = null;
    var extent = cy.extent();
    var vpManip = r.pinching || r.hoverData.dragging || r.swipePanning || r.data.wheelZooming || r.hoverData.draggingEles || r.cy.animated();
    var hideEdges = r.hideEdgesOnViewport && vpManip;
    var needMbClear = [];
    needMbClear[r.NODE] = !needDraw[r.NODE] && motionBlur && !r.clearedForMotionBlur[r.NODE] || r.clearingMotionBlur;
    if (needMbClear[r.NODE]) r.clearedForMotionBlur[r.NODE] = true;
    needMbClear[r.DRAG] = !needDraw[r.DRAG] && motionBlur && !r.clearedForMotionBlur[r.DRAG] || r.clearingMotionBlur;
    if (needMbClear[r.DRAG]) r.clearedForMotionBlur[r.DRAG] = true;
    if (needDraw[r.NODE] || drawAllLayers || drawOnlyNodeLayer || needMbClear[r.NODE]) {
        var useBuffer = motionBlur && !needMbClear[r.NODE] && mbPxRatio !== 1;
        var context = forcedContext || (useBuffer ? r.data.bufferContexts[r.MOTIONBLUR_BUFFER_NODE] : data.contexts[r.NODE]);
        var clear = motionBlur && !useBuffer ? 'motionBlur' : undefined;
        setContextTransform(context, clear);
        if (hideEdges) r.drawCachedNodes(context, eles.nondrag, pixelRatio, extent);
        else r.drawLayeredElements(context, eles.nondrag, pixelRatio, extent);
        if (r.debug) r.drawDebugPoints(context, eles.nondrag);
        if (!drawAllLayers && !motionBlur) needDraw[r.NODE] = false;
    }
    if (!drawOnlyNodeLayer && (needDraw[r.DRAG] || drawAllLayers || needMbClear[r.DRAG])) {
        var useBuffer = motionBlur && !needMbClear[r.DRAG] && mbPxRatio !== 1;
        var context = forcedContext || (useBuffer ? r.data.bufferContexts[r.MOTIONBLUR_BUFFER_DRAG] : data.contexts[r.DRAG]);
        setContextTransform(context, motionBlur && !useBuffer ? 'motionBlur' : undefined);
        if (hideEdges) r.drawCachedNodes(context, eles.drag, pixelRatio, extent);
        else r.drawCachedElements(context, eles.drag, pixelRatio, extent);
        if (r.debug) r.drawDebugPoints(context, eles.drag);
        if (!drawAllLayers && !motionBlur) needDraw[r.DRAG] = false;
    }
    this.drawSelectionRectangle(options, setContextTransform);
    // motionblur: blit rendered blurry frames
    if (motionBlur && mbPxRatio !== 1) {
        var cxtNode = data.contexts[r.NODE];
        var txtNode = r.data.bufferCanvases[r.MOTIONBLUR_BUFFER_NODE];
        var cxtDrag = data.contexts[r.DRAG];
        var txtDrag = r.data.bufferCanvases[r.MOTIONBLUR_BUFFER_DRAG];
        var drawMotionBlur = function drawMotionBlur(cxt, txt, needClear) {
            cxt.setTransform(1, 0, 0, 1, 0, 0);
            if (needClear || !motionBlurFadeEffect) cxt.clearRect(0, 0, r.canvasWidth, r.canvasHeight);
            else mbclear(cxt, 0, 0, r.canvasWidth, r.canvasHeight);
            var pxr = mbPxRatio;
            cxt.drawImage(txt, // img
            0, 0, // sx, sy
            r.canvasWidth * pxr, r.canvasHeight * pxr, // sw, sh
            0, 0, // x, y
            r.canvasWidth, r.canvasHeight // w, h
            );
        };
        if (needDraw[r.NODE] || needMbClear[r.NODE]) {
            drawMotionBlur(cxtNode, txtNode, needMbClear[r.NODE]);
            needDraw[r.NODE] = false;
        }
        if (needDraw[r.DRAG] || needMbClear[r.DRAG]) {
            drawMotionBlur(cxtDrag, txtDrag, needMbClear[r.DRAG]);
            needDraw[r.DRAG] = false;
        }
    }
    r.prevViewport = vp;
    if (r.clearingMotionBlur) {
        r.clearingMotionBlur = false;
        r.motionBlurCleared = true;
        r.motionBlur = true;
    }
    if (motionBlur) r.motionBlurTimeout = setTimeout(function() {
        r.motionBlurTimeout = null;
        r.clearedForMotionBlur[r.NODE] = false;
        r.clearedForMotionBlur[r.DRAG] = false;
        r.motionBlur = false;
        r.clearingMotionBlur = !textureDraw;
        r.mbFrames = 0;
        needDraw[r.NODE] = true;
        needDraw[r.DRAG] = true;
        r.redraw();
    }, $e815fda779bc047b$var$motionBlurDelay);
    if (!forcedContext) cy.emit('render');
};
var $e815fda779bc047b$var$fpsHeight;
$e815fda779bc047b$var$CRp$5.drawSelectionRectangle = function(options, setContextTransform) {
    var r = this;
    var cy = r.cy;
    var data = r.data;
    var style = cy.style();
    var drawOnlyNodeLayer = options.drawOnlyNodeLayer;
    var drawAllLayers = options.drawAllLayers;
    var needDraw = data.canvasNeedsRedraw;
    var forcedContext = options.forcedContext;
    if (r.showFps || !drawOnlyNodeLayer && needDraw[r.SELECT_BOX] && !drawAllLayers) {
        var context = forcedContext || data.contexts[r.SELECT_BOX];
        setContextTransform(context);
        if (r.selection[4] == 1 && (r.hoverData.selecting || r.touchData.selecting)) {
            var zoom = r.cy.zoom();
            var borderWidth = style.core('selection-box-border-width').value / zoom;
            context.lineWidth = borderWidth;
            context.fillStyle = 'rgba(' + style.core('selection-box-color').value[0] + ',' + style.core('selection-box-color').value[1] + ',' + style.core('selection-box-color').value[2] + ',' + style.core('selection-box-opacity').value + ')';
            context.fillRect(r.selection[0], r.selection[1], r.selection[2] - r.selection[0], r.selection[3] - r.selection[1]);
            if (borderWidth > 0) {
                context.strokeStyle = 'rgba(' + style.core('selection-box-border-color').value[0] + ',' + style.core('selection-box-border-color').value[1] + ',' + style.core('selection-box-border-color').value[2] + ',' + style.core('selection-box-opacity').value + ')';
                context.strokeRect(r.selection[0], r.selection[1], r.selection[2] - r.selection[0], r.selection[3] - r.selection[1]);
            }
        }
        if (data.bgActivePosistion && !r.hoverData.selecting) {
            var zoom = r.cy.zoom();
            var pos = data.bgActivePosistion;
            context.fillStyle = 'rgba(' + style.core('active-bg-color').value[0] + ',' + style.core('active-bg-color').value[1] + ',' + style.core('active-bg-color').value[2] + ',' + style.core('active-bg-opacity').value + ')';
            context.beginPath();
            context.arc(pos.x, pos.y, style.core('active-bg-size').pfValue / zoom, 0, 2 * Math.PI);
            context.fill();
        }
        var timeToRender = r.lastRedrawTime;
        if (r.showFps && timeToRender) {
            timeToRender = Math.round(timeToRender);
            var fps = Math.round(1000 / timeToRender);
            var text = '1 frame = ' + timeToRender + ' ms = ' + fps + ' fps';
            context.setTransform(1, 0, 0, 1, 0, 0);
            context.fillStyle = 'rgba(255, 0, 0, 0.75)';
            context.strokeStyle = 'rgba(255, 0, 0, 0.75)';
            // context.lineWidth = 1;
            context.font = '30px Arial';
            if (!$e815fda779bc047b$var$fpsHeight) {
                var dims = context.measureText(text);
                $e815fda779bc047b$var$fpsHeight = dims.actualBoundingBoxAscent;
            }
            context.fillText(text, 0, $e815fda779bc047b$var$fpsHeight);
            var maxFps = 60;
            context.strokeRect(0, $e815fda779bc047b$var$fpsHeight + 10, 250, 20);
            context.fillRect(0, $e815fda779bc047b$var$fpsHeight + 10, 250 * Math.min(fps / maxFps, 1), 20);
        }
        if (!drawAllLayers) needDraw[r.SELECT_BOX] = false;
    }
};
/**
 * Notes:
 * - All colors have premultiplied alpha. Very important for textues and 
 *   blending to work correctly.
 */ function $e815fda779bc047b$var$compileShader(gl, type, source) {
    var shader = gl.createShader(type);
    gl.shaderSource(shader, source);
    gl.compileShader(shader);
    if (!gl.getShaderParameter(shader, gl.COMPILE_STATUS)) throw new Error(gl.getShaderInfoLog(shader));
    // console.log(gl.getShaderInfoLog(shader));
    return shader;
}
function $e815fda779bc047b$var$createProgram(gl, vertexSource, fragementSource) {
    var vertexShader = $e815fda779bc047b$var$compileShader(gl, gl.VERTEX_SHADER, vertexSource);
    var fragmentShader = $e815fda779bc047b$var$compileShader(gl, gl.FRAGMENT_SHADER, fragementSource);
    var program = gl.createProgram();
    gl.attachShader(program, vertexShader);
    gl.attachShader(program, fragmentShader);
    gl.linkProgram(program);
    if (!gl.getProgramParameter(program, gl.LINK_STATUS)) throw new Error('Could not initialize shaders');
    return program;
}
/**
 * Creates an offscren canvas with a 2D context, for the
 * canvas renderer to use for drawing textures.
 */ function $e815fda779bc047b$var$createTextureCanvas(r, width, height) {
    if (height === undefined) height = width;
    var canvas = r.makeOffscreenCanvas(width, height);
    var ctx = canvas.context = canvas.getContext('2d');
    canvas.clear = function() {
        return ctx.clearRect(0, 0, canvas.width, canvas.height);
    };
    canvas.clear();
    return canvas;
}
/**
 * Returns the current pan & zoom values, scaled by the pixel ratio.
 */ function $e815fda779bc047b$var$getEffectivePanZoom(r) {
    var pixelRatio = r.pixelRatio;
    var zoom = r.cy.zoom();
    var pan = r.cy.pan();
    return {
        zoom: zoom * pixelRatio,
        pan: {
            x: pan.x * pixelRatio,
            y: pan.y * pixelRatio
        }
    };
}
/**
 * Returns the zoom value, scaled by the pixel ratio.
 */ function $e815fda779bc047b$var$getEffectiveZoom(r) {
    var pixelRatio = r.pixelRatio;
    var zoom = r.cy.zoom();
    return zoom * pixelRatio;
}
function $e815fda779bc047b$var$modelToRenderedPosition(r, pan, zoom, x, y) {
    var rx = x * zoom + pan.x;
    var ry = y * zoom + pan.y;
    ry = Math.round(r.canvasHeight - ry); // adjust for webgl
    return [
        rx,
        ry
    ];
}
function $e815fda779bc047b$var$isSimpleShape(node) {
    // the actual shape is checked in ElementDrawingWebGL._getVertTypeForShape()
    // no need to check it twice, this just checks other visual properties
    if (node.pstyle('background-fill').value !== 'solid') return false;
    if (node.pstyle('background-image').strValue !== 'none') return false;
    if (node.pstyle('border-width').value === 0) return true;
    if (node.pstyle('border-opacity').value === 0) return true;
    // we have a border but it must be simple
    if (node.pstyle('border-style').value !== 'solid') return false;
    // TODO ignoring 'border-cap', 'border-join' and 'border-position' for now
    return true;
}
function $e815fda779bc047b$var$arrayEqual(a1, a2) {
    if (a1.length !== a2.length) return false;
    for(var i = 0; i < a1.length; i++){
        if (a1[i] !== a2[i]) return false;
    }
    return true;
}
/**
 * Takes color & opacity style values and converts them to WebGL format. 
 * Alpha is premultiplied.
 */ function $e815fda779bc047b$var$toWebGLColor(color, opacity, outArray) {
    var r = color[0] / 255;
    var g = color[1] / 255;
    var b = color[2] / 255;
    var a = opacity;
    var arr = outArray || new Array(4);
    arr[0] = r * a;
    arr[1] = g * a;
    arr[2] = b * a;
    arr[3] = a;
    return arr;
}
function $e815fda779bc047b$var$indexToVec4(index, outArray) {
    var arr = outArray || new Array(4);
    arr[0] = (index >> 0 & 0xFF) / 0xFF;
    arr[1] = (index >> 8 & 0xFF) / 0xFF;
    arr[2] = (index >> 16 & 0xFF) / 0xFF;
    arr[3] = (index >> 24 & 0xFF) / 0xFF;
    return arr;
}
function $e815fda779bc047b$var$vec4ToIndex(vec4) {
    return vec4[0] + (vec4[1] << 8) + (vec4[2] << 16) + (vec4[3] << 24);
}
function $e815fda779bc047b$var$createTexture(gl, debugID) {
    var texture = gl.createTexture();
    texture.buffer = function(offscreenCanvas) {
        gl.bindTexture(gl.TEXTURE_2D, texture);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR_MIPMAP_NEAREST);
        // very important, this tells webgl to premultiply colors by the alpha channel
        gl.pixelStorei(gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, true);
        gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, offscreenCanvas);
        gl.generateMipmap(gl.TEXTURE_2D);
        gl.bindTexture(gl.TEXTURE_2D, null);
    };
    texture.deleteTexture = function() {
        gl.deleteTexture(texture);
    };
    return texture;
}
function $e815fda779bc047b$var$getTypeInfo(gl, glslType) {
    switch(glslType){
        case 'float':
            return [
                1,
                gl.FLOAT,
                4
            ];
        case 'vec2':
            return [
                2,
                gl.FLOAT,
                4
            ];
        case 'vec3':
            return [
                3,
                gl.FLOAT,
                4
            ];
        case 'vec4':
            return [
                4,
                gl.FLOAT,
                4
            ];
        case 'int':
            return [
                1,
                gl.INT,
                4
            ];
        case 'ivec2':
            return [
                2,
                gl.INT,
                4
            ];
    }
}
function $e815fda779bc047b$var$createTypedArray(gl, glType, dataOrSize) {
    switch(glType){
        case gl.FLOAT:
            return new Float32Array(dataOrSize);
        case gl.INT:
            return new Int32Array(dataOrSize);
    }
}
function $e815fda779bc047b$var$createTypedArrayView(gl, glType, array, stride, size, i) {
    switch(glType){
        case gl.FLOAT:
            return new Float32Array(array.buffer, i * stride, size);
        case gl.INT:
            return new Int32Array(array.buffer, i * stride, size);
    }
}
/** @param {WebGLRenderingContext} gl */ function $e815fda779bc047b$var$createBufferStaticDraw(gl, type, attributeLoc, dataArray) {
    var _getTypeInfo = $e815fda779bc047b$var$getTypeInfo(gl, type), _getTypeInfo2 = $e815fda779bc047b$var$_slicedToArray(_getTypeInfo, 2), size = _getTypeInfo2[0], glType = _getTypeInfo2[1];
    var data = $e815fda779bc047b$var$createTypedArray(gl, glType, dataArray);
    var buffer = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
    gl.bufferData(gl.ARRAY_BUFFER, data, gl.STATIC_DRAW);
    if (glType === gl.FLOAT) gl.vertexAttribPointer(attributeLoc, size, glType, false, 0, 0);
    else if (glType === gl.INT) gl.vertexAttribIPointer(attributeLoc, size, glType, 0, 0);
    gl.enableVertexAttribArray(attributeLoc);
    gl.bindBuffer(gl.ARRAY_BUFFER, null);
    return buffer;
}
/** 
 * Creates a float buffer with gl.DYNAMIC_DRAW.
 * The returned buffer object contains functions to easily set instance data and buffer the data before a draw call.
 * @param {WebGLRenderingContext} gl 
 */ function $e815fda779bc047b$var$createBufferDynamicDraw(gl, instances, type, attributeLoc) {
    var _getTypeInfo3 = $e815fda779bc047b$var$getTypeInfo(gl, type), _getTypeInfo4 = $e815fda779bc047b$var$_slicedToArray(_getTypeInfo3, 3), size = _getTypeInfo4[0], glType = _getTypeInfo4[1], bytes = _getTypeInfo4[2];
    var dataArray = $e815fda779bc047b$var$createTypedArray(gl, glType, instances * size);
    var stride = size * bytes;
    var buffer = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
    gl.bufferData(gl.ARRAY_BUFFER, instances * stride, gl.DYNAMIC_DRAW);
    gl.enableVertexAttribArray(attributeLoc);
    if (glType === gl.FLOAT) gl.vertexAttribPointer(attributeLoc, size, glType, false, stride, 0);
    else if (glType === gl.INT) gl.vertexAttribIPointer(attributeLoc, size, glType, stride, 0);
    gl.vertexAttribDivisor(attributeLoc, 1);
    gl.bindBuffer(gl.ARRAY_BUFFER, null);
    // use array views to set values directly into the buffer array
    var views = new Array(instances);
    for(var i = 0; i < instances; i++)views[i] = $e815fda779bc047b$var$createTypedArrayView(gl, glType, dataArray, stride, size, i);
    buffer.dataArray = dataArray;
    buffer.stride = stride;
    buffer.size = size;
    buffer.getView = function(i) {
        return views[i];
    };
    buffer.setPoint = function(i, x, y) {
        var view = views[i];
        view[0] = x;
        view[1] = y;
    };
    buffer.bufferSubData = function(count) {
        gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
        if (count) gl.bufferSubData(gl.ARRAY_BUFFER, 0, dataArray, 0, count * size);
        else gl.bufferSubData(gl.ARRAY_BUFFER, 0, dataArray);
    };
    return buffer;
}
/** 
 * Creates a buffer of 3x3 matrix data for use as attribute data.
 * @param {WebGLRenderingContext} gl 
 */ function $e815fda779bc047b$var$create3x3MatrixBufferDynamicDraw(gl, instances, attributeLoc) {
    var matrixSize = 9; // 3x3 matrix
    var matrixData = new Float32Array(instances * matrixSize);
    // use matrix views to set values directly into the matrixData array
    var matrixViews = new Array(instances);
    for(var i = 0; i < instances; i++){
        var byteOffset = i * matrixSize * 4; // 4 bytes per float
        matrixViews[i] = new Float32Array(matrixData.buffer, byteOffset, matrixSize); // array view
    }
    var buffer = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
    gl.bufferData(gl.ARRAY_BUFFER, matrixData.byteLength, gl.DYNAMIC_DRAW);
    // each row of the matrix needs to be a separate attribute
    for(var _i = 0; _i < 3; _i++){
        var loc = attributeLoc + _i;
        gl.enableVertexAttribArray(loc);
        gl.vertexAttribPointer(loc, 3, gl.FLOAT, false, 36, _i * 12);
        gl.vertexAttribDivisor(loc, 1);
    }
    gl.bindBuffer(gl.ARRAY_BUFFER, null);
    buffer.getMatrixView = function(i) {
        return matrixViews[i];
    };
    // TODO this is too slow, use getMatrixView and pass the view directly to the glmatrix library
    buffer.setData = function(matrix, i) {
        matrixViews[i].set(matrix, 0);
    };
    buffer.bufferSubData = function() {
        gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
        gl.bufferSubData(gl.ARRAY_BUFFER, 0, matrixData);
    };
    return buffer;
}
/** 
 * Creates a Frame Buffer to use for offscreen rendering.
 * @param {WebGLRenderingContext} gl 
 */ function $e815fda779bc047b$var$createPickingFrameBuffer(gl) {
    // Create and bind the framebuffer
    var fb = gl.createFramebuffer();
    gl.bindFramebuffer(gl.FRAMEBUFFER, fb);
    // Create a texture to render to
    var targetTexture = gl.createTexture();
    gl.bindTexture(gl.TEXTURE_2D, targetTexture);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
    // attach the texture as the first color attachment
    gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, targetTexture, 0);
    gl.bindFramebuffer(gl.FRAMEBUFFER, null);
    fb.setFramebufferAttachmentSizes = function(width, height) {
        gl.bindTexture(gl.TEXTURE_2D, targetTexture);
        gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, width, height, 0, gl.RGBA, gl.UNSIGNED_BYTE, null);
    };
    return fb;
}
/**
 * Common utilities
 * @module glMatrix
 */ // Configuration Constants
var $e815fda779bc047b$var$ARRAY_TYPE = typeof Float32Array !== 'undefined' ? Float32Array : Array;
if (!Math.hypot) Math.hypot = function() {
    var y = 0, i = arguments.length;
    while(i--)y += arguments[i] * arguments[i];
    return Math.sqrt(y);
};
/**
 * 3x3 Matrix
 * @module mat3
 */ /**
 * Creates a new identity mat3
 *
 * @returns {mat3} a new 3x3 matrix
 */ function $e815fda779bc047b$var$create() {
    var out = new $e815fda779bc047b$var$ARRAY_TYPE(9);
    if ($e815fda779bc047b$var$ARRAY_TYPE != Float32Array) {
        out[1] = 0;
        out[2] = 0;
        out[3] = 0;
        out[5] = 0;
        out[6] = 0;
        out[7] = 0;
    }
    out[0] = 1;
    out[4] = 1;
    out[8] = 1;
    return out;
}
/**
 * Set a mat3 to the identity matrix
 *
 * @param {mat3} out the receiving matrix
 * @returns {mat3} out
 */ function $e815fda779bc047b$var$identity(out) {
    out[0] = 1;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 1;
    out[5] = 0;
    out[6] = 0;
    out[7] = 0;
    out[8] = 1;
    return out;
}
/**
 * Multiplies two mat3's
 *
 * @param {mat3} out the receiving matrix
 * @param {ReadonlyMat3} a the first operand
 * @param {ReadonlyMat3} b the second operand
 * @returns {mat3} out
 */ function $e815fda779bc047b$var$multiply(out, a, b) {
    var a00 = a[0], a01 = a[1], a02 = a[2];
    var a10 = a[3], a11 = a[4], a12 = a[5];
    var a20 = a[6], a21 = a[7], a22 = a[8];
    var b00 = b[0], b01 = b[1], b02 = b[2];
    var b10 = b[3], b11 = b[4], b12 = b[5];
    var b20 = b[6], b21 = b[7], b22 = b[8];
    out[0] = b00 * a00 + b01 * a10 + b02 * a20;
    out[1] = b00 * a01 + b01 * a11 + b02 * a21;
    out[2] = b00 * a02 + b01 * a12 + b02 * a22;
    out[3] = b10 * a00 + b11 * a10 + b12 * a20;
    out[4] = b10 * a01 + b11 * a11 + b12 * a21;
    out[5] = b10 * a02 + b11 * a12 + b12 * a22;
    out[6] = b20 * a00 + b21 * a10 + b22 * a20;
    out[7] = b20 * a01 + b21 * a11 + b22 * a21;
    out[8] = b20 * a02 + b21 * a12 + b22 * a22;
    return out;
}
/**
 * Translate a mat3 by the given vector
 *
 * @param {mat3} out the receiving matrix
 * @param {ReadonlyMat3} a the matrix to translate
 * @param {ReadonlyVec2} v vector to translate by
 * @returns {mat3} out
 */ function $e815fda779bc047b$var$translate(out, a, v) {
    var a00 = a[0], a01 = a[1], a02 = a[2], a10 = a[3], a11 = a[4], a12 = a[5], a20 = a[6], a21 = a[7], a22 = a[8], x = v[0], y = v[1];
    out[0] = a00;
    out[1] = a01;
    out[2] = a02;
    out[3] = a10;
    out[4] = a11;
    out[5] = a12;
    out[6] = x * a00 + y * a10 + a20;
    out[7] = x * a01 + y * a11 + a21;
    out[8] = x * a02 + y * a12 + a22;
    return out;
}
/**
 * Rotates a mat3 by the given angle
 *
 * @param {mat3} out the receiving matrix
 * @param {ReadonlyMat3} a the matrix to rotate
 * @param {Number} rad the angle to rotate the matrix by
 * @returns {mat3} out
 */ function $e815fda779bc047b$var$rotate(out, a, rad) {
    var a00 = a[0], a01 = a[1], a02 = a[2], a10 = a[3], a11 = a[4], a12 = a[5], a20 = a[6], a21 = a[7], a22 = a[8], s = Math.sin(rad), c = Math.cos(rad);
    out[0] = c * a00 + s * a10;
    out[1] = c * a01 + s * a11;
    out[2] = c * a02 + s * a12;
    out[3] = c * a10 - s * a00;
    out[4] = c * a11 - s * a01;
    out[5] = c * a12 - s * a02;
    out[6] = a20;
    out[7] = a21;
    out[8] = a22;
    return out;
}
/**
 * Scales the mat3 by the dimensions in the given vec2
 *
 * @param {mat3} out the receiving matrix
 * @param {ReadonlyMat3} a the matrix to rotate
 * @param {ReadonlyVec2} v the vec2 to scale the matrix by
 * @returns {mat3} out
 **/ function $e815fda779bc047b$var$scale(out, a, v) {
    var x = v[0], y = v[1];
    out[0] = x * a[0];
    out[1] = x * a[1];
    out[2] = x * a[2];
    out[3] = y * a[3];
    out[4] = y * a[4];
    out[5] = y * a[5];
    out[6] = a[6];
    out[7] = a[7];
    out[8] = a[8];
    return out;
}
/**
 * Generates a 2D projection matrix with the given bounds
 *
 * @param {mat3} out mat3 frustum matrix will be written into
 * @param {number} width Width of your gl context
 * @param {number} height Height of gl context
 * @returns {mat3} out
 */ function $e815fda779bc047b$var$projection(out, width, height) {
    out[0] = 2 / width;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = -2 / height;
    out[5] = 0;
    out[6] = -1;
    out[7] = 1;
    out[8] = 1;
    return out;
}
// A "texture atlas" is a big canvas, and sections of it are used as textures for nodes/labels.
/**
 * A single square texture atlas (also known as a "sprite sheet").
 */ var $e815fda779bc047b$var$Atlas = /*#__PURE__*/ function() {
    function Atlas(r, texSize, texRows, createTextureCanvas) {
        $e815fda779bc047b$var$_classCallCheck(this, Atlas);
        this.debugID = Math.floor(Math.random() * 10000);
        this.r = r;
        this.texSize = texSize;
        this.texRows = texRows;
        this.texHeight = Math.floor(texSize / texRows);
        this.enableWrapping = true; // hardcoded for now, can be made an option
        this.locked = false; // once an atlas is locked it can no longer be drawn to
        this.texture = null; // WebGLTexture object
        this.needsBuffer = true;
        // a "location" is an pointer into the atlas with a 'row' and 'x' fields
        this.freePointer = {
            x: 0,
            row: 0
        };
        // map from the style key to the row/x where the texture starts
        // if the texture wraps then there's a second location
        this.keyToLocation = new Map(); // styleKey -> [ location, location ]
        this.canvas = createTextureCanvas(r, texSize, texSize);
        this.scratch = createTextureCanvas(r, texSize, this.texHeight, 'scratch');
    }
    return $e815fda779bc047b$var$_createClass(Atlas, [
        {
            key: "lock",
            value: function lock() {
                this.locked = true;
            }
        },
        {
            key: "getKeys",
            value: function getKeys() {
                return new Set(this.keyToLocation.keys());
            }
        },
        {
            key: "getScale",
            value: function getScale(_ref) {
                var w = _ref.w, h = _ref.h;
                var texHeight = this.texHeight, maxTexWidth = this.texSize;
                // try to fit to the height of a row
                var scale = texHeight / h; // TODO what about pixelRatio?
                var texW = w * scale;
                var texH = h * scale;
                // if the scaled width is too wide then scale to fit max width instead
                if (texW > maxTexWidth) {
                    scale = maxTexWidth / w;
                    texW = w * scale;
                    texH = h * scale;
                }
                return {
                    scale: scale,
                    texW: texW,
                    texH: texH
                };
            }
        },
        {
            key: "draw",
            value: function draw(key, bb, doDrawing) {
                var _this = this;
                if (this.locked) throw new Error('can\'t draw, atlas is locked');
                var texSize = this.texSize, texRows = this.texRows, texHeight = this.texHeight;
                var _this$getScale = this.getScale(bb), scale = _this$getScale.scale, texW = _this$getScale.texW, texH = _this$getScale.texH;
                var drawAt = function drawAt(location, canvas) {
                    if (doDrawing && canvas) {
                        var context = canvas.context;
                        var x = location.x, row = location.row;
                        var xOffset = x;
                        var yOffset = texHeight * row;
                        context.save();
                        context.translate(xOffset, yOffset);
                        context.scale(scale, scale);
                        doDrawing(context, bb);
                        context.restore();
                    }
                };
                var locations = [
                    null,
                    null
                ];
                var drawNormal = function drawNormal() {
                    // don't need to wrap, draw directly on the canvas
                    drawAt(_this.freePointer, _this.canvas);
                    locations[0] = {
                        x: _this.freePointer.x,
                        y: _this.freePointer.row * texHeight,
                        w: texW,
                        h: texH
                    };
                    locations[1] = {
                        // create a second location with a width of 0, for convenience
                        x: _this.freePointer.x + texW,
                        y: _this.freePointer.row * texHeight,
                        w: 0,
                        h: texH
                    };
                    // move the pointer to the end of the texture
                    _this.freePointer.x += texW;
                    if (_this.freePointer.x == texSize) {
                        _this.freePointer.x = 0;
                        _this.freePointer.row++;
                    }
                };
                var drawWrapped = function drawWrapped() {
                    var scratch = _this.scratch, canvas = _this.canvas;
                    // Draw to the scratch canvas
                    scratch.clear();
                    drawAt({
                        x: 0,
                        row: 0
                    }, scratch);
                    var firstTexW = texSize - _this.freePointer.x;
                    var secondTexW = texW - firstTexW;
                    var h = texHeight;
                    // copy first part of scratch to the first texture
                    var dx = _this.freePointer.x;
                    var dy = _this.freePointer.row * texHeight;
                    var w = firstTexW;
                    canvas.context.drawImage(scratch, 0, 0, w, h, dx, dy, w, h);
                    locations[0] = {
                        x: dx,
                        y: dy,
                        w: w,
                        h: texH
                    };
                    // copy second part of scratch to the second texture
                    var sx = firstTexW;
                    var _dy = (_this.freePointer.row + 1) * texHeight;
                    var _w = secondTexW;
                    if (canvas) canvas.context.drawImage(scratch, sx, 0, _w, h, 0, _dy, _w, h);
                    locations[1] = {
                        x: 0,
                        y: _dy,
                        w: _w,
                        h: texH
                    };
                    _this.freePointer.x = secondTexW;
                    _this.freePointer.row++;
                };
                var moveToStartOfNextRow = function moveToStartOfNextRow() {
                    _this.freePointer.x = 0;
                    _this.freePointer.row++;
                };
                if (this.freePointer.x + texW <= texSize) // There's enough space in the current row
                drawNormal();
                else if (this.freePointer.row >= texRows - 1) // Need to move to the next row, but there are no more rows, atlas is full.
                return false;
                else if (this.freePointer.x === texSize) {
                    // happen to be right at end of current row
                    moveToStartOfNextRow();
                    drawNormal();
                } else if (this.enableWrapping) // draw part of the texture to the end of the curent row, then wrap to the next row
                drawWrapped();
                else {
                    // move to the start of the next row, then draw normally
                    moveToStartOfNextRow();
                    drawNormal();
                }
                this.keyToLocation.set(key, locations);
                this.needsBuffer = true;
                return locations;
            }
        },
        {
            key: "getOffsets",
            value: function getOffsets(key) {
                return this.keyToLocation.get(key);
            }
        },
        {
            key: "isEmpty",
            value: function isEmpty() {
                return this.freePointer.x === 0 && this.freePointer.row === 0;
            }
        },
        {
            key: "canFit",
            value: function canFit(bb) {
                if (this.locked) return false;
                var texSize = this.texSize, texRows = this.texRows;
                var _this$getScale2 = this.getScale(bb), texW = _this$getScale2.texW;
                if (this.freePointer.x + texW > texSize) // need to wrap
                return this.freePointer.row < texRows - 1; // return true if there's a row to wrap to
                return true;
            }
        },
        {
            key: "bufferIfNeeded",
            value: function bufferIfNeeded(gl) {
                if (!this.texture) this.texture = $e815fda779bc047b$var$createTexture(gl, this.debugID);
                if (this.needsBuffer) {
                    this.texture.buffer(this.canvas);
                    this.needsBuffer = false;
                    if (this.locked) {
                        this.canvas = null;
                        this.scratch = null;
                    }
                }
            }
        },
        {
            key: "dispose",
            value: function dispose() {
                if (this.texture) {
                    this.texture.deleteTexture();
                    this.texture = null;
                }
                this.canvas = null;
                this.scratch = null;
                this.locked = true;
            }
        }
    ]);
}();
/**
 * A collection of texture atlases, all of the same "render type". 
 * ('node-body' is an example of a render type.)
 * An AtlasCollection can also be notified when a texture is no longer needed, 
 * and it can garbage collect the unused textures.
 */ var $e815fda779bc047b$var$AtlasCollection = /*#__PURE__*/ function() {
    function AtlasCollection(r, texSize, texRows, createTextureCanvas) {
        $e815fda779bc047b$var$_classCallCheck(this, AtlasCollection);
        this.r = r;
        this.texSize = texSize;
        this.texRows = texRows;
        this.createTextureCanvas = createTextureCanvas;
        this.atlases = [];
        this.styleKeyToAtlas = new Map();
        this.markedKeys = new Set(); // marked for garbage collection
    }
    return $e815fda779bc047b$var$_createClass(AtlasCollection, [
        {
            key: "getKeys",
            value: function getKeys() {
                return new Set(this.styleKeyToAtlas.keys());
            }
        },
        {
            key: "_createAtlas",
            value: function _createAtlas() {
                var r = this.r, texSize = this.texSize, texRows = this.texRows, createTextureCanvas = this.createTextureCanvas;
                return new $e815fda779bc047b$var$Atlas(r, texSize, texRows, createTextureCanvas);
            }
        },
        {
            key: "_getScratchCanvas",
            value: function _getScratchCanvas() {
                if (!this.scratch) {
                    var r = this.r, texSize = this.texSize, texRows = this.texRows, createTextureCanvas = this.createTextureCanvas;
                    var texHeight = Math.floor(texSize / texRows);
                    this.scratch = createTextureCanvas(r, texSize, texHeight, 'scratch');
                }
                return this.scratch;
            }
        },
        {
            key: "draw",
            value: function draw(key, bb, doDrawing) {
                var atlas = this.styleKeyToAtlas.get(key);
                if (!atlas) {
                    // check for space at the end of the last atlas
                    atlas = this.atlases[this.atlases.length - 1];
                    if (!atlas || !atlas.canFit(bb)) {
                        if (atlas) atlas.lock();
                        // create a new atlas
                        atlas = this._createAtlas();
                        this.atlases.push(atlas);
                    }
                    atlas.draw(key, bb, doDrawing);
                    this.styleKeyToAtlas.set(key, atlas);
                }
                return atlas;
            }
        },
        {
            key: "getAtlas",
            value: function getAtlas(key) {
                return this.styleKeyToAtlas.get(key);
            }
        },
        {
            key: "hasAtlas",
            value: function hasAtlas(key) {
                return this.styleKeyToAtlas.has(key);
            }
        },
        {
            key: "markKeyForGC",
            value: function markKeyForGC(key) {
                this.markedKeys.add(key);
            }
        },
        {
            key: "gc",
            value: function gc() {
                var _this2 = this;
                var markedKeys = this.markedKeys;
                if (markedKeys.size === 0) {
                    console.log('nothing to garbage collect');
                    return;
                }
                var newAtlases = [];
                var newStyleKeyToAtlas = new Map();
                var newAtlas = null;
                var _iterator = $e815fda779bc047b$var$_createForOfIteratorHelper(this.atlases), _step;
                try {
                    var _loop = function _loop() {
                        var atlas = _step.value;
                        var keys = atlas.getKeys();
                        var keysToCollect = $e815fda779bc047b$var$intersection(markedKeys, keys);
                        if (keysToCollect.size === 0) {
                            // this atlas can still be used
                            newAtlases.push(atlas);
                            keys.forEach(function(k) {
                                return newStyleKeyToAtlas.set(k, atlas);
                            });
                            return 1; // continue
                        }
                        if (!newAtlas) {
                            newAtlas = _this2._createAtlas();
                            newAtlases.push(newAtlas);
                        }
                        var _iterator2 = $e815fda779bc047b$var$_createForOfIteratorHelper(keys), _step2;
                        try {
                            for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                                var key = _step2.value;
                                if (!keysToCollect.has(key)) {
                                    var _atlas$getOffsets = atlas.getOffsets(key), _atlas$getOffsets2 = $e815fda779bc047b$var$_slicedToArray(_atlas$getOffsets, 2), s1 = _atlas$getOffsets2[0], s2 = _atlas$getOffsets2[1];
                                    if (!newAtlas.canFit({
                                        w: s1.w + s2.w,
                                        h: s1.h
                                    })) {
                                        newAtlas.lock();
                                        newAtlas = _this2._createAtlas();
                                        newAtlases.push(newAtlas);
                                    }
                                    if (atlas.canvas) {
                                        // if the texture can't be copied then it will have to be redrawn on the next frame
                                        _this2._copyTextureToNewAtlas(key, atlas, newAtlas);
                                        newStyleKeyToAtlas.set(key, newAtlas);
                                    }
                                }
                            }
                        } catch (err) {
                            _iterator2.e(err);
                        } finally{
                            _iterator2.f();
                        }
                        atlas.dispose();
                    };
                    for(_iterator.s(); !(_step = _iterator.n()).done;){
                        if (_loop()) continue;
                    }
                } catch (err) {
                    _iterator.e(err);
                } finally{
                    _iterator.f();
                }
                this.atlases = newAtlases;
                this.styleKeyToAtlas = newStyleKeyToAtlas;
                this.markedKeys = new Set();
            }
        },
        {
            key: "_copyTextureToNewAtlas",
            value: function _copyTextureToNewAtlas(key, oldAtlas, newAtlas) {
                var _oldAtlas$getOffsets = oldAtlas.getOffsets(key), _oldAtlas$getOffsets2 = $e815fda779bc047b$var$_slicedToArray(_oldAtlas$getOffsets, 2), s1 = _oldAtlas$getOffsets2[0], s2 = _oldAtlas$getOffsets2[1];
                if (s2.w === 0) // the texture does not wrap, draw directly to new atlas
                newAtlas.draw(key, s1, function(context) {
                    context.drawImage(oldAtlas.canvas, s1.x, s1.y, s1.w, s1.h, 0, 0, s1.w, s1.h);
                });
                else {
                    // the texture wraps, first draw both parts to a scratch canvas
                    var scratch = this._getScratchCanvas();
                    scratch.clear();
                    scratch.context.drawImage(oldAtlas.canvas, s1.x, s1.y, s1.w, s1.h, 0, 0, s1.w, s1.h);
                    scratch.context.drawImage(oldAtlas.canvas, s2.x, s2.y, s2.w, s2.h, s1.w, 0, s2.w, s2.h);
                    // now draw the scratch to the new atlas
                    var w = s1.w + s2.w;
                    var h = s1.h;
                    newAtlas.draw(key, {
                        w: w,
                        h: h
                    }, function(context) {
                        context.drawImage(scratch, 0, 0, w, h, 0, 0, w, h // the destination context has already been translated to the correct position
                        );
                    });
                }
            }
        },
        {
            key: "getCounts",
            value: function getCounts() {
                return {
                    keyCount: this.styleKeyToAtlas.size,
                    atlasCount: new Set(this.styleKeyToAtlas.values()).size
                };
            }
        }
    ]);
}();
function $e815fda779bc047b$var$intersection(set1, set2) {
    // TODO why no Set.intersection in node 16???
    if (set1.intersection) return set1.intersection(set2);
    else return new Set($e815fda779bc047b$var$_toConsumableArray(set1).filter(function(x) {
        return set2.has(x);
    }));
}
/**
 * Used to manage batches of Atlases for drawing nodes and labels.
 * Supports different types of AtlasCollections for different render types,
 * for example 'node-body' and 'node-label' would be different render types.
 * Render types are kept separate because they will likely need to be garbage collected
 * separately and its not entierly guaranteed that their style keys won't collide.
 */ var $e815fda779bc047b$var$AtlasManager = /*#__PURE__*/ function() {
    function AtlasManager(r, globalOptions) {
        $e815fda779bc047b$var$_classCallCheck(this, AtlasManager);
        this.r = r;
        this.globalOptions = globalOptions;
        this.atlasSize = globalOptions.webglTexSize;
        this.maxAtlasesPerBatch = globalOptions.webglTexPerBatch;
        this.renderTypes = new Map(); // renderType:string -> renderTypeOptions
        this.collections = new Map(); // collectionName:string -> AtlasCollection
        this.typeAndIdToKey = new Map(); // [renderType,id] => Array<style key>
    }
    return $e815fda779bc047b$var$_createClass(AtlasManager, [
        {
            key: "getAtlasSize",
            value: function getAtlasSize() {
                return this.atlasSize;
            }
        },
        {
            key: "addAtlasCollection",
            value: function addAtlasCollection(collectionName, atlasCollectionOptions) {
                var _this$globalOptions = this.globalOptions, webglTexSize = _this$globalOptions.webglTexSize, createTextureCanvas = _this$globalOptions.createTextureCanvas;
                var texRows = atlasCollectionOptions.texRows;
                var cachedCreateTextureCanvas = this._cacheScratchCanvas(createTextureCanvas);
                var atlasCollection = new $e815fda779bc047b$var$AtlasCollection(this.r, webglTexSize, texRows, cachedCreateTextureCanvas);
                this.collections.set(collectionName, atlasCollection);
            }
        },
        {
            key: "addRenderType",
            value: function addRenderType(type, renderTypeOptions) {
                var collection = renderTypeOptions.collection;
                if (!this.collections.has(collection)) throw new Error("invalid atlas collection name '".concat(collection, "'"));
                var atlasCollection = this.collections.get(collection);
                var opts = $e815fda779bc047b$var$extend({
                    type: type,
                    atlasCollection: atlasCollection
                }, renderTypeOptions);
                this.renderTypes.set(type, opts);
            }
        },
        {
            key: "getRenderTypeOpts",
            value: function getRenderTypeOpts(type) {
                return this.renderTypes.get(type);
            }
        },
        {
            key: "getAtlasCollection",
            value: function getAtlasCollection(name) {
                return this.collections.get(name);
            }
        },
        {
            key: "_cacheScratchCanvas",
            value: function _cacheScratchCanvas(createTextureCanvas) {
                // all scratch canvases for the same render type will have the same width and height (ie webglTexRows option)
                // but we'll keep track of the width and height just to be safe
                var prevW = -1;
                var prevH = -1;
                var scratchCanvas = null;
                return function(r, w, h, scratch) {
                    if (scratch) {
                        if (!scratchCanvas || w != prevW || h != prevH) {
                            prevW = w;
                            prevH = h;
                            scratchCanvas = createTextureCanvas(r, w, h);
                        }
                        return scratchCanvas;
                    } else return createTextureCanvas(r, w, h);
                };
            }
        },
        {
            key: "_key",
            value: function _key(renderType, id) {
                return "".concat(renderType, "-").concat(id); // TODO not very efficient
            }
        },
        {
            key: "invalidate",
            value: function invalidate(eles) {
                var _this3 = this;
                var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, _ref2$forceRedraw = _ref2.forceRedraw, forceRedraw = _ref2$forceRedraw === undefined ? false : _ref2$forceRedraw, _ref2$filterEle = _ref2.filterEle, filterEle = _ref2$filterEle === undefined ? function() {
                    return true;
                } : _ref2$filterEle, _ref2$filterType = _ref2.filterType, filterType = _ref2$filterType === undefined ? function() {
                    return true;
                } : _ref2$filterType;
                var needGC = false;
                var runGCNow = false;
                var _iterator3 = $e815fda779bc047b$var$_createForOfIteratorHelper(eles), _step3;
                try {
                    for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                        var ele = _step3.value;
                        if (filterEle(ele)) {
                            var _iterator4 = $e815fda779bc047b$var$_createForOfIteratorHelper(this.renderTypes.values()), _step4;
                            try {
                                var _loop2 = function _loop2() {
                                    var opts = _step4.value;
                                    var renderType = opts.type;
                                    if (filterType(renderType)) {
                                        var atlasCollection = _this3.collections.get(opts.collection);
                                        var key = opts.getKey(ele);
                                        var keyArray = Array.isArray(key) ? key : [
                                            key
                                        ];
                                        // when a node's background image finishes loading, the style key doesn't change but still needs to be redrawn
                                        if (forceRedraw) {
                                            keyArray.forEach(function(key) {
                                                return atlasCollection.markKeyForGC(key);
                                            });
                                            runGCNow = true; // run GC to remove the old texture right now, that way we don't need to remember for the next gc 
                                        } else {
                                            var id = opts.getID ? opts.getID(ele) : ele.id();
                                            var mapKey = _this3._key(renderType, id);
                                            var oldKeyArray = _this3.typeAndIdToKey.get(mapKey);
                                            if (oldKeyArray !== undefined && !$e815fda779bc047b$var$arrayEqual(keyArray, oldKeyArray)) {
                                                // conservative approach, if any of the keys don't match then throw them all away
                                                needGC = true;
                                                _this3.typeAndIdToKey["delete"](mapKey);
                                                oldKeyArray.forEach(function(oldKey) {
                                                    return atlasCollection.markKeyForGC(oldKey);
                                                });
                                            }
                                        }
                                    }
                                };
                                for(_iterator4.s(); !(_step4 = _iterator4.n()).done;)_loop2();
                            } catch (err) {
                                _iterator4.e(err);
                            } finally{
                                _iterator4.f();
                            }
                        }
                    }
                } catch (err) {
                    _iterator3.e(err);
                } finally{
                    _iterator3.f();
                }
                if (runGCNow) {
                    this.gc();
                    needGC = false;
                }
                return needGC;
            }
        },
        {
            key: "gc",
            value: function gc() {
                var _iterator5 = $e815fda779bc047b$var$_createForOfIteratorHelper(this.collections.values()), _step5;
                try {
                    for(_iterator5.s(); !(_step5 = _iterator5.n()).done;){
                        var collection = _step5.value;
                        collection.gc();
                    }
                } catch (err) {
                    _iterator5.e(err);
                } finally{
                    _iterator5.f();
                }
            }
        },
        {
            key: "getOrCreateAtlas",
            value: function getOrCreateAtlas(ele, type, bb, styleKey) {
                // styleKey is not an array here
                var opts = this.renderTypes.get(type);
                var atlasCollection = this.collections.get(opts.collection);
                // draws the texture only if needed
                var drawn = false;
                var atlas = atlasCollection.draw(styleKey, bb, function(context) {
                    if (opts.drawClipped) {
                        context.save();
                        context.beginPath();
                        context.rect(0, 0, bb.w, bb.h);
                        context.clip();
                        opts.drawElement(context, ele, bb, true, true);
                        context.restore();
                    } else opts.drawElement(context, ele, bb, true, true);
                    drawn = true;
                });
                if (drawn) {
                    var id = opts.getID ? opts.getID(ele) : ele.id(); // for testing
                    var mapKey = this._key(type, id);
                    if (this.typeAndIdToKey.has(mapKey)) this.typeAndIdToKey.get(mapKey).push(styleKey);
                    else this.typeAndIdToKey.set(mapKey, [
                        styleKey
                    ]);
                }
                return atlas;
            }
        },
        {
            key: "getAtlasInfo",
            value: function getAtlasInfo(ele, type) {
                var _this4 = this;
                var opts = this.renderTypes.get(type);
                var key = opts.getKey(ele);
                var keyArray = Array.isArray(key) ? key : [
                    key
                ];
                return keyArray.map(function(styleKey) {
                    var bb = opts.getBoundingBox(ele, styleKey); // pass the key back to the getBoundingBox method
                    var atlas = _this4.getOrCreateAtlas(ele, type, bb, styleKey);
                    var _atlas$getOffsets3 = atlas.getOffsets(styleKey), _atlas$getOffsets4 = $e815fda779bc047b$var$_slicedToArray(_atlas$getOffsets3, 2), tex1 = _atlas$getOffsets4[0], tex2 = _atlas$getOffsets4[1];
                    return {
                        atlas: atlas,
                        tex: tex1,
                        tex1: tex1,
                        tex2: tex2,
                        bb: bb
                    };
                });
            }
        },
        {
            key: "getDebugInfo",
            value: function getDebugInfo() {
                var debugInfo = [];
                var _iterator6 = $e815fda779bc047b$var$_createForOfIteratorHelper(this.collections), _step6;
                try {
                    for(_iterator6.s(); !(_step6 = _iterator6.n()).done;){
                        var _step6$value = $e815fda779bc047b$var$_slicedToArray(_step6.value, 2), name = _step6$value[0], collection = _step6$value[1];
                        var _collection$getCounts = collection.getCounts(), keyCount = _collection$getCounts.keyCount, atlasCount = _collection$getCounts.atlasCount;
                        debugInfo.push({
                            type: name,
                            keyCount: keyCount,
                            atlasCount: atlasCount
                        });
                    }
                } catch (err) {
                    _iterator6.e(err);
                } finally{
                    _iterator6.f();
                }
                return debugInfo;
            }
        }
    ]);
}();
var $e815fda779bc047b$var$AtlasBatchManager = /*#__PURE__*/ function() {
    function AtlasBatchManager(globalOptions) {
        $e815fda779bc047b$var$_classCallCheck(this, AtlasBatchManager);
        this.globalOptions = globalOptions;
        this.atlasSize = globalOptions.webglTexSize;
        this.maxAtlasesPerBatch = globalOptions.webglTexPerBatch;
        this.batchAtlases = [];
    }
    return $e815fda779bc047b$var$_createClass(AtlasBatchManager, [
        {
            key: "getMaxAtlasesPerBatch",
            value: function getMaxAtlasesPerBatch() {
                return this.maxAtlasesPerBatch;
            }
        },
        {
            key: "getAtlasSize",
            value: function getAtlasSize() {
                return this.atlasSize;
            }
        },
        {
            key: "getIndexArray",
            value: function getIndexArray() {
                return Array.from({
                    length: this.maxAtlasesPerBatch
                }, function(v, i) {
                    return i;
                });
            }
        },
        {
            key: "startBatch",
            value: function startBatch() {
                this.batchAtlases = [];
            }
        },
        {
            key: "getAtlasCount",
            value: function getAtlasCount() {
                return this.batchAtlases.length;
            }
        },
        {
            key: "getAtlases",
            value: function getAtlases() {
                return this.batchAtlases;
            }
        },
        {
            key: "canAddToCurrentBatch",
            value: function canAddToCurrentBatch(atlas) {
                if (this.batchAtlases.length === this.maxAtlasesPerBatch) return this.batchAtlases.includes(atlas);
                return true; // not full
            }
        },
        {
            key: "getAtlasIndexForBatch",
            value: function getAtlasIndexForBatch(atlas) {
                var atlasID = this.batchAtlases.indexOf(atlas);
                if (atlasID < 0) {
                    if (this.batchAtlases.length === this.maxAtlasesPerBatch) throw new Error('cannot add more atlases to batch');
                    this.batchAtlases.push(atlas);
                    atlasID = this.batchAtlases.length - 1;
                }
                return atlasID;
            }
        }
    ]);
}();
// Fragment shader functions to calculate signed distance
// https://iquilezles.org/articles/distfunctions2d/
// ellipse: https://www.shadertoy.com/view/4lsXDN 
/**
 * param p - point
 * float r - circle radius, eg 0.5 for unit circle
 */ var $e815fda779bc047b$var$circleSD = "\n  float circleSD(vec2 p, float r) {\n    return distance(vec2(0), p) - r; // signed distance\n  }\n";
/**
 * param p - point
 * param b - b.x = half width, b.y = half height
 */ var $e815fda779bc047b$var$rectangleSD = "\n  float rectangleSD(vec2 p, vec2 b) {\n    vec2 d = abs(p)-b;\n    return distance(vec2(0),max(d,0.0)) + min(max(d.x,d.y),0.0);\n  }\n";
/**
 * param p - point
 * param b - b.x = half width, b.y = half height
 * param cr - vector of corner radiuses
 */ var $e815fda779bc047b$var$roundRectangleSD = "\n  float roundRectangleSD(vec2 p, vec2 b, vec4 cr) {\n    cr.xy = (p.x > 0.0) ? cr.xy : cr.zw;\n    cr.x  = (p.y > 0.0) ? cr.x  : cr.y;\n    vec2 q = abs(p) - b + cr.x;\n    return min(max(q.x, q.y), 0.0) + distance(vec2(0), max(q, 0.0)) - cr.x;\n  }\n";
/**
 * param p - point
 * param ab - a.x = horizontal radius, a.y = vertical radius
 */ var $e815fda779bc047b$var$ellipseSD = "\n  float ellipseSD(vec2 p, vec2 ab) {\n    p = abs( p ); // symmetry\n\n    // find root with Newton solver\n    vec2 q = ab*(p-ab);\n    float w = (q.x<q.y)? 1.570796327 : 0.0;\n    for( int i=0; i<5; i++ ) {\n      vec2 cs = vec2(cos(w),sin(w));\n      vec2 u = ab*vec2( cs.x,cs.y);\n      vec2 v = ab*vec2(-cs.y,cs.x);\n      w = w + dot(p-u,v)/(dot(p-u,u)+dot(v,v));\n    }\n    \n    // compute final point and distance\n    float d = length(p-ab*vec2(cos(w),sin(w)));\n    \n    // return signed distance\n    return (dot(p/ab,p/ab)>1.0) ? d : -d;\n  }\n";
/**
 * Two render modes. Each mode has its own shader program. They are almost identical, the main difference is the output.
 * SCREEN:  output pixel colors to the screen
 * PICKING: output z-order index to an offscreen framebuffer, used to detect what's under the mouse cursor
 */ var $e815fda779bc047b$var$RENDER_TARGET = {
    SCREEN: {
        name: 'screen',
        screen: true
    },
    PICKING: {
        name: 'picking',
        picking: true
    }
};
/**
 * Special handing for label textures in PICKING mode. See issue #3337.
 */ var $e815fda779bc047b$var$TEX_PICKING_MODE = {
    // render the texture just like in RENDER_TARGET.SCREEN mode
    IGNORE: 1,
    // don't render the texture at all
    USE_BB: 2 // render the bounding box as an opaque rectangle
};
// Vertex types.
// Used directly in the shaders so must be numeric.
// There is only one shader program used for an entire frame that renders all types of elements.
// There are if-else blocks in the shaders that do different things depending on the vertex type.
// This allows all elements to be rendererd in large batches without switching shader programs.
var $e815fda779bc047b$var$TEXTURE = 0;
var $e815fda779bc047b$var$EDGE_STRAIGHT = 1;
var $e815fda779bc047b$var$EDGE_CURVE_SEGMENT = 2;
var $e815fda779bc047b$var$EDGE_ARROW = 3;
var $e815fda779bc047b$var$RECTANGLE = 4;
var $e815fda779bc047b$var$ROUND_RECTANGLE = 5;
var $e815fda779bc047b$var$BOTTOM_ROUND_RECTANGLE = 6;
var $e815fda779bc047b$var$ELLIPSE = 7;
var $e815fda779bc047b$var$ElementDrawingWebGL = /*#__PURE__*/ function() {
    /**
   * @param {WebGLRenderingContext} gl
   */ function ElementDrawingWebGL(r, gl, opts) {
        $e815fda779bc047b$var$_classCallCheck(this, ElementDrawingWebGL);
        this.r = r; // reference to the canvas renderer
        this.gl = gl;
        this.maxInstances = opts.webglBatchSize;
        this.atlasSize = opts.webglTexSize;
        this.bgColor = opts.bgColor;
        this.debug = opts.webglDebug;
        this.batchDebugInfo = [];
        opts.enableWrapping = true;
        opts.createTextureCanvas = $e815fda779bc047b$var$createTextureCanvas; // Unit tests mock this
        this.atlasManager = new $e815fda779bc047b$var$AtlasManager(r, opts);
        this.batchManager = new $e815fda779bc047b$var$AtlasBatchManager(opts);
        this.simpleShapeOptions = new Map();
        this.program = this._createShaderProgram($e815fda779bc047b$var$RENDER_TARGET.SCREEN);
        this.pickingProgram = this._createShaderProgram($e815fda779bc047b$var$RENDER_TARGET.PICKING);
        this.vao = this._createVAO();
    }
    /**
   * @param { string } collectionName
   * @param {{ texRows: number }} opts
   */ return $e815fda779bc047b$var$_createClass(ElementDrawingWebGL, [
        {
            key: "addAtlasCollection",
            value: function addAtlasCollection(collectionName, opts) {
                this.atlasManager.addAtlasCollection(collectionName, opts);
            }
        },
        {
            key: "addTextureAtlasRenderType",
            value: function addTextureAtlasRenderType(typeName, opts) {
                this.atlasManager.addRenderType(typeName, opts);
            }
        },
        {
            key: "addSimpleShapeRenderType",
            value: function addSimpleShapeRenderType(typeName, opts) {
                this.simpleShapeOptions.set(typeName, opts);
            }
        },
        {
            key: "invalidate",
            value: function invalidate(eles) {
                var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, type = _ref.type;
                var atlasManager = this.atlasManager;
                if (type) return atlasManager.invalidate(eles, {
                    filterType: function filterType(t) {
                        return t === type;
                    },
                    forceRedraw: true
                });
                else return atlasManager.invalidate(eles);
            }
        },
        {
            key: "gc",
            value: function gc() {
                this.atlasManager.gc();
            }
        },
        {
            key: "_createShaderProgram",
            value: function _createShaderProgram(renderTarget) {
                var gl = this.gl;
                var vertexShaderSource = "#version 300 es\n      precision highp float;\n\n      uniform mat3 uPanZoomMatrix;\n      uniform int  uAtlasSize;\n      \n      // instanced\n      in vec2 aPosition; // a vertex from the unit square\n      \n      in mat3 aTransform; // used to transform verticies, eg into a bounding box\n      in int aVertType; // the type of thing we are rendering\n\n      // the z-index that is output when using picking mode\n      in vec4 aIndex;\n      \n      // For textures\n      in int aAtlasId; // which shader unit/atlas to use\n      in vec4 aTex; // x/y/w/h of texture in atlas\n\n      // for edges\n      in vec4 aPointAPointB;\n      in vec4 aPointCPointD;\n      in vec2 aLineWidth; // also used for node border width\n\n      // simple shapes\n      in vec4 aCornerRadius; // for round-rectangle [top-right, bottom-right, top-left, bottom-left]\n      in vec4 aColor; // also used for edges\n      in vec4 aBorderColor; // aLineWidth is used for border width\n\n      // output values passed to the fragment shader\n      out vec2 vTexCoord;\n      out vec4 vColor;\n      out vec2 vPosition;\n      // flat values are not interpolated\n      flat out int vAtlasId; \n      flat out int vVertType;\n      flat out vec2 vTopRight;\n      flat out vec2 vBotLeft;\n      flat out vec4 vCornerRadius;\n      flat out vec4 vBorderColor;\n      flat out vec2 vBorderWidth;\n      flat out vec4 vIndex;\n      \n      void main(void) {\n        int vid = gl_VertexID;\n        vec2 position = aPosition; // TODO make this a vec3, simplifies some code below\n\n        if(aVertType == ".concat($e815fda779bc047b$var$TEXTURE, ") {\n          float texX = aTex.x; // texture coordinates\n          float texY = aTex.y;\n          float texW = aTex.z;\n          float texH = aTex.w;\n\n          if(vid == 1 || vid == 2 || vid == 4) {\n            texX += texW;\n          }\n          if(vid == 2 || vid == 4 || vid == 5) {\n            texY += texH;\n          }\n\n          float d = float(uAtlasSize);\n          vTexCoord = vec2(texX / d, texY / d); // tex coords must be between 0 and 1\n\n          gl_Position = vec4(uPanZoomMatrix * aTransform * vec3(position, 1.0), 1.0);\n        }\n        else if(aVertType == ").concat($e815fda779bc047b$var$RECTANGLE, " || aVertType == ").concat($e815fda779bc047b$var$ELLIPSE, " \n             || aVertType == ").concat($e815fda779bc047b$var$ROUND_RECTANGLE, " || aVertType == ").concat($e815fda779bc047b$var$BOTTOM_ROUND_RECTANGLE, ") { // simple shapes\n\n          // the bounding box is needed by the fragment shader\n          vBotLeft  = (aTransform * vec3(0, 0, 1)).xy; // flat\n          vTopRight = (aTransform * vec3(1, 1, 1)).xy; // flat\n          vPosition = (aTransform * vec3(position, 1)).xy; // will be interpolated\n\n          // calculations are done in the fragment shader, just pass these along\n          vColor = aColor;\n          vCornerRadius = aCornerRadius;\n          vBorderColor = aBorderColor;\n          vBorderWidth = aLineWidth;\n\n          gl_Position = vec4(uPanZoomMatrix * aTransform * vec3(position, 1.0), 1.0);\n        }\n        else if(aVertType == ").concat($e815fda779bc047b$var$EDGE_STRAIGHT, ") {\n          vec2 source = aPointAPointB.xy;\n          vec2 target = aPointAPointB.zw;\n\n          // adjust the geometry so that the line is centered on the edge\n          position.y = position.y - 0.5;\n\n          // stretch the unit square into a long skinny rectangle\n          vec2 xBasis = target - source;\n          vec2 yBasis = normalize(vec2(-xBasis.y, xBasis.x));\n          vec2 point = source + xBasis * position.x + yBasis * aLineWidth[0] * position.y;\n\n          gl_Position = vec4(uPanZoomMatrix * vec3(point, 1.0), 1.0);\n          vColor = aColor;\n        } \n        else if(aVertType == ").concat($e815fda779bc047b$var$EDGE_CURVE_SEGMENT, ") {\n          vec2 pointA = aPointAPointB.xy;\n          vec2 pointB = aPointAPointB.zw;\n          vec2 pointC = aPointCPointD.xy;\n          vec2 pointD = aPointCPointD.zw;\n\n          // adjust the geometry so that the line is centered on the edge\n          position.y = position.y - 0.5;\n\n          vec2 p0, p1, p2, pos;\n          if(position.x == 0.0) { // The left side of the unit square\n            p0 = pointA;\n            p1 = pointB;\n            p2 = pointC;\n            pos = position;\n          } else { // The right side of the unit square, use same approach but flip the geometry upside down\n            p0 = pointD;\n            p1 = pointC;\n            p2 = pointB;\n            pos = vec2(0.0, -position.y);\n          }\n\n          vec2 p01 = p1 - p0;\n          vec2 p12 = p2 - p1;\n          vec2 p21 = p1 - p2;\n\n          // Find the normal vector.\n          vec2 tangent = normalize(normalize(p12) + normalize(p01));\n          vec2 normal = vec2(-tangent.y, tangent.x);\n\n          // Find the vector perpendicular to p0 -> p1.\n          vec2 p01Norm = normalize(vec2(-p01.y, p01.x));\n\n          // Determine the bend direction.\n          float sigma = sign(dot(p01 + p21, normal));\n          float width = aLineWidth[0];\n\n          if(sign(pos.y) == -sigma) {\n            // This is an intersecting vertex. Adjust the position so that there's no overlap.\n            vec2 point = 0.5 * width * normal * -sigma / dot(normal, p01Norm);\n            gl_Position = vec4(uPanZoomMatrix * vec3(p1 + point, 1.0), 1.0);\n          } else {\n            // This is a non-intersecting vertex. Treat it like a mitre join.\n            vec2 point = 0.5 * width * normal * sigma * dot(normal, p01Norm);\n            gl_Position = vec4(uPanZoomMatrix * vec3(p1 + point, 1.0), 1.0);\n          }\n\n          vColor = aColor;\n        } \n        else if(aVertType == ").concat($e815fda779bc047b$var$EDGE_ARROW, " && vid < 3) {\n          // massage the first triangle into an edge arrow\n          if(vid == 0)\n            position = vec2(-0.15, -0.3);\n          if(vid == 1)\n            position = vec2(  0.0,  0.0);\n          if(vid == 2)\n            position = vec2( 0.15, -0.3);\n\n          gl_Position = vec4(uPanZoomMatrix * aTransform * vec3(position, 1.0), 1.0);\n          vColor = aColor;\n        }\n        else {\n          gl_Position = vec4(2.0, 0.0, 0.0, 1.0); // discard vertex by putting it outside webgl clip space\n        }\n\n        vAtlasId = aAtlasId;\n        vVertType = aVertType;\n        vIndex = aIndex;\n      }\n    ");
                var idxs = this.batchManager.getIndexArray();
                var fragmentShaderSource = "#version 300 es\n      precision highp float;\n\n      // declare texture unit for each texture atlas in the batch\n      ".concat(idxs.map(function(i) {
                    return "uniform sampler2D uTexture".concat(i, ";");
                }).join('\n\t'), "\n\n      uniform vec4 uBGColor;\n      uniform float uZoom;\n\n      in vec2 vTexCoord;\n      in vec4 vColor;\n      in vec2 vPosition; // model coordinates\n\n      flat in int vAtlasId;\n      flat in vec4 vIndex;\n      flat in int vVertType;\n      flat in vec2 vTopRight;\n      flat in vec2 vBotLeft;\n      flat in vec4 vCornerRadius;\n      flat in vec4 vBorderColor;\n      flat in vec2 vBorderWidth;\n\n      out vec4 outColor;\n\n      ").concat($e815fda779bc047b$var$circleSD, "\n      ").concat($e815fda779bc047b$var$rectangleSD, "\n      ").concat($e815fda779bc047b$var$roundRectangleSD, "\n      ").concat($e815fda779bc047b$var$ellipseSD, "\n\n      vec4 blend(vec4 top, vec4 bot) { // blend colors with premultiplied alpha\n        return vec4( \n          top.rgb + (bot.rgb * (1.0 - top.a)),\n          top.a   + (bot.a   * (1.0 - top.a)) \n        );\n      }\n\n      vec4 distInterp(vec4 cA, vec4 cB, float d) { // interpolate color using Signed Distance\n        // scale to the zoom level so that borders don't look blurry when zoomed in\n        // note 1.5 is an aribitrary value chosen because it looks good\n        return mix(cA, cB, 1.0 - smoothstep(0.0, 1.5 / uZoom, abs(d))); \n      }\n\n      void main(void) {\n        if(vVertType == ").concat($e815fda779bc047b$var$TEXTURE, ") {\n          // look up the texel from the texture unit\n          ").concat(idxs.map(function(i) {
                    return "if(vAtlasId == ".concat(i, ") outColor = texture(uTexture").concat(i, ", vTexCoord);");
                }).join('\n\telse '), "\n        } \n        else if(vVertType == ").concat($e815fda779bc047b$var$EDGE_ARROW, ") {\n          // mimics how canvas renderer uses context.globalCompositeOperation = 'destination-out';\n          outColor = blend(vColor, uBGColor);\n          outColor.a = 1.0; // make opaque, masks out line under arrow\n        }\n        else if(vVertType == ").concat($e815fda779bc047b$var$RECTANGLE, " && vBorderWidth == vec2(0.0)) { // simple rectangle with no border\n          outColor = vColor; // unit square is already transformed to the rectangle, nothing else needs to be done\n        }\n        else if(vVertType == ").concat($e815fda779bc047b$var$RECTANGLE, " || vVertType == ").concat($e815fda779bc047b$var$ELLIPSE, " \n          || vVertType == ").concat($e815fda779bc047b$var$ROUND_RECTANGLE, " || vVertType == ").concat($e815fda779bc047b$var$BOTTOM_ROUND_RECTANGLE, ") { // use SDF\n\n          float outerBorder = vBorderWidth[0];\n          float innerBorder = vBorderWidth[1];\n          float borderPadding = outerBorder * 2.0;\n          float w = vTopRight.x - vBotLeft.x - borderPadding;\n          float h = vTopRight.y - vBotLeft.y - borderPadding;\n          vec2 b = vec2(w/2.0, h/2.0); // half width, half height\n          vec2 p = vPosition - vec2(vTopRight.x - b[0] - outerBorder, vTopRight.y - b[1] - outerBorder); // translate to center\n\n          float d; // signed distance\n          if(vVertType == ").concat($e815fda779bc047b$var$RECTANGLE, ") {\n            d = rectangleSD(p, b);\n          } else if(vVertType == ").concat($e815fda779bc047b$var$ELLIPSE, " && w == h) {\n            d = circleSD(p, b.x); // faster than ellipse\n          } else if(vVertType == ").concat($e815fda779bc047b$var$ELLIPSE, ") {\n            d = ellipseSD(p, b);\n          } else {\n            d = roundRectangleSD(p, b, vCornerRadius.wzyx);\n          }\n\n          // use the distance to interpolate a color to smooth the edges of the shape, doesn't need multisampling\n          // we must smooth colors inwards, because we can't change pixels outside the shape's bounding box\n          if(d > 0.0) {\n            if(d > outerBorder) {\n              discard;\n            } else {\n              outColor = distInterp(vBorderColor, vec4(0), d - outerBorder);\n            }\n          } else {\n            if(d > innerBorder) {\n              vec4 outerColor = outerBorder == 0.0 ? vec4(0) : vBorderColor;\n              vec4 innerBorderColor = blend(vBorderColor, vColor);\n              outColor = distInterp(innerBorderColor, outerColor, d);\n            } \n            else {\n              vec4 outerColor;\n              if(innerBorder == 0.0 && outerBorder == 0.0) {\n                outerColor = vec4(0);\n              } else if(innerBorder == 0.0) {\n                outerColor = vBorderColor;\n              } else {\n                outerColor = blend(vBorderColor, vColor);\n              }\n              outColor = distInterp(vColor, outerColor, d - innerBorder);\n            }\n          }\n        }\n        else {\n          outColor = vColor;\n        }\n\n        ").concat(renderTarget.picking ? "if(outColor.a == 0.0) discard;\n             else outColor = vIndex;" : '', "\n      }\n    ");
                var program = $e815fda779bc047b$var$createProgram(gl, vertexShaderSource, fragmentShaderSource);
                // instance geometry
                program.aPosition = gl.getAttribLocation(program, 'aPosition');
                // attributes
                program.aIndex = gl.getAttribLocation(program, 'aIndex');
                program.aVertType = gl.getAttribLocation(program, 'aVertType');
                program.aTransform = gl.getAttribLocation(program, 'aTransform');
                program.aAtlasId = gl.getAttribLocation(program, 'aAtlasId');
                program.aTex = gl.getAttribLocation(program, 'aTex');
                program.aPointAPointB = gl.getAttribLocation(program, 'aPointAPointB');
                program.aPointCPointD = gl.getAttribLocation(program, 'aPointCPointD');
                program.aLineWidth = gl.getAttribLocation(program, 'aLineWidth');
                program.aColor = gl.getAttribLocation(program, 'aColor');
                program.aCornerRadius = gl.getAttribLocation(program, 'aCornerRadius');
                program.aBorderColor = gl.getAttribLocation(program, 'aBorderColor');
                // uniforms
                program.uPanZoomMatrix = gl.getUniformLocation(program, 'uPanZoomMatrix');
                program.uAtlasSize = gl.getUniformLocation(program, 'uAtlasSize');
                program.uBGColor = gl.getUniformLocation(program, 'uBGColor');
                program.uZoom = gl.getUniformLocation(program, 'uZoom');
                program.uTextures = [];
                for(var i = 0; i < this.batchManager.getMaxAtlasesPerBatch(); i++)program.uTextures.push(gl.getUniformLocation(program, "uTexture".concat(i)));
                return program;
            }
        },
        {
            key: "_createVAO",
            value: function _createVAO() {
                var unitSquare = [
                    0,
                    0,
                    1,
                    0,
                    1,
                    1,
                    0,
                    0,
                    1,
                    1,
                    0,
                    1
                ];
                this.vertexCount = unitSquare.length / 2;
                var n = this.maxInstances;
                var gl = this.gl, program = this.program;
                var vao = gl.createVertexArray();
                gl.bindVertexArray(vao);
                $e815fda779bc047b$var$createBufferStaticDraw(gl, 'vec2', program.aPosition, unitSquare);
                // Create buffers for all the attributes
                this.transformBuffer = $e815fda779bc047b$var$create3x3MatrixBufferDynamicDraw(gl, n, program.aTransform);
                this.indexBuffer = $e815fda779bc047b$var$createBufferDynamicDraw(gl, n, 'vec4', program.aIndex);
                this.vertTypeBuffer = $e815fda779bc047b$var$createBufferDynamicDraw(gl, n, 'int', program.aVertType);
                this.atlasIdBuffer = $e815fda779bc047b$var$createBufferDynamicDraw(gl, n, 'int', program.aAtlasId);
                this.texBuffer = $e815fda779bc047b$var$createBufferDynamicDraw(gl, n, 'vec4', program.aTex);
                this.pointAPointBBuffer = $e815fda779bc047b$var$createBufferDynamicDraw(gl, n, 'vec4', program.aPointAPointB);
                this.pointCPointDBuffer = $e815fda779bc047b$var$createBufferDynamicDraw(gl, n, 'vec4', program.aPointCPointD);
                this.lineWidthBuffer = $e815fda779bc047b$var$createBufferDynamicDraw(gl, n, 'vec2', program.aLineWidth);
                this.colorBuffer = $e815fda779bc047b$var$createBufferDynamicDraw(gl, n, 'vec4', program.aColor);
                this.cornerRadiusBuffer = $e815fda779bc047b$var$createBufferDynamicDraw(gl, n, 'vec4', program.aCornerRadius);
                this.borderColorBuffer = $e815fda779bc047b$var$createBufferDynamicDraw(gl, n, 'vec4', program.aBorderColor);
                gl.bindVertexArray(null);
                return vao;
            }
        },
        {
            key: "buffers",
            get: function get() {
                var _this = this;
                if (!this._buffers) this._buffers = Object.keys(this).filter(function(k) {
                    return $e815fda779bc047b$var$endsWith(k, 'Buffer');
                }).map(function(k) {
                    return _this[k];
                });
                return this._buffers;
            }
        },
        {
            key: "startFrame",
            value: function startFrame(panZoomMatrix) {
                var renderTarget = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $e815fda779bc047b$var$RENDER_TARGET.SCREEN;
                this.panZoomMatrix = panZoomMatrix;
                this.renderTarget = renderTarget;
                this.batchDebugInfo = [];
                this.wrappedCount = 0;
                this.simpleCount = 0;
                this.startBatch();
            }
        },
        {
            key: "startBatch",
            value: function startBatch() {
                this.instanceCount = 0;
                this.batchManager.startBatch();
            }
        },
        {
            key: "endFrame",
            value: function endFrame() {
                this.endBatch();
            }
        },
        {
            key: "_isVisible",
            value: function _isVisible(ele, opts) {
                if (ele.visible()) {
                    if (opts && opts.isVisible) return opts.isVisible(ele);
                    return true;
                }
                return false;
            }
        },
        {
            key: "drawTexture",
            value: function drawTexture(ele, eleIndex, type) {
                var atlasManager = this.atlasManager, batchManager = this.batchManager;
                var opts = atlasManager.getRenderTypeOpts(type);
                if (!this._isVisible(ele, opts)) return;
                // Edges with invalid points could be passed here (labels), causing errors
                // Ref: Random "Script Error" thrown when generating nodes and edges in newest webgl version #3365
                // https://github.com/cytoscape/cytoscape.js/issues/3365
                if (ele.isEdge() && !this._isValidEdge(ele)) return;
                if (this.renderTarget.picking && opts.getTexPickingMode) {
                    var mode = opts.getTexPickingMode(ele);
                    if (mode === $e815fda779bc047b$var$TEX_PICKING_MODE.IGNORE) return;
                    else if (mode == $e815fda779bc047b$var$TEX_PICKING_MODE.USE_BB) {
                        this.drawPickingRectangle(ele, eleIndex, type);
                        return;
                    }
                }
                // Get the atlas and the texture coordinates, will draw the texture if it hasn't been drawn yet
                // May be more than one texture if for example the label has multiple lines
                var atlasInfoArray = atlasManager.getAtlasInfo(ele, type);
                var _iterator = $e815fda779bc047b$var$_createForOfIteratorHelper(atlasInfoArray), _step;
                try {
                    for(_iterator.s(); !(_step = _iterator.n()).done;){
                        var atlasInfo = _step.value;
                        var atlas = atlasInfo.atlas, tex1 = atlasInfo.tex1, tex2 = atlasInfo.tex2; // tex2 is used if the label wraps and there are two textures
                        if (!batchManager.canAddToCurrentBatch(atlas)) this.endBatch();
                        var atlasIndex = batchManager.getAtlasIndexForBatch(atlas);
                        for(var _i = 0, _arr = [
                            [
                                tex1,
                                true
                            ],
                            [
                                tex2,
                                false
                            ]
                        ]; _i < _arr.length; _i++){
                            var _arr$_i = $e815fda779bc047b$var$_slicedToArray(_arr[_i], 2), tex = _arr$_i[0], first = _arr$_i[1];
                            if (tex.w != 0) {
                                var instance = this.instanceCount;
                                this.vertTypeBuffer.getView(instance)[0] = $e815fda779bc047b$var$TEXTURE;
                                var indexView = this.indexBuffer.getView(instance);
                                $e815fda779bc047b$var$indexToVec4(eleIndex, indexView);
                                // Set values in the buffers using Typed Array Views for performance.
                                var atlasIdView = this.atlasIdBuffer.getView(instance);
                                atlasIdView[0] = atlasIndex;
                                // we have two sets of texture coordinates and transforms because textures can wrap in the atlas
                                var texView = this.texBuffer.getView(instance);
                                texView[0] = tex.x;
                                texView[1] = tex.y;
                                texView[2] = tex.w;
                                texView[3] = tex.h;
                                var matrixView = this.transformBuffer.getMatrixView(instance);
                                this.setTransformMatrix(ele, matrixView, opts, atlasInfo, first);
                                this.instanceCount++;
                                if (!first) this.wrappedCount++;
                                if (this.instanceCount >= this.maxInstances) this.endBatch();
                            }
                        }
                    }
                } catch (err) {
                    _iterator.e(err);
                } finally{
                    _iterator.f();
                }
            }
        },
        {
            key: "setTransformMatrix",
            value: function setTransformMatrix(ele, matrix, opts, atlasInfo) {
                var first = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
                var padding = 0;
                if (opts.shapeProps && opts.shapeProps.padding) padding = ele.pstyle(opts.shapeProps.padding).pfValue;
                if (atlasInfo) {
                    // we've already computed the bb and tex bounds for a texture
                    var bb = atlasInfo.bb, tex1 = atlasInfo.tex1, tex2 = atlasInfo.tex2;
                    // wrapped textures need separate matrix for each part
                    var ratio = tex1.w / (tex1.w + tex2.w);
                    if (!first) // first = true means its the first part of the wrapped texture
                    ratio = 1 - ratio;
                    var adjBB = this._getAdjustedBB(bb, padding, first, ratio);
                    this._applyTransformMatrix(matrix, adjBB, opts, ele);
                } else {
                    // we don't have a texture, or we want to avoid creating a texture for simple shapes
                    var _bb = opts.getBoundingBox(ele);
                    var _adjBB = this._getAdjustedBB(_bb, padding, true, 1);
                    this._applyTransformMatrix(matrix, _adjBB, opts, ele);
                }
            }
        },
        {
            key: "_applyTransformMatrix",
            value: function _applyTransformMatrix(matrix, adjBB, opts, ele) {
                var x, y;
                $e815fda779bc047b$var$identity(matrix);
                var theta = opts.getRotation ? opts.getRotation(ele) : 0;
                if (theta !== 0) {
                    var _opts$getRotationPoin = opts.getRotationPoint(ele), sx = _opts$getRotationPoin.x, sy = _opts$getRotationPoin.y;
                    $e815fda779bc047b$var$translate(matrix, matrix, [
                        sx,
                        sy
                    ]);
                    $e815fda779bc047b$var$rotate(matrix, matrix, theta);
                    var offset = opts.getRotationOffset(ele);
                    x = offset.x + (adjBB.xOffset || 0);
                    y = offset.y + (adjBB.yOffset || 0);
                } else {
                    x = adjBB.x1;
                    y = adjBB.y1;
                }
                $e815fda779bc047b$var$translate(matrix, matrix, [
                    x,
                    y
                ]);
                $e815fda779bc047b$var$scale(matrix, matrix, [
                    adjBB.w,
                    adjBB.h
                ]);
            }
        },
        {
            key: "_getAdjustedBB",
            value: function _getAdjustedBB(bb, padding, first, ratio) {
                var x1 = bb.x1, y1 = bb.y1, w = bb.w, h = bb.h, yOffset = bb.yOffset;
                if (padding) {
                    x1 -= padding;
                    y1 -= padding;
                    w += 2 * padding;
                    h += 2 * padding;
                }
                var xOffset = 0;
                var adjW = w * ratio;
                if (first && ratio < 1) w = adjW;
                else if (!first && ratio < 1) {
                    xOffset = w - adjW;
                    x1 += xOffset;
                    w = adjW;
                }
                return {
                    x1: x1,
                    y1: y1,
                    w: w,
                    h: h,
                    xOffset: xOffset,
                    yOffset: yOffset
                };
            }
        },
        {
            key: "drawPickingRectangle",
            value: function drawPickingRectangle(ele, eleIndex, type) {
                var opts = this.atlasManager.getRenderTypeOpts(type);
                var instance = this.instanceCount;
                this.vertTypeBuffer.getView(instance)[0] = $e815fda779bc047b$var$RECTANGLE;
                var indexView = this.indexBuffer.getView(instance);
                $e815fda779bc047b$var$indexToVec4(eleIndex, indexView);
                var colorView = this.colorBuffer.getView(instance);
                $e815fda779bc047b$var$toWebGLColor([
                    0,
                    0,
                    0
                ], 1, colorView); // opaque, so entire label BB is clickable
                var matrixView = this.transformBuffer.getMatrixView(instance);
                this.setTransformMatrix(ele, matrixView, opts);
                this.simpleCount++;
                this.instanceCount++;
                if (this.instanceCount >= this.maxInstances) this.endBatch();
            }
        },
        {
            key: "drawNode",
            value: function drawNode(node, eleIndex, type) {
                var opts = this.simpleShapeOptions.get(type);
                if (!this._isVisible(node, opts)) return;
                var props = opts.shapeProps;
                // Check if we have to use a texture
                var vertType = this._getVertTypeForShape(node, props.shape);
                if (vertType === undefined || opts.isSimple && !opts.isSimple(node)) {
                    this.drawTexture(node, eleIndex, type);
                    return;
                }
                // Render a "simple shape" using SDF (signed distance fields)
                var instance = this.instanceCount;
                this.vertTypeBuffer.getView(instance)[0] = vertType;
                if (vertType === $e815fda779bc047b$var$ROUND_RECTANGLE || vertType === $e815fda779bc047b$var$BOTTOM_ROUND_RECTANGLE) {
                    // get corner radius
                    var bb = opts.getBoundingBox(node);
                    var radius = this._getCornerRadius(node, props.radius, bb);
                    var radiusView = this.cornerRadiusBuffer.getView(instance);
                    radiusView[0] = radius; // top-right
                    radiusView[1] = radius; // bottom-right
                    radiusView[2] = radius; // top-left
                    radiusView[3] = radius; // bottom-left
                    if (vertType === $e815fda779bc047b$var$BOTTOM_ROUND_RECTANGLE) {
                        radiusView[0] = 0;
                        radiusView[2] = 0;
                    }
                }
                var indexView = this.indexBuffer.getView(instance);
                $e815fda779bc047b$var$indexToVec4(eleIndex, indexView);
                var color = node.pstyle(props.color).value;
                var opacity = node.pstyle(props.opacity).value;
                var colorView = this.colorBuffer.getView(instance);
                $e815fda779bc047b$var$toWebGLColor(color, opacity, colorView);
                var lineWidthView = this.lineWidthBuffer.getView(instance); // reuse edge line width attribute for node border
                lineWidthView[0] = 0;
                lineWidthView[1] = 0;
                if (props.border) {
                    var borderWidth = node.pstyle('border-width').value;
                    if (borderWidth > 0) {
                        var borderColor = node.pstyle('border-color').value;
                        var borderOpacity = node.pstyle('border-opacity').value;
                        var borderColorView = this.borderColorBuffer.getView(instance);
                        $e815fda779bc047b$var$toWebGLColor(borderColor, borderOpacity, borderColorView);
                        // SDF distance is negative inside the shape and positive outside
                        var borderPos = node.pstyle('border-position').value;
                        if (borderPos === 'inside') {
                            lineWidthView[0] = 0;
                            lineWidthView[1] = -borderWidth;
                        } else if (borderPos === 'outside') {
                            lineWidthView[0] = borderWidth;
                            lineWidthView[1] = 0;
                        } else {
                            // 'center'
                            var halfWidth = borderWidth / 2;
                            lineWidthView[0] = halfWidth;
                            lineWidthView[1] = -halfWidth;
                        }
                    }
                }
                var matrixView = this.transformBuffer.getMatrixView(instance);
                this.setTransformMatrix(node, matrixView, opts);
                this.simpleCount++;
                this.instanceCount++;
                if (this.instanceCount >= this.maxInstances) this.endBatch();
            }
        },
        {
            key: "_getVertTypeForShape",
            value: function _getVertTypeForShape(node, shapeProp) {
                var shape = node.pstyle(shapeProp).value;
                switch(shape){
                    case 'rectangle':
                        return $e815fda779bc047b$var$RECTANGLE;
                    case 'ellipse':
                        return $e815fda779bc047b$var$ELLIPSE;
                    case 'roundrectangle':
                    case 'round-rectangle':
                        return $e815fda779bc047b$var$ROUND_RECTANGLE;
                    case 'bottom-round-rectangle':
                        return $e815fda779bc047b$var$BOTTOM_ROUND_RECTANGLE;
                    default:
                        return undefined;
                }
            }
        },
        {
            key: "_getCornerRadius",
            value: function _getCornerRadius(node, radiusProp, _ref2) {
                var w = _ref2.w, h = _ref2.h;
                // see CRp.drawRoundRectanglePath
                if (node.pstyle(radiusProp).value === 'auto') return $e815fda779bc047b$var$getRoundRectangleRadius(w, h);
                else {
                    var radius = node.pstyle(radiusProp).pfValue;
                    var halfWidth = w / 2;
                    var halfHeight = h / 2;
                    return Math.min(radius, halfHeight, halfWidth);
                }
            }
        },
        {
            key: "drawEdgeArrow",
            value: function drawEdgeArrow(edge, eleIndex, prefix) {
                if (!edge.visible()) return;
                // Edge points and arrow angles etc are calculated by the base renderer and cached in the rscratch object.
                var rs = edge._private.rscratch;
                var x, y, angle;
                if (prefix === 'source') {
                    x = rs.arrowStartX;
                    y = rs.arrowStartY;
                    angle = rs.srcArrowAngle;
                } else {
                    x = rs.arrowEndX;
                    y = rs.arrowEndY;
                    angle = rs.tgtArrowAngle;
                }
                // taken from CRp.drawArrowhead
                if (isNaN(x) || x == null || isNaN(y) || y == null || isNaN(angle) || angle == null) return;
                // check shape after the x/y check because pstyle() is a bit slow
                var arrowShape = edge.pstyle(prefix + '-arrow-shape').value;
                if (arrowShape === 'none') return;
                var color = edge.pstyle(prefix + '-arrow-color').value;
                var baseOpacity = edge.pstyle('opacity').value;
                var lineOpacity = edge.pstyle('line-opacity').value;
                var opacity = baseOpacity * lineOpacity;
                var lineWidth = edge.pstyle('width').pfValue;
                var scale$1 = edge.pstyle('arrow-scale').value;
                var size = this.r.getArrowWidth(lineWidth, scale$1);
                var instance = this.instanceCount;
                var transform = this.transformBuffer.getMatrixView(instance);
                $e815fda779bc047b$var$identity(transform);
                $e815fda779bc047b$var$translate(transform, transform, [
                    x,
                    y
                ]);
                $e815fda779bc047b$var$scale(transform, transform, [
                    size,
                    size
                ]);
                $e815fda779bc047b$var$rotate(transform, transform, angle);
                this.vertTypeBuffer.getView(instance)[0] = $e815fda779bc047b$var$EDGE_ARROW;
                var indexView = this.indexBuffer.getView(instance);
                $e815fda779bc047b$var$indexToVec4(eleIndex, indexView);
                var colorView = this.colorBuffer.getView(instance);
                $e815fda779bc047b$var$toWebGLColor(color, opacity, colorView);
                this.instanceCount++;
                if (this.instanceCount >= this.maxInstances) this.endBatch();
            }
        },
        {
            key: "drawEdgeLine",
            value: function drawEdgeLine(edge, eleIndex) {
                if (!edge.visible()) return;
                var points = this._getEdgePoints(edge);
                if (!points) return;
                // line style
                var baseOpacity = edge.pstyle('opacity').value;
                var lineOpacity = edge.pstyle('line-opacity').value;
                var width = edge.pstyle('width').pfValue;
                var color = edge.pstyle('line-color').value;
                var opacity = baseOpacity * lineOpacity;
                if (points.length / 2 + this.instanceCount > this.maxInstances) this.endBatch();
                if (points.length == 4) {
                    // straight line
                    var instance = this.instanceCount;
                    this.vertTypeBuffer.getView(instance)[0] = $e815fda779bc047b$var$EDGE_STRAIGHT;
                    var indexView = this.indexBuffer.getView(instance);
                    $e815fda779bc047b$var$indexToVec4(eleIndex, indexView);
                    var colorView = this.colorBuffer.getView(instance);
                    $e815fda779bc047b$var$toWebGLColor(color, opacity, colorView);
                    var lineWidthBuffer = this.lineWidthBuffer.getView(instance);
                    lineWidthBuffer[0] = width;
                    var sourceTargetView = this.pointAPointBBuffer.getView(instance);
                    sourceTargetView[0] = points[0]; // source x
                    sourceTargetView[1] = points[1]; // source y
                    sourceTargetView[2] = points[2]; // target x
                    sourceTargetView[3] = points[3]; // target y
                    this.instanceCount++;
                    if (this.instanceCount >= this.maxInstances) this.endBatch();
                } else // curved line
                for(var i = 0; i < points.length - 2; i += 2){
                    var _instance = this.instanceCount;
                    this.vertTypeBuffer.getView(_instance)[0] = $e815fda779bc047b$var$EDGE_CURVE_SEGMENT;
                    var _indexView = this.indexBuffer.getView(_instance);
                    $e815fda779bc047b$var$indexToVec4(eleIndex, _indexView);
                    var _colorView = this.colorBuffer.getView(_instance);
                    $e815fda779bc047b$var$toWebGLColor(color, opacity, _colorView);
                    var _lineWidthBuffer = this.lineWidthBuffer.getView(_instance);
                    _lineWidthBuffer[0] = width;
                    var pAx = points[i - 2], pAy = points[i - 1];
                    var pBx = points[i], pBy = points[i + 1];
                    var pCx = points[i + 2], pCy = points[i + 3];
                    var pDx = points[i + 4], pDy = points[i + 5];
                    // make phantom points for the first and last segments
                    // TODO adding 0.001 to avoid division by zero in the shader (I think), need a better solution
                    if (i == 0) {
                        pAx = 2 * pBx - pCx + 0.001;
                        pAy = 2 * pBy - pCy + 0.001;
                    }
                    if (i == points.length - 4) {
                        pDx = 2 * pCx - pBx + 0.001;
                        pDy = 2 * pCy - pBy + 0.001;
                    }
                    var pointABView = this.pointAPointBBuffer.getView(_instance);
                    pointABView[0] = pAx;
                    pointABView[1] = pAy;
                    pointABView[2] = pBx;
                    pointABView[3] = pBy;
                    var pointCDView = this.pointCPointDBuffer.getView(_instance);
                    pointCDView[0] = pCx;
                    pointCDView[1] = pCy;
                    pointCDView[2] = pDx;
                    pointCDView[3] = pDy;
                    this.instanceCount++;
                    if (this.instanceCount >= this.maxInstances) this.endBatch();
                }
            }
        },
        {
            key: "_isValidEdge",
            value: function _isValidEdge(edge) {
                var rs = edge._private.rscratch;
                if (rs.badLine || rs.allpts == null || isNaN(rs.allpts[0])) // isNaN in case edge is impossible and browser bugs (e.g. safari)
                return false;
                return true;
            }
        },
        {
            key: "_getEdgePoints",
            value: function _getEdgePoints(edge) {
                var rs = edge._private.rscratch;
                // if bezier ctrl pts can not be calculated, then die
                if (!this._isValidEdge(edge)) // isNaN in case edge is impossible and browser bugs (e.g. safari)
                return;
                var controlPoints = rs.allpts;
                if (controlPoints.length == 4) return controlPoints;
                var numSegments = this._getNumSegments(edge);
                return this._getCurveSegmentPoints(controlPoints, numSegments);
            }
        },
        {
            key: "_getNumSegments",
            value: function _getNumSegments(edge) {
                // TODO Need a heuristic that decides how many segments to use. Factors to consider:
                // - edge width/length
                // - edge curvature (the more the curvature, the more segments)
                // - zoom level (more segments when zoomed in)
                // - number of visible edges (more segments when there are fewer edges)
                // - performance (fewer segments when performance is a concern)
                // - user configurable option(s)
                // note: number of segments must be less than the max number of instances
                // note: segments don't need to be evenly spaced out, it might make sense to have shorter segments nearer to the control points
                var numSegments = 15;
                return Math.min(Math.max(numSegments, 5), this.maxInstances);
            }
        },
        {
            key: "_getCurveSegmentPoints",
            value: function _getCurveSegmentPoints(controlPoints, segments) {
                if (controlPoints.length == 4) return controlPoints; // straight line
                var curvePoints = Array((segments + 1) * 2);
                for(var i = 0; i <= segments; i++){
                    // the first and last points are the same as the first and last control points
                    if (i == 0) {
                        curvePoints[0] = controlPoints[0];
                        curvePoints[1] = controlPoints[1];
                    } else if (i == segments) {
                        curvePoints[i * 2] = controlPoints[controlPoints.length - 2];
                        curvePoints[i * 2 + 1] = controlPoints[controlPoints.length - 1];
                    } else {
                        var t = i / segments; // segments have equal length, its not strictly necessary to do it this way
                        // pass in curvePoints to set the values in the array directly
                        this._setCurvePoint(controlPoints, t, curvePoints, i * 2);
                    }
                }
                return curvePoints;
            }
        },
        {
            key: "_setCurvePoint",
            value: function _setCurvePoint(points, t, curvePoints, cpi) {
                if (points.length <= 2) {
                    curvePoints[cpi] = points[0];
                    curvePoints[cpi + 1] = points[1];
                } else {
                    var newpoints = Array(points.length - 2);
                    for(var i = 0; i < newpoints.length; i += 2){
                        var x = (1 - t) * points[i] + t * points[i + 2];
                        var y = (1 - t) * points[i + 1] + t * points[i + 3];
                        newpoints[i] = x;
                        newpoints[i + 1] = y;
                    }
                    return this._setCurvePoint(newpoints, t, curvePoints, cpi);
                }
            }
        },
        {
            key: "endBatch",
            value: function endBatch() {
                var gl = this.gl, vao = this.vao, vertexCount = this.vertexCount, count = this.instanceCount;
                if (count === 0) return;
                var program = this.renderTarget.picking ? this.pickingProgram : this.program;
                gl.useProgram(program);
                gl.bindVertexArray(vao);
                // buffer the attribute data
                var _iterator2 = $e815fda779bc047b$var$_createForOfIteratorHelper(this.buffers), _step2;
                try {
                    for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                        var buffer = _step2.value;
                        buffer.bufferSubData(count);
                    }
                } catch (err) {
                    _iterator2.e(err);
                } finally{
                    _iterator2.f();
                }
                var atlases = this.batchManager.getAtlases();
                // must buffer before activating texture units
                for(var i = 0; i < atlases.length; i++)atlases[i].bufferIfNeeded(gl);
                // Activate all the texture units that we need
                for(var _i2 = 0; _i2 < atlases.length; _i2++){
                    gl.activeTexture(gl.TEXTURE0 + _i2);
                    gl.bindTexture(gl.TEXTURE_2D, atlases[_i2].texture);
                    gl.uniform1i(program.uTextures[_i2], _i2);
                }
                // Set the uniforms
                gl.uniform1f(program.uZoom, $e815fda779bc047b$var$getEffectiveZoom(this.r));
                gl.uniformMatrix3fv(program.uPanZoomMatrix, false, this.panZoomMatrix);
                gl.uniform1i(program.uAtlasSize, this.batchManager.getAtlasSize());
                // set background color, needed for edge arrow color blending
                var webglBgColor = $e815fda779bc047b$var$toWebGLColor(this.bgColor, 1);
                gl.uniform4fv(program.uBGColor, webglBgColor);
                // draw!
                gl.drawArraysInstanced(gl.TRIANGLES, 0, vertexCount, count);
                gl.bindVertexArray(null);
                gl.bindTexture(gl.TEXTURE_2D, null); // TODO is this right when having multiple texture units?
                if (this.debug) this.batchDebugInfo.push({
                    count: count,
                    // instance count
                    atlasCount: atlases.length
                });
                // start the next batch, even if not needed
                this.startBatch();
            }
        },
        {
            key: "getDebugInfo",
            value: function getDebugInfo() {
                var atlasInfo = this.atlasManager.getDebugInfo();
                var totalAtlases = atlasInfo.reduce(function(count, info) {
                    return count + info.atlasCount;
                }, 0);
                var batchInfo = this.batchDebugInfo;
                var totalInstances = batchInfo.reduce(function(count, info) {
                    return count + info.count;
                }, 0);
                return {
                    atlasInfo: atlasInfo,
                    totalAtlases: totalAtlases,
                    wrappedCount: this.wrappedCount,
                    simpleCount: this.simpleCount,
                    batchCount: batchInfo.length,
                    batchInfo: batchInfo,
                    totalInstances: totalInstances
                };
            }
        }
    ]);
}();
var $e815fda779bc047b$var$CRp$4 = {};
/**
 * Initialize the WebGL rendering mode after the Canvas renderer has been initialized.
 */ $e815fda779bc047b$var$CRp$4.initWebgl = function(opts, fns) {
    var r = this;
    var gl = r.data.contexts[r.WEBGL];
    // Set defaults and limits for configuration options.
    opts.bgColor = $e815fda779bc047b$var$getBGColor(r);
    opts.webglTexSize = Math.min(opts.webglTexSize, gl.getParameter(gl.MAX_TEXTURE_SIZE));
    opts.webglTexRows = Math.min(opts.webglTexRows, 54);
    opts.webglTexRowsNodes = Math.min(opts.webglTexRowsNodes, 54);
    opts.webglBatchSize = Math.min(opts.webglBatchSize, 16384);
    opts.webglTexPerBatch = Math.min(opts.webglTexPerBatch, gl.getParameter(gl.MAX_TEXTURE_IMAGE_UNITS));
    // Turn debug mode on or off.
    r.webglDebug = opts.webglDebug;
    r.webglDebugShowAtlases = opts.webglDebugShowAtlases;
    // Create offscreen framebuffer that stores the results when RENDER_TARGET.PICKING is enabled.
    // This is used to store the topmost element z-index for each pixel, which is used to tell whats under the mouse cursor point.
    r.pickingFrameBuffer = $e815fda779bc047b$var$createPickingFrameBuffer(gl);
    r.pickingFrameBuffer.needsDraw = true;
    // Create an ElementDrawingWebGL instance wich is used to do the actual WebGL rendering.
    // This instance needs to be configured to draw various types of elements.
    r.drawing = new $e815fda779bc047b$var$ElementDrawingWebGL(r, gl, opts);
    // Some functions that are used to configure ElementDrawingWebGL
    var getLabelRotation = function getLabelRotation(prop) {
        return function(ele) {
            return r.getTextAngle(ele, prop);
        };
    };
    var isLabelVisible = function isLabelVisible(prop) {
        return function(ele) {
            var label = ele.pstyle(prop);
            return label && label.value;
        };
    };
    var isLayerVisible = function isLayerVisible(prefix) {
        return function(node) {
            // prefix is 'overlay' or 'underlay'
            return node.pstyle("".concat(prefix, "-opacity")).value > 0;
        };
    };
    var getTexPickingMode = function getTexPickingMode(ele) {
        // tells when a label should be clickable
        var enabled = ele.pstyle('text-events').strValue === 'yes';
        return enabled ? $e815fda779bc047b$var$TEX_PICKING_MODE.USE_BB : $e815fda779bc047b$var$TEX_PICKING_MODE.IGNORE;
    };
    var getBBForSimpleShape = function getBBForSimpleShape(node) {
        // "simple" shapes need their BB to include border and padding
        var _node$position = node.position(), x = _node$position.x, y = _node$position.y;
        var w = node.outerWidth(); // includes border and padding
        var h = node.outerHeight();
        return {
            w: w,
            h: h,
            x1: x - w / 2,
            y1: y - h / 2
        };
    };
    // An AtlasCollection is a collection of Atlases that have the same configuraiton options.
    // Create one for node bodies and one for all types of labels.
    r.drawing.addAtlasCollection('node', {
        texRows: opts.webglTexRowsNodes
    });
    r.drawing.addAtlasCollection('label', {
        texRows: opts.webglTexRows
    });
    // Configure the different types of elements that can be rendered.
    // Node bodies can be rendered as textures or as "simple shapes". 
    // Simple shapes are preferred because they do not use texture memory.
    // Textures are required if the node body uses complex styles. 
    r.drawing.addTextureAtlasRenderType('node-body', {
        collection: 'node',
        getKey: fns.getStyleKey,
        getBoundingBox: fns.getElementBox,
        drawElement: fns.drawElement
    });
    r.drawing.addSimpleShapeRenderType('node-body', {
        getBoundingBox: getBBForSimpleShape,
        isSimple: $e815fda779bc047b$var$isSimpleShape,
        shapeProps: {
            shape: 'shape',
            color: 'background-color',
            opacity: 'background-opacity',
            radius: 'corner-radius',
            border: true
        }
    });
    r.drawing.addSimpleShapeRenderType('node-overlay', {
        getBoundingBox: getBBForSimpleShape,
        isVisible: isLayerVisible('overlay'),
        shapeProps: {
            shape: 'overlay-shape',
            color: 'overlay-color',
            opacity: 'overlay-opacity',
            padding: 'overlay-padding',
            radius: 'overlay-corner-radius'
        }
    });
    r.drawing.addSimpleShapeRenderType('node-underlay', {
        getBoundingBox: getBBForSimpleShape,
        isVisible: isLayerVisible('underlay'),
        shapeProps: {
            shape: 'underlay-shape',
            color: 'underlay-color',
            opacity: 'underlay-opacity',
            padding: 'underlay-padding',
            radius: 'underlay-corner-radius'
        }
    });
    r.drawing.addTextureAtlasRenderType('label', {
        // node label or edge mid label
        collection: 'label',
        getTexPickingMode: getTexPickingMode,
        getKey: $e815fda779bc047b$var$getStyleKeysForLabel(fns.getLabelKey, null),
        getBoundingBox: $e815fda779bc047b$var$getBoundingBoxForLabel(fns.getLabelBox, null),
        drawClipped: true,
        drawElement: fns.drawLabel,
        getRotation: getLabelRotation(null),
        getRotationPoint: fns.getLabelRotationPoint,
        getRotationOffset: fns.getLabelRotationOffset,
        isVisible: isLabelVisible('label')
    });
    r.drawing.addTextureAtlasRenderType('edge-source-label', {
        collection: 'label',
        getTexPickingMode: getTexPickingMode,
        getKey: $e815fda779bc047b$var$getStyleKeysForLabel(fns.getSourceLabelKey, 'source'),
        getBoundingBox: $e815fda779bc047b$var$getBoundingBoxForLabel(fns.getSourceLabelBox, 'source'),
        drawClipped: true,
        drawElement: fns.drawSourceLabel,
        getRotation: getLabelRotation('source'),
        getRotationPoint: fns.getSourceLabelRotationPoint,
        getRotationOffset: fns.getSourceLabelRotationOffset,
        isVisible: isLabelVisible('source-label')
    });
    r.drawing.addTextureAtlasRenderType('edge-target-label', {
        collection: 'label',
        getTexPickingMode: getTexPickingMode,
        getKey: $e815fda779bc047b$var$getStyleKeysForLabel(fns.getTargetLabelKey, 'target'),
        getBoundingBox: $e815fda779bc047b$var$getBoundingBoxForLabel(fns.getTargetLabelBox, 'target'),
        drawClipped: true,
        drawElement: fns.drawTargetLabel,
        getRotation: getLabelRotation('target'),
        getRotationPoint: fns.getTargetLabelRotationPoint,
        getRotationOffset: fns.getTargetLabelRotationOffset,
        isVisible: isLabelVisible('target-label')
    });
    // Very simplistic way of triggering garbage collection, just use a timer.
    var setGCFlag = $e815fda779bc047b$var$debounce(function() {
        console.log('garbage collect flag set');
        r.data.gc = true;
    }, 10000);
    // Event listener checks if style keys are no longer in use.
    r.onUpdateEleCalcs(function(willDraw, eles) {
        var gcNeeded = false;
        if (eles && eles.length > 0) gcNeeded |= r.drawing.invalidate(eles);
        if (gcNeeded) setGCFlag();
    });
    // "Override" certain functions in canvas and base renderer
    $e815fda779bc047b$var$overrideCanvasRendererFunctions(r);
};
function $e815fda779bc047b$var$getBGColor(r) {
    var container = r.cy.container();
    var cssColor = container && container.style && container.style.backgroundColor || 'white';
    return $e815fda779bc047b$var$color2tuple(cssColor);
}
function $e815fda779bc047b$var$getLabelLines(ele, prefix) {
    var rs = ele._private.rscratch;
    return $e815fda779bc047b$var$getPrefixedProperty(rs, 'labelWrapCachedLines', prefix) || [];
}
/** 
 * Handle multi-line labels by rendering each line as a seperate texture.
 * That means each line needs its own style key.
 */ var $e815fda779bc047b$var$getStyleKeysForLabel = function getStyleKeysForLabel(getKey, prefix) {
    return function(ele) {
        var key = getKey(ele);
        var lines = $e815fda779bc047b$var$getLabelLines(ele, prefix);
        if (lines.length > 1) return lines.map(function(line, index) {
            return "".concat(key, "_").concat(index);
        });
        return key;
    };
};
/**
 * Need to create a separate bounding box for each line of a multi-line label.
 * Note that 'drawClipped: true' should be used with this.
 */ var $e815fda779bc047b$var$getBoundingBoxForLabel = function getBoundingBoxForLabel(getBoundingBox, prefix) {
    return function(ele, styleKey) {
        var bb = getBoundingBox(ele);
        if (typeof styleKey === 'string') {
            var ui = styleKey.indexOf('_');
            if (ui > 0) {
                var lineIndex = Number(styleKey.substring(ui + 1));
                var lines = $e815fda779bc047b$var$getLabelLines(ele, prefix);
                // Adjust the height and Y coordinate for one line of the label.
                var h = bb.h / lines.length;
                var yOffset = h * lineIndex;
                var y1 = bb.y1 + yOffset;
                // the yOffset is needed when rotating the label
                return {
                    x1: bb.x1,
                    w: bb.w,
                    y1: y1,
                    h: h,
                    yOffset: yOffset
                };
            }
        }
        return bb;
    };
};
/**
 * Plug into the canvas renderer by dynamically overriding some of its functions.
 * This requires minimal changes to the canvas rendrerer.
 */ function $e815fda779bc047b$var$overrideCanvasRendererFunctions(r) {
    // Override the render function to call the webgl render function if the zoom level is appropriate
    var renderCanvas = r.render;
    r.render = function(options) {
        options = options || {};
        var cy = r.cy;
        if (r.webgl) {
            // If the zoom level is greater than the max zoom level, then disable webgl and switch back to 
            // the canvas renderer.
            if (cy.zoom() > $e815fda779bc047b$var$maxZoom$1) {
                $e815fda779bc047b$var$clearWebgl(r);
                renderCanvas.call(r, options);
            } else {
                $e815fda779bc047b$var$clearCanvas(r);
                $e815fda779bc047b$var$renderWebgl(r, options, $e815fda779bc047b$var$RENDER_TARGET.SCREEN);
            }
        }
    };
    // Override the matchCanvasSize function to update the picking frame buffer size
    var baseFunc = r.matchCanvasSize;
    r.matchCanvasSize = function(container) {
        baseFunc.call(r, container);
        r.pickingFrameBuffer.setFramebufferAttachmentSizes(r.canvasWidth, r.canvasHeight);
        r.pickingFrameBuffer.needsDraw = true;
    };
    // Override function to call the webgl version for picking.
    // Don't override r.getAllInBox() selction box picking, its not accurate enough with webgl
    r.findNearestElements = function(x, y, interactiveElementsOnly, isTouch) {
        // the canvas version of this function is very slow on large graphs
        return $e815fda779bc047b$var$findNearestElementsWebgl(r, x, y);
    };
    // need to know when the cached elements have changed so we can invalidate our caches
    var _baseFunc = r.invalidateCachedZSortedEles;
    r.invalidateCachedZSortedEles = function() {
        _baseFunc.call(r);
        r.pickingFrameBuffer.needsDraw = true;
    };
    // need to know when the cached elements have changed so we can invalidate our caches
    var _baseFunc2 = r.notify;
    r.notify = function(eventName, eles) {
        _baseFunc2.call(r, eventName, eles);
        if (eventName === 'viewport' || eventName === 'bounds') r.pickingFrameBuffer.needsDraw = true;
        else if (eventName === 'background') // background image finished loading, need to redraw
        r.drawing.invalidate(eles, {
            type: 'node-body'
        });
    };
}
function $e815fda779bc047b$var$clearWebgl(r) {
    var gl = r.data.contexts[r.WEBGL];
    gl.clear(gl.COLOR_BUFFER_BIT | gl.DEPTH_BUFFER_BIT);
}
function $e815fda779bc047b$var$clearCanvas(r) {
    // the CRp.clearCanvas() function doesn't take the transform into account
    var clear = function clear(context) {
        context.save();
        context.setTransform(1, 0, 0, 1, 0, 0);
        context.clearRect(0, 0, r.canvasWidth, r.canvasHeight);
        context.restore();
    };
    clear(r.data.contexts[r.NODE]);
    clear(r.data.contexts[r.DRAG]);
}
function $e815fda779bc047b$var$createPanZoomMatrix(r) {
    var width = r.canvasWidth;
    var height = r.canvasHeight;
    var _util$getEffectivePan = $e815fda779bc047b$var$getEffectivePanZoom(r), pan = _util$getEffectivePan.pan, zoom = _util$getEffectivePan.zoom;
    var transform = $e815fda779bc047b$var$create();
    $e815fda779bc047b$var$translate(transform, transform, [
        pan.x,
        pan.y
    ]);
    $e815fda779bc047b$var$scale(transform, transform, [
        zoom,
        zoom
    ]);
    var projection$1 = $e815fda779bc047b$var$create();
    $e815fda779bc047b$var$projection(projection$1, width, height);
    var product = $e815fda779bc047b$var$create();
    $e815fda779bc047b$var$multiply(product, projection$1, transform);
    return product;
}
function $e815fda779bc047b$var$setContextTransform(r, context) {
    var width = r.canvasWidth;
    var height = r.canvasHeight;
    var _util$getEffectivePan2 = $e815fda779bc047b$var$getEffectivePanZoom(r), pan = _util$getEffectivePan2.pan, zoom = _util$getEffectivePan2.zoom;
    context.setTransform(1, 0, 0, 1, 0, 0);
    context.clearRect(0, 0, width, height);
    context.translate(pan.x, pan.y);
    context.scale(zoom, zoom);
}
function $e815fda779bc047b$var$drawSelectionRectangle(r, options) {
    r.drawSelectionRectangle(options, function(context) {
        return $e815fda779bc047b$var$setContextTransform(r, context);
    });
}
function $e815fda779bc047b$var$drawAxes(r) {
    // for debgging
    var context = r.data.contexts[r.NODE];
    context.save();
    $e815fda779bc047b$var$setContextTransform(r, context);
    context.strokeStyle = 'rgba(0, 0, 0, 0.3)';
    context.beginPath();
    context.moveTo(-1000, 0);
    context.lineTo(1000, 0);
    context.stroke();
    context.beginPath();
    context.moveTo(0, -1000);
    context.lineTo(0, 1000);
    context.stroke();
    context.restore();
}
function $e815fda779bc047b$var$drawAtlases(r) {
    // For debugging the atlases, this doesn't work for Atlases that are locked
    var draw = function draw(drawing, name, row) {
        var collection = drawing.atlasManager.getAtlasCollection(name);
        var context = r.data.contexts[r.NODE];
        var atlases = collection.atlases;
        for(var _i = 0; _i < atlases.length; _i++){
            var atlas = atlases[_i];
            var canvas = atlas.canvas;
            if (canvas) {
                var w = canvas.width;
                var h = canvas.height;
                var x = w * _i;
                var y = canvas.height * row;
                var scale = 0.4;
                context.save();
                context.scale(scale, scale);
                context.drawImage(canvas, x, y);
                context.strokeStyle = 'black';
                context.rect(x, y, w, h);
                context.stroke();
                context.restore();
            }
        }
    };
    var i = 0;
    draw(r.drawing, 'node', i++);
    draw(r.drawing, 'label', i++);
}
/**
 * Returns the z-order index of elments under or very close to the mouse cursor point.
 * Arguments are in model coordinates.
 * (x1, y1) is top left corner
 * (x2, y2) is bottom right corner (optional)
 * Returns a Set of indexes.
 */ function $e815fda779bc047b$var$getPickingIndexes(r, mX1, mY1, mX2, mY2) {
    var x, y, w, h;
    var _util$getEffectivePan3 = $e815fda779bc047b$var$getEffectivePanZoom(r), pan = _util$getEffectivePan3.pan, zoom = _util$getEffectivePan3.zoom;
    var _util$modelToRendered = $e815fda779bc047b$var$modelToRenderedPosition(r, pan, zoom, mX1, mY1), _util$modelToRendered2 = $e815fda779bc047b$var$_slicedToArray(_util$modelToRendered, 2), cX1 = _util$modelToRendered2[0], cY1 = _util$modelToRendered2[1];
    var t = 6; // should be even
    x = cX1 - t / 2;
    y = cY1 - t / 2;
    w = t;
    h = t;
    if (w === 0 || h === 0) return [];
    var gl = r.data.contexts[r.WEBGL];
    gl.bindFramebuffer(gl.FRAMEBUFFER, r.pickingFrameBuffer);
    if (r.pickingFrameBuffer.needsDraw) {
        // Draw element z-indexes to the picking framebuffer
        gl.viewport(0, 0, gl.canvas.width, gl.canvas.height);
        $e815fda779bc047b$var$renderWebgl(r, null, $e815fda779bc047b$var$RENDER_TARGET.PICKING);
        r.pickingFrameBuffer.needsDraw = false;
    }
    var n = w * h; // number of pixels to read
    var data = new Uint8Array(n * 4); // 4 bytes per pixel
    gl.readPixels(x, y, w, h, gl.RGBA, gl.UNSIGNED_BYTE, data);
    gl.bindFramebuffer(gl.FRAMEBUFFER, null);
    var indexes = new Set();
    for(var i = 0; i < n; i++){
        var pixel = data.slice(i * 4, i * 4 + 4);
        var index = $e815fda779bc047b$var$vec4ToIndex(pixel) - 1; // The framebuffer is cleared with 0s, so z-indexes are offset by 1
        if (index >= 0) indexes.add(index);
    }
    return indexes;
}
/**
 * Cy.js: model coordinate y axis goes down
 */ function $e815fda779bc047b$var$findNearestElementsWebgl(r, x, y) {
    // model coordinates
    var indexes = $e815fda779bc047b$var$getPickingIndexes(r, x, y);
    var eles = r.getCachedZSortedEles();
    var node, edge;
    var _iterator = $e815fda779bc047b$var$_createForOfIteratorHelper(indexes), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var index = _step.value;
            var ele = eles[index];
            if (!node && ele.isNode()) node = ele;
            if (!edge && ele.isEdge()) edge = ele;
            if (node && edge) break;
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    return [
        node,
        edge
    ].filter(Boolean);
}
/**
 * Draw one node or edge. 
 */ function $e815fda779bc047b$var$drawEle(r, index, ele) {
    var drawing = r.drawing;
    index += 1; // 0 is used to clear the background, need to offset all z-indexes by one
    if (ele.isNode()) {
        drawing.drawNode(ele, index, 'node-underlay');
        drawing.drawNode(ele, index, 'node-body');
        drawing.drawTexture(ele, index, 'label');
        drawing.drawNode(ele, index, 'node-overlay');
    } else {
        drawing.drawEdgeLine(ele, index);
        drawing.drawEdgeArrow(ele, index, 'source');
        drawing.drawEdgeArrow(ele, index, 'target');
        drawing.drawTexture(ele, index, 'label');
        drawing.drawTexture(ele, index, 'edge-source-label');
        drawing.drawTexture(ele, index, 'edge-target-label');
    }
}
/**
 * Render one frame.
 */ function $e815fda779bc047b$var$renderWebgl(r, options, renderTarget) {
    var start;
    if (r.webglDebug) start = performance.now(); // eslint-disable-line no-undef
    var drawing = r.drawing;
    var eleCount = 0;
    if (renderTarget.screen) {
        if (r.data.canvasNeedsRedraw[r.SELECT_BOX]) $e815fda779bc047b$var$drawSelectionRectangle(r, options);
    }
    // see drawing-elements.js drawCachedElement()
    if (r.data.canvasNeedsRedraw[r.NODE] || renderTarget.picking) {
        var gl = r.data.contexts[r.WEBGL];
        if (renderTarget.screen) {
            gl.clearColor(0, 0, 0, 0); // background color
            gl.enable(gl.BLEND); // enable alpha blending of colors
            gl.blendFunc(gl.ONE, gl.ONE_MINUS_SRC_ALPHA); // webgl colors use premultiplied alpha
        } else gl.disable(gl.BLEND); // don't blend z-order index values! they are not colors
        gl.clear(gl.COLOR_BUFFER_BIT | gl.DEPTH_BUFFER_BIT);
        gl.viewport(0, 0, gl.canvas.width, gl.canvas.height);
        var panZoomMatrix = $e815fda779bc047b$var$createPanZoomMatrix(r);
        var eles = r.getCachedZSortedEles();
        eleCount = eles.length;
        drawing.startFrame(panZoomMatrix, renderTarget);
        if (renderTarget.screen) {
            for(var i = 0; i < eles.nondrag.length; i++)$e815fda779bc047b$var$drawEle(r, i, eles.nondrag[i]);
            for(var _i2 = 0; _i2 < eles.drag.length; _i2++)$e815fda779bc047b$var$drawEle(r, _i2, eles.drag[_i2]);
        } else if (renderTarget.picking) for(var _i3 = 0; _i3 < eles.length; _i3++)$e815fda779bc047b$var$drawEle(r, _i3, eles[_i3]);
        drawing.endFrame();
        if (renderTarget.screen && r.webglDebugShowAtlases) {
            $e815fda779bc047b$var$drawAxes(r);
            $e815fda779bc047b$var$drawAtlases(r);
        }
        r.data.canvasNeedsRedraw[r.NODE] = false;
        r.data.canvasNeedsRedraw[r.DRAG] = false;
    }
    if (r.webglDebug) {
        // eslint-disable-next-line no-undef
        var end = performance.now();
        var compact = false;
        var time = Math.ceil(end - start);
        var debugInfo = drawing.getDebugInfo();
        var report = [
            "".concat(eleCount, " elements"),
            "".concat(debugInfo.totalInstances, " instances"),
            "".concat(debugInfo.batchCount, " batches"),
            "".concat(debugInfo.totalAtlases, " atlases"),
            "".concat(debugInfo.wrappedCount, " wrapped textures"),
            "".concat(debugInfo.simpleCount, " simple shapes")
        ].join(', ');
        if (compact) console.log("WebGL (".concat(renderTarget.name, ") - time ").concat(time, "ms, ").concat(report));
        else {
            console.log("WebGL (".concat(renderTarget.name, ") - frame time ").concat(time, "ms"));
            console.log('Totals:');
            console.log("  ".concat(report));
            console.log('Texture Atlases Used:');
            var atlasInfo = debugInfo.atlasInfo;
            var _iterator2 = $e815fda779bc047b$var$_createForOfIteratorHelper(atlasInfo), _step2;
            try {
                for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                    var info = _step2.value;
                    console.log("  ".concat(info.type, ": ").concat(info.keyCount, " keys, ").concat(info.atlasCount, " atlases"));
                }
            } catch (err) {
                _iterator2.e(err);
            } finally{
                _iterator2.f();
            }
            console.log('');
        }
    }
    if (r.data.gc) {
        console.log('Garbage Collect!');
        r.data.gc = false;
        drawing.gc();
    }
}
var $e815fda779bc047b$var$CRp$3 = {};
// @O Polygon drawing
$e815fda779bc047b$var$CRp$3.drawPolygonPath = function(context, x, y, width, height, points) {
    var halfW = width / 2;
    var halfH = height / 2;
    if (context.beginPath) context.beginPath();
    context.moveTo(x + halfW * points[0], y + halfH * points[1]);
    for(var i = 1; i < points.length / 2; i++)context.lineTo(x + halfW * points[i * 2], y + halfH * points[i * 2 + 1]);
    context.closePath();
};
$e815fda779bc047b$var$CRp$3.drawRoundPolygonPath = function(context, x, y, width, height, points, corners) {
    corners.forEach(function(corner) {
        return $e815fda779bc047b$var$drawPreparedRoundCorner(context, corner);
    });
    context.closePath();
};
// Round rectangle drawing
$e815fda779bc047b$var$CRp$3.drawRoundRectanglePath = function(context, x, y, width, height, radius) {
    var halfWidth = width / 2;
    var halfHeight = height / 2;
    var cornerRadius = radius === 'auto' ? $e815fda779bc047b$var$getRoundRectangleRadius(width, height) : Math.min(radius, halfHeight, halfWidth);
    if (context.beginPath) context.beginPath();
    // Start at top middle
    context.moveTo(x, y - halfHeight);
    // Arc from middle top to right side
    context.arcTo(x + halfWidth, y - halfHeight, x + halfWidth, y, cornerRadius);
    // Arc from right side to bottom
    context.arcTo(x + halfWidth, y + halfHeight, x, y + halfHeight, cornerRadius);
    // Arc from bottom to left side
    context.arcTo(x - halfWidth, y + halfHeight, x - halfWidth, y, cornerRadius);
    // Arc from left side to topBorder
    context.arcTo(x - halfWidth, y - halfHeight, x, y - halfHeight, cornerRadius);
    // Join line
    context.lineTo(x, y - halfHeight);
    context.closePath();
};
$e815fda779bc047b$var$CRp$3.drawBottomRoundRectanglePath = function(context, x, y, width, height, radius) {
    var halfWidth = width / 2;
    var halfHeight = height / 2;
    var cornerRadius = radius === 'auto' ? $e815fda779bc047b$var$getRoundRectangleRadius(width, height) : radius;
    if (context.beginPath) context.beginPath();
    // Start at top middle
    context.moveTo(x, y - halfHeight);
    context.lineTo(x + halfWidth, y - halfHeight);
    context.lineTo(x + halfWidth, y);
    context.arcTo(x + halfWidth, y + halfHeight, x, y + halfHeight, cornerRadius);
    context.arcTo(x - halfWidth, y + halfHeight, x - halfWidth, y, cornerRadius);
    context.lineTo(x - halfWidth, y - halfHeight);
    context.lineTo(x, y - halfHeight);
    context.closePath();
};
$e815fda779bc047b$var$CRp$3.drawCutRectanglePath = function(context, x, y, width, height, points, corners) {
    var halfWidth = width / 2;
    var halfHeight = height / 2;
    var cornerLength = corners === 'auto' ? $e815fda779bc047b$var$getCutRectangleCornerLength() : corners;
    if (context.beginPath) context.beginPath();
    context.moveTo(x - halfWidth + cornerLength, y - halfHeight);
    context.lineTo(x + halfWidth - cornerLength, y - halfHeight);
    context.lineTo(x + halfWidth, y - halfHeight + cornerLength);
    context.lineTo(x + halfWidth, y + halfHeight - cornerLength);
    context.lineTo(x + halfWidth - cornerLength, y + halfHeight);
    context.lineTo(x - halfWidth + cornerLength, y + halfHeight);
    context.lineTo(x - halfWidth, y + halfHeight - cornerLength);
    context.lineTo(x - halfWidth, y - halfHeight + cornerLength);
    context.closePath();
};
$e815fda779bc047b$var$CRp$3.drawBarrelPath = function(context, x, y, width, height) {
    var halfWidth = width / 2;
    var halfHeight = height / 2;
    var xBegin = x - halfWidth;
    var xEnd = x + halfWidth;
    var yBegin = y - halfHeight;
    var yEnd = y + halfHeight;
    var barrelCurveConstants = $e815fda779bc047b$var$getBarrelCurveConstants(width, height);
    var wOffset = barrelCurveConstants.widthOffset;
    var hOffset = barrelCurveConstants.heightOffset;
    var ctrlPtXOffset = barrelCurveConstants.ctrlPtOffsetPct * wOffset;
    if (context.beginPath) context.beginPath();
    context.moveTo(xBegin, yBegin + hOffset);
    context.lineTo(xBegin, yEnd - hOffset);
    context.quadraticCurveTo(xBegin + ctrlPtXOffset, yEnd, xBegin + wOffset, yEnd);
    context.lineTo(xEnd - wOffset, yEnd);
    context.quadraticCurveTo(xEnd - ctrlPtXOffset, yEnd, xEnd, yEnd - hOffset);
    context.lineTo(xEnd, yBegin + hOffset);
    context.quadraticCurveTo(xEnd - ctrlPtXOffset, yBegin, xEnd - wOffset, yBegin);
    context.lineTo(xBegin + wOffset, yBegin);
    context.quadraticCurveTo(xBegin + ctrlPtXOffset, yBegin, xBegin, yBegin + hOffset);
    context.closePath();
};
var $e815fda779bc047b$var$sin0 = Math.sin(0);
var $e815fda779bc047b$var$cos0 = Math.cos(0);
var $e815fda779bc047b$var$sin = {};
var $e815fda779bc047b$var$cos = {};
var $e815fda779bc047b$var$ellipseStepSize = Math.PI / 40;
for(var $e815fda779bc047b$var$i = 0 * Math.PI; $e815fda779bc047b$var$i < 2 * Math.PI; $e815fda779bc047b$var$i += $e815fda779bc047b$var$ellipseStepSize){
    $e815fda779bc047b$var$sin[$e815fda779bc047b$var$i] = Math.sin($e815fda779bc047b$var$i);
    $e815fda779bc047b$var$cos[$e815fda779bc047b$var$i] = Math.cos($e815fda779bc047b$var$i);
}
$e815fda779bc047b$var$CRp$3.drawEllipsePath = function(context, centerX, centerY, width, height) {
    if (context.beginPath) context.beginPath();
    if (context.ellipse) context.ellipse(centerX, centerY, width / 2, height / 2, 0, 0, 2 * Math.PI);
    else {
        var xPos, yPos;
        var rw = width / 2;
        var rh = height / 2;
        for(var i = 0 * Math.PI; i < 2 * Math.PI; i += $e815fda779bc047b$var$ellipseStepSize){
            xPos = centerX - rw * $e815fda779bc047b$var$sin[i] * $e815fda779bc047b$var$sin0 + rw * $e815fda779bc047b$var$cos[i] * $e815fda779bc047b$var$cos0;
            yPos = centerY + rh * $e815fda779bc047b$var$cos[i] * $e815fda779bc047b$var$sin0 + rh * $e815fda779bc047b$var$sin[i] * $e815fda779bc047b$var$cos0;
            if (i === 0) context.moveTo(xPos, yPos);
            else context.lineTo(xPos, yPos);
        }
    }
    context.closePath();
};
/* global atob, ArrayBuffer, Uint8Array, Blob */ var $e815fda779bc047b$var$CRp$2 = {};
$e815fda779bc047b$var$CRp$2.createBuffer = function(w, h) {
    var buffer = document.createElement('canvas'); // eslint-disable-line no-undef
    buffer.width = w;
    buffer.height = h;
    return [
        buffer,
        buffer.getContext('2d')
    ];
};
$e815fda779bc047b$var$CRp$2.bufferCanvasImage = function(options) {
    var cy = this.cy;
    var eles = cy.mutableElements();
    var bb = eles.boundingBox();
    var ctrRect = this.findContainerClientCoords();
    var width = options.full ? Math.ceil(bb.w) : ctrRect[2];
    var height = options.full ? Math.ceil(bb.h) : ctrRect[3];
    var specdMaxDims = $e815fda779bc047b$var$number$1(options.maxWidth) || $e815fda779bc047b$var$number$1(options.maxHeight);
    var pxRatio = this.getPixelRatio();
    var scale = 1;
    if (options.scale !== undefined) {
        width *= options.scale;
        height *= options.scale;
        scale = options.scale;
    } else if (specdMaxDims) {
        var maxScaleW = Infinity;
        var maxScaleH = Infinity;
        if ($e815fda779bc047b$var$number$1(options.maxWidth)) maxScaleW = scale * options.maxWidth / width;
        if ($e815fda779bc047b$var$number$1(options.maxHeight)) maxScaleH = scale * options.maxHeight / height;
        scale = Math.min(maxScaleW, maxScaleH);
        width *= scale;
        height *= scale;
    }
    if (!specdMaxDims) {
        width *= pxRatio;
        height *= pxRatio;
        scale *= pxRatio;
    }
    var buffCanvas = document.createElement('canvas'); // eslint-disable-line no-undef
    buffCanvas.width = width;
    buffCanvas.height = height;
    buffCanvas.style.width = width + 'px';
    buffCanvas.style.height = height + 'px';
    var buffCxt = buffCanvas.getContext('2d');
    // Rasterize the layers, but only if container has nonzero size
    if (width > 0 && height > 0) {
        buffCxt.clearRect(0, 0, width, height);
        buffCxt.globalCompositeOperation = 'source-over';
        var zsortedEles = this.getCachedZSortedEles();
        if (options.full) {
            // draw the full bounds of the graph
            buffCxt.translate(-bb.x1 * scale, -bb.y1 * scale);
            buffCxt.scale(scale, scale);
            this.drawElements(buffCxt, zsortedEles);
            buffCxt.scale(1 / scale, 1 / scale);
            buffCxt.translate(bb.x1 * scale, bb.y1 * scale);
        } else {
            // draw the current view
            var pan = cy.pan();
            var translation = {
                x: pan.x * scale,
                y: pan.y * scale
            };
            scale *= cy.zoom();
            buffCxt.translate(translation.x, translation.y);
            buffCxt.scale(scale, scale);
            this.drawElements(buffCxt, zsortedEles);
            buffCxt.scale(1 / scale, 1 / scale);
            buffCxt.translate(-translation.x, -translation.y);
        }
        // need to fill bg at end like this in order to fill cleared transparent pixels in jpgs
        if (options.bg) {
            buffCxt.globalCompositeOperation = 'destination-over';
            buffCxt.fillStyle = options.bg;
            buffCxt.rect(0, 0, width, height);
            buffCxt.fill();
        }
    }
    return buffCanvas;
};
function $e815fda779bc047b$var$b64ToBlob(b64, mimeType) {
    var bytes = atob(b64);
    var buff = new ArrayBuffer(bytes.length);
    var buffUint8 = new Uint8Array(buff);
    for(var i = 0; i < bytes.length; i++)buffUint8[i] = bytes.charCodeAt(i);
    return new Blob([
        buff
    ], {
        type: mimeType
    });
}
function $e815fda779bc047b$var$b64UriToB64(b64uri) {
    var i = b64uri.indexOf(',');
    return b64uri.substr(i + 1);
}
function $e815fda779bc047b$var$output(options, canvas, mimeType) {
    var getB64Uri = function getB64Uri() {
        return canvas.toDataURL(mimeType, options.quality);
    };
    switch(options.output){
        case 'blob-promise':
            return new $e815fda779bc047b$var$Promise$1(function(resolve, reject) {
                try {
                    canvas.toBlob(function(blob) {
                        if (blob != null) resolve(blob);
                        else reject(new Error('`canvas.toBlob()` sent a null value in its callback'));
                    }, mimeType, options.quality);
                } catch (err) {
                    reject(err);
                }
            });
        case 'blob':
            return $e815fda779bc047b$var$b64ToBlob($e815fda779bc047b$var$b64UriToB64(getB64Uri()), mimeType);
        case 'base64':
            return $e815fda779bc047b$var$b64UriToB64(getB64Uri());
        case 'base64uri':
        default:
            return getB64Uri();
    }
}
$e815fda779bc047b$var$CRp$2.png = function(options) {
    return $e815fda779bc047b$var$output(options, this.bufferCanvasImage(options), 'image/png');
};
$e815fda779bc047b$var$CRp$2.jpg = function(options) {
    return $e815fda779bc047b$var$output(options, this.bufferCanvasImage(options), 'image/jpeg');
};
var $e815fda779bc047b$var$CRp$1 = {};
$e815fda779bc047b$var$CRp$1.nodeShapeImpl = function(name, context, centerX, centerY, width, height, points, corners) {
    switch(name){
        case 'ellipse':
            return this.drawEllipsePath(context, centerX, centerY, width, height);
        case 'polygon':
            return this.drawPolygonPath(context, centerX, centerY, width, height, points);
        case 'round-polygon':
            return this.drawRoundPolygonPath(context, centerX, centerY, width, height, points, corners);
        case 'roundrectangle':
        case 'round-rectangle':
            return this.drawRoundRectanglePath(context, centerX, centerY, width, height, corners);
        case 'cutrectangle':
        case 'cut-rectangle':
            return this.drawCutRectanglePath(context, centerX, centerY, width, height, points, corners);
        case 'bottomroundrectangle':
        case 'bottom-round-rectangle':
            return this.drawBottomRoundRectanglePath(context, centerX, centerY, width, height, corners);
        case 'barrel':
            return this.drawBarrelPath(context, centerX, centerY, width, height);
    }
};
var $e815fda779bc047b$var$CR = $e815fda779bc047b$var$CanvasRenderer;
var $e815fda779bc047b$var$CRp = $e815fda779bc047b$var$CanvasRenderer.prototype;
$e815fda779bc047b$var$CRp.CANVAS_LAYERS = 3;
//
$e815fda779bc047b$var$CRp.SELECT_BOX = 0;
$e815fda779bc047b$var$CRp.DRAG = 1;
$e815fda779bc047b$var$CRp.NODE = 2;
$e815fda779bc047b$var$CRp.WEBGL = 3;
$e815fda779bc047b$var$CRp.CANVAS_TYPES = [
    '2d',
    '2d',
    '2d',
    'webgl2'
];
$e815fda779bc047b$var$CRp.BUFFER_COUNT = 3;
//
$e815fda779bc047b$var$CRp.TEXTURE_BUFFER = 0;
$e815fda779bc047b$var$CRp.MOTIONBLUR_BUFFER_NODE = 1;
$e815fda779bc047b$var$CRp.MOTIONBLUR_BUFFER_DRAG = 2;
function $e815fda779bc047b$var$CanvasRenderer(options) {
    var r = this;
    var containerWindow = r.cy.window();
    var document1 = containerWindow.document;
    if (options.webgl) {
        $e815fda779bc047b$var$CRp.CANVAS_LAYERS = r.CANVAS_LAYERS = 4;
        console.log('webgl rendering enabled');
    }
    r.data = {
        canvases: new Array($e815fda779bc047b$var$CRp.CANVAS_LAYERS),
        contexts: new Array($e815fda779bc047b$var$CRp.CANVAS_LAYERS),
        canvasNeedsRedraw: new Array($e815fda779bc047b$var$CRp.CANVAS_LAYERS),
        bufferCanvases: new Array($e815fda779bc047b$var$CRp.BUFFER_COUNT),
        bufferContexts: new Array($e815fda779bc047b$var$CRp.CANVAS_LAYERS)
    };
    var tapHlOffAttr = '-webkit-tap-highlight-color';
    var tapHlOffStyle = 'rgba(0,0,0,0)';
    r.data.canvasContainer = document1.createElement('div'); // eslint-disable-line no-undef
    var containerStyle = r.data.canvasContainer.style;
    r.data.canvasContainer.style[tapHlOffAttr] = tapHlOffStyle;
    containerStyle.position = 'relative';
    containerStyle.zIndex = '0';
    containerStyle.overflow = 'hidden';
    var container = options.cy.container();
    container.appendChild(r.data.canvasContainer);
    container.style[tapHlOffAttr] = tapHlOffStyle;
    var styleMap = {
        '-webkit-user-select': 'none',
        '-moz-user-select': '-moz-none',
        'user-select': 'none',
        '-webkit-tap-highlight-color': 'rgba(0,0,0,0)',
        'outline-style': 'none'
    };
    if ($e815fda779bc047b$var$ms()) {
        styleMap['-ms-touch-action'] = 'none';
        styleMap['touch-action'] = 'none';
    }
    for(var i = 0; i < $e815fda779bc047b$var$CRp.CANVAS_LAYERS; i++){
        var canvas = r.data.canvases[i] = document1.createElement('canvas'); // eslint-disable-line no-undef
        var type = $e815fda779bc047b$var$CRp.CANVAS_TYPES[i];
        r.data.contexts[i] = canvas.getContext(type);
        if (!r.data.contexts[i]) $e815fda779bc047b$var$error('Could not create canvas of type ' + type);
        Object.keys(styleMap).forEach(function(k) {
            canvas.style[k] = styleMap[k];
        });
        canvas.style.position = 'absolute';
        canvas.setAttribute('data-id', 'layer' + i);
        canvas.style.zIndex = String($e815fda779bc047b$var$CRp.CANVAS_LAYERS - i);
        r.data.canvasContainer.appendChild(canvas);
        r.data.canvasNeedsRedraw[i] = false;
    }
    r.data.topCanvas = r.data.canvases[0];
    r.data.canvases[$e815fda779bc047b$var$CRp.NODE].setAttribute('data-id', 'layer' + $e815fda779bc047b$var$CRp.NODE + '-node');
    r.data.canvases[$e815fda779bc047b$var$CRp.SELECT_BOX].setAttribute('data-id', 'layer' + $e815fda779bc047b$var$CRp.SELECT_BOX + '-selectbox');
    r.data.canvases[$e815fda779bc047b$var$CRp.DRAG].setAttribute('data-id', 'layer' + $e815fda779bc047b$var$CRp.DRAG + '-drag');
    if (r.data.canvases[$e815fda779bc047b$var$CRp.WEBGL]) r.data.canvases[$e815fda779bc047b$var$CRp.WEBGL].setAttribute('data-id', 'layer' + $e815fda779bc047b$var$CRp.WEBGL + '-webgl');
    for(var i = 0; i < $e815fda779bc047b$var$CRp.BUFFER_COUNT; i++){
        r.data.bufferCanvases[i] = document1.createElement('canvas'); // eslint-disable-line no-undef
        r.data.bufferContexts[i] = r.data.bufferCanvases[i].getContext('2d');
        r.data.bufferCanvases[i].style.position = 'absolute';
        r.data.bufferCanvases[i].setAttribute('data-id', 'buffer' + i);
        r.data.bufferCanvases[i].style.zIndex = String(-i - 1);
        r.data.bufferCanvases[i].style.visibility = 'hidden';
    //r.data.canvasContainer.appendChild(r.data.bufferCanvases[i]);
    }
    r.pathsEnabled = true;
    var emptyBb = $e815fda779bc047b$var$makeBoundingBox();
    var getBoxCenter = function getBoxCenter(bb) {
        return {
            x: (bb.x1 + bb.x2) / 2,
            y: (bb.y1 + bb.y2) / 2
        };
    };
    var getCenterOffset = function getCenterOffset(bb) {
        return {
            x: -bb.w / 2,
            y: -bb.h / 2
        };
    };
    var backgroundTimestampHasChanged = function backgroundTimestampHasChanged(ele) {
        var _p = ele[0]._private;
        var same = _p.oldBackgroundTimestamp === _p.backgroundTimestamp;
        return !same;
    };
    var getStyleKey = function getStyleKey(ele) {
        return ele[0]._private.nodeKey;
    };
    var getLabelKey = function getLabelKey(ele) {
        return ele[0]._private.labelStyleKey;
    };
    var getSourceLabelKey = function getSourceLabelKey(ele) {
        return ele[0]._private.sourceLabelStyleKey;
    };
    var getTargetLabelKey = function getTargetLabelKey(ele) {
        return ele[0]._private.targetLabelStyleKey;
    };
    var drawElement = function drawElement(context, ele, bb, scaledLabelShown, useEleOpacity) {
        return r.drawElement(context, ele, bb, false, false, useEleOpacity);
    };
    var drawLabel = function drawLabel(context, ele, bb, scaledLabelShown, useEleOpacity) {
        return r.drawElementText(context, ele, bb, scaledLabelShown, 'main', useEleOpacity);
    };
    var drawSourceLabel = function drawSourceLabel(context, ele, bb, scaledLabelShown, useEleOpacity) {
        return r.drawElementText(context, ele, bb, scaledLabelShown, 'source', useEleOpacity);
    };
    var drawTargetLabel = function drawTargetLabel(context, ele, bb, scaledLabelShown, useEleOpacity) {
        return r.drawElementText(context, ele, bb, scaledLabelShown, 'target', useEleOpacity);
    };
    var getElementBox = function getElementBox(ele) {
        ele.boundingBox();
        return ele[0]._private.bodyBounds;
    };
    var getLabelBox = function getLabelBox(ele) {
        ele.boundingBox();
        return ele[0]._private.labelBounds.main || emptyBb;
    };
    var getSourceLabelBox = function getSourceLabelBox(ele) {
        ele.boundingBox();
        return ele[0]._private.labelBounds.source || emptyBb;
    };
    var getTargetLabelBox = function getTargetLabelBox(ele) {
        ele.boundingBox();
        return ele[0]._private.labelBounds.target || emptyBb;
    };
    var isLabelVisibleAtScale = function isLabelVisibleAtScale(ele, scaledLabelShown) {
        return scaledLabelShown;
    };
    var getElementRotationPoint = function getElementRotationPoint(ele) {
        return getBoxCenter(getElementBox(ele));
    };
    var addTextMargin = function addTextMargin(prefix, pt, ele) {
        var pre = prefix ? prefix + '-' : '';
        return {
            x: pt.x + ele.pstyle(pre + 'text-margin-x').pfValue,
            y: pt.y + ele.pstyle(pre + 'text-margin-y').pfValue
        };
    };
    var getRsPt = function getRsPt(ele, x, y) {
        var rs = ele[0]._private.rscratch;
        return {
            x: rs[x],
            y: rs[y]
        };
    };
    var getLabelRotationPoint = function getLabelRotationPoint(ele) {
        return addTextMargin('', getRsPt(ele, 'labelX', 'labelY'), ele);
    };
    var getSourceLabelRotationPoint = function getSourceLabelRotationPoint(ele) {
        return addTextMargin('source', getRsPt(ele, 'sourceLabelX', 'sourceLabelY'), ele);
    };
    var getTargetLabelRotationPoint = function getTargetLabelRotationPoint(ele) {
        return addTextMargin('target', getRsPt(ele, 'targetLabelX', 'targetLabelY'), ele);
    };
    var getElementRotationOffset = function getElementRotationOffset(ele) {
        return getCenterOffset(getElementBox(ele));
    };
    var getSourceLabelRotationOffset = function getSourceLabelRotationOffset(ele) {
        return getCenterOffset(getSourceLabelBox(ele));
    };
    var getTargetLabelRotationOffset = function getTargetLabelRotationOffset(ele) {
        return getCenterOffset(getTargetLabelBox(ele));
    };
    var getLabelRotationOffset = function getLabelRotationOffset(ele) {
        var bb = getLabelBox(ele);
        var p = getCenterOffset(getLabelBox(ele));
        if (ele.isNode()) {
            switch(ele.pstyle('text-halign').value){
                case 'left':
                    p.x = -bb.w - (bb.leftPad || 0);
                    break;
                case 'right':
                    p.x = -(bb.rightPad || 0);
                    break;
            }
            switch(ele.pstyle('text-valign').value){
                case 'top':
                    p.y = -bb.h - (bb.topPad || 0);
                    break;
                case 'bottom':
                    p.y = -(bb.botPad || 0);
                    break;
            }
        }
        return p;
    };
    var eleTxrCache = r.data.eleTxrCache = new $e815fda779bc047b$var$ElementTextureCache(r, {
        getKey: getStyleKey,
        doesEleInvalidateKey: backgroundTimestampHasChanged,
        drawElement: drawElement,
        getBoundingBox: getElementBox,
        getRotationPoint: getElementRotationPoint,
        getRotationOffset: getElementRotationOffset,
        allowEdgeTxrCaching: false,
        allowParentTxrCaching: false
    });
    var lblTxrCache = r.data.lblTxrCache = new $e815fda779bc047b$var$ElementTextureCache(r, {
        getKey: getLabelKey,
        drawElement: drawLabel,
        getBoundingBox: getLabelBox,
        getRotationPoint: getLabelRotationPoint,
        getRotationOffset: getLabelRotationOffset,
        isVisible: isLabelVisibleAtScale
    });
    var slbTxrCache = r.data.slbTxrCache = new $e815fda779bc047b$var$ElementTextureCache(r, {
        getKey: getSourceLabelKey,
        drawElement: drawSourceLabel,
        getBoundingBox: getSourceLabelBox,
        getRotationPoint: getSourceLabelRotationPoint,
        getRotationOffset: getSourceLabelRotationOffset,
        isVisible: isLabelVisibleAtScale
    });
    var tlbTxrCache = r.data.tlbTxrCache = new $e815fda779bc047b$var$ElementTextureCache(r, {
        getKey: getTargetLabelKey,
        drawElement: drawTargetLabel,
        getBoundingBox: getTargetLabelBox,
        getRotationPoint: getTargetLabelRotationPoint,
        getRotationOffset: getTargetLabelRotationOffset,
        isVisible: isLabelVisibleAtScale
    });
    var lyrTxrCache = r.data.lyrTxrCache = new $e815fda779bc047b$var$LayeredTextureCache(r);
    r.onUpdateEleCalcs(function invalidateTextureCaches(willDraw, eles) {
        // each cache should check for sub-key diff to see that the update affects that cache particularly
        eleTxrCache.invalidateElements(eles);
        lblTxrCache.invalidateElements(eles);
        slbTxrCache.invalidateElements(eles);
        tlbTxrCache.invalidateElements(eles);
        // any change invalidates the layers
        lyrTxrCache.invalidateElements(eles);
        // update the old bg timestamp so diffs can be done in the ele txr caches
        for(var _i = 0; _i < eles.length; _i++){
            var _p = eles[_i]._private;
            _p.oldBackgroundTimestamp = _p.backgroundTimestamp;
        }
    });
    var refineInLayers = function refineInLayers(reqs) {
        for(var i = 0; i < reqs.length; i++)lyrTxrCache.enqueueElementRefinement(reqs[i].ele);
    };
    eleTxrCache.onDequeue(refineInLayers);
    lblTxrCache.onDequeue(refineInLayers);
    slbTxrCache.onDequeue(refineInLayers);
    tlbTxrCache.onDequeue(refineInLayers);
    if (options.webgl) r.initWebgl(options, {
        getStyleKey: getStyleKey,
        getLabelKey: getLabelKey,
        getSourceLabelKey: getSourceLabelKey,
        getTargetLabelKey: getTargetLabelKey,
        drawElement: drawElement,
        drawLabel: drawLabel,
        drawSourceLabel: drawSourceLabel,
        drawTargetLabel: drawTargetLabel,
        getElementBox: getElementBox,
        getLabelBox: getLabelBox,
        getSourceLabelBox: getSourceLabelBox,
        getTargetLabelBox: getTargetLabelBox,
        getElementRotationPoint: getElementRotationPoint,
        getElementRotationOffset: getElementRotationOffset,
        getLabelRotationPoint: getLabelRotationPoint,
        getSourceLabelRotationPoint: getSourceLabelRotationPoint,
        getTargetLabelRotationPoint: getTargetLabelRotationPoint,
        getLabelRotationOffset: getLabelRotationOffset,
        getSourceLabelRotationOffset: getSourceLabelRotationOffset,
        getTargetLabelRotationOffset: getTargetLabelRotationOffset
    });
}
$e815fda779bc047b$var$CRp.redrawHint = function(group, bool) {
    var r = this;
    switch(group){
        case 'eles':
            r.data.canvasNeedsRedraw[$e815fda779bc047b$var$CRp.NODE] = bool;
            break;
        case 'drag':
            r.data.canvasNeedsRedraw[$e815fda779bc047b$var$CRp.DRAG] = bool;
            break;
        case 'select':
            r.data.canvasNeedsRedraw[$e815fda779bc047b$var$CRp.SELECT_BOX] = bool;
            break;
        case 'gc':
            r.data.gc = true;
            break;
    }
};
// whether to use Path2D caching for drawing
var $e815fda779bc047b$var$pathsImpld = typeof Path2D !== 'undefined';
$e815fda779bc047b$var$CRp.path2dEnabled = function(on) {
    if (on === undefined) return this.pathsEnabled;
    this.pathsEnabled = on ? true : false;
};
$e815fda779bc047b$var$CRp.usePaths = function() {
    return $e815fda779bc047b$var$pathsImpld && this.pathsEnabled;
};
$e815fda779bc047b$var$CRp.setImgSmoothing = function(context, bool) {
    if (context.imageSmoothingEnabled != null) context.imageSmoothingEnabled = bool;
    else {
        context.webkitImageSmoothingEnabled = bool;
        context.mozImageSmoothingEnabled = bool;
        context.msImageSmoothingEnabled = bool;
    }
};
$e815fda779bc047b$var$CRp.getImgSmoothing = function(context) {
    if (context.imageSmoothingEnabled != null) return context.imageSmoothingEnabled;
    else return context.webkitImageSmoothingEnabled || context.mozImageSmoothingEnabled || context.msImageSmoothingEnabled;
};
$e815fda779bc047b$var$CRp.makeOffscreenCanvas = function(width, height) {
    var canvas;
    if ((typeof OffscreenCanvas === "undefined" ? "undefined" : $e815fda779bc047b$var$_typeof(OffscreenCanvas)) !== "undefined") canvas = new OffscreenCanvas(width, height);
    else {
        var containerWindow = this.cy.window();
        var document1 = containerWindow.document;
        canvas = document1.createElement('canvas'); // eslint-disable-line no-undef
        canvas.width = width;
        canvas.height = height;
    }
    return canvas;
};
[
    $e815fda779bc047b$var$CRp$b,
    $e815fda779bc047b$var$CRp$a,
    $e815fda779bc047b$var$CRp$9,
    $e815fda779bc047b$var$CRp$8,
    $e815fda779bc047b$var$CRp$7,
    $e815fda779bc047b$var$CRp$6,
    $e815fda779bc047b$var$CRp$5,
    $e815fda779bc047b$var$CRp$4,
    $e815fda779bc047b$var$CRp$3,
    $e815fda779bc047b$var$CRp$2,
    $e815fda779bc047b$var$CRp$1
].forEach(function(props) {
    $e815fda779bc047b$var$extend($e815fda779bc047b$var$CRp, props);
});
var $e815fda779bc047b$var$renderer = [
    {
        name: 'null',
        impl: $e815fda779bc047b$var$NullRenderer
    },
    {
        name: 'base',
        impl: $e815fda779bc047b$var$BR
    },
    {
        name: 'canvas',
        impl: $e815fda779bc047b$var$CR
    }
];
var $e815fda779bc047b$var$incExts = [
    {
        type: 'layout',
        extensions: $e815fda779bc047b$var$layout
    },
    {
        type: 'renderer',
        extensions: $e815fda779bc047b$var$renderer
    }
];
// registered extensions to cytoscape, indexed by name
var $e815fda779bc047b$var$extensions = {};
// registered modules for extensions, indexed by name
var $e815fda779bc047b$var$modules = {};
function $e815fda779bc047b$var$setExtension(type, name, registrant) {
    var ext = registrant;
    var overrideErr = function overrideErr(field) {
        $e815fda779bc047b$var$warn('Can not register `' + name + '` for `' + type + '` since `' + field + '` already exists in the prototype and can not be overridden');
    };
    if (type === 'core') {
        if ($e815fda779bc047b$var$Core.prototype[name]) return overrideErr(name);
        else $e815fda779bc047b$var$Core.prototype[name] = registrant;
    } else if (type === 'collection') {
        if ($e815fda779bc047b$var$Collection.prototype[name]) return overrideErr(name);
        else $e815fda779bc047b$var$Collection.prototype[name] = registrant;
    } else if (type === 'layout') {
        // fill in missing layout functions in the prototype
        var Layout = function Layout(options) {
            this.options = options;
            registrant.call(this, options);
            // make sure layout has _private for use w/ std apis like .on()
            if (!$e815fda779bc047b$var$plainObject(this._private)) this._private = {};
            this._private.cy = options.cy;
            this._private.listeners = [];
            this.createEmitter();
        };
        var layoutProto = Layout.prototype = Object.create(registrant.prototype);
        var optLayoutFns = [];
        for(var i = 0; i < optLayoutFns.length; i++){
            var fnName = optLayoutFns[i];
            layoutProto[fnName] = layoutProto[fnName] || function() {
                return this;
            };
        }
        // either .start() or .run() is defined, so autogen the other
        if (layoutProto.start && !layoutProto.run) layoutProto.run = function() {
            this.start();
            return this;
        };
        else if (!layoutProto.start && layoutProto.run) layoutProto.start = function() {
            this.run();
            return this;
        };
        var regStop = registrant.prototype.stop;
        layoutProto.stop = function() {
            var opts = this.options;
            if (opts && opts.animate) {
                var anis = this.animations;
                if (anis) for(var _i = 0; _i < anis.length; _i++)anis[_i].stop();
            }
            if (regStop) regStop.call(this);
            else this.emit('layoutstop');
            return this;
        };
        if (!layoutProto.destroy) layoutProto.destroy = function() {
            return this;
        };
        layoutProto.cy = function() {
            return this._private.cy;
        };
        var getCy = function getCy(layout) {
            return layout._private.cy;
        };
        var emitterOpts = {
            addEventFields: function addEventFields(layout, evt) {
                evt.layout = layout;
                evt.cy = getCy(layout);
                evt.target = layout;
            },
            bubble: function bubble() {
                return true;
            },
            parent: function parent(layout) {
                return getCy(layout);
            }
        };
        $e815fda779bc047b$var$extend(layoutProto, {
            createEmitter: function createEmitter() {
                this._private.emitter = new $e815fda779bc047b$var$Emitter(emitterOpts, this);
                return this;
            },
            emitter: function emitter() {
                return this._private.emitter;
            },
            on: function on(evt, cb) {
                this.emitter().on(evt, cb);
                return this;
            },
            one: function one(evt, cb) {
                this.emitter().one(evt, cb);
                return this;
            },
            once: function once(evt, cb) {
                this.emitter().one(evt, cb);
                return this;
            },
            removeListener: function removeListener(evt, cb) {
                this.emitter().removeListener(evt, cb);
                return this;
            },
            removeAllListeners: function removeAllListeners() {
                this.emitter().removeAllListeners();
                return this;
            },
            emit: function emit(evt, params) {
                this.emitter().emit(evt, params);
                return this;
            }
        });
        $e815fda779bc047b$var$define.eventAliasesOn(layoutProto);
        ext = Layout; // replace with our wrapped layout
    } else if (type === 'renderer' && name !== 'null' && name !== 'base') {
        // user registered renderers inherit from base
        var BaseRenderer = $e815fda779bc047b$var$getExtension('renderer', 'base');
        var bProto = BaseRenderer.prototype;
        var RegistrantRenderer = registrant;
        var rProto = registrant.prototype;
        var Renderer = function Renderer() {
            BaseRenderer.apply(this, arguments);
            RegistrantRenderer.apply(this, arguments);
        };
        var proto = Renderer.prototype;
        for(var pName in bProto){
            var pVal = bProto[pName];
            var existsInR = rProto[pName] != null;
            if (existsInR) return overrideErr(pName);
            proto[pName] = pVal; // take impl from base
        }
        for(var _pName in rProto)proto[_pName] = rProto[_pName]; // take impl from registrant
        bProto.clientFunctions.forEach(function(name) {
            proto[name] = proto[name] || function() {
                $e815fda779bc047b$var$error('Renderer does not implement `renderer.' + name + '()` on its prototype');
            };
        });
        ext = Renderer;
    } else if (type === '__proto__' || type === 'constructor' || type === 'prototype') // to avoid potential prototype pollution
    return $e815fda779bc047b$var$error(type + ' is an illegal type to be registered, possibly lead to prototype pollutions');
    return $e815fda779bc047b$var$setMap({
        map: $e815fda779bc047b$var$extensions,
        keys: [
            type,
            name
        ],
        value: ext
    });
}
function $e815fda779bc047b$var$getExtension(type, name) {
    return $e815fda779bc047b$var$getMap({
        map: $e815fda779bc047b$var$extensions,
        keys: [
            type,
            name
        ]
    });
}
function $e815fda779bc047b$var$setModule(type, name, moduleType, moduleName, registrant) {
    return $e815fda779bc047b$var$setMap({
        map: $e815fda779bc047b$var$modules,
        keys: [
            type,
            name,
            moduleType,
            moduleName
        ],
        value: registrant
    });
}
function $e815fda779bc047b$var$getModule(type, name, moduleType, moduleName) {
    return $e815fda779bc047b$var$getMap({
        map: $e815fda779bc047b$var$modules,
        keys: [
            type,
            name,
            moduleType,
            moduleName
        ]
    });
}
var $e815fda779bc047b$var$extension = function extension() {
    // e.g. extension('renderer', 'svg')
    if (arguments.length === 2) return $e815fda779bc047b$var$getExtension.apply(null, arguments);
    else if (arguments.length === 3) return $e815fda779bc047b$var$setExtension.apply(null, arguments);
    else if (arguments.length === 4) return $e815fda779bc047b$var$getModule.apply(null, arguments);
    else if (arguments.length === 5) return $e815fda779bc047b$var$setModule.apply(null, arguments);
    else $e815fda779bc047b$var$error('Invalid extension access syntax');
};
// allows a core instance to access extensions internally
$e815fda779bc047b$var$Core.prototype.extension = $e815fda779bc047b$var$extension;
// included extensions
$e815fda779bc047b$var$incExts.forEach(function(group) {
    group.extensions.forEach(function(ext) {
        $e815fda779bc047b$var$setExtension(group.type, ext.name, ext.impl);
    });
});
// a dummy stylesheet object that doesn't need a reference to the core
// (useful for init)
var $e815fda779bc047b$var$_Stylesheet = function Stylesheet() {
    if (!(this instanceof $e815fda779bc047b$var$_Stylesheet)) return new $e815fda779bc047b$var$_Stylesheet();
    this.length = 0;
};
var $e815fda779bc047b$var$sheetfn = $e815fda779bc047b$var$_Stylesheet.prototype;
$e815fda779bc047b$var$sheetfn.instanceString = function() {
    return 'stylesheet';
};
// just store the selector to be parsed later
$e815fda779bc047b$var$sheetfn.selector = function(selector) {
    var i = this.length++;
    this[i] = {
        selector: selector,
        properties: []
    };
    return this; // chaining
};
// just store the property to be parsed later
$e815fda779bc047b$var$sheetfn.css = function(name, value) {
    var i = this.length - 1;
    if ($e815fda779bc047b$var$string(name)) this[i].properties.push({
        name: name,
        value: value
    });
    else if ($e815fda779bc047b$var$plainObject(name)) {
        var map = name;
        var propNames = Object.keys(map);
        for(var j = 0; j < propNames.length; j++){
            var key = propNames[j];
            var mapVal = map[key];
            if (mapVal == null) continue;
            var prop = $e815fda779bc047b$var$_Style.properties[key] || $e815fda779bc047b$var$_Style.properties[$e815fda779bc047b$var$dash2camel(key)];
            if (prop == null) continue;
            var _name = prop.name;
            var _value = mapVal;
            this[i].properties.push({
                name: _name,
                value: _value
            });
        }
    }
    return this; // chaining
};
$e815fda779bc047b$var$sheetfn.style = $e815fda779bc047b$var$sheetfn.css;
// generate a real style object from the dummy stylesheet
$e815fda779bc047b$var$sheetfn.generateStyle = function(cy) {
    var style = new $e815fda779bc047b$var$_Style(cy);
    return this.appendToStyle(style);
};
// append a dummy stylesheet object on a real style object
$e815fda779bc047b$var$sheetfn.appendToStyle = function(style) {
    for(var i = 0; i < this.length; i++){
        var context = this[i];
        var selector = context.selector;
        var props = context.properties;
        style.selector(selector); // apply selector
        for(var j = 0; j < props.length; j++){
            var prop = props[j];
            style.css(prop.name, prop.value); // apply property
        }
    }
    return style;
};
var $e815fda779bc047b$var$version = "3.33.1";
var $e815fda779bc047b$export$2e2bcd8739ae039 = function cytoscape(options) {
    // if no options specified, use default
    if (options === undefined) options = {};
    // create instance
    if ($e815fda779bc047b$var$plainObject(options)) return new $e815fda779bc047b$var$Core(options);
    else if ($e815fda779bc047b$var$string(options)) return $e815fda779bc047b$var$extension.apply($e815fda779bc047b$var$extension, arguments);
};
// e.g. cytoscape.use( require('cytoscape-foo'), bar )
$e815fda779bc047b$export$2e2bcd8739ae039.use = function(ext) {
    var args = Array.prototype.slice.call(arguments, 1); // args to pass to ext
    args.unshift($e815fda779bc047b$export$2e2bcd8739ae039); // cytoscape is first arg to ext
    ext.apply(null, args);
    return this;
};
$e815fda779bc047b$export$2e2bcd8739ae039.warnings = function(bool) {
    return $e815fda779bc047b$var$warnings(bool);
};
// replaced by build system
$e815fda779bc047b$export$2e2bcd8739ae039.version = $e815fda779bc047b$var$version;
// expose public apis (mostly for extensions)
$e815fda779bc047b$export$2e2bcd8739ae039.stylesheet = $e815fda779bc047b$export$2e2bcd8739ae039.Stylesheet = $e815fda779bc047b$var$_Stylesheet;

});

parcelRegister("8E8xA", function(module, exports) {

(function webpackUniversalModuleDefinition(root, factory) {
    module.exports = factory((parcelRequire("8zBl0")));
})(module.exports, function(__WEBPACK_EXTERNAL_MODULE_4__) {
    return /******/ function(modules) {
        /******/ // The module cache
        /******/ var installedModules = {};
        /******/ /******/ // The require function
        /******/ function __webpack_require__(moduleId) {
            /******/ /******/ // Check if module is in cache
            /******/ if (installedModules[moduleId]) /******/ return installedModules[moduleId].exports;
            /******/ // Create a new module (and put it into the cache)
            /******/ var module1 = installedModules[moduleId] = {
                /******/ i: moduleId,
                /******/ l: false,
                /******/ exports: {}
            };
            /******/ /******/ // Execute the module function
            /******/ modules[moduleId].call(module1.exports, module1, module1.exports, __webpack_require__);
            /******/ /******/ // Flag the module as loaded
            /******/ module1.l = true;
            /******/ /******/ // Return the exports of the module
            /******/ return module1.exports;
        /******/ }
        /******/ /******/ /******/ // expose the modules object (__webpack_modules__)
        /******/ __webpack_require__.m = modules;
        /******/ /******/ // expose the module cache
        /******/ __webpack_require__.c = installedModules;
        /******/ /******/ // identity function for calling harmony imports with the correct context
        /******/ __webpack_require__.i = function(value) {
            return value;
        };
        /******/ /******/ // define getter function for harmony exports
        /******/ __webpack_require__.d = function(exports, name, getter) {
            /******/ if (!__webpack_require__.o(exports, name)) /******/ Object.defineProperty(exports, name, {
                /******/ configurable: false,
                /******/ enumerable: true,
                /******/ get: getter
            });
        /******/ };
        /******/ /******/ // getDefaultExport function for compatibility with non-harmony modules
        /******/ __webpack_require__.n = function(module1) {
            /******/ var getter = module1 && module1.__esModule ? /******/ function getDefault() {
                return module1['default'];
            } : /******/ function getModuleExports() {
                return module1;
            };
            /******/ __webpack_require__.d(getter, 'a', getter);
            /******/ return getter;
        /******/ };
        /******/ /******/ // Object.prototype.hasOwnProperty.call
        /******/ __webpack_require__.o = function(object, property) {
            return Object.prototype.hasOwnProperty.call(object, property);
        };
        /******/ /******/ // __webpack_public_path__
        /******/ __webpack_require__.p = "";
        /******/ /******/ // Load entry module and return exports
        /******/ return __webpack_require__(__webpack_require__.s = 3);
    /******/ }([
        /* 0 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var klay = __webpack_require__(4);
            var assign = __webpack_require__(1);
            var defaults = __webpack_require__(2);
            var klayNSLookup = {
                'addUnnecessaryBendpoints': 'de.cau.cs.kieler.klay.layered.unnecessaryBendpoints',
                'alignment': 'de.cau.cs.kieler.alignment',
                'aspectRatio': 'de.cau.cs.kieler.aspectRatio',
                'borderSpacing': 'borderSpacing',
                'compactComponents': 'de.cau.cs.kieler.klay.layered.components.compact',
                'compactionStrategy': 'de.cau.cs.kieler.klay.layered.nodeplace.compactionStrategy',
                'contentAlignment': 'de.cau.cs.kieler.klay.layered.contentAlignment',
                'crossingMinimization': 'de.cau.cs.kieler.klay.layered.crossMin',
                'cycleBreaking': 'de.cau.cs.kieler.klay.layered.cycleBreaking',
                'debugMode': 'de.cau.cs.kieler.debugMode',
                'direction': 'de.cau.cs.kieler.direction',
                'edgeLabelSideSelection': 'de.cau.cs.kieler.klay.layered.edgeLabelSideSelection',
                // <broken> 'de.cau.cs.kieler.klay.layered.edgeNodeSpacingFactor': options.edgeNodeSpacingFactor,
                'edgeRouting': 'de.cau.cs.kieler.edgeRouting',
                'edgeSpacingFactor': 'de.cau.cs.kieler.klay.layered.edgeSpacingFactor',
                'feedbackEdges': 'de.cau.cs.kieler.klay.layered.feedBackEdges',
                'fixedAlignment': 'de.cau.cs.kieler.klay.layered.fixedAlignment',
                'greedySwitchCrossingMinimization': 'de.cau.cs.kieler.klay.layered.greedySwitch',
                'hierarchyHandling': 'de.cau.cs.kieler.hierarchyHandling',
                'inLayerSpacingFactor': 'de.cau.cs.kieler.klay.layered.inLayerSpacingFactor',
                'interactiveReferencePoint': 'de.cau.cs.kieler.klay.layered.interactiveReferencePoint',
                'layerConstraint': 'de.cau.cs.kieler.klay.layered.layerConstraint',
                'layoutHierarchy': 'de.cau.cs.kieler.layoutHierarchy',
                'linearSegmentsDeflectionDampening': 'de.cau.cs.kieler.klay.layered.linearSegmentsDeflectionDampening',
                'mergeEdges': 'de.cau.cs.kieler.klay.layered.mergeEdges',
                'mergeHierarchyCrossingEdges': 'de.cau.cs.kieler.klay.layered.mergeHierarchyEdges',
                'noLayout': 'de.cau.cs.kieler.noLayout',
                'nodeLabelPlacement': 'de.cau.cs.kieler.nodeLabelPlacement',
                'nodeLayering': 'de.cau.cs.kieler.klay.layered.nodeLayering',
                'nodePlacement': 'de.cau.cs.kieler.klay.layered.nodePlace',
                'portAlignment': 'de.cau.cs.kieler.portAlignment',
                'portAlignmentEastern': 'de.cau.cs.kieler.portAlignment.east',
                'portAlignmentNorth': 'de.cau.cs.kieler.portAlignment.north',
                'portAlignmentSouth': 'de.cau.cs.kieler.portAlignment.south',
                'portAlignmentWest': 'de.cau.cs.kieler.portAlignment.west',
                'portConstraints': 'de.cau.cs.kieler.portConstraints',
                'portLabelPlacement': 'de.cau.cs.kieler.portLabelPlacement',
                'portOffset': 'de.cau.cs.kieler.offset',
                'portSide': 'de.cau.cs.kieler.portSide',
                'portSpacing': 'de.cau.cs.kieler.portSpacing',
                'postCompaction': 'de.cau.cs.kieler.klay.layered.postCompaction',
                'priority': 'de.cau.cs.kieler.priority',
                'randomizationSeed': 'de.cau.cs.kieler.randomSeed',
                'routeSelfLoopInside': 'de.cau.cs.kieler.selfLoopInside',
                'separateConnectedComponents': 'de.cau.cs.kieler.separateConnComp',
                'sizeConstraint': 'de.cau.cs.kieler.sizeConstraint',
                'sizeOptions': 'de.cau.cs.kieler.sizeOptions',
                'spacing': 'de.cau.cs.kieler.spacing',
                'splineSelfLoopPlacement': 'de.cau.cs.kieler.klay.layered.splines.selfLoopPlacement',
                'thoroughness': 'de.cau.cs.kieler.klay.layered.thoroughness',
                'wideNodesOnMultipleLayers': 'de.cau.cs.kieler.klay.layered.wideNodesOnMultipleLayers'
            };
            var mapToKlayNS = function mapToKlayNS(klayOpts) {
                var keys = Object.keys(klayOpts);
                var ret = {};
                for(var i = 0; i < keys.length; i++){
                    var key = keys[i];
                    var nsKey = klayNSLookup[key];
                    var val = klayOpts[key];
                    ret[nsKey] = val;
                }
                return ret;
            };
            var klayOverrides = {
                interactiveReferencePoint: 'CENTER' // Determines which point of a node is considered by interactive layout phases.
            };
            var getPos = function getPos(ele) {
                var parent = ele.parent();
                var k = ele.scratch('klay');
                var p = {
                    x: k.x,
                    y: k.y
                };
                while(parent.nonempty()){
                    var kp = parent.scratch('klay');
                    p.x += kp.x;
                    p.y += kp.y;
                    parent = parent.parent();
                }
                return p;
            };
            var makeNode = function makeNode(node, options) {
                var dims = node.layoutDimensions(options);
                var padding = node.numericStyle('padding');
                var k = {
                    _cyEle: node,
                    id: node.id(),
                    padding: {
                        top: padding,
                        left: padding,
                        bottom: padding,
                        right: padding
                    }
                };
                if (!node.isParent()) {
                    k.width = dims.w;
                    k.height = dims.h;
                }
                node.scratch('klay', k);
                return k;
            };
            var makeEdge = function makeEdge(edge, options) {
                var k = {
                    _cyEle: edge,
                    id: edge.id(),
                    source: edge.data('source'),
                    target: edge.data('target'),
                    properties: {}
                };
                var priority = options.priority(edge);
                if (priority != null) k.properties.priority = priority;
                edge.scratch('klay', k);
                return k;
            };
            var makeGraph = function makeGraph(nodes, edges, options) {
                var klayNodes = [];
                var klayEdges = [];
                var klayEleLookup = {};
                var graph = {
                    id: 'root',
                    children: [],
                    edges: []
                };
                // map all nodes
                for(var i = 0; i < nodes.length; i++){
                    var n = nodes[i];
                    var k = makeNode(n, options);
                    klayNodes.push(k);
                    klayEleLookup[n.id()] = k;
                }
                // map all edges
                for(var _i = 0; _i < edges.length; _i++){
                    var e = edges[_i];
                    var _k = makeEdge(e, options);
                    klayEdges.push(_k);
                    klayEleLookup[e.id()] = _k;
                }
                // make hierarchy
                for(var _i2 = 0; _i2 < klayNodes.length; _i2++){
                    var _k2 = klayNodes[_i2];
                    var _n = _k2._cyEle;
                    if (!_n.isChild()) graph.children.push(_k2);
                    else {
                        var parent = _n.parent();
                        var parentK = klayEleLookup[parent.id()];
                        var children = parentK.children = parentK.children || [];
                        children.push(_k2);
                    }
                }
                for(var _i3 = 0; _i3 < klayEdges.length; _i3++){
                    var _k3 = klayEdges[_i3];
                    var _e = _k3._cyEle;
                    var parentSrc = _e.source().parent();
                    var parentTgt = _e.target().parent();
                    var kp;
                    graph.edges.push(_k3);
                }
                return graph;
            };
            function Layout(options) {
                var klayOptions = options.klay;
                this.options = assign({}, defaults, options);
                this.options.klay = assign({}, defaults.klay, klayOptions, klayOverrides);
            }
            Layout.prototype.run = function() {
                var layout = this;
                var options = this.options;
                var eles = options.eles;
                var nodes = eles.nodes();
                var edges = eles.edges();
                var graph = makeGraph(nodes, edges, options);
                klay.layout({
                    graph: graph,
                    options: mapToKlayNS(options.klay),
                    success: function success() {},
                    error: function error(_error) {
                        throw _error;
                    }
                });
                nodes.filter(function(n) {
                    return !n.isParent();
                }).layoutPositions(layout, options, getPos);
                return this;
            };
            Layout.prototype.stop = function() {
                return this; // chaining
            };
            Layout.prototype.destroy = function() {
                return this; // chaining
            };
            module1.exports = Layout;
        /***/ },
        /* 1 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            // Simple, internal Object.assign() polyfill for options objects etc.
            module1.exports = Object.assign != null ? Object.assign.bind(Object) : function(tgt) {
                for(var _len = arguments.length, srcs = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)srcs[_key - 1] = arguments[_key];
                srcs.filter(function(src) {
                    return src != null;
                }).forEach(function(src) {
                    Object.keys(src).forEach(function(k) {
                        return tgt[k] = src[k];
                    });
                });
                return tgt;
            };
        /***/ },
        /* 2 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var defaults = {
                nodeDimensionsIncludeLabels: false,
                fit: true,
                padding: 20,
                animate: false,
                animateFilter: function animateFilter(node, i) {
                    return true;
                },
                animationDuration: 500,
                animationEasing: undefined,
                transform: function transform(node, pos) {
                    return pos;
                },
                ready: undefined,
                stop: undefined,
                klay: {
                    // Following descriptions taken from http://layout.rtsys.informatik.uni-kiel.de:9444/Providedlayout.html?algorithm=de.cau.cs.kieler.klay.layered
                    addUnnecessaryBendpoints: false,
                    aspectRatio: 1.6,
                    borderSpacing: 20,
                    compactComponents: false,
                    crossingMinimization: 'LAYER_SWEEP',
                    /* LAYER_SWEEP The layer sweep algorithm iterates multiple times over the layers, trying to find node orderings that minimize the number of crossings. The algorithm uses randomization to increase the odds of finding a good result. To improve its results, consider increasing the Thoroughness option, which influences the number of iterations done. The Randomization seed also influences results.
    INTERACTIVE Orders the nodes of each layer by comparing their positions before the layout algorithm was started. The idea is that the relative order of nodes as it was before layout was applied is not changed. This of course requires valid positions for all nodes to have been set on the input graph before calling the layout algorithm. The interactive layer sweep algorithm uses the Interactive Reference Point option to determine which reference point of nodes are used to compare positions. */ cycleBreaking: 'GREEDY',
                    /* GREEDY This algorithm reverses edges greedily. The algorithm tries to avoid edges that have the Priority property set.
    INTERACTIVE The interactive algorithm tries to reverse edges that already pointed leftwards in the input graph. This requires node and port coordinates to have been set to sensible values.*/ direction: 'UNDEFINED',
                    /* UNDEFINED, RIGHT, LEFT, DOWN, UP */ edgeRouting: 'ORTHOGONAL',
                    edgeSpacingFactor: 0.5,
                    feedbackEdges: false,
                    fixedAlignment: 'NONE',
                    /* NONE Chooses the smallest layout from the four possible candidates.
    LEFTUP Chooses the left-up candidate from the four possible candidates.
    RIGHTUP Chooses the right-up candidate from the four possible candidates.
    LEFTDOWN Chooses the left-down candidate from the four possible candidates.
    RIGHTDOWN Chooses the right-down candidate from the four possible candidates.
    BALANCED Creates a balanced layout from the four possible candidates. */ inLayerSpacingFactor: 1.0,
                    layoutHierarchy: false,
                    linearSegmentsDeflectionDampening: 0.3,
                    mergeEdges: false,
                    mergeHierarchyCrossingEdges: true,
                    nodeLayering: 'NETWORK_SIMPLEX',
                    /* NETWORK_SIMPLEX This algorithm tries to minimize the length of edges. This is the most computationally intensive algorithm. The number of iterations after which it aborts if it hasn't found a result yet can be set with the Maximal Iterations option.
    LONGEST_PATH A very simple algorithm that distributes nodes along their longest path to a sink node.
    INTERACTIVE Distributes the nodes into layers by comparing their positions before the layout algorithm was started. The idea is that the relative horizontal order of nodes as it was before layout was applied is not changed. This of course requires valid positions for all nodes to have been set on the input graph before calling the layout algorithm. The interactive node layering algorithm uses the Interactive Reference Point option to determine which reference point of nodes are used to compare positions. */ nodePlacement: 'BRANDES_KOEPF',
                    /* BRANDES_KOEPF Minimizes the number of edge bends at the expense of diagram size: diagrams drawn with this algorithm are usually higher than diagrams drawn with other algorithms.
    LINEAR_SEGMENTS Computes a balanced placement.
    INTERACTIVE Tries to keep the preset y coordinates of nodes from the original layout. For dummy nodes, a guess is made to infer their coordinates. Requires the other interactive phase implementations to have run as well.
    SIMPLE Minimizes the area at the expense of... well, pretty much everything else. */ randomizationSeed: 1,
                    routeSelfLoopInside: false,
                    separateConnectedComponents: true,
                    spacing: 20,
                    thoroughness: 7 // How much effort should be spent to produce a nice layout..
                },
                priority: function priority(edge) {
                    return null;
                } // Edges with a non-nil value are skipped when geedy edge cycle breaking is enabled
            };
            module1.exports = defaults;
        /***/ },
        /* 3 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var impl = __webpack_require__(0);
            // registers the extension on a cytoscape lib ref
            var register = function register(cytoscape1) {
                if (!cytoscape1) return;
                 // can't register if cytoscape unspecified
                cytoscape1('layout', 'klay', impl); // register with cytoscape.js
            };
            if (typeof cytoscape !== 'undefined') // expose to global cytoscape (i.e. window.cytoscape)
            register(cytoscape);
            module1.exports = register;
        /***/ },
        /* 4 */ /***/ function(module1, exports) {
            module1.exports = __WEBPACK_EXTERNAL_MODULE_4__;
        /***/ }
    ]);
});

});
parcelRegister("8zBl0", function(module, exports) {
/** klay.js version 0.4.1 build 201604131004 */ var $63de8e1e54a3eb03$var$klayregister;
var $63de8e1e54a3eb03$var$klaycallback;
(function() {
    var $wnd, $doc;
    if (typeof window !== 'undefined') {
        $wnd = window;
        $doc = $wnd.document;
    } else $wnd = {
        Array: function() {}
    };
    function kI() {}
    function iI() {}
    function pb() {}
    function Ab() {}
    function Tt() {}
    function Jt() {}
    function Jq() {}
    function Vq() {}
    function Vs() {}
    function yl() {}
    function Yl() {}
    function gm() {}
    function Cu() {}
    function tJ() {}
    function NJ() {}
    function PJ() {}
    function PS() {}
    function sS() {}
    function yS() {}
    function AS() {}
    function MS() {}
    function RS() {}
    function TS() {}
    function lR() {}
    function HR() {}
    function IR() {}
    function KR() {}
    function WR() {}
    function AT() {}
    function FT() {}
    function HT() {}
    function JT() {}
    function LT() {}
    function NT() {}
    function sU() {}
    function uV() {}
    function xV() {}
    function EV() {}
    function HW() {}
    function UX() {}
    function XX() {}
    function ZX() {}
    function _X() {}
    function bY() {}
    function dY() {}
    function wY() {}
    function zY() {}
    function SY() {}
    function VY() {}
    function qZ() {}
    function tZ() {}
    function wZ() {}
    function AZ() {}
    function d$() {}
    function g$() {}
    function j$() {}
    function w$() {}
    function z$() {}
    function C$() {}
    function F$() {}
    function I$() {}
    function L$() {}
    function N$() {}
    function R$() {}
    function X$() {}
    function _$() {}
    function k0() {}
    function m0() {}
    function s0() {}
    function w0() {}
    function A0() {}
    function C0() {}
    function E0() {}
    function G0() {}
    function V0() {}
    function Z0() {}
    function _0() {}
    function _1() {}
    function b1() {}
    function e1() {}
    function k1() {}
    function q1() {}
    function u1() {}
    function R1() {}
    function X1() {}
    function Z1() {}
    function c2() {}
    function f2() {}
    function h2() {}
    function k2() {}
    function n2() {}
    function q2() {}
    function x2() {}
    function A2() {}
    function H2() {}
    function H4() {}
    function z4() {}
    function B4() {}
    function D4() {}
    function U4() {}
    function i3() {}
    function l3() {}
    function u3() {}
    function C3() {}
    function I3() {}
    function $5() {}
    function d7() {}
    function V7() {}
    function q8() {}
    function smb() {}
    function Wbb() {}
    function rcb() {}
    function Mcb() {}
    function Vdb() {}
    function hkb() {}
    function Kpb() {}
    function Spb() {}
    function aqb() {}
    function iqb() {}
    function pqb() {}
    function isb() {}
    function mvb() {}
    function zwb() {}
    function yfb(a) {}
    function sP(a) {}
    function XW(a) {}
    function _t() {
        Wt();
    }
    function lI() {
        GP();
    }
    function J8() {
        G8();
    }
    function m8() {
        k8();
    }
    function CQ() {
        zQ();
    }
    function CV() {
        AV();
    }
    function q0() {
        p0();
    }
    function S0() {
        J0();
    }
    function y9() {
        w9();
    }
    function Bab() {
        zab();
    }
    function Qab() {
        Hab();
    }
    function cbb() {
        abb();
    }
    function sbb() {
        rbb();
    }
    function Ycb() {
        Xcb();
    }
    function Wfb() {
        Mfb();
    }
    function ft() {
        _s(this);
    }
    function uP() {
        sP(this);
    }
    function GU() {
        tU(this);
    }
    function ZW() {
        XW(this);
    }
    function ic(a) {
        this.a = a;
    }
    function sc(a) {
        this.a = a;
    }
    function $c(a) {
        this.a = a;
    }
    function sf(a) {
        this.a = a;
    }
    function Qg(a) {
        this.a = a;
    }
    function qh(a) {
        this.a = a;
    }
    function Vj(a) {
        this.a = a;
    }
    function Nk(a) {
        this.a = a;
    }
    function km(a) {
        this.a = a;
    }
    function dm(a) {
        this.b = a;
    }
    function En(a) {
        this.a = a;
    }
    function Hn(a) {
        this.a = a;
    }
    function Yp(a) {
        this.a = a;
    }
    function bq(a) {
        this.a = a;
    }
    function eq(a) {
        this.a = a;
    }
    function tq(a) {
        this.a = a;
    }
    function wq(a) {
        this.a = a;
    }
    function ku(a) {
        this.a = a;
    }
    function uu(a) {
        this.a = a;
    }
    function Gu(a) {
        this.a = a;
    }
    function Uu(a) {
        this.a = a;
    }
    function WJ(a) {
        this.a = a;
    }
    function rP(a) {
        this.a = a;
    }
    function $V(a) {
        this.a = a;
    }
    function tW(a) {
        this.a = a;
    }
    function yW(a) {
        this.e = a;
    }
    function fY(a) {
        this.a = a;
    }
    function hY(a) {
        this.a = a;
    }
    function lY(a) {
        this.a = a;
    }
    function nY(a) {
        this.a = a;
    }
    function CY(a) {
        this.a = a;
    }
    function JY(a) {
        this.a = a;
    }
    function SZ(a) {
        this.a = a;
    }
    function Z$(a) {
        this.a = a;
    }
    function b_(a) {
        this.a = a;
    }
    function d_(a) {
        this.a = a;
    }
    function f_(a) {
        this.a = a;
    }
    function w1(a) {
        this.a = a;
    }
    function y1(a) {
        this.a = a;
    }
    function E3(a) {
        this.a = a;
    }
    function q4(a) {
        this.a = a;
    }
    function x4(a) {
        this.a = a;
    }
    function F4(a) {
        this.a = a;
    }
    function $8(a) {
        this.a = a;
    }
    function a9(a) {
        this.a = a;
    }
    function l9(a) {
        this.a = a;
    }
    function C9(a) {
        this.a = a;
    }
    function k9(a) {
        this.c = a;
    }
    function wlb(a) {
        this.a = a;
    }
    function nxb(a) {
        this.a = a;
    }
    function wcb(a) {
        this.a = a;
    }
    function tdb(a) {
        this.a = a;
    }
    function ydb(a) {
        this.a = a;
    }
    function Ddb(a) {
        this.a = a;
    }
    function lkb(a) {
        this.a = a;
    }
    function klb(a) {
        this.a = a;
    }
    function llb(a) {
        this.a = a;
    }
    function inb(a) {
        this.a = a;
    }
    function wnb(a) {
        this.d = a;
    }
    function Snb(a) {
        this.a = a;
    }
    function Ynb(a) {
        this.a = a;
    }
    function aob(a) {
        this.a = a;
    }
    function fob(a) {
        this.a = a;
    }
    function Bob(a) {
        this.b = a;
    }
    function Gob(a) {
        this.a = a;
    }
    function Mob(a) {
        this.a = a;
    }
    function Tob(a) {
        this.c = a;
    }
    function opb(a) {
        this.a = a;
    }
    function Ipb(a) {
        this.a = a;
    }
    function rqb(a) {
        this.a = a;
    }
    function zqb(a) {
        this.b = a;
    }
    function Nqb(a) {
        this.b = a;
    }
    function mrb(a) {
        this.c = a;
    }
    function Trb(a) {
        this.a = a;
    }
    function Xrb(a) {
        this.a = a;
    }
    function Fsb(a) {
        this.a = a;
    }
    function ju() {
        this.a = [];
    }
    function ytb(a) {
        this.a = a;
    }
    function Lub(a) {
        this.a = a;
    }
    function u5(a) {
        a.b = a.a;
    }
    function vg(a) {
        a.c = a.d.d;
    }
    function sX(a, b) {
        a.g = b;
    }
    function bfb(a, b) {
        a.k = b;
    }
    function qfb(a, b) {
        a.a = b;
    }
    function rfb(a, b) {
        a.b = b;
    }
    function qW(a, b) {
        a.e.k = b;
    }
    function qu(a) {
        return a.a;
    }
    function yu(a) {
        return a.a;
    }
    function Mu(a) {
        return a.a;
    }
    function $u(a) {
        return a.a;
    }
    function rv(a) {
        return a.a;
    }
    function jv() {
        return null;
    }
    function Fu() {
        return null;
    }
    function Rh() {
        this.c = this;
    }
    function tkb() {
        _s(this);
    }
    function ntb() {
        Ymb(this);
    }
    function b5(a) {
        a5(this, a);
    }
    function GO(a) {
        IO();
        $O(a);
    }
    function mI(a) {
        a.a = new aJ;
    }
    function IZ(a, b) {
        a.a = b - a.a;
    }
    function KZ(a, b) {
        a.b = b - a.b;
    }
    function Dq() {
        Dq = iI;
        new Jq;
    }
    function nW() {
        nW = iI;
        new HW;
    }
    function ni() {
        throw new Hmb;
    }
    function ii() {
        throw new Hmb;
    }
    function ji() {
        throw new Hmb;
    }
    function li() {
        throw new Hmb;
    }
    function mi() {
        throw new Hmb;
    }
    function dd() {
        throw new Hmb;
    }
    function pj() {
        throw new Hmb;
    }
    function Wn() {
        throw new Hmb;
    }
    function $n() {
        throw new Hmb;
    }
    function qT() {
        this.a = new GU;
    }
    function fU() {
        this.a = new GU;
    }
    function cV() {
        this.a = new GU;
    }
    function pV() {
        this.a = new GU;
    }
    function l7() {
        this.a = new GU;
    }
    function k7() {
        this.a = new d7;
    }
    function A7() {
        this.a = new n7;
    }
    function t8() {
        this.b = new GU;
    }
    function jJ() {
        aJ.call(this);
    }
    function ZN() {
        UN.call(this);
    }
    function AP() {
        uP.call(this);
    }
    function DP() {
        uP.call(this);
    }
    function q7() {
        GU.call(this);
    }
    function alb() {
        ft.call(this);
    }
    function rlb() {
        ft.call(this);
    }
    function nkb() {
        ft.call(this);
    }
    function qkb() {
        ft.call(this);
    }
    function tlb() {
        ft.call(this);
    }
    function Vlb() {
        ft.call(this);
    }
    function Hmb() {
        ft.call(this);
    }
    function Wab() {
        this.f = new GU;
    }
    function Ybb() {
        this.d = new GU;
    }
    function jV() {
        this.a = new vtb;
    }
    function vqb() {
        throw new Hmb;
    }
    function wqb() {
        throw new Hmb;
    }
    function xqb() {
        throw new Hmb;
    }
    function yqb() {
        throw new Hmb;
    }
    function Mqb() {
        throw new Hmb;
    }
    function Uvb() {
        this.a = new GU;
    }
    function it() {
        it = iI;
        ht = new pb;
    }
    function bmb() {
        bmb = iI;
        new smb;
    }
    function zb() {
        zb = iI;
        yb = new Ab;
    }
    function Tq() {
        Tq = iI;
        Sq = new Vq;
    }
    function dr() {
        dr = iI;
        cr = new er;
    }
    function Gt() {
        Gt = iI;
        Ft = new Jt;
    }
    function Bu() {
        Bu = iI;
        Au = new Cu;
    }
    function fR() {
        fR = iI;
        eR = new lR;
    }
    function VR() {
        VR = iI;
        UR = new WR;
    }
    function jS(a) {
        dS(a);
        return a;
    }
    function jl(a) {
        Gi();
        this.a = a;
    }
    function vi(a) {
        hi();
        this.a = a;
    }
    function Uk(a) {
        hi();
        this.a = a;
    }
    function Zk(a) {
        hi();
        this.a = a;
    }
    function ds(a, b) {
        a.i = b;
        b.f = a;
    }
    function ycb(a, b) {
        stb(a.b, b);
    }
    function nsb() {
        ft.call(this);
    }
    function osb() {
        ft.call(this);
    }
    function nvb() {
        ft.call(this);
    }
    function Ccb() {
        Bcb.call(this);
    }
    function Jcb() {
        Bcb.call(this);
    }
    function pkb() {
        nkb.call(this);
    }
    function Xlb() {
        rlb.call(this);
    }
    function gt(a) {
        et.call(this, a);
    }
    function Vd(a) {
        Md.call(this, a);
    }
    function uh(a) {
        Md.call(this, a);
    }
    function Bk(a) {
        Hj.call(this, a);
    }
    function Jk(a) {
        dk.call(this, a);
    }
    function Lm(a) {
        Em.call(this, a);
    }
    function nq(a) {
        vm.call(this, a);
    }
    function ap(a) {
        Ro.call(this, a);
    }
    function ir(a) {
        Hj.call(this, a);
    }
    function Op(a, b) {
        a.a.W().nb(b);
    }
    function emb(a, b) {
        return a === b;
    }
    function Zr(a) {
        return !a ? 0 : a.a;
    }
    function Rs(a) {
        return !a ? 0 : a.d;
    }
    function Ts(a) {
        return !a ? 0 : a.j;
    }
    function zu(a) {
        gt.call(this, a);
    }
    function $J(a) {
        gt.call(this, a);
    }
    function _J(a) {
        gt.call(this, a);
    }
    function EQ(a) {
        _J.call(this, a);
    }
    function Tu() {
        Uu.call(this, {});
    }
    function y5(a) {
        b5.call(this, a);
    }
    function H5(a) {
        b5.call(this, a);
    }
    function WP(a, b, c) {
        XP(a, b.b, c);
    }
    function a7(a, b, c) {
        f6(a.c, b, c);
    }
    function qV(a, b, c) {
        a.b.Fc(b, c);
    }
    function M9(a) {
        $8.call(this, a);
    }
    function P9(a) {
        $8.call(this, a);
    }
    function YY() {
        this.a = (sK(), qK);
    }
    function cZ() {
        this.a = (sK(), qK);
    }
    function vtb() {
        this.a = new ntb;
    }
    function Vwb() {
        this.a = new iwb;
    }
    function vT() {
        vT = iI;
        uT = new AT;
    }
    function AV() {
        AV = iI;
        zV = new EV;
    }
    function p0() {
        p0 = iI;
        o0 = new s0;
    }
    function Ckb(a) {
        xkb();
        return a;
    }
    function Ixb(a) {
        Dxb(a);
        return a;
    }
    function ikb(a) {
        et.call(this, a);
    }
    function okb(a) {
        gt.call(this, a);
    }
    function slb(a) {
        gt.call(this, a);
    }
    function Kb(a) {
        this.c = $v(_b(a));
    }
    function FI() {
        this.a = 0;
        this.b = 0;
    }
    function aJ() {
        OI(this);
        _I(this);
    }
    function cI() {
        aI == null && (aI = []);
    }
    function Vvb(a) {
        a.b = null;
        a.c = 0;
    }
    function mS(a, b) {
        a.b = b;
        return a;
    }
    function nS(a, b) {
        a.c = b;
        return a;
    }
    function oS(a, b) {
        a.f = b;
        return a;
    }
    function pS(a, b) {
        a.g = b;
        return a;
    }
    function S7(a, b) {
        a.a = b;
        return a;
    }
    function T7(a, b) {
        a.f = b;
        return a;
    }
    function U7(a, b) {
        a.k = b;
        return a;
    }
    function xc(a, b) {
        return a.e - b.e;
    }
    function H3(a, b) {
        return a.d - b.d;
    }
    function Klb(a) {
        return a < 0 ? -a : a;
    }
    function hlb(a) {
        return isNaN(a);
    }
    function gv(a) {
        return new Gu(a);
    }
    function iv(a) {
        return new lv(a);
    }
    function rkb(a) {
        gt.call(this, a);
    }
    function ulb(a) {
        gt.call(this, a);
    }
    function Ulb(a) {
        gt.call(this, a);
    }
    function Wlb(a) {
        gt.call(this, a);
    }
    function Imb(a) {
        gt.call(this, a);
    }
    function et(a) {
        this.f = a;
        _s(this);
    }
    function _2() {
        this.b = 0;
        this.a = 0;
    }
    function Ws() {
        Ws = iI;
    }
    function Ytb() {
        Ytb = iI;
        Xtb = $tb();
    }
    function Vtb(c, a, b) {
        c.set(a, b);
    }
    function Wtb(c, a, b) {
        c.set(a, b);
    }
    function Ot(a, b) {
        Nt();
        Mt.dc(a, b);
    }
    function tv(a, b) {
        return Skb(a, b);
    }
    function zm(a, b) {
        return a.a.B(b);
    }
    function aP(a, b) {
        return a.g[b.e];
    }
    function bP(a, b) {
        return a.i[b.e];
    }
    function cP(a, b) {
        return a.j[b.e];
    }
    function dP(a, b) {
        return a.n[b.e];
    }
    function eP(a, b) {
        return a.o[b.e];
    }
    function Ou(b, a) {
        return a in b.a;
    }
    function Tab(a, b) {
        return a.b - b.b;
    }
    function ndb(a, b) {
        return a.d - b.d;
    }
    function jgb(a, b) {
        return a.i - b.i;
    }
    function Nlb(a, b) {
        return a > b ? a : b;
    }
    function Olb(a, b) {
        return a > b ? a : b;
    }
    function Plb(a, b) {
        return a > b ? a : b;
    }
    function Qlb(a, b) {
        return a < b ? a : b;
    }
    function Rlb(a, b) {
        return a < b ? a : b;
    }
    function Slb(a, b) {
        return a < b ? a : b;
    }
    function awb(a) {
        return !!a && a.b;
    }
    function $ob(a) {
        _ob(a, a.length);
    }
    function bpb(a) {
        apb(a, a.length);
    }
    function dpb(a) {
        cpb(a, a.length);
    }
    function Cmb(a) {
        okb.call(this, a);
    }
    function Bmb(a) {
        lkb.call(this, a);
    }
    function oxb(a) {
        nxb.call(this, a);
    }
    function Ylb(a) {
        slb.call(this, a);
    }
    function Frb(a) {
        zqb.call(this, a);
    }
    function Nrb(a) {
        Frb.call(this, a);
    }
    function csb(a) {
        Rqb.call(this, a);
    }
    function zmb() {
        lkb.call(this, '');
    }
    function Amb() {
        lkb.call(this, '');
    }
    function Ikb(a) {
        Gkb(a);
        return a.n;
    }
    function Jkb(a) {
        Gkb(a);
        return a.j;
    }
    function Hkb(a) {
        return a.e && a.e();
    }
    function Lk(a, b) {
        return a.a.sb(b);
    }
    function Sb(a, b) {
        return a ? a : _b(b);
    }
    function vW(a, b) {
        return rJ(a.a, b);
    }
    function w4(a, b) {
        return t4(a.a, b);
    }
    function VH(a, b) {
        return RH(a, b) < 0;
    }
    function Dlb(a) {
        return bmb(), '' + a;
    }
    function qe(a) {
        return !a ? null : a.d;
    }
    function Gr(a) {
        hi();
        this.a = _b(a);
    }
    function I9() {
        F9();
        this.g = new Um;
    }
    function J0() {
        J0 = iI;
        I0 = (kP(), hP);
    }
    function Et() {
        ut != 0 && (ut = 0);
        wt = -1;
    }
    function bS(a) {
        cS(a, a.d);
        return a;
    }
    function i7(a, b) {
        a.a.d = b;
        return a;
    }
    function g7(a, b) {
        a.a.a = b;
        return a;
    }
    function h7(a, b) {
        a.a.c = b;
        return a;
    }
    function j7(a, b) {
        a.a.f = b;
        return a;
    }
    function z7(a, b) {
        a.a.f = b;
        return a;
    }
    function y7(a, b) {
        a.a.b = b;
        return a;
    }
    function hxb(a, b, c) {
        a.splice(b, c);
    }
    function oqb(a, b) {
        return Akb(b, a);
    }
    function Drb(a, b) {
        return a.b.t(b);
    }
    function jrb(a, b) {
        return a.c.t(b);
    }
    function ttb(a, b) {
        return a.a.R(b);
    }
    function Ttb(b, a) {
        return b.get(a);
    }
    function Utb(b, a) {
        return b.get(a);
    }
    function elb(a, b) {
        return a.test(b);
    }
    function Jlb(a) {
        return a <= 0 ? 0 - a : a;
    }
    function ilb(a) {
        return bmb(), '' + a;
    }
    function qlb(a) {
        return bmb(), '' + a;
    }
    function wtb(a) {
        this.a = new otb(a);
    }
    function Wwb(a) {
        this.a = new jwb(a);
    }
    function nc(a) {
        this.a = Wv(_b(a), 19);
    }
    function Bf(a) {
        this.b = Wv(_b(a), 57);
    }
    function Ch(a) {
        this.d = Wv(_b(a), 56);
    }
    function Ac(a, b) {
        this.d = a;
        this.e = b;
    }
    function Ie(a, b) {
        this.b = a;
        this.a = b;
    }
    function tm(a, b) {
        this.b = a;
        this.a = b;
    }
    function Pf(a, b) {
        this.b = a;
        this.c = b;
    }
    function Fk(a, b) {
        this.a = a;
        this.b = b;
    }
    function Bn(a, b) {
        this.a = a;
        this.b = b;
    }
    function Sn(a, b) {
        this.a = a;
        this.f = b;
    }
    function Mc(a, b) {
        Ac.call(this, a, b);
    }
    function Hh(a, b) {
        Ac.call(this, a, b);
    }
    function yp(a, b) {
        Ac.call(this, a, b);
    }
    function bp(a, b) {
        this.b = a;
        this.c = b;
    }
    function Oq(a, b) {
        this.e = a;
        this.c = b;
    }
    function Yq(a, b) {
        this.a = a;
        this.b = b;
    }
    function fs(a, b) {
        this.a = a;
        this.b = b;
    }
    function rs(a, b) {
        Ac.call(this, a, b);
    }
    function _u(a, b) {
        this.a = a;
        this.b = b;
    }
    function Mo(a) {
        this.a = Wv(_b(a), 20);
    }
    function Ro(a) {
        this.a = Wv(_b(a), 20);
    }
    function Fp(a) {
        this.a = Wv(_b(a), 57);
    }
    function vm(a) {
        this.b = Wv(_b(a), 35);
    }
    function HI(a, b) {
        this.a = a;
        this.b = b;
    }
    function RJ(a, b) {
        this.a = a;
        this.b = b;
    }
    function jK(a, b) {
        Ac.call(this, a, b);
    }
    function Qm(a, b) {
        return Qmb(a.b, b);
    }
    function fv(a) {
        return tu(), a ? su : ru;
    }
    function tK(a) {
        return a == oK || a == pK;
    }
    function uK(a) {
        return a == rK || a == nK;
    }
    function RI(a, b) {
        TI(a, b, a.a, a.a.a);
    }
    function SI(a, b) {
        TI(a, b, a.c.b, a.c);
    }
    function wK(a, b) {
        Ac.call(this, a, b);
    }
    function FK(a, b) {
        Ac.call(this, a, b);
    }
    function OK(a, b) {
        Ac.call(this, a, b);
    }
    function ZK(a, b) {
        Ac.call(this, a, b);
    }
    function fL(a, b) {
        Ac.call(this, a, b);
    }
    function pM(a, b) {
        Ac.call(this, a, b);
    }
    function AM(a, b) {
        Ac.call(this, a, b);
    }
    function NM(a, b) {
        Ac.call(this, a, b);
    }
    function VM(a, b) {
        Ac.call(this, a, b);
    }
    function uN(a, b) {
        Ac.call(this, a, b);
    }
    function EN(a, b) {
        Ac.call(this, a, b);
    }
    function NN(a, b) {
        Ac.call(this, a, b);
    }
    function EO(a, b) {
        Ac.call(this, a, b);
    }
    function lP(a, b) {
        Ac.call(this, a, b);
    }
    function OS(a, b) {
        this.b = a;
        this.a = b;
    }
    function VS(a, b) {
        this.c = a;
        this.d = b;
    }
    function wW(a, b) {
        this.a = a;
        this.c = b;
    }
    function BW(a, b) {
        this.e = a;
        this.c = b;
    }
    function FW(a, b) {
        this.e = a;
        this.d = b;
    }
    function fT(a, b) {
        Ac.call(this, a, b);
    }
    function DX(a, b) {
        Ac.call(this, a, b);
    }
    function MY(a, b) {
        this.a = a;
        this.b = b;
    }
    function PY(a, b) {
        this.a = a;
        this.b = b;
    }
    function YZ(a, b) {
        Ac.call(this, a, b);
    }
    function f0(a, b) {
        Ac.call(this, a, b);
    }
    function J1(a, b) {
        Ac.call(this, a, b);
    }
    function Y3(a, b) {
        Ac.call(this, a, b);
    }
    function h4(a, b) {
        Ac.call(this, a, b);
    }
    function $7(a, b) {
        Ac.call(this, a, b);
    }
    function y8(a, b) {
        Ac.call(this, a, b);
    }
    function q9(a, b) {
        Ac.call(this, a, b);
    }
    function MR(a, b) {
        return Zsb(a.c, b);
    }
    function Bnb(a) {
        return a.b < a.d.Y();
    }
    function Zmb(a) {
        return a.d.c + a.e.c;
    }
    function hrb(a, b) {
        return a.c.ab(b);
    }
    function Brb(a, b) {
        return a.b.kb(b);
    }
    function Crb(a, b) {
        return a.b.lb(b);
    }
    function Erb(a, b) {
        return a.b.pb(b);
    }
    function Irb(a, b) {
        return a.b.kb(b);
    }
    function Jrb(a, b) {
        return a.b.lb(b);
    }
    function dT(a) {
        return a == $S || a == bT;
    }
    function eT(a) {
        return a == $S || a == _S;
    }
    function MM(a) {
        return a != IM && a != JM;
    }
    function lg(a) {
        return Yf(a), a.d.Y();
    }
    function jtb(a) {
        this.c = a;
        gtb(this);
    }
    function otb(a) {
        $mb.call(this, a, 0);
    }
    function iwb() {
        jwb.call(this, null);
    }
    function xk() {
        uh.call(this, new ntb);
    }
    function Ap() {
        yp.call(this, 'KEY', 0);
    }
    function lr(a) {
        kr();
        dk.call(this, a);
    }
    function Dt(a) {
        $wnd.clearTimeout(a);
    }
    function um(a) {
        return a.Vb(a.b.H());
    }
    function Pp(a) {
        this.a = Wv(_b(a), 144);
    }
    function Um() {
        this.b = (mp(), new ntb);
    }
    function hsb() {
        hsb = iI;
        gsb = new isb;
    }
    function Rpb() {
        Rpb = iI;
        Qpb = new Spb;
    }
    function nqb() {
        nqb = iI;
        mqb = new pqb;
    }
    function hc() {
        hc = iI;
        gc = new Kb(',');
    }
    function nJ() {
        nJ = iI;
    }
    function UN() {
        VN.call(this, 0, 0, 0, 0);
    }
    function wab(a, b) {
        Ac.call(this, a, b);
    }
    function lbb(a, b) {
        Ac.call(this, a, b);
    }
    function Hbb(a, b) {
        Ac.call(this, a, b);
    }
    function Mbb(a, b) {
        Ac.call(this, a, b);
    }
    function xQ(a) {
        wJ();
        CJ.call(this, a);
    }
    function mcb(a, b) {
        Ac.call(this, a, b);
    }
    function gab(a, b) {
        this.c = a;
        this.b = b;
    }
    function Qbb(a, b) {
        this.a = a;
        this.b = b;
    }
    function Fcb(a, b) {
        this.b = a;
        this.d = b;
    }
    function ggb(a, b) {
        Ac.call(this, a, b);
    }
    function Agb(a, b) {
        Ac.call(this, a, b);
    }
    function Igb(a, b) {
        Ac.call(this, a, b);
    }
    function Rgb(a, b) {
        Ac.call(this, a, b);
    }
    function ahb(a, b) {
        Ac.call(this, a, b);
    }
    function phb(a, b) {
        Ac.call(this, a, b);
    }
    function Ihb(a, b) {
        Ac.call(this, a, b);
    }
    function Nhb(a, b) {
        Ac.call(this, a, b);
    }
    function Yib(a, b) {
        Ac.call(this, a, b);
    }
    function ejb(a, b) {
        Ac.call(this, a, b);
    }
    function Rjb(a, b) {
        Ac.call(this, a, b);
    }
    function dkb(a, b) {
        Ac.call(this, a, b);
    }
    function fxb(a, b, c) {
        a.splice(b, 0, c);
    }
    function Yjb(a, b, c) {
        a.g[b.e][b.e] = c;
    }
    function D6(a, b) {
        a.a = b;
        a.g = 0;
        a.f = 0;
    }
    function BI(a) {
        a.a = 0;
        a.b = 0;
        return a;
    }
    function rY(a) {
        return zU(a.b.c, a, 0);
    }
    function Llb(a) {
        return Math.ceil(a);
    }
    function Tlb(a) {
        return Math.sqrt(a);
    }
    function cub(a, b) {
        return Utb(a.a, b);
    }
    function vob(a, b) {
        return !!Wvb(a, b);
    }
    function Yob(a, b) {
        Zob(a, a.length, b);
    }
    function Gwb(a, b) {
        Ac.call(this, a, b);
    }
    function Psb(a, b) {
        this.b = a;
        this.a = b;
    }
    function qob(a, b) {
        this.d = a;
        this.e = b;
    }
    function dcb() {
        $bb();
        this.c = new vtb;
    }
    function Rdb() {
        Ndb();
        this.a = new vtb;
    }
    function aub() {
        Ytb();
        return new Xtb;
    }
    function Xb(a) {
        if (!a) throw new rlb;
    }
    function dc(a) {
        if (!a) throw new tlb;
    }
    function Vm(a) {
        if (!a) throw new nvb;
    }
    function SV() {
        this.b = (mp(), new ntb);
    }
    function Q4() {
        this.b = (mp(), new ntb);
    }
    function II(a) {
        this.a = a.a;
        this.b = a.b;
    }
    function gw(a) {
        return a == null ? null : a;
    }
    function re(a) {
        return !a ? null : a.zb();
    }
    function $i(a, b) {
        return a.Nb().sb(b);
    }
    function aq(a, b) {
        return a.a.a.a.U(b);
    }
    function nl(a, b) {
        return Ll(a.mb(), b);
    }
    function B3(a, b) {
        return glb(b.b, a.b);
    }
    function h3(a, b) {
        return glb(b.k, a.k);
    }
    function Mlb(a) {
        return Math.floor(a);
    }
    function vmb(a, b) {
        return a.a += '' + b, a;
    }
    function xmb(a, b) {
        a.a += '' + b;
        return a;
    }
    function ymb(a, b) {
        a.a += '' + b;
        return a;
    }
    function iw(a) {
        Hxb(a == null);
        return a;
    }
    function T2(a) {
        a.d && Z2(a);
        return a.a;
    }
    function U2(a) {
        a.d && Z2(a);
        return a.b;
    }
    function V2(a) {
        a.d && Z2(a);
        return a.c;
    }
    function Tvb(a, b) {
        vU(a.a, b);
        return b;
    }
    function ptb(a) {
        Ymb(this);
        he(this, a);
    }
    function _4(a) {
        this.c = a;
        this.e = false;
    }
    function Jh() {
        Hh.call(this, 'OPEN', 0);
    }
    function ts() {
        rs.call(this, 'SIZE', 0);
    }
    function qxb() {
        nxb.call(this, 'UTF-8');
    }
    function Nxb() {
        Nxb = iI;
        Kxb = {};
        Mxb = {};
    }
    function IO() {
        IO = iI;
        HO = new DJ(yzb, 0);
    }
    function Sh(a) {
        _b(a);
        return new Vh(a);
    }
    function pmb(a) {
        bmb();
        return a.length;
    }
    function Jmb(a, b) {
        return cmb(a.a, b.a);
    }
    function vlb(a, b) {
        return xlb(a.a, b.a);
    }
    function Ys(a, b) {
        return a == b ? 0 : a ? 1 : -1;
    }
    function Cs(a) {
        return Rs(a.e) - Rs(a.g);
    }
    function xI(a) {
        return new HI(a.a, a.b);
    }
    function RN(a) {
        return new HI(a.d, a.e);
    }
    function tU(a) {
        a.c = xv(UF, syb, 1, 0, 4, 1);
    }
    function Cp() {
        yp.call(this, 'VALUE', 1);
    }
    function dX(a) {
        cX.call(this);
        this.a = a;
    }
    function Q2(a) {
        this.a = new $2;
        this.b = a;
    }
    function Vh(a) {
        this.a = a;
        Rh.call(this);
    }
    function vl(a) {
        this.a = a;
        Rh.call(this);
    }
    function U8() {
        P8();
        this.d = (ckb(), bkb);
    }
    function zxb(a) {
        if (!a) throw new qkb;
    }
    function uxb(a) {
        if (!a) throw new tlb;
    }
    function vxb(a) {
        if (!a) throw new rlb;
    }
    function Hxb(a) {
        if (!a) throw new alb;
    }
    function Bxb(a) {
        if (!a) throw new nvb;
    }
    function Wub() {
        ytb.call(this, new wub);
    }
    function Kh() {
        Hh.call(this, 'CLOSED', 1);
    }
    function Im(a) {
        Em.call(this, new Lm(a));
    }
    function p7(a, b) {
        ++a.d;
        return BU(a, b);
    }
    function kkb(a, b) {
        return gmb(a.a, 0, b);
    }
    function jlb(a, b) {
        return glb(a.a, b.a);
    }
    function Al(a) {
        return Pl(a.b.mb(), a.a);
    }
    function Dl(a) {
        return Wl(a.a.mb(), a.b);
    }
    function q6(a, b) {
        return b == a.c ? a.d : a.c;
    }
    function Zs(a, b) {
        return a < b ? -1 : a > b ? 1 : 0;
    }
    function xlb(a, b) {
        return a < b ? -1 : a > b ? 1 : 0;
    }
    function pvb(a) {
        return a != null ? vb(a) : 0;
    }
    function Ntb(a) {
        this.a = aub();
        this.b = a;
    }
    function fub(a) {
        this.a = aub();
        this.b = a;
    }
    function Cg(a) {
        this.a = a;
        xg.call(this, a);
    }
    function o4() {
        n4();
        this.b = new q4(this);
    }
    function Oh() {
        Oh = iI;
        Nh = Jb(new Kb(', '));
    }
    function Gh() {
        Gh = iI;
        Fh = new Jh;
        Eh = new Kh;
    }
    function Il() {
        Il = iI;
        Gl = new Yl;
        Hl = new gm;
    }
    function xp() {
        xp = iI;
        vp = new Ap;
        wp = new Cp;
    }
    function qs() {
        qs = iI;
        ps = new ts;
        os = new ws;
    }
    function wJ() {
        wJ = iI;
        uJ = new NJ;
        vJ = new PJ;
    }
    function Teb(a) {
        a.g = new GU;
        a.b = new GU;
    }
    function OI(a) {
        a.a = new mvb;
        a.c = new mvb;
    }
    function n4() {
        n4 = iI;
        m4 = new U4;
        l4 = new u4;
    }
    function Uc() {
        Mc.call(this, 'IS_NULL', 2);
    }
    function Kwb() {
        Gwb.call(this, 'Head', 1);
    }
    function Pwb() {
        Gwb.call(this, 'Tail', 3);
    }
    function pR(a, b) {
        qR.call(this, a, b, null);
    }
    function lpb(a, b) {
        ipb(a, 0, a.length, b);
    }
    function x7(a, b) {
        vU(b.a, a.a);
        return a.a;
    }
    function CI(a, b) {
        a.a *= b;
        a.b *= b;
        return a;
    }
    function gl(a, b) {
        Gi();
        this.a = a;
        this.b = b;
    }
    function i9(a, b) {
        return a.a[b.d.k][b.k];
    }
    function W9(a, b) {
        return a.a[b.d.k][b.k];
    }
    function xJ(a, b) {
        return kmb(a.b, b.mc());
    }
    function Swb(a, b) {
        return qe(Xvb(a.a, b));
    }
    function Twb(a, b) {
        return qe(Yvb(a.a, b));
    }
    function $T(a, b) {
        return Wv(Dd(a.a, b), 20);
    }
    function aw(a, b) {
        return a != null && Vv(a, b);
    }
    function Qob(a) {
        return a.a < a.c.c.length;
    }
    function htb(a) {
        return a.a < a.c.a.length;
    }
    function y$(a, b) {
        return glb(a.i.a, b.i.a);
    }
    function S$(a, b) {
        return a.i.b = (Dxb(b), b);
    }
    function T$(a, b) {
        return a.i.b = (Dxb(b), b);
    }
    function utb(a, b) {
        return a.a.eb(b) != null;
    }
    function Vjb(a, b, c) {
        return a.g[b.e][c.e];
    }
    function Bkb(a) {
        xkb();
        return bmb(), '' + a;
    }
    function Mwb() {
        Gwb.call(this, 'Range', 2);
    }
    function ws() {
        rs.call(this, 'DISTINCT', 1);
    }
    function Xc() {
        Mc.call(this, 'NOT_NULL', 3);
    }
    function mp() {
        mp = iI;
        lp = new Rb((Oh(), Nh));
    }
    function Hj(a) {
        this.d = (ypb(), new mrb(a));
    }
    function Hb(a, b) {
        return Gb(a, new zmb, b).a;
    }
    function Mb(a, b) {
        return b == null ? a.b : Ib(b);
    }
    function mt(a) {
        return a == null ? null : a.name;
    }
    function cw(a) {
        return typeof a === 'number';
    }
    function ew(a) {
        return typeof a === 'string';
    }
    function Hi(a, b) {
        return new Mk(a, a.Y(), b);
    }
    function An(a, b) {
        return new no(a.a, a.b, b);
    }
    function Jb(a) {
        _b(Wxb);
        return new Nb(a, a);
    }
    function Do(a) {
        Mh(a, Vyb);
        return new HU(a);
    }
    function Am(a, b) {
        this.a = b;
        vm.call(this, a);
    }
    function tp(a, b) {
        this.a = b;
        vm.call(this, a);
    }
    function If(a, b) {
        this.a = a;
        Bf.call(this, b);
    }
    function ks(a) {
        this.c = a;
        this.a = Qr(this.c);
    }
    function MZ(a) {
        var b;
        b = a.a;
        a.a = a.b;
        a.b = b;
    }
    function pW(a, b) {
        a.e.j.a = b.a;
        a.e.j.b = b.b;
    }
    function xvb(a, b, c) {
        a.a = b ^ 1502;
        a.b = c ^ _Ab;
    }
    function uI(a, b, c) {
        a.a += b;
        a.b += c;
        return a;
    }
    function DI(a, b, c) {
        a.a -= b;
        a.b -= c;
        return a;
    }
    function zI(a) {
        a.a = -a.a;
        a.b = -a.b;
        return a;
    }
    function UI(a) {
        Bxb(a.b != 0);
        return a.a.a.c;
    }
    function VI(a) {
        Bxb(a.b != 0);
        return a.c.b.c;
    }
    function uub(a, b) {
        if (a.a) {
            Hub(b);
            Gub(b);
        }
    }
    function rn(a, b, c) {
        var d;
        d = a.ub(b);
        d.J(c);
    }
    function Iq(a, b) {
        return Zs(b.Yb(), a.Yb());
    }
    function o5(a) {
        return Wv(yU(a.a, a.b), 128);
    }
    function EU(a) {
        return cxb(a.c, a.c.length);
    }
    function Fv(a) {
        return a.l + a.m * czb + a.h * dzb;
    }
    function LM(a) {
        return a == EM || a == GM || a == FM;
    }
    function UH(a) {
        return typeof a === 'number';
    }
    function Zsb(a, b) {
        return !!b && a.b[b.e] == b;
    }
    function lsb(a, b) {
        var c;
        c = a[WAb];
        b[WAb] = c;
    }
    function FQ(a, b) {
        _J.call(this, a);
        this.b = b;
    }
    function Rqb(a) {
        zqb.call(this, a);
        this.a = a;
    }
    function arb(a) {
        Nqb.call(this, a);
        this.a = a;
    }
    function dsb(a) {
        Frb.call(this, a);
        this.a = a;
    }
    function Xub(a) {
        ytb.call(this, new xub(a));
    }
    function wwb(a) {
        this.a = a;
        Bob.call(this, a);
    }
    function v5(a) {
        this.c = a;
        this.a = 1;
        this.b = 1;
    }
    function Rb(a) {
        this.a = a;
        this.b = $v(_b('='));
    }
    function B5() {
        this.a = new aJ;
        this.e = new aJ;
    }
    function tV() {
        this.a = new fU;
        this.c = new uV;
    }
    function cX() {
        this.i = new FI;
        this.j = new FI;
    }
    function Md(a) {
        Xb(a.d.c + a.e.c == 0);
        this.b = a;
    }
    function _s(a) {
        a.g = null;
        Ot(a, a.f);
        return a;
    }
    function Nl(a) {
        Il();
        _b(a);
        return new om(a);
    }
    function St(a) {
        Nt();
        return parseInt(a) || -1;
    }
    function Uwb(a, b) {
        return cwb(a.a, b) != null;
    }
    function ok(a, b) {
        return !rk(a, b) && !qk(a, b);
    }
    function txb(a) {
        return a.$H || (a.$H = ++sxb);
    }
    function yc(a) {
        return a.d != null ? a.d : '' + a.e;
    }
    function zc(a) {
        return a.d != null ? a.d : '' + a.e;
    }
    function pwb(a) {
        return a.b = Wv(Cnb(a.a), 21);
    }
    function bw(a) {
        return typeof a === 'boolean';
    }
    function pub(a) {
        a.b = new Iub(a);
        a.c = new ntb;
    }
    function oab() {
        this.a = new GU;
        this.d = new GU;
    }
    function Iub(a) {
        Jub.call(this, a, null, null);
    }
    function ug(a, b, c, d) {
        mg.call(this, a, b, c, d);
    }
    function BP(a, b, c, d) {
        vP.call(this, a, b, c, d);
    }
    function EP(a, b, c, d) {
        vP.call(this, a, b, c, d);
    }
    function Kg(a, b, c) {
        _f.call(this, a, b, c, null);
    }
    function Lg(a, b, c) {
        _f.call(this, a, b, c, null);
    }
    function es(a, b, c) {
        a.i = b;
        b.f = a;
        b.i = c;
        c.f = b;
    }
    function tI(a, b) {
        mI(this);
        this.e = a;
        this.f = b;
    }
    function yg(a, b) {
        this.d = a;
        vg(this);
        this.b = b;
    }
    function kJ(a) {
        OI(this);
        _I(this);
        Ue(this, a);
    }
    function Xv(a) {
        Hxb(a == null || bw(a));
        return a;
    }
    function Yv(a) {
        Hxb(a == null || cw(a));
        return a;
    }
    function $v(a) {
        Hxb(a == null || ew(a));
        return a;
    }
    function vI(a, b) {
        a.a += b.a;
        a.b += b.b;
        return a;
    }
    function EI(a, b) {
        a.a -= b.a;
        a.b -= b.b;
        return a;
    }
    function U$(a, b) {
        return a.i.a = (Dxb(b), b) + 10;
    }
    function V$(a, b) {
        return a.i.a = (Dxb(b), b) + 10;
    }
    function h6(a, b) {
        return Wv(Smb(a.k, b), 24).a;
    }
    function Bj(a, b) {
        return Lh(a, b), new zr(a, b);
    }
    function Web(a, b) {
        return Wv(a.b.sb(b), 92).a;
    }
    function WX(a) {
        return Wv(a, 7).b.c.length != 0;
    }
    function TX(a) {
        return Wv(a, 7).e.c.length != 0;
    }
    function jX(a) {
        return !a.d ? -1 : zU(a.d.a, a, 0);
    }
    function lt(a) {
        return a == null ? null : a.message;
    }
    function Gkb(a) {
        if (a.n != null) return;
        Wkb(a);
    }
    function wmb(a, b, c, d) {
        jkb(a, b, c, d);
        return a;
    }
    function mmb(a, b) {
        bmb();
        return a.indexOf(b);
    }
    function QX(a, b) {
        if (!b) throw new Vlb;
        a.g = b;
    }
    function Mn(a) {
        if (a.e.c != a.b) throw new nsb;
    }
    function Xn(a) {
        if (a.f.c != a.b) throw new nsb;
    }
    function Uq(a, b) {
        _b(a);
        _b(b);
        return Akb(a, b);
    }
    function U6(a, b) {
        this.a = a;
        this.c = b;
        this.b = 2;
    }
    function sI() {
        mI(this);
        this.e = -1;
        this.f = true;
    }
    function Dh() {
        Vd.call(this, new ntb);
        this.a = 3;
    }
    function CP(a) {
        vP.call(this, a.d, a.b, a.a, a.c);
    }
    function FP(a) {
        vP.call(this, a.d, a.b, a.a, a.c);
    }
    function r6(a) {
        k6.call(this, a);
        this.c = new GU;
    }
    function Oc() {
        Mc.call(this, 'ALWAYS_TRUE', 0);
    }
    function Rc() {
        Mc.call(this, 'ALWAYS_FALSE', 1);
    }
    function _T(a) {
        XT();
        this.a = new Dh;
        YT(this, a);
    }
    function Y9(a) {
        !a.e && (a.e = new GU);
        return a.e;
    }
    function W7(a) {
        var b;
        b = new V7;
        b.e = a;
        return b;
    }
    function msb(a) {
        var b;
        b = a[WAb] | 0;
        a[WAb] = b + 1;
    }
    function Anb(a, b) {
        a.a.rb(a.b, b);
        ++a.b;
        a.c = -1;
    }
    function Enb(a, b) {
        uxb(a.c != -1);
        a.a.wb(a.c, b);
    }
    function zkb(a, b) {
        xkb();
        return a == b ? 0 : a ? 1 : -1;
    }
    function Wjb(a, b, c) {
        return a.g[b.e][c.e] * a.d;
    }
    function xt(a, b, c) {
        var d;
        return a.apply(b, c);
    }
    function ssb(a, b, c) {
        return rsb(a, Wv(b, 17), c);
    }
    function m5(a, b) {
        return b == (sN(), rN) ? a.c : a.d;
    }
    function Zi(a, b) {
        return b != null && a.Nb().kb(b);
    }
    function skb(a, b) {
        this.e = b;
        this.f = a;
        _s(this);
    }
    function om(a) {
        this.b = a;
        this.a = (Il(), Il(), Hl);
    }
    function dk(a) {
        hi();
        this.a = (ypb(), new Frb(a));
    }
    function hi() {
        hi = iI;
        new vi((ypb(), ypb(), vpb));
    }
    function e8() {
        e8 = iI;
        d8 = PQ(new WQ, (d0(), X_));
    }
    function rwb(a) {
        swb.call(this, a, (Fwb(), Bwb));
    }
    function IU(a) {
        tU(this);
        gxb(this.c, 0, a.ob());
    }
    function tr(a, b, c) {
        this.b = a;
        this.a = b;
        this.c = c;
    }
    function WS(a, b, c) {
        VS.call(this, a, b);
        this.b = c;
    }
    function XV(a, b, c) {
        this.b = a;
        this.a = b;
        this.c = c;
    }
    function job(a, b) {
        var c;
        c = a.e;
        a.e = b;
        return c;
    }
    function qub(a) {
        Ymb(a.c);
        a.b.b = a.b;
        a.b.a = a.b;
    }
    function Vf(a) {
        a.b ? Vf(a.b) : Umb(a.f.b, a.e, a.d);
    }
    function YI(a) {
        Bxb(a.b != 0);
        return $I(a, a.a.a);
    }
    function ZI(a) {
        Bxb(a.b != 0);
        return $I(a, a.c.b);
    }
    function Wl(a, b) {
        Il();
        _b(b);
        return new Am(a, b);
    }
    function np(a, b) {
        mp();
        return new tp(a.mb(), b);
    }
    function jmb(a, b) {
        bmb();
        return a.charCodeAt(b);
    }
    function imb(a, b, c) {
        bmb();
        return a.substr(b, c);
    }
    function qmb(a) {
        bmb();
        return a == null ? Wxb : xb(a);
    }
    function Xjb(a, b, c) {
        return Vjb(a, b.g, c.g) * a.d;
    }
    function Ev(a, b, c) {
        return {
            'l': a,
            'm': b,
            'h': c
        };
    }
    function YU(a, b) {
        return ZU(a, new VS(b.a, b.b));
    }
    function SN(a, b, c, d, e) {
        a.d = b;
        a.e = c;
        a.c = d;
        a.b = e;
    }
    function wS(a, b, c, d, e) {
        a.b = b;
        a.c = c;
        a.d = d;
        a.a = e;
    }
    function QI(a, b) {
        TI(a, b, a.c.b, a.c);
        return true;
    }
    function vU(a, b) {
        a.c[a.c.length] = b;
        return true;
    }
    function DJ(a, b) {
        wJ();
        CJ.call(this, a);
        this.a = b;
    }
    function g8() {
        e8();
        this.e = new aJ;
        this.d = new aJ;
    }
    function Fmb() {
        Fmb = iI;
        Dmb = new hkb;
        Emb = new hkb;
    }
    function zab() {
        zab = iI;
        yab = VQ(new WQ, (d0(), v_));
    }
    function abb() {
        abb = iI;
        _ab = VQ(new WQ, (d0(), v_));
    }
    function rbb() {
        rbb = iI;
        qbb = VQ(new WQ, (d0(), v_));
    }
    function $bb() {
        $bb = iI;
        Zbb = VQ(new WQ, (d0(), v_));
    }
    function Wt() {
        Wt = iI;
        Error.stackTraceLimit = 64;
    }
    function xS() {
        wS(this, false, false, false, false);
    }
    function Bo(a) {
        var b;
        b = new GU;
        Jl(b, a);
        return b;
    }
    function Eo(a) {
        var b;
        b = new aJ;
        ml(b, a);
        return b;
    }
    function XQ(a) {
        var b;
        b = new WQ;
        QQ(b, a);
        return b;
    }
    function Ocb(a) {
        var b;
        b = new Mcb;
        b.a = a;
        return b;
    }
    function Wv(a, b) {
        Hxb(a == null || Vv(a, b));
        return a;
    }
    function Dvb(a, b) {
        if (a < 0 || a >= b) throw new pkb;
    }
    function pl(a, b) {
        _b(a);
        _b(b);
        return new Bl(a, b);
    }
    function ul(a, b) {
        _b(a);
        _b(b);
        return new El(a, b);
    }
    function nmb(a, b) {
        bmb();
        return a.lastIndexOf(b);
    }
    function rgb(a, b, c) {
        return a < b ? c <= a : a <= c || a == b;
    }
    function cvb(a, b, c) {
        this.d = a;
        this.b = c;
        this.a = b;
    }
    function atb(a, b, c) {
        this.a = a;
        this.b = b;
        this.c = c;
    }
    function lub(a, b, c) {
        this.a = a;
        this.b = b;
        this.c = c;
    }
    function Nb(a, b) {
        this.a = a;
        this.b = Wxb;
        this.c = b.c;
    }
    function z3(a) {
        this.c = a.c;
        this.a = a.e;
        this.b = a.b;
    }
    function xg(a) {
        this.d = a;
        vg(this);
        this.b = Ed(a.d);
    }
    function u4() {
        FS.call(this);
        this.a = new x4(this);
    }
    function FS() {
        this.c = new PS;
        this.d = new KS(this);
    }
    function qr(a) {
        var b;
        b = new vtb;
        Jl(b, a);
        return b;
    }
    function qwb(a) {
        vnb(a.a);
        dwb(a.c, a.b);
        a.b = null;
    }
    function n5(a) {
        return a.c - Wv(yU(a.a, a.b), 128).b;
    }
    function t5(a, b) {
        return a.c < b.c ? -1 : a.c == b.c ? 0 : 1;
    }
    function t4(a, b) {
        return tK(a.b.d) ? b.xc() : b.wc();
    }
    function gmb(a, b, c) {
        return bmb(), a.substr(b, c - b);
    }
    function gxb(a, b, c) {
        dxb(c, 0, a, b, c.length, false);
    }
    function Jub(a, b, c) {
        this.c = a;
        qob.call(this, b, c);
    }
    function Bl(a, b) {
        this.b = a;
        this.a = b;
        Rh.call(this);
    }
    function El(a, b) {
        this.a = a;
        this.b = b;
        Rh.call(this);
    }
    function Lq(a, b) {
        this.b = a;
        this.a = b;
        Mh(b, 'count');
    }
    function dl(a) {
        this.b = a;
        this.a = nj(this.b.a).Kb();
    }
    function CJ(a) {
        wJ();
        this.c = uJ;
        this.d = vJ;
        this.b = a;
    }
    function iab(a, b, c) {
        gab.call(this, a, b);
        this.a = c;
    }
    function mab(a, b, c) {
        gab.call(this, a, b);
        this.a = c;
    }
    function yU(a, b) {
        Cxb(b, a.c.length);
        return a.c[b];
    }
    function PQ(a, b) {
        Wv(yU(a.a, 5), 18).ib(b);
        return a;
    }
    function RQ(a, b) {
        Wv(yU(a.a, 0), 18).ib(b);
        return a;
    }
    function SQ(a, b) {
        Wv(yU(a.a, 1), 18).ib(b);
        return a;
    }
    function TQ(a, b) {
        Wv(yU(a.a, 2), 18).ib(b);
        return a;
    }
    function UQ(a, b) {
        Wv(yU(a.a, 3), 18).ib(b);
        return a;
    }
    function VQ(a, b) {
        Wv(yU(a.a, 4), 18).ib(b);
        return a;
    }
    function iS(a) {
        gS(a, (sK(), oK));
        a.e = true;
        return a;
    }
    function Pt(a) {
        Nt();
        var b;
        b = Mt.ec(a);
        return Qt(b);
    }
    function Pkb(a, b) {
        var c;
        c = Mkb(a, b);
        c.g = 2;
        return c;
    }
    function _ob(a, b) {
        var c;
        for(c = 0; c < b; ++c)a[c] = 0;
    }
    function YW(a, b) {
        a.b = b.b;
        a.c = b.c;
        a.d = b.d;
        a.a = b.a;
    }
    function Hub(a) {
        a.a.b = a.b;
        a.b.a = a.a;
        a.a = a.b = null;
    }
    function NX(a) {
        return a.b.c.length + a.e.c.length;
    }
    function zv(a) {
        return Array.isArray(a) && a.ad === kI;
    }
    function ol(a, b) {
        return Il(), Tl(new Tob(a), b) != -1;
    }
    function vv(a, b, c, d, e, f) {
        return wv(a, b, c, d, e, 0, f);
    }
    function BJ(a, b, c) {
        wJ();
        FJ.call(this, a.b, b, c, a.d);
    }
    function AJ(a, b) {
        wJ();
        FJ.call(this, a.b, b, a.c, a.d);
    }
    function uU(a, b, c) {
        Fxb(b, a.c.length);
        fxb(a.c, b, c);
    }
    function mpb(a, b) {
        Cxb(b, a.a.length);
        return a.a[b];
    }
    function kpb(c) {
        c.sort(function(a, b) {
            return a - b;
        });
    }
    function _b(a) {
        if (a == null) throw new Vlb;
        return a;
    }
    function lv(a) {
        if (a == null) throw new Vlb;
        this.a = a;
    }
    function Us(a, b, c) {
        if (a.a != b) throw new nsb;
        a.a = c;
    }
    function wxb(a, b) {
        if (!a) throw new slb((bmb(), b));
    }
    function Axb(a, b) {
        if (!a) throw new rkb((bmb(), b));
    }
    function Dxb(a) {
        if (a == null) throw new Vlb;
        return a;
    }
    function Yub(a) {
        ytb.call(this, new wub);
        Ue(this, a);
    }
    function xtb(a) {
        this.a = new otb(a.Y());
        Ue(this, a);
    }
    function Lsb(a) {
        this.c = a;
        this.a = new jtb(this.c.a);
    }
    function Er(a) {
        Gi();
        this.a = (ypb(), new rqb(_b(a)));
    }
    function xkb() {
        xkb = iI;
        vkb = (xkb(), false);
        wkb = true;
    }
    function Glb() {
        Glb = iI;
        Flb = xv(PF, Txb, 24, 256, 0, 1);
    }
    function k8() {
        k8 = iI;
        j8 = PQ(RQ(new WQ, (d0(), z_)), X_);
    }
    function aS() {
        aS = iI;
        ZR = new yS;
        _R = new FS;
        $R = new AS;
    }
    function dw(a) {
        return a != null && fw(a) && !(a.ad === kI);
    }
    function _v(a) {
        return !Array.isArray(a) && a.ad === kI;
    }
    function Wmb(a, b) {
        return ew(b) ? Xmb(a, b) : Mtb(a.d, b);
    }
    function Ysb(a, b) {
        return aw(b, 17) && Zsb(a, Wv(b, 17));
    }
    function $sb(a, b) {
        return aw(b, 17) && _sb(a, Wv(b, 17));
    }
    function bub(a, b) {
        return !(Utb(a.a, b) === undefined);
    }
    function Vsb(a, b) {
        var c;
        c = Usb(a);
        zpb(c, b);
        return c;
    }
    function Kt(a, b) {
        !a && (a = []);
        a[a.length] = b;
        return a;
    }
    function rsb(a, b, c) {
        Wsb(a.a, b);
        return usb(a, b.e, c);
    }
    function omb(a, b, c) {
        bmb();
        return a.lastIndexOf(b, c);
    }
    function xxb(a, b, c) {
        if (!a) throw new slb(Jxb(b, c));
    }
    function Zob(a, b, c) {
        var d;
        for(d = 0; d < b; ++d)a[d] = c;
    }
    function Qo(a, b) {
        var c;
        c = a.a.Y();
        bc(b, c);
        return c - b;
    }
    function ud(a) {
        var b;
        b = a.i;
        return !b ? a.i = a.T() : b;
    }
    function Ae(a) {
        var b;
        b = a.c;
        return !b ? a.c = a.gb() : b;
    }
    function ki(a) {
        var b;
        b = a.c;
        return !b ? a.c = a.Jb() : b;
    }
    function nj(a) {
        if (a.e) return a.e;
        return a.e = a.Ob();
    }
    function oj(a) {
        if (a.f) return a.f;
        return a.f = a.Pb();
    }
    function Hv(a, b) {
        return Ev(a.l & b.l, a.m & b.m, a.h & b.h);
    }
    function flb(a, b) {
        return glb((Dxb(a), a), (Dxb(b), b));
    }
    function Ed(a) {
        return aw(a, 20) ? Wv(a, 20).tb() : a.mb();
    }
    function Ml(a) {
        Il();
        _b(a);
        while(a.G()){
            a.H();
            a.I();
        }
    }
    function Uab(a) {
        var b;
        b = a;
        while(b.g)b = b.g;
        return b;
    }
    function LY(a) {
        a.b.i.a += a.a.f * (a.a.a - 1);
        return null;
    }
    function Sob(a) {
        uxb(a.b != -1);
        a.c.vb(a.a = a.b);
        a.b = -1;
    }
    function Dnb(a) {
        Bxb(a.b > 0);
        return a.a.sb(a.c = --a.b);
    }
    function $f(a) {
        a.b ? $f(a.b) : a.d.V() && Wmb(a.f.b, a.e);
    }
    function wg(a) {
        Yf(a.d);
        if (a.d.d != a.c) throw new nsb;
    }
    function ksb(a, b) {
        if (b[WAb] != a[WAb]) throw new nsb;
    }
    function Pl(a, b) {
        Il();
        _b(a);
        _b(b);
        return new tm(a, b);
    }
    function Zq(a, b) {
        Gi();
        Yq.call(this, a, Yi(new opb(b)));
    }
    function mg(a, b, c, d) {
        this.a = a;
        _f.call(this, a, b, c, d);
    }
    function GI(a) {
        this.a = Math.cos(a);
        this.b = Math.sin(a);
    }
    function GQ(a, b, c) {
        _J.call(this, a);
        this.b = b;
        this.a = c;
    }
    function NR(a) {
        this.b = new GU;
        this.a = new GU;
        this.c = a;
    }
    function sY(a) {
        this.c = new FI;
        this.a = new GU;
        this.b = a;
    }
    function tu() {
        tu = iI;
        ru = new uu(false);
        su = new uu(true);
    }
    function o7(a, b) {
        ++a.d;
        return a.c[a.c.length] = b, true;
    }
    function $ub(a, b) {
        TI(a.d, b, a.b.b, a.b);
        ++a.a;
        a.c = null;
    }
    function stb(a, b) {
        var c;
        c = a.a.db(b, a);
        return c == null;
    }
    function cxb(a, b) {
        var c;
        c = a.slice(0, b);
        return Cv(c, a);
    }
    function exb(a, b) {
        var c;
        c = new Array(b);
        return Cv(c, a);
    }
    function usb(a, b, c) {
        var d;
        d = a.b[b];
        a.b[b] = c;
        return d;
    }
    function apb(a, b) {
        var c;
        for(c = 0; c < b; ++c)a[c] = null;
    }
    function cpb(a, b) {
        var c;
        for(c = 0; c < b; ++c)a[c] = false;
    }
    function r1(a, b) {
        return xkb(), Wv(b.b, 24).a < a ? wkb : vkb;
    }
    function s1(a, b) {
        return xkb(), Wv(b.a, 24).a < a ? wkb : vkb;
    }
    function Tk(a, b) {
        return Wv(ki(nj(a.a)).sb(b), 21).yb();
    }
    function dq(a) {
        return mp(), Wl(Rm(a.a).mb(), (xp(), vp));
    }
    function Uh(a) {
        return Il(), new Im(Dl(ul(a.a, new yl)));
    }
    function fw(a) {
        return typeof a === Sxb || typeof a === Zxb;
    }
    function Ct(a) {
        $wnd.setTimeout(function() {
            throw a;
        }, 0);
    }
    function oI(a, b) {
        return a > 0 ? new tI(a - 1, b) : new tI(a, b);
    }
    function Ib(a) {
        _b(a);
        return aw(a, 345) ? Wv(a, 345) : xb(a);
    }
    function Rwb(a, b) {
        return bwb(a.a, b, (xkb(), vkb)) == null;
    }
    function Po(a, b) {
        var c;
        c = a.a.Y();
        $b(b, c);
        return c - 1 - b;
    }
    function hu(a, b, c) {
        var d;
        d = gu(a, b);
        iu(a, b, c);
        return d;
    }
    function Nkb(a, b, c) {
        var d;
        d = Mkb(a, b);
        $kb(c, d);
        return d;
    }
    function Mkb(a, b) {
        var c;
        c = new Kkb;
        c.i = a;
        c.d = b;
        return c;
    }
    function Mk(a, b, c) {
        this.a = a;
        bc(c, b);
        this.c = b;
        this.b = c;
    }
    function Av(a, b, c) {
        zxb(c == null || sv(a, c));
        return a[b] = c;
    }
    function Pm(a) {
        a.a = null;
        a.e = null;
        Ymb(a.b);
        a.d = 0;
        ++a.c;
    }
    function Pmb(a) {
        slb.call(this, (bmb(), a == null ? Wxb : a));
    }
    function Omb(a) {
        slb.call(this, (bmb(), a == null ? Wxb : a));
    }
    function Om(a) {
        var b;
        return b = a.f, !b ? a.f = new Pp(a) : b;
    }
    function Jd(a) {
        var b;
        return b = a.k, !b ? a.k = new Qg(a) : b;
    }
    function Be(a) {
        var b;
        b = a.e;
        return !b ? a.e = new Fp(a) : b;
    }
    function Vg(a) {
        var b;
        b = a.e;
        !b && (a.e = b = a.gb());
        return b;
    }
    function d6(a) {
        var b, c;
        b = a.c.f.d;
        c = a.d.f.d;
        return b == c;
    }
    function Gfb(a, b) {
        var c;
        c = new Dfb(a);
        Afb(c, b);
        return c;
    }
    function umb(a, b) {
        a.a += String.fromCharCode(b);
        return a;
    }
    function hX(a) {
        if (!a.a && !!a.d) return a.d.b;
        return a.a;
    }
    function _H(a) {
        if (UH(a)) return a | 0;
        return a.l | a.m << 22;
    }
    function xo(a) {
        Mh(a, Uyb);
        return $s(PH(PH(5, a), a / 10 | 0));
    }
    function Smb(a, b) {
        return ew(b) ? Tmb(a, b) : re(Ktb(a.d, b));
    }
    function tl(a) {
        return aw(a, 19) ? Wv(a, 19).Y() : Ul(a.mb());
    }
    function pr(a) {
        return a ? new xtb((Oh(), a)) : qr(null.mb());
    }
    function Tb(a, b) {
        return gw(a) === gw(b) || a != null && rb(a, b);
    }
    function zT(a, b) {
        return vT(), glb(Ixb(Yv(a)), Ixb(Yv(b)));
    }
    function Ep(a) {
        return mp(), Wl(a.a.bb().mb(), (xp(), wp));
    }
    function Gi() {
        Gi = iI;
        hi();
        Fi = new gr((ypb(), ypb(), vpb));
    }
    function kr() {
        kr = iI;
        hi();
        jr = new lr((ypb(), ypb(), xpb));
    }
    function Exb(a, b) {
        if (a == null) throw new Wlb((bmb(), b));
    }
    function Zfb(a, b) {
        Mfb();
        return (a - b <= 0 ? 0 - (a - b) : a - b) < 0.2;
    }
    function U0(a, b) {
        return a.i.b < b.i.b ? -1 : a.i.b == b.i.b ? 0 : 1;
    }
    function Zjb(a, b, c, d) {
        a.g[b.e][c.e] = d;
        a.g[c.e][b.e] = d;
    }
    function vnb(a) {
        uxb(a.c != -1);
        a.d.vb(a.c);
        a.b = a.c;
        a.c = -1;
    }
    function Sub(a) {
        this.c = a;
        this.b = a.a.b.a;
        lsb(a.a.c, this);
    }
    function ufb(a) {
        efb.call(this, new opb(a));
        this.a = new FI;
    }
    function er() {
        Bk.call(this, new ir(new ntb));
        this.a = this;
    }
    function OQ() {
        JQ();
        this.b = (mp(), new ntb);
        this.a = new ntb;
    }
    function zp() {
        xp();
        return Bv(tv(jy, 1), uyb, 188, 0, [
            vp,
            wp
        ]);
    }
    function Ih() {
        Gh();
        return Bv(tv(dx, 1), uyb, 159, 0, [
            Fh,
            Eh
        ]);
    }
    function ss() {
        qs();
        return Bv(tv(Ty, 1), uyb, 205, 0, [
            ps,
            os
        ]);
    }
    function psb(a) {
        We(a.a);
        a.b = xv(UF, syb, 1, a.b.length, 4, 1);
    }
    function krb(a) {
        !a.b && (a.b = new Frb(a.c.W()));
        return a.b;
    }
    function cwb(a, b) {
        var c;
        c = new zwb;
        ewb(a, b, c);
        return c.d;
    }
    function Qkb(a, b) {
        var c;
        c = Mkb('', a);
        c.k = b;
        c.g = 1;
        return c;
    }
    function We(a) {
        var b;
        for(b = a.mb(); b.G();){
            b.H();
            b.I();
        }
    }
    function yJ(a, b) {
        return aw(b, 79) && emb(a.b, Wv(b, 79).mc());
    }
    function Z3() {
        X3();
        return Bv(tv(iD, 1), uyb, 175, 0, [
            V3,
            W3
        ]);
    }
    function a8() {
        Z7();
        return Bv(tv(WD, 1), uyb, 193, 0, [
            X7,
            Y7
        ]);
    }
    function s9() {
        p9();
        return Bv(tv(hE, 1), uyb, 192, 0, [
            o9,
            n9
        ]);
    }
    function Umb(a, b, c) {
        return ew(b) ? Vmb(a, b, c) : Ltb(a.d, b, c);
    }
    function h5(a, b, c) {
        a.i = 0;
        a.e = 0;
        if (b == c) return;
        d5(a, b, c);
    }
    function g5(a, b, c) {
        a.i = 0;
        a.e = 0;
        if (b == c) return;
        c5(a, b, c);
    }
    function t6(a, b, c, d) {
        this.d = a;
        this.b = b;
        this.a = c;
        this.c = d;
    }
    function VN(a, b, c, d) {
        this.d = a;
        this.e = b;
        this.c = c;
        this.b = d;
    }
    function E5(a, b, c, d) {
        this.a = a;
        this.c = b;
        this.b = c;
        this.d = d;
    }
    function vO(a, b, c, d) {
        Ac.call(this, a, b);
        this.a = c;
        this.b = d;
    }
    function Jtb(a, b) {
        var c;
        c = Ttb(a.a, b);
        return c == null ? [] : c;
    }
    function kmb(a, b) {
        bmb();
        if (a == b) return 0;
        return a < b ? -1 : 1;
    }
    function CR(a, b) {
        var c;
        c = hR(a.f, b);
        return vI(zI(c), a.f.d);
    }
    function qsb(a, b) {
        return Ysb(a.a, b) ? a.b[Wv(b, 17).e] : null;
    }
    function ovb(a, b) {
        return gw(a) === gw(b) || a != null && rb(a, b);
    }
    function Pu(a, b) {
        if (b == null) throw new Vlb;
        return Qu(a, b);
    }
    function Zv(a) {
        Hxb(a == null || fw(a) && !(a.ad === kI));
        return a;
    }
    function irb(a) {
        !a.a && (a.a = new Nrb(a.c.bb()));
        return a.a;
    }
    function lrb(a) {
        !a.d && (a.d = new zqb(a.c.fb()));
        return a.d;
    }
    function _I(a) {
        a.a.a = a.c;
        a.c.b = a.a;
        a.a.b = a.c.a = null;
        a.b = 0;
    }
    function Cnb(a) {
        return Bxb(a.b < a.d.Y()), a.d.sb(a.c = a.b++);
    }
    function Xmb(a, b) {
        return b == null ? Mtb(a.d, null) : eub(a.e, b);
    }
    function $9(a, b) {
        this.g = a;
        this.d = Bv(tv(qB, 1), Nzb, 9, 0, [
            b
        ]);
    }
    function KS(a) {
        this.c = a;
        this.b = new Wwb(Wv(_b(new MS), 56));
    }
    function hW() {
        this.a = new jJ;
        this.b = (Mh(3, Vyb), new HU(3));
    }
    function Dg(a, b) {
        this.a = a;
        yg.call(this, a, Wv(a.d, 20).ub(b));
    }
    function rab(a, b, c, d) {
        this.a = a;
        this.c = b;
        this.b = c;
        this.d = d;
    }
    function Zlb(a, b, c) {
        this.a = Yxb;
        this.d = a;
        this.b = b;
        this.c = c;
    }
    function $W() {
        XW(this);
        this.d = 0;
        this.b = 0;
        this.a = 0;
        this.c = 0;
    }
    function Bcb() {
        this.b = new vtb;
        this.d = new aJ;
        this.e = new Uvb;
    }
    function ypb() {
        ypb = iI;
        vpb = new Kpb;
        wpb = new aqb;
        xpb = new iqb;
    }
    function Lc() {
        Lc = iI;
        Ic = new Oc;
        Hc = new Rc;
        Jc = new Uc;
        Kc = new Xc;
    }
    function Z7() {
        Z7 = iI;
        X7 = new $7('GREEDY', 0);
        Y7 = new $7(zAb, 1);
    }
    function zQ() {
        zQ = iI;
        yQ = new AJ((eM(), EL), (xkb(), xkb(), wkb));
    }
    function w9() {
        w9 = iI;
        v9 = PQ(UQ(TQ(new WQ, (d0(), N_)), B_), M_);
    }
    function N6(a, b) {
        var c;
        c = M6(b);
        return Wv(Smb(a.c, c), 24).a;
    }
    function PR(a, b) {
        var c;
        c = utb(a.a, b);
        c && (b.f = null);
        return c;
    }
    function Krb(a) {
        var b;
        b = a.b.ob();
        Mrb(b, b.length);
        return b;
    }
    function NP(a) {
        if (a < 0) return -1;
        if (a > 0) return 1;
        return 0;
    }
    function mP() {
        kP();
        return Bv(tv(Rz, 1), uyb, 171, 0, [
            jP,
            gP,
            hP
        ]);
    }
    function gL() {
        eL();
        return Bv(tv(Fz, 1), uyb, 166, 0, [
            cL,
            bL,
            dL
        ]);
    }
    function WM() {
        UM();
        return Bv(tv(Jz, 1), uyb, 149, 0, [
            TM,
            SM,
            RM
        ]);
    }
    function FO() {
        DO();
        return Bv(tv(Pz, 1), uyb, 225, 0, [
            BO,
            AO,
            CO
        ]);
    }
    function ZZ() {
        XZ();
        return Bv(tv(VB, 1), uyb, 221, 0, [
            VZ,
            WZ,
            UZ
        ]);
    }
    function A8() {
        x8();
        return Bv(tv(_D, 1), uyb, 173, 0, [
            w8,
            v8,
            u8
        ]);
    }
    function QH(a, b) {
        return SH(Hv(UH(a) ? YH(a) : a, UH(b) ? YH(b) : b));
    }
    function XI(a) {
        return a.b == 0 ? null : (Bxb(a.b != 0), $I(a, a.a.a));
    }
    function zfb(a) {
        a.d = a.d - 15;
        a.b = a.b - 15;
        a.c = a.c + 15;
        a.a = a.a + 15;
    }
    function Rn(a) {
        this.b = a;
        this.c = a;
        a.e = null;
        a.c = null;
        this.a = 1;
    }
    function nZ(a, b, c) {
        this.d = a;
        this.b = new GU;
        this.c = b;
        this.a = c;
    }
    function sfb(a, b) {
        qfb(this, new HI(a.a, a.b));
        rfb(this, Eo(b));
    }
    function Xf(a, b) {
        if (b === a) return true;
        Yf(a);
        return a.d.t(b);
    }
    function Oeb(a) {
        if (a == neb || a == keb) return true;
        return false;
    }
    function VO(a) {
        if (!Qob(new Tob(zW(a.e)))) return;
        OO(a);
        QO(a);
    }
    function Y2(a, b) {
        var c;
        c = Wv(vub(a.e, b), 116);
        !!c && (a.d = true);
    }
    function Lrb(a, b) {
        var c;
        c = a.b.pb(b);
        Mrb(c, a.b.Y());
        return c;
    }
    function a6(a) {
        var b;
        b = e6(a, (sN(), rN));
        b += e6(a, ZM);
        return b;
    }
    function f6(a, b, c) {
        j6(a, b, c, (sN(), ZM), a.f);
        j6(a, b, c, rN, a.n);
    }
    function PX(a, b) {
        !!a.f && BU(a.f.f, a);
        a.f = b;
        !!a.f && vU(a.f.f, a);
    }
    function rX(a, b) {
        !!a.d && BU(a.d.a, a);
        a.d = b;
        !!a.d && vU(a.d.a, a);
    }
    function eW(a, b) {
        !!a.d && BU(a.d.b, a);
        a.d = b;
        !!a.d && vU(a.d.b, a);
    }
    function dW(a, b) {
        !!a.c && BU(a.c.e, a);
        a.c = b;
        !!a.c && vU(a.c.e, a);
    }
    function Zdb(a) {
        var b;
        b = Eo(a.b);
        Ue(b, a.c);
        Ue(b, a.i);
        return b;
    }
    function Qxb() {
        if (Lxb == 256) {
            Kxb = Mxb;
            Mxb = {};
            Lxb = 0;
        }
        ++Lxb;
    }
    function Gbb() {
        Gbb = iI;
        Fbb = new Hbb(pzb, 0);
        Ebb = new Hbb(ozb, 1);
    }
    function fgb() {
        fgb = iI;
        dgb = new ggb(ozb, 0);
        egb = new ggb(pzb, 1);
    }
    function hgb() {
        fgb();
        return Bv(tv(fF, 1), uyb, 223, 0, [
            dgb,
            egb
        ]);
    }
    function xab() {
        vab();
        return Bv(tv(rE, 1), uyb, 242, 0, [
            uab,
            tab
        ]);
    }
    function Ibb() {
        Gbb();
        return Bv(tv(BE, 1), uyb, 248, 0, [
            Fbb,
            Ebb
        ]);
    }
    function Nbb() {
        Lbb();
        return Bv(tv(CE, 1), uyb, 247, 0, [
            Jbb,
            Kbb
        ]);
    }
    function ncb() {
        lcb();
        return Bv(tv(JE, 1), uyb, 194, 0, [
            jcb,
            kcb
        ]);
    }
    function Ohb() {
        Mhb();
        return Bv(tv(pF, 1), uyb, 174, 0, [
            Khb,
            Lhb
        ]);
    }
    function Hpb(a) {
        ypb();
        return aw(a, 63) ? new csb(a) : new Rqb(a);
    }
    function Rm(a) {
        var b;
        return b = a.g, Wv(!b ? a.g = new En(a) : b, 20);
    }
    function Ktb(a, b) {
        return Itb(a, b, Jtb(a, b == null ? 0 : a.b.Vc(b)));
    }
    function tX(a) {
        var b;
        return b = lX(a), 'n_' + (b == null ? Dlb(a.k) : b);
    }
    function ob(a) {
        return Ikb(tb(a)) + '@' + (vb(a) >>> 0).toString(16);
    }
    function ykb(a, b) {
        return zkb(Ckb((Dxb(a), a)), Ckb((Dxb(b), b)));
    }
    function Tmb(a, b) {
        return b == null ? re(Ktb(a.d, null)) : cub(a.e, b);
    }
    function Rr(a, b, c) {
        return new Ur(a.c, pk(a.b, wk(a.d, b, c)), a.a);
    }
    function hw(a) {
        return Math.max(Math.min(a, $xb), -2147483648) | 0;
    }
    function Ptb(a) {
        this.e = a;
        this.b = this.e.a.entries();
        this.a = [];
    }
    function xf(a) {
        this.c = a;
        this.b = new rnb(new inb(this.c.a).a);
    }
    function Em(a) {
        this.b = (Il(), Il(), Il(), Gl);
        this.a = Wv(_b(a), 35);
    }
    function EJ(a, b, c) {
        wJ();
        DJ.call(this, a, b);
        c != null && (this.c = c);
    }
    function cc(a, b, c) {
        if (a < 0 || b < a || b > c) throw new okb(Wb(a, b, c));
    }
    function $b(a, b) {
        if (a < 0 || a >= b) throw new okb(Ub(a, b));
        return a;
    }
    function ac(a, b) {
        if (a == null) throw new Wlb((bmb(), b));
        return a;
    }
    function Dm(a) {
        if (!Cm(a)) throw new nvb;
        a.c = a.b;
        return a.b.H();
    }
    function jI(a) {
        function b() {}
        b.prototype = a || {};
        return new b;
    }
    function rr(a) {
        var b;
        b = new wtb(op(a.length));
        zpb(b, a);
        return b;
    }
    function Gub(a) {
        var b;
        b = a.c.b.b;
        a.b = b;
        a.a = a.c.b;
        b.a = a.c.b.b = a;
    }
    function jwb(a) {
        this.b = null;
        !a && (a = (hsb(), hsb(), gsb));
        this.a = a;
    }
    function W6(a) {
        this.b = a;
        this.a = new Fnb(this.b, this.b.c.length);
    }
    function Li(a) {
        Gi();
        _b(a);
        return a ? Ki(a) : Ki(Bo(new Tob(null)));
    }
    function rt(a, b) {
        var c = qt[a.charCodeAt(0)];
        return c == null ? a : c;
    }
    function Skb(a, b) {
        var c = a.a = a.a || [];
        return c[b] || (c[b] = a.Oc(b));
    }
    function CU(a, b, c) {
        var d;
        Gxb(b, c, a.c.length);
        d = c - b;
        hxb(a.c, b, d);
    }
    function Ur(a, b, c) {
        Ch.call(this, b.a);
        this.c = a;
        this.b = b;
        this.a = c;
    }
    function ko(a) {
        Vm(a.c);
        a.e = a.a = a.c;
        a.c = a.c.c;
        ++a.d;
        return a.a.f;
    }
    function lo(a) {
        Vm(a.e);
        a.c = a.a = a.e;
        a.e = a.e.e;
        --a.d;
        return a.a.f;
    }
    function MX(a) {
        return MI(Bv(tv(qz, 1), Fzb, 10, 0, [
            a.f.i,
            a.i,
            a.a
        ]));
    }
    function GK() {
        EK();
        return Bv(tv(Cz, 1), uyb, 107, 0, [
            DK,
            AK,
            BK,
            CK
        ]);
    }
    function PK() {
        NK();
        return Bv(tv(Dz, 1), uyb, 122, 0, [
            MK,
            KK,
            JK,
            LK
        ]);
    }
    function ON() {
        MN();
        return Bv(tv(Mz, 1), uyb, 139, 0, [
            KN,
            LN,
            JN,
            IN
        ]);
    }
    function FN() {
        DN();
        return Bv(tv(Lz, 1), uyb, 150, 0, [
            BN,
            CN,
            AN,
            zN
        ]);
    }
    function Nc() {
        Lc();
        return Bv(tv(Bw, 1), uyb, 136, 0, [
            Ic,
            Hc,
            Jc,
            Kc
        ]);
    }
    function iT() {
        cT();
        return Bv(tv(yA, 1), uyb, 201, 0, [
            $S,
            bT,
            _S,
            aT
        ]);
    }
    function wN() {
        sN();
        return Bv(tv(Kz, 1), uyb, 32, 0, [
            qN,
            $M,
            ZM,
            pN,
            rN
        ]);
    }
    function xK() {
        sK();
        return Bv(tv(Bz, 1), uyb, 59, 0, [
            qK,
            pK,
            oK,
            nK,
            rK
        ]);
    }
    function c8() {
        c8 = iI;
        b8 = Cc((Z7(), Bv(tv(WD, 1), uyb, 193, 0, [
            X7,
            Y7
        ])));
    }
    function _3() {
        _3 = iI;
        $3 = Cc((X3(), Bv(tv(iD, 1), uyb, 175, 0, [
            V3,
            W3
        ])));
    }
    function u9() {
        u9 = iI;
        t9 = Cc((p9(), Bv(tv(hE, 1), uyb, 192, 0, [
            o9,
            n9
        ])));
    }
    function Jhb() {
        Hhb();
        return Bv(tv(oF, 1), uyb, 140, 0, [
            Fhb,
            Ghb,
            Ehb
        ]);
    }
    function Jgb() {
        Hgb();
        return Bv(tv(jF, 1), uyb, 218, 0, [
            Fgb,
            Egb,
            Ggb
        ]);
    }
    function fjb() {
        djb();
        return Bv(tv(rF, 1), uyb, 219, 0, [
            cjb,
            ajb,
            bjb
        ]);
    }
    function Sjb() {
        Qjb();
        return Bv(tv(sF, 1), uyb, 153, 0, [
            Njb,
            Pjb,
            Ojb
        ]);
    }
    function ekb() {
        ckb();
        return Bv(tv(uF, 1), uyb, 172, 0, [
            _jb,
            akb,
            bkb
        ]);
    }
    function Vmb(a, b, c) {
        return b == null ? Ltb(a.d, null, c) : dub(a.e, b, c);
    }
    function wk(a, b, c) {
        return new sk(a, false, null, (Gh(), Fh), true, b, c);
    }
    function tsb(a, b) {
        return $sb(a.a, b) ? usb(a, Wv(b, 17).e, null) : null;
    }
    function ql(a) {
        _b(a);
        return Ql((Il(), new Im(Dl(ul(a.a, new yl)))));
    }
    function Epb(a) {
        ypb();
        if (!a) return nqb(), mqb;
        return new Ipb(a);
    }
    function Oo(a, b) {
        var c, d;
        d = Qo(a, b);
        c = a.a.ub(d);
        return new bp(a, c);
    }
    function Cpb(a, b) {
        var c, d;
        d = a.Y();
        for(c = 0; c < d; c++)a.wb(c, b[c]);
    }
    function Xbb(a, b, c) {
        var d;
        d = new Wbb;
        d.b = b;
        d.a = c;
        ++b.b;
        vU(a.d, d);
    }
    function fW(a, b, c) {
        !!a.d && BU(a.d.b, a);
        a.d = b;
        !!a.d && uU(a.d.b, c, a);
    }
    function Mnb(a, b, c) {
        Gxb(b, c, a.Y());
        this.c = a;
        this.a = b;
        this.b = c - b;
    }
    function vP(a, b, c, d) {
        sP(this);
        this.d = a;
        this.b = b;
        this.a = c;
        this.c = d;
    }
    function zr(a, b) {
        Bk.call(this, Fpb(_b(a), _b(b)));
        this.b = a;
        this.c = b;
    }
    function Fnb(a, b) {
        this.a = a;
        wnb.call(this, a);
        Fxb(b, a.Y());
        this.b = b;
    }
    function FJ(a, b, c, d) {
        wJ();
        EJ.call(this, a, b, c);
        d != null && (this.d = d);
    }
    function e5(a, b, c) {
        a.i = 0;
        a.e = 0;
        if (b == c) return;
        d5(a, b, c);
        c5(a, b, c);
    }
    function Rob(a) {
        Bxb(a.a < a.c.c.length);
        a.b = a.a++;
        return a.c.c[a.b];
    }
    function avb(a) {
        Bxb(a.b.b != a.d.a);
        a.c = a.b = a.b.b;
        --a.a;
        return a.c.c;
    }
    function gwb(a, b) {
        var c;
        c = 1 - b;
        a.a[c] = hwb(a.a[c], c);
        return hwb(a, b);
    }
    function S2(a) {
        var b;
        b = (Ieb(), Ieb(), heb);
        a.d && Z2(a);
        ni();
        return b;
    }
    function ZH(a) {
        var b;
        if (UH(a)) {
            b = a;
            return b == -0 ? 0 : b;
        }
        return Nv(a);
    }
    function Ii(a) {
        var b;
        b = (_b(a), new IU((Oh(), a)));
        Dpb(b);
        return Yi(b);
    }
    function Rl(a) {
        Il();
        var b;
        while(true){
            b = a.H();
            if (!a.G()) return b;
        }
    }
    function Yn(a) {
        Xn(a);
        Vm(a.c);
        a.e = a.a = a.c;
        a.c = a.c.b;
        ++a.d;
        return a.a;
    }
    function Zn(a) {
        Xn(a);
        Vm(a.e);
        a.c = a.a = a.e;
        a.e = a.e.d;
        --a.d;
        return a.a;
    }
    function Wf(a) {
        var b;
        b = a.Y();
        if (b == 0) return;
        a.d.Q();
        a.f.c -= b;
        $f(a);
    }
    function At(a, b, c) {
        var d;
        d = yt();
        try {
            return xt(a, b, c);
        } finally{
            Bt(d);
        }
    }
    function zt(b) {
        return function() {
            var a;
            return At(b, this, arguments);
        };
    }
    function sl(a) {
        if (aw(a, 19)) return Wv(a, 19).V();
        return !a.mb().G();
    }
    function gr(a) {
        Gi();
        this.a = (ypb(), aw(a, 63) ? new csb(a) : new Rqb(a));
    }
    function Mhb() {
        Mhb = iI;
        Khb = new Nhb(qzb, 0);
        Lhb = new Nhb('TOP_LEFT', 1);
    }
    function Lbb() {
        Lbb = iI;
        Jbb = new Mbb('DOWN', 0);
        Kbb = new Mbb('UP', 1);
    }
    function p9() {
        p9 = iI;
        o9 = new q9('LAYER_SWEEP', 0);
        n9 = new q9(zAb, 1);
    }
    function vab() {
        vab = iI;
        uab = new wab('UPPER', 0);
        tab = new wab('LOWER', 1);
    }
    function yxb(a) {
        if (a < 0) throw new Ulb('Negative array size: ' + a);
    }
    function hnb(a, b) {
        if (aw(b, 21)) return ee(a.a, Wv(b, 21));
        return false;
    }
    function Esb(a, b) {
        if (aw(b, 21)) return ee(a.a, Wv(b, 21));
        return false;
    }
    function Kub(a, b) {
        if (aw(b, 21)) return ee(a.a, Wv(b, 21));
        return false;
    }
    function IV(a) {
        var b;
        b = new hW;
        qJ(b, a);
        sJ(b, (eM(), CL), null);
        return b;
    }
    function je(a, b) {
        return b === a ? '(this Map)' : (bmb(), b == null ? Wxb : xb(b));
    }
    function Ld(a, b, c, d) {
        return aw(c, 63) ? new ug(a, b, c, d) : new mg(a, b, c, d);
    }
    function BM() {
        zM();
        return Bv(tv(Hz, 1), uyb, 100, 0, [
            yM,
            xM,
            uM,
            vM,
            wM
        ]);
    }
    function OM() {
        KM();
        return Bv(tv(Iz, 1), uyb, 28, 0, [
            JM,
            IM,
            HM,
            EM,
            GM,
            FM
        ]);
    }
    function kK() {
        iK();
        return Bv(tv(Az, 1), uyb, 103, 0, [
            cK,
            fK,
            gK,
            hK,
            dK,
            eK
        ]);
    }
    function $K() {
        YK();
        return Bv(tv(Ez, 1), uyb, 133, 0, [
            WK,
            UK,
            XK,
            SK,
            VK,
            TK
        ]);
    }
    function YM() {
        YM = iI;
        XM = Cc((UM(), Bv(tv(Jz, 1), uyb, 149, 0, [
            TM,
            SM,
            RM
        ])));
    }
    function iL() {
        iL = iI;
        hL = Cc((eL(), Bv(tv(Fz, 1), uyb, 166, 0, [
            cL,
            bL,
            dL
        ])));
    }
    function C8() {
        C8 = iI;
        B8 = Cc((x8(), Bv(tv(_D, 1), uyb, 173, 0, [
            w8,
            v8,
            u8
        ])));
    }
    function EX() {
        CX();
        return Bv(tv(pB, 1), uyb, 132, 0, [
            AX,
            zX,
            xX,
            BX,
            yX,
            wX
        ]);
    }
    function i4() {
        g4();
        return Bv(tv(jD, 1), uyb, 125, 0, [
            e4,
            b4,
            f4,
            d4,
            c4,
            a4
        ]);
    }
    function Vl(a) {
        Il();
        return umb(Gb((Oh(), Nh), umb(new zmb, 91), a), 93).a;
    }
    function Gpb(a, b) {
        ypb();
        var c;
        c = a.ob();
        ipb(c, 0, c.length, b);
        Cpb(a, c);
    }
    function G3(a, b, c, d, e) {
        this.c = a;
        this.e = b;
        this.d = c;
        this.b = d;
        this.a = e;
    }
    function Peb(a, b, c, d, e) {
        Ac.call(this, a, b);
        this.a = c;
        this.b = d;
        this.c = e;
    }
    function Ahb(a, b, c, d, e) {
        Ac.call(this, a, b);
        this.a = c;
        this.b = d;
        this.c = e;
    }
    function QT(a, b, c) {
        this.a = b;
        this.c = a;
        this.b = (_b(c), new IU((Oh(), c)));
    }
    function $U() {
        tU(this);
        this.b = new HI(Uzb, Uzb);
        this.a = new HI(Vzb, Vzb);
    }
    function X3() {
        X3 = iI;
        V3 = new Y3('QUADRATIC', 0);
        W3 = new Y3('SCANLINE', 1);
    }
    function Te() {
        throw new Imb('Add not supported on this collection');
    }
    function pq(a) {
        var b, c;
        c = qmb(a.Zb());
        b = a.Yb();
        return b == 1 ? c : c + ' x ' + b;
    }
    function _ub(a) {
        Bxb(a.b != a.d.c);
        a.c = a.b;
        a.b = a.b.a;
        ++a.a;
        return a.c.c;
    }
    function Ukb(a) {
        if (a.Tc()) return null;
        var b = a.k;
        var c = fI[b];
        return c;
    }
    function bc(a, b) {
        if (a < 0 || a > b) throw new okb(Vb(a, b, 'index'));
        return a;
    }
    function Zf(a, b) {
        var c;
        Yf(a);
        c = a.d.nb(b);
        if (c) {
            --a.f.c;
            $f(a);
        }
        return c;
    }
    function RT(a, b, c) {
        var d;
        d = (_b(a), new IU((Oh(), a)));
        PT(new QT(d, b, c));
    }
    function cmb(a, b) {
        return kmb((bmb(), a.toLowerCase()), b.toLowerCase());
    }
    function rmb(a, b) {
        return kmb((bmb(), a.toLowerCase()), b.toLowerCase());
    }
    function Jwb() {
        Fwb();
        return Bv(tv(DH, 1), uyb, 138, 0, [
            Bwb,
            Cwb,
            Dwb,
            Ewb
        ]);
    }
    function bxb(a, b, c, d) {
        Array.prototype.splice.apply(a, [
            b,
            c
        ].concat(d));
    }
    function TI(a, b, c, d) {
        var e;
        e = new mvb;
        e.c = b;
        e.b = c;
        e.a = d;
        d.b = c.a = e;
        ++a.b;
    }
    function Sm(a, b) {
        var c;
        c = Hpb(Bo(new mo(a, b)));
        Ml(new mo(a, b));
        return c;
    }
    function Su(d, a, b) {
        if (b) {
            var c = b.gc();
            d.a[a] = c(b);
        } else delete d.a[a];
    }
    function iu(d, a, b) {
        if (b) {
            var c = b.gc();
            b = c(b);
        } else b = undefined;
        d.a[a] = b;
    }
    function Dfb(a) {
        yfb(this);
        this.d = a.d;
        this.c = a.c;
        this.a = a.a;
        this.b = a.b;
    }
    function n7() {
        this.g = new q7;
        this.c = new q7;
        this.a = new GU;
        this.k = new GU;
    }
    function dR() {
        this.d = new OQ;
        this.a = new tV;
        this.c = new SV;
        this.b = new CV;
    }
    function oR() {
        this.i = new GU;
        this.g = new FI;
        this.n = new xS;
        this.q = new xS;
    }
    function _Y(a, b, c, d) {
        this.e = a;
        this.b = new GU;
        this.d = b;
        this.a = c;
        this.c = d;
    }
    function oT() {
        oT = iI;
        lT = new FT;
        mT = new HT;
        jT = new JT;
        kT = new LT;
        nT = new NT;
    }
    function DO() {
        DO = iI;
        BO = new EO(ozb, 0);
        AO = new EO(qzb, 1);
        CO = new EO(pzb, 2);
    }
    function IK() {
        IK = iI;
        HK = Cc((EK(), Bv(tv(Cz, 1), uyb, 107, 0, [
            DK,
            AK,
            BK,
            CK
        ])));
    }
    function RK() {
        RK = iI;
        QK = Cc((NK(), Bv(tv(Dz, 1), uyb, 122, 0, [
            MK,
            KK,
            JK,
            LK
        ])));
    }
    function QN() {
        QN = iI;
        PN = Cc((MN(), Bv(tv(Mz, 1), uyb, 139, 0, [
            KN,
            LN,
            JN,
            IN
        ])));
    }
    function HN() {
        HN = iI;
        GN = Cc((DN(), Bv(tv(Lz, 1), uyb, 150, 0, [
            BN,
            CN,
            AN,
            zN
        ])));
    }
    function pcb() {
        pcb = iI;
        ocb = Cc((lcb(), Bv(tv(JE, 1), uyb, 194, 0, [
            jcb,
            kcb
        ])));
    }
    function Qhb() {
        Qhb = iI;
        Phb = Cc((Mhb(), Bv(tv(pF, 1), uyb, 174, 0, [
            Khb,
            Lhb
        ])));
    }
    function Ao(a) {
        _b(a);
        return aw(a, 19) ? new IU((Oh(), Wv(a, 19))) : Bo(a.mb());
    }
    function yY(a) {
        return Ckb(Ixb(Xv(rJ(a, (Rib(), Vhb))))) && rJ(a, uib) != null;
    }
    function UY(a) {
        return Ckb(Ixb(Xv(rJ(a, (Rib(), Vhb))))) && rJ(a, uib) != null;
    }
    function jkb(a, b, c, d) {
        b == null && (b = Wxb);
        a.a += '' + (bmb(), b.substr(c, d - c));
    }
    function Mrb(a, b) {
        var c;
        for(c = 0; c < b; ++c)Av(a, c, new Xrb(Wv(a[c], 21)));
    }
    function Hd(a, b) {
        var c, d;
        c = Wv(sp(a.b, b), 19);
        if (c) {
            d = c.Y();
            c.Q();
            a.c -= d;
        }
    }
    function DU(a, b, c) {
        var d;
        d = (Cxb(b, a.c.length), a.c[b]);
        a.c[b] = c;
        return d;
    }
    function itb(a) {
        Bxb(a.a < a.c.a.length);
        a.b = a.a;
        gtb(a);
        return a.c.b[a.b];
    }
    function Ul(a) {
        Il();
        var b;
        b = 0;
        while(a.G()){
            a.H();
            b = PH(b, 1);
        }
        return $s(b);
    }
    function hub(a) {
        this.d = a;
        this.b = this.d.a.entries();
        this.a = this.b.next();
    }
    function DT(a) {
        this.g = a;
        this.f = new GU;
        this.a = Qlb(this.g.c.c, this.g.d.c);
    }
    function kt(a) {
        it();
        this.e = null;
        this.f = null;
        this.a = '';
        this.b = a;
        this.a = '';
    }
    function wub() {
        ntb.call(this);
        pub(this);
        this.b.b = this.b;
        this.b.a = this.b;
    }
    function Bt(a) {
        a && It((Gt(), Ft));
        --ut;
        if (a) {
            if (wt != -1) {
                Dt(wt);
                wt = -1;
            }
        }
    }
    function bW(a) {
        if (!a.c || !a.d) return false;
        return !!a.c.f && a.c.f == a.d.f;
    }
    function pt() {
        if (Date.now) return Date.now();
        return (new Date).getTime();
    }
    function lX(a) {
        if (a.c.c.length != 0) return Wv(yU(a.c, 0), 33).a;
        return null;
    }
    function OX(a) {
        if (a.c.c.length != 0) return Wv(yU(a.c, 0), 33).a;
        return null;
    }
    function qd(a) {
        a.d = 3;
        a.c = sm(a);
        if (a.d != 2) {
            a.d = 0;
            return true;
        }
        return false;
    }
    function bgb(a, b, c) {
        this.a = a;
        this.b = b;
        this.c = c;
        vU(a.j, this);
        vU(b.d, this);
    }
    function VP(a, b, c, d) {
        var e;
        a.c ? e = new Gu(hw(d)) : e = new Gu(d);
        Ru(b, c, e);
    }
    function Co(a) {
        var b, c;
        _b(a);
        b = xo(a.length);
        c = new HU(b);
        zpb(c, a);
        return c;
    }
    function Dv(a) {
        var b, c, d;
        b = a & azb;
        c = a >> 22 & azb;
        d = a < 0 ? bzb : 0;
        return Ev(b, c, d);
    }
    function nbb() {
        kbb();
        return Bv(tv(zE, 1), uyb, 141, 0, [
            jbb,
            gbb,
            hbb,
            fbb,
            ibb
        ]);
    }
    function Sgb() {
        Pgb();
        return Bv(tv(kF, 1), uyb, 115, 0, [
            Lgb,
            Kgb,
            Ngb,
            Mgb,
            Ogb
        ]);
    }
    function Zib() {
        Xib();
        return Bv(tv(qF, 1), uyb, 85, 0, [
            Wib,
            Sib,
            Tib,
            Uib,
            Vib
        ]);
    }
    function zK() {
        zK = iI;
        yK = Cc((sK(), Bv(tv(Bz, 1), uyb, 59, 0, [
            qK,
            pK,
            oK,
            nK,
            rK
        ])));
    }
    function yN() {
        yN = iI;
        xN = Cc((sN(), Bv(tv(Kz, 1), uyb, 32, 0, [
            qN,
            $M,
            ZM,
            pN,
            rN
        ])));
    }
    function DM() {
        DM = iI;
        CM = Cc((zM(), Bv(tv(Hz, 1), uyb, 100, 0, [
            yM,
            xM,
            uM,
            vM,
            wM
        ])));
    }
    function F9() {
        F9 = iI;
        E9 = PQ(UQ(UQ(UQ(TQ(new WQ, (d0(), N_)), U_), r_), B_), M_);
    }
    function TT(a, b) {
        var c, d;
        for(d = b.mb(); d.G();){
            c = Wv(d.H(), 55);
            ST(a, c, 0, 0);
        }
    }
    function VT(a, b, c) {
        var d, e;
        for(e = a.mb(); e.G();){
            d = Wv(e.H(), 55);
            UT(d, b, c);
        }
    }
    function X8(a, b, c) {
        var d, e;
        d = 0;
        for(e = 0; e < b.length; e++)d += a.Hc(b[e], d, c);
    }
    function AU(a, b) {
        var c;
        c = (Cxb(b, a.c.length), a.c[b]);
        hxb(a.c, b, 1);
        return c;
    }
    function Kl(a) {
        var b;
        _b(a);
        Yb(true);
        for(b = 0; b < 0 && Cm(a); b++)Dm(a);
        return b;
    }
    function Ymb(a) {
        var b;
        a.d = new Ntb(a);
        a.e = new fub(a);
        b = a[WAb] | 0;
        a[WAb] = b + 1;
    }
    function igb(a) {
        a.g = new vtb;
        a.o = new vtb;
        a.c = new vtb;
        a.j = new GU;
        a.d = new GU;
    }
    function Fxb(a, b) {
        if (a < 0 || a > b) throw new okb('Index: ' + a + ', Size: ' + b);
    }
    function Cxb(a, b) {
        if (a < 0 || a >= b) throw new okb('Index: ' + a + ', Size: ' + b);
    }
    function uob(a, b) {
        var c, d;
        c = b.yb();
        d = Wvb(a, c);
        return !!d && ovb(d.e, b.zb());
    }
    function zbb(a, b) {
        var c;
        c = a.d;
        if (b > 0) return Wv(yU(c.a, b - 1), 9);
        return null;
    }
    function xv(a, b, c, d, e, f) {
        var g;
        g = yv(e, d);
        e != 9 && Bv(tv(a, f), b, c, e, g);
        return g;
    }
    function pd(a) {
        var b;
        if (!od(a)) throw new nvb;
        a.d = 1;
        b = a.c;
        a.c = null;
        return b;
    }
    function _f(a, b, c, d) {
        this.f = a;
        this.e = b;
        this.d = c;
        this.b = d;
        this.c = !d ? null : d.d;
    }
    function MH(b, c) {
        if (b && typeof b == Sxb) try {
            b.__gwt$exception = c;
        } catch (a) {}
    }
    function wT(a, b) {
        if (a.a.$b(b.d, a.b) > 0) {
            vU(a.c, new WS(b.c, b.d, a.d));
            a.b = b.d;
        }
    }
    function W4(a, b) {
        var c;
        c = glb(a.j, b.j);
        if (c == 0) return glb(a.k, b.k);
        return c;
    }
    function C6(a) {
        var b, c;
        c = Wv(yU(a.f, 0), 7);
        b = Wv(rJ(c, (Rib(), uib)), 7);
        return b;
    }
    function M6(a) {
        var b, c;
        c = Wv(yU(a.f, 0), 7);
        b = Wv(rJ(c, (Rib(), uib)), 7);
        return b;
    }
    function B$(a, b) {
        return glb(Ixb(Yv(rJ(a, (Rib(), Cib)))), Ixb(Yv(rJ(b, Cib))));
    }
    function Ujb() {
        Ujb = iI;
        Tjb = Cc((Qjb(), Bv(tv(sF, 1), uyb, 153, 0, [
            Njb,
            Pjb,
            Ojb
        ])));
    }
    function gkb() {
        gkb = iI;
        fkb = Cc((ckb(), Bv(tv(uF, 1), uyb, 172, 0, [
            _jb,
            akb,
            bkb
        ])));
    }
    function mK() {
        mK = iI;
        lK = Cc((iK(), Bv(tv(Az, 1), uyb, 103, 0, [
            cK,
            fK,
            gK,
            hK,
            dK,
            eK
        ])));
    }
    function aL() {
        aL = iI;
        _K = Cc((YK(), Bv(tv(Ez, 1), uyb, 133, 0, [
            WK,
            UK,
            XK,
            SK,
            VK,
            TK
        ])));
    }
    function QM() {
        QM = iI;
        PM = Cc((KM(), Bv(tv(Iz, 1), uyb, 28, 0, [
            JM,
            IM,
            HM,
            EM,
            GM,
            FM
        ])));
    }
    function k4() {
        k4 = iI;
        j4 = Cc((g4(), Bv(tv(jD, 1), uyb, 125, 0, [
            e4,
            b4,
            f4,
            d4,
            c4,
            a4
        ])));
    }
    function K1() {
        I1();
        return Bv(tv(GC, 1), uyb, 109, 0, [
            G1,
            B1,
            E1,
            C1,
            D1,
            A1,
            F1,
            H1
        ]);
    }
    function qM() {
        oM();
        return Bv(tv(Gz, 1), uyb, 41, 0, [
            gM,
            fM,
            iM,
            nM,
            mM,
            lM,
            jM,
            kM,
            hM
        ]);
    }
    function Bgb() {
        zgb();
        return Bv(tv(iF, 1), uyb, 123, 0, [
            ygb,
            xgb,
            wgb,
            ugb,
            tgb,
            vgb
        ]);
    }
    function bhb() {
        _gb();
        return Bv(tv(lF, 1), uyb, 124, 0, [
            Ygb,
            Xgb,
            $gb,
            Wgb,
            Zgb,
            Vgb
        ]);
    }
    function bK() {
        bK = iI;
        aK = new DJ('de.cau.cs.kieler.labels.labelManager', null);
    }
    function ixb() {
        if (Date.now) return Date.now();
        return (new Date).getTime();
    }
    function Xsb(a) {
        var b;
        b = Wv(cxb(a.b, a.b.length), 11);
        return new atb(a.a, b, a.c);
    }
    function dmb(a, b) {
        var c;
        c = (bmb(), b.length);
        return emb(imb(a, a.length - c, c), b);
    }
    function dwb(a, b) {
        var c;
        c = new zwb;
        c.c = true;
        c.d = b.zb();
        return ewb(a, b.yb(), c);
    }
    function He(a, b) {
        var c;
        c = b.yb();
        return mp(), new Fk(c, Kd(a.b, c, Wv(b.zb(), 19)));
    }
    function BU(a, b) {
        var c;
        c = zU(a, b, 0);
        if (c == -1) return false;
        a.vb(c);
        return true;
    }
    function Cv(a, b) {
        uv(b) != 9 && Bv(tb(b), b._c, b.__elementTypeId$, uv(b), a);
        return a;
    }
    function Rub(a) {
        ksb(a.c.a.c, a);
        Bxb(a.b != a.c.a.b);
        a.a = a.b;
        a.b = a.b.a;
        return a.a;
    }
    function qnb(a) {
        uxb(!!a.c);
        ksb(a.e, a);
        a.c.I();
        a.c = null;
        a.b = onb(a);
        lsb(a.e, a);
    }
    function Acb(a, b, c) {
        a.a = b;
        a.c = c;
        a.b.a.Q();
        _I(a.d);
        a.e.a.c = xv(UF, syb, 1, 0, 4, 1);
    }
    function Ar(a, b, c) {
        Bk.call(this, Fpb(_b(a), _b(b)));
        this.b = a;
        this.c = b;
        this.a = c;
    }
    function j9(a, b, c, d) {
        this.b = new l9(this);
        this.a = a;
        this.c = b;
        this.e = c;
        this.d = d;
    }
    function xub(a) {
        $mb.call(this, a, 0);
        pub(this);
        this.b.b = this.b;
        this.b.a = this.b;
    }
    function ywb(a, b) {
        qob.call(this, a, b);
        this.a = xv(yH, syb, 183, 2, 0, 1);
        this.b = true;
    }
    function Qmb(a, b) {
        return ew(b) ? b == null ? !!Ktb(a.d, null) : bub(a.e, b) : !!Ktb(a.d, b);
    }
    function RR(a, b) {
        return Ws(), (a - b > 0 ? a - b : -(a - b)) <= $yb || a == b || isNaN(a) && isNaN(b);
    }
    function Xs(a, b) {
        Ws();
        return (a - b > 0 ? a - b : -(a - b)) <= $yb || a == b || isNaN(a) && isNaN(b);
    }
    function Z5(a) {
        var b, c;
        b = true;
        do {
            b ? c = W5(a) : c = U5(a);
            b = !b;
        }while (c);
        S5(a, a.d);
    }
    function Ru(a, b, c) {
        var d;
        if (b == null) throw new Vlb;
        d = Pu(a, b);
        Su(a, b, c);
        return d;
    }
    function sJ(a, b, c) {
        !a.n && (a.n = new ntb);
        c == null ? Wmb(a.n, b) : Umb(a.n, b, c);
        return a;
    }
    function zU(a, b, c) {
        for(; c < a.c.length; ++c){
            if (ovb(b, a.c[c])) return c;
        }
        return -1;
    }
    function b2(a, b) {
        while(b >= a.a.c.length)vU(a.a, new aJ);
        return Wv(yU(a.a, b), 20);
    }
    function Fe(a, b) {
        var c;
        c = Wv(rp(a.a, b), 19);
        if (!c) return null;
        return Kd(a.b, b, c);
    }
    function XP(a, b, c) {
        var d;
        d = Pu(a, Gzb);
        if (!d) {
            d = new Tu;
            Ru(a, Gzb, d);
        }
        Ru(d.kc(), b, c);
    }
    function Okb(a, b, c, d, e) {
        var f;
        f = Mkb(a, b);
        $kb(c, f);
        f.g = e ? 8 : 0;
        f.f = d;
        f.e = e;
        return f;
    }
    function mo(a, b) {
        var c;
        this.f = a;
        this.b = b;
        c = Wv(Smb(a.b, b), 126);
        this.c = !c ? null : c.b;
    }
    function fJ(a, b) {
        var c, d, e;
        for(d = 0, e = b.length; d < e; ++d){
            c = b[d];
            TI(a, c, a.c.b, a.c);
        }
    }
    function GV(a, b, c, d, e, f) {
        var g;
        g = IV(d);
        dW(g, e);
        eW(g, f);
        Fd(a.a, d, new XV(g, b, c.f));
    }
    function bab(a, b, c) {
        var d;
        d = 0;
        a.c[c] > 0 && (d += dab(b));
        a.b[c] && (d += eab(b));
        return d;
    }
    function vub(a, b) {
        var c;
        c = Wv(Wmb(a.c, b), 176);
        if (c) {
            Hub(c);
            return c.e;
        }
        return null;
    }
    function $s(a) {
        if (RH(a, $xb) > 0) return $xb;
        if (RH(a, eyb) < 0) return eyb;
        return _H(a);
    }
    function Ph(a) {
        Oh();
        Mh(a, 'size');
        return _H(VH(WH(a, 8), Nyb) ? WH(a, 8) : Nyb), new Amb;
    }
    function ukb(a) {
        skb.call(this, (bmb(), a == null ? Wxb : xb(a)), aw(a, 46) ? Wv(a, 46) : null);
    }
    function HU(a) {
        tU(this);
        wxb(a >= 0, 'Initial capacity must not be negative');
    }
    function JQ() {
        JQ = iI;
        HQ = VQ(UQ(UQ(new WQ, (d0(), O_)), C_), J_);
        IQ = TQ(new WQ, G_);
    }
    function LX() {
        LX = iI;
        IX = new UX;
        GX = new XX;
        HX = new ZX;
        FX = new _X;
        JX = new bY;
        KX = new dY;
    }
    function Fwb() {
        Fwb = iI;
        Bwb = new Gwb('All', 0);
        Cwb = new Kwb;
        Dwb = new Mwb;
        Ewb = new Pwb;
    }
    function x8() {
        x8 = iI;
        w8 = new y8(DAb, 0);
        v8 = new y8('LONGEST_PATH', 1);
        u8 = new y8(zAb, 2);
    }
    function Rv() {
        Rv = iI;
        Ov = Ev(azb, azb, 524287);
        Pv = Ev(0, 0, 524288);
        Dv(1);
        Dv(2);
        Qv = Dv(0);
    }
    function M1() {
        M1 = iI;
        L1 = Cc((I1(), Bv(tv(GC, 1), uyb, 109, 0, [
            G1,
            B1,
            E1,
            C1,
            D1,
            A1,
            F1,
            H1
        ])));
    }
    function pbb() {
        pbb = iI;
        obb = Cc((kbb(), Bv(tv(zE, 1), uyb, 141, 0, [
            jbb,
            gbb,
            hbb,
            fbb,
            ibb
        ])));
    }
    function Ugb() {
        Ugb = iI;
        Tgb = Cc((Pgb(), Bv(tv(kF, 1), uyb, 115, 0, [
            Lgb,
            Kgb,
            Ngb,
            Mgb,
            Ogb
        ])));
    }
    function _ib() {
        _ib = iI;
        $ib = Cc((Xib(), Bv(tv(qF, 1), uyb, 85, 0, [
            Wib,
            Sib,
            Tib,
            Uib,
            Vib
        ])));
    }
    function zvb(a) {
        tvb();
        xvb(this, _H(QH(SH(Lv(UH(a) ? YH(a) : a, 24)), bBb)), _H(QH(a, bBb)));
    }
    function tb(a) {
        return ew(a) ? $F : cw(a) ? HF : bw(a) ? EF : _v(a) ? a.$c : zv(a) ? a.$c : a.$c || $y;
    }
    function uv(a) {
        return a.__elementTypeCategory$ == null ? 9 : a.__elementTypeCategory$;
    }
    function Ht(a) {
        var b, c;
        if (a.a) {
            c = null;
            do {
                b = a.a;
                a.a = null;
                c = Lt(b, c);
            }while (a.a);
            a.a = c;
        }
    }
    function It(a) {
        var b, c;
        if (a.b) {
            c = null;
            do {
                b = a.b;
                a.b = null;
                c = Lt(b, c);
            }while (a.b);
            a.b = c;
        }
    }
    function oJ(a) {
        nJ();
        var b, c;
        c = jzb;
        for(b = 0; b < a.length; b++)a[b] > c && (c = a[b]);
        return c;
    }
    function KQ(a, b) {
        var c;
        c = Wv(Smb(a.b, b), 106);
        if (!c) {
            c = b.rc();
            Umb(a.b, b, c);
        }
        return c;
    }
    function rub(a, b) {
        var c;
        c = Wv(Smb(a.c, b), 176);
        if (c) {
            uub(a, c);
            return c.e;
        }
        return null;
    }
    function R2(a, b, c, d) {
        var e;
        e = Wv(rub(a.e, b), 116);
        e.b += c;
        e.a += d;
        tub(a.e, b, e);
        a.d = true;
    }
    function gtb(a) {
        var b;
        ++a.a;
        for(b = a.c.a.length; a.a < b; ++a.a){
            if (a.c.b[a.a]) return;
        }
    }
    function bt(a) {
        var b, c, d;
        for(b = (a.g == null && (a.g = Pt(a)), a.g), c = 0, d = b.length; c < d; ++c);
    }
    function Tf(a, b) {
        var c, d;
        Yf(a);
        d = a.d.V();
        c = a.d.ib(b);
        if (c) {
            ++a.f.c;
            d && Vf(a);
        }
        return c;
    }
    function Mh(a, b) {
        if (a < 0) throw new slb(b + ' cannot be negative but was: ' + a);
        return a;
    }
    function Yb(a) {
        if (!a) throw new slb((bmb(), 'numberToAdvance must be nonnegative'));
    }
    function nm(a) {
        if (!a.a.G()) {
            a.a = a.b.mb();
            if (!a.a.G()) throw new nvb;
        }
        return a.a.H();
    }
    function Xl(a) {
        Il();
        var b;
        _b(a);
        if (aw(a, 108)) {
            b = Wv(a, 108);
            return b;
        }
        return new km(a);
    }
    function gu(d, a) {
        var b = d.a[a];
        var c = (ev(), dv)[typeof b];
        return c ? c(b) : kv(typeof b);
    }
    function K2(a, b) {
        var c, d;
        for(d = new Tob(a); d.a < d.c.c.length;){
            c = Wv(Rob(d), 7);
            J2(c, b);
        }
    }
    function Z9(a, b) {
        var c, d, e, f;
        for(d = a.d, e = 0, f = d.length; e < f; ++e){
            c = d[e];
            W9(a.g, c).a = b;
        }
    }
    function hR(a, b) {
        var c;
        c = EI(xI(Wv(Smb(a.g, b), 10)), RN(Wv(Smb(a.f, b), 198).b));
        return c;
    }
    function sr(a) {
        var b;
        return !od(Pl((b = new Snb(a.b.a).a.bb().mb(), new Ynb(b)), a.a));
    }
    function bvb(a) {
        var b;
        uxb(!!a.c);
        b = a.c.a;
        $I(a.d, a.c);
        a.b == a.c ? a.b = b : --a.a;
        a.c = null;
    }
    function gW(a) {
        return !!a.c && !!a.d ? a.c.f + '(' + a.c + ')->' + a.d.f + '(' + a.d + ')' : 'e_' + txb(a);
    }
    function gT(a, b) {
        cT();
        return a == $S && b == bT || a == bT && b == $S || a == aT && b == _S || a == _S && b == aT;
    }
    function hT(a, b) {
        cT();
        return a == $S && b == _S || a == $S && b == aT || a == bT && b == aT || a == bT && b == _S;
    }
    function Bhb() {
        zhb();
        return Bv(tv(nF, 1), uyb, 110, 0, [
            shb,
            whb,
            thb,
            xhb,
            uhb,
            yhb,
            vhb,
            rhb
        ]);
    }
    function sM() {
        sM = iI;
        rM = Cc((oM(), Bv(tv(Gz, 1), uyb, 41, 0, [
            gM,
            fM,
            iM,
            nM,
            mM,
            lM,
            jM,
            kM,
            hM
        ])));
    }
    function UM() {
        UM = iI;
        TM = new VM('OUTSIDE', 0);
        SM = new VM('INSIDE', 1);
        RM = new VM('FIXED', 2);
    }
    function Hhb() {
        Hhb = iI;
        Fhb = new Ihb(tzb, 0);
        Ghb = new Ihb('TOP', 1);
        Ehb = new Ihb('BOTTOM', 2);
    }
    function mxb() {
        mxb = iI;
        lxb = new qxb;
        kxb = new oxb('ISO-LATIN-1');
        jxb = new oxb('ISO-8859-1');
    }
    function lcb() {
        lcb = iI;
        jcb = new mcb('CLASSIC', 0);
        kcb = new mcb('IMPROVE_STRAIGHTNESS', 1);
    }
    function kW() {
        this.e = new FI;
        this.a = new $W;
        this.d = new FI;
        this.b = new GU;
        this.c = new GU;
    }
    function kdb(a, b, c) {
        this.b = b;
        this.a = a;
        this.c = c;
        vU(this.a.e, this);
        vU(this.b.b, this);
    }
    function Afb(a, b) {
        a.d = Qlb(a.d, b.d);
        a.c = Nlb(a.c, b.c);
        a.a = Nlb(a.a, b.a);
        a.b = Qlb(a.b, b.b);
    }
    function $I(a, b) {
        var c;
        c = b.c;
        b.a.b = b.b;
        b.b.a = b.a;
        b.a = b.b = null;
        b.c = null;
        --a.b;
        return c;
    }
    function Jl(a, b) {
        Il();
        var c;
        _b(a);
        _b(b);
        c = false;
        while(b.G())c = c | a.ib(b.H());
        return c;
    }
    function pnb(a) {
        var b;
        ksb(a.e, a);
        Bxb(a.b);
        a.c = a.a;
        b = Wv(a.a.H(), 21);
        a.b = onb(a);
        return b;
    }
    function sm(a) {
        var b;
        while(a.b.G()){
            b = a.b.H();
            if (a.a.D(b)) return b;
        }
        return a.d = 2, null;
    }
    function _sb(a, b) {
        if (!!b && a.b[b.e] == b) {
            Av(a.b, b.e, null);
            --a.c;
            return true;
        }
        return false;
    }
    function TH(a) {
        if (ezb < a && a < dzb) return a < 0 ? Math.ceil(a) : Math.floor(a);
        return SH(Jv(a));
    }
    function rl(a) {
        if (a) {
            if (a.V()) throw new nvb;
            return a.sb(a.Y() - 1);
        }
        return Rl(null.mb());
    }
    function ybb(a, b) {
        var c;
        c = a.d;
        if (b < c.a.c.length - 1) return Wv(yU(c.a, b + 1), 9);
        return null;
    }
    function $kb(a, b) {
        var c;
        if (!a) return;
        b.k = a;
        var d = Ukb(b);
        if (!d) {
            fI[a] = [
                b
            ];
            return;
        }
        d.$c = b;
    }
    function O5(a, b) {
        var c, d;
        d = false;
        do {
            a.i ? c = V5(a, b) : c = X5(a, b);
            d = d | c;
        }while (c);
        return d;
    }
    function Bbb(a, b, c) {
        var d, e;
        d = b;
        do {
            e = Ixb(a.n[d.k]) + c;
            a.n[d.k] = e;
            d = a.a[d.k];
        }while (d != b);
    }
    function M4(a) {
        var b, c;
        for(c = new Tob(a.a.b); c.a < c.c.c.length;){
            b = Wv(Rob(c), 25);
            b.vc();
        }
    }
    function bI() {
        cI();
        var a = aI;
        for(var b = 0; b < arguments.length; b++)a.push(arguments[b]);
    }
    function dn(a, b) {
        var c, d;
        for(c = 0, d = a.Y(); c < d; ++c){
            if (ovb(b, a.sb(c))) return c;
        }
        return -1;
    }
    function or(a, b) {
        var c;
        ac(a, 'set1');
        ac(b, 'set2');
        c = (hc(), new nc(b));
        return new tr(a, c, b);
    }
    function Rt(a) {
        var b = /function(?:\s+([\w$]+))?\s*\(/;
        var c = b.exec(a);
        return c && c[1] || Xxb;
    }
    function YQ(a, b, c) {
        nI(c, Tzb, 3);
        NV(a.c, b, rI(c, 1));
        aR(a, b, rI(c, 1));
        BV(b, rI(c, 1));
        pI(c);
    }
    function Dgb() {
        Dgb = iI;
        Cgb = Cc((zgb(), Bv(tv(iF, 1), uyb, 123, 0, [
            ygb,
            xgb,
            wgb,
            ugb,
            tgb,
            vgb
        ])));
    }
    function dhb() {
        dhb = iI;
        chb = Cc((_gb(), Bv(tv(lF, 1), uyb, 124, 0, [
            Ygb,
            Xgb,
            $gb,
            Wgb,
            Zgb,
            Vgb
        ])));
    }
    function Ilb() {
        Ilb = iI;
        Hlb = Bv(tv(mw, 1), Yyb, 26, 12, [
            0,
            8,
            4,
            12,
            2,
            10,
            6,
            14,
            1,
            9,
            5,
            13,
            3,
            11,
            7,
            15
        ]);
    }
    function djb() {
        djb = iI;
        cjb = new ejb(szb, 0);
        ajb = new ejb('INPUT', 1);
        bjb = new ejb('OUTPUT', 2);
    }
    function de(a) {
        this.c = a;
        this.b = new rnb(new inb(a.b).a);
        this.a = null;
        this.d = (Il(), Il(), Hl);
    }
    function Nn(a) {
        this.e = a;
        this.d = new wtb(op(ud(this.e).Y()));
        this.c = this.e.a;
        this.b = this.e.c;
    }
    function qR(a, b, c) {
        this.c = a;
        oR.call(this);
        this.b = b;
        this.j = new VN(b.d, b.e, b.c, b.b);
        this.a = c;
    }
    function qI(a, b) {
        if (a.j > 0 && a.c < a.j) {
            a.c += b;
            !!a.g && a.g.d > 0 && a.e != 0 && qI(a.g, b / a.j * a.g.d);
        }
    }
    function WV(a) {
        if (a.b.d.f.g == (CX(), xX)) return Wv(rJ(a.b.d.f, (Rib(), uib)), 7);
        return a.b.d;
    }
    function VV(a) {
        if (a.b.c.f.g == (CX(), xX)) return Wv(rJ(a.b.c.f, (Rib(), uib)), 7);
        return a.b.c;
    }
    function od(a) {
        dc(a.d != 3);
        switch(a.d){
            case 2:
                return false;
            case 0:
                return true;
        }
        return qd(a);
    }
    function CZ(a) {
        switch(a.e){
            case 2:
                return sN(), rN;
            case 4:
                return sN(), ZM;
            default:
                return a;
        }
    }
    function DZ(a) {
        switch(a.e){
            case 1:
                return sN(), pN;
            case 3:
                return sN(), $M;
            default:
                return a;
        }
    }
    function Km(a) {
        var b;
        if (aw(a, 90)) {
            b = Wv(a, 90);
            return new Lm(b.a);
        } else return Il(), new dm(a);
    }
    function Fpb(a, b) {
        ypb();
        var c;
        c = new otb(1);
        ew(a) ? Vmb(c, a, b) : Ltb(c.d, a, b);
        return new mrb(c);
    }
    function Is(a, b) {
        if (!a.g) return a.e;
        else {
            a.g = Is(a.g, b);
            --a.a;
            a.j = XH(a.j, b.c);
            return Gs(a);
        }
    }
    function Js(a, b) {
        if (!a.e) return a.g;
        else {
            a.e = Js(a.e, b);
            --a.a;
            a.j = XH(a.j, b.c);
            return Gs(a);
        }
    }
    function Ue(a, b) {
        var c, d, e;
        Dxb(b);
        c = false;
        for(e = b.mb(); e.G();){
            d = e.H();
            c = c | a.ib(d);
        }
        return c;
    }
    function nr(a) {
        var b, c, d;
        b = 0;
        for(d = a.mb(); d.G();){
            c = d.H();
            b += c != null ? vb(c) : 0;
            b = ~~b;
        }
        return b;
    }
    function BY(a) {
        var b, c, d, e;
        for(c = a.a, d = 0, e = c.length; d < e; ++d){
            b = c[d];
            b.B(null);
        }
        return null;
    }
    function Xeb(a) {
        var b, c, d;
        d = new jJ;
        for(c = a.b.mb(); c.G();){
            b = Wv(c.H(), 92);
            QI(d, b.a);
        }
        return d;
    }
    function mfb(a) {
        var b, c, d;
        b = 0;
        for(d = a.mb(); d.G();){
            c = Yv(d.H());
            b += (Dxb(c), c);
        }
        return b / a.Y();
    }
    function Rbb(a, b) {
        var c;
        c = Wv(Smb(a.c, b), 200);
        if (!c) {
            c = new Ybb;
            c.c = b;
            Umb(a.c, c.c, c);
        }
        return c;
    }
    function Wsb(a, b) {
        var c;
        Dxb(b);
        c = b.e;
        if (!a.b[c]) {
            Av(a.b, c, b);
            ++a.c;
            return true;
        }
        return false;
    }
    function hwb(a, b) {
        var c, d;
        c = 1 - b;
        d = a.a[c];
        a.a[c] = d.a[b];
        d.a[b] = a;
        a.b = true;
        d.b = false;
        return d;
    }
    function yI(a, b) {
        var c;
        if (aw(b, 10)) {
            c = Wv(b, 10);
            return a.a == c.a && a.b == c.b;
        } else return false;
    }
    function Bs(a, b, c) {
        a.g = new Os(b, c);
        es(a, a.g, a.i);
        a.d = Plb(2, a.d);
        ++a.a;
        a.j = PH(a.j, c);
        return a;
    }
    function As(a, b, c) {
        a.e = new Os(b, c);
        es(a.f, a.e, a);
        a.d = Plb(2, a.d);
        ++a.a;
        a.j = PH(a.j, c);
        return a;
    }
    function Nu(e, a) {
        var b = e.a;
        var c = 0;
        for(var d in b)b.hasOwnProperty(d) && (a[c++] = d);
        return a;
    }
    function he(a, b) {
        var c, d;
        Dxb(b);
        for(d = b.bb().mb(); d.G();){
            c = Wv(d.H(), 21);
            a.db(c.yb(), c.zb());
        }
    }
    function vcb(a, b, c) {
        var d;
        d = a.a.e[Wv(b.a, 9).k] - a.a.e[Wv(c.a, 9).k];
        return hw(d > 0 ? 1 : d < 0 ? -1 : 0);
    }
    function r5(a, b, c) {
        this.g = a;
        this.d = b;
        this.e = c;
        this.a = new GU;
        p5(this);
        ypb();
        Gpb(this.a, null);
    }
    function Os(a, b) {
        Xb(b > 0);
        this.b = a;
        this.c = b;
        this.j = b;
        this.a = 1;
        this.d = 1;
        this.e = null;
        this.g = null;
    }
    function qcb(a) {
        a.a = null;
        a.e = null;
        a.b.c = xv(UF, syb, 1, 0, 4, 1);
        a.f.c = xv(UF, syb, 1, 0, 4, 1);
        a.c = null;
    }
    function qhb() {
        ohb();
        return Bv(tv(mF, 1), uyb, 113, 0, [
            fhb,
            hhb,
            ihb,
            jhb,
            khb,
            lhb,
            nhb,
            ehb,
            ghb,
            mhb
        ]);
    }
    function uvb(a) {
        return wvb(a, 26) * 1.4901161193847656E-8 + wvb(a, 27) * 1.1102230246251565E-16;
    }
    function Fo(a) {
        return aw(a, 87) ? Ii(Wv(a, 87)) : aw(a, 88) ? Wv(a, 88).a : aw(a, 63) ? new ap(a) : new Ro(a);
    }
    function Udb(a) {
        var b;
        b = Wv(rJ(a, (Rib(), hib)), 32);
        return a.g == (CX(), xX) && (b == (sN(), rN) || b == ZM);
    }
    function YT(a, b) {
        if (ZT(a, b)) {
            Fd(a.a, Wv(rJ(b, (Rib(), fib)), 18), b);
            return true;
        } else return false;
    }
    function QQ(a, b) {
        var c;
        if (b) for(c = 0; c < 6; c++)Wv(yU(a.a, c), 18).jb(Wv(yU(b.a, c), 19));
        return a;
    }
    function rI(a, b) {
        var c;
        if (a.b) return null;
        else {
            c = oI(a.e, a.f);
            QI(a.a, c);
            c.g = a;
            a.d = b;
            return c;
        }
    }
    function hJ(a, b) {
        var c, d;
        for(d = WI(a, 0); d.b != d.d.c;){
            c = Wv(_ub(d), 10);
            c.a += b.a;
            c.b += b.b;
        }
        return a;
    }
    function J9(a, b) {
        var c, d;
        for(c = 0; c < b.length; c++)for(d = 0; d < b[c].length; d++)b[c][d] = a[c][d];
    }
    function P2(a) {
        var b, c;
        for(c = new Tob(a.b.f); c.a < c.c.c.length;){
            b = Wv(Rob(c), 7);
            Y2(a.a, Reb(b.g));
        }
    }
    function cT() {
        cT = iI;
        $S = new fT('Q1', 0);
        bT = new fT('Q4', 1);
        _S = new fT('Q2', 2);
        aT = new fT('Q3', 3);
    }
    function EK() {
        EK = iI;
        DK = new FK(szb, 0);
        AK = new FK(qzb, 1);
        BK = new FK('HEAD', 2);
        CK = new FK('TAIL', 3);
    }
    function ckb() {
        ckb = iI;
        _jb = new dkb('AGGRESSIVE', 0);
        akb = new dkb('CAREFUL', 1);
        bkb = new dkb('OFF', 2);
    }
    function Dhb() {
        Dhb = iI;
        Chb = Cc((zhb(), Bv(tv(nF, 1), uyb, 110, 0, [
            shb,
            whb,
            thb,
            xhb,
            uhb,
            yhb,
            vhb,
            rhb
        ])));
    }
    function Akb(a, b) {
        xkb();
        return ew(a) ? kmb(a, $v(b)) : cw(a) ? flb(a, Yv(b)) : bw(a) ? ykb(a, Xv(b)) : a.F(b);
    }
    function Es(a, b, c) {
        var d;
        d = b.$b(c, a.b);
        return d < 0 ? !a.e ? 0 : Es(a.e, b, c) : d > 0 ? !a.g ? 0 : Es(a.g, b, c) : a.c;
    }
    function rk(a, b) {
        var c, d;
        if (!a.b) return false;
        d = a.e;
        c = a.a.$b(b, d);
        return c < 0 | c == 0 & a.d == (Gh(), Fh);
    }
    function qk(a, b) {
        var c, d;
        if (!a.c) return false;
        d = a.g;
        c = a.a.$b(b, d);
        return c > 0 | c == 0 & a.f == (Gh(), Fh);
    }
    function SH(a) {
        var b;
        b = a.h;
        if (b == 0) return a.l + a.m * czb;
        if (b == bzb) return a.l + a.m * czb - dzb;
        return a;
    }
    function MI(a) {
        var b, c, d, e;
        b = new FI;
        for(d = 0, e = a.length; d < e; ++d){
            c = a[d];
            b.a += c.a;
            b.b += c.b;
        }
        return b;
    }
    function J6(a) {
        var b, c, d, e;
        for(c = a.a, d = 0, e = c.length; d < e; ++d){
            b = c[d];
            Q6(a, b, (sN(), pN));
            Q6(a, b, $M);
        }
    }
    function zo(a) {
        var b, c, d;
        b = 1;
        for(d = a.mb(); d.G();){
            c = d.H();
            b = 31 * b + (c == null ? 0 : vb(c));
            b = ~~b;
        }
        return b;
    }
    function Tsb(a) {
        var b, c;
        b = Wv(a.e && a.e(), 11);
        c = Wv(cxb(b, b.length), 11);
        return new atb(b, c, b.length);
    }
    function R6(a) {
        this.e = gw(rJ(hX(a[0]), (eM(), uL))) === gw((NK(), JK));
        this.a = a;
        this.c = new ntb;
        J6(this);
    }
    function kR(a) {
        fR();
        this.g = (mp(), new ntb);
        this.f = new ntb;
        this.b = new ntb;
        this.c = new xk;
        this.i = a;
    }
    function odb(a) {
        this.o = a;
        this.g = new GU;
        this.j = new aJ;
        this.n = new aJ;
        this.e = new GU;
        this.b = new GU;
    }
    function OR(a, b) {
        stb(a.a, b);
        if (b.f) throw new gt('CNode belongs to another CGroup.');
        b.f = a;
    }
    function eI(a, b) {
        typeof window === Sxb && typeof window['$gwt'] === Sxb && (window['$gwt'][a] = b);
    }
    function K5(a, b, c, d) {
        var e, f;
        e = I5(a, b, c, d);
        e < 0 && (e = -e - 1);
        for(f = c - 1; f >= e; f--)a[f + 1] = a[f];
        a[e] = d;
    }
    function kab(a, b, c, d) {
        var e, f;
        e = jab(a, b, c, d);
        e < 0 && (e = -e - 1);
        for(f = c - 1; f >= e; f--)a[f + 1] = a[f];
        a[e] = d;
    }
    function Xe(a, b) {
        var c, d;
        Dxb(b);
        for(d = b.mb(); d.G();){
            c = d.H();
            if (!a.kb(c)) return false;
        }
        return true;
    }
    function Ll(a, b) {
        Il();
        var c;
        _b(b);
        while(a.G()){
            c = a.H();
            if (!Udb(Wv(c, 9))) return false;
        }
        return true;
    }
    function wV(a, b) {
        var c, d, e;
        c = b.k - a.k;
        if (c == 0) {
            d = a.e.a * a.e.b;
            e = b.e.a * b.e.b;
            return glb(d, e);
        }
        return c;
    }
    function YH(a) {
        var b, c, d, e;
        e = a;
        d = 0;
        if (e < 0) {
            e += dzb;
            d = bzb;
        }
        c = hw(e / czb);
        b = hw(e - c * czb);
        return Ev(b, c, d);
    }
    function n6(a, b) {
        a.c.c = xv(UF, syb, 1, 0, 4, 1);
        o6(a, a.e, b);
        o6(a, a.a, b);
        ypb();
        Gpb(a.c, null);
        return p6(a);
    }
    function c5(a, b, c) {
        a.g = i5(a, b, (sN(), ZM), a.b);
        a.d = i5(a, c, ZM, a.b);
        if (a.g.c == 0 || a.d.c == 0) return;
        f5(a);
    }
    function d5(a, b, c) {
        a.g = i5(a, b, (sN(), rN), a.j);
        a.d = i5(a, c, rN, a.j);
        if (a.g.c == 0 || a.d.c == 0) return;
        f5(a);
    }
    function pU(a, b, c) {
        return new VN(Qlb(a.a, b.a) - c / 2, Qlb(a.b, b.b) - c / 2, Jlb(a.a - b.a) + c, Jlb(a.b - b.b) + c);
    }
    function onb(a) {
        if (a.a.G()) return true;
        if (a.a != a.d) return false;
        a.a = new Ptb(a.e.d);
        return a.a.G();
    }
    function xU(a, b) {
        var c, d;
        c = b.ob();
        d = c.length;
        if (d == 0) return false;
        gxb(a.c, a.c.length, c);
        return true;
    }
    function S5(a, b) {
        var c, d;
        for(c = 0; c < a.a.length; c++)for(d = 0; d < a.a[c].length; d++)a.a[c][d] = b[c][d];
    }
    function zpb(a, b) {
        ypb();
        var c, d, e, f;
        f = false;
        for(d = 0, e = b.length; d < e; ++d){
            c = b[d];
            f = f | a.ib(c);
        }
        return f;
    }
    function op(a) {
        mp();
        if (a < 3) {
            Mh(a, 'expectedSize');
            return a + 1;
        }
        if (a < Nyb) return hw(a / 0.75 + 1);
        return $xb;
    }
    function ml(a, b) {
        var c;
        if (aw(b, 19)) {
            c = (Oh(), Wv(b, 19));
            return a.jb(c);
        }
        return Jl(a, Wv(_b(b), 22).mb());
    }
    function Ufb(a, b) {
        var c, d;
        d = a.d.f;
        if (d.g == (CX(), AX)) return;
        c = Uh(mX(d));
        Cm(c) && Umb(b, a, Wv(Dm(c), 12));
    }
    function Xob(a, b) {
        var c, d;
        yxb(b);
        return c = epb(a, 0, b), d = xv(mw, Yyb, 26, b, 12, 1), dxb(a, 0, d, 0, c, true), d;
    }
    function swb(a, b) {
        var c;
        this.c = a;
        c = new GU;
        Zvb(a, c, b, a.b, null, false, null, false);
        this.a = new Fnb(c, 0);
    }
    function is(a) {
        if (!a.a) return false;
        else if (qk(a.c.b, a.a.b)) {
            a.a = null;
            return false;
        } else return true;
    }
    function ec(a) {
        if (!a) throw new ulb((bmb(), 'no calls to next() since the last call to remove()'));
    }
    function ev() {
        ev = iI;
        dv = {
            'boolean': fv,
            'number': gv,
            'string': iv,
            'object': hv,
            'function': hv,
            'undefined': jv
        };
    }
    function xR() {
        xR = iI;
        vR = rr(Bv(tv(Bz, 1), uyb, 59, 0, [
            (sK(), oK),
            pK
        ]));
        wR = rr(Bv(tv(Bz, 1), uyb, 59, 0, [
            rK,
            nK
        ]));
    }
    function Apb(a) {
        ypb();
        var b, c, d;
        d = 0;
        for(c = a.mb(); c.G();){
            b = c.H();
            d = d + (b != null ? vb(b) : 0);
            d = d | 0;
        }
        return d;
    }
    function Hq(a) {
        Dq();
        var b, c, d;
        d = 0;
        for(c = Vg(a).mb(); c.G();){
            b = Wv(c.H(), 83);
            d = PH(d, b.Yb());
        }
        return $s(d);
    }
    function dS(a) {
        var b, c;
        for(c = new Tob(a.a.b); c.a < c.c.c.length;){
            b = Wv(Rob(c), 25);
            b.i.Q();
        }
        a.c.Dc(a);
        eS(a);
    }
    function eub(a, b) {
        var c;
        c = Utb(a.a, b);
        if (c === undefined) ++a.d;
        else {
            a.a[$Ab](b);
            --a.c;
            msb(a.b);
        }
        return c;
    }
    function X5(a, b) {
        var c, d, e, f;
        c = false;
        d = a.d[b].length;
        for(e = d - 1; e > 0; e--){
            f = e - 1;
            c = c | Y5(a, b, f, e);
        }
        return c;
    }
    function V5(a, b) {
        var c, d, e, f;
        c = false;
        d = a.d[b].length;
        for(f = 0; f < d - 1; f++){
            e = f + 1;
            c = c | Y5(a, b, f, e);
        }
        return c;
    }
    function Gv(a, b) {
        var c, d, e;
        c = a.l + b.l;
        d = a.m + b.m + (c >> 22);
        e = a.h + b.h + (d >> 22);
        return Ev(c & azb, d & azb, e & bzb);
    }
    function Mv(a, b) {
        var c, d, e;
        c = a.l - b.l;
        d = a.m - b.m + (c >> 22);
        e = a.h - b.h + (d >> 22);
        return Ev(c & azb, d & azb, e & bzb);
    }
    function LI(a, b) {
        var c;
        for(c = 0; c < (bmb(), b.length); c++){
            if (a == b.charCodeAt(c)) return true;
        }
        return false;
    }
    function yP(a, b) {
        var c;
        for(c = 0; c < (bmb(), b.length); c++){
            if (a == b.charCodeAt(c)) return true;
        }
        return false;
    }
    function rJ(a, b) {
        var c, d;
        if (a.n) {
            d = Smb(a.n, b);
            if (d != null) return d;
        }
        c = zJ(b);
        aw(c, 5) && sJ(a, b, c);
        return c;
    }
    function lJ(a) {
        var b, c, d;
        b = new jJ;
        for(d = WI(a, 0); d.b != d.d.c;){
            c = Wv(_ub(d), 10);
            rn(b, 0, new II(c));
        }
        return b;
    }
    function Q6(a, b, c) {
        var d, e, f, g;
        g = new U6(b, c);
        f = 0;
        for(e = T6(g); e.G();){
            d = Wv(e.H(), 7);
            Umb(a.c, d, Elb(f++));
        }
    }
    function Fb(a, b, c) {
        _b(b);
        if (c.G()) {
            vmb(b, a.C(c.H()));
            while(c.G()){
                vmb(b, a.c);
                vmb(b, a.C(c.H()));
            }
        }
        return b;
    }
    function g9(a, b, c, d, e) {
        if (d) h9(a, b);
        else {
            d9(a, b, e);
            e9(a, b, c);
        }
        if (b.c.length > 1) {
            Gpb(b, a.b);
            V9(a.c, b);
        }
    }
    function Bv(a, b, c, d, e) {
        e.$c = a;
        e._c = b;
        e.ad = kI;
        e.__elementTypeId$ = c;
        e.__elementTypeCategory$ = d;
        return e;
    }
    function vS(a, b, c) {
        switch(c.e){
            case 2:
                a.b = b;
                break;
            case 1:
                a.c = b;
                break;
            case 4:
                a.d = b;
                break;
            case 3:
                a.a = b;
        }
    }
    function B6(a, b, c) {
        var d, e;
        e = C6(c).g;
        d = w6(a, b, e).a;
        return d - Klb(Wv(Smb(a.c, b), 24).a - Wv(Smb(a.c, c), 24).a);
    }
    function glb(a, b) {
        if (a < b) return -1;
        if (a > b) return 1;
        if (a == b) return 0;
        return isNaN(a) ? isNaN(b) ? 0 : 1 : -1;
    }
    function Yi(a) {
        switch(a.Y()){
            case 0:
                return Fi;
            case 1:
                return new Er(a.mb().H());
            default:
                return new gr(a);
        }
    }
    function Nt() {
        Nt = iI;
        var a, b;
        b = !(!!Error.stackTraceLimit || 'stack' in new Error);
        a = new _t;
        Mt = b ? new Tt : a;
    }
    function RP() {
        RP = iI;
        OP = new DJ('intCoordinates', (xkb(), xkb(), vkb));
        PP = new CJ('jsonObject');
        QP = new HI(0, 0);
    }
    function XZ() {
        XZ = iI;
        VZ = new YZ('MIRROR_X', 0);
        WZ = new YZ('TRANSPOSE', 1);
        UZ = new YZ('MIRROR_AND_TRANSPOSE', 2);
    }
    function Hgb() {
        Hgb = iI;
        Fgb = new Igb(tzb, 0);
        Egb = new Igb('INCOMING_ONLY', 1);
        Ggb = new Igb('OUTGOING_ONLY', 2);
    }
    function Seb() {
        Ieb();
        return Bv(tv(_E, 1), uyb, 60, 0, [
            meb,
            jeb,
            ieb,
            peb,
            oeb,
            Heb,
            Geb,
            neb,
            keb,
            leb,
            qeb,
            Eeb,
            Feb
        ]);
    }
    function b3() {
        b3 = iI;
        var a, b, c, d;
        a3 = new vsb(_E);
        for(b = Seb(), c = 0, d = b.length; c < d; ++c){
            a = b[c];
            ssb(a3, a, null);
        }
    }
    function Bpb(a) {
        ypb();
        var b, c, d;
        d = 1;
        for(c = a.mb(); c.G();){
            b = c.H();
            d = 31 * d + (b != null ? vb(b) : 0);
            d = d | 0;
        }
        return d;
    }
    function Tl(a, b) {
        Il();
        var c, d;
        ac(b, 'predicate');
        for(d = 0; a.G(); d++){
            c = a.H();
            if (b.D(c)) return d;
        }
        return -1;
    }
    function Or(a, b) {
        var c, d;
        c = a.c.a;
        d = b.ac(c);
        a.b.b && (d = XH(d, Nr(a, b, c)));
        a.b.c && (d = XH(d, Mr(a, b, c)));
        return d;
    }
    function bwb(a, b, c) {
        var d, e;
        d = new ywb(b, c);
        e = new zwb;
        a.b = _vb(a, a.b, d, e);
        e.b || ++a.c;
        a.b.b = false;
        return e.d;
    }
    function gJ(a, b, c) {
        var d, e, f;
        d = new aJ;
        for(f = WI(c, 0); f.b != f.d.c;){
            e = Wv(_ub(f), 10);
            QI(d, new II(e));
        }
        sn(a, b, d);
    }
    function Mp(a, b) {
        var c;
        if (b === a) return true;
        if (aw(b, 144)) {
            c = Wv(b, 144);
            return a.P().t(c.P());
        }
        return false;
    }
    function Svb(a) {
        var b;
        b = a.a.c.length;
        if (b > 0) return Dvb(b - 1, a.a.c.length), AU(a.a, b - 1);
        else throw new osb;
    }
    function p2(a) {
        if (a.b.c.length - a.e.c.length < 0) {
            QX(a, (sN(), ZM));
            a.a.a = a.j.a;
        } else {
            QX(a, (sN(), rN));
            a.a.a = 0;
        }
    }
    function $mb(a, b) {
        wxb(a >= 0, 'Negative initial capacity');
        wxb(b >= 0, 'Non-positive load factor');
        Ymb(this);
    }
    function rnb(a) {
        var b;
        this.e = a;
        this.d = new hub(this.e.e);
        this.a = this.d;
        this.b = onb(this);
        b = a[WAb];
        this[WAb] = b;
    }
    function Kkb() {
        ++Fkb;
        this.n = null;
        this.j = null;
        this.i = null;
        this.d = null;
        this.b = null;
        this.k = null;
        this.a = null;
    }
    function fpb(a) {
        var b, c, d, e;
        e = 1;
        for(c = 0, d = a.length; c < d; ++c){
            b = a[c];
            e = 31 * e + (b != null ? vb(b) : 0);
            e = e | 0;
        }
        return e;
    }
    function Cc(a) {
        var b, c, d, e;
        b = {};
        for(d = 0, e = a.length; d < e; ++d){
            c = a[d];
            b[':' + (c.d != null ? c.d : '' + c.e)] = c;
        }
        return b;
    }
    function wO(a) {
        uO();
        var b, c, d, e;
        for(c = xO(), d = 0, e = c.length; d < e; ++d){
            b = c[d];
            if (Zi(b.a, a)) return b;
        }
        return tO;
    }
    function Itb(a, b, c) {
        var d, e, f;
        for(e = 0, f = c.length; e < f; ++e){
            d = c[e];
            if (a.b.Uc(b, d.yb())) return d;
        }
        return null;
    }
    function Rmb(a, b, c) {
        var d, e;
        for(e = c.mb(); e.G();){
            d = Wv(e.H(), 21);
            if (a.Uc(b, d.zb())) return true;
        }
        return false;
    }
    function Wvb(a, b) {
        var c, d, e;
        e = a.b;
        while(e){
            c = a.a.$b(b, e.d);
            if (c == 0) return e;
            d = c < 0 ? 0 : 1;
            e = e.a[d];
        }
        return null;
    }
    function Ge(a, b) {
        var c, d;
        c = Wv(Wmb(a.a, b), 19);
        if (!c) return null;
        d = a.b.Z();
        d.jb(c);
        a.b.c -= c.Y();
        c.Q();
        return d;
    }
    function y0(a, b, c) {
        var d;
        d = Wv(b.B(a), 9);
        while(d.g == (CX(), zX)){
            !d.n && (d.n = new ntb);
            Wmb(d.n, c);
            d = Wv(b.B(d), 9);
        }
    }
    function RH(a, b) {
        var c;
        if (UH(a) && UH(b)) {
            c = a - b;
            if (!isNaN(c)) return c;
        }
        return Iv(UH(a) ? YH(a) : a, UH(b) ? YH(b) : b);
    }
    function OH(a) {
        var b;
        if (aw(a, 46)) return a;
        b = a && a.__gwt$exception;
        if (!b) {
            b = new kt(a);
            Ot(b, a);
            MH(a, b);
        }
        return b;
    }
    function p6(a) {
        var b, c, d;
        b = 0;
        for(d = new Tob(a.c); d.a < d.c.c.length;){
            c = Wv(Rob(d), 226);
            b += b6(a, c.a, c.b);
        }
        return b;
    }
    function pT(a) {
        var b;
        b = new DT(a);
        RT(a.a, nT, new opb(Bv(tv(JA, 1), syb, 160, 0, [
            b
        ])));
        !!b.d && vU(b.f, b.d);
        return b.f;
    }
    function w6(a, b, c) {
        switch(c.e){
            case 1:
                return Wv(Smb(a.d, b), 24);
            case 3:
                return Wv(Smb(a.j, b), 24);
        }
        return Elb(0);
    }
    function M5(a, b, c) {
        if (!a.d[b.k][c.k]) {
            L5(a, b, c);
            a.d[b.k][c.k] = true;
            a.d[c.k][b.k] = true;
        }
        return a.a[b.k][c.k];
    }
    function Ds(a, b, c) {
        var d;
        d = b.$b(c, a.b);
        return d < 0 ? !a.e ? a : Wv(Sb(Ds(a.e, b, c), a), 206) : d == 0 ? a : !a.g ? null : Ds(a.g, b, c);
    }
    function rb(a, b) {
        return ew(a) ? emb(a, b) : cw(a) ? (Dxb(a), a === b) : bw(a) ? (Dxb(a), a === b) : _v(a) ? a.t(b) : zv(a) ? a === b : a === b;
    }
    function vQ(a, b) {
        return emb(a.b, b) || dmb(a.b, b) && ((bmb(), b.length) == pmb(a.b) || jmb(a.b, pmb(a.b) - b.length - 1) == 46);
    }
    function L6(a, b) {
        var c, d, e;
        c = 0;
        for(e = nX(a, b).mb(); e.G();){
            d = Wv(e.H(), 7);
            c += rJ(d, (Rib(), Bib)) != null ? 1 : 0;
        }
        return c;
    }
    function Xvb(a, b) {
        var c, d, e;
        d = null;
        e = a.b;
        while(e){
            c = a.a.$b(b, e.d);
            if (c >= 0) e = e.a[1];
            else {
                d = e;
                e = e.a[0];
            }
        }
        return d;
    }
    function Yvb(a, b) {
        var c, d, e;
        d = null;
        e = a.b;
        while(e){
            c = a.a.$b(b, e.d);
            if (c <= 0) e = e.a[0];
            else {
                d = e;
                e = e.a[1];
            }
        }
        return d;
    }
    function u0(a, b, c, d) {
        var e, f;
        for(f = a.mb(); f.G();){
            e = Wv(f.H(), 33);
            e.i.a = b.a + (d.a - e.j.a) / 2;
            e.i.b = b.b;
            b.b += e.j.b + c;
        }
    }
    function o$(a, b) {
        var c;
        if (a.c.length == 0) return;
        c = Wv(FU(a, xv(qB, Nzb, 9, a.c.length, 0, 1)), 51);
        lpb(c, new z$);
        l$(c, b);
    }
    function t$(a, b) {
        var c;
        if (a.c.length == 0) return;
        c = Wv(FU(a, xv(qB, Nzb, 9, a.c.length, 0, 1)), 51);
        lpb(c, new C$);
        l$(c, b);
    }
    function _Z(a) {
        var b, c;
        b = a.g;
        if (b == (CX(), xX)) {
            c = Wv(rJ(a, (Rib(), hib)), 32);
            return c == (sN(), $M) || c == pN;
        }
        return false;
    }
    function Gc(a, b) {
        var c;
        Dxb(b);
        c = a[':' + b];
        xxb(!!c, 'Enum constant undefined: %s', Bv(tv(UF, 1), syb, 1, 4, [
            b
        ]));
        return c;
    }
    function Zb(a, b, c) {
        if (!a) throw new slb(fc('lowerEndpoint (%s) > upperEndpoint (%s)', Bv(tv(UF, 1), syb, 1, 4, [
            b,
            c
        ])));
    }
    function kv(a) {
        ev();
        throw new zu("Unexpected typeof result '" + a + "'; please report this bug to the GWT team");
    }
    function tN(a) {
        switch(a.e){
            case 1:
                return pN;
            case 2:
                return rN;
            case 3:
                return $M;
            case 4:
                return ZM;
            default:
                return qN;
        }
    }
    function vK(a) {
        switch(a.e){
            case 2:
                return pK;
            case 1:
                return oK;
            case 4:
                return nK;
            case 3:
                return rK;
            default:
                return qK;
        }
    }
    function Dkb(a) {
        if (a >= 48 && a < 58) return a - 48;
        if (a >= 97 && a < 97) return a - 97 + 10;
        if (a >= 65 && a < 65) return a - 65 + 10;
        return -1;
    }
    function td(a, b) {
        var c, d;
        for(d = Ep(Be(a.P())); d.b.G();){
            c = Wv(zm(d, d.b.H()), 19);
            if (c.kb(b)) return true;
        }
        return false;
    }
    function js(a) {
        var b;
        if (!is(a)) throw new nvb;
        b = new fs(a.c, a.a);
        a.b = b;
        a.a.i == a.c.a ? a.a = null : a.a = a.a.i;
        return b;
    }
    function pp(a, b) {
        mp();
        var c;
        if (a === b) return true;
        else if (aw(b, 57)) {
            c = Wv(b, 57);
            return mr(nj(a), c.bb());
        }
        return false;
    }
    function Gq(a, b, c, d) {
        Dq();
        Mh(c, 'oldCount');
        Mh(d, 'newCount');
        if (a.Cb(b) == c) {
            a.Gb(b, d);
            return true;
        } else return false;
    }
    function Bh(a, b, c, d, e) {
        _b(c);
        _b(e);
        return Rr(new Ur(a.c, pk(a.b, new sk(a.d, true, b, c, false, null, (Gh(), Fh))), a.a), d, e);
    }
    function ck(a) {
        hi();
        switch(a.Y()){
            case 0:
                return kr(), jr;
            case 1:
                return new Gr(a.mb().H());
            default:
                return new lr(a);
        }
    }
    function PH(a, b) {
        var c;
        if (UH(a) && UH(b)) {
            c = a + b;
            if (ezb < c && c < dzb) return c;
        }
        return SH(Gv(UH(a) ? YH(a) : a, UH(b) ? YH(b) : b));
    }
    function WH(a, b) {
        var c;
        if (UH(a) && UH(b)) {
            c = a * b;
            if (ezb < c && c < dzb) return c;
        }
        return SH(Kv(UH(a) ? YH(a) : a, UH(b) ? YH(b) : b));
    }
    function XH(a, b) {
        var c;
        if (UH(a) && UH(b)) {
            c = a - b;
            if (ezb < c && c < dzb) return c;
        }
        return SH(Mv(UH(a) ? YH(a) : a, UH(b) ? YH(b) : b));
    }
    function sK() {
        sK = iI;
        qK = new wK(szb, 0);
        pK = new wK(pzb, 1);
        oK = new wK(ozb, 2);
        nK = new wK('DOWN', 3);
        rK = new wK('UP', 4);
    }
    function NK() {
        NK = iI;
        MK = new OK(szb, 0);
        KK = new OK('POLYLINE', 1);
        JK = new OK('ORTHOGONAL', 2);
        LK = new OK('SPLINES', 3);
    }
    function eL() {
        eL = iI;
        cL = new fL('INHERIT', 0);
        bL = new fL('INCLUDE_CHILDREN', 1);
        dL = new fL('SEPARATE_CHILDREN', 2);
    }
    function G8() {
        G8 = iI;
        D8 = TQ(RQ(new WQ, (d0(), p_)), I_);
        E8 = PQ(TQ(SQ(new WQ, j_), h_), i_);
        F8 = PQ(UQ(new WQ, k_), i_);
    }
    function P8() {
        P8 = iI;
        M8 = TQ(RQ(new WQ, (d0(), p_)), I_);
        N8 = PQ(TQ(SQ(new WQ, j_), h_), i_);
        O8 = PQ(UQ(new WQ, k_), i_);
    }
    function deb(a) {
        this.a = new Wub;
        this.d = new Wub;
        this.b = new Wub;
        this.c = new Wub;
        this.g = new Wub;
        this.i = new Wub;
        this.f = a;
    }
    function UV(a, b, c, d, e, f) {
        this.e = new GU;
        this.f = (djb(), cjb);
        vU(this.e, a);
        this.d = b;
        this.a = c;
        this.b = d;
        this.f = e;
        this.c = f;
    }
    function hpb(a, b, c, d, e, f, g, h) {
        var i;
        i = c;
        while(f < g)i >= d || b < c && h.$b(a[b], a[i]) <= 0 ? Av(e, f++, a[b++]) : Av(e, f++, a[i++]);
    }
    function v0(a, b, c, d, e) {
        var f, g;
        for(g = a.mb(); g.G();){
            f = Wv(g.H(), 33);
            f.i.a = b.a;
            f.i.b = e ? b.b : b.b + d.b - f.j.b;
            b.a += f.j.a + c;
        }
    }
    function gcb(a, b) {
        $bb();
        var c, d;
        for(d = Uh(gX(a)); Cm(d);){
            c = Wv(Dm(d), 12);
            if (c.d.f == b || c.c.f == b) return c;
        }
        return null;
    }
    function fdb(a, b, c) {
        var d, e, f;
        d = 0;
        for(f = WI(a, 0); f.b != f.d.c;){
            e = Ixb(Yv(_ub(f)));
            if (e > c) break;
            else e >= b && ++d;
        }
        return d;
    }
    function sn(a, b, c) {
        var d, e, f, g;
        Dxb(c);
        g = false;
        f = WI(a, b);
        for(e = WI(c, 0); e.b != e.d.c;){
            d = _ub(e);
            $ub(f, d);
            g = true;
        }
        return g;
    }
    function Uf(a, b) {
        var c, d, e;
        if (b.V()) return false;
        e = a.Y();
        c = a.d.jb(b);
        if (c) {
            d = a.d.Y();
            a.f.c += d - e;
            e == 0 && Vf(a);
        }
        return c;
    }
    function qJ(a, b) {
        var c;
        if (!b) return a;
        c = !b.n ? (ypb(), ypb(), wpb) : b.n;
        c.V() || (!a.n ? a.n = new ptb(c) : he(a.n, c));
        return a;
    }
    function Gb(b, c, d) {
        var e;
        try {
            Fb(b, c, d);
        } catch (a) {
            a = OH(a);
            if (aw(a, 181)) {
                e = a;
                throw new ukb(e);
            } else throw NH(a);
        }
        return c;
    }
    function Qb(b, c, d) {
        var e;
        try {
            Pb(b, c, d);
        } catch (a) {
            a = OH(a);
            if (aw(a, 181)) {
                e = a;
                throw new ukb(e);
            } else throw NH(a);
        }
        return c;
    }
    function NH(a) {
        var b;
        if (aw(a, 164)) {
            b = Wv(a, 164);
            if (gw(b.b) !== gw((it(), ht))) return gw(b.b) === gw(ht) ? null : b.b;
        }
        return a;
    }
    function SW(a, b) {
        var c;
        c = Wv(rJ(hX(a), (Rib(), zib)), 9);
        while(c){
            if (c == b) return true;
            c = Wv(rJ(hX(c), zib), 9);
        }
        return false;
    }
    function EZ(a) {
        switch(Wv(rJ(a, (Rib(), mib)), 140).e){
            case 1:
                sJ(a, mib, (Hhb(), Ehb));
                break;
            case 2:
                sJ(a, mib, (Hhb(), Ghb));
        }
    }
    function Kk(a) {
        hi();
        switch(a.c){
            case 0:
                return kr(), jr;
            case 1:
                return new Gr(Sl(new jtb(a)));
            default:
                return new Jk(a);
        }
    }
    function Ti(a) {
        Gi();
        var b, c;
        for(b = 0, c = a.length; b < c; b++){
            if (a[b] == null) throw new Wlb('at index ' + b);
        }
        return new opb(a);
    }
    function $4(a, b, c) {
        if (b.length == 0 || c.length == 0) return 0;
        a.e ? a.b = new y5(a.c) : a.b = new H5(a.c);
        return a.b.Gc(b, c);
    }
    function pI(a) {
        if (a.i == null) throw new ulb('The task has not begun yet.');
        if (!a.b) {
            a.c < a.j && qI(a, a.j - a.c);
            a.b = true;
        }
    }
    function DR(a, b) {
        var c, d;
        for(d = new Tob(b); d.a < d.c.c.length;){
            c = Wv(Rob(d), 27);
            BU(a.b.b, c.b);
            PR(Wv(c.a, 78), Wv(c.b, 25));
        }
    }
    function aU(a, b) {
        var c, d;
        for(d = new Tob(a.a); d.a < d.c.c.length;){
            c = Wv(Rob(d), 222);
            if (YT(c, b)) return;
        }
        vU(a.a, new _T(b));
    }
    function aV(a) {
        var b, c, d;
        b = new GU;
        for(d = new Tob(a.b); d.a < d.c.c.length;){
            c = Wv(Rob(d), 251);
            xU(b, Wv(c.Ac(), 19));
        }
        return b;
    }
    function Q0(a, b) {
        var c, d, e;
        e = new GU;
        for(d = nX(a, b).mb(); d.G();){
            c = Wv(d.H(), 7);
            e.c[e.c.length] = c;
        }
        Gpb(e, new V0);
        return e;
    }
    function iX(a) {
        var b, c, d;
        b = new GU;
        for(d = new Tob(a.f); d.a < d.c.c.length;){
            c = Wv(Rob(d), 7);
            vU(b, c.b);
        }
        return _b(b), new Vh(b);
    }
    function mX(a) {
        var b, c, d;
        b = new GU;
        for(d = new Tob(a.f); d.a < d.c.c.length;){
            c = Wv(Rob(d), 7);
            vU(b, c.e);
        }
        return _b(b), new Vh(b);
    }
    function Elb(a) {
        var b, c;
        if (a > -129 && a < 128) {
            b = a + 128;
            c = (Glb(), Flb)[b];
            !c && (c = Flb[b] = new wlb(a));
            return c;
        }
        return new wlb(a);
    }
    function R5(a) {
        var b, c;
        b = Z4(a.b, a.d);
        c = $xb;
        while(c > b){
            S5(a, a.d);
            if (b == 0) {
                c = 0;
                break;
            }
            W5(a);
            U5(a);
            c = b;
            b = Z4(a.b, a.d);
        }
        a.c = c;
    }
    function yvb() {
        tvb();
        var a, b, c;
        c = svb++ + ixb();
        a = hw(Math.floor(c * FAb)) & bBb;
        b = hw(c - a * aBb);
        this.a = a ^ 1502;
        this.b = b ^ _Ab;
    }
    function vb(a) {
        return ew(a) ? Pxb(a) : cw(a) ? hw((Dxb(a), a)) : bw(a) ? Ckb((Dxb(a), a)) ? 1231 : 1237 : _v(a) ? a.v() : zv(a) ? txb(a) : txb(a);
    }
    function AQ(a, b, c) {
        var d, e, f;
        e = new jQ;
        e.d = c;
        d = UP(e, b);
        f = new dR;
        Ckb(Ixb(Xv(rJ(d, yQ)))) ? YQ(f, d, new sI) : BQ(a, f, d);
        ZP(e, d);
    }
    function E6(a, b, c, d) {
        var e, f, g, h;
        h = new U6(b, d);
        g = 0;
        for(f = T6(h); f.G();){
            e = Wv(f.H(), 7);
            Umb(a.i, e, Elb(g++));
        }
        Umb(c, b, Elb(g));
    }
    function c6(a, b) {
        var c, d, e, f, g;
        c = 0;
        g = 0;
        for(e = 0, f = b.length; e < f; ++e){
            d = b[e];
            c = i6(a, c, d, (sN(), ZM), a.f);
            g = i6(a, g, d, rN, a.n);
        }
    }
    function pJ(a, b) {
        var c, d, e, f;
        if (!a.n) return;
        for(d = 0, e = b.length; d < e; ++d){
            c = b[d];
            f = Smb(a.n, c);
            if (f != null) {
                c.nc();
                c.oc();
            }
        }
    }
    function L2(a, b) {
        var c, d, e;
        for(d = new Tob(b); d.a < d.c.c.length;){
            c = Wv(Rob(d), 75);
            e = X2(a.a);
            R2(a.a, e, c.k, c.j);
            aeb(c, e, true);
        }
    }
    function M2(a, b) {
        var c, d, e;
        for(d = new Tob(b); d.a < d.c.c.length;){
            c = Wv(Rob(d), 75);
            e = W2(a.a);
            R2(a.a, e, c.k, c.j);
            aeb(c, e, true);
        }
    }
    function PW(a) {
        var b, c;
        c = Wv(rJ(a, (eM(), sL)), 59);
        if (c == (sK(), qK)) {
            b = Wv(rJ(a, (Rib(), Rhb)), 15).a;
            return b >= 1 ? pK : nK;
        }
        return c;
    }
    function Cm(a) {
        _b(a.b);
        if (a.b.G()) return true;
        while(a.a.G()){
            _b(a.b = a.Wb(a.a.H()));
            if (a.b.G()) return true;
        }
        return false;
    }
    function m7(a) {
        if (a.d != a.c.d || a.i != a.g.d) {
            a.a.c = xv(UF, syb, 1, 0, 4, 1);
            xU(a.a, a.c);
            xU(a.a, a.g);
            a.d = a.c.d;
            a.i = a.g.d;
        }
        return a.a;
    }
    function Yf(a) {
        var b;
        if (a.b) {
            Yf(a.b);
            if (a.b.d != a.c) throw new nsb;
        } else if (a.d.V()) {
            b = Wv(Smb(a.f.b, a.e), 19);
            !!b && (a.d = b);
        }
    }
    function H9(a, b, c, d, e) {
        var f, g, h, i;
        i = Co(a);
        g9(b, i, d, e, c);
        f = 0;
        for(h = new Tob(i); h.a < h.c.c.length;){
            g = Wv(Rob(h), 9);
            a[f++] = g;
        }
    }
    function oP(a) {
        var b, c, d;
        d = Wv(vW(a.a, (eM(), DL)), 15).a;
        for(c = new Tob(uW(a.a)); c.a < c.c.c.length;){
            b = Wv(Rob(c), 626);
            qP(a, b, d);
        }
    }
    function WQ() {
        var a, b;
        this.a = new HU(6);
        for(b = 0; b < 6; b++)vU(this.a, (a = Wv(Hkb(mC), 11), new atb(a, Wv(exb(a, a.length), 11), 0)));
    }
    function W5(a) {
        var b, c, d;
        d = false;
        for(c = 0; c < a.d.length; c++){
            a.j = (b = new N5(a.e, a.d, c, 0), new b7(c, a.d, b));
            d = d | O5(a, c);
        }
        return d;
    }
    function H8(a, b, c) {
        var d, e;
        e = a.a.c;
        for(d = e.c.length; d < c; d++)uU(e, 0, new sY(a.a));
        rX(b, Wv(yU(e, e.c.length - c), 16));
        a.b[b.k] = c;
    }
    function hdb(a, b) {
        var c, d;
        c = WI(a, 0);
        while(c.b != c.d.c){
            d = Ixb(Yv(_ub(c)));
            if (d == b) return;
            else if (d > b) {
                avb(c);
                break;
            }
        }
        $ub(c, b);
    }
    function dub(a, b, c) {
        var d;
        d = Utb(a.a, b);
        Wtb(a.a, b, c === undefined ? null : c);
        if (d === undefined) {
            ++a.c;
            msb(a.b);
        } else ++a.d;
        return d;
    }
    function qgb(a, b, c) {
        if ((b - a <= 0 ? 0 - (b - a) : b - a) < uAb || (c - a <= 0 ? 0 - (c - a) : c - a) < uAb) return true;
        return b - a > uAb ? a - c > uAb : c - a > uAb;
    }
    function Qgb(a) {
        switch(a.e){
            case 0:
                return Kgb;
            case 1:
                return Lgb;
            case 2:
                return Mgb;
            case 3:
                return Ngb;
            default:
                return Ogb;
        }
    }
    function uS(a, b) {
        switch(b.e){
            case 2:
                return a.b;
            case 1:
                return a.c;
            case 4:
                return a.d;
            case 3:
                return a.a;
            default:
                return false;
        }
    }
    function vN(a) {
        sN();
        switch(a.e){
            case 4:
                return $M;
            case 1:
                return ZM;
            case 3:
                return pN;
            case 2:
                return rN;
            default:
                return qN;
        }
    }
    function c7(a, b) {
        if (b == a.c) return a.d;
        else if (b == a.d) return a.c;
        else throw new slb('Node ' + b + ' not part of edge ' + a);
    }
    function zO(a, b) {
        var c;
        if (Zsb(a.a, b)) return Wv(Zsb(a.a, b) ? a.b[b.e] : null, 62);
        else {
            c = new ZN;
            Wsb(a.a, b);
            usb(a, b.e, c);
            return c;
        }
    }
    function Zeb(a, b) {
        var c, d, e, f;
        f = a.g.tb();
        c = 0;
        while(f.G()){
            d = Ixb(Yv(f.H()));
            e = d - b;
            if (e > RAb) return c;
            else e > SAb && ++c;
        }
        return c;
    }
    function Usb(a) {
        var b, c, d, e;
        c = (b = Wv(Hkb((d = a.$c, e = d.f, e == IF ? d : e)), 11), new atb(b, Wv(exb(b, b.length), 11), 0));
        Wsb(c, a);
        return c;
    }
    function yR(a, b) {
        var c, d;
        for(d = new Tob(b); d.a < d.c.c.length;){
            c = Wv(Rob(d), 27);
            vU(a.b.b, Wv(c.b, 25));
            OR(Wv(c.a, 78), Wv(c.b, 25));
        }
    }
    function gpb(a, b, c, d) {
        var e, f, g;
        for(e = b + 1; e < c; ++e)for(f = e; f > b && d.$b(a[f - 1], a[f]) > 0; --f){
            g = a[f];
            Av(a, f, a[f - 1]);
            Av(a, f - 1, g);
        }
    }
    function k3(a) {
        var b, c;
        if (!MM(Wv(rJ(a, (eM(), TL)), 28))) for(c = new Tob(a.f); c.a < c.c.c.length;){
            b = Wv(Rob(c), 7);
            QX(b, (sN(), qN));
        }
    }
    function oX(a, b) {
        switch(b.e){
            case 1:
                return pl(a.f, (LX(), GX));
            case 2:
                return pl(a.f, (LX(), IX));
            default:
                return ypb(), ypb(), vpb;
        }
    }
    function oW(a, b) {
        if (yJ(b, (eM(), cM))) return rJ(a.e, (Rib(), Jib));
        else if (yJ(b, LL)) return rJ(a.e, (Rib(), tib));
        return rJ(a.e, b);
    }
    function I5(a, b, c, d) {
        var e, f, g;
        f = b;
        e = c - 1;
        while(f <= e){
            g = (f + e) / 2 | 0;
            if (a[g] == d) return g;
            else a[g] < d ? f = g + 1 : e = g - 1;
        }
        return -f - 1;
    }
    function Ve(a, b, c) {
        var d, e;
        for(e = a.mb(); e.G();){
            d = e.H();
            if (gw(b) === gw(d) || b != null && rb(b, d)) {
                c && e.I();
                return true;
            }
        }
        return false;
    }
    function epb(a, b, c) {
        var d;
        xxb(b <= c, '%s > %s', Bv(tv(UF, 1), syb, 1, 4, [
            Elb(b),
            Elb(c)
        ]));
        d = a.length;
        c = c < d ? c : d;
        Gxb(b, c, d);
        return c - b;
    }
    function aW(a, b) {
        var c, d, e;
        c = a;
        e = 0;
        do {
            if (c == b) return e;
            d = Wv(rJ(c, (Rib(), zib)), 9);
            if (!d) throw new rlb;
            c = hX(d);
            ++e;
        }while (true);
    }
    function U5(a) {
        var b, c, d;
        d = false;
        for(c = a.d.length - 1; c >= 0; c--){
            a.j = (b = new N5(a.e, a.d, c, 1), new b7(c, a.d, b));
            d = d | O5(a, c);
        }
        return d;
    }
    function k6(a) {
        this.f = (mp(), new ntb);
        this.n = new ntb;
        this.k = new ntb;
        this.g = new vtb;
        this.i = new Vr((Tq(), Sq));
        this.j = a;
        c6(this, a);
    }
    function vsb(a) {
        var b;
        this.a = (b = Wv(a.e && a.e(), 11), new atb(b, Wv(exb(b, b.length), 11), 0));
        this.b = xv(UF, syb, 1, this.a.a.length, 4, 1);
    }
    function jf(a, b) {
        var c;
        if (b === a) return true;
        if (!aw(b, 18)) return false;
        c = Wv(b, 18);
        if (c.Y() != a.Y()) return false;
        return a.lb(c);
    }
    function Reb(a) {
        Ieb();
        switch(a.e){
            case 1:
                return meb;
            case 2:
                return ieb;
            case 3:
                return oeb;
            case 4:
                return Geb;
            default:
                return Feb;
        }
    }
    function pgb(a, b) {
        switch(b.e){
            case 1:
                return a.e.d;
            case 2:
                return a.e.c;
            case 3:
                return a.e.a;
            case 4:
                return a.e.b;
            default:
                return 0;
        }
    }
    function xO() {
        uO();
        return Bv(tv(Oz, 1), uyb, 67, 0, [
            rO,
            qO,
            sO,
            iO,
            hO,
            jO,
            mO,
            lO,
            kO,
            pO,
            oO,
            nO,
            fO,
            eO,
            gO,
            cO,
            bO,
            dO,
            _N,
            $N,
            aO,
            tO
        ]);
    }
    function zM() {
        zM = iI;
        yM = new AM(szb, 0);
        xM = new AM('JUSTIFIED', 1);
        uM = new AM('BEGIN', 2);
        vM = new AM(qzb, 3);
        wM = new AM('END', 4);
    }
    function DN() {
        DN = iI;
        BN = new EN('PORTS', 0);
        CN = new EN('PORT_LABELS', 1);
        AN = new EN('NODE_LABELS', 2);
        zN = new EN('MINIMUM_SIZE', 3);
    }
    function kP() {
        kP = iI;
        jP = new lP('UNKNOWN', 0);
        gP = new lP('ABOVE', 1);
        hP = new lP('BELOW', 2);
        iP = new DJ('de.cau.cs.kieler.labelSide', jP);
    }
    function Qjb() {
        Qjb = iI;
        Njb = new Rjb('EQUALLY_DISTRIBUTED', 0);
        Pjb = new Rjb('NORTH_STACKED', 1);
        Ojb = new Rjb('NORTH_SEQUENCE', 2);
    }
    function gI() {
        fI = {};
        !Array.isArray && (Array.isArray = function(a) {
            return Object.prototype.toString.call(a) === '[object Array]';
        });
    }
    function SR(a, b) {
        return Ws(), Ws(), ((a - b > 0 ? a - b : -(a - b)) <= $yb || a == b || isNaN(a) && isNaN(b) ? 0 : a < b ? -1 : a > b ? 1 : Ys(isNaN(a), isNaN(b))) > 0;
    }
    function TR(a, b) {
        return Ws(), Ws(), ((a - b > 0 ? a - b : -(a - b)) <= $yb || a == b || isNaN(a) && isNaN(b) ? 0 : a < b ? -1 : a > b ? 1 : Ys(isNaN(a), isNaN(b))) < 0;
    }
    function Veb(a) {
        var b, c;
        a.d || cfb(a);
        c = new jJ;
        b = a.b.mb();
        b.H();
        while(b.G())QI(c, Wv(b.H(), 92).a);
        Bxb(c.b != 0);
        $I(c, c.c.b);
        return c;
    }
    function $db(a) {
        var b, c, d, e;
        e = new Wub;
        b = new IU(a.c);
        Dpb(b);
        for(d = new Tob(b); d.a < d.c.c.length;){
            c = Wv(Rob(d), 7);
            e.a.db(c, e);
        }
        return e;
    }
    function Np(a, b) {
        var c, d, e;
        _b(b);
        for(d = (e = a.g, Wv(!e ? a.g = new En(a) : e, 20)).mb(); d.G();){
            c = Wv(d.H(), 21);
            Fd(b, c.zb(), c.yb());
        }
        return b;
    }
    function mf(a, b) {
        var c, d, e;
        if (aw(b, 21)) {
            c = Wv(b, 21);
            d = c.yb();
            e = rp(a.qb(), d);
            return Tb(e, c.zb()) && (e != null || a.qb().R(d));
        }
        return false;
    }
    function Yeb(a, b) {
        var c, d, e;
        e = a.g.tb();
        while(e.G()){
            c = Ixb(Yv(e.H()));
            d = c - b <= 0 ? 0 - (c - b) : c - b;
            if (d < RAb) return e.L() - 1;
        }
        return a.g.Y();
    }
    function Vfb(a) {
        var b, c;
        for(c = new Tob(a.a); c.a < c.c.c.length;){
            b = Wv(Rob(c), 9);
            if (b.g == (CX(), AX) || b.g == wX) return false;
        }
        return true;
    }
    function nI(a, b, c) {
        if (a.b) throw new ulb('The task is already done.');
        else if (a.i != null) return false;
        else {
            a.i = b;
            a.j = c;
            return true;
        }
    }
    function A5(a, b) {
        if (a.f < b.f) return -1;
        else if (a.f > b.f) return 1;
        else if (a.g < b.g) return -1;
        else if (a.g > b.g) return 1;
        return a.b - b.b;
    }
    function S8(a, b) {
        if (b.c == a) return b.d;
        else if (b.d == a) return b.c;
        throw new slb('Input edge is not connected to the input port.');
    }
    function q5(a) {
        var b;
        if (a.c == 0) return;
        b = Wv(yU(a.a, a.b), 128);
        b.b == 1 ? (++a.b, a.b < a.a.c.length && u5(Wv(yU(a.a, a.b), 128))) : --b.b;
        --a.c;
    }
    function ZU(a, b) {
        a.b.a = Qlb(a.b.a, b.c);
        a.b.b = Qlb(a.b.b, b.d);
        a.a.a = Nlb(a.a.a, b.c);
        a.a.b = Nlb(a.a.b, b.d);
        return a.c[a.c.length] = b, true;
    }
    function vbb(a, b, c) {
        var d, e;
        d = Ixb(a.n[b.f.k]) + Ixb(a.d[b.f.k]) + b.i.b + b.a.b;
        e = Ixb(a.n[c.f.k]) + Ixb(a.d[c.f.k]) + c.i.b + c.a.b;
        return e - d;
    }
    function Y5(a, b, c, d) {
        var e, f, g;
        e = false;
        if ($6(a.j, c, d)) {
            a7(a.j, a.d[b][c], a.d[b][d]);
            f = a.d[b];
            g = f[d];
            f[d] = f[c];
            f[c] = g;
            e = true;
        }
        return e;
    }
    function fX(a, b, c) {
        var d, e, f, g, h;
        h = hX(a);
        e = h.a;
        d = Wv(rJ(h, (Rib(), Xhb)), 15).a;
        f = h.d;
        g = a.i;
        b && (g.a = g.a - e.b - d - f.a);
        c && (g.b = g.b - e.d - d - f.b);
    }
    function Q$(a, b) {
        var c, d, e;
        for(d = Uh(gX(a)); Cm(d);){
            c = Wv(Dm(d), 12);
            e = Wv(b.B(c), 9);
            return new $c(_b(e.i.b + e.j.b / 2));
        }
        return zb(), zb(), yb;
    }
    function ifb(a) {
        var b, c, d, e, f;
        d = gfb(a);
        b = rAb;
        f = 0;
        e = 0;
        while(b > 0.5 && f < 50){
            e = ofb(d);
            c = $eb(d, e, true);
            b = Jlb(c.b);
            ++f;
        }
        return $eb(a, e, false);
    }
    function jfb(a) {
        var b, c, d, e, f;
        d = gfb(a);
        b = rAb;
        f = 0;
        e = 0;
        while(b > 0.5 && f < 50){
            e = nfb(d);
            c = $eb(d, e, true);
            b = Jlb(c.a);
            ++f;
        }
        return $eb(a, e, false);
    }
    function QR(a) {
        var b, c, d;
        this.a = new Wub;
        this.e = new vtb;
        this.f = 0;
        for(c = 0, d = a.length; c < d; ++c){
            b = a[c];
            !this.g && (this.g = b);
            OR(this, b);
        }
    }
    function dfb(a) {
        Teb(this);
        this.c = a.c;
        this.f = a.f;
        this.e = a.e;
        this.k = a.k;
        this.d = a.d;
        this.g = Eo(a.g);
        this.j = a.j;
        this.i = a.i;
        this.b = Eo(a.b);
    }
    function oU(a) {
        switch(a.e){
            case 1:
                return sK(), rK;
            case 4:
                return sK(), oK;
            case 2:
                return sK(), pK;
            case 3:
                return sK(), nK;
        }
        return sK(), qK;
    }
    function Xdb(a, b) {
        if (_db(a, b)) {
            stb(a.g, b);
            return true;
        }
        b.g != (sN(), qN) && stb(a.i, b);
        b.e.c.length == 0 ? stb(a.c, b) : stb(a.b, b);
        return false;
    }
    function wU(a, b) {
        var c, d;
        Fxb(0, a.c.length);
        c = Ye(b, xv(UF, syb, 1, b.a.Y(), 4, 1));
        d = c.length;
        if (d == 0) return false;
        gxb(a.c, 0, c);
        return true;
    }
    function Zkb(a, b) {
        var c = 0;
        while(!b[c] || b[c] == '')c++;
        var d = b[c++];
        for(; c < b.length; c++){
            if (!b[c] || b[c] == '') continue;
            d += a + b[c];
        }
        return d;
    }
    function yt() {
        var a;
        if (ut != 0) {
            a = pt();
            if (a - vt > 2000) {
                vt = a;
                wt = $wnd.setTimeout(Et, 10);
            }
        }
        if (ut++ == 0) {
            Ht((Gt(), Ft));
            return true;
        }
        return false;
    }
    function kS(a) {
        var b, c;
        for(c = new Tob(a.a.b); c.a < c.c.c.length;){
            b = Wv(Rob(c), 25);
            b.j.d = -b.j.d - b.j.c;
            !!b.o && (b.g.a = -b.g.a + b.o.j.c);
        }
        fS(a);
    }
    function D2(a, b) {
        var c;
        c = a;
        while(b.b < b.d.Y() && c == a)c = (Bxb(b.b < b.d.Y()), Wv(b.d.sb(b.c = b.b++), 7)).g;
        c == a || (Bxb(b.b > 0), b.a.sb(b.c = --b.b));
    }
    function a$(a) {
        var b;
        if (!LM(Wv(rJ(a, (eM(), TL)), 28))) return;
        b = a.c;
        b$((Cxb(0, b.c.length), Wv(b.c[0], 16)));
        b$(Wv(yU(b, b.c.length - 1), 16));
    }
    function NV(a, b, c) {
        nI(c, 'Compound graph preprocessor', 1);
        a.a = new xk;
        RV(a, b, null);
        MV(a, b);
        sJ(b, (Rib(), bib), a.a);
        a.a = null;
        Ymb(a.b);
        pI(c);
    }
    function P0(a) {
        var b, c;
        b = Wv(Dm(Uh(iX(a))), 12);
        c = Wv(Dm(Uh(mX(a))), 12);
        return !Ckb(Ixb(Xv(rJ(b, (Rib(), Iib))))) || !Ckb(Ixb(Xv(rJ(c, Iib))));
    }
    function O6(a, b, c) {
        if (b.g == (CX(), AX) && c.g == zX) {
            a.d = L6(b, (sN(), pN));
            a.b = L6(b, $M);
        }
        if (c.g == AX && b.g == zX) {
            a.d = L6(c, (sN(), $M));
            a.b = L6(c, pN);
        }
    }
    function _8(a, b, c) {
        var d, e, f, g;
        f = b.g;
        g = c.g;
        if (f != g) return f.e - g.e;
        else {
            d = a.a[b.k];
            e = a.a[c.k];
            return !d && !e ? 0 : !d ? -1 : !e ? 1 : glb(d.a, e.a);
        }
    }
    function jab(a, b, c, d) {
        var e, f, g, h;
        f = b;
        e = c - 1;
        while(f <= e){
            g = f + e >>> 1;
            h = a[g];
            if (h < d) f = g + 1;
            else if (h > d) e = g - 1;
            else return g;
        }
        return -(f + 1);
    }
    function Id(a) {
        return aw(a, 137) ? (ypb(), new dsb(Wv(a, 137))) : aw(a, 18) ? (ypb(), new Frb(Wv(a, 18))) : aw(a, 20) ? Hpb(Wv(a, 20)) : (ypb(), new zqb(a));
    }
    function Kd(a, b, c) {
        return aw(c, 137) ? new Lg(a, b, Wv(c, 137)) : aw(c, 18) ? new Kg(a, b, Wv(c, 18)) : aw(c, 20) ? Ld(a, b, Wv(c, 20), null) : new _f(a, b, c, null);
    }
    function tn(b, c) {
        var d;
        d = b.ub(c);
        try {
            return d.H();
        } catch (a) {
            a = OH(a);
            if (aw(a, 74)) throw new okb("Can't get element " + c);
            else throw NH(a);
        }
    }
    function rp(b, c) {
        mp();
        _b(b);
        try {
            return b.cb(c);
        } catch (a) {
            a = OH(a);
            if (aw(a, 119)) return null;
            else if (aw(a, 76)) return null;
            else throw NH(a);
        }
    }
    function Qu(f, a) {
        var b = f.a;
        var c;
        a = String(a);
        b.hasOwnProperty(a) && (c = b[a]);
        var d = (ev(), dv)[typeof c];
        var e = d ? d(c) : kv(typeof c);
        return e;
    }
    function kgb(a, b, c, d) {
        if (b < c) {
            a.b = 0.5 * (b + c);
            a.p = UAb * a.b + 0.9 * b;
            a.a = UAb * a.b + 0.9 * c;
        } else {
            a.b = 0.5 * (b + d);
            a.p = UAb * a.b + 0.9 * d;
            a.a = UAb * a.b + 0.9 * b;
        }
    }
    function Vr(a) {
        Ch.call(this, a);
        this.b = new sk(a, false, null, (Gh(), Fh), false, null, Fh);
        this.a = new Os(null, 1);
        ds(this.a, this.a);
        this.c = new Vs;
    }
    function xT(a) {
        vT();
        this.c = new GU;
        this.d = a;
        switch(a.e){
            case 0:
            case 2:
                this.a = Epb(uT);
                this.b = Uzb;
                break;
            case 3:
            case 1:
                this.a = uT;
                this.b = Vzb;
        }
    }
    function iK() {
        iK = iI;
        cK = new jK('AUTOMATIC', 0);
        fK = new jK(ozb, 1);
        gK = new jK(pzb, 2);
        hK = new jK('TOP', 3);
        dK = new jK('BOTTOM', 4);
        eK = new jK(qzb, 5);
    }
    function Pxb(a) {
        Nxb();
        var b, c, d;
        c = ':' + a;
        d = Mxb[c];
        if (!(d === undefined)) return d;
        d = Kxb[c];
        b = d === undefined ? Oxb(a) : d;
        Qxb();
        Mxb[c] = b;
        return b;
    }
    function bk(a, b, c, d, e, f, g) {
        hi();
        var h, i;
        i = g.length + 6;
        h = new HU(i);
        zpb(h, Bv(tv(UF, 1), syb, 1, 4, [
            a,
            b,
            c,
            d,
            e,
            f
        ]));
        zpb(h, g);
        return Yj(new Tob(h));
    }
    function GZ(a) {
        var b;
        b = Wv(rJ(a, (eM(), JL)), 18);
        if (b.V()) return;
        if (b.kb((oM(), gM))) {
            b.nb(gM);
            b.ib(iM);
        } else if (b.kb(iM)) {
            b.nb(iM);
            b.ib(gM);
        }
    }
    function HZ(a) {
        var b;
        b = Wv(rJ(a, (eM(), JL)), 18);
        if (b.V()) return;
        if (b.kb((oM(), nM))) {
            b.nb(nM);
            b.ib(lM);
        } else if (b.kb(lM)) {
            b.nb(lM);
            b.ib(nM);
        }
    }
    function f$(a, b) {
        var c, d, e, f;
        e = a.g;
        c = Ixb(Yv(rJ(a, (Rib(), Cib))));
        f = b.g;
        d = Ixb(Yv(rJ(b, Cib)));
        return f != (CX(), xX) ? -1 : e != xX ? 1 : c == d ? 0 : c < d ? -1 : 1;
    }
    function g6(a, b, c) {
        var d, e;
        d = Slb(h6(a, b.d), h6(a, b.c));
        e = Plb(h6(a, b.d), h6(a, b.c));
        return $s(Or(Bh(c, Elb(d), (Gh(), Fh), Elb(e), Fh), (qs(), ps)));
    }
    function qp(b, c) {
        mp();
        _b(b);
        try {
            return b.R(c);
        } catch (a) {
            a = OH(a);
            if (aw(a, 119)) return false;
            else if (aw(a, 76)) return false;
            else throw NH(a);
        }
    }
    function Qh(b, c) {
        Oh();
        _b(b);
        try {
            return hnb(b, c);
        } catch (a) {
            a = OH(a);
            if (aw(a, 119)) return false;
            else if (aw(a, 76)) return false;
            else throw NH(a);
        }
    }
    function nab(a, b) {
        if (a.e < b.e) return -1;
        else if (a.e > b.e) return 1;
        else if (a.f < b.f) return -1;
        else if (a.f > b.f) return 1;
        return txb(a) - txb(b);
    }
    function QZ(a) {
        switch(a.e){
            case 1:
                return sN(), rN;
            case 4:
                return sN(), $M;
            case 3:
                return sN(), ZM;
            case 2:
                return sN(), pN;
            default:
                return sN(), qN;
        }
    }
    function Ki(a) {
        var b, c;
        b = cxb(a.c, a.c.length);
        switch(b.length){
            case 0:
                return Fi;
            case 1:
                c = new Er(b[0]);
                return c;
            default:
                return new gr(Ti(b));
        }
    }
    function EY(a) {
        var b, c, d, e;
        d = xv(ow, syb, 64, a.c.length, 0, 1);
        e = 0;
        for(c = new Tob(a); c.a < c.c.c.length;){
            b = Wv(Rob(c), 64);
            d[e++] = b;
        }
        return new CY(d);
    }
    function sW(a) {
        var b, c;
        if (!a.b) {
            a.b = Do(a.a.b.c.length);
            for(c = new Tob(a.a.b); c.a < c.c.c.length;){
                b = Wv(Rob(c), 33);
                vU(a.b, new yW(b));
            }
        }
        return a.b;
    }
    function K6(a, b) {
        var c, d, e;
        if (a.e) return 1;
        c = 0;
        for(e = new Tob(b.f); e.a < e.c.c.length;){
            d = Wv(Rob(e), 7);
            c += d.b.c.length + d.e.c.length;
        }
        return c;
    }
    function I6(a) {
        var b, c, d, e;
        b = false;
        e = false;
        for(d = new Tob(a.f); d.a < d.c.c.length;){
            c = Wv(Rob(d), 7);
            b = b | c.g == (sN(), ZM);
            e = e | c.g == rN;
        }
        return b && e;
    }
    function bV(a) {
        var b, c;
        this.b = new GU;
        this.c = a;
        this.a = false;
        for(c = new Tob(a.b); c.a < c.c.c.length;){
            b = Wv(Rob(c), 9);
            this.a = this.a | b.g == (CX(), AX);
        }
    }
    function uX(a) {
        cX.call(this);
        this.g = (CX(), AX);
        this.f = (Mh(6, Vyb), new HU(6));
        this.c = (Mh(2, Vyb), new HU(2));
        this.e = new ZW;
        this.b = new ZW;
        this.a = a;
    }
    function ffb(a, b, c, d, e, f) {
        Teb(this);
        this.e = a;
        this.f = b;
        this.d = c;
        this.c = d;
        this.g = e;
        this.b = f;
        this.j = Ixb(Yv(e.mb().H()));
        this.i = Ixb(Yv(rl(e)));
    }
    function Lh(a, b) {
        if (a == null) throw new Wlb('null key in entry: null=' + b);
        else if (b == null) throw new Wlb('null value in entry: ' + a + '=null');
    }
    function Hab() {
        Hab = iI;
        Eab = VQ(new WQ, (d0(), v_));
        Fab = new DJ('linearSegments.inputPrio', Elb(0));
        Gab = new DJ('linearSegments.outputPrio', Elb(0));
    }
    function Cd(a) {
        var b, c, d, e;
        for(c = (e = new aob(a.b).a.bb().mb(), new fob(e)); c.a.G();){
            b = (d = Wv(c.a.H(), 21), Wv(d.zb(), 19));
            b.Q();
        }
        Ymb(a.b);
        a.c = 0;
    }
    function WI(a, b) {
        var c, d;
        Fxb(b, a.b);
        if (b >= a.b >> 1) {
            d = a.c;
            for(c = a.b; c > b; --c)d = d.b;
        } else {
            d = a.a.a;
            for(c = 0; c < b; ++c)d = d.a;
        }
        return new cvb(a, b, d);
    }
    function cU(a, b) {
        var c, d, e;
        e = new FI;
        for(d = a.mb(); d.G();){
            c = Wv(d.H(), 55);
            UT(c, e.a, 0);
            e.a += c.e.a + b;
            e.b = Nlb(e.b, c.e.b);
        }
        e.b > 0 && (e.b += b);
        return e;
    }
    function eU(a, b) {
        var c, d, e;
        e = new FI;
        for(d = a.mb(); d.G();){
            c = Wv(d.H(), 55);
            UT(c, 0, e.b);
            e.b += c.e.b + b;
            e.a = Nlb(e.a, c.e.a);
        }
        e.a > 0 && (e.a += b);
        return e;
    }
    function tub(a, b, c) {
        var d, e, f;
        e = Wv(Smb(a.c, b), 176);
        if (!e) {
            d = new Jub(a, b, c);
            Umb(a.c, b, d);
            Gub(d);
            return null;
        } else {
            f = job(e, c);
            uub(a, e);
            return f;
        }
    }
    function y3(a, b) {
        if (!Keb(a.b).kb(b.c)) return false;
        return Oeb(a.b) ? !(rgb(b.d, a.c, a.a) && rgb(b.a, a.c, a.a)) : rgb(b.d, a.c, a.a) && rgb(b.a, a.c, a.a);
    }
    function s6(a, b) {
        return a.c < b.c || a.c == b.c && d6(a.a) && d6(b.a) && h6(a.d, q6(a.a, a.b)) > h6(a.d, q6(b.a, b.b)) ? -1 : a.c == b.c && q6(a.a, a.b) == q6(a.a, a.b) ? 0 : 1;
    }
    function L5(a, b, c) {
        if (a.e) switch(a.b){
            case 1:
                g5(a.c, b, c);
                break;
            case 0:
                h5(a.c, b, c);
        }
        else e5(a.c, b, c);
        a.a[b.k][c.k] = a.c.i;
        a.a[c.k][b.k] = a.c.e;
    }
    function LW(a, b, c) {
        switch(c.e){
            case 1:
                a.a = b.a / 2;
                a.b = 0;
                break;
            case 2:
                a.a = b.a;
                a.b = b.b / 2;
                break;
            case 3:
                a.a = b.a / 2;
                a.b = b.b;
                break;
            case 4:
                a.a = 0;
                a.b = b.b / 2;
        }
    }
    function Jeb(a) {
        switch(a.e){
            case 8:
                return sN(), $M;
            case 9:
                return sN(), pN;
            case 10:
                return sN(), ZM;
            case 11:
                return sN(), rN;
            default:
                return sN(), qN;
        }
    }
    function Qt(a) {
        var b, c, d;
        b = 'Ot';
        d = Slb(a.length, 5);
        for(c = 0; c < d; c++)if (emb(a[c].d, b)) {
            a.length >= c + 1 && (a.splice(0, c + 1), undefined);
            break;
        }
        return a;
    }
    function Vv(a, b) {
        if (ew(a)) return !!Uv[b];
        else if (a._c) return !!a._c[b];
        else if (cw(a)) return !!Tv[b];
        else if (bw(a)) return !!Sv[b];
        return false;
    }
    function jQ() {
        RP();
        this.i = (mp(), new ntb);
        this.a = new ntb;
        this.k = new ntb;
        this.j = new ntb;
        this.b = new ntb;
        this.n = new ntb;
        this.f = new ntb;
        this.e = new ntb;
    }
    function r$(a, b) {
        var c, d;
        if (b.a.R(a)) return;
        else {
            d = Wv(rJ(a, (Rib(), hib)), 32);
            c = Wv(yU(a.f, 0), 7);
            d == (sN(), $M) ? QX(c, pN) : d == pN && QX(c, $M);
            b.a.db(a, b);
        }
    }
    function bbb(a) {
        var b, c;
        c = Plb(1, Wv(rJ(a, (Rib(), Eib)), 24).a);
        a.c.f.g == (CX(), AX) && a.d.f.g == AX ? b = 1 : a.c.f.g == AX || a.d.f.g == AX ? b = 2 : b = 8;
        return c * b;
    }
    function P1(a) {
        var b, c, d, e, f;
        f = Wv(rJ(a, (Rib(), uib)), 7);
        b = Wv(FU(a.b, xv(dB, gAb, 12, a.b.c.length, 0, 1)), 47);
        for(d = 0, e = b.length; d < e; ++d){
            c = b[d];
            eW(c, f);
        }
    }
    function Q1(a) {
        var b, c, d, e, f;
        c = Wv(rJ(a, (Rib(), uib)), 7);
        b = Wv(FU(a.e, xv(dB, gAb, 12, a.e.c.length, 0, 1)), 47);
        for(e = 0, f = b.length; e < f; ++e){
            d = b[e];
            dW(d, c);
        }
    }
    function Cfb(a) {
        var b, c;
        yfb(this);
        c = a.i;
        b = vI(new HI(c.a, c.b), a.j);
        this.d = Qlb(c.b, b.b);
        this.a = Nlb(c.b, b.b);
        this.b = Qlb(c.a, b.a);
        this.c = Nlb(c.a, b.a);
    }
    function ipb(a, b, c, d) {
        var e, f, g, h;
        !d && (d = (hsb(), hsb(), gsb));
        e = (f = epb(a, b, c), g = (h = new Array(c - b), Cv(h, a)), dxb(a, b, g, 0, f, true), g);
        jpb(e, a, b, c, -b, d);
    }
    function FU(a, b) {
        var c, d, e;
        e = a.c.length;
        b.length < e && (b = (d = new Array(e), Cv(d, b)));
        for(c = 0; c < e; ++c)Av(b, c, a.c[c]);
        b.length > e && Av(b, e, null);
        return b;
    }
    function npb(a, b) {
        var c, d, e;
        e = a.a.length;
        b.length < e && (b = (d = new Array(e), Cv(d, b)));
        for(c = 0; c < e; ++c)Av(b, c, a.a[c]);
        b.length > e && Av(b, e, null);
        return b;
    }
    function xb(a) {
        return ew(a) ? a : cw(a) ? ilb((Dxb(a), a)) : bw(a) ? Bkb(Ckb((Dxb(a), a))) : _v(a) ? a.w() : zv(a) ? ob(a) : a.toString ? a.toString() : '[JavaScriptObject]';
    }
    function A6(a) {
        var b, c, d, e, f;
        f = 0;
        for(c = a.b, d = 0, e = c.length; d < e; ++d){
            b = c[d];
            b.g == (CX(), zX) || Umb(a.c, b, Elb(f++));
            E6(a, b, a.d, (sN(), $M));
            E6(a, b, a.j, pN);
        }
    }
    function kbb() {
        kbb = iI;
        jbb = new lbb('SIMPLE', 0);
        gbb = new lbb(zAb, 1);
        hbb = new lbb('LINEAR_SEGMENTS', 2);
        fbb = new lbb('BRANDES_KOEPF', 3);
        ibb = new lbb(DAb, 4);
    }
    function Xib() {
        Xib = iI;
        Wib = new Yib(tzb, 0);
        Sib = new Yib('FIRST', 1);
        Tib = new Yib('FIRST_SEPARATE', 2);
        Uib = new Yib('LAST', 3);
        Vib = new Yib('LAST_SEPARATE', 4);
    }
    function Ndb() {
        Ndb = iI;
        Mdb = new Vdb;
        Kdb = TQ(new WQ, (d0(), A_));
        Ldb = PQ(TQ(new WQ, R_), Q_);
        Idb = PQ(UQ(TQ(SQ(new WQ, D_), F_), H_), E_);
        Jdb = PQ(UQ(new WQ, H_), q_);
    }
    function ceb(a) {
        var b, c, d, e;
        for(c = (e = new Snb(a.d.a).a.bb().mb(), new Ynb(e)); c.a.G();){
            b = (d = Wv(c.a.H(), 21), Wv(d.yb(), 12));
            vU(b.c.e, b);
            vU(b.d.b, b);
        }
    }
    function vvb(a, b) {
        var c, d;
        vxb(b > 0);
        if ((b & -b) == b) return hw(b * wvb(a, 31) * 4.6566128730773926E-10);
        do {
            c = wvb(a, 31);
            d = c % b;
        }while (c - d + (b - 1) < 0);
        return hw(d);
    }
    function zcb(a, b) {
        if (a.c.f == b) return a.d.f;
        else if (a.d.f == b) return a.c.f;
        else throw new slb('Node ' + b + ' is neither source nor target of edge ' + a);
    }
    function Ekb(a, b, c) {
        vxb(a >= 0 && a <= 1114111);
        if (a >= ayb) {
            b[c++] = 55296 + (a - ayb >> 10 & 1023) & byb;
            b[c] = 56320 + (a - ayb & 1023) & byb;
            return 2;
        } else {
            b[c] = a & byb;
            return 1;
        }
    }
    function Ol(a, b) {
        Il();
        var c, d;
        while(a.G()){
            if (!b.G()) return false;
            c = a.H();
            d = b.H();
            if (!(gw(c) === gw(d) || c != null && rb(c, d))) return false;
        }
        return !b.G();
    }
    function JS(a) {
        var b, c, d;
        Vvb(a.b.a);
        a.a = xv(kA, syb, 25, a.c.b.a.b.c.length, 0, 1);
        b = 0;
        for(d = new Tob(a.c.b.a.b); d.a < d.c.c.length;){
            c = Wv(Rob(d), 25);
            c.k = b++;
        }
    }
    function PT(a) {
        var b, c, d, e;
        Gpb(a.c, a.a);
        for(e = new Tob(a.c); e.a < e.c.c.length;){
            d = Rob(e);
            for(c = new Tob(a.b); c.a < c.c.c.length;){
                b = Wv(Rob(c), 160);
                b.Ec(d);
            }
        }
    }
    function zW(a) {
        var b, c;
        if (!a.a) {
            a.a = Do(Wv(a.e, 9).c.c.length);
            for(c = new Tob(Wv(a.e, 9).c); c.a < c.c.c.length;){
                b = Wv(Rob(c), 33);
                vU(a.a, new yW(b));
            }
        }
        return a.a;
    }
    function DW(a) {
        var b, c;
        if (!a.b) {
            a.b = Do(Wv(a.e, 7).c.c.length);
            for(c = new Tob(Wv(a.e, 7).c); c.a < c.c.c.length;){
                b = Wv(Rob(c), 33);
                vU(a.b, new yW(b));
            }
        }
        return a.b;
    }
    function F6(a) {
        this.b = a;
        this.c = (mp(), new ntb);
        this.i = new ntb;
        this.d = new ntb;
        this.j = new ntb;
        this.k = gw(rJ(hX(a[0]), (eM(), uL))) === gw((NK(), JK));
        A6(this);
    }
    function sgb(a) {
        switch(a.e){
            case 1:
                return 4.71238898038469;
            default:
            case 2:
                return 0;
            case 3:
                return 1.5707963267948966;
            case 4:
                return 3.141592653589793;
        }
    }
    function Ql(a) {
        Il();
        var b;
        b = Kl(a);
        if (!Cm(a)) throw new okb('position (0) must be less than the number of elements that remained (' + b + ')');
        return Dm(a);
    }
    function un(b, c) {
        var d, e;
        d = b.ub(c);
        try {
            e = d.H();
            d.I();
            return e;
        } catch (a) {
            a = OH(a);
            if (aw(a, 74)) throw new okb("Can't remove element " + c);
            else throw NH(a);
        }
    }
    function Ye(a, b) {
        var c, d, e, f;
        f = a.Y();
        b.length < f && (b = (e = new Array(f), Cv(e, b)));
        d = a.mb();
        for(c = 0; c < f; ++c)Av(b, c, d.H());
        b.length > f && Av(b, f, null);
        return b;
    }
    function qX(a, b, c) {
        if (!!c && (b < 0 || b > c.a.c.length)) throw new slb('index must be >= 0 and <= layer node count');
        !!a.d && BU(a.d.a, a);
        a.d = c;
        !!c && uU(c.a, b, a);
    }
    function Zvb(a, b, c, d, e, f, g, h) {
        var i, j;
        if (!d) return;
        i = d.a[0];
        !!i && Zvb(a, b, c, i, e, f, g, h);
        $vb(a, c, d.d, e, f, g, h) && b.ib(d);
        j = d.a[1];
        !!j && Zvb(a, b, c, j, e, f, g, h);
    }
    function Gxb(a, b, c) {
        if (a < 0) throw new okb(jyb + a + ' < 0');
        if (b > c) throw new okb('toIndex: ' + b + ' > size ' + c);
        if (a > b) throw new slb(jyb + a + ' > toIndex: ' + b);
    }
    function ee(a, b) {
        var c, d, e;
        c = b.yb();
        e = b.zb();
        d = a.cb(c);
        if (!(gw(e) === gw(d) || e != null && rb(e, d))) return false;
        if (d == null && !a.R(c)) return false;
        return true;
    }
    function h1(a, b, c) {
        var d;
        d = b.c.f;
        if (d.g == (CX(), zX)) {
            sJ(a, (Rib(), qib), Wv(rJ(d, qib), 7));
            sJ(a, rib, Wv(rJ(d, rib), 7));
        } else {
            sJ(a, (Rib(), qib), b.c);
            sJ(a, rib, c.d);
        }
    }
    function w2(a, b, c) {
        var d;
        d = b.c.f;
        if (d.g == (CX(), zX)) {
            sJ(a, (Rib(), qib), Wv(rJ(d, qib), 7));
            sJ(a, rib, Wv(rJ(d, rib), 7));
        } else {
            sJ(a, (Rib(), qib), b.c);
            sJ(a, rib, c.d);
        }
    }
    function at(a, b, c) {
        var d, e, f, g, h;
        bt(a);
        for(e = (a.i == null && (a.i = xv(_F, Txb, 46, 0, 0, 1)), a.i), f = 0, g = e.length; f < g; ++f){
            d = e[f];
            at(d, b, '\t' + c);
        }
        h = a.e;
        !!h && at(h, b, c);
    }
    function yv(a, b) {
        var c = new Array(b);
        var d;
        switch(a){
            case 11:
            case 12:
                d = 0;
                break;
            case 13:
                d = false;
                break;
            default:
                return c;
        }
        for(var e = 0; e < b; ++e)c[e] = d;
        return c;
    }
    function P5(a) {
        var b, c, d, e;
        e = xv(qB, Txb, 51, a.a.length, 0, 2);
        for(c = 0; c < e.length; c++){
            d = a.a[c].length;
            b = xv(qB, Nzb, 9, d, 0, 1);
            Gmb(a.a[c], 0, b, 0, d);
            e[c] = b;
        }
        return e;
    }
    function AW(a) {
        var b, c;
        if (!a.b) {
            a.b = Do(Wv(a.e, 9).f.c.length);
            for(c = new Tob(Wv(a.e, 9).f); c.a < c.c.c.length;){
                b = Wv(Rob(c), 7);
                vU(a.b, new FW(b, a.c));
            }
        }
        return a.b;
    }
    function sp(b, c) {
        mp();
        _b(b);
        try {
            return ew(c) ? Xmb(b, c) : Mtb(b.d, c);
        } catch (a) {
            a = OH(a);
            if (aw(a, 119)) return null;
            else if (aw(a, 76)) return null;
            else throw NH(a);
        }
    }
    function Blb(a) {
        var b;
        b = (Ilb(), Hlb);
        return b[a >>> 28] | b[a >> 24 & 15] << 4 | b[a >> 20 & 15] << 8 | b[a >> 16 & 15] << 12 | b[a >> 12 & 15] << 16 | b[a >> 8 & 15] << 20 | b[a >> 4 & 15] << 24 | b[a & 15] << 28;
    }
    function ZV(a, b, c) {
        var d, e;
        if (b.c == (djb(), bjb) && c.c == ajb) return -1;
        else if (b.c == ajb && c.c == bjb) return 1;
        d = aW(b.a, a.a);
        e = aW(c.a, a.a);
        return b.c == bjb ? e - d : d - e;
    }
    function L7(a) {
        var b, c, d, e, f;
        e = $xb;
        f = null;
        for(d = new Tob(a.d); d.a < d.c.c.length;){
            c = Wv(Rob(d), 89);
            if (c.c.j ^ c.d.j) {
                b = c.d.e - c.c.e - c.a;
                if (b < e) {
                    e = b;
                    f = c;
                }
            }
        }
        return f;
    }
    function $vb(a, b, c, d, e, f, g) {
        var h, i;
        if (b.Xc() && (i = a.a.$b(c, d), i < 0 || !e && i == 0)) return false;
        if (b.Yc() && (h = a.a.$b(c, f), h > 0 || !g && h == 0)) return false;
        return true;
    }
    function Yj(a) {
        hi();
        var b, c;
        if (!a.G()) return kr(), jr;
        c = a.H();
        if (!a.G()) return new Gr(c);
        b = new Wub;
        stb(b, _b(c));
        do stb(b, _b(a.H()));
        while (a.G());
        return ck(b);
    }
    function m6(a, b, c) {
        a.e = b;
        a.a = c;
        a.d = n6(a, (sN(), ZM));
        a.d += n6(a, rN);
        j6(a, b, c, ZM, a.f);
        j6(a, b, c, rN, a.n);
        a.b = n6(a, ZM);
        a.b += n6(a, rN);
        j6(a, c, b, ZM, a.f);
        j6(a, c, b, rN, a.n);
    }
    function hmb(a) {
        var b, c, d;
        c = (bmb(), a.length);
        d = 0;
        while(d < c && a.charCodeAt(d) <= 32)++d;
        b = c;
        while(b > d && a.charCodeAt(b - 1) <= 32)--b;
        return d > 0 || b < c ? a.substr(d, b - d) : a;
    }
    function dxb(a, b, c, d, e, f) {
        var g, h, i;
        if (gw(a) === gw(c)) {
            a = a.slice(b, b + e);
            b = 0;
        }
        for(h = b, i = b + e; h < i;){
            g = h + 10000 < i ? h + 10000 : i;
            e = g - h;
            bxb(c, d, f ? e : 0, a.slice(h, g));
            h = g;
            d += e;
        }
    }
    function Nv(a) {
        var b, c, d;
        if (Iv(a, (Rv(), Qv)) < 0) return -Fv((b = ~a.l + 1 & azb, c = ~a.m + (b == 0 ? 1 : 0) & azb, d = ~a.h + (b == 0 && c == 0 ? 1 : 0) & bzb, Ev(b, c, d)));
        return a.l + a.m * czb + a.h * dzb;
    }
    function JW(a, b) {
        var c;
        c = a.f;
        switch(b.e){
            case 1:
                return -(a.i.b + a.j.b);
            case 2:
                return a.i.a - c.j.a;
            case 3:
                return a.i.b - c.j.b;
            case 4:
                return -(a.i.a + a.j.a);
        }
        return 0;
    }
    function KM() {
        KM = iI;
        JM = new NM(szb, 0);
        IM = new NM('FREE', 1);
        HM = new NM('FIXED_SIDE', 2);
        EM = new NM('FIXED_ORDER', 3);
        GM = new NM('FIXED_RATIO', 4);
        FM = new NM('FIXED_POS', 5);
    }
    function ZT(a, b) {
        var c, d, e, f;
        c = Wv(rJ(b, (Rib(), fib)), 18);
        f = Wv(Dd(WT, c), 18);
        for(e = f.mb(); e.G();){
            d = Wv(e.H(), 18);
            if (!Wv(Dd(a.a, d), 20).V()) return false;
        }
        return true;
    }
    function HY(a, b, c) {
        this.b = new Dh;
        this.i = new GU;
        this.d = new JY(this);
        this.g = a;
        this.a = b.c.length;
        this.c = b;
        this.e = Wv(yU(this.c, this.c.c.length - 1), 9);
        this.f = c;
        FY(this);
    }
    function Pgb() {
        Pgb = iI;
        Lgb = new Rgb('ALWAYS_UP', 0);
        Kgb = new Rgb('ALWAYS_DOWN', 1);
        Ngb = new Rgb('DIRECTION_UP', 2);
        Mgb = new Rgb('DIRECTION_DOWN', 3);
        Ogb = new Rgb('SMART', 4);
    }
    function Iv(a, b) {
        var c, d, e, f, g, h, i, j;
        i = a.h >> 19;
        j = b.h >> 19;
        if (i != j) return j - i;
        e = a.h;
        h = b.h;
        if (e != h) return e - h;
        d = a.m;
        g = b.m;
        if (d != g) return d - g;
        c = a.l;
        f = b.l;
        return c - f;
    }
    function K7(a) {
        var b, c, d, e;
        for(c = (e = new Snb(a.p.a).a.bb().mb(), new Ynb(e)); c.a.G();){
            b = (d = Wv(c.a.H(), 21), Wv(d.yb(), 89));
            if (b.e && a.b[b.b] < 0) return b;
        }
        return null;
    }
    function TN(a, b) {
        var c, d, e, f, g;
        d = Qlb(a.d, b.d);
        f = Qlb(a.e, b.e);
        e = Nlb(a.d + a.c, b.d + b.c);
        g = Nlb(a.e + a.b, b.e + b.b);
        if (e < d) {
            c = d;
            d = e;
            e = c;
        }
        if (g < f) {
            c = f;
            f = g;
            g = c;
        }
        SN(a, d, f, e - d, g - f);
    }
    function hQ(a, b) {
        var c;
        if (Gzb in a.a) {
            c = Pu(a, Gzb);
            if (!c.kc()) throw new GQ("The 'properties' property of a graph element must be an object.", c, a);
            iQ(c.kc(), b, true);
        }
    }
    function HS(a, b) {
        var c, d, e;
        d = a.b.j.e;
        a.a || (d += a.b.j.b);
        e = b.b.j.e;
        b.a || (e += b.b.j.b);
        c = glb(d, e);
        if (c == 0) {
            if (!a.a && b.a) return -1;
            else if (!b.a && a.a) return 1;
        }
        return c;
    }
    function kX(a) {
        var b, c;
        switch(Wv(rJ(hX(a), (Mjb(), ujb)), 174).e){
            case 0:
                b = a.i;
                c = a.j;
                return new HI(b.a + c.a / 2, b.b + c.b / 2);
            case 1:
                return new II(a.i);
            default:
                return null;
        }
    }
    function RX() {
        LX();
        cX.call(this);
        this.g = (sN(), qN);
        this.a = new FI;
        this.d = new ZW;
        this.c = (Mh(2, Vyb), new HU(2));
        this.b = (Mh(4, Vyb), new HU(4));
        this.e = (Mh(4, Vyb), new HU(4));
    }
    function G6(a, b, c) {
        a.d = 0;
        a.b = 0;
        P6(a, b, c);
        b.g == (CX(), BX) && c.g == zX ? M6(b).g == (sN(), $M) ? a.d = 1 : a.b = 1 : c.g == BX && b.g == zX && (M6(c).g == (sN(), $M) ? a.b = 1 : a.d = 1);
        O6(a, b, c);
    }
    function h9(a, b) {
        var c, d;
        for(d = new Tob(b); d.a < d.c.c.length;){
            c = Wv(Rob(d), 9);
            a.a[c.d.k][c.k].a = uvb(a.e);
            a.a[c.d.k][c.k].d = Ixb(a.a[c.d.k][c.k].a);
            a.a[c.d.k][c.k].b = 1;
        }
    }
    function d9(a, b, c) {
        var d, e, f;
        for(f = new Tob(b); f.a < f.c.c.length;){
            d = Wv(Rob(f), 9);
            a.a[d.d.k][d.k].e = false;
        }
        for(e = new Tob(b); e.a < e.c.c.length;){
            d = Wv(Rob(e), 9);
            c9(a, d, c);
        }
    }
    function Ydb(a, b) {
        var c, d, e, f;
        c = 0;
        d = 0;
        for(f = new Tob(b.b); f.a < f.c.c.length;){
            e = Wv(Rob(f), 33);
            c = Nlb(c, e.j.a);
            d += e.j.b;
        }
        sJ(b, (Rib(), Lib), new HI(c, d));
        a.k < c && (a.k = c);
        a.j += d;
    }
    function Vbb(a, b) {
        this.c = (mp(), new ntb);
        this.a = a;
        this.b = b;
        this.d = Wv(rJ(a, (Rib(), Kib)), 134);
        gw(rJ(a, (Mjb(), hjb))) === gw((lcb(), kcb)) ? this.e = new Jcb : this.e = new Ccb;
    }
    function Z4(a, b) {
        var c, d, e, f;
        e = 0;
        for(d = 0; d < b.length; d++){
            c = b[d];
            if (d < b.length - 1) {
                f = b[d + 1];
                e += $4(a, c, f);
            }
            e += (a.d = new F6(c), x6(a.d));
            e += (a.a = new k6(c), a6(a.a));
        }
        return e;
    }
    function S6(a) {
        switch(a.c.e){
            case 1:
                return LX(), HX;
            case 2:
                return LX(), FX;
            case 3:
                return LX(), JX;
            case 4:
                return LX(), KX;
        }
        throw new Imb("Can't filter on undefined side");
    }
    function Pr(b, c) {
        var d;
        try {
            d = b.c.a;
            if (!ok(b.b, c) || !d) return 0;
            return Es(d, b.d, c);
        } catch (a) {
            a = OH(a);
            if (aw(a, 119)) return 0;
            else if (aw(a, 76)) return 0;
            else throw NH(a);
        }
    }
    function J4(a) {
        var b, c, d, e, f;
        for(d = new rnb(new inb(a.b).a); d.b;){
            c = pnb(d);
            b = Wv(c.yb(), 9);
            f = Wv(Wv(c.zb(), 27).a, 9);
            e = Wv(Wv(c.zb(), 27).b, 10);
            vI(BI(b.i), vI(xI(f.i), e));
        }
    }
    function B9(a, b, c) {
        var d, e, f;
        d = glb(a.a[b.k], a.a[c.k]);
        if (d == 0) {
            e = Wv(rJ(b, (Rib(), oib)), 20);
            f = Wv(rJ(c, oib), 20);
            if (e.kb(c)) return -1;
            else if (f.kb(b)) return 1;
        }
        return d;
    }
    function ogb(a, b) {
        var c, d;
        d = vI(xI(a.i), a.a);
        c = a.f.j;
        switch(b.e){
            case 1:
                return -d.b;
            case 2:
                return -d.a + c.a;
            case 3:
                return -d.b + c.b;
            case 4:
                return -d.a;
            default:
                return 0;
        }
    }
    function Z8(a, b) {
        var c, d, e, f;
        for(e = 0; e < b.length; e++){
            e + 1 < b.length && X8(a, b[e + 1], (djb(), ajb));
            f = b[e];
            c = 0;
            for(d = 0; d < f.length; d++){
                Y8(a, f[d]);
                c += a.Hc(f[d], c, (djb(), bjb));
            }
        }
    }
    function Mfb() {
        Mfb = iI;
        Lfb = UQ(UQ(RQ(new WQ, (d0(), __)), $_), a0);
        Hfb = PQ(UQ(TQ(SQ(new WQ, D_), F_), H_), E_);
        Jfb = TQ(new WQ, A_);
        Kfb = PQ(TQ(new WQ, R_), Q_);
        Ifb = PQ(UQ(new WQ, H_), q_);
    }
    function dI(b, c, d, e) {
        cI();
        var f = aI;
        $moduleName = c;
        $moduleBase = d;
        LH = e;
        function g() {
            for(var a = 0; a < f.length; a++)f[a]();
        }
        if (b) try {
            Rxb(g)();
        } catch (a) {
            b(c, a);
        }
        else Rxb(g)();
    }
    function clb(a) {
        blb == null && (blb = /^\s*[+-]?(NaN|Infinity|((\d+\.?\d*)|(\.\d+))([eE][+-]?\d+)?[dDfF]?)\s*$/);
        if (!elb(blb, a)) throw new Ylb(dyb + a + '"');
        return parseFloat(a);
    }
    function _gb() {
        _gb = iI;
        Ygb = new ahb(tzb, 0);
        Xgb = new ahb('LEFTUP', 1);
        $gb = new ahb('RIGHTUP', 2);
        Wgb = new ahb('LEFTDOWN', 3);
        Zgb = new ahb('RIGHTDOWN', 4);
        Vgb = new ahb('BALANCED', 5);
    }
    function zgb() {
        zgb = iI;
        ygb = new Agb('V_TOP', 0);
        xgb = new Agb('V_CENTER', 1);
        wgb = new Agb('V_BOTTOM', 2);
        ugb = new Agb('H_LEFT', 3);
        tgb = new Agb('H_CENTER', 4);
        vgb = new Agb('H_RIGHT', 5);
    }
    function YK() {
        YK = iI;
        WK = new ZK(tzb, 0);
        UK = new ZK('DIRECTED', 1);
        XK = new ZK('UNDIRECTED', 2);
        SK = new ZK('ASSOCIATION', 3);
        VK = new ZK('GENERALIZATION', 4);
        TK = new ZK('DEPENDENCY', 5);
    }
    function CX() {
        CX = iI;
        AX = new DX('NORMAL', 0);
        zX = new DX('LONG_EDGE', 1);
        xX = new DX('EXTERNAL_PORT', 2);
        BX = new DX('NORTH_SOUTH_PORT', 3);
        yX = new DX('LABEL', 4);
        wX = new DX('BIG_NODE', 5);
    }
    function wv(a, b, c, d, e, f, g) {
        var h, i, j, k, l;
        k = e[f];
        j = f == g - 1;
        h = j ? d : 0;
        l = yv(h, k);
        d != 9 && Bv(tv(a, g - f), b[f], c[f], h, l);
        if (!j) {
            ++f;
            for(i = 0; i < k; ++i)l[i] = wv(a, b, c, d, e, f, g);
        }
        return l;
    }
    function gX(a) {
        var b, c, d;
        b = new GU;
        for(d = new Tob(a.f); d.a < d.c.c.length;){
            c = Wv(Rob(d), 7);
            vU(b, Sh((Gi(), new gr(Ti(Bv(tv(UF, 1), syb, 1, 4, [
                c.b,
                c.e
            ]))))));
        }
        return _b(b), new Vh(b);
    }
    function b7(a, b, c) {
        this.a = c;
        if (a >= b.length) throw new okb('Greedy SwitchDecider: Free layer layer not in graph.');
        this.b = b[a];
        this.c = new r6(this.b);
        this.d = new R6(this.b);
    }
    function _n(a, b) {
        var c;
        this.f = a;
        this.b = this.f.c;
        c = a.d;
        bc(b, c);
        if (b >= (c / 2 | 0)) {
            this.e = a.e;
            this.d = c;
            while(b++ < c)Zn(this);
        } else {
            this.c = a.a;
            while(b-- > 0)Yn(this);
        }
        this.a = null;
    }
    function qS(a) {
        var b, c, d;
        for(c = new Tob(a.a.b); c.a < c.c.c.length;){
            b = Wv(Rob(c), 25);
            d = b.j.d;
            b.j.d = b.j.e;
            b.j.e = d;
            d = b.j.c;
            b.j.c = b.j.b;
            b.j.b = d;
            d = b.g.a;
            b.g.a = b.g.b;
            b.g.b = d;
        }
        fS(a);
    }
    function f1(a, b) {
        var c, d, e;
        d = new Fnb(a.b, 0);
        while(d.b < d.d.Y()){
            c = (Bxb(d.b < d.d.Y()), Wv(d.d.sb(d.c = d.b++), 33));
            e = Wv(rJ(c, (eM(), tL)), 107);
            if (e == (EK(), BK)) {
                vnb(d);
                vU(b.b, c);
            }
        }
    }
    function Vab(a, b, c) {
        var d, e, f, g;
        g = zU(a.f, b, 0);
        f = new Wab;
        f.b = c;
        d = new Fnb(a.f, g);
        while(d.b < d.d.Y()){
            e = (Bxb(d.b < d.d.Y()), Wv(d.d.sb(d.c = d.b++), 9));
            e.k = c;
            vU(f.f, e);
            vnb(d);
        }
        return f;
    }
    function Eq(a, b) {
        Dq();
        var c, d, e;
        if (b.V()) return false;
        if (aw(b, 207)) {
            e = Wv(b, 207);
            for(d = e.bb().mb(); d.G();){
                c = Wv(d.H(), 83);
                a.Bb(c.Zb(), c.Yb());
            }
        } else Jl(a, b.mb());
        return true;
    }
    function MN() {
        MN = iI;
        KN = new NN('DEFAULT_MINIMUM_SIZE', 0);
        LN = new NN('MINIMUM_SIZE_ACCOUNTS_FOR_INSETS', 1);
        JN = new NN('COMPUTE_INSETS', 2);
        IN = new NN('APPLY_ADDITIONAL_INSETS', 3);
    }
    function MP(a) {
        var b, c, d, e;
        c = a.a.b + 2;
        e = xv(qz, Fzb, 10, c, 0, 1);
        e[0] = xI(MX(a.c));
        d = WI(a.a, 0);
        while(d.b != d.d.c){
            b = Wv(_ub(d), 10);
            e[d.a] = new HI(b.a, b.b);
        }
        e[c - 1] = xI(MX(a.d));
        return e;
    }
    function ge(a, b, c) {
        var d, e, f;
        for(e = a.bb().mb(); e.G();){
            d = Wv(e.H(), 21);
            f = d.yb();
            if (gw(b) === gw(f) || b != null && rb(b, f)) {
                if (c) {
                    d = new qob(d.yb(), d.zb());
                    e.I();
                }
                return d;
            }
        }
        return null;
    }
    function f9(a, b, c) {
        var d, e;
        d = a.a[b.d.k][b.k];
        e = a.a[c.d.k][c.k];
        if (d.a != null && e.a != null) return flb(d.a, e.a);
        else if (d.a != null) return -1;
        else if (e.a != null) return 1;
        return 0;
    }
    function beb(a, b, c) {
        var d, e, f;
        e = b.c;
        f = b.d;
        d = c;
        if (stb(a.a, b)) {
            Xdb(a, e) && (d = true);
            Xdb(a, f) && (d = true);
            if (d) {
                BU(b.c.e, b);
                BU(b.d.b, b);
                stb(a.d, b);
            }
            Ydb(a, b);
            return true;
        }
        return false;
    }
    function $eb(a, b, c) {
        var d, e;
        e = Zeb(a, b);
        if (e == a.c) return Web(a, Yeb(a, b));
        if (c) {
            _eb(a, b, a.c - e);
            return Web(a, Yeb(a, b));
        } else {
            d = new dfb(a);
            _eb(d, b, a.c - e);
            return Web(d, Yeb(d, b));
        }
    }
    function $tb() {
        function b() {
            try {
                return (new Map).entries().next().done;
            } catch (a) {
                return false;
            }
        }
        if (typeof Map === Zxb && Map.prototype.entries && b()) return Map;
        else return _tb();
    }
    function Dd(a, b) {
        var c;
        c = Wv(Smb(a.b, b), 19);
        !c && (c = a.Z());
        return aw(c, 137) ? new Lg(a, b, Wv(c, 137)) : aw(c, 18) ? new Kg(a, b, Wv(c, 18)) : aw(c, 20) ? Ld(a, b, Wv(c, 20), null) : new _f(a, b, c, null);
    }
    function Gs(a) {
        switch(Rs(a.e) - Rs(a.g)){
            case -2:
                Cs(a.g) > 0 && (a.g = Ls(a.g));
                return Ks(a);
            case 2:
                Cs(a.e) < 0 && (a.e = Ks(a.e));
                return Ls(a);
            default:
                a.d = 1 + Plb(Rs(a.e), Rs(a.g));
                return a;
        }
    }
    function k5(a, b) {
        this.f = (mp(), new ntb);
        this.b = new ntb;
        this.j = new ntb;
        this.a = a;
        this.c = b;
        this.c > 0 && j5(this, this.c - 1, (sN(), ZM));
        this.c < this.a.length - 1 && j5(this, this.c + 1, (sN(), rN));
    }
    function jt(a) {
        var b;
        if (a.c == null) {
            b = gw(a.b) === gw(ht) ? null : a.b;
            a.d = b == null ? Wxb : dw(b) ? mt(Zv(b)) : ew(b) ? 'String' : Ikb(tb(b));
            a.a = a.a + ': ' + (dw(b) ? lt(Zv(b)) : b + '');
            a.c = '(' + a.d + ') ' + a.a;
        }
    }
    function IY(a) {
        var b, c, d, e;
        for(c = new Tob(a.a.c); c.a < c.c.c.length;){
            b = Wv(Rob(c), 9);
            for(e = WI(Eo(b.c), 0); e.b != e.d.c;){
                d = Wv(_ub(e), 33);
                rJ(d, (Rib(), uib)) == null && BU(b.c, d);
            }
        }
        return null;
    }
    function e3(a, b) {
        var c, d, e, f, g;
        g = new GU;
        for(d = Wv(qsb(a3, a), 20).mb(); d.G();){
            c = Wv(d.H(), 75);
            xU(g, c.b);
        }
        Dpb(g);
        K2(g, a.a);
        for(f = new Tob(g); f.a < f.c.c.length;){
            e = Wv(Rob(f), 7);
            Anb(b, e);
        }
    }
    function P7(a) {
        var b, c, d, e;
        while(a.o.a.c.length != 0){
            c = Wv(Svb(a.o), 27);
            d = Wv(c.a, 61);
            b = Wv(c.b, 89);
            e = c7(b, d);
            if (b.d == d) {
                o7(e.g, b);
                d.e = e.e + b.a;
            } else {
                o7(e.c, b);
                d.e = e.e - b.a;
            }
            vU(a.e.a, d);
        }
    }
    function Tr(a, b, c) {
        var d, e, f;
        Mh(c, 'count');
        if (!ok(a.b, b)) {
            Xb(c == 0);
            return 0;
        }
        f = a.c.a;
        if (!f) {
            c > 0 && Lr(a, b, c);
            return 0;
        }
        e = xv(mw, Yyb, 26, 1, 12, 1);
        d = Ns(f, a.d, b, c, e);
        Us(a.c, f, d);
        return e[0];
    }
    function l$(a, b) {
        var c, d, e, f, g;
        e = Wv(rJ(b, (Rib(), Jib)), 15).a * Wv(rJ(b, (Mjb(), qjb)), 15).a;
        g = a[0].i.a + a[0].j.a;
        for(f = 1; f < a.length; f++){
            c = a[f].i;
            d = a[f].j;
            c.a <= g + e && (c.a = g + e);
            g = c.a + d.a;
        }
    }
    function tvb() {
        tvb = iI;
        var a, b, c, d;
        qvb = xv(kw, hyb, 26, 25, 12, 1);
        rvb = xv(kw, hyb, 26, 33, 12, 1);
        d = 1.52587890625E-5;
        for(b = 32; b >= 0; b--){
            rvb[b] = d;
            d *= 0.5;
        }
        c = 1;
        for(a = 24; a >= 0; a--){
            qvb[a] = c;
            c *= 0.5;
        }
    }
    function f5(a) {
        while(a.g.c != 0 && a.d.c != 0){
            if (o5(a.g).c > o5(a.d).c) {
                a.i += a.g.c;
                q5(a.d);
            } else if (o5(a.d).c > o5(a.g).c) {
                a.e += a.d.c;
                q5(a.g);
            } else {
                a.i += n5(a.g);
                a.e += n5(a.d);
                q5(a.g);
                q5(a.d);
            }
        }
    }
    function TP(a) {
        if (!a) throw new EQ('An element is null. The origin of an edge could not be determined, this might be due to an inconsistency within the internal element mappings.');
    }
    function UP(a, b) {
        var c, d;
        Ymb(a.i);
        Ymb(a.a);
        Ymb(a.k);
        Ymb(a.j);
        Ymb(a.b);
        Ymb(a.n);
        Ymb(a.f);
        Ymb(a.e);
        if (a.d) {
            d = Pu(a.d, OP.b);
            !!d && !!d.ic() && (a.c = d.ic().a);
        }
        c = fQ(a, b, null);
        bQ(a, b);
        return c;
    }
    function kfb(a) {
        var b, c, d, e, f, g;
        d = hfb(gfb(a));
        b = rAb;
        f = 0;
        e = 0;
        while(b > 0.5 && f < 50){
            e = ofb(d);
            c = $eb(d, e, true);
            b = Jlb(c.b);
            ++f;
        }
        g = Yv(tn(Eo(a.g), Eo(a.g).b - 1));
        return $eb(a, (Dxb(g), g) - e, false);
    }
    function lfb(a) {
        var b, c, d, e, f, g;
        d = hfb(gfb(a));
        b = rAb;
        f = 0;
        e = 0;
        while(b > 0.5 && f < 50){
            e = nfb(d);
            c = $eb(d, e, true);
            b = Jlb(c.a);
            ++f;
        }
        g = Yv(tn(Eo(a.g), Eo(a.g).b - 1));
        return $eb(a, (Dxb(g), g) - e, false);
    }
    function Ze(a) {
        var b, c, d, e;
        e = new Bmb('[');
        b = false;
        for(d = a.mb(); d.G();){
            c = d.H();
            b ? (e.a += ', ', e) : b = true;
            ymb(e, c === a ? '(this Collection)' : (bmb(), c == null ? Wxb : xb(c)));
        }
        e.a += ']';
        return e.a;
    }
    function ie(a) {
        var b, c, d, e;
        e = new Bmb('{');
        b = false;
        for(d = a.bb().mb(); d.G();){
            c = Wv(d.H(), 21);
            b ? (e.a += ', ', e) : b = true;
            ymb(e, je(a, c.yb()));
            e.a += '=';
            ymb(e, je(a, c.zb()));
        }
        e.a += '}';
        return e.a;
    }
    function Ks(a) {
        var b;
        dc(!!a.g);
        b = a.g;
        a.g = b.e;
        b.e = a;
        b.j = a.j;
        b.a = a.a;
        a.a = 1 + Zr(a.e) + Zr(a.g);
        a.j = PH(PH(a.c, Ts(a.e)), Ts(a.g));
        a.d = 1 + Plb(Rs(a.e), Rs(a.g));
        b.d = 1 + Plb(Rs(b.e), Rs(b.g));
        return b;
    }
    function Ls(a) {
        var b;
        dc(!!a.e);
        b = a.e;
        a.e = b.g;
        b.g = a;
        b.j = a.j;
        b.a = a.a;
        a.a = 1 + Zr(a.e) + Zr(a.g);
        a.j = PH(PH(a.c, Ts(a.e)), Ts(a.g));
        a.d = 1 + Plb(Rs(a.e), Rs(a.g));
        b.d = 1 + Plb(Rs(b.e), Rs(b.g));
        return b;
    }
    function ZO(a) {
        var b;
        if (!Qob(new Tob(AW(a.e)))) return;
        b = Wv(oW(a.e, (eM(), TL)), 28);
        b == (KM(), FM) ? SO(a.e) : b == GM ? TO(a.e) : Ckb(Ixb(Xv(oW(a.e, AL)))) || a.e.e.j.a == 0 && a.e.e.j.b == 0 ? UO(a.e) : WO(a);
    }
    function s3(a, b, c) {
        var d, e, f;
        e = new Tob(a);
        if (e.a < e.c.c.length) {
            f = Wv(Rob(e), 33);
            d = r3(f, b, c);
            while(e.a < e.c.c.length){
                f = Wv(Rob(e), 33);
                Afb(d, r3(f, b, c));
            }
            return new Dfb(d);
        } else return null;
    }
    function u2(a, b) {
        var c, d, e, f, g, h;
        e = 0;
        for(d = new Tob(b.c); d.a < d.c.c.length;){
            c = Wv(Rob(d), 16);
            for(g = new Tob(c.a); g.a < g.c.c.length;){
                f = Wv(Rob(g), 9);
                h = f.j.a + f.e.c + f.e.b + a.b;
                e = e > h ? e : h;
            }
        }
        return e;
    }
    function sT(a, b) {
        oT();
        var c;
        if (a.c == b.c) {
            if (a.b == b.b || gT(a.b, b.b)) {
                c = dT(a.b) ? 1 : -1;
                if (a.a && !b.a) return c;
                else if (!a.a && b.a) return -c;
            }
            return xlb(a.b.e, b.b.e);
        } else return glb(a.c, b.c);
    }
    function nU(a) {
        var b, c;
        c = xI(MI(Bv(tv(qz, 1), Fzb, 10, 0, [
            a.f.i,
            a.i,
            a.a
        ])));
        b = a.f.e;
        switch(a.g.e){
            case 1:
                c.b -= b.d;
                break;
            case 2:
                c.a += b.c;
                break;
            case 3:
                c.b += b.a;
                break;
            case 4:
                c.a -= b.b;
        }
        return c;
    }
    function z6(a, b) {
        var c;
        c = 0;
        if (b.g == (CX(), BX)) {
            if (C6(b).f != a.a) {
                D6(a, C6(b).f);
                a.e = true;
            }
            a.e ? ++a.g : c += a.f;
        } else if (b.g == zX) a.e ? c += a.g : ++a.f;
        else if (b.g == AX) {
            D6(a, b);
            a.e = false;
        }
        return c;
    }
    function HV(a, b, c, d, e) {
        var f, g, h, i;
        i = null;
        for(h = new Tob(d); h.a < h.c.c.length;){
            g = Wv(Rob(h), 187);
            if (g != c && zU(g.e, e, 0) != -1) {
                i = g;
                break;
            }
        }
        f = IV(e);
        dW(f, c.b);
        eW(f, i.b);
        Fd(a.a, e, new XV(f, b, c.f));
    }
    function FZ(a) {
        switch(Wv(rJ(a, (Mjb(), vjb)), 85).e){
            case 1:
                sJ(a, vjb, (Xib(), Uib));
                break;
            case 2:
                sJ(a, vjb, (Xib(), Vib));
                break;
            case 3:
                sJ(a, vjb, (Xib(), Sib));
                break;
            case 4:
                sJ(a, vjb, (Xib(), Tib));
        }
    }
    function iQ(a, b, c) {
        var d, e, f, g;
        if (a) for(e = (f = Nu(a, xv($F, Txb, 2, 0, 5, 1)), new wnb(new opb(new _u(a, f).b))); e.b < e.d.Y();){
            d = (Bxb(e.b < e.d.Y()), $v(e.d.sb(e.c = e.b++)));
            g = Pu(a, d);
            wQ(b, d, g, c);
        }
    }
    function G5(a, b, c) {
        var d, e, f, g, h, i;
        e = 1;
        while(e < a)e *= 2;
        i = 2 * e - 1;
        e -= 1;
        h = xv(mw, Yyb, 26, i, 12, 1);
        d = 0;
        for(g = 0; g < b; g++){
            f = c[g] + e;
            ++h[f];
            while(f > 0){
                f % 2 > 0 && (d += h[f + 1]);
                f = (f - 1) / 2 | 0;
                ++h[f];
            }
        }
        return d;
    }
    function aeb(a, b, c) {
        var d, e, f, g;
        a.e = b;
        if (c) for(e = (g = new Snb(a.a.a).a.bb().mb(), new Ynb(g)); e.a.G();){
            d = (f = Wv(e.a.H(), 21), Wv(f.yb(), 12));
            sJ(d, (Rib(), Mib), a.e);
            QX(d.c, b.a);
            QX(d.d, b.b);
        }
    }
    function g4() {
        g4 = iI;
        e4 = new h4(tzb, 0);
        b4 = new h4(ozb, 1);
        f4 = new h4(pzb, 2);
        d4 = new h4('LEFT_RIGHT_CONSTRAINT_LOCKING', 3);
        c4 = new h4('LEFT_RIGHT_CONNECTION_LOCKING', 4);
        a4 = new h4('EDGE_LENGTH', 5);
    }
    function N5(a, b, c, d) {
        var e;
        this.b = d;
        this.e = a.a;
        e = b[c];
        this.d = vv(KH, [
            Txb,
            xAb
        ], [
            227,
            26
        ], 13, [
            e.length,
            e.length
        ], 2);
        this.a = vv(mw, [
            Txb,
            Yyb
        ], [
            52,
            26
        ], 12, [
            e.length,
            e.length
        ], 2);
        this.c = new k5(b, c);
    }
    function fwb(a, b, c, d) {
        var e, f;
        f = b;
        e = f.d == null || a.a.$b(c.d, f.d) > 0 ? 1 : 0;
        while(f.a[e] != c){
            f = f.a[e];
            e = a.a.$b(c.d, f.d) > 0 ? 1 : 0;
        }
        f.a[e] = d;
        d.b = c.b;
        d.a[0] = c.a[0];
        d.a[1] = c.a[1];
        c.a[0] = null;
        c.a[1] = null;
    }
    function ZQ(a, b, c) {
        var d, e, f, g;
        nI(c, Tzb, 1);
        NQ(a.d, b);
        g = sV(a.a, b);
        if (g.Y() == 1) _Q(Wv(g.sb(0), 55), c);
        else {
            f = 1 / g.Y();
            for(e = g.mb(); e.G();){
                d = Wv(e.H(), 55);
                _Q(d, rI(c, f));
            }
        }
        qV(a.a, g, b);
        bR(b);
        pI(c);
    }
    function o6(a, b, c) {
        var d, e, f, g, h;
        h = new U6(b, c);
        for(g = T6(h); g.G();){
            f = Wv(g.H(), 7);
            for(e = Uh(Sh((Gi(), new gr(Ti(Bv(tv(UF, 1), syb, 1, 4, [
                f.b,
                f.e
            ])))))); Cm(e);){
                d = Wv(Dm(e), 12);
                bW(d) || l6(a, b, f, d);
            }
        }
    }
    function _6(a, b) {
        var c, d, e;
        e = nX(a, b);
        for(d = e.mb(); d.G();){
            c = Wv(d.H(), 7);
            if (rJ(c, (Rib(), Bib)) != null || Cm(Uh(Sh((Gi(), new gr(Ti(Bv(tv(UF, 1), syb, 1, 4, [
                c.b,
                c.e
            ])))))))) return true;
        }
        return false;
    }
    function Efb(a) {
        var b, c;
        if (sl(a)) throw new slb(TAb);
        for(c = WI(a, 0); c.b != c.d.c;){
            b = Wv(_ub(c), 10);
            this.d = Qlb(this.d, b.b);
            this.c = Nlb(this.c, b.a);
            this.a = Nlb(this.a, b.b);
            this.b = Qlb(this.b, b.a);
        }
    }
    function wI(a, b, c) {
        if (b < 0 || c < 0) throw new slb('The highx must be bigger then lowx and the highy must be bigger then lowy');
        a.a < 0 ? a.a = 0 : a.a > b && (a.a = b);
        a.b < 0 ? a.b = 0 : a.b > c && (a.b = c);
        return a;
    }
    function nX(a, b) {
        switch(b.e){
            case 1:
                return pl(a.f, (LX(), HX));
            case 2:
                return pl(a.f, (LX(), FX));
            case 3:
                return pl(a.f, (LX(), JX));
            case 4:
                return pl(a.f, (LX(), KX));
            default:
                return ypb(), ypb(), vpb;
        }
    }
    function K0(a) {
        var b, c, d, e;
        for(e = (Il(), new Im(Dl(ul(a.a, new yl)))); Cm(e);){
            d = Wv(Dm(e), 9);
            d.g == (CX(), yX) && sJ(d, (Rib(), pib), (kP(), hP));
            for(c = Uh(mX(d)); Cm(c);){
                b = Wv(Dm(c), 12);
                M0(b, (kP(), hP));
            }
        }
    }
    function L0(a) {
        var b, c, d, e;
        for(e = (Il(), new Im(Dl(ul(a.a, new yl)))); Cm(e);){
            d = Wv(Dm(e), 9);
            d.g == (CX(), yX) && sJ(d, (Rib(), pib), (kP(), gP));
            for(c = Uh(mX(d)); Cm(c);){
                b = Wv(Dm(c), 12);
                M0(b, (kP(), gP));
            }
        }
    }
    function cdb(a, b) {
        this.b = new vtb;
        switch(a){
            case 0:
                this.d = new Ddb(this);
                break;
            case 1:
                this.d = new tdb(this);
                break;
            case 2:
                this.d = new ydb(this);
                break;
            default:
                throw new rlb;
        }
        this.c = b;
        this.a = 0.2 * b;
    }
    function uW(a) {
        var b, c, d, e;
        if (!a.b) {
            a.b = new GU;
            for(c = new Tob(a.a.c); c.a < c.c.c.length;){
                b = Wv(Rob(c), 16);
                for(e = new Tob(b.a); e.a < e.c.c.length;){
                    d = Wv(Rob(e), 9);
                    vU(a.b, new BW(d, a.c));
                }
            }
        }
        return a.b;
    }
    function l5(a, b) {
        var c, d, e;
        c = m5(b, a.e);
        d = Wv(Smb(a.g.f, c), 24).a;
        e = a.a.c.length - 1;
        if (a.a.c.length != 0 && Wv(yU(a.a, e), 128).c == d) {
            ++Wv(yU(a.a, e), 128).a;
            ++Wv(yU(a.a, e), 128).b;
        } else vU(a.a, new v5(d));
    }
    function lmb(a) {
        bmb();
        var b, c;
        if (a >= ayb) {
            b = 55296 + (a - ayb >> 10 & 1023) & byb;
            c = 56320 + (a - ayb & 1023) & byb;
            return String.fromCharCode(b) + ('' + String.fromCharCode(c));
        } else return String.fromCharCode(a & byb);
    }
    function KV(a, b, c, d) {
        var e, f, g;
        e = hX(c);
        f = PW(e);
        g = new RX;
        PX(g, c);
        switch(d.e){
            case 1:
                QX(g, tN(vN(f)));
                break;
            case 2:
                QX(g, vN(f));
        }
        sJ(g, (Rib(), tib), Wv(rJ(b, tib), 15));
        sJ(b, uib, g);
        Umb(a.b, g, b);
        return g;
    }
    function l6(a, b, c, d) {
        var e;
        vU(a.c, new t6(a, c, d, Wv(Smb(a.k, c), 24).a));
        if (d6(d) && (b == a.e ? d.d.f != a.a && d.c.f != a.a : d.d.f != a.e && d.c.f != a.e)) {
            e = c == d.c ? d.d : d.c;
            vU(a.c, new t6(a, e, d, Wv(Smb(a.k, e), 24).a));
        }
    }
    function fe(a, b) {
        var c, d, e;
        if (b === a) return true;
        if (!aw(b, 57)) return false;
        e = Wv(b, 57);
        if (a.Y() != e.Y()) return false;
        for(d = e.bb().mb(); d.G();){
            c = Wv(d.H(), 21);
            if (!a._(c)) return false;
        }
        return true;
    }
    function $Z(a, b) {
        var c, d, e;
        d = new uX(a);
        qJ(d, b);
        sJ(d, (Rib(), gib), b);
        sJ(d, (eM(), TL), (KM(), FM));
        sJ(d, lL, (iK(), eK));
        sX(d, (CX(), xX));
        c = new RX;
        PX(c, d);
        QX(c, (sN(), rN));
        e = new RX;
        PX(e, d);
        QX(e, ZM);
        return d;
    }
    function O7(a, b) {
        var c, d, e;
        e = $xb;
        for(d = new Tob(m7(b)); d.a < d.c.c.length;){
            c = Wv(Rob(d), 89);
            if (c.e && !a.c[c.b]) {
                a.c[c.b] = true;
                e = Slb(e, O7(a, c7(c, b)));
            }
        }
        a.i[b.b] = a.j;
        a.g[b.b] = Slb(e, a.j++);
        return a.g[b.b];
    }
    function _eb(a, b, c) {
        var d, e, f, g;
        g = a.g.tb();
        if (a.e) for(e = 0; e < a.c; e++)g.H();
        else for(e = 0; e < a.c - 1; e++)g.H();
        f = a.b.tb();
        d = Ixb(Yv(g.H()));
        while(d - b < RAb){
            d = Ixb(Yv(g.H()));
            f.H();
        }
        g.M();
        afb(a, c, b, f, g);
    }
    function Lt(b, c) {
        var d, e, f, g;
        for(e = 0, f = b.length; e < f; e++){
            g = b[e];
            try {
                g[1] ? g[0].bd() && (c = Kt(c, g)) : g[0].bd();
            } catch (a) {
                a = OH(a);
                if (aw(a, 46)) {
                    d = a;
                    Ct(aw(d, 164) ? Wv(d, 164).cc() : d);
                } else throw NH(a);
            }
        }
        return c;
    }
    function Qr(a) {
        var b, c, d;
        d = a.c.a;
        if (!d) return null;
        if (a.b.b) {
            b = a.b.e;
            c = Ds(a.c.a, a.d, b);
            if (!c) return null;
            a.b.d == (Gh(), Fh) && a.d.$b(b, c.b) == 0 && (c = c.i);
        } else c = a.a.i;
        return c == a.a || !ok(a.b, c.b) ? null : c;
    }
    function t2(a, b) {
        var c, d, e, f, g, h;
        f = 0;
        for(d = new Tob(b.c); d.a < d.c.c.length;){
            c = Wv(Rob(d), 16);
            e = 0;
            for(h = new Tob(c.a); h.a < h.c.c.length;){
                g = Wv(Rob(h), 9);
                e += g.j.b + g.e.a + g.e.d + a.a;
            }
            e -= a.a;
            f = f > e ? f : e;
        }
        return f;
    }
    function M7(a) {
        var b, c, d, e, f;
        f = $xb;
        e = $xb;
        for(d = new Tob(m7(a)); d.a < d.c.c.length;){
            c = Wv(Rob(d), 89);
            b = c.d.e - c.c.e;
            c.d == a && b < e ? e = b : b < f && (f = b);
        }
        e == $xb && (e = -1);
        f == $xb && (f = -1);
        return new RJ(Elb(e), Elb(f));
    }
    function l8(a, b, c) {
        var d, e, f, g, h;
        b.k = -1;
        for(h = oX(b, (djb(), bjb)).mb(); h.G();){
            g = Wv(h.H(), 7);
            for(e = new Tob(g.e); e.a < e.c.c.length;){
                d = Wv(Rob(e), 12);
                f = d.d.f;
                b != f && (f.k < 0 ? c.ib(d) : f.k > 0 && l8(a, f, c));
            }
        }
        b.k = 0;
    }
    function Bfb(a, b) {
        yfb(this);
        if (0 > b) throw new slb('Top must be smaller or equal to bottom.');
        else if (0 > a) throw new slb('Left must be smaller or equal to right.');
        this.d = 0;
        this.c = a;
        this.a = b;
        this.b = 0;
    }
    function Ffb(a) {
        var b, c, d;
        yfb(this);
        if (a.length == 0) throw new slb(TAb);
        for(c = 0, d = a.length; c < d; ++c){
            b = a[c];
            this.d = Qlb(this.d, b.b);
            this.c = Nlb(this.c, b.a);
            this.a = Nlb(this.a, b.b);
            this.b = Qlb(this.b, b.a);
        }
    }
    function g0() {
        d0();
        return Bv(tv(mC, 1), uyb, 37, 0, [
            L_,
            o_,
            c0,
            m_,
            p_,
            __,
            z_,
            T_,
            j_,
            D_,
            S_,
            P_,
            I_,
            s_,
            h_,
            N_,
            W_,
            F_,
            G_,
            A_,
            Z_,
            V_,
            R_,
            r_,
            U_,
            $_,
            Y_,
            B_,
            x_,
            H_,
            k_,
            C_,
            a0,
            O_,
            t_,
            v_,
            J_,
            i_,
            l_,
            y_,
            u_,
            M_,
            Q_,
            E_,
            w_,
            X_,
            K_,
            n_,
            b0,
            q_
        ]);
    }
    function a5(a, b) {
        var c, d, e, f, g, h, i, j, k;
        k = 0;
        for(d = 0, e = b.length; d < e; ++d){
            c = b[d];
            for(g = 0, h = c.length; g < h; ++g){
                f = c[g];
                for(j = new Tob(f.f); j.a < j.c.c.length;){
                    i = Wv(Rob(j), 7);
                    i.k = k++;
                }
            }
        }
        a.a = xv(mw, Yyb, 26, k, 12, 1);
    }
    function Sl(a) {
        Il();
        var b, c, d;
        b = a.H();
        if (!a.G()) return b;
        d = new zmb;
        d.a += 'expected one element but was: <' + b;
        for(c = 0; c < 4 && a.G(); c++)ymb(d, ', ' + a.H());
        a.G() && (d.a += ', ...', d);
        d.a += '>';
        throw new slb(d.a);
    }
    function x6(a) {
        var b, c, d, e, f;
        b = 0;
        for(d = a.b, e = 0, f = d.length; e < f; ++e){
            c = d[e];
            b += z6(a, c);
            if (LM(Wv(rJ(c, (eM(), TL)), 28))) {
                nX(c, (sN(), $M)).mb().G() && (b += y6(a, c, $M));
                nX(c, pN).mb().G() && (b += y6(a, c, pN));
            }
        }
        return b;
    }
    function i5(a, b, c, d) {
        var e, f, g, h, i;
        if (d.d.c + d.e.c == 0) for(g = a.a[a.c], h = 0, i = g.length; h < i; ++h){
            f = g[h];
            Umb(d, f, new r5(a, f, c));
        }
        e = Wv(re(Ktb(d.d, b)), 284);
        e.b = 0;
        e.c = e.f;
        e.c == 0 || u5(Wv(yU(e.a, e.b), 128));
        return e;
    }
    function Dpb(a) {
        var h;
        ypb();
        var b, c, d, e, f, g;
        if (aw(a, 63)) for(e = 0, d = a.Y() - 1; e < d; ++e, --d){
            h = a.sb(e);
            a.wb(e, a.sb(d));
            a.wb(d, h);
        }
        else {
            b = a.tb();
            f = a.ub(a.Y());
            while(b.L() < f.N()){
                c = b.H();
                g = f.M();
                b.O(g);
                f.O(c);
            }
        }
    }
    function Wb(a, b, c) {
        if (a < 0 || a > c) return Vb(a, c, 'start index');
        if (b < 0 || b > c) return Vb(b, c, 'end index');
        return fc('end index (%s) must not be less than start index (%s)', Bv(tv(UF, 1), syb, 1, 4, [
            Elb(b),
            Elb(a)
        ]));
    }
    function SP(a) {
        if (!('id' in a.a)) throw new FQ("Every graph element must specify an 'id' property.", a);
        if (!Pu(a, 'id').lc()) throw new FQ("Invalid format for 'id'. Must be a string, was " + Pu(a, 'id').$c, a);
    }
    function f3(a, b) {
        var c, d, e, f, g, h, i;
        i = a.b;
        for(d = Wv(qsb(a3, a), 20).mb(); d.G();){
            c = Wv(d.H(), 75);
            for(h = (f = new Snb(c.c.a).a.bb().mb(), new Ynb(f)); h.a.G();){
                g = (e = Wv(h.a.H(), 21), Wv(e.yb(), 7));
                Anb(b, g);
                J2(g, i);
            }
        }
    }
    function _db(a, b) {
        var c, d, e;
        for(e = new Tob(b.e); e.a < e.c.c.length;){
            c = Wv(Rob(e), 12);
            if (c.d.f != a.f) return true;
        }
        for(d = new Tob(b.b); d.a < d.c.c.length;){
            c = Wv(Rob(d), 12);
            if (c.c.f != a.f) return true;
        }
        return false;
    }
    function Z2(a) {
        var b, c, d, e;
        We(a.c);
        We(a.b);
        We(a.a);
        for(e = (c = new Snb(a.e).a.bb().mb(), new Ynb(c)); e.a.G();){
            d = (b = Wv(e.a.H(), 21), Wv(b.yb(), 60));
            if (d.c != 2) {
                Wsb(a.a, d);
                d.c == 0 && Wsb(a.c, d);
            }
            Wsb(a.b, d);
        }
        a.d = false;
    }
    function mr(b, c) {
        var d;
        if (b === c) return true;
        if (aw(c, 18)) {
            d = Wv(c, 18);
            try {
                return b.Y() == d.Y() && b.lb(d);
            } catch (a) {
                a = OH(a);
                if (aw(a, 76)) return false;
                else if (aw(a, 119)) return false;
                else throw NH(a);
            }
        }
        return false;
    }
    function Ltb(a, b, c) {
        var d, e, f, g;
        g = b == null ? 0 : a.b.Vc(b);
        e = (d = Ttb(a.a, g), d == null ? [] : d);
        if (e.length == 0) Vtb(a.a, g, e);
        else {
            f = Itb(a, b, e);
            if (f) return f.Ab(c);
        }
        Av(e, e.length, new qob(b, c));
        ++a.c;
        msb(a.b);
        return null;
    }
    function Vb(a, b, c) {
        if (a < 0) return fc(ryb, Bv(tv(UF, 1), syb, 1, 4, [
            c,
            Elb(a)
        ]));
        else if (b < 0) throw new slb(tyb + b);
        else return fc('%s (%s) must not be greater than size (%s)', Bv(tv(UF, 1), syb, 1, 4, [
            c,
            Elb(a),
            Elb(b)
        ]));
    }
    function Ub(a, b) {
        if (a < 0) return fc(ryb, Bv(tv(UF, 1), syb, 1, 4, [
            'index',
            Elb(a)
        ]));
        else if (b < 0) throw new slb(tyb + b);
        else return fc('%s (%s) must be less than size (%s)', Bv(tv(UF, 1), syb, 1, 4, [
            'index',
            Elb(a),
            Elb(b)
        ]));
    }
    function jW(a) {
        var b, c, d, e;
        e = xv(qB, Txb, 51, a.c.c.length, 0, 2);
        d = new Fnb(a.c, 0);
        while(d.b < d.d.Y()){
            b = (Bxb(d.b < d.d.Y()), Wv(d.d.sb(d.c = d.b++), 16));
            c = d.b - 1;
            e[c] = Wv(FU(b.a, xv(qB, Nzb, 9, b.a.c.length, 0, 1)), 51);
        }
        return e;
    }
    function w3(a, b, c, d, e) {
        this.c = e;
        this.d = b;
        this.a = c;
        switch(e.e){
            case 4:
                this.b = Jlb(a.b);
                break;
            case 1:
                this.b = Jlb(a.d);
                break;
            case 2:
                this.b = Jlb(a.c - d.j.a);
                break;
            case 3:
                this.b = Jlb(a.a - d.j.b);
                break;
            default:
                this.b = 0;
        }
    }
    function adb(a, b, c, d, e) {
        var f, g, h, i, j;
        if (b) for(h = b.mb(); h.G();){
            g = Wv(h.H(), 9);
            for(j = pX(g, (djb(), bjb), c).mb(); j.G();){
                i = Wv(j.H(), 7);
                f = Wv(re(Ktb(e.d, i)), 80);
                if (!f) {
                    f = new odb(a);
                    d.c[d.c.length] = f;
                    mdb(f, i, e);
                }
            }
        }
    }
    function Ofb(a, b) {
        var c, d, e;
        c = a.c;
        if (c.a.Y() > 1) throw new slb('In straight hyperEdges there may be only one edge.');
        QI((e = new Snb(c.a).a.bb().mb(), d = Wv(new Ynb(e).a.H(), 21), Wv(d.yb(), 12)).a, new HI(b, a.b));
    }
    function no(a, b, c) {
        var d, e;
        this.f = a;
        d = Wv(Smb(a.b, b), 126);
        e = !d ? 0 : d.a;
        bc(c, e);
        if (c >= (e / 2 | 0)) {
            this.e = !d ? null : d.c;
            this.d = e;
            while(c++ < e)lo(this);
        } else {
            this.c = !d ? null : d.b;
            while(c-- > 0)ko(this);
        }
        this.b = b;
        this.a = null;
    }
    function HP(a, b) {
        if (typeof $63de8e1e54a3eb03$var$klaycallback === Zxb) $63de8e1e54a3eb03$var$klaycallback(b);
        else {
            typeof document !== Czb ? Rxb(a(b)) : "object" === Sxb && module.exports && Rxb(a(b));
            typeof document === Czb && typeof self !== Czb && self.postMessage(b);
        }
    }
    function _P(a, b) {
        var c, d, e, f;
        if ('x' in a.a) {
            e = Wv(Pu(a, 'x'), 104);
            b.i.a = e.a;
        }
        if ('y' in a.a) {
            f = Wv(Pu(a, 'y'), 104);
            b.i.b = f.a;
        }
        if (Jzb in a.a) {
            d = Wv(Pu(a, Jzb), 104);
            b.j.a = d.a;
        }
        if (Kzb in a.a) {
            c = Wv(Pu(a, Kzb), 104);
            b.j.b = c.a;
        }
    }
    function lgb(a, b, c) {
        var d, e;
        igb(this);
        b == (fgb(), dgb) ? stb(this.g, a.c) : stb(this.o, a.c);
        c == dgb ? stb(this.g, a.d) : stb(this.o, a.d);
        stb(this.c, a);
        d = MX(a.c).b;
        e = MX(a.d).b;
        kgb(this, d, e, e);
        this.f = Zfb(MX(a.c).b, MX(a.d).b);
    }
    function p5(a) {
        var b, c, d, e, f, g;
        g = new U6(a.d, a.e);
        for(f = T6(g); f.G();){
            e = Wv(f.H(), 7);
            d = a.e == (sN(), rN) ? e.b : e.e;
            for(c = new Tob(d); c.a < c.c.c.length;){
                b = Wv(Rob(c), 12);
                if (!bW(b) && b.c.f.d != b.d.f.d) {
                    l5(a, b);
                    ++a.f;
                    ++a.c;
                }
            }
        }
    }
    function LQ(a, b, c) {
        var d, e, f, g, h;
        g = (ypb(), new Frb(Wv(yU(b.a, c), 18)));
        h = new HU(g.b.Y());
        for(e = new Nqb(g.b.mb()); e.b.G();){
            d = Wv(e.b.H(), 37);
            f = Wv(Smb(a.a, d), 31);
            if (!f) {
                f = e0(d);
                Umb(a.a, d, f);
            }
            h.c[h.c.length] = f;
        }
        return h;
    }
    function T5(a, b) {
        var c, d, e, f;
        d = new Fnb(a.f.c, 0);
        while(d.b < d.d.Y()){
            c = (Bxb(d.b < d.d.Y()), Wv(d.d.sb(d.c = d.b++), 16));
            f = b[d.b - 1];
            e = new Fnb(c.a, 0);
            while(e.b < e.d.Y()){
                Bxb(e.b < e.d.Y());
                e.d.sb(e.c = e.b++);
                Enb(e, f[e.b - 1]);
            }
        }
    }
    function m2(a) {
        var b, c;
        if (MM(Wv(rJ(a, (eM(), TL)), 28))) for(c = new Tob(a.f); c.a < c.c.c.length;){
            b = Wv(Rob(c), 7);
            b.g == (sN(), qN) && p2(b);
        }
        else {
            for(c = new Tob(a.f); c.a < c.c.c.length;){
                b = Wv(Rob(c), 7);
                p2(b);
            }
            sJ(a, TL, (KM(), HM));
        }
    }
    function jpb(a, b, c, d, e, f) {
        var g, h, i, j;
        g = d - c;
        if (g < 7) {
            gpb(b, c, d, f);
            return;
        }
        i = c + e;
        h = d + e;
        j = i + (h - i >> 1);
        jpb(b, a, i, j, -e, f);
        jpb(b, a, j, h, -e, f);
        if (f.$b(a[j - 1], a[j]) <= 0) {
            while(c < d)Av(b, c++, a[i++]);
            return;
        }
        hpb(a, i, j, h, b, c, d, f);
    }
    function hv(a) {
        if (!a) return Bu(), Au;
        var b = a.valueOf ? a.valueOf() : a;
        if (b !== a) {
            var c = dv[typeof b];
            return c ? c(b) : kv(typeof b);
        } else if (a instanceof Array || a instanceof $wnd.Array) return new ku(a);
        else return new Uu(a);
    }
    function I7(a, b, c) {
        var d, e;
        d = c.c;
        e = c.d;
        if (a.g[d.b] <= a.i[b.b] && a.i[b.b] <= a.i[d.b] && a.g[e.b] <= a.i[b.b] && a.i[b.b] <= a.i[e.b]) {
            if (a.i[d.b] < a.i[e.b]) return false;
            return true;
        }
        if (a.i[d.b] < a.i[e.b]) return true;
        return false;
    }
    function j5(a, b, c) {
        var d, e, f, g, h, i, j, k;
        j = 0;
        for(e = a.a[b], f = 0, g = e.length; f < g; ++f){
            d = e[f];
            k = new U6(d, c);
            for(i = T6(k); i.G();){
                h = Wv(i.H(), 7);
                Umb(a.f, h, Elb(j));
                LM(Wv(rJ(d, (eM(), TL)), 28)) && ++j;
            }
            LM(Wv(rJ(d, (eM(), TL)), 28)) || ++j;
        }
    }
    function Pb(a, b, c) {
        var d, e;
        _b(b);
        if (c.G()) {
            e = Wv(c.H(), 21);
            vmb(b, Mb(a.a, e.yb()));
            vmb(b, a.b);
            vmb(b, Mb(a.a, e.zb()));
            while(c.G()){
                vmb(b, a.a.c);
                d = Wv(c.H(), 21);
                vmb(b, Mb(a.a, d.yb()));
                vmb(b, a.b);
                vmb(b, Mb(a.a, d.zb()));
            }
        }
        return b;
    }
    function Gd(a, b) {
        var c, d;
        c = Wv(Wmb(a.b, b), 19);
        if (!c) return a.$();
        d = a.Z();
        d.jb(c);
        a.c -= c.Y();
        c.Q();
        return aw(d, 137) ? (ypb(), new dsb(Wv(d, 137))) : aw(d, 18) ? (ypb(), new Frb(Wv(d, 18))) : aw(d, 20) ? Hpb(Wv(d, 20)) : (ypb(), new zqb(d));
    }
    function Tm(a, b) {
        var c;
        b.d ? b.d.b = b.b : a.a = b.b;
        b.b ? b.b.d = b.d : a.e = b.d;
        if (!b.e && !b.c) {
            c = Wv(Wmb(a.b, b.a), 126);
            c.a = 0;
            ++a.c;
        } else {
            c = Wv(Smb(a.b, b.a), 126);
            --c.a;
            !b.e ? c.b = b.c : b.e.c = b.c;
            !b.c ? c.c = b.e : b.c.e = b.e;
        }
        --a.d;
    }
    function mU(a, b, c) {
        switch(c.e){
            case 1:
                return new HI(b.a, Qlb(a.d.b, b.b));
            case 2:
                return new HI(Nlb(a.c.a, b.a), b.b);
            case 3:
                return new HI(b.a, Nlb(a.c.b, b.b));
            case 4:
                return new HI(Qlb(b.a, a.d.a), b.b);
        }
        return new HI(b.a, b.b);
    }
    function Oxb(a) {
        var b, c, d, e;
        b = 0;
        d = (bmb(), a.length);
        e = d - 4;
        c = 0;
        while(c < e){
            b = a.charCodeAt(c + 3) + 31 * (a.charCodeAt(c + 2) + 31 * (a.charCodeAt(c + 1) + 31 * (a.charCodeAt(c) + 31 * b)));
            b = b | 0;
            c += 4;
        }
        while(c < d)b = b * 31 + jmb(a, c++);
        b = b | 0;
        return b;
    }
    function X9(a, b) {
        var c, d, e;
        this.a = a;
        this.c = b;
        this.b = xv(nE, Txb, 673, a.length, 0, 2);
        for(c = 0; c < a.length; ++c){
            e = a[c].length;
            this.b[c] = xv(nE, {
                673: 1,
                3: 1,
                5: 1,
                6: 1
            }, 102, e, 0, 1);
            for(d = 0; d < e; ++d)this.b[c][d] = new $9(this, a[c][d].c);
        }
    }
    function sk(a, b, c, d, e, f, g) {
        var h;
        this.a = Wv(_b(a), 56);
        this.b = b;
        this.c = e;
        this.e = c;
        this.d = Wv(_b(d), 159);
        this.g = f;
        this.f = Wv(_b(g), 159);
        b && a.$b(c, c);
        e && a.$b(f, f);
        if (b && e) {
            h = a.$b(c, f);
            Zb(h <= 0, c, f);
            h == 0 && Xb(d != (Gh(), Fh) | g != Fh);
        }
    }
    function eV(a) {
        this.a = a;
        if (a.c.f.g == (CX(), xX)) {
            this.c = a.c;
            this.d = Wv(rJ(a.c.f, (Rib(), hib)), 32);
        } else if (a.d.f.g == xX) {
            this.c = a.d;
            this.d = Wv(rJ(a.d.f, (Rib(), hib)), 32);
        } else throw new slb('Edge ' + a + ' is not an external edge.');
    }
    function Xcb() {
        Xcb = iI;
        Scb = UQ(new WQ, (d0(), x_));
        Ucb = TQ(new WQ, A_);
        Vcb = PQ(TQ(new WQ, R_), Q_);
        Rcb = PQ(UQ(TQ(new WQ, s_), t_), u_);
        Wcb = TQ(new WQ, Z_);
        Tcb = PQ(new WQ, y_);
        Pcb = PQ(UQ(TQ(SQ(new WQ, D_), F_), H_), E_);
        Qcb = PQ(UQ(new WQ, H_), q_);
    }
    function Lr(a, b, c) {
        var d, e, f, g;
        Mh(c, Xyb);
        if (c == 0) return Pr(a, b);
        Xb(ok(a.b, b));
        g = a.c.a;
        if (!g) {
            a.d.$b(b, b);
            e = new Os(b, c);
            es(a.a, e, a.a);
            Us(a.c, null, e);
            return 0;
        }
        f = xv(mw, Yyb, 26, 1, 12, 1);
        d = zs(g, a.d, b, c, f);
        Us(a.c, g, d);
        return f[0];
    }
    function i$(a, b, c) {
        var d, e, f, g, h, i;
        d = 0;
        i = c;
        if (!b) {
            d = c * (a.c.length - 1);
            i *= -1;
        }
        for(f = new Tob(a); f.a < f.c.c.length;){
            e = Wv(Rob(f), 9);
            sJ(e, (eM(), lL), (iK(), eK));
            e.j.a = d;
            for(h = nX(e, (sN(), ZM)).mb(); h.G();){
                g = Wv(h.H(), 7);
                g.i.a = d;
            }
            d += i;
        }
    }
    function Fd(a, b, c) {
        var d;
        d = Wv(Smb(a.b, b), 19);
        if (!d) {
            d = a.Z();
            if (d.ib(c)) {
                ++a.c;
                Umb(a.b, b, d);
                return true;
            } else throw new ukb('New Collection violated the Collection spec');
        } else if (d.ib(c)) {
            ++a.c;
            return true;
        } else return false;
    }
    function ES(a, b, c) {
        var d, e, f;
        CS(a, b, c);
        f = new GU;
        for(e = new Tob(a.b.a.b); e.a < e.c.c.length;){
            d = Wv(Rob(e), 25);
            if (b.D(d)) {
                vU(f, new OS(d, true));
                vU(f, new OS(d, false));
            }
        }
        JS(a.d);
        RT(f, a.c, new opb(Bv(tv(JA, 1), syb, 160, 0, [
            a.d
        ])));
        DS(a, b, c);
    }
    function R8(a, b) {
        var c, d, e, f, g;
        a.c[b.k] = true;
        vU(a.a, b);
        for(g = new Tob(b.f); g.a < g.c.c.length;){
            f = Wv(Rob(g), 7);
            for(d = Uh(Sh((Gi(), new gr(Ti(Bv(tv(UF, 1), syb, 1, 4, [
                f.b,
                f.e
            ])))))); Cm(d);){
                c = Wv(Dm(d), 12);
                e = S8(f, c).f;
                a.c[e.k] || R8(a, e);
            }
        }
    }
    function dQ(a, b, c, d) {
        var e, f, g;
        if ('labels' in b.a) {
            g = Pu(b, 'labels');
            if (!g.hc()) throw new GQ("The 'labels' property of a node must be an array.", g, b);
            f = g.hc();
            for(e = 0; e < f.a.length; ++e)aw(gu(f, e), 69) && cQ(a, Wv(gu(f, e), 69), c, d);
        }
    }
    function j0(a, b, c) {
        var d, e, f, g, h, i;
        f = Wv(yU(b.b, 0), 12).c;
        d = f.f;
        e = d.g;
        i = Wv(yU(c.e, 0), 12).d;
        g = i.f;
        h = g.g;
        e == (CX(), zX) ? sJ(a, (Rib(), qib), Wv(rJ(d, qib), 7)) : sJ(a, (Rib(), qib), f);
        h == zX ? sJ(a, (Rib(), rib), Wv(rJ(g, rib), 7)) : sJ(a, (Rib(), rib), i);
    }
    function oM() {
        oM = iI;
        gM = new pM('H_LEFT', 0);
        fM = new pM('H_CENTER', 1);
        iM = new pM('H_RIGHT', 2);
        nM = new pM('V_TOP', 3);
        mM = new pM('V_CENTER', 4);
        lM = new pM('V_BOTTOM', 5);
        jM = new pM('INSIDE', 6);
        kM = new pM('OUTSIDE', 7);
        hM = new pM('H_PRIORITY', 8);
    }
    function rS(a) {
        aS();
        var b, c, d;
        this.b = ZR;
        this.c = _R;
        this.d = (sK(), qK);
        this.g = (VR(), UR);
        this.a = a;
        oS(this, new sS);
        fS(this);
        for(d = new Tob(a.b); d.a < d.c.c.length;){
            c = Wv(Rob(d), 25);
            if (!c.f) {
                b = new QR(Bv(tv(kA, 1), syb, 25, 0, [
                    c
                ]));
                vU(a.a, b);
            }
        }
    }
    function R7(a, b) {
        var c, d, e, f;
        e = 1;
        b.j = true;
        for(d = new Tob(m7(b)); d.a < d.c.c.length;){
            c = Wv(Rob(d), 89);
            if (!a.c[c.b]) {
                a.c[c.b] = true;
                f = c7(c, b);
                if (c.e) e += R7(a, f);
                else if (!f.j && c.a == c.d.e - c.c.e) {
                    c.e = true;
                    stb(a.p, c);
                    e += R7(a, f);
                }
            }
        }
        return e;
    }
    function Abb(a) {
        var b, c, d, e, f, g, h, i;
        e = Uzb;
        d = Vzb;
        for(c = new Tob(a.e.c); c.a < c.c.c.length;){
            b = Wv(Rob(c), 16);
            for(g = new Tob(b.a); g.a < g.c.c.length;){
                f = Wv(Rob(g), 9);
                i = Ixb(a.n[f.k]);
                h = i + Ixb(a.b[a.f[f.k].k]);
                e = e < i ? e : i;
                d = d > h ? d : h;
            }
        }
        return d - e;
    }
    function DQ(a) {
        var b;
        b = new Tu;
        Ru(b, 'type', new lv((Gkb($z), $z.n)));
        Ru(b, Dzb, new lv(a.f));
        !!a.b && Ru(b, 'value', a.b);
        !!a.a && Ru(b, 'context', a.a);
        Ru(b, Ezb, new lv(Hb(new Kb('\n'), new wnb(new opb((a.g == null && (a.g = Pt(a)), a.g))))));
        return b;
    }
    function D5(a, b) {
        if (a.c < b.c) return -1;
        else if (a.c > b.c) return 1;
        else if (a.b < b.b) return -1;
        else if (a.b > b.b) return 1;
        else if (a.a != b.a) return a.a.b - b.a.b;
        else if (a.d == 0 && b.d == 1) return -1;
        else if (a.d == 1 && b.d == 0) return 1;
        return 0;
    }
    function cn(a, b) {
        var c, d, e, f, g;
        if (b === a) return true;
        if (!aw(b, 20)) return false;
        g = Wv(b, 20);
        if (a.Y() != g.Y()) return false;
        f = g.mb();
        for(d = a.mb(); d.G();){
            c = d.H();
            e = f.H();
            if (!(gw(c) === gw(e) || c != null && rb(c, e))) return false;
        }
        return true;
    }
    function st(b) {
        var c = (!qt && (qt = tt()), qt);
        var d = b.replace(/[\x00-\x1f\xad\u0600-\u0603\u06dd\u070f\u17b4\u17b5\u200b-\u200f\u2028-\u202e\u2060-\u2064\u206a-\u206f\ufeff\ufff9-\ufffb"\\]/g, function(a) {
            return rt(a, c);
        });
        return '"' + d + '"';
    }
    function ER(a, b) {
        var c, d, e, f, g, h, i;
        e = b == 1 ? wR : vR;
        for(d = (g = new Snb(e.a).a.bb().mb(), new Ynb(g)); d.a.G();){
            c = (f = Wv(d.a.H(), 21), Wv(f.yb(), 59));
            for(i = Wv(Dd(a.f.c, c), 18).mb(); i.G();){
                h = Wv(i.H(), 27);
                BU(a.b.b, h.b);
                BU(a.b.a, Wv(h.b, 25).f);
            }
        }
    }
    function aR(a, b, c) {
        var d, e, f, g;
        nI(c, 'Recursive layout', 2);
        if (b.b.c.length != 0) {
            g = 1 / b.b.c.length;
            for(f = new Tob(b.b); f.a < f.c.c.length;){
                e = Wv(Rob(f), 9);
                d = Wv(rJ(e, (Rib(), sib)), 55);
                if (d) {
                    aR(a, d, rI(c, g));
                    $Q(e, d);
                }
            }
            NQ(a.d, b);
            _Q(b, c);
        }
        bR(b);
        pI(c);
    }
    function L3(a, b) {
        oR.call(this);
        this.d = new vtb;
        this.b = Wv(rJ(b, (Rib(), Jib)), 15).a * Wv(rJ(b, (Mjb(), qjb)), 15).a;
        this.e = this.b * Wv(rJ(b, Ejb), 15).a;
        this.a = new jJ;
        this.c = new jJ;
        this.j = new VN(a.j, a.k, 0, a.n - a.k);
        this.o = a.g;
        this.g.a = a.i;
        K3(this, a);
    }
    function Mtb(a, b) {
        var c, d, e, f, g;
        f = b == null ? 0 : a.b.Vc(b);
        d = (c = Ttb(a.a, f), c == null ? [] : c);
        for(g = 0; g < d.length; g++){
            e = d[g];
            if (a.b.Uc(b, e.yb())) {
                if (d.length == 1) {
                    d.length = 0;
                    a.a[$Ab](f);
                } else d.splice(g, 1);
                --a.c;
                msb(a.b);
                return e.zb();
            }
        }
        return null;
    }
    function hU(a, b, c) {
        var d;
        d = null;
        !!b && (d = b.e);
        ZU(a, new VS(b.i.a - d.b + c.a, b.i.b - d.d + c.b));
        ZU(a, new VS(b.i.a - d.b + c.a, b.i.b + b.j.b + d.a + c.b));
        ZU(a, new VS(b.i.a + b.j.a + d.c + c.a, b.i.b - d.d + c.b));
        ZU(a, new VS(b.i.a + b.j.a + d.c + c.a, b.i.b + b.j.b + d.a + c.b));
    }
    function J2(a, b) {
        switch(b.e){
            case 2:
                QX(a, (sN(), ZM));
                a.a.a = a.j.a;
                a.a.b = a.j.b / 2;
                break;
            case 4:
                QX(a, (sN(), rN));
                a.a.a = 0;
                a.a.b = a.j.b / 2;
                break;
            case 1:
                QX(a, (sN(), $M));
                a.a.a = a.j.a / 2;
                a.a.b = 0;
                break;
            case 3:
                QX(a, (sN(), pN));
                a.a.a = a.j.a / 2;
                a.a.b = a.j.b;
        }
    }
    function Fq(a, b) {
        Dq();
        var c, d, e;
        if (b === a) return true;
        if (aw(b, 207)) {
            e = Wv(b, 207);
            if (a.Y() != e.Y() || Vg(a).Y() != e.bb().Y()) return false;
            for(d = e.bb().mb(); d.G();){
                c = Wv(d.H(), 83);
                if (a.Cb(c.Zb()) != c.Yb()) return false;
            }
            return true;
        }
        return false;
    }
    function wvb(a, b) {
        var c, d, e, f, g, h;
        f = a.a * _Ab + a.b * 1502;
        h = a.b * _Ab + 11;
        c = Math.floor(h * FAb);
        f += c;
        h -= c * aBb;
        f %= aBb;
        a.a = f;
        a.b = h;
        if (b <= 24) return Mlb(a.a * qvb[b]);
        else {
            e = a.a * (1 << b - 24);
            g = Mlb(a.b * rvb[b]);
            d = e + g;
            d >= 2147483648 && (d -= 4294967296);
            return d;
        }
    }
    function MW(a, b, c) {
        var d, e, f;
        if (b == c) return;
        d = b;
        do {
            vI(a, d.d);
            f = Wv(rJ(d, (Rib(), zib)), 9);
            if (f) {
                e = d.a;
                uI(a, e.b, e.d);
                vI(a, f.i);
                d = hX(f);
            }
        }while (f);
        d = c;
        do {
            EI(a, d.d);
            f = Wv(rJ(d, (Rib(), zib)), 9);
            if (f) {
                e = d.a;
                DI(a, e.b, e.d);
                EI(a, f.i);
                d = hX(f);
            }
        }while (f);
    }
    function n3(a, b) {
        var c, d, e, f, g, h;
        c = new GU;
        h = new Um;
        for(e = (g = new Snb(a.a).a.bb().mb(), new Ynb(g)); e.a.G();){
            d = (f = Wv(e.a.H(), 21), Wv(f.yb(), 12));
            Nm(h, d.c, d, null);
            Nm(h, d.d, d, null);
        }
        while(h.a)vU(c, m3(h, b, LM(Wv(rJ(b, (eM(), TL)), 28))));
        return c;
    }
    function B7(a, b) {
        var c, d, e, f, g;
        for(f = new Tob(a.e.a); f.a < f.c.c.length;){
            e = Wv(Rob(f), 61);
            if (e.c.c.length == e.g.c.length) {
                d = e.e;
                g = M7(e);
                for(c = e.e - Wv(g.a, 24).a + 1; c < e.e + Wv(g.b, 24).a; c++)b[c] < b[d] && (d = c);
                if (b[d] < b[e.e]) {
                    --b[e.e];
                    ++b[d];
                    e.e = d;
                }
            }
        }
    }
    function zR(a, b) {
        var c, d, e, f, g, h, i;
        e = b == 1 ? wR : vR;
        for(d = (g = new Snb(e.a).a.bb().mb(), new Ynb(g)); d.a.G();){
            c = (f = Wv(d.a.H(), 21), Wv(f.yb(), 59));
            for(i = Wv(Dd(a.f.c, c), 18).mb(); i.G();){
                h = Wv(i.H(), 27);
                vU(a.b.b, Wv(h.b, 25));
                vU(a.b.a, Wv(h.b, 25).f);
            }
        }
    }
    function ecb(a) {
        $bb();
        var b, c, d, e, f, g, h;
        c = (mp(), new wub);
        for(e = new Tob(a.e.c); e.a < e.c.c.length;){
            d = Wv(Rob(e), 16);
            for(g = new Tob(d.a); g.a < g.c.c.length;){
                f = Wv(Rob(g), 9);
                h = a.f[f.k];
                b = Wv(rub(c, h), 20);
                if (!b) {
                    b = new GU;
                    tub(c, h, b);
                }
                b.ib(f);
            }
        }
        return c;
    }
    function cS(a, b) {
        var c, d, e, f;
        for(d = new Tob(a.a.a); d.a < d.c.c.length;){
            c = Wv(Rob(d), 78);
            c.i = true;
        }
        for(f = new Tob(a.a.b); f.a < f.c.c.length;){
            e = Wv(Rob(f), 25);
            e.p = Ckb(Ixb(Xv(a.f.B(new RJ(e, b)))));
            e.f.i = e.f.i & Ckb(Ixb(Xv(a.f.B(new RJ(e, b)))));
        }
        return a;
    }
    function RY(a, b) {
        var c, d, e, f;
        e = Eo(mX(b));
        for(d = WI(e, 0); d.b != d.d.c;){
            c = Wv(_ub(d), 12);
            f = c.d.f;
            if (f.g == (CX(), wX) && !(Ckb(Ixb(Xv(rJ(f, (Rib(), Vhb))))) && rJ(f, uib) != null)) {
                BU(f.d.a, f);
                PX(c.c, null);
                PX(c.d, null);
                return RY(a, f);
            } else return b;
        }
        return b;
    }
    function D7(a, b) {
        var c, d, e, f, g, h, i;
        if (!b.e) throw new slb('The input edge is not a tree edge.');
        f = null;
        e = $xb;
        for(d = new Tob(a.d); d.a < d.c.c.length;){
            c = Wv(Rob(d), 89);
            h = c.c;
            i = c.d;
            if (I7(a, h, b) && !I7(a, i, b)) {
                g = i.e - h.e - c.a;
                if (g < e) {
                    e = g;
                    f = c;
                }
            }
        }
        return f;
    }
    function Icb(a, b) {
        var c, d, e, f, g;
        f = b.a;
        f.c.f == b.b ? g = f.d : g = f.c;
        f.c.f == b.b ? d = f.c : d = f.d;
        e = vbb(a.a, g, d);
        if (e > 0 && e < rAb) {
            c = wbb(a.a, d.f, e);
            Bbb(a.a, d.f, -c);
            return c > 0;
        } else if (e < 0 && -e < rAb) {
            c = xbb(a.a, d.f, -e);
            Bbb(a.a, d.f, c);
            return c > 0;
        }
        return false;
    }
    function Odb(a, b, c, d, e) {
        var f, g;
        if (!yI(MI(Bv(tv(qz, 1), Fzb, 10, 0, [
            e.f.i,
            e.i,
            e.a
        ])), c)) {
            b.c == e ? rn(b.a, 0, new II(c)) : QI(b.a, new II(c));
            if (d && !ttb(a.a, c)) {
                g = Wv(rJ(b, (eM(), CL)), 44);
                if (!g) {
                    g = new jJ;
                    sJ(b, CL, g);
                }
                f = new II(c);
                TI(g, f, g.c.b, g.c);
                stb(a.a, f);
            }
        }
    }
    function Pdb(a) {
        var b, c, d, e, f, g, h;
        b = 0;
        for(d = new Tob(a.a); d.a < d.c.c.length;){
            c = Wv(Rob(d), 9);
            for(f = Uh(mX(c)); Cm(f);){
                e = Wv(Dm(f), 12);
                if (a == e.d.f.d && e.c.g == (sN(), rN)) {
                    g = MX(e.c).b;
                    h = MX(e.d).b;
                    b = b > (h - g <= 0 ? 0 - (h - g) : h - g) ? b : h - g <= 0 ? 0 - (h - g) : h - g;
                }
            }
        }
        return b;
    }
    function yo(a, b) {
        var c, d, e;
        if (gw(b) === gw(_b(a))) return true;
        if (!aw(b, 20)) return false;
        d = Wv(b, 20);
        e = a.Y();
        if (e != d.Y()) return false;
        if (aw(d, 63)) {
            for(c = 0; c < e; c++){
                if (!Tb(a.sb(c), d.sb(c))) return false;
            }
            return true;
        } else return Ol(a.mb(), d.mb());
    }
    function I8(a, b) {
        var c, d, e, f, g, h, i, j;
        e = a.b[b.k];
        if (e >= 0) return e;
        else {
            f = 1;
            for(h = new Tob(b.f); h.a < h.c.c.length;){
                g = Wv(Rob(h), 7);
                for(d = new Tob(g.e); d.a < d.c.c.length;){
                    c = Wv(Rob(d), 12);
                    j = c.d.f;
                    if (b != j) {
                        i = I8(a, j);
                        f = f > i + 1 ? f : i + 1;
                    }
                }
            }
            H8(a, b, f);
            return f;
        }
    }
    function edb(a, b, c) {
        var d, e, f, g, h, i;
        d = 0;
        if (a.b != 0 && b.b != 0) {
            f = WI(a, 0);
            g = WI(b, 0);
            h = Ixb(Yv(_ub(f)));
            i = Ixb(Yv(_ub(g)));
            e = true;
            do {
                h > i - c && h < i + c && ++d;
                h <= i && f.b != f.d.c ? h = Ixb(Yv(_ub(f))) : i <= h && g.b != g.d.c ? i = Ixb(Yv(_ub(g))) : e = false;
            }while (e);
        }
        return d;
    }
    function sv(a, b) {
        switch(uv(a)){
            case 5:
                return ew(b);
            case 6:
                return cw(b);
            case 7:
                return bw(b);
            case 0:
                return Vv(b, a.__elementTypeId$);
            case 2:
                return fw(b) && !(b.ad === kI);
            case 1:
                return fw(b) && !(b.ad === kI) || Vv(b, a.__elementTypeId$);
            default:
                return true;
        }
    }
    function Lv(a, b) {
        var c, d, e, f, g;
        b &= 63;
        c = a.h;
        d = (c & 524288) != 0;
        d && (c |= -1048576);
        if (b < 22) {
            g = c >> b;
            f = a.m >> b | c << 22 - b;
            e = a.l >> b | a.m << 22 - b;
        } else if (b < 44) {
            g = d ? bzb : 0;
            f = c >> b - 22;
            e = a.m >> b - 22 | c << 44 - b;
        } else {
            g = d ? bzb : 0;
            f = d ? azb : 0;
            e = c >> b - 44;
        }
        return Ev(e & azb, f & azb, g & bzb);
    }
    function O9(a, b) {
        switch(a.e){
            case 1:
                switch(b.e){
                    case 1:
                        return 1;
                    case 4:
                        return 2;
                    case 3:
                        return 3;
                    case 2:
                        return 4;
                }
                break;
            case 2:
                switch(b.e){
                    case 1:
                        return 1;
                    case 2:
                        return 2;
                    case 3:
                        return 3;
                    case 4:
                        return 4;
                }
                break;
            default:
                throw new slb(GAb);
        }
        return 0;
    }
    function hZ(a, b, c) {
        var d, e, f, g, h, i;
        d = new GU;
        d.c[d.c.length] = b;
        i = b;
        h = 0;
        do {
            i = mZ(a, i);
            !!i && (d.c[d.c.length] = i);
            ++h;
        }while (i);
        g = (c - (d.c.length - 1) * a.d.d) / d.c.length;
        for(f = new Tob(d); f.a < f.c.c.length;){
            e = Wv(Rob(f), 9);
            e.j.a = g;
        }
        return new RJ(Elb(h), g);
    }
    function kZ(a, b, c) {
        var d, e, f, g, h, i;
        d = new GU;
        d.c[d.c.length] = b;
        i = b;
        h = 0;
        do {
            i = lZ(a, i);
            !!i && (d.c[d.c.length] = i);
            ++h;
        }while (i);
        g = (c - (d.c.length - 1) * a.d.d) / d.c.length;
        for(f = new Tob(d); f.a < f.c.c.length;){
            e = Wv(Rob(f), 9);
            e.j.a = g;
        }
        return new RJ(Elb(h), g);
    }
    function m$(a) {
        var b, c, d, e, f, g;
        e = Wv(yU(a.f, 0), 7);
        g = 0;
        for(d = Uh(Sh((Gi(), new gr(Ti(Bv(tv(UF, 1), syb, 1, 4, [
            new fY(e),
            new lY(e)
        ])))))); Cm(d);){
            c = Wv(Dm(d), 7);
            g += c.f.i.a + c.i.a + c.a.a;
        }
        b = Wv(rJ(a, (eM(), SL)), 10);
        f = !b ? 0 : b.a;
        a.i.a = g / (e.b.c.length + e.e.c.length) - f;
    }
    function Ueb(a, b) {
        var c, d, e, f;
        if (b < 2 * a.c) throw new slb('The knot vector must have at least two time the dimension elements.');
        a.j = 0;
        a.i = 1;
        for(d = 0; d < a.c; d++)a.g.ib(0);
        f = b + 1 - 2 * a.c;
        for(e = 1; e < f; e++)a.g.ib(e / f);
        if (a.e) for(c = 0; c < a.c; c++)a.g.ib(1);
    }
    function Fs(a) {
        var b, c;
        c = a.c;
        a.c = 0;
        ds(a.f, a.i);
        if (!a.e) return a.g;
        else if (!a.g) return a.e;
        else if (a.e.d >= a.g.d) {
            b = a.f;
            b.e = Is(a.e, b);
            b.g = a.g;
            b.a = a.a - 1;
            b.j = XH(a.j, c);
            return Gs(b);
        } else {
            b = a.i;
            b.g = Js(a.g, b);
            b.e = a.e;
            b.a = a.a - 1;
            b.j = XH(a.j, c);
            return Gs(b);
        }
    }
    function e2(a) {
        var b, c, d, e, f, g;
        for(e = new Tob(a.a); e.a < e.c.c.length;){
            d = Wv(Rob(e), 9);
            if (d.g == (CX(), BX)) {
                f = Wv(rJ(d, (Rib(), nib)), 9);
                c = d.f;
                b = (Cxb(0, c.c.length), Wv(c.c[0], 7));
                g = Wv(rJ(b, uib), 7);
                g.g == (sN(), $M) && d.k > f.k ? QX(g, pN) : g.g == pN && f.k > d.k && QX(g, $M);
            }
        }
    }
    function q3(a, b, c) {
        var d, e, f, g, h, i, j;
        j = a.b;
        g = 0;
        for(f = new Tob(a.a.b); f.a < f.c.c.length;){
            e = Wv(Rob(f), 33);
            g = Nlb(g, e.j.a);
        }
        i = wfb(a.a.c, a.a.d, b, c, g);
        Ue(a.a.a, Veb(i));
        h = s3(a.a.b, i.a, j);
        d = new Dfb((!i.k && (i.k = new Efb(Xeb(i))), i.k));
        zfb(d);
        return !h ? d : Gfb(d, h);
    }
    function wbb(a, b, c) {
        var d, e, f, g, h, i, j;
        d = c;
        e = b;
        do {
            e = a.a[e.k];
            g = (j = a.f[e.k], Ixb(a.n[j.k]) + Ixb(a.d[e.k]) - e.e.d);
            h = zbb(e, !e.d ? -1 : zU(e.d.a, e, 0));
            if (h) {
                f = (i = a.f[h.k], Ixb(a.n[i.k]) + Ixb(a.d[h.k]) + h.j.b + h.e.a);
                d = Qlb(d, g - (f + Xjb(a.j, e, h)));
            }
        }while (b != e);
        return d;
    }
    function xbb(a, b, c) {
        var d, e, f, g, h, i, j;
        d = c;
        e = b;
        do {
            e = a.a[e.k];
            f = (j = a.f[e.k], Ixb(a.n[j.k]) + Ixb(a.d[e.k]) + e.j.b + e.e.a);
            h = ybb(e, !e.d ? -1 : zU(e.d.a, e, 0));
            if (h) {
                g = (i = a.f[h.k], Ixb(a.n[i.k]) + Ixb(a.d[h.k]) - h.e.d);
                d = Qlb(d, g - (f + Xjb(a.j, e, h)));
            }
        }while (b != e);
        return d;
    }
    function Sr(b, c, d) {
        var e, f, g;
        Mh(d, Xyb);
        if (d == 0) return Pr(b, c);
        g = b.c.a;
        f = xv(mw, Yyb, 26, 1, 12, 1);
        try {
            if (!ok(b.b, c) || !g) return 0;
            e = Hs(g, b.d, c, d, f);
        } catch (a) {
            a = OH(a);
            if (aw(a, 119)) return 0;
            else if (aw(a, 76)) return 0;
            else throw NH(a);
        }
        Us(b.c, g, e);
        return f[0];
    }
    function MO(a, b) {
        var c, d, e, f, g;
        if (a.b) {
            d = Wv(oW(a.e, (eM(), jL)), 65);
            e = d.b + d.c;
            c = d.d + d.a;
        } else {
            e = b * 2;
            c = b * 2;
        }
        g = Nlb(a.o[1] > 0 ? e + a.i[1] * b + a.n[1] : 0, a.o[3] > 0 ? e + a.i[3] * b + a.n[3] : 0);
        f = Nlb(a.o[4] > 0 ? c + a.i[4] * b + a.n[4] : 0, a.o[2] > 0 ? c + a.i[2] * b + a.n[2] : 0);
        return new HI(g, f);
    }
    function b$(a) {
        var b, c, d, e, f, g;
        g = Wv(FU(a.a, xv(qB, Nzb, 9, a.a.c.length, 0, 1)), 51);
        lpb(g, new g$);
        c = null;
        for(e = 0, f = g.length; e < f; ++e){
            d = g[e];
            if (d.g != (CX(), xX)) break;
            b = Wv(rJ(d, (Rib(), hib)), 32);
            if (b != (sN(), rN) && b != ZM) continue;
            !!c && Wv(rJ(c, oib), 20).ib(d);
            c = d;
        }
    }
    function j6(a, b, c, d, e) {
        var f, g, h, i;
        i = new U6(b, d);
        for(h = T6(i); h.G();){
            f = Wv(h.H(), 7);
            Umb(a.k, f, Elb(Wv(Smb(a.k, f), 24).a + Wv(re(Ktb(e.d, c)), 24).a));
        }
        i = new U6(c, d);
        for(g = T6(i); g.G();){
            f = Wv(g.H(), 7);
            Umb(a.k, f, Elb(Wv(Smb(a.k, f), 24).a - Wv(re(Ktb(e.d, b)), 24).a));
        }
    }
    function hI(a, b, c) {
        var d = fI, h;
        var e = d[a];
        var f = e instanceof Array ? e[0] : null;
        if (e && !f) _ = e;
        else {
            _ = (h = b && b.prototype, !h && (h = fI[b]), jI(h));
            _._c = c;
            _.constructor = _;
            !b && (_.ad = kI);
            d[a] = _;
        }
        for(var g = 3; g < arguments.length; ++g)arguments[g].prototype = _;
        f && (_.$c = f);
    }
    function Wkb(a) {
        if (a.Sc()) {
            var b = a.c;
            b.Tc() ? a.n = '[' + b.k : !b.Sc() ? a.n = '[L' + b.Qc() + ';' : a.n = '[' + b.Qc();
            a.b = b.Pc() + '[]';
            a.j = b.Rc() + '[]';
            return;
        }
        var c = a.i;
        var d = a.d;
        d = d.split('/');
        a.n = Zkb('.', [
            c,
            Zkb('$', d)
        ]);
        a.b = Zkb('.', [
            c,
            Zkb('.', d)
        ]);
        a.j = d[d.length - 1];
    }
    function Mr(a, b, c) {
        var d;
        if (!c) return 0;
        d = a.d.$b(a.b.g, c.b);
        if (d > 0) return Mr(a, b, c.g);
        else if (d == 0) switch(a.b.f.e){
            case 0:
                return PH(b._b(c), b.ac(c.g));
            case 1:
                return b.ac(c.g);
            default:
                throw new tkb;
        }
        else return PH(PH(b.ac(c.g), b._b(c)), Mr(a, b, c.e));
    }
    function Nr(a, b, c) {
        var d;
        if (!c) return 0;
        d = a.d.$b(a.b.e, c.b);
        if (d < 0) return Nr(a, b, c.e);
        else if (d == 0) switch(a.b.d.e){
            case 0:
                return PH(b._b(c), b.ac(c.e));
            case 1:
                return b.ac(c.e);
            default:
                throw new tkb;
        }
        else return PH(PH(b.ac(c.e), b._b(c)), Nr(a, b, c.g));
    }
    function z2(a, b, c, d) {
        var e, f, g, h;
        g = new uX(a);
        sX(g, (CX(), zX));
        sJ(g, (Rib(), uib), b);
        sJ(g, (eM(), TL), (KM(), FM));
        sJ(g, qib, c);
        sJ(g, rib, d);
        f = new RX;
        QX(f, (sN(), rN));
        PX(f, g);
        h = new RX;
        QX(h, ZM);
        PX(h, g);
        eW(b, f);
        e = new hW;
        qJ(e, b);
        sJ(e, CL, null);
        dW(e, h);
        eW(e, d);
        return g;
    }
    function e6(a, b) {
        var c, d, e, f, g, h, i, j, k, l;
        c = 0;
        for(g = a.j, h = 0, i = g.length; h < i; ++h){
            f = g[h];
            l = new U6(f, b);
            for(k = T6(l); k.G();){
                j = Wv(k.H(), 7);
                for(e = Uh(Sh((Gi(), new gr(Ti(Bv(tv(UF, 1), syb, 1, 4, [
                    j.b,
                    j.e
                ])))))); Cm(e);){
                    d = Wv(Dm(e), 12);
                    bW(d) || (c += b6(a, d, j));
                }
            }
        }
        return c;
    }
    function qab(a, b) {
        if (a.c < b.c) return -1;
        else if (a.c > b.c) return 1;
        else if (a.b < b.b) return -1;
        else if (a.b > b.b) return 1;
        else if (a.a != b.a) return txb(a.a) - txb(b.a);
        else if (a.d == (vab(), uab) && b.d == tab) return -1;
        else if (a.d == tab && b.d == uab) return 1;
        return 0;
    }
    function R4(a) {
        var b, c, d, e, f, g;
        e = new aJ;
        for(d = new Tob(a.d.a); d.a < d.c.c.length;){
            c = Wv(Rob(d), 61);
            c.c.c.length == 0 && TI(e, c, e.c.b, e.c);
        }
        if (e.b > 1) {
            b = x7(y7(new A7, a.b++), a.d);
            for(g = WI(e, 0); g.b != g.d.c;){
                f = Wv(_ub(g), 61);
                f7(i7(h7(j7(g7(new k7, 1), 0), b), f));
            }
        }
    }
    function p3(a, b, c, d) {
        var e, f, g, h, i, j;
        j = 0;
        for(g = new Tob(a.a.b); g.a < g.c.c.length;){
            f = Wv(Rob(g), 33);
            j = Nlb(j, f.j.a);
        }
        i = vfb(a.a.c, b, a.a.d, d, Jeb(a.b), c);
        Ue(a.a.a, Veb(i));
        h = s3(a.a.b, i.a, a.b);
        e = new Dfb((!i.k && (i.k = new Efb(Xeb(i))), i.k));
        zfb(e);
        return !h ? e : Gfb(e, h);
    }
    function M0(a, b) {
        var c, d, e, f, g;
        for(d = new Tob(a.b); d.a < d.c.c.length;){
            c = Wv(Rob(d), 33);
            sJ(c, (Rib(), pib), b);
        }
        for(g = new Tob(a.c.c); g.a < g.c.c.length;){
            e = Wv(Rob(g), 33);
            sJ(e, (Rib(), pib), b);
        }
        for(f = new Tob(a.d.c); f.a < f.c.c.length;){
            e = Wv(Rob(f), 33);
            sJ(e, (Rib(), pib), b);
        }
    }
    function I1() {
        I1 = iI;
        G1 = new J1(tzb, 0);
        B1 = new J1('NIKOLOV', 1);
        E1 = new J1('NIKOLOV_PIXEL', 2);
        C1 = new J1('NIKOLOV_IMPROVED', 3);
        D1 = new J1('NIKOLOV_IMPROVED_PIXEL', 4);
        A1 = new J1('DUMMYNODE_PERCENTAGE', 5);
        F1 = new J1('NODECOUNT_PERCENTAGE', 6);
        H1 = new J1('NO_BOUNDARY', 7);
    }
    function cab(a, b) {
        var c, d, e, f, g;
        f = 0;
        g = Wv(re(Ktb(b.d, a)), 24);
        if (!g) return 0;
        for(e = Uh(Sh((Gi(), new gr(Ti(Bv(tv(UF, 1), syb, 1, 4, [
            a.b,
            a.e
        ])))))); Cm(e);){
            d = Wv(Dm(e), 12);
            d.c == a ? c = Wv(Smb(b, d.d), 24) : c = Wv(Smb(b, d.c), 24);
            !!c && g.a > c.a && (f = Plb(f, g.a - c.a - 1));
        }
        return f;
    }
    function RZ(a) {
        var b, c;
        b = Wv(rJ(a, (eM(), HL)), 15).a;
        c = Wv(rJ(a, IL), 15).a;
        sJ(a, IL, new llb(b));
        sJ(a, HL, new llb(c));
        switch(Wv(rJ(a, lL), 103).e){
            case 1:
                sJ(a, lL, (iK(), hK));
                break;
            case 2:
                sJ(a, lL, (iK(), dK));
                break;
            case 3:
                sJ(a, lL, (iK(), fK));
                break;
            case 4:
                sJ(a, lL, (iK(), gK));
        }
    }
    function N0(a) {
        var b, c, d, e, f;
        for(e = (Il(), new Im(Dl(ul(a.a, new yl)))); Cm(e);){
            d = Wv(Dm(e), 9);
            if (d.g == (CX(), yX)) {
                f = P0(d) ? (kP(), hP) : (kP(), gP);
                sJ(d, (Rib(), pib), f);
            }
            for(c = Uh(mX(d)); Cm(c);){
                b = Wv(Dm(c), 12);
                f = Ckb(Ixb(Xv(rJ(b, (Rib(), Iib))))) ? (kP(), gP) : (kP(), hP);
                M0(b, f);
            }
        }
    }
    function O0(a) {
        var b, c, d, e, f;
        for(e = (Il(), new Im(Dl(ul(a.a, new yl)))); Cm(e);){
            d = Wv(Dm(e), 9);
            if (d.g == (CX(), yX)) {
                f = P0(d) ? (kP(), gP) : (kP(), hP);
                sJ(d, (Rib(), pib), f);
            }
            for(c = Uh(mX(d)); Cm(c);){
                b = Wv(Dm(c), 12);
                f = Ckb(Ixb(Xv(rJ(b, (Rib(), Iib))))) ? (kP(), hP) : (kP(), gP);
                M0(b, f);
            }
        }
    }
    function jdb(a, b, c) {
        var d, e, f;
        for(f = new Tob(a.e); f.a < f.c.c.length;){
            d = Wv(Rob(f), 118);
            if (d.b.d < 0 && d.c > 0) {
                d.b.c -= d.c;
                d.b.c <= 0 && d.b.f > 0 && QI(b, d.b);
            }
        }
        for(e = new Tob(a.b); e.a < e.c.c.length;){
            d = Wv(Rob(e), 118);
            if (d.a.d < 0 && d.c > 0) {
                d.a.f -= d.c;
                d.a.f <= 0 && d.a.c > 0 && QI(c, d.a);
            }
        }
    }
    function agb(a, b, c) {
        var d, e, f;
        for(f = new Tob(a.j); f.a < f.c.c.length;){
            d = Wv(Rob(f), 117);
            if (d.b.i < 0 && d.c > 0) {
                d.b.e -= d.c;
                d.b.e <= 0 && d.b.k > 0 && QI(b, d.b);
            }
        }
        for(e = new Tob(a.d); e.a < e.c.c.length;){
            d = Wv(Rob(e), 117);
            if (d.a.i < 0 && d.c > 0) {
                d.a.k -= d.c;
                d.a.k <= 0 && d.a.e > 0 && QI(c, d.a);
            }
        }
    }
    function tj(a) {
        var b, c, d, e, f;
        f = a.d.c + a.e.c;
        switch(f){
            case 0:
                return dr(), cr;
            case 1:
                d = Wv(Sl(new rnb(new inb(a).a)), 21);
                return Bj(d.yb(), d.zb());
            default:
                e = (mp(), new wub);
                for(c = new rnb(new inb(a).a); c.b;){
                    b = pnb(c);
                    tub(e, _b(b.yb()), _b(b.zb()));
                }
                return new ir(e);
        }
    }
    function DS(a, b, c) {
        var d, e, f;
        for(e = new Tob(a.b.a.b); e.a < e.c.c.length;){
            d = Wv(Rob(e), 25);
            if (!b.D(d)) continue;
            f = Ixb(Yv(c.B(d)));
            if (f > 0) {
                !(tK(a.b.d) && d.q.d) && !(uK(a.b.d) && d.q.b) && (d.j.e += 0 > f / 2 - 0.5 ? 0 : f / 2 - 0.5);
                !(tK(a.b.d) && d.q.a) && !(uK(a.b.d) && d.q.c) && (d.j.b -= f - 1);
            }
        }
    }
    function R9(a, b) {
        switch(a.e){
            case 1:
                switch(b.e){
                    case 1:
                        return HAb;
                    case 4:
                        return 0.5;
                    case 3:
                        return IAb;
                    case 2:
                        return JAb;
                }
                break;
            case 2:
                switch(b.e){
                    case 1:
                        return HAb;
                    case 2:
                        return 0.5;
                    case 3:
                        return IAb;
                    case 4:
                        return JAb;
                }
                break;
            default:
                throw new slb(GAb);
        }
        return 0;
    }
    function rT(a, b) {
        var c, d, e, f;
        f = new Fnb(a, 0);
        c = (Bxb(f.b < f.d.Y()), Wv(f.d.sb(f.c = f.b++), 48));
        while(f.b < f.d.Y()){
            d = (Bxb(f.b < f.d.Y()), Wv(f.d.sb(f.c = f.b++), 48));
            e = new WS(d.c, c.d, b);
            Bxb(f.b > 0);
            f.a.sb(f.c = --f.b);
            Anb(f, e);
            Bxb(f.b < f.d.Y());
            f.d.sb(f.c = f.b++);
            e.a = false;
            c = d;
        }
    }
    function oZ(a) {
        var b, c, d, e, f, g;
        e = Wv(rJ(a, (Rib(), Zhb)), 7);
        for(g = new Tob(a.f); g.a < g.c.c.length;){
            f = Wv(Rob(g), 7);
            for(d = new Tob(f.e); d.a < d.c.c.length;){
                b = Wv(Rob(d), 12);
                eW(b, e);
                return f;
            }
            for(c = new Tob(f.b); c.a < c.c.c.length;){
                b = Wv(Rob(c), 12);
                dW(b, e);
                return f;
            }
        }
        return null;
    }
    function i6(a, b, c, d, e) {
        var f, g, h, i, j, k;
        g = b;
        f = 0;
        h = false;
        k = new U6(c, d);
        for(j = T6(k); j.G();){
            i = Wv(j.H(), 7);
            h = true;
            Umb(a.k, i, Elb(g));
            if (LM(Wv(rJ(c, (eM(), TL)), 28)) || i.b.c.length + i.e.c.length > 1) {
                ++f;
                ++g;
            }
        }
        if (!LM(Wv(rJ(c, (eM(), TL)), 28)) && h) {
            ++f;
            ++g;
        }
        Umb(e, c, Elb(f));
        return g;
    }
    function nfb(a) {
        var b, c, d, e, f, g, h, i, j, k, l, m;
        g = a.b.mb();
        h = Wv(g.H(), 92);
        k = h.a.a;
        j = k > RAb;
        i = k < SAb;
        while(g.G()){
            c = h;
            f = k;
            e = j;
            d = i;
            h = Wv(g.H(), 92);
            k = h.a.a;
            j = k > RAb;
            i = k < SAb;
            if (!(j || i)) return mfb(h.b);
            if (e && i || d && j) {
                b = f / (f - k);
                l = mfb(c.b);
                m = mfb(h.b);
                return b * l + (1 - b) * m;
            }
        }
        return 0;
    }
    function ofb(a) {
        var b, c, d, e, f, g, h, i, j, k, l, m;
        g = a.b.mb();
        h = Wv(g.H(), 92);
        k = h.a.b;
        j = k > RAb;
        i = k < SAb;
        while(g.G()){
            c = h;
            f = k;
            e = j;
            d = i;
            h = Wv(g.H(), 92);
            k = h.a.b;
            j = k > RAb;
            i = k < SAb;
            if (!(j || i)) return mfb(h.b);
            if (e && i || d && j) {
                b = f / (f - k);
                l = mfb(c.b);
                m = mfb(h.b);
                return b * l + (1 - b) * m;
            }
        }
        return 0;
    }
    function b6(a, b, c) {
        var d, e;
        d = 0;
        if (d6(b)) {
            if (ttb(a.g, b)) {
                Sr(a.i, Elb(h6(a, b.c)), 1);
                Sr(a.i, Elb(h6(a, b.d)), 1);
                utb(a.g, b);
                d += g6(a, b, a.i);
            } else {
                stb(a.g, b);
                Lr(a.i, Elb(h6(a, b.c)), 1);
                Lr(a.i, Elb(h6(a, b.d)), 1);
            }
        } else {
            e = Pr(a.i, Elb(Wv(Smb(a.k, c), 24).a));
            d += a.g.a.Y() - e;
        }
        return d;
    }
    function Keb(a) {
        switch(a.e){
            case 0:
                return veb;
            case 1:
                return seb;
            case 2:
                return reb;
            case 3:
                return yeb;
            case 4:
                return xeb;
            case 5:
                return Deb;
            case 6:
                return Ceb;
            case 7:
                return web;
            case 8:
                return teb;
            case 9:
                return ueb;
            case 11:
                return Aeb;
            case 10:
                return zeb;
            default:
                return Beb;
        }
    }
    function Leb(a) {
        switch(a.e){
            case 0:
                return neb;
            case 1:
                return meb;
            case 2:
                return jeb;
            case 3:
                return ieb;
            case 4:
                return peb;
            case 5:
                return oeb;
            case 6:
                return Heb;
            case 7:
                return Geb;
            case 8:
                return leb;
            case 9:
                return keb;
            case 10:
                return Eeb;
            case 11:
                return qeb;
            default:
                return Feb;
        }
    }
    function Meb(a) {
        switch(a.e){
            case 0:
                return oeb;
            case 1:
                return Heb;
            case 2:
                return Geb;
            case 3:
                return neb;
            case 4:
                return meb;
            case 5:
                return jeb;
            case 6:
                return ieb;
            case 7:
                return peb;
            case 8:
                return leb;
            case 9:
                return keb;
            case 10:
                return Eeb;
            case 11:
                return qeb;
            default:
                return Feb;
        }
    }
    function Neb(a) {
        switch(a.e){
            case 0:
                return jeb;
            case 1:
                return ieb;
            case 2:
                return peb;
            case 3:
                return oeb;
            case 4:
                return Heb;
            case 5:
                return Geb;
            case 6:
                return neb;
            case 7:
                return meb;
            case 8:
                return leb;
            case 9:
                return keb;
            case 10:
                return Eeb;
            case 11:
                return qeb;
            default:
                return Feb;
        }
    }
    function fcb(a) {
        var b, c, d, e, f, g, h, i;
        c = (mp(), new wub);
        h = new Yub((Oh(), new opb(a.f)));
        for(g = (e = new Snb(h.a).a.bb().mb(), new Ynb(e)); g.a.G();){
            f = (d = Wv(g.a.H(), 21), Wv(d.yb(), 9));
            if (!f) {
                Fmb();
                break;
            }
            i = a.i[f.k];
            b = Wv(rub(c, i), 20);
            if (!b) {
                b = new GU;
                tub(c, i, b);
            }
            b.ib(f);
        }
        return c;
    }
    function CS(a, b, c) {
        var d, e, f;
        for(e = new Tob(a.b.a.b); e.a < e.c.c.length;){
            d = Wv(Rob(e), 25);
            if (!b.D(d)) continue;
            f = Ixb(Yv(c.B(d)));
            if (f > 0) {
                !(tK(a.b.d) && d.q.d) && !(uK(a.b.d) && d.q.b) && (d.j.e -= 0 > f / 2 - 0.5 ? 0 : f / 2 - 0.5);
                !(tK(a.b.d) && d.q.a) && !(uK(a.b.d) && d.q.c) && (d.j.b += 0 > f - 1 ? 0 : f - 1);
            }
        }
    }
    function T6(a) {
        var b, c, d;
        d = a.a.f;
        switch(a.b){
            case 0:
                return new Tob(a.a.f);
            case 1:
                return Pl((c = new W6(d), c), S6(a));
            case 2:
                switch(a.c.e){
                    case 2:
                    case 1:
                        return Pl(new Tob(d), S6(a));
                    case 3:
                    case 4:
                        return Pl((b = new W6(d), b), S6(a));
                }
        }
        throw new Imb('PortOrder not implemented.');
    }
    function CT(a, b) {
        var c;
        if (!!a.d && (b.c != a.e.c || hT(a.e.b, b.b))) {
            vU(a.f, a.d);
            a.a = a.d.d + a.d.c;
            a.d = null;
            a.e = null;
        }
        eT(b.b) ? a.c = b : a.b = b;
        if (b.b == (cT(), $S) && !b.a || b.b == _S && b.a || b.b == aT && b.a || b.b == bT && !b.a) {
            if (!!a.c && !!a.b) {
                c = new VN(a.a, a.c.d, b.c - a.a, a.b.d - a.c.d);
                a.d = c;
                a.e = b;
            }
        }
    }
    function Cbb(a, b, c, d) {
        this.e = a;
        this.j = Wv(rJ(a, (Rib(), Kib)), 134);
        this.f = xv(qB, Nzb, 9, b, 0, 1);
        this.b = xv(HF, Txb, 184, b, 6, 1);
        this.a = xv(qB, Nzb, 9, b, 0, 1);
        this.d = xv(HF, Txb, 184, b, 6, 1);
        this.i = xv(qB, Nzb, 9, b, 0, 1);
        this.g = xv(HF, Txb, 184, b, 6, 1);
        this.n = xv(HF, Txb, 184, b, 6, 1);
        this.k = c;
        this.c = d;
    }
    function P6(a, b, c) {
        var d, e;
        if (b.g == (CX(), BX) && c.g == BX) {
            if (!LM(Wv(rJ(Wv(rJ(b, (Rib(), uib)), 9), (eM(), TL)), 28)) || Wv(rJ(b, uib), 9) != Wv(rJ(c, uib), 9)) return;
            if (I6(b) || I6(c)) {
                a.d = 1;
                a.b = 1;
                return;
            }
            e = Wv(yU(b.f, 0), 7).g;
            d = Wv(yU(c.f, 0), 7).g;
            M6(b).g == (sN(), $M) ? H6(a, b, c, e, d) : H6(a, c, b, d, e);
        }
    }
    function f7(a) {
        if (!a.a.c || !a.a.d) throw new ulb((Gkb(QD), QD.j + ' must have a source and target ' + (Gkb(UD), UD.j) + ' specified.'));
        if (a.a.c == a.a.d) throw new ulb('Network simplex does not support self-loops: ' + a.a + ' ' + a.a.c + ' ' + a.a.d);
        o7(a.a.c.g, a.a);
        o7(a.a.d.c, a.a);
        return a.a;
    }
    function H6(a, b, c, d, e) {
        if (d == (sN(), ZM) && e == ZM) N6(a, b) > N6(a, c) ? a.d = K6(a, c) : a.b = K6(a, b);
        else if (d == rN && e == rN) N6(a, b) < N6(a, c) ? a.d = K6(a, c) : a.b = K6(a, b);
        else if (d == rN && e == ZM) {
            if (N6(a, b) > N6(a, c)) {
                a.d = K6(a, c);
                a.b = K6(a, b);
            }
        } else if (N6(a, b) < N6(a, c)) {
            a.d = K6(a, c);
            a.b = K6(a, b);
        }
    }
    function W1(a) {
        var b, c, d, e, f, g, h, i;
        i = a.f.c.length;
        c = 0;
        b = i;
        e = 2 * i;
        for(h = new Tob(a.f); h.a < h.c.c.length;){
            g = Wv(Rob(h), 7);
            switch(g.g.e){
                case 2:
                case 4:
                    g.k = -1;
                    break;
                case 1:
                case 3:
                    d = g.b.c.length;
                    f = g.e.c.length;
                    d > 0 && f > 0 ? g.k = b++ : d > 0 ? g.k = c++ : f > 0 ? g.k = e++ : g.k = c++;
            }
        }
        Gpb(a.f, new Z1);
    }
    function i0(a, b, c, d) {
        var e, f, g, h, i;
        if (c.d.f == b.f) return;
        e = new uX(a);
        sX(e, (CX(), zX));
        sJ(e, (Rib(), uib), c);
        sJ(e, (eM(), TL), (KM(), FM));
        d.c[d.c.length] = e;
        g = new RX;
        PX(g, e);
        QX(g, (sN(), rN));
        h = new RX;
        PX(h, e);
        QX(h, ZM);
        i = c.d;
        eW(c, g);
        f = new hW;
        qJ(f, c);
        sJ(f, CL, null);
        dW(f, h);
        eW(f, i);
        j0(e, g, h);
    }
    function W2(a) {
        var b, c, d, e, f, g, h, i, j;
        g = rAb;
        i = rAb;
        h = null;
        for(c = new Sub(new Lub(a.e)); c.b != c.c.a.b;){
            b = Rub(c);
            if (Wv(b.d, 60).c == 1) {
                d = Wv(b.e, 116).a;
                j = Wv(b.e, 116).b;
                e = g - d > uAb;
                f = d - g < uAb && i - j > uAb;
                if (e || f) {
                    i = Wv(b.e, 116).b;
                    g = Wv(b.e, 116).a;
                    h = Wv(b.d, 60);
                    if (i == 0 && g == 0) return h;
                }
            }
        }
        return h;
    }
    function i1(a, b) {
        var c, d, e, f, g, h;
        f = a.d;
        h = Wv(rJ(a, (eM(), dM)), 15).a;
        if (h < 0) {
            h = 0;
            sJ(a, dM, new llb(h));
        }
        b.j.b = h;
        g = Math.floor(h / 2);
        d = new RX;
        QX(d, (sN(), rN));
        PX(d, b);
        d.i.b = g;
        e = new RX;
        QX(e, ZM);
        PX(e, b);
        e.i.b = g;
        eW(a, d);
        c = new hW;
        qJ(c, a);
        sJ(c, CL, null);
        dW(c, e);
        eW(c, f);
        h1(b, a, c);
        f1(a, c);
        return c;
    }
    function OZ(a) {
        var b, c;
        c = Wv(rJ(a, (Mjb(), vjb)), 85);
        b = Wv(rJ(a, (Rib(), mib)), 140);
        if (c == (Xib(), Tib)) {
            sJ(a, vjb, Wib);
            sJ(a, mib, (Hhb(), Ghb));
        } else if (c == Vib) {
            sJ(a, vjb, Wib);
            sJ(a, mib, (Hhb(), Ehb));
        } else if (b == (Hhb(), Ghb)) {
            sJ(a, vjb, Tib);
            sJ(a, mib, Fhb);
        } else if (b == Ehb) {
            sJ(a, vjb, Vib);
            sJ(a, mib, Fhb);
        }
    }
    function QO(a) {
        var b, c, d, e, f;
        for(d = new Tob(zW(a.e)); d.a < d.c.c.length;){
            c = Wv(Rob(d), 129);
            f = new II(c.e.i);
            e = xO()[c.e.k];
            b = Wv(qsb(a.c, e), 283);
            f.b = b.e + b.a;
            e.b == (DO(), BO) ? f.a = b.d : e.b == AO ? f.a = b.d + (b.c - c.e.j.a) / 2 : e.b == CO && (f.a = b.d + b.c - c.e.j.a);
            c.e.i.a = f.a;
            c.e.i.b = f.b;
            b.a += c.e.j.b + a.d;
        }
    }
    function UO(a) {
        var b, c, d;
        for(c = new Tob(AW(a)); c.a < c.c.c.length;){
            b = Wv(Rob(c), 161);
            d = new II(b.e.i);
            switch(Wv(b.e, 7).g.e){
                case 4:
                    d.a = 0;
                    d.b = a.e.j.b / 2;
                    break;
                case 2:
                    d.a = a.e.j.a;
                    d.b = a.e.j.b / 2;
                    break;
                case 1:
                    d.a = a.e.j.a / 2;
                    d.b = 0;
                    break;
                case 3:
                    d.a = a.e.j.a / 2;
                    d.b = a.e.j.b;
            }
            b.e.i.a = d.a;
            b.e.i.b = d.b;
        }
    }
    function oV() {
        this.c = xv(kw, hyb, 26, (sN(), Bv(tv(Kz, 1), uyb, 32, 0, [
            qN,
            $M,
            ZM,
            pN,
            rN
        ])).length, 12, 1);
        this.b = xv(kw, hyb, 26, Bv(tv(Kz, 1), uyb, 32, 0, [
            qN,
            $M,
            ZM,
            pN,
            rN
        ]).length, 12, 1);
        this.a = xv(kw, hyb, 26, Bv(tv(Kz, 1), uyb, 32, 0, [
            qN,
            $M,
            ZM,
            pN,
            rN
        ]).length, 12, 1);
        Yob(this.c, Uzb);
        Yob(this.b, Vzb);
        Yob(this.a, Vzb);
    }
    function tfb(a, b, c) {
        var d, e, f, g, h, i, j, k;
        f = Ixb(Yv(a.b.mb().H()));
        j = Ixb(Yv(rl(b.b)));
        d = CI(xI(a.a), j - c);
        e = CI(xI(b.a), c - f);
        k = vI(d, e);
        CI(k, 1 / (j - f));
        this.a = k;
        this.b = new GU;
        h = true;
        g = a.b.mb();
        g.H();
        while(g.G()){
            i = Ixb(Yv(g.H()));
            if (h && i - c > RAb) {
                this.b.ib(c);
                h = false;
            }
            this.b.ib(i);
        }
        h && this.b.ib(c);
    }
    function G7(a) {
        var b, c, d, e;
        J7(a, a.n);
        if (a.d.c.length > 0) {
            dpb(a.c);
            while(R7(a, Wv(Rob(new Tob(a.e.a)), 61)) < a.e.a.c.length){
                b = L7(a);
                e = b.d.e - b.c.e - b.a;
                b.d.j && (e = -e);
                for(d = new Tob(a.e.a); d.a < d.c.c.length;){
                    c = Wv(Rob(d), 61);
                    c.j && (c.e += e);
                }
                dpb(a.c);
            }
            dpb(a.c);
            O7(a, Wv(Rob(new Tob(a.e.a)), 61));
            C7(a);
        }
    }
    function Aab(a, b) {
        var c, d, e, f, g, h, i;
        c = Vzb;
        h = (CX(), AX);
        for(e = new Tob(b.a); e.a < e.c.c.length;){
            d = Wv(Rob(e), 9);
            f = d.g;
            if (f != AX) {
                g = Yv(rJ(d, (Rib(), wib)));
                if (g == null) {
                    c = c > 0 ? c : 0;
                    d.i.b = c + Wjb(a.a, f, h);
                } else d.i.b = (Dxb(g), g);
            }
            i = Wjb(a.a, f, h);
            d.i.b < c + i + d.e.d && (d.i.b = c + i + d.e.d);
            c = d.i.b + d.j.b + d.e.a;
            h = f;
        }
    }
    function mdb(a, b, c) {
        var d, e, f;
        c.db(b, a);
        vU(a.g, b);
        f = a.o.d.Lc(b);
        hlb(a.k) ? a.k = f : a.k = Qlb(a.k, f);
        hlb(a.a) ? a.a = f : a.a = Nlb(a.a, f);
        b.g == a.o.d.Mc() ? hdb(a.j, f) : hdb(a.n, f);
        for(e = Uh(Sh((Gi(), new gr(Ti(Bv(tv(UF, 1), syb, 1, 4, [
            new fY(b),
            new lY(b)
        ])))))); Cm(e);){
            d = Wv(Dm(e), 7);
            c.R(d) || mdb(a, d, c);
        }
    }
    function dlb(a) {
        var b, c, d, e, f;
        d = (bmb(), a.length);
        e = d > 0 && (a.charCodeAt(0) == 45 || a.charCodeAt(0) == 43) ? 1 : 0;
        for(b = e; b < d; b++){
            if (Dkb(a.charCodeAt(b)) == -1) throw new Ylb(dyb + a + '"');
        }
        f = parseInt(a, 10);
        c = f < eyb;
        if (isNaN(f)) throw new Ylb(dyb + a + '"');
        else if (c || f > $xb) throw new Ylb(dyb + a + '"');
        return f;
    }
    function H$(a, b, c, d) {
        var e, f, g, h;
        e = Wv(nX(b, (sN(), rN)).mb().H(), 7);
        f = Wv(nX(b, ZM).mb().H(), 7);
        for(h = new Tob(a.f); h.a < h.c.c.length;){
            g = Wv(Rob(h), 7);
            while(g.b.c.length != 0)eW(Wv(yU(g.b, 0), 12), e);
            while(g.e.c.length != 0)dW(Wv(yU(g.e, 0), 12), f);
        }
        c || sJ(b, (Rib(), qib), null);
        d || sJ(b, (Rib(), rib), null);
    }
    function jU(a) {
        var b, c, d, e, f, g, h;
        h = new $U;
        for(g = new Tob(a.b); g.a < g.c.c.length;){
            f = Wv(Rob(g), 9);
            if (f.g == (CX(), xX)) continue;
            hU(h, f, new FI);
            for(e = Uh(mX(f)); Cm(e);){
                d = Wv(Dm(e), 12);
                if (d.c.f.g == xX || d.d.f.g == xX) continue;
                for(c = WI(d.a, 0); c.b != c.d.c;){
                    b = Wv(_ub(c), 10);
                    ZU(h, new VS(b.a, b.b));
                }
            }
        }
        return h;
    }
    function X4(a, b, c, d) {
        var e, f, g;
        this.e = new jJ;
        this.a = a;
        this.b = b;
        if (a.b < b.b) {
            this.j = a.a;
            this.k = a.b;
            this.n = b.b;
        } else {
            this.j = b.a;
            this.k = b.b;
            this.n = a.b;
        }
        e = Wv(rJ(d, (eM(), CL)), 44);
        if (e) for(g = WI(e, 0); g.b != g.d.c;){
            f = Wv(_ub(g), 10);
            RR(f.a, a.a) && QI(this.e, f);
        }
        this.g = c;
        !!this.g && (this.i = this.j - c.j.d);
        this.f = d;
    }
    function Zj(a) {
        hi();
        var b, c, d, e, f, g;
        g = new Wub;
        zpb(g, a);
        for(c = (f = new Snb(g.a).a.bb().mb(), new Ynb(f)); c.a.G();){
            b = (d = Wv(c.a.H(), 21), d.yb());
            _b(b);
        }
        switch(g.a.Y()){
            case 0:
                return kr(), jr;
            case 1:
                return new Gr((e = new Snb(g.a).a.bb().mb(), d = Wv(new Ynb(e).a.H(), 21), d.yb()));
            default:
                return new lr(g);
        }
    }
    function $P(a, b, c, d) {
        var e, f, g;
        VP(a, c, 'x', b.i.a + d.a);
        VP(a, c, 'y', b.i.b + d.b);
        VP(a, c, Jzb, b.j.a);
        VP(a, c, Kzb, b.j.b);
        if (aw(b, 9)) {
            if (Wv(rJ(b, (eM(), bM)), 86).kb((MN(), JN))) {
                e = Wv(b, 9).b;
                g = Pu(c, Lzb);
                if (!g) {
                    g = new Tu;
                    Ru(c, Lzb, g);
                }
                f = g.kc();
                VP(a, f, 'left', e.b);
                VP(a, f, 'top', e.d);
                VP(a, f, 'right', e.c);
                VP(a, f, Azb, e.a);
            }
        }
    }
    function GR(a, b) {
        var c, d, e, f, g, h, i, j, k, l;
        g = b == 1 ? wR : vR;
        for(f = (i = new Snb(g.a).a.bb().mb(), new Ynb(i)); f.a.G();){
            e = (h = Wv(f.a.H(), 21), Wv(h.yb(), 59));
            for(k = Wv(Dd(a.f.c, e), 18).mb(); k.G();){
                j = Wv(k.H(), 27);
                d = Wv(j.b, 25);
                l = Wv(j.a, 78);
                c = l.c;
                switch(e.e){
                    case 2:
                    case 1:
                        d.j.e += c;
                        break;
                    case 4:
                    case 3:
                        d.j.d += c;
                }
            }
        }
    }
    function IS(a, b) {
        var c, d, e;
        b.a ? (Rwb(a.b, b.b), a.a[b.b.k] = Wv(Twb(a.b, b.b), 25), c = Wv(Swb(a.b, b.b), 25), !!c && (a.a[c.k] = b.b), undefined) : (d = Wv(Twb(a.b, b.b), 25), !!d && d == a.a[b.b.k] && !!d.f && d.f != b.b.f && d.i.ib(b.b), e = Wv(Swb(a.b, b.b), 25), !!e && a.a[e.k] == b.b && !!e.f && e.f != b.b.f && b.b.i.ib(e), Uwb(a.b, b.b), undefined);
    }
    function p1(a, b) {
        var c, d, e, f, g, h, i;
        e = new GU;
        for(c = 0; c <= a.i; c++){
            d = new sY(b);
            d.k = a.i - c;
            e.c[e.c.length] = d;
        }
        for(h = new Tob(a.o); h.a < h.c.c.length;){
            g = Wv(Rob(h), 9);
            rX(g, Wv(yU(e, a.i - a.f[g.k]), 16));
        }
        f = new Tob(e);
        while(f.a < f.c.c.length){
            i = Wv(Rob(f), 16);
            i.a.c.length == 0 && Sob(f);
        }
        b.c.c = xv(UF, syb, 1, 0, 4, 1);
        xU(b.c, e);
    }
    function N4(a) {
        var b, c, d, e;
        a.a.a.c = xv(UF, syb, 1, 0, 4, 1);
        for(d = new Tob(a.a.b); d.a < d.c.c.length;){
            b = Wv(Rob(d), 25);
            b.f = null;
        }
        for(e = new Tob(a.a.b); e.a < e.c.c.length;){
            b = Wv(Rob(e), 25);
            !b.o && vU(a.a.a, new QR(Bv(tv(kA, 1), syb, 25, 0, [
                b
            ])));
        }
        for(c = new Tob(a.a.b); c.a < c.c.c.length;){
            b = Wv(Rob(c), 25);
            !!b.o && OR(b.o.f, b);
        }
    }
    function fc(a, b) {
        var c, d, e, f;
        a = (bmb(), a == null ? Wxb : a);
        c = (a.length, b.length, new Amb);
        f = 0;
        d = 0;
        while(d < b.length){
            e = a.indexOf('%s', f);
            if (e == -1) break;
            jkb(c, a, f, e);
            xmb(c, b[d++]);
            f = e + 2;
        }
        wmb(c, a, f, a.length);
        if (d < b.length) {
            c.a += ' [';
            xmb(c, b[d++]);
            while(d < b.length){
                c.a += ', ';
                xmb(c, b[d++]);
            }
            c.a += ']';
        }
        return c.a;
    }
    function _vb(a, b, c, d) {
        var e, f;
        if (!b) return c;
        else {
            e = a.a.$b(c.d, b.d);
            if (e == 0) {
                d.d = job(b, c.e);
                d.b = true;
                return b;
            }
            f = e < 0 ? 0 : 1;
            b.a[f] = _vb(a, b.a[f], c, d);
            if (awb(b.a[f])) {
                if (awb(b.a[1 - f])) {
                    b.b = true;
                    b.a[0].b = false;
                    b.a[1].b = false;
                } else awb(b.a[f].a[f]) ? b = hwb(b, 1 - f) : awb(b.a[f].a[1 - f]) && (b = gwb(b, 1 - f));
            }
        }
        return b;
    }
    function GY(a, b) {
        var c, d, e, f, g, h, i, j, k, l;
        i = pmb(b.a);
        h = hw(Llb(i / a.a));
        l = b.a;
        g = 0;
        j = h;
        for(f = 0; f < a.a; ++f){
            k = (bmb(), l.substr((0 > g ? 0 : g) < i ? 0 > g ? 0 : g : i, (0 > (j < i ? j : i) ? 0 : j < i ? j : i) - ((0 > g ? 0 : g) < i ? 0 > g ? 0 : g : i)));
            g = j;
            j += h;
            d = Wv(yU(a.c, f), 9);
            c = new dX(k);
            c.j.b = b.j.b;
            Fd(a.b, b, c);
            vU(d.c, c);
        }
        BU(a.g.c, b);
        vU(a.i, (e = new PY(a, b), e));
    }
    function p8(a, b, c) {
        var d, e, f, g, h, i, j, k, l;
        b.k = 1;
        f = b.d;
        for(l = oX(b, (djb(), bjb)).mb(); l.G();){
            k = Wv(l.H(), 7);
            for(e = new Tob(k.e); e.a < e.c.c.length;){
                d = Wv(Rob(e), 12);
                j = d.d.f;
                if (b != j) {
                    g = j.d;
                    if (g.k <= f.k) {
                        h = f.k + 1;
                        if (h == c.c.c.length) {
                            i = new sY(c);
                            i.k = h;
                            vU(c.c, i);
                            rX(j, i);
                        } else {
                            i = Wv(yU(c.c, h), 16);
                            rX(j, i);
                        }
                        p8(a, j, c);
                    }
                }
            }
        }
    }
    function SO(a) {
        var b, c, d, e, f;
        b = a.e.j;
        for(d = new Tob(AW(a)); d.a < d.c.c.length;){
            c = Wv(Rob(d), 161);
            e = Wv(oW(c, (eM(), LL)), 15);
            !e && (e = new llb(0));
            f = new II(c.e.i);
            switch(Wv(c.e, 7).g.e){
                case 4:
                    f.a = -c.e.j.a - e.a;
                    break;
                case 2:
                    f.a = b.a + e.a;
                    break;
                case 1:
                    f.b = -c.e.j.b - e.a;
                    break;
                case 3:
                    f.b = b.b + e.a;
            }
            c.e.i.a = f.a;
            c.e.i.b = f.b;
        }
    }
    function PZ(a) {
        var b, c, d;
        d = Wv(rJ(a, (eM(), JL)), 18);
        if (d.V()) return;
        c = (b = Wv(Hkb(Gz), 11), new atb(b, Wv(exb(b, b.length), 11), 0));
        d.kb((oM(), jM)) ? Wsb(c, jM) : Wsb(c, kM);
        d.kb(hM) || Wsb(c, hM);
        d.kb(gM) ? Wsb(c, nM) : d.kb(fM) ? Wsb(c, mM) : d.kb(iM) && Wsb(c, lM);
        d.kb(nM) ? Wsb(c, gM) : d.kb(mM) ? Wsb(c, fM) : d.kb(lM) && Wsb(c, iM);
        sJ(a, JL, c);
    }
    function afb(a, b, c, d, e) {
        var f, g, h, i, j, k, l, m, n, o1;
        m = Zeb(a, c);
        for(i = 0; i < b; i++){
            e.J(c);
            n = new GU;
            o1 = Wv(d.H(), 92);
            for(k = m + i; k < a.c; k++){
                h = o1;
                o1 = Wv(d.H(), 92);
                vU(n, new tfb(h, o1, c));
            }
            for(l = m + i; l < a.c; l++){
                d.M();
                l > m + i && d.I();
            }
            for(g = new Tob(n); g.a < g.c.c.length;){
                f = Wv(Rob(g), 92);
                d.J(f);
            }
            if (i < b - 1) for(j = m + i; j < a.c; j++)d.M();
        }
    }
    function CW(a) {
        var b, c, d, e;
        if (a.d && Wv(a.e, 7).f.g == (CX(), BX)) return ypb(), ypb(), vpb;
        else if (!a.a) {
            a.a = new GU;
            for(d = new Tob(Wv(a.e, 7).b); d.a < d.c.c.length;){
                b = Wv(Rob(d), 12);
                vU(a.a, new tW(b));
            }
            if (a.d) {
                e = Wv(rJ(Wv(a.e, 7), (Rib(), Bib)), 9);
                if (e) for(c = Uh(iX(e)); Cm(c);){
                    b = Wv(Dm(c), 12);
                    vU(a.a, new tW(b));
                }
            }
        }
        return a.a;
    }
    function EW(a) {
        var b, c, d, e;
        if (a.d && Wv(a.e, 7).f.g == (CX(), BX)) return ypb(), ypb(), vpb;
        else if (!a.c) {
            a.c = new GU;
            for(d = new Tob(Wv(a.e, 7).e); d.a < d.c.c.length;){
                b = Wv(Rob(d), 12);
                vU(a.c, new tW(b));
            }
            if (a.d) {
                e = Wv(rJ(Wv(a.e, 7), (Rib(), Bib)), 9);
                if (e) for(c = Uh(mX(e)); Cm(c);){
                    b = Wv(Dm(c), 12);
                    vU(a.c, new tW(b));
                }
            }
        }
        return a.c;
    }
    function N1(a, b) {
        var c, d, e, f, g, h, i, j;
        h = Wv(rJ(a, (Rib(), uib)), 7);
        i = MI(Bv(tv(qz, 1), Fzb, 10, 0, [
            h.f.i,
            h.i,
            h.a
        ])).a;
        j = a.f.i.b;
        c = Wv(FU(a.b, xv(dB, gAb, 12, a.b.c.length, 0, 1)), 47);
        for(e = 0, f = c.length; e < f; ++e){
            d = c[e];
            eW(d, h);
            SI(d.a, new HI(i, j));
            if (b) {
                g = Wv(rJ(d, (eM(), CL)), 44);
                if (!g) {
                    g = new jJ;
                    sJ(d, CL, g);
                }
                QI(g, new HI(i, j));
            }
        }
    }
    function O1(a, b) {
        var c, d, e, f, g, h, i, j;
        e = Wv(rJ(a, (Rib(), uib)), 7);
        i = MI(Bv(tv(qz, 1), Fzb, 10, 0, [
            e.f.i,
            e.i,
            e.a
        ])).a;
        j = a.f.i.b;
        c = Wv(FU(a.e, xv(dB, gAb, 12, a.e.c.length, 0, 1)), 47);
        for(g = 0, h = c.length; g < h; ++g){
            f = c[g];
            dW(f, e);
            RI(f.a, new HI(i, j));
            if (b) {
                d = Wv(rJ(f, (eM(), CL)), 44);
                if (!d) {
                    d = new jJ;
                    sJ(f, CL, d);
                }
                QI(d, new HI(i, j));
            }
        }
    }
    function X2(a) {
        var b, c, d, e, f, g, h, i, j;
        g = rAb;
        i = rAb;
        h = null;
        for(c = new Sub(new Lub(a.e)); c.b != c.c.a.b;){
            b = Rub(c);
            if (gw(b.d) === gw((Ieb(), keb)) || gw(b.d) === gw(leb)) {
                d = Wv(b.e, 116).a;
                j = Wv(b.e, 116).b;
                e = g - d > uAb;
                f = d - g < uAb && i - j > uAb;
                if (e || f) {
                    i = Wv(b.e, 116).b;
                    g = Wv(b.e, 116).a;
                    h = Wv(b.d, 60);
                    if (i == 0 && g == 0) return h;
                }
            }
        }
        return h;
    }
    function P4(a, b) {
        var c, d, e, f, g;
        a.d = b;
        Ymb(a.b);
        a.c = false;
        h: for(d = new Tob(a.d.c); d.a < d.c.c.length;){
            c = Wv(Rob(d), 16);
            for(f = new Tob(c.a); f.a < f.c.c.length;){
                e = Wv(Rob(f), 9);
                if (!sl(gX(e))) {
                    a.c = true;
                    break h;
                }
            }
        }
        g = Vsb((sK(), qK), Bv(tv(Bz, 1), uyb, 59, 0, [
            oK,
            pK
        ]));
        if (!a.c) {
            Wsb(g, rK);
            Wsb(g, nK);
        }
        a.a = new NR(g);
        O4(a);
        return a.a;
    }
    function $2() {
        var a, b, c, d, e;
        this.e = (mp(), new wub);
        this.b = (c = Wv(Hkb(_E), 11), new atb(c, Wv(exb(c, c.length), 11), 0));
        this.c = (d = Wv(Hkb(_E), 11), new atb(d, Wv(exb(d, d.length), 11), 0));
        this.a = (e = Wv(Hkb(_E), 11), new atb(e, Wv(exb(e, e.length), 11), 0));
        for(b = (Ieb(), Ieb(), feb).mb(); b.G();){
            a = Wv(b.H(), 60);
            tub(this.e, a, new _2);
        }
    }
    function gdb(a, b, c) {
        var d, e, f, g, h, i;
        if (Jlb(a.k - a.a) < dAb || Jlb(b.k - b.a) < dAb) return;
        d = edb(a.n, b.j, c);
        e = edb(b.n, a.j, c);
        f = fdb(a.n, b.k, b.a) + fdb(b.j, a.k, a.a);
        g = fdb(b.n, a.k, a.a) + fdb(a.j, b.k, b.a);
        h = 16 * d + f;
        i = 16 * e + g;
        if (h < i) new kdb(a, b, i - h);
        else if (h > i) new kdb(b, a, h - i);
        else if (h > 0 && i > 0) {
            new kdb(a, b, 0);
            new kdb(b, a, 0);
        }
    }
    function c3(a, b) {
        var c, d, e, f, g, h, i, j, k;
        j = new GU;
        k = null;
        for(d = Wv(qsb(a3, a), 20).mb(); d.G();){
            c = Wv(d.H(), 75);
            for(i = (f = new Snb(c.c.a).a.bb().mb(), new Ynb(f)); i.a.G();){
                g = (e = Wv(i.a.H(), 21), Wv(e.yb(), 7));
                Anb(b, g);
                J2(g, a.b);
            }
            xU(j, c.b);
            k = a.a;
        }
        Dpb(j);
        K2(j, k);
        for(h = new Tob(j); h.a < h.c.c.length;){
            g = Wv(Rob(h), 7);
            Anb(b, g);
        }
    }
    function GP() {
        var b = {
            'layout': function(a) {
                Rxb(IP(a));
            }
        };
        if (typeof $63de8e1e54a3eb03$var$klayregister === Zxb) $63de8e1e54a3eb03$var$klayregister(b);
        else {
            typeof document !== Czb && ($wnd.$klay = b);
            "object" === Sxb && module.exports && (module.exports = b);
            typeof document === Czb && typeof self !== Czb && self.addEventListener('message', function(a) {
                b.layout(a.data);
            }, false);
        }
    }
    function _cb(a, b, c, d, e) {
        var f, g, h;
        h = e ? d.b : d.a;
        if (h > c.k && h < c.a || c.j.b != 0 && c.n.b != 0 && (Jlb(h - Ixb(Yv(UI(c.j)))) < dAb && Jlb(h - Ixb(Yv(UI(c.n)))) < dAb || Jlb(h - Ixb(Yv(VI(c.j)))) < dAb && Jlb(h - Ixb(Yv(VI(c.n)))) < dAb)) {
            if (!ttb(a.b, d)) {
                g = Wv(rJ(b, (eM(), CL)), 44);
                if (!g) {
                    g = new jJ;
                    sJ(b, CL, g);
                }
                f = new II(d);
                TI(g, f, g.c.b, g.c);
                stb(a.b, f);
            }
        }
    }
    function lU(a, b, c) {
        var d, e, f, g, h, i, j, k, l;
        d = c.c;
        e = c.d;
        h = MX(b.c);
        i = MX(b.d);
        if (d == b.c) {
            h = mU(a, h, e);
            i = nU(b.d);
        } else {
            h = nU(b.c);
            i = mU(a, i, e);
        }
        j = new kJ(b.a);
        TI(j, h, j.a, j.a.a);
        TI(j, i, j.c.b, j.c);
        g = b.c == d;
        l = new pV;
        for(f = 0; f < j.b - 1; ++f){
            k = new RJ(Wv(tn(j, f), 10), Wv(tn(j, f + 1), 10));
            g && f == 0 || !g && f == j.b - 2 ? l.b = k : vU(l.a, k);
        }
        return l;
    }
    function GW(a, b) {
        var c, d, e, f;
        f = a.g.e - b.g.e;
        if (f != 0) return f;
        c = Wv(rJ(a, (eM(), UL)), 24);
        d = Wv(rJ(b, UL), 24);
        if (!!c && !!d) {
            e = c.a - d.a;
            if (e != 0) return e;
        }
        switch(a.g.e){
            case 1:
                return glb(a.i.a, b.i.a);
            case 2:
                return glb(a.i.b, b.i.b);
            case 3:
                return glb(b.i.a, a.i.a);
            case 4:
                return glb(b.i.b, a.i.b);
            default:
                throw new ulb(iAb);
        }
    }
    function KO(a, b) {
        var c, d, e, f, g;
        g = new FI;
        for(f = new Tob(AW(a)); f.a < f.c.c.length;){
            e = Wv(Rob(f), 161);
            switch(Wv(e.e, 7).g.e){
                case 4:
                case 2:
                    g.b = Nlb(g.b, e.e.i.b + e.e.j.b + (b ? (d = Wv(e.e, 7).d, new EP(d.d, d.b, d.a, d.c)).a : 0));
                    break;
                case 1:
                case 3:
                    g.a = Nlb(g.a, e.e.i.a + e.e.j.a + (b ? (c = Wv(e.e, 7).d, new EP(c.d, c.b, c.a, c.c)).c : 0));
            }
        }
        return g;
    }
    function d3(a, b) {
        var c, d, e, f, g, h, i;
        e = new GU;
        i = new GU;
        c = Wv(qsb(a3, a), 20).mb();
        while(c.G()){
            d = Wv(c.H(), 75);
            wU(e, d.b);
            wU(e, $db(d));
            if (c.G()) {
                d = Wv(c.H(), 75);
                xU(i, $db(d));
                xU(i, d.b);
            }
        }
        K2(e, a.b);
        K2(i, a.a);
        for(h = new Tob(e); h.a < h.c.c.length;){
            f = Wv(Rob(h), 7);
            Anb(b, f);
        }
        for(g = new Tob(i); g.a < g.c.c.length;){
            f = Wv(Rob(g), 7);
            Anb(b, f);
        }
    }
    function ohb() {
        ohb = iI;
        fhb = new phb('COMMENTS', 0);
        hhb = new phb('EXTERNAL_PORTS', 1);
        ihb = new phb('HYPEREDGES', 2);
        jhb = new phb('HYPERNODES', 3);
        khb = new phb('NON_FREE_PORTS', 4);
        lhb = new phb('NORTH_SOUTH_PORTS', 5);
        nhb = new phb('SELF_LOOPS', 6);
        ehb = new phb('CENTER_LABELS', 7);
        ghb = new phb('END_LABELS', 8);
        mhb = new phb('PARTITIONS', 9);
    }
    function Jxb(a, b) {
        var c, d, e, f;
        a = (bmb(), a == null ? Wxb : a);
        c = (a.length, b.length, new Amb);
        f = 0;
        d = 0;
        while(d < b.length){
            e = a.indexOf('%s', f);
            if (e == -1) break;
            ymb(c, a.substr(f, e - f));
            xmb(c, b[d++]);
            f = e + 2;
        }
        ymb(c, imb(a, f, a.length - f));
        if (d < b.length) {
            c.a += ' [';
            xmb(c, b[d++]);
            while(d < b.length){
                c.a += ', ';
                xmb(c, b[d++]);
            }
            c.a += ']';
        }
        return c.a;
    }
    function pX(a, b, c) {
        var d, e;
        e = null;
        switch(b.e){
            case 1:
                e = (LX(), GX);
                break;
            case 2:
                e = (LX(), IX);
        }
        d = null;
        switch(c.e){
            case 1:
                d = (LX(), HX);
                break;
            case 2:
                d = (LX(), FX);
                break;
            case 3:
                d = (LX(), JX);
                break;
            case 4:
                d = (LX(), KX);
        }
        return !!e && !!d ? pl(a.f, (hc(), new ic(new opb(Bv(tv(tw, 1), syb, 68, 0, [
            Wv(_b(e), 68),
            Wv(_b(d), 68)
        ]))))) : (ypb(), ypb(), vpb);
    }
    function vY(a, b, c) {
        var d, e, f, g, h, i, j;
        i = Eo(mX(b));
        for(e = WI(i, 0); e.b != e.d.c;){
            d = Wv(_ub(e), 12);
            j = d.d.f;
            if (!(Ckb(Ixb(Xv(rJ(j, (Rib(), Vhb))))) && rJ(j, uib) != null) && j.g == (CX(), wX) && !Ckb(Ixb(Xv(rJ(d, Iib)))) && d.d.g == (sN(), rN)) {
                f = rY(j.d) - rY(b.d);
                if (f > 1) {
                    c ? g = rY(b.d) + 1 : g = rY(j.d) - 1;
                    h = Wv(yU(a.a.c, g), 16);
                    rX(j, h);
                }
                vY(a, j, c);
            }
        }
        return b;
    }
    function Hcb(a, b) {
        var c, d, e, f;
        b.d ? e = a.a.c == (Gbb(), Fbb) ? iX(b.b) : mX(b.b) : e = a.a.c == (Gbb(), Ebb) ? iX(b.b) : mX(b.b);
        f = false;
        for(d = (Il(), new Im(Dl(ul(e.a, new yl)))); Cm(d);){
            c = Wv(Dm(d), 12);
            if (a.c.a[c.c.f.d.k] === a.c.a[c.d.f.d.k]) continue;
            f = true;
            if (ttb(a.b, a.a.f[zcb(c, b.b).k])) {
                b.c = true;
                b.a = c;
                return b;
            }
        }
        b.c = f;
        b.a = null;
        return b;
    }
    function K4(a, b, c) {
        var d, e, f, g;
        d = Wv(rJ(a.d, (eM(), pL)), 15).a;
        for(f = new Tob(a.a.b); f.a < f.c.c.length;){
            e = Wv(Rob(f), 25);
            if (aw(e, 93)) {
                g = Wv(e, 93).b;
                if (g.g == (CX(), xX)) switch(Wv(rJ(g, (Rib(), hib)), 32).e){
                    case 4:
                        g.i.a = b.a - d;
                        break;
                    case 2:
                        g.i.a = c.a + d - (g.j.a + g.e.c);
                        break;
                    case 1:
                        g.i.b = b.b - d;
                        break;
                    case 3:
                        g.i.b = c.b + d - (g.j.b + g.e.a);
                }
            }
        }
    }
    function Ztb() {
        if (!Object.create || !Object.getOwnPropertyNames) return false;
        var a = '__proto__';
        var b = Object.create(null);
        if (b[a] !== undefined) return false;
        var c = Object.getOwnPropertyNames(b);
        if (c.length != 0) return false;
        b[a] = 42;
        if (b[a] !== 42) return false;
        if (Object.getOwnPropertyNames(b).length == 0) return false;
        return true;
    }
    function eS(a) {
        var b, c, d, e, f, g, h, i, j;
        for(g = new Tob(a.a.a); g.a < g.c.c.length;){
            e = Wv(Rob(g), 78);
            e.f = 0;
            e.e.a.Q();
        }
        for(f = new Tob(a.a.a); f.a < f.c.c.length;){
            e = Wv(Rob(f), 78);
            for(c = (j = new Snb(e.a.a).a.bb().mb(), new Ynb(j)); c.a.G();){
                b = (d = Wv(c.a.H(), 21), Wv(d.yb(), 25));
                for(i = b.i.mb(); i.G();){
                    h = Wv(i.H(), 25);
                    if (h.f != e) {
                        stb(e.e, h);
                        ++h.f.f;
                    }
                }
            }
        }
    }
    function bcb(a, b, c, d) {
        var e, f, g, h;
        if (b.g == (CX(), wX)) for(f = Uh(iX(b)); Cm(f);){
            e = Wv(Dm(f), 12);
            g = e.c.f;
            if ((g.g == wX || Ckb(Ixb(Xv(rJ(g, (Rib(), Vhb)))))) && a.d.a[e.c.f.d.k] == d && a.d.a[b.d.k] == c) return true;
        }
        if (b.g == zX) for(f = Uh(iX(b)); Cm(f);){
            e = Wv(Dm(f), 12);
            h = e.c.f.g;
            if (h == zX && a.d.a[e.c.f.d.k] == d && a.d.a[b.d.k] == c) return true;
        }
        return false;
    }
    function cfb(a) {
        var b, c, d, e, f, g;
        e = a.g.tb();
        d = a.b.tb();
        if (a.e) for(c = 0; c < a.c; c++)e.H();
        else for(c = 0; c < a.c - 1; c++){
            e.H();
            e.I();
        }
        b = Ixb(Yv(e.H()));
        while(a.i - b > RAb){
            f = b;
            g = 0;
            while((b - f <= 0 ? 0 - (b - f) : b - f) < RAb){
                ++g;
                b = Ixb(Yv(e.H()));
                d.H();
            }
            if (g < a.c) {
                e.M();
                afb(a, a.c - g, f, d, e);
                e.H();
            }
            d.M();
        }
        if (!a.e) for(c = 0; c < a.c - 1; c++){
            e.H();
            e.I();
        }
        a.e = true;
        a.d = true;
    }
    function O2(a) {
        var b, c, d, e;
        switch(V2(a.a).c){
            case 4:
                return Ieb(), oeb;
            case 3:
                return Wv(S2(a.a).mb().H(), 60);
            case 2:
                d = V2(a.a);
                c = new jtb(d);
                b = Wv(itb(c), 60);
                e = Wv(itb(c), 60);
                return Meb(b) == e ? Zsb(d, (Ieb(), oeb)) ? ieb : oeb : Leb(Leb(b)) == e ? Leb(b) : Neb(b);
            case 1:
                d = V2(a.a);
                return Meb(Wv(itb(new jtb(d)), 60));
            case 0:
                return Ieb(), peb;
            default:
                return null;
        }
    }
    function Q3(a, b) {
        var c;
        oR.call(this);
        this.a = Wv(rJ(b, (Rib(), Jib)), 15).a;
        this.c = this.a * Wv(rJ(b, (Mjb(), Ejb)), 15).a;
        this.b = a;
        this.j = new VN(a.i.a - a.e.b, a.i.b - a.e.d, a.j.a + a.e.b + a.e.c, a.j.b + a.e.d + a.e.a);
        BI(this.g);
        c = tl(iX(a)) - tl(mX(a));
        c < 0 ? vS(this.n, true, (sK(), oK)) : c > 0 && vS(this.n, true, (sK(), pK));
        a.g == (CX(), xX) && wS(this.n, false, false, false, false);
    }
    function UT(a, b, c) {
        var d, e, f, g, h, i, j, k, l, m;
        f = new HI(b, c);
        for(k = new Tob(a.b); k.a < k.c.c.length;){
            j = Wv(Rob(k), 9);
            vI(j.i, f);
            for(m = new Tob(j.f); m.a < m.c.c.length;){
                l = Wv(Rob(m), 7);
                for(e = new Tob(l.e); e.a < e.c.c.length;){
                    d = Wv(Rob(e), 12);
                    hJ(d.a, f);
                    g = Wv(rJ(d, (eM(), CL)), 44);
                    !!g && hJ(g, f);
                    for(i = new Tob(d.b); i.a < i.c.c.length;){
                        h = Wv(Rob(i), 33);
                        vI(h.i, f);
                    }
                }
            }
        }
    }
    function TW(a, b, c) {
        var d, e, f, g, h, i, j, k, l, m;
        f = new HI(b, c);
        for(k = new Tob(a.b); k.a < k.c.c.length;){
            j = Wv(Rob(k), 9);
            vI(j.i, f);
            for(m = new Tob(j.f); m.a < m.c.c.length;){
                l = Wv(Rob(m), 7);
                for(e = new Tob(l.e); e.a < e.c.c.length;){
                    d = Wv(Rob(e), 12);
                    hJ(d.a, f);
                    g = Wv(rJ(d, (eM(), CL)), 44);
                    !!g && hJ(g, f);
                    for(i = new Tob(d.b); i.a < i.c.c.length;){
                        h = Wv(Rob(i), 33);
                        vI(h.i, f);
                    }
                }
            }
        }
    }
    function X0(a, b) {
        var c, d, e, f, g;
        for(g = new Tob(a.f); g.a < g.c.c.length;){
            f = Wv(Rob(g), 7);
            if (b) {
                if (f.b.c.length != 0) throw new $J((e = lX(a), nAb + (e == null ? Dlb(a.k) : e) + oAb + pAb + qAb));
            } else for(d = new Tob(f.b); d.a < d.c.c.length;){
                c = Wv(Rob(d), 12);
                if (gw(rJ(c.c.f, (Mjb(), vjb))) !== gw((Xib(), Tib))) throw new $J((e = lX(a), nAb + (e == null ? Dlb(a.k) : e) + oAb + pAb + qAb));
            }
        }
    }
    function y6(a, b, c) {
        var d, e, f, g, h, i, j;
        d = 0;
        j = nX(b, c);
        for(i = j.mb(); i.G();){
            h = Wv(i.H(), 7);
            if (Wv(rJ(h, (Rib(), Bib)), 9)) {
                g = Wv(rJ(h, Bib), 9);
                nX(g, (sN(), ZM)).mb().G() && (d += (f = a.k ? 1 : NX(Wv(yU(g.f, 0), 7)), f * Slb(w6(a, b, c).a - 1 - Wv(Smb(a.i, h), 24).a, B6(a, b, g))));
                nX(g, rN).mb().G() && (d += (e = a.k ? 1 : NX(Wv(yU(g.f, 0), 7)), e * Slb(Wv(Smb(a.i, h), 24).a, B6(a, b, g))));
            }
        }
        return d;
    }
    function J7(a, b) {
        var c, d, e, f, g, h, i;
        e = xv(mw, Yyb, 26, a.e.a.c.length, 12, 1);
        for(g = new Tob(a.e.a); g.a < g.c.c.length;){
            f = Wv(Rob(g), 61);
            e[f.b] += f.c.c.length;
        }
        h = Eo(b);
        while(h.b != 0){
            f = Wv(h.b == 0 ? null : (Bxb(h.b != 0), $I(h, h.a.a)), 61);
            for(d = new Tob(f.g); d.a < d.c.c.length;){
                c = Wv(Rob(d), 89);
                i = c.d;
                i.e = Plb(i.e, f.e + c.a);
                --e[i.b];
                e[i.b] == 0 && TI(h, i, h.c.b, h.c);
            }
        }
    }
    function nP(a, b, c, d, e, f, g) {
        a.d = d.e.i.a;
        a.e = d.e.i.b;
        if (e) {
            a.d += e.e.i.a;
            a.e += e.e.i.b;
        }
        a.c = b.e.j.a;
        a.b = b.e.j.b;
        if (!e) c ? a.d -= g + b.e.j.a : a.d += d.e.j.a + g;
        else switch(Wv(e.e, 7).g.e){
            case 0:
            case 2:
                a.d += e.e.j.a + g + f.a + g;
                break;
            case 4:
                a.d -= g + f.a + g + b.e.j.a;
                break;
            case 1:
                a.d += e.e.j.a + g;
                a.e -= g + f.b + g + b.e.j.b;
                break;
            case 3:
                a.d += e.e.j.a + g;
                a.e += e.e.j.b + g + f.b + g;
        }
    }
    function V9(a, b) {
        var c, d, e, f, g, h, i, j, k;
        e = new GU;
        for(i = new Tob(b); i.a < i.c.c.length;){
            f = Wv(Rob(i), 9);
            vU(e, a.b[f.d.k][f.k]);
        }
        S9(a, e);
        while(k = T9(e))U9(a, Wv(k.a, 102), Wv(k.b, 102), e);
        b.c = xv(UF, syb, 1, 0, 4, 1);
        for(d = new Tob(e); d.a < d.c.c.length;){
            c = Wv(Rob(d), 102);
            for(g = c.d, h = 0, j = g.length; h < j; ++h){
                f = g[h];
                b.c[b.c.length] = f;
                a.a[f.d.k][f.k].a = W9(c.g, c.d[0]).a;
            }
        }
    }
    function lS(a) {
        var b, c, d, e, f, g, h;
        h = (mp(), new ntb);
        for(d = new Tob(a.a.b); d.a < d.c.c.length;){
            b = Wv(Rob(d), 25);
            Umb(h, b, new GU);
        }
        for(e = new Tob(a.a.b); e.a < e.c.c.length;){
            b = Wv(Rob(e), 25);
            b.r = Vzb;
            for(g = b.i.mb(); g.G();){
                f = Wv(g.H(), 25);
                Wv(re(Ktb(h.d, f)), 20).ib(b);
            }
        }
        for(c = new Tob(a.a.b); c.a < c.c.c.length;){
            b = Wv(Rob(c), 25);
            b.i.Q();
            b.i = Wv(re(Ktb(h.d, b)), 20);
        }
        eS(a);
    }
    function kU(a) {
        var b, c, d, e, f;
        e = Wv(yU(a.b, 0), 9);
        b = new uX(a);
        vU(a.b, b);
        b.j.a = Nlb(1, e.j.a);
        b.j.b = Nlb(1, e.j.b);
        b.i.a = e.i.a;
        b.i.b = e.i.b;
        switch(Wv(rJ(e, (Rib(), hib)), 32).e){
            case 4:
                b.i.a += 2;
                break;
            case 1:
                b.i.b += 2;
                break;
            case 2:
                b.i.a -= 2;
                break;
            case 3:
                b.i.b -= 2;
        }
        d = new RX;
        PX(d, b);
        c = new hW;
        f = Wv(yU(e.f, 0), 7);
        dW(c, f);
        eW(c, d);
        vI(BI(d.i), f.i);
        vI(BI(d.a), f.a);
        return b;
    }
    function T8(a) {
        var b, c, d, e, f, g, h, i, j;
        j = (mp(), new ntb);
        b = 0;
        c = new l7;
        for(h = a.mb(); h.G();){
            f = Wv(h.H(), 9);
            i = x7(z7(y7(new A7, b++), f), c);
            Ltb(j.d, f, i);
        }
        for(g = a.mb(); g.G();){
            f = Wv(g.H(), 9);
            for(e = Uh(mX(f)); Cm(e);){
                d = Wv(Dm(e), 12);
                if (bW(d)) continue;
                f7(i7(h7(g7(j7(new k7, Plb(1, Wv(rJ(d, (Rib(), Eib)), 24).a)), 1), Wv(Smb(j, d.c.f), 61)), Wv(Smb(j, d.d.f), 61)));
            }
        }
        return c;
    }
    function E2(a) {
        var b, c;
        if (a.V()) return;
        c = Wv(a.sb(0), 75).f;
        new g3(a);
        b = new Fnb(c.f, 0);
        e3((Ieb(), neb), b);
        f3(Eeb, b);
        D2((sN(), $M), b);
        d3(meb, b);
        f3(qeb, b);
        c3(jeb, b);
        e3(keb, b);
        D2(ZM, b);
        d3(ieb, b);
        e3(leb, b);
        c3(peb, b);
        e3(qeb, b);
        D2(pN, b);
        d3(oeb, b);
        e3(Eeb, b);
        c3(Heb, b);
        f3(leb, b);
        while(b.b < b.d.Y()){
            Bxb(b.b < b.d.Y());
            b.d.sb(b.c = b.b++);
        }
        d3(Geb, b);
        f3(keb, b);
        f3(neb, b);
    }
    function F2(a) {
        var b, c;
        if (a.V()) return;
        c = Wv(a.sb(0), 75).f;
        new g3(a);
        b = new Fnb(c.f, 0);
        e3((Ieb(), neb), b);
        f3(Eeb, b);
        D2((sN(), $M), b);
        c3(meb, b);
        f3(qeb, b);
        c3(jeb, b);
        e3(keb, b);
        D2(ZM, b);
        c3(ieb, b);
        e3(leb, b);
        c3(peb, b);
        e3(qeb, b);
        D2(pN, b);
        c3(oeb, b);
        e3(Eeb, b);
        c3(Heb, b);
        f3(leb, b);
        while(b.b < b.d.Y()){
            Bxb(b.b < b.d.Y());
            b.d.sb(b.c = b.b++);
        }
        c3(Geb, b);
        f3(keb, b);
        f3(neb, b);
    }
    function N7(a) {
        var b, c, d, e, f, g, h, i, j;
        e = eyb;
        g = $xb;
        for(j = new Tob(a.e.a); j.a < j.c.c.length;){
            h = Wv(Rob(j), 61);
            g = Slb(g, h.e);
            e = Plb(e, h.e);
        }
        f = 0;
        d = xv(mw, Yyb, 26, e - g + 1, 12, 1);
        for(i = new Tob(a.e.a); i.a < i.c.c.length;){
            h = Wv(Rob(i), 61);
            h.e -= g;
            ++d[h.e];
        }
        if (a.k) for(c = new Tob(a.k.c); c.a < c.c.c.length;){
            b = Wv(Rob(c), 16);
            d[f++] += b.a.c.length;
            if (d.length == f) break;
        }
        return d;
    }
    function L4(a) {
        var b, c, d, e;
        M4(a);
        J4(a);
        e = new HI(Uzb, Uzb);
        b = new HI(Vzb, Vzb);
        for(d = new Tob(a.a.b); d.a < d.c.c.length;){
            c = Wv(Rob(d), 25);
            e.a = Qlb(e.a, c.j.d);
            e.b = Qlb(e.b, c.j.e);
            b.a = Nlb(b.a, c.j.d + c.j.c);
            b.b = Nlb(b.b, c.j.e + c.j.b);
        }
        vI(BI(a.d.d), zI(new HI(e.a, e.b)));
        vI(BI(a.d.e), EI(new HI(b.a, b.b), e));
        K4(a, e, b);
        a.a.a.c = xv(UF, syb, 1, 0, 4, 1);
        a.a.b.c = xv(UF, syb, 1, 0, 4, 1);
    }
    function j1(a, b) {
        var c, d, e, f, g, h, i, j, k, l;
        g = a.e;
        k = Wv(rJ(a, (Rib(), Qib)), 20);
        l = 0;
        if (k) {
            i = 0;
            for(f = k.mb(); f.G();){
                e = Wv(f.H(), 9);
                i = Nlb(i, e.j.b);
                l += e.j.a;
            }
            l += b / 2 * (k.Y() - 1);
            g.d += i + b;
        }
        c = Wv(rJ(a, Yhb), 20);
        d = 0;
        if (c) {
            i = 0;
            for(f = c.mb(); f.G();){
                e = Wv(f.H(), 9);
                i = Nlb(i, e.j.b);
                d += e.j.a;
            }
            d += b / 2 * (c.Y() - 1);
            g.a += i + b;
        }
        h = l > d ? l : d;
        if (h > a.j.a) {
            j = (h - a.j.a) / 2;
            g.b = Nlb(g.b, j);
            g.c = Nlb(g.c, j);
        }
    }
    function ST(a, b, c, d) {
        var e, f, g, h, i, j, k, l, m, n;
        g = uI(b.d, c, d);
        for(l = new Tob(b.b); l.a < l.c.c.length;){
            k = Wv(Rob(l), 9);
            vI(k.i, g);
            for(n = new Tob(k.f); n.a < n.c.c.length;){
                m = Wv(Rob(n), 7);
                for(f = new Tob(m.e); f.a < f.c.c.length;){
                    e = Wv(Rob(f), 12);
                    hJ(e.a, g);
                    h = Wv(rJ(e, (eM(), CL)), 44);
                    !!h && hJ(h, g);
                    for(j = new Tob(e.b); j.a < j.c.c.length;){
                        i = Wv(Rob(j), 33);
                        vI(i.i, g);
                    }
                }
            }
            vU(a.b, k);
            k.a = a;
        }
    }
    function Q8(a, b) {
        var c, d, e, f, g;
        a.c == null || a.c.length < b.c.length ? a.c = xv(KH, xAb, 26, b.c.length, 13, 1) : dpb(a.c);
        a.a = new GU;
        d = 0;
        for(g = new Tob(b); g.a < g.c.c.length;){
            e = Wv(Rob(g), 9);
            e.k = d++;
        }
        c = new aJ;
        for(f = new Tob(b); f.a < f.c.c.length;){
            e = Wv(Rob(f), 9);
            if (!a.c[e.k]) {
                R8(a, e);
                c.b == 0 || (Bxb(c.b != 0), Wv(c.a.a.c, 20)).Y() < a.a.c.length ? RI(c, a.a) : SI(c, a.a);
                a.a = new GU;
            }
        }
        return c;
    }
    function xfb(a, b, c) {
        var d, e, f, g, h, i, j, k, l;
        d = sgb(a.g);
        j = vI(xI(a.i), a.a);
        k = vI(xI(b.i), b.a);
        e = vI(new II(j), CI(new GI(d), c));
        l = vI(new II(k), CI(new GI(d), c));
        g = CI(EI(new II(e), l), 0.5);
        i = vI(vI(new II(l), g), CI(new GI(d), Tlb(g.a * g.a + g.b * g.b)));
        h = new ufb(Bv(tv(qz, 1), Fzb, 10, 0, [
            j,
            e,
            i,
            l,
            k
        ]));
        f = $eb(h, 0.5, false);
        h.a = f;
        bfb(h, new Ffb(Bv(tv(qz, 1), Fzb, 10, 0, [
            f,
            j,
            k
        ])));
        return h;
    }
    function F7(a, b) {
        var c, d, e, f, g;
        nI(b, 'Network simplex', 1);
        if (a.e.a.c.length < 1) {
            pI(b);
            return;
        }
        for(f = new Tob(a.e.a); f.a < f.c.c.length;){
            e = Wv(Rob(f), 61);
            e.e = 0;
        }
        g = a.e.a.c.length >= 40;
        g && Q7(a);
        H7(a);
        G7(a);
        c = K7(a);
        d = 0;
        while(!!c && d < a.f){
            E7(a, c, D7(a, c));
            c = K7(a);
            ++d;
        }
        g && P7(a);
        a.a ? B7(a, N7(a)) : N7(a);
        a.b = null;
        a.d = null;
        a.p = null;
        a.c = null;
        a.g = null;
        a.i = null;
        a.n = null;
        a.o = null;
        pI(b);
    }
    function uQ(a) {
        var b, c, d, e, f, g, h, i, j, k;
        j = new vtb;
        e = (mp(), new ntb);
        for(h = 0, i = a.length; h < i; ++h){
            g = a[h];
            b = g.mc();
            j.a.db(b, j);
            b == null ? Ltb(e.d, null, g) : dub(e.e, b, g);
            k = gmb(b, (bmb(), b.lastIndexOf('.')) + 1, b.length);
            if (!ttb(sQ, k)) {
                j.a.db(k, j);
                k == null ? Ltb(e.d, null, g) : dub(e.e, k, g);
                stb(sQ, k);
            }
        }
        d = (hi(), Yj((f = new Snb(j.a).a.bb().mb(), new Ynb(f))));
        c = tj(e);
        return new RJ(d, c);
    }
    function E7(a, b, c) {
        var d, e, f;
        if (!b.e) throw new slb('Given leave edge is no tree edge.');
        if (c.e) throw new slb('Given enter edge is a tree edge already.');
        b.e = false;
        utb(a.p, b);
        c.e = true;
        stb(a.p, c);
        d = c.d.e - c.c.e - c.a;
        I7(a, c.d, b) || (d = -d);
        for(f = new Tob(a.e.a); f.a < f.c.c.length;){
            e = Wv(Rob(f), 61);
            I7(a, e, b) || (e.e += d);
        }
        a.j = 1;
        dpb(a.c);
        O7(a, Wv(Rob(new Tob(a.e.a)), 61));
        C7(a);
    }
    function dU(a, b) {
        var c, d, e, f, g, h, i, j, k, l, m, n;
        if (a.V()) return new FI;
        j = 0;
        l = 0;
        for(e = a.mb(); e.G();){
            d = Wv(e.H(), 55);
            f = d.e;
            j = Nlb(j, f.a);
            l += f.a * f.b;
        }
        j = Nlb(j, Math.sqrt(l) * Wv(rJ(Wv(a.mb().H(), 55), (Rib(), Rhb)), 15).a);
        m = 0;
        n = 0;
        i = 0;
        c = b;
        for(h = a.mb(); h.G();){
            g = Wv(h.H(), 55);
            k = g.e;
            if (m + k.a > j) {
                m = 0;
                n += i + b;
                i = 0;
            }
            UT(g, m, n);
            c = Nlb(c, m + k.a);
            i = Nlb(i, k.b);
            m += k.a + b;
        }
        return new HI(c + b, n + i + b);
    }
    function Nm(a, b, c, d) {
        var e, f, g;
        g = new Sn(b, c);
        if (!a.a) {
            a.a = a.e = g;
            Umb(a.b, b, new Rn(g));
            ++a.c;
        } else if (!d) {
            a.e.b = g;
            g.d = a.e;
            a.e = g;
            e = Wv(Smb(a.b, b), 126);
            if (!e) {
                Umb(a.b, b, new Rn(g));
                ++a.c;
            } else {
                ++e.a;
                f = e.c;
                f.c = g;
                g.e = f;
                e.c = g;
            }
        } else {
            e = Wv(Smb(a.b, b), 126);
            ++e.a;
            g.d = d.d;
            g.e = d.e;
            g.b = d;
            g.c = d;
            !d.e ? Wv(Smb(a.b, b), 126).b = g : d.e.c = g;
            !d.d ? a.a = g : d.d.b = g;
            d.d = g;
            d.e = g;
        }
        ++a.d;
        return g;
    }
    function hS(a) {
        var b, c, d, e, f, g, h, i;
        if (a.e) throw new ulb((Gkb(nA), 'The ' + nA.j + Yzb));
        a.d == (sK(), qK) && gS(a, oK);
        for(c = new Tob(a.a.a); c.a < c.c.c.length;){
            b = Wv(Rob(c), 78);
            b.f = 0;
        }
        for(g = new Tob(a.a.b); g.a < g.c.c.length;){
            f = Wv(Rob(g), 25);
            f.r = Vzb;
            for(e = f.i.mb(); e.G();){
                d = Wv(e.H(), 25);
                ++d.f.f;
            }
        }
        a.b.Cc(a);
        for(i = new Tob(a.a.b); i.a < i.c.c.length;){
            h = Wv(Rob(i), 25);
            h.p = true;
        }
        return a;
    }
    function V1(a, b, c, d, e) {
        var f, g, h, i;
        f = new uX(a);
        sX(f, (CX(), BX));
        sJ(f, (eM(), TL), (KM(), FM));
        sJ(f, (Rib(), uib), b.c.f);
        g = new RX;
        sJ(g, uib, b.c);
        QX(g, e);
        PX(g, f);
        sJ(b.c, Bib, f);
        h = new uX(a);
        sX(h, BX);
        sJ(h, TL, FM);
        sJ(h, uib, b.d.f);
        i = new RX;
        sJ(i, uib, b.d);
        QX(i, e);
        PX(i, h);
        sJ(b.d, Bib, h);
        dW(b, g);
        eW(b, i);
        Fxb(0, c.c.length);
        fxb(c.c, 0, f);
        d.c[d.c.length] = h;
        sJ(f, aib, Elb(1));
        sJ(h, aib, Elb(1));
    }
    function j2(a, b) {
        var c, d, e, f, g;
        g = Wv(rJ(a.f, (eM(), TL)), 28);
        f = a.g.e - b.g.e;
        if (f != 0 || g == (KM(), HM)) return f;
        if (g == (KM(), EM)) {
            c = Wv(rJ(a, UL), 24);
            d = Wv(rJ(b, UL), 24);
            if (!!c && !!d) {
                e = c.a - d.a;
                if (e != 0) return e;
            }
        }
        switch(a.g.e){
            case 1:
                return glb(a.i.a, b.i.a);
            case 2:
                return glb(a.i.b, b.i.b);
            case 3:
                return glb(b.i.a, a.i.a);
            case 4:
                return glb(b.i.b, a.i.b);
            default:
                throw new ulb(iAb);
        }
    }
    function hfb(a) {
        var b, c, d, e, f, g, h, i, j, k, l;
        h = new GU;
        f = Ixb(Yv(a.g.sb(a.g.Y() - 1)));
        for(l = a.g.mb(); l.G();){
            k = Yv(l.H());
            uU(h, 0, f - (Dxb(k), k));
        }
        g = lJ(Xeb(a));
        j = new GU;
        e = new Tob(h);
        i = new GU;
        for(b = 0; b < a.c - 1; b++)vU(j, Yv(Rob(e)));
        for(d = WI(g, 0); d.b != d.d.c;){
            c = Wv(_ub(d), 10);
            vU(j, Yv(Rob(e)));
            vU(i, new sfb(c, j));
            Cxb(0, j.c.length);
            j.c.splice(0, 1);
        }
        return new ffb(a.e, a.f, a.d, a.c, h, i);
    }
    function zs(a, b, c, d, e) {
        var f, g, h, i, j;
        f = b.$b(c, a.b);
        if (f < 0) {
            h = a.e;
            if (!h) {
                e[0] = 0;
                return As(a, c, d);
            }
            g = h.d;
            a.e = zs(h, b, c, d, e);
            e[0] == 0 && ++a.a;
            a.j = PH(a.j, d);
            return a.e.d == g ? a : Gs(a);
        } else if (f > 0) {
            i = a.g;
            if (!i) {
                e[0] = 0;
                return Bs(a, c, d);
            }
            g = i.d;
            a.g = zs(i, b, c, d, e);
            e[0] == 0 && ++a.a;
            a.j = PH(a.j, d);
            return a.g.d == g ? a : Gs(a);
        }
        e[0] = a.c;
        j = PH(a.c, d);
        Xb(RH(j, $xb) <= 0);
        a.c += d;
        a.j = PH(a.j, d);
        return a;
    }
    function iJ(b, c) {
        var d, e, f, g, h, i;
        f = fmb(c, ',|;|\\(|\\)|\\[|\\]|\\{|\\}| |\t|\n');
        _I(b);
        try {
            e = 0;
            h = 0;
            g = 0;
            i = 0;
            while(e < f.length){
                if (f[e] != null && pmb(hmb(f[e])) > 0) {
                    h % 2 == 0 ? g = clb(f[e]) : i = clb(f[e]);
                    h > 0 && h % 2 != 0 && QI(b, new HI(g, i));
                    ++h;
                }
                ++e;
            }
        } catch (a) {
            a = OH(a);
            if (aw(a, 130)) {
                d = a;
                throw new slb('The given string does not match the expected format for vectors.' + d);
            } else throw NH(a);
        }
    }
    function _bb(a, b, c) {
        var d, e, f, g, h, i, j, k;
        e = true;
        for(g = new Tob(b.c); g.a < g.c.c.length;){
            f = Wv(Rob(g), 16);
            j = Vzb;
            for(i = new Tob(f.a); i.a < i.c.c.length;){
                h = Wv(Rob(i), 9);
                k = Ixb(c.n[h.k]) + Ixb(c.d[h.k]) - h.e.d;
                d = Ixb(c.n[h.k]) + Ixb(c.d[h.k]) + h.j.b + h.e.a;
                if (k > j && d > j) j = Ixb(c.n[h.k]) + Ixb(c.d[h.k]) + h.j.b + h.e.a;
                else {
                    e = false;
                    a.a && (Fmb(), Emb);
                    break;
                }
            }
            if (!e) break;
        }
        a.a && (Fmb(), Emb);
        return e;
    }
    function Jv(a) {
        var b, c, d, e, f, g, h, i;
        if (isNaN(a)) return Rv(), Qv;
        if (a < -9223372036854776000) return Rv(), Pv;
        if (a >= 9223372036854775807) return Rv(), Ov;
        e = false;
        if (a < 0) {
            e = true;
            a = -a;
        }
        d = 0;
        if (a >= dzb) {
            d = hw(a / dzb);
            a -= d * dzb;
        }
        c = 0;
        if (a >= czb) {
            c = hw(a / czb);
            a -= c * czb;
        }
        b = hw(a);
        f = Ev(b, c, d);
        e && (g = ~f.l + 1 & azb, h = ~f.m + (g == 0 ? 1 : 0) & azb, i = ~f.h + (g == 0 && h == 0 ? 1 : 0) & bzb, f.l = g, f.m = h, f.h = i, undefined);
        return f;
    }
    function JO(a) {
        var b, c, d, e, f, g, h;
        e = DW(a);
        if (Qob(new Tob(e))) {
            h = new VN(0, 0, a.e.j.a, a.e.j.b);
            for(c = new Tob(e); c.a < c.c.c.length;){
                b = Wv(Rob(c), 129);
                d = new VN(b.e.i.a, b.e.i.b, b.e.j.a, b.e.j.b);
                TN(h, d);
            }
            g = new FP((f = Wv(a.e, 7).d, new EP(f.d, f.b, f.a, f.c)));
            g.d = -h.e;
            g.a = h.e + h.b - a.e.j.b;
            g.b = -h.d;
            g.c = h.d + h.c - a.e.j.a;
            Wv(a.e, 7).d.b = g.b;
            Wv(a.e, 7).d.d = g.d;
            Wv(a.e, 7).d.c = g.c;
            Wv(a.e, 7).d.a = g.a;
        }
    }
    function Y0(a) {
        var b, c, d, e, f;
        for(f = new Tob(a.f); f.a < f.c.c.length;){
            e = Wv(Rob(f), 7);
            for(d = new Tob(e.e); d.a < d.c.c.length;){
                c = Wv(Rob(d), 12);
                if (gw(rJ(c.d.f, (Mjb(), vjb))) !== gw((Xib(), Vib))) throw new $J((b = lX(a), nAb + (b == null ? Dlb(a.k) : b) + "' has its layer constraint set to LAST or LAST_SEPARATE, but has " + 'at least one outgoing edge. Connections between nodes with these ' + qAb));
            }
        }
    }
    function Rfb(a, b, c, d) {
        var e, f, g, h, i, j;
        for(f = new Tob(a); f.a < f.c.c.length;){
            e = Wv(Rob(f), 12);
            g = e.c;
            if (b.a.R(g)) h = (fgb(), dgb);
            else if (c.a.R(g)) h = (fgb(), egb);
            else throw new slb('Source port must be in one of the port sets.');
            i = e.d;
            if (b.a.R(i)) j = (fgb(), dgb);
            else if (c.a.R(i)) j = (fgb(), egb);
            else throw new slb('Target port must be in one of the port sets.');
            vU(d, new lgb(e, h, j));
        }
    }
    function bQ(a, b) {
        var c, d, e, f, g, h;
        if ('edges' in b.a) {
            h = Pu(b, 'edges');
            if (!h.hc()) throw new GQ("The 'edges' property of a node has to be an array.", h, b);
            f = h.hc();
            for(g = 0; g < f.a.length; ++g){
                e = gu(f, g);
                if (!e.kc()) throw new GQ("All elements of the 'edges' property must be objects.", e, b);
                aQ(a, e.kc());
            }
        }
        if (Mzb in b.a) {
            d = Pu(b, Mzb).hc();
            for(g = 0; g < d.a.length; ++g){
                c = gu(d, g).kc();
                bQ(a, c);
            }
        }
    }
    function fS(a) {
        var b, c, d, e, f, g, h, i;
        for(d = new Tob(a.a.a); d.a < d.c.c.length;){
            c = Wv(Rob(d), 78);
            c.g = null;
            for(g = (i = new Snb(c.a.a).a.bb().mb(), new Ynb(i)); g.a.G();){
                e = (b = Wv(g.a.H(), 21), Wv(b.yb(), 25));
                BI(e.g);
                (!c.g || e.j.d < c.g.j.d) && (c.g = e);
            }
            for(f = (h = new Snb(c.a.a).a.bb().mb(), new Ynb(h)); f.a.G();){
                e = (b = Wv(f.a.H(), 21), Wv(b.yb(), 25));
                e.g.a = e.j.d - c.g.j.d;
                e.g.b = e.j.e - c.g.j.e;
            }
        }
        return a;
    }
    function Nab(a, b) {
        var c, d, e, f, g, h, i, j, k, l, m, n, o1;
        c = false;
        n = $yb * a.b.f * a.b.d;
        for(e = new Tob(b.c); e.a < e.c.c.length;){
            d = Wv(Rob(e), 16);
            j = new Tob(d.a);
            f = Wv(Rob(j), 9);
            k = Uab(a.a[f.k]);
            while(j.a < j.c.c.length){
                h = Wv(Rob(j), 9);
                l = Uab(a.a[h.k]);
                if (k != l) {
                    m = Xjb(a.b, f, h);
                    g = f.i.b + f.j.b + f.e.a + k.a + m;
                    i = h.i.b - h.e.d + l.a;
                    if (g > i + n) {
                        o1 = k.i + l.i;
                        l.a = (l.i * l.a + k.i * k.a) / o1;
                        l.i = o1;
                        k.g = l;
                        c = true;
                    }
                }
                f = h;
                k = l;
            }
        }
        return c;
    }
    function XY(a) {
        var b, c, d, e, f, g;
        if (gw(rJ(a, (eM(), TL))) === gw((KM(), GM)) || gw(rJ(a, TL)) === gw(FM)) for(g = new Tob(a.f); g.a < g.c.c.length;){
            f = Wv(Rob(g), 7);
            if (f.g == (sN(), $M) || f.g == pN) return false;
        }
        if (MM(Wv(rJ(a, TL), 28))) for(e = nX(a, (sN(), ZM)).mb(); e.G();){
            d = Wv(e.H(), 7);
            if (d.b.c.length != 0) return false;
        }
        for(c = Uh(mX(a)); Cm(c);){
            b = Wv(Dm(c), 12);
            if (b.c.f == b.d.f) return false;
        }
        return true;
    }
    function KW(a, b) {
        var c, d, e, f, g, h, i, j, k;
        e = a.f;
        g = e.j.a;
        f = e.j.b;
        if (g <= 0 && f <= 0) return sN(), qN;
        j = a.i.a;
        k = a.i.b;
        h = a.j.a;
        c = a.j.b;
        switch(b.e){
            case 2:
            case 1:
                if (j < 0) return sN(), rN;
                else if (j + h > g) return sN(), ZM;
                break;
            case 4:
            case 3:
                if (k < 0) return sN(), $M;
                else if (k + c > f) return sN(), pN;
        }
        i = (j + h / 2) / g;
        d = (k + c / 2) / f;
        return i + d <= 1 && i - d <= 0 ? (sN(), rN) : i + d >= 1 && i - d >= 0 ? (sN(), ZM) : d < 0.5 ? (sN(), $M) : (sN(), pN);
    }
    function pP(a, b, c, d, e, f, g) {
        var h, i, j, k, l, m;
        m = new UN;
        for(j = b.mb(); j.G();){
            h = Wv(j.H(), 627);
            for(l = new Tob(sW(h)); l.a < l.c.c.length;){
                k = Wv(Rob(l), 129);
                if (gw(oW(k, (eM(), tL))) === gw((EK(), CK))) {
                    nP(m, k, false, d, e, f, g);
                    TN(a, m);
                }
            }
        }
        for(i = c.mb(); i.G();){
            h = Wv(i.H(), 627);
            for(l = new Tob(sW(h)); l.a < l.c.c.length;){
                k = Wv(Rob(l), 129);
                if (gw(oW(k, (eM(), tL))) === gw((EK(), BK))) {
                    nP(m, k, true, d, e, f, g);
                    TN(a, m);
                }
            }
        }
    }
    function f8(a, b) {
        var c, d, e, f, g, h, i, j;
        for(i = new Tob(b.f); i.a < i.c.c.length;){
            h = Wv(Rob(i), 7);
            for(e = Uh(Sh((Gi(), new gr(Ti(Bv(tv(UF, 1), syb, 1, 4, [
                h.b,
                h.e
            ])))))); Cm(e);){
                d = Wv(Dm(e), 12);
                c = d.c == h ? d.d : d.c;
                f = c.f;
                if (b == f) continue;
                j = Wv(rJ(d, (Rib(), Eib)), 24).a;
                j < 0 && (j = 0);
                g = f.k;
                if (a.b[g] == 0) {
                    if (d.d == c) {
                        a.a[g] -= j + 1;
                        a.a[g] <= 0 && a.c[g] > 0 && QI(a.e, f);
                    } else {
                        a.c[g] -= j + 1;
                        a.c[g] <= 0 && a.a[g] > 0 && QI(a.d, f);
                    }
                }
            }
        }
    }
    function tcb(a, b) {
        var c, d, e, f, g, h, i, j, k;
        for(g = new Tob(b.c); g.a < g.c.c.length;){
            f = Wv(Rob(g), 16);
            for(j = new Tob(f.a); j.a < j.c.c.length;){
                i = Wv(Rob(j), 9);
                k = new GU;
                h = 0;
                for(e = Uh(iX(i)); Cm(e);){
                    c = Wv(Dm(e), 12);
                    Wv(rJ(c, (Rib(), Eib)), 24).a > h && (h = Wv(rJ(c, Eib), 24).a);
                }
                for(d = Uh(iX(i)); Cm(d);){
                    c = Wv(Dm(d), 12);
                    i.d != c.c.f.d && Wv(rJ(c, (Rib(), Eib)), 24).a == h && vU(k, new RJ(c.c.f, c));
                }
                Gpb(k, a.c);
                uU(a.b, i.k, k);
            }
        }
    }
    function ucb(a, b) {
        var c, d, e, f, g, h, i, j, k;
        for(g = new Tob(b.c); g.a < g.c.c.length;){
            f = Wv(Rob(g), 16);
            for(j = new Tob(f.a); j.a < j.c.c.length;){
                i = Wv(Rob(j), 9);
                k = new GU;
                h = 0;
                for(e = Uh(mX(i)); Cm(e);){
                    c = Wv(Dm(e), 12);
                    Wv(rJ(c, (Rib(), Eib)), 24).a > h && (h = Wv(rJ(c, Eib), 24).a);
                }
                for(d = Uh(mX(i)); Cm(d);){
                    c = Wv(Dm(d), 12);
                    i.d != c.d.f.d && Wv(rJ(c, (Rib(), Eib)), 24).a == h && vU(k, new RJ(c.d.f, c));
                }
                Gpb(k, a.c);
                uU(a.f, i.k, k);
            }
        }
    }
    function g3(a) {
        b3();
        var b, c, d, e, f, g, h, i, j, k;
        this.b = new i3;
        this.c = new GU;
        this.a = new GU;
        for(i = Seb(), j = 0, k = i.length; j < k; ++j){
            h = i[j];
            ssb(a3, h, new GU);
        }
        for(c = a.mb(); c.G();){
            b = Wv(c.H(), 75);
            xU(this.a, Zdb(b));
            b.g.a.Y() == 0 ? Wv(qsb(a3, b.e), 20).ib(b) : vU(this.c, b);
        }
        for(f = (g = new aob(a3).a.bb().mb(), new fob(g)); f.a.G();){
            e = (d = Wv(f.a.H(), 21), Wv(d.zb(), 20));
            Gpb(e, this.b);
        }
        Dpb(Wv(qsb(a3, (Ieb(), neb)), 20));
    }
    function E$(a, b) {
        var c, d, e, f, g, h, i;
        i = Wv(rJ(b, (eM(), TL)), 28);
        if (!(i == (KM(), GM) || i == FM)) return;
        f = (c = Wv(rJ(b, (Rib(), Xhb)), 15).a, new HI(b.e.a + b.a.b + b.a.c + 2 * c, b.e.b + b.a.d + b.a.a + 2 * c)).b;
        for(h = new Tob(a.a); h.a < h.c.c.length;){
            g = Wv(Rob(h), 9);
            if (g.g != (CX(), xX)) continue;
            d = Wv(rJ(g, hib), 32);
            if (d != (sN(), ZM) && d != rN) continue;
            e = Ixb(Yv(rJ(g, Cib)));
            i == GM && (e *= f);
            g.i.b = e - Wv(rJ(g, SL), 10).b;
            fX(g, false, true);
        }
    }
    function fZ(a, b) {
        var c, d, e, f, g, h, i, j;
        c = new uX(a.d.c);
        sX(c, (CX(), wX));
        sJ(c, (eM(), TL), Wv(rJ(b, TL), 28));
        sJ(c, JL, Wv(rJ(b, JL), 86));
        c.k = a.d.b++;
        vU(a.b, c);
        c.j.b = b.j.b;
        c.j.a = 0;
        j = (sN(), ZM);
        f = Ao(nX(b, j));
        for(i = new Tob(f); i.a < i.c.c.length;){
            h = Wv(Rob(i), 7);
            PX(h, c);
        }
        g = new RX;
        QX(g, j);
        PX(g, b);
        g.i.a = c.j.a;
        g.i.b = c.j.b / 2;
        e = new RX;
        QX(e, tN(j));
        PX(e, c);
        e.i.b = c.j.b / 2;
        e.i.a = -e.j.a;
        d = new hW;
        dW(d, g);
        eW(d, e);
        return c;
    }
    function m3(a, b, c) {
        var d, e, f, g, h, i, j, k, l, m, n, o1;
        i = new Dh;
        Np(a, i);
        e = new deb(b);
        n = new GU;
        vU(n, (o1 = a.j, Wv(um(dq(!o1 ? a.j = new eq(a) : o1)), 7)));
        m = new GU;
        while(n.c.length != 0){
            h = Wv(Rob(new Tob(n)), 7);
            m.c[m.c.length] = h;
            d = Sm(a, h);
            for(g = new Nqb(d.b.mb()); g.b.G();){
                f = Wv(g.b.H(), 12);
                if (beb(e, f, c)) {
                    l = Wv(Gd(i, f), 20);
                    for(k = l.mb(); k.G();){
                        j = Wv(k.H(), 7);
                        zU(m, j, 0) != -1 || (n.c[n.c.length] = j);
                    }
                }
            }
            BU(n, h);
        }
        return e;
    }
    function fmb(a, b) {
        var c, d, e, f, g, h, i;
        c = RegExp(b, 'g');
        h = xv($F, Txb, 2, 0, 5, 1);
        d = 0;
        i = a;
        f = null;
        while(true){
            g = c.exec(i);
            if (g == null || i == '') {
                h[d] = i;
                break;
            } else {
                h[d] = gmb(i, 0, g.index);
                i = gmb(i, g.index + g[0].length, (bmb(), i.length));
                c.lastIndex = 0;
                if (f == i) {
                    h[d] = i.substr(0, 1);
                    i = imb(i, 1, i.length - 1);
                }
                f = i;
                ++d;
            }
        }
        if ((bmb(), a.length) > 0) {
            e = h.length;
            while(e > 0 && h[e - 1] == '')--e;
            e < h.length && (h.length = e, undefined);
        }
        return h;
    }
    function NO(a) {
        var b, c, d, e, f, g;
        for(g = new Tob(AW(a.e)); g.a < g.c.c.length;){
            f = Wv(Rob(g), 161);
            switch(Wv(f.e, 7).g.e){
                case 4:
                    a.q.b = Nlb(a.q.b, (c = Wv(f.e, 7).d, new EP(c.d, c.b, c.a, c.c)).c);
                    break;
                case 2:
                    a.q.c = Nlb(a.q.c, (d = Wv(f.e, 7).d, new EP(d.d, d.b, d.a, d.c)).b);
                    break;
                case 1:
                    a.q.d = Nlb(a.q.d, (e = Wv(f.e, 7).d, new EP(e.d, e.b, e.a, e.c)).a);
                    break;
                case 3:
                    a.q.a = Nlb(a.q.a, (b = Wv(f.e, 7).d, new EP(b.d, b.b, b.a, b.c)).d);
            }
        }
    }
    function Ns(a, b, c, d, e) {
        var f, g, h;
        f = b.$b(c, a.b);
        if (f < 0) {
            g = a.e;
            if (!g) {
                e[0] = 0;
                return d > 0 ? As(a, c, d) : a;
            }
            a.e = Ns(g, b, c, d, e);
            d == 0 && e[0] != 0 ? --a.a : d > 0 && e[0] == 0 && ++a.a;
            a.j = PH(a.j, d - e[0]);
            return Gs(a);
        } else if (f > 0) {
            h = a.g;
            if (!h) {
                e[0] = 0;
                return d > 0 ? Bs(a, c, d) : a;
            }
            a.g = Ns(h, b, c, d, e);
            d == 0 && e[0] != 0 ? --a.a : d > 0 && e[0] == 0 && ++a.a;
            a.j = PH(a.j, d - e[0]);
            return Gs(a);
        }
        e[0] = a.c;
        if (d == 0) return Fs(a);
        a.j = PH(a.j, d - a.c);
        a.c = d;
        return a;
    }
    function Q7(a) {
        var b, c, d, e, f, g, h;
        a.o = new Uvb;
        d = new aJ;
        for(g = new Tob(a.e.a); g.a < g.c.c.length;){
            f = Wv(Rob(g), 61);
            m7(f).c.length == 1 && TI(d, f, d.c.b, d.c);
        }
        while(d.b != 0){
            f = Wv(d.b == 0 ? null : (Bxb(d.b != 0), $I(d, d.a.a)), 61);
            if (m7(f).c.length == 0) continue;
            b = Wv(yU(m7(f), 0), 89);
            c = f.g.c.length > 0;
            h = c7(b, f);
            c ? p7(h.c, b) : p7(h.g, b);
            m7(h).c.length == 1 && TI(d, h, d.c.b, d.c);
            e = new RJ(f, b);
            Tvb(a.o, e);
            BU(a.e.a, f);
        }
    }
    function Hs(a, b, c, d, e) {
        var f, g, h;
        f = b.$b(c, a.b);
        if (f < 0) {
            g = a.e;
            if (!g) {
                e[0] = 0;
                return a;
            }
            a.e = Hs(g, b, c, d, e);
            if (e[0] > 0) {
                if (d >= e[0]) {
                    --a.a;
                    a.j = XH(a.j, e[0]);
                } else a.j = XH(a.j, d);
            }
            return e[0] == 0 ? a : Gs(a);
        } else if (f > 0) {
            h = a.g;
            if (!h) {
                e[0] = 0;
                return a;
            }
            a.g = Hs(h, b, c, d, e);
            if (e[0] > 0) {
                if (d >= e[0]) {
                    --a.a;
                    a.j = XH(a.j, e[0]);
                } else a.j = XH(a.j, d);
            }
            return Gs(a);
        }
        e[0] = a.c;
        if (d >= a.c) return Fs(a);
        else {
            a.c -= d;
            a.j = XH(a.j, d);
            return a;
        }
    }
    function BQ(a, b, c) {
        var d, e, f, g, h, i, j, k;
        for(i = new Tob(c.b); i.a < i.c.c.length;){
            h = Wv(Rob(i), 9);
            g = Wv(rJ(h, (Rib(), sib)), 55);
            if (g) {
                k = BQ(a, b, g);
                h.j.a = (f = Wv(rJ(k, Xhb), 15).a, new HI(k.e.a + k.a.b + k.a.c + 2 * f, k.e.b + k.a.d + k.a.a + 2 * f)).a;
                h.j.b = (e = Wv(rJ(k, Xhb), 15).a, new HI(k.e.a + k.a.b + k.a.c + 2 * e, k.e.b + k.a.d + k.a.a + 2 * e)).b;
            }
        }
        j = new sI;
        d = $v(rJ(c, (eM(), kL)));
        d != null && emb(d, 'de.cau.cs.kieler.fixed') ? JP(c, j) : ZQ(b, c, j);
        return c;
    }
    function bR(a) {
        var b, c, d, e, f, g, h, i;
        h = Wv(rJ(a, (eM(), aM)), 18);
        i = Wv(rJ(a, bM), 18);
        d = Wv(rJ(a, (Rib(), Xhb)), 15).a;
        a.d.a += d;
        a.d.b += d;
        a.e.a += 2 * d;
        a.e.b += 2 * d;
        sJ(a, Xhb, new llb(0));
        e = (c = Wv(rJ(a, Xhb), 15).a, new HI(a.e.a + a.a.b + a.a.c + 2 * c, a.e.b + a.a.d + a.a.a + 2 * c));
        b = new II(e);
        if (h.kb((DN(), zN))) {
            g = Wv(rJ(a, IL), 15).a;
            f = Wv(rJ(a, HL), 15).a;
            if (i.kb((MN(), KN))) {
                g <= 0 && (g = 20);
                f <= 0 && (f = 20);
            }
            b.a = Nlb(e.a, g);
            b.b = Nlb(e.b, f);
        }
        cR(a, e, b);
    }
    function rV(a, b, c) {
        var d, e, f, g, h, i, j, k;
        if (b.k == 0) {
            b.k = 1;
            g = c;
            if (!c) {
                e = new GU;
                f = (d = Wv(Hkb(Kz), 11), new atb(d, Wv(exb(d, d.length), 11), 0));
                g = new RJ(e, f);
            }
            Wv(g.a, 20).ib(b);
            b.g == (CX(), xX) && Wv(g.b, 18).ib(Wv(rJ(b, (Rib(), hib)), 32));
            for(i = new Tob(b.f); i.a < i.c.c.length;){
                h = Wv(Rob(i), 7);
                for(k = Uh(Sh((Gi(), new gr(Ti(Bv(tv(UF, 1), syb, 1, 4, [
                    new fY(h),
                    new lY(h)
                ])))))); Cm(k);){
                    j = Wv(Dm(k), 7);
                    rV(a, j.f, g);
                }
            }
            return g;
        }
        return null;
    }
    function QW(a, b, c, d) {
        var e, f, g, h, i;
        i = new II(b.i);
        i.a += b.j.a / 2;
        i.b += b.j.b / 2;
        h = Wv(rJ(b, (Rib(), tib)), 15).a;
        f = a.e;
        g = a.a;
        e = a.d;
        switch(Wv(rJ(b, hib), 32).e){
            case 1:
                i.a += g.b + e.a - c / 2;
                i.b = -d - h;
                b.i.b = -(g.d + h + e.b);
                break;
            case 2:
                i.a = f.a + g.b + g.c + h;
                i.b += g.d + e.b - d / 2;
                b.i.a = f.a + g.c + h - e.a;
                break;
            case 3:
                i.a += g.b + e.a - c / 2;
                i.b = f.b + g.d + g.a + h;
                b.i.b = f.b + g.a + h - e.b;
                break;
            case 4:
                i.a = -c - h;
                i.b += g.d + e.b - d / 2;
                b.i.a = -(g.b + h + e.a);
        }
        return i;
    }
    function $Q(a, b) {
        var c, d, e, f, g, h, i;
        for(f = new Tob(b.b); f.a < f.c.c.length;){
            e = Wv(Rob(f), 9);
            g = rJ(e, (Rib(), uib));
            if (aw(g, 7)) {
                h = Wv(g, 7);
                i = QW(b, e, h.j.a, h.j.b);
                h.i.a = i.a;
                h.i.b = i.b;
                QX(h, Wv(rJ(e, hib), 32));
            }
        }
        c = (d = Wv(rJ(b, (Rib(), Xhb)), 15).a, new HI(b.e.a + b.a.b + b.a.c + 2 * d, b.e.b + b.a.d + b.a.a + 2 * d));
        if (Wv(rJ(b, jib), 18).kb((ohb(), hhb))) {
            sJ(a, (eM(), TL), (KM(), FM));
            Wv(rJ(hX(a), jib), 18).ib(khb);
            WW(a, c, false);
        } else WW(a, c, true);
    }
    function VW(a, b, c) {
        var d, e, f, g, h;
        h = null;
        switch(b.e){
            case 1:
                for(e = new Tob(a.f); e.a < e.c.c.length;){
                    d = Wv(Rob(e), 7);
                    if (Ckb(Ixb(Xv(rJ(d, (Rib(), kib)))))) return d;
                }
                h = new RX;
                sJ(h, (Rib(), kib), (xkb(), xkb(), wkb));
                break;
            case 2:
                for(g = new Tob(a.f); g.a < g.c.c.length;){
                    f = Wv(Rob(g), 7);
                    if (Ckb(Ixb(Xv(rJ(f, (Rib(), yib)))))) return f;
                }
                h = new RX;
                sJ(h, (Rib(), yib), (xkb(), xkb(), wkb));
        }
        if (h) {
            PX(h, a);
            QX(h, c);
            LW(h.i, a.j, c);
        }
        return h;
    }
    function pk(a, b) {
        var c, d, e, f, g, h, i;
        _b(b);
        Xb(a.a.t(b.a));
        d = a.b;
        f = a.e;
        g = a.d;
        if (a.b) {
            if (b.b) {
                c = a.a.$b(a.e, b.e);
                if (c < 0 || c == 0 && b.d == (Gh(), Fh)) {
                    f = b.e;
                    g = b.d;
                }
            }
        } else {
            d = b.b;
            f = b.e;
            g = b.d;
        }
        e = a.c;
        h = a.g;
        i = a.f;
        if (a.c) {
            if (b.c) {
                c = a.a.$b(a.g, b.g);
                if (c > 0 || c == 0 && b.f == (Gh(), Fh)) {
                    h = b.g;
                    i = b.f;
                }
            }
        } else {
            e = b.c;
            h = b.g;
            i = b.f;
        }
        if (d && e) {
            c = a.a.$b(f, h);
            if (c > 0 || c == 0 && g == (Gh(), Fh) && i == (Gh(), Fh)) {
                f = h;
                g = (Gh(), Fh);
                i = Eh;
            }
        }
        return new sk(a.a, d, f, g, e, h, i);
    }
    function h0(a, b, c, d) {
        var e, f, g, h, i, j, k;
        if (c.c.f == b.f) return;
        e = new uX(a);
        sX(e, (CX(), zX));
        sJ(e, (Rib(), uib), c);
        sJ(e, (eM(), TL), (KM(), FM));
        d.c[d.c.length] = e;
        g = new RX;
        PX(g, e);
        QX(g, (sN(), rN));
        h = new RX;
        PX(h, e);
        QX(h, ZM);
        eW(c, g);
        f = new hW;
        qJ(f, c);
        sJ(f, CL, null);
        dW(f, h);
        eW(f, b);
        j0(e, g, h);
        j = new Fnb(c.b, 0);
        while(j.b < j.d.Y()){
            i = (Bxb(j.b < j.d.Y()), Wv(j.d.sb(j.c = j.b++), 33));
            k = Wv(rJ(i, tL), 107);
            if (k == (EK(), BK)) {
                vnb(j);
                vU(f.b, i);
            }
        }
    }
    function Pfb(a, b, c, d) {
        var e, f, g, h, i, j, k, l, m, n, o1, p, q;
        f = c + (b.n + 1) * a.a;
        g = b.b;
        e = new HI(f, g);
        for(i = (k = new Snb(b.c.a).a.bb().mb(), new Ynb(k)); i.a.G();){
            h = (j = Wv(i.a.H(), 21), Wv(j.yb(), 12));
            o1 = MX(h.d);
            l = MX(h.c);
            n = new HI(f, l.b);
            q = new HI(f, o1.b);
            m = new HI(c - 10, l.b);
            p = new HI(d, o1.b);
            o1.a >= d && l.a >= d && (m.a = d);
            o1.a <= c && l.a <= c && (p.a = c - 10);
            b.c.a.Y() == 1 ? fJ(h.a, Bv(tv(qz, 1), Fzb, 10, 0, [
                m,
                n,
                q,
                p
            ])) : fJ(h.a, Bv(tv(qz, 1), Fzb, 10, 0, [
                m,
                n,
                e,
                q,
                p
            ]));
        }
    }
    function cW(a, b) {
        var c, d, e, f, g, h;
        f = a.c;
        g = a.d;
        dW(a, null);
        eW(a, null);
        b && Ckb(Ixb(Xv(rJ(g, (Rib(), kib))))) ? dW(a, VW(g.f, (djb(), bjb), (sN(), ZM))) : dW(a, g);
        b && Ckb(Ixb(Xv(rJ(f, (Rib(), yib))))) ? eW(a, VW(f.f, (djb(), ajb), (sN(), rN))) : eW(a, f);
        for(d = new Tob(a.b); d.a < d.c.c.length;){
            c = Wv(Rob(d), 33);
            e = Wv(rJ(c, (eM(), tL)), 107);
            e == (EK(), CK) ? sJ(c, tL, BK) : e == BK && sJ(c, tL, CK);
        }
        h = Ckb(Ixb(Xv(rJ(a, (Rib(), Iib)))));
        sJ(a, Iib, (xkb(), h ? vkb : wkb));
        a.a = lJ(a.a);
    }
    function efb(a) {
        var b, c, d, e, f, g;
        Teb(this);
        for(c = a.Y() - 1; c < 3; c++)a.rb(0, Wv(a.sb(0), 10));
        if (a.Y() < 4) throw new slb('At (least dimension + 1) control points are necessary!');
        else {
            this.c = 3;
            this.e = true;
            this.f = true;
            this.d = false;
            Ueb(this, a.Y() + this.c - 1);
            g = new GU;
            f = this.g.mb();
            for(b = 0; b < this.c - 1; b++)vU(g, Yv(f.H()));
            for(e = a.mb(); e.G();){
                d = Wv(e.H(), 10);
                vU(g, Yv(f.H()));
                this.b.ib(new sfb(d, g));
                Cxb(0, g.c.length);
                g.c.splice(0, 1);
            }
        }
    }
    function scb(a) {
        var b, c, d, e, f, g, h, i, j, k, l;
        l = new rcb;
        l.d = 0;
        for(g = new Tob(a.c); g.a < g.c.c.length;){
            f = Wv(Rob(g), 16);
            l.d += f.a.c.length;
        }
        d = 0;
        e = 0;
        l.a = xv(mw, Yyb, 26, a.c.c.length, 12, 1);
        j = 0;
        l.e = xv(mw, Yyb, 26, l.d, 12, 1);
        for(c = new Tob(a.c); c.a < c.c.c.length;){
            b = Wv(Rob(c), 16);
            b.k = d++;
            l.a[b.k] = e++;
            k = 0;
            for(i = new Tob(b.a); i.a < i.c.c.length;){
                h = Wv(Rob(i), 9);
                h.k = j++;
                l.e[h.k] = k++;
            }
        }
        l.c = new wcb(l);
        l.b = Do(l.d);
        tcb(l, a);
        l.f = Do(l.d);
        ucb(l, a);
        return l;
    }
    function Lab(a, b) {
        var c, d, e, f, g, h, i, j, k, l, m, n, o1, p;
        h = xv(mw, Yyb, 26, b.c.c.length, 12, 1);
        j = xv(pB, uyb, 132, b.c.c.length, 0, 1);
        for(l = a.a, m = 0, n = l.length; m < n; ++m){
            k = l[m];
            p = 0;
            for(g = new Tob(k.f); g.a < g.c.c.length;){
                e = Wv(Rob(g), 9);
                i = e.g;
                d = rY(e.d);
                ++h[d];
                o1 = a.b.a * a.b.d;
                h[d] > 0 && !!j[d] && (o1 = Wjb(a.b, j[d], i));
                p = Nlb(p, e.d.c.b + o1);
            }
            for(f = new Tob(k.f); f.a < f.c.c.length;){
                e = Wv(Rob(f), 9);
                e.i.b = p + e.e.d;
                c = e.d;
                c.c.b = p + e.e.d + e.j.b + e.e.a;
                j[zU(c.b.c, c, 0)] = e.g;
            }
        }
    }
    function n$(a) {
        var b, c, d, e, f, g, h, i, j, k;
        for(i = new Tob(a.a); i.a < i.c.c.length;){
            h = Wv(Rob(i), 9);
            if (h.g != (CX(), xX)) continue;
            e = Wv(rJ(h, (Rib(), hib)), 32);
            if (e == (sN(), ZM) || e == rN) for(d = Uh(gX(h)); Cm(d);){
                c = Wv(Dm(d), 12);
                b = c.a;
                if (b.b == 0) continue;
                j = c.c;
                if (j.f == h) {
                    f = (Bxb(b.b != 0), Wv(b.a.a.c, 10));
                    f.b = MI(Bv(tv(qz, 1), Fzb, 10, 0, [
                        j.f.i,
                        j.i,
                        j.a
                    ])).b;
                }
                k = c.d;
                if (k.f == h) {
                    g = (Bxb(b.b != 0), Wv(b.c.b.c, 10));
                    g.b = MI(Bv(tv(qz, 1), Fzb, 10, 0, [
                        k.f.i,
                        k.i,
                        k.a
                    ])).b;
                }
            }
        }
    }
    function U9(a, b, c, d) {
        var e, f, g, h, i, j;
        g = new _9(a, b, c);
        i = new Fnb(d, 0);
        e = false;
        while(i.b < i.d.Y()){
            h = (Bxb(i.b < i.d.Y()), Wv(i.d.sb(i.c = i.b++), 102));
            if (h == b || h == c) vnb(i);
            else if (!e && Ixb(W9(h.g, h.d[0]).a) > Ixb(W9(g.g, g.d[0]).a)) {
                Bxb(i.b > 0);
                i.a.sb(i.c = --i.b);
                Anb(i, g);
                e = true;
            } else if (!!h.e && h.e.Y() > 0) {
                f = (!h.e && (h.e = new GU), h.e).nb(b);
                j = (!h.e && (h.e = new GU), h.e).nb(c);
                if (f || j) {
                    (!h.e && (h.e = new GU), h.e).ib(g);
                    ++g.c;
                }
            }
        }
        e || (d.c[d.c.length] = g);
    }
    function s2(a, b, c, d) {
        var e, f, g, h, i, j, k, l, m, n, o1;
        if (c.d.f == b.f) return;
        e = new uX(a);
        sX(e, (CX(), zX));
        sJ(e, (Rib(), uib), c);
        sJ(e, (eM(), TL), (KM(), FM));
        d.c[d.c.length] = e;
        g = new RX;
        PX(g, e);
        QX(g, (sN(), rN));
        h = new RX;
        PX(h, e);
        QX(h, ZM);
        i = c.d;
        eW(c, g);
        f = new hW;
        qJ(f, c);
        sJ(f, CL, null);
        dW(f, h);
        eW(f, i);
        j = Wv(yU(g.b, 0), 12).c;
        k = j.f;
        l = k.g;
        m = Wv(yU(h.e, 0), 12).d;
        n = m.f;
        o1 = n.g;
        l == zX ? sJ(e, qib, Wv(rJ(k, qib), 7)) : sJ(e, qib, j);
        o1 == zX ? sJ(e, rib, Wv(rJ(n, rib), 7)) : sJ(e, rib, m);
    }
    function $6(a, b, c) {
        var d, e, f, g, h, i, j, k, l, m, n, o1, p, q, r;
        if (h = a.b[b], i = a.b[c], (j = Wv(rJ(h, (Rib(), oib)), 20), !!j && j.Y() != 0 && j.kb(i)) || (k = h.g != (CX(), zX) && i.g != zX, l = Wv(rJ(h, nib), 9), m = Wv(rJ(i, nib), 9), n = !!l && l != h || !!m && m != i, o1 = l != m, p = _6(h, (sN(), $M)), q = _6(i, pN), r = n && o1 || p || q, k && r) || h.g == (CX(), BX) && i.g == AX || i.g == (CX(), BX) && h.g == AX) return false;
        g = a.b[b];
        d = a.b[c];
        m6(a.c, g, d);
        G6(a.d, g, d);
        f = M5(a.a, g, d) + a.c.d + a.d.d;
        e = M5(a.a, d, g) + a.c.b + a.d.b;
        return f > e;
    }
    function v2(a, b) {
        var c, d, e, f, g, h, i, j, k, l, m, n, o1, p;
        g = b;
        m = b.d;
        k = b.c.f;
        n = b.d.f;
        l = rY(k.d);
        o1 = rY(n.d);
        for(h = l; h < o1; h++){
            e = new uX(a);
            sX(e, (CX(), zX));
            sJ(e, (Rib(), uib), g);
            sJ(e, (eM(), TL), (KM(), FM));
            i = Wv(yU(a.c, h + 1), 16);
            rX(e, i);
            p = Wv(rJ(g, dM), 15).a;
            if (p < 0) {
                p = 0;
                sJ(g, dM, new llb(p));
            }
            e.j.b = p;
            j = Math.floor(p / 2);
            d = new RX;
            QX(d, (sN(), rN));
            PX(d, e);
            d.i.b = j;
            f = new RX;
            QX(f, ZM);
            PX(f, e);
            f.i.b = j;
            eW(g, d);
            c = new hW;
            qJ(c, g);
            sJ(c, CL, null);
            dW(c, f);
            eW(c, m);
            w2(e, g, c);
            g = c;
        }
    }
    function Qeb(a, b) {
        Ieb();
        if (a == b) return Reb(a);
        switch(a.e){
            case 1:
                switch(b.e){
                    case 4:
                        return neb;
                    case 1:
                        return meb;
                    case 2:
                        return jeb;
                    case 3:
                        return qeb;
                }
            case 2:
                switch(b.e){
                    case 1:
                        return jeb;
                    case 2:
                        return ieb;
                    case 3:
                        return peb;
                    case 4:
                        return keb;
                }
            case 3:
                switch(b.e){
                    case 2:
                        return peb;
                    case 3:
                        return oeb;
                    case 4:
                        return Heb;
                    case 1:
                        return qeb;
                }
            case 4:
                switch(b.e){
                    case 3:
                        return Heb;
                    case 4:
                        return Geb;
                    case 1:
                        return neb;
                    case 2:
                        return keb;
                }
        }
        return Feb;
    }
    function s$(a) {
        var b, c, d, e, f, g, h, i, j, k, l, m, n, o1, p;
        l = new Wub;
        e = null;
        for(g = new Tob(a.c); g.a < g.c.c.length;){
            f = Wv(Rob(g), 16);
            for(i = new Tob(f.a); i.a < i.c.c.length;){
                h = Wv(Rob(i), 9);
                if (h.g != (CX(), xX)) continue;
                k = Wv(rJ(h, (Rib(), gib)), 9);
                if (k) {
                    r$(k, l);
                    m = new RX;
                    PX(m, h);
                    n = Wv(rJ(h, hib), 32);
                    QX(m, n);
                    o1 = Wv(yU(k.f, 0), 7);
                    p = new hW;
                    dW(p, m);
                    eW(p, o1);
                }
            }
            e = f;
        }
        for(c = (j = new Snb(l.a).a.bb().mb(), new Ynb(j)); c.a.G();){
            b = (d = Wv(c.a.H(), 21), Wv(d.yb(), 9));
            rX(b, e);
        }
        return l;
    }
    function RV(a, b, c) {
        var d, e, f, g, h, i, j, k, l;
        e = new GU;
        for(j = new Tob(b.b); j.a < j.c.c.length;){
            i = Wv(Rob(j), 9);
            h = Wv(rJ(i, (Rib(), sib)), 55);
            if (h) {
                d = RV(a, h, i);
                xU(e, d);
                PV(a, h, i);
                if (Wv(rJ(h, jib), 18).kb((ohb(), hhb))) for(l = new Tob(i.f); l.a < l.c.c.length;){
                    k = Wv(Rob(l), 7);
                    if (Smb(a.b, k) == null) {
                        f = NW(k, (KM(), IM), k.g, -(k.b.c.length - k.e.c.length), k.j, Wv(rJ(h, (eM(), sL)), 59), h);
                        sJ(f, uib, k);
                        Umb(a.b, k, f);
                        vU(h.b, f);
                    }
                }
            }
        }
        g = new GU;
        OV(a, b, c, e, g);
        !!c && QV(a, b, c, g);
        return g;
    }
    function Obb(a) {
        var b, c, d, e, f, g, h, i, j, k, l, m;
        b = ecb(a);
        for(k = (h = new Snb(b).a.bb().mb(), new Ynb(h)); k.a.G();){
            j = (e = Wv(k.a.H(), 21), Wv(e.yb(), 9));
            l = j.e.d;
            m = j.j.b + j.e.a;
            a.d[j.k] = 0;
            c = j;
            while((f = a.a[c.k]) != j){
                d = gcb(c, f);
                a.c == (Gbb(), Ebb) ? i = d.d.i.b + d.d.a.b - d.c.i.b - d.c.a.b : i = d.c.i.b + d.c.a.b - d.d.i.b - d.d.a.b;
                g = Ixb(a.d[c.k]) + i;
                a.d[f.k] = g;
                l = Nlb(l, f.e.d - g);
                m = Nlb(m, g + f.j.b + f.e.a);
                c = f;
            }
            c = j;
            do {
                a.d[c.k] = Ixb(a.d[c.k]) + l;
                c = a.a[c.k];
            }while (c != j);
            a.b[j.k] = l + m;
        }
    }
    function Gcb(a, b, c) {
        var d, e, f, g, h, i, j, k;
        d = a.a.k == (Lbb(), Kbb) ? Uzb : Vzb;
        h = Hcb(a, new Fcb(b, c));
        if (!h.a && h.c) {
            QI(a.d, h);
            return d;
        } else if (h.a) {
            e = h.a.c;
            i = h.a.d;
            if (c) {
                j = a.a.c == (Gbb(), Fbb) ? i : e;
                f = a.a.c == Fbb ? e : i;
                g = a.a.f[f.f.k];
                k = Ixb(a.a.n[g.k]) + Ixb(a.a.d[f.f.k]) + f.i.b + f.a.b - Ixb(a.a.d[j.f.k]) - j.i.b - j.a.b;
            } else {
                j = a.a.c == (Gbb(), Ebb) ? i : e;
                f = a.a.c == Ebb ? e : i;
                k = Ixb(a.a.n[a.a.f[f.f.k].k]) + Ixb(a.a.d[f.f.k]) + f.i.b + f.a.b - Ixb(a.a.d[j.f.k]) - j.i.b - j.a.b;
            }
            return k;
        }
        return d;
    }
    function FY(a) {
        var b, c, d, e, f;
        sJ(a.g, (Rib(), Thb), Eo(a.g.c));
        for(b = 1; b < a.c.c.length - 1; ++b)sJ(Wv(yU(a.c, b), 9), (eM(), JL), (oM(), Vsb(jM, Bv(tv(Gz, 1), uyb, 41, 0, [
            mM,
            fM
        ]))));
        for(d = WI(Eo(a.g.c), 0); d.b != d.d.c;){
            c = Wv(_ub(d), 33);
            e = Wv(rJ(a.g, (eM(), JL)), 86);
            if (Xe(e, Vsb((oM(), kM), Bv(tv(Gz, 1), uyb, 41, 0, [
                gM,
                mM
            ])))) ;
            else if (Xe(e, Vsb(kM, Bv(tv(Gz, 1), uyb, 41, 0, [
                iM,
                mM
            ])))) {
                vU(a.e.c, c);
                BU(a.g.c, c);
                f = new MY(a, c);
                sJ(a.g, Uhb, f);
            } else {
                GY(a, c);
                vU(a.i, a.d);
                sJ(a.g, Uhb, EY(a.i));
            }
        }
    }
    function OW(a, b, c, d) {
        var e, f, g, h, i, j, k;
        f = PW(d);
        h = Ckb(Ixb(Xv(rJ(d, (Mjb(), xjb)))));
        if ((h || Ckb(Ixb(Xv(rJ(a, (eM(), AL)))))) && !MM(Wv(rJ(a, (eM(), TL)), 28))) {
            e = vN(f);
            i = VW(a, c, c == (djb(), bjb) ? e : tN(e));
        } else {
            i = new RX;
            PX(i, a);
            k = i.i;
            k.a = b.a - a.i.a;
            k.b = b.b - a.i.b;
            wI(k, a.j.a, a.j.b);
            QX(i, KW(i, f));
            g = Wv(rJ(d, (Rib(), jib)), 18);
            j = i.g;
            switch(f.e){
                case 2:
                case 1:
                    (j == (sN(), $M) || j == pN) && g.ib((ohb(), lhb));
                    break;
                case 4:
                case 3:
                    (j == (sN(), ZM) || j == rN) && g.ib((ohb(), lhb));
            }
        }
        return i;
    }
    function G2(a) {
        var b, c, d, e, f, g, h, i;
        d = Nl(Ao(a.a));
        e = (b = Wv(Hkb(_E), 11), new atb(b, Wv(exb(b, b.length), 11), 0));
        while(d.a.G() || d.b.mb().G()){
            c = Wv(nm(d), 12);
            h = c.c.g;
            i = c.d.g;
            if (h == (sN(), qN)) {
                if (i != qN) {
                    g = Reb(i);
                    sJ(c, (Rib(), Mib), g);
                    QX(c.c, i);
                    Wsb(e, g);
                    d.a.I();
                }
            } else if (i == qN) {
                g = Reb(h);
                sJ(c, (Rib(), Mib), g);
                QX(c.d, h);
                Wsb(e, g);
                d.a.I();
            } else {
                g = Qeb(h, i);
                sJ(c, (Rib(), Mib), g);
                Wsb(e, g);
                d.a.I();
            }
        }
        e.c == 1 ? f = Wv(itb(new jtb(e)), 60) : f = (Ieb(), Feb);
        aeb(a, f, false);
        return f;
    }
    function AI(b, c) {
        var d, e, f, g;
        f = 0;
        while(f < (bmb(), c.length) && LI(c.charCodeAt(f), fzb))++f;
        d = c.length;
        while(d > 0 && LI(c.charCodeAt(d - 1), gzb))--d;
        if (f >= d) throw new slb('The given string does not contain any numbers.');
        g = fmb(c.substr(f, d - f), ',|;|\r|\n');
        if (g.length != 2) throw new slb('Exactly two numbers are expected, ' + g.length + ' were found.');
        try {
            b.a = clb(hmb(g[0]));
            b.b = clb(hmb(g[1]));
        } catch (a) {
            a = OH(a);
            if (aw(a, 130)) {
                e = a;
                throw new slb(hzb + e);
            } else throw NH(a);
        }
    }
    function Qdb(a, b, c) {
        var d, e, f, g, h, i, j, k, l;
        i = c + b.d.c.a;
        for(l = new Tob(b.f); l.a < l.c.c.length;){
            k = Wv(Rob(l), 7);
            d = MI(Bv(tv(qz, 1), Fzb, 10, 0, [
                k.f.i,
                k.i,
                k.a
            ]));
            f = new HI(0, d.b);
            if (k.g == (sN(), ZM)) f.a = i;
            else if (k.g == rN) f.a = c;
            else continue;
            if (d.a == f.a) continue;
            e = k.e.c.length + k.b.c.length > 1;
            for(h = Uh(Sh((Gi(), new gr(Ti(Bv(tv(UF, 1), syb, 1, 4, [
                k.b,
                k.e
            ])))))); Cm(h);){
                g = Wv(Dm(h), 12);
                j = g.c == k ? g.d : g.c;
                Jlb(MI(Bv(tv(qz, 1), Fzb, 10, 0, [
                    j.f.i,
                    j.i,
                    j.a
                ])).b - f.b) > 1 && Odb(a, g, f, e, k);
            }
        }
    }
    function FR(a, b) {
        var c, d, e, f, g, h;
        for(g = new rnb(new inb(a.f.b).a); g.b;){
            f = pnb(g);
            e = Wv(f.yb(), 251);
            if (b == 1) {
                if (e.yc() != (sK(), rK) && e.yc() != nK) continue;
            } else {
                if (e.yc() != (sK(), oK) && e.yc() != pK) continue;
            }
            d = Wv(Wv(f.zb(), 27).b, 25);
            h = Wv(Wv(f.zb(), 27).a, 78);
            c = h.c;
            switch(e.yc().e){
                case 2:
                    d.j.d = a.e.a;
                    d.j.c = Nlb(1, d.j.c + c);
                    break;
                case 1:
                    d.j.d = d.j.d + c;
                    d.j.c = Nlb(1, d.j.c - c);
                    break;
                case 4:
                    d.j.e = a.e.b;
                    d.j.b = Nlb(1, d.j.b + c);
                    break;
                case 3:
                    d.j.e = d.j.e + c;
                    d.j.b = Nlb(1, d.j.b - c);
            }
        }
    }
    function bdb(a, b, c, d, e) {
        var f, g, h, i, j, k, l, m, n;
        m = (mp(), new ntb);
        h = new GU;
        adb(a, c, a.d.Mc(), h, m);
        adb(a, d, a.d.Nc(), h, m);
        i = new Fnb(h, 0);
        while(i.b < i.d.Y()){
            f = (Bxb(i.b < i.d.Y()), Wv(i.d.sb(i.c = i.b++), 80));
            j = new Fnb(h, i.b);
            while(j.b < j.d.Y()){
                g = (Bxb(j.b < j.d.Y()), Wv(j.d.sb(j.c = j.b++), 80));
                gdb(f, g, a.a);
            }
        }
        ddb(h, Wv(rJ(b, (Rib(), Gib)), 154));
        idb(h);
        n = -1;
        for(l = new Tob(h); l.a < l.c.c.length;){
            k = Wv(Rob(l), 80);
            if (Jlb(k.k - k.a) < dAb) continue;
            n = Plb(n, k.i);
            a.d.Kc(k, e);
        }
        a.b.a.Q();
        return n + 1;
    }
    function r3(a, b, c) {
        var d, e;
        e = new II(b);
        d = new II(a.j);
        switch(c.e){
            case 1:
            case 8:
            case 7:
                uI(e, -d.a / 2, -d.b);
                uI(b, 0, -(0.5 + d.b));
                break;
            case 3:
            case 4:
            case 5:
                uI(e, -d.a / 2, 0);
                uI(b, 0, 0.5 + d.b);
                break;
            case 0:
                uI(e, -d.a / 2, -d.b);
                uI(b, 0, -(0.5 + -d.b));
                break;
            case 10:
            case 2:
                uI(e, 0, -d.b / 2);
                uI(b, 0, -(0.5 + d.b));
                break;
            case 6:
                uI(e, -d.a, d.b / 2);
                uI(b, 0, -(0.5 + d.b));
                break;
            case 9:
                uI(e, -d.a / 2, 0);
                uI(b, 0, -(0.5 + d.b));
                break;
            case 11:
                uI(e, -d.a, -d.b / 2);
                uI(b, 0, -(0.5 + d.b));
        }
        vI(BI(a.i), e);
        return new Cfb(a);
    }
    function Gmb(a, b, c, d, e) {
        Fmb();
        var f, g, h, i, j, k, l;
        Exb(a, 'src');
        Exb(c, 'dest');
        k = tb(a);
        h = tb(c);
        Axb((k.g & 4) != 0, 'srcType is not an array');
        Axb((h.g & 4) != 0, 'destType is not an array');
        j = k.c;
        f = h.c;
        Axb((j.g & 1) != 0 ? j == f : (f.g & 1) == 0, "Array types don't match");
        l = a.length;
        i = c.length;
        if (b < 0 || d < 0 || e < 0 || b + e > l || d + e > i) throw new nkb;
        if (((j.g & 1) == 0 || (j.g & 4) != 0) && k != h) {
            if (a === c && b < d) {
                b += e;
                for(g = d + e; g-- > d;)c[g] = a[--b];
            } else for(g = d + e; d < g;)c[d++] = a[b++];
        } else e > 0 && dxb(a, b, c, d, e, true);
    }
    function cR(a, b, c) {
        var d, e, f, g, h;
        d = Wv(rJ(a, (Mjb(), jjb)), 18);
        c.a > b.a && (d.kb((zgb(), tgb)) ? a.d.a += (c.a - b.a) / 2 : d.kb(vgb) && (a.d.a += c.a - b.a));
        c.b > b.b && (d.kb((zgb(), xgb)) ? a.d.b += (c.b - b.b) / 2 : d.kb(wgb) && (a.d.b += c.b - b.b));
        if (Wv(rJ(a, (Rib(), jib)), 18).kb((ohb(), hhb)) && (c.a > b.a || c.b > b.b)) for(h = new Tob(a.b); h.a < h.c.c.length;){
            g = Wv(Rob(h), 9);
            if (g.g == (CX(), xX)) {
                e = Wv(rJ(g, hib), 32);
                e == (sN(), ZM) ? g.i.a += c.a - b.a : e == pN && (g.i.b += c.b - b.b);
            }
        }
        f = a.a;
        a.e.a = c.a - f.b - f.c;
        a.e.b = c.b - f.d - f.a;
    }
    function Ms(a, b, c, d, e, f) {
        var g, h, i;
        g = b.$b(c, a.b);
        if (g < 0) {
            h = a.e;
            if (!h) {
                f[0] = 0;
                if (d == 0 && e > 0) return As(a, c, e);
                return a;
            }
            a.e = Ms(h, b, c, d, e, f);
            if (f[0] == d) {
                e == 0 && f[0] != 0 ? --a.a : e > 0 && f[0] == 0 && ++a.a;
                a.j = PH(a.j, e - f[0]);
            }
            return Gs(a);
        } else if (g > 0) {
            i = a.g;
            if (!i) {
                f[0] = 0;
                if (d == 0 && e > 0) return Bs(a, c, e);
                return a;
            }
            a.g = Ms(i, b, c, d, e, f);
            if (f[0] == d) {
                e == 0 && f[0] != 0 ? --a.a : e > 0 && f[0] == 0 && ++a.a;
                a.j = PH(a.j, e - f[0]);
            }
            return Gs(a);
        }
        f[0] = a.c;
        if (d == a.c) {
            if (e == 0) return Fs(a);
            a.j = PH(a.j, e - a.c);
            a.c = e;
        }
        return a;
    }
    function gfb(a) {
        var b, c, d, e, f, g, h, i, j, k, l, m, n, o1, p, q;
        i = a.e;
        n = a.f;
        g = a.d;
        o1 = a.c;
        k = o1 - 1;
        p = a.g;
        l = Eo(a.g.xb(1, a.g.Y() - 1));
        j = new GU;
        for(c = 0; c < a.b.Y() - 1; c++){
            h = CI(EI(xI(Wv(a.b.sb(c + 1), 92).a), Wv(a.b.sb(c), 92).a), o1 / (Ixb(Yv(p.sb(c + o1))) - Ixb(Yv(p.sb(c)))));
            j.c[j.c.length] = h;
        }
        q = new GU;
        f = WI(l, 0);
        m = new GU;
        for(b = 0; b < k - 1; b++)vU(q, Yv(_ub(f)));
        for(e = new Tob(j); e.a < e.c.c.length;){
            d = Wv(Rob(e), 10);
            vU(q, Yv(_ub(f)));
            vU(m, new sfb(d, q));
            Cxb(0, q.c.length);
            q.c.splice(0, 1);
        }
        return new ffb(i, n, g, k, l, m);
    }
    function fP(a) {
        this.q = new AP;
        this.p = new AP;
        this.o = xv(mw, Yyb, 26, (sN(), Bv(tv(Kz, 1), uyb, 32, 0, [
            qN,
            $M,
            ZM,
            pN,
            rN
        ])).length, 12, 1);
        this.i = xv(mw, Yyb, 26, Bv(tv(Kz, 1), uyb, 32, 0, [
            qN,
            $M,
            ZM,
            pN,
            rN
        ]).length, 12, 1);
        this.j = xv(kw, hyb, 26, Bv(tv(Kz, 1), uyb, 32, 0, [
            qN,
            $M,
            ZM,
            pN,
            rN
        ]).length, 12, 1);
        this.n = xv(kw, hyb, 26, Bv(tv(Kz, 1), uyb, 32, 0, [
            qN,
            $M,
            ZM,
            pN,
            rN
        ]).length, 12, 1);
        this.g = xv(Hz, uyb, 100, Bv(tv(Kz, 1), uyb, 32, 0, [
            qN,
            $M,
            ZM,
            pN,
            rN
        ]).length, 0, 1);
        this.c = new vsb(Oz);
        this.e = a;
        $ob(this.o);
        $ob(this.i);
        Yob(this.n, 0);
    }
    function _Q(a, b) {
        var c, d, e, f, g, h, i, j, k, l;
        g = b.i != null && !b.b;
        g || nI(b, 'Component Layout', 1);
        c = Wv(rJ(a, (Rib(), Fib)), 20);
        f = 1 / c.Y();
        if (Ckb(Ixb(Xv(rJ(a, (eM(), rL)))))) {
            l = 0;
            for(k = c.mb(); k.G();){
                j = Wv(k.H(), 31);
                ++l;
                Jkb(tb(j));
                j.sc(a, rI(b, f));
            }
        } else for(k = c.mb(); k.G();){
            j = Wv(k.H(), 31);
            j.sc(a, rI(b, f));
        }
        for(e = new Tob(a.c); e.a < e.c.c.length;){
            d = Wv(Rob(e), 16);
            xU(a.b, d.a);
            d.a.c = xv(UF, syb, 1, 0, 4, 1);
        }
        for(i = new Tob(a.b); i.a < i.c.c.length;){
            h = Wv(Rob(i), 9);
            rX(h, null);
        }
        a.c.c = xv(UF, syb, 1, 0, 4, 1);
        g || pI(b);
    }
    function S9(a, b) {
        var c, d, e, f, g, h, i, j, k, l, m;
        for(g = new Tob(b); g.a < g.c.c.length;){
            e = Wv(Rob(g), 102);
            e.e = null;
            e.c = 0;
        }
        h = null;
        for(f = new Tob(b); f.a < f.c.c.length;){
            e = Wv(Rob(f), 102);
            k = e.d[0];
            for(m = Wv(rJ(k, (Rib(), oib)), 20).mb(); m.G();){
                l = Wv(m.H(), 9);
                (!e.e && (e.e = new GU), e.e).ib(a.b[l.d.k][l.k]);
                ++a.b[l.d.k][l.k].c;
            }
            if (k.g == (CX(), AX)) {
                if (h) for(j = An(new Bn(a.c, h), 0); j.c;){
                    i = Wv(ko(j), 9);
                    for(d = An(new Bn(a.c, k), 0); d.c;){
                        c = Wv(ko(d), 9);
                        Y9(a.b[i.d.k][i.k]).ib(a.b[c.d.k][c.k]);
                        ++a.b[c.d.k][c.k].c;
                    }
                }
                h = k;
            }
        }
    }
    function gQ(a, b, c, d) {
        var e, f, g, h, i, j;
        SP(b);
        f = Wv(rJ(d, (Rib(), jib)), 18);
        h = (eM(), KL).b;
        if (h in b.a && Pu(b, h).ic().a) return;
        i = new RX;
        sJ(i, uib, b);
        PX(i, c);
        g = Wv(Pu(b, 'id'), 97);
        Vmb(a.k, g.a, i);
        Umb(a.n, i, b);
        _P(b, i);
        hQ(b, i);
        dQ(a, b, i, d);
        QX(i, Wv(rJ(i, WL), 32));
        j = Wv(rJ(c, TL), 28);
        j == (KM(), JM) && (j = IM);
        e = Wv(rJ(d, sL), 59);
        e == (sK(), qK) && (e = pK);
        RW(i, j, e, Wv(rJ(i, SL), 10));
        switch(e.e){
            case 2:
            case 1:
                (i.g == (sN(), $M) || i.g == pN) && f.ib((ohb(), lhb));
                break;
            case 4:
            case 3:
                (i.g == (sN(), ZM) || i.g == rN) && f.ib((ohb(), lhb));
        }
    }
    function Q5(a, b) {
        var c, d, e, f, g, h, i, j;
        a.f = b;
        e = b.c.c.length;
        a.a = xv(qB, Txb, 51, e, 0, 2);
        a.d = xv(qB, Txb, 51, e, 0, 2);
        a.g = xv(qB, Txb, 51, e, 0, 2);
        g = new Fnb(b.c, 0);
        while(g.b < g.d.Y()){
            d = (Bxb(g.b < g.d.Y()), Wv(g.d.sb(g.c = g.b++), 16));
            h = d.a.c.length;
            f = g.b - 1;
            a.a[f] = xv(qB, Nzb, 9, h, 0, 1);
            a.d[f] = xv(qB, Nzb, 9, h, 0, 1);
            a.g[f] = xv(qB, Nzb, 9, h, 0, 1);
            j = new Fnb(d.a, 0);
            c = 0;
            while(j.b < j.d.Y()){
                i = (Bxb(j.b < j.d.Y()), Wv(j.d.sb(j.c = j.b++), 9));
                i.k = c++;
                a.d[f][j.b - 1] = i;
                a.a[f][j.b - 1] = i;
                a.g[f][j.b - 1] = i;
            }
        }
        a.b = new _4(a.d);
        a.e.c && (a.b.e = true);
    }
    function gZ(a) {
        var b, c, d, e, f, g;
        e = new GU;
        for(g = new Tob(a.c.f); g.a < g.c.c.length;){
            f = Wv(Rob(g), 7);
            f.g == (sN(), ZM) && (e.c[e.c.length] = f);
        }
        if (a.d.a == (sK(), pK) && !MM(Wv(rJ(a.c, (eM(), TL)), 28))) for(d = Uh(mX(a.c)); Cm(d);){
            c = Wv(Dm(d), 12);
            vU(e, c.c);
        }
        sJ(a.c, (Rib(), Whb), new llb(a.c.j.a));
        sJ(a.c, Vhb, (xkb(), xkb(), wkb));
        vU(a.b, a.c);
        b = null;
        a.e == 1 ? b = jZ(a, a.c, rY(a.c.d), a.c.j.a) : a.e == 0 ? b = iZ(a, a.c, rY(a.c.d), a.c.j.a) : a.e == 3 ? b = kZ(a, a.c, a.c.j.a) : a.e == 2 && (b = hZ(a, a.c, a.c.j.a));
        !!b && new HY(a.c, a.b, Ixb(Yv(b.b)));
    }
    function Mab(a, b, c) {
        var d, e, f, g, h, i, j, k;
        e = b.g;
        Ckb(Ixb(Xv(rJ(b, (Rib(), Vhb))))) && (e = (CX(), wX));
        if (b.k >= 0) return false;
        else if (!!c.e && e == (CX(), wX) && e != c.e) return false;
        else {
            b.k = c.b;
            vU(c.f, b);
        }
        c.e = e;
        if (e == (CX(), zX) || e == BX || e == wX) for(g = new Tob(b.f); g.a < g.c.c.length;){
            f = Wv(Rob(g), 7);
            for(k = (d = new Tob(new lY(f).a.e), new nY(d)); Qob(k.a);){
                j = Wv(Rob(k.a), 12).d;
                h = j.f;
                i = h.g;
                if (b.d != h.d) {
                    if (e == wX) {
                        if (i == wX) {
                            if (Mab(a, h, c)) return true;
                        }
                    } else if (i == zX || i == BX) {
                        if (Mab(a, h, c)) return true;
                    }
                }
            }
        }
        return true;
    }
    function K3(a, b) {
        var c, d, e, f, g, h, i, j, k;
        fJ(a.a, Bv(tv(qz, 1), Fzb, 10, 0, [
            b.a,
            b.b
        ]));
        Ue(a.c, b.e);
        a.q.d = a.q.d | b.d;
        a.q.a = a.q.a | b.c;
        h = Qlb(a.j.e, b.k);
        i = Nlb(a.j.e + a.j.b, b.n);
        SN(a.j, b.j, h, 0, i - h);
        stb(a.d, b.f);
        b.f.c.f == b.f.d.f && wS(a.n, true, true, true, true);
        g = new vtb;
        j = new vtb;
        for(e = (k = new Snb(a.d.a).a.bb().mb(), new Ynb(k)); e.a.G();){
            d = (f = Wv(e.a.H(), 21), Wv(f.yb(), 12));
            stb(g, d.c);
            stb(j, d.d);
        }
        c = g.a.Y() - j.a.Y();
        if (c < 0) {
            vS(a.n, true, (sK(), oK));
            vS(a.n, false, pK);
        } else if (c > 0) {
            vS(a.n, false, (sK(), oK));
            vS(a.n, true, pK);
        }
    }
    function tP(b, c) {
        var d, e, f, g, h, i, j, k, l, m;
        h = 0;
        while(h < (bmb(), c.length) && yP(c.charCodeAt(h), fzb))++h;
        d = c.length;
        while(d > 0 && yP(c.charCodeAt(d - 1), gzb))--d;
        if (h < d) {
            l = fmb(c.substr(h, d - h), ',|;');
            try {
                for(j = 0, k = l.length; j < k; ++j){
                    i = l[j];
                    g = fmb(i, '=');
                    if (g.length != 2) throw new slb('Expecting a list of key-value pairs.');
                    f = hmb(g[0]);
                    m = clb(hmb(g[1]));
                    emb(f, 'top') ? b.d = m : emb(f, 'left') ? b.b = m : emb(f, Azb) ? b.a = m : emb(f, 'right') && (b.c = m);
                }
            } catch (a) {
                a = OH(a);
                if (aw(a, 130)) {
                    e = a;
                    throw new slb(hzb + e);
                } else throw NH(a);
            }
        }
    }
    function Ubb(a, b) {
        var c, d, e, f, g, h, i, j, k;
        k = new aJ;
        for(h = (j = new aob(a.c).a.bb().mb(), new fob(j)); h.a.G();){
            f = (e = Wv(h.a.H(), 21), Wv(e.zb(), 200));
            f.b == 0 && TI(k, f, k.c.b, k.c);
        }
        while(k.b != 0){
            f = Wv(k.b == 0 ? null : (Bxb(k.b != 0), $I(k, k.a.a)), 200);
            for(d = new Tob(f.d); d.a < d.c.c.length;){
                c = Wv(Rob(d), 279);
                b.k == (Lbb(), Jbb) ? c.b.a = Qlb(c.b.a, f.a + c.a) : c.b.a = Nlb(c.b.a, f.a + c.a);
                --c.b.b;
                c.b.b == 0 && QI(k, c.b);
            }
        }
        for(g = (i = new aob(a.c).a.bb().mb(), new fob(i)); g.a.G();){
            f = (e = Wv(g.a.H(), 21), Wv(e.zb(), 200));
            b.g[f.c.k] = f.a;
        }
    }
    function yZ(a, b, c) {
        var d, e, f, g;
        f = a.i;
        e = MI(Bv(tv(qz, 1), Fzb, 10, 0, [
            b.i,
            b.f.i
        ]));
        d = MI(Bv(tv(qz, 1), Fzb, 10, 0, [
            b.f.i,
            b.i,
            b.a
        ]));
        g = b.d;
        switch(b.g.e){
            case 4:
                f.a = Qlb(e.a, d.a) - g.b - a.j.a - c;
                f.b = MI(Bv(tv(qz, 1), Fzb, 10, 0, [
                    b.f.i,
                    b.i,
                    b.a
                ])).b + c;
                break;
            case 2:
                f.a = Nlb(e.a + b.j.a, d.a) + g.c + c;
                f.b = MI(Bv(tv(qz, 1), Fzb, 10, 0, [
                    b.f.i,
                    b.i,
                    b.a
                ])).b + c;
                break;
            case 1:
                f.a = MI(Bv(tv(qz, 1), Fzb, 10, 0, [
                    b.f.i,
                    b.i,
                    b.a
                ])).a + c;
                f.b = Qlb(e.b, d.b) - g.d - a.j.b - c;
                break;
            case 3:
                f.a = MI(Bv(tv(qz, 1), Fzb, 10, 0, [
                    b.f.i,
                    b.i,
                    b.a
                ])).a + c;
                f.b = Nlb(e.b + b.j.b, d.b) + g.a + c;
        }
    }
    function zZ(a, b, c) {
        var d, e, f, g;
        f = a.i;
        e = MI(Bv(tv(qz, 1), Fzb, 10, 0, [
            b.i,
            b.f.i
        ]));
        d = MI(Bv(tv(qz, 1), Fzb, 10, 0, [
            b.f.i,
            b.i,
            b.a
        ]));
        g = b.d;
        switch(b.g.e){
            case 4:
                f.a = Qlb(e.a, d.a) - g.b - a.j.a - c;
                f.b = MI(Bv(tv(qz, 1), Fzb, 10, 0, [
                    b.f.i,
                    b.i,
                    b.a
                ])).b - a.j.b - c;
                break;
            case 2:
                f.a = Nlb(e.a + b.j.a, d.a) + g.c + c;
                f.b = MI(Bv(tv(qz, 1), Fzb, 10, 0, [
                    b.f.i,
                    b.i,
                    b.a
                ])).b - a.j.b - c;
                break;
            case 1:
                f.a = MI(Bv(tv(qz, 1), Fzb, 10, 0, [
                    b.f.i,
                    b.i,
                    b.a
                ])).a + c;
                f.b = Qlb(e.b, d.b) - g.d - a.j.b - c;
                break;
            case 3:
                f.a = MI(Bv(tv(qz, 1), Fzb, 10, 0, [
                    b.f.i,
                    b.i,
                    b.a
                ])).a + c;
                f.b = Nlb(e.b + b.j.b, d.b) + g.a + c;
        }
    }
    function MQ(a) {
        var b, c;
        c = Wv(rJ(a, (Rib(), jib)), 18);
        b = XQ(HQ);
        Ckb(Ixb(Xv(rJ(a, (Mjb(), rjb))))) ? RQ(b, (d0(), W_)) : TQ(b, (d0(), W_));
        rJ(a, (bK(), aK)) != null && QQ(b, IQ);
        switch(Wv(rJ(a, (eM(), sL)), 59).e){
            case 2:
                PQ(RQ(b, (d0(), L_)), K_);
                break;
            case 3:
                PQ(RQ(b, (d0(), o_)), n_);
                break;
            case 4:
                PQ(RQ(b, (d0(), c0)), b0);
        }
        c.kb((ohb(), fhb)) && PQ(RQ(b, (d0(), m_)), l_);
        gw(rJ(a, Bjb)) !== gw((I1(), G1)) && TQ(b, (d0(), P_));
        gw(rJ(a, Fjb)) !== gw((g4(), e4)) && gw(rJ(a, eib)) === gw((NK(), JK)) && PQ(b, (d0(), w_));
        if (c.kb(mhb)) {
            RQ(b, (d0(), T_));
            TQ(b, S_);
        }
        return b;
    }
    function zhb() {
        zhb = iI;
        shb = new Ahb('ONE_SIDED', 0, true, false, false);
        whb = new Ahb('TWO_SIDED', 1, false, false, false);
        thb = new Ahb('ONE_SIDED_BEST_OF_UP_OR_DOWN', 2, true, true, false);
        xhb = new Ahb('TWO_SIDED_BEST_OF_UP_OR_DOWN', 3, false, true, false);
        uhb = new Ahb('ONE_SIDED_BEST_OF_UP_OR_DOWN_ORTHOGONAL_HYPEREDGES', 4, true, true, true);
        yhb = new Ahb('TWO_SIDED_BEST_OF_UP_OR_DOWN_ORTHOGONAL_HYPEREDGES', 5, false, true, true);
        vhb = new Ahb('ONE_SIDED_ORTHOGONAL_HYPEREDGES', 6, true, false, true);
        rhb = new Ahb('OFF', 7, false, false, false);
    }
    function LV(a, b, c, d, e, f, g) {
        var h, i, j, k, l, m, n;
        l = Ckb(Ixb(Xv(rJ(b, (Mjb(), yjb)))));
        m = null;
        f == (djb(), ajb) && d.c.f == c ? m = d.c : f == bjb && d.d.f == c && (m = d.d);
        j = g;
        if (!g || !l || !!m) {
            k = (sN(), qN);
            m ? k = m.g : MM(Wv(rJ(c, (eM(), TL)), 28)) && (k = f == ajb ? rN : ZM);
            i = JV(a, b, c, f, k, d);
            h = IV((hX(c), d));
            if (f == ajb) {
                dW(h, Wv(yU(i.f, 0), 7));
                eW(h, e);
            } else {
                dW(h, e);
                eW(h, Wv(yU(i.f, 0), 7));
            }
            j = new UV(d, h, i, Wv(rJ(i, (Rib(), uib)), 7), f, !m);
        } else {
            vU(g.e, d);
            n = Olb(Wv(rJ(g.d, (eM(), dM)), 15).a, Wv(rJ(d, dM), 15).a);
            sJ(g.d, dM, new llb(n));
        }
        Fd(a.a, d, new XV(j.d, b, f));
        return j;
    }
    function T1(a, b, c, d) {
        var e, f, g, h, i, j, k, l;
        f = new uX(a);
        sX(f, (CX(), BX));
        sJ(f, (eM(), TL), (KM(), FM));
        e = 0;
        if (b) {
            g = new RX;
            sJ(g, (Rib(), uib), b);
            sJ(f, uib, b.f);
            QX(g, (sN(), rN));
            PX(g, f);
            l = Wv(FU(b.b, xv(dB, gAb, 12, b.b.c.length, 0, 1)), 47);
            for(j = 0, k = l.length; j < k; ++j){
                i = l[j];
                eW(i, g);
            }
            sJ(b, Bib, f);
            ++e;
        }
        if (c) {
            h = new RX;
            sJ(f, (Rib(), uib), c.f);
            sJ(h, uib, c);
            QX(h, (sN(), ZM));
            PX(h, f);
            l = Wv(FU(c.e, xv(dB, gAb, 12, c.e.c.length, 0, 1)), 47);
            for(j = 0, k = l.length; j < k; ++j){
                i = l[j];
                dW(i, h);
            }
            sJ(c, Bib, f);
            ++e;
        }
        sJ(f, (Rib(), aib), Elb(e));
        d.c[d.c.length] = f;
        return f;
    }
    function MV(a, b) {
        var c, d, e, f, g, h, i;
        for(g = ud(a.a).mb(); g.G();){
            f = Wv(g.H(), 12);
            if (f.b.c.length > 0) {
                d = new IU(Wv(Dd(a.a, f), 18));
                Gpb(d, new $V(b));
                e = new Fnb(f.b, 0);
                while(e.b < e.d.Y()){
                    c = (Bxb(e.b < e.d.Y()), Wv(e.d.sb(e.c = e.b++), 33));
                    h = -1;
                    switch(Wv(rJ(c, (eM(), tL)), 107).e){
                        case 2:
                            h = d.c.length - 1;
                            break;
                        case 1:
                            h = d.c.length / 2 | 0;
                            break;
                        case 3:
                            h = 0;
                    }
                    if (h != -1) {
                        i = (Cxb(h, d.c.length), Wv(d.c[h], 114));
                        vU(i.b.b, c);
                        Wv(rJ(hX(i.b.c.f), (Rib(), jib)), 18).ib((ohb(), ghb));
                        Wv(rJ(hX(i.b.c.f), jib), 18).ib(ehb);
                        vnb(e);
                        sJ(c, xib, f);
                    }
                }
            }
            dW(f, null);
            eW(f, null);
        }
    }
    function H7(a) {
        var b, c, d, e, f, g, h, i, j, k, l;
        k = a.e.a.c.length;
        for(g = new Tob(a.e.a); g.a < g.c.c.length;){
            f = Wv(Rob(g), 61);
            f.j = false;
        }
        a.i = xv(mw, Yyb, 26, k, 12, 1);
        a.g = xv(mw, Yyb, 26, k, 12, 1);
        a.n = new GU;
        e = 0;
        l = new GU;
        for(i = new Tob(a.e.a); i.a < i.c.c.length;){
            h = Wv(Rob(i), 61);
            h.b = e++;
            h.c.c.length == 0 && vU(a.n, h);
            xU(l, h.g);
        }
        b = 0;
        for(d = new Tob(l); d.a < d.c.c.length;){
            c = Wv(Rob(d), 89);
            c.b = b++;
            c.e = false;
        }
        j = l.c.length;
        if (a.b == null || a.b.length < j) {
            a.b = xv(kw, hyb, 26, j, 12, 1);
            a.c = xv(KH, xAb, 26, j, 13, 1);
        } else dpb(a.c);
        a.d = l;
        a.p = new Xub(op(a.d.c.length));
        a.j = 1;
    }
    function z0(a, b) {
        var c, d, e, f, g, h, i, j, k, l, m, n, o1, p, q, r, s, t, u;
        p = a.d;
        q = b.d;
        n = Wv(oX(a, (djb(), ajb)).mb().H(), 7);
        t = Wv(oX(a, bjb).mb().H(), 7);
        o1 = Wv(oX(b, ajb).mb().H(), 7);
        u = Wv(oX(b, bjb).mb().H(), 7);
        l = Wv(FU(n.b, xv(dB, gAb, 12, 1, 0, 1)), 47);
        r = Wv(FU(t.e, xv(dB, gAb, 12, 1, 0, 1)), 47);
        m = Wv(FU(o1.b, xv(dB, gAb, 12, 1, 0, 1)), 47);
        s = Wv(FU(u.e, xv(dB, gAb, 12, 1, 0, 1)), 47);
        rX(a, q);
        for(e = 0, i = m.length; e < i; ++e){
            c = m[e];
            eW(c, n);
        }
        for(f = 0, j = s.length; f < j; ++f){
            c = s[f];
            dW(c, t);
        }
        rX(b, p);
        for(g = 0, k = l.length; g < k; ++g){
            c = l[g];
            eW(c, o1);
        }
        for(d = 0, h = r.length; d < h; ++d){
            c = r[d];
            dW(c, u);
        }
    }
    function gR(a) {
        var b, c, d, e, f, g, h, i;
        for(f = new Tob(a.a.b); f.a < f.c.c.length;){
            e = Wv(Rob(f), 25);
            e.vc();
        }
        i = new HI(Uzb, Uzb);
        b = new HI(Vzb, Vzb);
        for(d = new Tob(a.a.b); d.a < d.c.c.length;){
            c = Wv(Rob(d), 25);
            i.a = Qlb(i.a, c.j.d);
            i.b = Qlb(i.b, c.j.e);
            b.a = Nlb(b.a, c.j.d + c.j.c);
            b.b = Nlb(b.b, c.j.e + c.j.b);
        }
        for(h = Jd(a.c).mb(); h.G();){
            g = Wv(h.H(), 27);
            c = Wv(g.b, 25);
            i.a = Qlb(i.a, c.j.d);
            i.b = Qlb(i.b, c.j.e);
            b.a = Nlb(b.a, c.j.d + c.j.c);
            b.b = Nlb(b.b, c.j.e + c.j.b);
        }
        a.d = zI(new HI(i.a, i.b));
        a.e = EI(new HI(b.a, b.b), i);
        a.a.a.c = xv(UF, syb, 1, 0, 4, 1);
        a.a.b.c = xv(UF, syb, 1, 0, 4, 1);
    }
    function P$(a) {
        var b, c, d, e, f, g, h;
        h = Wv(yU(a.f, 0), 7);
        if (h.e.c.length != 0 && h.b.c.length != 0) throw new ulb('Interactive layout does not support NORTH/SOUTH ports with incoming _and_ outgoing edges.');
        if (h.e.c.length != 0) {
            f = Uzb;
            for(c = new Tob(h.e); c.a < c.c.c.length;){
                b = Wv(Rob(c), 12);
                g = b.d.f;
                d = Wv(rJ(g, (eM(), GL)), 65);
                f = Qlb(f, g.i.a - d.b);
            }
            return new $c(_b(f));
        }
        if (h.b.c.length != 0) {
            e = Vzb;
            for(c = new Tob(h.b); c.a < c.c.c.length;){
                b = Wv(Rob(c), 12);
                g = b.c.f;
                d = Wv(rJ(g, (eM(), GL)), 65);
                e = Nlb(e, g.i.a + g.j.a + d.c);
            }
            return new $c(_b(e));
        }
        return zb(), zb(), yb;
    }
    function JV(a, b, c, d, e, f) {
        var g, h, i, j, k, l, m;
        j = d == (djb(), ajb) ? f.c : f.d;
        i = PW(b);
        if (j.f == c) {
            g = Wv(Smb(a.b, j), 9);
            if (!g) {
                g = NW(j, Wv(rJ(c, (eM(), TL)), 28), e, d == ajb ? -1 : 1, j.j, i, b);
                sJ(g, (Rib(), uib), j);
                Umb(a.b, j, g);
            }
        } else {
            k = Wv(rJ(f, (eM(), dM)), 15).a;
            g = NW((l = new tJ, m = Wv(rJ(b, (Rib(), Jib)), 15).a * Wv(rJ(b, (Mjb(), qjb)), 15).a / 2, sJ(l, tib, new llb(m)), l), Wv(rJ(c, TL), 28), e, d == ajb ? -1 : 1, new HI(k, k), i, b);
            h = KV(a, g, c, d);
            sJ(g, uib, h);
            Umb(a.b, h, g);
        }
        Wv(rJ(b, (Rib(), jib)), 18).ib((ohb(), hhb));
        MM(Wv(rJ(b, (eM(), TL)), 28)) ? sJ(b, TL, (KM(), HM)) : sJ(b, TL, (KM(), IM));
        return g;
    }
    function Iab(a, b) {
        var c, d, e, f, g, h, i, j, k, l, m, n, o1, p, q, r, s, t, u, v, w, A;
        d = Wv(rJ(b, (Mjb(), wjb)), 15).a;
        v = Wv(rJ(b, Kjb), 24).a;
        m = 4;
        e = 3;
        w = 20 / v;
        n = false;
        i = 0;
        g = $xb;
        do {
            f = i != 1;
            l = i != 0;
            A = 0;
            for(q = a.a, s = 0, u = q.length; s < u; ++s){
                o1 = q[s];
                o1.g = null;
                Jab(a, o1, f, l, d);
                A += Jlb(o1.a);
            }
            do h = Nab(a, b);
            while (h);
            for(p = a.a, r = 0, t = p.length; r < t; ++r){
                o1 = p[r];
                c = Uab(o1).a;
                if (c != 0) for(k = new Tob(o1.f); k.a < k.c.c.length;){
                    j = Wv(Rob(k), 9);
                    j.i.b += c;
                }
            }
            if (i == 0 || i == 1) {
                --m;
                if (m <= 0 && (A < g || -m > v)) {
                    i = 2;
                    g = $xb;
                } else if (i == 0) {
                    i = 1;
                    g = A;
                } else {
                    i = 0;
                    g = A;
                }
            } else {
                n = A >= g || g - A < w;
                g = A;
                n && --e;
            }
        }while (!(n && e <= 0));
    }
    function vZ(a, b, c) {
        var d, e, f, g, h, i, j, k, l, m, n;
        l = Wv(FU(a.f, xv(BB, mAb, 7, a.f.c.length, 0, 1)), 346);
        for(j = 0, k = l.length; j < k; ++j){
            i = l[j];
            if (c != (djb(), ajb)) {
                h = Wv(FU(i.e, xv(dB, gAb, 12, i.e.c.length, 0, 1)), 47);
                for(e = 0, f = h.length; e < f; ++e){
                    d = h[e];
                    n = Wv(rJ(d.d.f, (Mjb(), vjb)), 85);
                    !Ckb(Ixb(Xv(rJ(d, (Rib(), Iib))))) && !(b == (Xib(), Uib) && n == Vib) && cW(d, true);
                }
            }
            if (c != bjb) {
                g = Wv(FU(i.b, xv(dB, gAb, 12, i.b.c.length, 0, 1)), 47);
                for(e = 0, f = g.length; e < f; ++e){
                    d = g[e];
                    m = Wv(rJ(d.c.f, (Mjb(), vjb)), 85);
                    !Ckb(Ixb(Xv(rJ(d, (Rib(), Iib))))) && !(b == (Xib(), Sib) && m == Tib) && cW(d, true);
                }
            }
        }
    }
    function RW(a, b, c, d) {
        var e, f, g, h, i;
        g = a.g;
        if (g == (sN(), qN) && b != (KM(), IM) && b != (KM(), JM)) {
            g = KW(a, c);
            QX(a, g);
            rJ(a, (eM(), LL)) == null && g != qN && (a.i.a != 0 || a.i.b != 0) && sJ(a, LL, new llb(JW(a, g)));
        }
        if (b == (KM(), GM)) {
            i = 0;
            switch(g.e){
                case 1:
                case 3:
                    f = a.f.j.a;
                    f > 0 && (i = a.i.a / f);
                    break;
                case 2:
                case 4:
                    e = a.f.j.b;
                    e > 0 && (i = a.i.b / e);
            }
            sJ(a, (Rib(), Cib), i);
        }
        h = a.j;
        if (d) {
            a.a.a = d.a;
            a.a.b = d.b;
        } else if (b != IM && b != JM && g != qN) switch(g.e){
            case 1:
                a.a.a = h.a / 2;
                break;
            case 2:
                a.a.a = h.a;
                a.a.b = h.b / 2;
                break;
            case 3:
                a.a.a = h.a / 2;
                a.a.b = h.b;
                break;
            case 4:
                a.a.b = h.b / 2;
        }
        else {
            a.a.a = h.a / 2;
            a.a.b = h.b / 2;
        }
    }
    function zJ(a) {
        var b, c, d, e;
        if (aw(a.a, 10)) return xI(Wv(a.a, 10));
        else if (aw(a.a, 66)) return Xsb(Wv(a.a, 86));
        else if (aw(a.a, 50)) return Wv(a.a, 50).Wc();
        else if (aw(a.a, 191)) {
            b = new Vwb;
            e = (d = new rwb(new wwb(new Gob(Wv(a.a, 191).a).a).b), new Mob(d));
            while(Bnb(e.a.a))Rwb(b, (c = pwb(e.a), c.yb()));
            return b;
        } else if (aw(a.a, 13)) return new IU(Wv(a.a, 13));
        else if (aw(a.a, 44)) {
            b = new jJ;
            e = WI(Wv(a.a, 44), 0);
            while(e.b != e.d.c)QI(b, Wv(_ub(e), 10));
            return b;
        } else if (aw(a.a, 58)) {
            b = new aJ;
            e = WI(Wv(a.a, 58), 0);
            while(e.b != e.d.c)QI(b, _ub(e));
            return b;
        } else return a.a;
    }
    function o1(a, b) {
        var c, d, e, f, g, h, i, j, k, l, m, n, o1;
        h = 0;
        o1 = 0;
        i = Xob(a.f, a.f.length);
        f = a.d;
        g = a.i;
        d = a.a;
        e = a.b;
        do {
            n = 0;
            for(k = new Tob(a.p); k.a < k.c.c.length;){
                j = Wv(Rob(k), 9);
                m = n1(a, j);
                c = true;
                (a.q == (I1(), B1) || a.q == E1) && (c = Ckb(Ixb(Xv(m.b))));
                if (Wv(m.a, 24).a < 0 && c) {
                    ++n;
                    i = Xob(a.f, a.f.length);
                    a.d = a.d + Wv(m.a, 24).a;
                    o1 += f - a.d;
                    f = a.d + Wv(m.a, 24).a;
                    g = a.i;
                    d = Ao(a.a);
                    e = Ao(a.b);
                } else {
                    a.f = Xob(i, i.length);
                    a.d = f;
                    a.a = (_b(d), d ? new IU((Oh(), d)) : Bo(new Tob(null)));
                    a.b = (_b(e), e ? new IU((Oh(), e)) : Bo(new Tob(null)));
                    a.i = g;
                }
            }
            ++h;
            l = n != 0 && Ckb(Ixb(Xv(b.B(new RJ(Elb(o1), Elb(h))))));
        }while (l);
    }
    function yO(a, b, c, d) {
        var e, f, g, h, i, j, k;
        if (!Qob(new Tob(zW(a)))) return d;
        k = wO(Wv(oW(a, (eM(), JL)), 86));
        for(i = new Tob(zW(a)); i.a < i.c.c.length;){
            h = Wv(Rob(i), 129);
            j = wO(Wv(oW(h, JL), 86));
            j == (uO(), tO) && (j = k);
            qW(h, j.e);
            e = zO(c, j);
            e.c = Nlb(e.c, h.e.j.a);
            e.b += h.e.j.b + b;
        }
        for(g = new Lsb(new Fsb(c).a); htb(g.a);){
            f = (g.b = itb(g.a), new Psb(g.c, g.b));
            e = Wv(f.b.b[f.a.e], 62);
            e.b -= b;
            switch(Wv(f.a, 67).e){
                case 12:
                case 13:
                case 14:
                    d.d = Nlb(d.d, e.b + b);
                    break;
                case 15:
                    d.b = Nlb(d.b, e.c + b);
                    break;
                case 17:
                    d.c = Nlb(d.c, e.c + b);
                    break;
                case 18:
                case 19:
                case 20:
                    d.a = Nlb(d.a, e.b + b);
            }
        }
        return d;
    }
    function mgb(a, b, c) {
        var d, e, f, g, h, i, j, k, l, m, n, o1, p;
        igb(this);
        c == (fgb(), dgb) ? stb(this.g, a) : stb(this.o, a);
        n = rAb;
        m = 4.9E-324;
        for(j = (g = new Snb(b.a).a.bb().mb(), new Ynb(g)); j.a.G();){
            h = (e = Wv(j.a.H(), 21), Wv(e.yb(), 27));
            k = Wv(h.a, 223);
            d = Wv(h.b, 12);
            l = d.c;
            l == a && (l = d.d);
            k == dgb ? stb(this.g, l) : stb(this.o, l);
            p = MI(Bv(tv(qz, 1), Fzb, 10, 0, [
                l.f.i,
                l.i,
                l.a
            ])).b;
            n = n < p ? n : p;
            m = m > p ? m : p;
        }
        o1 = MI(Bv(tv(qz, 1), Fzb, 10, 0, [
            a.f.i,
            a.i,
            a.a
        ])).b;
        kgb(this, o1, n, m);
        for(i = (f = new Snb(b.a).a.bb().mb(), new Ynb(f)); i.a.G();){
            h = (e = Wv(i.a.H(), 21), Wv(e.yb(), 27));
            stb(this.c, Wv(h.b, 12));
        }
        this.f = false;
    }
    function cQ(a, b, c, d) {
        var e, f, g, h, i, j;
        h = (eM(), KL).b;
        if (h in b.a && Pu(b, h).ic().a) return;
        j = Pu(b, Dzb);
        if (!j) throw new GQ("Labels must have a property 'text'.", null, b);
        else if (!j.lc()) throw new GQ("A label's 'text' property must be a string.", j, b);
        i = j.lc().a;
        f = new dX(i);
        sJ(f, (Rib(), uib), b);
        Umb(a.f, f, b);
        _P(b, f);
        hQ(b, f);
        aw(c, 9) ? vU(Wv(c, 9).c, f) : aw(c, 12) ? vU(Wv(c, 12).b, f) : aw(c, 7) && vU(Wv(c, 7).c, f);
        if (aw(c, 12)) {
            g = Wv(rJ(f, tL), 107);
            _P(b, f);
            sJ(f, tL, g);
            e = Wv(rJ(d, jib), 18);
            switch(g.e){
                case 2:
                case 3:
                    e.ib((ohb(), ghb));
                case 1:
                case 0:
                    e.ib((ohb(), ehb));
                    sJ(f, tL, (EK(), AK));
            }
        }
    }
    function UW(a, b) {
        var c, d, e, f, g, h, i, j, k, l, m, n, o1, p, q, r;
        f = 0;
        g = 0;
        for(j = new Tob(a.a); j.a < j.c.c.length;){
            h = Wv(Rob(j), 9);
            f = Nlb(f, h.e.b);
            g = Nlb(g, h.e.c);
        }
        for(i = new Tob(a.a); i.a < i.c.c.length;){
            h = Wv(Rob(i), 9);
            c = Wv(rJ(h, (eM(), lL)), 103);
            switch(c.e){
                case 1:
                    o1 = 0;
                    break;
                case 2:
                    o1 = 1;
                    break;
                case 5:
                    o1 = 0.5;
                    break;
                default:
                    d = 0;
                    l = 0;
                    for(n = new Tob(h.f); n.a < n.c.c.length;){
                        m = Wv(Rob(n), 7);
                        m.b.c.length == 0 || ++d;
                        m.e.c.length == 0 || ++l;
                    }
                    d + l == 0 ? o1 = 0.5 : o1 = l / (d + l);
            }
            q = a.c;
            k = h.j.a;
            r = (q.a - k) * o1;
            o1 > 0.5 ? r -= g * 2 * (o1 - 0.5) : o1 < 0.5 && (r += f * 2 * (0.5 - o1));
            e = h.e.b;
            r < e && (r = e);
            p = h.e.c;
            r > q.a - p - k && (r = q.a - p - k);
            h.i.a = b + r;
        }
    }
    function Kv(a, b) {
        var c, d, e, f, g, h, i, j, k, l, m, n, o1, p, q, r, s, t, u, v, w, A, B, C, D, F, G;
        c = a.l & 8191;
        d = a.l >> 13 | (a.m & 15) << 9;
        e = a.m >> 4 & 8191;
        f = a.m >> 17 | (a.h & 255) << 5;
        g = (a.h & 1048320) >> 8;
        h = b.l & 8191;
        i = b.l >> 13 | (b.m & 15) << 9;
        j = b.m >> 4 & 8191;
        k = b.m >> 17 | (b.h & 255) << 5;
        l = (b.h & 1048320) >> 8;
        B = c * h;
        C = d * h;
        D = e * h;
        F = f * h;
        G = g * h;
        if (i != 0) {
            C += c * i;
            D += d * i;
            F += e * i;
            G += f * i;
        }
        if (j != 0) {
            D += c * j;
            F += d * j;
            G += e * j;
        }
        if (k != 0) {
            F += c * k;
            G += d * k;
        }
        l != 0 && (G += c * l);
        n = B & azb;
        o1 = (C & 511) << 13;
        m = n + o1;
        q = B >> 22;
        r = C >> 9;
        s = (D & 262143) << 4;
        t = (F & 31) << 17;
        p = q + r + s + t;
        v = D >> 18;
        w = F >> 5;
        A = (G & 4095) << 8;
        u = v + w + A;
        p += m >> 22;
        m &= azb;
        u += p >> 22;
        p &= azb;
        u &= bzb;
        return Ev(m, p, u);
    }
    function jZ(a, b, c, d) {
        var e, f, g, h, i, j, k, l, m, n, o1, p, q, r, s, t, u, v, w;
        q = a.d.c.c.c.length;
        if (c >= q - 1) return null;
        e = new GU;
        e.c[e.c.length] = b;
        u = b;
        g = c;
        o1 = -1;
        h = Wv(yU(a.d.c.c, c), 16);
        for(n = 0; n < h.a.c.length; ++n){
            r = Wv(yU(h.a, n), 9);
            if (r == b) {
                o1 = n;
                break;
            }
        }
        p = eZ(a, 1, o1, c, q, a.a);
        if (!p) return null;
        v = a.a;
        m = 0;
        f = 0;
        while(!!u && v > 1 && g < q - 1){
            k = fZ(a, u);
            l = Wv(yU(a.d.c.c, g + 1), 16);
            w = Wv(p.sb(m++), 24).a;
            s = Slb(w, l.a.c.length);
            qX(k, s, l);
            !!u && (e.c[e.c.length] = u);
            u = k;
            --v;
            ++f;
            ++g;
        }
        t = (d - (e.c.length - 1) * a.d.d) / e.c.length;
        for(j = new Tob(e); j.a < j.c.c.length;){
            i = Wv(Rob(j), 9);
            i.j.a = t;
        }
        return new RJ(Elb(f), t);
    }
    function iZ(a, b, c, d) {
        var e, f, g, h, i, j, k, l, m, n, o1, p, q, r, s, t, u, v, w;
        if (c <= 0) return null;
        e = new GU;
        e.c[e.c.length] = b;
        u = b;
        g = c;
        o1 = -1;
        h = Wv(yU(a.d.c.c, c), 16);
        for(n = 0; n < h.a.c.length; ++n){
            q = Wv(yU(h.a, n), 9);
            if (q == b) {
                o1 = n;
                break;
            }
        }
        p = eZ(a, 0, o1, c, a.d.c.c.c.length, a.a);
        if (!p) return null;
        v = a.a;
        m = 0;
        f = 0;
        t = o1;
        while(!!u && v > 1 && g > 1){
            k = fZ(a, u);
            h = Wv(yU(a.d.c.c, g), 16);
            l = Wv(yU(a.d.c.c, g - 1), 16);
            w = Wv(p.sb(m++), 24).a;
            r = Slb(w, l.a.c.length);
            qX(u, r, l);
            qX(k, t, h);
            t = r;
            !!u && (e.c[e.c.length] = u);
            u = k;
            --v;
            ++f;
            --g;
        }
        s = (d - (e.c.length - 1) * a.d.d) / e.c.length;
        for(j = new Tob(e); j.a < j.c.c.length;){
            i = Wv(Rob(j), 9);
            i.j.a = s;
        }
        return new RJ(Elb(f), s);
    }
    function sV(a, b) {
        var c, d, e, f, g, h, i, j, k, l, m, n, o1;
        a.b = a.c;
        o1 = Xv(rJ(b, (eM(), _L)));
        n = o1 == null || Ckb((Dxb(o1), o1));
        f = Wv(rJ(b, (Rib(), jib)), 18).kb((ohb(), hhb));
        e = Wv(rJ(b, TL), 28);
        c = !(e == (KM(), EM) || e == GM || e == FM);
        if (n && (c || !f)) {
            for(l = new Tob(b.b); l.a < l.c.c.length;){
                j = Wv(Rob(l), 9);
                j.k = 0;
            }
            m = new GU;
            for(k = new Tob(b.b); k.a < k.c.c.length;){
                j = Wv(Rob(k), 9);
                d = rV(a, j, null);
                if (d) {
                    i = new kW;
                    qJ(i, b);
                    sJ(i, fib, Wv(d.b, 18));
                    YW(i.a, b.a);
                    for(h = Wv(d.a, 20).mb(); h.G();){
                        g = Wv(h.H(), 9);
                        vU(i.b, g);
                        g.a = i;
                    }
                    m.ib(i);
                }
            }
            f && (a.b = a.a);
        } else m = new opb(Bv(tv(mB, 1), {
            38: 1,
            39: 1,
            42: 1,
            3: 1,
            8: 1,
            5: 1,
            6: 1
        }, 55, 0, [
            b
        ]));
        return m;
    }
    function T4(a) {
        var b, c, d, e, f, g, h, i, j;
        for(c = new Tob(a.a.a.b); c.a < c.c.c.length;){
            b = Wv(Rob(c), 25);
            for(g = b.i.mb(); g.G();){
                f = Wv(g.H(), 25);
                if (b.f == f.f) continue;
                tK(a.a.d) ? i = a.a.g.tc(b, f) : i = a.a.g.uc(b, f);
                d = b.g.a + b.j.c + i - f.g.a;
                d = Math.ceil(d);
                d = 0 > d ? 0 : d;
                if (!!b.o && !!f.o && aw(b, 82) && aw(f, 82) && !sr(or(Wv(b, 82).d, Wv(f, 82).d))) {
                    e = x7(new A7, a.d);
                    h = hw(Llb(f.g.a - b.g.a));
                    f7(i7(h7(j7(g7(new k7, 0 > h ? 0 : h), 1), e), a.c[b.f.d]));
                    f7(i7(h7(j7(g7(new k7, 0 > -h ? 0 : -h), 1), e), a.c[f.f.d]));
                } else {
                    j = 1;
                    (aw(b, 82) && aw(f, 93) || aw(f, 82) && aw(b, 93)) && (j = 2);
                    f7(i7(h7(j7(g7(new k7, hw(d)), j), a.c[b.f.d]), a.c[f.f.d]));
                }
            }
        }
    }
    function tQ() {
        tQ = iI;
        sQ = new vtb;
        rQ = uQ(Bv(tv(rz, 1), syb, 79, 0, [
            (eM(), kL),
            xL
        ]));
        oQ = uQ(Bv(tv(rz, 1), syb, 79, 0, [
            ML,
            UL,
            (Mjb(), Hjb),
            yL,
            (Rib(), Eib),
            Kjb,
            Cjb
        ]));
        kQ = uQ(Bv(tv(rz, 1), syb, 79, 0, [
            mL,
            qL,
            KL,
            wL,
            BL,
            EL,
            FL,
            $L,
            _L,
            AL,
            gjb,
            mjb,
            njb,
            xjb,
            rjb,
            yjb,
            Ijb,
            Djb,
            ijb
        ]));
        nQ = uQ(Bv(tv(rz, 1), syb, 79, 0, [
            IL,
            HL,
            DL,
            dM,
            LL,
            Dib,
            Xhb,
            Rhb,
            Jib,
            Ejb,
            qjb,
            wjb
        ]));
        mQ = uQ(Bv(tv(rz, 1), syb, 79, 0, [
            WL,
            lL,
            sL,
            uL,
            tL,
            vL,
            zL,
            NL,
            OL,
            PL,
            QL,
            RL,
            TL,
            VL,
            hjb,
            ljb,
            zjb,
            ojb,
            kjb,
            Ajb,
            Bjb,
            sjb,
            tjb,
            vjb,
            Fjb,
            Gjb,
            Jjb,
            Ljb,
            ujb
        ]));
        lQ = uQ(Bv(tv(rz, 1), syb, 79, 0, [
            JL,
            aM,
            bM,
            jjb
        ]));
        qQ = uQ(Bv(tv(rz, 1), syb, 79, 0, [
            jL,
            oL,
            CL,
            GL,
            SL,
            YL
        ]));
        pQ = uQ(Bv(tv(rz, 1), syb, 79, 0, [
            (RP(), OP)
        ]));
    }
    function AR(a) {
        var b, c, d, e, f, g, h;
        b = 0;
        for(f = new Tob(a.b.a); f.a < f.c.c.length;){
            d = Wv(Rob(f), 78);
            d.b = 0;
            d.c = 0;
        }
        zR(a, 0);
        yR(a, a.g);
        fS(a.c);
        jS(a.c);
        c = (sK(), oK);
        hS(bS(gS(hS(bS(gS(hS(gS(a.c, c)), vK(c)))), c)));
        gS(a.c, oK);
        DR(a, a.g);
        ER(a, 0);
        FR(a, 0);
        GR(a, 1);
        zR(a, 1);
        yR(a, a.d);
        fS(a.c);
        for(g = new Tob(a.b.a); g.a < g.c.c.length;){
            d = Wv(Rob(g), 78);
            b += Jlb(d.c);
        }
        for(h = new Tob(a.b.a); h.a < h.c.c.length;){
            d = Wv(Rob(h), 78);
            d.b = 0;
            d.c = 0;
        }
        c = rK;
        hS(bS(gS(hS(bS(gS(hS(jS(gS(a.c, c))), vK(c)))), c)));
        gS(a.c, oK);
        DR(a, a.d);
        ER(a, 1);
        FR(a, 1);
        GR(a, 0);
        jS(a.c);
        for(e = new Tob(a.b.a); e.a < e.c.c.length;){
            d = Wv(Rob(e), 78);
            b += Jlb(d.c);
        }
        return b;
    }
    function BR(a) {
        var b, c, d, e, f, g, h;
        b = new GU;
        a.g = new GU;
        a.d = new GU;
        for(g = new rnb(new inb(a.f.b).a); g.b;){
            f = pnb(g);
            vU(b, Wv(Wv(f.zb(), 27).b, 25));
            tK(Wv(f.yb(), 251).yc()) ? vU(a.d, Wv(f.zb(), 27)) : vU(a.g, Wv(f.zb(), 27));
        }
        yR(a, a.d);
        yR(a, a.g);
        a.c = new rS(a.b);
        pS(a.c, (fR(), eR));
        DR(a, a.d);
        DR(a, a.g);
        xU(b, a.c.a.b);
        a.e = new HI(Uzb, Uzb);
        a.a = new HI(Vzb, Vzb);
        for(d = new Tob(b); d.a < d.c.c.length;){
            c = Wv(Rob(d), 25);
            a.e.a = Qlb(a.e.a, c.j.d);
            a.e.b = Qlb(a.e.b, c.j.e);
            a.a.a = Nlb(a.a.a, c.j.d + c.j.c);
            a.a.b = Nlb(a.a.b, c.j.e + c.j.b);
        }
        oS(a.c, new IR);
        h = 0;
        do {
            e = AR(a);
            ++h;
        }while ((h < 2 || e > $yb) && h < 10);
        oS(a.c, new KR);
        AR(a);
        iS(a.c);
        gR(a.f);
    }
    function tT(a) {
        oT();
        var b, c, d, e, f, g, h;
        h = new qT;
        for(c = new Tob(a); c.a < c.c.c.length;){
            b = Wv(Rob(c), 48);
            (!h.b || b.c >= h.b.c) && (h.b = b);
            if (!h.c || b.c <= h.c.c) {
                h.d = h.c;
                h.c = b;
            }
            (!h.e || b.d >= h.e.d) && (h.e = b);
            (!h.f || b.d <= h.f.d) && (h.f = b);
        }
        d = new xT((cT(), $S));
        RT(a, mT, new opb(Bv(tv(JA, 1), syb, 160, 0, [
            d
        ])));
        g = new xT(bT);
        RT(a, lT, new opb(Bv(tv(JA, 1), syb, 160, 0, [
            g
        ])));
        e = new xT(_S);
        RT(a, kT, new opb(Bv(tv(JA, 1), syb, 160, 0, [
            e
        ])));
        f = new xT(aT);
        RT(a, jT, new opb(Bv(tv(JA, 1), syb, 160, 0, [
            f
        ])));
        rT(d.c, $S);
        rT(e.c, _S);
        rT(f.c, aT);
        rT(g.c, bT);
        h.a.c = xv(UF, syb, 1, 0, 4, 1);
        xU(h.a, d.c);
        xU(h.a, Fo(e.c));
        xU(h.a, f.c);
        xU(h.a, Fo(g.c));
        return h;
    }
    function $O(a) {
        var b, c, d, e, f, g, h, i, j, k;
        e = Wv(vW(a, (eM(), DL)), 15).a;
        for(h = new Tob(uW(a)); h.a < h.c.c.length;){
            g = Wv(Rob(h), 626);
            c = new fP(g);
            c.d = e;
            c.k = Wv(oW(g, XL), 15).a;
            d = Wv(oW(g, VL), 149);
            b = Ckb(Ixb(Xv(rJ(Wv(g.e, 9), (Rib(), $hb)))));
            for(k = new Tob(AW(g)); k.a < k.c.c.length;){
                j = Wv(Rob(k), 161);
                d == (UM(), SM) ? XO(j, b, e) : d == TM && YO(j, e);
                JO(j);
            }
            LO(c, Wv(oW(g, aM), 86).kb((DN(), CN)));
            NO(c);
            yO(c.e, c.d, c.c, c.p);
            _O(c);
            ZO(c);
            VO(c);
            i = new CP((f = Wv(g.e, 9).b, new BP(f.d, f.b, f.a, f.c)));
            i.b = c.p.b + c.q.b;
            i.c = c.p.c + c.q.c;
            i.d = c.p.d + c.q.d;
            i.a = c.p.a + c.q.a;
            Wv(g.e, 9).b.b = i.b;
            Wv(g.e, 9).b.d = i.d;
            Wv(g.e, 9).b.c = i.c;
            Wv(g.e, 9).b.a = i.a;
        }
    }
    function c1(a, b) {
        var c, d, e, f, g, h, i, j, k, l, m, n, o1, p, q, r, s, t;
        i = Wv(nX(a, (sN(), rN)).mb().H(), 7).b;
        n = Wv(nX(a, ZM).mb().H(), 7).e;
        h = i.c.length;
        t = MX(Wv(yU(a.f, 0), 7));
        while(h-- > 0){
            p = (Cxb(0, i.c.length), Wv(i.c[0], 12));
            e = (Cxb(0, n.c.length), Wv(n.c[0], 12));
            s = e.d.b;
            f = zU(s, e, 0);
            fW(p, e.d, f);
            dW(e, null);
            eW(e, null);
            o1 = p.a;
            b && QI(o1, new II(t));
            for(d = WI(e.a, 0); d.b != d.d.c;){
                c = Wv(_ub(d), 10);
                QI(o1, new II(c));
            }
            r = p.b;
            for(m = new Tob(e.b); m.a < m.c.c.length;){
                l = Wv(Rob(m), 33);
                r.c[r.c.length] = l;
            }
            q = Wv(rJ(p, (eM(), CL)), 44);
            g = Wv(rJ(e, CL), 44);
            if (g) {
                if (!q) {
                    q = new jJ;
                    sJ(p, CL, q);
                }
                for(k = WI(g, 0); k.b != k.d.c;){
                    j = Wv(_ub(k), 10);
                    QI(q, new II(j));
                }
            }
        }
    }
    function XO(a, b, c) {
        var d, e, f, g, h;
        f = Li(DW(a));
        if (f.Nb().V()) return;
        h = 0;
        switch(Wv(a.e, 7).g.e){
            case 4:
            case 2:
                h = b && Ckb(Ixb(Xv(rJ(Wv(a.e, 7), (Rib(), lib))))) ? a.e.j.b : (a.e.j.b - Wv(f.Nb().sb(0), 129).pc().b) / 2 - c;
                break;
            case 1:
                h = a.e.j.b;
                break;
            case 3:
                h = 0;
        }
        Wv(a.e, 7).g == (sN(), pN) && Ii(f);
        for(e = new Tob(DW(a)); e.a < e.c.c.length;){
            d = Wv(Rob(e), 129);
            g = new II(a.e.i);
            switch(Wv(a.e, 7).g.e){
                case 4:
                    g.a = a.e.j.a + c;
                    g.b = h + c;
                    h += c + d.e.j.b;
                    break;
                case 2:
                    g.a = -d.e.j.a - c;
                    g.b = h + c;
                    h += c + d.e.j.b;
                    break;
                case 1:
                    g.a = (a.e.j.a - d.e.j.a) / 2;
                    g.b = h + c;
                    h += c + d.e.j.b;
                    break;
                case 3:
                    g.a = (a.e.j.a - d.e.j.a) / 2;
                    g.b = h - c - d.e.j.b;
                    h -= c + d.e.j.b;
            }
            d.e.i.a = g.a;
            d.e.i.b = g.b;
        }
    }
    function jR(a, b) {
        var c, d, e, f, g, h, i, j, k, l;
        a.a = new NR(Tsb(Bz));
        for(d = new Tob(b.a); d.a < d.c.c.length;){
            c = Wv(Rob(d), 347);
            h = new QR(Bv(tv(kA, 1), syb, 25, 0, []));
            vU(a.a.a, h);
            for(j = new Tob(c.d); j.a < j.c.c.length;){
                i = Wv(Rob(j), 62);
                k = new pR(a, i);
                iR(k, Wv(rJ(c.c, (Rib(), fib)), 18));
                if (!Qmb(a.g, c)) {
                    Umb(a.g, c, new HI(i.d, i.e));
                    Umb(a.f, c, k);
                }
                vU(a.a.b, k);
                OR(h, k);
            }
            for(g = new Tob(c.b); g.a < g.c.c.length;){
                f = Wv(Rob(g), 251);
                k = new pR(a, f.Bc());
                Umb(a.b, f, new RJ(h, k));
                iR(k, Wv(rJ(c.c, (Rib(), fib)), 18));
                if (f.zc()) {
                    l = new qR(a, f.zc(), 1);
                    iR(l, Wv(rJ(c.c, fib), 18));
                    e = new QR(Bv(tv(kA, 1), syb, 25, 0, []));
                    OR(e, l);
                    Fd(a.c, f.yc(), new RJ(h, l));
                }
            }
        }
        return a.a;
    }
    function ccb(a, b) {
        var c, d, e, f, g, h, i, j, k, l, m, n, o1, p, q, r, s, t;
        p = b.c.c.length;
        if (p < 3) return;
        n = xv(mw, Yyb, 26, p, 12, 1);
        l = 0;
        for(k = new Tob(b.c); k.a < k.c.c.length;){
            j = Wv(Rob(k), 16);
            n[l++] = j.a.c.length;
        }
        m = new Fnb(b.c, 2);
        for(d = 1; d < p - 1; d++){
            c = (Bxb(m.b < m.d.Y()), Wv(m.d.sb(m.c = m.b++), 16));
            o1 = new Tob(c.a);
            f = 0;
            h = 0;
            for(i = 0; i < n[d + 1]; i++){
                t = Wv(Rob(o1), 9);
                if (i == n[d + 1] - 1 || bcb(a, t, d + 1, d)) {
                    g = n[d] - 1;
                    bcb(a, t, d + 1, d) && (g = a.d.e[Wv(Wv(Wv(yU(a.d.b, t.k), 20).sb(0), 27).a, 9).k]);
                    while(h <= i){
                        s = Wv(yU(c.a, h), 9);
                        if (!bcb(a, s, d + 1, d)) for(r = Wv(yU(a.d.b, s.k), 20).mb(); r.G();){
                            q = Wv(r.H(), 27);
                            e = a.d.e[Wv(q.a, 9).k];
                            (e < f || e > g) && stb(a.c, Wv(q.b, 12));
                        }
                        ++h;
                    }
                    f = g;
                }
            }
        }
    }
    function _9(a, b, c) {
        var d, e, f, g, h, i;
        this.g = a;
        h = b.d.length;
        i = c.d.length;
        this.d = xv(qB, Nzb, 9, h + i, 0, 1);
        for(g = 0; g < h; g++)this.d[g] = b.d[g];
        for(f = 0; f < i; f++)this.d[h + f] = c.d[f];
        if (b.e) {
            this.e = Eo(b.e);
            this.e.nb(c);
            if (c.e) for(e = c.e.mb(); e.G();){
                d = Wv(e.H(), 102);
                if (d == b) continue;
                else this.e.kb(d) ? --d.c : this.e.ib(d);
            }
        } else if (c.e) {
            this.e = Eo(c.e);
            this.e.nb(b);
        }
        this.f = b.f + c.f;
        this.a = b.a + c.a;
        this.a > 0 ? Z9(this, this.f / this.a) : W9(b.g, b.d[0]).a != null && W9(c.g, c.d[0]).a != null ? Z9(this, (Ixb(W9(b.g, b.d[0]).a) + Ixb(W9(c.g, c.d[0]).a)) / 2) : W9(b.g, b.d[0]).a != null ? Z9(this, W9(b.g, b.d[0]).a) : W9(c.g, c.d[0]).a != null && Z9(this, W9(c.g, c.d[0]).a);
    }
    function x9(a, b) {
        var c, d, e, f, g, h, i, j, k, l, m;
        switch(a.g.e){
            case 1:
                d = Wv(rJ(a, (Rib(), uib)), 12);
                c = Wv(rJ(d, vib), 44);
                !c ? c = new jJ : Ckb(Ixb(Xv(rJ(d, Iib)))) && (c = lJ(c));
                j = Wv(rJ(a, qib), 7);
                k = MI(Bv(tv(qz, 1), Fzb, 10, 0, [
                    j.f.i,
                    j.i,
                    j.a
                ]));
                if (b <= k.a) return k.b;
                TI(c, k, c.a, c.a.a);
                l = Wv(rJ(a, rib), 7);
                m = MI(Bv(tv(qz, 1), Fzb, 10, 0, [
                    l.f.i,
                    l.i,
                    l.a
                ]));
                if (m.a <= b) return m.b;
                TI(c, m, c.c.b, c.c);
                i = WI(c, 0);
                g = Wv(_ub(i), 10);
                h = Wv(_ub(i), 10);
                while(h.a < b && i.b != i.d.c){
                    g = h;
                    h = Wv(_ub(i), 10);
                }
                return g.b + (b - g.a) / (h.a - g.a) * (h.b - g.b);
            case 3:
                f = Wv(rJ(Wv(yU(a.f, 0), 7), (Rib(), uib)), 7);
                e = f.f;
                switch(f.g.e){
                    case 1:
                        return e.i.b;
                    case 3:
                        return e.i.b + e.j.b;
                }
        }
        return kX(a).b;
    }
    function KP(a) {
        var b, c, d, e, f, g, h, i, j, k, l, m;
        k = gw(rJ(a.c.f, (Rib(), sib))) === gw(rJ(a.d.f, sib));
        g = new FI;
        c = Wv(rJ(a, (eM(), oL)), 44);
        if (!!c && c.b >= 2) {
            _I(a.a);
            d = 0;
            for(m = WI(c, 0); m.b != m.d.c;){
                l = Wv(_ub(m), 10);
                if (d == 0) {
                    b = EI(EI(new HI(l.a, l.b), a.c.i), a.c.f.i);
                    a.c.a.a = b.a;
                    a.c.a.b = b.b;
                } else if (d == c.b - 1) {
                    b = EI(EI(new HI(l.a, l.b), a.d.i), a.d.f.i);
                    a.d.a.a = b.a;
                    a.d.a.b = b.b;
                } else QI(a.a, l);
                ++d;
            }
        }
        if (k) for(i = WI(a.a, 0); i.b != i.d.c;){
            h = Wv(_ub(i), 10);
            g.a = Nlb(g.a, h.a);
            g.b = Nlb(g.b, h.b);
        }
        for(f = new Tob(a.b); f.a < f.c.c.length;){
            e = Wv(Rob(f), 33);
            j = Wv(rJ(e, YL), 10);
            if (j) {
                e.i.a = j.a;
                e.i.b = j.b;
            }
            if (k) {
                g.a = Nlb(g.a, e.i.a + e.j.a);
                g.b = Nlb(g.b, e.i.b + e.j.b);
            }
        }
        return g;
    }
    function eQ(a, b, c) {
        var d, e, f, g, h, i, j;
        SP(b);
        d = Wv(rJ(c, (Rib(), jib)), 18);
        g = new uX(c);
        sJ(g, uib, b);
        vU(c.b, g);
        f = Wv(Pu(b, 'id'), 97);
        Vmb(a.i, f.a, g);
        Umb(a.j, g, b);
        _P(b, g);
        hQ(b, g);
        if ('ports' in b.a) {
            j = Pu(b, 'ports');
            if (!j.hc()) throw new GQ("The 'ports' property of the node must be an array.", j, b);
            i = j.hc();
            for(e = 0; e < i.a.length; ++e)aw(gu(i, e), 69) && gQ(a, Wv(gu(i, e), 69), g, c);
        }
        dQ(a, b, g, c);
        Mzb in b.a && Pu(b, Mzb).hc().a.length > 0 && sJ(g, $hb, (xkb(), xkb(), wkb));
        h = Wv(rJ(g, (eM(), TL)), 28);
        h == (KM(), JM) ? IM : h != IM && d.ib((ohb(), khb));
        Ckb(Ixb(Xv(rJ(g, qL)))) && d.ib((ohb(), fhb));
        if (Ckb(Ixb(Xv(rJ(g, AL))))) {
            d.ib((ohb(), jhb));
            d.ib(ihb);
            sJ(g, TL, IM);
        }
        return g;
    }
    function iR(a, b) {
        b.V() && wS(a.n, true, true, true, true);
        b.t((sN(), eN)) && wS(a.n, true, true, true, false);
        b.t(_M) && wS(a.n, false, true, true, true);
        b.t(mN) && wS(a.n, true, true, false, true);
        b.t(oN) && wS(a.n, true, false, true, true);
        b.t(fN) && wS(a.n, false, true, true, false);
        b.t(aN) && wS(a.n, false, true, false, true);
        b.t(nN) && wS(a.n, true, false, false, true);
        b.t(lN) && wS(a.n, true, false, true, false);
        b.t(jN) && wS(a.n, true, true, true, true);
        b.t(cN) && wS(a.n, true, true, true, true);
        b.t(jN) && wS(a.n, true, true, true, true);
        b.t(bN) && wS(a.n, true, true, true, true);
        b.t(kN) && wS(a.n, true, true, true, true);
        b.t(iN) && wS(a.n, true, true, true, true);
        b.t(hN) && wS(a.n, true, true, true, true);
    }
    function n1(a, b) {
        var c, d, e, f, g, h, i, j, k, l;
        i = true;
        e = 0;
        j = a.f[b.k];
        k = b.j.b + a.n;
        c = a.c[b.k][2];
        DU(a.a, j, Elb(Wv(yU(a.a, j), 24).a - 1 + c));
        DU(a.b, j, Ixb(Yv(yU(a.b, j))) - k + c * a.e);
        ++j;
        if (j >= a.i) {
            ++a.i;
            vU(a.a, Elb(1));
            vU(a.b, k);
        } else {
            d = a.c[b.k][1];
            DU(a.a, j, Elb(Wv(yU(a.a, j), 24).a + 1 - d));
            DU(a.b, j, Ixb(Yv(yU(a.b, j))) + k - d * a.e);
        }
        (a.q == (I1(), B1) && (Wv(yU(a.a, j), 24).a > a.j || Wv(yU(a.a, j - 1), 24).a > a.j) || a.q == E1 && (Ixb(Yv(yU(a.b, j))) > a.k || Ixb(Yv(yU(a.b, j - 1))) > a.k)) && (i = false);
        for(g = Uh(iX(b)); Cm(g);){
            f = Wv(Dm(g), 12);
            h = f.c.f;
            if (a.f[h.k] == j) {
                l = n1(a, h);
                e = e + Wv(l.a, 24).a;
                i = i && Ckb(Ixb(Xv(l.b)));
            }
        }
        a.f[b.k] = j;
        e = e + a.c[b.k][0];
        return new RJ(Elb(e), (xkb(), i ? wkb : vkb));
    }
    function WW(a, b, c) {
        var d, e, f, g, h, i, j, k, l, m, n, o1, p, q, r;
        m = new II(a.j);
        r = b.a / m.a;
        h = b.b / m.b;
        p = b.a - m.a;
        f = b.b - m.b;
        if (c) {
            e = gw(rJ(a, (eM(), TL))) === gw((KM(), FM));
            for(o1 = new Tob(a.f); o1.a < o1.c.c.length;){
                n = Wv(Rob(o1), 7);
                switch(n.g.e){
                    case 1:
                        e || (n.i.a *= r);
                        break;
                    case 2:
                        n.i.a += p;
                        e || (n.i.b *= h);
                        break;
                    case 3:
                        e || (n.i.a *= r);
                        n.i.b += f;
                        break;
                    case 4:
                        e || (n.i.b *= h);
                }
            }
        }
        for(j = new Tob(a.c); j.a < j.c.c.length;){
            i = Wv(Rob(j), 33);
            k = i.i.a + i.j.a / 2;
            l = i.i.b + i.j.b / 2;
            q = k / m.a;
            g = l / m.b;
            if (q + g >= 1) {
                if (q - g > 0 && l >= 0) {
                    i.i.a += p;
                    i.i.b += f * g;
                } else if (q - g < 0 && k >= 0) {
                    i.i.a += p * q;
                    i.i.b += f;
                }
            }
        }
        a.j.a = b.a;
        a.j.b = b.b;
        sJ(a, (eM(), aM), (DN(), d = Wv(Hkb(Lz), 11), new atb(d, Wv(exb(d, d.length), 11), 0)));
    }
    function C7(a) {
        var b, c, d, e, f, g, h, i, j, k;
        d = new GU;
        for(g = new Tob(a.e.a); g.a < g.c.c.length;){
            e = Wv(Rob(g), 61);
            k = 0;
            e.k.c = xv(UF, syb, 1, 0, 4, 1);
            for(c = new Tob(m7(e)); c.a < c.c.c.length;){
                b = Wv(Rob(c), 89);
                if (b.e) {
                    vU(e.k, b);
                    ++k;
                }
            }
            k == 1 && (d.c[d.c.length] = e);
        }
        for(f = new Tob(d); f.a < f.c.c.length;){
            e = Wv(Rob(f), 61);
            while(e.k.c.length == 1){
                j = Wv(Rob(new Tob(e.k)), 89);
                a.b[j.b] = j.f;
                h = j.c;
                i = j.d;
                for(c = new Tob(m7(e)); c.a < c.c.c.length;){
                    b = Wv(Rob(c), 89);
                    b == j || (b.e ? h == b.c || i == b.d ? a.b[j.b] -= a.b[b.b] - b.f : a.b[j.b] += a.b[b.b] - b.f : e == h ? b.c == e ? a.b[j.b] += b.f : a.b[j.b] -= b.f : b.c == e ? a.b[j.b] -= b.f : a.b[j.b] += b.f);
                }
                BU(h.k, j);
                BU(i.k, j);
                h == e ? e = j.d : e = j.c;
            }
        }
    }
    function _fb(a) {
        var b, c, d, e, f, g, h, i, j, k;
        j = new aJ;
        h = new aJ;
        for(f = new Tob(a); f.a < f.c.c.length;){
            d = Wv(Rob(f), 77);
            d.e = d.d.c.length;
            d.k = d.j.c.length;
            d.e == 0 && TI(j, d, j.c.b, j.c);
            d.k == 0 && d.g.a.Y() == 0 && TI(h, d, h.c.b, h.c);
        }
        g = -1;
        while(j.b != 0){
            d = Wv(un(j, 0), 77);
            for(c = new Tob(d.j); c.a < c.c.c.length;){
                b = Wv(Rob(c), 117);
                k = b.b;
                k.n = Plb(k.n, d.n + 1);
                g = Plb(g, k.n);
                --k.e;
                k.e == 0 && TI(j, k, j.c.b, j.c);
            }
        }
        if (g > -1) {
            for(e = WI(h, 0); e.b != e.d.c;){
                d = Wv(_ub(e), 77);
                d.n = g;
            }
            while(h.b != 0){
                d = Wv(un(h, 0), 77);
                for(c = new Tob(d.d); c.a < c.c.c.length;){
                    b = Wv(Rob(c), 117);
                    i = b.a;
                    if (i.g.a.Y() != 0) continue;
                    i.n = Slb(i.n, d.n - 1);
                    --i.k;
                    i.k == 0 && TI(h, i, h.c.b, h.c);
                }
            }
        }
    }
    function QV(a, b, c, d) {
        var e, f, g, h, i, j, k, l, m, n, o1, p, q, r, s, t, u, v;
        i = new GU;
        for(f = new Tob(b.b); f.a < f.c.c.length;){
            e = Wv(Rob(f), 9);
            for(h = new Tob(e.f); h.a < h.c.c.length;){
                g = Wv(Rob(h), 7);
                k = null;
                for(t = Wv(FU(g.e, xv(dB, gAb, 12, 0, 0, 1)), 47), u = 0, v = t.length; u < v; ++u){
                    s = t[u];
                    if (!SW(s.d.f, c)) {
                        r = LV(a, b, c, s, s.c, (djb(), bjb), k);
                        r != k && (i.c[i.c.length] = r);
                        r.c && (k = r);
                    }
                }
                j = null;
                for(o1 = Wv(FU(g.b, xv(dB, gAb, 12, 0, 0, 1)), 47), p = 0, q = o1.length; p < q; ++p){
                    n = o1[p];
                    if (!SW(n.c.f, c)) {
                        r = LV(a, b, c, n, n.d, (djb(), ajb), j);
                        r != j && (i.c[i.c.length] = r);
                        r.c && (j = r);
                    }
                }
            }
        }
        for(m = new Tob(i); m.a < m.c.c.length;){
            l = Wv(Rob(m), 187);
            zU(b.b, l.a, 0) != -1 || vU(b.b, l.a);
            l.c && (d.c[d.c.length] = l);
        }
    }
    function WO(a) {
        var b, c, d, e, f, g, h, i, j;
        d = a.e.e.j;
        b = Wv(oW(a.e, (eM(), aM)), 86).kb((DN(), CN));
        PO(a);
        for(f = new Tob(AW(a.e)); f.a < f.c.c.length;){
            e = Wv(Rob(f), 161);
            h = Wv(oW(e, LL), 15);
            !h && (h = new llb(0));
            i = e.e.j;
            g = (c = Wv(e.e, 7).d, new EP(c.d, c.b, c.a, c.c));
            j = new II(e.e.i);
            switch(Wv(e.e, 7).g.e){
                case 4:
                    j.a = -i.a - h.a;
                    j.b = a.s - i.b - (b ? g.a : 0);
                    a.s -= cP(a, (sN(), rN)) + i.b + (b ? g.d + g.a : 0);
                    break;
                case 2:
                    j.a = d.a + h.a;
                    j.b = a.a + (b ? g.d : 0);
                    a.a += cP(a, (sN(), ZM)) + i.b + (b ? g.d + g.a : 0);
                    break;
                case 1:
                    j.a = a.f + (b ? g.b : 0);
                    j.b = -e.e.j.b - h.a;
                    a.f += cP(a, (sN(), $M)) + i.a + (b ? g.b + g.c : 0);
                    break;
                case 3:
                    j.a = a.r - i.a - (b ? g.c : 0);
                    j.b = d.b + h.a;
                    a.r -= cP(a, (sN(), pN)) + i.a + (b ? g.b + g.c : 0);
            }
            e.e.i.a = j.a;
            e.e.i.b = j.b;
        }
    }
    function u$(a, b, c) {
        var d, e, f, g, h, i, j, k, l, m, n, o1, p, q, r;
        k = new Wub;
        l = new Wub;
        q = new Wub;
        r = new Wub;
        j = Wv(rJ(b, (Rib(), Jib)), 15).a;
        f = j * Wv(rJ(b, (Mjb(), qjb)), 15).a;
        Ckb(Ixb(Xv(rJ(b, (eM(), rL)))));
        for(i = (m = new Snb(c.a).a.bb().mb(), new Ynb(m)); i.a.G();){
            h = (g = Wv(i.a.H(), 21), Wv(g.yb(), 9));
            n = Wv(rJ(h, hib), 32);
            if (n == (sN(), $M)) {
                l.a.db(h, l);
                for(e = Uh(iX(h)); Cm(e);){
                    d = Wv(Dm(e), 12);
                    stb(k, d.c.f);
                }
            } else if (n == pN) {
                r.a.db(h, r);
                for(e = Uh(iX(h)); Cm(e);){
                    d = Wv(Dm(e), 12);
                    stb(q, d.c.f);
                }
            }
        }
        if (k.a.Y() != 0) {
            o1 = new cdb(2, f);
            p = bdb(o1, b, k, l, -j - b.d.b);
            if (p > 0) {
                a.a = j + (p - 1) * f;
                b.d.b += a.a;
                b.e.b += a.a;
            }
        }
        if (q.a.Y() != 0) {
            o1 = new cdb(1, f);
            p = bdb(o1, b, q, r, b.e.b + j - b.d.b);
            p > 0 && (b.e.b += j + (p - 1) * f);
        }
    }
    function Xt(a, b) {
        var c, d, e, f, g, h, i, j, k;
        if ((bmb(), b.length) == 0) return a.fc(Yxb, Xxb, -1, -1);
        k = hmb(b);
        emb(k.substr(0, 3), 'at ') && (k = imb(k, 3, k.length - 3));
        k = k.replace(/\[.*?\]/g, '');
        g = k.indexOf('(');
        if (g == -1) {
            g = k.indexOf('@');
            if (g == -1) {
                j = k;
                k = '';
            } else {
                j = hmb(imb(k, g + 1, k.length - (g + 1)));
                k = hmb(k.substr(0, g));
            }
        } else {
            c = k.indexOf(')', g);
            j = k.substr(g + 1, c - (g + 1));
            k = hmb(k.substr(0, g));
        }
        g = mmb(k, lmb(46));
        g != -1 && (k = imb(k, g + 1, k.length - (g + 1)));
        (k.length == 0 || emb(k, 'Anonymous function')) && (k = Xxb);
        h = nmb(j, lmb(58));
        e = omb(j, lmb(58), h - 1);
        i = -1;
        d = -1;
        f = Yxb;
        if (h != -1 && e != -1) {
            f = j.substr(0, e);
            i = St(j.substr(e + 1, h - (e + 1)));
            d = St(imb(j, h + 1, j.length - (h + 1)));
        }
        return a.fc(f, k, i, d);
    }
    function idb(a) {
        var b, c, d, e, f, g, h, i, j, k;
        j = new GU;
        h = new GU;
        for(g = new Tob(a); g.a < g.c.c.length;){
            e = Wv(Rob(g), 80);
            e.c = e.b.c.length;
            e.f = e.e.c.length;
            e.c == 0 && (j.c[j.c.length] = e);
            e.f == 0 && e.j.b == 0 && (h.c[h.c.length] = e);
        }
        d = -1;
        while(j.c.length != 0){
            e = Wv(AU(j, 0), 80);
            for(c = new Tob(e.e); c.a < c.c.c.length;){
                b = Wv(Rob(c), 118);
                k = b.b;
                k.i = Plb(k.i, e.i + 1);
                d = Plb(d, k.i);
                --k.c;
                k.c == 0 && (j.c[j.c.length] = k);
            }
        }
        if (d > -1) {
            for(f = new Tob(h); f.a < f.c.c.length;){
                e = Wv(Rob(f), 80);
                e.i = d;
            }
            while(h.c.length != 0){
                e = Wv(AU(h, 0), 80);
                for(c = new Tob(e.b); c.a < c.c.c.length;){
                    b = Wv(Rob(c), 118);
                    i = b.a;
                    if (i.j.b > 0) continue;
                    i.i = Slb(i.i, e.i - 1);
                    --i.f;
                    i.f == 0 && (h.c[h.c.length] = i);
                }
            }
        }
    }
    function PV(a, b, c) {
        var d, e, f, g, h, i, j, k, l, m, n, o1, p;
        if (!Ckb(Ixb(Xv(rJ(c, (eM(), $L)))))) return;
        for(h = new Tob(c.f); h.a < h.c.c.length;){
            g = Wv(Rob(h), 7);
            l = Wv(FU(g.e, xv(dB, gAb, 12, g.e.c.length, 0, 1)), 47);
            for(j = 0, k = l.length; j < k; ++j){
                i = l[j];
                f = i.d.f == c;
                e = f && Ckb(Ixb(Xv(rJ(i, $L))));
                if (e) {
                    n = i.c;
                    m = Wv(Smb(a.b, n), 9);
                    if (!m) {
                        m = NW(n, (KM(), IM), n.g, -1, n.j, Wv(rJ(b, sL), 59), b);
                        sJ(m, (Rib(), uib), n);
                        Umb(a.b, n, m);
                        vU(b.b, m);
                    }
                    p = i.d;
                    o1 = Wv(Smb(a.b, p), 9);
                    if (!o1) {
                        o1 = NW(p, (KM(), IM), p.g, 1, p.j, Wv(rJ(b, sL), 59), b);
                        sJ(o1, (Rib(), uib), p);
                        Umb(a.b, p, o1);
                        vU(b.b, o1);
                    }
                    d = IV(i);
                    dW(d, Wv(yU(m.f, 0), 7));
                    eW(d, Wv(yU(o1.f, 0), 7));
                    Fd(a.a, i, new XV(d, b, (djb(), bjb)));
                    Wv(rJ(b, (Rib(), jib)), 18).ib((ohb(), hhb));
                }
            }
        }
    }
    function vfb(a, b, c, d, e, f) {
        var g, h, i, j, k, l, m, n, o1, p, q, r, s, t;
        n = sgb(a.g);
        p = sgb(c.g);
        o1 = vI(xI(a.i), a.a);
        q = vI(xI(c.i), c.a);
        g = vI(new II(o1), CI(new GI(n), b));
        h = vI(new II(q), CI(new GI(p), d));
        j = ogb(a, e);
        e == (sN(), pN) || e == ZM ? j += f : j -= f;
        m = new FI;
        r = new FI;
        switch(e.e){
            case 1:
            case 3:
                m.a = g.a;
                m.b = o1.b + j;
                r.a = h.a;
                r.b = m.b;
                break;
            case 2:
            case 4:
                m.a = o1.a + j;
                m.b = g.b;
                r.a = m.a;
                r.b = h.b;
                break;
            default:
                return null;
        }
        k = CI(vI(new HI(m.a, m.b), r), 0.5);
        l = new ufb(Bv(tv(qz, 1), Fzb, 10, 0, [
            o1,
            g,
            m,
            k,
            r,
            h,
            q
        ]));
        i = ifb(l);
        t = jfb(l);
        switch(e.e){
            case 1:
            case 3:
                l.a = i;
                s = lfb(l);
                break;
            case 2:
            case 4:
                l.a = t;
                s = kfb(l);
                break;
            default:
                return null;
        }
        bfb(l, new Ffb(Bv(tv(qz, 1), Fzb, 10, 0, [
            i,
            t,
            s,
            o1,
            q
        ])));
        return l;
    }
    function qU(a, b, c, d) {
        var e, f, g, h, i, j, k, l, m, n;
        f = new eV(b);
        l = lU(a, b, f);
        n = Nlb(Wv(rJ(b, (eM(), dM)), 15).a, 1);
        for(k = new Tob(l.a); k.a < k.c.c.length;){
            j = Wv(Rob(k), 27);
            i = pU(Wv(j.a, 10), Wv(j.b, 10), n);
            o = true;
            o = o & YU(c, new HI(i.d, i.e));
            o = o & YU(c, uI(new HI(i.d, i.e), i.c, 0));
            o = o & YU(c, uI(new HI(i.d, i.e), 0, i.b));
            o, YU(c, uI(new HI(i.d, i.e), i.c, i.b));
        }
        m = f.d;
        h = pU(Wv(l.b.a, 10), Wv(l.b.b, 10), n);
        if (m == (sN(), rN) || m == ZM) {
            d.c[m.e] = Qlb(d.c[m.e], h.e);
            d.b[m.e] = Nlb(d.b[m.e], h.e + h.b);
        } else {
            d.c[m.e] = Qlb(d.c[m.e], h.d);
            d.b[m.e] = Nlb(d.b[m.e], h.d + h.c);
        }
        e = Vzb;
        g = f.c.f.e;
        switch(m.e){
            case 4:
                e = g.c;
                break;
            case 2:
                e = g.b;
                break;
            case 1:
                e = g.a;
                break;
            case 3:
                e = g.d;
        }
        d.a[m.e] = Nlb(d.a[m.e], e);
        return f;
    }
    function OV(a, b, c, d, e) {
        var f, g, h, i, j, k, l, m, n, o1, p, q;
        f = new GU;
        for(j = new Tob(d); j.a < j.c.c.length;){
            h = Wv(Rob(j), 187);
            g = null;
            if (h.f == (djb(), bjb)) for(o1 = new Tob(h.e); o1.a < o1.c.c.length;){
                n = Wv(Rob(o1), 12);
                q = n.d.f;
                if (hX(q) == b) GV(a, b, h, n, h.b, n.d);
                else if (!c || SW(q, c)) HV(a, b, h, d, n);
                else {
                    m = LV(a, b, c, n, h.b, bjb, g);
                    m != g && (f.c[f.c.length] = m);
                    m.c && (g = m);
                }
            }
            else for(l = new Tob(h.e); l.a < l.c.c.length;){
                k = Wv(Rob(l), 12);
                p = k.c.f;
                if (hX(p) == b) GV(a, b, h, k, k.c, h.b);
                else if (!c || SW(p, c)) continue;
                else {
                    m = LV(a, b, c, k, h.b, ajb, g);
                    m != g && (f.c[f.c.length] = m);
                    m.c && (g = m);
                }
            }
        }
        for(i = new Tob(f); i.a < i.c.c.length;){
            h = Wv(Rob(i), 187);
            zU(b.b, h.a, 0) != -1 || vU(b.b, h.a);
            h.c && (e.c[e.c.length] = h);
        }
    }
    function TO(a) {
        var b, c, d, e;
        b = a.e.j;
        for(d = new Tob(AW(a)); d.a < d.c.c.length;){
            c = Wv(Rob(d), 161);
            e = Wv(oW(c, (eM(), LL)), 15);
            !e && (e = new llb(0));
            switch(Wv(c.e, 7).g.e){
                case 4:
                    c.e.i.b = b.b * Ixb(Yv(oW(c, HO)));
                    c.e.i.a = -c.e.j.a - e.a;
                    break;
                case 2:
                    c.e.i.b = b.b * Ixb(Yv(oW(c, HO)));
                    c.e.i.a = b.a + e.a;
                    break;
                case 1:
                    c.e.i.a = b.a * Ixb(Yv(oW(c, HO)));
                    c.e.i.b = -c.e.j.b - e.a;
                    break;
                case 3:
                    c.e.i.a = b.a * Ixb(Yv(oW(c, HO)));
                    c.e.i.b = b.b + e.a;
            }
            switch(Wv(c.e, 7).g.e){
                case 4:
                    c.e.i.b = b.b * Ixb(Yv(oW(c, HO)));
                    c.e.i.a = -c.e.j.a - e.a;
                    break;
                case 2:
                    c.e.i.b = b.b * Ixb(Yv(oW(c, HO)));
                    c.e.i.a = b.a + e.a;
                    break;
                case 1:
                    c.e.i.a = b.a * Ixb(Yv(oW(c, HO)));
                    c.e.i.b = -c.e.j.b - e.a;
                    break;
                case 3:
                    c.e.i.a = b.a * Ixb(Yv(oW(c, HO)));
                    c.e.i.b = b.b + e.a;
            }
        }
    }
    function C2(a) {
        var b, c, d, e, f, g, h, i, j;
        f = a.f;
        e = pr(Zdb(a));
        j = WI(Eo(a.g), 0);
        while(j.b != j.d.c){
            i = Wv(_ub(j), 7);
            if (i.e.c.length == 0) for(c = new Tob(i.b); c.a < c.c.c.length;){
                b = Wv(Rob(c), 12);
                d = b.c;
                if (e.a.R(d)) {
                    g = new Fnb(f.f, 0);
                    h = (Bxb(g.b < g.d.Y()), Wv(g.d.sb(g.c = g.b++), 7));
                    while(h != i)h = (Bxb(g.b < g.d.Y()), Wv(g.d.sb(g.c = g.b++), 7));
                    Anb(g, d);
                    $ub(j, d);
                    J2(d, i.g);
                    avb(j);
                    avb(j);
                    e.a.eb(d);
                }
            }
            else for(c = new Tob(i.e); c.a < c.c.c.length;){
                b = Wv(Rob(c), 12);
                d = b.d;
                if (e.a.R(d)) {
                    g = new Fnb(f.f, 0);
                    h = (Bxb(g.b < g.d.Y()), Wv(g.d.sb(g.c = g.b++), 7));
                    while(h != i)h = (Bxb(g.b < g.d.Y()), Wv(g.d.sb(g.c = g.b++), 7));
                    Bxb(g.b > 0);
                    g.a.sb(g.c = --g.b);
                    Anb(g, d);
                    $ub(j, d);
                    J2(d, i.g);
                    avb(j);
                    avb(j);
                    e.a.eb(d);
                }
            }
        }
    }
    function IP(b) {
        var c, d, e, f, g, h, i, j, k;
        g = new Uu(b);
        f = Pu(g, 'graph');
        j = Pu(g, 'success');
        e = Pu(g, 'error');
        h = Pu(g, 'options');
        try {
            if (!f || !f.kc()) throw new $J("Mandatory parameter missing, 'graph' must be specified");
            AQ(new CQ, f.kc(), h ? h.kc() : null);
            i = f.kc().a;
            !!j && !!j.kc() ? HP(j.kc().a, i) : HP(null, i);
        } catch (a) {
            a = OH(a);
            if (aw(a, 73)) {
                k = a;
                !!e && !!e.kc() ? HP(e.kc().a, DQ(k).a) : HP(null, DQ(k).a);
            } else if (aw(a, 54)) {
                c = a;
                d = new Tu;
                Ru(d, 'type', new lv(Ikb(c.$c)));
                c.bc() != null ? Ru(d, Dzb, new lv(c.bc())) : Ru(d, Dzb, new lv('null (sic)'));
                Ru(d, Ezb, new lv(Hb(new Kb('\n'), new wnb(new opb((c.g == null && (c.g = Pt(c)), c.g))))));
                !!e && !!e.kc() ? HP(e.kc().a, d.a) : HP(null, d.a);
                at(c, (Fmb(), Dmb), '');
            } else throw NH(a);
        }
    }
    function e9(a, b, c) {
        var d, e, f, g, h, i, j, k, l, m;
        if (c) {
            d = -1;
            k = new Fnb(b, 0);
            while(k.b < k.d.Y()){
                h = (Bxb(k.b < k.d.Y()), Wv(k.d.sb(k.c = k.b++), 9));
                l = a.a[h.d.k][h.k].a;
                if (l == null) {
                    g = d + 1;
                    f = new Fnb(b, k.b);
                    while(f.b < f.d.Y()){
                        m = i9(a, (Bxb(f.b < f.d.Y()), Wv(f.d.sb(f.c = f.b++), 9))).a;
                        if (m != null) {
                            g = (Dxb(m), m);
                            break;
                        }
                    }
                    l = (d + g) / 2;
                    a.a[h.d.k][h.k].a = l;
                    a.a[h.d.k][h.k].d = (Dxb(l), l);
                    a.a[h.d.k][h.k].b = 1;
                }
                d = (Dxb(l), l);
            }
        } else {
            e = 0;
            for(j = new Tob(b); j.a < j.c.c.length;){
                h = Wv(Rob(j), 9);
                a.a[h.d.k][h.k].a != null && (e = Nlb(e, Ixb(a.a[h.d.k][h.k].a)));
            }
            e += 2;
            for(i = new Tob(b); i.a < i.c.c.length;){
                h = Wv(Rob(i), 9);
                if (a.a[h.d.k][h.k].a == null) {
                    l = wvb(a.e, 24) * FAb * e - 1;
                    a.a[h.d.k][h.k].a = l;
                    a.a[h.d.k][h.k].d = l;
                    a.a[h.d.k][h.k].b = 1;
                }
            }
        }
    }
    function RO(a, b, c) {
        var d, e, f, g, h, i, j, k, l, m, n, o1;
        i = 0;
        j = 0;
        o1 = 0;
        n = 0;
        g = 0;
        m = 0;
        l = 0;
        k = 0;
        for(f = new Lsb(new Fsb(a.c).a); htb(f.a);){
            e = (f.b = itb(f.a), new Psb(f.c, f.b));
            d = Wv(e.b.b[e.a.e], 62);
            switch(Wv(e.a, 67).e){
                case 12:
                case 13:
                case 14:
                    m += d.c + b;
                    break;
                case 15:
                case 16:
                case 17:
                    l += d.c + b;
                    g = Nlb(g, d.b + b);
                    break;
                case 18:
                case 19:
                case 20:
                    k += d.c + b;
                    break;
                case 0:
                case 1:
                case 2:
                    o1 += d.c + b;
                    break;
                case 3:
                case 4:
                case 5:
                    n += d.c + b;
                    break;
                case 6:
                case 7:
                case 8:
                    i += d.b + b;
                    break;
                case 9:
                case 10:
                case 11:
                    j += d.b + b;
            }
        }
        i -= b;
        j -= b;
        o1 -= b;
        n -= b;
        m += m != 0 ? b : 0;
        l += l != 0 ? b : 0;
        k += k != 0 ? b : 0;
        h = a.p.d + g + a.p.a;
        h += h != 0 ? b : 0;
        c.a = Nlb(c.a, o1);
        c.a = Nlb(c.a, m);
        c.a = Nlb(c.a, l);
        c.a = Nlb(c.a, k);
        c.a = Nlb(c.a, n);
        c.b = Nlb(c.b, i);
        c.b = Nlb(c.b, h);
        c.b = Nlb(c.b, j);
    }
    function T9(a) {
        var b, c, d, e, f, g, h, i;
        b = null;
        for(d = new Tob(a); d.a < d.c.c.length;){
            c = Wv(Rob(d), 102);
            Ixb(W9(c.g, c.d[0]).a);
            c.b = null;
            if (!!c.e && c.e.Y() > 0 && c.c == 0) {
                !b && (b = new GU);
                b.c[b.c.length] = c;
            }
        }
        if (b) while(b.c.length != 0){
            c = Wv(AU(b, 0), 102);
            if (!!c.b && c.b.c.length > 0) for(f = (!c.b && (c.b = new GU), new Tob(c.b)); f.a < f.c.c.length;){
                e = Wv(Rob(f), 102);
                if (Ixb(W9(e.g, e.d[0]).a) == Ixb(W9(c.g, c.d[0]).a)) {
                    if (zU(a, e, 0) > zU(a, c, 0)) return new RJ(e, c);
                } else if (Ixb(W9(e.g, e.d[0]).a) > Ixb(W9(c.g, c.d[0]).a)) return new RJ(e, c);
            }
            for(h = (!c.e && (c.e = new GU), c.e).mb(); h.G();){
                g = Wv(h.H(), 102);
                i = (!g.b && (g.b = new GU), g.b);
                Fxb(0, i.c.length);
                fxb(i.c, 0, c);
                g.c == i.c.length && (b.c[b.c.length] = g);
            }
        }
        return null;
    }
    function R0(a) {
        var b, c, d, e, f, g, h, i, j, k, l, m, n, o1, p;
        l = (mp(), new ntb);
        for(k = (Il(), new Im(Dl(ul(a.a, new yl)))); Cm(k);){
            j = Wv(Dm(k), 9);
            e = Q0(j, (sN(), ZM));
            for(d = new Tob(e); d.a < d.c.c.length;){
                c = Wv(Rob(d), 7);
                for(g = new Tob(c.e); g.a < g.c.c.length;){
                    f = Wv(Rob(g), 12);
                    kP();
                    p = f.d.f;
                    (p.g == (CX(), zX) || p.g == yX) && (p = Wv(rJ(p, (Rib(), rib)), 7).f);
                    if (Ktb(l.d, p)) b = Wv(re(Ktb(l.d, p)), 171);
                    else {
                        e.c.length == 2 ? gw(c) === gw((Cxb(0, e.c.length), e.c[0])) ? b = gP : b = hP : b = gP;
                        Ltb(l.d, p, b);
                    }
                    for(i = new Tob(f.b); i.a < i.c.c.length;){
                        h = Wv(Rob(i), 33);
                        sJ(h, (Rib(), pib), b);
                    }
                    for(o1 = new Tob(f.c.c); o1.a < o1.c.c.length;){
                        m = Wv(Rob(o1), 33);
                        sJ(m, (Rib(), pib), b);
                    }
                    for(n = new Tob(f.d.c); n.a < n.c.c.length;){
                        m = Wv(Rob(n), 33);
                        sJ(m, (Rib(), pib), b);
                    }
                }
            }
        }
    }
    function lZ(a, b) {
        var c, d, e, f, g, h, i, j, k;
        if (tl(mX(b)) != 1 || Wv(ql(mX(b)), 12).d.f.g != (CX(), zX)) return null;
        f = Wv(ql(mX(b)), 12);
        c = f.d.f;
        sX(c, (CX(), wX));
        sJ(c, (Rib(), qib), null);
        sJ(c, rib, null);
        sJ(c, (eM(), TL), Wv(rJ(b, TL), 28));
        sJ(c, JL, Wv(rJ(b, JL), 86));
        e = rJ(f.c, uib);
        g = null;
        for(j = nX(c, (sN(), ZM)).mb(); j.G();){
            h = Wv(j.H(), 7);
            if (h.e.c.length != 0) {
                sJ(h, uib, e);
                k = f.c;
                h.j.a = k.j.a;
                h.j.b = k.j.b;
                h.a.a = k.a.a;
                h.a.b = k.a.b;
                xU(h.c, k.c);
                k.c.c = xv(UF, syb, 1, 0, 4, 1);
                g = h;
                break;
            }
        }
        sJ(f.c, uib, null);
        if (!sl(nX(b, ZM))) for(i = new Tob(Ao(nX(b, ZM))); i.a < i.c.c.length;){
            h = Wv(Rob(i), 7);
            if (h.e.c.length == 0) {
                d = new RX;
                QX(d, ZM);
                d.j.a = h.j.a;
                d.j.b = h.j.b;
                PX(d, c);
                sJ(d, uib, rJ(h, uib));
                PX(h, null);
            } else PX(g, c);
        }
        c.j.b = b.j.b;
        vU(a.b, c);
        return c;
    }
    function _O(a) {
        var b, c, d, e, f, g, h, i, j;
        f = a.e.e.j;
        g = new II(f);
        i = Wv(oW(a.e, (eM(), aM)), 86);
        j = Wv(oW(a.e, bM), 86);
        h = Wv(oW(a.e, TL), 28);
        b = Zsb(i, (DN(), CN));
        if (i.c == 0) return;
        f.a = 0;
        f.b = 0;
        d = null;
        switch(h.e){
            case 1:
            case 2:
            case 3:
                d = MO(a, a.k);
                break;
            case 4:
                d = new II(g);
                break;
            case 5:
                d = KO(a.e, b);
        }
        if (Zsb(i, BN)) {
            if (d) {
                f.a = Nlb(f.a, d.a);
                f.b = Nlb(f.b, d.b);
            }
            if (b) {
                f.a = Nlb(f.a, a.q.b + a.q.c + a.k);
                f.b = Nlb(f.b, a.q.d + a.q.a + a.k);
            }
        }
        Zsb(i, AN) && Qob(new Tob(zW(a.e))) && RO(a, a.d, f);
        if (Zsb(i, zN)) {
            e = Wv(oW(a.e, IL), 15).a;
            c = Wv(oW(a.e, HL), 15).a;
            if (Zsb(j, (MN(), KN))) {
                e <= 0 && (e = 20);
                c <= 0 && (c = 20);
            }
            if (Zsb(j, LN)) {
                e > 0 && (f.a = Nlb(f.a, e + a.q.b + a.q.c));
                c > 0 && (f.b = Nlb(f.b, c + a.q.d + a.q.a));
            } else {
                e > 0 && (f.a = Nlb(f.a, e));
                c > 0 && (f.b = Nlb(f.b, c));
            }
        }
        pW(a.e, f);
    }
    function ewb(a, b, c) {
        var d, e, f, g, h, i, j, k, l, m, n;
        if (!a.b) return false;
        g = null;
        m = null;
        i = new ywb(null, null);
        e = 1;
        i.a[1] = a.b;
        l = i;
        while(l.a[e]){
            j = e;
            h = m;
            m = l;
            l = l.a[e];
            d = a.a.$b(b, l.d);
            e = d < 0 ? 0 : 1;
            d == 0 && (!c.c || ovb(l.e, c.d)) && (g = l);
            if (!(!!l && l.b) && !awb(l.a[e])) {
                if (awb(l.a[1 - e])) m = m.a[j] = hwb(l, e);
                else if (!awb(l.a[1 - e])) {
                    n = m.a[1 - j];
                    if (n) {
                        if (!awb(n.a[1 - j]) && !awb(n.a[j])) {
                            m.b = false;
                            n.b = true;
                            l.b = true;
                        } else {
                            f = h.a[1] == m ? 1 : 0;
                            awb(n.a[j]) ? h.a[f] = gwb(m, j) : awb(n.a[1 - j]) && (h.a[f] = hwb(m, j));
                            l.b = h.a[f].b = true;
                            h.a[f].a[0].b = false;
                            h.a[f].a[1].b = false;
                        }
                    }
                }
            }
        }
        if (g) {
            c.b = true;
            c.d = g.e;
            if (l != g) {
                k = new ywb(l.d, l.e);
                fwb(a, i, g, k);
                m == g && (m = k);
            }
            m.a[m.a[1] == l ? 1 : 0] = l.a[!l.a[0] ? 1 : 0];
            --a.c;
        }
        a.b = i.a[1];
        !!a.b && (a.b.b = false);
        return c.b;
    }
    function v$(a, b) {
        var c, d, e, f, g, h, i, j, k, l, m, n, o1, p, q, r, s;
        d = Wv(rJ(a, (eM(), TL)), 28);
        i = a.e;
        h = a.a;
        c = Wv(rJ(a, (Rib(), Xhb)), 15).a;
        j = i.a + h.b + h.c + 2 * c;
        k = 0 - h.d - c - a.d.b;
        n = i.b + h.d + h.a + 2 * c - a.d.b;
        l = new GU;
        o1 = new GU;
        for(f = (m = new Snb(b.a).a.bb().mb(), new Ynb(m)); f.a.G();){
            e = (g = Wv(f.a.H(), 21), Wv(g.yb(), 9));
            switch(d.e){
                case 1:
                case 2:
                case 3:
                    m$(e);
                    break;
                case 4:
                    p = Wv(rJ(e, SL), 10);
                    q = !p ? 0 : p.a;
                    e.i.a = j * Ixb(Yv(rJ(e, Cib))) - q;
                    fX(e, true, false);
                    break;
                case 5:
                    r = Wv(rJ(e, SL), 10);
                    s = !r ? 0 : r.a;
                    e.i.a = Ixb(Yv(rJ(e, Cib))) - s;
                    fX(e, true, false);
                    i.a = Nlb(i.a, e.i.a + e.j.a / 2);
            }
            switch(Wv(rJ(e, hib), 32).e){
                case 1:
                    e.i.b = k;
                    l.c[l.c.length] = e;
                    break;
                case 3:
                    e.i.b = n;
                    o1.c[o1.c.length] = e;
            }
        }
        switch(d.e){
            case 1:
            case 2:
                o$(l, a);
                o$(o1, a);
                break;
            case 3:
                t$(l, a);
                t$(o1, a);
        }
    }
    function OY(a) {
        var b, c, d, e, f, g;
        d = Wv(rJ(a.a.g, (eM(), JL)), 86);
        if (jf(d, (oM(), b = Wv(Hkb(Gz), 11), new atb(b, Wv(exb(b, b.length), 11), 0)))) ;
        else if (Xe(d, Usb(gM))) {
            c = Wv(Wv(Dd(a.a.b, a.b), 20).sb(0), 33);
            a.b.i.a = c.i.a;
            a.b.i.b = c.i.b;
        } else if (Xe(d, Usb(iM))) {
            e = Wv(yU(a.a.c, a.a.c.c.length - 1), 9);
            f = Wv(Wv(Dd(a.a.b, a.b), 20).sb(Wv(Dd(a.a.b, a.b), 20).Y() - 1), 33);
            g = e.j.a - (f.i.a + f.j.a);
            a.b.i.a = a.a.g.j.a - g - a.b.j.a;
            a.b.i.b = f.i.b;
        } else if (Xe(d, Vsb(mM, Bv(tv(Gz, 1), uyb, 41, 0, [
            fM
        ])))) {
            c = Wv(Wv(Dd(a.a.b, a.b), 20).sb(0), 33);
            a.b.i.a = (a.a.g.j.a - a.b.j.a) / 2;
            a.b.i.b = c.i.b;
        } else if (Xe(d, Usb(mM))) {
            c = Wv(Wv(Dd(a.a.b, a.b), 20).sb(0), 33);
            a.b.i.b = c.i.b;
        } else if (Xe(d, Usb(fM))) {
            c = Wv(Wv(Dd(a.a.b, a.b), 20).sb(0), 33);
            a.b.i.a = (a.a.g.j.a - a.b.j.a) / 2;
            a.b.i.b = c.i.b;
        }
        return null;
    }
    function NZ(a) {
        var b, c, d, e, f, g, h, i, j, k, l, m, n, o1, p, q;
        for(o1 = new Tob(a); o1.a < o1.c.c.length;){
            n = Wv(Rob(o1), 9);
            MZ(n.i);
            MZ(n.j);
            PZ(n);
            RZ(n);
            for(q = new Tob(n.f); q.a < q.c.c.length;){
                p = Wv(Rob(q), 7);
                MZ(p.i);
                MZ(p.a);
                MZ(p.j);
                QX(p, QZ(p.g));
                f = Wv(rJ(p, (eM(), UL)), 24);
                !!f && sJ(p, UL, Elb(-f.a));
                for(e = new Tob(p.e); e.a < e.c.c.length;){
                    d = Wv(Rob(e), 12);
                    for(c = WI(d.a, 0); c.b != c.d.c;){
                        b = Wv(_ub(c), 10);
                        MZ(b);
                    }
                    i = Wv(rJ(d, CL), 44);
                    if (i) for(h = WI(i, 0); h.b != h.d.c;){
                        g = Wv(_ub(h), 10);
                        MZ(g);
                    }
                    for(l = new Tob(d.b); l.a < l.c.c.length;){
                        j = Wv(Rob(l), 33);
                        MZ(j.i);
                        MZ(j.j);
                    }
                }
                for(m = new Tob(p.c); m.a < m.c.c.length;){
                    j = Wv(Rob(m), 33);
                    MZ(j.i);
                    MZ(j.j);
                }
            }
            if (n.g == (CX(), xX)) {
                sJ(n, (Rib(), hib), QZ(Wv(rJ(n, hib), 32)));
                OZ(n);
            }
            for(k = new Tob(n.c); k.a < k.c.c.length;){
                j = Wv(Rob(k), 33);
                MZ(j.j);
                MZ(j.i);
            }
        }
    }
    function YP(a, b, c, d) {
        var e, f, g, h, i, j, k, l, m, n, o1, p, q, r, s;
        TP(c);
        if (SW(b.d.f, b.c.f)) {
            k = b.c;
            l = MI(Bv(tv(qz, 1), Fzb, 10, 0, [
                k.i,
                k.a
            ]));
            j = k.f.b;
            uI(l, -j.b, -j.d);
            l.a -= d.a;
            l.b -= d.b;
        } else l = MX(b.c);
        l.a += d.a;
        l.b += d.b;
        m = new Tu;
        VP(a, m, 'x', l.a);
        VP(a, m, 'y', l.b);
        Ru(c, 'sourcePoint', m);
        n = MX(b.d);
        rJ(b, (Rib(), Pib)) != null && vI(n, Wv(rJ(b, Pib), 10));
        vI(n, d);
        o1 = new Tu;
        VP(a, o1, 'x', n.a);
        VP(a, o1, 'y', n.b);
        Ru(c, 'targetPoint', o1);
        e = new ju;
        s = hJ(b.a, d);
        f = 0;
        for(r = WI(s, 0); r.b != r.d.c;){
            p = Wv(_ub(r), 10);
            i = new Tu;
            VP(a, i, 'x', p.a);
            VP(a, i, 'y', p.b);
            hu(e, f++, i);
        }
        s.b == 0 ? Ru(c, Hzb, null) : Ru(c, Hzb, e);
        g = Wv(rJ(b, (eM(), CL)), 44);
        f = 0;
        if (g) {
            hJ(g, d);
            h = new ju;
            for(q = WI(g, 0); q.b != q.d.c;){
                p = Wv(_ub(q), 10);
                i = new Tu;
                VP(a, i, 'x', p.a);
                VP(a, i, 'y', p.b);
                hu(h, f++, i);
            }
            Ru(c, Izb, h);
        } else Ru(c, Izb, null);
    }
    function pZ(a, b, c, d) {
        var e, f, g, h, i, j, k, l, m, n, o1, p, q, r;
        p = a.i;
        q = a.j;
        m = a.e;
        if (b) {
            l = d / 2 * (b.Y() - 1);
            n = 0;
            for(j = b.mb(); j.G();){
                h = Wv(j.H(), 9);
                l += h.j.a;
                n = Nlb(n, h.j.b);
            }
            r = p.a - (l - q.a) / 2;
            g = p.b - m.d + n;
            e = q.a / (b.Y() + 1);
            f = e;
            for(i = b.mb(); i.G();){
                h = Wv(i.H(), 9);
                h.i.a = r;
                h.i.b = g - h.j.b;
                r += h.j.a + d / 2;
                k = oZ(h);
                k.i.a = h.j.a / 2 - k.a.a;
                k.i.b = h.j.b;
                o1 = Wv(rJ(h, (Rib(), Zhb)), 7);
                if (o1.b.c.length + o1.e.c.length == 1) {
                    o1.i.a = f - o1.a.a;
                    o1.i.b = 0;
                    PX(o1, a);
                }
                f += e;
            }
        }
        if (c) {
            l = d / 2 * (c.Y() - 1);
            n = 0;
            for(j = c.mb(); j.G();){
                h = Wv(j.H(), 9);
                l += h.j.a;
                n = Nlb(n, h.j.b);
            }
            r = p.a - (l - q.a) / 2;
            g = p.b + q.b + m.a - n;
            e = q.a / (c.Y() + 1);
            f = e;
            for(i = c.mb(); i.G();){
                h = Wv(i.H(), 9);
                h.i.a = r;
                h.i.b = g;
                r += h.j.a + d / 2;
                k = oZ(h);
                k.i.a = h.j.a / 2 - k.a.a;
                k.i.b = 0;
                o1 = Wv(rJ(h, (Rib(), Zhb)), 7);
                if (o1.b.c.length + o1.e.c.length == 1) {
                    o1.i.a = f - o1.a.a;
                    o1.i.b = q.b;
                    PX(o1, a);
                }
                f += e;
            }
        }
    }
    function Jab(a, b, c, d, e) {
        var f, g, h, i, j, k, l, m, n, o1, p, q, r, s, t, u, v, w;
        w = 0;
        n = 0;
        for(l = new Tob(b.f); l.a < l.c.c.length;){
            k = Wv(Rob(l), 9);
            m = 0;
            h = 0;
            i = c ? Wv(rJ(k, Fab), 24).a : eyb;
            r = d ? Wv(rJ(k, Gab), 24).a : eyb;
            j = i > r ? i : r;
            for(t = new Tob(k.f); t.a < t.c.c.length;){
                s = Wv(Rob(t), 7);
                u = k.i.b + s.i.b + s.a.b;
                if (d) for(g = new Tob(s.e); g.a < g.c.c.length;){
                    f = Wv(Rob(g), 12);
                    p = f.d;
                    o1 = p.f;
                    if (b != a.a[o1.k]) {
                        q = Plb(Wv(rJ(o1, Fab), 24).a, Wv(rJ(o1, Gab), 24).a);
                        v = Wv(rJ(f, (Rib(), Eib)), 24).a;
                        if (v >= j && v >= q) {
                            m += o1.i.b + p.i.b + p.a.b - u;
                            ++h;
                        }
                    }
                }
                if (c) for(g = new Tob(s.b); g.a < g.c.c.length;){
                    f = Wv(Rob(g), 12);
                    p = f.c;
                    o1 = p.f;
                    if (b != a.a[o1.k]) {
                        q = Plb(Wv(rJ(o1, Fab), 24).a, Wv(rJ(o1, Gab), 24).a);
                        v = Wv(rJ(f, (Rib(), Eib)), 24).a;
                        if (v >= j && v >= q) {
                            m += o1.i.b + p.i.b + p.a.b - u;
                            ++h;
                        }
                    }
                }
            }
            if (h > 0) {
                w += m / h;
                ++n;
            }
        }
        if (n > 0) {
            b.a = e * w / n;
            b.i = n;
        } else {
            b.a = 0;
            b.i = 0;
        }
    }
    function Kab(a, b, c, d) {
        var e, f, g, h, i, j, k, l, m, n, o1, p, q, r, s;
        n = b.c.length;
        m = 0;
        for(l = new Tob(a.c); l.a < l.c.c.length;){
            k = Wv(Rob(l), 16);
            r = k.a;
            if (r.c.length == 0) continue;
            q = new Tob(r);
            j = 0;
            s = null;
            e = Wv(Rob(q), 9);
            while(e){
                f = Wv(yU(b, e.k), 111);
                if (f.c >= 0) {
                    i = null;
                    h = new Fnb(k.a, j + 1);
                    while(h.b < h.d.Y()){
                        g = (Bxb(h.b < h.d.Y()), Wv(h.d.sb(h.c = h.b++), 9));
                        i = Wv(yU(b, g.k), 111);
                        if (i.d == f.d && i.c < f.c) break;
                        else i = null;
                    }
                    if (i) {
                        if (s) {
                            DU(d, e.k, Elb(Wv(yU(d, e.k), 24).a - 1));
                            Wv(yU(c, s.k), 20).nb(f);
                        }
                        f = Vab(f, e, n++);
                        b.c[b.c.length] = f;
                        vU(c, new GU);
                        if (s) {
                            Wv(yU(c, s.k), 20).ib(f);
                            vU(d, Elb(1));
                        } else vU(d, Elb(0));
                    }
                }
                o1 = null;
                if (q.a < q.c.c.length) {
                    o1 = Wv(Rob(q), 9);
                    p = Wv(yU(b, o1.k), 111);
                    Wv(yU(c, e.k), 20).ib(p);
                    DU(d, o1.k, Elb(Wv(yU(d, o1.k), 24).a + 1));
                }
                f.d = m;
                f.c = j++;
                s = e;
                e = o1;
            }
            ++m;
        }
        Ckb(Ixb(Xv(rJ(a, (eM(), rL))))) && undefined;
    }
    function gS(a, b) {
        var c;
        if (a.e) throw new ulb((Gkb(nA), 'The ' + nA.j + Yzb));
        if (!MR(a.a, b)) throw new gt('The direction ' + b + ' is not supported by the CGraph instance.');
        if (b == a.d) return a;
        c = a.d;
        a.d = b;
        switch(c.e){
            case 0:
                switch(b.e){
                    case 2:
                        dS(a);
                        break;
                    case 1:
                        kS(a);
                        dS(a);
                        break;
                    case 4:
                        qS(a);
                        dS(a);
                        break;
                    case 3:
                        qS(a);
                        kS(a);
                        dS(a);
                }
                break;
            case 2:
                switch(b.e){
                    case 1:
                        kS(a);
                        lS(a);
                        break;
                    case 4:
                        qS(a);
                        dS(a);
                        break;
                    case 3:
                        qS(a);
                        kS(a);
                        dS(a);
                }
                break;
            case 1:
                switch(b.e){
                    case 2:
                        kS(a);
                        lS(a);
                        break;
                    case 4:
                        kS(a);
                        qS(a);
                        dS(a);
                        break;
                    case 3:
                        kS(a);
                        qS(a);
                        kS(a);
                        dS(a);
                }
                break;
            case 4:
                switch(b.e){
                    case 2:
                        qS(a);
                        dS(a);
                        break;
                    case 1:
                        qS(a);
                        kS(a);
                        dS(a);
                        break;
                    case 3:
                        kS(a);
                        lS(a);
                }
                break;
            case 3:
                switch(b.e){
                    case 2:
                        kS(a);
                        qS(a);
                        dS(a);
                        break;
                    case 1:
                        kS(a);
                        qS(a);
                        kS(a);
                        dS(a);
                        break;
                    case 4:
                        kS(a);
                        lS(a);
                }
        }
        return a;
    }
    function c9(a, b, c) {
        var d, e, f, g, h, i, j, k, l;
        if (a.a[b.d.k][b.k].e) return;
        else a.a[b.d.k][b.k].e = true;
        a.a[b.d.k][b.k].b = 0;
        a.a[b.d.k][b.k].d = 0;
        a.a[b.d.k][b.k].a = null;
        for(k = new Tob(b.f); k.a < k.c.c.length;){
            j = Wv(Rob(k), 7);
            l = c ? new fY(j) : new lY(j);
            for(i = l.mb(); i.G();){
                h = Wv(i.H(), 7);
                g = h.f;
                if (g.d == b.d) {
                    if (g != b) {
                        c9(a, g, c);
                        a.a[b.d.k][b.k].b += a.a[g.d.k][g.k].b;
                        a.a[b.d.k][b.k].d += a.a[g.d.k][g.k].d;
                    }
                } else {
                    a.a[b.d.k][b.k].d += a.d[h.k];
                    ++a.a[b.d.k][b.k].b;
                }
            }
        }
        f = Wv(rJ(b, (Rib(), Shb)), 20);
        if (f) for(e = f.mb(); e.G();){
            d = Wv(e.H(), 9);
            if (b.d == d.d) {
                c9(a, d, c);
                a.a[b.d.k][b.k].b += a.a[d.d.k][d.k].b;
                a.a[b.d.k][b.k].d += a.a[d.d.k][d.k].d;
            }
        }
        if (a.a[b.d.k][b.k].b > 0) {
            a.a[b.d.k][b.k].d += wvb(a.e, 24) * FAb * 0.07000000029802322 - 0.03500000014901161;
            a.a[b.d.k][b.k].a = a.a[b.d.k][b.k].d / a.a[b.d.k][b.k].b;
        }
    }
    function Sbb(a, b) {
        var c, d, e, f, g, h, i, j, k, l, m;
        for(e = new Tob(a.a.c); e.a < e.c.c.length;){
            c = Wv(Rob(e), 16);
            for(i = new Tob(c.a); i.a < i.c.c.length;){
                h = Wv(Rob(i), 9);
                b.i[h.k] = h;
                b.g[h.k] = b.k == (Lbb(), Kbb) ? Vzb : Uzb;
            }
        }
        g = a.a.c;
        b.c == (Gbb(), Ebb) && (g = aw(g, 87) ? Ii(Wv(g, 87)) : aw(g, 88) ? Wv(g, 88).a : aw(g, 63) ? new ap(g) : new Ro(g));
        Acb(a.e, b, a.b);
        bpb(b.n);
        for(f = g.mb(); f.G();){
            c = Wv(f.H(), 16);
            j = c.a;
            b.k == (Lbb(), Kbb) && (j = aw(j, 87) ? Ii(Wv(j, 87)) : aw(j, 88) ? Wv(j, 88).a : aw(j, 63) ? new ap(j) : new Ro(j));
            for(m = j.mb(); m.G();){
                l = Wv(m.H(), 9);
                b.f[l.k] == l && Tbb(a, l, b);
            }
        }
        Ubb(a, b);
        for(d = g.mb(); d.G();){
            c = Wv(d.H(), 16);
            for(m = new Tob(c.a); m.a < m.c.c.length;){
                l = Wv(Rob(m), 9);
                b.n[l.k] = b.n[b.f[l.k].k];
                if (l == b.f[l.k]) {
                    k = Ixb(b.g[b.i[l.k].k]);
                    (b.k == (Lbb(), Kbb) && k > Vzb || b.k == Jbb && k < Uzb) && (b.n[l.k] = Ixb(b.n[l.k]) + k);
                }
            }
        }
        a.e.Jc();
    }
    function NQ(a, b) {
        var c, d, e, f, g, h, i, j, k, l, m;
        pJ(b, Bv(tv(rz, 1), syb, 79, 0, [
            (Rib(), Jib),
            Xhb,
            (Mjb(), Kjb),
            Rhb
        ]));
        j = Wv(rJ(b, Jib), 15).a;
        Wv(rJ(b, qjb), 15).a * j < 2 && sJ(b, qjb, new llb(2 / j));
        k = Wv(rJ(b, (eM(), sL)), 59);
        k == (sK(), qK) && sJ(b, sL, PW(b));
        l = Wv(rJ(b, Hjb), 24);
        l.a == 0 ? sJ(b, Gib, new yvb) : sJ(b, Gib, new zvb(l.a));
        m = new $jb(b);
        sJ(b, Kib, m);
        e = KQ(a, Wv(rJ(b, ljb), 180));
        h = KQ(a, Wv(rJ(b, zjb), 180));
        d = KQ(a, Wv(rJ(b, kjb), 180));
        i = KQ(a, Wv(rJ(b, Ajb), 180));
        f = KQ(a, Ocb(Wv(rJ(b, eib), 122)));
        g = new WQ;
        sJ(b, _hb, g);
        QQ(QQ(QQ(QQ(QQ(QQ(g, e.qc(b)), h.qc(b)), d.qc(b)), i.qc(b)), f.qc(b)), MQ(b));
        c = (Mh(30, Vyb), new HU(30));
        sJ(b, Fib, c);
        xU(c, LQ(a, g, 0));
        c.c[c.c.length] = e;
        xU(c, LQ(a, g, 1));
        c.c[c.c.length] = h;
        xU(c, LQ(a, g, 2));
        c.c[c.c.length] = d;
        xU(c, LQ(a, g, 3));
        c.c[c.c.length] = i;
        xU(c, LQ(a, g, 4));
        c.c[c.c.length] = f;
        xU(c, LQ(a, g, 5));
    }
    function YO(a, b) {
        var c, d, e, f, g, h;
        f = Li(DW(a));
        if (f.Nb().V()) return;
        e = Wv(rJ(Wv(Wv(Wv(f.Nb().sb(0), 129), 224).e, 33), (kP(), iP)), 171);
        e = e == jP ? hP : e;
        h = 0;
        switch(Wv(a.e, 7).g.e){
            case 4:
            case 2:
                e == hP && (h = a.e.j.b);
                break;
            case 3:
                h = a.e.j.b;
        }
        (Wv(a.e, 7).g == (sN(), $M) || e == gP) && (f = Ii(f));
        for(d = Xl(f.Nb().mb()); d.G();){
            c = Wv(d.H(), 129);
            g = new II(c.e.i);
            if (e == gP) switch(Wv(a.e, 7).g.e){
                case 1:
                case 4:
                    g.a = -c.e.j.a - b;
                    g.b = h - b - c.e.j.b;
                    h -= b + c.e.j.b;
                    break;
                case 2:
                    g.a = a.e.j.a + b;
                    g.b = h - b - c.e.j.b;
                    h -= b + c.e.j.b;
                    break;
                case 3:
                    g.a = -c.e.j.a - b;
                    g.b = h + b;
                    h += b + c.e.j.b;
            }
            else switch(Wv(a.e, 7).g.e){
                case 4:
                    g.a = -c.e.j.a - b;
                    g.b = h + b;
                    h += b + c.e.j.b;
                    break;
                case 2:
                    g.a = a.e.j.a + b;
                    g.b = h + b;
                    h += b + c.e.j.b;
                    break;
                case 1:
                    g.a = a.e.j.a + b;
                    g.b = h - b - c.e.j.b;
                    h -= b + c.e.j.b;
                    break;
                case 3:
                    g.a = a.e.j.a + b;
                    g.b = h + b;
                    h += b + c.e.j.b;
            }
            c.e.i.a = g.a;
            c.e.i.b = g.b;
        }
    }
    function fab(a, b, c) {
        var d, e, f, g, h, i, j, k, l, m, n;
        d = 0;
        e = 0;
        for(k = 0; k < a.length; k++){
            i = a[k];
            if (LM(Wv(rJ(i, (eM(), TL)), 28))) for(g = nX(i, (sN(), ZM)).mb(); g.G();){
                f = Wv(g.H(), 7);
                if (f.b.c.length + f.e.c.length > 0) {
                    d += f.b.c.length + f.e.c.length;
                    Umb(b, f, Elb(d));
                }
            }
            else {
                for(h = nX(i, (sN(), ZM)).mb(); h.G();){
                    f = Wv(h.H(), 7);
                    d += f.b.c.length + f.e.c.length;
                }
                for(g = nX(i, ZM).mb(); g.G();){
                    f = Wv(g.H(), 7);
                    f.b.c.length + f.e.c.length > 0 && Umb(b, f, Elb(d));
                }
            }
        }
        for(j = a.length - 1; j >= 0; j--){
            i = a[j];
            if (LM(Wv(rJ(i, (eM(), TL)), 28))) for(m = nX(i, (sN(), rN)).mb(); m.G();){
                l = Wv(m.H(), 7);
                if (l.b.c.length + l.e.c.length > 0) {
                    e += l.b.c.length + l.e.c.length;
                    Umb(c, l, Elb(e));
                }
            }
            else {
                for(n = nX(i, (sN(), rN)).mb(); n.G();){
                    l = Wv(n.H(), 7);
                    e += l.b.c.length + l.e.c.length;
                }
                for(m = nX(i, rN).mb(); m.G();){
                    l = Wv(m.H(), 7);
                    l.b.c.length + l.e.c.length > 0 && Umb(c, l, Elb(e));
                }
            }
        }
    }
    function wfb(a, b, c, d, e) {
        var f, g, h, i, j, k, l, m, n, o1, p, q, r;
        m = sgb(a.g);
        o1 = sgb(b.g);
        n = vI(xI(a.i), a.a);
        p = vI(xI(b.i), b.a);
        i = vI(new HI(n.a, n.b), CI(new GI(m), 1.3 * c));
        q = vI(new HI(p.a, p.b), CI(new GI(o1), 1.3 * d));
        h = Jlb(i.a - q.a);
        h < e && (a.g == (sN(), rN) || a.g == ZM ? i.a < q.a ? i.a = q.a - e : i.a = q.a + e : i.a < q.a ? q.a = i.a + e : q.a = i.a - e);
        f = 0;
        g = 0;
        switch(a.g.e){
            case 4:
                f = 2 * (n.a - c) - 0.5 * (i.a + q.a);
                break;
            case 2:
                f = 2 * (n.a + c) - 0.5 * (i.a + q.a);
                break;
            case 1:
                g = 2 * (n.b - c) - 0.5 * (i.b + q.b);
                break;
            case 3:
                g = 2 * (n.b + c) - 0.5 * (i.b + q.b);
        }
        switch(b.g.e){
            case 4:
                f = 2 * (p.a - d) - 0.5 * (q.a + i.a);
                break;
            case 2:
                f = 2 * (p.a + d) - 0.5 * (q.a + i.a);
                break;
            case 1:
                g = 2 * (p.b - d) - 0.5 * (q.b + i.b);
                break;
            case 3:
                g = 2 * (p.b + d) - 0.5 * (q.b + i.b);
        }
        l = new HI(f, g);
        k = new ufb(Bv(tv(qz, 1), Fzb, 10, 0, [
            n,
            i,
            l,
            q,
            p
        ]));
        j = ifb(k);
        r = jfb(k);
        k.a = j;
        bfb(k, new Ffb(Bv(tv(qz, 1), Fzb, 10, 0, [
            j,
            r,
            n,
            p
        ])));
        return k;
    }
    function p$(a, b, c) {
        var d, e, f, g, h, i, j, k, l, m, n, o1, p, q;
        i = c.a;
        e = Wv(rJ(c, (Rib(), Xhb)), 15).a;
        o1 = c.d;
        h = (d = Wv(rJ(c, Xhb), 15).a, new HI(c.e.a + c.a.b + c.a.c + 2 * d, c.e.b + c.a.d + c.a.a + 2 * d));
        j = h.b;
        for(m = new Tob(a.a); m.a < m.c.c.length;){
            k = Wv(Rob(m), 9);
            if (k.g != (CX(), xX)) continue;
            f = Wv(rJ(k, hib), 32);
            g = Wv(rJ(k, iib), 10);
            n = k.i;
            switch(f.e){
                case 2:
                    n.a = c.e.a + e + i.c - o1.a;
                    break;
                case 4:
                    n.a = -o1.a - e - i.b;
            }
            q = 0;
            switch(f.e){
                case 2:
                case 4:
                    if (b == (KM(), GM)) {
                        p = Ixb(Yv(rJ(k, Cib)));
                        n.b = h.b * p - Wv(rJ(k, (eM(), SL)), 10).b;
                        q = n.b + g.b;
                        fX(k, false, true);
                    } else if (b == FM) {
                        n.b = Ixb(Yv(rJ(k, Cib))) - Wv(rJ(k, (eM(), SL)), 10).b;
                        q = n.b + g.b;
                        fX(k, false, true);
                    }
            }
            j = j > q ? j : q;
        }
        c.e.b += j - h.b;
        for(l = new Tob(a.a); l.a < l.c.c.length;){
            k = Wv(Rob(l), 9);
            if (k.g != (CX(), xX)) continue;
            f = Wv(rJ(k, hib), 32);
            n = k.i;
            switch(f.e){
                case 1:
                    n.b = -o1.b - e - i.d;
                    break;
                case 3:
                    n.b = c.e.b + e + i.a - o1.b;
            }
        }
    }
    function $Y(a) {
        var b, c, d, e, f, g, h, i, j, k, l, m, n, o1;
        e = new GU;
        for(i = new Tob(a.d.f); i.a < i.c.c.length;){
            g = Wv(Rob(i), 7);
            g.g == (sN(), ZM) && (e.c[e.c.length] = g);
        }
        if (a.e.a == (sK(), pK) && !MM(Wv(rJ(a.d, (eM(), TL)), 28))) for(d = Uh(mX(a.d)); Cm(d);){
            c = Wv(Dm(d), 12);
            vU(e, c.c);
        }
        f = a.d.j.a;
        sJ(a.d, (Rib(), Whb), new llb(a.d.j.a));
        a.d.j.a = a.c;
        sJ(a.d, Vhb, (xkb(), xkb(), wkb));
        vU(a.b, a.d);
        j = a.d;
        f -= a.c;
        k = a.a;
        while(k > 1){
            b = Qlb(f, a.c);
            j = (l = new uX(a.e.c), sX(l, (CX(), wX)), sJ(l, (eM(), TL), Wv(rJ(j, TL), 28)), sJ(l, JL, Wv(rJ(j, JL), 86)), l.k = a.e.b++, vU(a.b, l), l.j.b = j.j.b, l.j.a = b, m = new RX, QX(m, (sN(), ZM)), PX(m, j), m.i.a = l.j.a, m.i.b = l.j.b / 2, n = new RX, QX(n, rN), PX(n, l), n.i.b = l.j.b / 2, n.i.a = -n.j.a, o1 = new hW, dW(o1, m), eW(o1, n), l);
            vU(a.e.c.b, j);
            --k;
            f -= a.c + a.e.d;
        }
        new HY(a.d, a.b, a.c);
        for(h = new Tob(e); h.a < h.c.c.length;){
            g = Wv(Rob(h), 7);
            BU(a.d.f, g);
            PX(g, j);
        }
    }
    function Qfb(a, b) {
        var c, d, e, f, g, h, i, j, k, l, m, n;
        if (a.p > b.a || b.p > a.a) return;
        c = 0;
        d = 0;
        for(l = (g = new Snb(a.o.a).a.bb().mb(), new Ynb(g)); l.a.G();){
            j = (e = Wv(l.a.H(), 21), Wv(e.yb(), 7));
            qgb(MI(Bv(tv(qz, 1), Fzb, 10, 0, [
                j.f.i,
                j.i,
                j.a
            ])).b, b.p, b.a) && ++c;
        }
        for(m = (h = new Snb(a.g.a).a.bb().mb(), new Ynb(h)); m.a.G();){
            j = (e = Wv(m.a.H(), 21), Wv(e.yb(), 7));
            qgb(MI(Bv(tv(qz, 1), Fzb, 10, 0, [
                j.f.i,
                j.i,
                j.a
            ])).b, b.p, b.a) && --c;
        }
        for(n = (i = new Snb(b.o.a).a.bb().mb(), new Ynb(i)); n.a.G();){
            j = (e = Wv(n.a.H(), 21), Wv(e.yb(), 7));
            qgb(MI(Bv(tv(qz, 1), Fzb, 10, 0, [
                j.f.i,
                j.i,
                j.a
            ])).b, a.p, a.a) && ++d;
        }
        for(k = (f = new Snb(b.g.a).a.bb().mb(), new Ynb(f)); k.a.G();){
            j = (e = Wv(k.a.H(), 21), Wv(e.yb(), 7));
            qgb(MI(Bv(tv(qz, 1), Fzb, 10, 0, [
                j.f.i,
                j.i,
                j.a
            ])).b, a.p, a.a) && --d;
        }
        if (c < d) new bgb(a, b, d - c);
        else if (d < c) new bgb(b, a, c - d);
        else {
            new bgb(b, a, 0);
            new bgb(a, b, 0);
        }
    }
    function $jb(a) {
        var b;
        this.f = Wv(rJ(a, (Rib(), Jib)), 15).a;
        this.d = Wv(rJ(a, (Mjb(), Ejb)), 15).a;
        this.a = this.f * Wv(rJ(a, qjb), 15).a;
        this.b = this.f * Wv(rJ(a, pjb), 15).a;
        Wv(rJ(a, Dib), 15);
        this.c = Wv(rJ(a, Dib), 15).a;
        this.e = Wv(rJ(a, (eM(), DL)), 15).a;
        b = (CX(), Bv(tv(pB, 1), uyb, 132, 0, [
            AX,
            zX,
            xX,
            BX,
            yX,
            wX
        ])).length;
        this.g = vv(lw, [
            Txb,
            tAb
        ], [
            250,
            26
        ], 12, [
            b,
            b
        ], 2);
        Yjb(this, AX, this.f);
        Zjb(this, AX, zX, this.b);
        Zjb(this, AX, BX, this.b);
        Zjb(this, AX, xX, this.c);
        Zjb(this, AX, yX, this.b);
        Zjb(this, AX, wX, this.b);
        Yjb(this, zX, this.a);
        Zjb(this, zX, BX, this.a);
        Zjb(this, zX, xX, this.c);
        Zjb(this, zX, yX, this.e);
        Zjb(this, zX, wX, this.b);
        Yjb(this, BX, this.a);
        Zjb(this, BX, xX, this.c);
        Zjb(this, BX, yX, this.e);
        Zjb(this, BX, wX, this.b);
        Yjb(this, xX, this.c);
        Zjb(this, xX, yX, this.c);
        Zjb(this, xX, wX, this.c);
        Yjb(this, yX, this.e);
        Zjb(this, yX, wX, this.e);
        Yjb(this, wX, this.f);
    }
    function mZ(a, b) {
        var c, d, e, f, g, h, i, j, k;
        if (tl(iX(b)) != 1 || Wv(ql(iX(b)), 12).c.f.g != (CX(), zX)) return null;
        c = Wv(ql(iX(b)), 12);
        d = c.c.f;
        sX(d, (CX(), AX));
        sJ(d, (Rib(), qib), null);
        sJ(d, rib, null);
        sJ(d, Whb, Wv(rJ(b, Whb), 15));
        sJ(d, Vhb, (xkb(), xkb(), wkb));
        sJ(d, uib, rJ(b, uib));
        d.j.b = b.j.b;
        f = rJ(c.d, uib);
        g = null;
        for(j = nX(d, (sN(), rN)).mb(); j.G();){
            h = Wv(j.H(), 7);
            if (h.b.c.length != 0) {
                sJ(h, uib, f);
                k = c.d;
                h.j.a = k.j.a;
                h.j.b = k.j.b;
                h.a.a = k.a.a;
                h.a.b = k.a.b;
                xU(h.c, k.c);
                k.c.c = xv(UF, syb, 1, 0, 4, 1);
                g = h;
                break;
            }
        }
        sJ(c.d, uib, null);
        if (tl(nX(b, rN)) > 1) for(i = WI(Eo(nX(b, rN)), 0); i.b != i.d.c;){
            h = Wv(_ub(i), 7);
            if (h.b.c.length == 0) {
                e = new RX;
                QX(e, rN);
                e.j.a = h.j.a;
                e.j.b = h.j.b;
                PX(e, d);
                sJ(e, uib, rJ(h, uib));
                PX(h, null);
            } else PX(g, d);
        }
        sJ(b, uib, null);
        sJ(b, Vhb, vkb);
        sX(b, wX);
        sJ(d, (eM(), TL), Wv(rJ(b, TL), 28));
        sJ(d, JL, Wv(rJ(b, JL), 86));
        uU(a.b, 0, d);
        return d;
    }
    function NW(a, b, c, d, e, f, g) {
        var h, i, j, k, l, m;
        l = c;
        j = new uX(g);
        sX(j, (CX(), xX));
        sJ(j, (Rib(), iib), e);
        sJ(j, (eM(), TL), (KM(), FM));
        sJ(j, tib, Wv(rJ(a, LL), 15));
        i = Wv(rJ(a, SL), 10);
        !i && (i = new HI(e.a / 2, e.b / 2));
        sJ(j, SL, i);
        k = new RX;
        PX(k, j);
        if (!(b != IM && b != JM)) {
            h = f != (sK(), qK) ? f : pK;
            d > 0 ? l = vN(h) : l = tN(vN(h));
            sJ(a, WL, l);
        }
        switch(l.e){
            case 4:
                sJ(j, (Mjb(), vjb), (Xib(), Tib));
                sJ(j, dib, (Hgb(), Ggb));
                j.j.b = e.b;
                QX(k, (sN(), ZM));
                k.i.b = i.b;
                break;
            case 2:
                sJ(j, (Mjb(), vjb), (Xib(), Vib));
                sJ(j, dib, (Hgb(), Egb));
                j.j.b = e.b;
                QX(k, (sN(), rN));
                k.i.b = i.b;
                break;
            case 1:
                sJ(j, mib, (Hhb(), Ghb));
                j.j.a = e.a;
                QX(k, (sN(), pN));
                k.i.a = i.a;
                break;
            case 3:
                sJ(j, mib, (Hhb(), Ehb));
                j.j.a = e.a;
                QX(k, (sN(), $M));
                k.i.a = i.a;
        }
        if (b == EM || b == GM || b == FM) {
            m = 0;
            switch(l.e){
                case 4:
                case 2:
                    m = null.cd;
                    b == GM && (m /= null.cd);
                    break;
                case 1:
                case 3:
                    m = null.cd;
                    b == GM && (m /= null.cd);
            }
            sJ(j, Cib, m);
        }
        sJ(j, hib, l);
        return j;
    }
    function LP(a) {
        var b, c, d, e, f, g, h, i, j, k, l, m, n, o1, p, q, r, s, t;
        j = new jJ;
        r = (mp(), new ntb);
        Umb(r, a, MP(a));
        d = (Mh(2, Vyb), new HU(2));
        !!a.c && vU(d, a.c);
        !!a.d && vU(d, a.d);
        for(n = new Tob(d); n.a < n.c.c.length;){
            m = Wv(Rob(n), 7);
            b = new aJ;
            Ue(b, Ao(Sh((Gi(), new gr(Ti(Bv(tv(UF, 1), syb, 1, 4, [
                m.b,
                m.e
            ])))))));
            Ve(b, a, true);
            if (b.b != 0) {
                t = Wv(re(Ktb(r.d, a)), 34);
                if (m == a.d) {
                    o1 = t[t.length - 1];
                    s = true;
                } else {
                    o1 = t[0];
                    s = false;
                }
                for(i = 1; i < t.length; i++){
                    s ? p = t[t.length - 1 - i] : p = t[i];
                    c = WI(b, 0);
                    while(c.b != c.d.c){
                        k = Wv(_ub(c), 12);
                        l = Wv(re(Ktb(r.d, k)), 34);
                        if (l == null) {
                            l = MP(k);
                            Ltb(r.d, k, l);
                        }
                        if (l.length <= i) bvb(c);
                        else {
                            s ? q = l[l.length - 1 - i] : q = l[i];
                            if (p.a != q.a || p.b != q.b) {
                                e = p.a - o1.a;
                                g = p.b - o1.b;
                                f = q.a - o1.a;
                                h = q.b - o1.b;
                                f * g == h * e && NP(e) == NP(f) && NP(g) == NP(h) ? ((e <= 0 ? 0 - e : e) < (f <= 0 ? 0 - f : f) || (g <= 0 ? 0 - g : g) < (h <= 0 ? 0 - h : h)) && TI(j, p, j.c.b, j.c) : i > 1 && TI(j, o1, j.c.b, j.c);
                                bvb(c);
                            }
                        }
                    }
                    o1 = p;
                }
            }
        }
        return j;
    }
    function m1(a) {
        var b, c, d, e, f, g, h, i, j, k, l, m, n, o1, p;
        a.n = Wv(rJ(a.g, (Rib(), Jib)), 15).a * Wv(rJ(a.g, (Mjb(), Ejb)), 15).a;
        a.e = a.n * Wv(rJ(a.g, qjb), 15).a;
        a.i = a.g.c.c.length;
        h = a.i - 1;
        m = 0;
        a.j = 0;
        a.k = 0;
        a.a = Co(xv(PF, Txb, 24, a.i, 0, 1));
        a.b = Co(xv(HF, Txb, 184, a.i, 6, 1));
        for(g = new Tob(a.g.c); g.a < g.c.c.length;){
            e = Wv(Rob(g), 16);
            e.k = h;
            for(l = new Tob(e.a); l.a < l.c.c.length;){
                k = Wv(Rob(l), 9);
                k.k = m;
                ++m;
            }
            --h;
        }
        a.f = xv(mw, Yyb, 26, m, 12, 1);
        a.c = vv(mw, [
            Txb,
            Yyb
        ], [
            52,
            26
        ], 12, [
            m,
            3
        ], 2);
        a.o = new GU;
        a.p = new GU;
        b = 0;
        a.d = 0;
        for(f = new Tob(a.g.c); f.a < f.c.c.length;){
            e = Wv(Rob(f), 16);
            h = e.k;
            d = 0;
            p = 0;
            i = e.a.c.length;
            j = 0;
            for(l = new Tob(e.a); l.a < l.c.c.length;){
                k = Wv(Rob(l), 9);
                m = k.k;
                a.f[m] = k.d.k;
                j += k.j.b + a.n;
                c = tl(iX(k));
                o1 = tl(mX(k));
                a.c[m][0] = o1 - c;
                a.c[m][1] = c;
                a.c[m][2] = o1;
                d += c;
                p += o1;
                c > 0 && vU(a.p, k);
                vU(a.o, k);
            }
            b -= d;
            n = i + b;
            j += b * a.e;
            DU(a.a, h, Elb(n));
            DU(a.b, h, j);
            a.j = Plb(a.j, n);
            a.k = Nlb(a.k, j);
            a.d += b;
            b += p;
        }
    }
    function sN() {
        sN = iI;
        var a;
        qN = new uN(szb, 0);
        $M = new uN('NORTH', 1);
        ZM = new uN('EAST', 2);
        pN = new uN('SOUTH', 3);
        rN = new uN('WEST', 4);
        dN = (ypb(), new Frb((a = Wv(Hkb(Kz), 11), new atb(a, Wv(exb(a, a.length), 11), 0))));
        eN = Kk(Vsb($M, Bv(tv(Kz, 1), uyb, 32, 0, [])));
        _M = Kk(Vsb(ZM, Bv(tv(Kz, 1), uyb, 32, 0, [])));
        mN = Kk(Vsb(pN, Bv(tv(Kz, 1), uyb, 32, 0, [])));
        oN = Kk(Vsb(rN, Bv(tv(Kz, 1), uyb, 32, 0, [])));
        jN = Kk(Vsb($M, Bv(tv(Kz, 1), uyb, 32, 0, [
            pN
        ])));
        cN = Kk(Vsb(ZM, Bv(tv(Kz, 1), uyb, 32, 0, [
            rN
        ])));
        lN = Kk(Vsb($M, Bv(tv(Kz, 1), uyb, 32, 0, [
            rN
        ])));
        fN = Kk(Vsb($M, Bv(tv(Kz, 1), uyb, 32, 0, [
            ZM
        ])));
        nN = Kk(Vsb(pN, Bv(tv(Kz, 1), uyb, 32, 0, [
            rN
        ])));
        aN = Kk(Vsb(ZM, Bv(tv(Kz, 1), uyb, 32, 0, [
            pN
        ])));
        iN = Kk(Vsb($M, Bv(tv(Kz, 1), uyb, 32, 0, [
            ZM,
            rN
        ])));
        bN = Kk(Vsb(ZM, Bv(tv(Kz, 1), uyb, 32, 0, [
            pN,
            rN
        ])));
        kN = Kk(Vsb($M, Bv(tv(Kz, 1), uyb, 32, 0, [
            pN,
            rN
        ])));
        gN = Kk(Vsb($M, Bv(tv(Kz, 1), uyb, 32, 0, [
            ZM,
            pN
        ])));
        hN = Kk(Vsb($M, Bv(tv(Kz, 1), uyb, 32, 0, [
            ZM,
            pN,
            rN
        ])));
    }
    function q$(a) {
        var b, c, d, e, f, g, h, i, j, k, l, m, n, o1, p, q, r, s, t, u, v, w, A, B, C;
        u = new GU;
        for(m = new Tob(a.c); m.a < m.c.c.length;){
            l = Wv(Rob(m), 16);
            for(p = new Tob(l.a); p.a < p.c.c.length;){
                n = Wv(Rob(p), 9);
                if (n.g != (CX(), xX)) continue;
                if (rJ(n, (Rib(), gib)) == null) continue;
                q = null;
                s = null;
                r = null;
                for(A = new Tob(n.f); A.a < A.c.c.length;){
                    w = Wv(Rob(A), 7);
                    switch(w.g.e){
                        case 4:
                            q = w;
                            break;
                        case 2:
                            s = w;
                            break;
                        default:
                            r = w;
                    }
                }
                t = Wv(yU(r.e, 0), 12);
                i = new kJ(t.a);
                h = new II(r.i);
                vI(h, n.i);
                j = WI(i, 0);
                $ub(j, h);
                v = lJ(t.a);
                k = new II(r.i);
                vI(k, n.i);
                TI(v, k, v.c.b, v.c);
                B = Wv(rJ(n, gib), 9);
                C = Wv(yU(B.f, 0), 7);
                g = Wv(FU(q.b, xv(dB, gAb, 12, 0, 0, 1)), 47);
                for(d = 0, f = g.length; d < f; ++d){
                    b = g[d];
                    eW(b, C);
                    gJ(b.a, b.a.b, i);
                }
                g = Wv(FU(s.e, xv(dB, gAb, 12, s.e.c.length, 0, 1)), 47);
                for(c = 0, e = g.length; c < e; ++c){
                    b = g[c];
                    dW(b, C);
                    gJ(b.a, 0, v);
                }
                dW(t, null);
                eW(t, null);
                u.c[u.c.length] = n;
            }
        }
        for(o1 = new Tob(u); o1.a < o1.c.c.length;){
            n = Wv(Rob(o1), 9);
            rX(n, null);
        }
    }
    function _tb() {
        function e() {
            this.obj = this.createObject();
        }
        e.prototype.createObject = function(a) {
            return Object.create(null);
        };
        e.prototype.get = function(a) {
            return this.obj[a];
        };
        e.prototype.set = function(a, b) {
            this.obj[a] = b;
        };
        e.prototype[$Ab] = function(a) {
            delete this.obj[a];
        };
        e.prototype.keys = function() {
            return Object.getOwnPropertyNames(this.obj);
        };
        e.prototype.entries = function() {
            var b = this.keys();
            var c = this;
            var d = 0;
            return {
                'next': function() {
                    if (d >= b.length) return {
                        'done': true
                    };
                    var a = b[d++];
                    return {
                        'value': [
                            a,
                            c.get(a)
                        ],
                        'done': false
                    };
                }
            };
        };
        if (!Ztb()) {
            e.prototype.createObject = function() {
                return {};
            };
            e.prototype.get = function(a) {
                return this.obj[':' + a];
            };
            e.prototype.set = function(a, b) {
                this.obj[':' + a] = b;
            };
            e.prototype[$Ab] = function(a) {
                delete this.obj[':' + a];
            };
            e.prototype.keys = function() {
                var a = [];
                for(var b in this.obj)b.charCodeAt(0) == 58 && a.push(b.substring(1));
                return a;
            };
        }
        return e;
    }
    function fQ(a, b, c) {
        var d, e, f, g, h, i, j, k, l, m, n, o1, p, q, r, s, t, u;
        k = new kW;
        sJ(k, PP, b);
        Umb(a.e, b, k);
        sJ(k, (Rib(), zib), c);
        !!a.d && iQ(a.d, k, false);
        hQ(b, k);
        if (Lzb in b.a) {
            q = k.a;
            r = Wv(Pu(b, Lzb), 69);
            p = Wv(Pu(r, 'left'), 104);
            !!p && (q.b = p.a);
            t = Wv(Pu(r, 'top'), 104);
            !!t && (q.d = t.a);
            s = Wv(Pu(r, 'right'), 104);
            !!s && (q.c = s.a);
            e = Wv(Pu(r, Azb), 104);
            !!e && (q.a = e.a);
        }
        l = (d = Wv(Hkb(mF), 11), new atb(d, Wv(exb(d, d.length), 11), 0));
        sJ(k, jib, l);
        a.g == null && (a.g = Xv(rJ(k, (zQ(), yQ))));
        if (Mzb in b.a) {
            u = Pu(b, Mzb);
            if (!u.hc()) throw new GQ("The 'children' property of nodes must be an array.", u, b);
            j = u.hc();
            if (j.a.length > 0) {
                !!c && sJ(c, sib, k);
                h = xv(qB, Nzb, 9, j.a.length, 0, 1);
                for(n = 0; n < j.a.length; ++n){
                    i = gu(j, n);
                    if (!i.kc()) throw new GQ("A 'children' array contains a non-object node element.", i, b);
                    f = eQ(a, i.kc(), k);
                    h[n] = f;
                }
                for(m = 0; m < j.a.length; ++m){
                    o1 = gu(j, m).kc();
                    g = h[m];
                    Mzb in o1.a && !Ckb(Ixb(Xv(rJ(g, (eM(), KL))))) && fQ(a, o1, g);
                }
            }
        }
        return k;
    }
    function LO(a, b) {
        var c, d, e, f, g, h, i, j, k, l, m, n, o1, p;
        if (!Qob(new Tob(AW(a.e)))) return;
        for(h = new Tob(AW(a.e)); h.a < h.c.c.length;){
            g = Wv(Rob(h), 161);
            j = Wv(g.e, 7).g.e;
            ++a.o[j];
            switch(Wv(g.e, 7).g.e){
                case 4:
                case 2:
                    a.n[j] += g.e.j.b + (b ? (d = Wv(g.e, 7).d, new EP(d.d, d.b, d.a, d.c)).a + (e = Wv(g.e, 7).d, new EP(e.d, e.b, e.a, e.c)).d : 0);
                    break;
                case 1:
                case 3:
                    a.n[j] += g.e.j.a + (b ? (f = Wv(g.e, 7).d, new EP(f.d, f.b, f.a, f.c)).b + (c = Wv(g.e, 7).d, new EP(c.d, c.b, c.a, c.c)).c : 0);
            }
        }
        i = Wv(oW(a.e, (eM(), NL)), 100);
        i = i == (zM(), yM) ? xM : i;
        a.g[1] = Wv(oW(a.e, PL), 100);
        a.g[3] = Wv(oW(a.e, QL), 100);
        a.g[4] = Wv(oW(a.e, RL), 100);
        a.g[2] = Wv(oW(a.e, OL), 100);
        for(l = (sN(), Bv(tv(Kz, 1), uyb, 32, 0, [
            qN,
            $M,
            ZM,
            pN,
            rN
        ])), n = 0, p = l.length; n < p; ++n){
            j = l[n];
            a.g[j.e] = a.g[j.e] == yM ? i : a.g[j.e];
        }
        a.b = oW(a.e, jL) != null;
        for(k = Bv(tv(Kz, 1), uyb, 32, 0, [
            qN,
            $M,
            ZM,
            pN,
            rN
        ]), m = 0, o1 = k.length; m < o1; ++m){
            j = k[m];
            a.o[j.e] == 1 ? a.i[j.e] = 2 : !a.b && a.g[j.e] == xM ? a.i[j.e] = a.o[j.e] + 1 : a.i[j.e] = a.o[j.e] - 1;
        }
    }
    function Tfb(a, b, c, d, e, f) {
        var g, h, i, j, k, l, m, n, o1, p, q, r, s, t, u, v;
        i = Wv(a.a, 16);
        p = Wv(a.b, 16);
        j = Wv(b.a, 18);
        q = Wv(b.b, 18);
        if (i) for(l = new Tob(i.a); l.a < l.c.c.length;){
            k = Wv(Rob(l), 9);
            for(t = nX(k, (sN(), ZM)).mb(); t.G();){
                s = Wv(t.H(), 7);
                j.ib(s);
                for(h = new Tob(s.e); h.a < h.c.c.length;){
                    g = Wv(Rob(h), 12);
                    if (bW(g)) continue;
                    c.c[c.c.length] = g;
                    Ufb(g, d);
                    r = g.c.f.g;
                    (r == (CX(), AX) || r == BX) && (e.c[e.c.length] = g);
                    v = g.d;
                    u = v.f.d;
                    u == p ? q.ib(v) : u == i ? j.ib(v) : BU(c, g);
                }
            }
        }
        if (p) for(l = new Tob(p.a); l.a < l.c.c.length;){
            k = Wv(Rob(l), 9);
            for(o1 = new Tob(k.f); o1.a < o1.c.c.length;){
                n = Wv(Rob(o1), 7);
                for(h = new Tob(n.e); h.a < h.c.c.length;){
                    g = Wv(Rob(h), 12);
                    bW(g) && (m = f.a.db(g, f), m);
                }
            }
            for(t = nX(k, (sN(), rN)).mb(); t.G();){
                s = Wv(t.H(), 7);
                q.ib(s);
                for(h = new Tob(s.e); h.a < h.c.c.length;){
                    g = Wv(Rob(h), 12);
                    if (bW(g)) continue;
                    c.c[c.c.length] = g;
                    Ufb(g, d);
                    r = g.c.f.g;
                    (r == (CX(), AX) || r == BX) && (e.c[e.c.length] = g);
                    v = g.d;
                    u = v.f.d;
                    u == p ? q.ib(v) : u == i ? j.ib(v) : BU(c, g);
                }
            }
        }
    }
    function acb(a, b, c) {
        var d, e, f, g, h, i, j, k, l, m, n, o1, p, q, r, s, t, u, v, w, A, B;
        t = b.c.length;
        e = new Cbb(a.b, c, null, null);
        B = xv(kw, hyb, 26, t, 12, 1);
        p = xv(kw, hyb, 26, t, 12, 1);
        o1 = xv(kw, hyb, 26, t, 12, 1);
        q = 0;
        for(h = 0; h < t; h++){
            p[h] = $xb;
            o1[h] = eyb;
        }
        for(i = 0; i < t; i++){
            d = (Cxb(i, b.c.length), Wv(b.c[i], 81));
            B[i] = Abb(d);
            B[q] > B[i] && (q = i);
            for(l = new Tob(a.b.c); l.a < l.c.c.length;){
                k = Wv(Rob(l), 16);
                for(s = new Tob(k.a); s.a < s.c.c.length;){
                    r = Wv(Rob(s), 9);
                    w = Ixb(d.n[r.k]) + Ixb(d.d[r.k]);
                    p[i] = p[i] < w ? p[i] : w;
                    o1[i] = Nlb(o1[i], w + r.j.b);
                }
            }
        }
        A = xv(kw, hyb, 26, t, 12, 1);
        for(j = 0; j < t; j++)(Cxb(j, b.c.length), Wv(b.c[j], 81)).k == (Lbb(), Jbb) ? A[j] = p[q] - p[j] : A[j] = o1[q] - o1[j];
        f = xv(kw, hyb, 26, t, 12, 1);
        for(n = new Tob(a.b.c); n.a < n.c.c.length;){
            m = Wv(Rob(n), 16);
            for(v = new Tob(m.a); v.a < v.c.c.length;){
                u = Wv(Rob(v), 9);
                for(g = 0; g < t; g++)f[g] = Ixb((Cxb(g, b.c.length), Wv(b.c[g], 81)).n[u.k]) + Ixb((Cxb(g, b.c.length), Wv(b.c[g], 81)).d[u.k]) + A[g];
                kpb(f);
                e.n[u.k] = (f[1] + f[2]) / 2;
                e.d[u.k] = 0;
            }
        }
        return e;
    }
    function Sfb(a, b, c, d, e, f) {
        var g, h, i, j, k, l, m, n, o1, p, q, r, s, t, u, v;
        p = null;
        c == (fgb(), dgb) ? p = a : c == egb && (p = b);
        for(r = (m = new Snb(p.a).a.bb().mb(), new Ynb(m)); r.a.G();){
            q = (k = Wv(r.a.H(), 21), Wv(k.yb(), 7));
            s = MI(Bv(tv(qz, 1), Fzb, 10, 0, [
                q.f.i,
                q.i,
                q.a
            ])).b;
            v = new vtb;
            g = new vtb;
            for(i = Uh(Sh((Gi(), new gr(Ti(Bv(tv(UF, 1), syb, 1, 4, [
                q.b,
                q.e
            ])))))); Cm(i);){
                h = Wv(Dm(i), 12);
                if (Ckb(Ixb(Xv(rJ(h, (Rib(), Iib))))) != d) continue;
                if (zU(e, h, 0) != -1) {
                    h.d == q ? t = h.c : t = h.d;
                    u = MI(Bv(tv(qz, 1), Fzb, 10, 0, [
                        t.f.i,
                        t.i,
                        t.a
                    ])).b;
                    if ((u - s <= 0 ? 0 - (u - s) : u - s) < 0.2) continue;
                    u < s ? a.a.R(t) ? stb(v, new RJ(dgb, h)) : stb(v, new RJ(egb, h)) : a.a.R(t) ? stb(g, new RJ(dgb, h)) : stb(g, new RJ(egb, h));
                }
            }
            if (v.a.Y() > 1) {
                vU(f, new mgb(q, v, c));
                for(o1 = (l = new Snb(v.a).a.bb().mb(), new Ynb(l)); o1.a.G();){
                    n = (j = Wv(o1.a.H(), 21), Wv(j.yb(), 27));
                    BU(e, n.b);
                }
            }
            if (g.a.Y() > 1) {
                vU(f, new mgb(q, g, c));
                for(o1 = (l = new Snb(g.a).a.bb().mb(), new Ynb(l)); o1.a.G();){
                    n = (j = Wv(o1.a.H(), 21), Wv(j.yb(), 27));
                    BU(e, n.b);
                }
            }
        }
    }
    function dab(a) {
        var b, c, d, e, f, g, h, i, j, k, l, m, n, o1, p, q, r, s, t, u, v, w, A;
        e = 0;
        s = 0;
        r = (mp(), new ntb);
        d = new ntb;
        f = new ntb;
        A = new ntb;
        fab(a, f, A);
        b = null;
        q = 0;
        w = 0;
        t = true;
        i = true;
        for(m = 0, o1 = a.length; m < o1; ++m){
            k = a[m];
            for(v = new Tob(k.f); v.a < v.c.c.length;){
                u = Wv(Rob(v), 7);
                switch(u.g.e){
                    case 2:
                        e += cab(u, f);
                        break;
                    case 4:
                        e += cab(u, A);
                }
            }
            p = k.g;
            if (i && (p == (CX(), AX) || p == BX)) {
                j = Wv(rJ(k, (Rib(), nib)), 9);
                if (!j) {
                    i = false;
                    continue;
                }
                if (b != j) {
                    !!b && Umb(r, b, new RJ(Elb(q), Elb(w)));
                    b = j;
                    q = 0;
                    w = 0;
                    t = true;
                }
                k == b && (t = false);
                if (t) {
                    q += Wv(rJ(k, aib), 24).a;
                    Umb(d, k, Elb(q));
                } else {
                    w += Wv(rJ(k, aib), 24).a;
                    Umb(d, k, Elb(w));
                }
            }
        }
        !!b && Umb(r, b, new RJ(Elb(q), Elb(w)));
        if (i) {
            h = null;
            g = 0;
            c = 0;
            t = true;
            for(l = 0, n = a.length; l < n; ++l){
                k = a[l];
                p = k.g;
                switch(p.e){
                    case 0:
                        g = Wv(re(Ktb(d.d, k)), 24).a;
                        c = Wv(Wv(re(Ktb(r.d, k)), 27).b, 24).a;
                        h = k;
                        t = false;
                        break;
                    case 3:
                        g = Wv(re(Ktb(d.d, k)), 24).a;
                        j = Wv(rJ(k, (Rib(), nib)), 9);
                        if (j != h) {
                            c = Wv(Wv(re(Ktb(r.d, j)), 27).a, 24).a;
                            h = j;
                            t = true;
                        }
                        break;
                    default:
                        s += t ? g : c - g;
                }
            }
        }
        return e + s;
    }
    function S4(a) {
        var b, c, d, e, f, g, h, i, j, k, l, m, n, o1, p, q, r, s, t;
        l = (mp(), new ntb);
        j = new xk;
        for(d = new Tob(a.a.a.b); d.a < d.c.c.length;){
            b = Wv(Rob(d), 25);
            if (aw(b, 93)) {
                k = Wv(b, 93).b;
                Ltb(l.d, k, b);
            } else if (aw(b, 82)) for(f = (o1 = new Snb(Wv(b, 82).d.a).a.bb().mb(), new Ynb(o1)); f.a.G();){
                e = (g = Wv(f.a.H(), 21), Wv(g.yb(), 12));
                Fd(j, e, b);
            }
        }
        for(c = new Tob(a.a.a.b); c.a < c.c.c.length;){
            b = Wv(Rob(c), 25);
            if (aw(b, 93)) {
                k = Wv(b, 93).b;
                for(i = Uh(mX(k)); Cm(i);){
                    h = Wv(Dm(i), 12);
                    if (bW(h)) continue;
                    q = h.c;
                    t = h.d;
                    if ((sN(), jN).kb(h.c.g) && jN.kb(h.d.g)) continue;
                    r = Wv(Smb(l, h.d.f), 25);
                    f7(i7(h7(j7(g7(new k7, 0), 100), a.c[b.f.d]), a.c[r.f.d]));
                    if (q.g == rN && TX((LX(), IX, q))) for(n = Wv(Dd(j, h), 18).mb(); n.G();){
                        m = Wv(n.H(), 25);
                        if (m.j.d < b.j.d) {
                            p = a.c[m.f.d];
                            s = a.c[b.f.d];
                            if (p == s) continue;
                            f7(i7(h7(j7(g7(new k7, 1), 100), p), s));
                        }
                    }
                    if (t.g == ZM && WX((LX(), GX, t))) for(n = Wv(Dd(j, h), 18).mb(); n.G();){
                        m = Wv(n.H(), 25);
                        if (m.j.d > b.j.d) {
                            p = a.c[b.f.d];
                            s = a.c[m.f.d];
                            if (p == s) continue;
                            f7(i7(h7(j7(g7(new k7, 1), 100), p), s));
                        }
                    }
                }
            }
        }
    }
    function t3(a, b) {
        var c, d, e, f, g, h, i, j, k, l, m, n, o1;
        g = new z3(a);
        h = Ao(pl(b, g));
        Gpb(h, new C3);
        e = a.b;
        switch(e.c){
            case 2:
                i = new E3(e.a);
                c = Al(pl(h, i));
                od(c) ? j = Wv(pd(c), 91).b : j = 15;
                i = new E3(Jeb(e));
                c = Al(pl(h, i));
                od(c) ? f = Wv(pd(c), 91).b : f = 15;
                i = new E3(e.b);
                c = Al(pl(h, i));
                od(c) ? k = Wv(pd(c), 91).b : k = 15;
                d = p3(a, j, f, k);
                stb(b, new w3(d, a.c, a.e, a.a.c.f, e.a));
                stb(b, new w3(d, a.c, a.e, a.a.c.f, Jeb(e)));
                stb(b, new w3(d, a.c, a.e, a.a.c.f, e.b));
                break;
            case 1:
                i = new E3(e.a);
                c = Al(pl(h, i));
                od(c) ? j = Wv(pd(c), 91).b : j = 15;
                i = new E3(e.b);
                c = Al(pl(h, i));
                od(c) ? k = Wv(pd(c), 91).b : k = 15;
                d = q3(a, j, k);
                stb(b, new w3(d, a.c, a.e, a.a.c.f, e.a));
                stb(b, new w3(d, a.c, a.e, a.a.c.f, e.b));
                break;
            case 0:
                i = new E3(e.a);
                c = Al(pl(h, i));
                od(c) ? j = Wv(pd(c), 91).b : j = 15;
                d = (l = a.b, m = xfb(a.a.c, a.a.d, j), Ue(a.a.a, Veb(m)), n = s3(a.a.b, m.a, l), o1 = new Dfb((!m.k && (m.k = new Efb(Xeb(m))), m.k)), zfb(o1), !n ? o1 : Gfb(o1, n));
                stb(b, new w3(d, a.c, a.e, a.a.c.f, e.a));
                break;
            default:
                throw new slb('The loopside must be defined.');
        }
        return d;
    }
    function Pbb(a, b, c) {
        var d, e, f, g, h, i, j, k, l, m, n, o1, p, q, r, s, t, u, v;
        for(h = new Tob(a.a.c); h.a < h.c.c.length;){
            f = Wv(Rob(h), 16);
            for(t = new Tob(f.a); t.a < t.c.c.length;){
                s = Wv(Rob(t), 9);
                b.f[s.k] = s;
                b.a[s.k] = s;
                b.d[s.k] = 0;
            }
        }
        i = a.a.c;
        b.c == (Gbb(), Ebb) && (i = aw(i, 87) ? Ii(Wv(i, 87)) : aw(i, 88) ? Wv(i, 88).a : aw(i, 63) ? new ap(i) : new Ro(i));
        for(g = i.mb(); g.G();){
            f = Wv(g.H(), 16);
            n = -1;
            m = f.a;
            if (b.k == (Lbb(), Kbb)) {
                n = $xb;
                m = aw(m, 87) ? Ii(Wv(m, 87)) : aw(m, 88) ? Wv(m, 88).a : aw(m, 63) ? new ap(m) : new Ro(m);
            }
            for(v = m.mb(); v.G();){
                u = Wv(v.H(), 9);
                b.c == Ebb ? l = Wv(yU(a.b.f, u.k), 20) : l = Wv(yU(a.b.b, u.k), 20);
                if (l.Y() > 0) {
                    d = l.Y();
                    j = hw(Math.floor((d + 1) / 2)) - 1;
                    e = hw(Math.ceil((d + 1) / 2)) - 1;
                    if (b.k == Kbb) {
                        for(k = e; k >= j; k--)if (b.a[u.k] == u) {
                            p = Wv(l.sb(k), 27);
                            o1 = Wv(p.a, 9);
                            if (!ttb(c, p.b) && n > a.b.e[o1.k]) {
                                b.a[o1.k] = u;
                                b.f[u.k] = b.f[o1.k];
                                b.a[u.k] = b.f[u.k];
                                n = a.b.e[o1.k];
                            }
                        }
                    } else {
                        for(k = j; k <= e; k++)if (b.a[u.k] == u) {
                            r = Wv(l.sb(k), 27);
                            q = Wv(r.a, 9);
                            if (!ttb(c, r.b) && n < a.b.e[q.k]) {
                                b.a[q.k] = u;
                                b.f[u.k] = b.f[q.k];
                                b.a[u.k] = b.f[u.k];
                                n = a.b.e[q.k];
                            }
                        }
                    }
                }
            }
        }
    }
    function Ieb() {
        Ieb = iI;
        meb = new Peb('N', 0, (sN(), $M), $M, 0);
        jeb = new Peb('EN', 1, ZM, $M, 1);
        ieb = new Peb('E', 2, ZM, ZM, 0);
        peb = new Peb('SE', 3, pN, ZM, 1);
        oeb = new Peb('S', 4, pN, pN, 0);
        Heb = new Peb('WS', 5, rN, pN, 1);
        Geb = new Peb('W', 6, rN, rN, 0);
        neb = new Peb('NW', 7, $M, rN, 1);
        keb = new Peb('ENW', 8, ZM, rN, 2);
        leb = new Peb('ESW', 9, ZM, rN, 2);
        qeb = new Peb('SEN', 10, pN, $M, 2);
        Eeb = new Peb('SWN', 11, pN, $M, 2);
        Feb = new Peb(szb, 12, qN, qN, 3);
        feb = bk(meb, jeb, ieb, peb, oeb, Heb, Bv(tv(_E, 1), uyb, 60, 0, [
            Geb,
            neb,
            keb,
            leb,
            qeb,
            Eeb
        ]));
        heb = (hi(), Zj(Bv(tv(UF, 1), syb, 1, 4, [
            meb,
            ieb,
            oeb,
            Geb
        ])));
        geb = Zj(Bv(tv(UF, 1), syb, 1, 4, [
            jeb,
            peb,
            Heb,
            neb
        ]));
        veb = new Gr($M);
        seb = Zj(Bv(tv(UF, 1), syb, 1, 4, [
            ZM,
            $M
        ]));
        reb = new Gr(ZM);
        yeb = Zj(Bv(tv(UF, 1), syb, 1, 4, [
            pN,
            ZM
        ]));
        xeb = new Gr(pN);
        Deb = Zj(Bv(tv(UF, 1), syb, 1, 4, [
            rN,
            pN
        ]));
        Ceb = new Gr(rN);
        web = Zj(Bv(tv(UF, 1), syb, 1, 4, [
            $M,
            rN
        ]));
        teb = Zj(Bv(tv(UF, 1), syb, 1, 4, [
            ZM,
            $M,
            rN
        ]));
        ueb = Zj(Bv(tv(UF, 1), syb, 1, 4, [
            ZM,
            pN,
            rN
        ]));
        Aeb = Zj(Bv(tv(UF, 1), syb, 1, 4, [
            pN,
            rN,
            $M
        ]));
        zeb = Zj(Bv(tv(UF, 1), syb, 1, 4, [
            pN,
            ZM,
            $M
        ]));
        Beb = (kr(), jr);
    }
    function JZ(a, b) {
        var c, d, e, f, g, h, i, j, k, l, m, n, o1, p, q, r, s, t, u;
        s = 0;
        if (b.e.a == 0) for(q = new Tob(a); q.a < q.c.c.length;){
            o1 = Wv(Rob(q), 9);
            s = Nlb(s, o1.i.a + o1.j.a + o1.e.c);
        }
        else s = b.e.a - b.d.a;
        s -= b.d.a;
        for(p = new Tob(a); p.a < p.c.c.length;){
            o1 = Wv(Rob(p), 9);
            IZ(o1.i, s - o1.j.a);
            GZ(o1);
            switch(Wv(rJ(o1, (eM(), lL)), 103).e){
                case 1:
                    sJ(o1, lL, (iK(), gK));
                    break;
                case 2:
                    sJ(o1, lL, (iK(), fK));
            }
            r = o1.j;
            for(u = new Tob(o1.f); u.a < u.c.c.length;){
                t = Wv(Rob(u), 7);
                IZ(t.i, r.a - t.j.a);
                IZ(t.a, t.j.a);
                QX(t, CZ(t.g));
                g = Wv(rJ(t, UL), 24);
                !!g && sJ(t, UL, Elb(-g.a));
                for(f = new Tob(t.e); f.a < f.c.c.length;){
                    e = Wv(Rob(f), 12);
                    for(d = WI(e.a, 0); d.b != d.d.c;){
                        c = Wv(_ub(d), 10);
                        c.a = s - c.a;
                    }
                    j = Wv(rJ(e, CL), 44);
                    if (j) for(i = WI(j, 0); i.b != i.d.c;){
                        h = Wv(_ub(i), 10);
                        h.a = s - h.a;
                    }
                    for(m = new Tob(e.b); m.a < m.c.c.length;){
                        k = Wv(Rob(m), 33);
                        IZ(k.i, s - k.j.a);
                    }
                }
                for(n = new Tob(t.c); n.a < n.c.c.length;){
                    k = Wv(Rob(n), 33);
                    IZ(k.i, -k.j.a);
                }
            }
            if (o1.g == (CX(), xX)) {
                sJ(o1, (Rib(), hib), CZ(Wv(rJ(o1, hib), 32)));
                FZ(o1);
            }
            for(l = new Tob(o1.c); l.a < l.c.c.length;){
                k = Wv(Rob(l), 33);
                IZ(k.i, r.a - k.j.a);
            }
        }
    }
    function LZ(a, b) {
        var c, d, e, f, g, h, i, j, k, l, m, n, o1, p, q, r, s, t, u;
        s = 0;
        if (b.e.b == 0) for(q = new Tob(a); q.a < q.c.c.length;){
            o1 = Wv(Rob(q), 9);
            s = Nlb(s, o1.i.b + o1.j.b + o1.e.a);
        }
        else s = b.e.b - b.d.b;
        s -= b.d.b;
        for(p = new Tob(a); p.a < p.c.c.length;){
            o1 = Wv(Rob(p), 9);
            KZ(o1.i, s - o1.j.b);
            HZ(o1);
            switch(Wv(rJ(o1, (eM(), lL)), 103).e){
                case 3:
                    sJ(o1, lL, (iK(), dK));
                    break;
                case 4:
                    sJ(o1, lL, (iK(), hK));
            }
            r = o1.j;
            for(u = new Tob(o1.f); u.a < u.c.c.length;){
                t = Wv(Rob(u), 7);
                KZ(t.i, r.b - t.j.b);
                KZ(t.a, t.j.b);
                QX(t, DZ(t.g));
                g = Wv(rJ(t, UL), 24);
                !!g && sJ(t, UL, Elb(-g.a));
                for(f = new Tob(t.e); f.a < f.c.c.length;){
                    e = Wv(Rob(f), 12);
                    for(d = WI(e.a, 0); d.b != d.d.c;){
                        c = Wv(_ub(d), 10);
                        c.b = s - c.b;
                    }
                    j = Wv(rJ(e, CL), 44);
                    if (j) for(i = WI(j, 0); i.b != i.d.c;){
                        h = Wv(_ub(i), 10);
                        h.b = s - h.b;
                    }
                    for(m = new Tob(e.b); m.a < m.c.c.length;){
                        k = Wv(Rob(m), 33);
                        KZ(k.i, s - k.j.b);
                    }
                }
                for(n = new Tob(t.c); n.a < n.c.c.length;){
                    k = Wv(Rob(n), 33);
                    KZ(k.i, -k.j.b);
                }
            }
            if (o1.g == (CX(), xX)) {
                sJ(o1, (Rib(), hib), DZ(Wv(rJ(o1, hib), 32)));
                EZ(o1);
            }
            for(l = new Tob(o1.c); l.a < l.c.c.length;){
                k = Wv(Rob(l), 33);
                KZ(k.i, r.b - k.j.b);
            }
        }
    }
    function qP(a, b, c) {
        var d, e, f, g, h, i, j, k, l, m, n;
        d = new VN(b.e.i.a, b.e.i.b, b.e.j.a, b.e.j.b);
        e = new UN;
        if (a.c) for(g = new Tob(zW(b)); g.a < g.c.c.length;){
            f = Wv(Rob(g), 129);
            e.d = f.e.i.a + b.e.i.a;
            e.e = f.e.i.b + b.e.i.b;
            e.c = f.e.j.a;
            e.b = f.e.j.b;
            TN(d, e);
        }
        for(k = new Tob(AW(b)); k.a < k.c.c.length;){
            j = Wv(Rob(k), 161);
            l = j.e.i.a + b.e.i.a;
            m = j.e.i.b + b.e.i.b;
            if (a.e) {
                e.d = l;
                e.e = m;
                e.c = j.e.j.a;
                e.b = j.e.j.b;
                TN(d, e);
            }
            if (a.d) for(g = new Tob(DW(j)); g.a < g.c.c.length;){
                f = Wv(Rob(g), 129);
                e.d = f.e.i.a + l;
                e.e = f.e.i.b + m;
                e.c = f.e.j.a;
                e.b = f.e.j.b;
                TN(d, e);
            }
            if (a.b) {
                n = new HI(-c, -c);
                if (gw(oW(b, (eM(), VL))) === gw((UM(), TM))) for(g = new Tob(DW(j)); g.a < g.c.c.length;){
                    f = Wv(Rob(g), 129);
                    n.a += f.e.j.a + c;
                    n.b += f.e.j.b + c;
                }
                n.a = Nlb(n.a, 0);
                n.b = Nlb(n.b, 0);
                pP(d, EW(j), CW(j), b, j, n, c);
            }
        }
        a.b && pP(d, (ypb(), ypb(), vpb), vpb, b, null, null, c);
        i = new FP((h = Wv(b.e, 9).e, new EP(h.d, h.b, h.a, h.c)));
        i.d = b.e.i.b - d.e;
        i.a = d.e + d.b - (b.e.i.b + b.e.j.b);
        i.b = b.e.i.a - d.d;
        i.c = d.d + d.c - (b.e.i.a + b.e.j.a);
        Wv(b.e, 9).e.b = i.b;
        Wv(b.e, 9).e.d = i.d;
        Wv(b.e, 9).e.c = i.c;
        Wv(b.e, 9).e.a = i.a;
    }
    function XT() {
        XT = iI;
        WT = new xk;
        Fd(WT, (sN(), dN), hN);
        Fd(WT, oN, kN);
        Fd(WT, oN, hN);
        Fd(WT, _M, gN);
        Fd(WT, _M, hN);
        Fd(WT, eN, iN);
        Fd(WT, eN, hN);
        Fd(WT, mN, bN);
        Fd(WT, mN, hN);
        Fd(WT, jN, cN);
        Fd(WT, jN, iN);
        Fd(WT, jN, bN);
        Fd(WT, jN, hN);
        Fd(WT, cN, jN);
        Fd(WT, cN, kN);
        Fd(WT, cN, gN);
        Fd(WT, cN, hN);
        Fd(WT, lN, lN);
        Fd(WT, lN, iN);
        Fd(WT, lN, kN);
        Fd(WT, fN, fN);
        Fd(WT, fN, iN);
        Fd(WT, fN, gN);
        Fd(WT, nN, nN);
        Fd(WT, nN, bN);
        Fd(WT, nN, kN);
        Fd(WT, aN, aN);
        Fd(WT, aN, bN);
        Fd(WT, aN, gN);
        Fd(WT, iN, eN);
        Fd(WT, iN, jN);
        Fd(WT, iN, lN);
        Fd(WT, iN, fN);
        Fd(WT, iN, iN);
        Fd(WT, iN, kN);
        Fd(WT, iN, gN);
        Fd(WT, iN, hN);
        Fd(WT, bN, mN);
        Fd(WT, bN, jN);
        Fd(WT, bN, nN);
        Fd(WT, bN, aN);
        Fd(WT, bN, bN);
        Fd(WT, bN, kN);
        Fd(WT, bN, gN);
        Fd(WT, bN, hN);
        Fd(WT, kN, oN);
        Fd(WT, kN, cN);
        Fd(WT, kN, lN);
        Fd(WT, kN, nN);
        Fd(WT, kN, iN);
        Fd(WT, kN, bN);
        Fd(WT, kN, kN);
        Fd(WT, kN, hN);
        Fd(WT, gN, _M);
        Fd(WT, gN, cN);
        Fd(WT, gN, fN);
        Fd(WT, gN, aN);
        Fd(WT, gN, iN);
        Fd(WT, gN, bN);
        Fd(WT, gN, gN);
        Fd(WT, gN, hN);
        Fd(WT, hN, dN);
        Fd(WT, hN, oN);
        Fd(WT, hN, _M);
        Fd(WT, hN, eN);
        Fd(WT, hN, mN);
        Fd(WT, hN, jN);
        Fd(WT, hN, cN);
        Fd(WT, hN, iN);
        Fd(WT, hN, bN);
        Fd(WT, hN, kN);
        Fd(WT, hN, gN);
        Fd(WT, hN, hN);
    }
    function Tbb(a, b, c) {
        var d, e, f, g, h, i, j, k, l, m, n, o1, p, q, r;
        if (c.n[b.k] != null) return;
        i = true;
        c.n[b.k] = 0;
        g = b;
        r = c.k == (Lbb(), Jbb) ? Vzb : Uzb;
        do {
            e = a.b.e[g.k];
            f = g.d.a.c.length;
            h = g.g;
            if (c.k == Jbb && e > 0 || c.k == Kbb && e < f - 1) {
                c.k == Kbb ? j = Wv(yU(g.d.a, e + 1), 9) : j = Wv(yU(g.d.a, e - 1), 9);
                l = c.f[j.k];
                k = j.g;
                Tbb(a, l, c);
                r = a.e.Ic(r, b, g);
                c.i[b.k] == b && (c.i[b.k] = c.i[l.k]);
                if (c.i[b.k] == c.i[l.k]) {
                    q = Wjb(a.d, h, k);
                    if (c.k == Kbb) {
                        d = Ixb(c.n[b.k]);
                        n = Ixb(c.n[l.k]) + Ixb(c.d[j.k]) - j.e.d - q - g.e.a - g.j.b - Ixb(c.d[g.k]);
                        if (i) {
                            i = false;
                            c.n[b.k] = n < r ? n : r;
                        } else c.n[b.k] = d < (n < r ? n : r) ? d : n < r ? n : r;
                    } else {
                        d = Ixb(c.n[b.k]);
                        n = Ixb(c.n[l.k]) + Ixb(c.d[j.k]) + j.j.b + j.e.a + q + g.e.d - Ixb(c.d[g.k]);
                        if (i) {
                            i = false;
                            c.n[b.k] = n > r ? n : r;
                        } else c.n[b.k] = d > (n > r ? n : r) ? d : n > r ? n : r;
                    }
                } else {
                    q = a.d.f;
                    p = Rbb(a, c.i[b.k]);
                    m = Rbb(a, c.i[l.k]);
                    if (c.k == Kbb) {
                        o1 = Ixb(c.n[b.k]) + Ixb(c.d[g.k]) + g.j.b + g.e.a + q - (Ixb(c.n[l.k]) + Ixb(c.d[j.k]) - j.e.d);
                        Xbb(p, m, o1);
                    } else {
                        o1 = Ixb(c.n[b.k]) + Ixb(c.d[g.k]) - g.e.d - Ixb(c.n[l.k]) - Ixb(c.d[j.k]) - j.j.b - j.e.a - q;
                        Xbb(p, m, o1);
                    }
                }
            } else r = a.e.Ic(r, b, g);
            g = c.a[g.k];
        }while (g != b);
        ycb(a.e, b);
    }
    function sZ(a, b, c, d) {
        var e, f, g, h, i, j, k, l, m, n, o1, p, q, r, s;
        m = false;
        l = false;
        if (MM(Wv(rJ(d, (eM(), TL)), 28))) {
            g = false;
            h = false;
            t: for(o1 = new Tob(d.f); o1.a < o1.c.c.length;){
                n = Wv(Rob(o1), 7);
                for(q = Uh(Sh((Gi(), new gr(Ti(Bv(tv(UF, 1), syb, 1, 4, [
                    new fY(n),
                    new lY(n)
                ])))))); Cm(q);){
                    p = Wv(Dm(q), 7);
                    if (!Ckb(Ixb(Xv(rJ(p.f, qL))))) {
                        if (n.g == (sN(), $M)) {
                            g = true;
                            break t;
                        }
                        if (n.g == pN) {
                            h = true;
                            break t;
                        }
                    }
                }
            }
            m = h && !g;
            l = g && !h;
        }
        if (!m && !l && d.c.c.length != 0) {
            k = 0;
            for(j = new Tob(d.c); j.a < j.c.c.length;){
                i = Wv(Rob(j), 33);
                k += i.i.b + i.j.b / 2;
            }
            k /= d.c.c.length;
            s = k >= d.j.b / 2;
        } else s = !l;
        if (s) {
            r = Wv(rJ(d, (Rib(), Qib)), 20);
            if (!r) {
                f = new GU;
                sJ(d, Qib, f);
            } else if (m) f = r;
            else {
                e = Wv(rJ(d, Yhb), 20);
                if (!e) {
                    f = new GU;
                    sJ(d, Yhb, f);
                } else r.Y() <= e.Y() ? f = r : f = e;
            }
        } else {
            e = Wv(rJ(d, (Rib(), Yhb)), 20);
            if (!e) {
                f = new GU;
                sJ(d, Yhb, f);
            } else if (l) f = e;
            else {
                r = Wv(rJ(d, Qib), 20);
                if (!r) {
                    f = new GU;
                    sJ(d, Qib, f);
                } else e.Y() <= r.Y() ? f = e : f = r;
            }
        }
        f.ib(a);
        sJ(a, (Rib(), Zhb), c);
        if (b.d == c) {
            eW(b, null);
            c.b.c.length + c.e.c.length == 0 && PX(c, null);
        } else {
            dW(b, null);
            c.b.c.length + c.e.c.length == 0 && PX(c, null);
        }
        _I(b.a);
    }
    function rU(a, b) {
        var c, d, e, f, g, h, i, j, k, l, m, n, o1, p, q, r, s, t;
        c = new bV(b);
        c.a || kU(b);
        j = jU(b);
        i = new xk;
        q = new oV;
        for(p = new Tob(b.b); p.a < p.c.c.length;){
            o1 = Wv(Rob(p), 9);
            for(e = Uh(mX(o1)); Cm(e);){
                d = Wv(Dm(e), 12);
                if (d.c.f.g == (CX(), xX) || d.d.f.g == xX) {
                    k = qU(a, d, j, q);
                    Fd(i, oU(k.d), k.a);
                }
            }
        }
        g = new GU;
        for(t = Wv(rJ(c.c, (Rib(), fib)), 18).mb(); t.G();){
            s = Wv(t.H(), 32);
            n = q.c[s.e];
            m = q.b[s.e];
            h = q.a[s.e];
            f = null;
            r = null;
            switch(s.e){
                case 4:
                    f = new VN(a.d.a, n, j.b.a - a.d.a, m - n);
                    r = new VN(a.d.a, n, h, m - n);
                    YU(j, new HI(f.d + f.c, f.e));
                    YU(j, new HI(f.d + f.c, f.e + f.b));
                    break;
                case 2:
                    f = new VN(j.a.a, n, a.c.a - j.a.a, m - n);
                    r = new VN(a.c.a - h, n, h, m - n);
                    YU(j, new HI(f.d, f.e));
                    YU(j, new HI(f.d, f.e + f.b));
                    break;
                case 1:
                    f = new VN(n, a.d.b, m - n, j.b.b - a.d.b);
                    r = new VN(n, a.d.b, m - n, h);
                    YU(j, new HI(f.d, f.e + f.b));
                    YU(j, new HI(f.d + f.c, f.e + f.b));
                    break;
                case 3:
                    f = new VN(n, j.a.b, m - n, a.c.b - j.a.b);
                    r = new VN(n, a.c.b - h, m - n, h);
                    YU(j, new HI(f.d, f.e));
                    YU(j, new HI(f.d + f.c, f.e));
            }
            if (f) {
                l = new jV;
                l.d = s;
                l.b = f;
                l.c = r;
                l.a = pr(Wv(Dd(i, oU(s)), 18));
                g.c[g.c.length] = l;
            }
        }
        xU(c.b, g);
        c.d = pT(tT(j));
        return c;
    }
    function tt() {
        var a = [
            '\\u0000',
            '\\u0001',
            '\\u0002',
            '\\u0003',
            '\\u0004',
            '\\u0005',
            '\\u0006',
            '\\u0007',
            '\\b',
            '\\t',
            '\\n',
            '\\u000B',
            '\\f',
            '\\r',
            '\\u000E',
            '\\u000F',
            '\\u0010',
            '\\u0011',
            '\\u0012',
            '\\u0013',
            '\\u0014',
            '\\u0015',
            '\\u0016',
            '\\u0017',
            '\\u0018',
            '\\u0019',
            '\\u001A',
            '\\u001B',
            '\\u001C',
            '\\u001D',
            '\\u001E',
            '\\u001F'
        ];
        a[34] = '\\"';
        a[92] = '\\\\';
        a[173] = '\\u00ad';
        a[1536] = '\\u0600';
        a[1537] = '\\u0601';
        a[1538] = '\\u0602';
        a[1539] = '\\u0603';
        a[1757] = '\\u06dd';
        a[1807] = '\\u070f';
        a[6068] = '\\u17b4';
        a[6069] = '\\u17b5';
        a[8203] = '\\u200b';
        a[8204] = '\\u200c';
        a[8205] = '\\u200d';
        a[8206] = '\\u200e';
        a[8207] = '\\u200f';
        a[8232] = '\\u2028';
        a[8233] = '\\u2029';
        a[8234] = '\\u202a';
        a[8235] = '\\u202b';
        a[8236] = '\\u202c';
        a[8237] = '\\u202d';
        a[8238] = '\\u202e';
        a[8288] = '\\u2060';
        a[8289] = '\\u2061';
        a[8290] = '\\u2062';
        a[8291] = '\\u2063';
        a[8292] = '\\u2064';
        a[8298] = '\\u206a';
        a[8299] = '\\u206b';
        a[8300] = '\\u206c';
        a[8301] = '\\u206d';
        a[8302] = '\\u206e';
        a[8303] = '\\u206f';
        a[65279] = '\\ufeff';
        a[65529] = '\\ufff9';
        a[65530] = '\\ufffa';
        a[65531] = '\\ufffb';
        return a;
    }
    function eab(a) {
        var b, c, d, e, f, g, h, i, j, k, l, m, n, o1, p, q, r, s, t, u, v, w;
        b = 0;
        r = true;
        w = null;
        for(d = 0; d < a.length; d++){
            f = a[d];
            q = f.g;
            if (q == (CX(), AX)) {
                w = f;
                r = false;
            } else if (q == BX) {
                if (aw(rJ(f, (Rib(), uib)), 12)) continue;
                c = Wv(rJ(f, uib), 9);
                if (w != c) {
                    w = c;
                    r = true;
                }
                if (!LM(Wv(rJ(c, (eM(), TL)), 28))) continue;
                m = null;
                o1 = null;
                for(t = new Tob(f.f); t.a < t.c.c.length;){
                    s = Wv(Rob(t), 7);
                    s.b.c.length == 0 ? s.e.c.length == 0 || (o1 = Wv(rJ(s, uib), 7)) : m = Wv(rJ(s, uib), 7);
                }
                for(e = d + 1; e < a.length; e++){
                    g = a[e];
                    l = g.g;
                    if (l == AX) break;
                    else if (l == BX) {
                        if (gw(rJ(g, uib)) !== gw(c)) break;
                        h = null;
                        j = null;
                        for(v = new Tob(g.f); v.a < v.c.c.length;){
                            u = Wv(Rob(v), 7);
                            u.b.c.length == 0 ? u.e.c.length == 0 || (j = Wv(rJ(u, uib), 7)) : h = Wv(rJ(u, uib), 7);
                        }
                        if (r) {
                            n = false;
                            p = false;
                            if (!!o1 && !!h && o1.k < h.k) {
                                ++b;
                                p = true;
                            }
                            if (!!m && !!j && m.k > j.k) {
                                ++b;
                                n = true;
                            }
                            if (!!o1 && !!j && o1.k > j.k) {
                                ++b;
                                p = true;
                            }
                            if (!!m && !!h && m.k < h.k) {
                                ++b;
                                n = true;
                            }
                            n && p && m == o1 && --b;
                        } else {
                            i = false;
                            k = false;
                            if (!!m && !!j && m.k < j.k) {
                                ++b;
                                k = true;
                            }
                            if (!!o1 && !!h && o1.k > h.k) {
                                ++b;
                                i = true;
                            }
                            if (!!m && !!h && m.k < h.k) {
                                ++b;
                                i = true;
                            }
                            if (!!o1 && !!j && o1.k > j.k) {
                                ++b;
                                k = true;
                            }
                            i && k && h == j && --b;
                        }
                    }
                }
            }
        }
        return b;
    }
    function Oab(a) {
        var b, c, d, e, f, g, h, i, j, k, l, m, n, o1, p, q, r, s, t, u, v, w, A, B, C, D;
        for(t = a.a, u = 0, v = t.length; u < v; ++u){
            s = t[u];
            j = $xb;
            k = $xb;
            for(o1 = new Tob(s.f); o1.a < o1.c.c.length;){
                m = Wv(Rob(o1), 9);
                g = !m.d ? -1 : zU(m.d.a, m, 0);
                if (g > 0) {
                    l = Wv(yU(m.d.a, g - 1), 9);
                    B = Xjb(a.b, m, l);
                    q = m.i.b - m.e.d - (l.i.b + l.j.b + l.e.a + B);
                } else q = m.i.b - m.e.d;
                j = q < j ? q : j;
                if (g < m.d.a.c.length - 1) {
                    l = Wv(yU(m.d.a, g + 1), 9);
                    B = Xjb(a.b, m, l);
                    r = l.i.b - l.e.d - (m.i.b + m.j.b + m.e.a + B);
                } else r = 2 * m.i.b;
                k = r < k ? r : k;
            }
            i = $xb;
            f = false;
            e = Wv(yU(s.f, 0), 9);
            for(D = new Tob(e.f); D.a < D.c.c.length;){
                C = Wv(Rob(D), 7);
                p = e.i.b + C.i.b + C.a.b;
                for(d = new Tob(C.b); d.a < d.c.c.length;){
                    c = Wv(Rob(d), 12);
                    w = c.c;
                    b = w.f.i.b + w.i.b + w.a.b - p;
                    if ((b <= 0 ? 0 - b : b) < (i <= 0 ? 0 - i : i) && (b <= 0 ? 0 - b : b) < (b < 0 ? j : k)) {
                        i = b;
                        f = true;
                    }
                }
            }
            h = Wv(yU(s.f, s.f.c.length - 1), 9);
            for(A = new Tob(h.f); A.a < A.c.c.length;){
                w = Wv(Rob(A), 7);
                p = h.i.b + w.i.b + w.a.b;
                for(d = new Tob(w.e); d.a < d.c.c.length;){
                    c = Wv(Rob(d), 12);
                    C = c.d;
                    b = C.f.i.b + C.i.b + C.a.b - p;
                    if ((b <= 0 ? 0 - b : b) < (i <= 0 ? 0 - i : i) && (b <= 0 ? 0 - b : b) < (b < 0 ? j : k)) {
                        i = b;
                        f = true;
                    }
                }
            }
            if (f && i != 0) for(n = new Tob(s.f); n.a < n.c.c.length;){
                m = Wv(Rob(n), 9);
                m.i.b += i;
            }
        }
    }
    function bU(a, b) {
        var c, d, e, f, g, h, i, j, k, l, m, n, o1, p, q, r, s, t, u, v, w, A, B, C, D;
        l = dU($T(a, (sN(), dN)), b);
        o1 = cU($T(a, eN), b);
        u = cU($T(a, mN), b);
        B = eU($T(a, oN), b);
        m = eU($T(a, _M), b);
        s = cU($T(a, lN), b);
        p = cU($T(a, fN), b);
        w = cU($T(a, nN), b);
        v = cU($T(a, aN), b);
        C = eU($T(a, cN), b);
        r = cU($T(a, jN), b);
        t = cU($T(a, iN), b);
        A = cU($T(a, bN), b);
        D = eU($T(a, kN), b);
        n = eU($T(a, gN), b);
        q = cU($T(a, hN), b);
        c = oJ(Bv(tv(kw, 1), hyb, 26, 12, [
            s.a,
            B.a,
            w.a,
            D.a
        ]));
        d = oJ(Bv(tv(kw, 1), hyb, 26, 12, [
            o1.a,
            l.a,
            u.a,
            q.a
        ]));
        e = r.a;
        f = oJ(Bv(tv(kw, 1), hyb, 26, 12, [
            p.a,
            m.a,
            v.a,
            n.a
        ]));
        j = oJ(Bv(tv(kw, 1), hyb, 26, 12, [
            s.b,
            o1.b,
            p.b,
            t.b
        ]));
        i = oJ(Bv(tv(kw, 1), hyb, 26, 12, [
            B.b,
            l.b,
            m.b,
            q.b
        ]));
        k = C.b;
        h = oJ(Bv(tv(kw, 1), hyb, 26, 12, [
            w.b,
            u.b,
            v.b,
            A.b
        ]));
        VT($T(a, dN), c + e, j + k);
        VT($T(a, hN), c + e, j + k);
        VT($T(a, eN), c + e, 0);
        VT($T(a, mN), c + e, j + k + i);
        VT($T(a, oN), 0, j + k);
        VT($T(a, _M), c + e + d, j + k);
        VT($T(a, fN), c + e + d, 0);
        VT($T(a, nN), 0, j + k + i);
        VT($T(a, aN), c + e + d, j + k + i);
        VT($T(a, cN), 0, j);
        VT($T(a, jN), c, 0);
        VT($T(a, bN), 0, j + k + i);
        VT($T(a, gN), c + e + d, 0);
        g = new FI;
        g.a = oJ(Bv(tv(kw, 1), hyb, 26, 12, [
            c + d + e + f,
            C.a,
            t.a,
            A.a
        ]));
        g.b = oJ(Bv(tv(kw, 1), hyb, 26, 12, [
            j + i + k + h,
            r.b,
            D.b,
            n.b
        ]));
        return g;
    }
    function Nfb(a, b) {
        var c, d, e, f, g, h, i, j, k, l, m, n, o1, p;
        d = new jJ;
        j = null;
        o1 = a.c;
        n = o1.f.g;
        if (n != (CX(), AX) && n != BX) throw new slb('The target node of the edge must be a normal node or a northSouthPort.');
        if (n == BX) {
            m = Wv(rJ(o1, (Rib(), uib)), 7);
            j = new HI(MI(Bv(tv(qz, 1), Fzb, 10, 0, [
                m.f.i,
                m.i,
                m.a
            ])).a, MI(Bv(tv(qz, 1), Fzb, 10, 0, [
                o1.f.i,
                o1.i,
                o1.a
            ])).b);
            o1 = m;
        }
        SI(d, MI(Bv(tv(qz, 1), Fzb, 10, 0, [
            o1.f.i,
            o1.i,
            o1.a
        ])));
        g = Nlb(5, pgb(o1.f, o1.g));
        l = new GI(sgb(o1.g));
        l.a *= g;
        l.b *= g;
        QI(d, vI(l, MI(Bv(tv(qz, 1), Fzb, 10, 0, [
            o1.f.i,
            o1.i,
            o1.a
        ]))));
        !!j && TI(d, j, d.c.b, d.c);
        f = a;
        i = a;
        h = null;
        c = false;
        while(f){
            e = f.a;
            if (e.b != 0) {
                if (c) {
                    QI(d, CI(vI(h, (Bxb(e.b != 0), Wv(e.a.a.c, 10))), 0.5));
                    c = false;
                } else c = true;
                h = xI((Bxb(e.b != 0), Wv(e.c.b.c, 10)));
                Ue(d, e);
                _I(e);
            }
            i = f;
            f = Wv(re(Ktb(b.d, f)), 12);
        }
        p = i.d;
        if (p.f.g == BX) {
            m = Wv(rJ(p, (Rib(), uib)), 7);
            QI(d, new HI(MI(Bv(tv(qz, 1), Fzb, 10, 0, [
                m.f.i,
                m.i,
                m.a
            ])).a, MI(Bv(tv(qz, 1), Fzb, 10, 0, [
                p.f.i,
                p.i,
                p.a
            ])).b));
            p = m;
        }
        g = Nlb(5, pgb(p.f, p.g));
        l = new GI(sgb(p.g));
        CI(l, g);
        QI(d, vI(l, MI(Bv(tv(qz, 1), Fzb, 10, 0, [
            p.f.i,
            p.i,
            p.a
        ]))));
        SI(d, MI(Bv(tv(qz, 1), Fzb, 10, 0, [
            p.f.i,
            p.i,
            p.a
        ])));
        k = new efb(d);
        Ue(a.a, Veb(k));
    }
    function bZ(a) {
        var b, c, d, e, f, g, h, i, j, k, l, m, n, o1;
        if (gw(rJ(a.c, (eM(), TL))) === gw((KM(), GM)) || gw(rJ(a.c, TL)) === gw(FM)) for(k = new Tob(a.c.f); k.a < k.c.c.length;){
            j = Wv(Rob(k), 7);
            if (j.g == (sN(), $M) || j.g == pN) return false;
        }
        for(d = Uh(mX(a.c)); Cm(d);){
            c = Wv(Dm(d), 12);
            if (c.c.f == c.d.f) return false;
        }
        if (MM(Wv(rJ(a.c, TL), 28))) {
            n = new GU;
            for(i = nX(a.c, (sN(), rN)).mb(); i.G();){
                g = Wv(i.H(), 7);
                vU(n, Sh((Gi(), new gr(Ti(Bv(tv(UF, 1), syb, 1, 4, [
                    g.b,
                    g.e
                ]))))));
            }
            o1 = (_b(n), new Vh(n));
            n = new GU;
            for(h = nX(a.c, ZM).mb(); h.G();){
                g = Wv(h.H(), 7);
                vU(n, Sh((Gi(), new gr(Ti(Bv(tv(UF, 1), syb, 1, 4, [
                    g.b,
                    g.e
                ]))))));
            }
            b = (_b(n), new Vh(n));
        } else {
            o1 = iX(a.c);
            b = mX(a.c);
        }
        f = !sl(mX(a.c));
        e = !sl(iX(a.c));
        if (!f && !e) return false;
        if (!f) {
            a.e = 1;
            return true;
        }
        if (!e) {
            a.e = 0;
            return true;
        }
        if (Ul((Il(), new Im(Dl(ul(o1.a, new yl))))) == 1) {
            l = (_b(o1), Wv(Ql(new Im(Dl(ul(o1.a, new yl)))), 12)).c.f;
            if (l.g == (CX(), zX) && Wv(rJ(l, (Rib(), qib)), 7).f != a.c) {
                a.e = 2;
                return true;
            }
        }
        if (Ul(new Im(Dl(ul(b.a, new yl)))) == 1) {
            m = (_b(b), Wv(Ql(new Im(Dl(ul(b.a, new yl)))), 12)).d.f;
            if (m.g == (CX(), zX) && Wv(rJ(m, (Rib(), rib)), 7).f != a.c) {
                a.e = 3;
                return true;
            }
        }
        return false;
    }
    function K$(a, b, c) {
        var d, e, f, g, h, i, j, k, l, m, n, o1, p, q, r;
        d = new GU;
        e = $xb;
        f = $xb;
        g = $xb;
        if (c) {
            e = a.e.a;
            for(p = new Tob(b.f); p.a < p.c.c.length;){
                o1 = Wv(Rob(p), 7);
                for(i = new Tob(o1.e); i.a < i.c.c.length;){
                    h = Wv(Rob(i), 12);
                    if (h.a.b != 0) {
                        k = Wv(UI(h.a), 10);
                        if (k.a < e) {
                            f = e - k.a;
                            g = $xb;
                            d.c = xv(UF, syb, 1, 0, 4, 1);
                            e = k.a;
                        }
                        if (k.a <= e) {
                            d.c[d.c.length] = h;
                            h.a.b > 1 && (g = Qlb(g, Jlb(Wv(tn(h.a, 1), 10).b - k.b)));
                        }
                    }
                }
            }
        } else for(p = new Tob(b.f); p.a < p.c.c.length;){
            o1 = Wv(Rob(p), 7);
            for(i = new Tob(o1.b); i.a < i.c.c.length;){
                h = Wv(Rob(i), 12);
                if (h.a.b != 0) {
                    m = Wv(VI(h.a), 10);
                    if (m.a > e) {
                        f = m.a - e;
                        g = $xb;
                        d.c = xv(UF, syb, 1, 0, 4, 1);
                        e = m.a;
                    }
                    if (m.a >= e) {
                        d.c[d.c.length] = h;
                        h.a.b > 1 && (g = Qlb(g, Jlb(Wv(tn(h.a, h.a.b - 2), 10).b - m.b)));
                    }
                }
            }
        }
        if (d.c.length != 0 && f > b.j.a / 2 && g > b.j.b / 2) {
            n = new RX;
            PX(n, b);
            QX(n, (sN(), $M));
            n.i.a = b.j.a / 2;
            r = new RX;
            PX(r, b);
            QX(r, pN);
            r.i.a = b.j.a / 2;
            r.i.b = b.j.b;
            for(i = new Tob(d); i.a < i.c.c.length;){
                h = Wv(Rob(i), 12);
                if (c) {
                    j = Wv(YI(h.a), 10);
                    q = h.a.b == 0 ? MX(h.d) : Wv(UI(h.a), 10);
                    q.b >= j.b ? dW(h, r) : dW(h, n);
                } else {
                    j = Wv(ZI(h.a), 10);
                    q = h.a.b == 0 ? MX(h.c) : Wv(VI(h.a), 10);
                    q.b >= j.b ? eW(h, r) : eW(h, n);
                }
                l = Wv(rJ(h, (eM(), CL)), 44);
                !!l && Ve(l, j, true);
            }
            b.i.a = e - b.j.a / 2;
        }
    }
    function N2(a, b) {
        var c, d, e, f, g, h, i, j, k, l, m, n, o1, p, q, r, s, t;
        r = new GU;
        s = new GU;
        t = new GU;
        for(f = new Tob(b); f.a < f.c.c.length;){
            e = Wv(Rob(f), 75);
            e.k > 50 ? r.c[r.c.length] = e : e.k > 0 ? s.c[s.c.length] = e : t.c[t.c.length] = e;
        }
        if (s.c.length == 1 && r.c.length == 0) {
            xU(r, s);
            s.c = xv(UF, syb, 1, 0, 4, 1);
        }
        r.c.length != 0 && Zsb(U2(a.a), (Ieb(), meb)) && Zsb(U2(a.a), (Ieb(), oeb)) ? L2(a, r) : xU(s, r);
        s.c.length == 0 || M2(a, s);
        if (t.c.length != 0) {
            c = V2(a.a);
            if (c.c != 0) {
                k = new Tob(t);
                i = (_b(c), Nl(new vl(c).a));
                while(k.a < k.c.c.length){
                    e = Wv(Rob(k), 75);
                    while(k.a < k.c.c.length && e.a.a.Y() < 2)e = Wv(Rob(k), 75);
                    if (e.a.a.Y() > 1) {
                        p = Wv(nm(i), 60);
                        aeb(e, p, true);
                        Sob(k);
                        Y2(a.a, p);
                    }
                }
            }
            m = t.c.length;
            d = O2(a);
            n = new GU;
            g = m / T2(a.a).c | 0;
            for(h = 0; h < g; h++)xU(n, T2(a.a));
            o1 = m % T2(a.a).c;
            if (o1 > 3) {
                xU(n, (Ieb(), Ieb(), geb));
                o1 -= 4;
            }
            switch(o1){
                case 3:
                    vU(n, Meb(d));
                case 2:
                    q = Leb(Meb(d));
                    do q = Leb(q);
                    while (!Zsb(U2(a.a), q));
                    n.c[n.c.length] = q;
                    q = Neb(Meb(d));
                    do q = Neb(q);
                    while (!Zsb(U2(a.a), q));
                    n.c[n.c.length] = q;
                    break;
                case 1:
                    vU(n, Meb(d));
            }
            l = new Tob(n);
            j = new Tob(t);
            while(l.a < l.c.c.length && j.a < j.c.c.length)aeb(Wv(Rob(j), 75), Wv(Rob(l), 60), true);
        }
    }
    function G9(a, b) {
        var c, d, e, f, g, h, i, j, k, l, m, n, o1, p, q, r, s, t, u, v, w;
        k = b.c.c.length;
        a.a = xv(qB, Txb, 51, k, 0, 2);
        a.b = xv(qB, Txb, 51, k, 0, 2);
        a.k = xv(qB, Txb, 51, k, 0, 2);
        i = xv(mw, Yyb, 26, k, 12, 1);
        g = xv(KH, xAb, 26, k, 13, 1);
        a.c = xv(KH, xAb, 26, k, 13, 1);
        a.d = xv(KH, xAb, 26, k, 13, 1);
        r = 0;
        v = 0;
        m = new Fnb(b.c, 0);
        while(m.b < m.d.Y()){
            j = (Bxb(m.b < m.d.Y()), Wv(m.d.sb(m.c = m.b++), 16));
            l = m.b - 1;
            n = j.a.c.length;
            a.a[l] = xv(qB, Nzb, 9, n, 0, 1);
            a.k[l] = xv(qB, Nzb, 9, n, 0, 1);
            a.b[l] = xv(qB, Nzb, 9, n, 0, 1);
            i[l] = 0;
            g[l] = false;
            s = new Fnb(j.a, 0);
            while(s.b < s.d.Y()){
                q = (Bxb(s.b < s.d.Y()), Wv(s.d.sb(s.c = s.b++), 9));
                a.b[l][s.b - 1] = q;
                q.k = r++;
                o1 = Wv(rJ(q, (Rib(), nib)), 9);
                !!o1 && Nm(a.g, o1, q, null);
                for(u = new Tob(q.f); u.a < u.c.c.length;){
                    t = Wv(Rob(u), 7);
                    t.k = v++;
                    for(f = new Tob(t.e); f.a < f.c.c.length;){
                        e = Wv(Rob(f), 12);
                        e.d.f.d == j && ++i[l];
                    }
                    t.g == (sN(), ZM) ? t.e.c.length + t.b.c.length > 1 && (a.c[l] = true) : t.g == rN && t.e.c.length + t.b.c.length > 1 && (a.d[l] = true);
                }
                if (q.g == (CX(), BX)) {
                    ++i[l];
                    g[l] = true;
                }
            }
        }
        c = true;
        p = true;
        for(h = 0; h < a.d.length - 1; h++){
            d = a.c[h] || a.d[h + 1];
            c = c & d;
            p = p & !d;
        }
        a.j = xv(lw, tAb, 26, v, 12, 1);
        w = xv(mw, Yyb, 26, v, 12, 1);
        if (!c) {
            a.i = new iab(i, g, w);
            a.f = a.i;
        }
        if (!p) {
            a.e = new mab(i, g, w);
            a.f = a.e;
        }
    }
    function iU(a, b, c) {
        var d, e, f, g, h, i, j, k, l, m, n, o1, p, q, r, s, t, u, v, w, A, B;
        a.d = new HI(Uzb, Uzb);
        a.c = new HI(Vzb, Vzb);
        for(m = b.mb(); m.G();){
            k = Wv(m.H(), 55);
            for(t = new Tob(k.b); t.a < t.c.c.length;){
                s = Wv(Rob(t), 9);
                a.d.a = Qlb(a.d.a, s.i.a - s.e.b);
                a.d.b = Qlb(a.d.b, s.i.b - s.e.d);
                a.c.a = Nlb(a.c.a, s.i.a + s.j.a + s.e.c);
                a.c.b = Nlb(a.c.b, s.i.b + s.j.b + s.e.a);
            }
        }
        h = new cV;
        for(l = b.mb(); l.G();){
            k = Wv(l.H(), 55);
            d = rU(a, k);
            vU(h.a, d);
            d.a = d.a | !Wv(rJ(d.c, (Rib(), fib)), 18).V();
        }
        a.b = (xR(), B = new HR, B.f = new kR(c), B.b = jR(B.f, h), B);
        BR((o1 = a.b, new sI, o1));
        a.e = new FI;
        a.a = a.b.f.e;
        for(g = new Tob(h.a); g.a < g.c.c.length;){
            e = Wv(Rob(g), 347);
            u = CR(a.b, e);
            TW(e.c, u.a, u.b);
            for(q = new Tob(e.c.b); q.a < q.c.c.length;){
                p = Wv(Rob(q), 9);
                if (p.g == (CX(), xX)) {
                    r = mU(a, p.i, Wv(rJ(p, (Rib(), hib)), 32));
                    vI(BI(p.i), r);
                }
            }
        }
        for(f = new Tob(h.a); f.a < f.c.c.length;){
            e = Wv(Rob(f), 347);
            for(j = new Tob(aV(e)); j.a < j.c.c.length;){
                i = Wv(Rob(j), 12);
                A = new kJ(i.a);
                rn(A, 0, MX(i.c));
                QI(A, MX(i.d));
                n = null;
                for(w = WI(A, 0); w.b != w.d.c;){
                    v = Wv(_ub(w), 10);
                    if (!n) {
                        n = v;
                        continue;
                    }
                    if (Xs(n.a, v.a)) {
                        a.e.a = Qlb(a.e.a, n.a);
                        a.a.a = Nlb(a.a.a, n.a);
                    } else if (Xs(n.b, v.b)) {
                        a.e.b = Qlb(a.e.b, n.b);
                        a.a.b = Nlb(a.a.b, n.b);
                    }
                    n = v;
                }
            }
        }
        zI(a.e);
        vI(a.a, a.e);
    }
    function U1(a, b, c, d, e) {
        var f, g, h, i, j, k, l, m, n, o1, p, q, r, s, t, u, v, w, A, B, C, D, F;
        p = new HU(b.b);
        u = new HU(b.b);
        m = new HU(b.b);
        B = new HU(b.b);
        q = new HU(b.b);
        for(A = WI(b, 0); A.b != A.d.c;){
            v = Wv(_ub(A), 7);
            for(h = new Tob(v.e); h.a < h.c.c.length;){
                f = Wv(Rob(h), 12);
                if (f.c.f == f.d.f) {
                    if (v.g == f.d.g) {
                        B.c[B.c.length] = f;
                        continue;
                    } else if (v.g == (sN(), $M) && f.d.g == pN) {
                        q.c[q.c.length] = f;
                        continue;
                    }
                }
            }
        }
        for(i = new Tob(q); i.a < i.c.c.length;){
            f = Wv(Rob(i), 12);
            V1(a, f, c, d, (sN(), ZM));
        }
        for(g = new Tob(B); g.a < g.c.c.length;){
            f = Wv(Rob(g), 12);
            C = new uX(a);
            sX(C, (CX(), BX));
            sJ(C, (eM(), TL), (KM(), FM));
            sJ(C, (Rib(), uib), f);
            D = new RX;
            sJ(D, uib, f.d);
            QX(D, (sN(), rN));
            PX(D, C);
            F = new RX;
            sJ(F, uib, f.c);
            QX(F, ZM);
            PX(F, C);
            sJ(f.c, Bib, C);
            sJ(f.d, Bib, C);
            dW(f, null);
            eW(f, null);
            c.c[c.c.length] = C;
            sJ(C, aib, Elb(2));
        }
        for(w = WI(b, 0); w.b != w.d.c;){
            v = Wv(_ub(w), 7);
            j = v.b.c.length > 0;
            r = v.e.c.length > 0;
            j && r ? m.c[m.c.length] = v : j ? p.c[p.c.length] = v : r && (u.c[u.c.length] = v);
        }
        for(o1 = new Tob(p); o1.a < o1.c.c.length;){
            n = Wv(Rob(o1), 7);
            vU(e, T1(a, n, null, c));
        }
        for(t = new Tob(u); t.a < t.c.c.length;){
            s = Wv(Rob(t), 7);
            vU(e, T1(a, null, s, c));
        }
        for(l = new Tob(m); l.a < l.c.c.length;){
            k = Wv(Rob(l), 7);
            vU(e, T1(a, k, k, c));
        }
    }
    function ZP(a, b) {
        var c, d, e, f, g, h, i, j, k, l, m, n, o1, p, q, r, s, t, u, v, w, A;
        u = new II(b.d);
        i = new GU;
        for(t = new Tob(b.b); t.a < t.c.c.length;){
            r = Wv(Rob(t), 9);
            n = Wv(Smb(a.j, r), 69);
            if (n) {
                $P(a, r, n, u);
                for(w = new Tob(r.f); w.a < w.c.c.length;){
                    v = Wv(Rob(w), 7);
                    o1 = Wv(Smb(a.n, v), 69);
                    if (o1) {
                        $P(a, v, o1, QP);
                        WP(o1, (eM(), WL), new lv(yc(v.g)));
                    }
                    if (gw(rJ(r, (eM(), VL))) !== gw((UM(), RM))) for(q = new Tob(v.c); q.a < q.c.c.length;){
                        p = Wv(Rob(q), 33);
                        m = Wv(Smb(a.f, p), 69);
                        $P(a, p, m, QP);
                    }
                }
                if (Wv(rJ(r, (eM(), JL)), 86).Y() != 0) for(q = new Tob(r.c); q.a < q.c.c.length;){
                    p = Wv(Rob(q), 33);
                    m = Wv(Smb(a.f, p), 69);
                    $P(a, p, m, QP);
                }
                for(h = Uh(mX(r)); Cm(h);){
                    f = Wv(Dm(h), 12);
                    SW(f.d.f, r) || (i.c[i.c.length] = f);
                }
            }
        }
        A = Wv(rJ(b, (Rib(), zib)), 9);
        if (A) for(h = Uh(mX(A)); Cm(h);){
            f = Wv(Dm(h), 12);
            SW(f.d.f, A) && (i.c[i.c.length] = f);
        }
        for(g = new Tob(i); g.a < g.c.c.length;){
            f = Wv(Rob(g), 12);
            l = Wv(Smb(a.b, f), 69);
            YP(a, f, l, u);
            for(q = new Tob(f.b); q.a < q.c.c.length;){
                p = Wv(Rob(q), 33);
                m = Wv(Smb(a.f, p), 69);
                $P(a, p, m, u);
            }
        }
        c = (d = Wv(rJ(b, Xhb), 15).a, new HI(b.e.a + b.a.b + b.a.c + 2 * d, b.e.b + b.a.d + b.a.a + 2 * d));
        k = Wv(rJ(b, zib), 9);
        if (k) {
            k.j.a = c.a;
            k.j.b = c.b;
        }
        j = Wv(rJ(b, PP), 69);
        VP(a, j, Jzb, c.a);
        VP(a, j, Kzb, c.b);
        for(s = new Tob(b.b); s.a < s.c.c.length;){
            r = Wv(Rob(s), 9);
            e = Wv(rJ(r, sib), 55);
            !!e && ZP(a, e);
        }
    }
    function Xfb(a, b) {
        var c, d, e, f, g, h, i, j, k, l, m, n, o1, p, q, r, s, t, u, v, w, A, B, C, D, F, G, H;
        F = new aJ;
        B = new aJ;
        r = -1;
        for(i = new Tob(a); i.a < i.c.c.length;){
            g = Wv(Rob(i), 77);
            g.i = r--;
            l = 0;
            v = 0;
            for(f = new Tob(g.j); f.a < f.c.c.length;){
                d = Wv(Rob(f), 117);
                v += d.c;
            }
            for(e = new Tob(g.d); e.a < e.c.c.length;){
                d = Wv(Rob(e), 117);
                l += d.c;
            }
            g.e = l;
            g.k = v;
            v == 0 ? TI(B, g, B.c.b, B.c) : l == 0 && TI(F, g, F.c.b, F.c);
        }
        H = new Yub((Oh(), a));
        m = a.c.length;
        q = m + 1;
        s = m - 1;
        o1 = new GU;
        while(H.a.Y() != 0){
            while(B.b != 0){
                A = (Bxb(B.b != 0), Wv($I(B, B.a.a), 77));
                H.a.eb(A);
                A.i = s--;
                agb(A, F, B);
            }
            while(F.b != 0){
                C = (Bxb(F.b != 0), Wv($I(F, F.a.a), 77));
                H.a.eb(C);
                C.i = q++;
                agb(C, F, B);
            }
            p = eyb;
            for(j = (t = new Snb(H.a).a.bb().mb(), new Ynb(t)); j.a.G();){
                g = (k = Wv(j.a.H(), 21), Wv(k.yb(), 77));
                u = g.k - g.e;
                if (u >= p) {
                    if (u > p) {
                        o1.c = xv(UF, syb, 1, 0, 4, 1);
                        p = u;
                    }
                    o1.c[o1.c.length] = g;
                }
            }
            if (o1.c.length != 0) {
                n = Wv(yU(o1, vvb(b, o1.c.length)), 77);
                H.a.eb(n);
                n.i = q++;
                agb(n, F, B);
                o1.c = xv(UF, syb, 1, 0, 4, 1);
            }
        }
        w = a.c.length + 1;
        for(h = new Tob(a); h.a < h.c.c.length;){
            g = Wv(Rob(h), 77);
            g.i < m && (g.i += w);
        }
        for(D = new Tob(a); D.a < D.c.c.length;){
            C = Wv(Rob(D), 77);
            c = new Fnb(C.j, 0);
            while(c.b < c.d.Y()){
                d = (Bxb(c.b < c.d.Y()), Wv(c.d.sb(c.c = c.b++), 117));
                G = d.b;
                if (C.i > G.i) {
                    vnb(c);
                    BU(G.d, d);
                    if (d.c > 0) {
                        d.a = G;
                        vU(G.j, d);
                        d.b = C;
                        vU(C.d, d);
                    }
                }
            }
        }
    }
    function OO(a) {
        var b, c, d;
        for(d = new Lsb(new Fsb(a.c).a); htb(d.a);){
            c = (d.b = itb(d.a), new Psb(d.c, d.b));
            b = Wv(c.b.b[c.a.e], 62);
            switch(Wv(c.a, 67).e){
                case 0:
                    b.d = 0;
                    b.e = -(b.b + a.d);
                    break;
                case 1:
                    b.d = (a.e.e.j.a - b.c) / 2;
                    b.e = -(b.b + a.d);
                    break;
                case 2:
                    b.d = a.e.e.j.a - b.c;
                    b.e = -(b.b + a.d);
                    break;
                case 3:
                    b.d = 0;
                    b.e = a.e.e.j.b + a.d;
                    break;
                case 4:
                    b.d = (a.e.e.j.a - b.c) / 2;
                    b.e = a.e.e.j.b + a.d;
                    break;
                case 5:
                    b.d = a.e.e.j.a - b.c;
                    b.e = a.e.e.j.b + a.d;
                    break;
                case 6:
                    b.d = -(b.c + a.d);
                    b.e = 0;
                    break;
                case 7:
                    b.d = -(b.c + a.d);
                    b.e = (a.e.e.j.b - b.b) / 2;
                    break;
                case 8:
                    b.d = -(b.c + a.d);
                    b.e = a.e.e.j.b - b.b;
                    break;
                case 9:
                    b.d = a.e.e.j.a + a.d;
                    b.e = 0;
                    break;
                case 10:
                    b.d = a.e.e.j.a + a.d;
                    b.e = (a.e.e.j.b - b.b) / 2;
                    break;
                case 11:
                    b.d = a.e.e.j.a + a.d;
                    b.e = a.e.e.j.b - b.b;
                    break;
                case 12:
                    b.d = a.q.b + a.d;
                    b.e = a.q.d + a.d;
                    break;
                case 13:
                    b.d = (a.e.e.j.a - b.c) / 2;
                    b.e = a.q.d + a.d;
                    break;
                case 14:
                    b.d = a.e.e.j.a - a.q.c - b.c - a.d;
                    b.e = a.q.d + a.d;
                    break;
                case 15:
                    b.d = a.q.b + a.d;
                    b.e = (a.e.e.j.b - b.b) / 2;
                    break;
                case 16:
                    b.d = (a.e.e.j.a - b.c) / 2;
                    b.e = (a.e.e.j.b - b.b) / 2;
                    break;
                case 17:
                    b.d = a.e.e.j.a - a.q.c - b.c - a.d;
                    b.e = (a.e.e.j.b - b.b) / 2;
                    break;
                case 18:
                    b.d = a.q.b + a.d;
                    b.e = a.e.e.j.b - a.q.a - b.b - a.d;
                    break;
                case 19:
                    b.d = (a.e.e.j.a - b.c) / 2;
                    b.e = a.e.e.j.b - a.q.a - b.b - a.d;
                    break;
                case 20:
                    b.d = a.e.e.j.a - a.q.c - b.c - a.d;
                    b.e = a.e.e.j.b - a.q.a - b.b - a.d;
            }
        }
    }
    function ddb(a, b) {
        var c, d, e, f, g, h, i, j, k, l, m, n, o1, p, q, r, s, t, u, v, w, A, B, C, D, F, G, H, I;
        F = new aJ;
        B = new aJ;
        o1 = -1;
        for(s = new Tob(a); s.a < s.c.c.length;){
            q = Wv(Rob(s), 80);
            q.d = o1--;
            i = 0;
            v = 0;
            for(f = new Tob(q.e); f.a < f.c.c.length;){
                d = Wv(Rob(f), 118);
                v += d.c;
            }
            for(e = new Tob(q.b); e.a < e.c.c.length;){
                d = Wv(Rob(e), 118);
                i += d.c;
            }
            q.c = i;
            q.f = v;
            v == 0 ? TI(B, q, B.c.b, B.c) : i == 0 && TI(F, q, F.c.b, F.c);
        }
        H = (I = new Vwb, ml(I, a), I);
        j = a.c.length;
        p = j - 1;
        n = j + 1;
        l = new GU;
        while(H.a.c != 0){
            while(B.b != 0){
                A = (Bxb(B.b != 0), Wv($I(B, B.a.a), 80));
                cwb(H.a, A);
                A.d = p--;
                jdb(A, F, B);
            }
            while(F.b != 0){
                C = (Bxb(F.b != 0), Wv($I(F, F.a.a), 80));
                cwb(H.a, C);
                C.d = n++;
                jdb(C, F, B);
            }
            m = eyb;
            for(t = (h = new rwb(new wwb(new Gob(H.a).a).b), new Mob(h)); Bnb(t.a.a);){
                q = (g = pwb(t.a), Wv(g.yb(), 80));
                u = q.f - q.c;
                if (u >= m) {
                    if (u > m) {
                        l.c = xv(UF, syb, 1, 0, 4, 1);
                        m = u;
                    }
                    l.c[l.c.length] = q;
                }
            }
            if (l.c.length != 0) {
                k = Wv(yU(l, vvb(b, l.c.length)), 80);
                cwb(H.a, k);
                k.d = n++;
                jdb(k, F, B);
                l.c = xv(UF, syb, 1, 0, 4, 1);
            }
        }
        w = a.c.length + 1;
        for(r = new Tob(a); r.a < r.c.c.length;){
            q = Wv(Rob(r), 80);
            q.d < j && (q.d += w);
        }
        for(D = new Tob(a); D.a < D.c.c.length;){
            C = Wv(Rob(D), 80);
            c = new Fnb(C.e, 0);
            while(c.b < c.d.Y()){
                d = (Bxb(c.b < c.d.Y()), Wv(c.d.sb(c.c = c.b++), 118));
                G = d.b;
                if (C.d > G.d) {
                    vnb(c);
                    BU(G.b, d);
                    if (d.c > 0) {
                        d.a = G;
                        vU(G.e, d);
                        d.b = C;
                        vU(C.b, d);
                    }
                }
            }
        }
    }
    function e0(a) {
        switch(a.e){
            case 14:
                return new wY;
            case 37:
                return new SY;
            case 8:
                return new YY;
            case 30:
                return new cZ;
            case 38:
                return new qZ;
            case 3:
                return new tZ;
            case 47:
            case 1:
                return new SZ((XZ(), WZ));
            case 4:
                return new wZ;
            case 49:
                return new AZ;
            case 23:
                return new $5;
            case 13:
                return new d$;
            case 34:
                return new j$;
            case 40:
                return new w$;
            case 35:
                return new F$;
            case 44:
                return new o4;
            case 28:
                return new I$;
            case 39:
                return new L$;
            case 27:
                return new N$;
            case 6:
                return new R$;
            case 31:
                return new m0;
            case 9:
                return new q0;
            case 43:
                return new w0;
            case 17:
                return new A0;
            case 18:
                return new G0;
            case 29:
                return new S0;
            case 11:
                return new q1;
            case 12:
                return new Z0;
            case 36:
                return new _0;
            case 46:
            case 0:
                return new SZ((XZ(), VZ));
            case 41:
                return new b1;
            case 15:
                return new e1;
            case 33:
                return new k1;
            case 42:
                return new R1;
            case 22:
                return new X1;
            case 19:
                return new k0;
            case 10:
                return new _1;
            case 7:
                return new c2;
            case 24:
                return new f2;
            case 21:
                return new h2;
            case 16:
                return new n2;
            case 45:
                return new q2;
            case 26:
                return new x2;
            case 20:
                return new A2;
            case 25:
                return new H2;
            case 5:
                return new l3;
            case 32:
                return new u3;
            case 48:
            case 2:
                return new SZ((XZ(), UZ));
            default:
                throw new slb('No implementation is available for the layout processor ' + (a.d != null ? a.d : '' + a.e));
        }
    }
    function PO(a) {
        var b, c, d, e, f, g, h;
        c = a.e.e.j;
        a.b ? b = Wv(oW(a.e, (eM(), jL)), 65) : b = new EP(a.k, a.k, a.k, a.k);
        e = c.a;
        (a.b || a.g[1] != (zM(), xM)) && (e -= b.b + b.c);
        f = c.a;
        (a.b || a.g[3] != (zM(), xM)) && (f -= b.b + b.c);
        g = c.b;
        (a.b || a.g[4] != (zM(), xM)) && (g -= b.d + b.a);
        d = c.b;
        (a.b || a.g[2] != (zM(), xM)) && (d -= b.d + b.a);
        if (aP(a, (sN(), $M)) == (zM(), xM)) {
            a.j[1] = (e - dP(a, $M)) / bP(a, $M);
            a.f = a.b ? b.b + (eP(a, $M) == 1 ? a.j[1] : 0) : a.j[1];
        } else {
            a.j[1] = a.k;
            h = dP(a, $M) + a.j[1] * (eP(a, $M) - 1);
            switch(aP(a, $M).e){
                case 2:
                    a.f = b.b;
                    break;
                case 3:
                    a.f = b.b + (e - h) / 2;
                    break;
                case 4:
                    a.f = c.a - h - b.c;
            }
        }
        if (aP(a, pN) == xM) {
            a.j[3] = (f - dP(a, pN)) / bP(a, pN);
            a.r = c.a - (a.b ? b.c + (eP(a, pN) == 1 ? a.j[3] : 0) : a.j[3]);
        } else {
            a.j[3] = a.k;
            h = dP(a, pN) + a.j[3] * (eP(a, pN) - 1);
            switch(aP(a, pN).e){
                case 2:
                    a.r = h + b.b;
                    break;
                case 3:
                    a.r = c.a - (f - h) / 2 - b.c;
                    break;
                case 4:
                    a.r = c.a - b.c;
            }
        }
        if (aP(a, rN) == xM) {
            a.j[4] = (g - dP(a, rN)) / bP(a, rN);
            a.s = c.b - (a.b ? b.a + (eP(a, rN) == 1 ? a.j[4] : 0) : a.j[4]);
        } else {
            a.j[4] = a.k;
            h = dP(a, rN) + a.j[4] * (eP(a, rN) - 1);
            switch(aP(a, rN).e){
                case 2:
                    a.s = h + b.d;
                    break;
                case 3:
                    a.s = c.b - (g - h) / 2 - b.a;
                    break;
                case 4:
                    a.s = c.b - b.a;
            }
        }
        if (aP(a, ZM) == xM) {
            a.j[2] = (d - dP(a, ZM)) / bP(a, ZM);
            a.a = a.b ? b.d + (eP(a, ZM) == 1 ? a.j[2] : 0) : a.j[2];
        } else {
            a.j[2] = a.k;
            h = dP(a, ZM) + a.j[2] * (eP(a, ZM) - 1);
            switch(aP(a, ZM).e){
                case 2:
                    a.a = b.d;
                    break;
                case 3:
                    a.a = b.d + (d - h) / 2;
                    break;
                case 4:
                    a.a = c.b - h - b.a;
            }
        }
    }
    function hab(a, b, c) {
        var d, e, f, g, h, i, j, k, l, m, n, o1, p, q, r, s, t, u, v, w, A, B, C, D, F, G, H, I;
        G = 0;
        g = 0;
        l = b[0].d;
        B = c[0].d;
        for(o1 = 0, q = c.length; o1 < q; ++o1){
            m = c[o1];
            if (LM(Wv(rJ(m, (eM(), TL)), 28))) {
                s = 0;
                for(v = new Tob(m.f); v.a < v.c.c.length;){
                    u = Wv(Rob(v), 7);
                    if (u.g == (sN(), $M)) for(f = new Tob(u.b); f.a < f.c.c.length;){
                        e = Wv(Rob(f), 12);
                        if (e.c.f.d == l) {
                            ++s;
                            break;
                        }
                    }
                    else break;
                }
                t = 0;
                A = new Fnb(m.f, m.f.c.length);
                while(A.b > 0){
                    u = (Bxb(A.b > 0), Wv(A.a.sb(A.c = --A.b), 7));
                    w = 0;
                    for(f = new Tob(u.b); f.a < f.c.c.length;){
                        e = Wv(Rob(f), 12);
                        e.c.f.d == l && ++w;
                    }
                    if (w > 0) {
                        if (u.g == (sN(), $M)) {
                            a.a[u.k] = G;
                            ++G;
                        } else {
                            a.a[u.k] = G + s + t;
                            ++t;
                        }
                        g += w;
                    }
                }
                G += t;
            } else {
                r = 0;
                for(v = new Tob(m.f); v.a < v.c.c.length;){
                    u = Wv(Rob(v), 7);
                    for(f = new Tob(u.b); f.a < f.c.c.length;){
                        e = Wv(Rob(f), 12);
                        e.c.f.d == l && ++r;
                    }
                    a.a[u.k] = G;
                }
                if (r > 0) {
                    ++G;
                    g += r;
                }
            }
        }
        C = xv(mw, Yyb, 26, g, 12, 1);
        i = 0;
        for(n = 0, p = b.length; n < p; ++n){
            m = b[n];
            if (LM(Wv(rJ(m, (eM(), TL)), 28))) for(v = new Tob(m.f); v.a < v.c.c.length;){
                u = Wv(Rob(v), 7);
                D = i;
                for(f = new Tob(u.e); f.a < f.c.c.length;){
                    e = Wv(Rob(f), 12);
                    F = e.d;
                    F.f.d == B && kab(C, D, i++, a.a[F.k]);
                }
            }
            else {
                D = i;
                for(v = new Tob(m.f); v.a < v.c.c.length;){
                    u = Wv(Rob(v), 7);
                    for(f = new Tob(u.e); f.a < f.c.c.length;){
                        e = Wv(Rob(f), 12);
                        F = e.d;
                        F.f.d == B && kab(C, D, i++, a.a[F.k]);
                    }
                }
            }
        }
        h = 1;
        while(h < G)h *= 2;
        I = 2 * h - 1;
        h -= 1;
        H = xv(mw, Yyb, 26, I, 12, 1);
        d = 0;
        for(k = 0; k < g; k++){
            j = C[k] + h;
            ++H[j];
            while(j > 0){
                j % 2 > 0 && (d += H[j + 1]);
                j = (j - 1) / 2 | 0;
                ++H[j];
            }
        }
        return d;
    }
    function BV(a, b) {
        var c, d, e, f, g, h, i, j, k, l, m, n, o1, p, q, r, s, t, u, v, w, A, B, C, D, F, G, H, I, J;
        nI(b, 'Compound graph postprocessor', 1);
        c = Ckb(Ixb(Xv(rJ(a, (Mjb(), gjb)))));
        h = Wv(rJ(a, (Rib(), bib)), 144);
        l = new vtb;
        for(w = h.W().mb(); w.G();){
            v = Wv(w.H(), 12);
            g = new IU(h.U(v));
            Gpb(g, new $V(a));
            F = VV((Cxb(0, g.c.length), Wv(g.c[0], 114)));
            H = WV(Wv(yU(g, g.c.length - 1), 114));
            _I(v.a);
            C = F.f;
            SW(H.f, C) ? B = Wv(rJ(C, sib), 55) : B = hX(C);
            o1 = Wv(rJ(v, (eM(), CL)), 44);
            if (ol(g, zV)) {
                if (!o1) {
                    o1 = new jJ;
                    sJ(v, CL, o1);
                } else _I(o1);
            } else !!o1 && sJ(v, CL, null);
            q = null;
            for(f = new Tob(g); f.a < f.c.c.length;){
                e = Wv(Rob(f), 114);
                u = new FI;
                MW(u, e.a, B);
                r = e.b;
                d = new jJ;
                gJ(d, 0, r.a);
                hJ(d, u);
                D = new II(MX(r.c));
                G = new II(MX(r.d));
                D.a += u.a;
                D.b += u.b;
                G.a += u.a;
                G.b += u.b;
                if (q) {
                    d.b == 0 ? t = G : t = (Bxb(d.b != 0), Wv(d.a.a.c, 10));
                    I = Jlb(q.a - t.a) > dAb;
                    J = Jlb(q.b - t.b) > dAb;
                    (!c && I && J || c && (I || J)) && QI(v.a, D);
                }
                Ue(v.a, d);
                d.b == 0 ? q = D : q = (Bxb(d.b != 0), Wv(d.c.b.c, 10));
                s = Wv(rJ(r, CL), 44);
                if (s) {
                    n = new jJ;
                    gJ(n, 0, s);
                    hJ(n, u);
                    Ue(o1, n);
                }
                if (WV(e) == H) {
                    if (hX(H.f) != e.a) {
                        u = new FI;
                        MW(u, hX(H.f), B);
                    }
                    sJ(v, Pib, u);
                }
                p = new Fnb(r.b, 0);
                while(p.b < p.d.Y()){
                    i = (Bxb(p.b < p.d.Y()), Wv(p.d.sb(p.c = p.b++), 33));
                    if (gw(rJ(i, xib)) !== gw(v)) continue;
                    MW(i.i, hX(r.c.f), B);
                    vnb(p);
                    vU(v.b, i);
                }
                l.a.db(r, l);
            }
            dW(v, F);
            eW(v, H);
        }
        for(k = (A = new Snb(l.a).a.bb().mb(), new Ynb(A)); k.a.G();){
            j = (m = Wv(k.a.H(), 21), Wv(m.yb(), 12));
            dW(j, null);
            eW(j, null);
        }
        pI(b);
    }
    function c$(a) {
        var b, c, d, e, f, g, h, i, j, k, l, m, n, o1, p, q, r, s, t, u, v, w, A, B, C, D, F, G, H, I;
        C = Wv(rJ(a, (eM(), TL)), 28);
        if (!(C != (KM(), IM) && C != JM)) return;
        p = a.c;
        o1 = p.c.length;
        l = new HU((Mh(o1 + 2, Uyb), $s(PH(PH(5, o1 + 2), (o1 + 2) / 10 | 0))));
        q = new HU((Mh(o1 + 2, Uyb), $s(PH(PH(5, o1 + 2), (o1 + 2) / 10 | 0))));
        vU(l, new ntb);
        vU(l, new ntb);
        vU(q, new GU);
        vU(q, new GU);
        A = new vtb;
        for(b = 0; b < o1; b++){
            c = (Cxb(b, p.c.length), Wv(p.c[b], 16));
            D = (Cxb(b, l.c.length), Wv(l.c[b], 57));
            r = (mp(), new ntb);
            l.c[l.c.length] = r;
            G = (Cxb(b, q.c.length), Wv(q.c[b], 20));
            t = new GU;
            q.c[q.c.length] = t;
            for(e = new Tob(c.a); e.a < e.c.c.length;){
                d = Wv(Rob(e), 9);
                for(j = Uh(iX(d)); Cm(j);){
                    h = Wv(Dm(j), 12);
                    H = h.c.f;
                    if (!_Z(H)) continue;
                    A.a.db(H, A);
                    F = Wv(D.cb(rJ(H, (Rib(), uib))), 9);
                    if (!F) {
                        F = $Z(a, H);
                        D.db(rJ(H, uib), F);
                        G.ib(F);
                    }
                    dW(h, Wv(yU(F.f, 1), 7));
                }
                for(i = Uh(mX(d)); Cm(i);){
                    h = Wv(Dm(i), 12);
                    I = h.d.f;
                    if (!_Z(I)) continue;
                    A.a.db(I, A);
                    s = Wv(Smb(r, rJ(I, (Rib(), uib))), 9);
                    if (!s) {
                        s = $Z(a, I);
                        Umb(r, rJ(I, uib), s);
                        t.c[t.c.length] = s;
                    }
                    eW(h, Wv(yU(s.f, 0), 7));
                }
            }
        }
        for(m = 0; m < q.c.length; m++){
            u = (Cxb(m, q.c.length), Wv(q.c[m], 20));
            if (u.V()) continue;
            if (m == 0) {
                n = new sY(a);
                Fxb(0, p.c.length);
                fxb(p.c, 0, n);
            } else if (m == l.c.length - 1) {
                n = new sY(a);
                p.c[p.c.length] = n;
            } else n = (Cxb(m - 1, p.c.length), Wv(p.c[m - 1], 16));
            for(g = u.mb(); g.G();){
                f = Wv(g.H(), 9);
                rX(f, n);
            }
        }
        for(w = (B = new Snb(A.a).a.bb().mb(), new Ynb(B)); w.a.G();){
            v = (k = Wv(w.a.H(), 21), Wv(k.yb(), 9));
            rX(v, null);
        }
    }
    function Pab(a, b) {
        var c, d, e, f, g, h, i, j, k, l, m, n, o1, p, q, r, s, t, u, v, w, A, B, C, D, F, G, H, I, J, K;
        I = new GU;
        for(o1 = new Tob(b.c); o1.a < o1.c.c.length;){
            m = Wv(Rob(o1), 16);
            for(v = new Tob(m.a); v.a < v.c.c.length;){
                u = Wv(Rob(v), 9);
                u.k = -1;
                l = eyb;
                B = eyb;
                for(D = new Tob(u.f); D.a < D.c.c.length;){
                    C = Wv(Rob(D), 7);
                    for(e = new Tob(C.b); e.a < e.c.c.length;){
                        c = Wv(Rob(e), 12);
                        F = Wv(rJ(c, (Rib(), Eib)), 24).a;
                        l = l > F ? l : F;
                    }
                    for(d = new Tob(C.e); d.a < d.c.c.length;){
                        c = Wv(Rob(d), 12);
                        F = Wv(rJ(c, (Rib(), Eib)), 24).a;
                        B = B > F ? B : F;
                    }
                }
                sJ(u, Fab, Elb(l));
                sJ(u, Gab, Elb(B));
            }
        }
        r = 0;
        for(n = new Tob(b.c); n.a < n.c.c.length;){
            m = Wv(Rob(n), 16);
            for(v = new Tob(m.a); v.a < v.c.c.length;){
                u = Wv(Rob(v), 9);
                if (u.k < 0) {
                    H = new Wab;
                    H.b = r++;
                    Mab(a, u, H);
                    I.c[I.c.length] = H;
                }
            }
        }
        A = Do(I.c.length);
        k = Do(I.c.length);
        for(g = 0; g < I.c.length; g++){
            vU(A, new GU);
            vU(k, Elb(0));
        }
        Kab(b, I, A, k);
        J = Wv(FU(I, xv(wE, NAb, 111, I.c.length, 0, 1)), 625);
        w = Wv(FU(A, xv(sH, {
            3: 1,
            5: 1,
            6: 1,
            672: 1
        }, 20, A.c.length, 0, 1)), 672);
        j = xv(mw, Yyb, 26, k.c.length, 12, 1);
        for(h = 0; h < j.length; h++)j[h] = (Cxb(h, k.c.length), Wv(k.c[h], 24)).a;
        s = 0;
        t = new GU;
        for(i = 0; i < J.length; i++)j[i] == 0 && vU(t, J[i]);
        q = xv(mw, Yyb, 26, J.length, 12, 1);
        while(t.c.length != 0){
            H = Wv(AU(t, 0), 111);
            q[H.b] = s++;
            while(!w[H.b].V()){
                K = Wv(w[H.b].vb(0), 111);
                --j[K.b];
                j[K.b] == 0 && (t.c[t.c.length] = K);
            }
        }
        a.a = xv(wE, NAb, 111, J.length, 0, 1);
        for(f = 0; f < J.length; f++){
            p = J[f];
            G = q[f];
            a.a[G] = p;
            p.b = G;
            for(v = new Tob(p.f); v.a < v.c.c.length;){
                u = Wv(Rob(v), 9);
                u.k = G;
            }
        }
        return a.a;
    }
    function JP(a, b) {
        var c, d, e, f, g, h, i, j, k, l, m, n, o1, p, q, r, s, t, u, v, w, A, B, C;
        nI(b, 'Fixed Layout', 1);
        i = Wv(rJ(a, (eM(), uL)), 122);
        p = 0;
        q = 0;
        for(t = new Tob(a.b); t.a < t.c.c.length;){
            r = Wv(Rob(t), 9);
            B = Wv(rJ(r, YL), 10);
            if (B) {
                r.i.a = B.a;
                r.i.b = B.b;
                if (Wv(rJ(r, aM), 86).kb((DN(), zN))) {
                    C = Wv(rJ(r, IL), 15).a;
                    j = Wv(rJ(r, HL), 15).a;
                    C > 0 && j > 0 && WW(r, new HI(C, j), true);
                }
            }
            p = Nlb(p, r.i.a + r.j.a);
            q = Nlb(q, r.i.b + r.j.b);
            for(n = new Tob(r.c); n.a < n.c.c.length;){
                l = Wv(Rob(n), 33);
                B = Wv(rJ(l, YL), 10);
                if (B) {
                    l.i.a = B.a;
                    l.i.b = B.b;
                }
                p = Nlb(p, r.i.a + l.i.a + l.j.a);
                q = Nlb(q, r.i.b + l.i.b + l.j.b);
            }
            for(v = new Tob(r.f); v.a < v.c.c.length;){
                u = Wv(Rob(v), 7);
                B = Wv(rJ(u, YL), 10);
                if (B) {
                    u.i.a = B.a;
                    u.i.b = B.b;
                }
                w = r.i.a + u.i.a;
                A = r.i.b + u.i.b;
                p = Nlb(p, w + u.j.a);
                q = Nlb(q, A + u.j.b);
                for(m = new Tob(u.c); m.a < m.c.c.length;){
                    l = Wv(Rob(m), 33);
                    B = Wv(rJ(l, YL), 10);
                    if (B) {
                        l.i.a = B.a;
                        l.i.b = B.b;
                    }
                    p = Nlb(p, w + l.i.a + l.j.a);
                    q = Nlb(q, A + l.i.b + l.j.b);
                }
            }
            for(h = Uh(mX(r)); Cm(h);){
                f = Wv(Dm(h), 12);
                o1 = KP(f);
                p = Nlb(p, o1.a);
                q = Nlb(q, o1.b);
            }
            for(g = Uh(iX(r)); Cm(g);){
                f = Wv(Dm(g), 12);
                if (gw(rJ(f.c.f, (Rib(), sib))) !== gw(a)) {
                    o1 = KP(f);
                    p = Nlb(p, o1.a);
                    q = Nlb(q, o1.b);
                }
            }
        }
        if (i == (NK(), JK)) for(s = new Tob(a.b); s.a < s.c.c.length;){
            r = Wv(Rob(s), 9);
            for(g = Uh(mX(r)); Cm(g);){
                f = Wv(Dm(g), 12);
                k = LP(f);
                k.b == 0 ? sJ(f, CL, null) : sJ(f, CL, k);
            }
        }
        a.e.a = p;
        a.e.b = q;
        sJ(a, aM, (DN(), d = Wv(Hkb(Lz), 11), new atb(d, Wv(exb(d, d.length), 11), 0)));
        e = Wv(rJ(a, (Rib(), zib)), 9);
        !!e && sJ(e, aM, (c = Wv(Hkb(Lz), 11), new atb(c, Wv(exb(c, c.length), 11), 0)));
        pI(b);
    }
    function Y8(a, b) {
        var c, d, e, f, g, h, i, j, k, l, m, n, o1, p, q, r, s, t, u, v, w, A, B, C, D, F, G;
        if (!LM(Wv(rJ(b, (eM(), TL)), 28))) {
            if (b.f.c.length > 1) {
                A = xv(LF, Txb, 15, a.a.length, 0, 1);
                j = Do(a.a.length);
                p = 0;
                o1 = 0;
                c = 2 * b.d.a.c.length + 1;
                H: for(w = new Tob(b.f); w.a < w.c.c.length;){
                    v = Wv(Rob(w), 7);
                    r = v.g == (sN(), $M) || v.g == pN;
                    G = 0;
                    if (r) {
                        B = Wv(rJ(v, (Rib(), Bib)), 9);
                        if (!B) continue;
                        m = false;
                        u = false;
                        for(D = new Tob(B.f); D.a < D.c.c.length;){
                            C = Wv(Rob(D), 7);
                            gw(rJ(C, uib)) === gw(v) && (C.e.c.length == 0 ? C.b.c.length == 0 || (m = true) : u = true);
                        }
                        m && !u ? G = v.g == $M ? -(!B.d ? -1 : zU(B.d.a, B, 0)) : c - (!B.d ? -1 : zU(B.d.a, B, 0)) : u && !m ? G = (!B.d ? -1 : zU(B.d.a, B, 0)) + 1 : m && u && (G = v.g == $M ? 0 : c / 2);
                    } else {
                        for(t = new Tob(v.e); t.a < t.c.c.length;){
                            s = Wv(Rob(t), 12);
                            e = s.d;
                            if (e.f.d == b.d) {
                                j.c[j.c.length] = v;
                                continue H;
                            } else G += a.a[e.k];
                        }
                        for(l = new Tob(v.b); l.a < l.c.c.length;){
                            k = Wv(Rob(l), 12);
                            e = k.c;
                            if (e.f.d == b.d) {
                                j.c[j.c.length] = v;
                                continue H;
                            } else G -= a.a[e.k];
                        }
                    }
                    if (v.b.c.length + v.e.c.length > 0) {
                        A[v.k] = new llb(G / (v.b.c.length + v.e.c.length));
                        p = Rlb(p, A[v.k].a);
                        o1 = Olb(o1, A[v.k].a);
                    } else r && (A[v.k] = new llb(G));
                }
                q = (!b.d ? -1 : zU(b.d.a, b, 0)) + 1;
                n = b.d.a.c.length + 1;
                for(i = new Tob(j); i.a < i.c.c.length;){
                    h = Wv(Rob(i), 7);
                    G = 0;
                    g = 0;
                    for(f = Uh(Sh((Gi(), new gr(Ti(Bv(tv(UF, 1), syb, 1, 4, [
                        new fY(h),
                        new lY(h)
                    ])))))); Cm(f);){
                        e = Wv(Dm(f), 7);
                        if (e.f.d == b.d) {
                            G += jX(e.f) + 1;
                            ++g;
                        }
                    }
                    d = G / g;
                    F = h.g;
                    F == (sN(), ZM) ? d < q ? A[h.k] = new llb(p - d) : A[h.k] = new llb(o1 + (n - d)) : F == rN && (d < q ? A[h.k] = new llb(o1 + d) : A[h.k] = new llb(p - (n - d)));
                }
                Gpb(b.f, new a9(A));
            }
            sJ(b, TL, (KM(), EM));
        }
    }
    function O4(a) {
        var b, c, d, e, f, g, h, i, j, k, l, m, n, o1, p, q, r, s, t, u, v, w, A, B, C;
        B = new GU;
        a.a.b.c = xv(UF, syb, 1, 0, 4, 1);
        u = (mp(), new ntb);
        for(r = new Tob(a.d.c); r.a < r.c.c.length;){
            p = Wv(Rob(r), 16);
            for(t = new Tob(p.a); t.a < t.c.c.length;){
                s = Wv(Rob(t), 9);
                if (Ckb(Ixb(Xv(rJ(s, (eM(), qL)))))) {
                    if (!sl(gX(s))) {
                        h = Wv(ql(gX(s)), 12);
                        v = h.c.f;
                        v == s && (v = h.d.f);
                        w = new RJ(v, EI(xI(s.i), v.i));
                        Umb(a.b, s, w);
                        continue;
                    }
                }
                f = new Q3(s, a.d);
                vU(a.a.b, f);
                Ltb(u.d, s, f);
            }
        }
        for(q = new Tob(a.d.c); q.a < q.c.c.length;){
            p = Wv(Rob(q), 16);
            for(t = new Tob(p.a); t.a < t.c.c.length;){
                s = Wv(Rob(t), 9);
                f = Wv(re(Ktb(u.d, s)), 25);
                for(k = Uh(mX(s)); Cm(k);){
                    i = Wv(Dm(k), 12);
                    d = WI(i.a, 0);
                    l = true;
                    o1 = null;
                    if (d.b != d.d.c) {
                        b = Wv(_ub(d), 10);
                        if (i.c.g == (sN(), $M)) {
                            C = new X4(b, new HI(b.a, f.j.e), f, i);
                            C.c = true;
                            B.c[B.c.length] = C;
                        }
                        if (i.c.g == pN) {
                            C = new X4(b, new HI(b.a, f.j.e + f.j.b), f, i);
                            C.d = true;
                            B.c[B.c.length] = C;
                        }
                        while(d.b != d.d.c){
                            c = Wv(_ub(d), 10);
                            if (!RR(b.b, c.b)) {
                                o1 = new X4(b, c, null, i);
                                B.c[B.c.length] = o1;
                                if (l) {
                                    l = false;
                                    if (c.b < f.j.e) o1.c = true;
                                    else if (c.b > f.j.e + f.j.b) o1.d = true;
                                    else {
                                        o1.d = true;
                                        o1.c = true;
                                    }
                                }
                            }
                            d.b != d.d.c && (b = c);
                        }
                        if (o1) {
                            g = Wv(Smb(u, i.d.f), 25);
                            if (b.b < g.j.e) o1.c = true;
                            else if (b.b > g.j.e + g.j.b) o1.d = true;
                            else {
                                o1.d = true;
                                o1.c = true;
                            }
                        }
                    }
                }
                for(j = Uh(iX(s)); Cm(j);){
                    i = Wv(Dm(j), 12);
                    if (i.a.b != 0) {
                        b = Wv(VI(i.a), 10);
                        if (i.d.g == (sN(), $M)) {
                            C = new X4(b, new HI(b.a, f.j.e), f, i);
                            C.c = true;
                            B.c[B.c.length] = C;
                        }
                        if (i.d.g == pN) {
                            C = new X4(b, new HI(b.a, f.j.e + f.j.b), f, i);
                            C.d = true;
                            B.c[B.c.length] = C;
                        }
                    }
                }
            }
        }
        if (B.c.length != 0) {
            ypb();
            Gpb(B, null);
            n = (Cxb(0, B.c.length), Wv(B.c[0], 142));
            e = new L3(n, a.d);
            for(m = 1; m < B.c.length; m++){
                A = (Cxb(m, B.c.length), Wv(B.c[m], 142));
                if (RR(e.j.d, A.j) && !(TR(e.j.e + e.j.b, A.k) || TR(A.n, e.j.e))) K3(e, A);
                else {
                    vU(a.a.b, e);
                    e = new L3(A, a.d);
                }
            }
            vU(a.a.b, e);
        }
        B.c = xv(UF, syb, 1, 0, 4, 1);
        N4(a);
    }
    function eZ(a, b, c, d, e, f) {
        var g, h, i, j, k, l, m, n, o1, p, q, r, s, t, u, v, w, A, B, C, D, F, G, H, I, J, K, L, M;
        h = Wv(yU(a.d.c.c, d), 16);
        K = new vtb;
        o1 = new vtb;
        for(n = 0; n < h.a.c.length; ++n){
            s = Wv(yU(h.a, n), 9);
            n < c ? (D = K.a.db(s, K), D) : n > c && (C = o1.a.db(s, o1), C);
        }
        L = new vtb;
        p = new vtb;
        for(u = (G = new Snb(K.a).a.bb().mb(), new Ynb(G)); u.a.G();){
            s = (l = Wv(u.a.H(), 21), Wv(l.yb(), 9));
            g = b == 1 ? mX(s) : iX(s);
            for(j = (Il(), new Im(Dl(ul(g.a, new yl)))); Cm(j);){
                i = Wv(Dm(j), 12);
                rY(s.d) != rY(i.d.f.d) && stb(L, i.d.f);
            }
        }
        for(v = (H = new Snb(o1.a).a.bb().mb(), new Ynb(H)); v.a.G();){
            s = (l = Wv(v.a.H(), 21), Wv(l.yb(), 9));
            g = b == 1 ? mX(s) : iX(s);
            for(j = (Il(), new Im(Dl(ul(g.a, new yl)))); Cm(j);){
                i = Wv(Dm(j), 12);
                rY(s.d) != rY(i.d.f.d) && stb(p, i.d.f);
            }
        }
        if (aZ) Fmb();
        B = Wv(yU(a.d.c.c, d + (b == 1 ? 1 : -1)), 16);
        q = eyb;
        r = $xb;
        for(m = 0; m < B.a.c.length; m++){
            s = Wv(yU(B.a, m), 9);
            L.a.R(s) ? q = q > m ? q : m : p.a.R(s) && (r = r < m ? r : m);
        }
        if (q < r) {
            for(w = (I = new Snb(L.a).a.bb().mb(), new Ynb(I)); w.a.G();){
                s = (l = Wv(w.a.H(), 21), Wv(l.yb(), 9));
                for(k = Uh(mX(s)); Cm(k);){
                    i = Wv(Dm(k), 12);
                    if (rY(s.d) == rY(i.d.f.d)) return null;
                }
                for(j = Uh(iX(s)); Cm(j);){
                    i = Wv(Dm(j), 12);
                    if (rY(s.d) == rY(i.c.f.d)) return null;
                }
            }
            for(A = (F = new Snb(p.a).a.bb().mb(), new Ynb(F)); A.a.G();){
                s = (l = Wv(A.a.H(), 21), Wv(l.yb(), 9));
                for(k = Uh(mX(s)); Cm(k);){
                    i = Wv(Dm(k), 12);
                    if (rY(s.d) == rY(i.d.f.d)) return null;
                }
                for(j = Uh(iX(s)); Cm(j);){
                    i = Wv(Dm(j), 12);
                    if (rY(s.d) == rY(i.c.f.d)) return null;
                }
            }
            K.a.Y() == 0 ? M = 0 : o1.a.Y() == 0 ? M = B.a.c.length : M = q + 1;
            for(t = new Tob(h.a); t.a < t.c.c.length;){
                s = Wv(Rob(t), 9);
                if (s.g == (CX(), BX)) return null;
            }
            if (f == 1) return Co(Bv(tv(PF, 1), Txb, 24, 0, [
                Elb(M)
            ]));
            else if (b == 1 && d == e - 2 || b == 0 && d == 1) return Co(Bv(tv(PF, 1), Txb, 24, 0, [
                Elb(M)
            ]));
            else {
                J = eZ(a, b, M, d + (b == 1 ? 1 : -1), e, f - 1);
                !!J && b == 1 && J.rb(0, Elb(M));
                return J;
            }
        }
        return null;
    }
    function aQ(b, c) {
        var d, e, f, g, h, i, j, k, l, m, n, o1, p, q, r, s, t, u;
        SP(c);
        o1 = (eM(), KL).b;
        if (o1 in c.a && Pu(c, o1).ic().a) return;
        j = Pu(c, 'source');
        k = Pu(c, 'sourcePort');
        l = Pu(c, 'target');
        m = Pu(c, 'targetPort');
        if (!j) throw new GQ("Edges must contain a 'source' property.", null, c);
        else if (!j.lc()) throw new GQ("Invalid format of an edge's 'source' property. It must be a string.", j, c);
        if (!l) throw new GQ("Edges must contain a 'target' property.", null, c);
        else if (!l.lc()) throw new GQ("Invalid format of an edge's 'target' property. It must be a string.", l, c);
        r = null;
        t = null;
        try {
            q = Wv(Tmb(b.i, j.lc().a), 9);
            !!k && !!k.lc() && (r = Wv(Tmb(b.k, k.lc().a), 7));
            s = Wv(Tmb(b.i, l.lc().a), 9);
            !!m && !!m.lc() && (t = Wv(Tmb(b.k, m.lc().a), 7));
        } catch (a) {
            a = OH(a);
            if (aw(a, 76)) throw new FQ("An edge's 'source', 'target', 'sourcePort', and 'targetPort' properties have to be strings.", c);
            else throw NH(a);
        }
        if (!Ckb(Ixb(b.g))) {
            if (!q || !s) return;
            else if (hX(q) != hX(s)) return;
        }
        if (!q || !s) throw new FQ("An edge's source or target node could not be resolved.", c);
        p = hX(q);
        e = new hW;
        sJ(e, (Rib(), uib), c);
        h = Wv(Pu(c, 'id'), 97);
        Vmb(b.a, h.a, e);
        Umb(b.b, e, c);
        hQ(c, e);
        dQ(b, c, e, p);
        f = Wv(rJ(p, jib), 18);
        q == s && f.ib((ohb(), nhb));
        if (!r) r = OW(q, new FI, (djb(), bjb), p);
        else if (r.f != q) throw new EQ('Inconsistent source port reference found.');
        if (!t) t = OW(s, new FI, (djb(), ajb), p);
        else if (t.f != s) throw new EQ('Inconsistent target port reference found.');
        dW(e, r);
        eW(e, t);
        (tl(Sh((Gi(), new gr(Ti(Bv(tv(UF, 1), syb, 1, 4, [
            r.b,
            r.e
        ])))))) > 1 || tl(Sh(new gr(Ti(Bv(tv(UF, 1), syb, 1, 4, [
            t.b,
            t.e
        ]))))) > 1) && f.ib((ohb(), ihb));
        if (gw(rJ(p, (Mjb(), kjb))) === gw((p9(), n9)) && !(Hzb in c.a)) {
            d = new jJ;
            try {
                i = Pu(c, Hzb).hc();
                for(g = 0; g < i.a.length; ++g){
                    n = gu(i, g).kc();
                    u = new HI(Pu(n, 'x').jc().a, Pu(n, 'y').jc().a);
                    TI(d, u, d.c.b, d.c);
                }
                sJ(e, vib, d);
            } catch (a) {
                a = OH(a);
                if (aw(a, 54)) throw new FQ("Invalid format of an edges 'bendPoints' property.", c);
                else throw NH(a);
            }
        }
        sJ(e, CL, null);
    }
    function d0() {
        d0 = iI;
        L_ = new f0('LEFT_DIR_PREPROCESSOR', 0);
        o_ = new f0('DOWN_DIR_PREPROCESSOR', 1);
        c0 = new f0('UP_DIR_PREPROCESSOR', 2);
        m_ = new f0('COMMENT_PREPROCESSOR', 3);
        p_ = new f0('EDGE_AND_LAYER_CONSTRAINT_EDGE_REVERSER', 4);
        __ = new f0('SPLINE_SELF_LOOP_PREPROCESSOR', 5);
        z_ = new f0('INTERACTIVE_EXTERNAL_PORT_POSITIONER', 6);
        T_ = new f0('PARTITION_PREPROCESSOR', 7);
        j_ = new f0('BIG_NODES_PREPROCESSOR', 8);
        D_ = new f0('LABEL_DUMMY_INSERTER', 9);
        S_ = new f0('PARTITION_POSTPROCESSOR', 10);
        P_ = new f0('NODE_PROMOTION', 11);
        I_ = new f0('LAYER_CONSTRAINT_PROCESSOR', 12);
        s_ = new f0('HIERARCHICAL_PORT_CONSTRAINT_PROCESSOR', 13);
        h_ = new f0('BIG_NODES_INTERMEDIATEPROCESSOR', 14);
        N_ = new f0('LONG_EDGE_SPLITTER', 15);
        W_ = new f0('PORT_SIDE_PROCESSOR', 16);
        F_ = new f0('LABEL_DUMMY_SWITCHER', 17);
        G_ = new f0('LABEL_MANAGEMENT_PROCESSOR', 18);
        A_ = new f0('INVERTED_PORT_PROCESSOR', 19);
        Z_ = new f0('SELF_LOOP_PROCESSOR', 20);
        V_ = new f0('PORT_LIST_SORTER', 21);
        R_ = new f0('NORTH_SOUTH_PORT_PREPROCESSOR', 22);
        r_ = new f0('GREEDY_SWITCH', 23);
        U_ = new f0('PORT_DISTRIBUTER', 24);
        $_ = new f0('SPLINE_SELF_LOOP_POSITIONER', 25);
        Y_ = new f0('SAUSAGE_COMPACTION', 26);
        B_ = new f0('IN_LAYER_CONSTRAINT_PROCESSOR', 27);
        x_ = new f0('HYPEREDGE_DUMMY_MERGER', 28);
        H_ = new f0('LABEL_SIDE_SELECTOR', 29);
        k_ = new f0('BIG_NODES_SPLITTER', 30);
        C_ = new f0('LABEL_AND_NODE_SIZE_PROCESSOR', 31);
        a0 = new f0('SPLINE_SELF_LOOP_ROUTER', 32);
        O_ = new f0('NODE_MARGIN_CALCULATOR', 33);
        t_ = new f0('HIERARCHICAL_PORT_DUMMY_SIZE_PROCESSOR', 34);
        v_ = new f0('HIERARCHICAL_PORT_POSITION_PROCESSOR', 35);
        J_ = new f0('LAYER_SIZE_AND_GRAPH_HEIGHT_CALCULATOR', 36);
        i_ = new f0('BIG_NODES_POSTPROCESSOR', 37);
        l_ = new f0('COMMENT_POSTPROCESSOR', 38);
        y_ = new f0('HYPERNODE_PROCESSOR', 39);
        u_ = new f0('HIERARCHICAL_PORT_ORTHOGONAL_EDGE_ROUTER', 40);
        M_ = new f0('LONG_EDGE_JOINER', 41);
        Q_ = new f0('NORTH_SOUTH_PORT_POSTPROCESSOR', 42);
        E_ = new f0('LABEL_DUMMY_REMOVER', 43);
        w_ = new f0('HORIZONTAL_COMPACTOR', 44);
        X_ = new f0('REVERSED_EDGE_RESTORER', 45);
        K_ = new f0('LEFT_DIR_POSTPROCESSOR', 46);
        n_ = new f0('DOWN_DIR_POSTPROCESSOR', 47);
        b0 = new f0('UP_DIR_POSTPROCESSOR', 48);
        q_ = new f0('END_LABEL_PROCESSOR', 49);
    }
    function Rib() {
        Rib = iI;
        var a, b;
        uib = new CJ('origin');
        _hb = new CJ('processingConfiguration');
        Fib = new CJ('processors');
        $hb = new DJ('compoundNode', (xkb(), xkb(), vkb));
        lib = new DJ('insideConnections', vkb);
        sib = new CJ('nestedLGraph');
        zib = new CJ('parentLNode');
        vib = new CJ('originalBendpoints');
        wib = new CJ('originalDummyNodePosition');
        xib = new CJ('originalLabelEdge');
        Hib = new CJ('representedLabels');
        pib = new DJ('labelSide', (kP(), jP));
        Iib = new DJ('reversed', vkb);
        Gib = new CJ('random');
        qib = new DJ('longEdgeSource', null);
        rib = new DJ('longEdgeTarget', null);
        dib = new DJ('edgeConstraint', (Hgb(), Fgb));
        nib = new CJ('inLayerLayoutUnit');
        mib = new DJ('inLayerConstraint', (Hhb(), Fhb));
        oib = new DJ('inLayerSuccessorConstraint', new GU);
        Bib = new CJ('portDummy');
        aib = new DJ('crossingHint', Elb(0));
        jib = new DJ('graphProperties', (b = Wv(Hkb(mF), 11), new atb(b, Wv(exb(b, b.length), 11), 0)));
        hib = new DJ('externalPortSide', (sN(), qN));
        iib = new DJ('externalPortSize', new FI);
        gib = new CJ('externalPortReplacedDummy');
        fib = new DJ('externalPortConnections', (a = Wv(Hkb(Kz), 11), new atb(a, Wv(exb(a, a.length), 11), 0)));
        Cib = new DJ(yzb, 0);
        Shb = new CJ('barycenterAssociates');
        Qib = new CJ('TopSideComments');
        Yhb = new CJ('BottomSideComments');
        Zhb = new CJ('CommentConnectionPort');
        kib = new DJ('inputCollect', vkb);
        yib = new DJ('outputCollect', vkb);
        cib = new DJ('cyclic', vkb);
        Whb = new DJ('bigNodeOriginalSize', new llb(0));
        Vhb = new DJ('bigNodeInitial', vkb);
        Thb = new DJ('de.cau.cs.kieler.klay.layered.bigNodeLabels', new GU);
        Uhb = new DJ('de.cau.cs.kieler.klay.layered.postProcess', null);
        bib = new CJ('crossHierarchyMap');
        Pib = new CJ('targetOffset');
        Lib = new DJ('splineLabelSize', new FI);
        Mib = new DJ('splineLoopSide', (Ieb(), Feb));
        Nib = new DJ('splineSelfLoopComponents', new GU);
        Oib = new DJ('splineSelfLoopMargins', new DP);
        Kib = new CJ('spacings');
        Aib = new DJ('partitionConstraint', vkb);
        tib = new AJ((eM(), LL), new llb(0));
        Jib = new BJ(cM, new llb(20), new llb(1));
        Dib = new BJ(XL, new llb(10), new llb(1));
        Xhb = new BJ(pL, new llb(12), new llb(0));
        Eib = new AJ(ZL, Elb(0));
        Rhb = new BJ(nL, new llb(cAb), new llb(0));
        eib = new AJ(uL, (NK(), JK));
    }
    function Mjb() {
        Mjb = iI;
        Bjb = new DJ('de.cau.cs.kieler.klay.layered.nodePromotion', (I1(), G1));
        Cjb = new FJ('de.cau.cs.kieler.klay.layered.nodePromotionBoundary', Elb(0), Elb(0), Elb(100));
        Hjb = new DJ(vzb, Elb(1));
        Ejb = new EJ('de.cau.cs.kieler.klay.layered.inLayerSpacingFactor', new llb(1), new llb(0));
        qjb = new DJ('de.cau.cs.kieler.klay.layered.edgeSpacingFactor', new llb(0.5));
        pjb = new DJ('de.cau.cs.kieler.klay.layered.edgeNodeSpacingFactor', new llb(IAb));
        njb = new DJ('de.cau.cs.kieler.klay.layered.distributeNodes', (xkb(), xkb(), vkb));
        Ljb = new DJ('de.cau.cs.kieler.klay.layered.wideNodesOnMultipleLayers', (ckb(), bkb));
        ljb = new DJ('de.cau.cs.kieler.klay.layered.cycleBreaking', (Z7(), X7));
        zjb = new DJ('de.cau.cs.kieler.klay.layered.nodeLayering', (x8(), w8));
        kjb = new DJ('de.cau.cs.kieler.klay.layered.crossMin', (p9(), o9));
        tjb = new DJ('de.cau.cs.kieler.klay.layered.greedySwitch', (zhb(), whb));
        Ajb = new DJ('de.cau.cs.kieler.klay.layered.nodePlace', (kbb(), fbb));
        wjb = new FJ('de.cau.cs.kieler.klay.layered.linearSegmentsDeflectionDampening', new llb(HAb), new llb(0), new llb(1));
        sjb = new DJ('de.cau.cs.kieler.klay.layered.fixedAlignment', (_gb(), Ygb));
        ojb = new DJ('de.cau.cs.kieler.klay.layered.edgeLabelSideSelection', (Pgb(), Lgb));
        mjb = new DJ(uzb, vkb);
        Kjb = new EJ('de.cau.cs.kieler.klay.layered.thoroughness', Elb(10), Elb(1));
        vjb = new DJ('de.cau.cs.kieler.klay.layered.layerConstraint', (Xib(), Wib));
        xjb = new DJ('de.cau.cs.kieler.klay.layered.mergeEdges', vkb);
        yjb = new DJ('de.cau.cs.kieler.klay.layered.mergeHierarchyEdges', wkb);
        ujb = new DJ('de.cau.cs.kieler.klay.layered.interactiveReferencePoint', (Mhb(), Khb));
        rjb = new DJ('de.cau.cs.kieler.klay.layered.feedBackEdges', vkb);
        gjb = new DJ('de.cau.cs.kieler.klay.layered.unnecessaryBendpoints', vkb);
        jjb = new DJ('de.cau.cs.kieler.klay.layered.contentAlignment', (zgb(), Vsb(ygb, Bv(tv(iF, 1), uyb, 123, 0, [
            ugb
        ]))));
        Ijb = new DJ('de.cau.cs.kieler.klay.layered.sausageFolding', vkb);
        Jjb = new DJ('de.cau.cs.kieler.klay.layered.splines.selfLoopPlacement', (Qjb(), Pjb));
        hjb = new DJ('de.cau.cs.kieler.klay.layered.nodeplace.compactionStrategy', (lcb(), jcb));
        Djb = new DJ('de.cau.cs.kieler.klay.layered.northOrSouthPort', vkb);
        Fjb = new DJ('de.cau.cs.kieler.klay.layered.postCompaction', (g4(), e4));
        Gjb = new DJ('de.cau.cs.kieler.klay.layered.postCompaction.constraints', (X3(), W3));
        ijb = new DJ('de.cau.cs.kieler.klay.layered.components.compact', vkb);
    }
    function uO() {
        uO = iI;
        rO = new vO('OUT_T_L', 0, (Gi(), new Er(Vsb((oM(), kM), Bv(tv(Gz, 1), uyb, 41, 0, [
            nM,
            gM
        ])))), (DO(), BO));
        qO = new vO('OUT_T_C', 1, new gr(Ti(Bv(tv(UF, 1), syb, 1, 4, [
            Vsb(kM, Bv(tv(Gz, 1), uyb, 41, 0, [
                nM,
                fM
            ])),
            Vsb(kM, Bv(tv(Gz, 1), uyb, 41, 0, [
                nM,
                fM,
                hM
            ]))
        ]))), AO);
        sO = new vO('OUT_T_R', 2, new Er(Vsb(kM, Bv(tv(Gz, 1), uyb, 41, 0, [
            nM,
            iM
        ]))), CO);
        iO = new vO('OUT_B_L', 3, new Er(Vsb(kM, Bv(tv(Gz, 1), uyb, 41, 0, [
            lM,
            gM
        ]))), BO);
        hO = new vO('OUT_B_C', 4, new gr(Ti(Bv(tv(UF, 1), syb, 1, 4, [
            Vsb(kM, Bv(tv(Gz, 1), uyb, 41, 0, [
                lM,
                fM
            ])),
            Vsb(kM, Bv(tv(Gz, 1), uyb, 41, 0, [
                lM,
                fM,
                hM
            ]))
        ]))), AO);
        jO = new vO('OUT_B_R', 5, new Er(Vsb(kM, Bv(tv(Gz, 1), uyb, 41, 0, [
            lM,
            iM
        ]))), CO);
        mO = new vO('OUT_L_T', 6, new Er(Vsb(kM, Bv(tv(Gz, 1), uyb, 41, 0, [
            gM,
            nM,
            hM
        ]))), CO);
        lO = new vO('OUT_L_C', 7, new gr(Ti(Bv(tv(UF, 1), syb, 1, 4, [
            Vsb(kM, Bv(tv(Gz, 1), uyb, 41, 0, [
                gM,
                mM
            ])),
            Vsb(kM, Bv(tv(Gz, 1), uyb, 41, 0, [
                gM,
                mM,
                hM
            ]))
        ]))), CO);
        kO = new vO('OUT_L_B', 8, new Er(Vsb(kM, Bv(tv(Gz, 1), uyb, 41, 0, [
            gM,
            lM,
            hM
        ]))), CO);
        pO = new vO('OUT_R_T', 9, new Er(Vsb(kM, Bv(tv(Gz, 1), uyb, 41, 0, [
            iM,
            nM,
            hM
        ]))), BO);
        oO = new vO('OUT_R_C', 10, new gr(Ti(Bv(tv(UF, 1), syb, 1, 4, [
            Vsb(kM, Bv(tv(Gz, 1), uyb, 41, 0, [
                iM,
                mM
            ])),
            Vsb(kM, Bv(tv(Gz, 1), uyb, 41, 0, [
                iM,
                mM,
                hM
            ]))
        ]))), BO);
        nO = new vO('OUT_R_B', 11, new Er(Vsb(kM, Bv(tv(Gz, 1), uyb, 41, 0, [
            iM,
            lM,
            hM
        ]))), BO);
        fO = new vO('IN_T_L', 12, new gr(Ti(Bv(tv(UF, 1), syb, 1, 4, [
            Vsb(jM, Bv(tv(Gz, 1), uyb, 41, 0, [
                nM,
                gM
            ])),
            Vsb(jM, Bv(tv(Gz, 1), uyb, 41, 0, [
                nM,
                gM,
                hM
            ]))
        ]))), BO);
        eO = new vO('IN_T_C', 13, new gr(Ti(Bv(tv(UF, 1), syb, 1, 4, [
            Vsb(jM, Bv(tv(Gz, 1), uyb, 41, 0, [
                nM,
                fM
            ])),
            Vsb(jM, Bv(tv(Gz, 1), uyb, 41, 0, [
                nM,
                fM,
                hM
            ]))
        ]))), AO);
        gO = new vO('IN_T_R', 14, new gr(Ti(Bv(tv(UF, 1), syb, 1, 4, [
            Vsb(jM, Bv(tv(Gz, 1), uyb, 41, 0, [
                nM,
                iM
            ])),
            Vsb(jM, Bv(tv(Gz, 1), uyb, 41, 0, [
                nM,
                iM,
                hM
            ]))
        ]))), CO);
        cO = new vO('IN_C_L', 15, new gr(Ti(Bv(tv(UF, 1), syb, 1, 4, [
            Vsb(jM, Bv(tv(Gz, 1), uyb, 41, 0, [
                mM,
                gM
            ])),
            Vsb(jM, Bv(tv(Gz, 1), uyb, 41, 0, [
                mM,
                gM,
                hM
            ]))
        ]))), BO);
        bO = new vO('IN_C_C', 16, new gr(Ti(Bv(tv(UF, 1), syb, 1, 4, [
            Vsb(jM, Bv(tv(Gz, 1), uyb, 41, 0, [
                mM,
                fM
            ])),
            Vsb(jM, Bv(tv(Gz, 1), uyb, 41, 0, [
                mM,
                fM,
                hM
            ]))
        ]))), AO);
        dO = new vO('IN_C_R', 17, new gr(Ti(Bv(tv(UF, 1), syb, 1, 4, [
            Vsb(jM, Bv(tv(Gz, 1), uyb, 41, 0, [
                mM,
                iM
            ])),
            Vsb(jM, Bv(tv(Gz, 1), uyb, 41, 0, [
                mM,
                iM,
                hM
            ]))
        ]))), CO);
        _N = new vO('IN_B_L', 18, new gr(Ti(Bv(tv(UF, 1), syb, 1, 4, [
            Vsb(jM, Bv(tv(Gz, 1), uyb, 41, 0, [
                lM,
                gM
            ])),
            Vsb(jM, Bv(tv(Gz, 1), uyb, 41, 0, [
                lM,
                gM,
                hM
            ]))
        ]))), BO);
        $N = new vO('IN_B_C', 19, new gr(Ti(Bv(tv(UF, 1), syb, 1, 4, [
            Vsb(jM, Bv(tv(Gz, 1), uyb, 41, 0, [
                lM,
                fM
            ])),
            Vsb(jM, Bv(tv(Gz, 1), uyb, 41, 0, [
                lM,
                fM,
                hM
            ]))
        ]))), AO);
        aO = new vO('IN_B_R', 20, new gr(Ti(Bv(tv(UF, 1), syb, 1, 4, [
            Vsb(jM, Bv(tv(Gz, 1), uyb, 41, 0, [
                lM,
                iM
            ])),
            Vsb(jM, Bv(tv(Gz, 1), uyb, 41, 0, [
                lM,
                iM,
                hM
            ]))
        ]))), CO);
        tO = new vO(szb, 21, Fi, null);
    }
    function lab(a, b, c) {
        var d, e, f, g, h, i, j, k, l, m, n, o1, p, q, r, s, t, u, v, w, A, B, C, D, F, G, H, I, J, K, L, M, N, O, P, Q, R, S, T, U, V, W, X, Y, Z, $, ab, bb, cb, db, eb, fb, gb, hb, ib;
        $ = 0;
        for(G = 0, J = b.length; G < J; ++G){
            D = b[G];
            if (LM(Wv(rJ(D, (eM(), TL)), 28))) for(S = new Tob(D.f); S.a < S.c.c.length;){
                R = Wv(Rob(S), 7);
                U = 0;
                for(h = new Tob(R.e); h.a < h.c.c.length;){
                    g = Wv(Rob(h), 12);
                    D.d != g.d.f.d && ++U;
                }
                U > 0 && (a.a[R.k] = $++);
            }
            else {
                L = 0;
                for(S = new Tob(D.f); S.a < S.c.c.length;){
                    R = Wv(Rob(S), 7);
                    for(h = new Tob(R.e); h.a < h.c.c.length;){
                        g = Wv(Rob(h), 12);
                        D.d != g.d.f.d && ++L;
                    }
                    a.a[R.k] = $;
                }
                L > 0 && ++$;
            }
        }
        eb = 0;
        for(H = 0, K = c.length; H < K; ++H){
            D = c[H];
            if (LM(Wv(rJ(D, (eM(), TL)), 28))) {
                M = 0;
                for(S = new Tob(D.f); S.a < S.c.c.length;){
                    R = Wv(Rob(S), 7);
                    if (R.g == (sN(), $M)) for(h = new Tob(R.b); h.a < h.c.c.length;){
                        g = Wv(Rob(h), 12);
                        if (D.d != g.c.f.d) {
                            ++M;
                            break;
                        }
                    }
                    else break;
                }
                O = 0;
                V = new Fnb(D.f, D.f.c.length);
                while(V.b > 0){
                    R = (Bxb(V.b > 0), Wv(V.a.sb(V.c = --V.b), 7));
                    U = 0;
                    for(h = new Tob(R.b); h.a < h.c.c.length;){
                        g = Wv(Rob(h), 12);
                        D.d != g.c.f.d && ++U;
                    }
                    if (U > 0) {
                        if (R.g == (sN(), $M)) {
                            a.a[R.k] = eb;
                            ++eb;
                        } else {
                            a.a[R.k] = eb + M + O;
                            ++O;
                        }
                    }
                }
                eb += O;
            } else {
                L = 0;
                for(S = new Tob(D.f); S.a < S.c.c.length;){
                    R = Wv(Rob(S), 7);
                    for(h = new Tob(R.b); h.a < h.c.c.length;){
                        g = Wv(Rob(h), 12);
                        D.d != g.c.f.d && ++L;
                    }
                    a.a[R.k] = eb;
                }
                L > 0 && ++eb;
            }
        }
        T = (mp(), new ntb);
        n = new Wub;
        for(F = 0, I = b.length; F < I; ++F){
            D = b[F];
            for(cb = new Tob(D.f); cb.a < cb.c.c.length;){
                bb = Wv(Rob(cb), 7);
                for(h = new Tob(bb.e); h.a < h.c.c.length;){
                    g = Wv(Rob(h), 12);
                    gb = g.d;
                    if (D.d != gb.f.d) {
                        ab = Wv(re(Ktb(T.d, bb)), 197);
                        fb = Wv(re(Ktb(T.d, gb)), 197);
                        if (!ab && !fb) {
                            m = new oab;
                            n.a.db(m, n);
                            vU(m.a, g);
                            vU(m.d, bb);
                            Ltb(T.d, bb, m);
                            vU(m.d, gb);
                            Ltb(T.d, gb, m);
                        } else if (!ab) {
                            vU(fb.a, g);
                            vU(fb.d, bb);
                            Ltb(T.d, bb, fb);
                        } else if (!fb) {
                            vU(ab.a, g);
                            vU(ab.d, gb);
                            Ltb(T.d, gb, ab);
                        } else if (ab == fb) vU(ab.a, g);
                        else {
                            vU(ab.a, g);
                            for(Q = new Tob(fb.d); Q.a < Q.c.c.length;){
                                P = Wv(Rob(Q), 7);
                                Ltb(T.d, P, ab);
                            }
                            xU(ab.a, fb.a);
                            xU(ab.d, fb.d);
                            n.a.eb(fb);
                        }
                    }
                }
            }
        }
        o1 = Wv(Ye(n, xv(tE, {
            674: 1,
            3: 1,
            5: 1,
            6: 1
        }, 197, n.a.Y(), 0, 1)), 674);
        C = b[0].d;
        Z = c[0].d;
        for(k = 0, l = o1.length; k < l; ++k){
            j = o1[k];
            j.e = $;
            j.f = eb;
            for(S = new Tob(j.d); S.a < S.c.c.length;){
                R = Wv(Rob(S), 7);
                W = a.a[R.k];
                if (R.f.d == C) {
                    W < j.e && (j.e = W);
                    W > j.b && (j.b = W);
                } else if (R.f.d == Z) {
                    W < j.f && (j.f = W);
                    W > j.c && (j.c = W);
                }
            }
        }
        ipb(o1, 0, o1.length, (hsb(), hsb(), gsb));
        db = xv(mw, Yyb, 26, o1.length, 12, 1);
        d = xv(mw, Yyb, 26, eb + 1, 12, 1);
        for(q = 0; q < o1.length; q++){
            db[q] = o1[q].f;
            d[db[q]] = 1;
        }
        f = 0;
        for(r = 0; r < d.length; r++)d[r] == 1 ? d[r] = f : --f;
        X = 0;
        for(s = 0; s < db.length; s++){
            db[s] += d[db[s]];
            X = Plb(X, db[s] + 1);
        }
        i = 1;
        while(i < X)i *= 2;
        ib = 2 * i - 1;
        i -= 1;
        hb = xv(mw, Yyb, 26, ib, 12, 1);
        e = 0;
        for(A = 0; A < db.length; A++){
            w = db[A] + i;
            ++hb[w];
            while(w > 0){
                w % 2 > 0 && (e += hb[w + 1]);
                w = (w - 1) / 2 | 0;
                ++hb[w];
            }
        }
        B = xv(sE, syb, 156, o1.length * 2, 0, 1);
        for(t = 0; t < o1.length; t++){
            B[2 * t] = new rab(o1[t], o1[t].e, o1[t].b, (vab(), uab));
            B[2 * t + 1] = new rab(o1[t], o1[t].b, o1[t].e, tab);
        }
        ipb(B, 0, B.length, gsb);
        N = 0;
        for(u = 0; u < B.length; u++)switch(B[u].d.e){
            case 0:
                ++N;
                break;
            case 1:
                --N;
                e += N;
        }
        Y = xv(sE, syb, 156, o1.length * 2, 0, 1);
        for(v = 0; v < o1.length; v++){
            Y[2 * v] = new rab(o1[v], o1[v].f, o1[v].c, (vab(), uab));
            Y[2 * v + 1] = new rab(o1[v], o1[v].c, o1[v].f, tab);
        }
        ipb(Y, 0, Y.length, gsb);
        N = 0;
        for(p = 0; p < Y.length; p++)switch(Y[p].d.e){
            case 0:
                ++N;
                break;
            case 1:
                --N;
                e += N;
        }
        return e;
    }
    function eM() {
        eM = iI;
        var a, b;
        mL = new DJ('de.cau.cs.kieler.animate', (xkb(), xkb(), wkb));
        new DJ('de.cau.cs.kieler.minAnimTime', Elb(400));
        new DJ('de.cau.cs.kieler.maxAnimTime', Elb(4000));
        new DJ('de.cau.cs.kieler.animTimeFactor', Elb(100));
        jL = new DJ('de.cau.cs.kieler.additionalPortSpace', null);
        qL = new DJ('de.cau.cs.kieler.commentBox', vkb);
        new CJ('de.cau.cs.kieler.diagramType');
        tL = new DJ('de.cau.cs.kieler.edgeLabelPlacement', (EK(), DK));
        vL = new DJ('de.cau.cs.kieler.edgeType', (YK(), WK));
        xL = new CJ('de.cau.cs.kieler.fontName');
        yL = new DJ('de.cau.cs.kieler.fontSize', Elb(0));
        AL = new DJ('de.cau.cs.kieler.hypernode', vkb);
        CL = new DJ('de.cau.cs.kieler.junctionPoints', new jJ);
        new DJ('de.cau.cs.kieler.layoutAncestors', vkb);
        GL = new DJ('de.cau.cs.kieler.margins', new DP);
        HL = new EJ('de.cau.cs.kieler.minHeight', new llb(0), new llb(0));
        IL = new EJ('de.cau.cs.kieler.minWidth', new llb(0), new llb(0));
        KL = new DJ('de.cau.cs.kieler.noLayout', vkb);
        LL = new CJ('de.cau.cs.kieler.offset');
        SL = new CJ('de.cau.cs.kieler.klay.layered.portAnchor');
        UL = new CJ('de.cau.cs.kieler.portIndex');
        WL = new DJ('de.cau.cs.kieler.portSide', (sN(), qN));
        new DJ('de.cau.cs.kieler.progressBar', vkb);
        new DJ('de.cau.cs.kieler.resetConfig', wkb);
        new DJ('de.cau.cs.kieler.scaleFactor', new llb(1));
        dM = new DJ('de.cau.cs.kieler.thickness', new llb(1));
        new DJ('de.cau.cs.kieler.zoomToFit', vkb);
        kL = new CJ('de.cau.cs.kieler.algorithm');
        lL = new DJ('de.cau.cs.kieler.alignment', (iK(), cK));
        nL = new DJ('de.cau.cs.kieler.aspectRatio', new llb(0));
        oL = new CJ('de.cau.cs.kieler.bendPoints');
        pL = new DJ('de.cau.cs.kieler.borderSpacing', new llb(-1));
        rL = new DJ(uzb, vkb);
        sL = new DJ('de.cau.cs.kieler.direction', (sK(), qK));
        uL = new DJ('de.cau.cs.kieler.edgeRouting', (NK(), MK));
        wL = new DJ('de.cau.cs.kieler.expandNodes', vkb);
        zL = new DJ('de.cau.cs.kieler.hierarchyHandling', (eL(), cL));
        BL = new DJ('de.cau.cs.kieler.interactive', vkb);
        DL = new EJ('de.cau.cs.kieler.labelSpacing', new llb(3), new llb(0));
        EL = new DJ('de.cau.cs.kieler.layoutHierarchy', vkb);
        JL = new DJ('de.cau.cs.kieler.nodeLabelPlacement', (oM(), b = Wv(Hkb(Gz), 11), new atb(b, Wv(exb(b, b.length), 11), 0)));
        TL = new DJ('de.cau.cs.kieler.portConstraints', (KM(), JM));
        VL = new DJ('de.cau.cs.kieler.portLabelPlacement', (UM(), TM));
        XL = new EJ('de.cau.cs.kieler.portSpacing', new llb(-1), new llb(0));
        NL = new DJ('de.cau.cs.kieler.portAlignment', (zM(), xM));
        PL = new DJ('de.cau.cs.kieler.portAlignment.north', yM);
        QL = new DJ('de.cau.cs.kieler.portAlignment.south', yM);
        RL = new DJ('de.cau.cs.kieler.portAlignment.west', yM);
        OL = new DJ('de.cau.cs.kieler.portAlignment.east', yM);
        YL = new CJ('de.cau.cs.kieler.position');
        ZL = new CJ('de.cau.cs.kieler.priority');
        new CJ(vzb);
        $L = new DJ('de.cau.cs.kieler.selfLoopInside', vkb);
        _L = new CJ('de.cau.cs.kieler.separateConnComp');
        aM = new DJ('de.cau.cs.kieler.sizeConstraint', (DN(), a = Wv(Hkb(Lz), 11), new atb(a, Wv(exb(a, a.length), 11), 0)));
        bM = new DJ('de.cau.cs.kieler.sizeOptions', Vsb((MN(), KN), Bv(tv(Mz, 1), uyb, 139, 0, [
            IN
        ])));
        cM = new EJ('de.cau.cs.kieler.spacing', new llb(-1), new llb(0));
        FL = new DJ('de.cau.cs.kieler.layoutPartitions', vkb);
        ML = new CJ('de.cau.cs.kieler.partition');
    }
    function wQ(b, c, d, e) {
        tQ();
        var f, g, h, i, j, k, l, m, n, o1, p, q, r, s, t;
        if (!e) {
            if ((!b.n ? (ypb(), ypb(), wpb) : b.n).R(new xQ(c))) return;
        }
        if (Wv(rQ.a, 18).kb(c)) {
            if (!d.lc()) throw new _J(Pzb + c + Qzb + d + ').');
            o1 = Wv(Wv(rQ.b, 57).cb(c), 79);
            p = d.lc().a;
            sJ(b, o1, p);
            return;
        } else if (Wv(oQ.a, 18).kb(c)) try {
            if (!d.jc()) throw new Xlb;
            o1 = Wv(Wv(oQ.b, 57).cb(c), 79);
            s = Elb(dlb((bmb(), '' + d.jc().a)));
            sJ(b, o1, s);
            return;
        } catch (a) {
            a = OH(a);
            if (aw(a, 130)) throw new _J("Invalid integer format for property '" + c + Qzb + d + ').');
            else throw NH(a);
        }
        else if (Wv(kQ.a, 18).kb(c)) {
            if (!d.ic()) throw new _J(Pzb + c + Qzb + d + ').');
            o1 = Wv(Wv(kQ.b, 57).cb(c), 79);
            s = (xkb(), d.ic().a ? wkb : vkb);
            sJ(b, o1, s);
            return;
        } else if (Wv(nQ.a, 18).kb(c)) {
            if (!d.jc()) throw new _J("Invalid float format for property '" + c + Qzb + d + ').');
            o1 = Wv(Wv(nQ.b, 57).cb(c), 79);
            s = new klb(d.jc().a);
            sJ(b, o1, s);
            return;
        } else if (Wv(mQ.a, 18).kb(c)) {
            if (!d.lc()) throw new _J(Rzb + c + Qzb + d + ').');
            l = d.lc().a;
            m = null;
            try {
                vQ((eM(), WL), c) ? m = (sN(), Wv(Gc((yN(), xN), l), 32)) : vQ(lL, c) ? m = (iK(), Wv(Gc((mK(), lK), l), 103)) : vQ(sL, c) ? m = (sK(), Wv(Gc((zK(), yK), l), 59)) : vQ(uL, c) ? m = (NK(), Wv(Gc((RK(), QK), l), 122)) : vQ(zL, c) ? m = (eL(), Wv(Gc((iL(), hL), l), 166)) : vQ(NL, c) || vQ(OL, c) || vQ(PL, c) || vQ(QL, c) || vQ(RL, c) ? m = (zM(), Wv(Gc((DM(), CM), l), 100)) : vQ(TL, c) ? m = (KM(), Wv(Gc((QM(), PM), l), 28)) : vQ(VL, c) ? m = (UM(), Wv(Gc((YM(), XM), l), 149)) : vQ(vL, c) ? m = (YK(), Wv(Gc((aL(), _K), l), 133)) : vQ(tL, c) ? m = (EK(), Wv(Gc((IK(), HK), l), 107)) : vQ((Mjb(), ljb), c) ? m = (Z7(), Wv(Gc((c8(), b8), l), 193)) : vQ(zjb, c) ? m = (x8(), Wv(Gc((C8(), B8), l), 173)) : vQ(ojb, c) ? m = (Pgb(), Wv(Gc((Ugb(), Tgb), l), 115)) : vQ(hjb, c) ? m = (lcb(), Wv(Gc((pcb(), ocb), l), 194)) : vQ(kjb, c) ? m = (p9(), Wv(Gc((u9(), t9), l), 192)) : vQ(Bjb, c) ? m = (I1(), Wv(Gc((M1(), L1), l), 109)) : vQ(Ajb, c) ? m = (kbb(), Wv(Gc((pbb(), obb), l), 141)) : vQ(Fjb, c) ? m = (g4(), Wv(Gc((k4(), j4), l), 125)) : vQ(Gjb, c) ? m = (X3(), Wv(Gc((_3(), $3), l), 175)) : vQ(sjb, c) ? m = (_gb(), Wv(Gc((dhb(), chb), l), 124)) : vQ(tjb, c) ? m = (zhb(), Wv(Gc((Dhb(), Chb), l), 110)) : vQ(vjb, c) ? m = (Xib(), Wv(Gc((_ib(), $ib), l), 85)) : vQ(Jjb, c) ? m = (Qjb(), Wv(Gc((Ujb(), Tjb), l), 153)) : vQ(Ljb, c) ? m = (ckb(), Wv(Gc((gkb(), fkb), l), 172)) : vQ(ujb, c) && (m = (Mhb(), Wv(Gc((Qhb(), Phb), l), 174)));
            } catch (a) {
                a = OH(a);
                if (aw(a, 54)) throw new _J(Rzb + c + Qzb + d + ').');
                else throw NH(a);
            }
            o1 = Wv(Wv(mQ.b, 57).cb(c), 79);
            sJ(b, o1, m);
            return;
        } else if (Wv(lQ.a, 18).kb(c)) {
            if (!d.lc()) throw new _J(Rzb + c + Qzb + d + ').');
            k = d.lc().a;
            q = null;
            j = fmb(k, '[\\[\\]\\s,]+');
            for(h = 0, i = j.length; h < i; ++h){
                g = j[h];
                if (pmb(hmb(g)) == 0) continue;
                if (vQ((eM(), JL), c)) {
                    !q && (q = (f = Wv(Hkb(Gz), 11), new atb(f, Wv(exb(f, f.length), 11), 0)));
                    Wsb(q, (oM(), Wv(Gc((sM(), rM), g), 41)));
                } else if (vQ(aM, c)) {
                    !q && (q = (f = Wv(Hkb(Lz), 11), new atb(f, Wv(exb(f, f.length), 11), 0)));
                    Wsb(q, (DN(), Wv(Gc((HN(), GN), g), 150)));
                } else if (vQ(bM, c)) {
                    !q && (q = (f = Wv(Hkb(Mz), 11), new atb(f, Wv(exb(f, f.length), 11), 0)));
                    Wsb(q, (MN(), Wv(Gc((QN(), PN), g), 139)));
                } else if (vQ((Mjb(), jjb), c)) {
                    !q && (q = (f = Wv(Hkb(iF), 11), new atb(f, Wv(exb(f, f.length), 11), 0)));
                    Wsb(q, (zgb(), Wv(Gc((Dgb(), Cgb), g), 123)));
                }
            }
            o1 = Wv(Wv(lQ.b, 57).cb(c), 79);
            sJ(b, o1, q);
            return;
        } else if (Wv(qQ.a, 18).kb(c)) {
            if (!d.lc()) throw new _J("Invalid _other_ format for property '" + c + Qzb + d + ').');
            if (vQ((eM(), YL), c) || vQ(SL, c)) try {
                r = new FI;
                AI(r, d.lc().a);
                o1 = Wv(Wv(qQ.b, 57).cb(c), 79);
                sJ(b, o1, r);
                return;
            } catch (a) {
                a = OH(a);
                if (aw(a, 29)) throw new _J("Invalid KVector format for property '" + c + "' " + d + '.');
                else throw NH(a);
            }
            else if (vQ(oL, c) || vQ(CL, c)) try {
                t = new jJ;
                iJ(t, d.lc().a);
                o1 = Wv(Wv(qQ.b, 57).cb(c), 79);
                sJ(b, o1, t);
                return;
            } catch (a) {
                a = OH(a);
                if (aw(a, 29)) throw new _J("Invalid KVectorChain format for property '" + c + "' " + d + '.');
                else throw NH(a);
            }
            else if (vQ(GL, c) || vQ(jL, c)) try {
                n = new DP;
                tP(n, d.lc().a);
                o1 = Wv(Wv(qQ.b, 57).cb(c), 79);
                sJ(b, o1, n);
                return;
            } catch (a) {
                a = OH(a);
                if (aw(a, 29)) throw new _J("Invalid Margins format for property '" + c + "' " + d + '.');
                else throw NH(a);
            }
        } else if (Wv(pQ.a, 18).kb(c)) return;
        throw new _J("Unsupported layout option '" + c + Qzb + d + ').');
    }
    var Sxb = 'object', Txb = {
        3: 1,
        8: 1,
        5: 1,
        6: 1
    }, Uxb = {
        3: 1,
        46: 1
    }, Vxb = {
        3: 1,
        54: 1,
        46: 1
    }, Wxb = 'null', Xxb = 'anonymous', Yxb = 'Unknown', Zxb = 'function', $xb = 2147483647, _xb = {
        181: 1,
        3: 1,
        54: 1,
        46: 1
    }, ayb = 65536, byb = 65535, cyb = {
        3: 1,
        54: 1,
        29: 1,
        46: 1
    }, dyb = 'For input string: "', eyb = -2147483648, fyb = {
        56: 1
    }, gyb = {
        23: 1,
        145: 1,
        185: 1
    }, hyb = {
        3: 1,
        5: 1
    }, iyb = 'Invalid UTF8 sequence', jyb = 'fromIndex: ', kyb = 'java.lang', lyb = 'com.google.gwt.core.client', myb = 'com.google.gwt.core.client.impl', nyb = 'java.io', oyb = 'java.nio.charset', pyb = 'javaemul.internal', qyb = 'com.google.common.base', ryb = '%s (%s) must not be negative', syb = {
        3: 1,
        5: 1,
        6: 1
    }, tyb = 'negative size: ', uyb = {
        3: 1,
        8: 1,
        5: 1,
        11: 1,
        6: 1
    }, vyb = {
        68: 1,
        136: 1,
        3: 1,
        23: 1,
        17: 1
    }, wyb = {
        108: 1,
        35: 1
    }, xyb = 'com.google.common.collect', yyb = {
        108: 1,
        35: 1,
        96: 1
    }, zyb = {
        144: 1,
        3: 1
    }, Ayb = {
        35: 1
    }, Byb = {
        57: 1
    }, Cyb = 'java.util', Dyb = {
        22: 1,
        19: 1
    }, Eyb = {
        22: 1,
        19: 1,
        18: 1
    }, Fyb = {
        22: 1,
        19: 1,
        20: 1
    }, Gyb = {
        22: 1,
        19: 1,
        20: 1,
        63: 1
    }, Hyb = {
        35: 1,
        96: 1
    }, Iyb = {
        22: 1,
        19: 1,
        18: 1,
        137: 1
    }, Jyb = {
        21: 1
    }, Kyb = 'AbstractMapEntry', Lyb = {
        207: 1,
        22: 1,
        19: 1
    }, Myb = {
        159: 1,
        3: 1,
        23: 1,
        17: 1
    }, Nyb = 1073741824, Oyb = {
        22: 1
    }, Pyb = {
        3: 1,
        22: 1,
        19: 1
    }, Qyb = {
        87: 1,
        3: 1,
        22: 1,
        19: 1,
        20: 1,
        63: 1
    }, Ryb = {
        3: 1,
        57: 1
    }, Syb = {
        3: 1,
        22: 1,
        19: 1,
        18: 1
    }, Tyb = {
        64: 1
    }, Uyb = 'arraySize', Vyb = 'initialArraySize', Wyb = {
        64: 1,
        188: 1,
        3: 1,
        23: 1,
        17: 1
    }, Xyb = 'occurrences', Yyb = {
        52: 1,
        3: 1,
        5: 1
    }, Zyb = {
        205: 1,
        3: 1,
        23: 1,
        17: 1
    }, $yb = 1.0E-4, _yb = 'com.google.gwt.json.client', azb = 4194303, bzb = 1048575, czb = 4194304, dzb = 17592186044416, ezb = -17592186044416, fzb = '([{"\' \t\r\n', gzb = ')]}"\' \t\r\n', hzb = 'The given string contains parts that cannot be parsed as numbers.', izb = 'de.cau.cs.kieler.core.math', jzb = -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000, kzb = 'de.cau.cs.kieler.core.properties', lzb = {
        79: 1,
        23: 1
    }, mzb = 'de.cau.cs.kieler.core.util', nzb = 'de.cau.cs.kieler.kiml', ozb = 'LEFT', pzb = 'RIGHT', qzb = 'CENTER', rzb = 'de.cau.cs.kieler.kiml.options', szb = 'UNDEFINED', tzb = 'NONE', uzb = 'de.cau.cs.kieler.debugMode', vzb = 'de.cau.cs.kieler.randomSeed', wzb = 'de.cau.cs.kieler.kiml.util.nodespacing', xzb = 'de.cau.cs.kieler.kiml.util.labelspacing', yzb = 'portRatioOrPosition', zzb = 'NodeMarginCalculator', Azb = 'bottom', Bzb = {
        286: 1,
        121: 1,
        3: 1,
        5: 1
    }, Czb = 'undefined', Dzb = 'text', Ezb = 'stacktrace', Fzb = {
        34: 1,
        3: 1,
        8: 1,
        5: 1,
        6: 1
    }, Gzb = 'properties', Hzb = 'bendPoints', Izb = 'junctionPoints', Jzb = 'width', Kzb = 'height', Lzb = 'padding', Mzb = 'children', Nzb = {
        38: 1,
        39: 1,
        42: 1,
        51: 1,
        71: 1,
        3: 1,
        8: 1,
        5: 1,
        6: 1
    }, Ozb = 'de.cau.cs.kieler.klay.gwt.client.layout', Pzb = "Invalid boolean format for property '", Qzb = "' (", Rzb = "Invalid enum format for property '", Szb = 'de.cau.cs.kieler.klay.layered', Tzb = 'Layered layout', Uzb = Infinity, Vzb = -Infinity, Wzb = 'de.cau.cs.kieler.klay.layered.compaction.components', Xzb = 'de.cau.cs.kieler.klay.layered.compaction.oned', Yzb = ' instance has been finished already.', Zzb = 'de.cau.cs.kieler.klay.layered.compaction.oned.algs', $zb = 'de.cau.cs.kieler.klay.layered.compaction.recthull', _zb = {
        68: 1
    }, aAb = 'de.cau.cs.kieler.klay.layered.components', bAb = {
        3: 1,
        5: 1,
        22: 1,
        13: 1,
        19: 1,
        20: 1,
        63: 1
    }, cAb = 1.600000023841858, dAb = 0.001, eAb = {
        31: 1
    }, fAb = 'de.cau.cs.kieler.klay.layered.compound', gAb = {
        38: 1,
        39: 1,
        47: 1,
        42: 1,
        3: 1,
        8: 1,
        5: 1,
        6: 1
    }, hAb = 'de.cau.cs.kieler.klay.layered.graph', iAb = 'Port side is undefined', jAb = 'de.cau.cs.kieler.klay.layered.intermediate', kAb = 'Big nodes pre-processing', lAb = 3.4028234663852886E38, mAb = {
        38: 1,
        39: 1,
        42: 1,
        346: 1,
        71: 1,
        3: 1,
        8: 1,
        5: 1,
        6: 1
    }, nAb = "Node '", oAb = "' has its layer constraint set to FIRST or FIRST_SEPARATE, but has ", pAb = 'at least one incoming edge. Connections between nodes with these ', qAb = 'layer constraints are not supported.', rAb = 1.7976931348623157E308, sAb = 'Odd port side processing', tAb = {
        250: 1,
        3: 1,
        5: 1
    }, uAb = 1.0E-8, vAb = 'de.cau.cs.kieler.klay.layered.intermediate.compaction', wAb = 'de.cau.cs.kieler.klay.layered.intermediate.greedyswitch', xAb = {
        227: 1,
        3: 1,
        5: 1
    }, yAb = 'de.cau.cs.kieler.klay.layered.networksimplex', zAb = 'INTERACTIVE', AAb = 'de.cau.cs.kieler.klay.layered.p1cycles', BAb = {
        106: 1,
        31: 1
    }, CAb = 'de.cau.cs.kieler.klay.layered.p2layers', DAb = 'NETWORK_SIMPLEX', EAb = 'de.cau.cs.kieler.klay.layered.p3order', FAb = 5.9604644775390625E-8, GAb = 'Port type is undefined', HAb = 0.30000001192092896, IAb = 0.699999988079071, JAb = 0.8999999761581421, KAb = 'de.cau.cs.kieler.klay.layered.p3order.constraints', LAb = 'de.cau.cs.kieler.klay.layered.p3order.counting', MAb = 'de.cau.cs.kieler.klay.layered.p4nodes', NAb = {
        625: 1,
        3: 1,
        5: 1,
        6: 1
    }, OAb = 'de.cau.cs.kieler.klay.layered.p4nodes.bk', PAb = 'de.cau.cs.kieler.klay.layered.p5edges', QAb = 'de.cau.cs.kieler.klay.layered.p5edges.splines', RAb = 1.0E-6, SAb = -0.000001, TAb = 'The list of vectors may not be empty.', UAb = 0.09999999999999998, VAb = 'de.cau.cs.kieler.klay.layered.properties', WAb = '_gwt_modCount', XAb = {
        3: 1,
        22: 1,
        19: 1,
        20: 1,
        63: 1
    }, YAb = {
        3: 1,
        5: 1,
        57: 1
    }, ZAb = {
        3: 1,
        5: 1,
        22: 1,
        19: 1,
        50: 1,
        18: 1
    }, $Ab = 'delete', _Ab = 15525485, aBb = 16777216, bBb = 16777215, cBb = {
        3: 1,
        5: 1,
        22: 1,
        19: 1,
        20: 1,
        63: 1
    }, dBb = {
        3: 1,
        23: 1,
        17: 1,
        138: 1
    };
    var _, fI, aI, LH = -1;
    gI();
    hI(1, null, {}, pb);
    _.t = function qb(a) {
        return this === a;
    };
    _.u = function sb() {
        return this.$c;
    };
    _.v = function ub() {
        return txb(this);
    };
    _.w = function wb() {
        return ob(this);
    };
    _.toString = function() {
        return this.w();
    };
    hI(46, 1, Uxb);
    _.bc = function ct() {
        return this.f;
    };
    _.w = function dt() {
        var a, b;
        return a = Ikb(this.$c), b = this.bc(), b != null ? a + ': ' + b : a;
    };
    hI(54, 46, Vxb);
    hI(72, 54, Vxb, gt);
    hI(164, 72, {
        164: 1,
        3: 1,
        54: 1,
        46: 1
    }, kt);
    _.bc = function nt() {
        jt(this);
        return this.c;
    };
    _.cc = function ot() {
        return gw(this.b) === gw(ht) ? null : this.b;
    };
    var ht;
    var Mt;
    hI(642, 1, {});
    hI(356, 642, {}, Tt);
    _.dc = function Ut(a, b) {
        var c = {}, k;
        var d = [];
        a.__gwt$backingJsError = {
            'fnStack': d
        };
        var e = arguments.callee.caller;
        while(e){
            var f = (Nt(), e.name || (e.name = Rt(e.toString())));
            d.push(f);
            var g = ':' + f;
            var h = c[g];
            if (h) {
                var i, j;
                for(i = 0, j = h.length; i < j; i++){
                    if (h[i] === e) return;
                }
            }
            (h || (c[g] = [])).push(e);
            e = e.caller;
        }
    };
    _.ec = function Vt(a) {
        var b, c, d, e, f;
        d = (Nt(), f = a.__gwt$backingJsError, f && f.fnStack ? f.fnStack : []);
        c = d.length;
        e = xv(WF, Txb, 146, c, 0, 1);
        for(b = 0; b < c; b++)e[b] = new Zlb(d[b], null, -1);
        return e;
    };
    hI(643, 642, {});
    _.dc = function Yt(c, d) {
        function e(b) {
            if (!('stack' in b)) try {
                throw b;
            } catch (a) {}
            return b;
        }
        var f;
        typeof d == 'string' ? f = e(new Error(d.replace('\n', ' '))) : d && typeof d == Sxb && 'stack' in d ? f = d : f = e(new Error);
        c.__gwt$backingJsError = f;
    };
    _.fc = function Zt(a, b, c, d) {
        return new Zlb(b, a + '@' + d, c < 0 ? -1 : c);
    };
    _.ec = function $t(a) {
        var b, c, d, e, f, g, h;
        e = (Nt(), h = a.__gwt$backingJsError, h && h.stack ? h.stack.split('\n') : []);
        f = xv(WF, Txb, 146, 0, 0, 1);
        b = 0;
        d = e.length;
        if (d == 0) return f;
        g = Xt(this, e[0]);
        emb(g.d, Xxb) || (f[b++] = g);
        for(c = 1; c < d; c++)f[b++] = Xt(this, e[c]);
        return f;
    };
    hI(357, 643, {}, _t);
    _.fc = function au(a, b, c, d) {
        return new Zlb(b, a, -1);
    };
    var Sv, Tv, Uv;
    hI(181, 54, _xb);
    hI(351, 181, _xb, ikb);
    hI(288, 1, {}, Kkb);
    _.Oc = function Lkb(a) {
        var b;
        b = new Kkb;
        b.g = 4;
        a > 1 ? b.c = Skb(this, a - 1) : b.c = this;
        return b;
    };
    _.Pc = function Rkb() {
        Gkb(this);
        return this.b;
    };
    _.Qc = function Tkb() {
        return Ikb(this);
    };
    _.Rc = function Vkb() {
        return Jkb(this);
    };
    _.Sc = function Xkb() {
        return (this.g & 4) != 0;
    };
    _.Tc = function Ykb() {
        return (this.g & 1) != 0;
    };
    _.w = function _kb() {
        return ((this.g & 2) != 0 ? 'interface ' : (this.g & 1) != 0 ? '' : 'class ') + (Gkb(this), this.n);
    };
    _.g = 0;
    var Fkb = 1;
    hI(119, 72, {
        3: 1,
        119: 1,
        54: 1,
        46: 1
    }, alb);
    hI(29, 72, cyb, rlb, slb);
    hI(95, 72, Vxb, nkb, okb);
    hI(231, 1, {
        3: 1,
        231: 1
    });
    var blb;
    hI(24, 231, {
        3: 1,
        23: 1,
        24: 1,
        231: 1
    }, wlb);
    _.F = function ylb(a) {
        return vlb(this, Wv(a, 24));
    };
    _.t = function zlb(a) {
        return aw(a, 24) && Wv(a, 24).a == this.a;
    };
    _.v = function Alb() {
        return this.a;
    };
    _.w = function Clb() {
        return Dlb(this.a);
    };
    _.a = 0;
    Uv = {
        3: 1,
        345: 1,
        23: 1,
        2: 1
    };
    hI(350, 1, fyb, smb);
    _.$b = function tmb(a, b) {
        return rmb($v(a), $v(b));
    };
    hI(257, 95, Vxb, Cmb);
    hI(145, 1, {
        23: 1,
        145: 1
    });
    _.F = function Kmb(a) {
        return Jmb(this, Wv(a, 145));
    };
    _.t = function Lmb(a) {
        var b;
        if (a === this) return true;
        if (!aw(a, 145)) return false;
        b = Wv(a, 145);
        return emb(this.a, b.a);
    };
    _.v = function Mmb() {
        return Pxb(this.a);
    };
    _.w = function Nmb() {
        return this.a;
    };
    hI(358, 29, cyb, Omb);
    hI(256, 29, {
        3: 1,
        54: 1,
        29: 1,
        46: 1,
        256: 1
    }, Pmb);
    hI(185, 145, gyb);
    var jxb, kxb, lxb;
    hI(289, 185, gyb, oxb);
    _.Zc = function pxb(a, b, c) {
        var d, e;
        d = xv(jw, hyb, 26, c, 12, 1);
        for(e = 0; e < c; ++e)d[e] = a[b + e] & 255 & byb;
        return d;
    };
    hI(355, 185, gyb, qxb);
    _.Zc = function rxb(a, b, c) {
        var d, e, f, g, h, i, j, k;
        f = 0;
        for(j = 0; j < c;){
            ++f;
            e = a[b + j];
            if ((e & 192) == 128) throw new slb(iyb);
            else if ((e & 128) == 0) ++j;
            else if ((e & 224) == 192) j += 2;
            else if ((e & 240) == 224) j += 3;
            else if ((e & 248) == 240) j += 4;
            else throw new slb(iyb);
            if (j > c) throw new okb(iyb);
        }
        g = xv(jw, hyb, 26, f, 12, 1);
        k = 0;
        h = 0;
        for(i = 0; i < c;){
            e = a[b + i++];
            if ((e & 128) == 0) {
                h = 1;
                e &= 127;
            } else if ((e & 224) == 192) {
                h = 2;
                e &= 31;
            } else if ((e & 240) == 224) {
                h = 3;
                e &= 15;
            } else if ((e & 248) == 240) {
                h = 4;
                e &= 7;
            } else if ((e & 252) == 248) {
                h = 5;
                e &= 3;
            }
            while(--h > 0){
                d = a[b + i++];
                if ((d & 192) != 128) throw new slb('Invalid UTF8 sequence at ' + (b + i - 1) + ', byte=' + (d >>> 0).toString(16));
                e = e << 6 | d & 63;
            }
            k += Ekb(e, g, k);
        }
        return g;
    };
    var UF = Nkb(kyb, 'Object', 1);
    var _F = Nkb(kyb, 'Throwable', 46);
    var KF = Nkb(kyb, 'Exception', 54);
    var VF = Nkb(kyb, 'RuntimeException', 72);
    var Zy = Nkb(lyb, 'JavaScriptException', 164);
    var ez = Nkb(myb, 'StackTraceCreator/Collector', 642);
    var bz = Nkb(myb, 'StackTraceCreator/CollectorLegacy', 356);
    var dz = Nkb(myb, 'StackTraceCreator/CollectorModern', 643);
    var cz = Nkb(myb, 'StackTraceCreator/CollectorModernNoSourceMap', 357);
    var wF = Nkb(nyb, 'IOException', 181);
    var zF = Nkb(nyb, 'UnsupportedEncodingException', 351);
    var GF = Nkb(kyb, 'Class', 288);
    var FF = Nkb(kyb, 'ClassCastException', 119);
    var MF = Nkb(kyb, 'IllegalArgumentException', 29);
    var OF = Nkb(kyb, 'IndexOutOfBoundsException', 95);
    var TF = Nkb(kyb, 'Number', 231);
    var PF = Nkb(kyb, 'Integer', 24);
    var $F = Nkb(kyb, 'String', 2);
    var XF = Nkb(kyb, 'String/1', 350);
    var ZF = Nkb(kyb, 'StringIndexOutOfBoundsException', 257);
    var bG = Nkb(oyb, 'Charset', 145);
    var cG = Nkb(oyb, 'IllegalCharsetNameException', 358);
    var dG = Nkb(oyb, 'UnsupportedCharsetException', 256);
    var JH = Nkb(pyb, 'EmulatedCharset', 185);
    var HH = Nkb(pyb, 'EmulatedCharset/LatinCharset', 289);
    var IH = Nkb(pyb, 'EmulatedCharset/UtfCharset', 355);
    hI(669, 1, {
        3: 1
    });
    var sw = Nkb(qyb, 'Optional', 669);
    hI(601, 669, {
        3: 1
    }, Ab);
    _.t = function Bb(a) {
        return a === this;
    };
    _.v = function Cb() {
        return 2040732332;
    };
    _.w = function Db() {
        return 'Optional.absent()';
    };
    _.A = function Eb(a) {
        _b(a);
        return zb(), yb;
    };
    var yb;
    var nw = Nkb(qyb, 'Absent', 601);
    var ow = Pkb(qyb, 'Function');
    hI(208, 1, {}, Kb);
    _.C = function Lb(a) {
        return Ib(a);
    };
    var rw = Nkb(qyb, 'Joiner', 208);
    hI(363, 208, {}, Nb);
    _.C = function Ob(a) {
        return Mb(this, a);
    };
    var pw = Nkb(qyb, 'Joiner/1', 363);
    hI(362, 1, {}, Rb);
    var qw = Nkb(qyb, 'Joiner/MapJoiner', 362);
    var tw = Pkb(qyb, 'Predicate');
    var gc;
    hI(244, 1, {
        68: 1,
        244: 1,
        3: 1
    }, ic);
    _.D = function jc(a) {
        var b;
        for(b = 0; b < this.a.a.length; b++){
            if (!Wv(mpb(this.a, b), 68).D(a)) return false;
        }
        return true;
    };
    _.t = function kc(a) {
        var b;
        if (aw(a, 244)) {
            b = Wv(a, 244);
            return cn(this.a, b.a);
        }
        return false;
    };
    _.v = function lc() {
        return Bpb(this.a) + 306654252;
    };
    _.w = function mc() {
        return 'Predicates.and(' + Hb((hc(), gc), new wnb(this.a)) + ')';
    };
    var uw = Nkb(qyb, 'Predicates/AndPredicate', 244);
    hI(246, 1, {
        68: 1,
        246: 1,
        3: 1
    }, nc);
    _.D = function oc(b) {
        try {
            return this.a.kb(b);
        } catch (a) {
            a = OH(a);
            if (aw(a, 76)) return false;
            else if (aw(a, 119)) return false;
            else throw NH(a);
        }
    };
    _.t = function pc(a) {
        var b;
        if (aw(a, 246)) {
            b = Wv(a, 246);
            return this.a.t(b.a);
        }
        return false;
    };
    _.v = function qc() {
        return this.a.v();
    };
    _.w = function rc() {
        return 'Predicates.in(' + this.a + ')';
    };
    var vw = Nkb(qyb, 'Predicates/InPredicate', 246);
    hI(245, 1, {
        68: 1,
        245: 1,
        3: 1
    }, sc);
    _.D = function tc(a) {
        return rb(this.a, a);
    };
    _.t = function uc(a) {
        var b;
        if (aw(a, 245)) {
            b = Wv(a, 245);
            return rb(this.a, b.a);
        }
        return false;
    };
    _.v = function vc() {
        return vb(this.a);
    };
    _.w = function wc() {
        return 'Predicates.equalTo(' + this.a + ')';
    };
    var ww = Nkb(qyb, 'Predicates/IsEqualToPredicate', 245);
    hI(17, 1, {
        3: 1,
        23: 1,
        17: 1
    });
    _.F = function Bc(a) {
        return xc(this, Wv(a, 17));
    };
    _.t = function Dc(a) {
        return this === a;
    };
    _.v = function Ec() {
        return txb(this);
    };
    _.w = function Fc() {
        return zc(this);
    };
    _.e = 0;
    var IF = Nkb(kyb, 'Enum', 17);
    hI(136, 17, vyb);
    var Hc, Ic, Jc, Kc;
    var Bw = Okb(qyb, 'Predicates/ObjectPredicate', 136, IF, Nc);
    hI(591, 136, vyb, Oc);
    _.D = function Pc(a) {
        return true;
    };
    _.w = function Qc() {
        return 'Predicates.alwaysTrue()';
    };
    var xw = Okb(qyb, 'Predicates/ObjectPredicate/1', 591, Bw, null);
    hI(592, 136, vyb, Rc);
    _.D = function Sc(a) {
        return false;
    };
    _.w = function Tc() {
        return 'Predicates.alwaysFalse()';
    };
    var yw = Okb(qyb, 'Predicates/ObjectPredicate/2', 592, Bw, null);
    hI(593, 136, vyb, Uc);
    _.D = function Vc(a) {
        return a == null;
    };
    _.w = function Wc() {
        return 'Predicates.isNull()';
    };
    var zw = Okb(qyb, 'Predicates/ObjectPredicate/3', 593, Bw, null);
    hI(594, 136, vyb, Xc);
    _.D = function Yc(a) {
        return a != null;
    };
    _.w = function Zc() {
        return 'Predicates.notNull()';
    };
    var Aw = Okb(qyb, 'Predicates/ObjectPredicate/4', 594, Bw, null);
    hI(177, 669, {
        177: 1,
        3: 1
    }, $c);
    _.t = function _c(a) {
        var b;
        if (aw(a, 177)) {
            b = Wv(a, 177);
            return rb(this.a, b.a);
        }
        return false;
    };
    _.v = function ad() {
        return 1502476572 + vb(this.a);
    };
    _.w = function bd() {
        return 'Optional.of(' + this.a + ')';
    };
    _.A = function cd(a) {
        return new $c(ac(a.B(this.a), 'the Function passed to Optional.transform() must not return null.'));
    };
    var Cw = Nkb(qyb, 'Present', 177);
    hI(108, 1, wyb);
    _.I = function ed() {
        dd();
    };
    var Xy = Nkb(xyb, 'UnmodifiableIterator', 108);
    hI(651, 108, yyb);
    _.J = function fd(a) {
        throw new Hmb;
    };
    _.O = function gd(a) {
        throw new Hmb;
    };
    var Yy = Nkb(xyb, 'UnmodifiableListIterator', 651);
    hI(378, 651, yyb);
    _.G = function hd() {
        return this.b < this.c;
    };
    _.K = function jd() {
        return this.b > 0;
    };
    _.H = function kd() {
        if (this.b >= this.c) throw new nvb;
        return Lk(this, this.b++);
    };
    _.L = function ld() {
        return this.b;
    };
    _.M = function md() {
        if (this.b <= 0) throw new nvb;
        return Lk(this, --this.b);
    };
    _.N = function nd() {
        return this.b - 1;
    };
    _.b = 0;
    _.c = 0;
    var Dw = Nkb(xyb, 'AbstractIndexedListIterator', 378);
    hI(428, 108, wyb);
    _.G = function rd() {
        return od(this);
    };
    _.H = function sd() {
        return pd(this);
    };
    _.d = 1;
    var Ew = Nkb(xyb, 'AbstractIterator', 428);
    hI(653, 1, {
        144: 1
    });
    _.P = function vd() {
        var a;
        return a = this.f, !a ? this.f = this.S() : a;
    };
    _.T = function wd() {
        return new Bf(this.P());
    };
    _.t = function xd(a) {
        return Mp(this, a);
    };
    _.v = function yd() {
        return this.P().v();
    };
    _.V = function zd() {
        return this.Y() == 0;
    };
    _.W = function Ad() {
        return ud(this);
    };
    _.w = function Bd() {
        return this.P().w();
    };
    var Xw = Nkb(xyb, 'AbstractMultimap', 653);
    hI(294, 653, zyb);
    _.Q = function Nd() {
        Cd(this);
    };
    _.R = function Od(a) {
        return Qmb(this.b, a);
    };
    _.S = function Pd() {
        return new Ie(this, this.b);
    };
    _.T = function Qd() {
        return new If(this, this.b);
    };
    _.$ = function Rd() {
        return Id(this.Z());
    };
    _.U = function Sd(a) {
        return Dd(this, a);
    };
    _.X = function Td(a) {
        return Gd(this, a);
    };
    _.Y = function Ud() {
        return this.c;
    };
    _.c = 0;
    var Uw = Nkb(xyb, 'AbstractMapBasedMultimap', 294);
    hI(600, 294, zyb);
    _.Z = function Xd() {
        return new HU(this.a);
    };
    _.$ = function Yd() {
        return Gi(), Gi(), Fi;
    };
    _.U = function $d(a) {
        return Wv(Dd(this, a), 20);
    };
    _.X = function _d(a) {
        return Wv(Gd(this, a), 20);
    };
    _.P = function Wd() {
        var a;
        return a = this.f, !a ? this.f = new Ie(this, this.b) : a;
    };
    _.t = function Zd(a) {
        return Mp(this, a);
    };
    var Fw = Nkb(xyb, 'AbstractListMultimap', 600);
    hI(388, 1, Ayb);
    _.G = function ae() {
        return this.b.b || this.d.G();
    };
    _.H = function be() {
        var a;
        if (!this.d.G()) {
            a = pnb(this.b);
            a.yb();
            this.a = Wv(a.zb(), 19);
            this.d = this.a.mb();
        }
        return this.d.H();
    };
    _.I = function ce() {
        this.d.I();
        this.a.V() && qnb(this.b);
        --this.c.c;
    };
    var Kw = Nkb(xyb, 'AbstractMapBasedMultimap/Itr', 388);
    hI(389, 388, Ayb, de);
    var Gw = Nkb(xyb, 'AbstractMapBasedMultimap/1', 389);
    hI(638, 1, Byb);
    _.Q = function ke() {
        this.bb().Q();
    };
    _._ = function le(a) {
        return ee(this, a);
    };
    _.R = function me(a) {
        return !!ge(this, a, false);
    };
    _.ab = function ne(a) {
        var b, c, d;
        for(c = this.bb().mb(); c.G();){
            b = Wv(c.H(), 21);
            d = b.zb();
            if (gw(a) === gw(d) || a != null && rb(a, d)) return true;
        }
        return false;
    };
    _.t = function oe(a) {
        return fe(this, a);
    };
    _.cb = function pe(a) {
        return re(ge(this, a, false));
    };
    _.v = function se() {
        return Apb(this.bb());
    };
    _.V = function te() {
        return this.Y() == 0;
    };
    _.W = function ue() {
        return new Snb(this);
    };
    _.db = function ve(a, b) {
        throw new Imb('Put not supported on this map');
    };
    _.eb = function we(a) {
        return re(ge(this, a, true));
    };
    _.Y = function xe() {
        return this.bb().Y();
    };
    _.w = function ye() {
        return ie(this);
    };
    _.fb = function ze() {
        return new aob(this);
    };
    var tG = Nkb(Cyb, 'AbstractMap', 638);
    hI(654, 638, Byb);
    _.bb = function Ce() {
        return Ae(this);
    };
    _.W = function De() {
        var a;
        a = this.d;
        return !a ? this.d = new Bf(this) : a;
    };
    _.fb = function Ee() {
        return Be(this);
    };
    var ny = Nkb(xyb, 'Maps/ViewCachingAbstractMap', 654);
    hI(262, 654, Byb, Ie);
    _.cb = function Ne(a) {
        return Fe(this, a);
    };
    _.eb = function Qe(a) {
        return Ge(this, a);
    };
    _.Q = function Je() {
        this.a == this.b.b ? Cd(this.b) : Ml(new xf(this));
    };
    _.R = function Ke(a) {
        return qp(this.a, a);
    };
    _.hb = function Le() {
        return new sf(this);
    };
    _.gb = function() {
        return this.hb();
    };
    _.t = function Me(a) {
        return this === a || fe(this.a, a);
    };
    _.v = function Oe() {
        return Apb(new inb(this.a));
    };
    _.W = function Pe() {
        return ud(this.b);
    };
    _.Y = function Re() {
        return Zmb(this.a);
    };
    _.w = function Se() {
        return ie(this.a);
    };
    var Jw = Nkb(xyb, 'AbstractMapBasedMultimap/AsMap', 262);
    hI(640, 1, Dyb);
    _.ib = function $e(a) {
        return Te();
    };
    _.jb = function _e(a) {
        return Ue(this, a);
    };
    _.Q = function af() {
        We(this);
    };
    _.kb = function bf(a) {
        return Ve(this, a, false);
    };
    _.lb = function cf(a) {
        return Xe(this, a);
    };
    _.V = function df() {
        return this.Y() == 0;
    };
    _.nb = function ef(a) {
        return Ve(this, a, true);
    };
    _.ob = function ff() {
        return this.pb(xv(UF, syb, 1, this.Y(), 4, 1));
    };
    _.pb = function gf(a) {
        return Ye(this, a);
    };
    _.w = function hf() {
        return Ze(this);
    };
    var eG = Nkb(Cyb, 'AbstractCollection', 640);
    hI(641, 640, Eyb);
    _.t = function kf(a) {
        return jf(this, a);
    };
    _.v = function lf() {
        return Apb(this);
    };
    var zG = Nkb(Cyb, 'AbstractSet', 641);
    hI(649, 641, Eyb);
    var Jy = Nkb(xyb, 'Sets/ImprovedAbstractSet', 649);
    hI(655, 649, Eyb);
    _.Q = function nf() {
        this.qb().Q();
    };
    _.kb = function of(a) {
        return mf(this, a);
    };
    _.V = function pf() {
        return this.qb().V();
    };
    _.nb = function qf(a) {
        var b;
        if (this.kb(a)) {
            b = Wv(a, 21);
            return this.qb().W().nb(b.yb());
        }
        return false;
    };
    _.Y = function rf() {
        return this.qb().Y();
    };
    var ky = Nkb(xyb, 'Maps/EntrySet', 655);
    hI(387, 655, Eyb, sf);
    _.kb = function tf(a) {
        return Qh(new inb(this.a.a), a);
    };
    _.mb = function uf() {
        return new xf(this.a);
    };
    _.qb = function vf() {
        return this.a;
    };
    _.nb = function wf(a) {
        var b;
        if (!Qh(new inb(this.a.a), a)) return false;
        b = Wv(a, 21);
        Hd(this.a.b, b.yb());
        return true;
    };
    var Hw = Nkb(xyb, 'AbstractMapBasedMultimap/AsMap/AsMapEntries', 387);
    hI(299, 1, Ayb, xf);
    _.H = function zf() {
        var a;
        return a = pnb(this.b), this.a = Wv(a.zb(), 19), He(this.c, a);
    };
    _.G = function yf() {
        return this.b.b;
    };
    _.I = function Af() {
        qnb(this.b);
        this.c.b.c -= this.a.Y();
        this.a.Q();
    };
    var Iw = Nkb(xyb, 'AbstractMapBasedMultimap/AsMap/AsMapIterator', 299);
    hI(260, 649, Eyb, Bf);
    _.Q = function Cf() {
        this.b.Q();
    };
    _.kb = function Df(a) {
        return this.b.R(a);
    };
    _.V = function Ef() {
        return this.b.V();
    };
    _.mb = function Ff() {
        return mp(), Wl(this.b.bb().mb(), (xp(), vp));
    };
    _.nb = function Gf(a) {
        if (this.b.R(a)) {
            this.b.eb(a);
            return true;
        }
        return false;
    };
    _.Y = function Hf() {
        return this.b.Y();
    };
    var ly = Nkb(xyb, 'Maps/KeySet', 260);
    hI(386, 260, Eyb, If);
    _.Q = function Jf() {
        var a;
        Ml((a = this.b.bb().mb(), new Pf(this, a)));
    };
    _.lb = function Kf(a) {
        return this.b.W().lb(a);
    };
    _.t = function Lf(a) {
        return this === a || this.b.W().t(a);
    };
    _.v = function Mf() {
        return this.b.W().v();
    };
    _.mb = function Nf() {
        var a;
        return a = this.b.bb().mb(), new Pf(this, a);
    };
    _.nb = function Of(a) {
        var b, c;
        c = 0;
        b = Wv(this.b.eb(a), 19);
        if (b) {
            c = b.Y();
            b.Q();
            this.a.c -= c;
        }
        return c > 0;
    };
    var Mw = Nkb(xyb, 'AbstractMapBasedMultimap/KeySet', 386);
    hI(300, 1, Ayb, Pf);
    _.G = function Qf() {
        return this.c.G();
    };
    _.H = function Rf() {
        this.a = Wv(this.c.H(), 21);
        return this.a.yb();
    };
    _.I = function Sf() {
        var a;
        ec(!!this.a);
        a = Wv(this.a.zb(), 19);
        this.c.I();
        this.b.a.c -= a.Y();
        a.Q();
    };
    var Lw = Nkb(xyb, 'AbstractMapBasedMultimap/KeySet/1', 300);
    hI(216, 640, Dyb, _f);
    _.ib = function ag(a) {
        return Tf(this, a);
    };
    _.jb = function bg(a) {
        return Uf(this, a);
    };
    _.Q = function cg() {
        Wf(this);
    };
    _.kb = function dg(a) {
        return Yf(this), this.d.kb(a);
    };
    _.lb = function eg(a) {
        return Yf(this), this.d.lb(a);
    };
    _.t = function fg(a) {
        return Xf(this, a);
    };
    _.v = function gg() {
        return Yf(this), this.d.v();
    };
    _.mb = function hg() {
        return Yf(this), new xg(this);
    };
    _.nb = function ig(a) {
        return Zf(this, a);
    };
    _.Y = function jg() {
        return Yf(this), this.d.Y();
    };
    _.w = function kg() {
        Yf(this);
        return xb(this.d);
    };
    var Pw = Nkb(xyb, 'AbstractMapBasedMultimap/WrappedCollection', 216);
    var sH = Pkb(Cyb, 'List');
    hI(297, 216, Fyb, mg);
    _.rb = function ng(a, b) {
        var c;
        Yf(this);
        c = this.d.V();
        Wv(this.d, 20).rb(a, b);
        ++this.a.c;
        c && Vf(this);
    };
    _.sb = function og(a) {
        Yf(this);
        return Wv(this.d, 20).sb(a);
    };
    _.tb = function pg() {
        Yf(this);
        return new Cg(this);
    };
    _.ub = function qg(a) {
        Yf(this);
        return new Dg(this, a);
    };
    _.vb = function rg(a) {
        var b;
        Yf(this);
        b = Wv(this.d, 20).vb(a);
        --this.a.c;
        $f(this);
        return b;
    };
    _.wb = function sg(a, b) {
        Yf(this);
        return Wv(this.d, 20).wb(a, b);
    };
    _.xb = function tg(a, b) {
        Yf(this);
        return Ld(this.a, this.e, Wv(this.d, 20).xb(a, b), !this.b ? this : this.b);
    };
    var Rw = Nkb(xyb, 'AbstractMapBasedMultimap/WrappedList', 297);
    hI(385, 297, Gyb, ug);
    var Nw = Nkb(xyb, 'AbstractMapBasedMultimap/RandomAccessWrappedList', 385);
    hI(189, 1, Ayb, xg);
    _.G = function zg() {
        return wg(this), this.b.G();
    };
    _.H = function Ag() {
        return wg(this), this.b.H();
    };
    _.I = function Bg() {
        this.b.I();
        --this.d.f.c;
        $f(this.d);
    };
    var Ow = Nkb(xyb, 'AbstractMapBasedMultimap/WrappedCollection/WrappedIterator', 189);
    hI(298, 189, Hyb, Cg, Dg);
    _.J = function Eg(a) {
        var b;
        b = lg(this.a) == 0;
        (wg(this), Wv(this.b, 96)).J(a);
        ++this.a.a.c;
        b && Vf(this.a);
    };
    _.K = function Fg() {
        return (wg(this), Wv(this.b, 96)).K();
    };
    _.L = function Gg() {
        return (wg(this), Wv(this.b, 96)).L();
    };
    _.M = function Hg() {
        return (wg(this), Wv(this.b, 96)).M();
    };
    _.N = function Ig() {
        return (wg(this), Wv(this.b, 96)).N();
    };
    _.O = function Jg(a) {
        (wg(this), Wv(this.b, 96)).O(a);
    };
    var Qw = Nkb(xyb, 'AbstractMapBasedMultimap/WrappedList/WrappedListIterator', 298);
    hI(295, 216, Eyb, Kg);
    var Sw = Nkb(xyb, 'AbstractMapBasedMultimap/WrappedSet', 295);
    hI(296, 216, Iyb, Lg);
    var Tw = Nkb(xyb, 'AbstractMapBasedMultimap/WrappedSortedSet', 296);
    hI(668, 1, Jyb);
    _.t = function Mg(a) {
        var b;
        if (aw(a, 21)) {
            b = Wv(a, 21);
            return Tb(this.yb(), b.yb()) && Tb(this.zb(), b.zb());
        }
        return false;
    };
    _.v = function Ng() {
        var a, b;
        a = this.yb();
        b = this.zb();
        return (a == null ? 0 : vb(a)) ^ (b == null ? 0 : vb(b));
    };
    _.Ab = function Og(a) {
        throw new Hmb;
    };
    _.w = function Pg() {
        return this.yb() + '=' + this.zb();
    };
    var Vw = Nkb(xyb, Kyb, 668);
    hI(390, 640, Dyb, Qg);
    _.Q = function Rg() {
        Cd(this.a);
    };
    _.kb = function Sg(a) {
        return td(this.a, a);
    };
    _.mb = function Tg() {
        return new de(this.a);
    };
    _.Y = function Ug() {
        return this.a.c;
    };
    var Ww = Nkb(xyb, 'AbstractMultimap/Values', 390);
    hI(656, 640, Lyb);
    _.ib = function Wg(a) {
        return this.Bb(a, 1), true;
    };
    _.Bb = function Xg(a, b) {
        throw new Hmb;
    };
    _.jb = function Yg(a) {
        return Eq(this, a);
    };
    _.Q = function Zg() {
        Ml(this.Eb());
    };
    _.kb = function $g(a) {
        return this.Cb(a) > 0;
    };
    _.Cb = function _g(a) {
        var b, c;
        for(c = Vg(this).mb(); c.G();){
            b = Wv(c.H(), 83);
            if (Tb(b.Zb(), a)) return b.Yb();
        }
        return 0;
    };
    _.gb = function ah() {
        return new qh(this);
    };
    _.bb = function bh() {
        return Vg(this);
    };
    _.t = function dh(a) {
        return Fq(this, a);
    };
    _.v = function eh() {
        return Vg(this).v();
    };
    _.V = function fh() {
        return Vg(this).V();
    };
    _.mb = function gh() {
        return Dq(), new Oq(this, Vg(this).mb());
    };
    _.nb = function hh(a) {
        return this.Fb(a, 1) > 0;
    };
    _.Fb = function ih(a, b) {
        throw new Hmb;
    };
    _.Gb = function jh(a, b) {
        var c, d;
        return Dq(), Mh(b, 'count'), c = this.Cb(a), d = b - c, d > 0 ? this.Bb(a, d) : d < 0 && this.Fb(a, -d), c;
    };
    _.Hb = function kh(a, b, c) {
        return Gq(this, a, b, c);
    };
    _.Y = function lh() {
        return Hq(this);
    };
    _.w = function mh() {
        return xb(Vg(this));
    };
    var Zw = Nkb(xyb, 'AbstractMultiset', 656);
    hI(657, 649, Eyb);
    _.Q = function nh() {
        this.Ib().Q();
    };
    _.kb = function oh(a) {
        var b, c;
        if (aw(a, 83)) {
            c = Wv(a, 83);
            if (c.Yb() <= 0) return false;
            b = this.Ib().Cb(c.Zb());
            return b == c.Yb();
        }
        return false;
    };
    _.nb = function ph(a) {
        var b, c, d, e;
        if (aw(a, 83)) {
            c = Wv(a, 83);
            b = c.Zb();
            d = c.Yb();
            if (d != 0) {
                e = this.Ib();
                return e.Hb(b, d, 0);
            }
        }
        return false;
    };
    var xy = Nkb(xyb, 'Multisets/EntrySet', 657);
    hI(396, 657, Eyb, qh);
    _.mb = function rh() {
        return this.a.Eb();
    };
    _.Ib = function sh() {
        return this.a;
    };
    _.Y = function th() {
        return this.a.Db();
    };
    var Yw = Nkb(xyb, 'AbstractMultiset/EntrySet', 396);
    hI(384, 294, zyb);
    _.Z = function wh() {
        return new wtb(op(this.a));
    };
    _.$ = function xh() {
        return hi(), kr(), jr;
    };
    _.U = function zh(a) {
        return Wv(Dd(this, a), 18);
    };
    _.X = function Ah(a) {
        return Wv(Gd(this, a), 18);
    };
    _.P = function vh() {
        var a;
        return a = this.f, !a ? this.f = new Ie(this, this.b) : a;
    };
    _.t = function yh(a) {
        return Mp(this, a);
    };
    var $w = Nkb(xyb, 'AbstractSetMultimap', 384);
    hI(342, 656, Lyb);
    var _w = Nkb(xyb, 'AbstractSortedMultiset', 342);
    hI(280, 600, zyb, Dh);
    _.a = 0;
    var ax = Nkb(xyb, 'ArrayListMultimap', 280);
    hI(159, 17, Myb);
    var Eh, Fh;
    var dx = Okb(xyb, 'BoundType', 159, IF, Ih);
    hI(623, 159, Myb, Jh);
    var bx = Okb(xyb, 'BoundType/1', 623, dx, null);
    hI(624, 159, Myb, Kh);
    var cx = Okb(xyb, 'BoundType/2', 624, dx, null);
    var Nh;
    hI(234, 1, Oyb);
    _.w = function Th() {
        return Vl(this.c.mb());
    };
    var fx = Nkb(xyb, 'FluentIterable', 234);
    hI(170, 234, Oyb, Vh);
    _.mb = function Wh() {
        return Uh(this);
    };
    var ex = Nkb(xyb, 'FluentIterable/2', 170);
    hI(664, 1, {});
    _.w = function Xh() {
        return xb(irb(this.a.d).b);
    };
    var mx = Nkb(xyb, 'ForwardingObject', 664);
    hI(665, 664, Dyb);
    _.ib = function Yh(a) {
        return irb(this.a.d), vqb();
    };
    _.jb = function Zh(a) {
        return irb(this.a.d), wqb();
    };
    _.Q = function $h() {
        irb(this.a.d);
        xqb();
    };
    _.kb = function _h(a) {
        return Irb(irb(this.a.d), a);
    };
    _.lb = function ai(a) {
        return Jrb(irb(this.a.d), a);
    };
    _.V = function bi() {
        return irb(this.a.d).b.V();
    };
    _.mb = function ci() {
        var a;
        return a = irb(this.a.d).b.mb(), new Trb(a);
    };
    _.nb = function di(a) {
        return irb(this.a.d), yqb();
    };
    _.Y = function ei() {
        return irb(this.a.d).b.Y();
    };
    _.ob = function fi() {
        return Krb(irb(this.a.d));
    };
    _.pb = function gi(a) {
        return Lrb(irb(this.a.d), a);
    };
    var gx = Nkb(xyb, 'ForwardingCollection', 665);
    hI(660, 640, Pyb);
    _.mb = function ti() {
        return this.Kb();
    };
    _.ib = function oi(a) {
        return ii();
    };
    _.jb = function pi(a) {
        return ji();
    };
    _.Q = function qi() {
        li();
    };
    _.kb = function ri(a) {
        return a != null && Ve(this, a, false);
    };
    _.Jb = function si() {
        switch(this.Y()){
            case 0:
                return Gi(), Gi(), Fi;
            case 1:
                return Gi(), new Er(this.Kb().H());
            default:
                return new Zq(this, this.ob());
        }
    };
    _.nb = function ui(a) {
        return mi();
    };
    var sx = Nkb(xyb, 'ImmutableCollection', 660);
    hI(316, 660, Pyb, vi);
    _.mb = function Ai() {
        return Xl(this.a.mb());
    };
    _.kb = function wi(a) {
        return a != null && this.a.kb(a);
    };
    _.lb = function xi(a) {
        return this.a.lb(a);
    };
    _.V = function yi() {
        return this.a.V();
    };
    _.Kb = function zi() {
        return Xl(this.a.mb());
    };
    _.Y = function Bi() {
        return this.a.Y();
    };
    _.ob = function Ci() {
        return this.a.ob();
    };
    _.pb = function Di(a) {
        return this.a.pb(a);
    };
    _.w = function Ei() {
        return xb(this.a);
    };
    var hx = Nkb(xyb, 'ForwardingImmutableCollection', 316);
    hI(87, 660, Qyb);
    _.mb = function Pi() {
        return this.Kb();
    };
    _.tb = function Qi() {
        return this.Lb(0);
    };
    _.ub = function Si(a) {
        return this.Lb(a);
    };
    _.xb = function Xi(a, b) {
        return this.Mb(a, b);
    };
    _.rb = function Ji(a, b) {
        throw new Hmb;
    };
    _.t = function Mi(a) {
        return yo(this, a);
    };
    _.v = function Ni() {
        return zo(this);
    };
    _.Kb = function Oi() {
        return this.Lb(0);
    };
    _.Lb = function Ri(a) {
        return Hi(this, a);
    };
    _.vb = function Ui(a) {
        throw new Hmb;
    };
    _.wb = function Vi(a, b) {
        throw new Hmb;
    };
    _.Mb = function Wi(a, b) {
        var c;
        return Yi((c = new Mo(this), new Mnb(c, a, b)));
    };
    var Fi;
    var wx = Nkb(xyb, 'ImmutableList', 87);
    hI(667, 87, Qyb);
    _.mb = function gj() {
        return Xl(this.Nb().mb());
    };
    _.xb = function jj(a, b) {
        return Yi(this.Nb().xb(a, b));
    };
    _.kb = function _i(a) {
        return Zi(this, a);
    };
    _.lb = function aj(a) {
        return this.Nb().lb(a);
    };
    _.t = function bj(a) {
        return this.Nb().t(a);
    };
    _.sb = function cj(a) {
        return $i(this, a);
    };
    _.v = function dj() {
        return this.Nb().v();
    };
    _.V = function ej() {
        return this.Nb().V();
    };
    _.Kb = function fj() {
        return Xl(this.Nb().mb());
    };
    _.Y = function hj() {
        return this.Nb().Y();
    };
    _.Mb = function ij(a, b) {
        return Yi(this.Nb().xb(a, b));
    };
    _.ob = function kj() {
        return this.Nb().pb(xv(UF, syb, 1, this.Nb().Y(), 4, 1));
    };
    _.pb = function lj(a) {
        return this.Nb().pb(a);
    };
    _.w = function mj() {
        return xb(this.Nb());
    };
    var ix = Nkb(xyb, 'ForwardingImmutableList', 667);
    hI(524, 1, Ryb);
    _.bb = function wj() {
        return nj(this);
    };
    _.W = function Aj() {
        return oj(this);
    };
    _.fb = function Gj() {
        return this.Rb();
    };
    _.Q = function qj() {
        throw new Hmb;
    };
    _.R = function rj(a) {
        return this.cb(a) != null;
    };
    _.ab = function sj(a) {
        return this.Rb().kb(a);
    };
    _.Pb = function uj() {
        return new Uk(this);
    };
    _.Qb = function vj() {
        return new Zk(this);
    };
    _.t = function xj(a) {
        return pp(this, a);
    };
    _.v = function yj() {
        return nj(this).v();
    };
    _.V = function zj() {
        return this.Y() == 0;
    };
    _.db = function Cj(a, b) {
        return pj();
    };
    _.eb = function Dj(a) {
        throw new Hmb;
    };
    _.w = function Ej() {
        var a;
        return mp(), a = umb(Ph(this.Y()), 123), Qb(lp, a, nj(this).mb()), a.a += '}', a.a;
    };
    _.Rb = function Fj() {
        if (this.g) return this.g;
        return this.g = this.Qb();
    };
    _.e = null;
    _.f = null;
    _.g = null;
    var Cx = Nkb(xyb, 'ImmutableMap', 524);
    hI(320, 524, Ryb);
    _.R = function Ij(a) {
        return qp(this.d, a);
    };
    _.ab = function Jj(a) {
        return hrb(this.d, a);
    };
    _.Ob = function Kj() {
        return ck(new Vj(this));
    };
    _.Pb = function Lj() {
        return ck(krb(this.d));
    };
    _.Qb = function Mj() {
        return hi(), new vi(lrb(this.d));
    };
    _.t = function Nj(a) {
        return jrb(this.d, a);
    };
    _.cb = function Oj(a) {
        return a == null ? null : rp(this.d, a);
    };
    _.v = function Pj() {
        return this.d.c.v();
    };
    _.V = function Qj() {
        return this.d.c.V();
    };
    _.Y = function Rj() {
        return this.d.c.Y();
    };
    _.w = function Sj() {
        return xb(this.d.c);
    };
    var kx = Nkb(xyb, 'ForwardingImmutableMap', 320);
    hI(666, 665, Eyb);
    _.t = function Tj(a) {
        return a === this || Drb(irb(this.a.d), a);
    };
    _.v = function Uj() {
        return irb(this.a.d).b.v();
    };
    var nx = Nkb(xyb, 'ForwardingSet', 666);
    hI(523, 666, Eyb, Vj);
    _.kb = function Wj(b) {
        if (aw(b, 21) && Wv(b, 21).yb() == null) return false;
        try {
            return Irb(irb(this.a.d), b);
        } catch (a) {
            a = OH(a);
            if (aw(a, 119)) return false;
            else throw NH(a);
        }
    };
    _.pb = function Xj(a) {
        var b;
        b = Lrb(irb(this.a.d), a);
        irb(this.a.d).b.Y() < b.length && Av(b, irb(this.a.d).b.Y(), null);
        return b;
    };
    var jx = Nkb(xyb, 'ForwardingImmutableMap/1', 523);
    hI(663, 660, Syb);
    _.mb = function ak() {
        return this.Kb();
    };
    _.t = function $j(a) {
        return mr(this, a);
    };
    _.v = function _j() {
        return nr(this);
    };
    var Fx = Nkb(xyb, 'ImmutableSet', 663);
    hI(315, 663, Syb);
    _.mb = function jk() {
        return Xl(new Nqb(this.a.b.mb()));
    };
    _.kb = function ek(a) {
        return a != null && Brb(this.a, a);
    };
    _.lb = function fk(a) {
        return Crb(this.a, a);
    };
    _.v = function gk() {
        return this.a.b.v();
    };
    _.V = function hk() {
        return this.a.b.V();
    };
    _.Kb = function ik() {
        return Xl(new Nqb(this.a.b.mb()));
    };
    _.Y = function kk() {
        return this.a.b.Y();
    };
    _.ob = function lk() {
        return this.a.b.ob();
    };
    _.pb = function mk(a) {
        return Erb(this.a, a);
    };
    _.w = function nk() {
        return xb(this.a.b);
    };
    var lx = Nkb(xyb, 'ForwardingImmutableSet', 315);
    hI(178, 1, {
        178: 1,
        3: 1
    }, sk);
    _.t = function tk(a) {
        var b;
        if (aw(a, 178)) {
            b = Wv(a, 178);
            return this.a.t(b.a) && this.b == b.b && this.c == b.c && this.d == b.d && this.f == b.f && Tb(this.e, b.e) && Tb(this.g, b.g);
        }
        return false;
    };
    _.v = function uk() {
        return fpb(Bv(tv(UF, 1), syb, 1, 4, [
            this.a,
            this.e,
            this.d,
            this.g,
            this.f
        ]));
    };
    _.w = function vk() {
        return umb(xmb(umb(xmb(umb(ymb(xmb(new zmb, this.a), ':'), this.d == (Gh(), Eh) ? 91 : 40), this.b ? this.e : '-\u221E'), 44), this.c ? this.g : '\u221E'), this.f == Eh ? 93 : 41).a;
    };
    _.b = false;
    _.c = false;
    var ox = Nkb(xyb, 'GeneralRange', 178);
    hI(215, 384, zyb, xk);
    _.a = 2;
    var px = Nkb(xyb, 'HashMultimap', 215);
    hI(661, 87, Qyb);
    _.kb = function yk(a) {
        return this.Sb().kb(a);
    };
    _.V = function zk() {
        return this.Sb().V();
    };
    _.Y = function Ak() {
        return this.Sb().Y();
    };
    var qx = Nkb(xyb, 'ImmutableAsList', 661);
    hI(275, 320, Ryb);
    _.Rb = function Ck() {
        return this.Ub();
    };
    _.fb = function Ek() {
        return this.Ub();
    };
    _.Ub = function Dk() {
        return oj(this.Tb());
    };
    var rx = Nkb(xyb, 'ImmutableBiMap', 275);
    hI(341, 668, {
        3: 1,
        21: 1
    }, Fk);
    _.yb = function Gk() {
        return this.a;
    };
    _.zb = function Hk() {
        return this.b;
    };
    _.Ab = function Ik(a) {
        throw new Hmb;
    };
    var tx = Nkb(xyb, 'ImmutableEntry', 341);
    hI(436, 315, Syb, Jk);
    var ux = Nkb(xyb, 'ImmutableEnumSet', 436);
    hI(379, 378, yyb, Mk);
    var vx = Nkb(xyb, 'ImmutableList/1', 379);
    hI(266, 108, wyb, Nk);
    _.G = function Ok() {
        return this.a.G();
    };
    _.H = function Pk() {
        return Wv(this.a.H(), 21).yb();
    };
    var xx = Nkb(xyb, 'ImmutableMap/1', 266);
    hI(670, 663, Syb);
    _.mb = function Sk() {
        var a;
        return a = nj(this.a).Kb(), new Nk(a);
    };
    _.Jb = function Qk() {
        return new jl(this);
    };
    _.Kb = function Rk() {
        var a;
        return (a = this.c, !a ? this.c = new jl(this) : a).Kb();
    };
    var Ex = Nkb(xyb, 'ImmutableSet/Indexed', 670);
    hI(606, 670, Syb, Uk);
    _.mb = function Xk() {
        var a;
        return a = nj(this.a).Kb(), new Nk(a);
    };
    _.kb = function Vk(a) {
        return this.a.R(a);
    };
    _.Kb = function Wk() {
        var a;
        return a = nj(this.a).Kb(), new Nk(a);
    };
    _.Y = function Yk() {
        return this.a.Y();
    };
    var yx = Nkb(xyb, 'ImmutableMapKeySet', 606);
    hI(604, 660, Pyb, Zk);
    _.mb = function bl() {
        return new dl(this);
    };
    _.kb = function $k(a) {
        return a != null && (Il(), Il(), Tl(new dl(this), (hc(), a == null ? (Lc(), Jc) : new sc(a))) != -1);
    };
    _.Jb = function _k() {
        var a;
        a = ki(nj(this.a));
        return new gl(this, a);
    };
    _.Kb = function al() {
        return new dl(this);
    };
    _.Y = function cl() {
        return this.a.Y();
    };
    var Bx = Nkb(xyb, 'ImmutableMapValues', 604);
    hI(282, 108, wyb, dl);
    _.G = function el() {
        return this.a.G();
    };
    _.H = function fl() {
        return Wv(this.a.H(), 21).zb();
    };
    var zx = Nkb(xyb, 'ImmutableMapValues/1', 282);
    hI(605, 661, Qyb, gl);
    _.Sb = function hl() {
        return this.a;
    };
    _.sb = function il(a) {
        return Wv(this.b.sb(a), 21).zb();
    };
    var Ax = Nkb(xyb, 'ImmutableMapValues/2', 605);
    hI(311, 661, Qyb, jl);
    _.Sb = function kl() {
        return this.a;
    };
    _.sb = function ll(a) {
        return Tk(this.a, a);
    };
    var Dx = Nkb(xyb, 'ImmutableSet/Indexed/1', 311);
    hI(414, 234, Oyb, vl);
    _.mb = function wl() {
        return Nl(this.a);
    };
    _.w = function xl() {
        return Ze(this.a) + ' (cycled)';
    };
    var Hx = Nkb(xyb, 'Iterables/1', 414);
    hI(105, 1, Tyb, yl);
    _.B = function zl(a) {
        return Wv(a, 22).mb();
    };
    var Gx = Nkb(xyb, 'Iterables/12', 105);
    hI(415, 234, Oyb, Bl);
    _.mb = function Cl() {
        return Al(this);
    };
    var Ix = Nkb(xyb, 'Iterables/4', 415);
    hI(416, 234, Oyb, El);
    _.mb = function Fl() {
        return Dl(this);
    };
    var Jx = Nkb(xyb, 'Iterables/5', 416);
    var Gl, Hl;
    hI(424, 651, yyb, Yl);
    _.G = function Zl() {
        return false;
    };
    _.K = function $l() {
        return false;
    };
    _.H = function _l() {
        throw new nvb;
    };
    _.L = function am() {
        return 0;
    };
    _.M = function bm() {
        throw new nvb;
    };
    _.N = function cm() {
        return -1;
    };
    var Lx = Nkb(xyb, 'Iterators/1', 424);
    hI(264, 108, wyb, dm);
    _.G = function em() {
        return !this.a;
    };
    _.H = function fm() {
        if (this.a) throw new nvb;
        this.a = true;
        return this.b;
    };
    _.a = false;
    var Kx = Nkb(xyb, 'Iterators/11', 264);
    hI(425, 1, Ayb, gm);
    _.G = function hm() {
        return false;
    };
    _.H = function im() {
        throw new nvb;
    };
    _.I = function jm() {
        ec(false);
    };
    var Mx = Nkb(xyb, 'Iterators/2', 425);
    hI(426, 108, wyb, km);
    _.G = function lm() {
        return this.a.G();
    };
    _.H = function mm() {
        return this.a.H();
    };
    var Nx = Nkb(xyb, 'Iterators/3', 426);
    hI(427, 1, Ayb, om);
    _.G = function pm() {
        return this.a.G() || this.b.mb().G();
    };
    _.H = function qm() {
        return nm(this);
    };
    _.I = function rm() {
        this.a.I();
    };
    var Ox = Nkb(xyb, 'Iterators/4', 427);
    hI(429, 428, wyb, tm);
    var Px = Nkb(xyb, 'Iterators/6', 429);
    hI(261, 1, Ayb);
    _.G = function wm() {
        return this.b.G();
    };
    _.H = function xm() {
        return um(this);
    };
    _.I = function ym() {
        this.b.I();
    };
    var Oy = Nkb(xyb, 'TransformedIterator', 261);
    hI(430, 261, Ayb, Am);
    _.Vb = function Bm(a) {
        return zm(this, a);
    };
    var Qx = Nkb(xyb, 'Iterators/7', 430);
    hI(313, 1, Ayb);
    _.G = function Fm() {
        return Cm(this);
    };
    _.H = function Gm() {
        return Dm(this);
    };
    _.I = function Hm() {
        ec(!!this.c);
        this.c.I();
        this.c = null;
    };
    var Ay = Nkb(xyb, 'MultitransformedIterator', 313);
    hI(90, 313, {
        90: 1,
        35: 1
    }, Im);
    _.Wb = function Jm(a) {
        return Wv(a, 35);
    };
    var Sx = Nkb(xyb, 'Iterators/ConcatenatedIterator', 90);
    hI(314, 313, Ayb, Lm);
    _.Wb = function Mm(a) {
        return Km(Wv(a, 35));
    };
    var Rx = Nkb(xyb, 'Iterators/ConcatenatedIterator/1', 314);
    hI(329, 653, zyb, Um);
    _.U = function $m(a) {
        return new Bn(this, a);
    };
    _.X = function an(a) {
        return Sm(this, a);
    };
    _.Q = function Wm() {
        Pm(this);
    };
    _.R = function Xm(a) {
        return Qm(this, a);
    };
    _.S = function Ym() {
        return new Pp(this);
    };
    _.T = function Zm() {
        return new Hn(this);
    };
    _.V = function _m() {
        return !this.a;
    };
    _.Y = function bn() {
        return this.d;
    };
    _.c = 0;
    _.d = 0;
    var _x = Nkb(xyb, 'LinkedListMultimap', 329);
    hI(647, 640, Fyb);
    _.rb = function en(a, b) {
        throw new Imb('Add not supported on this list');
    };
    _.ib = function fn(a) {
        this.rb(this.Y(), a);
        return true;
    };
    _.Q = function gn() {
        this.Xb(0, this.Y());
    };
    _.t = function hn(a) {
        return cn(this, a);
    };
    _.v = function jn() {
        return Bpb(this);
    };
    _.mb = function kn() {
        return new wnb(this);
    };
    _.tb = function ln() {
        return this.ub(0);
    };
    _.ub = function mn(a) {
        return new Fnb(this, a);
    };
    _.vb = function nn(a) {
        throw new Imb('Remove not supported on this list');
    };
    _.Xb = function on(a, b) {
        var c, d;
        d = this.ub(a);
        for(c = a; c < b; ++c){
            d.H();
            d.I();
        }
    };
    _.wb = function pn(a, b) {
        throw new Imb('Set not supported on this list');
    };
    _.xb = function qn(a, b) {
        return new Mnb(this, a, b);
    };
    _.d = 0;
    var lG = Nkb(Cyb, 'AbstractList', 647);
    hI(648, 647, Fyb);
    _.rb = function vn(a, b) {
        rn(this, a, b);
    };
    _.sb = function wn(a) {
        return tn(this, a);
    };
    _.mb = function xn() {
        return this.ub(0);
    };
    _.vb = function yn(a) {
        return un(this, a);
    };
    _.wb = function zn(b, c) {
        var d, e;
        d = this.ub(b);
        try {
            e = d.H();
            d.O(c);
            return e;
        } catch (a) {
            a = OH(a);
            if (aw(a, 74)) throw new okb("Can't set element " + b);
            else throw NH(a);
        }
    };
    var yG = Nkb(Cyb, 'AbstractSequentialList', 648);
    hI(276, 648, Fyb, Bn);
    _.ub = function Cn(a) {
        return An(this, a);
    };
    _.Y = function Dn() {
        var a;
        a = Wv(Smb(this.a.b, this.b), 126);
        return !a ? 0 : a.a;
    };
    var Vx = Nkb(xyb, 'LinkedListMultimap/1', 276);
    hI(330, 648, Fyb, En);
    _.ub = function Fn(a) {
        return new _n(this.a, a);
    };
    _.Y = function Gn() {
        return this.a.d;
    };
    var Tx = Nkb(xyb, 'LinkedListMultimap/1EntriesImpl', 330);
    hI(563, 649, Eyb, Hn);
    _.kb = function In(a) {
        return Qm(this.a, a);
    };
    _.mb = function Jn() {
        return new Nn(this.a);
    };
    _.nb = function Kn(a) {
        return !Sm(this.a, a).a.V();
    };
    _.Y = function Ln() {
        return Zmb(this.a.b);
    };
    var Ux = Nkb(xyb, 'LinkedListMultimap/1KeySetImpl', 563);
    hI(562, 1, Ayb, Nn);
    _.G = function On() {
        Mn(this);
        return !!this.c;
    };
    _.H = function Pn() {
        Mn(this);
        Vm(this.c);
        this.a = this.c;
        stb(this.d, this.a.a);
        do this.c = this.c.b;
        while (!!this.c && !stb(this.d, this.c.a));
        return this.a.a;
    };
    _.I = function Qn() {
        Mn(this);
        ec(!!this.a);
        Ml(new mo(this.e, this.a.a));
        this.a = null;
        this.b = this.e.c;
    };
    _.b = 0;
    var Wx = Nkb(xyb, 'LinkedListMultimap/DistinctKeyIterator', 562);
    hI(126, 1, {
        126: 1
    }, Rn);
    _.a = 0;
    var Xx = Nkb(xyb, 'LinkedListMultimap/KeyList', 126);
    hI(560, 668, Jyb, Sn);
    _.yb = function Tn() {
        return this.a;
    };
    _.zb = function Un() {
        return this.f;
    };
    _.Ab = function Vn(a) {
        var b;
        b = this.f;
        this.f = a;
        return b;
    };
    var Zx = Nkb(xyb, 'LinkedListMultimap/Node', 560);
    hI(561, 1, Hyb, _n);
    _.J = function ao(a) {
        Wv(a, 21);
        Wn();
    };
    _.H = function eo() {
        return Yn(this);
    };
    _.M = function go() {
        return Zn(this);
    };
    _.O = function jo(a) {
        Wv(a, 21);
        $n();
    };
    _.G = function bo() {
        Xn(this);
        return !!this.c;
    };
    _.K = function co() {
        Xn(this);
        return !!this.e;
    };
    _.L = function fo() {
        return this.d;
    };
    _.N = function ho() {
        return this.d - 1;
    };
    _.I = function io() {
        Xn(this);
        ec(!!this.a);
        if (this.a != this.c) {
            this.e = this.a.d;
            --this.d;
        } else this.c = this.a.b;
        Tm(this.f, this.a);
        this.a = null;
        this.b = this.f.c;
    };
    _.b = 0;
    _.d = 0;
    var Yx = Nkb(xyb, 'LinkedListMultimap/NodeIterator', 561);
    hI(241, 1, Hyb, mo, no);
    _.J = function oo(a) {
        this.e = Nm(this.f, this.b, a, this.c);
        ++this.d;
        this.a = null;
    };
    _.G = function po() {
        return !!this.c;
    };
    _.K = function qo() {
        return !!this.e;
    };
    _.H = function ro() {
        return ko(this);
    };
    _.L = function so() {
        return this.d;
    };
    _.M = function to() {
        return lo(this);
    };
    _.N = function uo() {
        return this.d - 1;
    };
    _.I = function vo() {
        ec(!!this.a);
        if (this.a != this.c) {
            this.e = this.a.e;
            --this.d;
        } else this.c = this.a.c;
        Tm(this.f, this.a);
        this.a = null;
    };
    _.O = function wo(a) {
        dc(!!this.a);
        this.a.f = a;
    };
    _.d = 0;
    var $x = Nkb(xyb, 'LinkedListMultimap/ValueForKeyIterator', 241);
    hI(419, 647, Fyb);
    _.rb = function Go(a, b) {
        this.a.rb(a, b);
    };
    _.kb = function Ho(a) {
        return this.a.kb(a);
    };
    _.sb = function Io(a) {
        return this.a.sb(a);
    };
    _.vb = function Jo(a) {
        return this.a.vb(a);
    };
    _.wb = function Ko(a, b) {
        return this.a.wb(a, b);
    };
    _.Y = function Lo() {
        return this.a.Y();
    };
    var by = Nkb(xyb, 'Lists/AbstractListWrapper', 419);
    hI(420, 419, Gyb);
    var cy = Nkb(xyb, 'Lists/RandomAccessListWrapper', 420);
    hI(422, 420, Gyb, Mo);
    _.ub = function No(a) {
        return this.a.ub(a);
    };
    var ay = Nkb(xyb, 'Lists/1', 422);
    hI(88, 647, {
        88: 1,
        22: 1,
        19: 1,
        20: 1
    }, Ro);
    _.rb = function So(a, b) {
        this.a.rb(Qo(this, a), b);
    };
    _.Q = function To() {
        this.a.Q();
    };
    _.sb = function Uo(a) {
        return this.a.sb(Po(this, a));
    };
    _.mb = function Vo() {
        return Oo(this, 0);
    };
    _.ub = function Wo(a) {
        return Oo(this, a);
    };
    _.vb = function Xo(a) {
        return this.a.vb(Po(this, a));
    };
    _.Xb = function Yo(a, b) {
        (cc(a, b, this.a.Y()), Fo(this.a.xb(Qo(this, b), Qo(this, a)))).Q();
    };
    _.wb = function Zo(a, b) {
        return this.a.wb(Po(this, a), b);
    };
    _.Y = function $o() {
        return this.a.Y();
    };
    _.xb = function _o(a, b) {
        return cc(a, b, this.a.Y()), Fo(this.a.xb(Qo(this, b), Qo(this, a)));
    };
    var fy = Nkb(xyb, 'Lists/ReverseList', 88);
    hI(220, 88, {
        88: 1,
        22: 1,
        19: 1,
        20: 1,
        63: 1
    }, ap);
    var dy = Nkb(xyb, 'Lists/RandomAccessReverseList', 220);
    hI(421, 1, Hyb, bp);
    _.J = function cp(a) {
        this.c.J(a);
        this.c.M();
        this.a = false;
    };
    _.G = function dp() {
        return this.c.K();
    };
    _.K = function ep() {
        return this.c.G();
    };
    _.H = function fp() {
        if (!this.c.K()) throw new nvb;
        this.a = true;
        return this.c.M();
    };
    _.L = function gp() {
        return Qo(this.b, this.c.L());
    };
    _.M = function hp() {
        if (!this.c.G()) throw new nvb;
        this.a = true;
        return this.c.H();
    };
    _.N = function ip() {
        return Qo(this.b, this.c.L()) - 1;
    };
    _.I = function jp() {
        ec(this.a);
        this.c.I();
        this.a = false;
    };
    _.O = function kp(a) {
        dc(this.a);
        this.c.O(a);
    };
    _.a = false;
    var ey = Nkb(xyb, 'Lists/ReverseList/1', 421);
    var lp;
    hI(376, 261, Ayb, tp);
    _.Vb = function up(a) {
        return mp(), new Fk(a, aq(this.a, a));
    };
    var gy = Nkb(xyb, 'Maps/1', 376);
    hI(188, 17, Wyb);
    var vp, wp;
    var jy = Okb(xyb, 'Maps/EntryFunction', 188, IF, zp);
    hI(374, 188, Wyb, Ap);
    _.B = function Bp(a) {
        return Wv(a, 21).yb();
    };
    var hy = Okb(xyb, 'Maps/EntryFunction/1', 374, jy, null);
    hI(375, 188, Wyb, Cp);
    _.B = function Dp(a) {
        return Wv(a, 21).zb();
    };
    var iy = Okb(xyb, 'Maps/EntryFunction/2', 375, jy, null);
    hI(373, 640, Dyb, Fp);
    _.Q = function Gp() {
        this.a.Q();
    };
    _.kb = function Hp(a) {
        return this.a.ab(a);
    };
    _.V = function Ip() {
        return this.a.V();
    };
    _.mb = function Jp() {
        return Ep(this);
    };
    _.nb = function Kp(b) {
        var c, d;
        try {
            return Ve(this, b, true);
        } catch (a) {
            a = OH(a);
            if (aw(a, 45)) {
                for(d = this.a.bb().mb(); d.G();){
                    c = Wv(d.H(), 21);
                    if (Tb(b, c.zb())) {
                        this.a.eb(c.yb());
                        return true;
                    }
                }
                return false;
            } else throw NH(a);
        }
    };
    _.Y = function Lp() {
        return this.a.Y();
    };
    var my = Nkb(xyb, 'Maps/Values', 373);
    hI(301, 654, Byb, Pp);
    _.cb = function Tp(a) {
        return this.a.R(a) ? this.a.U(a) : null;
    };
    _.eb = function Wp(a) {
        return this.a.R(a) ? this.a.X(a) : null;
    };
    _.Q = function Qp() {
        this.a.Q();
    };
    _.R = function Rp(a) {
        return this.a.R(a);
    };
    _.hb = function Sp() {
        return new Yp(this);
    };
    _.gb = function() {
        return this.hb();
    };
    _.V = function Up() {
        return this.a.V();
    };
    _.W = function Vp() {
        return this.a.W();
    };
    _.Y = function Xp() {
        return this.a.W().Y();
    };
    var qy = Nkb(xyb, 'Multimaps/AsMap', 301);
    hI(393, 655, Eyb, Yp);
    _.mb = function Zp() {
        return np(this.a.a.W(), new bq(this));
    };
    _.qb = function $p() {
        return this.a;
    };
    _.nb = function _p(a) {
        var b;
        if (!mf(this, a)) return false;
        b = Wv(a, 21);
        Op(this.a, b.yb());
        return true;
    };
    var py = Nkb(xyb, 'Multimaps/AsMap/EntrySet', 393);
    hI(395, 1, Tyb, bq);
    _.B = function cq(a) {
        return aq(this, a);
    };
    var oy = Nkb(xyb, 'Multimaps/AsMap/EntrySet/1', 395);
    hI(391, 656, Lyb, eq);
    _.Q = function fq() {
        Pm(this.a);
    };
    _.kb = function gq(a) {
        return Qm(this.a, a);
    };
    _.Cb = function hq(a) {
        var b;
        return b = Wv(rp(Om(this.a), a), 19), !b ? 0 : b.Y();
    };
    _.gb = function iq() {
        return new wq(this);
    };
    _.Db = function jq() {
        return Om(this.a).Y();
    };
    _.Eb = function kq() {
        return new nq(Ae(Om(this.a)).mb());
    };
    _.mb = function lq() {
        return dq(this);
    };
    _.Fb = function mq(a, b) {
        var c, d, e, f, g;
        Mh(b, Xyb);
        if (b == 0) return g = Wv(rp(Om(this.a), a), 19), !g ? 0 : g.Y();
        f = Wv(rp(Om(this.a), a), 19);
        if (!f) return 0;
        e = f.Y();
        if (b >= e) f.Q();
        else {
            d = f.mb();
            for(c = 0; c < b; c++){
                d.H();
                d.I();
            }
        }
        return e;
    };
    var uy = Nkb(xyb, 'Multimaps/Keys', 391);
    hI(302, 261, Ayb, nq);
    _.Vb = function oq(a) {
        return new tq(Wv(a, 21));
    };
    var sy = Nkb(xyb, 'Multimaps/Keys/1', 302);
    hI(658, 1, {
        83: 1
    });
    _.t = function qq(a) {
        var b;
        if (aw(a, 83)) {
            b = Wv(a, 83);
            return this.Yb() == b.Yb() && Tb(this.Zb(), b.Zb());
        }
        return false;
    };
    _.v = function rq() {
        var a;
        a = this.Zb();
        return (a == null ? 0 : vb(a)) ^ this.Yb();
    };
    _.w = function sq() {
        return pq(this);
    };
    var wy = Nkb(xyb, 'Multisets/AbstractEntry', 658);
    hI(394, 658, {
        83: 1
    }, tq);
    _.Yb = function uq() {
        return Wv(this.a.zb(), 19).Y();
    };
    _.Zb = function vq() {
        return this.a.yb();
    };
    var ry = Nkb(xyb, 'Multimaps/Keys/1/1', 394);
    hI(392, 657, Eyb, wq);
    _.kb = function xq(a) {
        var b, c;
        if (aw(a, 83)) {
            c = Wv(a, 83);
            b = Wv(Om(this.a.a).cb(c.Zb()), 19);
            return !!b && b.Y() == c.Yb();
        }
        return false;
    };
    _.V = function yq() {
        return !this.a.a.a;
    };
    _.mb = function zq() {
        return new nq(Ae(Om(this.a.a)).mb());
    };
    _.Ib = function Aq() {
        return this.a;
    };
    _.nb = function Bq(a) {
        var b, c;
        if (aw(a, 83)) {
            c = Wv(a, 83);
            b = Wv(Om(this.a.a).cb(c.Zb()), 19);
            if (!!b && b.Y() == c.Yb()) {
                b.Q();
                return true;
            }
        }
        return false;
    };
    _.Y = function Cq() {
        return Om(this.a.a).Y();
    };
    var ty = Nkb(xyb, 'Multimaps/Keys/KeysEntrySet', 392);
    hI(659, 1, fyb);
    var Cy = Nkb(xyb, 'Ordering', 659);
    hI(398, 659, fyb, Jq);
    _.$b = function Kq(a, b) {
        return Iq(Wv(a, 83), Wv(b, 83));
    };
    var vy = Nkb(xyb, 'Multisets/1', 398);
    hI(397, 658, {
        83: 1,
        3: 1
    }, Lq);
    _.Yb = function Mq() {
        return this.a;
    };
    _.Zb = function Nq() {
        return this.b;
    };
    _.a = 0;
    var yy = Nkb(xyb, 'Multisets/ImmutableEntry', 397);
    hI(303, 1, Ayb, Oq);
    _.G = function Pq() {
        return this.d > 0 || this.c.G();
    };
    _.H = function Qq() {
        if (!(this.d > 0 || this.c.G())) throw new nvb;
        if (this.d == 0) {
            this.b = Wv(this.c.H(), 83);
            this.f = this.d = this.b.Yb();
        }
        --this.d;
        this.a = true;
        return this.b.Zb();
    };
    _.I = function Rq() {
        ec(this.a);
        this.f == 1 ? this.c.I() : this.e.Fb(this.b.Zb(), 1);
        --this.f;
        this.a = false;
    };
    _.a = false;
    _.d = 0;
    _.f = 0;
    var zy = Nkb(xyb, 'Multisets/MultisetIteratorImpl', 303);
    hI(622, 659, {
        3: 1,
        56: 1
    }, Vq);
    _.$b = function Wq(a, b) {
        return Uq(Wv(a, 23), Wv(b, 23));
    };
    _.w = function Xq() {
        return 'Ordering.natural()';
    };
    var Sq;
    var By = Nkb(xyb, 'NaturalOrdering', 622);
    hI(343, 661, Qyb, Zq);
    _.ub = function br(a) {
        return Hi(this.b, a);
    };
    _.Sb = function $q() {
        return this.a;
    };
    _.sb = function _q(a) {
        return $i(this.b, a);
    };
    _.Lb = function ar(a) {
        return Hi(this.b, a);
    };
    var Dy = Nkb(xyb, 'RegularImmutableAsList', 343);
    hI(559, 275, Ryb, er);
    _.Tb = function fr() {
        return this.a;
    };
    var cr;
    var Ey = Nkb(xyb, 'RegularImmutableBiMap', 559);
    hI(53, 667, Qyb, gr);
    _.Nb = function hr() {
        return this.a;
    };
    var Fy = Nkb(xyb, 'RegularImmutableList', 53);
    hI(321, 320, Ryb, ir);
    var Gy = Nkb(xyb, 'RegularImmutableMap', 321);
    hI(265, 315, Syb, lr);
    var jr;
    var Hy = Nkb(xyb, 'RegularImmutableSet', 265);
    hI(650, 641, Eyb);
    var Ky = Nkb(xyb, 'Sets/SetView', 650);
    hI(377, 650, Eyb, tr);
    _.kb = function ur(a) {
        return ttb(this.b, a) && ttb(this.c, a);
    };
    _.lb = function vr(a) {
        return Xe(this.b, a) && Xe(this.c, a);
    };
    _.V = function wr() {
        return sr(this);
    };
    _.mb = function xr() {
        var a;
        return Pl((a = new Snb(this.b.a).a.bb().mb(), new Ynb(a)), this.a);
    };
    _.Y = function yr() {
        var a;
        return Ul(Pl((a = new Snb(this.b.a).a.bb().mb(), new Ynb(a)), this.a));
    };
    var Iy = Nkb(xyb, 'Sets/2', 377);
    hI(328, 275, Ryb, zr, Ar);
    _.fb = function Dr() {
        return hi(), new Gr(this.c);
    };
    _.Tb = function Br() {
        var a;
        a = this.a;
        return !a ? this.a = new Ar(this.c, this.b, this) : a;
    };
    _.Ub = function Cr() {
        return hi(), new Gr(this.c);
    };
    var Ly = Nkb(xyb, 'SingletonImmutableBiMap', 328);
    hI(127, 667, Qyb, Er);
    _.Nb = function Fr() {
        return this.a;
    };
    var My = Nkb(xyb, 'SingletonImmutableList', 127);
    hI(135, 663, Syb, Gr);
    _.mb = function Jr() {
        return Il(), new dm(this.a);
    };
    _.kb = function Hr(a) {
        return rb(this.a, a);
    };
    _.Kb = function Ir() {
        return Il(), new dm(this.a);
    };
    _.Y = function Kr() {
        return 1;
    };
    var Ny = Nkb(xyb, 'SingletonImmutableSet', 135);
    hI(285, 342, {
        207: 1,
        3: 1,
        22: 1,
        19: 1
    }, Ur, Vr);
    _.Bb = function Wr(a, b) {
        return Lr(this, a, b);
    };
    _.Cb = function Xr(a) {
        return Pr(this, a);
    };
    _.Db = function Yr() {
        return $s(Or(this, (qs(), os)));
    };
    _.Eb = function $r() {
        return new ks(this);
    };
    _.Fb = function _r(a, b) {
        return Sr(this, a, b);
    };
    _.Gb = function as(a, b) {
        return Tr(this, a, b);
    };
    _.Hb = function bs(a, b, c) {
        var d, e, f;
        Mh(c, 'newCount');
        Mh(b, 'oldCount');
        Xb(ok(this.b, a));
        f = this.c.a;
        if (!f) {
            if (b == 0) {
                c > 0 && Lr(this, a, c);
                return true;
            } else return false;
        }
        e = xv(mw, Yyb, 26, 1, 12, 1);
        d = Ms(f, this.d, a, b, c, e);
        Us(this.c, f, d);
        return e[0] == b;
    };
    _.Y = function cs() {
        return $s(Or(this, (qs(), ps)));
    };
    var Wy = Nkb(xyb, 'TreeMultiset', 285);
    hI(619, 658, {
        83: 1
    }, fs);
    _.Yb = function gs() {
        var a;
        a = this.b.c;
        return a == 0 ? Pr(this.a, this.b.b) : a;
    };
    _.Zb = function hs() {
        return this.b.b;
    };
    var Py = Nkb(xyb, 'TreeMultiset/1', 619);
    hI(620, 1, Ayb, ks);
    _.H = function ms() {
        return js(this);
    };
    _.G = function ls() {
        return is(this);
    };
    _.I = function ns() {
        ec(!!this.b);
        Tr(this.c, this.b.b.b, 0);
        this.b = null;
    };
    var Qy = Nkb(xyb, 'TreeMultiset/2', 620);
    hI(205, 17, Zyb);
    var os, ps;
    var Ty = Okb(xyb, 'TreeMultiset/Aggregate', 205, IF, ss);
    hI(617, 205, Zyb, ts);
    _._b = function us(a) {
        return a.c;
    };
    _.ac = function vs(a) {
        return !a ? 0 : a.j;
    };
    var Ry = Okb(xyb, 'TreeMultiset/Aggregate/1', 617, Ty, null);
    hI(618, 205, Zyb, ws);
    _._b = function xs(a) {
        return 1;
    };
    _.ac = function ys(a) {
        return !a ? 0 : a.a;
    };
    var Sy = Okb(xyb, 'TreeMultiset/Aggregate/2', 618, Ty, null);
    hI(206, 658, {
        83: 1,
        206: 1
    }, Os);
    _.Yb = function Ps() {
        return this.c;
    };
    _.Zb = function Qs() {
        return this.b;
    };
    _.w = function Ss() {
        return Dq(), pq(new Lq(this.b, this.c));
    };
    _.a = 0;
    _.c = 0;
    _.d = 0;
    _.j = 0;
    var Uy = Nkb(xyb, 'TreeMultiset/AvlNode', 206);
    hI(616, 1, {}, Vs);
    var Vy = Nkb(xyb, 'TreeMultiset/Reference', 616);
    var $y = Nkb(lyb, 'JavaScriptObject$', 0);
    var qt;
    hI(628, 1, {});
    var _y = Nkb(lyb, 'Scheduler', 628);
    var ut = 0, vt = 0, wt = -1;
    hI(360, 628, {}, Jt);
    var Ft;
    var az = Nkb(myb, 'SchedulerImpl', 360);
    hI(646, 1, {});
    _.hc = function bu() {
        return null;
    };
    _.ic = function cu() {
        return null;
    };
    _.jc = function du() {
        return null;
    };
    _.kc = function eu() {
        return null;
    };
    _.lc = function fu() {
        return null;
    };
    var nz = Nkb(_yb, 'JSONValue', 646);
    hI(214, 646, {
        214: 1
    }, ju, ku);
    _.t = function lu(a) {
        if (!aw(a, 214)) return false;
        return this.a == Wv(a, 214).a;
    };
    _.gc = function mu() {
        return qu;
    };
    _.v = function nu() {
        return txb(this.a);
    };
    _.hc = function ou() {
        return this;
    };
    _.w = function pu() {
        var a, b, c;
        c = new Bmb('[');
        for(b = 0, a = this.a.length; b < a; b++){
            b > 0 && (c.a += ',', c);
            xmb(c, gu(this, b));
        }
        c.a += ']';
        return c.a;
    };
    var fz = Nkb(_yb, 'JSONArray', 214);
    hI(292, 646, {}, uu);
    _.gc = function vu() {
        return yu;
    };
    _.ic = function wu() {
        return this;
    };
    _.w = function xu() {
        return Bkb(this.a);
    };
    _.a = false;
    var ru, su;
    var gz = Nkb(_yb, 'JSONBoolean', 292);
    hI(371, 72, Vxb, zu);
    var hz = Nkb(_yb, 'JSONException', 371);
    hI(435, 646, {}, Cu);
    _.gc = function Du() {
        return Fu;
    };
    _.w = function Eu() {
        return Wxb;
    };
    var Au;
    var iz = Nkb(_yb, 'JSONNull', 435);
    hI(104, 646, {
        104: 1
    }, Gu);
    _.t = function Hu(a) {
        if (!aw(a, 104)) return false;
        return this.a == Wv(a, 104).a;
    };
    _.gc = function Iu() {
        return Mu;
    };
    _.v = function Ju() {
        return hw(Ixb(this.a));
    };
    _.jc = function Ku() {
        return this;
    };
    _.w = function Lu() {
        return this.a + '';
    };
    _.a = 0;
    var jz = Nkb(_yb, 'JSONNumber', 104);
    hI(69, 646, {
        69: 1
    }, Tu, Uu);
    _.t = function Vu(a) {
        if (!aw(a, 69)) return false;
        return this.a == Wv(a, 69).a;
    };
    _.gc = function Wu() {
        return $u;
    };
    _.v = function Xu() {
        return txb(this.a);
    };
    _.kc = function Yu() {
        return this;
    };
    _.w = function Zu() {
        var a, b, c, d, e, f;
        f = new Bmb('{');
        a = true;
        e = Nu(this, xv($F, Txb, 2, 0, 5, 1));
        for(c = 0, d = e.length; c < d; ++c){
            b = e[c];
            a ? a = false : (f.a += ', ', f);
            ymb(f, st(b));
            f.a += ':';
            xmb(f, Pu(this, b));
        }
        f.a += '}';
        return f.a;
    };
    var lz = Nkb(_yb, 'JSONObject', 69);
    hI(361, 641, Eyb, _u);
    _.kb = function av(a) {
        return ew(a) && Ou(this.a, $v(a));
    };
    _.mb = function bv() {
        return new wnb(new opb(this.b));
    };
    _.Y = function cv() {
        return this.b.length;
    };
    var kz = Nkb(_yb, 'JSONObject/1', 361);
    var dv;
    hI(97, 646, {
        97: 1
    }, lv);
    _.t = function mv(a) {
        if (!aw(a, 97)) return false;
        return emb(this.a, Wv(a, 97).a);
    };
    _.gc = function nv() {
        return rv;
    };
    _.v = function ov() {
        return Pxb(this.a);
    };
    _.lc = function pv() {
        return this;
    };
    _.w = function qv() {
        return st(this.a);
    };
    var mz = Nkb(_yb, 'JSONString', 97);
    var Ov, Pv, Qv;
    hI(186, 1, {}, sI, tI);
    _.b = false;
    _.c = 0;
    _.d = -1;
    _.e = 0;
    _.f = false;
    _.j = 0;
    var oz = Nkb('de.cau.cs.kieler.core.alg', 'BasicProgressMonitor', 186);
    hI(10, 1, {
        10: 1,
        286: 1,
        3: 1,
        5: 1
    }, FI, GI, HI, II);
    _.t = function JI(a) {
        return yI(this, a);
    };
    _.v = function KI() {
        return hw(Ixb(this.a)) + Blb(hw(Ixb(this.b)));
    };
    _.w = function NI() {
        return '(' + this.a + ',' + this.b + ')';
    };
    _.a = 0;
    _.b = 0;
    var qz = Nkb(izb, 'KVector', 10);
    hI(58, 648, {
        3: 1,
        5: 1,
        22: 1,
        19: 1,
        58: 1,
        20: 1
    }, aJ);
    _.ib = function bJ(a) {
        return QI(this, a);
    };
    _.Q = function cJ() {
        _I(this);
    };
    _.ub = function dJ(a) {
        return WI(this, a);
    };
    _.Y = function eJ() {
        return this.b;
    };
    _.b = 0;
    var rH = Nkb(Cyb, 'LinkedList', 58);
    hI(44, 58, {
        44: 1,
        286: 1,
        3: 1,
        5: 1,
        22: 1,
        19: 1,
        58: 1,
        20: 1
    }, jJ, kJ);
    _.w = function mJ() {
        var a, b, c;
        a = new Bmb('(');
        b = WI(this, 0);
        while(b.b != b.d.c){
            c = Wv(_ub(b), 10);
            ymb(a, c.a + ',' + c.b);
            b.b != b.d.c && (a.a += '; ', a);
        }
        return a.a += ')', a.a;
    };
    var pz = Nkb(izb, 'KVectorChain', 44);
    var rz = Pkb(kzb, 'IProperty');
    hI(131, 1, {
        179: 1,
        131: 1,
        3: 1
    }, tJ);
    var sz = Nkb(kzb, 'MapPropertyHolder', 131);
    hI(14, 1, lzb, AJ, BJ, CJ, DJ, EJ, FJ);
    _.F = function GJ(a) {
        return xJ(this, Wv(a, 79));
    };
    _.t = function HJ(a) {
        return yJ(this, a);
    };
    _.mc = function IJ() {
        return this.b;
    };
    _.nc = function JJ() {
        return this.c;
    };
    _.oc = function KJ() {
        return this.d;
    };
    _.v = function LJ() {
        return Pxb(this.b);
    };
    _.w = function MJ() {
        return this.b;
    };
    var uJ, vJ;
    var vz = Nkb(kzb, 'Property', 14);
    hI(366, 1, {
        23: 1
    }, NJ);
    _.F = function OJ(a) {
        return -1;
    };
    var tz = Nkb(kzb, 'Property/1', 366);
    hI(367, 1, {
        23: 1
    }, PJ);
    _.F = function QJ(a) {
        return 1;
    };
    var uz = Nkb(kzb, 'Property/2', 367);
    hI(27, 1, {
        27: 1,
        22: 1
    }, RJ);
    _.t = function SJ(a) {
        var b, c, d;
        if (aw(a, 27)) {
            c = Wv(a, 27);
            b = this.a == null ? c.a == null : rb(this.a, c.a);
            d = this.b == null ? c.b == null : rb(this.b, c.b);
            return b && d;
        } else return false;
    };
    _.v = function TJ() {
        var a, b, c, d, e, f;
        c = this.a == null ? 0 : vb(this.a);
        a = c & byb;
        b = c & -65536;
        f = this.b == null ? 0 : vb(this.b);
        d = f & byb;
        e = f & -65536;
        return a ^ e >> 16 & byb | b ^ d << 16;
    };
    _.mb = function UJ() {
        return new WJ(this);
    };
    _.w = function VJ() {
        return this.a == null && this.b == null ? 'pair(null,null)' : this.a == null ? 'pair(null,' + xb(this.b) + ')' : this.b == null ? 'pair(' + xb(this.a) + ',null)' : 'pair(' + xb(this.a) + ',' + xb(this.b) + ')';
    };
    var xz = Nkb(mzb, 'Pair', 27);
    hI(431, 1, Ayb, WJ);
    _.G = function XJ() {
        return !this.c && (!this.b && this.a.a != null || this.a.b != null);
    };
    _.H = function YJ() {
        if (!this.c && !this.b && this.a.a != null) {
            this.b = true;
            return this.a.a;
        } else if (!this.c && this.a.b != null) {
            this.c = true;
            return this.a.b;
        }
        throw new nvb;
    };
    _.I = function ZJ() {
        this.c && this.a.b != null ? this.a.b = null : this.b && this.a.a != null && (this.a.a = null);
        throw new tlb;
    };
    _.b = false;
    _.c = false;
    var wz = Nkb(mzb, 'Pair/1', 431);
    hI(228, 72, Vxb, $J);
    var yz = Nkb(nzb, 'UnsupportedConfigurationException', 228);
    hI(99, 72, Vxb, _J);
    var zz = Nkb(nzb, 'UnsupportedGraphException', 99);
    var aK;
    hI(103, 17, {
        103: 1,
        3: 1,
        23: 1,
        17: 1
    }, jK);
    var cK, dK, eK, fK, gK, hK;
    var Az = Okb(rzb, 'Alignment', 103, IF, kK);
    var lK;
    hI(59, 17, {
        59: 1,
        3: 1,
        23: 1,
        17: 1
    }, wK);
    var nK, oK, pK, qK, rK;
    var Bz = Okb(rzb, 'Direction', 59, IF, xK);
    var yK;
    hI(107, 17, {
        107: 1,
        3: 1,
        23: 1,
        17: 1
    }, FK);
    var AK, BK, CK, DK;
    var Cz = Okb(rzb, 'EdgeLabelPlacement', 107, IF, GK);
    var HK;
    hI(122, 17, {
        122: 1,
        3: 1,
        23: 1,
        17: 1
    }, OK);
    var JK, KK, LK, MK;
    var Dz = Okb(rzb, 'EdgeRouting', 122, IF, PK);
    var QK;
    hI(133, 17, {
        133: 1,
        3: 1,
        23: 1,
        17: 1
    }, ZK);
    var SK, TK, UK, VK, WK, XK;
    var Ez = Okb(rzb, 'EdgeType', 133, IF, $K);
    var _K;
    hI(166, 17, {
        166: 1,
        3: 1,
        23: 1,
        17: 1
    }, fL);
    var bL, cL, dL;
    var Fz = Okb(rzb, 'HierarchyHandling', 166, IF, gL);
    var hL;
    var jL, kL, lL, mL, nL, oL, pL, qL, rL, sL, tL, uL, vL, wL, xL, yL, zL, AL, BL, CL, DL, EL, FL, GL, HL, IL, JL, KL, LL, ML, NL, OL, PL, QL, RL, SL, TL, UL, VL, WL, XL, YL, ZL, $L, _L, aM, bM, cM, dM;
    hI(41, 17, {
        41: 1,
        3: 1,
        23: 1,
        17: 1
    }, pM);
    var fM, gM, hM, iM, jM, kM, lM, mM, nM;
    var Gz = Okb(rzb, 'NodeLabelPlacement', 41, IF, qM);
    var rM;
    hI(100, 17, {
        100: 1,
        3: 1,
        23: 1,
        17: 1
    }, AM);
    var uM, vM, wM, xM, yM;
    var Hz = Okb(rzb, 'PortAlignment', 100, IF, BM);
    var CM;
    hI(28, 17, {
        28: 1,
        3: 1,
        23: 1,
        17: 1
    }, NM);
    var EM, FM, GM, HM, IM, JM;
    var Iz = Okb(rzb, 'PortConstraints', 28, IF, OM);
    var PM;
    hI(149, 17, {
        149: 1,
        3: 1,
        23: 1,
        17: 1
    }, VM);
    var RM, SM, TM;
    var Jz = Okb(rzb, 'PortLabelPlacement', 149, IF, WM);
    var XM;
    hI(32, 17, {
        32: 1,
        3: 1,
        23: 1,
        17: 1
    }, uN);
    var ZM, $M, _M, aN, bN, cN, dN, eN, fN, gN, hN, iN, jN, kN, lN, mN, nN, oN, pN, qN, rN;
    var Kz = Okb(rzb, 'PortSide', 32, IF, wN);
    var xN;
    hI(150, 17, {
        150: 1,
        3: 1,
        23: 1,
        17: 1
    }, EN);
    var zN, AN, BN, CN;
    var Lz = Okb(rzb, 'SizeConstraint', 150, IF, FN);
    var GN;
    hI(139, 17, {
        139: 1,
        3: 1,
        23: 1,
        17: 1
    }, NN);
    var IN, JN, KN, LN;
    var Mz = Okb(rzb, 'SizeOptions', 139, IF, ON);
    var PN;
    hI(62, 1, {
        62: 1
    }, UN, VN);
    _.t = function WN(a) {
        var b;
        if (a == null || !aw(a, 62)) return false;
        b = Wv(a, 62);
        return ovb(this.d, b.d) && ovb(this.e, b.e) && ovb(this.c, b.c) && ovb(this.b, b.b);
    };
    _.v = function XN() {
        return fpb(Bv(tv(UF, 1), syb, 1, 4, [
            this.d,
            this.e,
            this.c,
            this.b
        ]));
    };
    _.w = function YN() {
        return 'Rect[x=' + this.d + ',y=' + this.e + ',w=' + this.c + ',h=' + this.b + ']';
    };
    _.b = 0;
    _.c = 0;
    _.d = 0;
    _.e = 0;
    var Tz = Nkb(wzb, 'Rectangle', 62);
    hI(283, 62, {
        283: 1,
        62: 1
    }, ZN);
    _.a = 0;
    var Nz = Nkb(xzb, 'LabelGroup', 283);
    hI(67, 17, {
        67: 1,
        3: 1,
        23: 1,
        17: 1
    }, vO);
    var $N, _N, aO, bO, cO, dO, eO, fO, gO, hO, iO, jO, kO, lO, mO, nO, oO, pO, qO, rO, sO, tO;
    var Oz = Okb(xzb, 'LabelLocation', 67, IF, xO);
    hI(225, 17, {
        225: 1,
        3: 1,
        23: 1,
        17: 1
    }, EO);
    var AO, BO, CO;
    var Pz = Okb(xzb, 'TextAlignment', 225, IF, FO);
    var HO;
    hI(589, 1, {}, fP);
    _.a = 0;
    _.b = false;
    _.d = 0;
    _.f = 0;
    _.k = 0;
    _.r = 0;
    _.s = 0;
    var Qz = Nkb(wzb, 'LabelAndNodeSizeProcessor/NodeData', 589);
    hI(171, 17, {
        171: 1,
        3: 1,
        23: 1,
        17: 1
    }, lP);
    var gP, hP, iP, jP;
    var Rz = Okb(wzb, 'LabelSide', 171, IF, mP);
    hI(590, 1, {}, rP);
    _.b = true;
    _.c = true;
    _.d = true;
    _.e = true;
    var Sz = Nkb(wzb, zzb, 590);
    hI(121, 1, Bzb);
    _.t = function wP(a) {
        var b;
        if (aw(a, 121)) {
            b = Wv(a, 121);
            return this.d == b.d && this.a == b.a && this.b == b.b && this.c == b.c;
        } else return false;
    };
    _.v = function xP() {
        var a, b;
        a = hw(Ixb(this.b)) << 16;
        a |= hw(Ixb(this.a)) & byb;
        b = hw(Ixb(this.c)) << 16;
        b |= hw(Ixb(this.d)) & byb;
        return a ^ b;
    };
    _.w = function zP() {
        return '[top=' + this.d + ',left=' + this.b + ',bottom=' + this.a + ',right=' + this.c + ']';
    };
    _.a = 0;
    _.b = 0;
    _.c = 0;
    _.d = 0;
    var Wz = Nkb(wzb, 'Spacing', 121);
    hI(232, 121, Bzb, AP, BP, CP);
    var Uz = Nkb(wzb, 'Spacing/Insets', 232);
    hI(65, 121, {
        286: 1,
        121: 1,
        65: 1,
        3: 1,
        5: 1
    }, DP, EP, FP);
    var Vz = Nkb(wzb, 'Spacing/Margins', 65);
    hI(364, 1, {}, jQ);
    _.c = false;
    _.d = null;
    _.g = null;
    var OP, PP, QP;
    var Xz = Nkb(Ozb, 'JsonGraphImporter', 364);
    var kQ, lQ, mQ, nQ, oQ, pQ, qQ, rQ, sQ;
    hI(417, 14, lzb, xQ);
    var Yz = Nkb(Ozb, 'LayoutOptionResolver/DummyProperty', 417);
    hI(348, 1, {}, CQ);
    var yQ;
    var Zz = Nkb(Ozb, 'RecursiveLGraphLayout', 348);
    hI(73, 99, {
        73: 1,
        3: 1,
        54: 1,
        46: 1
    }, EQ, FQ, GQ);
    var $z = Nkb(Ozb, 'UnsupportedJsonGraphException', 73);
    hI(380, 1, {}, OQ);
    var HQ, IQ;
    var _z = Nkb(Szb, 'GraphConfigurator', 380);
    hI(49, 1, {}, WQ);
    var aA = Nkb(Szb, 'IntermediateProcessingConfiguration', 49);
    hI(365, 1, {}, dR);
    var bA = Nkb(Szb, 'KlayLayered', 365);
    hI(577, 1, {}, kR);
    _.i = 0;
    var eR;
    var eA = Nkb(Wzb, 'ComponentsToCGraphTransformer', 577);
    var UR;
    hI(578, 1, {}, lR);
    _.tc = function mR(a, b) {
        return Qlb(a.wc(), b.wc());
    };
    _.uc = function nR(a, b) {
        return Qlb(a.xc(), b.xc());
    };
    var cA = Nkb(Wzb, 'ComponentsToCGraphTransformer/1', 578);
    hI(25, 1, {
        25: 1
    });
    _.k = 0;
    _.o = null;
    _.p = true;
    _.r = Vzb;
    var kA = Nkb(Xzb, 'CNode', 25);
    hI(198, 25, {
        198: 1,
        25: 1
    }, pR, qR);
    _.vc = function rR() {
        this.b.d = this.j.d;
        this.b.e = this.j.e;
    };
    _.wc = function sR() {
        return this.a != null ? Ixb(this.a) : this.c.i;
    };
    _.xc = function tR() {
        return this.a != null ? Ixb(this.a) : this.c.i;
    };
    _.w = function uR() {
        return '';
    };
    var dA = Nkb(Wzb, 'ComponentsToCGraphTransformer/CRectNode', 198);
    hI(549, 1, {}, HR);
    var vR, wR;
    var hA = Nkb(Wzb, 'OneDimensionalComponentsCompaction', 549);
    hI(550, 1, Tyb, IR);
    _.B = function JR(a) {
        return xR(), xkb(), Wv(Wv(a, 27).a, 25).f.f != 0 ? wkb : vkb;
    };
    var fA = Nkb(Wzb, 'OneDimensionalComponentsCompaction/lambda$0$Type', 550);
    hI(551, 1, Tyb, KR);
    _.B = function LR(a) {
        return xR(), xkb(), uS(Wv(Wv(a, 27).a, 25).n, Wv(Wv(a, 27).b, 59)) || Wv(Wv(a, 27).a, 25).f.f != 0 && uS(Wv(Wv(a, 27).a, 25).n, Wv(Wv(a, 27).b, 59)) ? wkb : vkb;
    };
    var gA = Nkb(Wzb, 'OneDimensionalComponentsCompaction/lambda$1$Type', 551);
    hI(324, 1, {}, NR);
    var iA = Nkb(Xzb, 'CGraph', 324);
    hI(78, 1, {
        78: 1
    }, QR);
    _.b = 0;
    _.c = 0;
    _.d = 0;
    _.f = 0;
    _.i = true;
    _.j = Vzb;
    var jA = Nkb(Xzb, 'CGroup', 78);
    hI(470, 1, {}, WR);
    _.tc = function XR(a, b) {
        return Nlb(a.wc(), b.wc());
    };
    _.uc = function YR(a, b) {
        return Nlb(a.xc(), b.xc());
    };
    var lA = Nkb(Xzb, 'ISpacingsHandler/1', 470);
    hI(323, 1, {}, rS);
    _.e = false;
    var ZR, $R, _R;
    var nA = Nkb(Xzb, 'OneDimensionalCompactor', 323);
    hI(554, 1, Tyb, sS);
    _.B = function tS(a) {
        return aS(), xkb(), Wv(Wv(a, 27).a, 25).f.f != 0 ? wkb : vkb;
    };
    var mA = Nkb(Xzb, 'OneDimensionalCompactor/lambda$0$Type', 554);
    hI(335, 1, {}, xS);
    _.a = false;
    _.b = false;
    _.c = false;
    _.d = false;
    var oA = Nkb(Xzb, 'Quadruplet', 335);
    hI(587, 1, {}, yS);
    _.Cc = function zS(a) {
        var b, c, d, e, f, g, h, i, j, k, l, m, n, o1, p, q, r, s;
        k = Uzb;
        for(d = new Tob(a.a.b); d.a < d.c.c.length;){
            b = Wv(Rob(d), 25);
            k = Qlb(k, b.f.g.j.d + b.g.a);
        }
        q = new aJ;
        for(h = new Tob(a.a.a); h.a < h.c.c.length;){
            g = Wv(Rob(h), 78);
            g.j = k;
            g.f == 0 && TI(q, g, q.c.b, q.c);
        }
        while(q.b != 0){
            g = Wv(q.b == 0 ? null : (Bxb(q.b != 0), $I(q, q.a.a)), 78);
            e = g.g.j.d;
            for(n = (p = new Snb(g.a.a).a.bb().mb(), new Ynb(p)); n.a.G();){
                l = (f = Wv(n.a.H(), 21), Wv(f.yb(), 25));
                s = g.j + l.g.a;
                l.f.i || l.j.d < s ? l.r = s : l.r = l.j.d;
            }
            e -= g.g.r;
            g.b += e;
            a.d == (sK(), pK) || a.d == nK ? g.c += e : g.c -= e;
            for(m = (o1 = new Snb(g.a.a).a.bb().mb(), new Ynb(o1)); m.a.G();){
                l = (f = Wv(m.a.H(), 21), Wv(f.yb(), 25));
                for(j = l.i.mb(); j.G();){
                    i = Wv(j.H(), 25);
                    tK(a.d) ? r = a.g.tc(l, i) : r = a.g.uc(l, i);
                    i.f.j = Nlb(i.f.j, l.r + l.j.c + r - i.g.a);
                    i.p || (i.f.j = Nlb(i.f.j, i.j.d - i.g.a));
                    --i.f.f;
                    i.f.f == 0 && QI(q, i.f);
                }
            }
        }
        for(c = new Tob(a.a.b); c.a < c.c.c.length;){
            b = Wv(Rob(c), 25);
            b.j.d = b.r;
        }
    };
    var pA = Nkb(Zzb, 'LongestPathCompaction', 587);
    hI(588, 1, {}, AS);
    _.Dc = function BS(a) {
        var b, c, d, e, f, g, h;
        for(c = new Tob(a.a.b); c.a < c.c.c.length;){
            b = Wv(Rob(c), 25);
            b.i.Q();
        }
        for(e = new Tob(a.a.b); e.a < e.c.c.length;){
            d = Wv(Rob(e), 25);
            for(g = new Tob(a.a.b); g.a < g.c.c.length;){
                f = Wv(Rob(g), 25);
                if (d == f) continue;
                if (!!d.f && d.f == f.f) continue;
                tK(a.d) ? h = a.g.uc(d, f) : h = a.g.tc(d, f);
                d != f.o && (f.j.d > d.j.d || d.j.d == f.j.d && d.j.c < f.j.c) && SR(f.j.e + f.j.b + h, d.j.e) && TR(f.j.e, d.j.e + d.j.b + h) && d.i.ib(f);
            }
        }
    };
    var qA = Nkb(Zzb, 'QuadraticConstraintCalculation', 588);
    hI(317, 1, {}, FS);
    _.Dc = function GS(a) {
        this.b = a;
        ES(this, new RS, new TS);
    };
    var xA = Nkb(Zzb, 'ScanlineConstraintCalculator', 317);
    var JA = Pkb($zb, 'Scanline/EventHandler');
    hI(464, 1, {
        160: 1
    }, KS);
    _.Ec = function LS(a) {
        IS(this, Wv(a, 235));
    };
    var sA = Nkb(Zzb, 'ScanlineConstraintCalculator/ConstraintsScanlineHandler', 464);
    hI(465, 1, fyb, MS);
    _.$b = function NS(a, b) {
        return glb((Wv(a, 25).j.d + Wv(a, 25).j.c) / 2, (Wv(b, 25).j.d + Wv(b, 25).j.c) / 2);
    };
    var rA = Nkb(Zzb, 'ScanlineConstraintCalculator/ConstraintsScanlineHandler/lambda$0$Type', 465);
    hI(235, 1, {
        235: 1
    }, OS);
    _.a = false;
    var tA = Nkb(Zzb, 'ScanlineConstraintCalculator/Timestamp', 235);
    hI(466, 1, fyb, PS);
    _.$b = function QS(a, b) {
        return HS(a, b);
    };
    var uA = Nkb(Zzb, 'ScanlineConstraintCalculator/lambda$0$Type', 466);
    hI(467, 1, _zb, RS);
    _.D = function SS(a) {
        return true;
    };
    var vA = Nkb(Zzb, 'ScanlineConstraintCalculator/lambda$1$Type', 467);
    hI(468, 1, Tyb, TS);
    _.B = function US(a) {
        return 0;
    };
    var wA = Nkb(Zzb, 'ScanlineConstraintCalculator/lambda$2$Type', 468);
    hI(48, 1, {
        48: 1
    }, VS, WS);
    _.t = function XS(a) {
        var b;
        if (a == null) return false;
        if (zA != tb(a)) return false;
        b = Wv(a, 48);
        return ovb(this.c, b.c) && ovb(this.d, b.d);
    };
    _.v = function YS() {
        return fpb(Bv(tv(UF, 1), syb, 1, 4, [
            this.c,
            this.d
        ]));
    };
    _.w = function ZS() {
        return '(' + this.c + ', ' + this.d + (this.a ? 'cx' : '') + this.b + ')';
    };
    _.a = true;
    _.c = 0;
    _.d = 0;
    var zA = Nkb($zb, 'Point', 48);
    hI(201, 17, {
        201: 1,
        3: 1,
        23: 1,
        17: 1
    }, fT);
    var $S, _S, aT, bT;
    var yA = Okb($zb, 'Point/Quadrant', 201, IF, iT);
    hI(569, 1, {}, qT);
    _.b = null;
    _.c = null;
    _.d = null;
    _.e = null;
    _.f = null;
    var jT, kT, lT, mT, nT;
    var IA = Nkb($zb, 'RectilinearConvexHull', 569);
    hI(243, 1, {
        160: 1
    }, xT);
    _.Ec = function yT(a) {
        wT(this, Wv(a, 48));
    };
    _.b = 0;
    var uT;
    var BA = Nkb($zb, 'RectilinearConvexHull/MaximalElementsEventHandler', 243);
    hI(571, 1, fyb, AT);
    _.$b = function BT(a, b) {
        return zT(a, b);
    };
    var AA = Nkb($zb, 'RectilinearConvexHull/MaximalElementsEventHandler/lambda$0$Type', 571);
    hI(570, 1, {
        160: 1
    }, DT);
    _.Ec = function ET(a) {
        CT(this, Wv(a, 48));
    };
    _.a = 0;
    _.b = null;
    _.c = null;
    _.d = null;
    _.e = null;
    var CA = Nkb($zb, 'RectilinearConvexHull/RectangleEventHandler', 570);
    hI(572, 1, fyb, FT);
    _.$b = function GT(a, b) {
        return oT(), Wv(a, 48).c == Wv(b, 48).c ? glb(Wv(b, 48).d, Wv(a, 48).d) : glb(Wv(a, 48).c, Wv(b, 48).c);
    };
    var DA = Nkb($zb, 'RectilinearConvexHull/lambda$0$Type', 572);
    hI(573, 1, fyb, HT);
    _.$b = function IT(a, b) {
        return oT(), Wv(a, 48).c == Wv(b, 48).c ? glb(Wv(a, 48).d, Wv(b, 48).d) : glb(Wv(a, 48).c, Wv(b, 48).c);
    };
    var EA = Nkb($zb, 'RectilinearConvexHull/lambda$1$Type', 573);
    hI(574, 1, fyb, JT);
    _.$b = function KT(a, b) {
        return oT(), Wv(a, 48).c == Wv(b, 48).c ? glb(Wv(b, 48).d, Wv(a, 48).d) : glb(Wv(b, 48).c, Wv(a, 48).c);
    };
    var FA = Nkb($zb, 'RectilinearConvexHull/lambda$2$Type', 574);
    hI(575, 1, fyb, LT);
    _.$b = function MT(a, b) {
        return oT(), Wv(a, 48).c == Wv(b, 48).c ? glb(Wv(a, 48).d, Wv(b, 48).d) : glb(Wv(b, 48).c, Wv(a, 48).c);
    };
    var GA = Nkb($zb, 'RectilinearConvexHull/lambda$3$Type', 575);
    hI(576, 1, fyb, NT);
    _.$b = function OT(a, b) {
        return sT(a, b);
    };
    var HA = Nkb($zb, 'RectilinearConvexHull/lambda$4$Type', 576);
    hI(469, 1, {}, QT);
    var KA = Nkb($zb, 'Scanline', 469);
    hI(662, 1, {});
    var LA = Nkb(aAb, 'AbstractGraphPlacer', 662);
    hI(222, 1, {
        222: 1
    }, _T);
    var WT;
    var NA = Nkb(aAb, 'ComponentGroup', 222);
    hI(434, 662, {}, fU);
    _.Fc = function gU(a, b) {
        var c, d, e, f, g, h, i, j, k, l, m, n, o1;
        this.a.c = xv(UF, syb, 1, 0, 4, 1);
        b.b.c = xv(UF, syb, 1, 0, 4, 1);
        if (a.V()) {
            b.e.a = 0;
            b.e.b = 0;
            return;
        }
        f = Wv(a.sb(0), 55);
        qJ(b, f);
        for(e = a.mb(); e.G();){
            d = Wv(e.H(), 55);
            aU(this, d);
        }
        n = new FI;
        o1 = 2 * Wv(rJ(f, (Rib(), Jib)), 15).a;
        for(i = new Tob(this.a); i.a < i.c.c.length;){
            g = Wv(Rob(i), 222);
            j = bU(g, o1);
            VT(Jd(g.a), n.a, n.b);
            n.a += j.a;
            n.b += j.b;
        }
        b.e.a = n.a - o1;
        b.e.b = n.b - o1;
        if (Ckb(Ixb(Xv(rJ(f, (Mjb(), ijb))))) && gw(rJ(f, (eM(), uL))) === gw((NK(), JK))) {
            for(m = a.mb(); m.G();){
                k = Wv(m.H(), 55);
                UT(k, k.d.a, k.d.b);
            }
            c = new sU;
            iU(c, a, o1);
            for(l = a.mb(); l.G();){
                k = Wv(l.H(), 55);
                vI(BI(k.d), c.e);
            }
            vI(BI(b.e), c.a);
        }
        for(h = new Tob(this.a); h.a < h.c.c.length;){
            g = Wv(Rob(h), 222);
            TT(b, Jd(g.a));
        }
    };
    var MA = Nkb(aAb, 'ComponentGroupGraphPlacer', 434);
    hI(322, 1, {}, sU);
    var VA = Nkb(aAb, 'ComponentsCompactor', 322);
    hI(13, 647, bAb, GU, HU, IU);
    _.rb = function JU(a, b) {
        uU(this, a, b);
    };
    _.ib = function KU(a) {
        return vU(this, a);
    };
    _.jb = function LU(a) {
        return xU(this, a);
    };
    _.Q = function MU() {
        this.c = xv(UF, syb, 1, 0, 4, 1);
    };
    _.kb = function NU(a) {
        return zU(this, a, 0) != -1;
    };
    _.sb = function OU(a) {
        return yU(this, a);
    };
    _.V = function PU() {
        return this.c.length == 0;
    };
    _.mb = function QU() {
        return new Tob(this);
    };
    _.vb = function RU(a) {
        return AU(this, a);
    };
    _.nb = function SU(a) {
        return BU(this, a);
    };
    _.Xb = function TU(a, b) {
        CU(this, a, b);
    };
    _.wb = function UU(a, b) {
        return DU(this, a, b);
    };
    _.Y = function VU() {
        return this.c.length;
    };
    _.ob = function WU() {
        return EU(this);
    };
    _.pb = function XU(a) {
        return FU(this, a);
    };
    var BG = Nkb(Cyb, 'ArrayList', 13);
    hI(532, 13, bAb, $U);
    _.ib = function _U(a) {
        return ZU(this, Wv(a, 48));
    };
    var OA = Nkb(aAb, 'ComponentsCompactor/Hullpoints', 532);
    hI(529, 1, {
        347: 1
    }, bV);
    _.a = false;
    var PA = Nkb(aAb, 'ComponentsCompactor/InternalComponent', 529);
    hI(528, 1, Oyb, cV);
    _.mb = function dV() {
        return new Tob(this.a);
    };
    var QA = Nkb(aAb, 'ComponentsCompactor/InternalConnectedComponents', 528);
    hI(531, 1, {
        251: 1
    }, eV);
    _.zc = function gV() {
        return null;
    };
    _.Ac = function hV() {
        return this.a;
    };
    _.yc = function fV() {
        return oU(this.d);
    };
    _.Bc = function iV() {
        return this.b;
    };
    var RA = Nkb(aAb, 'ComponentsCompactor/InternalExternalExtension', 531);
    hI(530, 1, {
        251: 1
    }, jV);
    _.Ac = function mV() {
        return this.a;
    };
    _.yc = function kV() {
        return oU(this.d);
    };
    _.zc = function lV() {
        return this.c;
    };
    _.Bc = function nV() {
        return this.b;
    };
    var SA = Nkb(aAb, 'ComponentsCompactor/InternalUnionExternalExtension', 530);
    hI(534, 1, {}, oV);
    var TA = Nkb(aAb, 'ComponentsCompactor/OuterSegments', 534);
    hI(533, 1, {}, pV);
    var UA = Nkb(aAb, 'ComponentsCompactor/Segments', 533);
    hI(381, 1, {}, tV);
    var WA = Nkb(aAb, 'ComponentsProcessor', 381);
    hI(432, 662, {}, uV);
    _.Fc = function vV(a, b) {
        var c, d, e, f, g, h, i, j, k, l, m, n, o1, p, q, r, s, t, u, v, w, A;
        if (a.Y() == 1) {
            t = Wv(a.sb(0), 55);
            if (t != b) {
                b.b.c = xv(UF, syb, 1, 0, 4, 1);
                ST(b, t, 0, 0);
                qJ(b, t);
                YW(b.a, t.a);
                b.e.a = t.e.a;
                b.e.b = t.e.b;
            }
            return;
        } else if (a.V()) {
            b.b.c = xv(UF, syb, 1, 0, 4, 1);
            b.e.a = 0;
            b.e.b = 0;
            return;
        }
        for(h = a.mb(); h.G();){
            f = Wv(h.H(), 55);
            q = 0;
            for(o1 = new Tob(f.b); o1.a < o1.c.c.length;){
                n = Wv(Rob(o1), 9);
                q += Wv(rJ(n, (Rib(), Eib)), 24).a;
            }
            f.k = q;
        }
        Gpb(a, new xV);
        e = Wv(a.sb(0), 55);
        b.b.c = xv(UF, syb, 1, 0, 4, 1);
        qJ(b, e);
        m = 0;
        v = 0;
        for(i = a.mb(); i.G();){
            f = Wv(i.H(), 55);
            s = f.e;
            m = Nlb(m, s.a);
            v += s.a * s.b;
        }
        m = Nlb(m, Math.sqrt(v) * Wv(rJ(b, (Rib(), Rhb)), 15).a);
        u = cAb * Wv(rJ(b, Jib), 15).a;
        w = 0;
        A = 0;
        l = 0;
        c = u;
        for(g = a.mb(); g.G();){
            f = Wv(g.H(), 55);
            s = f.e;
            if (w + s.a > m) {
                w = 0;
                A += l + u;
                l = 0;
            }
            p = f.d;
            UT(f, w + p.a, A + p.b);
            p.a = 0;
            p.b = 0;
            c = Nlb(c, w + s.a);
            l = Nlb(l, s.b);
            w += s.a + u;
        }
        b.e.a = c;
        b.e.b = A + l;
        r = Wv(rJ(b, Jib), 15).a;
        if (Ckb(Ixb(Xv(rJ(e, (Mjb(), ijb)))))) {
            d = new sU;
            iU(d, a, r);
            for(k = a.mb(); k.G();){
                j = Wv(k.H(), 55);
                vI(BI(j.d), d.e);
            }
            vI(BI(b.e), d.a);
        }
        TT(b, a);
    };
    var YA = Nkb(aAb, 'SimpleRowGraphPlacer', 432);
    hI(433, 1, fyb, xV);
    _.$b = function yV(a, b) {
        return wV(Wv(a, 55), Wv(b, 55));
    };
    var XA = Nkb(aAb, 'SimpleRowGraphPlacer/1', 433);
    hI(369, 1, eAb, CV);
    _.sc = function DV(a, b) {
        BV(a, b);
    };
    var zV;
    var $A = Nkb(fAb, 'CompoundGraphPostprocessor', 369);
    hI(370, 1, _zb, EV);
    _.D = function FV(a) {
        var b;
        return b = Wv(rJ(Wv(a, 114).b, (eM(), CL)), 44), !!b && b.b != 0;
    };
    var ZA = Nkb(fAb, 'CompoundGraphPostprocessor/1', 370);
    hI(368, 1, eAb, SV);
    _.sc = function TV(a, b) {
        NV(this, a, b);
    };
    var aB = Nkb(fAb, 'CompoundGraphPreprocessor', 368);
    hI(187, 1, {
        187: 1
    }, UV);
    _.c = false;
    var _A = Nkb(fAb, 'CompoundGraphPreprocessor/ExternalPort', 187);
    hI(114, 1, {
        114: 1
    }, XV);
    _.w = function YV() {
        return zc(this.c) + ':' + gW(this.b);
    };
    var cB = Nkb(fAb, 'CrossHierarchyEdge', 114);
    hI(310, 1, fyb, $V);
    _.$b = function _V(a, b) {
        return ZV(this, Wv(a, 114), Wv(b, 114));
    };
    var bB = Nkb(fAb, 'CrossHierarchyEdgeComparator', 310);
    hI(147, 131, {
        179: 1,
        131: 1,
        147: 1,
        3: 1
    });
    _.k = 0;
    var lB = Nkb(hAb, 'LGraphElement', 147);
    hI(12, 147, {
        179: 1,
        131: 1,
        12: 1,
        147: 1,
        3: 1
    }, hW);
    _.w = function iW() {
        return gW(this);
    };
    var dB = Nkb(hAb, 'LEdge', 12);
    hI(55, 147, {
        179: 1,
        131: 1,
        55: 1,
        147: 1,
        3: 1,
        22: 1
    }, kW);
    _.mb = function lW() {
        return new Tob(this.c);
    };
    _.w = function mW() {
        if (this.c.c.length == 0) return 'G-unlayered' + Ze(this.b);
        else if (this.b.c.length == 0) return 'G-layered' + Ze(this.c);
        return 'G[layerless' + Ze(this.b) + ', layers' + Ze(this.c) + ']';
    };
    var mB = Nkb(hAb, 'LGraph', 55);
    hI(273, 1, {});
    _.pc = function rW() {
        return this.e.j;
    };
    var eB = Nkb(hAb, 'LGraphAdapters/AbstractLShapeAdapter', 273);
    hI(240, 1, {
        627: 1
    }, tW);
    _.b = null;
    var fB = Nkb(hAb, 'LGraphAdapters/LEdgeAdapter', 240);
    hI(325, 1, {}, wW);
    _.pc = function xW() {
        return this.a.e;
    };
    _.b = null;
    _.c = false;
    var gB = Nkb(hAb, 'LGraphAdapters/LGraphAdapter', 325);
    hI(224, 273, {
        129: 1,
        224: 1
    }, yW);
    var hB = Nkb(hAb, 'LGraphAdapters/LLabelAdapter', 224);
    hI(555, 273, {
        626: 1
    }, BW);
    _.a = null;
    _.b = null;
    _.c = false;
    var iB = Nkb(hAb, 'LGraphAdapters/LNodeAdapter', 555);
    hI(556, 273, {
        161: 1
    }, FW);
    _.a = null;
    _.b = null;
    _.c = null;
    _.d = false;
    var jB = Nkb(hAb, 'LGraphAdapters/LPortAdapter', 556);
    hI(557, 1, fyb, HW);
    _.$b = function IW(a, b) {
        return GW(Wv(a, 7), Wv(b, 7));
    };
    var kB = Nkb(hAb, 'LGraphAdapters/PortComparator', 557);
    hI(168, 1, {
        168: 1
    }, ZW, $W);
    _.t = function _W(a) {
        var b;
        if (aw(a, 168)) {
            b = Wv(a, 168);
            return this.d == b.d && this.a == b.a && this.b == b.b && this.c == b.c;
        } else return false;
    };
    _.v = function aX() {
        var a, b;
        a = hw(Ixb(this.b)) << 16;
        a |= hw(Ixb(this.a)) & byb;
        b = hw(Ixb(this.c)) << 16;
        b |= hw(Ixb(this.d)) & byb;
        return a ^ b;
    };
    _.w = function bX() {
        return 'Insets[top=' + this.d + ',left=' + this.b + ',bottom=' + this.a + ',right=' + this.c + ']';
    };
    _.a = 0;
    _.b = 0;
    _.c = 0;
    _.d = 0;
    var nB = Nkb(hAb, 'LInsets', 168);
    hI(165, 147, {
        179: 1,
        131: 1,
        147: 1,
        165: 1,
        3: 1
    });
    var CB = Nkb(hAb, 'LShape', 165);
    hI(33, 165, {
        179: 1,
        131: 1,
        147: 1,
        33: 1,
        165: 1,
        3: 1
    }, dX);
    _.w = function eX() {
        return this.a == null ? 'l_' + this.k : 'l_' + this.a;
    };
    var oB = Nkb(hAb, 'LLabel', 33);
    hI(9, 165, {
        179: 1,
        131: 1,
        147: 1,
        9: 1,
        165: 1,
        3: 1
    }, uX);
    _.w = function vX() {
        return tX(this);
    };
    var qB = Nkb(hAb, 'LNode', 9);
    hI(132, 17, {
        132: 1,
        3: 1,
        23: 1,
        17: 1
    }, DX);
    var wX, xX, yX, zX, AX, BX;
    var pB = Okb(hAb, 'LNode/NodeType', 132, IF, EX);
    hI(7, 165, {
        179: 1,
        131: 1,
        147: 1,
        7: 1,
        165: 1,
        3: 1
    }, RX);
    _.w = function SX() {
        var a;
        return a = OX(this), a == null ? 'p_' + this.k : 'p_' + a;
    };
    var FX, GX, HX, IX, JX, KX;
    var BB = Nkb(hAb, 'LPort', 7);
    hI(399, 1, _zb, UX);
    _.D = function VX(a) {
        return TX(a);
    };
    var rB = Nkb(hAb, 'LPort/1', 399);
    hI(400, 1, _zb, XX);
    _.D = function YX(a) {
        return WX(a);
    };
    var sB = Nkb(hAb, 'LPort/2', 400);
    hI(401, 1, _zb, ZX);
    _.D = function $X(a) {
        return Wv(a, 7).g == (sN(), $M);
    };
    var tB = Nkb(hAb, 'LPort/3', 401);
    hI(402, 1, _zb, _X);
    _.D = function aY(a) {
        return Wv(a, 7).g == (sN(), ZM);
    };
    var uB = Nkb(hAb, 'LPort/4', 402);
    hI(403, 1, _zb, bY);
    _.D = function cY(a) {
        return Wv(a, 7).g == (sN(), pN);
    };
    var vB = Nkb(hAb, 'LPort/5', 403);
    hI(404, 1, _zb, dY);
    _.D = function eY(a) {
        return Wv(a, 7).g == (sN(), rN);
    };
    var wB = Nkb(hAb, 'LPort/6', 404);
    hI(190, 1, Oyb, fY);
    _.mb = function gY() {
        var a;
        a = new Tob(this.a.b);
        return new hY(a);
    };
    var yB = Nkb(hAb, 'LPort/7', 190);
    hI(405, 1, Ayb, hY);
    _.H = function jY() {
        return Wv(Rob(this.a), 12).c;
    };
    _.G = function iY() {
        return Qob(this.a);
    };
    _.I = function kY() {
        Sob(this.a);
    };
    var xB = Nkb(hAb, 'LPort/7/1', 405);
    hI(169, 1, Oyb, lY);
    _.mb = function mY() {
        var a;
        return a = new Tob(this.a.e), new nY(a);
    };
    var AB = Nkb(hAb, 'LPort/8', 169);
    hI(304, 1, Ayb, nY);
    _.H = function pY() {
        return Wv(Rob(this.a), 12).d;
    };
    _.G = function oY() {
        return Qob(this.a);
    };
    _.I = function qY() {
        Sob(this.a);
    };
    var zB = Nkb(hAb, 'LPort/8/1', 304);
    hI(16, 147, {
        179: 1,
        131: 1,
        147: 1,
        16: 1,
        3: 1,
        22: 1
    }, sY);
    _.mb = function tY() {
        return new Tob(this.a);
    };
    _.w = function uY() {
        return 'L_' + zU(this.b.c, this, 0) + Ze(this.a);
    };
    var DB = Nkb(hAb, 'Layer', 16);
    hI(437, 1, eAb, wY);
    _.sc = function xY(a, b) {
        var c, d, e, f, g, h, i;
        nI(b, 'Big nodes intermediate-processing', 1);
        this.a = a;
        for(f = new Tob(this.a.c); f.a < f.c.c.length;){
            e = Wv(Rob(f), 16);
            i = Eo(e.a);
            c = pl(i, new zY);
            for(h = Pl(c.b.mb(), c.a); od(h);){
                g = Wv(pd(h), 9);
                if (gw(rJ(g, (Mjb(), vjb))) === gw((Xib(), Uib)) || gw(rJ(g, vjb)) === gw(Vib)) {
                    d = vY(this, g, false);
                    sJ(d, vjb, Wv(rJ(g, vjb), 85));
                    sJ(g, vjb, Wib);
                } else vY(this, g, true);
            }
        }
        pI(b);
    };
    var FB = Nkb(jAb, 'BigNodesIntermediateProcessor', 437);
    hI(438, 1, _zb, zY);
    _.D = function AY(a) {
        return yY(Wv(a, 9));
    };
    var EB = Nkb(jAb, 'BigNodesIntermediateProcessor/1', 438);
    hI(582, 1, Tyb, CY);
    _.B = function DY(a) {
        var b;
        return BY((b = this, iw(a), b));
    };
    var GB = Nkb(jAb, 'BigNodesLabelHandler/CompoundFunction', 582);
    hI(332, 1, {}, HY);
    _.a = 0;
    _.e = null;
    _.f = 0;
    var KB = Nkb(jAb, 'BigNodesLabelHandler/Handler', 332);
    hI(583, 1, Tyb, JY);
    _.B = function KY(a) {
        var b;
        return IY((b = this, iw(a), b));
    };
    var HB = Nkb(jAb, 'BigNodesLabelHandler/Handler/1', 583);
    hI(584, 1, Tyb, MY);
    _.B = function NY(a) {
        var b;
        return LY((b = this, iw(a), b));
    };
    var IB = Nkb(jAb, 'BigNodesLabelHandler/Handler/2', 584);
    hI(585, 1, Tyb, PY);
    _.B = function QY(a) {
        var b;
        return OY((b = this, iw(a), b));
    };
    var JB = Nkb(jAb, 'BigNodesLabelHandler/Handler/3', 585);
    hI(439, 1, eAb, SY);
    _.sc = function TY(a, b) {
        var c, d, e, f, g, h, i, j, k, l, m, n, o1, p;
        nI(b, 'Big nodes post-processing', 1);
        this.a = a;
        for(h = new Tob(this.a.c); h.a < h.c.c.length;){
            g = Wv(Rob(h), 16);
            c = pl(g.a, new VY);
            for(j = Pl(c.b.mb(), c.a); od(j);){
                i = Wv(pd(j), 9);
                l = Wv(rJ(i, (Rib(), Whb)), 15);
                f = RY(this, i);
                p = new GU;
                for(o1 = nX(f, (sN(), ZM)).mb(); o1.G();){
                    m = Wv(o1.H(), 7);
                    p.c[p.c.length] = m;
                    k = m.i.a - f.j.a;
                    m.i.a = l.a + k;
                }
                i.j.a = l.a;
                for(n = new Tob(p); n.a < n.c.c.length;){
                    m = Wv(Rob(n), 7);
                    PX(m, i);
                }
                this.a.e.a < i.i.a + i.j.a && (this.a.e.a = i.i.a + i.j.a);
                e = Wv(rJ(i, Thb), 20);
                xU(i.c, e);
                d = Wv(rJ(i, Uhb), 64);
                !!d && d.B(null);
            }
        }
        pI(b);
    };
    var MB = Nkb(jAb, 'BigNodesPostProcessor', 439);
    hI(440, 1, _zb, VY);
    _.D = function WY(a) {
        return UY(Wv(a, 9));
    };
    var LB = Nkb(jAb, 'BigNodesPostProcessor/1', 440);
    hI(441, 1, eAb, YY);
    _.sc = function ZY(a, b) {
        var c, d, e, f, g, h, i, j, k, l, m, n;
        nI(b, kAb, 1);
        this.c = a;
        l = this.c.b;
        e = 0;
        for(i = new Tob(l); i.a < i.c.c.length;){
            g = Wv(Rob(i), 9);
            g.k = e++;
        }
        this.d = Wv(rJ(this.c, (Rib(), Jib)), 15).a;
        this.a = Wv(rJ(this.c, (eM(), sL)), 59);
        this.b = l.c.length;
        f = lAb;
        for(j = new Tob(l); j.a < j.c.c.length;){
            g = Wv(Rob(j), 9);
            g.g == (CX(), AX) && g.j.a < f && (f = g.j.a);
        }
        f = 50 > f ? 50 : f;
        c = new GU;
        n = f + this.d;
        for(k = new Tob(l); k.a < k.c.c.length;){
            g = Wv(Rob(k), 9);
            if (g.g == (CX(), AX) && g.j.a > n) {
                m = 1;
                d = g.j.a;
                while(d > f){
                    ++m;
                    d = (g.j.a - (m - 1) * this.d) / m;
                }
                vU(c, new _Y(this, g, m, d));
            }
        }
        for(h = new Tob(c); h.a < h.c.c.length;){
            g = Wv(Rob(h), 267);
            XY(g.d) && $Y(g);
        }
        pI(b);
    };
    _.b = 0;
    _.d = 0;
    var OB = Nkb(jAb, 'BigNodesPreProcessor', 441);
    hI(267, 1, {
        267: 1
    }, _Y);
    _.a = 0;
    _.c = 0;
    var NB = Nkb(jAb, 'BigNodesPreProcessor/BigNode', 267);
    hI(442, 1, eAb, cZ);
    _.sc = function dZ(a, b) {
        var c, d, e, f, g, h, i, j, k, l, m, n, o1, p;
        nI(b, kAb, 1);
        aZ = Ckb(Ixb(Xv(rJ(a, (eM(), rL)))));
        this.c = a;
        n = new GU;
        for(g = new Tob(a.c); g.a < g.c.c.length;){
            f = Wv(Rob(g), 16);
            xU(n, f.a);
        }
        e = 0;
        for(k = new Tob(n); k.a < k.c.c.length;){
            i = Wv(Rob(k), 9);
            i.k = e++;
        }
        this.d = Wv(rJ(this.c, (Rib(), Jib)), 15).a;
        this.a = Wv(rJ(this.c, sL), 59);
        this.b = n.c.length;
        h = lAb;
        for(l = new Tob(n); l.a < l.c.c.length;){
            i = Wv(Rob(l), 9);
            i.g == (CX(), AX) && i.j.a < h && (h = i.j.a);
        }
        h = 50 > h ? 50 : h;
        c = new GU;
        p = h + this.d;
        for(m = new Tob(n); m.a < m.c.c.length;){
            i = Wv(Rob(m), 9);
            if (i.g == (CX(), AX) && i.j.a > p) {
                o1 = 1;
                d = i.j.a;
                while(d > h){
                    ++o1;
                    d = (i.j.a - (o1 - 1) * this.d) / o1;
                }
                vU(c, new nZ(this, i, o1));
            }
        }
        for(j = new Tob(c); j.a < j.c.c.length;){
            i = Wv(Rob(j), 268);
            bZ(i) && gZ(i);
        }
        pI(b);
    };
    _.b = 0;
    _.d = 0;
    var aZ = false;
    var QB = Nkb(jAb, 'BigNodesSplitter', 442);
    hI(268, 1, {
        268: 1
    }, nZ);
    _.a = 0;
    _.e = 4;
    var PB = Nkb(jAb, 'BigNodesSplitter/BigNode', 268);
    hI(443, 1, eAb, qZ);
    _.sc = function rZ(a, b) {
        var c, d, e, f, g, h, i, j;
        nI(b, 'Comment post-processing', 1);
        i = Wv(rJ(a, (Rib(), Jib)), 15).a;
        for(f = new Tob(a.c); f.a < f.c.c.length;){
            e = Wv(Rob(f), 16);
            d = new GU;
            for(h = new Tob(e.a); h.a < h.c.c.length;){
                g = Wv(Rob(h), 9);
                j = Wv(rJ(g, Qib), 20);
                c = Wv(rJ(g, Yhb), 20);
                if (!!j || !!c) {
                    pZ(g, j, c, i);
                    !!j && xU(d, j);
                    !!c && xU(d, c);
                }
            }
            xU(e.a, d);
        }
        pI(b);
    };
    var RB = Nkb(jAb, 'CommentPostprocessor', 443);
    hI(444, 1, eAb, tZ);
    _.sc = function uZ(a, b) {
        var c, d, e, f, g, h, i, j, k, l, m, n, o1, p, q;
        nI(b, 'Comment pre-processing', 1);
        h = new Tob(a.b);
        while(h.a < h.c.c.length){
            g = Wv(Rob(h), 9);
            if (Ckb(Ixb(Xv(rJ(g, (eM(), qL)))))) {
                d = 0;
                c = null;
                i = null;
                for(n = new Tob(g.f); n.a < n.c.c.length;){
                    l = Wv(Rob(n), 7);
                    d += l.b.c.length + l.e.c.length;
                    if (l.b.c.length == 1) {
                        c = Wv(yU(l.b, 0), 12);
                        i = c.c;
                    }
                    if (l.e.c.length == 1) {
                        c = Wv(yU(l.e, 0), 12);
                        i = c.d;
                    }
                }
                if (d == 1 && i.b.c.length + i.e.c.length == 1 && !Ckb(Ixb(Xv(rJ(i.f, qL))))) {
                    sZ(g, c, i, i.f);
                    Sob(h);
                } else {
                    q = new GU;
                    for(m = new Tob(g.f); m.a < m.c.c.length;){
                        l = Wv(Rob(m), 7);
                        for(k = new Tob(l.e); k.a < k.c.c.length;){
                            j = Wv(Rob(k), 12);
                            j.d.e.c.length == 0 || (q.c[q.c.length] = j);
                        }
                        for(f = new Tob(l.b); f.a < f.c.c.length;){
                            e = Wv(Rob(f), 12);
                            e.c.b.c.length == 0 || (q.c[q.c.length] = e);
                        }
                    }
                    for(p = new Tob(q); p.a < p.c.c.length;){
                        o1 = Wv(Rob(p), 12);
                        cW(o1, true);
                    }
                }
            }
        }
        pI(b);
    };
    var SB = Nkb(jAb, 'CommentPreprocessor', 444);
    hI(445, 1, eAb, wZ);
    _.sc = function xZ(a, b) {
        var c, d, e, f, g, h, i, j, k, l;
        nI(b, 'Edge and layer constraint edge reversal', 1);
        for(j = new Tob(a.b); j.a < j.c.c.length;){
            i = Wv(Rob(j), 9);
            g = Wv(rJ(i, (Mjb(), vjb)), 85);
            f = null;
            switch(g.e){
                case 1:
                case 2:
                    f = (Hgb(), Ggb);
                    break;
                case 3:
                case 4:
                    f = (Hgb(), Egb);
            }
            if (f) {
                sJ(i, (Rib(), dib), (Hgb(), Ggb));
                f == Egb ? vZ(i, g, (djb(), bjb)) : f == Ggb && vZ(i, g, (djb(), ajb));
            } else if (MM(Wv(rJ(i, (eM(), TL)), 28)) && i.f.c.length != 0) {
                c = true;
                for(l = new Tob(i.f); l.a < l.c.c.length;){
                    k = Wv(Rob(l), 7);
                    if (!(k.g == (sN(), ZM) && k.b.c.length - k.e.c.length > 0 || k.g == rN && k.b.c.length - k.e.c.length < 0)) {
                        c = false;
                        break;
                    }
                    if (k.g == rN) for(e = new Tob(k.e); e.a < e.c.c.length;){
                        d = Wv(Rob(e), 12);
                        h = Wv(rJ(d.d.f, vjb), 85);
                        if (h == (Xib(), Uib) || h == Vib) {
                            c = false;
                            break;
                        }
                    }
                    if (k.g == ZM) for(e = new Tob(k.b); e.a < e.c.c.length;){
                        d = Wv(Rob(e), 12);
                        h = Wv(rJ(d.c.f, vjb), 85);
                        if (h == (Xib(), Sib) || h == Tib) {
                            c = false;
                            break;
                        }
                    }
                }
                c && vZ(i, g, (djb(), cjb));
            }
        }
        pI(b);
    };
    var TB = Nkb(jAb, 'EdgeAndLayerConstraintEdgeReverser', 445);
    hI(446, 1, eAb, AZ);
    _.sc = function BZ(a, b) {
        var c, d, e, f, g, h, i, j, k, l;
        nI(b, 'End label placement', 1);
        g = Wv(rJ(a, (eM(), DL)), 15).a;
        this.a = (mp(), new ntb);
        this.c = new ntb;
        this.b = new ntb;
        for(i = new Tob(a.c); i.a < i.c.c.length;){
            h = Wv(Rob(i), 16);
            for(k = new Tob(h.a); k.a < k.c.c.length;){
                j = Wv(Rob(k), 9);
                for(d = Uh(mX(j)); Cm(d);){
                    c = Wv(Dm(d), 12);
                    for(f = new Tob(c.b); f.a < f.c.c.length;){
                        e = Wv(Rob(f), 33);
                        (gw(rJ(e, tL)) === gw((EK(), CK)) || gw(rJ(e, tL)) === gw(BK)) && (l = null, gw(rJ(e, tL)) === gw(CK) ? l = c.c : gw(rJ(e, tL)) === gw(BK) && (l = c.d), Qmb(this.a, l.f) || Umb(this.a, l.f, 0), Qmb(this.c, l.f) || Umb(this.c, l.f, 0), Qmb(this.b, l) || Umb(this.b, l, 0), gw(rJ(e, (Rib(), pib))) === gw((kP(), gP)) ? zZ(e, l, g) : yZ(e, l, g), undefined);
                    }
                }
            }
        }
        pI(b);
    };
    var UB = Nkb(jAb, 'EndLabelProcessor', 446);
    hI(269, 1, eAb, SZ);
    _.sc = function TZ(a, b) {
        var c, d, e, f, g;
        nI(b, 'Graph transformation (' + this.a + ')', 1);
        e = Ao(a.b);
        for(d = new Tob(a.c); d.a < d.c.c.length;){
            c = Wv(Rob(d), 16);
            xU(e, c.a);
        }
        switch(this.a.e){
            case 0:
                JZ(e, a);
                break;
            case 1:
                NZ(e);
                g = Wv(rJ(a, (Mjb(), ojb)), 115);
                !!g && sJ(a, ojb, Qgb(g));
                MZ(a.d);
                MZ(a.e);
                break;
            case 2:
                JZ(e, a);
                LZ(e, a);
                NZ(e);
                f = Wv(rJ(a, (Mjb(), ojb)), 115);
                !!f && sJ(a, ojb, Qgb(f));
                MZ(a.d);
                MZ(a.e);
        }
        pI(b);
    };
    var WB = Nkb(jAb, 'GraphTransformer', 269);
    hI(221, 17, {
        221: 1,
        3: 1,
        23: 1,
        17: 1
    }, YZ);
    var UZ, VZ, WZ;
    var VB = Okb(jAb, 'GraphTransformer/Mode', 221, IF, ZZ);
    hI(448, 1, eAb, d$);
    _.sc = function e$(a, b) {
        nI(b, 'Hierarchical port constraint processing', 1);
        a$(a);
        c$(a);
        pI(b);
    };
    var YB = Nkb(jAb, 'HierarchicalPortConstraintProcessor', 448);
    hI(449, 1, fyb, g$);
    _.$b = function h$(a, b) {
        return f$(Wv(a, 9), Wv(b, 9));
    };
    var XB = Nkb(jAb, 'HierarchicalPortConstraintProcessor/NodeComparator', 449);
    hI(450, 1, eAb, j$);
    _.sc = function k$(a, b) {
        var c, d, e, f, g, h, i, j, k, l;
        nI(b, 'Hierarchical port dummy size processing', 1);
        i = new GU;
        l = new GU;
        h = Wv(rJ(a, (Rib(), Jib)), 15).a;
        k = h * Wv(rJ(a, (Mjb(), qjb)), 15).a;
        c = k * 2;
        for(e = new Tob(a.c); e.a < e.c.c.length;){
            d = Wv(Rob(e), 16);
            i.c = xv(UF, syb, 1, 0, 4, 1);
            l.c = xv(UF, syb, 1, 0, 4, 1);
            for(g = new Tob(d.a); g.a < g.c.c.length;){
                f = Wv(Rob(g), 9);
                if (f.g == (CX(), xX)) {
                    j = Wv(rJ(f, hib), 32);
                    j == (sN(), $M) ? i.c[i.c.length] = f : j == pN && (l.c[l.c.length] = f);
                }
            }
            i$(i, true, c);
            i$(l, false, c);
        }
        pI(b);
    };
    var ZB = Nkb(jAb, 'HierarchicalPortDummySizeProcessor', 450);
    hI(451, 1, eAb, w$);
    _.sc = function x$(a, b) {
        var c, d, e, f;
        nI(b, 'Orthogonally routing hierarchical port edges', 1);
        this.a = 0;
        c = s$(a);
        v$(a, c);
        u$(this, a, c);
        q$(a);
        d = Wv(rJ(a, (eM(), TL)), 28);
        e = a.c;
        p$((Cxb(0, e.c.length), Wv(e.c[0], 16)), d, a);
        p$(Wv(yU(e, e.c.length - 1), 16), d, a);
        f = a.c;
        n$((Cxb(0, f.c.length), Wv(f.c[0], 16)));
        n$(Wv(yU(f, f.c.length - 1), 16));
        pI(b);
    };
    _.a = 0;
    var aC = Nkb(jAb, 'HierarchicalPortOrthogonalEdgeRouter', 451);
    hI(452, 1, fyb, z$);
    _.$b = function A$(a, b) {
        return y$(Wv(a, 9), Wv(b, 9));
    };
    var $B = Nkb(jAb, 'HierarchicalPortOrthogonalEdgeRouter/1', 452);
    hI(453, 1, fyb, C$);
    _.$b = function D$(a, b) {
        return B$(Wv(a, 9), Wv(b, 9));
    };
    var _B = Nkb(jAb, 'HierarchicalPortOrthogonalEdgeRouter/2', 453);
    hI(454, 1, eAb, F$);
    _.sc = function G$(a, b) {
        var c;
        nI(b, 'Hierarchical port position processing', 1);
        c = a.c;
        c.c.length > 0 && E$((Cxb(0, c.c.length), Wv(c.c[0], 16)), a);
        c.c.length > 1 && E$(Wv(yU(c, c.c.length - 1), 16), a);
        pI(b);
    };
    var bC = Nkb(jAb, 'HierarchicalPortPositionProcessor', 454);
    hI(471, 1, eAb, I$);
    _.sc = function J$(a, b) {
        var c, d, e, f, g, h, i, j, k, l, m, n, o1, p;
        nI(b, 'Hyperedge merging', 1);
        n = new Fnb(a.c, 0);
        while(n.b < n.d.Y()){
            m = (Bxb(n.b < n.d.Y()), Wv(n.d.sb(n.c = n.b++), 16));
            p = m.a;
            if (p.c.length == 0) continue;
            h = null;
            l = null;
            for(o1 = 0; o1 < p.c.length; o1++){
                c = (Cxb(o1, p.c.length), Wv(p.c[o1], 9));
                g = c.g;
                if (g == (CX(), zX) && l == zX) {
                    e = Wv(rJ(c, (Rib(), qib)), 7);
                    j = Wv(rJ(h, qib), 7);
                    f = Wv(rJ(c, rib), 7);
                    k = Wv(rJ(h, rib), 7);
                    d = !!e || !!f;
                    i = !!j || !!k;
                    if (d && i && (e == j || f == k)) {
                        H$(c, h, e == j, f == k);
                        Cxb(o1, p.c.length);
                        hxb(p.c, o1, 1);
                        --o1;
                        c = h;
                        g = l;
                    }
                }
                h = c;
                l = g;
            }
        }
        pI(b);
    };
    var cC = Nkb(jAb, 'HyperedgeDummyMerger', 471);
    hI(472, 1, eAb, L$);
    _.sc = function M$(a, b) {
        var c, d, e, f, g, h, i, j, k, l;
        nI(b, 'Hypernodes processing', 1);
        for(e = new Tob(a.c); e.a < e.c.c.length;){
            d = Wv(Rob(e), 16);
            for(h = new Tob(d.a); h.a < h.c.c.length;){
                g = Wv(Rob(h), 9);
                if (Ckb(Ixb(Xv(rJ(g, (eM(), AL))))) && g.f.c.length <= 2) {
                    l = 0;
                    k = 0;
                    c = 0;
                    f = 0;
                    for(j = new Tob(g.f); j.a < j.c.c.length;){
                        i = Wv(Rob(j), 7);
                        switch(i.g.e){
                            case 1:
                                ++l;
                                break;
                            case 2:
                                ++k;
                                break;
                            case 3:
                                ++c;
                                break;
                            case 4:
                                ++f;
                        }
                    }
                    l == 0 && c == 0 && K$(a, g, f <= k);
                }
            }
        }
        pI(b);
    };
    var dC = Nkb(jAb, 'HypernodesProcessor', 472);
    hI(473, 1, eAb, N$);
    _.sc = function O$(a, b) {
        var c, d, e, f, g, h, i, j, k;
        nI(b, 'Layer constraint edge reversal', 1);
        for(g = new Tob(a.c); g.a < g.c.c.length;){
            f = Wv(Rob(g), 16);
            k = -1;
            c = new GU;
            j = Wv(FU(f.a, xv(qB, Nzb, 9, f.a.c.length, 0, 1)), 51);
            for(e = 0; e < j.length; e++){
                d = Wv(rJ(j[e], (Rib(), mib)), 140);
                if (k == -1) d != (Hhb(), Ghb) && (k = e);
                else if (d == (Hhb(), Ghb)) {
                    rX(j[e], null);
                    qX(j[e], k++, f);
                }
                d == (Hhb(), Ehb) && vU(c, j[e]);
            }
            for(i = new Tob(c); i.a < i.c.c.length;){
                h = Wv(Rob(i), 9);
                rX(h, null);
                rX(h, f);
            }
        }
        pI(b);
    };
    var eC = Nkb(jAb, 'InLayerConstraintProcessor', 473);
    hI(474, 1, eAb, R$);
    _.sc = function W$(a, b) {
        var c, d, e, f, g, h;
        if (!Wv(rJ(a, (Rib(), jib)), 18).kb((ohb(), hhb))) return;
        for(h = new Tob(a.b); h.a < h.c.c.length;){
            f = Wv(Rob(h), 9);
            if (f.g == (CX(), AX)) {
                e = Wv(rJ(f, (eM(), GL)), 65);
                this.c = Qlb(this.c, f.i.a - e.b);
                this.a = Nlb(this.a, f.i.a + f.j.a + e.c);
                this.d = Qlb(this.d, f.i.b - e.d);
                this.b = Nlb(this.b, f.i.b + f.j.b + e.a);
            }
        }
        for(g = new Tob(a.b); g.a < g.c.c.length;){
            f = Wv(Rob(g), 9);
            if (f.g != (CX(), AX)) switch(f.g.e){
                case 2:
                    d = Wv(rJ(f, (Mjb(), vjb)), 85);
                    if (d == (Xib(), Tib)) {
                        f.i.a = this.c - 10;
                        Q$(f, new X$).A(new Z$(f));
                        break;
                    }
                    if (d == Vib) {
                        f.i.a = this.a + 10;
                        Q$(f, new _$).A(new b_(f));
                        break;
                    }
                    c = Wv(rJ(f, mib), 140);
                    if (c == (Hhb(), Ghb)) {
                        P$(f).A(new d_(f));
                        f.i.b = this.d - 10;
                        break;
                    }
                    if (c == Ehb) {
                        P$(f).A(new f_(f));
                        f.i.b = this.b + 10;
                        break;
                    }
                    break;
                default:
                    throw new slb('The node type ' + f.g + ' is not supported by the ' + lC);
            }
        }
    };
    _.a = Vzb;
    _.b = Vzb;
    _.c = Uzb;
    _.d = Uzb;
    var lC = Nkb(jAb, 'InteractiveExternalPortPositioner', 474);
    hI(475, 1, Tyb, X$);
    _.B = function Y$(a) {
        return Wv(a, 12).d.f;
    };
    var fC = Nkb(jAb, 'InteractiveExternalPortPositioner/lambda$0$Type', 475);
    hI(476, 1, Tyb, Z$);
    _.B = function $$(a) {
        return S$(this.a, a);
    };
    var gC = Nkb(jAb, 'InteractiveExternalPortPositioner/lambda$1$Type', 476);
    hI(477, 1, Tyb, _$);
    _.B = function a_(a) {
        return Wv(a, 12).c.f;
    };
    var hC = Nkb(jAb, 'InteractiveExternalPortPositioner/lambda$2$Type', 477);
    hI(478, 1, Tyb, b_);
    _.B = function c_(a) {
        return T$(this.a, a);
    };
    var iC = Nkb(jAb, 'InteractiveExternalPortPositioner/lambda$3$Type', 478);
    hI(479, 1, Tyb, d_);
    _.B = function e_(a) {
        return U$(this.a, a);
    };
    var jC = Nkb(jAb, 'InteractiveExternalPortPositioner/lambda$4$Type', 479);
    hI(480, 1, Tyb, f_);
    _.B = function g_(a) {
        return V$(this.a, a);
    };
    var kC = Nkb(jAb, 'InteractiveExternalPortPositioner/lambda$5$Type', 480);
    hI(37, 17, {
        37: 1,
        3: 1,
        23: 1,
        17: 1
    }, f0);
    var h_, i_, j_, k_, l_, m_, n_, o_, p_, q_, r_, s_, t_, u_, v_, w_, x_, y_, z_, A_, B_, C_, D_, E_, F_, G_, H_, I_, J_, K_, L_, M_, N_, O_, P_, Q_, R_, S_, T_, U_, V_, W_, X_, Y_, Z_, $_, __, a0, b0, c0;
    var mC = Okb(jAb, 'IntermediateProcessorStrategy', 37, IF, g0);
    hI(503, 1, eAb, k0);
    _.sc = function l0(a, b) {
        var c, d, e, f, g, h, i, j, k, l, m, n, o1, p, q, r, s;
        nI(b, 'Inverted port preprocessing', 1);
        j = a.c;
        i = new Fnb(j, 0);
        c = null;
        s = new GU;
        while(i.b < i.d.Y()){
            r = c;
            c = (Bxb(i.b < i.d.Y()), Wv(i.d.sb(i.c = i.b++), 16));
            for(m = new Tob(s); m.a < m.c.c.length;){
                k = Wv(Rob(m), 9);
                rX(k, r);
            }
            s.c = xv(UF, syb, 1, 0, 4, 1);
            for(n = new Tob(c.a); n.a < n.c.c.length;){
                k = Wv(Rob(n), 9);
                if (k.g != (CX(), AX)) continue;
                if (!MM(Wv(rJ(k, (eM(), TL)), 28))) continue;
                for(q = pX(k, (djb(), ajb), (sN(), ZM)).mb(); q.G();){
                    o1 = Wv(q.H(), 7);
                    h = o1.b;
                    g = Wv(FU(h, xv(dB, gAb, 12, h.c.length, 0, 1)), 47);
                    for(e = 0, f = g.length; e < f; ++e){
                        d = g[e];
                        h0(a, o1, d, s);
                    }
                }
                for(p = pX(k, bjb, rN).mb(); p.G();){
                    o1 = Wv(p.H(), 7);
                    h = o1.e;
                    g = Wv(FU(h, xv(dB, gAb, 12, h.c.length, 0, 1)), 47);
                    for(e = 0, f = g.length; e < f; ++e){
                        d = g[e];
                        i0(a, o1, d, s);
                    }
                }
            }
        }
        for(l = new Tob(s); l.a < l.c.c.length;){
            k = Wv(Rob(l), 9);
            rX(k, c);
        }
        pI(b);
    };
    var nC = Nkb(jAb, 'InvertedPortProcessor', 503);
    hI(481, 1, eAb, m0);
    _.sc = function n0(a, b) {
        nI(b, 'Node and Port Label Placement and Node Sizing', 1);
        GO((nW(), nW(), new wW(a, false)));
        pI(b);
    };
    var oC = Nkb(jAb, 'LabelAndNodeSizeProcessor', 481);
    hI(482, 1, eAb, q0);
    _.sc = function r0(a, b) {
        var c, d, e, f, g, h, i, j, k, l, m, n, o1, p, q, r, s, t;
        nI(b, 'Label dummy insertions', 1);
        m = new GU;
        k = Wv(rJ(a, (eM(), DL)), 15).a;
        l = Wv(rJ(a, sL), 59);
        for(o1 = new Tob(a.b); o1.a < o1.c.c.length;){
            n = Wv(Rob(o1), 9);
            for(q = new Tob(n.f); q.a < q.c.c.length;){
                p = Wv(Rob(q), 7);
                for(h = new Tob(p.e); h.a < h.c.c.length;){
                    g = Wv(Rob(h), 12);
                    if (g.c.f != g.d.f && ol(g.b, o0)) {
                        s = Do(g.b.c.length);
                        c = new uX(a);
                        sX(c, (CX(), yX));
                        sJ(c, (Rib(), uib), g);
                        sJ(c, Hib, s);
                        sJ(c, TL, (KM(), FM));
                        sJ(c, qib, g.c);
                        sJ(c, rib, g.d);
                        m.c[m.c.length] = c;
                        i1(g, c);
                        t = Wv(rJ(g, dM), 15).a;
                        if (t < 0) {
                            t = 0;
                            sJ(g, dM, new llb(t));
                        }
                        r = Math.floor(t / 2);
                        for(e = new Tob(c.f); e.a < e.c.c.length;){
                            d = Wv(Rob(e), 7);
                            d.i.b = r;
                        }
                        f = c.j;
                        i = new Fnb(g.b, 0);
                        while(i.b < i.d.Y()){
                            j = (Bxb(i.b < i.d.Y()), Wv(i.d.sb(i.c = i.b++), 33));
                            if (gw(rJ(j, tL)) === gw((EK(), AK))) {
                                if (l == (sK(), rK) || l == nK) {
                                    f.a += j.j.a + k;
                                    f.b = Nlb(f.b, j.j.b);
                                } else {
                                    f.a = Nlb(f.a, j.j.a);
                                    f.b += j.j.b + k;
                                }
                                s.c[s.c.length] = j;
                                vnb(i);
                            }
                        }
                        if (l == (sK(), rK) || l == nK) {
                            f.a -= k;
                            f.b += k + t;
                        } else f.b += k + t;
                    }
                }
            }
        }
        xU(a.b, m);
        pI(b);
    };
    var o0;
    var qC = Nkb(jAb, 'LabelDummyInserter', 482);
    hI(483, 1, _zb, s0);
    _.D = function t0(a) {
        return gw(rJ(Wv(a, 33), (eM(), tL))) === gw((EK(), AK));
    };
    var pC = Nkb(jAb, 'LabelDummyInserter/1', 483);
    hI(484, 1, eAb, w0);
    _.sc = function x0(a, b) {
        var c, d, e, f, g, h, i, j, k, l, m;
        nI(b, 'Label dummy removal', 1);
        e = Wv(rJ(a, (eM(), DL)), 15).a;
        h = Wv(rJ(a, sL), 59);
        for(g = new Tob(a.c); g.a < g.c.c.length;){
            f = Wv(Rob(g), 16);
            j = new Fnb(f.a, 0);
            while(j.b < j.d.Y()){
                i = (Bxb(j.b < j.d.Y()), Wv(j.d.sb(j.c = j.b++), 9));
                if (i.g == (CX(), yX)) {
                    k = Wv(rJ(i, (Rib(), uib)), 12);
                    m = Wv(rJ(k, dM), 15).a;
                    c = new II(i.i);
                    gw(rJ(i, pib)) === gw((kP(), hP)) && (c.b += m + e);
                    d = new HI(i.j.a, i.j.b - m - e);
                    l = Wv(rJ(i, Hib), 20);
                    h == (sK(), rK) || h == nK ? v0(l, c, e, d, gw(rJ(i, pib)) !== gw(gP)) : u0(l, c, e, d);
                    xU(k.b, l);
                    c1(i, false);
                    vnb(j);
                }
            }
        }
        pI(b);
    };
    var rC = Nkb(jAb, 'LabelDummyRemover', 484);
    hI(485, 1, eAb, A0);
    _.sc = function B0(a, b) {
        var c, d, e, f, g, h, i, j, k, l, m, n, o1, p, q, r, s;
        nI(b, 'Label dummy switching', 1);
        c = new GU;
        l = new GU;
        h = new GU;
        n = new GU;
        for(g = new Tob(a.c); g.a < g.c.c.length;){
            f = Wv(Rob(g), 16);
            for(k = new Tob(f.a); k.a < k.c.c.length;){
                j = Wv(Rob(k), 9);
                if (j.g == (CX(), yX)) {
                    c.c[c.c.length] = j;
                    h.c = xv(UF, syb, 1, 0, 4, 1);
                    n.c = xv(UF, syb, 1, 0, 4, 1);
                    p = j;
                    do {
                        p = Wv(Dm(Uh(iX(p))), 12).c.f;
                        p.g == zX && (h.c[h.c.length] = p);
                    }while (p.g == zX);
                    s = j;
                    do {
                        s = Wv(Dm(Uh(mX(s))), 12).d.f;
                        s.g == zX && (n.c[n.c.length] = s);
                    }while (s.g == zX);
                    i = h.c.length;
                    o1 = n.c.length;
                    if (i > o1 + 1) {
                        m = (i + o1) / 2 | 0;
                        vU(l, new RJ(j, (Cxb(m, h.c.length), Wv(h.c[m], 9))));
                    } else if (o1 > i + 1) {
                        m = ((o1 - i) / 2 | 0) - 1;
                        vU(l, new RJ(j, (Cxb(m, n.c.length), Wv(n.c[m], 9))));
                    }
                }
            }
        }
        for(r = new Tob(l); r.a < r.c.c.length;){
            q = Wv(Rob(r), 27);
            z0(Wv(q.a, 9), Wv(q.b, 9));
        }
        for(e = new Tob(c); e.a < e.c.c.length;){
            d = Wv(Rob(e), 9);
            y0(d, new C0, (Rib(), rib));
            y0(d, new E0, qib);
        }
        pI(b);
    };
    var uC = Nkb(jAb, 'LabelDummySwitcher', 485);
    hI(486, 1, Tyb, C0);
    _.B = function D0(a) {
        return Wv(Dm(Uh(iX(Wv(a, 9)))), 12).c.f;
    };
    var sC = Nkb(jAb, 'LabelDummySwitcher/lambda$0$Type', 486);
    hI(487, 1, Tyb, E0);
    _.B = function F0(a) {
        return Wv(Dm(Uh(mX(Wv(a, 9)))), 12).d.f;
    };
    var tC = Nkb(jAb, 'LabelDummySwitcher/lambda$1$Type', 487);
    hI(488, 1, eAb, G0);
    _.sc = function H0(a, b) {
        nI(b, 'Label management', 1);
        iw(rJ(a, (bK(), aK)));
        pI(b);
    };
    var vC = Nkb(jAb, 'LabelManagementProcessor', 488);
    hI(489, 1, eAb, S0);
    _.sc = function T0(a, b) {
        var c, d, e, f, g, h, i, j, k, l, m, n, o1, p;
        i = Wv(rJ(a, (Mjb(), ojb)), 115);
        nI(b, 'Label side selection (' + i + ')', 1);
        j = (_b(a), new Vh(a));
        switch(i.e){
            case 0:
                L0(j);
                break;
            case 1:
                K0(j);
                break;
            case 2:
                O0(j);
                break;
            case 3:
                N0(j);
                break;
            case 4:
                R0(j);
        }
        for(h = new Tob(a.c); h.a < h.c.c.length;){
            g = Wv(Rob(h), 16);
            for(d = new Tob(g.a); d.a < d.c.c.length;){
                c = Wv(Rob(d), 9);
                for(n = new Tob(c.f); n.a < n.c.c.length;){
                    l = Wv(Rob(n), 7);
                    for(f = new Tob(l.c); f.a < f.c.c.length;){
                        e = Wv(Rob(f), 33);
                        gw(rJ(e, (Rib(), pib))) === gw((kP(), jP)) && sJ(e, pib, I0);
                    }
                }
                if (c.g == (CX(), yX)) {
                    if (gw(rJ(c, (Rib(), pib))) === gw((kP(), gP))) {
                        k = Wv(rJ(c, uib), 12);
                        p = Wv(rJ(k, (eM(), dM)), 15).a;
                        o1 = c.j.b - Math.ceil(p / 2);
                        for(m = new Tob(c.f); m.a < m.c.c.length;){
                            l = Wv(Rob(m), 7);
                            l.i.b = o1;
                        }
                    }
                }
            }
        }
        pI(b);
    };
    var I0;
    var xC = Nkb(jAb, 'LabelSideSelector', 489);
    hI(490, 1, fyb, V0);
    _.$b = function W0(a, b) {
        return U0(Wv(a, 7), Wv(b, 7));
    };
    var wC = Nkb(jAb, 'LabelSideSelector/1', 490);
    hI(495, 1, eAb, Z0);
    _.sc = function $0(a, b) {
        var c, d, e, f, g, h, i, j, k, l, m, n, o1, p, q, r, s, t;
        nI(b, 'Layer constraint application', 1);
        j = a.c;
        if (j.c.length == 0) {
            pI(b);
            return;
        }
        f = (Cxb(0, j.c.length), Wv(j.c[0], 16));
        g = Wv(yU(j, j.c.length - 1), 16);
        s = new sY(a);
        t = new sY(a);
        for(i = new Tob(j); i.a < i.c.c.length;){
            h = Wv(Rob(i), 16);
            p = Wv(FU(h.a, xv(qB, Nzb, 9, h.a.c.length, 0, 1)), 51);
            for(m = 0, o1 = p.length; m < o1; ++m){
                l = p[m];
                c = Wv(rJ(l, (Mjb(), vjb)), 85);
                switch(c.e){
                    case 1:
                        rX(l, f);
                        X0(l, false);
                        break;
                    case 2:
                        rX(l, s);
                        X0(l, true);
                        break;
                    case 3:
                        rX(l, g);
                        Y0(l);
                        break;
                    case 4:
                        rX(l, t);
                        Y0(l);
                }
            }
        }
        if (j.c.length >= 2) {
            k = true;
            q = (Cxb(1, j.c.length), Wv(j.c[1], 16));
            for(n = new Tob(f.a); n.a < n.c.c.length;){
                l = Wv(Rob(n), 9);
                if (gw(rJ(l, (Mjb(), vjb))) === gw((Xib(), Wib))) {
                    k = false;
                    break;
                }
                for(e = Uh(mX(l)); Cm(e);){
                    d = Wv(Dm(e), 12);
                    if (d.d.f.d == q) {
                        k = false;
                        break;
                    }
                }
                if (!k) break;
            }
            if (k) {
                p = Wv(FU(f.a, xv(qB, Nzb, 9, f.a.c.length, 0, 1)), 51);
                for(m = 0, o1 = p.length; m < o1; ++m){
                    l = p[m];
                    rX(l, q);
                }
                BU(j, f);
            }
        }
        if (j.c.length >= 2) {
            k = true;
            r = Wv(yU(j, j.c.length - 2), 16);
            for(n = new Tob(g.a); n.a < n.c.c.length;){
                l = Wv(Rob(n), 9);
                if (gw(rJ(l, (Mjb(), vjb))) === gw((Xib(), Wib))) {
                    k = false;
                    break;
                }
                for(e = Uh(iX(l)); Cm(e);){
                    d = Wv(Dm(e), 12);
                    if (d.c.f.d == r) {
                        k = false;
                        break;
                    }
                }
                if (!k) break;
            }
            if (k) {
                p = Wv(FU(g.a, xv(qB, Nzb, 9, g.a.c.length, 0, 1)), 51);
                for(m = 0, o1 = p.length; m < o1; ++m){
                    l = p[m];
                    rX(l, r);
                }
                BU(j, g);
            }
        }
        j.c.length == 1 && (Cxb(0, j.c.length), Wv(j.c[0], 16)).a.c.length == 0 && AU(j, 0);
        s.a.c.length == 0 || (Fxb(0, j.c.length), fxb(j.c, 0, s));
        t.a.c.length == 0 || (j.c[j.c.length] = t);
        pI(b);
    };
    var yC = Nkb(jAb, 'LayerConstraintProcessor', 495);
    hI(496, 1, eAb, _0);
    _.sc = function a1(a, b) {
        var c, d, e, f, g, h, i, j, k, l, m, n, o1;
        nI(b, 'Layer size calculation', 1);
        j = rAb;
        i = 4.9E-324;
        for(g = new Tob(a.c); g.a < g.c.c.length;){
            f = Wv(Rob(g), 16);
            h = f.c;
            h.a = 0;
            h.b = 0;
            if (f.a.c.length == 0) continue;
            for(l = new Tob(f.a); l.a < l.c.c.length;){
                k = Wv(Rob(l), 9);
                n = k.j;
                m = k.e;
                h.a = Nlb(h.a, n.a + m.b + m.c);
            }
            d = Wv(yU(f.a, 0), 9);
            o1 = d.i.b - d.e.d;
            e = Wv(yU(f.a, f.a.c.length - 1), 9);
            c = e.i.b + e.j.b + e.e.a;
            h.b = c - o1;
            j = j < o1 ? j : o1;
            i = i > c ? i : c;
        }
        a.e.b = i - j;
        a.d.b -= j;
        pI(b);
    };
    var zC = Nkb(jAb, 'LayerSizeAndGraphHeightCalculator', 496);
    hI(497, 1, eAb, b1);
    _.sc = function d1(a, b) {
        var c, d, e, f, g;
        nI(b, 'Edge joining', 1);
        c = Ckb(Ixb(Xv(rJ(a, (Mjb(), gjb)))));
        for(e = new Tob(a.c); e.a < e.c.c.length;){
            d = Wv(Rob(e), 16);
            g = new Fnb(d.a, 0);
            while(g.b < g.d.Y()){
                f = (Bxb(g.b < g.d.Y()), Wv(g.d.sb(g.c = g.b++), 9));
                if (f.g == (CX(), zX)) {
                    c1(f, c);
                    vnb(g);
                }
            }
        }
        pI(b);
    };
    var AC = Nkb(jAb, 'LongEdgeJoiner', 497);
    hI(498, 1, eAb, e1);
    _.sc = function g1(a, b) {
        var c, d, e, f, g, h, i, j, k, l, m, n;
        nI(b, 'Edge splitting', 1);
        if (a.c.c.length <= 2) {
            pI(b);
            return;
        }
        f = new Fnb(a.c, 0);
        g = (Bxb(f.b < f.d.Y()), Wv(f.d.sb(f.c = f.b++), 16));
        while(f.b < f.d.Y()){
            e = g;
            g = (Bxb(f.b < f.d.Y()), Wv(f.d.sb(f.c = f.b++), 16));
            for(i = new Tob(e.a); i.a < i.c.c.length;){
                h = Wv(Rob(i), 9);
                for(k = new Tob(h.f); k.a < k.c.c.length;){
                    j = Wv(Rob(k), 7);
                    for(d = new Tob(j.e); d.a < d.c.c.length;){
                        c = Wv(Rob(d), 12);
                        m = c.d;
                        l = m.f.d;
                        l != e && l != g && i1(c, (n = new uX(a), sX(n, (CX(), zX)), sJ(n, (Rib(), uib), c), sJ(n, (eM(), TL), (KM(), FM)), rX(n, g), n));
                    }
                }
            }
        }
        pI(b);
    };
    var BC = Nkb(jAb, 'LongEdgeSplitter', 498);
    hI(499, 1, eAb, k1);
    _.sc = function l1(a, b) {
        var c, d, e, f, g, h, i, j;
        nI(b, 'Node margin calculation', 1);
        c = new rP((nW(), new wW(a, true)));
        oP(c);
        h = Wv(rJ(a, (Rib(), Jib)), 15).a;
        for(e = new Tob(a.c); e.a < e.c.c.length;){
            d = Wv(Rob(e), 16);
            for(g = new Tob(d.a); g.a < g.c.c.length;){
                f = Wv(Rob(g), 9);
                j1(f, h);
                i = f.e;
                j = Wv(rJ(f, Oib), 65);
                i.b = Nlb(i.b, j.b);
                i.c = Nlb(i.c, j.c);
                i.a = Nlb(i.a, j.a);
                i.d = Nlb(i.d, j.d);
            }
        }
        pI(b);
    };
    var CC = Nkb(jAb, zzb, 499);
    hI(491, 1, eAb, q1);
    _.sc = function t1(a, b) {
        var c, d, e, f, g, h, i, j, k, l;
        nI(b, 'Node promotion heuristic', 1);
        this.g = a;
        m1(this);
        this.q = Wv(rJ(a, (Mjb(), Bjb)), 109);
        j = Wv(rJ(this.g, Cjb), 24).a;
        e = new u1;
        switch(this.q.e){
            case 2:
            case 1:
                o1(this, e);
                break;
            case 3:
                this.q = (I1(), H1);
                o1(this, e);
                h = 0;
                for(g = new Tob(this.a); g.a < g.c.c.length;){
                    f = Wv(Rob(g), 24);
                    h = Plb(h, f.a);
                }
                if (h > this.j) {
                    this.q = B1;
                    o1(this, e);
                }
                break;
            case 4:
                this.q = (I1(), H1);
                o1(this, e);
                i = 0;
                for(d = new Tob(this.b); d.a < d.c.c.length;){
                    c = Yv(Rob(d));
                    i = Nlb(i, (Dxb(c), c));
                }
                if (i > this.k) {
                    this.q = E1;
                    o1(this, e);
                }
                break;
            case 6:
                l = hw(Llb(this.f.length * j / 100));
                o1(this, new w1(l));
                break;
            case 5:
                k = hw(Llb(this.d * j / 100));
                o1(this, new y1(k));
                break;
            default:
                o1(this, e);
        }
        p1(this, a);
        pI(b);
    };
    _.d = 0;
    _.e = 0;
    _.i = 0;
    _.j = 0;
    _.k = 0;
    _.n = 0;
    var HC = Nkb(jAb, 'NodePromotion', 491);
    hI(492, 1, Tyb, u1);
    _.B = function v1(a) {
        return xkb(), xkb(), wkb;
    };
    var DC = Nkb(jAb, 'NodePromotion/lambda$0$Type', 492);
    hI(493, 1, Tyb, w1);
    _.B = function x1(a) {
        return r1(this.a, a);
    };
    _.a = 0;
    var EC = Nkb(jAb, 'NodePromotion/lambda$1$Type', 493);
    hI(494, 1, Tyb, y1);
    _.B = function z1(a) {
        return s1(this.a, a);
    };
    _.a = 0;
    var FC = Nkb(jAb, 'NodePromotion/lambda$2$Type', 494);
    hI(109, 17, {
        109: 1,
        3: 1,
        23: 1,
        17: 1
    }, J1);
    var A1, B1, C1, D1, E1, F1, G1, H1;
    var GC = Okb(jAb, 'NodePromotionStrategy', 109, IF, K1);
    var L1;
    hI(500, 1, eAb, R1);
    _.sc = function S1(a, b) {
        var c, d, e, f, g, h, i, j, k, l, m, n, o1, p, q, r, s, t, u;
        nI(b, sAb, 1);
        n = Wv(rJ(a, (eM(), uL)), 122);
        for(e = new Tob(a.c); e.a < e.c.c.length;){
            d = Wv(Rob(e), 16);
            i = Wv(FU(d.a, xv(qB, Nzb, 9, d.a.c.length, 0, 1)), 51);
            for(g = 0, h = i.length; g < h; ++g){
                f = i[g];
                if (f.g != (CX(), BX)) continue;
                if (n == (NK(), LK)) for(k = new Tob(f.f); k.a < k.c.c.length;){
                    j = Wv(Rob(k), 7);
                    j.b.c.length == 0 || P1(j);
                    j.e.c.length == 0 || Q1(j);
                }
                else if (aw(rJ(f, (Rib(), uib)), 12)) {
                    p = Wv(rJ(f, uib), 12);
                    q = Wv(nX(f, (sN(), rN)).mb().H(), 7);
                    r = Wv(nX(f, ZM).mb().H(), 7);
                    s = Wv(rJ(q, uib), 7);
                    t = Wv(rJ(r, uib), 7);
                    dW(p, t);
                    eW(p, s);
                    u = new II(r.f.i);
                    u.a = MI(Bv(tv(qz, 1), Fzb, 10, 0, [
                        t.f.i,
                        t.i,
                        t.a
                    ])).a;
                    QI(p.a, u);
                    u = new II(q.f.i);
                    u.a = MI(Bv(tv(qz, 1), Fzb, 10, 0, [
                        s.f.i,
                        s.i,
                        s.a
                    ])).a;
                    QI(p.a, u);
                } else {
                    if (f.f.c.length >= 2) {
                        o1 = true;
                        l = new Tob(f.f);
                        c = Wv(Rob(l), 7);
                        while(l.a < l.c.c.length){
                            m = c;
                            c = Wv(Rob(l), 7);
                            if (!rb(rJ(m, uib), rJ(c, uib))) {
                                o1 = false;
                                break;
                            }
                        }
                    } else o1 = false;
                    for(k = new Tob(f.f); k.a < k.c.c.length;){
                        j = Wv(Rob(k), 7);
                        j.b.c.length == 0 || N1(j, o1);
                        j.e.c.length == 0 || O1(j, o1);
                    }
                }
                rX(f, null);
            }
        }
        pI(b);
    };
    var IC = Nkb(jAb, 'NorthSouthPortPostprocessor', 500);
    hI(501, 1, eAb, X1);
    _.sc = function Y1(a, b) {
        var c, d, e, f, g, h, i, j, k, l, m, n, o1, p, q, r, s, t, u;
        nI(b, sAb, 1);
        o1 = new GU;
        u = new GU;
        for(j = new Tob(a.c); j.a < j.c.c.length;){
            i = Wv(Rob(j), 16);
            q = -1;
            n = Wv(FU(i.a, xv(qB, Nzb, 9, i.a.c.length, 0, 1)), 51);
            for(l = 0, m = n.length; l < m; ++l){
                k = n[l];
                ++q;
                if (!(k.g == (CX(), AX) && MM(Wv(rJ(k, (eM(), TL)), 28)))) continue;
                LM(Wv(rJ(k, (eM(), TL)), 28)) || W1(k);
                sJ(k, (Rib(), nib), k);
                o1.c = xv(UF, syb, 1, 0, 4, 1);
                u.c = xv(UF, syb, 1, 0, 4, 1);
                c = new GU;
                t = new aJ;
                ml(t, nX(k, (sN(), $M)));
                U1(a, t, o1, u, c);
                h = q;
                for(f = new Tob(o1); f.a < f.c.c.length;){
                    d = Wv(Rob(f), 9);
                    qX(d, h, i);
                    ++q;
                    sJ(d, nib, k);
                    g = Wv(yU(d.f, 0), 7);
                    p = Wv(rJ(g, uib), 7);
                    Ckb(Ixb(Xv(rJ(p, (Mjb(), Djb))))) || Wv(rJ(d, oib), 20).ib(k);
                }
                _I(t);
                for(s = nX(k, pN).mb(); s.G();){
                    r = Wv(s.H(), 7);
                    TI(t, r, t.a, t.a.a);
                }
                U1(a, t, u, null, c);
                for(e = new Tob(u); e.a < e.c.c.length;){
                    d = Wv(Rob(e), 9);
                    qX(d, ++q, i);
                    sJ(d, nib, k);
                    g = Wv(yU(d.f, 0), 7);
                    p = Wv(rJ(g, uib), 7);
                    Ckb(Ixb(Xv(rJ(p, (Mjb(), Djb))))) || Wv(rJ(k, oib), 20).ib(d);
                }
                c.c.length == 0 || sJ(k, Shb, c);
            }
        }
        pI(b);
    };
    var KC = Nkb(jAb, 'NorthSouthPortPreprocessor', 501);
    hI(502, 1, fyb, Z1);
    _.$b = function $1(a, b) {
        var c, d;
        return c = a.g, d = b.g, c != d ? c.e - d.e : a.k == b.k ? 0 : c == (sN(), $M) ? a.k - b.k : b.k - a.k;
    };
    var JC = Nkb(jAb, 'NorthSouthPortPreprocessor/lambda$0$Type', 502);
    hI(504, 1, eAb, _1);
    _.sc = function a2(a, b) {
        var c, d, e, f, g, h;
        nI(b, 'Removing partition constraint edges', 1);
        for(d = new Tob(a.c); d.a < d.c.c.length;){
            c = Wv(Rob(d), 16);
            for(f = new Tob(c.a); f.a < f.c.c.length;){
                e = Wv(Rob(f), 9);
                h = new Tob(e.f);
                while(h.a < h.c.c.length){
                    g = Wv(Rob(h), 7);
                    Ckb(Ixb(Xv(rJ(g, (Rib(), Aib))))) && Sob(h);
                }
            }
        }
        pI(b);
    };
    var LC = Nkb(jAb, 'PartitionPostprocessor', 504);
    hI(505, 1, eAb, c2);
    _.sc = function d2(a, b) {
        var c, d, e, f, g, h, i, j, k, l;
        nI(b, 'Adding partition constraint edges', 1);
        this.a = new GU;
        for(h = new Tob(a.b); h.a < h.c.c.length;){
            f = Wv(Rob(h), 9);
            e = Wv(rJ(f, (eM(), ML)), 24);
            b2(this, e.a).ib(f);
        }
        for(d = 0; d < this.a.c.length - 1; d++)for(g = Wv(yU(this.a, d), 20).mb(); g.G();){
            f = Wv(g.H(), 9);
            k = new RX;
            PX(k, f);
            QX(k, (sN(), ZM));
            sJ(k, (Rib(), Aib), (xkb(), xkb(), wkb));
            for(j = Wv(yU(this.a, d + 1), 20).mb(); j.G();){
                i = Wv(j.H(), 9);
                l = new RX;
                PX(l, i);
                QX(l, rN);
                sJ(l, Aib, wkb);
                c = new hW;
                sJ(c, Aib, wkb);
                sJ(c, (eM(), ZL), Elb(20));
                dW(c, k);
                eW(c, l);
            }
        }
        this.a = null;
        pI(b);
    };
    var MC = Nkb(jAb, 'PartitionPreprocessor', 505);
    hI(506, 1, eAb, f2);
    _.sc = function g2(a, b) {
        var c, d, e, f, g, h, i, j, k, l, m, n, o1, p;
        nI(b, 'Port distribution', 1);
        c = jW(a);
        n = 0;
        k = 0;
        for(e = 0, g = c.length; e < g; ++e){
            d = c[e];
            for(i = 0, j = d.length; i < j; ++i){
                h = d[i];
                h.k = k++;
                for(m = new Tob(h.f); m.a < m.c.c.length;){
                    l = Wv(Rob(m), 7);
                    l.k = n++;
                }
            }
        }
        for(f = new Tob(a.c); f.a < f.c.c.length;){
            d = Wv(Rob(f), 16);
            e2(d);
        }
        p = Wv(rJ(a, (Rib(), Gib)), 154);
        o1 = wvb(p, 1) != 0 ? new P9(xv(lw, tAb, 26, n, 12, 1)) : new M9(xv(lw, tAb, 26, n, 12, 1));
        Z8(o1, c);
        pI(b);
    };
    var NC = Nkb(jAb, 'PortDistributionProcessor', 506);
    hI(507, 1, eAb, h2);
    _.sc = function i2(a, b) {
        var c, d, e, f, g;
        nI(b, 'Port order processing', 1);
        g = new k2;
        for(d = new Tob(a.c); d.a < d.c.c.length;){
            c = Wv(Rob(d), 16);
            for(f = new Tob(c.a); f.a < f.c.c.length;){
                e = Wv(Rob(f), 9);
                MM(Wv(rJ(e, (eM(), TL)), 28)) && Gpb(e.f, g);
            }
        }
        pI(b);
    };
    var PC = Nkb(jAb, 'PortListSorter', 507);
    hI(508, 1, fyb, k2);
    _.$b = function l2(a, b) {
        return j2(Wv(a, 7), Wv(b, 7));
    };
    var OC = Nkb(jAb, 'PortListSorter/PortComparator', 508);
    hI(509, 1, eAb, n2);
    _.sc = function o2(a, b) {
        var c, d, e, f, g;
        nI(b, 'Port side processing', 1);
        for(g = new Tob(a.b); g.a < g.c.c.length;){
            e = Wv(Rob(g), 9);
            m2(e);
        }
        for(d = new Tob(a.c); d.a < d.c.c.length;){
            c = Wv(Rob(d), 16);
            for(f = new Tob(c.a); f.a < f.c.c.length;){
                e = Wv(Rob(f), 9);
                m2(e);
            }
        }
        pI(b);
    };
    var QC = Nkb(jAb, 'PortSideProcessor', 509);
    hI(510, 1, eAb, q2);
    _.sc = function r2(a, b) {
        var c, d, e, f, g, h, i, j, k, l;
        nI(b, 'Restoring reversed edges', 1);
        for(h = new Tob(a.c); h.a < h.c.c.length;){
            g = Wv(Rob(h), 16);
            for(j = new Tob(g.a); j.a < j.c.c.length;){
                i = Wv(Rob(j), 9);
                for(l = new Tob(i.f); l.a < l.c.c.length;){
                    k = Wv(Rob(l), 7);
                    f = Wv(FU(k.e, xv(dB, gAb, 12, k.e.c.length, 0, 1)), 47);
                    for(d = 0, e = f.length; d < e; ++d){
                        c = f[d];
                        Ckb(Ixb(Xv(rJ(c, (Rib(), Iib))))) && cW(c, false);
                    }
                }
            }
        }
        pI(b);
    };
    var RC = Nkb(jAb, 'ReversedEdgeRestorer', 510);
    hI(511, 1, eAb, x2);
    _.sc = function y2(a, b) {
        var c, d, e, f, g, h, i, j, k, l, m, n, o1, p, q, r, s, t, u, v, w, A, B, C, D, F, G, H, I, J;
        nI(b, 'Sausage Folding', 1);
        this.b = Wv(rJ(a, (Rib(), Jib)), 15).a;
        this.a = this.b * Wv(rJ(a, (Mjb(), Ejb)), 15).a;
        o1 = t2(this, a);
        n = a.c.c.length;
        p = u2(this, a);
        G = n * p;
        e = Wv(rJ(a, (eM(), sL)), 59);
        e == (sK(), oK) || e == pK || e == qK ? d = Wv(rJ(a, Rhb), 15).a : d = 1 / Wv(rJ(a, Rhb), 15).a;
        c = G / o1;
        if (d > c) {
            pI(b);
            return;
        }
        D = 0;
        f = rAb;
        do {
            ++D;
            c = G / D / (o1 * D);
            m = f;
            f = c - d <= 0 ? 0 - (c - d) : c - d;
        }while (c > d);
        m < f && --D;
        B = n / (1 > D ? 1 : D) | 0;
        j = B;
        u = B;
        J = true;
        while(j < n){
            l = Wv(yU(a.c, j), 16);
            C = true;
            s = null;
            t = null;
            K: for(I = new Tob(l.a); I.a < I.c.c.length;){
                H = Wv(Rob(I), 9);
                for(h = Uh(iX(H)); Cm(h);){
                    g = Wv(Dm(h), 12);
                    if (!!s && s != H) {
                        C = false;
                        break K;
                    }
                    s = H;
                    F = g.c.f;
                    if (!!t && t != F) {
                        C = false;
                        break K;
                    }
                    t = F;
                }
            }
            if (J && C) {
                u = 0;
                J = false;
            }
            if (j != u) {
                v = Wv(yU(a.c, u), 16);
                for(r = new Tob(Ao(l.a)); r.a < r.c.c.length;){
                    q = Wv(Rob(r), 9);
                    qX(q, v.a.c.length, v);
                    if (u == 0) for(h = new Tob(Ao(iX(q))); h.a < h.c.c.length;){
                        g = Wv(Rob(h), 12);
                        cW(g, true);
                        sJ(a, cib, (xkb(), xkb(), wkb));
                        v2(a, g);
                        i = new GU;
                        s2(a, g.c, g, i);
                        for(A = new Tob(i); A.a < A.c.c.length;){
                            w = Wv(Rob(A), 9);
                            qX(w, v.a.c.length - 1, v);
                        }
                    }
                }
            }
            u >= B && (J = true);
            ++u;
            ++j;
        }
        k = new Fnb(a.c, 0);
        while(k.b < k.d.Y()){
            l = (Bxb(k.b < k.d.Y()), Wv(k.d.sb(k.c = k.b++), 16));
            l.a.c.length == 0 && vnb(k);
        }
        pI(b);
    };
    _.a = 0;
    _.b = 0;
    var SC = Nkb(jAb, 'SausageFolding', 511);
    hI(512, 1, eAb, A2);
    _.sc = function B2(a, b) {
        var c, d, e, f, g, h, i, j, k, l, m, n, o1, p, q, r, s;
        nI(b, 'Self-loop processing', 1);
        c = new GU;
        for(k = new Tob(a.c); k.a < k.c.c.length;){
            j = Wv(Rob(k), 16);
            c.c = xv(UF, syb, 1, 0, 4, 1);
            for(m = new Tob(j.a); m.a < m.c.c.length;){
                l = Wv(Rob(m), 9);
                for(o1 = new Tob(l.f); o1.a < o1.c.c.length;){
                    n = Wv(Rob(o1), 7);
                    i = Wv(FU(n.e, xv(dB, gAb, 12, n.e.c.length, 0, 1)), 47);
                    for(g = 0, h = i.length; g < h; ++g){
                        f = i[g];
                        if (f.c.f != f.d.f) continue;
                        p = f.c;
                        r = f.d;
                        q = p.g;
                        s = r.g;
                        (q == (sN(), $M) || q == pN) && s == rN ? cW(f, false) : q == pN && s == $M ? cW(f, false) : q == ZM && s != ZM && cW(f, false);
                        q == ZM && s == rN ? vU(c, z2(a, f, r, p)) : q == rN && s == ZM && vU(c, z2(a, f, p, r));
                    }
                }
            }
            for(e = new Tob(c); e.a < e.c.c.length;){
                d = Wv(Rob(e), 9);
                rX(d, j);
            }
        }
        pI(b);
    };
    var TC = Nkb(jAb, 'SelfLoopProcessor', 512);
    hI(513, 1, eAb, H2);
    _.sc = function I2(a, b) {
        var c, d, e, f, g, h, i, j, k, l, m, n, o1;
        nI(b, 'Spline SelfLoop positioning', 1);
        k = Wv(rJ(a, (Mjb(), Jjb)), 153);
        for(j = new Tob(a.c); j.a < j.c.c.length;){
            i = Wv(Rob(j), 16);
            for(m = new Tob(i.a); m.a < m.c.c.length;){
                l = Wv(Rob(m), 9);
                g = Wv(rJ(l, (Rib(), Nib)), 20);
                h = new GU;
                for(e = g.mb(); e.G();){
                    c = Wv(e.H(), 75);
                    ceb(c);
                    if ((n = pr(c.g), Ue(n, c.i), n).a.Y() == 0) h.c[h.c.length] = c;
                    else {
                        G2(c);
                        c.g.a.Y() == 0 || C2(c);
                    }
                }
                switch(k.e){
                    case 0:
                        o1 = new Q2(l);
                        P2(o1);
                        N2(o1, h);
                        break;
                    case 2:
                        for(f = new Tob(h); f.a < f.c.c.length;){
                            c = Wv(Rob(f), 75);
                            aeb(c, (Ieb(), meb), true);
                        }
                        break;
                    case 1:
                        for(d = new Tob(h); d.a < d.c.c.length;){
                            c = Wv(Rob(d), 75);
                            aeb(c, (Ieb(), meb), true);
                        }
                }
                switch(k.e){
                    case 0:
                    case 1:
                        F2(g);
                        break;
                    case 2:
                        E2(g);
                }
            }
        }
        pI(b);
    };
    var ZC = Nkb(jAb, 'SplineSelfLoopPositioner', 513);
    hI(515, 1, {}, Q2);
    var WC = Nkb(jAb, 'SplineSelfLoopPositioner/DistributedLoopSidesCalculator', 515);
    hI(516, 1, {}, $2);
    _.d = true;
    var VC = Nkb(jAb, 'SplineSelfLoopPositioner/DistributedLoopSidesCalculator/SortedLoopSides', 516);
    hI(116, 1, {
        116: 1
    }, _2);
    _.a = 0;
    _.b = 0;
    var UC = Nkb(jAb, 'SplineSelfLoopPositioner/DistributedLoopSidesCalculator/SortedLoopSides/SizeOfSide', 116);
    hI(318, 1, {}, g3);
    var a3;
    var XC = Nkb(jAb, 'SplineSelfLoopPositioner/PortReadder', 318);
    hI(514, 1, fyb, i3);
    _.$b = function j3(a, b) {
        return h3(Wv(a, 75), Wv(b, 75));
    };
    var YC = Nkb(jAb, 'SplineSelfLoopPositioner/TextWidthComparator', 514);
    hI(517, 1, eAb, l3);
    _.sc = function o3(a, b) {
        var c, d, e, f, g, h, i, j, k, l, m, n, o1, p, q, r, s;
        nI(b, 'Spline SelfLoop pre-processing.', 1);
        k = new Wub;
        for(m = new Tob(a.b); m.a < m.c.c.length;){
            l = Wv(Rob(m), 9);
            k3(l);
            k.a.Q();
            for(h = Uh(mX(l)); Cm(h);){
                f = Wv(Dm(h), 12);
                bW(f) && (n = k.a.db(f, k), n);
            }
            for(g = (o1 = new Snb(k.a).a.bb().mb(), new Ynb(o1)); g.a.G();){
                f = (i = Wv(g.a.H(), 21), Wv(i.yb(), 12));
                r = f.c.g;
                s = f.d.g;
                (r == (sN(), $M) && (s == ZM || s == pN) || r == ZM && s == pN || r == pN && s == rN || r == rN && (s == $M || s == ZM)) && cW(f, false);
            }
            c = n3(k, l);
            sJ(l, (Rib(), Nib), c);
            if (!LM(Wv(rJ(l, (eM(), TL)), 28))) {
                q = new vtb;
                for(e = new Tob(c); e.a < e.c.c.length;){
                    d = Wv(Rob(e), 75);
                    Ue(q, Zdb(d));
                    Ue(q, d.i);
                }
                j = new Fnb(l.f, 0);
                while(j.b < j.d.Y()){
                    p = (Bxb(j.b < j.d.Y()), Wv(j.d.sb(j.c = j.b++), 7));
                    q.a.R(p) && vnb(j);
                }
            }
        }
        pI(b);
    };
    var $C = Nkb(jAb, 'SplineSelfLoopPreProcessor', 517);
    hI(518, 1, eAb, u3);
    _.sc = function v3(a, b) {
        var c, d, e, f, g, h, i, j, k, l, m, n, o1, p, q, r, s, t, u, v, w, A, B, C, D, F, G, H, I;
        nI(b, 'Spline SelfLoop routing', 1);
        D = new I3;
        for(m = new Tob(a.c); m.a < m.c.c.length;){
            l = Wv(Rob(m), 16);
            for(s = new Tob(l.a); s.a < s.c.c.length;){
                r = Wv(Rob(s), 9);
                u = r.f;
                n = new Wub;
                for(d = Wv(rJ(r, (Rib(), Nib)), 20).mb(); d.G();){
                    c = Wv(d.H(), 75);
                    Ue(n, c.a);
                }
                v = new GU;
                for(g = (t = new Snb(n.a).a.bb().mb(), new Ynb(t)); g.a.G();){
                    f = (h = Wv(g.a.H(), 21), Wv(h.yb(), 12));
                    B = f.c;
                    G = f.d;
                    k = new Tob(f.c.f.f);
                    A = 0;
                    F = 0;
                    i = 0;
                    j = 0;
                    while(i < 2){
                        e = Wv(Rob(k), 7);
                        if (B == e) {
                            A = j;
                            ++i;
                        }
                        if (G == e) {
                            F = j;
                            ++i;
                        }
                        ++j;
                    }
                    w = Wv(rJ(f, Mib), 60);
                    C = w == (Ieb(), neb) || w == keb ? u.c.length - (F - A < 0 ? -(F - A) : F - A) + 1 : F - A < 0 ? -(F - A) : F - A;
                    vU(v, new G3(A, F, C, w, f));
                }
                Gpb(v, D);
                p = new vtb;
                o1 = new Tob(v);
                if (o1.a < o1.c.c.length) {
                    q = t3(Wv(Rob(o1), 195), p);
                    while(o1.a < o1.c.c.length)Afb(q, t3(Wv(Rob(o1), 195), p));
                    sJ(r, Oib, (H = new DP, I = new Bfb(r.j.a, r.j.b), H.d = Nlb(0, I.d - q.d), H.b = Nlb(0, I.b - q.b), H.a = Nlb(0, q.a - I.a), H.c = Nlb(0, q.c - I.c), H));
                }
            }
        }
        pI(b);
    };
    var fD = Nkb(jAb, 'SplineSelfLoopRouter', 518);
    hI(91, 1, {
        91: 1
    }, w3);
    _.w = function x3() {
        return this.b + ': ' + this.d + ' -> ' + this.a + ' ' + zc(this.c);
    };
    _.a = 0;
    _.b = 0;
    _.d = 0;
    var cD = Nkb(jAb, 'SplineSelfLoopRouter/LoopPadding', 91);
    hI(521, 1, _zb, z3);
    _.D = function A3(a) {
        return y3(this, Wv(a, 91));
    };
    _.a = 0;
    _.c = 0;
    var _C = Nkb(jAb, 'SplineSelfLoopRouter/LoopPadding/EnclosingPredicate', 521);
    hI(520, 1, fyb, C3);
    _.$b = function D3(a, b) {
        return B3(Wv(a, 91), Wv(b, 91));
    };
    var aD = Nkb(jAb, 'SplineSelfLoopRouter/LoopPadding/MarginComparator', 520);
    hI(196, 1, _zb, E3);
    _.D = function F3(a) {
        return Wv(a, 91).c == this.a;
    };
    var bD = Nkb(jAb, 'SplineSelfLoopRouter/LoopPadding/PortSidePredicate', 196);
    hI(195, 1, {
        195: 1
    }, G3);
    _.c = 0;
    _.d = 0;
    _.e = 0;
    var eD = Nkb(jAb, 'SplineSelfLoopRouter/SelfLoopEdge', 195);
    hI(519, 1, fyb, I3);
    _.$b = function J3(a, b) {
        return H3(Wv(a, 195), Wv(b, 195));
    };
    var dD = Nkb(jAb, 'SplineSelfLoopRouter/SelfLoopEdge/StepSizeComparator', 519);
    hI(82, 25, {
        25: 1,
        82: 1
    }, L3);
    _.vc = function M3() {
        var a, b, c, d;
        for(b = WI(this.a, 0); b.b != b.d.c;){
            a = Wv(_ub(b), 10);
            a.a = this.j.d;
        }
        for(d = WI(this.c, 0); d.b != d.d.c;){
            c = Wv(_ub(d), 10);
            c.a = this.j.d;
        }
    };
    _.wc = function N3() {
        return this.b;
    };
    _.xc = function O3() {
        return this.e;
    };
    _.w = function P3() {
        return Ze(new Snb(this.d.a));
    };
    _.b = 0;
    _.e = 0;
    var gD = Nkb(vAb, 'CLEdge', 82);
    hI(93, 25, {
        25: 1,
        93: 1
    }, Q3);
    _.vc = function R3() {
        this.b.i.a = this.j.d + this.b.e.b;
    };
    _.wc = function S3() {
        if (this.b.g == (CX(), xX)) return 0;
        return this.a;
    };
    _.xc = function T3() {
        if (this.b.g == (CX(), xX)) return 0;
        return this.c;
    };
    _.w = function U3() {
        return xb(rJ(this.b, (Rib(), uib)));
    };
    _.a = 0;
    _.c = 0;
    var hD = Nkb(vAb, 'CLNode', 93);
    hI(175, 17, {
        175: 1,
        3: 1,
        23: 1,
        17: 1
    }, Y3);
    var V3, W3;
    var iD = Okb(vAb, 'ConstraintCalculationStrategy', 175, IF, Z3);
    var $3;
    hI(125, 17, {
        125: 1,
        3: 1,
        23: 1,
        17: 1
    }, h4);
    var a4, b4, c4, d4, e4, f4;
    var jD = Okb(vAb, 'GraphCompactionStrategy', 125, IF, i4);
    var j4;
    hI(455, 1, eAb, o4);
    _.sc = function p4(a, b) {
        var c, d, e;
        d = Wv(rJ(a, (Mjb(), Fjb)), 125);
        if (d == (g4(), e4)) return;
        nI(b, 'Horizontal Compaction', 1);
        this.a = a;
        e = new Q4;
        c = new rS(P4(e, a));
        pS(c, this.b);
        switch(Wv(rJ(a, Gjb), 175).e){
            case 1:
                nS(c, l4);
                break;
            default:
                nS(c, (aS(), $R));
        }
        switch(d.e){
            case 1:
                hS(c);
                break;
            case 2:
                hS(gS(c, (sK(), pK)));
                break;
            case 3:
                hS(bS(gS(hS(c), (sK(), pK))));
                break;
            case 4:
                hS(bS(oS(gS(hS(c), (sK(), pK)), new H4)));
                break;
            case 5:
                hS(mS(c, m4));
        }
        gS(c, (sK(), oK));
        c.e = true;
        L4(e);
        pI(b);
    };
    var l4, m4;
    var sD = Nkb(vAb, 'HorizontalGraphCompactor', 455);
    hI(462, 1, {}, q4);
    _.tc = function r4(a, b) {
        var c, d, e;
        if (aw(a, 82) && aw(b, 82) && !sr(or(Wv(a, 82).d, Wv(b, 82).d))) return 0;
        c = null;
        aw(a, 93) && (c = Wv(a, 93).b);
        d = null;
        aw(b, 93) && (d = Wv(b, 93).b);
        if (!!c && c.g == (CX(), xX) || !!d && d.g == (CX(), xX)) return 0;
        e = Wv(rJ(this.a.a, (Rib(), Kib)), 134);
        return Vjb(e, c ? c.g : (CX(), zX), d ? d.g : (CX(), zX));
    };
    _.uc = function s4(a, b) {
        if (aw(a, 82) && aw(b, 82) && !sr(or(Wv(a, 82).d, Wv(b, 82).d))) return 1;
        return Qlb(a.xc(), b.xc());
    };
    var kD = Nkb(vAb, 'HorizontalGraphCompactor/1', 462);
    hI(456, 317, {}, u4);
    _.Dc = function v4(a) {
        var b, c, d;
        this.b = a;
        ES(this, new z4, this.a);
        ES(this, new B4, this.a);
        b = Uzb;
        for(d = new Tob(this.b.a.b); d.a < d.c.c.length;){
            c = Wv(Rob(d), 25);
            if (aw(c, 93) && Wv(c, 93).b.g == (CX(), xX)) continue;
            b = Qlb(b, Ixb(w4(this.a, c)));
        }
        b == Uzb && (b = 0);
        ES(this, new D4, new F4(b));
    };
    var qD = Nkb(vAb, 'HorizontalGraphCompactor/EdgeAwareScanlineConstraintCalculation', 456);
    hI(457, 1, Tyb, x4);
    _.B = function y4(a) {
        return w4(this, a);
    };
    var lD = Nkb(vAb, 'HorizontalGraphCompactor/EdgeAwareScanlineConstraintCalculation/lambda$0$Type', 457);
    hI(458, 1, _zb, z4);
    _.D = function A4(a) {
        return aw(Wv(a, 25), 82);
    };
    var mD = Nkb(vAb, 'HorizontalGraphCompactor/EdgeAwareScanlineConstraintCalculation/lambda$1$Type', 458);
    hI(459, 1, _zb, B4);
    _.D = function C4(a) {
        return aw(Wv(a, 25), 93);
    };
    var nD = Nkb(vAb, 'HorizontalGraphCompactor/EdgeAwareScanlineConstraintCalculation/lambda$2$Type', 459);
    hI(460, 1, _zb, D4);
    _.D = function E4(a) {
        return true;
    };
    var oD = Nkb(vAb, 'HorizontalGraphCompactor/EdgeAwareScanlineConstraintCalculation/lambda$3$Type', 460);
    hI(461, 1, Tyb, F4);
    _.B = function G4(a) {
        return this.a;
    };
    _.a = 0;
    var pD = Nkb(vAb, 'HorizontalGraphCompactor/EdgeAwareScanlineConstraintCalculation/lambda$4$Type', 461);
    hI(463, 1, Tyb, H4);
    _.B = function I4(a) {
        return n4(), xkb(), uS(Wv(Wv(a, 27).a, 25).n, Wv(Wv(a, 27).b, 59)) ? vkb : wkb;
    };
    var rD = Nkb(vAb, 'HorizontalGraphCompactor/lambda$0$Type', 463);
    hI(553, 1, {}, Q4);
    _.c = false;
    var tD = Nkb(vAb, 'LGraphToCGraphTransformer', 553);
    hI(552, 1, {}, U4);
    _.Cc = function V4(a) {
        var b, c, d, e, f;
        this.a = a;
        this.d = new l7;
        this.c = xv(UD, syb, 61, this.a.a.a.c.length, 0, 1);
        this.b = 0;
        for(c = new Tob(this.a.a.a); c.a < c.c.c.length;){
            b = Wv(Rob(c), 78);
            b.d = this.b;
            f = x7(z7(y7(new A7, this.b), b), this.d);
            this.c[this.b] = f;
            ++this.b;
        }
        T4(this);
        S4(this);
        R4(this);
        F7(W7(this.d), new sI);
        for(e = new Tob(this.a.a.b); e.a < e.c.c.length;){
            d = Wv(Rob(e), 25);
            d.r = this.c[d.f.d].e + d.g.a;
            d.j.d = d.r;
        }
    };
    _.b = 0;
    var uD = Nkb(vAb, 'NetworkSimplexCompaction', 552);
    hI(142, 1, {
        142: 1,
        23: 1
    }, X4);
    _.F = function Y4(a) {
        return W4(this, Wv(a, 142));
    };
    _.c = false;
    _.d = true;
    _.i = 0;
    _.j = 0;
    _.k = 0;
    _.n = 0;
    var vD = Nkb(vAb, 'VerticalSegment', 142);
    hI(586, 1, {}, _4);
    _.e = false;
    var wD = Nkb(wAb, 'AllCrossingsCounter', 586);
    hI(339, 1, {});
    var xD = Nkb(wAb, 'BetweenLayerEdgeAllCrossingsCounter', 339);
    hI(613, 1, {}, k5);
    _.c = 0;
    _.e = 0;
    _.i = 0;
    var AD = Nkb(wAb, 'BetweenLayerEdgeTwoNodeCrossingsCounter', 613);
    hI(284, 1, {
        284: 1
    }, r5);
    _.w = function s5() {
        return 'AdjacencyList [node=' + this.d + ', adjacencies= ' + this.a + ']';
    };
    _.b = 0;
    _.c = 0;
    _.f = 0;
    var zD = Nkb(wAb, 'BetweenLayerEdgeTwoNodeCrossingsCounter/AdjacencyList', 284);
    hI(128, 1, {
        128: 1,
        23: 1
    }, v5);
    _.F = function w5(a) {
        return t5(this, Wv(a, 128));
    };
    _.w = function x5() {
        return 'Adjacency [position=' + this.c + ', cardinality=' + this.a + ', currentCardinality=' + this.b + ']';
    };
    _.a = 0;
    _.b = 0;
    _.c = 0;
    var yD = Nkb(wAb, 'BetweenLayerEdgeTwoNodeCrossingsCounter/AdjacencyList/Adjacency', 128);
    hI(610, 339, {}, y5);
    _.Gc = function z5(a, b) {
        var c, d, e, f, g, h, i, j, k, l, m, n, o1, p, q, r, s, t, u, v, w, A, B, C, D, F, G, H, I, J, K, L, M, N, O, P, Q, R, S, T, U, V, W, X, Y, Z, $, ab, bb, cb, db, eb, fb, gb, hb, ib, jb, kb, lb, mb, nb;
        eb = 0;
        for(I = 0, L = a.length; I < L; ++I){
            G = a[I];
            if (LM(Wv(rJ(G, (eM(), TL)), 28))) for(U = new Tob(G.f); U.a < U.c.c.length;){
                T = Wv(Rob(U), 7);
                W = 0;
                for(g = new Tob(T.e); g.a < g.c.c.length;){
                    f = Wv(Rob(g), 12);
                    G.d != f.d.f.d && ++W;
                }
                W > 0 && (this.a[T.k] = eb++);
            }
            else {
                N = 0;
                for(U = new Tob(G.f); U.a < U.c.c.length;){
                    T = Wv(Rob(U), 7);
                    for(g = new Tob(T.e); g.a < g.c.c.length;){
                        f = Wv(Rob(g), 12);
                        G.d != f.d.f.d && ++N;
                    }
                    this.a[T.k] = eb;
                }
                N > 0 && ++eb;
            }
        }
        jb = 0;
        for(J = 0, M = b.length; J < M; ++J){
            G = b[J];
            if (LM(Wv(rJ(G, (eM(), TL)), 28))) {
                O = 0;
                for(U = new Tob(G.f); U.a < U.c.c.length;){
                    T = Wv(Rob(U), 7);
                    if (T.g == (sN(), $M)) for(g = new Tob(T.b); g.a < g.c.c.length;){
                        f = Wv(Rob(g), 12);
                        if (G.d != f.c.f.d) {
                            ++O;
                            break;
                        }
                    }
                    else break;
                }
                Q = 0;
                X = new Fnb(G.f, G.f.c.length);
                while(X.b > 0){
                    T = (Bxb(X.b > 0), Wv(X.a.sb(X.c = --X.b), 7));
                    W = 0;
                    for(g = new Tob(T.b); g.a < g.c.c.length;){
                        f = Wv(Rob(g), 12);
                        G.d != f.c.f.d && ++W;
                    }
                    if (W > 0) {
                        if (T.g == (sN(), $M)) {
                            this.a[T.k] = jb;
                            ++jb;
                        } else {
                            this.a[T.k] = jb + O + Q;
                            ++Q;
                        }
                    }
                }
                jb += Q;
            } else {
                N = 0;
                for(U = new Tob(G.f); U.a < U.c.c.length;){
                    T = Wv(Rob(U), 7);
                    for(g = new Tob(T.b); g.a < g.c.c.length;){
                        f = Wv(Rob(g), 12);
                        G.d != f.c.f.d && ++N;
                    }
                    this.a[T.k] = jb;
                }
                N > 0 && ++jb;
            }
        }
        V = new ntb;
        p = new vtb;
        for(H = 0, K = a.length; H < K; ++H){
            G = a[H];
            for(hb = new Tob(G.f); hb.a < hb.c.c.length;){
                gb = Wv(Rob(hb), 7);
                for(g = new Tob(gb.e); g.a < g.c.c.length;){
                    f = Wv(Rob(g), 12);
                    lb = f.d;
                    if (G.d != lb.f.d) {
                        fb = Wv(re(Ktb(V.d, gb)), 204);
                        kb = Wv(re(Ktb(V.d, lb)), 204);
                        if (!fb && !kb) {
                            o1 = new B5;
                            p.a.db(o1, p);
                            QI(o1.a, f);
                            QI(o1.e, gb);
                            Ltb(V.d, gb, o1);
                            QI(o1.e, lb);
                            Ltb(V.d, lb, o1);
                        } else if (!fb) {
                            QI(kb.a, f);
                            QI(kb.e, gb);
                            Ltb(V.d, gb, kb);
                        } else if (!kb) {
                            QI(fb.a, f);
                            QI(fb.e, lb);
                            Ltb(V.d, lb, fb);
                        } else if (fb == kb) QI(fb.a, f);
                        else {
                            QI(fb.a, f);
                            for(S = WI(kb.e, 0); S.b != S.d.c;){
                                R = Wv(_ub(S), 7);
                                Ltb(V.d, R, fb);
                            }
                            Ue(fb.a, kb.a);
                            Ue(fb.e, kb.e);
                            p.a.eb(kb);
                        }
                    }
                }
            }
        }
        q = Wv(Ye(p, xv(CD, {
            675: 1,
            3: 1,
            5: 1,
            6: 1
        }, 204, p.a.Y(), 0, 1)), 675);
        F = a[0].d;
        db = b[0].d;
        for(m = 0, n = q.length; m < n; ++m){
            l = q[m];
            l.f = eb;
            l.g = jb;
            for(U = WI(l.e, 0); U.b != U.d.c;){
                T = Wv(_ub(U), 7);
                Y = this.a[T.k];
                if (T.f.d == F) {
                    if (Y < l.f) {
                        l.f = Y;
                        l.b = txb(T);
                    }
                    Y > l.c && (l.c = Y);
                } else if (T.f.d == db) {
                    Y < l.g && (l.g = Y);
                    Y > l.d && (l.d = Y);
                }
            }
        }
        ipb(q, 0, q.length, (hsb(), hsb(), gsb));
        ib = xv(mw, Yyb, 26, q.length, 12, 1);
        c = xv(mw, Yyb, 26, jb + 1, 12, 1);
        for(s = 0; s < q.length; s++){
            ib[s] = q[s].g;
            c[ib[s]] = 1;
        }
        e = 0;
        for(t = 0; t < c.length; t++)c[t] == 1 ? c[t] = e : --e;
        Z = 0;
        for(u = 0; u < ib.length; u++){
            ib[u] += c[ib[u]];
            Z = Plb(Z, ib[u] + 1);
        }
        k = 1;
        while(k < Z)k *= 2;
        nb = 2 * k - 1;
        k -= 1;
        mb = xv(mw, Yyb, 26, nb, 12, 1);
        d = 0;
        for(i = 0, j = ib.length; i < j; ++i){
            h = ib[i];
            w = h + k;
            ++mb[w];
            while(w > 0){
                w % 2 > 0 && (d += mb[w + 1]);
                w = (w - 1) / 2 | 0;
                ++mb[w];
            }
        }
        D = xv(BD, syb, 158, q.length * 2, 0, 1);
        for(v = 0; v < q.length; v++){
            D[2 * v] = new E5(q[v], q[v].f, q[v].c, 0);
            D[2 * v + 1] = new E5(q[v], q[v].c, q[v].f, 1);
        }
        ipb(D, 0, D.length, gsb);
        P = 0;
        for(B = 0, C = D.length; B < C; ++B){
            A = D[B];
            switch(A.d){
                case 0:
                    ++P;
                    break;
                case 1:
                    --P;
                    d += P;
            }
        }
        cb = xv(BD, syb, 158, q.length * 2, 0, 1);
        for(r = 0; r < q.length; r++){
            cb[2 * r] = new E5(q[r], q[r].g, q[r].d, 0);
            cb[2 * r + 1] = new E5(q[r], q[r].d, q[r].g, 1);
        }
        ipb(cb, 0, cb.length, gsb);
        P = 0;
        for(ab = 0, bb = cb.length; ab < bb; ++ab){
            $ = cb[ab];
            switch($.d){
                case 0:
                    ++P;
                    break;
                case 1:
                    --P;
                    d += P;
            }
        }
        return d;
    };
    var DD = Nkb(wAb, 'BetweenLayerHyperedgeAllCrossingsCounter', 610);
    hI(204, 1, {
        204: 1,
        23: 1
    }, B5);
    _.F = function C5(a) {
        return A5(this, Wv(a, 204));
    };
    _.b = 0;
    _.c = 0;
    _.d = 0;
    _.f = 0;
    _.g = 0;
    var CD = Nkb(wAb, 'BetweenLayerHyperedgeAllCrossingsCounter/Hyperedge', 204);
    hI(158, 1, {
        158: 1,
        23: 1
    }, E5);
    _.F = function F5(a) {
        return D5(this, Wv(a, 158));
    };
    _.b = 0;
    _.c = 0;
    _.d = 0;
    var BD = Nkb(wAb, 'BetweenLayerHyperedgeAllCrossingsCounter/HyperedgeCorner', 158);
    hI(611, 339, {}, H5);
    _.Gc = function J5(a, b) {
        var c, d, e, f, g, h, i, j, k, l, m, n, o1, p, q, r, s, t, u, v, w, A, B;
        B = 0;
        f = 0;
        h = a[0].d;
        u = b[0].d;
        for(k = 0, m = b.length; k < m; ++k){
            i = b[k];
            if (LM(Wv(rJ(i, (eM(), TL)), 28))) {
                o1 = 0;
                for(r = new Tob(i.f); r.a < r.c.c.length;){
                    q = Wv(Rob(r), 7);
                    if (q.g == (sN(), $M)) for(e = new Tob(q.b); e.a < e.c.c.length;){
                        d = Wv(Rob(e), 12);
                        if (d.c.f.d == h) {
                            ++o1;
                            break;
                        }
                    }
                    else break;
                }
                p = 0;
                t = new Fnb(i.f, i.f.c.length);
                while(t.b > 0){
                    q = (Bxb(t.b > 0), Wv(t.a.sb(t.c = --t.b), 7));
                    s = 0;
                    for(e = new Tob(q.b); e.a < e.c.c.length;){
                        d = Wv(Rob(e), 12);
                        d.c.f.d == h && ++s;
                    }
                    if (s > 0) {
                        if (q.g == (sN(), $M)) {
                            this.a[q.k] = B;
                            ++B;
                        } else {
                            this.a[q.k] = B + o1 + p;
                            ++p;
                        }
                        f += s;
                    }
                }
                B += p;
            } else {
                n = 0;
                for(r = new Tob(i.f); r.a < r.c.c.length;){
                    q = Wv(Rob(r), 7);
                    for(e = new Tob(q.b); e.a < e.c.c.length;){
                        d = Wv(Rob(e), 12);
                        d.c.f.d == h && ++n;
                    }
                    this.a[q.k] = B;
                }
                if (n > 0) {
                    ++B;
                    f += n;
                }
            }
        }
        v = xv(mw, Yyb, 26, f, 12, 1);
        g = 0;
        for(j = 0, l = a.length; j < l; ++j){
            i = a[j];
            if (LM(Wv(rJ(i, (eM(), TL)), 28))) for(r = new Tob(i.f); r.a < r.c.c.length;){
                q = Wv(Rob(r), 7);
                w = g;
                for(e = new Tob(q.e); e.a < e.c.c.length;){
                    d = Wv(Rob(e), 12);
                    A = d.d;
                    A.f.d == u && K5(v, w, g++, this.a[A.k]);
                }
            }
            else {
                w = g;
                for(r = new Tob(i.f); r.a < r.c.c.length;){
                    q = Wv(Rob(r), 7);
                    for(e = new Tob(q.e); e.a < e.c.c.length;){
                        d = Wv(Rob(e), 12);
                        A = d.d;
                        A.f.d == u && K5(v, w, g++, this.a[A.k]);
                    }
                }
            }
        }
        c = G5(B, f, v);
        return c;
    };
    var ED = Nkb(wAb, 'BetweenLayerStraightEdgeAllCrossingsCounter', 611);
    hI(338, 1, {}, N5);
    _.b = 0;
    _.e = false;
    var FD = Nkb(wAb, 'CrossingMatrixFiller', 338);
    hI(447, 1, eAb, $5);
    _.sc = function _5(a, b) {
        var c, d, e, f;
        nI(b, 'Greedy switch crossing reduction', 1);
        this.e = Wv(rJ(a, (Mjb(), tjb)), 110);
        c = a.c.c.length;
        if (c < 2 || this.e == (zhb(), rhb)) {
            pI(b);
            return;
        }
        Q5(this, a);
        this.e.b ? (this.e.a ? R5(this) : Z5(this), d = P5(this), e = this.e.a ? this.c : Z4(this.b, this.d), this.i = !this.i, this.d = this.g, this.e.a ? R5(this) : Z5(this), f = this.e.a ? this.c : Z4(this.b, this.d), e <= f && S5(this, d), undefined) : this.e.a ? R5(this) : Z5(this);
        T5(this, this.a);
        pI(b);
    };
    _.c = 0;
    _.i = true;
    var GD = Nkb(wAb, 'GreedySwitchProcessor', 447);
    hI(340, 1, {}, k6);
    var HD = Nkb(wAb, 'InLayerEdgeAllCrossingsCounter', 340);
    hI(614, 340, {}, r6);
    _.b = 0;
    _.d = 0;
    var JD = Nkb(wAb, 'InLayerEdgeTwoNodeCrossingCounter', 614);
    hI(226, 1, {
        226: 1,
        23: 1
    }, t6);
    _.F = function u6(a) {
        return s6(this, Wv(a, 226));
    };
    _.w = function v6() {
        return 'ComparableEdgeAndPort [port=' + this.b + ', edge=' + this.a + ', portPosition=' + this.c + ']';
    };
    _.c = 0;
    var ID = Nkb(wAb, 'InLayerEdgeTwoNodeCrossingCounter/ComparableEdgeAndPort', 226);
    hI(612, 1, {}, F6);
    _.e = true;
    _.f = 0;
    _.g = 0;
    _.k = false;
    var KD = Nkb(wAb, 'NorthSouthEdgeAllCrossingsCounter', 612);
    hI(615, 1, {}, R6);
    _.b = 0;
    _.d = 0;
    _.e = false;
    var LD = Nkb(wAb, 'NorthSouthEdgeNeighbouringNodeCrossingsCounter', 615);
    hI(143, 1, Oyb, U6);
    _.mb = function V6() {
        return T6(this);
    };
    _.b = 0;
    var ND = Nkb(wAb, 'PortIterable', 143);
    hI(344, 1, Ayb, W6);
    _.H = function Y6() {
        return Wv(Dnb(this.a), 7);
    };
    _.G = function X6() {
        return this.a.b > 0;
    };
    _.I = function Z6() {
        throw new Hmb;
    };
    var MD = Nkb(wAb, 'PortIterable/1', 344);
    hI(336, 1, {}, b7);
    var OD = Nkb(wAb, 'SwitchDecider', 336);
    hI(89, 1, {
        89: 1
    }, d7);
    _.w = function e7() {
        return 'NEdge[id=' + this.b + ' w=' + this.f + ' d=' + this.a + ']';
    };
    _.a = 1;
    _.b = 0;
    _.e = false;
    _.f = 0;
    var QD = Nkb(yAb, 'NEdge', 89);
    hI(157, 1, {}, k7);
    var PD = Nkb(yAb, 'NEdge/NEdgeBuilder', 157);
    hI(278, 1, {}, l7);
    var RD = Nkb(yAb, 'NGraph', 278);
    hI(61, 1, {
        61: 1
    }, n7);
    _.b = 0;
    _.d = -1;
    _.e = 0;
    _.i = -1;
    _.j = false;
    var UD = Nkb(yAb, 'NNode', 61);
    hI(333, 13, bAb, q7);
    _.rb = function r7(a, b) {
        ++this.d;
        Fxb(a, this.c.length);
        fxb(this.c, a, b);
    };
    _.ib = function s7(a) {
        return o7(this, a);
    };
    _.jb = function t7(a) {
        ++this.d;
        return xU(this, a);
    };
    _.Q = function u7() {
        ++this.d;
        this.c = xv(UF, syb, 1, 0, 4, 1);
    };
    _.vb = function v7(a) {
        ++this.d;
        return AU(this, a);
    };
    _.nb = function w7(a) {
        return p7(this, a);
    };
    var SD = Nkb(yAb, 'NNode/ChangeAwareArrayList', 333);
    hI(199, 1, {}, A7);
    var TD = Nkb(yAb, 'NNode/NNodeBuilder', 199);
    hI(595, 1, {}, V7);
    _.a = false;
    _.f = $xb;
    _.j = 0;
    var VD = Nkb(yAb, 'NetworkSimplex', 595);
    hI(193, 17, {
        180: 1,
        193: 1,
        3: 1,
        23: 1,
        17: 1
    }, $7);
    _.rc = function _7() {
        switch(this.e){
            case 0:
                return new g8;
            case 1:
                return new m8;
            default:
                throw new slb('No implementation is available for the cycle breaker ' + (this.d != null ? this.d : '' + this.e));
        }
    };
    var X7, Y7;
    var WD = Okb(AAb, 'CycleBreakingStrategy', 193, IF, a8);
    var b8;
    hI(539, 1, BAb, g8);
    _.qc = function h8(a) {
        return d8;
    };
    _.sc = function i8(a, b) {
        var c, d, e, f, g, h, i, j, k, l, m, n, o1, p, q, r, s, t, u, v, w, A, B, C, D, F, G, H, I, J;
        nI(b, 'Greedy cycle removal', 1);
        r = a.b;
        J = r.c.length;
        this.a = xv(mw, Yyb, 26, J, 12, 1);
        this.c = xv(mw, Yyb, 26, J, 12, 1);
        this.b = xv(mw, Yyb, 26, J, 12, 1);
        h = 0;
        for(p = new Tob(r); p.a < p.c.c.length;){
            n = Wv(Rob(p), 9);
            n.k = h;
            for(w = new Tob(n.f); w.a < w.c.c.length;){
                u = Wv(Rob(w), 7);
                for(f = new Tob(u.b); f.a < f.c.c.length;){
                    c = Wv(Rob(f), 12);
                    if (c.c.f == n) continue;
                    C = Wv(rJ(c, (Rib(), Eib)), 24).a;
                    this.a[h] += C > 0 ? C + 1 : 1;
                }
                for(e = new Tob(u.e); e.a < e.c.c.length;){
                    c = Wv(Rob(e), 12);
                    if (c.d.f == n) continue;
                    C = Wv(rJ(c, (Rib(), Eib)), 24).a;
                    this.c[h] += C > 0 ? C + 1 : 1;
                }
            }
            this.c[h] == 0 ? QI(this.d, n) : this.a[h] == 0 && QI(this.e, n);
            ++h;
        }
        m = -1;
        l = 1;
        j = new GU;
        D = Wv(rJ(a, (Rib(), Gib)), 154);
        while(J > 0){
            while(this.d.b != 0){
                G = Wv(YI(this.d), 9);
                this.b[G.k] = m--;
                f8(this, G);
                --J;
            }
            while(this.e.b != 0){
                H = Wv(YI(this.e), 9);
                this.b[H.k] = l++;
                f8(this, H);
                --J;
            }
            if (J > 0) {
                k = eyb;
                for(q = new Tob(r); q.a < q.c.c.length;){
                    n = Wv(Rob(q), 9);
                    if (this.b[n.k] == 0) {
                        s = this.c[n.k] - this.a[n.k];
                        if (s >= k) {
                            if (s > k) {
                                j.c = xv(UF, syb, 1, 0, 4, 1);
                                k = s;
                            }
                            j.c[j.c.length] = n;
                        }
                    }
                }
                i = Wv(yU(j, vvb(D, j.c.length)), 9);
                this.b[i.k] = l++;
                f8(this, i);
                --J;
            }
        }
        F = r.c.length + 1;
        for(h = 0; h < r.c.length; h++)this.b[h] < 0 && (this.b[h] += F);
        for(o1 = new Tob(r); o1.a < o1.c.c.length;){
            n = Wv(Rob(o1), 9);
            B = Wv(FU(n.f, xv(BB, mAb, 7, n.f.c.length, 0, 1)), 346);
            for(v = 0, A = B.length; v < A; ++v){
                u = B[v];
                t = Wv(FU(u.e, xv(dB, gAb, 12, u.e.c.length, 0, 1)), 47);
                for(d = 0, g = t.length; d < g; ++d){
                    c = t[d];
                    I = c.d.f.k;
                    if (this.b[n.k] > this.b[I]) {
                        cW(c, true);
                        sJ(a, cib, (xkb(), xkb(), wkb));
                    }
                }
            }
        }
        this.a = null;
        this.c = null;
        this.b = null;
        _I(this.e);
        _I(this.d);
        pI(b);
    };
    var d8;
    var XD = Nkb(AAb, 'GreedyCycleBreaker', 539);
    hI(540, 1, BAb, m8);
    _.qc = function n8(a) {
        return j8;
    };
    _.sc = function o8(a, b) {
        var c, d, e, f, g, h, i, j, k, l, m, n, o1, p;
        nI(b, 'Interactive cycle breaking', 1);
        k = new GU;
        for(m = new Tob(a.b); m.a < m.c.c.length;){
            l = Wv(Rob(m), 9);
            l.k = 1;
            n = kX(l).a;
            for(j = oX(l, (djb(), bjb)).mb(); j.G();){
                i = Wv(j.H(), 7);
                for(e = new Tob(i.e); e.a < e.c.c.length;){
                    c = Wv(Rob(e), 12);
                    o1 = c.d.f;
                    if (o1 != l) {
                        p = kX(o1).a;
                        p < n && (k.c[k.c.length] = c);
                    }
                }
            }
        }
        for(f = new Tob(k); f.a < f.c.c.length;){
            c = Wv(Rob(f), 12);
            cW(c, true);
        }
        k.c = xv(UF, syb, 1, 0, 4, 1);
        for(h = new Tob(a.b); h.a < h.c.c.length;){
            g = Wv(Rob(h), 9);
            g.k > 0 && l8(this, g, k);
        }
        for(d = new Tob(k); d.a < d.c.c.length;){
            c = Wv(Rob(d), 12);
            cW(c, true);
        }
        k.c = xv(UF, syb, 1, 0, 4, 1);
        pI(b);
    };
    var j8;
    var YD = Nkb(AAb, 'InteractiveCycleBreaker', 540);
    hI(543, 1, BAb, q8);
    _.qc = function r8(a) {
        return TQ(RQ(new WQ, (d0(), z_)), I_);
    };
    _.sc = function s8(a, b) {
        var c, d, e, f, g, h, i, j, k, l, m, n, o1, p;
        nI(b, 'Interactive node layering', 1);
        c = new GU;
        for(l = new Tob(a.b); l.a < l.c.c.length;){
            j = Wv(Rob(l), 9);
            h = j.i.a;
            g = h + j.j.a;
            g = h + 1 > g ? h + 1 : g;
            p = new Fnb(c, 0);
            d = null;
            while(p.b < p.d.Y()){
                n = (Bxb(p.b < p.d.Y()), Wv(p.d.sb(p.c = p.b++), 239));
                if (n.c >= g) {
                    Bxb(p.b > 0);
                    p.a.sb(p.c = --p.b);
                    break;
                } else if (n.a > h) {
                    if (!d) {
                        vU(n.b, j);
                        n.c = Qlb(n.c, h);
                        n.a = Nlb(n.a, g);
                        d = n;
                    } else {
                        xU(d.b, n.b);
                        d.a = Nlb(d.a, n.a);
                        vnb(p);
                    }
                }
            }
            if (!d) {
                d = new t8;
                d.c = h;
                d.a = g;
                Anb(p, d);
                vU(d.b, j);
            }
        }
        f = a.c;
        i = 0;
        for(o1 = new Tob(c); o1.a < o1.c.c.length;){
            n = Wv(Rob(o1), 239);
            e = new sY(a);
            e.k = i++;
            f.c[f.c.length] = e;
            for(m = new Tob(n.b); m.a < m.c.c.length;){
                j = Wv(Rob(m), 9);
                rX(j, e);
                j.k = 0;
            }
        }
        for(k = new Tob(a.b); k.a < k.c.c.length;){
            j = Wv(Rob(k), 9);
            j.k == 0 && p8(this, j, a);
        }
        while((Cxb(0, f.c.length), Wv(f.c[0], 16)).a.c.length == 0){
            Cxb(0, f.c.length);
            f.c.splice(0, 1);
        }
        a.b.c = xv(UF, syb, 1, 0, 4, 1);
        pI(b);
    };
    var $D = Nkb(CAb, 'InteractiveLayerer', 543);
    hI(239, 1, {
        239: 1
    }, t8);
    _.a = 0;
    _.c = 0;
    var ZD = Nkb(CAb, 'InteractiveLayerer/LayerSpan', 239);
    hI(173, 17, {
        180: 1,
        173: 1,
        3: 1,
        23: 1,
        17: 1
    }, y8);
    _.rc = function z8() {
        switch(this.e){
            case 0:
                return new U8;
            case 1:
                return new J8;
            case 2:
                return new q8;
            default:
                throw new slb('No implementation is available for the layerer ' + (this.d != null ? this.d : '' + this.e));
        }
    };
    var u8, v8, w8;
    var _D = Okb(CAb, 'LayeringStrategy', 173, IF, A8);
    var B8;
    hI(542, 1, BAb, J8);
    _.qc = function K8(a) {
        var b;
        b = XQ(D8);
        Ckb(Ixb(Xv(rJ(a, (Mjb(), njb))))) || gw(rJ(a, Ljb)) === gw((ckb(), _jb)) ? QQ(b, E8) : gw(rJ(a, Ljb)) === gw((ckb(), akb)) && QQ(b, F8);
        Ckb(Ixb(Xv(rJ(a, Ijb)))) && UQ(b, (d0(), Y_));
        return b;
    };
    _.sc = function L8(a, b) {
        var c, d, e, f, g;
        nI(b, 'Longest path layering', 1);
        this.a = a;
        g = this.a.b;
        this.b = xv(mw, Yyb, 26, g.c.length, 12, 1);
        c = 0;
        for(f = new Tob(g); f.a < f.c.c.length;){
            d = Wv(Rob(f), 9);
            d.k = c;
            this.b[c] = -1;
            ++c;
        }
        for(e = new Tob(g); e.a < e.c.c.length;){
            d = Wv(Rob(e), 9);
            I8(this, d);
        }
        g.c = xv(UF, syb, 1, 0, 4, 1);
        this.a = null;
        this.b = null;
        pI(b);
    };
    var D8, E8, F8;
    var aE = Nkb(CAb, 'LongestPathLayerer', 542);
    hI(541, 1, BAb, U8);
    _.qc = function V8(a) {
        var b;
        b = XQ(M8);
        if (Ckb(Ixb(Xv(rJ(a, (Mjb(), njb))))) || gw(rJ(a, Ljb)) === gw((ckb(), _jb))) {
            QQ(b, N8);
            this.d = (ckb(), _jb);
        } else if (gw(rJ(a, Ljb)) === gw((ckb(), akb))) {
            QQ(b, O8);
            this.d = akb;
        }
        return b;
    };
    _.sc = function W8(a, b) {
        var c, d, e, f, g, h, i, j, k, l;
        nI(b, 'Network simplex layering', 1);
        this.b = a;
        l = Wv(rJ(a, (Mjb(), Kjb)), 24).a * 4;
        k = this.b.b;
        if (k.c.length < 1) {
            pI(b);
            return;
        }
        for(d = WI(Q8(this, k), 0); d.b != d.d.c;){
            c = Wv(_ub(d), 20);
            f = l * hw(Tlb(c.Y()));
            e = T8(c);
            F7(S7(U7(T7(W7(e), f), this.b), this.d == (ckb(), _jb)), rI(b, 1));
            h = this.b.c;
            for(j = new Tob(e.a); j.a < j.c.c.length;){
                i = Wv(Rob(j), 61);
                while(h.c.length <= i.e)uU(h, h.c.length, new sY(this.b));
                g = Wv(i.f, 9);
                rX(g, Wv(yU(h, i.e), 16));
            }
        }
        k.c = xv(UF, syb, 1, 0, 4, 1);
        this.a = null;
        this.b = null;
        this.c = null;
        pI(b);
    };
    var M8, N8, O8;
    var bE = Nkb(CAb, 'NetworkSimplexLayerer', 541);
    hI(326, 1, {});
    var dE = Nkb(EAb, 'AbstractPortDistributor', 326);
    hI(558, 1, fyb, a9);
    _.$b = function b9(a, b) {
        return _8(this, Wv(a, 7), Wv(b, 7));
    };
    var cE = Nkb(EAb, 'AbstractPortDistributor/1', 558);
    hI(564, 1, {}, j9);
    var gE = Nkb(EAb, 'BarycenterHeuristic', 564);
    hI(272, 1, {
        272: 1
    }, k9);
    _.b = 0;
    _.d = 0;
    _.e = false;
    var eE = Nkb(EAb, 'BarycenterHeuristic/BarycenterState', 272);
    hI(565, 1, fyb, l9);
    _.$b = function m9(a, b) {
        return f9(this.a, a, b);
    };
    var fE = Nkb(EAb, 'BarycenterHeuristic/lambda$0$Type', 565);
    hI(192, 17, {
        180: 1,
        192: 1,
        3: 1,
        23: 1,
        17: 1
    }, q9);
    _.rc = function r9() {
        switch(this.e){
            case 0:
                return new I9;
            case 1:
                return new y9;
            default:
                throw new slb('No implementation is available for the crossing minimizer ' + (this.d != null ? this.d : '' + this.e));
        }
    };
    var n9, o9;
    var hE = Okb(EAb, 'CrossingMinimizationStrategy', 192, IF, s9);
    var t9;
    hI(526, 1, BAb, y9);
    _.qc = function z9(a) {
        var b;
        b = XQ(v9);
        Wv(rJ(a, (Rib(), jib)), 18).kb((ohb(), khb)) && TQ(b, (d0(), V_));
        return b;
    };
    _.sc = function A9(a, b) {
        var c, d, e, f, g, h, i, j, k, l, m, n, o1;
        nI(b, 'Interactive crossing minimization', 1);
        m = 0;
        for(e = new Tob(a.c); e.a < e.c.c.length;){
            d = Wv(Rob(e), 16);
            c = 0;
            j = 0;
            for(i = new Tob(d.a); i.a < i.c.c.length;){
                g = Wv(Rob(i), 9);
                if (g.i.a > 0) {
                    c += g.i.a + g.j.a / 2;
                    ++j;
                }
                for(l = new Tob(g.f); l.a < l.c.c.length;){
                    k = Wv(Rob(l), 7);
                    k.k = m++;
                }
            }
            c /= j;
            o1 = xv(kw, hyb, 26, d.a.c.length, 12, 1);
            f = 0;
            for(h = new Tob(d.a); h.a < h.c.c.length;){
                g = Wv(Rob(h), 9);
                g.k = f++;
                o1[g.k] = x9(g, c);
                g.g == (CX(), zX) && sJ(g, (Rib(), wib), o1[g.k]);
            }
            Gpb(d.a, new C9(o1));
        }
        n = new P9(xv(lw, tAb, 26, m, 12, 1));
        Z8(n, jW(a));
        pI(b);
    };
    var v9;
    var jE = Nkb(EAb, 'InteractiveCrossingMinimizer', 526);
    hI(527, 1, fyb, C9);
    _.$b = function D9(a, b) {
        return B9(this, Wv(a, 9), Wv(b, 9));
    };
    var iE = Nkb(EAb, 'InteractiveCrossingMinimizer/1', 527);
    hI(525, 1, BAb, I9);
    _.qc = function K9(a) {
        var b;
        b = XQ(E9);
        Wv(rJ(a, (Rib(), jib)), 18).kb((ohb(), khb)) && TQ(b, (d0(), V_));
        return b;
    };
    _.sc = function L9(a, b) {
        var c, d, e, f, g, h, i, j, k, l, m, n, o1, p, q, r, s, t, u, v, w, A, B, C, D, F, G, H;
        nI(b, 'Layer sweep crossing minimization', 1);
        F = Wv(rJ(a, (Rib(), Gib)), 154);
        q = a.c.c.length;
        if (q < 2) {
            pI(b);
            return;
        }
        G9(this, a);
        d = $xb;
        H = Wv(rJ(a, (Mjb(), Kjb)), 24).a;
        c = xv(eE, Txb, 671, a.c.c.length, 0, 2);
        m = 0;
        for(p = new Tob(a.c); p.a < p.c.c.length;){
            o1 = Wv(Rob(p), 16);
            o1.k = m;
            c[m] = xv(eE, {
                671: 1,
                3: 1,
                5: 1,
                6: 1
            }, 272, o1.a.c.length, 0, 1);
            n = 0;
            for(v = new Tob(o1.a); v.a < v.c.c.length;){
                u = Wv(Rob(v), 9);
                u.k = n;
                c[m][n] = new k9(u);
                ++n;
            }
            ++m;
        }
        e = new X9(c, this.g);
        f = new j9(c, e, F, this.j);
        A = new P9(this.j);
        t = new M9(this.j);
        for(G = 0; G < H && d > 0; G++){
            k = wvb(F, 1) != 0;
            j = k ? 0 : q - 1;
            i = this.b[j];
            C = wvb(F, 1) != 0 ? A : t;
            H9(i, f, k, false, true);
            g = $xb;
            h = true;
            do {
                J9(this.b, this.k);
                D = g;
                g = 0;
                g += bab(this.f, i, j);
                if (k) {
                    for(r = 1; r < q; r++){
                        l = this.b[r];
                        X8(C, i, (djb(), bjb));
                        H9(l, f, true, !h, false);
                        g += bab(this.f, l, r);
                        this.d[r] || this.c[r - 1] ? g += lab(this.e, i, l) : g += hab(this.i, i, l);
                        i = l;
                    }
                    j = q - 1;
                } else {
                    for(r = q - 2; r >= 0; r--){
                        l = this.b[r];
                        X8(C, i, (djb(), ajb));
                        H9(l, f, false, !h, false);
                        g += bab(this.f, l, r);
                        this.c[r] || this.d[r + 1] ? g += lab(this.e, l, i) : g += hab(this.i, l, i);
                        i = l;
                    }
                    j = 0;
                }
                h = false;
                k = !k;
            }while (g < D && g > 0);
            if (g < d || D < d) {
                if (g <= D) {
                    J9(this.b, this.a);
                    d = g;
                } else {
                    J9(this.k, this.a);
                    d = D;
                }
            }
        }
        s = new Fnb(a.c, 0);
        while(s.b < s.d.Y()){
            o1 = (Bxb(s.b < s.d.Y()), Wv(s.d.sb(s.c = s.b++), 16));
            B = this.a[s.b - 1];
            w = new Fnb(o1.a, 0);
            while(w.b < w.d.Y()){
                Bxb(w.b < w.d.Y());
                w.d.sb(w.c = w.b++);
                Enb(w, B[w.b - 1]);
            }
        }
        this.j = null;
        this.a = null;
        this.b = null;
        this.k = null;
        this.i = null;
        this.e = null;
        this.c = null;
        this.d = null;
        Pm(this.g);
        pI(b);
    };
    var E9;
    var kE = Nkb(EAb, 'LayerSweepCrossingMinimizer', 525);
    hI(327, 326, {}, M9);
    _.Hc = function N9(a, b, c) {
        var d, e, f, g, h, i, j, k, l, m, n, o1;
        m = this.a;
        if (LM(Wv(rJ(a, (eM(), TL)), 28))) switch(c.e){
            case 1:
                e = 0;
                h = 0;
                for(l = new Tob(a.f); l.a < l.c.c.length;){
                    j = Wv(Rob(l), 7);
                    if (j.b.c.length != 0) {
                        ++e;
                        j.g == (sN(), $M) && ++h;
                    }
                }
                i = b + h;
                o1 = b + e;
                for(k = oX(a, (djb(), ajb)).mb(); k.G();){
                    j = Wv(k.H(), 7);
                    if (j.g == (sN(), $M)) {
                        m[j.k] = i;
                        --i;
                    } else {
                        m[j.k] = o1;
                        --o1;
                    }
                }
                return e;
            case 2:
                n = 0;
                for(k = oX(a, (djb(), bjb)).mb(); k.G();){
                    j = Wv(k.H(), 7);
                    ++n;
                    m[j.k] = b + n;
                }
                return n;
            default:
                throw new rlb;
        }
        else {
            g = 4;
            f = 0;
            for(l = oX(a, c).mb(); l.G();){
                j = Wv(l.H(), 7);
                d = O9(c, j.g);
                g = g < d - 1 ? g : d - 1;
                f = f > d ? f : d;
            }
            if (f > g) {
                for(k = oX(a, c).mb(); k.G();){
                    j = Wv(k.H(), 7);
                    m[j.k] = b + O9(c, j.g) - g;
                }
                return f - g;
            }
            return 0;
        }
    };
    var lE = Nkb(EAb, 'LayerTotalPortDistributor', 327);
    hI(274, 326, {}, P9);
    _.Hc = function Q9(a, b, c) {
        var d, e, f, g, h, i, j, k, l, m, n;
        l = this.a;
        if (LM(Wv(rJ(a, (eM(), TL)), 28))) switch(c.e){
            case 1:
                e = 0;
                f = 0;
                for(k = new Tob(a.f); k.a < k.c.c.length;){
                    i = Wv(Rob(k), 7);
                    if (i.b.c.length != 0) {
                        ++e;
                        i.g == (sN(), $M) && ++f;
                    }
                }
                d = 1 / (e + 1);
                g = b + f * d;
                n = b + 1 - d;
                for(j = oX(a, (djb(), ajb)).mb(); j.G();){
                    i = Wv(j.H(), 7);
                    if (i.g == (sN(), $M)) {
                        l[i.k] = g;
                        g -= d;
                    } else {
                        l[i.k] = n;
                        n -= d;
                    }
                }
                break;
            case 2:
                h = 0;
                for(k = new Tob(a.f); k.a < k.c.c.length;){
                    i = Wv(Rob(k), 7);
                    i.e.c.length == 0 || ++h;
                }
                d = 1 / (h + 1);
                m = b + d;
                for(j = oX(a, (djb(), bjb)).mb(); j.G();){
                    i = Wv(j.H(), 7);
                    l[i.k] = m;
                    m += d;
                }
                break;
            default:
                throw new slb(GAb);
        }
        else for(j = oX(a, c).mb(); j.G();){
            i = Wv(j.H(), 7);
            l[i.k] = b + R9(c, i.g);
        }
        return 1;
    };
    var mE = Nkb(EAb, 'NodeRelativePortDistributor', 274);
    hI(566, 1, {}, X9);
    var oE = Nkb(KAb, 'ForsterConstraintResolver', 566);
    hI(102, 1, {
        102: 1
    }, $9, _9);
    _.w = function aab() {
        var a, b;
        b = new zmb;
        b.a += '[';
        for(a = 0; a < this.d.length; a++){
            ymb(b, tX(this.d[a]));
            W9(this.g, this.d[0]).a != null && ymb(ymb((b.a += '<', b), ilb(Ixb(W9(this.g, this.d[0]).a))), '>');
            a < this.d.length - 1 && (b.a += ', ', b);
        }
        return b.a += ']', b.a;
    };
    _.a = 0;
    _.c = 0;
    _.f = 0;
    var nE = Nkb(KAb, 'ForsterConstraintResolver/ConstraintGroup', 102);
    hI(331, 1, {});
    var pE = Nkb(LAb, 'AbstractCrossingsCounter', 331);
    hI(568, 331, {}, iab);
    var qE = Nkb(LAb, 'BarthJuengerMutzelCrossingsCounter', 568);
    hI(567, 331, {}, mab);
    var uE = Nkb(LAb, 'HyperedgeCrossingsCounter', 567);
    hI(197, 1, {
        197: 1,
        23: 1
    }, oab);
    _.F = function pab(a) {
        return nab(this, Wv(a, 197));
    };
    _.b = 0;
    _.c = 0;
    _.e = 0;
    _.f = 0;
    var tE = Nkb(LAb, 'HyperedgeCrossingsCounter/Hyperedge', 197);
    hI(156, 1, {
        156: 1,
        23: 1
    }, rab);
    _.F = function sab(a) {
        return qab(this, Wv(a, 156));
    };
    _.b = 0;
    _.c = 0;
    var sE = Nkb(LAb, 'HyperedgeCrossingsCounter/HyperedgeCorner', 156);
    hI(242, 17, {
        242: 1,
        3: 1,
        23: 1,
        17: 1
    }, wab);
    var tab, uab;
    var rE = Okb(LAb, 'HyperedgeCrossingsCounter/HyperedgeCorner/Type', 242, IF, xab);
    hI(545, 1, BAb, Bab);
    _.qc = function Cab(a) {
        return Wv(rJ(a, (Rib(), jib)), 18).kb((ohb(), hhb)) ? yab : null;
    };
    _.sc = function Dab(a, b) {
        var c, d;
        nI(b, 'Interactive node placement', 1);
        this.a = Wv(rJ(a, (Rib(), Kib)), 134);
        for(d = new Tob(a.c); d.a < d.c.c.length;){
            c = Wv(Rob(d), 16);
            Aab(this, c);
        }
        pI(b);
    };
    var yab;
    var vE = Nkb(MAb, 'InteractiveNodePlacer', 545);
    hI(546, 1, BAb, Qab);
    _.qc = function Rab(a) {
        return Wv(rJ(a, (Rib(), jib)), 18).kb((ohb(), hhb)) ? Eab : null;
    };
    _.sc = function Sab(a, b) {
        nI(b, 'Linear segments node placement', 1);
        this.b = Wv(rJ(a, (Rib(), Kib)), 134);
        Pab(this, a);
        Lab(this, a);
        Iab(this, a);
        Oab(this);
        this.a = null;
        this.b = null;
        pI(b);
    };
    var Eab, Fab, Gab;
    var xE = Nkb(MAb, 'LinearSegmentsNodePlacer', 546);
    hI(111, 1, {
        111: 1,
        23: 1
    }, Wab);
    _.F = function Xab(a) {
        return Tab(this, Wv(a, 111));
    };
    _.t = function Yab(a) {
        var b;
        if (aw(a, 111)) {
            b = Wv(a, 111);
            return this.b == b.b;
        }
        return false;
    };
    _.v = function Zab() {
        return this.b;
    };
    _.w = function $ab() {
        return 'ls' + Ze(this.f);
    };
    _.a = 0;
    _.b = 0;
    _.c = -1;
    _.d = -1;
    _.i = 0;
    var wE = Nkb(MAb, 'LinearSegmentsNodePlacer/LinearSegment', 111);
    hI(548, 1, BAb, cbb);
    _.qc = function dbb(a) {
        return Wv(rJ(a, (Rib(), jib)), 18).kb((ohb(), hhb)) ? _ab : null;
    };
    _.sc = function ebb(a, b) {
        var c, d, e, f, g, h, i, j, k, l, m, n, o1, p, q, r, s, t, u, v, w, A, B, C, D, F, G, H, I, J;
        H = Wv(rJ(a, (Rib(), Kib)), 134);
        u = (mp(), new ntb);
        t = 0;
        e = new l7;
        for(i = new Tob(a.c); i.a < i.c.c.length;){
            g = Wv(Rob(i), 16);
            D = null;
            C = null;
            for(n = new Tob(g.a); n.a < n.c.c.length;){
                m = Wv(Rob(n), 9);
                ++t;
                s = x7(new A7, e);
                s.f = m;
                Ltb(u.d, m, s);
                m.e.d = Llb(m.e.d);
                if (C) {
                    r = new d7;
                    r.f = 0;
                    r.a = hw(Mlb(D.e.d + D.j.b + D.e.a + Xjb(H, Wv(C.f, 9), m)));
                    r.c = C;
                    r.d = s;
                    o7(C.g, r);
                    o7(s.c, r);
                }
                D = m;
                C = s;
            }
        }
        for(j = new Tob(a.c); j.a < j.c.c.length;){
            g = Wv(Rob(j), 16);
            for(n = new Tob(g.a); n.a < n.c.c.length;){
                m = Wv(Rob(n), 9);
                for(A = new Tob(m.f); A.a < A.c.c.length;){
                    w = Wv(Rob(A), 7);
                    J = w.i.b + w.a.b;
                    if (J != Math.floor(J)) {
                        v = J - ZH(TH(Math.round(J)));
                        w.i.b -= v;
                    }
                }
            }
        }
        for(h = new Tob(a.c); h.a < h.c.c.length;){
            g = Wv(Rob(h), 16);
            for(n = new Tob(g.a); n.a < n.c.c.length;){
                m = Wv(Rob(n), 9);
                for(l = Uh(mX(m)); Cm(l);){
                    k = Wv(Dm(l), 12);
                    if (bW(k)) continue;
                    if (k.d.f.d == g) continue;
                    G = k.c.f.e.d + k.c.i.b + k.c.a.b;
                    I = k.d.f.e.d + k.d.i.b + k.d.a.b;
                    c = I - G;
                    B = hw(c);
                    d = x7(new A7, e);
                    o1 = new d7;
                    o1.f = bbb(k);
                    o1.a = B > 0 ? B : 0;
                    o1.c = d;
                    o1.d = Wv(Smb(u, k.c.f), 61);
                    o7(o1.c.g, o1);
                    o7(o1.d.c, o1);
                    F = new d7;
                    F.f = bbb(k);
                    F.a = B < 0 ? -B : 0;
                    F.c = d;
                    F.d = Wv(Smb(u, k.d.f), 61);
                    o7(F.c.g, F);
                    o7(F.d.c, F);
                }
            }
        }
        f = Wv(rJ(a, (Mjb(), Kjb)), 24).a * hw(Math.sqrt(t));
        F7(S7(T7(W7(e), f), false), rI(b, 1));
        for(q = new Tob(e.a); q.a < q.c.c.length;){
            p = Wv(Rob(q), 61);
            if (p.f != null) {
                m = Wv(p.f, 9);
                m.i.b = p.e + m.e.d;
            }
        }
    };
    var _ab;
    var yE = Nkb(MAb, 'NetworkSimplexPlacer', 548);
    hI(141, 17, {
        180: 1,
        141: 1,
        3: 1,
        23: 1,
        17: 1
    }, lbb);
    _.rc = function mbb() {
        switch(this.e){
            case 0:
                return new sbb;
            case 1:
                return new Bab;
            case 2:
                return new Qab;
            case 3:
                return new dcb;
            case 4:
                return new cbb;
            default:
                throw new slb('No implementation is available for the node placer ' + (this.d != null ? this.d : '' + this.e));
        }
    };
    var fbb, gbb, hbb, ibb, jbb;
    var zE = Okb(MAb, 'NodePlacementStrategy', 141, IF, nbb);
    var obb;
    hI(544, 1, BAb, sbb);
    _.qc = function tbb(a) {
        return Wv(rJ(a, (Rib(), jib)), 18).kb((ohb(), hhb)) ? qbb : null;
    };
    _.sc = function ubb(a, b) {
        var c, d, e, f, g, h, i, j, k, l;
        nI(b, 'Simple node placement', 1);
        l = Wv(rJ(a, (Rib(), Kib)), 134);
        h = 0;
        for(f = new Tob(a.c); f.a < f.c.c.length;){
            d = Wv(Rob(f), 16);
            g = d.c;
            g.b = 0;
            c = null;
            for(j = new Tob(d.a); j.a < j.c.c.length;){
                i = Wv(Rob(j), 9);
                !!c && (g.b += Vjb(l, i.g, c.g) * l.d);
                g.b += i.e.d + i.j.b + i.e.a;
                c = i;
            }
            h = Nlb(h, g.b);
        }
        for(e = new Tob(a.c); e.a < e.c.c.length;){
            d = Wv(Rob(e), 16);
            g = d.c;
            k = (h - g.b) / 2;
            c = null;
            for(j = new Tob(d.a); j.a < j.c.c.length;){
                i = Wv(Rob(j), 9);
                !!c && (k += Vjb(l, i.g, c.g) * l.d);
                k += i.e.d;
                i.i.b = k;
                k += i.j.b + i.e.a;
                c = i;
            }
        }
        pI(b);
    };
    var qbb;
    var AE = Nkb(MAb, 'SimpleNodePlacer', 544);
    hI(81, 1, {
        81: 1
    }, Cbb);
    _.w = function Dbb() {
        var a;
        a = '';
        this.c == (Gbb(), Fbb) ? a += pzb : this.c == Ebb && (a += ozb);
        this.k == (Lbb(), Jbb) ? a += 'DOWN' : this.k == Kbb ? a += 'UP' : a += 'BALANCED';
        return a;
    };
    var DE = Nkb(OAb, 'BKAlignedLayout', 81);
    hI(248, 17, {
        248: 1,
        3: 1,
        23: 1,
        17: 1
    }, Hbb);
    var Ebb, Fbb;
    var BE = Okb(OAb, 'BKAlignedLayout/HDirection', 248, IF, Ibb);
    hI(247, 17, {
        247: 1,
        3: 1,
        23: 1,
        17: 1
    }, Mbb);
    var Jbb, Kbb;
    var CE = Okb(OAb, 'BKAlignedLayout/VDirection', 247, IF, Nbb);
    hI(596, 1, {}, Qbb);
    var EE = Nkb(OAb, 'BKAligner', 596);
    hI(599, 1, {}, Vbb);
    var HE = Nkb(OAb, 'BKCompactor', 599);
    hI(279, 1, {
        279: 1
    }, Wbb);
    _.a = 0;
    var FE = Nkb(OAb, 'BKCompactor/ClassEdge', 279);
    hI(200, 1, {
        200: 1
    }, Ybb);
    _.a = 0;
    _.b = 0;
    var GE = Nkb(OAb, 'BKCompactor/ClassNode', 200);
    hI(547, 1, BAb, dcb);
    _.qc = function hcb(a) {
        return Wv(rJ(a, (Rib(), jib)), 18).kb((ohb(), hhb)) ? Zbb : null;
    };
    _.sc = function icb(a, b) {
        var c, d, e, f, g, h, i, j, k, l, m, n, o1, p, q, r, s, t;
        nI(b, 'Brandes & Koepf node placement', 1);
        this.b = a;
        this.d = scb(a);
        this.a = Ckb(Ixb(Xv(rJ(a, (Mjb(), mjb)))));
        this.e = gw(rJ(a, sjb)) === gw((_gb(), Vgb));
        ccb(this, a);
        n = (Mh(4, Vyb), new HU(4));
        switch(Wv(rJ(a, sjb), 124).e){
            case 3:
                o1 = new Cbb(a, this.d.d, (Lbb(), Jbb), (Gbb(), Ebb));
                n.c[n.c.length] = o1;
                break;
            case 1:
                p = new Cbb(a, this.d.d, (Lbb(), Kbb), (Gbb(), Ebb));
                n.c[n.c.length] = p;
                break;
            case 4:
                s = new Cbb(a, this.d.d, (Lbb(), Jbb), (Gbb(), Fbb));
                n.c[n.c.length] = s;
                break;
            case 2:
                t = new Cbb(a, this.d.d, (Lbb(), Kbb), (Gbb(), Fbb));
                n.c[n.c.length] = t;
                break;
            default:
                o1 = new Cbb(a, this.d.d, (Lbb(), Jbb), (Gbb(), Ebb));
                p = new Cbb(a, this.d.d, Kbb, Ebb);
                s = new Cbb(a, this.d.d, Jbb, Fbb);
                t = new Cbb(a, this.d.d, Kbb, Fbb);
                n.c[n.c.length] = s;
                n.c[n.c.length] = t;
                n.c[n.c.length] = o1;
                n.c[n.c.length] = p;
        }
        c = new Qbb(a, this.d);
        for(f = new Tob(n); f.a < f.c.c.length;){
            d = Wv(Rob(f), 81);
            Pbb(c, d, this.c);
            Obb(d);
        }
        k = new Vbb(a, this.d);
        for(g = new Tob(n); g.a < g.c.c.length;){
            d = Wv(Rob(g), 81);
            Sbb(k, d);
        }
        if (this.a) for(h = new Tob(n); h.a < h.c.c.length;){
            d = Wv(Rob(h), 81);
            Fmb();
            Abb(d);
        }
        j = null;
        if (this.e) {
            i = acb(this, n, this.d.d);
            _bb(this, a, i) && (j = i);
        }
        if (!j) for(h = new Tob(n); h.a < h.c.c.length;){
            d = Wv(Rob(h), 81);
            _bb(this, a, d) && (!j || Abb(j) > Abb(d)) && (j = d);
        }
        !j && (j = (Cxb(0, n.c.length), Wv(n.c[0], 81)));
        for(m = new Tob(a.c); m.a < m.c.c.length;){
            l = Wv(Rob(m), 16);
            for(r = new Tob(l.a); r.a < r.c.c.length;){
                q = Wv(Rob(r), 9);
                q.i.b = Ixb(j.n[q.k]) + Ixb(j.d[q.k]);
            }
        }
        if (this.a) {
            Fmb();
            ecb(j);
            fcb(j);
        }
        for(e = new Tob(n); e.a < e.c.c.length;){
            d = Wv(Rob(e), 81);
            d.f = null;
            d.b = null;
            d.a = null;
            d.d = null;
            d.i = null;
            d.g = null;
            d.n = null;
        }
        qcb(this.d);
        this.c.a.Q();
        pI(b);
    };
    _.a = false;
    _.e = false;
    var Zbb;
    var IE = Nkb(OAb, 'BKNodePlacer', 547);
    hI(194, 17, {
        194: 1,
        3: 1,
        23: 1,
        17: 1
    }, mcb);
    var jcb, kcb;
    var JE = Okb(OAb, 'CompactionStrategy', 194, IF, ncb);
    var ocb;
    hI(597, 1, {}, rcb);
    _.d = 0;
    var LE = Nkb(OAb, 'NeighborhoodInformation', 597);
    hI(598, 1, fyb, wcb);
    _.$b = function xcb(a, b) {
        return vcb(this, Wv(a, 27), Wv(b, 27));
    };
    var KE = Nkb(OAb, 'NeighborhoodInformation/NeighborComparator', 598);
    hI(334, 1, {});
    var PE = Nkb(OAb, 'ThresholdStrategy', 334);
    hI(602, 334, {}, Ccb);
    _.Ic = function Dcb(a, b, c) {
        return this.a.k == (Lbb(), Kbb) ? Uzb : Vzb;
    };
    _.Jc = function Ecb() {};
    var ME = Nkb(OAb, 'ThresholdStrategy/NullThresholdStrategy', 602);
    hI(249, 1, {
        249: 1
    }, Fcb);
    _.c = false;
    _.d = false;
    var NE = Nkb(OAb, 'ThresholdStrategy/Postprocessable', 249);
    hI(603, 334, {}, Jcb);
    _.Ic = function Kcb(a, b, c) {
        var d, e, f;
        e = b == c;
        d = this.a.a[c.k] == b;
        if (!(e || d)) return a;
        f = a;
        if (this.a.c == (Gbb(), Fbb)) {
            e && (f = Gcb(this, b, true));
            (f == Infinity || f == -Infinity) && d && (f = Gcb(this, c, false));
        } else {
            e && (f = Gcb(this, b, true));
            (f == Infinity || f == -Infinity) && d && (f = Gcb(this, c, false));
        }
        return f;
    };
    _.Jc = function Lcb() {
        var a, b, c, d;
        while(this.d.b != 0){
            d = Wv(XI(this.d), 249);
            c = Hcb(this, d);
            if (!c.a) continue;
            a = c.a;
            if (this.c.a[a.c.f.d.k] === this.c.a[a.d.f.d.k]) continue;
            b = Icb(this, d);
            b || Tvb(this.e, d);
        }
        while(this.e.a.c.length != 0)Icb(this, Wv(Svb(this.e), 249));
    };
    var OE = Nkb(OAb, 'ThresholdStrategy/SimpleThresholdStrategy', 603);
    hI(423, 1, {
        180: 1
    }, Mcb);
    _.rc = function Ncb() {
        switch(this.a.e){
            case 1:
                return new Rdb;
            case 3:
                return new Wfb;
            default:
                return new Ycb;
        }
    };
    var QE = Nkb(PAb, 'EdgeRouterFactory', 423);
    hI(538, 1, BAb, Ycb);
    _.qc = function Zcb(a) {
        var b, c;
        c = Wv(rJ(a, (Rib(), jib)), 18);
        b = new WQ;
        if (c.kb((ohb(), ihb))) {
            QQ(b, Scb);
            QQ(b, Ucb);
        }
        if (c.kb(khb) || Ckb(Ixb(Xv(rJ(a, (Mjb(), rjb)))))) {
            QQ(b, Ucb);
            c.kb(lhb) && QQ(b, Vcb);
        }
        c.kb(hhb) && QQ(b, Rcb);
        c.kb(nhb) && QQ(b, Wcb);
        c.kb(jhb) && QQ(b, Tcb);
        c.kb(ehb) && QQ(b, Pcb);
        c.kb(ghb) && QQ(b, Qcb);
        return b;
    };
    _.sc = function $cb(a, b) {
        var c, d, e, f, g, h, i, j, k, l, m, n, o1;
        nI(b, 'Orthogonal edge routing', 1);
        m = Wv(rJ(a, (Rib(), Kib)), 134);
        Ckb(Ixb(Xv(rJ(a, (eM(), rL)))));
        k = new cdb(0, m.a);
        o1 = 0;
        f = new Fnb(a.c, 0);
        g = null;
        h = null;
        do {
            i = f.b < f.d.Y() ? (Bxb(f.b < f.d.Y()), Wv(f.d.sb(f.c = f.b++), 16)) : null;
            j = !i ? null : i.a;
            if (g) {
                UW(g, o1);
                o1 += g.c.a;
            }
            n = !g ? o1 : o1 + m.b;
            l = bdb(k, a, h, j, n);
            d = !g || nl(h, (Ndb(), Mdb));
            e = !i || nl(j, (Ndb(), Mdb));
            if (l > 0) {
                c = m.b + (l - 1) * m.a;
                !!i && (c += m.b);
                c < m.f && !d && !e && (c = m.f);
                o1 += c;
            } else !d && !e && (o1 += m.f);
            g = i;
            h = j;
        }while (i);
        a.e.a = o1;
        pI(b);
    };
    var Pcb, Qcb, Rcb, Scb, Tcb, Ucb, Vcb, Wcb;
    var RE = Nkb(PAb, 'OrthogonalEdgeRouter', 538);
    hI(277, 1, {}, cdb);
    _.a = 0;
    _.c = 0;
    var XE = Nkb(PAb, 'OrthogonalRoutingGenerator', 277);
    hI(118, 1, {
        118: 1
    }, kdb);
    _.w = function ldb() {
        return this.a + '->' + this.b;
    };
    _.c = 0;
    var SE = Nkb(PAb, 'OrthogonalRoutingGenerator/Dependency', 118);
    hI(80, 1, {
        80: 1,
        23: 1
    }, odb);
    _.F = function pdb(a) {
        return ndb(this, Wv(a, 80));
    };
    _.t = function qdb(a) {
        var b;
        if (aw(a, 80)) {
            b = Wv(a, 80);
            return this.d == b.d;
        }
        return false;
    };
    _.v = function rdb() {
        return this.d;
    };
    _.w = function sdb() {
        var a, b, c, d;
        a = new Bmb('{');
        d = new Tob(this.g);
        while(d.a < d.c.c.length){
            c = Wv(Rob(d), 7);
            b = lX(c.f);
            b == null && (b = 'n' + jX(c.f));
            a.a += '' + b;
            d.a < d.c.c.length && (a.a += ',', a);
        }
        a.a += '}';
        return a.a;
    };
    _.a = NaN;
    _.c = 0;
    _.d = 0;
    _.f = 0;
    _.i = 0;
    _.k = NaN;
    var TE = Nkb(PAb, 'OrthogonalRoutingGenerator/HyperNode', 80);
    hI(580, 1, {}, tdb);
    _.Kc = function udb(a, b) {
        var c, d, e, f, g, h, i, j, k, l;
        l = b + a.i * this.a.c;
        for(h = new Tob(a.g); h.a < h.c.c.length;){
            g = Wv(Rob(h), 7);
            i = MI(Bv(tv(qz, 1), Fzb, 10, 0, [
                g.f.i,
                g.i,
                g.a
            ])).a;
            for(d = new Tob(g.e); d.a < d.c.c.length;){
                c = Wv(Rob(d), 12);
                j = c.d;
                k = MI(Bv(tv(qz, 1), Fzb, 10, 0, [
                    j.f.i,
                    j.i,
                    j.a
                ])).a;
                if ((i - k <= 0 ? 0 - (i - k) : i - k) > dAb) {
                    e = new HI(i, l);
                    QI(c.a, e);
                    _cb(this.a, c, a, e, false);
                    f = new HI(k, l);
                    QI(c.a, f);
                    _cb(this.a, c, a, f, false);
                }
            }
        }
    };
    _.Lc = function vdb(a) {
        return a.f.i.a + a.i.a + a.a.a;
    };
    _.Mc = function wdb() {
        return sN(), pN;
    };
    _.Nc = function xdb() {
        return sN(), $M;
    };
    var UE = Nkb(PAb, 'OrthogonalRoutingGenerator/NorthToSouthRoutingStrategy', 580);
    hI(581, 1, {}, ydb);
    _.Kc = function zdb(a, b) {
        var c, d, e, f, g, h, i, j, k, l;
        l = b - a.i * this.a.c;
        for(h = new Tob(a.g); h.a < h.c.c.length;){
            g = Wv(Rob(h), 7);
            i = MI(Bv(tv(qz, 1), Fzb, 10, 0, [
                g.f.i,
                g.i,
                g.a
            ])).a;
            for(d = new Tob(g.e); d.a < d.c.c.length;){
                c = Wv(Rob(d), 12);
                j = c.d;
                k = MI(Bv(tv(qz, 1), Fzb, 10, 0, [
                    j.f.i,
                    j.i,
                    j.a
                ])).a;
                if ((i - k <= 0 ? 0 - (i - k) : i - k) > dAb) {
                    e = new HI(i, l);
                    QI(c.a, e);
                    _cb(this.a, c, a, e, false);
                    f = new HI(k, l);
                    QI(c.a, f);
                    _cb(this.a, c, a, f, false);
                }
            }
        }
    };
    _.Lc = function Adb(a) {
        return a.f.i.a + a.i.a + a.a.a;
    };
    _.Mc = function Bdb() {
        return sN(), $M;
    };
    _.Nc = function Cdb() {
        return sN(), pN;
    };
    var VE = Nkb(PAb, 'OrthogonalRoutingGenerator/SouthToNorthRoutingStrategy', 581);
    hI(579, 1, {}, Ddb);
    _.Kc = function Edb(a, b) {
        var c, d, e, f, g, h, i, j, k, l;
        l = b + a.i * this.a.c;
        for(h = new Tob(a.g); h.a < h.c.c.length;){
            g = Wv(Rob(h), 7);
            i = MI(Bv(tv(qz, 1), Fzb, 10, 0, [
                g.f.i,
                g.i,
                g.a
            ])).b;
            for(d = new Tob(g.e); d.a < d.c.c.length;){
                c = Wv(Rob(d), 12);
                j = c.d;
                k = MI(Bv(tv(qz, 1), Fzb, 10, 0, [
                    j.f.i,
                    j.i,
                    j.a
                ])).b;
                if ((i - k <= 0 ? 0 - (i - k) : i - k) > dAb) {
                    e = new HI(l, i);
                    QI(c.a, e);
                    _cb(this.a, c, a, e, true);
                    f = new HI(l, k);
                    QI(c.a, f);
                    _cb(this.a, c, a, f, true);
                }
            }
        }
    };
    _.Lc = function Fdb(a) {
        return a.f.i.b + a.i.b + a.a.b;
    };
    _.Mc = function Gdb() {
        return sN(), ZM;
    };
    _.Nc = function Hdb() {
        return sN(), rN;
    };
    var WE = Nkb(PAb, 'OrthogonalRoutingGenerator/WestToEastRoutingStrategy', 579);
    hI(535, 1, BAb, Rdb);
    _.qc = function Sdb(a) {
        var b, c;
        c = Wv(rJ(a, (Rib(), jib)), 18);
        b = new WQ;
        if (c.kb((ohb(), khb)) || Ckb(Ixb(Xv(rJ(a, (Mjb(), rjb)))))) {
            QQ(b, Kdb);
            c.kb(lhb) && QQ(b, Ldb);
        }
        c.kb(ehb) && QQ(b, Idb);
        c.kb(ghb) && QQ(b, Jdb);
        return b;
    };
    _.sc = function Tdb(a, b) {
        var c, d, e, f, g, h, i, j, k, l, m, n, o1, p, q, r, s, t, u, v;
        nI(b, 'Polyline edge routing', 1);
        l = Wv(rJ(a, (Rib(), Jib)), 15).a;
        c = Wv(rJ(a, (Mjb(), qjb)), 15).a;
        q = 0;
        if (a.c.c.length != 0) {
            r = Pdb(Wv(yU(a.c, 0), 16));
            q = 0.4 * c * r;
        }
        f = new Fnb(a.c, 0);
        while(f.b < f.d.Y()){
            e = (Bxb(f.b < f.d.Y()), Wv(f.d.sb(f.c = f.b++), 16));
            d = nl(e, Mdb);
            d && q > 0 && (q -= l);
            UW(e, q);
            i = 0;
            for(k = new Tob(e.a); k.a < k.c.c.length;){
                j = Wv(Rob(k), 9);
                h = 0;
                for(n = Uh(mX(j)); Cm(n);){
                    m = Wv(Dm(n), 12);
                    o1 = MX(m.c).b;
                    p = MX(m.d).b;
                    if (e == m.d.f.d) {
                        s = m.c;
                        t = m.d;
                        u = (MI(Bv(tv(qz, 1), Fzb, 10, 0, [
                            s.f.i,
                            s.i,
                            s.a
                        ])).b + MI(Bv(tv(qz, 1), Fzb, 10, 0, [
                            t.f.i,
                            t.i,
                            t.a
                        ])).b) / 2;
                        s.g == (sN(), ZM) ? v = new HI(q + s.f.d.c.a + 0.4 * c * (o1 - p <= 0 ? 0 - (o1 - p) : o1 - p), u) : v = new HI(q - 0.4 * c * (o1 - p <= 0 ? 0 - (o1 - p) : o1 - p), u);
                        rn(m.a, 0, v);
                        if (m.c.g == rN) {
                            o1 = 0;
                            p = 0;
                        }
                    }
                    h = h > (p - o1 <= 0 ? 0 - (p - o1) : p - o1) ? h : p - o1 <= 0 ? 0 - (p - o1) : p - o1;
                }
                switch(j.g.e){
                    case 0:
                    case 4:
                    case 1:
                    case 3:
                        Qdb(this, j, q);
                }
                i = i > h ? i : h;
            }
            if (f.b < f.d.Y()) {
                r = Pdb((Bxb(f.b < f.d.Y()), Wv(f.d.sb(f.c = f.b++), 16)));
                i = i > r ? i : r;
                Bxb(f.b > 0);
                f.a.sb(f.c = --f.b);
            }
            g = 0.4 * c * i;
            !d && f.b < f.d.Y() && (g += l);
            q += e.c.a + g;
        }
        this.a.a.Q();
        a.e.a = q;
        pI(b);
    };
    var Idb, Jdb, Kdb, Ldb, Mdb;
    var ZE = Nkb(PAb, 'PolylineEdgeRouter', 535);
    hI(536, 1, _zb, Vdb);
    _.D = function Wdb(a) {
        return Udb(Wv(a, 9));
    };
    var YE = Nkb(PAb, 'PolylineEdgeRouter/1', 536);
    hI(75, 1, {
        75: 1
    }, deb);
    _.w = function eeb() {
        var a, b, c, d;
        c = new zmb;
        !!this.e && ymb(ymb(c, zc(this.e)), ': ');
        for(b = WI(Zdb(this), 0); b.b != b.d.c;){
            a = Wv(_ub(b), 7);
            ymb(ymb(umb(ymb(c, (d = OX(a), d == null ? 'p_' + a.k : 'p_' + d)), 32), zc(a.g)), ' / ');
        }
        return kkb(c, pmb(c.a) - 2 - 1);
    };
    _.j = 0;
    _.k = 0;
    var $E = Nkb(QAb, 'ConnectedSelfLoopComponent', 75);
    hI(60, 17, {
        60: 1,
        3: 1,
        23: 1,
        17: 1
    }, Peb);
    _.c = 0;
    var feb, geb, heb, ieb, jeb, keb, leb, meb, neb, oeb, peb, qeb, reb, seb, teb, ueb, veb, web, xeb, yeb, zeb, Aeb, Beb, Ceb, Deb, Eeb, Feb, Geb, Heb;
    var _E = Okb(QAb, 'LoopSide', 60, IF, Seb);
    hI(203, 1, {}, dfb, efb, ffb);
    _.w = function pfb() {
        return this.b.w();
    };
    _.c = 0;
    _.d = false;
    _.e = false;
    _.f = false;
    _.i = 0;
    _.j = 0;
    var bF = Nkb(QAb, 'NubSpline', 203);
    hI(92, 1, {
        92: 1
    }, sfb, tfb);
    var aF = Nkb(QAb, 'NubSpline/PolarCP', 92);
    hI(281, 203, {}, ufb);
    var cF = Nkb(QAb, 'NubsSelfLoop', 281);
    hI(112, 1, {}, Bfb, Cfb, Dfb, Efb, Ffb);
    _.a = jzb;
    _.b = rAb;
    _.c = jzb;
    _.d = rAb;
    var dF = Nkb(QAb, 'Rectangle', 112);
    hI(537, 1, BAb, Wfb);
    _.qc = function Yfb(a) {
        var b, c;
        b = new WQ;
        c = Wv(rJ(a, (Rib(), jib)), 18);
        c.kb((ohb(), nhb)) && QQ(b, Lfb);
        c.kb(ehb) && QQ(b, Hfb);
        if (c.kb(khb) || Ckb(Ixb(Xv(rJ(a, (Mjb(), rjb)))))) {
            QQ(b, Jfb);
            c.kb(lhb) && QQ(b, Kfb);
        }
        c.kb(ghb) && QQ(b, Ifb);
        return b;
    };
    _.sc = function $fb(a, b) {
        var c, d, e, f, g, h, i, j, k, l, m, n, o1, p, q, r, s, t, u, v, w, A, B, C, D, F, G, H, I, J, K, L;
        nI(b, 'Spline edge routing', 1);
        u = Wv(rJ(a, (Rib(), Jib)), 15).a;
        this.a = u * Wv(rJ(a, (Mjb(), qjb)), 15).a;
        L = 0;
        q = new Tob(a.c);
        r = null;
        J = (mp(), new ntb);
        I = new GU;
        i = true;
        j = true;
        do {
            A = q.a < q.c.c.length ? Wv(Rob(q), 16) : null;
            m = new GU;
            g = new GU;
            s = new Wub;
            C = new Wub;
            G = new Wub;
            Tfb(new RJ(r, A), new RJ(s, C), g, J, I, G);
            Sfb(s, C, (fgb(), dgb), true, g, m);
            Sfb(s, C, dgb, false, g, m);
            Sfb(s, C, egb, true, g, m);
            Sfb(s, C, egb, false, g, m);
            Rfb(g, s, C, m);
            H = new Fnb(m, 0);
            while(H.b < H.d.Y()){
                k = (Bxb(H.b < H.d.Y()), Wv(H.d.sb(H.c = H.b++), 77));
                K = new Fnb(m, H.b);
                while(K.b < K.d.Y()){
                    l = (Bxb(K.b < K.d.Y()), Wv(K.d.sb(K.c = K.b++), 77));
                    Qfb(k, l);
                }
            }
            Xfb(m, Wv(rJ(a, Gib), 154));
            _fb(m);
            B = L + 10;
            if (A) {
                j = !A || nl(A.a, (Ndb(), Mdb));
                t = -1;
                for(e = new Tob(m); e.a < e.c.c.length;){
                    c = Wv(Rob(e), 77);
                    t = Plb(t, c.n);
                }
                ++t;
                if (t > 0) {
                    n = (t + 1) * this.a;
                    n < u && !i && !j && (n = u);
                    B += n;
                } else i || j || Vfb(r) || Vfb(A) || (B += u);
                UW(A, B);
            }
            for(F = (w = new Snb(G.a).a.bb().mb(), new Ynb(w)); F.a.G();){
                D = (h = Wv(F.a.H(), 21), Wv(h.yb(), 12));
                v = D.c.f.i;
                hJ(D.a, v);
                for(p = new Tob(D.b); p.a < p.c.c.length;){
                    o1 = Wv(Rob(p), 33);
                    vI(o1.i, v);
                }
            }
            for(f = new Tob(m); f.a < f.c.c.length;){
                c = Wv(Rob(f), 77);
                c.f ? Ofb(c, L) : Pfb(this, c, L, B);
            }
            if (A) L = B + A.c.a + 10;
            else {
                t = -1;
                for(e = new Tob(m); e.a < e.c.c.length;){
                    c = Wv(Rob(e), 77);
                    t = Plb(t, c.n);
                }
                t >= 0 && (L += (t + 2) * this.a);
            }
            r = A;
            i = j;
        }while (A);
        for(d = new Tob(I); d.a < d.c.c.length;){
            c = Wv(Rob(d), 12);
            Nfb(c, J);
        }
        a.e.a = L;
        pI(b);
    };
    _.a = 3;
    var Hfb, Ifb, Jfb, Kfb, Lfb;
    var hF = Nkb(QAb, 'SplineEdgeRouter', 537);
    hI(117, 1, {
        117: 1
    }, bgb);
    _.w = function cgb() {
        return this.a + ' ->(' + this.c + ') ' + this.b;
    };
    _.c = 0;
    var eF = Nkb(QAb, 'SplineEdgeRouter/Dependency', 117);
    hI(223, 17, {
        223: 1,
        3: 1,
        23: 1,
        17: 1
    }, ggb);
    var dgb, egb;
    var fF = Okb(QAb, 'SplineEdgeRouter/SideToProcess', 223, IF, hgb);
    hI(77, 1, {
        77: 1,
        23: 1
    }, lgb, mgb);
    _.F = function ngb(a) {
        return jgb(this, Wv(a, 77));
    };
    _.a = 0;
    _.b = 0;
    _.e = 0;
    _.f = false;
    _.i = 0;
    _.k = 0;
    _.n = 0;
    _.p = 0;
    var gF = Nkb(QAb, 'SplineEdgeRouter/SplineHyperEdge', 77);
    hI(123, 17, {
        123: 1,
        3: 1,
        23: 1,
        17: 1
    }, Agb);
    var tgb, ugb, vgb, wgb, xgb, ygb;
    var iF = Okb(VAb, 'ContentAlignment', 123, IF, Bgb);
    var Cgb;
    hI(218, 17, {
        218: 1,
        3: 1,
        23: 1,
        17: 1
    }, Igb);
    var Egb, Fgb, Ggb;
    var jF = Okb(VAb, 'EdgeConstraint', 218, IF, Jgb);
    hI(115, 17, {
        115: 1,
        3: 1,
        23: 1,
        17: 1
    }, Rgb);
    var Kgb, Lgb, Mgb, Ngb, Ogb;
    var kF = Okb(VAb, 'EdgeLabelSideSelection', 115, IF, Sgb);
    var Tgb;
    hI(124, 17, {
        124: 1,
        3: 1,
        23: 1,
        17: 1
    }, ahb);
    var Vgb, Wgb, Xgb, Ygb, Zgb, $gb;
    var lF = Okb(VAb, 'FixedAlignment', 124, IF, bhb);
    var chb;
    hI(113, 17, {
        113: 1,
        3: 1,
        23: 1,
        17: 1
    }, phb);
    var ehb, fhb, ghb, hhb, ihb, jhb, khb, lhb, mhb, nhb;
    var mF = Okb(VAb, 'GraphProperties', 113, IF, qhb);
    hI(110, 17, {
        110: 1,
        3: 1,
        23: 1,
        17: 1
    }, Ahb);
    _.a = false;
    _.b = false;
    _.c = false;
    var rhb, shb, thb, uhb, vhb, whb, xhb, yhb;
    var nF = Okb(VAb, 'GreedySwitchType', 110, IF, Bhb);
    var Chb;
    hI(140, 17, {
        140: 1,
        3: 1,
        23: 1,
        17: 1
    }, Ihb);
    var Ehb, Fhb, Ghb;
    var oF = Okb(VAb, 'InLayerConstraint', 140, IF, Jhb);
    hI(174, 17, {
        174: 1,
        3: 1,
        23: 1,
        17: 1
    }, Nhb);
    var Khb, Lhb;
    var pF = Okb(VAb, 'InteractiveReferencePoint', 174, IF, Ohb);
    var Phb;
    var Rhb, Shb, Thb, Uhb, Vhb, Whb, Xhb, Yhb, Zhb, $hb, _hb, aib, bib, cib, dib, eib, fib, gib, hib, iib, jib, kib, lib, mib, nib, oib, pib, qib, rib, sib, tib, uib, vib, wib, xib, yib, zib, Aib, Bib, Cib, Dib, Eib, Fib, Gib, Hib, Iib, Jib, Kib, Lib, Mib, Nib, Oib, Pib, Qib;
    hI(85, 17, {
        85: 1,
        3: 1,
        23: 1,
        17: 1
    }, Yib);
    var Sib, Tib, Uib, Vib, Wib;
    var qF = Okb(VAb, 'LayerConstraint', 85, IF, Zib);
    var $ib;
    hI(219, 17, {
        219: 1,
        3: 1,
        23: 1,
        17: 1
    }, ejb);
    var ajb, bjb, cjb;
    var rF = Okb(VAb, 'PortType', 219, IF, fjb);
    var gjb, hjb, ijb, jjb, kjb, ljb, mjb, njb, ojb, pjb, qjb, rjb, sjb, tjb, ujb, vjb, wjb, xjb, yjb, zjb, Ajb, Bjb, Cjb, Djb, Ejb, Fjb, Gjb, Hjb, Ijb, Jjb, Kjb, Ljb;
    hI(153, 17, {
        153: 1,
        3: 1,
        23: 1,
        17: 1
    }, Rjb);
    var Njb, Ojb, Pjb;
    var sF = Okb(VAb, 'SelfLoopPlacement', 153, IF, Sjb);
    var Tjb;
    hI(134, 1, {
        134: 1
    }, $jb);
    _.a = 0;
    _.b = 0;
    _.c = 0;
    _.d = 0;
    _.e = 0;
    _.f = 0;
    var tF = Nkb(VAb, 'Spacings', 134);
    hI(172, 17, {
        172: 1,
        3: 1,
        23: 1,
        17: 1
    }, dkb);
    var _jb, akb, bkb;
    var uF = Okb(VAb, 'WideNodesStrategy', 172, IF, ekb);
    var fkb;
    hI(644, 1, {});
    var xF = Nkb(nyb, 'OutputStream', 644);
    hI(645, 644, {});
    var vF = Nkb(nyb, 'FilterOutputStream', 645);
    hI(291, 645, {}, hkb);
    var yF = Nkb(nyb, 'PrintStream', 291);
    hI(255, 1, {});
    _.w = function mkb() {
        return this.a;
    };
    var AF = Nkb(kyb, 'AbstractStringBuilder', 255);
    hI(621, 95, Vxb, pkb);
    var BF = Nkb(kyb, 'ArrayIndexOutOfBoundsException', 621);
    hI(290, 72, Vxb, qkb, rkb);
    var CF = Nkb(kyb, 'ArrayStoreException', 290);
    hI(252, 46, Uxb);
    var JF = Nkb(kyb, 'Error', 252);
    hI(84, 252, Uxb, tkb, ukb);
    var DF = Nkb(kyb, 'AssertionError', 84);
    Sv = {
        3: 1,
        349: 1,
        23: 1
    };
    var vkb, wkb;
    var EF = Nkb(kyb, 'Boolean', 349);
    Tv = {
        3: 1,
        23: 1,
        184: 1,
        231: 1
    };
    var HF = Nkb(kyb, 'Double', 184);
    hI(15, 231, {
        3: 1,
        23: 1,
        15: 1,
        231: 1
    }, klb, llb);
    _.F = function mlb(a) {
        return jlb(this, Wv(a, 15));
    };
    _.t = function nlb(a) {
        return aw(a, 15) && Wv(a, 15).a == this.a;
    };
    _.v = function olb() {
        return hw(this.a);
    };
    _.w = function plb() {
        return qlb(this.a);
    };
    _.a = 0;
    var LF = Nkb(kyb, 'Float', 15);
    hI(101, 72, Vxb, tlb, ulb);
    var NF = Nkb(kyb, 'IllegalStateException', 101);
    var Flb;
    var Hlb;
    hI(608, 72, Vxb, Ulb);
    var QF = Nkb(kyb, 'NegativeArraySizeException', 608);
    hI(76, 72, {
        3: 1,
        54: 1,
        76: 1,
        46: 1
    }, Vlb, Wlb);
    var RF = Nkb(kyb, 'NullPointerException', 76);
    hI(130, 29, {
        3: 1,
        54: 1,
        29: 1,
        130: 1,
        46: 1
    }, Xlb, Ylb);
    var SF = Nkb(kyb, 'NumberFormatException', 130);
    hI(146, 1, {
        3: 1,
        146: 1
    }, Zlb);
    _.t = function $lb(a) {
        var b;
        if (aw(a, 146)) {
            b = Wv(a, 146);
            return this.c == b.c && ovb(this.d, b.d) && ovb(this.a, b.a) && ovb(this.b, b.b);
        }
        return false;
    };
    _.v = function _lb() {
        return fpb(Bv(tv(UF, 1), syb, 1, 4, [
            Elb(this.c),
            this.a,
            this.d,
            this.b
        ]));
    };
    _.w = function amb() {
        return this.a + '.' + this.d + '(' + (this.b != null ? this.b : 'Unknown Source') + (this.c >= 0 ? ':' + this.c : '') + ')';
    };
    _.c = 0;
    var WF = Nkb(kyb, 'StackTraceElement', 146);
    hI(98, 255, {
        345: 1
    }, zmb, Amb, Bmb);
    var YF = Nkb(kyb, 'StringBuilder', 98);
    var Dmb, Emb;
    hI(45, 72, {
        3: 1,
        54: 1,
        46: 1,
        45: 1
    }, Hmb, Imb);
    var aG = Nkb(kyb, 'UnsupportedOperationException', 45);
    hI(213, 638, Byb);
    _.Q = function _mb() {
        Ymb(this);
    };
    _.R = function anb(a) {
        return Qmb(this, a);
    };
    _.ab = function bnb(a) {
        return Rmb(this, a, this.e) || Rmb(this, a, this.d);
    };
    _.bb = function cnb() {
        return new inb(this);
    };
    _.cb = function dnb(a) {
        return Smb(this, a);
    };
    _.db = function enb(a, b) {
        return Umb(this, a, b);
    };
    _.eb = function fnb(a) {
        return Wmb(this, a);
    };
    _.Y = function gnb() {
        return Zmb(this);
    };
    var hG = Nkb(Cyb, 'AbstractHashMap', 213);
    hI(120, 641, Eyb, inb);
    _.Q = function jnb() {
        this.a.Q();
    };
    _.kb = function knb(a) {
        return hnb(this, a);
    };
    _.mb = function lnb() {
        return new rnb(this.a);
    };
    _.nb = function mnb(a) {
        var b;
        if (hnb(this, a)) {
            b = Wv(a, 21).yb();
            this.a.eb(b);
            return true;
        }
        return false;
    };
    _.Y = function nnb() {
        return this.a.Y();
    };
    var gG = Nkb(Cyb, 'AbstractHashMap/EntrySet', 120);
    hI(148, 1, Ayb, rnb);
    _.H = function tnb() {
        return pnb(this);
    };
    _.G = function snb() {
        return this.b;
    };
    _.I = function unb() {
        qnb(this);
    };
    _.b = false;
    var fG = Nkb(Cyb, 'AbstractHashMap/EntrySetIterator', 148);
    hI(162, 1, Ayb, wnb);
    _.G = function xnb() {
        return this.b < this.d.Y();
    };
    _.H = function ynb() {
        return Bxb(this.G()), this.d.sb(this.c = this.b++);
    };
    _.I = function znb() {
        vnb(this);
    };
    _.b = 0;
    _.c = -1;
    var iG = Nkb(Cyb, 'AbstractList/IteratorImpl', 162);
    hI(43, 162, Hyb, Fnb);
    _.J = function Gnb(a) {
        Anb(this, a);
    };
    _.K = function Hnb() {
        return this.b > 0;
    };
    _.L = function Inb() {
        return this.b;
    };
    _.M = function Jnb() {
        return Dnb(this);
    };
    _.N = function Knb() {
        return this.b - 1;
    };
    _.O = function Lnb(a) {
        Enb(this, a);
    };
    var jG = Nkb(Cyb, 'AbstractList/ListIteratorImpl', 43);
    hI(258, 647, Fyb, Mnb);
    _.rb = function Nnb(a, b) {
        Fxb(a, this.b);
        this.c.rb(this.a + a, b);
        ++this.b;
    };
    _.sb = function Onb(a) {
        Cxb(a, this.b);
        return this.c.sb(this.a + a);
    };
    _.vb = function Pnb(a) {
        var b;
        Cxb(a, this.b);
        b = this.c.vb(this.a + a);
        --this.b;
        return b;
    };
    _.wb = function Qnb(a, b) {
        Cxb(a, this.b);
        return this.c.wb(this.a + a, b);
    };
    _.Y = function Rnb() {
        return this.b;
    };
    _.a = 0;
    _.b = 0;
    var kG = Nkb(Cyb, 'AbstractList/SubList', 258);
    hI(36, 641, Eyb, Snb);
    _.Q = function Tnb() {
        this.a.Q();
    };
    _.kb = function Unb(a) {
        return this.a.R(a);
    };
    _.mb = function Vnb() {
        var a;
        return a = this.a.bb().mb(), new Ynb(a);
    };
    _.nb = function Wnb(a) {
        if (this.a.R(a)) {
            this.a.eb(a);
            return true;
        }
        return false;
    };
    _.Y = function Xnb() {
        return this.a.Y();
    };
    var nG = Nkb(Cyb, 'AbstractMap/1', 36);
    hI(40, 1, Ayb, Ynb);
    _.G = function Znb() {
        return this.a.G();
    };
    _.H = function $nb() {
        var a;
        return a = Wv(this.a.H(), 21), a.yb();
    };
    _.I = function _nb() {
        this.a.I();
    };
    var mG = Nkb(Cyb, 'AbstractMap/1/1', 40);
    hI(211, 640, Dyb, aob);
    _.Q = function bob() {
        this.a.Q();
    };
    _.kb = function cob(a) {
        return this.a.ab(a);
    };
    _.mb = function dob() {
        var a;
        return a = this.a.bb().mb(), new fob(a);
    };
    _.Y = function eob() {
        return this.a.Y();
    };
    var pG = Nkb(Cyb, 'AbstractMap/2', 211);
    hI(212, 1, Ayb, fob);
    _.G = function gob() {
        return this.a.G();
    };
    _.H = function hob() {
        var a;
        return a = Wv(this.a.H(), 21), a.zb();
    };
    _.I = function iob() {
        this.a.I();
    };
    var oG = Nkb(Cyb, 'AbstractMap/2/1', 212);
    hI(210, 1, {
        210: 1,
        21: 1
    });
    _.t = function kob(a) {
        var b;
        if (!aw(a, 21)) return false;
        b = Wv(a, 21);
        return ovb(this.d, b.yb()) && ovb(this.e, b.zb());
    };
    _.yb = function lob() {
        return this.d;
    };
    _.zb = function mob() {
        return this.e;
    };
    _.v = function nob() {
        return pvb(this.d) ^ pvb(this.e);
    };
    _.Ab = function oob(a) {
        return job(this, a);
    };
    _.w = function pob() {
        return this.d + '=' + this.e;
    };
    var qG = Nkb(Cyb, 'AbstractMap/AbstractEntry', 210);
    hI(163, 210, {
        210: 1,
        163: 1,
        21: 1
    }, qob);
    var rG = Nkb(Cyb, 'AbstractMap/SimpleEntry', 163);
    hI(652, 1, Jyb);
    _.t = function rob(a) {
        var b;
        if (!aw(a, 21)) return false;
        b = Wv(a, 21);
        return ovb(this.yb(), b.yb()) && ovb(this.zb(), b.zb());
    };
    _.v = function sob() {
        return pvb(this.yb()) ^ pvb(this.zb());
    };
    _.w = function tob() {
        return this.yb() + '=' + this.zb();
    };
    var sG = Nkb(Cyb, Kyb, 652);
    hI(639, 638, Byb);
    _._ = function wob(a) {
        return uob(this, a);
    };
    _.R = function xob(a) {
        return vob(this, a);
    };
    _.bb = function yob() {
        return new Bob(this);
    };
    _.cb = function zob(a) {
        return re(Wvb(this, a));
    };
    _.W = function Aob() {
        return new Gob(this);
    };
    var xG = Nkb(Cyb, 'AbstractNavigableMap', 639);
    hI(287, 641, Eyb, Bob);
    _.kb = function Cob(a) {
        return aw(a, 21) && uob(this.b, Wv(a, 21));
    };
    _.mb = function Dob() {
        return new rwb(this.b);
    };
    _.nb = function Eob(a) {
        var b;
        if (aw(a, 21)) {
            b = Wv(a, 21);
            return dwb(this.b, b);
        }
        return false;
    };
    _.Y = function Fob() {
        return this.b.c;
    };
    var uG = Nkb(Cyb, 'AbstractNavigableMap/EntrySet', 287);
    hI(229, 641, Iyb, Gob);
    _.Q = function Hob() {
        Vvb(this.a);
    };
    _.kb = function Iob(a) {
        return vob(this.a, a);
    };
    _.mb = function Job() {
        var a;
        return a = new rwb(new wwb(this.a).b), new Mob(a);
    };
    _.nb = function Kob(a) {
        if (vob(this.a, a)) {
            cwb(this.a, a);
            return true;
        }
        return false;
    };
    _.Y = function Lob() {
        return this.a.c;
    };
    var wG = Nkb(Cyb, 'AbstractNavigableMap/NavigableKeySet', 229);
    hI(230, 1, Ayb, Mob);
    _.G = function Nob() {
        return Bnb(this.a.a);
    };
    _.H = function Oob() {
        var a;
        return a = pwb(this.a), a.yb();
    };
    _.I = function Pob() {
        qwb(this.a);
    };
    var vG = Nkb(Cyb, 'AbstractNavigableMap/NavigableKeySet/1', 230);
    hI(4, 1, Ayb, Tob);
    _.G = function Uob() {
        return Qob(this);
    };
    _.H = function Vob() {
        return Rob(this);
    };
    _.I = function Wob() {
        Sob(this);
    };
    _.a = 0;
    _.b = -1;
    var AG = Nkb(Cyb, 'ArrayList/1', 4);
    hI(94, 647, XAb, opb);
    _.kb = function ppb(a) {
        return dn(this, a) != -1;
    };
    _.sb = function qpb(a) {
        return mpb(this, a);
    };
    _.wb = function rpb(a, b) {
        var c;
        c = (Cxb(a, this.a.length), this.a[a]);
        Av(this.a, a, b);
        return c;
    };
    _.Y = function spb() {
        return this.a.length;
    };
    _.ob = function tpb() {
        return npb(this, xv(UF, syb, 1, this.a.length, 4, 1));
    };
    _.pb = function upb(a) {
        return npb(this, a);
    };
    var CG = Nkb(Cyb, 'Arrays/ArrayList', 94);
    var vpb, wpb, xpb;
    hI(413, 1, fyb, Ipb);
    _.$b = function Jpb(a, b) {
        return zT(b, a);
    };
    var DG = Nkb(Cyb, 'Collections/2', 413);
    hI(406, 647, XAb, Kpb);
    _.kb = function Lpb(a) {
        return false;
    };
    _.sb = function Mpb(a) {
        Cxb(a, 0);
        return null;
    };
    _.mb = function Npb() {
        return ypb(), Rpb(), Qpb;
    };
    _.tb = function Opb() {
        return ypb(), Rpb(), Qpb;
    };
    _.Y = function Ppb() {
        return 0;
    };
    var FG = Nkb(Cyb, 'Collections/EmptyList', 406);
    hI(407, 1, Hyb, Spb);
    _.J = function Tpb(a) {
        throw new Hmb;
    };
    _.G = function Upb() {
        return false;
    };
    _.K = function Vpb() {
        return false;
    };
    _.H = function Wpb() {
        throw new nvb;
    };
    _.L = function Xpb() {
        return 0;
    };
    _.M = function Ypb() {
        throw new nvb;
    };
    _.N = function Zpb() {
        return -1;
    };
    _.I = function $pb() {
        throw new tlb;
    };
    _.O = function _pb(a) {
        throw new tlb;
    };
    var Qpb;
    var EG = Nkb(Cyb, 'Collections/EmptyListIterator', 407);
    hI(409, 638, Ryb, aqb);
    _.R = function bqb(a) {
        return false;
    };
    _.ab = function cqb(a) {
        return false;
    };
    _.bb = function dqb() {
        return ypb(), xpb;
    };
    _.cb = function eqb(a) {
        return null;
    };
    _.W = function fqb() {
        return ypb(), xpb;
    };
    _.Y = function gqb() {
        return 0;
    };
    _.fb = function hqb() {
        return ypb(), vpb;
    };
    var GG = Nkb(Cyb, 'Collections/EmptyMap', 409);
    hI(408, 641, Syb, iqb);
    _.kb = function jqb(a) {
        return false;
    };
    _.mb = function kqb() {
        return ypb(), Rpb(), Qpb;
    };
    _.Y = function lqb() {
        return 0;
    };
    var HG = Nkb(Cyb, 'Collections/EmptySet', 408);
    hI(410, 1, fyb, pqb);
    _.$b = function qqb(a, b) {
        return oqb(Wv(a, 23), Wv(b, 23));
    };
    var mqb;
    var IG = Nkb(Cyb, 'Collections/ReverseComparator', 410);
    hI(411, 647, {
        3: 1,
        22: 1,
        19: 1,
        20: 1
    }, rqb);
    _.kb = function sqb(a) {
        return ovb(this.a, a);
    };
    _.sb = function tqb(a) {
        Cxb(a, 1);
        return this.a;
    };
    _.Y = function uqb() {
        return 1;
    };
    var JG = Nkb(Cyb, 'Collections/SingletonList', 411);
    hI(217, 1, Dyb, zqb);
    _.ib = function Aqb(a) {
        return vqb();
    };
    _.jb = function Bqb(a) {
        return wqb();
    };
    _.Q = function Cqb() {
        xqb();
    };
    _.kb = function Dqb(a) {
        return this.b.kb(a);
    };
    _.lb = function Eqb(a) {
        return this.b.lb(a);
    };
    _.V = function Fqb() {
        return this.b.V();
    };
    _.mb = function Gqb() {
        return new Nqb(this.b.mb());
    };
    _.nb = function Hqb(a) {
        return yqb();
    };
    _.Y = function Iqb() {
        return this.b.Y();
    };
    _.ob = function Jqb() {
        return this.b.ob();
    };
    _.pb = function Kqb(a) {
        return this.b.pb(a);
    };
    _.w = function Lqb() {
        return xb(this.b);
    };
    var LG = Nkb(Cyb, 'Collections/UnmodifiableCollection', 217);
    hI(152, 1, Ayb, Nqb);
    _.G = function Oqb() {
        return this.b.G();
    };
    _.H = function Pqb() {
        return this.b.H();
    };
    _.I = function Qqb() {
        Mqb();
    };
    var KG = Nkb(Cyb, 'Collections/UnmodifiableCollectionIterator', 152);
    hI(233, 217, Fyb, Rqb);
    _.rb = function Sqb(a, b) {
        throw new Hmb;
    };
    _.t = function Tqb(a) {
        return this.a.t(a);
    };
    _.sb = function Uqb(a) {
        return this.a.sb(a);
    };
    _.v = function Vqb() {
        return this.a.v();
    };
    _.V = function Wqb() {
        return this.a.V();
    };
    _.tb = function Xqb() {
        return new arb(this.a.ub(0));
    };
    _.ub = function Yqb(a) {
        return new arb(this.a.ub(a));
    };
    _.vb = function Zqb(a) {
        throw new Hmb;
    };
    _.wb = function $qb(a, b) {
        throw new Hmb;
    };
    _.xb = function _qb(a, b) {
        return new Rqb(this.a.xb(a, b));
    };
    var NG = Nkb(Cyb, 'Collections/UnmodifiableList', 233);
    hI(309, 152, Hyb, arb);
    _.J = function brb(a) {
        throw new Hmb;
    };
    _.K = function crb() {
        return this.a.K();
    };
    _.L = function drb() {
        return this.a.L();
    };
    _.M = function erb() {
        return this.a.M();
    };
    _.N = function frb() {
        return this.a.N();
    };
    _.O = function grb(a) {
        throw new Hmb;
    };
    var MG = Nkb(Cyb, 'Collections/UnmodifiableListIterator', 309);
    hI(305, 1, Byb, mrb);
    _.Q = function nrb() {
        throw new Hmb;
    };
    _.R = function orb(a) {
        return this.c.R(a);
    };
    _.ab = function prb(a) {
        return hrb(this, a);
    };
    _.bb = function qrb() {
        return irb(this);
    };
    _.t = function rrb(a) {
        return jrb(this, a);
    };
    _.cb = function srb(a) {
        return this.c.cb(a);
    };
    _.v = function trb() {
        return this.c.v();
    };
    _.V = function urb() {
        return this.c.V();
    };
    _.W = function vrb() {
        return krb(this);
    };
    _.db = function wrb(a, b) {
        throw new Hmb;
    };
    _.eb = function xrb(a) {
        throw new Hmb;
    };
    _.Y = function yrb() {
        return this.c.Y();
    };
    _.w = function zrb() {
        return xb(this.c);
    };
    _.fb = function Arb() {
        return lrb(this);
    };
    var RG = Nkb(Cyb, 'Collections/UnmodifiableMap', 305);
    hI(151, 217, Eyb, Frb);
    _.t = function Grb(a) {
        return Drb(this, a);
    };
    _.v = function Hrb() {
        return this.b.v();
    };
    var TG = Nkb(Cyb, 'Collections/UnmodifiableSet', 151);
    hI(412, 151, Eyb, Nrb);
    _.kb = function Orb(a) {
        return Irb(this, a);
    };
    _.lb = function Prb(a) {
        return Jrb(this, a);
    };
    _.mb = function Qrb() {
        var a;
        return a = this.b.mb(), new Trb(a);
    };
    _.ob = function Rrb() {
        return Krb(this);
    };
    _.pb = function Srb(a) {
        return Lrb(this, a);
    };
    var QG = Nkb(Cyb, 'Collections/UnmodifiableMap/UnmodifiableEntrySet', 412);
    hI(263, 1, Ayb, Trb);
    _.H = function Vrb() {
        return new Xrb(Wv(this.a.H(), 21));
    };
    _.G = function Urb() {
        return this.a.G();
    };
    _.I = function Wrb() {
        throw new Hmb;
    };
    var OG = Nkb(Cyb, 'Collections/UnmodifiableMap/UnmodifiableEntrySet/1', 263);
    hI(306, 1, Jyb, Xrb);
    _.t = function Yrb(a) {
        return this.a.t(a);
    };
    _.yb = function Zrb() {
        return this.a.yb();
    };
    _.zb = function $rb() {
        return this.a.zb();
    };
    _.v = function _rb() {
        return this.a.v();
    };
    _.Ab = function asb(a) {
        throw new Hmb;
    };
    _.w = function bsb() {
        return xb(this.a);
    };
    var PG = Nkb(Cyb, 'Collections/UnmodifiableMap/UnmodifiableEntrySet/UnmodifiableEntry', 306);
    hI(307, 233, Gyb, csb);
    var SG = Nkb(Cyb, 'Collections/UnmodifiableRandomAccessList', 307);
    hI(308, 151, Iyb, dsb);
    _.t = function esb(a) {
        return this.a.t(a);
    };
    _.v = function fsb() {
        return this.a.v();
    };
    var UG = Nkb(Cyb, 'Collections/UnmodifiableSortedSet', 308);
    var gsb;
    hI(522, 1, fyb, isb);
    _.$b = function jsb(a, b) {
        Dxb(a);
        Dxb(b);
        return Akb(Wv(a, 23), b);
    };
    var VG = Nkb(Cyb, 'Comparators/1', 522);
    hI(202, 72, Vxb, nsb);
    var WG = Nkb(Cyb, 'ConcurrentModificationException', 202);
    hI(609, 72, Vxb, osb);
    var XG = Nkb(Cyb, 'EmptyStackException', 609);
    hI(319, 638, Byb, vsb);
    _.db = function Bsb(a, b) {
        return ssb(this, a, b);
    };
    _.Q = function wsb() {
        psb(this);
    };
    _.R = function xsb(a) {
        return Ysb(this.a, a);
    };
    _.ab = function ysb(a) {
        var b, c;
        for(c = new jtb(this.a); c.a < c.c.a.length;){
            b = itb(c);
            if (ovb(a, this.b[b.e])) return true;
        }
        return false;
    };
    _.bb = function zsb() {
        return new Fsb(this);
    };
    _.cb = function Asb(a) {
        return qsb(this, a);
    };
    _.eb = function Csb(a) {
        return tsb(this, a);
    };
    _.Y = function Dsb() {
        return this.a.c;
    };
    var _G = Nkb(Cyb, 'EnumMap', 319);
    hI(236, 641, Eyb, Fsb);
    _.Q = function Gsb() {
        psb(this.a);
    };
    _.kb = function Hsb(a) {
        return Esb(this, a);
    };
    _.mb = function Isb() {
        return new Lsb(this.a);
    };
    _.nb = function Jsb(a) {
        var b;
        if (Esb(this, a)) {
            b = Wv(a, 21).yb();
            tsb(this.a, b);
            return true;
        }
        return false;
    };
    _.Y = function Ksb() {
        return this.a.a.c;
    };
    var ZG = Nkb(Cyb, 'EnumMap/EntrySet', 236);
    hI(237, 1, Ayb, Lsb);
    _.H = function Nsb() {
        return this.b = itb(this.a), new Psb(this.c, this.b);
    };
    _.G = function Msb() {
        return htb(this.a);
    };
    _.I = function Osb() {
        uxb(!!this.b);
        tsb(this.c, this.b);
        this.b = null;
    };
    var YG = Nkb(Cyb, 'EnumMap/EntrySetIterator', 237);
    hI(238, 652, Jyb, Psb);
    _.yb = function Qsb() {
        return this.a;
    };
    _.zb = function Rsb() {
        return this.b.b[this.a.e];
    };
    _.Ab = function Ssb(a) {
        return usb(this.b, this.a.e, a);
    };
    var $G = Nkb(Cyb, 'EnumMap/MapEntry', 238);
    hI(86, 641, {
        22: 1,
        19: 1,
        86: 1,
        18: 1
    });
    var cH = Nkb(Cyb, 'EnumSet', 86);
    hI(66, 86, {
        22: 1,
        19: 1,
        86: 1,
        66: 1,
        18: 1
    }, atb);
    _.ib = function btb(a) {
        return Wsb(this, Wv(a, 17));
    };
    _.kb = function ctb(a) {
        return Ysb(this, a);
    };
    _.mb = function dtb() {
        return new jtb(this);
    };
    _.nb = function etb(a) {
        return $sb(this, a);
    };
    _.Y = function ftb() {
        return this.c;
    };
    _.c = 0;
    var bH = Nkb(Cyb, 'EnumSet/EnumSetImpl', 66);
    hI(167, 1, Ayb, jtb);
    _.H = function ltb() {
        return itb(this);
    };
    _.G = function ktb() {
        return htb(this);
    };
    _.I = function mtb() {
        uxb(this.b != -1);
        Av(this.c.b, this.b, null);
        --this.c.c;
        this.b = -1;
    };
    _.a = -1;
    _.b = -1;
    var aH = Nkb(Cyb, 'EnumSet/EnumSetImpl/IteratorImpl', 167);
    hI(30, 213, YAb, ntb, otb, ptb);
    _.Uc = function qtb(a, b) {
        return gw(a) === gw(b) || a != null && rb(a, b);
    };
    _.Vc = function rtb(a) {
        var b;
        b = vb(a);
        return b | 0;
    };
    var dH = Nkb(Cyb, 'HashMap', 30);
    hI(50, 641, ZAb, vtb, wtb, xtb);
    _.ib = function ztb(a) {
        return stb(this, a);
    };
    _.Q = function Atb() {
        this.a.Q();
    };
    _.Wc = function Btb() {
        return new xtb(this);
    };
    _.kb = function Ctb(a) {
        return ttb(this, a);
    };
    _.V = function Dtb() {
        return this.a.Y() == 0;
    };
    _.mb = function Etb() {
        var a;
        return a = new Snb(this.a).a.bb().mb(), new Ynb(a);
    };
    _.nb = function Ftb(a) {
        return utb(this, a);
    };
    _.Y = function Gtb() {
        return this.a.Y();
    };
    _.w = function Htb() {
        return Ze(new Snb(this.a));
    };
    var eH = Nkb(Cyb, 'HashSet', 50);
    hI(418, 1, Oyb, Ntb);
    _.mb = function Otb() {
        return new Ptb(this);
    };
    _.c = 0;
    var gH = Nkb(Cyb, 'InternalHashCodeMap', 418);
    hI(312, 1, Ayb, Ptb);
    _.H = function Rtb() {
        return this.d = this.a[this.c++], this.d;
    };
    _.G = function Qtb() {
        var a;
        if (this.c < this.a.length) return true;
        a = this.b.next();
        if (!a.done) {
            this.a = a.value[1];
            this.c = 0;
            return true;
        }
        return false;
    };
    _.I = function Stb() {
        Mtb(this.e, this.d.yb());
        this.c != 0 && --this.c;
    };
    _.c = 0;
    _.d = null;
    var fH = Nkb(Cyb, 'InternalHashCodeMap/1', 312);
    var Xtb;
    hI(382, 1, Oyb, fub);
    _.mb = function gub() {
        return new hub(this);
    };
    _.c = 0;
    _.d = 0;
    var jH = Nkb(Cyb, 'InternalStringMap', 382);
    hI(293, 1, Ayb, hub);
    _.H = function jub() {
        return this.c = this.a, this.a = this.b.next(), new lub(this.d, this.c, this.d.d);
    };
    _.G = function iub() {
        return !this.a.done;
    };
    _.I = function kub() {
        eub(this.d, this.c.value[0]);
    };
    var hH = Nkb(Cyb, 'InternalStringMap/1', 293);
    hI(383, 652, Jyb, lub);
    _.yb = function mub() {
        return this.b.value[0];
    };
    _.zb = function nub() {
        if (this.a.d != this.c) return cub(this.a, this.b.value[0]);
        return this.b.value[1];
    };
    _.Ab = function oub(a) {
        return dub(this.a, this.b.value[0], a);
    };
    _.c = 0;
    var iH = Nkb(Cyb, 'InternalStringMap/2', 383);
    hI(155, 30, YAb, wub, xub);
    _.Q = function yub() {
        qub(this);
    };
    _.R = function zub(a) {
        return Qmb(this.c, a);
    };
    _.ab = function Aub(a) {
        var b;
        b = this.b.a;
        while(b != this.b){
            if (ovb(b.e, a)) return true;
            b = b.a;
        }
        return false;
    };
    _.bb = function Bub() {
        return new Lub(this);
    };
    _.cb = function Cub(a) {
        return rub(this, a);
    };
    _.db = function Dub(a, b) {
        return tub(this, a, b);
    };
    _.eb = function Eub(a) {
        return vub(this, a);
    };
    _.Y = function Fub() {
        return Zmb(this.c);
    };
    _.a = false;
    var nH = Nkb(Cyb, 'LinkedHashMap', 155);
    hI(176, 163, {
        210: 1,
        163: 1,
        176: 1,
        21: 1
    }, Iub, Jub);
    var kH = Nkb(Cyb, 'LinkedHashMap/ChainEntry', 176);
    hI(270, 641, Eyb, Lub);
    _.Q = function Mub() {
        qub(this.a);
    };
    _.kb = function Nub(a) {
        return Kub(this, a);
    };
    _.mb = function Oub() {
        return new Sub(this);
    };
    _.nb = function Pub(a) {
        var b;
        if (Kub(this, a)) {
            b = Wv(a, 21).yb();
            vub(this.a, b);
            return true;
        }
        return false;
    };
    _.Y = function Qub() {
        return Zmb(this.a.c);
    };
    var mH = Nkb(Cyb, 'LinkedHashMap/EntrySet', 270);
    hI(271, 1, Ayb, Sub);
    _.H = function Uub() {
        return Rub(this);
    };
    _.G = function Tub() {
        return this.b != this.c.a.b;
    };
    _.I = function Vub() {
        uxb(!!this.a);
        ksb(this.c.a.c, this);
        Hub(this.a);
        Wmb(this.c.a.c, this.a.d);
        lsb(this.c.a.c, this);
        this.a = null;
    };
    var lH = Nkb(Cyb, 'LinkedHashMap/EntrySet/EntryIterator', 271);
    hI(70, 50, ZAb, Wub, Xub, Yub);
    _.Wc = function Zub() {
        return new Yub(this);
    };
    var oH = Nkb(Cyb, 'LinkedHashSet', 70);
    hI(372, 1, Hyb, cvb);
    _.J = function dvb(a) {
        $ub(this, a);
    };
    _.G = function evb() {
        return this.b != this.d.c;
    };
    _.K = function fvb() {
        return this.b.b != this.d.a;
    };
    _.H = function gvb() {
        return _ub(this);
    };
    _.L = function hvb() {
        return this.a;
    };
    _.M = function ivb() {
        return avb(this);
    };
    _.N = function jvb() {
        return this.a - 1;
    };
    _.I = function kvb() {
        bvb(this);
    };
    _.O = function lvb(a) {
        uxb(!!this.c);
        this.c.c = a;
    };
    _.a = 0;
    _.c = null;
    var pH = Nkb(Cyb, 'LinkedList/ListIteratorImpl', 372);
    hI(259, 1, {}, mvb);
    var qH = Nkb(Cyb, 'LinkedList/Node', 259);
    hI(74, 72, {
        3: 1,
        54: 1,
        46: 1,
        74: 1
    }, nvb);
    var tH = Nkb(Cyb, 'NoSuchElementException', 74);
    hI(154, 1, {
        154: 1
    }, yvb, zvb);
    _.a = 0;
    _.b = 0;
    var qvb, rvb, svb = 0;
    var uH = Nkb(Cyb, 'Random', 154);
    hI(607, 647, cBb);
    _.rb = function Avb(a, b) {
        Dvb(a, this.a.c.length + 1);
        uU(this.a, a, b);
    };
    _.ib = function Bvb(a) {
        return vU(this.a, a);
    };
    _.jb = function Cvb(a) {
        return xU(this.a, a);
    };
    _.Q = function Evb() {
        this.a.c = xv(UF, syb, 1, 0, 4, 1);
    };
    _.kb = function Fvb(a) {
        return zU(this.a, a, 0) != -1;
    };
    _.lb = function Gvb(a) {
        return Xe(this.a, a);
    };
    _.sb = function Hvb(a) {
        Dvb(a, this.a.c.length);
        return yU(this.a, a);
    };
    _.V = function Ivb() {
        return this.a.c.length == 0;
    };
    _.mb = function Jvb() {
        return new Tob(this.a);
    };
    _.vb = function Kvb(a) {
        return Dvb(a, this.a.c.length), AU(this.a, a);
    };
    _.Xb = function Lvb(a, b) {
        CU(this.a, a, b);
    };
    _.wb = function Mvb(a, b) {
        Dvb(a, this.a.c.length);
        return DU(this.a, a, b);
    };
    _.Y = function Nvb() {
        return this.a.c.length;
    };
    _.xb = function Ovb(a, b) {
        return new Mnb(this.a, a, b);
    };
    _.ob = function Pvb() {
        return EU(this.a);
    };
    _.pb = function Qvb(a) {
        return FU(this.a, a);
    };
    _.w = function Rvb() {
        return Ze(this.a);
    };
    var GH = Nkb(Cyb, 'Vector', 607);
    hI(337, 607, cBb, Uvb);
    var vH = Nkb(Cyb, 'Stack', 337);
    hI(253, 639, Ryb, iwb, jwb);
    _.Q = function kwb() {
        Vvb(this);
    };
    _.bb = function lwb() {
        return new wwb(this);
    };
    _.db = function mwb(a, b) {
        return bwb(this, a, b);
    };
    _.eb = function nwb(a) {
        return cwb(this, a);
    };
    _.Y = function owb() {
        return this.c;
    };
    _.c = 0;
    var EH = Nkb(Cyb, 'TreeMap', 253);
    hI(182, 1, Ayb, rwb);
    _.H = function uwb() {
        return pwb(this);
    };
    _.G = function twb() {
        return Bnb(this.a);
    };
    _.I = function vwb() {
        qwb(this);
    };
    var wH = Nkb(Cyb, 'TreeMap/EntryIterator', 182);
    hI(209, 287, Eyb, wwb);
    _.Q = function xwb() {
        Vvb(this.a);
    };
    var xH = Nkb(Cyb, 'TreeMap/EntrySet', 209);
    hI(183, 163, {
        210: 1,
        163: 1,
        21: 1,
        183: 1
    }, ywb);
    _.b = false;
    var yH = Nkb(Cyb, 'TreeMap/Node', 183);
    hI(254, 1, {}, zwb);
    _.w = function Awb() {
        return 'State: mv=' + this.c + ' value=' + this.d + ' done=' + this.a + ' found=' + this.b;
    };
    _.a = false;
    _.b = false;
    _.c = false;
    var zH = Nkb(Cyb, 'TreeMap/State', 254);
    hI(138, 17, dBb, Gwb);
    _.Xc = function Hwb() {
        return false;
    };
    _.Yc = function Iwb() {
        return false;
    };
    var Bwb, Cwb, Dwb, Ewb;
    var DH = Okb(Cyb, 'TreeMap/SubMapType', 138, IF, Jwb);
    hI(352, 138, dBb, Kwb);
    _.Yc = function Lwb() {
        return true;
    };
    var AH = Okb(Cyb, 'TreeMap/SubMapType/1', 352, DH, null);
    hI(353, 138, dBb, Mwb);
    _.Xc = function Nwb() {
        return true;
    };
    _.Yc = function Owb() {
        return true;
    };
    var BH = Okb(Cyb, 'TreeMap/SubMapType/2', 353, DH, null);
    hI(354, 138, dBb, Pwb);
    _.Xc = function Qwb() {
        return true;
    };
    var CH = Okb(Cyb, 'TreeMap/SubMapType/3', 354, DH, null);
    hI(191, 641, {
        3: 1,
        22: 1,
        19: 1,
        18: 1,
        137: 1,
        191: 1
    }, Vwb, Wwb);
    _.ib = function Xwb(a) {
        return Rwb(this, a);
    };
    _.Q = function Ywb() {
        Vvb(this.a);
    };
    _.kb = function Zwb(a) {
        return vob(this.a, a);
    };
    _.mb = function $wb() {
        var a;
        return a = new rwb(new wwb(new Gob(this.a).a).b), new Mob(a);
    };
    _.nb = function _wb(a) {
        return Uwb(this, a);
    };
    _.Y = function axb() {
        return this.a.c;
    };
    var FH = Nkb(Cyb, 'TreeSet', 191);
    var sxb = 0;
    var Kxb, Lxb = 0, Mxb;
    var mw = Qkb('int', 'I');
    var KH = Qkb('boolean', 'Z');
    var jw = Qkb('char', 'C');
    var kw = Qkb('double', 'D');
    var lw = Qkb('float', 'F');
    var Rxb = zt;
    var gwtOnLoad = gwtOnLoad = dI;
    bI(lI);
    eI('permProps', [
        [
            [
                'locale',
                'default'
            ],
            [
                'user.agent',
                'gecko1_8'
            ]
        ]
    ]);
    var $moduleName, $moduleBase, $stats = function() {}, $sessionId = function() {};
    gwtOnLoad(null, 'klay', null);
})();

});


parcelRegister("cTjUK", function(module, exports) {

(function webpackUniversalModuleDefinition(root, factory) {
    module.exports = factory((parcelRequire("261Fc")));
})(module.exports, function(__WEBPACK_EXTERNAL_MODULE__4__) {
    return /******/ function(modules) {
        /******/ // The module cache
        /******/ var installedModules = {};
        /******/ /******/ // The require function
        /******/ function __webpack_require__(moduleId) {
            /******/ /******/ // Check if module is in cache
            /******/ if (installedModules[moduleId]) /******/ return installedModules[moduleId].exports;
            /******/ // Create a new module (and put it into the cache)
            /******/ var module1 = installedModules[moduleId] = {
                /******/ i: moduleId,
                /******/ l: false,
                /******/ exports: {}
            };
            /******/ /******/ // Execute the module function
            /******/ modules[moduleId].call(module1.exports, module1, module1.exports, __webpack_require__);
            /******/ /******/ // Flag the module as loaded
            /******/ module1.l = true;
            /******/ /******/ // Return the exports of the module
            /******/ return module1.exports;
        /******/ }
        /******/ /******/ /******/ // expose the modules object (__webpack_modules__)
        /******/ __webpack_require__.m = modules;
        /******/ /******/ // expose the module cache
        /******/ __webpack_require__.c = installedModules;
        /******/ /******/ // define getter function for harmony exports
        /******/ __webpack_require__.d = function(exports, name, getter) {
            /******/ if (!__webpack_require__.o(exports, name)) /******/ Object.defineProperty(exports, name, {
                enumerable: true,
                get: getter
            });
        /******/ };
        /******/ /******/ // define __esModule on exports
        /******/ __webpack_require__.r = function(exports) {
            /******/ if (typeof Symbol !== 'undefined' && Symbol.toStringTag) /******/ Object.defineProperty(exports, Symbol.toStringTag, {
                value: 'Module'
            });
            /******/ Object.defineProperty(exports, '__esModule', {
                value: true
            });
        /******/ };
        /******/ /******/ // create a fake namespace object
        /******/ // mode & 1: value is a module id, require it
        /******/ // mode & 2: merge all properties of value into the ns
        /******/ // mode & 4: return value when already ns object
        /******/ // mode & 8|1: behave like require
        /******/ __webpack_require__.t = function(value, mode) {
            /******/ if (mode & 1) value = __webpack_require__(value);
            /******/ if (mode & 8) return value;
            /******/ if (mode & 4 && typeof value === 'object' && value && value.__esModule) return value;
            /******/ var ns = Object.create(null);
            /******/ __webpack_require__.r(ns);
            /******/ Object.defineProperty(ns, 'default', {
                enumerable: true,
                value: value
            });
            /******/ if (mode & 2 && typeof value != 'string') for(var key in value)__webpack_require__.d(ns, key, (function(key) {
                return value[key];
            }).bind(null, key));
            /******/ return ns;
        /******/ };
        /******/ /******/ // getDefaultExport function for compatibility with non-harmony modules
        /******/ __webpack_require__.n = function(module1) {
            /******/ var getter = module1 && module1.__esModule ? /******/ function getDefault() {
                return module1['default'];
            } : /******/ function getModuleExports() {
                return module1;
            };
            /******/ __webpack_require__.d(getter, 'a', getter);
            /******/ return getter;
        /******/ };
        /******/ /******/ // Object.prototype.hasOwnProperty.call
        /******/ __webpack_require__.o = function(object, property) {
            return Object.prototype.hasOwnProperty.call(object, property);
        };
        /******/ /******/ // __webpack_public_path__
        /******/ __webpack_require__.p = "";
        /******/ /******/ /******/ // Load entry module and return exports
        /******/ return __webpack_require__(__webpack_require__.s = 0);
    /******/ }([
        /* 0 */ /***/ function(module1, exports, __webpack_require__) {
            var impl = __webpack_require__(1); // registers the extension on a cytoscape lib ref
            var register = function register(cytoscape1) {
                if (!cytoscape1) return;
                 // can't register if cytoscape unspecified
                cytoscape1('layout', 'dagre', impl); // register with cytoscape.js
            };
            if (typeof cytoscape !== 'undefined') // expose to global cytoscape (i.e. window.cytoscape)
            register(cytoscape);
            module1.exports = register;
        /***/ },
        /* 1 */ /***/ function(module1, exports, __webpack_require__) {
            function _typeof(obj) {
                "@babel/helpers - typeof";
                if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
                    return typeof obj;
                };
                else _typeof = function _typeof(obj) {
                    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                };
                return _typeof(obj);
            }
            var isFunction = function isFunction(o) {
                return typeof o === 'function';
            };
            var defaults = __webpack_require__(2);
            var assign = __webpack_require__(3);
            var dagre = __webpack_require__(4); // constructor
            // options : object containing layout options
            function DagreLayout(options) {
                this.options = assign({}, defaults, options);
            } // runs the layout
            DagreLayout.prototype.run = function() {
                var options = this.options;
                var layout = this;
                var cy = options.cy; // cy is automatically populated for us in the constructor
                var eles = options.eles;
                var getVal = function getVal(ele, val) {
                    return isFunction(val) ? val.apply(ele, [
                        ele
                    ]) : val;
                };
                var bb = options.boundingBox || {
                    x1: 0,
                    y1: 0,
                    w: cy.width(),
                    h: cy.height()
                };
                if (bb.x2 === undefined) bb.x2 = bb.x1 + bb.w;
                if (bb.w === undefined) bb.w = bb.x2 - bb.x1;
                if (bb.y2 === undefined) bb.y2 = bb.y1 + bb.h;
                if (bb.h === undefined) bb.h = bb.y2 - bb.y1;
                var g = new dagre.graphlib.Graph({
                    multigraph: true,
                    compound: true
                });
                var gObj = {};
                var setGObj = function setGObj(name, val) {
                    if (val != null) gObj[name] = val;
                };
                setGObj('nodesep', options.nodeSep);
                setGObj('edgesep', options.edgeSep);
                setGObj('ranksep', options.rankSep);
                setGObj('rankdir', options.rankDir);
                setGObj('align', options.align);
                setGObj('ranker', options.ranker);
                setGObj('acyclicer', options.acyclicer);
                g.setGraph(gObj);
                g.setDefaultEdgeLabel(function() {
                    return {};
                });
                g.setDefaultNodeLabel(function() {
                    return {};
                }); // add nodes to dagre
                var nodes = eles.nodes();
                if (isFunction(options.sort)) nodes = nodes.sort(options.sort);
                for(var i = 0; i < nodes.length; i++){
                    var node = nodes[i];
                    var nbb = node.layoutDimensions(options);
                    g.setNode(node.id(), {
                        width: nbb.w,
                        height: nbb.h,
                        name: node.id()
                    }); // console.log( g.node(node.id()) );
                } // set compound parents
                for(var _i = 0; _i < nodes.length; _i++){
                    var _node = nodes[_i];
                    if (_node.isChild()) g.setParent(_node.id(), _node.parent().id());
                } // add edges to dagre
                var edges = eles.edges().stdFilter(function(edge) {
                    return !edge.source().isParent() && !edge.target().isParent(); // dagre can't handle edges on compound nodes
                });
                if (isFunction(options.sort)) edges = edges.sort(options.sort);
                for(var _i2 = 0; _i2 < edges.length; _i2++){
                    var edge = edges[_i2];
                    g.setEdge(edge.source().id(), edge.target().id(), {
                        minlen: getVal(edge, options.minLen),
                        weight: getVal(edge, options.edgeWeight),
                        name: edge.id()
                    }, edge.id()); // console.log( g.edge(edge.source().id(), edge.target().id(), edge.id()) );
                }
                dagre.layout(g);
                var gNodeIds = g.nodes();
                for(var _i3 = 0; _i3 < gNodeIds.length; _i3++){
                    var id = gNodeIds[_i3];
                    var n = g.node(id);
                    cy.getElementById(id).scratch().dagre = n;
                }
                var dagreBB;
                if (options.boundingBox) {
                    dagreBB = {
                        x1: Infinity,
                        x2: -Infinity,
                        y1: Infinity,
                        y2: -Infinity
                    };
                    nodes.forEach(function(node) {
                        var dModel = node.scratch().dagre;
                        dagreBB.x1 = Math.min(dagreBB.x1, dModel.x);
                        dagreBB.x2 = Math.max(dagreBB.x2, dModel.x);
                        dagreBB.y1 = Math.min(dagreBB.y1, dModel.y);
                        dagreBB.y2 = Math.max(dagreBB.y2, dModel.y);
                    });
                    dagreBB.w = dagreBB.x2 - dagreBB.x1;
                    dagreBB.h = dagreBB.y2 - dagreBB.y1;
                } else dagreBB = bb;
                var constrainPos = function constrainPos(p) {
                    if (options.boundingBox) {
                        var xPct = dagreBB.w === 0 ? 0 : (p.x - dagreBB.x1) / dagreBB.w;
                        var yPct = dagreBB.h === 0 ? 0 : (p.y - dagreBB.y1) / dagreBB.h;
                        return {
                            x: bb.x1 + xPct * bb.w,
                            y: bb.y1 + yPct * bb.h
                        };
                    } else return p;
                };
                nodes.layoutPositions(layout, options, function(ele) {
                    ele = _typeof(ele) === "object" ? ele : this;
                    var dModel = ele.scratch().dagre;
                    return constrainPos({
                        x: dModel.x,
                        y: dModel.y
                    });
                });
                return this; // chaining
            };
            module1.exports = DagreLayout;
        /***/ },
        /* 2 */ /***/ function(module1, exports) {
            var defaults = {
                // dagre algo options, uses default value on undefined
                nodeSep: undefined,
                // the separation between adjacent nodes in the same rank
                edgeSep: undefined,
                // the separation between adjacent edges in the same rank
                rankSep: undefined,
                // the separation between adjacent nodes in the same rank
                rankDir: undefined,
                // 'TB' for top to bottom flow, 'LR' for left to right,
                align: undefined,
                // alignment for rank nodes. Can be 'UL', 'UR', 'DL', or 'DR', where U = up, D = down, L = left, and R = right
                acyclicer: undefined,
                // If set to 'greedy', uses a greedy heuristic for finding a feedback arc set for a graph.
                // A feedback arc set is a set of edges that can be removed to make a graph acyclic.
                ranker: undefined,
                // Type of algorithm to assigns a rank to each node in the input graph.
                // Possible values: network-simplex, tight-tree or longest-path
                minLen: function minLen(edge) {
                    return 1;
                },
                // number of ranks to keep between the source and target of the edge
                edgeWeight: function edgeWeight(edge) {
                    return 1;
                },
                // higher weight edges are generally made shorter and straighter than lower weight edges
                // general layout options
                fit: true,
                // whether to fit to viewport
                padding: 30,
                // fit padding
                spacingFactor: undefined,
                // Applies a multiplicative factor (>0) to expand or compress the overall area that the nodes take up
                nodeDimensionsIncludeLabels: false,
                // whether labels should be included in determining the space used by a node
                animate: false,
                // whether to transition the node positions
                animateFilter: function animateFilter(node, i) {
                    return true;
                },
                // whether to animate specific nodes when animation is on; non-animated nodes immediately go to their final positions
                animationDuration: 500,
                // duration of animation in ms if enabled
                animationEasing: undefined,
                // easing of animation if enabled
                boundingBox: undefined,
                // constrain layout bounds; { x1, y1, x2, y2 } or { x1, y1, w, h }
                transform: function transform(node, pos) {
                    return pos;
                },
                // a function that applies a transform to the final node position
                ready: function ready() {},
                // on layoutready
                sort: undefined,
                // a sorting function to order the nodes and edges; e.g. function(a, b){ return a.data('weight') - b.data('weight') }
                // because cytoscape dagre creates a directed graph, and directed graphs use the node order as a tie breaker when
                // defining the topology of a graph, this sort function can help ensure the correct order of the nodes/edges.
                // this feature is most useful when adding and removing the same nodes and edges multiple times in a graph.
                stop: function stop() {} // on layoutstop
            };
            module1.exports = defaults;
        /***/ },
        /* 3 */ /***/ function(module1, exports) {
            // Simple, internal Object.assign() polyfill for options objects etc.
            module1.exports = Object.assign != null ? Object.assign.bind(Object) : function(tgt) {
                for(var _len = arguments.length, srcs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)srcs[_key - 1] = arguments[_key];
                srcs.forEach(function(src) {
                    Object.keys(src).forEach(function(k) {
                        return tgt[k] = src[k];
                    });
                });
                return tgt;
            };
        /***/ },
        /* 4 */ /***/ function(module1, exports) {
            module1.exports = __WEBPACK_EXTERNAL_MODULE__4__;
        /***/ }
    ]);
});

});
parcelRegister("261Fc", function(module, exports) {
/*
Copyright (c) 2012-2014 Chris Pettitt

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in
all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
THE SOFTWARE.
*/ 





module.exports = {
    graphlib: (parcelRequire("6mwJ2")),
    layout: (parcelRequire("VZEn7")),
    debug: (parcelRequire("8XBdx")),
    util: {
        time: (parcelRequire("1kMKg")).time,
        notime: (parcelRequire("1kMKg")).notime
    },
    version: (parcelRequire("9Grre"))
};

});
parcelRegister("6mwJ2", function(module, exports) {
/* global window */ var $4a1e2ebf410e6993$var$graphlib;

try {
    $4a1e2ebf410e6993$var$graphlib = (parcelRequire("2B9Zv"));
} catch (e) {
// continue regardless of error
}
if (!$4a1e2ebf410e6993$var$graphlib) $4a1e2ebf410e6993$var$graphlib = window.graphlib;
module.exports = $4a1e2ebf410e6993$var$graphlib;

});
parcelRegister("2B9Zv", function(module, exports) {
/**
 * Copyright (c) 2014, Chris Pettitt
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice, this
 * list of conditions and the following disclaimer.
 *
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 * this list of conditions and the following disclaimer in the documentation
 * and/or other materials provided with the distribution.
 *
 * 3. Neither the name of the copyright holder nor the names of its contributors
 * may be used to endorse or promote products derived from this software without
 * specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
 * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE
 * FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
 * DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
 * SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
 * CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY,
 * OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
 * OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */ 
var $5j6So = parcelRequire("5j6So");


module.exports = {
    Graph: $5j6So.Graph,
    json: (parcelRequire("cOdIh")),
    alg: (parcelRequire("jm1Oa")),
    version: $5j6So.version
};

});
parcelRegister("5j6So", function(module, exports) {
// Includes only the "core" of graphlib


module.exports = {
    Graph: (parcelRequire("4JZcb")),
    version: (parcelRequire("5LcVV"))
};

});
parcelRegister("4JZcb", function(module, exports) {
"use strict";

var $dOCPl = parcelRequire("dOCPl");
module.exports = $373ad590b7c1733e$var$Graph;
var $373ad590b7c1733e$var$DEFAULT_EDGE_NAME = "\x00";
var $373ad590b7c1733e$var$GRAPH_NODE = "\x00";
var $373ad590b7c1733e$var$EDGE_KEY_DELIM = "\x01";
// Implementation notes:
//
//  * Node id query functions should return string ids for the nodes
//  * Edge id query functions should return an "edgeObj", edge object, that is
//    composed of enough information to uniquely identify an edge: {v, w, name}.
//  * Internally we use an "edgeId", a stringified form of the edgeObj, to
//    reference edges. This is because we need a performant way to look these
//    edges up and, object properties, which have string keys, are the closest
//    we're going to get to a performant hashtable in JavaScript.
function $373ad590b7c1733e$var$Graph(opts) {
    this._isDirected = $dOCPl.has(opts, "directed") ? opts.directed : true;
    this._isMultigraph = $dOCPl.has(opts, "multigraph") ? opts.multigraph : false;
    this._isCompound = $dOCPl.has(opts, "compound") ? opts.compound : false;
    // Label for the graph itself
    this._label = undefined;
    // Defaults to be set when creating a new node
    this._defaultNodeLabelFn = $dOCPl.constant(undefined);
    // Defaults to be set when creating a new edge
    this._defaultEdgeLabelFn = $dOCPl.constant(undefined);
    // v -> label
    this._nodes = {};
    if (this._isCompound) {
        // v -> parent
        this._parent = {};
        // v -> children
        this._children = {};
        this._children[$373ad590b7c1733e$var$GRAPH_NODE] = {};
    }
    // v -> edgeObj
    this._in = {};
    // u -> v -> Number
    this._preds = {};
    // v -> edgeObj
    this._out = {};
    // v -> w -> Number
    this._sucs = {};
    // e -> edgeObj
    this._edgeObjs = {};
    // e -> label
    this._edgeLabels = {};
}
/* Number of nodes in the graph. Should only be changed by the implementation. */ $373ad590b7c1733e$var$Graph.prototype._nodeCount = 0;
/* Number of edges in the graph. Should only be changed by the implementation. */ $373ad590b7c1733e$var$Graph.prototype._edgeCount = 0;
/* === Graph functions ========= */ $373ad590b7c1733e$var$Graph.prototype.isDirected = function() {
    return this._isDirected;
};
$373ad590b7c1733e$var$Graph.prototype.isMultigraph = function() {
    return this._isMultigraph;
};
$373ad590b7c1733e$var$Graph.prototype.isCompound = function() {
    return this._isCompound;
};
$373ad590b7c1733e$var$Graph.prototype.setGraph = function(label) {
    this._label = label;
    return this;
};
$373ad590b7c1733e$var$Graph.prototype.graph = function() {
    return this._label;
};
/* === Node functions ========== */ $373ad590b7c1733e$var$Graph.prototype.setDefaultNodeLabel = function(newDefault) {
    if (!$dOCPl.isFunction(newDefault)) newDefault = $dOCPl.constant(newDefault);
    this._defaultNodeLabelFn = newDefault;
    return this;
};
$373ad590b7c1733e$var$Graph.prototype.nodeCount = function() {
    return this._nodeCount;
};
$373ad590b7c1733e$var$Graph.prototype.nodes = function() {
    return $dOCPl.keys(this._nodes);
};
$373ad590b7c1733e$var$Graph.prototype.sources = function() {
    var self = this;
    return $dOCPl.filter(this.nodes(), function(v) {
        return $dOCPl.isEmpty(self._in[v]);
    });
};
$373ad590b7c1733e$var$Graph.prototype.sinks = function() {
    var self = this;
    return $dOCPl.filter(this.nodes(), function(v) {
        return $dOCPl.isEmpty(self._out[v]);
    });
};
$373ad590b7c1733e$var$Graph.prototype.setNodes = function(vs, value) {
    var args = arguments;
    var self = this;
    $dOCPl.each(vs, function(v) {
        if (args.length > 1) self.setNode(v, value);
        else self.setNode(v);
    });
    return this;
};
$373ad590b7c1733e$var$Graph.prototype.setNode = function(v, value) {
    if ($dOCPl.has(this._nodes, v)) {
        if (arguments.length > 1) this._nodes[v] = value;
        return this;
    }
    this._nodes[v] = arguments.length > 1 ? value : this._defaultNodeLabelFn(v);
    if (this._isCompound) {
        this._parent[v] = $373ad590b7c1733e$var$GRAPH_NODE;
        this._children[v] = {};
        this._children[$373ad590b7c1733e$var$GRAPH_NODE][v] = true;
    }
    this._in[v] = {};
    this._preds[v] = {};
    this._out[v] = {};
    this._sucs[v] = {};
    ++this._nodeCount;
    return this;
};
$373ad590b7c1733e$var$Graph.prototype.node = function(v) {
    return this._nodes[v];
};
$373ad590b7c1733e$var$Graph.prototype.hasNode = function(v) {
    return $dOCPl.has(this._nodes, v);
};
$373ad590b7c1733e$var$Graph.prototype.removeNode = function(v) {
    var self = this;
    if ($dOCPl.has(this._nodes, v)) {
        var removeEdge = function(e) {
            self.removeEdge(self._edgeObjs[e]);
        };
        delete this._nodes[v];
        if (this._isCompound) {
            this._removeFromParentsChildList(v);
            delete this._parent[v];
            $dOCPl.each(this.children(v), function(child) {
                self.setParent(child);
            });
            delete this._children[v];
        }
        $dOCPl.each($dOCPl.keys(this._in[v]), removeEdge);
        delete this._in[v];
        delete this._preds[v];
        $dOCPl.each($dOCPl.keys(this._out[v]), removeEdge);
        delete this._out[v];
        delete this._sucs[v];
        --this._nodeCount;
    }
    return this;
};
$373ad590b7c1733e$var$Graph.prototype.setParent = function(v, parent) {
    if (!this._isCompound) throw new Error("Cannot set parent in a non-compound graph");
    if ($dOCPl.isUndefined(parent)) parent = $373ad590b7c1733e$var$GRAPH_NODE;
    else {
        // Coerce parent to string
        parent += "";
        for(var ancestor = parent; !$dOCPl.isUndefined(ancestor); ancestor = this.parent(ancestor)){
            if (ancestor === v) throw new Error("Setting " + parent + " as parent of " + v + " would create a cycle");
        }
        this.setNode(parent);
    }
    this.setNode(v);
    this._removeFromParentsChildList(v);
    this._parent[v] = parent;
    this._children[parent][v] = true;
    return this;
};
$373ad590b7c1733e$var$Graph.prototype._removeFromParentsChildList = function(v) {
    delete this._children[this._parent[v]][v];
};
$373ad590b7c1733e$var$Graph.prototype.parent = function(v) {
    if (this._isCompound) {
        var parent = this._parent[v];
        if (parent !== $373ad590b7c1733e$var$GRAPH_NODE) return parent;
    }
};
$373ad590b7c1733e$var$Graph.prototype.children = function(v) {
    if ($dOCPl.isUndefined(v)) v = $373ad590b7c1733e$var$GRAPH_NODE;
    if (this._isCompound) {
        var children = this._children[v];
        if (children) return $dOCPl.keys(children);
    } else if (v === $373ad590b7c1733e$var$GRAPH_NODE) return this.nodes();
    else if (this.hasNode(v)) return [];
};
$373ad590b7c1733e$var$Graph.prototype.predecessors = function(v) {
    var predsV = this._preds[v];
    if (predsV) return $dOCPl.keys(predsV);
};
$373ad590b7c1733e$var$Graph.prototype.successors = function(v) {
    var sucsV = this._sucs[v];
    if (sucsV) return $dOCPl.keys(sucsV);
};
$373ad590b7c1733e$var$Graph.prototype.neighbors = function(v) {
    var preds = this.predecessors(v);
    if (preds) return $dOCPl.union(preds, this.successors(v));
};
$373ad590b7c1733e$var$Graph.prototype.isLeaf = function(v) {
    var neighbors;
    if (this.isDirected()) neighbors = this.successors(v);
    else neighbors = this.neighbors(v);
    return neighbors.length === 0;
};
$373ad590b7c1733e$var$Graph.prototype.filterNodes = function(filter) {
    var copy = new this.constructor({
        directed: this._isDirected,
        multigraph: this._isMultigraph,
        compound: this._isCompound
    });
    copy.setGraph(this.graph());
    var self = this;
    $dOCPl.each(this._nodes, function(value, v) {
        if (filter(v)) copy.setNode(v, value);
    });
    $dOCPl.each(this._edgeObjs, function(e) {
        if (copy.hasNode(e.v) && copy.hasNode(e.w)) copy.setEdge(e, self.edge(e));
    });
    var parents = {};
    function findParent(v) {
        var parent = self.parent(v);
        if (parent === undefined || copy.hasNode(parent)) {
            parents[v] = parent;
            return parent;
        } else if (parent in parents) return parents[parent];
        else return findParent(parent);
    }
    if (this._isCompound) $dOCPl.each(copy.nodes(), function(v) {
        copy.setParent(v, findParent(v));
    });
    return copy;
};
/* === Edge functions ========== */ $373ad590b7c1733e$var$Graph.prototype.setDefaultEdgeLabel = function(newDefault) {
    if (!$dOCPl.isFunction(newDefault)) newDefault = $dOCPl.constant(newDefault);
    this._defaultEdgeLabelFn = newDefault;
    return this;
};
$373ad590b7c1733e$var$Graph.prototype.edgeCount = function() {
    return this._edgeCount;
};
$373ad590b7c1733e$var$Graph.prototype.edges = function() {
    return $dOCPl.values(this._edgeObjs);
};
$373ad590b7c1733e$var$Graph.prototype.setPath = function(vs, value) {
    var self = this;
    var args = arguments;
    $dOCPl.reduce(vs, function(v, w) {
        if (args.length > 1) self.setEdge(v, w, value);
        else self.setEdge(v, w);
        return w;
    });
    return this;
};
/*
 * setEdge(v, w, [value, [name]])
 * setEdge({ v, w, [name] }, [value])
 */ $373ad590b7c1733e$var$Graph.prototype.setEdge = function() {
    var v, w, name, value;
    var valueSpecified = false;
    var arg0 = arguments[0];
    if (typeof arg0 === "object" && arg0 !== null && "v" in arg0) {
        v = arg0.v;
        w = arg0.w;
        name = arg0.name;
        if (arguments.length === 2) {
            value = arguments[1];
            valueSpecified = true;
        }
    } else {
        v = arg0;
        w = arguments[1];
        name = arguments[3];
        if (arguments.length > 2) {
            value = arguments[2];
            valueSpecified = true;
        }
    }
    v = "" + v;
    w = "" + w;
    if (!$dOCPl.isUndefined(name)) name = "" + name;
    var e = $373ad590b7c1733e$var$edgeArgsToId(this._isDirected, v, w, name);
    if ($dOCPl.has(this._edgeLabels, e)) {
        if (valueSpecified) this._edgeLabels[e] = value;
        return this;
    }
    if (!$dOCPl.isUndefined(name) && !this._isMultigraph) throw new Error("Cannot set a named edge when isMultigraph = false");
    // It didn't exist, so we need to create it.
    // First ensure the nodes exist.
    this.setNode(v);
    this.setNode(w);
    this._edgeLabels[e] = valueSpecified ? value : this._defaultEdgeLabelFn(v, w, name);
    var edgeObj = $373ad590b7c1733e$var$edgeArgsToObj(this._isDirected, v, w, name);
    // Ensure we add undirected edges in a consistent way.
    v = edgeObj.v;
    w = edgeObj.w;
    Object.freeze(edgeObj);
    this._edgeObjs[e] = edgeObj;
    $373ad590b7c1733e$var$incrementOrInitEntry(this._preds[w], v);
    $373ad590b7c1733e$var$incrementOrInitEntry(this._sucs[v], w);
    this._in[w][e] = edgeObj;
    this._out[v][e] = edgeObj;
    this._edgeCount++;
    return this;
};
$373ad590b7c1733e$var$Graph.prototype.edge = function(v, w, name) {
    var e = arguments.length === 1 ? $373ad590b7c1733e$var$edgeObjToId(this._isDirected, arguments[0]) : $373ad590b7c1733e$var$edgeArgsToId(this._isDirected, v, w, name);
    return this._edgeLabels[e];
};
$373ad590b7c1733e$var$Graph.prototype.hasEdge = function(v, w, name) {
    var e = arguments.length === 1 ? $373ad590b7c1733e$var$edgeObjToId(this._isDirected, arguments[0]) : $373ad590b7c1733e$var$edgeArgsToId(this._isDirected, v, w, name);
    return $dOCPl.has(this._edgeLabels, e);
};
$373ad590b7c1733e$var$Graph.prototype.removeEdge = function(v, w, name) {
    var e = arguments.length === 1 ? $373ad590b7c1733e$var$edgeObjToId(this._isDirected, arguments[0]) : $373ad590b7c1733e$var$edgeArgsToId(this._isDirected, v, w, name);
    var edge = this._edgeObjs[e];
    if (edge) {
        v = edge.v;
        w = edge.w;
        delete this._edgeLabels[e];
        delete this._edgeObjs[e];
        $373ad590b7c1733e$var$decrementOrRemoveEntry(this._preds[w], v);
        $373ad590b7c1733e$var$decrementOrRemoveEntry(this._sucs[v], w);
        delete this._in[w][e];
        delete this._out[v][e];
        this._edgeCount--;
    }
    return this;
};
$373ad590b7c1733e$var$Graph.prototype.inEdges = function(v, u) {
    var inV = this._in[v];
    if (inV) {
        var edges = $dOCPl.values(inV);
        if (!u) return edges;
        return $dOCPl.filter(edges, function(edge) {
            return edge.v === u;
        });
    }
};
$373ad590b7c1733e$var$Graph.prototype.outEdges = function(v, w) {
    var outV = this._out[v];
    if (outV) {
        var edges = $dOCPl.values(outV);
        if (!w) return edges;
        return $dOCPl.filter(edges, function(edge) {
            return edge.w === w;
        });
    }
};
$373ad590b7c1733e$var$Graph.prototype.nodeEdges = function(v, w) {
    var inEdges = this.inEdges(v, w);
    if (inEdges) return inEdges.concat(this.outEdges(v, w));
};
function $373ad590b7c1733e$var$incrementOrInitEntry(map, k) {
    if (map[k]) map[k]++;
    else map[k] = 1;
}
function $373ad590b7c1733e$var$decrementOrRemoveEntry(map, k) {
    if (!--map[k]) delete map[k];
}
function $373ad590b7c1733e$var$edgeArgsToId(isDirected, v_, w_, name) {
    var v = "" + v_;
    var w = "" + w_;
    if (!isDirected && v > w) {
        var tmp = v;
        v = w;
        w = tmp;
    }
    return v + $373ad590b7c1733e$var$EDGE_KEY_DELIM + w + $373ad590b7c1733e$var$EDGE_KEY_DELIM + ($dOCPl.isUndefined(name) ? $373ad590b7c1733e$var$DEFAULT_EDGE_NAME : name);
}
function $373ad590b7c1733e$var$edgeArgsToObj(isDirected, v_, w_, name) {
    var v = "" + v_;
    var w = "" + w_;
    if (!isDirected && v > w) {
        var tmp = v;
        v = w;
        w = tmp;
    }
    var edgeObj = {
        v: v,
        w: w
    };
    if (name) edgeObj.name = name;
    return edgeObj;
}
function $373ad590b7c1733e$var$edgeObjToId(isDirected, edgeObj) {
    return $373ad590b7c1733e$var$edgeArgsToId(isDirected, edgeObj.v, edgeObj.w, edgeObj.name);
}

});
parcelRegister("dOCPl", function(module, exports) {
/* global window */ var $a0ee10204aed0d3b$var$lodash;
















try {
    $a0ee10204aed0d3b$var$lodash = {
        clone: (parcelRequire("bTYY2")),
        constant: (parcelRequire("9HRmE")),
        each: (parcelRequire("5kE3T")),
        filter: (parcelRequire("jLJR7")),
        has: (parcelRequire("jplJt")),
        isArray: (parcelRequire("o8HxT")),
        isEmpty: (parcelRequire("44Pmt")),
        isFunction: (parcelRequire("01ubZ")),
        isUndefined: (parcelRequire("enrJD")),
        keys: (parcelRequire("LAMcS")),
        map: (parcelRequire("437iZ")),
        reduce: (parcelRequire("2KuAh")),
        size: (parcelRequire("2RKXE")),
        transform: (parcelRequire("bGcIb")),
        union: (parcelRequire("1c10x")),
        values: (parcelRequire("7D6Gq"))
    };
} catch (e) {
// continue regardless of error
}
if (!$a0ee10204aed0d3b$var$lodash) $a0ee10204aed0d3b$var$lodash = window._;
module.exports = $a0ee10204aed0d3b$var$lodash;

});
parcelRegister("bTYY2", function(module, exports) {

var $kqX4j = parcelRequire("kqX4j");
/** Used to compose bitmasks for cloning. */ var $8aa41f9fe04bb5cc$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * Creates a shallow clone of `value`.
 *
 * **Note:** This method is loosely based on the
 * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
 * and supports cloning arrays, array buffers, booleans, date objects, maps,
 * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
 * arrays. The own enumerable properties of `arguments` objects are cloned
 * as plain objects. An empty object is returned for uncloneable values such
 * as error objects, functions, DOM nodes, and WeakMaps.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to clone.
 * @returns {*} Returns the cloned value.
 * @see _.cloneDeep
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var shallow = _.clone(objects);
 * console.log(shallow[0] === objects[0]);
 * // => true
 */ function $8aa41f9fe04bb5cc$var$clone(value) {
    return $kqX4j(value, $8aa41f9fe04bb5cc$var$CLONE_SYMBOLS_FLAG);
}
module.exports = $8aa41f9fe04bb5cc$var$clone;

});
parcelRegister("kqX4j", function(module, exports) {

var $g779E = parcelRequire("g779E");

var $bFZGr = parcelRequire("bFZGr");

var $5i71d = parcelRequire("5i71d");

var $XXQDs = parcelRequire("XXQDs");

var $1djPb = parcelRequire("1djPb");

var $uQ1Em = parcelRequire("uQ1Em");

var $aA0pv = parcelRequire("aA0pv");

var $hIxJe = parcelRequire("hIxJe");

var $7n7lE = parcelRequire("7n7lE");

var $apVCl = parcelRequire("apVCl");

var $i0kKc = parcelRequire("i0kKc");

var $67A6V = parcelRequire("67A6V");

var $4UmGC = parcelRequire("4UmGC");

var $btuqH = parcelRequire("btuqH");

var $dFJsF = parcelRequire("dFJsF");

var $o8HxT = parcelRequire("o8HxT");

var $f504n = parcelRequire("f504n");

var $eJObK = parcelRequire("eJObK");

var $lsJ54 = parcelRequire("lsJ54");

var $jZm8C = parcelRequire("jZm8C");

var $LAMcS = parcelRequire("LAMcS");

var $f4lqP = parcelRequire("f4lqP");
/** Used to compose bitmasks for cloning. */ var $ee040e257a097984$var$CLONE_DEEP_FLAG = 1, $ee040e257a097984$var$CLONE_FLAT_FLAG = 2, $ee040e257a097984$var$CLONE_SYMBOLS_FLAG = 4;
/** `Object#toString` result references. */ var $ee040e257a097984$var$argsTag = '[object Arguments]', $ee040e257a097984$var$arrayTag = '[object Array]', $ee040e257a097984$var$boolTag = '[object Boolean]', $ee040e257a097984$var$dateTag = '[object Date]', $ee040e257a097984$var$errorTag = '[object Error]', $ee040e257a097984$var$funcTag = '[object Function]', $ee040e257a097984$var$genTag = '[object GeneratorFunction]', $ee040e257a097984$var$mapTag = '[object Map]', $ee040e257a097984$var$numberTag = '[object Number]', $ee040e257a097984$var$objectTag = '[object Object]', $ee040e257a097984$var$regexpTag = '[object RegExp]', $ee040e257a097984$var$setTag = '[object Set]', $ee040e257a097984$var$stringTag = '[object String]', $ee040e257a097984$var$symbolTag = '[object Symbol]', $ee040e257a097984$var$weakMapTag = '[object WeakMap]';
var $ee040e257a097984$var$arrayBufferTag = '[object ArrayBuffer]', $ee040e257a097984$var$dataViewTag = '[object DataView]', $ee040e257a097984$var$float32Tag = '[object Float32Array]', $ee040e257a097984$var$float64Tag = '[object Float64Array]', $ee040e257a097984$var$int8Tag = '[object Int8Array]', $ee040e257a097984$var$int16Tag = '[object Int16Array]', $ee040e257a097984$var$int32Tag = '[object Int32Array]', $ee040e257a097984$var$uint8Tag = '[object Uint8Array]', $ee040e257a097984$var$uint8ClampedTag = '[object Uint8ClampedArray]', $ee040e257a097984$var$uint16Tag = '[object Uint16Array]', $ee040e257a097984$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values supported by `_.clone`. */ var $ee040e257a097984$var$cloneableTags = {};
$ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$argsTag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$arrayTag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$arrayBufferTag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$dataViewTag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$boolTag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$dateTag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$float32Tag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$float64Tag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$int8Tag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$int16Tag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$int32Tag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$mapTag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$numberTag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$objectTag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$regexpTag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$setTag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$stringTag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$symbolTag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$uint8Tag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$uint8ClampedTag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$uint16Tag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$uint32Tag] = true;
$ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$errorTag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$funcTag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$weakMapTag] = false;
/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */ function $ee040e257a097984$var$baseClone(value, bitmask, customizer, key, object, stack) {
    var result, isDeep = bitmask & $ee040e257a097984$var$CLONE_DEEP_FLAG, isFlat = bitmask & $ee040e257a097984$var$CLONE_FLAT_FLAG, isFull = bitmask & $ee040e257a097984$var$CLONE_SYMBOLS_FLAG;
    if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
    if (result !== undefined) return result;
    if (!$lsJ54(value)) return value;
    var isArr = $o8HxT(value);
    if (isArr) {
        result = $4UmGC(value);
        if (!isDeep) return $aA0pv(value, result);
    } else {
        var tag = $67A6V(value), isFunc = tag == $ee040e257a097984$var$funcTag || tag == $ee040e257a097984$var$genTag;
        if ($f504n(value)) return $uQ1Em(value, isDeep);
        if (tag == $ee040e257a097984$var$objectTag || tag == $ee040e257a097984$var$argsTag || isFunc && !object) {
            result = isFlat || isFunc ? {} : $dFJsF(value);
            if (!isDeep) return isFlat ? $7n7lE(value, $1djPb(result, value)) : $hIxJe(value, $XXQDs(result, value));
        } else {
            if (!$ee040e257a097984$var$cloneableTags[tag]) return object ? value : {};
            result = $btuqH(value, tag, isDeep);
        }
    }
    // Check for circular references and return its corresponding clone.
    stack || (stack = new $g779E);
    var stacked = stack.get(value);
    if (stacked) return stacked;
    stack.set(value, result);
    if ($jZm8C(value)) value.forEach(function(subValue) {
        result.add($ee040e257a097984$var$baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
    else if ($eJObK(value)) value.forEach(function(subValue, key) {
        result.set(key, $ee040e257a097984$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    var keysFunc = isFull ? isFlat ? $i0kKc : $apVCl : isFlat ? $f4lqP : $LAMcS;
    var props = isArr ? undefined : keysFunc(value);
    $bFZGr(props || value, function(subValue, key) {
        if (props) {
            key = subValue;
            subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        $5i71d(result, key, $ee040e257a097984$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    return result;
}
module.exports = $ee040e257a097984$var$baseClone;

});
parcelRegister("g779E", function(module, exports) {

var $iYOpJ = parcelRequire("iYOpJ");

var $jZSEZ = parcelRequire("jZSEZ");

var $fm6cW = parcelRequire("fm6cW");

var $b3G1Z = parcelRequire("b3G1Z");

var $5DEbp = parcelRequire("5DEbp");

var $czPDU = parcelRequire("czPDU");
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $bbb2d98cae25b61a$var$Stack(entries) {
    var data = this.__data__ = new $iYOpJ(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$bbb2d98cae25b61a$var$Stack.prototype.clear = $jZSEZ;
$bbb2d98cae25b61a$var$Stack.prototype['delete'] = $fm6cW;
$bbb2d98cae25b61a$var$Stack.prototype.get = $b3G1Z;
$bbb2d98cae25b61a$var$Stack.prototype.has = $5DEbp;
$bbb2d98cae25b61a$var$Stack.prototype.set = $czPDU;
module.exports = $bbb2d98cae25b61a$var$Stack;

});
parcelRegister("iYOpJ", function(module, exports) {

var $bjX1n = parcelRequire("bjX1n");

var $i2OST = parcelRequire("i2OST");

var $fmh4d = parcelRequire("fmh4d");

var $3AXiV = parcelRequire("3AXiV");

var $lWpQQ = parcelRequire("lWpQQ");
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $dd14efc87ba1cd5b$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$dd14efc87ba1cd5b$var$ListCache.prototype.clear = $bjX1n;
$dd14efc87ba1cd5b$var$ListCache.prototype['delete'] = $i2OST;
$dd14efc87ba1cd5b$var$ListCache.prototype.get = $fmh4d;
$dd14efc87ba1cd5b$var$ListCache.prototype.has = $3AXiV;
$dd14efc87ba1cd5b$var$ListCache.prototype.set = $lWpQQ;
module.exports = $dd14efc87ba1cd5b$var$ListCache;

});
parcelRegister("bjX1n", function(module, exports) {
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $83df40714bf7006e$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
module.exports = $83df40714bf7006e$var$listCacheClear;

});

parcelRegister("i2OST", function(module, exports) {

var $bBnDb = parcelRequire("bBnDb");
/** Used for built-in method references. */ var $d22fe27824ff9351$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $d22fe27824ff9351$var$splice = $d22fe27824ff9351$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $d22fe27824ff9351$var$listCacheDelete(key) {
    var data = this.__data__, index = $bBnDb(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $d22fe27824ff9351$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
module.exports = $d22fe27824ff9351$var$listCacheDelete;

});
parcelRegister("bBnDb", function(module, exports) {

var $6TC8i = parcelRequire("6TC8i");
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $87257b05f5d9ad81$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ($6TC8i(array[length][0], key)) return length;
    }
    return -1;
}
module.exports = $87257b05f5d9ad81$var$assocIndexOf;

});
parcelRegister("6TC8i", function(module, exports) {
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $50557587dab070a0$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
module.exports = $50557587dab070a0$var$eq;

});



parcelRegister("fmh4d", function(module, exports) {

var $bBnDb = parcelRequire("bBnDb");
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $b2e6263d81cdc1b3$var$listCacheGet(key) {
    var data = this.__data__, index = $bBnDb(data, key);
    return index < 0 ? undefined : data[index][1];
}
module.exports = $b2e6263d81cdc1b3$var$listCacheGet;

});

parcelRegister("3AXiV", function(module, exports) {

var $bBnDb = parcelRequire("bBnDb");
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $29e2bc7b7348833e$var$listCacheHas(key) {
    return $bBnDb(this.__data__, key) > -1;
}
module.exports = $29e2bc7b7348833e$var$listCacheHas;

});

parcelRegister("lWpQQ", function(module, exports) {

var $bBnDb = parcelRequire("bBnDb");
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $ff9311500b60ab72$var$listCacheSet(key, value) {
    var data = this.__data__, index = $bBnDb(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
module.exports = $ff9311500b60ab72$var$listCacheSet;

});


parcelRegister("jZSEZ", function(module, exports) {

var $iYOpJ = parcelRequire("iYOpJ");
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $e8ee1d354807980a$var$stackClear() {
    this.__data__ = new $iYOpJ;
    this.size = 0;
}
module.exports = $e8ee1d354807980a$var$stackClear;

});

parcelRegister("fm6cW", function(module, exports) {
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $b2ddb9d63293f3a5$var$stackDelete(key) {
    var data = this.__data__, result = data['delete'](key);
    this.size = data.size;
    return result;
}
module.exports = $b2ddb9d63293f3a5$var$stackDelete;

});

parcelRegister("b3G1Z", function(module, exports) {
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $80d0940a423a17dc$var$stackGet(key) {
    return this.__data__.get(key);
}
module.exports = $80d0940a423a17dc$var$stackGet;

});

parcelRegister("5DEbp", function(module, exports) {
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $010f38d5d914cfa2$var$stackHas(key) {
    return this.__data__.has(key);
}
module.exports = $010f38d5d914cfa2$var$stackHas;

});

parcelRegister("czPDU", function(module, exports) {

var $iYOpJ = parcelRequire("iYOpJ");

var $2cJKd = parcelRequire("2cJKd");

var $6gDBQ = parcelRequire("6gDBQ");
/** Used as the size to enable large array optimizations. */ var $9280d00f89f25fa9$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $9280d00f89f25fa9$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof $iYOpJ) {
        var pairs = data.__data__;
        if (!$2cJKd || pairs.length < $9280d00f89f25fa9$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new $6gDBQ(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
module.exports = $9280d00f89f25fa9$var$stackSet;

});
parcelRegister("2cJKd", function(module, exports) {

var $6T08O = parcelRequire("6T08O");

var $23YZo = parcelRequire("23YZo");
/* Built-in method references that are verified to be native. */ var $19b02faa57603249$var$Map = $6T08O($23YZo, 'Map');
module.exports = $19b02faa57603249$var$Map;

});
parcelRegister("6T08O", function(module, exports) {

var $bhj99 = parcelRequire("bhj99");

var $ii1B1 = parcelRequire("ii1B1");
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $5037fd2e597c2a03$var$getNative(object, key) {
    var value = $ii1B1(object, key);
    return $bhj99(value) ? value : undefined;
}
module.exports = $5037fd2e597c2a03$var$getNative;

});
parcelRegister("bhj99", function(module, exports) {

var $01ubZ = parcelRequire("01ubZ");

var $87ifd = parcelRequire("87ifd");

var $lsJ54 = parcelRequire("lsJ54");

var $dqC5h = parcelRequire("dqC5h");
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $8360225fb63098b3$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $8360225fb63098b3$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $8360225fb63098b3$var$funcProto = Function.prototype, $8360225fb63098b3$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $8360225fb63098b3$var$funcToString = $8360225fb63098b3$var$funcProto.toString;
/** Used to check objects for own properties. */ var $8360225fb63098b3$var$hasOwnProperty = $8360225fb63098b3$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $8360225fb63098b3$var$reIsNative = RegExp('^' + $8360225fb63098b3$var$funcToString.call($8360225fb63098b3$var$hasOwnProperty).replace($8360225fb63098b3$var$reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $8360225fb63098b3$var$baseIsNative(value) {
    if (!$lsJ54(value) || $87ifd(value)) return false;
    var pattern = $01ubZ(value) ? $8360225fb63098b3$var$reIsNative : $8360225fb63098b3$var$reIsHostCtor;
    return pattern.test($dqC5h(value));
}
module.exports = $8360225fb63098b3$var$baseIsNative;

});
parcelRegister("01ubZ", function(module, exports) {

var $eq6CV = parcelRequire("eq6CV");

var $lsJ54 = parcelRequire("lsJ54");
/** `Object#toString` result references. */ var $004783abbde551e4$var$asyncTag = '[object AsyncFunction]', $004783abbde551e4$var$funcTag = '[object Function]', $004783abbde551e4$var$genTag = '[object GeneratorFunction]', $004783abbde551e4$var$proxyTag = '[object Proxy]';
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $004783abbde551e4$var$isFunction(value) {
    if (!$lsJ54(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = $eq6CV(value);
    return tag == $004783abbde551e4$var$funcTag || tag == $004783abbde551e4$var$genTag || tag == $004783abbde551e4$var$asyncTag || tag == $004783abbde551e4$var$proxyTag;
}
module.exports = $004783abbde551e4$var$isFunction;

});
parcelRegister("eq6CV", function(module, exports) {

var $57wYk = parcelRequire("57wYk");

var $iMn5C = parcelRequire("iMn5C");

var $5tDQy = parcelRequire("5tDQy");
/** `Object#toString` result references. */ var $a7f8a2555793d7d3$var$nullTag = '[object Null]', $a7f8a2555793d7d3$var$undefinedTag = '[object Undefined]';
/** Built-in value references. */ var $a7f8a2555793d7d3$var$symToStringTag = $57wYk ? $57wYk.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $a7f8a2555793d7d3$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $a7f8a2555793d7d3$var$undefinedTag : $a7f8a2555793d7d3$var$nullTag;
    return $a7f8a2555793d7d3$var$symToStringTag && $a7f8a2555793d7d3$var$symToStringTag in Object(value) ? $iMn5C(value) : $5tDQy(value);
}
module.exports = $a7f8a2555793d7d3$var$baseGetTag;

});
parcelRegister("57wYk", function(module, exports) {

var $23YZo = parcelRequire("23YZo");
/** Built-in value references. */ var $3ba72ebe7e4419b5$var$Symbol = $23YZo.Symbol;
module.exports = $3ba72ebe7e4419b5$var$Symbol;

});
parcelRegister("23YZo", function(module, exports) {

var $ljJ8G = parcelRequire("ljJ8G");
/** Detect free variable `self`. */ var $180b2bc3c0deaf6c$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $180b2bc3c0deaf6c$var$root = $ljJ8G || $180b2bc3c0deaf6c$var$freeSelf || Function('return this')();
module.exports = $180b2bc3c0deaf6c$var$root;

});
parcelRegister("ljJ8G", function(module, exports) {
/** Detect free variable `global` from Node.js. */ var $f84e62f9db5b9ccd$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
module.exports = $f84e62f9db5b9ccd$var$freeGlobal;

});



parcelRegister("iMn5C", function(module, exports) {

var $57wYk = parcelRequire("57wYk");
/** Used for built-in method references. */ var $dabe9ecbecc6d0b5$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $dabe9ecbecc6d0b5$var$hasOwnProperty = $dabe9ecbecc6d0b5$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $dabe9ecbecc6d0b5$var$nativeObjectToString = $dabe9ecbecc6d0b5$var$objectProto.toString;
/** Built-in value references. */ var $dabe9ecbecc6d0b5$var$symToStringTag = $57wYk ? $57wYk.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $dabe9ecbecc6d0b5$var$getRawTag(value) {
    var isOwn = $dabe9ecbecc6d0b5$var$hasOwnProperty.call(value, $dabe9ecbecc6d0b5$var$symToStringTag), tag = value[$dabe9ecbecc6d0b5$var$symToStringTag];
    try {
        value[$dabe9ecbecc6d0b5$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $dabe9ecbecc6d0b5$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$dabe9ecbecc6d0b5$var$symToStringTag] = tag;
        else delete value[$dabe9ecbecc6d0b5$var$symToStringTag];
    }
    return result;
}
module.exports = $dabe9ecbecc6d0b5$var$getRawTag;

});

parcelRegister("5tDQy", function(module, exports) {
/** Used for built-in method references. */ var $3fce91ec3914aaed$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $3fce91ec3914aaed$var$nativeObjectToString = $3fce91ec3914aaed$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $3fce91ec3914aaed$var$objectToString(value) {
    return $3fce91ec3914aaed$var$nativeObjectToString.call(value);
}
module.exports = $3fce91ec3914aaed$var$objectToString;

});


parcelRegister("lsJ54", function(module, exports) {
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $f9ff2e983beb6b86$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
module.exports = $f9ff2e983beb6b86$var$isObject;

});


parcelRegister("87ifd", function(module, exports) {

var $g3dHA = parcelRequire("g3dHA");
/** Used to detect methods masquerading as native. */ var $5e8d211f630cd46d$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec($g3dHA && $g3dHA.keys && $g3dHA.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $5e8d211f630cd46d$var$isMasked(func) {
    return !!$5e8d211f630cd46d$var$maskSrcKey && $5e8d211f630cd46d$var$maskSrcKey in func;
}
module.exports = $5e8d211f630cd46d$var$isMasked;

});
parcelRegister("g3dHA", function(module, exports) {

var $23YZo = parcelRequire("23YZo");
/** Used to detect overreaching core-js shims. */ var $baf78e1246b3b18f$var$coreJsData = $23YZo["__core-js_shared__"];
module.exports = $baf78e1246b3b18f$var$coreJsData;

});


parcelRegister("dqC5h", function(module, exports) {
/** Used for built-in method references. */ var $9c6b3ec69362487e$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $9c6b3ec69362487e$var$funcToString = $9c6b3ec69362487e$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $9c6b3ec69362487e$var$toSource(func) {
    if (func != null) {
        try {
            return $9c6b3ec69362487e$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
module.exports = $9c6b3ec69362487e$var$toSource;

});


parcelRegister("ii1B1", function(module, exports) {
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $d50b255f8680c47a$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
module.exports = $d50b255f8680c47a$var$getValue;

});



parcelRegister("6gDBQ", function(module, exports) {

var $j9XgB = parcelRequire("j9XgB");

var $5Rqhl = parcelRequire("5Rqhl");

var $g0JTV = parcelRequire("g0JTV");

var $iaILb = parcelRequire("iaILb");

var $4vfJO = parcelRequire("4vfJO");
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $4902f64a16640324$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$4902f64a16640324$var$MapCache.prototype.clear = $j9XgB;
$4902f64a16640324$var$MapCache.prototype['delete'] = $5Rqhl;
$4902f64a16640324$var$MapCache.prototype.get = $g0JTV;
$4902f64a16640324$var$MapCache.prototype.has = $iaILb;
$4902f64a16640324$var$MapCache.prototype.set = $4vfJO;
module.exports = $4902f64a16640324$var$MapCache;

});
parcelRegister("j9XgB", function(module, exports) {

var $c8dKl = parcelRequire("c8dKl");

var $iYOpJ = parcelRequire("iYOpJ");

var $2cJKd = parcelRequire("2cJKd");
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $df2cd4bc93f21548$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        'hash': new $c8dKl,
        'map': new ($2cJKd || $iYOpJ),
        'string': new $c8dKl
    };
}
module.exports = $df2cd4bc93f21548$var$mapCacheClear;

});
parcelRegister("c8dKl", function(module, exports) {

var $b4nbb = parcelRequire("b4nbb");

var $8ink3 = parcelRequire("8ink3");

var $VQwbj = parcelRequire("VQwbj");

var $19QNA = parcelRequire("19QNA");

var $i8qJC = parcelRequire("i8qJC");
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $8d50e526a9e9b7fa$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$8d50e526a9e9b7fa$var$Hash.prototype.clear = $b4nbb;
$8d50e526a9e9b7fa$var$Hash.prototype['delete'] = $8ink3;
$8d50e526a9e9b7fa$var$Hash.prototype.get = $VQwbj;
$8d50e526a9e9b7fa$var$Hash.prototype.has = $19QNA;
$8d50e526a9e9b7fa$var$Hash.prototype.set = $i8qJC;
module.exports = $8d50e526a9e9b7fa$var$Hash;

});
parcelRegister("b4nbb", function(module, exports) {

var $k1Z3J = parcelRequire("k1Z3J");
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $80f20c637ba11563$var$hashClear() {
    this.__data__ = $k1Z3J ? $k1Z3J(null) : {};
    this.size = 0;
}
module.exports = $80f20c637ba11563$var$hashClear;

});
parcelRegister("k1Z3J", function(module, exports) {

var $6T08O = parcelRequire("6T08O");
/* Built-in method references that are verified to be native. */ var $e95343b7bf5d617b$var$nativeCreate = $6T08O(Object, 'create');
module.exports = $e95343b7bf5d617b$var$nativeCreate;

});


parcelRegister("8ink3", function(module, exports) {
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $60a2188452e03a76$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = $60a2188452e03a76$var$hashDelete;

});

parcelRegister("VQwbj", function(module, exports) {

var $k1Z3J = parcelRequire("k1Z3J");
/** Used to stand-in for `undefined` hash values. */ var $0ade0ffa62051a98$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used for built-in method references. */ var $0ade0ffa62051a98$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $0ade0ffa62051a98$var$hasOwnProperty = $0ade0ffa62051a98$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $0ade0ffa62051a98$var$hashGet(key) {
    var data = this.__data__;
    if ($k1Z3J) {
        var result = data[key];
        return result === $0ade0ffa62051a98$var$HASH_UNDEFINED ? undefined : result;
    }
    return $0ade0ffa62051a98$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
module.exports = $0ade0ffa62051a98$var$hashGet;

});

parcelRegister("19QNA", function(module, exports) {

var $k1Z3J = parcelRequire("k1Z3J");
/** Used for built-in method references. */ var $0d7f9677a17b6bef$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $0d7f9677a17b6bef$var$hasOwnProperty = $0d7f9677a17b6bef$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $0d7f9677a17b6bef$var$hashHas(key) {
    var data = this.__data__;
    return $k1Z3J ? data[key] !== undefined : $0d7f9677a17b6bef$var$hasOwnProperty.call(data, key);
}
module.exports = $0d7f9677a17b6bef$var$hashHas;

});

parcelRegister("i8qJC", function(module, exports) {

var $k1Z3J = parcelRequire("k1Z3J");
/** Used to stand-in for `undefined` hash values. */ var $d33db65186b62952$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $d33db65186b62952$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = $k1Z3J && value === undefined ? $d33db65186b62952$var$HASH_UNDEFINED : value;
    return this;
}
module.exports = $d33db65186b62952$var$hashSet;

});



parcelRegister("5Rqhl", function(module, exports) {

var $gxIuO = parcelRequire("gxIuO");
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $44464964ade29765$var$mapCacheDelete(key) {
    var result = $gxIuO(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = $44464964ade29765$var$mapCacheDelete;

});
parcelRegister("gxIuO", function(module, exports) {

var $PZpyR = parcelRequire("PZpyR");
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $c0b23e5f03c2595b$var$getMapData(map, key) {
    var data = map.__data__;
    return $PZpyR(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
module.exports = $c0b23e5f03c2595b$var$getMapData;

});
parcelRegister("PZpyR", function(module, exports) {
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $09c4668903e66c1d$var$isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
module.exports = $09c4668903e66c1d$var$isKeyable;

});



parcelRegister("g0JTV", function(module, exports) {

var $gxIuO = parcelRequire("gxIuO");
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $ba80406da5503086$var$mapCacheGet(key) {
    return $gxIuO(this, key).get(key);
}
module.exports = $ba80406da5503086$var$mapCacheGet;

});

parcelRegister("iaILb", function(module, exports) {

var $gxIuO = parcelRequire("gxIuO");
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $d3abe18ea687dfb7$var$mapCacheHas(key) {
    return $gxIuO(this, key).has(key);
}
module.exports = $d3abe18ea687dfb7$var$mapCacheHas;

});

parcelRegister("4vfJO", function(module, exports) {

var $gxIuO = parcelRequire("gxIuO");
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $347643e3dcfcc207$var$mapCacheSet(key, value) {
    var data = $gxIuO(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
module.exports = $347643e3dcfcc207$var$mapCacheSet;

});




parcelRegister("bFZGr", function(module, exports) {
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */ function $88035f224ff89479$var$arrayEach(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (iteratee(array[index], index, array) === false) break;
    }
    return array;
}
module.exports = $88035f224ff89479$var$arrayEach;

});

parcelRegister("5i71d", function(module, exports) {

var $cWbJD = parcelRequire("cWbJD");

var $6TC8i = parcelRequire("6TC8i");
/** Used for built-in method references. */ var $3da413f0b86c10df$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $3da413f0b86c10df$var$hasOwnProperty = $3da413f0b86c10df$var$objectProto.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $3da413f0b86c10df$var$assignValue(object, key, value) {
    var objValue = object[key];
    if (!($3da413f0b86c10df$var$hasOwnProperty.call(object, key) && $6TC8i(objValue, value)) || value === undefined && !(key in object)) $cWbJD(object, key, value);
}
module.exports = $3da413f0b86c10df$var$assignValue;

});
parcelRegister("cWbJD", function(module, exports) {

var $4hwTc = parcelRequire("4hwTc");
/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $96b401257ea00d24$var$baseAssignValue(object, key, value) {
    if (key == '__proto__' && $4hwTc) $4hwTc(object, key, {
        'configurable': true,
        'enumerable': true,
        'value': value,
        'writable': true
    });
    else object[key] = value;
}
module.exports = $96b401257ea00d24$var$baseAssignValue;

});
parcelRegister("4hwTc", function(module, exports) {

var $6T08O = parcelRequire("6T08O");
var $31e24313ace94404$var$defineProperty = function() {
    try {
        var func = $6T08O(Object, 'defineProperty');
        func({}, '', {});
        return func;
    } catch (e) {}
}();
module.exports = $31e24313ace94404$var$defineProperty;

});



parcelRegister("XXQDs", function(module, exports) {

var $cYlGN = parcelRequire("cYlGN");

var $LAMcS = parcelRequire("LAMcS");
/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $0b43ef5c64ba7f70$var$baseAssign(object, source) {
    return object && $cYlGN(source, $LAMcS(source), object);
}
module.exports = $0b43ef5c64ba7f70$var$baseAssign;

});
parcelRegister("cYlGN", function(module, exports) {

var $5i71d = parcelRequire("5i71d");

var $cWbJD = parcelRequire("cWbJD");
/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function $971be9a5edcd8d07$var$copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) newValue = source[key];
        if (isNew) $cWbJD(object, key, newValue);
        else $5i71d(object, key, newValue);
    }
    return object;
}
module.exports = $971be9a5edcd8d07$var$copyObject;

});

parcelRegister("LAMcS", function(module, exports) {

var $8C60w = parcelRequire("8C60w");

var $jViFF = parcelRequire("jViFF");

var $eMthh = parcelRequire("eMthh");
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $08f0eaf3fbcb2fde$var$keys(object) {
    return $eMthh(object) ? $8C60w(object) : $jViFF(object);
}
module.exports = $08f0eaf3fbcb2fde$var$keys;

});
parcelRegister("8C60w", function(module, exports) {

var $fdM6B = parcelRequire("fdM6B");

var $aJD6g = parcelRequire("aJD6g");

var $o8HxT = parcelRequire("o8HxT");

var $f504n = parcelRequire("f504n");

var $iyUuu = parcelRequire("iyUuu");

var $1Q21n = parcelRequire("1Q21n");
/** Used for built-in method references. */ var $64568844439edb7f$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $64568844439edb7f$var$hasOwnProperty = $64568844439edb7f$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $64568844439edb7f$var$arrayLikeKeys(value, inherited) {
    var isArr = $o8HxT(value), isArg = !isArr && $aJD6g(value), isBuff = !isArr && !isArg && $f504n(value), isType = !isArr && !isArg && !isBuff && $1Q21n(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? $fdM6B(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $64568844439edb7f$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
    $iyUuu(key, length)))) result.push(key);
    return result;
}
module.exports = $64568844439edb7f$var$arrayLikeKeys;

});
parcelRegister("fdM6B", function(module, exports) {
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $b14d62a510ae7f2d$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
module.exports = $b14d62a510ae7f2d$var$baseTimes;

});

parcelRegister("aJD6g", function(module, exports) {

var $lB3aj = parcelRequire("lB3aj");

var $8l89S = parcelRequire("8l89S");
/** Used for built-in method references. */ var $7d0c6fd0eb26be0e$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $7d0c6fd0eb26be0e$var$hasOwnProperty = $7d0c6fd0eb26be0e$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $7d0c6fd0eb26be0e$var$propertyIsEnumerable = $7d0c6fd0eb26be0e$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $7d0c6fd0eb26be0e$var$isArguments = $lB3aj(function() {
    return arguments;
}()) ? $lB3aj : function(value) {
    return $8l89S(value) && $7d0c6fd0eb26be0e$var$hasOwnProperty.call(value, 'callee') && !$7d0c6fd0eb26be0e$var$propertyIsEnumerable.call(value, 'callee');
};
module.exports = $7d0c6fd0eb26be0e$var$isArguments;

});
parcelRegister("lB3aj", function(module, exports) {

var $eq6CV = parcelRequire("eq6CV");

var $8l89S = parcelRequire("8l89S");
/** `Object#toString` result references. */ var $fb8f823cdc90f511$var$argsTag = '[object Arguments]';
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $fb8f823cdc90f511$var$baseIsArguments(value) {
    return $8l89S(value) && $eq6CV(value) == $fb8f823cdc90f511$var$argsTag;
}
module.exports = $fb8f823cdc90f511$var$baseIsArguments;

});
parcelRegister("8l89S", function(module, exports) {
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $61269cf1f3e020be$var$isObjectLike(value) {
    return value != null && typeof value == 'object';
}
module.exports = $61269cf1f3e020be$var$isObjectLike;

});



parcelRegister("o8HxT", function(module, exports) {
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $0488fde9aa355453$var$isArray = Array.isArray;
module.exports = $0488fde9aa355453$var$isArray;

});

parcelRegister("f504n", function(module, exports) {

var $23YZo = parcelRequire("23YZo");

var $fiQnm = parcelRequire("fiQnm");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $23YZo.Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || $fiQnm;
module.exports = isBuffer;

});
parcelRegister("fiQnm", function(module, exports) {
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $b2412a30bba480f5$var$stubFalse() {
    return false;
}
module.exports = $b2412a30bba480f5$var$stubFalse;

});


parcelRegister("iyUuu", function(module, exports) {
/** Used as references for various `Number` constants. */ var $d83738e053b5eb08$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $d83738e053b5eb08$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $d83738e053b5eb08$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $d83738e053b5eb08$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == 'number' || type != 'symbol' && $d83738e053b5eb08$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
module.exports = $d83738e053b5eb08$var$isIndex;

});

parcelRegister("1Q21n", function(module, exports) {

var $dtRoq = parcelRequire("dtRoq");

var $91Qdd = parcelRequire("91Qdd");

var $jIny1 = parcelRequire("jIny1");
/* Node.js helper references. */ var $156c3727697ab085$var$nodeIsTypedArray = $jIny1 && $jIny1.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $156c3727697ab085$var$isTypedArray = $156c3727697ab085$var$nodeIsTypedArray ? $91Qdd($156c3727697ab085$var$nodeIsTypedArray) : $dtRoq;
module.exports = $156c3727697ab085$var$isTypedArray;

});
parcelRegister("dtRoq", function(module, exports) {

var $eq6CV = parcelRequire("eq6CV");

var $1S9lz = parcelRequire("1S9lz");

var $8l89S = parcelRequire("8l89S");
/** `Object#toString` result references. */ var $9d076681a0e29d68$var$argsTag = '[object Arguments]', $9d076681a0e29d68$var$arrayTag = '[object Array]', $9d076681a0e29d68$var$boolTag = '[object Boolean]', $9d076681a0e29d68$var$dateTag = '[object Date]', $9d076681a0e29d68$var$errorTag = '[object Error]', $9d076681a0e29d68$var$funcTag = '[object Function]', $9d076681a0e29d68$var$mapTag = '[object Map]', $9d076681a0e29d68$var$numberTag = '[object Number]', $9d076681a0e29d68$var$objectTag = '[object Object]', $9d076681a0e29d68$var$regexpTag = '[object RegExp]', $9d076681a0e29d68$var$setTag = '[object Set]', $9d076681a0e29d68$var$stringTag = '[object String]', $9d076681a0e29d68$var$weakMapTag = '[object WeakMap]';
var $9d076681a0e29d68$var$arrayBufferTag = '[object ArrayBuffer]', $9d076681a0e29d68$var$dataViewTag = '[object DataView]', $9d076681a0e29d68$var$float32Tag = '[object Float32Array]', $9d076681a0e29d68$var$float64Tag = '[object Float64Array]', $9d076681a0e29d68$var$int8Tag = '[object Int8Array]', $9d076681a0e29d68$var$int16Tag = '[object Int16Array]', $9d076681a0e29d68$var$int32Tag = '[object Int32Array]', $9d076681a0e29d68$var$uint8Tag = '[object Uint8Array]', $9d076681a0e29d68$var$uint8ClampedTag = '[object Uint8ClampedArray]', $9d076681a0e29d68$var$uint16Tag = '[object Uint16Array]', $9d076681a0e29d68$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values of typed arrays. */ var $9d076681a0e29d68$var$typedArrayTags = {};
$9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$float32Tag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$float64Tag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$int8Tag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$int16Tag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$int32Tag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$uint8Tag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$uint8ClampedTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$uint16Tag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$uint32Tag] = true;
$9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$argsTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$arrayTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$arrayBufferTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$boolTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$dataViewTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$dateTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$errorTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$funcTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$mapTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$numberTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$objectTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$regexpTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$setTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$stringTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $9d076681a0e29d68$var$baseIsTypedArray(value) {
    return $8l89S(value) && $1S9lz(value.length) && !!$9d076681a0e29d68$var$typedArrayTags[$eq6CV(value)];
}
module.exports = $9d076681a0e29d68$var$baseIsTypedArray;

});
parcelRegister("1S9lz", function(module, exports) {
/** Used as references for various `Number` constants. */ var $15d215b19bcf1187$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $15d215b19bcf1187$var$isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= $15d215b19bcf1187$var$MAX_SAFE_INTEGER;
}
module.exports = $15d215b19bcf1187$var$isLength;

});


parcelRegister("91Qdd", function(module, exports) {
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $692cb5474f422969$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
module.exports = $692cb5474f422969$var$baseUnary;

});

parcelRegister("jIny1", function(module, exports) {

var $ljJ8G = parcelRequire("ljJ8G");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && $ljJ8G.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require('util').types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
}();
module.exports = nodeUtil;

});



parcelRegister("jViFF", function(module, exports) {

var $3wZFp = parcelRequire("3wZFp");

var $Xlg65 = parcelRequire("Xlg65");
/** Used for built-in method references. */ var $e811d2e210fb58cc$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $e811d2e210fb58cc$var$hasOwnProperty = $e811d2e210fb58cc$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $e811d2e210fb58cc$var$baseKeys(object) {
    if (!$3wZFp(object)) return $Xlg65(object);
    var result = [];
    for(var key in Object(object))if ($e811d2e210fb58cc$var$hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
module.exports = $e811d2e210fb58cc$var$baseKeys;

});
parcelRegister("3wZFp", function(module, exports) {
/** Used for built-in method references. */ var $292432068be14a79$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $292432068be14a79$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || $292432068be14a79$var$objectProto;
    return value === proto;
}
module.exports = $292432068be14a79$var$isPrototype;

});

parcelRegister("Xlg65", function(module, exports) {

var $lW2Sc = parcelRequire("lW2Sc");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $0b26005314403d97$var$nativeKeys = $lW2Sc(Object.keys, Object);
module.exports = $0b26005314403d97$var$nativeKeys;

});
parcelRegister("lW2Sc", function(module, exports) {
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $ff813e49bf3cca3d$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
module.exports = $ff813e49bf3cca3d$var$overArg;

});



parcelRegister("eMthh", function(module, exports) {

var $01ubZ = parcelRequire("01ubZ");

var $1S9lz = parcelRequire("1S9lz");
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $ac2c42592aa05543$var$isArrayLike(value) {
    return value != null && $1S9lz(value.length) && !$01ubZ(value);
}
module.exports = $ac2c42592aa05543$var$isArrayLike;

});



parcelRegister("1djPb", function(module, exports) {

var $cYlGN = parcelRequire("cYlGN");

var $f4lqP = parcelRequire("f4lqP");
/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $0e266213253a5976$var$baseAssignIn(object, source) {
    return object && $cYlGN(source, $f4lqP(source), object);
}
module.exports = $0e266213253a5976$var$baseAssignIn;

});
parcelRegister("f4lqP", function(module, exports) {

var $8C60w = parcelRequire("8C60w");

var $4ECPT = parcelRequire("4ECPT");

var $eMthh = parcelRequire("eMthh");
/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function $af87da9a76941740$var$keysIn(object) {
    return $eMthh(object) ? $8C60w(object, true) : $4ECPT(object);
}
module.exports = $af87da9a76941740$var$keysIn;

});
parcelRegister("4ECPT", function(module, exports) {

var $lsJ54 = parcelRequire("lsJ54");

var $3wZFp = parcelRequire("3wZFp");

var $7w1ie = parcelRequire("7w1ie");
/** Used for built-in method references. */ var $363905e043db7569$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $363905e043db7569$var$hasOwnProperty = $363905e043db7569$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $363905e043db7569$var$baseKeysIn(object) {
    if (!$lsJ54(object)) return $7w1ie(object);
    var isProto = $3wZFp(object), result = [];
    for(var key in object)if (!(key == 'constructor' && (isProto || !$363905e043db7569$var$hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
module.exports = $363905e043db7569$var$baseKeysIn;

});
parcelRegister("7w1ie", function(module, exports) {
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $578c86548a505f7a$var$nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
module.exports = $578c86548a505f7a$var$nativeKeysIn;

});




parcelRegister("uQ1Em", function(module, exports) {

var $23YZo = parcelRequire("23YZo");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $23YZo.Buffer : undefined, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
}
module.exports = cloneBuffer;

});

parcelRegister("aA0pv", function(module, exports) {
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function $7b3d95b0cd9dcb32$var$copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
module.exports = $7b3d95b0cd9dcb32$var$copyArray;

});

parcelRegister("hIxJe", function(module, exports) {

var $cYlGN = parcelRequire("cYlGN");

var $6YcYN = parcelRequire("6YcYN");
/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $ce60b583e6a24a63$var$copySymbols(source, object) {
    return $cYlGN(source, $6YcYN(source), object);
}
module.exports = $ce60b583e6a24a63$var$copySymbols;

});
parcelRegister("6YcYN", function(module, exports) {

var $8H9RZ = parcelRequire("8H9RZ");

var $clnSu = parcelRequire("clnSu");
/** Used for built-in method references. */ var $51326a29f571e7cd$var$objectProto = Object.prototype;
/** Built-in value references. */ var $51326a29f571e7cd$var$propertyIsEnumerable = $51326a29f571e7cd$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $51326a29f571e7cd$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $51326a29f571e7cd$var$getSymbols = !$51326a29f571e7cd$var$nativeGetSymbols ? $clnSu : function(object) {
    if (object == null) return [];
    object = Object(object);
    return $8H9RZ($51326a29f571e7cd$var$nativeGetSymbols(object), function(symbol) {
        return $51326a29f571e7cd$var$propertyIsEnumerable.call(object, symbol);
    });
};
module.exports = $51326a29f571e7cd$var$getSymbols;

});
parcelRegister("8H9RZ", function(module, exports) {
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $6549fed720324048$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
module.exports = $6549fed720324048$var$arrayFilter;

});

parcelRegister("clnSu", function(module, exports) {
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $8fc9f7df9b0c06bb$var$stubArray() {
    return [];
}
module.exports = $8fc9f7df9b0c06bb$var$stubArray;

});



parcelRegister("7n7lE", function(module, exports) {

var $cYlGN = parcelRequire("cYlGN");

var $aiaLi = parcelRequire("aiaLi");
/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $55e06195de8b50ba$var$copySymbolsIn(source, object) {
    return $cYlGN(source, $aiaLi(source), object);
}
module.exports = $55e06195de8b50ba$var$copySymbolsIn;

});
parcelRegister("aiaLi", function(module, exports) {

var $hynws = parcelRequire("hynws");

var $cdnOB = parcelRequire("cdnOB");

var $6YcYN = parcelRequire("6YcYN");

var $clnSu = parcelRequire("clnSu");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $77e3eeed2d30c6bc$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $77e3eeed2d30c6bc$var$getSymbolsIn = !$77e3eeed2d30c6bc$var$nativeGetSymbols ? $clnSu : function(object) {
    var result = [];
    while(object){
        $hynws(result, $6YcYN(object));
        object = $cdnOB(object);
    }
    return result;
};
module.exports = $77e3eeed2d30c6bc$var$getSymbolsIn;

});
parcelRegister("hynws", function(module, exports) {
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $cc77dbb7c08db6a8$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
module.exports = $cc77dbb7c08db6a8$var$arrayPush;

});

parcelRegister("cdnOB", function(module, exports) {

var $lW2Sc = parcelRequire("lW2Sc");
/** Built-in value references. */ var $8e492c1d7a7ea307$var$getPrototype = $lW2Sc(Object.getPrototypeOf, Object);
module.exports = $8e492c1d7a7ea307$var$getPrototype;

});



parcelRegister("apVCl", function(module, exports) {

var $ctgi8 = parcelRequire("ctgi8");

var $6YcYN = parcelRequire("6YcYN");

var $LAMcS = parcelRequire("LAMcS");
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $7958eecccfe4cef6$var$getAllKeys(object) {
    return $ctgi8(object, $LAMcS, $6YcYN);
}
module.exports = $7958eecccfe4cef6$var$getAllKeys;

});
parcelRegister("ctgi8", function(module, exports) {

var $hynws = parcelRequire("hynws");

var $o8HxT = parcelRequire("o8HxT");
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $9144d49da7a47a72$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return $o8HxT(object) ? result : $hynws(result, symbolsFunc(object));
}
module.exports = $9144d49da7a47a72$var$baseGetAllKeys;

});


parcelRegister("i0kKc", function(module, exports) {

var $ctgi8 = parcelRequire("ctgi8");

var $aiaLi = parcelRequire("aiaLi");

var $f4lqP = parcelRequire("f4lqP");
/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $d1b85174ea17081a$var$getAllKeysIn(object) {
    return $ctgi8(object, $f4lqP, $aiaLi);
}
module.exports = $d1b85174ea17081a$var$getAllKeysIn;

});

parcelRegister("67A6V", function(module, exports) {

var $5Ehf1 = parcelRequire("5Ehf1");

var $2cJKd = parcelRequire("2cJKd");

var $f7yH3 = parcelRequire("f7yH3");

var $vH4x0 = parcelRequire("vH4x0");

var $f0N2p = parcelRequire("f0N2p");

var $eq6CV = parcelRequire("eq6CV");

var $dqC5h = parcelRequire("dqC5h");
/** `Object#toString` result references. */ var $474f685f496bfe31$var$mapTag = '[object Map]', $474f685f496bfe31$var$objectTag = '[object Object]', $474f685f496bfe31$var$promiseTag = '[object Promise]', $474f685f496bfe31$var$setTag = '[object Set]', $474f685f496bfe31$var$weakMapTag = '[object WeakMap]';
var $474f685f496bfe31$var$dataViewTag = '[object DataView]';
/** Used to detect maps, sets, and weakmaps. */ var $474f685f496bfe31$var$dataViewCtorString = $dqC5h($5Ehf1), $474f685f496bfe31$var$mapCtorString = $dqC5h($2cJKd), $474f685f496bfe31$var$promiseCtorString = $dqC5h($f7yH3), $474f685f496bfe31$var$setCtorString = $dqC5h($vH4x0), $474f685f496bfe31$var$weakMapCtorString = $dqC5h($f0N2p);
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $474f685f496bfe31$var$getTag = $eq6CV;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ($5Ehf1 && $474f685f496bfe31$var$getTag(new $5Ehf1(new ArrayBuffer(1))) != $474f685f496bfe31$var$dataViewTag || $2cJKd && $474f685f496bfe31$var$getTag(new $2cJKd) != $474f685f496bfe31$var$mapTag || $f7yH3 && $474f685f496bfe31$var$getTag($f7yH3.resolve()) != $474f685f496bfe31$var$promiseTag || $vH4x0 && $474f685f496bfe31$var$getTag(new $vH4x0) != $474f685f496bfe31$var$setTag || $f0N2p && $474f685f496bfe31$var$getTag(new $f0N2p) != $474f685f496bfe31$var$weakMapTag) $474f685f496bfe31$var$getTag = function(value) {
    var result = $eq6CV(value), Ctor = result == $474f685f496bfe31$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? $dqC5h(Ctor) : '';
    if (ctorString) switch(ctorString){
        case $474f685f496bfe31$var$dataViewCtorString:
            return $474f685f496bfe31$var$dataViewTag;
        case $474f685f496bfe31$var$mapCtorString:
            return $474f685f496bfe31$var$mapTag;
        case $474f685f496bfe31$var$promiseCtorString:
            return $474f685f496bfe31$var$promiseTag;
        case $474f685f496bfe31$var$setCtorString:
            return $474f685f496bfe31$var$setTag;
        case $474f685f496bfe31$var$weakMapCtorString:
            return $474f685f496bfe31$var$weakMapTag;
    }
    return result;
};
module.exports = $474f685f496bfe31$var$getTag;

});
parcelRegister("5Ehf1", function(module, exports) {

var $6T08O = parcelRequire("6T08O");

var $23YZo = parcelRequire("23YZo");
/* Built-in method references that are verified to be native. */ var $41ce0ff3b38ee753$var$DataView = $6T08O($23YZo, 'DataView');
module.exports = $41ce0ff3b38ee753$var$DataView;

});

parcelRegister("f7yH3", function(module, exports) {

var $6T08O = parcelRequire("6T08O");

var $23YZo = parcelRequire("23YZo");
/* Built-in method references that are verified to be native. */ var $b0226bdea11cb834$var$Promise = $6T08O($23YZo, 'Promise');
module.exports = $b0226bdea11cb834$var$Promise;

});

parcelRegister("vH4x0", function(module, exports) {

var $6T08O = parcelRequire("6T08O");

var $23YZo = parcelRequire("23YZo");
/* Built-in method references that are verified to be native. */ var $05f44e958da968eb$var$Set = $6T08O($23YZo, 'Set');
module.exports = $05f44e958da968eb$var$Set;

});

parcelRegister("f0N2p", function(module, exports) {

var $6T08O = parcelRequire("6T08O");

var $23YZo = parcelRequire("23YZo");
/* Built-in method references that are verified to be native. */ var $aedce50092a1e6a6$var$WeakMap = $6T08O($23YZo, 'WeakMap');
module.exports = $aedce50092a1e6a6$var$WeakMap;

});


parcelRegister("4UmGC", function(module, exports) {
/** Used for built-in method references. */ var $392dfd68f4953502$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $392dfd68f4953502$var$hasOwnProperty = $392dfd68f4953502$var$objectProto.hasOwnProperty;
/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */ function $392dfd68f4953502$var$initCloneArray(array) {
    var length = array.length, result = new array.constructor(length);
    // Add properties assigned by `RegExp#exec`.
    if (length && typeof array[0] == 'string' && $392dfd68f4953502$var$hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
    }
    return result;
}
module.exports = $392dfd68f4953502$var$initCloneArray;

});

parcelRegister("btuqH", function(module, exports) {

var $jjbq1 = parcelRequire("jjbq1");

var $aKTvD = parcelRequire("aKTvD");

var $5IIrB = parcelRequire("5IIrB");

var $jxFRj = parcelRequire("jxFRj");

var $5JAGM = parcelRequire("5JAGM");
/** `Object#toString` result references. */ var $85aa01d56b12d536$var$boolTag = '[object Boolean]', $85aa01d56b12d536$var$dateTag = '[object Date]', $85aa01d56b12d536$var$mapTag = '[object Map]', $85aa01d56b12d536$var$numberTag = '[object Number]', $85aa01d56b12d536$var$regexpTag = '[object RegExp]', $85aa01d56b12d536$var$setTag = '[object Set]', $85aa01d56b12d536$var$stringTag = '[object String]', $85aa01d56b12d536$var$symbolTag = '[object Symbol]';
var $85aa01d56b12d536$var$arrayBufferTag = '[object ArrayBuffer]', $85aa01d56b12d536$var$dataViewTag = '[object DataView]', $85aa01d56b12d536$var$float32Tag = '[object Float32Array]', $85aa01d56b12d536$var$float64Tag = '[object Float64Array]', $85aa01d56b12d536$var$int8Tag = '[object Int8Array]', $85aa01d56b12d536$var$int16Tag = '[object Int16Array]', $85aa01d56b12d536$var$int32Tag = '[object Int32Array]', $85aa01d56b12d536$var$uint8Tag = '[object Uint8Array]', $85aa01d56b12d536$var$uint8ClampedTag = '[object Uint8ClampedArray]', $85aa01d56b12d536$var$uint16Tag = '[object Uint16Array]', $85aa01d56b12d536$var$uint32Tag = '[object Uint32Array]';
/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */ function $85aa01d56b12d536$var$initCloneByTag(object, tag, isDeep) {
    var Ctor = object.constructor;
    switch(tag){
        case $85aa01d56b12d536$var$arrayBufferTag:
            return $jjbq1(object);
        case $85aa01d56b12d536$var$boolTag:
        case $85aa01d56b12d536$var$dateTag:
            return new Ctor(+object);
        case $85aa01d56b12d536$var$dataViewTag:
            return $aKTvD(object, isDeep);
        case $85aa01d56b12d536$var$float32Tag:
        case $85aa01d56b12d536$var$float64Tag:
        case $85aa01d56b12d536$var$int8Tag:
        case $85aa01d56b12d536$var$int16Tag:
        case $85aa01d56b12d536$var$int32Tag:
        case $85aa01d56b12d536$var$uint8Tag:
        case $85aa01d56b12d536$var$uint8ClampedTag:
        case $85aa01d56b12d536$var$uint16Tag:
        case $85aa01d56b12d536$var$uint32Tag:
            return $5JAGM(object, isDeep);
        case $85aa01d56b12d536$var$mapTag:
            return new Ctor;
        case $85aa01d56b12d536$var$numberTag:
        case $85aa01d56b12d536$var$stringTag:
            return new Ctor(object);
        case $85aa01d56b12d536$var$regexpTag:
            return $5IIrB(object);
        case $85aa01d56b12d536$var$setTag:
            return new Ctor;
        case $85aa01d56b12d536$var$symbolTag:
            return $jxFRj(object);
    }
}
module.exports = $85aa01d56b12d536$var$initCloneByTag;

});
parcelRegister("jjbq1", function(module, exports) {

var $lx3EF = parcelRequire("lx3EF");
/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function $e0e8a62ea95bc20a$var$cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new $lx3EF(result).set(new $lx3EF(arrayBuffer));
    return result;
}
module.exports = $e0e8a62ea95bc20a$var$cloneArrayBuffer;

});
parcelRegister("lx3EF", function(module, exports) {

var $23YZo = parcelRequire("23YZo");
/** Built-in value references. */ var $facf83d1449a27b8$var$Uint8Array = $23YZo.Uint8Array;
module.exports = $facf83d1449a27b8$var$Uint8Array;

});


parcelRegister("aKTvD", function(module, exports) {

var $jjbq1 = parcelRequire("jjbq1");
/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */ function $7d49423a2080f7e8$var$cloneDataView(dataView, isDeep) {
    var buffer = isDeep ? $jjbq1(dataView.buffer) : dataView.buffer;
    return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}
module.exports = $7d49423a2080f7e8$var$cloneDataView;

});

parcelRegister("5IIrB", function(module, exports) {
/** Used to match `RegExp` flags from their coerced string values. */ var $42a38980bea1ca34$var$reFlags = /\w*$/;
/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */ function $42a38980bea1ca34$var$cloneRegExp(regexp) {
    var result = new regexp.constructor(regexp.source, $42a38980bea1ca34$var$reFlags.exec(regexp));
    result.lastIndex = regexp.lastIndex;
    return result;
}
module.exports = $42a38980bea1ca34$var$cloneRegExp;

});

parcelRegister("jxFRj", function(module, exports) {

var $57wYk = parcelRequire("57wYk");
/** Used to convert symbols to primitives and strings. */ var $e3a191b3227aae5b$var$symbolProto = $57wYk ? $57wYk.prototype : undefined, $e3a191b3227aae5b$var$symbolValueOf = $e3a191b3227aae5b$var$symbolProto ? $e3a191b3227aae5b$var$symbolProto.valueOf : undefined;
/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */ function $e3a191b3227aae5b$var$cloneSymbol(symbol) {
    return $e3a191b3227aae5b$var$symbolValueOf ? Object($e3a191b3227aae5b$var$symbolValueOf.call(symbol)) : {};
}
module.exports = $e3a191b3227aae5b$var$cloneSymbol;

});

parcelRegister("5JAGM", function(module, exports) {

var $jjbq1 = parcelRequire("jjbq1");
/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function $42cd9d64f56ec214$var$cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? $jjbq1(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
module.exports = $42cd9d64f56ec214$var$cloneTypedArray;

});


parcelRegister("dFJsF", function(module, exports) {

var $4XGZt = parcelRequire("4XGZt");

var $cdnOB = parcelRequire("cdnOB");

var $3wZFp = parcelRequire("3wZFp");
/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function $9f425e619197b80f$var$initCloneObject(object) {
    return typeof object.constructor == 'function' && !$3wZFp(object) ? $4XGZt($cdnOB(object)) : {};
}
module.exports = $9f425e619197b80f$var$initCloneObject;

});
parcelRegister("4XGZt", function(module, exports) {

var $lsJ54 = parcelRequire("lsJ54");
/** Built-in value references. */ var $39ce05228f203f9a$var$objectCreate = Object.create;
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */ var $39ce05228f203f9a$var$baseCreate = function() {
    function object() {}
    return function(proto) {
        if (!$lsJ54(proto)) return {};
        if ($39ce05228f203f9a$var$objectCreate) return $39ce05228f203f9a$var$objectCreate(proto);
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
    };
}();
module.exports = $39ce05228f203f9a$var$baseCreate;

});


parcelRegister("eJObK", function(module, exports) {

var $9ORep = parcelRequire("9ORep");

var $91Qdd = parcelRequire("91Qdd");

var $jIny1 = parcelRequire("jIny1");
/* Node.js helper references. */ var $abac330771f68232$var$nodeIsMap = $jIny1 && $jIny1.isMap;
/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */ var $abac330771f68232$var$isMap = $abac330771f68232$var$nodeIsMap ? $91Qdd($abac330771f68232$var$nodeIsMap) : $9ORep;
module.exports = $abac330771f68232$var$isMap;

});
parcelRegister("9ORep", function(module, exports) {

var $67A6V = parcelRequire("67A6V");

var $8l89S = parcelRequire("8l89S");
/** `Object#toString` result references. */ var $7262133281c40437$var$mapTag = '[object Map]';
/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */ function $7262133281c40437$var$baseIsMap(value) {
    return $8l89S(value) && $67A6V(value) == $7262133281c40437$var$mapTag;
}
module.exports = $7262133281c40437$var$baseIsMap;

});


parcelRegister("jZm8C", function(module, exports) {

var $eFk8g = parcelRequire("eFk8g");

var $91Qdd = parcelRequire("91Qdd");

var $jIny1 = parcelRequire("jIny1");
/* Node.js helper references. */ var $e8d4e2fa1f2b8f08$var$nodeIsSet = $jIny1 && $jIny1.isSet;
/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */ var $e8d4e2fa1f2b8f08$var$isSet = $e8d4e2fa1f2b8f08$var$nodeIsSet ? $91Qdd($e8d4e2fa1f2b8f08$var$nodeIsSet) : $eFk8g;
module.exports = $e8d4e2fa1f2b8f08$var$isSet;

});
parcelRegister("eFk8g", function(module, exports) {

var $67A6V = parcelRequire("67A6V");

var $8l89S = parcelRequire("8l89S");
/** `Object#toString` result references. */ var $aad482e59457493b$var$setTag = '[object Set]';
/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */ function $aad482e59457493b$var$baseIsSet(value) {
    return $8l89S(value) && $67A6V(value) == $aad482e59457493b$var$setTag;
}
module.exports = $aad482e59457493b$var$baseIsSet;

});




parcelRegister("9HRmE", function(module, exports) {
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */ function $7111863c3c692f0e$var$constant(value) {
    return function() {
        return value;
    };
}
module.exports = $7111863c3c692f0e$var$constant;

});

parcelRegister("5kE3T", function(module, exports) {

module.exports = (parcelRequire("iWSff"));

});
parcelRegister("iWSff", function(module, exports) {

var $bFZGr = parcelRequire("bFZGr");

var $4DjQp = parcelRequire("4DjQp");

var $4c8Zb = parcelRequire("4c8Zb");

var $o8HxT = parcelRequire("o8HxT");
/**
 * Iterates over elements of `collection` and invokes `iteratee` for each element.
 * The iteratee is invoked with three arguments: (value, index|key, collection).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * **Note:** As with other "Collections" methods, objects with a "length"
 * property are iterated like arrays. To avoid this behavior use `_.forIn`
 * or `_.forOwn` for object iteration.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias each
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 * @see _.forEachRight
 * @example
 *
 * _.forEach([1, 2], function(value) {
 *   console.log(value);
 * });
 * // => Logs `1` then `2`.
 *
 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */ function $dcb7b8b4ed4ef64b$var$forEach(collection, iteratee) {
    var func = $o8HxT(collection) ? $bFZGr : $4DjQp;
    return func(collection, $4c8Zb(iteratee));
}
module.exports = $dcb7b8b4ed4ef64b$var$forEach;

});
parcelRegister("4DjQp", function(module, exports) {

var $4xK4A = parcelRequire("4xK4A");

var $kCOH9 = parcelRequire("kCOH9");
/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */ var $35fa3296f177aa01$var$baseEach = $kCOH9($4xK4A);
module.exports = $35fa3296f177aa01$var$baseEach;

});
parcelRegister("4xK4A", function(module, exports) {

var $dEvx9 = parcelRequire("dEvx9");

var $LAMcS = parcelRequire("LAMcS");
/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function $34edfba366a0cfa1$var$baseForOwn(object, iteratee) {
    return object && $dEvx9(object, iteratee, $LAMcS);
}
module.exports = $34edfba366a0cfa1$var$baseForOwn;

});
parcelRegister("dEvx9", function(module, exports) {

var $jTvRt = parcelRequire("jTvRt");
/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var $9f0778b809a8c692$var$baseFor = $jTvRt();
module.exports = $9f0778b809a8c692$var$baseFor;

});
parcelRegister("jTvRt", function(module, exports) {
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $e7bbde6376f4568a$var$createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
module.exports = $e7bbde6376f4568a$var$createBaseFor;

});



parcelRegister("kCOH9", function(module, exports) {

var $eMthh = parcelRequire("eMthh");
/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $f03eae3721f9ace8$var$createBaseEach(eachFunc, fromRight) {
    return function(collection, iteratee) {
        if (collection == null) return collection;
        if (!$eMthh(collection)) return eachFunc(collection, iteratee);
        var length = collection.length, index = fromRight ? length : -1, iterable = Object(collection);
        while(fromRight ? index-- : ++index < length){
            if (iteratee(iterable[index], index, iterable) === false) break;
        }
        return collection;
    };
}
module.exports = $f03eae3721f9ace8$var$createBaseEach;

});


parcelRegister("4c8Zb", function(module, exports) {

var $4Nq5y = parcelRequire("4Nq5y");
/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */ function $30df40d61e63f4ce$var$castFunction(value) {
    return typeof value == 'function' ? value : $4Nq5y;
}
module.exports = $30df40d61e63f4ce$var$castFunction;

});
parcelRegister("4Nq5y", function(module, exports) {
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function $37dff9aa04444f9c$var$identity(value) {
    return value;
}
module.exports = $37dff9aa04444f9c$var$identity;

});




parcelRegister("jLJR7", function(module, exports) {

var $8H9RZ = parcelRequire("8H9RZ");

var $agamk = parcelRequire("agamk");

var $7MWok = parcelRequire("7MWok");

var $o8HxT = parcelRequire("o8HxT");
/**
 * Iterates over elements of `collection`, returning an array of all elements
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * **Note:** Unlike `_.remove`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 * @see _.reject
 * @example
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': true },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * _.filter(users, function(o) { return !o.active; });
 * // => objects for ['fred']
 *
 * // The `_.matches` iteratee shorthand.
 * _.filter(users, { 'age': 36, 'active': true });
 * // => objects for ['barney']
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.filter(users, ['active', false]);
 * // => objects for ['fred']
 *
 * // The `_.property` iteratee shorthand.
 * _.filter(users, 'active');
 * // => objects for ['barney']
 *
 * // Combining several predicates using `_.overEvery` or `_.overSome`.
 * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
 * // => objects for ['fred', 'barney']
 */ function $e645fa20844da7aa$var$filter(collection, predicate) {
    var func = $o8HxT(collection) ? $8H9RZ : $agamk;
    return func(collection, $7MWok(predicate, 3));
}
module.exports = $e645fa20844da7aa$var$filter;

});
parcelRegister("agamk", function(module, exports) {

var $4DjQp = parcelRequire("4DjQp");
/**
 * The base implementation of `_.filter` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $77836f185896e906$var$baseFilter(collection, predicate) {
    var result = [];
    $4DjQp(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) result.push(value);
    });
    return result;
}
module.exports = $77836f185896e906$var$baseFilter;

});

parcelRegister("7MWok", function(module, exports) {

var $jShkp = parcelRequire("jShkp");

var $in5n5 = parcelRequire("in5n5");

var $4Nq5y = parcelRequire("4Nq5y");

var $o8HxT = parcelRequire("o8HxT");

var $bAYPD = parcelRequire("bAYPD");
/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function $5aba4f6d9f8304a3$var$baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == 'function') return value;
    if (value == null) return $4Nq5y;
    if (typeof value == 'object') return $o8HxT(value) ? $in5n5(value[0], value[1]) : $jShkp(value);
    return $bAYPD(value);
}
module.exports = $5aba4f6d9f8304a3$var$baseIteratee;

});
parcelRegister("jShkp", function(module, exports) {

var $kgn8n = parcelRequire("kgn8n");

var $9dd8D = parcelRequire("9dd8D");

var $2IhDm = parcelRequire("2IhDm");
/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function $e780807e2b795134$var$baseMatches(source) {
    var matchData = $9dd8D(source);
    if (matchData.length == 1 && matchData[0][2]) return $2IhDm(matchData[0][0], matchData[0][1]);
    return function(object) {
        return object === source || $kgn8n(object, source, matchData);
    };
}
module.exports = $e780807e2b795134$var$baseMatches;

});
parcelRegister("kgn8n", function(module, exports) {

var $g779E = parcelRequire("g779E");

var $abgWr = parcelRequire("abgWr");
/** Used to compose bitmasks for value comparisons. */ var $ec073f38db6e7d54$var$COMPARE_PARTIAL_FLAG = 1, $ec073f38db6e7d54$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function $ec073f38db6e7d54$var$baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = Object(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var stack = new $g779E;
            if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
            if (!(result === undefined ? $abgWr(srcValue, objValue, $ec073f38db6e7d54$var$COMPARE_PARTIAL_FLAG | $ec073f38db6e7d54$var$COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
        }
    }
    return true;
}
module.exports = $ec073f38db6e7d54$var$baseIsMatch;

});
parcelRegister("abgWr", function(module, exports) {

var $7qq40 = parcelRequire("7qq40");

var $8l89S = parcelRequire("8l89S");
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function $769812b29c18141e$var$baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !$8l89S(value) && !$8l89S(other)) return value !== value && other !== other;
    return $7qq40(value, other, bitmask, customizer, $769812b29c18141e$var$baseIsEqual, stack);
}
module.exports = $769812b29c18141e$var$baseIsEqual;

});
parcelRegister("7qq40", function(module, exports) {

var $g779E = parcelRequire("g779E");

var $1pRE7 = parcelRequire("1pRE7");

var $g3aCZ = parcelRequire("g3aCZ");

var $eOqMj = parcelRequire("eOqMj");

var $67A6V = parcelRequire("67A6V");

var $o8HxT = parcelRequire("o8HxT");

var $f504n = parcelRequire("f504n");

var $1Q21n = parcelRequire("1Q21n");
/** Used to compose bitmasks for value comparisons. */ var $567f2dd161ebd4f6$var$COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var $567f2dd161ebd4f6$var$argsTag = '[object Arguments]', $567f2dd161ebd4f6$var$arrayTag = '[object Array]', $567f2dd161ebd4f6$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $567f2dd161ebd4f6$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $567f2dd161ebd4f6$var$hasOwnProperty = $567f2dd161ebd4f6$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $567f2dd161ebd4f6$var$baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = $o8HxT(object), othIsArr = $o8HxT(other), objTag = objIsArr ? $567f2dd161ebd4f6$var$arrayTag : $67A6V(object), othTag = othIsArr ? $567f2dd161ebd4f6$var$arrayTag : $67A6V(other);
    objTag = objTag == $567f2dd161ebd4f6$var$argsTag ? $567f2dd161ebd4f6$var$objectTag : objTag;
    othTag = othTag == $567f2dd161ebd4f6$var$argsTag ? $567f2dd161ebd4f6$var$objectTag : othTag;
    var objIsObj = objTag == $567f2dd161ebd4f6$var$objectTag, othIsObj = othTag == $567f2dd161ebd4f6$var$objectTag, isSameTag = objTag == othTag;
    if (isSameTag && $f504n(object)) {
        if (!$f504n(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new $g779E);
        return objIsArr || $1Q21n(object) ? $1pRE7(object, other, bitmask, customizer, equalFunc, stack) : $g3aCZ(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & $567f2dd161ebd4f6$var$COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && $567f2dd161ebd4f6$var$hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && $567f2dd161ebd4f6$var$hasOwnProperty.call(other, '__wrapped__');
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new $g779E);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new $g779E);
    return $eOqMj(object, other, bitmask, customizer, equalFunc, stack);
}
module.exports = $567f2dd161ebd4f6$var$baseIsEqualDeep;

});
parcelRegister("1pRE7", function(module, exports) {

var $dXA7v = parcelRequire("dXA7v");

var $eFBTL = parcelRequire("eFBTL");

var $2l8n7 = parcelRequire("2l8n7");
/** Used to compose bitmasks for value comparisons. */ var $1081bd3a2e361911$var$COMPARE_PARTIAL_FLAG = 1, $1081bd3a2e361911$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function $1081bd3a2e361911$var$equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $1081bd3a2e361911$var$COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & $1081bd3a2e361911$var$COMPARE_UNORDERED_FLAG ? new $dXA7v : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!$eFBTL(other, function(othValue, othIndex) {
                if (!$2l8n7(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack['delete'](array);
    stack['delete'](other);
    return result;
}
module.exports = $1081bd3a2e361911$var$equalArrays;

});
parcelRegister("dXA7v", function(module, exports) {

var $6gDBQ = parcelRequire("6gDBQ");

var $j1Tfx = parcelRequire("j1Tfx");

var $8NkYQ = parcelRequire("8NkYQ");
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function $a29ccdc0f60e279e$var$SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new $6gDBQ;
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
$a29ccdc0f60e279e$var$SetCache.prototype.add = $a29ccdc0f60e279e$var$SetCache.prototype.push = $j1Tfx;
$a29ccdc0f60e279e$var$SetCache.prototype.has = $8NkYQ;
module.exports = $a29ccdc0f60e279e$var$SetCache;

});
parcelRegister("j1Tfx", function(module, exports) {
/** Used to stand-in for `undefined` hash values. */ var $dda8f7b6b589544e$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function $dda8f7b6b589544e$var$setCacheAdd(value) {
    this.__data__.set(value, $dda8f7b6b589544e$var$HASH_UNDEFINED);
    return this;
}
module.exports = $dda8f7b6b589544e$var$setCacheAdd;

});

parcelRegister("8NkYQ", function(module, exports) {
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function $66732c92c350622c$var$setCacheHas(value) {
    return this.__data__.has(value);
}
module.exports = $66732c92c350622c$var$setCacheHas;

});


parcelRegister("eFBTL", function(module, exports) {
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $aae24ad60cc3cfcb$var$arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
module.exports = $aae24ad60cc3cfcb$var$arraySome;

});

parcelRegister("2l8n7", function(module, exports) {
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $1b44096ad4b9e2d5$var$cacheHas(cache, key) {
    return cache.has(key);
}
module.exports = $1b44096ad4b9e2d5$var$cacheHas;

});


parcelRegister("g3aCZ", function(module, exports) {

var $57wYk = parcelRequire("57wYk");

var $lx3EF = parcelRequire("lx3EF");

var $6TC8i = parcelRequire("6TC8i");

var $1pRE7 = parcelRequire("1pRE7");

var $cwfcG = parcelRequire("cwfcG");

var $1xAji = parcelRequire("1xAji");
/** Used to compose bitmasks for value comparisons. */ var $baf52b9e146f3da7$var$COMPARE_PARTIAL_FLAG = 1, $baf52b9e146f3da7$var$COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var $baf52b9e146f3da7$var$boolTag = '[object Boolean]', $baf52b9e146f3da7$var$dateTag = '[object Date]', $baf52b9e146f3da7$var$errorTag = '[object Error]', $baf52b9e146f3da7$var$mapTag = '[object Map]', $baf52b9e146f3da7$var$numberTag = '[object Number]', $baf52b9e146f3da7$var$regexpTag = '[object RegExp]', $baf52b9e146f3da7$var$setTag = '[object Set]', $baf52b9e146f3da7$var$stringTag = '[object String]', $baf52b9e146f3da7$var$symbolTag = '[object Symbol]';
var $baf52b9e146f3da7$var$arrayBufferTag = '[object ArrayBuffer]', $baf52b9e146f3da7$var$dataViewTag = '[object DataView]';
/** Used to convert symbols to primitives and strings. */ var $baf52b9e146f3da7$var$symbolProto = $57wYk ? $57wYk.prototype : undefined, $baf52b9e146f3da7$var$symbolValueOf = $baf52b9e146f3da7$var$symbolProto ? $baf52b9e146f3da7$var$symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $baf52b9e146f3da7$var$equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case $baf52b9e146f3da7$var$dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case $baf52b9e146f3da7$var$arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new $lx3EF(object), new $lx3EF(other))) return false;
            return true;
        case $baf52b9e146f3da7$var$boolTag:
        case $baf52b9e146f3da7$var$dateTag:
        case $baf52b9e146f3da7$var$numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return $6TC8i(+object, +other);
        case $baf52b9e146f3da7$var$errorTag:
            return object.name == other.name && object.message == other.message;
        case $baf52b9e146f3da7$var$regexpTag:
        case $baf52b9e146f3da7$var$stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + '';
        case $baf52b9e146f3da7$var$mapTag:
            var convert = $cwfcG;
        case $baf52b9e146f3da7$var$setTag:
            var isPartial = bitmask & $baf52b9e146f3da7$var$COMPARE_PARTIAL_FLAG;
            convert || (convert = $1xAji);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= $baf52b9e146f3da7$var$COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = $1pRE7(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack['delete'](object);
            return result;
        case $baf52b9e146f3da7$var$symbolTag:
            if ($baf52b9e146f3da7$var$symbolValueOf) return $baf52b9e146f3da7$var$symbolValueOf.call(object) == $baf52b9e146f3da7$var$symbolValueOf.call(other);
    }
    return false;
}
module.exports = $baf52b9e146f3da7$var$equalByTag;

});
parcelRegister("cwfcG", function(module, exports) {
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function $91d4444cbb077e0c$var$mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
module.exports = $91d4444cbb077e0c$var$mapToArray;

});

parcelRegister("1xAji", function(module, exports) {
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function $11f509f8f53d8c36$var$setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
module.exports = $11f509f8f53d8c36$var$setToArray;

});


parcelRegister("eOqMj", function(module, exports) {

var $apVCl = parcelRequire("apVCl");
/** Used to compose bitmasks for value comparisons. */ var $ac8a81cbae0357e8$var$COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var $ac8a81cbae0357e8$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $ac8a81cbae0357e8$var$hasOwnProperty = $ac8a81cbae0357e8$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $ac8a81cbae0357e8$var$equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $ac8a81cbae0357e8$var$COMPARE_PARTIAL_FLAG, objProps = $apVCl(object), objLength = objProps.length, othProps = $apVCl(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : $ac8a81cbae0357e8$var$hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == 'constructor');
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
    }
    stack['delete'](object);
    stack['delete'](other);
    return result;
}
module.exports = $ac8a81cbae0357e8$var$equalObjects;

});




parcelRegister("9dd8D", function(module, exports) {

var $1n1hd = parcelRequire("1n1hd");

var $LAMcS = parcelRequire("LAMcS");
/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function $6b4f84f6be7f825c$var$getMatchData(object) {
    var result = $LAMcS(object), length = result.length;
    while(length--){
        var key = result[length], value = object[key];
        result[length] = [
            key,
            value,
            $1n1hd(value)
        ];
    }
    return result;
}
module.exports = $6b4f84f6be7f825c$var$getMatchData;

});
parcelRegister("1n1hd", function(module, exports) {

var $lsJ54 = parcelRequire("lsJ54");
/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function $0ff8edf4f90a7955$var$isStrictComparable(value) {
    return value === value && !$lsJ54(value);
}
module.exports = $0ff8edf4f90a7955$var$isStrictComparable;

});


parcelRegister("2IhDm", function(module, exports) {
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $1f9d5e891556ddb9$var$matchesStrictComparable(key, srcValue) {
    return function(object) {
        if (object == null) return false;
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
}
module.exports = $1f9d5e891556ddb9$var$matchesStrictComparable;

});


parcelRegister("in5n5", function(module, exports) {

var $abgWr = parcelRequire("abgWr");

var $i51gj = parcelRequire("i51gj");

var $2VBx6 = parcelRequire("2VBx6");

var $kPpic = parcelRequire("kPpic");

var $1n1hd = parcelRequire("1n1hd");

var $2IhDm = parcelRequire("2IhDm");

var $6DSvu = parcelRequire("6DSvu");
/** Used to compose bitmasks for value comparisons. */ var $d5fe8a98fe4800eb$var$COMPARE_PARTIAL_FLAG = 1, $d5fe8a98fe4800eb$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $d5fe8a98fe4800eb$var$baseMatchesProperty(path, srcValue) {
    if ($kPpic(path) && $1n1hd(srcValue)) return $2IhDm($6DSvu(path), srcValue);
    return function(object) {
        var objValue = $i51gj(object, path);
        return objValue === undefined && objValue === srcValue ? $2VBx6(object, path) : $abgWr(srcValue, objValue, $d5fe8a98fe4800eb$var$COMPARE_PARTIAL_FLAG | $d5fe8a98fe4800eb$var$COMPARE_UNORDERED_FLAG);
    };
}
module.exports = $d5fe8a98fe4800eb$var$baseMatchesProperty;

});
parcelRegister("i51gj", function(module, exports) {

var $lJEX1 = parcelRequire("lJEX1");
/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function $d299ac421c05c135$var$get(object, path, defaultValue) {
    var result = object == null ? undefined : $lJEX1(object, path);
    return result === undefined ? defaultValue : result;
}
module.exports = $d299ac421c05c135$var$get;

});
parcelRegister("lJEX1", function(module, exports) {

var $4RK0h = parcelRequire("4RK0h");

var $6DSvu = parcelRequire("6DSvu");
/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function $fd2d90f592c63519$var$baseGet(object, path) {
    path = $4RK0h(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[$6DSvu(path[index++])];
    return index && index == length ? object : undefined;
}
module.exports = $fd2d90f592c63519$var$baseGet;

});
parcelRegister("4RK0h", function(module, exports) {

var $o8HxT = parcelRequire("o8HxT");

var $kPpic = parcelRequire("kPpic");

var $lnP3M = parcelRequire("lnP3M");

var $l6E2L = parcelRequire("l6E2L");
/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function $38afcbfab85a0553$var$castPath(value, object) {
    if ($o8HxT(value)) return value;
    return $kPpic(value, object) ? [
        value
    ] : $lnP3M($l6E2L(value));
}
module.exports = $38afcbfab85a0553$var$castPath;

});
parcelRegister("kPpic", function(module, exports) {

var $o8HxT = parcelRequire("o8HxT");

var $9dr3u = parcelRequire("9dr3u");
/** Used to match property names within property paths. */ var $03e9beb856e9b4cd$var$reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, $03e9beb856e9b4cd$var$reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function $03e9beb856e9b4cd$var$isKey(value, object) {
    if ($o8HxT(value)) return false;
    var type = typeof value;
    if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || $9dr3u(value)) return true;
    return $03e9beb856e9b4cd$var$reIsPlainProp.test(value) || !$03e9beb856e9b4cd$var$reIsDeepProp.test(value) || object != null && value in Object(object);
}
module.exports = $03e9beb856e9b4cd$var$isKey;

});
parcelRegister("9dr3u", function(module, exports) {

var $eq6CV = parcelRequire("eq6CV");

var $8l89S = parcelRequire("8l89S");
/** `Object#toString` result references. */ var $6b5a5095e0934938$var$symbolTag = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $6b5a5095e0934938$var$isSymbol(value) {
    return typeof value == 'symbol' || $8l89S(value) && $eq6CV(value) == $6b5a5095e0934938$var$symbolTag;
}
module.exports = $6b5a5095e0934938$var$isSymbol;

});


parcelRegister("lnP3M", function(module, exports) {

var $99Rk8 = parcelRequire("99Rk8");
/** Used to match property names within property paths. */ var $f9135a667399ede4$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var $f9135a667399ede4$var$reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $f9135a667399ede4$var$stringToPath = $99Rk8(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
    string.replace($f9135a667399ede4$var$rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace($f9135a667399ede4$var$reEscapeChar, '$1') : number || match);
    });
    return result;
});
module.exports = $f9135a667399ede4$var$stringToPath;

});
parcelRegister("99Rk8", function(module, exports) {

var $23xpV = parcelRequire("23xpV");
/** Used as the maximum memoize cache size. */ var $6aae515404bf5dd2$var$MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function $6aae515404bf5dd2$var$memoizeCapped(func) {
    var result = $23xpV(func, function(key) {
        if (cache.size === $6aae515404bf5dd2$var$MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
module.exports = $6aae515404bf5dd2$var$memoizeCapped;

});
parcelRegister("23xpV", function(module, exports) {

var $6gDBQ = parcelRequire("6gDBQ");
/** Error message constants. */ var $17f5c88c594eac51$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $17f5c88c594eac51$var$memoize(func, resolver) {
    if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError($17f5c88c594eac51$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new ($17f5c88c594eac51$var$memoize.Cache || $6gDBQ);
    return memoized;
}
// Expose `MapCache`.
$17f5c88c594eac51$var$memoize.Cache = $6gDBQ;
module.exports = $17f5c88c594eac51$var$memoize;

});



parcelRegister("l6E2L", function(module, exports) {

var $kJ9w3 = parcelRequire("kJ9w3");
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $f5d9385a9cc7e413$var$toString(value) {
    return value == null ? '' : $kJ9w3(value);
}
module.exports = $f5d9385a9cc7e413$var$toString;

});
parcelRegister("kJ9w3", function(module, exports) {

var $57wYk = parcelRequire("57wYk");

var $i46jW = parcelRequire("i46jW");

var $o8HxT = parcelRequire("o8HxT");

var $9dr3u = parcelRequire("9dr3u");
/** Used as references for various `Number` constants. */ var $f16f644742c27c21$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $f16f644742c27c21$var$symbolProto = $57wYk ? $57wYk.prototype : undefined, $f16f644742c27c21$var$symbolToString = $f16f644742c27c21$var$symbolProto ? $f16f644742c27c21$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $f16f644742c27c21$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') return value;
    if ($o8HxT(value)) // Recursively convert values (susceptible to call stack limits).
    return $i46jW(value, $f16f644742c27c21$var$baseToString) + '';
    if ($9dr3u(value)) return $f16f644742c27c21$var$symbolToString ? $f16f644742c27c21$var$symbolToString.call(value) : '';
    var result = value + '';
    return result == '0' && 1 / value == -$f16f644742c27c21$var$INFINITY ? '-0' : result;
}
module.exports = $f16f644742c27c21$var$baseToString;

});
parcelRegister("i46jW", function(module, exports) {
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $d26d80da1ba3948c$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
module.exports = $d26d80da1ba3948c$var$arrayMap;

});




parcelRegister("6DSvu", function(module, exports) {

var $9dr3u = parcelRequire("9dr3u");
/** Used as references for various `Number` constants. */ var $4d60aa8c33155976$var$INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $4d60aa8c33155976$var$toKey(value) {
    if (typeof value == 'string' || $9dr3u(value)) return value;
    var result = value + '';
    return result == '0' && 1 / value == -$4d60aa8c33155976$var$INFINITY ? '-0' : result;
}
module.exports = $4d60aa8c33155976$var$toKey;

});



parcelRegister("2VBx6", function(module, exports) {

var $ij33W = parcelRequire("ij33W");

var $btvBm = parcelRequire("btvBm");
/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function $221e04e57e35dd04$var$hasIn(object, path) {
    return object != null && $btvBm(object, path, $ij33W);
}
module.exports = $221e04e57e35dd04$var$hasIn;

});
parcelRegister("ij33W", function(module, exports) {
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function $d53c6080f339a51f$var$baseHasIn(object, key) {
    return object != null && key in Object(object);
}
module.exports = $d53c6080f339a51f$var$baseHasIn;

});

parcelRegister("btvBm", function(module, exports) {

var $4RK0h = parcelRequire("4RK0h");

var $aJD6g = parcelRequire("aJD6g");

var $o8HxT = parcelRequire("o8HxT");

var $iyUuu = parcelRequire("iyUuu");

var $1S9lz = parcelRequire("1S9lz");

var $6DSvu = parcelRequire("6DSvu");
/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function $85aaea8f77d790ae$var$hasPath(object, path, hasFunc) {
    path = $4RK0h(path, object);
    var index = -1, length = path.length, result = false;
    while(++index < length){
        var key = $6DSvu(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result || ++index != length) return result;
    length = object == null ? 0 : object.length;
    return !!length && $1S9lz(length) && $iyUuu(key, length) && ($o8HxT(object) || $aJD6g(object));
}
module.exports = $85aaea8f77d790ae$var$hasPath;

});



parcelRegister("bAYPD", function(module, exports) {

var $ielIK = parcelRequire("ielIK");

var $jfdoV = parcelRequire("jfdoV");

var $kPpic = parcelRequire("kPpic");

var $6DSvu = parcelRequire("6DSvu");
/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function $87123e72266aa58c$var$property(path) {
    return $kPpic(path) ? $ielIK($6DSvu(path)) : $jfdoV(path);
}
module.exports = $87123e72266aa58c$var$property;

});
parcelRegister("ielIK", function(module, exports) {
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $d45a621b4548f6bb$var$baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
module.exports = $d45a621b4548f6bb$var$baseProperty;

});

parcelRegister("jfdoV", function(module, exports) {

var $lJEX1 = parcelRequire("lJEX1");
/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $e029d02f9dd10368$var$basePropertyDeep(path) {
    return function(object) {
        return $lJEX1(object, path);
    };
}
module.exports = $e029d02f9dd10368$var$basePropertyDeep;

});




parcelRegister("jplJt", function(module, exports) {

var $5aSdf = parcelRequire("5aSdf");

var $btvBm = parcelRequire("btvBm");
/**
 * Checks if `path` is a direct property of `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = { 'a': { 'b': 2 } };
 * var other = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.has(object, 'a');
 * // => true
 *
 * _.has(object, 'a.b');
 * // => true
 *
 * _.has(object, ['a', 'b']);
 * // => true
 *
 * _.has(other, 'a');
 * // => false
 */ function $e21135b6db383fe3$var$has(object, path) {
    return object != null && $btvBm(object, path, $5aSdf);
}
module.exports = $e21135b6db383fe3$var$has;

});
parcelRegister("5aSdf", function(module, exports) {
/** Used for built-in method references. */ var $3c47f0745c8ad323$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $3c47f0745c8ad323$var$hasOwnProperty = $3c47f0745c8ad323$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.has` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function $3c47f0745c8ad323$var$baseHas(object, key) {
    return object != null && $3c47f0745c8ad323$var$hasOwnProperty.call(object, key);
}
module.exports = $3c47f0745c8ad323$var$baseHas;

});


parcelRegister("44Pmt", function(module, exports) {

var $jViFF = parcelRequire("jViFF");

var $67A6V = parcelRequire("67A6V");

var $aJD6g = parcelRequire("aJD6g");

var $o8HxT = parcelRequire("o8HxT");

var $eMthh = parcelRequire("eMthh");

var $f504n = parcelRequire("f504n");

var $3wZFp = parcelRequire("3wZFp");

var $1Q21n = parcelRequire("1Q21n");
/** `Object#toString` result references. */ var $2f7f607262506341$var$mapTag = '[object Map]', $2f7f607262506341$var$setTag = '[object Set]';
/** Used for built-in method references. */ var $2f7f607262506341$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $2f7f607262506341$var$hasOwnProperty = $2f7f607262506341$var$objectProto.hasOwnProperty;
/**
 * Checks if `value` is an empty object, collection, map, or set.
 *
 * Objects are considered empty if they have no own enumerable string keyed
 * properties.
 *
 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
 * jQuery-like collections are considered empty if they have a `length` of `0`.
 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */ function $2f7f607262506341$var$isEmpty(value) {
    if (value == null) return true;
    if ($eMthh(value) && ($o8HxT(value) || typeof value == 'string' || typeof value.splice == 'function' || $f504n(value) || $1Q21n(value) || $aJD6g(value))) return !value.length;
    var tag = $67A6V(value);
    if (tag == $2f7f607262506341$var$mapTag || tag == $2f7f607262506341$var$setTag) return !value.size;
    if ($3wZFp(value)) return !$jViFF(value).length;
    for(var key in value){
        if ($2f7f607262506341$var$hasOwnProperty.call(value, key)) return false;
    }
    return true;
}
module.exports = $2f7f607262506341$var$isEmpty;

});

parcelRegister("enrJD", function(module, exports) {
/**
 * Checks if `value` is `undefined`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
 * @example
 *
 * _.isUndefined(void 0);
 * // => true
 *
 * _.isUndefined(null);
 * // => false
 */ function $a778ba4a8bc65100$var$isUndefined(value) {
    return value === undefined;
}
module.exports = $a778ba4a8bc65100$var$isUndefined;

});

parcelRegister("437iZ", function(module, exports) {

var $i46jW = parcelRequire("i46jW");

var $7MWok = parcelRequire("7MWok");

var $fDc61 = parcelRequire("fDc61");

var $o8HxT = parcelRequire("o8HxT");
/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */ function $2f2d1bf022ac3e3d$var$map(collection, iteratee) {
    var func = $o8HxT(collection) ? $i46jW : $fDc61;
    return func(collection, $7MWok(iteratee, 3));
}
module.exports = $2f2d1bf022ac3e3d$var$map;

});
parcelRegister("fDc61", function(module, exports) {

var $4DjQp = parcelRequire("4DjQp");

var $eMthh = parcelRequire("eMthh");
/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $b613e194c1b157de$var$baseMap(collection, iteratee) {
    var index = -1, result = $eMthh(collection) ? Array(collection.length) : [];
    $4DjQp(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
    });
    return result;
}
module.exports = $b613e194c1b157de$var$baseMap;

});


parcelRegister("2KuAh", function(module, exports) {

var $1FZZ3 = parcelRequire("1FZZ3");

var $4DjQp = parcelRequire("4DjQp");

var $7MWok = parcelRequire("7MWok");

var $aJqKN = parcelRequire("aJqKN");

var $o8HxT = parcelRequire("o8HxT");
/**
 * Reduces `collection` to a value which is the accumulated result of running
 * each element in `collection` thru `iteratee`, where each successive
 * invocation is supplied the return value of the previous. If `accumulator`
 * is not given, the first element of `collection` is used as the initial
 * value. The iteratee is invoked with four arguments:
 * (accumulator, value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.reduce`, `_.reduceRight`, and `_.transform`.
 *
 * The guarded methods are:
 * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
 * and `sortBy`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @returns {*} Returns the accumulated value.
 * @see _.reduceRight
 * @example
 *
 * _.reduce([1, 2], function(sum, n) {
 *   return sum + n;
 * }, 0);
 * // => 3
 *
 * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
 *   (result[value] || (result[value] = [])).push(key);
 *   return result;
 * }, {});
 * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
 */ function $20079a03744bdfdb$var$reduce(collection, iteratee, accumulator) {
    var func = $o8HxT(collection) ? $1FZZ3 : $aJqKN, initAccum = arguments.length < 3;
    return func(collection, $7MWok(iteratee, 4), accumulator, initAccum, $4DjQp);
}
module.exports = $20079a03744bdfdb$var$reduce;

});
parcelRegister("1FZZ3", function(module, exports) {
/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */ function $1389b3710f5da9e8$var$arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1, length = array == null ? 0 : array.length;
    if (initAccum && length) accumulator = array[++index];
    while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
    return accumulator;
}
module.exports = $1389b3710f5da9e8$var$arrayReduce;

});

parcelRegister("aJqKN", function(module, exports) {
/**
 * The base implementation of `_.reduce` and `_.reduceRight`, without support
 * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} accumulator The initial value.
 * @param {boolean} initAccum Specify using the first or last element of
 *  `collection` as the initial value.
 * @param {Function} eachFunc The function to iterate over `collection`.
 * @returns {*} Returns the accumulated value.
 */ function $7d02dc1e77542632$var$baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
        accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
}
module.exports = $7d02dc1e77542632$var$baseReduce;

});


parcelRegister("2RKXE", function(module, exports) {

var $jViFF = parcelRequire("jViFF");

var $67A6V = parcelRequire("67A6V");

var $eMthh = parcelRequire("eMthh");

var $1SJGG = parcelRequire("1SJGG");

var $irc76 = parcelRequire("irc76");
/** `Object#toString` result references. */ var $2164f585c713957a$var$mapTag = '[object Map]', $2164f585c713957a$var$setTag = '[object Set]';
/**
 * Gets the size of `collection` by returning its length for array-like
 * values or the number of own enumerable string keyed properties for objects.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object|string} collection The collection to inspect.
 * @returns {number} Returns the collection size.
 * @example
 *
 * _.size([1, 2, 3]);
 * // => 3
 *
 * _.size({ 'a': 1, 'b': 2 });
 * // => 2
 *
 * _.size('pebbles');
 * // => 7
 */ function $2164f585c713957a$var$size(collection) {
    if (collection == null) return 0;
    if ($eMthh(collection)) return $1SJGG(collection) ? $irc76(collection) : collection.length;
    var tag = $67A6V(collection);
    if (tag == $2164f585c713957a$var$mapTag || tag == $2164f585c713957a$var$setTag) return collection.size;
    return $jViFF(collection).length;
}
module.exports = $2164f585c713957a$var$size;

});
parcelRegister("1SJGG", function(module, exports) {

var $eq6CV = parcelRequire("eq6CV");

var $o8HxT = parcelRequire("o8HxT");

var $8l89S = parcelRequire("8l89S");
/** `Object#toString` result references. */ var $15ee4628980e0994$var$stringTag = '[object String]';
/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */ function $15ee4628980e0994$var$isString(value) {
    return typeof value == 'string' || !$o8HxT(value) && $8l89S(value) && $eq6CV(value) == $15ee4628980e0994$var$stringTag;
}
module.exports = $15ee4628980e0994$var$isString;

});

parcelRegister("irc76", function(module, exports) {

var $ijOWR = parcelRequire("ijOWR");

var $05hp8 = parcelRequire("05hp8");

var $etsxF = parcelRequire("etsxF");
/**
 * Gets the number of symbols in `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the string size.
 */ function $d6c4251e3abece1b$var$stringSize(string) {
    return $05hp8(string) ? $etsxF(string) : $ijOWR(string);
}
module.exports = $d6c4251e3abece1b$var$stringSize;

});
parcelRegister("ijOWR", function(module, exports) {

var $ielIK = parcelRequire("ielIK");
/**
 * Gets the size of an ASCII `string`.
 *
 * @private
 * @param {string} string The string inspect.
 * @returns {number} Returns the string size.
 */ var $d56185a2b451cebc$var$asciiSize = $ielIK('length');
module.exports = $d56185a2b451cebc$var$asciiSize;

});

parcelRegister("05hp8", function(module, exports) {
/** Used to compose unicode character classes. */ var $00fdf7eab00be2e7$var$rsAstralRange = '\\ud800-\\udfff', $00fdf7eab00be2e7$var$rsComboMarksRange = '\\u0300-\\u036f', $00fdf7eab00be2e7$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $00fdf7eab00be2e7$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $00fdf7eab00be2e7$var$rsComboRange = $00fdf7eab00be2e7$var$rsComboMarksRange + $00fdf7eab00be2e7$var$reComboHalfMarksRange + $00fdf7eab00be2e7$var$rsComboSymbolsRange, $00fdf7eab00be2e7$var$rsVarRange = '\\ufe0e\\ufe0f';
/** Used to compose unicode capture groups. */ var $00fdf7eab00be2e7$var$rsZWJ = '\\u200d';
/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var $00fdf7eab00be2e7$var$reHasUnicode = RegExp('[' + $00fdf7eab00be2e7$var$rsZWJ + $00fdf7eab00be2e7$var$rsAstralRange + $00fdf7eab00be2e7$var$rsComboRange + $00fdf7eab00be2e7$var$rsVarRange + ']');
/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */ function $00fdf7eab00be2e7$var$hasUnicode(string) {
    return $00fdf7eab00be2e7$var$reHasUnicode.test(string);
}
module.exports = $00fdf7eab00be2e7$var$hasUnicode;

});

parcelRegister("etsxF", function(module, exports) {
/** Used to compose unicode character classes. */ var $a899e9fda8cd3735$var$rsAstralRange = '\\ud800-\\udfff', $a899e9fda8cd3735$var$rsComboMarksRange = '\\u0300-\\u036f', $a899e9fda8cd3735$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $a899e9fda8cd3735$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $a899e9fda8cd3735$var$rsComboRange = $a899e9fda8cd3735$var$rsComboMarksRange + $a899e9fda8cd3735$var$reComboHalfMarksRange + $a899e9fda8cd3735$var$rsComboSymbolsRange, $a899e9fda8cd3735$var$rsVarRange = '\\ufe0e\\ufe0f';
/** Used to compose unicode capture groups. */ var $a899e9fda8cd3735$var$rsAstral = '[' + $a899e9fda8cd3735$var$rsAstralRange + ']', $a899e9fda8cd3735$var$rsCombo = '[' + $a899e9fda8cd3735$var$rsComboRange + ']', $a899e9fda8cd3735$var$rsFitz = '\\ud83c[\\udffb-\\udfff]', $a899e9fda8cd3735$var$rsModifier = '(?:' + $a899e9fda8cd3735$var$rsCombo + '|' + $a899e9fda8cd3735$var$rsFitz + ')', $a899e9fda8cd3735$var$rsNonAstral = '[^' + $a899e9fda8cd3735$var$rsAstralRange + ']', $a899e9fda8cd3735$var$rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', $a899e9fda8cd3735$var$rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', $a899e9fda8cd3735$var$rsZWJ = '\\u200d';
/** Used to compose unicode regexes. */ var $a899e9fda8cd3735$var$reOptMod = $a899e9fda8cd3735$var$rsModifier + '?', $a899e9fda8cd3735$var$rsOptVar = '[' + $a899e9fda8cd3735$var$rsVarRange + ']?', $a899e9fda8cd3735$var$rsOptJoin = '(?:' + $a899e9fda8cd3735$var$rsZWJ + '(?:' + [
    $a899e9fda8cd3735$var$rsNonAstral,
    $a899e9fda8cd3735$var$rsRegional,
    $a899e9fda8cd3735$var$rsSurrPair
].join('|') + ')' + $a899e9fda8cd3735$var$rsOptVar + $a899e9fda8cd3735$var$reOptMod + ')*', $a899e9fda8cd3735$var$rsSeq = $a899e9fda8cd3735$var$rsOptVar + $a899e9fda8cd3735$var$reOptMod + $a899e9fda8cd3735$var$rsOptJoin, $a899e9fda8cd3735$var$rsSymbol = '(?:' + [
    $a899e9fda8cd3735$var$rsNonAstral + $a899e9fda8cd3735$var$rsCombo + '?',
    $a899e9fda8cd3735$var$rsCombo,
    $a899e9fda8cd3735$var$rsRegional,
    $a899e9fda8cd3735$var$rsSurrPair,
    $a899e9fda8cd3735$var$rsAstral
].join('|') + ')';
/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var $a899e9fda8cd3735$var$reUnicode = RegExp($a899e9fda8cd3735$var$rsFitz + '(?=' + $a899e9fda8cd3735$var$rsFitz + ')|' + $a899e9fda8cd3735$var$rsSymbol + $a899e9fda8cd3735$var$rsSeq, 'g');
/**
 * Gets the size of a Unicode `string`.
 *
 * @private
 * @param {string} string The string inspect.
 * @returns {number} Returns the string size.
 */ function $a899e9fda8cd3735$var$unicodeSize(string) {
    var result = $a899e9fda8cd3735$var$reUnicode.lastIndex = 0;
    while($a899e9fda8cd3735$var$reUnicode.test(string))++result;
    return result;
}
module.exports = $a899e9fda8cd3735$var$unicodeSize;

});



parcelRegister("bGcIb", function(module, exports) {

var $bFZGr = parcelRequire("bFZGr");

var $4XGZt = parcelRequire("4XGZt");

var $4xK4A = parcelRequire("4xK4A");

var $7MWok = parcelRequire("7MWok");

var $cdnOB = parcelRequire("cdnOB");

var $o8HxT = parcelRequire("o8HxT");

var $f504n = parcelRequire("f504n");

var $01ubZ = parcelRequire("01ubZ");

var $lsJ54 = parcelRequire("lsJ54");

var $1Q21n = parcelRequire("1Q21n");
/**
 * An alternative to `_.reduce`; this method transforms `object` to a new
 * `accumulator` object which is the result of running each of its own
 * enumerable string keyed properties thru `iteratee`, with each invocation
 * potentially mutating the `accumulator` object. If `accumulator` is not
 * provided, a new object with the same `[[Prototype]]` will be used. The
 * iteratee is invoked with four arguments: (accumulator, value, key, object).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @static
 * @memberOf _
 * @since 1.3.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @param {*} [accumulator] The custom accumulator value.
 * @returns {*} Returns the accumulated value.
 * @example
 *
 * _.transform([2, 3, 4], function(result, n) {
 *   result.push(n *= n);
 *   return n % 2 == 0;
 * }, []);
 * // => [4, 9]
 *
 * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
 *   (result[value] || (result[value] = [])).push(key);
 * }, {});
 * // => { '1': ['a', 'c'], '2': ['b'] }
 */ function $880d7a3d41bd08eb$var$transform(object, iteratee, accumulator) {
    var isArr = $o8HxT(object), isArrLike = isArr || $f504n(object) || $1Q21n(object);
    iteratee = $7MWok(iteratee, 4);
    if (accumulator == null) {
        var Ctor = object && object.constructor;
        if (isArrLike) accumulator = isArr ? new Ctor : [];
        else if ($lsJ54(object)) accumulator = $01ubZ(Ctor) ? $4XGZt($cdnOB(object)) : {};
        else accumulator = {};
    }
    (isArrLike ? $bFZGr : $4xK4A)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
    });
    return accumulator;
}
module.exports = $880d7a3d41bd08eb$var$transform;

});

parcelRegister("1c10x", function(module, exports) {

var $fgBHx = parcelRequire("fgBHx");

var $5iyRF = parcelRequire("5iyRF");

var $5VSS6 = parcelRequire("5VSS6");

var $jGP9B = parcelRequire("jGP9B");
/**
 * Creates an array of unique values, in order, from all given arrays using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @returns {Array} Returns the new array of combined values.
 * @example
 *
 * _.union([2], [1, 2]);
 * // => [2, 1]
 */ var $0de7b1862975f367$var$union = $5iyRF(function(arrays) {
    return $5VSS6($fgBHx(arrays, 1, $jGP9B, true));
});
module.exports = $0de7b1862975f367$var$union;

});
parcelRegister("fgBHx", function(module, exports) {

var $hynws = parcelRequire("hynws");

var $hStNq = parcelRequire("hStNq");
/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */ function $b1d5985487d54dea$var$baseFlatten(array, depth, predicate, isStrict, result) {
    var index = -1, length = array.length;
    predicate || (predicate = $hStNq);
    result || (result = []);
    while(++index < length){
        var value = array[index];
        if (depth > 0 && predicate(value)) {
            if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
            $b1d5985487d54dea$var$baseFlatten(value, depth - 1, predicate, isStrict, result);
            else $hynws(result, value);
        } else if (!isStrict) result[result.length] = value;
    }
    return result;
}
module.exports = $b1d5985487d54dea$var$baseFlatten;

});
parcelRegister("hStNq", function(module, exports) {

var $57wYk = parcelRequire("57wYk");

var $aJD6g = parcelRequire("aJD6g");

var $o8HxT = parcelRequire("o8HxT");
/** Built-in value references. */ var $035bd928078475ee$var$spreadableSymbol = $57wYk ? $57wYk.isConcatSpreadable : undefined;
/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */ function $035bd928078475ee$var$isFlattenable(value) {
    return $o8HxT(value) || $aJD6g(value) || !!($035bd928078475ee$var$spreadableSymbol && value && value[$035bd928078475ee$var$spreadableSymbol]);
}
module.exports = $035bd928078475ee$var$isFlattenable;

});


parcelRegister("5iyRF", function(module, exports) {

var $4Nq5y = parcelRequire("4Nq5y");

var $b86t6 = parcelRequire("b86t6");

var $iGMVy = parcelRequire("iGMVy");
/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */ function $3db9ad8fe1351fef$var$baseRest(func, start) {
    return $iGMVy($b86t6(func, start, $4Nq5y), func + '');
}
module.exports = $3db9ad8fe1351fef$var$baseRest;

});
parcelRegister("b86t6", function(module, exports) {

var $jpWht = parcelRequire("jpWht");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $81a5758ee0248452$var$nativeMax = Math.max;
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */ function $81a5758ee0248452$var$overRest(func, start, transform) {
    start = $81a5758ee0248452$var$nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = $81a5758ee0248452$var$nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = transform(array);
        return $jpWht(func, this, otherArgs);
    };
}
module.exports = $81a5758ee0248452$var$overRest;

});
parcelRegister("jpWht", function(module, exports) {
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ function $e22d8f7aab4ea8e2$var$apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
module.exports = $e22d8f7aab4ea8e2$var$apply;

});


parcelRegister("iGMVy", function(module, exports) {

var $2yzAw = parcelRequire("2yzAw");

var $7WhTB = parcelRequire("7WhTB");
/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $d9b21a2cad7f96c2$var$setToString = $7WhTB($2yzAw);
module.exports = $d9b21a2cad7f96c2$var$setToString;

});
parcelRegister("2yzAw", function(module, exports) {

var $9HRmE = parcelRequire("9HRmE");

var $4hwTc = parcelRequire("4hwTc");

var $4Nq5y = parcelRequire("4Nq5y");
/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $1dca5cc74bf5ffaf$var$baseSetToString = !$4hwTc ? $4Nq5y : function(func, string) {
    return $4hwTc(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': $9HRmE(string),
        'writable': true
    });
};
module.exports = $1dca5cc74bf5ffaf$var$baseSetToString;

});

parcelRegister("7WhTB", function(module, exports) {
/** Used to detect hot functions by number of calls within a span of milliseconds. */ var $5c7bd4e931ae22e5$var$HOT_COUNT = 800, $5c7bd4e931ae22e5$var$HOT_SPAN = 16;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $5c7bd4e931ae22e5$var$nativeNow = Date.now;
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */ function $5c7bd4e931ae22e5$var$shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
        var stamp = $5c7bd4e931ae22e5$var$nativeNow(), remaining = $5c7bd4e931ae22e5$var$HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
            if (++count >= $5c7bd4e931ae22e5$var$HOT_COUNT) return arguments[0];
        } else count = 0;
        return func.apply(undefined, arguments);
    };
}
module.exports = $5c7bd4e931ae22e5$var$shortOut;

});



parcelRegister("5VSS6", function(module, exports) {

var $dXA7v = parcelRequire("dXA7v");

var $ebE2M = parcelRequire("ebE2M");

var $eSdxB = parcelRequire("eSdxB");

var $2l8n7 = parcelRequire("2l8n7");

var $5sRi0 = parcelRequire("5sRi0");

var $1xAji = parcelRequire("1xAji");
/** Used as the size to enable large array optimizations. */ var $451cd6fc5b077ebe$var$LARGE_ARRAY_SIZE = 200;
/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */ function $451cd6fc5b077ebe$var$baseUniq(array, iteratee, comparator) {
    var index = -1, includes = $ebE2M, length = array.length, isCommon = true, result = [], seen = result;
    if (comparator) {
        isCommon = false;
        includes = $eSdxB;
    } else if (length >= $451cd6fc5b077ebe$var$LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : $5sRi0(array);
        if (set) return $1xAji(set);
        isCommon = false;
        includes = $2l8n7;
        seen = new $dXA7v;
    } else seen = iteratee ? [] : result;
    outer: while(++index < length){
        var value = array[index], computed = iteratee ? iteratee(value) : value;
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
            var seenIndex = seen.length;
            while(seenIndex--){
                if (seen[seenIndex] === computed) continue outer;
            }
            if (iteratee) seen.push(computed);
            result.push(value);
        } else if (!includes(seen, computed, comparator)) {
            if (seen !== result) seen.push(computed);
            result.push(value);
        }
    }
    return result;
}
module.exports = $451cd6fc5b077ebe$var$baseUniq;

});
parcelRegister("ebE2M", function(module, exports) {

var $7pFTU = parcelRequire("7pFTU");
/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $a541279ebb64f2c9$var$arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && $7pFTU(array, value, 0) > -1;
}
module.exports = $a541279ebb64f2c9$var$arrayIncludes;

});
parcelRegister("7pFTU", function(module, exports) {

var $eAor6 = parcelRequire("eAor6");

var $h2dHy = parcelRequire("h2dHy");

var $dU1uo = parcelRequire("dU1uo");
/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $565b5ed18efa4b9c$var$baseIndexOf(array, value, fromIndex) {
    return value === value ? $dU1uo(array, value, fromIndex) : $eAor6(array, $h2dHy, fromIndex);
}
module.exports = $565b5ed18efa4b9c$var$baseIndexOf;

});
parcelRegister("eAor6", function(module, exports) {
/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $a9e76203bd7c412f$var$baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
    while(fromRight ? index-- : ++index < length){
        if (predicate(array[index], index, array)) return index;
    }
    return -1;
}
module.exports = $a9e76203bd7c412f$var$baseFindIndex;

});

parcelRegister("h2dHy", function(module, exports) {
/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */ function $c66d4063f81f4687$var$baseIsNaN(value) {
    return value !== value;
}
module.exports = $c66d4063f81f4687$var$baseIsNaN;

});

parcelRegister("dU1uo", function(module, exports) {
/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $a1f1a90cd7caaefa$var$strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1, length = array.length;
    while(++index < length){
        if (array[index] === value) return index;
    }
    return -1;
}
module.exports = $a1f1a90cd7caaefa$var$strictIndexOf;

});



parcelRegister("eSdxB", function(module, exports) {
/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $ad409cc63f3cbe79$var$arrayIncludesWith(array, value, comparator) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (comparator(value, array[index])) return true;
    }
    return false;
}
module.exports = $ad409cc63f3cbe79$var$arrayIncludesWith;

});

parcelRegister("5sRi0", function(module, exports) {

var $vH4x0 = parcelRequire("vH4x0");

var $9iECD = parcelRequire("9iECD");

var $1xAji = parcelRequire("1xAji");
/** Used as references for various `Number` constants. */ var $3fa8e773494800f5$var$INFINITY = 1 / 0;
/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */ var $3fa8e773494800f5$var$createSet = !($vH4x0 && 1 / $1xAji(new $vH4x0([
    ,
    -0
]))[1] == $3fa8e773494800f5$var$INFINITY) ? $9iECD : function(values) {
    return new $vH4x0(values);
};
module.exports = $3fa8e773494800f5$var$createSet;

});
parcelRegister("9iECD", function(module, exports) {
/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */ function $6c554e32feae9faa$var$noop() {
// No operation performed.
}
module.exports = $6c554e32feae9faa$var$noop;

});



parcelRegister("jGP9B", function(module, exports) {

var $eMthh = parcelRequire("eMthh");

var $8l89S = parcelRequire("8l89S");
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function $e5599ea424e07f76$var$isArrayLikeObject(value) {
    return $8l89S(value) && $eMthh(value);
}
module.exports = $e5599ea424e07f76$var$isArrayLikeObject;

});


parcelRegister("7D6Gq", function(module, exports) {

var $jaYdQ = parcelRequire("jaYdQ");

var $LAMcS = parcelRequire("LAMcS");
/**
 * Creates an array of the own enumerable string keyed property values of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property values.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.values(new Foo);
 * // => [1, 2] (iteration order is not guaranteed)
 *
 * _.values('hi');
 * // => ['h', 'i']
 */ function $58e15c1958c92f73$var$values(object) {
    return object == null ? [] : $jaYdQ(object, $LAMcS(object));
}
module.exports = $58e15c1958c92f73$var$values;

});
parcelRegister("jaYdQ", function(module, exports) {

var $i46jW = parcelRequire("i46jW");
/**
 * The base implementation of `_.values` and `_.valuesIn` which creates an
 * array of `object` property values corresponding to the property names
 * of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the array of property values.
 */ function $df5daa5e60cd3cbe$var$baseValues(object, props) {
    return $i46jW(props, function(key) {
        return object[key];
    });
}
module.exports = $df5daa5e60cd3cbe$var$baseValues;

});




parcelRegister("5LcVV", function(module, exports) {
module.exports = '2.1.8';

});


parcelRegister("cOdIh", function(module, exports) {

var $dOCPl = parcelRequire("dOCPl");

var $4JZcb = parcelRequire("4JZcb");
module.exports = {
    write: $9534cab8b40cf3db$var$write,
    read: $9534cab8b40cf3db$var$read
};
function $9534cab8b40cf3db$var$write(g) {
    var json = {
        options: {
            directed: g.isDirected(),
            multigraph: g.isMultigraph(),
            compound: g.isCompound()
        },
        nodes: $9534cab8b40cf3db$var$writeNodes(g),
        edges: $9534cab8b40cf3db$var$writeEdges(g)
    };
    if (!$dOCPl.isUndefined(g.graph())) json.value = $dOCPl.clone(g.graph());
    return json;
}
function $9534cab8b40cf3db$var$writeNodes(g) {
    return $dOCPl.map(g.nodes(), function(v) {
        var nodeValue = g.node(v);
        var parent = g.parent(v);
        var node = {
            v: v
        };
        if (!$dOCPl.isUndefined(nodeValue)) node.value = nodeValue;
        if (!$dOCPl.isUndefined(parent)) node.parent = parent;
        return node;
    });
}
function $9534cab8b40cf3db$var$writeEdges(g) {
    return $dOCPl.map(g.edges(), function(e) {
        var edgeValue = g.edge(e);
        var edge = {
            v: e.v,
            w: e.w
        };
        if (!$dOCPl.isUndefined(e.name)) edge.name = e.name;
        if (!$dOCPl.isUndefined(edgeValue)) edge.value = edgeValue;
        return edge;
    });
}
function $9534cab8b40cf3db$var$read(json) {
    var g = new $4JZcb(json.options).setGraph(json.value);
    $dOCPl.each(json.nodes, function(entry) {
        g.setNode(entry.v, entry.value);
        if (entry.parent) g.setParent(entry.v, entry.parent);
    });
    $dOCPl.each(json.edges, function(entry) {
        g.setEdge({
            v: entry.v,
            w: entry.w,
            name: entry.name
        }, entry.value);
    });
    return g;
}

});

parcelRegister("jm1Oa", function(module, exports) {











module.exports = {
    components: (parcelRequire("c3Kkn")),
    dijkstra: (parcelRequire("a8y4J")),
    dijkstraAll: (parcelRequire("3uso6")),
    findCycles: (parcelRequire("6pFca")),
    floydWarshall: (parcelRequire("2yn2B")),
    isAcyclic: (parcelRequire("3hBSd")),
    postorder: (parcelRequire("dX1tj")),
    preorder: (parcelRequire("e890l")),
    prim: (parcelRequire("ifTuH")),
    tarjan: (parcelRequire("38Zd5")),
    topsort: (parcelRequire("8UkLw"))
};

});
parcelRegister("c3Kkn", function(module, exports) {

var $dOCPl = parcelRequire("dOCPl");
module.exports = $8c79b38e8bb785e6$var$components;
function $8c79b38e8bb785e6$var$components(g) {
    var visited = {};
    var cmpts = [];
    var cmpt;
    function dfs(v) {
        if ($dOCPl.has(visited, v)) return;
        visited[v] = true;
        cmpt.push(v);
        $dOCPl.each(g.successors(v), dfs);
        $dOCPl.each(g.predecessors(v), dfs);
    }
    $dOCPl.each(g.nodes(), function(v) {
        cmpt = [];
        dfs(v);
        if (cmpt.length) cmpts.push(cmpt);
    });
    return cmpts;
}

});

parcelRegister("a8y4J", function(module, exports) {

var $dOCPl = parcelRequire("dOCPl");

var $5ZDax = parcelRequire("5ZDax");
module.exports = $7615155e1d66a6d5$var$dijkstra;
var $7615155e1d66a6d5$var$DEFAULT_WEIGHT_FUNC = $dOCPl.constant(1);
function $7615155e1d66a6d5$var$dijkstra(g, source, weightFn, edgeFn) {
    return $7615155e1d66a6d5$var$runDijkstra(g, String(source), weightFn || $7615155e1d66a6d5$var$DEFAULT_WEIGHT_FUNC, edgeFn || function(v) {
        return g.outEdges(v);
    });
}
function $7615155e1d66a6d5$var$runDijkstra(g, source, weightFn, edgeFn) {
    var results = {};
    var pq = new $5ZDax();
    var v, vEntry;
    var updateNeighbors = function(edge) {
        var w = edge.v !== v ? edge.v : edge.w;
        var wEntry = results[w];
        var weight = weightFn(edge);
        var distance = vEntry.distance + weight;
        if (weight < 0) throw new Error("dijkstra does not allow negative edge weights. Bad edge: " + edge + " Weight: " + weight);
        if (distance < wEntry.distance) {
            wEntry.distance = distance;
            wEntry.predecessor = v;
            pq.decrease(w, distance);
        }
    };
    g.nodes().forEach(function(v) {
        var distance = v === source ? 0 : Number.POSITIVE_INFINITY;
        results[v] = {
            distance: distance
        };
        pq.add(v, distance);
    });
    while(pq.size() > 0){
        v = pq.removeMin();
        vEntry = results[v];
        if (vEntry.distance === Number.POSITIVE_INFINITY) break;
        edgeFn(v).forEach(updateNeighbors);
    }
    return results;
}

});
parcelRegister("5ZDax", function(module, exports) {

var $dOCPl = parcelRequire("dOCPl");
module.exports = $45d10863bd1362e9$var$PriorityQueue;
/**
 * A min-priority queue data structure. This algorithm is derived from Cormen,
 * et al., "Introduction to Algorithms". The basic idea of a min-priority
 * queue is that you can efficiently (in O(1) time) get the smallest key in
 * the queue. Adding and removing elements takes O(log n) time. A key can
 * have its priority decreased in O(log n) time.
 */ function $45d10863bd1362e9$var$PriorityQueue() {
    this._arr = [];
    this._keyIndices = {};
}
/**
 * Returns the number of elements in the queue. Takes `O(1)` time.
 */ $45d10863bd1362e9$var$PriorityQueue.prototype.size = function() {
    return this._arr.length;
};
/**
 * Returns the keys that are in the queue. Takes `O(n)` time.
 */ $45d10863bd1362e9$var$PriorityQueue.prototype.keys = function() {
    return this._arr.map(function(x) {
        return x.key;
    });
};
/**
 * Returns `true` if **key** is in the queue and `false` if not.
 */ $45d10863bd1362e9$var$PriorityQueue.prototype.has = function(key) {
    return $dOCPl.has(this._keyIndices, key);
};
/**
 * Returns the priority for **key**. If **key** is not present in the queue
 * then this function returns `undefined`. Takes `O(1)` time.
 *
 * @param {Object} key
 */ $45d10863bd1362e9$var$PriorityQueue.prototype.priority = function(key) {
    var index = this._keyIndices[key];
    if (index !== undefined) return this._arr[index].priority;
};
/**
 * Returns the key for the minimum element in this queue. If the queue is
 * empty this function throws an Error. Takes `O(1)` time.
 */ $45d10863bd1362e9$var$PriorityQueue.prototype.min = function() {
    if (this.size() === 0) throw new Error("Queue underflow");
    return this._arr[0].key;
};
/**
 * Inserts a new key into the priority queue. If the key already exists in
 * the queue this function returns `false`; otherwise it will return `true`.
 * Takes `O(n)` time.
 *
 * @param {Object} key the key to add
 * @param {Number} priority the initial priority for the key
 */ $45d10863bd1362e9$var$PriorityQueue.prototype.add = function(key, priority) {
    var keyIndices = this._keyIndices;
    key = String(key);
    if (!$dOCPl.has(keyIndices, key)) {
        var arr = this._arr;
        var index = arr.length;
        keyIndices[key] = index;
        arr.push({
            key: key,
            priority: priority
        });
        this._decrease(index);
        return true;
    }
    return false;
};
/**
 * Removes and returns the smallest key in the queue. Takes `O(log n)` time.
 */ $45d10863bd1362e9$var$PriorityQueue.prototype.removeMin = function() {
    this._swap(0, this._arr.length - 1);
    var min = this._arr.pop();
    delete this._keyIndices[min.key];
    this._heapify(0);
    return min.key;
};
/**
 * Decreases the priority for **key** to **priority**. If the new priority is
 * greater than the previous priority, this function will throw an Error.
 *
 * @param {Object} key the key for which to raise priority
 * @param {Number} priority the new priority for the key
 */ $45d10863bd1362e9$var$PriorityQueue.prototype.decrease = function(key, priority) {
    var index = this._keyIndices[key];
    if (priority > this._arr[index].priority) throw new Error("New priority is greater than current priority. Key: " + key + " Old: " + this._arr[index].priority + " New: " + priority);
    this._arr[index].priority = priority;
    this._decrease(index);
};
$45d10863bd1362e9$var$PriorityQueue.prototype._heapify = function(i) {
    var arr = this._arr;
    var l = 2 * i;
    var r = l + 1;
    var largest = i;
    if (l < arr.length) {
        largest = arr[l].priority < arr[largest].priority ? l : largest;
        if (r < arr.length) largest = arr[r].priority < arr[largest].priority ? r : largest;
        if (largest !== i) {
            this._swap(i, largest);
            this._heapify(largest);
        }
    }
};
$45d10863bd1362e9$var$PriorityQueue.prototype._decrease = function(index) {
    var arr = this._arr;
    var priority = arr[index].priority;
    var parent;
    while(index !== 0){
        parent = index >> 1;
        if (arr[parent].priority < priority) break;
        this._swap(index, parent);
        index = parent;
    }
};
$45d10863bd1362e9$var$PriorityQueue.prototype._swap = function(i, j) {
    var arr = this._arr;
    var keyIndices = this._keyIndices;
    var origArrI = arr[i];
    var origArrJ = arr[j];
    arr[i] = origArrJ;
    arr[j] = origArrI;
    keyIndices[origArrJ.key] = i;
    keyIndices[origArrI.key] = j;
};

});


parcelRegister("3uso6", function(module, exports) {

var $a8y4J = parcelRequire("a8y4J");

var $dOCPl = parcelRequire("dOCPl");
module.exports = $28aa31ab5a3c320e$var$dijkstraAll;
function $28aa31ab5a3c320e$var$dijkstraAll(g, weightFunc, edgeFunc) {
    return $dOCPl.transform(g.nodes(), function(acc, v) {
        acc[v] = $a8y4J(g, v, weightFunc, edgeFunc);
    }, {});
}

});

parcelRegister("6pFca", function(module, exports) {

var $dOCPl = parcelRequire("dOCPl");

var $38Zd5 = parcelRequire("38Zd5");
module.exports = $4ab50861b5d77a2b$var$findCycles;
function $4ab50861b5d77a2b$var$findCycles(g) {
    return $dOCPl.filter($38Zd5(g), function(cmpt) {
        return cmpt.length > 1 || cmpt.length === 1 && g.hasEdge(cmpt[0], cmpt[0]);
    });
}

});
parcelRegister("38Zd5", function(module, exports) {

var $dOCPl = parcelRequire("dOCPl");
module.exports = $24a1997f93a076e1$var$tarjan;
function $24a1997f93a076e1$var$tarjan(g) {
    var index = 0;
    var stack = [];
    var visited = {}; // node id -> { onStack, lowlink, index }
    var results = [];
    function dfs(v) {
        var entry = visited[v] = {
            onStack: true,
            lowlink: index,
            index: index++
        };
        stack.push(v);
        g.successors(v).forEach(function(w) {
            if (!$dOCPl.has(visited, w)) {
                dfs(w);
                entry.lowlink = Math.min(entry.lowlink, visited[w].lowlink);
            } else if (visited[w].onStack) entry.lowlink = Math.min(entry.lowlink, visited[w].index);
        });
        if (entry.lowlink === entry.index) {
            var cmpt = [];
            var w;
            do {
                w = stack.pop();
                visited[w].onStack = false;
                cmpt.push(w);
            }while (v !== w);
            results.push(cmpt);
        }
    }
    g.nodes().forEach(function(v) {
        if (!$dOCPl.has(visited, v)) dfs(v);
    });
    return results;
}

});


parcelRegister("2yn2B", function(module, exports) {

var $dOCPl = parcelRequire("dOCPl");
module.exports = $1dc0a13696a98e60$var$floydWarshall;
var $1dc0a13696a98e60$var$DEFAULT_WEIGHT_FUNC = $dOCPl.constant(1);
function $1dc0a13696a98e60$var$floydWarshall(g, weightFn, edgeFn) {
    return $1dc0a13696a98e60$var$runFloydWarshall(g, weightFn || $1dc0a13696a98e60$var$DEFAULT_WEIGHT_FUNC, edgeFn || function(v) {
        return g.outEdges(v);
    });
}
function $1dc0a13696a98e60$var$runFloydWarshall(g, weightFn, edgeFn) {
    var results = {};
    var nodes = g.nodes();
    nodes.forEach(function(v) {
        results[v] = {};
        results[v][v] = {
            distance: 0
        };
        nodes.forEach(function(w) {
            if (v !== w) results[v][w] = {
                distance: Number.POSITIVE_INFINITY
            };
        });
        edgeFn(v).forEach(function(edge) {
            var w = edge.v === v ? edge.w : edge.v;
            var d = weightFn(edge);
            results[v][w] = {
                distance: d,
                predecessor: v
            };
        });
    });
    nodes.forEach(function(k) {
        var rowK = results[k];
        nodes.forEach(function(i) {
            var rowI = results[i];
            nodes.forEach(function(j) {
                var ik = rowI[k];
                var kj = rowK[j];
                var ij = rowI[j];
                var altDistance = ik.distance + kj.distance;
                if (altDistance < ij.distance) {
                    ij.distance = altDistance;
                    ij.predecessor = kj.predecessor;
                }
            });
        });
    });
    return results;
}

});

parcelRegister("3hBSd", function(module, exports) {

var $8UkLw = parcelRequire("8UkLw");
module.exports = $2640567c8b029db9$var$isAcyclic;
function $2640567c8b029db9$var$isAcyclic(g) {
    try {
        $8UkLw(g);
    } catch (e) {
        if (e instanceof $8UkLw.CycleException) return false;
        throw e;
    }
    return true;
}

});
parcelRegister("8UkLw", function(module, exports) {

var $dOCPl = parcelRequire("dOCPl");
module.exports = $67c3a94e2e06a874$var$topsort;
$67c3a94e2e06a874$var$topsort.CycleException = $67c3a94e2e06a874$var$CycleException;
function $67c3a94e2e06a874$var$topsort(g) {
    var visited = {};
    var stack = {};
    var results = [];
    function visit(node) {
        if ($dOCPl.has(stack, node)) throw new $67c3a94e2e06a874$var$CycleException();
        if (!$dOCPl.has(visited, node)) {
            stack[node] = true;
            visited[node] = true;
            $dOCPl.each(g.predecessors(node), visit);
            delete stack[node];
            results.push(node);
        }
    }
    $dOCPl.each(g.sinks(), visit);
    if ($dOCPl.size(visited) !== g.nodeCount()) throw new $67c3a94e2e06a874$var$CycleException();
    return results;
}
function $67c3a94e2e06a874$var$CycleException() {}
$67c3a94e2e06a874$var$CycleException.prototype = new Error(); // must be an instance of Error to pass testing

});


parcelRegister("dX1tj", function(module, exports) {

var $aCKt6 = parcelRequire("aCKt6");
module.exports = $a281ed51bb559346$var$postorder;
function $a281ed51bb559346$var$postorder(g, vs) {
    return $aCKt6(g, vs, "post");
}

});
parcelRegister("aCKt6", function(module, exports) {

var $dOCPl = parcelRequire("dOCPl");
module.exports = $7bc17fabfc4c38ec$var$dfs;
/*
 * A helper that preforms a pre- or post-order traversal on the input graph
 * and returns the nodes in the order they were visited. If the graph is
 * undirected then this algorithm will navigate using neighbors. If the graph
 * is directed then this algorithm will navigate using successors.
 *
 * Order must be one of "pre" or "post".
 */ function $7bc17fabfc4c38ec$var$dfs(g, vs, order) {
    if (!$dOCPl.isArray(vs)) vs = [
        vs
    ];
    var navigation = (g.isDirected() ? g.successors : g.neighbors).bind(g);
    var acc = [];
    var visited = {};
    $dOCPl.each(vs, function(v) {
        if (!g.hasNode(v)) throw new Error("Graph does not have node: " + v);
        $7bc17fabfc4c38ec$var$doDfs(g, v, order === "post", visited, navigation, acc);
    });
    return acc;
}
function $7bc17fabfc4c38ec$var$doDfs(g, v, postorder, visited, navigation, acc) {
    if (!$dOCPl.has(visited, v)) {
        visited[v] = true;
        if (!postorder) acc.push(v);
        $dOCPl.each(navigation(v), function(w) {
            $7bc17fabfc4c38ec$var$doDfs(g, w, postorder, visited, navigation, acc);
        });
        if (postorder) acc.push(v);
    }
}

});


parcelRegister("e890l", function(module, exports) {

var $aCKt6 = parcelRequire("aCKt6");
module.exports = $a498cc2fcabcfc22$var$preorder;
function $a498cc2fcabcfc22$var$preorder(g, vs) {
    return $aCKt6(g, vs, "pre");
}

});

parcelRegister("ifTuH", function(module, exports) {

var $dOCPl = parcelRequire("dOCPl");

var $4JZcb = parcelRequire("4JZcb");

var $5ZDax = parcelRequire("5ZDax");
module.exports = $d4a4acb6cacbea91$var$prim;
function $d4a4acb6cacbea91$var$prim(g, weightFunc) {
    var result = new $4JZcb();
    var parents = {};
    var pq = new $5ZDax();
    var v;
    function updateNeighbors(edge) {
        var w = edge.v === v ? edge.w : edge.v;
        var pri = pq.priority(w);
        if (pri !== undefined) {
            var edgeWeight = weightFunc(edge);
            if (edgeWeight < pri) {
                parents[w] = v;
                pq.decrease(w, edgeWeight);
            }
        }
    }
    if (g.nodeCount() === 0) return result;
    $dOCPl.each(g.nodes(), function(v) {
        pq.add(v, Number.POSITIVE_INFINITY);
        result.setNode(v);
    });
    // Start from an arbitrary node
    pq.decrease(g.nodes()[0], 0);
    var init = false;
    while(pq.size() > 0){
        v = pq.removeMin();
        if ($dOCPl.has(parents, v)) result.setEdge(v, parents[v]);
        else if (init) throw new Error("Input graph is not connected: " + g);
        else init = true;
        g.nodeEdges(v).forEach(updateNeighbors);
    }
    return result;
}

});




parcelRegister("VZEn7", function(module, exports) {
"use strict";

var $bqfL5 = parcelRequire("bqfL5");

var $61rsw = parcelRequire("61rsw");

var $fi6eg = parcelRequire("fi6eg");

var $hv32p = parcelRequire("hv32p");

var $1kMKg = parcelRequire("1kMKg");
var $0ae5256c4a1477f2$require$normalizeRanks = $1kMKg.normalizeRanks;

var $eBG2O = parcelRequire("eBG2O");

var $1kMKg = parcelRequire("1kMKg");
var $0ae5256c4a1477f2$require$removeEmptyRanks = $1kMKg.removeEmptyRanks;

var $YdQc0 = parcelRequire("YdQc0");

var $fSZns = parcelRequire("fSZns");

var $lWVsJ = parcelRequire("lWVsJ");

var $3dyGB = parcelRequire("3dyGB");

var $j257S = parcelRequire("j257S");

var $1kMKg = parcelRequire("1kMKg");

var $6mwJ2 = parcelRequire("6mwJ2");
var $0ae5256c4a1477f2$require$Graph = $6mwJ2.Graph;
module.exports = $0ae5256c4a1477f2$var$layout;
function $0ae5256c4a1477f2$var$layout(g, opts) {
    var time = opts && opts.debugTiming ? $1kMKg.time : $1kMKg.notime;
    time("layout", function() {
        var layoutGraph = time("  buildLayoutGraph", function() {
            return $0ae5256c4a1477f2$var$buildLayoutGraph(g);
        });
        time("  runLayout", function() {
            $0ae5256c4a1477f2$var$runLayout(layoutGraph, time);
        });
        time("  updateInputGraph", function() {
            $0ae5256c4a1477f2$var$updateInputGraph(g, layoutGraph);
        });
    });
}
function $0ae5256c4a1477f2$var$runLayout(g, time) {
    time("    makeSpaceForEdgeLabels", function() {
        $0ae5256c4a1477f2$var$makeSpaceForEdgeLabels(g);
    });
    time("    removeSelfEdges", function() {
        $0ae5256c4a1477f2$var$removeSelfEdges(g);
    });
    time("    acyclic", function() {
        $61rsw.run(g);
    });
    time("    nestingGraph.run", function() {
        $YdQc0.run(g);
    });
    time("    rank", function() {
        $hv32p($1kMKg.asNonCompoundGraph(g));
    });
    time("    injectEdgeLabelProxies", function() {
        $0ae5256c4a1477f2$var$injectEdgeLabelProxies(g);
    });
    time("    removeEmptyRanks", function() {
        $0ae5256c4a1477f2$require$removeEmptyRanks(g);
    });
    time("    nestingGraph.cleanup", function() {
        $YdQc0.cleanup(g);
    });
    time("    normalizeRanks", function() {
        $0ae5256c4a1477f2$require$normalizeRanks(g);
    });
    time("    assignRankMinMax", function() {
        $0ae5256c4a1477f2$var$assignRankMinMax(g);
    });
    time("    removeEdgeLabelProxies", function() {
        $0ae5256c4a1477f2$var$removeEdgeLabelProxies(g);
    });
    time("    normalize.run", function() {
        $fi6eg.run(g);
    });
    time("    parentDummyChains", function() {
        $eBG2O(g);
    });
    time("    addBorderSegments", function() {
        $fSZns(g);
    });
    time("    order", function() {
        $3dyGB(g);
    });
    time("    insertSelfEdges", function() {
        $0ae5256c4a1477f2$var$insertSelfEdges(g);
    });
    time("    adjustCoordinateSystem", function() {
        $lWVsJ.adjust(g);
    });
    time("    position", function() {
        $j257S(g);
    });
    time("    positionSelfEdges", function() {
        $0ae5256c4a1477f2$var$positionSelfEdges(g);
    });
    time("    removeBorderNodes", function() {
        $0ae5256c4a1477f2$var$removeBorderNodes(g);
    });
    time("    normalize.undo", function() {
        $fi6eg.undo(g);
    });
    time("    fixupEdgeLabelCoords", function() {
        $0ae5256c4a1477f2$var$fixupEdgeLabelCoords(g);
    });
    time("    undoCoordinateSystem", function() {
        $lWVsJ.undo(g);
    });
    time("    translateGraph", function() {
        $0ae5256c4a1477f2$var$translateGraph(g);
    });
    time("    assignNodeIntersects", function() {
        $0ae5256c4a1477f2$var$assignNodeIntersects(g);
    });
    time("    reversePoints", function() {
        $0ae5256c4a1477f2$var$reversePointsForReversedEdges(g);
    });
    time("    acyclic.undo", function() {
        $61rsw.undo(g);
    });
}
/*
 * Copies final layout information from the layout graph back to the input
 * graph. This process only copies whitelisted attributes from the layout graph
 * to the input graph, so it serves as a good place to determine what
 * attributes can influence layout.
 */ function $0ae5256c4a1477f2$var$updateInputGraph(inputGraph, layoutGraph) {
    $bqfL5.forEach(inputGraph.nodes(), function(v) {
        var inputLabel = inputGraph.node(v);
        var layoutLabel = layoutGraph.node(v);
        if (inputLabel) {
            inputLabel.x = layoutLabel.x;
            inputLabel.y = layoutLabel.y;
            if (layoutGraph.children(v).length) {
                inputLabel.width = layoutLabel.width;
                inputLabel.height = layoutLabel.height;
            }
        }
    });
    $bqfL5.forEach(inputGraph.edges(), function(e) {
        var inputLabel = inputGraph.edge(e);
        var layoutLabel = layoutGraph.edge(e);
        inputLabel.points = layoutLabel.points;
        if ($bqfL5.has(layoutLabel, "x")) {
            inputLabel.x = layoutLabel.x;
            inputLabel.y = layoutLabel.y;
        }
    });
    inputGraph.graph().width = layoutGraph.graph().width;
    inputGraph.graph().height = layoutGraph.graph().height;
}
var $0ae5256c4a1477f2$var$graphNumAttrs = [
    "nodesep",
    "edgesep",
    "ranksep",
    "marginx",
    "marginy"
];
var $0ae5256c4a1477f2$var$graphDefaults = {
    ranksep: 50,
    edgesep: 20,
    nodesep: 50,
    rankdir: "tb"
};
var $0ae5256c4a1477f2$var$graphAttrs = [
    "acyclicer",
    "ranker",
    "rankdir",
    "align"
];
var $0ae5256c4a1477f2$var$nodeNumAttrs = [
    "width",
    "height"
];
var $0ae5256c4a1477f2$var$nodeDefaults = {
    width: 0,
    height: 0
};
var $0ae5256c4a1477f2$var$edgeNumAttrs = [
    "minlen",
    "weight",
    "width",
    "height",
    "labeloffset"
];
var $0ae5256c4a1477f2$var$edgeDefaults = {
    minlen: 1,
    weight: 1,
    width: 0,
    height: 0,
    labeloffset: 10,
    labelpos: "r"
};
var $0ae5256c4a1477f2$var$edgeAttrs = [
    "labelpos"
];
/*
 * Constructs a new graph from the input graph, which can be used for layout.
 * This process copies only whitelisted attributes from the input graph to the
 * layout graph. Thus this function serves as a good place to determine what
 * attributes can influence layout.
 */ function $0ae5256c4a1477f2$var$buildLayoutGraph(inputGraph) {
    var g = new $0ae5256c4a1477f2$require$Graph({
        multigraph: true,
        compound: true
    });
    var graph = $0ae5256c4a1477f2$var$canonicalize(inputGraph.graph());
    g.setGraph($bqfL5.merge({}, $0ae5256c4a1477f2$var$graphDefaults, $0ae5256c4a1477f2$var$selectNumberAttrs(graph, $0ae5256c4a1477f2$var$graphNumAttrs), $bqfL5.pick(graph, $0ae5256c4a1477f2$var$graphAttrs)));
    $bqfL5.forEach(inputGraph.nodes(), function(v) {
        var node = $0ae5256c4a1477f2$var$canonicalize(inputGraph.node(v));
        g.setNode(v, $bqfL5.defaults($0ae5256c4a1477f2$var$selectNumberAttrs(node, $0ae5256c4a1477f2$var$nodeNumAttrs), $0ae5256c4a1477f2$var$nodeDefaults));
        g.setParent(v, inputGraph.parent(v));
    });
    $bqfL5.forEach(inputGraph.edges(), function(e) {
        var edge = $0ae5256c4a1477f2$var$canonicalize(inputGraph.edge(e));
        g.setEdge(e, $bqfL5.merge({}, $0ae5256c4a1477f2$var$edgeDefaults, $0ae5256c4a1477f2$var$selectNumberAttrs(edge, $0ae5256c4a1477f2$var$edgeNumAttrs), $bqfL5.pick(edge, $0ae5256c4a1477f2$var$edgeAttrs)));
    });
    return g;
}
/*
 * This idea comes from the Gansner paper: to account for edge labels in our
 * layout we split each rank in half by doubling minlen and halving ranksep.
 * Then we can place labels at these mid-points between nodes.
 *
 * We also add some minimal padding to the width to push the label for the edge
 * away from the edge itself a bit.
 */ function $0ae5256c4a1477f2$var$makeSpaceForEdgeLabels(g) {
    var graph = g.graph();
    graph.ranksep /= 2;
    $bqfL5.forEach(g.edges(), function(e) {
        var edge = g.edge(e);
        edge.minlen *= 2;
        if (edge.labelpos.toLowerCase() !== "c") {
            if (graph.rankdir === "TB" || graph.rankdir === "BT") edge.width += edge.labeloffset;
            else edge.height += edge.labeloffset;
        }
    });
}
/*
 * Creates temporary dummy nodes that capture the rank in which each edge's
 * label is going to, if it has one of non-zero width and height. We do this
 * so that we can safely remove empty ranks while preserving balance for the
 * label's position.
 */ function $0ae5256c4a1477f2$var$injectEdgeLabelProxies(g) {
    $bqfL5.forEach(g.edges(), function(e) {
        var edge = g.edge(e);
        if (edge.width && edge.height) {
            var v = g.node(e.v);
            var w = g.node(e.w);
            var label = {
                rank: (w.rank - v.rank) / 2 + v.rank,
                e: e
            };
            $1kMKg.addDummyNode(g, "edge-proxy", label, "_ep");
        }
    });
}
function $0ae5256c4a1477f2$var$assignRankMinMax(g) {
    var maxRank = 0;
    $bqfL5.forEach(g.nodes(), function(v) {
        var node = g.node(v);
        if (node.borderTop) {
            node.minRank = g.node(node.borderTop).rank;
            node.maxRank = g.node(node.borderBottom).rank;
            maxRank = $bqfL5.max(maxRank, node.maxRank);
        }
    });
    g.graph().maxRank = maxRank;
}
function $0ae5256c4a1477f2$var$removeEdgeLabelProxies(g) {
    $bqfL5.forEach(g.nodes(), function(v) {
        var node = g.node(v);
        if (node.dummy === "edge-proxy") {
            g.edge(node.e).labelRank = node.rank;
            g.removeNode(v);
        }
    });
}
function $0ae5256c4a1477f2$var$translateGraph(g) {
    var minX = Number.POSITIVE_INFINITY;
    var maxX = 0;
    var minY = Number.POSITIVE_INFINITY;
    var maxY = 0;
    var graphLabel = g.graph();
    var marginX = graphLabel.marginx || 0;
    var marginY = graphLabel.marginy || 0;
    function getExtremes(attrs) {
        var x = attrs.x;
        var y = attrs.y;
        var w = attrs.width;
        var h = attrs.height;
        minX = Math.min(minX, x - w / 2);
        maxX = Math.max(maxX, x + w / 2);
        minY = Math.min(minY, y - h / 2);
        maxY = Math.max(maxY, y + h / 2);
    }
    $bqfL5.forEach(g.nodes(), function(v) {
        getExtremes(g.node(v));
    });
    $bqfL5.forEach(g.edges(), function(e) {
        var edge = g.edge(e);
        if ($bqfL5.has(edge, "x")) getExtremes(edge);
    });
    minX -= marginX;
    minY -= marginY;
    $bqfL5.forEach(g.nodes(), function(v) {
        var node = g.node(v);
        node.x -= minX;
        node.y -= minY;
    });
    $bqfL5.forEach(g.edges(), function(e) {
        var edge = g.edge(e);
        $bqfL5.forEach(edge.points, function(p) {
            p.x -= minX;
            p.y -= minY;
        });
        if ($bqfL5.has(edge, "x")) edge.x -= minX;
        if ($bqfL5.has(edge, "y")) edge.y -= minY;
    });
    graphLabel.width = maxX - minX + marginX;
    graphLabel.height = maxY - minY + marginY;
}
function $0ae5256c4a1477f2$var$assignNodeIntersects(g) {
    $bqfL5.forEach(g.edges(), function(e) {
        var edge = g.edge(e);
        var nodeV = g.node(e.v);
        var nodeW = g.node(e.w);
        var p1, p2;
        if (!edge.points) {
            edge.points = [];
            p1 = nodeW;
            p2 = nodeV;
        } else {
            p1 = edge.points[0];
            p2 = edge.points[edge.points.length - 1];
        }
        edge.points.unshift($1kMKg.intersectRect(nodeV, p1));
        edge.points.push($1kMKg.intersectRect(nodeW, p2));
    });
}
function $0ae5256c4a1477f2$var$fixupEdgeLabelCoords(g) {
    $bqfL5.forEach(g.edges(), function(e) {
        var edge = g.edge(e);
        if ($bqfL5.has(edge, "x")) {
            if (edge.labelpos === "l" || edge.labelpos === "r") edge.width -= edge.labeloffset;
            switch(edge.labelpos){
                case "l":
                    edge.x -= edge.width / 2 + edge.labeloffset;
                    break;
                case "r":
                    edge.x += edge.width / 2 + edge.labeloffset;
                    break;
            }
        }
    });
}
function $0ae5256c4a1477f2$var$reversePointsForReversedEdges(g) {
    $bqfL5.forEach(g.edges(), function(e) {
        var edge = g.edge(e);
        if (edge.reversed) edge.points.reverse();
    });
}
function $0ae5256c4a1477f2$var$removeBorderNodes(g) {
    $bqfL5.forEach(g.nodes(), function(v) {
        if (g.children(v).length) {
            var node = g.node(v);
            var t = g.node(node.borderTop);
            var b = g.node(node.borderBottom);
            var l = g.node($bqfL5.last(node.borderLeft));
            var r = g.node($bqfL5.last(node.borderRight));
            node.width = Math.abs(r.x - l.x);
            node.height = Math.abs(b.y - t.y);
            node.x = l.x + node.width / 2;
            node.y = t.y + node.height / 2;
        }
    });
    $bqfL5.forEach(g.nodes(), function(v) {
        if (g.node(v).dummy === "border") g.removeNode(v);
    });
}
function $0ae5256c4a1477f2$var$removeSelfEdges(g) {
    $bqfL5.forEach(g.edges(), function(e) {
        if (e.v === e.w) {
            var node = g.node(e.v);
            if (!node.selfEdges) node.selfEdges = [];
            node.selfEdges.push({
                e: e,
                label: g.edge(e)
            });
            g.removeEdge(e);
        }
    });
}
function $0ae5256c4a1477f2$var$insertSelfEdges(g) {
    var layers = $1kMKg.buildLayerMatrix(g);
    $bqfL5.forEach(layers, function(layer) {
        var orderShift = 0;
        $bqfL5.forEach(layer, function(v, i) {
            var node = g.node(v);
            node.order = i + orderShift;
            $bqfL5.forEach(node.selfEdges, function(selfEdge) {
                $1kMKg.addDummyNode(g, "selfedge", {
                    width: selfEdge.label.width,
                    height: selfEdge.label.height,
                    rank: node.rank,
                    order: i + ++orderShift,
                    e: selfEdge.e,
                    label: selfEdge.label
                }, "_se");
            });
            delete node.selfEdges;
        });
    });
}
function $0ae5256c4a1477f2$var$positionSelfEdges(g) {
    $bqfL5.forEach(g.nodes(), function(v) {
        var node = g.node(v);
        if (node.dummy === "selfedge") {
            var selfNode = g.node(node.e.v);
            var x = selfNode.x + selfNode.width / 2;
            var y = selfNode.y;
            var dx = node.x - x;
            var dy = selfNode.height / 2;
            g.setEdge(node.e, node.label);
            g.removeNode(v);
            node.label.points = [
                {
                    x: x + 2 * dx / 3,
                    y: y - dy
                },
                {
                    x: x + 5 * dx / 6,
                    y: y - dy
                },
                {
                    x: x + dx,
                    y: y
                },
                {
                    x: x + 5 * dx / 6,
                    y: y + dy
                },
                {
                    x: x + 2 * dx / 3,
                    y: y + dy
                }
            ];
            node.label.x = node.x;
            node.label.y = node.y;
        }
    });
}
function $0ae5256c4a1477f2$var$selectNumberAttrs(obj, attrs) {
    return $bqfL5.mapValues($bqfL5.pick(obj, attrs), Number);
}
function $0ae5256c4a1477f2$var$canonicalize(attrs) {
    var newAttrs = {};
    $bqfL5.forEach(attrs, function(v, k) {
        newAttrs[k.toLowerCase()] = v;
    });
    return newAttrs;
}

});
parcelRegister("bqfL5", function(module, exports) {
/* global window */ var $850e58b67514fb74$var$lodash;


























try {
    $850e58b67514fb74$var$lodash = {
        cloneDeep: (parcelRequire("iGQLm")),
        constant: (parcelRequire("9HRmE")),
        defaults: (parcelRequire("1SWLj")),
        each: (parcelRequire("5kE3T")),
        filter: (parcelRequire("jLJR7")),
        find: (parcelRequire("8I8e5")),
        flatten: (parcelRequire("20Rgr")),
        forEach: (parcelRequire("iWSff")),
        forIn: (parcelRequire("jojmF")),
        has: (parcelRequire("jplJt")),
        isUndefined: (parcelRequire("enrJD")),
        last: (parcelRequire("hkfXi")),
        map: (parcelRequire("437iZ")),
        mapValues: (parcelRequire("1Z7cU")),
        max: (parcelRequire("aK6kk")),
        merge: (parcelRequire("5W3lT")),
        min: (parcelRequire("3Ne9k")),
        minBy: (parcelRequire("5oTLF")),
        now: (parcelRequire("9nn6T")),
        pick: (parcelRequire("12eN8")),
        range: (parcelRequire("fpRwA")),
        reduce: (parcelRequire("2KuAh")),
        sortBy: (parcelRequire("47O2q")),
        uniqueId: (parcelRequire("g0ikZ")),
        values: (parcelRequire("7D6Gq")),
        zipObject: (parcelRequire("d0lTW"))
    };
} catch (e) {
// continue regardless of error
}
if (!$850e58b67514fb74$var$lodash) $850e58b67514fb74$var$lodash = window._;
module.exports = $850e58b67514fb74$var$lodash;

});
parcelRegister("iGQLm", function(module, exports) {

var $kqX4j = parcelRequire("kqX4j");
/** Used to compose bitmasks for cloning. */ var $d9b513d63d79678d$var$CLONE_DEEP_FLAG = 1, $d9b513d63d79678d$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */ function $d9b513d63d79678d$var$cloneDeep(value) {
    return $kqX4j(value, $d9b513d63d79678d$var$CLONE_DEEP_FLAG | $d9b513d63d79678d$var$CLONE_SYMBOLS_FLAG);
}
module.exports = $d9b513d63d79678d$var$cloneDeep;

});

parcelRegister("1SWLj", function(module, exports) {

var $5iyRF = parcelRequire("5iyRF");

var $6TC8i = parcelRequire("6TC8i");

var $b8mN0 = parcelRequire("b8mN0");

var $f4lqP = parcelRequire("f4lqP");
/** Used for built-in method references. */ var $15f86a7fdfb0f225$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $15f86a7fdfb0f225$var$hasOwnProperty = $15f86a7fdfb0f225$var$objectProto.hasOwnProperty;
/**
 * Assigns own and inherited enumerable string keyed properties of source
 * objects to the destination object for all destination properties that
 * resolve to `undefined`. Source objects are applied from left to right.
 * Once a property is set, additional values of the same property are ignored.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.defaultsDeep
 * @example
 *
 * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
 * // => { 'a': 1, 'b': 2 }
 */ var $15f86a7fdfb0f225$var$defaults = $5iyRF(function(object, sources) {
    object = Object(object);
    var index = -1;
    var length = sources.length;
    var guard = length > 2 ? sources[2] : undefined;
    if (guard && $b8mN0(sources[0], sources[1], guard)) length = 1;
    while(++index < length){
        var source = sources[index];
        var props = $f4lqP(source);
        var propsIndex = -1;
        var propsLength = props.length;
        while(++propsIndex < propsLength){
            var key = props[propsIndex];
            var value = object[key];
            if (value === undefined || $6TC8i(value, $15f86a7fdfb0f225$var$objectProto[key]) && !$15f86a7fdfb0f225$var$hasOwnProperty.call(object, key)) object[key] = source[key];
        }
    }
    return object;
});
module.exports = $15f86a7fdfb0f225$var$defaults;

});
parcelRegister("b8mN0", function(module, exports) {

var $6TC8i = parcelRequire("6TC8i");

var $eMthh = parcelRequire("eMthh");

var $iyUuu = parcelRequire("iyUuu");

var $lsJ54 = parcelRequire("lsJ54");
/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */ function $81b21e8b41d211e8$var$isIterateeCall(value, index, object) {
    if (!$lsJ54(object)) return false;
    var type = typeof index;
    if (type == 'number' ? $eMthh(object) && $iyUuu(index, object.length) : type == 'string' && index in object) return $6TC8i(object[index], value);
    return false;
}
module.exports = $81b21e8b41d211e8$var$isIterateeCall;

});


parcelRegister("8I8e5", function(module, exports) {

var $ePhxS = parcelRequire("ePhxS");

var $cpmrH = parcelRequire("cpmrH");
/**
 * Iterates over elements of `collection`, returning the first element
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36, 'active': true },
 *   { 'user': 'fred',    'age': 40, 'active': false },
 *   { 'user': 'pebbles', 'age': 1,  'active': true }
 * ];
 *
 * _.find(users, function(o) { return o.age < 40; });
 * // => object for 'barney'
 *
 * // The `_.matches` iteratee shorthand.
 * _.find(users, { 'age': 1, 'active': true });
 * // => object for 'pebbles'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.find(users, ['active', false]);
 * // => object for 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.find(users, 'active');
 * // => object for 'barney'
 */ var $6578d05764c8afc8$var$find = $ePhxS($cpmrH);
module.exports = $6578d05764c8afc8$var$find;

});
parcelRegister("ePhxS", function(module, exports) {

var $7MWok = parcelRequire("7MWok");

var $eMthh = parcelRequire("eMthh");

var $LAMcS = parcelRequire("LAMcS");
/**
 * Creates a `_.find` or `_.findLast` function.
 *
 * @private
 * @param {Function} findIndexFunc The function to find the collection index.
 * @returns {Function} Returns the new find function.
 */ function $acb3703f94fb96ce$var$createFind(findIndexFunc) {
    return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!$eMthh(collection)) {
            var iteratee = $7MWok(predicate, 3);
            collection = $LAMcS(collection);
            predicate = function(key) {
                return iteratee(iterable[key], key, iterable);
            };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
    };
}
module.exports = $acb3703f94fb96ce$var$createFind;

});

parcelRegister("cpmrH", function(module, exports) {

var $eAor6 = parcelRequire("eAor6");

var $7MWok = parcelRequire("7MWok");

var $2MGGR = parcelRequire("2MGGR");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $90893b1abc59631b$var$nativeMax = Math.max;
/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */ function $90893b1abc59631b$var$findIndex(array, predicate, fromIndex) {
    var length = array == null ? 0 : array.length;
    if (!length) return -1;
    var index = fromIndex == null ? 0 : $2MGGR(fromIndex);
    if (index < 0) index = $90893b1abc59631b$var$nativeMax(length + index, 0);
    return $eAor6(array, $7MWok(predicate, 3), index);
}
module.exports = $90893b1abc59631b$var$findIndex;

});
parcelRegister("2MGGR", function(module, exports) {

var $9lLgO = parcelRequire("9lLgO");
/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */ function $20712de2064d78dd$var$toInteger(value) {
    var result = $9lLgO(value), remainder = result % 1;
    return result === result ? remainder ? result - remainder : result : 0;
}
module.exports = $20712de2064d78dd$var$toInteger;

});
parcelRegister("9lLgO", function(module, exports) {

var $iV4PZ = parcelRequire("iV4PZ");
/** Used as references for various `Number` constants. */ var $6ceabe126a95a54e$var$INFINITY = 1 / 0, $6ceabe126a95a54e$var$MAX_INTEGER = 1.7976931348623157e+308;
/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */ function $6ceabe126a95a54e$var$toFinite(value) {
    if (!value) return value === 0 ? value : 0;
    value = $iV4PZ(value);
    if (value === $6ceabe126a95a54e$var$INFINITY || value === -$6ceabe126a95a54e$var$INFINITY) {
        var sign = value < 0 ? -1 : 1;
        return sign * $6ceabe126a95a54e$var$MAX_INTEGER;
    }
    return value === value ? value : 0;
}
module.exports = $6ceabe126a95a54e$var$toFinite;

});
parcelRegister("iV4PZ", function(module, exports) {

var $s0iWz = parcelRequire("s0iWz");

var $lsJ54 = parcelRequire("lsJ54");

var $9dr3u = parcelRequire("9dr3u");
/** Used as references for various `Number` constants. */ var $dc614d828223dea6$var$NAN = 0 / 0;
/** Used to detect bad signed hexadecimal string values. */ var $dc614d828223dea6$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $dc614d828223dea6$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $dc614d828223dea6$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $dc614d828223dea6$var$freeParseInt = parseInt;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $dc614d828223dea6$var$toNumber(value) {
    if (typeof value == 'number') return value;
    if ($9dr3u(value)) return $dc614d828223dea6$var$NAN;
    if ($lsJ54(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = $lsJ54(other) ? other + '' : other;
    }
    if (typeof value != 'string') return value === 0 ? value : +value;
    value = $s0iWz(value);
    var isBinary = $dc614d828223dea6$var$reIsBinary.test(value);
    return isBinary || $dc614d828223dea6$var$reIsOctal.test(value) ? $dc614d828223dea6$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $dc614d828223dea6$var$reIsBadHex.test(value) ? $dc614d828223dea6$var$NAN : +value;
}
module.exports = $dc614d828223dea6$var$toNumber;

});
parcelRegister("s0iWz", function(module, exports) {

var $kzo8D = parcelRequire("kzo8D");
/** Used to match leading whitespace. */ var $0542da1d887b1c4d$var$reTrimStart = /^\s+/;
/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */ function $0542da1d887b1c4d$var$baseTrim(string) {
    return string ? string.slice(0, $kzo8D(string) + 1).replace($0542da1d887b1c4d$var$reTrimStart, '') : string;
}
module.exports = $0542da1d887b1c4d$var$baseTrim;

});
parcelRegister("kzo8D", function(module, exports) {
/** Used to match a single whitespace character. */ var $ef99cce288c7323e$var$reWhitespace = /\s/;
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */ function $ef99cce288c7323e$var$trimmedEndIndex(string) {
    var index = string.length;
    while(index-- && $ef99cce288c7323e$var$reWhitespace.test(string.charAt(index)));
    return index;
}
module.exports = $ef99cce288c7323e$var$trimmedEndIndex;

});







parcelRegister("20Rgr", function(module, exports) {

var $fgBHx = parcelRequire("fgBHx");
/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */ function $1774e6065e7ade58$var$flatten(array) {
    var length = array == null ? 0 : array.length;
    return length ? $fgBHx(array, 1) : [];
}
module.exports = $1774e6065e7ade58$var$flatten;

});

parcelRegister("jojmF", function(module, exports) {

var $dEvx9 = parcelRequire("dEvx9");

var $4c8Zb = parcelRequire("4c8Zb");

var $f4lqP = parcelRequire("f4lqP");
/**
 * Iterates over own and inherited enumerable string keyed properties of an
 * object and invokes `iteratee` for each property. The iteratee is invoked
 * with three arguments: (value, key, object). Iteratee functions may exit
 * iteration early by explicitly returning `false`.
 *
 * @static
 * @memberOf _
 * @since 0.3.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns `object`.
 * @see _.forInRight
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.forIn(new Foo, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
 */ function $e1df479b00a6084f$var$forIn(object, iteratee) {
    return object == null ? object : $dEvx9(object, $4c8Zb(iteratee), $f4lqP);
}
module.exports = $e1df479b00a6084f$var$forIn;

});

parcelRegister("hkfXi", function(module, exports) {
/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */ function $c9d0ae50fd1d1372$var$last(array) {
    var length = array == null ? 0 : array.length;
    return length ? array[length - 1] : undefined;
}
module.exports = $c9d0ae50fd1d1372$var$last;

});

parcelRegister("1Z7cU", function(module, exports) {

var $cWbJD = parcelRequire("cWbJD");

var $4xK4A = parcelRequire("4xK4A");

var $7MWok = parcelRequire("7MWok");
/**
 * Creates an object with the same keys as `object` and values generated
 * by running each own enumerable string keyed property of `object` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapKeys
 * @example
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * _.mapValues(users, function(o) { return o.age; });
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 *
 * // The `_.property` iteratee shorthand.
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */ function $17211428bc2045c4$var$mapValues(object, iteratee) {
    var result = {};
    iteratee = $7MWok(iteratee, 3);
    $4xK4A(object, function(value, key, object) {
        $cWbJD(result, key, iteratee(value, key, object));
    });
    return result;
}
module.exports = $17211428bc2045c4$var$mapValues;

});

parcelRegister("aK6kk", function(module, exports) {

var $gv3JG = parcelRequire("gv3JG");

var $iK245 = parcelRequire("iK245");

var $4Nq5y = parcelRequire("4Nq5y");
/**
 * Computes the maximum value of `array`. If `array` is empty or falsey,
 * `undefined` is returned.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Math
 * @param {Array} array The array to iterate over.
 * @returns {*} Returns the maximum value.
 * @example
 *
 * _.max([4, 2, 8, 6]);
 * // => 8
 *
 * _.max([]);
 * // => undefined
 */ function $7d231ba5a67a42db$var$max(array) {
    return array && array.length ? $gv3JG(array, $4Nq5y, $iK245) : undefined;
}
module.exports = $7d231ba5a67a42db$var$max;

});
parcelRegister("gv3JG", function(module, exports) {

var $9dr3u = parcelRequire("9dr3u");
/**
 * The base implementation of methods like `_.max` and `_.min` which accepts a
 * `comparator` to determine the extremum value.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} iteratee The iteratee invoked per iteration.
 * @param {Function} comparator The comparator used to compare values.
 * @returns {*} Returns the extremum value.
 */ function $c032706da200ef36$var$baseExtremum(array, iteratee, comparator) {
    var index = -1, length = array.length;
    while(++index < length){
        var value = array[index], current = iteratee(value);
        if (current != null && (computed === undefined ? current === current && !$9dr3u(current) : comparator(current, computed))) var computed = current, result = value;
    }
    return result;
}
module.exports = $c032706da200ef36$var$baseExtremum;

});

parcelRegister("iK245", function(module, exports) {
/**
 * The base implementation of `_.gt` which doesn't coerce arguments.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is greater than `other`,
 *  else `false`.
 */ function $da4e1fe5f8bd1939$var$baseGt(value, other) {
    return value > other;
}
module.exports = $da4e1fe5f8bd1939$var$baseGt;

});


parcelRegister("5W3lT", function(module, exports) {

var $4uZ7x = parcelRequire("4uZ7x");

var $i1jm6 = parcelRequire("i1jm6");
/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */ var $4524f833ae45779b$var$merge = $i1jm6(function(object, source, srcIndex) {
    $4uZ7x(object, source, srcIndex);
});
module.exports = $4524f833ae45779b$var$merge;

});
parcelRegister("4uZ7x", function(module, exports) {

var $g779E = parcelRequire("g779E");

var $7RXmv = parcelRequire("7RXmv");

var $dEvx9 = parcelRequire("dEvx9");

var $cTZHA = parcelRequire("cTZHA");

var $lsJ54 = parcelRequire("lsJ54");

var $f4lqP = parcelRequire("f4lqP");

var $1ys2O = parcelRequire("1ys2O");
/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function $34696005ed9b3f30$var$baseMerge(object, source, srcIndex, customizer, stack) {
    if (object === source) return;
    $dEvx9(source, function(srcValue, key) {
        stack || (stack = new $g779E);
        if ($lsJ54(srcValue)) $cTZHA(object, source, key, srcIndex, $34696005ed9b3f30$var$baseMerge, customizer, stack);
        else {
            var newValue = customizer ? customizer($1ys2O(object, key), srcValue, key + '', object, source, stack) : undefined;
            if (newValue === undefined) newValue = srcValue;
            $7RXmv(object, key, newValue);
        }
    }, $f4lqP);
}
module.exports = $34696005ed9b3f30$var$baseMerge;

});
parcelRegister("7RXmv", function(module, exports) {

var $cWbJD = parcelRequire("cWbJD");

var $6TC8i = parcelRequire("6TC8i");
/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $5bab87b519c266a0$var$assignMergeValue(object, key, value) {
    if (value !== undefined && !$6TC8i(object[key], value) || value === undefined && !(key in object)) $cWbJD(object, key, value);
}
module.exports = $5bab87b519c266a0$var$assignMergeValue;

});

parcelRegister("cTZHA", function(module, exports) {

var $7RXmv = parcelRequire("7RXmv");

var $uQ1Em = parcelRequire("uQ1Em");

var $5JAGM = parcelRequire("5JAGM");

var $aA0pv = parcelRequire("aA0pv");

var $dFJsF = parcelRequire("dFJsF");

var $aJD6g = parcelRequire("aJD6g");

var $o8HxT = parcelRequire("o8HxT");

var $jGP9B = parcelRequire("jGP9B");

var $f504n = parcelRequire("f504n");

var $01ubZ = parcelRequire("01ubZ");

var $lsJ54 = parcelRequire("lsJ54");

var $xMy82 = parcelRequire("xMy82");

var $1Q21n = parcelRequire("1Q21n");

var $1ys2O = parcelRequire("1ys2O");

var $kp2OI = parcelRequire("kp2OI");
/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function $964a7bd734d0fbad$var$baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
    var objValue = $1ys2O(object, key), srcValue = $1ys2O(source, key), stacked = stack.get(srcValue);
    if (stacked) {
        $7RXmv(object, key, stacked);
        return;
    }
    var newValue = customizer ? customizer(objValue, srcValue, key + '', object, source, stack) : undefined;
    var isCommon = newValue === undefined;
    if (isCommon) {
        var isArr = $o8HxT(srcValue), isBuff = !isArr && $f504n(srcValue), isTyped = !isArr && !isBuff && $1Q21n(srcValue);
        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
            if ($o8HxT(objValue)) newValue = objValue;
            else if ($jGP9B(objValue)) newValue = $aA0pv(objValue);
            else if (isBuff) {
                isCommon = false;
                newValue = $uQ1Em(srcValue, true);
            } else if (isTyped) {
                isCommon = false;
                newValue = $5JAGM(srcValue, true);
            } else newValue = [];
        } else if ($xMy82(srcValue) || $aJD6g(srcValue)) {
            newValue = objValue;
            if ($aJD6g(objValue)) newValue = $kp2OI(objValue);
            else if (!$lsJ54(objValue) || $01ubZ(objValue)) newValue = $dFJsF(srcValue);
        } else isCommon = false;
    }
    if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
    }
    $7RXmv(object, key, newValue);
}
module.exports = $964a7bd734d0fbad$var$baseMergeDeep;

});
parcelRegister("xMy82", function(module, exports) {

var $eq6CV = parcelRequire("eq6CV");

var $cdnOB = parcelRequire("cdnOB");

var $8l89S = parcelRequire("8l89S");
/** `Object#toString` result references. */ var $0658be17f7793a43$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $0658be17f7793a43$var$funcProto = Function.prototype, $0658be17f7793a43$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $0658be17f7793a43$var$funcToString = $0658be17f7793a43$var$funcProto.toString;
/** Used to check objects for own properties. */ var $0658be17f7793a43$var$hasOwnProperty = $0658be17f7793a43$var$objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var $0658be17f7793a43$var$objectCtorString = $0658be17f7793a43$var$funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function $0658be17f7793a43$var$isPlainObject(value) {
    if (!$8l89S(value) || $eq6CV(value) != $0658be17f7793a43$var$objectTag) return false;
    var proto = $cdnOB(value);
    if (proto === null) return true;
    var Ctor = $0658be17f7793a43$var$hasOwnProperty.call(proto, 'constructor') && proto.constructor;
    return typeof Ctor == 'function' && Ctor instanceof Ctor && $0658be17f7793a43$var$funcToString.call(Ctor) == $0658be17f7793a43$var$objectCtorString;
}
module.exports = $0658be17f7793a43$var$isPlainObject;

});

parcelRegister("1ys2O", function(module, exports) {
/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $121eb86ef7ce6b9c$var$safeGet(object, key) {
    if (key === 'constructor' && typeof object[key] === 'function') return;
    if (key == '__proto__') return;
    return object[key];
}
module.exports = $121eb86ef7ce6b9c$var$safeGet;

});

parcelRegister("kp2OI", function(module, exports) {

var $cYlGN = parcelRequire("cYlGN");

var $f4lqP = parcelRequire("f4lqP");
/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */ function $eda853de6b056001$var$toPlainObject(value) {
    return $cYlGN(value, $f4lqP(value));
}
module.exports = $eda853de6b056001$var$toPlainObject;

});



parcelRegister("i1jm6", function(module, exports) {

var $5iyRF = parcelRequire("5iyRF");

var $b8mN0 = parcelRequire("b8mN0");
/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */ function $d1e75591f556b111$var$createAssigner(assigner) {
    return $5iyRF(function(object, sources) {
        var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
        customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;
        if (guard && $b8mN0(sources[0], sources[1], guard)) {
            customizer = length < 3 ? undefined : customizer;
            length = 1;
        }
        object = Object(object);
        while(++index < length){
            var source = sources[index];
            if (source) assigner(object, source, index, customizer);
        }
        return object;
    });
}
module.exports = $d1e75591f556b111$var$createAssigner;

});


parcelRegister("3Ne9k", function(module, exports) {

var $gv3JG = parcelRequire("gv3JG");

var $hGcz8 = parcelRequire("hGcz8");

var $4Nq5y = parcelRequire("4Nq5y");
/**
 * Computes the minimum value of `array`. If `array` is empty or falsey,
 * `undefined` is returned.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Math
 * @param {Array} array The array to iterate over.
 * @returns {*} Returns the minimum value.
 * @example
 *
 * _.min([4, 2, 8, 6]);
 * // => 2
 *
 * _.min([]);
 * // => undefined
 */ function $2c30ec7848ba160d$var$min(array) {
    return array && array.length ? $gv3JG(array, $4Nq5y, $hGcz8) : undefined;
}
module.exports = $2c30ec7848ba160d$var$min;

});
parcelRegister("hGcz8", function(module, exports) {
/**
 * The base implementation of `_.lt` which doesn't coerce arguments.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is less than `other`,
 *  else `false`.
 */ function $cdf01b2c29e1be9c$var$baseLt(value, other) {
    return value < other;
}
module.exports = $cdf01b2c29e1be9c$var$baseLt;

});


parcelRegister("5oTLF", function(module, exports) {

var $gv3JG = parcelRequire("gv3JG");

var $7MWok = parcelRequire("7MWok");

var $hGcz8 = parcelRequire("hGcz8");
/**
 * This method is like `_.min` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * the value is ranked. The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Math
 * @param {Array} array The array to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {*} Returns the minimum value.
 * @example
 *
 * var objects = [{ 'n': 1 }, { 'n': 2 }];
 *
 * _.minBy(objects, function(o) { return o.n; });
 * // => { 'n': 1 }
 *
 * // The `_.property` iteratee shorthand.
 * _.minBy(objects, 'n');
 * // => { 'n': 1 }
 */ function $3eea73fc544592fd$var$minBy(array, iteratee) {
    return array && array.length ? $gv3JG(array, $7MWok(iteratee, 2), $hGcz8) : undefined;
}
module.exports = $3eea73fc544592fd$var$minBy;

});

parcelRegister("9nn6T", function(module, exports) {

var $23YZo = parcelRequire("23YZo");
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $6d38303b9c8735ba$var$now = function() {
    return $23YZo.Date.now();
};
module.exports = $6d38303b9c8735ba$var$now;

});

parcelRegister("12eN8", function(module, exports) {

var $1AWBt = parcelRequire("1AWBt");

var $8KK0w = parcelRequire("8KK0w");
/**
 * Creates an object composed of the picked `object` properties.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to pick.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pick(object, ['a', 'c']);
 * // => { 'a': 1, 'c': 3 }
 */ var $0c11739df3ac35ad$var$pick = $8KK0w(function(object, paths) {
    return object == null ? {} : $1AWBt(object, paths);
});
module.exports = $0c11739df3ac35ad$var$pick;

});
parcelRegister("1AWBt", function(module, exports) {

var $6IXDN = parcelRequire("6IXDN");

var $2VBx6 = parcelRequire("2VBx6");
/**
 * The base implementation of `_.pick` without support for individual
 * property identifiers.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @returns {Object} Returns the new object.
 */ function $12969ca4851cc4ab$var$basePick(object, paths) {
    return $6IXDN(object, paths, function(value, path) {
        return $2VBx6(object, path);
    });
}
module.exports = $12969ca4851cc4ab$var$basePick;

});
parcelRegister("6IXDN", function(module, exports) {

var $lJEX1 = parcelRequire("lJEX1");

var $eJzCK = parcelRequire("eJzCK");

var $4RK0h = parcelRequire("4RK0h");
/**
 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @param {Function} predicate The function invoked per property.
 * @returns {Object} Returns the new object.
 */ function $4e551d8e73f04819$var$basePickBy(object, paths, predicate) {
    var index = -1, length = paths.length, result = {};
    while(++index < length){
        var path = paths[index], value = $lJEX1(object, path);
        if (predicate(value, path)) $eJzCK(result, $4RK0h(path, object), value);
    }
    return result;
}
module.exports = $4e551d8e73f04819$var$basePickBy;

});
parcelRegister("eJzCK", function(module, exports) {

var $5i71d = parcelRequire("5i71d");

var $4RK0h = parcelRequire("4RK0h");

var $iyUuu = parcelRequire("iyUuu");

var $lsJ54 = parcelRequire("lsJ54");

var $6DSvu = parcelRequire("6DSvu");
/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */ function $aba0e6d66e8d80dd$var$baseSet(object, path, value, customizer) {
    if (!$lsJ54(object)) return object;
    path = $4RK0h(path, object);
    var index = -1, length = path.length, lastIndex = length - 1, nested = object;
    while(nested != null && ++index < length){
        var key = $6DSvu(path[index]), newValue = value;
        if (key === '__proto__' || key === 'constructor' || key === 'prototype') return object;
        if (index != lastIndex) {
            var objValue = nested[key];
            newValue = customizer ? customizer(objValue, key, nested) : undefined;
            if (newValue === undefined) newValue = $lsJ54(objValue) ? objValue : $iyUuu(path[index + 1]) ? [] : {};
        }
        $5i71d(nested, key, newValue);
        nested = nested[key];
    }
    return object;
}
module.exports = $aba0e6d66e8d80dd$var$baseSet;

});



parcelRegister("8KK0w", function(module, exports) {

var $20Rgr = parcelRequire("20Rgr");

var $b86t6 = parcelRequire("b86t6");

var $iGMVy = parcelRequire("iGMVy");
/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */ function $65f64eb9f31faa0d$var$flatRest(func) {
    return $iGMVy($b86t6(func, undefined, $20Rgr), func + '');
}
module.exports = $65f64eb9f31faa0d$var$flatRest;

});


parcelRegister("fpRwA", function(module, exports) {

var $hDGMd = parcelRequire("hDGMd");
/**
 * Creates an array of numbers (positive and/or negative) progressing from
 * `start` up to, but not including, `end`. A step of `-1` is used if a negative
 * `start` is specified without an `end` or `step`. If `end` is not specified,
 * it's set to `start` with `start` then set to `0`.
 *
 * **Note:** JavaScript follows the IEEE-754 standard for resolving
 * floating-point values which can produce unexpected results.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {number} [start=0] The start of the range.
 * @param {number} end The end of the range.
 * @param {number} [step=1] The value to increment or decrement by.
 * @returns {Array} Returns the range of numbers.
 * @see _.inRange, _.rangeRight
 * @example
 *
 * _.range(4);
 * // => [0, 1, 2, 3]
 *
 * _.range(-4);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 5);
 * // => [1, 2, 3, 4]
 *
 * _.range(0, 20, 5);
 * // => [0, 5, 10, 15]
 *
 * _.range(0, -4, -1);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 4, 0);
 * // => [1, 1, 1]
 *
 * _.range(0);
 * // => []
 */ var $b392b5b21038a0ce$var$range = $hDGMd();
module.exports = $b392b5b21038a0ce$var$range;

});
parcelRegister("hDGMd", function(module, exports) {

var $ia9lU = parcelRequire("ia9lU");

var $b8mN0 = parcelRequire("b8mN0");

var $9lLgO = parcelRequire("9lLgO");
/**
 * Creates a `_.range` or `_.rangeRight` function.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new range function.
 */ function $cd7742b81dd96fb0$var$createRange(fromRight) {
    return function(start, end, step) {
        if (step && typeof step != 'number' && $b8mN0(start, end, step)) end = step = undefined;
        // Ensure the sign of `-0` is preserved.
        start = $9lLgO(start);
        if (end === undefined) {
            end = start;
            start = 0;
        } else end = $9lLgO(end);
        step = step === undefined ? start < end ? 1 : -1 : $9lLgO(step);
        return $ia9lU(start, end, step, fromRight);
    };
}
module.exports = $cd7742b81dd96fb0$var$createRange;

});
parcelRegister("ia9lU", function(module, exports) {
/* Built-in method references for those with the same name as other `lodash` methods. */ var $d3906a592348eb7a$var$nativeCeil = Math.ceil, $d3906a592348eb7a$var$nativeMax = Math.max;
/**
 * The base implementation of `_.range` and `_.rangeRight` which doesn't
 * coerce arguments.
 *
 * @private
 * @param {number} start The start of the range.
 * @param {number} end The end of the range.
 * @param {number} step The value to increment or decrement by.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Array} Returns the range of numbers.
 */ function $d3906a592348eb7a$var$baseRange(start, end, step, fromRight) {
    var index = -1, length = $d3906a592348eb7a$var$nativeMax($d3906a592348eb7a$var$nativeCeil((end - start) / (step || 1)), 0), result = Array(length);
    while(length--){
        result[fromRight ? length : ++index] = start;
        start += step;
    }
    return result;
}
module.exports = $d3906a592348eb7a$var$baseRange;

});



parcelRegister("47O2q", function(module, exports) {

var $fgBHx = parcelRequire("fgBHx");

var $jrtNg = parcelRequire("jrtNg");

var $5iyRF = parcelRequire("5iyRF");

var $b8mN0 = parcelRequire("b8mN0");
/**
 * Creates an array of elements, sorted in ascending order by the results of
 * running each element in a collection thru each iteratee. This method
 * performs a stable sort, that is, it preserves the original sort order of
 * equal elements. The iteratees are invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {...(Function|Function[])} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 36 },
 *   { 'user': 'fred',   'age': 30 },
 *   { 'user': 'barney', 'age': 34 }
 * ];
 *
 * _.sortBy(users, [function(o) { return o.user; }]);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
 *
 * _.sortBy(users, ['user', 'age']);
 * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
 */ var $300ea168693086c2$var$sortBy = $5iyRF(function(collection, iteratees) {
    if (collection == null) return [];
    var length = iteratees.length;
    if (length > 1 && $b8mN0(collection, iteratees[0], iteratees[1])) iteratees = [];
    else if (length > 2 && $b8mN0(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
        iteratees[0]
    ];
    return $jrtNg(collection, $fgBHx(iteratees, 1), []);
});
module.exports = $300ea168693086c2$var$sortBy;

});
parcelRegister("jrtNg", function(module, exports) {

var $i46jW = parcelRequire("i46jW");

var $lJEX1 = parcelRequire("lJEX1");

var $7MWok = parcelRequire("7MWok");

var $fDc61 = parcelRequire("fDc61");

var $9xZGY = parcelRequire("9xZGY");

var $91Qdd = parcelRequire("91Qdd");

var $fyGSR = parcelRequire("fyGSR");

var $4Nq5y = parcelRequire("4Nq5y");

var $o8HxT = parcelRequire("o8HxT");
/**
 * The base implementation of `_.orderBy` without param guards.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
 * @param {string[]} orders The sort orders of `iteratees`.
 * @returns {Array} Returns the new sorted array.
 */ function $e277a64de4eeade6$var$baseOrderBy(collection, iteratees, orders) {
    if (iteratees.length) iteratees = $i46jW(iteratees, function(iteratee) {
        if ($o8HxT(iteratee)) return function(value) {
            return $lJEX1(value, iteratee.length === 1 ? iteratee[0] : iteratee);
        };
        return iteratee;
    });
    else iteratees = [
        $4Nq5y
    ];
    var index = -1;
    iteratees = $i46jW(iteratees, $91Qdd($7MWok));
    var result = $fDc61(collection, function(value, key, collection) {
        var criteria = $i46jW(iteratees, function(iteratee) {
            return iteratee(value);
        });
        return {
            'criteria': criteria,
            'index': ++index,
            'value': value
        };
    });
    return $9xZGY(result, function(object, other) {
        return $fyGSR(object, other, orders);
    });
}
module.exports = $e277a64de4eeade6$var$baseOrderBy;

});
parcelRegister("9xZGY", function(module, exports) {
/**
 * The base implementation of `_.sortBy` which uses `comparer` to define the
 * sort order of `array` and replaces criteria objects with their corresponding
 * values.
 *
 * @private
 * @param {Array} array The array to sort.
 * @param {Function} comparer The function to define sort order.
 * @returns {Array} Returns `array`.
 */ function $6f370ce7a904568e$var$baseSortBy(array, comparer) {
    var length = array.length;
    array.sort(comparer);
    while(length--)array[length] = array[length].value;
    return array;
}
module.exports = $6f370ce7a904568e$var$baseSortBy;

});

parcelRegister("fyGSR", function(module, exports) {

var $1HU00 = parcelRequire("1HU00");
/**
 * Used by `_.orderBy` to compare multiple properties of a value to another
 * and stable sort them.
 *
 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
 * specify an order of "desc" for descending or "asc" for ascending sort order
 * of corresponding values.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {boolean[]|string[]} orders The order to sort by for each property.
 * @returns {number} Returns the sort order indicator for `object`.
 */ function $b53b4bd61680c3b6$var$compareMultiple(object, other, orders) {
    var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
    while(++index < length){
        var result = $1HU00(objCriteria[index], othCriteria[index]);
        if (result) {
            if (index >= ordersLength) return result;
            var order = orders[index];
            return result * (order == 'desc' ? -1 : 1);
        }
    }
    // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
    // that causes it, under certain circumstances, to provide the same value for
    // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
    // for more details.
    //
    // This also ensures a stable sort in V8 and other engines.
    // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
    return object.index - other.index;
}
module.exports = $b53b4bd61680c3b6$var$compareMultiple;

});
parcelRegister("1HU00", function(module, exports) {

var $9dr3u = parcelRequire("9dr3u");
/**
 * Compares values to sort them in ascending order.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {number} Returns the sort order indicator for `value`.
 */ function $13e53edf809f77b7$var$compareAscending(value, other) {
    if (value !== other) {
        var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = $9dr3u(value);
        var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = $9dr3u(other);
        if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
        if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
    }
    return 0;
}
module.exports = $13e53edf809f77b7$var$compareAscending;

});




parcelRegister("g0ikZ", function(module, exports) {

var $l6E2L = parcelRequire("l6E2L");
/** Used to generate unique IDs. */ var $ba6adedcdb459bac$var$idCounter = 0;
/**
 * Generates a unique ID. If `prefix` is given, the ID is appended to it.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {string} [prefix=''] The value to prefix the ID with.
 * @returns {string} Returns the unique ID.
 * @example
 *
 * _.uniqueId('contact_');
 * // => 'contact_104'
 *
 * _.uniqueId();
 * // => '105'
 */ function $ba6adedcdb459bac$var$uniqueId(prefix) {
    var id = ++$ba6adedcdb459bac$var$idCounter;
    return $l6E2L(prefix) + id;
}
module.exports = $ba6adedcdb459bac$var$uniqueId;

});

parcelRegister("d0lTW", function(module, exports) {

var $5i71d = parcelRequire("5i71d");

var $gMJL8 = parcelRequire("gMJL8");
/**
 * This method is like `_.fromPairs` except that it accepts two arrays,
 * one of property identifiers and one of corresponding values.
 *
 * @static
 * @memberOf _
 * @since 0.4.0
 * @category Array
 * @param {Array} [props=[]] The property identifiers.
 * @param {Array} [values=[]] The property values.
 * @returns {Object} Returns the new object.
 * @example
 *
 * _.zipObject(['a', 'b'], [1, 2]);
 * // => { 'a': 1, 'b': 2 }
 */ function $977c4393d7c5d19f$var$zipObject(props, values) {
    return $gMJL8(props || [], values || [], $5i71d);
}
module.exports = $977c4393d7c5d19f$var$zipObject;

});
parcelRegister("gMJL8", function(module, exports) {
/**
 * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
 *
 * @private
 * @param {Array} props The property identifiers.
 * @param {Array} values The property values.
 * @param {Function} assignFunc The function to assign values.
 * @returns {Object} Returns the new object.
 */ function $c3849fdfd5a45efd$var$baseZipObject(props, values, assignFunc) {
    var index = -1, length = props.length, valsLength = values.length, result = {};
    while(++index < length){
        var value = index < valsLength ? values[index] : undefined;
        assignFunc(result, props[index], value);
    }
    return result;
}
module.exports = $c3849fdfd5a45efd$var$baseZipObject;

});



parcelRegister("61rsw", function(module, exports) {
"use strict";

var $bqfL5 = parcelRequire("bqfL5");

var $7azAU = parcelRequire("7azAU");
module.exports = {
    run: $462822e0eb73a15e$var$run,
    undo: $462822e0eb73a15e$var$undo
};
function $462822e0eb73a15e$var$run(g) {
    var fas = g.graph().acyclicer === "greedy" ? $7azAU(g, weightFn(g)) : $462822e0eb73a15e$var$dfsFAS(g);
    $bqfL5.forEach(fas, function(e) {
        var label = g.edge(e);
        g.removeEdge(e);
        label.forwardName = e.name;
        label.reversed = true;
        g.setEdge(e.w, e.v, label, $bqfL5.uniqueId("rev"));
    });
    function weightFn(g) {
        return function(e) {
            return g.edge(e).weight;
        };
    }
}
function $462822e0eb73a15e$var$dfsFAS(g) {
    var fas = [];
    var stack = {};
    var visited = {};
    function dfs(v) {
        if ($bqfL5.has(visited, v)) return;
        visited[v] = true;
        stack[v] = true;
        $bqfL5.forEach(g.outEdges(v), function(e) {
            if ($bqfL5.has(stack, e.w)) fas.push(e);
            else dfs(e.w);
        });
        delete stack[v];
    }
    $bqfL5.forEach(g.nodes(), dfs);
    return fas;
}
function $462822e0eb73a15e$var$undo(g) {
    $bqfL5.forEach(g.edges(), function(e) {
        var label = g.edge(e);
        if (label.reversed) {
            g.removeEdge(e);
            var forwardName = label.forwardName;
            delete label.reversed;
            delete label.forwardName;
            g.setEdge(e.w, e.v, label, forwardName);
        }
    });
}

});
parcelRegister("7azAU", function(module, exports) {

var $bqfL5 = parcelRequire("bqfL5");

var $6mwJ2 = parcelRequire("6mwJ2");
var $538513d89390fb19$require$Graph = $6mwJ2.Graph;

var $1Gvoz = parcelRequire("1Gvoz");
/*
 * A greedy heuristic for finding a feedback arc set for a graph. A feedback
 * arc set is a set of edges that can be removed to make a graph acyclic.
 * The algorithm comes from: P. Eades, X. Lin, and W. F. Smyth, "A fast and
 * effective heuristic for the feedback arc set problem." This implementation
 * adjusts that from the paper to allow for weighted edges.
 */ module.exports = $538513d89390fb19$var$greedyFAS;
var $538513d89390fb19$var$DEFAULT_WEIGHT_FN = $bqfL5.constant(1);
function $538513d89390fb19$var$greedyFAS(g, weightFn) {
    if (g.nodeCount() <= 1) return [];
    var state = $538513d89390fb19$var$buildState(g, weightFn || $538513d89390fb19$var$DEFAULT_WEIGHT_FN);
    var results = $538513d89390fb19$var$doGreedyFAS(state.graph, state.buckets, state.zeroIdx);
    // Expand multi-edges
    return $bqfL5.flatten($bqfL5.map(results, function(e) {
        return g.outEdges(e.v, e.w);
    }), true);
}
function $538513d89390fb19$var$doGreedyFAS(g, buckets, zeroIdx) {
    var results = [];
    var sources = buckets[buckets.length - 1];
    var sinks = buckets[0];
    var entry;
    while(g.nodeCount()){
        while(entry = sinks.dequeue())$538513d89390fb19$var$removeNode(g, buckets, zeroIdx, entry);
        while(entry = sources.dequeue())$538513d89390fb19$var$removeNode(g, buckets, zeroIdx, entry);
        if (g.nodeCount()) for(var i = buckets.length - 2; i > 0; --i){
            entry = buckets[i].dequeue();
            if (entry) {
                results = results.concat($538513d89390fb19$var$removeNode(g, buckets, zeroIdx, entry, true));
                break;
            }
        }
    }
    return results;
}
function $538513d89390fb19$var$removeNode(g, buckets, zeroIdx, entry, collectPredecessors) {
    var results = collectPredecessors ? [] : undefined;
    $bqfL5.forEach(g.inEdges(entry.v), function(edge) {
        var weight = g.edge(edge);
        var uEntry = g.node(edge.v);
        if (collectPredecessors) results.push({
            v: edge.v,
            w: edge.w
        });
        uEntry.out -= weight;
        $538513d89390fb19$var$assignBucket(buckets, zeroIdx, uEntry);
    });
    $bqfL5.forEach(g.outEdges(entry.v), function(edge) {
        var weight = g.edge(edge);
        var w = edge.w;
        var wEntry = g.node(w);
        wEntry["in"] -= weight;
        $538513d89390fb19$var$assignBucket(buckets, zeroIdx, wEntry);
    });
    g.removeNode(entry.v);
    return results;
}
function $538513d89390fb19$var$buildState(g, weightFn) {
    var fasGraph = new $538513d89390fb19$require$Graph();
    var maxIn = 0;
    var maxOut = 0;
    $bqfL5.forEach(g.nodes(), function(v) {
        fasGraph.setNode(v, {
            v: v,
            "in": 0,
            out: 0
        });
    });
    // Aggregate weights on nodes, but also sum the weights across multi-edges
    // into a single edge for the fasGraph.
    $bqfL5.forEach(g.edges(), function(e) {
        var prevWeight = fasGraph.edge(e.v, e.w) || 0;
        var weight = weightFn(e);
        var edgeWeight = prevWeight + weight;
        fasGraph.setEdge(e.v, e.w, edgeWeight);
        maxOut = Math.max(maxOut, fasGraph.node(e.v).out += weight);
        maxIn = Math.max(maxIn, fasGraph.node(e.w)["in"] += weight);
    });
    var buckets = $bqfL5.range(maxOut + maxIn + 3).map(function() {
        return new $1Gvoz();
    });
    var zeroIdx = maxIn + 1;
    $bqfL5.forEach(fasGraph.nodes(), function(v) {
        $538513d89390fb19$var$assignBucket(buckets, zeroIdx, fasGraph.node(v));
    });
    return {
        graph: fasGraph,
        buckets: buckets,
        zeroIdx: zeroIdx
    };
}
function $538513d89390fb19$var$assignBucket(buckets, zeroIdx, entry) {
    if (!entry.out) buckets[0].enqueue(entry);
    else if (!entry["in"]) buckets[buckets.length - 1].enqueue(entry);
    else buckets[entry.out - entry["in"] + zeroIdx].enqueue(entry);
}

});
parcelRegister("1Gvoz", function(module, exports) {
/*
 * Simple doubly linked list implementation derived from Cormen, et al.,
 * "Introduction to Algorithms".
 */ module.exports = $13a211288b92d897$var$List;
function $13a211288b92d897$var$List() {
    var sentinel = {};
    sentinel._next = sentinel._prev = sentinel;
    this._sentinel = sentinel;
}
$13a211288b92d897$var$List.prototype.dequeue = function() {
    var sentinel = this._sentinel;
    var entry = sentinel._prev;
    if (entry !== sentinel) {
        $13a211288b92d897$var$unlink(entry);
        return entry;
    }
};
$13a211288b92d897$var$List.prototype.enqueue = function(entry) {
    var sentinel = this._sentinel;
    if (entry._prev && entry._next) $13a211288b92d897$var$unlink(entry);
    entry._next = sentinel._next;
    sentinel._next._prev = entry;
    sentinel._next = entry;
    entry._prev = sentinel;
};
$13a211288b92d897$var$List.prototype.toString = function() {
    var strs = [];
    var sentinel = this._sentinel;
    var curr = sentinel._prev;
    while(curr !== sentinel){
        strs.push(JSON.stringify(curr, $13a211288b92d897$var$filterOutLinks));
        curr = curr._prev;
    }
    return "[" + strs.join(", ") + "]";
};
function $13a211288b92d897$var$unlink(entry) {
    entry._prev._next = entry._next;
    entry._next._prev = entry._prev;
    delete entry._next;
    delete entry._prev;
}
function $13a211288b92d897$var$filterOutLinks(k, v) {
    if (k !== "_next" && k !== "_prev") return v;
}

});



parcelRegister("fi6eg", function(module, exports) {
"use strict";

var $bqfL5 = parcelRequire("bqfL5");

var $1kMKg = parcelRequire("1kMKg");
module.exports = {
    run: $b21d5e65d022816f$var$run,
    undo: $b21d5e65d022816f$var$undo
};
/*
 * Breaks any long edges in the graph into short segments that span 1 layer
 * each. This operation is undoable with the denormalize function.
 *
 * Pre-conditions:
 *
 *    1. The input graph is a DAG.
 *    2. Each node in the graph has a "rank" property.
 *
 * Post-condition:
 *
 *    1. All edges in the graph have a length of 1.
 *    2. Dummy nodes are added where edges have been split into segments.
 *    3. The graph is augmented with a "dummyChains" attribute which contains
 *       the first dummy in each chain of dummy nodes produced.
 */ function $b21d5e65d022816f$var$run(g) {
    g.graph().dummyChains = [];
    $bqfL5.forEach(g.edges(), function(edge) {
        $b21d5e65d022816f$var$normalizeEdge(g, edge);
    });
}
function $b21d5e65d022816f$var$normalizeEdge(g, e) {
    var v = e.v;
    var vRank = g.node(v).rank;
    var w = e.w;
    var wRank = g.node(w).rank;
    var name = e.name;
    var edgeLabel = g.edge(e);
    var labelRank = edgeLabel.labelRank;
    if (wRank === vRank + 1) return;
    g.removeEdge(e);
    var dummy, attrs, i;
    for(i = 0, ++vRank; vRank < wRank; ++i, ++vRank){
        edgeLabel.points = [];
        attrs = {
            width: 0,
            height: 0,
            edgeLabel: edgeLabel,
            edgeObj: e,
            rank: vRank
        };
        dummy = $1kMKg.addDummyNode(g, "edge", attrs, "_d");
        if (vRank === labelRank) {
            attrs.width = edgeLabel.width;
            attrs.height = edgeLabel.height;
            attrs.dummy = "edge-label";
            attrs.labelpos = edgeLabel.labelpos;
        }
        g.setEdge(v, dummy, {
            weight: edgeLabel.weight
        }, name);
        if (i === 0) g.graph().dummyChains.push(dummy);
        v = dummy;
    }
    g.setEdge(v, w, {
        weight: edgeLabel.weight
    }, name);
}
function $b21d5e65d022816f$var$undo(g) {
    $bqfL5.forEach(g.graph().dummyChains, function(v) {
        var node = g.node(v);
        var origLabel = node.edgeLabel;
        var w;
        g.setEdge(node.edgeObj, origLabel);
        while(node.dummy){
            w = g.successors(v)[0];
            g.removeNode(v);
            origLabel.points.push({
                x: node.x,
                y: node.y
            });
            if (node.dummy === "edge-label") {
                origLabel.x = node.x;
                origLabel.y = node.y;
                origLabel.width = node.width;
                origLabel.height = node.height;
            }
            v = w;
            node = g.node(v);
        }
    });
}

});
parcelRegister("1kMKg", function(module, exports) {
/* eslint "no-console": off */ "use strict";

var $bqfL5 = parcelRequire("bqfL5");

var $6mwJ2 = parcelRequire("6mwJ2");
var $0f8d7874fb4245ee$require$Graph = $6mwJ2.Graph;
module.exports = {
    addDummyNode: $0f8d7874fb4245ee$var$addDummyNode,
    simplify: $0f8d7874fb4245ee$var$simplify,
    asNonCompoundGraph: $0f8d7874fb4245ee$var$asNonCompoundGraph,
    successorWeights: $0f8d7874fb4245ee$var$successorWeights,
    predecessorWeights: $0f8d7874fb4245ee$var$predecessorWeights,
    intersectRect: $0f8d7874fb4245ee$var$intersectRect,
    buildLayerMatrix: $0f8d7874fb4245ee$var$buildLayerMatrix,
    normalizeRanks: $0f8d7874fb4245ee$var$normalizeRanks,
    removeEmptyRanks: $0f8d7874fb4245ee$var$removeEmptyRanks,
    addBorderNode: $0f8d7874fb4245ee$var$addBorderNode,
    maxRank: $0f8d7874fb4245ee$var$maxRank,
    partition: $0f8d7874fb4245ee$var$partition,
    time: $0f8d7874fb4245ee$var$time,
    notime: $0f8d7874fb4245ee$var$notime
};
/*
 * Adds a dummy node to the graph and return v.
 */ function $0f8d7874fb4245ee$var$addDummyNode(g, type, attrs, name) {
    var v;
    do v = $bqfL5.uniqueId(name);
    while (g.hasNode(v));
    attrs.dummy = type;
    g.setNode(v, attrs);
    return v;
}
/*
 * Returns a new graph with only simple edges. Handles aggregation of data
 * associated with multi-edges.
 */ function $0f8d7874fb4245ee$var$simplify(g) {
    var simplified = new $0f8d7874fb4245ee$require$Graph().setGraph(g.graph());
    $bqfL5.forEach(g.nodes(), function(v) {
        simplified.setNode(v, g.node(v));
    });
    $bqfL5.forEach(g.edges(), function(e) {
        var simpleLabel = simplified.edge(e.v, e.w) || {
            weight: 0,
            minlen: 1
        };
        var label = g.edge(e);
        simplified.setEdge(e.v, e.w, {
            weight: simpleLabel.weight + label.weight,
            minlen: Math.max(simpleLabel.minlen, label.minlen)
        });
    });
    return simplified;
}
function $0f8d7874fb4245ee$var$asNonCompoundGraph(g) {
    var simplified = new $0f8d7874fb4245ee$require$Graph({
        multigraph: g.isMultigraph()
    }).setGraph(g.graph());
    $bqfL5.forEach(g.nodes(), function(v) {
        if (!g.children(v).length) simplified.setNode(v, g.node(v));
    });
    $bqfL5.forEach(g.edges(), function(e) {
        simplified.setEdge(e, g.edge(e));
    });
    return simplified;
}
function $0f8d7874fb4245ee$var$successorWeights(g) {
    var weightMap = $bqfL5.map(g.nodes(), function(v) {
        var sucs = {};
        $bqfL5.forEach(g.outEdges(v), function(e) {
            sucs[e.w] = (sucs[e.w] || 0) + g.edge(e).weight;
        });
        return sucs;
    });
    return $bqfL5.zipObject(g.nodes(), weightMap);
}
function $0f8d7874fb4245ee$var$predecessorWeights(g) {
    var weightMap = $bqfL5.map(g.nodes(), function(v) {
        var preds = {};
        $bqfL5.forEach(g.inEdges(v), function(e) {
            preds[e.v] = (preds[e.v] || 0) + g.edge(e).weight;
        });
        return preds;
    });
    return $bqfL5.zipObject(g.nodes(), weightMap);
}
/*
 * Finds where a line starting at point ({x, y}) would intersect a rectangle
 * ({x, y, width, height}) if it were pointing at the rectangle's center.
 */ function $0f8d7874fb4245ee$var$intersectRect(rect, point) {
    var x = rect.x;
    var y = rect.y;
    // Rectangle intersection algorithm from:
    // http://math.stackexchange.com/questions/108113/find-edge-between-two-boxes
    var dx = point.x - x;
    var dy = point.y - y;
    var w = rect.width / 2;
    var h = rect.height / 2;
    if (!dx && !dy) throw new Error("Not possible to find intersection inside of the rectangle");
    var sx, sy;
    if (Math.abs(dy) * w > Math.abs(dx) * h) {
        // Intersection is top or bottom of rect.
        if (dy < 0) h = -h;
        sx = h * dx / dy;
        sy = h;
    } else {
        // Intersection is left or right of rect.
        if (dx < 0) w = -w;
        sx = w;
        sy = w * dy / dx;
    }
    return {
        x: x + sx,
        y: y + sy
    };
}
/*
 * Given a DAG with each node assigned "rank" and "order" properties, this
 * function will produce a matrix with the ids of each node.
 */ function $0f8d7874fb4245ee$var$buildLayerMatrix(g) {
    var layering = $bqfL5.map($bqfL5.range($0f8d7874fb4245ee$var$maxRank(g) + 1), function() {
        return [];
    });
    $bqfL5.forEach(g.nodes(), function(v) {
        var node = g.node(v);
        var rank = node.rank;
        if (!$bqfL5.isUndefined(rank)) layering[rank][node.order] = v;
    });
    return layering;
}
/*
 * Adjusts the ranks for all nodes in the graph such that all nodes v have
 * rank(v) >= 0 and at least one node w has rank(w) = 0.
 */ function $0f8d7874fb4245ee$var$normalizeRanks(g) {
    var min = $bqfL5.min($bqfL5.map(g.nodes(), function(v) {
        return g.node(v).rank;
    }));
    $bqfL5.forEach(g.nodes(), function(v) {
        var node = g.node(v);
        if ($bqfL5.has(node, "rank")) node.rank -= min;
    });
}
function $0f8d7874fb4245ee$var$removeEmptyRanks(g) {
    // Ranks may not start at 0, so we need to offset them
    var offset = $bqfL5.min($bqfL5.map(g.nodes(), function(v) {
        return g.node(v).rank;
    }));
    var layers = [];
    $bqfL5.forEach(g.nodes(), function(v) {
        var rank = g.node(v).rank - offset;
        if (!layers[rank]) layers[rank] = [];
        layers[rank].push(v);
    });
    var delta = 0;
    var nodeRankFactor = g.graph().nodeRankFactor;
    $bqfL5.forEach(layers, function(vs, i) {
        if ($bqfL5.isUndefined(vs) && i % nodeRankFactor !== 0) --delta;
        else if (delta) $bqfL5.forEach(vs, function(v) {
            g.node(v).rank += delta;
        });
    });
}
function $0f8d7874fb4245ee$var$addBorderNode(g, prefix, rank, order) {
    var node = {
        width: 0,
        height: 0
    };
    if (arguments.length >= 4) {
        node.rank = rank;
        node.order = order;
    }
    return $0f8d7874fb4245ee$var$addDummyNode(g, "border", node, prefix);
}
function $0f8d7874fb4245ee$var$maxRank(g) {
    return $bqfL5.max($bqfL5.map(g.nodes(), function(v) {
        var rank = g.node(v).rank;
        if (!$bqfL5.isUndefined(rank)) return rank;
    }));
}
/*
 * Partition a collection into two groups: `lhs` and `rhs`. If the supplied
 * function returns true for an entry it goes into `lhs`. Otherwise it goes
 * into `rhs.
 */ function $0f8d7874fb4245ee$var$partition(collection, fn) {
    var result = {
        lhs: [],
        rhs: []
    };
    $bqfL5.forEach(collection, function(value) {
        if (fn(value)) result.lhs.push(value);
        else result.rhs.push(value);
    });
    return result;
}
/*
 * Returns a new function that wraps `fn` with a timer. The wrapper logs the
 * time it takes to execute the function.
 */ function $0f8d7874fb4245ee$var$time(name, fn) {
    var start = $bqfL5.now();
    try {
        return fn();
    } finally{
        console.log(name + " time: " + ($bqfL5.now() - start) + "ms");
    }
}
function $0f8d7874fb4245ee$var$notime(name, fn) {
    return fn();
}

});


parcelRegister("hv32p", function(module, exports) {
"use strict";

var $7JZFZ = parcelRequire("7JZFZ");
var $cbd7b02ec197fd8b$var$longestPath = $7JZFZ.longestPath;

var $8eEo6 = parcelRequire("8eEo6");

var $fT8MR = parcelRequire("fT8MR");
module.exports = $cbd7b02ec197fd8b$var$rank;
/*
 * Assigns a rank to each node in the input graph that respects the "minlen"
 * constraint specified on edges between nodes.
 *
 * This basic structure is derived from Gansner, et al., "A Technique for
 * Drawing Directed Graphs."
 *
 * Pre-conditions:
 *
 *    1. Graph must be a connected DAG
 *    2. Graph nodes must be objects
 *    3. Graph edges must have "weight" and "minlen" attributes
 *
 * Post-conditions:
 *
 *    1. Graph nodes will have a "rank" attribute based on the results of the
 *       algorithm. Ranks can start at any index (including negative), we'll
 *       fix them up later.
 */ function $cbd7b02ec197fd8b$var$rank(g) {
    switch(g.graph().ranker){
        case "network-simplex":
            $cbd7b02ec197fd8b$var$networkSimplexRanker(g);
            break;
        case "tight-tree":
            $cbd7b02ec197fd8b$var$tightTreeRanker(g);
            break;
        case "longest-path":
            $cbd7b02ec197fd8b$var$longestPathRanker(g);
            break;
        default:
            $cbd7b02ec197fd8b$var$networkSimplexRanker(g);
    }
}
// A fast and simple ranker, but results are far from optimal.
var $cbd7b02ec197fd8b$var$longestPathRanker = $cbd7b02ec197fd8b$var$longestPath;
function $cbd7b02ec197fd8b$var$tightTreeRanker(g) {
    $cbd7b02ec197fd8b$var$longestPath(g);
    $8eEo6(g);
}
function $cbd7b02ec197fd8b$var$networkSimplexRanker(g) {
    $fT8MR(g);
}

});
parcelRegister("7JZFZ", function(module, exports) {
"use strict";

var $bqfL5 = parcelRequire("bqfL5");
module.exports = {
    longestPath: $5a2c9402b96e1199$var$longestPath,
    slack: $5a2c9402b96e1199$var$slack
};
/*
 * Initializes ranks for the input graph using the longest path algorithm. This
 * algorithm scales well and is fast in practice, it yields rather poor
 * solutions. Nodes are pushed to the lowest layer possible, leaving the bottom
 * ranks wide and leaving edges longer than necessary. However, due to its
 * speed, this algorithm is good for getting an initial ranking that can be fed
 * into other algorithms.
 *
 * This algorithm does not normalize layers because it will be used by other
 * algorithms in most cases. If using this algorithm directly, be sure to
 * run normalize at the end.
 *
 * Pre-conditions:
 *
 *    1. Input graph is a DAG.
 *    2. Input graph node labels can be assigned properties.
 *
 * Post-conditions:
 *
 *    1. Each node will be assign an (unnormalized) "rank" property.
 */ function $5a2c9402b96e1199$var$longestPath(g) {
    var visited = {};
    function dfs(v) {
        var label = g.node(v);
        if ($bqfL5.has(visited, v)) return label.rank;
        visited[v] = true;
        var rank = $bqfL5.min($bqfL5.map(g.outEdges(v), function(e) {
            return dfs(e.w) - g.edge(e).minlen;
        }));
        if (rank === Number.POSITIVE_INFINITY || // return value of _.map([]) for Lodash 3
        rank === undefined || // return value of _.map([]) for Lodash 4
        rank === null) rank = 0;
        return label.rank = rank;
    }
    $bqfL5.forEach(g.sources(), dfs);
}
/*
 * Returns the amount of slack for the given edge. The slack is defined as the
 * difference between the length of the edge and its minimum length.
 */ function $5a2c9402b96e1199$var$slack(g, e) {
    return g.node(e.w).rank - g.node(e.v).rank - g.edge(e).minlen;
}

});

parcelRegister("8eEo6", function(module, exports) {
"use strict";

var $bqfL5 = parcelRequire("bqfL5");

var $6mwJ2 = parcelRequire("6mwJ2");
var $5feef5b0afc29ce6$require$Graph = $6mwJ2.Graph;

var $7JZFZ = parcelRequire("7JZFZ");
var $5feef5b0afc29ce6$require$slack = $7JZFZ.slack;
module.exports = $5feef5b0afc29ce6$var$feasibleTree;
/*
 * Constructs a spanning tree with tight edges and adjusted the input node's
 * ranks to achieve this. A tight edge is one that is has a length that matches
 * its "minlen" attribute.
 *
 * The basic structure for this function is derived from Gansner, et al., "A
 * Technique for Drawing Directed Graphs."
 *
 * Pre-conditions:
 *
 *    1. Graph must be a DAG.
 *    2. Graph must be connected.
 *    3. Graph must have at least one node.
 *    5. Graph nodes must have been previously assigned a "rank" property that
 *       respects the "minlen" property of incident edges.
 *    6. Graph edges must have a "minlen" property.
 *
 * Post-conditions:
 *
 *    - Graph nodes will have their rank adjusted to ensure that all edges are
 *      tight.
 *
 * Returns a tree (undirected graph) that is constructed using only "tight"
 * edges.
 */ function $5feef5b0afc29ce6$var$feasibleTree(g) {
    var t = new $5feef5b0afc29ce6$require$Graph({
        directed: false
    });
    // Choose arbitrary node from which to start our tree
    var start = g.nodes()[0];
    var size = g.nodeCount();
    t.setNode(start, {});
    var edge, delta;
    while($5feef5b0afc29ce6$var$tightTree(t, g) < size){
        edge = $5feef5b0afc29ce6$var$findMinSlackEdge(t, g);
        delta = t.hasNode(edge.v) ? $5feef5b0afc29ce6$require$slack(g, edge) : -$5feef5b0afc29ce6$require$slack(g, edge);
        $5feef5b0afc29ce6$var$shiftRanks(t, g, delta);
    }
    return t;
}
/*
 * Finds a maximal tree of tight edges and returns the number of nodes in the
 * tree.
 */ function $5feef5b0afc29ce6$var$tightTree(t, g) {
    function dfs(v) {
        $bqfL5.forEach(g.nodeEdges(v), function(e) {
            var edgeV = e.v, w = v === edgeV ? e.w : edgeV;
            if (!t.hasNode(w) && !$5feef5b0afc29ce6$require$slack(g, e)) {
                t.setNode(w, {});
                t.setEdge(v, w, {});
                dfs(w);
            }
        });
    }
    $bqfL5.forEach(t.nodes(), dfs);
    return t.nodeCount();
}
/*
 * Finds the edge with the smallest slack that is incident on tree and returns
 * it.
 */ function $5feef5b0afc29ce6$var$findMinSlackEdge(t, g) {
    return $bqfL5.minBy(g.edges(), function(e) {
        if (t.hasNode(e.v) !== t.hasNode(e.w)) return $5feef5b0afc29ce6$require$slack(g, e);
    });
}
function $5feef5b0afc29ce6$var$shiftRanks(t, g, delta) {
    $bqfL5.forEach(t.nodes(), function(v) {
        g.node(v).rank += delta;
    });
}

});

parcelRegister("fT8MR", function(module, exports) {
"use strict";

var $bqfL5 = parcelRequire("bqfL5");

var $8eEo6 = parcelRequire("8eEo6");

var $7JZFZ = parcelRequire("7JZFZ");
var $b912cf006614473d$require$slack = $7JZFZ.slack;

var $7JZFZ = parcelRequire("7JZFZ");
var $b912cf006614473d$require$initRank = $7JZFZ.longestPath;

var $b912cf006614473d$var$preorder = (parcelRequire("6mwJ2")).alg.preorder;

var $b912cf006614473d$var$postorder = (parcelRequire("6mwJ2")).alg.postorder;

var $1kMKg = parcelRequire("1kMKg");
var $b912cf006614473d$require$simplify = $1kMKg.simplify;
module.exports = $b912cf006614473d$var$networkSimplex;
// Expose some internals for testing purposes
$b912cf006614473d$var$networkSimplex.initLowLimValues = $b912cf006614473d$var$initLowLimValues;
$b912cf006614473d$var$networkSimplex.initCutValues = $b912cf006614473d$var$initCutValues;
$b912cf006614473d$var$networkSimplex.calcCutValue = $b912cf006614473d$var$calcCutValue;
$b912cf006614473d$var$networkSimplex.leaveEdge = $b912cf006614473d$var$leaveEdge;
$b912cf006614473d$var$networkSimplex.enterEdge = $b912cf006614473d$var$enterEdge;
$b912cf006614473d$var$networkSimplex.exchangeEdges = $b912cf006614473d$var$exchangeEdges;
/*
 * The network simplex algorithm assigns ranks to each node in the input graph
 * and iteratively improves the ranking to reduce the length of edges.
 *
 * Preconditions:
 *
 *    1. The input graph must be a DAG.
 *    2. All nodes in the graph must have an object value.
 *    3. All edges in the graph must have "minlen" and "weight" attributes.
 *
 * Postconditions:
 *
 *    1. All nodes in the graph will have an assigned "rank" attribute that has
 *       been optimized by the network simplex algorithm. Ranks start at 0.
 *
 *
 * A rough sketch of the algorithm is as follows:
 *
 *    1. Assign initial ranks to each node. We use the longest path algorithm,
 *       which assigns ranks to the lowest position possible. In general this
 *       leads to very wide bottom ranks and unnecessarily long edges.
 *    2. Construct a feasible tight tree. A tight tree is one such that all
 *       edges in the tree have no slack (difference between length of edge
 *       and minlen for the edge). This by itself greatly improves the assigned
 *       rankings by shorting edges.
 *    3. Iteratively find edges that have negative cut values. Generally a
 *       negative cut value indicates that the edge could be removed and a new
 *       tree edge could be added to produce a more compact graph.
 *
 * Much of the algorithms here are derived from Gansner, et al., "A Technique
 * for Drawing Directed Graphs." The structure of the file roughly follows the
 * structure of the overall algorithm.
 */ function $b912cf006614473d$var$networkSimplex(g) {
    g = $b912cf006614473d$require$simplify(g);
    $b912cf006614473d$require$initRank(g);
    var t = $8eEo6(g);
    $b912cf006614473d$var$initLowLimValues(t);
    $b912cf006614473d$var$initCutValues(t, g);
    var e, f;
    while(e = $b912cf006614473d$var$leaveEdge(t)){
        f = $b912cf006614473d$var$enterEdge(t, g, e);
        $b912cf006614473d$var$exchangeEdges(t, g, e, f);
    }
}
/*
 * Initializes cut values for all edges in the tree.
 */ function $b912cf006614473d$var$initCutValues(t, g) {
    var vs = $b912cf006614473d$var$postorder(t, t.nodes());
    vs = vs.slice(0, vs.length - 1);
    $bqfL5.forEach(vs, function(v) {
        $b912cf006614473d$var$assignCutValue(t, g, v);
    });
}
function $b912cf006614473d$var$assignCutValue(t, g, child) {
    var childLab = t.node(child);
    var parent = childLab.parent;
    t.edge(child, parent).cutvalue = $b912cf006614473d$var$calcCutValue(t, g, child);
}
/*
 * Given the tight tree, its graph, and a child in the graph calculate and
 * return the cut value for the edge between the child and its parent.
 */ function $b912cf006614473d$var$calcCutValue(t, g, child) {
    var childLab = t.node(child);
    var parent = childLab.parent;
    // True if the child is on the tail end of the edge in the directed graph
    var childIsTail = true;
    // The graph's view of the tree edge we're inspecting
    var graphEdge = g.edge(child, parent);
    // The accumulated cut value for the edge between this node and its parent
    var cutValue = 0;
    if (!graphEdge) {
        childIsTail = false;
        graphEdge = g.edge(parent, child);
    }
    cutValue = graphEdge.weight;
    $bqfL5.forEach(g.nodeEdges(child), function(e) {
        var isOutEdge = e.v === child, other = isOutEdge ? e.w : e.v;
        if (other !== parent) {
            var pointsToHead = isOutEdge === childIsTail, otherWeight = g.edge(e).weight;
            cutValue += pointsToHead ? otherWeight : -otherWeight;
            if ($b912cf006614473d$var$isTreeEdge(t, child, other)) {
                var otherCutValue = t.edge(child, other).cutvalue;
                cutValue += pointsToHead ? -otherCutValue : otherCutValue;
            }
        }
    });
    return cutValue;
}
function $b912cf006614473d$var$initLowLimValues(tree, root) {
    if (arguments.length < 2) root = tree.nodes()[0];
    $b912cf006614473d$var$dfsAssignLowLim(tree, {}, 1, root);
}
function $b912cf006614473d$var$dfsAssignLowLim(tree, visited, nextLim, v, parent) {
    var low = nextLim;
    var label = tree.node(v);
    visited[v] = true;
    $bqfL5.forEach(tree.neighbors(v), function(w) {
        if (!$bqfL5.has(visited, w)) nextLim = $b912cf006614473d$var$dfsAssignLowLim(tree, visited, nextLim, w, v);
    });
    label.low = low;
    label.lim = nextLim++;
    if (parent) label.parent = parent;
    else // TODO should be able to remove this when we incrementally update low lim
    delete label.parent;
    return nextLim;
}
function $b912cf006614473d$var$leaveEdge(tree) {
    return $bqfL5.find(tree.edges(), function(e) {
        return tree.edge(e).cutvalue < 0;
    });
}
function $b912cf006614473d$var$enterEdge(t, g, edge) {
    var v = edge.v;
    var w = edge.w;
    // For the rest of this function we assume that v is the tail and w is the
    // head, so if we don't have this edge in the graph we should flip it to
    // match the correct orientation.
    if (!g.hasEdge(v, w)) {
        v = edge.w;
        w = edge.v;
    }
    var vLabel = t.node(v);
    var wLabel = t.node(w);
    var tailLabel = vLabel;
    var flip = false;
    // If the root is in the tail of the edge then we need to flip the logic that
    // checks for the head and tail nodes in the candidates function below.
    if (vLabel.lim > wLabel.lim) {
        tailLabel = wLabel;
        flip = true;
    }
    var candidates = $bqfL5.filter(g.edges(), function(edge) {
        return flip === $b912cf006614473d$var$isDescendant(t, t.node(edge.v), tailLabel) && flip !== $b912cf006614473d$var$isDescendant(t, t.node(edge.w), tailLabel);
    });
    return $bqfL5.minBy(candidates, function(edge) {
        return $b912cf006614473d$require$slack(g, edge);
    });
}
function $b912cf006614473d$var$exchangeEdges(t, g, e, f) {
    var v = e.v;
    var w = e.w;
    t.removeEdge(v, w);
    t.setEdge(f.v, f.w, {});
    $b912cf006614473d$var$initLowLimValues(t);
    $b912cf006614473d$var$initCutValues(t, g);
    $b912cf006614473d$var$updateRanks(t, g);
}
function $b912cf006614473d$var$updateRanks(t, g) {
    var root = $bqfL5.find(t.nodes(), function(v) {
        return !g.node(v).parent;
    });
    var vs = $b912cf006614473d$var$preorder(t, root);
    vs = vs.slice(1);
    $bqfL5.forEach(vs, function(v) {
        var parent = t.node(v).parent, edge = g.edge(v, parent), flipped = false;
        if (!edge) {
            edge = g.edge(parent, v);
            flipped = true;
        }
        g.node(v).rank = g.node(parent).rank + (flipped ? edge.minlen : -edge.minlen);
    });
}
/*
 * Returns true if the edge is in the tree.
 */ function $b912cf006614473d$var$isTreeEdge(tree, u, v) {
    return tree.hasEdge(u, v);
}
/*
 * Returns true if the specified node is descendant of the root node per the
 * assigned low and lim attributes in the tree.
 */ function $b912cf006614473d$var$isDescendant(tree, vLabel, rootLabel) {
    return rootLabel.low <= vLabel.lim && vLabel.lim <= rootLabel.lim;
}

});


parcelRegister("eBG2O", function(module, exports) {

var $bqfL5 = parcelRequire("bqfL5");
module.exports = $aa252286d7a30ca5$var$parentDummyChains;
function $aa252286d7a30ca5$var$parentDummyChains(g) {
    var postorderNums = $aa252286d7a30ca5$var$postorder(g);
    $bqfL5.forEach(g.graph().dummyChains, function(v) {
        var node = g.node(v);
        var edgeObj = node.edgeObj;
        var pathData = $aa252286d7a30ca5$var$findPath(g, postorderNums, edgeObj.v, edgeObj.w);
        var path = pathData.path;
        var lca = pathData.lca;
        var pathIdx = 0;
        var pathV = path[pathIdx];
        var ascending = true;
        while(v !== edgeObj.w){
            node = g.node(v);
            if (ascending) {
                while((pathV = path[pathIdx]) !== lca && g.node(pathV).maxRank < node.rank)pathIdx++;
                if (pathV === lca) ascending = false;
            }
            if (!ascending) {
                while(pathIdx < path.length - 1 && g.node(pathV = path[pathIdx + 1]).minRank <= node.rank)pathIdx++;
                pathV = path[pathIdx];
            }
            g.setParent(v, pathV);
            v = g.successors(v)[0];
        }
    });
}
// Find a path from v to w through the lowest common ancestor (LCA). Return the
// full path and the LCA.
function $aa252286d7a30ca5$var$findPath(g, postorderNums, v, w) {
    var vPath = [];
    var wPath = [];
    var low = Math.min(postorderNums[v].low, postorderNums[w].low);
    var lim = Math.max(postorderNums[v].lim, postorderNums[w].lim);
    var parent;
    var lca;
    // Traverse up from v to find the LCA
    parent = v;
    do {
        parent = g.parent(parent);
        vPath.push(parent);
    }while (parent && (postorderNums[parent].low > low || lim > postorderNums[parent].lim));
    lca = parent;
    // Traverse from w to LCA
    parent = w;
    while((parent = g.parent(parent)) !== lca)wPath.push(parent);
    return {
        path: vPath.concat(wPath.reverse()),
        lca: lca
    };
}
function $aa252286d7a30ca5$var$postorder(g) {
    var result = {};
    var lim = 0;
    function dfs(v) {
        var low = lim;
        $bqfL5.forEach(g.children(v), dfs);
        result[v] = {
            low: low,
            lim: lim++
        };
    }
    $bqfL5.forEach(g.children(), dfs);
    return result;
}

});

parcelRegister("YdQc0", function(module, exports) {

var $bqfL5 = parcelRequire("bqfL5");

var $1kMKg = parcelRequire("1kMKg");
module.exports = {
    run: $0b5057358d9c05c8$var$run,
    cleanup: $0b5057358d9c05c8$var$cleanup
};
/*
 * A nesting graph creates dummy nodes for the tops and bottoms of subgraphs,
 * adds appropriate edges to ensure that all cluster nodes are placed between
 * these boundries, and ensures that the graph is connected.
 *
 * In addition we ensure, through the use of the minlen property, that nodes
 * and subgraph border nodes to not end up on the same rank.
 *
 * Preconditions:
 *
 *    1. Input graph is a DAG
 *    2. Nodes in the input graph has a minlen attribute
 *
 * Postconditions:
 *
 *    1. Input graph is connected.
 *    2. Dummy nodes are added for the tops and bottoms of subgraphs.
 *    3. The minlen attribute for nodes is adjusted to ensure nodes do not
 *       get placed on the same rank as subgraph border nodes.
 *
 * The nesting graph idea comes from Sander, "Layout of Compound Directed
 * Graphs."
 */ function $0b5057358d9c05c8$var$run(g) {
    var root = $1kMKg.addDummyNode(g, "root", {}, "_root");
    var depths = $0b5057358d9c05c8$var$treeDepths(g);
    var height = $bqfL5.max($bqfL5.values(depths)) - 1; // Note: depths is an Object not an array
    var nodeSep = 2 * height + 1;
    g.graph().nestingRoot = root;
    // Multiply minlen by nodeSep to align nodes on non-border ranks.
    $bqfL5.forEach(g.edges(), function(e) {
        g.edge(e).minlen *= nodeSep;
    });
    // Calculate a weight that is sufficient to keep subgraphs vertically compact
    var weight = $0b5057358d9c05c8$var$sumWeights(g) + 1;
    // Create border nodes and link them up
    $bqfL5.forEach(g.children(), function(child) {
        $0b5057358d9c05c8$var$dfs(g, root, nodeSep, weight, height, depths, child);
    });
    // Save the multiplier for node layers for later removal of empty border
    // layers.
    g.graph().nodeRankFactor = nodeSep;
}
function $0b5057358d9c05c8$var$dfs(g, root, nodeSep, weight, height, depths, v) {
    var children = g.children(v);
    if (!children.length) {
        if (v !== root) g.setEdge(root, v, {
            weight: 0,
            minlen: nodeSep
        });
        return;
    }
    var top = $1kMKg.addBorderNode(g, "_bt");
    var bottom = $1kMKg.addBorderNode(g, "_bb");
    var label = g.node(v);
    g.setParent(top, v);
    label.borderTop = top;
    g.setParent(bottom, v);
    label.borderBottom = bottom;
    $bqfL5.forEach(children, function(child) {
        $0b5057358d9c05c8$var$dfs(g, root, nodeSep, weight, height, depths, child);
        var childNode = g.node(child);
        var childTop = childNode.borderTop ? childNode.borderTop : child;
        var childBottom = childNode.borderBottom ? childNode.borderBottom : child;
        var thisWeight = childNode.borderTop ? weight : 2 * weight;
        var minlen = childTop !== childBottom ? 1 : height - depths[v] + 1;
        g.setEdge(top, childTop, {
            weight: thisWeight,
            minlen: minlen,
            nestingEdge: true
        });
        g.setEdge(childBottom, bottom, {
            weight: thisWeight,
            minlen: minlen,
            nestingEdge: true
        });
    });
    if (!g.parent(v)) g.setEdge(root, top, {
        weight: 0,
        minlen: height + depths[v]
    });
}
function $0b5057358d9c05c8$var$treeDepths(g) {
    var depths = {};
    function dfs(v, depth) {
        var children = g.children(v);
        if (children && children.length) $bqfL5.forEach(children, function(child) {
            dfs(child, depth + 1);
        });
        depths[v] = depth;
    }
    $bqfL5.forEach(g.children(), function(v) {
        dfs(v, 1);
    });
    return depths;
}
function $0b5057358d9c05c8$var$sumWeights(g) {
    return $bqfL5.reduce(g.edges(), function(acc, e) {
        return acc + g.edge(e).weight;
    }, 0);
}
function $0b5057358d9c05c8$var$cleanup(g) {
    var graphLabel = g.graph();
    g.removeNode(graphLabel.nestingRoot);
    delete graphLabel.nestingRoot;
    $bqfL5.forEach(g.edges(), function(e) {
        var edge = g.edge(e);
        if (edge.nestingEdge) g.removeEdge(e);
    });
}

});

parcelRegister("fSZns", function(module, exports) {

var $bqfL5 = parcelRequire("bqfL5");

var $1kMKg = parcelRequire("1kMKg");
module.exports = $b90b826f4fed8d23$var$addBorderSegments;
function $b90b826f4fed8d23$var$addBorderSegments(g) {
    function dfs(v) {
        var children = g.children(v);
        var node = g.node(v);
        if (children.length) $bqfL5.forEach(children, dfs);
        if ($bqfL5.has(node, "minRank")) {
            node.borderLeft = [];
            node.borderRight = [];
            for(var rank = node.minRank, maxRank = node.maxRank + 1; rank < maxRank; ++rank){
                $b90b826f4fed8d23$var$addBorderNode(g, "borderLeft", "_bl", v, node, rank);
                $b90b826f4fed8d23$var$addBorderNode(g, "borderRight", "_br", v, node, rank);
            }
        }
    }
    $bqfL5.forEach(g.children(), dfs);
}
function $b90b826f4fed8d23$var$addBorderNode(g, prop, prefix, sg, sgNode, rank) {
    var label = {
        width: 0,
        height: 0,
        rank: rank,
        borderType: prop
    };
    var prev = sgNode[prop][rank - 1];
    var curr = $1kMKg.addDummyNode(g, "border", label, prefix);
    sgNode[prop][rank] = curr;
    g.setParent(curr, sg);
    if (prev) g.setEdge(prev, curr, {
        weight: 1
    });
}

});

parcelRegister("lWVsJ", function(module, exports) {
"use strict";

var $bqfL5 = parcelRequire("bqfL5");
module.exports = {
    adjust: $ffab96934221be07$var$adjust,
    undo: $ffab96934221be07$var$undo
};
function $ffab96934221be07$var$adjust(g) {
    var rankDir = g.graph().rankdir.toLowerCase();
    if (rankDir === "lr" || rankDir === "rl") $ffab96934221be07$var$swapWidthHeight(g);
}
function $ffab96934221be07$var$undo(g) {
    var rankDir = g.graph().rankdir.toLowerCase();
    if (rankDir === "bt" || rankDir === "rl") $ffab96934221be07$var$reverseY(g);
    if (rankDir === "lr" || rankDir === "rl") {
        $ffab96934221be07$var$swapXY(g);
        $ffab96934221be07$var$swapWidthHeight(g);
    }
}
function $ffab96934221be07$var$swapWidthHeight(g) {
    $bqfL5.forEach(g.nodes(), function(v) {
        $ffab96934221be07$var$swapWidthHeightOne(g.node(v));
    });
    $bqfL5.forEach(g.edges(), function(e) {
        $ffab96934221be07$var$swapWidthHeightOne(g.edge(e));
    });
}
function $ffab96934221be07$var$swapWidthHeightOne(attrs) {
    var w = attrs.width;
    attrs.width = attrs.height;
    attrs.height = w;
}
function $ffab96934221be07$var$reverseY(g) {
    $bqfL5.forEach(g.nodes(), function(v) {
        $ffab96934221be07$var$reverseYOne(g.node(v));
    });
    $bqfL5.forEach(g.edges(), function(e) {
        var edge = g.edge(e);
        $bqfL5.forEach(edge.points, $ffab96934221be07$var$reverseYOne);
        if ($bqfL5.has(edge, "y")) $ffab96934221be07$var$reverseYOne(edge);
    });
}
function $ffab96934221be07$var$reverseYOne(attrs) {
    attrs.y = -attrs.y;
}
function $ffab96934221be07$var$swapXY(g) {
    $bqfL5.forEach(g.nodes(), function(v) {
        $ffab96934221be07$var$swapXYOne(g.node(v));
    });
    $bqfL5.forEach(g.edges(), function(e) {
        var edge = g.edge(e);
        $bqfL5.forEach(edge.points, $ffab96934221be07$var$swapXYOne);
        if ($bqfL5.has(edge, "x")) $ffab96934221be07$var$swapXYOne(edge);
    });
}
function $ffab96934221be07$var$swapXYOne(attrs) {
    var x = attrs.x;
    attrs.x = attrs.y;
    attrs.y = x;
}

});

parcelRegister("3dyGB", function(module, exports) {
"use strict";

var $bqfL5 = parcelRequire("bqfL5");

var $7H72Y = parcelRequire("7H72Y");

var $lesrU = parcelRequire("lesrU");

var $3CKyT = parcelRequire("3CKyT");

var $lvOrT = parcelRequire("lvOrT");

var $7mMpT = parcelRequire("7mMpT");

var $6mwJ2 = parcelRequire("6mwJ2");
var $257d7deb0180286c$require$Graph = $6mwJ2.Graph;

var $1kMKg = parcelRequire("1kMKg");
module.exports = $257d7deb0180286c$var$order;
/*
 * Applies heuristics to minimize edge crossings in the graph and sets the best
 * order solution as an order attribute on each node.
 *
 * Pre-conditions:
 *
 *    1. Graph must be DAG
 *    2. Graph nodes must be objects with a "rank" attribute
 *    3. Graph edges must have the "weight" attribute
 *
 * Post-conditions:
 *
 *    1. Graph nodes will have an "order" attribute based on the results of the
 *       algorithm.
 */ function $257d7deb0180286c$var$order(g) {
    var maxRank = $1kMKg.maxRank(g), downLayerGraphs = $257d7deb0180286c$var$buildLayerGraphs(g, $bqfL5.range(1, maxRank + 1), "inEdges"), upLayerGraphs = $257d7deb0180286c$var$buildLayerGraphs(g, $bqfL5.range(maxRank - 1, -1, -1), "outEdges");
    var layering = $7H72Y(g);
    $257d7deb0180286c$var$assignOrder(g, layering);
    var bestCC = Number.POSITIVE_INFINITY, best;
    for(var i = 0, lastBest = 0; lastBest < 4; ++i, ++lastBest){
        $257d7deb0180286c$var$sweepLayerGraphs(i % 2 ? downLayerGraphs : upLayerGraphs, i % 4 >= 2);
        layering = $1kMKg.buildLayerMatrix(g);
        var cc = $lesrU(g, layering);
        if (cc < bestCC) {
            lastBest = 0;
            best = $bqfL5.cloneDeep(layering);
            bestCC = cc;
        }
    }
    $257d7deb0180286c$var$assignOrder(g, best);
}
function $257d7deb0180286c$var$buildLayerGraphs(g, ranks, relationship) {
    return $bqfL5.map(ranks, function(rank) {
        return $lvOrT(g, rank, relationship);
    });
}
function $257d7deb0180286c$var$sweepLayerGraphs(layerGraphs, biasRight) {
    var cg = new $257d7deb0180286c$require$Graph();
    $bqfL5.forEach(layerGraphs, function(lg) {
        var root = lg.graph().root;
        var sorted = $3CKyT(lg, root, cg, biasRight);
        $bqfL5.forEach(sorted.vs, function(v, i) {
            lg.node(v).order = i;
        });
        $7mMpT(lg, cg, sorted.vs);
    });
}
function $257d7deb0180286c$var$assignOrder(g, layering) {
    $bqfL5.forEach(layering, function(layer) {
        $bqfL5.forEach(layer, function(v, i) {
            g.node(v).order = i;
        });
    });
}

});
parcelRegister("7H72Y", function(module, exports) {
"use strict";

var $bqfL5 = parcelRequire("bqfL5");
module.exports = $59a203f227f1c21c$var$initOrder;
/*
 * Assigns an initial order value for each node by performing a DFS search
 * starting from nodes in the first rank. Nodes are assigned an order in their
 * rank as they are first visited.
 *
 * This approach comes from Gansner, et al., "A Technique for Drawing Directed
 * Graphs."
 *
 * Returns a layering matrix with an array per layer and each layer sorted by
 * the order of its nodes.
 */ function $59a203f227f1c21c$var$initOrder(g) {
    var visited = {};
    var simpleNodes = $bqfL5.filter(g.nodes(), function(v) {
        return !g.children(v).length;
    });
    var maxRank = $bqfL5.max($bqfL5.map(simpleNodes, function(v) {
        return g.node(v).rank;
    }));
    var layers = $bqfL5.map($bqfL5.range(maxRank + 1), function() {
        return [];
    });
    function dfs(v) {
        if ($bqfL5.has(visited, v)) return;
        visited[v] = true;
        var node = g.node(v);
        layers[node.rank].push(v);
        $bqfL5.forEach(g.successors(v), dfs);
    }
    var orderedVs = $bqfL5.sortBy(simpleNodes, function(v) {
        return g.node(v).rank;
    });
    $bqfL5.forEach(orderedVs, dfs);
    return layers;
}

});

parcelRegister("lesrU", function(module, exports) {
"use strict";

var $bqfL5 = parcelRequire("bqfL5");
module.exports = $f750f92bb92fe0f2$var$crossCount;
/*
 * A function that takes a layering (an array of layers, each with an array of
 * ordererd nodes) and a graph and returns a weighted crossing count.
 *
 * Pre-conditions:
 *
 *    1. Input graph must be simple (not a multigraph), directed, and include
 *       only simple edges.
 *    2. Edges in the input graph must have assigned weights.
 *
 * Post-conditions:
 *
 *    1. The graph and layering matrix are left unchanged.
 *
 * This algorithm is derived from Barth, et al., "Bilayer Cross Counting."
 */ function $f750f92bb92fe0f2$var$crossCount(g, layering) {
    var cc = 0;
    for(var i = 1; i < layering.length; ++i)cc += $f750f92bb92fe0f2$var$twoLayerCrossCount(g, layering[i - 1], layering[i]);
    return cc;
}
function $f750f92bb92fe0f2$var$twoLayerCrossCount(g, northLayer, southLayer) {
    // Sort all of the edges between the north and south layers by their position
    // in the north layer and then the south. Map these edges to the position of
    // their head in the south layer.
    var southPos = $bqfL5.zipObject(southLayer, $bqfL5.map(southLayer, function(v, i) {
        return i;
    }));
    var southEntries = $bqfL5.flatten($bqfL5.map(northLayer, function(v) {
        return $bqfL5.sortBy($bqfL5.map(g.outEdges(v), function(e) {
            return {
                pos: southPos[e.w],
                weight: g.edge(e).weight
            };
        }), "pos");
    }), true);
    // Build the accumulator tree
    var firstIndex = 1;
    while(firstIndex < southLayer.length)firstIndex <<= 1;
    var treeSize = 2 * firstIndex - 1;
    firstIndex -= 1;
    var tree = $bqfL5.map(new Array(treeSize), function() {
        return 0;
    });
    // Calculate the weighted crossings
    var cc = 0;
    $bqfL5.forEach(southEntries.forEach(function(entry) {
        var index = entry.pos + firstIndex;
        tree[index] += entry.weight;
        var weightSum = 0;
        while(index > 0){
            if (index % 2) weightSum += tree[index + 1];
            index = index - 1 >> 1;
            tree[index] += entry.weight;
        }
        cc += entry.weight * weightSum;
    }));
    return cc;
}

});

parcelRegister("3CKyT", function(module, exports) {

var $bqfL5 = parcelRequire("bqfL5");

var $6dVLr = parcelRequire("6dVLr");

var $7P6no = parcelRequire("7P6no");

var $6WEME = parcelRequire("6WEME");
module.exports = $2a3909eacdbc5484$var$sortSubgraph;
function $2a3909eacdbc5484$var$sortSubgraph(g, v, cg, biasRight) {
    var movable = g.children(v);
    var node = g.node(v);
    var bl = node ? node.borderLeft : undefined;
    var br = node ? node.borderRight : undefined;
    var subgraphs = {};
    if (bl) movable = $bqfL5.filter(movable, function(w) {
        return w !== bl && w !== br;
    });
    var barycenters = $6dVLr(g, movable);
    $bqfL5.forEach(barycenters, function(entry) {
        if (g.children(entry.v).length) {
            var subgraphResult = $2a3909eacdbc5484$var$sortSubgraph(g, entry.v, cg, biasRight);
            subgraphs[entry.v] = subgraphResult;
            if ($bqfL5.has(subgraphResult, "barycenter")) $2a3909eacdbc5484$var$mergeBarycenters(entry, subgraphResult);
        }
    });
    var entries = $7P6no(barycenters, cg);
    $2a3909eacdbc5484$var$expandSubgraphs(entries, subgraphs);
    var result = $6WEME(entries, biasRight);
    if (bl) {
        result.vs = $bqfL5.flatten([
            bl,
            result.vs,
            br
        ], true);
        if (g.predecessors(bl).length) {
            var blPred = g.node(g.predecessors(bl)[0]), brPred = g.node(g.predecessors(br)[0]);
            if (!$bqfL5.has(result, "barycenter")) {
                result.barycenter = 0;
                result.weight = 0;
            }
            result.barycenter = (result.barycenter * result.weight + blPred.order + brPred.order) / (result.weight + 2);
            result.weight += 2;
        }
    }
    return result;
}
function $2a3909eacdbc5484$var$expandSubgraphs(entries, subgraphs) {
    $bqfL5.forEach(entries, function(entry) {
        entry.vs = $bqfL5.flatten(entry.vs.map(function(v) {
            if (subgraphs[v]) return subgraphs[v].vs;
            return v;
        }), true);
    });
}
function $2a3909eacdbc5484$var$mergeBarycenters(target, other) {
    if (!$bqfL5.isUndefined(target.barycenter)) {
        target.barycenter = (target.barycenter * target.weight + other.barycenter * other.weight) / (target.weight + other.weight);
        target.weight += other.weight;
    } else {
        target.barycenter = other.barycenter;
        target.weight = other.weight;
    }
}

});
parcelRegister("6dVLr", function(module, exports) {

var $bqfL5 = parcelRequire("bqfL5");
module.exports = $4880c3b846cacbd2$var$barycenter;
function $4880c3b846cacbd2$var$barycenter(g, movable) {
    return $bqfL5.map(movable, function(v) {
        var inV = g.inEdges(v);
        if (!inV.length) return {
            v: v
        };
        else {
            var result = $bqfL5.reduce(inV, function(acc, e) {
                var edge = g.edge(e), nodeU = g.node(e.v);
                return {
                    sum: acc.sum + edge.weight * nodeU.order,
                    weight: acc.weight + edge.weight
                };
            }, {
                sum: 0,
                weight: 0
            });
            return {
                v: v,
                barycenter: result.sum / result.weight,
                weight: result.weight
            };
        }
    });
}

});

parcelRegister("7P6no", function(module, exports) {
"use strict";

var $bqfL5 = parcelRequire("bqfL5");
module.exports = $5b223e00506bc319$var$resolveConflicts;
/*
 * Given a list of entries of the form {v, barycenter, weight} and a
 * constraint graph this function will resolve any conflicts between the
 * constraint graph and the barycenters for the entries. If the barycenters for
 * an entry would violate a constraint in the constraint graph then we coalesce
 * the nodes in the conflict into a new node that respects the contraint and
 * aggregates barycenter and weight information.
 *
 * This implementation is based on the description in Forster, "A Fast and
 * Simple Hueristic for Constrained Two-Level Crossing Reduction," thought it
 * differs in some specific details.
 *
 * Pre-conditions:
 *
 *    1. Each entry has the form {v, barycenter, weight}, or if the node has
 *       no barycenter, then {v}.
 *
 * Returns:
 *
 *    A new list of entries of the form {vs, i, barycenter, weight}. The list
 *    `vs` may either be a singleton or it may be an aggregation of nodes
 *    ordered such that they do not violate constraints from the constraint
 *    graph. The property `i` is the lowest original index of any of the
 *    elements in `vs`.
 */ function $5b223e00506bc319$var$resolveConflicts(entries, cg) {
    var mappedEntries = {};
    $bqfL5.forEach(entries, function(entry, i) {
        var tmp = mappedEntries[entry.v] = {
            indegree: 0,
            "in": [],
            out: [],
            vs: [
                entry.v
            ],
            i: i
        };
        if (!$bqfL5.isUndefined(entry.barycenter)) {
            tmp.barycenter = entry.barycenter;
            tmp.weight = entry.weight;
        }
    });
    $bqfL5.forEach(cg.edges(), function(e) {
        var entryV = mappedEntries[e.v];
        var entryW = mappedEntries[e.w];
        if (!$bqfL5.isUndefined(entryV) && !$bqfL5.isUndefined(entryW)) {
            entryW.indegree++;
            entryV.out.push(mappedEntries[e.w]);
        }
    });
    var sourceSet = $bqfL5.filter(mappedEntries, function(entry) {
        return !entry.indegree;
    });
    return $5b223e00506bc319$var$doResolveConflicts(sourceSet);
}
function $5b223e00506bc319$var$doResolveConflicts(sourceSet) {
    var entries = [];
    function handleIn(vEntry) {
        return function(uEntry) {
            if (uEntry.merged) return;
            if ($bqfL5.isUndefined(uEntry.barycenter) || $bqfL5.isUndefined(vEntry.barycenter) || uEntry.barycenter >= vEntry.barycenter) $5b223e00506bc319$var$mergeEntries(vEntry, uEntry);
        };
    }
    function handleOut(vEntry) {
        return function(wEntry) {
            wEntry["in"].push(vEntry);
            if (--wEntry.indegree === 0) sourceSet.push(wEntry);
        };
    }
    while(sourceSet.length){
        var entry = sourceSet.pop();
        entries.push(entry);
        $bqfL5.forEach(entry["in"].reverse(), handleIn(entry));
        $bqfL5.forEach(entry.out, handleOut(entry));
    }
    return $bqfL5.map($bqfL5.filter(entries, function(entry) {
        return !entry.merged;
    }), function(entry) {
        return $bqfL5.pick(entry, [
            "vs",
            "i",
            "barycenter",
            "weight"
        ]);
    });
}
function $5b223e00506bc319$var$mergeEntries(target, source) {
    var sum = 0;
    var weight = 0;
    if (target.weight) {
        sum += target.barycenter * target.weight;
        weight += target.weight;
    }
    if (source.weight) {
        sum += source.barycenter * source.weight;
        weight += source.weight;
    }
    target.vs = source.vs.concat(target.vs);
    target.barycenter = sum / weight;
    target.weight = weight;
    target.i = Math.min(source.i, target.i);
    source.merged = true;
}

});

parcelRegister("6WEME", function(module, exports) {

var $bqfL5 = parcelRequire("bqfL5");

var $1kMKg = parcelRequire("1kMKg");
module.exports = $50e7cbac5d0d1447$var$sort;
function $50e7cbac5d0d1447$var$sort(entries, biasRight) {
    var parts = $1kMKg.partition(entries, function(entry) {
        return $bqfL5.has(entry, "barycenter");
    });
    var sortable = parts.lhs, unsortable = $bqfL5.sortBy(parts.rhs, function(entry) {
        return -entry.i;
    }), vs = [], sum = 0, weight = 0, vsIndex = 0;
    sortable.sort($50e7cbac5d0d1447$var$compareWithBias(!!biasRight));
    vsIndex = $50e7cbac5d0d1447$var$consumeUnsortable(vs, unsortable, vsIndex);
    $bqfL5.forEach(sortable, function(entry) {
        vsIndex += entry.vs.length;
        vs.push(entry.vs);
        sum += entry.barycenter * entry.weight;
        weight += entry.weight;
        vsIndex = $50e7cbac5d0d1447$var$consumeUnsortable(vs, unsortable, vsIndex);
    });
    var result = {
        vs: $bqfL5.flatten(vs, true)
    };
    if (weight) {
        result.barycenter = sum / weight;
        result.weight = weight;
    }
    return result;
}
function $50e7cbac5d0d1447$var$consumeUnsortable(vs, unsortable, index) {
    var last;
    while(unsortable.length && (last = $bqfL5.last(unsortable)).i <= index){
        unsortable.pop();
        vs.push(last.vs);
        index++;
    }
    return index;
}
function $50e7cbac5d0d1447$var$compareWithBias(bias) {
    return function(entryV, entryW) {
        if (entryV.barycenter < entryW.barycenter) return -1;
        else if (entryV.barycenter > entryW.barycenter) return 1;
        return !bias ? entryV.i - entryW.i : entryW.i - entryV.i;
    };
}

});


parcelRegister("lvOrT", function(module, exports) {

var $bqfL5 = parcelRequire("bqfL5");

var $6mwJ2 = parcelRequire("6mwJ2");
var $fa93a057a2513c66$require$Graph = $6mwJ2.Graph;
module.exports = $fa93a057a2513c66$var$buildLayerGraph;
/*
 * Constructs a graph that can be used to sort a layer of nodes. The graph will
 * contain all base and subgraph nodes from the request layer in their original
 * hierarchy and any edges that are incident on these nodes and are of the type
 * requested by the "relationship" parameter.
 *
 * Nodes from the requested rank that do not have parents are assigned a root
 * node in the output graph, which is set in the root graph attribute. This
 * makes it easy to walk the hierarchy of movable nodes during ordering.
 *
 * Pre-conditions:
 *
 *    1. Input graph is a DAG
 *    2. Base nodes in the input graph have a rank attribute
 *    3. Subgraph nodes in the input graph has minRank and maxRank attributes
 *    4. Edges have an assigned weight
 *
 * Post-conditions:
 *
 *    1. Output graph has all nodes in the movable rank with preserved
 *       hierarchy.
 *    2. Root nodes in the movable layer are made children of the node
 *       indicated by the root attribute of the graph.
 *    3. Non-movable nodes incident on movable nodes, selected by the
 *       relationship parameter, are included in the graph (without hierarchy).
 *    4. Edges incident on movable nodes, selected by the relationship
 *       parameter, are added to the output graph.
 *    5. The weights for copied edges are aggregated as need, since the output
 *       graph is not a multi-graph.
 */ function $fa93a057a2513c66$var$buildLayerGraph(g, rank, relationship) {
    var root = $fa93a057a2513c66$var$createRootNode(g), result = new $fa93a057a2513c66$require$Graph({
        compound: true
    }).setGraph({
        root: root
    }).setDefaultNodeLabel(function(v) {
        return g.node(v);
    });
    $bqfL5.forEach(g.nodes(), function(v) {
        var node = g.node(v), parent = g.parent(v);
        if (node.rank === rank || node.minRank <= rank && rank <= node.maxRank) {
            result.setNode(v);
            result.setParent(v, parent || root);
            // This assumes we have only short edges!
            $bqfL5.forEach(g[relationship](v), function(e) {
                var u = e.v === v ? e.w : e.v, edge = result.edge(u, v), weight = !$bqfL5.isUndefined(edge) ? edge.weight : 0;
                result.setEdge(u, v, {
                    weight: g.edge(e).weight + weight
                });
            });
            if ($bqfL5.has(node, "minRank")) result.setNode(v, {
                borderLeft: node.borderLeft[rank],
                borderRight: node.borderRight[rank]
            });
        }
    });
    return result;
}
function $fa93a057a2513c66$var$createRootNode(g) {
    var v;
    while(g.hasNode(v = $bqfL5.uniqueId("_root")));
    return v;
}

});

parcelRegister("7mMpT", function(module, exports) {

var $bqfL5 = parcelRequire("bqfL5");
module.exports = $55d025054c74605a$var$addSubgraphConstraints;
function $55d025054c74605a$var$addSubgraphConstraints(g, cg, vs) {
    var prev = {}, rootPrev;
    $bqfL5.forEach(vs, function(v) {
        var child = g.parent(v), parent, prevChild;
        while(child){
            parent = g.parent(child);
            if (parent) {
                prevChild = prev[parent];
                prev[parent] = child;
            } else {
                prevChild = rootPrev;
                rootPrev = child;
            }
            if (prevChild && prevChild !== child) {
                cg.setEdge(prevChild, child);
                return;
            }
            child = parent;
        }
    });
/*
  function dfs(v) {
    var children = v ? g.children(v) : g.children();
    if (children.length) {
      var min = Number.POSITIVE_INFINITY,
          subgraphs = [];
      _.each(children, function(child) {
        var childMin = dfs(child);
        if (g.children(child).length) {
          subgraphs.push({ v: child, order: childMin });
        }
        min = Math.min(min, childMin);
      });
      _.reduce(_.sortBy(subgraphs, "order"), function(prev, curr) {
        cg.setEdge(prev.v, curr.v);
        return curr;
      });
      return min;
    }
    return g.node(v).order;
  }
  dfs(undefined);
  */ }

});


parcelRegister("j257S", function(module, exports) {
"use strict";

var $bqfL5 = parcelRequire("bqfL5");

var $1kMKg = parcelRequire("1kMKg");

var $94mUQ = parcelRequire("94mUQ");
var $ddb22e2223075eef$require$positionX = $94mUQ.positionX;
module.exports = $ddb22e2223075eef$var$position;
function $ddb22e2223075eef$var$position(g) {
    g = $1kMKg.asNonCompoundGraph(g);
    $ddb22e2223075eef$var$positionY(g);
    $bqfL5.forEach($ddb22e2223075eef$require$positionX(g), function(x, v) {
        g.node(v).x = x;
    });
}
function $ddb22e2223075eef$var$positionY(g) {
    var layering = $1kMKg.buildLayerMatrix(g);
    var rankSep = g.graph().ranksep;
    var prevY = 0;
    $bqfL5.forEach(layering, function(layer) {
        var maxHeight = $bqfL5.max($bqfL5.map(layer, function(v) {
            return g.node(v).height;
        }));
        $bqfL5.forEach(layer, function(v) {
            g.node(v).y = prevY + maxHeight / 2;
        });
        prevY += maxHeight + rankSep;
    });
}

});
parcelRegister("94mUQ", function(module, exports) {
"use strict";

var $bqfL5 = parcelRequire("bqfL5");

var $6mwJ2 = parcelRequire("6mwJ2");
var $69a6435f926c5c17$require$Graph = $6mwJ2.Graph;

var $1kMKg = parcelRequire("1kMKg");
/*
 * This module provides coordinate assignment based on Brandes and Köpf, "Fast
 * and Simple Horizontal Coordinate Assignment."
 */ module.exports = {
    positionX: $69a6435f926c5c17$var$positionX,
    findType1Conflicts: $69a6435f926c5c17$var$findType1Conflicts,
    findType2Conflicts: $69a6435f926c5c17$var$findType2Conflicts,
    addConflict: $69a6435f926c5c17$var$addConflict,
    hasConflict: $69a6435f926c5c17$var$hasConflict,
    verticalAlignment: $69a6435f926c5c17$var$verticalAlignment,
    horizontalCompaction: $69a6435f926c5c17$var$horizontalCompaction,
    alignCoordinates: $69a6435f926c5c17$var$alignCoordinates,
    findSmallestWidthAlignment: $69a6435f926c5c17$var$findSmallestWidthAlignment,
    balance: $69a6435f926c5c17$var$balance
};
/*
 * Marks all edges in the graph with a type-1 conflict with the "type1Conflict"
 * property. A type-1 conflict is one where a non-inner segment crosses an
 * inner segment. An inner segment is an edge with both incident nodes marked
 * with the "dummy" property.
 *
 * This algorithm scans layer by layer, starting with the second, for type-1
 * conflicts between the current layer and the previous layer. For each layer
 * it scans the nodes from left to right until it reaches one that is incident
 * on an inner segment. It then scans predecessors to determine if they have
 * edges that cross that inner segment. At the end a final scan is done for all
 * nodes on the current rank to see if they cross the last visited inner
 * segment.
 *
 * This algorithm (safely) assumes that a dummy node will only be incident on a
 * single node in the layers being scanned.
 */ function $69a6435f926c5c17$var$findType1Conflicts(g, layering) {
    var conflicts = {};
    function visitLayer(prevLayer, layer) {
        var // last visited node in the previous layer that is incident on an inner
        // segment.
        k0 = 0, // Tracks the last node in this layer scanned for crossings with a type-1
        // segment.
        scanPos = 0, prevLayerLength = prevLayer.length, lastNode = $bqfL5.last(layer);
        $bqfL5.forEach(layer, function(v, i) {
            var w = $69a6435f926c5c17$var$findOtherInnerSegmentNode(g, v), k1 = w ? g.node(w).order : prevLayerLength;
            if (w || v === lastNode) {
                $bqfL5.forEach(layer.slice(scanPos, i + 1), function(scanNode) {
                    $bqfL5.forEach(g.predecessors(scanNode), function(u) {
                        var uLabel = g.node(u), uPos = uLabel.order;
                        if ((uPos < k0 || k1 < uPos) && !(uLabel.dummy && g.node(scanNode).dummy)) $69a6435f926c5c17$var$addConflict(conflicts, u, scanNode);
                    });
                });
                scanPos = i + 1;
                k0 = k1;
            }
        });
        return layer;
    }
    $bqfL5.reduce(layering, visitLayer);
    return conflicts;
}
function $69a6435f926c5c17$var$findType2Conflicts(g, layering) {
    var conflicts = {};
    function scan(south, southPos, southEnd, prevNorthBorder, nextNorthBorder) {
        var v;
        $bqfL5.forEach($bqfL5.range(southPos, southEnd), function(i) {
            v = south[i];
            if (g.node(v).dummy) $bqfL5.forEach(g.predecessors(v), function(u) {
                var uNode = g.node(u);
                if (uNode.dummy && (uNode.order < prevNorthBorder || uNode.order > nextNorthBorder)) $69a6435f926c5c17$var$addConflict(conflicts, u, v);
            });
        });
    }
    function visitLayer(north, south) {
        var prevNorthPos = -1, nextNorthPos, southPos = 0;
        $bqfL5.forEach(south, function(v, southLookahead) {
            if (g.node(v).dummy === "border") {
                var predecessors = g.predecessors(v);
                if (predecessors.length) {
                    nextNorthPos = g.node(predecessors[0]).order;
                    scan(south, southPos, southLookahead, prevNorthPos, nextNorthPos);
                    southPos = southLookahead;
                    prevNorthPos = nextNorthPos;
                }
            }
            scan(south, southPos, south.length, nextNorthPos, north.length);
        });
        return south;
    }
    $bqfL5.reduce(layering, visitLayer);
    return conflicts;
}
function $69a6435f926c5c17$var$findOtherInnerSegmentNode(g, v) {
    if (g.node(v).dummy) return $bqfL5.find(g.predecessors(v), function(u) {
        return g.node(u).dummy;
    });
}
function $69a6435f926c5c17$var$addConflict(conflicts, v, w) {
    if (v > w) {
        var tmp = v;
        v = w;
        w = tmp;
    }
    var conflictsV = conflicts[v];
    if (!conflictsV) conflicts[v] = conflictsV = {};
    conflictsV[w] = true;
}
function $69a6435f926c5c17$var$hasConflict(conflicts, v, w) {
    if (v > w) {
        var tmp = v;
        v = w;
        w = tmp;
    }
    return $bqfL5.has(conflicts[v], w);
}
/*
 * Try to align nodes into vertical "blocks" where possible. This algorithm
 * attempts to align a node with one of its median neighbors. If the edge
 * connecting a neighbor is a type-1 conflict then we ignore that possibility.
 * If a previous node has already formed a block with a node after the node
 * we're trying to form a block with, we also ignore that possibility - our
 * blocks would be split in that scenario.
 */ function $69a6435f926c5c17$var$verticalAlignment(g, layering, conflicts, neighborFn) {
    var root = {}, align = {}, pos = {};
    // We cache the position here based on the layering because the graph and
    // layering may be out of sync. The layering matrix is manipulated to
    // generate different extreme alignments.
    $bqfL5.forEach(layering, function(layer) {
        $bqfL5.forEach(layer, function(v, order) {
            root[v] = v;
            align[v] = v;
            pos[v] = order;
        });
    });
    $bqfL5.forEach(layering, function(layer) {
        var prevIdx = -1;
        $bqfL5.forEach(layer, function(v) {
            var ws = neighborFn(v);
            if (ws.length) {
                ws = $bqfL5.sortBy(ws, function(w) {
                    return pos[w];
                });
                var mp = (ws.length - 1) / 2;
                for(var i = Math.floor(mp), il = Math.ceil(mp); i <= il; ++i){
                    var w = ws[i];
                    if (align[v] === v && prevIdx < pos[w] && !$69a6435f926c5c17$var$hasConflict(conflicts, v, w)) {
                        align[w] = v;
                        align[v] = root[v] = root[w];
                        prevIdx = pos[w];
                    }
                }
            }
        });
    });
    return {
        root: root,
        align: align
    };
}
function $69a6435f926c5c17$var$horizontalCompaction(g, layering, root, align, reverseSep) {
    // This portion of the algorithm differs from BK due to a number of problems.
    // Instead of their algorithm we construct a new block graph and do two
    // sweeps. The first sweep places blocks with the smallest possible
    // coordinates. The second sweep removes unused space by moving blocks to the
    // greatest coordinates without violating separation.
    var xs = {}, blockG = $69a6435f926c5c17$var$buildBlockGraph(g, layering, root, reverseSep), borderType = reverseSep ? "borderLeft" : "borderRight";
    function iterate(setXsFunc, nextNodesFunc) {
        var stack = blockG.nodes();
        var elem = stack.pop();
        var visited = {};
        while(elem){
            if (visited[elem]) setXsFunc(elem);
            else {
                visited[elem] = true;
                stack.push(elem);
                stack = stack.concat(nextNodesFunc(elem));
            }
            elem = stack.pop();
        }
    }
    // First pass, assign smallest coordinates
    function pass1(elem) {
        xs[elem] = blockG.inEdges(elem).reduce(function(acc, e) {
            return Math.max(acc, xs[e.v] + blockG.edge(e));
        }, 0);
    }
    // Second pass, assign greatest coordinates
    function pass2(elem) {
        var min = blockG.outEdges(elem).reduce(function(acc, e) {
            return Math.min(acc, xs[e.w] - blockG.edge(e));
        }, Number.POSITIVE_INFINITY);
        var node = g.node(elem);
        if (min !== Number.POSITIVE_INFINITY && node.borderType !== borderType) xs[elem] = Math.max(xs[elem], min);
    }
    iterate(pass1, blockG.predecessors.bind(blockG));
    iterate(pass2, blockG.successors.bind(blockG));
    // Assign x coordinates to all nodes
    $bqfL5.forEach(align, function(v) {
        xs[v] = xs[root[v]];
    });
    return xs;
}
function $69a6435f926c5c17$var$buildBlockGraph(g, layering, root, reverseSep) {
    var blockGraph = new $69a6435f926c5c17$require$Graph(), graphLabel = g.graph(), sepFn = $69a6435f926c5c17$var$sep(graphLabel.nodesep, graphLabel.edgesep, reverseSep);
    $bqfL5.forEach(layering, function(layer) {
        var u;
        $bqfL5.forEach(layer, function(v) {
            var vRoot = root[v];
            blockGraph.setNode(vRoot);
            if (u) {
                var uRoot = root[u], prevMax = blockGraph.edge(uRoot, vRoot);
                blockGraph.setEdge(uRoot, vRoot, Math.max(sepFn(g, v, u), prevMax || 0));
            }
            u = v;
        });
    });
    return blockGraph;
}
/*
 * Returns the alignment that has the smallest width of the given alignments.
 */ function $69a6435f926c5c17$var$findSmallestWidthAlignment(g, xss) {
    return $bqfL5.minBy($bqfL5.values(xss), function(xs) {
        var max = Number.NEGATIVE_INFINITY;
        var min = Number.POSITIVE_INFINITY;
        $bqfL5.forIn(xs, function(x, v) {
            var halfWidth = $69a6435f926c5c17$var$width(g, v) / 2;
            max = Math.max(x + halfWidth, max);
            min = Math.min(x - halfWidth, min);
        });
        return max - min;
    });
}
/*
 * Align the coordinates of each of the layout alignments such that
 * left-biased alignments have their minimum coordinate at the same point as
 * the minimum coordinate of the smallest width alignment and right-biased
 * alignments have their maximum coordinate at the same point as the maximum
 * coordinate of the smallest width alignment.
 */ function $69a6435f926c5c17$var$alignCoordinates(xss, alignTo) {
    var alignToVals = $bqfL5.values(alignTo), alignToMin = $bqfL5.min(alignToVals), alignToMax = $bqfL5.max(alignToVals);
    $bqfL5.forEach([
        "u",
        "d"
    ], function(vert) {
        $bqfL5.forEach([
            "l",
            "r"
        ], function(horiz) {
            var alignment = vert + horiz, xs = xss[alignment], delta;
            if (xs === alignTo) return;
            var xsVals = $bqfL5.values(xs);
            delta = horiz === "l" ? alignToMin - $bqfL5.min(xsVals) : alignToMax - $bqfL5.max(xsVals);
            if (delta) xss[alignment] = $bqfL5.mapValues(xs, function(x) {
                return x + delta;
            });
        });
    });
}
function $69a6435f926c5c17$var$balance(xss, align) {
    return $bqfL5.mapValues(xss.ul, function(ignore, v) {
        if (align) return xss[align.toLowerCase()][v];
        else {
            var xs = $bqfL5.sortBy($bqfL5.map(xss, v));
            return (xs[1] + xs[2]) / 2;
        }
    });
}
function $69a6435f926c5c17$var$positionX(g) {
    var layering = $1kMKg.buildLayerMatrix(g);
    var conflicts = $bqfL5.merge($69a6435f926c5c17$var$findType1Conflicts(g, layering), $69a6435f926c5c17$var$findType2Conflicts(g, layering));
    var xss = {};
    var adjustedLayering;
    $bqfL5.forEach([
        "u",
        "d"
    ], function(vert) {
        adjustedLayering = vert === "u" ? layering : $bqfL5.values(layering).reverse();
        $bqfL5.forEach([
            "l",
            "r"
        ], function(horiz) {
            if (horiz === "r") adjustedLayering = $bqfL5.map(adjustedLayering, function(inner) {
                return $bqfL5.values(inner).reverse();
            });
            var neighborFn = (vert === "u" ? g.predecessors : g.successors).bind(g);
            var align = $69a6435f926c5c17$var$verticalAlignment(g, adjustedLayering, conflicts, neighborFn);
            var xs = $69a6435f926c5c17$var$horizontalCompaction(g, adjustedLayering, align.root, align.align, horiz === "r");
            if (horiz === "r") xs = $bqfL5.mapValues(xs, function(x) {
                return -x;
            });
            xss[vert + horiz] = xs;
        });
    });
    var smallestWidth = $69a6435f926c5c17$var$findSmallestWidthAlignment(g, xss);
    $69a6435f926c5c17$var$alignCoordinates(xss, smallestWidth);
    return $69a6435f926c5c17$var$balance(xss, g.graph().align);
}
function $69a6435f926c5c17$var$sep(nodeSep, edgeSep, reverseSep) {
    return function(g, v, w) {
        var vLabel = g.node(v);
        var wLabel = g.node(w);
        var sum = 0;
        var delta;
        sum += vLabel.width / 2;
        if ($bqfL5.has(vLabel, "labelpos")) switch(vLabel.labelpos.toLowerCase()){
            case "l":
                delta = -vLabel.width / 2;
                break;
            case "r":
                delta = vLabel.width / 2;
                break;
        }
        if (delta) sum += reverseSep ? delta : -delta;
        delta = 0;
        sum += (vLabel.dummy ? edgeSep : nodeSep) / 2;
        sum += (wLabel.dummy ? edgeSep : nodeSep) / 2;
        sum += wLabel.width / 2;
        if ($bqfL5.has(wLabel, "labelpos")) switch(wLabel.labelpos.toLowerCase()){
            case "l":
                delta = wLabel.width / 2;
                break;
            case "r":
                delta = -wLabel.width / 2;
                break;
        }
        if (delta) sum += reverseSep ? delta : -delta;
        delta = 0;
        return sum;
    };
}
function $69a6435f926c5c17$var$width(g, v) {
    return g.node(v).width;
}

});



parcelRegister("8XBdx", function(module, exports) {

var $bqfL5 = parcelRequire("bqfL5");

var $1kMKg = parcelRequire("1kMKg");

var $6mwJ2 = parcelRequire("6mwJ2");
var $6860b4009ab03a40$require$Graph = $6mwJ2.Graph;
module.exports = {
    debugOrdering: $6860b4009ab03a40$var$debugOrdering
};
/* istanbul ignore next */ function $6860b4009ab03a40$var$debugOrdering(g) {
    var layerMatrix = $1kMKg.buildLayerMatrix(g);
    var h = new $6860b4009ab03a40$require$Graph({
        compound: true,
        multigraph: true
    }).setGraph({});
    $bqfL5.forEach(g.nodes(), function(v) {
        h.setNode(v, {
            label: v
        });
        h.setParent(v, "layer" + g.node(v).rank);
    });
    $bqfL5.forEach(g.edges(), function(e) {
        h.setEdge(e.v, e.w, {}, e.name);
    });
    $bqfL5.forEach(layerMatrix, function(layer, i) {
        var layerV = "layer" + i;
        h.setNode(layerV, {
            rank: "same"
        });
        $bqfL5.reduce(layer, function(u, v) {
            h.setEdge(u, v, {
                style: "invis"
            });
            return v;
        });
    });
    return h;
}

});

parcelRegister("9Grre", function(module, exports) {
module.exports = "0.8.5";

});



parcelRegister("5YqKr", function(module, exports) {

$parcel$export(module.exports, "default", () => $011f57f785a25e0d$export$2e2bcd8739ae039);

var $6xYJF = parcelRequire("6xYJF");
function $011f57f785a25e0d$export$2e2bcd8739ae039(cytoscape) {
    cytoscape("layout", "tidytree", (0, $6xYJF.CyLayout));
}
if (typeof window.cytoscape !== "undefined") $011f57f785a25e0d$export$2e2bcd8739ae039(window.cytoscape);

});
parcelRegister("6xYJF", function(module, exports) {

$parcel$export(module.exports, "CyLayout", () => $4c44eff53bb479ff$export$5a3891e443a6cc35);

var $9f5MY = parcelRequire("9f5MY");
class $4c44eff53bb479ff$var$DefaultOptions {
    //** Needed to for the layout to be called from cytoscape */
    name = "tidytree";
    /**
     * Specific layout options
     */ dataOnly = false;
    horizontalSpacing = 20;
    verticalSpacing = 40;
    direction = "TB";
    // a map from node's id to how much space should be added between it and its parent
    extraVerticalSpacings = {};
    // a map from node's id to how much space should be added for the node to have this y position
    // overrides extraVerticalSpacings if both are set for a particular node
    // if the y position would result in the child not being below the parent, the setting is ignored and a warning is printed
    customYs = {};
    // the width of the space left after a node is moved down
    lineWidth = 5;
    // forces nodes to be positioned on multiples of this value if set
    layerHeight = undefined;
    // a sorting function for the children array of the tree representation
    // if undefined, the order is based on the order of the collection the layout was called on
    edgeComparator = undefined;
    // when not changed, the width and height of each node is read directly from the node
    // this parameter allows to supply your own sizes
    // if the h or w property is missing from the returned object, it is taken from the node
    sizeGetter = ()=>({});
    /**
     * Layout options passed to nodes.layoutPositions()
     * https://js.cytoscape.org/#nodes.layoutPositions
     */ fit = true;
    padding = 30;
    pan = undefined;
    zoom = undefined;
    // a positive value which adjusts spacing between nodes (>1 means greater than usual spacing)
    spacingFactor = 1;
    // allows to transform a given node's position before it is applied
    transform = (n, p)=>p;
    animate = false;
    animationDuration = 500;
    animationEasing = undefined;
    // returns true for nodes that should be animated, or false when the position should be set immediately
    animateFilter = ()=>true;
    ready = undefined;
    stop = undefined;
    /**
     * Layout options passed to nodes.node.layoutDimensions()
     * https://js.cytoscape.org/#node.layoutDimensions
     */ nodeDimensionsIncludeLabels = true;
}
function $4c44eff53bb479ff$export$5a3891e443a6cc35(options) {
    this.options = {
        ...new $4c44eff53bb479ff$var$DefaultOptions(),
        ...options
    };
}
// eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
$4c44eff53bb479ff$export$5a3891e443a6cc35.prototype.createTreeData = function() {
    const includeLabels = this.options.nodeDimensionsIncludeLabels ?? true;
    const eles = this.options.eles;
    const ys = this.options.customYs;
    const vertSpaces = this.options.extraVerticalSpacings;
    const roots = new Set();
    for (const node of eles.nodes()){
        const dims = {
            ...node.layoutDimensions({
                nodeDimensionsIncludeLabels: includeLabels
            }),
            ...this.options.sizeGetter(node)
        };
        if (this.options.direction === "LR" || this.options.direction === "RL") [dims.w, dims.h] = [
            dims.h,
            dims.w
        ];
        const data = {
            id: node.id(),
            w: dims.w,
            h: dims.h,
            children: [],
            extraVerticalSpacing: vertSpaces[node.id()],
            customY: ys[node.id()] === undefined ? undefined : ys[node.id()] - dims.h / 2
        };
        node.scratch("tidytree", data);
        roots.add(data);
    }
    const comp = this.options.edgeComparator;
    const edges = comp === undefined ? eles.edges() : eles.edges().sort(comp);
    for (const edge of edges){
        const sourceData = edge.source().scratch("tidytree");
        const targetData = edge.target().scratch("tidytree");
        // ignore the edge if target already has a parent
        if (roots.has(targetData)) {
            sourceData.children.push(targetData);
            roots.delete(targetData);
        }
    }
    // if there are no roots, choose the first node as the root
    if (roots.size === 0) {
        const fakeRoot = eles.nodes().first();
        const rootData = fakeRoot.scratch("tidytree");
        roots.add(rootData);
        // remove root from its parent's children list
        for (const parent of fakeRoot.incomers("node")){
            const sourceData = parent.scratch("tidytree");
            const i = sourceData.children.indexOf(rootData);
            if (i !== -1) sourceData.children.splice(i, 1);
        }
    }
    const newRoot = {
        w: 0,
        h: 0,
        children: Array.from(roots),
        customY: Math.min(-this.options.verticalSpacing, -(this.options.layerHeight ?? 0))
    };
    return newRoot;
};
// eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
$4c44eff53bb479ff$export$5a3891e443a6cc35.prototype.run = function() {
    const treeData = this.createTreeData();
    const tree = new (0, $9f5MY.Layout)(this.options).run(treeData);
    const nodes = this.options.eles.nodes();
    if (!this.options.dataOnly) // casts because of wrong types in @types/cytoscape
    // - first argument should be the layout object, not string
    // - LayoutPositionOptions' "ready" and "stop" properties should be callback functions, not undefined
    nodes.layoutPositions(this, this.options, (node)=>{
        const data = node.scratch("tidytree");
        const pos = {
            x: data.x + data.w / 2,
            y: data.y + data.h / 2
        };
        if (this.options.direction === "LR" || this.options.direction === "RL") [pos.x, pos.y] = [
            pos.y,
            pos.x
        ];
        if (this.options.direction === "BT") pos.y = -pos.y;
        if (this.options.direction === "RL") pos.x = -pos.x;
        return pos;
    });
    return {
        treeData: treeData,
        tree: tree
    };
};

});
parcelRegister("9f5MY", function(module, exports) {

$parcel$export(module.exports, "Layout", () => $6baa015302108bf6$export$c84671f46d6a1ca);

var $fz84O = parcelRequire("fz84O");
class $6baa015302108bf6$export$c84671f46d6a1ca {
    options;
    constructor(options){
        this.options = {
            horizontalSpacing: 10,
            verticalSpacing: 20,
            lineWidth: 3,
            layerHeight: undefined,
            ...options
        };
    }
    run(data) {
        const tree = this.makeTree(data, data.customY);
        tree.layout();
        this.setLayoutResult(data, tree);
        return tree;
    }
    makeTree(data, root_y = 0) {
        const outerWidth = data.w + this.options.horizontalSpacing;
        let outerHeight = data.h + this.options.verticalSpacing;
        let extraSpacing = data.extraVerticalSpacing ?? 0;
        const layerHeight = this.options.layerHeight;
        if (layerHeight !== undefined) {
            outerHeight = Math.ceil(outerHeight / layerHeight) * layerHeight;
            extraSpacing = Math.round(extraSpacing / layerHeight) * layerHeight;
        }
        if (data.customY !== undefined) {
            extraSpacing = data.customY - root_y;
            data.y = root_y + extraSpacing;
        }
        data.y = root_y + extraSpacing;
        const vertex = new (0, $fz84O.Tree)(outerWidth, outerHeight, data.y, data.children.map((child)=>this.makeTree(child, data.y + outerHeight)));
        if (extraSpacing < 0) console.warn("Node has negative extra space, ignoring", data);
        if (extraSpacing > 0) return new (0, $fz84O.Tree)(this.options.lineWidth, extraSpacing, root_y, [
            vertex
        ], true);
        return vertex;
    }
    setLayoutResult(data, tree) {
        if (tree.isExtra) tree = tree.c[0];
        data.x = tree.x + this.options.horizontalSpacing / 2;
        data.children.forEach((child, i)=>this.setLayoutResult(child, tree.c[i]));
    }
}

});
parcelRegister("fz84O", function(module, exports) {

$parcel$export(module.exports, "Tree", () => $b55063b90ed6007e$export$7fbedc92909ed28e);
// A linked list of the indexes of left siblings and their lowest vertical coordinate.
class $b55063b90ed6007e$var$IYL {
    lowY;
    index;
    nxt;
    constructor(lowY, index, nxt){
        this.lowY = lowY;
        this.index = index;
        this.nxt = nxt;
    }
    static updateIYL(minY, i, ih) {
        // Remove siblings that are hidden by the new subtree.
        while(ih != undefined && minY >= ih.lowY)ih = ih.nxt;
        // Prepend the new subtree.
        return new $b55063b90ed6007e$var$IYL(minY, i, ih);
    }
}
class $b55063b90ed6007e$export$7fbedc92909ed28e {
    isExtra;
    w;
    h;
    x;
    y;
    c;
    prelim = 0;
    mod = 0;
    shift = 0;
    change = 0;
    tl;
    tr;
    el;
    er;
    msel;
    mser;
    constructor(w, h, y, c, isExtra = false){
        this.w = w;
        this.h = h;
        this.y = y;
        this.c = c;
        this.isExtra = isExtra;
    }
    layout() {
        this.firstWalk();
        this.secondWalk(0);
    }
    firstWalk() {
        if (this.c.length == 0) {
            this.setExtremes();
            return;
        }
        this.c[0].firstWalk();
        // Create siblings in contour minimal vertical coordinate and index list.
        let ih = $b55063b90ed6007e$var$IYL.updateIYL(this.c[0].el.bottom(), 0, undefined);
        for(let i = 1; i < this.c.length; i++){
            this.c[i].firstWalk();
            //Store lowest vertical coordinate while extreme nodes still point in current subtree.
            const minY = this.c[i].er.bottom();
            this.separate(i, ih);
            ih = $b55063b90ed6007e$var$IYL.updateIYL(minY, i, ih);
        }
        this.positionRoot();
        this.setExtremes();
    }
    setExtremes() {
        if (this.c.length == 0) {
            this.el = this;
            this.er = this;
            this.msel = this.mser = 0;
        } else {
            this.el = this.c[0].el;
            this.msel = this.c[0].msel;
            this.er = this.c[this.c.length - 1].er;
            this.mser = this.c[this.c.length - 1].mser;
        }
    }
    separate(i, ih) {
        // Right contour node of left siblings and its sum of modfiers.
        let sr = this.c[i - 1];
        let mssr = sr.mod;
        // Left contour node of current subtree and its sum of modfiers.
        let cl = this.c[i];
        let mscl = cl.mod;
        // Modification to the algorithm: correctly lay out the first child if it has no children
        let first = true;
        while(sr !== undefined && cl !== undefined){
            if (sr.bottom() > ih.lowY) ih = ih.nxt;
            // How far to the left of the right side of sr is the left side of cl?
            const dist = mssr + sr.prelim + sr.w - (mscl + cl.prelim);
            if (dist > 0 || first && dist <= 0) {
                mscl += dist;
                this.moveSubtree(i, ih.index, dist);
            }
            first = false;
            const sy = sr.bottom(), cy = cl.bottom();
            // Advance highest node(s) and sum(s) of modifiers (Coordinate system increases downwards)
            if (sy <= cy) {
                sr = sr.nextRightContour();
                if (sr !== undefined) mssr += sr.mod;
            }
            if (sy >= cy) {
                cl = cl.nextLeftContour();
                if (cl !== undefined) mscl += cl.mod;
            }
        }
        // Set threads and update extreme nodes.
        // In the first case, the current subtree must be taller than the left siblings.
        if (sr == undefined && cl != undefined) this.setLeftThread(i, cl, mscl);
        else if (sr != undefined && cl == undefined) this.setRightThread(i, sr, mssr);
    }
    moveSubtree(i, si, dist) {
        // Move subtree by changing mod.
        this.c[i].mod += dist;
        this.c[i].msel += dist;
        this.c[i].mser += dist;
        this.distributeExtra(i, si, dist);
    }
    nextLeftContour() {
        return this.c.length == 0 ? this.tl : this.c[0];
    }
    nextRightContour() {
        return this.c.length == 0 ? this.tr : this.c[this.c.length - 1];
    }
    bottom() {
        return this.y + this.h;
    }
    setLeftThread(i, cl, modsumcl) {
        const li = this.c[0].el;
        li.tl = cl;
        // Change mod so that the sum of modifier after following thread is correct.
        const diff = modsumcl - cl.mod - this.c[0].msel;
        li.mod += diff;
        // Change preliminary x coordinate so that the node does not move.
        li.prelim -= diff;
        // Update extreme node and its sum of modifiers.
        this.c[0].el = this.c[i].el;
        this.c[0].msel = this.c[i].msel;
    }
    // Symmetrical to setLeftThread.
    setRightThread(i, sr, modsumsr) {
        const ri = this.c[i].er;
        ri.tr = sr;
        const diff = modsumsr - sr.mod - this.c[i].mser;
        ri.mod += diff;
        ri.prelim -= diff;
        this.c[i].er = this.c[i - 1].er;
        this.c[i].mser = this.c[i - 1].mser;
    }
    positionRoot() {
        // Position root between children, taking into account their mod.
        this.prelim = (this.c[0].prelim + this.c[0].mod + this.c[this.c.length - 1].mod + this.c[this.c.length - 1].prelim + this.c[this.c.length - 1].w) / 2 - this.w / 2;
    }
    secondWalk(modsum) {
        modsum += this.mod;
        // Set absolute (non-relative) horizontal coordinate.
        this.x = this.prelim + modsum;
        this.addChildSpacing();
        for (const child of this.c)child.secondWalk(modsum);
    }
    distributeExtra(i, si, dist) {
        // Are there intermediate children?
        if (si != i - 1) {
            const nr = i - si;
            this.c[si + 1].shift += dist / nr;
            this.c[i].shift -= dist / nr;
            this.c[i].change -= dist - dist / nr;
        }
    }
    // Process change and shift to add intermediate spacing to mod.
    addChildSpacing() {
        let d = 0, modsumdelta = 0;
        for (const child of this.c){
            d += child.shift;
            modsumdelta += d + child.change;
            child.mod += modsumdelta;
        }
    }
}

});




parcelRegister("7jtZA", function(module, exports) {
(function webpackUniversalModuleDefinition(root, factory) {
    module.exports = factory();
})(module.exports, function() {
    return /******/ function(modules) {
        /******/ // The module cache
        /******/ var installedModules = {};
        /******/ /******/ // The require function
        /******/ function __webpack_require__(moduleId) {
            /******/ /******/ // Check if module is in cache
            /******/ if (installedModules[moduleId]) /******/ return installedModules[moduleId].exports;
            /******/ // Create a new module (and put it into the cache)
            /******/ var module1 = installedModules[moduleId] = {
                /******/ i: moduleId,
                /******/ l: false,
                /******/ exports: {}
            };
            /******/ /******/ // Execute the module function
            /******/ modules[moduleId].call(module1.exports, module1, module1.exports, __webpack_require__);
            /******/ /******/ // Flag the module as loaded
            /******/ module1.l = true;
            /******/ /******/ // Return the exports of the module
            /******/ return module1.exports;
        /******/ }
        /******/ /******/ /******/ // expose the modules object (__webpack_modules__)
        /******/ __webpack_require__.m = modules;
        /******/ /******/ // expose the module cache
        /******/ __webpack_require__.c = installedModules;
        /******/ /******/ // identity function for calling harmony imports with the correct context
        /******/ __webpack_require__.i = function(value) {
            return value;
        };
        /******/ /******/ // define getter function for harmony exports
        /******/ __webpack_require__.d = function(exports, name, getter) {
            /******/ if (!__webpack_require__.o(exports, name)) /******/ Object.defineProperty(exports, name, {
                /******/ configurable: false,
                /******/ enumerable: true,
                /******/ get: getter
            });
        /******/ };
        /******/ /******/ // getDefaultExport function for compatibility with non-harmony modules
        /******/ __webpack_require__.n = function(module1) {
            /******/ var getter = module1 && module1.__esModule ? /******/ function getDefault() {
                return module1['default'];
            } : /******/ function getModuleExports() {
                return module1;
            };
            /******/ __webpack_require__.d(getter, 'a', getter);
            /******/ return getter;
        /******/ };
        /******/ /******/ // Object.prototype.hasOwnProperty.call
        /******/ __webpack_require__.o = function(object, property) {
            return Object.prototype.hasOwnProperty.call(object, property);
        };
        /******/ /******/ // __webpack_public_path__
        /******/ __webpack_require__.p = "";
        /******/ /******/ // Load entry module and return exports
        /******/ return __webpack_require__(__webpack_require__.s = 11);
    /******/ }([
        /* 0 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            module1.exports = Object.assign != null ? Object.assign.bind(Object) : function(tgt) {
                for(var _len = arguments.length, srcs = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)srcs[_key - 1] = arguments[_key];
                srcs.forEach(function(src) {
                    Object.keys(src).forEach(function(k) {
                        return tgt[k] = src[k];
                    });
                });
                return tgt;
            };
        /***/ },
        /* 1 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var assign = __webpack_require__(0);
            var defaults = Object.freeze({
                source: null,
                target: null,
                length: 80,
                coeff: 0.0002,
                weight: 1
            });
            function makeSpring(spring) {
                return assign({}, defaults, spring);
            }
            function applySpring(spring) {
                var body1 = spring.source, body2 = spring.target, length = spring.length < 0 ? defaults.length : spring.length, dx = body2.pos.x - body1.pos.x, dy = body2.pos.y - body1.pos.y, r = Math.sqrt(dx * dx + dy * dy);
                if (r === 0) {
                    dx = (Math.random() - 0.5) / 50;
                    dy = (Math.random() - 0.5) / 50;
                    r = Math.sqrt(dx * dx + dy * dy);
                }
                var d = r - length;
                var coeff = (!spring.coeff || spring.coeff < 0 ? defaults.springCoeff : spring.coeff) * d / r * spring.weight;
                body1.force.x += coeff * dx;
                body1.force.y += coeff * dy;
                body2.force.x -= coeff * dx;
                body2.force.y -= coeff * dy;
            }
            module1.exports = {
                makeSpring: makeSpring,
                applySpring: applySpring
            };
        /***/ },
        /* 2 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self, call) {
                if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            /**
The implementation of the Euler layout algorithm
*/ var Layout = __webpack_require__(13);
            var assign = __webpack_require__(0);
            var defaults = __webpack_require__(4);
            var _require = __webpack_require__(10), _tick = _require.tick;
            var _require2 = __webpack_require__(7), makeQuadtree = _require2.makeQuadtree;
            var _require3 = __webpack_require__(3), makeBody = _require3.makeBody;
            var _require4 = __webpack_require__(1), makeSpring = _require4.makeSpring;
            var isFn = function isFn(fn) {
                return typeof fn === 'function';
            };
            var isParent = function isParent(n) {
                return n.isParent();
            };
            var notIsParent = function notIsParent(n) {
                return !isParent(n);
            };
            var isLocked = function isLocked(n) {
                return n.locked();
            };
            var notIsLocked = function notIsLocked(n) {
                return !isLocked(n);
            };
            var isParentEdge = function isParentEdge(e) {
                return isParent(e.source()) || isParent(e.target());
            };
            var notIsParentEdge = function notIsParentEdge(e) {
                return !isParentEdge(e);
            };
            var getBody = function getBody(n) {
                return n.scratch('euler').body;
            };
            var getNonParentDescendants = function getNonParentDescendants(n) {
                return isParent(n) ? n.descendants().filter(notIsParent) : n;
            };
            var getScratch = function getScratch(el) {
                var scratch = el.scratch('euler');
                if (!scratch) {
                    scratch = {};
                    el.scratch('euler', scratch);
                }
                return scratch;
            };
            var optFn = function optFn(opt, ele) {
                if (isFn(opt)) return opt(ele);
                else return opt;
            };
            var Euler = function(_Layout) {
                _inherits(Euler, _Layout);
                function Euler(options) {
                    _classCallCheck(this, Euler);
                    return _possibleConstructorReturn(this, (Euler.__proto__ || Object.getPrototypeOf(Euler)).call(this, assign({}, defaults, options)));
                }
                _createClass(Euler, [
                    {
                        key: 'prerun',
                        value: function prerun(state) {
                            var s = state;
                            s.quadtree = makeQuadtree();
                            var bodies = s.bodies = [];
                            // regular nodes
                            s.nodes.filter(function(n) {
                                return notIsParent(n);
                            }).forEach(function(n) {
                                var scratch = getScratch(n);
                                var body = makeBody({
                                    pos: {
                                        x: scratch.x,
                                        y: scratch.y
                                    },
                                    mass: optFn(s.mass, n),
                                    locked: scratch.locked
                                });
                                body._cyNode = n;
                                scratch.body = body;
                                body._scratch = scratch;
                                bodies.push(body);
                            });
                            var springs = s.springs = [];
                            // regular edge springs
                            s.edges.filter(notIsParentEdge).forEach(function(e) {
                                var spring = makeSpring({
                                    source: getBody(e.source()),
                                    target: getBody(e.target()),
                                    length: optFn(s.springLength, e),
                                    coeff: optFn(s.springCoeff, e)
                                });
                                spring._cyEdge = e;
                                var scratch = getScratch(e);
                                spring._scratch = scratch;
                                scratch.spring = spring;
                                springs.push(spring);
                            });
                            // compound edge springs
                            s.edges.filter(isParentEdge).forEach(function(e) {
                                var sources = getNonParentDescendants(e.source());
                                var targets = getNonParentDescendants(e.target());
                                // just add one spring for perf
                                sources = [
                                    sources[0]
                                ];
                                targets = [
                                    targets[0]
                                ];
                                sources.forEach(function(src) {
                                    targets.forEach(function(tgt) {
                                        springs.push(makeSpring({
                                            source: getBody(src),
                                            target: getBody(tgt),
                                            length: optFn(s.springLength, e),
                                            coeff: optFn(s.springCoeff, e)
                                        }));
                                    });
                                });
                            });
                        }
                    },
                    {
                        key: 'tick',
                        value: function tick(state) {
                            var movement = _tick(state);
                            var isDone = movement <= state.movementThreshold;
                            return isDone;
                        }
                    }
                ]);
                return Euler;
            }(Layout);
            module1.exports = Euler;
        /***/ },
        /* 3 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var defaults = Object.freeze({
                pos: {
                    x: 0,
                    y: 0
                },
                prevPos: {
                    x: 0,
                    y: 0
                },
                force: {
                    x: 0,
                    y: 0
                },
                velocity: {
                    x: 0,
                    y: 0
                },
                mass: 1
            });
            var copyVec = function copyVec(v) {
                return {
                    x: v.x,
                    y: v.y
                };
            };
            var getValue = function getValue(val, def) {
                return val != null ? val : def;
            };
            var getVec = function getVec(vec, def) {
                return copyVec(getValue(vec, def));
            };
            function makeBody(opts) {
                var b = {};
                b.pos = getVec(opts.pos, defaults.pos);
                b.prevPos = getVec(opts.prevPos, b.pos);
                b.force = getVec(opts.force, defaults.force);
                b.velocity = getVec(opts.velocity, defaults.velocity);
                b.mass = opts.mass != null ? opts.mass : defaults.mass;
                b.locked = opts.locked;
                return b;
            }
            module1.exports = {
                makeBody: makeBody
            };
        /***/ },
        /* 4 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var defaults = Object.freeze({
                // The ideal legth of a spring
                // - This acts as a hint for the edge length
                // - The edge length can be longer or shorter if the forces are set to extreme values
                springLength: function springLength(edge) {
                    return 80;
                },
                // Hooke's law coefficient
                // - The value ranges on [0, 1]
                // - Lower values give looser springs
                // - Higher values give tighter springs
                springCoeff: function springCoeff(edge) {
                    return 0.0008;
                },
                // The mass of the node in the physics simulation
                // - The mass affects the gravity node repulsion/attraction
                mass: function mass(node) {
                    return 4;
                },
                // Coulomb's law coefficient
                // - Makes the nodes repel each other for negative values
                // - Makes the nodes attract each other for positive values
                gravity: -1.2,
                // A force that pulls nodes towards the origin (0, 0)
                // Higher values keep the components less spread out
                pull: 0.001,
                // Theta coefficient from Barnes-Hut simulation
                // - Value ranges on [0, 1]
                // - Performance is better with smaller values
                // - Very small values may not create enough force to give a good result
                theta: 0.666,
                // Friction / drag coefficient to make the system stabilise over time
                dragCoeff: 0.02,
                // When the total of the squared position deltas is less than this value, the simulation ends
                movementThreshold: 1,
                // The amount of time passed per tick
                // - Larger values result in faster runtimes but might spread things out too far
                // - Smaller values produce more accurate results
                timeStep: 20
            });
            module1.exports = defaults;
        /***/ },
        /* 5 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var defaultCoeff = 0.02;
            function applyDrag(body, manualDragCoeff) {
                var dragCoeff = void 0;
                if (manualDragCoeff != null) dragCoeff = manualDragCoeff;
                else if (body.dragCoeff != null) dragCoeff = body.dragCoeff;
                else dragCoeff = defaultCoeff;
                body.force.x -= dragCoeff * body.velocity.x;
                body.force.y -= dragCoeff * body.velocity.y;
            }
            module1.exports = {
                applyDrag: applyDrag
            };
        /***/ },
        /* 6 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            // use euler method for force integration http://en.wikipedia.org/wiki/Euler_method
            // return sum of squared position deltas
            function integrate(bodies, timeStep) {
                var dx = 0, tx = 0, dy = 0, ty = 0, i, max = bodies.length;
                if (max === 0) return 0;
                for(i = 0; i < max; ++i){
                    var body = bodies[i], coeff = timeStep / body.mass;
                    if (body.grabbed) continue;
                    if (body.locked) {
                        body.velocity.x = 0;
                        body.velocity.y = 0;
                    } else {
                        body.velocity.x += coeff * body.force.x;
                        body.velocity.y += coeff * body.force.y;
                    }
                    var vx = body.velocity.x, vy = body.velocity.y, v = Math.sqrt(vx * vx + vy * vy);
                    if (v > 1) {
                        body.velocity.x = vx / v;
                        body.velocity.y = vy / v;
                    }
                    dx = timeStep * body.velocity.x;
                    dy = timeStep * body.velocity.y;
                    body.pos.x += dx;
                    body.pos.y += dy;
                    tx += Math.abs(dx);
                    ty += Math.abs(dy);
                }
                return (tx * tx + ty * ty) / max;
            }
            module1.exports = {
                integrate: integrate
            };
        /***/ },
        /* 7 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            // impl of barnes hut
            // http://www.eecs.berkeley.edu/~demmel/cs267/lecture26/lecture26.html
            // http://en.wikipedia.org/wiki/Barnes%E2%80%93Hut_simulation
            var Node = __webpack_require__(9);
            var InsertStack = __webpack_require__(8);
            var resetVec = function resetVec(v) {
                v.x = 0;
                v.y = 0;
            };
            var isSamePosition = function isSamePosition(p1, p2) {
                var threshold = 1e-8;
                var dx = Math.abs(p1.x - p2.x);
                var dy = Math.abs(p1.y - p2.y);
                return dx < threshold && dy < threshold;
            };
            function makeQuadtree() {
                var updateQueue = [], insertStack = new InsertStack(), nodesCache = [], currentInCache = 0, root = newNode();
                function newNode() {
                    // To avoid pressure on GC we reuse nodes.
                    var node = nodesCache[currentInCache];
                    if (node) {
                        node.quad0 = null;
                        node.quad1 = null;
                        node.quad2 = null;
                        node.quad3 = null;
                        node.body = null;
                        node.mass = node.massX = node.massY = 0;
                        node.left = node.right = node.top = node.bottom = 0;
                    } else {
                        node = new Node();
                        nodesCache[currentInCache] = node;
                    }
                    ++currentInCache;
                    return node;
                }
                function update(sourceBody, gravity, theta, pull) {
                    var queue = updateQueue, v = void 0, dx = void 0, dy = void 0, r = void 0, fx = 0, fy = 0, queueLength = 1, shiftIdx = 0, pushIdx = 1;
                    queue[0] = root;
                    resetVec(sourceBody.force);
                    var px = -sourceBody.pos.x;
                    var py = -sourceBody.pos.y;
                    var pr = Math.sqrt(px * px + py * py);
                    var pv = sourceBody.mass * pull / pr;
                    fx += pv * px;
                    fy += pv * py;
                    while(queueLength){
                        var node = queue[shiftIdx], body = node.body;
                        queueLength -= 1;
                        shiftIdx += 1;
                        var differentBody = body !== sourceBody;
                        if (body && differentBody) {
                            // If the current node is a leaf node (and it is not source body),
                            // calculate the force exerted by the current node on body, and add this
                            // amount to body's net force.
                            dx = body.pos.x - sourceBody.pos.x;
                            dy = body.pos.y - sourceBody.pos.y;
                            r = Math.sqrt(dx * dx + dy * dy);
                            if (r === 0) {
                                // Poor man's protection against zero distance.
                                dx = (Math.random() - 0.5) / 50;
                                dy = (Math.random() - 0.5) / 50;
                                r = Math.sqrt(dx * dx + dy * dy);
                            }
                            // This is standard gravition force calculation but we divide
                            // by r^3 to save two operations when normalizing force vector.
                            v = gravity * body.mass * sourceBody.mass / (r * r * r);
                            fx += v * dx;
                            fy += v * dy;
                        } else if (differentBody) {
                            // Otherwise, calculate the ratio s / r,  where s is the width of the region
                            // represented by the internal node, and r is the distance between the body
                            // and the node's center-of-mass
                            dx = node.massX / node.mass - sourceBody.pos.x;
                            dy = node.massY / node.mass - sourceBody.pos.y;
                            r = Math.sqrt(dx * dx + dy * dy);
                            if (r === 0) {
                                // Sorry about code duplucation. I don't want to create many functions
                                // right away. Just want to see performance first.
                                dx = (Math.random() - 0.5) / 50;
                                dy = (Math.random() - 0.5) / 50;
                                r = Math.sqrt(dx * dx + dy * dy);
                            }
                            // If s / r < θ, treat this internal node as a single body, and calculate the
                            // force it exerts on sourceBody, and add this amount to sourceBody's net force.
                            if ((node.right - node.left) / r < theta) {
                                // in the if statement above we consider node's width only
                                // because the region was squarified during tree creation.
                                // Thus there is no difference between using width or height.
                                v = gravity * node.mass * sourceBody.mass / (r * r * r);
                                fx += v * dx;
                                fy += v * dy;
                            } else {
                                // Otherwise, run the procedure recursively on each of the current node's children.
                                // I intentionally unfolded this loop, to save several CPU cycles.
                                if (node.quad0) {
                                    queue[pushIdx] = node.quad0;
                                    queueLength += 1;
                                    pushIdx += 1;
                                }
                                if (node.quad1) {
                                    queue[pushIdx] = node.quad1;
                                    queueLength += 1;
                                    pushIdx += 1;
                                }
                                if (node.quad2) {
                                    queue[pushIdx] = node.quad2;
                                    queueLength += 1;
                                    pushIdx += 1;
                                }
                                if (node.quad3) {
                                    queue[pushIdx] = node.quad3;
                                    queueLength += 1;
                                    pushIdx += 1;
                                }
                            }
                        }
                    }
                    sourceBody.force.x += fx;
                    sourceBody.force.y += fy;
                }
                function insertBodies(bodies) {
                    if (bodies.length === 0) return;
                    var x1 = Number.MAX_VALUE, y1 = Number.MAX_VALUE, x2 = Number.MIN_VALUE, y2 = Number.MIN_VALUE, i = void 0, max = bodies.length;
                    // To reduce quad tree depth we are looking for exact bounding box of all particles.
                    i = max;
                    while(i--){
                        var x = bodies[i].pos.x;
                        var y = bodies[i].pos.y;
                        if (x < x1) x1 = x;
                        if (x > x2) x2 = x;
                        if (y < y1) y1 = y;
                        if (y > y2) y2 = y;
                    }
                    // Squarify the bounds.
                    var dx = x2 - x1, dy = y2 - y1;
                    if (dx > dy) y2 = y1 + dx;
                    else x2 = x1 + dy;
                    currentInCache = 0;
                    root = newNode();
                    root.left = x1;
                    root.right = x2;
                    root.top = y1;
                    root.bottom = y2;
                    i = max - 1;
                    if (i >= 0) root.body = bodies[i];
                    while(i--)insert(bodies[i], root);
                }
                function insert(newBody) {
                    insertStack.reset();
                    insertStack.push(root, newBody);
                    while(!insertStack.isEmpty()){
                        var stackItem = insertStack.pop(), node = stackItem.node, body = stackItem.body;
                        if (!node.body) {
                            // This is internal node. Update the total mass of the node and center-of-mass.
                            var x = body.pos.x;
                            var y = body.pos.y;
                            node.mass = node.mass + body.mass;
                            node.massX = node.massX + body.mass * x;
                            node.massY = node.massY + body.mass * y;
                            // Recursively insert the body in the appropriate quadrant.
                            // But first find the appropriate quadrant.
                            var quadIdx = 0, // Assume we are in the 0's quad.
                            left = node.left, right = (node.right + left) / 2, top = node.top, bottom = (node.bottom + top) / 2;
                            if (x > right) {
                                // somewhere in the eastern part.
                                quadIdx = quadIdx + 1;
                                left = right;
                                right = node.right;
                            }
                            if (y > bottom) {
                                // and in south.
                                quadIdx = quadIdx + 2;
                                top = bottom;
                                bottom = node.bottom;
                            }
                            var child = getChild(node, quadIdx);
                            if (!child) {
                                // The node is internal but this quadrant is not taken. Add
                                // subnode to it.
                                child = newNode();
                                child.left = left;
                                child.top = top;
                                child.right = right;
                                child.bottom = bottom;
                                child.body = body;
                                setChild(node, quadIdx, child);
                            } else // continue searching in this quadrant.
                            insertStack.push(child, body);
                        } else {
                            // We are trying to add to the leaf node.
                            // We have to convert current leaf into internal node
                            // and continue adding two nodes.
                            var oldBody = node.body;
                            node.body = null; // internal nodes do not cary bodies
                            if (isSamePosition(oldBody.pos, body.pos)) {
                                // Prevent infinite subdivision by bumping one node
                                // anywhere in this quadrant
                                var retriesCount = 3;
                                do {
                                    var offset = Math.random();
                                    var dx = (node.right - node.left) * offset;
                                    var dy = (node.bottom - node.top) * offset;
                                    oldBody.pos.x = node.left + dx;
                                    oldBody.pos.y = node.top + dy;
                                    retriesCount -= 1;
                                // Make sure we don't bump it out of the box. If we do, next iteration should fix it
                                }while (retriesCount > 0 && isSamePosition(oldBody.pos, body.pos));
                                if (retriesCount === 0 && isSamePosition(oldBody.pos, body.pos)) // This is very bad, we ran out of precision.
                                // if we do not return from the method we'll get into
                                // infinite loop here. So we sacrifice correctness of layout, and keep the app running
                                // Next layout iteration should get larger bounding box in the first step and fix this
                                return;
                            }
                            // Next iteration should subdivide node further.
                            insertStack.push(node, oldBody);
                            insertStack.push(node, body);
                        }
                    }
                }
                return {
                    insertBodies: insertBodies,
                    updateBodyForce: update
                };
            }
            function getChild(node, idx) {
                if (idx === 0) return node.quad0;
                if (idx === 1) return node.quad1;
                if (idx === 2) return node.quad2;
                if (idx === 3) return node.quad3;
                return null;
            }
            function setChild(node, idx, child) {
                if (idx === 0) node.quad0 = child;
                else if (idx === 1) node.quad1 = child;
                else if (idx === 2) node.quad2 = child;
                else if (idx === 3) node.quad3 = child;
            }
            module1.exports = {
                makeQuadtree: makeQuadtree
            };
        /***/ },
        /* 8 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            module1.exports = InsertStack;
            /**
 * Our implmentation of QuadTree is non-recursive to avoid GC hit
 * This data structure represent stack of elements
 * which we are trying to insert into quad tree.
 */ function InsertStack() {
                this.stack = [];
                this.popIdx = 0;
            }
            InsertStack.prototype = {
                isEmpty: function isEmpty() {
                    return this.popIdx === 0;
                },
                push: function push(node, body) {
                    var item = this.stack[this.popIdx];
                    if (!item) // we are trying to avoid memory pressue: create new element
                    // only when absolutely necessary
                    this.stack[this.popIdx] = new InsertStackElement(node, body);
                    else {
                        item.node = node;
                        item.body = body;
                    }
                    ++this.popIdx;
                },
                pop: function pop() {
                    if (this.popIdx > 0) return this.stack[--this.popIdx];
                },
                reset: function reset() {
                    this.popIdx = 0;
                }
            };
            function InsertStackElement(node, body) {
                this.node = node; // QuadTree node
                this.body = body; // physical body which needs to be inserted to node
            }
        /***/ },
        /* 9 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * Internal data structure to represent 2D QuadTree node
 */ module1.exports = function Node() {
                // body stored inside this node. In quad tree only leaf nodes (by construction)
                // contain boides:
                this.body = null;
                // Child nodes are stored in quads. Each quad is presented by number:
                // 0 | 1
                // -----
                // 2 | 3
                this.quad0 = null;
                this.quad1 = null;
                this.quad2 = null;
                this.quad3 = null;
                // Total mass of current node
                this.mass = 0;
                // Center of mass coordinates
                this.massX = 0;
                this.massY = 0;
                // bounding box coordinates
                this.left = 0;
                this.top = 0;
                this.bottom = 0;
                this.right = 0;
            };
        /***/ },
        /* 10 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var _require = __webpack_require__(6), integrate = _require.integrate;
            var _require2 = __webpack_require__(5), applyDrag = _require2.applyDrag;
            var _require3 = __webpack_require__(1), applySpring = _require3.applySpring;
            function tick(_ref) {
                var bodies = _ref.bodies, springs = _ref.springs, quadtree = _ref.quadtree, timeStep = _ref.timeStep, gravity = _ref.gravity, theta = _ref.theta, dragCoeff = _ref.dragCoeff, pull = _ref.pull;
                // update body from scratch in case of any changes
                bodies.forEach(function(body) {
                    var p = body._scratch;
                    if (!p) return;
                    body.locked = p.locked;
                    body.grabbed = p.grabbed;
                    body.pos.x = p.x;
                    body.pos.y = p.y;
                });
                quadtree.insertBodies(bodies);
                for(var i = 0; i < bodies.length; i++){
                    var body = bodies[i];
                    quadtree.updateBodyForce(body, gravity, theta, pull);
                    applyDrag(body, dragCoeff);
                }
                for(var _i = 0; _i < springs.length; _i++){
                    var spring = springs[_i];
                    applySpring(spring);
                }
                var movement = integrate(bodies, timeStep);
                // update scratch positions from body positions
                bodies.forEach(function(body) {
                    var p = body._scratch;
                    if (!p) return;
                    p.x = body.pos.x;
                    p.y = body.pos.y;
                });
                return movement;
            }
            module1.exports = {
                tick: tick
            };
        /***/ },
        /* 11 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var Euler = __webpack_require__(2);
            // registers the extension on a cytoscape lib ref
            var register = function register(cytoscape1) {
                if (!cytoscape1) return;
                 // can't register if cytoscape unspecified
                cytoscape1('layout', 'euler', Euler); // register with cytoscape.js
            };
            if (typeof cytoscape !== 'undefined') // expose to global cytoscape (i.e. window.cytoscape)
            register(cytoscape);
            module1.exports = register;
        /***/ },
        /* 12 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            // general default options for force-directed layout
            module1.exports = Object.freeze({
                animate: true,
                refresh: 10,
                maxIterations: 1000,
                maxSimulationTime: 4000,
                ungrabifyWhileSimulating: false,
                fit: true,
                padding: 30,
                boundingBox: undefined,
                // layout event callbacks
                ready: function ready() {},
                stop: function stop() {},
                // positioning options
                randomize: false,
                // infinite layout options
                infinite: false // overrides all other options for a forces-all-the-time mode
            });
        /***/ },
        /* 13 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            /**
A generic continuous layout class
*/ var assign = __webpack_require__(0);
            var defaults = __webpack_require__(12);
            var makeBoundingBox = __webpack_require__(14);
            var _require = __webpack_require__(15), setInitialPositionState = _require.setInitialPositionState, refreshPositions = _require.refreshPositions, getNodePositionData = _require.getNodePositionData;
            var _require2 = __webpack_require__(16), multitick = _require2.multitick;
            var Layout = function() {
                function Layout(options) {
                    _classCallCheck(this, Layout);
                    var o = this.options = assign({}, defaults, options);
                    var nodes = o.eles.nodes();
                    // prevent infinite loop and memory overflow when nodes occupy the same position
                    if (!o.randomize) {
                        nodes = nodes.sort(function(a, b) {
                            return a.position().x - b.position().x;
                        });
                        var prev = {
                            x: 0,
                            y: 0
                        };
                        var pos = {};
                        nodes.forEach(function(n) {
                            Object.assign(pos, n.position());
                            if (Math.abs(prev.x - pos.x) < o.theta && Math.abs(prev.y - pos.y) < o.theta) n.position({
                                x: Math.random() * 100,
                                y: Math.random() * 100
                            });
                            Object.assign(prev, pos);
                        });
                    }
                    var s = this.state = assign({}, o, {
                        layout: this,
                        nodes: nodes,
                        edges: o.eles.edges(),
                        tickIndex: 0,
                        firstUpdate: true
                    });
                    s.animateEnd = o.animate && o.animate === 'end';
                    s.animateContinuously = o.animate && !s.animateEnd;
                }
                _createClass(Layout, [
                    {
                        key: 'run',
                        value: function run() {
                            var l = this;
                            var s = this.state;
                            s.tickIndex = 0;
                            s.firstUpdate = true;
                            s.startTime = Date.now();
                            s.running = true;
                            s.currentBoundingBox = makeBoundingBox(s.boundingBox, s.cy);
                            if (s.ready) l.one('ready', s.ready);
                            if (s.stop) l.one('stop', s.stop);
                            s.nodes.forEach(function(n) {
                                return setInitialPositionState(n, s);
                            });
                            l.prerun(s);
                            if (s.animateContinuously) {
                                var ungrabify = function ungrabify(node) {
                                    if (!s.ungrabifyWhileSimulating) return;
                                    var grabbable = getNodePositionData(node, s).grabbable = node.grabbable();
                                    if (grabbable) node.ungrabify();
                                };
                                var regrabify = function regrabify(node) {
                                    if (!s.ungrabifyWhileSimulating) return;
                                    var grabbable = getNodePositionData(node, s).grabbable;
                                    if (grabbable) node.grabify();
                                };
                                var updateGrabState = function updateGrabState(node) {
                                    return getNodePositionData(node, s).grabbed = node.grabbed();
                                };
                                var onGrab = function onGrab(_ref) {
                                    var target = _ref.target;
                                    updateGrabState(target);
                                };
                                var onFree = onGrab;
                                var onDrag = function onDrag(_ref2) {
                                    var target = _ref2.target;
                                    var p = getNodePositionData(target, s);
                                    var tp = target.position();
                                    p.x = tp.x;
                                    p.y = tp.y;
                                };
                                var listenToGrab = function listenToGrab(node) {
                                    node.on('grab', onGrab);
                                    node.on('free', onFree);
                                    node.on('drag', onDrag);
                                };
                                var unlistenToGrab = function unlistenToGrab(node) {
                                    node.removeListener('grab', onGrab);
                                    node.removeListener('free', onFree);
                                    node.removeListener('drag', onDrag);
                                };
                                var fit = function fit() {
                                    if (s.fit && s.animateContinuously) s.cy.fit(s.padding);
                                };
                                var onNotDone = function onNotDone() {
                                    refreshPositions(s.nodes, s);
                                    fit();
                                    requestAnimationFrame(_frame);
                                };
                                var _frame = function _frame() {
                                    multitick(s, onNotDone, _onDone);
                                };
                                var _onDone = function _onDone() {
                                    refreshPositions(s.nodes, s);
                                    fit();
                                    s.nodes.forEach(function(n) {
                                        regrabify(n);
                                        unlistenToGrab(n);
                                    });
                                    s.running = false;
                                    l.emit('layoutstop');
                                };
                                l.emit('layoutstart');
                                s.nodes.forEach(function(n) {
                                    ungrabify(n);
                                    listenToGrab(n);
                                });
                                _frame(); // kick off
                            } else {
                                var done = false;
                                var _onNotDone = function _onNotDone() {};
                                var _onDone2 = function _onDone2() {
                                    return done = true;
                                };
                                while(!done)multitick(s, _onNotDone, _onDone2);
                                s.eles.layoutPositions(this, s, function(node) {
                                    var pd = getNodePositionData(node, s);
                                    return {
                                        x: pd.x,
                                        y: pd.y
                                    };
                                });
                            }
                            l.postrun(s);
                            return this; // chaining
                        }
                    },
                    {
                        key: 'prerun',
                        value: function prerun() {}
                    },
                    {
                        key: 'postrun',
                        value: function postrun() {}
                    },
                    {
                        key: 'tick',
                        value: function tick() {}
                    },
                    {
                        key: 'stop',
                        value: function stop() {
                            this.state.running = false;
                            return this; // chaining
                        }
                    },
                    {
                        key: 'destroy',
                        value: function destroy() {
                            return this; // chaining
                        }
                    }
                ]);
                return Layout;
            }();
            module1.exports = Layout;
        /***/ },
        /* 14 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            module1.exports = function(bb, cy) {
                if (bb == null) bb = {
                    x1: 0,
                    y1: 0,
                    w: cy.width(),
                    h: cy.height()
                };
                else // copy
                bb = {
                    x1: bb.x1,
                    x2: bb.x2,
                    y1: bb.y1,
                    y2: bb.y2,
                    w: bb.w,
                    h: bb.h
                };
                if (bb.x2 == null) bb.x2 = bb.x1 + bb.w;
                if (bb.w == null) bb.w = bb.x2 - bb.x1;
                if (bb.y2 == null) bb.y2 = bb.y1 + bb.h;
                if (bb.h == null) bb.h = bb.y2 - bb.y1;
                return bb;
            };
        /***/ },
        /* 15 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var assign = __webpack_require__(0);
            var setInitialPositionState = function setInitialPositionState(node, state) {
                var p = node.position();
                var bb = state.currentBoundingBox;
                var scratch = node.scratch(state.name);
                if (scratch == null) {
                    scratch = {};
                    node.scratch(state.name, scratch);
                }
                assign(scratch, state.randomize ? {
                    x: bb.x1 + Math.random() * bb.w,
                    y: bb.y1 + Math.random() * bb.h
                } : {
                    x: p.x,
                    y: p.y
                });
                scratch.locked = node.locked();
            };
            var getNodePositionData = function getNodePositionData(node, state) {
                return node.scratch(state.name);
            };
            var refreshPositions = function refreshPositions(nodes, state) {
                nodes.positions(function(node) {
                    var scratch = node.scratch(state.name);
                    return {
                        x: scratch.x,
                        y: scratch.y
                    };
                });
            };
            module1.exports = {
                setInitialPositionState: setInitialPositionState,
                getNodePositionData: getNodePositionData,
                refreshPositions: refreshPositions
            };
        /***/ },
        /* 16 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var nop = function nop() {};
            var tick = function tick(state) {
                var s = state;
                var l = state.layout;
                var tickIndicatesDone = l.tick(s);
                if (s.firstUpdate) {
                    if (s.animateContinuously) // indicate the initial positions have been set
                    s.layout.emit('layoutready');
                    s.firstUpdate = false;
                }
                s.tickIndex++;
                var duration = Date.now() - s.startTime;
                return !s.infinite && (tickIndicatesDone || s.tickIndex >= s.maxIterations || duration >= s.maxSimulationTime);
            };
            var multitick = function multitick(state) {
                var onNotDone = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : nop;
                var onDone = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : nop;
                var done = false;
                var s = state;
                for(var i = 0; i < s.refresh; i++){
                    done = !s.running || tick(s);
                    if (done) break;
                }
                if (!done) onNotDone();
                else onDone();
            };
            module1.exports = {
                tick: tick,
                multitick: multitick
            };
        /***/ }
    ]);
});

});

parcelRegister("7jXoy", function(module, exports) {

(function webpackUniversalModuleDefinition(root, factory) {
    module.exports = factory((parcelRequire("29IVF")));
})(module.exports, function(__WEBPACK_EXTERNAL_MODULE_3__) {
    return /******/ function(modules) {
        /******/ // The module cache
        /******/ var installedModules = {};
        /******/ /******/ // The require function
        /******/ function __webpack_require__(moduleId) {
            /******/ /******/ // Check if module is in cache
            /******/ if (installedModules[moduleId]) /******/ return installedModules[moduleId].exports;
            /******/ // Create a new module (and put it into the cache)
            /******/ var module1 = installedModules[moduleId] = {
                /******/ i: moduleId,
                /******/ l: false,
                /******/ exports: {}
            };
            /******/ /******/ // Execute the module function
            /******/ modules[moduleId].call(module1.exports, module1, module1.exports, __webpack_require__);
            /******/ /******/ // Flag the module as loaded
            /******/ module1.l = true;
            /******/ /******/ // Return the exports of the module
            /******/ return module1.exports;
        /******/ }
        /******/ /******/ /******/ // expose the modules object (__webpack_modules__)
        /******/ __webpack_require__.m = modules;
        /******/ /******/ // expose the module cache
        /******/ __webpack_require__.c = installedModules;
        /******/ /******/ // identity function for calling harmony imports with the correct context
        /******/ __webpack_require__.i = function(value) {
            return value;
        };
        /******/ /******/ // define getter function for harmony exports
        /******/ __webpack_require__.d = function(exports, name, getter) {
            /******/ if (!__webpack_require__.o(exports, name)) /******/ Object.defineProperty(exports, name, {
                /******/ configurable: false,
                /******/ enumerable: true,
                /******/ get: getter
            });
        /******/ };
        /******/ /******/ // getDefaultExport function for compatibility with non-harmony modules
        /******/ __webpack_require__.n = function(module1) {
            /******/ var getter = module1 && module1.__esModule ? /******/ function getDefault() {
                return module1['default'];
            } : /******/ function getModuleExports() {
                return module1;
            };
            /******/ __webpack_require__.d(getter, 'a', getter);
            /******/ return getter;
        /******/ };
        /******/ /******/ // Object.prototype.hasOwnProperty.call
        /******/ __webpack_require__.o = function(object, property) {
            return Object.prototype.hasOwnProperty.call(object, property);
        };
        /******/ /******/ // __webpack_public_path__
        /******/ __webpack_require__.p = "";
        /******/ /******/ // Load entry module and return exports
        /******/ return __webpack_require__(__webpack_require__.s = 1);
    /******/ }([
        /* 0 */ /***/ function(module1, exports, __webpack_require__) {
            var Thread = __webpack_require__(3).Thread;
            var Voronoi = __webpack_require__(2);
            var defaults = {
                animate: true,
                ready: undefined,
                stop: undefined,
                fit: true,
                minDist: 20,
                padding: 20,
                expandingFactor: -1,
                // criterium then it expands the network of this amount
                // If it is set to -1.0 the amount of expansion is automatically
                // calculated based on the minDist, the aspect ratio and the
                // number of nodes
                prelayout: {
                    name: 'cose'
                },
                maxExpandIterations: 4,
                boundingBox: undefined,
                randomize: false // Uses random initial node positions on true
            };
            function SpreadLayout(options) {
                var opts = this.options = {};
                for(var i in defaults)opts[i] = defaults[i];
                for(var i in options)opts[i] = options[i];
            }
            SpreadLayout.prototype.run = function() {
                var layout = this;
                var options = this.options;
                var cy = options.cy;
                var bb = options.boundingBox || {
                    x1: 0,
                    y1: 0,
                    w: cy.width(),
                    h: cy.height()
                };
                if (bb.x2 === undefined) bb.x2 = bb.x1 + bb.w;
                if (bb.w === undefined) bb.w = bb.x2 - bb.x1;
                if (bb.y2 === undefined) bb.y2 = bb.y1 + bb.h;
                if (bb.h === undefined) bb.h = bb.y2 - bb.y1;
                var nodes = cy.nodes();
                var edges = cy.edges();
                var cWidth = cy.width();
                var cHeight = cy.height();
                var simulationBounds = bb;
                var padding = options.padding;
                var simBBFactor = Math.max(1, Math.log(nodes.length) * 0.8);
                if (nodes.length < 100) simBBFactor /= 2;
                layout.trigger({
                    type: 'layoutstart',
                    layout: layout
                });
                var simBB = {
                    x1: 0,
                    y1: 0,
                    x2: cWidth * simBBFactor,
                    y2: cHeight * simBBFactor
                };
                if (simulationBounds) {
                    simBB.x1 = simulationBounds.x1;
                    simBB.y1 = simulationBounds.y1;
                    simBB.x2 = simulationBounds.x2;
                    simBB.y2 = simulationBounds.y2;
                }
                simBB.x1 += padding;
                simBB.y1 += padding;
                simBB.x2 -= padding;
                simBB.y2 -= padding;
                var width = simBB.x2 - simBB.x1;
                var height = simBB.y2 - simBB.y1;
                // Get start time
                var startTime = Date.now();
                // layout doesn't work with just 1 node
                if (nodes.size() <= 1) {
                    nodes.positions({
                        x: Math.round((simBB.x1 + simBB.x2) / 2),
                        y: Math.round((simBB.y1 + simBB.y2) / 2)
                    });
                    if (options.fit) cy.fit(options.padding);
                    // Get end time
                    var endTime = Date.now();
                    console.info("Layout on " + nodes.size() + " nodes took " + (endTime - startTime) + " ms");
                    layout.one("layoutready", options.ready);
                    layout.trigger("layoutready");
                    layout.one("layoutstop", options.stop);
                    layout.trigger("layoutstop");
                    return;
                }
                // First I need to create the data structure to pass to the worker
                var pData = {
                    'width': width,
                    'height': height,
                    'minDist': options.minDist,
                    'expFact': options.expandingFactor,
                    'expIt': 0,
                    'maxExpIt': options.maxExpandIterations,
                    'vertices': [],
                    'edges': [],
                    'startTime': startTime
                };
                for(var i = nodes.length - 1; i >= 0; i--){
                    var nodeId = nodes[i].id();
                    var pos = nodes[i].position();
                    if (options.randomize) pos = {
                        x: Math.round(simBB.x1 + (simBB.x2 - simBB.x1) * Math.random()),
                        y: Math.round(simBB.y1 + (simBB.y2 - simBB.y1) * Math.random())
                    };
                    pData['vertices'].push({
                        id: nodeId,
                        x: pos.x,
                        y: pos.y
                    });
                }
                for(var i = edges.length - 1; i >= 0; i--){
                    var srcNodeId = edges[i].source().id();
                    var tgtNodeId = edges[i].target().id();
                    pData['edges'].push({
                        src: srcNodeId,
                        tgt: tgtNodeId
                    });
                }
                //Decleration
                var t1 = layout.thread;
                // reuse old thread if possible
                if (!t1 || t1.stopped()) {
                    t1 = layout.thread = Thread();
                    // And to add the required scripts
                    t1.require(Voronoi, 'Voronoi');
                }
                function setPositions(pData) {
                    // First we retrieve the important data
                    // var expandIteration = pData[ 'expIt' ];
                    var dataVertices = pData['vertices'];
                    var vertices = [];
                    for(var i = 0; i < dataVertices.length; ++i){
                        var dv = dataVertices[i];
                        vertices[dv.id] = {
                            x: dv.x,
                            y: dv.y
                        };
                    }
                    /*
     * FINALLY:
     *
     * We position the nodes based on the calculation
     */ nodes.positions(function(node, i) {
                        // Perform 2.x and 1.x backwards compatibility check
                        if (typeof node === "number") node = i;
                        var id = node.id();
                        var vertex = vertices[id];
                        return {
                            x: Math.round(simBB.x1 + vertex.x),
                            y: Math.round(simBB.y1 + vertex.y)
                        };
                    });
                    if (options.fit) cy.fit(options.padding);
                }
                var didLayoutReady = false;
                t1.on('message', function(e) {
                    var pData = e.message; //console.log('message', e)
                    if (!options.animate) return;
                    setPositions(pData);
                    if (!didLayoutReady) {
                        layout.trigger("layoutready");
                        didLayoutReady = true;
                    }
                });
                layout.one("layoutready", options.ready);
                if (options.prelayout) {
                    var prelayout = cy.makeLayout(options.prelayout);
                    var promise = prelayout.promiseOn('layoutstop');
                    promise.then(runVoronoi);
                    prelayout.run();
                } else runVoronoi();
                function runVoronoi() {
                    t1.pass(pData).run(function(pData) {
                        function cellCentroid(cell) {
                            var hes = cell.halfedges;
                            var area = 0, x = 0, y = 0;
                            var p1, p2, f;
                            for(var i = 0; i < hes.length; ++i){
                                p1 = hes[i].getEndpoint();
                                p2 = hes[i].getStartpoint();
                                area += p1.x * p2.y;
                                area -= p1.y * p2.x;
                                f = p1.x * p2.y - p2.x * p1.y;
                                x += (p1.x + p2.x) * f;
                                y += (p1.y + p2.y) * f;
                            }
                            area /= 2;
                            f = area * 6;
                            return {
                                x: x / f,
                                y: y / f
                            };
                        }
                        function sitesDistance(ls, rs) {
                            var dx = ls.x - rs.x;
                            var dy = ls.y - rs.y;
                            return Math.sqrt(dx * dx + dy * dy);
                        }
                        Voronoi = _ref_('Voronoi');
                        // I need to retrieve the important data
                        var lWidth = pData['width'];
                        var lHeight = pData['height'];
                        var lMinDist = pData['minDist'];
                        var lExpFact = pData['expFact'];
                        var lMaxExpIt = pData['maxExpIt'];
                        // Prepare the data to output
                        var savePositions = function() {
                            pData['width'] = lWidth;
                            pData['height'] = lHeight;
                            pData['expIt'] = expandIteration;
                            pData['expFact'] = lExpFact;
                            pData['vertices'] = [];
                            for(var i = 0; i < fv.length; ++i)pData['vertices'].push({
                                id: fv[i].label,
                                x: fv[i].x,
                                y: fv[i].y
                            });
                        };
                        var messagePositions = function() {
                            broadcast(pData);
                        };
                        var dataVertices = pData['vertices'];
                        var dataEdges = pData['edges'];
                        var x1 = Infinity;
                        var x2 = -Infinity;
                        var y1 = Infinity;
                        var y2 = -Infinity;
                        dataVertices.forEach(function(v) {
                            x1 = Math.min(v.x, x1);
                            x2 = Math.max(v.x, x2);
                            y1 = Math.min(v.y, y1);
                            y2 = Math.max(v.y, y2);
                        });
                        var scale = function(x, minX, maxX, scaledMinX, scaledMaxX) {
                            var p = (x - minX) / (maxX - minX);
                            if (isNaN(p)) p = Math.random();
                            return scaledMinX + (scaledMaxX - scaledMinX) * p;
                        };
                        // NB Voronoi expects all nodes to be on { x in [0, lWidth], y in [0, lHeight] }
                        var fv = dataVertices.map(function(v) {
                            return {
                                label: v.id,
                                x: scale(v.x, x1, x2, 0, lWidth),
                                y: scale(v.y, y1, y2, 0, lHeight)
                            };
                        });
                        savePositions();
                        messagePositions();
                        if (lMaxExpIt <= 0) return pData;
                        /*
       * SECOND STEP: Tiding up of the graph.
       *
       * We use the method described by Gansner and North, based on Voronoi
       * diagrams.
       *
       * Ref: doi:10.1007/3-540-37623-2_28
       */ // We calculate the Voronoi diagram dor the position of the nodes
                        var voronoi = new Voronoi();
                        var bbox = {
                            xl: 0,
                            xr: lWidth,
                            yt: 0,
                            yb: lHeight
                        };
                        var vSites = [];
                        for(var i = 0; i < fv.length; ++i)vSites[fv[i].label] = fv[i];
                        function checkMinDist(ee) {
                            var infractions = 0;
                            // Then we check if the minimum distance is satisfied
                            for(var eei = 0; eei < ee.length; ++eei){
                                var e = ee[eei];
                                if (e.lSite != null && e.rSite != null && sitesDistance(e.lSite, e.rSite) < lMinDist) ++infractions;
                            }
                            return infractions;
                        }
                        var diagram = voronoi.compute(fv, bbox);
                        // Then we reposition the nodes at the centroid of their Voronoi cells
                        var cells = diagram.cells;
                        for(var i = 0; i < cells.length; ++i){
                            var cell = cells[i];
                            var site = cell.site;
                            var centroid = cellCentroid(cell);
                            var currv = vSites[site.label];
                            currv.x = centroid.x;
                            currv.y = centroid.y;
                        }
                        if (lExpFact < 0.0) // Calculates the expanding factor
                        lExpFact = Math.max(0.05, Math.min(0.10, lMinDist / Math.sqrt(lWidth * lHeight / fv.length) * 0.5));
                        var prevInfractions = checkMinDist(diagram.edges);
                        //console.info("Initial infractions " + prevInfractions);
                        var bStop = prevInfractions <= 0 || lMaxExpIt <= 0;
                        var voronoiIteration = 0;
                        var expandIteration = 0;
                        // var initWidth = lWidth;
                        while(!bStop){
                            ++voronoiIteration;
                            for(var it = 0; it <= 4; ++it){
                                voronoi.recycle(diagram);
                                diagram = voronoi.compute(fv, bbox);
                                // Then we reposition the nodes at the centroid of their Voronoi cells
                                // cells = diagram.cells;
                                for(var i = 0; i < cells.length; ++i){
                                    var cell = cells[i];
                                    var site = cell.site;
                                    var centroid = cellCentroid(cell);
                                    var currv = vSites[site.label];
                                    currv.x = centroid.x;
                                    currv.y = centroid.y;
                                }
                            }
                            var currInfractions = checkMinDist(diagram.edges);
                            //console.info("Current infractions " + currInfractions);
                            if (currInfractions <= 0) bStop = true;
                            else if (currInfractions >= prevInfractions || voronoiIteration >= 4) {
                                if (expandIteration >= lMaxExpIt) bStop = true;
                                else {
                                    lWidth += lWidth * lExpFact;
                                    lHeight += lHeight * lExpFact;
                                    bbox = {
                                        xl: 0,
                                        xr: lWidth,
                                        yt: 0,
                                        yb: lHeight
                                    };
                                    ++expandIteration;
                                    voronoiIteration = 0;
                                //console.info("Expanded to ("+width+","+height+")");
                                }
                            }
                            prevInfractions = currInfractions;
                            savePositions();
                            messagePositions();
                        }
                        savePositions();
                        return pData;
                    }).then(function(pData) {
                        // var expandIteration = pData[ 'expIt' ];
                        var dataVertices = pData['vertices'];
                        setPositions(pData);
                        // Get end time
                        var startTime = pData['startTime'];
                        var endTime = new Date();
                        console.info("Layout on " + dataVertices.length + " nodes took " + (endTime - startTime) + " ms");
                        layout.one("layoutstop", options.stop);
                        if (!options.animate) layout.trigger("layoutready");
                        layout.trigger("layoutstop");
                        t1.stop();
                    });
                }
                return this;
            }; // run
            SpreadLayout.prototype.stop = function() {
                if (this.thread) this.thread.stop();
                this.trigger('layoutstop');
            };
            SpreadLayout.prototype.destroy = function() {
                if (this.thread) this.thread.stop();
            };
            module1.exports = SpreadLayout;
        /***/ },
        /* 1 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            // registers the extension on a cytoscape lib ref
            var Layout = __webpack_require__(0);
            var register = function(cytoscape1) {
                cytoscape1('layout', 'spread', Layout);
            };
            if (typeof cytoscape !== 'undefined') register(cytoscape);
            module1.exports = register;
        /***/ },
        /* 2 */ /***/ function(module1, exports) {
            /*!
Copyright (C) 2010-2013 Raymond Hill: https://github.com/gorhill/Javascript-Voronoi
MIT License: See https://github.com/gorhill/Javascript-Voronoi/LICENSE.md
*/ /*
Author: Raymond Hill (rhill@raymondhill.net)
Contributor: Jesse Morgan (morgajel@gmail.com)
File: rhill-voronoi-core.js
Version: 0.98
Date: January 21, 2013
Description: This is my personal Javascript implementation of
Steven Fortune's algorithm to compute Voronoi diagrams.

License: See https://github.com/gorhill/Javascript-Voronoi/LICENSE.md
Credits: See https://github.com/gorhill/Javascript-Voronoi/CREDITS.md
History: See https://github.com/gorhill/Javascript-Voronoi/CHANGELOG.md

## Usage:

  var sites = [{x:300,y:300}, {x:100,y:100}, {x:200,y:500}, {x:250,y:450}, {x:600,y:150}];
  // xl, xr means x left, x right
  // yt, yb means y top, y bottom
  var bbox = {xl:0, xr:800, yt:0, yb:600};
  var voronoi = new Voronoi();
  // pass an object which exhibits xl, xr, yt, yb properties. The bounding
  // box will be used to connect unbound edges, and to close open cells
  result = voronoi.compute(sites, bbox);
  // render, further analyze, etc.

Return value:
  An object with the following properties:

  result.vertices = an array of unordered, unique Voronoi.Vertex objects making
    up the Voronoi diagram.
  result.edges = an array of unordered, unique Voronoi.Edge objects making up
    the Voronoi diagram.
  result.cells = an array of Voronoi.Cell object making up the Voronoi diagram.
    A Cell object might have an empty array of halfedges, meaning no Voronoi
    cell could be computed for a particular cell.
  result.execTime = the time it took to compute the Voronoi diagram, in
    milliseconds.

Voronoi.Vertex object:
  x: The x position of the vertex.
  y: The y position of the vertex.

Voronoi.Edge object:
  lSite: the Voronoi site object at the left of this Voronoi.Edge object.
  rSite: the Voronoi site object at the right of this Voronoi.Edge object (can
    be null).
  va: an object with an 'x' and a 'y' property defining the start point
    (relative to the Voronoi site on the left) of this Voronoi.Edge object.
  vb: an object with an 'x' and a 'y' property defining the end point
    (relative to Voronoi site on the left) of this Voronoi.Edge object.

  For edges which are used to close open cells (using the supplied bounding
  box), the rSite property will be null.

Voronoi.Cell object:
  site: the Voronoi site object associated with the Voronoi cell.
  halfedges: an array of Voronoi.Halfedge objects, ordered counterclockwise,
    defining the polygon for this Voronoi cell.

Voronoi.Halfedge object:
  site: the Voronoi site object owning this Voronoi.Halfedge object.
  edge: a reference to the unique Voronoi.Edge object underlying this
    Voronoi.Halfedge object.
  getStartpoint(): a method returning an object with an 'x' and a 'y' property
    for the start point of this halfedge. Keep in mind halfedges are always
    countercockwise.
  getEndpoint(): a method returning an object with an 'x' and a 'y' property
    for the end point of this halfedge. Keep in mind halfedges are always
    countercockwise.

TODO: Identify opportunities for performance improvement.

TODO: Let the user close the Voronoi cells, do not do it automatically. Not only let
      him close the cells, but also allow him to close more than once using a different
      bounding box for the same Voronoi diagram.
*/ /*global Math */ // ---------------------------------------------------------------------------
            function Voronoi() {
                this.vertices = null;
                this.edges = null;
                this.cells = null;
                this.toRecycle = null;
                this.beachsectionJunkyard = [];
                this.circleEventJunkyard = [];
                this.vertexJunkyard = [];
                this.edgeJunkyard = [];
                this.cellJunkyard = [];
            }
            // ---------------------------------------------------------------------------
            Voronoi.prototype.reset = function() {
                if (!this.beachline) this.beachline = new this.RBTree();
                // Move leftover beachsections to the beachsection junkyard.
                if (this.beachline.root) {
                    var beachsection = this.beachline.getFirst(this.beachline.root);
                    while(beachsection){
                        this.beachsectionJunkyard.push(beachsection); // mark for reuse
                        beachsection = beachsection.rbNext;
                    }
                }
                this.beachline.root = null;
                if (!this.circleEvents) this.circleEvents = new this.RBTree();
                this.circleEvents.root = this.firstCircleEvent = null;
                this.vertices = [];
                this.edges = [];
                this.cells = [];
            };
            Voronoi.prototype.sqrt = function(n) {
                return Math.sqrt(n);
            };
            Voronoi.prototype.abs = function(n) {
                return Math.abs(n);
            };
            Voronoi.prototype.\u03B5 = Voronoi.\u03B5 = 1e-9;
            Voronoi.prototype.inv\u03B5 = Voronoi.inv\u03B5 = 1.0 / Voronoi.\u03B5;
            Voronoi.prototype.equalWithEpsilon = function(a, b) {
                return this.abs(a - b) < 1e-9;
            };
            Voronoi.prototype.greaterThanWithEpsilon = function(a, b) {
                return a - b > 1e-9;
            };
            Voronoi.prototype.greaterThanOrEqualWithEpsilon = function(a, b) {
                return b - a < 1e-9;
            };
            Voronoi.prototype.lessThanWithEpsilon = function(a, b) {
                return b - a > 1e-9;
            };
            Voronoi.prototype.lessThanOrEqualWithEpsilon = function(a, b) {
                return a - b < 1e-9;
            };
            // ---------------------------------------------------------------------------
            // Red-Black tree code (based on C version of "rbtree" by Franck Bui-Huu
            // https://github.com/fbuihuu/libtree/blob/master/rb.c
            Voronoi.prototype.RBTree = function() {
                this.root = null;
            };
            Voronoi.prototype.RBTree.prototype.rbInsertSuccessor = function(node, successor) {
                var parent;
                if (node) {
                    // >>> rhill 2011-05-27: Performance: cache previous/next nodes
                    successor.rbPrevious = node;
                    successor.rbNext = node.rbNext;
                    if (node.rbNext) node.rbNext.rbPrevious = successor;
                    node.rbNext = successor;
                    // <<<
                    if (node.rbRight) {
                        // in-place expansion of node.rbRight.getFirst();
                        node = node.rbRight;
                        while(node.rbLeft)node = node.rbLeft;
                        node.rbLeft = successor;
                    } else node.rbRight = successor;
                    parent = node;
                } else if (this.root) {
                    node = this.getFirst(this.root);
                    // >>> Performance: cache previous/next nodes
                    successor.rbPrevious = null;
                    successor.rbNext = node;
                    node.rbPrevious = successor;
                    // <<<
                    node.rbLeft = successor;
                    parent = node;
                } else {
                    // >>> Performance: cache previous/next nodes
                    successor.rbPrevious = successor.rbNext = null;
                    // <<<
                    this.root = successor;
                    parent = null;
                }
                successor.rbLeft = successor.rbRight = null;
                successor.rbParent = parent;
                successor.rbRed = true;
                // Fixup the modified tree by recoloring nodes and performing
                // rotations (2 at most) hence the red-black tree properties are
                // preserved.
                var grandpa, uncle;
                node = successor;
                while(parent && parent.rbRed){
                    grandpa = parent.rbParent;
                    if (parent === grandpa.rbLeft) {
                        uncle = grandpa.rbRight;
                        if (uncle && uncle.rbRed) {
                            parent.rbRed = uncle.rbRed = false;
                            grandpa.rbRed = true;
                            node = grandpa;
                        } else {
                            if (node === parent.rbRight) {
                                this.rbRotateLeft(parent);
                                node = parent;
                                parent = node.rbParent;
                            }
                            parent.rbRed = false;
                            grandpa.rbRed = true;
                            this.rbRotateRight(grandpa);
                        }
                    } else {
                        uncle = grandpa.rbLeft;
                        if (uncle && uncle.rbRed) {
                            parent.rbRed = uncle.rbRed = false;
                            grandpa.rbRed = true;
                            node = grandpa;
                        } else {
                            if (node === parent.rbLeft) {
                                this.rbRotateRight(parent);
                                node = parent;
                                parent = node.rbParent;
                            }
                            parent.rbRed = false;
                            grandpa.rbRed = true;
                            this.rbRotateLeft(grandpa);
                        }
                    }
                    parent = node.rbParent;
                }
                this.root.rbRed = false;
            };
            Voronoi.prototype.RBTree.prototype.rbRemoveNode = function(node) {
                // >>> rhill 2011-05-27: Performance: cache previous/next nodes
                if (node.rbNext) node.rbNext.rbPrevious = node.rbPrevious;
                if (node.rbPrevious) node.rbPrevious.rbNext = node.rbNext;
                node.rbNext = node.rbPrevious = null;
                // <<<
                var parent = node.rbParent, left = node.rbLeft, right = node.rbRight, next;
                if (!left) next = right;
                else if (!right) next = left;
                else next = this.getFirst(right);
                if (parent) {
                    if (parent.rbLeft === node) parent.rbLeft = next;
                    else parent.rbRight = next;
                } else this.root = next;
                // enforce red-black rules
                var isRed;
                if (left && right) {
                    isRed = next.rbRed;
                    next.rbRed = node.rbRed;
                    next.rbLeft = left;
                    left.rbParent = next;
                    if (next !== right) {
                        parent = next.rbParent;
                        next.rbParent = node.rbParent;
                        node = next.rbRight;
                        parent.rbLeft = node;
                        next.rbRight = right;
                        right.rbParent = next;
                    } else {
                        next.rbParent = parent;
                        parent = next;
                        node = next.rbRight;
                    }
                } else {
                    isRed = node.rbRed;
                    node = next;
                }
                // 'node' is now the sole successor's child and 'parent' its
                // new parent (since the successor can have been moved)
                if (node) node.rbParent = parent;
                // the 'easy' cases
                if (isRed) return;
                if (node && node.rbRed) {
                    node.rbRed = false;
                    return;
                }
                // the other cases
                var sibling;
                do {
                    if (node === this.root) break;
                    if (node === parent.rbLeft) {
                        sibling = parent.rbRight;
                        if (sibling.rbRed) {
                            sibling.rbRed = false;
                            parent.rbRed = true;
                            this.rbRotateLeft(parent);
                            sibling = parent.rbRight;
                        }
                        if (sibling.rbLeft && sibling.rbLeft.rbRed || sibling.rbRight && sibling.rbRight.rbRed) {
                            if (!sibling.rbRight || !sibling.rbRight.rbRed) {
                                sibling.rbLeft.rbRed = false;
                                sibling.rbRed = true;
                                this.rbRotateRight(sibling);
                                sibling = parent.rbRight;
                            }
                            sibling.rbRed = parent.rbRed;
                            parent.rbRed = sibling.rbRight.rbRed = false;
                            this.rbRotateLeft(parent);
                            node = this.root;
                            break;
                        }
                    } else {
                        sibling = parent.rbLeft;
                        if (sibling.rbRed) {
                            sibling.rbRed = false;
                            parent.rbRed = true;
                            this.rbRotateRight(parent);
                            sibling = parent.rbLeft;
                        }
                        if (sibling.rbLeft && sibling.rbLeft.rbRed || sibling.rbRight && sibling.rbRight.rbRed) {
                            if (!sibling.rbLeft || !sibling.rbLeft.rbRed) {
                                sibling.rbRight.rbRed = false;
                                sibling.rbRed = true;
                                this.rbRotateLeft(sibling);
                                sibling = parent.rbLeft;
                            }
                            sibling.rbRed = parent.rbRed;
                            parent.rbRed = sibling.rbLeft.rbRed = false;
                            this.rbRotateRight(parent);
                            node = this.root;
                            break;
                        }
                    }
                    sibling.rbRed = true;
                    node = parent;
                    parent = parent.rbParent;
                }while (!node.rbRed);
                if (node) node.rbRed = false;
            };
            Voronoi.prototype.RBTree.prototype.rbRotateLeft = function(node) {
                var p = node, q = node.rbRight, parent = p.rbParent;
                if (parent) {
                    if (parent.rbLeft === p) parent.rbLeft = q;
                    else parent.rbRight = q;
                } else this.root = q;
                q.rbParent = parent;
                p.rbParent = q;
                p.rbRight = q.rbLeft;
                if (p.rbRight) p.rbRight.rbParent = p;
                q.rbLeft = p;
            };
            Voronoi.prototype.RBTree.prototype.rbRotateRight = function(node) {
                var p = node, q = node.rbLeft, parent = p.rbParent;
                if (parent) {
                    if (parent.rbLeft === p) parent.rbLeft = q;
                    else parent.rbRight = q;
                } else this.root = q;
                q.rbParent = parent;
                p.rbParent = q;
                p.rbLeft = q.rbRight;
                if (p.rbLeft) p.rbLeft.rbParent = p;
                q.rbRight = p;
            };
            Voronoi.prototype.RBTree.prototype.getFirst = function(node) {
                while(node.rbLeft)node = node.rbLeft;
                return node;
            };
            Voronoi.prototype.RBTree.prototype.getLast = function(node) {
                while(node.rbRight)node = node.rbRight;
                return node;
            };
            // ---------------------------------------------------------------------------
            // Diagram methods
            Voronoi.prototype.Diagram = function(site) {
                this.site = site;
            };
            // ---------------------------------------------------------------------------
            // Cell methods
            Voronoi.prototype.Cell = function(site) {
                this.site = site;
                this.halfedges = [];
                this.closeMe = false;
            };
            Voronoi.prototype.Cell.prototype.init = function(site) {
                this.site = site;
                this.halfedges = [];
                this.closeMe = false;
                return this;
            };
            Voronoi.prototype.createCell = function(site) {
                var cell = this.cellJunkyard.pop();
                if (cell) return cell.init(site);
                return new this.Cell(site);
            };
            Voronoi.prototype.Cell.prototype.prepareHalfedges = function() {
                var halfedges = this.halfedges, iHalfedge = halfedges.length, edge;
                // get rid of unused halfedges
                // rhill 2011-05-27: Keep it simple, no point here in trying
                // to be fancy: dangling edges are a typically a minority.
                while(iHalfedge--){
                    edge = halfedges[iHalfedge].edge;
                    if (!edge.vb || !edge.va) halfedges.splice(iHalfedge, 1);
                }
                // rhill 2011-05-26: I tried to use a binary search at insertion
                // time to keep the array sorted on-the-fly (in Cell.addHalfedge()).
                // There was no real benefits in doing so, performance on
                // Firefox 3.6 was improved marginally, while performance on
                // Opera 11 was penalized marginally.
                halfedges.sort(function(a, b) {
                    return b.angle - a.angle;
                });
                return halfedges.length;
            };
            // Return a list of the neighbor Ids
            Voronoi.prototype.Cell.prototype.getNeighborIds = function() {
                var neighbors = [], iHalfedge = this.halfedges.length, edge;
                while(iHalfedge--){
                    edge = this.halfedges[iHalfedge].edge;
                    if (edge.lSite !== null && edge.lSite.voronoiId != this.site.voronoiId) neighbors.push(edge.lSite.voronoiId);
                    else if (edge.rSite !== null && edge.rSite.voronoiId != this.site.voronoiId) neighbors.push(edge.rSite.voronoiId);
                }
                return neighbors;
            };
            // Compute bounding box
            //
            Voronoi.prototype.Cell.prototype.getBbox = function() {
                var halfedges = this.halfedges, iHalfedge = halfedges.length, xmin = Infinity, ymin = Infinity, xmax = -Infinity, ymax = -Infinity, v, vx, vy;
                while(iHalfedge--){
                    v = halfedges[iHalfedge].getStartpoint();
                    vx = v.x;
                    vy = v.y;
                    if (vx < xmin) xmin = vx;
                    if (vy < ymin) ymin = vy;
                    if (vx > xmax) xmax = vx;
                    if (vy > ymax) ymax = vy;
                // we dont need to take into account end point,
                // since each end point matches a start point
                }
                return {
                    x: xmin,
                    y: ymin,
                    width: xmax - xmin,
                    height: ymax - ymin
                };
            };
            // Return whether a point is inside, on, or outside the cell:
            //   -1: point is outside the perimeter of the cell
            //    0: point is on the perimeter of the cell
            //    1: point is inside the perimeter of the cell
            //
            Voronoi.prototype.Cell.prototype.pointIntersection = function(x, y) {
                // Check if point in polygon. Since all polygons of a Voronoi
                // diagram are convex, then:
                // http://paulbourke.net/geometry/polygonmesh/
                // Solution 3 (2D):
                //   "If the polygon is convex then one can consider the polygon
                //   "as a 'path' from the first vertex. A point is on the interior
                //   "of this polygons if it is always on the same side of all the
                //   "line segments making up the path. ...
                //   "(y - y0) (x1 - x0) - (x - x0) (y1 - y0)
                //   "if it is less than 0 then P is to the right of the line segment,
                //   "if greater than 0 it is to the left, if equal to 0 then it lies
                //   "on the line segment"
                var halfedges = this.halfedges, iHalfedge = halfedges.length, halfedge, p0, p1, r;
                while(iHalfedge--){
                    halfedge = halfedges[iHalfedge];
                    p0 = halfedge.getStartpoint();
                    p1 = halfedge.getEndpoint();
                    r = (y - p0.y) * (p1.x - p0.x) - (x - p0.x) * (p1.y - p0.y);
                    if (!r) return 0;
                    if (r > 0) return -1;
                }
                return 1;
            };
            // ---------------------------------------------------------------------------
            // Edge methods
            //
            Voronoi.prototype.Vertex = function(x, y) {
                this.x = x;
                this.y = y;
            };
            Voronoi.prototype.Edge = function(lSite, rSite) {
                this.lSite = lSite;
                this.rSite = rSite;
                this.va = this.vb = null;
            };
            Voronoi.prototype.Halfedge = function(edge, lSite, rSite) {
                this.site = lSite;
                this.edge = edge;
                // 'angle' is a value to be used for properly sorting the
                // halfsegments counterclockwise. By convention, we will
                // use the angle of the line defined by the 'site to the left'
                // to the 'site to the right'.
                // However, border edges have no 'site to the right': thus we
                // use the angle of line perpendicular to the halfsegment (the
                // edge should have both end points defined in such case.)
                if (rSite) this.angle = Math.atan2(rSite.y - lSite.y, rSite.x - lSite.x);
                else {
                    var va = edge.va, vb = edge.vb;
                    // rhill 2011-05-31: used to call getStartpoint()/getEndpoint(),
                    // but for performance purpose, these are expanded in place here.
                    this.angle = edge.lSite === lSite ? Math.atan2(vb.x - va.x, va.y - vb.y) : Math.atan2(va.x - vb.x, vb.y - va.y);
                }
            };
            Voronoi.prototype.createHalfedge = function(edge, lSite, rSite) {
                return new this.Halfedge(edge, lSite, rSite);
            };
            Voronoi.prototype.Halfedge.prototype.getStartpoint = function() {
                return this.edge.lSite === this.site ? this.edge.va : this.edge.vb;
            };
            Voronoi.prototype.Halfedge.prototype.getEndpoint = function() {
                return this.edge.lSite === this.site ? this.edge.vb : this.edge.va;
            };
            // this create and add a vertex to the internal collection
            Voronoi.prototype.createVertex = function(x, y) {
                var v = this.vertexJunkyard.pop();
                if (!v) v = new this.Vertex(x, y);
                else {
                    v.x = x;
                    v.y = y;
                }
                this.vertices.push(v);
                return v;
            };
            // this create and add an edge to internal collection, and also create
            // two halfedges which are added to each site's counterclockwise array
            // of halfedges.
            Voronoi.prototype.createEdge = function(lSite, rSite, va, vb) {
                var edge = this.edgeJunkyard.pop();
                if (!edge) edge = new this.Edge(lSite, rSite);
                else {
                    edge.lSite = lSite;
                    edge.rSite = rSite;
                    edge.va = edge.vb = null;
                }
                this.edges.push(edge);
                if (va) this.setEdgeStartpoint(edge, lSite, rSite, va);
                if (vb) this.setEdgeEndpoint(edge, lSite, rSite, vb);
                this.cells[lSite.voronoiId].halfedges.push(this.createHalfedge(edge, lSite, rSite));
                this.cells[rSite.voronoiId].halfedges.push(this.createHalfedge(edge, rSite, lSite));
                return edge;
            };
            Voronoi.prototype.createBorderEdge = function(lSite, va, vb) {
                var edge = this.edgeJunkyard.pop();
                if (!edge) edge = new this.Edge(lSite, null);
                else {
                    edge.lSite = lSite;
                    edge.rSite = null;
                }
                edge.va = va;
                edge.vb = vb;
                this.edges.push(edge);
                return edge;
            };
            Voronoi.prototype.setEdgeStartpoint = function(edge, lSite, rSite, vertex) {
                if (!edge.va && !edge.vb) {
                    edge.va = vertex;
                    edge.lSite = lSite;
                    edge.rSite = rSite;
                } else if (edge.lSite === rSite) edge.vb = vertex;
                else edge.va = vertex;
            };
            Voronoi.prototype.setEdgeEndpoint = function(edge, lSite, rSite, vertex) {
                this.setEdgeStartpoint(edge, rSite, lSite, vertex);
            };
            // ---------------------------------------------------------------------------
            // Beachline methods
            // rhill 2011-06-07: For some reasons, performance suffers significantly
            // when instanciating a literal object instead of an empty ctor
            Voronoi.prototype.Beachsection = function() {};
            // rhill 2011-06-02: A lot of Beachsection instanciations
            // occur during the computation of the Voronoi diagram,
            // somewhere between the number of sites and twice the
            // number of sites, while the number of Beachsections on the
            // beachline at any given time is comparatively low. For this
            // reason, we reuse already created Beachsections, in order
            // to avoid new memory allocation. This resulted in a measurable
            // performance gain.
            Voronoi.prototype.createBeachsection = function(site) {
                var beachsection = this.beachsectionJunkyard.pop();
                if (!beachsection) beachsection = new this.Beachsection();
                beachsection.site = site;
                return beachsection;
            };
            // calculate the left break point of a particular beach section,
            // given a particular sweep line
            Voronoi.prototype.leftBreakPoint = function(arc, directrix) {
                // http://en.wikipedia.org/wiki/Parabola
                // http://en.wikipedia.org/wiki/Quadratic_equation
                // h1 = x1,
                // k1 = (y1+directrix)/2,
                // h2 = x2,
                // k2 = (y2+directrix)/2,
                // p1 = k1-directrix,
                // a1 = 1/(4*p1),
                // b1 = -h1/(2*p1),
                // c1 = h1*h1/(4*p1)+k1,
                // p2 = k2-directrix,
                // a2 = 1/(4*p2),
                // b2 = -h2/(2*p2),
                // c2 = h2*h2/(4*p2)+k2,
                // x = (-(b2-b1) + Math.sqrt((b2-b1)*(b2-b1) - 4*(a2-a1)*(c2-c1))) / (2*(a2-a1))
                // When x1 become the x-origin:
                // h1 = 0,
                // k1 = (y1+directrix)/2,
                // h2 = x2-x1,
                // k2 = (y2+directrix)/2,
                // p1 = k1-directrix,
                // a1 = 1/(4*p1),
                // b1 = 0,
                // c1 = k1,
                // p2 = k2-directrix,
                // a2 = 1/(4*p2),
                // b2 = -h2/(2*p2),
                // c2 = h2*h2/(4*p2)+k2,
                // x = (-b2 + Math.sqrt(b2*b2 - 4*(a2-a1)*(c2-k1))) / (2*(a2-a1)) + x1
                // change code below at your own risk: care has been taken to
                // reduce errors due to computers' finite arithmetic precision.
                // Maybe can still be improved, will see if any more of this
                // kind of errors pop up again.
                var site = arc.site, rfocx = site.x, rfocy = site.y, pby2 = rfocy - directrix;
                // parabola in degenerate case where focus is on directrix
                if (!pby2) return rfocx;
                var lArc = arc.rbPrevious;
                if (!lArc) return -Infinity;
                site = lArc.site;
                var lfocx = site.x, lfocy = site.y, plby2 = lfocy - directrix;
                // parabola in degenerate case where focus is on directrix
                if (!plby2) return lfocx;
                var hl = lfocx - rfocx, aby2 = 1 / pby2 - 1 / plby2, b = hl / plby2;
                if (aby2) return (-b + this.sqrt(b * b - 2 * aby2 * (hl * hl / (-2 * plby2) - lfocy + plby2 / 2 + rfocy - pby2 / 2))) / aby2 + rfocx;
                // both parabolas have same distance to directrix, thus break point is midway
                return (rfocx + lfocx) / 2;
            };
            // calculate the right break point of a particular beach section,
            // given a particular directrix
            Voronoi.prototype.rightBreakPoint = function(arc, directrix) {
                var rArc = arc.rbNext;
                if (rArc) return this.leftBreakPoint(rArc, directrix);
                var site = arc.site;
                return site.y === directrix ? site.x : Infinity;
            };
            Voronoi.prototype.detachBeachsection = function(beachsection) {
                this.detachCircleEvent(beachsection); // detach potentially attached circle event
                this.beachline.rbRemoveNode(beachsection); // remove from RB-tree
                this.beachsectionJunkyard.push(beachsection); // mark for reuse
            };
            Voronoi.prototype.removeBeachsection = function(beachsection) {
                var circle = beachsection.circleEvent, x = circle.x, y = circle.ycenter, vertex = this.createVertex(x, y), previous = beachsection.rbPrevious, next = beachsection.rbNext, disappearingTransitions = [
                    beachsection
                ], abs_fn = Math.abs;
                // remove collapsed beachsection from beachline
                this.detachBeachsection(beachsection);
                // there could be more than one empty arc at the deletion point, this
                // happens when more than two edges are linked by the same vertex,
                // so we will collect all those edges by looking up both sides of
                // the deletion point.
                // by the way, there is *always* a predecessor/successor to any collapsed
                // beach section, it's just impossible to have a collapsing first/last
                // beach sections on the beachline, since they obviously are unconstrained
                // on their left/right side.
                // look left
                var lArc = previous;
                while(lArc.circleEvent && abs_fn(x - lArc.circleEvent.x) < 1e-9 && abs_fn(y - lArc.circleEvent.ycenter) < 1e-9){
                    previous = lArc.rbPrevious;
                    disappearingTransitions.unshift(lArc);
                    this.detachBeachsection(lArc); // mark for reuse
                    lArc = previous;
                }
                // even though it is not disappearing, I will also add the beach section
                // immediately to the left of the left-most collapsed beach section, for
                // convenience, since we need to refer to it later as this beach section
                // is the 'left' site of an edge for which a start point is set.
                disappearingTransitions.unshift(lArc);
                this.detachCircleEvent(lArc);
                // look right
                var rArc = next;
                while(rArc.circleEvent && abs_fn(x - rArc.circleEvent.x) < 1e-9 && abs_fn(y - rArc.circleEvent.ycenter) < 1e-9){
                    next = rArc.rbNext;
                    disappearingTransitions.push(rArc);
                    this.detachBeachsection(rArc); // mark for reuse
                    rArc = next;
                }
                // we also have to add the beach section immediately to the right of the
                // right-most collapsed beach section, since there is also a disappearing
                // transition representing an edge's start point on its left.
                disappearingTransitions.push(rArc);
                this.detachCircleEvent(rArc);
                // walk through all the disappearing transitions between beach sections and
                // set the start point of their (implied) edge.
                var nArcs = disappearingTransitions.length, iArc;
                for(iArc = 1; iArc < nArcs; iArc++){
                    rArc = disappearingTransitions[iArc];
                    lArc = disappearingTransitions[iArc - 1];
                    this.setEdgeStartpoint(rArc.edge, lArc.site, rArc.site, vertex);
                }
                // create a new edge as we have now a new transition between
                // two beach sections which were previously not adjacent.
                // since this edge appears as a new vertex is defined, the vertex
                // actually define an end point of the edge (relative to the site
                // on the left)
                lArc = disappearingTransitions[0];
                rArc = disappearingTransitions[nArcs - 1];
                rArc.edge = this.createEdge(lArc.site, rArc.site, undefined, vertex);
                // create circle events if any for beach sections left in the beachline
                // adjacent to collapsed sections
                this.attachCircleEvent(lArc);
                this.attachCircleEvent(rArc);
            };
            Voronoi.prototype.addBeachsection = function(site) {
                var x = site.x, directrix = site.y;
                // find the left and right beach sections which will surround the newly
                // created beach section.
                // rhill 2011-06-01: This loop is one of the most often executed,
                // hence we expand in-place the comparison-against-epsilon calls.
                var lArc, rArc, dxl, dxr, node = this.beachline.root;
                while(node){
                    dxl = this.leftBreakPoint(node, directrix) - x;
                    // x lessThanWithEpsilon xl => falls somewhere before the left edge of the beachsection
                    if (dxl > 1e-9) // this case should never happen
                    // if (!node.rbLeft) {
                    //    rArc = node.rbLeft;
                    //    break;
                    //    }
                    node = node.rbLeft;
                    else {
                        dxr = x - this.rightBreakPoint(node, directrix);
                        // x greaterThanWithEpsilon xr => falls somewhere after the right edge of the beachsection
                        if (dxr > 1e-9) {
                            if (!node.rbRight) {
                                lArc = node;
                                break;
                            }
                            node = node.rbRight;
                        } else {
                            // x equalWithEpsilon xl => falls exactly on the left edge of the beachsection
                            if (dxl > -0.000000001) {
                                lArc = node.rbPrevious;
                                rArc = node;
                            } else if (dxr > -0.000000001) {
                                lArc = node;
                                rArc = node.rbNext;
                            } else lArc = rArc = node;
                            break;
                        }
                    }
                }
                // at this point, keep in mind that lArc and/or rArc could be
                // undefined or null.
                // create a new beach section object for the site and add it to RB-tree
                var newArc = this.createBeachsection(site);
                this.beachline.rbInsertSuccessor(lArc, newArc);
                // cases:
                //
                // [null,null]
                // least likely case: new beach section is the first beach section on the
                // beachline.
                // This case means:
                //   no new transition appears
                //   no collapsing beach section
                //   new beachsection become root of the RB-tree
                if (!lArc && !rArc) return;
                // [lArc,rArc] where lArc == rArc
                // most likely case: new beach section split an existing beach
                // section.
                // This case means:
                //   one new transition appears
                //   the left and right beach section might be collapsing as a result
                //   two new nodes added to the RB-tree
                if (lArc === rArc) {
                    // invalidate circle event of split beach section
                    this.detachCircleEvent(lArc);
                    // split the beach section into two separate beach sections
                    rArc = this.createBeachsection(lArc.site);
                    this.beachline.rbInsertSuccessor(newArc, rArc);
                    // since we have a new transition between two beach sections,
                    // a new edge is born
                    newArc.edge = rArc.edge = this.createEdge(lArc.site, newArc.site);
                    // check whether the left and right beach sections are collapsing
                    // and if so create circle events, to be notified when the point of
                    // collapse is reached.
                    this.attachCircleEvent(lArc);
                    this.attachCircleEvent(rArc);
                    return;
                }
                // [lArc,null]
                // even less likely case: new beach section is the *last* beach section
                // on the beachline -- this can happen *only* if *all* the previous beach
                // sections currently on the beachline share the same y value as
                // the new beach section.
                // This case means:
                //   one new transition appears
                //   no collapsing beach section as a result
                //   new beach section become right-most node of the RB-tree
                if (lArc && !rArc) {
                    newArc.edge = this.createEdge(lArc.site, newArc.site);
                    return;
                }
                // [null,rArc]
                // impossible case: because sites are strictly processed from top to bottom,
                // and left to right, which guarantees that there will always be a beach section
                // on the left -- except of course when there are no beach section at all on
                // the beach line, which case was handled above.
                // rhill 2011-06-02: No point testing in non-debug version
                //if (!lArc && rArc) {
                //    throw "Voronoi.addBeachsection(): What is this I don't even";
                //    }
                // [lArc,rArc] where lArc != rArc
                // somewhat less likely case: new beach section falls *exactly* in between two
                // existing beach sections
                // This case means:
                //   one transition disappears
                //   two new transitions appear
                //   the left and right beach section might be collapsing as a result
                //   only one new node added to the RB-tree
                if (lArc !== rArc) {
                    // invalidate circle events of left and right sites
                    this.detachCircleEvent(lArc);
                    this.detachCircleEvent(rArc);
                    // an existing transition disappears, meaning a vertex is defined at
                    // the disappearance point.
                    // since the disappearance is caused by the new beachsection, the
                    // vertex is at the center of the circumscribed circle of the left,
                    // new and right beachsections.
                    // http://mathforum.org/library/drmath/view/55002.html
                    // Except that I bring the origin at A to simplify
                    // calculation
                    var lSite = lArc.site, ax = lSite.x, ay = lSite.y, bx = site.x - ax, by = site.y - ay, rSite = rArc.site, cx = rSite.x - ax, cy = rSite.y - ay, d = 2 * (bx * cy - by * cx), hb = bx * bx + by * by, hc = cx * cx + cy * cy, vertex = this.createVertex((cy * hb - by * hc) / d + ax, (bx * hc - cx * hb) / d + ay);
                    // one transition disappear
                    this.setEdgeStartpoint(rArc.edge, lSite, rSite, vertex);
                    // two new transitions appear at the new vertex location
                    newArc.edge = this.createEdge(lSite, site, undefined, vertex);
                    rArc.edge = this.createEdge(site, rSite, undefined, vertex);
                    // check whether the left and right beach sections are collapsing
                    // and if so create circle events, to handle the point of collapse.
                    this.attachCircleEvent(lArc);
                    this.attachCircleEvent(rArc);
                    return;
                }
            };
            // ---------------------------------------------------------------------------
            // Circle event methods
            // rhill 2011-06-07: For some reasons, performance suffers significantly
            // when instanciating a literal object instead of an empty ctor
            Voronoi.prototype.CircleEvent = function() {
                // rhill 2013-10-12: it helps to state exactly what we are at ctor time.
                this.arc = null;
                this.rbLeft = null;
                this.rbNext = null;
                this.rbParent = null;
                this.rbPrevious = null;
                this.rbRed = false;
                this.rbRight = null;
                this.site = null;
                this.x = this.y = this.ycenter = 0;
            };
            Voronoi.prototype.attachCircleEvent = function(arc) {
                var lArc = arc.rbPrevious, rArc = arc.rbNext;
                if (!lArc || !rArc) return;
                 // does that ever happen?
                var lSite = lArc.site, cSite = arc.site, rSite = rArc.site;
                // If site of left beachsection is same as site of
                // right beachsection, there can't be convergence
                if (lSite === rSite) return;
                // Find the circumscribed circle for the three sites associated
                // with the beachsection triplet.
                // rhill 2011-05-26: It is more efficient to calculate in-place
                // rather than getting the resulting circumscribed circle from an
                // object returned by calling Voronoi.circumcircle()
                // http://mathforum.org/library/drmath/view/55002.html
                // Except that I bring the origin at cSite to simplify calculations.
                // The bottom-most part of the circumcircle is our Fortune 'circle
                // event', and its center is a vertex potentially part of the final
                // Voronoi diagram.
                var bx = cSite.x, by = cSite.y, ax = lSite.x - bx, ay = lSite.y - by, cx = rSite.x - bx, cy = rSite.y - by;
                // If points l->c->r are clockwise, then center beach section does not
                // collapse, hence it can't end up as a vertex (we reuse 'd' here, which
                // sign is reverse of the orientation, hence we reverse the test.
                // http://en.wikipedia.org/wiki/Curve_orientation#Orientation_of_a_simple_polygon
                // rhill 2011-05-21: Nasty finite precision error which caused circumcircle() to
                // return infinites: 1e-12 seems to fix the problem.
                var d = 2 * (ax * cy - ay * cx);
                if (d >= -0.000000000002) return;
                var ha = ax * ax + ay * ay, hc = cx * cx + cy * cy, x = (cy * ha - ay * hc) / d, y = (ax * hc - cx * ha) / d, ycenter = y + by;
                // Important: ybottom should always be under or at sweep, so no need
                // to waste CPU cycles by checking
                // recycle circle event object if possible
                var circleEvent = this.circleEventJunkyard.pop();
                if (!circleEvent) circleEvent = new this.CircleEvent();
                circleEvent.arc = arc;
                circleEvent.site = cSite;
                circleEvent.x = x + bx;
                circleEvent.y = ycenter + this.sqrt(x * x + y * y); // y bottom
                circleEvent.ycenter = ycenter;
                arc.circleEvent = circleEvent;
                // find insertion point in RB-tree: circle events are ordered from
                // smallest to largest
                var predecessor = null, node = this.circleEvents.root;
                while(node){
                    if (circleEvent.y < node.y || circleEvent.y === node.y && circleEvent.x <= node.x) {
                        if (node.rbLeft) node = node.rbLeft;
                        else {
                            predecessor = node.rbPrevious;
                            break;
                        }
                    } else if (node.rbRight) node = node.rbRight;
                    else {
                        predecessor = node;
                        break;
                    }
                }
                this.circleEvents.rbInsertSuccessor(predecessor, circleEvent);
                if (!predecessor) this.firstCircleEvent = circleEvent;
            };
            Voronoi.prototype.detachCircleEvent = function(arc) {
                var circleEvent = arc.circleEvent;
                if (circleEvent) {
                    if (!circleEvent.rbPrevious) this.firstCircleEvent = circleEvent.rbNext;
                    this.circleEvents.rbRemoveNode(circleEvent); // remove from RB-tree
                    this.circleEventJunkyard.push(circleEvent);
                    arc.circleEvent = null;
                }
            };
            // ---------------------------------------------------------------------------
            // Diagram completion methods
            // connect dangling edges (not if a cursory test tells us
            // it is not going to be visible.
            // return value:
            //   false: the dangling endpoint couldn't be connected
            //   true: the dangling endpoint could be connected
            Voronoi.prototype.connectEdge = function(edge, bbox) {
                // skip if end point already connected
                var vb = edge.vb;
                if (!!vb) return true;
                // make local copy for performance purpose
                var va = edge.va, xl = bbox.xl, xr = bbox.xr, yt = bbox.yt, yb = bbox.yb, lSite = edge.lSite, rSite = edge.rSite, lx = lSite.x, ly = lSite.y, rx = rSite.x, ry = rSite.y, fx = (lx + rx) / 2, fy = (ly + ry) / 2, fm, fb;
                // if we reach here, this means cells which use this edge will need
                // to be closed, whether because the edge was removed, or because it
                // was connected to the bounding box.
                this.cells[lSite.voronoiId].closeMe = true;
                this.cells[rSite.voronoiId].closeMe = true;
                // get the line equation of the bisector if line is not vertical
                if (ry !== ly) {
                    fm = (lx - rx) / (ry - ly);
                    fb = fy - fm * fx;
                }
                // remember, direction of line (relative to left site):
                // upward: left.x < right.x
                // downward: left.x > right.x
                // horizontal: left.x == right.x
                // upward: left.x < right.x
                // rightward: left.y < right.y
                // leftward: left.y > right.y
                // vertical: left.y == right.y
                // depending on the direction, find the best side of the
                // bounding box to use to determine a reasonable start point
                // rhill 2013-12-02:
                // While at it, since we have the values which define the line,
                // clip the end of va if it is outside the bbox.
                // https://github.com/gorhill/Javascript-Voronoi/issues/15
                // TODO: Do all the clipping here rather than rely on Liang-Barsky
                // which does not do well sometimes due to loss of arithmetic
                // precision. The code here doesn't degrade if one of the vertex is
                // at a huge distance.
                // special case: vertical line
                if (fm === undefined) {
                    // doesn't intersect with viewport
                    if (fx < xl || fx >= xr) return false;
                    // downward
                    if (lx > rx) {
                        if (!va || va.y < yt) va = this.createVertex(fx, yt);
                        else if (va.y >= yb) return false;
                        vb = this.createVertex(fx, yb);
                    } else {
                        if (!va || va.y > yb) va = this.createVertex(fx, yb);
                        else if (va.y < yt) return false;
                        vb = this.createVertex(fx, yt);
                    }
                } else if (fm < -1 || fm > 1) {
                    // downward
                    if (lx > rx) {
                        if (!va || va.y < yt) va = this.createVertex((yt - fb) / fm, yt);
                        else if (va.y >= yb) return false;
                        vb = this.createVertex((yb - fb) / fm, yb);
                    } else {
                        if (!va || va.y > yb) va = this.createVertex((yb - fb) / fm, yb);
                        else if (va.y < yt) return false;
                        vb = this.createVertex((yt - fb) / fm, yt);
                    }
                } else // rightward
                if (ly < ry) {
                    if (!va || va.x < xl) va = this.createVertex(xl, fm * xl + fb);
                    else if (va.x >= xr) return false;
                    vb = this.createVertex(xr, fm * xr + fb);
                } else {
                    if (!va || va.x > xr) va = this.createVertex(xr, fm * xr + fb);
                    else if (va.x < xl) return false;
                    vb = this.createVertex(xl, fm * xl + fb);
                }
                edge.va = va;
                edge.vb = vb;
                return true;
            };
            // line-clipping code taken from:
            //   Liang-Barsky function by Daniel White
            //   http://www.skytopia.com/project/articles/compsci/clipping.html
            // Thanks!
            // A bit modified to minimize code paths
            Voronoi.prototype.clipEdge = function(edge, bbox) {
                var ax = edge.va.x, ay = edge.va.y, bx = edge.vb.x, by = edge.vb.y, t0 = 0, t1 = 1, dx = bx - ax, dy = by - ay;
                // left
                var q = ax - bbox.xl;
                if (dx === 0 && q < 0) return false;
                var r = -q / dx;
                if (dx < 0) {
                    if (r < t0) return false;
                    if (r < t1) t1 = r;
                } else if (dx > 0) {
                    if (r > t1) return false;
                    if (r > t0) t0 = r;
                }
                // right
                q = bbox.xr - ax;
                if (dx === 0 && q < 0) return false;
                r = q / dx;
                if (dx < 0) {
                    if (r > t1) return false;
                    if (r > t0) t0 = r;
                } else if (dx > 0) {
                    if (r < t0) return false;
                    if (r < t1) t1 = r;
                }
                // top
                q = ay - bbox.yt;
                if (dy === 0 && q < 0) return false;
                r = -q / dy;
                if (dy < 0) {
                    if (r < t0) return false;
                    if (r < t1) t1 = r;
                } else if (dy > 0) {
                    if (r > t1) return false;
                    if (r > t0) t0 = r;
                }
                // bottom
                q = bbox.yb - ay;
                if (dy === 0 && q < 0) return false;
                r = q / dy;
                if (dy < 0) {
                    if (r > t1) return false;
                    if (r > t0) t0 = r;
                } else if (dy > 0) {
                    if (r < t0) return false;
                    if (r < t1) t1 = r;
                }
                // if we reach this point, Voronoi edge is within bbox
                // if t0 > 0, va needs to change
                // rhill 2011-06-03: we need to create a new vertex rather
                // than modifying the existing one, since the existing
                // one is likely shared with at least another edge
                if (t0 > 0) edge.va = this.createVertex(ax + t0 * dx, ay + t0 * dy);
                // if t1 < 1, vb needs to change
                // rhill 2011-06-03: we need to create a new vertex rather
                // than modifying the existing one, since the existing
                // one is likely shared with at least another edge
                if (t1 < 1) edge.vb = this.createVertex(ax + t1 * dx, ay + t1 * dy);
                // va and/or vb were clipped, thus we will need to close
                // cells which use this edge.
                if (t0 > 0 || t1 < 1) {
                    this.cells[edge.lSite.voronoiId].closeMe = true;
                    this.cells[edge.rSite.voronoiId].closeMe = true;
                }
                return true;
            };
            // Connect/cut edges at bounding box
            Voronoi.prototype.clipEdges = function(bbox) {
                // connect all dangling edges to bounding box
                // or get rid of them if it can't be done
                var edges = this.edges, iEdge = edges.length, edge, abs_fn = Math.abs;
                // iterate backward so we can splice safely
                while(iEdge--){
                    edge = edges[iEdge];
                    // edge is removed if:
                    //   it is wholly outside the bounding box
                    //   it is looking more like a point than a line
                    if (!this.connectEdge(edge, bbox) || !this.clipEdge(edge, bbox) || abs_fn(edge.va.x - edge.vb.x) < 1e-9 && abs_fn(edge.va.y - edge.vb.y) < 1e-9) {
                        edge.va = edge.vb = null;
                        edges.splice(iEdge, 1);
                    }
                }
            };
            // Close the cells.
            // The cells are bound by the supplied bounding box.
            // Each cell refers to its associated site, and a list
            // of halfedges ordered counterclockwise.
            Voronoi.prototype.closeCells = function(bbox) {
                var xl = bbox.xl, xr = bbox.xr, yt = bbox.yt, yb = bbox.yb, cells = this.cells, iCell = cells.length, cell, iLeft, halfedges, nHalfedges, edge, va, vb, vz, lastBorderSegment, abs_fn = Math.abs;
                while(iCell--){
                    cell = cells[iCell];
                    // prune, order halfedges counterclockwise, then add missing ones
                    // required to close cells
                    if (!cell.prepareHalfedges()) continue;
                    if (!cell.closeMe) continue;
                    // find first 'unclosed' point.
                    // an 'unclosed' point will be the end point of a halfedge which
                    // does not match the start point of the following halfedge
                    halfedges = cell.halfedges;
                    nHalfedges = halfedges.length;
                    // special case: only one site, in which case, the viewport is the cell
                    // ...
                    // all other cases
                    iLeft = 0;
                    while(iLeft < nHalfedges){
                        va = halfedges[iLeft].getEndpoint();
                        vz = halfedges[(iLeft + 1) % nHalfedges].getStartpoint();
                        // if end point is not equal to start point, we need to add the missing
                        // halfedge(s) up to vz
                        if (abs_fn(va.x - vz.x) >= 1e-9 || abs_fn(va.y - vz.y) >= 1e-9) // rhill 2013-12-02:
                        // "Holes" in the halfedges are not necessarily always adjacent.
                        // https://github.com/gorhill/Javascript-Voronoi/issues/16
                        // find entry point:
                        switch(true){
                            // walk downward along left side
                            case this.equalWithEpsilon(va.x, xl) && this.lessThanWithEpsilon(va.y, yb):
                                lastBorderSegment = this.equalWithEpsilon(vz.x, xl);
                                vb = this.createVertex(xl, lastBorderSegment ? vz.y : yb);
                                edge = this.createBorderEdge(cell.site, va, vb);
                                iLeft++;
                                halfedges.splice(iLeft, 0, this.createHalfedge(edge, cell.site, null));
                                nHalfedges++;
                                if (lastBorderSegment) break;
                                va = vb;
                            // fall through
                            // walk rightward along bottom side
                            case this.equalWithEpsilon(va.y, yb) && this.lessThanWithEpsilon(va.x, xr):
                                lastBorderSegment = this.equalWithEpsilon(vz.y, yb);
                                vb = this.createVertex(lastBorderSegment ? vz.x : xr, yb);
                                edge = this.createBorderEdge(cell.site, va, vb);
                                iLeft++;
                                halfedges.splice(iLeft, 0, this.createHalfedge(edge, cell.site, null));
                                nHalfedges++;
                                if (lastBorderSegment) break;
                                va = vb;
                            // fall through
                            // walk upward along right side
                            case this.equalWithEpsilon(va.x, xr) && this.greaterThanWithEpsilon(va.y, yt):
                                lastBorderSegment = this.equalWithEpsilon(vz.x, xr);
                                vb = this.createVertex(xr, lastBorderSegment ? vz.y : yt);
                                edge = this.createBorderEdge(cell.site, va, vb);
                                iLeft++;
                                halfedges.splice(iLeft, 0, this.createHalfedge(edge, cell.site, null));
                                nHalfedges++;
                                if (lastBorderSegment) break;
                                va = vb;
                            // fall through
                            // walk leftward along top side
                            case this.equalWithEpsilon(va.y, yt) && this.greaterThanWithEpsilon(va.x, xl):
                                lastBorderSegment = this.equalWithEpsilon(vz.y, yt);
                                vb = this.createVertex(lastBorderSegment ? vz.x : xl, yt);
                                edge = this.createBorderEdge(cell.site, va, vb);
                                iLeft++;
                                halfedges.splice(iLeft, 0, this.createHalfedge(edge, cell.site, null));
                                nHalfedges++;
                                if (lastBorderSegment) break;
                                va = vb;
                                // fall through
                                // walk downward along left side
                                lastBorderSegment = this.equalWithEpsilon(vz.x, xl);
                                vb = this.createVertex(xl, lastBorderSegment ? vz.y : yb);
                                edge = this.createBorderEdge(cell.site, va, vb);
                                iLeft++;
                                halfedges.splice(iLeft, 0, this.createHalfedge(edge, cell.site, null));
                                nHalfedges++;
                                if (lastBorderSegment) break;
                                va = vb;
                                // fall through
                                // walk rightward along bottom side
                                lastBorderSegment = this.equalWithEpsilon(vz.y, yb);
                                vb = this.createVertex(lastBorderSegment ? vz.x : xr, yb);
                                edge = this.createBorderEdge(cell.site, va, vb);
                                iLeft++;
                                halfedges.splice(iLeft, 0, this.createHalfedge(edge, cell.site, null));
                                nHalfedges++;
                                if (lastBorderSegment) break;
                                va = vb;
                                // fall through
                                // walk upward along right side
                                lastBorderSegment = this.equalWithEpsilon(vz.x, xr);
                                vb = this.createVertex(xr, lastBorderSegment ? vz.y : yt);
                                edge = this.createBorderEdge(cell.site, va, vb);
                                iLeft++;
                                halfedges.splice(iLeft, 0, this.createHalfedge(edge, cell.site, null));
                                nHalfedges++;
                                if (lastBorderSegment) break;
                            // fall through
                            default:
                                throw "Voronoi.closeCells() > this makes no sense!";
                        }
                        iLeft++;
                    }
                    cell.closeMe = false;
                }
            };
            // ---------------------------------------------------------------------------
            // Debugging helper
            /*
Voronoi.prototype.dumpBeachline = function(y) {
    console.log('Voronoi.dumpBeachline(%f) > Beachsections, from left to right:', y);
    if ( !this.beachline ) {
        console.log('  None');
        }
    else {
        var bs = this.beachline.getFirst(this.beachline.root);
        while ( bs ) {
            console.log('  site %d: xl: %f, xr: %f', bs.site.voronoiId, this.leftBreakPoint(bs, y), this.rightBreakPoint(bs, y));
            bs = bs.rbNext;
            }
        }
    };
*/ // ---------------------------------------------------------------------------
            // Helper: Quantize sites
            // rhill 2013-10-12:
            // This is to solve https://github.com/gorhill/Javascript-Voronoi/issues/15
            // Since not all users will end up using the kind of coord values which would
            // cause the issue to arise, I chose to let the user decide whether or not
            // he should sanitize his coord values through this helper. This way, for
            // those users who uses coord values which are known to be fine, no overhead is
            // added.
            Voronoi.prototype.quantizeSites = function(sites) {
                var \u03B5 = this.\u03B5, n = sites.length, site;
                while(n--){
                    site = sites[n];
                    site.x = Math.floor(site.x / \u03B5) * \u03B5;
                    site.y = Math.floor(site.y / \u03B5) * \u03B5;
                }
            };
            // ---------------------------------------------------------------------------
            // Helper: Recycle diagram: all vertex, edge and cell objects are
            // "surrendered" to the Voronoi object for reuse.
            // TODO: rhill-voronoi-core v2: more performance to be gained
            // when I change the semantic of what is returned.
            Voronoi.prototype.recycle = function(diagram) {
                if (diagram) {
                    if (diagram instanceof this.Diagram) this.toRecycle = diagram;
                    else throw 'Voronoi.recycleDiagram() > Need a Diagram object.';
                }
            };
            // ---------------------------------------------------------------------------
            // Top-level Fortune loop
            // rhill 2011-05-19:
            //   Voronoi sites are kept client-side now, to allow
            //   user to freely modify content. At compute time,
            //   *references* to sites are copied locally.
            Voronoi.prototype.compute = function(sites, bbox) {
                // to measure execution time
                var startTime = new Date();
                // init internal state
                this.reset();
                // any diagram data available for recycling?
                // I do that here so that this is included in execution time
                if (this.toRecycle) {
                    this.vertexJunkyard = this.vertexJunkyard.concat(this.toRecycle.vertices);
                    this.edgeJunkyard = this.edgeJunkyard.concat(this.toRecycle.edges);
                    this.cellJunkyard = this.cellJunkyard.concat(this.toRecycle.cells);
                    this.toRecycle = null;
                }
                // Initialize site event queue
                var siteEvents = sites.slice(0);
                siteEvents.sort(function(a, b) {
                    var r = b.y - a.y;
                    if (r) return r;
                    return b.x - a.x;
                });
                // process queue
                var site = siteEvents.pop(), siteid = 0, xsitex, xsitey, cells = this.cells, circle;
                // main loop
                for(;;){
                    // we need to figure whether we handle a site or circle event
                    // for this we find out if there is a site event and it is
                    // 'earlier' than the circle event
                    circle = this.firstCircleEvent;
                    // add beach section
                    if (site && (!circle || site.y < circle.y || site.y === circle.y && site.x < circle.x)) {
                        // only if site is not a duplicate
                        if (site.x !== xsitex || site.y !== xsitey) {
                            // first create cell for new site
                            cells[siteid] = this.createCell(site);
                            site.voronoiId = siteid++;
                            // then create a beachsection for that site
                            this.addBeachsection(site);
                            // remember last site coords to detect duplicate
                            xsitey = site.y;
                            xsitex = site.x;
                        }
                        site = siteEvents.pop();
                    } else if (circle) this.removeBeachsection(circle.arc);
                    else break;
                }
                // wrapping-up:
                //   connect dangling edges to bounding box
                //   cut edges as per bounding box
                //   discard edges completely outside bounding box
                //   discard edges which are point-like
                this.clipEdges(bbox);
                //   add missing edges in order to close opened cells
                this.closeCells(bbox);
                // to measure execution time
                var stopTime = new Date();
                // prepare return values
                var diagram = new this.Diagram();
                diagram.cells = this.cells;
                diagram.edges = this.edges;
                diagram.vertices = this.vertices;
                diagram.execTime = stopTime.getTime() - startTime.getTime();
                // clean up
                this.reset();
                return diagram;
            };
            module1.exports = Voronoi;
        /***/ },
        /* 3 */ /***/ function(module1, exports) {
            module1.exports = __WEBPACK_EXTERNAL_MODULE_3__;
        /***/ }
    ]);
});

});
parcelRegister("29IVF", function(module, exports) {
var __dirname = "node_modules/weaverjs/dist";
/*!
Copyright © 2016 Max Franz

Permission is hereby granted, free of charge, to any person obtaining a copy of
this software and associated documentation files (the “Software”), to deal in
the Software without restriction, including without limitation the rights to
use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies
of the Software, and to permit persons to whom the Software is furnished to do
so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all
copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED “AS IS”, WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
SOFTWARE.
*/ (function(f) {
    var g;
    module.exports = f();
})(function() {
    var define, module1, exports;
    return (function e(t, n, r) {
        function s(o, u) {
            if (!n[o]) {
                if (!t[o]) {
                    var a = undefined;
                    if (!u && a) return a(o, !0);
                    if (i) return i(o, !0);
                    var f = new Error("Cannot find module '" + o + "'");
                    throw f.code = "MODULE_NOT_FOUND", f;
                }
                var l = n[o] = {
                    exports: {}
                };
                t[o][0].call(l.exports, function(e) {
                    var n = t[o][1][e];
                    return s(n ? n : e);
                }, l, l.exports, e, t, n, r);
            }
            return n[o].exports;
        }
        var i = undefined;
        for(var o = 0; o < r.length; o++)s(r[o]);
        return s;
    })({
        1: [
            function(_dereq_, module1, exports) {
                'use strict';
                var is = _dereq_('./is');
                var util = _dereq_('./util');
                var Promise = _dereq_('./promise');
                var Event = _dereq_('./event');
                var define = {
                    // event function reusable stuff
                    event: {
                        regex: /(\w+)(\.\w+)?/,
                        optionalTypeRegex: /(\w+)?(\.\w+)?/,
                        falseCallback: function() {
                            return false;
                        }
                    },
                    // event binding
                    on: function(params) {
                        var defaults = {
                            unbindSelfOnTrigger: false,
                            unbindAllBindersOnTrigger: false
                        };
                        params = util.extend({}, defaults, params);
                        return function onImpl(events, data, callback) {
                            var self = this;
                            var selfIsArrayLike = self.length !== undefined;
                            var all = selfIsArrayLike ? self : [
                                self
                            ]; // put in array if not array-like
                            var eventsIsString = is.string(events);
                            var p = params;
                            if (is.fn(data) || data === false) {
                                callback = data;
                                data = undefined;
                            }
                            // if there isn't a callback, we can't really do anything
                            // (can't speak for mapped events arg version)
                            if (!(is.fn(callback) || callback === false) && eventsIsString) return self; // maintain chaining
                            if (eventsIsString) {
                                var map = {};
                                map[events] = callback;
                                events = map;
                            }
                            for(var evts in events){
                                callback = events[evts];
                                if (callback === false) callback = define.event.falseCallback;
                                if (!is.fn(callback)) continue;
                                evts = evts.split(/\s+/);
                                for(var i = 0; i < evts.length; i++){
                                    var evt = evts[i];
                                    if (is.emptyString(evt)) continue;
                                    var match = evt.match(define.event.regex); // type[.namespace]
                                    if (match) {
                                        var type = match[1];
                                        var namespace = match[2] ? match[2] : undefined;
                                        var listener = {
                                            callback: callback,
                                            data: data,
                                            type: type,
                                            namespace: namespace,
                                            unbindSelfOnTrigger: p.unbindSelfOnTrigger,
                                            unbindAllBindersOnTrigger: p.unbindAllBindersOnTrigger,
                                            binders: all // who bound together
                                        };
                                        for(var j = 0; j < all.length; j++){
                                            var _p = all[j]._private;
                                            _p.listeners = _p.listeners || [];
                                            _p.listeners.push(listener);
                                        }
                                    }
                                } // for events array
                            } // for events map
                            return self; // maintain chaining
                        }; // function
                    },
                    eventAliasesOn: function(proto) {
                        var p = proto;
                        p.addListener = p.listen = p.bind = p.on;
                        p.removeListener = p.unlisten = p.unbind = p.off;
                        p.emit = p.trigger;
                        // this is just a wrapper alias of .on()
                        p.pon = p.promiseOn = function(events, selector) {
                            var self = this;
                            var args = Array.prototype.slice.call(arguments, 0);
                            return new Promise(function(resolve1, reject) {
                                var callback = function(e) {
                                    self.off.apply(self, offArgs);
                                    resolve1(e);
                                };
                                var onArgs = args.concat([
                                    callback
                                ]);
                                var offArgs = onArgs.concat([]);
                                self.on.apply(self, onArgs);
                            });
                        };
                    },
                    off: function offImpl(params) {
                        var defaults = {};
                        params = util.extend({}, defaults, params);
                        return function(events, callback) {
                            var self = this;
                            var selfIsArrayLike = self.length !== undefined;
                            var all = selfIsArrayLike ? self : [
                                self
                            ]; // put in array if not array-like
                            var eventsIsString = is.string(events);
                            if (arguments.length === 0) {
                                for(var i = 0; i < all.length; i++)all[i]._private.listeners = [];
                                return self; // maintain chaining
                            }
                            if (eventsIsString) {
                                var map = {};
                                map[events] = callback;
                                events = map;
                            }
                            for(var evts in events){
                                callback = events[evts];
                                if (callback === false) callback = define.event.falseCallback;
                                evts = evts.split(/\s+/);
                                for(var h = 0; h < evts.length; h++){
                                    var evt = evts[h];
                                    if (is.emptyString(evt)) continue;
                                    var match = evt.match(define.event.optionalTypeRegex); // [type][.namespace]
                                    if (match) {
                                        var type = match[1] ? match[1] : undefined;
                                        var namespace = match[2] ? match[2] : undefined;
                                        for(var i = 0; i < all.length; i++){
                                            var listeners = all[i]._private.listeners = all[i]._private.listeners || [];
                                            for(var j = 0; j < listeners.length; j++){
                                                var listener = listeners[j];
                                                var nsMatches = !namespace || namespace === listener.namespace;
                                                var typeMatches = !type || listener.type === type;
                                                var cbMatches = !callback || callback === listener.callback;
                                                var listenerMatches = nsMatches && typeMatches && cbMatches;
                                                // delete listener if it matches
                                                if (listenerMatches) {
                                                    listeners.splice(j, 1);
                                                    j--;
                                                }
                                            } // for listeners
                                        } // for all
                                    } // if match
                                } // for events array
                            } // for events map
                            return self; // maintain chaining
                        }; // function
                    },
                    trigger: function(params) {
                        var defaults = {};
                        params = util.extend({}, defaults, params);
                        return function triggerImpl(events, extraParams, fnToTrigger) {
                            var self = this;
                            var selfIsArrayLike = self.length !== undefined;
                            var all = selfIsArrayLike ? self : [
                                self
                            ]; // put in array if not array-like
                            var eventsIsString = is.string(events);
                            var eventsIsObject = is.plainObject(events);
                            var eventsIsEvent = is.event(events);
                            if (eventsIsString) {
                                var evts = events.split(/\s+/);
                                events = [];
                                for(var i = 0; i < evts.length; i++){
                                    var evt = evts[i];
                                    if (is.emptyString(evt)) continue;
                                    var match = evt.match(define.event.regex); // type[.namespace]
                                    var type = match[1];
                                    var namespace = match[2] ? match[2] : undefined;
                                    events.push({
                                        type: type,
                                        namespace: namespace
                                    });
                                }
                            } else if (eventsIsObject) {
                                var eventArgObj = events;
                                events = [
                                    eventArgObj
                                ];
                            }
                            if (extraParams) {
                                if (!is.array(extraParams)) extraParams = [
                                    extraParams
                                ];
                            } else extraParams = [];
                            for(var i = 0; i < events.length; i++){
                                var evtObj = events[i];
                                for(var j = 0; j < all.length; j++){
                                    var triggerer = all[j];
                                    var listeners = triggerer._private.listeners = triggerer._private.listeners || [];
                                    var bubbleUp = false;
                                    // create the event for this element from the event object
                                    var evt;
                                    if (eventsIsEvent) evt = evtObj;
                                    else evt = new Event(evtObj, {
                                        namespace: evtObj.namespace
                                    });
                                    if (fnToTrigger) listeners = [
                                        {
                                            namespace: evt.namespace,
                                            type: evt.type,
                                            callback: fnToTrigger
                                        }
                                    ];
                                    for(var k = 0; k < listeners.length; k++){
                                        var lis = listeners[k];
                                        var nsMatches = !lis.namespace || lis.namespace === evt.namespace;
                                        var typeMatches = lis.type === evt.type;
                                        var targetMatches = true;
                                        var listenerMatches = nsMatches && typeMatches && targetMatches;
                                        if (listenerMatches) {
                                            var args = [
                                                evt
                                            ];
                                            args = args.concat(extraParams); // add extra params to args list
                                            if (lis.data) evt.data = lis.data;
                                            else evt.data = undefined;
                                            if (lis.unbindSelfOnTrigger || lis.unbindAllBindersOnTrigger) {
                                                listeners.splice(k, 1);
                                                k--;
                                            }
                                            if (lis.unbindAllBindersOnTrigger) {
                                                var binders = lis.binders;
                                                for(var l = 0; l < binders.length; l++){
                                                    var binder = binders[l];
                                                    if (!binder || binder === triggerer) continue;
                                                     // already handled triggerer or we can't handle it
                                                    var binderListeners = binder._private.listeners;
                                                    for(var m = 0; m < binderListeners.length; m++){
                                                        var binderListener = binderListeners[m];
                                                        if (binderListener === lis) {
                                                            binderListeners.splice(m, 1);
                                                            m--;
                                                        }
                                                    }
                                                }
                                            }
                                            // run the callback
                                            var context = triggerer;
                                            var ret = lis.callback.apply(context, args);
                                            if (ret === false || evt.isPropagationStopped()) {
                                                // then don't bubble
                                                bubbleUp = false;
                                                if (ret === false) {
                                                    // returning false is a shorthand for stopping propagation and preventing the def. action
                                                    evt.stopPropagation();
                                                    evt.preventDefault();
                                                }
                                            }
                                        } // if listener matches
                                    } // for each listener
                                    bubbleUp;
                                } // for each of all
                            } // for each event
                            return self; // maintain chaining
                        }; // function
                    } // trigger
                }; // define
                module1.exports = define;
            },
            {
                "./event": 2,
                "./is": 5,
                "./promise": 6,
                "./util": 8
            }
        ],
        2: [
            function(_dereq_, module1, exports) {
                'use strict';
                // https://github.com/jquery/jquery/blob/master/src/event.js
                var Event = function(src, props) {
                    // Allow instantiation without the 'new' keyword
                    if (!(this instanceof Event)) return new Event(src, props);
                    // Event object
                    if (src && src.type) {
                        this.originalEvent = src;
                        this.type = src.type;
                        // Events bubbling up the document may have been marked as prevented
                        // by a handler lower down the tree; reflect the correct value.
                        this.isDefaultPrevented = src.defaultPrevented ? returnTrue : returnFalse;
                    // Event type
                    } else this.type = src;
                    // Put explicitly provided properties onto the event object
                    if (props) {
                        // more efficient to manually copy fields we use
                        this.type = props.type !== undefined ? props.type : this.type;
                        this.namespace = props.namespace;
                        this.layout = props.layout;
                        this.data = props.data;
                        this.message = props.message;
                    }
                    // Create a timestamp if incoming event doesn't have one
                    this.timeStamp = src && src.timeStamp || +new Date();
                };
                function returnFalse() {
                    return false;
                }
                function returnTrue() {
                    return true;
                }
                // jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
                // http://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
                Event.prototype = {
                    instanceString: function() {
                        return 'event';
                    },
                    preventDefault: function() {
                        this.isDefaultPrevented = returnTrue;
                        var e = this.originalEvent;
                        if (!e) return;
                        // if preventDefault exists run it on the original event
                        if (e.preventDefault) e.preventDefault();
                    },
                    stopPropagation: function() {
                        this.isPropagationStopped = returnTrue;
                        var e = this.originalEvent;
                        if (!e) return;
                        // if stopPropagation exists run it on the original event
                        if (e.stopPropagation) e.stopPropagation();
                    },
                    stopImmediatePropagation: function() {
                        this.isImmediatePropagationStopped = returnTrue;
                        this.stopPropagation();
                    },
                    isDefaultPrevented: returnFalse,
                    isPropagationStopped: returnFalse,
                    isImmediatePropagationStopped: returnFalse
                };
                module1.exports = Event;
            },
            {}
        ],
        3: [
            function(_dereq_, module1, exports) {
                /*! Weaver licensed under MIT (https://tldrlegal.com/license/mit-license), copyright Max Franz */ 'use strict';
                var is = _dereq_('./is');
                var util = _dereq_('./util');
                var Thread = _dereq_('./thread');
                var Promise = _dereq_('./promise');
                var define = _dereq_('./define');
                var Fabric = function(N) {
                    if (!(this instanceof Fabric)) return new Fabric(N);
                    this._private = {
                        pass: []
                    };
                    var defN = 4;
                    is.number(N);
                    if (typeof navigator !== 'undefined' && navigator.hardwareConcurrency != null) N = navigator.hardwareConcurrency;
                    else try {
                        N = _dereq_('os').cpus().length;
                    } catch (err) {
                        N = defN;
                    }
                     // TODO could use an estimation here but would the additional expense be worth it?
                    for(var i = 0; i < N; i++)this[i] = new Thread();
                    this.length = N;
                };
                var fabfn = Fabric.prototype; // short alias
                util.extend(fabfn, {
                    instanceString: function() {
                        return 'fabric';
                    },
                    // require fn in all threads
                    require: function(fn, as) {
                        for(var i = 0; i < this.length; i++){
                            var thread = this[i];
                            thread.require(fn, as);
                        }
                        return this;
                    },
                    // get a random thread
                    random: function() {
                        var i = Math.round((this.length - 1) * Math.random());
                        var thread = this[i];
                        return thread;
                    },
                    // run on random thread
                    run: function(fn) {
                        var pass = this._private.pass.shift();
                        return this.random().pass(pass).run(fn);
                    },
                    // sends a random thread a message
                    message: function(m) {
                        return this.random().message(m);
                    },
                    // send all threads a message
                    broadcast: function(m) {
                        for(var i = 0; i < this.length; i++){
                            var thread = this[i];
                            thread.message(m);
                        }
                        return this; // chaining
                    },
                    // stop all threads
                    stop: function() {
                        for(var i = 0; i < this.length; i++){
                            var thread = this[i];
                            thread.stop();
                        }
                        return this; // chaining
                    },
                    // pass data to be used with .spread() etc.
                    pass: function(data) {
                        var pass = this._private.pass;
                        if (is.array(data)) pass.push(data);
                        else throw 'Only arrays may be used with fabric.pass()';
                        return this; // chaining
                    },
                    spreadSize: function() {
                        var subsize = Math.ceil(this._private.pass[0].length / this.length);
                        subsize = Math.max(1, subsize); // don't pass less than one ele to each thread
                        return subsize;
                    },
                    // split the data into slices to spread the data equally among threads
                    spread: function(fn) {
                        var self = this;
                        var _p = self._private;
                        var subsize = self.spreadSize(); // number of pass eles to handle in each thread
                        var pass = _p.pass.shift().concat([]); // keep a copy
                        var runPs = [];
                        for(var i = 0; i < this.length; i++){
                            var thread = this[i];
                            var slice = pass.splice(0, subsize);
                            var runP = thread.pass(slice).run(fn);
                            runPs.push(runP);
                            var doneEarly = pass.length === 0;
                            if (doneEarly) break;
                        }
                        return Promise.all(runPs).then(function(thens) {
                            var postpass = [];
                            var p = 0;
                            // fill postpass with the total result joined from all threads
                            for(var i = 0; i < thens.length; i++){
                                var then = thens[i]; // array result from thread i
                                for(var j = 0; j < then.length; j++){
                                    var t = then[j]; // array element
                                    postpass[p++] = t;
                                }
                            }
                            return postpass;
                        });
                    },
                    // parallel version of array.map()
                    map: function(fn) {
                        var self = this;
                        self.require(fn, '_$_$_fabmap');
                        return self.spread(function(split) {
                            var mapped = [];
                            var origResolve = resolve; // jshint ignore:line
                            resolve = function(val) {
                                mapped.push(val);
                            };
                            for(var i = 0; i < split.length; i++){
                                var oldLen = mapped.length;
                                var ret = _$_$_fabmap(split[i]); // jshint ignore:line
                                var nothingInsdByResolve = oldLen === mapped.length;
                                if (nothingInsdByResolve) mapped.push(ret);
                            }
                            resolve = origResolve; // jshint ignore:line
                            return mapped;
                        });
                    },
                    // parallel version of array.filter()
                    filter: function(fn) {
                        var _p = this._private;
                        var pass = _p.pass[0];
                        return this.map(fn).then(function(include) {
                            var ret = [];
                            for(var i = 0; i < pass.length; i++){
                                var datum = pass[i];
                                var incDatum = include[i];
                                if (incDatum) ret.push(datum);
                            }
                            return ret;
                        });
                    },
                    // sorts the passed array using a divide and conquer strategy
                    sort: function(cmp) {
                        var self = this;
                        var P = this._private.pass[0].length;
                        var subsize = this.spreadSize();
                        cmp = cmp || function(a, b) {
                            if (a < b) return -1;
                            else if (a > b) return 1;
                            return 0;
                        };
                        self.require(cmp, '_$_$_cmp');
                        return self.spread(function(split) {
                            var sortedSplit = split.sort(_$_$_cmp); // jshint ignore:line
                            resolve(sortedSplit); // jshint ignore:line
                        }).then(function(joined) {
                            // do all the merging in the main thread to minimise data transfer
                            // TODO could do merging in separate threads but would incur add'l cost of data transfer
                            // for each level of the merge
                            var merge = function(i, j, max) {
                                // don't overflow array
                                j = Math.min(j, P);
                                max = Math.min(max, P);
                                // left and right sides of merge
                                var l = i;
                                var r = j;
                                var sorted = [];
                                for(var k = l; k < max; k++){
                                    var eleI = joined[i];
                                    var eleJ = joined[j];
                                    if (i < r && (j >= max || cmp(eleI, eleJ) <= 0)) {
                                        sorted.push(eleI);
                                        i++;
                                    } else {
                                        sorted.push(eleJ);
                                        j++;
                                    }
                                }
                                // in the array proper, put the sorted values
                                for(var k = 0; k < sorted.length; k++){
                                    var index = l + k;
                                    joined[index] = sorted[k];
                                }
                            };
                            for(var splitL = subsize; splitL < P; splitL *= 2)for(var i = 0; i < P; i += 2 * splitL)merge(i, i + splitL, i + 2 * splitL);
                            return joined;
                        });
                    }
                });
                var defineRandomPasser = function(opts) {
                    opts = opts || {};
                    return function(fn, arg1) {
                        var pass = this._private.pass.shift();
                        return this.random().pass(pass)[opts.threadFn](fn, arg1);
                    };
                };
                util.extend(fabfn, {
                    randomMap: defineRandomPasser({
                        threadFn: 'map'
                    }),
                    reduce: defineRandomPasser({
                        threadFn: 'reduce'
                    }),
                    reduceRight: defineRandomPasser({
                        threadFn: 'reduceRight'
                    })
                });
                // aliases
                var fn = fabfn;
                fn.promise = fn.run;
                fn.terminate = fn.halt = fn.stop;
                fn.include = fn.require;
                // pull in event apis
                util.extend(fabfn, {
                    on: define.on(),
                    one: define.on({
                        unbindSelfOnTrigger: true
                    }),
                    off: define.off(),
                    trigger: define.trigger()
                });
                define.eventAliasesOn(fabfn);
                module1.exports = Fabric;
            },
            {
                "./define": 1,
                "./is": 5,
                "./promise": 6,
                "./thread": 7,
                "./util": 8,
                "os": undefined
            }
        ],
        4: [
            function(_dereq_, module1, exports) {
                'use strict';
                var Thread = _dereq_('./thread');
                var Fabric = _dereq_('./fabric');
                var weaver = function() {
                    return;
                };
                weaver.version = '1.2.0';
                weaver.thread = weaver.Thread = weaver.worker = weaver.Worker = Thread;
                weaver.fabric = weaver.Fabric = Fabric;
                module1.exports = weaver;
            },
            {
                "./fabric": 3,
                "./thread": 7
            }
        ],
        5: [
            function(_dereq_, module1, exports) {
                // type testing utility functions
                'use strict';
                var typeofstr = "string";
                var typeofobj = "object";
                var typeoffn = "function";
                var instanceStr = function(obj) {
                    return obj && obj.instanceString && is.fn(obj.instanceString) ? obj.instanceString() : null;
                };
                var is = {
                    defined: function(obj) {
                        return obj != null; // not undefined or null
                    },
                    string: function(obj) {
                        return obj != null && typeof obj == typeofstr;
                    },
                    fn: function(obj) {
                        return obj != null && typeof obj === typeoffn;
                    },
                    array: function(obj) {
                        return Array.isArray ? Array.isArray(obj) : obj != null && obj instanceof Array;
                    },
                    plainObject: function(obj) {
                        return obj != null && typeof obj === typeofobj && !is.array(obj) && obj.constructor === Object;
                    },
                    object: function(obj) {
                        return obj != null && typeof obj === typeofobj;
                    },
                    number: function(obj) {
                        return obj != null && typeof obj === "number" && !isNaN(obj);
                    },
                    integer: function(obj) {
                        return is.number(obj) && Math.floor(obj) === obj;
                    },
                    bool: function(obj) {
                        return obj != null && typeof obj === "boolean";
                    },
                    event: function(obj) {
                        return instanceStr(obj) === 'event';
                    },
                    thread: function(obj) {
                        return instanceStr(obj) === 'thread';
                    },
                    fabric: function(obj) {
                        return instanceStr(obj) === 'fabric';
                    },
                    emptyString: function(obj) {
                        if (!obj) return true;
                        else if (is.string(obj)) {
                            if (obj === '' || obj.match(/^\s+$/)) return true; // empty string is empty
                        }
                        return false; // otherwise, we don't know what we've got
                    },
                    nonemptyString: function(obj) {
                        if (obj && is.string(obj) && obj !== '' && !obj.match(/^\s+$/)) return true;
                        return false;
                    }
                };
                module1.exports = is;
            },
            {}
        ],
        6: [
            function(_dereq_, module1, exports) {
                // internal, minimal Promise impl s.t. apis can return promises in old envs
                // based on thenable (http://github.com/rse/thenable)
                'use strict';
                /*  promise states [Promises/A+ 2.1]  */ var STATE_PENDING = 0; /*  [Promises/A+ 2.1.1]  */ 
                var STATE_FULFILLED = 1; /*  [Promises/A+ 2.1.2]  */ 
                var STATE_REJECTED = 2; /*  [Promises/A+ 2.1.3]  */ 
                /*  promise object constructor  */ var api = function(executor) {
                    /*  optionally support non-constructor/plain-function call  */ if (!(this instanceof api)) return new api(executor);
                    /*  initialize object  */ this.id = "Thenable/1.0.7";
                    this.state = STATE_PENDING; /*  initial state  */ 
                    this.fulfillValue = undefined; /*  initial value  */  /*  [Promises/A+ 1.3, 2.1.2.2]  */ 
                    this.rejectReason = undefined; /*  initial reason */  /*  [Promises/A+ 1.5, 2.1.3.2]  */ 
                    this.onFulfilled = []; /*  initial handlers  */ 
                    this.onRejected = []; /*  initial handlers  */ 
                    /*  provide optional information-hiding proxy  */ this.proxy = {
                        then: this.then.bind(this)
                    };
                    /*  support optional executor function  */ if (typeof executor === "function") executor.call(this, this.fulfill.bind(this), this.reject.bind(this));
                };
                /*  promise API methods  */ api.prototype = {
                    /*  promise resolving methods  */ fulfill: function(value) {
                        return deliver(this, STATE_FULFILLED, "fulfillValue", value);
                    },
                    reject: function(value) {
                        return deliver(this, STATE_REJECTED, "rejectReason", value);
                    },
                    /*  "The then Method" [Promises/A+ 1.1, 1.2, 2.2]  */ then: function(onFulfilled, onRejected) {
                        var curr = this;
                        var next = new api(); /*  [Promises/A+ 2.2.7]  */ 
                        curr.onFulfilled.push(resolver(onFulfilled, next, "fulfill")); /*  [Promises/A+ 2.2.2/2.2.6]  */ 
                        curr.onRejected.push(resolver(onRejected, next, "reject")); /*  [Promises/A+ 2.2.3/2.2.6]  */ 
                        execute(curr);
                        return next.proxy; /*  [Promises/A+ 2.2.7, 3.3]  */ 
                    }
                };
                /*  deliver an action  */ var deliver = function(curr, state, name, value) {
                    if (curr.state === STATE_PENDING) {
                        curr.state = state; /*  [Promises/A+ 2.1.2.1, 2.1.3.1]  */ 
                        curr[name] = value; /*  [Promises/A+ 2.1.2.2, 2.1.3.2]  */ 
                        execute(curr);
                    }
                    return curr;
                };
                /*  execute all handlers  */ var execute = function(curr) {
                    if (curr.state === STATE_FULFILLED) execute_handlers(curr, "onFulfilled", curr.fulfillValue);
                    else if (curr.state === STATE_REJECTED) execute_handlers(curr, "onRejected", curr.rejectReason);
                };
                /*  execute particular set of handlers  */ var execute_handlers = function(curr, name, value) {
                    /* global setImmediate: true */ /* global setTimeout: true */ /*  short-circuit processing  */ if (curr[name].length === 0) return;
                    /*  iterate over all handlers, exactly once  */ var handlers = curr[name];
                    curr[name] = []; /*  [Promises/A+ 2.2.2.3, 2.2.3.3]  */ 
                    var func = function() {
                        for(var i = 0; i < handlers.length; i++)handlers[i](value); /*  [Promises/A+ 2.2.5]  */ 
                    };
                    /*  execute procedure asynchronously  */ /*  [Promises/A+ 2.2.4, 3.1]  */ if (typeof setImmediate === "function") setImmediate(func);
                    else setTimeout(func, 0);
                };
                /*  generate a resolver function  */ var resolver = function(cb, next, method) {
                    return function(value) {
                        if (typeof cb !== "function") /*  [Promises/A+ 2.2.1, 2.2.7.3, 2.2.7.4]  */ next[method].call(next, value); /*  [Promises/A+ 2.2.7.3, 2.2.7.4]  */ 
                        else {
                            var result;
                            try {
                                result = cb(value);
                            } catch (e) {
                                next.reject(e); /*  [Promises/A+ 2.2.7.2]  */ 
                                return;
                            }
                            resolve1(next, result); /*  [Promises/A+ 2.2.7.1]  */ 
                        }
                    };
                };
                /*  "Promise Resolution Procedure"  */ /*  [Promises/A+ 2.3]  */ var resolve1 = function(promise, x) {
                    /*  sanity check arguments  */ /*  [Promises/A+ 2.3.1]  */ if (promise === x || promise.proxy === x) {
                        promise.reject(new TypeError("cannot resolve promise with itself"));
                        return;
                    }
                    /*  surgically check for a "then" method
    (mainly to just call the "getter" of "then" only once)  */ var then;
                    if (typeof x === "object" && x !== null || typeof x === "function") try {
                        then = x.then;
                    } catch (e) {
                        promise.reject(e); /*  [Promises/A+ 2.3.3.2]  */ 
                        return;
                    }
                    /*  handle own Thenables    [Promises/A+ 2.3.2]
    and similar "thenables" [Promises/A+ 2.3.3]  */ if (typeof then === "function") {
                        var resolved = false;
                        try {
                            /*  call retrieved "then" method */ /*  [Promises/A+ 2.3.3.3]  */ then.call(x, /*  resolvePromise  */ /*  [Promises/A+ 2.3.3.3.1]  */ function(y) {
                                if (resolved) return;
                                resolved = true; /*  [Promises/A+ 2.3.3.3.3]  */ 
                                if (y === x) /*  [Promises/A+ 3.6]  */ promise.reject(new TypeError("circular thenable chain"));
                                else resolve1(promise, y);
                            }, /*  rejectPromise  */ /*  [Promises/A+ 2.3.3.3.2]  */ function(r) {
                                if (resolved) return;
                                resolved = true; /*  [Promises/A+ 2.3.3.3.3]  */ 
                                promise.reject(r);
                            });
                        } catch (e) {
                            if (!resolved) /*  [Promises/A+ 2.3.3.3.3]  */ promise.reject(e); /*  [Promises/A+ 2.3.3.3.4]  */ 
                        }
                        return;
                    }
                    /*  handle other values  */ promise.fulfill(x); /*  [Promises/A+ 2.3.4, 2.3.3.4]  */ 
                };
                // use native promises where possible
                var Promise = typeof Promise === 'undefined' ? api : Promise;
                // so we always have Promise.all()
                Promise.all = Promise.all || function(ps) {
                    return new Promise(function(resolveAll, rejectAll) {
                        var vals = new Array(ps.length);
                        var doneCount = 0;
                        var fulfill = function(i, val) {
                            vals[i] = val;
                            doneCount++;
                            if (doneCount === ps.length) resolveAll(vals);
                        };
                        for(var i = 0; i < ps.length; i++)(function(i) {
                            var p = ps[i];
                            var isPromise = p.then != null;
                            if (isPromise) p.then(function(val) {
                                fulfill(i, val);
                            }, function(err) {
                                rejectAll(err);
                            });
                            else {
                                var val = p;
                                fulfill(i, val);
                            }
                        })(i);
                    });
                };
                module1.exports = Promise;
            },
            {}
        ],
        7: [
            function(_dereq_, module1, exports) {
                /*! Weaver licensed under MIT (https://tldrlegal.com/license/mit-license), copyright Max Franz */ // cross-env thread/worker
                // NB : uses (heavyweight) processes on nodejs so best not to create too many threads
                'use strict';
                var window1 = _dereq_('./window');
                var util = _dereq_('./util');
                var Promise = _dereq_('./promise');
                var Event = _dereq_('./event');
                var define = _dereq_('./define');
                var is = _dereq_('./is');
                var Thread = function(opts) {
                    if (!(this instanceof Thread)) return new Thread(opts);
                    var _p = this._private = {
                        requires: [],
                        files: [],
                        queue: null,
                        pass: [],
                        disabled: false
                    };
                    if (is.plainObject(opts)) {
                        if (opts.disabled != null) _p.disabled = !!opts.disabled;
                    }
                };
                var thdfn = Thread.prototype; // short alias
                var stringifyFieldVal = function(val) {
                    var valStr = is.fn(val) ? val.toString() : "JSON.parse('" + JSON.stringify(val) + "')";
                    return valStr;
                };
                // allows for requires with prototypes and subobjs etc
                var fnAsRequire = function(fn) {
                    var req;
                    var fnName;
                    if (is.object(fn) && fn.fn) {
                        req = fnAs(fn.fn, fn.name);
                        fnName = fn.name;
                        fn = fn.fn;
                    } else if (is.fn(fn)) {
                        req = fn.toString();
                        fnName = fn.name;
                    } else if (is.string(fn)) req = fn;
                    else if (is.object(fn)) {
                        if (fn.proto) req = '';
                        else req = fn.name + ' = {};';
                        fnName = fn.name;
                        fn = fn.obj;
                    }
                    req += '\n';
                    var protoreq = function(val, subname) {
                        if (val.prototype) {
                            var protoNonempty = false;
                            for(var prop in val.prototype){
                                protoNonempty = true;
                                break;
                            } // jshint ignore:line
                            if (protoNonempty) req += fnAsRequire({
                                name: subname,
                                obj: val,
                                proto: true
                            }, val);
                        }
                    };
                    // pull in prototype
                    if (fn.prototype && fnName != null) for(var name in fn.prototype){
                        var protoStr = '';
                        var val = fn.prototype[name];
                        var valStr = stringifyFieldVal(val);
                        var subname = fnName + '.prototype.' + name;
                        protoStr += subname + ' = ' + valStr + ';\n';
                        if (protoStr) req += protoStr;
                        protoreq(val, subname); // subobject with prototype
                    }
                    // pull in properties for obj/fns
                    if (!is.string(fn)) for(var name in fn){
                        var propsStr = '';
                        if (fn.hasOwnProperty(name)) {
                            var val = fn[name];
                            var valStr = stringifyFieldVal(val);
                            var subname = fnName + '["' + name + '"]';
                            propsStr += subname + ' = ' + valStr + ';\n';
                        }
                        if (propsStr) req += propsStr;
                        protoreq(val, subname); // subobject with prototype
                    }
                    return req;
                };
                var isPathStr = function(str) {
                    return is.string(str) && str.match(/\.js$/);
                };
                util.extend(thdfn, {
                    instanceString: function() {
                        return 'thread';
                    },
                    require: function(fn, as) {
                        var requires = this._private.requires;
                        if (isPathStr(fn)) {
                            this._private.files.push(fn);
                            return this;
                        }
                        if (as) {
                            if (is.fn(fn)) fn = {
                                name: as,
                                fn: fn
                            };
                            else fn = {
                                name: as,
                                obj: fn
                            };
                        } else if (is.fn(fn)) {
                            if (!fn.name) throw 'The function name could not be automatically determined.  Use thread.require( someFunction, "someFunction" )';
                            fn = {
                                name: fn.name,
                                fn: fn
                            };
                        }
                        requires.push(fn);
                        return this; // chaining
                    },
                    pass: function(data) {
                        this._private.pass.push(data);
                        return this; // chaining
                    },
                    run: function(fn, pass) {
                        var self = this;
                        var _p = this._private;
                        pass = pass || _p.pass.shift();
                        if (_p.stopped) throw 'Attempted to run a stopped thread!  Start a new thread or do not stop the existing thread and reuse it.';
                        if (_p.running) return _p.queue = _p.queue.then(function() {
                            return self.run(fn, pass);
                        });
                        var useWW = window1 != null && !_p.disabled;
                        var useNode = !window1 && typeof module1 !== 'undefined' && !_p.disabled;
                        self.trigger('run');
                        var runP = new Promise(function(resolve1, reject) {
                            _p.running = true;
                            var threadTechAlreadyExists = _p.ran;
                            var fnImplStr = is.string(fn) ? fn : fn.toString();
                            // worker code to exec
                            var fnStr = '\n' + _p.requires.map(function(r) {
                                return fnAsRequire(r);
                            }).concat(_p.files.map(function(f) {
                                if (useWW) {
                                    var wwifyFile = function(file) {
                                        if (file.match(/^\.\//) || file.match(/^\.\./)) return window1.location.origin + window1.location.pathname + file;
                                        else if (file.match(/^\//)) return window1.location.origin + '/' + file;
                                        return file;
                                    };
                                    return 'importScripts("' + wwifyFile(f) + '");';
                                } else if (useNode) return 'eval( require("fs").readFileSync("' + f + '", { encoding: "utf8" }) );';
                                else throw 'External file `' + f + '` can not be required without any threading technology.';
                            })).concat([
                                '( function(){',
                                'var ret = (' + fnImplStr + ')(' + JSON.stringify(pass) + ');',
                                'if( ret !== undefined ){ resolve(ret); }',
                                '} )()\n'
                            ]).join('\n');
                            // because we've now consumed the requires, empty the list so we don't dupe on next run()
                            _p.requires = [];
                            _p.files = [];
                            if (useWW) {
                                var fnBlob, fnUrl;
                                // add normalised thread api functions
                                if (!threadTechAlreadyExists) {
                                    var fnPre = fnStr + '';
                                    fnStr = [
                                        'function _ref_(o){ return eval(o); };',
                                        'function broadcast(m){ return message(m); };',
                                        'function message(m){ postMessage(m); };',
                                        'function listen(fn){',
                                        '  self.addEventListener("message", function(m){ ',
                                        '    if( typeof m === "object" && (m.data.$$eval || m.data === "$$start") ){',
                                        '    } else { ',
                                        '      fn( m.data );',
                                        '    }',
                                        '  });',
                                        '};',
                                        'self.addEventListener("message", function(m){  if( m.data.$$eval ){ eval( m.data.$$eval ); }  });',
                                        'function resolve(v){ postMessage({ $$resolve: v }); };',
                                        'function reject(v){ postMessage({ $$reject: v }); };'
                                    ].join('\n');
                                    fnStr += fnPre;
                                    fnBlob = new Blob([
                                        fnStr
                                    ], {
                                        type: 'application/javascript'
                                    });
                                    fnUrl = window1.URL.createObjectURL(fnBlob);
                                }
                                // create webworker and let it exec the serialised code
                                var ww = _p.webworker = _p.webworker || new Worker(fnUrl);
                                if (threadTechAlreadyExists) ww.postMessage({
                                    $$eval: fnStr
                                });
                                // worker messages => events
                                var cb;
                                ww.addEventListener('message', cb = function(m) {
                                    var isObject = is.object(m) && is.object(m.data);
                                    if (isObject && '$$resolve' in m.data) {
                                        ww.removeEventListener('message', cb); // done listening b/c resolve()
                                        resolve1(m.data.$$resolve);
                                    } else if (isObject && '$$reject' in m.data) {
                                        ww.removeEventListener('message', cb); // done listening b/c reject()
                                        reject(m.data.$$reject);
                                    } else self.trigger(new Event(m, {
                                        type: 'message',
                                        message: m.data
                                    }));
                                }, false);
                                if (!threadTechAlreadyExists) ww.postMessage('$$start'); // start up the worker
                            } else if (useNode) {
                                // create a new process
                                if (!_p.child) _p.child = _dereq_('child_process').fork(_dereq_('path').join(__dirname, 'thread-node-fork'));
                                var child = _p.child;
                                // child process messages => events
                                var cb;
                                child.on('message', cb = function(m) {
                                    if (is.object(m) && '$$resolve' in m) {
                                        child.removeListener('message', cb); // done listening b/c resolve()
                                        resolve1(m.$$resolve);
                                    } else if (is.object(m) && '$$reject' in m) {
                                        child.removeListener('message', cb); // done listening b/c reject()
                                        reject(m.$$reject);
                                    } else self.trigger(new Event({}, {
                                        type: 'message',
                                        message: m
                                    }));
                                });
                                // ask the child process to eval the worker code
                                child.send({
                                    $$eval: fnStr
                                });
                            } else {
                                var promiseResolve = resolve1;
                                var promiseReject = reject;
                                var timer = _p.timer = _p.timer || {
                                    listeners: [],
                                    exec: function() {
                                        // as a string so it can't be mangled by minifiers and processors
                                        fnStr = [
                                            'function _ref_(o){ return eval(o); };',
                                            'function broadcast(m){ return message(m); };',
                                            'function message(m){ self.trigger( new Event({}, { type: "message", message: m }) ); };',
                                            'function listen(fn){ timer.listeners.push( fn ); };',
                                            'function resolve(v){ promiseResolve(v); };',
                                            'function reject(v){ promiseReject(v); };'
                                        ].join('\n') + fnStr;
                                        // the .run() code
                                        eval(fnStr); // jshint ignore:line
                                    },
                                    message: function(m) {
                                        var ls = timer.listeners;
                                        for(var i = 0; i < ls.length; i++){
                                            var fn = ls[i];
                                            fn(m);
                                        }
                                    }
                                };
                                timer.exec();
                            }
                        }).then(function(v) {
                            _p.running = false;
                            _p.ran = true;
                            self.trigger('ran');
                            return v;
                        });
                        if (_p.queue == null) _p.queue = runP; // i.e. first step of inductive promise chain (for queue)
                        return runP;
                    },
                    // send the thread a message
                    message: function(m) {
                        var _p = this._private;
                        if (_p.webworker) _p.webworker.postMessage(m);
                        if (_p.child) _p.child.send(m);
                        if (_p.timer) _p.timer.message(m);
                        return this; // chaining
                    },
                    stop: function() {
                        var _p = this._private;
                        if (_p.webworker) _p.webworker.terminate();
                        if (_p.child) _p.child.kill();
                        _p.timer;
                        _p.stopped = true;
                        return this.trigger('stop'); // chaining
                    },
                    stopped: function() {
                        return this._private.stopped;
                    }
                });
                // turns a stringified function into a (re)named function
                var fnAs = function(fn, name) {
                    var fnStr = fn.toString();
                    fnStr = fnStr.replace(/function\s*?\S*?\s*?\(/, 'function ' + name + '(');
                    return fnStr;
                };
                var defineFnal = function(opts) {
                    opts = opts || {};
                    return function fnalImpl(fn, arg1) {
                        var fnStr = fnAs(fn, '_$_$_' + opts.name);
                        this.require(fnStr);
                        return this.run([
                            'function( data ){',
                            '  var origResolve = resolve;',
                            '  var res = [];',
                            '  ',
                            '  resolve = function( val ){',
                            '    res.push( val );',
                            '  };',
                            '  ',
                            '  var ret = data.' + opts.name + '( _$_$_' + opts.name + (arguments.length > 1 ? ', ' + JSON.stringify(arg1) : '') + ' );',
                            '  ',
                            '  resolve = origResolve;',
                            '  resolve( res.length > 0 ? res : ret );',
                            '}'
                        ].join('\n'));
                    };
                };
                util.extend(thdfn, {
                    reduce: defineFnal({
                        name: 'reduce'
                    }),
                    reduceRight: defineFnal({
                        name: 'reduceRight'
                    }),
                    map: defineFnal({
                        name: 'map'
                    })
                });
                // aliases
                var fn = thdfn;
                fn.promise = fn.run;
                fn.terminate = fn.halt = fn.stop;
                fn.include = fn.require;
                // pull in event apis
                util.extend(thdfn, {
                    on: define.on(),
                    one: define.on({
                        unbindSelfOnTrigger: true
                    }),
                    off: define.off(),
                    trigger: define.trigger()
                });
                define.eventAliasesOn(thdfn);
                module1.exports = Thread;
            },
            {
                "./define": 1,
                "./event": 2,
                "./is": 5,
                "./promise": 6,
                "./util": 8,
                "./window": 9,
                "child_process": undefined,
                "path": undefined
            }
        ],
        8: [
            function(_dereq_, module1, exports) {
                'use strict';
                var is = _dereq_('./is');
                var util;
                // utility functions only for internal use
                util = {
                    // the jquery extend() function
                    // NB: modified to use is etc since we can't use jquery functions
                    extend: function() {
                        var options, name, src, copy, copyIsArray, clone, target = arguments[0] || {}, i = 1, length = arguments.length, deep = false;
                        // Handle a deep copy situation
                        if (typeof target === 'boolean') {
                            deep = target;
                            target = arguments[1] || {};
                            // skip the boolean and the target
                            i = 2;
                        }
                        // Handle case when target is a string or something (possible in deep copy)
                        if (typeof target !== 'object' && !is.fn(target)) target = {};
                        // extend jQuery itself if only one argument is passed
                        if (length === i) {
                            target = this;
                            --i;
                        }
                        for(; i < length; i++){
                            // Only deal with non-null/undefined values
                            if ((options = arguments[i]) != null) // Extend the base object
                            for(name in options){
                                src = target[name];
                                copy = options[name];
                                // Prevent never-ending loop
                                if (target === copy) continue;
                                // Recurse if we're merging plain objects or arrays
                                if (deep && copy && (is.plainObject(copy) || (copyIsArray = is.array(copy)))) {
                                    if (copyIsArray) {
                                        copyIsArray = false;
                                        clone = src && is.array(src) ? src : [];
                                    } else clone = src && is.plainObject(src) ? src : {};
                                    // Never move original objects, clone them
                                    target[name] = util.extend(deep, clone, copy);
                                // Don't bring in undefined values
                                } else if (copy !== undefined) target[name] = copy;
                            }
                        }
                        // Return the modified object
                        return target;
                    },
                    error: function(msg) {
                        if (console) {
                            if (console.error) console.error.apply(console, arguments);
                            else if (console.log) console.log.apply(console, arguments);
                            else throw msg;
                        } else throw msg;
                    }
                };
                module1.exports = util;
            },
            {
                "./is": 5
            }
        ],
        9: [
            function(_dereq_, module1, exports) {
                module1.exports = typeof window === 'undefined' ? null : window;
            },
            {}
        ]
    }, {}, [
        4
    ])(4);
});

});


parcelRegister("2UrZ2", function(module, exports) {

$parcel$export(module.exports, "dfs", () => $21e684ac5fac7011$export$51b654aff22fc5a6);
$parcel$export(module.exports, "setupClickEvent", () => $21e684ac5fac7011$export$410bcbfce3bc1dde);
$parcel$export(module.exports, "displayElementInfo", () => $21e684ac5fac7011$export$4e3b336a2bf7438e);
$parcel$export(module.exports, "hideSingletonNodes", () => $21e684ac5fac7011$export$d95b4270f7110dc3);
$parcel$export(module.exports, "resizePanels", () => $21e684ac5fac7011$export$fc648b45f7e6cbfb);

var $65AEs = parcelRequire("65AEs");

var $5qD1E = parcelRequire("5qD1E");

var $ftuQo = parcelRequire("ftuQo");

function $21e684ac5fac7011$export$51b654aff22fc5a6(node, currentPath, sinkNodes, isPathValid = true) {
    if (!isPathValid) return;
    currentPath.push(node);
    if (sinkNodes.includes(node) && currentPath.length >= (0, $5qD1E.STATE).minPathLength) (0, $5qD1E.STATE).walks.push([
        ...currentPath
    ]); // Found a path
    else // Correctly use outgoers as a method call
    node.outgoers("node").forEach((neighbor)=>{
        const connectingEdge = node.edgesTo(neighbor);
        if (connectingEdge.data("weight") >= (0, $5qD1E.STATE).minEdgeWeight) // if current path's leght is greater than maxdepth, don't continue
        {
            if (currentPath.length < (0, $5qD1E.STATE).maxPathLength) $21e684ac5fac7011$export$51b654aff22fc5a6(neighbor, currentPath, sinkNodes, true);
        } else $21e684ac5fac7011$export$51b654aff22fc5a6(neighbor, currentPath, sinkNodes, false);
    });
    currentPath.pop(); // backtrack
}
function $21e684ac5fac7011$export$410bcbfce3bc1dde() {
    const { cy: cy, previousClickedElement: previousClickedElement } = (0, $5qD1E.STATE);
    const infoContent = document.getElementById("infoContent");
    cy.on("tap", "node, edge", function(evt) {
        const element = evt.target;
        // Reset previous styles
        if (previousClickedElement) previousClickedElement.removeClass("selected");
        // Add selected class to current element
        element.addClass("selected");
        // Store as previous element for next click
        (0, $5qD1E.STATE).previousClickedElement = element;
        // Show element information in the info panel
        $21e684ac5fac7011$export$4e3b336a2bf7438e(element, infoContent);
    });
}

function $21e684ac5fac7011$export$4e3b336a2bf7438e(element, container) {
    const type = element.isNode() ? "Node" : "Edge";
    const data = element.data();
    let html = `
    <div class="info-header-modern mb-4">
      <div class="info-title-card">
        <div class="info-icon ${type.toLowerCase()}-icon">
          <i class="bi ${type === "Node" ? "bi-circle-fill" : "bi-arrow-right-circle-fill"}"></i>
        </div>
        <div class="info-title-content">
          <h4 class="info-main-title">${type} Information</h4>
          <p class="info-subtitle">Detailed ${type.toLowerCase()} properties and relationships</p>
        </div>
      </div>
    </div>
    <div class="info-body">
  `;
    // ID and basic info section
    html += `
    <div class="card mb-3">
      <div class="card-header bg-gradient-primary text-white d-flex align-items-center">
        <i class="bi bi-info-circle-fill me-2"></i>
        <strong>Basic Information</strong>
      </div>
      <div class="card-body">
        <div class="info-field mb-3">
          <i class="bi bi-hash text-primary me-2"></i>
          <span class="field-label">ID:</span>
          <code class="field-value text-muted">${data.id || "Not available"}</code>
        </div>
  `;
    if (type === "Node") {
        html += `

        <div class="row g-2 mb-2">
          <div class="col-12">
            <div class="info-field">
              <i class="bi bi-tag-fill text-primary me-2"></i>
              <span class="field-label">Name:</span>
              <span class="field-value badge bg-light text-dark">${data.name || data.id || "Not available"}</span>
            </div>
          </div>
        </div>
        
        <div class="row g-2">
          <div class="col-6">
            <div class="stat-card text-center p-2 bg-light rounded">
              <i class="bi bi-diagram-3 text-info mb-1"></i>
              <div class="stat-number">${element.connectedEdges().length}</div>
              <div class="stat-label">Connections</div>
            </div>
          </div>
          <div class="col-6">
            <div class="stat-card text-center p-2 bg-light rounded">
              <i class="bi bi-arrows text-success mb-1"></i>
              <div class="stat-number">${element.indegree()}/${element.outdegree()}</div>
              <div class="stat-label">In/Out Degree</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    `;
        // Genomic information section (if available)
        if (data.chrom || data.ref_start || data.ref_end) {
            const length = data.ref_start && data.ref_end ? data.ref_end - data.ref_start + 1 : null;
            html += `
        <div class="card mb-3 genomic-card">
          <div class="card-header bg-gradient-primary text-white d-flex align-items-center">
            <i class="bi bi-geo-alt-fill me-2"></i>
            <strong>Genomic Location</strong>
          </div>
          <div class="card-body p-3">
            <div class="row g-3">
              <div class="col-6">
                <div class="genomic-field">
                  <i class="bi bi-diagram-2 text-primary me-2"></i>
                  <div class="field-content">
                    <div class="field-label">Chromosome</div>
                    <div class="field-value chromosome-badge">${data.chrom || "N/A"}</div>
                  </div>
                </div>
              </div>
              <div class="col-6">
                <div class="genomic-field">
                  <i class="bi bi-arrow-${data.strand === '+' ? 'right' : data.strand === '-' ? 'left' : 'left-right'} text-${data.strand === '+' ? 'success' : data.strand === '-' ? 'warning' : 'secondary'} me-2"></i>
                  <div class="field-content">
                    <div class="field-label">Strand</div>
                    <div class="field-value strand-badge strand-${data.strand || 'unknown'}">${data.strand || "N/A"}</div>
                  </div>
                </div>
              </div>
            </div>
            
            <div class="position-info mt-3 p-3 bg-light rounded">
              <div class="row g-2 text-center">
                <div class="col-4">
                  <div class="position-stat">
                    <div class="position-number">${data.ref_start?.toLocaleString() || "N/A"}</div>
                    <div class="position-label">Start</div>
                  </div>
                </div>
                <div class="col-4">
                  <div class="position-stat">
                    <div class="position-number">${data.ref_end?.toLocaleString() || "N/A"}</div>
                    <div class="position-label">End</div>
                  </div>
                </div>
                <div class="col-4">
                  <div class="position-stat">
                    <div class="position-number ${length ? 'text-info' : ''}">${length ? length.toLocaleString() : "N/A"}</div>
                    <div class="position-label">Length${length ? ' (bp)' : ''}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      `;
        }
        // PTC/PTF information section (if available)
        if (data.ptc !== undefined || data.ptf !== undefined) html += `
        <div class="card mb-3 metrics-card">
          <div class="card-header bg-gradient-info text-white d-flex align-items-center">
            <i class="bi bi-bar-chart-fill me-2"></i>
            <strong>Expression Metrics</strong>
          </div>
          <div class="card-body p-3">
            <div class="row g-3">
              <div class="col-6">
                <div class="metric-stat-card">
                  <div class="metric-icon mb-2">
                    <i class="bi bi-pie-chart-fill text-primary"></i>
                  </div>
                  <div class="metric-content">
                    <div class="metric-label">PTC</div>
                    <div class="metric-value ptc-value">${data.ptc !== undefined ? data.ptc.toFixed(4) : "N/A"}</div>
                    <div class="metric-description">Path Traversal Count</div>
                  </div>
                </div>
              </div>
              <div class="col-6">
                <div class="metric-stat-card">
                  <div class="metric-icon mb-2">
                    <i class="bi bi-graph-up text-success"></i>
                  </div>
                  <div class="metric-content">
                    <div class="metric-label">PTF</div>
                    <div class="metric-value ptf-value">${data.ptf !== undefined ? data.ptf.toFixed(4) : "N/A"}</div>
                    <div class="metric-description">Path Traversal Fraction</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      `;
        // Exons information if available
        if (data.exons) {
            // Create the visualization button
            const visualizeBtn = `
              <button class="btn btn-sm btn-light border exon-visualize-btn" data-exons="${data.exons.replace(/"/g, '&quot;')}">
                <i class="bi bi-bar-chart-line-fill me-1"></i> Visualize
              </button>
            `;
            html += `
        <div class="card mb-3 exons-card">
          <div class="card-header bg-gradient-success text-white d-flex justify-content-between align-items-center">
            <div class="d-flex align-items-center">
              <i class="bi bi-diagram-2-fill me-2"></i>
              <strong>Exon Structure</strong>
            </div>
            ${visualizeBtn}
          </div>
          <div class="card-body p-0">
            <div class="exon-list-container">
              ${$21e684ac5fac7011$var$formatExons(data.exons)}
            </div>
          </div>
        </div>
      `;
            // Add event listener for the button after a small delay (to ensure DOM is ready)
            setTimeout(()=>{
                const buttons = document.querySelectorAll('.exon-visualize-btn');
                buttons.forEach((btn)=>{
                    if (!btn.hasAttribute('data-listener-added')) {
                        btn.setAttribute('data-listener-added', 'true');
                        btn.addEventListener('click', function() {
                            const exonsData = this.getAttribute('data-exons');
                            // Get chromosome info from the node data
                            const chromosomeInfo = {
                                chrom: data.chrom || null,
                                strand: data.strand || null,
                                start: data.ref_start || null,
                                end: data.ref_end || null
                            };
                            (parcelRequire("8BDVI")).then((module)=>{
                                module.showExonVisualizationModal(exonsData, "Node Structure", chromosomeInfo);
                            });
                        });
                    }
                });
            }, 100);
        }
    } else // Edge specific information
    html += `
        <div class="edge-connection mb-3">
          <div class="connection-flow d-flex align-items-center justify-content-center">
            <div class="node-endpoint">
              <i class="bi bi-circle-fill text-success"></i>
              <div class="endpoint-label">Source</div>
              <code class="endpoint-id">${data.source || "N/A"}</code>
            </div>
            
            <div class="flow-arrow mx-3">
              <i class="bi bi-arrow-right text-primary" style="font-size: 1.5rem;"></i>
              ${data.weight ? `<div class="weight-badge badge bg-primary mt-1 fw-bold">${data.weight}</div>` : ''}
              ${data.weight ? `<div class="weight-label">Weight</div>` : ''}
            </div>
            
            <div class="node-endpoint">
              <i class="bi bi-circle-fill text-danger"></i>
              <div class="endpoint-label">Target</div>
              <code class="endpoint-id">${data.target || "N/A"}</code>
            </div>
          </div>
        </div>
      </div>
    </div>
    `;
    // Additional properties section for any other data
    const standardProps = type === "Node" ? [
        "id",
        "name",
        "chrom",
        "ref_start",
        "ref_end",
        "strand",
        "exons",
        "ptc",
        "ptf",
        "node_id",
        "is_head",
        "value",
        "source-node",
        "geneAnnotations"
    ] : [
        "id",
        "source",
        "target",
        "weight"
    ];
    const additionalProps = Object.keys(data).filter((key)=>!standardProps.includes(key));
    if (additionalProps.length > 0) {
        html += `
      <div class="card mb-3 additional-props-card">
        <div class="card-header bg-gradient-secondary text-white d-flex align-items-center">
          <i class="bi bi-list-ul me-2"></i>
          <strong>Additional Properties</strong>
          <span class="badge bg-light text-dark ms-2">${additionalProps.length}</span>
        </div>
        <div class="card-body p-3">
    `;
        additionalProps.forEach((key, index)=>{
            const isLast = index === additionalProps.length - 1;
            html += `
          <div class="property-row ${!isLast ? 'border-bottom' : ''} pb-3 ${!isLast ? 'mb-3' : ''}">
            <div class="property-header mb-2">
              <i class="bi bi-chevron-right text-primary me-1"></i>
              <span class="property-name">${key}</span>
            </div>
            <div class="property-content">
              ${$21e684ac5fac7011$var$formatValue(data[key], key)}
            </div>
          </div>
      `;
        });
        html += `
        </div>
      </div>
    `;
    }
    html += `</div>`;
    container.innerHTML = html;
    // If this is a node, render gene annotations
    if (type === "Node") (0, $ftuQo.renderGeneAnnotations)(element, container);
    // Add custom styles for the info panel
    $21e684ac5fac7011$var$addInfoPanelStyles();
}
/**
 * Format exons string into a readable format
 * @param {string} exonsStr - String representing exons
 * @returns {string} HTML representation of exons
 */ function $21e684ac5fac7011$var$formatExons(exonsStr) {
    if (!exonsStr) return "No exon information available";
    // Try to parse the exons string which might be in format like "[start-end,start-end]"
    try {
        // Remove brackets and split by comma
        const exonList = exonsStr.replace(/^\[|\]$/g, "").split(",");
        if (exonList.length === 0) return "No exons found";
        let html = '<ul class="list-group list-group-flush">';
        exonList.forEach((exon, index)=>{
            const [start, end] = exon.split("-").map(Number);
            const length = end - start + 1;
            html += `
            <li class="list-group-item d-flex justify-content-between align-items-center">
              Exon ${index + 1}
              <div>
                <span class="badge bg-secondary">${start.toLocaleString()}-${end.toLocaleString()}</span>
                <span class="badge bg-info">${length.toLocaleString()} bp</span>
              </div>
            </li>
            `;
        });
        html += `</ul>`;
        return html;
    } catch (e) {
        console.error("Error parsing exons:", e);
        return `<div class="alert alert-warning">Could not parse exon information: ${exonsStr}</div>`;
    }
}
/**
 * List of property names that should be formatted as tables when they contain arrays or lists
 */ const $21e684ac5fac7011$var$TABLE_APPROVED_PROPERTIES = [
    "read_ids",
    "reads"
];
/**
 * Format a data value for display
 * @param {any} value - The value to format
 * @param {string} propertyName - Name of the property being formatted (optional)
 * @returns {string} Formatted value as string
 */ function $21e684ac5fac7011$var$formatValue(value, propertyName = null) {
    if (value === undefined || value === null) return "N/A";
    if (typeof value === "boolean") return value ? "Yes" : "No";
    // Only format as tables if this property is approved for table formatting
    const isApprovedForTable = !propertyName || $21e684ac5fac7011$var$TABLE_APPROVED_PROPERTIES.includes(propertyName);
    if (isApprovedForTable) {
        // Check if value is an array (must come before generic object check)
        if (Array.isArray(value)) return $21e684ac5fac7011$var$formatArrayTable(value, propertyName);
        // Check if value is a string representation of an array (e.g., ["a", "b"] or ['a', 'b'])
        if (typeof value === "string" && $21e684ac5fac7011$var$isArrayString(value)) try {
            const parsedArray = $21e684ac5fac7011$var$parseArrayString(value);
            return $21e684ac5fac7011$var$formatArrayTable(parsedArray, propertyName);
        } catch (e) {
            console.warn("Failed to parse array string:", value, e);
            return String(value);
        }
        // Check if value is a comma-separated string (fallback for non-array format)
        if (typeof value === "string" && value.includes(",") && value.split(",").length > 1) {
            const items = value.split(",").map((item)=>item.trim()).filter((item)=>item.length > 0);
            if (items.length > 1) return $21e684ac5fac7011$var$formatArrayTable(items, propertyName);
        }
    }
    if (typeof value === "object") try {
        return `<pre class="code-block">${JSON.stringify(value, null, 2)}</pre>`;
    } catch (e) {
        return String(value);
    }
    return String(value);
}
/**
 * Check if a string represents an array (e.g., ["a"], ["a", "b"] or ['a', 'b'])
 * @param {string} str - String to check
 * @returns {boolean} True if string appears to be an array representation
 */ function $21e684ac5fac7011$var$isArrayString(str) {
    const trimmed = str.trim();
    return trimmed.startsWith('[') && trimmed.endsWith(']');
}
/**
 * Parse array string into actual array
 * @param {string} str - String representation of array
 * @returns {Array} Parsed array
 */ function $21e684ac5fac7011$var$parseArrayString(str) {
    const trimmed = str.trim();
    try {
        // Try JSON.parse first for proper JSON arrays
        return JSON.parse(trimmed);
    } catch (e) {
        // Fallback: manual parsing for less strict formats
        const content = trimmed.slice(1, -1); // Remove brackets
        if (content.trim() === '') return [];
        // Split by comma and clean up each item
        return content.split(',').map((item)=>{
            item = item.trim();
            // Remove quotes if present
            if (item.startsWith('"') && item.endsWith('"') || item.startsWith("'") && item.endsWith("'")) item = item.slice(1, -1);
            return item;
        }).filter((item)=>item.length > 0);
    }
}
/**
 * Format array as a table with copy buttons
 * @param {Array} array - Array to format
 * @param {string} propertyName - Name of the property for export purposes
 * @returns {string} HTML table representation
 */ function $21e684ac5fac7011$var$formatArrayTable(array, propertyName = null) {
    if (!Array.isArray(array) || array.length === 0) return "No items found";
    let tableId = `table-${Math.random().toString(36).substr(2, 9)}`;
    const isExportable = propertyName && $21e684ac5fac7011$var$TABLE_APPROVED_PROPERTIES.includes(propertyName);
    let html = `
        <div class="comma-separated-table">
            <div class="table-header d-flex justify-content-between align-items-center mb-2">
                <span class="table-title text-muted">${array.length} items</span>
                ${isExportable ? `
                <button class="btn btn-sm btn-outline-primary export-btn" 
                        data-export-data="${JSON.stringify(array).replace(/"/g, '&quot;')}"
                        data-export-name="${propertyName}"
                        title="Export all items to text file">
                    <i class="bi bi-download me-1"></i>Export TXT
                </button>
                ` : ''}
            </div>
            <table class="table table-sm table-striped" id="${tableId}">
                <thead>
                    <tr>
                        <th scope="col">#</th>
                        <th scope="col">Value</th>
                        <th scope="col">Action</th>
                    </tr>
                </thead>
                <tbody>
    `;
    array.forEach((item, index)=>{
        const itemId = `item-${tableId}-${index}`;
        const displayValue = typeof item === 'object' ? JSON.stringify(item) : String(item);
        const copyValue = displayValue;
        html += `
            <tr>
                <td>${index + 1}</td>
                <td class="item-value" id="${itemId}">${displayValue}</td>
                <td>
                    <button class="btn btn-sm btn-outline-secondary copy-btn" 
                            data-copy-text="${copyValue.replace(/"/g, '&quot;')}" 
                            title="Copy to clipboard">
                        <i class="bi bi-clipboard"></i>
                    </button>
                </td>
            </tr>
        `;
    });
    html += `
                </tbody>
            </table>
        </div>
    `;
    // Add event listeners for copy and export buttons after a delay
    setTimeout(()=>{
        $21e684ac5fac7011$var$addCopyButtonListeners();
        $21e684ac5fac7011$var$addExportButtonListeners();
    }, 100);
    return html;
}
/**
 * Add event listeners for copy buttons
 */ function $21e684ac5fac7011$var$addCopyButtonListeners() {
    const copyButtons = document.querySelectorAll('.copy-btn:not([data-listener-added])');
    copyButtons.forEach((button)=>{
        button.setAttribute('data-listener-added', 'true');
        button.addEventListener('click', async function(e) {
            e.preventDefault();
            const textToCopy = this.getAttribute('data-copy-text');
            const icon = this.querySelector('i');
            const originalClass = icon.className;
            try {
                // Use modern clipboard API if available
                if (navigator.clipboard && window.isSecureContext) await navigator.clipboard.writeText(textToCopy);
                else {
                    // Fallback for older browsers
                    const textarea = document.createElement('textarea');
                    textarea.value = textToCopy;
                    textarea.style.position = 'fixed';
                    textarea.style.opacity = '0';
                    document.body.appendChild(textarea);
                    textarea.select();
                    document.execCommand('copy');
                    document.body.removeChild(textarea);
                }
                // Visual feedback
                icon.className = 'bi bi-check-lg';
                this.classList.remove('btn-outline-secondary');
                this.classList.add('btn-success');
                // Reset after 2 seconds
                setTimeout(()=>{
                    icon.className = originalClass;
                    this.classList.remove('btn-success');
                    this.classList.add('btn-outline-secondary');
                }, 2000);
            } catch (err) {
                console.error('Failed to copy text: ', err);
                // Error feedback
                icon.className = 'bi bi-x-lg';
                this.classList.remove('btn-outline-secondary');
                this.classList.add('btn-danger');
                // Reset after 2 seconds
                setTimeout(()=>{
                    icon.className = originalClass;
                    this.classList.remove('btn-danger');
                    this.classList.add('btn-outline-secondary');
                }, 2000);
            }
        });
    });
}
/**
 * Add event listeners for export buttons
 */ function $21e684ac5fac7011$var$addExportButtonListeners() {
    const exportButtons = document.querySelectorAll('.export-btn:not([data-listener-added])');
    exportButtons.forEach((button)=>{
        button.setAttribute('data-listener-added', 'true');
        button.addEventListener('click', function(e) {
            e.preventDefault();
            const exportDataStr = this.getAttribute('data-export-data');
            const exportName = this.getAttribute('data-export-name');
            const icon = this.querySelector('i');
            const originalClass = icon.className;
            const buttonText = this.innerHTML;
            try {
                const exportData = JSON.parse(exportDataStr);
                // Create text content with each item on a new line
                const textContent = exportData.join('\n');
                // Create blob and download
                const blob = new Blob([
                    textContent
                ], {
                    type: 'text/plain'
                });
                const url = URL.createObjectURL(blob);
                // Create temporary download link
                const downloadLink = document.createElement('a');
                downloadLink.href = url;
                downloadLink.download = `${exportName}_export_${new Date().toISOString().slice(0, 19).replace(/:/g, '-')}.txt`;
                // Trigger download
                document.body.appendChild(downloadLink);
                downloadLink.click();
                document.body.removeChild(downloadLink);
                // Clean up the URL
                URL.revokeObjectURL(url);
                // Visual feedback
                icon.className = 'bi bi-check-lg';
                this.innerHTML = `<i class="bi bi-check-lg me-1"></i>Exported!`;
                this.classList.remove('btn-outline-primary');
                this.classList.add('btn-success');
                // Reset after 3 seconds
                setTimeout(()=>{
                    this.innerHTML = buttonText;
                    this.classList.remove('btn-success');
                    this.classList.add('btn-outline-primary');
                }, 3000);
            } catch (err) {
                console.error('Failed to export data: ', err);
                // Error feedback
                icon.className = 'bi bi-x-lg';
                this.innerHTML = `<i class="bi bi-x-lg me-1"></i>Failed`;
                this.classList.remove('btn-outline-primary');
                this.classList.add('btn-danger');
                // Reset after 3 seconds
                setTimeout(()=>{
                    this.innerHTML = buttonText;
                    this.classList.remove('btn-danger');
                    this.classList.add('btn-outline-primary');
                }, 3000);
            }
        });
    });
}
/**
 * Add custom styles to enhance the info panel
 */ function $21e684ac5fac7011$var$addInfoPanelStyles() {
    // Check if our styles are already added
    if (!document.getElementById("info-panel-styles")) {
        const style = document.createElement("style");
        style.id = "info-panel-styles";
        style.textContent = `
      #infoContent .card {
        box-shadow: 0 2px 4px rgba(0,0,0,0.05);
      }
      #infoContent .card-header {
        padding: 0.5rem 1rem;
      }
      #infoContent .metric-card {
        transition: all 0.3s ease;
      }
      #infoContent .metric-card:hover {
        background-color: #f8f9fa;
        transform: translateY(-2px);
        box-shadow: 0 4px 8px rgba(0,0,0,0.1);
      }
      #infoContent .code-block {
        background: #f5f5f5;
        border-radius: 3px;
        padding: 5px;
        font-size: 0.875rem;
        max-height: 100px;
        overflow-y: auto;
        margin-bottom: 0;
      }
      #infoContent .exon-list {
        max-height: 200px;
        overflow-y: auto;
      }
      #infoContent .comma-separated-table {
        max-height: 300px;
        overflow-y: auto;
        border: 1px solid #dee2e6;
        border-radius: 0.375rem;
      }
      #infoContent .comma-separated-table .table {
        margin-bottom: 0;
        font-size: 0.875rem;
      }
      #infoContent .comma-separated-table .table th {
        background-color: #f8f9fa;
        border-top: none;
        padding: 0.5rem;
        font-weight: 600;
      }
      #infoContent .comma-separated-table .table td {
        padding: 0.5rem;
        vertical-align: middle;
      }
      #infoContent .copy-btn {
        transition: all 0.2s ease;
        border-radius: 0.25rem;
      }
      #infoContent .copy-btn:hover {
        transform: scale(1.05);
      }
      #infoContent .item-value {
        word-break: break-all;
        font-family: 'Courier New', monospace;
        background-color: #f8f9fa;
        padding: 0.25rem 0.5rem;
        border-radius: 0.25rem;
      }
      
      /* Modern header styling */
      #infoContent .info-header-modern {
        background: linear-gradient(135deg, #f8f9fa, #e9ecef);
        border-radius: 0.75rem;
        padding: 1.5rem;
        border: 1px solid #dee2e6;
        position: relative;
        overflow: hidden;
      }
      #infoContent .info-header-modern::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        height: 4px;
        background: linear-gradient(90deg, #007bff, #28a745, #17a2b8);
      }
      #infoContent .info-title-card {
        display: flex;
        align-items: center;
        gap: 1rem;
      }
      #infoContent .info-icon {
        width: 60px;
        height: 60px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 1.5rem;
        color: white;
        box-shadow: 0 4px 12px rgba(0,0,0,0.15);
      }
      #infoContent .node-icon {
        background: linear-gradient(135deg, #007bff, #0056b3);
      }
      #infoContent .edge-icon {
        background: linear-gradient(135deg, #28a745, #1e7e34);
      }
      #infoContent .info-title-content {
        flex: 1;
      }
      #infoContent .info-main-title {
        font-size: 1.75rem;
        font-weight: 700;
        color: #2c3e50;
        margin-bottom: 0.25rem;
        line-height: 1.2;
      }
      #infoContent .info-subtitle {
        font-size: 0.95rem;
        color: #6c757d;
        margin-bottom: 0;
        font-style: italic;
      }
      
      /* Modern info field styling */
      #infoContent .info-field {
        display: flex;
        align-items: center;
        margin-bottom: 0.5rem;
      }
      #infoContent .field-label {
        font-weight: 600;
        color: #495057;
        margin-right: 0.5rem;
      }
      #infoContent .field-value {
        font-weight: 500;
      }
      
      /* Stat cards */
      #infoContent .stat-card {
        transition: all 0.3s ease;
        border: 1px solid #e9ecef;
      }
      #infoContent .stat-card:hover {
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(0,0,0,0.1);
        border-color: #007bff;
      }
      #infoContent .stat-number {
        font-size: 1.25rem;
        font-weight: 700;
        color: #2c3e50;
      }
      #infoContent .stat-label {
        font-size: 0.875rem;
        color: #6c757d;
        font-weight: 500;
      }
      
      /* Genomic card styling */
      #infoContent .genomic-card .card-header {
        background: linear-gradient(135deg, #007bff, #0056b3) !important;
        border: none;
      }
      #infoContent .genomic-field {
        display: flex;
        align-items: flex-start;
        padding: 0.5rem;
        border-radius: 0.375rem;
        transition: background-color 0.2s ease;
      }
      #infoContent .genomic-field:hover {
        background-color: rgba(0,123,255,0.05);
      }
      #infoContent .field-content {
        flex: 1;
      }
      #infoContent .field-content .field-label {
        font-size: 0.75rem;
        text-transform: uppercase;
        letter-spacing: 0.5px;
        color: #6c757d;
        margin-bottom: 0.25rem;
      }
      #infoContent .chromosome-badge {
        background: linear-gradient(45deg, #28a745, #20c997);
        color: white;
        padding: 0.25rem 0.75rem;
        border-radius: 1rem;
        font-weight: 600;
        font-size: 0.875rem;
      }
      #infoContent .strand-badge {
        padding: 0.25rem 0.5rem;
        border-radius: 0.375rem;
        font-weight: 600;
        font-size: 0.875rem;
      }
      #infoContent .strand-+ {
        background-color: #d4edda;
        color: #155724;
        border: 1px solid #c3e6cb;
      }
      #infoContent .strand-- {
        background-color: #fff3cd;
        color: #856404;
        border: 1px solid #ffeaa7;
      }
      #infoContent .strand-unknown {
        background-color: #e2e3e5;
        color: #383d41;
        border: 1px solid #ced4da;
      }
      #infoContent .position-info {
        border-left: 4px solid #007bff;
      }
      #infoContent .position-stat {
        padding: 0.5rem;
      }
      #infoContent .position-number {
        font-size: 1.1rem;
        font-weight: 700;
        color: #2c3e50;
        font-family: 'Courier New', monospace;
      }
      #infoContent .position-label {
        font-size: 0.75rem;
        text-transform: uppercase;
        letter-spacing: 0.5px;
        color: #6c757d;
        margin-top: 0.25rem;
      }
      
      /* Edge connection styling */
      #infoContent .edge-connection {
        background: linear-gradient(135deg, #f8f9fa, #e9ecef);
        border-radius: 0.5rem;
        padding: 1.5rem;
        border: 1px solid #dee2e6;
      }
      #infoContent .node-endpoint {
        text-align: center;
        padding: 0.75rem;
        background: white;
        border-radius: 0.5rem;
        box-shadow: 0 2px 4px rgba(0,0,0,0.1);
        min-width: 120px;
      }
      #infoContent .endpoint-label {
        font-size: 0.75rem;
        text-transform: uppercase;
        letter-spacing: 0.5px;
        color: #6c757d;
        margin: 0.5rem 0 0.25rem 0;
        font-weight: 600;
      }
      #infoContent .endpoint-id {
        background-color: #f8f9fa;
        padding: 0.25rem 0.5rem;
        border-radius: 0.25rem;
        font-size: 0.875rem;
        color: #495057;
      }
      #infoContent .flow-arrow {
        display: flex;
        flex-direction: column;
        align-items: center;
      }
      #infoContent .weight-badge {
        font-size: 0.875rem;
        font-weight: 700;
        padding: 0.375rem 0.75rem;
        border-radius: 0.5rem;
      }
      #infoContent .weight-label {
        font-size: 0.625rem;
        text-transform: uppercase;
        letter-spacing: 0.5px;
        color: #6c757d;
        margin-top: 0.25rem;
        font-weight: 600;
      }
      #infoContent .edge-stats {
        border-left: 4px solid #17a2b8;
        background: linear-gradient(135deg, #e7f3ff, #f0f8ff);
      }
      #infoContent .stat-icon {
        opacity: 0.8;
      }
      
      /* Table header and export button styling */
      #infoContent .table-header {
        padding: 0.5rem 0;
        border-bottom: 1px solid #e9ecef;
        margin-bottom: 0.75rem !important;
      }
      #infoContent .table-title {
        font-size: 0.875rem;
        font-weight: 500;
      }
      #infoContent .export-btn {
        transition: all 0.3s ease;
        font-size: 0.8rem;
        font-weight: 500;
        border-radius: 0.375rem;
        padding: 0.375rem 0.75rem;
      }
      #infoContent .export-btn:hover {
        transform: translateY(-1px);
        box-shadow: 0 4px 8px rgba(0,123,255,0.2);
      }
      #infoContent .export-btn i {
        font-size: 0.875rem;
      }
      
      /* Consistent card header styling */
      #infoContent .card-header.bg-gradient-primary {
        background: linear-gradient(135deg, #007bff, #0056b3) !important;
        border: none;
      }
      #infoContent .metrics-card .card-header {
        background: linear-gradient(135deg, #17a2b8, #138496) !important;
        border: none;
      }
      #infoContent .exons-card .card-header {
        background: linear-gradient(135deg, #28a745, #1e7e34) !important;
        border: none;
      }
      #infoContent .additional-props-card .card-header {
        background: linear-gradient(135deg, #6c757d, #545b62) !important;
        border: none;
      }
      
      /* PTC/PTF metrics styling */
      #infoContent .metric-stat-card {
        text-align: center;
        padding: 1rem;
        background: white;
        border-radius: 0.5rem;
        box-shadow: 0 2px 4px rgba(0,0,0,0.05);
        transition: all 0.3s ease;
        border: 1px solid #e9ecef;
      }
      #infoContent .metric-stat-card:hover {
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(0,0,0,0.1);
        border-color: #007bff;
      }
      #infoContent .metric-icon {
        font-size: 1.25rem;
      }
      #infoContent .metric-label {
        font-size: 0.75rem;
        text-transform: uppercase;
        letter-spacing: 0.5px;
        color: #6c757d;
        font-weight: 600;
        margin-bottom: 0.5rem;
      }
      #infoContent .metric-value {
        font-size: 1.5rem;
        font-weight: 700;
        font-family: 'Courier New', monospace;
        margin-bottom: 0.25rem;
      }
      #infoContent .ptc-value {
        color: #007bff;
      }
      #infoContent .ptf-value {
        color: #28a745;
      }
      #infoContent .metric-description {
        font-size: 0.625rem;
        color: #868e96;
        font-style: italic;
      }
      
      /* Exons section styling */
      #infoContent .exon-list-container {
        max-height: 250px;
        overflow-y: auto;
      }
      #infoContent .exons-card .exon-visualize-btn {
        background-color: rgba(255, 255, 255, 0.9);
        border-color: rgba(255, 255, 255, 0.5);
        color: #28a745;
        font-weight: 600;
        transition: all 0.3s ease;
      }
      #infoContent .exons-card .exon-visualize-btn:hover {
        background-color: white;
        border-color: white;
        transform: translateY(-1px);
        box-shadow: 0 2px 8px rgba(0,0,0,0.15);
      }
      
      /* Additional properties styling */
      #infoContent .property-row {
        border-color: #e9ecef !important;
      }
      #infoContent .property-header {
        display: flex;
        align-items: center;
      }
      #infoContent .property-name {
        font-weight: 600;
        color: #495057;
        text-transform: capitalize;
        font-size: 0.95rem;
      }
      #infoContent .property-content {
        margin-left: 1rem;
      }
      
      /* Consistent spacing for all cards */
      #infoContent .card {
        border: none;
        box-shadow: 0 2px 8px rgba(0,0,0,0.08);
        border-radius: 0.5rem;
        overflow: hidden;
      }
      #infoContent .card-header {
        font-weight: 600;
        font-size: 0.95rem;
        padding: 0.75rem 1rem;
        border-bottom: none;
      }
      #infoContent .card-body {
        padding: 1rem;
      }
    `;
        document.head.appendChild(style);
    }
}
function $21e684ac5fac7011$export$d95b4270f7110dc3() {
    (0, $5qD1E.STATE).cy.nodes().forEach((node)=>{
        // Check if all connected edges of the node are hidden
        if (node.connectedEdges(":visible").length === 0) node.hide();
    });
}
function $21e684ac5fac7011$export$fc648b45f7e6cbfb() {
    // Enable drag and resize interactions on the cy container
    (0, (/*@__PURE__*/$parcel$interopDefault($65AEs)))("#cy").resizable({
        // Enable resize from right edge
        edges: {
            right: true,
            bottom: true
        },
        // Set minimum size
        restrictSize: {
            min: {
                width: 100,
                height: 100
            }
        }
    }).on("resizemove", (event)=>{
        const target = event.target;
        let x = parseFloat(target.getAttribute("data-x")) || 0;
        let y = parseFloat(target.getAttribute("data-y")) || 0;
        // Update the element's style
        target.style.width = `${event.rect.width}px`;
        target.style.height = `${event.rect.height}px`;
        // Translate when resizing from top or left edges
        x += event.deltaRect.left;
        y += event.deltaRect.top;
        target.style.webkitTransform = target.style.transform = `translate(${x}px,${y}px)`;
        target.setAttribute("data-x", x);
        target.setAttribute("data-y", y);
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($65AEs)))("#rightContainer").resizable({
        // Enable resize from left edge
        edges: {
            left: true,
            right: true
        },
        // Set minimum size
        restrictSize: {
            min: {
                width: 100
            }
        }
    }).on("resizemove", (event)=>{
        const target = event.target;
        let x = parseFloat(target.getAttribute("data-x")) || 0;
        // Update the element's style
        target.style.width = `${event.rect.width}px`;
        // Translate when resizing from left edge
        x += event.deltaRect.left;
        target.style.webkitTransform = target.style.transform = `translate(${x}px)`;
        target.setAttribute("data-x", x);
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($65AEs)))("#info, #walks").resizable({
        edges: {
            right: true
        },
        restrictSize: {
            min: {
                width: 100
            }
        }
    }).on("resizemove", (event)=>{
        const target = event.target;
        const newWidth = event.rect.width;
        // Update the width of the element
        target.style.width = `${newWidth}px`;
        // Update the right position to fill the right side of the screen
        target.style.right = "0";
    });
}

});
parcelRegister("65AEs", function(module, exports) {
/* interact.js 1.10.27 | https://raw.github.com/taye/interact.js/main/LICENSE */ !function(t1, e) {
    module.exports = e();
}(this, function() {
    "use strict";
    function t1(t1, e) {
        var n = Object.keys(t1);
        if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(t1);
            e && (r = r.filter(function(e) {
                return Object.getOwnPropertyDescriptor(t1, e).enumerable;
            })), n.push.apply(n, r);
        }
        return n;
    }
    function e(e) {
        for(var n = 1; n < arguments.length; n++){
            var r = null != arguments[n] ? arguments[n] : {};
            n % 2 ? t1(Object(r), !0).forEach(function(t1) {
                a(e, t1, r[t1]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : t1(Object(r)).forEach(function(t1) {
                Object.defineProperty(e, t1, Object.getOwnPropertyDescriptor(r, t1));
            });
        }
        return e;
    }
    function n(t1) {
        return n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t1) {
            return typeof t1;
        } : function(t1) {
            return t1 && "function" == typeof Symbol && t1.constructor === Symbol && t1 !== Symbol.prototype ? "symbol" : typeof t1;
        }, n(t1);
    }
    function r(t1, e) {
        if (!(t1 instanceof e)) throw new TypeError("Cannot call a class as a function");
    }
    function i(t1, e) {
        for(var n = 0; n < e.length; n++){
            var r = e[n];
            r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t1, d(r.key), r);
        }
    }
    function o(t1, e, n) {
        return e && i(t1.prototype, e), n && i(t1, n), Object.defineProperty(t1, "prototype", {
            writable: !1
        }), t1;
    }
    function a(t1, e, n) {
        return (e = d(e)) in t1 ? Object.defineProperty(t1, e, {
            value: n,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : t1[e] = n, t1;
    }
    function s(t1, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t1.prototype = Object.create(e && e.prototype, {
            constructor: {
                value: t1,
                writable: !0,
                configurable: !0
            }
        }), Object.defineProperty(t1, "prototype", {
            writable: !1
        }), e && l(t1, e);
    }
    function c(t1) {
        return c = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t1) {
            return t1.__proto__ || Object.getPrototypeOf(t1);
        }, c(t1);
    }
    function l(t1, e) {
        return l = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t1, e) {
            return t1.__proto__ = e, t1;
        }, l(t1, e);
    }
    function u(t1) {
        if (void 0 === t1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t1;
    }
    function p(t1) {
        var e = function() {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
            } catch (t1) {
                return !1;
            }
        }();
        return function() {
            var n, r = c(t1);
            if (e) {
                var i = c(this).constructor;
                n = Reflect.construct(r, arguments, i);
            } else n = r.apply(this, arguments);
            return function(t1, e) {
                if (e && ("object" == typeof e || "function" == typeof e)) return e;
                if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
                return u(t1);
            }(this, n);
        };
    }
    function f() {
        return f = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function(t1, e, n) {
            var r = function(t1, e) {
                for(; !Object.prototype.hasOwnProperty.call(t1, e) && null !== (t1 = c(t1)););
                return t1;
            }(t1, e);
            if (r) {
                var i = Object.getOwnPropertyDescriptor(r, e);
                return i.get ? i.get.call(arguments.length < 3 ? t1 : n) : i.value;
            }
        }, f.apply(this, arguments);
    }
    function d(t1) {
        var e = function(t1, e) {
            if ("object" != typeof t1 || null === t1) return t1;
            var n = t1[Symbol.toPrimitive];
            if (void 0 !== n) {
                var r = n.call(t1, e || "default");
                if ("object" != typeof r) return r;
                throw new TypeError("@@toPrimitive must return a primitive value.");
            }
            return ("string" === e ? String : Number)(t1);
        }(t1, "string");
        return "symbol" == typeof e ? e : e + "";
    }
    var h = function(t1) {
        return !(!t1 || !t1.Window) && t1 instanceof t1.Window;
    }, v = void 0, g = void 0;
    function m(t1) {
        v = t1;
        var e = t1.document.createTextNode("");
        e.ownerDocument !== t1.document && "function" == typeof t1.wrap && t1.wrap(e) === e && (t1 = t1.wrap(t1)), g = t1;
    }
    function y(t1) {
        return h(t1) ? t1 : (t1.ownerDocument || t1).defaultView || g.window;
    }
    "undefined" != typeof window && window && m(window);
    var b = function(t1) {
        return !!t1 && "object" === n(t1);
    }, x = function(t1) {
        return "function" == typeof t1;
    }, w = {
        window: function(t1) {
            return t1 === g || h(t1);
        },
        docFrag: function(t1) {
            return b(t1) && 11 === t1.nodeType;
        },
        object: b,
        func: x,
        number: function(t1) {
            return "number" == typeof t1;
        },
        bool: function(t1) {
            return "boolean" == typeof t1;
        },
        string: function(t1) {
            return "string" == typeof t1;
        },
        element: function(t1) {
            if (!t1 || "object" !== n(t1)) return !1;
            var e = y(t1) || g;
            return /object|function/.test("undefined" == typeof Element ? "undefined" : n(Element)) ? t1 instanceof Element || t1 instanceof e.Element : 1 === t1.nodeType && "string" == typeof t1.nodeName;
        },
        plainObject: function(t1) {
            return b(t1) && !!t1.constructor && /function Object\b/.test(t1.constructor.toString());
        },
        array: function(t1) {
            return b(t1) && void 0 !== t1.length && x(t1.splice);
        }
    };
    function E(t1) {
        var e = t1.interaction;
        if ("drag" === e.prepared.name) {
            var n = e.prepared.axis;
            "x" === n ? (e.coords.cur.page.y = e.coords.start.page.y, e.coords.cur.client.y = e.coords.start.client.y, e.coords.velocity.client.y = 0, e.coords.velocity.page.y = 0) : "y" === n && (e.coords.cur.page.x = e.coords.start.page.x, e.coords.cur.client.x = e.coords.start.client.x, e.coords.velocity.client.x = 0, e.coords.velocity.page.x = 0);
        }
    }
    function T(t1) {
        var e = t1.iEvent, n = t1.interaction;
        if ("drag" === n.prepared.name) {
            var r = n.prepared.axis;
            if ("x" === r || "y" === r) {
                var i = "x" === r ? "y" : "x";
                e.page[i] = n.coords.start.page[i], e.client[i] = n.coords.start.client[i], e.delta[i] = 0;
            }
        }
    }
    var S = {
        id: "actions/drag",
        install: function(t1) {
            var e = t1.actions, n = t1.Interactable, r = t1.defaults;
            n.prototype.draggable = S.draggable, e.map.drag = S, e.methodDict.drag = "draggable", r.actions.drag = S.defaults;
        },
        listeners: {
            "interactions:before-action-move": E,
            "interactions:action-resume": E,
            "interactions:action-move": T,
            "auto-start:check": function(t1) {
                var e = t1.interaction, n = t1.interactable, r = t1.buttons, i = n.options.drag;
                if (i && i.enabled && (!e.pointerIsDown || !/mouse|pointer/.test(e.pointerType) || 0 != (r & n.options.drag.mouseButtons))) return t1.action = {
                    name: "drag",
                    axis: "start" === i.lockAxis ? i.startAxis : i.lockAxis
                }, !1;
            }
        },
        draggable: function(t1) {
            return w.object(t1) ? (this.options.drag.enabled = !1 !== t1.enabled, this.setPerAction("drag", t1), this.setOnEvents("drag", t1), /^(xy|x|y|start)$/.test(t1.lockAxis) && (this.options.drag.lockAxis = t1.lockAxis), /^(xy|x|y)$/.test(t1.startAxis) && (this.options.drag.startAxis = t1.startAxis), this) : w.bool(t1) ? (this.options.drag.enabled = t1, this) : this.options.drag;
        },
        beforeMove: E,
        move: T,
        defaults: {
            startAxis: "xy",
            lockAxis: "xy"
        },
        getCursor: function() {
            return "move";
        },
        filterEventType: function(t1) {
            return 0 === t1.search("drag");
        }
    }, _ = S, P = {
        init: function(t1) {
            var e = t1;
            P.document = e.document, P.DocumentFragment = e.DocumentFragment || O, P.SVGElement = e.SVGElement || O, P.SVGSVGElement = e.SVGSVGElement || O, P.SVGElementInstance = e.SVGElementInstance || O, P.Element = e.Element || O, P.HTMLElement = e.HTMLElement || P.Element, P.Event = e.Event, P.Touch = e.Touch || O, P.PointerEvent = e.PointerEvent || e.MSPointerEvent;
        },
        document: null,
        DocumentFragment: null,
        SVGElement: null,
        SVGSVGElement: null,
        SVGElementInstance: null,
        Element: null,
        HTMLElement: null,
        Event: null,
        Touch: null,
        PointerEvent: null
    };
    function O() {}
    var k = P;
    var D = {
        init: function(t1) {
            var e = k.Element, n = t1.navigator || {};
            D.supportsTouch = "ontouchstart" in t1 || w.func(t1.DocumentTouch) && k.document instanceof t1.DocumentTouch, D.supportsPointerEvent = !1 !== n.pointerEnabled && !!k.PointerEvent, D.isIOS = /iP(hone|od|ad)/.test(n.platform), D.isIOS7 = /iP(hone|od|ad)/.test(n.platform) && /OS 7[^\d]/.test(n.appVersion), D.isIe9 = /MSIE 9/.test(n.userAgent), D.isOperaMobile = "Opera" === n.appName && D.supportsTouch && /Presto/.test(n.userAgent), D.prefixedMatchesSelector = "matches" in e.prototype ? "matches" : "webkitMatchesSelector" in e.prototype ? "webkitMatchesSelector" : "mozMatchesSelector" in e.prototype ? "mozMatchesSelector" : "oMatchesSelector" in e.prototype ? "oMatchesSelector" : "msMatchesSelector", D.pEventTypes = D.supportsPointerEvent ? k.PointerEvent === t1.MSPointerEvent ? {
                up: "MSPointerUp",
                down: "MSPointerDown",
                over: "mouseover",
                out: "mouseout",
                move: "MSPointerMove",
                cancel: "MSPointerCancel"
            } : {
                up: "pointerup",
                down: "pointerdown",
                over: "pointerover",
                out: "pointerout",
                move: "pointermove",
                cancel: "pointercancel"
            } : null, D.wheelEvent = k.document && "onmousewheel" in k.document ? "mousewheel" : "wheel";
        },
        supportsTouch: null,
        supportsPointerEvent: null,
        isIOS7: null,
        isIOS: null,
        isIe9: null,
        isOperaMobile: null,
        prefixedMatchesSelector: null,
        pEventTypes: null,
        wheelEvent: null
    };
    var I = D;
    function M(t1, e) {
        if (t1.contains) return t1.contains(e);
        for(; e;){
            if (e === t1) return !0;
            e = e.parentNode;
        }
        return !1;
    }
    function z(t1, e) {
        for(; w.element(t1);){
            if (R(t1, e)) return t1;
            t1 = A(t1);
        }
        return null;
    }
    function A(t1) {
        var e = t1.parentNode;
        if (w.docFrag(e)) {
            for(; (e = e.host) && w.docFrag(e););
            return e;
        }
        return e;
    }
    function R(t1, e) {
        return g !== v && (e = e.replace(/\/deep\//g, " ")), t1[I.prefixedMatchesSelector](e);
    }
    var C = function(t1) {
        return t1.parentNode || t1.host;
    };
    function j(t1, e) {
        for(var n, r = [], i = t1; (n = C(i)) && i !== e && n !== i.ownerDocument;)r.unshift(i), i = n;
        return r;
    }
    function F(t1, e, n) {
        for(; w.element(t1);){
            if (R(t1, e)) return !0;
            if ((t1 = A(t1)) === n) return R(t1, e);
        }
        return !1;
    }
    function X(t1) {
        return t1.correspondingUseElement || t1;
    }
    function Y(t1) {
        var e = t1 instanceof k.SVGElement ? t1.getBoundingClientRect() : t1.getClientRects()[0];
        return e && {
            left: e.left,
            right: e.right,
            top: e.top,
            bottom: e.bottom,
            width: e.width || e.right - e.left,
            height: e.height || e.bottom - e.top
        };
    }
    function L(t1) {
        var e, n = Y(t1);
        if (!I.isIOS7 && n) {
            var r = {
                x: (e = (e = y(t1)) || g).scrollX || e.document.documentElement.scrollLeft,
                y: e.scrollY || e.document.documentElement.scrollTop
            };
            n.left += r.x, n.right += r.x, n.top += r.y, n.bottom += r.y;
        }
        return n;
    }
    function q(t1) {
        for(var e = []; t1;)e.push(t1), t1 = A(t1);
        return e;
    }
    function B(t1) {
        return !!w.string(t1) && (k.document.querySelector(t1), !0);
    }
    function V(t1, e) {
        for(var n in e)t1[n] = e[n];
        return t1;
    }
    function W(t1, e, n) {
        return "parent" === t1 ? A(n) : "self" === t1 ? e.getRect(n) : z(n, t1);
    }
    function G(t1, e, n, r) {
        var i = t1;
        return w.string(i) ? i = W(i, e, n) : w.func(i) && (i = i.apply(void 0, r)), w.element(i) && (i = L(i)), i;
    }
    function N(t1) {
        return t1 && {
            x: "x" in t1 ? t1.x : t1.left,
            y: "y" in t1 ? t1.y : t1.top
        };
    }
    function U(t1) {
        return !t1 || "x" in t1 && "y" in t1 || ((t1 = V({}, t1)).x = t1.left || 0, t1.y = t1.top || 0, t1.width = t1.width || (t1.right || 0) - t1.x, t1.height = t1.height || (t1.bottom || 0) - t1.y), t1;
    }
    function H(t1, e, n) {
        t1.left && (e.left += n.x), t1.right && (e.right += n.x), t1.top && (e.top += n.y), t1.bottom && (e.bottom += n.y), e.width = e.right - e.left, e.height = e.bottom - e.top;
    }
    function K(t1, e, n) {
        var r = n && t1.options[n];
        return N(G(r && r.origin || t1.options.origin, t1, e, [
            t1 && e
        ])) || {
            x: 0,
            y: 0
        };
    }
    function $(t1, e) {
        var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : function(t1) {
            return !0;
        }, r = arguments.length > 3 ? arguments[3] : void 0;
        if (r = r || {}, w.string(t1) && -1 !== t1.search(" ") && (t1 = J(t1)), w.array(t1)) return t1.forEach(function(t1) {
            return $(t1, e, n, r);
        }), r;
        if (w.object(t1) && (e = t1, t1 = ""), w.func(e) && n(t1)) r[t1] = r[t1] || [], r[t1].push(e);
        else if (w.array(e)) for(var i = 0, o = e; i < o.length; i++){
            var a = o[i];
            $(t1, a, n, r);
        }
        else if (w.object(e)) for(var s in e)$(J(s).map(function(e) {
            return "".concat(t1).concat(e);
        }), e[s], n, r);
        return r;
    }
    function J(t1) {
        return t1.trim().split(/ +/);
    }
    var Q = function(t1, e) {
        return Math.sqrt(t1 * t1 + e * e);
    }, Z = [
        "webkit",
        "moz"
    ];
    function tt(t1, e) {
        t1.__set || (t1.__set = {});
        var n = function(n) {
            if (Z.some(function(t1) {
                return 0 === n.indexOf(t1);
            })) return 1;
            "function" != typeof t1[n] && "__set" !== n && Object.defineProperty(t1, n, {
                get: function() {
                    return n in t1.__set ? t1.__set[n] : t1.__set[n] = e[n];
                },
                set: function(e) {
                    t1.__set[n] = e;
                },
                configurable: !0
            });
        };
        for(var r in e)n(r);
        return t1;
    }
    function et(t1, e) {
        t1.page = t1.page || {}, t1.page.x = e.page.x, t1.page.y = e.page.y, t1.client = t1.client || {}, t1.client.x = e.client.x, t1.client.y = e.client.y, t1.timeStamp = e.timeStamp;
    }
    function nt(t1) {
        t1.page.x = 0, t1.page.y = 0, t1.client.x = 0, t1.client.y = 0;
    }
    function rt(t1) {
        return t1 instanceof k.Event || t1 instanceof k.Touch;
    }
    function it(t1, e, n) {
        return t1 = t1 || "page", (n = n || {}).x = e[t1 + "X"], n.y = e[t1 + "Y"], n;
    }
    function ot(t1, e) {
        return e = e || {
            x: 0,
            y: 0
        }, I.isOperaMobile && rt(t1) ? (it("screen", t1, e), e.x += window.scrollX, e.y += window.scrollY) : it("page", t1, e), e;
    }
    function at(t1) {
        return w.number(t1.pointerId) ? t1.pointerId : t1.identifier;
    }
    function st(t1, e, n) {
        var r = e.length > 1 ? lt(e) : e[0];
        ot(r, t1.page), function(t1, e) {
            e = e || {}, I.isOperaMobile && rt(t1) ? it("screen", t1, e) : it("client", t1, e);
        }(r, t1.client), t1.timeStamp = n;
    }
    function ct(t1) {
        var e = [];
        return w.array(t1) ? (e[0] = t1[0], e[1] = t1[1]) : "touchend" === t1.type ? 1 === t1.touches.length ? (e[0] = t1.touches[0], e[1] = t1.changedTouches[0]) : 0 === t1.touches.length && (e[0] = t1.changedTouches[0], e[1] = t1.changedTouches[1]) : (e[0] = t1.touches[0], e[1] = t1.touches[1]), e;
    }
    function lt(t1) {
        for(var e = {
            pageX: 0,
            pageY: 0,
            clientX: 0,
            clientY: 0,
            screenX: 0,
            screenY: 0
        }, n = 0; n < t1.length; n++){
            var r = t1[n];
            for(var i in e)e[i] += r[i];
        }
        for(var o in e)e[o] /= t1.length;
        return e;
    }
    function ut(t1) {
        if (!t1.length) return null;
        var e = ct(t1), n = Math.min(e[0].pageX, e[1].pageX), r = Math.min(e[0].pageY, e[1].pageY), i = Math.max(e[0].pageX, e[1].pageX), o = Math.max(e[0].pageY, e[1].pageY);
        return {
            x: n,
            y: r,
            left: n,
            top: r,
            right: i,
            bottom: o,
            width: i - n,
            height: o - r
        };
    }
    function pt(t1, e) {
        var n = e + "X", r = e + "Y", i = ct(t1), o = i[0][n] - i[1][n], a = i[0][r] - i[1][r];
        return Q(o, a);
    }
    function ft(t1, e) {
        var n = e + "X", r = e + "Y", i = ct(t1), o = i[1][n] - i[0][n], a = i[1][r] - i[0][r];
        return 180 * Math.atan2(a, o) / Math.PI;
    }
    function dt(t1) {
        return w.string(t1.pointerType) ? t1.pointerType : w.number(t1.pointerType) ? [
            void 0,
            void 0,
            "touch",
            "pen",
            "mouse"
        ][t1.pointerType] : /touch/.test(t1.type || "") || t1 instanceof k.Touch ? "touch" : "mouse";
    }
    function ht(t1) {
        var e = w.func(t1.composedPath) ? t1.composedPath() : t1.path;
        return [
            X(e ? e[0] : t1.target),
            X(t1.currentTarget)
        ];
    }
    var vt = function() {
        function t1(e) {
            r(this, t1), this.immediatePropagationStopped = !1, this.propagationStopped = !1, this._interaction = e;
        }
        return o(t1, [
            {
                key: "preventDefault",
                value: function() {}
            },
            {
                key: "stopPropagation",
                value: function() {
                    this.propagationStopped = !0;
                }
            },
            {
                key: "stopImmediatePropagation",
                value: function() {
                    this.immediatePropagationStopped = this.propagationStopped = !0;
                }
            }
        ]), t1;
    }();
    Object.defineProperty(vt.prototype, "interaction", {
        get: function() {
            return this._interaction._proxy;
        },
        set: function() {}
    });
    var gt = function(t1, e) {
        for(var n = 0; n < e.length; n++){
            var r = e[n];
            t1.push(r);
        }
        return t1;
    }, mt = function(t1) {
        return gt([], t1);
    }, yt = function(t1, e) {
        for(var n = 0; n < t1.length; n++)if (e(t1[n], n, t1)) return n;
        return -1;
    }, bt = function(t1, e) {
        return t1[yt(t1, e)];
    }, xt = function(t1) {
        s(n, t1);
        var e = p(n);
        function n(t1, i, o) {
            var a;
            r(this, n), (a = e.call(this, i._interaction)).dropzone = void 0, a.dragEvent = void 0, a.relatedTarget = void 0, a.draggable = void 0, a.propagationStopped = !1, a.immediatePropagationStopped = !1;
            var s = "dragleave" === o ? t1.prev : t1.cur, c = s.element, l = s.dropzone;
            return a.type = o, a.target = c, a.currentTarget = c, a.dropzone = l, a.dragEvent = i, a.relatedTarget = i.target, a.draggable = i.interactable, a.timeStamp = i.timeStamp, a;
        }
        return o(n, [
            {
                key: "reject",
                value: function() {
                    var t1 = this, e = this._interaction.dropState;
                    if ("dropactivate" === this.type || this.dropzone && e.cur.dropzone === this.dropzone && e.cur.element === this.target) {
                        if (e.prev.dropzone = this.dropzone, e.prev.element = this.target, e.rejected = !0, e.events.enter = null, this.stopImmediatePropagation(), "dropactivate" === this.type) {
                            var r = e.activeDrops, i = yt(r, function(e) {
                                var n = e.dropzone, r = e.element;
                                return n === t1.dropzone && r === t1.target;
                            });
                            e.activeDrops.splice(i, 1);
                            var o = new n(e, this.dragEvent, "dropdeactivate");
                            o.dropzone = this.dropzone, o.target = this.target, this.dropzone.fire(o);
                        } else this.dropzone.fire(new n(e, this.dragEvent, "dragleave"));
                    }
                }
            },
            {
                key: "preventDefault",
                value: function() {}
            },
            {
                key: "stopPropagation",
                value: function() {
                    this.propagationStopped = !0;
                }
            },
            {
                key: "stopImmediatePropagation",
                value: function() {
                    this.immediatePropagationStopped = this.propagationStopped = !0;
                }
            }
        ]), n;
    }(vt);
    function wt(t1, e) {
        for(var n = 0, r = t1.slice(); n < r.length; n++){
            var i = r[n], o = i.dropzone, a = i.element;
            e.dropzone = o, e.target = a, o.fire(e), e.propagationStopped = e.immediatePropagationStopped = !1;
        }
    }
    function Et(t1, e) {
        for(var n = function(t1, e) {
            for(var n = [], r = 0, i = t1.interactables.list; r < i.length; r++){
                var o = i[r];
                if (o.options.drop.enabled) {
                    var a = o.options.drop.accept;
                    if (!(w.element(a) && a !== e || w.string(a) && !R(e, a) || w.func(a) && !a({
                        dropzone: o,
                        draggableElement: e
                    }))) for(var s = 0, c = o.getAllElements(); s < c.length; s++){
                        var l = c[s];
                        l !== e && n.push({
                            dropzone: o,
                            element: l,
                            rect: o.getRect(l)
                        });
                    }
                }
            }
            return n;
        }(t1, e), r = 0; r < n.length; r++){
            var i = n[r];
            i.rect = i.dropzone.getRect(i.element);
        }
        return n;
    }
    function Tt(t1, e, n) {
        for(var r = t1.dropState, i = t1.interactable, o = t1.element, a = [], s = 0, c = r.activeDrops; s < c.length; s++){
            var l = c[s], u = l.dropzone, p = l.element, f = l.rect, d = u.dropCheck(e, n, i, o, p, f);
            a.push(d ? p : null);
        }
        var h = function(t1) {
            for(var e, n, r, i = [], o = 0; o < t1.length; o++){
                var a = t1[o], s = t1[e];
                if (a && o !== e) {
                    if (s) {
                        var c = C(a), l = C(s);
                        if (c !== a.ownerDocument) {
                            if (l !== a.ownerDocument) {
                                if (c !== l) {
                                    i = i.length ? i : j(s);
                                    var u = void 0;
                                    if (s instanceof k.HTMLElement && a instanceof k.SVGElement && !(a instanceof k.SVGSVGElement)) {
                                        if (a === l) continue;
                                        u = a.ownerSVGElement;
                                    } else u = a;
                                    for(var p = j(u, s.ownerDocument), f = 0; p[f] && p[f] === i[f];)f++;
                                    var d = [
                                        p[f - 1],
                                        p[f],
                                        i[f]
                                    ];
                                    if (d[0]) for(var h = d[0].lastChild; h;){
                                        if (h === d[1]) {
                                            e = o, i = p;
                                            break;
                                        }
                                        if (h === d[2]) break;
                                        h = h.previousSibling;
                                    }
                                } else r = s, (parseInt(y(n = a).getComputedStyle(n).zIndex, 10) || 0) >= (parseInt(y(r).getComputedStyle(r).zIndex, 10) || 0) && (e = o);
                            } else e = o;
                        }
                    } else e = o;
                }
            }
            return e;
        }(a);
        return r.activeDrops[h] || null;
    }
    function St(t1, e, n) {
        var r = t1.dropState, i = {
            enter: null,
            leave: null,
            activate: null,
            deactivate: null,
            move: null,
            drop: null
        };
        return "dragstart" === n.type && (i.activate = new xt(r, n, "dropactivate"), i.activate.target = null, i.activate.dropzone = null), "dragend" === n.type && (i.deactivate = new xt(r, n, "dropdeactivate"), i.deactivate.target = null, i.deactivate.dropzone = null), r.rejected || (r.cur.element !== r.prev.element && (r.prev.dropzone && (i.leave = new xt(r, n, "dragleave"), n.dragLeave = i.leave.target = r.prev.element, n.prevDropzone = i.leave.dropzone = r.prev.dropzone), r.cur.dropzone && (i.enter = new xt(r, n, "dragenter"), n.dragEnter = r.cur.element, n.dropzone = r.cur.dropzone)), "dragend" === n.type && r.cur.dropzone && (i.drop = new xt(r, n, "drop"), n.dropzone = r.cur.dropzone, n.relatedTarget = r.cur.element), "dragmove" === n.type && r.cur.dropzone && (i.move = new xt(r, n, "dropmove"), n.dropzone = r.cur.dropzone)), i;
    }
    function _t(t1, e) {
        var n = t1.dropState, r = n.activeDrops, i = n.cur, o = n.prev;
        e.leave && o.dropzone.fire(e.leave), e.enter && i.dropzone.fire(e.enter), e.move && i.dropzone.fire(e.move), e.drop && i.dropzone.fire(e.drop), e.deactivate && wt(r, e.deactivate), n.prev.dropzone = i.dropzone, n.prev.element = i.element;
    }
    function Pt(t1, e) {
        var n = t1.interaction, r = t1.iEvent, i = t1.event;
        if ("dragmove" === r.type || "dragend" === r.type) {
            var o = n.dropState;
            e.dynamicDrop && (o.activeDrops = Et(e, n.element));
            var a = r, s = Tt(n, a, i);
            o.rejected = o.rejected && !!s && s.dropzone === o.cur.dropzone && s.element === o.cur.element, o.cur.dropzone = s && s.dropzone, o.cur.element = s && s.element, o.events = St(n, 0, a);
        }
    }
    var Ot = {
        id: "actions/drop",
        install: function(t1) {
            var e = t1.actions, n = t1.interactStatic, r = t1.Interactable, i = t1.defaults;
            t1.usePlugin(_), r.prototype.dropzone = function(t1) {
                return function(t1, e) {
                    if (w.object(e)) {
                        if (t1.options.drop.enabled = !1 !== e.enabled, e.listeners) {
                            var n = $(e.listeners), r = Object.keys(n).reduce(function(t1, e) {
                                return t1[/^(enter|leave)/.test(e) ? "drag".concat(e) : /^(activate|deactivate|move)/.test(e) ? "drop".concat(e) : e] = n[e], t1;
                            }, {}), i = t1.options.drop.listeners;
                            i && t1.off(i), t1.on(r), t1.options.drop.listeners = r;
                        }
                        return w.func(e.ondrop) && t1.on("drop", e.ondrop), w.func(e.ondropactivate) && t1.on("dropactivate", e.ondropactivate), w.func(e.ondropdeactivate) && t1.on("dropdeactivate", e.ondropdeactivate), w.func(e.ondragenter) && t1.on("dragenter", e.ondragenter), w.func(e.ondragleave) && t1.on("dragleave", e.ondragleave), w.func(e.ondropmove) && t1.on("dropmove", e.ondropmove), /^(pointer|center)$/.test(e.overlap) ? t1.options.drop.overlap = e.overlap : w.number(e.overlap) && (t1.options.drop.overlap = Math.max(Math.min(1, e.overlap), 0)), "accept" in e && (t1.options.drop.accept = e.accept), "checker" in e && (t1.options.drop.checker = e.checker), t1;
                    }
                    if (w.bool(e)) return t1.options.drop.enabled = e, t1;
                    return t1.options.drop;
                }(this, t1);
            }, r.prototype.dropCheck = function(t1, e, n, r, i, o) {
                return function(t1, e, n, r, i, o, a) {
                    var s = !1;
                    if (!(a = a || t1.getRect(o))) return !!t1.options.drop.checker && t1.options.drop.checker(e, n, s, t1, o, r, i);
                    var c = t1.options.drop.overlap;
                    if ("pointer" === c) {
                        var l = K(r, i, "drag"), u = ot(e);
                        u.x += l.x, u.y += l.y;
                        var p = u.x > a.left && u.x < a.right, f = u.y > a.top && u.y < a.bottom;
                        s = p && f;
                    }
                    var d = r.getRect(i);
                    if (d && "center" === c) {
                        var h = d.left + d.width / 2, v = d.top + d.height / 2;
                        s = h >= a.left && h <= a.right && v >= a.top && v <= a.bottom;
                    }
                    if (d && w.number(c)) s = Math.max(0, Math.min(a.right, d.right) - Math.max(a.left, d.left)) * Math.max(0, Math.min(a.bottom, d.bottom) - Math.max(a.top, d.top)) / (d.width * d.height) >= c;
                    t1.options.drop.checker && (s = t1.options.drop.checker(e, n, s, t1, o, r, i));
                    return s;
                }(this, t1, e, n, r, i, o);
            }, n.dynamicDrop = function(e) {
                return w.bool(e) ? (t1.dynamicDrop = e, n) : t1.dynamicDrop;
            }, V(e.phaselessTypes, {
                dragenter: !0,
                dragleave: !0,
                dropactivate: !0,
                dropdeactivate: !0,
                dropmove: !0,
                drop: !0
            }), e.methodDict.drop = "dropzone", t1.dynamicDrop = !1, i.actions.drop = Ot.defaults;
        },
        listeners: {
            "interactions:before-action-start": function(t1) {
                var e = t1.interaction;
                "drag" === e.prepared.name && (e.dropState = {
                    cur: {
                        dropzone: null,
                        element: null
                    },
                    prev: {
                        dropzone: null,
                        element: null
                    },
                    rejected: null,
                    events: null,
                    activeDrops: []
                });
            },
            "interactions:after-action-start": function(t1, e) {
                var n = t1.interaction, r = (t1.event, t1.iEvent);
                if ("drag" === n.prepared.name) {
                    var i = n.dropState;
                    i.activeDrops = [], i.events = {}, i.activeDrops = Et(e, n.element), i.events = St(n, 0, r), i.events.activate && (wt(i.activeDrops, i.events.activate), e.fire("actions/drop:start", {
                        interaction: n,
                        dragEvent: r
                    }));
                }
            },
            "interactions:action-move": Pt,
            "interactions:after-action-move": function(t1, e) {
                var n = t1.interaction, r = t1.iEvent;
                if ("drag" === n.prepared.name) {
                    var i = n.dropState;
                    _t(n, i.events), e.fire("actions/drop:move", {
                        interaction: n,
                        dragEvent: r
                    }), i.events = {};
                }
            },
            "interactions:action-end": function(t1, e) {
                if ("drag" === t1.interaction.prepared.name) {
                    var n = t1.interaction, r = t1.iEvent;
                    Pt(t1, e), _t(n, n.dropState.events), e.fire("actions/drop:end", {
                        interaction: n,
                        dragEvent: r
                    });
                }
            },
            "interactions:stop": function(t1) {
                var e = t1.interaction;
                if ("drag" === e.prepared.name) {
                    var n = e.dropState;
                    n && (n.activeDrops = null, n.events = null, n.cur.dropzone = null, n.cur.element = null, n.prev.dropzone = null, n.prev.element = null, n.rejected = !1);
                }
            }
        },
        getActiveDrops: Et,
        getDrop: Tt,
        getDropEvents: St,
        fireDropEvents: _t,
        filterEventType: function(t1) {
            return 0 === t1.search("drag") || 0 === t1.search("drop");
        },
        defaults: {
            enabled: !1,
            accept: null,
            overlap: "pointer"
        }
    }, kt = Ot;
    function Dt(t1) {
        var e = t1.interaction, n = t1.iEvent, r = t1.phase;
        if ("gesture" === e.prepared.name) {
            var i = e.pointers.map(function(t1) {
                return t1.pointer;
            }), o = "start" === r, a = "end" === r, s = e.interactable.options.deltaSource;
            if (n.touches = [
                i[0],
                i[1]
            ], o) n.distance = pt(i, s), n.box = ut(i), n.scale = 1, n.ds = 0, n.angle = ft(i, s), n.da = 0, e.gesture.startDistance = n.distance, e.gesture.startAngle = n.angle;
            else if (a || e.pointers.length < 2) {
                var c = e.prevEvent;
                n.distance = c.distance, n.box = c.box, n.scale = c.scale, n.ds = 0, n.angle = c.angle, n.da = 0;
            } else n.distance = pt(i, s), n.box = ut(i), n.scale = n.distance / e.gesture.startDistance, n.angle = ft(i, s), n.ds = n.scale - e.gesture.scale, n.da = n.angle - e.gesture.angle;
            e.gesture.distance = n.distance, e.gesture.angle = n.angle, w.number(n.scale) && n.scale !== 1 / 0 && !isNaN(n.scale) && (e.gesture.scale = n.scale);
        }
    }
    var It = {
        id: "actions/gesture",
        before: [
            "actions/drag",
            "actions/resize"
        ],
        install: function(t1) {
            var e = t1.actions, n = t1.Interactable, r = t1.defaults;
            n.prototype.gesturable = function(t1) {
                return w.object(t1) ? (this.options.gesture.enabled = !1 !== t1.enabled, this.setPerAction("gesture", t1), this.setOnEvents("gesture", t1), this) : w.bool(t1) ? (this.options.gesture.enabled = t1, this) : this.options.gesture;
            }, e.map.gesture = It, e.methodDict.gesture = "gesturable", r.actions.gesture = It.defaults;
        },
        listeners: {
            "interactions:action-start": Dt,
            "interactions:action-move": Dt,
            "interactions:action-end": Dt,
            "interactions:new": function(t1) {
                t1.interaction.gesture = {
                    angle: 0,
                    distance: 0,
                    scale: 1,
                    startAngle: 0,
                    startDistance: 0
                };
            },
            "auto-start:check": function(t1) {
                if (!(t1.interaction.pointers.length < 2)) {
                    var e = t1.interactable.options.gesture;
                    if (e && e.enabled) return t1.action = {
                        name: "gesture"
                    }, !1;
                }
            }
        },
        defaults: {},
        getCursor: function() {
            return "";
        },
        filterEventType: function(t1) {
            return 0 === t1.search("gesture");
        }
    }, Mt = It;
    function zt(t1, e, n, r, i, o, a) {
        if (!e) return !1;
        if (!0 === e) {
            var s = w.number(o.width) ? o.width : o.right - o.left, c = w.number(o.height) ? o.height : o.bottom - o.top;
            if (a = Math.min(a, Math.abs(("left" === t1 || "right" === t1 ? s : c) / 2)), s < 0 && ("left" === t1 ? t1 = "right" : "right" === t1 && (t1 = "left")), c < 0 && ("top" === t1 ? t1 = "bottom" : "bottom" === t1 && (t1 = "top")), "left" === t1) {
                var l = s >= 0 ? o.left : o.right;
                return n.x < l + a;
            }
            if ("top" === t1) {
                var u = c >= 0 ? o.top : o.bottom;
                return n.y < u + a;
            }
            if ("right" === t1) return n.x > (s >= 0 ? o.right : o.left) - a;
            if ("bottom" === t1) return n.y > (c >= 0 ? o.bottom : o.top) - a;
        }
        return !!w.element(r) && (w.element(e) ? e === r : F(r, e, i));
    }
    function At(t1) {
        var e = t1.iEvent, n = t1.interaction;
        if ("resize" === n.prepared.name && n.resizeAxes) {
            var r = e;
            n.interactable.options.resize.square ? ("y" === n.resizeAxes ? r.delta.x = r.delta.y : r.delta.y = r.delta.x, r.axes = "xy") : (r.axes = n.resizeAxes, "x" === n.resizeAxes ? r.delta.y = 0 : "y" === n.resizeAxes && (r.delta.x = 0));
        }
    }
    var Rt, Ct, jt = {
        id: "actions/resize",
        before: [
            "actions/drag"
        ],
        install: function(t1) {
            var e = t1.actions, n = t1.browser, r = t1.Interactable, i = t1.defaults;
            jt.cursors = function(t1) {
                return t1.isIe9 ? {
                    x: "e-resize",
                    y: "s-resize",
                    xy: "se-resize",
                    top: "n-resize",
                    left: "w-resize",
                    bottom: "s-resize",
                    right: "e-resize",
                    topleft: "se-resize",
                    bottomright: "se-resize",
                    topright: "ne-resize",
                    bottomleft: "ne-resize"
                } : {
                    x: "ew-resize",
                    y: "ns-resize",
                    xy: "nwse-resize",
                    top: "ns-resize",
                    left: "ew-resize",
                    bottom: "ns-resize",
                    right: "ew-resize",
                    topleft: "nwse-resize",
                    bottomright: "nwse-resize",
                    topright: "nesw-resize",
                    bottomleft: "nesw-resize"
                };
            }(n), jt.defaultMargin = n.supportsTouch || n.supportsPointerEvent ? 20 : 10, r.prototype.resizable = function(e) {
                return function(t1, e, n) {
                    if (w.object(e)) return t1.options.resize.enabled = !1 !== e.enabled, t1.setPerAction("resize", e), t1.setOnEvents("resize", e), w.string(e.axis) && /^x$|^y$|^xy$/.test(e.axis) ? t1.options.resize.axis = e.axis : null === e.axis && (t1.options.resize.axis = n.defaults.actions.resize.axis), w.bool(e.preserveAspectRatio) ? t1.options.resize.preserveAspectRatio = e.preserveAspectRatio : w.bool(e.square) && (t1.options.resize.square = e.square), t1;
                    if (w.bool(e)) return t1.options.resize.enabled = e, t1;
                    return t1.options.resize;
                }(this, e, t1);
            }, e.map.resize = jt, e.methodDict.resize = "resizable", i.actions.resize = jt.defaults;
        },
        listeners: {
            "interactions:new": function(t1) {
                t1.interaction.resizeAxes = "xy";
            },
            "interactions:action-start": function(t1) {
                !function(t1) {
                    var e = t1.iEvent, n = t1.interaction;
                    if ("resize" === n.prepared.name && n.prepared.edges) {
                        var r = e, i = n.rect;
                        n._rects = {
                            start: V({}, i),
                            corrected: V({}, i),
                            previous: V({}, i),
                            delta: {
                                left: 0,
                                right: 0,
                                width: 0,
                                top: 0,
                                bottom: 0,
                                height: 0
                            }
                        }, r.edges = n.prepared.edges, r.rect = n._rects.corrected, r.deltaRect = n._rects.delta;
                    }
                }(t1), At(t1);
            },
            "interactions:action-move": function(t1) {
                !function(t1) {
                    var e = t1.iEvent, n = t1.interaction;
                    if ("resize" === n.prepared.name && n.prepared.edges) {
                        var r = e, i = n.interactable.options.resize.invert, o = "reposition" === i || "negate" === i, a = n.rect, s = n._rects, c = s.start, l = s.corrected, u = s.delta, p = s.previous;
                        if (V(p, l), o) {
                            if (V(l, a), "reposition" === i) {
                                if (l.top > l.bottom) {
                                    var f = l.top;
                                    l.top = l.bottom, l.bottom = f;
                                }
                                if (l.left > l.right) {
                                    var d = l.left;
                                    l.left = l.right, l.right = d;
                                }
                            }
                        } else l.top = Math.min(a.top, c.bottom), l.bottom = Math.max(a.bottom, c.top), l.left = Math.min(a.left, c.right), l.right = Math.max(a.right, c.left);
                        for(var h in l.width = l.right - l.left, l.height = l.bottom - l.top, l)u[h] = l[h] - p[h];
                        r.edges = n.prepared.edges, r.rect = l, r.deltaRect = u;
                    }
                }(t1), At(t1);
            },
            "interactions:action-end": function(t1) {
                var e = t1.iEvent, n = t1.interaction;
                if ("resize" === n.prepared.name && n.prepared.edges) {
                    var r = e;
                    r.edges = n.prepared.edges, r.rect = n._rects.corrected, r.deltaRect = n._rects.delta;
                }
            },
            "auto-start:check": function(t1) {
                var e = t1.interaction, n = t1.interactable, r = t1.element, i = t1.rect, o = t1.buttons;
                if (i) {
                    var a = V({}, e.coords.cur.page), s = n.options.resize;
                    if (s && s.enabled && (!e.pointerIsDown || !/mouse|pointer/.test(e.pointerType) || 0 != (o & s.mouseButtons))) {
                        if (w.object(s.edges)) {
                            var c = {
                                left: !1,
                                right: !1,
                                top: !1,
                                bottom: !1
                            };
                            for(var l in c)c[l] = zt(l, s.edges[l], a, e._latestPointer.eventTarget, r, i, s.margin || jt.defaultMargin);
                            c.left = c.left && !c.right, c.top = c.top && !c.bottom, (c.left || c.right || c.top || c.bottom) && (t1.action = {
                                name: "resize",
                                edges: c
                            });
                        } else {
                            var u = "y" !== s.axis && a.x > i.right - jt.defaultMargin, p = "x" !== s.axis && a.y > i.bottom - jt.defaultMargin;
                            (u || p) && (t1.action = {
                                name: "resize",
                                axes: (u ? "x" : "") + (p ? "y" : "")
                            });
                        }
                        return !t1.action && void 0;
                    }
                }
            }
        },
        defaults: {
            square: !1,
            preserveAspectRatio: !1,
            axis: "xy",
            margin: NaN,
            edges: null,
            invert: "none"
        },
        cursors: null,
        getCursor: function(t1) {
            var e = t1.edges, n = t1.axis, r = t1.name, i = jt.cursors, o = null;
            if (n) o = i[r + n];
            else if (e) {
                for(var a = "", s = 0, c = [
                    "top",
                    "bottom",
                    "left",
                    "right"
                ]; s < c.length; s++){
                    var l = c[s];
                    e[l] && (a += l);
                }
                o = i[a];
            }
            return o;
        },
        filterEventType: function(t1) {
            return 0 === t1.search("resize");
        },
        defaultMargin: null
    }, Ft = jt, Xt = {
        id: "actions",
        install: function(t1) {
            t1.usePlugin(Mt), t1.usePlugin(Ft), t1.usePlugin(_), t1.usePlugin(kt);
        }
    }, Yt = 0;
    var Lt = {
        request: function(t1) {
            return Rt(t1);
        },
        cancel: function(t1) {
            return Ct(t1);
        },
        init: function(t1) {
            if (Rt = t1.requestAnimationFrame, Ct = t1.cancelAnimationFrame, !Rt) for(var e = [
                "ms",
                "moz",
                "webkit",
                "o"
            ], n = 0; n < e.length; n++){
                var r = e[n];
                Rt = t1["".concat(r, "RequestAnimationFrame")], Ct = t1["".concat(r, "CancelAnimationFrame")] || t1["".concat(r, "CancelRequestAnimationFrame")];
            }
            Rt = Rt && Rt.bind(t1), Ct = Ct && Ct.bind(t1), Rt || (Rt = function(e) {
                var n = Date.now(), r = Math.max(0, 16 - (n - Yt)), i = t1.setTimeout(function() {
                    e(n + r);
                }, r);
                return Yt = n + r, i;
            }, Ct = function(t1) {
                return clearTimeout(t1);
            });
        }
    };
    var qt = {
        defaults: {
            enabled: !1,
            margin: 60,
            container: null,
            speed: 300
        },
        now: Date.now,
        interaction: null,
        i: 0,
        x: 0,
        y: 0,
        isScrolling: !1,
        prevTime: 0,
        margin: 0,
        speed: 0,
        start: function(t1) {
            qt.isScrolling = !0, Lt.cancel(qt.i), t1.autoScroll = qt, qt.interaction = t1, qt.prevTime = qt.now(), qt.i = Lt.request(qt.scroll);
        },
        stop: function() {
            qt.isScrolling = !1, qt.interaction && (qt.interaction.autoScroll = null), Lt.cancel(qt.i);
        },
        scroll: function() {
            var t1 = qt.interaction, e = t1.interactable, n = t1.element, r = t1.prepared.name, i = e.options[r].autoScroll, o = Bt(i.container, e, n), a = qt.now(), s = (a - qt.prevTime) / 1e3, c = i.speed * s;
            if (c >= 1) {
                var l = {
                    x: qt.x * c,
                    y: qt.y * c
                };
                if (l.x || l.y) {
                    var u = Vt(o);
                    w.window(o) ? o.scrollBy(l.x, l.y) : o && (o.scrollLeft += l.x, o.scrollTop += l.y);
                    var p = Vt(o), f = {
                        x: p.x - u.x,
                        y: p.y - u.y
                    };
                    (f.x || f.y) && e.fire({
                        type: "autoscroll",
                        target: n,
                        interactable: e,
                        delta: f,
                        interaction: t1,
                        container: o
                    });
                }
                qt.prevTime = a;
            }
            qt.isScrolling && (Lt.cancel(qt.i), qt.i = Lt.request(qt.scroll));
        },
        check: function(t1, e) {
            var n;
            return null == (n = t1.options[e].autoScroll) ? void 0 : n.enabled;
        },
        onInteractionMove: function(t1) {
            var e = t1.interaction, n = t1.pointer;
            if (e.interacting() && qt.check(e.interactable, e.prepared.name)) {
                if (e.simulation) qt.x = qt.y = 0;
                else {
                    var r, i, o, a, s = e.interactable, c = e.element, l = e.prepared.name, u = s.options[l].autoScroll, p = Bt(u.container, s, c);
                    if (w.window(p)) a = n.clientX < qt.margin, r = n.clientY < qt.margin, i = n.clientX > p.innerWidth - qt.margin, o = n.clientY > p.innerHeight - qt.margin;
                    else {
                        var f = Y(p);
                        a = n.clientX < f.left + qt.margin, r = n.clientY < f.top + qt.margin, i = n.clientX > f.right - qt.margin, o = n.clientY > f.bottom - qt.margin;
                    }
                    qt.x = i ? 1 : a ? -1 : 0, qt.y = o ? 1 : r ? -1 : 0, qt.isScrolling || (qt.margin = u.margin, qt.speed = u.speed, qt.start(e));
                }
            }
        }
    };
    function Bt(t1, e, n) {
        return (w.string(t1) ? W(t1, e, n) : t1) || y(n);
    }
    function Vt(t1) {
        return w.window(t1) && (t1 = window.document.body), {
            x: t1.scrollLeft,
            y: t1.scrollTop
        };
    }
    var Wt = {
        id: "auto-scroll",
        install: function(t1) {
            var e = t1.defaults, n = t1.actions;
            t1.autoScroll = qt, qt.now = function() {
                return t1.now();
            }, n.phaselessTypes.autoscroll = !0, e.perAction.autoScroll = qt.defaults;
        },
        listeners: {
            "interactions:new": function(t1) {
                t1.interaction.autoScroll = null;
            },
            "interactions:destroy": function(t1) {
                t1.interaction.autoScroll = null, qt.stop(), qt.interaction && (qt.interaction = null);
            },
            "interactions:stop": qt.stop,
            "interactions:action-move": function(t1) {
                return qt.onInteractionMove(t1);
            }
        }
    }, Gt = Wt;
    function Nt(t1, e) {
        var n = !1;
        return function() {
            return n || (g.console.warn(e), n = !0), t1.apply(this, arguments);
        };
    }
    function Ut(t1, e) {
        return t1.name = e.name, t1.axis = e.axis, t1.edges = e.edges, t1;
    }
    function Ht(t1) {
        return w.bool(t1) ? (this.options.styleCursor = t1, this) : null === t1 ? (delete this.options.styleCursor, this) : this.options.styleCursor;
    }
    function Kt(t1) {
        return w.func(t1) ? (this.options.actionChecker = t1, this) : null === t1 ? (delete this.options.actionChecker, this) : this.options.actionChecker;
    }
    var $t = {
        id: "auto-start/interactableMethods",
        install: function(t1) {
            var e = t1.Interactable;
            e.prototype.getAction = function(e, n, r, i) {
                var o = function(t1, e, n, r, i) {
                    var o = t1.getRect(r), a = e.buttons || ({
                        0: 1,
                        1: 4,
                        3: 8,
                        4: 16
                    })[e.button], s = {
                        action: null,
                        interactable: t1,
                        interaction: n,
                        element: r,
                        rect: o,
                        buttons: a
                    };
                    return i.fire("auto-start:check", s), s.action;
                }(this, n, r, i, t1);
                return this.options.actionChecker ? this.options.actionChecker(e, n, o, this, i, r) : o;
            }, e.prototype.ignoreFrom = Nt(function(t1) {
                return this._backCompatOption("ignoreFrom", t1);
            }, "Interactable.ignoreFrom() has been deprecated. Use Interactble.draggable({ignoreFrom: newValue})."), e.prototype.allowFrom = Nt(function(t1) {
                return this._backCompatOption("allowFrom", t1);
            }, "Interactable.allowFrom() has been deprecated. Use Interactble.draggable({allowFrom: newValue})."), e.prototype.actionChecker = Kt, e.prototype.styleCursor = Ht;
        }
    };
    function Jt(t1, e, n, r, i) {
        return e.testIgnoreAllow(e.options[t1.name], n, r) && e.options[t1.name].enabled && ee(e, n, t1, i) ? t1 : null;
    }
    function Qt(t1, e, n, r, i, o, a) {
        for(var s = 0, c = r.length; s < c; s++){
            var l = r[s], u = i[s], p = l.getAction(e, n, t1, u);
            if (p) {
                var f = Jt(p, l, u, o, a);
                if (f) return {
                    action: f,
                    interactable: l,
                    element: u
                };
            }
        }
        return {
            action: null,
            interactable: null,
            element: null
        };
    }
    function Zt(t1, e, n, r, i) {
        var o = [], a = [], s = r;
        function c(t1) {
            o.push(t1), a.push(s);
        }
        for(; w.element(s);){
            o = [], a = [], i.interactables.forEachMatch(s, c);
            var l = Qt(t1, e, n, o, a, r, i);
            if (l.action && !l.interactable.options[l.action.name].manualStart) return l;
            s = A(s);
        }
        return {
            action: null,
            interactable: null,
            element: null
        };
    }
    function te(t1, e, n) {
        var r = e.action, i = e.interactable, o = e.element;
        r = r || {
            name: null
        }, t1.interactable = i, t1.element = o, Ut(t1.prepared, r), t1.rect = i && r.name ? i.getRect(o) : null, ie(t1, n), n.fire("autoStart:prepared", {
            interaction: t1
        });
    }
    function ee(t1, e, n, r) {
        var i = t1.options, o = i[n.name].max, a = i[n.name].maxPerElement, s = r.autoStart.maxInteractions, c = 0, l = 0, u = 0;
        if (!(o && a && s)) return !1;
        for(var p = 0, f = r.interactions.list; p < f.length; p++){
            var d = f[p], h = d.prepared.name;
            if (d.interacting()) {
                if (++c >= s) return !1;
                if (d.interactable === t1) {
                    if ((l += h === n.name ? 1 : 0) >= o) return !1;
                    if (d.element === e && (u++, h === n.name && u >= a)) return !1;
                }
            }
        }
        return s > 0;
    }
    function ne(t1, e) {
        return w.number(t1) ? (e.autoStart.maxInteractions = t1, this) : e.autoStart.maxInteractions;
    }
    function re(t1, e, n) {
        var r = n.autoStart.cursorElement;
        r && r !== t1 && (r.style.cursor = ""), t1.ownerDocument.documentElement.style.cursor = e, t1.style.cursor = e, n.autoStart.cursorElement = e ? t1 : null;
    }
    function ie(t1, e) {
        var n = t1.interactable, r = t1.element, i = t1.prepared;
        if ("mouse" === t1.pointerType && n && n.options.styleCursor) {
            var o = "";
            if (i.name) {
                var a = n.options[i.name].cursorChecker;
                o = w.func(a) ? a(i, n, r, t1._interacting) : e.actions.map[i.name].getCursor(i);
            }
            re(t1.element, o || "", e);
        } else e.autoStart.cursorElement && re(e.autoStart.cursorElement, "", e);
    }
    var oe = {
        id: "auto-start/base",
        before: [
            "actions"
        ],
        install: function(t1) {
            var e = t1.interactStatic, n = t1.defaults;
            t1.usePlugin($t), n.base.actionChecker = null, n.base.styleCursor = !0, V(n.perAction, {
                manualStart: !1,
                max: 1 / 0,
                maxPerElement: 1,
                allowFrom: null,
                ignoreFrom: null,
                mouseButtons: 1
            }), e.maxInteractions = function(e) {
                return ne(e, t1);
            }, t1.autoStart = {
                maxInteractions: 1 / 0,
                withinInteractionLimit: ee,
                cursorElement: null
            };
        },
        listeners: {
            "interactions:down": function(t1, e) {
                var n = t1.interaction, r = t1.pointer, i = t1.event, o = t1.eventTarget;
                n.interacting() || te(n, Zt(n, r, i, o, e), e);
            },
            "interactions:move": function(t1, e) {
                !function(t1, e) {
                    var n = t1.interaction, r = t1.pointer, i = t1.event, o = t1.eventTarget;
                    "mouse" !== n.pointerType || n.pointerIsDown || n.interacting() || te(n, Zt(n, r, i, o, e), e);
                }(t1, e), function(t1, e) {
                    var n = t1.interaction;
                    if (n.pointerIsDown && !n.interacting() && n.pointerWasMoved && n.prepared.name) {
                        e.fire("autoStart:before-start", t1);
                        var r = n.interactable, i = n.prepared.name;
                        i && r && (r.options[i].manualStart || !ee(r, n.element, n.prepared, e) ? n.stop() : (n.start(n.prepared, r, n.element), ie(n, e)));
                    }
                }(t1, e);
            },
            "interactions:stop": function(t1, e) {
                var n = t1.interaction, r = n.interactable;
                r && r.options.styleCursor && re(n.element, "", e);
            }
        },
        maxInteractions: ne,
        withinInteractionLimit: ee,
        validateAction: Jt
    }, ae = oe;
    var se = {
        id: "auto-start/dragAxis",
        listeners: {
            "autoStart:before-start": function(t1, e) {
                var n = t1.interaction, r = t1.eventTarget, i = t1.dx, o = t1.dy;
                if ("drag" === n.prepared.name) {
                    var a = Math.abs(i), s = Math.abs(o), c = n.interactable.options.drag, l = c.startAxis, u = a > s ? "x" : a < s ? "y" : "xy";
                    if (n.prepared.axis = "start" === c.lockAxis ? u[0] : c.lockAxis, "xy" !== u && "xy" !== l && l !== u) {
                        n.prepared.name = null;
                        for(var p = r, f = function(t1) {
                            if (t1 !== n.interactable) {
                                var i = n.interactable.options.drag;
                                if (!i.manualStart && t1.testIgnoreAllow(i, p, r)) {
                                    var o = t1.getAction(n.downPointer, n.downEvent, n, p);
                                    if (o && "drag" === o.name && function(t1, e) {
                                        if (!e) return !1;
                                        var n = e.options.drag.startAxis;
                                        return "xy" === t1 || "xy" === n || n === t1;
                                    }(u, t1) && ae.validateAction(o, t1, p, r, e)) return t1;
                                }
                            }
                        }; w.element(p);){
                            var d = e.interactables.forEachMatch(p, f);
                            if (d) {
                                n.prepared.name = "drag", n.interactable = d, n.element = p;
                                break;
                            }
                            p = A(p);
                        }
                    }
                }
            }
        }
    };
    function ce(t1) {
        var e = t1.prepared && t1.prepared.name;
        if (!e) return null;
        var n = t1.interactable.options;
        return n[e].hold || n[e].delay;
    }
    var le = {
        id: "auto-start/hold",
        install: function(t1) {
            var e = t1.defaults;
            t1.usePlugin(ae), e.perAction.hold = 0, e.perAction.delay = 0;
        },
        listeners: {
            "interactions:new": function(t1) {
                t1.interaction.autoStartHoldTimer = null;
            },
            "autoStart:prepared": function(t1) {
                var e = t1.interaction, n = ce(e);
                n > 0 && (e.autoStartHoldTimer = setTimeout(function() {
                    e.start(e.prepared, e.interactable, e.element);
                }, n));
            },
            "interactions:move": function(t1) {
                var e = t1.interaction, n = t1.duplicate;
                e.autoStartHoldTimer && e.pointerWasMoved && !n && (clearTimeout(e.autoStartHoldTimer), e.autoStartHoldTimer = null);
            },
            "autoStart:before-start": function(t1) {
                var e = t1.interaction;
                ce(e) > 0 && (e.prepared.name = null);
            }
        },
        getHoldDuration: ce
    }, ue = le, pe = {
        id: "auto-start",
        install: function(t1) {
            t1.usePlugin(ae), t1.usePlugin(ue), t1.usePlugin(se);
        }
    }, fe = function(t1) {
        return /^(always|never|auto)$/.test(t1) ? (this.options.preventDefault = t1, this) : w.bool(t1) ? (this.options.preventDefault = t1 ? "always" : "never", this) : this.options.preventDefault;
    };
    function de(t1) {
        var e = t1.interaction, n = t1.event;
        e.interactable && e.interactable.checkAndPreventDefault(n);
    }
    var he = {
        id: "core/interactablePreventDefault",
        install: function(t1) {
            var e = t1.Interactable;
            e.prototype.preventDefault = fe, e.prototype.checkAndPreventDefault = function(e) {
                return function(t1, e, n) {
                    var r = t1.options.preventDefault;
                    if ("never" !== r) {
                        if ("always" !== r) {
                            if (e.events.supportsPassive && /^touch(start|move)$/.test(n.type)) {
                                var i = y(n.target).document, o = e.getDocOptions(i);
                                if (!o || !o.events || !1 !== o.events.passive) return;
                            }
                            /^(mouse|pointer|touch)*(down|start)/i.test(n.type) || w.element(n.target) && R(n.target, "input,select,textarea,[contenteditable=true],[contenteditable=true] *") || n.preventDefault();
                        } else n.preventDefault();
                    }
                }(this, t1, e);
            }, t1.interactions.docEvents.push({
                type: "dragstart",
                listener: function(e) {
                    for(var n = 0, r = t1.interactions.list; n < r.length; n++){
                        var i = r[n];
                        if (i.element && (i.element === e.target || M(i.element, e.target))) return void i.interactable.checkAndPreventDefault(e);
                    }
                }
            });
        },
        listeners: [
            "down",
            "move",
            "up",
            "cancel"
        ].reduce(function(t1, e) {
            return t1["interactions:".concat(e)] = de, t1;
        }, {})
    };
    function ve(t1, e) {
        if (e.phaselessTypes[t1]) return !0;
        for(var n in e.map)if (0 === t1.indexOf(n) && t1.substr(n.length) in e.phases) return !0;
        return !1;
    }
    function ge(t1) {
        var e = {};
        for(var n in t1){
            var r = t1[n];
            w.plainObject(r) ? e[n] = ge(r) : w.array(r) ? e[n] = mt(r) : e[n] = r;
        }
        return e;
    }
    var me = function() {
        function t1(e) {
            r(this, t1), this.states = [], this.startOffset = {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0
            }, this.startDelta = void 0, this.result = void 0, this.endResult = void 0, this.startEdges = void 0, this.edges = void 0, this.interaction = void 0, this.interaction = e, this.result = ye(), this.edges = {
                left: !1,
                right: !1,
                top: !1,
                bottom: !1
            };
        }
        return o(t1, [
            {
                key: "start",
                value: function(t1, e) {
                    var n, r, i = t1.phase, o = this.interaction, a = function(t1) {
                        var e = t1.interactable.options[t1.prepared.name], n = e.modifiers;
                        if (n && n.length) return n;
                        return [
                            "snap",
                            "snapSize",
                            "snapEdges",
                            "restrict",
                            "restrictEdges",
                            "restrictSize"
                        ].map(function(t1) {
                            var n = e[t1];
                            return n && n.enabled && {
                                options: n,
                                methods: n._methods
                            };
                        }).filter(function(t1) {
                            return !!t1;
                        });
                    }(o);
                    this.prepareStates(a), this.startEdges = V({}, o.edges), this.edges = V({}, this.startEdges), this.startOffset = (n = o.rect, r = e, n ? {
                        left: r.x - n.left,
                        top: r.y - n.top,
                        right: n.right - r.x,
                        bottom: n.bottom - r.y
                    } : {
                        left: 0,
                        top: 0,
                        right: 0,
                        bottom: 0
                    }), this.startDelta = {
                        x: 0,
                        y: 0
                    };
                    var s = this.fillArg({
                        phase: i,
                        pageCoords: e,
                        preEnd: !1
                    });
                    return this.result = ye(), this.startAll(s), this.result = this.setAll(s);
                }
            },
            {
                key: "fillArg",
                value: function(t1) {
                    var e = this.interaction;
                    return t1.interaction = e, t1.interactable = e.interactable, t1.element = e.element, t1.rect || (t1.rect = e.rect), t1.edges || (t1.edges = this.startEdges), t1.startOffset = this.startOffset, t1;
                }
            },
            {
                key: "startAll",
                value: function(t1) {
                    for(var e = 0, n = this.states; e < n.length; e++){
                        var r = n[e];
                        r.methods.start && (t1.state = r, r.methods.start(t1));
                    }
                }
            },
            {
                key: "setAll",
                value: function(t1) {
                    var e = t1.phase, n = t1.preEnd, r = t1.skipModifiers, i = t1.rect, o = t1.edges;
                    t1.coords = V({}, t1.pageCoords), t1.rect = V({}, i), t1.edges = V({}, o);
                    for(var a = r ? this.states.slice(r) : this.states, s = ye(t1.coords, t1.rect), c = 0; c < a.length; c++){
                        var l, u = a[c], p = u.options, f = V({}, t1.coords), d = null;
                        null != (l = u.methods) && l.set && this.shouldDo(p, n, e) && (t1.state = u, d = u.methods.set(t1), H(t1.edges, t1.rect, {
                            x: t1.coords.x - f.x,
                            y: t1.coords.y - f.y
                        })), s.eventProps.push(d);
                    }
                    V(this.edges, t1.edges), s.delta.x = t1.coords.x - t1.pageCoords.x, s.delta.y = t1.coords.y - t1.pageCoords.y, s.rectDelta.left = t1.rect.left - i.left, s.rectDelta.right = t1.rect.right - i.right, s.rectDelta.top = t1.rect.top - i.top, s.rectDelta.bottom = t1.rect.bottom - i.bottom;
                    var h = this.result.coords, v = this.result.rect;
                    if (h && v) {
                        var g = s.rect.left !== v.left || s.rect.right !== v.right || s.rect.top !== v.top || s.rect.bottom !== v.bottom;
                        s.changed = g || h.x !== s.coords.x || h.y !== s.coords.y;
                    }
                    return s;
                }
            },
            {
                key: "applyToInteraction",
                value: function(t1) {
                    var e = this.interaction, n = t1.phase, r = e.coords.cur, i = e.coords.start, o = this.result, a = this.startDelta, s = o.delta;
                    "start" === n && V(this.startDelta, o.delta);
                    for(var c = 0, l = [
                        [
                            i,
                            a
                        ],
                        [
                            r,
                            s
                        ]
                    ]; c < l.length; c++){
                        var u = l[c], p = u[0], f = u[1];
                        p.page.x += f.x, p.page.y += f.y, p.client.x += f.x, p.client.y += f.y;
                    }
                    var d = this.result.rectDelta, h = t1.rect || e.rect;
                    h.left += d.left, h.right += d.right, h.top += d.top, h.bottom += d.bottom, h.width = h.right - h.left, h.height = h.bottom - h.top;
                }
            },
            {
                key: "setAndApply",
                value: function(t1) {
                    var e = this.interaction, n = t1.phase, r = t1.preEnd, i = t1.skipModifiers, o = this.setAll(this.fillArg({
                        preEnd: r,
                        phase: n,
                        pageCoords: t1.modifiedCoords || e.coords.cur.page
                    }));
                    if (this.result = o, !o.changed && (!i || i < this.states.length) && e.interacting()) return !1;
                    if (t1.modifiedCoords) {
                        var a = e.coords.cur.page, s = {
                            x: t1.modifiedCoords.x - a.x,
                            y: t1.modifiedCoords.y - a.y
                        };
                        o.coords.x += s.x, o.coords.y += s.y, o.delta.x += s.x, o.delta.y += s.y;
                    }
                    this.applyToInteraction(t1);
                }
            },
            {
                key: "beforeEnd",
                value: function(t1) {
                    var e = t1.interaction, n = t1.event, r = this.states;
                    if (r && r.length) {
                        for(var i = !1, o = 0; o < r.length; o++){
                            var a = r[o];
                            t1.state = a;
                            var s = a.options, c = a.methods, l = c.beforeEnd && c.beforeEnd(t1);
                            if (l) return this.endResult = l, !1;
                            i = i || !i && this.shouldDo(s, !0, t1.phase, !0);
                        }
                        i && e.move({
                            event: n,
                            preEnd: !0
                        });
                    }
                }
            },
            {
                key: "stop",
                value: function(t1) {
                    var e = t1.interaction;
                    if (this.states && this.states.length) {
                        var n = V({
                            states: this.states,
                            interactable: e.interactable,
                            element: e.element,
                            rect: null
                        }, t1);
                        this.fillArg(n);
                        for(var r = 0, i = this.states; r < i.length; r++){
                            var o = i[r];
                            n.state = o, o.methods.stop && o.methods.stop(n);
                        }
                        this.states = null, this.endResult = null;
                    }
                }
            },
            {
                key: "prepareStates",
                value: function(t1) {
                    this.states = [];
                    for(var e = 0; e < t1.length; e++){
                        var n = t1[e], r = n.options, i = n.methods, o = n.name;
                        this.states.push({
                            options: r,
                            methods: i,
                            index: e,
                            name: o
                        });
                    }
                    return this.states;
                }
            },
            {
                key: "restoreInteractionCoords",
                value: function(t1) {
                    var e = t1.interaction, n = e.coords, r = e.rect, i = e.modification;
                    if (i.result) {
                        for(var o = i.startDelta, a = i.result, s = a.delta, c = a.rectDelta, l = 0, u = [
                            [
                                n.start,
                                o
                            ],
                            [
                                n.cur,
                                s
                            ]
                        ]; l < u.length; l++){
                            var p = u[l], f = p[0], d = p[1];
                            f.page.x -= d.x, f.page.y -= d.y, f.client.x -= d.x, f.client.y -= d.y;
                        }
                        r.left -= c.left, r.right -= c.right, r.top -= c.top, r.bottom -= c.bottom;
                    }
                }
            },
            {
                key: "shouldDo",
                value: function(t1, e, n, r) {
                    return !(!t1 || !1 === t1.enabled || r && !t1.endOnly || t1.endOnly && !e || "start" === n && !t1.setStart);
                }
            },
            {
                key: "copyFrom",
                value: function(t1) {
                    this.startOffset = t1.startOffset, this.startDelta = t1.startDelta, this.startEdges = t1.startEdges, this.edges = t1.edges, this.states = t1.states.map(function(t1) {
                        return ge(t1);
                    }), this.result = ye(V({}, t1.result.coords), V({}, t1.result.rect));
                }
            },
            {
                key: "destroy",
                value: function() {
                    for(var t1 in this)this[t1] = null;
                }
            }
        ]), t1;
    }();
    function ye(t1, e) {
        return {
            rect: e,
            coords: t1,
            delta: {
                x: 0,
                y: 0
            },
            rectDelta: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0
            },
            eventProps: [],
            changed: !0
        };
    }
    function be(t1, e) {
        var n = t1.defaults, r = {
            start: t1.start,
            set: t1.set,
            beforeEnd: t1.beforeEnd,
            stop: t1.stop
        }, i = function(t1) {
            var i = t1 || {};
            for(var o in i.enabled = !1 !== i.enabled, n)o in i || (i[o] = n[o]);
            var a = {
                options: i,
                methods: r,
                name: e,
                enable: function() {
                    return i.enabled = !0, a;
                },
                disable: function() {
                    return i.enabled = !1, a;
                }
            };
            return a;
        };
        return e && "string" == typeof e && (i._defaults = n, i._methods = r), i;
    }
    function xe(t1) {
        var e = t1.iEvent, n = t1.interaction.modification.result;
        n && (e.modifiers = n.eventProps);
    }
    var we = {
        id: "modifiers/base",
        before: [
            "actions"
        ],
        install: function(t1) {
            t1.defaults.perAction.modifiers = [];
        },
        listeners: {
            "interactions:new": function(t1) {
                var e = t1.interaction;
                e.modification = new me(e);
            },
            "interactions:before-action-start": function(t1) {
                var e = t1.interaction, n = t1.interaction.modification;
                n.start(t1, e.coords.start.page), e.edges = n.edges, n.applyToInteraction(t1);
            },
            "interactions:before-action-move": function(t1) {
                var e = t1.interaction, n = e.modification, r = n.setAndApply(t1);
                return e.edges = n.edges, r;
            },
            "interactions:before-action-end": function(t1) {
                var e = t1.interaction, n = e.modification, r = n.beforeEnd(t1);
                return e.edges = n.startEdges, r;
            },
            "interactions:action-start": xe,
            "interactions:action-move": xe,
            "interactions:action-end": xe,
            "interactions:after-action-start": function(t1) {
                return t1.interaction.modification.restoreInteractionCoords(t1);
            },
            "interactions:after-action-move": function(t1) {
                return t1.interaction.modification.restoreInteractionCoords(t1);
            },
            "interactions:stop": function(t1) {
                return t1.interaction.modification.stop(t1);
            }
        }
    }, Ee = we, Te = {
        base: {
            preventDefault: "auto",
            deltaSource: "page"
        },
        perAction: {
            enabled: !1,
            origin: {
                x: 0,
                y: 0
            }
        },
        actions: {}
    }, Se = function(t1) {
        s(n, t1);
        var e = p(n);
        function n(t1, i, o, a, s, c, l) {
            var p;
            r(this, n), (p = e.call(this, t1)).relatedTarget = null, p.screenX = void 0, p.screenY = void 0, p.button = void 0, p.buttons = void 0, p.ctrlKey = void 0, p.shiftKey = void 0, p.altKey = void 0, p.metaKey = void 0, p.page = void 0, p.client = void 0, p.delta = void 0, p.rect = void 0, p.x0 = void 0, p.y0 = void 0, p.t0 = void 0, p.dt = void 0, p.duration = void 0, p.clientX0 = void 0, p.clientY0 = void 0, p.velocity = void 0, p.speed = void 0, p.swipe = void 0, p.axes = void 0, p.preEnd = void 0, s = s || t1.element;
            var f = t1.interactable, d = (f && f.options || Te).deltaSource, h = K(f, s, o), v = "start" === a, g = "end" === a, m = v ? u(p) : t1.prevEvent, y = v ? t1.coords.start : g ? {
                page: m.page,
                client: m.client,
                timeStamp: t1.coords.cur.timeStamp
            } : t1.coords.cur;
            return p.page = V({}, y.page), p.client = V({}, y.client), p.rect = V({}, t1.rect), p.timeStamp = y.timeStamp, g || (p.page.x -= h.x, p.page.y -= h.y, p.client.x -= h.x, p.client.y -= h.y), p.ctrlKey = i.ctrlKey, p.altKey = i.altKey, p.shiftKey = i.shiftKey, p.metaKey = i.metaKey, p.button = i.button, p.buttons = i.buttons, p.target = s, p.currentTarget = s, p.preEnd = c, p.type = l || o + (a || ""), p.interactable = f, p.t0 = v ? t1.pointers[t1.pointers.length - 1].downTime : m.t0, p.x0 = t1.coords.start.page.x - h.x, p.y0 = t1.coords.start.page.y - h.y, p.clientX0 = t1.coords.start.client.x - h.x, p.clientY0 = t1.coords.start.client.y - h.y, p.delta = v || g ? {
                x: 0,
                y: 0
            } : {
                x: p[d].x - m[d].x,
                y: p[d].y - m[d].y
            }, p.dt = t1.coords.delta.timeStamp, p.duration = p.timeStamp - p.t0, p.velocity = V({}, t1.coords.velocity[d]), p.speed = Q(p.velocity.x, p.velocity.y), p.swipe = g || "inertiastart" === a ? p.getSwipe() : null, p;
        }
        return o(n, [
            {
                key: "getSwipe",
                value: function() {
                    var t1 = this._interaction;
                    if (t1.prevEvent.speed < 600 || this.timeStamp - t1.prevEvent.timeStamp > 150) return null;
                    var e = 180 * Math.atan2(t1.prevEvent.velocityY, t1.prevEvent.velocityX) / Math.PI;
                    e < 0 && (e += 360);
                    var n = 112.5 <= e && e < 247.5, r = 202.5 <= e && e < 337.5;
                    return {
                        up: r,
                        down: !r && 22.5 <= e && e < 157.5,
                        left: n,
                        right: !n && (292.5 <= e || e < 67.5),
                        angle: e,
                        speed: t1.prevEvent.speed,
                        velocity: {
                            x: t1.prevEvent.velocityX,
                            y: t1.prevEvent.velocityY
                        }
                    };
                }
            },
            {
                key: "preventDefault",
                value: function() {}
            },
            {
                key: "stopImmediatePropagation",
                value: function() {
                    this.immediatePropagationStopped = this.propagationStopped = !0;
                }
            },
            {
                key: "stopPropagation",
                value: function() {
                    this.propagationStopped = !0;
                }
            }
        ]), n;
    }(vt);
    Object.defineProperties(Se.prototype, {
        pageX: {
            get: function() {
                return this.page.x;
            },
            set: function(t1) {
                this.page.x = t1;
            }
        },
        pageY: {
            get: function() {
                return this.page.y;
            },
            set: function(t1) {
                this.page.y = t1;
            }
        },
        clientX: {
            get: function() {
                return this.client.x;
            },
            set: function(t1) {
                this.client.x = t1;
            }
        },
        clientY: {
            get: function() {
                return this.client.y;
            },
            set: function(t1) {
                this.client.y = t1;
            }
        },
        dx: {
            get: function() {
                return this.delta.x;
            },
            set: function(t1) {
                this.delta.x = t1;
            }
        },
        dy: {
            get: function() {
                return this.delta.y;
            },
            set: function(t1) {
                this.delta.y = t1;
            }
        },
        velocityX: {
            get: function() {
                return this.velocity.x;
            },
            set: function(t1) {
                this.velocity.x = t1;
            }
        },
        velocityY: {
            get: function() {
                return this.velocity.y;
            },
            set: function(t1) {
                this.velocity.y = t1;
            }
        }
    });
    var _e = o(function t1(e, n, i, o, a) {
        r(this, t1), this.id = void 0, this.pointer = void 0, this.event = void 0, this.downTime = void 0, this.downTarget = void 0, this.id = e, this.pointer = n, this.event = i, this.downTime = o, this.downTarget = a;
    }), Pe = function(t1) {
        return t1.interactable = "", t1.element = "", t1.prepared = "", t1.pointerIsDown = "", t1.pointerWasMoved = "", t1._proxy = "", t1;
    }({}), Oe = function(t1) {
        return t1.start = "", t1.move = "", t1.end = "", t1.stop = "", t1.interacting = "", t1;
    }({}), ke = 0, De = function() {
        function t1(e) {
            var n = this, i = e.pointerType, o = e.scopeFire;
            r(this, t1), this.interactable = null, this.element = null, this.rect = null, this._rects = void 0, this.edges = null, this._scopeFire = void 0, this.prepared = {
                name: null,
                axis: null,
                edges: null
            }, this.pointerType = void 0, this.pointers = [], this.downEvent = null, this.downPointer = {}, this._latestPointer = {
                pointer: null,
                event: null,
                eventTarget: null
            }, this.prevEvent = null, this.pointerIsDown = !1, this.pointerWasMoved = !1, this._interacting = !1, this._ending = !1, this._stopped = !0, this._proxy = void 0, this.simulation = null, this.doMove = Nt(function(t1) {
                this.move(t1);
            }, "The interaction.doMove() method has been renamed to interaction.move()"), this.coords = {
                start: {
                    page: {
                        x: 0,
                        y: 0
                    },
                    client: {
                        x: 0,
                        y: 0
                    },
                    timeStamp: 0
                },
                prev: {
                    page: {
                        x: 0,
                        y: 0
                    },
                    client: {
                        x: 0,
                        y: 0
                    },
                    timeStamp: 0
                },
                cur: {
                    page: {
                        x: 0,
                        y: 0
                    },
                    client: {
                        x: 0,
                        y: 0
                    },
                    timeStamp: 0
                },
                delta: {
                    page: {
                        x: 0,
                        y: 0
                    },
                    client: {
                        x: 0,
                        y: 0
                    },
                    timeStamp: 0
                },
                velocity: {
                    page: {
                        x: 0,
                        y: 0
                    },
                    client: {
                        x: 0,
                        y: 0
                    },
                    timeStamp: 0
                }
            }, this._id = ke++, this._scopeFire = o, this.pointerType = i;
            var a = this;
            this._proxy = {};
            var s = function(t1) {
                Object.defineProperty(n._proxy, t1, {
                    get: function() {
                        return a[t1];
                    }
                });
            };
            for(var c in Pe)s(c);
            var l = function(t1) {
                Object.defineProperty(n._proxy, t1, {
                    value: function() {
                        return a[t1].apply(a, arguments);
                    }
                });
            };
            for(var u in Oe)l(u);
            this._scopeFire("interactions:new", {
                interaction: this
            });
        }
        return o(t1, [
            {
                key: "pointerMoveTolerance",
                get: function() {
                    return 1;
                }
            },
            {
                key: "pointerDown",
                value: function(t1, e, n) {
                    var r = this.updatePointer(t1, e, n, !0), i = this.pointers[r];
                    this._scopeFire("interactions:down", {
                        pointer: t1,
                        event: e,
                        eventTarget: n,
                        pointerIndex: r,
                        pointerInfo: i,
                        type: "down",
                        interaction: this
                    });
                }
            },
            {
                key: "start",
                value: function(t1, e, n) {
                    return !(this.interacting() || !this.pointerIsDown || this.pointers.length < ("gesture" === t1.name ? 2 : 1) || !e.options[t1.name].enabled) && (Ut(this.prepared, t1), this.interactable = e, this.element = n, this.rect = e.getRect(n), this.edges = this.prepared.edges ? V({}, this.prepared.edges) : {
                        left: !0,
                        right: !0,
                        top: !0,
                        bottom: !0
                    }, this._stopped = !1, this._interacting = this._doPhase({
                        interaction: this,
                        event: this.downEvent,
                        phase: "start"
                    }) && !this._stopped, this._interacting);
                }
            },
            {
                key: "pointerMove",
                value: function(t1, e, n) {
                    this.simulation || this.modification && this.modification.endResult || this.updatePointer(t1, e, n, !1);
                    var r, i, o = this.coords.cur.page.x === this.coords.prev.page.x && this.coords.cur.page.y === this.coords.prev.page.y && this.coords.cur.client.x === this.coords.prev.client.x && this.coords.cur.client.y === this.coords.prev.client.y;
                    this.pointerIsDown && !this.pointerWasMoved && (r = this.coords.cur.client.x - this.coords.start.client.x, i = this.coords.cur.client.y - this.coords.start.client.y, this.pointerWasMoved = Q(r, i) > this.pointerMoveTolerance);
                    var a, s, c, l = this.getPointerIndex(t1), u = {
                        pointer: t1,
                        pointerIndex: l,
                        pointerInfo: this.pointers[l],
                        event: e,
                        type: "move",
                        eventTarget: n,
                        dx: r,
                        dy: i,
                        duplicate: o,
                        interaction: this
                    };
                    o || (a = this.coords.velocity, s = this.coords.delta, c = Math.max(s.timeStamp / 1e3, .001), a.page.x = s.page.x / c, a.page.y = s.page.y / c, a.client.x = s.client.x / c, a.client.y = s.client.y / c, a.timeStamp = c), this._scopeFire("interactions:move", u), o || this.simulation || (this.interacting() && (u.type = null, this.move(u)), this.pointerWasMoved && et(this.coords.prev, this.coords.cur));
                }
            },
            {
                key: "move",
                value: function(t1) {
                    t1 && t1.event || nt(this.coords.delta), (t1 = V({
                        pointer: this._latestPointer.pointer,
                        event: this._latestPointer.event,
                        eventTarget: this._latestPointer.eventTarget,
                        interaction: this
                    }, t1 || {})).phase = "move", this._doPhase(t1);
                }
            },
            {
                key: "pointerUp",
                value: function(t1, e, n, r) {
                    var i = this.getPointerIndex(t1);
                    -1 === i && (i = this.updatePointer(t1, e, n, !1));
                    var o = /cancel$/i.test(e.type) ? "cancel" : "up";
                    this._scopeFire("interactions:".concat(o), {
                        pointer: t1,
                        pointerIndex: i,
                        pointerInfo: this.pointers[i],
                        event: e,
                        eventTarget: n,
                        type: o,
                        curEventTarget: r,
                        interaction: this
                    }), this.simulation || this.end(e), this.removePointer(t1, e);
                }
            },
            {
                key: "documentBlur",
                value: function(t1) {
                    this.end(t1), this._scopeFire("interactions:blur", {
                        event: t1,
                        type: "blur",
                        interaction: this
                    });
                }
            },
            {
                key: "end",
                value: function(t1) {
                    var e;
                    this._ending = !0, t1 = t1 || this._latestPointer.event, this.interacting() && (e = this._doPhase({
                        event: t1,
                        interaction: this,
                        phase: "end"
                    })), this._ending = !1, !0 === e && this.stop();
                }
            },
            {
                key: "currentAction",
                value: function() {
                    return this._interacting ? this.prepared.name : null;
                }
            },
            {
                key: "interacting",
                value: function() {
                    return this._interacting;
                }
            },
            {
                key: "stop",
                value: function() {
                    this._scopeFire("interactions:stop", {
                        interaction: this
                    }), this.interactable = this.element = null, this._interacting = !1, this._stopped = !0, this.prepared.name = this.prevEvent = null;
                }
            },
            {
                key: "getPointerIndex",
                value: function(t1) {
                    var e = at(t1);
                    return "mouse" === this.pointerType || "pen" === this.pointerType ? this.pointers.length - 1 : yt(this.pointers, function(t1) {
                        return t1.id === e;
                    });
                }
            },
            {
                key: "getPointerInfo",
                value: function(t1) {
                    return this.pointers[this.getPointerIndex(t1)];
                }
            },
            {
                key: "updatePointer",
                value: function(t1, e, n, r) {
                    var i, o, a, s = at(t1), c = this.getPointerIndex(t1), l = this.pointers[c];
                    return r = !1 !== r && (r || /(down|start)$/i.test(e.type)), l ? l.pointer = t1 : (l = new _e(s, t1, e, null, null), c = this.pointers.length, this.pointers.push(l)), st(this.coords.cur, this.pointers.map(function(t1) {
                        return t1.pointer;
                    }), this._now()), i = this.coords.delta, o = this.coords.prev, a = this.coords.cur, i.page.x = a.page.x - o.page.x, i.page.y = a.page.y - o.page.y, i.client.x = a.client.x - o.client.x, i.client.y = a.client.y - o.client.y, i.timeStamp = a.timeStamp - o.timeStamp, r && (this.pointerIsDown = !0, l.downTime = this.coords.cur.timeStamp, l.downTarget = n, tt(this.downPointer, t1), this.interacting() || (et(this.coords.start, this.coords.cur), et(this.coords.prev, this.coords.cur), this.downEvent = e, this.pointerWasMoved = !1)), this._updateLatestPointer(t1, e, n), this._scopeFire("interactions:update-pointer", {
                        pointer: t1,
                        event: e,
                        eventTarget: n,
                        down: r,
                        pointerInfo: l,
                        pointerIndex: c,
                        interaction: this
                    }), c;
                }
            },
            {
                key: "removePointer",
                value: function(t1, e) {
                    var n = this.getPointerIndex(t1);
                    if (-1 !== n) {
                        var r = this.pointers[n];
                        this._scopeFire("interactions:remove-pointer", {
                            pointer: t1,
                            event: e,
                            eventTarget: null,
                            pointerIndex: n,
                            pointerInfo: r,
                            interaction: this
                        }), this.pointers.splice(n, 1), this.pointerIsDown = !1;
                    }
                }
            },
            {
                key: "_updateLatestPointer",
                value: function(t1, e, n) {
                    this._latestPointer.pointer = t1, this._latestPointer.event = e, this._latestPointer.eventTarget = n;
                }
            },
            {
                key: "destroy",
                value: function() {
                    this._latestPointer.pointer = null, this._latestPointer.event = null, this._latestPointer.eventTarget = null;
                }
            },
            {
                key: "_createPreparedEvent",
                value: function(t1, e, n, r) {
                    return new Se(this, t1, this.prepared.name, e, this.element, n, r);
                }
            },
            {
                key: "_fireEvent",
                value: function(t1) {
                    var e;
                    null == (e = this.interactable) || e.fire(t1), (!this.prevEvent || t1.timeStamp >= this.prevEvent.timeStamp) && (this.prevEvent = t1);
                }
            },
            {
                key: "_doPhase",
                value: function(t1) {
                    var e = t1.event, n = t1.phase, r = t1.preEnd, i = t1.type, o = this.rect;
                    if (o && "move" === n && (H(this.edges, o, this.coords.delta[this.interactable.options.deltaSource]), o.width = o.right - o.left, o.height = o.bottom - o.top), !1 === this._scopeFire("interactions:before-action-".concat(n), t1)) return !1;
                    var a = t1.iEvent = this._createPreparedEvent(e, n, r, i);
                    return this._scopeFire("interactions:action-".concat(n), t1), "start" === n && (this.prevEvent = a), this._fireEvent(a), this._scopeFire("interactions:after-action-".concat(n), t1), !0;
                }
            },
            {
                key: "_now",
                value: function() {
                    return Date.now();
                }
            }
        ]), t1;
    }();
    function Ie(t1) {
        Me(t1.interaction);
    }
    function Me(t1) {
        if (!function(t1) {
            return !(!t1.offset.pending.x && !t1.offset.pending.y);
        }(t1)) return !1;
        var e = t1.offset.pending;
        return Ae(t1.coords.cur, e), Ae(t1.coords.delta, e), H(t1.edges, t1.rect, e), e.x = 0, e.y = 0, !0;
    }
    function ze(t1) {
        var e = t1.x, n = t1.y;
        this.offset.pending.x += e, this.offset.pending.y += n, this.offset.total.x += e, this.offset.total.y += n;
    }
    function Ae(t1, e) {
        var n = t1.page, r = t1.client, i = e.x, o = e.y;
        n.x += i, n.y += o, r.x += i, r.y += o;
    }
    Oe.offsetBy = "";
    var Re = {
        id: "offset",
        before: [
            "modifiers",
            "pointer-events",
            "actions",
            "inertia"
        ],
        install: function(t1) {
            t1.Interaction.prototype.offsetBy = ze;
        },
        listeners: {
            "interactions:new": function(t1) {
                t1.interaction.offset = {
                    total: {
                        x: 0,
                        y: 0
                    },
                    pending: {
                        x: 0,
                        y: 0
                    }
                };
            },
            "interactions:update-pointer": function(t1) {
                return function(t1) {
                    t1.pointerIsDown && (Ae(t1.coords.cur, t1.offset.total), t1.offset.pending.x = 0, t1.offset.pending.y = 0);
                }(t1.interaction);
            },
            "interactions:before-action-start": Ie,
            "interactions:before-action-move": Ie,
            "interactions:before-action-end": function(t1) {
                var e = t1.interaction;
                if (Me(e)) return e.move({
                    offset: !0
                }), e.end(), !1;
            },
            "interactions:stop": function(t1) {
                var e = t1.interaction;
                e.offset.total.x = 0, e.offset.total.y = 0, e.offset.pending.x = 0, e.offset.pending.y = 0;
            }
        }
    }, Ce = Re;
    var je = function() {
        function t1(e) {
            r(this, t1), this.active = !1, this.isModified = !1, this.smoothEnd = !1, this.allowResume = !1, this.modification = void 0, this.modifierCount = 0, this.modifierArg = void 0, this.startCoords = void 0, this.t0 = 0, this.v0 = 0, this.te = 0, this.targetOffset = void 0, this.modifiedOffset = void 0, this.currentOffset = void 0, this.lambda_v0 = 0, this.one_ve_v0 = 0, this.timeout = void 0, this.interaction = void 0, this.interaction = e;
        }
        return o(t1, [
            {
                key: "start",
                value: function(t1) {
                    var e = this.interaction, n = Fe(e);
                    if (!n || !n.enabled) return !1;
                    var r = e.coords.velocity.client, i = Q(r.x, r.y), o = this.modification || (this.modification = new me(e));
                    if (o.copyFrom(e.modification), this.t0 = e._now(), this.allowResume = n.allowResume, this.v0 = i, this.currentOffset = {
                        x: 0,
                        y: 0
                    }, this.startCoords = e.coords.cur.page, this.modifierArg = o.fillArg({
                        pageCoords: this.startCoords,
                        preEnd: !0,
                        phase: "inertiastart"
                    }), this.t0 - e.coords.cur.timeStamp < 50 && i > n.minSpeed && i > n.endSpeed) this.startInertia();
                    else {
                        if (o.result = o.setAll(this.modifierArg), !o.result.changed) return !1;
                        this.startSmoothEnd();
                    }
                    return e.modification.result.rect = null, e.offsetBy(this.targetOffset), e._doPhase({
                        interaction: e,
                        event: t1,
                        phase: "inertiastart"
                    }), e.offsetBy({
                        x: -this.targetOffset.x,
                        y: -this.targetOffset.y
                    }), e.modification.result.rect = null, this.active = !0, e.simulation = this, !0;
                }
            },
            {
                key: "startInertia",
                value: function() {
                    var t1 = this, e = this.interaction.coords.velocity.client, n = Fe(this.interaction), r = n.resistance, i = -Math.log(n.endSpeed / this.v0) / r;
                    this.targetOffset = {
                        x: (e.x - i) / r,
                        y: (e.y - i) / r
                    }, this.te = i, this.lambda_v0 = r / this.v0, this.one_ve_v0 = 1 - n.endSpeed / this.v0;
                    var o = this.modification, a = this.modifierArg;
                    a.pageCoords = {
                        x: this.startCoords.x + this.targetOffset.x,
                        y: this.startCoords.y + this.targetOffset.y
                    }, o.result = o.setAll(a), o.result.changed && (this.isModified = !0, this.modifiedOffset = {
                        x: this.targetOffset.x + o.result.delta.x,
                        y: this.targetOffset.y + o.result.delta.y
                    }), this.onNextFrame(function() {
                        return t1.inertiaTick();
                    });
                }
            },
            {
                key: "startSmoothEnd",
                value: function() {
                    var t1 = this;
                    this.smoothEnd = !0, this.isModified = !0, this.targetOffset = {
                        x: this.modification.result.delta.x,
                        y: this.modification.result.delta.y
                    }, this.onNextFrame(function() {
                        return t1.smoothEndTick();
                    });
                }
            },
            {
                key: "onNextFrame",
                value: function(t1) {
                    var e = this;
                    this.timeout = Lt.request(function() {
                        e.active && t1();
                    });
                }
            },
            {
                key: "inertiaTick",
                value: function() {
                    var t1, e, n, r, i, o, a, s = this, c = this.interaction, l = Fe(c).resistance, u = (c._now() - this.t0) / 1e3;
                    if (u < this.te) {
                        var p, f = 1 - (Math.exp(-l * u) - this.lambda_v0) / this.one_ve_v0;
                        this.isModified ? (t1 = 0, e = 0, n = this.targetOffset.x, r = this.targetOffset.y, i = this.modifiedOffset.x, o = this.modifiedOffset.y, p = {
                            x: Ye(a = f, t1, n, i),
                            y: Ye(a, e, r, o)
                        }) : p = {
                            x: this.targetOffset.x * f,
                            y: this.targetOffset.y * f
                        };
                        var d = {
                            x: p.x - this.currentOffset.x,
                            y: p.y - this.currentOffset.y
                        };
                        this.currentOffset.x += d.x, this.currentOffset.y += d.y, c.offsetBy(d), c.move(), this.onNextFrame(function() {
                            return s.inertiaTick();
                        });
                    } else c.offsetBy({
                        x: this.modifiedOffset.x - this.currentOffset.x,
                        y: this.modifiedOffset.y - this.currentOffset.y
                    }), this.end();
                }
            },
            {
                key: "smoothEndTick",
                value: function() {
                    var t1 = this, e = this.interaction, n = e._now() - this.t0, r = Fe(e).smoothEndDuration;
                    if (n < r) {
                        var i = {
                            x: Le(n, 0, this.targetOffset.x, r),
                            y: Le(n, 0, this.targetOffset.y, r)
                        }, o = {
                            x: i.x - this.currentOffset.x,
                            y: i.y - this.currentOffset.y
                        };
                        this.currentOffset.x += o.x, this.currentOffset.y += o.y, e.offsetBy(o), e.move({
                            skipModifiers: this.modifierCount
                        }), this.onNextFrame(function() {
                            return t1.smoothEndTick();
                        });
                    } else e.offsetBy({
                        x: this.targetOffset.x - this.currentOffset.x,
                        y: this.targetOffset.y - this.currentOffset.y
                    }), this.end();
                }
            },
            {
                key: "resume",
                value: function(t1) {
                    var e = t1.pointer, n = t1.event, r = t1.eventTarget, i = this.interaction;
                    i.offsetBy({
                        x: -this.currentOffset.x,
                        y: -this.currentOffset.y
                    }), i.updatePointer(e, n, r, !0), i._doPhase({
                        interaction: i,
                        event: n,
                        phase: "resume"
                    }), et(i.coords.prev, i.coords.cur), this.stop();
                }
            },
            {
                key: "end",
                value: function() {
                    this.interaction.move(), this.interaction.end(), this.stop();
                }
            },
            {
                key: "stop",
                value: function() {
                    this.active = this.smoothEnd = !1, this.interaction.simulation = null, Lt.cancel(this.timeout);
                }
            }
        ]), t1;
    }();
    function Fe(t1) {
        var e = t1.interactable, n = t1.prepared;
        return e && e.options && n.name && e.options[n.name].inertia;
    }
    var Xe = {
        id: "inertia",
        before: [
            "modifiers",
            "actions"
        ],
        install: function(t1) {
            var e = t1.defaults;
            t1.usePlugin(Ce), t1.usePlugin(Ee), t1.actions.phases.inertiastart = !0, t1.actions.phases.resume = !0, e.perAction.inertia = {
                enabled: !1,
                resistance: 10,
                minSpeed: 100,
                endSpeed: 10,
                allowResume: !0,
                smoothEndDuration: 300
            };
        },
        listeners: {
            "interactions:new": function(t1) {
                var e = t1.interaction;
                e.inertia = new je(e);
            },
            "interactions:before-action-end": function(t1) {
                var e = t1.interaction, n = t1.event;
                return (!e._interacting || e.simulation || !e.inertia.start(n)) && null;
            },
            "interactions:down": function(t1) {
                var e = t1.interaction, n = t1.eventTarget, r = e.inertia;
                if (r.active) for(var i = n; w.element(i);){
                    if (i === e.element) {
                        r.resume(t1);
                        break;
                    }
                    i = A(i);
                }
            },
            "interactions:stop": function(t1) {
                var e = t1.interaction.inertia;
                e.active && e.stop();
            },
            "interactions:before-action-resume": function(t1) {
                var e = t1.interaction.modification;
                e.stop(t1), e.start(t1, t1.interaction.coords.cur.page), e.applyToInteraction(t1);
            },
            "interactions:before-action-inertiastart": function(t1) {
                return t1.interaction.modification.setAndApply(t1);
            },
            "interactions:action-resume": xe,
            "interactions:action-inertiastart": xe,
            "interactions:after-action-inertiastart": function(t1) {
                return t1.interaction.modification.restoreInteractionCoords(t1);
            },
            "interactions:after-action-resume": function(t1) {
                return t1.interaction.modification.restoreInteractionCoords(t1);
            }
        }
    };
    function Ye(t1, e, n, r) {
        var i = 1 - t1;
        return i * i * e + 2 * i * t1 * n + t1 * t1 * r;
    }
    function Le(t1, e, n, r) {
        return -n * (t1 /= r) * (t1 - 2) + e;
    }
    var qe = Xe;
    function Be(t1, e) {
        for(var n = 0; n < e.length; n++){
            var r = e[n];
            if (t1.immediatePropagationStopped) break;
            r(t1);
        }
    }
    var Ve = function() {
        function t1(e) {
            r(this, t1), this.options = void 0, this.types = {}, this.propagationStopped = !1, this.immediatePropagationStopped = !1, this.global = void 0, this.options = V({}, e || {});
        }
        return o(t1, [
            {
                key: "fire",
                value: function(t1) {
                    var e, n = this.global;
                    (e = this.types[t1.type]) && Be(t1, e), !t1.propagationStopped && n && (e = n[t1.type]) && Be(t1, e);
                }
            },
            {
                key: "on",
                value: function(t1, e) {
                    var n = $(t1, e);
                    for(t1 in n)this.types[t1] = gt(this.types[t1] || [], n[t1]);
                }
            },
            {
                key: "off",
                value: function(t1, e) {
                    var n = $(t1, e);
                    for(t1 in n){
                        var r = this.types[t1];
                        if (r && r.length) for(var i = 0, o = n[t1]; i < o.length; i++){
                            var a = o[i], s = r.indexOf(a);
                            -1 !== s && r.splice(s, 1);
                        }
                    }
                }
            },
            {
                key: "getRect",
                value: function(t1) {
                    return null;
                }
            }
        ]), t1;
    }();
    var We = function() {
        function t1(e) {
            r(this, t1), this.currentTarget = void 0, this.originalEvent = void 0, this.type = void 0, this.originalEvent = e, tt(this, e);
        }
        return o(t1, [
            {
                key: "preventOriginalDefault",
                value: function() {
                    this.originalEvent.preventDefault();
                }
            },
            {
                key: "stopPropagation",
                value: function() {
                    this.originalEvent.stopPropagation();
                }
            },
            {
                key: "stopImmediatePropagation",
                value: function() {
                    this.originalEvent.stopImmediatePropagation();
                }
            }
        ]), t1;
    }();
    function Ge(t1) {
        return w.object(t1) ? {
            capture: !!t1.capture,
            passive: !!t1.passive
        } : {
            capture: !!t1,
            passive: !1
        };
    }
    function Ne(t1, e) {
        return t1 === e || ("boolean" == typeof t1 ? !!e.capture === t1 && !1 == !!e.passive : !!t1.capture == !!e.capture && !!t1.passive == !!e.passive);
    }
    var Ue = {
        id: "events",
        install: function(t1) {
            var e, n = [], r = {}, i = [], o = {
                add: a,
                remove: s,
                addDelegate: function(t1, e, n, o, s) {
                    var u = Ge(s);
                    if (!r[n]) {
                        r[n] = [];
                        for(var p = 0; p < i.length; p++){
                            var f = i[p];
                            a(f, n, c), a(f, n, l, !0);
                        }
                    }
                    var d = r[n], h = bt(d, function(n) {
                        return n.selector === t1 && n.context === e;
                    });
                    h || (h = {
                        selector: t1,
                        context: e,
                        listeners: []
                    }, d.push(h));
                    h.listeners.push({
                        func: o,
                        options: u
                    });
                },
                removeDelegate: function(t1, e, n, i, o) {
                    var a, u = Ge(o), p = r[n], f = !1;
                    if (!p) return;
                    for(a = p.length - 1; a >= 0; a--){
                        var d = p[a];
                        if (d.selector === t1 && d.context === e) {
                            for(var h = d.listeners, v = h.length - 1; v >= 0; v--){
                                var g = h[v];
                                if (g.func === i && Ne(g.options, u)) {
                                    h.splice(v, 1), h.length || (p.splice(a, 1), s(e, n, c), s(e, n, l, !0)), f = !0;
                                    break;
                                }
                            }
                            if (f) break;
                        }
                    }
                },
                delegateListener: c,
                delegateUseCapture: l,
                delegatedEvents: r,
                documents: i,
                targets: n,
                supportsOptions: !1,
                supportsPassive: !1
            };
            function a(t1, e, r, i) {
                if (t1.addEventListener) {
                    var a = Ge(i), s = bt(n, function(e) {
                        return e.eventTarget === t1;
                    });
                    s || (s = {
                        eventTarget: t1,
                        events: {}
                    }, n.push(s)), s.events[e] || (s.events[e] = []), bt(s.events[e], function(t1) {
                        return t1.func === r && Ne(t1.options, a);
                    }) || (t1.addEventListener(e, r, o.supportsOptions ? a : a.capture), s.events[e].push({
                        func: r,
                        options: a
                    }));
                }
            }
            function s(t1, e, r, i) {
                if (t1.addEventListener && t1.removeEventListener) {
                    var a = yt(n, function(e) {
                        return e.eventTarget === t1;
                    }), c = n[a];
                    if (c && c.events) {
                        if ("all" !== e) {
                            var l = !1, u = c.events[e];
                            if (u) {
                                if ("all" === r) {
                                    for(var p = u.length - 1; p >= 0; p--){
                                        var f = u[p];
                                        s(t1, e, f.func, f.options);
                                    }
                                    return;
                                }
                                for(var d = Ge(i), h = 0; h < u.length; h++){
                                    var v = u[h];
                                    if (v.func === r && Ne(v.options, d)) {
                                        t1.removeEventListener(e, r, o.supportsOptions ? d : d.capture), u.splice(h, 1), 0 === u.length && (delete c.events[e], l = !0);
                                        break;
                                    }
                                }
                            }
                            l && !Object.keys(c.events).length && n.splice(a, 1);
                        } else for(e in c.events)c.events.hasOwnProperty(e) && s(t1, e, "all");
                    }
                }
            }
            function c(t1, e) {
                for(var n = Ge(e), i = new We(t1), o = r[t1.type], a = ht(t1)[0], s = a; w.element(s);){
                    for(var c = 0; c < o.length; c++){
                        var l = o[c], u = l.selector, p = l.context;
                        if (R(s, u) && M(p, a) && M(p, s)) {
                            var f = l.listeners;
                            i.currentTarget = s;
                            for(var d = 0; d < f.length; d++){
                                var h = f[d];
                                Ne(h.options, n) && h.func(i);
                            }
                        }
                    }
                    s = A(s);
                }
            }
            function l(t1) {
                return c(t1, !0);
            }
            return null == (e = t1.document) || e.createElement("div").addEventListener("test", null, {
                get capture () {
                    return o.supportsOptions = !0;
                },
                get passive () {
                    return o.supportsPassive = !0;
                }
            }), t1.events = o, o;
        }
    }, He = {
        methodOrder: [
            "simulationResume",
            "mouseOrPen",
            "hasPointer",
            "idle"
        ],
        search: function(t1) {
            for(var e = 0, n = He.methodOrder; e < n.length; e++){
                var r = n[e], i = He[r](t1);
                if (i) return i;
            }
            return null;
        },
        simulationResume: function(t1) {
            var e = t1.pointerType, n = t1.eventType, r = t1.eventTarget, i = t1.scope;
            if (!/down|start/i.test(n)) return null;
            for(var o = 0, a = i.interactions.list; o < a.length; o++){
                var s = a[o], c = r;
                if (s.simulation && s.simulation.allowResume && s.pointerType === e) for(; c;){
                    if (c === s.element) return s;
                    c = A(c);
                }
            }
            return null;
        },
        mouseOrPen: function(t1) {
            var e, n = t1.pointerId, r = t1.pointerType, i = t1.eventType, o = t1.scope;
            if ("mouse" !== r && "pen" !== r) return null;
            for(var a = 0, s = o.interactions.list; a < s.length; a++){
                var c = s[a];
                if (c.pointerType === r) {
                    if (c.simulation && !Ke(c, n)) continue;
                    if (c.interacting()) return c;
                    e || (e = c);
                }
            }
            if (e) return e;
            for(var l = 0, u = o.interactions.list; l < u.length; l++){
                var p = u[l];
                if (!(p.pointerType !== r || /down/i.test(i) && p.simulation)) return p;
            }
            return null;
        },
        hasPointer: function(t1) {
            for(var e = t1.pointerId, n = 0, r = t1.scope.interactions.list; n < r.length; n++){
                var i = r[n];
                if (Ke(i, e)) return i;
            }
            return null;
        },
        idle: function(t1) {
            for(var e = t1.pointerType, n = 0, r = t1.scope.interactions.list; n < r.length; n++){
                var i = r[n];
                if (1 === i.pointers.length) {
                    var o = i.interactable;
                    if (o && (!o.options.gesture || !o.options.gesture.enabled)) continue;
                } else if (i.pointers.length >= 2) continue;
                if (!i.interacting() && e === i.pointerType) return i;
            }
            return null;
        }
    };
    function Ke(t1, e) {
        return t1.pointers.some(function(t1) {
            return t1.id === e;
        });
    }
    var $e = He, Je = [
        "pointerDown",
        "pointerMove",
        "pointerUp",
        "updatePointer",
        "removePointer",
        "windowBlur"
    ];
    function Qe(t1, e) {
        return function(n) {
            var r = e.interactions.list, i = dt(n), o = ht(n), a = o[0], s = o[1], c = [];
            if (/^touch/.test(n.type)) {
                e.prevTouchTime = e.now();
                for(var l = 0, u = n.changedTouches; l < u.length; l++){
                    var p = u[l], f = {
                        pointer: p,
                        pointerId: at(p),
                        pointerType: i,
                        eventType: n.type,
                        eventTarget: a,
                        curEventTarget: s,
                        scope: e
                    }, d = Ze(f);
                    c.push([
                        f.pointer,
                        f.eventTarget,
                        f.curEventTarget,
                        d
                    ]);
                }
            } else {
                var h = !1;
                if (!I.supportsPointerEvent && /mouse/.test(n.type)) {
                    for(var v = 0; v < r.length && !h; v++)h = "mouse" !== r[v].pointerType && r[v].pointerIsDown;
                    h = h || e.now() - e.prevTouchTime < 500 || 0 === n.timeStamp;
                }
                if (!h) {
                    var g = {
                        pointer: n,
                        pointerId: at(n),
                        pointerType: i,
                        eventType: n.type,
                        curEventTarget: s,
                        eventTarget: a,
                        scope: e
                    }, m = Ze(g);
                    c.push([
                        g.pointer,
                        g.eventTarget,
                        g.curEventTarget,
                        m
                    ]);
                }
            }
            for(var y = 0; y < c.length; y++){
                var b = c[y], x = b[0], w = b[1], E = b[2];
                b[3][t1](x, n, w, E);
            }
        };
    }
    function Ze(t1) {
        var e = t1.pointerType, n = t1.scope, r = {
            interaction: $e.search(t1),
            searchDetails: t1
        };
        return n.fire("interactions:find", r), r.interaction || n.interactions.new({
            pointerType: e
        });
    }
    function tn(t1, e) {
        var n = t1.doc, r = t1.scope, i = t1.options, o = r.interactions.docEvents, a = r.events, s = a[e];
        for(var c in r.browser.isIOS && !i.events && (i.events = {
            passive: !1
        }), a.delegatedEvents)s(n, c, a.delegateListener), s(n, c, a.delegateUseCapture, !0);
        for(var l = i && i.events, u = 0; u < o.length; u++){
            var p = o[u];
            s(n, p.type, p.listener, l);
        }
    }
    var en = {
        id: "core/interactions",
        install: function(t1) {
            for(var e = {}, n = 0; n < Je.length; n++){
                var i = Je[n];
                e[i] = Qe(i, t1);
            }
            var a, c = I.pEventTypes;
            function l() {
                for(var e = 0, n = t1.interactions.list; e < n.length; e++){
                    var r = n[e];
                    if (r.pointerIsDown && "touch" === r.pointerType && !r._interacting) for(var i = function() {
                        var e = a[o];
                        t1.documents.some(function(t1) {
                            return M(t1.doc, e.downTarget);
                        }) || r.removePointer(e.pointer, e.event);
                    }, o = 0, a = r.pointers; o < a.length; o++)i();
                }
            }
            (a = k.PointerEvent ? [
                {
                    type: c.down,
                    listener: l
                },
                {
                    type: c.down,
                    listener: e.pointerDown
                },
                {
                    type: c.move,
                    listener: e.pointerMove
                },
                {
                    type: c.up,
                    listener: e.pointerUp
                },
                {
                    type: c.cancel,
                    listener: e.pointerUp
                }
            ] : [
                {
                    type: "mousedown",
                    listener: e.pointerDown
                },
                {
                    type: "mousemove",
                    listener: e.pointerMove
                },
                {
                    type: "mouseup",
                    listener: e.pointerUp
                },
                {
                    type: "touchstart",
                    listener: l
                },
                {
                    type: "touchstart",
                    listener: e.pointerDown
                },
                {
                    type: "touchmove",
                    listener: e.pointerMove
                },
                {
                    type: "touchend",
                    listener: e.pointerUp
                },
                {
                    type: "touchcancel",
                    listener: e.pointerUp
                }
            ]).push({
                type: "blur",
                listener: function(e) {
                    for(var n = 0, r = t1.interactions.list; n < r.length; n++)r[n].documentBlur(e);
                }
            }), t1.prevTouchTime = 0, t1.Interaction = function(e) {
                s(i, e);
                var n = p(i);
                function i() {
                    return r(this, i), n.apply(this, arguments);
                }
                return o(i, [
                    {
                        key: "pointerMoveTolerance",
                        get: function() {
                            return t1.interactions.pointerMoveTolerance;
                        },
                        set: function(e) {
                            t1.interactions.pointerMoveTolerance = e;
                        }
                    },
                    {
                        key: "_now",
                        value: function() {
                            return t1.now();
                        }
                    }
                ]), i;
            }(De), t1.interactions = {
                list: [],
                new: function(e) {
                    e.scopeFire = function(e, n) {
                        return t1.fire(e, n);
                    };
                    var n = new t1.Interaction(e);
                    return t1.interactions.list.push(n), n;
                },
                listeners: e,
                docEvents: a,
                pointerMoveTolerance: 1
            }, t1.usePlugin(he);
        },
        listeners: {
            "scope:add-document": function(t1) {
                return tn(t1, "add");
            },
            "scope:remove-document": function(t1) {
                return tn(t1, "remove");
            },
            "interactable:unset": function(t1, e) {
                for(var n = t1.interactable, r = e.interactions.list.length - 1; r >= 0; r--){
                    var i = e.interactions.list[r];
                    i.interactable === n && (i.stop(), e.fire("interactions:destroy", {
                        interaction: i
                    }), i.destroy(), e.interactions.list.length > 2 && e.interactions.list.splice(r, 1));
                }
            }
        },
        onDocSignal: tn,
        doOnInteractions: Qe,
        methodNames: Je
    }, nn = en, rn = function(t1) {
        return t1[t1.On = 0] = "On", t1[t1.Off = 1] = "Off", t1;
    }(rn || {}), on = function() {
        function t1(e, n, i, o) {
            r(this, t1), this.target = void 0, this.options = void 0, this._actions = void 0, this.events = new Ve, this._context = void 0, this._win = void 0, this._doc = void 0, this._scopeEvents = void 0, this._actions = n.actions, this.target = e, this._context = n.context || i, this._win = y(B(e) ? this._context : e), this._doc = this._win.document, this._scopeEvents = o, this.set(n);
        }
        return o(t1, [
            {
                key: "_defaults",
                get: function() {
                    return {
                        base: {},
                        perAction: {},
                        actions: {}
                    };
                }
            },
            {
                key: "setOnEvents",
                value: function(t1, e) {
                    return w.func(e.onstart) && this.on("".concat(t1, "start"), e.onstart), w.func(e.onmove) && this.on("".concat(t1, "move"), e.onmove), w.func(e.onend) && this.on("".concat(t1, "end"), e.onend), w.func(e.oninertiastart) && this.on("".concat(t1, "inertiastart"), e.oninertiastart), this;
                }
            },
            {
                key: "updatePerActionListeners",
                value: function(t1, e, n) {
                    var r, i = this, o = null == (r = this._actions.map[t1]) ? void 0 : r.filterEventType, a = function(t1) {
                        return (null == o || o(t1)) && ve(t1, i._actions);
                    };
                    (w.array(e) || w.object(e)) && this._onOff(rn.Off, t1, e, void 0, a), (w.array(n) || w.object(n)) && this._onOff(rn.On, t1, n, void 0, a);
                }
            },
            {
                key: "setPerAction",
                value: function(t1, e) {
                    var n = this._defaults;
                    for(var r in e){
                        var i = r, o = this.options[t1], a = e[i];
                        "listeners" === i && this.updatePerActionListeners(t1, o.listeners, a), w.array(a) ? o[i] = mt(a) : w.plainObject(a) ? (o[i] = V(o[i] || {}, ge(a)), w.object(n.perAction[i]) && "enabled" in n.perAction[i] && (o[i].enabled = !1 !== a.enabled)) : w.bool(a) && w.object(n.perAction[i]) ? o[i].enabled = a : o[i] = a;
                    }
                }
            },
            {
                key: "getRect",
                value: function(t1) {
                    return t1 = t1 || (w.element(this.target) ? this.target : null), w.string(this.target) && (t1 = t1 || this._context.querySelector(this.target)), L(t1);
                }
            },
            {
                key: "rectChecker",
                value: function(t1) {
                    var e = this;
                    return w.func(t1) ? (this.getRect = function(n) {
                        var r = V({}, t1.apply(e, n));
                        return "width" in r || (r.width = r.right - r.left, r.height = r.bottom - r.top), r;
                    }, this) : null === t1 ? (delete this.getRect, this) : this.getRect;
                }
            },
            {
                key: "_backCompatOption",
                value: function(t1, e) {
                    if (B(e) || w.object(e)) {
                        for(var n in this.options[t1] = e, this._actions.map)this.options[n][t1] = e;
                        return this;
                    }
                    return this.options[t1];
                }
            },
            {
                key: "origin",
                value: function(t1) {
                    return this._backCompatOption("origin", t1);
                }
            },
            {
                key: "deltaSource",
                value: function(t1) {
                    return "page" === t1 || "client" === t1 ? (this.options.deltaSource = t1, this) : this.options.deltaSource;
                }
            },
            {
                key: "getAllElements",
                value: function() {
                    var t1 = this.target;
                    return w.string(t1) ? Array.from(this._context.querySelectorAll(t1)) : w.func(t1) && t1.getAllElements ? t1.getAllElements() : w.element(t1) ? [
                        t1
                    ] : [];
                }
            },
            {
                key: "context",
                value: function() {
                    return this._context;
                }
            },
            {
                key: "inContext",
                value: function(t1) {
                    return this._context === t1.ownerDocument || M(this._context, t1);
                }
            },
            {
                key: "testIgnoreAllow",
                value: function(t1, e, n) {
                    return !this.testIgnore(t1.ignoreFrom, e, n) && this.testAllow(t1.allowFrom, e, n);
                }
            },
            {
                key: "testAllow",
                value: function(t1, e, n) {
                    return !t1 || !!w.element(n) && (w.string(t1) ? F(n, t1, e) : !!w.element(t1) && M(t1, n));
                }
            },
            {
                key: "testIgnore",
                value: function(t1, e, n) {
                    return !(!t1 || !w.element(n)) && (w.string(t1) ? F(n, t1, e) : !!w.element(t1) && M(t1, n));
                }
            },
            {
                key: "fire",
                value: function(t1) {
                    return this.events.fire(t1), this;
                }
            },
            {
                key: "_onOff",
                value: function(t1, e, n, r, i) {
                    w.object(e) && !w.array(e) && (r = n, n = null);
                    var o = $(e, n, i);
                    for(var a in o){
                        "wheel" === a && (a = I.wheelEvent);
                        for(var s = 0, c = o[a]; s < c.length; s++){
                            var l = c[s];
                            ve(a, this._actions) ? this.events[t1 === rn.On ? "on" : "off"](a, l) : w.string(this.target) ? this._scopeEvents[t1 === rn.On ? "addDelegate" : "removeDelegate"](this.target, this._context, a, l, r) : this._scopeEvents[t1 === rn.On ? "add" : "remove"](this.target, a, l, r);
                        }
                    }
                    return this;
                }
            },
            {
                key: "on",
                value: function(t1, e, n) {
                    return this._onOff(rn.On, t1, e, n);
                }
            },
            {
                key: "off",
                value: function(t1, e, n) {
                    return this._onOff(rn.Off, t1, e, n);
                }
            },
            {
                key: "set",
                value: function(t1) {
                    var e = this._defaults;
                    for(var n in w.object(t1) || (t1 = {}), this.options = ge(e.base), this._actions.methodDict){
                        var r = n, i = this._actions.methodDict[r];
                        this.options[r] = {}, this.setPerAction(r, V(V({}, e.perAction), e.actions[r])), this[i](t1[r]);
                    }
                    for(var o in t1)"getRect" !== o ? w.func(this[o]) && this[o](t1[o]) : this.rectChecker(t1.getRect);
                    return this;
                }
            },
            {
                key: "unset",
                value: function() {
                    if (w.string(this.target)) for(var t1 in this._scopeEvents.delegatedEvents)for(var e = this._scopeEvents.delegatedEvents[t1], n = e.length - 1; n >= 0; n--){
                        var r = e[n], i = r.selector, o = r.context, a = r.listeners;
                        i === this.target && o === this._context && e.splice(n, 1);
                        for(var s = a.length - 1; s >= 0; s--)this._scopeEvents.removeDelegate(this.target, this._context, t1, a[s][0], a[s][1]);
                    }
                    else this._scopeEvents.remove(this.target, "all");
                }
            }
        ]), t1;
    }(), an = function() {
        function t1(e) {
            var n = this;
            r(this, t1), this.list = [], this.selectorMap = {}, this.scope = void 0, this.scope = e, e.addListeners({
                "interactable:unset": function(t1) {
                    var e = t1.interactable, r = e.target, i = w.string(r) ? n.selectorMap[r] : r[n.scope.id], o = yt(i, function(t1) {
                        return t1 === e;
                    });
                    i.splice(o, 1);
                }
            });
        }
        return o(t1, [
            {
                key: "new",
                value: function(t1, e) {
                    e = V(e || {}, {
                        actions: this.scope.actions
                    });
                    var n = new this.scope.Interactable(t1, e, this.scope.document, this.scope.events);
                    return this.scope.addDocument(n._doc), this.list.push(n), w.string(t1) ? (this.selectorMap[t1] || (this.selectorMap[t1] = []), this.selectorMap[t1].push(n)) : (n.target[this.scope.id] || Object.defineProperty(t1, this.scope.id, {
                        value: [],
                        configurable: !0
                    }), t1[this.scope.id].push(n)), this.scope.fire("interactable:new", {
                        target: t1,
                        options: e,
                        interactable: n,
                        win: this.scope._win
                    }), n;
                }
            },
            {
                key: "getExisting",
                value: function(t1, e) {
                    var n = e && e.context || this.scope.document, r = w.string(t1), i = r ? this.selectorMap[t1] : t1[this.scope.id];
                    if (i) return bt(i, function(e) {
                        return e._context === n && (r || e.inContext(t1));
                    });
                }
            },
            {
                key: "forEachMatch",
                value: function(t1, e) {
                    for(var n = 0, r = this.list; n < r.length; n++){
                        var i = r[n], o = void 0;
                        if ((w.string(i.target) ? w.element(t1) && R(t1, i.target) : t1 === i.target) && i.inContext(t1) && (o = e(i)), void 0 !== o) return o;
                    }
                }
            }
        ]), t1;
    }();
    var sn = function() {
        function t1() {
            var e = this;
            r(this, t1), this.id = "__interact_scope_".concat(Math.floor(100 * Math.random())), this.isInitialized = !1, this.listenerMaps = [], this.browser = I, this.defaults = ge(Te), this.Eventable = Ve, this.actions = {
                map: {},
                phases: {
                    start: !0,
                    move: !0,
                    end: !0
                },
                methodDict: {},
                phaselessTypes: {}
            }, this.interactStatic = function(t1) {
                var e = function e(n, r) {
                    var i = t1.interactables.getExisting(n, r);
                    return i || ((i = t1.interactables.new(n, r)).events.global = e.globalEvents), i;
                };
                return e.getPointerAverage = lt, e.getTouchBBox = ut, e.getTouchDistance = pt, e.getTouchAngle = ft, e.getElementRect = L, e.getElementClientRect = Y, e.matchesSelector = R, e.closest = z, e.globalEvents = {}, e.version = "1.10.27", e.scope = t1, e.use = function(t1, e) {
                    return this.scope.usePlugin(t1, e), this;
                }, e.isSet = function(t1, e) {
                    return !!this.scope.interactables.get(t1, e && e.context);
                }, e.on = Nt(function(t1, e, n) {
                    if (w.string(t1) && -1 !== t1.search(" ") && (t1 = t1.trim().split(/ +/)), w.array(t1)) {
                        for(var r = 0, i = t1; r < i.length; r++){
                            var o = i[r];
                            this.on(o, e, n);
                        }
                        return this;
                    }
                    if (w.object(t1)) {
                        for(var a in t1)this.on(a, t1[a], e);
                        return this;
                    }
                    return ve(t1, this.scope.actions) ? this.globalEvents[t1] ? this.globalEvents[t1].push(e) : this.globalEvents[t1] = [
                        e
                    ] : this.scope.events.add(this.scope.document, t1, e, {
                        options: n
                    }), this;
                }, "The interact.on() method is being deprecated"), e.off = Nt(function(t1, e, n) {
                    if (w.string(t1) && -1 !== t1.search(" ") && (t1 = t1.trim().split(/ +/)), w.array(t1)) {
                        for(var r = 0, i = t1; r < i.length; r++){
                            var o = i[r];
                            this.off(o, e, n);
                        }
                        return this;
                    }
                    if (w.object(t1)) {
                        for(var a in t1)this.off(a, t1[a], e);
                        return this;
                    }
                    var s;
                    return ve(t1, this.scope.actions) ? t1 in this.globalEvents && -1 !== (s = this.globalEvents[t1].indexOf(e)) && this.globalEvents[t1].splice(s, 1) : this.scope.events.remove(this.scope.document, t1, e, n), this;
                }, "The interact.off() method is being deprecated"), e.debug = function() {
                    return this.scope;
                }, e.supportsTouch = function() {
                    return I.supportsTouch;
                }, e.supportsPointerEvent = function() {
                    return I.supportsPointerEvent;
                }, e.stop = function() {
                    for(var t1 = 0, e = this.scope.interactions.list; t1 < e.length; t1++)e[t1].stop();
                    return this;
                }, e.pointerMoveTolerance = function(t1) {
                    return w.number(t1) ? (this.scope.interactions.pointerMoveTolerance = t1, this) : this.scope.interactions.pointerMoveTolerance;
                }, e.addDocument = function(t1, e) {
                    this.scope.addDocument(t1, e);
                }, e.removeDocument = function(t1) {
                    this.scope.removeDocument(t1);
                }, e;
            }(this), this.InteractEvent = Se, this.Interactable = void 0, this.interactables = new an(this), this._win = void 0, this.document = void 0, this.window = void 0, this.documents = [], this._plugins = {
                list: [],
                map: {}
            }, this.onWindowUnload = function(t1) {
                return e.removeDocument(t1.target);
            };
            var n = this;
            this.Interactable = function(t1) {
                s(i, t1);
                var e = p(i);
                function i() {
                    return r(this, i), e.apply(this, arguments);
                }
                return o(i, [
                    {
                        key: "_defaults",
                        get: function() {
                            return n.defaults;
                        }
                    },
                    {
                        key: "set",
                        value: function(t1) {
                            return f(c(i.prototype), "set", this).call(this, t1), n.fire("interactable:set", {
                                options: t1,
                                interactable: this
                            }), this;
                        }
                    },
                    {
                        key: "unset",
                        value: function() {
                            f(c(i.prototype), "unset", this).call(this);
                            var t1 = n.interactables.list.indexOf(this);
                            t1 < 0 || (n.interactables.list.splice(t1, 1), n.fire("interactable:unset", {
                                interactable: this
                            }));
                        }
                    }
                ]), i;
            }(on);
        }
        return o(t1, [
            {
                key: "addListeners",
                value: function(t1, e) {
                    this.listenerMaps.push({
                        id: e,
                        map: t1
                    });
                }
            },
            {
                key: "fire",
                value: function(t1, e) {
                    for(var n = 0, r = this.listenerMaps; n < r.length; n++){
                        var i = r[n].map[t1];
                        if (i && !1 === i(e, this, t1)) return !1;
                    }
                }
            },
            {
                key: "init",
                value: function(t1) {
                    return this.isInitialized ? this : function(t1, e) {
                        t1.isInitialized = !0, w.window(e) && m(e);
                        return k.init(e), I.init(e), Lt.init(e), t1.window = e, t1.document = e.document, t1.usePlugin(nn), t1.usePlugin(Ue), t1;
                    }(this, t1);
                }
            },
            {
                key: "pluginIsInstalled",
                value: function(t1) {
                    var e = t1.id;
                    return e ? !!this._plugins.map[e] : -1 !== this._plugins.list.indexOf(t1);
                }
            },
            {
                key: "usePlugin",
                value: function(t1, e) {
                    if (!this.isInitialized) return this;
                    if (this.pluginIsInstalled(t1)) return this;
                    if (t1.id && (this._plugins.map[t1.id] = t1), this._plugins.list.push(t1), t1.install && t1.install(this, e), t1.listeners && t1.before) {
                        for(var n = 0, r = this.listenerMaps.length, i = t1.before.reduce(function(t1, e) {
                            return t1[e] = !0, t1[cn(e)] = !0, t1;
                        }, {}); n < r; n++){
                            var o = this.listenerMaps[n].id;
                            if (o && (i[o] || i[cn(o)])) break;
                        }
                        this.listenerMaps.splice(n, 0, {
                            id: t1.id,
                            map: t1.listeners
                        });
                    } else t1.listeners && this.listenerMaps.push({
                        id: t1.id,
                        map: t1.listeners
                    });
                    return this;
                }
            },
            {
                key: "addDocument",
                value: function(t1, e) {
                    if (-1 !== this.getDocIndex(t1)) return !1;
                    var n = y(t1);
                    e = e ? V({}, e) : {}, this.documents.push({
                        doc: t1,
                        options: e
                    }), this.events.documents.push(t1), t1 !== this.document && this.events.add(n, "unload", this.onWindowUnload), this.fire("scope:add-document", {
                        doc: t1,
                        window: n,
                        scope: this,
                        options: e
                    });
                }
            },
            {
                key: "removeDocument",
                value: function(t1) {
                    var e = this.getDocIndex(t1), n = y(t1), r = this.documents[e].options;
                    this.events.remove(n, "unload", this.onWindowUnload), this.documents.splice(e, 1), this.events.documents.splice(e, 1), this.fire("scope:remove-document", {
                        doc: t1,
                        window: n,
                        scope: this,
                        options: r
                    });
                }
            },
            {
                key: "getDocIndex",
                value: function(t1) {
                    for(var e = 0; e < this.documents.length; e++)if (this.documents[e].doc === t1) return e;
                    return -1;
                }
            },
            {
                key: "getDocOptions",
                value: function(t1) {
                    var e = this.getDocIndex(t1);
                    return -1 === e ? null : this.documents[e].options;
                }
            },
            {
                key: "now",
                value: function() {
                    return (this.window.Date || Date).now();
                }
            }
        ]), t1;
    }();
    function cn(t1) {
        return t1 && t1.replace(/\/.*$/, "");
    }
    var ln = new sn, un = ln.interactStatic, pn = "undefined" != typeof globalThis ? globalThis : window;
    ln.init(pn);
    var fn = Object.freeze({
        __proto__: null,
        edgeTarget: function() {},
        elements: function() {},
        grid: function(t1) {
            var e = [
                [
                    "x",
                    "y"
                ],
                [
                    "left",
                    "top"
                ],
                [
                    "right",
                    "bottom"
                ],
                [
                    "width",
                    "height"
                ]
            ].filter(function(e) {
                var n = e[0], r = e[1];
                return n in t1 || r in t1;
            }), n = function(n, r) {
                for(var i = t1.range, o = t1.limits, a = void 0 === o ? {
                    left: -1 / 0,
                    right: 1 / 0,
                    top: -1 / 0,
                    bottom: 1 / 0
                } : o, s = t1.offset, c = void 0 === s ? {
                    x: 0,
                    y: 0
                } : s, l = {
                    range: i,
                    grid: t1,
                    x: null,
                    y: null
                }, u = 0; u < e.length; u++){
                    var p = e[u], f = p[0], d = p[1], h = Math.round((n - c.x) / t1[f]), v = Math.round((r - c.y) / t1[d]);
                    l[f] = Math.max(a.left, Math.min(a.right, h * t1[f] + c.x)), l[d] = Math.max(a.top, Math.min(a.bottom, v * t1[d] + c.y));
                }
                return l;
            };
            return n.grid = t1, n.coordFields = e, n;
        }
    }), dn = {
        id: "snappers",
        install: function(t1) {
            var e = t1.interactStatic;
            e.snappers = V(e.snappers || {}, fn), e.createSnapGrid = e.snappers.grid;
        }
    }, hn = dn, vn = {
        start: function(t1) {
            var n = t1.state, r = t1.rect, i = t1.edges, o = t1.pageCoords, a = n.options, s = a.ratio, c = a.enabled, l = n.options, u = l.equalDelta, p = l.modifiers;
            "preserve" === s && (s = r.width / r.height), n.startCoords = V({}, o), n.startRect = V({}, r), n.ratio = s, n.equalDelta = u;
            var f = n.linkedEdges = {
                top: i.top || i.left && !i.bottom,
                left: i.left || i.top && !i.right,
                bottom: i.bottom || i.right && !i.top,
                right: i.right || i.bottom && !i.left
            };
            if (n.xIsPrimaryAxis = !(!i.left && !i.right), n.equalDelta) {
                var d = (f.left ? 1 : -1) * (f.top ? 1 : -1);
                n.edgeSign = {
                    x: d,
                    y: d
                };
            } else n.edgeSign = {
                x: f.left ? -1 : 1,
                y: f.top ? -1 : 1
            };
            if (!1 !== c && V(i, f), null != p && p.length) {
                var h = new me(t1.interaction);
                h.copyFrom(t1.interaction.modification), h.prepareStates(p), n.subModification = h, h.startAll(e({}, t1));
            }
        },
        set: function(t1) {
            var n = t1.state, r = t1.rect, i = t1.coords, o = n.linkedEdges, a = V({}, i), s = n.equalDelta ? gn : mn;
            if (V(t1.edges, o), s(n, n.xIsPrimaryAxis, i, r), !n.subModification) return null;
            var c = V({}, r);
            H(o, c, {
                x: i.x - a.x,
                y: i.y - a.y
            });
            var l = n.subModification.setAll(e(e({}, t1), {}, {
                rect: c,
                edges: o,
                pageCoords: i,
                prevCoords: i,
                prevRect: c
            })), u = l.delta;
            l.changed && (s(n, Math.abs(u.x) > Math.abs(u.y), l.coords, l.rect), V(i, l.coords));
            return l.eventProps;
        },
        defaults: {
            ratio: "preserve",
            equalDelta: !1,
            modifiers: [],
            enabled: !1
        }
    };
    function gn(t1, e, n) {
        var r = t1.startCoords, i = t1.edgeSign;
        e ? n.y = r.y + (n.x - r.x) * i.y : n.x = r.x + (n.y - r.y) * i.x;
    }
    function mn(t1, e, n, r) {
        var i = t1.startRect, o = t1.startCoords, a = t1.ratio, s = t1.edgeSign;
        if (e) {
            var c = r.width / a;
            n.y = o.y + (c - i.height) * s.y;
        } else {
            var l = r.height * a;
            n.x = o.x + (l - i.width) * s.x;
        }
    }
    var yn = be(vn, "aspectRatio"), bn = function() {};
    bn._defaults = {};
    var xn = bn;
    function wn(t1, e, n) {
        return w.func(t1) ? G(t1, e.interactable, e.element, [
            n.x,
            n.y,
            e
        ]) : G(t1, e.interactable, e.element);
    }
    var En = {
        start: function(t1) {
            var e = t1.rect, n = t1.startOffset, r = t1.state, i = t1.interaction, o = t1.pageCoords, a = r.options, s = a.elementRect, c = V({
                left: 0,
                top: 0,
                right: 0,
                bottom: 0
            }, a.offset || {});
            if (e && s) {
                var l = wn(a.restriction, i, o);
                if (l) {
                    var u = l.right - l.left - e.width, p = l.bottom - l.top - e.height;
                    u < 0 && (c.left += u, c.right += u), p < 0 && (c.top += p, c.bottom += p);
                }
                c.left += n.left - e.width * s.left, c.top += n.top - e.height * s.top, c.right += n.right - e.width * (1 - s.right), c.bottom += n.bottom - e.height * (1 - s.bottom);
            }
            r.offset = c;
        },
        set: function(t1) {
            var e = t1.coords, n = t1.interaction, r = t1.state, i = r.options, o = r.offset, a = wn(i.restriction, n, e);
            if (a) {
                var s = function(t1) {
                    return !t1 || "left" in t1 && "top" in t1 || ((t1 = V({}, t1)).left = t1.x || 0, t1.top = t1.y || 0, t1.right = t1.right || t1.left + t1.width, t1.bottom = t1.bottom || t1.top + t1.height), t1;
                }(a);
                e.x = Math.max(Math.min(s.right - o.right, e.x), s.left + o.left), e.y = Math.max(Math.min(s.bottom - o.bottom, e.y), s.top + o.top);
            }
        },
        defaults: {
            restriction: null,
            elementRect: null,
            offset: null,
            endOnly: !1,
            enabled: !1
        }
    }, Tn = be(En, "restrict"), Sn = {
        top: 1 / 0,
        left: 1 / 0,
        bottom: -1 / 0,
        right: -1 / 0
    }, _n = {
        top: -1 / 0,
        left: -1 / 0,
        bottom: 1 / 0,
        right: 1 / 0
    };
    function Pn(t1, e) {
        for(var n = 0, r = [
            "top",
            "left",
            "bottom",
            "right"
        ]; n < r.length; n++){
            var i = r[n];
            i in t1 || (t1[i] = e[i]);
        }
        return t1;
    }
    var On = {
        noInner: Sn,
        noOuter: _n,
        start: function(t1) {
            var e, n = t1.interaction, r = t1.startOffset, i = t1.state, o = i.options;
            o && (e = N(wn(o.offset, n, n.coords.start.page))), e = e || {
                x: 0,
                y: 0
            }, i.offset = {
                top: e.y + r.top,
                left: e.x + r.left,
                bottom: e.y - r.bottom,
                right: e.x - r.right
            };
        },
        set: function(t1) {
            var e = t1.coords, n = t1.edges, r = t1.interaction, i = t1.state, o = i.offset, a = i.options;
            if (n) {
                var s = V({}, e), c = wn(a.inner, r, s) || {}, l = wn(a.outer, r, s) || {};
                Pn(c, Sn), Pn(l, _n), n.top ? e.y = Math.min(Math.max(l.top + o.top, s.y), c.top + o.top) : n.bottom && (e.y = Math.max(Math.min(l.bottom + o.bottom, s.y), c.bottom + o.bottom)), n.left ? e.x = Math.min(Math.max(l.left + o.left, s.x), c.left + o.left) : n.right && (e.x = Math.max(Math.min(l.right + o.right, s.x), c.right + o.right));
            }
        },
        defaults: {
            inner: null,
            outer: null,
            offset: null,
            endOnly: !1,
            enabled: !1
        }
    }, kn = be(On, "restrictEdges"), Dn = V({
        get elementRect () {
            return {
                top: 0,
                left: 0,
                bottom: 1,
                right: 1
            };
        },
        set elementRect (t){}
    }, En.defaults), In = be({
        start: En.start,
        set: En.set,
        defaults: Dn
    }, "restrictRect"), Mn = {
        width: -1 / 0,
        height: -1 / 0
    }, zn = {
        width: 1 / 0,
        height: 1 / 0
    };
    var An = be({
        start: function(t1) {
            return On.start(t1);
        },
        set: function(t1) {
            var e = t1.interaction, n = t1.state, r = t1.rect, i = t1.edges, o = n.options;
            if (i) {
                var a = U(wn(o.min, e, t1.coords)) || Mn, s = U(wn(o.max, e, t1.coords)) || zn;
                n.options = {
                    endOnly: o.endOnly,
                    inner: V({}, On.noInner),
                    outer: V({}, On.noOuter)
                }, i.top ? (n.options.inner.top = r.bottom - a.height, n.options.outer.top = r.bottom - s.height) : i.bottom && (n.options.inner.bottom = r.top + a.height, n.options.outer.bottom = r.top + s.height), i.left ? (n.options.inner.left = r.right - a.width, n.options.outer.left = r.right - s.width) : i.right && (n.options.inner.right = r.left + a.width, n.options.outer.right = r.left + s.width), On.set(t1), n.options = o;
            }
        },
        defaults: {
            min: null,
            max: null,
            endOnly: !1,
            enabled: !1
        }
    }, "restrictSize");
    var Rn = {
        start: function(t1) {
            var e, n = t1.interaction, r = t1.interactable, i = t1.element, o = t1.rect, a = t1.state, s = t1.startOffset, c = a.options, l = c.offsetWithOrigin ? function(t1) {
                var e = t1.interaction.element, n = N(G(t1.state.options.origin, null, null, [
                    e
                ])), r = n || K(t1.interactable, e, t1.interaction.prepared.name);
                return r;
            }(t1) : {
                x: 0,
                y: 0
            };
            if ("startCoords" === c.offset) e = {
                x: n.coords.start.page.x,
                y: n.coords.start.page.y
            };
            else {
                var u = G(c.offset, r, i, [
                    n
                ]);
                (e = N(u) || {
                    x: 0,
                    y: 0
                }).x += l.x, e.y += l.y;
            }
            var p = c.relativePoints;
            a.offsets = o && p && p.length ? p.map(function(t1, n) {
                return {
                    index: n,
                    relativePoint: t1,
                    x: s.left - o.width * t1.x + e.x,
                    y: s.top - o.height * t1.y + e.y
                };
            }) : [
                {
                    index: 0,
                    relativePoint: null,
                    x: e.x,
                    y: e.y
                }
            ];
        },
        set: function(t1) {
            var e = t1.interaction, n = t1.coords, r = t1.state, i = r.options, o = r.offsets, a = K(e.interactable, e.element, e.prepared.name), s = V({}, n), c = [];
            i.offsetWithOrigin || (s.x -= a.x, s.y -= a.y);
            for(var l = 0, u = o; l < u.length; l++)for(var p = u[l], f = s.x - p.x, d = s.y - p.y, h = 0, v = i.targets.length; h < v; h++){
                var g = i.targets[h], m = void 0;
                (m = w.func(g) ? g(f, d, e._proxy, p, h) : g) && c.push({
                    x: (w.number(m.x) ? m.x : f) + p.x,
                    y: (w.number(m.y) ? m.y : d) + p.y,
                    range: w.number(m.range) ? m.range : i.range,
                    source: g,
                    index: h,
                    offset: p
                });
            }
            for(var y = {
                target: null,
                inRange: !1,
                distance: 0,
                range: 0,
                delta: {
                    x: 0,
                    y: 0
                }
            }, b = 0; b < c.length; b++){
                var x = c[b], E = x.range, T = x.x - s.x, S = x.y - s.y, _ = Q(T, S), P = _ <= E;
                E === 1 / 0 && y.inRange && y.range !== 1 / 0 && (P = !1), y.target && !(P ? y.inRange && E !== 1 / 0 ? _ / E < y.distance / y.range : E === 1 / 0 && y.range !== 1 / 0 || _ < y.distance : !y.inRange && _ < y.distance) || (y.target = x, y.distance = _, y.range = E, y.inRange = P, y.delta.x = T, y.delta.y = S);
            }
            return y.inRange && (n.x = y.target.x, n.y = y.target.y), r.closest = y, y;
        },
        defaults: {
            range: 1 / 0,
            targets: null,
            offset: null,
            offsetWithOrigin: !0,
            origin: null,
            relativePoints: null,
            endOnly: !1,
            enabled: !1
        }
    }, Cn = be(Rn, "snap");
    var jn = {
        start: function(t1) {
            var e = t1.state, n = t1.edges, r = e.options;
            if (!n) return null;
            t1.state = {
                options: {
                    targets: null,
                    relativePoints: [
                        {
                            x: n.left ? 0 : 1,
                            y: n.top ? 0 : 1
                        }
                    ],
                    offset: r.offset || "self",
                    origin: {
                        x: 0,
                        y: 0
                    },
                    range: r.range
                }
            }, e.targetFields = e.targetFields || [
                [
                    "width",
                    "height"
                ],
                [
                    "x",
                    "y"
                ]
            ], Rn.start(t1), e.offsets = t1.state.offsets, t1.state = e;
        },
        set: function(t1) {
            var e = t1.interaction, n = t1.state, r = t1.coords, i = n.options, o = n.offsets, a = {
                x: r.x - o[0].x,
                y: r.y - o[0].y
            };
            n.options = V({}, i), n.options.targets = [];
            for(var s = 0, c = i.targets || []; s < c.length; s++){
                var l = c[s], u = void 0;
                if (u = w.func(l) ? l(a.x, a.y, e) : l) {
                    for(var p = 0, f = n.targetFields; p < f.length; p++){
                        var d = f[p], h = d[0], v = d[1];
                        if (h in u || v in u) {
                            u.x = u[h], u.y = u[v];
                            break;
                        }
                    }
                    n.options.targets.push(u);
                }
            }
            var g = Rn.set(t1);
            return n.options = i, g;
        },
        defaults: {
            range: 1 / 0,
            targets: null,
            offset: null,
            endOnly: !1,
            enabled: !1
        }
    }, Fn = be(jn, "snapSize");
    var Xn = {
        aspectRatio: yn,
        restrictEdges: kn,
        restrict: Tn,
        restrictRect: In,
        restrictSize: An,
        snapEdges: be({
            start: function(t1) {
                var e = t1.edges;
                return e ? (t1.state.targetFields = t1.state.targetFields || [
                    [
                        e.left ? "left" : "right",
                        e.top ? "top" : "bottom"
                    ]
                ], jn.start(t1)) : null;
            },
            set: jn.set,
            defaults: V(ge(jn.defaults), {
                targets: void 0,
                range: void 0,
                offset: {
                    x: 0,
                    y: 0
                }
            })
        }, "snapEdges"),
        snap: Cn,
        snapSize: Fn,
        spring: xn,
        avoid: xn,
        transform: xn,
        rubberband: xn
    }, Yn = {
        id: "modifiers",
        install: function(t1) {
            var e = t1.interactStatic;
            for(var n in t1.usePlugin(Ee), t1.usePlugin(hn), e.modifiers = Xn, Xn){
                var r = Xn[n], i = r._defaults, o = r._methods;
                i._methods = o, t1.defaults.perAction[n] = i;
            }
        }
    }, Ln = Yn, qn = function(t1) {
        s(n, t1);
        var e = p(n);
        function n(t1, i, o, a, s, c) {
            var l;
            if (r(this, n), tt(u(l = e.call(this, s)), o), o !== i && tt(u(l), i), l.timeStamp = c, l.originalEvent = o, l.type = t1, l.pointerId = at(i), l.pointerType = dt(i), l.target = a, l.currentTarget = null, "tap" === t1) {
                var p = s.getPointerIndex(i);
                l.dt = l.timeStamp - s.pointers[p].downTime;
                var f = l.timeStamp - s.tapTime;
                l.double = !!s.prevTap && "doubletap" !== s.prevTap.type && s.prevTap.target === l.target && f < 500;
            } else "doubletap" === t1 && (l.dt = i.timeStamp - s.tapTime, l.double = !0);
            return l;
        }
        return o(n, [
            {
                key: "_subtractOrigin",
                value: function(t1) {
                    var e = t1.x, n = t1.y;
                    return this.pageX -= e, this.pageY -= n, this.clientX -= e, this.clientY -= n, this;
                }
            },
            {
                key: "_addOrigin",
                value: function(t1) {
                    var e = t1.x, n = t1.y;
                    return this.pageX += e, this.pageY += n, this.clientX += e, this.clientY += n, this;
                }
            },
            {
                key: "preventDefault",
                value: function() {
                    this.originalEvent.preventDefault();
                }
            }
        ]), n;
    }(vt), Bn = {
        id: "pointer-events/base",
        before: [
            "inertia",
            "modifiers",
            "auto-start",
            "actions"
        ],
        install: function(t1) {
            t1.pointerEvents = Bn, t1.defaults.actions.pointerEvents = Bn.defaults, V(t1.actions.phaselessTypes, Bn.types);
        },
        listeners: {
            "interactions:new": function(t1) {
                var e = t1.interaction;
                e.prevTap = null, e.tapTime = 0;
            },
            "interactions:update-pointer": function(t1) {
                var e = t1.down, n = t1.pointerInfo;
                if (!e && n.hold) return;
                n.hold = {
                    duration: 1 / 0,
                    timeout: null
                };
            },
            "interactions:move": function(t1, e) {
                var n = t1.interaction, r = t1.pointer, i = t1.event, o = t1.eventTarget;
                t1.duplicate || n.pointerIsDown && !n.pointerWasMoved || (n.pointerIsDown && Gn(t1), Vn({
                    interaction: n,
                    pointer: r,
                    event: i,
                    eventTarget: o,
                    type: "move"
                }, e));
            },
            "interactions:down": function(t1, e) {
                !function(t1, e) {
                    for(var n = t1.interaction, r = t1.pointer, i = t1.event, o = t1.eventTarget, a = t1.pointerIndex, s = n.pointers[a].hold, c = q(o), l = {
                        interaction: n,
                        pointer: r,
                        event: i,
                        eventTarget: o,
                        type: "hold",
                        targets: [],
                        path: c,
                        node: null
                    }, u = 0; u < c.length; u++){
                        var p = c[u];
                        l.node = p, e.fire("pointerEvents:collect-targets", l);
                    }
                    if (!l.targets.length) return;
                    for(var f = 1 / 0, d = 0, h = l.targets; d < h.length; d++){
                        var v = h[d].eventable.options.holdDuration;
                        v < f && (f = v);
                    }
                    s.duration = f, s.timeout = setTimeout(function() {
                        Vn({
                            interaction: n,
                            eventTarget: o,
                            pointer: r,
                            event: i,
                            type: "hold"
                        }, e);
                    }, f);
                }(t1, e), Vn(t1, e);
            },
            "interactions:up": function(t1, e) {
                Gn(t1), Vn(t1, e), function(t1, e) {
                    var n = t1.interaction, r = t1.pointer, i = t1.event, o = t1.eventTarget;
                    n.pointerWasMoved || Vn({
                        interaction: n,
                        eventTarget: o,
                        pointer: r,
                        event: i,
                        type: "tap"
                    }, e);
                }(t1, e);
            },
            "interactions:cancel": function(t1, e) {
                Gn(t1), Vn(t1, e);
            }
        },
        PointerEvent: qn,
        fire: Vn,
        collectEventTargets: Wn,
        defaults: {
            holdDuration: 600,
            ignoreFrom: null,
            allowFrom: null,
            origin: {
                x: 0,
                y: 0
            }
        },
        types: {
            down: !0,
            move: !0,
            up: !0,
            cancel: !0,
            tap: !0,
            doubletap: !0,
            hold: !0
        }
    };
    function Vn(t1, e) {
        var n = t1.interaction, r = t1.pointer, i = t1.event, o = t1.eventTarget, a = t1.type, s = t1.targets, c = void 0 === s ? Wn(t1, e) : s, l = new qn(a, r, i, o, n, e.now());
        e.fire("pointerEvents:new", {
            pointerEvent: l
        });
        for(var u = {
            interaction: n,
            pointer: r,
            event: i,
            eventTarget: o,
            targets: c,
            type: a,
            pointerEvent: l
        }, p = 0; p < c.length; p++){
            var f = c[p];
            for(var d in f.props || {})l[d] = f.props[d];
            var h = K(f.eventable, f.node);
            if (l._subtractOrigin(h), l.eventable = f.eventable, l.currentTarget = f.node, f.eventable.fire(l), l._addOrigin(h), l.immediatePropagationStopped || l.propagationStopped && p + 1 < c.length && c[p + 1].node !== l.currentTarget) break;
        }
        if (e.fire("pointerEvents:fired", u), "tap" === a) {
            var v = l.double ? Vn({
                interaction: n,
                pointer: r,
                event: i,
                eventTarget: o,
                type: "doubletap"
            }, e) : l;
            n.prevTap = v, n.tapTime = v.timeStamp;
        }
        return l;
    }
    function Wn(t1, e) {
        var n = t1.interaction, r = t1.pointer, i = t1.event, o = t1.eventTarget, a = t1.type, s = n.getPointerIndex(r), c = n.pointers[s];
        if ("tap" === a && (n.pointerWasMoved || !c || c.downTarget !== o)) return [];
        for(var l = q(o), u = {
            interaction: n,
            pointer: r,
            event: i,
            eventTarget: o,
            type: a,
            path: l,
            targets: [],
            node: null
        }, p = 0; p < l.length; p++){
            var f = l[p];
            u.node = f, e.fire("pointerEvents:collect-targets", u);
        }
        return "hold" === a && (u.targets = u.targets.filter(function(t1) {
            var e, r;
            return t1.eventable.options.holdDuration === (null == (e = n.pointers[s]) || null == (r = e.hold) ? void 0 : r.duration);
        })), u.targets;
    }
    function Gn(t1) {
        var e = t1.interaction, n = t1.pointerIndex, r = e.pointers[n].hold;
        r && r.timeout && (clearTimeout(r.timeout), r.timeout = null);
    }
    var Nn = Object.freeze({
        __proto__: null,
        default: Bn
    });
    function Un(t1) {
        var e = t1.interaction;
        e.holdIntervalHandle && (clearInterval(e.holdIntervalHandle), e.holdIntervalHandle = null);
    }
    var Hn = {
        id: "pointer-events/holdRepeat",
        install: function(t1) {
            t1.usePlugin(Bn);
            var e = t1.pointerEvents;
            e.defaults.holdRepeatInterval = 0, e.types.holdrepeat = t1.actions.phaselessTypes.holdrepeat = !0;
        },
        listeners: [
            "move",
            "up",
            "cancel",
            "endall"
        ].reduce(function(t1, e) {
            return t1["pointerEvents:".concat(e)] = Un, t1;
        }, {
            "pointerEvents:new": function(t1) {
                var e = t1.pointerEvent;
                "hold" === e.type && (e.count = (e.count || 0) + 1);
            },
            "pointerEvents:fired": function(t1, e) {
                var n = t1.interaction, r = t1.pointerEvent, i = t1.eventTarget, o = t1.targets;
                if ("hold" === r.type && o.length) {
                    var a = o[0].eventable.options.holdRepeatInterval;
                    a <= 0 || (n.holdIntervalHandle = setTimeout(function() {
                        e.pointerEvents.fire({
                            interaction: n,
                            eventTarget: i,
                            type: "hold",
                            pointer: r,
                            event: r
                        }, e);
                    }, a));
                }
            }
        })
    }, Kn = Hn;
    var $n = {
        id: "pointer-events/interactableTargets",
        install: function(t1) {
            var e = t1.Interactable;
            e.prototype.pointerEvents = function(t1) {
                return V(this.events.options, t1), this;
            };
            var n = e.prototype._backCompatOption;
            e.prototype._backCompatOption = function(t1, e) {
                var r = n.call(this, t1, e);
                return r === this && (this.events.options[t1] = e), r;
            };
        },
        listeners: {
            "pointerEvents:collect-targets": function(t1, e) {
                var n = t1.targets, r = t1.node, i = t1.type, o = t1.eventTarget;
                e.interactables.forEachMatch(r, function(t1) {
                    var e = t1.events, a = e.options;
                    e.types[i] && e.types[i].length && t1.testIgnoreAllow(a, r, o) && n.push({
                        node: r,
                        eventable: e,
                        props: {
                            interactable: t1
                        }
                    });
                });
            },
            "interactable:new": function(t1) {
                var e = t1.interactable;
                e.events.getRect = function(t1) {
                    return e.getRect(t1);
                };
            },
            "interactable:set": function(t1, e) {
                var n = t1.interactable, r = t1.options;
                V(n.events.options, e.pointerEvents.defaults), V(n.events.options, r.pointerEvents || {});
            }
        }
    }, Jn = $n, Qn = {
        id: "pointer-events",
        install: function(t1) {
            t1.usePlugin(Nn), t1.usePlugin(Kn), t1.usePlugin(Jn);
        }
    }, Zn = Qn;
    var tr = {
        id: "reflow",
        install: function(t1) {
            var e = t1.Interactable;
            t1.actions.phases.reflow = !0, e.prototype.reflow = function(e) {
                return function(t1, e, n) {
                    for(var r = t1.getAllElements(), i = n.window.Promise, o = i ? [] : null, a = function() {
                        var a = r[s], c = t1.getRect(a);
                        if (!c) return 1;
                        var l, u = bt(n.interactions.list, function(n) {
                            return n.interacting() && n.interactable === t1 && n.element === a && n.prepared.name === e.name;
                        });
                        if (u) u.move(), o && (l = u._reflowPromise || new i(function(t1) {
                            u._reflowResolve = t1;
                        }));
                        else {
                            var p = U(c), f = function(t1) {
                                return {
                                    coords: t1,
                                    get page () {
                                        return this.coords.page;
                                    },
                                    get client () {
                                        return this.coords.client;
                                    },
                                    get timeStamp () {
                                        return this.coords.timeStamp;
                                    },
                                    get pageX () {
                                        return this.coords.page.x;
                                    },
                                    get pageY () {
                                        return this.coords.page.y;
                                    },
                                    get clientX () {
                                        return this.coords.client.x;
                                    },
                                    get clientY () {
                                        return this.coords.client.y;
                                    },
                                    get pointerId () {
                                        return this.coords.pointerId;
                                    },
                                    get target () {
                                        return this.coords.target;
                                    },
                                    get type () {
                                        return this.coords.type;
                                    },
                                    get pointerType () {
                                        return this.coords.pointerType;
                                    },
                                    get buttons () {
                                        return this.coords.buttons;
                                    },
                                    preventDefault: function() {}
                                };
                            }({
                                page: {
                                    x: p.x,
                                    y: p.y
                                },
                                client: {
                                    x: p.x,
                                    y: p.y
                                },
                                timeStamp: n.now()
                            });
                            l = function(t1, e, n, r, i) {
                                var o = t1.interactions.new({
                                    pointerType: "reflow"
                                }), a = {
                                    interaction: o,
                                    event: i,
                                    pointer: i,
                                    eventTarget: n,
                                    phase: "reflow"
                                };
                                o.interactable = e, o.element = n, o.prevEvent = i, o.updatePointer(i, i, n, !0), nt(o.coords.delta), Ut(o.prepared, r), o._doPhase(a);
                                var s = t1.window, c = s.Promise, l = c ? new c(function(t1) {
                                    o._reflowResolve = t1;
                                }) : void 0;
                                o._reflowPromise = l, o.start(r, e, n), o._interacting ? (o.move(a), o.end(i)) : (o.stop(), o._reflowResolve());
                                return o.removePointer(i, i), l;
                            }(n, t1, a, e, f);
                        }
                        o && o.push(l);
                    }, s = 0; s < r.length && !a(); s++);
                    return o && i.all(o).then(function() {
                        return t1;
                    });
                }(this, e, t1);
            };
        },
        listeners: {
            "interactions:stop": function(t1, e) {
                var n = t1.interaction;
                "reflow" === n.pointerType && (n._reflowResolve && n._reflowResolve(), function(t1, e) {
                    t1.splice(t1.indexOf(e), 1);
                }(e.interactions.list, n));
            }
        }
    }, er = tr;
    if (un.use(he), un.use(Ce), un.use(Zn), un.use(qe), un.use(Ln), un.use(pe), un.use(Xt), un.use(Gt), un.use(er), un.default = un, "object" === n(module) && module) try {
        module.exports = un;
    } catch (t1) {}
    return un.default = un, un;
});

});

parcelRegister("ftuQo", function(module, exports) {

$parcel$export(module.exports, "loadGeneData", () => $b4417d6990619992$export$ecab240cd5ae5335);
$parcel$export(module.exports, "annotateAllNodes", () => $b4417d6990619992$export$b8b9b678724a585d);
$parcel$export(module.exports, "renderGeneAnnotations", () => $b4417d6990619992$export$55b0045b65d750a3);
$parcel$export(module.exports, "initGeneAnnotation", () => $b4417d6990619992$export$4fa9aaf818b81efc);

var $e4ypD = parcelRequire("e4ypD");

var $2UrZ2 = parcelRequire("2UrZ2");

var $5qD1E = parcelRequire("5qD1E");

// Hard-code the path to the asset for development purposes
// Define the path to the gene data file
const $b4417d6990619992$var$geneDataUrl = new URL((parcelRequire("a56V2"))).href;
// In-memory gene database
let $b4417d6990619992$var$geneDatabase = [];
let $b4417d6990619992$var$isGeneDataLoaded = false;
let $b4417d6990619992$var$isLoading = false;
let $b4417d6990619992$var$assetLoadingAttempted = false;
// Chromosome-indexed gene lookup for efficient queries.
// Map<string, Gene[]> where each Gene[] is sorted by gene.start ascending.
let $b4417d6990619992$var$geneIndex = new Map();
// Prefix-max-end arrays for each chromosome, enabling O(log N) lower-bound
// search in findOverlappingGenes(). prefixMaxEnd[i] = max(genes[0].end, ..., genes[i].end).
// Since genes are sorted by start, prefixMaxEnd is monotonically non-decreasing.
let $b4417d6990619992$var$genePrefixMaxEnd = new Map();
/**
 * Normalize chromosome name to always have "chr" prefix.
 * @param {string} chrom - Chromosome name (e.g., "1", "chr1")
 * @returns {string} - Normalized chromosome name (e.g., "chr1")
 */ function $b4417d6990619992$var$normalizeChrom(chrom) {
    return chrom.startsWith("chr") ? chrom : `chr${chrom}`;
}
/**
 * Build the chromosome-indexed gene lookup from the gene database.
 * Groups genes by normalized chromosome, sorts each group by start position,
 * and precomputes a prefixMaxEnd array for efficient lower-bound queries.
 *
 * prefixMaxEnd[i] = max(genes[0].end, ..., genes[i].end)
 * This is monotonically non-decreasing and allows binary search to find
 * the first gene index where any gene at or before that index could overlap
 * a query region [start, end].
 *
 * @param {Array<Gene>} genes - Array of Gene objects
 */ function $b4417d6990619992$var$buildGeneIndex(genes) {
    $b4417d6990619992$var$geneIndex.clear();
    $b4417d6990619992$var$genePrefixMaxEnd.clear();
    for (const gene of genes){
        const chrom = $b4417d6990619992$var$normalizeChrom(gene.chromosome);
        if (!$b4417d6990619992$var$geneIndex.has(chrom)) $b4417d6990619992$var$geneIndex.set(chrom, []);
        $b4417d6990619992$var$geneIndex.get(chrom).push(gene);
    }
    // Sort each chromosome's genes by start position, then build prefixMaxEnd
    for (const [chrom, chromGenes] of $b4417d6990619992$var$geneIndex.entries()){
        chromGenes.sort((a, b)=>a.start - b.start);
        // Build prefix-max-end array: prefixMaxEnd[i] = max(genes[0..i].end)
        const pme = new Array(chromGenes.length);
        let maxEnd = 0;
        for(let i = 0; i < chromGenes.length; i++){
            maxEnd = Math.max(maxEnd, chromGenes[i].end);
            pme[i] = maxEnd;
        }
        $b4417d6990619992$var$genePrefixMaxEnd.set(chrom, pme);
    }
    console.log(`Built gene index: ${$b4417d6990619992$var$geneIndex.size} chromosomes, ${genes.length} genes`);
}
/**
 * Parse an exon string into a sorted array of {start, end} intervals.
 * Handles formats: "[start-end,start-end,...]" or "start-end,start-end,..."
 * @param {string} exonsStr - Exon intervals string
 * @returns {Array<{start: number, end: number}>} - Sorted array of exon intervals
 */ function $b4417d6990619992$var$parseExonString(exonsStr) {
    if (!exonsStr || typeof exonsStr !== "string") return [];
    const cleaned = exonsStr.replace(/^\[|\]$/g, "").trim();
    if (!cleaned) return [];
    const parts = cleaned.split(",");
    const exons = [];
    for (const part of parts){
        const [startStr, endStr] = part.split("-");
        const start = parseInt(startStr);
        const end = parseInt(endStr);
        if (!isNaN(start) && !isNaN(end)) exons.push({
            start: start,
            end: end
        });
    }
    exons.sort((a, b)=>a.start - b.start);
    return exons;
}
/**
 * Gene class to represent a gene annotation
 */ class $b4417d6990619992$var$Gene {
    /**
   * @param {string} geneId - Gene identifier (e.g., "ENSG00000186092")
   * @param {string} chromosome - Chromosome (e.g., "chr1")
   * @param {number|string} start - Gene start position
   * @param {number|string} end - Gene end position
   * @param {string} strand - Strand ("+" or "-")
   * @param {string} geneName - Gene symbol (e.g., "OR4F5")
   * @param {Array<{start: number, end: number}>|null} exons - Merged exon intervals,
   *   sorted by start. If null, defaults to the gene span as a single interval.
   */ constructor(geneId, chromosome, start, end, strand, geneName, exons = null){
        this.geneId = geneId;
        this.chromosome = chromosome;
        this.start = parseInt(start);
        this.end = parseInt(end);
        this.strand = strand;
        this.geneName = geneName;
        // If exon data provided, use it; otherwise fall back to gene span as single interval
        this.exons = exons && exons.length > 0 ? exons : [
            {
                start: this.start,
                end: this.end
            }
        ];
    }
    /**
   * Check if this gene's span overlaps with given genomic coordinates.
   * Used as a fast pre-filter before exon-level checks.
   */ overlaps(chrom, start, end) {
        return this.chromosome === chrom && this.start <= end && this.end >= start;
    }
    /**
   * Check if any of this gene's exons overlap with any of the given node exon intervals.
   * Uses a two-pointer merge scan — O(E_g + E_n) where both arrays are sorted by start.
   * @param {Array<{start: number, end: number}>} nodeExons - Sorted node exon intervals
   * @returns {boolean} - True if at least one gene exon overlaps a node exon
   */ overlapsExons(nodeExons) {
        if (!nodeExons || nodeExons.length === 0) return false;
        let gi = 0;
        let ni = 0;
        while(gi < this.exons.length && ni < nodeExons.length){
            const ge = this.exons[gi];
            const ne = nodeExons[ni];
            if (ge.start <= ne.end && ge.end >= ne.start) return true; // Found overlap, early exit
            // Advance the pointer with the smaller end position
            if (ge.end < ne.end) gi++;
            else ni++;
        }
        return false;
    }
    /**
   * Calculate the exon-level overlap percentage: total bases of node exons
   * overlapping gene exons, divided by total node exon bases.
   * Uses a two-pointer merge scan — O(E_g + E_n).
   * @param {Array<{start: number, end: number}>} nodeExons - Sorted node exon intervals
   * @returns {number} - Overlap percentage (0-100)
   */ calculateExonOverlapPercentage(nodeExons) {
        if (!nodeExons || nodeExons.length === 0) return 0;
        let totalNodeBases = 0;
        for (const ne of nodeExons)totalNodeBases += ne.end - ne.start + 1;
        if (totalNodeBases === 0) return 0;
        let overlapBases = 0;
        let gi = 0;
        let ni = 0;
        while(gi < this.exons.length && ni < nodeExons.length){
            const ge = this.exons[gi];
            const ne = nodeExons[ni];
            if (ge.start <= ne.end && ge.end >= ne.start) overlapBases += Math.min(ge.end, ne.end) - Math.max(ge.start, ne.start) + 1;
            // Advance the pointer with the smaller end position
            if (ge.end < ne.end) gi++;
            else ni++;
        }
        return overlapBases / totalNodeBases * 100;
    }
    /**
   * Calculate the span-level overlap percentage with given genomic coordinates.
   * Kept for backward compatibility with files lacking exon data.
   * @param {number} start - Region start
   * @param {number} end - Region end
   * @returns {number} Overlap percentage (0-100)
   */ calculateOverlapPercentage(start, end) {
        const overlapStart = Math.max(this.start, start);
        const overlapEnd = Math.min(this.end, end);
        const overlapLength = Math.max(0, overlapEnd - overlapStart + 1);
        const regionLength = end - start + 1;
        return overlapLength / regionLength * 100;
    }
    /**
   * Return a human-readable representation of this gene
   */ toString() {
        return `${this.geneName} (${this.geneId}): ${this.chromosome}:${this.start}-${this.end} ${this.strand} [${this.exons.length} exons]`;
    }
}
/**
 * Parse gene data from text format
 * @param {string} text - Tab-delimited gene data
 * @returns {Array<Gene>} - Array of parsed genes
 */ function $b4417d6990619992$var$parseGeneData(text) {
    console.log(`Parsing gene data (${text.length} characters)...`);
    const genes = [];
    try {
        // Split by newlines and process each line
        const lines = text.split(/\r?\n/);
        console.log(`Processing ${lines.length} lines from gene data`);
        // Find first line that looks like valid data or header
        let headerFound = false;
        for(let i = 0; i < lines.length; i++){
            const line = lines[i].trim();
            // Skip empty lines or comment lines
            if (!line || line.startsWith("//") || line.startsWith("#")) continue;
            // Split by tabs or multiple spaces
            const fields = line.split(/\t+|\s{2,}/g).filter((field)=>field.trim().length > 0);
            if (fields.length < 5) continue; // Need at least 5 fields for minimal gene info
            // Check if this is a header line
            if (!headerFound && fields.some((f)=>f.toLowerCase().includes("gene") || f.toLowerCase() === "chrom" || f.toLowerCase().includes("chromosome"))) {
                console.log("Found header line:", fields);
                headerFound = true;
                continue;
            }
            // If we're here, we have a data line
            // Determine field positions
            let geneId, chromosome, start, end, strand, geneName, exonsField;
            if (fields.length >= 7) // New format with exons: gene_id chromosome start end strand gene_name exons
            [geneId, chromosome, start, end, strand, geneName, exonsField] = fields;
            else if (fields.length >= 6) // Standard format: gene_id chromosome start end strand gene_name
            [geneId, chromosome, start, end, strand, geneName] = fields;
            else if (fields.length === 5) {
                // Alternative format: gene_name chromosome start end strand
                [geneName, chromosome, start, end, strand] = fields;
                geneId = geneName; // Use gene name as ID
            } else {
                console.warn(`Skipping line with invalid field count: ${fields.length}`, fields);
                continue;
            }
            // Clean up all fields
            geneId = geneId.trim();
            chromosome = chromosome.trim();
            start = start.trim();
            end = end.trim();
            strand = strand.trim();
            geneName = (geneName || geneId).trim();
            // Convert start/end to integers and validate
            const startNum = parseInt(start);
            const endNum = parseInt(end);
            if (isNaN(startNum) || isNaN(endNum)) {
                console.warn(`Skipping gene with invalid coordinates: ${start}, ${end}`);
                continue;
            }
            // Parse exon intervals if present (7th column)
            const exons = exonsField ? $b4417d6990619992$var$parseExonString(exonsField) : null;
            // Create and add gene
            genes.push(new $b4417d6990619992$var$Gene(geneId, chromosome, startNum, endNum, strand, geneName, exons));
            if (genes.length % 1000 === 0) console.log(`Parsed ${genes.length} genes so far...`);
        }
        console.log(`Successfully parsed ${genes.length} genes`);
        // Build the chromosome index for efficient lookups
        if (genes.length > 0) $b4417d6990619992$var$buildGeneIndex(genes);
    } catch (error) {
        console.error("Error parsing gene data:", error);
    }
    return genes;
}
async function $b4417d6990619992$export$ecab240cd5ae5335() {
    if ($b4417d6990619992$var$isLoading) {
        console.log("Gene data loading already in progress...");
        return false;
    }
    if ($b4417d6990619992$var$isGeneDataLoaded && $b4417d6990619992$var$geneDatabase.length > 0) {
        console.log("Gene data already loaded with", $b4417d6990619992$var$geneDatabase.length, "genes");
        return true;
    }
    $b4417d6990619992$var$isLoading = true;
    console.log("Starting gene data loading process...");
    try {
        // Show loading indicator
        $b4417d6990619992$var$updateAnnotationStatus("Loading gene annotations...");
        // Priority 1: Try to load genes.txt from assets directory
        if (!$b4417d6990619992$var$assetLoadingAttempted) {
            $b4417d6990619992$var$assetLoadingAttempted = true;
            try {
                console.log(`Attempting to load gene data from ${$b4417d6990619992$var$geneDataUrl}`);
                const assetResponse = await fetch($b4417d6990619992$var$geneDataUrl);
                if (assetResponse.ok) {
                    const geneText = await assetResponse.text();
                    if (geneText && geneText.length > 0) {
                        const genes = $b4417d6990619992$var$parseGeneData(geneText);
                        if (genes && genes.length > 0) {
                            console.log(`Loaded ${genes.length} genes from asset file`);
                            $b4417d6990619992$var$geneDatabase = genes;
                            $b4417d6990619992$var$isGeneDataLoaded = true;
                            $b4417d6990619992$var$updateAnnotationStatus(`Loaded ${genes.length} genes from asset file`, 3000);
                            return true;
                        }
                    }
                } else console.warn("Could not load gene.txt from assets:", assetResponse.statusText);
            } catch (assetError) {
                console.warn("Error loading gene data from asset:", assetError);
            }
        }
        // Priority 3: Use fallback data
        if ($b4417d6990619992$var$geneDatabase.length === 0) {
            console.log("Using fallback gene data");
            $b4417d6990619992$var$geneDatabase = $b4417d6990619992$var$getFallbackGeneData();
            $b4417d6990619992$var$isGeneDataLoaded = true;
            $b4417d6990619992$var$updateAnnotationStatus(`Using ${$b4417d6990619992$var$geneDatabase.length} fallback gene annotations`, 3000);
        }
        return $b4417d6990619992$var$isGeneDataLoaded && $b4417d6990619992$var$geneDatabase.length > 0;
    } catch (error) {
        console.error("Error in gene data loading process:", error);
        $b4417d6990619992$var$updateAnnotationStatus(`Error loading gene annotations: ${error.message}`, 0, true);
        // Make sure we have fallback data
        if ($b4417d6990619992$var$geneDatabase.length === 0) {
            $b4417d6990619992$var$geneDatabase = $b4417d6990619992$var$getFallbackGeneData();
            $b4417d6990619992$var$isGeneDataLoaded = $b4417d6990619992$var$geneDatabase.length > 0;
            if ($b4417d6990619992$var$isGeneDataLoaded) $b4417d6990619992$var$updateAnnotationStatus(`Using ${$b4417d6990619992$var$geneDatabase.length} fallback gene annotations`, 3000);
        }
        return $b4417d6990619992$var$isGeneDataLoaded && $b4417d6990619992$var$geneDatabase.length > 0;
    } finally{
        $b4417d6990619992$var$isLoading = false;
    }
}
// Fallback data in case loading from file fails (protein-coding genes with exons)
function $b4417d6990619992$var$getFallbackGeneData() {
    const fallbackData = [
        // Format: [geneId, chromosome, start, end, strand, geneName, exonsString]
        [
            "ENSG00000186092",
            "chr1",
            65419,
            71585,
            "+",
            "OR4F5",
            "65419-65433,65520-65573,69037-71585"
        ],
        [
            "ENSG00000187634",
            "chr1",
            923923,
            944574,
            "+",
            "SAMD11",
            "923923-924948,925731-925800,925922-926013,930155-930336,931039-931089,935772-935896,939040-939129,939272-939460,941144-941306,942136-942251,942410-942488,942559-943058,943253-943377,943698-943808,943893-944574"
        ],
        [
            "ENSG00000188976",
            "chr1",
            943527,
            960714,
            "-",
            "NOC2L",
            "943527-944800,945042-945146,945518-945653,946173-946286,946402-946545,946757-946972,948059-948232,948490-948603,951127-951238,952000-952139,952412-952600,952877-952945,953169-953288,953782-953934,954004-954184,954464-954523,955412-955477,955638-955706,955923-956028,956095-956215,956894-957043,957099-957273,958929-959081,959215-960714"
        ],
        [
            "ENSG00000187961",
            "chr1",
            960576,
            965719,
            "+",
            "KLHL17",
            "960576-960800,961293-961552,961629-961750,961826-962047,962286-962471,962704-962917,963032-963253,963337-963504,963857-964008,964107-964180,964349-964530,964963-965719"
        ],
        [
            "ENSG00000167034",
            "chr8",
            23678697,
            23682938,
            "-",
            "NKX3-1",
            "23678697-23681639,23682604-23682938"
        ],
        [
            "ENSG00000167653",
            "chr8",
            142674358,
            142682725,
            "+",
            "PSCA",
            "142674358-142676236,142680395-142680563,142681327-142681770,142681921-142682725"
        ]
    ];
    const genes = fallbackData.map(([geneId, chromosome, start, end, strand, geneName, exonsStr])=>new $b4417d6990619992$var$Gene(geneId, chromosome, start, end, strand, geneName, $b4417d6990619992$var$parseExonString(exonsStr)));
    // Build the index for the fallback data too
    $b4417d6990619992$var$buildGeneIndex(genes);
    return genes;
}
function $b4417d6990619992$export$3bfd859989d47e7b(chrom, start, end, strand = null) {
    if (!$b4417d6990619992$var$isGeneDataLoaded) {
        console.warn("Gene data not loaded yet. Call loadGeneData first.");
        return [];
    }
    const chromNorm = $b4417d6990619992$var$normalizeChrom(chrom);
    const genes = $b4417d6990619992$var$geneIndex.get(chromNorm);
    if (!genes || genes.length === 0) return [];
    const pme = $b4417d6990619992$var$genePrefixMaxEnd.get(chromNorm);
    // Binary search upper bound: first index where gene.start > end.
    // All genes at index >= upper start after the query end — can't overlap.
    let lo = 0;
    let hi = genes.length;
    while(lo < hi){
        const mid = lo + hi >> 1;
        if (genes[mid].start > end) hi = mid;
        else lo = mid + 1;
    }
    const upper = lo;
    // Binary search lower bound using prefixMaxEnd: first index where
    // prefixMaxEnd[i] >= start. All genes before this index have end < start
    // (and so do all genes before them), so they can't overlap.
    let lower = 0;
    if (pme) {
        lo = 0;
        hi = upper; // only search within [0, upper)
        while(lo < hi){
            const mid = lo + hi >> 1;
            if (pme[mid] < start) lo = mid + 1;
            else hi = mid;
        }
        lower = lo;
    }
    // Scan only genes[lower..upper-1] and collect those where gene.end >= start
    const results = [];
    for(let i = lower; i < upper; i++){
        const gene = genes[i];
        if (gene.end >= start) {
            if (!strand || gene.strand === strand) results.push(gene);
        }
    }
    return results;
}
function $b4417d6990619992$export$dff9b6effaaf4b19(node) {
    if (!node || !$b4417d6990619992$var$isGeneDataLoaded) return node;
    const nodeData = node.data();
    const chrom = nodeData.chrom;
    const start = parseInt(nodeData.ref_start);
    const end = parseInt(nodeData.ref_end);
    const strand = nodeData.strand || "+";
    if (!chrom || isNaN(start) || isNaN(end)) // Node doesn't have genomic coordinates
    return node;
    // Parse node's exon intervals (if available)
    const nodeExons = $b4417d6990619992$var$parseExonString(nodeData.exons);
    const hasExonData = nodeExons.length > 0;
    // Step 1: Find span-level candidate genes (fast, uses chromosome index + binary search)
    const candidateGenes = $b4417d6990619992$export$3bfd859989d47e7b(chrom, start, end, strand);
    // Step 2: Filter to genes with actual exon-level overlap
    let overlappingGenes;
    if (hasExonData) overlappingGenes = candidateGenes.filter((gene)=>gene.overlapsExons(nodeExons));
    else // No node exon data — use all span-level candidates (backward compat)
    overlappingGenes = candidateGenes;
    // Step 3: Sort by exon overlap percentage (or span overlap as fallback)
    if (hasExonData) overlappingGenes.sort((a, b)=>b.calculateExonOverlapPercentage(nodeExons) - a.calculateExonOverlapPercentage(nodeExons));
    else overlappingGenes.sort((a, b)=>b.calculateOverlapPercentage(start, end) - a.calculateOverlapPercentage(start, end));
    if (overlappingGenes.length > 0) {
        // Add the gene annotations to the node data
        node.data("geneAnnotations", overlappingGenes.map((gene)=>{
            const overlapPct = hasExonData ? gene.calculateExonOverlapPercentage(nodeExons) : gene.calculateOverlapPercentage(start, end);
            return {
                geneId: gene.geneId,
                geneName: gene.geneName,
                strand: gene.strand,
                start: gene.start,
                end: gene.end,
                exonCount: gene.exons.length,
                overlapPercentage: overlapPct.toFixed(1)
            };
        }));
        // Add the first gene name as a node label, but avoid overwriting an existing label
        const primaryGene = overlappingGenes[0];
        const existingGeneName = nodeData.gene_name;
        if (existingGeneName == null || existingGeneName === node.id()) node.data("gene_name", primaryGene.geneName);
    }
    return node;
}
async function $b4417d6990619992$export$b8b9b678724a585d(cy) {
    if (!cy) {
        console.error("No cytosscape instance provided");
        return 0;
    }
    if (!$b4417d6990619992$var$isGeneDataLoaded) {
        const loaded = await $b4417d6990619992$export$ecab240cd5ae5335();
        if (!loaded) {
            $b4417d6990619992$var$updateAnnotationStatus("Failed to load gene data", 3000, true);
            return 0;
        }
    }
    let annotatedCount = 0;
    let nodesWithCoords = 0;
    cy.nodes().forEach((node)=>{
        const nodeData = node.data();
        if (nodeData.chrom && nodeData.ref_start && nodeData.ref_end) {
            nodesWithCoords++;
            const beforeAnnotation = node.data("geneAnnotations") ? node.data("geneAnnotations").length : 0;
            $b4417d6990619992$export$dff9b6effaaf4b19(node);
            const afterAnnotation = node.data("geneAnnotations") ? node.data("geneAnnotations").length : 0;
            if (afterAnnotation > beforeAnnotation) annotatedCount++;
        }
    });
    // Update node styles to show gene names if they've been annotated
    if (annotatedCount > 0) {
        console.log(`Annotated ${annotatedCount} nodes out of ${nodesWithCoords} with genomic coordinates`);
        $b4417d6990619992$var$updateAnnotationStatus(`Annotated ${annotatedCount} nodes with gene names`, 3000);
        // If any node was updated, refresh the current view
        if ((0, $5qD1E.STATE).cy) (0, $5qD1E.STATE).cy.style().update();
    } else $b4417d6990619992$var$updateAnnotationStatus(`No nodes could be annotated (${nodesWithCoords} nodes had coordinates)`, 3000);
    return annotatedCount;
}
function $b4417d6990619992$export$55b0045b65d750a3(node, container) {
    if (!node || !container) return;
    const geneAnnotations = node.data("geneAnnotations") || [];
    if (!geneAnnotations || geneAnnotations.length === 0) {
        // If no annotations but node has genomic coordinates, show option to annotate
        const nodeData = node.data();
        if (nodeData && nodeData.chrom && nodeData.ref_start && nodeData.ref_end) {
            const noAnnotationsDiv = document.createElement("div");
            noAnnotationsDiv.className = "card mb-3";
            noAnnotationsDiv.innerHTML = `
        <div class="card-header bg-light">
          <strong>Gene Annotations</strong>
        </div>
        <div class="card-body text-center p-4">
          <p class="mb-2">No gene annotations available for this node.</p>
          <button id="annotateNodeBtn" class="btn btn-sm btn-primary">
            <i class="fas fa-dna me-1"></i> Annotate Node
          </button>
        </div>
      `;
            container.appendChild(noAnnotationsDiv);
            // Add event listener to annotate button
            setTimeout(()=>{
                const annotateBtn = document.getElementById("annotateNodeBtn");
                if (annotateBtn) annotateBtn.addEventListener("click", async ()=>{
                    if (!$b4417d6990619992$var$isGeneDataLoaded) await $b4417d6990619992$export$ecab240cd5ae5335();
                    if ($b4417d6990619992$var$isGeneDataLoaded) {
                        $b4417d6990619992$export$dff9b6effaaf4b19(node);
                        // Re-render the node info to show the annotations
                        const infoContent = document.getElementById("infoContent");
                        if (infoContent) {
                            infoContent.innerHTML = "";
                            (0, $2UrZ2.displayElementInfo)(node, infoContent);
                        }
                    }
                });
            }, 0);
            return;
        }
        return;
    }
    const geneSection = document.createElement("div");
    geneSection.className = "card mb-3";
    geneSection.innerHTML = `
    <div class="card-header bg-light d-flex justify-content-between align-items-center">
      <strong>Gene Annotations</strong>
      <span class="badge bg-primary">${geneAnnotations.length}</span>
    </div>
    <div class="card-body p-0">
      <div class="table-responsive">
        <table class="table table-hover table-striped mb-0">
          <thead>
            <tr>
              <th>Gene</th>
              <th>Location</th>
              <th>Strand</th>
              <th>Exons</th>
              <th>Overlap</th>
            </tr>
          </thead>
          <tbody>
            ${geneAnnotations.map((gene)=>`
              <tr>
                <td>
                  <a href="https://www.ncbi.nlm.nih.gov/gene/?term=${gene.geneName}"
                     target="_blank" class="text-decoration-none">
                    ${gene.geneName}
                    <i class="bi bi-box-arrow-up-right text-muted small ms-1"></i>
                  </a>
                  <div class="small text-muted">${gene.geneId}</div>
                </td>
                <td class="small">
                  ${gene.start?.toLocaleString()}-${gene.end?.toLocaleString()}
                </td>
                <td>${gene.strand}</td>
                <td class="text-center">${gene.exonCount || "-"}</td>
                <td>
                  <div class="progress" style="height: 5px;">
                    <div class="progress-bar" role="progressbar"
                         style="width: ${gene.overlapPercentage}%;"
                         aria-valuenow="${gene.overlapPercentage}"
                         aria-valuemin="0" aria-valuemax="100">
                    </div>
                  </div>
                  <small>${gene.overlapPercentage}%</small>
                </td>
              </tr>
            `).join("")}
          </tbody>
        </table>
      </div>
    </div>
  `;
    container.appendChild(geneSection);
}
/**
 * Update annotation status display using the alert utility
 * @param {string} message - Message to display
 * @param {number} timeout - Time in ms before fading out (0 for no fade)
 * @param {boolean} isError - Whether this is an error message
 */ function $b4417d6990619992$var$updateAnnotationStatus(message, timeout = 0, isError = false) {
    // Use the global showAlert function instead of imported one
    const alertType = isError ? "error" : "info";
    // Check if showAlert is available globally and use it
    if (typeof window.showAlert === "function") window.showAlert(message, alertType, timeout);
    else {
        // Fallback if showAlert is not available
        console.log(`[${alertType}] ${message}`);
        let statusDiv = document.getElementById("annotationStatus");
        if (!statusDiv) {
            statusDiv = document.createElement("div");
            statusDiv.id = "annotationStatus";
            document.body.appendChild(statusDiv);
        }
        statusDiv.textContent = message;
        statusDiv.className = isError ? "error" : "";
        statusDiv.classList.remove("d-none", "fade-out");
        if (timeout > 0) setTimeout(()=>{
            statusDiv.classList.add("fade-out");
            setTimeout(()=>{
                statusDiv.classList.add("d-none");
                statusDiv.classList.remove("fade-out");
            }, 1000);
        }, timeout);
    }
}
/**
 * Add CSS styles for gene annotations
 */ function $b4417d6990619992$var$addGeneAnnotationStyles() {
    // Only add styles if our dedicated CSS file is not loaded
    if (document.getElementById("gene-annotation-styles") || document.querySelector('link[href*="gene-annotations.css"]')) return;
    // Fallback styles if external css is not loaded
    const style = document.createElement("style");
    style.id = "gene-annotation-styles";
    style.textContent = `
    #annotationStatus {
      position: fixed;
      bottom: 20px;
      left: 20px;
      background-color: rgba(0, 0, 0, 0.7);
      color: white;
      padding: 10px 20px;
      border-radius: 5px;
      z-index: 1000;
      transition: opacity 1s ease;
    }

    #annotationStatus.fade-out {
      opacity: 0;
    }

    #annotationStatus.error {
      background-color: rgba(220, 53, 69, 0.9);
    }

    .gene-file-input {
      display: none;
    }

    #uploadGeneLabel {
      cursor: pointer;
    }
  `;
    document.head.appendChild(style);
    console.log("Added fallback gene annotation styles");
}
/**
 * Read file contents as text
 * @param {File} file - File object to read
 * @returns {Promise<string>} - File contents as string
 */ function $b4417d6990619992$var$readFileContent(file) {
    return new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.onload = (event)=>{
            try {
                const content = event.target.result;
                // Check if it's gzipped (starts with magic numbers)
                if (file.name.endsWith(".gz") || $b4417d6990619992$var$isGzipped(content)) {
                    // Decompress gzipped content
                    const inflated = (0, $e4ypD.default).inflate(new Uint8Array(content), {
                        to: "string"
                    });
                    resolve(inflated);
                } else // Plain text
                resolve(new TextDecoder().decode(content));
            } catch (error) {
                reject(error);
            }
        };
        reader.onerror = ()=>{
            reject(new Error("Failed to read file"));
        };
        reader.readAsArrayBuffer(file);
    });
}
/**
 * Check if data is gzipped based on magic number
 * @param {ArrayBuffer} data - Data to check
 * @returns {boolean} - True if data is gzipped
 */ function $b4417d6990619992$var$isGzipped(data) {
    const header = new Uint8Array(data.slice(0, 2));
    return header[0] === 0x1f && header[1] === 0x8b;
}
function $b4417d6990619992$export$4fa9aaf818b81efc() {
    // Add styles
    $b4417d6990619992$var$addGeneAnnotationStyles();
    // Initialize event listeners once DOM is ready
    if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", $b4417d6990619992$var$setupGeneAnnotationListeners);
    else // DOM already ready, set up listeners now
    $b4417d6990619992$var$setupGeneAnnotationListeners();
    // Pre-load gene data in the background for faster annotation later
    setTimeout(()=>{
        console.log("Pre-loading gene data...");
        $b4417d6990619992$export$ecab240cd5ae5335().then((success)=>{
            if (success) console.log("Gene data pre-loaded successfully");
        }).catch((err)=>{
            console.warn("Gene pre-loading failed:", err);
        });
    }, 1000); // Wait 1 second after initialization to avoid competing with graph loading
}
/**
 * Set up event listeners for the annotation buttons in the modal
 */ function $b4417d6990619992$var$setupGeneAnnotationListeners() {
    console.log("Setting up gene annotation event listeners");
    // Annotate all nodes button
    const annotateAllBtn = document.getElementById("annotateAllNodesBtn");
    if (annotateAllBtn) {
        console.log("Found annotateAllNodesBtn, adding event listener");
        // Remove any existing listener to avoid duplicates
        annotateAllBtn.replaceWith(annotateAllBtn.cloneNode(true));
        const newAnnotateAllBtn = document.getElementById("annotateAllNodesBtn");
        // Add fresh event listener
        newAnnotateAllBtn.addEventListener("click", async ()=>{
            console.log("Annotate all nodes button clicked");
            newAnnotateAllBtn.disabled = true;
            newAnnotateAllBtn.innerHTML = '<i class="fas fa-spinner fa-spin me-1"></i> Annotating...';
            try {
                if (!$b4417d6990619992$var$isGeneDataLoaded) // Try to load default gene data first
                await $b4417d6990619992$export$ecab240cd5ae5335();
                if ($b4417d6990619992$var$isGeneDataLoaded) {
                    const cy = window.STATE?.cy;
                    if (cy) {
                        const count = await $b4417d6990619992$export$b8b9b678724a585d(cy);
                        // Show success message
                        if (count > 0) window.showAlert(`Successfully annotated ${count} nodes with gene information.`, "success", 3000);
                        else window.showAlert("No nodes could be annotated. Make sure nodes have genomic coordinates.", "info", 3000);
                        // Close modal
                        const modal = bootstrap.Modal.getInstance(document.getElementById("geneAnnotationModal"));
                        if (modal) modal.hide();
                    } else window.showAlert("No graph loaded", "warning", 3000);
                }
            } catch (err) {
                console.error("Error annotating nodes:", err);
                window.showAlert(`Error: ${err.message}`, "error", 4000);
            } finally{
                newAnnotateAllBtn.disabled = false;
                newAnnotateAllBtn.innerHTML = "Annotate All Nodes";
            }
        });
    }
    // Fixed gene file upload event handling
    const fileInput = document.getElementById("geneFileInput");
    const uploadBtn = document.getElementById("uploadGeneBtn");
    if (fileInput && uploadBtn) {
        console.log("Setting up gene file upload listeners");
        // Handle file selection
        fileInput.addEventListener("change", function() {
            console.log("File selected:", this.files.length > 0 ? this.files[0].name : "none");
            uploadBtn.disabled = this.files.length === 0;
        });
        // Handle upload button click
        uploadBtn.addEventListener("click", async ()=>{
            if (!fileInput || fileInput.files.length === 0) {
                console.warn("No file selected for upload");
                return;
            }
            console.log("Processing gene file upload");
            const file = fileInput.files[0];
            const progressBar = document.getElementById("geneUploadProgress");
            const progressIndicator = progressBar?.querySelector(".progress-bar");
            if (progressBar) progressBar.classList.remove("d-none");
            if (progressIndicator) {
                progressIndicator.style.width = "0%";
                progressIndicator.setAttribute("aria-valuenow", "0");
            }
            try {
                window.showAlert(`Reading gene file: ${file.name}`, "info");
                // Read file content
                const fileContent = await $b4417d6990619992$var$readFileContent(file);
                // Show 50% progress
                if (progressIndicator) {
                    progressIndicator.style.width = "50%";
                    progressIndicator.setAttribute("aria-valuenow", "50");
                }
                window.showAlert(`Parsing gene data from file...`, "info");
                // Parse the data
                const genes = $b4417d6990619992$var$parseGeneData(fileContent);
                if (genes && genes.length > 0) {
                    // Success - set gene database
                    $b4417d6990619992$var$geneDatabase = genes;
                    $b4417d6990619992$var$isGeneDataLoaded = true;
                    // Show 100% progress
                    if (progressIndicator) {
                        progressIndicator.style.width = "100%";
                        progressIndicator.setAttribute("aria-valuenow", "100");
                    }
                    window.showAlert(`Loaded ${genes.length} gene annotations from file`, "success", 3000);
                    // Close modal after short delay
                    setTimeout(()=>{
                        const modal = bootstrap.Modal.getInstance(document.getElementById("geneAnnotationModal"));
                        if (modal) modal.hide();
                    }, 1500);
                } else throw new Error("No genes found in file or invalid format");
            } catch (error) {
                console.error("Error processing gene file:", error);
                if (progressBar) progressBar.classList.add("d-none");
                window.showAlert(`Error processing gene file: ${error.message}`, "error", 5000);
            }
        });
    } else console.warn("Gene file input or upload button not found in the DOM");
    // Regular button in toolbar (annotation button)
    const geneAnnotationBtn = document.getElementById("geneAnnotationBtn");
    if (geneAnnotationBtn) console.log("Found gene annotation button");
}

});
parcelRegister("e4ypD", function(module, exports) {

$parcel$export(module.exports, "default", () => $2dd4f45c8894762f$export$2e2bcd8739ae039);
/*! pako 2.1.0 https://github.com/nodeca/pako @license (MIT AND Zlib) */ // (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
/* eslint-disable space-unary-ops */ /* Public constants ==========================================================*/ /* ===========================================================================*/ //const Z_FILTERED          = 1;
//const Z_HUFFMAN_ONLY      = 2;
//const Z_RLE               = 3;
const $2dd4f45c8894762f$var$Z_FIXED$1 = 4;
//const Z_DEFAULT_STRATEGY  = 0;
/* Possible values of the data_type field (though see inflate()) */ const $2dd4f45c8894762f$var$Z_BINARY = 0;
const $2dd4f45c8894762f$var$Z_TEXT = 1;
//const Z_ASCII             = 1; // = Z_TEXT
const $2dd4f45c8894762f$var$Z_UNKNOWN$1 = 2;
/*============================================================================*/ function $2dd4f45c8894762f$var$zero$1(buf) {
    let len = buf.length;
    while(--len >= 0)buf[len] = 0;
}
// From zutil.h
const $2dd4f45c8894762f$var$STORED_BLOCK = 0;
const $2dd4f45c8894762f$var$STATIC_TREES = 1;
const $2dd4f45c8894762f$var$DYN_TREES = 2;
/* The three kinds of block type */ const $2dd4f45c8894762f$var$MIN_MATCH$1 = 3;
const $2dd4f45c8894762f$var$MAX_MATCH$1 = 258;
/* The minimum and maximum match lengths */ // From deflate.h
/* ===========================================================================
 * Internal compression state.
 */ const $2dd4f45c8894762f$var$LENGTH_CODES$1 = 29;
/* number of length codes, not counting the special END_BLOCK code */ const $2dd4f45c8894762f$var$LITERALS$1 = 256;
/* number of literal bytes 0..255 */ const $2dd4f45c8894762f$var$L_CODES$1 = $2dd4f45c8894762f$var$LITERALS$1 + 1 + $2dd4f45c8894762f$var$LENGTH_CODES$1;
/* number of Literal or Length codes, including the END_BLOCK code */ const $2dd4f45c8894762f$var$D_CODES$1 = 30;
/* number of distance codes */ const $2dd4f45c8894762f$var$BL_CODES$1 = 19;
/* number of codes used to transfer the bit lengths */ const $2dd4f45c8894762f$var$HEAP_SIZE$1 = 2 * $2dd4f45c8894762f$var$L_CODES$1 + 1;
/* maximum heap size */ const $2dd4f45c8894762f$var$MAX_BITS$1 = 15;
/* All codes must not exceed MAX_BITS bits */ const $2dd4f45c8894762f$var$Buf_size = 16;
/* size of bit buffer in bi_buf */ /* ===========================================================================
 * Constants
 */ const $2dd4f45c8894762f$var$MAX_BL_BITS = 7;
/* Bit length codes must not exceed MAX_BL_BITS bits */ const $2dd4f45c8894762f$var$END_BLOCK = 256;
/* end of block literal code */ const $2dd4f45c8894762f$var$REP_3_6 = 16;
/* repeat previous bit length 3-6 times (2 bits of repeat count) */ const $2dd4f45c8894762f$var$REPZ_3_10 = 17;
/* repeat a zero length 3-10 times  (3 bits of repeat count) */ const $2dd4f45c8894762f$var$REPZ_11_138 = 18;
/* repeat a zero length 11-138 times  (7 bits of repeat count) */ /* eslint-disable comma-spacing,array-bracket-spacing */ const $2dd4f45c8894762f$var$extra_lbits = /* extra bits for each length code */ new Uint8Array([
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    3,
    3,
    3,
    3,
    4,
    4,
    4,
    4,
    5,
    5,
    5,
    5,
    0
]);
const $2dd4f45c8894762f$var$extra_dbits = /* extra bits for each distance code */ new Uint8Array([
    0,
    0,
    0,
    0,
    1,
    1,
    2,
    2,
    3,
    3,
    4,
    4,
    5,
    5,
    6,
    6,
    7,
    7,
    8,
    8,
    9,
    9,
    10,
    10,
    11,
    11,
    12,
    12,
    13,
    13
]);
const $2dd4f45c8894762f$var$extra_blbits = /* extra bits for each bit length code */ new Uint8Array([
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    3,
    7
]);
const $2dd4f45c8894762f$var$bl_order = new Uint8Array([
    16,
    17,
    18,
    0,
    8,
    7,
    9,
    6,
    10,
    5,
    11,
    4,
    12,
    3,
    13,
    2,
    14,
    1,
    15
]);
/* eslint-enable comma-spacing,array-bracket-spacing */ /* The lengths of the bit length codes are sent in order of decreasing
 * probability, to avoid transmitting the lengths for unused bit length codes.
 */ /* ===========================================================================
 * Local data. These are initialized only once.
 */ // We pre-fill arrays with 0 to avoid uninitialized gaps
const $2dd4f45c8894762f$var$DIST_CODE_LEN = 512; /* see definition of array dist_code below */ 
// !!!! Use flat array instead of structure, Freq = i*2, Len = i*2+1
const $2dd4f45c8894762f$var$static_ltree = new Array(($2dd4f45c8894762f$var$L_CODES$1 + 2) * 2);
$2dd4f45c8894762f$var$zero$1($2dd4f45c8894762f$var$static_ltree);
/* The static literal tree. Since the bit lengths are imposed, there is no
 * need for the L_CODES extra codes used during heap construction. However
 * The codes 286 and 287 are needed to build a canonical tree (see _tr_init
 * below).
 */ const $2dd4f45c8894762f$var$static_dtree = new Array($2dd4f45c8894762f$var$D_CODES$1 * 2);
$2dd4f45c8894762f$var$zero$1($2dd4f45c8894762f$var$static_dtree);
/* The static distance tree. (Actually a trivial tree since all codes use
 * 5 bits.)
 */ const $2dd4f45c8894762f$var$_dist_code = new Array($2dd4f45c8894762f$var$DIST_CODE_LEN);
$2dd4f45c8894762f$var$zero$1($2dd4f45c8894762f$var$_dist_code);
/* Distance codes. The first 256 values correspond to the distances
 * 3 .. 258, the last 256 values correspond to the top 8 bits of
 * the 15 bit distances.
 */ const $2dd4f45c8894762f$var$_length_code = new Array($2dd4f45c8894762f$var$MAX_MATCH$1 - $2dd4f45c8894762f$var$MIN_MATCH$1 + 1);
$2dd4f45c8894762f$var$zero$1($2dd4f45c8894762f$var$_length_code);
/* length code for each normalized match length (0 == MIN_MATCH) */ const $2dd4f45c8894762f$var$base_length = new Array($2dd4f45c8894762f$var$LENGTH_CODES$1);
$2dd4f45c8894762f$var$zero$1($2dd4f45c8894762f$var$base_length);
/* First normalized length for each code (0 = MIN_MATCH) */ const $2dd4f45c8894762f$var$base_dist = new Array($2dd4f45c8894762f$var$D_CODES$1);
$2dd4f45c8894762f$var$zero$1($2dd4f45c8894762f$var$base_dist);
/* First normalized distance for each code (0 = distance of 1) */ function $2dd4f45c8894762f$var$StaticTreeDesc(static_tree, extra_bits, extra_base, elems, max_length) {
    this.static_tree = static_tree; /* static tree or NULL */ 
    this.extra_bits = extra_bits; /* extra bits for each code or NULL */ 
    this.extra_base = extra_base; /* base index for extra_bits */ 
    this.elems = elems; /* max number of elements in the tree */ 
    this.max_length = max_length; /* max bit length for the codes */ 
    // show if `static_tree` has data or dummy - needed for monomorphic objects
    this.has_stree = static_tree && static_tree.length;
}
let $2dd4f45c8894762f$var$static_l_desc;
let $2dd4f45c8894762f$var$static_d_desc;
let $2dd4f45c8894762f$var$static_bl_desc;
function $2dd4f45c8894762f$var$TreeDesc(dyn_tree, stat_desc) {
    this.dyn_tree = dyn_tree; /* the dynamic tree */ 
    this.max_code = 0; /* largest code with non zero frequency */ 
    this.stat_desc = stat_desc; /* the corresponding static tree */ 
}
const $2dd4f45c8894762f$var$d_code = (dist)=>{
    return dist < 256 ? $2dd4f45c8894762f$var$_dist_code[dist] : $2dd4f45c8894762f$var$_dist_code[256 + (dist >>> 7)];
};
/* ===========================================================================
 * Output a short LSB first on the stream.
 * IN assertion: there is enough room in pendingBuf.
 */ const $2dd4f45c8894762f$var$put_short = (s, w)=>{
    //    put_byte(s, (uch)((w) & 0xff));
    //    put_byte(s, (uch)((ush)(w) >> 8));
    s.pending_buf[s.pending++] = w & 0xff;
    s.pending_buf[s.pending++] = w >>> 8 & 0xff;
};
/* ===========================================================================
 * Send a value on a given number of bits.
 * IN assertion: length <= 16 and value fits in length bits.
 */ const $2dd4f45c8894762f$var$send_bits = (s, value, length)=>{
    if (s.bi_valid > $2dd4f45c8894762f$var$Buf_size - length) {
        s.bi_buf |= value << s.bi_valid & 0xffff;
        $2dd4f45c8894762f$var$put_short(s, s.bi_buf);
        s.bi_buf = value >> $2dd4f45c8894762f$var$Buf_size - s.bi_valid;
        s.bi_valid += length - $2dd4f45c8894762f$var$Buf_size;
    } else {
        s.bi_buf |= value << s.bi_valid & 0xffff;
        s.bi_valid += length;
    }
};
const $2dd4f45c8894762f$var$send_code = (s, c, tree)=>{
    $2dd4f45c8894762f$var$send_bits(s, tree[c * 2], tree[c * 2 + 1]);
};
/* ===========================================================================
 * Reverse the first len bits of a code, using straightforward code (a faster
 * method would use a table)
 * IN assertion: 1 <= len <= 15
 */ const $2dd4f45c8894762f$var$bi_reverse = (code, len)=>{
    let res = 0;
    do {
        res |= code & 1;
        code >>>= 1;
        res <<= 1;
    }while (--len > 0);
    return res >>> 1;
};
/* ===========================================================================
 * Flush the bit buffer, keeping at most 7 bits in it.
 */ const $2dd4f45c8894762f$var$bi_flush = (s)=>{
    if (s.bi_valid === 16) {
        $2dd4f45c8894762f$var$put_short(s, s.bi_buf);
        s.bi_buf = 0;
        s.bi_valid = 0;
    } else if (s.bi_valid >= 8) {
        s.pending_buf[s.pending++] = s.bi_buf & 0xff;
        s.bi_buf >>= 8;
        s.bi_valid -= 8;
    }
};
/* ===========================================================================
 * Compute the optimal bit lengths for a tree and update the total bit length
 * for the current block.
 * IN assertion: the fields freq and dad are set, heap[heap_max] and
 *    above are the tree nodes sorted by increasing frequency.
 * OUT assertions: the field len is set to the optimal bit length, the
 *     array bl_count contains the frequencies for each bit length.
 *     The length opt_len is updated; static_len is also updated if stree is
 *     not null.
 */ const $2dd4f45c8894762f$var$gen_bitlen = (s, desc)=>{
    //    deflate_state *s;
    //    tree_desc *desc;    /* the tree descriptor */
    const tree = desc.dyn_tree;
    const max_code = desc.max_code;
    const stree = desc.stat_desc.static_tree;
    const has_stree = desc.stat_desc.has_stree;
    const extra = desc.stat_desc.extra_bits;
    const base = desc.stat_desc.extra_base;
    const max_length = desc.stat_desc.max_length;
    let h; /* heap index */ 
    let n, m; /* iterate over the tree elements */ 
    let bits; /* bit length */ 
    let xbits; /* extra bits */ 
    let f; /* frequency */ 
    let overflow = 0; /* number of elements with bit length too large */ 
    for(bits = 0; bits <= $2dd4f45c8894762f$var$MAX_BITS$1; bits++)s.bl_count[bits] = 0;
    /* In a first pass, compute the optimal bit lengths (which may
   * overflow in the case of the bit length tree).
   */ tree[s.heap[s.heap_max] * 2 + 1] = 0; /* root of the heap */ 
    for(h = s.heap_max + 1; h < $2dd4f45c8894762f$var$HEAP_SIZE$1; h++){
        n = s.heap[h];
        bits = tree[tree[n * 2 + 1] * 2 + 1] + 1;
        if (bits > max_length) {
            bits = max_length;
            overflow++;
        }
        tree[n * 2 + 1] = bits;
        /* We overwrite tree[n].Dad which is no longer needed */ if (n > max_code) continue;
         /* not a leaf node */ 
        s.bl_count[bits]++;
        xbits = 0;
        if (n >= base) xbits = extra[n - base];
        f = tree[n * 2] /*.Freq*/ ;
        s.opt_len += f * (bits + xbits);
        if (has_stree) s.static_len += f * (stree[n * 2 + 1] + xbits);
    }
    if (overflow === 0) return;
    // Tracev((stderr,"\nbit length overflow\n"));
    /* This happens for example on obj2 and pic of the Calgary corpus */ /* Find the first bit length which could increase: */ do {
        bits = max_length - 1;
        while(s.bl_count[bits] === 0)bits--;
        s.bl_count[bits]--; /* move one leaf down the tree */ 
        s.bl_count[bits + 1] += 2; /* move one overflow item as its brother */ 
        s.bl_count[max_length]--;
        /* The brother of the overflow item also moves one step up,
     * but this does not affect bl_count[max_length]
     */ overflow -= 2;
    }while (overflow > 0);
    /* Now recompute all bit lengths, scanning in increasing frequency.
   * h is still equal to HEAP_SIZE. (It is simpler to reconstruct all
   * lengths instead of fixing only the wrong ones. This idea is taken
   * from 'ar' written by Haruhiko Okumura.)
   */ for(bits = max_length; bits !== 0; bits--){
        n = s.bl_count[bits];
        while(n !== 0){
            m = s.heap[--h];
            if (m > max_code) continue;
            if (tree[m * 2 + 1] !== bits) {
                // Tracev((stderr,"code %d bits %d->%d\n", m, tree[m].Len, bits));
                s.opt_len += (bits - tree[m * 2 + 1]) * tree[m * 2] /*.Freq*/ ;
                tree[m * 2 + 1] = bits;
            }
            n--;
        }
    }
};
/* ===========================================================================
 * Generate the codes for a given tree and bit counts (which need not be
 * optimal).
 * IN assertion: the array bl_count contains the bit length statistics for
 * the given tree and the field len is set for all tree elements.
 * OUT assertion: the field code is set for all tree elements of non
 *     zero code length.
 */ const $2dd4f45c8894762f$var$gen_codes = (tree, max_code, bl_count)=>{
    //    ct_data *tree;             /* the tree to decorate */
    //    int max_code;              /* largest code with non zero frequency */
    //    ushf *bl_count;            /* number of codes at each bit length */
    const next_code = new Array($2dd4f45c8894762f$var$MAX_BITS$1 + 1); /* next code value for each bit length */ 
    let code = 0; /* running code value */ 
    let bits; /* bit index */ 
    let n; /* code index */ 
    /* The distribution counts are first used to generate the code values
   * without bit reversal.
   */ for(bits = 1; bits <= $2dd4f45c8894762f$var$MAX_BITS$1; bits++){
        code = code + bl_count[bits - 1] << 1;
        next_code[bits] = code;
    }
    /* Check that the bit counts in bl_count are consistent. The last code
   * must be all ones.
   */ //Assert (code + bl_count[MAX_BITS]-1 == (1<<MAX_BITS)-1,
    //        "inconsistent bit counts");
    //Tracev((stderr,"\ngen_codes: max_code %d ", max_code));
    for(n = 0; n <= max_code; n++){
        let len = tree[n * 2 + 1] /*.Len*/ ;
        if (len === 0) continue;
        /* Now reverse the bits */ tree[n * 2] = $2dd4f45c8894762f$var$bi_reverse(next_code[len]++, len);
    //Tracecv(tree != static_ltree, (stderr,"\nn %3d %c l %2d c %4x (%x) ",
    //     n, (isgraph(n) ? n : ' '), len, tree[n].Code, next_code[len]-1));
    }
};
/* ===========================================================================
 * Initialize the various 'constant' tables.
 */ const $2dd4f45c8894762f$var$tr_static_init = ()=>{
    let n; /* iterates over tree elements */ 
    let bits; /* bit counter */ 
    let length; /* length value */ 
    let code; /* code value */ 
    let dist; /* distance index */ 
    const bl_count = new Array($2dd4f45c8894762f$var$MAX_BITS$1 + 1);
    /* number of codes at each bit length for an optimal tree */ // do check in _tr_init()
    //if (static_init_done) return;
    /* For some embedded targets, global variables are not initialized: */ /*#ifdef NO_INIT_GLOBAL_POINTERS
  static_l_desc.static_tree = static_ltree;
  static_l_desc.extra_bits = extra_lbits;
  static_d_desc.static_tree = static_dtree;
  static_d_desc.extra_bits = extra_dbits;
  static_bl_desc.extra_bits = extra_blbits;
#endif*/ /* Initialize the mapping length (0..255) -> length code (0..28) */ length = 0;
    for(code = 0; code < $2dd4f45c8894762f$var$LENGTH_CODES$1 - 1; code++){
        $2dd4f45c8894762f$var$base_length[code] = length;
        for(n = 0; n < 1 << $2dd4f45c8894762f$var$extra_lbits[code]; n++)$2dd4f45c8894762f$var$_length_code[length++] = code;
    }
    //Assert (length == 256, "tr_static_init: length != 256");
    /* Note that the length 255 (match length 258) can be represented
   * in two different ways: code 284 + 5 bits or code 285, so we
   * overwrite length_code[255] to use the best encoding:
   */ $2dd4f45c8894762f$var$_length_code[length - 1] = code;
    /* Initialize the mapping dist (0..32K) -> dist code (0..29) */ dist = 0;
    for(code = 0; code < 16; code++){
        $2dd4f45c8894762f$var$base_dist[code] = dist;
        for(n = 0; n < 1 << $2dd4f45c8894762f$var$extra_dbits[code]; n++)$2dd4f45c8894762f$var$_dist_code[dist++] = code;
    }
    //Assert (dist == 256, "tr_static_init: dist != 256");
    dist >>= 7; /* from now on, all distances are divided by 128 */ 
    for(; code < $2dd4f45c8894762f$var$D_CODES$1; code++){
        $2dd4f45c8894762f$var$base_dist[code] = dist << 7;
        for(n = 0; n < 1 << $2dd4f45c8894762f$var$extra_dbits[code] - 7; n++)$2dd4f45c8894762f$var$_dist_code[256 + dist++] = code;
    }
    //Assert (dist == 256, "tr_static_init: 256+dist != 512");
    /* Construct the codes of the static literal tree */ for(bits = 0; bits <= $2dd4f45c8894762f$var$MAX_BITS$1; bits++)bl_count[bits] = 0;
    n = 0;
    while(n <= 143){
        $2dd4f45c8894762f$var$static_ltree[n * 2 + 1] = 8;
        n++;
        bl_count[8]++;
    }
    while(n <= 255){
        $2dd4f45c8894762f$var$static_ltree[n * 2 + 1] = 9;
        n++;
        bl_count[9]++;
    }
    while(n <= 279){
        $2dd4f45c8894762f$var$static_ltree[n * 2 + 1] = 7;
        n++;
        bl_count[7]++;
    }
    while(n <= 287){
        $2dd4f45c8894762f$var$static_ltree[n * 2 + 1] = 8;
        n++;
        bl_count[8]++;
    }
    /* Codes 286 and 287 do not exist, but we must include them in the
   * tree construction to get a canonical Huffman tree (longest code
   * all ones)
   */ $2dd4f45c8894762f$var$gen_codes($2dd4f45c8894762f$var$static_ltree, $2dd4f45c8894762f$var$L_CODES$1 + 1, bl_count);
    /* The static distance tree is trivial: */ for(n = 0; n < $2dd4f45c8894762f$var$D_CODES$1; n++){
        $2dd4f45c8894762f$var$static_dtree[n * 2 + 1] = 5;
        $2dd4f45c8894762f$var$static_dtree[n * 2] = $2dd4f45c8894762f$var$bi_reverse(n, 5);
    }
    // Now data ready and we can init static trees
    $2dd4f45c8894762f$var$static_l_desc = new $2dd4f45c8894762f$var$StaticTreeDesc($2dd4f45c8894762f$var$static_ltree, $2dd4f45c8894762f$var$extra_lbits, $2dd4f45c8894762f$var$LITERALS$1 + 1, $2dd4f45c8894762f$var$L_CODES$1, $2dd4f45c8894762f$var$MAX_BITS$1);
    $2dd4f45c8894762f$var$static_d_desc = new $2dd4f45c8894762f$var$StaticTreeDesc($2dd4f45c8894762f$var$static_dtree, $2dd4f45c8894762f$var$extra_dbits, 0, $2dd4f45c8894762f$var$D_CODES$1, $2dd4f45c8894762f$var$MAX_BITS$1);
    $2dd4f45c8894762f$var$static_bl_desc = new $2dd4f45c8894762f$var$StaticTreeDesc(new Array(0), $2dd4f45c8894762f$var$extra_blbits, 0, $2dd4f45c8894762f$var$BL_CODES$1, $2dd4f45c8894762f$var$MAX_BL_BITS);
//static_init_done = true;
};
/* ===========================================================================
 * Initialize a new block.
 */ const $2dd4f45c8894762f$var$init_block = (s)=>{
    let n; /* iterates over tree elements */ 
    /* Initialize the trees. */ for(n = 0; n < $2dd4f45c8894762f$var$L_CODES$1; n++)s.dyn_ltree[n * 2] = 0;
    for(n = 0; n < $2dd4f45c8894762f$var$D_CODES$1; n++)s.dyn_dtree[n * 2] = 0;
    for(n = 0; n < $2dd4f45c8894762f$var$BL_CODES$1; n++)s.bl_tree[n * 2] = 0;
    s.dyn_ltree[$2dd4f45c8894762f$var$END_BLOCK * 2] = 1;
    s.opt_len = s.static_len = 0;
    s.sym_next = s.matches = 0;
};
/* ===========================================================================
 * Flush the bit buffer and align the output on a byte boundary
 */ const $2dd4f45c8894762f$var$bi_windup = (s)=>{
    if (s.bi_valid > 8) $2dd4f45c8894762f$var$put_short(s, s.bi_buf);
    else if (s.bi_valid > 0) //put_byte(s, (Byte)s->bi_buf);
    s.pending_buf[s.pending++] = s.bi_buf;
    s.bi_buf = 0;
    s.bi_valid = 0;
};
/* ===========================================================================
 * Compares to subtrees, using the tree depth as tie breaker when
 * the subtrees have equal frequency. This minimizes the worst case length.
 */ const $2dd4f45c8894762f$var$smaller = (tree, n, m, depth)=>{
    const _n2 = n * 2;
    const _m2 = m * 2;
    return tree[_n2] < tree[_m2] || tree[_n2] === tree[_m2] && depth[n] <= depth[m];
};
/* ===========================================================================
 * Restore the heap property by moving down the tree starting at node k,
 * exchanging a node with the smallest of its two sons if necessary, stopping
 * when the heap property is re-established (each father smaller than its
 * two sons).
 */ const $2dd4f45c8894762f$var$pqdownheap = (s, tree, k)=>{
    //    deflate_state *s;
    //    ct_data *tree;  /* the tree to restore */
    //    int k;               /* node to move down */
    const v = s.heap[k];
    let j = k << 1; /* left son of k */ 
    while(j <= s.heap_len){
        /* Set j to the smallest of the two sons: */ if (j < s.heap_len && $2dd4f45c8894762f$var$smaller(tree, s.heap[j + 1], s.heap[j], s.depth)) j++;
        /* Exit if v is smaller than both sons */ if ($2dd4f45c8894762f$var$smaller(tree, v, s.heap[j], s.depth)) break;
        /* Exchange v with the smallest son */ s.heap[k] = s.heap[j];
        k = j;
        /* And continue down the tree, setting j to the left son of k */ j <<= 1;
    }
    s.heap[k] = v;
};
// inlined manually
// const SMALLEST = 1;
/* ===========================================================================
 * Send the block data compressed using the given Huffman trees
 */ const $2dd4f45c8894762f$var$compress_block = (s, ltree, dtree)=>{
    //    deflate_state *s;
    //    const ct_data *ltree; /* literal tree */
    //    const ct_data *dtree; /* distance tree */
    let dist; /* distance of matched string */ 
    let lc; /* match length or unmatched char (if dist == 0) */ 
    let sx = 0; /* running index in sym_buf */ 
    let code; /* the code to send */ 
    let extra; /* number of extra bits to send */ 
    if (s.sym_next !== 0) do {
        dist = s.pending_buf[s.sym_buf + sx++] & 0xff;
        dist += (s.pending_buf[s.sym_buf + sx++] & 0xff) << 8;
        lc = s.pending_buf[s.sym_buf + sx++];
        if (dist === 0) $2dd4f45c8894762f$var$send_code(s, lc, ltree); /* send a literal byte */ 
        else {
            /* Here, lc is the match length - MIN_MATCH */ code = $2dd4f45c8894762f$var$_length_code[lc];
            $2dd4f45c8894762f$var$send_code(s, code + $2dd4f45c8894762f$var$LITERALS$1 + 1, ltree); /* send the length code */ 
            extra = $2dd4f45c8894762f$var$extra_lbits[code];
            if (extra !== 0) {
                lc -= $2dd4f45c8894762f$var$base_length[code];
                $2dd4f45c8894762f$var$send_bits(s, lc, extra); /* send the extra length bits */ 
            }
            dist--; /* dist is now the match distance - 1 */ 
            code = $2dd4f45c8894762f$var$d_code(dist);
            //Assert (code < D_CODES, "bad d_code");
            $2dd4f45c8894762f$var$send_code(s, code, dtree); /* send the distance code */ 
            extra = $2dd4f45c8894762f$var$extra_dbits[code];
            if (extra !== 0) {
                dist -= $2dd4f45c8894762f$var$base_dist[code];
                $2dd4f45c8894762f$var$send_bits(s, dist, extra); /* send the extra distance bits */ 
            }
        } /* literal or match pair ? */ 
    /* Check that the overlay between pending_buf and sym_buf is ok: */ //Assert(s->pending < s->lit_bufsize + sx, "pendingBuf overflow");
    }while (sx < s.sym_next);
    $2dd4f45c8894762f$var$send_code(s, $2dd4f45c8894762f$var$END_BLOCK, ltree);
};
/* ===========================================================================
 * Construct one Huffman tree and assigns the code bit strings and lengths.
 * Update the total bit length for the current block.
 * IN assertion: the field freq is set for all tree elements.
 * OUT assertions: the fields len and code are set to the optimal bit length
 *     and corresponding code. The length opt_len is updated; static_len is
 *     also updated if stree is not null. The field max_code is set.
 */ const $2dd4f45c8894762f$var$build_tree = (s, desc)=>{
    //    deflate_state *s;
    //    tree_desc *desc; /* the tree descriptor */
    const tree = desc.dyn_tree;
    const stree = desc.stat_desc.static_tree;
    const has_stree = desc.stat_desc.has_stree;
    const elems = desc.stat_desc.elems;
    let n, m; /* iterate over heap elements */ 
    let max_code = -1; /* largest code with non zero frequency */ 
    let node; /* new node being created */ 
    /* Construct the initial heap, with least frequent element in
   * heap[SMALLEST]. The sons of heap[n] are heap[2*n] and heap[2*n+1].
   * heap[0] is not used.
   */ s.heap_len = 0;
    s.heap_max = $2dd4f45c8894762f$var$HEAP_SIZE$1;
    for(n = 0; n < elems; n++)if (tree[n * 2] !== 0) {
        s.heap[++s.heap_len] = max_code = n;
        s.depth[n] = 0;
    } else tree[n * 2 + 1] = 0;
    /* The pkzip format requires that at least one distance code exists,
   * and that at least one bit should be sent even if there is only one
   * possible code. So to avoid special checks later on we force at least
   * two codes of non zero frequency.
   */ while(s.heap_len < 2){
        node = s.heap[++s.heap_len] = max_code < 2 ? ++max_code : 0;
        tree[node * 2] = 1;
        s.depth[node] = 0;
        s.opt_len--;
        if (has_stree) s.static_len -= stree[node * 2 + 1] /*.Len*/ ;
    /* node is 0 or 1 so it does not have extra bits */ }
    desc.max_code = max_code;
    /* The elements heap[heap_len/2+1 .. heap_len] are leaves of the tree,
   * establish sub-heaps of increasing lengths:
   */ for(n = s.heap_len >> 1 /*int /2*/ ; n >= 1; n--)$2dd4f45c8894762f$var$pqdownheap(s, tree, n);
    /* Construct the Huffman tree by repeatedly combining the least two
   * frequent nodes.
   */ node = elems; /* next internal node of the tree */ 
    do {
        //pqremove(s, tree, n);  /* n = node of least frequency */
        /*** pqremove ***/ n = s.heap[1 /*SMALLEST*/ ];
        s.heap[1 /*SMALLEST*/ ] = s.heap[s.heap_len--];
        $2dd4f45c8894762f$var$pqdownheap(s, tree, 1 /*SMALLEST*/ );
        /***/ m = s.heap[1 /*SMALLEST*/ ]; /* m = node of next least frequency */ 
        s.heap[--s.heap_max] = n; /* keep the nodes sorted by frequency */ 
        s.heap[--s.heap_max] = m;
        /* Create a new node father of n and m */ tree[node * 2] = tree[n * 2] + tree[m * 2] /*.Freq*/ ;
        s.depth[node] = (s.depth[n] >= s.depth[m] ? s.depth[n] : s.depth[m]) + 1;
        tree[n * 2 + 1] = tree[m * 2 + 1] = node;
        /* and insert the new node in the heap */ s.heap[1 /*SMALLEST*/ ] = node++;
        $2dd4f45c8894762f$var$pqdownheap(s, tree, 1 /*SMALLEST*/ );
    }while (s.heap_len >= 2);
    s.heap[--s.heap_max] = s.heap[1 /*SMALLEST*/ ];
    /* At this point, the fields freq and dad are set. We can now
   * generate the bit lengths.
   */ $2dd4f45c8894762f$var$gen_bitlen(s, desc);
    /* The field len is now set, we can generate the bit codes */ $2dd4f45c8894762f$var$gen_codes(tree, max_code, s.bl_count);
};
/* ===========================================================================
 * Scan a literal or distance tree to determine the frequencies of the codes
 * in the bit length tree.
 */ const $2dd4f45c8894762f$var$scan_tree = (s, tree, max_code)=>{
    //    deflate_state *s;
    //    ct_data *tree;   /* the tree to be scanned */
    //    int max_code;    /* and its largest code of non zero frequency */
    let n; /* iterates over all tree elements */ 
    let prevlen = -1; /* last emitted length */ 
    let curlen; /* length of current code */ 
    let nextlen = tree[1] /*.Len*/ ; /* length of next code */ 
    let count = 0; /* repeat count of the current code */ 
    let max_count = 7; /* max repeat count */ 
    let min_count = 4; /* min repeat count */ 
    if (nextlen === 0) {
        max_count = 138;
        min_count = 3;
    }
    tree[(max_code + 1) * 2 + 1] = 0xffff; /* guard */ 
    for(n = 0; n <= max_code; n++){
        curlen = nextlen;
        nextlen = tree[(n + 1) * 2 + 1] /*.Len*/ ;
        if (++count < max_count && curlen === nextlen) continue;
        else if (count < min_count) s.bl_tree[curlen * 2] += count;
        else if (curlen !== 0) {
            if (curlen !== prevlen) s.bl_tree[curlen * 2]++;
            s.bl_tree[$2dd4f45c8894762f$var$REP_3_6 * 2]++;
        } else if (count <= 10) s.bl_tree[$2dd4f45c8894762f$var$REPZ_3_10 * 2]++;
        else s.bl_tree[$2dd4f45c8894762f$var$REPZ_11_138 * 2]++;
        count = 0;
        prevlen = curlen;
        if (nextlen === 0) {
            max_count = 138;
            min_count = 3;
        } else if (curlen === nextlen) {
            max_count = 6;
            min_count = 3;
        } else {
            max_count = 7;
            min_count = 4;
        }
    }
};
/* ===========================================================================
 * Send a literal or distance tree in compressed form, using the codes in
 * bl_tree.
 */ const $2dd4f45c8894762f$var$send_tree = (s, tree, max_code)=>{
    //    deflate_state *s;
    //    ct_data *tree; /* the tree to be scanned */
    //    int max_code;       /* and its largest code of non zero frequency */
    let n; /* iterates over all tree elements */ 
    let prevlen = -1; /* last emitted length */ 
    let curlen; /* length of current code */ 
    let nextlen = tree[1] /*.Len*/ ; /* length of next code */ 
    let count = 0; /* repeat count of the current code */ 
    let max_count = 7; /* max repeat count */ 
    let min_count = 4; /* min repeat count */ 
    /* tree[max_code+1].Len = -1; */ /* guard already set */ if (nextlen === 0) {
        max_count = 138;
        min_count = 3;
    }
    for(n = 0; n <= max_code; n++){
        curlen = nextlen;
        nextlen = tree[(n + 1) * 2 + 1] /*.Len*/ ;
        if (++count < max_count && curlen === nextlen) continue;
        else if (count < min_count) do $2dd4f45c8894762f$var$send_code(s, curlen, s.bl_tree);
        while (--count !== 0);
        else if (curlen !== 0) {
            if (curlen !== prevlen) {
                $2dd4f45c8894762f$var$send_code(s, curlen, s.bl_tree);
                count--;
            }
            //Assert(count >= 3 && count <= 6, " 3_6?");
            $2dd4f45c8894762f$var$send_code(s, $2dd4f45c8894762f$var$REP_3_6, s.bl_tree);
            $2dd4f45c8894762f$var$send_bits(s, count - 3, 2);
        } else if (count <= 10) {
            $2dd4f45c8894762f$var$send_code(s, $2dd4f45c8894762f$var$REPZ_3_10, s.bl_tree);
            $2dd4f45c8894762f$var$send_bits(s, count - 3, 3);
        } else {
            $2dd4f45c8894762f$var$send_code(s, $2dd4f45c8894762f$var$REPZ_11_138, s.bl_tree);
            $2dd4f45c8894762f$var$send_bits(s, count - 11, 7);
        }
        count = 0;
        prevlen = curlen;
        if (nextlen === 0) {
            max_count = 138;
            min_count = 3;
        } else if (curlen === nextlen) {
            max_count = 6;
            min_count = 3;
        } else {
            max_count = 7;
            min_count = 4;
        }
    }
};
/* ===========================================================================
 * Construct the Huffman tree for the bit lengths and return the index in
 * bl_order of the last bit length code to send.
 */ const $2dd4f45c8894762f$var$build_bl_tree = (s)=>{
    let max_blindex; /* index of last bit length code of non zero freq */ 
    /* Determine the bit length frequencies for literal and distance trees */ $2dd4f45c8894762f$var$scan_tree(s, s.dyn_ltree, s.l_desc.max_code);
    $2dd4f45c8894762f$var$scan_tree(s, s.dyn_dtree, s.d_desc.max_code);
    /* Build the bit length tree: */ $2dd4f45c8894762f$var$build_tree(s, s.bl_desc);
    /* opt_len now includes the length of the tree representations, except
   * the lengths of the bit lengths codes and the 5+5+4 bits for the counts.
   */ /* Determine the number of bit length codes to send. The pkzip format
   * requires that at least 4 bit length codes be sent. (appnote.txt says
   * 3 but the actual value used is 4.)
   */ for(max_blindex = $2dd4f45c8894762f$var$BL_CODES$1 - 1; max_blindex >= 3; max_blindex--){
        if (s.bl_tree[$2dd4f45c8894762f$var$bl_order[max_blindex] * 2 + 1] !== 0) break;
    }
    /* Update opt_len to include the bit length tree and counts */ s.opt_len += 3 * (max_blindex + 1) + 5 + 5 + 4;
    //Tracev((stderr, "\ndyn trees: dyn %ld, stat %ld",
    //        s->opt_len, s->static_len));
    return max_blindex;
};
/* ===========================================================================
 * Send the header for a block using dynamic Huffman trees: the counts, the
 * lengths of the bit length codes, the literal tree and the distance tree.
 * IN assertion: lcodes >= 257, dcodes >= 1, blcodes >= 4.
 */ const $2dd4f45c8894762f$var$send_all_trees = (s, lcodes, dcodes, blcodes)=>{
    //    deflate_state *s;
    //    int lcodes, dcodes, blcodes; /* number of codes for each tree */
    let rank; /* index in bl_order */ 
    //Assert (lcodes >= 257 && dcodes >= 1 && blcodes >= 4, "not enough codes");
    //Assert (lcodes <= L_CODES && dcodes <= D_CODES && blcodes <= BL_CODES,
    //        "too many codes");
    //Tracev((stderr, "\nbl counts: "));
    $2dd4f45c8894762f$var$send_bits(s, lcodes - 257, 5); /* not +255 as stated in appnote.txt */ 
    $2dd4f45c8894762f$var$send_bits(s, dcodes - 1, 5);
    $2dd4f45c8894762f$var$send_bits(s, blcodes - 4, 4); /* not -3 as stated in appnote.txt */ 
    for(rank = 0; rank < blcodes; rank++)//Tracev((stderr, "\nbl code %2d ", bl_order[rank]));
    $2dd4f45c8894762f$var$send_bits(s, s.bl_tree[$2dd4f45c8894762f$var$bl_order[rank] * 2 + 1], 3);
    //Tracev((stderr, "\nbl tree: sent %ld", s->bits_sent));
    $2dd4f45c8894762f$var$send_tree(s, s.dyn_ltree, lcodes - 1); /* literal tree */ 
    //Tracev((stderr, "\nlit tree: sent %ld", s->bits_sent));
    $2dd4f45c8894762f$var$send_tree(s, s.dyn_dtree, dcodes - 1); /* distance tree */ 
//Tracev((stderr, "\ndist tree: sent %ld", s->bits_sent));
};
/* ===========================================================================
 * Check if the data type is TEXT or BINARY, using the following algorithm:
 * - TEXT if the two conditions below are satisfied:
 *    a) There are no non-portable control characters belonging to the
 *       "block list" (0..6, 14..25, 28..31).
 *    b) There is at least one printable character belonging to the
 *       "allow list" (9 {TAB}, 10 {LF}, 13 {CR}, 32..255).
 * - BINARY otherwise.
 * - The following partially-portable control characters form a
 *   "gray list" that is ignored in this detection algorithm:
 *   (7 {BEL}, 8 {BS}, 11 {VT}, 12 {FF}, 26 {SUB}, 27 {ESC}).
 * IN assertion: the fields Freq of dyn_ltree are set.
 */ const $2dd4f45c8894762f$var$detect_data_type = (s)=>{
    /* block_mask is the bit mask of block-listed bytes
   * set bits 0..6, 14..25, and 28..31
   * 0xf3ffc07f = binary 11110011111111111100000001111111
   */ let block_mask = 0xf3ffc07f;
    let n;
    /* Check for non-textual ("block-listed") bytes. */ for(n = 0; n <= 31; n++, block_mask >>>= 1){
        if (block_mask & 1 && s.dyn_ltree[n * 2] !== 0) return $2dd4f45c8894762f$var$Z_BINARY;
    }
    /* Check for textual ("allow-listed") bytes. */ if (s.dyn_ltree[18] !== 0 || s.dyn_ltree[20] !== 0 || s.dyn_ltree[26] !== 0) return $2dd4f45c8894762f$var$Z_TEXT;
    for(n = 32; n < $2dd4f45c8894762f$var$LITERALS$1; n++){
        if (s.dyn_ltree[n * 2] !== 0) return $2dd4f45c8894762f$var$Z_TEXT;
    }
    /* There are no "block-listed" or "allow-listed" bytes:
   * this stream either is empty or has tolerated ("gray-listed") bytes only.
   */ return $2dd4f45c8894762f$var$Z_BINARY;
};
let $2dd4f45c8894762f$var$static_init_done = false;
/* ===========================================================================
 * Initialize the tree data structures for a new zlib stream.
 */ const $2dd4f45c8894762f$var$_tr_init$1 = (s)=>{
    if (!$2dd4f45c8894762f$var$static_init_done) {
        $2dd4f45c8894762f$var$tr_static_init();
        $2dd4f45c8894762f$var$static_init_done = true;
    }
    s.l_desc = new $2dd4f45c8894762f$var$TreeDesc(s.dyn_ltree, $2dd4f45c8894762f$var$static_l_desc);
    s.d_desc = new $2dd4f45c8894762f$var$TreeDesc(s.dyn_dtree, $2dd4f45c8894762f$var$static_d_desc);
    s.bl_desc = new $2dd4f45c8894762f$var$TreeDesc(s.bl_tree, $2dd4f45c8894762f$var$static_bl_desc);
    s.bi_buf = 0;
    s.bi_valid = 0;
    /* Initialize the first block of the first file: */ $2dd4f45c8894762f$var$init_block(s);
};
/* ===========================================================================
 * Send a stored block
 */ const $2dd4f45c8894762f$var$_tr_stored_block$1 = (s, buf, stored_len, last)=>{
    //DeflateState *s;
    //charf *buf;       /* input block */
    //ulg stored_len;   /* length of input block */
    //int last;         /* one if this is the last block for a file */
    $2dd4f45c8894762f$var$send_bits(s, ($2dd4f45c8894762f$var$STORED_BLOCK << 1) + (last ? 1 : 0), 3); /* send block type */ 
    $2dd4f45c8894762f$var$bi_windup(s); /* align on byte boundary */ 
    $2dd4f45c8894762f$var$put_short(s, stored_len);
    $2dd4f45c8894762f$var$put_short(s, ~stored_len);
    if (stored_len) s.pending_buf.set(s.window.subarray(buf, buf + stored_len), s.pending);
    s.pending += stored_len;
};
/* ===========================================================================
 * Send one empty static block to give enough lookahead for inflate.
 * This takes 10 bits, of which 7 may remain in the bit buffer.
 */ const $2dd4f45c8894762f$var$_tr_align$1 = (s)=>{
    $2dd4f45c8894762f$var$send_bits(s, $2dd4f45c8894762f$var$STATIC_TREES << 1, 3);
    $2dd4f45c8894762f$var$send_code(s, $2dd4f45c8894762f$var$END_BLOCK, $2dd4f45c8894762f$var$static_ltree);
    $2dd4f45c8894762f$var$bi_flush(s);
};
/* ===========================================================================
 * Determine the best encoding for the current block: dynamic trees, static
 * trees or store, and write out the encoded block.
 */ const $2dd4f45c8894762f$var$_tr_flush_block$1 = (s, buf, stored_len, last)=>{
    //DeflateState *s;
    //charf *buf;       /* input block, or NULL if too old */
    //ulg stored_len;   /* length of input block */
    //int last;         /* one if this is the last block for a file */
    let opt_lenb, static_lenb; /* opt_len and static_len in bytes */ 
    let max_blindex = 0; /* index of last bit length code of non zero freq */ 
    /* Build the Huffman trees unless a stored block is forced */ if (s.level > 0) {
        /* Check if the file is binary or text */ if (s.strm.data_type === $2dd4f45c8894762f$var$Z_UNKNOWN$1) s.strm.data_type = $2dd4f45c8894762f$var$detect_data_type(s);
        /* Construct the literal and distance trees */ $2dd4f45c8894762f$var$build_tree(s, s.l_desc);
        // Tracev((stderr, "\nlit data: dyn %ld, stat %ld", s->opt_len,
        //        s->static_len));
        $2dd4f45c8894762f$var$build_tree(s, s.d_desc);
        // Tracev((stderr, "\ndist data: dyn %ld, stat %ld", s->opt_len,
        //        s->static_len));
        /* At this point, opt_len and static_len are the total bit lengths of
     * the compressed block data, excluding the tree representations.
     */ /* Build the bit length tree for the above two trees, and get the index
     * in bl_order of the last bit length code to send.
     */ max_blindex = $2dd4f45c8894762f$var$build_bl_tree(s);
        /* Determine the best encoding. Compute the block lengths in bytes. */ opt_lenb = s.opt_len + 3 + 7 >>> 3;
        static_lenb = s.static_len + 3 + 7 >>> 3;
        // Tracev((stderr, "\nopt %lu(%lu) stat %lu(%lu) stored %lu lit %u ",
        //        opt_lenb, s->opt_len, static_lenb, s->static_len, stored_len,
        //        s->sym_next / 3));
        if (static_lenb <= opt_lenb) opt_lenb = static_lenb;
    } else // Assert(buf != (char*)0, "lost buf");
    opt_lenb = static_lenb = stored_len + 5; /* force a stored block */ 
    if (stored_len + 4 <= opt_lenb && buf !== -1) /* 4: two words for the lengths */ /* The test buf != NULL is only necessary if LIT_BUFSIZE > WSIZE.
     * Otherwise we can't have processed more than WSIZE input bytes since
     * the last block flush, because compression would have been
     * successful. If LIT_BUFSIZE <= WSIZE, it is never too late to
     * transform a block into a stored block.
     */ $2dd4f45c8894762f$var$_tr_stored_block$1(s, buf, stored_len, last);
    else if (s.strategy === $2dd4f45c8894762f$var$Z_FIXED$1 || static_lenb === opt_lenb) {
        $2dd4f45c8894762f$var$send_bits(s, ($2dd4f45c8894762f$var$STATIC_TREES << 1) + (last ? 1 : 0), 3);
        $2dd4f45c8894762f$var$compress_block(s, $2dd4f45c8894762f$var$static_ltree, $2dd4f45c8894762f$var$static_dtree);
    } else {
        $2dd4f45c8894762f$var$send_bits(s, ($2dd4f45c8894762f$var$DYN_TREES << 1) + (last ? 1 : 0), 3);
        $2dd4f45c8894762f$var$send_all_trees(s, s.l_desc.max_code + 1, s.d_desc.max_code + 1, max_blindex + 1);
        $2dd4f45c8894762f$var$compress_block(s, s.dyn_ltree, s.dyn_dtree);
    }
    // Assert (s->compressed_len == s->bits_sent, "bad compressed size");
    /* The above check is made mod 2^32, for files larger than 512 MB
   * and uLong implemented on 32 bits.
   */ $2dd4f45c8894762f$var$init_block(s);
    if (last) $2dd4f45c8894762f$var$bi_windup(s);
// Tracev((stderr,"\ncomprlen %lu(%lu) ", s->compressed_len>>3,
//       s->compressed_len-7*last));
};
/* ===========================================================================
 * Save the match info and tally the frequency counts. Return true if
 * the current block must be flushed.
 */ const $2dd4f45c8894762f$var$_tr_tally$1 = (s, dist, lc)=>{
    //    deflate_state *s;
    //    unsigned dist;  /* distance of matched string */
    //    unsigned lc;    /* match length-MIN_MATCH or unmatched char (if dist==0) */
    s.pending_buf[s.sym_buf + s.sym_next++] = dist;
    s.pending_buf[s.sym_buf + s.sym_next++] = dist >> 8;
    s.pending_buf[s.sym_buf + s.sym_next++] = lc;
    if (dist === 0) /* lc is the unmatched char */ s.dyn_ltree[lc * 2]++;
    else {
        s.matches++;
        /* Here, lc is the match length - MIN_MATCH */ dist--; /* dist = match distance - 1 */ 
        //Assert((ush)dist < (ush)MAX_DIST(s) &&
        //       (ush)lc <= (ush)(MAX_MATCH-MIN_MATCH) &&
        //       (ush)d_code(dist) < (ush)D_CODES,  "_tr_tally: bad match");
        s.dyn_ltree[($2dd4f45c8894762f$var$_length_code[lc] + $2dd4f45c8894762f$var$LITERALS$1 + 1) * 2]++;
        s.dyn_dtree[$2dd4f45c8894762f$var$d_code(dist) * 2]++;
    }
    return s.sym_next === s.sym_end;
};
var $2dd4f45c8894762f$var$_tr_init_1 = $2dd4f45c8894762f$var$_tr_init$1;
var $2dd4f45c8894762f$var$_tr_stored_block_1 = $2dd4f45c8894762f$var$_tr_stored_block$1;
var $2dd4f45c8894762f$var$_tr_flush_block_1 = $2dd4f45c8894762f$var$_tr_flush_block$1;
var $2dd4f45c8894762f$var$_tr_tally_1 = $2dd4f45c8894762f$var$_tr_tally$1;
var $2dd4f45c8894762f$var$_tr_align_1 = $2dd4f45c8894762f$var$_tr_align$1;
var $2dd4f45c8894762f$var$trees = {
    _tr_init: $2dd4f45c8894762f$var$_tr_init_1,
    _tr_stored_block: $2dd4f45c8894762f$var$_tr_stored_block_1,
    _tr_flush_block: $2dd4f45c8894762f$var$_tr_flush_block_1,
    _tr_tally: $2dd4f45c8894762f$var$_tr_tally_1,
    _tr_align: $2dd4f45c8894762f$var$_tr_align_1
};
// Note: adler32 takes 12% for level 0 and 2% for level 6.
// It isn't worth it to make additional optimizations as in original.
// Small size is preferable.
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
const $2dd4f45c8894762f$var$adler32 = (adler, buf, len, pos)=>{
    let s1 = adler & 0xffff | 0, s2 = adler >>> 16 & 0xffff | 0, n = 0;
    while(len !== 0){
        // Set limit ~ twice less than 5552, to keep
        // s2 in 31-bits, because we force signed ints.
        // in other case %= will fail.
        n = len > 2000 ? 2000 : len;
        len -= n;
        do {
            s1 = s1 + buf[pos++] | 0;
            s2 = s2 + s1 | 0;
        }while (--n);
        s1 %= 65521;
        s2 %= 65521;
    }
    return s1 | s2 << 16 | 0;
};
var $2dd4f45c8894762f$var$adler32_1 = $2dd4f45c8894762f$var$adler32;
// Note: we can't get significant speed boost here.
// So write code to minimize size - no pregenerated tables
// and array tools dependencies.
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
// Use ordinary array, since untyped makes no boost here
const $2dd4f45c8894762f$var$makeTable = ()=>{
    let c, table = [];
    for(var n = 0; n < 256; n++){
        c = n;
        for(var k = 0; k < 8; k++)c = c & 1 ? 0xEDB88320 ^ c >>> 1 : c >>> 1;
        table[n] = c;
    }
    return table;
};
// Create table on load. Just 255 signed longs. Not a problem.
const $2dd4f45c8894762f$var$crcTable = new Uint32Array($2dd4f45c8894762f$var$makeTable());
const $2dd4f45c8894762f$var$crc32 = (crc, buf, len, pos)=>{
    const t = $2dd4f45c8894762f$var$crcTable;
    const end = pos + len;
    crc ^= -1;
    for(let i = pos; i < end; i++)crc = crc >>> 8 ^ t[(crc ^ buf[i]) & 0xFF];
    return crc ^ -1; // >>> 0;
};
var $2dd4f45c8894762f$var$crc32_1 = $2dd4f45c8894762f$var$crc32;
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
var $2dd4f45c8894762f$var$messages = {
    2: 'need dictionary',
    /* Z_NEED_DICT       2  */ 1: 'stream end',
    /* Z_STREAM_END      1  */ 0: '',
    /* Z_OK              0  */ '-1': 'file error',
    /* Z_ERRNO         (-1) */ '-2': 'stream error',
    /* Z_STREAM_ERROR  (-2) */ '-3': 'data error',
    /* Z_DATA_ERROR    (-3) */ '-4': 'insufficient memory',
    /* Z_MEM_ERROR     (-4) */ '-5': 'buffer error',
    /* Z_BUF_ERROR     (-5) */ '-6': 'incompatible version' /* Z_VERSION_ERROR (-6) */ 
};
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
var $2dd4f45c8894762f$var$constants$2 = {
    /* Allowed flush values; see deflate() and inflate() below for details */ Z_NO_FLUSH: 0,
    Z_PARTIAL_FLUSH: 1,
    Z_SYNC_FLUSH: 2,
    Z_FULL_FLUSH: 3,
    Z_FINISH: 4,
    Z_BLOCK: 5,
    Z_TREES: 6,
    /* Return codes for the compression/decompression functions. Negative values
  * are errors, positive values are used for special but normal events.
  */ Z_OK: 0,
    Z_STREAM_END: 1,
    Z_NEED_DICT: 2,
    Z_ERRNO: -1,
    Z_STREAM_ERROR: -2,
    Z_DATA_ERROR: -3,
    Z_MEM_ERROR: -4,
    Z_BUF_ERROR: -5,
    //Z_VERSION_ERROR: -6,
    /* compression levels */ Z_NO_COMPRESSION: 0,
    Z_BEST_SPEED: 1,
    Z_BEST_COMPRESSION: 9,
    Z_DEFAULT_COMPRESSION: -1,
    Z_FILTERED: 1,
    Z_HUFFMAN_ONLY: 2,
    Z_RLE: 3,
    Z_FIXED: 4,
    Z_DEFAULT_STRATEGY: 0,
    /* Possible values of the data_type field (though see inflate()) */ Z_BINARY: 0,
    Z_TEXT: 1,
    //Z_ASCII:                1, // = Z_TEXT (deprecated)
    Z_UNKNOWN: 2,
    /* The deflate compression method */ Z_DEFLATED: 8
};
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
const { _tr_init: $2dd4f45c8894762f$var$_tr_init, _tr_stored_block: $2dd4f45c8894762f$var$_tr_stored_block, _tr_flush_block: $2dd4f45c8894762f$var$_tr_flush_block, _tr_tally: $2dd4f45c8894762f$var$_tr_tally, _tr_align: $2dd4f45c8894762f$var$_tr_align } = $2dd4f45c8894762f$var$trees;
/* Public constants ==========================================================*/ /* ===========================================================================*/ const { Z_NO_FLUSH: $2dd4f45c8894762f$var$Z_NO_FLUSH$2, Z_PARTIAL_FLUSH: $2dd4f45c8894762f$var$Z_PARTIAL_FLUSH, Z_FULL_FLUSH: $2dd4f45c8894762f$var$Z_FULL_FLUSH$1, Z_FINISH: $2dd4f45c8894762f$var$Z_FINISH$3, Z_BLOCK: $2dd4f45c8894762f$var$Z_BLOCK$1, Z_OK: $2dd4f45c8894762f$var$Z_OK$3, Z_STREAM_END: $2dd4f45c8894762f$var$Z_STREAM_END$3, Z_STREAM_ERROR: $2dd4f45c8894762f$var$Z_STREAM_ERROR$2, Z_DATA_ERROR: $2dd4f45c8894762f$var$Z_DATA_ERROR$2, Z_BUF_ERROR: $2dd4f45c8894762f$var$Z_BUF_ERROR$1, Z_DEFAULT_COMPRESSION: $2dd4f45c8894762f$var$Z_DEFAULT_COMPRESSION$1, Z_FILTERED: $2dd4f45c8894762f$var$Z_FILTERED, Z_HUFFMAN_ONLY: $2dd4f45c8894762f$var$Z_HUFFMAN_ONLY, Z_RLE: $2dd4f45c8894762f$var$Z_RLE, Z_FIXED: $2dd4f45c8894762f$var$Z_FIXED, Z_DEFAULT_STRATEGY: $2dd4f45c8894762f$var$Z_DEFAULT_STRATEGY$1, Z_UNKNOWN: $2dd4f45c8894762f$var$Z_UNKNOWN, Z_DEFLATED: $2dd4f45c8894762f$var$Z_DEFLATED$2 } = $2dd4f45c8894762f$var$constants$2;
/*============================================================================*/ const $2dd4f45c8894762f$var$MAX_MEM_LEVEL = 9;
/* Maximum value for memLevel in deflateInit2 */ const $2dd4f45c8894762f$var$MAX_WBITS$1 = 15;
/* 32K LZ77 window */ const $2dd4f45c8894762f$var$DEF_MEM_LEVEL = 8;
const $2dd4f45c8894762f$var$LENGTH_CODES = 29;
/* number of length codes, not counting the special END_BLOCK code */ const $2dd4f45c8894762f$var$LITERALS = 256;
/* number of literal bytes 0..255 */ const $2dd4f45c8894762f$var$L_CODES = $2dd4f45c8894762f$var$LITERALS + 1 + $2dd4f45c8894762f$var$LENGTH_CODES;
/* number of Literal or Length codes, including the END_BLOCK code */ const $2dd4f45c8894762f$var$D_CODES = 30;
/* number of distance codes */ const $2dd4f45c8894762f$var$BL_CODES = 19;
/* number of codes used to transfer the bit lengths */ const $2dd4f45c8894762f$var$HEAP_SIZE = 2 * $2dd4f45c8894762f$var$L_CODES + 1;
/* maximum heap size */ const $2dd4f45c8894762f$var$MAX_BITS = 15;
/* All codes must not exceed MAX_BITS bits */ const $2dd4f45c8894762f$var$MIN_MATCH = 3;
const $2dd4f45c8894762f$var$MAX_MATCH = 258;
const $2dd4f45c8894762f$var$MIN_LOOKAHEAD = $2dd4f45c8894762f$var$MAX_MATCH + $2dd4f45c8894762f$var$MIN_MATCH + 1;
const $2dd4f45c8894762f$var$PRESET_DICT = 0x20;
const $2dd4f45c8894762f$var$INIT_STATE = 42; /* zlib header -> BUSY_STATE */ 
//#ifdef GZIP
const $2dd4f45c8894762f$var$GZIP_STATE = 57; /* gzip header -> BUSY_STATE | EXTRA_STATE */ 
//#endif
const $2dd4f45c8894762f$var$EXTRA_STATE = 69; /* gzip extra block -> NAME_STATE */ 
const $2dd4f45c8894762f$var$NAME_STATE = 73; /* gzip file name -> COMMENT_STATE */ 
const $2dd4f45c8894762f$var$COMMENT_STATE = 91; /* gzip comment -> HCRC_STATE */ 
const $2dd4f45c8894762f$var$HCRC_STATE = 103; /* gzip header CRC -> BUSY_STATE */ 
const $2dd4f45c8894762f$var$BUSY_STATE = 113; /* deflate -> FINISH_STATE */ 
const $2dd4f45c8894762f$var$FINISH_STATE = 666; /* stream complete */ 
const $2dd4f45c8894762f$var$BS_NEED_MORE = 1; /* block not completed, need more input or more output */ 
const $2dd4f45c8894762f$var$BS_BLOCK_DONE = 2; /* block flush performed */ 
const $2dd4f45c8894762f$var$BS_FINISH_STARTED = 3; /* finish started, need only more output at next deflate */ 
const $2dd4f45c8894762f$var$BS_FINISH_DONE = 4; /* finish done, accept no more input or output */ 
const $2dd4f45c8894762f$var$OS_CODE = 0x03; // Unix :) . Don't detect, use this default.
const $2dd4f45c8894762f$var$err = (strm, errorCode)=>{
    strm.msg = $2dd4f45c8894762f$var$messages[errorCode];
    return errorCode;
};
const $2dd4f45c8894762f$var$rank = (f)=>{
    return f * 2 - (f > 4 ? 9 : 0);
};
const $2dd4f45c8894762f$var$zero = (buf)=>{
    let len = buf.length;
    while(--len >= 0)buf[len] = 0;
};
/* ===========================================================================
 * Slide the hash table when sliding the window down (could be avoided with 32
 * bit values at the expense of memory usage). We slide even when level == 0 to
 * keep the hash table consistent if we switch back to level > 0 later.
 */ const $2dd4f45c8894762f$var$slide_hash = (s)=>{
    let n, m;
    let p;
    let wsize = s.w_size;
    n = s.hash_size;
    p = n;
    do {
        m = s.head[--p];
        s.head[p] = m >= wsize ? m - wsize : 0;
    }while (--n);
    n = wsize;
    //#ifndef FASTEST
    p = n;
    do {
        m = s.prev[--p];
        s.prev[p] = m >= wsize ? m - wsize : 0;
    /* If n is not on any hash chain, prev[n] is garbage but
     * its value will never be used.
     */ }while (--n);
//#endif
};
/* eslint-disable new-cap */ let $2dd4f45c8894762f$var$HASH_ZLIB = (s, prev, data)=>(prev << s.hash_shift ^ data) & s.hash_mask;
// This hash causes less collisions, https://github.com/nodeca/pako/issues/135
// But breaks binary compatibility
//let HASH_FAST = (s, prev, data) => ((prev << 8) + (prev >> 8) + (data << 4)) & s.hash_mask;
let $2dd4f45c8894762f$var$HASH = $2dd4f45c8894762f$var$HASH_ZLIB;
/* =========================================================================
 * Flush as much pending output as possible. All deflate() output, except for
 * some deflate_stored() output, goes through this function so some
 * applications may wish to modify it to avoid allocating a large
 * strm->next_out buffer and copying into it. (See also read_buf()).
 */ const $2dd4f45c8894762f$var$flush_pending = (strm)=>{
    const s = strm.state;
    //_tr_flush_bits(s);
    let len = s.pending;
    if (len > strm.avail_out) len = strm.avail_out;
    if (len === 0) return;
    strm.output.set(s.pending_buf.subarray(s.pending_out, s.pending_out + len), strm.next_out);
    strm.next_out += len;
    s.pending_out += len;
    strm.total_out += len;
    strm.avail_out -= len;
    s.pending -= len;
    if (s.pending === 0) s.pending_out = 0;
};
const $2dd4f45c8894762f$var$flush_block_only = (s, last)=>{
    $2dd4f45c8894762f$var$_tr_flush_block(s, s.block_start >= 0 ? s.block_start : -1, s.strstart - s.block_start, last);
    s.block_start = s.strstart;
    $2dd4f45c8894762f$var$flush_pending(s.strm);
};
const $2dd4f45c8894762f$var$put_byte = (s, b)=>{
    s.pending_buf[s.pending++] = b;
};
/* =========================================================================
 * Put a short in the pending buffer. The 16-bit value is put in MSB order.
 * IN assertion: the stream state is correct and there is enough room in
 * pending_buf.
 */ const $2dd4f45c8894762f$var$putShortMSB = (s, b)=>{
    //  put_byte(s, (Byte)(b >> 8));
    //  put_byte(s, (Byte)(b & 0xff));
    s.pending_buf[s.pending++] = b >>> 8 & 0xff;
    s.pending_buf[s.pending++] = b & 0xff;
};
/* ===========================================================================
 * Read a new buffer from the current input stream, update the adler32
 * and total number of bytes read.  All deflate() input goes through
 * this function so some applications may wish to modify it to avoid
 * allocating a large strm->input buffer and copying from it.
 * (See also flush_pending()).
 */ const $2dd4f45c8894762f$var$read_buf = (strm, buf, start, size)=>{
    let len = strm.avail_in;
    if (len > size) len = size;
    if (len === 0) return 0;
    strm.avail_in -= len;
    // zmemcpy(buf, strm->next_in, len);
    buf.set(strm.input.subarray(strm.next_in, strm.next_in + len), start);
    if (strm.state.wrap === 1) strm.adler = $2dd4f45c8894762f$var$adler32_1(strm.adler, buf, len, start);
    else if (strm.state.wrap === 2) strm.adler = $2dd4f45c8894762f$var$crc32_1(strm.adler, buf, len, start);
    strm.next_in += len;
    strm.total_in += len;
    return len;
};
/* ===========================================================================
 * Set match_start to the longest match starting at the given string and
 * return its length. Matches shorter or equal to prev_length are discarded,
 * in which case the result is equal to prev_length and match_start is
 * garbage.
 * IN assertions: cur_match is the head of the hash chain for the current
 *   string (strstart) and its distance is <= MAX_DIST, and prev_length >= 1
 * OUT assertion: the match length is not greater than s->lookahead.
 */ const $2dd4f45c8894762f$var$longest_match = (s, cur_match)=>{
    let chain_length = s.max_chain_length; /* max hash chain length */ 
    let scan = s.strstart; /* current string */ 
    let match; /* matched string */ 
    let len; /* length of current match */ 
    let best_len = s.prev_length; /* best match length so far */ 
    let nice_match = s.nice_match; /* stop if match long enough */ 
    const limit = s.strstart > s.w_size - $2dd4f45c8894762f$var$MIN_LOOKAHEAD ? s.strstart - (s.w_size - $2dd4f45c8894762f$var$MIN_LOOKAHEAD) : 0 /*NIL*/ ;
    const _win = s.window; // shortcut
    const wmask = s.w_mask;
    const prev = s.prev;
    /* Stop when cur_match becomes <= limit. To simplify the code,
   * we prevent matches with the string of window index 0.
   */ const strend = s.strstart + $2dd4f45c8894762f$var$MAX_MATCH;
    let scan_end1 = _win[scan + best_len - 1];
    let scan_end = _win[scan + best_len];
    /* The code is optimized for HASH_BITS >= 8 and MAX_MATCH-2 multiple of 16.
   * It is easy to get rid of this optimization if necessary.
   */ // Assert(s->hash_bits >= 8 && MAX_MATCH == 258, "Code too clever");
    /* Do not waste too much time if we already have a good match: */ if (s.prev_length >= s.good_match) chain_length >>= 2;
    /* Do not look for matches beyond the end of the input. This is necessary
   * to make deflate deterministic.
   */ if (nice_match > s.lookahead) nice_match = s.lookahead;
    // Assert((ulg)s->strstart <= s->window_size-MIN_LOOKAHEAD, "need lookahead");
    do {
        // Assert(cur_match < s->strstart, "no future");
        match = cur_match;
        /* Skip to next match if the match length cannot increase
     * or if the match length is less than 2.  Note that the checks below
     * for insufficient lookahead only occur occasionally for performance
     * reasons.  Therefore uninitialized memory will be accessed, and
     * conditional jumps will be made that depend on those values.
     * However the length of the match is limited to the lookahead, so
     * the output of deflate is not affected by the uninitialized values.
     */ if (_win[match + best_len] !== scan_end || _win[match + best_len - 1] !== scan_end1 || _win[match] !== _win[scan] || _win[++match] !== _win[scan + 1]) continue;
        /* The check at best_len-1 can be removed because it will be made
     * again later. (This heuristic is not always a win.)
     * It is not necessary to compare scan[2] and match[2] since they
     * are always equal when the other bytes match, given that
     * the hash keys are equal and that HASH_BITS >= 8.
     */ scan += 2;
        match++;
        // Assert(*scan == *match, "match[2]?");
        /* We check for insufficient lookahead only every 8th comparison;
     * the 256th check will be made at strstart+258.
     */ do ;
        while (_win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && scan < strend);
        // Assert(scan <= s->window+(unsigned)(s->window_size-1), "wild scan");
        len = $2dd4f45c8894762f$var$MAX_MATCH - (strend - scan);
        scan = strend - $2dd4f45c8894762f$var$MAX_MATCH;
        if (len > best_len) {
            s.match_start = cur_match;
            best_len = len;
            if (len >= nice_match) break;
            scan_end1 = _win[scan + best_len - 1];
            scan_end = _win[scan + best_len];
        }
    }while ((cur_match = prev[cur_match & wmask]) > limit && --chain_length !== 0);
    if (best_len <= s.lookahead) return best_len;
    return s.lookahead;
};
/* ===========================================================================
 * Fill the window when the lookahead becomes insufficient.
 * Updates strstart and lookahead.
 *
 * IN assertion: lookahead < MIN_LOOKAHEAD
 * OUT assertions: strstart <= window_size-MIN_LOOKAHEAD
 *    At least one byte has been read, or avail_in == 0; reads are
 *    performed for at least two bytes (required for the zip translate_eol
 *    option -- not supported here).
 */ const $2dd4f45c8894762f$var$fill_window = (s)=>{
    const _w_size = s.w_size;
    let n, more, str;
    //Assert(s->lookahead < MIN_LOOKAHEAD, "already enough lookahead");
    do {
        more = s.window_size - s.lookahead - s.strstart;
        // JS ints have 32 bit, block below not needed
        /* Deal with !@#$% 64K limit: */ //if (sizeof(int) <= 2) {
        //    if (more == 0 && s->strstart == 0 && s->lookahead == 0) {
        //        more = wsize;
        //
        //  } else if (more == (unsigned)(-1)) {
        //        /* Very unlikely, but possible on 16 bit machine if
        //         * strstart == 0 && lookahead == 1 (input done a byte at time)
        //         */
        //        more--;
        //    }
        //}
        /* If the window is almost full and there is insufficient lookahead,
     * move the upper half to the lower one to make room in the upper half.
     */ if (s.strstart >= _w_size + (_w_size - $2dd4f45c8894762f$var$MIN_LOOKAHEAD)) {
            s.window.set(s.window.subarray(_w_size, _w_size + _w_size - more), 0);
            s.match_start -= _w_size;
            s.strstart -= _w_size;
            /* we now have strstart >= MAX_DIST */ s.block_start -= _w_size;
            if (s.insert > s.strstart) s.insert = s.strstart;
            $2dd4f45c8894762f$var$slide_hash(s);
            more += _w_size;
        }
        if (s.strm.avail_in === 0) break;
        /* If there was no sliding:
     *    strstart <= WSIZE+MAX_DIST-1 && lookahead <= MIN_LOOKAHEAD - 1 &&
     *    more == window_size - lookahead - strstart
     * => more >= window_size - (MIN_LOOKAHEAD-1 + WSIZE + MAX_DIST-1)
     * => more >= window_size - 2*WSIZE + 2
     * In the BIG_MEM or MMAP case (not yet supported),
     *   window_size == input_size + MIN_LOOKAHEAD  &&
     *   strstart + s->lookahead <= input_size => more >= MIN_LOOKAHEAD.
     * Otherwise, window_size == 2*WSIZE so more >= 2.
     * If there was sliding, more >= WSIZE. So in all cases, more >= 2.
     */ //Assert(more >= 2, "more < 2");
        n = $2dd4f45c8894762f$var$read_buf(s.strm, s.window, s.strstart + s.lookahead, more);
        s.lookahead += n;
        /* Initialize the hash value now that we have some input: */ if (s.lookahead + s.insert >= $2dd4f45c8894762f$var$MIN_MATCH) {
            str = s.strstart - s.insert;
            s.ins_h = s.window[str];
            /* UPDATE_HASH(s, s->ins_h, s->window[str + 1]); */ s.ins_h = $2dd4f45c8894762f$var$HASH(s, s.ins_h, s.window[str + 1]);
            //#if MIN_MATCH != 3
            //        Call update_hash() MIN_MATCH-3 more times
            //#endif
            while(s.insert){
                /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */ s.ins_h = $2dd4f45c8894762f$var$HASH(s, s.ins_h, s.window[str + $2dd4f45c8894762f$var$MIN_MATCH - 1]);
                s.prev[str & s.w_mask] = s.head[s.ins_h];
                s.head[s.ins_h] = str;
                str++;
                s.insert--;
                if (s.lookahead + s.insert < $2dd4f45c8894762f$var$MIN_MATCH) break;
            }
        }
    /* If the whole input has less than MIN_MATCH bytes, ins_h is garbage,
     * but this is not important since only literal bytes will be emitted.
     */ }while (s.lookahead < $2dd4f45c8894762f$var$MIN_LOOKAHEAD && s.strm.avail_in !== 0);
/* If the WIN_INIT bytes after the end of the current data have never been
   * written, then zero those bytes in order to avoid memory check reports of
   * the use of uninitialized (or uninitialised as Julian writes) bytes by
   * the longest match routines.  Update the high water mark for the next
   * time through here.  WIN_INIT is set to MAX_MATCH since the longest match
   * routines allow scanning to strstart + MAX_MATCH, ignoring lookahead.
   */ //  if (s.high_water < s.window_size) {
//    const curr = s.strstart + s.lookahead;
//    let init = 0;
//
//    if (s.high_water < curr) {
//      /* Previous high water mark below current data -- zero WIN_INIT
//       * bytes or up to end of window, whichever is less.
//       */
//      init = s.window_size - curr;
//      if (init > WIN_INIT)
//        init = WIN_INIT;
//      zmemzero(s->window + curr, (unsigned)init);
//      s->high_water = curr + init;
//    }
//    else if (s->high_water < (ulg)curr + WIN_INIT) {
//      /* High water mark at or above current data, but below current data
//       * plus WIN_INIT -- zero out to current data plus WIN_INIT, or up
//       * to end of window, whichever is less.
//       */
//      init = (ulg)curr + WIN_INIT - s->high_water;
//      if (init > s->window_size - s->high_water)
//        init = s->window_size - s->high_water;
//      zmemzero(s->window + s->high_water, (unsigned)init);
//      s->high_water += init;
//    }
//  }
//
//  Assert((ulg)s->strstart <= s->window_size - MIN_LOOKAHEAD,
//    "not enough room for search");
};
/* ===========================================================================
 * Copy without compression as much as possible from the input stream, return
 * the current block state.
 *
 * In case deflateParams() is used to later switch to a non-zero compression
 * level, s->matches (otherwise unused when storing) keeps track of the number
 * of hash table slides to perform. If s->matches is 1, then one hash table
 * slide will be done when switching. If s->matches is 2, the maximum value
 * allowed here, then the hash table will be cleared, since two or more slides
 * is the same as a clear.
 *
 * deflate_stored() is written to minimize the number of times an input byte is
 * copied. It is most efficient with large input and output buffers, which
 * maximizes the opportunites to have a single copy from next_in to next_out.
 */ const $2dd4f45c8894762f$var$deflate_stored = (s, flush)=>{
    /* Smallest worthy block size when not flushing or finishing. By default
   * this is 32K. This can be as small as 507 bytes for memLevel == 1. For
   * large input and output buffers, the stored block size will be larger.
   */ let min_block = s.pending_buf_size - 5 > s.w_size ? s.w_size : s.pending_buf_size - 5;
    /* Copy as many min_block or larger stored blocks directly to next_out as
   * possible. If flushing, copy the remaining available input to next_out as
   * stored blocks, if there is enough space.
   */ let len, left, have, last = 0;
    let used = s.strm.avail_in;
    do {
        /* Set len to the maximum size block that we can copy directly with the
     * available input data and output space. Set left to how much of that
     * would be copied from what's left in the window.
     */ len = 65535 /* MAX_STORED */ ; /* maximum deflate stored block length */ 
        have = s.bi_valid + 42 >> 3; /* number of header bytes */ 
        if (s.strm.avail_out < have) break;
        /* maximum stored block length that will fit in avail_out: */ have = s.strm.avail_out - have;
        left = s.strstart - s.block_start; /* bytes left in window */ 
        if (len > left + s.strm.avail_in) len = left + s.strm.avail_in; /* limit len to the input */ 
        if (len > have) len = have; /* limit len to the output */ 
        /* If the stored block would be less than min_block in length, or if
     * unable to copy all of the available input when flushing, then try
     * copying to the window and the pending buffer instead. Also don't
     * write an empty block when flushing -- deflate() does that.
     */ if (len < min_block && (len === 0 && flush !== $2dd4f45c8894762f$var$Z_FINISH$3 || flush === $2dd4f45c8894762f$var$Z_NO_FLUSH$2 || len !== left + s.strm.avail_in)) break;
        /* Make a dummy stored block in pending to get the header bytes,
     * including any pending bits. This also updates the debugging counts.
     */ last = flush === $2dd4f45c8894762f$var$Z_FINISH$3 && len === left + s.strm.avail_in ? 1 : 0;
        $2dd4f45c8894762f$var$_tr_stored_block(s, 0, 0, last);
        /* Replace the lengths in the dummy stored block with len. */ s.pending_buf[s.pending - 4] = len;
        s.pending_buf[s.pending - 3] = len >> 8;
        s.pending_buf[s.pending - 2] = ~len;
        s.pending_buf[s.pending - 1] = ~len >> 8;
        /* Write the stored block header bytes. */ $2dd4f45c8894762f$var$flush_pending(s.strm);
        //#ifdef ZLIB_DEBUG
        //    /* Update debugging counts for the data about to be copied. */
        //    s->compressed_len += len << 3;
        //    s->bits_sent += len << 3;
        //#endif
        /* Copy uncompressed bytes from the window to next_out. */ if (left) {
            if (left > len) left = len;
            //zmemcpy(s->strm->next_out, s->window + s->block_start, left);
            s.strm.output.set(s.window.subarray(s.block_start, s.block_start + left), s.strm.next_out);
            s.strm.next_out += left;
            s.strm.avail_out -= left;
            s.strm.total_out += left;
            s.block_start += left;
            len -= left;
        }
        /* Copy uncompressed bytes directly from next_in to next_out, updating
     * the check value.
     */ if (len) {
            $2dd4f45c8894762f$var$read_buf(s.strm, s.strm.output, s.strm.next_out, len);
            s.strm.next_out += len;
            s.strm.avail_out -= len;
            s.strm.total_out += len;
        }
    }while (last === 0);
    /* Update the sliding window with the last s->w_size bytes of the copied
   * data, or append all of the copied data to the existing window if less
   * than s->w_size bytes were copied. Also update the number of bytes to
   * insert in the hash tables, in the event that deflateParams() switches to
   * a non-zero compression level.
   */ used -= s.strm.avail_in; /* number of input bytes directly copied */ 
    if (used) {
        /* If any input was used, then no unused input remains in the window,
     * therefore s->block_start == s->strstart.
     */ if (used >= s.w_size) {
            s.matches = 2; /* clear hash */ 
            //zmemcpy(s->window, s->strm->next_in - s->w_size, s->w_size);
            s.window.set(s.strm.input.subarray(s.strm.next_in - s.w_size, s.strm.next_in), 0);
            s.strstart = s.w_size;
            s.insert = s.strstart;
        } else {
            if (s.window_size - s.strstart <= used) {
                /* Slide the window down. */ s.strstart -= s.w_size;
                //zmemcpy(s->window, s->window + s->w_size, s->strstart);
                s.window.set(s.window.subarray(s.w_size, s.w_size + s.strstart), 0);
                if (s.matches < 2) s.matches++; /* add a pending slide_hash() */ 
                if (s.insert > s.strstart) s.insert = s.strstart;
            }
            //zmemcpy(s->window + s->strstart, s->strm->next_in - used, used);
            s.window.set(s.strm.input.subarray(s.strm.next_in - used, s.strm.next_in), s.strstart);
            s.strstart += used;
            s.insert += used > s.w_size - s.insert ? s.w_size - s.insert : used;
        }
        s.block_start = s.strstart;
    }
    if (s.high_water < s.strstart) s.high_water = s.strstart;
    /* If the last block was written to next_out, then done. */ if (last) return $2dd4f45c8894762f$var$BS_FINISH_DONE;
    /* If flushing and all input has been consumed, then done. */ if (flush !== $2dd4f45c8894762f$var$Z_NO_FLUSH$2 && flush !== $2dd4f45c8894762f$var$Z_FINISH$3 && s.strm.avail_in === 0 && s.strstart === s.block_start) return $2dd4f45c8894762f$var$BS_BLOCK_DONE;
    /* Fill the window with any remaining input. */ have = s.window_size - s.strstart;
    if (s.strm.avail_in > have && s.block_start >= s.w_size) {
        /* Slide the window down. */ s.block_start -= s.w_size;
        s.strstart -= s.w_size;
        //zmemcpy(s->window, s->window + s->w_size, s->strstart);
        s.window.set(s.window.subarray(s.w_size, s.w_size + s.strstart), 0);
        if (s.matches < 2) s.matches++; /* add a pending slide_hash() */ 
        have += s.w_size; /* more space now */ 
        if (s.insert > s.strstart) s.insert = s.strstart;
    }
    if (have > s.strm.avail_in) have = s.strm.avail_in;
    if (have) {
        $2dd4f45c8894762f$var$read_buf(s.strm, s.window, s.strstart, have);
        s.strstart += have;
        s.insert += have > s.w_size - s.insert ? s.w_size - s.insert : have;
    }
    if (s.high_water < s.strstart) s.high_water = s.strstart;
    /* There was not enough avail_out to write a complete worthy or flushed
   * stored block to next_out. Write a stored block to pending instead, if we
   * have enough input for a worthy block, or if flushing and there is enough
   * room for the remaining input as a stored block in the pending buffer.
   */ have = s.bi_valid + 42 >> 3; /* number of header bytes */ 
    /* maximum stored block length that will fit in pending: */ have = s.pending_buf_size - have > 65535 /* MAX_STORED */  ? 65535 /* MAX_STORED */  : s.pending_buf_size - have;
    min_block = have > s.w_size ? s.w_size : have;
    left = s.strstart - s.block_start;
    if (left >= min_block || (left || flush === $2dd4f45c8894762f$var$Z_FINISH$3) && flush !== $2dd4f45c8894762f$var$Z_NO_FLUSH$2 && s.strm.avail_in === 0 && left <= have) {
        len = left > have ? have : left;
        last = flush === $2dd4f45c8894762f$var$Z_FINISH$3 && s.strm.avail_in === 0 && len === left ? 1 : 0;
        $2dd4f45c8894762f$var$_tr_stored_block(s, s.block_start, len, last);
        s.block_start += len;
        $2dd4f45c8894762f$var$flush_pending(s.strm);
    }
    /* We've done all we can with the available input and output. */ return last ? $2dd4f45c8894762f$var$BS_FINISH_STARTED : $2dd4f45c8894762f$var$BS_NEED_MORE;
};
/* ===========================================================================
 * Compress as much as possible from the input stream, return the current
 * block state.
 * This function does not perform lazy evaluation of matches and inserts
 * new strings in the dictionary only for unmatched strings or for short
 * matches. It is used only for the fast compression options.
 */ const $2dd4f45c8894762f$var$deflate_fast = (s, flush)=>{
    let hash_head; /* head of the hash chain */ 
    let bflush; /* set if current block must be flushed */ 
    for(;;){
        /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the next match, plus MIN_MATCH bytes to insert the
     * string following the next match.
     */ if (s.lookahead < $2dd4f45c8894762f$var$MIN_LOOKAHEAD) {
            $2dd4f45c8894762f$var$fill_window(s);
            if (s.lookahead < $2dd4f45c8894762f$var$MIN_LOOKAHEAD && flush === $2dd4f45c8894762f$var$Z_NO_FLUSH$2) return $2dd4f45c8894762f$var$BS_NEED_MORE;
            if (s.lookahead === 0) break; /* flush the current block */ 
        }
        /* Insert the string window[strstart .. strstart+2] in the
     * dictionary, and set hash_head to the head of the hash chain:
     */ hash_head = 0 /*NIL*/ ;
        if (s.lookahead >= $2dd4f45c8894762f$var$MIN_MATCH) {
            /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = $2dd4f45c8894762f$var$HASH(s, s.ins_h, s.window[s.strstart + $2dd4f45c8894762f$var$MIN_MATCH - 1]);
            hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
            s.head[s.ins_h] = s.strstart;
        /***/ }
        /* Find the longest match, discarding those <= prev_length.
     * At this point we have always match_length < MIN_MATCH
     */ if (hash_head !== 0 /*NIL*/  && s.strstart - hash_head <= s.w_size - $2dd4f45c8894762f$var$MIN_LOOKAHEAD) /* To simplify the code, we prevent matches with the string
       * of window index 0 (in particular we have to avoid a match
       * of the string with itself at the start of the input file).
       */ s.match_length = $2dd4f45c8894762f$var$longest_match(s, hash_head);
        if (s.match_length >= $2dd4f45c8894762f$var$MIN_MATCH) {
            // check_match(s, s.strstart, s.match_start, s.match_length); // for debug only
            /*** _tr_tally_dist(s, s.strstart - s.match_start,
                     s.match_length - MIN_MATCH, bflush); ***/ bflush = $2dd4f45c8894762f$var$_tr_tally(s, s.strstart - s.match_start, s.match_length - $2dd4f45c8894762f$var$MIN_MATCH);
            s.lookahead -= s.match_length;
            /* Insert new strings in the hash table only if the match length
       * is not too large. This saves time but degrades compression.
       */ if (s.match_length <= s.max_lazy_match /*max_insert_length*/  && s.lookahead >= $2dd4f45c8894762f$var$MIN_MATCH) {
                s.match_length--; /* string at strstart already in table */ 
                do {
                    s.strstart++;
                    /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = $2dd4f45c8894762f$var$HASH(s, s.ins_h, s.window[s.strstart + $2dd4f45c8894762f$var$MIN_MATCH - 1]);
                    hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
                    s.head[s.ins_h] = s.strstart;
                /***/ /* strstart never exceeds WSIZE-MAX_MATCH, so there are
           * always MIN_MATCH bytes ahead.
           */ }while (--s.match_length !== 0);
                s.strstart++;
            } else {
                s.strstart += s.match_length;
                s.match_length = 0;
                s.ins_h = s.window[s.strstart];
                /* UPDATE_HASH(s, s.ins_h, s.window[s.strstart+1]); */ s.ins_h = $2dd4f45c8894762f$var$HASH(s, s.ins_h, s.window[s.strstart + 1]);
            //#if MIN_MATCH != 3
            //                Call UPDATE_HASH() MIN_MATCH-3 more times
            //#endif
            /* If lookahead < MIN_MATCH, ins_h is garbage, but it does not
         * matter since it will be recomputed at next deflate call.
         */ }
        } else {
            /* No match, output a literal byte */ //Tracevv((stderr,"%c", s.window[s.strstart]));
            /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/ bflush = $2dd4f45c8894762f$var$_tr_tally(s, 0, s.window[s.strstart]);
            s.lookahead--;
            s.strstart++;
        }
        if (bflush) {
            /*** FLUSH_BLOCK(s, 0); ***/ $2dd4f45c8894762f$var$flush_block_only(s, false);
            if (s.strm.avail_out === 0) return $2dd4f45c8894762f$var$BS_NEED_MORE;
        /***/ }
    }
    s.insert = s.strstart < $2dd4f45c8894762f$var$MIN_MATCH - 1 ? s.strstart : $2dd4f45c8894762f$var$MIN_MATCH - 1;
    if (flush === $2dd4f45c8894762f$var$Z_FINISH$3) {
        /*** FLUSH_BLOCK(s, 1); ***/ $2dd4f45c8894762f$var$flush_block_only(s, true);
        if (s.strm.avail_out === 0) return $2dd4f45c8894762f$var$BS_FINISH_STARTED;
        /***/ return $2dd4f45c8894762f$var$BS_FINISH_DONE;
    }
    if (s.sym_next) {
        /*** FLUSH_BLOCK(s, 0); ***/ $2dd4f45c8894762f$var$flush_block_only(s, false);
        if (s.strm.avail_out === 0) return $2dd4f45c8894762f$var$BS_NEED_MORE;
    /***/ }
    return $2dd4f45c8894762f$var$BS_BLOCK_DONE;
};
/* ===========================================================================
 * Same as above, but achieves better compression. We use a lazy
 * evaluation for matches: a match is finally adopted only if there is
 * no better match at the next window position.
 */ const $2dd4f45c8894762f$var$deflate_slow = (s, flush)=>{
    let hash_head; /* head of hash chain */ 
    let bflush; /* set if current block must be flushed */ 
    let max_insert;
    /* Process the input block. */ for(;;){
        /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the next match, plus MIN_MATCH bytes to insert the
     * string following the next match.
     */ if (s.lookahead < $2dd4f45c8894762f$var$MIN_LOOKAHEAD) {
            $2dd4f45c8894762f$var$fill_window(s);
            if (s.lookahead < $2dd4f45c8894762f$var$MIN_LOOKAHEAD && flush === $2dd4f45c8894762f$var$Z_NO_FLUSH$2) return $2dd4f45c8894762f$var$BS_NEED_MORE;
            if (s.lookahead === 0) break;
             /* flush the current block */ 
        }
        /* Insert the string window[strstart .. strstart+2] in the
     * dictionary, and set hash_head to the head of the hash chain:
     */ hash_head = 0 /*NIL*/ ;
        if (s.lookahead >= $2dd4f45c8894762f$var$MIN_MATCH) {
            /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = $2dd4f45c8894762f$var$HASH(s, s.ins_h, s.window[s.strstart + $2dd4f45c8894762f$var$MIN_MATCH - 1]);
            hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
            s.head[s.ins_h] = s.strstart;
        /***/ }
        /* Find the longest match, discarding those <= prev_length.
     */ s.prev_length = s.match_length;
        s.prev_match = s.match_start;
        s.match_length = $2dd4f45c8894762f$var$MIN_MATCH - 1;
        if (hash_head !== 0 /*NIL*/  && s.prev_length < s.max_lazy_match && s.strstart - hash_head <= s.w_size - $2dd4f45c8894762f$var$MIN_LOOKAHEAD) {
            /* To simplify the code, we prevent matches with the string
       * of window index 0 (in particular we have to avoid a match
       * of the string with itself at the start of the input file).
       */ s.match_length = $2dd4f45c8894762f$var$longest_match(s, hash_head);
            /* longest_match() sets match_start */ if (s.match_length <= 5 && (s.strategy === $2dd4f45c8894762f$var$Z_FILTERED || s.match_length === $2dd4f45c8894762f$var$MIN_MATCH && s.strstart - s.match_start > 4096 /*TOO_FAR*/ )) /* If prev_match is also MIN_MATCH, match_start is garbage
         * but we will ignore the current match anyway.
         */ s.match_length = $2dd4f45c8894762f$var$MIN_MATCH - 1;
        }
        /* If there was a match at the previous step and the current
     * match is not better, output the previous match:
     */ if (s.prev_length >= $2dd4f45c8894762f$var$MIN_MATCH && s.match_length <= s.prev_length) {
            max_insert = s.strstart + s.lookahead - $2dd4f45c8894762f$var$MIN_MATCH;
            /* Do not insert strings in hash table beyond this. */ //check_match(s, s.strstart-1, s.prev_match, s.prev_length);
            /***_tr_tally_dist(s, s.strstart - 1 - s.prev_match,
                     s.prev_length - MIN_MATCH, bflush);***/ bflush = $2dd4f45c8894762f$var$_tr_tally(s, s.strstart - 1 - s.prev_match, s.prev_length - $2dd4f45c8894762f$var$MIN_MATCH);
            /* Insert in hash table all strings up to the end of the match.
       * strstart-1 and strstart are already inserted. If there is not
       * enough lookahead, the last two strings are not inserted in
       * the hash table.
       */ s.lookahead -= s.prev_length - 1;
            s.prev_length -= 2;
            do if (++s.strstart <= max_insert) {
                /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = $2dd4f45c8894762f$var$HASH(s, s.ins_h, s.window[s.strstart + $2dd4f45c8894762f$var$MIN_MATCH - 1]);
                hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
                s.head[s.ins_h] = s.strstart;
            /***/ }
            while (--s.prev_length !== 0);
            s.match_available = 0;
            s.match_length = $2dd4f45c8894762f$var$MIN_MATCH - 1;
            s.strstart++;
            if (bflush) {
                /*** FLUSH_BLOCK(s, 0); ***/ $2dd4f45c8894762f$var$flush_block_only(s, false);
                if (s.strm.avail_out === 0) return $2dd4f45c8894762f$var$BS_NEED_MORE;
            /***/ }
        } else if (s.match_available) {
            /* If there was no match at the previous position, output a
       * single literal. If there was a match but the current match
       * is longer, truncate the previous match to a single literal.
       */ //Tracevv((stderr,"%c", s->window[s->strstart-1]));
            /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/ bflush = $2dd4f45c8894762f$var$_tr_tally(s, 0, s.window[s.strstart - 1]);
            if (bflush) /*** FLUSH_BLOCK_ONLY(s, 0) ***/ $2dd4f45c8894762f$var$flush_block_only(s, false);
            s.strstart++;
            s.lookahead--;
            if (s.strm.avail_out === 0) return $2dd4f45c8894762f$var$BS_NEED_MORE;
        } else {
            /* There is no previous match to compare with, wait for
       * the next step to decide.
       */ s.match_available = 1;
            s.strstart++;
            s.lookahead--;
        }
    }
    //Assert (flush != Z_NO_FLUSH, "no flush?");
    if (s.match_available) {
        //Tracevv((stderr,"%c", s->window[s->strstart-1]));
        /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/ bflush = $2dd4f45c8894762f$var$_tr_tally(s, 0, s.window[s.strstart - 1]);
        s.match_available = 0;
    }
    s.insert = s.strstart < $2dd4f45c8894762f$var$MIN_MATCH - 1 ? s.strstart : $2dd4f45c8894762f$var$MIN_MATCH - 1;
    if (flush === $2dd4f45c8894762f$var$Z_FINISH$3) {
        /*** FLUSH_BLOCK(s, 1); ***/ $2dd4f45c8894762f$var$flush_block_only(s, true);
        if (s.strm.avail_out === 0) return $2dd4f45c8894762f$var$BS_FINISH_STARTED;
        /***/ return $2dd4f45c8894762f$var$BS_FINISH_DONE;
    }
    if (s.sym_next) {
        /*** FLUSH_BLOCK(s, 0); ***/ $2dd4f45c8894762f$var$flush_block_only(s, false);
        if (s.strm.avail_out === 0) return $2dd4f45c8894762f$var$BS_NEED_MORE;
    /***/ }
    return $2dd4f45c8894762f$var$BS_BLOCK_DONE;
};
/* ===========================================================================
 * For Z_RLE, simply look for runs of bytes, generate matches only of distance
 * one.  Do not maintain a hash table.  (It will be regenerated if this run of
 * deflate switches away from Z_RLE.)
 */ const $2dd4f45c8894762f$var$deflate_rle = (s, flush)=>{
    let bflush; /* set if current block must be flushed */ 
    let prev; /* byte at distance one to match */ 
    let scan, strend; /* scan goes up to strend for length of run */ 
    const _win = s.window;
    for(;;){
        /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the longest run, plus one for the unrolled loop.
     */ if (s.lookahead <= $2dd4f45c8894762f$var$MAX_MATCH) {
            $2dd4f45c8894762f$var$fill_window(s);
            if (s.lookahead <= $2dd4f45c8894762f$var$MAX_MATCH && flush === $2dd4f45c8894762f$var$Z_NO_FLUSH$2) return $2dd4f45c8894762f$var$BS_NEED_MORE;
            if (s.lookahead === 0) break;
             /* flush the current block */ 
        }
        /* See how many times the previous byte repeats */ s.match_length = 0;
        if (s.lookahead >= $2dd4f45c8894762f$var$MIN_MATCH && s.strstart > 0) {
            scan = s.strstart - 1;
            prev = _win[scan];
            if (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan]) {
                strend = s.strstart + $2dd4f45c8894762f$var$MAX_MATCH;
                do ;
                while (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && scan < strend);
                s.match_length = $2dd4f45c8894762f$var$MAX_MATCH - (strend - scan);
                if (s.match_length > s.lookahead) s.match_length = s.lookahead;
            }
        //Assert(scan <= s->window+(uInt)(s->window_size-1), "wild scan");
        }
        /* Emit match if have run of MIN_MATCH or longer, else emit literal */ if (s.match_length >= $2dd4f45c8894762f$var$MIN_MATCH) {
            //check_match(s, s.strstart, s.strstart - 1, s.match_length);
            /*** _tr_tally_dist(s, 1, s.match_length - MIN_MATCH, bflush); ***/ bflush = $2dd4f45c8894762f$var$_tr_tally(s, 1, s.match_length - $2dd4f45c8894762f$var$MIN_MATCH);
            s.lookahead -= s.match_length;
            s.strstart += s.match_length;
            s.match_length = 0;
        } else {
            /* No match, output a literal byte */ //Tracevv((stderr,"%c", s->window[s->strstart]));
            /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/ bflush = $2dd4f45c8894762f$var$_tr_tally(s, 0, s.window[s.strstart]);
            s.lookahead--;
            s.strstart++;
        }
        if (bflush) {
            /*** FLUSH_BLOCK(s, 0); ***/ $2dd4f45c8894762f$var$flush_block_only(s, false);
            if (s.strm.avail_out === 0) return $2dd4f45c8894762f$var$BS_NEED_MORE;
        /***/ }
    }
    s.insert = 0;
    if (flush === $2dd4f45c8894762f$var$Z_FINISH$3) {
        /*** FLUSH_BLOCK(s, 1); ***/ $2dd4f45c8894762f$var$flush_block_only(s, true);
        if (s.strm.avail_out === 0) return $2dd4f45c8894762f$var$BS_FINISH_STARTED;
        /***/ return $2dd4f45c8894762f$var$BS_FINISH_DONE;
    }
    if (s.sym_next) {
        /*** FLUSH_BLOCK(s, 0); ***/ $2dd4f45c8894762f$var$flush_block_only(s, false);
        if (s.strm.avail_out === 0) return $2dd4f45c8894762f$var$BS_NEED_MORE;
    /***/ }
    return $2dd4f45c8894762f$var$BS_BLOCK_DONE;
};
/* ===========================================================================
 * For Z_HUFFMAN_ONLY, do not look for matches.  Do not maintain a hash table.
 * (It will be regenerated if this run of deflate switches away from Huffman.)
 */ const $2dd4f45c8894762f$var$deflate_huff = (s, flush)=>{
    let bflush; /* set if current block must be flushed */ 
    for(;;){
        /* Make sure that we have a literal to write. */ if (s.lookahead === 0) {
            $2dd4f45c8894762f$var$fill_window(s);
            if (s.lookahead === 0) {
                if (flush === $2dd4f45c8894762f$var$Z_NO_FLUSH$2) return $2dd4f45c8894762f$var$BS_NEED_MORE;
                break; /* flush the current block */ 
            }
        }
        /* Output a literal byte */ s.match_length = 0;
        //Tracevv((stderr,"%c", s->window[s->strstart]));
        /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/ bflush = $2dd4f45c8894762f$var$_tr_tally(s, 0, s.window[s.strstart]);
        s.lookahead--;
        s.strstart++;
        if (bflush) {
            /*** FLUSH_BLOCK(s, 0); ***/ $2dd4f45c8894762f$var$flush_block_only(s, false);
            if (s.strm.avail_out === 0) return $2dd4f45c8894762f$var$BS_NEED_MORE;
        /***/ }
    }
    s.insert = 0;
    if (flush === $2dd4f45c8894762f$var$Z_FINISH$3) {
        /*** FLUSH_BLOCK(s, 1); ***/ $2dd4f45c8894762f$var$flush_block_only(s, true);
        if (s.strm.avail_out === 0) return $2dd4f45c8894762f$var$BS_FINISH_STARTED;
        /***/ return $2dd4f45c8894762f$var$BS_FINISH_DONE;
    }
    if (s.sym_next) {
        /*** FLUSH_BLOCK(s, 0); ***/ $2dd4f45c8894762f$var$flush_block_only(s, false);
        if (s.strm.avail_out === 0) return $2dd4f45c8894762f$var$BS_NEED_MORE;
    /***/ }
    return $2dd4f45c8894762f$var$BS_BLOCK_DONE;
};
/* Values for max_lazy_match, good_match and max_chain_length, depending on
 * the desired pack level (0..9). The values given below have been tuned to
 * exclude worst case performance for pathological files. Better values may be
 * found for specific files.
 */ function $2dd4f45c8894762f$var$Config(good_length, max_lazy, nice_length, max_chain, func) {
    this.good_length = good_length;
    this.max_lazy = max_lazy;
    this.nice_length = nice_length;
    this.max_chain = max_chain;
    this.func = func;
}
const $2dd4f45c8894762f$var$configuration_table = [
    /*      good lazy nice chain */ new $2dd4f45c8894762f$var$Config(0, 0, 0, 0, $2dd4f45c8894762f$var$deflate_stored),
    /* 0 store only */ new $2dd4f45c8894762f$var$Config(4, 4, 8, 4, $2dd4f45c8894762f$var$deflate_fast),
    /* 1 max speed, no lazy matches */ new $2dd4f45c8894762f$var$Config(4, 5, 16, 8, $2dd4f45c8894762f$var$deflate_fast),
    /* 2 */ new $2dd4f45c8894762f$var$Config(4, 6, 32, 32, $2dd4f45c8894762f$var$deflate_fast),
    /* 3 */ new $2dd4f45c8894762f$var$Config(4, 4, 16, 16, $2dd4f45c8894762f$var$deflate_slow),
    /* 4 lazy matches */ new $2dd4f45c8894762f$var$Config(8, 16, 32, 32, $2dd4f45c8894762f$var$deflate_slow),
    /* 5 */ new $2dd4f45c8894762f$var$Config(8, 16, 128, 128, $2dd4f45c8894762f$var$deflate_slow),
    /* 6 */ new $2dd4f45c8894762f$var$Config(8, 32, 128, 256, $2dd4f45c8894762f$var$deflate_slow),
    /* 7 */ new $2dd4f45c8894762f$var$Config(32, 128, 258, 1024, $2dd4f45c8894762f$var$deflate_slow),
    /* 8 */ new $2dd4f45c8894762f$var$Config(32, 258, 258, 4096, $2dd4f45c8894762f$var$deflate_slow)
];
/* ===========================================================================
 * Initialize the "longest match" routines for a new zlib stream
 */ const $2dd4f45c8894762f$var$lm_init = (s)=>{
    s.window_size = 2 * s.w_size;
    /*** CLEAR_HASH(s); ***/ $2dd4f45c8894762f$var$zero(s.head); // Fill with NIL (= 0);
    /* Set the default configuration parameters:
   */ s.max_lazy_match = $2dd4f45c8894762f$var$configuration_table[s.level].max_lazy;
    s.good_match = $2dd4f45c8894762f$var$configuration_table[s.level].good_length;
    s.nice_match = $2dd4f45c8894762f$var$configuration_table[s.level].nice_length;
    s.max_chain_length = $2dd4f45c8894762f$var$configuration_table[s.level].max_chain;
    s.strstart = 0;
    s.block_start = 0;
    s.lookahead = 0;
    s.insert = 0;
    s.match_length = s.prev_length = $2dd4f45c8894762f$var$MIN_MATCH - 1;
    s.match_available = 0;
    s.ins_h = 0;
};
function $2dd4f45c8894762f$var$DeflateState() {
    this.strm = null; /* pointer back to this zlib stream */ 
    this.status = 0; /* as the name implies */ 
    this.pending_buf = null; /* output still pending */ 
    this.pending_buf_size = 0; /* size of pending_buf */ 
    this.pending_out = 0; /* next pending byte to output to the stream */ 
    this.pending = 0; /* nb of bytes in the pending buffer */ 
    this.wrap = 0; /* bit 0 true for zlib, bit 1 true for gzip */ 
    this.gzhead = null; /* gzip header information to write */ 
    this.gzindex = 0; /* where in extra, name, or comment */ 
    this.method = $2dd4f45c8894762f$var$Z_DEFLATED$2; /* can only be DEFLATED */ 
    this.last_flush = -1; /* value of flush param for previous deflate call */ 
    this.w_size = 0; /* LZ77 window size (32K by default) */ 
    this.w_bits = 0; /* log2(w_size)  (8..16) */ 
    this.w_mask = 0; /* w_size - 1 */ 
    this.window = null;
    /* Sliding window. Input bytes are read into the second half of the window,
   * and move to the first half later to keep a dictionary of at least wSize
   * bytes. With this organization, matches are limited to a distance of
   * wSize-MAX_MATCH bytes, but this ensures that IO is always
   * performed with a length multiple of the block size.
   */ this.window_size = 0;
    /* Actual size of window: 2*wSize, except when the user input buffer
   * is directly used as sliding window.
   */ this.prev = null;
    /* Link to older string with same hash index. To limit the size of this
   * array to 64K, this link is maintained only for the last 32K strings.
   * An index in this array is thus a window index modulo 32K.
   */ this.head = null; /* Heads of the hash chains or NIL. */ 
    this.ins_h = 0; /* hash index of string to be inserted */ 
    this.hash_size = 0; /* number of elements in hash table */ 
    this.hash_bits = 0; /* log2(hash_size) */ 
    this.hash_mask = 0; /* hash_size-1 */ 
    this.hash_shift = 0;
    /* Number of bits by which ins_h must be shifted at each input
   * step. It must be such that after MIN_MATCH steps, the oldest
   * byte no longer takes part in the hash key, that is:
   *   hash_shift * MIN_MATCH >= hash_bits
   */ this.block_start = 0;
    /* Window position at the beginning of the current output block. Gets
   * negative when the window is moved backwards.
   */ this.match_length = 0; /* length of best match */ 
    this.prev_match = 0; /* previous match */ 
    this.match_available = 0; /* set if previous match exists */ 
    this.strstart = 0; /* start of string to insert */ 
    this.match_start = 0; /* start of matching string */ 
    this.lookahead = 0; /* number of valid bytes ahead in window */ 
    this.prev_length = 0;
    /* Length of the best match at previous step. Matches not greater than this
   * are discarded. This is used in the lazy match evaluation.
   */ this.max_chain_length = 0;
    /* To speed up deflation, hash chains are never searched beyond this
   * length.  A higher limit improves compression ratio but degrades the
   * speed.
   */ this.max_lazy_match = 0;
    /* Attempt to find a better match only when the current match is strictly
   * smaller than this value. This mechanism is used only for compression
   * levels >= 4.
   */ // That's alias to max_lazy_match, don't use directly
    //this.max_insert_length = 0;
    /* Insert new strings in the hash table only if the match length is not
   * greater than this length. This saves time but degrades compression.
   * max_insert_length is used only for compression levels <= 3.
   */ this.level = 0; /* compression level (1..9) */ 
    this.strategy = 0; /* favor or force Huffman coding*/ 
    this.good_match = 0;
    /* Use a faster search when the previous match is longer than this */ this.nice_match = 0; /* Stop searching when current match exceeds this */ 
    /* used by trees.c: */ /* Didn't use ct_data typedef below to suppress compiler warning */ // struct ct_data_s dyn_ltree[HEAP_SIZE];   /* literal and length tree */
    // struct ct_data_s dyn_dtree[2*D_CODES+1]; /* distance tree */
    // struct ct_data_s bl_tree[2*BL_CODES+1];  /* Huffman tree for bit lengths */
    // Use flat array of DOUBLE size, with interleaved fata,
    // because JS does not support effective
    this.dyn_ltree = new Uint16Array($2dd4f45c8894762f$var$HEAP_SIZE * 2);
    this.dyn_dtree = new Uint16Array((2 * $2dd4f45c8894762f$var$D_CODES + 1) * 2);
    this.bl_tree = new Uint16Array((2 * $2dd4f45c8894762f$var$BL_CODES + 1) * 2);
    $2dd4f45c8894762f$var$zero(this.dyn_ltree);
    $2dd4f45c8894762f$var$zero(this.dyn_dtree);
    $2dd4f45c8894762f$var$zero(this.bl_tree);
    this.l_desc = null; /* desc. for literal tree */ 
    this.d_desc = null; /* desc. for distance tree */ 
    this.bl_desc = null; /* desc. for bit length tree */ 
    //ush bl_count[MAX_BITS+1];
    this.bl_count = new Uint16Array($2dd4f45c8894762f$var$MAX_BITS + 1);
    /* number of codes at each bit length for an optimal tree */ //int heap[2*L_CODES+1];      /* heap used to build the Huffman trees */
    this.heap = new Uint16Array(2 * $2dd4f45c8894762f$var$L_CODES + 1); /* heap used to build the Huffman trees */ 
    $2dd4f45c8894762f$var$zero(this.heap);
    this.heap_len = 0; /* number of elements in the heap */ 
    this.heap_max = 0; /* element of largest frequency */ 
    /* The sons of heap[n] are heap[2*n] and heap[2*n+1]. heap[0] is not used.
   * The same heap array is used to build all trees.
   */ this.depth = new Uint16Array(2 * $2dd4f45c8894762f$var$L_CODES + 1); //uch depth[2*L_CODES+1];
    $2dd4f45c8894762f$var$zero(this.depth);
    /* Depth of each subtree used as tie breaker for trees of equal frequency
   */ this.sym_buf = 0; /* buffer for distances and literals/lengths */ 
    this.lit_bufsize = 0;
    /* Size of match buffer for literals/lengths.  There are 4 reasons for
   * limiting lit_bufsize to 64K:
   *   - frequencies can be kept in 16 bit counters
   *   - if compression is not successful for the first block, all input
   *     data is still in the window so we can still emit a stored block even
   *     when input comes from standard input.  (This can also be done for
   *     all blocks if lit_bufsize is not greater than 32K.)
   *   - if compression is not successful for a file smaller than 64K, we can
   *     even emit a stored file instead of a stored block (saving 5 bytes).
   *     This is applicable only for zip (not gzip or zlib).
   *   - creating new Huffman trees less frequently may not provide fast
   *     adaptation to changes in the input data statistics. (Take for
   *     example a binary file with poorly compressible code followed by
   *     a highly compressible string table.) Smaller buffer sizes give
   *     fast adaptation but have of course the overhead of transmitting
   *     trees more frequently.
   *   - I can't count above 4
   */ this.sym_next = 0; /* running index in sym_buf */ 
    this.sym_end = 0; /* symbol table full when sym_next reaches this */ 
    this.opt_len = 0; /* bit length of current block with optimal trees */ 
    this.static_len = 0; /* bit length of current block with static trees */ 
    this.matches = 0; /* number of string matches in current block */ 
    this.insert = 0; /* bytes at end of window left to insert */ 
    this.bi_buf = 0;
    /* Output buffer. bits are inserted starting at the bottom (least
   * significant bits).
   */ this.bi_valid = 0;
/* Number of valid bits in bi_buf.  All bits above the last valid bit
   * are always zero.
   */ // Used for window memory init. We safely ignore it for JS. That makes
// sense only for pointers and memory check tools.
//this.high_water = 0;
/* High water mark offset in window for initialized bytes -- bytes above
   * this are set to zero in order to avoid memory check warnings when
   * longest match routines access bytes past the input.  This is then
   * updated to the new high water mark.
   */ }
/* =========================================================================
 * Check for a valid deflate stream state. Return 0 if ok, 1 if not.
 */ const $2dd4f45c8894762f$var$deflateStateCheck = (strm)=>{
    if (!strm) return 1;
    const s = strm.state;
    if (!s || s.strm !== strm || s.status !== $2dd4f45c8894762f$var$INIT_STATE && //#ifdef GZIP
    s.status !== $2dd4f45c8894762f$var$GZIP_STATE && //#endif
    s.status !== $2dd4f45c8894762f$var$EXTRA_STATE && s.status !== $2dd4f45c8894762f$var$NAME_STATE && s.status !== $2dd4f45c8894762f$var$COMMENT_STATE && s.status !== $2dd4f45c8894762f$var$HCRC_STATE && s.status !== $2dd4f45c8894762f$var$BUSY_STATE && s.status !== $2dd4f45c8894762f$var$FINISH_STATE) return 1;
    return 0;
};
const $2dd4f45c8894762f$var$deflateResetKeep = (strm)=>{
    if ($2dd4f45c8894762f$var$deflateStateCheck(strm)) return $2dd4f45c8894762f$var$err(strm, $2dd4f45c8894762f$var$Z_STREAM_ERROR$2);
    strm.total_in = strm.total_out = 0;
    strm.data_type = $2dd4f45c8894762f$var$Z_UNKNOWN;
    const s = strm.state;
    s.pending = 0;
    s.pending_out = 0;
    if (s.wrap < 0) s.wrap = -s.wrap;
    s.status = //#ifdef GZIP
    s.wrap === 2 ? $2dd4f45c8894762f$var$GZIP_STATE : //#endif
    s.wrap ? $2dd4f45c8894762f$var$INIT_STATE : $2dd4f45c8894762f$var$BUSY_STATE;
    strm.adler = s.wrap === 2 ? 0 // crc32(0, Z_NULL, 0)
     : 1; // adler32(0, Z_NULL, 0)
    s.last_flush = -2;
    $2dd4f45c8894762f$var$_tr_init(s);
    return $2dd4f45c8894762f$var$Z_OK$3;
};
const $2dd4f45c8894762f$var$deflateReset = (strm)=>{
    const ret = $2dd4f45c8894762f$var$deflateResetKeep(strm);
    if (ret === $2dd4f45c8894762f$var$Z_OK$3) $2dd4f45c8894762f$var$lm_init(strm.state);
    return ret;
};
const $2dd4f45c8894762f$var$deflateSetHeader = (strm, head)=>{
    if ($2dd4f45c8894762f$var$deflateStateCheck(strm) || strm.state.wrap !== 2) return $2dd4f45c8894762f$var$Z_STREAM_ERROR$2;
    strm.state.gzhead = head;
    return $2dd4f45c8894762f$var$Z_OK$3;
};
const $2dd4f45c8894762f$var$deflateInit2 = (strm, level, method, windowBits, memLevel, strategy)=>{
    if (!strm) return $2dd4f45c8894762f$var$Z_STREAM_ERROR$2;
    let wrap = 1;
    if (level === $2dd4f45c8894762f$var$Z_DEFAULT_COMPRESSION$1) level = 6;
    if (windowBits < 0) {
        wrap = 0;
        windowBits = -windowBits;
    } else if (windowBits > 15) {
        wrap = 2; /* write gzip wrapper instead */ 
        windowBits -= 16;
    }
    if (memLevel < 1 || memLevel > $2dd4f45c8894762f$var$MAX_MEM_LEVEL || method !== $2dd4f45c8894762f$var$Z_DEFLATED$2 || windowBits < 8 || windowBits > 15 || level < 0 || level > 9 || strategy < 0 || strategy > $2dd4f45c8894762f$var$Z_FIXED || windowBits === 8 && wrap !== 1) return $2dd4f45c8894762f$var$err(strm, $2dd4f45c8894762f$var$Z_STREAM_ERROR$2);
    if (windowBits === 8) windowBits = 9;
    /* until 256-byte window bug fixed */ const s = new $2dd4f45c8894762f$var$DeflateState();
    strm.state = s;
    s.strm = strm;
    s.status = $2dd4f45c8894762f$var$INIT_STATE; /* to pass state test in deflateReset() */ 
    s.wrap = wrap;
    s.gzhead = null;
    s.w_bits = windowBits;
    s.w_size = 1 << s.w_bits;
    s.w_mask = s.w_size - 1;
    s.hash_bits = memLevel + 7;
    s.hash_size = 1 << s.hash_bits;
    s.hash_mask = s.hash_size - 1;
    s.hash_shift = ~~((s.hash_bits + $2dd4f45c8894762f$var$MIN_MATCH - 1) / $2dd4f45c8894762f$var$MIN_MATCH);
    s.window = new Uint8Array(s.w_size * 2);
    s.head = new Uint16Array(s.hash_size);
    s.prev = new Uint16Array(s.w_size);
    // Don't need mem init magic for JS.
    //s.high_water = 0;  /* nothing written to s->window yet */
    s.lit_bufsize = 1 << memLevel + 6; /* 16K elements by default */ 
    /* We overlay pending_buf and sym_buf. This works since the average size
   * for length/distance pairs over any compressed block is assured to be 31
   * bits or less.
   *
   * Analysis: The longest fixed codes are a length code of 8 bits plus 5
   * extra bits, for lengths 131 to 257. The longest fixed distance codes are
   * 5 bits plus 13 extra bits, for distances 16385 to 32768. The longest
   * possible fixed-codes length/distance pair is then 31 bits total.
   *
   * sym_buf starts one-fourth of the way into pending_buf. So there are
   * three bytes in sym_buf for every four bytes in pending_buf. Each symbol
   * in sym_buf is three bytes -- two for the distance and one for the
   * literal/length. As each symbol is consumed, the pointer to the next
   * sym_buf value to read moves forward three bytes. From that symbol, up to
   * 31 bits are written to pending_buf. The closest the written pending_buf
   * bits gets to the next sym_buf symbol to read is just before the last
   * code is written. At that time, 31*(n-2) bits have been written, just
   * after 24*(n-2) bits have been consumed from sym_buf. sym_buf starts at
   * 8*n bits into pending_buf. (Note that the symbol buffer fills when n-1
   * symbols are written.) The closest the writing gets to what is unread is
   * then n+14 bits. Here n is lit_bufsize, which is 16384 by default, and
   * can range from 128 to 32768.
   *
   * Therefore, at a minimum, there are 142 bits of space between what is
   * written and what is read in the overlain buffers, so the symbols cannot
   * be overwritten by the compressed data. That space is actually 139 bits,
   * due to the three-bit fixed-code block header.
   *
   * That covers the case where either Z_FIXED is specified, forcing fixed
   * codes, or when the use of fixed codes is chosen, because that choice
   * results in a smaller compressed block than dynamic codes. That latter
   * condition then assures that the above analysis also covers all dynamic
   * blocks. A dynamic-code block will only be chosen to be emitted if it has
   * fewer bits than a fixed-code block would for the same set of symbols.
   * Therefore its average symbol length is assured to be less than 31. So
   * the compressed data for a dynamic block also cannot overwrite the
   * symbols from which it is being constructed.
   */ s.pending_buf_size = s.lit_bufsize * 4;
    s.pending_buf = new Uint8Array(s.pending_buf_size);
    // It is offset from `s.pending_buf` (size is `s.lit_bufsize * 2`)
    //s->sym_buf = s->pending_buf + s->lit_bufsize;
    s.sym_buf = s.lit_bufsize;
    //s->sym_end = (s->lit_bufsize - 1) * 3;
    s.sym_end = (s.lit_bufsize - 1) * 3;
    /* We avoid equality with lit_bufsize*3 because of wraparound at 64K
   * on 16 bit machines and because stored blocks are restricted to
   * 64K-1 bytes.
   */ s.level = level;
    s.strategy = strategy;
    s.method = method;
    return $2dd4f45c8894762f$var$deflateReset(strm);
};
const $2dd4f45c8894762f$var$deflateInit = (strm, level)=>{
    return $2dd4f45c8894762f$var$deflateInit2(strm, level, $2dd4f45c8894762f$var$Z_DEFLATED$2, $2dd4f45c8894762f$var$MAX_WBITS$1, $2dd4f45c8894762f$var$DEF_MEM_LEVEL, $2dd4f45c8894762f$var$Z_DEFAULT_STRATEGY$1);
};
/* ========================================================================= */ const $2dd4f45c8894762f$var$deflate$2 = (strm, flush)=>{
    if ($2dd4f45c8894762f$var$deflateStateCheck(strm) || flush > $2dd4f45c8894762f$var$Z_BLOCK$1 || flush < 0) return strm ? $2dd4f45c8894762f$var$err(strm, $2dd4f45c8894762f$var$Z_STREAM_ERROR$2) : $2dd4f45c8894762f$var$Z_STREAM_ERROR$2;
    const s = strm.state;
    if (!strm.output || strm.avail_in !== 0 && !strm.input || s.status === $2dd4f45c8894762f$var$FINISH_STATE && flush !== $2dd4f45c8894762f$var$Z_FINISH$3) return $2dd4f45c8894762f$var$err(strm, strm.avail_out === 0 ? $2dd4f45c8894762f$var$Z_BUF_ERROR$1 : $2dd4f45c8894762f$var$Z_STREAM_ERROR$2);
    const old_flush = s.last_flush;
    s.last_flush = flush;
    /* Flush as much pending output as possible */ if (s.pending !== 0) {
        $2dd4f45c8894762f$var$flush_pending(strm);
        if (strm.avail_out === 0) {
            /* Since avail_out is 0, deflate will be called again with
       * more output space, but possibly with both pending and
       * avail_in equal to zero. There won't be anything to do,
       * but this is not an error situation so make sure we
       * return OK instead of BUF_ERROR at next call of deflate:
       */ s.last_flush = -1;
            return $2dd4f45c8894762f$var$Z_OK$3;
        }
    /* Make sure there is something to do and avoid duplicate consecutive
     * flushes. For repeated and useless calls with Z_FINISH, we keep
     * returning Z_STREAM_END instead of Z_BUF_ERROR.
     */ } else if (strm.avail_in === 0 && $2dd4f45c8894762f$var$rank(flush) <= $2dd4f45c8894762f$var$rank(old_flush) && flush !== $2dd4f45c8894762f$var$Z_FINISH$3) return $2dd4f45c8894762f$var$err(strm, $2dd4f45c8894762f$var$Z_BUF_ERROR$1);
    /* User must not provide more input after the first FINISH: */ if (s.status === $2dd4f45c8894762f$var$FINISH_STATE && strm.avail_in !== 0) return $2dd4f45c8894762f$var$err(strm, $2dd4f45c8894762f$var$Z_BUF_ERROR$1);
    /* Write the header */ if (s.status === $2dd4f45c8894762f$var$INIT_STATE && s.wrap === 0) s.status = $2dd4f45c8894762f$var$BUSY_STATE;
    if (s.status === $2dd4f45c8894762f$var$INIT_STATE) {
        /* zlib header */ let header = $2dd4f45c8894762f$var$Z_DEFLATED$2 + (s.w_bits - 8 << 4) << 8;
        let level_flags = -1;
        if (s.strategy >= $2dd4f45c8894762f$var$Z_HUFFMAN_ONLY || s.level < 2) level_flags = 0;
        else if (s.level < 6) level_flags = 1;
        else if (s.level === 6) level_flags = 2;
        else level_flags = 3;
        header |= level_flags << 6;
        if (s.strstart !== 0) header |= $2dd4f45c8894762f$var$PRESET_DICT;
        header += 31 - header % 31;
        $2dd4f45c8894762f$var$putShortMSB(s, header);
        /* Save the adler32 of the preset dictionary: */ if (s.strstart !== 0) {
            $2dd4f45c8894762f$var$putShortMSB(s, strm.adler >>> 16);
            $2dd4f45c8894762f$var$putShortMSB(s, strm.adler & 0xffff);
        }
        strm.adler = 1; // adler32(0L, Z_NULL, 0);
        s.status = $2dd4f45c8894762f$var$BUSY_STATE;
        /* Compression must start with an empty pending buffer */ $2dd4f45c8894762f$var$flush_pending(strm);
        if (s.pending !== 0) {
            s.last_flush = -1;
            return $2dd4f45c8894762f$var$Z_OK$3;
        }
    }
    //#ifdef GZIP
    if (s.status === $2dd4f45c8894762f$var$GZIP_STATE) {
        /* gzip header */ strm.adler = 0; //crc32(0L, Z_NULL, 0);
        $2dd4f45c8894762f$var$put_byte(s, 31);
        $2dd4f45c8894762f$var$put_byte(s, 139);
        $2dd4f45c8894762f$var$put_byte(s, 8);
        if (!s.gzhead) {
            $2dd4f45c8894762f$var$put_byte(s, 0);
            $2dd4f45c8894762f$var$put_byte(s, 0);
            $2dd4f45c8894762f$var$put_byte(s, 0);
            $2dd4f45c8894762f$var$put_byte(s, 0);
            $2dd4f45c8894762f$var$put_byte(s, 0);
            $2dd4f45c8894762f$var$put_byte(s, s.level === 9 ? 2 : s.strategy >= $2dd4f45c8894762f$var$Z_HUFFMAN_ONLY || s.level < 2 ? 4 : 0);
            $2dd4f45c8894762f$var$put_byte(s, $2dd4f45c8894762f$var$OS_CODE);
            s.status = $2dd4f45c8894762f$var$BUSY_STATE;
            /* Compression must start with an empty pending buffer */ $2dd4f45c8894762f$var$flush_pending(strm);
            if (s.pending !== 0) {
                s.last_flush = -1;
                return $2dd4f45c8894762f$var$Z_OK$3;
            }
        } else {
            $2dd4f45c8894762f$var$put_byte(s, (s.gzhead.text ? 1 : 0) + (s.gzhead.hcrc ? 2 : 0) + (!s.gzhead.extra ? 0 : 4) + (!s.gzhead.name ? 0 : 8) + (!s.gzhead.comment ? 0 : 16));
            $2dd4f45c8894762f$var$put_byte(s, s.gzhead.time & 0xff);
            $2dd4f45c8894762f$var$put_byte(s, s.gzhead.time >> 8 & 0xff);
            $2dd4f45c8894762f$var$put_byte(s, s.gzhead.time >> 16 & 0xff);
            $2dd4f45c8894762f$var$put_byte(s, s.gzhead.time >> 24 & 0xff);
            $2dd4f45c8894762f$var$put_byte(s, s.level === 9 ? 2 : s.strategy >= $2dd4f45c8894762f$var$Z_HUFFMAN_ONLY || s.level < 2 ? 4 : 0);
            $2dd4f45c8894762f$var$put_byte(s, s.gzhead.os & 0xff);
            if (s.gzhead.extra && s.gzhead.extra.length) {
                $2dd4f45c8894762f$var$put_byte(s, s.gzhead.extra.length & 0xff);
                $2dd4f45c8894762f$var$put_byte(s, s.gzhead.extra.length >> 8 & 0xff);
            }
            if (s.gzhead.hcrc) strm.adler = $2dd4f45c8894762f$var$crc32_1(strm.adler, s.pending_buf, s.pending, 0);
            s.gzindex = 0;
            s.status = $2dd4f45c8894762f$var$EXTRA_STATE;
        }
    }
    if (s.status === $2dd4f45c8894762f$var$EXTRA_STATE) {
        if (s.gzhead.extra /* != Z_NULL*/ ) {
            let beg = s.pending; /* start of bytes to update crc */ 
            let left = (s.gzhead.extra.length & 0xffff) - s.gzindex;
            while(s.pending + left > s.pending_buf_size){
                let copy = s.pending_buf_size - s.pending;
                // zmemcpy(s.pending_buf + s.pending,
                //    s.gzhead.extra + s.gzindex, copy);
                s.pending_buf.set(s.gzhead.extra.subarray(s.gzindex, s.gzindex + copy), s.pending);
                s.pending = s.pending_buf_size;
                //--- HCRC_UPDATE(beg) ---//
                if (s.gzhead.hcrc && s.pending > beg) strm.adler = $2dd4f45c8894762f$var$crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
                //---//
                s.gzindex += copy;
                $2dd4f45c8894762f$var$flush_pending(strm);
                if (s.pending !== 0) {
                    s.last_flush = -1;
                    return $2dd4f45c8894762f$var$Z_OK$3;
                }
                beg = 0;
                left -= copy;
            }
            // JS specific: s.gzhead.extra may be TypedArray or Array for backward compatibility
            //              TypedArray.slice and TypedArray.from don't exist in IE10-IE11
            let gzhead_extra = new Uint8Array(s.gzhead.extra);
            // zmemcpy(s->pending_buf + s->pending,
            //     s->gzhead->extra + s->gzindex, left);
            s.pending_buf.set(gzhead_extra.subarray(s.gzindex, s.gzindex + left), s.pending);
            s.pending += left;
            //--- HCRC_UPDATE(beg) ---//
            if (s.gzhead.hcrc && s.pending > beg) strm.adler = $2dd4f45c8894762f$var$crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
            //---//
            s.gzindex = 0;
        }
        s.status = $2dd4f45c8894762f$var$NAME_STATE;
    }
    if (s.status === $2dd4f45c8894762f$var$NAME_STATE) {
        if (s.gzhead.name /* != Z_NULL*/ ) {
            let beg = s.pending; /* start of bytes to update crc */ 
            let val;
            do {
                if (s.pending === s.pending_buf_size) {
                    //--- HCRC_UPDATE(beg) ---//
                    if (s.gzhead.hcrc && s.pending > beg) strm.adler = $2dd4f45c8894762f$var$crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
                    //---//
                    $2dd4f45c8894762f$var$flush_pending(strm);
                    if (s.pending !== 0) {
                        s.last_flush = -1;
                        return $2dd4f45c8894762f$var$Z_OK$3;
                    }
                    beg = 0;
                }
                // JS specific: little magic to add zero terminator to end of string
                if (s.gzindex < s.gzhead.name.length) val = s.gzhead.name.charCodeAt(s.gzindex++) & 0xff;
                else val = 0;
                $2dd4f45c8894762f$var$put_byte(s, val);
            }while (val !== 0);
            //--- HCRC_UPDATE(beg) ---//
            if (s.gzhead.hcrc && s.pending > beg) strm.adler = $2dd4f45c8894762f$var$crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
            //---//
            s.gzindex = 0;
        }
        s.status = $2dd4f45c8894762f$var$COMMENT_STATE;
    }
    if (s.status === $2dd4f45c8894762f$var$COMMENT_STATE) {
        if (s.gzhead.comment /* != Z_NULL*/ ) {
            let beg = s.pending; /* start of bytes to update crc */ 
            let val;
            do {
                if (s.pending === s.pending_buf_size) {
                    //--- HCRC_UPDATE(beg) ---//
                    if (s.gzhead.hcrc && s.pending > beg) strm.adler = $2dd4f45c8894762f$var$crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
                    //---//
                    $2dd4f45c8894762f$var$flush_pending(strm);
                    if (s.pending !== 0) {
                        s.last_flush = -1;
                        return $2dd4f45c8894762f$var$Z_OK$3;
                    }
                    beg = 0;
                }
                // JS specific: little magic to add zero terminator to end of string
                if (s.gzindex < s.gzhead.comment.length) val = s.gzhead.comment.charCodeAt(s.gzindex++) & 0xff;
                else val = 0;
                $2dd4f45c8894762f$var$put_byte(s, val);
            }while (val !== 0);
            //--- HCRC_UPDATE(beg) ---//
            if (s.gzhead.hcrc && s.pending > beg) strm.adler = $2dd4f45c8894762f$var$crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
        //---//
        }
        s.status = $2dd4f45c8894762f$var$HCRC_STATE;
    }
    if (s.status === $2dd4f45c8894762f$var$HCRC_STATE) {
        if (s.gzhead.hcrc) {
            if (s.pending + 2 > s.pending_buf_size) {
                $2dd4f45c8894762f$var$flush_pending(strm);
                if (s.pending !== 0) {
                    s.last_flush = -1;
                    return $2dd4f45c8894762f$var$Z_OK$3;
                }
            }
            $2dd4f45c8894762f$var$put_byte(s, strm.adler & 0xff);
            $2dd4f45c8894762f$var$put_byte(s, strm.adler >> 8 & 0xff);
            strm.adler = 0; //crc32(0L, Z_NULL, 0);
        }
        s.status = $2dd4f45c8894762f$var$BUSY_STATE;
        /* Compression must start with an empty pending buffer */ $2dd4f45c8894762f$var$flush_pending(strm);
        if (s.pending !== 0) {
            s.last_flush = -1;
            return $2dd4f45c8894762f$var$Z_OK$3;
        }
    }
    //#endif
    /* Start a new block or continue the current one.
   */ if (strm.avail_in !== 0 || s.lookahead !== 0 || flush !== $2dd4f45c8894762f$var$Z_NO_FLUSH$2 && s.status !== $2dd4f45c8894762f$var$FINISH_STATE) {
        let bstate = s.level === 0 ? $2dd4f45c8894762f$var$deflate_stored(s, flush) : s.strategy === $2dd4f45c8894762f$var$Z_HUFFMAN_ONLY ? $2dd4f45c8894762f$var$deflate_huff(s, flush) : s.strategy === $2dd4f45c8894762f$var$Z_RLE ? $2dd4f45c8894762f$var$deflate_rle(s, flush) : $2dd4f45c8894762f$var$configuration_table[s.level].func(s, flush);
        if (bstate === $2dd4f45c8894762f$var$BS_FINISH_STARTED || bstate === $2dd4f45c8894762f$var$BS_FINISH_DONE) s.status = $2dd4f45c8894762f$var$FINISH_STATE;
        if (bstate === $2dd4f45c8894762f$var$BS_NEED_MORE || bstate === $2dd4f45c8894762f$var$BS_FINISH_STARTED) {
            if (strm.avail_out === 0) s.last_flush = -1;
            return $2dd4f45c8894762f$var$Z_OK$3;
        /* If flush != Z_NO_FLUSH && avail_out == 0, the next call
       * of deflate should use the same flush parameter to make sure
       * that the flush is complete. So we don't have to output an
       * empty block here, this will be done at next call. This also
       * ensures that for a very small output buffer, we emit at most
       * one empty block.
       */ }
        if (bstate === $2dd4f45c8894762f$var$BS_BLOCK_DONE) {
            if (flush === $2dd4f45c8894762f$var$Z_PARTIAL_FLUSH) $2dd4f45c8894762f$var$_tr_align(s);
            else if (flush !== $2dd4f45c8894762f$var$Z_BLOCK$1) {
                $2dd4f45c8894762f$var$_tr_stored_block(s, 0, 0, false);
                /* For a full flush, this empty block will be recognized
         * as a special marker by inflate_sync().
         */ if (flush === $2dd4f45c8894762f$var$Z_FULL_FLUSH$1) {
                    /*** CLEAR_HASH(s); ***/ /* forget history */ $2dd4f45c8894762f$var$zero(s.head); // Fill with NIL (= 0);
                    if (s.lookahead === 0) {
                        s.strstart = 0;
                        s.block_start = 0;
                        s.insert = 0;
                    }
                }
            }
            $2dd4f45c8894762f$var$flush_pending(strm);
            if (strm.avail_out === 0) {
                s.last_flush = -1; /* avoid BUF_ERROR at next call, see above */ 
                return $2dd4f45c8894762f$var$Z_OK$3;
            }
        }
    }
    if (flush !== $2dd4f45c8894762f$var$Z_FINISH$3) return $2dd4f45c8894762f$var$Z_OK$3;
    if (s.wrap <= 0) return $2dd4f45c8894762f$var$Z_STREAM_END$3;
    /* Write the trailer */ if (s.wrap === 2) {
        $2dd4f45c8894762f$var$put_byte(s, strm.adler & 0xff);
        $2dd4f45c8894762f$var$put_byte(s, strm.adler >> 8 & 0xff);
        $2dd4f45c8894762f$var$put_byte(s, strm.adler >> 16 & 0xff);
        $2dd4f45c8894762f$var$put_byte(s, strm.adler >> 24 & 0xff);
        $2dd4f45c8894762f$var$put_byte(s, strm.total_in & 0xff);
        $2dd4f45c8894762f$var$put_byte(s, strm.total_in >> 8 & 0xff);
        $2dd4f45c8894762f$var$put_byte(s, strm.total_in >> 16 & 0xff);
        $2dd4f45c8894762f$var$put_byte(s, strm.total_in >> 24 & 0xff);
    } else {
        $2dd4f45c8894762f$var$putShortMSB(s, strm.adler >>> 16);
        $2dd4f45c8894762f$var$putShortMSB(s, strm.adler & 0xffff);
    }
    $2dd4f45c8894762f$var$flush_pending(strm);
    /* If avail_out is zero, the application will call deflate again
   * to flush the rest.
   */ if (s.wrap > 0) s.wrap = -s.wrap;
    /* write the trailer only once! */ return s.pending !== 0 ? $2dd4f45c8894762f$var$Z_OK$3 : $2dd4f45c8894762f$var$Z_STREAM_END$3;
};
const $2dd4f45c8894762f$var$deflateEnd = (strm)=>{
    if ($2dd4f45c8894762f$var$deflateStateCheck(strm)) return $2dd4f45c8894762f$var$Z_STREAM_ERROR$2;
    const status = strm.state.status;
    strm.state = null;
    return status === $2dd4f45c8894762f$var$BUSY_STATE ? $2dd4f45c8894762f$var$err(strm, $2dd4f45c8894762f$var$Z_DATA_ERROR$2) : $2dd4f45c8894762f$var$Z_OK$3;
};
/* =========================================================================
 * Initializes the compression dictionary from the given byte
 * sequence without producing any compressed output.
 */ const $2dd4f45c8894762f$var$deflateSetDictionary = (strm, dictionary)=>{
    let dictLength = dictionary.length;
    if ($2dd4f45c8894762f$var$deflateStateCheck(strm)) return $2dd4f45c8894762f$var$Z_STREAM_ERROR$2;
    const s = strm.state;
    const wrap = s.wrap;
    if (wrap === 2 || wrap === 1 && s.status !== $2dd4f45c8894762f$var$INIT_STATE || s.lookahead) return $2dd4f45c8894762f$var$Z_STREAM_ERROR$2;
    /* when using zlib wrappers, compute Adler-32 for provided dictionary */ if (wrap === 1) /* adler32(strm->adler, dictionary, dictLength); */ strm.adler = $2dd4f45c8894762f$var$adler32_1(strm.adler, dictionary, dictLength, 0);
    s.wrap = 0; /* avoid computing Adler-32 in read_buf */ 
    /* if dictionary would fill window, just replace the history */ if (dictLength >= s.w_size) {
        if (wrap === 0) {
            /*** CLEAR_HASH(s); ***/ $2dd4f45c8894762f$var$zero(s.head); // Fill with NIL (= 0);
            s.strstart = 0;
            s.block_start = 0;
            s.insert = 0;
        }
        /* use the tail */ // dictionary = dictionary.slice(dictLength - s.w_size);
        let tmpDict = new Uint8Array(s.w_size);
        tmpDict.set(dictionary.subarray(dictLength - s.w_size, dictLength), 0);
        dictionary = tmpDict;
        dictLength = s.w_size;
    }
    /* insert dictionary into window and hash */ const avail = strm.avail_in;
    const next = strm.next_in;
    const input = strm.input;
    strm.avail_in = dictLength;
    strm.next_in = 0;
    strm.input = dictionary;
    $2dd4f45c8894762f$var$fill_window(s);
    while(s.lookahead >= $2dd4f45c8894762f$var$MIN_MATCH){
        let str = s.strstart;
        let n = s.lookahead - ($2dd4f45c8894762f$var$MIN_MATCH - 1);
        do {
            /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */ s.ins_h = $2dd4f45c8894762f$var$HASH(s, s.ins_h, s.window[str + $2dd4f45c8894762f$var$MIN_MATCH - 1]);
            s.prev[str & s.w_mask] = s.head[s.ins_h];
            s.head[s.ins_h] = str;
            str++;
        }while (--n);
        s.strstart = str;
        s.lookahead = $2dd4f45c8894762f$var$MIN_MATCH - 1;
        $2dd4f45c8894762f$var$fill_window(s);
    }
    s.strstart += s.lookahead;
    s.block_start = s.strstart;
    s.insert = s.lookahead;
    s.lookahead = 0;
    s.match_length = s.prev_length = $2dd4f45c8894762f$var$MIN_MATCH - 1;
    s.match_available = 0;
    strm.next_in = next;
    strm.input = input;
    strm.avail_in = avail;
    s.wrap = wrap;
    return $2dd4f45c8894762f$var$Z_OK$3;
};
var $2dd4f45c8894762f$var$deflateInit_1 = $2dd4f45c8894762f$var$deflateInit;
var $2dd4f45c8894762f$var$deflateInit2_1 = $2dd4f45c8894762f$var$deflateInit2;
var $2dd4f45c8894762f$var$deflateReset_1 = $2dd4f45c8894762f$var$deflateReset;
var $2dd4f45c8894762f$var$deflateResetKeep_1 = $2dd4f45c8894762f$var$deflateResetKeep;
var $2dd4f45c8894762f$var$deflateSetHeader_1 = $2dd4f45c8894762f$var$deflateSetHeader;
var $2dd4f45c8894762f$var$deflate_2$1 = $2dd4f45c8894762f$var$deflate$2;
var $2dd4f45c8894762f$var$deflateEnd_1 = $2dd4f45c8894762f$var$deflateEnd;
var $2dd4f45c8894762f$var$deflateSetDictionary_1 = $2dd4f45c8894762f$var$deflateSetDictionary;
var $2dd4f45c8894762f$var$deflateInfo = 'pako deflate (from Nodeca project)';
/* Not implemented
module.exports.deflateBound = deflateBound;
module.exports.deflateCopy = deflateCopy;
module.exports.deflateGetDictionary = deflateGetDictionary;
module.exports.deflateParams = deflateParams;
module.exports.deflatePending = deflatePending;
module.exports.deflatePrime = deflatePrime;
module.exports.deflateTune = deflateTune;
*/ var $2dd4f45c8894762f$var$deflate_1$2 = {
    deflateInit: $2dd4f45c8894762f$var$deflateInit_1,
    deflateInit2: $2dd4f45c8894762f$var$deflateInit2_1,
    deflateReset: $2dd4f45c8894762f$var$deflateReset_1,
    deflateResetKeep: $2dd4f45c8894762f$var$deflateResetKeep_1,
    deflateSetHeader: $2dd4f45c8894762f$var$deflateSetHeader_1,
    deflate: $2dd4f45c8894762f$var$deflate_2$1,
    deflateEnd: $2dd4f45c8894762f$var$deflateEnd_1,
    deflateSetDictionary: $2dd4f45c8894762f$var$deflateSetDictionary_1,
    deflateInfo: $2dd4f45c8894762f$var$deflateInfo
};
const $2dd4f45c8894762f$var$_has = (obj, key)=>{
    return Object.prototype.hasOwnProperty.call(obj, key);
};
var $2dd4f45c8894762f$var$assign = function(obj /*from1, from2, from3, ...*/ ) {
    const sources = Array.prototype.slice.call(arguments, 1);
    while(sources.length){
        const source = sources.shift();
        if (!source) continue;
        if (typeof source !== 'object') throw new TypeError(source + 'must be non-object');
        for(const p in source)if ($2dd4f45c8894762f$var$_has(source, p)) obj[p] = source[p];
    }
    return obj;
};
// Join array of chunks to single array.
var $2dd4f45c8894762f$var$flattenChunks = (chunks)=>{
    // calculate data length
    let len = 0;
    for(let i = 0, l = chunks.length; i < l; i++)len += chunks[i].length;
    // join chunks
    const result = new Uint8Array(len);
    for(let i = 0, pos = 0, l = chunks.length; i < l; i++){
        let chunk = chunks[i];
        result.set(chunk, pos);
        pos += chunk.length;
    }
    return result;
};
var $2dd4f45c8894762f$var$common = {
    assign: $2dd4f45c8894762f$var$assign,
    flattenChunks: $2dd4f45c8894762f$var$flattenChunks
};
// String encode/decode helpers
// Quick check if we can use fast array to bin string conversion
//
// - apply(Array) can fail on Android 2.2
// - apply(Uint8Array) can fail on iOS 5.1 Safari
//
let $2dd4f45c8894762f$var$STR_APPLY_UIA_OK = true;
try {
    String.fromCharCode.apply(null, new Uint8Array(1));
} catch (__) {
    $2dd4f45c8894762f$var$STR_APPLY_UIA_OK = false;
}
// Table with utf8 lengths (calculated by first byte of sequence)
// Note, that 5 & 6-byte values and some 4-byte values can not be represented in JS,
// because max possible codepoint is 0x10ffff
const $2dd4f45c8894762f$var$_utf8len = new Uint8Array(256);
for(let q = 0; q < 256; q++)$2dd4f45c8894762f$var$_utf8len[q] = q >= 252 ? 6 : q >= 248 ? 5 : q >= 240 ? 4 : q >= 224 ? 3 : q >= 192 ? 2 : 1;
$2dd4f45c8894762f$var$_utf8len[254] = $2dd4f45c8894762f$var$_utf8len[254] = 1; // Invalid sequence start
// convert string to array (typed, when possible)
var $2dd4f45c8894762f$var$string2buf = (str)=>{
    if (typeof TextEncoder === 'function' && TextEncoder.prototype.encode) return new TextEncoder().encode(str);
    let buf, c, c2, m_pos, i, str_len = str.length, buf_len = 0;
    // count binary size
    for(m_pos = 0; m_pos < str_len; m_pos++){
        c = str.charCodeAt(m_pos);
        if ((c & 0xfc00) === 0xd800 && m_pos + 1 < str_len) {
            c2 = str.charCodeAt(m_pos + 1);
            if ((c2 & 0xfc00) === 0xdc00) {
                c = 0x10000 + (c - 0xd800 << 10) + (c2 - 0xdc00);
                m_pos++;
            }
        }
        buf_len += c < 0x80 ? 1 : c < 0x800 ? 2 : c < 0x10000 ? 3 : 4;
    }
    // allocate buffer
    buf = new Uint8Array(buf_len);
    // convert
    for(i = 0, m_pos = 0; i < buf_len; m_pos++){
        c = str.charCodeAt(m_pos);
        if ((c & 0xfc00) === 0xd800 && m_pos + 1 < str_len) {
            c2 = str.charCodeAt(m_pos + 1);
            if ((c2 & 0xfc00) === 0xdc00) {
                c = 0x10000 + (c - 0xd800 << 10) + (c2 - 0xdc00);
                m_pos++;
            }
        }
        if (c < 0x80) /* one byte */ buf[i++] = c;
        else if (c < 0x800) {
            /* two bytes */ buf[i++] = 0xC0 | c >>> 6;
            buf[i++] = 0x80 | c & 0x3f;
        } else if (c < 0x10000) {
            /* three bytes */ buf[i++] = 0xE0 | c >>> 12;
            buf[i++] = 0x80 | c >>> 6 & 0x3f;
            buf[i++] = 0x80 | c & 0x3f;
        } else {
            /* four bytes */ buf[i++] = 0xf0 | c >>> 18;
            buf[i++] = 0x80 | c >>> 12 & 0x3f;
            buf[i++] = 0x80 | c >>> 6 & 0x3f;
            buf[i++] = 0x80 | c & 0x3f;
        }
    }
    return buf;
};
// Helper
const $2dd4f45c8894762f$var$buf2binstring = (buf, len)=>{
    // On Chrome, the arguments in a function call that are allowed is `65534`.
    // If the length of the buffer is smaller than that, we can use this optimization,
    // otherwise we will take a slower path.
    if (len < 65534) {
        if (buf.subarray && $2dd4f45c8894762f$var$STR_APPLY_UIA_OK) return String.fromCharCode.apply(null, buf.length === len ? buf : buf.subarray(0, len));
    }
    let result = '';
    for(let i = 0; i < len; i++)result += String.fromCharCode(buf[i]);
    return result;
};
// convert array to string
var $2dd4f45c8894762f$var$buf2string = (buf, max)=>{
    const len = max || buf.length;
    if (typeof TextDecoder === 'function' && TextDecoder.prototype.decode) return new TextDecoder().decode(buf.subarray(0, max));
    let i, out;
    // Reserve max possible length (2 words per char)
    // NB: by unknown reasons, Array is significantly faster for
    //     String.fromCharCode.apply than Uint16Array.
    const utf16buf = new Array(len * 2);
    for(out = 0, i = 0; i < len;){
        let c = buf[i++];
        // quick process ascii
        if (c < 0x80) {
            utf16buf[out++] = c;
            continue;
        }
        let c_len = $2dd4f45c8894762f$var$_utf8len[c];
        // skip 5 & 6 byte codes
        if (c_len > 4) {
            utf16buf[out++] = 0xfffd;
            i += c_len - 1;
            continue;
        }
        // apply mask on first byte
        c &= c_len === 2 ? 0x1f : c_len === 3 ? 0x0f : 0x07;
        // join the rest
        while(c_len > 1 && i < len){
            c = c << 6 | buf[i++] & 0x3f;
            c_len--;
        }
        // terminated by end of string?
        if (c_len > 1) {
            utf16buf[out++] = 0xfffd;
            continue;
        }
        if (c < 0x10000) utf16buf[out++] = c;
        else {
            c -= 0x10000;
            utf16buf[out++] = 0xd800 | c >> 10 & 0x3ff;
            utf16buf[out++] = 0xdc00 | c & 0x3ff;
        }
    }
    return $2dd4f45c8894762f$var$buf2binstring(utf16buf, out);
};
// Calculate max possible position in utf8 buffer,
// that will not break sequence. If that's not possible
// - (very small limits) return max size as is.
//
// buf[] - utf8 bytes array
// max   - length limit (mandatory);
var $2dd4f45c8894762f$var$utf8border = (buf, max)=>{
    max = max || buf.length;
    if (max > buf.length) max = buf.length;
    // go back from last position, until start of sequence found
    let pos = max - 1;
    while(pos >= 0 && (buf[pos] & 0xC0) === 0x80)pos--;
    // Very small and broken sequence,
    // return max, because we should return something anyway.
    if (pos < 0) return max;
    // If we came to start of buffer - that means buffer is too small,
    // return max too.
    if (pos === 0) return max;
    return pos + $2dd4f45c8894762f$var$_utf8len[buf[pos]] > max ? pos : max;
};
var $2dd4f45c8894762f$var$strings = {
    string2buf: $2dd4f45c8894762f$var$string2buf,
    buf2string: $2dd4f45c8894762f$var$buf2string,
    utf8border: $2dd4f45c8894762f$var$utf8border
};
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
function $2dd4f45c8894762f$var$ZStream() {
    /* next input byte */ this.input = null; // JS specific, because we have no pointers
    this.next_in = 0;
    /* number of bytes available at input */ this.avail_in = 0;
    /* total number of input bytes read so far */ this.total_in = 0;
    /* next output byte should be put there */ this.output = null; // JS specific, because we have no pointers
    this.next_out = 0;
    /* remaining free space at output */ this.avail_out = 0;
    /* total number of bytes output so far */ this.total_out = 0;
    /* last error message, NULL if no error */ this.msg = '' /*Z_NULL*/ ;
    /* not visible by applications */ this.state = null;
    /* best guess about the data type: binary or text */ this.data_type = 2 /*Z_UNKNOWN*/ ;
    /* adler32 value of the uncompressed data */ this.adler = 0;
}
var $2dd4f45c8894762f$var$zstream = $2dd4f45c8894762f$var$ZStream;
const $2dd4f45c8894762f$var$toString$1 = Object.prototype.toString;
/* Public constants ==========================================================*/ /* ===========================================================================*/ const { Z_NO_FLUSH: $2dd4f45c8894762f$var$Z_NO_FLUSH$1, Z_SYNC_FLUSH: $2dd4f45c8894762f$var$Z_SYNC_FLUSH, Z_FULL_FLUSH: $2dd4f45c8894762f$var$Z_FULL_FLUSH, Z_FINISH: $2dd4f45c8894762f$var$Z_FINISH$2, Z_OK: $2dd4f45c8894762f$var$Z_OK$2, Z_STREAM_END: $2dd4f45c8894762f$var$Z_STREAM_END$2, Z_DEFAULT_COMPRESSION: $2dd4f45c8894762f$var$Z_DEFAULT_COMPRESSION, Z_DEFAULT_STRATEGY: $2dd4f45c8894762f$var$Z_DEFAULT_STRATEGY, Z_DEFLATED: $2dd4f45c8894762f$var$Z_DEFLATED$1 } = $2dd4f45c8894762f$var$constants$2;
/* ===========================================================================*/ /**
 * class Deflate
 *
 * Generic JS-style wrapper for zlib calls. If you don't need
 * streaming behaviour - use more simple functions: [[deflate]],
 * [[deflateRaw]] and [[gzip]].
 **/ /* internal
 * Deflate.chunks -> Array
 *
 * Chunks of output data, if [[Deflate#onData]] not overridden.
 **/ /**
 * Deflate.result -> Uint8Array
 *
 * Compressed result, generated by default [[Deflate#onData]]
 * and [[Deflate#onEnd]] handlers. Filled after you push last chunk
 * (call [[Deflate#push]] with `Z_FINISH` / `true` param).
 **/ /**
 * Deflate.err -> Number
 *
 * Error code after deflate finished. 0 (Z_OK) on success.
 * You will not need it in real life, because deflate errors
 * are possible only on wrong options or bad `onData` / `onEnd`
 * custom handlers.
 **/ /**
 * Deflate.msg -> String
 *
 * Error message, if [[Deflate.err]] != 0
 **/ /**
 * new Deflate(options)
 * - options (Object): zlib deflate options.
 *
 * Creates new deflator instance with specified params. Throws exception
 * on bad params. Supported options:
 *
 * - `level`
 * - `windowBits`
 * - `memLevel`
 * - `strategy`
 * - `dictionary`
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information on these.
 *
 * Additional options, for internal needs:
 *
 * - `chunkSize` - size of generated data chunks (16K by default)
 * - `raw` (Boolean) - do raw deflate
 * - `gzip` (Boolean) - create gzip wrapper
 * - `header` (Object) - custom header for gzip
 *   - `text` (Boolean) - true if compressed data believed to be text
 *   - `time` (Number) - modification time, unix timestamp
 *   - `os` (Number) - operation system code
 *   - `extra` (Array) - array of bytes with extra data (max 65536)
 *   - `name` (String) - file name (binary string)
 *   - `comment` (String) - comment (binary string)
 *   - `hcrc` (Boolean) - true if header crc should be added
 *
 * ##### Example:
 *
 * ```javascript
 * const pako = require('pako')
 *   , chunk1 = new Uint8Array([1,2,3,4,5,6,7,8,9])
 *   , chunk2 = new Uint8Array([10,11,12,13,14,15,16,17,18,19]);
 *
 * const deflate = new pako.Deflate({ level: 3});
 *
 * deflate.push(chunk1, false);
 * deflate.push(chunk2, true);  // true -> last chunk
 *
 * if (deflate.err) { throw new Error(deflate.err); }
 *
 * console.log(deflate.result);
 * ```
 **/ function $2dd4f45c8894762f$var$Deflate$1(options) {
    this.options = $2dd4f45c8894762f$var$common.assign({
        level: $2dd4f45c8894762f$var$Z_DEFAULT_COMPRESSION,
        method: $2dd4f45c8894762f$var$Z_DEFLATED$1,
        chunkSize: 16384,
        windowBits: 15,
        memLevel: 8,
        strategy: $2dd4f45c8894762f$var$Z_DEFAULT_STRATEGY
    }, options || {});
    let opt = this.options;
    if (opt.raw && opt.windowBits > 0) opt.windowBits = -opt.windowBits;
    else if (opt.gzip && opt.windowBits > 0 && opt.windowBits < 16) opt.windowBits += 16;
    this.err = 0; // error code, if happens (0 = Z_OK)
    this.msg = ''; // error message
    this.ended = false; // used to avoid multiple onEnd() calls
    this.chunks = []; // chunks of compressed data
    this.strm = new $2dd4f45c8894762f$var$zstream();
    this.strm.avail_out = 0;
    let status = $2dd4f45c8894762f$var$deflate_1$2.deflateInit2(this.strm, opt.level, opt.method, opt.windowBits, opt.memLevel, opt.strategy);
    if (status !== $2dd4f45c8894762f$var$Z_OK$2) throw new Error($2dd4f45c8894762f$var$messages[status]);
    if (opt.header) $2dd4f45c8894762f$var$deflate_1$2.deflateSetHeader(this.strm, opt.header);
    if (opt.dictionary) {
        let dict;
        // Convert data if needed
        if (typeof opt.dictionary === 'string') // If we need to compress text, change encoding to utf8.
        dict = $2dd4f45c8894762f$var$strings.string2buf(opt.dictionary);
        else if ($2dd4f45c8894762f$var$toString$1.call(opt.dictionary) === '[object ArrayBuffer]') dict = new Uint8Array(opt.dictionary);
        else dict = opt.dictionary;
        status = $2dd4f45c8894762f$var$deflate_1$2.deflateSetDictionary(this.strm, dict);
        if (status !== $2dd4f45c8894762f$var$Z_OK$2) throw new Error($2dd4f45c8894762f$var$messages[status]);
        this._dict_set = true;
    }
}
/**
 * Deflate#push(data[, flush_mode]) -> Boolean
 * - data (Uint8Array|ArrayBuffer|String): input data. Strings will be
 *   converted to utf8 byte sequence.
 * - flush_mode (Number|Boolean): 0..6 for corresponding Z_NO_FLUSH..Z_TREE modes.
 *   See constants. Skipped or `false` means Z_NO_FLUSH, `true` means Z_FINISH.
 *
 * Sends input data to deflate pipe, generating [[Deflate#onData]] calls with
 * new compressed chunks. Returns `true` on success. The last data block must
 * have `flush_mode` Z_FINISH (or `true`). That will flush internal pending
 * buffers and call [[Deflate#onEnd]].
 *
 * On fail call [[Deflate#onEnd]] with error code and return false.
 *
 * ##### Example
 *
 * ```javascript
 * push(chunk, false); // push one of data chunks
 * ...
 * push(chunk, true);  // push last chunk
 * ```
 **/ $2dd4f45c8894762f$var$Deflate$1.prototype.push = function(data, flush_mode) {
    const strm = this.strm;
    const chunkSize = this.options.chunkSize;
    let status, _flush_mode;
    if (this.ended) return false;
    if (flush_mode === ~~flush_mode) _flush_mode = flush_mode;
    else _flush_mode = flush_mode === true ? $2dd4f45c8894762f$var$Z_FINISH$2 : $2dd4f45c8894762f$var$Z_NO_FLUSH$1;
    // Convert data if needed
    if (typeof data === 'string') // If we need to compress text, change encoding to utf8.
    strm.input = $2dd4f45c8894762f$var$strings.string2buf(data);
    else if ($2dd4f45c8894762f$var$toString$1.call(data) === '[object ArrayBuffer]') strm.input = new Uint8Array(data);
    else strm.input = data;
    strm.next_in = 0;
    strm.avail_in = strm.input.length;
    for(;;){
        if (strm.avail_out === 0) {
            strm.output = new Uint8Array(chunkSize);
            strm.next_out = 0;
            strm.avail_out = chunkSize;
        }
        // Make sure avail_out > 6 to avoid repeating markers
        if ((_flush_mode === $2dd4f45c8894762f$var$Z_SYNC_FLUSH || _flush_mode === $2dd4f45c8894762f$var$Z_FULL_FLUSH) && strm.avail_out <= 6) {
            this.onData(strm.output.subarray(0, strm.next_out));
            strm.avail_out = 0;
            continue;
        }
        status = $2dd4f45c8894762f$var$deflate_1$2.deflate(strm, _flush_mode);
        // Ended => flush and finish
        if (status === $2dd4f45c8894762f$var$Z_STREAM_END$2) {
            if (strm.next_out > 0) this.onData(strm.output.subarray(0, strm.next_out));
            status = $2dd4f45c8894762f$var$deflate_1$2.deflateEnd(this.strm);
            this.onEnd(status);
            this.ended = true;
            return status === $2dd4f45c8894762f$var$Z_OK$2;
        }
        // Flush if out buffer full
        if (strm.avail_out === 0) {
            this.onData(strm.output);
            continue;
        }
        // Flush if requested and has data
        if (_flush_mode > 0 && strm.next_out > 0) {
            this.onData(strm.output.subarray(0, strm.next_out));
            strm.avail_out = 0;
            continue;
        }
        if (strm.avail_in === 0) break;
    }
    return true;
};
/**
 * Deflate#onData(chunk) -> Void
 * - chunk (Uint8Array): output data.
 *
 * By default, stores data blocks in `chunks[]` property and glue
 * those in `onEnd`. Override this handler, if you need another behaviour.
 **/ $2dd4f45c8894762f$var$Deflate$1.prototype.onData = function(chunk) {
    this.chunks.push(chunk);
};
/**
 * Deflate#onEnd(status) -> Void
 * - status (Number): deflate status. 0 (Z_OK) on success,
 *   other if not.
 *
 * Called once after you tell deflate that the input stream is
 * complete (Z_FINISH). By default - join collected chunks,
 * free memory and fill `results` / `err` properties.
 **/ $2dd4f45c8894762f$var$Deflate$1.prototype.onEnd = function(status) {
    // On success - join
    if (status === $2dd4f45c8894762f$var$Z_OK$2) this.result = $2dd4f45c8894762f$var$common.flattenChunks(this.chunks);
    this.chunks = [];
    this.err = status;
    this.msg = this.strm.msg;
};
/**
 * deflate(data[, options]) -> Uint8Array
 * - data (Uint8Array|ArrayBuffer|String): input data to compress.
 * - options (Object): zlib deflate options.
 *
 * Compress `data` with deflate algorithm and `options`.
 *
 * Supported options are:
 *
 * - level
 * - windowBits
 * - memLevel
 * - strategy
 * - dictionary
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information on these.
 *
 * Sugar (options):
 *
 * - `raw` (Boolean) - say that we work with raw stream, if you don't wish to specify
 *   negative windowBits implicitly.
 *
 * ##### Example:
 *
 * ```javascript
 * const pako = require('pako')
 * const data = new Uint8Array([1,2,3,4,5,6,7,8,9]);
 *
 * console.log(pako.deflate(data));
 * ```
 **/ function $2dd4f45c8894762f$var$deflate$1(input, options) {
    const deflator = new $2dd4f45c8894762f$var$Deflate$1(options);
    deflator.push(input, true);
    // That will never happens, if you don't cheat with options :)
    if (deflator.err) throw deflator.msg || $2dd4f45c8894762f$var$messages[deflator.err];
    return deflator.result;
}
/**
 * deflateRaw(data[, options]) -> Uint8Array
 * - data (Uint8Array|ArrayBuffer|String): input data to compress.
 * - options (Object): zlib deflate options.
 *
 * The same as [[deflate]], but creates raw data, without wrapper
 * (header and adler32 crc).
 **/ function $2dd4f45c8894762f$var$deflateRaw$1(input, options) {
    options = options || {};
    options.raw = true;
    return $2dd4f45c8894762f$var$deflate$1(input, options);
}
/**
 * gzip(data[, options]) -> Uint8Array
 * - data (Uint8Array|ArrayBuffer|String): input data to compress.
 * - options (Object): zlib deflate options.
 *
 * The same as [[deflate]], but create gzip wrapper instead of
 * deflate one.
 **/ function $2dd4f45c8894762f$var$gzip$1(input, options) {
    options = options || {};
    options.gzip = true;
    return $2dd4f45c8894762f$var$deflate$1(input, options);
}
var $2dd4f45c8894762f$var$Deflate_1$1 = $2dd4f45c8894762f$var$Deflate$1;
var $2dd4f45c8894762f$var$deflate_2 = $2dd4f45c8894762f$var$deflate$1;
var $2dd4f45c8894762f$var$deflateRaw_1$1 = $2dd4f45c8894762f$var$deflateRaw$1;
var $2dd4f45c8894762f$var$gzip_1$1 = $2dd4f45c8894762f$var$gzip$1;
var $2dd4f45c8894762f$var$constants$1 = $2dd4f45c8894762f$var$constants$2;
var $2dd4f45c8894762f$var$deflate_1$1 = {
    Deflate: $2dd4f45c8894762f$var$Deflate_1$1,
    deflate: $2dd4f45c8894762f$var$deflate_2,
    deflateRaw: $2dd4f45c8894762f$var$deflateRaw_1$1,
    gzip: $2dd4f45c8894762f$var$gzip_1$1,
    constants: $2dd4f45c8894762f$var$constants$1
};
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
// See state defs from inflate.js
const $2dd4f45c8894762f$var$BAD$1 = 16209; /* got a data error -- remain here until reset */ 
const $2dd4f45c8894762f$var$TYPE$1 = 16191; /* i: waiting for type bits, including last-flag bit */ 
/*
   Decode literal, length, and distance codes and write out the resulting
   literal and match bytes until either not enough input or output is
   available, an end-of-block is encountered, or a data error is encountered.
   When large enough input and output buffers are supplied to inflate(), for
   example, a 16K input buffer and a 64K output buffer, more than 95% of the
   inflate execution time is spent in this routine.

   Entry assumptions:

        state.mode === LEN
        strm.avail_in >= 6
        strm.avail_out >= 258
        start >= strm.avail_out
        state.bits < 8

   On return, state.mode is one of:

        LEN -- ran out of enough output space or enough available input
        TYPE -- reached end of block code, inflate() to interpret next block
        BAD -- error in block data

   Notes:

    - The maximum input bits used by a length/distance pair is 15 bits for the
      length code, 5 bits for the length extra, 15 bits for the distance code,
      and 13 bits for the distance extra.  This totals 48 bits, or six bytes.
      Therefore if strm.avail_in >= 6, then there is enough input to avoid
      checking for available input while decoding.

    - The maximum bytes that a single length/distance pair can output is 258
      bytes, which is the maximum length that can be coded.  inflate_fast()
      requires strm.avail_out >= 258 for each loop to avoid checking for
      output space.
 */ var $2dd4f45c8894762f$var$inffast = function inflate_fast(strm, start) {
    let _in; /* local strm.input */ 
    let last; /* have enough input while in < last */ 
    let _out; /* local strm.output */ 
    let beg; /* inflate()'s initial strm.output */ 
    let end; /* while out < end, enough space available */ 
    //#ifdef INFLATE_STRICT
    let dmax; /* maximum distance from zlib header */ 
    //#endif
    let wsize; /* window size or zero if not using window */ 
    let whave; /* valid bytes in the window */ 
    let wnext; /* window write index */ 
    // Use `s_window` instead `window`, avoid conflict with instrumentation tools
    let s_window; /* allocated sliding window, if wsize != 0 */ 
    let hold; /* local strm.hold */ 
    let bits; /* local strm.bits */ 
    let lcode; /* local strm.lencode */ 
    let dcode; /* local strm.distcode */ 
    let lmask; /* mask for first level of length codes */ 
    let dmask; /* mask for first level of distance codes */ 
    let here; /* retrieved table entry */ 
    let op; /* code bits, operation, extra bits, or */ 
    /*  window position, window bytes to copy */ let len; /* match length, unused bytes */ 
    let dist; /* match distance */ 
    let from; /* where to copy match from */ 
    let from_source;
    let input, output; // JS specific, because we have no pointers
    /* copy state to local variables */ const state = strm.state;
    //here = state.here;
    _in = strm.next_in;
    input = strm.input;
    last = _in + (strm.avail_in - 5);
    _out = strm.next_out;
    output = strm.output;
    beg = _out - (start - strm.avail_out);
    end = _out + (strm.avail_out - 257);
    //#ifdef INFLATE_STRICT
    dmax = state.dmax;
    //#endif
    wsize = state.wsize;
    whave = state.whave;
    wnext = state.wnext;
    s_window = state.window;
    hold = state.hold;
    bits = state.bits;
    lcode = state.lencode;
    dcode = state.distcode;
    lmask = (1 << state.lenbits) - 1;
    dmask = (1 << state.distbits) - 1;
    /* decode literals and length/distances until end-of-block or not enough
     input data or output space */ top: do {
        if (bits < 15) {
            hold += input[_in++] << bits;
            bits += 8;
            hold += input[_in++] << bits;
            bits += 8;
        }
        here = lcode[hold & lmask];
        dolen: for(;;){
            op = here >>> 24 /*here.bits*/ ;
            hold >>>= op;
            bits -= op;
            op = here >>> 16 & 0xff /*here.op*/ ;
            if (op === 0) //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
            //        "inflate:         literal '%c'\n" :
            //        "inflate:         literal 0x%02x\n", here.val));
            output[_out++] = here & 0xffff /*here.val*/ ;
            else if (op & 16) {
                len = here & 0xffff /*here.val*/ ;
                op &= 15; /* number of extra bits */ 
                if (op) {
                    if (bits < op) {
                        hold += input[_in++] << bits;
                        bits += 8;
                    }
                    len += hold & (1 << op) - 1;
                    hold >>>= op;
                    bits -= op;
                }
                //Tracevv((stderr, "inflate:         length %u\n", len));
                if (bits < 15) {
                    hold += input[_in++] << bits;
                    bits += 8;
                    hold += input[_in++] << bits;
                    bits += 8;
                }
                here = dcode[hold & dmask];
                dodist: for(;;){
                    op = here >>> 24 /*here.bits*/ ;
                    hold >>>= op;
                    bits -= op;
                    op = here >>> 16 & 0xff /*here.op*/ ;
                    if (op & 16) {
                        dist = here & 0xffff /*here.val*/ ;
                        op &= 15; /* number of extra bits */ 
                        if (bits < op) {
                            hold += input[_in++] << bits;
                            bits += 8;
                            if (bits < op) {
                                hold += input[_in++] << bits;
                                bits += 8;
                            }
                        }
                        dist += hold & (1 << op) - 1;
                        //#ifdef INFLATE_STRICT
                        if (dist > dmax) {
                            strm.msg = 'invalid distance too far back';
                            state.mode = $2dd4f45c8894762f$var$BAD$1;
                            break top;
                        }
                        //#endif
                        hold >>>= op;
                        bits -= op;
                        //Tracevv((stderr, "inflate:         distance %u\n", dist));
                        op = _out - beg; /* max distance in output */ 
                        if (dist > op) {
                            op = dist - op; /* distance back in window */ 
                            if (op > whave) {
                                if (state.sane) {
                                    strm.msg = 'invalid distance too far back';
                                    state.mode = $2dd4f45c8894762f$var$BAD$1;
                                    break top;
                                }
                            }
                            from = 0; // window index
                            from_source = s_window;
                            if (wnext === 0) {
                                from += wsize - op;
                                if (op < len) {
                                    len -= op;
                                    do output[_out++] = s_window[from++];
                                    while (--op);
                                    from = _out - dist; /* rest from output */ 
                                    from_source = output;
                                }
                            } else if (wnext < op) {
                                from += wsize + wnext - op;
                                op -= wnext;
                                if (op < len) {
                                    len -= op;
                                    do output[_out++] = s_window[from++];
                                    while (--op);
                                    from = 0;
                                    if (wnext < len) {
                                        op = wnext;
                                        len -= op;
                                        do output[_out++] = s_window[from++];
                                        while (--op);
                                        from = _out - dist; /* rest from output */ 
                                        from_source = output;
                                    }
                                }
                            } else {
                                from += wnext - op;
                                if (op < len) {
                                    len -= op;
                                    do output[_out++] = s_window[from++];
                                    while (--op);
                                    from = _out - dist; /* rest from output */ 
                                    from_source = output;
                                }
                            }
                            while(len > 2){
                                output[_out++] = from_source[from++];
                                output[_out++] = from_source[from++];
                                output[_out++] = from_source[from++];
                                len -= 3;
                            }
                            if (len) {
                                output[_out++] = from_source[from++];
                                if (len > 1) output[_out++] = from_source[from++];
                            }
                        } else {
                            from = _out - dist; /* copy direct from output */ 
                            do {
                                output[_out++] = output[from++];
                                output[_out++] = output[from++];
                                output[_out++] = output[from++];
                                len -= 3;
                            }while (len > 2);
                            if (len) {
                                output[_out++] = output[from++];
                                if (len > 1) output[_out++] = output[from++];
                            }
                        }
                    } else if ((op & 64) === 0) {
                        here = dcode[(here & 0xffff) + (hold & (1 << op) - 1)];
                        continue dodist;
                    } else {
                        strm.msg = 'invalid distance code';
                        state.mode = $2dd4f45c8894762f$var$BAD$1;
                        break top;
                    }
                    break; // need to emulate goto via "continue"
                }
            } else if ((op & 64) === 0) {
                here = lcode[(here & 0xffff) + (hold & (1 << op) - 1)];
                continue dolen;
            } else if (op & 32) {
                //Tracevv((stderr, "inflate:         end of block\n"));
                state.mode = $2dd4f45c8894762f$var$TYPE$1;
                break top;
            } else {
                strm.msg = 'invalid literal/length code';
                state.mode = $2dd4f45c8894762f$var$BAD$1;
                break top;
            }
            break; // need to emulate goto via "continue"
        }
    }while (_in < last && _out < end);
    /* return unused bytes (on entry, bits < 8, so in won't go too far back) */ len = bits >> 3;
    _in -= len;
    bits -= len << 3;
    hold &= (1 << bits) - 1;
    /* update state and return */ strm.next_in = _in;
    strm.next_out = _out;
    strm.avail_in = _in < last ? 5 + (last - _in) : 5 - (_in - last);
    strm.avail_out = _out < end ? 257 + (end - _out) : 257 - (_out - end);
    state.hold = hold;
    state.bits = bits;
    return;
};
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
const $2dd4f45c8894762f$var$MAXBITS = 15;
const $2dd4f45c8894762f$var$ENOUGH_LENS$1 = 852;
const $2dd4f45c8894762f$var$ENOUGH_DISTS$1 = 592;
//const ENOUGH = (ENOUGH_LENS+ENOUGH_DISTS);
const $2dd4f45c8894762f$var$CODES$1 = 0;
const $2dd4f45c8894762f$var$LENS$1 = 1;
const $2dd4f45c8894762f$var$DISTS$1 = 2;
const $2dd4f45c8894762f$var$lbase = new Uint16Array([
    /* Length codes 257..285 base */ 3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    13,
    15,
    17,
    19,
    23,
    27,
    31,
    35,
    43,
    51,
    59,
    67,
    83,
    99,
    115,
    131,
    163,
    195,
    227,
    258,
    0,
    0
]);
const $2dd4f45c8894762f$var$lext = new Uint8Array([
    /* Length codes 257..285 extra */ 16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    17,
    17,
    17,
    17,
    18,
    18,
    18,
    18,
    19,
    19,
    19,
    19,
    20,
    20,
    20,
    20,
    21,
    21,
    21,
    21,
    16,
    72,
    78
]);
const $2dd4f45c8894762f$var$dbase = new Uint16Array([
    /* Distance codes 0..29 base */ 1,
    2,
    3,
    4,
    5,
    7,
    9,
    13,
    17,
    25,
    33,
    49,
    65,
    97,
    129,
    193,
    257,
    385,
    513,
    769,
    1025,
    1537,
    2049,
    3073,
    4097,
    6145,
    8193,
    12289,
    16385,
    24577,
    0,
    0
]);
const $2dd4f45c8894762f$var$dext = new Uint8Array([
    /* Distance codes 0..29 extra */ 16,
    16,
    16,
    16,
    17,
    17,
    18,
    18,
    19,
    19,
    20,
    20,
    21,
    21,
    22,
    22,
    23,
    23,
    24,
    24,
    25,
    25,
    26,
    26,
    27,
    27,
    28,
    28,
    29,
    29,
    64,
    64
]);
const $2dd4f45c8894762f$var$inflate_table = (type, lens, lens_index, codes, table, table_index, work, opts)=>{
    const bits = opts.bits;
    //here = opts.here; /* table entry for duplication */
    let len = 0; /* a code's length in bits */ 
    let sym = 0; /* index of code symbols */ 
    let min = 0, max = 0; /* minimum and maximum code lengths */ 
    let root = 0; /* number of index bits for root table */ 
    let curr = 0; /* number of index bits for current table */ 
    let drop = 0; /* code bits to drop for sub-table */ 
    let left = 0; /* number of prefix codes available */ 
    let used = 0; /* code entries in table used */ 
    let huff = 0; /* Huffman code */ 
    let incr; /* for incrementing code, index */ 
    let fill; /* index for replicating entries */ 
    let low; /* low bits for current root entry */ 
    let mask; /* mask for low root bits */ 
    let next; /* next available space in table */ 
    let base = null; /* base value table to use */ 
    //  let shoextra;    /* extra bits table to use */
    let match; /* use base and extra for symbol >= match */ 
    const count = new Uint16Array($2dd4f45c8894762f$var$MAXBITS + 1); //[MAXBITS+1];    /* number of codes of each length */
    const offs = new Uint16Array($2dd4f45c8894762f$var$MAXBITS + 1); //[MAXBITS+1];     /* offsets in table for each length */
    let extra = null;
    let here_bits, here_op, here_val;
    /*
   Process a set of code lengths to create a canonical Huffman code.  The
   code lengths are lens[0..codes-1].  Each length corresponds to the
   symbols 0..codes-1.  The Huffman code is generated by first sorting the
   symbols by length from short to long, and retaining the symbol order
   for codes with equal lengths.  Then the code starts with all zero bits
   for the first code of the shortest length, and the codes are integer
   increments for the same length, and zeros are appended as the length
   increases.  For the deflate format, these bits are stored backwards
   from their more natural integer increment ordering, and so when the
   decoding tables are built in the large loop below, the integer codes
   are incremented backwards.

   This routine assumes, but does not check, that all of the entries in
   lens[] are in the range 0..MAXBITS.  The caller must assure this.
   1..MAXBITS is interpreted as that code length.  zero means that that
   symbol does not occur in this code.

   The codes are sorted by computing a count of codes for each length,
   creating from that a table of starting indices for each length in the
   sorted table, and then entering the symbols in order in the sorted
   table.  The sorted table is work[], with that space being provided by
   the caller.

   The length counts are used for other purposes as well, i.e. finding
   the minimum and maximum length codes, determining if there are any
   codes at all, checking for a valid set of lengths, and looking ahead
   at length counts to determine sub-table sizes when building the
   decoding tables.
   */ /* accumulate lengths for codes (assumes lens[] all in 0..MAXBITS) */ for(len = 0; len <= $2dd4f45c8894762f$var$MAXBITS; len++)count[len] = 0;
    for(sym = 0; sym < codes; sym++)count[lens[lens_index + sym]]++;
    /* bound code lengths, force root to be within code lengths */ root = bits;
    for(max = $2dd4f45c8894762f$var$MAXBITS; max >= 1; max--){
        if (count[max] !== 0) break;
    }
    if (root > max) root = max;
    if (max === 0) {
        //table.op[opts.table_index] = 64;  //here.op = (var char)64;    /* invalid code marker */
        //table.bits[opts.table_index] = 1;   //here.bits = (var char)1;
        //table.val[opts.table_index++] = 0;   //here.val = (var short)0;
        table[table_index++] = 20971520;
        //table.op[opts.table_index] = 64;
        //table.bits[opts.table_index] = 1;
        //table.val[opts.table_index++] = 0;
        table[table_index++] = 20971520;
        opts.bits = 1;
        return 0; /* no symbols, but wait for decoding to report error */ 
    }
    for(min = 1; min < max; min++){
        if (count[min] !== 0) break;
    }
    if (root < min) root = min;
    /* check for an over-subscribed or incomplete set of lengths */ left = 1;
    for(len = 1; len <= $2dd4f45c8894762f$var$MAXBITS; len++){
        left <<= 1;
        left -= count[len];
        if (left < 0) return -1;
         /* over-subscribed */ 
    }
    if (left > 0 && (type === $2dd4f45c8894762f$var$CODES$1 || max !== 1)) return -1; /* incomplete set */ 
    /* generate offsets into symbol table for each length for sorting */ offs[1] = 0;
    for(len = 1; len < $2dd4f45c8894762f$var$MAXBITS; len++)offs[len + 1] = offs[len] + count[len];
    /* sort symbols by length, by symbol order within each length */ for(sym = 0; sym < codes; sym++)if (lens[lens_index + sym] !== 0) work[offs[lens[lens_index + sym]]++] = sym;
    /*
   Create and fill in decoding tables.  In this loop, the table being
   filled is at next and has curr index bits.  The code being used is huff
   with length len.  That code is converted to an index by dropping drop
   bits off of the bottom.  For codes where len is less than drop + curr,
   those top drop + curr - len bits are incremented through all values to
   fill the table with replicated entries.

   root is the number of index bits for the root table.  When len exceeds
   root, sub-tables are created pointed to by the root entry with an index
   of the low root bits of huff.  This is saved in low to check for when a
   new sub-table should be started.  drop is zero when the root table is
   being filled, and drop is root when sub-tables are being filled.

   When a new sub-table is needed, it is necessary to look ahead in the
   code lengths to determine what size sub-table is needed.  The length
   counts are used for this, and so count[] is decremented as codes are
   entered in the tables.

   used keeps track of how many table entries have been allocated from the
   provided *table space.  It is checked for LENS and DIST tables against
   the constants ENOUGH_LENS and ENOUGH_DISTS to guard against changes in
   the initial root table size constants.  See the comments in inftrees.h
   for more information.

   sym increments through all symbols, and the loop terminates when
   all codes of length max, i.e. all codes, have been processed.  This
   routine permits incomplete codes, so another loop after this one fills
   in the rest of the decoding tables with invalid code markers.
   */ /* set up for code type */ // poor man optimization - use if-else instead of switch,
    // to avoid deopts in old v8
    if (type === $2dd4f45c8894762f$var$CODES$1) {
        base = extra = work; /* dummy value--not used */ 
        match = 20;
    } else if (type === $2dd4f45c8894762f$var$LENS$1) {
        base = $2dd4f45c8894762f$var$lbase;
        extra = $2dd4f45c8894762f$var$lext;
        match = 257;
    } else {
        base = $2dd4f45c8894762f$var$dbase;
        extra = $2dd4f45c8894762f$var$dext;
        match = 0;
    }
    /* initialize opts for loop */ huff = 0; /* starting code */ 
    sym = 0; /* starting code symbol */ 
    len = min; /* starting code length */ 
    next = table_index; /* current table to fill in */ 
    curr = root; /* current table index bits */ 
    drop = 0; /* current bits to drop from code for index */ 
    low = -1; /* trigger new sub-table when len > root */ 
    used = 1 << root; /* use root table entries */ 
    mask = used - 1; /* mask for comparing low */ 
    /* check available table space */ if (type === $2dd4f45c8894762f$var$LENS$1 && used > $2dd4f45c8894762f$var$ENOUGH_LENS$1 || type === $2dd4f45c8894762f$var$DISTS$1 && used > $2dd4f45c8894762f$var$ENOUGH_DISTS$1) return 1;
    /* process all codes and make table entries */ for(;;){
        /* create table entry */ here_bits = len - drop;
        if (work[sym] + 1 < match) {
            here_op = 0;
            here_val = work[sym];
        } else if (work[sym] >= match) {
            here_op = extra[work[sym] - match];
            here_val = base[work[sym] - match];
        } else {
            here_op = 96; /* end of block */ 
            here_val = 0;
        }
        /* replicate for those indices with low len bits equal to huff */ incr = 1 << len - drop;
        fill = 1 << curr;
        min = fill; /* save offset to next table */ 
        do {
            fill -= incr;
            table[next + (huff >> drop) + fill] = here_bits << 24 | here_op << 16 | here_val | 0;
        }while (fill !== 0);
        /* backwards increment the len-bit code huff */ incr = 1 << len - 1;
        while(huff & incr)incr >>= 1;
        if (incr !== 0) {
            huff &= incr - 1;
            huff += incr;
        } else huff = 0;
        /* go to next symbol, update count, len */ sym++;
        if (--count[len] === 0) {
            if (len === max) break;
            len = lens[lens_index + work[sym]];
        }
        /* create new sub-table if needed */ if (len > root && (huff & mask) !== low) {
            /* if first time, transition to sub-tables */ if (drop === 0) drop = root;
            /* increment past last table */ next += min; /* here min is 1 << curr */ 
            /* determine length of next table */ curr = len - drop;
            left = 1 << curr;
            while(curr + drop < max){
                left -= count[curr + drop];
                if (left <= 0) break;
                curr++;
                left <<= 1;
            }
            /* check for enough space */ used += 1 << curr;
            if (type === $2dd4f45c8894762f$var$LENS$1 && used > $2dd4f45c8894762f$var$ENOUGH_LENS$1 || type === $2dd4f45c8894762f$var$DISTS$1 && used > $2dd4f45c8894762f$var$ENOUGH_DISTS$1) return 1;
            /* point entry in root table to sub-table */ low = huff & mask;
            /*table.op[low] = curr;
      table.bits[low] = root;
      table.val[low] = next - opts.table_index;*/ table[low] = root << 24 | curr << 16 | next - table_index | 0;
        }
    }
    /* fill in remaining table entry if code is incomplete (guaranteed to have
   at most one remaining entry, since if the code is incomplete, the
   maximum code length that was allowed to get this far is one bit) */ if (huff !== 0) //table.op[next + huff] = 64;            /* invalid code marker */
    //table.bits[next + huff] = len - drop;
    //table.val[next + huff] = 0;
    table[next + huff] = len - drop << 24 | 4194304;
    /* set return parameters */ //opts.table_index += used;
    opts.bits = root;
    return 0;
};
var $2dd4f45c8894762f$var$inftrees = $2dd4f45c8894762f$var$inflate_table;
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
const $2dd4f45c8894762f$var$CODES = 0;
const $2dd4f45c8894762f$var$LENS = 1;
const $2dd4f45c8894762f$var$DISTS = 2;
/* Public constants ==========================================================*/ /* ===========================================================================*/ const { Z_FINISH: $2dd4f45c8894762f$var$Z_FINISH$1, Z_BLOCK: $2dd4f45c8894762f$var$Z_BLOCK, Z_TREES: $2dd4f45c8894762f$var$Z_TREES, Z_OK: $2dd4f45c8894762f$var$Z_OK$1, Z_STREAM_END: $2dd4f45c8894762f$var$Z_STREAM_END$1, Z_NEED_DICT: $2dd4f45c8894762f$var$Z_NEED_DICT$1, Z_STREAM_ERROR: $2dd4f45c8894762f$var$Z_STREAM_ERROR$1, Z_DATA_ERROR: $2dd4f45c8894762f$var$Z_DATA_ERROR$1, Z_MEM_ERROR: $2dd4f45c8894762f$var$Z_MEM_ERROR$1, Z_BUF_ERROR: $2dd4f45c8894762f$var$Z_BUF_ERROR, Z_DEFLATED: $2dd4f45c8894762f$var$Z_DEFLATED } = $2dd4f45c8894762f$var$constants$2;
/* STATES ====================================================================*/ /* ===========================================================================*/ const $2dd4f45c8894762f$var$HEAD = 16180; /* i: waiting for magic header */ 
const $2dd4f45c8894762f$var$FLAGS = 16181; /* i: waiting for method and flags (gzip) */ 
const $2dd4f45c8894762f$var$TIME = 16182; /* i: waiting for modification time (gzip) */ 
const $2dd4f45c8894762f$var$OS = 16183; /* i: waiting for extra flags and operating system (gzip) */ 
const $2dd4f45c8894762f$var$EXLEN = 16184; /* i: waiting for extra length (gzip) */ 
const $2dd4f45c8894762f$var$EXTRA = 16185; /* i: waiting for extra bytes (gzip) */ 
const $2dd4f45c8894762f$var$NAME = 16186; /* i: waiting for end of file name (gzip) */ 
const $2dd4f45c8894762f$var$COMMENT = 16187; /* i: waiting for end of comment (gzip) */ 
const $2dd4f45c8894762f$var$HCRC = 16188; /* i: waiting for header crc (gzip) */ 
const $2dd4f45c8894762f$var$DICTID = 16189; /* i: waiting for dictionary check value */ 
const $2dd4f45c8894762f$var$DICT = 16190; /* waiting for inflateSetDictionary() call */ 
const $2dd4f45c8894762f$var$TYPE = 16191; /* i: waiting for type bits, including last-flag bit */ 
const $2dd4f45c8894762f$var$TYPEDO = 16192; /* i: same, but skip check to exit inflate on new block */ 
const $2dd4f45c8894762f$var$STORED = 16193; /* i: waiting for stored size (length and complement) */ 
const $2dd4f45c8894762f$var$COPY_ = 16194; /* i/o: same as COPY below, but only first time in */ 
const $2dd4f45c8894762f$var$COPY = 16195; /* i/o: waiting for input or output to copy stored block */ 
const $2dd4f45c8894762f$var$TABLE = 16196; /* i: waiting for dynamic block table lengths */ 
const $2dd4f45c8894762f$var$LENLENS = 16197; /* i: waiting for code length code lengths */ 
const $2dd4f45c8894762f$var$CODELENS = 16198; /* i: waiting for length/lit and distance code lengths */ 
const $2dd4f45c8894762f$var$LEN_ = 16199; /* i: same as LEN below, but only first time in */ 
const $2dd4f45c8894762f$var$LEN = 16200; /* i: waiting for length/lit/eob code */ 
const $2dd4f45c8894762f$var$LENEXT = 16201; /* i: waiting for length extra bits */ 
const $2dd4f45c8894762f$var$DIST = 16202; /* i: waiting for distance code */ 
const $2dd4f45c8894762f$var$DISTEXT = 16203; /* i: waiting for distance extra bits */ 
const $2dd4f45c8894762f$var$MATCH = 16204; /* o: waiting for output space to copy string */ 
const $2dd4f45c8894762f$var$LIT = 16205; /* o: waiting for output space to write literal */ 
const $2dd4f45c8894762f$var$CHECK = 16206; /* i: waiting for 32-bit check value */ 
const $2dd4f45c8894762f$var$LENGTH = 16207; /* i: waiting for 32-bit length (gzip) */ 
const $2dd4f45c8894762f$var$DONE = 16208; /* finished check, done -- remain here until reset */ 
const $2dd4f45c8894762f$var$BAD = 16209; /* got a data error -- remain here until reset */ 
const $2dd4f45c8894762f$var$MEM = 16210; /* got an inflate() memory error -- remain here until reset */ 
const $2dd4f45c8894762f$var$SYNC = 16211; /* looking for synchronization bytes to restart inflate() */ 
/* ===========================================================================*/ const $2dd4f45c8894762f$var$ENOUGH_LENS = 852;
const $2dd4f45c8894762f$var$ENOUGH_DISTS = 592;
//const ENOUGH =  (ENOUGH_LENS+ENOUGH_DISTS);
const $2dd4f45c8894762f$var$MAX_WBITS = 15;
/* 32K LZ77 window */ const $2dd4f45c8894762f$var$DEF_WBITS = $2dd4f45c8894762f$var$MAX_WBITS;
const $2dd4f45c8894762f$var$zswap32 = (q)=>{
    return (q >>> 24 & 0xff) + (q >>> 8 & 0xff00) + ((q & 0xff00) << 8) + ((q & 0xff) << 24);
};
function $2dd4f45c8894762f$var$InflateState() {
    this.strm = null; /* pointer back to this zlib stream */ 
    this.mode = 0; /* current inflate mode */ 
    this.last = false; /* true if processing last block */ 
    this.wrap = 0; /* bit 0 true for zlib, bit 1 true for gzip,
                                 bit 2 true to validate check value */ 
    this.havedict = false; /* true if dictionary provided */ 
    this.flags = 0; /* gzip header method and flags (0 if zlib), or
                                 -1 if raw or no header yet */ 
    this.dmax = 0; /* zlib header max distance (INFLATE_STRICT) */ 
    this.check = 0; /* protected copy of check value */ 
    this.total = 0; /* protected copy of output count */ 
    // TODO: may be {}
    this.head = null; /* where to save gzip header information */ 
    /* sliding window */ this.wbits = 0; /* log base 2 of requested window size */ 
    this.wsize = 0; /* window size or zero if not using window */ 
    this.whave = 0; /* valid bytes in the window */ 
    this.wnext = 0; /* window write index */ 
    this.window = null; /* allocated sliding window, if needed */ 
    /* bit accumulator */ this.hold = 0; /* input bit accumulator */ 
    this.bits = 0; /* number of bits in "in" */ 
    /* for string and stored block copying */ this.length = 0; /* literal or length of data to copy */ 
    this.offset = 0; /* distance back to copy string from */ 
    /* for table and code decoding */ this.extra = 0; /* extra bits needed */ 
    /* fixed and dynamic code tables */ this.lencode = null; /* starting table for length/literal codes */ 
    this.distcode = null; /* starting table for distance codes */ 
    this.lenbits = 0; /* index bits for lencode */ 
    this.distbits = 0; /* index bits for distcode */ 
    /* dynamic table building */ this.ncode = 0; /* number of code length code lengths */ 
    this.nlen = 0; /* number of length code lengths */ 
    this.ndist = 0; /* number of distance code lengths */ 
    this.have = 0; /* number of code lengths in lens[] */ 
    this.next = null; /* next available space in codes[] */ 
    this.lens = new Uint16Array(320); /* temporary storage for code lengths */ 
    this.work = new Uint16Array(288); /* work area for code table building */ 
    /*
   because we don't have pointers in js, we use lencode and distcode directly
   as buffers so we don't need codes
  */ //this.codes = new Int32Array(ENOUGH);       /* space for code tables */
    this.lendyn = null; /* dynamic table for length/literal codes (JS specific) */ 
    this.distdyn = null; /* dynamic table for distance codes (JS specific) */ 
    this.sane = 0; /* if false, allow invalid distance too far */ 
    this.back = 0; /* bits back of last unprocessed length/lit */ 
    this.was = 0; /* initial length of match */ 
}
const $2dd4f45c8894762f$var$inflateStateCheck = (strm)=>{
    if (!strm) return 1;
    const state = strm.state;
    if (!state || state.strm !== strm || state.mode < $2dd4f45c8894762f$var$HEAD || state.mode > $2dd4f45c8894762f$var$SYNC) return 1;
    return 0;
};
const $2dd4f45c8894762f$var$inflateResetKeep = (strm)=>{
    if ($2dd4f45c8894762f$var$inflateStateCheck(strm)) return $2dd4f45c8894762f$var$Z_STREAM_ERROR$1;
    const state = strm.state;
    strm.total_in = strm.total_out = state.total = 0;
    strm.msg = ''; /*Z_NULL*/ 
    if (state.wrap) strm.adler = state.wrap & 1;
    state.mode = $2dd4f45c8894762f$var$HEAD;
    state.last = 0;
    state.havedict = 0;
    state.flags = -1;
    state.dmax = 32768;
    state.head = null /*Z_NULL*/ ;
    state.hold = 0;
    state.bits = 0;
    //state.lencode = state.distcode = state.next = state.codes;
    state.lencode = state.lendyn = new Int32Array($2dd4f45c8894762f$var$ENOUGH_LENS);
    state.distcode = state.distdyn = new Int32Array($2dd4f45c8894762f$var$ENOUGH_DISTS);
    state.sane = 1;
    state.back = -1;
    //Tracev((stderr, "inflate: reset\n"));
    return $2dd4f45c8894762f$var$Z_OK$1;
};
const $2dd4f45c8894762f$var$inflateReset = (strm)=>{
    if ($2dd4f45c8894762f$var$inflateStateCheck(strm)) return $2dd4f45c8894762f$var$Z_STREAM_ERROR$1;
    const state = strm.state;
    state.wsize = 0;
    state.whave = 0;
    state.wnext = 0;
    return $2dd4f45c8894762f$var$inflateResetKeep(strm);
};
const $2dd4f45c8894762f$var$inflateReset2 = (strm, windowBits)=>{
    let wrap;
    /* get the state */ if ($2dd4f45c8894762f$var$inflateStateCheck(strm)) return $2dd4f45c8894762f$var$Z_STREAM_ERROR$1;
    const state = strm.state;
    /* extract wrap request from windowBits parameter */ if (windowBits < 0) {
        wrap = 0;
        windowBits = -windowBits;
    } else {
        wrap = (windowBits >> 4) + 5;
        if (windowBits < 48) windowBits &= 15;
    }
    /* set number of window bits, free window if different */ if (windowBits && (windowBits < 8 || windowBits > 15)) return $2dd4f45c8894762f$var$Z_STREAM_ERROR$1;
    if (state.window !== null && state.wbits !== windowBits) state.window = null;
    /* update state and reset the rest of it */ state.wrap = wrap;
    state.wbits = windowBits;
    return $2dd4f45c8894762f$var$inflateReset(strm);
};
const $2dd4f45c8894762f$var$inflateInit2 = (strm, windowBits)=>{
    if (!strm) return $2dd4f45c8894762f$var$Z_STREAM_ERROR$1;
    //strm.msg = Z_NULL;                 /* in case we return an error */
    const state = new $2dd4f45c8894762f$var$InflateState();
    //if (state === Z_NULL) return Z_MEM_ERROR;
    //Tracev((stderr, "inflate: allocated\n"));
    strm.state = state;
    state.strm = strm;
    state.window = null /*Z_NULL*/ ;
    state.mode = $2dd4f45c8894762f$var$HEAD; /* to pass state test in inflateReset2() */ 
    const ret = $2dd4f45c8894762f$var$inflateReset2(strm, windowBits);
    if (ret !== $2dd4f45c8894762f$var$Z_OK$1) strm.state = null /*Z_NULL*/ ;
    return ret;
};
const $2dd4f45c8894762f$var$inflateInit = (strm)=>{
    return $2dd4f45c8894762f$var$inflateInit2(strm, $2dd4f45c8894762f$var$DEF_WBITS);
};
/*
 Return state with length and distance decoding tables and index sizes set to
 fixed code decoding.  Normally this returns fixed tables from inffixed.h.
 If BUILDFIXED is defined, then instead this routine builds the tables the
 first time it's called, and returns those tables the first time and
 thereafter.  This reduces the size of the code by about 2K bytes, in
 exchange for a little execution time.  However, BUILDFIXED should not be
 used for threaded applications, since the rewriting of the tables and virgin
 may not be thread-safe.
 */ let $2dd4f45c8894762f$var$virgin = true;
let $2dd4f45c8894762f$var$lenfix, $2dd4f45c8894762f$var$distfix; // We have no pointers in JS, so keep tables separate
const $2dd4f45c8894762f$var$fixedtables = (state)=>{
    /* build fixed huffman tables if first call (may not be thread safe) */ if ($2dd4f45c8894762f$var$virgin) {
        $2dd4f45c8894762f$var$lenfix = new Int32Array(512);
        $2dd4f45c8894762f$var$distfix = new Int32Array(32);
        /* literal/length table */ let sym = 0;
        while(sym < 144)state.lens[sym++] = 8;
        while(sym < 256)state.lens[sym++] = 9;
        while(sym < 280)state.lens[sym++] = 7;
        while(sym < 288)state.lens[sym++] = 8;
        $2dd4f45c8894762f$var$inftrees($2dd4f45c8894762f$var$LENS, state.lens, 0, 288, $2dd4f45c8894762f$var$lenfix, 0, state.work, {
            bits: 9
        });
        /* distance table */ sym = 0;
        while(sym < 32)state.lens[sym++] = 5;
        $2dd4f45c8894762f$var$inftrees($2dd4f45c8894762f$var$DISTS, state.lens, 0, 32, $2dd4f45c8894762f$var$distfix, 0, state.work, {
            bits: 5
        });
        /* do this just once */ $2dd4f45c8894762f$var$virgin = false;
    }
    state.lencode = $2dd4f45c8894762f$var$lenfix;
    state.lenbits = 9;
    state.distcode = $2dd4f45c8894762f$var$distfix;
    state.distbits = 5;
};
/*
 Update the window with the last wsize (normally 32K) bytes written before
 returning.  If window does not exist yet, create it.  This is only called
 when a window is already in use, or when output has been written during this
 inflate call, but the end of the deflate stream has not been reached yet.
 It is also called to create a window for dictionary data when a dictionary
 is loaded.

 Providing output buffers larger than 32K to inflate() should provide a speed
 advantage, since only the last 32K of output is copied to the sliding window
 upon return from inflate(), and since all distances after the first 32K of
 output will fall in the output data, making match copies simpler and faster.
 The advantage may be dependent on the size of the processor's data caches.
 */ const $2dd4f45c8894762f$var$updatewindow = (strm, src, end, copy)=>{
    let dist;
    const state = strm.state;
    /* if it hasn't been done already, allocate space for the window */ if (state.window === null) {
        state.wsize = 1 << state.wbits;
        state.wnext = 0;
        state.whave = 0;
        state.window = new Uint8Array(state.wsize);
    }
    /* copy state->wsize or less output bytes into the circular window */ if (copy >= state.wsize) {
        state.window.set(src.subarray(end - state.wsize, end), 0);
        state.wnext = 0;
        state.whave = state.wsize;
    } else {
        dist = state.wsize - state.wnext;
        if (dist > copy) dist = copy;
        //zmemcpy(state->window + state->wnext, end - copy, dist);
        state.window.set(src.subarray(end - copy, end - copy + dist), state.wnext);
        copy -= dist;
        if (copy) {
            //zmemcpy(state->window, end - copy, copy);
            state.window.set(src.subarray(end - copy, end), 0);
            state.wnext = copy;
            state.whave = state.wsize;
        } else {
            state.wnext += dist;
            if (state.wnext === state.wsize) state.wnext = 0;
            if (state.whave < state.wsize) state.whave += dist;
        }
    }
    return 0;
};
const $2dd4f45c8894762f$var$inflate$2 = (strm, flush)=>{
    let state;
    let input, output; // input/output buffers
    let next; /* next input INDEX */ 
    let put; /* next output INDEX */ 
    let have, left; /* available input and output */ 
    let hold; /* bit buffer */ 
    let bits; /* bits in bit buffer */ 
    let _in, _out; /* save starting available input and output */ 
    let copy; /* number of stored or match bytes to copy */ 
    let from; /* where to copy match bytes from */ 
    let from_source;
    let here = 0; /* current decoding table entry */ 
    let here_bits, here_op, here_val; // paked "here" denormalized (JS specific)
    //let last;                   /* parent table entry */
    let last_bits, last_op, last_val; // paked "last" denormalized (JS specific)
    let len; /* length to copy for repeats, bits to drop */ 
    let ret; /* return code */ 
    const hbuf = new Uint8Array(4); /* buffer for gzip header crc calculation */ 
    let opts;
    let n; // temporary variable for NEED_BITS
    const order = /* permutation of code lengths */ new Uint8Array([
        16,
        17,
        18,
        0,
        8,
        7,
        9,
        6,
        10,
        5,
        11,
        4,
        12,
        3,
        13,
        2,
        14,
        1,
        15
    ]);
    if ($2dd4f45c8894762f$var$inflateStateCheck(strm) || !strm.output || !strm.input && strm.avail_in !== 0) return $2dd4f45c8894762f$var$Z_STREAM_ERROR$1;
    state = strm.state;
    if (state.mode === $2dd4f45c8894762f$var$TYPE) state.mode = $2dd4f45c8894762f$var$TYPEDO;
     /* skip check */ 
    //--- LOAD() ---
    put = strm.next_out;
    output = strm.output;
    left = strm.avail_out;
    next = strm.next_in;
    input = strm.input;
    have = strm.avail_in;
    hold = state.hold;
    bits = state.bits;
    //---
    _in = have;
    _out = left;
    ret = $2dd4f45c8894762f$var$Z_OK$1;
    inf_leave: for(;;)switch(state.mode){
        case $2dd4f45c8894762f$var$HEAD:
            if (state.wrap === 0) {
                state.mode = $2dd4f45c8894762f$var$TYPEDO;
                break;
            }
            //=== NEEDBITS(16);
            while(bits < 16){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if (state.wrap & 2 && hold === 0x8b1f) {
                if (state.wbits === 0) state.wbits = 15;
                state.check = 0 /*crc32(0L, Z_NULL, 0)*/ ;
                //=== CRC2(state.check, hold);
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                state.check = $2dd4f45c8894762f$var$crc32_1(state.check, hbuf, 2, 0);
                //===//
                //=== INITBITS();
                hold = 0;
                bits = 0;
                //===//
                state.mode = $2dd4f45c8894762f$var$FLAGS;
                break;
            }
            if (state.head) state.head.done = false;
            if (!(state.wrap & 1) || /* check if zlib header allowed */ (((hold & 0xff) << 8) + (hold >> 8)) % 31) {
                strm.msg = 'incorrect header check';
                state.mode = $2dd4f45c8894762f$var$BAD;
                break;
            }
            if ((hold & 0x0f) !== $2dd4f45c8894762f$var$Z_DEFLATED) {
                strm.msg = 'unknown compression method';
                state.mode = $2dd4f45c8894762f$var$BAD;
                break;
            }
            //--- DROPBITS(4) ---//
            hold >>>= 4;
            bits -= 4;
            //---//
            len = (hold & 0x0f) + 8;
            if (state.wbits === 0) state.wbits = len;
            if (len > 15 || len > state.wbits) {
                strm.msg = 'invalid window size';
                state.mode = $2dd4f45c8894762f$var$BAD;
                break;
            }
            // !!! pako patch. Force use `options.windowBits` if passed.
            // Required to always use max window size by default.
            state.dmax = 1 << state.wbits;
            //state.dmax = 1 << len;
            state.flags = 0; /* indicate zlib header */ 
            //Tracev((stderr, "inflate:   zlib header ok\n"));
            strm.adler = state.check = 1 /*adler32(0L, Z_NULL, 0)*/ ;
            state.mode = hold & 0x200 ? $2dd4f45c8894762f$var$DICTID : $2dd4f45c8894762f$var$TYPE;
            //=== INITBITS();
            hold = 0;
            bits = 0;
            break;
        case $2dd4f45c8894762f$var$FLAGS:
            //=== NEEDBITS(16); */
            while(bits < 16){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            state.flags = hold;
            if ((state.flags & 0xff) !== $2dd4f45c8894762f$var$Z_DEFLATED) {
                strm.msg = 'unknown compression method';
                state.mode = $2dd4f45c8894762f$var$BAD;
                break;
            }
            if (state.flags & 0xe000) {
                strm.msg = 'unknown header flags set';
                state.mode = $2dd4f45c8894762f$var$BAD;
                break;
            }
            if (state.head) state.head.text = hold >> 8 & 1;
            if (state.flags & 0x0200 && state.wrap & 4) {
                //=== CRC2(state.check, hold);
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                state.check = $2dd4f45c8894762f$var$crc32_1(state.check, hbuf, 2, 0);
            //===//
            }
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $2dd4f45c8894762f$var$TIME;
        /* falls through */ case $2dd4f45c8894762f$var$TIME:
            //=== NEEDBITS(32); */
            while(bits < 32){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if (state.head) state.head.time = hold;
            if (state.flags & 0x0200 && state.wrap & 4) {
                //=== CRC4(state.check, hold)
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                hbuf[2] = hold >>> 16 & 0xff;
                hbuf[3] = hold >>> 24 & 0xff;
                state.check = $2dd4f45c8894762f$var$crc32_1(state.check, hbuf, 4, 0);
            //===
            }
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $2dd4f45c8894762f$var$OS;
        /* falls through */ case $2dd4f45c8894762f$var$OS:
            //=== NEEDBITS(16); */
            while(bits < 16){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if (state.head) {
                state.head.xflags = hold & 0xff;
                state.head.os = hold >> 8;
            }
            if (state.flags & 0x0200 && state.wrap & 4) {
                //=== CRC2(state.check, hold);
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                state.check = $2dd4f45c8894762f$var$crc32_1(state.check, hbuf, 2, 0);
            //===//
            }
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $2dd4f45c8894762f$var$EXLEN;
        /* falls through */ case $2dd4f45c8894762f$var$EXLEN:
            if (state.flags & 0x0400) {
                //=== NEEDBITS(16); */
                while(bits < 16){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.length = hold;
                if (state.head) state.head.extra_len = hold;
                if (state.flags & 0x0200 && state.wrap & 4) {
                    //=== CRC2(state.check, hold);
                    hbuf[0] = hold & 0xff;
                    hbuf[1] = hold >>> 8 & 0xff;
                    state.check = $2dd4f45c8894762f$var$crc32_1(state.check, hbuf, 2, 0);
                //===//
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            } else if (state.head) state.head.extra = null /*Z_NULL*/ ;
            state.mode = $2dd4f45c8894762f$var$EXTRA;
        /* falls through */ case $2dd4f45c8894762f$var$EXTRA:
            if (state.flags & 0x0400) {
                copy = state.length;
                if (copy > have) copy = have;
                if (copy) {
                    if (state.head) {
                        len = state.head.extra_len - state.length;
                        if (!state.head.extra) // Use untyped array for more convenient processing later
                        state.head.extra = new Uint8Array(state.head.extra_len);
                        state.head.extra.set(input.subarray(next, // extra field is limited to 65536 bytes
                        // - no need for additional size check
                        next + copy), /*len + copy > state.head.extra_max - len ? state.head.extra_max : copy,*/ len);
                    //zmemcpy(state.head.extra + len, next,
                    //        len + copy > state.head.extra_max ?
                    //        state.head.extra_max - len : copy);
                    }
                    if (state.flags & 0x0200 && state.wrap & 4) state.check = $2dd4f45c8894762f$var$crc32_1(state.check, input, copy, next);
                    have -= copy;
                    next += copy;
                    state.length -= copy;
                }
                if (state.length) break inf_leave;
            }
            state.length = 0;
            state.mode = $2dd4f45c8894762f$var$NAME;
        /* falls through */ case $2dd4f45c8894762f$var$NAME:
            if (state.flags & 0x0800) {
                if (have === 0) break inf_leave;
                copy = 0;
                do {
                    // TODO: 2 or 1 bytes?
                    len = input[next + copy++];
                    /* use constant limit because in js we should not preallocate memory */ if (state.head && len && state.length < 65536 /*state.head.name_max*/ ) state.head.name += String.fromCharCode(len);
                }while (len && copy < have);
                if (state.flags & 0x0200 && state.wrap & 4) state.check = $2dd4f45c8894762f$var$crc32_1(state.check, input, copy, next);
                have -= copy;
                next += copy;
                if (len) break inf_leave;
            } else if (state.head) state.head.name = null;
            state.length = 0;
            state.mode = $2dd4f45c8894762f$var$COMMENT;
        /* falls through */ case $2dd4f45c8894762f$var$COMMENT:
            if (state.flags & 0x1000) {
                if (have === 0) break inf_leave;
                copy = 0;
                do {
                    len = input[next + copy++];
                    /* use constant limit because in js we should not preallocate memory */ if (state.head && len && state.length < 65536 /*state.head.comm_max*/ ) state.head.comment += String.fromCharCode(len);
                }while (len && copy < have);
                if (state.flags & 0x0200 && state.wrap & 4) state.check = $2dd4f45c8894762f$var$crc32_1(state.check, input, copy, next);
                have -= copy;
                next += copy;
                if (len) break inf_leave;
            } else if (state.head) state.head.comment = null;
            state.mode = $2dd4f45c8894762f$var$HCRC;
        /* falls through */ case $2dd4f45c8894762f$var$HCRC:
            if (state.flags & 0x0200) {
                //=== NEEDBITS(16); */
                while(bits < 16){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                if (state.wrap & 4 && hold !== (state.check & 0xffff)) {
                    strm.msg = 'header crc mismatch';
                    state.mode = $2dd4f45c8894762f$var$BAD;
                    break;
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            }
            if (state.head) {
                state.head.hcrc = state.flags >> 9 & 1;
                state.head.done = true;
            }
            strm.adler = state.check = 0;
            state.mode = $2dd4f45c8894762f$var$TYPE;
            break;
        case $2dd4f45c8894762f$var$DICTID:
            //=== NEEDBITS(32); */
            while(bits < 32){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            strm.adler = state.check = $2dd4f45c8894762f$var$zswap32(hold);
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $2dd4f45c8894762f$var$DICT;
        /* falls through */ case $2dd4f45c8894762f$var$DICT:
            if (state.havedict === 0) {
                //--- RESTORE() ---
                strm.next_out = put;
                strm.avail_out = left;
                strm.next_in = next;
                strm.avail_in = have;
                state.hold = hold;
                state.bits = bits;
                //---
                return $2dd4f45c8894762f$var$Z_NEED_DICT$1;
            }
            strm.adler = state.check = 1 /*adler32(0L, Z_NULL, 0)*/ ;
            state.mode = $2dd4f45c8894762f$var$TYPE;
        /* falls through */ case $2dd4f45c8894762f$var$TYPE:
            if (flush === $2dd4f45c8894762f$var$Z_BLOCK || flush === $2dd4f45c8894762f$var$Z_TREES) break inf_leave;
        /* falls through */ case $2dd4f45c8894762f$var$TYPEDO:
            if (state.last) {
                //--- BYTEBITS() ---//
                hold >>>= bits & 7;
                bits -= bits & 7;
                //---//
                state.mode = $2dd4f45c8894762f$var$CHECK;
                break;
            }
            //=== NEEDBITS(3); */
            while(bits < 3){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            state.last = hold & 0x01 /*BITS(1)*/ ;
            //--- DROPBITS(1) ---//
            hold >>>= 1;
            bits -= 1;
            //---//
            switch(hold & 0x03){
                case 0:
                    /* stored block */ //Tracev((stderr, "inflate:     stored block%s\n",
                    //        state.last ? " (last)" : ""));
                    state.mode = $2dd4f45c8894762f$var$STORED;
                    break;
                case 1:
                    /* fixed block */ $2dd4f45c8894762f$var$fixedtables(state);
                    //Tracev((stderr, "inflate:     fixed codes block%s\n",
                    //        state.last ? " (last)" : ""));
                    state.mode = $2dd4f45c8894762f$var$LEN_; /* decode codes */ 
                    if (flush === $2dd4f45c8894762f$var$Z_TREES) {
                        //--- DROPBITS(2) ---//
                        hold >>>= 2;
                        bits -= 2;
                        break inf_leave;
                    }
                    break;
                case 2:
                    /* dynamic block */ //Tracev((stderr, "inflate:     dynamic codes block%s\n",
                    //        state.last ? " (last)" : ""));
                    state.mode = $2dd4f45c8894762f$var$TABLE;
                    break;
                case 3:
                    strm.msg = 'invalid block type';
                    state.mode = $2dd4f45c8894762f$var$BAD;
            }
            //--- DROPBITS(2) ---//
            hold >>>= 2;
            bits -= 2;
            break;
        case $2dd4f45c8894762f$var$STORED:
            //--- BYTEBITS() ---// /* go to byte boundary */
            hold >>>= bits & 7;
            bits -= bits & 7;
            //---//
            //=== NEEDBITS(32); */
            while(bits < 32){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if ((hold & 0xffff) !== (hold >>> 16 ^ 0xffff)) {
                strm.msg = 'invalid stored block lengths';
                state.mode = $2dd4f45c8894762f$var$BAD;
                break;
            }
            state.length = hold & 0xffff;
            //Tracev((stderr, "inflate:       stored length %u\n",
            //        state.length));
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $2dd4f45c8894762f$var$COPY_;
            if (flush === $2dd4f45c8894762f$var$Z_TREES) break inf_leave;
        /* falls through */ case $2dd4f45c8894762f$var$COPY_:
            state.mode = $2dd4f45c8894762f$var$COPY;
        /* falls through */ case $2dd4f45c8894762f$var$COPY:
            copy = state.length;
            if (copy) {
                if (copy > have) copy = have;
                if (copy > left) copy = left;
                if (copy === 0) break inf_leave;
                //--- zmemcpy(put, next, copy); ---
                output.set(input.subarray(next, next + copy), put);
                //---//
                have -= copy;
                next += copy;
                left -= copy;
                put += copy;
                state.length -= copy;
                break;
            }
            //Tracev((stderr, "inflate:       stored end\n"));
            state.mode = $2dd4f45c8894762f$var$TYPE;
            break;
        case $2dd4f45c8894762f$var$TABLE:
            //=== NEEDBITS(14); */
            while(bits < 14){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            state.nlen = (hold & 0x1f) + 257;
            //--- DROPBITS(5) ---//
            hold >>>= 5;
            bits -= 5;
            //---//
            state.ndist = (hold & 0x1f) + 1;
            //--- DROPBITS(5) ---//
            hold >>>= 5;
            bits -= 5;
            //---//
            state.ncode = (hold & 0x0f) + 4;
            //--- DROPBITS(4) ---//
            hold >>>= 4;
            bits -= 4;
            //---//
            //#ifndef PKZIP_BUG_WORKAROUND
            if (state.nlen > 286 || state.ndist > 30) {
                strm.msg = 'too many length or distance symbols';
                state.mode = $2dd4f45c8894762f$var$BAD;
                break;
            }
            //#endif
            //Tracev((stderr, "inflate:       table sizes ok\n"));
            state.have = 0;
            state.mode = $2dd4f45c8894762f$var$LENLENS;
        /* falls through */ case $2dd4f45c8894762f$var$LENLENS:
            while(state.have < state.ncode){
                //=== NEEDBITS(3);
                while(bits < 3){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.lens[order[state.have++]] = hold & 0x07; //BITS(3);
                //--- DROPBITS(3) ---//
                hold >>>= 3;
                bits -= 3;
            //---//
            }
            while(state.have < 19)state.lens[order[state.have++]] = 0;
            // We have separate tables & no pointers. 2 commented lines below not needed.
            //state.next = state.codes;
            //state.lencode = state.next;
            // Switch to use dynamic table
            state.lencode = state.lendyn;
            state.lenbits = 7;
            opts = {
                bits: state.lenbits
            };
            ret = $2dd4f45c8894762f$var$inftrees($2dd4f45c8894762f$var$CODES, state.lens, 0, 19, state.lencode, 0, state.work, opts);
            state.lenbits = opts.bits;
            if (ret) {
                strm.msg = 'invalid code lengths set';
                state.mode = $2dd4f45c8894762f$var$BAD;
                break;
            }
            //Tracev((stderr, "inflate:       code lengths ok\n"));
            state.have = 0;
            state.mode = $2dd4f45c8894762f$var$CODELENS;
        /* falls through */ case $2dd4f45c8894762f$var$CODELENS:
            while(state.have < state.nlen + state.ndist){
                for(;;){
                    here = state.lencode[hold & (1 << state.lenbits) - 1]; /*BITS(state.lenbits)*/ 
                    here_bits = here >>> 24;
                    here_op = here >>> 16 & 0xff;
                    here_val = here & 0xffff;
                    if (here_bits <= bits) break;
                    //--- PULLBYTE() ---//
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                //---//
                }
                if (here_val < 16) {
                    //--- DROPBITS(here.bits) ---//
                    hold >>>= here_bits;
                    bits -= here_bits;
                    //---//
                    state.lens[state.have++] = here_val;
                } else {
                    if (here_val === 16) {
                        //=== NEEDBITS(here.bits + 2);
                        n = here_bits + 2;
                        while(bits < n){
                            if (have === 0) break inf_leave;
                            have--;
                            hold += input[next++] << bits;
                            bits += 8;
                        }
                        //===//
                        //--- DROPBITS(here.bits) ---//
                        hold >>>= here_bits;
                        bits -= here_bits;
                        //---//
                        if (state.have === 0) {
                            strm.msg = 'invalid bit length repeat';
                            state.mode = $2dd4f45c8894762f$var$BAD;
                            break;
                        }
                        len = state.lens[state.have - 1];
                        copy = 3 + (hold & 0x03); //BITS(2);
                        //--- DROPBITS(2) ---//
                        hold >>>= 2;
                        bits -= 2;
                    //---//
                    } else if (here_val === 17) {
                        //=== NEEDBITS(here.bits + 3);
                        n = here_bits + 3;
                        while(bits < n){
                            if (have === 0) break inf_leave;
                            have--;
                            hold += input[next++] << bits;
                            bits += 8;
                        }
                        //===//
                        //--- DROPBITS(here.bits) ---//
                        hold >>>= here_bits;
                        bits -= here_bits;
                        //---//
                        len = 0;
                        copy = 3 + (hold & 0x07); //BITS(3);
                        //--- DROPBITS(3) ---//
                        hold >>>= 3;
                        bits -= 3;
                    //---//
                    } else {
                        //=== NEEDBITS(here.bits + 7);
                        n = here_bits + 7;
                        while(bits < n){
                            if (have === 0) break inf_leave;
                            have--;
                            hold += input[next++] << bits;
                            bits += 8;
                        }
                        //===//
                        //--- DROPBITS(here.bits) ---//
                        hold >>>= here_bits;
                        bits -= here_bits;
                        //---//
                        len = 0;
                        copy = 11 + (hold & 0x7f); //BITS(7);
                        //--- DROPBITS(7) ---//
                        hold >>>= 7;
                        bits -= 7;
                    //---//
                    }
                    if (state.have + copy > state.nlen + state.ndist) {
                        strm.msg = 'invalid bit length repeat';
                        state.mode = $2dd4f45c8894762f$var$BAD;
                        break;
                    }
                    while(copy--)state.lens[state.have++] = len;
                }
            }
            /* handle error breaks in while */ if (state.mode === $2dd4f45c8894762f$var$BAD) break;
            /* check for end-of-block code (better have one) */ if (state.lens[256] === 0) {
                strm.msg = 'invalid code -- missing end-of-block';
                state.mode = $2dd4f45c8894762f$var$BAD;
                break;
            }
            /* build code tables -- note: do not change the lenbits or distbits
           values here (9 and 6) without reading the comments in inftrees.h
           concerning the ENOUGH constants, which depend on those values */ state.lenbits = 9;
            opts = {
                bits: state.lenbits
            };
            ret = $2dd4f45c8894762f$var$inftrees($2dd4f45c8894762f$var$LENS, state.lens, 0, state.nlen, state.lencode, 0, state.work, opts);
            // We have separate tables & no pointers. 2 commented lines below not needed.
            // state.next_index = opts.table_index;
            state.lenbits = opts.bits;
            // state.lencode = state.next;
            if (ret) {
                strm.msg = 'invalid literal/lengths set';
                state.mode = $2dd4f45c8894762f$var$BAD;
                break;
            }
            state.distbits = 6;
            //state.distcode.copy(state.codes);
            // Switch to use dynamic table
            state.distcode = state.distdyn;
            opts = {
                bits: state.distbits
            };
            ret = $2dd4f45c8894762f$var$inftrees($2dd4f45c8894762f$var$DISTS, state.lens, state.nlen, state.ndist, state.distcode, 0, state.work, opts);
            // We have separate tables & no pointers. 2 commented lines below not needed.
            // state.next_index = opts.table_index;
            state.distbits = opts.bits;
            // state.distcode = state.next;
            if (ret) {
                strm.msg = 'invalid distances set';
                state.mode = $2dd4f45c8894762f$var$BAD;
                break;
            }
            //Tracev((stderr, 'inflate:       codes ok\n'));
            state.mode = $2dd4f45c8894762f$var$LEN_;
            if (flush === $2dd4f45c8894762f$var$Z_TREES) break inf_leave;
        /* falls through */ case $2dd4f45c8894762f$var$LEN_:
            state.mode = $2dd4f45c8894762f$var$LEN;
        /* falls through */ case $2dd4f45c8894762f$var$LEN:
            if (have >= 6 && left >= 258) {
                //--- RESTORE() ---
                strm.next_out = put;
                strm.avail_out = left;
                strm.next_in = next;
                strm.avail_in = have;
                state.hold = hold;
                state.bits = bits;
                //---
                $2dd4f45c8894762f$var$inffast(strm, _out);
                //--- LOAD() ---
                put = strm.next_out;
                output = strm.output;
                left = strm.avail_out;
                next = strm.next_in;
                input = strm.input;
                have = strm.avail_in;
                hold = state.hold;
                bits = state.bits;
                //---
                if (state.mode === $2dd4f45c8894762f$var$TYPE) state.back = -1;
                break;
            }
            state.back = 0;
            for(;;){
                here = state.lencode[hold & (1 << state.lenbits) - 1]; /*BITS(state.lenbits)*/ 
                here_bits = here >>> 24;
                here_op = here >>> 16 & 0xff;
                here_val = here & 0xffff;
                if (here_bits <= bits) break;
                //--- PULLBYTE() ---//
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            //---//
            }
            if (here_op && (here_op & 0xf0) === 0) {
                last_bits = here_bits;
                last_op = here_op;
                last_val = here_val;
                for(;;){
                    here = state.lencode[last_val + ((hold & (1 << last_bits + last_op) - 1) >> last_bits)];
                    here_bits = here >>> 24;
                    here_op = here >>> 16 & 0xff;
                    here_val = here & 0xffff;
                    if (last_bits + here_bits <= bits) break;
                    //--- PULLBYTE() ---//
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                //---//
                }
                //--- DROPBITS(last.bits) ---//
                hold >>>= last_bits;
                bits -= last_bits;
                //---//
                state.back += last_bits;
            }
            //--- DROPBITS(here.bits) ---//
            hold >>>= here_bits;
            bits -= here_bits;
            //---//
            state.back += here_bits;
            state.length = here_val;
            if (here_op === 0) {
                //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
                //        "inflate:         literal '%c'\n" :
                //        "inflate:         literal 0x%02x\n", here.val));
                state.mode = $2dd4f45c8894762f$var$LIT;
                break;
            }
            if (here_op & 32) {
                //Tracevv((stderr, "inflate:         end of block\n"));
                state.back = -1;
                state.mode = $2dd4f45c8894762f$var$TYPE;
                break;
            }
            if (here_op & 64) {
                strm.msg = 'invalid literal/length code';
                state.mode = $2dd4f45c8894762f$var$BAD;
                break;
            }
            state.extra = here_op & 15;
            state.mode = $2dd4f45c8894762f$var$LENEXT;
        /* falls through */ case $2dd4f45c8894762f$var$LENEXT:
            if (state.extra) {
                //=== NEEDBITS(state.extra);
                n = state.extra;
                while(bits < n){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.length += hold & (1 << state.extra) - 1 /*BITS(state.extra)*/ ;
                //--- DROPBITS(state.extra) ---//
                hold >>>= state.extra;
                bits -= state.extra;
                //---//
                state.back += state.extra;
            }
            //Tracevv((stderr, "inflate:         length %u\n", state.length));
            state.was = state.length;
            state.mode = $2dd4f45c8894762f$var$DIST;
        /* falls through */ case $2dd4f45c8894762f$var$DIST:
            for(;;){
                here = state.distcode[hold & (1 << state.distbits) - 1]; /*BITS(state.distbits)*/ 
                here_bits = here >>> 24;
                here_op = here >>> 16 & 0xff;
                here_val = here & 0xffff;
                if (here_bits <= bits) break;
                //--- PULLBYTE() ---//
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            //---//
            }
            if ((here_op & 0xf0) === 0) {
                last_bits = here_bits;
                last_op = here_op;
                last_val = here_val;
                for(;;){
                    here = state.distcode[last_val + ((hold & (1 << last_bits + last_op) - 1) >> last_bits)];
                    here_bits = here >>> 24;
                    here_op = here >>> 16 & 0xff;
                    here_val = here & 0xffff;
                    if (last_bits + here_bits <= bits) break;
                    //--- PULLBYTE() ---//
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                //---//
                }
                //--- DROPBITS(last.bits) ---//
                hold >>>= last_bits;
                bits -= last_bits;
                //---//
                state.back += last_bits;
            }
            //--- DROPBITS(here.bits) ---//
            hold >>>= here_bits;
            bits -= here_bits;
            //---//
            state.back += here_bits;
            if (here_op & 64) {
                strm.msg = 'invalid distance code';
                state.mode = $2dd4f45c8894762f$var$BAD;
                break;
            }
            state.offset = here_val;
            state.extra = here_op & 15;
            state.mode = $2dd4f45c8894762f$var$DISTEXT;
        /* falls through */ case $2dd4f45c8894762f$var$DISTEXT:
            if (state.extra) {
                //=== NEEDBITS(state.extra);
                n = state.extra;
                while(bits < n){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.offset += hold & (1 << state.extra) - 1 /*BITS(state.extra)*/ ;
                //--- DROPBITS(state.extra) ---//
                hold >>>= state.extra;
                bits -= state.extra;
                //---//
                state.back += state.extra;
            }
            //#ifdef INFLATE_STRICT
            if (state.offset > state.dmax) {
                strm.msg = 'invalid distance too far back';
                state.mode = $2dd4f45c8894762f$var$BAD;
                break;
            }
            //#endif
            //Tracevv((stderr, "inflate:         distance %u\n", state.offset));
            state.mode = $2dd4f45c8894762f$var$MATCH;
        /* falls through */ case $2dd4f45c8894762f$var$MATCH:
            if (left === 0) break inf_leave;
            copy = _out - left;
            if (state.offset > copy) {
                copy = state.offset - copy;
                if (copy > state.whave) {
                    if (state.sane) {
                        strm.msg = 'invalid distance too far back';
                        state.mode = $2dd4f45c8894762f$var$BAD;
                        break;
                    }
                }
                if (copy > state.wnext) {
                    copy -= state.wnext;
                    from = state.wsize - copy;
                } else from = state.wnext - copy;
                if (copy > state.length) copy = state.length;
                from_source = state.window;
            } else {
                from_source = output;
                from = put - state.offset;
                copy = state.length;
            }
            if (copy > left) copy = left;
            left -= copy;
            state.length -= copy;
            do output[put++] = from_source[from++];
            while (--copy);
            if (state.length === 0) state.mode = $2dd4f45c8894762f$var$LEN;
            break;
        case $2dd4f45c8894762f$var$LIT:
            if (left === 0) break inf_leave;
            output[put++] = state.length;
            left--;
            state.mode = $2dd4f45c8894762f$var$LEN;
            break;
        case $2dd4f45c8894762f$var$CHECK:
            if (state.wrap) {
                //=== NEEDBITS(32);
                while(bits < 32){
                    if (have === 0) break inf_leave;
                    have--;
                    // Use '|' instead of '+' to make sure that result is signed
                    hold |= input[next++] << bits;
                    bits += 8;
                }
                //===//
                _out -= left;
                strm.total_out += _out;
                state.total += _out;
                if (state.wrap & 4 && _out) strm.adler = state.check = /*UPDATE_CHECK(state.check, put - _out, _out);*/ state.flags ? $2dd4f45c8894762f$var$crc32_1(state.check, output, _out, put - _out) : $2dd4f45c8894762f$var$adler32_1(state.check, output, _out, put - _out);
                _out = left;
                // NB: crc32 stored as signed 32-bit int, zswap32 returns signed too
                if (state.wrap & 4 && (state.flags ? hold : $2dd4f45c8894762f$var$zswap32(hold)) !== state.check) {
                    strm.msg = 'incorrect data check';
                    state.mode = $2dd4f45c8894762f$var$BAD;
                    break;
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            //Tracev((stderr, "inflate:   check matches trailer\n"));
            }
            state.mode = $2dd4f45c8894762f$var$LENGTH;
        /* falls through */ case $2dd4f45c8894762f$var$LENGTH:
            if (state.wrap && state.flags) {
                //=== NEEDBITS(32);
                while(bits < 32){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                if (state.wrap & 4 && hold !== (state.total & 0xffffffff)) {
                    strm.msg = 'incorrect length check';
                    state.mode = $2dd4f45c8894762f$var$BAD;
                    break;
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            //Tracev((stderr, "inflate:   length matches trailer\n"));
            }
            state.mode = $2dd4f45c8894762f$var$DONE;
        /* falls through */ case $2dd4f45c8894762f$var$DONE:
            ret = $2dd4f45c8894762f$var$Z_STREAM_END$1;
            break inf_leave;
        case $2dd4f45c8894762f$var$BAD:
            ret = $2dd4f45c8894762f$var$Z_DATA_ERROR$1;
            break inf_leave;
        case $2dd4f45c8894762f$var$MEM:
            return $2dd4f45c8894762f$var$Z_MEM_ERROR$1;
        case $2dd4f45c8894762f$var$SYNC:
        /* falls through */ default:
            return $2dd4f45c8894762f$var$Z_STREAM_ERROR$1;
    }
    // inf_leave <- here is real place for "goto inf_leave", emulated via "break inf_leave"
    /*
     Return from inflate(), updating the total counts and the check value.
     If there was no progress during the inflate() call, return a buffer
     error.  Call updatewindow() to create and/or update the window state.
     Note: a memory error from inflate() is non-recoverable.
   */ //--- RESTORE() ---
    strm.next_out = put;
    strm.avail_out = left;
    strm.next_in = next;
    strm.avail_in = have;
    state.hold = hold;
    state.bits = bits;
    //---
    if (state.wsize || _out !== strm.avail_out && state.mode < $2dd4f45c8894762f$var$BAD && (state.mode < $2dd4f45c8894762f$var$CHECK || flush !== $2dd4f45c8894762f$var$Z_FINISH$1)) $2dd4f45c8894762f$var$updatewindow(strm, strm.output, strm.next_out, _out - strm.avail_out);
    _in -= strm.avail_in;
    _out -= strm.avail_out;
    strm.total_in += _in;
    strm.total_out += _out;
    state.total += _out;
    if (state.wrap & 4 && _out) strm.adler = state.check = /*UPDATE_CHECK(state.check, strm.next_out - _out, _out);*/ state.flags ? $2dd4f45c8894762f$var$crc32_1(state.check, output, _out, strm.next_out - _out) : $2dd4f45c8894762f$var$adler32_1(state.check, output, _out, strm.next_out - _out);
    strm.data_type = state.bits + (state.last ? 64 : 0) + (state.mode === $2dd4f45c8894762f$var$TYPE ? 128 : 0) + (state.mode === $2dd4f45c8894762f$var$LEN_ || state.mode === $2dd4f45c8894762f$var$COPY_ ? 256 : 0);
    if ((_in === 0 && _out === 0 || flush === $2dd4f45c8894762f$var$Z_FINISH$1) && ret === $2dd4f45c8894762f$var$Z_OK$1) ret = $2dd4f45c8894762f$var$Z_BUF_ERROR;
    return ret;
};
const $2dd4f45c8894762f$var$inflateEnd = (strm)=>{
    if ($2dd4f45c8894762f$var$inflateStateCheck(strm)) return $2dd4f45c8894762f$var$Z_STREAM_ERROR$1;
    let state = strm.state;
    if (state.window) state.window = null;
    strm.state = null;
    return $2dd4f45c8894762f$var$Z_OK$1;
};
const $2dd4f45c8894762f$var$inflateGetHeader = (strm, head)=>{
    /* check state */ if ($2dd4f45c8894762f$var$inflateStateCheck(strm)) return $2dd4f45c8894762f$var$Z_STREAM_ERROR$1;
    const state = strm.state;
    if ((state.wrap & 2) === 0) return $2dd4f45c8894762f$var$Z_STREAM_ERROR$1;
    /* save header structure */ state.head = head;
    head.done = false;
    return $2dd4f45c8894762f$var$Z_OK$1;
};
const $2dd4f45c8894762f$var$inflateSetDictionary = (strm, dictionary)=>{
    const dictLength = dictionary.length;
    let state;
    let dictid;
    let ret;
    /* check state */ if ($2dd4f45c8894762f$var$inflateStateCheck(strm)) return $2dd4f45c8894762f$var$Z_STREAM_ERROR$1;
    state = strm.state;
    if (state.wrap !== 0 && state.mode !== $2dd4f45c8894762f$var$DICT) return $2dd4f45c8894762f$var$Z_STREAM_ERROR$1;
    /* check for correct dictionary identifier */ if (state.mode === $2dd4f45c8894762f$var$DICT) {
        dictid = 1; /* adler32(0, null, 0)*/ 
        /* dictid = adler32(dictid, dictionary, dictLength); */ dictid = $2dd4f45c8894762f$var$adler32_1(dictid, dictionary, dictLength, 0);
        if (dictid !== state.check) return $2dd4f45c8894762f$var$Z_DATA_ERROR$1;
    }
    /* copy dictionary to window using updatewindow(), which will amend the
   existing dictionary if appropriate */ ret = $2dd4f45c8894762f$var$updatewindow(strm, dictionary, dictLength, dictLength);
    if (ret) {
        state.mode = $2dd4f45c8894762f$var$MEM;
        return $2dd4f45c8894762f$var$Z_MEM_ERROR$1;
    }
    state.havedict = 1;
    // Tracev((stderr, "inflate:   dictionary set\n"));
    return $2dd4f45c8894762f$var$Z_OK$1;
};
var $2dd4f45c8894762f$var$inflateReset_1 = $2dd4f45c8894762f$var$inflateReset;
var $2dd4f45c8894762f$var$inflateReset2_1 = $2dd4f45c8894762f$var$inflateReset2;
var $2dd4f45c8894762f$var$inflateResetKeep_1 = $2dd4f45c8894762f$var$inflateResetKeep;
var $2dd4f45c8894762f$var$inflateInit_1 = $2dd4f45c8894762f$var$inflateInit;
var $2dd4f45c8894762f$var$inflateInit2_1 = $2dd4f45c8894762f$var$inflateInit2;
var $2dd4f45c8894762f$var$inflate_2$1 = $2dd4f45c8894762f$var$inflate$2;
var $2dd4f45c8894762f$var$inflateEnd_1 = $2dd4f45c8894762f$var$inflateEnd;
var $2dd4f45c8894762f$var$inflateGetHeader_1 = $2dd4f45c8894762f$var$inflateGetHeader;
var $2dd4f45c8894762f$var$inflateSetDictionary_1 = $2dd4f45c8894762f$var$inflateSetDictionary;
var $2dd4f45c8894762f$var$inflateInfo = 'pako inflate (from Nodeca project)';
/* Not implemented
module.exports.inflateCodesUsed = inflateCodesUsed;
module.exports.inflateCopy = inflateCopy;
module.exports.inflateGetDictionary = inflateGetDictionary;
module.exports.inflateMark = inflateMark;
module.exports.inflatePrime = inflatePrime;
module.exports.inflateSync = inflateSync;
module.exports.inflateSyncPoint = inflateSyncPoint;
module.exports.inflateUndermine = inflateUndermine;
module.exports.inflateValidate = inflateValidate;
*/ var $2dd4f45c8894762f$var$inflate_1$2 = {
    inflateReset: $2dd4f45c8894762f$var$inflateReset_1,
    inflateReset2: $2dd4f45c8894762f$var$inflateReset2_1,
    inflateResetKeep: $2dd4f45c8894762f$var$inflateResetKeep_1,
    inflateInit: $2dd4f45c8894762f$var$inflateInit_1,
    inflateInit2: $2dd4f45c8894762f$var$inflateInit2_1,
    inflate: $2dd4f45c8894762f$var$inflate_2$1,
    inflateEnd: $2dd4f45c8894762f$var$inflateEnd_1,
    inflateGetHeader: $2dd4f45c8894762f$var$inflateGetHeader_1,
    inflateSetDictionary: $2dd4f45c8894762f$var$inflateSetDictionary_1,
    inflateInfo: $2dd4f45c8894762f$var$inflateInfo
};
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
function $2dd4f45c8894762f$var$GZheader() {
    /* true if compressed data believed to be text */ this.text = 0;
    /* modification time */ this.time = 0;
    /* extra flags (not used when writing a gzip file) */ this.xflags = 0;
    /* operating system */ this.os = 0;
    /* pointer to extra field or Z_NULL if none */ this.extra = null;
    /* extra field length (valid if extra != Z_NULL) */ this.extra_len = 0; // Actually, we don't need it in JS,
    // but leave for few code modifications
    //
    // Setup limits is not necessary because in js we should not preallocate memory
    // for inflate use constant limit in 65536 bytes
    //
    /* space at extra (only when reading header) */ // this.extra_max  = 0;
    /* pointer to zero-terminated file name or Z_NULL */ this.name = '';
    /* space at name (only when reading header) */ // this.name_max   = 0;
    /* pointer to zero-terminated comment or Z_NULL */ this.comment = '';
    /* space at comment (only when reading header) */ // this.comm_max   = 0;
    /* true if there was or will be a header crc */ this.hcrc = 0;
    /* true when done reading gzip header (not used when writing a gzip file) */ this.done = false;
}
var $2dd4f45c8894762f$var$gzheader = $2dd4f45c8894762f$var$GZheader;
const $2dd4f45c8894762f$var$toString = Object.prototype.toString;
/* Public constants ==========================================================*/ /* ===========================================================================*/ const { Z_NO_FLUSH: $2dd4f45c8894762f$var$Z_NO_FLUSH, Z_FINISH: $2dd4f45c8894762f$var$Z_FINISH, Z_OK: $2dd4f45c8894762f$var$Z_OK, Z_STREAM_END: $2dd4f45c8894762f$var$Z_STREAM_END, Z_NEED_DICT: $2dd4f45c8894762f$var$Z_NEED_DICT, Z_STREAM_ERROR: $2dd4f45c8894762f$var$Z_STREAM_ERROR, Z_DATA_ERROR: $2dd4f45c8894762f$var$Z_DATA_ERROR, Z_MEM_ERROR: $2dd4f45c8894762f$var$Z_MEM_ERROR } = $2dd4f45c8894762f$var$constants$2;
/* ===========================================================================*/ /**
 * class Inflate
 *
 * Generic JS-style wrapper for zlib calls. If you don't need
 * streaming behaviour - use more simple functions: [[inflate]]
 * and [[inflateRaw]].
 **/ /* internal
 * inflate.chunks -> Array
 *
 * Chunks of output data, if [[Inflate#onData]] not overridden.
 **/ /**
 * Inflate.result -> Uint8Array|String
 *
 * Uncompressed result, generated by default [[Inflate#onData]]
 * and [[Inflate#onEnd]] handlers. Filled after you push last chunk
 * (call [[Inflate#push]] with `Z_FINISH` / `true` param).
 **/ /**
 * Inflate.err -> Number
 *
 * Error code after inflate finished. 0 (Z_OK) on success.
 * Should be checked if broken data possible.
 **/ /**
 * Inflate.msg -> String
 *
 * Error message, if [[Inflate.err]] != 0
 **/ /**
 * new Inflate(options)
 * - options (Object): zlib inflate options.
 *
 * Creates new inflator instance with specified params. Throws exception
 * on bad params. Supported options:
 *
 * - `windowBits`
 * - `dictionary`
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information on these.
 *
 * Additional options, for internal needs:
 *
 * - `chunkSize` - size of generated data chunks (16K by default)
 * - `raw` (Boolean) - do raw inflate
 * - `to` (String) - if equal to 'string', then result will be converted
 *   from utf8 to utf16 (javascript) string. When string output requested,
 *   chunk length can differ from `chunkSize`, depending on content.
 *
 * By default, when no options set, autodetect deflate/gzip data format via
 * wrapper header.
 *
 * ##### Example:
 *
 * ```javascript
 * const pako = require('pako')
 * const chunk1 = new Uint8Array([1,2,3,4,5,6,7,8,9])
 * const chunk2 = new Uint8Array([10,11,12,13,14,15,16,17,18,19]);
 *
 * const inflate = new pako.Inflate({ level: 3});
 *
 * inflate.push(chunk1, false);
 * inflate.push(chunk2, true);  // true -> last chunk
 *
 * if (inflate.err) { throw new Error(inflate.err); }
 *
 * console.log(inflate.result);
 * ```
 **/ function $2dd4f45c8894762f$var$Inflate$1(options) {
    this.options = $2dd4f45c8894762f$var$common.assign({
        chunkSize: 65536,
        windowBits: 15,
        to: ''
    }, options || {});
    const opt = this.options;
    // Force window size for `raw` data, if not set directly,
    // because we have no header for autodetect.
    if (opt.raw && opt.windowBits >= 0 && opt.windowBits < 16) {
        opt.windowBits = -opt.windowBits;
        if (opt.windowBits === 0) opt.windowBits = -15;
    }
    // If `windowBits` not defined (and mode not raw) - set autodetect flag for gzip/deflate
    if (opt.windowBits >= 0 && opt.windowBits < 16 && !(options && options.windowBits)) opt.windowBits += 32;
    // Gzip header has no info about windows size, we can do autodetect only
    // for deflate. So, if window size not set, force it to max when gzip possible
    if (opt.windowBits > 15 && opt.windowBits < 48) // bit 3 (16) -> gzipped data
    // bit 4 (32) -> autodetect gzip/deflate
    {
        if ((opt.windowBits & 15) === 0) opt.windowBits |= 15;
    }
    this.err = 0; // error code, if happens (0 = Z_OK)
    this.msg = ''; // error message
    this.ended = false; // used to avoid multiple onEnd() calls
    this.chunks = []; // chunks of compressed data
    this.strm = new $2dd4f45c8894762f$var$zstream();
    this.strm.avail_out = 0;
    let status = $2dd4f45c8894762f$var$inflate_1$2.inflateInit2(this.strm, opt.windowBits);
    if (status !== $2dd4f45c8894762f$var$Z_OK) throw new Error($2dd4f45c8894762f$var$messages[status]);
    this.header = new $2dd4f45c8894762f$var$gzheader();
    $2dd4f45c8894762f$var$inflate_1$2.inflateGetHeader(this.strm, this.header);
    // Setup dictionary
    if (opt.dictionary) {
        // Convert data if needed
        if (typeof opt.dictionary === 'string') opt.dictionary = $2dd4f45c8894762f$var$strings.string2buf(opt.dictionary);
        else if ($2dd4f45c8894762f$var$toString.call(opt.dictionary) === '[object ArrayBuffer]') opt.dictionary = new Uint8Array(opt.dictionary);
        if (opt.raw) {
            status = $2dd4f45c8894762f$var$inflate_1$2.inflateSetDictionary(this.strm, opt.dictionary);
            if (status !== $2dd4f45c8894762f$var$Z_OK) throw new Error($2dd4f45c8894762f$var$messages[status]);
        }
    }
}
/**
 * Inflate#push(data[, flush_mode]) -> Boolean
 * - data (Uint8Array|ArrayBuffer): input data
 * - flush_mode (Number|Boolean): 0..6 for corresponding Z_NO_FLUSH..Z_TREE
 *   flush modes. See constants. Skipped or `false` means Z_NO_FLUSH,
 *   `true` means Z_FINISH.
 *
 * Sends input data to inflate pipe, generating [[Inflate#onData]] calls with
 * new output chunks. Returns `true` on success. If end of stream detected,
 * [[Inflate#onEnd]] will be called.
 *
 * `flush_mode` is not needed for normal operation, because end of stream
 * detected automatically. You may try to use it for advanced things, but
 * this functionality was not tested.
 *
 * On fail call [[Inflate#onEnd]] with error code and return false.
 *
 * ##### Example
 *
 * ```javascript
 * push(chunk, false); // push one of data chunks
 * ...
 * push(chunk, true);  // push last chunk
 * ```
 **/ $2dd4f45c8894762f$var$Inflate$1.prototype.push = function(data, flush_mode) {
    const strm = this.strm;
    const chunkSize = this.options.chunkSize;
    const dictionary = this.options.dictionary;
    let status, _flush_mode, last_avail_out;
    if (this.ended) return false;
    if (flush_mode === ~~flush_mode) _flush_mode = flush_mode;
    else _flush_mode = flush_mode === true ? $2dd4f45c8894762f$var$Z_FINISH : $2dd4f45c8894762f$var$Z_NO_FLUSH;
    // Convert data if needed
    if ($2dd4f45c8894762f$var$toString.call(data) === '[object ArrayBuffer]') strm.input = new Uint8Array(data);
    else strm.input = data;
    strm.next_in = 0;
    strm.avail_in = strm.input.length;
    for(;;){
        if (strm.avail_out === 0) {
            strm.output = new Uint8Array(chunkSize);
            strm.next_out = 0;
            strm.avail_out = chunkSize;
        }
        status = $2dd4f45c8894762f$var$inflate_1$2.inflate(strm, _flush_mode);
        if (status === $2dd4f45c8894762f$var$Z_NEED_DICT && dictionary) {
            status = $2dd4f45c8894762f$var$inflate_1$2.inflateSetDictionary(strm, dictionary);
            if (status === $2dd4f45c8894762f$var$Z_OK) status = $2dd4f45c8894762f$var$inflate_1$2.inflate(strm, _flush_mode);
            else if (status === $2dd4f45c8894762f$var$Z_DATA_ERROR) // Replace code with more verbose
            status = $2dd4f45c8894762f$var$Z_NEED_DICT;
        }
        // Skip snyc markers if more data follows and not raw mode
        while(strm.avail_in > 0 && status === $2dd4f45c8894762f$var$Z_STREAM_END && strm.state.wrap > 0 && data[strm.next_in] !== 0){
            $2dd4f45c8894762f$var$inflate_1$2.inflateReset(strm);
            status = $2dd4f45c8894762f$var$inflate_1$2.inflate(strm, _flush_mode);
        }
        switch(status){
            case $2dd4f45c8894762f$var$Z_STREAM_ERROR:
            case $2dd4f45c8894762f$var$Z_DATA_ERROR:
            case $2dd4f45c8894762f$var$Z_NEED_DICT:
            case $2dd4f45c8894762f$var$Z_MEM_ERROR:
                this.onEnd(status);
                this.ended = true;
                return false;
        }
        // Remember real `avail_out` value, because we may patch out buffer content
        // to align utf8 strings boundaries.
        last_avail_out = strm.avail_out;
        if (strm.next_out) {
            if (strm.avail_out === 0 || status === $2dd4f45c8894762f$var$Z_STREAM_END) {
                if (this.options.to === 'string') {
                    let next_out_utf8 = $2dd4f45c8894762f$var$strings.utf8border(strm.output, strm.next_out);
                    let tail = strm.next_out - next_out_utf8;
                    let utf8str = $2dd4f45c8894762f$var$strings.buf2string(strm.output, next_out_utf8);
                    // move tail & realign counters
                    strm.next_out = tail;
                    strm.avail_out = chunkSize - tail;
                    if (tail) strm.output.set(strm.output.subarray(next_out_utf8, next_out_utf8 + tail), 0);
                    this.onData(utf8str);
                } else this.onData(strm.output.length === strm.next_out ? strm.output : strm.output.subarray(0, strm.next_out));
            }
        }
        // Must repeat iteration if out buffer is full
        if (status === $2dd4f45c8894762f$var$Z_OK && last_avail_out === 0) continue;
        // Finalize if end of stream reached.
        if (status === $2dd4f45c8894762f$var$Z_STREAM_END) {
            status = $2dd4f45c8894762f$var$inflate_1$2.inflateEnd(this.strm);
            this.onEnd(status);
            this.ended = true;
            return true;
        }
        if (strm.avail_in === 0) break;
    }
    return true;
};
/**
 * Inflate#onData(chunk) -> Void
 * - chunk (Uint8Array|String): output data. When string output requested,
 *   each chunk will be string.
 *
 * By default, stores data blocks in `chunks[]` property and glue
 * those in `onEnd`. Override this handler, if you need another behaviour.
 **/ $2dd4f45c8894762f$var$Inflate$1.prototype.onData = function(chunk) {
    this.chunks.push(chunk);
};
/**
 * Inflate#onEnd(status) -> Void
 * - status (Number): inflate status. 0 (Z_OK) on success,
 *   other if not.
 *
 * Called either after you tell inflate that the input stream is
 * complete (Z_FINISH). By default - join collected chunks,
 * free memory and fill `results` / `err` properties.
 **/ $2dd4f45c8894762f$var$Inflate$1.prototype.onEnd = function(status) {
    // On success - join
    if (status === $2dd4f45c8894762f$var$Z_OK) {
        if (this.options.to === 'string') this.result = this.chunks.join('');
        else this.result = $2dd4f45c8894762f$var$common.flattenChunks(this.chunks);
    }
    this.chunks = [];
    this.err = status;
    this.msg = this.strm.msg;
};
/**
 * inflate(data[, options]) -> Uint8Array|String
 * - data (Uint8Array|ArrayBuffer): input data to decompress.
 * - options (Object): zlib inflate options.
 *
 * Decompress `data` with inflate/ungzip and `options`. Autodetect
 * format via wrapper header by default. That's why we don't provide
 * separate `ungzip` method.
 *
 * Supported options are:
 *
 * - windowBits
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information.
 *
 * Sugar (options):
 *
 * - `raw` (Boolean) - say that we work with raw stream, if you don't wish to specify
 *   negative windowBits implicitly.
 * - `to` (String) - if equal to 'string', then result will be converted
 *   from utf8 to utf16 (javascript) string. When string output requested,
 *   chunk length can differ from `chunkSize`, depending on content.
 *
 *
 * ##### Example:
 *
 * ```javascript
 * const pako = require('pako');
 * const input = pako.deflate(new Uint8Array([1,2,3,4,5,6,7,8,9]));
 * let output;
 *
 * try {
 *   output = pako.inflate(input);
 * } catch (err) {
 *   console.log(err);
 * }
 * ```
 **/ function $2dd4f45c8894762f$var$inflate$1(input, options) {
    const inflator = new $2dd4f45c8894762f$var$Inflate$1(options);
    inflator.push(input);
    // That will never happens, if you don't cheat with options :)
    if (inflator.err) throw inflator.msg || $2dd4f45c8894762f$var$messages[inflator.err];
    return inflator.result;
}
/**
 * inflateRaw(data[, options]) -> Uint8Array|String
 * - data (Uint8Array|ArrayBuffer): input data to decompress.
 * - options (Object): zlib inflate options.
 *
 * The same as [[inflate]], but creates raw data, without wrapper
 * (header and adler32 crc).
 **/ function $2dd4f45c8894762f$var$inflateRaw$1(input, options) {
    options = options || {};
    options.raw = true;
    return $2dd4f45c8894762f$var$inflate$1(input, options);
}
/**
 * ungzip(data[, options]) -> Uint8Array|String
 * - data (Uint8Array|ArrayBuffer): input data to decompress.
 * - options (Object): zlib inflate options.
 *
 * Just shortcut to [[inflate]], because it autodetects format
 * by header.content. Done for convenience.
 **/ var $2dd4f45c8894762f$var$Inflate_1$1 = $2dd4f45c8894762f$var$Inflate$1;
var $2dd4f45c8894762f$var$inflate_2 = $2dd4f45c8894762f$var$inflate$1;
var $2dd4f45c8894762f$var$inflateRaw_1$1 = $2dd4f45c8894762f$var$inflateRaw$1;
var $2dd4f45c8894762f$var$ungzip$1 = $2dd4f45c8894762f$var$inflate$1;
var $2dd4f45c8894762f$var$constants = $2dd4f45c8894762f$var$constants$2;
var $2dd4f45c8894762f$var$inflate_1$1 = {
    Inflate: $2dd4f45c8894762f$var$Inflate_1$1,
    inflate: $2dd4f45c8894762f$var$inflate_2,
    inflateRaw: $2dd4f45c8894762f$var$inflateRaw_1$1,
    ungzip: $2dd4f45c8894762f$var$ungzip$1,
    constants: $2dd4f45c8894762f$var$constants
};
const { Deflate: $2dd4f45c8894762f$var$Deflate, deflate: $2dd4f45c8894762f$var$deflate, deflateRaw: $2dd4f45c8894762f$var$deflateRaw, gzip: $2dd4f45c8894762f$var$gzip } = $2dd4f45c8894762f$var$deflate_1$1;
const { Inflate: $2dd4f45c8894762f$var$Inflate, inflate: $2dd4f45c8894762f$var$inflate, inflateRaw: $2dd4f45c8894762f$var$inflateRaw, ungzip: $2dd4f45c8894762f$var$ungzip } = $2dd4f45c8894762f$var$inflate_1$1;
var $2dd4f45c8894762f$export$ae157b6234afe138 = $2dd4f45c8894762f$var$Deflate;
var $2dd4f45c8894762f$export$2316623ecd1285ab = $2dd4f45c8894762f$var$deflate;
var $2dd4f45c8894762f$export$e95d6a8f69fb340a = $2dd4f45c8894762f$var$deflateRaw;
var $2dd4f45c8894762f$export$69f0ea7cf3a331a8 = $2dd4f45c8894762f$var$gzip;
var $2dd4f45c8894762f$export$d1de70a877d6e43c = $2dd4f45c8894762f$var$Inflate;
var $2dd4f45c8894762f$export$cae1ce83fe4a1782 = $2dd4f45c8894762f$var$inflate;
var $2dd4f45c8894762f$export$d0f0aa2d05c905c5 = $2dd4f45c8894762f$var$inflateRaw;
var $2dd4f45c8894762f$export$95adf9d270383091 = $2dd4f45c8894762f$var$ungzip;
var $2dd4f45c8894762f$export$1a988e7317c65621 = $2dd4f45c8894762f$var$constants$2;
var $2dd4f45c8894762f$export$2e2bcd8739ae039 = {
    Deflate: $2dd4f45c8894762f$export$ae157b6234afe138,
    deflate: $2dd4f45c8894762f$export$2316623ecd1285ab,
    deflateRaw: $2dd4f45c8894762f$export$e95d6a8f69fb340a,
    gzip: $2dd4f45c8894762f$export$69f0ea7cf3a331a8,
    Inflate: $2dd4f45c8894762f$export$d1de70a877d6e43c,
    inflate: $2dd4f45c8894762f$export$cae1ce83fe4a1782,
    inflateRaw: $2dd4f45c8894762f$export$d0f0aa2d05c905c5,
    ungzip: $2dd4f45c8894762f$export$95adf9d270383091,
    constants: $2dd4f45c8894762f$export$1a988e7317c65621
};

});

parcelRegister("a56V2", function(module, exports) {
module.exports = import.meta.resolve("iBGpI");

});


parcelRegister("8BDVI", function(module, exports) {
module.exports = import("f3XbX").then(()=>parcelRequire('iNwrO'));

});


parcelRegister("e8aKe", function(module, exports) {

$parcel$export(module.exports, "getLabelsVisible", () => $a49a25b1cc68a3e2$export$df3134c34edb3420);
$parcel$export(module.exports, "setLabelsVisible", () => $a49a25b1cc68a3e2$export$7c2844ea27b4593a);
$parcel$export(module.exports, "initializeGraph", () => $a49a25b1cc68a3e2$export$82c630a16d9c47e8);

var $2UrZ2 = parcelRequire("2UrZ2");

var $5qD1E = parcelRequire("5qD1E");

var $lsJox = parcelRequire("lsJox");

var $gDo9R = parcelRequire("gDo9R");

var $aPVQm = parcelRequire("aPVQm");
// Register the SVG extension
(0, $lsJox.default).use((0, (/*@__PURE__*/$parcel$interopDefault($gDo9R))));
function $a49a25b1cc68a3e2$var$getColorForWeight(weight, minWeight, maxWeight, colorScale) {
    if (weight <= minWeight) return colorScale[0];
    if (weight >= maxWeight) return colorScale[colorScale.length - 1];
    const index = Math.floor((colorScale.length - 1) * (weight - minWeight) / (maxWeight - minWeight));
    return colorScale[index];
}
// Export a getter and setter for labelsVisible
let $a49a25b1cc68a3e2$var$labelsVisible = false;
function $a49a25b1cc68a3e2$export$df3134c34edb3420() {
    return $a49a25b1cc68a3e2$var$labelsVisible;
}
function $a49a25b1cc68a3e2$export$7c2844ea27b4593a(value) {
    $a49a25b1cc68a3e2$var$labelsVisible = value;
}
function $a49a25b1cc68a3e2$export$82c630a16d9c47e8(graphData) {
    const maxWeight = Math.max(...graphData.edges.map((edge)=>edge.data.weight));
    // Assume minWeight and maxWeight are known (you can calculate these based on your data)
    const minWeight = 1;
    const colorScale = (0, $aPVQm.default).scale([
        "gray",
        "black"
    ]).mode("lch").colors(maxWeight);
    let node_label = function(ele) {
        if (!$a49a25b1cc68a3e2$export$df3134c34edb3420()) return "";
        return ele.data("gene_name") ? ele.data("gene_name") : "";
    };
    let edge_label = function(ele) {
        if (!$a49a25b1cc68a3e2$export$df3134c34edb3420()) return "";
        return ele.data("weight") ? ele.data("weight") : "";
    };
    (0, $5qD1E.STATE).cy = (0, $lsJox.default)({
        container: document.getElementById("cy"),
        layout: {
            name: "dagre",
            fit: true,
            padding: 10,
            avoidOverlap: true,
            rankDir: "LR"
        },
        style: [
            {
                selector: "node",
                style: {
                    label: node_label,
                    "background-color": (0, $5qD1E.STATE).nodeColor,
                    "border-color": "#000",
                    "border-width": 2,
                    shape: "ellipse"
                }
            },
            {
                selector: "node[source-node]",
                style: {
                    "background-color": (0, $5qD1E.STATE).sourceNodeColor
                }
            },
            {
                selector: "edge",
                style: {
                    width: 4,
                    "line-color": (ele)=>{
                        const weight = ele.data("weight");
                        return $a49a25b1cc68a3e2$var$getColorForWeight(weight, minWeight, maxWeight, colorScale);
                    },
                    "target-arrow-color": (ele)=>{
                        const weight = ele.data("weight");
                        return $a49a25b1cc68a3e2$var$getColorForWeight(weight, minWeight, maxWeight, colorScale);
                    },
                    label: edge_label,
                    "text-rotation": "autorotate",
                    "target-arrow-shape": "triangle",
                    "curve-style": "bezier",
                    "text-margin-y": -10
                }
            },
            // Add these style definitions for highlighted and faded elements
            {
                selector: ".highlighted",
                style: {
                    "border-width": 4,
                    "border-color": "#ff0000",
                    "background-color": "#ffcccc",
                    color: "#000000",
                    "font-weight": "bold",
                    "z-index": 999,
                    "transition-property": "border-width, border-color, background-color, color, font-weight, opacity",
                    "transition-duration": "0.3s"
                }
            },
            {
                selector: ".faded",
                style: {
                    opacity: 0.25,
                    "transition-property": "opacity",
                    "transition-duration": "0.3s"
                }
            }
        ],
        // initial viewport state:
        zoom: 1,
        pan: {
            x: 0,
            y: 0
        },
        // interaction options:
        minZoom: 0.1,
        maxZoom: 3,
        zoomingEnabled: true,
        userZoomingEnabled: true,
        panningEnabled: true,
        userPanningEnabled: true,
        boxSelectionEnabled: true,
        selectionType: "single",
        touchTapThreshold: 8,
        desktopTapThreshold: 4,
        autolock: false,
        autoungrabify: false,
        elements: graphData
    });
    (0, $5qD1E.STATE).cy.nodes().forEach((node)=>{
        if (node.outgoers().edges().length > 0 && node.incomers().edges().length === 0) node.data("source-node", true);
    });
    // set style highlight
    (0, $5qD1E.STATE).cy.style().selector("node.highlightWalk").style({
        "background-color": (0, $5qD1E.STATE).highlightWalkColor
    });
    const sourceNodes = (0, $5qD1E.STATE).cy.nodes().filter((node)=>node.indegree() === 0);
    const sinkNodes = (0, $5qD1E.STATE).cy.nodes().filter((node)=>node.outdegree() === 0);
    (0, $5qD1E.STATE).walks.length = 0;
    sourceNodes.forEach((sourceNode)=>{
        (0, $2UrZ2.dfs)(sourceNode, [], sinkNodes);
    });
    // Make sure displayWalks is available to the event handlers
    if (typeof window !== "undefined" && typeof window.displayWalks === "undefined" && typeof displayWalks === "function") window.displayWalks = displayWalks;
    // Make sure handleAuroraIdsFileUpload is available to the event handlers
    if (typeof window !== "undefined" && typeof window.handleAuroraIdsFileUpload === "undefined" && typeof handleAuroraIdsFileUpload === "function") window.handleAuroraIdsFileUpload = handleAuroraIdsFileUpload;
}

});
parcelRegister("gDo9R", function(module, exports) {
!function(t, e) {
    module.exports = e();
}(window, function() {
    return function(t) {
        var e = {};
        function r(i) {
            if (e[i]) return e[i].exports;
            var n = e[i] = {
                i: i,
                l: !1,
                exports: {}
            };
            return t[i].call(n.exports, n, n.exports, r), n.l = !0, n.exports;
        }
        return r.m = t, r.c = e, r.d = function(t, e, i) {
            r.o(t, e) || Object.defineProperty(t, e, {
                enumerable: !0,
                get: i
            });
        }, r.r = function(t) {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(t, "__esModule", {
                value: !0
            });
        }, r.t = function(t, e) {
            if (1 & e && (t = r(t)), 8 & e) return t;
            if (4 & e && "object" == typeof t && t && t.__esModule) return t;
            var i = Object.create(null);
            if (r.r(i), Object.defineProperty(i, "default", {
                enumerable: !0,
                value: t
            }), 2 & e && "string" != typeof t) for(var n in t)r.d(i, n, (function(e) {
                return t[e];
            }).bind(null, n));
            return i;
        }, r.n = function(t) {
            var e = t && t.__esModule ? function() {
                return t.default;
            } : function() {
                return t;
            };
            return r.d(e, "a", e), e;
        }, r.o = function(t, e) {
            return Object.prototype.hasOwnProperty.call(t, e);
        }, r.p = "", r(r.s = 0);
    }([
        function(t, e, r) {
            "use strict";
            var i = r(1), n = function(t) {
                t && t("core", "svg", i.svg);
            };
            "undefined" != typeof cytoscape && n(cytoscape), t.exports = n;
        },
        function(t, e, r) {
            "use strict";
            var i = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
                return typeof t;
            } : function(t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
            }, n = r(2), o = {}, s = {};
            s.number = function(t) {
                return null != t && (void 0 === t ? "undefined" : i(t)) === i(1) && !isNaN(t);
            }, o.bufferCanvasImage = function(t, e) {
                var r = e.renderer().usePaths;
                e.renderer().usePaths = function() {
                    return !1;
                }, e.elements().forEach(function(t) {
                    t._private.rscratch.pathCacheKey = null, t._private.rscratch.pathCache = null;
                });
                var i = e.renderer(), o = e.mutableElements().boundingBox(), a = i.findContainerClientCoords(), l = t.full ? Math.ceil(o.w) : a[2], h = t.full ? Math.ceil(o.h) : a[3], c = s.number(t.maxWidth) || s.number(t.maxHeight), p = i.getPixelRatio(), u = 1;
                if (void 0 !== t.scale) l *= t.scale, h *= t.scale, u = t.scale;
                else if (c) {
                    var _ = 1 / 0, d = 1 / 0;
                    s.number(t.maxWidth) && (_ = u * t.maxWidth / l), s.number(t.maxHeight) && (d = u * t.maxHeight / h), l *= u = Math.min(_, d), h *= u;
                }
                c || (l *= p, h *= p, u *= p);
                var f = null, g = f = new n(l, h);
                if (l > 0 && h > 0) {
                    f.clearRect(0, 0, l, h), t.bg && (f.globalCompositeOperation = "destination-over", f.fillStyle = t.bg, f.fillRect(0, 0, l, h)), f.globalCompositeOperation = "source-over";
                    var m = i.getCachedZSortedEles();
                    if (t.full) f.translate(-o.x1 * u, -o.y1 * u), f.scale(u, u), i.drawElements(f, m), f.scale(1 / u, 1 / u), f.translate(o.x1 * u, o.y1 * u);
                    else {
                        var y = e.pan(), v = {
                            x: y.x * u,
                            y: y.y * u
                        };
                        u *= e.zoom(), f.translate(v.x, v.y), f.scale(u, u), i.drawElements(f, m), f.scale(1 / u, 1 / u), f.translate(-v.x, -v.y);
                    }
                }
                return e.renderer().usePaths = r, g;
            }, o.svg = function(t) {
                return o.bufferCanvasImage(t || {}, this).getSerializedSvg();
            }, t.exports = o;
        },
        function(t, e, r) {
            !function() {
                "use strict";
                var e, r, i, n, o;
                function s(t, e) {
                    var r, i = Object.keys(e);
                    for(r = 0; r < i.length; r++)t = t.replace(new RegExp("\\{" + i[r] + "\\}", "gi"), e[i[r]]);
                    return t;
                }
                function a(t) {
                    var e, r, i;
                    if (!t) throw new Error("cannot create a random attribute name for an undefined object");
                    e = "ABCDEFGHIJKLMNOPQRSTUVWXTZabcdefghiklmnopqrstuvwxyz", r = "";
                    do for(r = "", i = 0; i < 12; i++)r += e[Math.floor(Math.random() * e.length)];
                    while (t[r]);
                    return r;
                }
                function l(t) {
                    var e = {
                        alphabetic: "alphabetic",
                        hanging: "hanging",
                        top: "text-before-edge",
                        bottom: "text-after-edge",
                        middle: "central"
                    };
                    return e[t] || e.alphabetic;
                }
                o = function(t, e) {
                    var r, i, n, o = {};
                    for(t = t.split(","), e = e || 10, r = 0; r < t.length; r += 2)i = "&" + t[r + 1] + ";", n = parseInt(t[r], e), o[i] = "&#" + n + ";";
                    return o["\\xa0"] = "&#160;", o;
                }("50,nbsp,51,iexcl,52,cent,53,pound,54,curren,55,yen,56,brvbar,57,sect,58,uml,59,copy,5a,ordf,5b,laquo,5c,not,5d,shy,5e,reg,5f,macr,5g,deg,5h,plusmn,5i,sup2,5j,sup3,5k,acute,5l,micro,5m,para,5n,middot,5o,cedil,5p,sup1,5q,ordm,5r,raquo,5s,frac14,5t,frac12,5u,frac34,5v,iquest,60,Agrave,61,Aacute,62,Acirc,63,Atilde,64,Auml,65,Aring,66,AElig,67,Ccedil,68,Egrave,69,Eacute,6a,Ecirc,6b,Euml,6c,Igrave,6d,Iacute,6e,Icirc,6f,Iuml,6g,ETH,6h,Ntilde,6i,Ograve,6j,Oacute,6k,Ocirc,6l,Otilde,6m,Ouml,6n,times,6o,Oslash,6p,Ugrave,6q,Uacute,6r,Ucirc,6s,Uuml,6t,Yacute,6u,THORN,6v,szlig,70,agrave,71,aacute,72,acirc,73,atilde,74,auml,75,aring,76,aelig,77,ccedil,78,egrave,79,eacute,7a,ecirc,7b,euml,7c,igrave,7d,iacute,7e,icirc,7f,iuml,7g,eth,7h,ntilde,7i,ograve,7j,oacute,7k,ocirc,7l,otilde,7m,ouml,7n,divide,7o,oslash,7p,ugrave,7q,uacute,7r,ucirc,7s,uuml,7t,yacute,7u,thorn,7v,yuml,ci,fnof,sh,Alpha,si,Beta,sj,Gamma,sk,Delta,sl,Epsilon,sm,Zeta,sn,Eta,so,Theta,sp,Iota,sq,Kappa,sr,Lambda,ss,Mu,st,Nu,su,Xi,sv,Omicron,t0,Pi,t1,Rho,t3,Sigma,t4,Tau,t5,Upsilon,t6,Phi,t7,Chi,t8,Psi,t9,Omega,th,alpha,ti,beta,tj,gamma,tk,delta,tl,epsilon,tm,zeta,tn,eta,to,theta,tp,iota,tq,kappa,tr,lambda,ts,mu,tt,nu,tu,xi,tv,omicron,u0,pi,u1,rho,u2,sigmaf,u3,sigma,u4,tau,u5,upsilon,u6,phi,u7,chi,u8,psi,u9,omega,uh,thetasym,ui,upsih,um,piv,812,bull,816,hellip,81i,prime,81j,Prime,81u,oline,824,frasl,88o,weierp,88h,image,88s,real,892,trade,89l,alefsym,8cg,larr,8ch,uarr,8ci,rarr,8cj,darr,8ck,harr,8dl,crarr,8eg,lArr,8eh,uArr,8ei,rArr,8ej,dArr,8ek,hArr,8g0,forall,8g2,part,8g3,exist,8g5,empty,8g7,nabla,8g8,isin,8g9,notin,8gb,ni,8gf,prod,8gh,sum,8gi,minus,8gn,lowast,8gq,radic,8gt,prop,8gu,infin,8h0,ang,8h7,and,8h8,or,8h9,cap,8ha,cup,8hb,int,8hk,there4,8hs,sim,8i5,cong,8i8,asymp,8j0,ne,8j1,equiv,8j4,le,8j5,ge,8k2,sub,8k3,sup,8k4,nsub,8k6,sube,8k7,supe,8kl,oplus,8kn,otimes,8l5,perp,8m5,sdot,8o8,lceil,8o9,rceil,8oa,lfloor,8ob,rfloor,8p9,lang,8pa,rang,9ea,loz,9j0,spades,9j3,clubs,9j5,hearts,9j6,diams,ai,OElig,aj,oelig,b0,Scaron,b1,scaron,bo,Yuml,m6,circ,ms,tilde,802,ensp,803,emsp,809,thinsp,80c,zwnj,80d,zwj,80e,lrm,80f,rlm,80j,ndash,80k,mdash,80o,lsquo,80p,rsquo,80q,sbquo,80s,ldquo,80t,rdquo,80u,bdquo,810,dagger,811,Dagger,81g,permil,81p,lsaquo,81q,rsaquo,85c,euro", 32), e = {
                    strokeStyle: {
                        svgAttr: "stroke",
                        canvas: "#000000",
                        svg: "none",
                        apply: "stroke"
                    },
                    fillStyle: {
                        svgAttr: "fill",
                        canvas: "#000000",
                        svg: null,
                        apply: "fill"
                    },
                    lineCap: {
                        svgAttr: "stroke-linecap",
                        canvas: "butt",
                        svg: "butt",
                        apply: "stroke"
                    },
                    lineJoin: {
                        svgAttr: "stroke-linejoin",
                        canvas: "miter",
                        svg: "miter",
                        apply: "stroke"
                    },
                    miterLimit: {
                        svgAttr: "stroke-miterlimit",
                        canvas: 10,
                        svg: 4,
                        apply: "stroke"
                    },
                    lineWidth: {
                        svgAttr: "stroke-width",
                        canvas: 1,
                        svg: 1,
                        apply: "stroke"
                    },
                    globalAlpha: {
                        svgAttr: "opacity",
                        canvas: 1,
                        svg: 1,
                        apply: "fill stroke"
                    },
                    font: {
                        canvas: "10px sans-serif"
                    },
                    shadowColor: {
                        canvas: "#000000"
                    },
                    shadowOffsetX: {
                        canvas: 0
                    },
                    shadowOffsetY: {
                        canvas: 0
                    },
                    shadowBlur: {
                        canvas: 0
                    },
                    textAlign: {
                        canvas: "start"
                    },
                    textBaseline: {
                        canvas: "alphabetic"
                    },
                    lineDash: {
                        svgAttr: "stroke-dasharray",
                        canvas: [],
                        svg: null,
                        apply: "stroke"
                    }
                }, (i = function(t, e) {
                    this.__root = t, this.__ctx = e;
                }).prototype.addColorStop = function(t, e) {
                    var r, i = this.__ctx.__createElement("stop");
                    i.setAttribute("offset", t), -1 !== e.indexOf("rgba") ? (r = /rgba\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d?\.?\d*)\s*\)/gi.exec(e), i.setAttribute("stop-color", s("rgb({r},{g},{b})", {
                        r: r[1],
                        g: r[2],
                        b: r[3]
                    })), i.setAttribute("stop-opacity", r[4])) : i.setAttribute("stop-color", e), this.__root.appendChild(i);
                }, n = function(t, e) {
                    this.__root = t, this.__ctx = e;
                }, (r = function(t) {
                    var e, i = {
                        width: 500,
                        height: 500,
                        enableMirroring: !1
                    };
                    if (arguments.length > 1 ? ((e = i).width = arguments[0], e.height = arguments[1]) : e = t || i, !(this instanceof r)) return new r(e);
                    this.width = e.width || i.width, this.height = e.height || i.height, this.enableMirroring = void 0 !== e.enableMirroring ? e.enableMirroring : i.enableMirroring, this.canvas = this, this.__document = e.document || document, e.ctx ? this.__ctx = e.ctx : (this.__canvas = this.__document.createElement("canvas"), this.__ctx = this.__canvas.getContext("2d")), this.__setDefaultStyles(), this.__stack = [
                        this.__getStyleState()
                    ], this.__groupStack = [], this.__root = this.__document.createElementNS("http://www.w3.org/2000/svg", "svg"), this.__root.setAttribute("version", 1.1), this.__root.setAttribute("xmlns", "http://www.w3.org/2000/svg"), this.__root.setAttributeNS("http://www.w3.org/2000/xmlns/", "xmlns:xlink", "http://www.w3.org/1999/xlink"), this.__root.setAttribute("width", this.width), this.__root.setAttribute("height", this.height), this.__ids = {}, this.__defs = this.__document.createElementNS("http://www.w3.org/2000/svg", "defs"), this.__root.appendChild(this.__defs), this.__currentElement = this.__document.createElementNS("http://www.w3.org/2000/svg", "g"), this.__root.appendChild(this.__currentElement);
                }).prototype.__createElement = function(t, e, r) {
                    void 0 === e && (e = {});
                    var i, n, o = this.__document.createElementNS("http://www.w3.org/2000/svg", t), s = Object.keys(e);
                    for(r && (o.setAttribute("fill", "none"), o.setAttribute("stroke", "none")), i = 0; i < s.length; i++)n = s[i], o.setAttribute(n, e[n]);
                    return o;
                }, r.prototype.__setDefaultStyles = function() {
                    var t, r, i = Object.keys(e);
                    for(t = 0; t < i.length; t++)this[r = i[t]] = e[r].canvas;
                }, r.prototype.__applyStyleState = function(t) {
                    if (t) {
                        var e, r, i = Object.keys(t);
                        for(e = 0; e < i.length; e++)this[r = i[e]] = t[r];
                    }
                }, r.prototype.__getStyleState = function() {
                    var t, r, i = {}, n = Object.keys(e);
                    for(t = 0; t < n.length; t++)i[r = n[t]] = this[r];
                    return i;
                }, r.prototype.__applyStyleToCurrentElement = function(t) {
                    var r = this.__currentElement;
                    this.__currentElementsToStyle;
                    var o, a, l, h, c, p = Object.keys(e);
                    for(o = 0; o < p.length; o++)if (a = e[p[o]], l = this[p[o]], a.apply) {
                        if (l instanceof n) {
                            if (l.__ctx) for(; l.__ctx.__defs.childNodes.length;)h = l.__ctx.__defs.childNodes[0].getAttribute("id"), this.__ids[h] = h, this.__defs.appendChild(l.__ctx.__defs.childNodes[0]);
                            r.setAttribute(a.apply, s("url(#{id})", {
                                id: l.__root.getAttribute("id")
                            }));
                        } else if (l instanceof i) r.setAttribute(a.apply, s("url(#{id})", {
                            id: l.__root.getAttribute("id")
                        }));
                        else if (-1 !== a.apply.indexOf(t) && a.svg !== l) {
                            if ("stroke" !== a.svgAttr && "fill" !== a.svgAttr || -1 === l.indexOf("rgba")) {
                                var u = a.svgAttr;
                                if ("globalAlpha" === p[o] && (u = t + "-" + a.svgAttr, r.getAttribute(u))) continue;
                                r.setAttribute(u, l);
                            } else {
                                c = /rgba\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d?\.?\d*)\s*\)/gi.exec(l), r.setAttribute(a.svgAttr, s("rgb({r},{g},{b})", {
                                    r: c[1],
                                    g: c[2],
                                    b: c[3]
                                }));
                                var _ = c[4], d = this.globalAlpha;
                                null != d && (_ *= d), r.setAttribute(a.svgAttr + "-opacity", _);
                            }
                        }
                    }
                }, r.prototype.__closestGroupOrSvg = function(t) {
                    return "g" === (t = t || this.__currentElement).nodeName || "svg" === t.nodeName ? t : this.__closestGroupOrSvg(t.parentNode);
                }, r.prototype.getSerializedSvg = function(t) {
                    var e, r, i, n, s, a = (new XMLSerializer).serializeToString(this.__root);
                    if (/xmlns="http:\/\/www\.w3\.org\/2000\/svg".+xmlns="http:\/\/www\.w3\.org\/2000\/svg/gi.test(a) && (a = a.replace('xmlns="http://www.w3.org/2000/svg', 'xmlns:xlink="http://www.w3.org/1999/xlink')), t) for(e = Object.keys(o), r = 0; r < e.length; r++)i = e[r], n = o[i], (s = new RegExp(i, "gi")).test(a) && (a = a.replace(s, n));
                    return a;
                }, r.prototype.getSvg = function() {
                    return this.__root;
                }, r.prototype.save = function() {
                    var t = this.__createElement("g"), e = this.__closestGroupOrSvg();
                    this.__groupStack.push(e), e.appendChild(t), this.__currentElement = t, this.__stack.push(this.__getStyleState());
                }, r.prototype.restore = function() {
                    this.__currentElement = this.__groupStack.pop(), this.__currentElementsToStyle = null, this.__currentElement || (this.__currentElement = this.__root.childNodes[1]);
                    var t = this.__stack.pop();
                    this.__applyStyleState(t);
                }, r.prototype.__addTransform = function(t) {
                    var e = this.__closestGroupOrSvg();
                    if (e.childNodes.length > 0) {
                        "path" === this.__currentElement.nodeName && (this.__currentElementsToStyle || (this.__currentElementsToStyle = {
                            element: e,
                            children: []
                        }), this.__currentElementsToStyle.children.push(this.__currentElement), this.__applyCurrentDefaultPath());
                        var r = this.__createElement("g");
                        e.appendChild(r), this.__currentElement = r;
                    }
                    var i = this.__currentElement.getAttribute("transform");
                    i ? i += " " : i = "", i += t, this.__currentElement.setAttribute("transform", i);
                }, r.prototype.scale = function(t, e) {
                    void 0 === e && (e = t), this.__addTransform(s("scale({x},{y})", {
                        x: t,
                        y: e
                    }));
                }, r.prototype.rotate = function(t) {
                    var e = 180 * t / Math.PI;
                    this.__addTransform(s("rotate({angle},{cx},{cy})", {
                        angle: e,
                        cx: 0,
                        cy: 0
                    }));
                }, r.prototype.translate = function(t, e) {
                    this.__addTransform(s("translate({x},{y})", {
                        x: t,
                        y: e
                    }));
                }, r.prototype.transform = function(t, e, r, i, n, o) {
                    this.__addTransform(s("matrix({a},{b},{c},{d},{e},{f})", {
                        a: t,
                        b: e,
                        c: r,
                        d: i,
                        e: n,
                        f: o
                    }));
                }, r.prototype.beginPath = function() {
                    var t;
                    this.__currentDefaultPath = "", this.__currentPosition = {}, t = this.__createElement("path", {}, !0), this.__closestGroupOrSvg().appendChild(t), this.__currentElement = t;
                }, r.prototype.__applyCurrentDefaultPath = function() {
                    var t = this.__currentElement;
                    "path" === t.nodeName ? t.setAttribute("d", this.__currentDefaultPath) : console.error("Attempted to apply path command to node", t.nodeName);
                }, r.prototype.__addPathCommand = function(t) {
                    this.__currentDefaultPath += " ", this.__currentDefaultPath += t;
                }, r.prototype.moveTo = function(t, e) {
                    "path" !== this.__currentElement.nodeName && this.beginPath(), this.__currentPosition = {
                        x: t,
                        y: e
                    }, this.__addPathCommand(s("M {x} {y}", {
                        x: t,
                        y: e
                    }));
                }, r.prototype.closePath = function() {
                    this.__currentDefaultPath && this.__addPathCommand("Z");
                }, r.prototype.lineTo = function(t, e) {
                    this.__currentPosition = {
                        x: t,
                        y: e
                    }, this.__currentDefaultPath.indexOf("M") > -1 ? this.__addPathCommand(s("L {x} {y}", {
                        x: t,
                        y: e
                    })) : this.__addPathCommand(s("M {x} {y}", {
                        x: t,
                        y: e
                    }));
                }, r.prototype.bezierCurveTo = function(t, e, r, i, n, o) {
                    this.__currentPosition = {
                        x: n,
                        y: o
                    }, this.__addPathCommand(s("C {cp1x} {cp1y} {cp2x} {cp2y} {x} {y}", {
                        cp1x: t,
                        cp1y: e,
                        cp2x: r,
                        cp2y: i,
                        x: n,
                        y: o
                    }));
                }, r.prototype.quadraticCurveTo = function(t, e, r, i) {
                    this.__currentPosition = {
                        x: r,
                        y: i
                    }, this.__addPathCommand(s("Q {cpx} {cpy} {x} {y}", {
                        cpx: t,
                        cpy: e,
                        x: r,
                        y: i
                    }));
                };
                var h = function(t) {
                    var e = Math.sqrt(t[0] * t[0] + t[1] * t[1]);
                    return [
                        t[0] / e,
                        t[1] / e
                    ];
                };
                r.prototype.arcTo = function(t, e, r, i, n) {
                    var o = this.__currentPosition && this.__currentPosition.x, s = this.__currentPosition && this.__currentPosition.y;
                    if (void 0 !== o && void 0 !== s) {
                        if (n < 0) throw new Error("IndexSizeError: The radius provided (" + n + ") is negative.");
                        if (o === t && s === e || t === r && e === i || 0 === n) this.lineTo(t, e);
                        else {
                            var a = h([
                                o - t,
                                s - e
                            ]), l = h([
                                r - t,
                                i - e
                            ]);
                            if (a[0] * l[1] != a[1] * l[0]) {
                                var c = a[0] * l[0] + a[1] * l[1], p = Math.acos(Math.abs(c)), u = h([
                                    a[0] + l[0],
                                    a[1] + l[1]
                                ]), _ = n / Math.sin(p / 2), d = t + _ * u[0], f = e + _ * u[1], g = [
                                    -a[1],
                                    a[0]
                                ], m = [
                                    l[1],
                                    -l[0]
                                ], y = function(t) {
                                    var e = t[0];
                                    return t[1] >= 0 ? Math.acos(e) : -Math.acos(e);
                                }, v = y(g), b = y(m);
                                this.lineTo(d + g[0] * n, f + g[1] * n), this.arc(d, f, n, v, b);
                            } else this.lineTo(t, e);
                        }
                    }
                }, r.prototype.stroke = function() {
                    "path" === this.__currentElement.nodeName && this.__currentElement.setAttribute("paint-order", "fill stroke markers"), this.__applyCurrentDefaultPath(), this.__applyStyleToCurrentElement("stroke");
                }, r.prototype.fill = function() {
                    "path" === this.__currentElement.nodeName && this.__currentElement.setAttribute("paint-order", "stroke fill markers"), this.__applyCurrentDefaultPath(), this.__applyStyleToCurrentElement("fill");
                }, r.prototype.rect = function(t, e, r, i) {
                    "path" !== this.__currentElement.nodeName && this.beginPath(), this.moveTo(t, e), this.lineTo(t + r, e), this.lineTo(t + r, e + i), this.lineTo(t, e + i), this.lineTo(t, e), this.closePath();
                }, r.prototype.fillRect = function(t, e, r, i) {
                    var n;
                    n = this.__createElement("rect", {
                        x: t,
                        y: e,
                        width: r,
                        height: i
                    }, !0), this.__closestGroupOrSvg().appendChild(n), this.__currentElement = n, this.__applyStyleToCurrentElement("fill");
                }, r.prototype.strokeRect = function(t, e, r, i) {
                    var n;
                    n = this.__createElement("rect", {
                        x: t,
                        y: e,
                        width: r,
                        height: i
                    }, !0), this.__closestGroupOrSvg().appendChild(n), this.__currentElement = n, this.__applyStyleToCurrentElement("stroke");
                }, r.prototype.__clearCanvas = function() {
                    for(var t = this.__closestGroupOrSvg().getAttribute("transform"), e = this.__root.childNodes[1], r = e.childNodes, i = r.length - 1; i >= 0; i--)r[i] && e.removeChild(r[i]);
                    this.__currentElement = e, this.__groupStack = [], t && this.__addTransform(t);
                }, r.prototype.clearRect = function(t, e, r, i) {
                    if (0 !== t || 0 !== e || r !== this.width || i !== this.height) {
                        var n, o = this.__closestGroupOrSvg();
                        n = this.__createElement("rect", {
                            x: t,
                            y: e,
                            width: r,
                            height: i,
                            fill: "#FFFFFF"
                        }, !0), o.appendChild(n);
                    } else this.__clearCanvas();
                }, r.prototype.createLinearGradient = function(t, e, r, n) {
                    var o = this.__createElement("linearGradient", {
                        id: a(this.__ids),
                        x1: t + "px",
                        x2: r + "px",
                        y1: e + "px",
                        y2: n + "px",
                        gradientUnits: "userSpaceOnUse"
                    }, !1);
                    return this.__defs.appendChild(o), new i(o, this);
                }, r.prototype.createRadialGradient = function(t, e, r, n, o, s) {
                    var l = this.__createElement("radialGradient", {
                        id: a(this.__ids),
                        cx: n + "px",
                        cy: o + "px",
                        r: s + "px",
                        fx: t + "px",
                        fy: e + "px",
                        gradientUnits: "userSpaceOnUse"
                    }, !1);
                    return this.__defs.appendChild(l), new i(l, this);
                }, r.prototype.__parseFont = function() {
                    var t = /^\s*(?=(?:(?:[-a-z]+\s*){0,2}(italic|oblique))?)(?=(?:(?:[-a-z]+\s*){0,2}(small-caps))?)(?=(?:(?:[-a-z]+\s*){0,2}(bold(?:er)?|lighter|[1-9]00))?)(?:(?:normal|\1|\2|\3)\s*){0,3}((?:xx?-)?(?:small|large)|medium|smaller|larger|[.\d]+(?:\%|in|[cem]m|ex|p[ctx]))(?:\s*\/\s*(normal|[.\d]+(?:\%|in|[cem]m|ex|p[ctx])))?\s*([-,\'\"\sa-z0-9]+?)\s*$/i.exec(this.font), e = {
                        style: t[1] || "normal",
                        size: t[4] || "10px",
                        family: t[6] || "sans-serif",
                        weight: t[3] || "normal",
                        decoration: t[2] || "normal",
                        href: null
                    };
                    return "underline" === this.__fontUnderline && (e.decoration = "underline"), this.__fontHref && (e.href = this.__fontHref), e;
                }, r.prototype.__wrapTextLink = function(t, e) {
                    if (t.href) {
                        var r = this.__createElement("a");
                        return r.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", t.href), r.appendChild(e), r;
                    }
                    return e;
                }, r.prototype.__applyText = function(t, e, r, i) {
                    var n, o, s = this.__parseFont(), a = this.__closestGroupOrSvg(), h = this.__createElement("text", {
                        "font-family": s.family,
                        "font-size": s.size,
                        "font-style": s.style,
                        "font-weight": s.weight,
                        "text-decoration": s.decoration,
                        x: e,
                        y: r,
                        "text-anchor": (n = this.textAlign, o = {
                            left: "start",
                            right: "end",
                            center: "middle",
                            start: "start",
                            end: "end"
                        }, o[n] || o.start),
                        "dominant-baseline": l(this.textBaseline)
                    }, !0);
                    h.appendChild(this.__document.createTextNode(t)), this.__currentElement = h, this.__applyStyleToCurrentElement(i), a.appendChild(this.__wrapTextLink(s, h));
                }, r.prototype.fillText = function(t, e, r) {
                    this.__applyText(t, e, r, "fill");
                }, r.prototype.strokeText = function(t, e, r) {
                    this.__applyText(t, e, r, "stroke");
                }, r.prototype.measureText = function(t) {
                    return this.__ctx.font = this.font, this.__ctx.measureText(t);
                }, r.prototype.arc = function(t, e, r, i, n, o) {
                    if (i !== n) {
                        (i %= 2 * Math.PI) === (n %= 2 * Math.PI) && (n = (n + 2 * Math.PI - .001 * (o ? -1 : 1)) % (2 * Math.PI));
                        var a = t + r * Math.cos(n), l = e + r * Math.sin(n), h = t + r * Math.cos(i), c = e + r * Math.sin(i), p = o ? 0 : 1, u = 0, _ = n - i;
                        _ < 0 && (_ += 2 * Math.PI), u = o ? _ > Math.PI ? 0 : 1 : _ > Math.PI ? 1 : 0, this.lineTo(h, c), this.__addPathCommand(s("A {rx} {ry} {xAxisRotation} {largeArcFlag} {sweepFlag} {endX} {endY}", {
                            rx: r,
                            ry: r,
                            xAxisRotation: 0,
                            largeArcFlag: u,
                            sweepFlag: p,
                            endX: a,
                            endY: l
                        })), this.__currentPosition = {
                            x: a,
                            y: l
                        };
                    }
                }, r.prototype.clip = function() {
                    var t = this.__closestGroupOrSvg(), e = this.__createElement("clipPath"), r = a(this.__ids), i = this.__createElement("g");
                    this.__applyCurrentDefaultPath(), t.removeChild(this.__currentElement), e.setAttribute("id", r), e.appendChild(this.__currentElement), this.__defs.appendChild(e), t.setAttribute("clip-path", s("url(#{id})", {
                        id: r
                    })), t.appendChild(i), this.__currentElement = i;
                }, r.prototype.drawImage = function() {
                    var t, e, i, n, o, s, a, l, h, c, p, u, _, d = Array.prototype.slice.call(arguments), f = d[0], g = 0, m = 0;
                    if (3 === d.length) t = d[1], e = d[2], i = o = f.width, n = s = f.height;
                    else if (5 === d.length) t = d[1], e = d[2], i = d[3], n = d[4], o = f.width, s = f.height;
                    else {
                        if (9 !== d.length) throw new Error("Inavlid number of arguments passed to drawImage: " + arguments.length);
                        g = d[1], m = d[2], o = d[3], s = d[4], t = d[5], e = d[6], i = d[7], n = d[8];
                    }
                    a = this.__closestGroupOrSvg(), this.__currentElement;
                    var y = "translate(" + t + ", " + e + ")";
                    if (f instanceof r) {
                        if ((l = f.getSvg().cloneNode(!0)).childNodes && l.childNodes.length > 1) {
                            for(h = l.childNodes[0]; h.childNodes.length;)_ = h.childNodes[0].getAttribute("id"), this.__ids[_] = _, this.__defs.appendChild(h.childNodes[0]);
                            if (c = l.childNodes[1]) {
                                var v, b = c.getAttribute("transform");
                                v = b ? b + " " + y : y, c.setAttribute("transform", v), a.appendChild(c);
                            }
                        }
                    } else "CANVAS" !== f.nodeName && "IMG" !== f.nodeName || ((p = this.__createElement("image")).setAttribute("width", i), p.setAttribute("height", n), p.setAttribute("opacity", this.globalAlpha), p.setAttribute("preserveAspectRatio", "none"), (u = this.__document.createElement("canvas")).width = i, u.height = n, u.getContext("2d").drawImage(f, g, m, o, s, 0, 0, i, n), f = u, p.setAttribute("transform", y), p.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", "CANVAS" === f.nodeName ? f.toDataURL() : f.getAttribute("src")), a.appendChild(p));
                }, r.prototype.createPattern = function(t, e) {
                    var i, o = this.__document.createElementNS("http://www.w3.org/2000/svg", "pattern"), s = a(this.__ids);
                    return o.setAttribute("id", s), o.setAttribute("width", t.width), o.setAttribute("height", t.height), "CANVAS" === t.nodeName || "IMG" === t.nodeName ? ((i = this.__document.createElementNS("http://www.w3.org/2000/svg", "image")).setAttribute("width", t.width), i.setAttribute("height", t.height), i.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", "CANVAS" === t.nodeName ? t.toDataURL() : t.getAttribute("src")), o.appendChild(i), this.__defs.appendChild(o)) : t instanceof r && (o.appendChild(t.__root.childNodes[1]), this.__defs.appendChild(o)), new n(o, this);
                }, r.prototype.setLineDash = function(t) {
                    t && t.length > 0 ? this.lineDash = t.join(",") : this.lineDash = null;
                }, r.prototype.drawFocusRing = function() {}, r.prototype.createImageData = function() {}, r.prototype.getImageData = function() {}, r.prototype.putImageData = function() {}, r.prototype.globalCompositeOperation = function() {}, r.prototype.setTransform = function() {}, "object" == typeof window && (window.C2S = r), "object" == typeof t.exports && (t.exports = r);
            }();
        }
    ]);
});

});

parcelRegister("aPVQm", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e3b89534f2c3158$export$2e2bcd8739ae039);
// feel free to comment out anything to rollup
// a smaller chroma.js bundle

var $4dsSs = parcelRequire("4dsSs");
parcelRequire("6nCMq");
parcelRequire("25t45");
parcelRequire("aFaUM");
parcelRequire("9F2Ad");
parcelRequire("KQRAX");
parcelRequire("9bpAk");
parcelRequire("7rOiv");
parcelRequire("8m60N");
parcelRequire("j9UwR");
parcelRequire("33sZr");
parcelRequire("2RvX8");
parcelRequire("Se4Sm");
parcelRequire("cBvRm");
parcelRequire("kPcfN");
parcelRequire("jMSjY");
parcelRequire("1ObGX");
parcelRequire("jsxUE");
parcelRequire("gHzE3");
parcelRequire("1QQvo");
parcelRequire("iDRu9");
parcelRequire("cxd0G");
parcelRequire("dnbKS");

var $1CpZi = parcelRequire("1CpZi");

var $h8ENh = parcelRequire("h8ENh");

var $4HYka = parcelRequire("4HYka");

var $b2lDa = parcelRequire("b2lDa");

var $4Dxga = parcelRequire("4Dxga");

var $ciHx9 = parcelRequire("ciHx9");

var $39JHd = parcelRequire("39JHd");

var $dnDjJ = parcelRequire("dnDjJ");

var $iTouk = parcelRequire("iTouk");

var $hEb9E = parcelRequire("hEb9E");

var $6PUrQ = parcelRequire("6PUrQ");

var $f9Ovk = parcelRequire("f9Ovk");

var $5LSz1 = parcelRequire("5LSz1");

var $cio9q = parcelRequire("cio9q");

var $f0u4B = parcelRequire("f0u4B");

var $gYCSE = parcelRequire("gYCSE");

var $iDIGL = parcelRequire("iDIGL");

var $9WhDB = parcelRequire("9WhDB");
parcelRequire("kvDv4");
parcelRequire("9cpWG");
parcelRequire("eioBY");
parcelRequire("8kdxP");
parcelRequire("9Q6Ul");
parcelRequire("jx0kP");
parcelRequire("cHZip");
parcelRequire("fdeu1");
parcelRequire("gdTSI");
parcelRequire("6YXfw");
parcelRequire("f6E2L");
parcelRequire("as1AR");
parcelRequire("lna4G");
parcelRequire("6p5Hh");
parcelRequire("9as51");
Object.assign((0, $4dsSs.default), {
    analyze: $dnDjJ.analyze,
    average: $1CpZi.default,
    bezier: $h8ENh.default,
    blend: $4HYka.default,
    brewer: $iDIGL.default,
    Color: $9WhDB.default,
    colors: $gYCSE.default,
    contrast: $iTouk.default,
    contrastAPCA: $hEb9E.default,
    cubehelix: $b2lDa.default,
    deltaE: $6PUrQ.default,
    distance: $f9Ovk.default,
    input: $cio9q.default,
    interpolate: (0, $4Dxga.default),
    limits: $dnDjJ.limits,
    mix: $4Dxga.default,
    random: $ciHx9.default,
    scale: $39JHd.default,
    scales: $f0u4B.default,
    valid: $5LSz1.default
});
var $7e3b89534f2c3158$export$2e2bcd8739ae039 = (0, $4dsSs.default);

});
parcelRegister("4dsSs", function(module, exports) {

$parcel$export(module.exports, "default", () => $311ec6bd16e186d1$export$2e2bcd8739ae039);

var $9WhDB = parcelRequire("9WhDB");

var $anMwX = parcelRequire("anMwX");
const $311ec6bd16e186d1$var$chroma = (...args)=>{
    return new (0, $9WhDB.default)(...args);
};
$311ec6bd16e186d1$var$chroma.version = (0, $anMwX.version);
var $311ec6bd16e186d1$export$2e2bcd8739ae039 = $311ec6bd16e186d1$var$chroma;

});
parcelRegister("9WhDB", function(module, exports) {

$parcel$export(module.exports, "default", () => $73c73657cae9064a$export$2e2bcd8739ae039);
parcelRequire("f8COF");
var $iMJbA = parcelRequire("iMJbA");
var $io9Wg = parcelRequire("io9Wg");
var $rAKRV = parcelRequire("rAKRV");

var $cio9q = parcelRequire("cio9q");
class $73c73657cae9064a$var$Color {
    constructor(...args){
        const me = this;
        if ((0, $rAKRV.default)(args[0]) === 'object' && args[0].constructor && args[0].constructor === this.constructor) // the argument is already a Color instance
        return args[0];
        // last argument could be the mode
        let mode = (0, $io9Wg.default)(args);
        let autodetect = false;
        if (!mode) {
            autodetect = true;
            if (!(0, $cio9q.default).sorted) {
                (0, $cio9q.default).autodetect = (0, $cio9q.default).autodetect.sort((a, b)=>b.p - a.p);
                (0, $cio9q.default).sorted = true;
            }
            // auto-detect format
            for (let chk of (0, $cio9q.default).autodetect){
                mode = chk.test(...args);
                if (mode) break;
            }
        }
        if ((0, $cio9q.default).format[mode]) {
            const rgb = (0, $cio9q.default).format[mode].apply(null, autodetect ? args : args.slice(0, -1));
            me._rgb = (0, $iMJbA.default)(rgb);
        } else throw new Error('unknown format: ' + args);
        // add alpha channel
        if (me._rgb.length === 3) me._rgb.push(1);
    }
    toString() {
        if ((0, $rAKRV.default)(this.hex) == 'function') return this.hex();
        return `[${this._rgb.join(',')}]`;
    }
}
var $73c73657cae9064a$export$2e2bcd8739ae039 = $73c73657cae9064a$var$Color;

});
parcelRegister("f8COF", function(module, exports) {

$parcel$export(module.exports, "min", () => $b055b672fea31fe3$export$96ec731ed4dcb222);
$parcel$export(module.exports, "max", () => $b055b672fea31fe3$export$8960430cfd85939f);
$parcel$export(module.exports, "rnd2", () => $b055b672fea31fe3$export$c6d486233e29f7d1);
$parcel$export(module.exports, "rnd3", () => $b055b672fea31fe3$export$6ed426801b9660b8);
$parcel$export(module.exports, "TWOPI", () => $b055b672fea31fe3$export$af54f71c879f5ba9);
$parcel$export(module.exports, "PITHIRD", () => $b055b672fea31fe3$export$e734282486210baf);
$parcel$export(module.exports, "DEG2RAD", () => $b055b672fea31fe3$export$460c4029b1a54a2e);
$parcel$export(module.exports, "RAD2DEG", () => $b055b672fea31fe3$export$914076c8150813e5);
$parcel$export(module.exports, "reverse3", () => $b055b672fea31fe3$export$d0e1128e52417073);
$parcel$export(module.exports, "clip_rgb", () => (parcelRequire("iMJbA")).default);
$parcel$export(module.exports, "limit", () => (parcelRequire("eeze8")).default);
$parcel$export(module.exports, "type", () => (parcelRequire("rAKRV")).default);
$parcel$export(module.exports, "unpack", () => (parcelRequire("6IMpB")).default);
$parcel$export(module.exports, "last", () => (parcelRequire("io9Wg")).default);

var $iMJbA = parcelRequire("iMJbA");

var $eeze8 = parcelRequire("eeze8");

var $rAKRV = parcelRequire("rAKRV");

var $6IMpB = parcelRequire("6IMpB");

var $io9Wg = parcelRequire("io9Wg");
const { PI: $b055b672fea31fe3$export$6b5c1ceb16d01dc3, min: $b055b672fea31fe3$export$96ec731ed4dcb222, max: $b055b672fea31fe3$export$8960430cfd85939f } = Math;
const $b055b672fea31fe3$export$c6d486233e29f7d1 = (a)=>Math.round(a * 100) / 100;
const $b055b672fea31fe3$export$6ed426801b9660b8 = (a)=>Math.round(a * 100) / 100;
const $b055b672fea31fe3$export$af54f71c879f5ba9 = $b055b672fea31fe3$export$6b5c1ceb16d01dc3 * 2;
const $b055b672fea31fe3$export$e734282486210baf = $b055b672fea31fe3$export$6b5c1ceb16d01dc3 / 3;
const $b055b672fea31fe3$export$460c4029b1a54a2e = $b055b672fea31fe3$export$6b5c1ceb16d01dc3 / 180;
const $b055b672fea31fe3$export$914076c8150813e5 = 180 / $b055b672fea31fe3$export$6b5c1ceb16d01dc3;
/**
 * Reverse the first three elements of an array
 *
 * @param {any[]} arr
 * @returns {any[]}
 */ function $b055b672fea31fe3$export$d0e1128e52417073(arr) {
    return [
        ...arr.slice(0, 3).reverse(),
        ...arr.slice(3)
    ];
}

});
parcelRegister("iMJbA", function(module, exports) {

$parcel$export(module.exports, "default", () => $dacfc2a564661593$export$2e2bcd8739ae039);

var $eeze8 = parcelRequire("eeze8");
var $dacfc2a564661593$export$2e2bcd8739ae039 = (rgb)=>{
    rgb._clipped = false;
    rgb._unclipped = rgb.slice(0);
    for(let i = 0; i <= 3; i++){
        if (i < 3) {
            if (rgb[i] < 0 || rgb[i] > 255) rgb._clipped = true;
            rgb[i] = (0, $eeze8.default)(rgb[i], 0, 255);
        } else if (i === 3) rgb[i] = (0, $eeze8.default)(rgb[i], 0, 1);
    }
    return rgb;
};

});
parcelRegister("eeze8", function(module, exports) {

$parcel$export(module.exports, "default", () => $a5cdb2d1e654e868$export$2e2bcd8739ae039);
const { min: $a5cdb2d1e654e868$var$min, max: $a5cdb2d1e654e868$var$max } = Math;
var $a5cdb2d1e654e868$export$2e2bcd8739ae039 = (x, low = 0, high = 1)=>{
    return $a5cdb2d1e654e868$var$min($a5cdb2d1e654e868$var$max(low, x), high);
};

});


parcelRegister("rAKRV", function(module, exports) {

$parcel$export(module.exports, "default", () => $052f087f906e983c$export$2e2bcd8739ae039);
// ported from jQuery's $.type
const $052f087f906e983c$var$classToType = {};
for (let name of [
    'Boolean',
    'Number',
    'String',
    'Function',
    'Array',
    'Date',
    'RegExp',
    'Undefined',
    'Null'
])$052f087f906e983c$var$classToType[`[object ${name}]`] = name.toLowerCase();
function $052f087f906e983c$export$2e2bcd8739ae039(obj) {
    return $052f087f906e983c$var$classToType[Object.prototype.toString.call(obj)] || 'object';
}

});

parcelRegister("6IMpB", function(module, exports) {

$parcel$export(module.exports, "default", () => $4e4c67bc5c6fc98d$export$2e2bcd8739ae039);

var $rAKRV = parcelRequire("rAKRV");
var $4e4c67bc5c6fc98d$export$2e2bcd8739ae039 = (args, keyOrder = null)=>{
    // if called with more than 3 arguments, we return the arguments
    if (args.length >= 3) return Array.prototype.slice.call(args);
    // with less than 3 args we check if first arg is object
    // and use the keyOrder string to extract and sort properties
    if ((0, $rAKRV.default)(args[0]) == 'object' && keyOrder) return keyOrder.split('').filter((k)=>args[0][k] !== undefined).map((k)=>args[0][k]);
    // otherwise we just return the first argument
    // (which we suppose is an array of args)
    return args[0].slice(0);
};

});

parcelRegister("io9Wg", function(module, exports) {

$parcel$export(module.exports, "default", () => $d6322d7f429dc557$export$2e2bcd8739ae039);

var $rAKRV = parcelRequire("rAKRV");
var $d6322d7f429dc557$export$2e2bcd8739ae039 = (args)=>{
    if (args.length < 2) return null;
    const l = args.length - 1;
    if ((0, $rAKRV.default)(args[l]) == 'string') return args[l].toLowerCase();
    return null;
};

});


parcelRegister("cio9q", function(module, exports) {

$parcel$export(module.exports, "default", () => $8f39e66366edca09$export$2e2bcd8739ae039);
var $8f39e66366edca09$export$2e2bcd8739ae039 = {
    format: {},
    autodetect: []
};

});


parcelRegister("anMwX", function(module, exports) {

$parcel$export(module.exports, "version", () => $78f1b280cc33258d$export$83d89fbfd8236492);
// this gets updated automatically
const $78f1b280cc33258d$export$83d89fbfd8236492 = '3.1.2';

});


parcelRegister("6nCMq", function(module, exports) {

var $9WhDB = parcelRequire("9WhDB");

var $cio9q = parcelRequire("cio9q");
parcelRequire("f8COF");
var $rAKRV = parcelRequire("rAKRV");

var $gYCSE = parcelRequire("gYCSE");

var $QfAJ3 = parcelRequire("QfAJ3");

var $eOU0G = parcelRequire("eOU0G");
(0, $9WhDB.default).prototype.name = function() {
    const hex = (0, $eOU0G.default)(this._rgb, 'rgb');
    for (let n of Object.keys((0, $gYCSE.default))){
        if ((0, $gYCSE.default)[n] === hex) return n.toLowerCase();
    }
    return hex;
};
(0, $cio9q.default).format.named = (name)=>{
    name = name.toLowerCase();
    if ((0, $gYCSE.default)[name]) return (0, $QfAJ3.default)((0, $gYCSE.default)[name]);
    throw new Error('unknown color name: ' + name);
};
(0, $cio9q.default).autodetect.push({
    p: 5,
    test: (h, ...rest)=>{
        if (!rest.length && (0, $rAKRV.default)(h) === 'string' && (0, $gYCSE.default)[h.toLowerCase()]) return 'named';
    }
});

});
parcelRegister("gYCSE", function(module, exports) {

$parcel$export(module.exports, "default", () => $c5c068cfa2d42134$export$2e2bcd8739ae039);
/**
	X11 color names

	http://www.w3.org/TR/css3-color/#svg-color
*/ const $c5c068cfa2d42134$var$w3cx11 = {
    aliceblue: '#f0f8ff',
    antiquewhite: '#faebd7',
    aqua: '#00ffff',
    aquamarine: '#7fffd4',
    azure: '#f0ffff',
    beige: '#f5f5dc',
    bisque: '#ffe4c4',
    black: '#000000',
    blanchedalmond: '#ffebcd',
    blue: '#0000ff',
    blueviolet: '#8a2be2',
    brown: '#a52a2a',
    burlywood: '#deb887',
    cadetblue: '#5f9ea0',
    chartreuse: '#7fff00',
    chocolate: '#d2691e',
    coral: '#ff7f50',
    cornflowerblue: '#6495ed',
    cornsilk: '#fff8dc',
    crimson: '#dc143c',
    cyan: '#00ffff',
    darkblue: '#00008b',
    darkcyan: '#008b8b',
    darkgoldenrod: '#b8860b',
    darkgray: '#a9a9a9',
    darkgreen: '#006400',
    darkgrey: '#a9a9a9',
    darkkhaki: '#bdb76b',
    darkmagenta: '#8b008b',
    darkolivegreen: '#556b2f',
    darkorange: '#ff8c00',
    darkorchid: '#9932cc',
    darkred: '#8b0000',
    darksalmon: '#e9967a',
    darkseagreen: '#8fbc8f',
    darkslateblue: '#483d8b',
    darkslategray: '#2f4f4f',
    darkslategrey: '#2f4f4f',
    darkturquoise: '#00ced1',
    darkviolet: '#9400d3',
    deeppink: '#ff1493',
    deepskyblue: '#00bfff',
    dimgray: '#696969',
    dimgrey: '#696969',
    dodgerblue: '#1e90ff',
    firebrick: '#b22222',
    floralwhite: '#fffaf0',
    forestgreen: '#228b22',
    fuchsia: '#ff00ff',
    gainsboro: '#dcdcdc',
    ghostwhite: '#f8f8ff',
    gold: '#ffd700',
    goldenrod: '#daa520',
    gray: '#808080',
    green: '#008000',
    greenyellow: '#adff2f',
    grey: '#808080',
    honeydew: '#f0fff0',
    hotpink: '#ff69b4',
    indianred: '#cd5c5c',
    indigo: '#4b0082',
    ivory: '#fffff0',
    khaki: '#f0e68c',
    laserlemon: '#ffff54',
    lavender: '#e6e6fa',
    lavenderblush: '#fff0f5',
    lawngreen: '#7cfc00',
    lemonchiffon: '#fffacd',
    lightblue: '#add8e6',
    lightcoral: '#f08080',
    lightcyan: '#e0ffff',
    lightgoldenrod: '#fafad2',
    lightgoldenrodyellow: '#fafad2',
    lightgray: '#d3d3d3',
    lightgreen: '#90ee90',
    lightgrey: '#d3d3d3',
    lightpink: '#ffb6c1',
    lightsalmon: '#ffa07a',
    lightseagreen: '#20b2aa',
    lightskyblue: '#87cefa',
    lightslategray: '#778899',
    lightslategrey: '#778899',
    lightsteelblue: '#b0c4de',
    lightyellow: '#ffffe0',
    lime: '#00ff00',
    limegreen: '#32cd32',
    linen: '#faf0e6',
    magenta: '#ff00ff',
    maroon: '#800000',
    maroon2: '#7f0000',
    maroon3: '#b03060',
    mediumaquamarine: '#66cdaa',
    mediumblue: '#0000cd',
    mediumorchid: '#ba55d3',
    mediumpurple: '#9370db',
    mediumseagreen: '#3cb371',
    mediumslateblue: '#7b68ee',
    mediumspringgreen: '#00fa9a',
    mediumturquoise: '#48d1cc',
    mediumvioletred: '#c71585',
    midnightblue: '#191970',
    mintcream: '#f5fffa',
    mistyrose: '#ffe4e1',
    moccasin: '#ffe4b5',
    navajowhite: '#ffdead',
    navy: '#000080',
    oldlace: '#fdf5e6',
    olive: '#808000',
    olivedrab: '#6b8e23',
    orange: '#ffa500',
    orangered: '#ff4500',
    orchid: '#da70d6',
    palegoldenrod: '#eee8aa',
    palegreen: '#98fb98',
    paleturquoise: '#afeeee',
    palevioletred: '#db7093',
    papayawhip: '#ffefd5',
    peachpuff: '#ffdab9',
    peru: '#cd853f',
    pink: '#ffc0cb',
    plum: '#dda0dd',
    powderblue: '#b0e0e6',
    purple: '#800080',
    purple2: '#7f007f',
    purple3: '#a020f0',
    rebeccapurple: '#663399',
    red: '#ff0000',
    rosybrown: '#bc8f8f',
    royalblue: '#4169e1',
    saddlebrown: '#8b4513',
    salmon: '#fa8072',
    sandybrown: '#f4a460',
    seagreen: '#2e8b57',
    seashell: '#fff5ee',
    sienna: '#a0522d',
    silver: '#c0c0c0',
    skyblue: '#87ceeb',
    slateblue: '#6a5acd',
    slategray: '#708090',
    slategrey: '#708090',
    snow: '#fffafa',
    springgreen: '#00ff7f',
    steelblue: '#4682b4',
    tan: '#d2b48c',
    teal: '#008080',
    thistle: '#d8bfd8',
    tomato: '#ff6347',
    turquoise: '#40e0d0',
    violet: '#ee82ee',
    wheat: '#f5deb3',
    white: '#ffffff',
    whitesmoke: '#f5f5f5',
    yellow: '#ffff00',
    yellowgreen: '#9acd32'
};
var $c5c068cfa2d42134$export$2e2bcd8739ae039 = $c5c068cfa2d42134$var$w3cx11;

});

parcelRegister("QfAJ3", function(module, exports) {

$parcel$export(module.exports, "default", () => $09d0f38f74bc928e$export$2e2bcd8739ae039);
const $09d0f38f74bc928e$var$RE_HEX = /^#?([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/;
const $09d0f38f74bc928e$var$RE_HEXA = /^#?([A-Fa-f0-9]{8}|[A-Fa-f0-9]{4})$/;
const $09d0f38f74bc928e$var$hex2rgb = (hex)=>{
    if (hex.match($09d0f38f74bc928e$var$RE_HEX)) {
        // remove optional leading #
        if (hex.length === 4 || hex.length === 7) hex = hex.substr(1);
        // expand short-notation to full six-digit
        if (hex.length === 3) {
            hex = hex.split('');
            hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
        }
        const u = parseInt(hex, 16);
        const r = u >> 16;
        const g = u >> 8 & 0xff;
        const b = u & 0xff;
        return [
            r,
            g,
            b,
            1
        ];
    }
    // match rgba hex format, eg #FF000077
    if (hex.match($09d0f38f74bc928e$var$RE_HEXA)) {
        if (hex.length === 5 || hex.length === 9) // remove optional leading #
        hex = hex.substr(1);
        // expand short-notation to full eight-digit
        if (hex.length === 4) {
            hex = hex.split('');
            hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2] + hex[3] + hex[3];
        }
        const u = parseInt(hex, 16);
        const r = u >> 24 & 0xff;
        const g = u >> 16 & 0xff;
        const b = u >> 8 & 0xff;
        const a = Math.round((u & 0xff) / 0xff * 100) / 100;
        return [
            r,
            g,
            b,
            a
        ];
    }
    // we used to check for css colors here
    // if _input.css? and rgb = _input.css hex
    //     return rgb
    throw new Error(`unknown hex color: ${hex}`);
};
var $09d0f38f74bc928e$export$2e2bcd8739ae039 = $09d0f38f74bc928e$var$hex2rgb;

});

parcelRegister("eOU0G", function(module, exports) {

$parcel$export(module.exports, "default", () => $aca12e9f2920fd69$export$2e2bcd8739ae039);
parcelRequire("f8COF");
var $io9Wg = parcelRequire("io9Wg");
var $6IMpB = parcelRequire("6IMpB");
const { round: $aca12e9f2920fd69$var$round } = Math;
const $aca12e9f2920fd69$var$rgb2hex = (...args)=>{
    let [r, g, b, a] = (0, $6IMpB.default)(args, 'rgba');
    let mode = (0, $io9Wg.default)(args) || 'auto';
    if (a === undefined) a = 1;
    if (mode === 'auto') mode = a < 1 ? 'rgba' : 'rgb';
    r = $aca12e9f2920fd69$var$round(r);
    g = $aca12e9f2920fd69$var$round(g);
    b = $aca12e9f2920fd69$var$round(b);
    const u = r << 16 | g << 8 | b;
    let str = '000000' + u.toString(16); //#.toUpperCase();
    str = str.substr(str.length - 6);
    let hxa = '0' + $aca12e9f2920fd69$var$round(a * 255).toString(16);
    hxa = hxa.substr(hxa.length - 2);
    switch(mode.toLowerCase()){
        case 'rgba':
            return `#${str}${hxa}`;
        case 'argb':
            return `#${hxa}${str}`;
        default:
            return `#${str}`;
    }
};
var $aca12e9f2920fd69$export$2e2bcd8739ae039 = $aca12e9f2920fd69$var$rgb2hex;

});


parcelRegister("25t45", function(module, exports) {

var $9WhDB = parcelRequire("9WhDB");
parcelRequire("f8COF");
var $rAKRV = parcelRequire("rAKRV");
(0, $9WhDB.default).prototype.alpha = function(a, mutate = false) {
    if (a !== undefined && (0, $rAKRV.default)(a) === 'number') {
        if (mutate) {
            this._rgb[3] = a;
            return this;
        }
        return new (0, $9WhDB.default)([
            this._rgb[0],
            this._rgb[1],
            this._rgb[2],
            a
        ], 'rgb');
    }
    return this._rgb[3];
};

});

parcelRegister("aFaUM", function(module, exports) {

var $9WhDB = parcelRequire("9WhDB");
(0, $9WhDB.default).prototype.clipped = function() {
    return this._rgb._clipped || false;
};

});

parcelRegister("9F2Ad", function(module, exports) {
parcelRequire("gdTSI");

var $9WhDB = parcelRequire("9WhDB");

var $jJM5U = parcelRequire("jJM5U");
(0, $9WhDB.default).prototype.darken = function(amount = 1) {
    const me = this;
    const lab = me.lab();
    lab[0] -= (0, $jJM5U.default).Kn * amount;
    return new (0, $9WhDB.default)(lab, 'lab').alpha(me.alpha(), true);
};
(0, $9WhDB.default).prototype.brighten = function(amount = 1) {
    return this.darken(-amount);
};
(0, $9WhDB.default).prototype.darker = (0, $9WhDB.default).prototype.darken;
(0, $9WhDB.default).prototype.brighter = (0, $9WhDB.default).prototype.brighten;

});
parcelRegister("gdTSI", function(module, exports) {
parcelRequire("f8COF");
var $rAKRV = parcelRequire("rAKRV");
var $6IMpB = parcelRequire("6IMpB");

var $4dsSs = parcelRequire("4dsSs");

var $9WhDB = parcelRequire("9WhDB");

var $cio9q = parcelRequire("cio9q");

var $1e9qI = parcelRequire("1e9qI");

var $a62iy = parcelRequire("a62iy");

var $jJM5U = parcelRequire("jJM5U");
(0, $9WhDB.default).prototype.lab = function() {
    return (0, $a62iy.default)(this._rgb);
};
const $bcf9351f4c766f5d$export$c83fb8f9027a6338 = (...args)=>new (0, $9WhDB.default)(...args, 'lab');
Object.assign((0, $4dsSs.default), {
    lab: $bcf9351f4c766f5d$export$c83fb8f9027a6338,
    getLabWhitePoint: $jJM5U.getLabWhitePoint,
    setLabWhitePoint: $jJM5U.setLabWhitePoint
});
(0, $cio9q.default).format.lab = (0, $1e9qI.default);
(0, $cio9q.default).autodetect.push({
    p: 2,
    test: (...args)=>{
        args = (0, $6IMpB.default)(args, 'lab');
        if ((0, $rAKRV.default)(args) === 'array' && args.length === 3) return 'lab';
    }
});

});
parcelRegister("1e9qI", function(module, exports) {

$parcel$export(module.exports, "xyz2rgb", () => $0e4e69d2086da257$export$22cbacf088b0f5c6);
$parcel$export(module.exports, "default", () => $0e4e69d2086da257$export$2e2bcd8739ae039);

var $jJM5U = parcelRequire("jJM5U");
parcelRequire("f8COF");
var $6IMpB = parcelRequire("6IMpB");
/*
 * L* [0..100]
 * a [-100..100]
 * b [-100..100]
 */ const $0e4e69d2086da257$var$lab2rgb = (...args)=>{
    args = (0, $6IMpB.default)(args, 'lab');
    const [L, a, b] = args;
    const [x, y, z] = $0e4e69d2086da257$var$lab2xyz(L, a, b);
    const [r, g, b_] = $0e4e69d2086da257$export$22cbacf088b0f5c6(x, y, z);
    return [
        r,
        g,
        b_,
        args.length > 3 ? args[3] : 1
    ];
};
const $0e4e69d2086da257$var$lab2xyz = (L, a, b)=>{
    const { kE: kE, kK: kK, kKE: kKE, Xn: Xn, Yn: Yn, Zn: Zn } = (0, $jJM5U.default);
    const fy = (L + 16.0) / 116.0;
    const fx = 0.002 * a + fy;
    const fz = fy - 0.005 * b;
    const fx3 = fx * fx * fx;
    const fz3 = fz * fz * fz;
    const xr = fx3 > kE ? fx3 : (116.0 * fx - 16.0) / kK;
    const yr = L > kKE ? Math.pow((L + 16.0) / 116.0, 3.0) : L / kK;
    const zr = fz3 > kE ? fz3 : (116.0 * fz - 16.0) / kK;
    const x = xr * Xn;
    const y = yr * Yn;
    const z = zr * Zn;
    return [
        x,
        y,
        z
    ];
};
const $0e4e69d2086da257$var$compand = (linear)=>{
    /* sRGB */ const sign = Math.sign(linear);
    linear = Math.abs(linear);
    return (linear <= 0.0031308 ? linear * 12.92 : 1.055 * Math.pow(linear, 1.0 / 2.4) - 0.055) * sign;
};
const $0e4e69d2086da257$export$22cbacf088b0f5c6 = (x, y, z)=>{
    const { MtxAdaptMa: MtxAdaptMa, MtxAdaptMaI: MtxAdaptMaI, MtxXYZ2RGB: MtxXYZ2RGB, RefWhiteRGB: RefWhiteRGB, Xn: Xn, Yn: Yn, Zn: Zn } = (0, $jJM5U.default);
    const As = Xn * MtxAdaptMa.m00 + Yn * MtxAdaptMa.m10 + Zn * MtxAdaptMa.m20;
    const Bs = Xn * MtxAdaptMa.m01 + Yn * MtxAdaptMa.m11 + Zn * MtxAdaptMa.m21;
    const Cs = Xn * MtxAdaptMa.m02 + Yn * MtxAdaptMa.m12 + Zn * MtxAdaptMa.m22;
    const Ad = RefWhiteRGB.X * MtxAdaptMa.m00 + RefWhiteRGB.Y * MtxAdaptMa.m10 + RefWhiteRGB.Z * MtxAdaptMa.m20;
    const Bd = RefWhiteRGB.X * MtxAdaptMa.m01 + RefWhiteRGB.Y * MtxAdaptMa.m11 + RefWhiteRGB.Z * MtxAdaptMa.m21;
    const Cd = RefWhiteRGB.X * MtxAdaptMa.m02 + RefWhiteRGB.Y * MtxAdaptMa.m12 + RefWhiteRGB.Z * MtxAdaptMa.m22;
    const X1 = (x * MtxAdaptMa.m00 + y * MtxAdaptMa.m10 + z * MtxAdaptMa.m20) * (Ad / As);
    const Y1 = (x * MtxAdaptMa.m01 + y * MtxAdaptMa.m11 + z * MtxAdaptMa.m21) * (Bd / Bs);
    const Z1 = (x * MtxAdaptMa.m02 + y * MtxAdaptMa.m12 + z * MtxAdaptMa.m22) * (Cd / Cs);
    const X2 = X1 * MtxAdaptMaI.m00 + Y1 * MtxAdaptMaI.m10 + Z1 * MtxAdaptMaI.m20;
    const Y2 = X1 * MtxAdaptMaI.m01 + Y1 * MtxAdaptMaI.m11 + Z1 * MtxAdaptMaI.m21;
    const Z2 = X1 * MtxAdaptMaI.m02 + Y1 * MtxAdaptMaI.m12 + Z1 * MtxAdaptMaI.m22;
    const r = $0e4e69d2086da257$var$compand(X2 * MtxXYZ2RGB.m00 + Y2 * MtxXYZ2RGB.m10 + Z2 * MtxXYZ2RGB.m20);
    const g = $0e4e69d2086da257$var$compand(X2 * MtxXYZ2RGB.m01 + Y2 * MtxXYZ2RGB.m11 + Z2 * MtxXYZ2RGB.m21);
    const b = $0e4e69d2086da257$var$compand(X2 * MtxXYZ2RGB.m02 + Y2 * MtxXYZ2RGB.m12 + Z2 * MtxXYZ2RGB.m22);
    return [
        r * 255,
        g * 255,
        b * 255
    ];
};
var $0e4e69d2086da257$export$2e2bcd8739ae039 = $0e4e69d2086da257$var$lab2rgb;

});
parcelRegister("jJM5U", function(module, exports) {

$parcel$export(module.exports, "default", () => $e5e786d1c89b5967$export$2e2bcd8739ae039);
$parcel$export(module.exports, "setLabWhitePoint", () => $e5e786d1c89b5967$export$23f27f4cae67c045);
$parcel$export(module.exports, "getLabWhitePoint", () => $e5e786d1c89b5967$export$922c3afbcbc31cb3);
const $e5e786d1c89b5967$var$labConstants = {
    // Corresponds roughly to RGB brighter/darker
    Kn: 18,
    // D65 standard referent
    labWhitePoint: 'd65',
    Xn: 0.95047,
    Yn: 1,
    Zn: 1.08883,
    t0: 0.137931034,
    t1: 0.206896552,
    t2: 0.12841855,
    t3: 0.008856452,
    kE: 216.0 / 24389.0,
    kKE: 8.0,
    kK: 24389.0 / 27.0,
    RefWhiteRGB: {
        // sRGB
        X: 0.95047,
        Y: 1,
        Z: 1.08883
    },
    MtxRGB2XYZ: {
        m00: 0.4124564390896922,
        m01: 0.21267285140562253,
        m02: 0.0193338955823293,
        m10: 0.357576077643909,
        m11: 0.715152155287818,
        m12: 0.11919202588130297,
        m20: 0.18043748326639894,
        m21: 0.07217499330655958,
        m22: 0.9503040785363679
    },
    MtxXYZ2RGB: {
        m00: 3.2404541621141045,
        m01: -0.9692660305051868,
        m02: 0.055643430959114726,
        m10: -1.5371385127977166,
        m11: 1.8760108454466942,
        m12: -0.2040259135167538,
        m20: -0.498531409556016,
        m21: 0.041556017530349834,
        m22: 1.0572251882231791
    },
    // used in rgb2xyz
    As: 0.9414285350000001,
    Bs: 1.040417467,
    Cs: 1.089532651,
    MtxAdaptMa: {
        m00: 0.8951,
        m01: -0.7502,
        m02: 0.0389,
        m10: 0.2664,
        m11: 1.7135,
        m12: -0.0685,
        m20: -0.1614,
        m21: 0.0367,
        m22: 1.0296
    },
    MtxAdaptMaI: {
        m00: 0.9869929054667123,
        m01: 0.43230526972339456,
        m02: -0.008528664575177328,
        m10: -0.14705425642099013,
        m11: 0.5183602715367776,
        m12: 0.04004282165408487,
        m20: 0.15996265166373125,
        m21: 0.0492912282128556,
        m22: 0.9684866957875502
    }
};
var $e5e786d1c89b5967$export$2e2bcd8739ae039 = $e5e786d1c89b5967$var$labConstants;
// taken from https://de.mathworks.com/help/images/ref/whitepoint.html
const $e5e786d1c89b5967$var$ILLUMINANTS = new Map([
    // ASTM E308-01
    [
        'a',
        [
            1.0985,
            0.35585
        ]
    ],
    // Wyszecki & Stiles, p. 769
    [
        'b',
        [
            1.0985,
            0.35585
        ]
    ],
    // C ASTM E308-01
    [
        'c',
        [
            0.98074,
            1.18232
        ]
    ],
    // D50 (ASTM E308-01)
    [
        'd50',
        [
            0.96422,
            0.82521
        ]
    ],
    // D55 (ASTM E308-01)
    [
        'd55',
        [
            0.95682,
            0.92149
        ]
    ],
    // D65 (ASTM E308-01)
    [
        'd65',
        [
            0.95047,
            1.08883
        ]
    ],
    // E (ASTM E308-01)
    [
        'e',
        [
            1,
            1,
            1
        ]
    ],
    // F2 (ASTM E308-01)
    [
        'f2',
        [
            0.99186,
            0.67393
        ]
    ],
    // F7 (ASTM E308-01)
    [
        'f7',
        [
            0.95041,
            1.08747
        ]
    ],
    // F11 (ASTM E308-01)
    [
        'f11',
        [
            1.00962,
            0.6435
        ]
    ],
    [
        'icc',
        [
            0.96422,
            0.82521
        ]
    ]
]);
function $e5e786d1c89b5967$export$23f27f4cae67c045(name) {
    const ill = $e5e786d1c89b5967$var$ILLUMINANTS.get(String(name).toLowerCase());
    if (!ill) throw new Error('unknown Lab illuminant ' + name);
    $e5e786d1c89b5967$var$labConstants.labWhitePoint = name;
    $e5e786d1c89b5967$var$labConstants.Xn = ill[0];
    $e5e786d1c89b5967$var$labConstants.Zn = ill[1];
}
function $e5e786d1c89b5967$export$922c3afbcbc31cb3() {
    return $e5e786d1c89b5967$var$labConstants.labWhitePoint;
}

});


parcelRegister("a62iy", function(module, exports) {

$parcel$export(module.exports, "rgb2xyz", () => $759c3f48fe1d971b$export$fca6d690f89f5907);
$parcel$export(module.exports, "default", () => $759c3f48fe1d971b$export$2e2bcd8739ae039);

var $jJM5U = parcelRequire("jJM5U");
parcelRequire("f8COF");
var $6IMpB = parcelRequire("6IMpB");
const $759c3f48fe1d971b$var$rgb2lab = (...args)=>{
    const [r, g, b, ...rest] = (0, $6IMpB.default)(args, 'rgb');
    const [x, y, z] = $759c3f48fe1d971b$export$fca6d690f89f5907(r, g, b);
    const [L, a, b_] = $759c3f48fe1d971b$var$xyz2lab(x, y, z);
    return [
        L,
        a,
        b_,
        ...rest.length > 0 && rest[0] < 1 ? [
            rest[0]
        ] : []
    ];
};
function $759c3f48fe1d971b$var$xyz2lab(x, y, z) {
    const { Xn: Xn, Yn: Yn, Zn: Zn, kE: kE, kK: kK } = (0, $jJM5U.default);
    const xr = x / Xn;
    const yr = y / Yn;
    const zr = z / Zn;
    const fx = xr > kE ? Math.pow(xr, 1.0 / 3.0) : (kK * xr + 16.0) / 116.0;
    const fy = yr > kE ? Math.pow(yr, 1.0 / 3.0) : (kK * yr + 16.0) / 116.0;
    const fz = zr > kE ? Math.pow(zr, 1.0 / 3.0) : (kK * zr + 16.0) / 116.0;
    return [
        116.0 * fy - 16.0,
        500.0 * (fx - fy),
        200.0 * (fy - fz)
    ];
}
function $759c3f48fe1d971b$var$gammaAdjustSRGB(companded) {
    const sign = Math.sign(companded);
    companded = Math.abs(companded);
    const linear = companded <= 0.04045 ? companded / 12.92 : Math.pow((companded + 0.055) / 1.055, 2.4);
    return linear * sign;
}
const $759c3f48fe1d971b$export$fca6d690f89f5907 = (r, g, b)=>{
    // normalize and gamma adjust
    r = $759c3f48fe1d971b$var$gammaAdjustSRGB(r / 255);
    g = $759c3f48fe1d971b$var$gammaAdjustSRGB(g / 255);
    b = $759c3f48fe1d971b$var$gammaAdjustSRGB(b / 255);
    const { MtxRGB2XYZ: MtxRGB2XYZ, MtxAdaptMa: MtxAdaptMa, MtxAdaptMaI: MtxAdaptMaI, Xn: Xn, Yn: Yn, Zn: Zn, As: As, Bs: Bs, Cs: Cs } = (0, $jJM5U.default);
    let x = r * MtxRGB2XYZ.m00 + g * MtxRGB2XYZ.m10 + b * MtxRGB2XYZ.m20;
    let y = r * MtxRGB2XYZ.m01 + g * MtxRGB2XYZ.m11 + b * MtxRGB2XYZ.m21;
    let z = r * MtxRGB2XYZ.m02 + g * MtxRGB2XYZ.m12 + b * MtxRGB2XYZ.m22;
    const Ad = Xn * MtxAdaptMa.m00 + Yn * MtxAdaptMa.m10 + Zn * MtxAdaptMa.m20;
    const Bd = Xn * MtxAdaptMa.m01 + Yn * MtxAdaptMa.m11 + Zn * MtxAdaptMa.m21;
    const Cd = Xn * MtxAdaptMa.m02 + Yn * MtxAdaptMa.m12 + Zn * MtxAdaptMa.m22;
    let X = x * MtxAdaptMa.m00 + y * MtxAdaptMa.m10 + z * MtxAdaptMa.m20;
    let Y = x * MtxAdaptMa.m01 + y * MtxAdaptMa.m11 + z * MtxAdaptMa.m21;
    let Z = x * MtxAdaptMa.m02 + y * MtxAdaptMa.m12 + z * MtxAdaptMa.m22;
    X *= Ad / As;
    Y *= Bd / Bs;
    Z *= Cd / Cs;
    x = X * MtxAdaptMaI.m00 + Y * MtxAdaptMaI.m10 + Z * MtxAdaptMaI.m20;
    y = X * MtxAdaptMaI.m01 + Y * MtxAdaptMaI.m11 + Z * MtxAdaptMaI.m21;
    z = X * MtxAdaptMaI.m02 + Y * MtxAdaptMaI.m12 + Z * MtxAdaptMaI.m22;
    return [
        x,
        y,
        z
    ];
};
var $759c3f48fe1d971b$export$2e2bcd8739ae039 = $759c3f48fe1d971b$var$rgb2lab;

});



parcelRegister("KQRAX", function(module, exports) {

var $9WhDB = parcelRequire("9WhDB");
(0, $9WhDB.default).prototype.get = function(mc) {
    const [mode, channel] = mc.split('.');
    const src = this[mode]();
    if (channel) {
        const i = mode.indexOf(channel) - (mode.substr(0, 2) === 'ok' ? 2 : 0);
        if (i > -1) return src[i];
        throw new Error(`unknown channel ${channel} in mode ${mode}`);
    } else return src;
};

});

parcelRegister("9bpAk", function(module, exports) {

var $9WhDB = parcelRequire("9WhDB");
parcelRequire("f8COF");
var $rAKRV = parcelRequire("rAKRV");
const { pow: $6af8fcc29ad49290$var$pow } = Math;
const $6af8fcc29ad49290$var$EPS = 1e-7;
const $6af8fcc29ad49290$var$MAX_ITER = 20;
(0, $9WhDB.default).prototype.luminance = function(lum, mode = 'rgb') {
    if (lum !== undefined && (0, $rAKRV.default)(lum) === 'number') {
        if (lum === 0) // return pure black
        return new (0, $9WhDB.default)([
            0,
            0,
            0,
            this._rgb[3]
        ], 'rgb');
        if (lum === 1) // return pure white
        return new (0, $9WhDB.default)([
            255,
            255,
            255,
            this._rgb[3]
        ], 'rgb');
        // compute new color using...
        let cur_lum = this.luminance();
        let max_iter = $6af8fcc29ad49290$var$MAX_ITER;
        const test = (low, high)=>{
            const mid = low.interpolate(high, 0.5, mode);
            const lm = mid.luminance();
            if (Math.abs(lum - lm) < $6af8fcc29ad49290$var$EPS || !max_iter--) // close enough
            return mid;
            return lm > lum ? test(low, mid) : test(mid, high);
        };
        const rgb = (cur_lum > lum ? test(new (0, $9WhDB.default)([
            0,
            0,
            0
        ]), this) : test(this, new (0, $9WhDB.default)([
            255,
            255,
            255
        ]))).rgb();
        return new (0, $9WhDB.default)([
            ...rgb,
            this._rgb[3]
        ]);
    }
    return $6af8fcc29ad49290$var$rgb2luminance(...this._rgb.slice(0, 3));
};
const $6af8fcc29ad49290$var$rgb2luminance = (r, g, b)=>{
    // relative luminance
    // see http://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef
    r = $6af8fcc29ad49290$var$luminance_x(r);
    g = $6af8fcc29ad49290$var$luminance_x(g);
    b = $6af8fcc29ad49290$var$luminance_x(b);
    return 0.2126 * r + 0.7152 * g + 0.0722 * b;
};
const $6af8fcc29ad49290$var$luminance_x = (x)=>{
    x /= 255;
    return x <= 0.03928 ? x / 12.92 : $6af8fcc29ad49290$var$pow((x + 0.055) / 1.055, 2.4);
};

});

parcelRegister("7rOiv", function(module, exports) {

var $9WhDB = parcelRequire("9WhDB");

var $4Dxga = parcelRequire("4Dxga");
(0, $9WhDB.default).prototype.mix = (0, $9WhDB.default).prototype.interpolate = function(col2, f = 0.5, ...rest) {
    return (0, $4Dxga.default)(this, col2, f, ...rest);
};

});
parcelRegister("4Dxga", function(module, exports) {

$parcel$export(module.exports, "default", () => $36049a9f16a5dcac$export$2e2bcd8739ae039);

var $9WhDB = parcelRequire("9WhDB");
parcelRequire("f8COF");
var $rAKRV = parcelRequire("rAKRV");

var $44zyK = parcelRequire("44zyK");
var $36049a9f16a5dcac$export$2e2bcd8739ae039 = (col1, col2, f = 0.5, ...rest)=>{
    let mode = rest[0] || 'lrgb';
    if (!(0, $44zyK.default)[mode] && !rest.length) // fall back to the first supported mode
    mode = Object.keys((0, $44zyK.default))[0];
    if (!(0, $44zyK.default)[mode]) throw new Error(`interpolation mode ${mode} is not defined`);
    if ((0, $rAKRV.default)(col1) !== 'object') col1 = new (0, $9WhDB.default)(col1);
    if ((0, $rAKRV.default)(col2) !== 'object') col2 = new (0, $9WhDB.default)(col2);
    return (0, $44zyK.default)[mode](col1, col2, f).alpha(col1.alpha() + f * (col2.alpha() - col1.alpha()));
};

});
parcelRegister("44zyK", function(module, exports) {

$parcel$export(module.exports, "default", () => $2f731e83e3211502$export$2e2bcd8739ae039);
var $2f731e83e3211502$export$2e2bcd8739ae039 = {};

});



parcelRegister("8m60N", function(module, exports) {

var $9WhDB = parcelRequire("9WhDB");
(0, $9WhDB.default).prototype.premultiply = function(mutate = false) {
    const rgb = this._rgb;
    const a = rgb[3];
    if (mutate) {
        this._rgb = [
            rgb[0] * a,
            rgb[1] * a,
            rgb[2] * a,
            a
        ];
        return this;
    } else return new (0, $9WhDB.default)([
        rgb[0] * a,
        rgb[1] * a,
        rgb[2] * a,
        a
    ], 'rgb');
};

});

parcelRegister("j9UwR", function(module, exports) {
parcelRequire("6YXfw");

var $9WhDB = parcelRequire("9WhDB");

var $jJM5U = parcelRequire("jJM5U");
(0, $9WhDB.default).prototype.saturate = function(amount = 1) {
    const me = this;
    const lch = me.lch();
    lch[1] += (0, $jJM5U.default).Kn * amount;
    if (lch[1] < 0) lch[1] = 0;
    return new (0, $9WhDB.default)(lch, 'lch').alpha(me.alpha(), true);
};
(0, $9WhDB.default).prototype.desaturate = function(amount = 1) {
    return this.saturate(-amount);
};

});
parcelRegister("6YXfw", function(module, exports) {

var $f8COF = parcelRequire("f8COF");
var $rAKRV = parcelRequire("rAKRV");
var $6IMpB = parcelRequire("6IMpB");

var $4dsSs = parcelRequire("4dsSs");

var $9WhDB = parcelRequire("9WhDB");

var $cio9q = parcelRequire("cio9q");

var $baiXr = parcelRequire("baiXr");

var $3AVvS = parcelRequire("3AVvS");

var $bETIL = parcelRequire("bETIL");
(0, $9WhDB.default).prototype.lch = function() {
    return (0, $bETIL.default)(this._rgb);
};
(0, $9WhDB.default).prototype.hcl = function() {
    return (0, $f8COF.reverse3)((0, $bETIL.default)(this._rgb));
};
const $51564e5ae773aa10$export$5a21418738164530 = (...args)=>new (0, $9WhDB.default)(...args, 'lch');
const $51564e5ae773aa10$export$d0e870ba50062ff1 = (...args)=>new (0, $9WhDB.default)(...args, 'hcl');
Object.assign((0, $4dsSs.default), {
    lch: $51564e5ae773aa10$export$5a21418738164530,
    hcl: $51564e5ae773aa10$export$d0e870ba50062ff1
});
(0, $cio9q.default).format.lch = (0, $baiXr.default);
(0, $cio9q.default).format.hcl = (0, $3AVvS.default);
[
    'lch',
    'hcl'
].forEach((m)=>(0, $cio9q.default).autodetect.push({
        p: 2,
        test: (...args)=>{
            args = (0, $6IMpB.default)(args, m);
            if ((0, $rAKRV.default)(args) === 'array' && args.length === 3) return m;
        }
    }));

});
parcelRegister("baiXr", function(module, exports) {

$parcel$export(module.exports, "default", () => $820f558227d224dc$export$2e2bcd8739ae039);
parcelRequire("f8COF");
var $6IMpB = parcelRequire("6IMpB");

var $1wyt6 = parcelRequire("1wyt6");

var $1e9qI = parcelRequire("1e9qI");
const $820f558227d224dc$var$lch2rgb = (...args)=>{
    args = (0, $6IMpB.default)(args, 'lch');
    const [l, c, h] = args;
    const [L, a, b_] = (0, $1wyt6.default)(l, c, h);
    const [r, g, b] = (0, $1e9qI.default)(L, a, b_);
    return [
        r,
        g,
        b,
        args.length > 3 ? args[3] : 1
    ];
};
var $820f558227d224dc$export$2e2bcd8739ae039 = $820f558227d224dc$var$lch2rgb;

});
parcelRegister("1wyt6", function(module, exports) {

$parcel$export(module.exports, "default", () => $11c384502518f696$export$2e2bcd8739ae039);

var $f8COF = parcelRequire("f8COF");
var $6IMpB = parcelRequire("6IMpB");
const { sin: $11c384502518f696$var$sin, cos: $11c384502518f696$var$cos } = Math;
const $11c384502518f696$var$lch2lab = (...args)=>{
    /*
    Convert from a qualitative parameter h and a quantitative parameter l to a 24-bit pixel.
    These formulas were invented by David Dalrymple to obtain maximum contrast without going
    out of gamut if the parameters are in the range 0-1.

    A saturation multiplier was added by Gregor Aisch
    */ let [l, c, h] = (0, $6IMpB.default)(args, 'lch');
    if (isNaN(h)) h = 0;
    h = h * (0, $f8COF.DEG2RAD);
    return [
        l,
        $11c384502518f696$var$cos(h) * c,
        $11c384502518f696$var$sin(h) * c
    ];
};
var $11c384502518f696$export$2e2bcd8739ae039 = $11c384502518f696$var$lch2lab;

});


parcelRegister("3AVvS", function(module, exports) {

$parcel$export(module.exports, "default", () => $29e158ccbd1f7b12$export$2e2bcd8739ae039);

var $f8COF = parcelRequire("f8COF");
var $6IMpB = parcelRequire("6IMpB");

var $baiXr = parcelRequire("baiXr");
const $29e158ccbd1f7b12$var$hcl2rgb = (...args)=>{
    const hcl = (0, $f8COF.reverse3)((0, $6IMpB.default)(args, 'hcl'));
    return (0, $baiXr.default)(...hcl);
};
var $29e158ccbd1f7b12$export$2e2bcd8739ae039 = $29e158ccbd1f7b12$var$hcl2rgb;

});

parcelRegister("bETIL", function(module, exports) {

$parcel$export(module.exports, "default", () => $87cea72c5aad1be6$export$2e2bcd8739ae039);
parcelRequire("f8COF");
var $6IMpB = parcelRequire("6IMpB");

var $a62iy = parcelRequire("a62iy");

var $j71Rx = parcelRequire("j71Rx");
const $87cea72c5aad1be6$var$rgb2lch = (...args)=>{
    const [r, g, b, ...rest] = (0, $6IMpB.default)(args, 'rgb');
    const [l, a, b_] = (0, $a62iy.default)(r, g, b);
    const [L, c, h] = (0, $j71Rx.default)(l, a, b_);
    return [
        L,
        c,
        h,
        ...rest.length > 0 && rest[0] < 1 ? [
            rest[0]
        ] : []
    ];
};
var $87cea72c5aad1be6$export$2e2bcd8739ae039 = $87cea72c5aad1be6$var$rgb2lch;

});
parcelRegister("j71Rx", function(module, exports) {

$parcel$export(module.exports, "default", () => $dea01d9fa2b6ac43$export$2e2bcd8739ae039);

var $f8COF = parcelRequire("f8COF");
var $6IMpB = parcelRequire("6IMpB");
const { sqrt: $dea01d9fa2b6ac43$var$sqrt, atan2: $dea01d9fa2b6ac43$var$atan2, round: $dea01d9fa2b6ac43$var$round } = Math;
const $dea01d9fa2b6ac43$var$lab2lch = (...args)=>{
    const [l, a, b] = (0, $6IMpB.default)(args, 'lab');
    const c = $dea01d9fa2b6ac43$var$sqrt(a * a + b * b);
    let h = ($dea01d9fa2b6ac43$var$atan2(b, a) * (0, $f8COF.RAD2DEG) + 360) % 360;
    if ($dea01d9fa2b6ac43$var$round(c * 10000) === 0) h = Number.NaN;
    return [
        l,
        c,
        h
    ];
};
var $dea01d9fa2b6ac43$export$2e2bcd8739ae039 = $dea01d9fa2b6ac43$var$lab2lch;

});




parcelRegister("33sZr", function(module, exports) {

var $9WhDB = parcelRequire("9WhDB");
parcelRequire("f8COF");
var $rAKRV = parcelRequire("rAKRV");
(0, $9WhDB.default).prototype.set = function(mc, value, mutate = false) {
    const [mode, channel] = mc.split('.');
    const src = this[mode]();
    if (channel) {
        const i = mode.indexOf(channel) - (mode.substr(0, 2) === 'ok' ? 2 : 0);
        if (i > -1) {
            if ((0, $rAKRV.default)(value) == 'string') switch(value.charAt(0)){
                case '+':
                    src[i] += +value;
                    break;
                case '-':
                    src[i] += +value;
                    break;
                case '*':
                    src[i] *= +value.substr(1);
                    break;
                case '/':
                    src[i] /= +value.substr(1);
                    break;
                default:
                    src[i] = +value;
            }
            else if ((0, $rAKRV.default)(value) === 'number') src[i] = value;
            else throw new Error(`unsupported value for Color.set`);
            const out = new (0, $9WhDB.default)(src, mode);
            if (mutate) {
                this._rgb = out._rgb;
                return this;
            }
            return out;
        }
        throw new Error(`unknown channel ${channel} in mode ${mode}`);
    } else return src;
};

});

parcelRegister("2RvX8", function(module, exports) {
parcelRequire("gdTSI");

var $9WhDB = parcelRequire("9WhDB");

var $4Dxga = parcelRequire("4Dxga");
(0, $9WhDB.default).prototype.tint = function(f = 0.5, ...rest) {
    return (0, $4Dxga.default)(this, 'white', f, ...rest);
};
(0, $9WhDB.default).prototype.shade = function(f = 0.5, ...rest) {
    return (0, $4Dxga.default)(this, 'black', f, ...rest);
};

});

parcelRegister("Se4Sm", function(module, exports) {

var $9WhDB = parcelRequire("9WhDB");

var $44zyK = parcelRequire("44zyK");
const $0a2ff6c965236cbc$var$rgb = (col1, col2, f)=>{
    const xyz0 = col1._rgb;
    const xyz1 = col2._rgb;
    return new (0, $9WhDB.default)(xyz0[0] + f * (xyz1[0] - xyz0[0]), xyz0[1] + f * (xyz1[1] - xyz0[1]), xyz0[2] + f * (xyz1[2] - xyz0[2]), 'rgb');
};
// register interpolator
(0, $44zyK.default).rgb = $0a2ff6c965236cbc$var$rgb;
var $0a2ff6c965236cbc$export$2e2bcd8739ae039 = $0a2ff6c965236cbc$var$rgb;

});

parcelRegister("cBvRm", function(module, exports) {

var $9WhDB = parcelRequire("9WhDB");

var $44zyK = parcelRequire("44zyK");
const { sqrt: $92d1a76c2e906c2a$var$sqrt, pow: $92d1a76c2e906c2a$var$pow } = Math;
const $92d1a76c2e906c2a$var$lrgb = (col1, col2, f)=>{
    const [x1, y1, z1] = col1._rgb;
    const [x2, y2, z2] = col2._rgb;
    return new (0, $9WhDB.default)($92d1a76c2e906c2a$var$sqrt($92d1a76c2e906c2a$var$pow(x1, 2) * (1 - f) + $92d1a76c2e906c2a$var$pow(x2, 2) * f), $92d1a76c2e906c2a$var$sqrt($92d1a76c2e906c2a$var$pow(y1, 2) * (1 - f) + $92d1a76c2e906c2a$var$pow(y2, 2) * f), $92d1a76c2e906c2a$var$sqrt($92d1a76c2e906c2a$var$pow(z1, 2) * (1 - f) + $92d1a76c2e906c2a$var$pow(z2, 2) * f), 'rgb');
};
// register interpolator
(0, $44zyK.default).lrgb = $92d1a76c2e906c2a$var$lrgb;
var $92d1a76c2e906c2a$export$2e2bcd8739ae039 = $92d1a76c2e906c2a$var$lrgb;

});

parcelRegister("kPcfN", function(module, exports) {
parcelRequire("gdTSI");

var $44zyK = parcelRequire("44zyK");

var $9WhDB = parcelRequire("9WhDB");
const $f29213695a0a0638$var$lab = (col1, col2, f)=>{
    const xyz0 = col1.lab();
    const xyz1 = col2.lab();
    return new (0, $9WhDB.default)(xyz0[0] + f * (xyz1[0] - xyz0[0]), xyz0[1] + f * (xyz1[1] - xyz0[1]), xyz0[2] + f * (xyz1[2] - xyz0[2]), 'lab');
};
// register interpolator
(0, $44zyK.default).lab = $f29213695a0a0638$var$lab;
var $f29213695a0a0638$export$2e2bcd8739ae039 = $f29213695a0a0638$var$lab;

});

parcelRegister("jMSjY", function(module, exports) {
parcelRequire("6YXfw");

var $ktl6m = parcelRequire("ktl6m");

var $44zyK = parcelRequire("44zyK");
const $e67ca313b7b33db9$var$lch = (col1, col2, f)=>{
    return (0, $ktl6m.default)(col1, col2, f, 'lch');
};
// register interpolator
(0, $44zyK.default).lch = $e67ca313b7b33db9$var$lch;
(0, $44zyK.default).hcl = $e67ca313b7b33db9$var$lch;
var $e67ca313b7b33db9$export$2e2bcd8739ae039 = $e67ca313b7b33db9$var$lch;

});
parcelRegister("ktl6m", function(module, exports) {

$parcel$export(module.exports, "default", () => $ee76e2650e18cb93$export$2e2bcd8739ae039);

var $9WhDB = parcelRequire("9WhDB");
var $ee76e2650e18cb93$export$2e2bcd8739ae039 = (col1, col2, f, m)=>{
    let xyz0, xyz1;
    if (m === 'hsl') {
        xyz0 = col1.hsl();
        xyz1 = col2.hsl();
    } else if (m === 'hsv') {
        xyz0 = col1.hsv();
        xyz1 = col2.hsv();
    } else if (m === 'hcg') {
        xyz0 = col1.hcg();
        xyz1 = col2.hcg();
    } else if (m === 'hsi') {
        xyz0 = col1.hsi();
        xyz1 = col2.hsi();
    } else if (m === 'lch' || m === 'hcl') {
        m = 'hcl';
        xyz0 = col1.hcl();
        xyz1 = col2.hcl();
    } else if (m === 'oklch') {
        xyz0 = col1.oklch().reverse();
        xyz1 = col2.oklch().reverse();
    }
    let hue0, hue1, sat0, sat1, lbv0, lbv1;
    if (m.substr(0, 1) === 'h' || m === 'oklch') {
        [hue0, sat0, lbv0] = xyz0;
        [hue1, sat1, lbv1] = xyz1;
    }
    let sat, hue, lbv, dh;
    if (!isNaN(hue0) && !isNaN(hue1)) {
        // both colors have hue
        if (hue1 > hue0 && hue1 - hue0 > 180) dh = hue1 - (hue0 + 360);
        else if (hue1 < hue0 && hue0 - hue1 > 180) dh = hue1 + 360 - hue0;
        else dh = hue1 - hue0;
        hue = hue0 + f * dh;
    } else if (!isNaN(hue0)) {
        hue = hue0;
        if ((lbv1 == 1 || lbv1 == 0) && m != 'hsv') sat = sat0;
    } else if (!isNaN(hue1)) {
        hue = hue1;
        if ((lbv0 == 1 || lbv0 == 0) && m != 'hsv') sat = sat1;
    } else hue = Number.NaN;
    if (sat === undefined) sat = sat0 + f * (sat1 - sat0);
    lbv = lbv0 + f * (lbv1 - lbv0);
    return m === 'oklch' ? new (0, $9WhDB.default)([
        lbv,
        sat,
        hue
    ], m) : new (0, $9WhDB.default)([
        hue,
        sat,
        lbv
    ], m);
};

});


parcelRegister("1ObGX", function(module, exports) {
parcelRequire("f6E2L");

var $44zyK = parcelRequire("44zyK");

var $9WhDB = parcelRequire("9WhDB");
const $151387b881e24d5f$var$num = (col1, col2, f)=>{
    const c1 = col1.num();
    const c2 = col2.num();
    return new (0, $9WhDB.default)(c1 + f * (c2 - c1), 'num');
};
// register interpolator
(0, $44zyK.default).num = $151387b881e24d5f$var$num;
var $151387b881e24d5f$export$2e2bcd8739ae039 = $151387b881e24d5f$var$num;

});
parcelRegister("f6E2L", function(module, exports) {

var $4dsSs = parcelRequire("4dsSs");

var $9WhDB = parcelRequire("9WhDB");

var $cio9q = parcelRequire("cio9q");
parcelRequire("f8COF");
var $rAKRV = parcelRequire("rAKRV");

var $iY7WP = parcelRequire("iY7WP");

var $57IUN = parcelRequire("57IUN");
(0, $9WhDB.default).prototype.num = function() {
    return (0, $57IUN.default)(this._rgb);
};
const $aff67a618b1fa03c$export$61cc6a0be4938a2a = (...args)=>new (0, $9WhDB.default)(...args, 'num');
Object.assign((0, $4dsSs.default), {
    num: $aff67a618b1fa03c$export$61cc6a0be4938a2a
});
(0, $cio9q.default).format.num = (0, $iY7WP.default);
(0, $cio9q.default).autodetect.push({
    p: 5,
    test: (...args)=>{
        if (args.length === 1 && (0, $rAKRV.default)(args[0]) === 'number' && args[0] >= 0 && args[0] <= 0xffffff) return 'num';
    }
});

});
parcelRegister("iY7WP", function(module, exports) {

$parcel$export(module.exports, "default", () => $dcf3fedce6cf0351$export$2e2bcd8739ae039);
parcelRequire("f8COF");
var $rAKRV = parcelRequire("rAKRV");
const $dcf3fedce6cf0351$var$num2rgb = (num)=>{
    if ((0, $rAKRV.default)(num) == 'number' && num >= 0 && num <= 0xffffff) {
        const r = num >> 16;
        const g = num >> 8 & 0xff;
        const b = num & 0xff;
        return [
            r,
            g,
            b,
            1
        ];
    }
    throw new Error('unknown num color: ' + num);
};
var $dcf3fedce6cf0351$export$2e2bcd8739ae039 = $dcf3fedce6cf0351$var$num2rgb;

});

parcelRegister("57IUN", function(module, exports) {

$parcel$export(module.exports, "default", () => $3bb07263329a5fd4$export$2e2bcd8739ae039);
parcelRequire("f8COF");
var $6IMpB = parcelRequire("6IMpB");
const $3bb07263329a5fd4$var$rgb2num = (...args)=>{
    const [r, g, b] = (0, $6IMpB.default)(args, 'rgb');
    return (r << 16) + (g << 8) + b;
};
var $3bb07263329a5fd4$export$2e2bcd8739ae039 = $3bb07263329a5fd4$var$rgb2num;

});



parcelRegister("jsxUE", function(module, exports) {
parcelRequire("8kdxP");

var $ktl6m = parcelRequire("ktl6m");

var $44zyK = parcelRequire("44zyK");
const $e2aaf02e811db4cb$var$hcg = (col1, col2, f)=>{
    return (0, $ktl6m.default)(col1, col2, f, 'hcg');
};
// register interpolator
(0, $44zyK.default).hcg = $e2aaf02e811db4cb$var$hcg;
var $e2aaf02e811db4cb$export$2e2bcd8739ae039 = $e2aaf02e811db4cb$var$hcg;

});
parcelRegister("8kdxP", function(module, exports) {
parcelRequire("f8COF");
var $rAKRV = parcelRequire("rAKRV");
var $6IMpB = parcelRequire("6IMpB");

var $4dsSs = parcelRequire("4dsSs");

var $9WhDB = parcelRequire("9WhDB");

var $cio9q = parcelRequire("cio9q");

var $aJRJn = parcelRequire("aJRJn");

var $6QmJ8 = parcelRequire("6QmJ8");
(0, $9WhDB.default).prototype.hcg = function() {
    return (0, $6QmJ8.default)(this._rgb);
};
const $60fab2a652bc6665$export$e588e1c8c259384c = (...args)=>new (0, $9WhDB.default)(...args, 'hcg');
(0, $4dsSs.default).hcg = $60fab2a652bc6665$export$e588e1c8c259384c;
(0, $cio9q.default).format.hcg = (0, $aJRJn.default);
(0, $cio9q.default).autodetect.push({
    p: 1,
    test: (...args)=>{
        args = (0, $6IMpB.default)(args, 'hcg');
        if ((0, $rAKRV.default)(args) === 'array' && args.length === 3) return 'hcg';
    }
});

});
parcelRegister("aJRJn", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d17c930c3b94a45$export$2e2bcd8739ae039);
parcelRequire("f8COF");
var $6IMpB = parcelRequire("6IMpB");
const { floor: $7d17c930c3b94a45$var$floor } = Math;
/*
 * this is basically just HSV with some minor tweaks
 *
 * hue.. [0..360]
 * chroma .. [0..1]
 * grayness .. [0..1]
 */ const $7d17c930c3b94a45$var$hcg2rgb = (...args)=>{
    args = (0, $6IMpB.default)(args, 'hcg');
    let [h, c, _g] = args;
    let r, g, b;
    _g = _g * 255;
    const _c = c * 255;
    if (c === 0) r = g = b = _g;
    else {
        if (h === 360) h = 0;
        if (h > 360) h -= 360;
        if (h < 0) h += 360;
        h /= 60;
        const i = $7d17c930c3b94a45$var$floor(h);
        const f = h - i;
        const p = _g * (1 - c);
        const q = p + _c * (1 - f);
        const t = p + _c * f;
        const v = p + _c;
        switch(i){
            case 0:
                [r, g, b] = [
                    v,
                    t,
                    p
                ];
                break;
            case 1:
                [r, g, b] = [
                    q,
                    v,
                    p
                ];
                break;
            case 2:
                [r, g, b] = [
                    p,
                    v,
                    t
                ];
                break;
            case 3:
                [r, g, b] = [
                    p,
                    q,
                    v
                ];
                break;
            case 4:
                [r, g, b] = [
                    t,
                    p,
                    v
                ];
                break;
            case 5:
                [r, g, b] = [
                    v,
                    p,
                    q
                ];
                break;
        }
    }
    return [
        r,
        g,
        b,
        args.length > 3 ? args[3] : 1
    ];
};
var $7d17c930c3b94a45$export$2e2bcd8739ae039 = $7d17c930c3b94a45$var$hcg2rgb;

});

parcelRegister("6QmJ8", function(module, exports) {

$parcel$export(module.exports, "default", () => $4fb93a884ae2da29$export$2e2bcd8739ae039);

var $f8COF = parcelRequire("f8COF");
var $6IMpB = parcelRequire("6IMpB");
const $4fb93a884ae2da29$var$rgb2hcg = (...args)=>{
    const [r, g, b] = (0, $6IMpB.default)(args, 'rgb');
    const minRgb = (0, $f8COF.min)(r, g, b);
    const maxRgb = (0, $f8COF.max)(r, g, b);
    const delta = maxRgb - minRgb;
    const c = delta * 100 / 255;
    const _g = minRgb / (255 - delta) * 100;
    let h;
    if (delta === 0) h = Number.NaN;
    else {
        if (r === maxRgb) h = (g - b) / delta;
        if (g === maxRgb) h = 2 + (b - r) / delta;
        if (b === maxRgb) h = 4 + (r - g) / delta;
        h *= 60;
        if (h < 0) h += 360;
    }
    return [
        h,
        c,
        _g
    ];
};
var $4fb93a884ae2da29$export$2e2bcd8739ae039 = $4fb93a884ae2da29$var$rgb2hcg;

});



parcelRegister("gHzE3", function(module, exports) {
parcelRequire("jx0kP");

var $ktl6m = parcelRequire("ktl6m");

var $44zyK = parcelRequire("44zyK");
const $c28c4fdb93d61fa1$var$hsi = (col1, col2, f)=>{
    return (0, $ktl6m.default)(col1, col2, f, 'hsi');
};
// register interpolator
(0, $44zyK.default).hsi = $c28c4fdb93d61fa1$var$hsi;
var $c28c4fdb93d61fa1$export$2e2bcd8739ae039 = $c28c4fdb93d61fa1$var$hsi;

});
parcelRegister("jx0kP", function(module, exports) {
parcelRequire("f8COF");
var $rAKRV = parcelRequire("rAKRV");
var $6IMpB = parcelRequire("6IMpB");

var $4dsSs = parcelRequire("4dsSs");

var $9WhDB = parcelRequire("9WhDB");

var $cio9q = parcelRequire("cio9q");

var $9dP6h = parcelRequire("9dP6h");

var $6C72Z = parcelRequire("6C72Z");
(0, $9WhDB.default).prototype.hsi = function() {
    return (0, $6C72Z.default)(this._rgb);
};
const $03ab60733f2cfa62$export$ec0e0a10cc3c404a = (...args)=>new (0, $9WhDB.default)(...args, 'hsi');
(0, $4dsSs.default).hsi = $03ab60733f2cfa62$export$ec0e0a10cc3c404a;
(0, $cio9q.default).format.hsi = (0, $9dP6h.default);
(0, $cio9q.default).autodetect.push({
    p: 2,
    test: (...args)=>{
        args = (0, $6IMpB.default)(args, 'hsi');
        if ((0, $rAKRV.default)(args) === 'array' && args.length === 3) return 'hsi';
    }
});

});
parcelRegister("9dP6h", function(module, exports) {

$parcel$export(module.exports, "default", () => $6b6cf761bdd88f2b$export$2e2bcd8739ae039);
parcelRequire("f8COF");
var $eeze8 = parcelRequire("eeze8");
var $f8COF = parcelRequire("f8COF");
var $6IMpB = parcelRequire("6IMpB");
const { cos: $6b6cf761bdd88f2b$var$cos } = Math;
/*
 * hue [0..360]
 * saturation [0..1]
 * intensity [0..1]
 */ const $6b6cf761bdd88f2b$var$hsi2rgb = (...args)=>{
    /*
    borrowed from here:
    http://hummer.stanford.edu/museinfo/doc/examples/humdrum/keyscape2/hsi2rgb.cpp
    */ args = (0, $6IMpB.default)(args, 'hsi');
    let [h, s, i] = args;
    let r, g, b;
    if (isNaN(h)) h = 0;
    if (isNaN(s)) s = 0;
    // normalize hue
    if (h > 360) h -= 360;
    if (h < 0) h += 360;
    h /= 360;
    if (h < 1 / 3) {
        b = (1 - s) / 3;
        r = (1 + s * $6b6cf761bdd88f2b$var$cos((0, $f8COF.TWOPI) * h) / $6b6cf761bdd88f2b$var$cos((0, $f8COF.PITHIRD) - (0, $f8COF.TWOPI) * h)) / 3;
        g = 1 - (b + r);
    } else if (h < 2 / 3) {
        h -= 1 / 3;
        r = (1 - s) / 3;
        g = (1 + s * $6b6cf761bdd88f2b$var$cos((0, $f8COF.TWOPI) * h) / $6b6cf761bdd88f2b$var$cos((0, $f8COF.PITHIRD) - (0, $f8COF.TWOPI) * h)) / 3;
        b = 1 - (r + g);
    } else {
        h -= 2 / 3;
        g = (1 - s) / 3;
        b = (1 + s * $6b6cf761bdd88f2b$var$cos((0, $f8COF.TWOPI) * h) / $6b6cf761bdd88f2b$var$cos((0, $f8COF.PITHIRD) - (0, $f8COF.TWOPI) * h)) / 3;
        r = 1 - (g + b);
    }
    r = (0, $eeze8.default)(i * r * 3);
    g = (0, $eeze8.default)(i * g * 3);
    b = (0, $eeze8.default)(i * b * 3);
    return [
        r * 255,
        g * 255,
        b * 255,
        args.length > 3 ? args[3] : 1
    ];
};
var $6b6cf761bdd88f2b$export$2e2bcd8739ae039 = $6b6cf761bdd88f2b$var$hsi2rgb;

});

parcelRegister("6C72Z", function(module, exports) {

$parcel$export(module.exports, "default", () => $4d0bc2235b63ccfe$export$2e2bcd8739ae039);

var $f8COF = parcelRequire("f8COF");
var $6IMpB = parcelRequire("6IMpB");
const { min: $4d0bc2235b63ccfe$var$min, sqrt: $4d0bc2235b63ccfe$var$sqrt, acos: $4d0bc2235b63ccfe$var$acos } = Math;
const $4d0bc2235b63ccfe$var$rgb2hsi = (...args)=>{
    /*
    borrowed from here:
    http://hummer.stanford.edu/museinfo/doc/examples/humdrum/keyscape2/rgb2hsi.cpp
    */ let [r, g, b] = (0, $6IMpB.default)(args, 'rgb');
    r /= 255;
    g /= 255;
    b /= 255;
    let h;
    const min_ = $4d0bc2235b63ccfe$var$min(r, g, b);
    const i = (r + g + b) / 3;
    const s = i > 0 ? 1 - min_ / i : 0;
    if (s === 0) h = NaN;
    else {
        h = (r - g + (r - b)) / 2;
        h /= $4d0bc2235b63ccfe$var$sqrt((r - g) * (r - g) + (r - b) * (g - b));
        h = $4d0bc2235b63ccfe$var$acos(h);
        if (b > g) h = (0, $f8COF.TWOPI) - h;
        h /= (0, $f8COF.TWOPI);
    }
    return [
        h * 360,
        s,
        i
    ];
};
var $4d0bc2235b63ccfe$export$2e2bcd8739ae039 = $4d0bc2235b63ccfe$var$rgb2hsi;

});



parcelRegister("1QQvo", function(module, exports) {
parcelRequire("cHZip");

var $ktl6m = parcelRequire("ktl6m");

var $44zyK = parcelRequire("44zyK");
const $15936043af9f08c3$var$hsl = (col1, col2, f)=>{
    return (0, $ktl6m.default)(col1, col2, f, 'hsl');
};
// register interpolator
(0, $44zyK.default).hsl = $15936043af9f08c3$var$hsl;
var $15936043af9f08c3$export$2e2bcd8739ae039 = $15936043af9f08c3$var$hsl;

});
parcelRegister("cHZip", function(module, exports) {
parcelRequire("f8COF");
var $rAKRV = parcelRequire("rAKRV");
var $6IMpB = parcelRequire("6IMpB");

var $4dsSs = parcelRequire("4dsSs");

var $9WhDB = parcelRequire("9WhDB");

var $cio9q = parcelRequire("cio9q");

var $diYXA = parcelRequire("diYXA");

var $hnEdb = parcelRequire("hnEdb");
(0, $9WhDB.default).prototype.hsl = function() {
    return (0, $hnEdb.default)(this._rgb);
};
const $94090c48533a700f$export$8f4a7c0bb78e6ea8 = (...args)=>new (0, $9WhDB.default)(...args, 'hsl');
(0, $4dsSs.default).hsl = $94090c48533a700f$export$8f4a7c0bb78e6ea8;
(0, $cio9q.default).format.hsl = (0, $diYXA.default);
(0, $cio9q.default).autodetect.push({
    p: 2,
    test: (...args)=>{
        args = (0, $6IMpB.default)(args, 'hsl');
        if ((0, $rAKRV.default)(args) === 'array' && args.length === 3) return 'hsl';
    }
});

});
parcelRegister("diYXA", function(module, exports) {

$parcel$export(module.exports, "default", () => $9afc3e3640e20219$export$2e2bcd8739ae039);
parcelRequire("f8COF");
var $6IMpB = parcelRequire("6IMpB");
const $9afc3e3640e20219$var$hsl2rgb = (...args)=>{
    args = (0, $6IMpB.default)(args, 'hsl');
    const [h, s, l] = args;
    let r, g, b;
    if (s === 0) r = g = b = l * 255;
    else {
        const t3 = [
            0,
            0,
            0
        ];
        const c = [
            0,
            0,
            0
        ];
        const t2 = l < 0.5 ? l * (1 + s) : l + s - l * s;
        const t1 = 2 * l - t2;
        const h_ = h / 360;
        t3[0] = h_ + 1 / 3;
        t3[1] = h_;
        t3[2] = h_ - 1 / 3;
        for(let i = 0; i < 3; i++){
            if (t3[i] < 0) t3[i] += 1;
            if (t3[i] > 1) t3[i] -= 1;
            if (6 * t3[i] < 1) c[i] = t1 + (t2 - t1) * 6 * t3[i];
            else if (2 * t3[i] < 1) c[i] = t2;
            else if (3 * t3[i] < 2) c[i] = t1 + (t2 - t1) * (2 / 3 - t3[i]) * 6;
            else c[i] = t1;
        }
        [r, g, b] = [
            c[0] * 255,
            c[1] * 255,
            c[2] * 255
        ];
    }
    if (args.length > 3) // keep alpha channel
    return [
        r,
        g,
        b,
        args[3]
    ];
    return [
        r,
        g,
        b,
        1
    ];
};
var $9afc3e3640e20219$export$2e2bcd8739ae039 = $9afc3e3640e20219$var$hsl2rgb;

});

parcelRegister("hnEdb", function(module, exports) {

$parcel$export(module.exports, "default", () => $ca73c6d9aefef096$export$2e2bcd8739ae039);

var $f8COF = parcelRequire("f8COF");
var $6IMpB = parcelRequire("6IMpB");
/*
 * supported arguments:
 * - rgb2hsl(r,g,b)
 * - rgb2hsl(r,g,b,a)
 * - rgb2hsl([r,g,b])
 * - rgb2hsl([r,g,b,a])
 * - rgb2hsl({r,g,b,a})
 */ const $ca73c6d9aefef096$var$rgb2hsl = (...args)=>{
    args = (0, $6IMpB.default)(args, 'rgba');
    let [r, g, b] = args;
    r /= 255;
    g /= 255;
    b /= 255;
    const minRgb = (0, $f8COF.min)(r, g, b);
    const maxRgb = (0, $f8COF.max)(r, g, b);
    const l = (maxRgb + minRgb) / 2;
    let s, h;
    if (maxRgb === minRgb) {
        s = 0;
        h = Number.NaN;
    } else s = l < 0.5 ? (maxRgb - minRgb) / (maxRgb + minRgb) : (maxRgb - minRgb) / (2 - maxRgb - minRgb);
    if (r == maxRgb) h = (g - b) / (maxRgb - minRgb);
    else if (g == maxRgb) h = 2 + (b - r) / (maxRgb - minRgb);
    else if (b == maxRgb) h = 4 + (r - g) / (maxRgb - minRgb);
    h *= 60;
    if (h < 0) h += 360;
    if (args.length > 3 && args[3] !== undefined) return [
        h,
        s,
        l,
        args[3]
    ];
    return [
        h,
        s,
        l
    ];
};
var $ca73c6d9aefef096$export$2e2bcd8739ae039 = $ca73c6d9aefef096$var$rgb2hsl;

});



parcelRegister("iDRu9", function(module, exports) {
parcelRequire("fdeu1");

var $ktl6m = parcelRequire("ktl6m");

var $44zyK = parcelRequire("44zyK");
const $d9255b9747dc8509$var$hsv = (col1, col2, f)=>{
    return (0, $ktl6m.default)(col1, col2, f, 'hsv');
};
// register interpolator
(0, $44zyK.default).hsv = $d9255b9747dc8509$var$hsv;
var $d9255b9747dc8509$export$2e2bcd8739ae039 = $d9255b9747dc8509$var$hsv;

});
parcelRegister("fdeu1", function(module, exports) {
parcelRequire("f8COF");
var $rAKRV = parcelRequire("rAKRV");
var $6IMpB = parcelRequire("6IMpB");

var $4dsSs = parcelRequire("4dsSs");

var $9WhDB = parcelRequire("9WhDB");

var $cio9q = parcelRequire("cio9q");

var $eMAah = parcelRequire("eMAah");

var $bNsTS = parcelRequire("bNsTS");
(0, $9WhDB.default).prototype.hsv = function() {
    return (0, $bNsTS.default)(this._rgb);
};
const $b1334dfd7e9194d6$export$a5d7c789f12d2213 = (...args)=>new (0, $9WhDB.default)(...args, 'hsv');
(0, $4dsSs.default).hsv = $b1334dfd7e9194d6$export$a5d7c789f12d2213;
(0, $cio9q.default).format.hsv = (0, $eMAah.default);
(0, $cio9q.default).autodetect.push({
    p: 2,
    test: (...args)=>{
        args = (0, $6IMpB.default)(args, 'hsv');
        if ((0, $rAKRV.default)(args) === 'array' && args.length === 3) return 'hsv';
    }
});

});
parcelRegister("eMAah", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac3199f94bdda45d$export$2e2bcd8739ae039);
parcelRequire("f8COF");
var $6IMpB = parcelRequire("6IMpB");
const { floor: $ac3199f94bdda45d$var$floor } = Math;
const $ac3199f94bdda45d$var$hsv2rgb = (...args)=>{
    args = (0, $6IMpB.default)(args, 'hsv');
    let [h, s, v] = args;
    let r, g, b;
    v *= 255;
    if (s === 0) r = g = b = v;
    else {
        if (h === 360) h = 0;
        if (h > 360) h -= 360;
        if (h < 0) h += 360;
        h /= 60;
        const i = $ac3199f94bdda45d$var$floor(h);
        const f = h - i;
        const p = v * (1 - s);
        const q = v * (1 - s * f);
        const t = v * (1 - s * (1 - f));
        switch(i){
            case 0:
                [r, g, b] = [
                    v,
                    t,
                    p
                ];
                break;
            case 1:
                [r, g, b] = [
                    q,
                    v,
                    p
                ];
                break;
            case 2:
                [r, g, b] = [
                    p,
                    v,
                    t
                ];
                break;
            case 3:
                [r, g, b] = [
                    p,
                    q,
                    v
                ];
                break;
            case 4:
                [r, g, b] = [
                    t,
                    p,
                    v
                ];
                break;
            case 5:
                [r, g, b] = [
                    v,
                    p,
                    q
                ];
                break;
        }
    }
    return [
        r,
        g,
        b,
        args.length > 3 ? args[3] : 1
    ];
};
var $ac3199f94bdda45d$export$2e2bcd8739ae039 = $ac3199f94bdda45d$var$hsv2rgb;

});

parcelRegister("bNsTS", function(module, exports) {

$parcel$export(module.exports, "default", () => $896ab0507911ba53$export$2e2bcd8739ae039);
parcelRequire("f8COF");
var $6IMpB = parcelRequire("6IMpB");
const { min: $896ab0507911ba53$var$min, max: $896ab0507911ba53$var$max } = Math;
/*
 * supported arguments:
 * - rgb2hsv(r,g,b)
 * - rgb2hsv([r,g,b])
 * - rgb2hsv({r,g,b})
 */ const $896ab0507911ba53$var$rgb2hsl = (...args)=>{
    args = (0, $6IMpB.default)(args, 'rgb');
    let [r, g, b] = args;
    const min_ = $896ab0507911ba53$var$min(r, g, b);
    const max_ = $896ab0507911ba53$var$max(r, g, b);
    const delta = max_ - min_;
    let h, s, v;
    v = max_ / 255.0;
    if (max_ === 0) {
        h = Number.NaN;
        s = 0;
    } else {
        s = delta / max_;
        if (r === max_) h = (g - b) / delta;
        if (g === max_) h = 2 + (b - r) / delta;
        if (b === max_) h = 4 + (r - g) / delta;
        h *= 60;
        if (h < 0) h += 360;
    }
    return [
        h,
        s,
        v
    ];
};
var $896ab0507911ba53$export$2e2bcd8739ae039 = $896ab0507911ba53$var$rgb2hsl;

});



parcelRegister("cxd0G", function(module, exports) {
parcelRequire("6p5Hh");

var $44zyK = parcelRequire("44zyK");

var $9WhDB = parcelRequire("9WhDB");
const $9202a8a2aba98a5f$var$oklab = (col1, col2, f)=>{
    const xyz0 = col1.oklab();
    const xyz1 = col2.oklab();
    return new (0, $9WhDB.default)(xyz0[0] + f * (xyz1[0] - xyz0[0]), xyz0[1] + f * (xyz1[1] - xyz0[1]), xyz0[2] + f * (xyz1[2] - xyz0[2]), 'oklab');
};
// register interpolator
(0, $44zyK.default).oklab = $9202a8a2aba98a5f$var$oklab;
var $9202a8a2aba98a5f$export$2e2bcd8739ae039 = $9202a8a2aba98a5f$var$oklab;

});
parcelRegister("6p5Hh", function(module, exports) {
parcelRequire("f8COF");
var $rAKRV = parcelRequire("rAKRV");
var $6IMpB = parcelRequire("6IMpB");

var $4dsSs = parcelRequire("4dsSs");

var $9WhDB = parcelRequire("9WhDB");

var $cio9q = parcelRequire("cio9q");

var $7rWyE = parcelRequire("7rWyE");

var $44muf = parcelRequire("44muf");
(0, $9WhDB.default).prototype.oklab = function() {
    return (0, $44muf.default)(this._rgb);
};
const $4a997f3203977e6d$export$b14b17e4e916d621 = (...args)=>new (0, $9WhDB.default)(...args, 'oklab');
Object.assign((0, $4dsSs.default), {
    oklab: $4a997f3203977e6d$export$b14b17e4e916d621
});
(0, $cio9q.default).format.oklab = (0, $7rWyE.default);
(0, $cio9q.default).autodetect.push({
    p: 2,
    test: (...args)=>{
        args = (0, $6IMpB.default)(args, 'oklab');
        if ((0, $rAKRV.default)(args) === 'array' && args.length === 3) return 'oklab';
    }
});

});
parcelRegister("7rWyE", function(module, exports) {

$parcel$export(module.exports, "default", () => $56c87a69f80a33b0$export$2e2bcd8739ae039);
parcelRequire("f8COF");
var $6IMpB = parcelRequire("6IMpB");

var $dxbe3 = parcelRequire("dxbe3");

var $1e9qI = parcelRequire("1e9qI");
const $56c87a69f80a33b0$var$oklab2rgb = (...args)=>{
    args = (0, $6IMpB.default)(args, 'lab');
    const [L, a, b, ...rest] = args;
    const [X, Y, Z] = $56c87a69f80a33b0$var$OKLab_to_XYZ([
        L,
        a,
        b
    ]);
    const [r, g, b_] = (0, $1e9qI.xyz2rgb)(X, Y, Z);
    return [
        r,
        g,
        b_,
        ...rest.length > 0 && rest[0] < 1 ? [
            rest[0]
        ] : []
    ];
};
// from https://www.w3.org/TR/css-color-4/#color-conversion-code
function $56c87a69f80a33b0$var$OKLab_to_XYZ(OKLab) {
    // Given OKLab, convert to XYZ relative to D65
    var LMStoXYZ = [
        [
            1.2268798758459243,
            -0.5578149944602171,
            0.2813910456659647
        ],
        [
            -0.0405757452148008,
            1.112286803280317,
            -0.0717110580655164
        ],
        [
            -0.0763729366746601,
            -0.4214933324022432,
            1.5869240198367816
        ]
    ];
    var OKLabtoLMS = [
        [
            1.0,
            0.3963377773761749,
            0.2158037573099136
        ],
        [
            1.0,
            -0.1055613458156586,
            -0.0638541728258133
        ],
        [
            1.0,
            -0.0894841775298119,
            -1.2914855480194092
        ]
    ];
    var LMSnl = (0, $dxbe3.default)(OKLabtoLMS, OKLab);
    return (0, $dxbe3.default)(LMStoXYZ, LMSnl.map((c)=>c ** 3));
}
var $56c87a69f80a33b0$export$2e2bcd8739ae039 = $56c87a69f80a33b0$var$oklab2rgb;

});
parcelRegister("dxbe3", function(module, exports) {

$parcel$export(module.exports, "default", () => $9da7109f3764a875$export$2e2bcd8739ae039);
// from https://www.w3.org/TR/css-color-4/multiply-matrices.js
function $9da7109f3764a875$export$2e2bcd8739ae039(A, B) {
    let m = A.length;
    if (!Array.isArray(A[0])) // A is vector, convert to [[a, b, c, ...]]
    A = [
        A
    ];
    if (!Array.isArray(B[0])) // B is vector, convert to [[a], [b], [c], ...]]
    B = B.map((x)=>[
            x
        ]);
    let p = B[0].length;
    let B_cols = B[0].map((_, i)=>B.map((x)=>x[i])); // transpose B
    let product = A.map((row)=>B_cols.map((col)=>{
            if (!Array.isArray(row)) return col.reduce((a, c)=>a + c * row, 0);
            return row.reduce((a, c, i)=>a + c * (col[i] || 0), 0);
        }));
    if (m === 1) product = product[0]; // Avoid [[a, b, c, ...]]
    if (p === 1) return product.map((x)=>x[0]); // Avoid [[a], [b], [c], ...]]
    return product;
}

});


parcelRegister("44muf", function(module, exports) {

$parcel$export(module.exports, "default", () => $2f68fa8e6563926b$export$2e2bcd8739ae039);
parcelRequire("f8COF");
var $6IMpB = parcelRequire("6IMpB");

var $dxbe3 = parcelRequire("dxbe3");

var $a62iy = parcelRequire("a62iy");
const $2f68fa8e6563926b$var$rgb2oklab = (...args)=>{
    const [r, g, b, ...rest] = (0, $6IMpB.default)(args, 'rgb');
    const xyz = (0, $a62iy.rgb2xyz)(r, g, b);
    const oklab = $2f68fa8e6563926b$var$XYZ_to_OKLab(xyz);
    return [
        ...oklab,
        ...rest.length > 0 && rest[0] < 1 ? [
            rest[0]
        ] : []
    ];
};
// from https://www.w3.org/TR/css-color-4/#color-conversion-code
function $2f68fa8e6563926b$var$XYZ_to_OKLab(XYZ) {
    // Given XYZ relative to D65, convert to OKLab
    const XYZtoLMS = [
        [
            0.819022437996703,
            0.3619062600528904,
            -0.1288737815209879
        ],
        [
            0.0329836539323885,
            0.9292868615863434,
            0.0361446663506424
        ],
        [
            0.0481771893596242,
            0.2642395317527308,
            0.6335478284694309
        ]
    ];
    const LMStoOKLab = [
        [
            0.210454268309314,
            0.7936177747023054,
            -0.0040720430116193
        ],
        [
            1.9779985324311684,
            -2.42859224204858,
            0.450593709617411
        ],
        [
            0.0259040424655478,
            0.7827717124575296,
            -0.8086757549230774
        ]
    ];
    const LMS = (0, $dxbe3.default)(XYZtoLMS, XYZ);
    // JavaScript Math.cbrt returns a sign-matched cube root
    // beware if porting to other languages
    // especially if tempted to use a general power function
    return (0, $dxbe3.default)(LMStoOKLab, LMS.map((c)=>Math.cbrt(c)));
// L in range [0,1]. For use in CSS, multiply by 100 and add a percent
}
var $2f68fa8e6563926b$export$2e2bcd8739ae039 = $2f68fa8e6563926b$var$rgb2oklab;

});



parcelRegister("dnbKS", function(module, exports) {
parcelRequire("6YXfw");

var $ktl6m = parcelRequire("ktl6m");

var $44zyK = parcelRequire("44zyK");
const $9bc68aa2e5b3e350$var$oklch = (col1, col2, f)=>{
    return (0, $ktl6m.default)(col1, col2, f, 'oklch');
};
// register interpolator
(0, $44zyK.default).oklch = $9bc68aa2e5b3e350$var$oklch;
var $9bc68aa2e5b3e350$export$2e2bcd8739ae039 = $9bc68aa2e5b3e350$var$oklch;

});

parcelRegister("1CpZi", function(module, exports) {

$parcel$export(module.exports, "default", () => $12dd7fa91b00d6d8$export$2e2bcd8739ae039);

var $9WhDB = parcelRequire("9WhDB");
parcelRequire("f8COF");
var $iMJbA = parcelRequire("iMJbA");
const { pow: $12dd7fa91b00d6d8$var$pow, sqrt: $12dd7fa91b00d6d8$var$sqrt, PI: $12dd7fa91b00d6d8$var$PI, cos: $12dd7fa91b00d6d8$var$cos, sin: $12dd7fa91b00d6d8$var$sin, atan2: $12dd7fa91b00d6d8$var$atan2 } = Math;
var $12dd7fa91b00d6d8$export$2e2bcd8739ae039 = (colors, mode = 'lrgb', weights = null)=>{
    const l = colors.length;
    if (!weights) weights = Array.from(new Array(l)).map(()=>1);
    // normalize weights
    const k = l / weights.reduce(function(a, b) {
        return a + b;
    });
    weights.forEach((w, i)=>{
        weights[i] *= k;
    });
    // convert colors to Color objects
    colors = colors.map((c)=>new (0, $9WhDB.default)(c));
    if (mode === 'lrgb') return $12dd7fa91b00d6d8$var$_average_lrgb(colors, weights);
    const first = colors.shift();
    const xyz = first.get(mode);
    const cnt = [];
    let dx = 0;
    let dy = 0;
    // initial color
    for(let i = 0; i < xyz.length; i++){
        xyz[i] = (xyz[i] || 0) * weights[0];
        cnt.push(isNaN(xyz[i]) ? 0 : weights[0]);
        if (mode.charAt(i) === 'h' && !isNaN(xyz[i])) {
            const A = xyz[i] / 180 * $12dd7fa91b00d6d8$var$PI;
            dx += $12dd7fa91b00d6d8$var$cos(A) * weights[0];
            dy += $12dd7fa91b00d6d8$var$sin(A) * weights[0];
        }
    }
    let alpha = first.alpha() * weights[0];
    colors.forEach((c, ci)=>{
        const xyz2 = c.get(mode);
        alpha += c.alpha() * weights[ci + 1];
        for(let i = 0; i < xyz.length; i++)if (!isNaN(xyz2[i])) {
            cnt[i] += weights[ci + 1];
            if (mode.charAt(i) === 'h') {
                const A = xyz2[i] / 180 * $12dd7fa91b00d6d8$var$PI;
                dx += $12dd7fa91b00d6d8$var$cos(A) * weights[ci + 1];
                dy += $12dd7fa91b00d6d8$var$sin(A) * weights[ci + 1];
            } else xyz[i] += xyz2[i] * weights[ci + 1];
        }
    });
    for(let i = 0; i < xyz.length; i++)if (mode.charAt(i) === 'h') {
        let A = $12dd7fa91b00d6d8$var$atan2(dy / cnt[i], dx / cnt[i]) / $12dd7fa91b00d6d8$var$PI * 180;
        while(A < 0)A += 360;
        while(A >= 360)A -= 360;
        xyz[i] = A;
    } else xyz[i] = xyz[i] / cnt[i];
    alpha /= l;
    return new (0, $9WhDB.default)(xyz, mode).alpha(alpha > 0.99999 ? 1 : alpha, true);
};
const $12dd7fa91b00d6d8$var$_average_lrgb = (colors, weights)=>{
    const l = colors.length;
    const xyz = [
        0,
        0,
        0,
        0
    ];
    for(let i = 0; i < colors.length; i++){
        const col = colors[i];
        const f = weights[i] / l;
        const rgb = col._rgb;
        xyz[0] += $12dd7fa91b00d6d8$var$pow(rgb[0], 2) * f;
        xyz[1] += $12dd7fa91b00d6d8$var$pow(rgb[1], 2) * f;
        xyz[2] += $12dd7fa91b00d6d8$var$pow(rgb[2], 2) * f;
        xyz[3] += rgb[3] * f;
    }
    xyz[0] = $12dd7fa91b00d6d8$var$sqrt(xyz[0]);
    xyz[1] = $12dd7fa91b00d6d8$var$sqrt(xyz[1]);
    xyz[2] = $12dd7fa91b00d6d8$var$sqrt(xyz[2]);
    if (xyz[3] > 0.9999999) xyz[3] = 1;
    return new (0, $9WhDB.default)((0, $iMJbA.default)(xyz));
};

});

parcelRegister("h8ENh", function(module, exports) {

$parcel$export(module.exports, "default", () => $c7a2d3d03020c6d6$export$2e2bcd8739ae039);
//
// interpolates between a set of colors uzing a bezier spline
//
// @requires utils lab

var $9WhDB = parcelRequire("9WhDB");
parcelRequire("gdTSI");

var $39JHd = parcelRequire("39JHd");
// nth row of the pascal triangle
const $c7a2d3d03020c6d6$var$binom_row = function(n) {
    let row = [
        1,
        1
    ];
    for(let i = 1; i < n; i++){
        let newrow = [
            1
        ];
        for(let j = 1; j <= row.length; j++)newrow[j] = (row[j] || 0) + row[j - 1];
        row = newrow;
    }
    return row;
};
const $c7a2d3d03020c6d6$var$bezier = function(colors) {
    let I, lab0, lab1, lab2;
    colors = colors.map((c)=>new (0, $9WhDB.default)(c));
    if (colors.length === 2) {
        // linear interpolation
        [lab0, lab1] = colors.map((c)=>c.lab());
        I = function(t) {
            const lab = [
                0,
                1,
                2
            ].map((i)=>lab0[i] + t * (lab1[i] - lab0[i]));
            return new (0, $9WhDB.default)(lab, 'lab');
        };
    } else if (colors.length === 3) {
        // quadratic bezier interpolation
        [lab0, lab1, lab2] = colors.map((c)=>c.lab());
        I = function(t) {
            const lab = [
                0,
                1,
                2
            ].map((i)=>(1 - t) * (1 - t) * lab0[i] + 2 * (1 - t) * t * lab1[i] + t * t * lab2[i]);
            return new (0, $9WhDB.default)(lab, 'lab');
        };
    } else if (colors.length === 4) {
        // cubic bezier interpolation
        let lab3;
        [lab0, lab1, lab2, lab3] = colors.map((c)=>c.lab());
        I = function(t) {
            const lab = [
                0,
                1,
                2
            ].map((i)=>(1 - t) * (1 - t) * (1 - t) * lab0[i] + 3 * (1 - t) * (1 - t) * t * lab1[i] + 3 * (1 - t) * t * t * lab2[i] + t * t * t * lab3[i]);
            return new (0, $9WhDB.default)(lab, 'lab');
        };
    } else if (colors.length >= 5) {
        // general case (degree n bezier)
        let labs, row, n;
        labs = colors.map((c)=>c.lab());
        n = colors.length - 1;
        row = $c7a2d3d03020c6d6$var$binom_row(n);
        I = function(t) {
            const u = 1 - t;
            const lab = [
                0,
                1,
                2
            ].map((i)=>labs.reduce((sum, el, j)=>sum + row[j] * u ** (n - j) * t ** j * el[i], 0));
            return new (0, $9WhDB.default)(lab, 'lab');
        };
    } else throw new RangeError('No point in running bezier with only one color.');
    return I;
};
var $c7a2d3d03020c6d6$export$2e2bcd8739ae039 = (colors)=>{
    const f = $c7a2d3d03020c6d6$var$bezier(colors);
    f.scale = ()=>(0, $39JHd.default)(f);
    return f;
};

});
parcelRegister("39JHd", function(module, exports) {

$parcel$export(module.exports, "default", () => $24c5a8a3d239afb3$export$2e2bcd8739ae039);
// minimal multi-purpose interface
// @requires utils color analyze

var $4dsSs = parcelRequire("4dsSs");
parcelRequire("f8COF");
var $eeze8 = parcelRequire("eeze8");
var $rAKRV = parcelRequire("rAKRV");
const { pow: $24c5a8a3d239afb3$var$pow } = Math;
function $24c5a8a3d239afb3$export$2e2bcd8739ae039(colors) {
    // constructor
    let _mode = 'rgb';
    let _nacol = (0, $4dsSs.default)('#ccc');
    let _spread = 0;
    // const _fixed = false;
    let _domain = [
        0,
        1
    ];
    let _pos = [];
    let _padding = [
        0,
        0
    ];
    let _classes = false;
    let _colors = [];
    let _out = false;
    let _min = 0;
    let _max = 1;
    let _correctLightness = false;
    let _colorCache = {};
    let _useCache = true;
    let _gamma = 1;
    // private methods
    const setColors = function(colors) {
        colors = colors || [
            '#fff',
            '#000'
        ];
        if (colors && (0, $rAKRV.default)(colors) === 'string' && (0, $4dsSs.default).brewer && (0, $4dsSs.default).brewer[colors.toLowerCase()]) colors = (0, $4dsSs.default).brewer[colors.toLowerCase()];
        if ((0, $rAKRV.default)(colors) === 'array') {
            // handle single color
            if (colors.length === 1) colors = [
                colors[0],
                colors[0]
            ];
            // make a copy of the colors
            colors = colors.slice(0);
            // convert to chroma classes
            for(let c = 0; c < colors.length; c++)colors[c] = (0, $4dsSs.default)(colors[c]);
            // auto-fill color position
            _pos.length = 0;
            for(let c = 0; c < colors.length; c++)_pos.push(c / (colors.length - 1));
        }
        resetCache();
        return _colors = colors;
    };
    const getClass = function(value) {
        if (_classes != null) {
            const n = _classes.length - 1;
            let i = 0;
            while(i < n && value >= _classes[i])i++;
            return i - 1;
        }
        return 0;
    };
    let tMapLightness = (t)=>t;
    let tMapDomain = (t)=>t;
    // const classifyValue = function(value) {
    //     let val = value;
    //     if (_classes.length > 2) {
    //         const n = _classes.length-1;
    //         const i = getClass(value);
    //         const minc = _classes[0] + ((_classes[1]-_classes[0]) * (0 + (_spread * 0.5)));  // center of 1st class
    //         const maxc = _classes[n-1] + ((_classes[n]-_classes[n-1]) * (1 - (_spread * 0.5)));  // center of last class
    //         val = _min + ((((_classes[i] + ((_classes[i+1] - _classes[i]) * 0.5)) - minc) / (maxc-minc)) * (_max - _min));
    //     }
    //     return val;
    // };
    const getColor = function(val, bypassMap) {
        let col, t;
        if (bypassMap == null) bypassMap = false;
        if (isNaN(val) || val === null) return _nacol;
        if (!bypassMap) {
            if (_classes && _classes.length > 2) {
                // find the class
                const c = getClass(val);
                t = c / (_classes.length - 2);
            } else if (_max !== _min) // just interpolate between min/max
            t = (val - _min) / (_max - _min);
            else t = 1;
        } else t = val;
        // domain map
        t = tMapDomain(t);
        if (!bypassMap) t = tMapLightness(t); // lightness correction
        if (_gamma !== 1) t = $24c5a8a3d239afb3$var$pow(t, _gamma);
        t = _padding[0] + t * (1 - _padding[0] - _padding[1]);
        t = (0, $eeze8.default)(t, 0, 1);
        const k = Math.floor(t * 10000);
        if (_useCache && _colorCache[k]) col = _colorCache[k];
        else {
            if ((0, $rAKRV.default)(_colors) === 'array') //for i in [0.._pos.length-1]
            for(let i = 0; i < _pos.length; i++){
                const p = _pos[i];
                if (t <= p) {
                    col = _colors[i];
                    break;
                }
                if (t >= p && i === _pos.length - 1) {
                    col = _colors[i];
                    break;
                }
                if (t > p && t < _pos[i + 1]) {
                    t = (t - p) / (_pos[i + 1] - p);
                    col = (0, $4dsSs.default).interpolate(_colors[i], _colors[i + 1], t, _mode);
                    break;
                }
            }
            else if ((0, $rAKRV.default)(_colors) === 'function') col = _colors(t);
            if (_useCache) _colorCache[k] = col;
        }
        return col;
    };
    var resetCache = ()=>_colorCache = {};
    setColors(colors);
    // public interface
    const f = function(v) {
        const c = (0, $4dsSs.default)(getColor(v));
        if (_out && c[_out]) return c[_out]();
        else return c;
    };
    f.classes = function(classes) {
        if (classes != null) {
            if ((0, $rAKRV.default)(classes) === 'array') {
                _classes = classes;
                _domain = [
                    classes[0],
                    classes[classes.length - 1]
                ];
            } else {
                const d = (0, $4dsSs.default).analyze(_domain);
                if (classes === 0) _classes = [
                    d.min,
                    d.max
                ];
                else _classes = (0, $4dsSs.default).limits(d, 'e', classes);
            }
            return f;
        }
        return _classes;
    };
    f.domain = function(domain) {
        if (!arguments.length) return _domain;
        _min = domain[0];
        _max = domain[domain.length - 1];
        _pos = [];
        const k = _colors.length;
        if (domain.length === k && _min !== _max) // update positions
        for (let d of Array.from(domain))_pos.push((d - _min) / (_max - _min));
        else {
            for(let c = 0; c < k; c++)_pos.push(c / (k - 1));
            if (domain.length > 2) {
                // set domain map
                const tOut = domain.map((d, i)=>i / (domain.length - 1));
                const tBreaks = domain.map((d)=>(d - _min) / (_max - _min));
                if (!tBreaks.every((val, i)=>tOut[i] === val)) tMapDomain = (t)=>{
                    if (t <= 0 || t >= 1) return t;
                    let i = 0;
                    while(t >= tBreaks[i + 1])i++;
                    const f = (t - tBreaks[i]) / (tBreaks[i + 1] - tBreaks[i]);
                    const out = tOut[i] + f * (tOut[i + 1] - tOut[i]);
                    return out;
                };
            }
        }
        _domain = [
            _min,
            _max
        ];
        return f;
    };
    f.mode = function(_m) {
        if (!arguments.length) return _mode;
        _mode = _m;
        resetCache();
        return f;
    };
    f.range = function(colors, _pos) {
        setColors(colors, _pos);
        return f;
    };
    f.out = function(_o) {
        _out = _o;
        return f;
    };
    f.spread = function(val) {
        if (!arguments.length) return _spread;
        _spread = val;
        return f;
    };
    f.correctLightness = function(v) {
        if (v == null) v = true;
        _correctLightness = v;
        resetCache();
        if (_correctLightness) tMapLightness = function(t) {
            const L0 = getColor(0, true).lab()[0];
            const L1 = getColor(1, true).lab()[0];
            const pol = L0 > L1;
            let L_actual = getColor(t, true).lab()[0];
            const L_ideal = L0 + (L1 - L0) * t;
            let L_diff = L_actual - L_ideal;
            let t0 = 0;
            let t1 = 1;
            let max_iter = 20;
            while(Math.abs(L_diff) > 1e-2 && max_iter-- > 0)(function() {
                if (pol) L_diff *= -1;
                if (L_diff < 0) {
                    t0 = t;
                    t += (t1 - t) * 0.5;
                } else {
                    t1 = t;
                    t += (t0 - t) * 0.5;
                }
                L_actual = getColor(t, true).lab()[0];
                return L_diff = L_actual - L_ideal;
            })();
            return t;
        };
        else tMapLightness = (t)=>t;
        return f;
    };
    f.padding = function(p) {
        if (p != null) {
            if ((0, $rAKRV.default)(p) === 'number') p = [
                p,
                p
            ];
            _padding = p;
            return f;
        } else return _padding;
    };
    f.colors = function(numColors, out) {
        // If no arguments are given, return the original colors that were provided
        if (arguments.length < 2) out = 'hex';
        let result = [];
        if (arguments.length === 0) result = _colors.slice(0);
        else if (numColors === 1) result = [
            f(0.5)
        ];
        else if (numColors > 1) {
            const dm = _domain[0];
            const dd = _domain[1] - dm;
            result = $24c5a8a3d239afb3$var$__range__(0, numColors, false).map((i)=>f(dm + i / (numColors - 1) * dd));
        } else {
            // returns all colors based on the defined classes
            colors = [];
            let samples = [];
            if (_classes && _classes.length > 2) for(let i = 1, end = _classes.length, asc = 1 <= end; asc ? i < end : i > end; asc ? i++ : i--)samples.push((_classes[i - 1] + _classes[i]) * 0.5);
            else samples = _domain;
            result = samples.map((v)=>f(v));
        }
        if ((0, $4dsSs.default)[out]) result = result.map((c)=>c[out]());
        return result;
    };
    f.cache = function(c) {
        if (c != null) {
            _useCache = c;
            return f;
        } else return _useCache;
    };
    f.gamma = function(g) {
        if (g != null) {
            _gamma = g;
            return f;
        } else return _gamma;
    };
    f.nodata = function(d) {
        if (d != null) {
            _nacol = (0, $4dsSs.default)(d);
            return f;
        } else return _nacol;
    };
    return f;
}
function $24c5a8a3d239afb3$var$__range__(left, right, inclusive) {
    let range = [];
    let ascending = left < right;
    let end = !inclusive ? right : ascending ? right + 1 : right - 1;
    for(let i = left; ascending ? i < end : i > end; ascending ? i++ : i--)range.push(i);
    return range;
}

});


parcelRegister("4HYka", function(module, exports) {

$parcel$export(module.exports, "default", () => $36d9f8b7360a85ad$export$2e2bcd8739ae039);
/*
 * interpolates between a set of colors uzing a bezier spline
 * blend mode formulas taken from https://web.archive.org/web/20180110014946/http://www.venture-ware.com/kevin/coding/lets-learn-math-photoshop-blend-modes/
 */ parcelRequire("as1AR");

var $4dsSs = parcelRequire("4dsSs");
const $36d9f8b7360a85ad$var$blend = (bottom, top, mode)=>{
    if (!$36d9f8b7360a85ad$var$blend[mode]) throw new Error('unknown blend mode ' + mode);
    return $36d9f8b7360a85ad$var$blend[mode](bottom, top);
};
const $36d9f8b7360a85ad$var$blend_f = (f)=>(bottom, top)=>{
        const c0 = (0, $4dsSs.default)(top).rgb();
        const c1 = (0, $4dsSs.default)(bottom).rgb();
        return (0, $4dsSs.default).rgb(f(c0, c1));
    };
const $36d9f8b7360a85ad$var$each = (f)=>(c0, c1)=>{
        const out = [];
        out[0] = f(c0[0], c1[0]);
        out[1] = f(c0[1], c1[1]);
        out[2] = f(c0[2], c1[2]);
        return out;
    };
const $36d9f8b7360a85ad$var$normal = (a)=>a;
const $36d9f8b7360a85ad$var$multiply = (a, b)=>a * b / 255;
const $36d9f8b7360a85ad$var$darken = (a, b)=>a > b ? b : a;
const $36d9f8b7360a85ad$var$lighten = (a, b)=>a > b ? a : b;
const $36d9f8b7360a85ad$var$screen = (a, b)=>255 * (1 - (1 - a / 255) * (1 - b / 255));
const $36d9f8b7360a85ad$var$overlay = (a, b)=>b < 128 ? 2 * a * b / 255 : 255 * (1 - 2 * (1 - a / 255) * (1 - b / 255));
const $36d9f8b7360a85ad$var$burn = (a, b)=>255 * (1 - (1 - b / 255) / (a / 255));
const $36d9f8b7360a85ad$var$dodge = (a, b)=>{
    if (a === 255) return 255;
    a = 255 * (b / 255) / (1 - a / 255);
    return a > 255 ? 255 : a;
};
// # add = (a,b) ->
// #     if (a + b > 255) then 255 else a + b
$36d9f8b7360a85ad$var$blend.normal = $36d9f8b7360a85ad$var$blend_f($36d9f8b7360a85ad$var$each($36d9f8b7360a85ad$var$normal));
$36d9f8b7360a85ad$var$blend.multiply = $36d9f8b7360a85ad$var$blend_f($36d9f8b7360a85ad$var$each($36d9f8b7360a85ad$var$multiply));
$36d9f8b7360a85ad$var$blend.screen = $36d9f8b7360a85ad$var$blend_f($36d9f8b7360a85ad$var$each($36d9f8b7360a85ad$var$screen));
$36d9f8b7360a85ad$var$blend.overlay = $36d9f8b7360a85ad$var$blend_f($36d9f8b7360a85ad$var$each($36d9f8b7360a85ad$var$overlay));
$36d9f8b7360a85ad$var$blend.darken = $36d9f8b7360a85ad$var$blend_f($36d9f8b7360a85ad$var$each($36d9f8b7360a85ad$var$darken));
$36d9f8b7360a85ad$var$blend.lighten = $36d9f8b7360a85ad$var$blend_f($36d9f8b7360a85ad$var$each($36d9f8b7360a85ad$var$lighten));
$36d9f8b7360a85ad$var$blend.dodge = $36d9f8b7360a85ad$var$blend_f($36d9f8b7360a85ad$var$each($36d9f8b7360a85ad$var$dodge));
$36d9f8b7360a85ad$var$blend.burn = $36d9f8b7360a85ad$var$blend_f($36d9f8b7360a85ad$var$each($36d9f8b7360a85ad$var$burn));
var // blend.add = blend_f(each(add));
$36d9f8b7360a85ad$export$2e2bcd8739ae039 = $36d9f8b7360a85ad$var$blend;

});
parcelRegister("as1AR", function(module, exports) {

var $4dsSs = parcelRequire("4dsSs");

var $9WhDB = parcelRequire("9WhDB");

var $cio9q = parcelRequire("cio9q");
parcelRequire("f8COF");
var $rAKRV = parcelRequire("rAKRV");
var $6IMpB = parcelRequire("6IMpB");
const { round: $79bdc158fc708d5b$var$round } = Math;
(0, $9WhDB.default).prototype.rgb = function(rnd = true) {
    if (rnd === false) return this._rgb.slice(0, 3);
    return this._rgb.slice(0, 3).map($79bdc158fc708d5b$var$round);
};
(0, $9WhDB.default).prototype.rgba = function(rnd = true) {
    return this._rgb.slice(0, 4).map((v, i)=>{
        return i < 3 ? rnd === false ? v : $79bdc158fc708d5b$var$round(v) : v;
    });
};
const $79bdc158fc708d5b$export$8972dc0e6ad9238f = (...args)=>new (0, $9WhDB.default)(...args, 'rgb');
Object.assign((0, $4dsSs.default), {
    rgb: $79bdc158fc708d5b$export$8972dc0e6ad9238f
});
(0, $cio9q.default).format.rgb = (...args)=>{
    const rgba = (0, $6IMpB.default)(args, 'rgba');
    if (rgba[3] === undefined) rgba[3] = 1;
    return rgba;
};
(0, $cio9q.default).autodetect.push({
    p: 3,
    test: (...args)=>{
        args = (0, $6IMpB.default)(args, 'rgba');
        if ((0, $rAKRV.default)(args) === 'array' && (args.length === 3 || args.length === 4 && (0, $rAKRV.default)(args[3]) == 'number' && args[3] >= 0 && args[3] <= 1)) return 'rgb';
    }
});

});


parcelRegister("b2lDa", function(module, exports) {

$parcel$export(module.exports, "default", () => $8090a903719cad5a$export$2e2bcd8739ae039);
// cubehelix interpolation
// based on D.A. Green "A colour scheme for the display of astronomical intensity images"
// http://astron-soc.in/bulletin/11June/289392011.pdf
parcelRequire("f8COF");
var $iMJbA = parcelRequire("iMJbA");
var $f8COF = parcelRequire("f8COF");
var $rAKRV = parcelRequire("rAKRV");

var $4dsSs = parcelRequire("4dsSs");
const { pow: $8090a903719cad5a$var$pow, sin: $8090a903719cad5a$var$sin, cos: $8090a903719cad5a$var$cos } = Math;
function $8090a903719cad5a$export$2e2bcd8739ae039(start = 300, rotations = -1.5, hue = 1, gamma = 1, lightness = [
    0,
    1
]) {
    let dh = 0, dl;
    if ((0, $rAKRV.default)(lightness) === 'array') dl = lightness[1] - lightness[0];
    else {
        dl = 0;
        lightness = [
            lightness,
            lightness
        ];
    }
    const f = function(fract) {
        const a = (0, $f8COF.TWOPI) * ((start + 120) / 360 + rotations * fract);
        const l = $8090a903719cad5a$var$pow(lightness[0] + dl * fract, gamma);
        const h = dh !== 0 ? hue[0] + fract * dh : hue;
        const amp = h * l * (1 - l) / 2;
        const cos_a = $8090a903719cad5a$var$cos(a);
        const sin_a = $8090a903719cad5a$var$sin(a);
        const r = l + amp * (-0.14861 * cos_a + 1.78277 * sin_a);
        const g = l + amp * (-0.29227 * cos_a - 0.90649 * sin_a);
        const b = l + amp * (1.97294 * cos_a);
        return (0, $4dsSs.default)((0, $iMJbA.default)([
            r * 255,
            g * 255,
            b * 255,
            1
        ]));
    };
    f.start = function(s) {
        if (s == null) return start;
        start = s;
        return f;
    };
    f.rotations = function(r) {
        if (r == null) return rotations;
        rotations = r;
        return f;
    };
    f.gamma = function(g) {
        if (g == null) return gamma;
        gamma = g;
        return f;
    };
    f.hue = function(h) {
        if (h == null) return hue;
        hue = h;
        if ((0, $rAKRV.default)(hue) === 'array') {
            dh = hue[1] - hue[0];
            if (dh === 0) hue = hue[1];
        } else dh = 0;
        return f;
    };
    f.lightness = function(h) {
        if (h == null) return lightness;
        if ((0, $rAKRV.default)(h) === 'array') {
            lightness = h;
            dl = h[1] - h[0];
        } else {
            lightness = [
                h,
                h
            ];
            dl = 0;
        }
        return f;
    };
    f.scale = ()=>(0, $4dsSs.default).scale(f);
    f.hue(hue);
    return f;
}

});

parcelRegister("ciHx9", function(module, exports) {

$parcel$export(module.exports, "default", () => $8f48ef595c9cfd89$export$2e2bcd8739ae039);

var $9WhDB = parcelRequire("9WhDB");
const $8f48ef595c9cfd89$var$digits = '0123456789abcdef';
const { floor: $8f48ef595c9cfd89$var$floor, random: $8f48ef595c9cfd89$var$random } = Math;
var $8f48ef595c9cfd89$export$2e2bcd8739ae039 = ()=>{
    let code = '#';
    for(let i = 0; i < 6; i++)code += $8f48ef595c9cfd89$var$digits.charAt($8f48ef595c9cfd89$var$floor($8f48ef595c9cfd89$var$random() * 16));
    return new (0, $9WhDB.default)(code, 'hex');
};

});

parcelRegister("dnDjJ", function(module, exports) {

$parcel$export(module.exports, "analyze", () => $9bdbebf464fb72d3$export$7cbcccfbecde6416);
$parcel$export(module.exports, "limits", () => $9bdbebf464fb72d3$export$e331ca4ad6a82555);

var $rAKRV = parcelRequire("rAKRV");
const { log: $9bdbebf464fb72d3$var$log, pow: $9bdbebf464fb72d3$var$pow, floor: $9bdbebf464fb72d3$var$floor, abs: $9bdbebf464fb72d3$var$abs } = Math;
function $9bdbebf464fb72d3$export$7cbcccfbecde6416(data, key = null) {
    const r = {
        min: Number.MAX_VALUE,
        max: Number.MAX_VALUE * -1,
        sum: 0,
        values: [],
        count: 0
    };
    if ((0, $rAKRV.default)(data) === 'object') data = Object.values(data);
    data.forEach((val)=>{
        if (key && (0, $rAKRV.default)(val) === 'object') val = val[key];
        if (val !== undefined && val !== null && !isNaN(val)) {
            r.values.push(val);
            r.sum += val;
            if (val < r.min) r.min = val;
            if (val > r.max) r.max = val;
            r.count += 1;
        }
    });
    r.domain = [
        r.min,
        r.max
    ];
    r.limits = (mode, num)=>$9bdbebf464fb72d3$export$e331ca4ad6a82555(r, mode, num);
    return r;
}
function $9bdbebf464fb72d3$export$e331ca4ad6a82555(data, mode = 'equal', num = 7) {
    if ((0, $rAKRV.default)(data) == 'array') data = $9bdbebf464fb72d3$export$7cbcccfbecde6416(data);
    const { min: min, max: max } = data;
    const values = data.values.sort((a, b)=>a - b);
    if (num === 1) return [
        min,
        max
    ];
    const limits1 = [];
    if (mode.substr(0, 1) === 'c') {
        // continuous
        limits1.push(min);
        limits1.push(max);
    }
    if (mode.substr(0, 1) === 'e') {
        // equal interval
        limits1.push(min);
        for(let i = 1; i < num; i++)limits1.push(min + i / num * (max - min));
        limits1.push(max);
    } else if (mode.substr(0, 1) === 'l') {
        // log scale
        if (min <= 0) throw new Error('Logarithmic scales are only possible for values > 0');
        const min_log = Math.LOG10E * $9bdbebf464fb72d3$var$log(min);
        const max_log = Math.LOG10E * $9bdbebf464fb72d3$var$log(max);
        limits1.push(min);
        for(let i = 1; i < num; i++)limits1.push($9bdbebf464fb72d3$var$pow(10, min_log + i / num * (max_log - min_log)));
        limits1.push(max);
    } else if (mode.substr(0, 1) === 'q') {
        // quantile scale
        limits1.push(min);
        for(let i = 1; i < num; i++){
            const p = (values.length - 1) * i / num;
            const pb = $9bdbebf464fb72d3$var$floor(p);
            if (pb === p) limits1.push(values[pb]);
            else {
                // p > pb
                const pr = p - pb;
                limits1.push(values[pb] * (1 - pr) + values[pb + 1] * pr);
            }
        }
        limits1.push(max);
    } else if (mode.substr(0, 1) === 'k') {
        // k-means clustering
        /*
        implementation based on
        http://code.google.com/p/figue/source/browse/trunk/figue.js#336
        simplified for 1-d input values
        */ let cluster;
        const n = values.length;
        const assignments = new Array(n);
        const clusterSizes = new Array(num);
        let repeat = true;
        let nb_iters = 0;
        let centroids = null;
        // get seed values
        centroids = [];
        centroids.push(min);
        for(let i = 1; i < num; i++)centroids.push(min + i / num * (max - min));
        centroids.push(max);
        while(repeat){
            // assignment step
            for(let j = 0; j < num; j++)clusterSizes[j] = 0;
            for(let i = 0; i < n; i++){
                const value = values[i];
                let mindist = Number.MAX_VALUE;
                let best;
                for(let j = 0; j < num; j++){
                    const dist = $9bdbebf464fb72d3$var$abs(centroids[j] - value);
                    if (dist < mindist) {
                        mindist = dist;
                        best = j;
                    }
                    clusterSizes[best]++;
                    assignments[i] = best;
                }
            }
            // update centroids step
            const newCentroids = new Array(num);
            for(let j = 0; j < num; j++)newCentroids[j] = null;
            for(let i = 0; i < n; i++){
                cluster = assignments[i];
                if (newCentroids[cluster] === null) newCentroids[cluster] = values[i];
                else newCentroids[cluster] += values[i];
            }
            for(let j = 0; j < num; j++)newCentroids[j] *= 1 / clusterSizes[j];
            // check convergence
            repeat = false;
            for(let j = 0; j < num; j++)if (newCentroids[j] !== centroids[j]) {
                repeat = true;
                break;
            }
            centroids = newCentroids;
            nb_iters++;
            if (nb_iters > 200) repeat = false;
        }
        // finished k-means clustering
        // the next part is borrowed from gabrielflor.it
        const kClusters = {};
        for(let j = 0; j < num; j++)kClusters[j] = [];
        for(let i = 0; i < n; i++){
            cluster = assignments[i];
            kClusters[cluster].push(values[i]);
        }
        let tmpKMeansBreaks = [];
        for(let j = 0; j < num; j++){
            tmpKMeansBreaks.push(kClusters[j][0]);
            tmpKMeansBreaks.push(kClusters[j][kClusters[j].length - 1]);
        }
        tmpKMeansBreaks = tmpKMeansBreaks.sort((a, b)=>a - b);
        limits1.push(tmpKMeansBreaks[0]);
        for(let i = 1; i < tmpKMeansBreaks.length; i += 2){
            const v = tmpKMeansBreaks[i];
            if (!isNaN(v) && limits1.indexOf(v) === -1) limits1.push(v);
        }
    }
    return limits1;
}

});

parcelRegister("iTouk", function(module, exports) {

$parcel$export(module.exports, "default", () => $dc105be0f4d2b0ec$export$2e2bcd8739ae039);

var $9WhDB = parcelRequire("9WhDB");
parcelRequire("9bpAk");
var $dc105be0f4d2b0ec$export$2e2bcd8739ae039 = (a, b)=>{
    // WCAG contrast ratio
    // see http://www.w3.org/TR/2008/REC-WCAG20-20081211/#contrast-ratiodef
    a = new (0, $9WhDB.default)(a);
    b = new (0, $9WhDB.default)(b);
    const l1 = a.luminance();
    const l2 = b.luminance();
    return l1 > l2 ? (l1 + 0.05) / (l2 + 0.05) : (l2 + 0.05) / (l1 + 0.05);
};

});

parcelRegister("hEb9E", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd8ed33332bc8cdf$export$2e2bcd8739ae039);

var $9WhDB = parcelRequire("9WhDB");

var $4Dxga = parcelRequire("4Dxga");
/**
 * @license
 *
 * The APCA contrast prediction algorithm is based of the formulas published
 * in the APCA-1.0.98G specification by Myndex. The specification is available at:
 * https://raw.githubusercontent.com/Myndex/apca-w3/master/images/APCAw3_0.1.17_APCA0.0.98G.svg
 *
 * Note that the APCA implementation is still beta, so please update to
 * future versions of chroma.js when they become available.
 *
 * You can read more about the APCA Readability Criterion at
 * https://readtech.org/ARC/
 */ // constants
const $cd8ed33332bc8cdf$var$W_offset = 0.027;
const $cd8ed33332bc8cdf$var$P_in = 0.0005;
const $cd8ed33332bc8cdf$var$P_out = 0.1;
const $cd8ed33332bc8cdf$var$R_scale = 1.14;
const $cd8ed33332bc8cdf$var$B_threshold = 0.022;
const $cd8ed33332bc8cdf$var$B_exp = 1.414;
var $cd8ed33332bc8cdf$export$2e2bcd8739ae039 = (text, bg)=>{
    // parse input colors
    text = new (0, $9WhDB.default)(text);
    bg = new (0, $9WhDB.default)(bg);
    // if text color has alpha, blend against background
    if (text.alpha() < 1) text = (0, $4Dxga.default)(bg, text, text.alpha(), 'rgb');
    const l_text = $cd8ed33332bc8cdf$var$lum(...text.rgb());
    const l_bg = $cd8ed33332bc8cdf$var$lum(...bg.rgb());
    // soft clamp black levels
    const Y_text = l_text >= $cd8ed33332bc8cdf$var$B_threshold ? l_text : l_text + Math.pow($cd8ed33332bc8cdf$var$B_threshold - l_text, $cd8ed33332bc8cdf$var$B_exp);
    const Y_bg = l_bg >= $cd8ed33332bc8cdf$var$B_threshold ? l_bg : l_bg + Math.pow($cd8ed33332bc8cdf$var$B_threshold - l_bg, $cd8ed33332bc8cdf$var$B_exp);
    // normal polarity (dark text on light background)
    const S_norm = Math.pow(Y_bg, 0.56) - Math.pow(Y_text, 0.57);
    // reverse polarity (light text on dark background)
    const S_rev = Math.pow(Y_bg, 0.65) - Math.pow(Y_text, 0.62);
    // clamp noise then scale
    const C = Math.abs(Y_bg - Y_text) < $cd8ed33332bc8cdf$var$P_in ? 0 : Y_text < Y_bg ? S_norm * $cd8ed33332bc8cdf$var$R_scale : S_rev * $cd8ed33332bc8cdf$var$R_scale;
    // clamp minimum contrast then offset
    const S_apc = Math.abs(C) < $cd8ed33332bc8cdf$var$P_out ? 0 : C > 0 ? C - $cd8ed33332bc8cdf$var$W_offset : C + $cd8ed33332bc8cdf$var$W_offset;
    // scale to 100
    return S_apc * 100;
};
function $cd8ed33332bc8cdf$var$lum(r, g, b) {
    return 0.2126729 * Math.pow(r / 255, 2.4) + 0.7151522 * Math.pow(g / 255, 2.4) + 0.072175 * Math.pow(b / 255, 2.4);
}

});

parcelRegister("6PUrQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $4fa34aef7ce53011$export$2e2bcd8739ae039);

var $9WhDB = parcelRequire("9WhDB");
const { sqrt: $4fa34aef7ce53011$var$sqrt, pow: $4fa34aef7ce53011$var$pow, min: $4fa34aef7ce53011$var$min, max: $4fa34aef7ce53011$var$max, atan2: $4fa34aef7ce53011$var$atan2, abs: $4fa34aef7ce53011$var$abs, cos: $4fa34aef7ce53011$var$cos, sin: $4fa34aef7ce53011$var$sin, exp: $4fa34aef7ce53011$var$exp, PI: $4fa34aef7ce53011$var$PI } = Math;
function $4fa34aef7ce53011$export$2e2bcd8739ae039(a, b, Kl = 1, Kc = 1, Kh = 1) {
    // Delta E (CIE 2000)
    // see http://www.brucelindbloom.com/index.html?Eqn_DeltaE_CIE2000.html
    var rad2deg = function(rad) {
        return 360 * rad / (2 * $4fa34aef7ce53011$var$PI);
    };
    var deg2rad = function(deg) {
        return 2 * $4fa34aef7ce53011$var$PI * deg / 360;
    };
    a = new (0, $9WhDB.default)(a);
    b = new (0, $9WhDB.default)(b);
    const [L1, a1, b1] = Array.from(a.lab());
    const [L2, a2, b2] = Array.from(b.lab());
    const avgL = (L1 + L2) / 2;
    const C1 = $4fa34aef7ce53011$var$sqrt($4fa34aef7ce53011$var$pow(a1, 2) + $4fa34aef7ce53011$var$pow(b1, 2));
    const C2 = $4fa34aef7ce53011$var$sqrt($4fa34aef7ce53011$var$pow(a2, 2) + $4fa34aef7ce53011$var$pow(b2, 2));
    const avgC = (C1 + C2) / 2;
    const G = 0.5 * (1 - $4fa34aef7ce53011$var$sqrt($4fa34aef7ce53011$var$pow(avgC, 7) / ($4fa34aef7ce53011$var$pow(avgC, 7) + $4fa34aef7ce53011$var$pow(25, 7))));
    const a1p = a1 * (1 + G);
    const a2p = a2 * (1 + G);
    const C1p = $4fa34aef7ce53011$var$sqrt($4fa34aef7ce53011$var$pow(a1p, 2) + $4fa34aef7ce53011$var$pow(b1, 2));
    const C2p = $4fa34aef7ce53011$var$sqrt($4fa34aef7ce53011$var$pow(a2p, 2) + $4fa34aef7ce53011$var$pow(b2, 2));
    const avgCp = (C1p + C2p) / 2;
    const arctan1 = rad2deg($4fa34aef7ce53011$var$atan2(b1, a1p));
    const arctan2 = rad2deg($4fa34aef7ce53011$var$atan2(b2, a2p));
    const h1p = arctan1 >= 0 ? arctan1 : arctan1 + 360;
    const h2p = arctan2 >= 0 ? arctan2 : arctan2 + 360;
    const avgHp = $4fa34aef7ce53011$var$abs(h1p - h2p) > 180 ? (h1p + h2p + 360) / 2 : (h1p + h2p) / 2;
    const T = 1 - 0.17 * $4fa34aef7ce53011$var$cos(deg2rad(avgHp - 30)) + 0.24 * $4fa34aef7ce53011$var$cos(deg2rad(2 * avgHp)) + 0.32 * $4fa34aef7ce53011$var$cos(deg2rad(3 * avgHp + 6)) - 0.2 * $4fa34aef7ce53011$var$cos(deg2rad(4 * avgHp - 63));
    let deltaHp = h2p - h1p;
    deltaHp = $4fa34aef7ce53011$var$abs(deltaHp) <= 180 ? deltaHp : h2p <= h1p ? deltaHp + 360 : deltaHp - 360;
    deltaHp = 2 * $4fa34aef7ce53011$var$sqrt(C1p * C2p) * $4fa34aef7ce53011$var$sin(deg2rad(deltaHp) / 2);
    const deltaL = L2 - L1;
    const deltaCp = C2p - C1p;
    const sl = 1 + 0.015 * $4fa34aef7ce53011$var$pow(avgL - 50, 2) / $4fa34aef7ce53011$var$sqrt(20 + $4fa34aef7ce53011$var$pow(avgL - 50, 2));
    const sc = 1 + 0.045 * avgCp;
    const sh = 1 + 0.015 * avgCp * T;
    const deltaTheta = 30 * $4fa34aef7ce53011$var$exp(-$4fa34aef7ce53011$var$pow((avgHp - 275) / 25, 2));
    const Rc = 2 * $4fa34aef7ce53011$var$sqrt($4fa34aef7ce53011$var$pow(avgCp, 7) / ($4fa34aef7ce53011$var$pow(avgCp, 7) + $4fa34aef7ce53011$var$pow(25, 7)));
    const Rt = -Rc * $4fa34aef7ce53011$var$sin(2 * deg2rad(deltaTheta));
    const result = $4fa34aef7ce53011$var$sqrt($4fa34aef7ce53011$var$pow(deltaL / (Kl * sl), 2) + $4fa34aef7ce53011$var$pow(deltaCp / (Kc * sc), 2) + $4fa34aef7ce53011$var$pow(deltaHp / (Kh * sh), 2) + Rt * (deltaCp / (Kc * sc)) * (deltaHp / (Kh * sh)));
    return $4fa34aef7ce53011$var$max(0, $4fa34aef7ce53011$var$min(100, result));
}

});

parcelRegister("f9Ovk", function(module, exports) {

$parcel$export(module.exports, "default", () => $b08edf62bea38a78$export$2e2bcd8739ae039);

var $9WhDB = parcelRequire("9WhDB");
function $b08edf62bea38a78$export$2e2bcd8739ae039(a, b, mode = 'lab') {
    // Delta E (CIE 1976)
    // see http://www.brucelindbloom.com/index.html?Equations.html
    a = new (0, $9WhDB.default)(a);
    b = new (0, $9WhDB.default)(b);
    const l1 = a.get(mode);
    const l2 = b.get(mode);
    let sum_sq = 0;
    for(let i in l1){
        const d = (l1[i] || 0) - (l2[i] || 0);
        sum_sq += d * d;
    }
    return Math.sqrt(sum_sq);
}

});

parcelRegister("5LSz1", function(module, exports) {

$parcel$export(module.exports, "default", () => $433baacaa82d6db3$export$2e2bcd8739ae039);

var $9WhDB = parcelRequire("9WhDB");
var $433baacaa82d6db3$export$2e2bcd8739ae039 = (...args)=>{
    try {
        new (0, $9WhDB.default)(...args);
        return true;
    // eslint-disable-next-line
    } catch (e) {
        return false;
    }
};

});

parcelRegister("f0u4B", function(module, exports) {

$parcel$export(module.exports, "default", () => $aece2f00be3b80cc$export$2e2bcd8739ae039);
// some pre-defined color scales:

var $4dsSs = parcelRequire("4dsSs");
parcelRequire("cHZip");

var $39JHd = parcelRequire("39JHd");
var $aece2f00be3b80cc$export$2e2bcd8739ae039 = {
    cool () {
        return (0, $39JHd.default)([
            (0, $4dsSs.default).hsl(180, 1, 0.9),
            (0, $4dsSs.default).hsl(250, 0.7, 0.4)
        ]);
    },
    hot () {
        return (0, $39JHd.default)([
            '#000',
            '#f00',
            '#ff0',
            '#fff'
        ], [
            0,
            0.25,
            0.75,
            1
        ]).mode('rgb');
    }
};

});

parcelRegister("iDIGL", function(module, exports) {

$parcel$export(module.exports, "default", () => $d91e88ca920c04af$export$2e2bcd8739ae039);
/**
    ColorBrewer colors for chroma.js

    Copyright (c) 2002 Cynthia Brewer, Mark Harrower, and The
    Pennsylvania State University.

    Licensed under the Apache License, Version 2.0 (the "License");
    you may not use this file except in compliance with the License.
    You may obtain a copy of the License at
    http://www.apache.org/licenses/LICENSE-2.0

    Unless required by applicable law or agreed to in writing, software distributed
    under the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
    CONDITIONS OF ANY KIND, either express or implied. See the License for the
    specific language governing permissions and limitations under the License.
*/ const $d91e88ca920c04af$var$colorbrewer = {
    // sequential
    OrRd: [
        '#fff7ec',
        '#fee8c8',
        '#fdd49e',
        '#fdbb84',
        '#fc8d59',
        '#ef6548',
        '#d7301f',
        '#b30000',
        '#7f0000'
    ],
    PuBu: [
        '#fff7fb',
        '#ece7f2',
        '#d0d1e6',
        '#a6bddb',
        '#74a9cf',
        '#3690c0',
        '#0570b0',
        '#045a8d',
        '#023858'
    ],
    BuPu: [
        '#f7fcfd',
        '#e0ecf4',
        '#bfd3e6',
        '#9ebcda',
        '#8c96c6',
        '#8c6bb1',
        '#88419d',
        '#810f7c',
        '#4d004b'
    ],
    Oranges: [
        '#fff5eb',
        '#fee6ce',
        '#fdd0a2',
        '#fdae6b',
        '#fd8d3c',
        '#f16913',
        '#d94801',
        '#a63603',
        '#7f2704'
    ],
    BuGn: [
        '#f7fcfd',
        '#e5f5f9',
        '#ccece6',
        '#99d8c9',
        '#66c2a4',
        '#41ae76',
        '#238b45',
        '#006d2c',
        '#00441b'
    ],
    YlOrBr: [
        '#ffffe5',
        '#fff7bc',
        '#fee391',
        '#fec44f',
        '#fe9929',
        '#ec7014',
        '#cc4c02',
        '#993404',
        '#662506'
    ],
    YlGn: [
        '#ffffe5',
        '#f7fcb9',
        '#d9f0a3',
        '#addd8e',
        '#78c679',
        '#41ab5d',
        '#238443',
        '#006837',
        '#004529'
    ],
    Reds: [
        '#fff5f0',
        '#fee0d2',
        '#fcbba1',
        '#fc9272',
        '#fb6a4a',
        '#ef3b2c',
        '#cb181d',
        '#a50f15',
        '#67000d'
    ],
    RdPu: [
        '#fff7f3',
        '#fde0dd',
        '#fcc5c0',
        '#fa9fb5',
        '#f768a1',
        '#dd3497',
        '#ae017e',
        '#7a0177',
        '#49006a'
    ],
    Greens: [
        '#f7fcf5',
        '#e5f5e0',
        '#c7e9c0',
        '#a1d99b',
        '#74c476',
        '#41ab5d',
        '#238b45',
        '#006d2c',
        '#00441b'
    ],
    YlGnBu: [
        '#ffffd9',
        '#edf8b1',
        '#c7e9b4',
        '#7fcdbb',
        '#41b6c4',
        '#1d91c0',
        '#225ea8',
        '#253494',
        '#081d58'
    ],
    Purples: [
        '#fcfbfd',
        '#efedf5',
        '#dadaeb',
        '#bcbddc',
        '#9e9ac8',
        '#807dba',
        '#6a51a3',
        '#54278f',
        '#3f007d'
    ],
    GnBu: [
        '#f7fcf0',
        '#e0f3db',
        '#ccebc5',
        '#a8ddb5',
        '#7bccc4',
        '#4eb3d3',
        '#2b8cbe',
        '#0868ac',
        '#084081'
    ],
    Greys: [
        '#ffffff',
        '#f0f0f0',
        '#d9d9d9',
        '#bdbdbd',
        '#969696',
        '#737373',
        '#525252',
        '#252525',
        '#000000'
    ],
    YlOrRd: [
        '#ffffcc',
        '#ffeda0',
        '#fed976',
        '#feb24c',
        '#fd8d3c',
        '#fc4e2a',
        '#e31a1c',
        '#bd0026',
        '#800026'
    ],
    PuRd: [
        '#f7f4f9',
        '#e7e1ef',
        '#d4b9da',
        '#c994c7',
        '#df65b0',
        '#e7298a',
        '#ce1256',
        '#980043',
        '#67001f'
    ],
    Blues: [
        '#f7fbff',
        '#deebf7',
        '#c6dbef',
        '#9ecae1',
        '#6baed6',
        '#4292c6',
        '#2171b5',
        '#08519c',
        '#08306b'
    ],
    PuBuGn: [
        '#fff7fb',
        '#ece2f0',
        '#d0d1e6',
        '#a6bddb',
        '#67a9cf',
        '#3690c0',
        '#02818a',
        '#016c59',
        '#014636'
    ],
    Viridis: [
        '#440154',
        '#482777',
        '#3f4a8a',
        '#31678e',
        '#26838f',
        '#1f9d8a',
        '#6cce5a',
        '#b6de2b',
        '#fee825'
    ],
    // diverging
    Spectral: [
        '#9e0142',
        '#d53e4f',
        '#f46d43',
        '#fdae61',
        '#fee08b',
        '#ffffbf',
        '#e6f598',
        '#abdda4',
        '#66c2a5',
        '#3288bd',
        '#5e4fa2'
    ],
    RdYlGn: [
        '#a50026',
        '#d73027',
        '#f46d43',
        '#fdae61',
        '#fee08b',
        '#ffffbf',
        '#d9ef8b',
        '#a6d96a',
        '#66bd63',
        '#1a9850',
        '#006837'
    ],
    RdBu: [
        '#67001f',
        '#b2182b',
        '#d6604d',
        '#f4a582',
        '#fddbc7',
        '#f7f7f7',
        '#d1e5f0',
        '#92c5de',
        '#4393c3',
        '#2166ac',
        '#053061'
    ],
    PiYG: [
        '#8e0152',
        '#c51b7d',
        '#de77ae',
        '#f1b6da',
        '#fde0ef',
        '#f7f7f7',
        '#e6f5d0',
        '#b8e186',
        '#7fbc41',
        '#4d9221',
        '#276419'
    ],
    PRGn: [
        '#40004b',
        '#762a83',
        '#9970ab',
        '#c2a5cf',
        '#e7d4e8',
        '#f7f7f7',
        '#d9f0d3',
        '#a6dba0',
        '#5aae61',
        '#1b7837',
        '#00441b'
    ],
    RdYlBu: [
        '#a50026',
        '#d73027',
        '#f46d43',
        '#fdae61',
        '#fee090',
        '#ffffbf',
        '#e0f3f8',
        '#abd9e9',
        '#74add1',
        '#4575b4',
        '#313695'
    ],
    BrBG: [
        '#543005',
        '#8c510a',
        '#bf812d',
        '#dfc27d',
        '#f6e8c3',
        '#f5f5f5',
        '#c7eae5',
        '#80cdc1',
        '#35978f',
        '#01665e',
        '#003c30'
    ],
    RdGy: [
        '#67001f',
        '#b2182b',
        '#d6604d',
        '#f4a582',
        '#fddbc7',
        '#ffffff',
        '#e0e0e0',
        '#bababa',
        '#878787',
        '#4d4d4d',
        '#1a1a1a'
    ],
    PuOr: [
        '#7f3b08',
        '#b35806',
        '#e08214',
        '#fdb863',
        '#fee0b6',
        '#f7f7f7',
        '#d8daeb',
        '#b2abd2',
        '#8073ac',
        '#542788',
        '#2d004b'
    ],
    // qualitative
    Set2: [
        '#66c2a5',
        '#fc8d62',
        '#8da0cb',
        '#e78ac3',
        '#a6d854',
        '#ffd92f',
        '#e5c494',
        '#b3b3b3'
    ],
    Accent: [
        '#7fc97f',
        '#beaed4',
        '#fdc086',
        '#ffff99',
        '#386cb0',
        '#f0027f',
        '#bf5b17',
        '#666666'
    ],
    Set1: [
        '#e41a1c',
        '#377eb8',
        '#4daf4a',
        '#984ea3',
        '#ff7f00',
        '#ffff33',
        '#a65628',
        '#f781bf',
        '#999999'
    ],
    Set3: [
        '#8dd3c7',
        '#ffffb3',
        '#bebada',
        '#fb8072',
        '#80b1d3',
        '#fdb462',
        '#b3de69',
        '#fccde5',
        '#d9d9d9',
        '#bc80bd',
        '#ccebc5',
        '#ffed6f'
    ],
    Dark2: [
        '#1b9e77',
        '#d95f02',
        '#7570b3',
        '#e7298a',
        '#66a61e',
        '#e6ab02',
        '#a6761d',
        '#666666'
    ],
    Paired: [
        '#a6cee3',
        '#1f78b4',
        '#b2df8a',
        '#33a02c',
        '#fb9a99',
        '#e31a1c',
        '#fdbf6f',
        '#ff7f00',
        '#cab2d6',
        '#6a3d9a',
        '#ffff99',
        '#b15928'
    ],
    Pastel2: [
        '#b3e2cd',
        '#fdcdac',
        '#cbd5e8',
        '#f4cae4',
        '#e6f5c9',
        '#fff2ae',
        '#f1e2cc',
        '#cccccc'
    ],
    Pastel1: [
        '#fbb4ae',
        '#b3cde3',
        '#ccebc5',
        '#decbe4',
        '#fed9a6',
        '#ffffcc',
        '#e5d8bd',
        '#fddaec',
        '#f2f2f2'
    ]
};
const $d91e88ca920c04af$var$colorbrewerTypes = Object.keys($d91e88ca920c04af$var$colorbrewer);
const $d91e88ca920c04af$var$typeMap = new Map($d91e88ca920c04af$var$colorbrewerTypes.map((key)=>[
        key.toLowerCase(),
        key
    ]));
// use Proxy to allow case-insensitive access to palettes
const $d91e88ca920c04af$var$colorbrewerProxy = typeof Proxy === 'function' ? new Proxy($d91e88ca920c04af$var$colorbrewer, {
    get (target, prop) {
        const lower = prop.toLowerCase();
        if ($d91e88ca920c04af$var$typeMap.has(lower)) return target[$d91e88ca920c04af$var$typeMap.get(lower)];
    },
    getOwnPropertyNames () {
        return Object.getOwnPropertyNames($d91e88ca920c04af$var$colorbrewerTypes);
    }
}) : $d91e88ca920c04af$var$colorbrewer;
var $d91e88ca920c04af$export$2e2bcd8739ae039 = $d91e88ca920c04af$var$colorbrewerProxy;

});

parcelRegister("kvDv4", function(module, exports) {

var $4dsSs = parcelRequire("4dsSs");

var $9WhDB = parcelRequire("9WhDB");

var $cio9q = parcelRequire("cio9q");
parcelRequire("f8COF");
var $rAKRV = parcelRequire("rAKRV");
var $6IMpB = parcelRequire("6IMpB");

var $aOAFb = parcelRequire("aOAFb");

var $fLR3v = parcelRequire("fLR3v");
(0, $9WhDB.default).prototype.cmyk = function() {
    return (0, $fLR3v.default)(this._rgb);
};
const $eee557d04ebe26b0$export$358b1a66a3c77756 = (...args)=>new (0, $9WhDB.default)(...args, 'cmyk');
Object.assign((0, $4dsSs.default), {
    cmyk: $eee557d04ebe26b0$export$358b1a66a3c77756
});
(0, $cio9q.default).format.cmyk = (0, $aOAFb.default);
(0, $cio9q.default).autodetect.push({
    p: 2,
    test: (...args)=>{
        args = (0, $6IMpB.default)(args, 'cmyk');
        if ((0, $rAKRV.default)(args) === 'array' && args.length === 4) return 'cmyk';
    }
});

});
parcelRegister("aOAFb", function(module, exports) {

$parcel$export(module.exports, "default", () => $7dfb03700941e666$export$2e2bcd8739ae039);
parcelRequire("f8COF");
var $6IMpB = parcelRequire("6IMpB");
const $7dfb03700941e666$var$cmyk2rgb = (...args)=>{
    args = (0, $6IMpB.default)(args, 'cmyk');
    const [c, m, y, k] = args;
    const alpha = args.length > 4 ? args[4] : 1;
    if (k === 1) return [
        0,
        0,
        0,
        alpha
    ];
    return [
        c >= 1 ? 0 : 255 * (1 - c) * (1 - k),
        m >= 1 ? 0 : 255 * (1 - m) * (1 - k),
        y >= 1 ? 0 : 255 * (1 - y) * (1 - k),
        alpha
    ];
};
var $7dfb03700941e666$export$2e2bcd8739ae039 = $7dfb03700941e666$var$cmyk2rgb;

});

parcelRegister("fLR3v", function(module, exports) {

$parcel$export(module.exports, "default", () => $b7b466880dadc9b9$export$2e2bcd8739ae039);
parcelRequire("f8COF");
var $6IMpB = parcelRequire("6IMpB");
const { max: $b7b466880dadc9b9$var$max } = Math;
const $b7b466880dadc9b9$var$rgb2cmyk = (...args)=>{
    let [r, g, b] = (0, $6IMpB.default)(args, 'rgb');
    r = r / 255;
    g = g / 255;
    b = b / 255;
    const k = 1 - $b7b466880dadc9b9$var$max(r, $b7b466880dadc9b9$var$max(g, b));
    const f = k < 1 ? 1 / (1 - k) : 0;
    const c = (1 - r - k) * f;
    const m = (1 - g - k) * f;
    const y = (1 - b - k) * f;
    return [
        c,
        m,
        y,
        k
    ];
};
var $b7b466880dadc9b9$export$2e2bcd8739ae039 = $b7b466880dadc9b9$var$rgb2cmyk;

});


parcelRegister("9cpWG", function(module, exports) {

var $4dsSs = parcelRequire("4dsSs");

var $9WhDB = parcelRequire("9WhDB");

var $cio9q = parcelRequire("cio9q");
parcelRequire("f8COF");
var $rAKRV = parcelRequire("rAKRV");

var $hUSl9 = parcelRequire("hUSl9");

var $hlIME = parcelRequire("hlIME");
(0, $9WhDB.default).prototype.css = function(mode) {
    return (0, $hUSl9.default)(this._rgb, mode);
};
const $6b295c44da857470$export$dbf350e5966cf602 = (...args)=>new (0, $9WhDB.default)(...args, 'css');
(0, $4dsSs.default).css = $6b295c44da857470$export$dbf350e5966cf602;
(0, $cio9q.default).format.css = (0, $hlIME.default);
(0, $cio9q.default).autodetect.push({
    p: 5,
    test: (h, ...rest)=>{
        if (!rest.length && (0, $rAKRV.default)(h) === 'string' && (0, $hlIME.default).test(h)) return 'css';
    }
});

});
parcelRegister("hUSl9", function(module, exports) {

$parcel$export(module.exports, "default", () => $d0b1d1770a7ce4b5$export$2e2bcd8739ae039);
parcelRequire("f8COF");
var $io9Wg = parcelRequire("io9Wg");
var $6IMpB = parcelRequire("6IMpB");

var $cZOvm = parcelRequire("cZOvm");

var $hnEdb = parcelRequire("hnEdb");

var $bLLQY = parcelRequire("bLLQY");

var $a62iy = parcelRequire("a62iy");

var $hihLj = parcelRequire("hihLj");

var $bETIL = parcelRequire("bETIL");

var $44muf = parcelRequire("44muf");

var $iG9GO = parcelRequire("iG9GO");

var $hGrMU = parcelRequire("hGrMU");

var $6PgmX = parcelRequire("6PgmX");

var $jJM5U = parcelRequire("jJM5U");
const { round: $d0b1d1770a7ce4b5$var$round } = Math;
/*
 * supported arguments:
 * - rgb2css(r,g,b)
 * - rgb2css(r,g,b,a)
 * - rgb2css([r,g,b], mode)
 * - rgb2css([r,g,b,a], mode)
 * - rgb2css({r,g,b,a}, mode)
 */ const $d0b1d1770a7ce4b5$var$rgb2css = (...args)=>{
    const rgba = (0, $6IMpB.default)(args, 'rgba');
    let mode = (0, $io9Wg.default)(args) || 'rgb';
    if (mode.substr(0, 3) === 'hsl') return (0, $cZOvm.default)((0, $hnEdb.default)(rgba), mode);
    if (mode.substr(0, 3) === 'lab') {
        // change to D50 lab whitepoint since this is what W3C is using for CSS Lab colors
        const prevWhitePoint = (0, $jJM5U.getLabWhitePoint)();
        (0, $jJM5U.setLabWhitePoint)('d50');
        const cssColor = (0, $bLLQY.default)((0, $a62iy.default)(rgba), mode);
        (0, $jJM5U.setLabWhitePoint)(prevWhitePoint);
        return cssColor;
    }
    if (mode.substr(0, 3) === 'lch') {
        // change to D50 lab whitepoint since this is what W3C is using for CSS Lab colors
        const prevWhitePoint = (0, $jJM5U.getLabWhitePoint)();
        (0, $jJM5U.setLabWhitePoint)('d50');
        const cssColor = (0, $hihLj.default)((0, $bETIL.default)(rgba), mode);
        (0, $jJM5U.setLabWhitePoint)(prevWhitePoint);
        return cssColor;
    }
    if (mode.substr(0, 5) === 'oklab') return (0, $iG9GO.default)((0, $44muf.default)(rgba));
    if (mode.substr(0, 5) === 'oklch') return (0, $6PgmX.default)((0, $hGrMU.default)(rgba));
    rgba[0] = $d0b1d1770a7ce4b5$var$round(rgba[0]);
    rgba[1] = $d0b1d1770a7ce4b5$var$round(rgba[1]);
    rgba[2] = $d0b1d1770a7ce4b5$var$round(rgba[2]);
    if (mode === 'rgba' || rgba.length > 3 && rgba[3] < 1) {
        rgba[3] = '/ ' + (rgba.length > 3 ? rgba[3] : 1);
        mode = 'rgba';
    }
    return `${mode.substr(0, 3)}(${rgba.slice(0, mode === 'rgb' ? 3 : 4).join(' ')})`;
};
var $d0b1d1770a7ce4b5$export$2e2bcd8739ae039 = $d0b1d1770a7ce4b5$var$rgb2css;

});
parcelRegister("cZOvm", function(module, exports) {

$parcel$export(module.exports, "default", () => $97625bbd65261d71$export$2e2bcd8739ae039);
parcelRequire("f8COF");
var $io9Wg = parcelRequire("io9Wg");
var $f8COF = parcelRequire("f8COF");
var $6IMpB = parcelRequire("6IMpB");
/*
 * supported arguments:
 * - hsl2css(h,s,l)
 * - hsl2css(h,s,l,a)
 * - hsl2css([h,s,l], mode)
 * - hsl2css([h,s,l,a], mode)
 * - hsl2css({h,s,l,a}, mode)
 */ const $97625bbd65261d71$var$hsl2css = (...args)=>{
    const hsla = (0, $6IMpB.default)(args, 'hsla');
    let mode = (0, $io9Wg.default)(args) || 'lsa';
    hsla[0] = (0, $f8COF.rnd2)(hsla[0] || 0) + 'deg';
    hsla[1] = (0, $f8COF.rnd2)(hsla[1] * 100) + '%';
    hsla[2] = (0, $f8COF.rnd2)(hsla[2] * 100) + '%';
    if (mode === 'hsla' || hsla.length > 3 && hsla[3] < 1) {
        hsla[3] = '/ ' + (hsla.length > 3 ? hsla[3] : 1);
        mode = 'hsla';
    } else hsla.length = 3;
    return `${mode.substr(0, 3)}(${hsla.join(' ')})`;
};
var $97625bbd65261d71$export$2e2bcd8739ae039 = $97625bbd65261d71$var$hsl2css;

});

parcelRegister("bLLQY", function(module, exports) {

$parcel$export(module.exports, "default", () => $8919343532ef136f$export$2e2bcd8739ae039);
parcelRequire("f8COF");
var $io9Wg = parcelRequire("io9Wg");
var $f8COF = parcelRequire("f8COF");
var $6IMpB = parcelRequire("6IMpB");
/*
 * supported arguments:
 * - lab2css(l,a,b)
 * - lab2css(l,a,b,alpha)
 * - lab2css([l,a,b], mode)
 * - lab2css([l,a,b,alpha], mode)
 */ const $8919343532ef136f$var$lab2css = (...args)=>{
    const laba = (0, $6IMpB.default)(args, 'lab');
    let mode = (0, $io9Wg.default)(args) || 'lab';
    laba[0] = (0, $f8COF.rnd2)(laba[0]) + '%';
    laba[1] = (0, $f8COF.rnd2)(laba[1]);
    laba[2] = (0, $f8COF.rnd2)(laba[2]);
    if (mode === 'laba' || laba.length > 3 && laba[3] < 1) laba[3] = '/ ' + (laba.length > 3 ? laba[3] : 1);
    else laba.length = 3;
    return `lab(${laba.join(' ')})`;
};
var $8919343532ef136f$export$2e2bcd8739ae039 = $8919343532ef136f$var$lab2css;

});

parcelRegister("hihLj", function(module, exports) {

$parcel$export(module.exports, "default", () => $c971e5469991ad05$export$2e2bcd8739ae039);
parcelRequire("f8COF");
var $io9Wg = parcelRequire("io9Wg");
var $f8COF = parcelRequire("f8COF");
var $6IMpB = parcelRequire("6IMpB");
/*
 * supported arguments:
 * - lab2css(l,a,b)
 * - lab2css(l,a,b,alpha)
 * - lab2css([l,a,b], mode)
 * - lab2css([l,a,b,alpha], mode)
 */ const $c971e5469991ad05$var$lch2css = (...args)=>{
    const lcha = (0, $6IMpB.default)(args, 'lch');
    let mode = (0, $io9Wg.default)(args) || 'lab';
    lcha[0] = (0, $f8COF.rnd2)(lcha[0]) + '%';
    lcha[1] = (0, $f8COF.rnd2)(lcha[1]);
    lcha[2] = isNaN(lcha[2]) ? 'none' : (0, $f8COF.rnd2)(lcha[2]) + 'deg'; // add deg unit to hue
    if (mode === 'lcha' || lcha.length > 3 && lcha[3] < 1) lcha[3] = '/ ' + (lcha.length > 3 ? lcha[3] : 1);
    else lcha.length = 3;
    return `lch(${lcha.join(' ')})`;
};
var $c971e5469991ad05$export$2e2bcd8739ae039 = $c971e5469991ad05$var$lch2css;

});

parcelRegister("iG9GO", function(module, exports) {

$parcel$export(module.exports, "default", () => $d993aa5b9b7deefa$export$2e2bcd8739ae039);

var $f8COF = parcelRequire("f8COF");
var $6IMpB = parcelRequire("6IMpB");
const $d993aa5b9b7deefa$var$oklab2css = (...args)=>{
    const laba = (0, $6IMpB.default)(args, 'lab');
    laba[0] = (0, $f8COF.rnd2)(laba[0] * 100) + '%';
    laba[1] = (0, $f8COF.rnd3)(laba[1]);
    laba[2] = (0, $f8COF.rnd3)(laba[2]);
    if (laba.length > 3 && laba[3] < 1) laba[3] = '/ ' + (laba.length > 3 ? laba[3] : 1);
    else laba.length = 3;
    return `oklab(${laba.join(' ')})`;
};
var $d993aa5b9b7deefa$export$2e2bcd8739ae039 = $d993aa5b9b7deefa$var$oklab2css;

});

parcelRegister("hGrMU", function(module, exports) {

$parcel$export(module.exports, "default", () => $cdfbea047f0b9913$export$2e2bcd8739ae039);
parcelRequire("f8COF");
var $6IMpB = parcelRequire("6IMpB");

var $44muf = parcelRequire("44muf");

var $j71Rx = parcelRequire("j71Rx");
const $cdfbea047f0b9913$var$rgb2oklch = (...args)=>{
    const [r, g, b, ...rest] = (0, $6IMpB.default)(args, 'rgb');
    const [l, a, b_] = (0, $44muf.default)(r, g, b);
    const [L, c, h] = (0, $j71Rx.default)(l, a, b_);
    return [
        L,
        c,
        h,
        ...rest.length > 0 && rest[0] < 1 ? [
            rest[0]
        ] : []
    ];
};
var $cdfbea047f0b9913$export$2e2bcd8739ae039 = $cdfbea047f0b9913$var$rgb2oklch;

});

parcelRegister("6PgmX", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f843419ebcd2fcc$export$2e2bcd8739ae039);

var $f8COF = parcelRequire("f8COF");
var $6IMpB = parcelRequire("6IMpB");
const $4f843419ebcd2fcc$var$oklch2css = (...args)=>{
    const lcha = (0, $6IMpB.default)(args, 'lch');
    lcha[0] = (0, $f8COF.rnd2)(lcha[0] * 100) + '%';
    lcha[1] = (0, $f8COF.rnd3)(lcha[1]);
    lcha[2] = isNaN(lcha[2]) ? 'none' : (0, $f8COF.rnd2)(lcha[2]) + 'deg'; // add deg unit to hue
    if (lcha.length > 3 && lcha[3] < 1) lcha[3] = '/ ' + (lcha.length > 3 ? lcha[3] : 1);
    else lcha.length = 3;
    return `oklch(${lcha.join(' ')})`;
};
var $4f843419ebcd2fcc$export$2e2bcd8739ae039 = $4f843419ebcd2fcc$var$oklch2css;

});


parcelRegister("hlIME", function(module, exports) {

$parcel$export(module.exports, "default", () => $ca1722ef8b79b00e$export$2e2bcd8739ae039);

var $diYXA = parcelRequire("diYXA");

var $1e9qI = parcelRequire("1e9qI");

var $baiXr = parcelRequire("baiXr");

var $7rWyE = parcelRequire("7rWyE");

var $bBNLb = parcelRequire("bBNLb");

var $cio9q = parcelRequire("cio9q");

var $eeze8 = parcelRequire("eeze8");

var $jJM5U = parcelRequire("jJM5U");
const $ca1722ef8b79b00e$var$INT_OR_PCT = /((?:-?\d+)|(?:-?\d+(?:\.\d+)?)%|none)/.source;
const $ca1722ef8b79b00e$var$FLOAT_OR_PCT = /((?:-?(?:\d+(?:\.\d*)?|\.\d+)%?)|none)/.source;
const $ca1722ef8b79b00e$var$PCT = /((?:-?(?:\d+(?:\.\d*)?|\.\d+)%)|none)/.source;
const $ca1722ef8b79b00e$var$RE_S = /\s*/.source;
const $ca1722ef8b79b00e$var$SEP = /\s+/.source;
const $ca1722ef8b79b00e$var$COMMA = /\s*,\s*/.source;
const $ca1722ef8b79b00e$var$ANLGE = /((?:-?(?:\d+(?:\.\d*)?|\.\d+)(?:deg)?)|none)/.source;
const $ca1722ef8b79b00e$var$ALPHA = /\s*(?:\/\s*((?:[01]|[01]?\.\d+)|\d+(?:\.\d+)?%))?/.source;
// e.g. rgb(250 20 0), rgb(100% 50% 20%), rgb(100% 50% 20% / 0.5)
const $ca1722ef8b79b00e$var$RE_RGB = new RegExp('^rgba?\\(' + $ca1722ef8b79b00e$var$RE_S + [
    $ca1722ef8b79b00e$var$INT_OR_PCT,
    $ca1722ef8b79b00e$var$INT_OR_PCT,
    $ca1722ef8b79b00e$var$INT_OR_PCT
].join($ca1722ef8b79b00e$var$SEP) + $ca1722ef8b79b00e$var$ALPHA + '\\)$');
const $ca1722ef8b79b00e$var$RE_RGB_LEGACY = new RegExp('^rgb\\(' + $ca1722ef8b79b00e$var$RE_S + [
    $ca1722ef8b79b00e$var$INT_OR_PCT,
    $ca1722ef8b79b00e$var$INT_OR_PCT,
    $ca1722ef8b79b00e$var$INT_OR_PCT
].join($ca1722ef8b79b00e$var$COMMA) + $ca1722ef8b79b00e$var$RE_S + '\\)$');
const $ca1722ef8b79b00e$var$RE_RGBA_LEGACY = new RegExp('^rgba\\(' + $ca1722ef8b79b00e$var$RE_S + [
    $ca1722ef8b79b00e$var$INT_OR_PCT,
    $ca1722ef8b79b00e$var$INT_OR_PCT,
    $ca1722ef8b79b00e$var$INT_OR_PCT,
    $ca1722ef8b79b00e$var$FLOAT_OR_PCT
].join($ca1722ef8b79b00e$var$COMMA) + $ca1722ef8b79b00e$var$RE_S + '\\)$');
const $ca1722ef8b79b00e$var$RE_HSL = new RegExp('^hsla?\\(' + $ca1722ef8b79b00e$var$RE_S + [
    $ca1722ef8b79b00e$var$ANLGE,
    $ca1722ef8b79b00e$var$PCT,
    $ca1722ef8b79b00e$var$PCT
].join($ca1722ef8b79b00e$var$SEP) + $ca1722ef8b79b00e$var$ALPHA + '\\)$');
const $ca1722ef8b79b00e$var$RE_HSL_LEGACY = new RegExp('^hsl?\\(' + $ca1722ef8b79b00e$var$RE_S + [
    $ca1722ef8b79b00e$var$ANLGE,
    $ca1722ef8b79b00e$var$PCT,
    $ca1722ef8b79b00e$var$PCT
].join($ca1722ef8b79b00e$var$COMMA) + $ca1722ef8b79b00e$var$RE_S + '\\)$');
const $ca1722ef8b79b00e$var$RE_HSLA_LEGACY = /^hsla\(\s*(-?\d+(?:\.\d+)?),\s*(-?\d+(?:\.\d+)?)%\s*,\s*(-?\d+(?:\.\d+)?)%\s*,\s*([01]|[01]?\.\d+)\)$/;
const $ca1722ef8b79b00e$var$RE_LAB = new RegExp('^lab\\(' + $ca1722ef8b79b00e$var$RE_S + [
    $ca1722ef8b79b00e$var$FLOAT_OR_PCT,
    $ca1722ef8b79b00e$var$FLOAT_OR_PCT,
    $ca1722ef8b79b00e$var$FLOAT_OR_PCT
].join($ca1722ef8b79b00e$var$SEP) + $ca1722ef8b79b00e$var$ALPHA + '\\)$');
const $ca1722ef8b79b00e$var$RE_LCH = new RegExp('^lch\\(' + $ca1722ef8b79b00e$var$RE_S + [
    $ca1722ef8b79b00e$var$FLOAT_OR_PCT,
    $ca1722ef8b79b00e$var$FLOAT_OR_PCT,
    $ca1722ef8b79b00e$var$ANLGE
].join($ca1722ef8b79b00e$var$SEP) + $ca1722ef8b79b00e$var$ALPHA + '\\)$');
const $ca1722ef8b79b00e$var$RE_OKLAB = new RegExp('^oklab\\(' + $ca1722ef8b79b00e$var$RE_S + [
    $ca1722ef8b79b00e$var$FLOAT_OR_PCT,
    $ca1722ef8b79b00e$var$FLOAT_OR_PCT,
    $ca1722ef8b79b00e$var$FLOAT_OR_PCT
].join($ca1722ef8b79b00e$var$SEP) + $ca1722ef8b79b00e$var$ALPHA + '\\)$');
const $ca1722ef8b79b00e$var$RE_OKLCH = new RegExp('^oklch\\(' + $ca1722ef8b79b00e$var$RE_S + [
    $ca1722ef8b79b00e$var$FLOAT_OR_PCT,
    $ca1722ef8b79b00e$var$FLOAT_OR_PCT,
    $ca1722ef8b79b00e$var$ANLGE
].join($ca1722ef8b79b00e$var$SEP) + $ca1722ef8b79b00e$var$ALPHA + '\\)$');
const { round: $ca1722ef8b79b00e$var$round } = Math;
const $ca1722ef8b79b00e$var$roundRGB = (rgb)=>{
    return rgb.map((v, i)=>i <= 2 ? (0, $eeze8.default)($ca1722ef8b79b00e$var$round(v), 0, 255) : v);
};
const $ca1722ef8b79b00e$var$percentToAbsolute = (pct, min = 0, max = 100, signed = false)=>{
    if (typeof pct === 'string' && pct.endsWith('%')) {
        pct = parseFloat(pct.substring(0, pct.length - 1)) / 100;
        if (signed) // signed percentages are in the range -100% to 100%
        pct = min + (pct + 1) * 0.5 * (max - min);
        else pct = min + pct * (max - min);
    }
    return +pct;
};
const $ca1722ef8b79b00e$var$noneToValue = (v, noneValue)=>{
    return v === 'none' ? noneValue : v;
};
const $ca1722ef8b79b00e$var$css2rgb = (css)=>{
    css = css.toLowerCase().trim();
    if (css === 'transparent') return [
        0,
        0,
        0,
        0
    ];
    let m;
    if ((0, $cio9q.default).format.named) try {
        return (0, $cio9q.default).format.named(css);
    // eslint-disable-next-line
    } catch (e) {}
    // rgb(250 20 0) or rgb(250,20,0)
    if ((m = css.match($ca1722ef8b79b00e$var$RE_RGB)) || (m = css.match($ca1722ef8b79b00e$var$RE_RGB_LEGACY))) {
        let rgb = m.slice(1, 4);
        for(let i = 0; i < 3; i++)rgb[i] = +$ca1722ef8b79b00e$var$percentToAbsolute($ca1722ef8b79b00e$var$noneToValue(rgb[i], 0), 0, 255);
        rgb = $ca1722ef8b79b00e$var$roundRGB(rgb);
        const alpha = m[4] !== undefined ? +$ca1722ef8b79b00e$var$percentToAbsolute(m[4], 0, 1) : 1;
        rgb[3] = alpha; // default alpha
        return rgb;
    }
    // rgba(250,20,0,0.4)
    if (m = css.match($ca1722ef8b79b00e$var$RE_RGBA_LEGACY)) {
        const rgb = m.slice(1, 5);
        for(let i = 0; i < 4; i++)rgb[i] = +$ca1722ef8b79b00e$var$percentToAbsolute(rgb[i], 0, 255);
        return rgb;
    }
    // hsl(0,100%,50%)
    if ((m = css.match($ca1722ef8b79b00e$var$RE_HSL)) || (m = css.match($ca1722ef8b79b00e$var$RE_HSL_LEGACY))) {
        const hsl = m.slice(1, 4);
        hsl[0] = +$ca1722ef8b79b00e$var$noneToValue(hsl[0].replace('deg', ''), 0);
        hsl[1] = +$ca1722ef8b79b00e$var$percentToAbsolute($ca1722ef8b79b00e$var$noneToValue(hsl[1], 0), 0, 100) * 0.01;
        hsl[2] = +$ca1722ef8b79b00e$var$percentToAbsolute($ca1722ef8b79b00e$var$noneToValue(hsl[2], 0), 0, 100) * 0.01;
        const rgb = $ca1722ef8b79b00e$var$roundRGB((0, $diYXA.default)(hsl));
        const alpha = m[4] !== undefined ? +$ca1722ef8b79b00e$var$percentToAbsolute(m[4], 0, 1) : 1;
        rgb[3] = alpha;
        return rgb;
    }
    // hsla(0,100%,50%,0.5)
    if (m = css.match($ca1722ef8b79b00e$var$RE_HSLA_LEGACY)) {
        const hsl = m.slice(1, 4);
        hsl[1] *= 0.01;
        hsl[2] *= 0.01;
        const rgb = (0, $diYXA.default)(hsl);
        for(let i = 0; i < 3; i++)rgb[i] = $ca1722ef8b79b00e$var$round(rgb[i]);
        rgb[3] = +m[4]; // default alpha = 1
        return rgb;
    }
    if (m = css.match($ca1722ef8b79b00e$var$RE_LAB)) {
        const lab = m.slice(1, 4);
        lab[0] = $ca1722ef8b79b00e$var$percentToAbsolute($ca1722ef8b79b00e$var$noneToValue(lab[0], 0), 0, 100);
        lab[1] = $ca1722ef8b79b00e$var$percentToAbsolute($ca1722ef8b79b00e$var$noneToValue(lab[1], 0), -125, 125, true);
        lab[2] = $ca1722ef8b79b00e$var$percentToAbsolute($ca1722ef8b79b00e$var$noneToValue(lab[2], 0), -125, 125, true);
        // convert to D50 Lab whitepoint
        const wp = (0, $jJM5U.getLabWhitePoint)();
        (0, $jJM5U.setLabWhitePoint)('d50');
        const rgb = $ca1722ef8b79b00e$var$roundRGB((0, $1e9qI.default)(lab));
        // convert back to original Lab whitepoint
        (0, $jJM5U.setLabWhitePoint)(wp);
        const alpha = m[4] !== undefined ? +$ca1722ef8b79b00e$var$percentToAbsolute(m[4], 0, 1) : 1;
        rgb[3] = alpha;
        return rgb;
    }
    if (m = css.match($ca1722ef8b79b00e$var$RE_LCH)) {
        const lch = m.slice(1, 4);
        lch[0] = $ca1722ef8b79b00e$var$percentToAbsolute(lch[0], 0, 100);
        lch[1] = $ca1722ef8b79b00e$var$percentToAbsolute($ca1722ef8b79b00e$var$noneToValue(lch[1], 0), 0, 150, false);
        lch[2] = +$ca1722ef8b79b00e$var$noneToValue(lch[2].replace('deg', ''), 0);
        // convert to D50 Lab whitepoint
        const wp = (0, $jJM5U.getLabWhitePoint)();
        (0, $jJM5U.setLabWhitePoint)('d50');
        const rgb = $ca1722ef8b79b00e$var$roundRGB((0, $baiXr.default)(lch));
        // convert back to original Lab whitepoint
        (0, $jJM5U.setLabWhitePoint)(wp);
        const alpha = m[4] !== undefined ? +$ca1722ef8b79b00e$var$percentToAbsolute(m[4], 0, 1) : 1;
        rgb[3] = alpha;
        return rgb;
    }
    if (m = css.match($ca1722ef8b79b00e$var$RE_OKLAB)) {
        const oklab = m.slice(1, 4);
        oklab[0] = $ca1722ef8b79b00e$var$percentToAbsolute($ca1722ef8b79b00e$var$noneToValue(oklab[0], 0), 0, 1);
        oklab[1] = $ca1722ef8b79b00e$var$percentToAbsolute($ca1722ef8b79b00e$var$noneToValue(oklab[1], 0), -0.4, 0.4, true);
        oklab[2] = $ca1722ef8b79b00e$var$percentToAbsolute($ca1722ef8b79b00e$var$noneToValue(oklab[2], 0), -0.4, 0.4, true);
        const rgb = $ca1722ef8b79b00e$var$roundRGB((0, $7rWyE.default)(oklab));
        const alpha = m[4] !== undefined ? +$ca1722ef8b79b00e$var$percentToAbsolute(m[4], 0, 1) : 1;
        rgb[3] = alpha;
        return rgb;
    }
    if (m = css.match($ca1722ef8b79b00e$var$RE_OKLCH)) {
        const oklch = m.slice(1, 4);
        oklch[0] = $ca1722ef8b79b00e$var$percentToAbsolute($ca1722ef8b79b00e$var$noneToValue(oklch[0], 0), 0, 1);
        oklch[1] = $ca1722ef8b79b00e$var$percentToAbsolute($ca1722ef8b79b00e$var$noneToValue(oklch[1], 0), 0, 0.4, false);
        oklch[2] = +$ca1722ef8b79b00e$var$noneToValue(oklch[2].replace('deg', ''), 0);
        const rgb = $ca1722ef8b79b00e$var$roundRGB((0, $bBNLb.default)(oklch));
        const alpha = m[4] !== undefined ? +$ca1722ef8b79b00e$var$percentToAbsolute(m[4], 0, 1) : 1;
        rgb[3] = alpha;
        return rgb;
    }
};
$ca1722ef8b79b00e$var$css2rgb.test = (s)=>{
    return(// modern
    $ca1722ef8b79b00e$var$RE_RGB.test(s) || $ca1722ef8b79b00e$var$RE_HSL.test(s) || $ca1722ef8b79b00e$var$RE_LAB.test(s) || $ca1722ef8b79b00e$var$RE_LCH.test(s) || $ca1722ef8b79b00e$var$RE_OKLAB.test(s) || $ca1722ef8b79b00e$var$RE_OKLCH.test(s) || // legacy
    $ca1722ef8b79b00e$var$RE_RGB_LEGACY.test(s) || $ca1722ef8b79b00e$var$RE_RGBA_LEGACY.test(s) || $ca1722ef8b79b00e$var$RE_HSL_LEGACY.test(s) || $ca1722ef8b79b00e$var$RE_HSLA_LEGACY.test(s) || s === 'transparent');
};
var $ca1722ef8b79b00e$export$2e2bcd8739ae039 = $ca1722ef8b79b00e$var$css2rgb;

});
parcelRegister("bBNLb", function(module, exports) {

$parcel$export(module.exports, "default", () => $8739bfbc33889254$export$2e2bcd8739ae039);
parcelRequire("f8COF");
var $6IMpB = parcelRequire("6IMpB");

var $1wyt6 = parcelRequire("1wyt6");

var $7rWyE = parcelRequire("7rWyE");
const $8739bfbc33889254$var$oklch2rgb = (...args)=>{
    args = (0, $6IMpB.default)(args, 'lch');
    const [l, c, h, ...rest] = args;
    const [L, a, b_] = (0, $1wyt6.default)(l, c, h);
    const [r, g, b] = (0, $7rWyE.default)(L, a, b_);
    return [
        r,
        g,
        b,
        ...rest.length > 0 && rest[0] < 1 ? [
            rest[0]
        ] : []
    ];
};
var $8739bfbc33889254$export$2e2bcd8739ae039 = $8739bfbc33889254$var$oklch2rgb;

});



parcelRegister("eioBY", function(module, exports) {

var $9WhDB = parcelRequire("9WhDB");

var $4dsSs = parcelRequire("4dsSs");

var $cio9q = parcelRequire("cio9q");
parcelRequire("f8COF");
var $6IMpB = parcelRequire("6IMpB");
(0, $cio9q.default).format.gl = (...args)=>{
    const rgb = (0, $6IMpB.default)(args, 'rgba');
    rgb[0] *= 255;
    rgb[1] *= 255;
    rgb[2] *= 255;
    return rgb;
};
const $a685d675a5c79ac1$export$5822a9d0880a5d82 = (...args)=>new (0, $9WhDB.default)(...args, 'gl');
(0, $4dsSs.default).gl = $a685d675a5c79ac1$export$5822a9d0880a5d82;
(0, $9WhDB.default).prototype.gl = function() {
    const rgb = this._rgb;
    return [
        rgb[0] / 255,
        rgb[1] / 255,
        rgb[2] / 255,
        rgb[3]
    ];
};

});

parcelRegister("9Q6Ul", function(module, exports) {

var $9WhDB = parcelRequire("9WhDB");

var $4dsSs = parcelRequire("4dsSs");
parcelRequire("f8COF");
var $rAKRV = parcelRequire("rAKRV");

var $cio9q = parcelRequire("cio9q");

var $QfAJ3 = parcelRequire("QfAJ3");

var $eOU0G = parcelRequire("eOU0G");
(0, $9WhDB.default).prototype.hex = function(mode) {
    return (0, $eOU0G.default)(this._rgb, mode);
};
const $729e542397ce9704$export$834dfc94dde4b3d8 = (...args)=>new (0, $9WhDB.default)(...args, 'hex');
(0, $4dsSs.default).hex = $729e542397ce9704$export$834dfc94dde4b3d8;
(0, $cio9q.default).format.hex = (0, $QfAJ3.default);
(0, $cio9q.default).autodetect.push({
    p: 4,
    test: (h, ...rest)=>{
        if (!rest.length && (0, $rAKRV.default)(h) === 'string' && [
            3,
            4,
            5,
            6,
            7,
            8,
            9
        ].indexOf(h.length) >= 0) return 'hex';
    }
});

});

parcelRegister("lna4G", function(module, exports) {

var $4dsSs = parcelRequire("4dsSs");

var $9WhDB = parcelRequire("9WhDB");

var $cio9q = parcelRequire("cio9q");

var $kDtr0 = parcelRequire("kDtr0");

var $aSmqn = parcelRequire("aSmqn");
(0, $9WhDB.default).prototype.temp = (0, $9WhDB.default).prototype.kelvin = (0, $9WhDB.default).prototype.temperature = function() {
    return (0, $aSmqn.default)(this._rgb);
};
const $f8f38f888a61f9d0$export$8d72b093afd1813e = (...args)=>new (0, $9WhDB.default)(...args, 'temp');
Object.assign((0, $4dsSs.default), {
    temp: $f8f38f888a61f9d0$export$8d72b093afd1813e,
    kelvin: $f8f38f888a61f9d0$export$8d72b093afd1813e,
    temperature: $f8f38f888a61f9d0$export$8d72b093afd1813e
});
(0, $cio9q.default).format.temp = (0, $cio9q.default).format.kelvin = (0, $cio9q.default).format.temperature = (0, $kDtr0.default);

});
parcelRegister("kDtr0", function(module, exports) {

$parcel$export(module.exports, "default", () => $f05e4842a8adc61b$export$2e2bcd8739ae039);
/*
 * Based on implementation by Neil Bartlett
 * https://github.com/neilbartlett/color-temperature
 */ const { log: $f05e4842a8adc61b$var$log } = Math;
const $f05e4842a8adc61b$var$temperature2rgb = (kelvin)=>{
    const temp = kelvin / 100;
    let r, g, b;
    if (temp < 66) {
        r = 255;
        g = temp < 6 ? 0 : -155.25485562709179 - 0.44596950469579133 * (g = temp - 2) + 104.49216199393888 * $f05e4842a8adc61b$var$log(g);
        b = temp < 20 ? 0 : -254.76935184120902 + 0.8274096064007395 * (b = temp - 10) + 115.67994401066147 * $f05e4842a8adc61b$var$log(b);
    } else {
        r = 351.97690566805693 + 0.114206453784165 * (r = temp - 55) - 40.25366309332127 * $f05e4842a8adc61b$var$log(r);
        g = 325.4494125711974 + 0.07943456536662342 * (g = temp - 50) - 28.0852963507957 * $f05e4842a8adc61b$var$log(g);
        b = 255;
    }
    return [
        r,
        g,
        b,
        1
    ];
};
var $f05e4842a8adc61b$export$2e2bcd8739ae039 = $f05e4842a8adc61b$var$temperature2rgb;

});

parcelRegister("aSmqn", function(module, exports) {

$parcel$export(module.exports, "default", () => $7eb057931f632797$export$2e2bcd8739ae039);
/*
 * Based on implementation by Neil Bartlett
 * https://github.com/neilbartlett/color-temperature
 **/ 
var $kDtr0 = parcelRequire("kDtr0");
parcelRequire("f8COF");
var $6IMpB = parcelRequire("6IMpB");
const { round: $7eb057931f632797$var$round } = Math;
const $7eb057931f632797$var$rgb2temperature = (...args)=>{
    const rgb = (0, $6IMpB.default)(args, 'rgb');
    const r = rgb[0], b = rgb[2];
    let minTemp = 1000;
    let maxTemp = 40000;
    const eps = 0.4;
    let temp;
    while(maxTemp - minTemp > eps){
        temp = (maxTemp + minTemp) * 0.5;
        const rgb = (0, $kDtr0.default)(temp);
        if (rgb[2] / rgb[0] >= b / r) maxTemp = temp;
        else minTemp = temp;
    }
    return $7eb057931f632797$var$round(temp);
};
var $7eb057931f632797$export$2e2bcd8739ae039 = $7eb057931f632797$var$rgb2temperature;

});


parcelRegister("9as51", function(module, exports) {
parcelRequire("f8COF");
var $rAKRV = parcelRequire("rAKRV");
var $6IMpB = parcelRequire("6IMpB");

var $4dsSs = parcelRequire("4dsSs");

var $9WhDB = parcelRequire("9WhDB");

var $cio9q = parcelRequire("cio9q");

var $bBNLb = parcelRequire("bBNLb");

var $hGrMU = parcelRequire("hGrMU");
(0, $9WhDB.default).prototype.oklch = function() {
    return (0, $hGrMU.default)(this._rgb);
};
const $6acad4565448b390$export$c21b932a666e3753 = (...args)=>new (0, $9WhDB.default)(...args, 'oklch');
Object.assign((0, $4dsSs.default), {
    oklch: $6acad4565448b390$export$c21b932a666e3753
});
(0, $cio9q.default).format.oklch = (0, $bBNLb.default);
(0, $cio9q.default).autodetect.push({
    p: 2,
    test: (...args)=>{
        args = (0, $6IMpB.default)(args, 'oklch');
        if ((0, $rAKRV.default)(args) === 'array' && args.length === 3) return 'oklch';
    }
});

});



parcelRegister("d8Pvn", function(module, exports) {

$parcel$export(module.exports, "createTooltip", () => $9913f98ecdefcd74$export$c16a9a598ac2ae39);

var $5qD1E = parcelRequire("5qD1E");
function $9913f98ecdefcd74$var$createTooltipContent(elementData, element) {
    const isNode = element.isNode();
    // Start with tooltip header
    let content = `<div class="tooltip-header ${isNode ? "node-header" : "edge-header"}">
        <strong>${isNode ? "Node" : "Edge"} Info</strong>
    </div>
    <div class="tooltip-body">`;
    // For nodes, show the most important information first
    if (isNode) {
        // Display basic node info (ID, name if available)
        content += `<div class="tooltip-section">
            <div class="tooltip-title">ID:</div>
            <div class="tooltip-value">${elementData.id || "N/A"}</div>
        </div>`;
        // If name exists and is different from ID, show it
        if (elementData.name && elementData.name !== elementData.id) content += `<div class="tooltip-section">
                <div class="tooltip-title">Name:</div>
                <div class="tooltip-value">${elementData.name}</div>
            </div>`;
        // Display genomic location if available
        if (elementData.chrom) content += `<div class="tooltip-section">
                <div class="tooltip-title">Location:</div>
                <div class="tooltip-value">${elementData.chrom}:${elementData.ref_start?.toLocaleString() || "?"}-${elementData.ref_end?.toLocaleString() || "?"}</div>
            </div>`;
        // Display PTC and PTF values if available
        if (elementData.ptc !== undefined || elementData.ptf !== undefined) {
            content += `<div class="tooltip-metrics">`;
            if (elementData.ptc !== undefined) content += `<div class="tooltip-metric">
                    <span class="metric-label">PTC</span>
                    <span class="metric-value" style="background-color: #007bff;">${elementData.ptc.toFixed(4)}</span>
                </div>`;
            if (elementData.ptf !== undefined) content += `<div class="tooltip-metric">
                    <span class="metric-label">PTF</span>
                    <span class="metric-value" style="background-color: #6c757d;">${elementData.ptf.toFixed(4)}</span>
                </div>`;
            content += `</div>`;
        }
    } else {
        // For edges, show source, target and weight
        content += `<div class="tooltip-section">
            <div class="tooltip-title">Source:</div>
            <div class="tooltip-value">${elementData.source}</div>
        </div>
        <div class="tooltip-section">
            <div class="tooltip-title">Target:</div>
            <div class="tooltip-value">${elementData.target}</div>
        </div>`;
        if (elementData.weight !== undefined) content += `<div class="tooltip-section">
                <div class="tooltip-title">Weight:</div>
                <div class="tooltip-value weight-value">${elementData.weight}</div>
            </div>`;
    }
    // Close tooltip body
    content += `</div>`;
    // Add a footer with hint
    content += `<div class="tooltip-footer">
        <small>Click for more details</small>
    </div>`;
    return content;
}
let $9913f98ecdefcd74$var$tooltipDisabled = false; // Initial state is false, tooltip starts enabled
function $9913f98ecdefcd74$export$c16a9a598ac2ae39() {
    // Add tooltip styles to the document
    $9913f98ecdefcd74$var$addTooltipStyles();
    // Only setup tooltip events if not disabled
    if (!$9913f98ecdefcd74$var$tooltipDisabled) {
        (0, $5qD1E.STATE).cy.on("mouseover", "node, edge", (event)=>{
            const target = event.target;
            const elementData = target.data();
            const tooltip = document.getElementById("tooltip");
            tooltip.innerHTML = $9913f98ecdefcd74$var$createTooltipContent(elementData, target);
            tooltip.style.display = "block";
            // Position tooltip near the cursor but not directly under it
            tooltip.style.left = `${event.originalEvent.pageX + 10}px`;
            tooltip.style.top = `${event.originalEvent.pageY - 10}px`;
            // Add animation class
            tooltip.classList.add("tooltip-visible");
        });
        (0, $5qD1E.STATE).cy.on("mouseout", "node, edge", ()=>{
            const tooltip = document.getElementById("tooltip");
            tooltip.classList.remove("tooltip-visible");
            // Set a small delay before hiding completely to allow smooth transition
            setTimeout(()=>{
                if (!tooltip.classList.contains("tooltip-visible")) tooltip.style.display = "none";
            }, 300);
        });
        // Update tooltip position on mousemove to follow cursor
        (0, $5qD1E.STATE).cy.on("mousemove", "node, edge", (event)=>{
            const tooltip = document.getElementById("tooltip");
            tooltip.style.left = `${event.originalEvent.pageX + 10}px`;
            tooltip.style.top = `${event.originalEvent.pageY - 10}px`;
        });
    }
}
function $9913f98ecdefcd74$export$b9cd626f8029bee7() {
    $9913f98ecdefcd74$var$tooltipDisabled = !$9913f98ecdefcd74$var$tooltipDisabled;
    console.log("Tooltip disabled:", $9913f98ecdefcd74$var$tooltipDisabled);
    const tooltip = document.getElementById("tooltip");
    if ($9913f98ecdefcd74$var$tooltipDisabled) {
        tooltip.style.display = "none";
        tooltip.classList.remove("tooltip-visible");
        // Remove event listeners when disabled
        (0, $5qD1E.STATE).cy.off("mouseover", "node, edge");
        (0, $5qD1E.STATE).cy.off("mouseout", "node, edge");
        (0, $5qD1E.STATE).cy.off("mousemove", "node, edge");
    } else $9913f98ecdefcd74$export$c16a9a598ac2ae39();
}
function $9913f98ecdefcd74$var$addTooltipStyles() {
    // Check if tooltip styles already exist
    if (document.getElementById("tooltip-styles")) return;
    // Create style element
    const style = document.createElement("style");
    style.id = "tooltip-styles";
    style.textContent = `
        #tooltip {
            position: absolute;
            display: none;
            min-width: 200px;
            max-width: 300px;
            background-color: white;
            border-radius: 6px;
            box-shadow: 0 3px 6px rgba(0,0,0,0.2);
            z-index: 1000;
            font-size: 14px;
            opacity: 0;
            transform: translateY(10px);
            transition: opacity 0.3s ease, transform 0.3s ease;
            pointer-events: none;
            overflow: hidden;
        }

        #tooltip.tooltip-visible {
            opacity: 1;
            transform: translateY(0);
        }

        .tooltip-header {
            padding: 8px 12px;
            color: white;
            font-weight: bold;
        }

        .node-header {
            background-color: #007bff;
        }

        .edge-header {
            background-color: #28a745;
        }

        .tooltip-body {
            padding: 12px;
        }

        .tooltip-section {
            display: flex;
            margin-bottom: 4px;
        }

        .tooltip-title {
            font-weight: bold;
            width: 70px;
            color: #555;
        }

        .tooltip-value {
            flex: 1;
            word-break: break-word;
        }

        .weight-value {
            font-weight: bold;
            color: #28a745;
        }

        .tooltip-metrics {
            display: flex;
            justify-content: space-between;
            margin-top: 8px;
            gap: 10px;
        }

        .tooltip-metric {
            flex: 1;
            text-align: center;
            border: 1px solid #eee;
            border-radius: 4px;
            overflow: hidden;
        }

        .metric-label {
            display: block;
            padding: 2px 0;
            font-size: 12px;
            font-weight: bold;
            color: #555;
        }

        .metric-value {
            display: block;
            padding: 4px 0;
            font-weight: bold;
            color: white;
        }

        .tooltip-footer {
            padding: 5px 12px;
            background-color: #f5f5f5;
            border-top: 1px solid #eee;
            text-align: center;
            color: #666;
        }
    `;
    // Add style to document head
    document.head.appendChild(style);
}
document.getElementById("toggleTooltip").addEventListener("click", $9913f98ecdefcd74$export$b9cd626f8029bee7);

});



parcelRequire("5qD1E");

//# sourceMappingURL=app.1a37859e.js.map
